import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
	Bytes: { input: string; output: string };
	Cursor: { input: string; output: string };
	Date: { input: string; output: string };
	Map: { input: Record<string, any>; output: Record<string, any> };
	Time: { input: string; output: string };
};

export type AcademicSubject = Node & {
	__typename?: "AcademicSubject";
	color: Scalars["String"]["output"];
	courses: Array<Course>;
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
};

export type AcademicSubjectCoursesArgs = {
	filters?: InputMaybe<Array<CourseFilterInput>>;
	order?: InputMaybe<CourseOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type AcademicSubjectConnection = {
	__typename?: "AcademicSubjectConnection";
	edges: Array<AcademicSubjectEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type AcademicSubjectCreateInput = {
	color: Scalars["String"]["input"];
	courseIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courses?: InputMaybe<Array<CourseInAcademicSubjectCreateInput>>;
	name: Scalars["String"]["input"];
};

export type AcademicSubjectEdge = {
	__typename?: "AcademicSubjectEdge";
	cursor: Scalars["Cursor"]["output"];
	node: AcademicSubject;
};

export type AcademicSubjectFilterInput = {
	and?: InputMaybe<Array<AcademicSubjectFilterInput>>;
	colorContains?: InputMaybe<Scalars["String"]["input"]>;
	colorEQ?: InputMaybe<Scalars["String"]["input"]>;
	colorHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	colorHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	colorIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	colorNEQ?: InputMaybe<Scalars["String"]["input"]>;
	colorNotContains?: InputMaybe<Scalars["String"]["input"]>;
	colorNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	colorNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	colorNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	courses?: InputMaybe<Array<CourseFilterInput>>;
	hasCourses?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<AcademicSubjectFilterInput>;
	or?: InputMaybe<Array<AcademicSubjectFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type AcademicSubjectHistory = Node & {
	__typename?: "AcademicSubjectHistory";
	color: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type AcademicSubjectHistoryConnection = {
	__typename?: "AcademicSubjectHistoryConnection";
	edges: Array<AcademicSubjectHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type AcademicSubjectHistoryEdge = {
	__typename?: "AcademicSubjectHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: AcademicSubjectHistory;
};

export type AcademicSubjectHistoryFilterInput = {
	and?: InputMaybe<Array<AcademicSubjectHistoryFilterInput>>;
	colorContains?: InputMaybe<Scalars["String"]["input"]>;
	colorEQ?: InputMaybe<Scalars["String"]["input"]>;
	colorHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	colorHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	colorIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	colorIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	colorNEQ?: InputMaybe<Scalars["String"]["input"]>;
	colorNotContains?: InputMaybe<Scalars["String"]["input"]>;
	colorNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	colorNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	colorNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<AcademicSubjectHistoryFilterInput>;
	or?: InputMaybe<Array<AcademicSubjectHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type AcademicSubjectHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<AcademicSubjectHistoryOrderField>;
};

export enum AcademicSubjectHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type AcademicSubjectOrder = {
	direction: OrderDirection;
	field?: InputMaybe<AcademicSubjectOrderField>;
};

export enum AcademicSubjectOrderField {
	Name = "NAME",
}

export type AcademicSubjectUpdateBulkInput = {
	addCourseIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearCourses?: InputMaybe<Scalars["Boolean"]["input"]>;
	color?: InputMaybe<Scalars["String"]["input"]>;
	courseIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeCourseIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type AcademicSubjectUpdateInput = {
	addCourseIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearCourses?: InputMaybe<Scalars["Boolean"]["input"]>;
	color?: InputMaybe<Scalars["String"]["input"]>;
	courseIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeCourseIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type AcademicTerm = Node & {
	__typename?: "AcademicTerm";
	academicYear: AcademicYear;
	academicYearID: Scalars["ID"]["output"];
	contracts: Array<Contract>;
	courseSections: Array<CourseSection>;
	endDate: Scalars["Date"]["output"];
	homeRoomSections: Array<HomeRoomSection>;
	id: Scalars["ID"]["output"];
	imageContentType: Scalars["String"]["output"];
	imageKey: Scalars["String"]["output"];
	imageURL: Scalars["String"]["output"];
	name: Scalars["String"]["output"];
	reportCards: Array<ReportCard>;
	startDate: Scalars["Date"]["output"];
	studentAcademicTermEnrollments: Array<StudentAcademicTermEnrollment>;
};

export type AcademicTermContractsArgs = {
	filters?: InputMaybe<Array<ContractFilterInput>>;
	order?: InputMaybe<ContractOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type AcademicTermCourseSectionsArgs = {
	filters?: InputMaybe<Array<CourseSectionFilterInput>>;
	order?: InputMaybe<CourseSectionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type AcademicTermHomeRoomSectionsArgs = {
	filters?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
	order?: InputMaybe<HomeRoomSectionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type AcademicTermReportCardsArgs = {
	filters?: InputMaybe<Array<ReportCardFilterInput>>;
	order?: InputMaybe<ReportCardOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type AcademicTermStudentAcademicTermEnrollmentsArgs = {
	filters?: InputMaybe<Array<StudentAcademicTermEnrollmentFilterInput>>;
	order?: InputMaybe<StudentAcademicTermEnrollmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type AcademicTermConnection = {
	__typename?: "AcademicTermConnection";
	edges: Array<AcademicTermEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type AcademicTermCreateInput = {
	academicYearID: Scalars["ID"]["input"];
	contractIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSections?: InputMaybe<Array<CourseSectionInAcademicTermCreateInput>>;
	endDate: Scalars["Date"]["input"];
	homeRoomSections?: InputMaybe<Array<HomeRoomSectionInAcademicTermCreateInput>>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	name: Scalars["String"]["input"];
	reportCards?: InputMaybe<Array<ReportCardInAcademicTermCreateInput>>;
	startDate: Scalars["Date"]["input"];
	studentAcademicTermEnrollments?: InputMaybe<Array<StudentAcademicTermEnrollmentInAcademicTermCreateInput>>;
};

export type AcademicTermEdge = {
	__typename?: "AcademicTermEdge";
	cursor: Scalars["Cursor"]["output"];
	node: AcademicTerm;
};

export type AcademicTermFilterInput = {
	academicYear?: InputMaybe<Array<AcademicYearFilterInput>>;
	academicYearIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicYearIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	academicYearIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicYearIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	and?: InputMaybe<Array<AcademicTermFilterInput>>;
	contracts?: InputMaybe<Array<ContractFilterInput>>;
	courseSections?: InputMaybe<Array<CourseSectionFilterInput>>;
	endDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	endDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	endDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	endDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	endDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	endDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	endDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	endDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	hasContracts?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCourseSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasHomeRoomSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasReportCards?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentAcademicTermEnrollments?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoomSections?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	imageContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<AcademicTermFilterInput>;
	or?: InputMaybe<Array<AcademicTermFilterInput>>;
	reportCards?: InputMaybe<Array<ReportCardFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	startDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	startDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	startDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	startDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	startDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	startDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	startDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	startDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	studentAcademicTermEnrollments?: InputMaybe<Array<StudentAcademicTermEnrollmentFilterInput>>;
};

export type AcademicTermHistory = Node & {
	__typename?: "AcademicTermHistory";
	academicYearID: Maybe<Scalars["ID"]["output"]>;
	endDate: Maybe<Scalars["Date"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	imageContentType: Maybe<Scalars["String"]["output"]>;
	imageKey: Maybe<Scalars["String"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	startDate: Maybe<Scalars["Date"]["output"]>;
};

export type AcademicTermHistoryConnection = {
	__typename?: "AcademicTermHistoryConnection";
	edges: Array<AcademicTermHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type AcademicTermHistoryEdge = {
	__typename?: "AcademicTermHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: AcademicTermHistory;
};

export type AcademicTermHistoryFilterInput = {
	academicYearIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicYearIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	academicYearIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	academicYearIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicYearIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	and?: InputMaybe<Array<AcademicTermHistoryFilterInput>>;
	endDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	endDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	endDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	endDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	endDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	endDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	endDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	endDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	endDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	imageContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageContentTypeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<AcademicTermHistoryFilterInput>;
	or?: InputMaybe<Array<AcademicTermHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	startDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	startDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	startDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	startDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	startDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	startDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	startDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	startDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	startDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
};

export type AcademicTermHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<AcademicTermHistoryOrderField>;
};

export enum AcademicTermHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type AcademicTermInAcademicYearCreateInput = {
	contractIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSections?: InputMaybe<Array<CourseSectionInAcademicTermCreateInput>>;
	endDate: Scalars["Date"]["input"];
	homeRoomSections?: InputMaybe<Array<HomeRoomSectionInAcademicTermCreateInput>>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	name: Scalars["String"]["input"];
	reportCards?: InputMaybe<Array<ReportCardInAcademicTermCreateInput>>;
	startDate: Scalars["Date"]["input"];
	studentAcademicTermEnrollments?: InputMaybe<Array<StudentAcademicTermEnrollmentInAcademicTermCreateInput>>;
};

export type AcademicTermOrder = {
	direction: OrderDirection;
	field?: InputMaybe<AcademicTermOrderField>;
};

export enum AcademicTermOrderField {
	EndDate = "END_DATE",
	Name = "NAME",
	StartDate = "START_DATE",
}

export type AcademicTermUpdateBulkInput = {
	academicYearID?: InputMaybe<Scalars["ID"]["input"]>;
	addContractIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearContracts?: InputMaybe<Scalars["Boolean"]["input"]>;
	contractIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	endDate?: InputMaybe<Scalars["Date"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeContractIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	startDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type AcademicTermUpdateInput = {
	academicYearID?: InputMaybe<Scalars["ID"]["input"]>;
	addContractIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearContracts?: InputMaybe<Scalars["Boolean"]["input"]>;
	contractIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	endDate?: InputMaybe<Scalars["Date"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeContractIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	startDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type AcademicYear = Node & {
	__typename?: "AcademicYear";
	academicTerms: Array<AcademicTerm>;
	enrollmentApplicationStudents: Array<EnrollmentApplicationStudent>;
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
	studentEnrollmentIntents: Array<StudentEnrollmentIntent>;
};

export type AcademicYearAcademicTermsArgs = {
	filters?: InputMaybe<Array<AcademicTermFilterInput>>;
	order?: InputMaybe<AcademicTermOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type AcademicYearEnrollmentApplicationStudentsArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationStudentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type AcademicYearStudentEnrollmentIntentsArgs = {
	filters?: InputMaybe<Array<StudentEnrollmentIntentFilterInput>>;
	order?: InputMaybe<StudentEnrollmentIntentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type AcademicYearConnection = {
	__typename?: "AcademicYearConnection";
	edges: Array<AcademicYearEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type AcademicYearCreateInput = {
	academicTermIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	academicTerms?: InputMaybe<Array<AcademicTermInAcademicYearCreateInput>>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudents?: InputMaybe<Array<EnrollmentApplicationStudentInAcademicYearCreateInput>>;
	name: Scalars["String"]["input"];
	studentEnrollmentIntents?: InputMaybe<Array<StudentEnrollmentIntentInAcademicYearCreateInput>>;
};

export type AcademicYearEdge = {
	__typename?: "AcademicYearEdge";
	cursor: Scalars["Cursor"]["output"];
	node: AcademicYear;
};

export type AcademicYearFilterInput = {
	academicTerms?: InputMaybe<Array<AcademicTermFilterInput>>;
	and?: InputMaybe<Array<AcademicYearFilterInput>>;
	enrollmentApplicationStudents?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	hasAcademicTerms?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentEnrollmentIntents?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<AcademicYearFilterInput>;
	or?: InputMaybe<Array<AcademicYearFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentEnrollmentIntents?: InputMaybe<Array<StudentEnrollmentIntentFilterInput>>;
};

export type AcademicYearHistory = Node & {
	__typename?: "AcademicYearHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type AcademicYearHistoryConnection = {
	__typename?: "AcademicYearHistoryConnection";
	edges: Array<AcademicYearHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type AcademicYearHistoryEdge = {
	__typename?: "AcademicYearHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: AcademicYearHistory;
};

export type AcademicYearHistoryFilterInput = {
	and?: InputMaybe<Array<AcademicYearHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<AcademicYearHistoryFilterInput>;
	or?: InputMaybe<Array<AcademicYearHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type AcademicYearHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<AcademicYearHistoryOrderField>;
};

export enum AcademicYearHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type AcademicYearOrder = {
	direction: OrderDirection;
	field?: InputMaybe<AcademicYearOrderField>;
};

export enum AcademicYearOrderField {
	Name = "NAME",
}

export type AcademicYearUpdateBulkInput = {
	academicTermIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addAcademicTermIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearAcademicTerms?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeAcademicTermIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type AcademicYearUpdateInput = {
	academicTermIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addAcademicTermIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearAcademicTerms?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeAcademicTermIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type Address = Node & {
	__typename?: "Address";
	addressLine1: Scalars["String"]["output"];
	addressLine2: Scalars["String"]["output"];
	city: Scalars["String"]["output"];
	country: Country;
	countryID: Scalars["ID"]["output"];
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
	people: Array<Person>;
	postalCode: Scalars["String"]["output"];
	stateOrProvince: Scalars["String"]["output"];
};

export type AddressPeopleArgs = {
	filters?: InputMaybe<Array<PersonFilterInput>>;
	order?: InputMaybe<PersonOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type AddressConnection = {
	__typename?: "AddressConnection";
	edges: Array<AddressEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type AddressCreateInput = {
	addressLine1: Scalars["String"]["input"];
	addressLine2?: InputMaybe<Scalars["String"]["input"]>;
	city: Scalars["String"]["input"];
	countryID: Scalars["ID"]["input"];
	name?: InputMaybe<Scalars["String"]["input"]>;
	personIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postalCode?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvince?: InputMaybe<Scalars["String"]["input"]>;
};

export type AddressEdge = {
	__typename?: "AddressEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Address;
};

export type AddressFilterInput = {
	addressLine1Contains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1EQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1HasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1HasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1In?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressLine1NEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressLine2Contains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2EQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2HasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2HasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2In?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressLine2NEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<AddressFilterInput>>;
	cityContains?: InputMaybe<Scalars["String"]["input"]>;
	cityEQ?: InputMaybe<Scalars["String"]["input"]>;
	cityHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	cityHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	cityIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	cityNEQ?: InputMaybe<Scalars["String"]["input"]>;
	cityNotContains?: InputMaybe<Scalars["String"]["input"]>;
	cityNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	cityNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	cityNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	country?: InputMaybe<Array<CountryFilterInput>>;
	countryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	countryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	countryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	countryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	hasPeople?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<AddressFilterInput>;
	or?: InputMaybe<Array<AddressFilterInput>>;
	people?: InputMaybe<Array<PersonFilterInput>>;
	postalCodeContains?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeEQ?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	postalCodeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceContains?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceEQ?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	stateOrProvinceNEQ?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceNotContains?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type AddressHistory = Node & {
	__typename?: "AddressHistory";
	addressLine1: Maybe<Scalars["String"]["output"]>;
	addressLine2: Maybe<Scalars["String"]["output"]>;
	city: Maybe<Scalars["String"]["output"]>;
	countryID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	postalCode: Maybe<Scalars["String"]["output"]>;
	stateOrProvince: Maybe<Scalars["String"]["output"]>;
};

export type AddressHistoryConnection = {
	__typename?: "AddressHistoryConnection";
	edges: Array<AddressHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type AddressHistoryEdge = {
	__typename?: "AddressHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: AddressHistory;
};

export type AddressHistoryFilterInput = {
	addressLine1Contains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1EQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1HasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1HasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1In?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressLine1IsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	addressLine1NEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressLine2Contains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2EQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2HasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2HasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2In?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressLine2IsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	addressLine2NEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<AddressHistoryFilterInput>>;
	cityContains?: InputMaybe<Scalars["String"]["input"]>;
	cityEQ?: InputMaybe<Scalars["String"]["input"]>;
	cityHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	cityHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	cityIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	cityIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	cityNEQ?: InputMaybe<Scalars["String"]["input"]>;
	cityNotContains?: InputMaybe<Scalars["String"]["input"]>;
	cityNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	cityNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	cityNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	countryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	countryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	countryIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	countryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	countryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<AddressHistoryFilterInput>;
	or?: InputMaybe<Array<AddressHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postalCodeContains?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeEQ?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	postalCodeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	postalCodeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceContains?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceEQ?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	stateOrProvinceIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	stateOrProvinceNEQ?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceNotContains?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type AddressHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<AddressHistoryOrderField>;
};

export enum AddressHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type AddressInCountryCreateInput = {
	addressLine1: Scalars["String"]["input"];
	addressLine2?: InputMaybe<Scalars["String"]["input"]>;
	city: Scalars["String"]["input"];
	name?: InputMaybe<Scalars["String"]["input"]>;
	personIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postalCode?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvince?: InputMaybe<Scalars["String"]["input"]>;
};

export type AddressOrder = {
	direction: OrderDirection;
	field?: InputMaybe<AddressOrderField>;
};

export enum AddressOrderField {
	AddressLine1 = "ADDRESS_LINE_1",
	City = "CITY",
	Name = "NAME",
	PostalCode = "POSTAL_CODE",
	StateOrProvince = "STATE_OR_PROVINCE",
}

export type AddressUpdateBulkInput = {
	addPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addressLine1?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2?: InputMaybe<Scalars["String"]["input"]>;
	city?: InputMaybe<Scalars["String"]["input"]>;
	clearPeople?: InputMaybe<Scalars["Boolean"]["input"]>;
	countryID?: InputMaybe<Scalars["ID"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	personIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postalCode?: InputMaybe<Scalars["String"]["input"]>;
	removePersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	stateOrProvince?: InputMaybe<Scalars["String"]["input"]>;
};

export type AddressUpdateInput = {
	addPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addressLine1?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2?: InputMaybe<Scalars["String"]["input"]>;
	city?: InputMaybe<Scalars["String"]["input"]>;
	clearPeople?: InputMaybe<Scalars["Boolean"]["input"]>;
	countryID?: InputMaybe<Scalars["ID"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	personIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postalCode?: InputMaybe<Scalars["String"]["input"]>;
	removePersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	stateOrProvince?: InputMaybe<Scalars["String"]["input"]>;
};

export type AggregateReportCardCompletionProgressStatistics = {
	__typename?: "AggregateReportCardCompletionProgressStatistics";
	complete: Scalars["Int"]["output"];
	count: Scalars["Int"]["output"];
	incomplete: Scalars["Int"]["output"];
	ready: Scalars["Int"]["output"];
};

export type Announcement = Node & {
	__typename?: "Announcement";
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Scalars["String"]["output"];
	endTime: Maybe<Scalars["Time"]["output"]>;
	id: Scalars["ID"]["output"];
	mediaAttachments: Array<MediaAttachment>;
	sharingRecord: Maybe<SharingRecord>;
	socialReactions: Array<SocialReaction>;
	startTime: Scalars["Time"]["output"];
	title: Scalars["String"]["output"];
};

export type AnnouncementMediaAttachmentsArgs = {
	filters?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	order?: InputMaybe<MediaAttachmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type AnnouncementSocialReactionsArgs = {
	filters?: InputMaybe<Array<SocialReactionFilterInput>>;
	order?: InputMaybe<SocialReactionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type AnnouncementConnection = {
	__typename?: "AnnouncementConnection";
	edges: Array<AnnouncementEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type AnnouncementCreateInput = {
	body: Scalars["String"]["input"];
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInAnnouncementCreateInput>>;
	sharingRecord?: InputMaybe<SharingRecordInAnnouncementCreateInput>;
	socialReactions?: InputMaybe<Array<SocialReactionInAnnouncementCreateInput>>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type AnnouncementEdge = {
	__typename?: "AnnouncementEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Announcement;
};

export type AnnouncementFilterInput = {
	and?: InputMaybe<Array<AnnouncementFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	endTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	endTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	endTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMediaAttachments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharingRecord?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSocialReactions?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	not?: InputMaybe<AnnouncementFilterInput>;
	or?: InputMaybe<Array<AnnouncementFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	sharingRecord?: InputMaybe<Array<SharingRecordFilterInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionFilterInput>>;
	startTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	startTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	titleContains?: InputMaybe<Scalars["String"]["input"]>;
	titleEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	titleNEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleNotContains?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type AnnouncementHistory = Node & {
	__typename?: "AnnouncementHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Maybe<Scalars["String"]["output"]>;
	endTime: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
	startTime: Maybe<Scalars["Time"]["output"]>;
	title: Maybe<Scalars["String"]["output"]>;
};

export type AnnouncementHistoryConnection = {
	__typename?: "AnnouncementHistoryConnection";
	edges: Array<AnnouncementHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type AnnouncementHistoryEdge = {
	__typename?: "AnnouncementHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: AnnouncementHistory;
};

export type AnnouncementHistoryFilterInput = {
	and?: InputMaybe<Array<AnnouncementHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	endTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	endTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	endTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<AnnouncementHistoryFilterInput>;
	or?: InputMaybe<Array<AnnouncementHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	startTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	startTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	startTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	titleContains?: InputMaybe<Scalars["String"]["input"]>;
	titleEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	titleIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	titleNEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleNotContains?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type AnnouncementHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<AnnouncementHistoryOrderField>;
};

export enum AnnouncementHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type AnnouncementInAuthorCreateInput = {
	body: Scalars["String"]["input"];
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInAnnouncementCreateInput>>;
	sharingRecord?: InputMaybe<SharingRecordInAnnouncementCreateInput>;
	socialReactions?: InputMaybe<Array<SocialReactionInAnnouncementCreateInput>>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type AnnouncementInSharingRecordCreateInput = {
	body: Scalars["String"]["input"];
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInAnnouncementCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInAnnouncementCreateInput>>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type AnnouncementOrder = {
	direction: OrderDirection;
	field?: InputMaybe<AnnouncementOrderField>;
};

export enum AnnouncementOrderField {
	StartTime = "START_TIME",
}

export type AnnouncementStatistics = {
	__typename?: "AnnouncementStatistics";
	count: Scalars["Int"]["output"];
	reactions: Scalars["Int"]["output"];
	views: Scalars["Int"]["output"];
};

export type AnnouncementUpdateBulkInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	clearEndTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type AnnouncementUpdateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	clearEndTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type AspectIndividualReportCardCompletionProgressStatistics = {
	__typename?: "AspectIndividualReportCardCompletionProgressStatistics";
	completionPercentage: Scalars["Float"]["output"];
	id: Scalars["String"]["output"];
	isComplete: Scalars["Boolean"]["output"];
	isReady: Scalars["Boolean"]["output"];
};

export type AttendanceRecordCountStatistics = {
	__typename?: "AttendanceRecordCountStatistics";
	absentExcused: Scalars["Int"]["output"];
	absentTotal: Scalars["Int"]["output"];
	absentUnexcused: Scalars["Int"]["output"];
	date: Scalars["Date"]["output"];
	earlyDepartureExcused: Scalars["Int"]["output"];
	earlyDepartureTotal: Scalars["Int"]["output"];
	earlyDepartureUnexcused: Scalars["Int"]["output"];
	lateArrivalExcused: Scalars["Int"]["output"];
	lateArrivalTotal: Scalars["Int"]["output"];
	lateArrivalUnexcused: Scalars["Int"]["output"];
	notTaken: Scalars["Int"]["output"];
	present: Scalars["Int"]["output"];
	presentTotal: Scalars["Int"]["output"];
	statuses: Array<AttendanceStatusCountStatistics>;
	students: Scalars["Int"]["output"];
};

export type AttendanceStatus = Node & {
	__typename?: "AttendanceStatus";
	code: Scalars["String"]["output"];
	courseAttendanceRecords: Array<CourseAttendanceRecord>;
	description: Scalars["String"]["output"];
	displayOrder: Maybe<Scalars["Int"]["output"]>;
	id: Scalars["ID"]["output"];
	indicatesAbsent: Scalars["Boolean"]["output"];
	indicatesEarlyDeparture: Scalars["Boolean"]["output"];
	indicatesExcused: Scalars["Boolean"]["output"];
	indicatesLateArrival: Scalars["Boolean"]["output"];
	isDefault: Scalars["Boolean"]["output"];
	name: Scalars["String"]["output"];
	schoolAttendanceRecords: Array<SchoolAttendanceRecord>;
	studentAttendanceNotes: Array<StudentAttendanceNote>;
};

export type AttendanceStatusCourseAttendanceRecordsArgs = {
	filters?: InputMaybe<Array<CourseAttendanceRecordFilterInput>>;
	order?: InputMaybe<CourseAttendanceRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type AttendanceStatusSchoolAttendanceRecordsArgs = {
	filters?: InputMaybe<Array<SchoolAttendanceRecordFilterInput>>;
	order?: InputMaybe<SchoolAttendanceRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type AttendanceStatusStudentAttendanceNotesArgs = {
	filters?: InputMaybe<Array<StudentAttendanceNoteFilterInput>>;
	order?: InputMaybe<StudentAttendanceNoteOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type AttendanceStatusConnection = {
	__typename?: "AttendanceStatusConnection";
	edges: Array<AttendanceStatusEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type AttendanceStatusCountStatistics = {
	__typename?: "AttendanceStatusCountStatistics";
	code: Scalars["String"]["output"];
	count: Scalars["Int"]["output"];
	description: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	indicatesAbsent: Scalars["Boolean"]["output"];
	indicatesEarlyDeparture: Scalars["Boolean"]["output"];
	indicatesExcused: Scalars["Boolean"]["output"];
	indicatesLateArrival: Scalars["Boolean"]["output"];
	name: Scalars["String"]["output"];
};

export type AttendanceStatusCreateInput = {
	code: Scalars["String"]["input"];
	courseAttendanceRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAttendanceRecords?: InputMaybe<Array<CourseAttendanceRecordInAttendanceStatusCreateInput>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	indicatesAbsent: Scalars["Boolean"]["input"];
	indicatesEarlyDeparture: Scalars["Boolean"]["input"];
	indicatesExcused: Scalars["Boolean"]["input"];
	indicatesLateArrival: Scalars["Boolean"]["input"];
	isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
	name: Scalars["String"]["input"];
	schoolAttendanceRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	schoolAttendanceRecords?: InputMaybe<Array<SchoolAttendanceRecordInAttendanceStatusCreateInput>>;
	studentAttendanceNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentAttendanceNotes?: InputMaybe<Array<StudentAttendanceNoteInAttendanceStatusCreateInput>>;
};

export type AttendanceStatusEdge = {
	__typename?: "AttendanceStatusEdge";
	cursor: Scalars["Cursor"]["output"];
	node: AttendanceStatus;
};

export type AttendanceStatusFilterInput = {
	and?: InputMaybe<Array<AttendanceStatusFilterInput>>;
	codeContains?: InputMaybe<Scalars["String"]["input"]>;
	codeEQ?: InputMaybe<Scalars["String"]["input"]>;
	codeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	codeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	codeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	codeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	codeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	codeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	codeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	codeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	courseAttendanceRecords?: InputMaybe<Array<CourseAttendanceRecordFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	displayOrderEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	displayOrderIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	displayOrderLT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderLTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	hasCourseAttendanceRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSchoolAttendanceRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentAttendanceNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	indicatesAbsentEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesAbsentNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesEarlyDepartureEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesEarlyDepartureNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesExcusedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesExcusedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesLateArrivalEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesLateArrivalNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isDefaultEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isDefaultNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<AttendanceStatusFilterInput>;
	or?: InputMaybe<Array<AttendanceStatusFilterInput>>;
	schoolAttendanceRecords?: InputMaybe<Array<SchoolAttendanceRecordFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentAttendanceNotes?: InputMaybe<Array<StudentAttendanceNoteFilterInput>>;
};

export type AttendanceStatusHistory = Node & {
	__typename?: "AttendanceStatusHistory";
	code: Maybe<Scalars["String"]["output"]>;
	description: Maybe<Scalars["String"]["output"]>;
	displayOrder: Maybe<Scalars["Int"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	indicatesAbsent: Maybe<Scalars["Boolean"]["output"]>;
	indicatesEarlyDeparture: Maybe<Scalars["Boolean"]["output"]>;
	indicatesExcused: Maybe<Scalars["Boolean"]["output"]>;
	indicatesLateArrival: Maybe<Scalars["Boolean"]["output"]>;
	isDefault: Maybe<Scalars["Boolean"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type AttendanceStatusHistoryConnection = {
	__typename?: "AttendanceStatusHistoryConnection";
	edges: Array<AttendanceStatusHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type AttendanceStatusHistoryEdge = {
	__typename?: "AttendanceStatusHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: AttendanceStatusHistory;
};

export type AttendanceStatusHistoryFilterInput = {
	and?: InputMaybe<Array<AttendanceStatusHistoryFilterInput>>;
	codeContains?: InputMaybe<Scalars["String"]["input"]>;
	codeEQ?: InputMaybe<Scalars["String"]["input"]>;
	codeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	codeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	codeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	codeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	codeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	codeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	codeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	codeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	codeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	displayOrderEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	displayOrderIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	displayOrderLT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderLTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	indicatesAbsentEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesAbsentIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesAbsentNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesEarlyDepartureEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesEarlyDepartureIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesEarlyDepartureNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesExcusedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesExcusedIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesExcusedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesLateArrivalEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesLateArrivalIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesLateArrivalNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isDefaultEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isDefaultIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isDefaultNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<AttendanceStatusHistoryFilterInput>;
	or?: InputMaybe<Array<AttendanceStatusHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type AttendanceStatusHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<AttendanceStatusHistoryOrderField>;
};

export enum AttendanceStatusHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type AttendanceStatusOrder = {
	direction: OrderDirection;
	field?: InputMaybe<AttendanceStatusOrderField>;
};

export enum AttendanceStatusOrderField {
	DisplayOrder = "DISPLAY_ORDER",
	IsDefault = "IS_DEFAULT",
}

export type AttendanceStatusUpdateBulkInput = {
	addCourseAttendanceRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSchoolAttendanceRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentAttendanceNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearCourseAttendanceRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearDisplayOrder?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSchoolAttendanceRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentAttendanceNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
	code?: InputMaybe<Scalars["String"]["input"]>;
	courseAttendanceRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	indicatesAbsent?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesEarlyDeparture?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesExcused?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesLateArrival?: InputMaybe<Scalars["Boolean"]["input"]>;
	isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeCourseAttendanceRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSchoolAttendanceRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentAttendanceNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	schoolAttendanceRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentAttendanceNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type AttendanceStatusUpdateInput = {
	addCourseAttendanceRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSchoolAttendanceRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentAttendanceNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearCourseAttendanceRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearDisplayOrder?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSchoolAttendanceRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentAttendanceNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
	code?: InputMaybe<Scalars["String"]["input"]>;
	courseAttendanceRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	indicatesAbsent?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesEarlyDeparture?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesExcused?: InputMaybe<Scalars["Boolean"]["input"]>;
	indicatesLateArrival?: InputMaybe<Scalars["Boolean"]["input"]>;
	isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeCourseAttendanceRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSchoolAttendanceRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentAttendanceNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	schoolAttendanceRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentAttendanceNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type BillingAdjustment = Node & {
	__typename?: "BillingAdjustment";
	amount: Scalars["Int"]["output"];
	id: Scalars["ID"]["output"];
	invoice: Invoice;
	invoiceID: Scalars["ID"]["output"];
	issueDate: Scalars["Date"]["output"];
	notes: Scalars["String"]["output"];
};

export type BillingAdjustmentConnection = {
	__typename?: "BillingAdjustmentConnection";
	edges: Array<BillingAdjustmentEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type BillingAdjustmentCreateInput = {
	amount: Scalars["Int"]["input"];
	invoiceID: Scalars["ID"]["input"];
	issueDate: Scalars["Date"]["input"];
	notes?: InputMaybe<Scalars["String"]["input"]>;
};

export type BillingAdjustmentEdge = {
	__typename?: "BillingAdjustmentEdge";
	cursor: Scalars["Cursor"]["output"];
	node: BillingAdjustment;
};

export type BillingAdjustmentFilterInput = {
	amountEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountGT?: InputMaybe<Scalars["Int"]["input"]>;
	amountGTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	amountLT?: InputMaybe<Scalars["Int"]["input"]>;
	amountLTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	and?: InputMaybe<Array<BillingAdjustmentFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	invoice?: InputMaybe<Array<InvoiceFilterInput>>;
	invoiceIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	invoiceIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	invoiceIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	invoiceIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	issueDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	issueDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	not?: InputMaybe<BillingAdjustmentFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<BillingAdjustmentFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type BillingAdjustmentHistory = Node & {
	__typename?: "BillingAdjustmentHistory";
	amount: Maybe<Scalars["Int"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	invoiceID: Maybe<Scalars["ID"]["output"]>;
	issueDate: Maybe<Scalars["Date"]["output"]>;
	notes: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type BillingAdjustmentHistoryConnection = {
	__typename?: "BillingAdjustmentHistoryConnection";
	edges: Array<BillingAdjustmentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type BillingAdjustmentHistoryEdge = {
	__typename?: "BillingAdjustmentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: BillingAdjustmentHistory;
};

export type BillingAdjustmentHistoryFilterInput = {
	amountEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountGT?: InputMaybe<Scalars["Int"]["input"]>;
	amountGTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	amountIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	amountLT?: InputMaybe<Scalars["Int"]["input"]>;
	amountLTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	and?: InputMaybe<Array<BillingAdjustmentHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	invoiceIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	invoiceIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	invoiceIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	invoiceIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	invoiceIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	issueDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	issueDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	not?: InputMaybe<BillingAdjustmentHistoryFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<BillingAdjustmentHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type BillingAdjustmentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<BillingAdjustmentHistoryOrderField>;
};

export enum BillingAdjustmentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type BillingAdjustmentInInvoiceCreateInput = {
	amount: Scalars["Int"]["input"];
	issueDate: Scalars["Date"]["input"];
	notes?: InputMaybe<Scalars["String"]["input"]>;
};

export type BillingAdjustmentOrder = {
	direction: OrderDirection;
	field?: InputMaybe<BillingAdjustmentOrderField>;
};

export enum BillingAdjustmentOrderField {
	Amount = "AMOUNT",
	IssueDate = "ISSUE_DATE",
}

export type BillingAdjustmentUpdateBulkInput = {
	amount?: InputMaybe<Scalars["Int"]["input"]>;
	issueDate?: InputMaybe<Scalars["Date"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
};

export type BillingAdjustmentUpdateInput = {
	amount?: InputMaybe<Scalars["Int"]["input"]>;
	issueDate?: InputMaybe<Scalars["Date"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
};

export type Building = Node & {
	__typename?: "Building";
	buildingFloors: Array<BuildingFloor>;
	campus: Campus;
	campusID: Scalars["ID"]["output"];
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
};

export type BuildingBuildingFloorsArgs = {
	filters?: InputMaybe<Array<BuildingFloorFilterInput>>;
	order?: InputMaybe<BuildingFloorOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type BuildingConnection = {
	__typename?: "BuildingConnection";
	edges: Array<BuildingEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type BuildingCreateInput = {
	buildingFloorIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	buildingFloors?: InputMaybe<Array<BuildingFloorInBuildingCreateInput>>;
	campusID: Scalars["ID"]["input"];
	name: Scalars["String"]["input"];
};

export type BuildingEdge = {
	__typename?: "BuildingEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Building;
};

export type BuildingFilterInput = {
	and?: InputMaybe<Array<BuildingFilterInput>>;
	buildingFloors?: InputMaybe<Array<BuildingFloorFilterInput>>;
	campus?: InputMaybe<Array<CampusFilterInput>>;
	campusIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	campusIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	campusIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	campusIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	hasBuildingFloors?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<BuildingFilterInput>;
	or?: InputMaybe<Array<BuildingFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type BuildingFloor = Node & {
	__typename?: "BuildingFloor";
	building: Building;
	buildingID: Scalars["ID"]["output"];
	id: Scalars["ID"]["output"];
	level: Scalars["Int"]["output"];
	rooms: Array<Room>;
};

export type BuildingFloorRoomsArgs = {
	filters?: InputMaybe<Array<RoomFilterInput>>;
	order?: InputMaybe<RoomOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type BuildingFloorConnection = {
	__typename?: "BuildingFloorConnection";
	edges: Array<BuildingFloorEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type BuildingFloorCreateInput = {
	buildingID: Scalars["ID"]["input"];
	level: Scalars["Int"]["input"];
	roomIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	rooms?: InputMaybe<Array<RoomInBuildingFloorCreateInput>>;
};

export type BuildingFloorEdge = {
	__typename?: "BuildingFloorEdge";
	cursor: Scalars["Cursor"]["output"];
	node: BuildingFloor;
};

export type BuildingFloorFilterInput = {
	and?: InputMaybe<Array<BuildingFloorFilterInput>>;
	building?: InputMaybe<Array<BuildingFilterInput>>;
	buildingIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	buildingIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	buildingIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	buildingIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	hasRooms?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	levelEQ?: InputMaybe<Scalars["Int"]["input"]>;
	levelGT?: InputMaybe<Scalars["Int"]["input"]>;
	levelGTE?: InputMaybe<Scalars["Int"]["input"]>;
	levelIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	levelLT?: InputMaybe<Scalars["Int"]["input"]>;
	levelLTE?: InputMaybe<Scalars["Int"]["input"]>;
	levelNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	levelNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	not?: InputMaybe<BuildingFloorFilterInput>;
	or?: InputMaybe<Array<BuildingFloorFilterInput>>;
	rooms?: InputMaybe<Array<RoomFilterInput>>;
};

export type BuildingFloorHistory = Node & {
	__typename?: "BuildingFloorHistory";
	buildingID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	level: Maybe<Scalars["Int"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type BuildingFloorHistoryConnection = {
	__typename?: "BuildingFloorHistoryConnection";
	edges: Array<BuildingFloorHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type BuildingFloorHistoryEdge = {
	__typename?: "BuildingFloorHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: BuildingFloorHistory;
};

export type BuildingFloorHistoryFilterInput = {
	and?: InputMaybe<Array<BuildingFloorHistoryFilterInput>>;
	buildingIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	buildingIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	buildingIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	buildingIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	buildingIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	levelEQ?: InputMaybe<Scalars["Int"]["input"]>;
	levelGT?: InputMaybe<Scalars["Int"]["input"]>;
	levelGTE?: InputMaybe<Scalars["Int"]["input"]>;
	levelIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	levelIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	levelLT?: InputMaybe<Scalars["Int"]["input"]>;
	levelLTE?: InputMaybe<Scalars["Int"]["input"]>;
	levelNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	levelNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	not?: InputMaybe<BuildingFloorHistoryFilterInput>;
	or?: InputMaybe<Array<BuildingFloorHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type BuildingFloorHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<BuildingFloorHistoryOrderField>;
};

export enum BuildingFloorHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type BuildingFloorInBuildingCreateInput = {
	level: Scalars["Int"]["input"];
	roomIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	rooms?: InputMaybe<Array<RoomInBuildingFloorCreateInput>>;
};

export type BuildingFloorOrder = {
	direction: OrderDirection;
	field?: InputMaybe<BuildingFloorOrderField>;
};

export enum BuildingFloorOrderField {
	Level = "LEVEL",
}

export type BuildingFloorUpdateBulkInput = {
	addRoomIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	buildingID?: InputMaybe<Scalars["ID"]["input"]>;
	clearRooms?: InputMaybe<Scalars["Boolean"]["input"]>;
	level?: InputMaybe<Scalars["Int"]["input"]>;
	removeRoomIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	roomIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type BuildingFloorUpdateInput = {
	addRoomIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	buildingID?: InputMaybe<Scalars["ID"]["input"]>;
	clearRooms?: InputMaybe<Scalars["Boolean"]["input"]>;
	level?: InputMaybe<Scalars["Int"]["input"]>;
	removeRoomIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	roomIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type BuildingHistory = Node & {
	__typename?: "BuildingHistory";
	campusID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type BuildingHistoryConnection = {
	__typename?: "BuildingHistoryConnection";
	edges: Array<BuildingHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type BuildingHistoryEdge = {
	__typename?: "BuildingHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: BuildingHistory;
};

export type BuildingHistoryFilterInput = {
	and?: InputMaybe<Array<BuildingHistoryFilterInput>>;
	campusIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	campusIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	campusIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	campusIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	campusIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<BuildingHistoryFilterInput>;
	or?: InputMaybe<Array<BuildingHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type BuildingHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<BuildingHistoryOrderField>;
};

export enum BuildingHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type BuildingInCampusCreateInput = {
	buildingFloorIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	buildingFloors?: InputMaybe<Array<BuildingFloorInBuildingCreateInput>>;
	name: Scalars["String"]["input"];
};

export type BuildingOrder = {
	direction: OrderDirection;
	field?: InputMaybe<BuildingOrderField>;
};

export enum BuildingOrderField {
	Name = "NAME",
}

export type BuildingUpdateBulkInput = {
	addBuildingFloorIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	buildingFloorIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	campusID?: InputMaybe<Scalars["ID"]["input"]>;
	clearBuildingFloors?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeBuildingFloorIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type BuildingUpdateInput = {
	addBuildingFloorIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	buildingFloorIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	campusID?: InputMaybe<Scalars["ID"]["input"]>;
	clearBuildingFloors?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeBuildingFloorIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CalendarEvent = Node & {
	__typename?: "CalendarEvent";
	allowsResponses: Scalars["Boolean"]["output"];
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	calendarEventResponses: Array<CalendarEventResponse>;
	createdAt: Scalars["Time"]["output"];
	description: Scalars["String"]["output"];
	endDate: Maybe<Scalars["Date"]["output"]>;
	endTime: Maybe<Scalars["Time"]["output"]>;
	id: Scalars["ID"]["output"];
	imageContentType: Scalars["String"]["output"];
	imageKey: Scalars["String"]["output"];
	imageURL: Scalars["String"]["output"];
	isAllDay: Scalars["Boolean"]["output"];
	isMultiDay: Scalars["Boolean"]["output"];
	location: Scalars["String"]["output"];
	mediaAttachments: Array<MediaAttachment>;
	name: Scalars["String"]["output"];
	sharingRecord: Maybe<SharingRecord>;
	startDate: Maybe<Scalars["Date"]["output"]>;
	startTime: Maybe<Scalars["Time"]["output"]>;
};

export type CalendarEventCalendarEventResponsesArgs = {
	filters?: InputMaybe<Array<CalendarEventResponseFilterInput>>;
	order?: InputMaybe<CalendarEventResponseOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CalendarEventMediaAttachmentsArgs = {
	filters?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	order?: InputMaybe<MediaAttachmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CalendarEventConnection = {
	__typename?: "CalendarEventConnection";
	edges: Array<CalendarEventEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CalendarEventCreateInput = {
	allowsResponses?: InputMaybe<Scalars["Boolean"]["input"]>;
	calendarEventResponses?: InputMaybe<Array<CalendarEventResponseInCalendarEventCreateInput>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	endDate?: InputMaybe<Scalars["Date"]["input"]>;
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	location?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInCalendarEventCreateInput>>;
	name: Scalars["String"]["input"];
	sharingRecord?: InputMaybe<SharingRecordInCalendarEventCreateInput>;
	startDate?: InputMaybe<Scalars["Date"]["input"]>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
};

export type CalendarEventEdge = {
	__typename?: "CalendarEventEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CalendarEvent;
};

export type CalendarEventFilterInput = {
	allowsResponsesEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowsResponsesNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	and?: InputMaybe<Array<CalendarEventFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventResponses?: InputMaybe<Array<CalendarEventResponseFilterInput>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	endDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	endDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	endDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	endDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	endDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	endDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	endDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	endDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	endDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	endTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	endTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	endTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCalendarEventResponses?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMediaAttachments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharingRecord?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	imageContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	locationContains?: InputMaybe<Scalars["String"]["input"]>;
	locationEQ?: InputMaybe<Scalars["String"]["input"]>;
	locationHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	locationHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	locationIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	locationNEQ?: InputMaybe<Scalars["String"]["input"]>;
	locationNotContains?: InputMaybe<Scalars["String"]["input"]>;
	locationNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	locationNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	locationNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<CalendarEventFilterInput>;
	or?: InputMaybe<Array<CalendarEventFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	sharingRecord?: InputMaybe<Array<SharingRecordFilterInput>>;
	startDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	startDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	startDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	startDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	startDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	startDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	startDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	startDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	startDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	startTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	startTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	startTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
};

export type CalendarEventHistory = Node & {
	__typename?: "CalendarEventHistory";
	allowsResponses: Maybe<Scalars["Boolean"]["output"]>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	description: Maybe<Scalars["String"]["output"]>;
	endDate: Maybe<Scalars["Date"]["output"]>;
	endTime: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	imageContentType: Maybe<Scalars["String"]["output"]>;
	imageKey: Maybe<Scalars["String"]["output"]>;
	location: Maybe<Scalars["String"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	startDate: Maybe<Scalars["Date"]["output"]>;
	startTime: Maybe<Scalars["Time"]["output"]>;
};

export type CalendarEventHistoryConnection = {
	__typename?: "CalendarEventHistoryConnection";
	edges: Array<CalendarEventHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CalendarEventHistoryEdge = {
	__typename?: "CalendarEventHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CalendarEventHistory;
};

export type CalendarEventHistoryFilterInput = {
	allowsResponsesEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowsResponsesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowsResponsesNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	and?: InputMaybe<Array<CalendarEventHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	endDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	endDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	endDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	endDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	endDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	endDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	endDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	endDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	endDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	endTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	endTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	endTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	imageContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageContentTypeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	locationContains?: InputMaybe<Scalars["String"]["input"]>;
	locationEQ?: InputMaybe<Scalars["String"]["input"]>;
	locationHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	locationHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	locationIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	locationIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	locationNEQ?: InputMaybe<Scalars["String"]["input"]>;
	locationNotContains?: InputMaybe<Scalars["String"]["input"]>;
	locationNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	locationNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	locationNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<CalendarEventHistoryFilterInput>;
	or?: InputMaybe<Array<CalendarEventHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	startDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	startDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	startDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	startDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	startDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	startDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	startDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	startDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	startDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	startTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	startTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	startTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
};

export type CalendarEventHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CalendarEventHistoryOrderField>;
};

export enum CalendarEventHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type CalendarEventInAuthorCreateInput = {
	allowsResponses?: InputMaybe<Scalars["Boolean"]["input"]>;
	calendarEventResponses?: InputMaybe<Array<CalendarEventResponseInCalendarEventCreateInput>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	endDate?: InputMaybe<Scalars["Date"]["input"]>;
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	location?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInCalendarEventCreateInput>>;
	name: Scalars["String"]["input"];
	sharingRecord?: InputMaybe<SharingRecordInCalendarEventCreateInput>;
	startDate?: InputMaybe<Scalars["Date"]["input"]>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
};

export type CalendarEventInSharingRecordCreateInput = {
	allowsResponses?: InputMaybe<Scalars["Boolean"]["input"]>;
	calendarEventResponses?: InputMaybe<Array<CalendarEventResponseInCalendarEventCreateInput>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	endDate?: InputMaybe<Scalars["Date"]["input"]>;
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	location?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInCalendarEventCreateInput>>;
	name: Scalars["String"]["input"];
	startDate?: InputMaybe<Scalars["Date"]["input"]>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
};

export type CalendarEventOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CalendarEventOrderField>;
};

export enum CalendarEventOrderField {
	CreatedAt = "CREATED_AT",
	EndDate = "END_DATE",
	EndTime = "END_TIME",
	Name = "NAME",
	StartDate = "START_DATE",
	StartTime = "START_TIME",
}

export type CalendarEventResponse = Node & {
	__typename?: "CalendarEventResponse";
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	calendarEvent: CalendarEvent;
	calendarEventID: Scalars["ID"]["output"];
	id: Scalars["ID"]["output"];
	response: CalendarEventResponseResponse;
};

export type CalendarEventResponseConnection = {
	__typename?: "CalendarEventResponseConnection";
	edges: Array<CalendarEventResponseEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CalendarEventResponseCreateInput = {
	calendarEventID: Scalars["ID"]["input"];
	response: CalendarEventResponseResponse;
};

export type CalendarEventResponseEdge = {
	__typename?: "CalendarEventResponseEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CalendarEventResponse;
};

export type CalendarEventResponseFilterInput = {
	and?: InputMaybe<Array<CalendarEventResponseFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEvent?: InputMaybe<Array<CalendarEventFilterInput>>;
	calendarEventIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<CalendarEventResponseFilterInput>;
	or?: InputMaybe<Array<CalendarEventResponseFilterInput>>;
	responseEQ?: InputMaybe<CalendarEventResponseResponse>;
	responseIn?: InputMaybe<Array<CalendarEventResponseResponse>>;
	responseNEQ?: InputMaybe<CalendarEventResponseResponse>;
	responseNotIn?: InputMaybe<Array<CalendarEventResponseResponse>>;
};

export type CalendarEventResponseHistory = Node & {
	__typename?: "CalendarEventResponseHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	calendarEventID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
	response: Maybe<CalendarEventResponseHistoryResponse>;
};

export type CalendarEventResponseHistoryConnection = {
	__typename?: "CalendarEventResponseHistoryConnection";
	edges: Array<CalendarEventResponseHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CalendarEventResponseHistoryEdge = {
	__typename?: "CalendarEventResponseHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CalendarEventResponseHistory;
};

export type CalendarEventResponseHistoryFilterInput = {
	and?: InputMaybe<Array<CalendarEventResponseHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	calendarEventIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<CalendarEventResponseHistoryFilterInput>;
	or?: InputMaybe<Array<CalendarEventResponseHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	responseEQ?: InputMaybe<CalendarEventResponseHistoryResponse>;
	responseIn?: InputMaybe<Array<CalendarEventResponseHistoryResponse>>;
	responseIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	responseNEQ?: InputMaybe<CalendarEventResponseHistoryResponse>;
	responseNotIn?: InputMaybe<Array<CalendarEventResponseHistoryResponse>>;
};

export type CalendarEventResponseHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CalendarEventResponseHistoryOrderField>;
};

export enum CalendarEventResponseHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export enum CalendarEventResponseHistoryResponse {
	Attending = "attending",
	MaybeAttending = "maybe_attending",
	NotAttending = "not_attending",
}

export type CalendarEventResponseInAuthorCreateInput = {
	calendarEventID: Scalars["ID"]["input"];
	response: CalendarEventResponseResponse;
};

export type CalendarEventResponseInCalendarEventCreateInput = {
	response: CalendarEventResponseResponse;
};

export type CalendarEventResponseOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CalendarEventResponseOrderField>;
};

export enum CalendarEventResponseOrderField {
	Response = "RESPONSE",
}

export enum CalendarEventResponseResponse {
	Attending = "attending",
	MaybeAttending = "maybe_attending",
	NotAttending = "not_attending",
}

export type CalendarEventResponseUpdateBulkInput = {
	response?: InputMaybe<CalendarEventResponseResponse>;
};

export type CalendarEventResponseUpdateInput = {
	response?: InputMaybe<CalendarEventResponseResponse>;
};

export type CalendarEventStatistics = {
	__typename?: "CalendarEventStatistics";
	count: Scalars["Int"]["output"];
	responsesAttending: Scalars["Int"]["output"];
	responsesMaybeAttending: Scalars["Int"]["output"];
	responsesNotAttending: Scalars["Int"]["output"];
};

export type CalendarEventUpdateBulkInput = {
	allowsResponses?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEndDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEndTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStartDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStartTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	endDate?: InputMaybe<Scalars["Date"]["input"]>;
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	location?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	startDate?: InputMaybe<Scalars["Date"]["input"]>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
};

export type CalendarEventUpdateInput = {
	allowsResponses?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEndDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEndTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStartDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStartTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	endDate?: InputMaybe<Scalars["Date"]["input"]>;
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	location?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	startDate?: InputMaybe<Scalars["Date"]["input"]>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
};

export type Campus = Node & {
	__typename?: "Campus";
	addressLine1: Scalars["String"]["output"];
	addressLine2: Scalars["String"]["output"];
	buildings: Array<Building>;
	city: Scalars["String"]["output"];
	country: Country;
	countryID: Scalars["ID"]["output"];
	employees: Array<Employee>;
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
	phoneNumber: Scalars["String"]["output"];
	postalCode: Scalars["String"]["output"];
	stateOrProvince: Scalars["String"]["output"];
};

export type CampusBuildingsArgs = {
	filters?: InputMaybe<Array<BuildingFilterInput>>;
	order?: InputMaybe<BuildingOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CampusEmployeesArgs = {
	filters?: InputMaybe<Array<EmployeeFilterInput>>;
	order?: InputMaybe<EmployeeOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CampusConnection = {
	__typename?: "CampusConnection";
	edges: Array<CampusEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CampusCreateInput = {
	addressLine1: Scalars["String"]["input"];
	addressLine2?: InputMaybe<Scalars["String"]["input"]>;
	buildingIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	buildings?: InputMaybe<Array<BuildingInCampusCreateInput>>;
	city: Scalars["String"]["input"];
	countryID: Scalars["ID"]["input"];
	employeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name: Scalars["String"]["input"];
	phoneNumber: Scalars["String"]["input"];
	postalCode?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvince?: InputMaybe<Scalars["String"]["input"]>;
};

export type CampusEdge = {
	__typename?: "CampusEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Campus;
};

export type CampusFilterInput = {
	addressLine1Contains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1EQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1HasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1HasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1In?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressLine1NEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressLine2Contains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2EQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2HasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2HasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2In?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressLine2NEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<CampusFilterInput>>;
	buildings?: InputMaybe<Array<BuildingFilterInput>>;
	cityContains?: InputMaybe<Scalars["String"]["input"]>;
	cityEQ?: InputMaybe<Scalars["String"]["input"]>;
	cityHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	cityHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	cityIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	cityNEQ?: InputMaybe<Scalars["String"]["input"]>;
	cityNotContains?: InputMaybe<Scalars["String"]["input"]>;
	cityNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	cityNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	cityNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	country?: InputMaybe<Array<CountryFilterInput>>;
	countryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	countryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	countryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	countryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	employees?: InputMaybe<Array<EmployeeFilterInput>>;
	hasBuildings?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<CampusFilterInput>;
	or?: InputMaybe<Array<CampusFilterInput>>;
	phoneNumberContains?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberEQ?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	phoneNumberNEQ?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotContains?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	postalCodeContains?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeEQ?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	postalCodeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceContains?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceEQ?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	stateOrProvinceNEQ?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceNotContains?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type CampusHistory = Node & {
	__typename?: "CampusHistory";
	addressLine1: Maybe<Scalars["String"]["output"]>;
	addressLine2: Maybe<Scalars["String"]["output"]>;
	city: Maybe<Scalars["String"]["output"]>;
	countryID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	phoneNumber: Maybe<Scalars["String"]["output"]>;
	postalCode: Maybe<Scalars["String"]["output"]>;
	stateOrProvince: Maybe<Scalars["String"]["output"]>;
};

export type CampusHistoryConnection = {
	__typename?: "CampusHistoryConnection";
	edges: Array<CampusHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CampusHistoryEdge = {
	__typename?: "CampusHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CampusHistory;
};

export type CampusHistoryFilterInput = {
	addressLine1Contains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1EQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1HasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1HasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1In?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressLine1IsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	addressLine1NEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressLine2Contains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2EQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2HasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2HasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2In?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressLine2IsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	addressLine2NEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<CampusHistoryFilterInput>>;
	cityContains?: InputMaybe<Scalars["String"]["input"]>;
	cityEQ?: InputMaybe<Scalars["String"]["input"]>;
	cityHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	cityHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	cityIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	cityIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	cityNEQ?: InputMaybe<Scalars["String"]["input"]>;
	cityNotContains?: InputMaybe<Scalars["String"]["input"]>;
	cityNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	cityNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	cityNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	countryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	countryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	countryIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	countryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	countryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<CampusHistoryFilterInput>;
	or?: InputMaybe<Array<CampusHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	phoneNumberContains?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberEQ?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	phoneNumberIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	phoneNumberNEQ?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotContains?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	postalCodeContains?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeEQ?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	postalCodeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	postalCodeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	postalCodeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceContains?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceEQ?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	stateOrProvinceIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	stateOrProvinceNEQ?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceNotContains?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvinceNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type CampusHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CampusHistoryOrderField>;
};

export enum CampusHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type CampusInCountryCreateInput = {
	addressLine1: Scalars["String"]["input"];
	addressLine2?: InputMaybe<Scalars["String"]["input"]>;
	buildingIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	buildings?: InputMaybe<Array<BuildingInCampusCreateInput>>;
	city: Scalars["String"]["input"];
	employeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name: Scalars["String"]["input"];
	phoneNumber: Scalars["String"]["input"];
	postalCode?: InputMaybe<Scalars["String"]["input"]>;
	stateOrProvince?: InputMaybe<Scalars["String"]["input"]>;
};

export type CampusOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CampusOrderField>;
};

export enum CampusOrderField {
	AddressLine1 = "ADDRESS_LINE_1",
	City = "CITY",
	Name = "NAME",
	PostalCode = "POSTAL_CODE",
	StateOrProvince = "STATE_OR_PROVINCE",
}

export type CampusUpdateBulkInput = {
	addBuildingIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addressLine1?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2?: InputMaybe<Scalars["String"]["input"]>;
	buildingIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	city?: InputMaybe<Scalars["String"]["input"]>;
	clearBuildings?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	countryID?: InputMaybe<Scalars["ID"]["input"]>;
	employeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
	postalCode?: InputMaybe<Scalars["String"]["input"]>;
	removeBuildingIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	stateOrProvince?: InputMaybe<Scalars["String"]["input"]>;
};

export type CampusUpdateInput = {
	addBuildingIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addressLine1?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2?: InputMaybe<Scalars["String"]["input"]>;
	buildingIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	city?: InputMaybe<Scalars["String"]["input"]>;
	clearBuildings?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	countryID?: InputMaybe<Scalars["ID"]["input"]>;
	employeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
	postalCode?: InputMaybe<Scalars["String"]["input"]>;
	removeBuildingIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	stateOrProvince?: InputMaybe<Scalars["String"]["input"]>;
};

export type ClassYear = Node & {
	__typename?: "ClassYear";
	classYearCategories: Array<ClassYearCategory>;
	courses: Array<Course>;
	currentEnrollmentApplicationStudents: Array<EnrollmentApplicationStudent>;
	employees: Array<Employee>;
	enrollmentApplicationStudents: Array<EnrollmentApplicationStudent>;
	graduationYear: Scalars["Int"]["output"];
	homeRooms: Array<HomeRoom>;
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
	services: Array<Service>;
	sharingRecords: Array<SharingRecord>;
	userGroups: Array<UserGroup>;
	yearsFromGraduation: Scalars["Int"]["output"];
};

export type ClassYearClassYearCategoriesArgs = {
	filters?: InputMaybe<Array<ClassYearCategoryFilterInput>>;
	order?: InputMaybe<ClassYearCategoryOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ClassYearCoursesArgs = {
	filters?: InputMaybe<Array<CourseFilterInput>>;
	order?: InputMaybe<CourseOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ClassYearCurrentEnrollmentApplicationStudentsArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationStudentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ClassYearEmployeesArgs = {
	filters?: InputMaybe<Array<EmployeeFilterInput>>;
	order?: InputMaybe<EmployeeOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ClassYearEnrollmentApplicationStudentsArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationStudentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ClassYearHomeRoomsArgs = {
	filters?: InputMaybe<Array<HomeRoomFilterInput>>;
	order?: InputMaybe<HomeRoomOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ClassYearServicesArgs = {
	filters?: InputMaybe<Array<ServiceFilterInput>>;
	order?: InputMaybe<ServiceOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ClassYearSharingRecordsArgs = {
	filters?: InputMaybe<Array<SharingRecordFilterInput>>;
	order?: InputMaybe<SharingRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ClassYearUserGroupsArgs = {
	filters?: InputMaybe<Array<UserGroupFilterInput>>;
	order?: InputMaybe<UserGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ClassYearAttendanceRecordCountStatistics = {
	__typename?: "ClassYearAttendanceRecordCountStatistics";
	attendanceRecordCountStatistics: AttendanceRecordCountStatistics;
	classYear: ClassYearInAttendanceRecordStatistics;
};

export type ClassYearCategory = Node & {
	__typename?: "ClassYearCategory";
	classYears: Array<ClassYear>;
	description: Scalars["String"]["output"];
	employees: Array<Employee>;
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
	sharingRecords: Array<SharingRecord>;
	userGroups: Array<UserGroup>;
};

export type ClassYearCategoryClassYearsArgs = {
	filters?: InputMaybe<Array<ClassYearFilterInput>>;
	order?: InputMaybe<ClassYearOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ClassYearCategoryEmployeesArgs = {
	filters?: InputMaybe<Array<EmployeeFilterInput>>;
	order?: InputMaybe<EmployeeOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ClassYearCategorySharingRecordsArgs = {
	filters?: InputMaybe<Array<SharingRecordFilterInput>>;
	order?: InputMaybe<SharingRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ClassYearCategoryUserGroupsArgs = {
	filters?: InputMaybe<Array<UserGroupFilterInput>>;
	order?: InputMaybe<UserGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ClassYearCategoryClassYearHistory = Node & {
	__typename?: "ClassYearCategoryClassYearHistory";
	classYearCategoryID: Maybe<Scalars["ID"]["output"]>;
	classYearID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
};

export type ClassYearCategoryClassYearHistoryConnection = {
	__typename?: "ClassYearCategoryClassYearHistoryConnection";
	edges: Array<ClassYearCategoryClassYearHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ClassYearCategoryClassYearHistoryEdge = {
	__typename?: "ClassYearCategoryClassYearHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ClassYearCategoryClassYearHistory;
};

export type ClassYearCategoryClassYearHistoryFilterInput = {
	and?: InputMaybe<Array<ClassYearCategoryClassYearHistoryFilterInput>>;
	classYearCategoryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearCategoryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearCategoryIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	classYearCategoryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearCategoryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	classYearIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<ClassYearCategoryClassYearHistoryFilterInput>;
	or?: InputMaybe<Array<ClassYearCategoryClassYearHistoryFilterInput>>;
};

export type ClassYearCategoryClassYearHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ClassYearCategoryClassYearHistoryOrderField>;
};

export enum ClassYearCategoryClassYearHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type ClassYearCategoryConnection = {
	__typename?: "ClassYearCategoryConnection";
	edges: Array<ClassYearCategoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ClassYearCategoryCreateInput = {
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	employeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name: Scalars["String"]["input"];
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ClassYearCategoryEdge = {
	__typename?: "ClassYearCategoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ClassYearCategory;
};

export type ClassYearCategoryFilterInput = {
	and?: InputMaybe<Array<ClassYearCategoryFilterInput>>;
	classYears?: InputMaybe<Array<ClassYearFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	employees?: InputMaybe<Array<EmployeeFilterInput>>;
	hasClassYears?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<ClassYearCategoryFilterInput>;
	or?: InputMaybe<Array<ClassYearCategoryFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	sharingRecords?: InputMaybe<Array<SharingRecordFilterInput>>;
	userGroups?: InputMaybe<Array<UserGroupFilterInput>>;
};

export type ClassYearCategoryHistory = Node & {
	__typename?: "ClassYearCategoryHistory";
	description: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type ClassYearCategoryHistoryConnection = {
	__typename?: "ClassYearCategoryHistoryConnection";
	edges: Array<ClassYearCategoryHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ClassYearCategoryHistoryEdge = {
	__typename?: "ClassYearCategoryHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ClassYearCategoryHistory;
};

export type ClassYearCategoryHistoryFilterInput = {
	and?: InputMaybe<Array<ClassYearCategoryHistoryFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<ClassYearCategoryHistoryFilterInput>;
	or?: InputMaybe<Array<ClassYearCategoryHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type ClassYearCategoryHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ClassYearCategoryHistoryOrderField>;
};

export enum ClassYearCategoryHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type ClassYearCategoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ClassYearCategoryOrderField>;
};

export enum ClassYearCategoryOrderField {
	Name = "NAME",
}

export type ClassYearCategoryUpdateBulkInput = {
	addClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearClassYears?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	employeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ClassYearCategoryUpdateInput = {
	addClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearClassYears?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	employeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ClassYearConnection = {
	__typename?: "ClassYearConnection";
	edges: Array<ClassYearEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ClassYearCourseHistory = Node & {
	__typename?: "ClassYearCourseHistory";
	classYearID: Maybe<Scalars["ID"]["output"]>;
	courseID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
};

export type ClassYearCourseHistoryConnection = {
	__typename?: "ClassYearCourseHistoryConnection";
	edges: Array<ClassYearCourseHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ClassYearCourseHistoryEdge = {
	__typename?: "ClassYearCourseHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ClassYearCourseHistory;
};

export type ClassYearCourseHistoryFilterInput = {
	and?: InputMaybe<Array<ClassYearCourseHistoryFilterInput>>;
	classYearIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	classYearIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<ClassYearCourseHistoryFilterInput>;
	or?: InputMaybe<Array<ClassYearCourseHistoryFilterInput>>;
};

export type ClassYearCourseHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ClassYearCourseHistoryOrderField>;
};

export enum ClassYearCourseHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type ClassYearCreateInput = {
	classYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	currentEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	currentEnrollmentApplicationStudents?: InputMaybe<Array<EnrollmentApplicationStudentInCurrentClassYearCreateInput>>;
	employeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudents?: InputMaybe<Array<EnrollmentApplicationStudentInClassYearCreateInput>>;
	homeRoomIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRooms?: InputMaybe<Array<HomeRoomInClassYearCreateInput>>;
	name: Scalars["String"]["input"];
	serviceIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	yearsFromGraduation: Scalars["Int"]["input"];
};

export type ClassYearEdge = {
	__typename?: "ClassYearEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ClassYear;
};

export type ClassYearFilterInput = {
	and?: InputMaybe<Array<ClassYearFilterInput>>;
	classYearCategories?: InputMaybe<Array<ClassYearCategoryFilterInput>>;
	courses?: InputMaybe<Array<CourseFilterInput>>;
	currentEnrollmentApplicationStudents?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	employees?: InputMaybe<Array<EmployeeFilterInput>>;
	enrollmentApplicationStudents?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	hasClassYearCategories?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCourses?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCurrentEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasHomeRooms?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasServices?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRooms?: InputMaybe<Array<HomeRoomFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<ClassYearFilterInput>;
	or?: InputMaybe<Array<ClassYearFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	services?: InputMaybe<Array<ServiceFilterInput>>;
	sharingRecords?: InputMaybe<Array<SharingRecordFilterInput>>;
	userGroups?: InputMaybe<Array<UserGroupFilterInput>>;
	yearsFromGraduationEQ?: InputMaybe<Scalars["Int"]["input"]>;
	yearsFromGraduationGT?: InputMaybe<Scalars["Int"]["input"]>;
	yearsFromGraduationGTE?: InputMaybe<Scalars["Int"]["input"]>;
	yearsFromGraduationIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	yearsFromGraduationLT?: InputMaybe<Scalars["Int"]["input"]>;
	yearsFromGraduationLTE?: InputMaybe<Scalars["Int"]["input"]>;
	yearsFromGraduationNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	yearsFromGraduationNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type ClassYearHistory = Node & {
	__typename?: "ClassYearHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	yearsFromGraduation: Maybe<Scalars["Int"]["output"]>;
};

export type ClassYearHistoryConnection = {
	__typename?: "ClassYearHistoryConnection";
	edges: Array<ClassYearHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ClassYearHistoryEdge = {
	__typename?: "ClassYearHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ClassYearHistory;
};

export type ClassYearHistoryFilterInput = {
	and?: InputMaybe<Array<ClassYearHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<ClassYearHistoryFilterInput>;
	or?: InputMaybe<Array<ClassYearHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	yearsFromGraduationEQ?: InputMaybe<Scalars["Int"]["input"]>;
	yearsFromGraduationGT?: InputMaybe<Scalars["Int"]["input"]>;
	yearsFromGraduationGTE?: InputMaybe<Scalars["Int"]["input"]>;
	yearsFromGraduationIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	yearsFromGraduationIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	yearsFromGraduationLT?: InputMaybe<Scalars["Int"]["input"]>;
	yearsFromGraduationLTE?: InputMaybe<Scalars["Int"]["input"]>;
	yearsFromGraduationNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	yearsFromGraduationNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type ClassYearHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ClassYearHistoryOrderField>;
};

export enum ClassYearHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type ClassYearInAttendanceRecordStatistics = {
	__typename?: "ClassYearInAttendanceRecordStatistics";
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
};

export type ClassYearOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ClassYearOrderField>;
};

export enum ClassYearOrderField {
	Name = "NAME",
	YearsFromGraduation = "YEARS_FROM_GRADUATION",
}

export type ClassYearUpdateBulkInput = {
	addClassYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addCourseIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addCurrentEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addHomeRoomIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addServiceIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearClassYearCategories?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearCourses?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearCurrentEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearHomeRooms?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearServices?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	currentEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	employeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeClassYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeCourseIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeCurrentEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeHomeRoomIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeServiceIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	serviceIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	yearsFromGraduation?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ClassYearUpdateInput = {
	addClassYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addCourseIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addCurrentEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addHomeRoomIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addServiceIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearClassYearCategories?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearCourses?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearCurrentEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearHomeRooms?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearServices?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	currentEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	employeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeClassYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeCourseIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeCurrentEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeHomeRoomIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeServiceIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	serviceIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	yearsFromGraduation?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Contract = Node & {
	__typename?: "Contract";
	academicTerms: Array<AcademicTerm>;
	approvingUser: Maybe<User>;
	approvingUserID: Maybe<Scalars["ID"]["output"]>;
	contractInstallments: Array<ContractInstallment>;
	contractLineItems: Array<ContractLineItem>;
	dateVoided: Maybe<Scalars["Date"]["output"]>;
	effectiveDate: Maybe<Scalars["Date"]["output"]>;
	fileContentType: Scalars["String"]["output"];
	fileKey: Scalars["String"]["output"];
	fileURL: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	isApproved: Scalars["Boolean"]["output"];
	isFinalized: Scalars["Boolean"]["output"];
	name: Scalars["String"]["output"];
	signedFileContentType: Scalars["String"]["output"];
	signedFileKey: Scalars["String"]["output"];
	signedFileURL: Scalars["String"]["output"];
	status: Scalars["String"]["output"];
	student: Student;
	studentID: Scalars["ID"]["output"];
};

export type ContractAcademicTermsArgs = {
	filters?: InputMaybe<Array<AcademicTermFilterInput>>;
	order?: InputMaybe<AcademicTermOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ContractContractInstallmentsArgs = {
	filters?: InputMaybe<Array<ContractInstallmentFilterInput>>;
	order?: InputMaybe<ContractInstallmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ContractContractLineItemsArgs = {
	filters?: InputMaybe<Array<ContractLineItemFilterInput>>;
	order?: InputMaybe<ContractLineItemOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ContractAcademicTermHistory = Node & {
	__typename?: "ContractAcademicTermHistory";
	academicTermID: Maybe<Scalars["ID"]["output"]>;
	contractID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
};

export type ContractAcademicTermHistoryConnection = {
	__typename?: "ContractAcademicTermHistoryConnection";
	edges: Array<ContractAcademicTermHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ContractAcademicTermHistoryEdge = {
	__typename?: "ContractAcademicTermHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ContractAcademicTermHistory;
};

export type ContractAcademicTermHistoryFilterInput = {
	academicTermIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicTermIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	academicTermIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	academicTermIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicTermIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	and?: InputMaybe<Array<ContractAcademicTermHistoryFilterInput>>;
	contractIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	contractIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	contractIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	contractIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	contractIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<ContractAcademicTermHistoryFilterInput>;
	or?: InputMaybe<Array<ContractAcademicTermHistoryFilterInput>>;
};

export type ContractAcademicTermHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ContractAcademicTermHistoryOrderField>;
};

export enum ContractAcademicTermHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type ContractConnection = {
	__typename?: "ContractConnection";
	edges: Array<ContractEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ContractCreateInput = {
	academicTermIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	contractInstallments?: InputMaybe<Array<ContractInstallmentInContractCreateInput>>;
	contractLineItems?: InputMaybe<Array<ContractLineItemInContractCreateInput>>;
	dateVoided?: InputMaybe<Scalars["Date"]["input"]>;
	effectiveDate?: InputMaybe<Scalars["Date"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	isApproved?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinalized?: InputMaybe<Scalars["Boolean"]["input"]>;
	name: Scalars["String"]["input"];
	signedFileContentType?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKey?: InputMaybe<Scalars["String"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type ContractEdge = {
	__typename?: "ContractEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Contract;
};

export type ContractFilterInput = {
	academicTerms?: InputMaybe<Array<AcademicTermFilterInput>>;
	and?: InputMaybe<Array<ContractFilterInput>>;
	approvingUser?: InputMaybe<Array<UserFilterInput>>;
	approvingUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	approvingUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	approvingUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	approvingUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	approvingUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	contractInstallments?: InputMaybe<Array<ContractInstallmentFilterInput>>;
	contractLineItems?: InputMaybe<Array<ContractLineItemFilterInput>>;
	dateVoidedEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateVoidedGT?: InputMaybe<Scalars["Date"]["input"]>;
	dateVoidedGTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateVoidedIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dateVoidedIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateVoidedLT?: InputMaybe<Scalars["Date"]["input"]>;
	dateVoidedLTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateVoidedNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateVoidedNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	effectiveDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	effectiveDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	effectiveDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	effectiveDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	effectiveDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	effectiveDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	effectiveDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	effectiveDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	effectiveDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	fileContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasAcademicTerms?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasApprovingUser?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasContractInstallments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasContractLineItems?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isApprovedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isApprovedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinalizedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinalizedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<ContractFilterInput>;
	or?: InputMaybe<Array<ContractFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	signedFileContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	signedFileContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	signedFileContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	signedFileContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	signedFileContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	signedFileContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	signedFileContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	signedFileContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	signedFileContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	signedFileContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	signedFileKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	signedFileKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ContractHistory = Node & {
	__typename?: "ContractHistory";
	approvingUserID: Maybe<Scalars["ID"]["output"]>;
	dateVoided: Maybe<Scalars["Date"]["output"]>;
	effectiveDate: Maybe<Scalars["Date"]["output"]>;
	fileContentType: Maybe<Scalars["String"]["output"]>;
	fileKey: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isApproved: Maybe<Scalars["Boolean"]["output"]>;
	isFinalized: Maybe<Scalars["Boolean"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	signedFileContentType: Maybe<Scalars["String"]["output"]>;
	signedFileKey: Maybe<Scalars["String"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
};

export type ContractHistoryConnection = {
	__typename?: "ContractHistoryConnection";
	edges: Array<ContractHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ContractHistoryEdge = {
	__typename?: "ContractHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ContractHistory;
};

export type ContractHistoryFilterInput = {
	and?: InputMaybe<Array<ContractHistoryFilterInput>>;
	approvingUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	approvingUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	approvingUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	approvingUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	approvingUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	dateVoidedEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateVoidedGT?: InputMaybe<Scalars["Date"]["input"]>;
	dateVoidedGTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateVoidedIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dateVoidedIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateVoidedLT?: InputMaybe<Scalars["Date"]["input"]>;
	dateVoidedLTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateVoidedNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateVoidedNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	effectiveDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	effectiveDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	effectiveDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	effectiveDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	effectiveDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	effectiveDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	effectiveDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	effectiveDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	effectiveDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	fileContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileContentTypeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	fileContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileKeyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	fileKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isApprovedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isApprovedIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isApprovedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinalizedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinalizedIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinalizedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<ContractHistoryFilterInput>;
	or?: InputMaybe<Array<ContractHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	signedFileContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	signedFileContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	signedFileContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	signedFileContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	signedFileContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	signedFileContentTypeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	signedFileContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	signedFileContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	signedFileContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	signedFileContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	signedFileContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	signedFileKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	signedFileKeyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	signedFileKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ContractHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ContractHistoryOrderField>;
};

export enum ContractHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type ContractInApprovingUserCreateInput = {
	academicTermIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	contractInstallments?: InputMaybe<Array<ContractInstallmentInContractCreateInput>>;
	contractLineItems?: InputMaybe<Array<ContractLineItemInContractCreateInput>>;
	dateVoided?: InputMaybe<Scalars["Date"]["input"]>;
	effectiveDate?: InputMaybe<Scalars["Date"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	isApproved?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinalized?: InputMaybe<Scalars["Boolean"]["input"]>;
	name: Scalars["String"]["input"];
	signedFileContentType?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKey?: InputMaybe<Scalars["String"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type ContractInStudentCreateInput = {
	academicTermIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	contractInstallments?: InputMaybe<Array<ContractInstallmentInContractCreateInput>>;
	contractLineItems?: InputMaybe<Array<ContractLineItemInContractCreateInput>>;
	dateVoided?: InputMaybe<Scalars["Date"]["input"]>;
	effectiveDate?: InputMaybe<Scalars["Date"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	isApproved?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinalized?: InputMaybe<Scalars["Boolean"]["input"]>;
	name: Scalars["String"]["input"];
	signedFileContentType?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type ContractInstallment = Node & {
	__typename?: "ContractInstallment";
	contract: Contract;
	contractID: Scalars["ID"]["output"];
	dueDate: Scalars["Date"]["output"];
	id: Scalars["ID"]["output"];
	invoices: Array<Invoice>;
	portion: Scalars["Int"]["output"];
};

export type ContractInstallmentInvoicesArgs = {
	filters?: InputMaybe<Array<InvoiceFilterInput>>;
	order?: InputMaybe<InvoiceOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ContractInstallmentConnection = {
	__typename?: "ContractInstallmentConnection";
	edges: Array<ContractInstallmentEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ContractInstallmentCreateInput = {
	contractID: Scalars["ID"]["input"];
	dueDate: Scalars["Date"]["input"];
	invoices?: InputMaybe<Array<InvoiceInContractInstallmentCreateInput>>;
	portion?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ContractInstallmentEdge = {
	__typename?: "ContractInstallmentEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ContractInstallment;
};

export type ContractInstallmentFilterInput = {
	and?: InputMaybe<Array<ContractInstallmentFilterInput>>;
	contract?: InputMaybe<Array<ContractFilterInput>>;
	contractIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	contractIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	contractIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	contractIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	dueDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dueDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	hasInvoices?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	invoices?: InputMaybe<Array<InvoiceFilterInput>>;
	not?: InputMaybe<ContractInstallmentFilterInput>;
	or?: InputMaybe<Array<ContractInstallmentFilterInput>>;
	portionEQ?: InputMaybe<Scalars["Int"]["input"]>;
	portionGT?: InputMaybe<Scalars["Int"]["input"]>;
	portionGTE?: InputMaybe<Scalars["Int"]["input"]>;
	portionIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	portionLT?: InputMaybe<Scalars["Int"]["input"]>;
	portionLTE?: InputMaybe<Scalars["Int"]["input"]>;
	portionNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	portionNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type ContractInstallmentHistory = Node & {
	__typename?: "ContractInstallmentHistory";
	contractID: Maybe<Scalars["ID"]["output"]>;
	dueDate: Maybe<Scalars["Date"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
	portion: Maybe<Scalars["Int"]["output"]>;
};

export type ContractInstallmentHistoryConnection = {
	__typename?: "ContractInstallmentHistoryConnection";
	edges: Array<ContractInstallmentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ContractInstallmentHistoryEdge = {
	__typename?: "ContractInstallmentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ContractInstallmentHistory;
};

export type ContractInstallmentHistoryFilterInput = {
	and?: InputMaybe<Array<ContractInstallmentHistoryFilterInput>>;
	contractIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	contractIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	contractIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	contractIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	contractIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	dueDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dueDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dueDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<ContractInstallmentHistoryFilterInput>;
	or?: InputMaybe<Array<ContractInstallmentHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	portionEQ?: InputMaybe<Scalars["Int"]["input"]>;
	portionGT?: InputMaybe<Scalars["Int"]["input"]>;
	portionGTE?: InputMaybe<Scalars["Int"]["input"]>;
	portionIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	portionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	portionLT?: InputMaybe<Scalars["Int"]["input"]>;
	portionLTE?: InputMaybe<Scalars["Int"]["input"]>;
	portionNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	portionNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type ContractInstallmentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ContractInstallmentHistoryOrderField>;
};

export enum ContractInstallmentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type ContractInstallmentInContractCreateInput = {
	dueDate: Scalars["Date"]["input"];
	invoices?: InputMaybe<Array<InvoiceInContractInstallmentCreateInput>>;
	portion?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ContractInstallmentOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ContractInstallmentOrderField>;
};

export enum ContractInstallmentOrderField {
	DueDate = "DUE_DATE",
}

export type ContractInstallmentUpdateBulkInput = {
	dueDate?: InputMaybe<Scalars["Date"]["input"]>;
	portion?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ContractInstallmentUpdateInput = {
	dueDate?: InputMaybe<Scalars["Date"]["input"]>;
	portion?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ContractLineItem = Node & {
	__typename?: "ContractLineItem";
	amount: Scalars["Int"]["output"];
	childContractLineItems: Array<ContractLineItem>;
	contract: Maybe<Contract>;
	contractID: Maybe<Scalars["ID"]["output"]>;
	dateAdded: Maybe<Scalars["Date"]["output"]>;
	dateRemoved: Maybe<Scalars["Date"]["output"]>;
	description: Scalars["String"]["output"];
	discount: Maybe<Discount>;
	discountID: Maybe<Scalars["ID"]["output"]>;
	displayOrder: Scalars["Int"]["output"];
	id: Scalars["ID"]["output"];
	invoiceLineItems: Array<InvoiceLineItem>;
	isDiscount: Scalars["Boolean"]["output"];
	parentContractLineItem: Maybe<ContractLineItem>;
	parentContractLineItemID: Maybe<Scalars["ID"]["output"]>;
	service: Maybe<Service>;
	serviceID: Maybe<Scalars["ID"]["output"]>;
};

export type ContractLineItemChildContractLineItemsArgs = {
	filters?: InputMaybe<Array<ContractLineItemFilterInput>>;
	order?: InputMaybe<ContractLineItemOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ContractLineItemInvoiceLineItemsArgs = {
	filters?: InputMaybe<Array<InvoiceLineItemFilterInput>>;
	order?: InputMaybe<InvoiceLineItemOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ContractLineItemConnection = {
	__typename?: "ContractLineItemConnection";
	edges: Array<ContractLineItemEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ContractLineItemCreateInput = {
	amount: Scalars["Int"]["input"];
	childContractLineItems?: InputMaybe<Array<ContractLineItemInParentContractLineItemCreateInput>>;
	contractID?: InputMaybe<Scalars["ID"]["input"]>;
	dateAdded?: InputMaybe<Scalars["Date"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	discountID?: InputMaybe<Scalars["ID"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	invoiceLineItems?: InputMaybe<Array<InvoiceLineItemInContractLineItemCreateInput>>;
	parentContractLineItemID?: InputMaybe<Scalars["ID"]["input"]>;
	serviceID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ContractLineItemEdge = {
	__typename?: "ContractLineItemEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ContractLineItem;
};

export type ContractLineItemFilterInput = {
	amountEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountGT?: InputMaybe<Scalars["Int"]["input"]>;
	amountGTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	amountLT?: InputMaybe<Scalars["Int"]["input"]>;
	amountLTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	and?: InputMaybe<Array<ContractLineItemFilterInput>>;
	childContractLineItems?: InputMaybe<Array<ContractLineItemFilterInput>>;
	contract?: InputMaybe<Array<ContractFilterInput>>;
	contractIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	contractIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	contractIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	contractIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	contractIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	dateAddedEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateAddedGT?: InputMaybe<Scalars["Date"]["input"]>;
	dateAddedGTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateAddedIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dateAddedIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateAddedLT?: InputMaybe<Scalars["Date"]["input"]>;
	dateAddedLTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateAddedNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateAddedNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dateRemovedEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateRemovedGT?: InputMaybe<Scalars["Date"]["input"]>;
	dateRemovedGTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateRemovedIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dateRemovedIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateRemovedLT?: InputMaybe<Scalars["Date"]["input"]>;
	dateRemovedLTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateRemovedNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateRemovedNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	discount?: InputMaybe<Array<DiscountFilterInput>>;
	discountIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	discountIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	discountIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	discountIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	discountIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	displayOrderEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	displayOrderLT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderLTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	hasChildContractLineItems?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasContract?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasDiscount?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasInvoiceLineItems?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasParentContractLineItem?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasService?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	invoiceLineItems?: InputMaybe<Array<InvoiceLineItemFilterInput>>;
	not?: InputMaybe<ContractLineItemFilterInput>;
	or?: InputMaybe<Array<ContractLineItemFilterInput>>;
	parentContractLineItem?: InputMaybe<Array<ContractLineItemFilterInput>>;
	parentContractLineItemIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	parentContractLineItemIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	parentContractLineItemIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	parentContractLineItemIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	parentContractLineItemIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	service?: InputMaybe<Array<ServiceFilterInput>>;
	serviceIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	serviceIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	serviceIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	serviceIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	serviceIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ContractLineItemHistory = Node & {
	__typename?: "ContractLineItemHistory";
	amount: Maybe<Scalars["Int"]["output"]>;
	contractID: Maybe<Scalars["ID"]["output"]>;
	dateAdded: Maybe<Scalars["Date"]["output"]>;
	dateRemoved: Maybe<Scalars["Date"]["output"]>;
	description: Maybe<Scalars["String"]["output"]>;
	discountID: Maybe<Scalars["ID"]["output"]>;
	displayOrder: Maybe<Scalars["Int"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
	parentContractLineItemID: Maybe<Scalars["ID"]["output"]>;
	serviceID: Maybe<Scalars["ID"]["output"]>;
};

export type ContractLineItemHistoryConnection = {
	__typename?: "ContractLineItemHistoryConnection";
	edges: Array<ContractLineItemHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ContractLineItemHistoryEdge = {
	__typename?: "ContractLineItemHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ContractLineItemHistory;
};

export type ContractLineItemHistoryFilterInput = {
	amountEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountGT?: InputMaybe<Scalars["Int"]["input"]>;
	amountGTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	amountIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	amountLT?: InputMaybe<Scalars["Int"]["input"]>;
	amountLTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	and?: InputMaybe<Array<ContractLineItemHistoryFilterInput>>;
	contractIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	contractIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	contractIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	contractIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	contractIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	dateAddedEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateAddedGT?: InputMaybe<Scalars["Date"]["input"]>;
	dateAddedGTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateAddedIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dateAddedIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateAddedLT?: InputMaybe<Scalars["Date"]["input"]>;
	dateAddedLTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateAddedNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateAddedNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dateRemovedEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateRemovedGT?: InputMaybe<Scalars["Date"]["input"]>;
	dateRemovedGTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateRemovedIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dateRemovedIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateRemovedLT?: InputMaybe<Scalars["Date"]["input"]>;
	dateRemovedLTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateRemovedNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateRemovedNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	discountIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	discountIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	discountIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	discountIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	discountIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	displayOrderEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	displayOrderIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	displayOrderLT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderLTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<ContractLineItemHistoryFilterInput>;
	or?: InputMaybe<Array<ContractLineItemHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	parentContractLineItemIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	parentContractLineItemIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	parentContractLineItemIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	parentContractLineItemIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	parentContractLineItemIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	serviceIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	serviceIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	serviceIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	serviceIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	serviceIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ContractLineItemHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ContractLineItemHistoryOrderField>;
};

export enum ContractLineItemHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type ContractLineItemInContractCreateInput = {
	amount: Scalars["Int"]["input"];
	childContractLineItems?: InputMaybe<Array<ContractLineItemInParentContractLineItemCreateInput>>;
	dateAdded?: InputMaybe<Scalars["Date"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	discountID?: InputMaybe<Scalars["ID"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	invoiceLineItems?: InputMaybe<Array<InvoiceLineItemInContractLineItemCreateInput>>;
	parentContractLineItemID?: InputMaybe<Scalars["ID"]["input"]>;
	serviceID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ContractLineItemInDiscountCreateInput = {
	amount: Scalars["Int"]["input"];
	childContractLineItems?: InputMaybe<Array<ContractLineItemInParentContractLineItemCreateInput>>;
	contractID?: InputMaybe<Scalars["ID"]["input"]>;
	dateAdded?: InputMaybe<Scalars["Date"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	invoiceLineItems?: InputMaybe<Array<InvoiceLineItemInContractLineItemCreateInput>>;
	parentContractLineItemID?: InputMaybe<Scalars["ID"]["input"]>;
	serviceID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ContractLineItemInParentContractLineItemCreateInput = {
	amount: Scalars["Int"]["input"];
	childContractLineItems?: InputMaybe<Array<ContractLineItemInParentContractLineItemCreateInput>>;
	contractID?: InputMaybe<Scalars["ID"]["input"]>;
	dateAdded?: InputMaybe<Scalars["Date"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	discountID?: InputMaybe<Scalars["ID"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	invoiceLineItems?: InputMaybe<Array<InvoiceLineItemInContractLineItemCreateInput>>;
	serviceID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ContractLineItemInServiceCreateInput = {
	amount: Scalars["Int"]["input"];
	childContractLineItems?: InputMaybe<Array<ContractLineItemInParentContractLineItemCreateInput>>;
	contractID?: InputMaybe<Scalars["ID"]["input"]>;
	dateAdded?: InputMaybe<Scalars["Date"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	discountID?: InputMaybe<Scalars["ID"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	invoiceLineItems?: InputMaybe<Array<InvoiceLineItemInContractLineItemCreateInput>>;
	parentContractLineItemID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ContractLineItemOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ContractLineItemOrderField>;
};

export enum ContractLineItemOrderField {
	Amount = "AMOUNT",
	DateAdded = "DATE_ADDED",
	DateRemoved = "DATE_REMOVED",
	DisplayOrder = "DISPLAY_ORDER",
}

export type ContractLineItemUpdateBulkInput = {
	amount?: InputMaybe<Scalars["Int"]["input"]>;
	clearDateAdded?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearDateRemoved?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateAdded?: InputMaybe<Scalars["Date"]["input"]>;
	dateRemoved?: InputMaybe<Scalars["Date"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ContractLineItemUpdateInput = {
	amount?: InputMaybe<Scalars["Int"]["input"]>;
	clearDateAdded?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearDateRemoved?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateAdded?: InputMaybe<Scalars["Date"]["input"]>;
	dateRemoved?: InputMaybe<Scalars["Date"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ContractOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ContractOrderField>;
};

export enum ContractOrderField {
	DateVoided = "DATE_VOIDED",
	EffectiveDate = "EFFECTIVE_DATE",
}

export type ContractUpdateBulkInput = {
	academicTermIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addAcademicTermIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearAcademicTerms?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearDateVoided?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEffectiveDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateVoided?: InputMaybe<Scalars["Date"]["input"]>;
	effectiveDate?: InputMaybe<Scalars["Date"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	isApproved?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinalized?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeAcademicTermIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	signedFileContentType?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type ContractUpdateInput = {
	academicTermIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addAcademicTermIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearAcademicTerms?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearDateVoided?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEffectiveDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateVoided?: InputMaybe<Scalars["Date"]["input"]>;
	effectiveDate?: InputMaybe<Scalars["Date"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	isApproved?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinalized?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeAcademicTermIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	signedFileContentType?: InputMaybe<Scalars["String"]["input"]>;
	signedFileKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type Country = Node & {
	__typename?: "Country";
	addressEnrollmentApplicationGuardians: Array<EnrollmentApplicationGuardian>;
	addresses: Array<Address>;
	campuses: Array<Campus>;
	enrollmentApplicationStudentSchools: Array<EnrollmentApplicationStudentSchool>;
	enrollmentApplicationStudents: Array<EnrollmentApplicationStudent>;
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
	people: Array<Person>;
};

export type CountryAddressEnrollmentApplicationGuardiansArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationGuardianOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CountryAddressesArgs = {
	filters?: InputMaybe<Array<AddressFilterInput>>;
	order?: InputMaybe<AddressOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CountryCampusesArgs = {
	filters?: InputMaybe<Array<CampusFilterInput>>;
	order?: InputMaybe<CampusOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CountryEnrollmentApplicationStudentSchoolsArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationStudentSchoolFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationStudentSchoolOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CountryEnrollmentApplicationStudentsArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationStudentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CountryPeopleArgs = {
	filters?: InputMaybe<Array<PersonFilterInput>>;
	order?: InputMaybe<PersonOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CountryConnection = {
	__typename?: "CountryConnection";
	edges: Array<CountryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CountryCreateInput = {
	addressEnrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addressEnrollmentApplicationGuardians?: InputMaybe<Array<EnrollmentApplicationGuardianInAddressCountryCreateInput>>;
	addressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addresses?: InputMaybe<Array<AddressInCountryCreateInput>>;
	campusIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	campuses?: InputMaybe<Array<CampusInCountryCreateInput>>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentSchools?: InputMaybe<Array<EnrollmentApplicationStudentSchoolInCountryCreateInput>>;
	name: Scalars["String"]["input"];
	personIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CountryEdge = {
	__typename?: "CountryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Country;
};

export type CountryFilterInput = {
	addressEnrollmentApplicationGuardians?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput>>;
	addresses?: InputMaybe<Array<AddressFilterInput>>;
	and?: InputMaybe<Array<CountryFilterInput>>;
	campuses?: InputMaybe<Array<CampusFilterInput>>;
	enrollmentApplicationStudentSchools?: InputMaybe<Array<EnrollmentApplicationStudentSchoolFilterInput>>;
	enrollmentApplicationStudents?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	hasAddressEnrollmentApplicationGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAddresses?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCampuses?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasEnrollmentApplicationStudentSchools?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPeople?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<CountryFilterInput>;
	or?: InputMaybe<Array<CountryFilterInput>>;
	people?: InputMaybe<Array<PersonFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type CountryHistory = Node & {
	__typename?: "CountryHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type CountryHistoryConnection = {
	__typename?: "CountryHistoryConnection";
	edges: Array<CountryHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CountryHistoryEdge = {
	__typename?: "CountryHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CountryHistory;
};

export type CountryHistoryFilterInput = {
	and?: InputMaybe<Array<CountryHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<CountryHistoryFilterInput>;
	or?: InputMaybe<Array<CountryHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type CountryHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CountryHistoryOrderField>;
};

export enum CountryHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type CountryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CountryOrderField>;
};

export enum CountryOrderField {
	Name = "NAME",
}

export type CountryUpdateBulkInput = {
	addAddressEnrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addCampusIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addEnrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addressEnrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	campusIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearAddressEnrollmentApplicationGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearAddresses?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearCampuses?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEnrollmentApplicationStudentSchools?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearPeople?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeAddressEnrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeCampusIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEnrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CountryUpdateInput = {
	addAddressEnrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addCampusIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addEnrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addressEnrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	campusIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearAddressEnrollmentApplicationGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearAddresses?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearCampuses?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEnrollmentApplicationStudentSchools?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearPeople?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	personIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeAddressEnrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeCampusIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEnrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type Course = Node & {
	__typename?: "Course";
	academicSubject: AcademicSubject;
	academicSubjectID: Scalars["ID"]["output"];
	classYears: Array<ClassYear>;
	courseSections: Array<CourseSection>;
	description: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
};

export type CourseClassYearsArgs = {
	filters?: InputMaybe<Array<ClassYearFilterInput>>;
	order?: InputMaybe<ClassYearOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CourseCourseSectionsArgs = {
	filters?: InputMaybe<Array<CourseSectionFilterInput>>;
	order?: InputMaybe<CourseSectionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CourseAssessment = Node & {
	__typename?: "CourseAssessment";
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	courseAssessmentCategory: CourseAssessmentCategory;
	courseAssessmentCategoryID: Scalars["ID"]["output"];
	courseAssessmentMarks: Array<CourseAssessmentMark>;
	courseAssessmentSubmissions: Array<CourseAssessmentSubmission>;
	courseAssessmentTimings: Array<CourseAssessmentTiming>;
	description: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	mediaAttachments: Array<MediaAttachment>;
	name: Scalars["String"]["output"];
	totalPoints: Scalars["Int"]["output"];
};

export type CourseAssessmentCourseAssessmentMarksArgs = {
	filters?: InputMaybe<Array<CourseAssessmentMarkFilterInput>>;
	order?: InputMaybe<CourseAssessmentMarkOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CourseAssessmentCourseAssessmentSubmissionsArgs = {
	filters?: InputMaybe<Array<CourseAssessmentSubmissionFilterInput>>;
	order?: InputMaybe<CourseAssessmentSubmissionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CourseAssessmentCourseAssessmentTimingsArgs = {
	filters?: InputMaybe<Array<CourseAssessmentTimingFilterInput>>;
	order?: InputMaybe<CourseAssessmentTimingOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CourseAssessmentMediaAttachmentsArgs = {
	filters?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	order?: InputMaybe<MediaAttachmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CourseAssessmentCategory = Node & {
	__typename?: "CourseAssessmentCategory";
	courseAssessmentCategoryMarkPortions: Array<CourseAssessmentCategoryMarkPortion>;
	courseAssessments: Array<CourseAssessment>;
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
};

export type CourseAssessmentCategoryCourseAssessmentCategoryMarkPortionsArgs = {
	filters?: InputMaybe<Array<CourseAssessmentCategoryMarkPortionFilterInput>>;
	order?: InputMaybe<CourseAssessmentCategoryMarkPortionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CourseAssessmentCategoryCourseAssessmentsArgs = {
	filters?: InputMaybe<Array<CourseAssessmentFilterInput>>;
	order?: InputMaybe<CourseAssessmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CourseAssessmentCategoryConnection = {
	__typename?: "CourseAssessmentCategoryConnection";
	edges: Array<CourseAssessmentCategoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseAssessmentCategoryCreateInput = {
	courseAssessmentCategoryMarkPortionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentCategoryMarkPortions?: InputMaybe<
		Array<CourseAssessmentCategoryMarkPortionInCourseAssessmentCategoryCreateInput>
	>;
	courseAssessmentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessments?: InputMaybe<Array<CourseAssessmentInCourseAssessmentCategoryCreateInput>>;
	name: Scalars["String"]["input"];
};

export type CourseAssessmentCategoryEdge = {
	__typename?: "CourseAssessmentCategoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseAssessmentCategory;
};

export type CourseAssessmentCategoryFilterInput = {
	and?: InputMaybe<Array<CourseAssessmentCategoryFilterInput>>;
	courseAssessmentCategoryMarkPortions?: InputMaybe<Array<CourseAssessmentCategoryMarkPortionFilterInput>>;
	courseAssessments?: InputMaybe<Array<CourseAssessmentFilterInput>>;
	hasCourseAssessmentCategoryMarkPortions?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCourseAssessments?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<CourseAssessmentCategoryFilterInput>;
	or?: InputMaybe<Array<CourseAssessmentCategoryFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type CourseAssessmentCategoryHistory = Node & {
	__typename?: "CourseAssessmentCategoryHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type CourseAssessmentCategoryHistoryConnection = {
	__typename?: "CourseAssessmentCategoryHistoryConnection";
	edges: Array<CourseAssessmentCategoryHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseAssessmentCategoryHistoryEdge = {
	__typename?: "CourseAssessmentCategoryHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseAssessmentCategoryHistory;
};

export type CourseAssessmentCategoryHistoryFilterInput = {
	and?: InputMaybe<Array<CourseAssessmentCategoryHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<CourseAssessmentCategoryHistoryFilterInput>;
	or?: InputMaybe<Array<CourseAssessmentCategoryHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type CourseAssessmentCategoryHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseAssessmentCategoryHistoryOrderField>;
};

export enum CourseAssessmentCategoryHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type CourseAssessmentCategoryMarkPortion = Node & {
	__typename?: "CourseAssessmentCategoryMarkPortion";
	courseAssessmentCategory: Maybe<CourseAssessmentCategory>;
	courseAssessmentCategoryID: Maybe<Scalars["ID"]["output"]>;
	courseSection: CourseSection;
	courseSectionID: Scalars["ID"]["output"];
	id: Scalars["ID"]["output"];
	markPortion: Scalars["Int"]["output"];
};

export type CourseAssessmentCategoryMarkPortionConnection = {
	__typename?: "CourseAssessmentCategoryMarkPortionConnection";
	edges: Array<CourseAssessmentCategoryMarkPortionEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseAssessmentCategoryMarkPortionCreateInput = {
	courseAssessmentCategoryID?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionID: Scalars["ID"]["input"];
	markPortion: Scalars["Int"]["input"];
};

export type CourseAssessmentCategoryMarkPortionEdge = {
	__typename?: "CourseAssessmentCategoryMarkPortionEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseAssessmentCategoryMarkPortion;
};

export type CourseAssessmentCategoryMarkPortionFilterInput = {
	and?: InputMaybe<Array<CourseAssessmentCategoryMarkPortionFilterInput>>;
	courseAssessmentCategory?: InputMaybe<Array<CourseAssessmentCategoryFilterInput>>;
	courseAssessmentCategoryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentCategoryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentCategoryIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseAssessmentCategoryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentCategoryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSection?: InputMaybe<Array<CourseSectionFilterInput>>;
	courseSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	hasCourseAssessmentCategory?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	markPortionEQ?: InputMaybe<Scalars["Int"]["input"]>;
	markPortionGT?: InputMaybe<Scalars["Int"]["input"]>;
	markPortionGTE?: InputMaybe<Scalars["Int"]["input"]>;
	markPortionIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	markPortionLT?: InputMaybe<Scalars["Int"]["input"]>;
	markPortionLTE?: InputMaybe<Scalars["Int"]["input"]>;
	markPortionNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	markPortionNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	not?: InputMaybe<CourseAssessmentCategoryMarkPortionFilterInput>;
	or?: InputMaybe<Array<CourseAssessmentCategoryMarkPortionFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type CourseAssessmentCategoryMarkPortionHistory = Node & {
	__typename?: "CourseAssessmentCategoryMarkPortionHistory";
	courseAssessmentCategoryID: Maybe<Scalars["ID"]["output"]>;
	courseSectionID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	markPortion: Maybe<Scalars["Int"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type CourseAssessmentCategoryMarkPortionHistoryConnection = {
	__typename?: "CourseAssessmentCategoryMarkPortionHistoryConnection";
	edges: Array<CourseAssessmentCategoryMarkPortionHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseAssessmentCategoryMarkPortionHistoryEdge = {
	__typename?: "CourseAssessmentCategoryMarkPortionHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseAssessmentCategoryMarkPortionHistory;
};

export type CourseAssessmentCategoryMarkPortionHistoryFilterInput = {
	and?: InputMaybe<Array<CourseAssessmentCategoryMarkPortionHistoryFilterInput>>;
	courseAssessmentCategoryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentCategoryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentCategoryIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseAssessmentCategoryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentCategoryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	markPortionEQ?: InputMaybe<Scalars["Int"]["input"]>;
	markPortionGT?: InputMaybe<Scalars["Int"]["input"]>;
	markPortionGTE?: InputMaybe<Scalars["Int"]["input"]>;
	markPortionIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	markPortionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	markPortionLT?: InputMaybe<Scalars["Int"]["input"]>;
	markPortionLTE?: InputMaybe<Scalars["Int"]["input"]>;
	markPortionNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	markPortionNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	not?: InputMaybe<CourseAssessmentCategoryMarkPortionHistoryFilterInput>;
	or?: InputMaybe<Array<CourseAssessmentCategoryMarkPortionHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CourseAssessmentCategoryMarkPortionHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseAssessmentCategoryMarkPortionHistoryOrderField>;
};

export enum CourseAssessmentCategoryMarkPortionHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type CourseAssessmentCategoryMarkPortionInCourseAssessmentCategoryCreateInput = {
	courseSectionID: Scalars["ID"]["input"];
	markPortion: Scalars["Int"]["input"];
};

export type CourseAssessmentCategoryMarkPortionInCourseSectionCreateInput = {
	courseAssessmentCategoryID?: InputMaybe<Scalars["ID"]["input"]>;
	markPortion: Scalars["Int"]["input"];
};

export type CourseAssessmentCategoryMarkPortionOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseAssessmentCategoryMarkPortionOrderField>;
};

export enum CourseAssessmentCategoryMarkPortionOrderField {
	MarkPortion = "MARK_PORTION",
}

export type CourseAssessmentCategoryMarkPortionUpdateBulkInput = {
	clearCourseAssessmentCategory?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseAssessmentCategoryID?: InputMaybe<Scalars["ID"]["input"]>;
	markPortion?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CourseAssessmentCategoryMarkPortionUpdateInput = {
	clearCourseAssessmentCategory?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseAssessmentCategoryID?: InputMaybe<Scalars["ID"]["input"]>;
	markPortion?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CourseAssessmentCategoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseAssessmentCategoryOrderField>;
};

export enum CourseAssessmentCategoryOrderField {
	Name = "NAME",
}

export type CourseAssessmentCategoryUpdateBulkInput = {
	addCourseAssessmentCategoryMarkPortionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addCourseAssessmentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearCourseAssessmentCategoryMarkPortions?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearCourseAssessments?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseAssessmentCategoryMarkPortionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeCourseAssessmentCategoryMarkPortionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeCourseAssessmentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CourseAssessmentCategoryUpdateInput = {
	addCourseAssessmentCategoryMarkPortionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addCourseAssessmentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearCourseAssessmentCategoryMarkPortions?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearCourseAssessments?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseAssessmentCategoryMarkPortionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeCourseAssessmentCategoryMarkPortionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeCourseAssessmentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CourseAssessmentConnection = {
	__typename?: "CourseAssessmentConnection";
	edges: Array<CourseAssessmentEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseAssessmentCreateInput = {
	courseAssessmentCategoryID: Scalars["ID"]["input"];
	courseAssessmentMarks?: InputMaybe<Array<CourseAssessmentMarkInCourseAssessmentCreateInput>>;
	courseAssessmentSubmissions?: InputMaybe<Array<CourseAssessmentSubmissionInCourseAssessmentCreateInput>>;
	courseAssessmentTimings?: InputMaybe<Array<CourseAssessmentTimingInCourseAssessmentCreateInput>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInCourseAssessmentCreateInput>>;
	name: Scalars["String"]["input"];
	totalPoints: Scalars["Int"]["input"];
};

export type CourseAssessmentEdge = {
	__typename?: "CourseAssessmentEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseAssessment;
};

export type CourseAssessmentFilterInput = {
	and?: InputMaybe<Array<CourseAssessmentFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentCategory?: InputMaybe<Array<CourseAssessmentCategoryFilterInput>>;
	courseAssessmentCategoryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentCategoryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentCategoryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentCategoryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentMarks?: InputMaybe<Array<CourseAssessmentMarkFilterInput>>;
	courseAssessmentSubmissions?: InputMaybe<Array<CourseAssessmentSubmissionFilterInput>>;
	courseAssessmentTimings?: InputMaybe<Array<CourseAssessmentTimingFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCourseAssessmentMarks?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCourseAssessmentSubmissions?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCourseAssessmentTimings?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMediaAttachments?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<CourseAssessmentFilterInput>;
	or?: InputMaybe<Array<CourseAssessmentFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	totalPointsEQ?: InputMaybe<Scalars["Int"]["input"]>;
	totalPointsGT?: InputMaybe<Scalars["Int"]["input"]>;
	totalPointsGTE?: InputMaybe<Scalars["Int"]["input"]>;
	totalPointsIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	totalPointsLT?: InputMaybe<Scalars["Int"]["input"]>;
	totalPointsLTE?: InputMaybe<Scalars["Int"]["input"]>;
	totalPointsNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	totalPointsNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type CourseAssessmentHistory = Node & {
	__typename?: "CourseAssessmentHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	courseAssessmentCategoryID: Maybe<Scalars["ID"]["output"]>;
	description: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	totalPoints: Maybe<Scalars["Int"]["output"]>;
};

export type CourseAssessmentHistoryConnection = {
	__typename?: "CourseAssessmentHistoryConnection";
	edges: Array<CourseAssessmentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseAssessmentHistoryEdge = {
	__typename?: "CourseAssessmentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseAssessmentHistory;
};

export type CourseAssessmentHistoryFilterInput = {
	and?: InputMaybe<Array<CourseAssessmentHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentCategoryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentCategoryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentCategoryIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseAssessmentCategoryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentCategoryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<CourseAssessmentHistoryFilterInput>;
	or?: InputMaybe<Array<CourseAssessmentHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	totalPointsEQ?: InputMaybe<Scalars["Int"]["input"]>;
	totalPointsGT?: InputMaybe<Scalars["Int"]["input"]>;
	totalPointsGTE?: InputMaybe<Scalars["Int"]["input"]>;
	totalPointsIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	totalPointsIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	totalPointsLT?: InputMaybe<Scalars["Int"]["input"]>;
	totalPointsLTE?: InputMaybe<Scalars["Int"]["input"]>;
	totalPointsNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	totalPointsNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type CourseAssessmentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseAssessmentHistoryOrderField>;
};

export enum CourseAssessmentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type CourseAssessmentInAuthorCreateInput = {
	courseAssessmentCategoryID: Scalars["ID"]["input"];
	courseAssessmentMarks?: InputMaybe<Array<CourseAssessmentMarkInCourseAssessmentCreateInput>>;
	courseAssessmentSubmissions?: InputMaybe<Array<CourseAssessmentSubmissionInCourseAssessmentCreateInput>>;
	courseAssessmentTimings?: InputMaybe<Array<CourseAssessmentTimingInCourseAssessmentCreateInput>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInCourseAssessmentCreateInput>>;
	name: Scalars["String"]["input"];
	totalPoints: Scalars["Int"]["input"];
};

export type CourseAssessmentInCourseAssessmentCategoryCreateInput = {
	courseAssessmentMarks?: InputMaybe<Array<CourseAssessmentMarkInCourseAssessmentCreateInput>>;
	courseAssessmentSubmissions?: InputMaybe<Array<CourseAssessmentSubmissionInCourseAssessmentCreateInput>>;
	courseAssessmentTimings?: InputMaybe<Array<CourseAssessmentTimingInCourseAssessmentCreateInput>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInCourseAssessmentCreateInput>>;
	name: Scalars["String"]["input"];
	totalPoints: Scalars["Int"]["input"];
};

export type CourseAssessmentMark = Node & {
	__typename?: "CourseAssessmentMark";
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	courseAssessment: CourseAssessment;
	courseAssessmentID: Scalars["ID"]["output"];
	id: Scalars["ID"]["output"];
	isExcused: Scalars["Boolean"]["output"];
	notes: Scalars["String"]["output"];
	points: Scalars["Int"]["output"];
	student: Student;
	studentID: Scalars["ID"]["output"];
	wasLate: Scalars["Boolean"]["output"];
};

export type CourseAssessmentMarkConnection = {
	__typename?: "CourseAssessmentMarkConnection";
	edges: Array<CourseAssessmentMarkEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseAssessmentMarkCreateInput = {
	courseAssessmentID: Scalars["ID"]["input"];
	isExcused?: InputMaybe<Scalars["Boolean"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	points: Scalars["Int"]["input"];
	studentID: Scalars["ID"]["input"];
	wasLate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CourseAssessmentMarkEdge = {
	__typename?: "CourseAssessmentMarkEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseAssessmentMark;
};

export type CourseAssessmentMarkFilterInput = {
	and?: InputMaybe<Array<CourseAssessmentMarkFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessment?: InputMaybe<Array<CourseAssessmentFilterInput>>;
	courseAssessmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isExcusedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isExcusedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<CourseAssessmentMarkFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<CourseAssessmentMarkFilterInput>>;
	pointsEQ?: InputMaybe<Scalars["Int"]["input"]>;
	pointsGT?: InputMaybe<Scalars["Int"]["input"]>;
	pointsGTE?: InputMaybe<Scalars["Int"]["input"]>;
	pointsIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	pointsLT?: InputMaybe<Scalars["Int"]["input"]>;
	pointsLTE?: InputMaybe<Scalars["Int"]["input"]>;
	pointsNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	pointsNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	wasLateEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	wasLateNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CourseAssessmentMarkHistory = Node & {
	__typename?: "CourseAssessmentMarkHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	courseAssessmentID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isExcused: Maybe<Scalars["Boolean"]["output"]>;
	notes: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	points: Maybe<Scalars["Int"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
	wasLate: Maybe<Scalars["Boolean"]["output"]>;
};

export type CourseAssessmentMarkHistoryConnection = {
	__typename?: "CourseAssessmentMarkHistoryConnection";
	edges: Array<CourseAssessmentMarkHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseAssessmentMarkHistoryEdge = {
	__typename?: "CourseAssessmentMarkHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseAssessmentMarkHistory;
};

export type CourseAssessmentMarkHistoryFilterInput = {
	and?: InputMaybe<Array<CourseAssessmentMarkHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseAssessmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isExcusedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isExcusedIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isExcusedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<CourseAssessmentMarkHistoryFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<CourseAssessmentMarkHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	pointsEQ?: InputMaybe<Scalars["Int"]["input"]>;
	pointsGT?: InputMaybe<Scalars["Int"]["input"]>;
	pointsGTE?: InputMaybe<Scalars["Int"]["input"]>;
	pointsIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	pointsIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	pointsLT?: InputMaybe<Scalars["Int"]["input"]>;
	pointsLTE?: InputMaybe<Scalars["Int"]["input"]>;
	pointsNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	pointsNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	wasLateEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	wasLateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	wasLateNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CourseAssessmentMarkHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseAssessmentMarkHistoryOrderField>;
};

export enum CourseAssessmentMarkHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type CourseAssessmentMarkInAuthorCreateInput = {
	courseAssessmentID: Scalars["ID"]["input"];
	isExcused?: InputMaybe<Scalars["Boolean"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	points: Scalars["Int"]["input"];
	studentID: Scalars["ID"]["input"];
	wasLate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CourseAssessmentMarkInCourseAssessmentCreateInput = {
	isExcused?: InputMaybe<Scalars["Boolean"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	points: Scalars["Int"]["input"];
	studentID: Scalars["ID"]["input"];
	wasLate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CourseAssessmentMarkInStudentCreateInput = {
	courseAssessmentID: Scalars["ID"]["input"];
	isExcused?: InputMaybe<Scalars["Boolean"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	points: Scalars["Int"]["input"];
	wasLate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CourseAssessmentMarkOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseAssessmentMarkOrderField>;
};

export enum CourseAssessmentMarkOrderField {
	IsExcused = "IS_EXCUSED",
	Points = "POINTS",
	WasLate = "WAS_LATE",
}

export type CourseAssessmentMarkUpdateBulkInput = {
	isExcused?: InputMaybe<Scalars["Boolean"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	points?: InputMaybe<Scalars["Int"]["input"]>;
	wasLate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CourseAssessmentMarkUpdateInput = {
	isExcused?: InputMaybe<Scalars["Boolean"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	points?: InputMaybe<Scalars["Int"]["input"]>;
	wasLate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CourseAssessmentOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseAssessmentOrderField>;
};

export enum CourseAssessmentOrderField {
	Name = "NAME",
	TotalPoints = "TOTAL_POINTS",
}

export type CourseAssessmentSubmission = Node & {
	__typename?: "CourseAssessmentSubmission";
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Scalars["String"]["output"];
	courseAssessment: CourseAssessment;
	courseAssessmentID: Scalars["ID"]["output"];
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	mediaAttachments: Array<MediaAttachment>;
	student: Student;
	studentID: Scalars["ID"]["output"];
	submissionDate: Scalars["Date"]["output"];
};

export type CourseAssessmentSubmissionMediaAttachmentsArgs = {
	filters?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	order?: InputMaybe<MediaAttachmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CourseAssessmentSubmissionConnection = {
	__typename?: "CourseAssessmentSubmissionConnection";
	edges: Array<CourseAssessmentSubmissionEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseAssessmentSubmissionCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	courseAssessmentID: Scalars["ID"]["input"];
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInCourseAssessmentSubmissionCreateInput>>;
	studentID: Scalars["ID"]["input"];
	submissionDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type CourseAssessmentSubmissionEdge = {
	__typename?: "CourseAssessmentSubmissionEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseAssessmentSubmission;
};

export type CourseAssessmentSubmissionFilterInput = {
	and?: InputMaybe<Array<CourseAssessmentSubmissionFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	courseAssessment?: InputMaybe<Array<CourseAssessmentFilterInput>>;
	courseAssessmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMediaAttachments?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	not?: InputMaybe<CourseAssessmentSubmissionFilterInput>;
	or?: InputMaybe<Array<CourseAssessmentSubmissionFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	submissionDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	submissionDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	submissionDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	submissionDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	submissionDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	submissionDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	submissionDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	submissionDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
};

export type CourseAssessmentSubmissionHistory = Node & {
	__typename?: "CourseAssessmentSubmissionHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Maybe<Scalars["String"]["output"]>;
	courseAssessmentID: Maybe<Scalars["ID"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
	submissionDate: Maybe<Scalars["Date"]["output"]>;
};

export type CourseAssessmentSubmissionHistoryConnection = {
	__typename?: "CourseAssessmentSubmissionHistoryConnection";
	edges: Array<CourseAssessmentSubmissionHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseAssessmentSubmissionHistoryEdge = {
	__typename?: "CourseAssessmentSubmissionHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseAssessmentSubmissionHistory;
};

export type CourseAssessmentSubmissionHistoryFilterInput = {
	and?: InputMaybe<Array<CourseAssessmentSubmissionHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	courseAssessmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseAssessmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<CourseAssessmentSubmissionHistoryFilterInput>;
	or?: InputMaybe<Array<CourseAssessmentSubmissionHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	submissionDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	submissionDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	submissionDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	submissionDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	submissionDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	submissionDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	submissionDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	submissionDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	submissionDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
};

export type CourseAssessmentSubmissionHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseAssessmentSubmissionHistoryOrderField>;
};

export enum CourseAssessmentSubmissionHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type CourseAssessmentSubmissionInAuthorCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	courseAssessmentID: Scalars["ID"]["input"];
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInCourseAssessmentSubmissionCreateInput>>;
	studentID: Scalars["ID"]["input"];
	submissionDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type CourseAssessmentSubmissionInCourseAssessmentCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInCourseAssessmentSubmissionCreateInput>>;
	studentID: Scalars["ID"]["input"];
	submissionDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type CourseAssessmentSubmissionInStudentCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	courseAssessmentID: Scalars["ID"]["input"];
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInCourseAssessmentSubmissionCreateInput>>;
	submissionDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type CourseAssessmentSubmissionOrder = {
	direction: OrderDirection;
};

export type CourseAssessmentSubmissionUpdateBulkInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	submissionDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type CourseAssessmentSubmissionUpdateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	submissionDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type CourseAssessmentTiming = Node & {
	__typename?: "CourseAssessmentTiming";
	assignOn: Maybe<Scalars["Date"]["output"]>;
	courseAssessment: CourseAssessment;
	courseAssessmentID: Scalars["ID"]["output"];
	courseSection: CourseSection;
	courseSectionID: Scalars["ID"]["output"];
	dueOn: Maybe<Scalars["Date"]["output"]>;
	id: Scalars["ID"]["output"];
};

export type CourseAssessmentTimingConnection = {
	__typename?: "CourseAssessmentTimingConnection";
	edges: Array<CourseAssessmentTimingEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseAssessmentTimingCreateInput = {
	assignOn?: InputMaybe<Scalars["Date"]["input"]>;
	courseAssessmentID: Scalars["ID"]["input"];
	courseSectionID: Scalars["ID"]["input"];
	dueOn?: InputMaybe<Scalars["Date"]["input"]>;
};

export type CourseAssessmentTimingEdge = {
	__typename?: "CourseAssessmentTimingEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseAssessmentTiming;
};

export type CourseAssessmentTimingFilterInput = {
	and?: InputMaybe<Array<CourseAssessmentTimingFilterInput>>;
	assignOnEQ?: InputMaybe<Scalars["Date"]["input"]>;
	assignOnGT?: InputMaybe<Scalars["Date"]["input"]>;
	assignOnGTE?: InputMaybe<Scalars["Date"]["input"]>;
	assignOnIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	assignOnIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	assignOnLT?: InputMaybe<Scalars["Date"]["input"]>;
	assignOnLTE?: InputMaybe<Scalars["Date"]["input"]>;
	assignOnNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	assignOnNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	courseAssessment?: InputMaybe<Array<CourseAssessmentFilterInput>>;
	courseAssessmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSection?: InputMaybe<Array<CourseSectionFilterInput>>;
	courseSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	dueOnEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dueOnGT?: InputMaybe<Scalars["Date"]["input"]>;
	dueOnGTE?: InputMaybe<Scalars["Date"]["input"]>;
	dueOnIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dueOnIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dueOnLT?: InputMaybe<Scalars["Date"]["input"]>;
	dueOnLTE?: InputMaybe<Scalars["Date"]["input"]>;
	dueOnNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dueOnNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<CourseAssessmentTimingFilterInput>;
	or?: InputMaybe<Array<CourseAssessmentTimingFilterInput>>;
};

export type CourseAssessmentTimingHistory = Node & {
	__typename?: "CourseAssessmentTimingHistory";
	assignOn: Maybe<Scalars["Date"]["output"]>;
	courseAssessmentID: Maybe<Scalars["ID"]["output"]>;
	courseSectionID: Maybe<Scalars["ID"]["output"]>;
	dueOn: Maybe<Scalars["Date"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type CourseAssessmentTimingHistoryConnection = {
	__typename?: "CourseAssessmentTimingHistoryConnection";
	edges: Array<CourseAssessmentTimingHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseAssessmentTimingHistoryEdge = {
	__typename?: "CourseAssessmentTimingHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseAssessmentTimingHistory;
};

export type CourseAssessmentTimingHistoryFilterInput = {
	and?: InputMaybe<Array<CourseAssessmentTimingHistoryFilterInput>>;
	assignOnEQ?: InputMaybe<Scalars["Date"]["input"]>;
	assignOnGT?: InputMaybe<Scalars["Date"]["input"]>;
	assignOnGTE?: InputMaybe<Scalars["Date"]["input"]>;
	assignOnIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	assignOnIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	assignOnLT?: InputMaybe<Scalars["Date"]["input"]>;
	assignOnLTE?: InputMaybe<Scalars["Date"]["input"]>;
	assignOnNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	assignOnNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	courseAssessmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseAssessmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	dueOnEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dueOnGT?: InputMaybe<Scalars["Date"]["input"]>;
	dueOnGTE?: InputMaybe<Scalars["Date"]["input"]>;
	dueOnIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dueOnIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dueOnLT?: InputMaybe<Scalars["Date"]["input"]>;
	dueOnLTE?: InputMaybe<Scalars["Date"]["input"]>;
	dueOnNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dueOnNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<CourseAssessmentTimingHistoryFilterInput>;
	or?: InputMaybe<Array<CourseAssessmentTimingHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CourseAssessmentTimingHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseAssessmentTimingHistoryOrderField>;
};

export enum CourseAssessmentTimingHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type CourseAssessmentTimingInCourseAssessmentCreateInput = {
	assignOn?: InputMaybe<Scalars["Date"]["input"]>;
	courseSectionID: Scalars["ID"]["input"];
	dueOn?: InputMaybe<Scalars["Date"]["input"]>;
};

export type CourseAssessmentTimingInCourseSectionCreateInput = {
	assignOn?: InputMaybe<Scalars["Date"]["input"]>;
	courseAssessmentID: Scalars["ID"]["input"];
	dueOn?: InputMaybe<Scalars["Date"]["input"]>;
};

export type CourseAssessmentTimingOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseAssessmentTimingOrderField>;
};

export enum CourseAssessmentTimingOrderField {
	AssignOn = "ASSIGN_ON",
	DueOn = "DUE_ON",
}

export type CourseAssessmentTimingUpdateBulkInput = {
	assignOn?: InputMaybe<Scalars["Date"]["input"]>;
	clearAssignOn?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearDueOn?: InputMaybe<Scalars["Boolean"]["input"]>;
	dueOn?: InputMaybe<Scalars["Date"]["input"]>;
};

export type CourseAssessmentTimingUpdateInput = {
	assignOn?: InputMaybe<Scalars["Date"]["input"]>;
	clearAssignOn?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearDueOn?: InputMaybe<Scalars["Boolean"]["input"]>;
	dueOn?: InputMaybe<Scalars["Date"]["input"]>;
};

export type CourseAssessmentUpdateBulkInput = {
	courseAssessmentCategoryID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	totalPoints?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CourseAssessmentUpdateInput = {
	courseAssessmentCategoryID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	totalPoints?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CourseAttendanceRecord = Node & {
	__typename?: "CourseAttendanceRecord";
	attendanceDate: Scalars["Date"]["output"];
	attendanceStatus: AttendanceStatus;
	attendanceStatusID: Scalars["ID"]["output"];
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	courseSectionPeriod: CourseSectionPeriod;
	courseSectionPeriodID: Scalars["ID"]["output"];
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	notes: Scalars["String"]["output"];
	student: Student;
	studentID: Scalars["ID"]["output"];
};

export type CourseAttendanceRecordConnection = {
	__typename?: "CourseAttendanceRecordConnection";
	edges: Array<CourseAttendanceRecordEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseAttendanceRecordCreateInput = {
	attendanceDate: Scalars["Date"]["input"];
	attendanceStatusID: Scalars["ID"]["input"];
	courseSectionPeriodID: Scalars["ID"]["input"];
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type CourseAttendanceRecordEdge = {
	__typename?: "CourseAttendanceRecordEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseAttendanceRecord;
};

export type CourseAttendanceRecordFilterInput = {
	and?: InputMaybe<Array<CourseAttendanceRecordFilterInput>>;
	attendanceDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	attendanceDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	attendanceStatus?: InputMaybe<Array<AttendanceStatusFilterInput>>;
	attendanceStatusIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	attendanceStatusIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	attendanceStatusIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	attendanceStatusIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionPeriod?: InputMaybe<Array<CourseSectionPeriodFilterInput>>;
	courseSectionPeriodIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionPeriodIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionPeriodIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionPeriodIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<CourseAttendanceRecordFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<CourseAttendanceRecordFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CourseAttendanceRecordHistory = Node & {
	__typename?: "CourseAttendanceRecordHistory";
	attendanceDate: Maybe<Scalars["Date"]["output"]>;
	attendanceStatusID: Maybe<Scalars["ID"]["output"]>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	courseSectionPeriodID: Maybe<Scalars["ID"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	notes: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
};

export type CourseAttendanceRecordHistoryConnection = {
	__typename?: "CourseAttendanceRecordHistoryConnection";
	edges: Array<CourseAttendanceRecordHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseAttendanceRecordHistoryEdge = {
	__typename?: "CourseAttendanceRecordHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseAttendanceRecordHistory;
};

export type CourseAttendanceRecordHistoryFilterInput = {
	and?: InputMaybe<Array<CourseAttendanceRecordHistoryFilterInput>>;
	attendanceDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	attendanceDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	attendanceDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	attendanceStatusIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	attendanceStatusIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	attendanceStatusIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	attendanceStatusIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	attendanceStatusIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionPeriodIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionPeriodIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionPeriodIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseSectionPeriodIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionPeriodIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<CourseAttendanceRecordHistoryFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<CourseAttendanceRecordHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CourseAttendanceRecordHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseAttendanceRecordHistoryOrderField>;
};

export enum CourseAttendanceRecordHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type CourseAttendanceRecordInAttendanceStatusCreateInput = {
	attendanceDate: Scalars["Date"]["input"];
	courseSectionPeriodID: Scalars["ID"]["input"];
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type CourseAttendanceRecordInAuthorCreateInput = {
	attendanceDate: Scalars["Date"]["input"];
	attendanceStatusID: Scalars["ID"]["input"];
	courseSectionPeriodID: Scalars["ID"]["input"];
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type CourseAttendanceRecordInCourseSectionPeriodCreateInput = {
	attendanceDate: Scalars["Date"]["input"];
	attendanceStatusID: Scalars["ID"]["input"];
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type CourseAttendanceRecordInStudentCreateInput = {
	attendanceDate: Scalars["Date"]["input"];
	attendanceStatusID: Scalars["ID"]["input"];
	courseSectionPeriodID: Scalars["ID"]["input"];
	notes?: InputMaybe<Scalars["String"]["input"]>;
};

export type CourseAttendanceRecordOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseAttendanceRecordOrderField>;
};

export enum CourseAttendanceRecordOrderField {
	AttendanceDate = "ATTENDANCE_DATE",
	CreatedAt = "CREATED_AT",
}

export type CourseAttendanceRecordUpdateBulkInput = {
	attendanceDate?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceStatusID?: InputMaybe<Scalars["ID"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
};

export type CourseAttendanceRecordUpdateInput = {
	attendanceDate?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceStatusID?: InputMaybe<Scalars["ID"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
};

export type CourseConnection = {
	__typename?: "CourseConnection";
	edges: Array<CourseEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseCreateInput = {
	academicSubjectID: Scalars["ID"]["input"];
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSections?: InputMaybe<Array<CourseSectionInCourseCreateInput>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	name: Scalars["String"]["input"];
};

export type CourseEdge = {
	__typename?: "CourseEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Course;
};

export type CourseFilterInput = {
	academicSubject?: InputMaybe<Array<AcademicSubjectFilterInput>>;
	academicSubjectIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicSubjectIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	academicSubjectIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicSubjectIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	and?: InputMaybe<Array<CourseFilterInput>>;
	classYears?: InputMaybe<Array<ClassYearFilterInput>>;
	courseSections?: InputMaybe<Array<CourseSectionFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasClassYears?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCourseSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<CourseFilterInput>;
	or?: InputMaybe<Array<CourseFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type CourseHistory = Node & {
	__typename?: "CourseHistory";
	academicSubjectID: Maybe<Scalars["ID"]["output"]>;
	description: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type CourseHistoryConnection = {
	__typename?: "CourseHistoryConnection";
	edges: Array<CourseHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseHistoryEdge = {
	__typename?: "CourseHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseHistory;
};

export type CourseHistoryFilterInput = {
	academicSubjectIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicSubjectIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	academicSubjectIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	academicSubjectIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicSubjectIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	and?: InputMaybe<Array<CourseHistoryFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<CourseHistoryFilterInput>;
	or?: InputMaybe<Array<CourseHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type CourseHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseHistoryOrderField>;
};

export enum CourseHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type CourseInAcademicSubjectCreateInput = {
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSections?: InputMaybe<Array<CourseSectionInCourseCreateInput>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	name: Scalars["String"]["input"];
};

export type CourseOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseOrderField>;
};

export enum CourseOrderField {
	Name = "NAME",
}

export type CourseSection = Node & {
	__typename?: "CourseSection";
	academicTerm: AcademicTerm;
	academicTermID: Scalars["ID"]["output"];
	course: Course;
	courseAssessmentCategoryMarkPortions: Array<CourseAssessmentCategoryMarkPortion>;
	courseAssessmentTimings: Array<CourseAssessmentTiming>;
	courseID: Scalars["ID"]["output"];
	courseSectionPeriods: Array<CourseSectionPeriod>;
	homeRoomSection: Maybe<HomeRoomSection>;
	homeRoomSectionID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	namePrefix: Scalars["String"]["output"];
	nameSuffix: Scalars["String"]["output"];
	reportCardSectionPolicies: Array<ReportCardSectionPolicy>;
	sharingRecords: Array<SharingRecord>;
	studentCourseSectionEnrollments: Array<StudentCourseSectionEnrollment>;
	teacherCourseSectionEnrollments: Array<TeacherCourseSectionEnrollment>;
	userGroups: Array<UserGroup>;
};

export type CourseSectionCourseAssessmentCategoryMarkPortionsArgs = {
	filters?: InputMaybe<Array<CourseAssessmentCategoryMarkPortionFilterInput>>;
	order?: InputMaybe<CourseAssessmentCategoryMarkPortionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CourseSectionCourseAssessmentTimingsArgs = {
	filters?: InputMaybe<Array<CourseAssessmentTimingFilterInput>>;
	order?: InputMaybe<CourseAssessmentTimingOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CourseSectionCourseSectionPeriodsArgs = {
	filters?: InputMaybe<Array<CourseSectionPeriodFilterInput>>;
	order?: InputMaybe<CourseSectionPeriodOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CourseSectionReportCardSectionPoliciesArgs = {
	filters?: InputMaybe<Array<ReportCardSectionPolicyFilterInput>>;
	order?: InputMaybe<ReportCardSectionPolicyOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CourseSectionSharingRecordsArgs = {
	filters?: InputMaybe<Array<SharingRecordFilterInput>>;
	order?: InputMaybe<SharingRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CourseSectionStudentCourseSectionEnrollmentsArgs = {
	filters?: InputMaybe<Array<StudentCourseSectionEnrollmentFilterInput>>;
	order?: InputMaybe<StudentCourseSectionEnrollmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CourseSectionTeacherCourseSectionEnrollmentsArgs = {
	filters?: InputMaybe<Array<TeacherCourseSectionEnrollmentFilterInput>>;
	order?: InputMaybe<TeacherCourseSectionEnrollmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CourseSectionUserGroupsArgs = {
	filters?: InputMaybe<Array<UserGroupFilterInput>>;
	order?: InputMaybe<UserGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CourseSectionAttendanceRecordCountStatistics = {
	__typename?: "CourseSectionAttendanceRecordCountStatistics";
	attendanceRecordCountStatistics: AttendanceRecordCountStatistics;
	courseSection: CourseSectionInAttendanceRecordStatistics;
};

export type CourseSectionConnection = {
	__typename?: "CourseSectionConnection";
	edges: Array<CourseSectionEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseSectionCreateInput = {
	academicTermID: Scalars["ID"]["input"];
	courseAssessmentCategoryMarkPortions?: InputMaybe<
		Array<CourseAssessmentCategoryMarkPortionInCourseSectionCreateInput>
	>;
	courseAssessmentTimings?: InputMaybe<Array<CourseAssessmentTimingInCourseSectionCreateInput>>;
	courseID: Scalars["ID"]["input"];
	courseSectionPeriods?: InputMaybe<Array<CourseSectionPeriodInCourseSectionCreateInput>>;
	homeRoomSectionID?: InputMaybe<Scalars["ID"]["input"]>;
	namePrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffix?: InputMaybe<Scalars["String"]["input"]>;
	reportCardSectionPolicies?: InputMaybe<Array<ReportCardSectionPolicyInCourseSectionCreateInput>>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentCourseSectionEnrollments?: InputMaybe<Array<StudentCourseSectionEnrollmentInCourseSectionCreateInput>>;
	teacherCourseSectionEnrollments?: InputMaybe<Array<TeacherCourseSectionEnrollmentInCourseSectionCreateInput>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CourseSectionEdge = {
	__typename?: "CourseSectionEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseSection;
};

export type CourseSectionFilterInput = {
	academicTerm?: InputMaybe<Array<AcademicTermFilterInput>>;
	academicTermIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicTermIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	academicTermIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicTermIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	and?: InputMaybe<Array<CourseSectionFilterInput>>;
	course?: InputMaybe<Array<CourseFilterInput>>;
	courseAssessmentCategoryMarkPortions?: InputMaybe<Array<CourseAssessmentCategoryMarkPortionFilterInput>>;
	courseAssessmentTimings?: InputMaybe<Array<CourseAssessmentTimingFilterInput>>;
	courseIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionPeriods?: InputMaybe<Array<CourseSectionPeriodFilterInput>>;
	hasCourseAssessmentCategoryMarkPortions?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCourseAssessmentTimings?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCourseSectionPeriods?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasHomeRoomSection?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasReportCardSectionPolicies?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentCourseSectionEnrollments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasTeacherCourseSectionEnrollments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoomSection?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
	homeRoomSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoomSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	namePrefixContains?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixEQ?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	namePrefixNEQ?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixNotContains?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameSuffixContains?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameSuffixNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<CourseSectionFilterInput>;
	or?: InputMaybe<Array<CourseSectionFilterInput>>;
	reportCardSectionPolicies?: InputMaybe<Array<ReportCardSectionPolicyFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	sharingRecords?: InputMaybe<Array<SharingRecordFilterInput>>;
	studentCourseSectionEnrollments?: InputMaybe<Array<StudentCourseSectionEnrollmentFilterInput>>;
	teacherCourseSectionEnrollments?: InputMaybe<Array<TeacherCourseSectionEnrollmentFilterInput>>;
	userGroups?: InputMaybe<Array<UserGroupFilterInput>>;
};

export type CourseSectionHistory = Node & {
	__typename?: "CourseSectionHistory";
	academicTermID: Maybe<Scalars["ID"]["output"]>;
	courseID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	homeRoomSectionID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	namePrefix: Maybe<Scalars["String"]["output"]>;
	nameSuffix: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type CourseSectionHistoryConnection = {
	__typename?: "CourseSectionHistoryConnection";
	edges: Array<CourseSectionHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseSectionHistoryEdge = {
	__typename?: "CourseSectionHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseSectionHistory;
};

export type CourseSectionHistoryFilterInput = {
	academicTermIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicTermIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	academicTermIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	academicTermIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicTermIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	and?: InputMaybe<Array<CourseSectionHistoryFilterInput>>;
	courseIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoomSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	namePrefixContains?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixEQ?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	namePrefixIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	namePrefixNEQ?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixNotContains?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameSuffixContains?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameSuffixIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameSuffixNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<CourseSectionHistoryFilterInput>;
	or?: InputMaybe<Array<CourseSectionHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type CourseSectionHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseSectionHistoryOrderField>;
};

export enum CourseSectionHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type CourseSectionInAcademicTermCreateInput = {
	courseAssessmentCategoryMarkPortions?: InputMaybe<
		Array<CourseAssessmentCategoryMarkPortionInCourseSectionCreateInput>
	>;
	courseAssessmentTimings?: InputMaybe<Array<CourseAssessmentTimingInCourseSectionCreateInput>>;
	courseID: Scalars["ID"]["input"];
	courseSectionPeriods?: InputMaybe<Array<CourseSectionPeriodInCourseSectionCreateInput>>;
	homeRoomSectionID?: InputMaybe<Scalars["ID"]["input"]>;
	namePrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffix?: InputMaybe<Scalars["String"]["input"]>;
	reportCardSectionPolicies?: InputMaybe<Array<ReportCardSectionPolicyInCourseSectionCreateInput>>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentCourseSectionEnrollments?: InputMaybe<Array<StudentCourseSectionEnrollmentInCourseSectionCreateInput>>;
	teacherCourseSectionEnrollments?: InputMaybe<Array<TeacherCourseSectionEnrollmentInCourseSectionCreateInput>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CourseSectionInAttendanceRecordStatistics = {
	__typename?: "CourseSectionInAttendanceRecordStatistics";
	classYears: Array<ClassYearInAttendanceRecordStatistics>;
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
};

export type CourseSectionInCourseCreateInput = {
	academicTermID: Scalars["ID"]["input"];
	courseAssessmentCategoryMarkPortions?: InputMaybe<
		Array<CourseAssessmentCategoryMarkPortionInCourseSectionCreateInput>
	>;
	courseAssessmentTimings?: InputMaybe<Array<CourseAssessmentTimingInCourseSectionCreateInput>>;
	courseSectionPeriods?: InputMaybe<Array<CourseSectionPeriodInCourseSectionCreateInput>>;
	homeRoomSectionID?: InputMaybe<Scalars["ID"]["input"]>;
	namePrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffix?: InputMaybe<Scalars["String"]["input"]>;
	reportCardSectionPolicies?: InputMaybe<Array<ReportCardSectionPolicyInCourseSectionCreateInput>>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentCourseSectionEnrollments?: InputMaybe<Array<StudentCourseSectionEnrollmentInCourseSectionCreateInput>>;
	teacherCourseSectionEnrollments?: InputMaybe<Array<TeacherCourseSectionEnrollmentInCourseSectionCreateInput>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CourseSectionInHomeRoomSectionCreateInput = {
	academicTermID: Scalars["ID"]["input"];
	courseAssessmentCategoryMarkPortions?: InputMaybe<
		Array<CourseAssessmentCategoryMarkPortionInCourseSectionCreateInput>
	>;
	courseAssessmentTimings?: InputMaybe<Array<CourseAssessmentTimingInCourseSectionCreateInput>>;
	courseID: Scalars["ID"]["input"];
	courseSectionPeriods?: InputMaybe<Array<CourseSectionPeriodInCourseSectionCreateInput>>;
	namePrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffix?: InputMaybe<Scalars["String"]["input"]>;
	reportCardSectionPolicies?: InputMaybe<Array<ReportCardSectionPolicyInCourseSectionCreateInput>>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentCourseSectionEnrollments?: InputMaybe<Array<StudentCourseSectionEnrollmentInCourseSectionCreateInput>>;
	teacherCourseSectionEnrollments?: InputMaybe<Array<TeacherCourseSectionEnrollmentInCourseSectionCreateInput>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CourseSectionOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseSectionOrderField>;
};

export enum CourseSectionOrderField {
	NamePrefix = "NAME_PREFIX",
	NameSuffix = "NAME_SUFFIX",
}

export type CourseSectionPeriod = Node & {
	__typename?: "CourseSectionPeriod";
	courseAttendanceRecords: Array<CourseAttendanceRecord>;
	courseSection: CourseSection;
	courseSectionID: Scalars["ID"]["output"];
	dayOfWeek: Scalars["Int"]["output"];
	endTimeMinutes: Scalars["Int"]["output"];
	id: Scalars["ID"]["output"];
	isActive: Scalars["Boolean"]["output"];
	room: Maybe<Room>;
	roomID: Maybe<Scalars["ID"]["output"]>;
	startTimeMinutes: Scalars["Int"]["output"];
};

export type CourseSectionPeriodCourseAttendanceRecordsArgs = {
	filters?: InputMaybe<Array<CourseAttendanceRecordFilterInput>>;
	order?: InputMaybe<CourseAttendanceRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CourseSectionPeriodConnection = {
	__typename?: "CourseSectionPeriodConnection";
	edges: Array<CourseSectionPeriodEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseSectionPeriodCreateInput = {
	courseAttendanceRecords?: InputMaybe<Array<CourseAttendanceRecordInCourseSectionPeriodCreateInput>>;
	courseSectionID: Scalars["ID"]["input"];
	dayOfWeek: Scalars["Int"]["input"];
	endTimeMinutes: Scalars["Int"]["input"];
	roomID?: InputMaybe<Scalars["ID"]["input"]>;
	startTimeMinutes: Scalars["Int"]["input"];
};

export type CourseSectionPeriodEdge = {
	__typename?: "CourseSectionPeriodEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseSectionPeriod;
};

export type CourseSectionPeriodFilterInput = {
	and?: InputMaybe<Array<CourseSectionPeriodFilterInput>>;
	courseAttendanceRecords?: InputMaybe<Array<CourseAttendanceRecordFilterInput>>;
	courseSection?: InputMaybe<Array<CourseSectionFilterInput>>;
	courseSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	dayOfWeekEQ?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekGT?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekGTE?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	dayOfWeekLT?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekLTE?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	endTimeMinutesEQ?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesGT?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesGTE?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	endTimeMinutesLT?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesLTE?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	hasCourseAttendanceRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasRoom?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isActiveEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActiveNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<CourseSectionPeriodFilterInput>;
	or?: InputMaybe<Array<CourseSectionPeriodFilterInput>>;
	room?: InputMaybe<Array<RoomFilterInput>>;
	roomIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	roomIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	roomIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	roomIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	roomIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	startTimeMinutesEQ?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesGT?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesGTE?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	startTimeMinutesLT?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesLTE?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type CourseSectionPeriodHistory = Node & {
	__typename?: "CourseSectionPeriodHistory";
	courseSectionID: Maybe<Scalars["ID"]["output"]>;
	dayOfWeek: Maybe<Scalars["Int"]["output"]>;
	endTimeMinutes: Maybe<Scalars["Int"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isActive: Maybe<Scalars["Boolean"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	roomID: Maybe<Scalars["ID"]["output"]>;
	startTimeMinutes: Maybe<Scalars["Int"]["output"]>;
};

export type CourseSectionPeriodHistoryConnection = {
	__typename?: "CourseSectionPeriodHistoryConnection";
	edges: Array<CourseSectionPeriodHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CourseSectionPeriodHistoryEdge = {
	__typename?: "CourseSectionPeriodHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CourseSectionPeriodHistory;
};

export type CourseSectionPeriodHistoryFilterInput = {
	and?: InputMaybe<Array<CourseSectionPeriodHistoryFilterInput>>;
	courseSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	dayOfWeekEQ?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekGT?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekGTE?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	dayOfWeekIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dayOfWeekLT?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekLTE?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	endTimeMinutesEQ?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesGT?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesGTE?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	endTimeMinutesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	endTimeMinutesLT?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesLTE?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isActiveEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActiveIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActiveNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<CourseSectionPeriodHistoryFilterInput>;
	or?: InputMaybe<Array<CourseSectionPeriodHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	roomIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	roomIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	roomIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	roomIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	roomIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	startTimeMinutesEQ?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesGT?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesGTE?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	startTimeMinutesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	startTimeMinutesLT?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesLTE?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type CourseSectionPeriodHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseSectionPeriodHistoryOrderField>;
};

export enum CourseSectionPeriodHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type CourseSectionPeriodInCourseSectionCreateInput = {
	courseAttendanceRecords?: InputMaybe<Array<CourseAttendanceRecordInCourseSectionPeriodCreateInput>>;
	dayOfWeek: Scalars["Int"]["input"];
	endTimeMinutes: Scalars["Int"]["input"];
	roomID?: InputMaybe<Scalars["ID"]["input"]>;
	startTimeMinutes: Scalars["Int"]["input"];
};

export type CourseSectionPeriodInRoomCreateInput = {
	courseAttendanceRecords?: InputMaybe<Array<CourseAttendanceRecordInCourseSectionPeriodCreateInput>>;
	courseSectionID: Scalars["ID"]["input"];
	dayOfWeek: Scalars["Int"]["input"];
	endTimeMinutes: Scalars["Int"]["input"];
	startTimeMinutes: Scalars["Int"]["input"];
};

export type CourseSectionPeriodOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CourseSectionPeriodOrderField>;
};

export enum CourseSectionPeriodOrderField {
	DayOfWeek = "DAY_OF_WEEK",
	EndTimeMinutes = "END_TIME_MINUTES",
	IsActive = "IS_ACTIVE",
	StartTimeMinutes = "START_TIME_MINUTES",
}

export type CourseSectionPeriodUpdateBulkInput = {
	clearRoom?: InputMaybe<Scalars["Boolean"]["input"]>;
	dayOfWeek?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutes?: InputMaybe<Scalars["Int"]["input"]>;
	isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
	roomID?: InputMaybe<Scalars["ID"]["input"]>;
	startTimeMinutes?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CourseSectionPeriodUpdateInput = {
	clearRoom?: InputMaybe<Scalars["Boolean"]["input"]>;
	dayOfWeek?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutes?: InputMaybe<Scalars["Int"]["input"]>;
	isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
	roomID?: InputMaybe<Scalars["ID"]["input"]>;
	startTimeMinutes?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CourseSectionUpdateBulkInput = {
	addSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearHomeRoomSection?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoomSectionID?: InputMaybe<Scalars["ID"]["input"]>;
	namePrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffix?: InputMaybe<Scalars["String"]["input"]>;
	removeSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CourseSectionUpdateInput = {
	addSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearHomeRoomSection?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoomSectionID?: InputMaybe<Scalars["ID"]["input"]>;
	namePrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffix?: InputMaybe<Scalars["String"]["input"]>;
	removeSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CourseUpdateBulkInput = {
	academicSubjectID?: InputMaybe<Scalars["ID"]["input"]>;
	addClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearClassYears?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CourseUpdateInput = {
	academicSubjectID?: InputMaybe<Scalars["ID"]["input"]>;
	addClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearClassYears?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type DeleteBulkResponse = {
	__typename?: "DeleteBulkResponse";
	ids: Array<Scalars["Int"]["output"]>;
	totalCount: Scalars["Int"]["output"];
};

export type Discount = Node & {
	__typename?: "Discount";
	contractLineItems: Array<ContractLineItem>;
	description: Scalars["String"]["output"];
	flatAmount: Maybe<Scalars["Int"]["output"]>;
	id: Scalars["ID"]["output"];
	isActive: Scalars["Boolean"]["output"];
	isPercentageAmount: Scalars["Boolean"]["output"];
	name: Scalars["String"]["output"];
	percentageAmount: Maybe<Scalars["Float"]["output"]>;
};

export type DiscountContractLineItemsArgs = {
	filters?: InputMaybe<Array<ContractLineItemFilterInput>>;
	order?: InputMaybe<ContractLineItemOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type DiscountConnection = {
	__typename?: "DiscountConnection";
	edges: Array<DiscountEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type DiscountCreateInput = {
	contractLineItems?: InputMaybe<Array<ContractLineItemInDiscountCreateInput>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	flatAmount?: InputMaybe<Scalars["Int"]["input"]>;
	name: Scalars["String"]["input"];
	percentageAmount?: InputMaybe<Scalars["Float"]["input"]>;
};

export type DiscountEdge = {
	__typename?: "DiscountEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Discount;
};

export type DiscountFilterInput = {
	and?: InputMaybe<Array<DiscountFilterInput>>;
	contractLineItems?: InputMaybe<Array<ContractLineItemFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	flatAmountEQ?: InputMaybe<Scalars["Int"]["input"]>;
	flatAmountGT?: InputMaybe<Scalars["Int"]["input"]>;
	flatAmountGTE?: InputMaybe<Scalars["Int"]["input"]>;
	flatAmountIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	flatAmountIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	flatAmountLT?: InputMaybe<Scalars["Int"]["input"]>;
	flatAmountLTE?: InputMaybe<Scalars["Int"]["input"]>;
	flatAmountNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	flatAmountNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	hasContractLineItems?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isActiveEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActiveNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<DiscountFilterInput>;
	or?: InputMaybe<Array<DiscountFilterInput>>;
	percentageAmountEQ?: InputMaybe<Scalars["Float"]["input"]>;
	percentageAmountGT?: InputMaybe<Scalars["Float"]["input"]>;
	percentageAmountGTE?: InputMaybe<Scalars["Float"]["input"]>;
	percentageAmountIn?: InputMaybe<Array<Scalars["Float"]["input"]>>;
	percentageAmountIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	percentageAmountLT?: InputMaybe<Scalars["Float"]["input"]>;
	percentageAmountLTE?: InputMaybe<Scalars["Float"]["input"]>;
	percentageAmountNEQ?: InputMaybe<Scalars["Float"]["input"]>;
	percentageAmountNotIn?: InputMaybe<Array<Scalars["Float"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type DiscountHistory = Node & {
	__typename?: "DiscountHistory";
	description: Maybe<Scalars["String"]["output"]>;
	flatAmount: Maybe<Scalars["Int"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isActive: Maybe<Scalars["Boolean"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	percentageAmount: Maybe<Scalars["Float"]["output"]>;
};

export type DiscountHistoryConnection = {
	__typename?: "DiscountHistoryConnection";
	edges: Array<DiscountHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type DiscountHistoryEdge = {
	__typename?: "DiscountHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: DiscountHistory;
};

export type DiscountHistoryFilterInput = {
	and?: InputMaybe<Array<DiscountHistoryFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	flatAmountEQ?: InputMaybe<Scalars["Int"]["input"]>;
	flatAmountGT?: InputMaybe<Scalars["Int"]["input"]>;
	flatAmountGTE?: InputMaybe<Scalars["Int"]["input"]>;
	flatAmountIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	flatAmountIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	flatAmountLT?: InputMaybe<Scalars["Int"]["input"]>;
	flatAmountLTE?: InputMaybe<Scalars["Int"]["input"]>;
	flatAmountNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	flatAmountNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isActiveEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActiveIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActiveNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<DiscountHistoryFilterInput>;
	or?: InputMaybe<Array<DiscountHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	percentageAmountEQ?: InputMaybe<Scalars["Float"]["input"]>;
	percentageAmountGT?: InputMaybe<Scalars["Float"]["input"]>;
	percentageAmountGTE?: InputMaybe<Scalars["Float"]["input"]>;
	percentageAmountIn?: InputMaybe<Array<Scalars["Float"]["input"]>>;
	percentageAmountIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	percentageAmountLT?: InputMaybe<Scalars["Float"]["input"]>;
	percentageAmountLTE?: InputMaybe<Scalars["Float"]["input"]>;
	percentageAmountNEQ?: InputMaybe<Scalars["Float"]["input"]>;
	percentageAmountNotIn?: InputMaybe<Array<Scalars["Float"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type DiscountHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<DiscountHistoryOrderField>;
};

export enum DiscountHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type DiscountOrder = {
	direction: OrderDirection;
	field?: InputMaybe<DiscountOrderField>;
};

export enum DiscountOrderField {
	FlatAmount = "FLAT_AMOUNT",
	Name = "NAME",
	PercentageAmount = "PERCENTAGE_AMOUNT",
}

export type DiscountUpdateBulkInput = {
	clearFlatAmount?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearPercentageAmount?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	flatAmount?: InputMaybe<Scalars["Int"]["input"]>;
	isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	percentageAmount?: InputMaybe<Scalars["Float"]["input"]>;
};

export type DiscountUpdateInput = {
	clearFlatAmount?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearPercentageAmount?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	flatAmount?: InputMaybe<Scalars["Int"]["input"]>;
	isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	percentageAmount?: InputMaybe<Scalars["Float"]["input"]>;
};

export type EdgePagination = {
	first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type EmailAddress = Node & {
	__typename?: "EmailAddress";
	emailAddress: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	isPrimary: Scalars["Boolean"]["output"];
	name: Scalars["String"]["output"];
	person: Maybe<Person>;
	personID: Maybe<Scalars["ID"]["output"]>;
};

export type EmailAddressConnection = {
	__typename?: "EmailAddressConnection";
	edges: Array<EmailAddressEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type EmailAddressCreateInput = {
	emailAddress: Scalars["String"]["input"];
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	personID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EmailAddressEdge = {
	__typename?: "EmailAddressEdge";
	cursor: Scalars["Cursor"]["output"];
	node: EmailAddress;
};

export type EmailAddressFilterInput = {
	and?: InputMaybe<Array<EmailAddressFilterInput>>;
	emailAddressContains?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	emailAddressNEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotContains?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasPerson?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isPrimaryEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<EmailAddressFilterInput>;
	or?: InputMaybe<Array<EmailAddressFilterInput>>;
	person?: InputMaybe<Array<PersonFilterInput>>;
	personIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	personIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type EmailAddressHistory = Node & {
	__typename?: "EmailAddressHistory";
	emailAddress: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isPrimary: Maybe<Scalars["Boolean"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	personID: Maybe<Scalars["ID"]["output"]>;
};

export type EmailAddressHistoryConnection = {
	__typename?: "EmailAddressHistoryConnection";
	edges: Array<EmailAddressHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type EmailAddressHistoryEdge = {
	__typename?: "EmailAddressHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: EmailAddressHistory;
};

export type EmailAddressHistoryFilterInput = {
	and?: InputMaybe<Array<EmailAddressHistoryFilterInput>>;
	emailAddressContains?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	emailAddressIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	emailAddressNEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotContains?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isPrimaryEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<EmailAddressHistoryFilterInput>;
	or?: InputMaybe<Array<EmailAddressHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	personIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type EmailAddressHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<EmailAddressHistoryOrderField>;
};

export enum EmailAddressHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type EmailAddressInPersonCreateInput = {
	emailAddress: Scalars["String"]["input"];
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
};

export type EmailAddressOrder = {
	direction: OrderDirection;
	field?: InputMaybe<EmailAddressOrderField>;
};

export enum EmailAddressOrderField {
	EmailAddress = "EMAIL_ADDRESS",
	IsPrimary = "IS_PRIMARY",
	Name = "NAME",
}

export type EmailAddressUpdateBulkInput = {
	clearPerson?: InputMaybe<Scalars["Boolean"]["input"]>;
	emailAddress?: InputMaybe<Scalars["String"]["input"]>;
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	personID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EmailAddressUpdateInput = {
	clearPerson?: InputMaybe<Scalars["Boolean"]["input"]>;
	emailAddress?: InputMaybe<Scalars["String"]["input"]>;
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	personID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type Employee = Node & {
	__typename?: "Employee";
	attendingStudentMedicalEvents: Array<StudentMedicalEvent>;
	bio: Scalars["String"]["output"];
	campuses: Array<Campus>;
	classYearCategories: Array<ClassYearCategory>;
	classYears: Array<ClassYear>;
	endDate: Maybe<Scalars["Date"]["output"]>;
	id: Scalars["ID"]["output"];
	jobTitle: Scalars["String"]["output"];
	person: Person;
	personID: Scalars["ID"]["output"];
	role: EmployeeRole;
	startDate: Scalars["Date"]["output"];
	teacherCourseSectionEnrollments: Array<TeacherCourseSectionEnrollment>;
	teacherHomeRoomSectionEnrollments: Array<TeacherHomeRoomSectionEnrollment>;
	workEmailAddress: Scalars["String"]["output"];
};

export type EmployeeAttendingStudentMedicalEventsArgs = {
	filters?: InputMaybe<Array<StudentMedicalEventFilterInput>>;
	order?: InputMaybe<StudentMedicalEventOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type EmployeeCampusesArgs = {
	filters?: InputMaybe<Array<CampusFilterInput>>;
	order?: InputMaybe<CampusOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type EmployeeClassYearCategoriesArgs = {
	filters?: InputMaybe<Array<ClassYearCategoryFilterInput>>;
	order?: InputMaybe<ClassYearCategoryOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type EmployeeClassYearsArgs = {
	filters?: InputMaybe<Array<ClassYearFilterInput>>;
	order?: InputMaybe<ClassYearOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type EmployeeTeacherCourseSectionEnrollmentsArgs = {
	filters?: InputMaybe<Array<TeacherCourseSectionEnrollmentFilterInput>>;
	order?: InputMaybe<TeacherCourseSectionEnrollmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type EmployeeTeacherHomeRoomSectionEnrollmentsArgs = {
	filters?: InputMaybe<Array<TeacherHomeRoomSectionEnrollmentFilterInput>>;
	order?: InputMaybe<TeacherHomeRoomSectionEnrollmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistory = Node & {
	__typename?: "EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistory";
	employeeID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	studentMedicalEventID: Maybe<Scalars["ID"]["output"]>;
};

export type EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistoryConnection = {
	__typename?: "EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistoryConnection";
	edges: Array<EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistoryEdge = {
	__typename?: "EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistory;
};

export type EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistoryFilterInput = {
	and?: InputMaybe<Array<EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistoryFilterInput>>;
	employeeIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	employeeIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	employeeIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	employeeIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	employeeIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistoryFilterInput>;
	or?: InputMaybe<Array<EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistoryFilterInput>>;
	studentMedicalEventIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentMedicalEventIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalEventIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentMedicalEventIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentMedicalEventIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistoryOrderField>;
};

export enum EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type EmployeeCampusHistory = Node & {
	__typename?: "EmployeeCampusHistory";
	campusID: Maybe<Scalars["ID"]["output"]>;
	employeeID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
};

export type EmployeeCampusHistoryConnection = {
	__typename?: "EmployeeCampusHistoryConnection";
	edges: Array<EmployeeCampusHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type EmployeeCampusHistoryEdge = {
	__typename?: "EmployeeCampusHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: EmployeeCampusHistory;
};

export type EmployeeCampusHistoryFilterInput = {
	and?: InputMaybe<Array<EmployeeCampusHistoryFilterInput>>;
	campusIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	campusIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	campusIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	campusIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	campusIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	employeeIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	employeeIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	employeeIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	employeeIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	employeeIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<EmployeeCampusHistoryFilterInput>;
	or?: InputMaybe<Array<EmployeeCampusHistoryFilterInput>>;
};

export type EmployeeCampusHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<EmployeeCampusHistoryOrderField>;
};

export enum EmployeeCampusHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type EmployeeClassYearCategoryHistory = Node & {
	__typename?: "EmployeeClassYearCategoryHistory";
	classYearCategoryID: Maybe<Scalars["ID"]["output"]>;
	employeeID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
};

export type EmployeeClassYearCategoryHistoryConnection = {
	__typename?: "EmployeeClassYearCategoryHistoryConnection";
	edges: Array<EmployeeClassYearCategoryHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type EmployeeClassYearCategoryHistoryEdge = {
	__typename?: "EmployeeClassYearCategoryHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: EmployeeClassYearCategoryHistory;
};

export type EmployeeClassYearCategoryHistoryFilterInput = {
	and?: InputMaybe<Array<EmployeeClassYearCategoryHistoryFilterInput>>;
	classYearCategoryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearCategoryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearCategoryIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	classYearCategoryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearCategoryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	employeeIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	employeeIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	employeeIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	employeeIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	employeeIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<EmployeeClassYearCategoryHistoryFilterInput>;
	or?: InputMaybe<Array<EmployeeClassYearCategoryHistoryFilterInput>>;
};

export type EmployeeClassYearCategoryHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<EmployeeClassYearCategoryHistoryOrderField>;
};

export enum EmployeeClassYearCategoryHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type EmployeeClassYearHistory = Node & {
	__typename?: "EmployeeClassYearHistory";
	classYearID: Maybe<Scalars["ID"]["output"]>;
	employeeID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
};

export type EmployeeClassYearHistoryConnection = {
	__typename?: "EmployeeClassYearHistoryConnection";
	edges: Array<EmployeeClassYearHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type EmployeeClassYearHistoryEdge = {
	__typename?: "EmployeeClassYearHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: EmployeeClassYearHistory;
};

export type EmployeeClassYearHistoryFilterInput = {
	and?: InputMaybe<Array<EmployeeClassYearHistoryFilterInput>>;
	classYearIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	classYearIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	employeeIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	employeeIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	employeeIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	employeeIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	employeeIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<EmployeeClassYearHistoryFilterInput>;
	or?: InputMaybe<Array<EmployeeClassYearHistoryFilterInput>>;
};

export type EmployeeClassYearHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<EmployeeClassYearHistoryOrderField>;
};

export enum EmployeeClassYearHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type EmployeeConnection = {
	__typename?: "EmployeeConnection";
	edges: Array<EmployeeEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type EmployeeCreateInput = {
	attendingStudentMedicalEventIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bio?: InputMaybe<Scalars["String"]["input"]>;
	campusIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	endDate?: InputMaybe<Scalars["Date"]["input"]>;
	jobTitle: Scalars["String"]["input"];
	person?: InputMaybe<PersonInEmployeeCreateInput>;
	personID?: InputMaybe<Scalars["ID"]["input"]>;
	role: EmployeeRole;
	startDate: Scalars["Date"]["input"];
	teacherCourseSectionEnrollments?: InputMaybe<Array<TeacherCourseSectionEnrollmentInTeacherCreateInput>>;
	teacherHomeRoomSectionEnrollments?: InputMaybe<Array<TeacherHomeRoomSectionEnrollmentInTeacherCreateInput>>;
	workEmailAddress: Scalars["String"]["input"];
};

export type EmployeeEdge = {
	__typename?: "EmployeeEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Employee;
};

export type EmployeeFilterInput = {
	and?: InputMaybe<Array<EmployeeFilterInput>>;
	attendingStudentMedicalEvents?: InputMaybe<Array<StudentMedicalEventFilterInput>>;
	bioContains?: InputMaybe<Scalars["String"]["input"]>;
	bioEQ?: InputMaybe<Scalars["String"]["input"]>;
	bioHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bioHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bioIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bioNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bioNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bioNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bioNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bioNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	campuses?: InputMaybe<Array<CampusFilterInput>>;
	classYearCategories?: InputMaybe<Array<ClassYearCategoryFilterInput>>;
	classYears?: InputMaybe<Array<ClassYearFilterInput>>;
	endDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	endDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	endDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	endDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	endDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	endDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	endDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	endDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	endDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	hasAttendingStudentMedicalEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCampuses?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasClassYearCategories?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasClassYears?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasTeacherCourseSectionEnrollments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasTeacherHomeRoomSectionEnrollments?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	jobTitleContains?: InputMaybe<Scalars["String"]["input"]>;
	jobTitleEQ?: InputMaybe<Scalars["String"]["input"]>;
	jobTitleHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	jobTitleHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	jobTitleIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	jobTitleNEQ?: InputMaybe<Scalars["String"]["input"]>;
	jobTitleNotContains?: InputMaybe<Scalars["String"]["input"]>;
	jobTitleNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	jobTitleNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	jobTitleNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<EmployeeFilterInput>;
	or?: InputMaybe<Array<EmployeeFilterInput>>;
	person?: InputMaybe<Array<PersonFilterInput>>;
	personIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	roleEQ?: InputMaybe<EmployeeRole>;
	roleIn?: InputMaybe<Array<EmployeeRole>>;
	roleNEQ?: InputMaybe<EmployeeRole>;
	roleNotIn?: InputMaybe<Array<EmployeeRole>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	startDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	startDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	startDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	startDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	startDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	startDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	startDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	startDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	teacherCourseSectionEnrollments?: InputMaybe<Array<TeacherCourseSectionEnrollmentFilterInput>>;
	teacherHomeRoomSectionEnrollments?: InputMaybe<Array<TeacherHomeRoomSectionEnrollmentFilterInput>>;
	workEmailAddressContains?: InputMaybe<Scalars["String"]["input"]>;
	workEmailAddressEQ?: InputMaybe<Scalars["String"]["input"]>;
	workEmailAddressHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	workEmailAddressHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	workEmailAddressIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	workEmailAddressNEQ?: InputMaybe<Scalars["String"]["input"]>;
	workEmailAddressNotContains?: InputMaybe<Scalars["String"]["input"]>;
	workEmailAddressNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	workEmailAddressNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	workEmailAddressNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type EmployeeHistory = Node & {
	__typename?: "EmployeeHistory";
	bio: Maybe<Scalars["String"]["output"]>;
	endDate: Maybe<Scalars["Date"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	jobTitle: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	personID: Maybe<Scalars["ID"]["output"]>;
	role: Maybe<EmployeeHistoryRole>;
	startDate: Maybe<Scalars["Date"]["output"]>;
	workEmailAddress: Maybe<Scalars["String"]["output"]>;
};

export type EmployeeHistoryConnection = {
	__typename?: "EmployeeHistoryConnection";
	edges: Array<EmployeeHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type EmployeeHistoryEdge = {
	__typename?: "EmployeeHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: EmployeeHistory;
};

export type EmployeeHistoryFilterInput = {
	and?: InputMaybe<Array<EmployeeHistoryFilterInput>>;
	bioContains?: InputMaybe<Scalars["String"]["input"]>;
	bioEQ?: InputMaybe<Scalars["String"]["input"]>;
	bioHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bioHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bioIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bioIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	bioNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bioNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bioNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bioNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bioNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	endDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	endDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	endDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	endDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	endDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	endDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	endDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	endDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	endDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	jobTitleContains?: InputMaybe<Scalars["String"]["input"]>;
	jobTitleEQ?: InputMaybe<Scalars["String"]["input"]>;
	jobTitleHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	jobTitleHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	jobTitleIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	jobTitleIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	jobTitleNEQ?: InputMaybe<Scalars["String"]["input"]>;
	jobTitleNotContains?: InputMaybe<Scalars["String"]["input"]>;
	jobTitleNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	jobTitleNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	jobTitleNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<EmployeeHistoryFilterInput>;
	or?: InputMaybe<Array<EmployeeHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	personIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	roleEQ?: InputMaybe<EmployeeHistoryRole>;
	roleIn?: InputMaybe<Array<EmployeeHistoryRole>>;
	roleIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	roleNEQ?: InputMaybe<EmployeeHistoryRole>;
	roleNotIn?: InputMaybe<Array<EmployeeHistoryRole>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	startDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	startDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	startDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	startDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	startDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	startDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	startDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	startDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	startDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	workEmailAddressContains?: InputMaybe<Scalars["String"]["input"]>;
	workEmailAddressEQ?: InputMaybe<Scalars["String"]["input"]>;
	workEmailAddressHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	workEmailAddressHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	workEmailAddressIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	workEmailAddressIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	workEmailAddressNEQ?: InputMaybe<Scalars["String"]["input"]>;
	workEmailAddressNotContains?: InputMaybe<Scalars["String"]["input"]>;
	workEmailAddressNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	workEmailAddressNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	workEmailAddressNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type EmployeeHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<EmployeeHistoryOrderField>;
};

export enum EmployeeHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export enum EmployeeHistoryRole {
	AcademicAdmin = "academic_admin",
	FinancialAdmin = "financial_admin",
	FrontDesk = "front_desk",
	GeneralAdmin = "general_admin",
	GeneralStaff = "general_staff",
	MedicalStaff = "medical_staff",
	PrincipalAdmin = "principal_admin",
	Teacher = "teacher",
}

export type EmployeeInPersonCreateInput = {
	attendingStudentMedicalEventIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bio?: InputMaybe<Scalars["String"]["input"]>;
	campusIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	endDate?: InputMaybe<Scalars["Date"]["input"]>;
	jobTitle: Scalars["String"]["input"];
	role: EmployeeRole;
	startDate: Scalars["Date"]["input"];
	teacherCourseSectionEnrollments?: InputMaybe<Array<TeacherCourseSectionEnrollmentInTeacherCreateInput>>;
	teacherHomeRoomSectionEnrollments?: InputMaybe<Array<TeacherHomeRoomSectionEnrollmentInTeacherCreateInput>>;
	workEmailAddress: Scalars["String"]["input"];
};

export type EmployeeOrder = {
	direction: OrderDirection;
	field?: InputMaybe<EmployeeOrderField>;
};

export enum EmployeeOrderField {
	EndDate = "END_DATE",
	JobTitle = "JOB_TITLE",
	Role = "ROLE",
	StartDate = "START_DATE",
}

export enum EmployeeRole {
	AcademicAdmin = "academic_admin",
	FinancialAdmin = "financial_admin",
	FrontDesk = "front_desk",
	GeneralAdmin = "general_admin",
	GeneralStaff = "general_staff",
	MedicalStaff = "medical_staff",
	PrincipalAdmin = "principal_admin",
	Teacher = "teacher",
}

export type EmployeeUpdateBulkInput = {
	addAttendingStudentMedicalEventIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addCampusIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addClassYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	attendingStudentMedicalEventIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bio?: InputMaybe<Scalars["String"]["input"]>;
	campusIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearAttendingStudentMedicalEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearCampuses?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearClassYearCategories?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearClassYears?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEndDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	endDate?: InputMaybe<Scalars["Date"]["input"]>;
	jobTitle?: InputMaybe<Scalars["String"]["input"]>;
	removeAttendingStudentMedicalEventIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeCampusIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeClassYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	role?: InputMaybe<EmployeeRole>;
	startDate?: InputMaybe<Scalars["Date"]["input"]>;
	workEmailAddress?: InputMaybe<Scalars["String"]["input"]>;
};

export type EmployeeUpdateInput = {
	addAttendingStudentMedicalEventIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addCampusIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addClassYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	attendingStudentMedicalEventIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bio?: InputMaybe<Scalars["String"]["input"]>;
	campusIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearAttendingStudentMedicalEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearCampuses?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearClassYearCategories?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearClassYears?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEndDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	endDate?: InputMaybe<Scalars["Date"]["input"]>;
	jobTitle?: InputMaybe<Scalars["String"]["input"]>;
	personID?: InputMaybe<Scalars["ID"]["input"]>;
	removeAttendingStudentMedicalEventIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeCampusIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeClassYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	role?: InputMaybe<EmployeeRole>;
	startDate?: InputMaybe<Scalars["Date"]["input"]>;
	workEmailAddress?: InputMaybe<Scalars["String"]["input"]>;
};

export type EnrollmentApplication = Node & {
	__typename?: "EnrollmentApplication";
	applicationSubmittedAt: Maybe<Scalars["Time"]["output"]>;
	createdAt: Scalars["Time"]["output"];
	doesConsentToCorrespondence: Scalars["Boolean"]["output"];
	doesConsentToDataProtectionPolicy: Scalars["Boolean"]["output"];
	doesConsentToDataUse: Scalars["Boolean"]["output"];
	enrollmentApplicationGuardians: Array<EnrollmentApplicationGuardian>;
	enrollmentApplicationStudents: Array<EnrollmentApplicationStudent>;
	id: Scalars["ID"]["output"];
	inquirySubmittedAt: Maybe<Scalars["Time"]["output"]>;
	notes: Scalars["String"]["output"];
	signatureDate: Maybe<Scalars["Date"]["output"]>;
	signatureName: Scalars["String"]["output"];
	source: Scalars["String"]["output"];
	sourceDetails: Scalars["String"]["output"];
	wasApplicationSubmitted: Scalars["Boolean"]["output"];
	wasInquirySubmitted: Scalars["Boolean"]["output"];
};

export type EnrollmentApplicationEnrollmentApplicationGuardiansArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationGuardianOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type EnrollmentApplicationEnrollmentApplicationStudentsArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationStudentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type EnrollmentApplicationConnection = {
	__typename?: "EnrollmentApplicationConnection";
	edges: Array<EnrollmentApplicationEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type EnrollmentApplicationCreateInput = {
	doesConsentToCorrespondence?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToDataProtectionPolicy?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToDataUse?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationGuardians?: InputMaybe<Array<EnrollmentApplicationGuardianInEnrollmentApplicationCreateInput>>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudents?: InputMaybe<Array<EnrollmentApplicationStudentInEnrollmentApplicationCreateInput>>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	signatureDate?: InputMaybe<Scalars["Date"]["input"]>;
	signatureName?: InputMaybe<Scalars["String"]["input"]>;
	source?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetails?: InputMaybe<Scalars["String"]["input"]>;
};

export type EnrollmentApplicationEdge = {
	__typename?: "EnrollmentApplicationEdge";
	cursor: Scalars["Cursor"]["output"];
	node: EnrollmentApplication;
};

export type EnrollmentApplicationFilterInput = {
	and?: InputMaybe<Array<EnrollmentApplicationFilterInput>>;
	applicationSubmittedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	applicationSubmittedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	applicationSubmittedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	applicationSubmittedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	applicationSubmittedAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	applicationSubmittedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	applicationSubmittedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	applicationSubmittedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	applicationSubmittedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	doesConsentToCorrespondenceEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToCorrespondenceNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToDataProtectionPolicyEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToDataProtectionPolicyNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToDataUseEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToDataUseNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationGuardians?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput>>;
	enrollmentApplicationStudents?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	hasEnrollmentApplicationGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	inquirySubmittedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	inquirySubmittedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	inquirySubmittedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	inquirySubmittedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	inquirySubmittedAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	inquirySubmittedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	inquirySubmittedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	inquirySubmittedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	inquirySubmittedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	not?: InputMaybe<EnrollmentApplicationFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<EnrollmentApplicationFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	signatureDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	signatureDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	signatureDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	signatureDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	signatureDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	signatureDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	signatureDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	signatureDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	signatureDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	signatureNameContains?: InputMaybe<Scalars["String"]["input"]>;
	signatureNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	signatureNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	signatureNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	signatureNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	signatureNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	signatureNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	signatureNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	signatureNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	signatureNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	sourceContains?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetailsContains?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetailsEQ?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetailsHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetailsHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetailsIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	sourceDetailsNEQ?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetailsNotContains?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetailsNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetailsNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetailsNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	sourceEQ?: InputMaybe<Scalars["String"]["input"]>;
	sourceHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	sourceHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	sourceIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	sourceNEQ?: InputMaybe<Scalars["String"]["input"]>;
	sourceNotContains?: InputMaybe<Scalars["String"]["input"]>;
	sourceNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	sourceNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	sourceNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type EnrollmentApplicationGuardian = Node & {
	__typename?: "EnrollmentApplicationGuardian";
	addressCity: Scalars["String"]["output"];
	addressCountry: Maybe<Country>;
	addressCountryID: Maybe<Scalars["ID"]["output"]>;
	addressLine1: Scalars["String"]["output"];
	addressLine2: Scalars["String"]["output"];
	addressPostalCode: Scalars["String"]["output"];
	addressStateOrProvince: Scalars["String"]["output"];
	dateOfBirth: Maybe<Scalars["Date"]["output"]>;
	emailAddress: Scalars["String"]["output"];
	enrollmentApplication: EnrollmentApplication;
	enrollmentApplicationID: Scalars["ID"]["output"];
	familyName: Scalars["String"]["output"];
	gender: Scalars["String"]["output"];
	givenName: Scalars["String"]["output"];
	guardian: Maybe<Guardian>;
	guardianID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isAuthorizedForPickup: Scalars["Boolean"]["output"];
	isEmergencyContact: Scalars["Boolean"]["output"];
	isFinancialContact: Scalars["Boolean"]["output"];
	isPrimary: Scalars["Boolean"]["output"];
	isPrimaryOnApplication: Scalars["Boolean"]["output"];
	livesWithStudent: Scalars["Boolean"]["output"];
	middleName: Scalars["String"]["output"];
	name: Scalars["String"]["output"];
	nameOrder: EnrollmentApplicationGuardianNameOrder;
	phoneNumber: Scalars["String"]["output"];
	relationshipStatus: Maybe<EnrollmentApplicationGuardianRelationshipStatus>;
	relationshipType: Scalars["String"]["output"];
	sameAddressGuardians: Array<EnrollmentApplicationGuardian>;
	targetAddressGuardian: Maybe<EnrollmentApplicationGuardian>;
	targetAddressGuardianID: Maybe<Scalars["ID"]["output"]>;
};

export type EnrollmentApplicationGuardianSameAddressGuardiansArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationGuardianOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type EnrollmentApplicationGuardianConnection = {
	__typename?: "EnrollmentApplicationGuardianConnection";
	edges: Array<EnrollmentApplicationGuardianEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type EnrollmentApplicationGuardianCreateInput = {
	addressCity?: InputMaybe<Scalars["String"]["input"]>;
	addressCountryID?: InputMaybe<Scalars["ID"]["input"]>;
	addressLine1?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCode?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvince?: InputMaybe<Scalars["String"]["input"]>;
	dateOfBirth?: InputMaybe<Scalars["Date"]["input"]>;
	emailAddress: Scalars["String"]["input"];
	enrollmentApplicationID: Scalars["ID"]["input"];
	familyName: Scalars["String"]["input"];
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName: Scalars["String"]["input"];
	guardianID?: InputMaybe<Scalars["ID"]["input"]>;
	isAuthorizedForPickup?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryOnApplication?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<EnrollmentApplicationGuardianNameOrder>;
	phoneNumber: Scalars["String"]["input"];
	relationshipStatus?: InputMaybe<EnrollmentApplicationGuardianRelationshipStatus>;
	relationshipType: Scalars["String"]["input"];
	sameAddressGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sameAddressGuardians?: InputMaybe<Array<EnrollmentApplicationGuardianInTargetAddressGuardianCreateInput>>;
	targetAddressGuardianID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EnrollmentApplicationGuardianEdge = {
	__typename?: "EnrollmentApplicationGuardianEdge";
	cursor: Scalars["Cursor"]["output"];
	node: EnrollmentApplicationGuardian;
};

export type EnrollmentApplicationGuardianFilterInput = {
	addressCityContains?: InputMaybe<Scalars["String"]["input"]>;
	addressCityEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressCityHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressCityHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressCityIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressCityNEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressCityNotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressCityNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressCityNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressCityNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressCountry?: InputMaybe<Array<CountryFilterInput>>;
	addressCountryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	addressCountryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addressCountryIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	addressCountryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	addressCountryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addressLine1Contains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1EQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1HasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1HasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1In?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressLine1NEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressLine2Contains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2EQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2HasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2HasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2In?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressLine2NEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressPostalCodeContains?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCodeEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCodeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCodeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCodeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressPostalCodeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCodeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCodeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCodeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCodeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressStateOrProvinceContains?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvinceEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvinceHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvinceHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvinceIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressStateOrProvinceNEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvinceNotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvinceNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvinceNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvinceNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput>>;
	dateOfBirthEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthGT?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthGTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dateOfBirthIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateOfBirthLT?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthLTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	emailAddressContains?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	emailAddressNEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotContains?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	enrollmentApplication?: InputMaybe<Array<EnrollmentApplicationFilterInput>>;
	enrollmentApplicationIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	familyNameContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	familyNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	genderContains?: InputMaybe<Scalars["String"]["input"]>;
	genderEQ?: InputMaybe<Scalars["String"]["input"]>;
	genderHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	genderHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	genderIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	genderNEQ?: InputMaybe<Scalars["String"]["input"]>;
	genderNotContains?: InputMaybe<Scalars["String"]["input"]>;
	genderNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	genderNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	genderNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	givenNameContains?: InputMaybe<Scalars["String"]["input"]>;
	givenNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	givenNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	givenNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	guardian?: InputMaybe<Array<GuardianFilterInput>>;
	guardianIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	guardianIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	guardianIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	guardianIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	guardianIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	hasAddressCountry?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasGuardian?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSameAddressGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasTargetAddressGuardian?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isAuthorizedForPickupEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isAuthorizedForPickupNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContactEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContactNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContactEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContactNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryOnApplicationEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryOnApplicationNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudentEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudentNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	middleNameContains?: InputMaybe<Scalars["String"]["input"]>;
	middleNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	middleNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	middleNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameOrderEQ?: InputMaybe<EnrollmentApplicationGuardianNameOrder>;
	nameOrderIn?: InputMaybe<Array<EnrollmentApplicationGuardianNameOrder>>;
	nameOrderNEQ?: InputMaybe<EnrollmentApplicationGuardianNameOrder>;
	nameOrderNotIn?: InputMaybe<Array<EnrollmentApplicationGuardianNameOrder>>;
	not?: InputMaybe<EnrollmentApplicationGuardianFilterInput>;
	or?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput>>;
	phoneNumberContains?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberEQ?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	phoneNumberNEQ?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotContains?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	relationshipStatusEQ?: InputMaybe<EnrollmentApplicationGuardianRelationshipStatus>;
	relationshipStatusIn?: InputMaybe<Array<EnrollmentApplicationGuardianRelationshipStatus>>;
	relationshipStatusIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	relationshipStatusNEQ?: InputMaybe<EnrollmentApplicationGuardianRelationshipStatus>;
	relationshipStatusNotIn?: InputMaybe<Array<EnrollmentApplicationGuardianRelationshipStatus>>;
	relationshipTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	relationshipTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	sameAddressGuardians?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	targetAddressGuardian?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput>>;
	targetAddressGuardianIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	targetAddressGuardianIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	targetAddressGuardianIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	targetAddressGuardianIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	targetAddressGuardianIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type EnrollmentApplicationGuardianHistory = Node & {
	__typename?: "EnrollmentApplicationGuardianHistory";
	addressCity: Maybe<Scalars["String"]["output"]>;
	addressCountryID: Maybe<Scalars["ID"]["output"]>;
	addressLine1: Maybe<Scalars["String"]["output"]>;
	addressLine2: Maybe<Scalars["String"]["output"]>;
	addressPostalCode: Maybe<Scalars["String"]["output"]>;
	addressStateOrProvince: Maybe<Scalars["String"]["output"]>;
	dateOfBirth: Maybe<Scalars["Date"]["output"]>;
	emailAddress: Maybe<Scalars["String"]["output"]>;
	enrollmentApplicationID: Maybe<Scalars["ID"]["output"]>;
	familyName: Maybe<Scalars["String"]["output"]>;
	gender: Maybe<Scalars["String"]["output"]>;
	givenName: Maybe<Scalars["String"]["output"]>;
	guardianID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isAuthorizedForPickup: Maybe<Scalars["Boolean"]["output"]>;
	isEmergencyContact: Maybe<Scalars["Boolean"]["output"]>;
	isFinancialContact: Maybe<Scalars["Boolean"]["output"]>;
	isPrimary: Maybe<Scalars["Boolean"]["output"]>;
	isPrimaryOnApplication: Maybe<Scalars["Boolean"]["output"]>;
	livesWithStudent: Maybe<Scalars["Boolean"]["output"]>;
	middleName: Maybe<Scalars["String"]["output"]>;
	nameOrder: Maybe<EnrollmentApplicationGuardianHistoryNameOrder>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	phoneNumber: Maybe<Scalars["String"]["output"]>;
	relationshipStatus: Maybe<EnrollmentApplicationGuardianHistoryRelationshipStatus>;
	relationshipType: Maybe<Scalars["String"]["output"]>;
	targetAddressGuardianID: Maybe<Scalars["ID"]["output"]>;
};

export type EnrollmentApplicationGuardianHistoryConnection = {
	__typename?: "EnrollmentApplicationGuardianHistoryConnection";
	edges: Array<EnrollmentApplicationGuardianHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type EnrollmentApplicationGuardianHistoryEdge = {
	__typename?: "EnrollmentApplicationGuardianHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: EnrollmentApplicationGuardianHistory;
};

export type EnrollmentApplicationGuardianHistoryFilterInput = {
	addressCityContains?: InputMaybe<Scalars["String"]["input"]>;
	addressCityEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressCityHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressCityHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressCityIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressCityIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	addressCityNEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressCityNotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressCityNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressCityNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressCityNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressCountryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	addressCountryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addressCountryIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	addressCountryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	addressCountryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addressLine1Contains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1EQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1HasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1HasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1In?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressLine1IsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	addressLine1NEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1NotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressLine2Contains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2EQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2HasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2HasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2In?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressLine2IsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	addressLine2NEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2NotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressPostalCodeContains?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCodeEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCodeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCodeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCodeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressPostalCodeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	addressPostalCodeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCodeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCodeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCodeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCodeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressStateOrProvinceContains?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvinceEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvinceHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvinceHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvinceIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressStateOrProvinceIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	addressStateOrProvinceNEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvinceNotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvinceNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvinceNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvinceNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<EnrollmentApplicationGuardianHistoryFilterInput>>;
	dateOfBirthEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthGT?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthGTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dateOfBirthIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateOfBirthLT?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthLTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	emailAddressContains?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	emailAddressIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	emailAddressNEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotContains?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	enrollmentApplicationIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	familyNameContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	familyNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	familyNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	genderContains?: InputMaybe<Scalars["String"]["input"]>;
	genderEQ?: InputMaybe<Scalars["String"]["input"]>;
	genderHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	genderHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	genderIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	genderIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	genderNEQ?: InputMaybe<Scalars["String"]["input"]>;
	genderNotContains?: InputMaybe<Scalars["String"]["input"]>;
	genderNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	genderNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	genderNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	givenNameContains?: InputMaybe<Scalars["String"]["input"]>;
	givenNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	givenNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	givenNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	givenNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	guardianIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	guardianIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	guardianIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	guardianIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	guardianIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isAuthorizedForPickupEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isAuthorizedForPickupIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isAuthorizedForPickupNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContactEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContactIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContactNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContactEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContactIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContactNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryOnApplicationEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryOnApplicationIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryOnApplicationNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudentEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudentIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudentNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	middleNameContains?: InputMaybe<Scalars["String"]["input"]>;
	middleNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	middleNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	middleNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	middleNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameOrderEQ?: InputMaybe<EnrollmentApplicationGuardianHistoryNameOrder>;
	nameOrderIn?: InputMaybe<Array<EnrollmentApplicationGuardianHistoryNameOrder>>;
	nameOrderIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameOrderNEQ?: InputMaybe<EnrollmentApplicationGuardianHistoryNameOrder>;
	nameOrderNotIn?: InputMaybe<Array<EnrollmentApplicationGuardianHistoryNameOrder>>;
	not?: InputMaybe<EnrollmentApplicationGuardianHistoryFilterInput>;
	or?: InputMaybe<Array<EnrollmentApplicationGuardianHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	phoneNumberContains?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberEQ?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	phoneNumberIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	phoneNumberNEQ?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotContains?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	relationshipStatusEQ?: InputMaybe<EnrollmentApplicationGuardianHistoryRelationshipStatus>;
	relationshipStatusIn?: InputMaybe<Array<EnrollmentApplicationGuardianHistoryRelationshipStatus>>;
	relationshipStatusIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	relationshipStatusNEQ?: InputMaybe<EnrollmentApplicationGuardianHistoryRelationshipStatus>;
	relationshipStatusNotIn?: InputMaybe<Array<EnrollmentApplicationGuardianHistoryRelationshipStatus>>;
	relationshipTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	relationshipTypeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	relationshipTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	targetAddressGuardianIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	targetAddressGuardianIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	targetAddressGuardianIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	targetAddressGuardianIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	targetAddressGuardianIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export enum EnrollmentApplicationGuardianHistoryNameOrder {
	FamilyGiven = "family_given",
	GivenFamily = "given_family",
}

export type EnrollmentApplicationGuardianHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<EnrollmentApplicationGuardianHistoryOrderField>;
};

export enum EnrollmentApplicationGuardianHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export enum EnrollmentApplicationGuardianHistoryRelationshipStatus {
	Married = "married",
	SeparatedOrDivorced = "separated_or_divorced",
	Single = "single",
	TogetherButNotMarried = "together_but_not_married",
}

export type EnrollmentApplicationGuardianInAddressCountryCreateInput = {
	addressCity?: InputMaybe<Scalars["String"]["input"]>;
	addressLine1?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCode?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvince?: InputMaybe<Scalars["String"]["input"]>;
	dateOfBirth?: InputMaybe<Scalars["Date"]["input"]>;
	emailAddress: Scalars["String"]["input"];
	enrollmentApplicationID: Scalars["ID"]["input"];
	familyName: Scalars["String"]["input"];
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName: Scalars["String"]["input"];
	guardianID?: InputMaybe<Scalars["ID"]["input"]>;
	isAuthorizedForPickup?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryOnApplication?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<EnrollmentApplicationGuardianNameOrder>;
	phoneNumber: Scalars["String"]["input"];
	relationshipStatus?: InputMaybe<EnrollmentApplicationGuardianRelationshipStatus>;
	relationshipType: Scalars["String"]["input"];
	sameAddressGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sameAddressGuardians?: InputMaybe<Array<EnrollmentApplicationGuardianInTargetAddressGuardianCreateInput>>;
	targetAddressGuardianID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EnrollmentApplicationGuardianInEnrollmentApplicationCreateInput = {
	addressCity?: InputMaybe<Scalars["String"]["input"]>;
	addressCountryID?: InputMaybe<Scalars["ID"]["input"]>;
	addressLine1?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCode?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvince?: InputMaybe<Scalars["String"]["input"]>;
	dateOfBirth?: InputMaybe<Scalars["Date"]["input"]>;
	emailAddress: Scalars["String"]["input"];
	familyName: Scalars["String"]["input"];
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName: Scalars["String"]["input"];
	guardianID?: InputMaybe<Scalars["ID"]["input"]>;
	isAuthorizedForPickup?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryOnApplication?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<EnrollmentApplicationGuardianNameOrder>;
	phoneNumber: Scalars["String"]["input"];
	relationshipStatus?: InputMaybe<EnrollmentApplicationGuardianRelationshipStatus>;
	relationshipType: Scalars["String"]["input"];
	sameAddressGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sameAddressGuardians?: InputMaybe<Array<EnrollmentApplicationGuardianInTargetAddressGuardianCreateInput>>;
	targetAddressGuardianID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EnrollmentApplicationGuardianInGuardianCreateInput = {
	addressCity?: InputMaybe<Scalars["String"]["input"]>;
	addressCountryID?: InputMaybe<Scalars["ID"]["input"]>;
	addressLine1?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCode?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvince?: InputMaybe<Scalars["String"]["input"]>;
	dateOfBirth?: InputMaybe<Scalars["Date"]["input"]>;
	emailAddress: Scalars["String"]["input"];
	enrollmentApplicationID: Scalars["ID"]["input"];
	familyName: Scalars["String"]["input"];
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName: Scalars["String"]["input"];
	isAuthorizedForPickup?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryOnApplication?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<EnrollmentApplicationGuardianNameOrder>;
	phoneNumber: Scalars["String"]["input"];
	relationshipStatus?: InputMaybe<EnrollmentApplicationGuardianRelationshipStatus>;
	relationshipType: Scalars["String"]["input"];
	sameAddressGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sameAddressGuardians?: InputMaybe<Array<EnrollmentApplicationGuardianInTargetAddressGuardianCreateInput>>;
	targetAddressGuardianID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EnrollmentApplicationGuardianInTargetAddressGuardianCreateInput = {
	addressCity?: InputMaybe<Scalars["String"]["input"]>;
	addressCountryID?: InputMaybe<Scalars["ID"]["input"]>;
	addressLine1?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCode?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvince?: InputMaybe<Scalars["String"]["input"]>;
	dateOfBirth?: InputMaybe<Scalars["Date"]["input"]>;
	emailAddress: Scalars["String"]["input"];
	enrollmentApplicationID: Scalars["ID"]["input"];
	familyName: Scalars["String"]["input"];
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName: Scalars["String"]["input"];
	guardianID?: InputMaybe<Scalars["ID"]["input"]>;
	isAuthorizedForPickup?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryOnApplication?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<EnrollmentApplicationGuardianNameOrder>;
	phoneNumber: Scalars["String"]["input"];
	relationshipStatus?: InputMaybe<EnrollmentApplicationGuardianRelationshipStatus>;
	relationshipType: Scalars["String"]["input"];
	sameAddressGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sameAddressGuardians?: InputMaybe<Array<EnrollmentApplicationGuardianInTargetAddressGuardianCreateInput>>;
};

export enum EnrollmentApplicationGuardianNameOrder {
	FamilyGiven = "family_given",
	GivenFamily = "given_family",
}

export type EnrollmentApplicationGuardianOrder = {
	direction: OrderDirection;
	field?: InputMaybe<EnrollmentApplicationGuardianOrderField>;
};

export enum EnrollmentApplicationGuardianOrderField {
	DateOfBirth = "DATE_OF_BIRTH",
	FamilyName = "FAMILY_NAME",
	GivenName = "GIVEN_NAME",
	IsAuthorizedForPickup = "IS_AUTHORIZED_FOR_PICKUP",
	IsEmergencyContact = "IS_EMERGENCY_CONTACT",
	IsFinancialContact = "IS_FINANCIAL_CONTACT",
	IsPrimary = "IS_PRIMARY",
	LivesWithStudent = "LIVES_WITH_STUDENT",
	RelationshipType = "RELATIONSHIP_TYPE",
}

export enum EnrollmentApplicationGuardianRelationshipStatus {
	Married = "married",
	SeparatedOrDivorced = "separated_or_divorced",
	Single = "single",
	TogetherButNotMarried = "together_but_not_married",
}

export type EnrollmentApplicationGuardianUpdateBulkInput = {
	addSameAddressGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addressCity?: InputMaybe<Scalars["String"]["input"]>;
	addressCountryID?: InputMaybe<Scalars["ID"]["input"]>;
	addressLine1?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCode?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvince?: InputMaybe<Scalars["String"]["input"]>;
	clearAddressCountry?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearDateOfBirth?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearGuardian?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearRelationshipStatus?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSameAddressGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearTargetAddressGuardian?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateOfBirth?: InputMaybe<Scalars["Date"]["input"]>;
	emailAddress?: InputMaybe<Scalars["String"]["input"]>;
	enrollmentApplicationID?: InputMaybe<Scalars["ID"]["input"]>;
	familyName?: InputMaybe<Scalars["String"]["input"]>;
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName?: InputMaybe<Scalars["String"]["input"]>;
	guardianID?: InputMaybe<Scalars["ID"]["input"]>;
	isAuthorizedForPickup?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryOnApplication?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<EnrollmentApplicationGuardianNameOrder>;
	phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
	relationshipStatus?: InputMaybe<EnrollmentApplicationGuardianRelationshipStatus>;
	relationshipType?: InputMaybe<Scalars["String"]["input"]>;
	removeSameAddressGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sameAddressGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	targetAddressGuardianID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EnrollmentApplicationGuardianUpdateInput = {
	addSameAddressGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addressCity?: InputMaybe<Scalars["String"]["input"]>;
	addressCountryID?: InputMaybe<Scalars["ID"]["input"]>;
	addressLine1?: InputMaybe<Scalars["String"]["input"]>;
	addressLine2?: InputMaybe<Scalars["String"]["input"]>;
	addressPostalCode?: InputMaybe<Scalars["String"]["input"]>;
	addressStateOrProvince?: InputMaybe<Scalars["String"]["input"]>;
	clearAddressCountry?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearDateOfBirth?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearGuardian?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearRelationshipStatus?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSameAddressGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearTargetAddressGuardian?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateOfBirth?: InputMaybe<Scalars["Date"]["input"]>;
	emailAddress?: InputMaybe<Scalars["String"]["input"]>;
	enrollmentApplicationID?: InputMaybe<Scalars["ID"]["input"]>;
	familyName?: InputMaybe<Scalars["String"]["input"]>;
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName?: InputMaybe<Scalars["String"]["input"]>;
	guardianID?: InputMaybe<Scalars["ID"]["input"]>;
	isAuthorizedForPickup?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryOnApplication?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<EnrollmentApplicationGuardianNameOrder>;
	phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
	relationshipStatus?: InputMaybe<EnrollmentApplicationGuardianRelationshipStatus>;
	relationshipType?: InputMaybe<Scalars["String"]["input"]>;
	removeSameAddressGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sameAddressGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	targetAddressGuardianID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EnrollmentApplicationHistory = Node & {
	__typename?: "EnrollmentApplicationHistory";
	applicationSubmittedAt: Maybe<Scalars["Time"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	doesConsentToCorrespondence: Maybe<Scalars["Boolean"]["output"]>;
	doesConsentToDataProtectionPolicy: Maybe<Scalars["Boolean"]["output"]>;
	doesConsentToDataUse: Maybe<Scalars["Boolean"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	inquirySubmittedAt: Maybe<Scalars["Time"]["output"]>;
	notes: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	signatureDate: Maybe<Scalars["Date"]["output"]>;
	signatureName: Maybe<Scalars["String"]["output"]>;
	source: Maybe<Scalars["String"]["output"]>;
	sourceDetails: Maybe<Scalars["String"]["output"]>;
};

export type EnrollmentApplicationHistoryConnection = {
	__typename?: "EnrollmentApplicationHistoryConnection";
	edges: Array<EnrollmentApplicationHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type EnrollmentApplicationHistoryEdge = {
	__typename?: "EnrollmentApplicationHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: EnrollmentApplicationHistory;
};

export type EnrollmentApplicationHistoryFilterInput = {
	and?: InputMaybe<Array<EnrollmentApplicationHistoryFilterInput>>;
	applicationSubmittedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	applicationSubmittedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	applicationSubmittedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	applicationSubmittedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	applicationSubmittedAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	applicationSubmittedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	applicationSubmittedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	applicationSubmittedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	applicationSubmittedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	doesConsentToCorrespondenceEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToCorrespondenceIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToCorrespondenceNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToDataProtectionPolicyEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToDataProtectionPolicyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToDataProtectionPolicyNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToDataUseEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToDataUseIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToDataUseNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	inquirySubmittedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	inquirySubmittedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	inquirySubmittedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	inquirySubmittedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	inquirySubmittedAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	inquirySubmittedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	inquirySubmittedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	inquirySubmittedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	inquirySubmittedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	not?: InputMaybe<EnrollmentApplicationHistoryFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<EnrollmentApplicationHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	signatureDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	signatureDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	signatureDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	signatureDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	signatureDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	signatureDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	signatureDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	signatureDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	signatureDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	signatureNameContains?: InputMaybe<Scalars["String"]["input"]>;
	signatureNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	signatureNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	signatureNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	signatureNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	signatureNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	signatureNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	signatureNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	signatureNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	signatureNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	signatureNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	sourceContains?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetailsContains?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetailsEQ?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetailsHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetailsHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetailsIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	sourceDetailsIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	sourceDetailsNEQ?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetailsNotContains?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetailsNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetailsNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetailsNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	sourceEQ?: InputMaybe<Scalars["String"]["input"]>;
	sourceHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	sourceHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	sourceIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	sourceIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	sourceNEQ?: InputMaybe<Scalars["String"]["input"]>;
	sourceNotContains?: InputMaybe<Scalars["String"]["input"]>;
	sourceNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	sourceNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	sourceNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type EnrollmentApplicationHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<EnrollmentApplicationHistoryOrderField>;
};

export enum EnrollmentApplicationHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type EnrollmentApplicationOrder = {
	direction: OrderDirection;
	field?: InputMaybe<EnrollmentApplicationOrderField>;
};

export enum EnrollmentApplicationOrderField {
	ApplicationSubmittedAt = "APPLICATION_SUBMITTED_AT",
	CreatedAt = "CREATED_AT",
	InquirySubmittedAt = "INQUIRY_SUBMITTED_AT",
	SignatureDate = "SIGNATURE_DATE",
}

export type EnrollmentApplicationStudent = Node & {
	__typename?: "EnrollmentApplicationStudent";
	academicYear: AcademicYear;
	academicYearID: Scalars["ID"]["output"];
	classYear: ClassYear;
	classYearID: Scalars["ID"]["output"];
	currentClassYear: Maybe<ClassYear>;
	currentClassYearID: Maybe<Scalars["ID"]["output"]>;
	dateOfBirth: Scalars["Date"]["output"];
	englishLanguageFluency: Maybe<EnrollmentApplicationStudentEnglishLanguageFluency>;
	enrollmentApplication: EnrollmentApplication;
	enrollmentApplicationID: Scalars["ID"]["output"];
	enrollmentApplicationStudentSchools: Array<EnrollmentApplicationStudentSchool>;
	familyName: Scalars["String"]["output"];
	gender: Scalars["String"]["output"];
	givenName: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	imageContentType: Scalars["String"]["output"];
	imageKey: Scalars["String"]["output"];
	imageURL: Scalars["String"]["output"];
	languages: Array<Language>;
	middleName: Scalars["String"]["output"];
	name: Scalars["String"]["output"];
	nameOrder: EnrollmentApplicationStudentNameOrder;
	nationalities: Array<Country>;
	questionnaireActivities: Scalars["String"]["output"];
	questionnaireAdditionalInformation: Scalars["String"]["output"];
	questionnaireBehaviorsDescription: Scalars["String"]["output"];
	questionnaireDescription: Scalars["String"]["output"];
	questionnaireHasBehaviors: Scalars["Boolean"]["output"];
	questionnaireHasPsychTreatment: Scalars["Boolean"]["output"];
	questionnaireHasSpecialNeeds: Scalars["Boolean"]["output"];
	questionnairePsychTreatmentDescription: Scalars["String"]["output"];
	questionnaireSpecialNeedsDescription: Scalars["String"]["output"];
	student: Maybe<Student>;
	studentEnrollmentApplication: Maybe<StudentEnrollmentApplication>;
	studentID: Maybe<Scalars["ID"]["output"]>;
};

export type EnrollmentApplicationStudentEnrollmentApplicationStudentSchoolsArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationStudentSchoolFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationStudentSchoolOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type EnrollmentApplicationStudentLanguagesArgs = {
	filters?: InputMaybe<Array<LanguageFilterInput>>;
	order?: InputMaybe<LanguageOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type EnrollmentApplicationStudentNationalitiesArgs = {
	filters?: InputMaybe<Array<CountryFilterInput>>;
	order?: InputMaybe<CountryOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type EnrollmentApplicationStudentConnection = {
	__typename?: "EnrollmentApplicationStudentConnection";
	edges: Array<EnrollmentApplicationStudentEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type EnrollmentApplicationStudentCountryNationalityHistory = Node & {
	__typename?: "EnrollmentApplicationStudentCountryNationalityHistory";
	countryID: Maybe<Scalars["ID"]["output"]>;
	enrollmentApplicationStudentID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
};

export type EnrollmentApplicationStudentCountryNationalityHistoryConnection = {
	__typename?: "EnrollmentApplicationStudentCountryNationalityHistoryConnection";
	edges: Array<EnrollmentApplicationStudentCountryNationalityHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type EnrollmentApplicationStudentCountryNationalityHistoryEdge = {
	__typename?: "EnrollmentApplicationStudentCountryNationalityHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: EnrollmentApplicationStudentCountryNationalityHistory;
};

export type EnrollmentApplicationStudentCountryNationalityHistoryFilterInput = {
	and?: InputMaybe<Array<EnrollmentApplicationStudentCountryNationalityHistoryFilterInput>>;
	countryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	countryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	countryIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	countryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	countryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationStudentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationStudentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationStudentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<EnrollmentApplicationStudentCountryNationalityHistoryFilterInput>;
	or?: InputMaybe<Array<EnrollmentApplicationStudentCountryNationalityHistoryFilterInput>>;
};

export type EnrollmentApplicationStudentCountryNationalityHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<EnrollmentApplicationStudentCountryNationalityHistoryOrderField>;
};

export enum EnrollmentApplicationStudentCountryNationalityHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type EnrollmentApplicationStudentCreateInput = {
	academicYearID: Scalars["ID"]["input"];
	classYearID: Scalars["ID"]["input"];
	currentClassYearID?: InputMaybe<Scalars["ID"]["input"]>;
	dateOfBirth: Scalars["Date"]["input"];
	englishLanguageFluency?: InputMaybe<EnrollmentApplicationStudentEnglishLanguageFluency>;
	enrollmentApplicationID: Scalars["ID"]["input"];
	enrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentSchools?: InputMaybe<
		Array<EnrollmentApplicationStudentSchoolInEnrollmentApplicationStudentCreateInput>
	>;
	familyName: Scalars["String"]["input"];
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName: Scalars["String"]["input"];
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	languageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<EnrollmentApplicationStudentNameOrder>;
	nationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	questionnaireActivities?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformation?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireHasBehaviors?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasPsychTreatment?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasSpecialNeeds?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnairePsychTreatmentDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescription?: InputMaybe<Scalars["String"]["input"]>;
	studentEnrollmentApplication?: InputMaybe<StudentEnrollmentApplicationInEnrollmentApplicationStudentCreateInput>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EnrollmentApplicationStudentEdge = {
	__typename?: "EnrollmentApplicationStudentEdge";
	cursor: Scalars["Cursor"]["output"];
	node: EnrollmentApplicationStudent;
};

export enum EnrollmentApplicationStudentEnglishLanguageFluency {
	A1 = "a1",
	A2 = "a2",
	B1 = "b1",
	B2 = "b2",
	C1 = "c1",
	C2 = "c2",
	NoKnowledge = "no_knowledge",
}

export type EnrollmentApplicationStudentFilterInput = {
	academicYear?: InputMaybe<Array<AcademicYearFilterInput>>;
	academicYearIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicYearIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	academicYearIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicYearIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	and?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	classYear?: InputMaybe<Array<ClassYearFilterInput>>;
	classYearIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	currentClassYear?: InputMaybe<Array<ClassYearFilterInput>>;
	currentClassYearIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	currentClassYearIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	currentClassYearIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	currentClassYearIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	currentClassYearIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	dateOfBirthEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthGT?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthGTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dateOfBirthLT?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthLTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	englishLanguageFluencyEQ?: InputMaybe<EnrollmentApplicationStudentEnglishLanguageFluency>;
	englishLanguageFluencyIn?: InputMaybe<Array<EnrollmentApplicationStudentEnglishLanguageFluency>>;
	englishLanguageFluencyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	englishLanguageFluencyNEQ?: InputMaybe<EnrollmentApplicationStudentEnglishLanguageFluency>;
	englishLanguageFluencyNotIn?: InputMaybe<Array<EnrollmentApplicationStudentEnglishLanguageFluency>>;
	enrollmentApplication?: InputMaybe<Array<EnrollmentApplicationFilterInput>>;
	enrollmentApplicationIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentSchools?: InputMaybe<Array<EnrollmentApplicationStudentSchoolFilterInput>>;
	familyNameContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	familyNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	genderContains?: InputMaybe<Scalars["String"]["input"]>;
	genderEQ?: InputMaybe<Scalars["String"]["input"]>;
	genderHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	genderHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	genderIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	genderNEQ?: InputMaybe<Scalars["String"]["input"]>;
	genderNotContains?: InputMaybe<Scalars["String"]["input"]>;
	genderNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	genderNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	genderNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	givenNameContains?: InputMaybe<Scalars["String"]["input"]>;
	givenNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	givenNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	givenNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasCurrentClassYear?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasEnrollmentApplicationStudentSchools?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasLanguages?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasNationalities?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentEnrollmentApplication?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	imageContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	languages?: InputMaybe<Array<LanguageFilterInput>>;
	middleNameContains?: InputMaybe<Scalars["String"]["input"]>;
	middleNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	middleNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	middleNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameOrderEQ?: InputMaybe<EnrollmentApplicationStudentNameOrder>;
	nameOrderIn?: InputMaybe<Array<EnrollmentApplicationStudentNameOrder>>;
	nameOrderNEQ?: InputMaybe<EnrollmentApplicationStudentNameOrder>;
	nameOrderNotIn?: InputMaybe<Array<EnrollmentApplicationStudentNameOrder>>;
	nationalities?: InputMaybe<Array<CountryFilterInput>>;
	not?: InputMaybe<EnrollmentApplicationStudentFilterInput>;
	or?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	questionnaireActivitiesContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireActivitiesEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireActivitiesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireActivitiesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireActivitiesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireActivitiesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireActivitiesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireActivitiesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireActivitiesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireActivitiesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireAdditionalInformationContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformationEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformationHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformationHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformationIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireAdditionalInformationNEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformationNotContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformationNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformationNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformationNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireBehaviorsDescriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireBehaviorsDescriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireDescriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireDescriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireHasBehaviorsEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasBehaviorsNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasPsychTreatmentEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasPsychTreatmentNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasSpecialNeedsEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasSpecialNeedsNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnairePsychTreatmentDescriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnairePsychTreatmentDescriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnairePsychTreatmentDescriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnairePsychTreatmentDescriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnairePsychTreatmentDescriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnairePsychTreatmentDescriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnairePsychTreatmentDescriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnairePsychTreatmentDescriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnairePsychTreatmentDescriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnairePsychTreatmentDescriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireSpecialNeedsDescriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireSpecialNeedsDescriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentEnrollmentApplication?: InputMaybe<Array<StudentEnrollmentApplicationFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type EnrollmentApplicationStudentHistory = Node & {
	__typename?: "EnrollmentApplicationStudentHistory";
	academicYearID: Maybe<Scalars["ID"]["output"]>;
	classYearID: Maybe<Scalars["ID"]["output"]>;
	currentClassYearID: Maybe<Scalars["ID"]["output"]>;
	dateOfBirth: Maybe<Scalars["Date"]["output"]>;
	englishLanguageFluency: Maybe<EnrollmentApplicationStudentHistoryEnglishLanguageFluency>;
	enrollmentApplicationID: Maybe<Scalars["ID"]["output"]>;
	familyName: Maybe<Scalars["String"]["output"]>;
	gender: Maybe<Scalars["String"]["output"]>;
	givenName: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	imageContentType: Maybe<Scalars["String"]["output"]>;
	imageKey: Maybe<Scalars["String"]["output"]>;
	middleName: Maybe<Scalars["String"]["output"]>;
	nameOrder: Maybe<EnrollmentApplicationStudentHistoryNameOrder>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	questionnaireActivities: Maybe<Scalars["String"]["output"]>;
	questionnaireAdditionalInformation: Maybe<Scalars["String"]["output"]>;
	questionnaireBehaviorsDescription: Maybe<Scalars["String"]["output"]>;
	questionnaireDescription: Maybe<Scalars["String"]["output"]>;
	questionnaireHasBehaviors: Maybe<Scalars["Boolean"]["output"]>;
	questionnaireHasPsychTreatment: Maybe<Scalars["Boolean"]["output"]>;
	questionnaireHasSpecialNeeds: Maybe<Scalars["Boolean"]["output"]>;
	questionnairePsychTreatmentDescription: Maybe<Scalars["String"]["output"]>;
	questionnaireSpecialNeedsDescription: Maybe<Scalars["String"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
};

export type EnrollmentApplicationStudentHistoryConnection = {
	__typename?: "EnrollmentApplicationStudentHistoryConnection";
	edges: Array<EnrollmentApplicationStudentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type EnrollmentApplicationStudentHistoryEdge = {
	__typename?: "EnrollmentApplicationStudentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: EnrollmentApplicationStudentHistory;
};

export enum EnrollmentApplicationStudentHistoryEnglishLanguageFluency {
	A1 = "a1",
	A2 = "a2",
	B1 = "b1",
	B2 = "b2",
	C1 = "c1",
	C2 = "c2",
	NoKnowledge = "no_knowledge",
}

export type EnrollmentApplicationStudentHistoryFilterInput = {
	academicYearIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicYearIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	academicYearIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	academicYearIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicYearIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	and?: InputMaybe<Array<EnrollmentApplicationStudentHistoryFilterInput>>;
	classYearIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	classYearIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	currentClassYearIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	currentClassYearIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	currentClassYearIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	currentClassYearIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	currentClassYearIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	dateOfBirthEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthGT?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthGTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dateOfBirthIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateOfBirthLT?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthLTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	englishLanguageFluencyEQ?: InputMaybe<EnrollmentApplicationStudentHistoryEnglishLanguageFluency>;
	englishLanguageFluencyIn?: InputMaybe<Array<EnrollmentApplicationStudentHistoryEnglishLanguageFluency>>;
	englishLanguageFluencyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	englishLanguageFluencyNEQ?: InputMaybe<EnrollmentApplicationStudentHistoryEnglishLanguageFluency>;
	englishLanguageFluencyNotIn?: InputMaybe<Array<EnrollmentApplicationStudentHistoryEnglishLanguageFluency>>;
	enrollmentApplicationIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	familyNameContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	familyNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	familyNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	genderContains?: InputMaybe<Scalars["String"]["input"]>;
	genderEQ?: InputMaybe<Scalars["String"]["input"]>;
	genderHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	genderHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	genderIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	genderIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	genderNEQ?: InputMaybe<Scalars["String"]["input"]>;
	genderNotContains?: InputMaybe<Scalars["String"]["input"]>;
	genderNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	genderNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	genderNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	givenNameContains?: InputMaybe<Scalars["String"]["input"]>;
	givenNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	givenNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	givenNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	givenNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	imageContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageContentTypeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	middleNameContains?: InputMaybe<Scalars["String"]["input"]>;
	middleNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	middleNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	middleNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	middleNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameOrderEQ?: InputMaybe<EnrollmentApplicationStudentHistoryNameOrder>;
	nameOrderIn?: InputMaybe<Array<EnrollmentApplicationStudentHistoryNameOrder>>;
	nameOrderIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameOrderNEQ?: InputMaybe<EnrollmentApplicationStudentHistoryNameOrder>;
	nameOrderNotIn?: InputMaybe<Array<EnrollmentApplicationStudentHistoryNameOrder>>;
	not?: InputMaybe<EnrollmentApplicationStudentHistoryFilterInput>;
	or?: InputMaybe<Array<EnrollmentApplicationStudentHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	questionnaireActivitiesContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireActivitiesEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireActivitiesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireActivitiesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireActivitiesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireActivitiesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireActivitiesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireActivitiesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireActivitiesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireActivitiesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireActivitiesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireAdditionalInformationContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformationEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformationHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformationHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformationIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireAdditionalInformationIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireAdditionalInformationNEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformationNotContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformationNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformationNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformationNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireBehaviorsDescriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireBehaviorsDescriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireBehaviorsDescriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireDescriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireDescriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireDescriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireHasBehaviorsEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasBehaviorsIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasBehaviorsNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasPsychTreatmentEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasPsychTreatmentIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasPsychTreatmentNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasSpecialNeedsEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasSpecialNeedsIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasSpecialNeedsNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnairePsychTreatmentDescriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnairePsychTreatmentDescriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnairePsychTreatmentDescriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnairePsychTreatmentDescriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnairePsychTreatmentDescriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnairePsychTreatmentDescriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnairePsychTreatmentDescriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnairePsychTreatmentDescriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnairePsychTreatmentDescriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnairePsychTreatmentDescriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnairePsychTreatmentDescriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireSpecialNeedsDescriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	questionnaireSpecialNeedsDescriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireSpecialNeedsDescriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export enum EnrollmentApplicationStudentHistoryNameOrder {
	FamilyGiven = "family_given",
	GivenFamily = "given_family",
}

export type EnrollmentApplicationStudentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<EnrollmentApplicationStudentHistoryOrderField>;
};

export enum EnrollmentApplicationStudentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type EnrollmentApplicationStudentInAcademicYearCreateInput = {
	classYearID: Scalars["ID"]["input"];
	currentClassYearID?: InputMaybe<Scalars["ID"]["input"]>;
	dateOfBirth: Scalars["Date"]["input"];
	englishLanguageFluency?: InputMaybe<EnrollmentApplicationStudentEnglishLanguageFluency>;
	enrollmentApplicationID: Scalars["ID"]["input"];
	enrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentSchools?: InputMaybe<
		Array<EnrollmentApplicationStudentSchoolInEnrollmentApplicationStudentCreateInput>
	>;
	familyName: Scalars["String"]["input"];
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName: Scalars["String"]["input"];
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	languageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<EnrollmentApplicationStudentNameOrder>;
	nationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	questionnaireActivities?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformation?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireHasBehaviors?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasPsychTreatment?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasSpecialNeeds?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnairePsychTreatmentDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescription?: InputMaybe<Scalars["String"]["input"]>;
	studentEnrollmentApplication?: InputMaybe<StudentEnrollmentApplicationInEnrollmentApplicationStudentCreateInput>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EnrollmentApplicationStudentInClassYearCreateInput = {
	academicYearID: Scalars["ID"]["input"];
	currentClassYearID?: InputMaybe<Scalars["ID"]["input"]>;
	dateOfBirth: Scalars["Date"]["input"];
	englishLanguageFluency?: InputMaybe<EnrollmentApplicationStudentEnglishLanguageFluency>;
	enrollmentApplicationID: Scalars["ID"]["input"];
	enrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentSchools?: InputMaybe<
		Array<EnrollmentApplicationStudentSchoolInEnrollmentApplicationStudentCreateInput>
	>;
	familyName: Scalars["String"]["input"];
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName: Scalars["String"]["input"];
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	languageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<EnrollmentApplicationStudentNameOrder>;
	nationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	questionnaireActivities?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformation?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireHasBehaviors?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasPsychTreatment?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasSpecialNeeds?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnairePsychTreatmentDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescription?: InputMaybe<Scalars["String"]["input"]>;
	studentEnrollmentApplication?: InputMaybe<StudentEnrollmentApplicationInEnrollmentApplicationStudentCreateInput>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EnrollmentApplicationStudentInCurrentClassYearCreateInput = {
	academicYearID: Scalars["ID"]["input"];
	classYearID: Scalars["ID"]["input"];
	dateOfBirth: Scalars["Date"]["input"];
	englishLanguageFluency?: InputMaybe<EnrollmentApplicationStudentEnglishLanguageFluency>;
	enrollmentApplicationID: Scalars["ID"]["input"];
	enrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentSchools?: InputMaybe<
		Array<EnrollmentApplicationStudentSchoolInEnrollmentApplicationStudentCreateInput>
	>;
	familyName: Scalars["String"]["input"];
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName: Scalars["String"]["input"];
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	languageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<EnrollmentApplicationStudentNameOrder>;
	nationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	questionnaireActivities?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformation?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireHasBehaviors?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasPsychTreatment?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasSpecialNeeds?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnairePsychTreatmentDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescription?: InputMaybe<Scalars["String"]["input"]>;
	studentEnrollmentApplication?: InputMaybe<StudentEnrollmentApplicationInEnrollmentApplicationStudentCreateInput>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EnrollmentApplicationStudentInEnrollmentApplicationCreateInput = {
	academicYearID: Scalars["ID"]["input"];
	classYearID: Scalars["ID"]["input"];
	currentClassYearID?: InputMaybe<Scalars["ID"]["input"]>;
	dateOfBirth: Scalars["Date"]["input"];
	englishLanguageFluency?: InputMaybe<EnrollmentApplicationStudentEnglishLanguageFluency>;
	enrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentSchools?: InputMaybe<
		Array<EnrollmentApplicationStudentSchoolInEnrollmentApplicationStudentCreateInput>
	>;
	familyName: Scalars["String"]["input"];
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName: Scalars["String"]["input"];
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	languageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<EnrollmentApplicationStudentNameOrder>;
	nationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	questionnaireActivities?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformation?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireHasBehaviors?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasPsychTreatment?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasSpecialNeeds?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnairePsychTreatmentDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescription?: InputMaybe<Scalars["String"]["input"]>;
	studentEnrollmentApplication?: InputMaybe<StudentEnrollmentApplicationInEnrollmentApplicationStudentCreateInput>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EnrollmentApplicationStudentInStudentCreateInput = {
	academicYearID: Scalars["ID"]["input"];
	classYearID: Scalars["ID"]["input"];
	currentClassYearID?: InputMaybe<Scalars["ID"]["input"]>;
	dateOfBirth: Scalars["Date"]["input"];
	englishLanguageFluency?: InputMaybe<EnrollmentApplicationStudentEnglishLanguageFluency>;
	enrollmentApplicationID: Scalars["ID"]["input"];
	enrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentSchools?: InputMaybe<
		Array<EnrollmentApplicationStudentSchoolInEnrollmentApplicationStudentCreateInput>
	>;
	familyName: Scalars["String"]["input"];
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName: Scalars["String"]["input"];
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	languageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<EnrollmentApplicationStudentNameOrder>;
	nationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	questionnaireActivities?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformation?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireHasBehaviors?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasPsychTreatment?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasSpecialNeeds?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnairePsychTreatmentDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescription?: InputMaybe<Scalars["String"]["input"]>;
	studentEnrollmentApplication?: InputMaybe<StudentEnrollmentApplicationInEnrollmentApplicationStudentCreateInput>;
};

export type EnrollmentApplicationStudentInStudentEnrollmentApplicationCreateInput = {
	academicYearID: Scalars["ID"]["input"];
	classYearID: Scalars["ID"]["input"];
	currentClassYearID?: InputMaybe<Scalars["ID"]["input"]>;
	dateOfBirth: Scalars["Date"]["input"];
	englishLanguageFluency?: InputMaybe<EnrollmentApplicationStudentEnglishLanguageFluency>;
	enrollmentApplicationID: Scalars["ID"]["input"];
	enrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentSchools?: InputMaybe<
		Array<EnrollmentApplicationStudentSchoolInEnrollmentApplicationStudentCreateInput>
	>;
	familyName: Scalars["String"]["input"];
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName: Scalars["String"]["input"];
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	languageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<EnrollmentApplicationStudentNameOrder>;
	nationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	questionnaireActivities?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformation?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireHasBehaviors?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasPsychTreatment?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasSpecialNeeds?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnairePsychTreatmentDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescription?: InputMaybe<Scalars["String"]["input"]>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EnrollmentApplicationStudentLanguageHistory = Node & {
	__typename?: "EnrollmentApplicationStudentLanguageHistory";
	enrollmentApplicationStudentID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	languageID: Maybe<Scalars["ID"]["output"]>;
};

export type EnrollmentApplicationStudentLanguageHistoryConnection = {
	__typename?: "EnrollmentApplicationStudentLanguageHistoryConnection";
	edges: Array<EnrollmentApplicationStudentLanguageHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type EnrollmentApplicationStudentLanguageHistoryEdge = {
	__typename?: "EnrollmentApplicationStudentLanguageHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: EnrollmentApplicationStudentLanguageHistory;
};

export type EnrollmentApplicationStudentLanguageHistoryFilterInput = {
	and?: InputMaybe<Array<EnrollmentApplicationStudentLanguageHistoryFilterInput>>;
	enrollmentApplicationStudentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationStudentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationStudentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationStudentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	languageIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	languageIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	languageIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	languageIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	languageIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<EnrollmentApplicationStudentLanguageHistoryFilterInput>;
	or?: InputMaybe<Array<EnrollmentApplicationStudentLanguageHistoryFilterInput>>;
};

export type EnrollmentApplicationStudentLanguageHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<EnrollmentApplicationStudentLanguageHistoryOrderField>;
};

export enum EnrollmentApplicationStudentLanguageHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export enum EnrollmentApplicationStudentNameOrder {
	FamilyGiven = "family_given",
	GivenFamily = "given_family",
}

export type EnrollmentApplicationStudentOrder = {
	direction: OrderDirection;
	field?: InputMaybe<EnrollmentApplicationStudentOrderField>;
};

export enum EnrollmentApplicationStudentOrderField {
	DateOfBirth = "DATE_OF_BIRTH",
	FamilyName = "FAMILY_NAME",
	GivenName = "GIVEN_NAME",
}

export type EnrollmentApplicationStudentSchool = Node & {
	__typename?: "EnrollmentApplicationStudentSchool";
	city: Scalars["String"]["output"];
	country: Country;
	countryID: Scalars["ID"]["output"];
	endDate: Scalars["Date"]["output"];
	enrollmentApplicationStudent: EnrollmentApplicationStudent;
	enrollmentApplicationStudentID: Scalars["ID"]["output"];
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
	startDate: Scalars["Date"]["output"];
};

export type EnrollmentApplicationStudentSchoolConnection = {
	__typename?: "EnrollmentApplicationStudentSchoolConnection";
	edges: Array<EnrollmentApplicationStudentSchoolEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type EnrollmentApplicationStudentSchoolCreateInput = {
	city: Scalars["String"]["input"];
	countryID: Scalars["ID"]["input"];
	endDate: Scalars["Date"]["input"];
	enrollmentApplicationStudentID: Scalars["ID"]["input"];
	name: Scalars["String"]["input"];
	startDate: Scalars["Date"]["input"];
};

export type EnrollmentApplicationStudentSchoolEdge = {
	__typename?: "EnrollmentApplicationStudentSchoolEdge";
	cursor: Scalars["Cursor"]["output"];
	node: EnrollmentApplicationStudentSchool;
};

export type EnrollmentApplicationStudentSchoolFilterInput = {
	and?: InputMaybe<Array<EnrollmentApplicationStudentSchoolFilterInput>>;
	cityContains?: InputMaybe<Scalars["String"]["input"]>;
	cityEQ?: InputMaybe<Scalars["String"]["input"]>;
	cityHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	cityHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	cityIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	cityNEQ?: InputMaybe<Scalars["String"]["input"]>;
	cityNotContains?: InputMaybe<Scalars["String"]["input"]>;
	cityNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	cityNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	cityNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	country?: InputMaybe<Array<CountryFilterInput>>;
	countryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	countryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	countryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	countryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	endDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	endDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	endDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	endDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	endDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	endDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	endDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	endDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	enrollmentApplicationStudent?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	enrollmentApplicationStudentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationStudentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationStudentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<EnrollmentApplicationStudentSchoolFilterInput>;
	or?: InputMaybe<Array<EnrollmentApplicationStudentSchoolFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	startDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	startDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	startDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	startDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	startDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	startDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	startDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	startDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
};

export type EnrollmentApplicationStudentSchoolInCountryCreateInput = {
	city: Scalars["String"]["input"];
	endDate: Scalars["Date"]["input"];
	enrollmentApplicationStudentID: Scalars["ID"]["input"];
	name: Scalars["String"]["input"];
	startDate: Scalars["Date"]["input"];
};

export type EnrollmentApplicationStudentSchoolInEnrollmentApplicationStudentCreateInput = {
	city: Scalars["String"]["input"];
	countryID: Scalars["ID"]["input"];
	endDate: Scalars["Date"]["input"];
	name: Scalars["String"]["input"];
	startDate: Scalars["Date"]["input"];
};

export type EnrollmentApplicationStudentSchoolOrder = {
	direction: OrderDirection;
	field?: InputMaybe<EnrollmentApplicationStudentSchoolOrderField>;
};

export enum EnrollmentApplicationStudentSchoolOrderField {
	StartDate = "START_DATE",
}

export type EnrollmentApplicationStudentSchoolUpdateBulkInput = {
	city?: InputMaybe<Scalars["String"]["input"]>;
	countryID?: InputMaybe<Scalars["ID"]["input"]>;
	endDate?: InputMaybe<Scalars["Date"]["input"]>;
	enrollmentApplicationStudentID?: InputMaybe<Scalars["ID"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	startDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type EnrollmentApplicationStudentSchoolUpdateInput = {
	city?: InputMaybe<Scalars["String"]["input"]>;
	countryID?: InputMaybe<Scalars["ID"]["input"]>;
	endDate?: InputMaybe<Scalars["Date"]["input"]>;
	enrollmentApplicationStudentID?: InputMaybe<Scalars["ID"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	startDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type EnrollmentApplicationStudentUpdateBulkInput = {
	academicYearID?: InputMaybe<Scalars["ID"]["input"]>;
	addEnrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addLanguageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addNationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearID?: InputMaybe<Scalars["ID"]["input"]>;
	clearCurrentClassYear?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEnglishLanguageFluency?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEnrollmentApplicationStudentSchools?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearLanguages?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearNationalities?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	currentClassYearID?: InputMaybe<Scalars["ID"]["input"]>;
	dateOfBirth?: InputMaybe<Scalars["Date"]["input"]>;
	englishLanguageFluency?: InputMaybe<EnrollmentApplicationStudentEnglishLanguageFluency>;
	enrollmentApplicationID?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	familyName?: InputMaybe<Scalars["String"]["input"]>;
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName?: InputMaybe<Scalars["String"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	languageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<EnrollmentApplicationStudentNameOrder>;
	nationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	questionnaireActivities?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformation?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireHasBehaviors?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasPsychTreatment?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasSpecialNeeds?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnairePsychTreatmentDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescription?: InputMaybe<Scalars["String"]["input"]>;
	removeEnrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeLanguageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeNationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EnrollmentApplicationStudentUpdateInput = {
	academicYearID?: InputMaybe<Scalars["ID"]["input"]>;
	addEnrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addLanguageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addNationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearID?: InputMaybe<Scalars["ID"]["input"]>;
	clearCurrentClassYear?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEnglishLanguageFluency?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEnrollmentApplicationStudentSchools?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearLanguages?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearNationalities?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	currentClassYearID?: InputMaybe<Scalars["ID"]["input"]>;
	dateOfBirth?: InputMaybe<Scalars["Date"]["input"]>;
	englishLanguageFluency?: InputMaybe<EnrollmentApplicationStudentEnglishLanguageFluency>;
	enrollmentApplicationID?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	familyName?: InputMaybe<Scalars["String"]["input"]>;
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName?: InputMaybe<Scalars["String"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	languageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<EnrollmentApplicationStudentNameOrder>;
	nationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	questionnaireActivities?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireAdditionalInformation?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireBehaviorsDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireHasBehaviors?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasPsychTreatment?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnaireHasSpecialNeeds?: InputMaybe<Scalars["Boolean"]["input"]>;
	questionnairePsychTreatmentDescription?: InputMaybe<Scalars["String"]["input"]>;
	questionnaireSpecialNeedsDescription?: InputMaybe<Scalars["String"]["input"]>;
	removeEnrollmentApplicationStudentSchoolIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeLanguageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeNationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EnrollmentApplicationUpdateBulkInput = {
	addEnrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearEnrollmentApplicationGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSignatureDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToCorrespondence?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToDataProtectionPolicy?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToDataUse?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	removeEnrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	signatureDate?: InputMaybe<Scalars["Date"]["input"]>;
	signatureName?: InputMaybe<Scalars["String"]["input"]>;
	source?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetails?: InputMaybe<Scalars["String"]["input"]>;
};

export type EnrollmentApplicationUpdateInput = {
	addEnrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearEnrollmentApplicationGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSignatureDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToCorrespondence?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToDataProtectionPolicy?: InputMaybe<Scalars["Boolean"]["input"]>;
	doesConsentToDataUse?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	removeEnrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	signatureDate?: InputMaybe<Scalars["Date"]["input"]>;
	signatureName?: InputMaybe<Scalars["String"]["input"]>;
	source?: InputMaybe<Scalars["String"]["input"]>;
	sourceDetails?: InputMaybe<Scalars["String"]["input"]>;
};

export type Guardian = Node & {
	__typename?: "Guardian";
	enrollmentApplicationGuardians: Array<EnrollmentApplicationGuardian>;
	id: Scalars["ID"]["output"];
	payments: Array<Payment>;
	person: Person;
	personID: Scalars["ID"]["output"];
	relationshipStatus: Maybe<GuardianRelationshipStatus>;
	relationships: Array<Relationship>;
	studentInformationVerifications: Array<StudentInformationVerification>;
};

export type GuardianEnrollmentApplicationGuardiansArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationGuardianOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type GuardianPaymentsArgs = {
	filters?: InputMaybe<Array<PaymentFilterInput>>;
	order?: InputMaybe<PaymentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type GuardianRelationshipsArgs = {
	filters?: InputMaybe<Array<RelationshipFilterInput>>;
	order?: InputMaybe<RelationshipOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type GuardianStudentInformationVerificationsArgs = {
	filters?: InputMaybe<Array<StudentInformationVerificationFilterInput>>;
	order?: InputMaybe<StudentInformationVerificationOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type GuardianConnection = {
	__typename?: "GuardianConnection";
	edges: Array<GuardianEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type GuardianCreateInput = {
	enrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationGuardians?: InputMaybe<Array<EnrollmentApplicationGuardianInGuardianCreateInput>>;
	paymentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	payments?: InputMaybe<Array<PaymentInGuardianPayerCreateInput>>;
	person?: InputMaybe<PersonInGuardianCreateInput>;
	personID?: InputMaybe<Scalars["ID"]["input"]>;
	relationshipIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	relationshipStatus?: InputMaybe<GuardianRelationshipStatus>;
	relationships?: InputMaybe<Array<RelationshipInGuardianCreateInput>>;
	studentInformationVerificationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type GuardianEdge = {
	__typename?: "GuardianEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Guardian;
};

export type GuardianFilterInput = {
	and?: InputMaybe<Array<GuardianFilterInput>>;
	enrollmentApplicationGuardians?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput>>;
	hasEnrollmentApplicationGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPayments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasRelationships?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentInformationVerifications?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<GuardianFilterInput>;
	or?: InputMaybe<Array<GuardianFilterInput>>;
	payments?: InputMaybe<Array<PaymentFilterInput>>;
	person?: InputMaybe<Array<PersonFilterInput>>;
	personIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	relationshipStatusEQ?: InputMaybe<GuardianRelationshipStatus>;
	relationshipStatusIn?: InputMaybe<Array<GuardianRelationshipStatus>>;
	relationshipStatusIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	relationshipStatusNEQ?: InputMaybe<GuardianRelationshipStatus>;
	relationshipStatusNotIn?: InputMaybe<Array<GuardianRelationshipStatus>>;
	relationships?: InputMaybe<Array<RelationshipFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentInformationVerifications?: InputMaybe<Array<StudentInformationVerificationFilterInput>>;
};

export type GuardianHistory = Node & {
	__typename?: "GuardianHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
	personID: Maybe<Scalars["ID"]["output"]>;
	relationshipStatus: Maybe<GuardianHistoryRelationshipStatus>;
};

export type GuardianHistoryConnection = {
	__typename?: "GuardianHistoryConnection";
	edges: Array<GuardianHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type GuardianHistoryEdge = {
	__typename?: "GuardianHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: GuardianHistory;
};

export type GuardianHistoryFilterInput = {
	and?: InputMaybe<Array<GuardianHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<GuardianHistoryFilterInput>;
	or?: InputMaybe<Array<GuardianHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	personIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	relationshipStatusEQ?: InputMaybe<GuardianHistoryRelationshipStatus>;
	relationshipStatusIn?: InputMaybe<Array<GuardianHistoryRelationshipStatus>>;
	relationshipStatusIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	relationshipStatusNEQ?: InputMaybe<GuardianHistoryRelationshipStatus>;
	relationshipStatusNotIn?: InputMaybe<Array<GuardianHistoryRelationshipStatus>>;
};

export type GuardianHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<GuardianHistoryOrderField>;
};

export enum GuardianHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export enum GuardianHistoryRelationshipStatus {
	Married = "married",
	Remarried = "remarried",
	SeparatedOrDivorced = "separated_or_divorced",
	Single = "single",
	TogetherButNotMarried = "together_but_not_married",
	Widowed = "widowed",
}

export type GuardianInPersonCreateInput = {
	enrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationGuardians?: InputMaybe<Array<EnrollmentApplicationGuardianInGuardianCreateInput>>;
	paymentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	payments?: InputMaybe<Array<PaymentInGuardianPayerCreateInput>>;
	relationshipIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	relationshipStatus?: InputMaybe<GuardianRelationshipStatus>;
	relationships?: InputMaybe<Array<RelationshipInGuardianCreateInput>>;
	studentInformationVerificationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type GuardianOrder = {
	direction: OrderDirection;
};

export enum GuardianRelationshipStatus {
	Married = "married",
	Remarried = "remarried",
	SeparatedOrDivorced = "separated_or_divorced",
	Single = "single",
	TogetherButNotMarried = "together_but_not_married",
	Widowed = "widowed",
}

export type GuardianUpdateBulkInput = {
	addEnrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addPaymentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addRelationshipIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentInformationVerificationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearEnrollmentApplicationGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearPayments?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearRelationshipStatus?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearRelationships?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentInformationVerifications?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	paymentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	relationshipIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	relationshipStatus?: InputMaybe<GuardianRelationshipStatus>;
	removeEnrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePaymentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeRelationshipIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentInformationVerificationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentInformationVerificationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type GuardianUpdateInput = {
	addEnrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addPaymentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addRelationshipIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentInformationVerificationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearEnrollmentApplicationGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearPayments?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearRelationshipStatus?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearRelationships?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentInformationVerifications?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	paymentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personID?: InputMaybe<Scalars["ID"]["input"]>;
	relationshipIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	relationshipStatus?: InputMaybe<GuardianRelationshipStatus>;
	removeEnrollmentApplicationGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePaymentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeRelationshipIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentInformationVerificationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentInformationVerificationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export enum HistoryType {
	Create = "create",
	Delete = "delete",
	Update = "update",
}

export type HomeRoom = Node & {
	__typename?: "HomeRoom";
	classYear: ClassYear;
	classYearID: Scalars["ID"]["output"];
	description: Scalars["String"]["output"];
	homeRoomSections: Array<HomeRoomSection>;
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
};

export type HomeRoomHomeRoomSectionsArgs = {
	filters?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
	order?: InputMaybe<HomeRoomSectionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type HomeRoomConnection = {
	__typename?: "HomeRoomConnection";
	edges: Array<HomeRoomEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type HomeRoomCreateInput = {
	classYearID: Scalars["ID"]["input"];
	description?: InputMaybe<Scalars["String"]["input"]>;
	homeRoomSections?: InputMaybe<Array<HomeRoomSectionInHomeRoomCreateInput>>;
	name: Scalars["String"]["input"];
};

export type HomeRoomEdge = {
	__typename?: "HomeRoomEdge";
	cursor: Scalars["Cursor"]["output"];
	node: HomeRoom;
};

export type HomeRoomFilterInput = {
	and?: InputMaybe<Array<HomeRoomFilterInput>>;
	classYear?: InputMaybe<Array<ClassYearFilterInput>>;
	classYearIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasHomeRoomSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoomSections?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<HomeRoomFilterInput>;
	or?: InputMaybe<Array<HomeRoomFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type HomeRoomHistory = Node & {
	__typename?: "HomeRoomHistory";
	classYearID: Maybe<Scalars["ID"]["output"]>;
	description: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type HomeRoomHistoryConnection = {
	__typename?: "HomeRoomHistoryConnection";
	edges: Array<HomeRoomHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type HomeRoomHistoryEdge = {
	__typename?: "HomeRoomHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: HomeRoomHistory;
};

export type HomeRoomHistoryFilterInput = {
	and?: InputMaybe<Array<HomeRoomHistoryFilterInput>>;
	classYearIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	classYearIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<HomeRoomHistoryFilterInput>;
	or?: InputMaybe<Array<HomeRoomHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type HomeRoomHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<HomeRoomHistoryOrderField>;
};

export enum HomeRoomHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type HomeRoomInClassYearCreateInput = {
	description?: InputMaybe<Scalars["String"]["input"]>;
	homeRoomSections?: InputMaybe<Array<HomeRoomSectionInHomeRoomCreateInput>>;
	name: Scalars["String"]["input"];
};

export type HomeRoomOrder = {
	direction: OrderDirection;
	field?: InputMaybe<HomeRoomOrderField>;
};

export enum HomeRoomOrderField {
	Name = "NAME",
}

export type HomeRoomSection = Node & {
	__typename?: "HomeRoomSection";
	academicTerm: AcademicTerm;
	academicTermID: Scalars["ID"]["output"];
	courseSections: Array<CourseSection>;
	homeRoom: HomeRoom;
	homeRoomID: Scalars["ID"]["output"];
	id: Scalars["ID"]["output"];
	namePrefix: Scalars["String"]["output"];
	nameSuffix: Scalars["String"]["output"];
	reportCardSectionPolicies: Array<ReportCardSectionPolicy>;
	room: Maybe<Room>;
	roomID: Maybe<Scalars["ID"]["output"]>;
	sharingRecords: Array<SharingRecord>;
	studentHomeRoomSectionEnrollments: Array<StudentHomeRoomSectionEnrollment>;
	teacherHomeRoomSectionEnrollments: Array<TeacherHomeRoomSectionEnrollment>;
	userGroups: Array<UserGroup>;
};

export type HomeRoomSectionCourseSectionsArgs = {
	filters?: InputMaybe<Array<CourseSectionFilterInput>>;
	order?: InputMaybe<CourseSectionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type HomeRoomSectionReportCardSectionPoliciesArgs = {
	filters?: InputMaybe<Array<ReportCardSectionPolicyFilterInput>>;
	order?: InputMaybe<ReportCardSectionPolicyOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type HomeRoomSectionSharingRecordsArgs = {
	filters?: InputMaybe<Array<SharingRecordFilterInput>>;
	order?: InputMaybe<SharingRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type HomeRoomSectionStudentHomeRoomSectionEnrollmentsArgs = {
	filters?: InputMaybe<Array<StudentHomeRoomSectionEnrollmentFilterInput>>;
	order?: InputMaybe<StudentHomeRoomSectionEnrollmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type HomeRoomSectionTeacherHomeRoomSectionEnrollmentsArgs = {
	filters?: InputMaybe<Array<TeacherHomeRoomSectionEnrollmentFilterInput>>;
	order?: InputMaybe<TeacherHomeRoomSectionEnrollmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type HomeRoomSectionUserGroupsArgs = {
	filters?: InputMaybe<Array<UserGroupFilterInput>>;
	order?: InputMaybe<UserGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type HomeRoomSectionAttendanceRecordCountStatistics = {
	__typename?: "HomeRoomSectionAttendanceRecordCountStatistics";
	attendanceRecordCountStatistics: AttendanceRecordCountStatistics;
	homeRoomSection: HomeRoomSectionInAttendanceRecordStatistics;
};

export type HomeRoomSectionConnection = {
	__typename?: "HomeRoomSectionConnection";
	edges: Array<HomeRoomSectionEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type HomeRoomSectionCreateInput = {
	academicTermID: Scalars["ID"]["input"];
	courseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSections?: InputMaybe<Array<CourseSectionInHomeRoomSectionCreateInput>>;
	homeRoomID: Scalars["ID"]["input"];
	namePrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffix?: InputMaybe<Scalars["String"]["input"]>;
	reportCardSectionPolicies?: InputMaybe<Array<ReportCardSectionPolicyInHomeRoomSectionCreateInput>>;
	roomID?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentHomeRoomSectionEnrollments?: InputMaybe<Array<StudentHomeRoomSectionEnrollmentInHomeRoomSectionCreateInput>>;
	teacherHomeRoomSectionEnrollments?: InputMaybe<Array<TeacherHomeRoomSectionEnrollmentInHomeRoomSectionCreateInput>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type HomeRoomSectionEdge = {
	__typename?: "HomeRoomSectionEdge";
	cursor: Scalars["Cursor"]["output"];
	node: HomeRoomSection;
};

export type HomeRoomSectionFilterInput = {
	academicTerm?: InputMaybe<Array<AcademicTermFilterInput>>;
	academicTermIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicTermIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	academicTermIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicTermIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	and?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
	courseSections?: InputMaybe<Array<CourseSectionFilterInput>>;
	hasCourseSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasReportCardSectionPolicies?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasRoom?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentHomeRoomSectionEnrollments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasTeacherHomeRoomSectionEnrollments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoom?: InputMaybe<Array<HomeRoomFilterInput>>;
	homeRoomIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	namePrefixContains?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixEQ?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	namePrefixNEQ?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixNotContains?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameSuffixContains?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameSuffixNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<HomeRoomSectionFilterInput>;
	or?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
	reportCardSectionPolicies?: InputMaybe<Array<ReportCardSectionPolicyFilterInput>>;
	room?: InputMaybe<Array<RoomFilterInput>>;
	roomIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	roomIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	roomIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	roomIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	roomIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	sharingRecords?: InputMaybe<Array<SharingRecordFilterInput>>;
	studentHomeRoomSectionEnrollments?: InputMaybe<Array<StudentHomeRoomSectionEnrollmentFilterInput>>;
	teacherHomeRoomSectionEnrollments?: InputMaybe<Array<TeacherHomeRoomSectionEnrollmentFilterInput>>;
	userGroups?: InputMaybe<Array<UserGroupFilterInput>>;
};

export type HomeRoomSectionHistory = Node & {
	__typename?: "HomeRoomSectionHistory";
	academicTermID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	homeRoomID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	namePrefix: Maybe<Scalars["String"]["output"]>;
	nameSuffix: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	roomID: Maybe<Scalars["ID"]["output"]>;
};

export type HomeRoomSectionHistoryConnection = {
	__typename?: "HomeRoomSectionHistoryConnection";
	edges: Array<HomeRoomSectionHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type HomeRoomSectionHistoryEdge = {
	__typename?: "HomeRoomSectionHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: HomeRoomSectionHistory;
};

export type HomeRoomSectionHistoryFilterInput = {
	academicTermIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicTermIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	academicTermIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	academicTermIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicTermIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	and?: InputMaybe<Array<HomeRoomSectionHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoomIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	namePrefixContains?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixEQ?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	namePrefixIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	namePrefixNEQ?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixNotContains?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	namePrefixNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameSuffixContains?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameSuffixIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameSuffixNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<HomeRoomSectionHistoryFilterInput>;
	or?: InputMaybe<Array<HomeRoomSectionHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	roomIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	roomIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	roomIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	roomIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	roomIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type HomeRoomSectionHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<HomeRoomSectionHistoryOrderField>;
};

export enum HomeRoomSectionHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type HomeRoomSectionInAcademicTermCreateInput = {
	courseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSections?: InputMaybe<Array<CourseSectionInHomeRoomSectionCreateInput>>;
	homeRoomID: Scalars["ID"]["input"];
	namePrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffix?: InputMaybe<Scalars["String"]["input"]>;
	reportCardSectionPolicies?: InputMaybe<Array<ReportCardSectionPolicyInHomeRoomSectionCreateInput>>;
	roomID?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentHomeRoomSectionEnrollments?: InputMaybe<Array<StudentHomeRoomSectionEnrollmentInHomeRoomSectionCreateInput>>;
	teacherHomeRoomSectionEnrollments?: InputMaybe<Array<TeacherHomeRoomSectionEnrollmentInHomeRoomSectionCreateInput>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type HomeRoomSectionInAttendanceRecordStatistics = {
	__typename?: "HomeRoomSectionInAttendanceRecordStatistics";
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
};

export type HomeRoomSectionInHomeRoomCreateInput = {
	academicTermID: Scalars["ID"]["input"];
	courseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSections?: InputMaybe<Array<CourseSectionInHomeRoomSectionCreateInput>>;
	namePrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffix?: InputMaybe<Scalars["String"]["input"]>;
	reportCardSectionPolicies?: InputMaybe<Array<ReportCardSectionPolicyInHomeRoomSectionCreateInput>>;
	roomID?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentHomeRoomSectionEnrollments?: InputMaybe<Array<StudentHomeRoomSectionEnrollmentInHomeRoomSectionCreateInput>>;
	teacherHomeRoomSectionEnrollments?: InputMaybe<Array<TeacherHomeRoomSectionEnrollmentInHomeRoomSectionCreateInput>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type HomeRoomSectionInRoomCreateInput = {
	academicTermID: Scalars["ID"]["input"];
	courseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSections?: InputMaybe<Array<CourseSectionInHomeRoomSectionCreateInput>>;
	homeRoomID: Scalars["ID"]["input"];
	namePrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffix?: InputMaybe<Scalars["String"]["input"]>;
	reportCardSectionPolicies?: InputMaybe<Array<ReportCardSectionPolicyInHomeRoomSectionCreateInput>>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentHomeRoomSectionEnrollments?: InputMaybe<Array<StudentHomeRoomSectionEnrollmentInHomeRoomSectionCreateInput>>;
	teacherHomeRoomSectionEnrollments?: InputMaybe<Array<TeacherHomeRoomSectionEnrollmentInHomeRoomSectionCreateInput>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type HomeRoomSectionOrder = {
	direction: OrderDirection;
	field?: InputMaybe<HomeRoomSectionOrderField>;
};

export enum HomeRoomSectionOrderField {
	NamePrefix = "NAME_PREFIX",
	NameSuffix = "NAME_SUFFIX",
}

export type HomeRoomSectionUpdateBulkInput = {
	addCourseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearCourseSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearRoom?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	namePrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffix?: InputMaybe<Scalars["String"]["input"]>;
	removeCourseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	roomID?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type HomeRoomSectionUpdateInput = {
	addCourseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearCourseSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearRoom?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	namePrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffix?: InputMaybe<Scalars["String"]["input"]>;
	removeCourseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	roomID?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type HomeRoomUpdateBulkInput = {
	classYearID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
};

export type HomeRoomUpdateInput = {
	classYearID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
};

export type IndividualReportCardCompletionProgressStatistics = {
	__typename?: "IndividualReportCardCompletionProgressStatistics";
	completionPercentage: Scalars["Float"]["output"];
	id: Scalars["ID"]["output"];
	isComplete: Scalars["Boolean"]["output"];
	isReady: Scalars["Boolean"]["output"];
};

export type Invoice = Node & {
	__typename?: "Invoice";
	billingAdjustments: Array<BillingAdjustment>;
	contractInstallment: ContractInstallment;
	contractInstallmentID: Scalars["ID"]["output"];
	description: Scalars["String"]["output"];
	dueDate: Scalars["Date"]["output"];
	id: Scalars["ID"]["output"];
	invoiceLineItems: Array<InvoiceLineItem>;
	issueDate: Scalars["Date"]["output"];
	name: Scalars["String"]["output"];
	paymentLineItems: Array<PaymentLineItem>;
	status: InvoiceStatus;
};

export type InvoiceBillingAdjustmentsArgs = {
	filters?: InputMaybe<Array<BillingAdjustmentFilterInput>>;
	order?: InputMaybe<BillingAdjustmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type InvoiceInvoiceLineItemsArgs = {
	filters?: InputMaybe<Array<InvoiceLineItemFilterInput>>;
	order?: InputMaybe<InvoiceLineItemOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type InvoicePaymentLineItemsArgs = {
	filters?: InputMaybe<Array<PaymentLineItemFilterInput>>;
	order?: InputMaybe<PaymentLineItemOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type InvoiceConnection = {
	__typename?: "InvoiceConnection";
	edges: Array<InvoiceEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type InvoiceCreateInput = {
	billingAdjustments?: InputMaybe<Array<BillingAdjustmentInInvoiceCreateInput>>;
	contractInstallmentID: Scalars["ID"]["input"];
	description?: InputMaybe<Scalars["String"]["input"]>;
	dueDate: Scalars["Date"]["input"];
	invoiceLineItems?: InputMaybe<Array<InvoiceLineItemInInvoiceCreateInput>>;
	issueDate: Scalars["Date"]["input"];
	name: Scalars["String"]["input"];
	paymentLineItems?: InputMaybe<Array<PaymentLineItemInInvoiceCreateInput>>;
	status?: InputMaybe<InvoiceStatus>;
};

export type InvoiceEdge = {
	__typename?: "InvoiceEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Invoice;
};

export type InvoiceFilterInput = {
	and?: InputMaybe<Array<InvoiceFilterInput>>;
	billingAdjustments?: InputMaybe<Array<BillingAdjustmentFilterInput>>;
	contractInstallment?: InputMaybe<Array<ContractInstallmentFilterInput>>;
	contractInstallmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	contractInstallmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	contractInstallmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	contractInstallmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	dueDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dueDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	hasBillingAdjustments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasInvoiceLineItems?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPaymentLineItems?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	invoiceLineItems?: InputMaybe<Array<InvoiceLineItemFilterInput>>;
	issueDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	issueDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<InvoiceFilterInput>;
	or?: InputMaybe<Array<InvoiceFilterInput>>;
	paymentLineItems?: InputMaybe<Array<PaymentLineItemFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	statusEQ?: InputMaybe<InvoiceStatus>;
	statusIn?: InputMaybe<Array<InvoiceStatus>>;
	statusNEQ?: InputMaybe<InvoiceStatus>;
	statusNotIn?: InputMaybe<Array<InvoiceStatus>>;
};

export type InvoiceHistory = Node & {
	__typename?: "InvoiceHistory";
	contractInstallmentID: Maybe<Scalars["ID"]["output"]>;
	description: Maybe<Scalars["String"]["output"]>;
	dueDate: Maybe<Scalars["Date"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	issueDate: Maybe<Scalars["Date"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	status: Maybe<InvoiceHistoryStatus>;
};

export type InvoiceHistoryConnection = {
	__typename?: "InvoiceHistoryConnection";
	edges: Array<InvoiceHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type InvoiceHistoryEdge = {
	__typename?: "InvoiceHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: InvoiceHistory;
};

export type InvoiceHistoryFilterInput = {
	and?: InputMaybe<Array<InvoiceHistoryFilterInput>>;
	contractInstallmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	contractInstallmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	contractInstallmentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	contractInstallmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	contractInstallmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	dueDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dueDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dueDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dueDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	issueDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	issueDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<InvoiceHistoryFilterInput>;
	or?: InputMaybe<Array<InvoiceHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	statusEQ?: InputMaybe<InvoiceHistoryStatus>;
	statusIn?: InputMaybe<Array<InvoiceHistoryStatus>>;
	statusIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	statusNEQ?: InputMaybe<InvoiceHistoryStatus>;
	statusNotIn?: InputMaybe<Array<InvoiceHistoryStatus>>;
};

export type InvoiceHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<InvoiceHistoryOrderField>;
};

export enum InvoiceHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export enum InvoiceHistoryStatus {
	Draft = "draft",
	Issued = "issued",
	Void = "void",
}

export type InvoiceInContractInstallmentCreateInput = {
	billingAdjustments?: InputMaybe<Array<BillingAdjustmentInInvoiceCreateInput>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	dueDate: Scalars["Date"]["input"];
	invoiceLineItems?: InputMaybe<Array<InvoiceLineItemInInvoiceCreateInput>>;
	issueDate: Scalars["Date"]["input"];
	name: Scalars["String"]["input"];
	paymentLineItems?: InputMaybe<Array<PaymentLineItemInInvoiceCreateInput>>;
	status?: InputMaybe<InvoiceStatus>;
};

export type InvoiceLineItem = Node & {
	__typename?: "InvoiceLineItem";
	amount: Scalars["Int"]["output"];
	contractLineItem: ContractLineItem;
	contractLineItemID: Scalars["ID"]["output"];
	displayOrder: Scalars["Int"]["output"];
	id: Scalars["ID"]["output"];
	invoice: Invoice;
	invoiceID: Scalars["ID"]["output"];
};

export type InvoiceLineItemConnection = {
	__typename?: "InvoiceLineItemConnection";
	edges: Array<InvoiceLineItemEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type InvoiceLineItemCreateInput = {
	amount: Scalars["Int"]["input"];
	contractLineItemID: Scalars["ID"]["input"];
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	invoiceID: Scalars["ID"]["input"];
};

export type InvoiceLineItemEdge = {
	__typename?: "InvoiceLineItemEdge";
	cursor: Scalars["Cursor"]["output"];
	node: InvoiceLineItem;
};

export type InvoiceLineItemFilterInput = {
	amountEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountGT?: InputMaybe<Scalars["Int"]["input"]>;
	amountGTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	amountLT?: InputMaybe<Scalars["Int"]["input"]>;
	amountLTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	and?: InputMaybe<Array<InvoiceLineItemFilterInput>>;
	contractLineItem?: InputMaybe<Array<ContractLineItemFilterInput>>;
	contractLineItemIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	contractLineItemIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	contractLineItemIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	contractLineItemIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	displayOrderEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	displayOrderLT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderLTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	invoice?: InputMaybe<Array<InvoiceFilterInput>>;
	invoiceIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	invoiceIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	invoiceIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	invoiceIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<InvoiceLineItemFilterInput>;
	or?: InputMaybe<Array<InvoiceLineItemFilterInput>>;
};

export type InvoiceLineItemHistory = Node & {
	__typename?: "InvoiceLineItemHistory";
	amount: Maybe<Scalars["Int"]["output"]>;
	contractLineItemID: Maybe<Scalars["ID"]["output"]>;
	displayOrder: Maybe<Scalars["Int"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	invoiceID: Maybe<Scalars["ID"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type InvoiceLineItemHistoryConnection = {
	__typename?: "InvoiceLineItemHistoryConnection";
	edges: Array<InvoiceLineItemHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type InvoiceLineItemHistoryEdge = {
	__typename?: "InvoiceLineItemHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: InvoiceLineItemHistory;
};

export type InvoiceLineItemHistoryFilterInput = {
	amountEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountGT?: InputMaybe<Scalars["Int"]["input"]>;
	amountGTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	amountIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	amountLT?: InputMaybe<Scalars["Int"]["input"]>;
	amountLTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	and?: InputMaybe<Array<InvoiceLineItemHistoryFilterInput>>;
	contractLineItemIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	contractLineItemIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	contractLineItemIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	contractLineItemIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	contractLineItemIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	displayOrderEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	displayOrderIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	displayOrderLT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderLTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	invoiceIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	invoiceIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	invoiceIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	invoiceIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	invoiceIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<InvoiceLineItemHistoryFilterInput>;
	or?: InputMaybe<Array<InvoiceLineItemHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type InvoiceLineItemHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<InvoiceLineItemHistoryOrderField>;
};

export enum InvoiceLineItemHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type InvoiceLineItemInContractLineItemCreateInput = {
	amount: Scalars["Int"]["input"];
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	invoiceID: Scalars["ID"]["input"];
};

export type InvoiceLineItemInInvoiceCreateInput = {
	amount: Scalars["Int"]["input"];
	contractLineItemID: Scalars["ID"]["input"];
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InvoiceLineItemOrder = {
	direction: OrderDirection;
	field?: InputMaybe<InvoiceLineItemOrderField>;
};

export enum InvoiceLineItemOrderField {
	DisplayOrder = "DISPLAY_ORDER",
}

export type InvoiceLineItemUpdateBulkInput = {
	amount?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InvoiceLineItemUpdateInput = {
	amount?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InvoiceOrder = {
	direction: OrderDirection;
	field?: InputMaybe<InvoiceOrderField>;
};

export enum InvoiceOrderField {
	IssueDate = "ISSUE_DATE",
}

export enum InvoiceStatus {
	Draft = "draft",
	Issued = "issued",
	Void = "void",
}

export type InvoiceUpdateBulkInput = {
	description?: InputMaybe<Scalars["String"]["input"]>;
	dueDate?: InputMaybe<Scalars["Date"]["input"]>;
	issueDate?: InputMaybe<Scalars["Date"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	status?: InputMaybe<InvoiceStatus>;
};

export type InvoiceUpdateInput = {
	description?: InputMaybe<Scalars["String"]["input"]>;
	dueDate?: InputMaybe<Scalars["Date"]["input"]>;
	issueDate?: InputMaybe<Scalars["Date"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	status?: InputMaybe<InvoiceStatus>;
};

export type Language = Node & {
	__typename?: "Language";
	enrollmentApplicationStudents: Array<EnrollmentApplicationStudent>;
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
	people: Array<Person>;
};

export type LanguageEnrollmentApplicationStudentsArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationStudentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type LanguagePeopleArgs = {
	filters?: InputMaybe<Array<PersonFilterInput>>;
	order?: InputMaybe<PersonOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type LanguageConnection = {
	__typename?: "LanguageConnection";
	edges: Array<LanguageEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type LanguageCreateInput = {
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name: Scalars["String"]["input"];
	personIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type LanguageEdge = {
	__typename?: "LanguageEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Language;
};

export type LanguageFilterInput = {
	and?: InputMaybe<Array<LanguageFilterInput>>;
	enrollmentApplicationStudents?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	hasEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPeople?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<LanguageFilterInput>;
	or?: InputMaybe<Array<LanguageFilterInput>>;
	people?: InputMaybe<Array<PersonFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type LanguageHistory = Node & {
	__typename?: "LanguageHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type LanguageHistoryConnection = {
	__typename?: "LanguageHistoryConnection";
	edges: Array<LanguageHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type LanguageHistoryEdge = {
	__typename?: "LanguageHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: LanguageHistory;
};

export type LanguageHistoryFilterInput = {
	and?: InputMaybe<Array<LanguageHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<LanguageHistoryFilterInput>;
	or?: InputMaybe<Array<LanguageHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type LanguageHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<LanguageHistoryOrderField>;
};

export enum LanguageHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type LanguageOrder = {
	direction: OrderDirection;
	field?: InputMaybe<LanguageOrderField>;
};

export enum LanguageOrderField {
	Name = "NAME",
}

export type LanguageUpdateBulkInput = {
	addEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearPeople?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type LanguageUpdateInput = {
	addEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearPeople?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	personIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type LearningObjective = Node & {
	__typename?: "LearningObjective";
	description: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	learningObjectiveCategory: LearningObjectiveCategory;
	learningObjectiveCategoryID: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
	reportCardSectionLearningObjectives: Array<ReportCardSectionLearningObjective>;
};

export type LearningObjectiveReportCardSectionLearningObjectivesArgs = {
	filters?: InputMaybe<Array<ReportCardSectionLearningObjectiveFilterInput>>;
	order?: InputMaybe<ReportCardSectionLearningObjectiveOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type LearningObjectiveCategory = Node & {
	__typename?: "LearningObjectiveCategory";
	id: Scalars["ID"]["output"];
	learningObjectives: Array<LearningObjective>;
	markingSystem: Maybe<MarkingSystem>;
	markingSystemID: Maybe<Scalars["ID"]["output"]>;
	name: Scalars["String"]["output"];
};

export type LearningObjectiveCategoryLearningObjectivesArgs = {
	filters?: InputMaybe<Array<LearningObjectiveFilterInput>>;
	order?: InputMaybe<LearningObjectiveOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type LearningObjectiveCategoryConnection = {
	__typename?: "LearningObjectiveCategoryConnection";
	edges: Array<LearningObjectiveCategoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type LearningObjectiveCategoryCreateInput = {
	learningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	learningObjectives?: InputMaybe<Array<LearningObjectiveInLearningObjectiveCategoryCreateInput>>;
	markingSystemID?: InputMaybe<Scalars["ID"]["input"]>;
	name: Scalars["String"]["input"];
};

export type LearningObjectiveCategoryEdge = {
	__typename?: "LearningObjectiveCategoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: LearningObjectiveCategory;
};

export type LearningObjectiveCategoryFilterInput = {
	and?: InputMaybe<Array<LearningObjectiveCategoryFilterInput>>;
	hasLearningObjectives?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMarkingSystem?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	learningObjectives?: InputMaybe<Array<LearningObjectiveFilterInput>>;
	markingSystem?: InputMaybe<Array<MarkingSystemFilterInput>>;
	markingSystemIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	markingSystemIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	markingSystemIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	markingSystemIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	markingSystemIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<LearningObjectiveCategoryFilterInput>;
	or?: InputMaybe<Array<LearningObjectiveCategoryFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type LearningObjectiveCategoryHistory = Node & {
	__typename?: "LearningObjectiveCategoryHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	markingSystemID: Maybe<Scalars["ID"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type LearningObjectiveCategoryHistoryConnection = {
	__typename?: "LearningObjectiveCategoryHistoryConnection";
	edges: Array<LearningObjectiveCategoryHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type LearningObjectiveCategoryHistoryEdge = {
	__typename?: "LearningObjectiveCategoryHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: LearningObjectiveCategoryHistory;
};

export type LearningObjectiveCategoryHistoryFilterInput = {
	and?: InputMaybe<Array<LearningObjectiveCategoryHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	markingSystemIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	markingSystemIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	markingSystemIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	markingSystemIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	markingSystemIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<LearningObjectiveCategoryHistoryFilterInput>;
	or?: InputMaybe<Array<LearningObjectiveCategoryHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type LearningObjectiveCategoryHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<LearningObjectiveCategoryHistoryOrderField>;
};

export enum LearningObjectiveCategoryHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type LearningObjectiveCategoryInMarkingSystemCreateInput = {
	learningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	learningObjectives?: InputMaybe<Array<LearningObjectiveInLearningObjectiveCategoryCreateInput>>;
	name: Scalars["String"]["input"];
};

export type LearningObjectiveCategoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<LearningObjectiveCategoryOrderField>;
};

export enum LearningObjectiveCategoryOrderField {
	Name = "NAME",
}

export type LearningObjectiveCategoryUpdateBulkInput = {
	addLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearLearningObjectives?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearMarkingSystem?: InputMaybe<Scalars["Boolean"]["input"]>;
	learningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	markingSystemID?: InputMaybe<Scalars["ID"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type LearningObjectiveCategoryUpdateInput = {
	addLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearLearningObjectives?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearMarkingSystem?: InputMaybe<Scalars["Boolean"]["input"]>;
	learningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	markingSystemID?: InputMaybe<Scalars["ID"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type LearningObjectiveConnection = {
	__typename?: "LearningObjectiveConnection";
	edges: Array<LearningObjectiveEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type LearningObjectiveCreateInput = {
	description?: InputMaybe<Scalars["String"]["input"]>;
	learningObjectiveCategoryID: Scalars["ID"]["input"];
	name: Scalars["String"]["input"];
	reportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionLearningObjectives?: InputMaybe<
		Array<ReportCardSectionLearningObjectiveInLearningObjectiveCreateInput>
	>;
};

export type LearningObjectiveEdge = {
	__typename?: "LearningObjectiveEdge";
	cursor: Scalars["Cursor"]["output"];
	node: LearningObjective;
};

export type LearningObjectiveFilterInput = {
	and?: InputMaybe<Array<LearningObjectiveFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasReportCardSectionLearningObjectives?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	learningObjectiveCategory?: InputMaybe<Array<LearningObjectiveCategoryFilterInput>>;
	learningObjectiveCategoryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	learningObjectiveCategoryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	learningObjectiveCategoryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	learningObjectiveCategoryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<LearningObjectiveFilterInput>;
	or?: InputMaybe<Array<LearningObjectiveFilterInput>>;
	reportCardSectionLearningObjectives?: InputMaybe<Array<ReportCardSectionLearningObjectiveFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type LearningObjectiveHistory = Node & {
	__typename?: "LearningObjectiveHistory";
	description: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	learningObjectiveCategoryID: Maybe<Scalars["ID"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type LearningObjectiveHistoryConnection = {
	__typename?: "LearningObjectiveHistoryConnection";
	edges: Array<LearningObjectiveHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type LearningObjectiveHistoryEdge = {
	__typename?: "LearningObjectiveHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: LearningObjectiveHistory;
};

export type LearningObjectiveHistoryFilterInput = {
	and?: InputMaybe<Array<LearningObjectiveHistoryFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	learningObjectiveCategoryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	learningObjectiveCategoryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	learningObjectiveCategoryIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	learningObjectiveCategoryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	learningObjectiveCategoryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<LearningObjectiveHistoryFilterInput>;
	or?: InputMaybe<Array<LearningObjectiveHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type LearningObjectiveHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<LearningObjectiveHistoryOrderField>;
};

export enum LearningObjectiveHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type LearningObjectiveInLearningObjectiveCategoryCreateInput = {
	description?: InputMaybe<Scalars["String"]["input"]>;
	name: Scalars["String"]["input"];
	reportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionLearningObjectives?: InputMaybe<
		Array<ReportCardSectionLearningObjectiveInLearningObjectiveCreateInput>
	>;
};

export type LearningObjectiveOrder = {
	direction: OrderDirection;
	field?: InputMaybe<LearningObjectiveOrderField>;
};

export enum LearningObjectiveOrderField {
	Name = "NAME",
}

export type LearningObjectiveUpdateBulkInput = {
	addReportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearReportCardSectionLearningObjectives?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	learningObjectiveCategoryID?: InputMaybe<Scalars["ID"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeReportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type LearningObjectiveUpdateInput = {
	addReportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearReportCardSectionLearningObjectives?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	learningObjectiveCategoryID?: InputMaybe<Scalars["ID"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeReportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type LoginRecord = Node & {
	__typename?: "LoginRecord";
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	isTrusted: Scalars["Boolean"]["output"];
	session: Maybe<Session>;
	sessionID: Maybe<Scalars["ID"]["output"]>;
	user: Maybe<User>;
	userEmail: Scalars["String"]["output"];
	userID: Maybe<Scalars["ID"]["output"]>;
	wasBlocked: Scalars["Boolean"]["output"];
	wasSuccessful: Scalars["Boolean"]["output"];
};

export type LoginRecordConnection = {
	__typename?: "LoginRecordConnection";
	edges: Array<LoginRecordEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type LoginRecordEdge = {
	__typename?: "LoginRecordEdge";
	cursor: Scalars["Cursor"]["output"];
	node: LoginRecord;
};

export type LoginRecordFilterInput = {
	and?: InputMaybe<Array<LoginRecordFilterInput>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasSession?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUser?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isTrustedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isTrustedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<LoginRecordFilterInput>;
	or?: InputMaybe<Array<LoginRecordFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	session?: InputMaybe<Array<SessionFilterInput>>;
	sessionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sessionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sessionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	sessionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sessionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	user?: InputMaybe<Array<UserFilterInput>>;
	userEmailContains?: InputMaybe<Scalars["String"]["input"]>;
	userEmailEQ?: InputMaybe<Scalars["String"]["input"]>;
	userEmailHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	userEmailHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	userEmailIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	userEmailNEQ?: InputMaybe<Scalars["String"]["input"]>;
	userEmailNotContains?: InputMaybe<Scalars["String"]["input"]>;
	userEmailNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	userEmailNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	userEmailNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	wasBlockedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	wasBlockedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	wasSuccessfulEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	wasSuccessfulNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LoginRecordOrder = {
	direction: OrderDirection;
	field?: InputMaybe<LoginRecordOrderField>;
};

export enum LoginRecordOrderField {
	CreatedAt = "CREATED_AT",
	UserEmail = "USER_EMAIL",
}

export type MFAFactor = Node & {
	__typename?: "MFAFactor";
	count: Scalars["Int"]["output"];
	createdAt: Scalars["Time"]["output"];
	email: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	isApp: Scalars["Boolean"]["output"];
	isVerified: Scalars["Boolean"]["output"];
	sms: Scalars["String"]["output"];
	user: User;
	userID: Scalars["ID"]["output"];
};

export type MFAFactorConnection = {
	__typename?: "MFAFactorConnection";
	edges: Array<MFAFactorEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MFAFactorEdge = {
	__typename?: "MFAFactorEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MFAFactor;
};

export type MFAFactorFilterInput = {
	and?: InputMaybe<Array<MFAFactorFilterInput>>;
	countEQ?: InputMaybe<Scalars["Int"]["input"]>;
	countGT?: InputMaybe<Scalars["Int"]["input"]>;
	countGTE?: InputMaybe<Scalars["Int"]["input"]>;
	countIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	countLT?: InputMaybe<Scalars["Int"]["input"]>;
	countLTE?: InputMaybe<Scalars["Int"]["input"]>;
	countNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	countNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	emailContains?: InputMaybe<Scalars["String"]["input"]>;
	emailEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	emailNEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailNotContains?: InputMaybe<Scalars["String"]["input"]>;
	emailNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isAppEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isAppNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isVerifiedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isVerifiedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<MFAFactorFilterInput>;
	or?: InputMaybe<Array<MFAFactorFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	smsContains?: InputMaybe<Scalars["String"]["input"]>;
	smsEQ?: InputMaybe<Scalars["String"]["input"]>;
	smsHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	smsHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	smsIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	smsNEQ?: InputMaybe<Scalars["String"]["input"]>;
	smsNotContains?: InputMaybe<Scalars["String"]["input"]>;
	smsNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	smsNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	smsNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	user?: InputMaybe<Array<UserFilterInput>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MFAFactorOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MFAFactorOrderField>;
};

export enum MFAFactorOrderField {
	CreatedAt = "CREATED_AT",
}

export type MFAInvalidOTPAttempt = Node & {
	__typename?: "MFAInvalidOTPAttempt";
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	session: Maybe<Session>;
	sessionID: Maybe<Scalars["ID"]["output"]>;
	user: User;
	userID: Scalars["ID"]["output"];
};

export type MFAInvalidOTPAttemptConnection = {
	__typename?: "MFAInvalidOTPAttemptConnection";
	edges: Array<MFAInvalidOTPAttemptEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MFAInvalidOTPAttemptEdge = {
	__typename?: "MFAInvalidOTPAttemptEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MFAInvalidOTPAttempt;
};

export type MFAInvalidOTPAttemptFilterInput = {
	and?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasSession?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MFAInvalidOTPAttemptFilterInput>;
	or?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput>>;
	session?: InputMaybe<Array<SessionFilterInput>>;
	sessionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sessionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sessionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	sessionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sessionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	user?: InputMaybe<Array<UserFilterInput>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MFAInvalidOTPAttemptOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MFAInvalidOTPAttemptOrderField>;
};

export enum MFAInvalidOTPAttemptOrderField {
	CreatedAt = "CREATED_AT",
}

export type MarkValue = Node & {
	__typename?: "MarkValue";
	description: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	isNull: Scalars["Boolean"]["output"];
	markingSystem: MarkingSystem;
	markingSystemID: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
	overallMarkReportCardSections: Array<ReportCardSection>;
	reportCardSectionLearningObjectives: Array<ReportCardSectionLearningObjective>;
	shortName: Scalars["String"]["output"];
	value: Scalars["Float"]["output"];
};

export type MarkValueOverallMarkReportCardSectionsArgs = {
	filters?: InputMaybe<Array<ReportCardSectionFilterInput>>;
	order?: InputMaybe<ReportCardSectionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MarkValueReportCardSectionLearningObjectivesArgs = {
	filters?: InputMaybe<Array<ReportCardSectionLearningObjectiveFilterInput>>;
	order?: InputMaybe<ReportCardSectionLearningObjectiveOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MarkValueConnection = {
	__typename?: "MarkValueConnection";
	edges: Array<MarkValueEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MarkValueCreateInput = {
	description?: InputMaybe<Scalars["String"]["input"]>;
	isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	markingSystemID: Scalars["ID"]["input"];
	name: Scalars["String"]["input"];
	overallMarkReportCardSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	overallMarkReportCardSections?: InputMaybe<Array<ReportCardSectionInOverallMarkValueCreateInput>>;
	reportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionLearningObjectives?: InputMaybe<Array<ReportCardSectionLearningObjectiveInMarkValueCreateInput>>;
	shortName?: InputMaybe<Scalars["String"]["input"]>;
	value: Scalars["Float"]["input"];
};

export type MarkValueEdge = {
	__typename?: "MarkValueEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MarkValue;
};

export type MarkValueFilterInput = {
	and?: InputMaybe<Array<MarkValueFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasOverallMarkReportCardSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasReportCardSectionLearningObjectives?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isNullEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isNullNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	markingSystem?: InputMaybe<Array<MarkingSystemFilterInput>>;
	markingSystemIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	markingSystemIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	markingSystemIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	markingSystemIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<MarkValueFilterInput>;
	or?: InputMaybe<Array<MarkValueFilterInput>>;
	overallMarkReportCardSections?: InputMaybe<Array<ReportCardSectionFilterInput>>;
	reportCardSectionLearningObjectives?: InputMaybe<Array<ReportCardSectionLearningObjectiveFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	shortNameContains?: InputMaybe<Scalars["String"]["input"]>;
	shortNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	shortNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	shortNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	shortNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	shortNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	shortNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	shortNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	shortNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	shortNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	valueEQ?: InputMaybe<Scalars["Float"]["input"]>;
	valueGT?: InputMaybe<Scalars["Float"]["input"]>;
	valueGTE?: InputMaybe<Scalars["Float"]["input"]>;
	valueIn?: InputMaybe<Array<Scalars["Float"]["input"]>>;
	valueLT?: InputMaybe<Scalars["Float"]["input"]>;
	valueLTE?: InputMaybe<Scalars["Float"]["input"]>;
	valueNEQ?: InputMaybe<Scalars["Float"]["input"]>;
	valueNotIn?: InputMaybe<Array<Scalars["Float"]["input"]>>;
};

export type MarkValueHistory = Node & {
	__typename?: "MarkValueHistory";
	description: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isNull: Maybe<Scalars["Boolean"]["output"]>;
	markingSystemID: Maybe<Scalars["ID"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	shortName: Maybe<Scalars["String"]["output"]>;
	value: Maybe<Scalars["Float"]["output"]>;
};

export type MarkValueHistoryConnection = {
	__typename?: "MarkValueHistoryConnection";
	edges: Array<MarkValueHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MarkValueHistoryEdge = {
	__typename?: "MarkValueHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MarkValueHistory;
};

export type MarkValueHistoryFilterInput = {
	and?: InputMaybe<Array<MarkValueHistoryFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isNullEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isNullIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isNullNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	markingSystemIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	markingSystemIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	markingSystemIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	markingSystemIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	markingSystemIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<MarkValueHistoryFilterInput>;
	or?: InputMaybe<Array<MarkValueHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	shortNameContains?: InputMaybe<Scalars["String"]["input"]>;
	shortNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	shortNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	shortNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	shortNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	shortNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	shortNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	shortNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	shortNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	shortNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	shortNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	valueEQ?: InputMaybe<Scalars["Float"]["input"]>;
	valueGT?: InputMaybe<Scalars["Float"]["input"]>;
	valueGTE?: InputMaybe<Scalars["Float"]["input"]>;
	valueIn?: InputMaybe<Array<Scalars["Float"]["input"]>>;
	valueIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	valueLT?: InputMaybe<Scalars["Float"]["input"]>;
	valueLTE?: InputMaybe<Scalars["Float"]["input"]>;
	valueNEQ?: InputMaybe<Scalars["Float"]["input"]>;
	valueNotIn?: InputMaybe<Array<Scalars["Float"]["input"]>>;
};

export type MarkValueHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MarkValueHistoryOrderField>;
};

export enum MarkValueHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MarkValueInMarkingSystemCreateInput = {
	description?: InputMaybe<Scalars["String"]["input"]>;
	isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	name: Scalars["String"]["input"];
	overallMarkReportCardSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	overallMarkReportCardSections?: InputMaybe<Array<ReportCardSectionInOverallMarkValueCreateInput>>;
	reportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionLearningObjectives?: InputMaybe<Array<ReportCardSectionLearningObjectiveInMarkValueCreateInput>>;
	shortName?: InputMaybe<Scalars["String"]["input"]>;
	value: Scalars["Float"]["input"];
};

export type MarkValueOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MarkValueOrderField>;
};

export enum MarkValueOrderField {
	Value = "VALUE",
}

export type MarkValueUpdateBulkInput = {
	addOverallMarkReportCardSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addReportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearOverallMarkReportCardSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearReportCardSectionLearningObjectives?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	markingSystemID?: InputMaybe<Scalars["ID"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkReportCardSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeOverallMarkReportCardSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeReportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	shortName?: InputMaybe<Scalars["String"]["input"]>;
	value?: InputMaybe<Scalars["Float"]["input"]>;
};

export type MarkValueUpdateInput = {
	addOverallMarkReportCardSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addReportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearOverallMarkReportCardSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearReportCardSectionLearningObjectives?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	markingSystemID?: InputMaybe<Scalars["ID"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkReportCardSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeOverallMarkReportCardSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeReportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	shortName?: InputMaybe<Scalars["String"]["input"]>;
	value?: InputMaybe<Scalars["Float"]["input"]>;
};

export type MarkingSystem = Node & {
	__typename?: "MarkingSystem";
	description: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	learningObjectiveCategories: Array<LearningObjectiveCategory>;
	markValues: Array<MarkValue>;
	name: Scalars["String"]["output"];
	overallMarkReportCardSectionPolicies: Array<ReportCardSectionPolicy>;
};

export type MarkingSystemLearningObjectiveCategoriesArgs = {
	filters?: InputMaybe<Array<LearningObjectiveCategoryFilterInput>>;
	order?: InputMaybe<LearningObjectiveCategoryOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MarkingSystemMarkValuesArgs = {
	filters?: InputMaybe<Array<MarkValueFilterInput>>;
	order?: InputMaybe<MarkValueOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MarkingSystemOverallMarkReportCardSectionPoliciesArgs = {
	filters?: InputMaybe<Array<ReportCardSectionPolicyFilterInput>>;
	order?: InputMaybe<ReportCardSectionPolicyOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MarkingSystemConnection = {
	__typename?: "MarkingSystemConnection";
	edges: Array<MarkingSystemEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MarkingSystemCreateInput = {
	description?: InputMaybe<Scalars["String"]["input"]>;
	learningObjectiveCategories?: InputMaybe<Array<LearningObjectiveCategoryInMarkingSystemCreateInput>>;
	learningObjectiveCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	markValueIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	markValues?: InputMaybe<Array<MarkValueInMarkingSystemCreateInput>>;
	name: Scalars["String"]["input"];
	overallMarkReportCardSectionPolicies?: InputMaybe<Array<ReportCardSectionPolicyInOverallMarkingSystemCreateInput>>;
	overallMarkReportCardSectionPolicyIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MarkingSystemEdge = {
	__typename?: "MarkingSystemEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MarkingSystem;
};

export type MarkingSystemFilterInput = {
	and?: InputMaybe<Array<MarkingSystemFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasLearningObjectiveCategories?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMarkValues?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasOverallMarkReportCardSectionPolicies?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	learningObjectiveCategories?: InputMaybe<Array<LearningObjectiveCategoryFilterInput>>;
	markValues?: InputMaybe<Array<MarkValueFilterInput>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<MarkingSystemFilterInput>;
	or?: InputMaybe<Array<MarkingSystemFilterInput>>;
	overallMarkReportCardSectionPolicies?: InputMaybe<Array<ReportCardSectionPolicyFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MarkingSystemHistory = Node & {
	__typename?: "MarkingSystemHistory";
	description: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type MarkingSystemHistoryConnection = {
	__typename?: "MarkingSystemHistoryConnection";
	edges: Array<MarkingSystemHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MarkingSystemHistoryEdge = {
	__typename?: "MarkingSystemHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MarkingSystemHistory;
};

export type MarkingSystemHistoryFilterInput = {
	and?: InputMaybe<Array<MarkingSystemHistoryFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<MarkingSystemHistoryFilterInput>;
	or?: InputMaybe<Array<MarkingSystemHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MarkingSystemHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MarkingSystemHistoryOrderField>;
};

export enum MarkingSystemHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MarkingSystemOrder = {
	direction: OrderDirection;
};

export type MarkingSystemUpdateBulkInput = {
	addLearningObjectiveCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addMarkValueIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addOverallMarkReportCardSectionPolicyIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearLearningObjectiveCategories?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearMarkValues?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearOverallMarkReportCardSectionPolicies?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	learningObjectiveCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	markValueIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkReportCardSectionPolicyIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeLearningObjectiveCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeMarkValueIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeOverallMarkReportCardSectionPolicyIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MarkingSystemUpdateInput = {
	addLearningObjectiveCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addMarkValueIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addOverallMarkReportCardSectionPolicyIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearLearningObjectiveCategories?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearMarkValues?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearOverallMarkReportCardSectionPolicies?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	learningObjectiveCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	markValueIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkReportCardSectionPolicyIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeLearningObjectiveCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeMarkValueIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeOverallMarkReportCardSectionPolicyIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MediaAttachment = Node & {
	__typename?: "MediaAttachment";
	announcement: Maybe<Announcement>;
	announcementID: Maybe<Scalars["ID"]["output"]>;
	calendarEvent: Maybe<CalendarEvent>;
	calendarEventID: Maybe<Scalars["ID"]["output"]>;
	courseAssessment: Maybe<CourseAssessment>;
	courseAssessmentID: Maybe<Scalars["ID"]["output"]>;
	courseAssessmentSubmission: Maybe<CourseAssessmentSubmission>;
	courseAssessmentSubmissionID: Maybe<Scalars["ID"]["output"]>;
	description: Scalars["String"]["output"];
	displayOrder: Scalars["Int"]["output"];
	fileContentType: Scalars["String"]["output"];
	fileKey: Scalars["String"]["output"];
	fileURL: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	isFile: Scalars["Boolean"]["output"];
	linkURL: Scalars["String"]["output"];
	message: Maybe<Message>;
	messageID: Maybe<Scalars["ID"]["output"]>;
	post: Maybe<Post>;
	postID: Maybe<Scalars["ID"]["output"]>;
	socialComments: Array<SocialComment>;
	socialReactions: Array<SocialReaction>;
	studentMedicalEvent: Maybe<StudentMedicalEvent>;
	studentMedicalEventID: Maybe<Scalars["ID"]["output"]>;
	studentNote: Maybe<StudentNote>;
	studentNoteID: Maybe<Scalars["ID"]["output"]>;
	taggedPeople: Array<Person>;
	title: Scalars["String"]["output"];
};

export type MediaAttachmentSocialCommentsArgs = {
	filters?: InputMaybe<Array<SocialCommentFilterInput>>;
	order?: InputMaybe<SocialCommentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MediaAttachmentSocialReactionsArgs = {
	filters?: InputMaybe<Array<SocialReactionFilterInput>>;
	order?: InputMaybe<SocialReactionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MediaAttachmentTaggedPeopleArgs = {
	filters?: InputMaybe<Array<PersonFilterInput>>;
	order?: InputMaybe<PersonOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MediaAttachmentConnection = {
	__typename?: "MediaAttachmentConnection";
	edges: Array<MediaAttachmentEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MediaAttachmentCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentID?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentSubmissionID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	linkURL?: InputMaybe<Scalars["String"]["input"]>;
	messageID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	socialComments?: InputMaybe<Array<SocialCommentInMediaAttachmentCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInMediaAttachmentCreateInput>>;
	studentMedicalEventID?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
	taggedPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MediaAttachmentEdge = {
	__typename?: "MediaAttachmentEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MediaAttachment;
};

export type MediaAttachmentFilterInput = {
	and?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	announcement?: InputMaybe<Array<AnnouncementFilterInput>>;
	announcementIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	announcementIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	announcementIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEvent?: InputMaybe<Array<CalendarEventFilterInput>>;
	calendarEventIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	calendarEventIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessment?: InputMaybe<Array<CourseAssessmentFilterInput>>;
	courseAssessmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseAssessmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentSubmission?: InputMaybe<Array<CourseAssessmentSubmissionFilterInput>>;
	courseAssessmentSubmissionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentSubmissionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentSubmissionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseAssessmentSubmissionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentSubmissionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	displayOrderEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	displayOrderLT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderLTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	fileContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasAnnouncement?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCalendarEvent?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCourseAssessment?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCourseAssessmentSubmission?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMessage?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPost?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSocialComments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSocialReactions?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentMedicalEvent?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentNote?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasTaggedPeople?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	linkURLContains?: InputMaybe<Scalars["String"]["input"]>;
	linkURLEQ?: InputMaybe<Scalars["String"]["input"]>;
	linkURLHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	linkURLHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	linkURLIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	linkURLNEQ?: InputMaybe<Scalars["String"]["input"]>;
	linkURLNotContains?: InputMaybe<Scalars["String"]["input"]>;
	linkURLNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	linkURLNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	linkURLNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	message?: InputMaybe<Array<MessageFilterInput>>;
	messageIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MediaAttachmentFilterInput>;
	or?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	post?: InputMaybe<Array<PostFilterInput>>;
	postIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	postIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	socialComments?: InputMaybe<Array<SocialCommentFilterInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionFilterInput>>;
	studentMedicalEvent?: InputMaybe<Array<StudentMedicalEventFilterInput>>;
	studentMedicalEventIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentMedicalEventIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalEventIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentMedicalEventIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentMedicalEventIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNote?: InputMaybe<Array<StudentNoteFilterInput>>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	taggedPeople?: InputMaybe<Array<PersonFilterInput>>;
	titleContains?: InputMaybe<Scalars["String"]["input"]>;
	titleEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	titleNEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleNotContains?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MediaAttachmentHistory = Node & {
	__typename?: "MediaAttachmentHistory";
	announcementID: Maybe<Scalars["ID"]["output"]>;
	calendarEventID: Maybe<Scalars["ID"]["output"]>;
	courseAssessmentID: Maybe<Scalars["ID"]["output"]>;
	courseAssessmentSubmissionID: Maybe<Scalars["ID"]["output"]>;
	description: Maybe<Scalars["String"]["output"]>;
	displayOrder: Maybe<Scalars["Int"]["output"]>;
	fileContentType: Maybe<Scalars["String"]["output"]>;
	fileKey: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	linkURL: Maybe<Scalars["String"]["output"]>;
	messageID: Maybe<Scalars["ID"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	postID: Maybe<Scalars["ID"]["output"]>;
	studentMedicalEventID: Maybe<Scalars["ID"]["output"]>;
	studentNoteID: Maybe<Scalars["ID"]["output"]>;
	title: Maybe<Scalars["String"]["output"]>;
};

export type MediaAttachmentHistoryConnection = {
	__typename?: "MediaAttachmentHistoryConnection";
	edges: Array<MediaAttachmentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MediaAttachmentHistoryEdge = {
	__typename?: "MediaAttachmentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MediaAttachmentHistory;
};

export type MediaAttachmentHistoryFilterInput = {
	and?: InputMaybe<Array<MediaAttachmentHistoryFilterInput>>;
	announcementIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	announcementIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	announcementIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	calendarEventIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseAssessmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentSubmissionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentSubmissionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseAssessmentSubmissionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseAssessmentSubmissionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentSubmissionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	displayOrderEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	displayOrderIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	displayOrderLT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderLTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	fileContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileContentTypeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	fileContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileKeyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	fileKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	linkURLContains?: InputMaybe<Scalars["String"]["input"]>;
	linkURLEQ?: InputMaybe<Scalars["String"]["input"]>;
	linkURLHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	linkURLHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	linkURLIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	linkURLIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	linkURLNEQ?: InputMaybe<Scalars["String"]["input"]>;
	linkURLNotContains?: InputMaybe<Scalars["String"]["input"]>;
	linkURLNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	linkURLNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	linkURLNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	messageIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MediaAttachmentHistoryFilterInput>;
	or?: InputMaybe<Array<MediaAttachmentHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	postIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentMedicalEventIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentMedicalEventIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalEventIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentMedicalEventIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentMedicalEventIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	titleContains?: InputMaybe<Scalars["String"]["input"]>;
	titleEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	titleIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	titleNEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleNotContains?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MediaAttachmentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MediaAttachmentHistoryOrderField>;
};

export enum MediaAttachmentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MediaAttachmentInAnnouncementCreateInput = {
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentID?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentSubmissionID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	linkURL?: InputMaybe<Scalars["String"]["input"]>;
	messageID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	socialComments?: InputMaybe<Array<SocialCommentInMediaAttachmentCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInMediaAttachmentCreateInput>>;
	studentMedicalEventID?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
	taggedPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MediaAttachmentInCalendarEventCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentID?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentSubmissionID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	linkURL?: InputMaybe<Scalars["String"]["input"]>;
	messageID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	socialComments?: InputMaybe<Array<SocialCommentInMediaAttachmentCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInMediaAttachmentCreateInput>>;
	studentMedicalEventID?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
	taggedPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MediaAttachmentInCourseAssessmentCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentSubmissionID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	linkURL?: InputMaybe<Scalars["String"]["input"]>;
	messageID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	socialComments?: InputMaybe<Array<SocialCommentInMediaAttachmentCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInMediaAttachmentCreateInput>>;
	studentMedicalEventID?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
	taggedPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MediaAttachmentInCourseAssessmentSubmissionCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	linkURL?: InputMaybe<Scalars["String"]["input"]>;
	messageID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	socialComments?: InputMaybe<Array<SocialCommentInMediaAttachmentCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInMediaAttachmentCreateInput>>;
	studentMedicalEventID?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
	taggedPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MediaAttachmentInMessageCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentID?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentSubmissionID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	linkURL?: InputMaybe<Scalars["String"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	socialComments?: InputMaybe<Array<SocialCommentInMediaAttachmentCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInMediaAttachmentCreateInput>>;
	studentMedicalEventID?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
	taggedPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MediaAttachmentInPostCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentID?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentSubmissionID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	linkURL?: InputMaybe<Scalars["String"]["input"]>;
	messageID?: InputMaybe<Scalars["ID"]["input"]>;
	socialComments?: InputMaybe<Array<SocialCommentInMediaAttachmentCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInMediaAttachmentCreateInput>>;
	studentMedicalEventID?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
	taggedPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MediaAttachmentInStudentMedicalEventCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentID?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentSubmissionID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	linkURL?: InputMaybe<Scalars["String"]["input"]>;
	messageID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	socialComments?: InputMaybe<Array<SocialCommentInMediaAttachmentCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInMediaAttachmentCreateInput>>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
	taggedPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MediaAttachmentInStudentNoteCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentID?: InputMaybe<Scalars["ID"]["input"]>;
	courseAssessmentSubmissionID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	linkURL?: InputMaybe<Scalars["String"]["input"]>;
	messageID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	socialComments?: InputMaybe<Array<SocialCommentInMediaAttachmentCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInMediaAttachmentCreateInput>>;
	studentMedicalEventID?: InputMaybe<Scalars["ID"]["input"]>;
	taggedPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MediaAttachmentOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MediaAttachmentOrderField>;
};

export enum MediaAttachmentOrderField {
	DisplayOrder = "DISPLAY_ORDER",
}

export type MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistory = Node & {
	__typename?: "MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	mediaAttachmentID: Maybe<Scalars["ID"]["output"]>;
	personID: Maybe<Scalars["ID"]["output"]>;
};

export type MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistoryConnection = {
	__typename?: "MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistoryConnection";
	edges: Array<MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistoryEdge = {
	__typename?: "MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistory;
};

export type MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistoryFilterInput = {
	and?: InputMaybe<Array<MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachmentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistoryFilterInput>;
	or?: InputMaybe<Array<MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistoryFilterInput>>;
	personIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	personIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistoryOrderField>;
};

export enum MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MediaAttachmentUpdateBulkInput = {
	addTaggedPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearTaggedPeople?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	linkURL?: InputMaybe<Scalars["String"]["input"]>;
	removeTaggedPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	taggedPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MediaAttachmentUpdateInput = {
	addTaggedPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearTaggedPeople?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	linkURL?: InputMaybe<Scalars["String"]["input"]>;
	removeTaggedPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	taggedPersonIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MedicalCondition = Node & {
	__typename?: "MedicalCondition";
	conditionType: MedicalConditionConditionType;
	description: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
	studentMedicalConditions: Array<StudentMedicalCondition>;
};

export type MedicalConditionStudentMedicalConditionsArgs = {
	filters?: InputMaybe<Array<StudentMedicalConditionFilterInput>>;
	order?: InputMaybe<StudentMedicalConditionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export enum MedicalConditionConditionType {
	Allergy = "allergy",
	FoodIntolerance = "food_intolerance",
	MedicalCondition = "medical_condition",
}

export type MedicalConditionConnection = {
	__typename?: "MedicalConditionConnection";
	edges: Array<MedicalConditionEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MedicalConditionCreateInput = {
	conditionType: MedicalConditionConditionType;
	description?: InputMaybe<Scalars["String"]["input"]>;
	name: Scalars["String"]["input"];
	studentMedicalConditionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalConditions?: InputMaybe<Array<StudentMedicalConditionInMedicalConditionCreateInput>>;
};

export type MedicalConditionEdge = {
	__typename?: "MedicalConditionEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MedicalCondition;
};

export type MedicalConditionFilterInput = {
	and?: InputMaybe<Array<MedicalConditionFilterInput>>;
	conditionTypeEQ?: InputMaybe<MedicalConditionConditionType>;
	conditionTypeIn?: InputMaybe<Array<MedicalConditionConditionType>>;
	conditionTypeNEQ?: InputMaybe<MedicalConditionConditionType>;
	conditionTypeNotIn?: InputMaybe<Array<MedicalConditionConditionType>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasStudentMedicalConditions?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<MedicalConditionFilterInput>;
	or?: InputMaybe<Array<MedicalConditionFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentMedicalConditions?: InputMaybe<Array<StudentMedicalConditionFilterInput>>;
};

export type MedicalConditionHistory = Node & {
	__typename?: "MedicalConditionHistory";
	conditionType: Maybe<MedicalConditionHistoryConditionType>;
	description: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export enum MedicalConditionHistoryConditionType {
	Allergy = "allergy",
	FoodIntolerance = "food_intolerance",
	MedicalCondition = "medical_condition",
}

export type MedicalConditionHistoryConnection = {
	__typename?: "MedicalConditionHistoryConnection";
	edges: Array<MedicalConditionHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MedicalConditionHistoryEdge = {
	__typename?: "MedicalConditionHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MedicalConditionHistory;
};

export type MedicalConditionHistoryFilterInput = {
	and?: InputMaybe<Array<MedicalConditionHistoryFilterInput>>;
	conditionTypeEQ?: InputMaybe<MedicalConditionHistoryConditionType>;
	conditionTypeIn?: InputMaybe<Array<MedicalConditionHistoryConditionType>>;
	conditionTypeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	conditionTypeNEQ?: InputMaybe<MedicalConditionHistoryConditionType>;
	conditionTypeNotIn?: InputMaybe<Array<MedicalConditionHistoryConditionType>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<MedicalConditionHistoryFilterInput>;
	or?: InputMaybe<Array<MedicalConditionHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MedicalConditionHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MedicalConditionHistoryOrderField>;
};

export enum MedicalConditionHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MedicalConditionOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MedicalConditionOrderField>;
};

export enum MedicalConditionOrderField {
	ConditionType = "CONDITION_TYPE",
	Name = "NAME",
}

export type MedicalConditionUpdateBulkInput = {
	addStudentMedicalConditionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearStudentMedicalConditions?: InputMaybe<Scalars["Boolean"]["input"]>;
	conditionType?: InputMaybe<MedicalConditionConditionType>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeStudentMedicalConditionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalConditionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MedicalConditionUpdateInput = {
	addStudentMedicalConditionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearStudentMedicalConditions?: InputMaybe<Scalars["Boolean"]["input"]>;
	conditionType?: InputMaybe<MedicalConditionConditionType>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeStudentMedicalConditionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalConditionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type Medication = Node & {
	__typename?: "Medication";
	description: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	isPrescription: Scalars["Boolean"]["output"];
	name: Scalars["String"]["output"];
	studentOtcMedications: Array<StudentOTCMedication>;
	studentPrescriptionMedications: Array<StudentPrescriptionMedication>;
};

export type MedicationStudentOTCMedicationsArgs = {
	filters?: InputMaybe<Array<StudentOTCMedicationFilterInput>>;
	order?: InputMaybe<StudentOTCMedicationOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MedicationStudentPrescriptionMedicationsArgs = {
	filters?: InputMaybe<Array<StudentPrescriptionMedicationFilterInput>>;
	order?: InputMaybe<StudentPrescriptionMedicationOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MedicationConnection = {
	__typename?: "MedicationConnection";
	edges: Array<MedicationEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MedicationCreateInput = {
	description?: InputMaybe<Scalars["String"]["input"]>;
	isPrescription?: InputMaybe<Scalars["Boolean"]["input"]>;
	name: Scalars["String"]["input"];
	studentOtcMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentOtcMedications?: InputMaybe<Array<StudentOTCMedicationInMedicationCreateInput>>;
	studentPrescriptionMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentPrescriptionMedications?: InputMaybe<Array<StudentPrescriptionMedicationInMedicationCreateInput>>;
};

export type MedicationEdge = {
	__typename?: "MedicationEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Medication;
};

export type MedicationFilterInput = {
	and?: InputMaybe<Array<MedicationFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasStudentOTCMedications?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentPrescriptionMedications?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isPrescriptionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrescriptionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<MedicationFilterInput>;
	or?: InputMaybe<Array<MedicationFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentOtcMedications?: InputMaybe<Array<StudentOTCMedicationFilterInput>>;
	studentPrescriptionMedications?: InputMaybe<Array<StudentPrescriptionMedicationFilterInput>>;
};

export type MedicationHistory = Node & {
	__typename?: "MedicationHistory";
	description: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isPrescription: Maybe<Scalars["Boolean"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type MedicationHistoryConnection = {
	__typename?: "MedicationHistoryConnection";
	edges: Array<MedicationHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MedicationHistoryEdge = {
	__typename?: "MedicationHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MedicationHistory;
};

export type MedicationHistoryFilterInput = {
	and?: InputMaybe<Array<MedicationHistoryFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isPrescriptionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrescriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrescriptionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<MedicationHistoryFilterInput>;
	or?: InputMaybe<Array<MedicationHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MedicationHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MedicationHistoryOrderField>;
};

export enum MedicationHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MedicationOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MedicationOrderField>;
};

export enum MedicationOrderField {
	Name = "NAME",
}

export type MedicationUpdateBulkInput = {
	addStudentOTCMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentPrescriptionMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearStudentOTCMedications?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentPrescriptionMedications?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	isPrescription?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeStudentOTCMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentPrescriptionMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentOtcMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentPrescriptionMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MedicationUpdateInput = {
	addStudentOTCMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentPrescriptionMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearStudentOTCMedications?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentPrescriptionMedications?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	isPrescription?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeStudentOTCMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentPrescriptionMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentOtcMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentPrescriptionMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type Message = Node & {
	__typename?: "Message";
	author: User;
	authorID: Scalars["ID"]["output"];
	body: Scalars["String"]["output"];
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	isRemoved: Scalars["Boolean"]["output"];
	lastEditedAt: Maybe<Scalars["Time"]["output"]>;
	mediaAttachments: Array<MediaAttachment>;
	messageGroup: MessageGroup;
	messageGroupID: Scalars["ID"]["output"];
	messageTopic: Maybe<MessageTopic>;
};

export type MessageMediaAttachmentsArgs = {
	filters?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	order?: InputMaybe<MediaAttachmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MessageAvailabilityPeriod = Node & {
	__typename?: "MessageAvailabilityPeriod";
	dayOfWeek: Scalars["Int"]["output"];
	endTimeMinutes: Scalars["Int"]["output"];
	id: Scalars["ID"]["output"];
	startTimeMinutes: Scalars["Int"]["output"];
	user: User;
	userID: Scalars["ID"]["output"];
};

export type MessageAvailabilityPeriodConnection = {
	__typename?: "MessageAvailabilityPeriodConnection";
	edges: Array<MessageAvailabilityPeriodEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageAvailabilityPeriodCreateInput = {
	dayOfWeek: Scalars["Int"]["input"];
	endTimeMinutes: Scalars["Int"]["input"];
	startTimeMinutes: Scalars["Int"]["input"];
};

export type MessageAvailabilityPeriodEdge = {
	__typename?: "MessageAvailabilityPeriodEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageAvailabilityPeriod;
};

export type MessageAvailabilityPeriodFilterInput = {
	and?: InputMaybe<Array<MessageAvailabilityPeriodFilterInput>>;
	dayOfWeekEQ?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekGT?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekGTE?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	dayOfWeekLT?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekLTE?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	endTimeMinutesEQ?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesGT?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesGTE?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	endTimeMinutesLT?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesLTE?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MessageAvailabilityPeriodFilterInput>;
	or?: InputMaybe<Array<MessageAvailabilityPeriodFilterInput>>;
	startTimeMinutesEQ?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesGT?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesGTE?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	startTimeMinutesLT?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesLTE?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	user?: InputMaybe<Array<UserFilterInput>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MessageAvailabilityPeriodHistory = Node & {
	__typename?: "MessageAvailabilityPeriodHistory";
	dayOfWeek: Maybe<Scalars["Int"]["output"]>;
	endTimeMinutes: Maybe<Scalars["Int"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
	startTimeMinutes: Maybe<Scalars["Int"]["output"]>;
	userID: Maybe<Scalars["ID"]["output"]>;
};

export type MessageAvailabilityPeriodHistoryConnection = {
	__typename?: "MessageAvailabilityPeriodHistoryConnection";
	edges: Array<MessageAvailabilityPeriodHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageAvailabilityPeriodHistoryEdge = {
	__typename?: "MessageAvailabilityPeriodHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageAvailabilityPeriodHistory;
};

export type MessageAvailabilityPeriodHistoryFilterInput = {
	and?: InputMaybe<Array<MessageAvailabilityPeriodHistoryFilterInput>>;
	dayOfWeekEQ?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekGT?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekGTE?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	dayOfWeekIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dayOfWeekLT?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekLTE?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	dayOfWeekNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	endTimeMinutesEQ?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesGT?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesGTE?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	endTimeMinutesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	endTimeMinutesLT?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesLTE?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutesNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MessageAvailabilityPeriodHistoryFilterInput>;
	or?: InputMaybe<Array<MessageAvailabilityPeriodHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	startTimeMinutesEQ?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesGT?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesGTE?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	startTimeMinutesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	startTimeMinutesLT?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesLTE?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutesNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MessageAvailabilityPeriodHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageAvailabilityPeriodHistoryOrderField>;
};

export enum MessageAvailabilityPeriodHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MessageAvailabilityPeriodInUserCreateInput = {
	dayOfWeek: Scalars["Int"]["input"];
	endTimeMinutes: Scalars["Int"]["input"];
	startTimeMinutes: Scalars["Int"]["input"];
};

export type MessageAvailabilityPeriodOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageAvailabilityPeriodOrderField>;
};

export enum MessageAvailabilityPeriodOrderField {
	DayOfWeek = "DAY_OF_WEEK",
	EndTimeMinutes = "END_TIME_MINUTES",
	StartTimeMinutes = "START_TIME_MINUTES",
}

export type MessageAvailabilityPeriodUpdateBulkInput = {
	dayOfWeek?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutes?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutes?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MessageAvailabilityPeriodUpdateInput = {
	dayOfWeek?: InputMaybe<Scalars["Int"]["input"]>;
	endTimeMinutes?: InputMaybe<Scalars["Int"]["input"]>;
	startTimeMinutes?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MessageConnection = {
	__typename?: "MessageConnection";
	edges: Array<MessageEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInMessageCreateInput>>;
	messageGroupID: Scalars["ID"]["input"];
	messageTopic?: InputMaybe<MessageTopicInMessageCreateInput>;
};

export type MessageEdge = {
	__typename?: "MessageEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Message;
};

export type MessageFilterInput = {
	and?: InputMaybe<Array<MessageFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasMediaAttachments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMessageTopic?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isRemovedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isRemovedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	lastEditedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	lastEditedAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	lastEditedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	messageGroup?: InputMaybe<Array<MessageGroupFilterInput>>;
	messageGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageTopic?: InputMaybe<Array<MessageTopicFilterInput>>;
	not?: InputMaybe<MessageFilterInput>;
	or?: InputMaybe<Array<MessageFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MessageGroup = Node & {
	__typename?: "MessageGroup";
	customName: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	isOneOnOne: Scalars["Boolean"]["output"];
	messageGroupArchivePoints: Array<MessageGroupArchivePoint>;
	messages: Array<Message>;
	userGroups: Array<UserGroup>;
	users: Array<User>;
};

export type MessageGroupMessageGroupArchivePointsArgs = {
	filters?: InputMaybe<Array<MessageGroupArchivePointFilterInput>>;
	order?: InputMaybe<MessageGroupArchivePointOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MessageGroupMessagesArgs = {
	filters?: InputMaybe<Array<MessageFilterInput>>;
	order?: InputMaybe<MessageOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MessageGroupUserGroupsArgs = {
	filters?: InputMaybe<Array<UserGroupFilterInput>>;
	order?: InputMaybe<UserGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MessageGroupUsersArgs = {
	filters?: InputMaybe<Array<UserFilterInput>>;
	order?: InputMaybe<UserOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MessageGroupArchivePoint = Node & {
	__typename?: "MessageGroupArchivePoint";
	author: User;
	authorID: Scalars["ID"]["output"];
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	messageGroup: MessageGroup;
	messageGroupID: Scalars["ID"]["output"];
};

export type MessageGroupArchivePointConnection = {
	__typename?: "MessageGroupArchivePointConnection";
	edges: Array<MessageGroupArchivePointEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageGroupArchivePointCreateInput = {
	messageGroupID: Scalars["ID"]["input"];
};

export type MessageGroupArchivePointEdge = {
	__typename?: "MessageGroupArchivePointEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageGroupArchivePoint;
};

export type MessageGroupArchivePointFilterInput = {
	and?: InputMaybe<Array<MessageGroupArchivePointFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroup?: InputMaybe<Array<MessageGroupFilterInput>>;
	messageGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MessageGroupArchivePointFilterInput>;
	or?: InputMaybe<Array<MessageGroupArchivePointFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MessageGroupArchivePointHistory = Node & {
	__typename?: "MessageGroupArchivePointHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	messageGroupID: Maybe<Scalars["ID"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type MessageGroupArchivePointHistoryConnection = {
	__typename?: "MessageGroupArchivePointHistoryConnection";
	edges: Array<MessageGroupArchivePointHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageGroupArchivePointHistoryEdge = {
	__typename?: "MessageGroupArchivePointHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageGroupArchivePointHistory;
};

export type MessageGroupArchivePointHistoryFilterInput = {
	and?: InputMaybe<Array<MessageGroupArchivePointHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MessageGroupArchivePointHistoryFilterInput>;
	or?: InputMaybe<Array<MessageGroupArchivePointHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MessageGroupArchivePointHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageGroupArchivePointHistoryOrderField>;
};

export enum MessageGroupArchivePointHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MessageGroupArchivePointInAuthorCreateInput = {
	messageGroupID: Scalars["ID"]["input"];
};

export type MessageGroupArchivePointInMessageGroupCreateInput = {
	_filler?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MessageGroupArchivePointOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageGroupArchivePointOrderField>;
};

export enum MessageGroupArchivePointOrderField {
	CreatedAt = "CREATED_AT",
}

export type MessageGroupArchivePointUpdateInput = {
	_filler?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MessageGroupConnection = {
	__typename?: "MessageGroupConnection";
	edges: Array<MessageGroupEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageGroupCreateInput = {
	customName?: InputMaybe<Scalars["String"]["input"]>;
	isOneOnOne?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageGroupArchivePoints?: InputMaybe<Array<MessageGroupArchivePointInMessageGroupCreateInput>>;
	messages?: InputMaybe<Array<MessageInMessageGroupCreateInput>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MessageGroupEdge = {
	__typename?: "MessageGroupEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageGroup;
};

export type MessageGroupFilterInput = {
	and?: InputMaybe<Array<MessageGroupFilterInput>>;
	customNameContains?: InputMaybe<Scalars["String"]["input"]>;
	customNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	customNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	customNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	customNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	customNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	customNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	customNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	customNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	customNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasMessageGroupArchivePoints?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMessages?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isOneOnOneEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isOneOnOneNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageGroupArchivePoints?: InputMaybe<Array<MessageGroupArchivePointFilterInput>>;
	messages?: InputMaybe<Array<MessageFilterInput>>;
	not?: InputMaybe<MessageGroupFilterInput>;
	or?: InputMaybe<Array<MessageGroupFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	userGroups?: InputMaybe<Array<UserGroupFilterInput>>;
	users?: InputMaybe<Array<UserFilterInput>>;
};

export type MessageGroupHistory = Node & {
	__typename?: "MessageGroupHistory";
	customName: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isOneOnOne: Maybe<Scalars["Boolean"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type MessageGroupHistoryConnection = {
	__typename?: "MessageGroupHistoryConnection";
	edges: Array<MessageGroupHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageGroupHistoryEdge = {
	__typename?: "MessageGroupHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageGroupHistory;
};

export type MessageGroupHistoryFilterInput = {
	and?: InputMaybe<Array<MessageGroupHistoryFilterInput>>;
	customNameContains?: InputMaybe<Scalars["String"]["input"]>;
	customNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	customNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	customNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	customNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	customNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	customNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	customNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	customNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	customNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	customNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isOneOnOneEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isOneOnOneIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isOneOnOneNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<MessageGroupHistoryFilterInput>;
	or?: InputMaybe<Array<MessageGroupHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MessageGroupHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageGroupHistoryOrderField>;
};

export enum MessageGroupHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MessageGroupOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageGroupOrderField>;
};

export enum MessageGroupOrderField {
	CustomName = "CUSTOM_NAME",
}

export type MessageGroupUpdateBulkInput = {
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	customName?: InputMaybe<Scalars["String"]["input"]>;
	isOneOnOne?: InputMaybe<Scalars["Boolean"]["input"]>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MessageGroupUpdateInput = {
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	customName?: InputMaybe<Scalars["String"]["input"]>;
	isOneOnOne?: InputMaybe<Scalars["Boolean"]["input"]>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MessageGroupUserGroupHistory = Node & {
	__typename?: "MessageGroupUserGroupHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	messageGroupID: Maybe<Scalars["ID"]["output"]>;
	userGroupID: Maybe<Scalars["ID"]["output"]>;
};

export type MessageGroupUserGroupHistoryConnection = {
	__typename?: "MessageGroupUserGroupHistoryConnection";
	edges: Array<MessageGroupUserGroupHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageGroupUserGroupHistoryEdge = {
	__typename?: "MessageGroupUserGroupHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageGroupUserGroupHistory;
};

export type MessageGroupUserGroupHistoryFilterInput = {
	and?: InputMaybe<Array<MessageGroupUserGroupHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MessageGroupUserGroupHistoryFilterInput>;
	or?: InputMaybe<Array<MessageGroupUserGroupHistoryFilterInput>>;
	userGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MessageGroupUserGroupHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageGroupUserGroupHistoryOrderField>;
};

export enum MessageGroupUserGroupHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MessageGroupUserHistory = Node & {
	__typename?: "MessageGroupUserHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	messageGroupID: Maybe<Scalars["ID"]["output"]>;
	userID: Maybe<Scalars["ID"]["output"]>;
};

export type MessageGroupUserHistoryConnection = {
	__typename?: "MessageGroupUserHistoryConnection";
	edges: Array<MessageGroupUserHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageGroupUserHistoryEdge = {
	__typename?: "MessageGroupUserHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageGroupUserHistory;
};

export type MessageGroupUserHistoryFilterInput = {
	and?: InputMaybe<Array<MessageGroupUserHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MessageGroupUserHistoryFilterInput>;
	or?: InputMaybe<Array<MessageGroupUserHistoryFilterInput>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MessageGroupUserHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageGroupUserHistoryOrderField>;
};

export enum MessageGroupUserHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MessageHistory = Node & {
	__typename?: "MessageHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Maybe<Scalars["String"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isRemoved: Maybe<Scalars["Boolean"]["output"]>;
	lastEditedAt: Maybe<Scalars["Time"]["output"]>;
	messageGroupID: Maybe<Scalars["ID"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type MessageHistoryConnection = {
	__typename?: "MessageHistoryConnection";
	edges: Array<MessageHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageHistoryEdge = {
	__typename?: "MessageHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageHistory;
};

export type MessageHistoryFilterInput = {
	and?: InputMaybe<Array<MessageHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isRemovedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isRemovedIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isRemovedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	lastEditedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	lastEditedAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	lastEditedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	messageGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MessageHistoryFilterInput>;
	or?: InputMaybe<Array<MessageHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MessageHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageHistoryOrderField>;
};

export enum MessageHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MessageInAuthorCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInMessageCreateInput>>;
	messageGroupID: Scalars["ID"]["input"];
	messageTopic?: InputMaybe<MessageTopicInMessageCreateInput>;
};

export type MessageInMessageGroupCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInMessageCreateInput>>;
	messageTopic?: InputMaybe<MessageTopicInMessageCreateInput>;
};

export type MessageInMessageTopicCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInMessageCreateInput>>;
	messageGroupID: Scalars["ID"]["input"];
};

export type MessageOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageOrderField>;
};

export enum MessageOrderField {
	CreatedAt = "CREATED_AT",
}

export type MessageTopic = Node & {
	__typename?: "MessageTopic";
	id: Scalars["ID"]["output"];
	message: Message;
	messageID: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
	students: Array<Student>;
};

export type MessageTopicStudentsArgs = {
	filters?: InputMaybe<Array<StudentFilterInput>>;
	order?: InputMaybe<StudentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MessageTopicConnection = {
	__typename?: "MessageTopicConnection";
	edges: Array<MessageTopicEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageTopicCreateInput = {
	message?: InputMaybe<MessageInMessageTopicCreateInput>;
	messageID?: InputMaybe<Scalars["ID"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	studentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MessageTopicEdge = {
	__typename?: "MessageTopicEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageTopic;
};

export type MessageTopicFilterInput = {
	and?: InputMaybe<Array<MessageTopicFilterInput>>;
	hasStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	message?: InputMaybe<Array<MessageFilterInput>>;
	messageIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<MessageTopicFilterInput>;
	or?: InputMaybe<Array<MessageTopicFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	students?: InputMaybe<Array<StudentFilterInput>>;
};

export type MessageTopicHistory = Node & {
	__typename?: "MessageTopicHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	messageID: Maybe<Scalars["ID"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type MessageTopicHistoryConnection = {
	__typename?: "MessageTopicHistoryConnection";
	edges: Array<MessageTopicHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageTopicHistoryEdge = {
	__typename?: "MessageTopicHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageTopicHistory;
};

export type MessageTopicHistoryFilterInput = {
	and?: InputMaybe<Array<MessageTopicHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<MessageTopicHistoryFilterInput>;
	or?: InputMaybe<Array<MessageTopicHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MessageTopicHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageTopicHistoryOrderField>;
};

export enum MessageTopicHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MessageTopicInMessageCreateInput = {
	name?: InputMaybe<Scalars["String"]["input"]>;
	studentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MessageTopicOrder = {
	direction: OrderDirection;
};

export type MessageTopicUpdateBulkInput = {
	addStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MessageTopicUpdateInput = {
	addStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MessageUpdateBulkInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	isRemoved?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MessageUpdateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	isRemoved?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ModelIdInformation = {
	__typename?: "ModelIDInformation";
	maxID: Scalars["ID"]["output"];
	minID: Scalars["ID"]["output"];
	modelName: Scalars["String"]["output"];
};

export type Mutation = {
	__typename?: "Mutation";
	createAcademicSubject: AcademicSubject;
	createAcademicTerm: AcademicTerm;
	createAcademicYear: AcademicYear;
	createAddress: Address;
	createAnnouncement: Announcement;
	createAttendanceStatus: AttendanceStatus;
	createBillingAdjustment: BillingAdjustment;
	createBuilding: Building;
	createBuildingFloor: BuildingFloor;
	createBulkAcademicSubjects: AcademicSubjectConnection;
	createBulkAcademicTerms: AcademicTermConnection;
	createBulkAcademicYears: AcademicYearConnection;
	createBulkAddresses: AddressConnection;
	createBulkAnnouncements: AnnouncementConnection;
	createBulkAttendanceStatuses: AttendanceStatusConnection;
	createBulkBillingAdjustments: BillingAdjustmentConnection;
	createBulkBuildingFloors: BuildingFloorConnection;
	createBulkBuildings: BuildingConnection;
	createBulkCalendarEventResponses: CalendarEventResponseConnection;
	createBulkCalendarEvents: CalendarEventConnection;
	createBulkCampuses: CampusConnection;
	createBulkClassYearCategories: ClassYearCategoryConnection;
	createBulkClassYears: ClassYearConnection;
	createBulkContractInstallments: ContractInstallmentConnection;
	createBulkContractLineItems: ContractLineItemConnection;
	createBulkContracts: ContractConnection;
	createBulkCountries: CountryConnection;
	createBulkCourseAssessmentCategories: CourseAssessmentCategoryConnection;
	createBulkCourseAssessmentCategoryMarkPortions: CourseAssessmentCategoryMarkPortionConnection;
	createBulkCourseAssessmentMarks: CourseAssessmentMarkConnection;
	createBulkCourseAssessmentSubmissions: CourseAssessmentSubmissionConnection;
	createBulkCourseAssessmentTimings: CourseAssessmentTimingConnection;
	createBulkCourseAssessments: CourseAssessmentConnection;
	createBulkCourseAttendanceRecords: CourseAttendanceRecordConnection;
	createBulkCourseSectionPeriods: CourseSectionPeriodConnection;
	createBulkCourseSections: CourseSectionConnection;
	createBulkCourses: CourseConnection;
	createBulkDiscounts: DiscountConnection;
	createBulkEmailAddresses: EmailAddressConnection;
	createBulkEmployees: EmployeeConnection;
	createBulkEnrollmentApplicationGuardians: EnrollmentApplicationGuardianConnection;
	createBulkEnrollmentApplicationStudentSchools: EnrollmentApplicationStudentSchoolConnection;
	createBulkEnrollmentApplicationStudents: EnrollmentApplicationStudentConnection;
	createBulkEnrollmentApplications: EnrollmentApplicationConnection;
	createBulkGuardians: GuardianConnection;
	createBulkHomeRoomSections: HomeRoomSectionConnection;
	createBulkHomeRooms: HomeRoomConnection;
	createBulkInvoiceLineItems: InvoiceLineItemConnection;
	createBulkInvoices: InvoiceConnection;
	createBulkLanguages: LanguageConnection;
	createBulkLearningObjectiveCategories: LearningObjectiveCategoryConnection;
	createBulkLearningObjectives: LearningObjectiveConnection;
	createBulkMarkValues: MarkValueConnection;
	createBulkMarkingSystems: MarkingSystemConnection;
	createBulkMediaAttachments: MediaAttachmentConnection;
	createBulkMedicalConditions: MedicalConditionConnection;
	createBulkMedications: MedicationConnection;
	createBulkMessageAvailabilityPeriods: MessageAvailabilityPeriodConnection;
	createBulkMessageGroupArchivePoints: MessageGroupArchivePointConnection;
	createBulkMessageGroups: MessageGroupConnection;
	createBulkMessageTopics: MessageTopicConnection;
	createBulkMessages: MessageConnection;
	createBulkNewsletters: NewsletterConnection;
	createBulkPaymentLineItems: PaymentLineItemConnection;
	createBulkPayments: PaymentConnection;
	createBulkPeople: PersonConnection;
	createBulkPermissionGroups: PermissionGroupConnection;
	createBulkPhoneNumbers: PhoneNumberConnection;
	createBulkPosts: PostConnection;
	createBulkQuotations: QuotationConnection;
	createBulkRefunds: RefundConnection;
	createBulkRelationships: RelationshipConnection;
	createBulkReportCardSectionLearningObjectives: ReportCardSectionLearningObjectiveConnection;
	createBulkReportCardSectionPolicies: ReportCardSectionPolicyConnection;
	createBulkReportCardSections: ReportCardSectionConnection;
	createBulkReportCards: ReportCardConnection;
	createBulkRooms: RoomConnection;
	createBulkSchoolAttendanceRecords: SchoolAttendanceRecordConnection;
	createBulkServices: ServiceConnection;
	createBulkSharingRecords: SharingRecordConnection;
	createBulkSocialComments: SocialCommentConnection;
	createBulkSocialReactions: SocialReactionConnection;
	createBulkStudentAcademicNotes: StudentAcademicNoteConnection;
	createBulkStudentAcademicTermEnrollments: StudentAcademicTermEnrollmentConnection;
	createBulkStudentAttendanceNotes: StudentAttendanceNoteConnection;
	createBulkStudentBehaviorNotes: StudentBehaviorNoteConnection;
	createBulkStudentCourseSectionEnrollments: StudentCourseSectionEnrollmentConnection;
	createBulkStudentDataConsents: StudentDataConsentConnection;
	createBulkStudentEnrollmentApplications: StudentEnrollmentApplicationConnection;
	createBulkStudentEnrollmentIntents: StudentEnrollmentIntentConnection;
	createBulkStudentHealthNotes: StudentHealthNoteConnection;
	createBulkStudentHomeRoomSectionEnrollments: StudentHomeRoomSectionEnrollmentConnection;
	createBulkStudentIncidentNotes: StudentIncidentNoteConnection;
	createBulkStudentInformationVerifications: StudentInformationVerificationConnection;
	createBulkStudentInjuryNotes: StudentInjuryNoteConnection;
	createBulkStudentMedicalConditions: StudentMedicalConditionConnection;
	createBulkStudentMedicalContacts: StudentMedicalContactConnection;
	createBulkStudentMedicalEvents: StudentMedicalEventConnection;
	createBulkStudentMedicalProfiles: StudentMedicalProfileConnection;
	createBulkStudentMedicationNotes: StudentMedicationNoteConnection;
	createBulkStudentNotes: StudentNoteConnection;
	createBulkStudentOTCMedications: StudentOTCMedicationConnection;
	createBulkStudentPrescriptionMedications: StudentPrescriptionMedicationConnection;
	createBulkStudentSocialEmotionalNotes: StudentSocialEmotionalNoteConnection;
	createBulkStudentVaccinationRecords: StudentVaccinationRecordConnection;
	createBulkStudents: StudentConnection;
	createBulkTeacherCourseSectionEnrollments: TeacherCourseSectionEnrollmentConnection;
	createBulkTeacherHomeRoomSectionEnrollments: TeacherHomeRoomSectionEnrollmentConnection;
	createBulkUserGroups: UserGroupConnection;
	createBulkUserViewRecords: UserViewRecordConnection;
	createBulkUsers: UserConnection;
	createBulkVaccines: VaccineConnection;
	createCalendarEvent: CalendarEvent;
	createCalendarEventResponse: CalendarEventResponse;
	createCampus: Campus;
	createClassYear: ClassYear;
	createClassYearCategory: ClassYearCategory;
	createContract: Contract;
	createContractInstallment: ContractInstallment;
	createContractLineItem: ContractLineItem;
	createCountry: Country;
	createCourse: Course;
	createCourseAssessment: CourseAssessment;
	createCourseAssessmentCategory: CourseAssessmentCategory;
	createCourseAssessmentCategoryMarkPortion: CourseAssessmentCategoryMarkPortion;
	createCourseAssessmentMark: CourseAssessmentMark;
	createCourseAssessmentSubmission: CourseAssessmentSubmission;
	createCourseAssessmentTiming: CourseAssessmentTiming;
	createCourseAttendanceRecord: CourseAttendanceRecord;
	createCourseSection: CourseSection;
	createCourseSectionPeriod: CourseSectionPeriod;
	createDiscount: Discount;
	createEmailAddress: EmailAddress;
	createEmployee: Employee;
	createEnrollmentApplication: EnrollmentApplication;
	createEnrollmentApplicationGuardian: EnrollmentApplicationGuardian;
	createEnrollmentApplicationStudent: EnrollmentApplicationStudent;
	createEnrollmentApplicationStudentSchool: EnrollmentApplicationStudentSchool;
	createGuardian: Guardian;
	createHomeRoom: HomeRoom;
	createHomeRoomSection: HomeRoomSection;
	createInvoice: Invoice;
	createInvoiceForContractInstallment: Invoice;
	createInvoiceLineItem: InvoiceLineItem;
	createLanguage: Language;
	createLearningObjective: LearningObjective;
	createLearningObjectiveCategory: LearningObjectiveCategory;
	createMarkValue: MarkValue;
	createMarkingSystem: MarkingSystem;
	createMediaAttachment: MediaAttachment;
	createMedicalCondition: MedicalCondition;
	createMedication: Medication;
	createMessage: Message;
	createMessageAvailabilityPeriod: MessageAvailabilityPeriod;
	createMessageGroup: MessageGroup;
	createMessageGroupArchivePoint: MessageGroupArchivePoint;
	createMessageTopic: MessageTopic;
	createNewsletter: Newsletter;
	createOrUpdateBulkSchoolAttendanceRecordsOnDate: SchoolAttendanceRecordConnection;
	createOrUpdateBulkStudentEnrollmentIntents: StudentEnrollmentIntentConnection;
	createOrUpdateMessageGroup: MessageGroup;
	createOrUpdateRecentStudentDataConsents: Scalars["Boolean"]["output"];
	createPayment: Payment;
	createPaymentLineItem: PaymentLineItem;
	createPermissionGroup: PermissionGroup;
	createPerson: Person;
	createPhoneNumber: PhoneNumber;
	createPost: Post;
	createQuotation: Quotation;
	createRefund: Refund;
	createRelationship: Relationship;
	createReportCard: ReportCard;
	createReportCardSection: ReportCardSection;
	createReportCardSectionLearningObjective: ReportCardSectionLearningObjective;
	createReportCardSectionPolicy: ReportCardSectionPolicy;
	createRoom: Room;
	createSchoolAttendanceRecord: SchoolAttendanceRecord;
	createService: Service;
	createSharingRecord: SharingRecord;
	createSocialComment: SocialComment;
	createSocialReaction: SocialReaction;
	createStudent: Student;
	createStudentAcademicNote: StudentAcademicNote;
	createStudentAcademicTermEnrollment: StudentAcademicTermEnrollment;
	createStudentAttendanceNote: StudentAttendanceNote;
	createStudentBehaviorNote: StudentBehaviorNote;
	createStudentCourseSectionEnrollment: StudentCourseSectionEnrollment;
	createStudentDataConsent: StudentDataConsent;
	createStudentEnrollmentApplication: StudentEnrollmentApplication;
	createStudentEnrollmentIntent: StudentEnrollmentIntent;
	createStudentFromWizard: StudentConnection;
	createStudentHealthNote: StudentHealthNote;
	createStudentHomeRoomSectionEnrollment: StudentHomeRoomSectionEnrollment;
	createStudentIncidentNote: StudentIncidentNote;
	createStudentInformationVerification: StudentInformationVerification;
	createStudentInjuryNote: StudentInjuryNote;
	createStudentMedicalCondition: StudentMedicalCondition;
	createStudentMedicalContact: StudentMedicalContact;
	createStudentMedicalEvent: StudentMedicalEvent;
	createStudentMedicalProfile: StudentMedicalProfile;
	createStudentMedicationNote: StudentMedicationNote;
	createStudentNote: StudentNote;
	createStudentOTCMedication: StudentOTCMedication;
	createStudentPrescriptionMedication: StudentPrescriptionMedication;
	createStudentSocialEmotionalNote: StudentSocialEmotionalNote;
	createStudentVaccinationRecord: StudentVaccinationRecord;
	createTeacherCourseSectionEnrollment: TeacherCourseSectionEnrollment;
	createTeacherHomeRoomSectionEnrollment: TeacherHomeRoomSectionEnrollment;
	createUser: User;
	createUserGroup: UserGroup;
	createUserViewRecord: UserViewRecord;
	createVaccine: Vaccine;
	deleteAcademicSubject: Scalars["Boolean"]["output"];
	deleteAcademicTerm: Scalars["Boolean"]["output"];
	deleteAcademicYear: Scalars["Boolean"]["output"];
	deleteAddress: Scalars["Boolean"]["output"];
	deleteAnnouncement: Scalars["Boolean"]["output"];
	deleteAttendanceStatus: Scalars["Boolean"]["output"];
	deleteBillingAdjustment: Scalars["Boolean"]["output"];
	deleteBuilding: Scalars["Boolean"]["output"];
	deleteBuildingFloor: Scalars["Boolean"]["output"];
	deleteBulkAcademicSubjects: DeleteBulkResponse;
	deleteBulkAcademicTerms: DeleteBulkResponse;
	deleteBulkAcademicYears: DeleteBulkResponse;
	deleteBulkAddresses: DeleteBulkResponse;
	deleteBulkAnnouncements: DeleteBulkResponse;
	deleteBulkAttendanceStatuses: DeleteBulkResponse;
	deleteBulkBillingAdjustments: DeleteBulkResponse;
	deleteBulkBuildingFloors: DeleteBulkResponse;
	deleteBulkBuildings: DeleteBulkResponse;
	deleteBulkCalendarEventResponses: DeleteBulkResponse;
	deleteBulkCalendarEvents: DeleteBulkResponse;
	deleteBulkCampuses: DeleteBulkResponse;
	deleteBulkClassYearCategories: DeleteBulkResponse;
	deleteBulkClassYears: DeleteBulkResponse;
	deleteBulkContractInstallments: DeleteBulkResponse;
	deleteBulkContractLineItems: DeleteBulkResponse;
	deleteBulkContracts: DeleteBulkResponse;
	deleteBulkCountries: DeleteBulkResponse;
	deleteBulkCourseAssessmentCategories: DeleteBulkResponse;
	deleteBulkCourseAssessmentCategoryMarkPortions: DeleteBulkResponse;
	deleteBulkCourseAssessmentMarks: DeleteBulkResponse;
	deleteBulkCourseAssessmentSubmissions: DeleteBulkResponse;
	deleteBulkCourseAssessmentTimings: DeleteBulkResponse;
	deleteBulkCourseAssessments: DeleteBulkResponse;
	deleteBulkCourseAttendanceRecords: DeleteBulkResponse;
	deleteBulkCourseSectionPeriods: DeleteBulkResponse;
	deleteBulkCourseSections: DeleteBulkResponse;
	deleteBulkCourses: DeleteBulkResponse;
	deleteBulkDiscounts: DeleteBulkResponse;
	deleteBulkEmailAddresses: DeleteBulkResponse;
	deleteBulkEmployees: DeleteBulkResponse;
	deleteBulkEnrollmentApplicationGuardians: DeleteBulkResponse;
	deleteBulkEnrollmentApplicationStudentSchools: DeleteBulkResponse;
	deleteBulkEnrollmentApplicationStudents: DeleteBulkResponse;
	deleteBulkEnrollmentApplications: DeleteBulkResponse;
	deleteBulkGuardians: DeleteBulkResponse;
	deleteBulkHomeRoomSections: DeleteBulkResponse;
	deleteBulkHomeRooms: DeleteBulkResponse;
	deleteBulkInvoiceLineItems: DeleteBulkResponse;
	deleteBulkInvoices: DeleteBulkResponse;
	deleteBulkLanguages: DeleteBulkResponse;
	deleteBulkLearningObjectiveCategories: DeleteBulkResponse;
	deleteBulkLearningObjectives: DeleteBulkResponse;
	deleteBulkMarkValues: DeleteBulkResponse;
	deleteBulkMarkingSystems: DeleteBulkResponse;
	deleteBulkMediaAttachments: DeleteBulkResponse;
	deleteBulkMedicalConditions: DeleteBulkResponse;
	deleteBulkMedications: DeleteBulkResponse;
	deleteBulkMessageAvailabilityPeriods: DeleteBulkResponse;
	deleteBulkMessageGroupArchivePoints: DeleteBulkResponse;
	deleteBulkMessageGroups: DeleteBulkResponse;
	deleteBulkMessageTopics: DeleteBulkResponse;
	deleteBulkMessages: DeleteBulkResponse;
	deleteBulkNewsletters: DeleteBulkResponse;
	deleteBulkPaymentLineItems: DeleteBulkResponse;
	deleteBulkPayments: DeleteBulkResponse;
	deleteBulkPeople: DeleteBulkResponse;
	deleteBulkPermissionGroups: DeleteBulkResponse;
	deleteBulkPhoneNumbers: DeleteBulkResponse;
	deleteBulkPosts: DeleteBulkResponse;
	deleteBulkQuotations: DeleteBulkResponse;
	deleteBulkRefunds: DeleteBulkResponse;
	deleteBulkRelationships: DeleteBulkResponse;
	deleteBulkReportCardSectionLearningObjectives: DeleteBulkResponse;
	deleteBulkReportCardSectionPolicies: DeleteBulkResponse;
	deleteBulkReportCardSections: DeleteBulkResponse;
	deleteBulkReportCards: DeleteBulkResponse;
	deleteBulkRooms: DeleteBulkResponse;
	deleteBulkSchoolAttendanceRecords: DeleteBulkResponse;
	deleteBulkServices: DeleteBulkResponse;
	deleteBulkSharingRecords: DeleteBulkResponse;
	deleteBulkSocialComments: DeleteBulkResponse;
	deleteBulkSocialReactions: DeleteBulkResponse;
	deleteBulkStudentAcademicNotes: DeleteBulkResponse;
	deleteBulkStudentAcademicTermEnrollments: DeleteBulkResponse;
	deleteBulkStudentAttendanceNotes: DeleteBulkResponse;
	deleteBulkStudentBehaviorNotes: DeleteBulkResponse;
	deleteBulkStudentCourseSectionEnrollments: DeleteBulkResponse;
	deleteBulkStudentDataConsents: DeleteBulkResponse;
	deleteBulkStudentEnrollmentApplications: DeleteBulkResponse;
	deleteBulkStudentEnrollmentIntents: DeleteBulkResponse;
	deleteBulkStudentHealthNotes: DeleteBulkResponse;
	deleteBulkStudentHomeRoomSectionEnrollments: DeleteBulkResponse;
	deleteBulkStudentIncidentNotes: DeleteBulkResponse;
	deleteBulkStudentInformationVerifications: DeleteBulkResponse;
	deleteBulkStudentInjuryNotes: DeleteBulkResponse;
	deleteBulkStudentMedicalConditions: DeleteBulkResponse;
	deleteBulkStudentMedicalContacts: DeleteBulkResponse;
	deleteBulkStudentMedicalEvents: DeleteBulkResponse;
	deleteBulkStudentMedicalProfiles: DeleteBulkResponse;
	deleteBulkStudentMedicationNotes: DeleteBulkResponse;
	deleteBulkStudentNotes: DeleteBulkResponse;
	deleteBulkStudentOTCMedications: DeleteBulkResponse;
	deleteBulkStudentPrescriptionMedications: DeleteBulkResponse;
	deleteBulkStudentSocialEmotionalNotes: DeleteBulkResponse;
	deleteBulkStudentVaccinationRecords: DeleteBulkResponse;
	deleteBulkStudents: DeleteBulkResponse;
	deleteBulkTeacherCourseSectionEnrollments: DeleteBulkResponse;
	deleteBulkTeacherHomeRoomSectionEnrollments: DeleteBulkResponse;
	deleteBulkUserGroups: DeleteBulkResponse;
	deleteBulkUserViewRecords: DeleteBulkResponse;
	deleteBulkUsers: DeleteBulkResponse;
	deleteBulkVaccines: DeleteBulkResponse;
	deleteCalendarEvent: Scalars["Boolean"]["output"];
	deleteCalendarEventResponse: Scalars["Boolean"]["output"];
	deleteCampus: Scalars["Boolean"]["output"];
	deleteClassYear: Scalars["Boolean"]["output"];
	deleteClassYearCategory: Scalars["Boolean"]["output"];
	deleteContract: Scalars["Boolean"]["output"];
	deleteContractInstallment: Scalars["Boolean"]["output"];
	deleteContractLineItem: Scalars["Boolean"]["output"];
	deleteCountry: Scalars["Boolean"]["output"];
	deleteCourse: Scalars["Boolean"]["output"];
	deleteCourseAssessment: Scalars["Boolean"]["output"];
	deleteCourseAssessmentCategory: Scalars["Boolean"]["output"];
	deleteCourseAssessmentCategoryMarkPortion: Scalars["Boolean"]["output"];
	deleteCourseAssessmentMark: Scalars["Boolean"]["output"];
	deleteCourseAssessmentSubmission: Scalars["Boolean"]["output"];
	deleteCourseAssessmentTiming: Scalars["Boolean"]["output"];
	deleteCourseAttendanceRecord: Scalars["Boolean"]["output"];
	deleteCourseSection: Scalars["Boolean"]["output"];
	deleteCourseSectionPeriod: Scalars["Boolean"]["output"];
	deleteDiscount: Scalars["Boolean"]["output"];
	deleteEmailAddress: Scalars["Boolean"]["output"];
	deleteEmployee: Scalars["Boolean"]["output"];
	deleteEnrollmentApplication: Scalars["Boolean"]["output"];
	deleteEnrollmentApplicationGuardian: Scalars["Boolean"]["output"];
	deleteEnrollmentApplicationStudent: Scalars["Boolean"]["output"];
	deleteEnrollmentApplicationStudentSchool: Scalars["Boolean"]["output"];
	deleteGuardian: Scalars["Boolean"]["output"];
	deleteHomeRoom: Scalars["Boolean"]["output"];
	deleteHomeRoomSection: Scalars["Boolean"]["output"];
	deleteInvoice: Scalars["Boolean"]["output"];
	deleteInvoiceLineItem: Scalars["Boolean"]["output"];
	deleteLanguage: Scalars["Boolean"]["output"];
	deleteLearningObjective: Scalars["Boolean"]["output"];
	deleteLearningObjectiveCategory: Scalars["Boolean"]["output"];
	deleteMarkValue: Scalars["Boolean"]["output"];
	deleteMarkingSystem: Scalars["Boolean"]["output"];
	deleteMediaAttachment: Scalars["Boolean"]["output"];
	deleteMedicalCondition: Scalars["Boolean"]["output"];
	deleteMedication: Scalars["Boolean"]["output"];
	deleteMessage: Scalars["Boolean"]["output"];
	deleteMessageAvailabilityPeriod: Scalars["Boolean"]["output"];
	deleteMessageGroup: Scalars["Boolean"]["output"];
	deleteMessageGroupArchivePoint: Scalars["Boolean"]["output"];
	deleteMessageTopic: Scalars["Boolean"]["output"];
	deleteNewsletter: Scalars["Boolean"]["output"];
	deletePayment: Scalars["Boolean"]["output"];
	deletePaymentLineItem: Scalars["Boolean"]["output"];
	deletePermissionGroup: Scalars["Boolean"]["output"];
	deletePerson: Scalars["Boolean"]["output"];
	deletePhoneNumber: Scalars["Boolean"]["output"];
	deletePost: Scalars["Boolean"]["output"];
	deleteQuotation: Scalars["Boolean"]["output"];
	deleteRefund: Scalars["Boolean"]["output"];
	deleteRelationship: Scalars["Boolean"]["output"];
	deleteReportCard: Scalars["Boolean"]["output"];
	deleteReportCardSection: Scalars["Boolean"]["output"];
	deleteReportCardSectionLearningObjective: Scalars["Boolean"]["output"];
	deleteReportCardSectionPolicy: Scalars["Boolean"]["output"];
	deleteRoom: Scalars["Boolean"]["output"];
	deleteSchoolAttendanceRecord: Scalars["Boolean"]["output"];
	deleteService: Scalars["Boolean"]["output"];
	deleteSharingRecord: Scalars["Boolean"]["output"];
	deleteSocialComment: Scalars["Boolean"]["output"];
	deleteSocialReaction: Scalars["Boolean"]["output"];
	deleteStudent: Scalars["Boolean"]["output"];
	deleteStudentAcademicNote: Scalars["Boolean"]["output"];
	deleteStudentAcademicTermEnrollment: Scalars["Boolean"]["output"];
	deleteStudentAttendanceNote: Scalars["Boolean"]["output"];
	deleteStudentBehaviorNote: Scalars["Boolean"]["output"];
	deleteStudentCourseSectionEnrollment: Scalars["Boolean"]["output"];
	deleteStudentDataConsent: Scalars["Boolean"]["output"];
	deleteStudentEnrollmentApplication: Scalars["Boolean"]["output"];
	deleteStudentEnrollmentIntent: Scalars["Boolean"]["output"];
	deleteStudentHealthNote: Scalars["Boolean"]["output"];
	deleteStudentHomeRoomSectionEnrollment: Scalars["Boolean"]["output"];
	deleteStudentIncidentNote: Scalars["Boolean"]["output"];
	deleteStudentInformationVerification: Scalars["Boolean"]["output"];
	deleteStudentInjuryNote: Scalars["Boolean"]["output"];
	deleteStudentMedicalCondition: Scalars["Boolean"]["output"];
	deleteStudentMedicalContact: Scalars["Boolean"]["output"];
	deleteStudentMedicalEvent: Scalars["Boolean"]["output"];
	deleteStudentMedicalProfile: Scalars["Boolean"]["output"];
	deleteStudentMedicationNote: Scalars["Boolean"]["output"];
	deleteStudentNote: Scalars["Boolean"]["output"];
	deleteStudentOTCMedication: Scalars["Boolean"]["output"];
	deleteStudentPrescriptionMedication: Scalars["Boolean"]["output"];
	deleteStudentSocialEmotionalNote: Scalars["Boolean"]["output"];
	deleteStudentVaccinationRecord: Scalars["Boolean"]["output"];
	deleteTeacherCourseSectionEnrollment: Scalars["Boolean"]["output"];
	deleteTeacherHomeRoomSectionEnrollment: Scalars["Boolean"]["output"];
	deleteUser: Scalars["Boolean"]["output"];
	deleteUserGroup: Scalars["Boolean"]["output"];
	deleteUserViewRecord: Scalars["Boolean"]["output"];
	deleteVaccine: Scalars["Boolean"]["output"];
	guardianOnboardingSubmission: Scalars["Boolean"]["output"];
	inviteUser: Scalars["Boolean"]["output"];
	recordView: UserViewRecord;
	recordViews: UserViewRecordConnection;
	removeMealPlanFromContract: Scalars["Boolean"]["output"];
	root: Scalars["Boolean"]["output"];
	sendParentPortalInviteMessage: Scalars["Boolean"]["output"];
	sendReEnrollmentConfirmationMessage: Scalars["Boolean"]["output"];
	sendReEnrollmentInviteMessage: Scalars["Boolean"]["output"];
	sendReportCardReleaseMessage: Scalars["Boolean"]["output"];
	setInstallmentFeeOnContract: Scalars["Boolean"]["output"];
	setMealPlanOnContract: Scalars["Boolean"]["output"];
	setPaymentPlanOnContract: Scalars["Boolean"]["output"];
	setStudentEnrollment: Scalars["Boolean"]["output"];
	submitEnrollmentApplication: EnrollmentApplication;
	unenrollStudentFromAcademicTerm: StudentAcademicTermUnenrollmentResult;
	updateAcademicSubject: AcademicSubject;
	updateAcademicTerm: AcademicTerm;
	updateAcademicYear: AcademicYear;
	updateAddress: Address;
	updateAnnouncement: Announcement;
	updateAttendanceStatus: AttendanceStatus;
	updateBillingAdjustment: BillingAdjustment;
	updateBuilding: Building;
	updateBuildingFloor: BuildingFloor;
	updateBulkAcademicSubjects: AcademicSubjectConnection;
	updateBulkAcademicTerms: AcademicTermConnection;
	updateBulkAcademicYears: AcademicYearConnection;
	updateBulkAddresses: AddressConnection;
	updateBulkAnnouncements: AnnouncementConnection;
	updateBulkAttendanceStatuses: AttendanceStatusConnection;
	updateBulkBillingAdjustments: BillingAdjustmentConnection;
	updateBulkBuildingFloors: BuildingFloorConnection;
	updateBulkBuildings: BuildingConnection;
	updateBulkCalendarEventResponses: CalendarEventResponseConnection;
	updateBulkCalendarEvents: CalendarEventConnection;
	updateBulkCampuses: CampusConnection;
	updateBulkClassYearCategories: ClassYearCategoryConnection;
	updateBulkClassYears: ClassYearConnection;
	updateBulkContractInstallments: ContractInstallmentConnection;
	updateBulkContractLineItems: ContractLineItemConnection;
	updateBulkContracts: ContractConnection;
	updateBulkCountries: CountryConnection;
	updateBulkCourseAssessmentCategories: CourseAssessmentCategoryConnection;
	updateBulkCourseAssessmentCategoryMarkPortions: CourseAssessmentCategoryMarkPortionConnection;
	updateBulkCourseAssessmentMarks: CourseAssessmentMarkConnection;
	updateBulkCourseAssessmentSubmissions: CourseAssessmentSubmissionConnection;
	updateBulkCourseAssessmentTimings: CourseAssessmentTimingConnection;
	updateBulkCourseAssessments: CourseAssessmentConnection;
	updateBulkCourseAttendanceRecords: CourseAttendanceRecordConnection;
	updateBulkCourseSectionPeriods: CourseSectionPeriodConnection;
	updateBulkCourseSections: CourseSectionConnection;
	updateBulkCourses: CourseConnection;
	updateBulkDiscounts: DiscountConnection;
	updateBulkEmailAddresses: EmailAddressConnection;
	updateBulkEmployees: EmployeeConnection;
	updateBulkEnrollmentApplicationGuardians: EnrollmentApplicationGuardianConnection;
	updateBulkEnrollmentApplicationStudentSchools: EnrollmentApplicationStudentSchoolConnection;
	updateBulkEnrollmentApplicationStudents: EnrollmentApplicationStudentConnection;
	updateBulkEnrollmentApplications: EnrollmentApplicationConnection;
	updateBulkGuardians: GuardianConnection;
	updateBulkHomeRoomSections: HomeRoomSectionConnection;
	updateBulkHomeRooms: HomeRoomConnection;
	updateBulkInvoiceLineItems: InvoiceLineItemConnection;
	updateBulkInvoices: InvoiceConnection;
	updateBulkLanguages: LanguageConnection;
	updateBulkLearningObjectiveCategories: LearningObjectiveCategoryConnection;
	updateBulkLearningObjectives: LearningObjectiveConnection;
	updateBulkMarkValues: MarkValueConnection;
	updateBulkMarkingSystems: MarkingSystemConnection;
	updateBulkMediaAttachments: MediaAttachmentConnection;
	updateBulkMedicalConditions: MedicalConditionConnection;
	updateBulkMedications: MedicationConnection;
	updateBulkMessageAvailabilityPeriods: MessageAvailabilityPeriodConnection;
	updateBulkMessageGroups: MessageGroupConnection;
	updateBulkMessageTopics: MessageTopicConnection;
	updateBulkMessages: MessageConnection;
	updateBulkNewsletters: NewsletterConnection;
	updateBulkPaymentLineItems: PaymentLineItemConnection;
	updateBulkPayments: PaymentConnection;
	updateBulkPeople: PersonConnection;
	updateBulkPermissionGroups: PermissionGroupConnection;
	updateBulkPermissions: PermissionConnection;
	updateBulkPhoneNumbers: PhoneNumberConnection;
	updateBulkPosts: PostConnection;
	updateBulkQuotations: QuotationConnection;
	updateBulkRefunds: RefundConnection;
	updateBulkRelationships: RelationshipConnection;
	updateBulkReportCardSectionLearningObjectives: ReportCardSectionLearningObjectiveConnection;
	updateBulkReportCardSectionPolicies: ReportCardSectionPolicyConnection;
	updateBulkReportCardSections: ReportCardSectionConnection;
	updateBulkReportCards: ReportCardConnection;
	updateBulkRooms: RoomConnection;
	updateBulkSchoolAttendanceRecords: SchoolAttendanceRecordConnection;
	updateBulkServices: ServiceConnection;
	updateBulkSharingRecords: SharingRecordConnection;
	updateBulkSocialComments: SocialCommentConnection;
	updateBulkSocialReactions: SocialReactionConnection;
	updateBulkStudentAcademicNotes: StudentAcademicNoteConnection;
	updateBulkStudentAcademicTermEnrollments: StudentAcademicTermEnrollmentConnection;
	updateBulkStudentAttendanceNotes: StudentAttendanceNoteConnection;
	updateBulkStudentBehaviorNotes: StudentBehaviorNoteConnection;
	updateBulkStudentCourseSectionEnrollments: StudentCourseSectionEnrollmentConnection;
	updateBulkStudentDataConsents: StudentDataConsentConnection;
	updateBulkStudentEnrollmentApplications: StudentEnrollmentApplicationConnection;
	updateBulkStudentEnrollmentIntents: StudentEnrollmentIntentConnection;
	updateBulkStudentHealthNotes: StudentHealthNoteConnection;
	updateBulkStudentHomeRoomSectionEnrollments: StudentHomeRoomSectionEnrollmentConnection;
	updateBulkStudentIncidentNotes: StudentIncidentNoteConnection;
	updateBulkStudentInformationVerifications: StudentInformationVerificationConnection;
	updateBulkStudentInjuryNotes: StudentInjuryNoteConnection;
	updateBulkStudentMedicalConditions: StudentMedicalConditionConnection;
	updateBulkStudentMedicalContacts: StudentMedicalContactConnection;
	updateBulkStudentMedicalEvents: StudentMedicalEventConnection;
	updateBulkStudentMedicalProfiles: StudentMedicalProfileConnection;
	updateBulkStudentMedicationNotes: StudentMedicationNoteConnection;
	updateBulkStudentNotes: StudentNoteConnection;
	updateBulkStudentOTCMedications: StudentOTCMedicationConnection;
	updateBulkStudentPrescriptionMedications: StudentPrescriptionMedicationConnection;
	updateBulkStudentSocialEmotionalNotes: StudentSocialEmotionalNoteConnection;
	updateBulkStudentVaccinationRecords: StudentVaccinationRecordConnection;
	updateBulkStudents: StudentConnection;
	updateBulkTeacherCourseSectionEnrollments: TeacherCourseSectionEnrollmentConnection;
	updateBulkTeacherHomeRoomSectionEnrollments: TeacherHomeRoomSectionEnrollmentConnection;
	updateBulkUserGroups: UserGroupConnection;
	updateBulkUsers: UserConnection;
	updateBulkVaccines: VaccineConnection;
	updateCalendarEvent: CalendarEvent;
	updateCalendarEventResponse: CalendarEventResponse;
	updateCampus: Campus;
	updateClassYear: ClassYear;
	updateClassYearCategory: ClassYearCategory;
	updateContract: Contract;
	updateContractInstallment: ContractInstallment;
	updateContractLineItem: ContractLineItem;
	updateCountry: Country;
	updateCourse: Course;
	updateCourseAssessment: CourseAssessment;
	updateCourseAssessmentCategory: CourseAssessmentCategory;
	updateCourseAssessmentCategoryMarkPortion: CourseAssessmentCategoryMarkPortion;
	updateCourseAssessmentMark: CourseAssessmentMark;
	updateCourseAssessmentSubmission: CourseAssessmentSubmission;
	updateCourseAssessmentTiming: CourseAssessmentTiming;
	updateCourseAttendanceRecord: CourseAttendanceRecord;
	updateCourseSection: CourseSection;
	updateCourseSectionPeriod: CourseSectionPeriod;
	updateDiscount: Discount;
	updateEmailAddress: EmailAddress;
	updateEmployee: Employee;
	updateEnrollmentApplication: EnrollmentApplication;
	updateEnrollmentApplicationGuardian: EnrollmentApplicationGuardian;
	updateEnrollmentApplicationStudent: EnrollmentApplicationStudent;
	updateEnrollmentApplicationStudentSchool: EnrollmentApplicationStudentSchool;
	updateGuardian: Guardian;
	updateHomeRoom: HomeRoom;
	updateHomeRoomSection: HomeRoomSection;
	updateInvoice: Invoice;
	updateInvoiceLineItem: InvoiceLineItem;
	updateLanguage: Language;
	updateLearningObjective: LearningObjective;
	updateLearningObjectiveCategory: LearningObjectiveCategory;
	updateMarkValue: MarkValue;
	updateMarkingSystem: MarkingSystem;
	updateMediaAttachment: MediaAttachment;
	updateMedicalCondition: MedicalCondition;
	updateMedication: Medication;
	updateMessage: Message;
	updateMessageAvailabilityPeriod: MessageAvailabilityPeriod;
	updateMessageGroup: MessageGroup;
	updateMessageGroupArchivePoint: MessageGroupArchivePoint;
	updateMessageTopic: MessageTopic;
	updateNewsletter: Newsletter;
	updatePayment: Payment;
	updatePaymentLineItem: PaymentLineItem;
	updatePermission: Permission;
	updatePermissionGroup: PermissionGroup;
	updatePerson: Person;
	updatePhoneNumber: PhoneNumber;
	updatePost: Post;
	updateQuotation: Quotation;
	updateRefund: Refund;
	updateRelationship: Relationship;
	updateReportCard: ReportCard;
	updateReportCardSection: ReportCardSection;
	updateReportCardSectionLearningObjective: ReportCardSectionLearningObjective;
	updateReportCardSectionPolicy: ReportCardSectionPolicy;
	updateRoom: Room;
	updateSchoolAttendanceRecord: SchoolAttendanceRecord;
	updateService: Service;
	updateSharingRecord: SharingRecord;
	updateSocialComment: SocialComment;
	updateSocialReaction: SocialReaction;
	updateStudent: Student;
	updateStudentAcademicNote: StudentAcademicNote;
	updateStudentAcademicTermEnrollment: StudentAcademicTermEnrollment;
	updateStudentAttendanceNote: StudentAttendanceNote;
	updateStudentBehaviorNote: StudentBehaviorNote;
	updateStudentCourseSectionEnrollment: StudentCourseSectionEnrollment;
	updateStudentDataConsent: StudentDataConsent;
	updateStudentEnrollmentApplication: StudentEnrollmentApplication;
	updateStudentEnrollmentIntent: StudentEnrollmentIntent;
	updateStudentHealthNote: StudentHealthNote;
	updateStudentHomeRoomSectionEnrollment: StudentHomeRoomSectionEnrollment;
	updateStudentIncidentNote: StudentIncidentNote;
	updateStudentInformationVerification: StudentInformationVerification;
	updateStudentInjuryNote: StudentInjuryNote;
	updateStudentMedicalCondition: StudentMedicalCondition;
	updateStudentMedicalContact: StudentMedicalContact;
	updateStudentMedicalEvent: StudentMedicalEvent;
	updateStudentMedicalProfile: StudentMedicalProfile;
	updateStudentMedicationNote: StudentMedicationNote;
	updateStudentNote: StudentNote;
	updateStudentOTCMedication: StudentOTCMedication;
	updateStudentPrescriptionMedication: StudentPrescriptionMedication;
	updateStudentSocialEmotionalNote: StudentSocialEmotionalNote;
	updateStudentVaccinationRecord: StudentVaccinationRecord;
	updateTeacherCourseSectionEnrollment: TeacherCourseSectionEnrollment;
	updateTeacherHomeRoomSectionEnrollment: TeacherHomeRoomSectionEnrollment;
	updateUser: User;
	updateUserGroup: UserGroup;
	updateUserViewRecord: UserViewRecord;
	updateVaccine: Vaccine;
};

export type MutationCreateAcademicSubjectArgs = {
	input: AcademicSubjectCreateInput;
};

export type MutationCreateAcademicTermArgs = {
	input: AcademicTermCreateInput;
};

export type MutationCreateAcademicYearArgs = {
	input: AcademicYearCreateInput;
};

export type MutationCreateAddressArgs = {
	input: AddressCreateInput;
};

export type MutationCreateAnnouncementArgs = {
	input: AnnouncementCreateInput;
};

export type MutationCreateAttendanceStatusArgs = {
	input: AttendanceStatusCreateInput;
};

export type MutationCreateBillingAdjustmentArgs = {
	input: BillingAdjustmentCreateInput;
};

export type MutationCreateBuildingArgs = {
	input: BuildingCreateInput;
};

export type MutationCreateBuildingFloorArgs = {
	input: BuildingFloorCreateInput;
};

export type MutationCreateBulkAcademicSubjectsArgs = {
	inputs: Array<AcademicSubjectCreateInput>;
};

export type MutationCreateBulkAcademicTermsArgs = {
	inputs: Array<AcademicTermCreateInput>;
};

export type MutationCreateBulkAcademicYearsArgs = {
	inputs: Array<AcademicYearCreateInput>;
};

export type MutationCreateBulkAddressesArgs = {
	inputs: Array<AddressCreateInput>;
};

export type MutationCreateBulkAnnouncementsArgs = {
	inputs: Array<AnnouncementCreateInput>;
};

export type MutationCreateBulkAttendanceStatusesArgs = {
	inputs: Array<AttendanceStatusCreateInput>;
};

export type MutationCreateBulkBillingAdjustmentsArgs = {
	inputs: Array<BillingAdjustmentCreateInput>;
};

export type MutationCreateBulkBuildingFloorsArgs = {
	inputs: Array<BuildingFloorCreateInput>;
};

export type MutationCreateBulkBuildingsArgs = {
	inputs: Array<BuildingCreateInput>;
};

export type MutationCreateBulkCalendarEventResponsesArgs = {
	inputs: Array<CalendarEventResponseCreateInput>;
};

export type MutationCreateBulkCalendarEventsArgs = {
	inputs: Array<CalendarEventCreateInput>;
};

export type MutationCreateBulkCampusesArgs = {
	inputs: Array<CampusCreateInput>;
};

export type MutationCreateBulkClassYearCategoriesArgs = {
	inputs: Array<ClassYearCategoryCreateInput>;
};

export type MutationCreateBulkClassYearsArgs = {
	inputs: Array<ClassYearCreateInput>;
};

export type MutationCreateBulkContractInstallmentsArgs = {
	inputs: Array<ContractInstallmentCreateInput>;
};

export type MutationCreateBulkContractLineItemsArgs = {
	inputs: Array<ContractLineItemCreateInput>;
};

export type MutationCreateBulkContractsArgs = {
	inputs: Array<ContractCreateInput>;
};

export type MutationCreateBulkCountriesArgs = {
	inputs: Array<CountryCreateInput>;
};

export type MutationCreateBulkCourseAssessmentCategoriesArgs = {
	inputs: Array<CourseAssessmentCategoryCreateInput>;
};

export type MutationCreateBulkCourseAssessmentCategoryMarkPortionsArgs = {
	inputs: Array<CourseAssessmentCategoryMarkPortionCreateInput>;
};

export type MutationCreateBulkCourseAssessmentMarksArgs = {
	inputs: Array<CourseAssessmentMarkCreateInput>;
};

export type MutationCreateBulkCourseAssessmentSubmissionsArgs = {
	inputs: Array<CourseAssessmentSubmissionCreateInput>;
};

export type MutationCreateBulkCourseAssessmentTimingsArgs = {
	inputs: Array<CourseAssessmentTimingCreateInput>;
};

export type MutationCreateBulkCourseAssessmentsArgs = {
	inputs: Array<CourseAssessmentCreateInput>;
};

export type MutationCreateBulkCourseAttendanceRecordsArgs = {
	inputs: Array<CourseAttendanceRecordCreateInput>;
};

export type MutationCreateBulkCourseSectionPeriodsArgs = {
	inputs: Array<CourseSectionPeriodCreateInput>;
};

export type MutationCreateBulkCourseSectionsArgs = {
	inputs: Array<CourseSectionCreateInput>;
};

export type MutationCreateBulkCoursesArgs = {
	inputs: Array<CourseCreateInput>;
};

export type MutationCreateBulkDiscountsArgs = {
	inputs: Array<DiscountCreateInput>;
};

export type MutationCreateBulkEmailAddressesArgs = {
	inputs: Array<EmailAddressCreateInput>;
};

export type MutationCreateBulkEmployeesArgs = {
	inputs: Array<EmployeeCreateInput>;
};

export type MutationCreateBulkEnrollmentApplicationGuardiansArgs = {
	inputs: Array<EnrollmentApplicationGuardianCreateInput>;
};

export type MutationCreateBulkEnrollmentApplicationStudentSchoolsArgs = {
	inputs: Array<EnrollmentApplicationStudentSchoolCreateInput>;
};

export type MutationCreateBulkEnrollmentApplicationStudentsArgs = {
	inputs: Array<EnrollmentApplicationStudentCreateInput>;
};

export type MutationCreateBulkEnrollmentApplicationsArgs = {
	inputs: Array<EnrollmentApplicationCreateInput>;
};

export type MutationCreateBulkGuardiansArgs = {
	inputs: Array<GuardianCreateInput>;
};

export type MutationCreateBulkHomeRoomSectionsArgs = {
	inputs: Array<HomeRoomSectionCreateInput>;
};

export type MutationCreateBulkHomeRoomsArgs = {
	inputs: Array<HomeRoomCreateInput>;
};

export type MutationCreateBulkInvoiceLineItemsArgs = {
	inputs: Array<InvoiceLineItemCreateInput>;
};

export type MutationCreateBulkInvoicesArgs = {
	inputs: Array<InvoiceCreateInput>;
};

export type MutationCreateBulkLanguagesArgs = {
	inputs: Array<LanguageCreateInput>;
};

export type MutationCreateBulkLearningObjectiveCategoriesArgs = {
	inputs: Array<LearningObjectiveCategoryCreateInput>;
};

export type MutationCreateBulkLearningObjectivesArgs = {
	inputs: Array<LearningObjectiveCreateInput>;
};

export type MutationCreateBulkMarkValuesArgs = {
	inputs: Array<MarkValueCreateInput>;
};

export type MutationCreateBulkMarkingSystemsArgs = {
	inputs: Array<MarkingSystemCreateInput>;
};

export type MutationCreateBulkMediaAttachmentsArgs = {
	inputs: Array<MediaAttachmentCreateInput>;
};

export type MutationCreateBulkMedicalConditionsArgs = {
	inputs: Array<MedicalConditionCreateInput>;
};

export type MutationCreateBulkMedicationsArgs = {
	inputs: Array<MedicationCreateInput>;
};

export type MutationCreateBulkMessageAvailabilityPeriodsArgs = {
	inputs: Array<MessageAvailabilityPeriodCreateInput>;
};

export type MutationCreateBulkMessageGroupArchivePointsArgs = {
	inputs: Array<MessageGroupArchivePointCreateInput>;
};

export type MutationCreateBulkMessageGroupsArgs = {
	inputs: Array<MessageGroupCreateInput>;
};

export type MutationCreateBulkMessageTopicsArgs = {
	inputs: Array<MessageTopicCreateInput>;
};

export type MutationCreateBulkMessagesArgs = {
	inputs: Array<MessageCreateInput>;
};

export type MutationCreateBulkNewslettersArgs = {
	inputs: Array<NewsletterCreateInput>;
};

export type MutationCreateBulkPaymentLineItemsArgs = {
	inputs: Array<PaymentLineItemCreateInput>;
};

export type MutationCreateBulkPaymentsArgs = {
	inputs: Array<PaymentCreateInput>;
};

export type MutationCreateBulkPeopleArgs = {
	inputs: Array<PersonCreateInput>;
};

export type MutationCreateBulkPermissionGroupsArgs = {
	inputs: Array<PermissionGroupCreateInput>;
};

export type MutationCreateBulkPhoneNumbersArgs = {
	inputs: Array<PhoneNumberCreateInput>;
};

export type MutationCreateBulkPostsArgs = {
	inputs: Array<PostCreateInput>;
};

export type MutationCreateBulkQuotationsArgs = {
	inputs: Array<QuotationCreateInput>;
};

export type MutationCreateBulkRefundsArgs = {
	inputs: Array<RefundCreateInput>;
};

export type MutationCreateBulkRelationshipsArgs = {
	inputs: Array<RelationshipCreateInput>;
};

export type MutationCreateBulkReportCardSectionLearningObjectivesArgs = {
	inputs: Array<ReportCardSectionLearningObjectiveCreateInput>;
};

export type MutationCreateBulkReportCardSectionPoliciesArgs = {
	inputs: Array<ReportCardSectionPolicyCreateInput>;
};

export type MutationCreateBulkReportCardSectionsArgs = {
	inputs: Array<ReportCardSectionCreateInput>;
};

export type MutationCreateBulkReportCardsArgs = {
	inputs: Array<ReportCardCreateInput>;
};

export type MutationCreateBulkRoomsArgs = {
	inputs: Array<RoomCreateInput>;
};

export type MutationCreateBulkSchoolAttendanceRecordsArgs = {
	inputs: Array<SchoolAttendanceRecordCreateInput>;
};

export type MutationCreateBulkServicesArgs = {
	inputs: Array<ServiceCreateInput>;
};

export type MutationCreateBulkSharingRecordsArgs = {
	inputs: Array<SharingRecordCreateInput>;
};

export type MutationCreateBulkSocialCommentsArgs = {
	inputs: Array<SocialCommentCreateInput>;
};

export type MutationCreateBulkSocialReactionsArgs = {
	inputs: Array<SocialReactionCreateInput>;
};

export type MutationCreateBulkStudentAcademicNotesArgs = {
	inputs: Array<StudentAcademicNoteCreateInput>;
};

export type MutationCreateBulkStudentAcademicTermEnrollmentsArgs = {
	inputs: Array<StudentAcademicTermEnrollmentCreateInput>;
};

export type MutationCreateBulkStudentAttendanceNotesArgs = {
	inputs: Array<StudentAttendanceNoteCreateInput>;
};

export type MutationCreateBulkStudentBehaviorNotesArgs = {
	inputs: Array<StudentBehaviorNoteCreateInput>;
};

export type MutationCreateBulkStudentCourseSectionEnrollmentsArgs = {
	inputs: Array<StudentCourseSectionEnrollmentCreateInput>;
};

export type MutationCreateBulkStudentDataConsentsArgs = {
	inputs: Array<StudentDataConsentCreateInput>;
};

export type MutationCreateBulkStudentEnrollmentApplicationsArgs = {
	inputs: Array<StudentEnrollmentApplicationCreateInput>;
};

export type MutationCreateBulkStudentEnrollmentIntentsArgs = {
	inputs: Array<StudentEnrollmentIntentCreateInput>;
};

export type MutationCreateBulkStudentHealthNotesArgs = {
	inputs: Array<StudentHealthNoteCreateInput>;
};

export type MutationCreateBulkStudentHomeRoomSectionEnrollmentsArgs = {
	inputs: Array<StudentHomeRoomSectionEnrollmentCreateInput>;
};

export type MutationCreateBulkStudentIncidentNotesArgs = {
	inputs: Array<StudentIncidentNoteCreateInput>;
};

export type MutationCreateBulkStudentInformationVerificationsArgs = {
	inputs: Array<StudentInformationVerificationCreateInput>;
};

export type MutationCreateBulkStudentInjuryNotesArgs = {
	inputs: Array<StudentInjuryNoteCreateInput>;
};

export type MutationCreateBulkStudentMedicalConditionsArgs = {
	inputs: Array<StudentMedicalConditionCreateInput>;
};

export type MutationCreateBulkStudentMedicalContactsArgs = {
	inputs: Array<StudentMedicalContactCreateInput>;
};

export type MutationCreateBulkStudentMedicalEventsArgs = {
	inputs: Array<StudentMedicalEventCreateInput>;
};

export type MutationCreateBulkStudentMedicalProfilesArgs = {
	inputs: Array<StudentMedicalProfileCreateInput>;
};

export type MutationCreateBulkStudentMedicationNotesArgs = {
	inputs: Array<StudentMedicationNoteCreateInput>;
};

export type MutationCreateBulkStudentNotesArgs = {
	inputs: Array<StudentNoteCreateInput>;
};

export type MutationCreateBulkStudentOTCMedicationsArgs = {
	inputs: Array<StudentOTCMedicationCreateInput>;
};

export type MutationCreateBulkStudentPrescriptionMedicationsArgs = {
	inputs: Array<StudentPrescriptionMedicationCreateInput>;
};

export type MutationCreateBulkStudentSocialEmotionalNotesArgs = {
	inputs: Array<StudentSocialEmotionalNoteCreateInput>;
};

export type MutationCreateBulkStudentVaccinationRecordsArgs = {
	inputs: Array<StudentVaccinationRecordCreateInput>;
};

export type MutationCreateBulkStudentsArgs = {
	inputs: Array<StudentCreateInput>;
};

export type MutationCreateBulkTeacherCourseSectionEnrollmentsArgs = {
	inputs: Array<TeacherCourseSectionEnrollmentCreateInput>;
};

export type MutationCreateBulkTeacherHomeRoomSectionEnrollmentsArgs = {
	inputs: Array<TeacherHomeRoomSectionEnrollmentCreateInput>;
};

export type MutationCreateBulkUserGroupsArgs = {
	inputs: Array<UserGroupCreateInput>;
};

export type MutationCreateBulkUserViewRecordsArgs = {
	inputs: Array<UserViewRecordCreateInput>;
};

export type MutationCreateBulkUsersArgs = {
	inputs: Array<UserCreateInput>;
};

export type MutationCreateBulkVaccinesArgs = {
	inputs: Array<VaccineCreateInput>;
};

export type MutationCreateCalendarEventArgs = {
	input: CalendarEventCreateInput;
};

export type MutationCreateCalendarEventResponseArgs = {
	input: CalendarEventResponseCreateInput;
};

export type MutationCreateCampusArgs = {
	input: CampusCreateInput;
};

export type MutationCreateClassYearArgs = {
	input: ClassYearCreateInput;
};

export type MutationCreateClassYearCategoryArgs = {
	input: ClassYearCategoryCreateInput;
};

export type MutationCreateContractArgs = {
	input: ContractCreateInput;
};

export type MutationCreateContractInstallmentArgs = {
	input: ContractInstallmentCreateInput;
};

export type MutationCreateContractLineItemArgs = {
	input: ContractLineItemCreateInput;
};

export type MutationCreateCountryArgs = {
	input: CountryCreateInput;
};

export type MutationCreateCourseArgs = {
	input: CourseCreateInput;
};

export type MutationCreateCourseAssessmentArgs = {
	input: CourseAssessmentCreateInput;
};

export type MutationCreateCourseAssessmentCategoryArgs = {
	input: CourseAssessmentCategoryCreateInput;
};

export type MutationCreateCourseAssessmentCategoryMarkPortionArgs = {
	input: CourseAssessmentCategoryMarkPortionCreateInput;
};

export type MutationCreateCourseAssessmentMarkArgs = {
	input: CourseAssessmentMarkCreateInput;
};

export type MutationCreateCourseAssessmentSubmissionArgs = {
	input: CourseAssessmentSubmissionCreateInput;
};

export type MutationCreateCourseAssessmentTimingArgs = {
	input: CourseAssessmentTimingCreateInput;
};

export type MutationCreateCourseAttendanceRecordArgs = {
	input: CourseAttendanceRecordCreateInput;
};

export type MutationCreateCourseSectionArgs = {
	input: CourseSectionCreateInput;
};

export type MutationCreateCourseSectionPeriodArgs = {
	input: CourseSectionPeriodCreateInput;
};

export type MutationCreateDiscountArgs = {
	input: DiscountCreateInput;
};

export type MutationCreateEmailAddressArgs = {
	input: EmailAddressCreateInput;
};

export type MutationCreateEmployeeArgs = {
	input: EmployeeCreateInput;
};

export type MutationCreateEnrollmentApplicationArgs = {
	input: EnrollmentApplicationCreateInput;
};

export type MutationCreateEnrollmentApplicationGuardianArgs = {
	input: EnrollmentApplicationGuardianCreateInput;
};

export type MutationCreateEnrollmentApplicationStudentArgs = {
	input: EnrollmentApplicationStudentCreateInput;
};

export type MutationCreateEnrollmentApplicationStudentSchoolArgs = {
	input: EnrollmentApplicationStudentSchoolCreateInput;
};

export type MutationCreateGuardianArgs = {
	input: GuardianCreateInput;
};

export type MutationCreateHomeRoomArgs = {
	input: HomeRoomCreateInput;
};

export type MutationCreateHomeRoomSectionArgs = {
	input: HomeRoomSectionCreateInput;
};

export type MutationCreateInvoiceArgs = {
	input: InvoiceCreateInput;
};

export type MutationCreateInvoiceForContractInstallmentArgs = {
	contractInstallmentID: Scalars["ID"]["input"];
};

export type MutationCreateInvoiceLineItemArgs = {
	input: InvoiceLineItemCreateInput;
};

export type MutationCreateLanguageArgs = {
	input: LanguageCreateInput;
};

export type MutationCreateLearningObjectiveArgs = {
	input: LearningObjectiveCreateInput;
};

export type MutationCreateLearningObjectiveCategoryArgs = {
	input: LearningObjectiveCategoryCreateInput;
};

export type MutationCreateMarkValueArgs = {
	input: MarkValueCreateInput;
};

export type MutationCreateMarkingSystemArgs = {
	input: MarkingSystemCreateInput;
};

export type MutationCreateMediaAttachmentArgs = {
	input: MediaAttachmentCreateInput;
};

export type MutationCreateMedicalConditionArgs = {
	input: MedicalConditionCreateInput;
};

export type MutationCreateMedicationArgs = {
	input: MedicationCreateInput;
};

export type MutationCreateMessageArgs = {
	input: MessageCreateInput;
};

export type MutationCreateMessageAvailabilityPeriodArgs = {
	input: MessageAvailabilityPeriodCreateInput;
};

export type MutationCreateMessageGroupArgs = {
	input: MessageGroupCreateInput;
};

export type MutationCreateMessageGroupArchivePointArgs = {
	input: MessageGroupArchivePointCreateInput;
};

export type MutationCreateMessageTopicArgs = {
	input: MessageTopicCreateInput;
};

export type MutationCreateNewsletterArgs = {
	input: NewsletterCreateInput;
};

export type MutationCreateOrUpdateBulkSchoolAttendanceRecordsOnDateArgs = {
	attendanceDate: Scalars["Date"]["input"];
	attendanceStatusID: Scalars["ID"]["input"];
	studentIDs: Array<Scalars["ID"]["input"]>;
};

export type MutationCreateOrUpdateBulkStudentEnrollmentIntentsArgs = {
	inputs: Array<StudentEnrollmentIntentCreateInput>;
};

export type MutationCreateOrUpdateMessageGroupArgs = {
	input: MessageGroupCreateInput;
};

export type MutationCreateOrUpdateRecentStudentDataConsentsArgs = {
	studentDataConsentInput: StudentDataConsentCreateInput;
	studentIDs: Array<Scalars["ID"]["input"]>;
};

export type MutationCreatePaymentArgs = {
	input: PaymentCreateInput;
};

export type MutationCreatePaymentLineItemArgs = {
	input: PaymentLineItemCreateInput;
};

export type MutationCreatePermissionGroupArgs = {
	input: PermissionGroupCreateInput;
};

export type MutationCreatePersonArgs = {
	input: PersonCreateInput;
};

export type MutationCreatePhoneNumberArgs = {
	input: PhoneNumberCreateInput;
};

export type MutationCreatePostArgs = {
	input: PostCreateInput;
};

export type MutationCreateQuotationArgs = {
	input: QuotationCreateInput;
};

export type MutationCreateRefundArgs = {
	input: RefundCreateInput;
};

export type MutationCreateRelationshipArgs = {
	input: RelationshipCreateInput;
};

export type MutationCreateReportCardArgs = {
	input: ReportCardCreateInput;
};

export type MutationCreateReportCardSectionArgs = {
	input: ReportCardSectionCreateInput;
};

export type MutationCreateReportCardSectionLearningObjectiveArgs = {
	input: ReportCardSectionLearningObjectiveCreateInput;
};

export type MutationCreateReportCardSectionPolicyArgs = {
	input: ReportCardSectionPolicyCreateInput;
};

export type MutationCreateRoomArgs = {
	input: RoomCreateInput;
};

export type MutationCreateSchoolAttendanceRecordArgs = {
	input: SchoolAttendanceRecordCreateInput;
};

export type MutationCreateServiceArgs = {
	input: ServiceCreateInput;
};

export type MutationCreateSharingRecordArgs = {
	input: SharingRecordCreateInput;
};

export type MutationCreateSocialCommentArgs = {
	input: SocialCommentCreateInput;
};

export type MutationCreateSocialReactionArgs = {
	input: SocialReactionCreateInput;
};

export type MutationCreateStudentArgs = {
	input: StudentCreateInput;
};

export type MutationCreateStudentAcademicNoteArgs = {
	input: StudentAcademicNoteCreateInput;
};

export type MutationCreateStudentAcademicTermEnrollmentArgs = {
	input: StudentAcademicTermEnrollmentCreateInput;
};

export type MutationCreateStudentAttendanceNoteArgs = {
	input: StudentAttendanceNoteCreateInput;
};

export type MutationCreateStudentBehaviorNoteArgs = {
	input: StudentBehaviorNoteCreateInput;
};

export type MutationCreateStudentCourseSectionEnrollmentArgs = {
	input: StudentCourseSectionEnrollmentCreateInput;
};

export type MutationCreateStudentDataConsentArgs = {
	input: StudentDataConsentCreateInput;
};

export type MutationCreateStudentEnrollmentApplicationArgs = {
	input: StudentEnrollmentApplicationCreateInput;
};

export type MutationCreateStudentEnrollmentIntentArgs = {
	input: StudentEnrollmentIntentCreateInput;
};

export type MutationCreateStudentFromWizardArgs = {
	addressInputs: Array<AddressCreateInput>;
	guardianAddressPairs: Array<Array<Scalars["Int"]["input"]>>;
	guardianInputs: Array<GuardianCreateInput>;
	studentInputs: Array<StudentCreateInput>;
};

export type MutationCreateStudentHealthNoteArgs = {
	input: StudentHealthNoteCreateInput;
};

export type MutationCreateStudentHomeRoomSectionEnrollmentArgs = {
	input: StudentHomeRoomSectionEnrollmentCreateInput;
};

export type MutationCreateStudentIncidentNoteArgs = {
	input: StudentIncidentNoteCreateInput;
};

export type MutationCreateStudentInformationVerificationArgs = {
	input: StudentInformationVerificationCreateInput;
};

export type MutationCreateStudentInjuryNoteArgs = {
	input: StudentInjuryNoteCreateInput;
};

export type MutationCreateStudentMedicalConditionArgs = {
	input: StudentMedicalConditionCreateInput;
};

export type MutationCreateStudentMedicalContactArgs = {
	input: StudentMedicalContactCreateInput;
};

export type MutationCreateStudentMedicalEventArgs = {
	input: StudentMedicalEventCreateInput;
};

export type MutationCreateStudentMedicalProfileArgs = {
	input: StudentMedicalProfileCreateInput;
};

export type MutationCreateStudentMedicationNoteArgs = {
	input: StudentMedicationNoteCreateInput;
};

export type MutationCreateStudentNoteArgs = {
	input: StudentNoteCreateInput;
};

export type MutationCreateStudentOTCMedicationArgs = {
	input: StudentOTCMedicationCreateInput;
};

export type MutationCreateStudentPrescriptionMedicationArgs = {
	input: StudentPrescriptionMedicationCreateInput;
};

export type MutationCreateStudentSocialEmotionalNoteArgs = {
	input: StudentSocialEmotionalNoteCreateInput;
};

export type MutationCreateStudentVaccinationRecordArgs = {
	input: StudentVaccinationRecordCreateInput;
};

export type MutationCreateTeacherCourseSectionEnrollmentArgs = {
	input: TeacherCourseSectionEnrollmentCreateInput;
};

export type MutationCreateTeacherHomeRoomSectionEnrollmentArgs = {
	input: TeacherHomeRoomSectionEnrollmentCreateInput;
};

export type MutationCreateUserArgs = {
	input: UserCreateInput;
};

export type MutationCreateUserGroupArgs = {
	input: UserGroupCreateInput;
};

export type MutationCreateUserViewRecordArgs = {
	input: UserViewRecordCreateInput;
};

export type MutationCreateVaccineArgs = {
	input: VaccineCreateInput;
};

export type MutationDeleteAcademicSubjectArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteAcademicTermArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteAcademicYearArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteAddressArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteAnnouncementArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteAttendanceStatusArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteBillingAdjustmentArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteBuildingArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteBuildingFloorArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteBulkAcademicSubjectsArgs = {
	filters: Array<AcademicSubjectFilterInput>;
};

export type MutationDeleteBulkAcademicTermsArgs = {
	filters: Array<AcademicTermFilterInput>;
};

export type MutationDeleteBulkAcademicYearsArgs = {
	filters: Array<AcademicYearFilterInput>;
};

export type MutationDeleteBulkAddressesArgs = {
	filters: Array<AddressFilterInput>;
};

export type MutationDeleteBulkAnnouncementsArgs = {
	filters: Array<AnnouncementFilterInput>;
};

export type MutationDeleteBulkAttendanceStatusesArgs = {
	filters: Array<AttendanceStatusFilterInput>;
};

export type MutationDeleteBulkBillingAdjustmentsArgs = {
	filters: Array<BillingAdjustmentFilterInput>;
};

export type MutationDeleteBulkBuildingFloorsArgs = {
	filters: Array<BuildingFloorFilterInput>;
};

export type MutationDeleteBulkBuildingsArgs = {
	filters: Array<BuildingFilterInput>;
};

export type MutationDeleteBulkCalendarEventResponsesArgs = {
	filters: Array<CalendarEventResponseFilterInput>;
};

export type MutationDeleteBulkCalendarEventsArgs = {
	filters: Array<CalendarEventFilterInput>;
};

export type MutationDeleteBulkCampusesArgs = {
	filters: Array<CampusFilterInput>;
};

export type MutationDeleteBulkClassYearCategoriesArgs = {
	filters: Array<ClassYearCategoryFilterInput>;
};

export type MutationDeleteBulkClassYearsArgs = {
	filters: Array<ClassYearFilterInput>;
};

export type MutationDeleteBulkContractInstallmentsArgs = {
	filters: Array<ContractInstallmentFilterInput>;
};

export type MutationDeleteBulkContractLineItemsArgs = {
	filters: Array<ContractLineItemFilterInput>;
};

export type MutationDeleteBulkContractsArgs = {
	filters: Array<ContractFilterInput>;
};

export type MutationDeleteBulkCountriesArgs = {
	filters: Array<CountryFilterInput>;
};

export type MutationDeleteBulkCourseAssessmentCategoriesArgs = {
	filters: Array<CourseAssessmentCategoryFilterInput>;
};

export type MutationDeleteBulkCourseAssessmentCategoryMarkPortionsArgs = {
	filters: Array<CourseAssessmentCategoryMarkPortionFilterInput>;
};

export type MutationDeleteBulkCourseAssessmentMarksArgs = {
	filters: Array<CourseAssessmentMarkFilterInput>;
};

export type MutationDeleteBulkCourseAssessmentSubmissionsArgs = {
	filters: Array<CourseAssessmentSubmissionFilterInput>;
};

export type MutationDeleteBulkCourseAssessmentTimingsArgs = {
	filters: Array<CourseAssessmentTimingFilterInput>;
};

export type MutationDeleteBulkCourseAssessmentsArgs = {
	filters: Array<CourseAssessmentFilterInput>;
};

export type MutationDeleteBulkCourseAttendanceRecordsArgs = {
	filters: Array<CourseAttendanceRecordFilterInput>;
};

export type MutationDeleteBulkCourseSectionPeriodsArgs = {
	filters: Array<CourseSectionPeriodFilterInput>;
};

export type MutationDeleteBulkCourseSectionsArgs = {
	filters: Array<CourseSectionFilterInput>;
};

export type MutationDeleteBulkCoursesArgs = {
	filters: Array<CourseFilterInput>;
};

export type MutationDeleteBulkDiscountsArgs = {
	filters: Array<DiscountFilterInput>;
};

export type MutationDeleteBulkEmailAddressesArgs = {
	filters: Array<EmailAddressFilterInput>;
};

export type MutationDeleteBulkEmployeesArgs = {
	filters: Array<EmployeeFilterInput>;
};

export type MutationDeleteBulkEnrollmentApplicationGuardiansArgs = {
	filters: Array<EnrollmentApplicationGuardianFilterInput>;
};

export type MutationDeleteBulkEnrollmentApplicationStudentSchoolsArgs = {
	filters: Array<EnrollmentApplicationStudentSchoolFilterInput>;
};

export type MutationDeleteBulkEnrollmentApplicationStudentsArgs = {
	filters: Array<EnrollmentApplicationStudentFilterInput>;
};

export type MutationDeleteBulkEnrollmentApplicationsArgs = {
	filters: Array<EnrollmentApplicationFilterInput>;
};

export type MutationDeleteBulkGuardiansArgs = {
	filters: Array<GuardianFilterInput>;
};

export type MutationDeleteBulkHomeRoomSectionsArgs = {
	filters: Array<HomeRoomSectionFilterInput>;
};

export type MutationDeleteBulkHomeRoomsArgs = {
	filters: Array<HomeRoomFilterInput>;
};

export type MutationDeleteBulkInvoiceLineItemsArgs = {
	filters: Array<InvoiceLineItemFilterInput>;
};

export type MutationDeleteBulkInvoicesArgs = {
	filters: Array<InvoiceFilterInput>;
};

export type MutationDeleteBulkLanguagesArgs = {
	filters: Array<LanguageFilterInput>;
};

export type MutationDeleteBulkLearningObjectiveCategoriesArgs = {
	filters: Array<LearningObjectiveCategoryFilterInput>;
};

export type MutationDeleteBulkLearningObjectivesArgs = {
	filters: Array<LearningObjectiveFilterInput>;
};

export type MutationDeleteBulkMarkValuesArgs = {
	filters: Array<MarkValueFilterInput>;
};

export type MutationDeleteBulkMarkingSystemsArgs = {
	filters: Array<MarkingSystemFilterInput>;
};

export type MutationDeleteBulkMediaAttachmentsArgs = {
	filters: Array<MediaAttachmentFilterInput>;
};

export type MutationDeleteBulkMedicalConditionsArgs = {
	filters: Array<MedicalConditionFilterInput>;
};

export type MutationDeleteBulkMedicationsArgs = {
	filters: Array<MedicationFilterInput>;
};

export type MutationDeleteBulkMessageAvailabilityPeriodsArgs = {
	filters: Array<MessageAvailabilityPeriodFilterInput>;
};

export type MutationDeleteBulkMessageGroupArchivePointsArgs = {
	filters: Array<MessageGroupArchivePointFilterInput>;
};

export type MutationDeleteBulkMessageGroupsArgs = {
	filters: Array<MessageGroupFilterInput>;
};

export type MutationDeleteBulkMessageTopicsArgs = {
	filters: Array<MessageTopicFilterInput>;
};

export type MutationDeleteBulkMessagesArgs = {
	filters: Array<MessageFilterInput>;
};

export type MutationDeleteBulkNewslettersArgs = {
	filters: Array<NewsletterFilterInput>;
};

export type MutationDeleteBulkPaymentLineItemsArgs = {
	filters: Array<PaymentLineItemFilterInput>;
};

export type MutationDeleteBulkPaymentsArgs = {
	filters: Array<PaymentFilterInput>;
};

export type MutationDeleteBulkPeopleArgs = {
	filters: Array<PersonFilterInput>;
};

export type MutationDeleteBulkPermissionGroupsArgs = {
	filters: Array<PermissionGroupFilterInput>;
};

export type MutationDeleteBulkPhoneNumbersArgs = {
	filters: Array<PhoneNumberFilterInput>;
};

export type MutationDeleteBulkPostsArgs = {
	filters: Array<PostFilterInput>;
};

export type MutationDeleteBulkQuotationsArgs = {
	filters: Array<QuotationFilterInput>;
};

export type MutationDeleteBulkRefundsArgs = {
	filters: Array<RefundFilterInput>;
};

export type MutationDeleteBulkRelationshipsArgs = {
	filters: Array<RelationshipFilterInput>;
};

export type MutationDeleteBulkReportCardSectionLearningObjectivesArgs = {
	filters: Array<ReportCardSectionLearningObjectiveFilterInput>;
};

export type MutationDeleteBulkReportCardSectionPoliciesArgs = {
	filters: Array<ReportCardSectionPolicyFilterInput>;
};

export type MutationDeleteBulkReportCardSectionsArgs = {
	filters: Array<ReportCardSectionFilterInput>;
};

export type MutationDeleteBulkReportCardsArgs = {
	filters: Array<ReportCardFilterInput>;
};

export type MutationDeleteBulkRoomsArgs = {
	filters: Array<RoomFilterInput>;
};

export type MutationDeleteBulkSchoolAttendanceRecordsArgs = {
	filters: Array<SchoolAttendanceRecordFilterInput>;
};

export type MutationDeleteBulkServicesArgs = {
	filters: Array<ServiceFilterInput>;
};

export type MutationDeleteBulkSharingRecordsArgs = {
	filters: Array<SharingRecordFilterInput>;
};

export type MutationDeleteBulkSocialCommentsArgs = {
	filters: Array<SocialCommentFilterInput>;
};

export type MutationDeleteBulkSocialReactionsArgs = {
	filters: Array<SocialReactionFilterInput>;
};

export type MutationDeleteBulkStudentAcademicNotesArgs = {
	filters: Array<StudentAcademicNoteFilterInput>;
};

export type MutationDeleteBulkStudentAcademicTermEnrollmentsArgs = {
	filters: Array<StudentAcademicTermEnrollmentFilterInput>;
};

export type MutationDeleteBulkStudentAttendanceNotesArgs = {
	filters: Array<StudentAttendanceNoteFilterInput>;
};

export type MutationDeleteBulkStudentBehaviorNotesArgs = {
	filters: Array<StudentBehaviorNoteFilterInput>;
};

export type MutationDeleteBulkStudentCourseSectionEnrollmentsArgs = {
	filters: Array<StudentCourseSectionEnrollmentFilterInput>;
};

export type MutationDeleteBulkStudentDataConsentsArgs = {
	filters: Array<StudentDataConsentFilterInput>;
};

export type MutationDeleteBulkStudentEnrollmentApplicationsArgs = {
	filters: Array<StudentEnrollmentApplicationFilterInput>;
};

export type MutationDeleteBulkStudentEnrollmentIntentsArgs = {
	filters: Array<StudentEnrollmentIntentFilterInput>;
};

export type MutationDeleteBulkStudentHealthNotesArgs = {
	filters: Array<StudentHealthNoteFilterInput>;
};

export type MutationDeleteBulkStudentHomeRoomSectionEnrollmentsArgs = {
	filters: Array<StudentHomeRoomSectionEnrollmentFilterInput>;
};

export type MutationDeleteBulkStudentIncidentNotesArgs = {
	filters: Array<StudentIncidentNoteFilterInput>;
};

export type MutationDeleteBulkStudentInformationVerificationsArgs = {
	filters: Array<StudentInformationVerificationFilterInput>;
};

export type MutationDeleteBulkStudentInjuryNotesArgs = {
	filters: Array<StudentInjuryNoteFilterInput>;
};

export type MutationDeleteBulkStudentMedicalConditionsArgs = {
	filters: Array<StudentMedicalConditionFilterInput>;
};

export type MutationDeleteBulkStudentMedicalContactsArgs = {
	filters: Array<StudentMedicalContactFilterInput>;
};

export type MutationDeleteBulkStudentMedicalEventsArgs = {
	filters: Array<StudentMedicalEventFilterInput>;
};

export type MutationDeleteBulkStudentMedicalProfilesArgs = {
	filters: Array<StudentMedicalProfileFilterInput>;
};

export type MutationDeleteBulkStudentMedicationNotesArgs = {
	filters: Array<StudentMedicationNoteFilterInput>;
};

export type MutationDeleteBulkStudentNotesArgs = {
	filters: Array<StudentNoteFilterInput>;
};

export type MutationDeleteBulkStudentOTCMedicationsArgs = {
	filters: Array<StudentOTCMedicationFilterInput>;
};

export type MutationDeleteBulkStudentPrescriptionMedicationsArgs = {
	filters: Array<StudentPrescriptionMedicationFilterInput>;
};

export type MutationDeleteBulkStudentSocialEmotionalNotesArgs = {
	filters: Array<StudentSocialEmotionalNoteFilterInput>;
};

export type MutationDeleteBulkStudentVaccinationRecordsArgs = {
	filters: Array<StudentVaccinationRecordFilterInput>;
};

export type MutationDeleteBulkStudentsArgs = {
	filters: Array<StudentFilterInput>;
};

export type MutationDeleteBulkTeacherCourseSectionEnrollmentsArgs = {
	filters: Array<TeacherCourseSectionEnrollmentFilterInput>;
};

export type MutationDeleteBulkTeacherHomeRoomSectionEnrollmentsArgs = {
	filters: Array<TeacherHomeRoomSectionEnrollmentFilterInput>;
};

export type MutationDeleteBulkUserGroupsArgs = {
	filters: Array<UserGroupFilterInput>;
};

export type MutationDeleteBulkUserViewRecordsArgs = {
	filters: Array<UserViewRecordFilterInput>;
};

export type MutationDeleteBulkUsersArgs = {
	filters: Array<UserFilterInput>;
};

export type MutationDeleteBulkVaccinesArgs = {
	filters: Array<VaccineFilterInput>;
};

export type MutationDeleteCalendarEventArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteCalendarEventResponseArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteCampusArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteClassYearArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteClassYearCategoryArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteContractArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteContractInstallmentArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteContractLineItemArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteCountryArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteCourseArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteCourseAssessmentArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteCourseAssessmentCategoryArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteCourseAssessmentCategoryMarkPortionArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteCourseAssessmentMarkArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteCourseAssessmentSubmissionArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteCourseAssessmentTimingArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteCourseAttendanceRecordArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteCourseSectionArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteCourseSectionPeriodArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteDiscountArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteEmailAddressArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteEmployeeArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteEnrollmentApplicationArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteEnrollmentApplicationGuardianArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteEnrollmentApplicationStudentArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteEnrollmentApplicationStudentSchoolArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteGuardianArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteHomeRoomArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteHomeRoomSectionArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteInvoiceArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteInvoiceLineItemArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteLanguageArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteLearningObjectiveArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteLearningObjectiveCategoryArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteMarkValueArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteMarkingSystemArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteMediaAttachmentArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteMedicalConditionArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteMedicationArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteMessageArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteMessageAvailabilityPeriodArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteMessageGroupArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteMessageGroupArchivePointArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteMessageTopicArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteNewsletterArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeletePaymentArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeletePaymentLineItemArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeletePermissionGroupArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeletePersonArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeletePhoneNumberArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeletePostArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteQuotationArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteRefundArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteRelationshipArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteReportCardArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteReportCardSectionArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteReportCardSectionLearningObjectiveArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteReportCardSectionPolicyArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteRoomArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteSchoolAttendanceRecordArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteServiceArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteSharingRecordArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteSocialCommentArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteSocialReactionArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentAcademicNoteArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentAcademicTermEnrollmentArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentAttendanceNoteArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentBehaviorNoteArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentCourseSectionEnrollmentArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentDataConsentArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentEnrollmentApplicationArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentEnrollmentIntentArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentHealthNoteArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentHomeRoomSectionEnrollmentArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentIncidentNoteArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentInformationVerificationArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentInjuryNoteArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentMedicalConditionArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentMedicalContactArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentMedicalEventArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentMedicalProfileArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentMedicationNoteArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentNoteArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentOTCMedicationArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentPrescriptionMedicationArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentSocialEmotionalNoteArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteStudentVaccinationRecordArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteTeacherCourseSectionEnrollmentArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteTeacherHomeRoomSectionEnrollmentArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteUserArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteUserGroupArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteUserViewRecordArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteVaccineArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationGuardianOnboardingSubmissionArgs = {
	personInput?: InputMaybe<PersonUpdateInput>;
	studentDataConsentInput?: InputMaybe<StudentDataConsentCreateInput>;
	userInput?: InputMaybe<UserUpdateInput>;
};

export type MutationInviteUserArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationRecordViewArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationRecordViewsArgs = {
	ids: Array<Scalars["ID"]["input"]>;
};

export type MutationRemoveMealPlanFromContractArgs = {
	contractID: Scalars["ID"]["input"];
};

export type MutationSendParentPortalInviteMessageArgs = {
	userID: Scalars["ID"]["input"];
};

export type MutationSendReEnrollmentConfirmationMessageArgs = {
	step: Scalars["Int"]["input"];
	userID: Scalars["ID"]["input"];
};

export type MutationSendReEnrollmentInviteMessageArgs = {
	reminderCount?: InputMaybe<Scalars["Int"]["input"]>;
	step: Scalars["Int"]["input"];
	userID: Scalars["ID"]["input"];
};

export type MutationSendReportCardReleaseMessageArgs = {
	userID: Scalars["ID"]["input"];
};

export type MutationSetInstallmentFeeOnContractArgs = {
	contractID: Scalars["ID"]["input"];
};

export type MutationSetMealPlanOnContractArgs = {
	contractID: Scalars["ID"]["input"];
	mealPlanID: Scalars["ID"]["input"];
};

export type MutationSetPaymentPlanOnContractArgs = {
	contractID: Scalars["ID"]["input"];
	numPayments: Scalars["Int"]["input"];
};

export type MutationSetStudentEnrollmentArgs = {
	academicTermID: Scalars["ID"]["input"];
	courseSectionIDs: Array<Scalars["ID"]["input"]>;
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	graduationYear: Scalars["Int"]["input"];
	homeRoomSectionID?: InputMaybe<Scalars["ID"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type MutationSubmitEnrollmentApplicationArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationUnenrollStudentFromAcademicTermArgs = {
	academicTermID: Scalars["ID"]["input"];
	studentID: Scalars["ID"]["input"];
};

export type MutationUpdateAcademicSubjectArgs = {
	id: Scalars["ID"]["input"];
	input: AcademicSubjectUpdateInput;
};

export type MutationUpdateAcademicTermArgs = {
	id: Scalars["ID"]["input"];
	input: AcademicTermUpdateInput;
};

export type MutationUpdateAcademicYearArgs = {
	id: Scalars["ID"]["input"];
	input: AcademicYearUpdateInput;
};

export type MutationUpdateAddressArgs = {
	id: Scalars["ID"]["input"];
	input: AddressUpdateInput;
};

export type MutationUpdateAnnouncementArgs = {
	id: Scalars["ID"]["input"];
	input: AnnouncementUpdateInput;
};

export type MutationUpdateAttendanceStatusArgs = {
	id: Scalars["ID"]["input"];
	input: AttendanceStatusUpdateInput;
};

export type MutationUpdateBillingAdjustmentArgs = {
	id: Scalars["ID"]["input"];
	input: BillingAdjustmentUpdateInput;
};

export type MutationUpdateBuildingArgs = {
	id: Scalars["ID"]["input"];
	input: BuildingUpdateInput;
};

export type MutationUpdateBuildingFloorArgs = {
	id: Scalars["ID"]["input"];
	input: BuildingFloorUpdateInput;
};

export type MutationUpdateBulkAcademicSubjectsArgs = {
	filters: Array<AcademicSubjectFilterInput>;
	input: AcademicSubjectUpdateBulkInput;
};

export type MutationUpdateBulkAcademicTermsArgs = {
	filters: Array<AcademicTermFilterInput>;
	input: AcademicTermUpdateBulkInput;
};

export type MutationUpdateBulkAcademicYearsArgs = {
	filters: Array<AcademicYearFilterInput>;
	input: AcademicYearUpdateBulkInput;
};

export type MutationUpdateBulkAddressesArgs = {
	filters: Array<AddressFilterInput>;
	input: AddressUpdateBulkInput;
};

export type MutationUpdateBulkAnnouncementsArgs = {
	filters: Array<AnnouncementFilterInput>;
	input: AnnouncementUpdateBulkInput;
};

export type MutationUpdateBulkAttendanceStatusesArgs = {
	filters: Array<AttendanceStatusFilterInput>;
	input: AttendanceStatusUpdateBulkInput;
};

export type MutationUpdateBulkBillingAdjustmentsArgs = {
	filters: Array<BillingAdjustmentFilterInput>;
	input: BillingAdjustmentUpdateBulkInput;
};

export type MutationUpdateBulkBuildingFloorsArgs = {
	filters: Array<BuildingFloorFilterInput>;
	input: BuildingFloorUpdateBulkInput;
};

export type MutationUpdateBulkBuildingsArgs = {
	filters: Array<BuildingFilterInput>;
	input: BuildingUpdateBulkInput;
};

export type MutationUpdateBulkCalendarEventResponsesArgs = {
	filters: Array<CalendarEventResponseFilterInput>;
	input: CalendarEventResponseUpdateBulkInput;
};

export type MutationUpdateBulkCalendarEventsArgs = {
	filters: Array<CalendarEventFilterInput>;
	input: CalendarEventUpdateBulkInput;
};

export type MutationUpdateBulkCampusesArgs = {
	filters: Array<CampusFilterInput>;
	input: CampusUpdateBulkInput;
};

export type MutationUpdateBulkClassYearCategoriesArgs = {
	filters: Array<ClassYearCategoryFilterInput>;
	input: ClassYearCategoryUpdateBulkInput;
};

export type MutationUpdateBulkClassYearsArgs = {
	filters: Array<ClassYearFilterInput>;
	input: ClassYearUpdateBulkInput;
};

export type MutationUpdateBulkContractInstallmentsArgs = {
	filters: Array<ContractInstallmentFilterInput>;
	input: ContractInstallmentUpdateBulkInput;
};

export type MutationUpdateBulkContractLineItemsArgs = {
	filters: Array<ContractLineItemFilterInput>;
	input: ContractLineItemUpdateBulkInput;
};

export type MutationUpdateBulkContractsArgs = {
	filters: Array<ContractFilterInput>;
	input: ContractUpdateBulkInput;
};

export type MutationUpdateBulkCountriesArgs = {
	filters: Array<CountryFilterInput>;
	input: CountryUpdateBulkInput;
};

export type MutationUpdateBulkCourseAssessmentCategoriesArgs = {
	filters: Array<CourseAssessmentCategoryFilterInput>;
	input: CourseAssessmentCategoryUpdateBulkInput;
};

export type MutationUpdateBulkCourseAssessmentCategoryMarkPortionsArgs = {
	filters: Array<CourseAssessmentCategoryMarkPortionFilterInput>;
	input: CourseAssessmentCategoryMarkPortionUpdateBulkInput;
};

export type MutationUpdateBulkCourseAssessmentMarksArgs = {
	filters: Array<CourseAssessmentMarkFilterInput>;
	input: CourseAssessmentMarkUpdateBulkInput;
};

export type MutationUpdateBulkCourseAssessmentSubmissionsArgs = {
	filters: Array<CourseAssessmentSubmissionFilterInput>;
	input: CourseAssessmentSubmissionUpdateBulkInput;
};

export type MutationUpdateBulkCourseAssessmentTimingsArgs = {
	filters: Array<CourseAssessmentTimingFilterInput>;
	input: CourseAssessmentTimingUpdateBulkInput;
};

export type MutationUpdateBulkCourseAssessmentsArgs = {
	filters: Array<CourseAssessmentFilterInput>;
	input: CourseAssessmentUpdateBulkInput;
};

export type MutationUpdateBulkCourseAttendanceRecordsArgs = {
	filters: Array<CourseAttendanceRecordFilterInput>;
	input: CourseAttendanceRecordUpdateBulkInput;
};

export type MutationUpdateBulkCourseSectionPeriodsArgs = {
	filters: Array<CourseSectionPeriodFilterInput>;
	input: CourseSectionPeriodUpdateBulkInput;
};

export type MutationUpdateBulkCourseSectionsArgs = {
	filters: Array<CourseSectionFilterInput>;
	input: CourseSectionUpdateBulkInput;
};

export type MutationUpdateBulkCoursesArgs = {
	filters: Array<CourseFilterInput>;
	input: CourseUpdateBulkInput;
};

export type MutationUpdateBulkDiscountsArgs = {
	filters: Array<DiscountFilterInput>;
	input: DiscountUpdateBulkInput;
};

export type MutationUpdateBulkEmailAddressesArgs = {
	filters: Array<EmailAddressFilterInput>;
	input: EmailAddressUpdateBulkInput;
};

export type MutationUpdateBulkEmployeesArgs = {
	filters: Array<EmployeeFilterInput>;
	input: EmployeeUpdateBulkInput;
};

export type MutationUpdateBulkEnrollmentApplicationGuardiansArgs = {
	filters: Array<EnrollmentApplicationGuardianFilterInput>;
	input: EnrollmentApplicationGuardianUpdateBulkInput;
};

export type MutationUpdateBulkEnrollmentApplicationStudentSchoolsArgs = {
	filters: Array<EnrollmentApplicationStudentSchoolFilterInput>;
	input: EnrollmentApplicationStudentSchoolUpdateBulkInput;
};

export type MutationUpdateBulkEnrollmentApplicationStudentsArgs = {
	filters: Array<EnrollmentApplicationStudentFilterInput>;
	input: EnrollmentApplicationStudentUpdateBulkInput;
};

export type MutationUpdateBulkEnrollmentApplicationsArgs = {
	filters: Array<EnrollmentApplicationFilterInput>;
	input: EnrollmentApplicationUpdateBulkInput;
};

export type MutationUpdateBulkGuardiansArgs = {
	filters: Array<GuardianFilterInput>;
	input: GuardianUpdateBulkInput;
};

export type MutationUpdateBulkHomeRoomSectionsArgs = {
	filters: Array<HomeRoomSectionFilterInput>;
	input: HomeRoomSectionUpdateBulkInput;
};

export type MutationUpdateBulkHomeRoomsArgs = {
	filters: Array<HomeRoomFilterInput>;
	input: HomeRoomUpdateBulkInput;
};

export type MutationUpdateBulkInvoiceLineItemsArgs = {
	filters: Array<InvoiceLineItemFilterInput>;
	input: InvoiceLineItemUpdateBulkInput;
};

export type MutationUpdateBulkInvoicesArgs = {
	filters: Array<InvoiceFilterInput>;
	input: InvoiceUpdateBulkInput;
};

export type MutationUpdateBulkLanguagesArgs = {
	filters: Array<LanguageFilterInput>;
	input: LanguageUpdateBulkInput;
};

export type MutationUpdateBulkLearningObjectiveCategoriesArgs = {
	filters: Array<LearningObjectiveCategoryFilterInput>;
	input: LearningObjectiveCategoryUpdateBulkInput;
};

export type MutationUpdateBulkLearningObjectivesArgs = {
	filters: Array<LearningObjectiveFilterInput>;
	input: LearningObjectiveUpdateBulkInput;
};

export type MutationUpdateBulkMarkValuesArgs = {
	filters: Array<MarkValueFilterInput>;
	input: MarkValueUpdateBulkInput;
};

export type MutationUpdateBulkMarkingSystemsArgs = {
	filters: Array<MarkingSystemFilterInput>;
	input: MarkingSystemUpdateBulkInput;
};

export type MutationUpdateBulkMediaAttachmentsArgs = {
	filters: Array<MediaAttachmentFilterInput>;
	input: MediaAttachmentUpdateBulkInput;
};

export type MutationUpdateBulkMedicalConditionsArgs = {
	filters: Array<MedicalConditionFilterInput>;
	input: MedicalConditionUpdateBulkInput;
};

export type MutationUpdateBulkMedicationsArgs = {
	filters: Array<MedicationFilterInput>;
	input: MedicationUpdateBulkInput;
};

export type MutationUpdateBulkMessageAvailabilityPeriodsArgs = {
	filters: Array<MessageAvailabilityPeriodFilterInput>;
	input: MessageAvailabilityPeriodUpdateBulkInput;
};

export type MutationUpdateBulkMessageGroupsArgs = {
	filters: Array<MessageGroupFilterInput>;
	input: MessageGroupUpdateBulkInput;
};

export type MutationUpdateBulkMessageTopicsArgs = {
	filters: Array<MessageTopicFilterInput>;
	input: MessageTopicUpdateBulkInput;
};

export type MutationUpdateBulkMessagesArgs = {
	filters: Array<MessageFilterInput>;
	input: MessageUpdateBulkInput;
};

export type MutationUpdateBulkNewslettersArgs = {
	filters: Array<NewsletterFilterInput>;
	input: NewsletterUpdateBulkInput;
};

export type MutationUpdateBulkPaymentLineItemsArgs = {
	filters: Array<PaymentLineItemFilterInput>;
	input: PaymentLineItemUpdateBulkInput;
};

export type MutationUpdateBulkPaymentsArgs = {
	filters: Array<PaymentFilterInput>;
	input: PaymentUpdateBulkInput;
};

export type MutationUpdateBulkPeopleArgs = {
	filters: Array<PersonFilterInput>;
	input: PersonUpdateBulkInput;
};

export type MutationUpdateBulkPermissionGroupsArgs = {
	filters: Array<PermissionGroupFilterInput>;
	input: PermissionGroupUpdateBulkInput;
};

export type MutationUpdateBulkPermissionsArgs = {
	filters: Array<PermissionFilterInput>;
	input: PermissionUpdateBulkInput;
};

export type MutationUpdateBulkPhoneNumbersArgs = {
	filters: Array<PhoneNumberFilterInput>;
	input: PhoneNumberUpdateBulkInput;
};

export type MutationUpdateBulkPostsArgs = {
	filters: Array<PostFilterInput>;
	input: PostUpdateBulkInput;
};

export type MutationUpdateBulkQuotationsArgs = {
	filters: Array<QuotationFilterInput>;
	input: QuotationUpdateBulkInput;
};

export type MutationUpdateBulkRefundsArgs = {
	filters: Array<RefundFilterInput>;
	input: RefundUpdateBulkInput;
};

export type MutationUpdateBulkRelationshipsArgs = {
	filters: Array<RelationshipFilterInput>;
	input: RelationshipUpdateBulkInput;
};

export type MutationUpdateBulkReportCardSectionLearningObjectivesArgs = {
	filters: Array<ReportCardSectionLearningObjectiveFilterInput>;
	input: ReportCardSectionLearningObjectiveUpdateBulkInput;
};

export type MutationUpdateBulkReportCardSectionPoliciesArgs = {
	filters: Array<ReportCardSectionPolicyFilterInput>;
	input: ReportCardSectionPolicyUpdateBulkInput;
};

export type MutationUpdateBulkReportCardSectionsArgs = {
	filters: Array<ReportCardSectionFilterInput>;
	input: ReportCardSectionUpdateBulkInput;
};

export type MutationUpdateBulkReportCardsArgs = {
	filters: Array<ReportCardFilterInput>;
	input: ReportCardUpdateBulkInput;
};

export type MutationUpdateBulkRoomsArgs = {
	filters: Array<RoomFilterInput>;
	input: RoomUpdateBulkInput;
};

export type MutationUpdateBulkSchoolAttendanceRecordsArgs = {
	filters: Array<SchoolAttendanceRecordFilterInput>;
	input: SchoolAttendanceRecordUpdateBulkInput;
};

export type MutationUpdateBulkServicesArgs = {
	filters: Array<ServiceFilterInput>;
	input: ServiceUpdateBulkInput;
};

export type MutationUpdateBulkSharingRecordsArgs = {
	filters: Array<SharingRecordFilterInput>;
	input: SharingRecordUpdateBulkInput;
};

export type MutationUpdateBulkSocialCommentsArgs = {
	filters: Array<SocialCommentFilterInput>;
	input: SocialCommentUpdateBulkInput;
};

export type MutationUpdateBulkSocialReactionsArgs = {
	filters: Array<SocialReactionFilterInput>;
	input: SocialReactionUpdateBulkInput;
};

export type MutationUpdateBulkStudentAcademicNotesArgs = {
	filters: Array<StudentAcademicNoteFilterInput>;
	input: StudentAcademicNoteUpdateBulkInput;
};

export type MutationUpdateBulkStudentAcademicTermEnrollmentsArgs = {
	filters: Array<StudentAcademicTermEnrollmentFilterInput>;
	input: StudentAcademicTermEnrollmentUpdateBulkInput;
};

export type MutationUpdateBulkStudentAttendanceNotesArgs = {
	filters: Array<StudentAttendanceNoteFilterInput>;
	input: StudentAttendanceNoteUpdateBulkInput;
};

export type MutationUpdateBulkStudentBehaviorNotesArgs = {
	filters: Array<StudentBehaviorNoteFilterInput>;
	input: StudentBehaviorNoteUpdateBulkInput;
};

export type MutationUpdateBulkStudentCourseSectionEnrollmentsArgs = {
	filters: Array<StudentCourseSectionEnrollmentFilterInput>;
	input: StudentCourseSectionEnrollmentUpdateBulkInput;
};

export type MutationUpdateBulkStudentDataConsentsArgs = {
	filters: Array<StudentDataConsentFilterInput>;
	input: StudentDataConsentUpdateBulkInput;
};

export type MutationUpdateBulkStudentEnrollmentApplicationsArgs = {
	filters: Array<StudentEnrollmentApplicationFilterInput>;
	input: StudentEnrollmentApplicationUpdateBulkInput;
};

export type MutationUpdateBulkStudentEnrollmentIntentsArgs = {
	filters: Array<StudentEnrollmentIntentFilterInput>;
	input: StudentEnrollmentIntentUpdateBulkInput;
};

export type MutationUpdateBulkStudentHealthNotesArgs = {
	filters: Array<StudentHealthNoteFilterInput>;
	input: StudentHealthNoteUpdateBulkInput;
};

export type MutationUpdateBulkStudentHomeRoomSectionEnrollmentsArgs = {
	filters: Array<StudentHomeRoomSectionEnrollmentFilterInput>;
	input: StudentHomeRoomSectionEnrollmentUpdateBulkInput;
};

export type MutationUpdateBulkStudentIncidentNotesArgs = {
	filters: Array<StudentIncidentNoteFilterInput>;
	input: StudentIncidentNoteUpdateBulkInput;
};

export type MutationUpdateBulkStudentInformationVerificationsArgs = {
	filters: Array<StudentInformationVerificationFilterInput>;
	input: StudentInformationVerificationUpdateBulkInput;
};

export type MutationUpdateBulkStudentInjuryNotesArgs = {
	filters: Array<StudentInjuryNoteFilterInput>;
	input: StudentInjuryNoteUpdateBulkInput;
};

export type MutationUpdateBulkStudentMedicalConditionsArgs = {
	filters: Array<StudentMedicalConditionFilterInput>;
	input: StudentMedicalConditionUpdateBulkInput;
};

export type MutationUpdateBulkStudentMedicalContactsArgs = {
	filters: Array<StudentMedicalContactFilterInput>;
	input: StudentMedicalContactUpdateBulkInput;
};

export type MutationUpdateBulkStudentMedicalEventsArgs = {
	filters: Array<StudentMedicalEventFilterInput>;
	input: StudentMedicalEventUpdateBulkInput;
};

export type MutationUpdateBulkStudentMedicalProfilesArgs = {
	filters: Array<StudentMedicalProfileFilterInput>;
	input: StudentMedicalProfileUpdateBulkInput;
};

export type MutationUpdateBulkStudentMedicationNotesArgs = {
	filters: Array<StudentMedicationNoteFilterInput>;
	input: StudentMedicationNoteUpdateBulkInput;
};

export type MutationUpdateBulkStudentNotesArgs = {
	filters: Array<StudentNoteFilterInput>;
	input: StudentNoteUpdateBulkInput;
};

export type MutationUpdateBulkStudentOTCMedicationsArgs = {
	filters: Array<StudentOTCMedicationFilterInput>;
	input: StudentOTCMedicationUpdateBulkInput;
};

export type MutationUpdateBulkStudentPrescriptionMedicationsArgs = {
	filters: Array<StudentPrescriptionMedicationFilterInput>;
	input: StudentPrescriptionMedicationUpdateBulkInput;
};

export type MutationUpdateBulkStudentSocialEmotionalNotesArgs = {
	filters: Array<StudentSocialEmotionalNoteFilterInput>;
	input: StudentSocialEmotionalNoteUpdateBulkInput;
};

export type MutationUpdateBulkStudentVaccinationRecordsArgs = {
	filters: Array<StudentVaccinationRecordFilterInput>;
	input: StudentVaccinationRecordUpdateBulkInput;
};

export type MutationUpdateBulkStudentsArgs = {
	filters: Array<StudentFilterInput>;
	input: StudentUpdateBulkInput;
};

export type MutationUpdateBulkTeacherCourseSectionEnrollmentsArgs = {
	filters: Array<TeacherCourseSectionEnrollmentFilterInput>;
	input: TeacherCourseSectionEnrollmentUpdateBulkInput;
};

export type MutationUpdateBulkTeacherHomeRoomSectionEnrollmentsArgs = {
	filters: Array<TeacherHomeRoomSectionEnrollmentFilterInput>;
	input: TeacherHomeRoomSectionEnrollmentUpdateBulkInput;
};

export type MutationUpdateBulkUserGroupsArgs = {
	filters: Array<UserGroupFilterInput>;
	input: UserGroupUpdateBulkInput;
};

export type MutationUpdateBulkUsersArgs = {
	filters: Array<UserFilterInput>;
	input: UserUpdateBulkInput;
};

export type MutationUpdateBulkVaccinesArgs = {
	filters: Array<VaccineFilterInput>;
	input: VaccineUpdateBulkInput;
};

export type MutationUpdateCalendarEventArgs = {
	id: Scalars["ID"]["input"];
	input: CalendarEventUpdateInput;
};

export type MutationUpdateCalendarEventResponseArgs = {
	id: Scalars["ID"]["input"];
	input: CalendarEventResponseUpdateInput;
};

export type MutationUpdateCampusArgs = {
	id: Scalars["ID"]["input"];
	input: CampusUpdateInput;
};

export type MutationUpdateClassYearArgs = {
	id: Scalars["ID"]["input"];
	input: ClassYearUpdateInput;
};

export type MutationUpdateClassYearCategoryArgs = {
	id: Scalars["ID"]["input"];
	input: ClassYearCategoryUpdateInput;
};

export type MutationUpdateContractArgs = {
	id: Scalars["ID"]["input"];
	input: ContractUpdateInput;
};

export type MutationUpdateContractInstallmentArgs = {
	id: Scalars["ID"]["input"];
	input: ContractInstallmentUpdateInput;
};

export type MutationUpdateContractLineItemArgs = {
	id: Scalars["ID"]["input"];
	input: ContractLineItemUpdateInput;
};

export type MutationUpdateCountryArgs = {
	id: Scalars["ID"]["input"];
	input: CountryUpdateInput;
};

export type MutationUpdateCourseArgs = {
	id: Scalars["ID"]["input"];
	input: CourseUpdateInput;
};

export type MutationUpdateCourseAssessmentArgs = {
	id: Scalars["ID"]["input"];
	input: CourseAssessmentUpdateInput;
};

export type MutationUpdateCourseAssessmentCategoryArgs = {
	id: Scalars["ID"]["input"];
	input: CourseAssessmentCategoryUpdateInput;
};

export type MutationUpdateCourseAssessmentCategoryMarkPortionArgs = {
	id: Scalars["ID"]["input"];
	input: CourseAssessmentCategoryMarkPortionUpdateInput;
};

export type MutationUpdateCourseAssessmentMarkArgs = {
	id: Scalars["ID"]["input"];
	input: CourseAssessmentMarkUpdateInput;
};

export type MutationUpdateCourseAssessmentSubmissionArgs = {
	id: Scalars["ID"]["input"];
	input: CourseAssessmentSubmissionUpdateInput;
};

export type MutationUpdateCourseAssessmentTimingArgs = {
	id: Scalars["ID"]["input"];
	input: CourseAssessmentTimingUpdateInput;
};

export type MutationUpdateCourseAttendanceRecordArgs = {
	id: Scalars["ID"]["input"];
	input: CourseAttendanceRecordUpdateInput;
};

export type MutationUpdateCourseSectionArgs = {
	id: Scalars["ID"]["input"];
	input: CourseSectionUpdateInput;
};

export type MutationUpdateCourseSectionPeriodArgs = {
	id: Scalars["ID"]["input"];
	input: CourseSectionPeriodUpdateInput;
};

export type MutationUpdateDiscountArgs = {
	id: Scalars["ID"]["input"];
	input: DiscountUpdateInput;
};

export type MutationUpdateEmailAddressArgs = {
	id: Scalars["ID"]["input"];
	input: EmailAddressUpdateInput;
};

export type MutationUpdateEmployeeArgs = {
	id: Scalars["ID"]["input"];
	input: EmployeeUpdateInput;
};

export type MutationUpdateEnrollmentApplicationArgs = {
	id: Scalars["ID"]["input"];
	input: EnrollmentApplicationUpdateInput;
};

export type MutationUpdateEnrollmentApplicationGuardianArgs = {
	id: Scalars["ID"]["input"];
	input: EnrollmentApplicationGuardianUpdateInput;
};

export type MutationUpdateEnrollmentApplicationStudentArgs = {
	id: Scalars["ID"]["input"];
	input: EnrollmentApplicationStudentUpdateInput;
};

export type MutationUpdateEnrollmentApplicationStudentSchoolArgs = {
	id: Scalars["ID"]["input"];
	input: EnrollmentApplicationStudentSchoolUpdateInput;
};

export type MutationUpdateGuardianArgs = {
	id: Scalars["ID"]["input"];
	input: GuardianUpdateInput;
};

export type MutationUpdateHomeRoomArgs = {
	id: Scalars["ID"]["input"];
	input: HomeRoomUpdateInput;
};

export type MutationUpdateHomeRoomSectionArgs = {
	id: Scalars["ID"]["input"];
	input: HomeRoomSectionUpdateInput;
};

export type MutationUpdateInvoiceArgs = {
	id: Scalars["ID"]["input"];
	input: InvoiceUpdateInput;
};

export type MutationUpdateInvoiceLineItemArgs = {
	id: Scalars["ID"]["input"];
	input: InvoiceLineItemUpdateInput;
};

export type MutationUpdateLanguageArgs = {
	id: Scalars["ID"]["input"];
	input: LanguageUpdateInput;
};

export type MutationUpdateLearningObjectiveArgs = {
	id: Scalars["ID"]["input"];
	input: LearningObjectiveUpdateInput;
};

export type MutationUpdateLearningObjectiveCategoryArgs = {
	id: Scalars["ID"]["input"];
	input: LearningObjectiveCategoryUpdateInput;
};

export type MutationUpdateMarkValueArgs = {
	id: Scalars["ID"]["input"];
	input: MarkValueUpdateInput;
};

export type MutationUpdateMarkingSystemArgs = {
	id: Scalars["ID"]["input"];
	input: MarkingSystemUpdateInput;
};

export type MutationUpdateMediaAttachmentArgs = {
	id: Scalars["ID"]["input"];
	input: MediaAttachmentUpdateInput;
};

export type MutationUpdateMedicalConditionArgs = {
	id: Scalars["ID"]["input"];
	input: MedicalConditionUpdateInput;
};

export type MutationUpdateMedicationArgs = {
	id: Scalars["ID"]["input"];
	input: MedicationUpdateInput;
};

export type MutationUpdateMessageArgs = {
	id: Scalars["ID"]["input"];
	input: MessageUpdateInput;
};

export type MutationUpdateMessageAvailabilityPeriodArgs = {
	id: Scalars["ID"]["input"];
	input: MessageAvailabilityPeriodUpdateInput;
};

export type MutationUpdateMessageGroupArgs = {
	id: Scalars["ID"]["input"];
	input: MessageGroupUpdateInput;
};

export type MutationUpdateMessageGroupArchivePointArgs = {
	id: Scalars["ID"]["input"];
	input: MessageGroupArchivePointUpdateInput;
};

export type MutationUpdateMessageTopicArgs = {
	id: Scalars["ID"]["input"];
	input: MessageTopicUpdateInput;
};

export type MutationUpdateNewsletterArgs = {
	id: Scalars["ID"]["input"];
	input: NewsletterUpdateInput;
};

export type MutationUpdatePaymentArgs = {
	id: Scalars["ID"]["input"];
	input: PaymentUpdateInput;
};

export type MutationUpdatePaymentLineItemArgs = {
	id: Scalars["ID"]["input"];
	input: PaymentLineItemUpdateInput;
};

export type MutationUpdatePermissionArgs = {
	id: Scalars["ID"]["input"];
	input: PermissionUpdateInput;
};

export type MutationUpdatePermissionGroupArgs = {
	id: Scalars["ID"]["input"];
	input: PermissionGroupUpdateInput;
};

export type MutationUpdatePersonArgs = {
	id: Scalars["ID"]["input"];
	input: PersonUpdateInput;
};

export type MutationUpdatePhoneNumberArgs = {
	id: Scalars["ID"]["input"];
	input: PhoneNumberUpdateInput;
};

export type MutationUpdatePostArgs = {
	id: Scalars["ID"]["input"];
	input: PostUpdateInput;
};

export type MutationUpdateQuotationArgs = {
	id: Scalars["ID"]["input"];
	input: QuotationUpdateInput;
};

export type MutationUpdateRefundArgs = {
	id: Scalars["ID"]["input"];
	input: RefundUpdateInput;
};

export type MutationUpdateRelationshipArgs = {
	id: Scalars["ID"]["input"];
	input: RelationshipUpdateInput;
};

export type MutationUpdateReportCardArgs = {
	id: Scalars["ID"]["input"];
	input: ReportCardUpdateInput;
};

export type MutationUpdateReportCardSectionArgs = {
	id: Scalars["ID"]["input"];
	input: ReportCardSectionUpdateInput;
};

export type MutationUpdateReportCardSectionLearningObjectiveArgs = {
	id: Scalars["ID"]["input"];
	input: ReportCardSectionLearningObjectiveUpdateInput;
};

export type MutationUpdateReportCardSectionPolicyArgs = {
	id: Scalars["ID"]["input"];
	input: ReportCardSectionPolicyUpdateInput;
};

export type MutationUpdateRoomArgs = {
	id: Scalars["ID"]["input"];
	input: RoomUpdateInput;
};

export type MutationUpdateSchoolAttendanceRecordArgs = {
	id: Scalars["ID"]["input"];
	input: SchoolAttendanceRecordUpdateInput;
};

export type MutationUpdateServiceArgs = {
	id: Scalars["ID"]["input"];
	input: ServiceUpdateInput;
};

export type MutationUpdateSharingRecordArgs = {
	id: Scalars["ID"]["input"];
	input: SharingRecordUpdateInput;
};

export type MutationUpdateSocialCommentArgs = {
	id: Scalars["ID"]["input"];
	input: SocialCommentUpdateInput;
};

export type MutationUpdateSocialReactionArgs = {
	id: Scalars["ID"]["input"];
	input: SocialReactionUpdateInput;
};

export type MutationUpdateStudentArgs = {
	id: Scalars["ID"]["input"];
	input: StudentUpdateInput;
};

export type MutationUpdateStudentAcademicNoteArgs = {
	id: Scalars["ID"]["input"];
	input: StudentAcademicNoteUpdateInput;
};

export type MutationUpdateStudentAcademicTermEnrollmentArgs = {
	id: Scalars["ID"]["input"];
	input: StudentAcademicTermEnrollmentUpdateInput;
};

export type MutationUpdateStudentAttendanceNoteArgs = {
	id: Scalars["ID"]["input"];
	input: StudentAttendanceNoteUpdateInput;
};

export type MutationUpdateStudentBehaviorNoteArgs = {
	id: Scalars["ID"]["input"];
	input: StudentBehaviorNoteUpdateInput;
};

export type MutationUpdateStudentCourseSectionEnrollmentArgs = {
	id: Scalars["ID"]["input"];
	input: StudentCourseSectionEnrollmentUpdateInput;
};

export type MutationUpdateStudentDataConsentArgs = {
	id: Scalars["ID"]["input"];
	input: StudentDataConsentUpdateInput;
};

export type MutationUpdateStudentEnrollmentApplicationArgs = {
	id: Scalars["ID"]["input"];
	input: StudentEnrollmentApplicationUpdateInput;
};

export type MutationUpdateStudentEnrollmentIntentArgs = {
	id: Scalars["ID"]["input"];
	input: StudentEnrollmentIntentUpdateInput;
};

export type MutationUpdateStudentHealthNoteArgs = {
	id: Scalars["ID"]["input"];
	input: StudentHealthNoteUpdateInput;
};

export type MutationUpdateStudentHomeRoomSectionEnrollmentArgs = {
	id: Scalars["ID"]["input"];
	input: StudentHomeRoomSectionEnrollmentUpdateInput;
};

export type MutationUpdateStudentIncidentNoteArgs = {
	id: Scalars["ID"]["input"];
	input: StudentIncidentNoteUpdateInput;
};

export type MutationUpdateStudentInformationVerificationArgs = {
	id: Scalars["ID"]["input"];
	input: StudentInformationVerificationUpdateInput;
};

export type MutationUpdateStudentInjuryNoteArgs = {
	id: Scalars["ID"]["input"];
	input: StudentInjuryNoteUpdateInput;
};

export type MutationUpdateStudentMedicalConditionArgs = {
	id: Scalars["ID"]["input"];
	input: StudentMedicalConditionUpdateInput;
};

export type MutationUpdateStudentMedicalContactArgs = {
	id: Scalars["ID"]["input"];
	input: StudentMedicalContactUpdateInput;
};

export type MutationUpdateStudentMedicalEventArgs = {
	id: Scalars["ID"]["input"];
	input: StudentMedicalEventUpdateInput;
};

export type MutationUpdateStudentMedicalProfileArgs = {
	id: Scalars["ID"]["input"];
	input: StudentMedicalProfileUpdateInput;
};

export type MutationUpdateStudentMedicationNoteArgs = {
	id: Scalars["ID"]["input"];
	input: StudentMedicationNoteUpdateInput;
};

export type MutationUpdateStudentNoteArgs = {
	id: Scalars["ID"]["input"];
	input: StudentNoteUpdateInput;
};

export type MutationUpdateStudentOTCMedicationArgs = {
	id: Scalars["ID"]["input"];
	input: StudentOTCMedicationUpdateInput;
};

export type MutationUpdateStudentPrescriptionMedicationArgs = {
	id: Scalars["ID"]["input"];
	input: StudentPrescriptionMedicationUpdateInput;
};

export type MutationUpdateStudentSocialEmotionalNoteArgs = {
	id: Scalars["ID"]["input"];
	input: StudentSocialEmotionalNoteUpdateInput;
};

export type MutationUpdateStudentVaccinationRecordArgs = {
	id: Scalars["ID"]["input"];
	input: StudentVaccinationRecordUpdateInput;
};

export type MutationUpdateTeacherCourseSectionEnrollmentArgs = {
	id: Scalars["ID"]["input"];
	input: TeacherCourseSectionEnrollmentUpdateInput;
};

export type MutationUpdateTeacherHomeRoomSectionEnrollmentArgs = {
	id: Scalars["ID"]["input"];
	input: TeacherHomeRoomSectionEnrollmentUpdateInput;
};

export type MutationUpdateUserArgs = {
	id: Scalars["ID"]["input"];
	input: UserUpdateInput;
};

export type MutationUpdateUserGroupArgs = {
	id: Scalars["ID"]["input"];
	input: UserGroupUpdateInput;
};

export type MutationUpdateUserViewRecordArgs = {
	id: Scalars["ID"]["input"];
	input: UserViewRecordUpdateInput;
};

export type MutationUpdateVaccineArgs = {
	id: Scalars["ID"]["input"];
	input: VaccineUpdateInput;
};

export type Newsletter = Node & {
	__typename?: "Newsletter";
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	imageContentType: Scalars["String"]["output"];
	imageKey: Scalars["String"]["output"];
	imageURL: Scalars["String"]["output"];
	releaseAt: Maybe<Scalars["Time"]["output"]>;
	sharingRecord: Maybe<SharingRecord>;
	socialComments: Array<SocialComment>;
	socialReactions: Array<SocialReaction>;
	title: Scalars["String"]["output"];
};

export type NewsletterSocialCommentsArgs = {
	filters?: InputMaybe<Array<SocialCommentFilterInput>>;
	order?: InputMaybe<SocialCommentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type NewsletterSocialReactionsArgs = {
	filters?: InputMaybe<Array<SocialReactionFilterInput>>;
	order?: InputMaybe<SocialReactionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type NewsletterConnection = {
	__typename?: "NewsletterConnection";
	edges: Array<NewsletterEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type NewsletterCreateInput = {
	body: Scalars["String"]["input"];
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	releaseAt?: InputMaybe<Scalars["Time"]["input"]>;
	sharingRecord?: InputMaybe<SharingRecordInNewsletterCreateInput>;
	socialComments?: InputMaybe<Array<SocialCommentInNewsletterCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInNewsletterCreateInput>>;
	title: Scalars["String"]["input"];
};

export type NewsletterEdge = {
	__typename?: "NewsletterEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Newsletter;
};

export type NewsletterFilterInput = {
	and?: InputMaybe<Array<NewsletterFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharingRecord?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSocialComments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSocialReactions?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	imageContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<NewsletterFilterInput>;
	or?: InputMaybe<Array<NewsletterFilterInput>>;
	releaseAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	releaseAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	releaseAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	sharingRecord?: InputMaybe<Array<SharingRecordFilterInput>>;
	socialComments?: InputMaybe<Array<SocialCommentFilterInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionFilterInput>>;
	titleContains?: InputMaybe<Scalars["String"]["input"]>;
	titleEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	titleNEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleNotContains?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type NewsletterHistory = Node & {
	__typename?: "NewsletterHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	imageContentType: Maybe<Scalars["String"]["output"]>;
	imageKey: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	releaseAt: Maybe<Scalars["Time"]["output"]>;
	title: Maybe<Scalars["String"]["output"]>;
};

export type NewsletterHistoryConnection = {
	__typename?: "NewsletterHistoryConnection";
	edges: Array<NewsletterHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type NewsletterHistoryEdge = {
	__typename?: "NewsletterHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: NewsletterHistory;
};

export type NewsletterHistoryFilterInput = {
	and?: InputMaybe<Array<NewsletterHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	imageContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageContentTypeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<NewsletterHistoryFilterInput>;
	or?: InputMaybe<Array<NewsletterHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	releaseAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	releaseAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	releaseAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	titleContains?: InputMaybe<Scalars["String"]["input"]>;
	titleEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	titleIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	titleNEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleNotContains?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type NewsletterHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<NewsletterHistoryOrderField>;
};

export enum NewsletterHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type NewsletterInAuthorCreateInput = {
	body: Scalars["String"]["input"];
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	releaseAt?: InputMaybe<Scalars["Time"]["input"]>;
	sharingRecord?: InputMaybe<SharingRecordInNewsletterCreateInput>;
	socialComments?: InputMaybe<Array<SocialCommentInNewsletterCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInNewsletterCreateInput>>;
	title: Scalars["String"]["input"];
};

export type NewsletterInSharingRecordCreateInput = {
	body: Scalars["String"]["input"];
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	releaseAt?: InputMaybe<Scalars["Time"]["input"]>;
	socialComments?: InputMaybe<Array<SocialCommentInNewsletterCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInNewsletterCreateInput>>;
	title: Scalars["String"]["input"];
};

export type NewsletterOrder = {
	direction: OrderDirection;
	field?: InputMaybe<NewsletterOrderField>;
};

export enum NewsletterOrderField {
	ReleaseAt = "RELEASE_AT",
	Title = "TITLE",
}

export type NewsletterStatistics = {
	__typename?: "NewsletterStatistics";
	comments: Scalars["Int"]["output"];
	count: Scalars["Int"]["output"];
	reactions: Scalars["Int"]["output"];
	views: Scalars["Int"]["output"];
};

export type NewsletterUpdateBulkInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	clearReleaseAt?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	releaseAt?: InputMaybe<Scalars["Time"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type NewsletterUpdateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	clearReleaseAt?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	releaseAt?: InputMaybe<Scalars["Time"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type Node = {
	id: Scalars["ID"]["output"];
};

export enum OrderDirection {
	Asc = "ASC",
	Desc = "DESC",
}

export type PageInfo = {
	__typename?: "PageInfo";
	endCursor: Maybe<Scalars["Cursor"]["output"]>;
	hasNextPage: Scalars["Boolean"]["output"];
	hasPreviousPage: Scalars["Boolean"]["output"];
	startCursor: Maybe<Scalars["Cursor"]["output"]>;
};

export type Pagination = {
	after?: InputMaybe<Scalars["Cursor"]["input"]>;
	before?: InputMaybe<Scalars["Cursor"]["input"]>;
	first?: InputMaybe<Scalars["Int"]["input"]>;
	last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Payment = Node & {
	__typename?: "Payment";
	customPayerName: Scalars["String"]["output"];
	guardianPayer: Maybe<Guardian>;
	guardianPayerID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isCustomPayer: Scalars["Boolean"]["output"];
	isInLocalCurrency: Scalars["Boolean"]["output"];
	issueDate: Scalars["Date"]["output"];
	localCurrency: Scalars["String"]["output"];
	notes: Scalars["String"]["output"];
	paymentLineItems: Array<PaymentLineItem>;
	paymentMethod: PaymentPaymentMethod;
	refunds: Array<Refund>;
};

export type PaymentPaymentLineItemsArgs = {
	filters?: InputMaybe<Array<PaymentLineItemFilterInput>>;
	order?: InputMaybe<PaymentLineItemOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PaymentRefundsArgs = {
	filters?: InputMaybe<Array<RefundFilterInput>>;
	order?: InputMaybe<RefundOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PaymentConnection = {
	__typename?: "PaymentConnection";
	edges: Array<PaymentEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PaymentCreateInput = {
	customPayerName?: InputMaybe<Scalars["String"]["input"]>;
	guardianPayerID?: InputMaybe<Scalars["ID"]["input"]>;
	issueDate: Scalars["Date"]["input"];
	localCurrency?: InputMaybe<Scalars["String"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	paymentLineItems?: InputMaybe<Array<PaymentLineItemInPaymentCreateInput>>;
	paymentMethod: PaymentPaymentMethod;
	refunds?: InputMaybe<Array<RefundInPaymentCreateInput>>;
};

export type PaymentEdge = {
	__typename?: "PaymentEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Payment;
};

export type PaymentFilterInput = {
	and?: InputMaybe<Array<PaymentFilterInput>>;
	customPayerNameContains?: InputMaybe<Scalars["String"]["input"]>;
	customPayerNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	customPayerNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	customPayerNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	customPayerNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	customPayerNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	customPayerNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	customPayerNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	customPayerNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	customPayerNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	guardianPayer?: InputMaybe<Array<GuardianFilterInput>>;
	guardianPayerIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	guardianPayerIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	guardianPayerIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	guardianPayerIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	guardianPayerIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	hasGuardianPayer?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPaymentLineItems?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasRefunds?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	issueDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	issueDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	localCurrencyContains?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyEQ?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	localCurrencyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<PaymentFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<PaymentFilterInput>>;
	paymentLineItems?: InputMaybe<Array<PaymentLineItemFilterInput>>;
	paymentMethodEQ?: InputMaybe<PaymentPaymentMethod>;
	paymentMethodIn?: InputMaybe<Array<PaymentPaymentMethod>>;
	paymentMethodNEQ?: InputMaybe<PaymentPaymentMethod>;
	paymentMethodNotIn?: InputMaybe<Array<PaymentPaymentMethod>>;
	refunds?: InputMaybe<Array<RefundFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type PaymentHistory = Node & {
	__typename?: "PaymentHistory";
	customPayerName: Maybe<Scalars["String"]["output"]>;
	guardianPayerID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	issueDate: Maybe<Scalars["Date"]["output"]>;
	localCurrency: Maybe<Scalars["String"]["output"]>;
	notes: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	paymentMethod: Maybe<PaymentHistoryPaymentMethod>;
};

export type PaymentHistoryConnection = {
	__typename?: "PaymentHistoryConnection";
	edges: Array<PaymentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PaymentHistoryEdge = {
	__typename?: "PaymentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PaymentHistory;
};

export type PaymentHistoryFilterInput = {
	and?: InputMaybe<Array<PaymentHistoryFilterInput>>;
	customPayerNameContains?: InputMaybe<Scalars["String"]["input"]>;
	customPayerNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	customPayerNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	customPayerNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	customPayerNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	customPayerNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	customPayerNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	customPayerNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	customPayerNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	customPayerNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	customPayerNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	guardianPayerIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	guardianPayerIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	guardianPayerIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	guardianPayerIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	guardianPayerIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	issueDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	issueDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	localCurrencyContains?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyEQ?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	localCurrencyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	localCurrencyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<PaymentHistoryFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<PaymentHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	paymentMethodEQ?: InputMaybe<PaymentHistoryPaymentMethod>;
	paymentMethodIn?: InputMaybe<Array<PaymentHistoryPaymentMethod>>;
	paymentMethodIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	paymentMethodNEQ?: InputMaybe<PaymentHistoryPaymentMethod>;
	paymentMethodNotIn?: InputMaybe<Array<PaymentHistoryPaymentMethod>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type PaymentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PaymentHistoryOrderField>;
};

export enum PaymentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export enum PaymentHistoryPaymentMethod {
	BankTransfer = "bank_transfer",
	Cash = "cash",
	Check = "check",
	CreditCard = "credit_card",
}

export type PaymentInGuardianPayerCreateInput = {
	customPayerName?: InputMaybe<Scalars["String"]["input"]>;
	issueDate: Scalars["Date"]["input"];
	localCurrency?: InputMaybe<Scalars["String"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	paymentLineItems?: InputMaybe<Array<PaymentLineItemInPaymentCreateInput>>;
	paymentMethod: PaymentPaymentMethod;
	refunds?: InputMaybe<Array<RefundInPaymentCreateInput>>;
};

export type PaymentLineItem = Node & {
	__typename?: "PaymentLineItem";
	amount: Scalars["Int"]["output"];
	displayOrder: Scalars["Int"]["output"];
	id: Scalars["ID"]["output"];
	invoice: Invoice;
	invoiceID: Scalars["ID"]["output"];
	localAmount: Maybe<Scalars["Int"]["output"]>;
	payment: Payment;
	paymentID: Scalars["ID"]["output"];
};

export type PaymentLineItemConnection = {
	__typename?: "PaymentLineItemConnection";
	edges: Array<PaymentLineItemEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PaymentLineItemCreateInput = {
	amount: Scalars["Int"]["input"];
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	invoiceID: Scalars["ID"]["input"];
	localAmount?: InputMaybe<Scalars["Int"]["input"]>;
	paymentID: Scalars["ID"]["input"];
};

export type PaymentLineItemEdge = {
	__typename?: "PaymentLineItemEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PaymentLineItem;
};

export type PaymentLineItemFilterInput = {
	amountEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountGT?: InputMaybe<Scalars["Int"]["input"]>;
	amountGTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	amountLT?: InputMaybe<Scalars["Int"]["input"]>;
	amountLTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	and?: InputMaybe<Array<PaymentLineItemFilterInput>>;
	displayOrderEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	displayOrderLT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderLTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	invoice?: InputMaybe<Array<InvoiceFilterInput>>;
	invoiceIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	invoiceIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	invoiceIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	invoiceIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	localAmountEQ?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountGT?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountGTE?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	localAmountIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	localAmountLT?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountLTE?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	not?: InputMaybe<PaymentLineItemFilterInput>;
	or?: InputMaybe<Array<PaymentLineItemFilterInput>>;
	payment?: InputMaybe<Array<PaymentFilterInput>>;
	paymentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	paymentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	paymentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	paymentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PaymentLineItemHistory = Node & {
	__typename?: "PaymentLineItemHistory";
	amount: Maybe<Scalars["Int"]["output"]>;
	displayOrder: Maybe<Scalars["Int"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	invoiceID: Maybe<Scalars["ID"]["output"]>;
	localAmount: Maybe<Scalars["Int"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	paymentID: Maybe<Scalars["ID"]["output"]>;
};

export type PaymentLineItemHistoryConnection = {
	__typename?: "PaymentLineItemHistoryConnection";
	edges: Array<PaymentLineItemHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PaymentLineItemHistoryEdge = {
	__typename?: "PaymentLineItemHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PaymentLineItemHistory;
};

export type PaymentLineItemHistoryFilterInput = {
	amountEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountGT?: InputMaybe<Scalars["Int"]["input"]>;
	amountGTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	amountIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	amountLT?: InputMaybe<Scalars["Int"]["input"]>;
	amountLTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	and?: InputMaybe<Array<PaymentLineItemHistoryFilterInput>>;
	displayOrderEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	displayOrderIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	displayOrderLT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderLTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	invoiceIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	invoiceIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	invoiceIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	invoiceIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	invoiceIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	localAmountEQ?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountGT?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountGTE?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	localAmountIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	localAmountLT?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountLTE?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	not?: InputMaybe<PaymentLineItemHistoryFilterInput>;
	or?: InputMaybe<Array<PaymentLineItemHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	paymentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	paymentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	paymentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	paymentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	paymentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PaymentLineItemHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PaymentLineItemHistoryOrderField>;
};

export enum PaymentLineItemHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type PaymentLineItemInInvoiceCreateInput = {
	amount: Scalars["Int"]["input"];
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	localAmount?: InputMaybe<Scalars["Int"]["input"]>;
	paymentID: Scalars["ID"]["input"];
};

export type PaymentLineItemInPaymentCreateInput = {
	amount: Scalars["Int"]["input"];
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	invoiceID: Scalars["ID"]["input"];
	localAmount?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PaymentLineItemOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PaymentLineItemOrderField>;
};

export enum PaymentLineItemOrderField {
	DisplayOrder = "DISPLAY_ORDER",
}

export type PaymentLineItemUpdateBulkInput = {
	amount?: InputMaybe<Scalars["Int"]["input"]>;
	clearLocalAmount?: InputMaybe<Scalars["Boolean"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	localAmount?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PaymentLineItemUpdateInput = {
	amount?: InputMaybe<Scalars["Int"]["input"]>;
	clearLocalAmount?: InputMaybe<Scalars["Boolean"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	localAmount?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PaymentOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PaymentOrderField>;
};

export enum PaymentOrderField {
	IssueDate = "ISSUE_DATE",
}

export enum PaymentPaymentMethod {
	BankTransfer = "bank_transfer",
	Cash = "cash",
	Check = "check",
	CreditCard = "credit_card",
}

export type PaymentUpdateBulkInput = {
	clearGuardianPayer?: InputMaybe<Scalars["Boolean"]["input"]>;
	customPayerName?: InputMaybe<Scalars["String"]["input"]>;
	guardianPayerID?: InputMaybe<Scalars["ID"]["input"]>;
	issueDate?: InputMaybe<Scalars["Date"]["input"]>;
	localCurrency?: InputMaybe<Scalars["String"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	paymentMethod?: InputMaybe<PaymentPaymentMethod>;
};

export type PaymentUpdateInput = {
	clearGuardianPayer?: InputMaybe<Scalars["Boolean"]["input"]>;
	customPayerName?: InputMaybe<Scalars["String"]["input"]>;
	guardianPayerID?: InputMaybe<Scalars["ID"]["input"]>;
	issueDate?: InputMaybe<Scalars["Date"]["input"]>;
	localCurrency?: InputMaybe<Scalars["String"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	paymentMethod?: InputMaybe<PaymentPaymentMethod>;
};

export type Permission = Node & {
	__typename?: "Permission";
	action: Scalars["String"]["output"];
	description: Scalars["String"]["output"];
	family: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	level: Scalars["String"]["output"];
	name: Scalars["String"]["output"];
	permissionGroups: Array<PermissionGroup>;
};

export type PermissionPermissionGroupsArgs = {
	filters?: InputMaybe<Array<PermissionGroupFilterInput>>;
	order?: InputMaybe<PermissionGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PermissionConnection = {
	__typename?: "PermissionConnection";
	edges: Array<PermissionEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PermissionEdge = {
	__typename?: "PermissionEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Permission;
};

export type PermissionFilterInput = {
	actionContains?: InputMaybe<Scalars["String"]["input"]>;
	actionEQ?: InputMaybe<Scalars["String"]["input"]>;
	actionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	actionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	actionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	actionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	actionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	actionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	actionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	actionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<PermissionFilterInput>>;
	familyContains?: InputMaybe<Scalars["String"]["input"]>;
	familyEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	familyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasPermissionGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	levelContains?: InputMaybe<Scalars["String"]["input"]>;
	levelEQ?: InputMaybe<Scalars["String"]["input"]>;
	levelHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	levelHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	levelIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	levelNEQ?: InputMaybe<Scalars["String"]["input"]>;
	levelNotContains?: InputMaybe<Scalars["String"]["input"]>;
	levelNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	levelNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	levelNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<PermissionFilterInput>;
	or?: InputMaybe<Array<PermissionFilterInput>>;
	permissionGroups?: InputMaybe<Array<PermissionGroupFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type PermissionGroup = Node & {
	__typename?: "PermissionGroup";
	description: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
	permissions: Array<Permission>;
	users: Array<User>;
};

export type PermissionGroupPermissionsArgs = {
	filters?: InputMaybe<Array<PermissionFilterInput>>;
	order?: InputMaybe<PermissionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PermissionGroupUsersArgs = {
	filters?: InputMaybe<Array<UserFilterInput>>;
	order?: InputMaybe<UserOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PermissionGroupConnection = {
	__typename?: "PermissionGroupConnection";
	edges: Array<PermissionGroupEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PermissionGroupCreateInput = {
	description?: InputMaybe<Scalars["String"]["input"]>;
	name: Scalars["String"]["input"];
	permissionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PermissionGroupEdge = {
	__typename?: "PermissionGroupEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PermissionGroup;
};

export type PermissionGroupFilterInput = {
	and?: InputMaybe<Array<PermissionGroupFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasPermissions?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<PermissionGroupFilterInput>;
	or?: InputMaybe<Array<PermissionGroupFilterInput>>;
	permissions?: InputMaybe<Array<PermissionFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	users?: InputMaybe<Array<UserFilterInput>>;
};

export type PermissionGroupHistory = Node & {
	__typename?: "PermissionGroupHistory";
	description: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type PermissionGroupHistoryConnection = {
	__typename?: "PermissionGroupHistoryConnection";
	edges: Array<PermissionGroupHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PermissionGroupHistoryEdge = {
	__typename?: "PermissionGroupHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PermissionGroupHistory;
};

export type PermissionGroupHistoryFilterInput = {
	and?: InputMaybe<Array<PermissionGroupHistoryFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<PermissionGroupHistoryFilterInput>;
	or?: InputMaybe<Array<PermissionGroupHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type PermissionGroupHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PermissionGroupHistoryOrderField>;
};

export enum PermissionGroupHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type PermissionGroupOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PermissionGroupOrderField>;
};

export enum PermissionGroupOrderField {
	Name = "NAME",
}

export type PermissionGroupPermissionHistory = Node & {
	__typename?: "PermissionGroupPermissionHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	permissionGroupID: Maybe<Scalars["ID"]["output"]>;
	permissionID: Maybe<Scalars["ID"]["output"]>;
};

export type PermissionGroupPermissionHistoryConnection = {
	__typename?: "PermissionGroupPermissionHistoryConnection";
	edges: Array<PermissionGroupPermissionHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PermissionGroupPermissionHistoryEdge = {
	__typename?: "PermissionGroupPermissionHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PermissionGroupPermissionHistory;
};

export type PermissionGroupPermissionHistoryFilterInput = {
	and?: InputMaybe<Array<PermissionGroupPermissionHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<PermissionGroupPermissionHistoryFilterInput>;
	or?: InputMaybe<Array<PermissionGroupPermissionHistoryFilterInput>>;
	permissionGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	permissionGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	permissionGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	permissionGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	permissionGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	permissionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	permissionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	permissionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	permissionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	permissionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PermissionGroupPermissionHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PermissionGroupPermissionHistoryOrderField>;
};

export enum PermissionGroupPermissionHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type PermissionGroupUpdateBulkInput = {
	addPermissionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearPermissions?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	permissionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePermissionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PermissionGroupUpdateInput = {
	addPermissionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearPermissions?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	permissionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePermissionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PermissionGroupUserHistory = Node & {
	__typename?: "PermissionGroupUserHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	permissionGroupID: Maybe<Scalars["ID"]["output"]>;
	userID: Maybe<Scalars["ID"]["output"]>;
};

export type PermissionGroupUserHistoryConnection = {
	__typename?: "PermissionGroupUserHistoryConnection";
	edges: Array<PermissionGroupUserHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PermissionGroupUserHistoryEdge = {
	__typename?: "PermissionGroupUserHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PermissionGroupUserHistory;
};

export type PermissionGroupUserHistoryFilterInput = {
	and?: InputMaybe<Array<PermissionGroupUserHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<PermissionGroupUserHistoryFilterInput>;
	or?: InputMaybe<Array<PermissionGroupUserHistoryFilterInput>>;
	permissionGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	permissionGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	permissionGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	permissionGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	permissionGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PermissionGroupUserHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PermissionGroupUserHistoryOrderField>;
};

export enum PermissionGroupUserHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type PermissionHistory = Node & {
	__typename?: "PermissionHistory";
	action: Maybe<Scalars["String"]["output"]>;
	family: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	level: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type PermissionHistoryConnection = {
	__typename?: "PermissionHistoryConnection";
	edges: Array<PermissionHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PermissionHistoryEdge = {
	__typename?: "PermissionHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PermissionHistory;
};

export type PermissionHistoryFilterInput = {
	actionContains?: InputMaybe<Scalars["String"]["input"]>;
	actionEQ?: InputMaybe<Scalars["String"]["input"]>;
	actionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	actionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	actionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	actionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	actionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	actionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	actionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	actionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	actionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<PermissionHistoryFilterInput>>;
	familyContains?: InputMaybe<Scalars["String"]["input"]>;
	familyEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	familyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	familyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	levelContains?: InputMaybe<Scalars["String"]["input"]>;
	levelEQ?: InputMaybe<Scalars["String"]["input"]>;
	levelHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	levelHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	levelIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	levelIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	levelNEQ?: InputMaybe<Scalars["String"]["input"]>;
	levelNotContains?: InputMaybe<Scalars["String"]["input"]>;
	levelNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	levelNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	levelNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<PermissionHistoryFilterInput>;
	or?: InputMaybe<Array<PermissionHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type PermissionHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PermissionHistoryOrderField>;
};

export enum PermissionHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type PermissionOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PermissionOrderField>;
};

export enum PermissionOrderField {
	Action = "ACTION",
	Family = "FAMILY",
	Level = "LEVEL",
}

export type PermissionUpdateBulkInput = {
	addPermissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearPermissionGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	permissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePermissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PermissionUpdateInput = {
	addPermissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearPermissionGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	permissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePermissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type Person = Node & {
	__typename?: "Person";
	addresses: Array<Address>;
	alternateNames: Scalars["String"]["output"];
	dateOfBirth: Maybe<Scalars["Date"]["output"]>;
	emailAddresses: Array<EmailAddress>;
	employee: Maybe<Employee>;
	englishLanguageFluency: Maybe<PersonEnglishLanguageFluency>;
	familyName: Scalars["String"]["output"];
	gender: Scalars["String"]["output"];
	givenName: Scalars["String"]["output"];
	governmentDocumentIssuedBy: Scalars["String"]["output"];
	governmentDocumentNumber: Scalars["String"]["output"];
	governmentDocumentSeries: Scalars["String"]["output"];
	guardian: Maybe<Guardian>;
	id: Scalars["ID"]["output"];
	imageContentType: Scalars["String"]["output"];
	imageKey: Scalars["String"]["output"];
	imageURL: Scalars["String"]["output"];
	languages: Array<Language>;
	middleName: Scalars["String"]["output"];
	name: Scalars["String"]["output"];
	nameOrder: PersonNameOrder;
	nationalIdentificationNumber: Scalars["String"]["output"];
	nationalities: Array<Country>;
	nickname: Scalars["String"]["output"];
	occupation: Scalars["String"]["output"];
	phoneNumbers: Array<PhoneNumber>;
	publicName: Scalars["String"]["output"];
	publicNameFormat: PersonPublicNameFormat;
	student: Maybe<Student>;
	taggedMediaAttachments: Array<MediaAttachment>;
	user: Maybe<User>;
	userID: Maybe<Scalars["ID"]["output"]>;
};

export type PersonAddressesArgs = {
	filters?: InputMaybe<Array<AddressFilterInput>>;
	order?: InputMaybe<AddressOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PersonEmailAddressesArgs = {
	filters?: InputMaybe<Array<EmailAddressFilterInput>>;
	order?: InputMaybe<EmailAddressOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PersonLanguagesArgs = {
	filters?: InputMaybe<Array<LanguageFilterInput>>;
	order?: InputMaybe<LanguageOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PersonNationalitiesArgs = {
	filters?: InputMaybe<Array<CountryFilterInput>>;
	order?: InputMaybe<CountryOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PersonPhoneNumbersArgs = {
	filters?: InputMaybe<Array<PhoneNumberFilterInput>>;
	order?: InputMaybe<PhoneNumberOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PersonTaggedMediaAttachmentsArgs = {
	filters?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	order?: InputMaybe<MediaAttachmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PersonAddressHistory = Node & {
	__typename?: "PersonAddressHistory";
	addressID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	personID: Maybe<Scalars["ID"]["output"]>;
};

export type PersonAddressHistoryConnection = {
	__typename?: "PersonAddressHistoryConnection";
	edges: Array<PersonAddressHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PersonAddressHistoryEdge = {
	__typename?: "PersonAddressHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PersonAddressHistory;
};

export type PersonAddressHistoryFilterInput = {
	addressIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	addressIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addressIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	addressIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	addressIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	and?: InputMaybe<Array<PersonAddressHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<PersonAddressHistoryFilterInput>;
	or?: InputMaybe<Array<PersonAddressHistoryFilterInput>>;
	personIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	personIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PersonAddressHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PersonAddressHistoryOrderField>;
};

export enum PersonAddressHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type PersonConnection = {
	__typename?: "PersonConnection";
	edges: Array<PersonEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PersonCountryNationalityHistory = Node & {
	__typename?: "PersonCountryNationalityHistory";
	countryID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	personID: Maybe<Scalars["ID"]["output"]>;
};

export type PersonCountryNationalityHistoryConnection = {
	__typename?: "PersonCountryNationalityHistoryConnection";
	edges: Array<PersonCountryNationalityHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PersonCountryNationalityHistoryEdge = {
	__typename?: "PersonCountryNationalityHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PersonCountryNationalityHistory;
};

export type PersonCountryNationalityHistoryFilterInput = {
	and?: InputMaybe<Array<PersonCountryNationalityHistoryFilterInput>>;
	countryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	countryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	countryIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	countryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	countryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<PersonCountryNationalityHistoryFilterInput>;
	or?: InputMaybe<Array<PersonCountryNationalityHistoryFilterInput>>;
	personIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	personIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PersonCountryNationalityHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PersonCountryNationalityHistoryOrderField>;
};

export enum PersonCountryNationalityHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type PersonCreateInput = {
	addressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	alternateNames?: InputMaybe<Scalars["String"]["input"]>;
	dateOfBirth?: InputMaybe<Scalars["Date"]["input"]>;
	emailAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	emailAddresses?: InputMaybe<Array<EmailAddressInPersonCreateInput>>;
	employee?: InputMaybe<EmployeeInPersonCreateInput>;
	employeeID?: InputMaybe<Scalars["ID"]["input"]>;
	englishLanguageFluency?: InputMaybe<PersonEnglishLanguageFluency>;
	familyName: Scalars["String"]["input"];
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName: Scalars["String"]["input"];
	governmentDocumentIssuedBy?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumber?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeries?: InputMaybe<Scalars["String"]["input"]>;
	guardian?: InputMaybe<GuardianInPersonCreateInput>;
	guardianID?: InputMaybe<Scalars["ID"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	languageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<PersonNameOrder>;
	nationalIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
	nationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nickname?: InputMaybe<Scalars["String"]["input"]>;
	occupation?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	phoneNumbers?: InputMaybe<Array<PhoneNumberInPersonCreateInput>>;
	publicNameFormat?: InputMaybe<PersonPublicNameFormat>;
	student?: InputMaybe<StudentInPersonCreateInput>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
	taggedMediaAttachmentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	user?: InputMaybe<UserInPersonCreateInput>;
	userID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type PersonEdge = {
	__typename?: "PersonEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Person;
};

export enum PersonEnglishLanguageFluency {
	A1 = "a1",
	A2 = "a2",
	B1 = "b1",
	B2 = "b2",
	C1 = "c1",
	C2 = "c2",
	NoKnowledge = "no_knowledge",
}

export type PersonFilterInput = {
	addresses?: InputMaybe<Array<AddressFilterInput>>;
	alternateNamesContains?: InputMaybe<Scalars["String"]["input"]>;
	alternateNamesEQ?: InputMaybe<Scalars["String"]["input"]>;
	alternateNamesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	alternateNamesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	alternateNamesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	alternateNamesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	alternateNamesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	alternateNamesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	alternateNamesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	alternateNamesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<PersonFilterInput>>;
	dateOfBirthEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthGT?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthGTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dateOfBirthIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateOfBirthLT?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthLTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	emailAddresses?: InputMaybe<Array<EmailAddressFilterInput>>;
	employee?: InputMaybe<Array<EmployeeFilterInput>>;
	englishLanguageFluencyEQ?: InputMaybe<PersonEnglishLanguageFluency>;
	englishLanguageFluencyIn?: InputMaybe<Array<PersonEnglishLanguageFluency>>;
	englishLanguageFluencyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	englishLanguageFluencyNEQ?: InputMaybe<PersonEnglishLanguageFluency>;
	englishLanguageFluencyNotIn?: InputMaybe<Array<PersonEnglishLanguageFluency>>;
	familyNameContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	familyNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	genderContains?: InputMaybe<Scalars["String"]["input"]>;
	genderEQ?: InputMaybe<Scalars["String"]["input"]>;
	genderHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	genderHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	genderIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	genderNEQ?: InputMaybe<Scalars["String"]["input"]>;
	genderNotContains?: InputMaybe<Scalars["String"]["input"]>;
	genderNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	genderNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	genderNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	givenNameContains?: InputMaybe<Scalars["String"]["input"]>;
	givenNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	givenNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	givenNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	governmentDocumentIssuedByContains?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentIssuedByEQ?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentIssuedByHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentIssuedByHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentIssuedByIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	governmentDocumentIssuedByNEQ?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentIssuedByNotContains?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentIssuedByNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentIssuedByNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentIssuedByNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	governmentDocumentNumberContains?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumberEQ?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumberHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumberHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumberIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	governmentDocumentNumberNEQ?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumberNotContains?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumberNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumberNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumberNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	governmentDocumentSeriesContains?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeriesEQ?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeriesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeriesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeriesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	governmentDocumentSeriesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeriesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeriesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeriesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeriesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	guardian?: InputMaybe<Array<GuardianFilterInput>>;
	hasAddresses?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasEmailAddresses?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasEmployee?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasGuardian?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasLanguages?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasNationalities?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPhoneNumbers?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasTaggedMediaAttachments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUser?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	imageContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	languages?: InputMaybe<Array<LanguageFilterInput>>;
	middleNameContains?: InputMaybe<Scalars["String"]["input"]>;
	middleNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	middleNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	middleNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameOrderEQ?: InputMaybe<PersonNameOrder>;
	nameOrderIn?: InputMaybe<Array<PersonNameOrder>>;
	nameOrderNEQ?: InputMaybe<PersonNameOrder>;
	nameOrderNotIn?: InputMaybe<Array<PersonNameOrder>>;
	nationalIdentificationNumberContains?: InputMaybe<Scalars["String"]["input"]>;
	nationalIdentificationNumberEQ?: InputMaybe<Scalars["String"]["input"]>;
	nationalIdentificationNumberHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nationalIdentificationNumberHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nationalIdentificationNumberIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nationalIdentificationNumberNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nationalIdentificationNumberNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nationalIdentificationNumberNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nationalIdentificationNumberNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nationalIdentificationNumberNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nationalities?: InputMaybe<Array<CountryFilterInput>>;
	nicknameContains?: InputMaybe<Scalars["String"]["input"]>;
	nicknameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nicknameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nicknameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nicknameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nicknameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nicknameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nicknameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nicknameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nicknameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<PersonFilterInput>;
	occupationContains?: InputMaybe<Scalars["String"]["input"]>;
	occupationEQ?: InputMaybe<Scalars["String"]["input"]>;
	occupationHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	occupationHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	occupationIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	occupationNEQ?: InputMaybe<Scalars["String"]["input"]>;
	occupationNotContains?: InputMaybe<Scalars["String"]["input"]>;
	occupationNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	occupationNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	occupationNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<PersonFilterInput>>;
	phoneNumbers?: InputMaybe<Array<PhoneNumberFilterInput>>;
	publicNameFormatEQ?: InputMaybe<PersonPublicNameFormat>;
	publicNameFormatIn?: InputMaybe<Array<PersonPublicNameFormat>>;
	publicNameFormatNEQ?: InputMaybe<PersonPublicNameFormat>;
	publicNameFormatNotIn?: InputMaybe<Array<PersonPublicNameFormat>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	taggedMediaAttachments?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	user?: InputMaybe<Array<UserFilterInput>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PersonHistory = Node & {
	__typename?: "PersonHistory";
	alternateNames: Maybe<Scalars["String"]["output"]>;
	dateOfBirth: Maybe<Scalars["Date"]["output"]>;
	englishLanguageFluency: Maybe<PersonHistoryEnglishLanguageFluency>;
	familyName: Maybe<Scalars["String"]["output"]>;
	gender: Maybe<Scalars["String"]["output"]>;
	givenName: Maybe<Scalars["String"]["output"]>;
	governmentDocumentIssuedBy: Maybe<Scalars["String"]["output"]>;
	governmentDocumentNumber: Maybe<Scalars["String"]["output"]>;
	governmentDocumentSeries: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	imageContentType: Maybe<Scalars["String"]["output"]>;
	imageKey: Maybe<Scalars["String"]["output"]>;
	middleName: Maybe<Scalars["String"]["output"]>;
	nameOrder: Maybe<PersonHistoryNameOrder>;
	nationalIdentificationNumber: Maybe<Scalars["String"]["output"]>;
	nickname: Maybe<Scalars["String"]["output"]>;
	occupation: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	publicNameFormat: Maybe<PersonHistoryPublicNameFormat>;
	userID: Maybe<Scalars["ID"]["output"]>;
};

export type PersonHistoryConnection = {
	__typename?: "PersonHistoryConnection";
	edges: Array<PersonHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PersonHistoryEdge = {
	__typename?: "PersonHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PersonHistory;
};

export enum PersonHistoryEnglishLanguageFluency {
	A1 = "a1",
	A2 = "a2",
	B1 = "b1",
	B2 = "b2",
	C1 = "c1",
	C2 = "c2",
	NoKnowledge = "no_knowledge",
}

export type PersonHistoryFilterInput = {
	alternateNamesContains?: InputMaybe<Scalars["String"]["input"]>;
	alternateNamesEQ?: InputMaybe<Scalars["String"]["input"]>;
	alternateNamesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	alternateNamesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	alternateNamesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	alternateNamesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	alternateNamesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	alternateNamesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	alternateNamesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	alternateNamesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	alternateNamesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<PersonHistoryFilterInput>>;
	dateOfBirthEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthGT?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthGTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	dateOfBirthIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateOfBirthLT?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthLTE?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	dateOfBirthNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	englishLanguageFluencyEQ?: InputMaybe<PersonHistoryEnglishLanguageFluency>;
	englishLanguageFluencyIn?: InputMaybe<Array<PersonHistoryEnglishLanguageFluency>>;
	englishLanguageFluencyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	englishLanguageFluencyNEQ?: InputMaybe<PersonHistoryEnglishLanguageFluency>;
	englishLanguageFluencyNotIn?: InputMaybe<Array<PersonHistoryEnglishLanguageFluency>>;
	familyNameContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	familyNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	familyNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	genderContains?: InputMaybe<Scalars["String"]["input"]>;
	genderEQ?: InputMaybe<Scalars["String"]["input"]>;
	genderHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	genderHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	genderIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	genderIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	genderNEQ?: InputMaybe<Scalars["String"]["input"]>;
	genderNotContains?: InputMaybe<Scalars["String"]["input"]>;
	genderNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	genderNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	genderNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	givenNameContains?: InputMaybe<Scalars["String"]["input"]>;
	givenNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	givenNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	givenNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	givenNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	governmentDocumentIssuedByContains?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentIssuedByEQ?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentIssuedByHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentIssuedByHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentIssuedByIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	governmentDocumentIssuedByIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	governmentDocumentIssuedByNEQ?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentIssuedByNotContains?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentIssuedByNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentIssuedByNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentIssuedByNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	governmentDocumentNumberContains?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumberEQ?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumberHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumberHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumberIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	governmentDocumentNumberIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	governmentDocumentNumberNEQ?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumberNotContains?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumberNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumberNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumberNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	governmentDocumentSeriesContains?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeriesEQ?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeriesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeriesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeriesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	governmentDocumentSeriesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	governmentDocumentSeriesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeriesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeriesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeriesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeriesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	imageContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageContentTypeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	middleNameContains?: InputMaybe<Scalars["String"]["input"]>;
	middleNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	middleNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	middleNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	middleNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameOrderEQ?: InputMaybe<PersonHistoryNameOrder>;
	nameOrderIn?: InputMaybe<Array<PersonHistoryNameOrder>>;
	nameOrderIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameOrderNEQ?: InputMaybe<PersonHistoryNameOrder>;
	nameOrderNotIn?: InputMaybe<Array<PersonHistoryNameOrder>>;
	nationalIdentificationNumberContains?: InputMaybe<Scalars["String"]["input"]>;
	nationalIdentificationNumberEQ?: InputMaybe<Scalars["String"]["input"]>;
	nationalIdentificationNumberHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nationalIdentificationNumberHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nationalIdentificationNumberIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nationalIdentificationNumberIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nationalIdentificationNumberNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nationalIdentificationNumberNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nationalIdentificationNumberNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nationalIdentificationNumberNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nationalIdentificationNumberNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nicknameContains?: InputMaybe<Scalars["String"]["input"]>;
	nicknameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nicknameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nicknameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nicknameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nicknameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nicknameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nicknameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nicknameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nicknameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nicknameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<PersonHistoryFilterInput>;
	occupationContains?: InputMaybe<Scalars["String"]["input"]>;
	occupationEQ?: InputMaybe<Scalars["String"]["input"]>;
	occupationHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	occupationHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	occupationIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	occupationIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	occupationNEQ?: InputMaybe<Scalars["String"]["input"]>;
	occupationNotContains?: InputMaybe<Scalars["String"]["input"]>;
	occupationNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	occupationNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	occupationNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<PersonHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	publicNameFormatEQ?: InputMaybe<PersonHistoryPublicNameFormat>;
	publicNameFormatIn?: InputMaybe<Array<PersonHistoryPublicNameFormat>>;
	publicNameFormatIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	publicNameFormatNEQ?: InputMaybe<PersonHistoryPublicNameFormat>;
	publicNameFormatNotIn?: InputMaybe<Array<PersonHistoryPublicNameFormat>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export enum PersonHistoryNameOrder {
	FamilyGiven = "family_given",
	GivenFamily = "given_family",
}

export type PersonHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PersonHistoryOrderField>;
};

export enum PersonHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export enum PersonHistoryPublicNameFormat {
	FamilyNameOnly = "family_name_only",
	FullName = "full_name",
	GivenInitialFamilyName = "given_initial_family_name",
	GivenNameFamilyInitial = "given_name_family_initial",
	GivenNameOnly = "given_name_only",
	Hidden = "hidden",
}

export type PersonInEmployeeCreateInput = {
	addressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	alternateNames?: InputMaybe<Scalars["String"]["input"]>;
	dateOfBirth?: InputMaybe<Scalars["Date"]["input"]>;
	emailAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	emailAddresses?: InputMaybe<Array<EmailAddressInPersonCreateInput>>;
	englishLanguageFluency?: InputMaybe<PersonEnglishLanguageFluency>;
	familyName: Scalars["String"]["input"];
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName: Scalars["String"]["input"];
	governmentDocumentIssuedBy?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumber?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeries?: InputMaybe<Scalars["String"]["input"]>;
	guardian?: InputMaybe<GuardianInPersonCreateInput>;
	guardianID?: InputMaybe<Scalars["ID"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	languageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<PersonNameOrder>;
	nationalIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
	nationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nickname?: InputMaybe<Scalars["String"]["input"]>;
	occupation?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	phoneNumbers?: InputMaybe<Array<PhoneNumberInPersonCreateInput>>;
	publicNameFormat?: InputMaybe<PersonPublicNameFormat>;
	student?: InputMaybe<StudentInPersonCreateInput>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
	taggedMediaAttachmentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	user?: InputMaybe<UserInPersonCreateInput>;
	userID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type PersonInGuardianCreateInput = {
	addressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	alternateNames?: InputMaybe<Scalars["String"]["input"]>;
	dateOfBirth?: InputMaybe<Scalars["Date"]["input"]>;
	emailAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	emailAddresses?: InputMaybe<Array<EmailAddressInPersonCreateInput>>;
	employee?: InputMaybe<EmployeeInPersonCreateInput>;
	employeeID?: InputMaybe<Scalars["ID"]["input"]>;
	englishLanguageFluency?: InputMaybe<PersonEnglishLanguageFluency>;
	familyName: Scalars["String"]["input"];
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName: Scalars["String"]["input"];
	governmentDocumentIssuedBy?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumber?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeries?: InputMaybe<Scalars["String"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	languageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<PersonNameOrder>;
	nationalIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
	nationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nickname?: InputMaybe<Scalars["String"]["input"]>;
	occupation?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	phoneNumbers?: InputMaybe<Array<PhoneNumberInPersonCreateInput>>;
	publicNameFormat?: InputMaybe<PersonPublicNameFormat>;
	student?: InputMaybe<StudentInPersonCreateInput>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
	taggedMediaAttachmentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	user?: InputMaybe<UserInPersonCreateInput>;
	userID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type PersonInStudentCreateInput = {
	addressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	alternateNames?: InputMaybe<Scalars["String"]["input"]>;
	dateOfBirth?: InputMaybe<Scalars["Date"]["input"]>;
	emailAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	emailAddresses?: InputMaybe<Array<EmailAddressInPersonCreateInput>>;
	employee?: InputMaybe<EmployeeInPersonCreateInput>;
	employeeID?: InputMaybe<Scalars["ID"]["input"]>;
	englishLanguageFluency?: InputMaybe<PersonEnglishLanguageFluency>;
	familyName: Scalars["String"]["input"];
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName: Scalars["String"]["input"];
	governmentDocumentIssuedBy?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumber?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeries?: InputMaybe<Scalars["String"]["input"]>;
	guardian?: InputMaybe<GuardianInPersonCreateInput>;
	guardianID?: InputMaybe<Scalars["ID"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	languageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<PersonNameOrder>;
	nationalIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
	nationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nickname?: InputMaybe<Scalars["String"]["input"]>;
	occupation?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	phoneNumbers?: InputMaybe<Array<PhoneNumberInPersonCreateInput>>;
	publicNameFormat?: InputMaybe<PersonPublicNameFormat>;
	taggedMediaAttachmentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	user?: InputMaybe<UserInPersonCreateInput>;
	userID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type PersonInUserCreateInput = {
	addressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	alternateNames?: InputMaybe<Scalars["String"]["input"]>;
	dateOfBirth?: InputMaybe<Scalars["Date"]["input"]>;
	emailAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	emailAddresses?: InputMaybe<Array<EmailAddressInPersonCreateInput>>;
	employee?: InputMaybe<EmployeeInPersonCreateInput>;
	employeeID?: InputMaybe<Scalars["ID"]["input"]>;
	englishLanguageFluency?: InputMaybe<PersonEnglishLanguageFluency>;
	familyName: Scalars["String"]["input"];
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName: Scalars["String"]["input"];
	governmentDocumentIssuedBy?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumber?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeries?: InputMaybe<Scalars["String"]["input"]>;
	guardian?: InputMaybe<GuardianInPersonCreateInput>;
	guardianID?: InputMaybe<Scalars["ID"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	languageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<PersonNameOrder>;
	nationalIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
	nationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nickname?: InputMaybe<Scalars["String"]["input"]>;
	occupation?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	phoneNumbers?: InputMaybe<Array<PhoneNumberInPersonCreateInput>>;
	publicNameFormat?: InputMaybe<PersonPublicNameFormat>;
	student?: InputMaybe<StudentInPersonCreateInput>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
	taggedMediaAttachmentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PersonLanguageHistory = Node & {
	__typename?: "PersonLanguageHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	languageID: Maybe<Scalars["ID"]["output"]>;
	personID: Maybe<Scalars["ID"]["output"]>;
};

export type PersonLanguageHistoryConnection = {
	__typename?: "PersonLanguageHistoryConnection";
	edges: Array<PersonLanguageHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PersonLanguageHistoryEdge = {
	__typename?: "PersonLanguageHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PersonLanguageHistory;
};

export type PersonLanguageHistoryFilterInput = {
	and?: InputMaybe<Array<PersonLanguageHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	languageIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	languageIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	languageIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	languageIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	languageIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<PersonLanguageHistoryFilterInput>;
	or?: InputMaybe<Array<PersonLanguageHistoryFilterInput>>;
	personIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	personIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PersonLanguageHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PersonLanguageHistoryOrderField>;
};

export enum PersonLanguageHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export enum PersonNameOrder {
	FamilyGiven = "family_given",
	GivenFamily = "given_family",
}

export type PersonOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PersonOrderField>;
};

export enum PersonOrderField {
	DateOfBirth = "DATE_OF_BIRTH",
	FamilyName = "FAMILY_NAME",
	Gender = "GENDER",
	GivenName = "GIVEN_NAME",
}

export enum PersonPublicNameFormat {
	FamilyNameOnly = "family_name_only",
	FullName = "full_name",
	GivenInitialFamilyName = "given_initial_family_name",
	GivenNameFamilyInitial = "given_name_family_initial",
	GivenNameOnly = "given_name_only",
	Hidden = "hidden",
}

export type PersonUpdateBulkInput = {
	addAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addEmailAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addLanguageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addNationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addPhoneNumberIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addTaggedMediaAttachmentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	alternateNames?: InputMaybe<Scalars["String"]["input"]>;
	clearAddresses?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearDateOfBirth?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEmailAddresses?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEnglishLanguageFluency?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearLanguages?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearNationalities?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearPhoneNumbers?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearTaggedMediaAttachments?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateOfBirth?: InputMaybe<Scalars["Date"]["input"]>;
	emailAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	englishLanguageFluency?: InputMaybe<PersonEnglishLanguageFluency>;
	familyName?: InputMaybe<Scalars["String"]["input"]>;
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentIssuedBy?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumber?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeries?: InputMaybe<Scalars["String"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	languageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<PersonNameOrder>;
	nationalIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
	nationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nickname?: InputMaybe<Scalars["String"]["input"]>;
	occupation?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	publicNameFormat?: InputMaybe<PersonPublicNameFormat>;
	removeAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEmailAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeLanguageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeNationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePhoneNumberIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeTaggedMediaAttachmentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	taggedMediaAttachmentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PersonUpdateInput = {
	addAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addEmailAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addLanguageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addNationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addPhoneNumberIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addTaggedMediaAttachmentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	alternateNames?: InputMaybe<Scalars["String"]["input"]>;
	clearAddresses?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearDateOfBirth?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEmailAddresses?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEmployee?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEnglishLanguageFluency?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearGuardian?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearLanguages?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearNationalities?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearPhoneNumbers?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearTaggedMediaAttachments?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUser?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateOfBirth?: InputMaybe<Scalars["Date"]["input"]>;
	emailAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	employeeID?: InputMaybe<Scalars["ID"]["input"]>;
	englishLanguageFluency?: InputMaybe<PersonEnglishLanguageFluency>;
	familyName?: InputMaybe<Scalars["String"]["input"]>;
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentIssuedBy?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentNumber?: InputMaybe<Scalars["String"]["input"]>;
	governmentDocumentSeries?: InputMaybe<Scalars["String"]["input"]>;
	guardianID?: InputMaybe<Scalars["ID"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	languageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<PersonNameOrder>;
	nationalIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
	nationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nickname?: InputMaybe<Scalars["String"]["input"]>;
	occupation?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	publicNameFormat?: InputMaybe<PersonPublicNameFormat>;
	removeAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEmailAddressIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeLanguageIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeNationalityIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePhoneNumberIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeTaggedMediaAttachmentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
	taggedMediaAttachmentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type PhoneNumber = Node & {
	__typename?: "PhoneNumber";
	id: Scalars["ID"]["output"];
	isPrimary: Scalars["Boolean"]["output"];
	name: Scalars["String"]["output"];
	person: Maybe<Person>;
	personID: Maybe<Scalars["ID"]["output"]>;
	phoneNumber: Scalars["String"]["output"];
};

export type PhoneNumberConnection = {
	__typename?: "PhoneNumberConnection";
	edges: Array<PhoneNumberEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PhoneNumberCreateInput = {
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	personID?: InputMaybe<Scalars["ID"]["input"]>;
	phoneNumber: Scalars["String"]["input"];
};

export type PhoneNumberEdge = {
	__typename?: "PhoneNumberEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PhoneNumber;
};

export type PhoneNumberFilterInput = {
	and?: InputMaybe<Array<PhoneNumberFilterInput>>;
	hasPerson?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isPrimaryEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<PhoneNumberFilterInput>;
	or?: InputMaybe<Array<PhoneNumberFilterInput>>;
	person?: InputMaybe<Array<PersonFilterInput>>;
	personIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	personIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	phoneNumberContains?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberEQ?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	phoneNumberNEQ?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotContains?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type PhoneNumberHistory = Node & {
	__typename?: "PhoneNumberHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isPrimary: Maybe<Scalars["Boolean"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	personID: Maybe<Scalars["ID"]["output"]>;
	phoneNumber: Maybe<Scalars["String"]["output"]>;
};

export type PhoneNumberHistoryConnection = {
	__typename?: "PhoneNumberHistoryConnection";
	edges: Array<PhoneNumberHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PhoneNumberHistoryEdge = {
	__typename?: "PhoneNumberHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PhoneNumberHistory;
};

export type PhoneNumberHistoryFilterInput = {
	and?: InputMaybe<Array<PhoneNumberHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isPrimaryEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<PhoneNumberHistoryFilterInput>;
	or?: InputMaybe<Array<PhoneNumberHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	personIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	phoneNumberContains?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberEQ?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	phoneNumberIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	phoneNumberNEQ?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotContains?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type PhoneNumberHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PhoneNumberHistoryOrderField>;
};

export enum PhoneNumberHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type PhoneNumberInPersonCreateInput = {
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumber: Scalars["String"]["input"];
};

export type PhoneNumberOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PhoneNumberOrderField>;
};

export enum PhoneNumberOrderField {
	IsPrimary = "IS_PRIMARY",
	Name = "NAME",
	PhoneNumber = "PHONE_NUMBER",
}

export type PhoneNumberUpdateBulkInput = {
	clearPerson?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	personID?: InputMaybe<Scalars["ID"]["input"]>;
	phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type PhoneNumberUpdateInput = {
	clearPerson?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	personID?: InputMaybe<Scalars["ID"]["input"]>;
	phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type PolicyAspectIndividualReportCardCompletionProgressStatistics = {
	__typename?: "PolicyAspectIndividualReportCardCompletionProgressStatistics";
	id: Scalars["ID"]["output"];
	statistics: Array<AspectIndividualReportCardCompletionProgressStatistics>;
};

export type Post = Node & {
	__typename?: "Post";
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Scalars["String"]["output"];
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	mediaAttachments: Array<MediaAttachment>;
	sharingRecord: Maybe<SharingRecord>;
	socialComments: Array<SocialComment>;
	socialReactions: Array<SocialReaction>;
	title: Scalars["String"]["output"];
};

export type PostMediaAttachmentsArgs = {
	filters?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	order?: InputMaybe<MediaAttachmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PostSocialCommentsArgs = {
	filters?: InputMaybe<Array<SocialCommentFilterInput>>;
	order?: InputMaybe<SocialCommentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PostSocialReactionsArgs = {
	filters?: InputMaybe<Array<SocialReactionFilterInput>>;
	order?: InputMaybe<SocialReactionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PostConnection = {
	__typename?: "PostConnection";
	edges: Array<PostEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PostCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInPostCreateInput>>;
	sharingRecord?: InputMaybe<SharingRecordInPostCreateInput>;
	socialComments?: InputMaybe<Array<SocialCommentInPostCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInPostCreateInput>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type PostEdge = {
	__typename?: "PostEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Post;
};

export type PostFilterInput = {
	and?: InputMaybe<Array<PostFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMediaAttachments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharingRecord?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSocialComments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSocialReactions?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	not?: InputMaybe<PostFilterInput>;
	or?: InputMaybe<Array<PostFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	sharingRecord?: InputMaybe<Array<SharingRecordFilterInput>>;
	socialComments?: InputMaybe<Array<SocialCommentFilterInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionFilterInput>>;
	titleContains?: InputMaybe<Scalars["String"]["input"]>;
	titleEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	titleNEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleNotContains?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type PostHistory = Node & {
	__typename?: "PostHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Maybe<Scalars["String"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
	title: Maybe<Scalars["String"]["output"]>;
};

export type PostHistoryConnection = {
	__typename?: "PostHistoryConnection";
	edges: Array<PostHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PostHistoryEdge = {
	__typename?: "PostHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PostHistory;
};

export type PostHistoryFilterInput = {
	and?: InputMaybe<Array<PostHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<PostHistoryFilterInput>;
	or?: InputMaybe<Array<PostHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	titleContains?: InputMaybe<Scalars["String"]["input"]>;
	titleEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	titleIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	titleNEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleNotContains?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type PostHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PostHistoryOrderField>;
};

export enum PostHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type PostInAuthorCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInPostCreateInput>>;
	sharingRecord?: InputMaybe<SharingRecordInPostCreateInput>;
	socialComments?: InputMaybe<Array<SocialCommentInPostCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInPostCreateInput>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type PostInSharingRecordCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInPostCreateInput>>;
	socialComments?: InputMaybe<Array<SocialCommentInPostCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInPostCreateInput>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type PostOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PostOrderField>;
};

export enum PostOrderField {
	CreatedAt = "CREATED_AT",
}

export type PostStatistics = {
	__typename?: "PostStatistics";
	comments: Scalars["Int"]["output"];
	count: Scalars["Int"]["output"];
	reactions: Scalars["Int"]["output"];
	views: Scalars["Int"]["output"];
};

export type PostUpdateBulkInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type PostUpdateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type Query = {
	__typename?: "Query";
	academicSubject: AcademicSubject;
	academicSubjectConnection: AcademicSubjectConnection;
	academicSubjectHistory: AcademicSubjectHistory;
	academicSubjectHistoryConnection: AcademicSubjectHistoryConnection;
	academicTerm: AcademicTerm;
	academicTermConnection: AcademicTermConnection;
	academicTermHistory: AcademicTermHistory;
	academicTermHistoryConnection: AcademicTermHistoryConnection;
	academicYear: AcademicYear;
	academicYearConnection: AcademicYearConnection;
	academicYearHistory: AcademicYearHistory;
	academicYearHistoryConnection: AcademicYearHistoryConnection;
	address: Address;
	addressConnection: AddressConnection;
	addressHistory: AddressHistory;
	addressHistoryConnection: AddressHistoryConnection;
	announcement: Announcement;
	announcementConnection: AnnouncementConnection;
	announcementHistory: AnnouncementHistory;
	announcementHistoryConnection: AnnouncementHistoryConnection;
	announcementStatistics: AnnouncementStatistics;
	aspectsReportCardSectionCompletionProgressStatistics: Array<AspectIndividualReportCardCompletionProgressStatistics>;
	attendanceStatus: AttendanceStatus;
	attendanceStatusConnection: AttendanceStatusConnection;
	attendanceStatusHistory: AttendanceStatusHistory;
	attendanceStatusHistoryConnection: AttendanceStatusHistoryConnection;
	billingAdjustment: BillingAdjustment;
	billingAdjustmentConnection: BillingAdjustmentConnection;
	billingAdjustmentHistory: BillingAdjustmentHistory;
	billingAdjustmentHistoryConnection: BillingAdjustmentHistoryConnection;
	building: Building;
	buildingConnection: BuildingConnection;
	buildingFloor: BuildingFloor;
	buildingFloorConnection: BuildingFloorConnection;
	buildingFloorHistory: BuildingFloorHistory;
	buildingFloorHistoryConnection: BuildingFloorHistoryConnection;
	buildingHistory: BuildingHistory;
	buildingHistoryConnection: BuildingHistoryConnection;
	calendarEvent: CalendarEvent;
	calendarEventConnection: CalendarEventConnection;
	calendarEventHistory: CalendarEventHistory;
	calendarEventHistoryConnection: CalendarEventHistoryConnection;
	calendarEventResponse: CalendarEventResponse;
	calendarEventResponseConnection: CalendarEventResponseConnection;
	calendarEventResponseHistory: CalendarEventResponseHistory;
	calendarEventResponseHistoryConnection: CalendarEventResponseHistoryConnection;
	calendarEventStatistics: CalendarEventStatistics;
	campus: Campus;
	campusConnection: CampusConnection;
	campusHistory: CampusHistory;
	campusHistoryConnection: CampusHistoryConnection;
	classYear: ClassYear;
	classYearCategory: ClassYearCategory;
	classYearCategoryClassYearHistory: ClassYearCategoryClassYearHistory;
	classYearCategoryClassYearHistoryConnection: ClassYearCategoryClassYearHistoryConnection;
	classYearCategoryConnection: ClassYearCategoryConnection;
	classYearCategoryHistory: ClassYearCategoryHistory;
	classYearCategoryHistoryConnection: ClassYearCategoryHistoryConnection;
	classYearConnection: ClassYearConnection;
	classYearCourseHistory: ClassYearCourseHistory;
	classYearCourseHistoryConnection: ClassYearCourseHistoryConnection;
	classYearHistory: ClassYearHistory;
	classYearHistoryConnection: ClassYearHistoryConnection;
	classYearsSchoolAttendanceRecordCountStatistics: Array<ClassYearAttendanceRecordCountStatistics>;
	contract: Contract;
	contractAcademicTermHistory: ContractAcademicTermHistory;
	contractAcademicTermHistoryConnection: ContractAcademicTermHistoryConnection;
	contractConnection: ContractConnection;
	contractHistory: ContractHistory;
	contractHistoryConnection: ContractHistoryConnection;
	contractInstallment: ContractInstallment;
	contractInstallmentConnection: ContractInstallmentConnection;
	contractInstallmentHistory: ContractInstallmentHistory;
	contractInstallmentHistoryConnection: ContractInstallmentHistoryConnection;
	contractLineItem: ContractLineItem;
	contractLineItemConnection: ContractLineItemConnection;
	contractLineItemHistory: ContractLineItemHistory;
	contractLineItemHistoryConnection: ContractLineItemHistoryConnection;
	country: Country;
	countryConnection: CountryConnection;
	countryHistory: CountryHistory;
	countryHistoryConnection: CountryHistoryConnection;
	course: Course;
	courseAssessment: CourseAssessment;
	courseAssessmentCategory: CourseAssessmentCategory;
	courseAssessmentCategoryConnection: CourseAssessmentCategoryConnection;
	courseAssessmentCategoryHistory: CourseAssessmentCategoryHistory;
	courseAssessmentCategoryHistoryConnection: CourseAssessmentCategoryHistoryConnection;
	courseAssessmentCategoryMarkPortion: CourseAssessmentCategoryMarkPortion;
	courseAssessmentCategoryMarkPortionConnection: CourseAssessmentCategoryMarkPortionConnection;
	courseAssessmentCategoryMarkPortionHistory: CourseAssessmentCategoryMarkPortionHistory;
	courseAssessmentCategoryMarkPortionHistoryConnection: CourseAssessmentCategoryMarkPortionHistoryConnection;
	courseAssessmentConnection: CourseAssessmentConnection;
	courseAssessmentHistory: CourseAssessmentHistory;
	courseAssessmentHistoryConnection: CourseAssessmentHistoryConnection;
	courseAssessmentMark: CourseAssessmentMark;
	courseAssessmentMarkConnection: CourseAssessmentMarkConnection;
	courseAssessmentMarkHistory: CourseAssessmentMarkHistory;
	courseAssessmentMarkHistoryConnection: CourseAssessmentMarkHistoryConnection;
	courseAssessmentSubmission: CourseAssessmentSubmission;
	courseAssessmentSubmissionConnection: CourseAssessmentSubmissionConnection;
	courseAssessmentSubmissionHistory: CourseAssessmentSubmissionHistory;
	courseAssessmentSubmissionHistoryConnection: CourseAssessmentSubmissionHistoryConnection;
	courseAssessmentTiming: CourseAssessmentTiming;
	courseAssessmentTimingConnection: CourseAssessmentTimingConnection;
	courseAssessmentTimingHistory: CourseAssessmentTimingHistory;
	courseAssessmentTimingHistoryConnection: CourseAssessmentTimingHistoryConnection;
	courseAttendanceRecord: CourseAttendanceRecord;
	courseAttendanceRecordConnection: CourseAttendanceRecordConnection;
	courseAttendanceRecordCountStatistics: AttendanceRecordCountStatistics;
	courseAttendanceRecordCountStatisticsRange: Array<AttendanceRecordCountStatistics>;
	courseAttendanceRecordHistory: CourseAttendanceRecordHistory;
	courseAttendanceRecordHistoryConnection: CourseAttendanceRecordHistoryConnection;
	courseConnection: CourseConnection;
	courseHistory: CourseHistory;
	courseHistoryConnection: CourseHistoryConnection;
	courseSection: CourseSection;
	courseSectionConnection: CourseSectionConnection;
	courseSectionHistory: CourseSectionHistory;
	courseSectionHistoryConnection: CourseSectionHistoryConnection;
	courseSectionPeriod: CourseSectionPeriod;
	courseSectionPeriodConnection: CourseSectionPeriodConnection;
	courseSectionPeriodHistory: CourseSectionPeriodHistory;
	courseSectionPeriodHistoryConnection: CourseSectionPeriodHistoryConnection;
	courseSectionsCourseAttendanceRecordCountStatistics: Array<CourseSectionAttendanceRecordCountStatistics>;
	dailyQuotation: Quotation;
	discount: Discount;
	discountConnection: DiscountConnection;
	discountHistory: DiscountHistory;
	discountHistoryConnection: DiscountHistoryConnection;
	emailAddress: EmailAddress;
	emailAddressConnection: EmailAddressConnection;
	emailAddressHistory: EmailAddressHistory;
	emailAddressHistoryConnection: EmailAddressHistoryConnection;
	employee: Employee;
	employeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistory: EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistory;
	employeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistoryConnection: EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistoryConnection;
	employeeCampusHistory: EmployeeCampusHistory;
	employeeCampusHistoryConnection: EmployeeCampusHistoryConnection;
	employeeClassYearCategoryHistory: EmployeeClassYearCategoryHistory;
	employeeClassYearCategoryHistoryConnection: EmployeeClassYearCategoryHistoryConnection;
	employeeClassYearHistory: EmployeeClassYearHistory;
	employeeClassYearHistoryConnection: EmployeeClassYearHistoryConnection;
	employeeConnection: EmployeeConnection;
	employeeHistory: EmployeeHistory;
	employeeHistoryConnection: EmployeeHistoryConnection;
	enrollmentApplication: EnrollmentApplication;
	enrollmentApplicationConnection: EnrollmentApplicationConnection;
	enrollmentApplicationGuardian: EnrollmentApplicationGuardian;
	enrollmentApplicationGuardianConnection: EnrollmentApplicationGuardianConnection;
	enrollmentApplicationGuardianHistory: EnrollmentApplicationGuardianHistory;
	enrollmentApplicationGuardianHistoryConnection: EnrollmentApplicationGuardianHistoryConnection;
	enrollmentApplicationHistory: EnrollmentApplicationHistory;
	enrollmentApplicationHistoryConnection: EnrollmentApplicationHistoryConnection;
	enrollmentApplicationStudent: EnrollmentApplicationStudent;
	enrollmentApplicationStudentConnection: EnrollmentApplicationStudentConnection;
	enrollmentApplicationStudentCountryNationalityHistory: EnrollmentApplicationStudentCountryNationalityHistory;
	enrollmentApplicationStudentCountryNationalityHistoryConnection: EnrollmentApplicationStudentCountryNationalityHistoryConnection;
	enrollmentApplicationStudentHistory: EnrollmentApplicationStudentHistory;
	enrollmentApplicationStudentHistoryConnection: EnrollmentApplicationStudentHistoryConnection;
	enrollmentApplicationStudentLanguageHistory: EnrollmentApplicationStudentLanguageHistory;
	enrollmentApplicationStudentLanguageHistoryConnection: EnrollmentApplicationStudentLanguageHistoryConnection;
	enrollmentApplicationStudentSchool: EnrollmentApplicationStudentSchool;
	enrollmentApplicationStudentSchoolConnection: EnrollmentApplicationStudentSchoolConnection;
	guardian: Guardian;
	guardianConnection: GuardianConnection;
	guardianHistory: GuardianHistory;
	guardianHistoryConnection: GuardianHistoryConnection;
	homeRoom: HomeRoom;
	homeRoomConnection: HomeRoomConnection;
	homeRoomHistory: HomeRoomHistory;
	homeRoomHistoryConnection: HomeRoomHistoryConnection;
	homeRoomSection: HomeRoomSection;
	homeRoomSectionConnection: HomeRoomSectionConnection;
	homeRoomSectionHistory: HomeRoomSectionHistory;
	homeRoomSectionHistoryConnection: HomeRoomSectionHistoryConnection;
	homeRoomSectionsSchoolAttendanceRecordCountStatistics: Array<HomeRoomSectionAttendanceRecordCountStatistics>;
	invoice: Invoice;
	invoiceConnection: InvoiceConnection;
	invoiceHistory: InvoiceHistory;
	invoiceHistoryConnection: InvoiceHistoryConnection;
	invoiceLineItem: InvoiceLineItem;
	invoiceLineItemConnection: InvoiceLineItemConnection;
	invoiceLineItemHistory: InvoiceLineItemHistory;
	invoiceLineItemHistoryConnection: InvoiceLineItemHistoryConnection;
	language: Language;
	languageConnection: LanguageConnection;
	languageHistory: LanguageHistory;
	languageHistoryConnection: LanguageHistoryConnection;
	latestMessageByGroupConnection: MessageConnection;
	learningObjective: LearningObjective;
	learningObjectiveCategory: LearningObjectiveCategory;
	learningObjectiveCategoryConnection: LearningObjectiveCategoryConnection;
	learningObjectiveCategoryHistory: LearningObjectiveCategoryHistory;
	learningObjectiveCategoryHistoryConnection: LearningObjectiveCategoryHistoryConnection;
	learningObjectiveConnection: LearningObjectiveConnection;
	learningObjectiveHistory: LearningObjectiveHistory;
	learningObjectiveHistoryConnection: LearningObjectiveHistoryConnection;
	loginRecord: LoginRecord;
	loginRecordConnection: LoginRecordConnection;
	markValue: MarkValue;
	markValueConnection: MarkValueConnection;
	markValueHistory: MarkValueHistory;
	markValueHistoryConnection: MarkValueHistoryConnection;
	markingSystem: MarkingSystem;
	markingSystemConnection: MarkingSystemConnection;
	markingSystemHistory: MarkingSystemHistory;
	markingSystemHistoryConnection: MarkingSystemHistoryConnection;
	mediaAttachment: MediaAttachment;
	mediaAttachmentConnection: MediaAttachmentConnection;
	mediaAttachmentHistory: MediaAttachmentHistory;
	mediaAttachmentHistoryConnection: MediaAttachmentHistoryConnection;
	mediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistory: MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistory;
	mediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistoryConnection: MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistoryConnection;
	medicalCondition: MedicalCondition;
	medicalConditionConnection: MedicalConditionConnection;
	medicalConditionHistory: MedicalConditionHistory;
	medicalConditionHistoryConnection: MedicalConditionHistoryConnection;
	medication: Medication;
	medicationConnection: MedicationConnection;
	medicationHistory: MedicationHistory;
	medicationHistoryConnection: MedicationHistoryConnection;
	message: Message;
	messageAvailabilityPeriod: MessageAvailabilityPeriod;
	messageAvailabilityPeriodConnection: MessageAvailabilityPeriodConnection;
	messageAvailabilityPeriodHistory: MessageAvailabilityPeriodHistory;
	messageAvailabilityPeriodHistoryConnection: MessageAvailabilityPeriodHistoryConnection;
	messageConnection: MessageConnection;
	messageGroup: MessageGroup;
	messageGroupArchivePoint: MessageGroupArchivePoint;
	messageGroupArchivePointConnection: MessageGroupArchivePointConnection;
	messageGroupArchivePointHistory: MessageGroupArchivePointHistory;
	messageGroupArchivePointHistoryConnection: MessageGroupArchivePointHistoryConnection;
	messageGroupConnection: MessageGroupConnection;
	messageGroupHistory: MessageGroupHistory;
	messageGroupHistoryConnection: MessageGroupHistoryConnection;
	messageGroupUserGroupHistory: MessageGroupUserGroupHistory;
	messageGroupUserGroupHistoryConnection: MessageGroupUserGroupHistoryConnection;
	messageGroupUserHistory: MessageGroupUserHistory;
	messageGroupUserHistoryConnection: MessageGroupUserHistoryConnection;
	messageHistory: MessageHistory;
	messageHistoryConnection: MessageHistoryConnection;
	messageTopic: MessageTopic;
	messageTopicConnection: MessageTopicConnection;
	messageTopicHistory: MessageTopicHistory;
	messageTopicHistoryConnection: MessageTopicHistoryConnection;
	mfaFactor: MFAFactor;
	mfaFactorConnection: MFAFactorConnection;
	mfaInvalidOTPAttempt: MFAInvalidOTPAttempt;
	mfaInvalidOTPAttemptConnection: MFAInvalidOTPAttemptConnection;
	modelIDs: Array<ModelIdInformation>;
	newsletter: Newsletter;
	newsletterConnection: NewsletterConnection;
	newsletterHistory: NewsletterHistory;
	newsletterHistoryConnection: NewsletterHistoryConnection;
	newsletterStatistics: NewsletterStatistics;
	node: Maybe<Node>;
	payment: Payment;
	paymentConnection: PaymentConnection;
	paymentHistory: PaymentHistory;
	paymentHistoryConnection: PaymentHistoryConnection;
	paymentLineItem: PaymentLineItem;
	paymentLineItemConnection: PaymentLineItemConnection;
	paymentLineItemHistory: PaymentLineItemHistory;
	paymentLineItemHistoryConnection: PaymentLineItemHistoryConnection;
	permission: Permission;
	permissionConnection: PermissionConnection;
	permissionGroup: PermissionGroup;
	permissionGroupConnection: PermissionGroupConnection;
	permissionGroupHistory: PermissionGroupHistory;
	permissionGroupHistoryConnection: PermissionGroupHistoryConnection;
	permissionGroupPermissionHistory: PermissionGroupPermissionHistory;
	permissionGroupPermissionHistoryConnection: PermissionGroupPermissionHistoryConnection;
	permissionGroupUserHistory: PermissionGroupUserHistory;
	permissionGroupUserHistoryConnection: PermissionGroupUserHistoryConnection;
	permissionHistory: PermissionHistory;
	permissionHistoryConnection: PermissionHistoryConnection;
	person: Person;
	personAddressHistory: PersonAddressHistory;
	personAddressHistoryConnection: PersonAddressHistoryConnection;
	personConnection: PersonConnection;
	personConnectionByBirthday: PersonConnection;
	personCountryNationalityHistory: PersonCountryNationalityHistory;
	personCountryNationalityHistoryConnection: PersonCountryNationalityHistoryConnection;
	personHistory: PersonHistory;
	personHistoryConnection: PersonHistoryConnection;
	personLanguageHistory: PersonLanguageHistory;
	personLanguageHistoryConnection: PersonLanguageHistoryConnection;
	phoneNumber: PhoneNumber;
	phoneNumberConnection: PhoneNumberConnection;
	phoneNumberHistory: PhoneNumberHistory;
	phoneNumberHistoryConnection: PhoneNumberHistoryConnection;
	policiesAspectsReportCardSectionCompletionProgressStatistics: Array<PolicyAspectIndividualReportCardCompletionProgressStatistics>;
	post: Post;
	postConnection: PostConnection;
	postHistory: PostHistory;
	postHistoryConnection: PostHistoryConnection;
	postStatistics: PostStatistics;
	quotation: Quotation;
	quotationConnection: QuotationConnection;
	quotationHistory: QuotationHistory;
	quotationHistoryConnection: QuotationHistoryConnection;
	refund: Refund;
	refundConnection: RefundConnection;
	refundHistory: RefundHistory;
	refundHistoryConnection: RefundHistoryConnection;
	relationship: Relationship;
	relationshipConnection: RelationshipConnection;
	relationshipHistory: RelationshipHistory;
	relationshipHistoryConnection: RelationshipHistoryConnection;
	reportCard: ReportCard;
	reportCardConnection: ReportCardConnection;
	reportCardHistory: ReportCardHistory;
	reportCardHistoryConnection: ReportCardHistoryConnection;
	reportCardSection: ReportCardSection;
	reportCardSectionConnection: ReportCardSectionConnection;
	reportCardSectionHistory: ReportCardSectionHistory;
	reportCardSectionHistoryConnection: ReportCardSectionHistoryConnection;
	reportCardSectionLearningObjective: ReportCardSectionLearningObjective;
	reportCardSectionLearningObjectiveConnection: ReportCardSectionLearningObjectiveConnection;
	reportCardSectionLearningObjectiveHistory: ReportCardSectionLearningObjectiveHistory;
	reportCardSectionLearningObjectiveHistoryConnection: ReportCardSectionLearningObjectiveHistoryConnection;
	reportCardSectionPolicy: ReportCardSectionPolicy;
	reportCardSectionPolicyConnection: ReportCardSectionPolicyConnection;
	reportCardSectionPolicyHistory: ReportCardSectionPolicyHistory;
	reportCardSectionPolicyHistoryConnection: ReportCardSectionPolicyHistoryConnection;
	reportCardSectionsCompletionProgressStatistics: AggregateReportCardCompletionProgressStatistics;
	reportCardsCompletionProgressStatistics: AggregateReportCardCompletionProgressStatistics;
	room: Room;
	roomConnection: RoomConnection;
	roomHistory: RoomHistory;
	roomHistoryConnection: RoomHistoryConnection;
	root: Scalars["Boolean"]["output"];
	schoolAttendanceRecord: SchoolAttendanceRecord;
	schoolAttendanceRecordConnection: SchoolAttendanceRecordConnection;
	schoolAttendanceRecordCountStatistics: AttendanceRecordCountStatistics;
	schoolAttendanceRecordCountStatisticsRange: Array<AttendanceRecordCountStatistics>;
	schoolAttendanceRecordHistory: SchoolAttendanceRecordHistory;
	schoolAttendanceRecordHistoryConnection: SchoolAttendanceRecordHistoryConnection;
	searchResult: SearchResult;
	searchResultConnection: SearchResultConnection;
	sectionsReportCardSectionsCompletionProgressStatistics: Array<SectionReportCardSectionsCompletionProgressStatistics>;
	service: Service;
	serviceClassYearHistory: ServiceClassYearHistory;
	serviceClassYearHistoryConnection: ServiceClassYearHistoryConnection;
	serviceConnection: ServiceConnection;
	serviceHistory: ServiceHistory;
	serviceHistoryConnection: ServiceHistoryConnection;
	session: Session;
	sessionConnection: SessionConnection;
	sharedUserConnection: UserConnection;
	sharingRecord: SharingRecord;
	sharingRecordClassYearCategoryHistory: SharingRecordClassYearCategoryHistory;
	sharingRecordClassYearCategoryHistoryConnection: SharingRecordClassYearCategoryHistoryConnection;
	sharingRecordClassYearHistory: SharingRecordClassYearHistory;
	sharingRecordClassYearHistoryConnection: SharingRecordClassYearHistoryConnection;
	sharingRecordConnection: SharingRecordConnection;
	sharingRecordCourseSectionHistory: SharingRecordCourseSectionHistory;
	sharingRecordCourseSectionHistoryConnection: SharingRecordCourseSectionHistoryConnection;
	sharingRecordHistory: SharingRecordHistory;
	sharingRecordHistoryConnection: SharingRecordHistoryConnection;
	sharingRecordHomeRoomSectionHistory: SharingRecordHomeRoomSectionHistory;
	sharingRecordHomeRoomSectionHistoryConnection: SharingRecordHomeRoomSectionHistoryConnection;
	sharingRecordSharedSharingRecordUserSharedUserHistory: SharingRecordSharedSharingRecordUserSharedUserHistory;
	sharingRecordSharedSharingRecordUserSharedUserHistoryConnection: SharingRecordSharedSharingRecordUserSharedUserHistoryConnection;
	sharingRecordUserGroupHistory: SharingRecordUserGroupHistory;
	sharingRecordUserGroupHistoryConnection: SharingRecordUserGroupHistoryConnection;
	sharingRecordUserHistory: SharingRecordUserHistory;
	sharingRecordUserHistoryConnection: SharingRecordUserHistoryConnection;
	socialComment: SocialComment;
	socialCommentConnection: SocialCommentConnection;
	socialCommentHistory: SocialCommentHistory;
	socialCommentHistoryConnection: SocialCommentHistoryConnection;
	socialReaction: SocialReaction;
	socialReactionConnection: SocialReactionConnection;
	socialReactionHistory: SocialReactionHistory;
	socialReactionHistoryConnection: SocialReactionHistoryConnection;
	student: Student;
	studentAcademicNote: StudentAcademicNote;
	studentAcademicNoteConnection: StudentAcademicNoteConnection;
	studentAcademicNoteHistory: StudentAcademicNoteHistory;
	studentAcademicNoteHistoryConnection: StudentAcademicNoteHistoryConnection;
	studentAcademicTermEnrollment: StudentAcademicTermEnrollment;
	studentAcademicTermEnrollmentConnection: StudentAcademicTermEnrollmentConnection;
	studentAcademicTermEnrollmentHistory: StudentAcademicTermEnrollmentHistory;
	studentAcademicTermEnrollmentHistoryConnection: StudentAcademicTermEnrollmentHistoryConnection;
	studentAttendanceNote: StudentAttendanceNote;
	studentAttendanceNoteConnection: StudentAttendanceNoteConnection;
	studentAttendanceNoteHistory: StudentAttendanceNoteHistory;
	studentAttendanceNoteHistoryConnection: StudentAttendanceNoteHistoryConnection;
	studentBehaviorNote: StudentBehaviorNote;
	studentBehaviorNoteConnection: StudentBehaviorNoteConnection;
	studentBehaviorNoteHistory: StudentBehaviorNoteHistory;
	studentBehaviorNoteHistoryConnection: StudentBehaviorNoteHistoryConnection;
	studentConnection: StudentConnection;
	studentCourseSectionEnrollment: StudentCourseSectionEnrollment;
	studentCourseSectionEnrollmentConnection: StudentCourseSectionEnrollmentConnection;
	studentCourseSectionEnrollmentHistory: StudentCourseSectionEnrollmentHistory;
	studentCourseSectionEnrollmentHistoryConnection: StudentCourseSectionEnrollmentHistoryConnection;
	studentDataConsent: StudentDataConsent;
	studentDataConsentConnection: StudentDataConsentConnection;
	studentDataConsentHistory: StudentDataConsentHistory;
	studentDataConsentHistoryConnection: StudentDataConsentHistoryConnection;
	studentEnrollmentApplication: StudentEnrollmentApplication;
	studentEnrollmentApplicationConnection: StudentEnrollmentApplicationConnection;
	studentEnrollmentApplicationHistory: StudentEnrollmentApplicationHistory;
	studentEnrollmentApplicationHistoryConnection: StudentEnrollmentApplicationHistoryConnection;
	studentEnrollmentIntent: StudentEnrollmentIntent;
	studentEnrollmentIntentConnection: StudentEnrollmentIntentConnection;
	studentEnrollmentIntentHistory: StudentEnrollmentIntentHistory;
	studentEnrollmentIntentHistoryConnection: StudentEnrollmentIntentHistoryConnection;
	studentHealthNote: StudentHealthNote;
	studentHealthNoteConnection: StudentHealthNoteConnection;
	studentHealthNoteHistory: StudentHealthNoteHistory;
	studentHealthNoteHistoryConnection: StudentHealthNoteHistoryConnection;
	studentHistory: StudentHistory;
	studentHistoryConnection: StudentHistoryConnection;
	studentHomeRoomSectionEnrollment: StudentHomeRoomSectionEnrollment;
	studentHomeRoomSectionEnrollmentConnection: StudentHomeRoomSectionEnrollmentConnection;
	studentHomeRoomSectionEnrollmentHistory: StudentHomeRoomSectionEnrollmentHistory;
	studentHomeRoomSectionEnrollmentHistoryConnection: StudentHomeRoomSectionEnrollmentHistoryConnection;
	studentIncidentNote: StudentIncidentNote;
	studentIncidentNoteConnection: StudentIncidentNoteConnection;
	studentIncidentNoteHistory: StudentIncidentNoteHistory;
	studentIncidentNoteHistoryConnection: StudentIncidentNoteHistoryConnection;
	studentInformationVerification: StudentInformationVerification;
	studentInformationVerificationConnection: StudentInformationVerificationConnection;
	studentInformationVerificationGuardianHistory: StudentInformationVerificationGuardianHistory;
	studentInformationVerificationGuardianHistoryConnection: StudentInformationVerificationGuardianHistoryConnection;
	studentInformationVerificationHistory: StudentInformationVerificationHistory;
	studentInformationVerificationHistoryConnection: StudentInformationVerificationHistoryConnection;
	studentInformationVerificationStudentHistory: StudentInformationVerificationStudentHistory;
	studentInformationVerificationStudentHistoryConnection: StudentInformationVerificationStudentHistoryConnection;
	studentInjuryNote: StudentInjuryNote;
	studentInjuryNoteConnection: StudentInjuryNoteConnection;
	studentInjuryNoteHistory: StudentInjuryNoteHistory;
	studentInjuryNoteHistoryConnection: StudentInjuryNoteHistoryConnection;
	studentMedicalCondition: StudentMedicalCondition;
	studentMedicalConditionConnection: StudentMedicalConditionConnection;
	studentMedicalConditionHistory: StudentMedicalConditionHistory;
	studentMedicalConditionHistoryConnection: StudentMedicalConditionHistoryConnection;
	studentMedicalContact: StudentMedicalContact;
	studentMedicalContactConnection: StudentMedicalContactConnection;
	studentMedicalContactHistory: StudentMedicalContactHistory;
	studentMedicalContactHistoryConnection: StudentMedicalContactHistoryConnection;
	studentMedicalEvent: StudentMedicalEvent;
	studentMedicalEventConnection: StudentMedicalEventConnection;
	studentMedicalEventHistory: StudentMedicalEventHistory;
	studentMedicalEventHistoryConnection: StudentMedicalEventHistoryConnection;
	studentMedicalProfile: StudentMedicalProfile;
	studentMedicalProfileConnection: StudentMedicalProfileConnection;
	studentMedicalProfileHistory: StudentMedicalProfileHistory;
	studentMedicalProfileHistoryConnection: StudentMedicalProfileHistoryConnection;
	studentMedicationNote: StudentMedicationNote;
	studentMedicationNoteConnection: StudentMedicationNoteConnection;
	studentMedicationNoteHistory: StudentMedicationNoteHistory;
	studentMedicationNoteHistoryConnection: StudentMedicationNoteHistoryConnection;
	studentMessageTopicHistory: StudentMessageTopicHistory;
	studentMessageTopicHistoryConnection: StudentMessageTopicHistoryConnection;
	studentNextYearTuitionAmount: Scalars["Int"]["output"];
	studentNextYearTuitionAmounts: Maybe<Scalars["Map"]["output"]>;
	studentNote: StudentNote;
	studentNoteConnection: StudentNoteConnection;
	studentNoteHistory: StudentNoteHistory;
	studentNoteHistoryConnection: StudentNoteHistoryConnection;
	studentNotePrimaryStudentNoteStudentPrimaryStudentHistory: StudentNotePrimaryStudentNoteStudentPrimaryStudentHistory;
	studentNotePrimaryStudentNoteStudentPrimaryStudentHistoryConnection: StudentNotePrimaryStudentNoteStudentPrimaryStudentHistoryConnection;
	studentNoteSecondaryStudentNoteStudentSecondaryStudentHistory: StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistory;
	studentNoteSecondaryStudentNoteStudentSecondaryStudentHistoryConnection: StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistoryConnection;
	studentOTCMedication: StudentOTCMedication;
	studentOTCMedicationConnection: StudentOTCMedicationConnection;
	studentOTCMedicationHistory: StudentOTCMedicationHistory;
	studentOTCMedicationHistoryConnection: StudentOTCMedicationHistoryConnection;
	studentPrescriptionMedication: StudentPrescriptionMedication;
	studentPrescriptionMedicationConnection: StudentPrescriptionMedicationConnection;
	studentPrescriptionMedicationHistory: StudentPrescriptionMedicationHistory;
	studentPrescriptionMedicationHistoryConnection: StudentPrescriptionMedicationHistoryConnection;
	studentReportCardCourseAttendanceStatistics: ReportCardAttendanceStatistics;
	studentReportCardSchoolAttendanceStatistics: ReportCardAttendanceStatistics;
	studentSchoolAttendanceRecordCountStatisticsRangeSum: AttendanceRecordCountStatistics;
	studentSchoolMailCredentials: SchoolMailCredentials;
	studentSocialEmotionalNote: StudentSocialEmotionalNote;
	studentSocialEmotionalNoteConnection: StudentSocialEmotionalNoteConnection;
	studentSocialEmotionalNoteHistory: StudentSocialEmotionalNoteHistory;
	studentSocialEmotionalNoteHistoryConnection: StudentSocialEmotionalNoteHistoryConnection;
	studentThirdPartyContractPayer: ThirdPartyContractPayer;
	studentVaccinationRecord: StudentVaccinationRecord;
	studentVaccinationRecordConnection: StudentVaccinationRecordConnection;
	studentVaccinationRecordHistory: StudentVaccinationRecordHistory;
	studentVaccinationRecordHistoryConnection: StudentVaccinationRecordHistoryConnection;
	studentsReportCardCompletionProgressStatistics: Array<IndividualReportCardCompletionProgressStatistics>;
	studentsReportCardSectionCompletionProgressStatistics: Array<IndividualReportCardCompletionProgressStatistics>;
	studentsSectionsReportCardSectionCompletionProgressStatistics: Array<StudentSectionReportCardSectionsCompletionProgressStatistics>;
	teacherCourseSectionEnrollment: TeacherCourseSectionEnrollment;
	teacherCourseSectionEnrollmentConnection: TeacherCourseSectionEnrollmentConnection;
	teacherCourseSectionEnrollmentHistory: TeacherCourseSectionEnrollmentHistory;
	teacherCourseSectionEnrollmentHistoryConnection: TeacherCourseSectionEnrollmentHistoryConnection;
	teacherHomeRoomSectionEnrollment: TeacherHomeRoomSectionEnrollment;
	teacherHomeRoomSectionEnrollmentConnection: TeacherHomeRoomSectionEnrollmentConnection;
	teacherHomeRoomSectionEnrollmentHistory: TeacherHomeRoomSectionEnrollmentHistory;
	teacherHomeRoomSectionEnrollmentHistoryConnection: TeacherHomeRoomSectionEnrollmentHistoryConnection;
	teachersSectionsReportCardSectionCompletionProgressStatistics: Array<TeacherSectionReportCardSectionsCompletionProgressStatistics>;
	timeline: TimelineConnection;
	trustedDevice: TrustedDevice;
	trustedDeviceConnection: TrustedDeviceConnection;
	unreadMessagesCount: Scalars["Int"]["output"];
	user: User;
	userConnection: UserConnection;
	userExternalNotificationMarker: UserExternalNotificationMarker;
	userExternalNotificationMarkerConnection: UserExternalNotificationMarkerConnection;
	userGroup: UserGroup;
	userGroupClassYearCategoryHistory: UserGroupClassYearCategoryHistory;
	userGroupClassYearCategoryHistoryConnection: UserGroupClassYearCategoryHistoryConnection;
	userGroupClassYearHistory: UserGroupClassYearHistory;
	userGroupClassYearHistoryConnection: UserGroupClassYearHistoryConnection;
	userGroupConnection: UserGroupConnection;
	userGroupCourseSectionHistory: UserGroupCourseSectionHistory;
	userGroupCourseSectionHistoryConnection: UserGroupCourseSectionHistoryConnection;
	userGroupHistory: UserGroupHistory;
	userGroupHistoryConnection: UserGroupHistoryConnection;
	userGroupHomeRoomSectionHistory: UserGroupHomeRoomSectionHistory;
	userGroupHomeRoomSectionHistoryConnection: UserGroupHomeRoomSectionHistoryConnection;
	userGroupMemberGroupUserMemberHistory: UserGroupMemberGroupUserMemberHistory;
	userGroupMemberGroupUserMemberHistoryConnection: UserGroupMemberGroupUserMemberHistoryConnection;
	userGroupUserHistory: UserGroupUserHistory;
	userGroupUserHistoryConnection: UserGroupUserHistoryConnection;
	userHistory: UserHistory;
	userHistoryConnection: UserHistoryConnection;
	userViewRecord: UserViewRecord;
	userViewRecordConnection: UserViewRecordConnection;
	vaccine: Vaccine;
	vaccineConnection: VaccineConnection;
	vaccineHistory: VaccineHistory;
	vaccineHistoryConnection: VaccineHistoryConnection;
	viewer: User;
};

export type QueryAcademicSubjectArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryAcademicSubjectConnectionArgs = {
	filters?: InputMaybe<Array<AcademicSubjectFilterInput>>;
	order?: InputMaybe<AcademicSubjectOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryAcademicSubjectHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryAcademicSubjectHistoryConnectionArgs = {
	filters?: InputMaybe<Array<AcademicSubjectHistoryFilterInput>>;
	order?: InputMaybe<AcademicSubjectHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryAcademicTermArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryAcademicTermConnectionArgs = {
	filters?: InputMaybe<Array<AcademicTermFilterInput>>;
	order?: InputMaybe<AcademicTermOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryAcademicTermHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryAcademicTermHistoryConnectionArgs = {
	filters?: InputMaybe<Array<AcademicTermHistoryFilterInput>>;
	order?: InputMaybe<AcademicTermHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryAcademicYearArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryAcademicYearConnectionArgs = {
	filters?: InputMaybe<Array<AcademicYearFilterInput>>;
	order?: InputMaybe<AcademicYearOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryAcademicYearHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryAcademicYearHistoryConnectionArgs = {
	filters?: InputMaybe<Array<AcademicYearHistoryFilterInput>>;
	order?: InputMaybe<AcademicYearHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryAddressArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryAddressConnectionArgs = {
	filters?: InputMaybe<Array<AddressFilterInput>>;
	order?: InputMaybe<AddressOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryAddressHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryAddressHistoryConnectionArgs = {
	filters?: InputMaybe<Array<AddressHistoryFilterInput>>;
	order?: InputMaybe<AddressHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryAnnouncementArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryAnnouncementConnectionArgs = {
	filters?: InputMaybe<Array<AnnouncementFilterInput>>;
	order?: InputMaybe<AnnouncementOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryAnnouncementHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryAnnouncementHistoryConnectionArgs = {
	filters?: InputMaybe<Array<AnnouncementHistoryFilterInput>>;
	order?: InputMaybe<AnnouncementHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryAnnouncementStatisticsArgs = {
	filters?: InputMaybe<Array<AnnouncementFilterInput>>;
};

export type QueryAspectsReportCardSectionCompletionProgressStatisticsArgs = {
	reportCardSectionFilters?: InputMaybe<Array<ReportCardSectionFilterInput>>;
};

export type QueryAttendanceStatusArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryAttendanceStatusConnectionArgs = {
	filters?: InputMaybe<Array<AttendanceStatusFilterInput>>;
	order?: InputMaybe<AttendanceStatusOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryAttendanceStatusHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryAttendanceStatusHistoryConnectionArgs = {
	filters?: InputMaybe<Array<AttendanceStatusHistoryFilterInput>>;
	order?: InputMaybe<AttendanceStatusHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryBillingAdjustmentArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryBillingAdjustmentConnectionArgs = {
	filters?: InputMaybe<Array<BillingAdjustmentFilterInput>>;
	order?: InputMaybe<BillingAdjustmentOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryBillingAdjustmentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryBillingAdjustmentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<BillingAdjustmentHistoryFilterInput>>;
	order?: InputMaybe<BillingAdjustmentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryBuildingArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryBuildingConnectionArgs = {
	filters?: InputMaybe<Array<BuildingFilterInput>>;
	order?: InputMaybe<BuildingOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryBuildingFloorArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryBuildingFloorConnectionArgs = {
	filters?: InputMaybe<Array<BuildingFloorFilterInput>>;
	order?: InputMaybe<BuildingFloorOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryBuildingFloorHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryBuildingFloorHistoryConnectionArgs = {
	filters?: InputMaybe<Array<BuildingFloorHistoryFilterInput>>;
	order?: InputMaybe<BuildingFloorHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryBuildingHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryBuildingHistoryConnectionArgs = {
	filters?: InputMaybe<Array<BuildingHistoryFilterInput>>;
	order?: InputMaybe<BuildingHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCalendarEventArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCalendarEventConnectionArgs = {
	filters?: InputMaybe<Array<CalendarEventFilterInput>>;
	order?: InputMaybe<CalendarEventOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCalendarEventHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCalendarEventHistoryConnectionArgs = {
	filters?: InputMaybe<Array<CalendarEventHistoryFilterInput>>;
	order?: InputMaybe<CalendarEventHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCalendarEventResponseArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCalendarEventResponseConnectionArgs = {
	filters?: InputMaybe<Array<CalendarEventResponseFilterInput>>;
	order?: InputMaybe<CalendarEventResponseOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCalendarEventResponseHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCalendarEventResponseHistoryConnectionArgs = {
	filters?: InputMaybe<Array<CalendarEventResponseHistoryFilterInput>>;
	order?: InputMaybe<CalendarEventResponseHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCalendarEventStatisticsArgs = {
	filters?: InputMaybe<Array<CalendarEventFilterInput>>;
};

export type QueryCampusArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCampusConnectionArgs = {
	filters?: InputMaybe<Array<CampusFilterInput>>;
	order?: InputMaybe<CampusOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCampusHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCampusHistoryConnectionArgs = {
	filters?: InputMaybe<Array<CampusHistoryFilterInput>>;
	order?: InputMaybe<CampusHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryClassYearArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryClassYearCategoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryClassYearCategoryClassYearHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryClassYearCategoryClassYearHistoryConnectionArgs = {
	filters?: InputMaybe<Array<ClassYearCategoryClassYearHistoryFilterInput>>;
	order?: InputMaybe<ClassYearCategoryClassYearHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryClassYearCategoryConnectionArgs = {
	filters?: InputMaybe<Array<ClassYearCategoryFilterInput>>;
	order?: InputMaybe<ClassYearCategoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryClassYearCategoryHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryClassYearCategoryHistoryConnectionArgs = {
	filters?: InputMaybe<Array<ClassYearCategoryHistoryFilterInput>>;
	order?: InputMaybe<ClassYearCategoryHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryClassYearConnectionArgs = {
	filters?: InputMaybe<Array<ClassYearFilterInput>>;
	order?: InputMaybe<ClassYearOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryClassYearCourseHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryClassYearCourseHistoryConnectionArgs = {
	filters?: InputMaybe<Array<ClassYearCourseHistoryFilterInput>>;
	order?: InputMaybe<ClassYearCourseHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryClassYearHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryClassYearHistoryConnectionArgs = {
	filters?: InputMaybe<Array<ClassYearHistoryFilterInput>>;
	order?: InputMaybe<ClassYearHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryClassYearsSchoolAttendanceRecordCountStatisticsArgs = {
	classYearFilters?: InputMaybe<Array<ClassYearFilterInput>>;
	date: Scalars["Date"]["input"];
	schoolAttendanceRecordFilters?: InputMaybe<Array<SchoolAttendanceRecordFilterInput>>;
};

export type QueryContractArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryContractAcademicTermHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryContractAcademicTermHistoryConnectionArgs = {
	filters?: InputMaybe<Array<ContractAcademicTermHistoryFilterInput>>;
	order?: InputMaybe<ContractAcademicTermHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryContractConnectionArgs = {
	filters?: InputMaybe<Array<ContractFilterInput>>;
	order?: InputMaybe<ContractOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryContractHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryContractHistoryConnectionArgs = {
	filters?: InputMaybe<Array<ContractHistoryFilterInput>>;
	order?: InputMaybe<ContractHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryContractInstallmentArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryContractInstallmentConnectionArgs = {
	filters?: InputMaybe<Array<ContractInstallmentFilterInput>>;
	order?: InputMaybe<ContractInstallmentOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryContractInstallmentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryContractInstallmentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<ContractInstallmentHistoryFilterInput>>;
	order?: InputMaybe<ContractInstallmentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryContractLineItemArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryContractLineItemConnectionArgs = {
	filters?: InputMaybe<Array<ContractLineItemFilterInput>>;
	order?: InputMaybe<ContractLineItemOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryContractLineItemHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryContractLineItemHistoryConnectionArgs = {
	filters?: InputMaybe<Array<ContractLineItemHistoryFilterInput>>;
	order?: InputMaybe<ContractLineItemHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCountryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCountryConnectionArgs = {
	filters?: InputMaybe<Array<CountryFilterInput>>;
	order?: InputMaybe<CountryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCountryHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCountryHistoryConnectionArgs = {
	filters?: InputMaybe<Array<CountryHistoryFilterInput>>;
	order?: InputMaybe<CountryHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseAssessmentArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseAssessmentCategoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseAssessmentCategoryConnectionArgs = {
	filters?: InputMaybe<Array<CourseAssessmentCategoryFilterInput>>;
	order?: InputMaybe<CourseAssessmentCategoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseAssessmentCategoryHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseAssessmentCategoryHistoryConnectionArgs = {
	filters?: InputMaybe<Array<CourseAssessmentCategoryHistoryFilterInput>>;
	order?: InputMaybe<CourseAssessmentCategoryHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseAssessmentCategoryMarkPortionArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseAssessmentCategoryMarkPortionConnectionArgs = {
	filters?: InputMaybe<Array<CourseAssessmentCategoryMarkPortionFilterInput>>;
	order?: InputMaybe<CourseAssessmentCategoryMarkPortionOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseAssessmentCategoryMarkPortionHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseAssessmentCategoryMarkPortionHistoryConnectionArgs = {
	filters?: InputMaybe<Array<CourseAssessmentCategoryMarkPortionHistoryFilterInput>>;
	order?: InputMaybe<CourseAssessmentCategoryMarkPortionHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseAssessmentConnectionArgs = {
	filters?: InputMaybe<Array<CourseAssessmentFilterInput>>;
	order?: InputMaybe<CourseAssessmentOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseAssessmentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseAssessmentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<CourseAssessmentHistoryFilterInput>>;
	order?: InputMaybe<CourseAssessmentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseAssessmentMarkArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseAssessmentMarkConnectionArgs = {
	filters?: InputMaybe<Array<CourseAssessmentMarkFilterInput>>;
	order?: InputMaybe<CourseAssessmentMarkOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseAssessmentMarkHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseAssessmentMarkHistoryConnectionArgs = {
	filters?: InputMaybe<Array<CourseAssessmentMarkHistoryFilterInput>>;
	order?: InputMaybe<CourseAssessmentMarkHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseAssessmentSubmissionArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseAssessmentSubmissionConnectionArgs = {
	filters?: InputMaybe<Array<CourseAssessmentSubmissionFilterInput>>;
	order?: InputMaybe<CourseAssessmentSubmissionOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseAssessmentSubmissionHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseAssessmentSubmissionHistoryConnectionArgs = {
	filters?: InputMaybe<Array<CourseAssessmentSubmissionHistoryFilterInput>>;
	order?: InputMaybe<CourseAssessmentSubmissionHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseAssessmentTimingArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseAssessmentTimingConnectionArgs = {
	filters?: InputMaybe<Array<CourseAssessmentTimingFilterInput>>;
	order?: InputMaybe<CourseAssessmentTimingOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseAssessmentTimingHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseAssessmentTimingHistoryConnectionArgs = {
	filters?: InputMaybe<Array<CourseAssessmentTimingHistoryFilterInput>>;
	order?: InputMaybe<CourseAssessmentTimingHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseAttendanceRecordArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseAttendanceRecordConnectionArgs = {
	filters?: InputMaybe<Array<CourseAttendanceRecordFilterInput>>;
	order?: InputMaybe<CourseAttendanceRecordOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseAttendanceRecordCountStatisticsArgs = {
	courseAttendanceRecordFilters?: InputMaybe<Array<CourseAttendanceRecordFilterInput>>;
	date: Scalars["Date"]["input"];
	studentFilters?: InputMaybe<Array<StudentFilterInput>>;
};

export type QueryCourseAttendanceRecordCountStatisticsRangeArgs = {
	courseAttendanceRecordFilters?: InputMaybe<Array<CourseAttendanceRecordFilterInput>>;
	endDate: Scalars["Date"]["input"];
	startDate: Scalars["Date"]["input"];
	studentFilters?: InputMaybe<Array<StudentFilterInput>>;
};

export type QueryCourseAttendanceRecordHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseAttendanceRecordHistoryConnectionArgs = {
	filters?: InputMaybe<Array<CourseAttendanceRecordHistoryFilterInput>>;
	order?: InputMaybe<CourseAttendanceRecordHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseConnectionArgs = {
	filters?: InputMaybe<Array<CourseFilterInput>>;
	order?: InputMaybe<CourseOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseHistoryConnectionArgs = {
	filters?: InputMaybe<Array<CourseHistoryFilterInput>>;
	order?: InputMaybe<CourseHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseSectionArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseSectionConnectionArgs = {
	filters?: InputMaybe<Array<CourseSectionFilterInput>>;
	order?: InputMaybe<CourseSectionOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseSectionHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseSectionHistoryConnectionArgs = {
	filters?: InputMaybe<Array<CourseSectionHistoryFilterInput>>;
	order?: InputMaybe<CourseSectionHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseSectionPeriodArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseSectionPeriodConnectionArgs = {
	filters?: InputMaybe<Array<CourseSectionPeriodFilterInput>>;
	order?: InputMaybe<CourseSectionPeriodOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseSectionPeriodHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCourseSectionPeriodHistoryConnectionArgs = {
	filters?: InputMaybe<Array<CourseSectionPeriodHistoryFilterInput>>;
	order?: InputMaybe<CourseSectionPeriodHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCourseSectionsCourseAttendanceRecordCountStatisticsArgs = {
	courseAttendanceRecordFilters?: InputMaybe<Array<CourseAttendanceRecordFilterInput>>;
	courseSectionFilters?: InputMaybe<Array<CourseSectionFilterInput>>;
	date: Scalars["Date"]["input"];
};

export type QueryDailyQuotationArgs = {
	date: Scalars["Date"]["input"];
};

export type QueryDiscountArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryDiscountConnectionArgs = {
	filters?: InputMaybe<Array<DiscountFilterInput>>;
	order?: InputMaybe<DiscountOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryDiscountHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryDiscountHistoryConnectionArgs = {
	filters?: InputMaybe<Array<DiscountHistoryFilterInput>>;
	order?: InputMaybe<DiscountHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryEmailAddressArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryEmailAddressConnectionArgs = {
	filters?: InputMaybe<Array<EmailAddressFilterInput>>;
	order?: InputMaybe<EmailAddressOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryEmailAddressHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryEmailAddressHistoryConnectionArgs = {
	filters?: InputMaybe<Array<EmailAddressHistoryFilterInput>>;
	order?: InputMaybe<EmailAddressHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryEmployeeArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryEmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryEmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistoryConnectionArgs = {
	filters?: InputMaybe<
		Array<EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistoryFilterInput>
	>;
	order?: InputMaybe<EmployeeAttendingEmployeeStudentMedicalEventAttendingStudentMedicalEventHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryEmployeeCampusHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryEmployeeCampusHistoryConnectionArgs = {
	filters?: InputMaybe<Array<EmployeeCampusHistoryFilterInput>>;
	order?: InputMaybe<EmployeeCampusHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryEmployeeClassYearCategoryHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryEmployeeClassYearCategoryHistoryConnectionArgs = {
	filters?: InputMaybe<Array<EmployeeClassYearCategoryHistoryFilterInput>>;
	order?: InputMaybe<EmployeeClassYearCategoryHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryEmployeeClassYearHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryEmployeeClassYearHistoryConnectionArgs = {
	filters?: InputMaybe<Array<EmployeeClassYearHistoryFilterInput>>;
	order?: InputMaybe<EmployeeClassYearHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryEmployeeConnectionArgs = {
	filters?: InputMaybe<Array<EmployeeFilterInput>>;
	order?: InputMaybe<EmployeeOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryEmployeeHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryEmployeeHistoryConnectionArgs = {
	filters?: InputMaybe<Array<EmployeeHistoryFilterInput>>;
	order?: InputMaybe<EmployeeHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryEnrollmentApplicationArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryEnrollmentApplicationConnectionArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryEnrollmentApplicationGuardianArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryEnrollmentApplicationGuardianConnectionArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationGuardianOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryEnrollmentApplicationGuardianHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryEnrollmentApplicationGuardianHistoryConnectionArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationGuardianHistoryFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationGuardianHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryEnrollmentApplicationHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryEnrollmentApplicationHistoryConnectionArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationHistoryFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryEnrollmentApplicationStudentArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryEnrollmentApplicationStudentConnectionArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationStudentOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryEnrollmentApplicationStudentCountryNationalityHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryEnrollmentApplicationStudentCountryNationalityHistoryConnectionArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationStudentCountryNationalityHistoryFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationStudentCountryNationalityHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryEnrollmentApplicationStudentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryEnrollmentApplicationStudentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationStudentHistoryFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationStudentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryEnrollmentApplicationStudentLanguageHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryEnrollmentApplicationStudentLanguageHistoryConnectionArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationStudentLanguageHistoryFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationStudentLanguageHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryEnrollmentApplicationStudentSchoolArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryEnrollmentApplicationStudentSchoolConnectionArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationStudentSchoolFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationStudentSchoolOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryGuardianArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryGuardianConnectionArgs = {
	filters?: InputMaybe<Array<GuardianFilterInput>>;
	order?: InputMaybe<GuardianOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryGuardianHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryGuardianHistoryConnectionArgs = {
	filters?: InputMaybe<Array<GuardianHistoryFilterInput>>;
	order?: InputMaybe<GuardianHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryHomeRoomArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryHomeRoomConnectionArgs = {
	filters?: InputMaybe<Array<HomeRoomFilterInput>>;
	order?: InputMaybe<HomeRoomOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryHomeRoomHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryHomeRoomHistoryConnectionArgs = {
	filters?: InputMaybe<Array<HomeRoomHistoryFilterInput>>;
	order?: InputMaybe<HomeRoomHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryHomeRoomSectionArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryHomeRoomSectionConnectionArgs = {
	filters?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
	order?: InputMaybe<HomeRoomSectionOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryHomeRoomSectionHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryHomeRoomSectionHistoryConnectionArgs = {
	filters?: InputMaybe<Array<HomeRoomSectionHistoryFilterInput>>;
	order?: InputMaybe<HomeRoomSectionHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryHomeRoomSectionsSchoolAttendanceRecordCountStatisticsArgs = {
	date: Scalars["Date"]["input"];
	homeRoomSectionFilters?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
	schoolAttendanceRecordFilters?: InputMaybe<Array<SchoolAttendanceRecordFilterInput>>;
};

export type QueryInvoiceArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryInvoiceConnectionArgs = {
	filters?: InputMaybe<Array<InvoiceFilterInput>>;
	order?: InputMaybe<InvoiceOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryInvoiceHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryInvoiceHistoryConnectionArgs = {
	filters?: InputMaybe<Array<InvoiceHistoryFilterInput>>;
	order?: InputMaybe<InvoiceHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryInvoiceLineItemArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryInvoiceLineItemConnectionArgs = {
	filters?: InputMaybe<Array<InvoiceLineItemFilterInput>>;
	order?: InputMaybe<InvoiceLineItemOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryInvoiceLineItemHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryInvoiceLineItemHistoryConnectionArgs = {
	filters?: InputMaybe<Array<InvoiceLineItemHistoryFilterInput>>;
	order?: InputMaybe<InvoiceLineItemHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryLanguageArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryLanguageConnectionArgs = {
	filters?: InputMaybe<Array<LanguageFilterInput>>;
	order?: InputMaybe<LanguageOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryLanguageHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryLanguageHistoryConnectionArgs = {
	filters?: InputMaybe<Array<LanguageHistoryFilterInput>>;
	order?: InputMaybe<LanguageHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryLatestMessageByGroupConnectionArgs = {
	archived?: InputMaybe<Scalars["Boolean"]["input"]>;
	filters?: InputMaybe<Array<MessageFilterInput>>;
	order?: InputMaybe<MessageOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryLearningObjectiveArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryLearningObjectiveCategoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryLearningObjectiveCategoryConnectionArgs = {
	filters?: InputMaybe<Array<LearningObjectiveCategoryFilterInput>>;
	order?: InputMaybe<LearningObjectiveCategoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryLearningObjectiveCategoryHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryLearningObjectiveCategoryHistoryConnectionArgs = {
	filters?: InputMaybe<Array<LearningObjectiveCategoryHistoryFilterInput>>;
	order?: InputMaybe<LearningObjectiveCategoryHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryLearningObjectiveConnectionArgs = {
	filters?: InputMaybe<Array<LearningObjectiveFilterInput>>;
	order?: InputMaybe<LearningObjectiveOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryLearningObjectiveHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryLearningObjectiveHistoryConnectionArgs = {
	filters?: InputMaybe<Array<LearningObjectiveHistoryFilterInput>>;
	order?: InputMaybe<LearningObjectiveHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryLoginRecordArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryLoginRecordConnectionArgs = {
	filters?: InputMaybe<Array<LoginRecordFilterInput>>;
	order?: InputMaybe<LoginRecordOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMarkValueArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMarkValueConnectionArgs = {
	filters?: InputMaybe<Array<MarkValueFilterInput>>;
	order?: InputMaybe<MarkValueOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMarkValueHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMarkValueHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MarkValueHistoryFilterInput>>;
	order?: InputMaybe<MarkValueHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMarkingSystemArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMarkingSystemConnectionArgs = {
	filters?: InputMaybe<Array<MarkingSystemFilterInput>>;
	order?: InputMaybe<MarkingSystemOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMarkingSystemHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMarkingSystemHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MarkingSystemHistoryFilterInput>>;
	order?: InputMaybe<MarkingSystemHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMediaAttachmentArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMediaAttachmentConnectionArgs = {
	filters?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	order?: InputMaybe<MediaAttachmentOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMediaAttachmentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMediaAttachmentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MediaAttachmentHistoryFilterInput>>;
	order?: InputMaybe<MediaAttachmentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistoryFilterInput>>;
	order?: InputMaybe<MediaAttachmentTaggedMediaAttachmentPersonTaggedPersonHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMedicalConditionArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMedicalConditionConnectionArgs = {
	filters?: InputMaybe<Array<MedicalConditionFilterInput>>;
	order?: InputMaybe<MedicalConditionOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMedicalConditionHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMedicalConditionHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MedicalConditionHistoryFilterInput>>;
	order?: InputMaybe<MedicalConditionHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMedicationArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMedicationConnectionArgs = {
	filters?: InputMaybe<Array<MedicationFilterInput>>;
	order?: InputMaybe<MedicationOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMedicationHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMedicationHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MedicationHistoryFilterInput>>;
	order?: InputMaybe<MedicationHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageAvailabilityPeriodArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageAvailabilityPeriodConnectionArgs = {
	filters?: InputMaybe<Array<MessageAvailabilityPeriodFilterInput>>;
	order?: InputMaybe<MessageAvailabilityPeriodOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageAvailabilityPeriodHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageAvailabilityPeriodHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MessageAvailabilityPeriodHistoryFilterInput>>;
	order?: InputMaybe<MessageAvailabilityPeriodHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageConnectionArgs = {
	filters?: InputMaybe<Array<MessageFilterInput>>;
	order?: InputMaybe<MessageOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageGroupArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageGroupArchivePointArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageGroupArchivePointConnectionArgs = {
	filters?: InputMaybe<Array<MessageGroupArchivePointFilterInput>>;
	order?: InputMaybe<MessageGroupArchivePointOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageGroupArchivePointHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageGroupArchivePointHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MessageGroupArchivePointHistoryFilterInput>>;
	order?: InputMaybe<MessageGroupArchivePointHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageGroupConnectionArgs = {
	filters?: InputMaybe<Array<MessageGroupFilterInput>>;
	order?: InputMaybe<MessageGroupOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageGroupHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageGroupHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MessageGroupHistoryFilterInput>>;
	order?: InputMaybe<MessageGroupHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageGroupUserGroupHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageGroupUserGroupHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MessageGroupUserGroupHistoryFilterInput>>;
	order?: InputMaybe<MessageGroupUserGroupHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageGroupUserHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageGroupUserHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MessageGroupUserHistoryFilterInput>>;
	order?: InputMaybe<MessageGroupUserHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MessageHistoryFilterInput>>;
	order?: InputMaybe<MessageHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageTopicArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageTopicConnectionArgs = {
	filters?: InputMaybe<Array<MessageTopicFilterInput>>;
	order?: InputMaybe<MessageTopicOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageTopicHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageTopicHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MessageTopicHistoryFilterInput>>;
	order?: InputMaybe<MessageTopicHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMFAFactorArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMFAFactorConnectionArgs = {
	filters?: InputMaybe<Array<MFAFactorFilterInput>>;
	order?: InputMaybe<MFAFactorOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMFAInvalidOTPAttemptArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMFAInvalidOTPAttemptConnectionArgs = {
	filters?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput>>;
	order?: InputMaybe<MFAInvalidOTPAttemptOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryNewsletterArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryNewsletterConnectionArgs = {
	filters?: InputMaybe<Array<NewsletterFilterInput>>;
	order?: InputMaybe<NewsletterOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryNewsletterHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryNewsletterHistoryConnectionArgs = {
	filters?: InputMaybe<Array<NewsletterHistoryFilterInput>>;
	order?: InputMaybe<NewsletterHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryNewsletterStatisticsArgs = {
	filters?: InputMaybe<Array<NewsletterFilterInput>>;
};

export type QueryNodeArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPaymentArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPaymentConnectionArgs = {
	filters?: InputMaybe<Array<PaymentFilterInput>>;
	order?: InputMaybe<PaymentOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPaymentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPaymentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<PaymentHistoryFilterInput>>;
	order?: InputMaybe<PaymentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPaymentLineItemArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPaymentLineItemConnectionArgs = {
	filters?: InputMaybe<Array<PaymentLineItemFilterInput>>;
	order?: InputMaybe<PaymentLineItemOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPaymentLineItemHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPaymentLineItemHistoryConnectionArgs = {
	filters?: InputMaybe<Array<PaymentLineItemHistoryFilterInput>>;
	order?: InputMaybe<PaymentLineItemHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPermissionArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPermissionConnectionArgs = {
	filters?: InputMaybe<Array<PermissionFilterInput>>;
	order?: InputMaybe<PermissionOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPermissionGroupArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPermissionGroupConnectionArgs = {
	filters?: InputMaybe<Array<PermissionGroupFilterInput>>;
	order?: InputMaybe<PermissionGroupOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPermissionGroupHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPermissionGroupHistoryConnectionArgs = {
	filters?: InputMaybe<Array<PermissionGroupHistoryFilterInput>>;
	order?: InputMaybe<PermissionGroupHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPermissionGroupPermissionHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPermissionGroupPermissionHistoryConnectionArgs = {
	filters?: InputMaybe<Array<PermissionGroupPermissionHistoryFilterInput>>;
	order?: InputMaybe<PermissionGroupPermissionHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPermissionGroupUserHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPermissionGroupUserHistoryConnectionArgs = {
	filters?: InputMaybe<Array<PermissionGroupUserHistoryFilterInput>>;
	order?: InputMaybe<PermissionGroupUserHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPermissionHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPermissionHistoryConnectionArgs = {
	filters?: InputMaybe<Array<PermissionHistoryFilterInput>>;
	order?: InputMaybe<PermissionHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPersonArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPersonAddressHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPersonAddressHistoryConnectionArgs = {
	filters?: InputMaybe<Array<PersonAddressHistoryFilterInput>>;
	order?: InputMaybe<PersonAddressHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPersonConnectionArgs = {
	filters?: InputMaybe<Array<PersonFilterInput>>;
	order?: InputMaybe<PersonOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPersonConnectionByBirthdayArgs = {
	dates: Array<Scalars["Date"]["input"]>;
	filters?: InputMaybe<Array<PersonFilterInput>>;
	order?: InputMaybe<PersonOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPersonCountryNationalityHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPersonCountryNationalityHistoryConnectionArgs = {
	filters?: InputMaybe<Array<PersonCountryNationalityHistoryFilterInput>>;
	order?: InputMaybe<PersonCountryNationalityHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPersonHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPersonHistoryConnectionArgs = {
	filters?: InputMaybe<Array<PersonHistoryFilterInput>>;
	order?: InputMaybe<PersonHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPersonLanguageHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPersonLanguageHistoryConnectionArgs = {
	filters?: InputMaybe<Array<PersonLanguageHistoryFilterInput>>;
	order?: InputMaybe<PersonLanguageHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPhoneNumberArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPhoneNumberConnectionArgs = {
	filters?: InputMaybe<Array<PhoneNumberFilterInput>>;
	order?: InputMaybe<PhoneNumberOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPhoneNumberHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPhoneNumberHistoryConnectionArgs = {
	filters?: InputMaybe<Array<PhoneNumberHistoryFilterInput>>;
	order?: InputMaybe<PhoneNumberHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPoliciesAspectsReportCardSectionCompletionProgressStatisticsArgs = {
	reportCardSectionFilters?: InputMaybe<Array<ReportCardSectionFilterInput>>;
};

export type QueryPostArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPostConnectionArgs = {
	filters?: InputMaybe<Array<PostFilterInput>>;
	order?: InputMaybe<PostOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPostHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPostHistoryConnectionArgs = {
	filters?: InputMaybe<Array<PostHistoryFilterInput>>;
	order?: InputMaybe<PostHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPostStatisticsArgs = {
	filters?: InputMaybe<Array<PostFilterInput>>;
};

export type QueryQuotationArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryQuotationConnectionArgs = {
	filters?: InputMaybe<Array<QuotationFilterInput>>;
	order?: InputMaybe<QuotationOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryQuotationHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryQuotationHistoryConnectionArgs = {
	filters?: InputMaybe<Array<QuotationHistoryFilterInput>>;
	order?: InputMaybe<QuotationHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryRefundArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryRefundConnectionArgs = {
	filters?: InputMaybe<Array<RefundFilterInput>>;
	order?: InputMaybe<RefundOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryRefundHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryRefundHistoryConnectionArgs = {
	filters?: InputMaybe<Array<RefundHistoryFilterInput>>;
	order?: InputMaybe<RefundHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryRelationshipArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryRelationshipConnectionArgs = {
	filters?: InputMaybe<Array<RelationshipFilterInput>>;
	order?: InputMaybe<RelationshipOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryRelationshipHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryRelationshipHistoryConnectionArgs = {
	filters?: InputMaybe<Array<RelationshipHistoryFilterInput>>;
	order?: InputMaybe<RelationshipHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryReportCardArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryReportCardConnectionArgs = {
	filters?: InputMaybe<Array<ReportCardFilterInput>>;
	order?: InputMaybe<ReportCardOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryReportCardHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryReportCardHistoryConnectionArgs = {
	filters?: InputMaybe<Array<ReportCardHistoryFilterInput>>;
	order?: InputMaybe<ReportCardHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryReportCardSectionArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryReportCardSectionConnectionArgs = {
	filters?: InputMaybe<Array<ReportCardSectionFilterInput>>;
	order?: InputMaybe<ReportCardSectionOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryReportCardSectionHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryReportCardSectionHistoryConnectionArgs = {
	filters?: InputMaybe<Array<ReportCardSectionHistoryFilterInput>>;
	order?: InputMaybe<ReportCardSectionHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryReportCardSectionLearningObjectiveArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryReportCardSectionLearningObjectiveConnectionArgs = {
	filters?: InputMaybe<Array<ReportCardSectionLearningObjectiveFilterInput>>;
	order?: InputMaybe<ReportCardSectionLearningObjectiveOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryReportCardSectionLearningObjectiveHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryReportCardSectionLearningObjectiveHistoryConnectionArgs = {
	filters?: InputMaybe<Array<ReportCardSectionLearningObjectiveHistoryFilterInput>>;
	order?: InputMaybe<ReportCardSectionLearningObjectiveHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryReportCardSectionPolicyArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryReportCardSectionPolicyConnectionArgs = {
	filters?: InputMaybe<Array<ReportCardSectionPolicyFilterInput>>;
	order?: InputMaybe<ReportCardSectionPolicyOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryReportCardSectionPolicyHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryReportCardSectionPolicyHistoryConnectionArgs = {
	filters?: InputMaybe<Array<ReportCardSectionPolicyHistoryFilterInput>>;
	order?: InputMaybe<ReportCardSectionPolicyHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryReportCardSectionsCompletionProgressStatisticsArgs = {
	filters?: InputMaybe<Array<ReportCardSectionFilterInput>>;
};

export type QueryReportCardsCompletionProgressStatisticsArgs = {
	filters?: InputMaybe<Array<ReportCardFilterInput>>;
};

export type QueryRoomArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryRoomConnectionArgs = {
	filters?: InputMaybe<Array<RoomFilterInput>>;
	order?: InputMaybe<RoomOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryRoomHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryRoomHistoryConnectionArgs = {
	filters?: InputMaybe<Array<RoomHistoryFilterInput>>;
	order?: InputMaybe<RoomHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySchoolAttendanceRecordArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySchoolAttendanceRecordConnectionArgs = {
	filters?: InputMaybe<Array<SchoolAttendanceRecordFilterInput>>;
	order?: InputMaybe<SchoolAttendanceRecordOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySchoolAttendanceRecordCountStatisticsArgs = {
	date: Scalars["Date"]["input"];
	schoolAttendanceRecordFilters?: InputMaybe<Array<SchoolAttendanceRecordFilterInput>>;
	studentFilters?: InputMaybe<Array<StudentFilterInput>>;
};

export type QuerySchoolAttendanceRecordCountStatisticsRangeArgs = {
	endDate: Scalars["Date"]["input"];
	schoolAttendanceRecordFilters?: InputMaybe<Array<SchoolAttendanceRecordFilterInput>>;
	startDate: Scalars["Date"]["input"];
	studentFilters?: InputMaybe<Array<StudentFilterInput>>;
};

export type QuerySchoolAttendanceRecordHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySchoolAttendanceRecordHistoryConnectionArgs = {
	filters?: InputMaybe<Array<SchoolAttendanceRecordHistoryFilterInput>>;
	order?: InputMaybe<SchoolAttendanceRecordHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySearchResultArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySearchResultConnectionArgs = {
	filters?: InputMaybe<Array<SearchResultFilterInput>>;
	order?: InputMaybe<SearchResultOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySectionsReportCardSectionsCompletionProgressStatisticsArgs = {
	courseSectionFilters?: InputMaybe<Array<CourseSectionFilterInput>>;
	homeRoomSectionFilters?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
};

export type QueryServiceArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryServiceClassYearHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryServiceClassYearHistoryConnectionArgs = {
	filters?: InputMaybe<Array<ServiceClassYearHistoryFilterInput>>;
	order?: InputMaybe<ServiceClassYearHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryServiceConnectionArgs = {
	filters?: InputMaybe<Array<ServiceFilterInput>>;
	order?: InputMaybe<ServiceOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryServiceHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryServiceHistoryConnectionArgs = {
	filters?: InputMaybe<Array<ServiceHistoryFilterInput>>;
	order?: InputMaybe<ServiceHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySessionArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySessionConnectionArgs = {
	filters?: InputMaybe<Array<SessionFilterInput>>;
	order?: InputMaybe<SessionOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySharedUserConnectionArgs = {
	filters?: InputMaybe<Array<UserFilterInput>>;
	order?: InputMaybe<UserOrder>;
	pagination?: InputMaybe<Pagination>;
	sharingRecord: SharingRecordCreateInput;
};

export type QuerySharingRecordArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySharingRecordClassYearCategoryHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySharingRecordClassYearCategoryHistoryConnectionArgs = {
	filters?: InputMaybe<Array<SharingRecordClassYearCategoryHistoryFilterInput>>;
	order?: InputMaybe<SharingRecordClassYearCategoryHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySharingRecordClassYearHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySharingRecordClassYearHistoryConnectionArgs = {
	filters?: InputMaybe<Array<SharingRecordClassYearHistoryFilterInput>>;
	order?: InputMaybe<SharingRecordClassYearHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySharingRecordConnectionArgs = {
	filters?: InputMaybe<Array<SharingRecordFilterInput>>;
	order?: InputMaybe<SharingRecordOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySharingRecordCourseSectionHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySharingRecordCourseSectionHistoryConnectionArgs = {
	filters?: InputMaybe<Array<SharingRecordCourseSectionHistoryFilterInput>>;
	order?: InputMaybe<SharingRecordCourseSectionHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySharingRecordHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySharingRecordHistoryConnectionArgs = {
	filters?: InputMaybe<Array<SharingRecordHistoryFilterInput>>;
	order?: InputMaybe<SharingRecordHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySharingRecordHomeRoomSectionHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySharingRecordHomeRoomSectionHistoryConnectionArgs = {
	filters?: InputMaybe<Array<SharingRecordHomeRoomSectionHistoryFilterInput>>;
	order?: InputMaybe<SharingRecordHomeRoomSectionHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySharingRecordSharedSharingRecordUserSharedUserHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySharingRecordSharedSharingRecordUserSharedUserHistoryConnectionArgs = {
	filters?: InputMaybe<Array<SharingRecordSharedSharingRecordUserSharedUserHistoryFilterInput>>;
	order?: InputMaybe<SharingRecordSharedSharingRecordUserSharedUserHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySharingRecordUserGroupHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySharingRecordUserGroupHistoryConnectionArgs = {
	filters?: InputMaybe<Array<SharingRecordUserGroupHistoryFilterInput>>;
	order?: InputMaybe<SharingRecordUserGroupHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySharingRecordUserHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySharingRecordUserHistoryConnectionArgs = {
	filters?: InputMaybe<Array<SharingRecordUserHistoryFilterInput>>;
	order?: InputMaybe<SharingRecordUserHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySocialCommentArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySocialCommentConnectionArgs = {
	filters?: InputMaybe<Array<SocialCommentFilterInput>>;
	order?: InputMaybe<SocialCommentOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySocialCommentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySocialCommentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<SocialCommentHistoryFilterInput>>;
	order?: InputMaybe<SocialCommentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySocialReactionArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySocialReactionConnectionArgs = {
	filters?: InputMaybe<Array<SocialReactionFilterInput>>;
	order?: InputMaybe<SocialReactionOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySocialReactionHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySocialReactionHistoryConnectionArgs = {
	filters?: InputMaybe<Array<SocialReactionHistoryFilterInput>>;
	order?: InputMaybe<SocialReactionHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentAcademicNoteArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentAcademicNoteConnectionArgs = {
	filters?: InputMaybe<Array<StudentAcademicNoteFilterInput>>;
	order?: InputMaybe<StudentAcademicNoteOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentAcademicNoteHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentAcademicNoteHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentAcademicNoteHistoryFilterInput>>;
	order?: InputMaybe<StudentAcademicNoteHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentAcademicTermEnrollmentArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentAcademicTermEnrollmentConnectionArgs = {
	filters?: InputMaybe<Array<StudentAcademicTermEnrollmentFilterInput>>;
	order?: InputMaybe<StudentAcademicTermEnrollmentOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentAcademicTermEnrollmentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentAcademicTermEnrollmentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentAcademicTermEnrollmentHistoryFilterInput>>;
	order?: InputMaybe<StudentAcademicTermEnrollmentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentAttendanceNoteArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentAttendanceNoteConnectionArgs = {
	filters?: InputMaybe<Array<StudentAttendanceNoteFilterInput>>;
	order?: InputMaybe<StudentAttendanceNoteOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentAttendanceNoteHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentAttendanceNoteHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentAttendanceNoteHistoryFilterInput>>;
	order?: InputMaybe<StudentAttendanceNoteHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentBehaviorNoteArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentBehaviorNoteConnectionArgs = {
	filters?: InputMaybe<Array<StudentBehaviorNoteFilterInput>>;
	order?: InputMaybe<StudentBehaviorNoteOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentBehaviorNoteHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentBehaviorNoteHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentBehaviorNoteHistoryFilterInput>>;
	order?: InputMaybe<StudentBehaviorNoteHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentConnectionArgs = {
	filters?: InputMaybe<Array<StudentFilterInput>>;
	order?: InputMaybe<StudentOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentCourseSectionEnrollmentArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentCourseSectionEnrollmentConnectionArgs = {
	filters?: InputMaybe<Array<StudentCourseSectionEnrollmentFilterInput>>;
	order?: InputMaybe<StudentCourseSectionEnrollmentOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentCourseSectionEnrollmentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentCourseSectionEnrollmentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentCourseSectionEnrollmentHistoryFilterInput>>;
	order?: InputMaybe<StudentCourseSectionEnrollmentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentDataConsentArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentDataConsentConnectionArgs = {
	filters?: InputMaybe<Array<StudentDataConsentFilterInput>>;
	order?: InputMaybe<StudentDataConsentOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentDataConsentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentDataConsentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentDataConsentHistoryFilterInput>>;
	order?: InputMaybe<StudentDataConsentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentEnrollmentApplicationArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentEnrollmentApplicationConnectionArgs = {
	filters?: InputMaybe<Array<StudentEnrollmentApplicationFilterInput>>;
	order?: InputMaybe<StudentEnrollmentApplicationOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentEnrollmentApplicationHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentEnrollmentApplicationHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentEnrollmentApplicationHistoryFilterInput>>;
	order?: InputMaybe<StudentEnrollmentApplicationHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentEnrollmentIntentArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentEnrollmentIntentConnectionArgs = {
	filters?: InputMaybe<Array<StudentEnrollmentIntentFilterInput>>;
	order?: InputMaybe<StudentEnrollmentIntentOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentEnrollmentIntentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentEnrollmentIntentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentEnrollmentIntentHistoryFilterInput>>;
	order?: InputMaybe<StudentEnrollmentIntentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentHealthNoteArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentHealthNoteConnectionArgs = {
	filters?: InputMaybe<Array<StudentHealthNoteFilterInput>>;
	order?: InputMaybe<StudentHealthNoteOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentHealthNoteHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentHealthNoteHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentHealthNoteHistoryFilterInput>>;
	order?: InputMaybe<StudentHealthNoteHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentHistoryFilterInput>>;
	order?: InputMaybe<StudentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentHomeRoomSectionEnrollmentArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentHomeRoomSectionEnrollmentConnectionArgs = {
	filters?: InputMaybe<Array<StudentHomeRoomSectionEnrollmentFilterInput>>;
	order?: InputMaybe<StudentHomeRoomSectionEnrollmentOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentHomeRoomSectionEnrollmentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentHomeRoomSectionEnrollmentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentHomeRoomSectionEnrollmentHistoryFilterInput>>;
	order?: InputMaybe<StudentHomeRoomSectionEnrollmentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentIncidentNoteArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentIncidentNoteConnectionArgs = {
	filters?: InputMaybe<Array<StudentIncidentNoteFilterInput>>;
	order?: InputMaybe<StudentIncidentNoteOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentIncidentNoteHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentIncidentNoteHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentIncidentNoteHistoryFilterInput>>;
	order?: InputMaybe<StudentIncidentNoteHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentInformationVerificationArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentInformationVerificationConnectionArgs = {
	filters?: InputMaybe<Array<StudentInformationVerificationFilterInput>>;
	order?: InputMaybe<StudentInformationVerificationOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentInformationVerificationGuardianHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentInformationVerificationGuardianHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentInformationVerificationGuardianHistoryFilterInput>>;
	order?: InputMaybe<StudentInformationVerificationGuardianHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentInformationVerificationHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentInformationVerificationHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentInformationVerificationHistoryFilterInput>>;
	order?: InputMaybe<StudentInformationVerificationHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentInformationVerificationStudentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentInformationVerificationStudentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentInformationVerificationStudentHistoryFilterInput>>;
	order?: InputMaybe<StudentInformationVerificationStudentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentInjuryNoteArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentInjuryNoteConnectionArgs = {
	filters?: InputMaybe<Array<StudentInjuryNoteFilterInput>>;
	order?: InputMaybe<StudentInjuryNoteOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentInjuryNoteHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentInjuryNoteHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentInjuryNoteHistoryFilterInput>>;
	order?: InputMaybe<StudentInjuryNoteHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentMedicalConditionArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentMedicalConditionConnectionArgs = {
	filters?: InputMaybe<Array<StudentMedicalConditionFilterInput>>;
	order?: InputMaybe<StudentMedicalConditionOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentMedicalConditionHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentMedicalConditionHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentMedicalConditionHistoryFilterInput>>;
	order?: InputMaybe<StudentMedicalConditionHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentMedicalContactArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentMedicalContactConnectionArgs = {
	filters?: InputMaybe<Array<StudentMedicalContactFilterInput>>;
	order?: InputMaybe<StudentMedicalContactOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentMedicalContactHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentMedicalContactHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentMedicalContactHistoryFilterInput>>;
	order?: InputMaybe<StudentMedicalContactHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentMedicalEventArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentMedicalEventConnectionArgs = {
	filters?: InputMaybe<Array<StudentMedicalEventFilterInput>>;
	order?: InputMaybe<StudentMedicalEventOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentMedicalEventHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentMedicalEventHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentMedicalEventHistoryFilterInput>>;
	order?: InputMaybe<StudentMedicalEventHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentMedicalProfileArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentMedicalProfileConnectionArgs = {
	filters?: InputMaybe<Array<StudentMedicalProfileFilterInput>>;
	order?: InputMaybe<StudentMedicalProfileOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentMedicalProfileHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentMedicalProfileHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentMedicalProfileHistoryFilterInput>>;
	order?: InputMaybe<StudentMedicalProfileHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentMedicationNoteArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentMedicationNoteConnectionArgs = {
	filters?: InputMaybe<Array<StudentMedicationNoteFilterInput>>;
	order?: InputMaybe<StudentMedicationNoteOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentMedicationNoteHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentMedicationNoteHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentMedicationNoteHistoryFilterInput>>;
	order?: InputMaybe<StudentMedicationNoteHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentMessageTopicHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentMessageTopicHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentMessageTopicHistoryFilterInput>>;
	order?: InputMaybe<StudentMessageTopicHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentNextYearTuitionAmountArgs = {
	studentID: Scalars["ID"]["input"];
};

export type QueryStudentNextYearTuitionAmountsArgs = {
	filters?: InputMaybe<Array<StudentFilterInput>>;
	order?: InputMaybe<StudentOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentNoteArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentNoteConnectionArgs = {
	filters?: InputMaybe<Array<StudentNoteFilterInput>>;
	order?: InputMaybe<StudentNoteOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentNoteHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentNoteHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentNoteHistoryFilterInput>>;
	order?: InputMaybe<StudentNoteHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentNotePrimaryStudentNoteStudentPrimaryStudentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentNotePrimaryStudentNoteStudentPrimaryStudentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentNotePrimaryStudentNoteStudentPrimaryStudentHistoryFilterInput>>;
	order?: InputMaybe<StudentNotePrimaryStudentNoteStudentPrimaryStudentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentNoteSecondaryStudentNoteStudentSecondaryStudentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentNoteSecondaryStudentNoteStudentSecondaryStudentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistoryFilterInput>>;
	order?: InputMaybe<StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentOTCMedicationArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentOTCMedicationConnectionArgs = {
	filters?: InputMaybe<Array<StudentOTCMedicationFilterInput>>;
	order?: InputMaybe<StudentOTCMedicationOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentOTCMedicationHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentOTCMedicationHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentOTCMedicationHistoryFilterInput>>;
	order?: InputMaybe<StudentOTCMedicationHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentPrescriptionMedicationArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentPrescriptionMedicationConnectionArgs = {
	filters?: InputMaybe<Array<StudentPrescriptionMedicationFilterInput>>;
	order?: InputMaybe<StudentPrescriptionMedicationOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentPrescriptionMedicationHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentPrescriptionMedicationHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentPrescriptionMedicationHistoryFilterInput>>;
	order?: InputMaybe<StudentPrescriptionMedicationHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentReportCardCourseAttendanceStatisticsArgs = {
	academicTermID: Scalars["ID"]["input"];
	studentID: Scalars["ID"]["input"];
};

export type QueryStudentReportCardSchoolAttendanceStatisticsArgs = {
	academicTermID: Scalars["ID"]["input"];
	studentID: Scalars["ID"]["input"];
};

export type QueryStudentSchoolAttendanceRecordCountStatisticsRangeSumArgs = {
	endDate: Scalars["Date"]["input"];
	schoolAttendanceRecordFilters?: InputMaybe<Array<SchoolAttendanceRecordFilterInput>>;
	startDate: Scalars["Date"]["input"];
	studentID: Scalars["ID"]["input"];
};

export type QueryStudentSchoolMailCredentialsArgs = {
	studentID: Scalars["ID"]["input"];
};

export type QueryStudentSocialEmotionalNoteArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentSocialEmotionalNoteConnectionArgs = {
	filters?: InputMaybe<Array<StudentSocialEmotionalNoteFilterInput>>;
	order?: InputMaybe<StudentSocialEmotionalNoteOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentSocialEmotionalNoteHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentSocialEmotionalNoteHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentSocialEmotionalNoteHistoryFilterInput>>;
	order?: InputMaybe<StudentSocialEmotionalNoteHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentThirdPartyContractPayerArgs = {
	studentID: Scalars["ID"]["input"];
};

export type QueryStudentVaccinationRecordArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentVaccinationRecordConnectionArgs = {
	filters?: InputMaybe<Array<StudentVaccinationRecordFilterInput>>;
	order?: InputMaybe<StudentVaccinationRecordOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentVaccinationRecordHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryStudentVaccinationRecordHistoryConnectionArgs = {
	filters?: InputMaybe<Array<StudentVaccinationRecordHistoryFilterInput>>;
	order?: InputMaybe<StudentVaccinationRecordHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryStudentsReportCardCompletionProgressStatisticsArgs = {
	reportCardFilters?: InputMaybe<Array<ReportCardFilterInput>>;
};

export type QueryStudentsReportCardSectionCompletionProgressStatisticsArgs = {
	reportCardSectionFilters?: InputMaybe<Array<ReportCardSectionFilterInput>>;
};

export type QueryStudentsSectionsReportCardSectionCompletionProgressStatisticsArgs = {
	reportCardSectionFilters?: InputMaybe<Array<ReportCardSectionFilterInput>>;
};

export type QueryTeacherCourseSectionEnrollmentArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryTeacherCourseSectionEnrollmentConnectionArgs = {
	filters?: InputMaybe<Array<TeacherCourseSectionEnrollmentFilterInput>>;
	order?: InputMaybe<TeacherCourseSectionEnrollmentOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryTeacherCourseSectionEnrollmentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryTeacherCourseSectionEnrollmentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<TeacherCourseSectionEnrollmentHistoryFilterInput>>;
	order?: InputMaybe<TeacherCourseSectionEnrollmentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryTeacherHomeRoomSectionEnrollmentArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryTeacherHomeRoomSectionEnrollmentConnectionArgs = {
	filters?: InputMaybe<Array<TeacherHomeRoomSectionEnrollmentFilterInput>>;
	order?: InputMaybe<TeacherHomeRoomSectionEnrollmentOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryTeacherHomeRoomSectionEnrollmentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryTeacherHomeRoomSectionEnrollmentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<TeacherHomeRoomSectionEnrollmentHistoryFilterInput>>;
	order?: InputMaybe<TeacherHomeRoomSectionEnrollmentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryTeachersSectionsReportCardSectionCompletionProgressStatisticsArgs = {
	reportCardSectionFilters?: InputMaybe<Array<ReportCardSectionFilterInput>>;
};

export type QueryTimelineArgs = {
	filter?: InputMaybe<TimelineFilterInput>;
	pagination?: InputMaybe<TimelinePagination>;
	timeZone?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryTrustedDeviceArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryTrustedDeviceConnectionArgs = {
	filters?: InputMaybe<Array<TrustedDeviceFilterInput>>;
	order?: InputMaybe<TrustedDeviceOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserConnectionArgs = {
	filters?: InputMaybe<Array<UserFilterInput>>;
	order?: InputMaybe<UserOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserExternalNotificationMarkerArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserExternalNotificationMarkerConnectionArgs = {
	filters?: InputMaybe<Array<UserExternalNotificationMarkerFilterInput>>;
	order?: InputMaybe<UserExternalNotificationMarkerOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserGroupArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserGroupClassYearCategoryHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserGroupClassYearCategoryHistoryConnectionArgs = {
	filters?: InputMaybe<Array<UserGroupClassYearCategoryHistoryFilterInput>>;
	order?: InputMaybe<UserGroupClassYearCategoryHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserGroupClassYearHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserGroupClassYearHistoryConnectionArgs = {
	filters?: InputMaybe<Array<UserGroupClassYearHistoryFilterInput>>;
	order?: InputMaybe<UserGroupClassYearHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserGroupConnectionArgs = {
	filters?: InputMaybe<Array<UserGroupFilterInput>>;
	order?: InputMaybe<UserGroupOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserGroupCourseSectionHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserGroupCourseSectionHistoryConnectionArgs = {
	filters?: InputMaybe<Array<UserGroupCourseSectionHistoryFilterInput>>;
	order?: InputMaybe<UserGroupCourseSectionHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserGroupHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserGroupHistoryConnectionArgs = {
	filters?: InputMaybe<Array<UserGroupHistoryFilterInput>>;
	order?: InputMaybe<UserGroupHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserGroupHomeRoomSectionHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserGroupHomeRoomSectionHistoryConnectionArgs = {
	filters?: InputMaybe<Array<UserGroupHomeRoomSectionHistoryFilterInput>>;
	order?: InputMaybe<UserGroupHomeRoomSectionHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserGroupMemberGroupUserMemberHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserGroupMemberGroupUserMemberHistoryConnectionArgs = {
	filters?: InputMaybe<Array<UserGroupMemberGroupUserMemberHistoryFilterInput>>;
	order?: InputMaybe<UserGroupMemberGroupUserMemberHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserGroupUserHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserGroupUserHistoryConnectionArgs = {
	filters?: InputMaybe<Array<UserGroupUserHistoryFilterInput>>;
	order?: InputMaybe<UserGroupUserHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserHistoryConnectionArgs = {
	filters?: InputMaybe<Array<UserHistoryFilterInput>>;
	order?: InputMaybe<UserHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserViewRecordArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserViewRecordConnectionArgs = {
	filters?: InputMaybe<Array<UserViewRecordFilterInput>>;
	order?: InputMaybe<UserViewRecordOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryVaccineArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryVaccineConnectionArgs = {
	filters?: InputMaybe<Array<VaccineFilterInput>>;
	order?: InputMaybe<VaccineOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryVaccineHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryVaccineHistoryConnectionArgs = {
	filters?: InputMaybe<Array<VaccineHistoryFilterInput>>;
	order?: InputMaybe<VaccineHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type Quotation = Node & {
	__typename?: "Quotation";
	attribution: Scalars["String"]["output"];
	body: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
};

export type QuotationConnection = {
	__typename?: "QuotationConnection";
	edges: Array<QuotationEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type QuotationCreateInput = {
	attribution: Scalars["String"]["input"];
	body: Scalars["String"]["input"];
};

export type QuotationEdge = {
	__typename?: "QuotationEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Quotation;
};

export type QuotationFilterInput = {
	and?: InputMaybe<Array<QuotationFilterInput>>;
	attributionContains?: InputMaybe<Scalars["String"]["input"]>;
	attributionEQ?: InputMaybe<Scalars["String"]["input"]>;
	attributionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	attributionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	attributionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	attributionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	attributionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	attributionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	attributionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	attributionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<QuotationFilterInput>;
	or?: InputMaybe<Array<QuotationFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuotationHistory = Node & {
	__typename?: "QuotationHistory";
	attribution: Maybe<Scalars["String"]["output"]>;
	body: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type QuotationHistoryConnection = {
	__typename?: "QuotationHistoryConnection";
	edges: Array<QuotationHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type QuotationHistoryEdge = {
	__typename?: "QuotationHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: QuotationHistory;
};

export type QuotationHistoryFilterInput = {
	and?: InputMaybe<Array<QuotationHistoryFilterInput>>;
	attributionContains?: InputMaybe<Scalars["String"]["input"]>;
	attributionEQ?: InputMaybe<Scalars["String"]["input"]>;
	attributionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	attributionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	attributionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	attributionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	attributionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	attributionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	attributionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	attributionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	attributionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<QuotationHistoryFilterInput>;
	or?: InputMaybe<Array<QuotationHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuotationHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<QuotationHistoryOrderField>;
};

export enum QuotationHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type QuotationOrder = {
	direction: OrderDirection;
	field?: InputMaybe<QuotationOrderField>;
};

export enum QuotationOrderField {
	Attribution = "ATTRIBUTION",
	Body = "BODY",
}

export type QuotationUpdateBulkInput = {
	attribution?: InputMaybe<Scalars["String"]["input"]>;
	body?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuotationUpdateInput = {
	attribution?: InputMaybe<Scalars["String"]["input"]>;
	body?: InputMaybe<Scalars["String"]["input"]>;
};

export type Refund = Node & {
	__typename?: "Refund";
	amount: Scalars["Int"]["output"];
	id: Scalars["ID"]["output"];
	isInLocalCurrency: Scalars["Boolean"]["output"];
	issueDate: Scalars["Date"]["output"];
	localAmount: Maybe<Scalars["Int"]["output"]>;
	localCurrency: Scalars["String"]["output"];
	notes: Scalars["String"]["output"];
	payment: Payment;
	paymentID: Scalars["ID"]["output"];
};

export type RefundConnection = {
	__typename?: "RefundConnection";
	edges: Array<RefundEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type RefundCreateInput = {
	amount: Scalars["Int"]["input"];
	issueDate: Scalars["Date"]["input"];
	localAmount?: InputMaybe<Scalars["Int"]["input"]>;
	localCurrency?: InputMaybe<Scalars["String"]["input"]>;
	notes: Scalars["String"]["input"];
	paymentID: Scalars["ID"]["input"];
};

export type RefundEdge = {
	__typename?: "RefundEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Refund;
};

export type RefundFilterInput = {
	amountEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountGT?: InputMaybe<Scalars["Int"]["input"]>;
	amountGTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	amountLT?: InputMaybe<Scalars["Int"]["input"]>;
	amountLTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	and?: InputMaybe<Array<RefundFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	issueDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	issueDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	localAmountEQ?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountGT?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountGTE?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	localAmountIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	localAmountLT?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountLTE?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	localCurrencyContains?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyEQ?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	localCurrencyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<RefundFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<RefundFilterInput>>;
	payment?: InputMaybe<Array<PaymentFilterInput>>;
	paymentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	paymentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	paymentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	paymentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type RefundHistory = Node & {
	__typename?: "RefundHistory";
	amount: Maybe<Scalars["Int"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	issueDate: Maybe<Scalars["Date"]["output"]>;
	localAmount: Maybe<Scalars["Int"]["output"]>;
	localCurrency: Maybe<Scalars["String"]["output"]>;
	notes: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	paymentID: Maybe<Scalars["ID"]["output"]>;
};

export type RefundHistoryConnection = {
	__typename?: "RefundHistoryConnection";
	edges: Array<RefundHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type RefundHistoryEdge = {
	__typename?: "RefundHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: RefundHistory;
};

export type RefundHistoryFilterInput = {
	amountEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountGT?: InputMaybe<Scalars["Int"]["input"]>;
	amountGTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	amountIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	amountLT?: InputMaybe<Scalars["Int"]["input"]>;
	amountLTE?: InputMaybe<Scalars["Int"]["input"]>;
	amountNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	amountNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	and?: InputMaybe<Array<RefundHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	issueDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	issueDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	issueDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	localAmountEQ?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountGT?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountGTE?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	localAmountIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	localAmountLT?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountLTE?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	localAmountNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	localCurrencyContains?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyEQ?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	localCurrencyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	localCurrencyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	localCurrencyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<RefundHistoryFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<RefundHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	paymentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	paymentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	paymentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	paymentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	paymentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type RefundHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<RefundHistoryOrderField>;
};

export enum RefundHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type RefundInPaymentCreateInput = {
	amount: Scalars["Int"]["input"];
	issueDate: Scalars["Date"]["input"];
	localAmount?: InputMaybe<Scalars["Int"]["input"]>;
	localCurrency?: InputMaybe<Scalars["String"]["input"]>;
	notes: Scalars["String"]["input"];
};

export type RefundOrder = {
	direction: OrderDirection;
	field?: InputMaybe<RefundOrderField>;
};

export enum RefundOrderField {
	Amount = "AMOUNT",
	IssueDate = "ISSUE_DATE",
}

export type RefundUpdateBulkInput = {
	amount?: InputMaybe<Scalars["Int"]["input"]>;
	clearLocalAmount?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueDate?: InputMaybe<Scalars["Date"]["input"]>;
	localAmount?: InputMaybe<Scalars["Int"]["input"]>;
	localCurrency?: InputMaybe<Scalars["String"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
};

export type RefundUpdateInput = {
	amount?: InputMaybe<Scalars["Int"]["input"]>;
	clearLocalAmount?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueDate?: InputMaybe<Scalars["Date"]["input"]>;
	localAmount?: InputMaybe<Scalars["Int"]["input"]>;
	localCurrency?: InputMaybe<Scalars["String"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
};

export type Relationship = Node & {
	__typename?: "Relationship";
	guardian: Guardian;
	guardianID: Scalars["ID"]["output"];
	hasCustody: Scalars["Boolean"]["output"];
	id: Scalars["ID"]["output"];
	isAuthorizedForPickup: Scalars["Boolean"]["output"];
	isEmergencyContact: Scalars["Boolean"]["output"];
	isFinancialContact: Scalars["Boolean"]["output"];
	isPrimary: Scalars["Boolean"]["output"];
	livesWithStudent: Scalars["Boolean"]["output"];
	relationshipType: Scalars["String"]["output"];
	student: Student;
	studentID: Scalars["ID"]["output"];
};

export type RelationshipConnection = {
	__typename?: "RelationshipConnection";
	edges: Array<RelationshipEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type RelationshipCreateInput = {
	guardianID: Scalars["ID"]["input"];
	hasCustody?: InputMaybe<Scalars["Boolean"]["input"]>;
	isAuthorizedForPickup?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	relationshipType: Scalars["String"]["input"];
	studentID: Scalars["ID"]["input"];
};

export type RelationshipEdge = {
	__typename?: "RelationshipEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Relationship;
};

export type RelationshipFilterInput = {
	and?: InputMaybe<Array<RelationshipFilterInput>>;
	guardian?: InputMaybe<Array<GuardianFilterInput>>;
	guardianIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	guardianIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	guardianIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	guardianIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	hasCustodyEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCustodyNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isAuthorizedForPickupEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isAuthorizedForPickupNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContactEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContactNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContactEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContactNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudentEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudentNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<RelationshipFilterInput>;
	or?: InputMaybe<Array<RelationshipFilterInput>>;
	relationshipTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	relationshipTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type RelationshipHistory = Node & {
	__typename?: "RelationshipHistory";
	guardianID: Maybe<Scalars["ID"]["output"]>;
	hasCustody: Maybe<Scalars["Boolean"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isAuthorizedForPickup: Maybe<Scalars["Boolean"]["output"]>;
	isEmergencyContact: Maybe<Scalars["Boolean"]["output"]>;
	isFinancialContact: Maybe<Scalars["Boolean"]["output"]>;
	isPrimary: Maybe<Scalars["Boolean"]["output"]>;
	livesWithStudent: Maybe<Scalars["Boolean"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	relationshipType: Maybe<Scalars["String"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
};

export type RelationshipHistoryConnection = {
	__typename?: "RelationshipHistoryConnection";
	edges: Array<RelationshipHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type RelationshipHistoryEdge = {
	__typename?: "RelationshipHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: RelationshipHistory;
};

export type RelationshipHistoryFilterInput = {
	and?: InputMaybe<Array<RelationshipHistoryFilterInput>>;
	guardianIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	guardianIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	guardianIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	guardianIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	guardianIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	hasCustodyEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCustodyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCustodyNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isAuthorizedForPickupEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isAuthorizedForPickupIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isAuthorizedForPickupNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContactEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContactIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContactNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContactEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContactIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContactNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimaryNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudentEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudentIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudentNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<RelationshipHistoryFilterInput>;
	or?: InputMaybe<Array<RelationshipHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	relationshipTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	relationshipTypeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	relationshipTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	relationshipTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type RelationshipHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<RelationshipHistoryOrderField>;
};

export enum RelationshipHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type RelationshipInGuardianCreateInput = {
	hasCustody?: InputMaybe<Scalars["Boolean"]["input"]>;
	isAuthorizedForPickup?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	relationshipType: Scalars["String"]["input"];
	studentID: Scalars["ID"]["input"];
};

export type RelationshipInStudentCreateInput = {
	guardianID: Scalars["ID"]["input"];
	hasCustody?: InputMaybe<Scalars["Boolean"]["input"]>;
	isAuthorizedForPickup?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	relationshipType: Scalars["String"]["input"];
};

export type RelationshipOrder = {
	direction: OrderDirection;
	field?: InputMaybe<RelationshipOrderField>;
};

export enum RelationshipOrderField {
	HasCustody = "HAS_CUSTODY",
	IsAuthorizedForPickup = "IS_AUTHORIZED_FOR_PICKUP",
	IsEmergencyContact = "IS_EMERGENCY_CONTACT",
	IsFinancialContact = "IS_FINANCIAL_CONTACT",
	IsPrimary = "IS_PRIMARY",
	LivesWithStudent = "LIVES_WITH_STUDENT",
	RelationshipType = "RELATIONSHIP_TYPE",
}

export type RelationshipUpdateBulkInput = {
	guardianID?: InputMaybe<Scalars["ID"]["input"]>;
	hasCustody?: InputMaybe<Scalars["Boolean"]["input"]>;
	isAuthorizedForPickup?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	relationshipType?: InputMaybe<Scalars["String"]["input"]>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type RelationshipUpdateInput = {
	guardianID?: InputMaybe<Scalars["ID"]["input"]>;
	hasCustody?: InputMaybe<Scalars["Boolean"]["input"]>;
	isAuthorizedForPickup?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEmergencyContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isFinancialContact?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
	livesWithStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	relationshipType?: InputMaybe<Scalars["String"]["input"]>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ReportCard = Node & {
	__typename?: "ReportCard";
	academicTerm: AcademicTerm;
	academicTermID: Scalars["ID"]["output"];
	approvingUser: Maybe<User>;
	approvingUserID: Maybe<Scalars["ID"]["output"]>;
	fileContentType: Scalars["String"]["output"];
	fileKey: Scalars["String"]["output"];
	fileURL: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	isComplete: Scalars["Boolean"]["output"];
	isReleased: Scalars["Boolean"]["output"];
	releaseDate: Maybe<Scalars["Date"]["output"]>;
	reportCardSections: Array<ReportCardSection>;
	student: Student;
	studentID: Scalars["ID"]["output"];
};

export type ReportCardReportCardSectionsArgs = {
	filters?: InputMaybe<Array<ReportCardSectionFilterInput>>;
	order?: InputMaybe<ReportCardSectionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ReportCardAttendanceStatistics = {
	__typename?: "ReportCardAttendanceStatistics";
	excusedAbsent: Scalars["Int"]["output"];
	excusedEarlyDeparture: Scalars["Int"]["output"];
	excusedLateArrival: Scalars["Int"]["output"];
	present: Scalars["Int"]["output"];
	total: Scalars["Int"]["output"];
	unexcusedAbsent: Scalars["Int"]["output"];
	unexcusedEarlyDeparture: Scalars["Int"]["output"];
	unexcusedLateArrival: Scalars["Int"]["output"];
};

export type ReportCardConnection = {
	__typename?: "ReportCardConnection";
	edges: Array<ReportCardEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ReportCardCreateInput = {
	academicTermID: Scalars["ID"]["input"];
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	isComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
	isReleased?: InputMaybe<Scalars["Boolean"]["input"]>;
	releaseDate?: InputMaybe<Scalars["Date"]["input"]>;
	reportCardSections?: InputMaybe<Array<ReportCardSectionInReportCardCreateInput>>;
	studentID: Scalars["ID"]["input"];
};

export type ReportCardEdge = {
	__typename?: "ReportCardEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ReportCard;
};

export type ReportCardFilterInput = {
	academicTerm?: InputMaybe<Array<AcademicTermFilterInput>>;
	academicTermIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicTermIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	academicTermIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicTermIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	and?: InputMaybe<Array<ReportCardFilterInput>>;
	approvingUser?: InputMaybe<Array<UserFilterInput>>;
	approvingUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	approvingUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	approvingUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	approvingUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	approvingUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	fileContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasApprovingUser?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasReportCardSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isCompleteEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isCompleteNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isReleasedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isReleasedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<ReportCardFilterInput>;
	or?: InputMaybe<Array<ReportCardFilterInput>>;
	releaseDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	releaseDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	releaseDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	releaseDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	releaseDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	releaseDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	releaseDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	releaseDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	releaseDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	reportCardSections?: InputMaybe<Array<ReportCardSectionFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ReportCardHistory = Node & {
	__typename?: "ReportCardHistory";
	academicTermID: Maybe<Scalars["ID"]["output"]>;
	approvingUserID: Maybe<Scalars["ID"]["output"]>;
	fileContentType: Maybe<Scalars["String"]["output"]>;
	fileKey: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isComplete: Maybe<Scalars["Boolean"]["output"]>;
	isReleased: Maybe<Scalars["Boolean"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	releaseDate: Maybe<Scalars["Date"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
};

export type ReportCardHistoryConnection = {
	__typename?: "ReportCardHistoryConnection";
	edges: Array<ReportCardHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ReportCardHistoryEdge = {
	__typename?: "ReportCardHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ReportCardHistory;
};

export type ReportCardHistoryFilterInput = {
	academicTermIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicTermIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	academicTermIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	academicTermIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicTermIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	and?: InputMaybe<Array<ReportCardHistoryFilterInput>>;
	approvingUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	approvingUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	approvingUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	approvingUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	approvingUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	fileContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileContentTypeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	fileContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileKeyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	fileKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isCompleteEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isCompleteIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isCompleteNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isReleasedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isReleasedIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isReleasedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<ReportCardHistoryFilterInput>;
	or?: InputMaybe<Array<ReportCardHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	releaseDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	releaseDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	releaseDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	releaseDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	releaseDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	releaseDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	releaseDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	releaseDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	releaseDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ReportCardHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ReportCardHistoryOrderField>;
};

export enum ReportCardHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type ReportCardInAcademicTermCreateInput = {
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	isComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
	isReleased?: InputMaybe<Scalars["Boolean"]["input"]>;
	releaseDate?: InputMaybe<Scalars["Date"]["input"]>;
	reportCardSections?: InputMaybe<Array<ReportCardSectionInReportCardCreateInput>>;
	studentID: Scalars["ID"]["input"];
};

export type ReportCardInApprovingUserCreateInput = {
	academicTermID: Scalars["ID"]["input"];
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	isComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
	isReleased?: InputMaybe<Scalars["Boolean"]["input"]>;
	releaseDate?: InputMaybe<Scalars["Date"]["input"]>;
	reportCardSections?: InputMaybe<Array<ReportCardSectionInReportCardCreateInput>>;
	studentID: Scalars["ID"]["input"];
};

export type ReportCardInStudentCreateInput = {
	academicTermID: Scalars["ID"]["input"];
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	isComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
	isReleased?: InputMaybe<Scalars["Boolean"]["input"]>;
	releaseDate?: InputMaybe<Scalars["Date"]["input"]>;
	reportCardSections?: InputMaybe<Array<ReportCardSectionInReportCardCreateInput>>;
};

export type ReportCardOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ReportCardOrderField>;
};

export enum ReportCardOrderField {
	ReleaseDate = "RELEASE_DATE",
}

export type ReportCardSection = Node & {
	__typename?: "ReportCardSection";
	comment: Scalars["String"]["output"];
	generalComment1: Scalars["String"]["output"];
	generalComment2: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	isComplete: Scalars["Boolean"]["output"];
	overallMarkValue: Maybe<MarkValue>;
	overallMarkValueID: Maybe<Scalars["ID"]["output"]>;
	reportCard: ReportCard;
	reportCardID: Scalars["ID"]["output"];
	reportCardSectionLearningObjectives: Array<ReportCardSectionLearningObjective>;
	reportCardSectionPolicy: ReportCardSectionPolicy;
	reportCardSectionPolicyID: Scalars["ID"]["output"];
	submittingUser: Maybe<User>;
	submittingUserID: Maybe<Scalars["ID"]["output"]>;
};

export type ReportCardSectionReportCardSectionLearningObjectivesArgs = {
	filters?: InputMaybe<Array<ReportCardSectionLearningObjectiveFilterInput>>;
	order?: InputMaybe<ReportCardSectionLearningObjectiveOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ReportCardSectionConnection = {
	__typename?: "ReportCardSectionConnection";
	edges: Array<ReportCardSectionEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ReportCardSectionCreateInput = {
	comment?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2?: InputMaybe<Scalars["String"]["input"]>;
	isComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
	overallMarkValueID?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardID: Scalars["ID"]["input"];
	reportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionLearningObjectives?: InputMaybe<
		Array<ReportCardSectionLearningObjectiveInReportCardSectionCreateInput>
	>;
	reportCardSectionPolicyID: Scalars["ID"]["input"];
};

export type ReportCardSectionEdge = {
	__typename?: "ReportCardSectionEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ReportCardSection;
};

export type ReportCardSectionFilterInput = {
	and?: InputMaybe<Array<ReportCardSectionFilterInput>>;
	commentContains?: InputMaybe<Scalars["String"]["input"]>;
	commentEQ?: InputMaybe<Scalars["String"]["input"]>;
	commentHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	commentHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	commentIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	commentNEQ?: InputMaybe<Scalars["String"]["input"]>;
	commentNotContains?: InputMaybe<Scalars["String"]["input"]>;
	commentNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	commentNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	commentNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	generalComment1Contains?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1EQ?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1HasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1HasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1In?: InputMaybe<Array<Scalars["String"]["input"]>>;
	generalComment1NEQ?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1NotContains?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1NotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1NotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1NotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	generalComment2Contains?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2EQ?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2HasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2HasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2In?: InputMaybe<Array<Scalars["String"]["input"]>>;
	generalComment2NEQ?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2NotContains?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2NotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2NotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2NotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasOverallMarkValue?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasReportCardSectionLearningObjectives?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSubmittingUser?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isCompleteEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isCompleteNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<ReportCardSectionFilterInput>;
	or?: InputMaybe<Array<ReportCardSectionFilterInput>>;
	overallMarkValue?: InputMaybe<Array<MarkValueFilterInput>>;
	overallMarkValueIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	overallMarkValueIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	overallMarkValueIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	overallMarkValueIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	overallMarkValueIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCard?: InputMaybe<Array<ReportCardFilterInput>>;
	reportCardIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionLearningObjectives?: InputMaybe<Array<ReportCardSectionLearningObjectiveFilterInput>>;
	reportCardSectionPolicy?: InputMaybe<Array<ReportCardSectionPolicyFilterInput>>;
	reportCardSectionPolicyIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardSectionPolicyIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionPolicyIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardSectionPolicyIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	submittingUser?: InputMaybe<Array<UserFilterInput>>;
	submittingUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	submittingUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	submittingUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	submittingUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	submittingUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ReportCardSectionHistory = Node & {
	__typename?: "ReportCardSectionHistory";
	comment: Maybe<Scalars["String"]["output"]>;
	generalComment1: Maybe<Scalars["String"]["output"]>;
	generalComment2: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isComplete: Maybe<Scalars["Boolean"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	overallMarkValueID: Maybe<Scalars["ID"]["output"]>;
	reportCardID: Maybe<Scalars["ID"]["output"]>;
	reportCardSectionPolicyID: Maybe<Scalars["ID"]["output"]>;
	submittingUserID: Maybe<Scalars["ID"]["output"]>;
};

export type ReportCardSectionHistoryConnection = {
	__typename?: "ReportCardSectionHistoryConnection";
	edges: Array<ReportCardSectionHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ReportCardSectionHistoryEdge = {
	__typename?: "ReportCardSectionHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ReportCardSectionHistory;
};

export type ReportCardSectionHistoryFilterInput = {
	and?: InputMaybe<Array<ReportCardSectionHistoryFilterInput>>;
	commentContains?: InputMaybe<Scalars["String"]["input"]>;
	commentEQ?: InputMaybe<Scalars["String"]["input"]>;
	commentHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	commentHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	commentIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	commentIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	commentNEQ?: InputMaybe<Scalars["String"]["input"]>;
	commentNotContains?: InputMaybe<Scalars["String"]["input"]>;
	commentNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	commentNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	commentNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	generalComment1Contains?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1EQ?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1HasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1HasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1In?: InputMaybe<Array<Scalars["String"]["input"]>>;
	generalComment1IsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	generalComment1NEQ?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1NotContains?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1NotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1NotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1NotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	generalComment2Contains?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2EQ?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2HasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2HasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2In?: InputMaybe<Array<Scalars["String"]["input"]>>;
	generalComment2IsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	generalComment2NEQ?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2NotContains?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2NotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2NotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2NotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isCompleteEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isCompleteIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isCompleteNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<ReportCardSectionHistoryFilterInput>;
	or?: InputMaybe<Array<ReportCardSectionHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	overallMarkValueIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	overallMarkValueIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	overallMarkValueIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	overallMarkValueIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	overallMarkValueIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	reportCardIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionPolicyIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardSectionPolicyIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionPolicyIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	reportCardSectionPolicyIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardSectionPolicyIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	submittingUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	submittingUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	submittingUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	submittingUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	submittingUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ReportCardSectionHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ReportCardSectionHistoryOrderField>;
};

export enum ReportCardSectionHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type ReportCardSectionInOverallMarkValueCreateInput = {
	comment?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2?: InputMaybe<Scalars["String"]["input"]>;
	isComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
	reportCardID: Scalars["ID"]["input"];
	reportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionLearningObjectives?: InputMaybe<
		Array<ReportCardSectionLearningObjectiveInReportCardSectionCreateInput>
	>;
	reportCardSectionPolicyID: Scalars["ID"]["input"];
};

export type ReportCardSectionInReportCardCreateInput = {
	comment?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2?: InputMaybe<Scalars["String"]["input"]>;
	isComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
	overallMarkValueID?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionLearningObjectives?: InputMaybe<
		Array<ReportCardSectionLearningObjectiveInReportCardSectionCreateInput>
	>;
	reportCardSectionPolicyID: Scalars["ID"]["input"];
};

export type ReportCardSectionInReportCardSectionPolicyCreateInput = {
	comment?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2?: InputMaybe<Scalars["String"]["input"]>;
	isComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
	overallMarkValueID?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardID: Scalars["ID"]["input"];
	reportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionLearningObjectives?: InputMaybe<
		Array<ReportCardSectionLearningObjectiveInReportCardSectionCreateInput>
	>;
};

export type ReportCardSectionInSubmittingUserCreateInput = {
	comment?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2?: InputMaybe<Scalars["String"]["input"]>;
	isComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
	overallMarkValueID?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardID: Scalars["ID"]["input"];
	reportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionLearningObjectives?: InputMaybe<
		Array<ReportCardSectionLearningObjectiveInReportCardSectionCreateInput>
	>;
	reportCardSectionPolicyID: Scalars["ID"]["input"];
};

export type ReportCardSectionLearningObjective = Node & {
	__typename?: "ReportCardSectionLearningObjective";
	id: Scalars["ID"]["output"];
	learningObjective: LearningObjective;
	learningObjectiveID: Scalars["ID"]["output"];
	markValue: Maybe<MarkValue>;
	markValueID: Maybe<Scalars["ID"]["output"]>;
	reportCardSection: ReportCardSection;
	reportCardSectionID: Scalars["ID"]["output"];
};

export type ReportCardSectionLearningObjectiveConnection = {
	__typename?: "ReportCardSectionLearningObjectiveConnection";
	edges: Array<ReportCardSectionLearningObjectiveEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ReportCardSectionLearningObjectiveCreateInput = {
	learningObjectiveID: Scalars["ID"]["input"];
	markValueID?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardSectionID: Scalars["ID"]["input"];
};

export type ReportCardSectionLearningObjectiveEdge = {
	__typename?: "ReportCardSectionLearningObjectiveEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ReportCardSectionLearningObjective;
};

export type ReportCardSectionLearningObjectiveFilterInput = {
	and?: InputMaybe<Array<ReportCardSectionLearningObjectiveFilterInput>>;
	hasMarkValue?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	learningObjective?: InputMaybe<Array<LearningObjectiveFilterInput>>;
	learningObjectiveIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	learningObjectiveIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	learningObjectiveIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	learningObjectiveIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	markValue?: InputMaybe<Array<MarkValueFilterInput>>;
	markValueIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	markValueIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	markValueIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	markValueIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	markValueIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<ReportCardSectionLearningObjectiveFilterInput>;
	or?: InputMaybe<Array<ReportCardSectionLearningObjectiveFilterInput>>;
	reportCardSection?: InputMaybe<Array<ReportCardSectionFilterInput>>;
	reportCardSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ReportCardSectionLearningObjectiveHistory = Node & {
	__typename?: "ReportCardSectionLearningObjectiveHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	learningObjectiveID: Maybe<Scalars["ID"]["output"]>;
	markValueID: Maybe<Scalars["ID"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	reportCardSectionID: Maybe<Scalars["ID"]["output"]>;
};

export type ReportCardSectionLearningObjectiveHistoryConnection = {
	__typename?: "ReportCardSectionLearningObjectiveHistoryConnection";
	edges: Array<ReportCardSectionLearningObjectiveHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ReportCardSectionLearningObjectiveHistoryEdge = {
	__typename?: "ReportCardSectionLearningObjectiveHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ReportCardSectionLearningObjectiveHistory;
};

export type ReportCardSectionLearningObjectiveHistoryFilterInput = {
	and?: InputMaybe<Array<ReportCardSectionLearningObjectiveHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	learningObjectiveIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	learningObjectiveIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	learningObjectiveIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	learningObjectiveIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	learningObjectiveIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	markValueIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	markValueIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	markValueIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	markValueIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	markValueIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<ReportCardSectionLearningObjectiveHistoryFilterInput>;
	or?: InputMaybe<Array<ReportCardSectionLearningObjectiveHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	reportCardSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ReportCardSectionLearningObjectiveHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ReportCardSectionLearningObjectiveHistoryOrderField>;
};

export enum ReportCardSectionLearningObjectiveHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type ReportCardSectionLearningObjectiveInLearningObjectiveCreateInput = {
	markValueID?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardSectionID: Scalars["ID"]["input"];
};

export type ReportCardSectionLearningObjectiveInMarkValueCreateInput = {
	learningObjectiveID: Scalars["ID"]["input"];
	reportCardSectionID: Scalars["ID"]["input"];
};

export type ReportCardSectionLearningObjectiveInReportCardSectionCreateInput = {
	learningObjectiveID: Scalars["ID"]["input"];
	markValueID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ReportCardSectionLearningObjectiveOrder = {
	direction: OrderDirection;
};

export type ReportCardSectionLearningObjectiveUpdateBulkInput = {
	clearMarkValue?: InputMaybe<Scalars["Boolean"]["input"]>;
	learningObjectiveID?: InputMaybe<Scalars["ID"]["input"]>;
	markValueID?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardSectionID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ReportCardSectionLearningObjectiveUpdateInput = {
	clearMarkValue?: InputMaybe<Scalars["Boolean"]["input"]>;
	learningObjectiveID?: InputMaybe<Scalars["ID"]["input"]>;
	markValueID?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardSectionID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ReportCardSectionOrder = {
	direction: OrderDirection;
};

export type ReportCardSectionPolicy = Node & {
	__typename?: "ReportCardSectionPolicy";
	commentLabel: Scalars["String"]["output"];
	courseSection: Maybe<CourseSection>;
	courseSectionID: Maybe<Scalars["ID"]["output"]>;
	description: Scalars["String"]["output"];
	descriptionLabel: Scalars["String"]["output"];
	homeRoomSection: Maybe<HomeRoomSection>;
	homeRoomSectionID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isForHomeRoomSection: Scalars["Boolean"]["output"];
	isOverallMarkManual: Scalars["Boolean"]["output"];
	maxCommentLength: Scalars["Int"]["output"];
	maxGeneralComment1Length: Scalars["Int"]["output"];
	maxGeneralComment2Length: Scalars["Int"]["output"];
	minCommentLength: Scalars["Int"]["output"];
	minGeneralComment1Length: Scalars["Int"]["output"];
	minGeneralComment2Length: Scalars["Int"]["output"];
	nameSuffix: Scalars["String"]["output"];
	overallMarkLabel: Scalars["String"]["output"];
	overallMarkingSystem: Maybe<MarkingSystem>;
	overallMarkingSystemID: Maybe<Scalars["ID"]["output"]>;
	reportCardSections: Array<ReportCardSection>;
	usesComment: Scalars["Boolean"]["output"];
	usesDescription: Scalars["Boolean"]["output"];
	usesGeneralComments: Scalars["Boolean"]["output"];
	usesOverallMark: Scalars["Boolean"]["output"];
};

export type ReportCardSectionPolicyReportCardSectionsArgs = {
	filters?: InputMaybe<Array<ReportCardSectionFilterInput>>;
	order?: InputMaybe<ReportCardSectionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ReportCardSectionPolicyConnection = {
	__typename?: "ReportCardSectionPolicyConnection";
	edges: Array<ReportCardSectionPolicyEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ReportCardSectionPolicyCreateInput = {
	commentLabel?: InputMaybe<Scalars["String"]["input"]>;
	courseSectionID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabel?: InputMaybe<Scalars["String"]["input"]>;
	homeRoomSectionID?: InputMaybe<Scalars["ID"]["input"]>;
	isOverallMarkManual?: InputMaybe<Scalars["Boolean"]["input"]>;
	maxCommentLength?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment1Length?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment2Length?: InputMaybe<Scalars["Int"]["input"]>;
	minCommentLength?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment1Length?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment2Length?: InputMaybe<Scalars["Int"]["input"]>;
	nameSuffix?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabel?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkingSystemID?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardSections?: InputMaybe<Array<ReportCardSectionInReportCardSectionPolicyCreateInput>>;
	usesComment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ReportCardSectionPolicyEdge = {
	__typename?: "ReportCardSectionPolicyEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ReportCardSectionPolicy;
};

export type ReportCardSectionPolicyFilterInput = {
	and?: InputMaybe<Array<ReportCardSectionPolicyFilterInput>>;
	commentLabelContains?: InputMaybe<Scalars["String"]["input"]>;
	commentLabelEQ?: InputMaybe<Scalars["String"]["input"]>;
	commentLabelHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	commentLabelHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	commentLabelIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	commentLabelNEQ?: InputMaybe<Scalars["String"]["input"]>;
	commentLabelNotContains?: InputMaybe<Scalars["String"]["input"]>;
	commentLabelNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	commentLabelNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	commentLabelNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	courseSection?: InputMaybe<Array<CourseSectionFilterInput>>;
	courseSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionLabelContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabelEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabelHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabelHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabelIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionLabelNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabelNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabelNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabelNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabelNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasCourseSection?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasHomeRoomSection?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasOverallMarkingSystem?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasReportCardSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoomSection?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
	homeRoomSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoomSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isOverallMarkManualEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isOverallMarkManualNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	maxCommentLengthEQ?: InputMaybe<Scalars["Int"]["input"]>;
	maxCommentLengthGT?: InputMaybe<Scalars["Int"]["input"]>;
	maxCommentLengthGTE?: InputMaybe<Scalars["Int"]["input"]>;
	maxCommentLengthIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	maxCommentLengthLT?: InputMaybe<Scalars["Int"]["input"]>;
	maxCommentLengthLTE?: InputMaybe<Scalars["Int"]["input"]>;
	maxCommentLengthNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	maxCommentLengthNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	maxGeneralComment1LengthEQ?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment1LengthGT?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment1LengthGTE?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment1LengthIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	maxGeneralComment1LengthLT?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment1LengthLTE?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment1LengthNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment1LengthNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	maxGeneralComment2LengthEQ?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment2LengthGT?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment2LengthGTE?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment2LengthIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	maxGeneralComment2LengthLT?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment2LengthLTE?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment2LengthNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment2LengthNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	minCommentLengthEQ?: InputMaybe<Scalars["Int"]["input"]>;
	minCommentLengthGT?: InputMaybe<Scalars["Int"]["input"]>;
	minCommentLengthGTE?: InputMaybe<Scalars["Int"]["input"]>;
	minCommentLengthIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	minCommentLengthLT?: InputMaybe<Scalars["Int"]["input"]>;
	minCommentLengthLTE?: InputMaybe<Scalars["Int"]["input"]>;
	minCommentLengthNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	minCommentLengthNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	minGeneralComment1LengthEQ?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment1LengthGT?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment1LengthGTE?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment1LengthIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	minGeneralComment1LengthLT?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment1LengthLTE?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment1LengthNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment1LengthNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	minGeneralComment2LengthEQ?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment2LengthGT?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment2LengthGTE?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment2LengthIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	minGeneralComment2LengthLT?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment2LengthLTE?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment2LengthNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment2LengthNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	nameSuffixContains?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameSuffixNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<ReportCardSectionPolicyFilterInput>;
	or?: InputMaybe<Array<ReportCardSectionPolicyFilterInput>>;
	overallMarkLabelContains?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabelEQ?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabelHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabelHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabelIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	overallMarkLabelNEQ?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabelNotContains?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabelNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabelNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabelNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	overallMarkingSystem?: InputMaybe<Array<MarkingSystemFilterInput>>;
	overallMarkingSystemIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	overallMarkingSystemIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	overallMarkingSystemIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	overallMarkingSystemIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	overallMarkingSystemIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSections?: InputMaybe<Array<ReportCardSectionFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	usesCommentEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	usesCommentNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ReportCardSectionPolicyHistory = Node & {
	__typename?: "ReportCardSectionPolicyHistory";
	commentLabel: Maybe<Scalars["String"]["output"]>;
	courseSectionID: Maybe<Scalars["ID"]["output"]>;
	description: Maybe<Scalars["String"]["output"]>;
	descriptionLabel: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	homeRoomSectionID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isOverallMarkManual: Maybe<Scalars["Boolean"]["output"]>;
	maxCommentLength: Maybe<Scalars["Int"]["output"]>;
	maxGeneralComment1Length: Maybe<Scalars["Int"]["output"]>;
	maxGeneralComment2Length: Maybe<Scalars["Int"]["output"]>;
	minCommentLength: Maybe<Scalars["Int"]["output"]>;
	minGeneralComment1Length: Maybe<Scalars["Int"]["output"]>;
	minGeneralComment2Length: Maybe<Scalars["Int"]["output"]>;
	nameSuffix: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	overallMarkLabel: Maybe<Scalars["String"]["output"]>;
	overallMarkingSystemID: Maybe<Scalars["ID"]["output"]>;
	usesComment: Maybe<Scalars["Boolean"]["output"]>;
};

export type ReportCardSectionPolicyHistoryConnection = {
	__typename?: "ReportCardSectionPolicyHistoryConnection";
	edges: Array<ReportCardSectionPolicyHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ReportCardSectionPolicyHistoryEdge = {
	__typename?: "ReportCardSectionPolicyHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ReportCardSectionPolicyHistory;
};

export type ReportCardSectionPolicyHistoryFilterInput = {
	and?: InputMaybe<Array<ReportCardSectionPolicyHistoryFilterInput>>;
	commentLabelContains?: InputMaybe<Scalars["String"]["input"]>;
	commentLabelEQ?: InputMaybe<Scalars["String"]["input"]>;
	commentLabelHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	commentLabelHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	commentLabelIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	commentLabelIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	commentLabelNEQ?: InputMaybe<Scalars["String"]["input"]>;
	commentLabelNotContains?: InputMaybe<Scalars["String"]["input"]>;
	commentLabelNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	commentLabelNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	commentLabelNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	courseSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionLabelContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabelEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabelHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabelHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabelIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionLabelIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionLabelNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabelNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabelNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabelNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabelNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoomSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isOverallMarkManualEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isOverallMarkManualIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isOverallMarkManualNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	maxCommentLengthEQ?: InputMaybe<Scalars["Int"]["input"]>;
	maxCommentLengthGT?: InputMaybe<Scalars["Int"]["input"]>;
	maxCommentLengthGTE?: InputMaybe<Scalars["Int"]["input"]>;
	maxCommentLengthIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	maxCommentLengthIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	maxCommentLengthLT?: InputMaybe<Scalars["Int"]["input"]>;
	maxCommentLengthLTE?: InputMaybe<Scalars["Int"]["input"]>;
	maxCommentLengthNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	maxCommentLengthNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	maxGeneralComment1LengthEQ?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment1LengthGT?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment1LengthGTE?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment1LengthIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	maxGeneralComment1LengthIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	maxGeneralComment1LengthLT?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment1LengthLTE?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment1LengthNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment1LengthNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	maxGeneralComment2LengthEQ?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment2LengthGT?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment2LengthGTE?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment2LengthIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	maxGeneralComment2LengthIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	maxGeneralComment2LengthLT?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment2LengthLTE?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment2LengthNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment2LengthNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	minCommentLengthEQ?: InputMaybe<Scalars["Int"]["input"]>;
	minCommentLengthGT?: InputMaybe<Scalars["Int"]["input"]>;
	minCommentLengthGTE?: InputMaybe<Scalars["Int"]["input"]>;
	minCommentLengthIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	minCommentLengthIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	minCommentLengthLT?: InputMaybe<Scalars["Int"]["input"]>;
	minCommentLengthLTE?: InputMaybe<Scalars["Int"]["input"]>;
	minCommentLengthNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	minCommentLengthNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	minGeneralComment1LengthEQ?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment1LengthGT?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment1LengthGTE?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment1LengthIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	minGeneralComment1LengthIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	minGeneralComment1LengthLT?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment1LengthLTE?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment1LengthNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment1LengthNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	minGeneralComment2LengthEQ?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment2LengthGT?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment2LengthGTE?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment2LengthIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	minGeneralComment2LengthIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	minGeneralComment2LengthLT?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment2LengthLTE?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment2LengthNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment2LengthNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	nameSuffixContains?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameSuffixIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameSuffixNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameSuffixNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<ReportCardSectionPolicyHistoryFilterInput>;
	or?: InputMaybe<Array<ReportCardSectionPolicyHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	overallMarkLabelContains?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabelEQ?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabelHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabelHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabelIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	overallMarkLabelIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	overallMarkLabelNEQ?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabelNotContains?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabelNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabelNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabelNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	overallMarkingSystemIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	overallMarkingSystemIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	overallMarkingSystemIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	overallMarkingSystemIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	overallMarkingSystemIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	usesCommentEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	usesCommentIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	usesCommentNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ReportCardSectionPolicyHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ReportCardSectionPolicyHistoryOrderField>;
};

export enum ReportCardSectionPolicyHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type ReportCardSectionPolicyInCourseSectionCreateInput = {
	commentLabel?: InputMaybe<Scalars["String"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabel?: InputMaybe<Scalars["String"]["input"]>;
	homeRoomSectionID?: InputMaybe<Scalars["ID"]["input"]>;
	isOverallMarkManual?: InputMaybe<Scalars["Boolean"]["input"]>;
	maxCommentLength?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment1Length?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment2Length?: InputMaybe<Scalars["Int"]["input"]>;
	minCommentLength?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment1Length?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment2Length?: InputMaybe<Scalars["Int"]["input"]>;
	nameSuffix?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabel?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkingSystemID?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardSections?: InputMaybe<Array<ReportCardSectionInReportCardSectionPolicyCreateInput>>;
	usesComment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ReportCardSectionPolicyInHomeRoomSectionCreateInput = {
	commentLabel?: InputMaybe<Scalars["String"]["input"]>;
	courseSectionID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabel?: InputMaybe<Scalars["String"]["input"]>;
	isOverallMarkManual?: InputMaybe<Scalars["Boolean"]["input"]>;
	maxCommentLength?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment1Length?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment2Length?: InputMaybe<Scalars["Int"]["input"]>;
	minCommentLength?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment1Length?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment2Length?: InputMaybe<Scalars["Int"]["input"]>;
	nameSuffix?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabel?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkingSystemID?: InputMaybe<Scalars["ID"]["input"]>;
	reportCardSections?: InputMaybe<Array<ReportCardSectionInReportCardSectionPolicyCreateInput>>;
	usesComment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ReportCardSectionPolicyInOverallMarkingSystemCreateInput = {
	commentLabel?: InputMaybe<Scalars["String"]["input"]>;
	courseSectionID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabel?: InputMaybe<Scalars["String"]["input"]>;
	homeRoomSectionID?: InputMaybe<Scalars["ID"]["input"]>;
	isOverallMarkManual?: InputMaybe<Scalars["Boolean"]["input"]>;
	maxCommentLength?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment1Length?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment2Length?: InputMaybe<Scalars["Int"]["input"]>;
	minCommentLength?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment1Length?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment2Length?: InputMaybe<Scalars["Int"]["input"]>;
	nameSuffix?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabel?: InputMaybe<Scalars["String"]["input"]>;
	reportCardSections?: InputMaybe<Array<ReportCardSectionInReportCardSectionPolicyCreateInput>>;
	usesComment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ReportCardSectionPolicyOrder = {
	direction: OrderDirection;
};

export type ReportCardSectionPolicyUpdateBulkInput = {
	clearOverallMarkingSystem?: InputMaybe<Scalars["Boolean"]["input"]>;
	commentLabel?: InputMaybe<Scalars["String"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabel?: InputMaybe<Scalars["String"]["input"]>;
	isOverallMarkManual?: InputMaybe<Scalars["Boolean"]["input"]>;
	maxCommentLength?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment1Length?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment2Length?: InputMaybe<Scalars["Int"]["input"]>;
	minCommentLength?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment1Length?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment2Length?: InputMaybe<Scalars["Int"]["input"]>;
	nameSuffix?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabel?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkingSystemID?: InputMaybe<Scalars["ID"]["input"]>;
	usesComment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ReportCardSectionPolicyUpdateInput = {
	clearOverallMarkingSystem?: InputMaybe<Scalars["Boolean"]["input"]>;
	commentLabel?: InputMaybe<Scalars["String"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	descriptionLabel?: InputMaybe<Scalars["String"]["input"]>;
	isOverallMarkManual?: InputMaybe<Scalars["Boolean"]["input"]>;
	maxCommentLength?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment1Length?: InputMaybe<Scalars["Int"]["input"]>;
	maxGeneralComment2Length?: InputMaybe<Scalars["Int"]["input"]>;
	minCommentLength?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment1Length?: InputMaybe<Scalars["Int"]["input"]>;
	minGeneralComment2Length?: InputMaybe<Scalars["Int"]["input"]>;
	nameSuffix?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkLabel?: InputMaybe<Scalars["String"]["input"]>;
	overallMarkingSystemID?: InputMaybe<Scalars["ID"]["input"]>;
	usesComment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ReportCardSectionUpdateBulkInput = {
	addReportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearOverallMarkValue?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearReportCardSectionLearningObjectives?: InputMaybe<Scalars["Boolean"]["input"]>;
	comment?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2?: InputMaybe<Scalars["String"]["input"]>;
	isComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
	overallMarkValueID?: InputMaybe<Scalars["ID"]["input"]>;
	removeReportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ReportCardSectionUpdateInput = {
	addReportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearOverallMarkValue?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearReportCardSectionLearningObjectives?: InputMaybe<Scalars["Boolean"]["input"]>;
	comment?: InputMaybe<Scalars["String"]["input"]>;
	generalComment1?: InputMaybe<Scalars["String"]["input"]>;
	generalComment2?: InputMaybe<Scalars["String"]["input"]>;
	isComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
	overallMarkValueID?: InputMaybe<Scalars["ID"]["input"]>;
	removeReportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reportCardSectionLearningObjectiveIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ReportCardUpdateBulkInput = {
	clearReleaseDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	isComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
	isReleased?: InputMaybe<Scalars["Boolean"]["input"]>;
	releaseDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type ReportCardUpdateInput = {
	clearReleaseDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	isComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
	isReleased?: InputMaybe<Scalars["Boolean"]["input"]>;
	releaseDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type Room = Node & {
	__typename?: "Room";
	buildingFloor: BuildingFloor;
	buildingFloorID: Scalars["ID"]["output"];
	courseSectionPeriods: Array<CourseSectionPeriod>;
	homeRoomSections: Array<HomeRoomSection>;
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
	roomNumber: Scalars["String"]["output"];
};

export type RoomCourseSectionPeriodsArgs = {
	filters?: InputMaybe<Array<CourseSectionPeriodFilterInput>>;
	order?: InputMaybe<CourseSectionPeriodOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type RoomHomeRoomSectionsArgs = {
	filters?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
	order?: InputMaybe<HomeRoomSectionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type RoomConnection = {
	__typename?: "RoomConnection";
	edges: Array<RoomEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type RoomCreateInput = {
	buildingFloorID: Scalars["ID"]["input"];
	courseSectionPeriodIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionPeriods?: InputMaybe<Array<CourseSectionPeriodInRoomCreateInput>>;
	homeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSections?: InputMaybe<Array<HomeRoomSectionInRoomCreateInput>>;
	name: Scalars["String"]["input"];
	roomNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type RoomEdge = {
	__typename?: "RoomEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Room;
};

export type RoomFilterInput = {
	and?: InputMaybe<Array<RoomFilterInput>>;
	buildingFloor?: InputMaybe<Array<BuildingFloorFilterInput>>;
	buildingFloorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	buildingFloorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	buildingFloorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	buildingFloorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionPeriods?: InputMaybe<Array<CourseSectionPeriodFilterInput>>;
	hasCourseSectionPeriods?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasHomeRoomSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoomSections?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<RoomFilterInput>;
	or?: InputMaybe<Array<RoomFilterInput>>;
	roomNumberContains?: InputMaybe<Scalars["String"]["input"]>;
	roomNumberEQ?: InputMaybe<Scalars["String"]["input"]>;
	roomNumberHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	roomNumberHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	roomNumberIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	roomNumberNEQ?: InputMaybe<Scalars["String"]["input"]>;
	roomNumberNotContains?: InputMaybe<Scalars["String"]["input"]>;
	roomNumberNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	roomNumberNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	roomNumberNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type RoomHistory = Node & {
	__typename?: "RoomHistory";
	buildingFloorID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	roomNumber: Maybe<Scalars["String"]["output"]>;
};

export type RoomHistoryConnection = {
	__typename?: "RoomHistoryConnection";
	edges: Array<RoomHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type RoomHistoryEdge = {
	__typename?: "RoomHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: RoomHistory;
};

export type RoomHistoryFilterInput = {
	and?: InputMaybe<Array<RoomHistoryFilterInput>>;
	buildingFloorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	buildingFloorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	buildingFloorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	buildingFloorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	buildingFloorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<RoomHistoryFilterInput>;
	or?: InputMaybe<Array<RoomHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	roomNumberContains?: InputMaybe<Scalars["String"]["input"]>;
	roomNumberEQ?: InputMaybe<Scalars["String"]["input"]>;
	roomNumberHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	roomNumberHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	roomNumberIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	roomNumberIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	roomNumberNEQ?: InputMaybe<Scalars["String"]["input"]>;
	roomNumberNotContains?: InputMaybe<Scalars["String"]["input"]>;
	roomNumberNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	roomNumberNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	roomNumberNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type RoomHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<RoomHistoryOrderField>;
};

export enum RoomHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type RoomInBuildingFloorCreateInput = {
	courseSectionPeriodIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionPeriods?: InputMaybe<Array<CourseSectionPeriodInRoomCreateInput>>;
	homeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSections?: InputMaybe<Array<HomeRoomSectionInRoomCreateInput>>;
	name: Scalars["String"]["input"];
	roomNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type RoomOrder = {
	direction: OrderDirection;
	field?: InputMaybe<RoomOrderField>;
};

export enum RoomOrderField {
	Name = "NAME",
	RoomNumber = "ROOM_NUMBER",
}

export type RoomUpdateBulkInput = {
	addCourseSectionPeriodIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addHomeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	buildingFloorID?: InputMaybe<Scalars["ID"]["input"]>;
	clearCourseSectionPeriods?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearHomeRoomSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseSectionPeriodIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeCourseSectionPeriodIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeHomeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	roomNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type RoomUpdateInput = {
	addCourseSectionPeriodIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addHomeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	buildingFloorID?: InputMaybe<Scalars["ID"]["input"]>;
	clearCourseSectionPeriods?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearHomeRoomSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseSectionPeriodIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeCourseSectionPeriodIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeHomeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	roomNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type SchoolAttendanceRecord = Node & {
	__typename?: "SchoolAttendanceRecord";
	arrivalTime: Maybe<Scalars["Time"]["output"]>;
	attendanceDate: Scalars["Date"]["output"];
	attendanceStatus: AttendanceStatus;
	attendanceStatusID: Scalars["ID"]["output"];
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	createdAt: Scalars["Time"]["output"];
	departureTime: Maybe<Scalars["Time"]["output"]>;
	id: Scalars["ID"]["output"];
	notes: Scalars["String"]["output"];
	student: Student;
	studentID: Scalars["ID"]["output"];
	wasSetByCourseAttendance: Scalars["Boolean"]["output"];
};

export type SchoolAttendanceRecordConnection = {
	__typename?: "SchoolAttendanceRecordConnection";
	edges: Array<SchoolAttendanceRecordEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SchoolAttendanceRecordCreateInput = {
	arrivalTime?: InputMaybe<Scalars["Time"]["input"]>;
	attendanceDate: Scalars["Date"]["input"];
	attendanceStatusID: Scalars["ID"]["input"];
	departureTime?: InputMaybe<Scalars["Time"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type SchoolAttendanceRecordEdge = {
	__typename?: "SchoolAttendanceRecordEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SchoolAttendanceRecord;
};

export type SchoolAttendanceRecordFilterInput = {
	and?: InputMaybe<Array<SchoolAttendanceRecordFilterInput>>;
	arrivalTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	arrivalTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	arrivalTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	arrivalTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	arrivalTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	arrivalTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	arrivalTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	arrivalTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	arrivalTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	attendanceDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	attendanceDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	attendanceStatus?: InputMaybe<Array<AttendanceStatusFilterInput>>;
	attendanceStatusIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	attendanceStatusIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	attendanceStatusIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	attendanceStatusIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	departureTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	departureTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	departureTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	departureTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	departureTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	departureTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	departureTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	departureTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	departureTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SchoolAttendanceRecordFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<SchoolAttendanceRecordFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	wasSetByCourseAttendanceEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	wasSetByCourseAttendanceNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SchoolAttendanceRecordHistory = Node & {
	__typename?: "SchoolAttendanceRecordHistory";
	arrivalTime: Maybe<Scalars["Time"]["output"]>;
	attendanceDate: Maybe<Scalars["Date"]["output"]>;
	attendanceStatusID: Maybe<Scalars["ID"]["output"]>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	departureTime: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	notes: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
	wasSetByCourseAttendance: Maybe<Scalars["Boolean"]["output"]>;
};

export type SchoolAttendanceRecordHistoryConnection = {
	__typename?: "SchoolAttendanceRecordHistoryConnection";
	edges: Array<SchoolAttendanceRecordHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SchoolAttendanceRecordHistoryEdge = {
	__typename?: "SchoolAttendanceRecordHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SchoolAttendanceRecordHistory;
};

export type SchoolAttendanceRecordHistoryFilterInput = {
	and?: InputMaybe<Array<SchoolAttendanceRecordHistoryFilterInput>>;
	arrivalTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	arrivalTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	arrivalTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	arrivalTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	arrivalTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	arrivalTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	arrivalTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	arrivalTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	arrivalTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	attendanceDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	attendanceDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	attendanceDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	attendanceStatusIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	attendanceStatusIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	attendanceStatusIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	attendanceStatusIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	attendanceStatusIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	departureTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	departureTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	departureTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	departureTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	departureTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	departureTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	departureTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	departureTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	departureTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SchoolAttendanceRecordHistoryFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<SchoolAttendanceRecordHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	wasSetByCourseAttendanceEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	wasSetByCourseAttendanceIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	wasSetByCourseAttendanceNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SchoolAttendanceRecordHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SchoolAttendanceRecordHistoryOrderField>;
};

export enum SchoolAttendanceRecordHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type SchoolAttendanceRecordInAttendanceStatusCreateInput = {
	arrivalTime?: InputMaybe<Scalars["Time"]["input"]>;
	attendanceDate: Scalars["Date"]["input"];
	departureTime?: InputMaybe<Scalars["Time"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type SchoolAttendanceRecordInAuthorCreateInput = {
	arrivalTime?: InputMaybe<Scalars["Time"]["input"]>;
	attendanceDate: Scalars["Date"]["input"];
	attendanceStatusID: Scalars["ID"]["input"];
	departureTime?: InputMaybe<Scalars["Time"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type SchoolAttendanceRecordInStudentCreateInput = {
	arrivalTime?: InputMaybe<Scalars["Time"]["input"]>;
	attendanceDate: Scalars["Date"]["input"];
	attendanceStatusID: Scalars["ID"]["input"];
	departureTime?: InputMaybe<Scalars["Time"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
};

export type SchoolAttendanceRecordOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SchoolAttendanceRecordOrderField>;
};

export enum SchoolAttendanceRecordOrderField {
	ArrivalTime = "ARRIVAL_TIME",
	AttendanceDate = "ATTENDANCE_DATE",
	CreatedAt = "CREATED_AT",
	DepartureTime = "DEPARTURE_TIME",
}

export type SchoolAttendanceRecordUpdateBulkInput = {
	arrivalTime?: InputMaybe<Scalars["Time"]["input"]>;
	attendanceDate?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceStatusID?: InputMaybe<Scalars["ID"]["input"]>;
	clearArrivalTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearDepartureTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	departureTime?: InputMaybe<Scalars["Time"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
};

export type SchoolAttendanceRecordUpdateInput = {
	arrivalTime?: InputMaybe<Scalars["Time"]["input"]>;
	attendanceDate?: InputMaybe<Scalars["Date"]["input"]>;
	attendanceStatusID?: InputMaybe<Scalars["ID"]["input"]>;
	clearArrivalTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearDepartureTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	departureTime?: InputMaybe<Scalars["Time"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
};

export type SchoolMailCredentials = {
	__typename?: "SchoolMailCredentials";
	email: Scalars["String"]["output"];
	password: Scalars["String"]["output"];
};

export type SearchResult = Node & {
	__typename?: "SearchResult";
	id: Scalars["ID"]["output"];
	modelName: Scalars["String"]["output"];
	name: Scalars["String"]["output"];
	searchText: Scalars["String"]["output"];
};

export type SearchResultConnection = {
	__typename?: "SearchResultConnection";
	edges: Array<SearchResultEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SearchResultEdge = {
	__typename?: "SearchResultEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SearchResult;
};

export type SearchResultFilterInput = {
	and?: InputMaybe<Array<SearchResultFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	modelNameContains?: InputMaybe<Scalars["String"]["input"]>;
	modelNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	modelNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	modelNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	modelNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	modelNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	modelNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	modelNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	modelNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	modelNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<SearchResultFilterInput>;
	or?: InputMaybe<Array<SearchResultFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	searchTextContains?: InputMaybe<Scalars["String"]["input"]>;
	searchTextEQ?: InputMaybe<Scalars["String"]["input"]>;
	searchTextHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	searchTextHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	searchTextIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	searchTextNEQ?: InputMaybe<Scalars["String"]["input"]>;
	searchTextNotContains?: InputMaybe<Scalars["String"]["input"]>;
	searchTextNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	searchTextNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	searchTextNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type SearchResultOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SearchResultOrderField>;
};

export enum SearchResultOrderField {
	ModelName = "MODEL_NAME",
	Name = "NAME",
}

export type SectionReportCardSectionsCompletionProgressStatistics = {
	__typename?: "SectionReportCardSectionsCompletionProgressStatistics";
	id: Scalars["ID"]["output"];
	statistics: AggregateReportCardCompletionProgressStatistics;
};

export type Service = Node & {
	__typename?: "Service";
	category: ServiceCategory;
	classYears: Array<ClassYear>;
	contractLineItems: Array<ContractLineItem>;
	description: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	isActive: Scalars["Boolean"]["output"];
	name: Scalars["String"]["output"];
	price: Scalars["Int"]["output"];
};

export type ServiceClassYearsArgs = {
	filters?: InputMaybe<Array<ClassYearFilterInput>>;
	order?: InputMaybe<ClassYearOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type ServiceContractLineItemsArgs = {
	filters?: InputMaybe<Array<ContractLineItemFilterInput>>;
	order?: InputMaybe<ContractLineItemOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export enum ServiceCategory {
	Fee = "fee",
	InstallmentFee = "installment_fee",
	MealPlan = "meal_plan",
	Service = "service",
	Tuition = "tuition",
}

export type ServiceClassYearHistory = Node & {
	__typename?: "ServiceClassYearHistory";
	classYearID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	serviceID: Maybe<Scalars["ID"]["output"]>;
};

export type ServiceClassYearHistoryConnection = {
	__typename?: "ServiceClassYearHistoryConnection";
	edges: Array<ServiceClassYearHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ServiceClassYearHistoryEdge = {
	__typename?: "ServiceClassYearHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ServiceClassYearHistory;
};

export type ServiceClassYearHistoryFilterInput = {
	and?: InputMaybe<Array<ServiceClassYearHistoryFilterInput>>;
	classYearIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	classYearIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<ServiceClassYearHistoryFilterInput>;
	or?: InputMaybe<Array<ServiceClassYearHistoryFilterInput>>;
	serviceIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	serviceIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	serviceIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	serviceIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	serviceIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ServiceClassYearHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ServiceClassYearHistoryOrderField>;
};

export enum ServiceClassYearHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type ServiceConnection = {
	__typename?: "ServiceConnection";
	edges: Array<ServiceEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ServiceCreateInput = {
	category: ServiceCategory;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	contractLineItems?: InputMaybe<Array<ContractLineItemInServiceCreateInput>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	name: Scalars["String"]["input"];
	price: Scalars["Int"]["input"];
};

export type ServiceEdge = {
	__typename?: "ServiceEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Service;
};

export type ServiceFilterInput = {
	and?: InputMaybe<Array<ServiceFilterInput>>;
	categoryEQ?: InputMaybe<ServiceCategory>;
	categoryIn?: InputMaybe<Array<ServiceCategory>>;
	categoryNEQ?: InputMaybe<ServiceCategory>;
	categoryNotIn?: InputMaybe<Array<ServiceCategory>>;
	classYears?: InputMaybe<Array<ClassYearFilterInput>>;
	contractLineItems?: InputMaybe<Array<ContractLineItemFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasClassYears?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasContractLineItems?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isActiveEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActiveNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<ServiceFilterInput>;
	or?: InputMaybe<Array<ServiceFilterInput>>;
	priceEQ?: InputMaybe<Scalars["Int"]["input"]>;
	priceGT?: InputMaybe<Scalars["Int"]["input"]>;
	priceGTE?: InputMaybe<Scalars["Int"]["input"]>;
	priceIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	priceLT?: InputMaybe<Scalars["Int"]["input"]>;
	priceLTE?: InputMaybe<Scalars["Int"]["input"]>;
	priceNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	priceNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type ServiceHistory = Node & {
	__typename?: "ServiceHistory";
	category: Maybe<ServiceHistoryCategory>;
	description: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isActive: Maybe<Scalars["Boolean"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	price: Maybe<Scalars["Int"]["output"]>;
};

export enum ServiceHistoryCategory {
	Fee = "fee",
	InstallmentFee = "installment_fee",
	MealPlan = "meal_plan",
	Service = "service",
	Tuition = "tuition",
}

export type ServiceHistoryConnection = {
	__typename?: "ServiceHistoryConnection";
	edges: Array<ServiceHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type ServiceHistoryEdge = {
	__typename?: "ServiceHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: ServiceHistory;
};

export type ServiceHistoryFilterInput = {
	and?: InputMaybe<Array<ServiceHistoryFilterInput>>;
	categoryEQ?: InputMaybe<ServiceHistoryCategory>;
	categoryIn?: InputMaybe<Array<ServiceHistoryCategory>>;
	categoryIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	categoryNEQ?: InputMaybe<ServiceHistoryCategory>;
	categoryNotIn?: InputMaybe<Array<ServiceHistoryCategory>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isActiveEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActiveIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActiveNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<ServiceHistoryFilterInput>;
	or?: InputMaybe<Array<ServiceHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	priceEQ?: InputMaybe<Scalars["Int"]["input"]>;
	priceGT?: InputMaybe<Scalars["Int"]["input"]>;
	priceGTE?: InputMaybe<Scalars["Int"]["input"]>;
	priceIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	priceIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	priceLT?: InputMaybe<Scalars["Int"]["input"]>;
	priceLTE?: InputMaybe<Scalars["Int"]["input"]>;
	priceNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	priceNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type ServiceHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ServiceHistoryOrderField>;
};

export enum ServiceHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type ServiceOrder = {
	direction: OrderDirection;
	field?: InputMaybe<ServiceOrderField>;
};

export enum ServiceOrderField {
	Name = "NAME",
	Price = "PRICE",
}

export type ServiceUpdateBulkInput = {
	addClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	category?: InputMaybe<ServiceCategory>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearClassYears?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	price?: InputMaybe<Scalars["Int"]["input"]>;
	removeClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ServiceUpdateInput = {
	addClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	category?: InputMaybe<ServiceCategory>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearClassYears?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	price?: InputMaybe<Scalars["Int"]["input"]>;
	removeClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type Session = Node & {
	__typename?: "Session";
	createdAt: Scalars["Time"]["output"];
	expiresAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	isCurrent: Scalars["Boolean"]["output"];
	isVerified: Scalars["Boolean"]["output"];
	loginRecord: Maybe<LoginRecord>;
	longestInactiveSec: Scalars["Int"]["output"];
	mfaInvalidOTPAttempts: Array<MFAInvalidOTPAttempt>;
	trustedDevice: Maybe<TrustedDevice>;
	trustedDeviceID: Maybe<Scalars["ID"]["output"]>;
	updatedAt: Scalars["Time"]["output"];
	user: User;
	userID: Scalars["ID"]["output"];
};

export type SessionMFAInvalidOTPAttemptsArgs = {
	filters?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput>>;
	order?: InputMaybe<MFAInvalidOTPAttemptOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type SessionConnection = {
	__typename?: "SessionConnection";
	edges: Array<SessionEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SessionEdge = {
	__typename?: "SessionEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Session;
};

export type SessionFilterInput = {
	and?: InputMaybe<Array<SessionFilterInput>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	expiresAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	expiresAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	expiresAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	expiresAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	expiresAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	expiresAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	expiresAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	expiresAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasLoginRecord?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMFAInvalidOTPAttempts?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasTrustedDevice?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isVerifiedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isVerifiedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	loginRecord?: InputMaybe<Array<LoginRecordFilterInput>>;
	longestInactiveSecEQ?: InputMaybe<Scalars["Int"]["input"]>;
	longestInactiveSecGT?: InputMaybe<Scalars["Int"]["input"]>;
	longestInactiveSecGTE?: InputMaybe<Scalars["Int"]["input"]>;
	longestInactiveSecIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	longestInactiveSecLT?: InputMaybe<Scalars["Int"]["input"]>;
	longestInactiveSecLTE?: InputMaybe<Scalars["Int"]["input"]>;
	longestInactiveSecNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	longestInactiveSecNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	mfaInvalidOTPAttempts?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput>>;
	not?: InputMaybe<SessionFilterInput>;
	or?: InputMaybe<Array<SessionFilterInput>>;
	trustedDevice?: InputMaybe<Array<TrustedDeviceFilterInput>>;
	trustedDeviceIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	trustedDeviceIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	trustedDeviceIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	trustedDeviceIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	trustedDeviceIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	updatedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	updatedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	user?: InputMaybe<Array<UserFilterInput>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SessionOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SessionOrderField>;
};

export enum SessionOrderField {
	CreatedAt = "CREATED_AT",
	ExpiresAt = "EXPIRES_AT",
	UpdatedAt = "UPDATED_AT",
}

export type SharingRecord = Node & {
	__typename?: "SharingRecord";
	announcement: Maybe<Announcement>;
	announcementID: Maybe<Scalars["ID"]["output"]>;
	calendarEvent: Maybe<CalendarEvent>;
	calendarEventID: Maybe<Scalars["ID"]["output"]>;
	classYearCategories: Array<ClassYearCategory>;
	classYears: Array<ClassYear>;
	courseSections: Array<CourseSection>;
	homeRoomSections: Array<HomeRoomSection>;
	id: Scalars["ID"]["output"];
	includeAllUsersOfPersonTypes: Scalars["Boolean"]["output"];
	includeEmployees: Scalars["Boolean"]["output"];
	includeGuardians: Scalars["Boolean"]["output"];
	isPublic: Scalars["Boolean"]["output"];
	newsletter: Maybe<Newsletter>;
	newsletterID: Maybe<Scalars["ID"]["output"]>;
	post: Maybe<Post>;
	postID: Maybe<Scalars["ID"]["output"]>;
	sharedUsers: Array<User>;
	studentNote: Maybe<StudentNote>;
	studentNoteID: Maybe<Scalars["ID"]["output"]>;
	userGroups: Array<UserGroup>;
	users: Array<User>;
};

export type SharingRecordClassYearCategoriesArgs = {
	filters?: InputMaybe<Array<ClassYearCategoryFilterInput>>;
	order?: InputMaybe<ClassYearCategoryOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type SharingRecordClassYearsArgs = {
	filters?: InputMaybe<Array<ClassYearFilterInput>>;
	order?: InputMaybe<ClassYearOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type SharingRecordCourseSectionsArgs = {
	filters?: InputMaybe<Array<CourseSectionFilterInput>>;
	order?: InputMaybe<CourseSectionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type SharingRecordHomeRoomSectionsArgs = {
	filters?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
	order?: InputMaybe<HomeRoomSectionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type SharingRecordSharedUsersArgs = {
	filters?: InputMaybe<Array<UserFilterInput>>;
	order?: InputMaybe<UserOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type SharingRecordUserGroupsArgs = {
	filters?: InputMaybe<Array<UserGroupFilterInput>>;
	order?: InputMaybe<UserGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type SharingRecordUsersArgs = {
	filters?: InputMaybe<Array<UserFilterInput>>;
	order?: InputMaybe<UserOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type SharingRecordClassYearCategoryHistory = Node & {
	__typename?: "SharingRecordClassYearCategoryHistory";
	classYearCategoryID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	sharingRecordID: Maybe<Scalars["ID"]["output"]>;
};

export type SharingRecordClassYearCategoryHistoryConnection = {
	__typename?: "SharingRecordClassYearCategoryHistoryConnection";
	edges: Array<SharingRecordClassYearCategoryHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SharingRecordClassYearCategoryHistoryEdge = {
	__typename?: "SharingRecordClassYearCategoryHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SharingRecordClassYearCategoryHistory;
};

export type SharingRecordClassYearCategoryHistoryFilterInput = {
	and?: InputMaybe<Array<SharingRecordClassYearCategoryHistoryFilterInput>>;
	classYearCategoryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearCategoryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearCategoryIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	classYearCategoryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearCategoryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SharingRecordClassYearCategoryHistoryFilterInput>;
	or?: InputMaybe<Array<SharingRecordClassYearCategoryHistoryFilterInput>>;
	sharingRecordIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	sharingRecordIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingRecordClassYearCategoryHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SharingRecordClassYearCategoryHistoryOrderField>;
};

export enum SharingRecordClassYearCategoryHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type SharingRecordClassYearHistory = Node & {
	__typename?: "SharingRecordClassYearHistory";
	classYearID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	sharingRecordID: Maybe<Scalars["ID"]["output"]>;
};

export type SharingRecordClassYearHistoryConnection = {
	__typename?: "SharingRecordClassYearHistoryConnection";
	edges: Array<SharingRecordClassYearHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SharingRecordClassYearHistoryEdge = {
	__typename?: "SharingRecordClassYearHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SharingRecordClassYearHistory;
};

export type SharingRecordClassYearHistoryFilterInput = {
	and?: InputMaybe<Array<SharingRecordClassYearHistoryFilterInput>>;
	classYearIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	classYearIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SharingRecordClassYearHistoryFilterInput>;
	or?: InputMaybe<Array<SharingRecordClassYearHistoryFilterInput>>;
	sharingRecordIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	sharingRecordIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingRecordClassYearHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SharingRecordClassYearHistoryOrderField>;
};

export enum SharingRecordClassYearHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type SharingRecordConnection = {
	__typename?: "SharingRecordConnection";
	edges: Array<SharingRecordEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SharingRecordCourseSectionHistory = Node & {
	__typename?: "SharingRecordCourseSectionHistory";
	courseSectionID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	sharingRecordID: Maybe<Scalars["ID"]["output"]>;
};

export type SharingRecordCourseSectionHistoryConnection = {
	__typename?: "SharingRecordCourseSectionHistoryConnection";
	edges: Array<SharingRecordCourseSectionHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SharingRecordCourseSectionHistoryEdge = {
	__typename?: "SharingRecordCourseSectionHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SharingRecordCourseSectionHistory;
};

export type SharingRecordCourseSectionHistoryFilterInput = {
	and?: InputMaybe<Array<SharingRecordCourseSectionHistoryFilterInput>>;
	courseSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SharingRecordCourseSectionHistoryFilterInput>;
	or?: InputMaybe<Array<SharingRecordCourseSectionHistoryFilterInput>>;
	sharingRecordIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	sharingRecordIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingRecordCourseSectionHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SharingRecordCourseSectionHistoryOrderField>;
};

export enum SharingRecordCourseSectionHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type SharingRecordCreateInput = {
	announcement?: InputMaybe<AnnouncementInSharingRecordCreateInput>;
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEvent?: InputMaybe<CalendarEventInSharingRecordCreateInput>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	classYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	includeAllUsersOfPersonTypes?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletter?: InputMaybe<NewsletterInSharingRecordCreateInput>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	post?: InputMaybe<PostInSharingRecordCreateInput>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	studentNote?: InputMaybe<StudentNoteInSharingRecordCreateInput>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingRecordEdge = {
	__typename?: "SharingRecordEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SharingRecord;
};

export type SharingRecordFilterInput = {
	and?: InputMaybe<Array<SharingRecordFilterInput>>;
	announcement?: InputMaybe<Array<AnnouncementFilterInput>>;
	announcementIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	announcementIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	announcementIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEvent?: InputMaybe<Array<CalendarEventFilterInput>>;
	calendarEventIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	calendarEventIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearCategories?: InputMaybe<Array<ClassYearCategoryFilterInput>>;
	classYears?: InputMaybe<Array<ClassYearFilterInput>>;
	courseSections?: InputMaybe<Array<CourseSectionFilterInput>>;
	hasAnnouncement?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCalendarEvent?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasClassYearCategories?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasClassYears?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCourseSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasHomeRoomSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasNewsletter?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPost?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharedUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentNote?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoomSections?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	includeAllUsersOfPersonTypesEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeAllUsersOfPersonTypesNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployeesEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployeesNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardiansEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardiansNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublicEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublicNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletter?: InputMaybe<Array<NewsletterFilterInput>>;
	newsletterIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletterIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletterIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SharingRecordFilterInput>;
	or?: InputMaybe<Array<SharingRecordFilterInput>>;
	post?: InputMaybe<Array<PostFilterInput>>;
	postIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	postIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharedUsers?: InputMaybe<Array<UserFilterInput>>;
	studentNote?: InputMaybe<Array<StudentNoteFilterInput>>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroups?: InputMaybe<Array<UserGroupFilterInput>>;
	users?: InputMaybe<Array<UserFilterInput>>;
};

export type SharingRecordHistory = Node & {
	__typename?: "SharingRecordHistory";
	announcementID: Maybe<Scalars["ID"]["output"]>;
	calendarEventID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	includeAllUsersOfPersonTypes: Maybe<Scalars["Boolean"]["output"]>;
	includeEmployees: Maybe<Scalars["Boolean"]["output"]>;
	includeGuardians: Maybe<Scalars["Boolean"]["output"]>;
	isPublic: Maybe<Scalars["Boolean"]["output"]>;
	newsletterID: Maybe<Scalars["ID"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	postID: Maybe<Scalars["ID"]["output"]>;
	studentNoteID: Maybe<Scalars["ID"]["output"]>;
};

export type SharingRecordHistoryConnection = {
	__typename?: "SharingRecordHistoryConnection";
	edges: Array<SharingRecordHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SharingRecordHistoryEdge = {
	__typename?: "SharingRecordHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SharingRecordHistory;
};

export type SharingRecordHistoryFilterInput = {
	and?: InputMaybe<Array<SharingRecordHistoryFilterInput>>;
	announcementIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	announcementIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	announcementIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	calendarEventIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	includeAllUsersOfPersonTypesEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeAllUsersOfPersonTypesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeAllUsersOfPersonTypesNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployeesEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployeesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployeesNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardiansEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardiansIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardiansNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublicEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublicIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublicNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletterIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletterIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletterIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SharingRecordHistoryFilterInput>;
	or?: InputMaybe<Array<SharingRecordHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	postIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingRecordHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SharingRecordHistoryOrderField>;
};

export enum SharingRecordHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type SharingRecordHomeRoomSectionHistory = Node & {
	__typename?: "SharingRecordHomeRoomSectionHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	homeRoomSectionID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	sharingRecordID: Maybe<Scalars["ID"]["output"]>;
};

export type SharingRecordHomeRoomSectionHistoryConnection = {
	__typename?: "SharingRecordHomeRoomSectionHistoryConnection";
	edges: Array<SharingRecordHomeRoomSectionHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SharingRecordHomeRoomSectionHistoryEdge = {
	__typename?: "SharingRecordHomeRoomSectionHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SharingRecordHomeRoomSectionHistory;
};

export type SharingRecordHomeRoomSectionHistoryFilterInput = {
	and?: InputMaybe<Array<SharingRecordHomeRoomSectionHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoomSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SharingRecordHomeRoomSectionHistoryFilterInput>;
	or?: InputMaybe<Array<SharingRecordHomeRoomSectionHistoryFilterInput>>;
	sharingRecordIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	sharingRecordIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingRecordHomeRoomSectionHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SharingRecordHomeRoomSectionHistoryOrderField>;
};

export enum SharingRecordHomeRoomSectionHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type SharingRecordInAnnouncementCreateInput = {
	calendarEvent?: InputMaybe<CalendarEventInSharingRecordCreateInput>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	classYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	includeAllUsersOfPersonTypes?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletter?: InputMaybe<NewsletterInSharingRecordCreateInput>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	post?: InputMaybe<PostInSharingRecordCreateInput>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	studentNote?: InputMaybe<StudentNoteInSharingRecordCreateInput>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingRecordInCalendarEventCreateInput = {
	announcement?: InputMaybe<AnnouncementInSharingRecordCreateInput>;
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	classYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	includeAllUsersOfPersonTypes?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletter?: InputMaybe<NewsletterInSharingRecordCreateInput>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	post?: InputMaybe<PostInSharingRecordCreateInput>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	studentNote?: InputMaybe<StudentNoteInSharingRecordCreateInput>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingRecordInNewsletterCreateInput = {
	announcement?: InputMaybe<AnnouncementInSharingRecordCreateInput>;
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEvent?: InputMaybe<CalendarEventInSharingRecordCreateInput>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	classYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	includeAllUsersOfPersonTypes?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	post?: InputMaybe<PostInSharingRecordCreateInput>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	studentNote?: InputMaybe<StudentNoteInSharingRecordCreateInput>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingRecordInPostCreateInput = {
	announcement?: InputMaybe<AnnouncementInSharingRecordCreateInput>;
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEvent?: InputMaybe<CalendarEventInSharingRecordCreateInput>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	classYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	includeAllUsersOfPersonTypes?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletter?: InputMaybe<NewsletterInSharingRecordCreateInput>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	studentNote?: InputMaybe<StudentNoteInSharingRecordCreateInput>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingRecordInStudentNoteCreateInput = {
	announcement?: InputMaybe<AnnouncementInSharingRecordCreateInput>;
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEvent?: InputMaybe<CalendarEventInSharingRecordCreateInput>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	classYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	includeAllUsersOfPersonTypes?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletter?: InputMaybe<NewsletterInSharingRecordCreateInput>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	post?: InputMaybe<PostInSharingRecordCreateInput>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingRecordOrder = {
	direction: OrderDirection;
};

export type SharingRecordSharedSharingRecordUserSharedUserHistory = Node & {
	__typename?: "SharingRecordSharedSharingRecordUserSharedUserHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	sharingRecordID: Maybe<Scalars["ID"]["output"]>;
	userID: Maybe<Scalars["ID"]["output"]>;
};

export type SharingRecordSharedSharingRecordUserSharedUserHistoryConnection = {
	__typename?: "SharingRecordSharedSharingRecordUserSharedUserHistoryConnection";
	edges: Array<SharingRecordSharedSharingRecordUserSharedUserHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SharingRecordSharedSharingRecordUserSharedUserHistoryEdge = {
	__typename?: "SharingRecordSharedSharingRecordUserSharedUserHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SharingRecordSharedSharingRecordUserSharedUserHistory;
};

export type SharingRecordSharedSharingRecordUserSharedUserHistoryFilterInput = {
	and?: InputMaybe<Array<SharingRecordSharedSharingRecordUserSharedUserHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SharingRecordSharedSharingRecordUserSharedUserHistoryFilterInput>;
	or?: InputMaybe<Array<SharingRecordSharedSharingRecordUserSharedUserHistoryFilterInput>>;
	sharingRecordIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	sharingRecordIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingRecordSharedSharingRecordUserSharedUserHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SharingRecordSharedSharingRecordUserSharedUserHistoryOrderField>;
};

export enum SharingRecordSharedSharingRecordUserSharedUserHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type SharingRecordUpdateBulkInput = {
	addClassYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addCourseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addHomeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearClassYearCategories?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearClassYears?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearCourseSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearHomeRoomSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	includeAllUsersOfPersonTypes?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	removeClassYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeCourseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeHomeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingRecordUpdateInput = {
	addClassYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addCourseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addHomeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearClassYearCategories?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearClassYears?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearCourseSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearHomeRoomSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	includeAllUsersOfPersonTypes?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	removeClassYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeCourseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeHomeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingRecordUserGroupHistory = Node & {
	__typename?: "SharingRecordUserGroupHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	sharingRecordID: Maybe<Scalars["ID"]["output"]>;
	userGroupID: Maybe<Scalars["ID"]["output"]>;
};

export type SharingRecordUserGroupHistoryConnection = {
	__typename?: "SharingRecordUserGroupHistoryConnection";
	edges: Array<SharingRecordUserGroupHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SharingRecordUserGroupHistoryEdge = {
	__typename?: "SharingRecordUserGroupHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SharingRecordUserGroupHistory;
};

export type SharingRecordUserGroupHistoryFilterInput = {
	and?: InputMaybe<Array<SharingRecordUserGroupHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SharingRecordUserGroupHistoryFilterInput>;
	or?: InputMaybe<Array<SharingRecordUserGroupHistoryFilterInput>>;
	sharingRecordIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	sharingRecordIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingRecordUserGroupHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SharingRecordUserGroupHistoryOrderField>;
};

export enum SharingRecordUserGroupHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type SharingRecordUserHistory = Node & {
	__typename?: "SharingRecordUserHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	sharingRecordID: Maybe<Scalars["ID"]["output"]>;
	userID: Maybe<Scalars["ID"]["output"]>;
};

export type SharingRecordUserHistoryConnection = {
	__typename?: "SharingRecordUserHistoryConnection";
	edges: Array<SharingRecordUserHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SharingRecordUserHistoryEdge = {
	__typename?: "SharingRecordUserHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SharingRecordUserHistory;
};

export type SharingRecordUserHistoryFilterInput = {
	and?: InputMaybe<Array<SharingRecordUserHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SharingRecordUserHistoryFilterInput>;
	or?: InputMaybe<Array<SharingRecordUserHistoryFilterInput>>;
	sharingRecordIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	sharingRecordIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingRecordUserHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SharingRecordUserHistoryOrderField>;
};

export enum SharingRecordUserHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type SocialComment = Node & {
	__typename?: "SocialComment";
	author: User;
	authorID: Scalars["ID"]["output"];
	body: Scalars["String"]["output"];
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	mediaAttachment: Maybe<MediaAttachment>;
	mediaAttachmentID: Maybe<Scalars["ID"]["output"]>;
	newsletter: Maybe<Newsletter>;
	newsletterID: Maybe<Scalars["ID"]["output"]>;
	post: Maybe<Post>;
	postID: Maybe<Scalars["ID"]["output"]>;
	studentNote: Maybe<StudentNote>;
	studentNoteID: Maybe<Scalars["ID"]["output"]>;
};

export type SocialCommentConnection = {
	__typename?: "SocialCommentConnection";
	edges: Array<SocialCommentEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SocialCommentCreateInput = {
	body: Scalars["String"]["input"];
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SocialCommentEdge = {
	__typename?: "SocialCommentEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SocialComment;
};

export type SocialCommentFilterInput = {
	and?: InputMaybe<Array<SocialCommentFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasMediaAttachment?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasNewsletter?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPost?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentNote?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachment?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	mediaAttachmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachmentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletter?: InputMaybe<Array<NewsletterFilterInput>>;
	newsletterIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletterIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletterIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SocialCommentFilterInput>;
	or?: InputMaybe<Array<SocialCommentFilterInput>>;
	post?: InputMaybe<Array<PostFilterInput>>;
	postIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	postIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentNote?: InputMaybe<Array<StudentNoteFilterInput>>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SocialCommentHistory = Node & {
	__typename?: "SocialCommentHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Maybe<Scalars["String"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	mediaAttachmentID: Maybe<Scalars["ID"]["output"]>;
	newsletterID: Maybe<Scalars["ID"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	postID: Maybe<Scalars["ID"]["output"]>;
	studentNoteID: Maybe<Scalars["ID"]["output"]>;
};

export type SocialCommentHistoryConnection = {
	__typename?: "SocialCommentHistoryConnection";
	edges: Array<SocialCommentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SocialCommentHistoryEdge = {
	__typename?: "SocialCommentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SocialCommentHistory;
};

export type SocialCommentHistoryFilterInput = {
	and?: InputMaybe<Array<SocialCommentHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachmentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletterIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletterIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletterIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SocialCommentHistoryFilterInput>;
	or?: InputMaybe<Array<SocialCommentHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	postIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SocialCommentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SocialCommentHistoryOrderField>;
};

export enum SocialCommentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type SocialCommentInAuthorCreateInput = {
	body: Scalars["String"]["input"];
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SocialCommentInMediaAttachmentCreateInput = {
	body: Scalars["String"]["input"];
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SocialCommentInNewsletterCreateInput = {
	body: Scalars["String"]["input"];
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SocialCommentInPostCreateInput = {
	body: Scalars["String"]["input"];
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SocialCommentInStudentNoteCreateInput = {
	body: Scalars["String"]["input"];
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SocialCommentOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SocialCommentOrderField>;
};

export enum SocialCommentOrderField {
	CreatedAt = "CREATED_AT",
}

export type SocialCommentUpdateBulkInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
};

export type SocialCommentUpdateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
};

export type SocialReaction = Node & {
	__typename?: "SocialReaction";
	announcement: Maybe<Announcement>;
	announcementID: Maybe<Scalars["ID"]["output"]>;
	author: User;
	authorID: Scalars["ID"]["output"];
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	mediaAttachment: Maybe<MediaAttachment>;
	mediaAttachmentID: Maybe<Scalars["ID"]["output"]>;
	newsletter: Maybe<Newsletter>;
	newsletterID: Maybe<Scalars["ID"]["output"]>;
	post: Maybe<Post>;
	postID: Maybe<Scalars["ID"]["output"]>;
	reaction: SocialReactionReaction;
};

export type SocialReactionConnection = {
	__typename?: "SocialReactionConnection";
	edges: Array<SocialReactionEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SocialReactionCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	reaction?: InputMaybe<SocialReactionReaction>;
};

export type SocialReactionEdge = {
	__typename?: "SocialReactionEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SocialReaction;
};

export type SocialReactionFilterInput = {
	and?: InputMaybe<Array<SocialReactionFilterInput>>;
	announcement?: InputMaybe<Array<AnnouncementFilterInput>>;
	announcementIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	announcementIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	announcementIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasAnnouncement?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMediaAttachment?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasNewsletter?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPost?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachment?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	mediaAttachmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachmentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletter?: InputMaybe<Array<NewsletterFilterInput>>;
	newsletterIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletterIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletterIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SocialReactionFilterInput>;
	or?: InputMaybe<Array<SocialReactionFilterInput>>;
	post?: InputMaybe<Array<PostFilterInput>>;
	postIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	postIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reactionEQ?: InputMaybe<SocialReactionReaction>;
	reactionIn?: InputMaybe<Array<SocialReactionReaction>>;
	reactionNEQ?: InputMaybe<SocialReactionReaction>;
	reactionNotIn?: InputMaybe<Array<SocialReactionReaction>>;
};

export type SocialReactionHistory = Node & {
	__typename?: "SocialReactionHistory";
	announcementID: Maybe<Scalars["ID"]["output"]>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	mediaAttachmentID: Maybe<Scalars["ID"]["output"]>;
	newsletterID: Maybe<Scalars["ID"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	postID: Maybe<Scalars["ID"]["output"]>;
	reaction: Maybe<SocialReactionHistoryReaction>;
};

export type SocialReactionHistoryConnection = {
	__typename?: "SocialReactionHistoryConnection";
	edges: Array<SocialReactionHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SocialReactionHistoryEdge = {
	__typename?: "SocialReactionHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SocialReactionHistory;
};

export type SocialReactionHistoryFilterInput = {
	and?: InputMaybe<Array<SocialReactionHistoryFilterInput>>;
	announcementIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	announcementIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	announcementIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachmentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletterIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletterIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletterIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SocialReactionHistoryFilterInput>;
	or?: InputMaybe<Array<SocialReactionHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	postIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reactionEQ?: InputMaybe<SocialReactionHistoryReaction>;
	reactionIn?: InputMaybe<Array<SocialReactionHistoryReaction>>;
	reactionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	reactionNEQ?: InputMaybe<SocialReactionHistoryReaction>;
	reactionNotIn?: InputMaybe<Array<SocialReactionHistoryReaction>>;
};

export type SocialReactionHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SocialReactionHistoryOrderField>;
};

export enum SocialReactionHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export enum SocialReactionHistoryReaction {
	Like = "like",
}

export type SocialReactionInAnnouncementCreateInput = {
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	reaction?: InputMaybe<SocialReactionReaction>;
};

export type SocialReactionInAuthorCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	reaction?: InputMaybe<SocialReactionReaction>;
};

export type SocialReactionInMediaAttachmentCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	reaction?: InputMaybe<SocialReactionReaction>;
};

export type SocialReactionInNewsletterCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	reaction?: InputMaybe<SocialReactionReaction>;
};

export type SocialReactionInPostCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	reaction?: InputMaybe<SocialReactionReaction>;
};

export type SocialReactionOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SocialReactionOrderField>;
};

export enum SocialReactionOrderField {
	CreatedAt = "CREATED_AT",
	Reaction = "REACTION",
}

export enum SocialReactionReaction {
	Like = "like",
}

export type SocialReactionUpdateBulkInput = {
	reaction?: InputMaybe<SocialReactionReaction>;
};

export type SocialReactionUpdateInput = {
	reaction?: InputMaybe<SocialReactionReaction>;
};

export type Student = Node & {
	__typename?: "Student";
	contracts: Array<Contract>;
	courseAssessmentMarks: Array<CourseAssessmentMark>;
	courseAssessmentSubmissions: Array<CourseAssessmentSubmission>;
	courseAttendanceRecords: Array<CourseAttendanceRecord>;
	enrollmentApplicationStudents: Array<EnrollmentApplicationStudent>;
	graduationYear: Maybe<Scalars["Int"]["output"]>;
	id: Scalars["ID"]["output"];
	messageTopics: Array<MessageTopic>;
	person: Person;
	personID: Scalars["ID"]["output"];
	primaryStudentNotes: Array<StudentNote>;
	relationships: Array<Relationship>;
	reportCards: Array<ReportCard>;
	schoolAttendanceRecords: Array<SchoolAttendanceRecord>;
	secondaryStudentNotes: Array<StudentNote>;
	studentAcademicTermEnrollments: Array<StudentAcademicTermEnrollment>;
	studentCourseSectionEnrollments: Array<StudentCourseSectionEnrollment>;
	studentDataConsents: Array<StudentDataConsent>;
	studentEnrollmentIntents: Array<StudentEnrollmentIntent>;
	studentHomeRoomSectionEnrollments: Array<StudentHomeRoomSectionEnrollment>;
	studentInformationVerifications: Array<StudentInformationVerification>;
	studentMedicalConditions: Array<StudentMedicalCondition>;
	studentMedicalContacts: Array<StudentMedicalContact>;
	studentMedicalEvents: Array<StudentMedicalEvent>;
	studentMedicalProfile: Maybe<StudentMedicalProfile>;
	studentOtcMedications: Array<StudentOTCMedication>;
	studentPrescriptionMedications: Array<StudentPrescriptionMedication>;
	studentVaccinationRecords: Array<StudentVaccinationRecord>;
	yearsFromGraduation: Scalars["Int"]["output"];
};

export type StudentContractsArgs = {
	filters?: InputMaybe<Array<ContractFilterInput>>;
	order?: InputMaybe<ContractOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentCourseAssessmentMarksArgs = {
	filters?: InputMaybe<Array<CourseAssessmentMarkFilterInput>>;
	order?: InputMaybe<CourseAssessmentMarkOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentCourseAssessmentSubmissionsArgs = {
	filters?: InputMaybe<Array<CourseAssessmentSubmissionFilterInput>>;
	order?: InputMaybe<CourseAssessmentSubmissionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentCourseAttendanceRecordsArgs = {
	filters?: InputMaybe<Array<CourseAttendanceRecordFilterInput>>;
	order?: InputMaybe<CourseAttendanceRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentEnrollmentApplicationStudentsArgs = {
	filters?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	order?: InputMaybe<EnrollmentApplicationStudentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentMessageTopicsArgs = {
	filters?: InputMaybe<Array<MessageTopicFilterInput>>;
	order?: InputMaybe<MessageTopicOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentPrimaryStudentNotesArgs = {
	filters?: InputMaybe<Array<StudentNoteFilterInput>>;
	order?: InputMaybe<StudentNoteOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentRelationshipsArgs = {
	filters?: InputMaybe<Array<RelationshipFilterInput>>;
	order?: InputMaybe<RelationshipOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentReportCardsArgs = {
	filters?: InputMaybe<Array<ReportCardFilterInput>>;
	order?: InputMaybe<ReportCardOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentSchoolAttendanceRecordsArgs = {
	filters?: InputMaybe<Array<SchoolAttendanceRecordFilterInput>>;
	order?: InputMaybe<SchoolAttendanceRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentSecondaryStudentNotesArgs = {
	filters?: InputMaybe<Array<StudentNoteFilterInput>>;
	order?: InputMaybe<StudentNoteOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentStudentAcademicTermEnrollmentsArgs = {
	filters?: InputMaybe<Array<StudentAcademicTermEnrollmentFilterInput>>;
	order?: InputMaybe<StudentAcademicTermEnrollmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentStudentCourseSectionEnrollmentsArgs = {
	filters?: InputMaybe<Array<StudentCourseSectionEnrollmentFilterInput>>;
	order?: InputMaybe<StudentCourseSectionEnrollmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentStudentDataConsentsArgs = {
	filters?: InputMaybe<Array<StudentDataConsentFilterInput>>;
	order?: InputMaybe<StudentDataConsentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentStudentEnrollmentIntentsArgs = {
	filters?: InputMaybe<Array<StudentEnrollmentIntentFilterInput>>;
	order?: InputMaybe<StudentEnrollmentIntentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentStudentHomeRoomSectionEnrollmentsArgs = {
	filters?: InputMaybe<Array<StudentHomeRoomSectionEnrollmentFilterInput>>;
	order?: InputMaybe<StudentHomeRoomSectionEnrollmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentStudentInformationVerificationsArgs = {
	filters?: InputMaybe<Array<StudentInformationVerificationFilterInput>>;
	order?: InputMaybe<StudentInformationVerificationOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentStudentMedicalConditionsArgs = {
	filters?: InputMaybe<Array<StudentMedicalConditionFilterInput>>;
	order?: InputMaybe<StudentMedicalConditionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentStudentMedicalContactsArgs = {
	filters?: InputMaybe<Array<StudentMedicalContactFilterInput>>;
	order?: InputMaybe<StudentMedicalContactOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentStudentMedicalEventsArgs = {
	filters?: InputMaybe<Array<StudentMedicalEventFilterInput>>;
	order?: InputMaybe<StudentMedicalEventOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentStudentOTCMedicationsArgs = {
	filters?: InputMaybe<Array<StudentOTCMedicationFilterInput>>;
	order?: InputMaybe<StudentOTCMedicationOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentStudentPrescriptionMedicationsArgs = {
	filters?: InputMaybe<Array<StudentPrescriptionMedicationFilterInput>>;
	order?: InputMaybe<StudentPrescriptionMedicationOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentStudentVaccinationRecordsArgs = {
	filters?: InputMaybe<Array<StudentVaccinationRecordFilterInput>>;
	order?: InputMaybe<StudentVaccinationRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentAcademicNote = Node & {
	__typename?: "StudentAcademicNote";
	id: Scalars["ID"]["output"];
	isIssueNatureAttentionIssue: Scalars["Boolean"]["output"];
	isIssueNatureEmotionalOrVulnerableIssue: Scalars["Boolean"]["output"];
	isIssueNatureFocusIssue: Scalars["Boolean"]["output"];
	isIssueNatureLearningDifficulty: Scalars["Boolean"]["output"];
	isIssueNatureOther: Scalars["Boolean"]["output"];
	isSolutionRecDifferentiatedLearning: Scalars["Boolean"]["output"];
	isSolutionRecInClassSupport: Scalars["Boolean"]["output"];
	isSolutionRecIndividualLearningPlan: Scalars["Boolean"]["output"];
	isSolutionRecOther: Scalars["Boolean"]["output"];
	isSolutionRecProfessionalSupport: Scalars["Boolean"]["output"];
	isSolutionRecTutoring: Scalars["Boolean"]["output"];
	issueNatureOther: Scalars["String"]["output"];
	solutionRecOther: Scalars["String"]["output"];
	studentNote: StudentNote;
	studentNoteID: Scalars["ID"]["output"];
};

export type StudentAcademicNoteConnection = {
	__typename?: "StudentAcademicNoteConnection";
	edges: Array<StudentAcademicNoteEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentAcademicNoteCreateInput = {
	isIssueNatureAttentionIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureEmotionalOrVulnerableIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureFocusIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureLearningDifficulty?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecDifferentiatedLearning?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecInClassSupport?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecIndividualLearningPlan?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecProfessionalSupport?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecTutoring?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueNatureOther?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOther?: InputMaybe<Scalars["String"]["input"]>;
	studentNote?: InputMaybe<StudentNoteInStudentAcademicNoteCreateInput>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentAcademicNoteEdge = {
	__typename?: "StudentAcademicNoteEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentAcademicNote;
};

export type StudentAcademicNoteFilterInput = {
	and?: InputMaybe<Array<StudentAcademicNoteFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isIssueNatureAttentionIssueEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureAttentionIssueNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureEmotionalOrVulnerableIssueEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureEmotionalOrVulnerableIssueNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureFocusIssueEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureFocusIssueNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureLearningDifficultyEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureLearningDifficultyNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureOtherEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureOtherNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecDifferentiatedLearningEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecDifferentiatedLearningNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecInClassSupportEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecInClassSupportNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecIndividualLearningPlanEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecIndividualLearningPlanNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecOtherEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecOtherNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecProfessionalSupportEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecProfessionalSupportNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecTutoringEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecTutoringNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueNatureOtherContains?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherEQ?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	issueNatureOtherNEQ?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherNotContains?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<StudentAcademicNoteFilterInput>;
	or?: InputMaybe<Array<StudentAcademicNoteFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherContains?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherEQ?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	solutionRecOtherNEQ?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherNotContains?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	studentNote?: InputMaybe<Array<StudentNoteFilterInput>>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentAcademicNoteHistory = Node & {
	__typename?: "StudentAcademicNoteHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isIssueNatureAttentionIssue: Maybe<Scalars["Boolean"]["output"]>;
	isIssueNatureEmotionalOrVulnerableIssue: Maybe<Scalars["Boolean"]["output"]>;
	isIssueNatureFocusIssue: Maybe<Scalars["Boolean"]["output"]>;
	isIssueNatureLearningDifficulty: Maybe<Scalars["Boolean"]["output"]>;
	isIssueNatureOther: Maybe<Scalars["Boolean"]["output"]>;
	isSolutionRecDifferentiatedLearning: Maybe<Scalars["Boolean"]["output"]>;
	isSolutionRecInClassSupport: Maybe<Scalars["Boolean"]["output"]>;
	isSolutionRecIndividualLearningPlan: Maybe<Scalars["Boolean"]["output"]>;
	isSolutionRecOther: Maybe<Scalars["Boolean"]["output"]>;
	isSolutionRecProfessionalSupport: Maybe<Scalars["Boolean"]["output"]>;
	isSolutionRecTutoring: Maybe<Scalars["Boolean"]["output"]>;
	issueNatureOther: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	solutionRecOther: Maybe<Scalars["String"]["output"]>;
	studentNoteID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentAcademicNoteHistoryConnection = {
	__typename?: "StudentAcademicNoteHistoryConnection";
	edges: Array<StudentAcademicNoteHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentAcademicNoteHistoryEdge = {
	__typename?: "StudentAcademicNoteHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentAcademicNoteHistory;
};

export type StudentAcademicNoteHistoryFilterInput = {
	and?: InputMaybe<Array<StudentAcademicNoteHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isIssueNatureAttentionIssueEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureAttentionIssueIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureAttentionIssueNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureEmotionalOrVulnerableIssueEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureEmotionalOrVulnerableIssueIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureEmotionalOrVulnerableIssueNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureFocusIssueEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureFocusIssueIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureFocusIssueNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureLearningDifficultyEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureLearningDifficultyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureLearningDifficultyNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureOtherEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureOtherIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureOtherNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecDifferentiatedLearningEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecDifferentiatedLearningIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecDifferentiatedLearningNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecInClassSupportEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecInClassSupportIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecInClassSupportNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecIndividualLearningPlanEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecIndividualLearningPlanIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecIndividualLearningPlanNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecOtherEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecOtherIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecOtherNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecProfessionalSupportEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecProfessionalSupportIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecProfessionalSupportNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecTutoringEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecTutoringIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecTutoringNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueNatureOtherContains?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherEQ?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	issueNatureOtherIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueNatureOtherNEQ?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherNotContains?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<StudentAcademicNoteHistoryFilterInput>;
	or?: InputMaybe<Array<StudentAcademicNoteHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherContains?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherEQ?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	solutionRecOtherIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	solutionRecOtherNEQ?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherNotContains?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentAcademicNoteHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentAcademicNoteHistoryOrderField>;
};

export enum StudentAcademicNoteHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentAcademicNoteInStudentNoteCreateInput = {
	isIssueNatureAttentionIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureEmotionalOrVulnerableIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureFocusIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureLearningDifficulty?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecDifferentiatedLearning?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecInClassSupport?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecIndividualLearningPlan?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecProfessionalSupport?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecTutoring?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueNatureOther?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOther?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentAcademicNoteOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentAcademicNoteOrderField>;
};

export enum StudentAcademicNoteOrderField {
	IsIssueNatureAttentionIssue = "IS_ISSUE_NATURE_ATTENTION_ISSUE",
	IsIssueNatureEmotionalOrVulnerableIssue = "IS_ISSUE_NATURE_EMOTIONAL_OR_VULNERABLE_ISSUE",
	IsIssueNatureFocusIssue = "IS_ISSUE_NATURE_FOCUS_ISSUE",
	IsIssueNatureLearningDifficulty = "IS_ISSUE_NATURE_LEARNING_DIFFICULTY",
	IsIssueNatureOther = "IS_ISSUE_NATURE_OTHER",
	IsSolutionRecDifferentiatedLearning = "IS_SOLUTION_REC_DIFFERENTIATED_LEARNING",
	IsSolutionRecIndividualLearningPlan = "IS_SOLUTION_REC_INDIVIDUAL_LEARNING_PLAN",
	IsSolutionRecInClassSupport = "IS_SOLUTION_REC_IN_CLASS_SUPPORT",
	IsSolutionRecOther = "IS_SOLUTION_REC_OTHER",
	IsSolutionRecProfessionalSupport = "IS_SOLUTION_REC_PROFESSIONAL_SUPPORT",
	IsSolutionRecTutoring = "IS_SOLUTION_REC_TUTORING",
}

export type StudentAcademicNoteUpdateBulkInput = {
	isIssueNatureAttentionIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureEmotionalOrVulnerableIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureFocusIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureLearningDifficulty?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecDifferentiatedLearning?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecInClassSupport?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecIndividualLearningPlan?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecProfessionalSupport?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecTutoring?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueNatureOther?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOther?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentAcademicNoteUpdateInput = {
	isIssueNatureAttentionIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureEmotionalOrVulnerableIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureFocusIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureLearningDifficulty?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecDifferentiatedLearning?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecInClassSupport?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecIndividualLearningPlan?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecProfessionalSupport?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecTutoring?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueNatureOther?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOther?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentAcademicTermEnrollment = Node & {
	__typename?: "StudentAcademicTermEnrollment";
	academicTerm: AcademicTerm;
	academicTermID: Scalars["ID"]["output"];
	earlyEndDate: Maybe<Scalars["Date"]["output"]>;
	id: Scalars["ID"]["output"];
	lateStartDate: Maybe<Scalars["Date"]["output"]>;
	student: Student;
	studentID: Scalars["ID"]["output"];
};

export type StudentAcademicTermEnrollmentConnection = {
	__typename?: "StudentAcademicTermEnrollmentConnection";
	edges: Array<StudentAcademicTermEnrollmentEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentAcademicTermEnrollmentCreateInput = {
	academicTermID: Scalars["ID"]["input"];
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type StudentAcademicTermEnrollmentEdge = {
	__typename?: "StudentAcademicTermEnrollmentEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentAcademicTermEnrollment;
};

export type StudentAcademicTermEnrollmentFilterInput = {
	academicTerm?: InputMaybe<Array<AcademicTermFilterInput>>;
	academicTermIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicTermIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	academicTermIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicTermIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	and?: InputMaybe<Array<StudentAcademicTermEnrollmentFilterInput>>;
	earlyEndDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	earlyEndDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	lateStartDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	lateStartDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	lateStartDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	not?: InputMaybe<StudentAcademicTermEnrollmentFilterInput>;
	or?: InputMaybe<Array<StudentAcademicTermEnrollmentFilterInput>>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentAcademicTermEnrollmentHistory = Node & {
	__typename?: "StudentAcademicTermEnrollmentHistory";
	academicTermID: Maybe<Scalars["ID"]["output"]>;
	earlyEndDate: Maybe<Scalars["Date"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	lateStartDate: Maybe<Scalars["Date"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentAcademicTermEnrollmentHistoryConnection = {
	__typename?: "StudentAcademicTermEnrollmentHistoryConnection";
	edges: Array<StudentAcademicTermEnrollmentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentAcademicTermEnrollmentHistoryEdge = {
	__typename?: "StudentAcademicTermEnrollmentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentAcademicTermEnrollmentHistory;
};

export type StudentAcademicTermEnrollmentHistoryFilterInput = {
	academicTermIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicTermIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	academicTermIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	academicTermIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicTermIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	and?: InputMaybe<Array<StudentAcademicTermEnrollmentHistoryFilterInput>>;
	earlyEndDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	earlyEndDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	lateStartDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	lateStartDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	lateStartDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	not?: InputMaybe<StudentAcademicTermEnrollmentHistoryFilterInput>;
	or?: InputMaybe<Array<StudentAcademicTermEnrollmentHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentAcademicTermEnrollmentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentAcademicTermEnrollmentHistoryOrderField>;
};

export enum StudentAcademicTermEnrollmentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentAcademicTermEnrollmentInAcademicTermCreateInput = {
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type StudentAcademicTermEnrollmentInStudentCreateInput = {
	academicTermID: Scalars["ID"]["input"];
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type StudentAcademicTermEnrollmentOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentAcademicTermEnrollmentOrderField>;
};

export enum StudentAcademicTermEnrollmentOrderField {
	EarlyEndDate = "EARLY_END_DATE",
	LateStartDate = "LATE_START_DATE",
}

export type StudentAcademicTermEnrollmentUpdateBulkInput = {
	clearEarlyEndDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearLateStartDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type StudentAcademicTermEnrollmentUpdateInput = {
	clearEarlyEndDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearLateStartDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type StudentAcademicTermUnenrollmentResult = {
	__typename?: "StudentAcademicTermUnenrollmentResult";
	studentAcademicTermEnrollments: DeleteBulkResponse;
	studentCourseSectionEnrollments: DeleteBulkResponse;
	studentHomeRoomSectionEnrollments: DeleteBulkResponse;
};

export type StudentAttendanceNote = Node & {
	__typename?: "StudentAttendanceNote";
	attendanceStatus: Maybe<AttendanceStatus>;
	attendanceStatusID: Maybe<Scalars["ID"]["output"]>;
	endDate: Scalars["Date"]["output"];
	id: Scalars["ID"]["output"];
	startDate: Scalars["Date"]["output"];
	studentNote: StudentNote;
	studentNoteID: Scalars["ID"]["output"];
};

export type StudentAttendanceNoteConnection = {
	__typename?: "StudentAttendanceNoteConnection";
	edges: Array<StudentAttendanceNoteEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentAttendanceNoteCreateInput = {
	attendanceStatusID?: InputMaybe<Scalars["ID"]["input"]>;
	endDate: Scalars["Date"]["input"];
	startDate: Scalars["Date"]["input"];
	studentNote?: InputMaybe<StudentNoteInStudentAttendanceNoteCreateInput>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentAttendanceNoteEdge = {
	__typename?: "StudentAttendanceNoteEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentAttendanceNote;
};

export type StudentAttendanceNoteFilterInput = {
	and?: InputMaybe<Array<StudentAttendanceNoteFilterInput>>;
	attendanceStatus?: InputMaybe<Array<AttendanceStatusFilterInput>>;
	attendanceStatusIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	attendanceStatusIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	attendanceStatusIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	attendanceStatusIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	attendanceStatusIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	endDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	endDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	endDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	endDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	endDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	endDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	endDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	endDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	hasAttendanceStatus?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentAttendanceNoteFilterInput>;
	or?: InputMaybe<Array<StudentAttendanceNoteFilterInput>>;
	startDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	startDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	startDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	startDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	startDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	startDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	startDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	startDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	studentNote?: InputMaybe<Array<StudentNoteFilterInput>>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentAttendanceNoteHistory = Node & {
	__typename?: "StudentAttendanceNoteHistory";
	attendanceStatusID: Maybe<Scalars["ID"]["output"]>;
	endDate: Maybe<Scalars["Date"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
	startDate: Maybe<Scalars["Date"]["output"]>;
	studentNoteID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentAttendanceNoteHistoryConnection = {
	__typename?: "StudentAttendanceNoteHistoryConnection";
	edges: Array<StudentAttendanceNoteHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentAttendanceNoteHistoryEdge = {
	__typename?: "StudentAttendanceNoteHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentAttendanceNoteHistory;
};

export type StudentAttendanceNoteHistoryFilterInput = {
	and?: InputMaybe<Array<StudentAttendanceNoteHistoryFilterInput>>;
	attendanceStatusIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	attendanceStatusIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	attendanceStatusIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	attendanceStatusIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	attendanceStatusIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	endDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	endDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	endDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	endDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	endDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	endDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	endDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	endDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	endDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentAttendanceNoteHistoryFilterInput>;
	or?: InputMaybe<Array<StudentAttendanceNoteHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	startDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	startDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	startDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	startDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	startDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	startDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	startDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	startDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	startDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentAttendanceNoteHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentAttendanceNoteHistoryOrderField>;
};

export enum StudentAttendanceNoteHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentAttendanceNoteInAttendanceStatusCreateInput = {
	endDate: Scalars["Date"]["input"];
	startDate: Scalars["Date"]["input"];
	studentNote?: InputMaybe<StudentNoteInStudentAttendanceNoteCreateInput>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentAttendanceNoteInStudentNoteCreateInput = {
	attendanceStatusID?: InputMaybe<Scalars["ID"]["input"]>;
	endDate: Scalars["Date"]["input"];
	startDate: Scalars["Date"]["input"];
};

export type StudentAttendanceNoteOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentAttendanceNoteOrderField>;
};

export enum StudentAttendanceNoteOrderField {
	EndDate = "END_DATE",
	StartDate = "START_DATE",
}

export type StudentAttendanceNoteUpdateBulkInput = {
	attendanceStatusID?: InputMaybe<Scalars["ID"]["input"]>;
	clearAttendanceStatus?: InputMaybe<Scalars["Boolean"]["input"]>;
	endDate?: InputMaybe<Scalars["Date"]["input"]>;
	startDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type StudentAttendanceNoteUpdateInput = {
	attendanceStatusID?: InputMaybe<Scalars["ID"]["input"]>;
	clearAttendanceStatus?: InputMaybe<Scalars["Boolean"]["input"]>;
	endDate?: InputMaybe<Scalars["Date"]["input"]>;
	startDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type StudentBehaviorNote = Node & {
	__typename?: "StudentBehaviorNote";
	additionalComments: Scalars["String"]["output"];
	consequenceRecOther: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	incidentLocation: Maybe<StudentBehaviorNoteIncidentLocation>;
	incidentOther: Scalars["String"]["output"];
	incidentTime: Maybe<Scalars["Time"]["output"]>;
	isConsequenceRecDirectorIntervention: Scalars["Boolean"]["output"];
	isConsequenceRecOther: Scalars["Boolean"]["output"];
	isConsequenceRecParentContactFromReporter: Scalars["Boolean"]["output"];
	isConsequenceRecParentContactFromSchoolDirector: Scalars["Boolean"]["output"];
	isConsequenceRecSenOrSelIntervention: Scalars["Boolean"]["output"];
	isConsequenceRecStudentServiceTeamIntervention: Scalars["Boolean"]["output"];
	isIncidentDefianceOrNonCompliance: Scalars["Boolean"]["output"];
	isIncidentDisrepectingTeacher: Scalars["Boolean"]["output"];
	isIncidentDisruption: Scalars["Boolean"]["output"];
	isIncidentFightingPhysicalAggression: Scalars["Boolean"]["output"];
	isIncidentOther: Scalars["Boolean"]["output"];
	isIncidentPhysicalContactAggression: Scalars["Boolean"]["output"];
	isIncidentVerbalAbuseDisrespectingStudent: Scalars["Boolean"]["output"];
	isMotivationAnger: Scalars["Boolean"]["output"];
	isMotivationAttentionSeeking: Scalars["Boolean"]["output"];
	isMotivationFrustration: Scalars["Boolean"]["output"];
	isMotivationHabit: Scalars["Boolean"]["output"];
	isMotivationLackOfSelfContol: Scalars["Boolean"]["output"];
	isMotivationOther: Scalars["Boolean"]["output"];
	isMotivationReaction: Scalars["Boolean"]["output"];
	motivationOther: Scalars["String"]["output"];
	studentNote: StudentNote;
	studentNoteID: Scalars["ID"]["output"];
};

export type StudentBehaviorNoteConnection = {
	__typename?: "StudentBehaviorNoteConnection";
	edges: Array<StudentBehaviorNoteEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentBehaviorNoteCreateInput = {
	additionalComments?: InputMaybe<Scalars["String"]["input"]>;
	consequenceRecOther?: InputMaybe<Scalars["String"]["input"]>;
	incidentLocation?: InputMaybe<StudentBehaviorNoteIncidentLocation>;
	incidentOther?: InputMaybe<Scalars["String"]["input"]>;
	incidentTime?: InputMaybe<Scalars["Time"]["input"]>;
	isConsequenceRecDirectorIntervention?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecParentContactFromReporter?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecParentContactFromSchoolDirector?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecSenOrSelIntervention?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecStudentServiceTeamIntervention?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDefianceOrNonCompliance?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDisrepectingTeacher?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDisruption?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentFightingPhysicalAggression?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentPhysicalContactAggression?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentVerbalAbuseDisrespectingStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationAnger?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationAttentionSeeking?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationFrustration?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationHabit?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationLackOfSelfContol?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationReaction?: InputMaybe<Scalars["Boolean"]["input"]>;
	motivationOther?: InputMaybe<Scalars["String"]["input"]>;
	studentNote?: InputMaybe<StudentNoteInStudentBehaviorNoteCreateInput>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentBehaviorNoteEdge = {
	__typename?: "StudentBehaviorNoteEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentBehaviorNote;
};

export type StudentBehaviorNoteFilterInput = {
	additionalCommentsContains?: InputMaybe<Scalars["String"]["input"]>;
	additionalCommentsEQ?: InputMaybe<Scalars["String"]["input"]>;
	additionalCommentsHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	additionalCommentsHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	additionalCommentsIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	additionalCommentsNEQ?: InputMaybe<Scalars["String"]["input"]>;
	additionalCommentsNotContains?: InputMaybe<Scalars["String"]["input"]>;
	additionalCommentsNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	additionalCommentsNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	additionalCommentsNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<StudentBehaviorNoteFilterInput>>;
	consequenceRecOtherContains?: InputMaybe<Scalars["String"]["input"]>;
	consequenceRecOtherEQ?: InputMaybe<Scalars["String"]["input"]>;
	consequenceRecOtherHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	consequenceRecOtherHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	consequenceRecOtherIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	consequenceRecOtherNEQ?: InputMaybe<Scalars["String"]["input"]>;
	consequenceRecOtherNotContains?: InputMaybe<Scalars["String"]["input"]>;
	consequenceRecOtherNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	consequenceRecOtherNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	consequenceRecOtherNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	incidentLocationEQ?: InputMaybe<StudentBehaviorNoteIncidentLocation>;
	incidentLocationIn?: InputMaybe<Array<StudentBehaviorNoteIncidentLocation>>;
	incidentLocationIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	incidentLocationNEQ?: InputMaybe<StudentBehaviorNoteIncidentLocation>;
	incidentLocationNotIn?: InputMaybe<Array<StudentBehaviorNoteIncidentLocation>>;
	incidentOtherContains?: InputMaybe<Scalars["String"]["input"]>;
	incidentOtherEQ?: InputMaybe<Scalars["String"]["input"]>;
	incidentOtherHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	incidentOtherHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	incidentOtherIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	incidentOtherNEQ?: InputMaybe<Scalars["String"]["input"]>;
	incidentOtherNotContains?: InputMaybe<Scalars["String"]["input"]>;
	incidentOtherNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	incidentOtherNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	incidentOtherNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	incidentTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	incidentTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	incidentTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	isConsequenceRecDirectorInterventionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecDirectorInterventionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecOtherEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecOtherNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecParentContactFromReporterEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecParentContactFromReporterNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecParentContactFromSchoolDirectorEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecParentContactFromSchoolDirectorNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecSenOrSelInterventionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecSenOrSelInterventionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecStudentServiceTeamInterventionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecStudentServiceTeamInterventionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDefianceOrNonComplianceEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDefianceOrNonComplianceNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDisrepectingTeacherEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDisrepectingTeacherNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDisruptionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDisruptionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentFightingPhysicalAggressionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentFightingPhysicalAggressionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentOtherEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentOtherNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentPhysicalContactAggressionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentPhysicalContactAggressionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentVerbalAbuseDisrespectingStudentEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentVerbalAbuseDisrespectingStudentNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationAngerEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationAngerNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationAttentionSeekingEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationAttentionSeekingNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationFrustrationEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationFrustrationNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationHabitEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationHabitNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationLackOfSelfContolEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationLackOfSelfContolNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationOtherEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationOtherNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationReactionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationReactionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	motivationOtherContains?: InputMaybe<Scalars["String"]["input"]>;
	motivationOtherEQ?: InputMaybe<Scalars["String"]["input"]>;
	motivationOtherHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	motivationOtherHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	motivationOtherIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	motivationOtherNEQ?: InputMaybe<Scalars["String"]["input"]>;
	motivationOtherNotContains?: InputMaybe<Scalars["String"]["input"]>;
	motivationOtherNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	motivationOtherNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	motivationOtherNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<StudentBehaviorNoteFilterInput>;
	or?: InputMaybe<Array<StudentBehaviorNoteFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentNote?: InputMaybe<Array<StudentNoteFilterInput>>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentBehaviorNoteHistory = Node & {
	__typename?: "StudentBehaviorNoteHistory";
	additionalComments: Maybe<Scalars["String"]["output"]>;
	consequenceRecOther: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	incidentLocation: Maybe<StudentBehaviorNoteHistoryIncidentLocation>;
	incidentOther: Maybe<Scalars["String"]["output"]>;
	incidentTime: Maybe<Scalars["Time"]["output"]>;
	isConsequenceRecDirectorIntervention: Maybe<Scalars["Boolean"]["output"]>;
	isConsequenceRecOther: Maybe<Scalars["Boolean"]["output"]>;
	isConsequenceRecParentContactFromReporter: Maybe<Scalars["Boolean"]["output"]>;
	isConsequenceRecParentContactFromSchoolDirector: Maybe<Scalars["Boolean"]["output"]>;
	isConsequenceRecSenOrSelIntervention: Maybe<Scalars["Boolean"]["output"]>;
	isConsequenceRecStudentServiceTeamIntervention: Maybe<Scalars["Boolean"]["output"]>;
	isIncidentDefianceOrNonCompliance: Maybe<Scalars["Boolean"]["output"]>;
	isIncidentDisrepectingTeacher: Maybe<Scalars["Boolean"]["output"]>;
	isIncidentDisruption: Maybe<Scalars["Boolean"]["output"]>;
	isIncidentFightingPhysicalAggression: Maybe<Scalars["Boolean"]["output"]>;
	isIncidentOther: Maybe<Scalars["Boolean"]["output"]>;
	isIncidentPhysicalContactAggression: Maybe<Scalars["Boolean"]["output"]>;
	isIncidentVerbalAbuseDisrespectingStudent: Maybe<Scalars["Boolean"]["output"]>;
	isMotivationAnger: Maybe<Scalars["Boolean"]["output"]>;
	isMotivationAttentionSeeking: Maybe<Scalars["Boolean"]["output"]>;
	isMotivationFrustration: Maybe<Scalars["Boolean"]["output"]>;
	isMotivationHabit: Maybe<Scalars["Boolean"]["output"]>;
	isMotivationLackOfSelfContol: Maybe<Scalars["Boolean"]["output"]>;
	isMotivationOther: Maybe<Scalars["Boolean"]["output"]>;
	isMotivationReaction: Maybe<Scalars["Boolean"]["output"]>;
	motivationOther: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	studentNoteID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentBehaviorNoteHistoryConnection = {
	__typename?: "StudentBehaviorNoteHistoryConnection";
	edges: Array<StudentBehaviorNoteHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentBehaviorNoteHistoryEdge = {
	__typename?: "StudentBehaviorNoteHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentBehaviorNoteHistory;
};

export type StudentBehaviorNoteHistoryFilterInput = {
	additionalCommentsContains?: InputMaybe<Scalars["String"]["input"]>;
	additionalCommentsEQ?: InputMaybe<Scalars["String"]["input"]>;
	additionalCommentsHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	additionalCommentsHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	additionalCommentsIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	additionalCommentsIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	additionalCommentsNEQ?: InputMaybe<Scalars["String"]["input"]>;
	additionalCommentsNotContains?: InputMaybe<Scalars["String"]["input"]>;
	additionalCommentsNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	additionalCommentsNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	additionalCommentsNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<StudentBehaviorNoteHistoryFilterInput>>;
	consequenceRecOtherContains?: InputMaybe<Scalars["String"]["input"]>;
	consequenceRecOtherEQ?: InputMaybe<Scalars["String"]["input"]>;
	consequenceRecOtherHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	consequenceRecOtherHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	consequenceRecOtherIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	consequenceRecOtherIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	consequenceRecOtherNEQ?: InputMaybe<Scalars["String"]["input"]>;
	consequenceRecOtherNotContains?: InputMaybe<Scalars["String"]["input"]>;
	consequenceRecOtherNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	consequenceRecOtherNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	consequenceRecOtherNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	incidentLocationEQ?: InputMaybe<StudentBehaviorNoteHistoryIncidentLocation>;
	incidentLocationIn?: InputMaybe<Array<StudentBehaviorNoteHistoryIncidentLocation>>;
	incidentLocationIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	incidentLocationNEQ?: InputMaybe<StudentBehaviorNoteHistoryIncidentLocation>;
	incidentLocationNotIn?: InputMaybe<Array<StudentBehaviorNoteHistoryIncidentLocation>>;
	incidentOtherContains?: InputMaybe<Scalars["String"]["input"]>;
	incidentOtherEQ?: InputMaybe<Scalars["String"]["input"]>;
	incidentOtherHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	incidentOtherHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	incidentOtherIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	incidentOtherIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	incidentOtherNEQ?: InputMaybe<Scalars["String"]["input"]>;
	incidentOtherNotContains?: InputMaybe<Scalars["String"]["input"]>;
	incidentOtherNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	incidentOtherNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	incidentOtherNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	incidentTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	incidentTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	incidentTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	isConsequenceRecDirectorInterventionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecDirectorInterventionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecDirectorInterventionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecOtherEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecOtherIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecOtherNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecParentContactFromReporterEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecParentContactFromReporterIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecParentContactFromReporterNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecParentContactFromSchoolDirectorEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecParentContactFromSchoolDirectorIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecParentContactFromSchoolDirectorNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecSenOrSelInterventionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecSenOrSelInterventionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecSenOrSelInterventionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecStudentServiceTeamInterventionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecStudentServiceTeamInterventionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecStudentServiceTeamInterventionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDefianceOrNonComplianceEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDefianceOrNonComplianceIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDefianceOrNonComplianceNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDisrepectingTeacherEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDisrepectingTeacherIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDisrepectingTeacherNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDisruptionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDisruptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDisruptionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentFightingPhysicalAggressionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentFightingPhysicalAggressionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentFightingPhysicalAggressionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentOtherEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentOtherIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentOtherNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentPhysicalContactAggressionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentPhysicalContactAggressionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentPhysicalContactAggressionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentVerbalAbuseDisrespectingStudentEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentVerbalAbuseDisrespectingStudentIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentVerbalAbuseDisrespectingStudentNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationAngerEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationAngerIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationAngerNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationAttentionSeekingEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationAttentionSeekingIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationAttentionSeekingNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationFrustrationEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationFrustrationIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationFrustrationNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationHabitEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationHabitIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationHabitNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationLackOfSelfContolEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationLackOfSelfContolIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationLackOfSelfContolNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationOtherEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationOtherIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationOtherNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationReactionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationReactionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationReactionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	motivationOtherContains?: InputMaybe<Scalars["String"]["input"]>;
	motivationOtherEQ?: InputMaybe<Scalars["String"]["input"]>;
	motivationOtherHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	motivationOtherHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	motivationOtherIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	motivationOtherIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	motivationOtherNEQ?: InputMaybe<Scalars["String"]["input"]>;
	motivationOtherNotContains?: InputMaybe<Scalars["String"]["input"]>;
	motivationOtherNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	motivationOtherNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	motivationOtherNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<StudentBehaviorNoteHistoryFilterInput>;
	or?: InputMaybe<Array<StudentBehaviorNoteHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export enum StudentBehaviorNoteHistoryIncidentLocation {
	Cafeteria = "cafeteria",
	Classroom = "classroom",
	Garden = "garden",
	Hallways = "hallways",
	Playground = "playground",
	SpecialtyClass = "specialty_class",
	Transportation = "transportation",
}

export type StudentBehaviorNoteHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentBehaviorNoteHistoryOrderField>;
};

export enum StudentBehaviorNoteHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentBehaviorNoteInStudentNoteCreateInput = {
	additionalComments?: InputMaybe<Scalars["String"]["input"]>;
	consequenceRecOther?: InputMaybe<Scalars["String"]["input"]>;
	incidentLocation?: InputMaybe<StudentBehaviorNoteIncidentLocation>;
	incidentOther?: InputMaybe<Scalars["String"]["input"]>;
	incidentTime?: InputMaybe<Scalars["Time"]["input"]>;
	isConsequenceRecDirectorIntervention?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecParentContactFromReporter?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecParentContactFromSchoolDirector?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecSenOrSelIntervention?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecStudentServiceTeamIntervention?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDefianceOrNonCompliance?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDisrepectingTeacher?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDisruption?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentFightingPhysicalAggression?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentPhysicalContactAggression?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentVerbalAbuseDisrespectingStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationAnger?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationAttentionSeeking?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationFrustration?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationHabit?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationLackOfSelfContol?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationReaction?: InputMaybe<Scalars["Boolean"]["input"]>;
	motivationOther?: InputMaybe<Scalars["String"]["input"]>;
};

export enum StudentBehaviorNoteIncidentLocation {
	Cafeteria = "cafeteria",
	Classroom = "classroom",
	Garden = "garden",
	Hallways = "hallways",
	Playground = "playground",
	SpecialtyClass = "specialty_class",
	Transportation = "transportation",
}

export type StudentBehaviorNoteOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentBehaviorNoteOrderField>;
};

export enum StudentBehaviorNoteOrderField {
	IncidentLocation = "INCIDENT_LOCATION",
	IncidentTime = "INCIDENT_TIME",
	IsConsequenceRecDirectorIntervention = "IS_CONSEQUENCE_REC_DIRECTOR_INTERVENTION",
	IsConsequenceRecOther = "IS_CONSEQUENCE_REC_OTHER",
	IsConsequenceRecParentContactFromReporter = "IS_CONSEQUENCE_REC_PARENT_CONTACT_FROM_REPORTER",
	IsConsequenceRecParentContactFromSchoolDirector = "IS_CONSEQUENCE_REC_PARENT_CONTACT_FROM_SCHOOL_DIRECTOR",
	IsConsequenceRecSenOrSelIntervention = "IS_CONSEQUENCE_REC_SEN_OR_SEL_INTERVENTION",
	IsConsequenceRecStudentServiceTeamIntervention = "IS_CONSEQUENCE_REC_STUDENT_SERVICE_TEAM_INTERVENTION",
	IsIncidentDefianceOrNonCompliance = "IS_INCIDENT_DEFIANCE_OR_NON_COMPLIANCE",
	IsIncidentDisrepectingTeacher = "IS_INCIDENT_DISREPECTING_TEACHER",
	IsIncidentDisruption = "IS_INCIDENT_DISRUPTION",
	IsIncidentFightingPhysicalAggression = "IS_INCIDENT_FIGHTING_PHYSICAL_AGGRESSION",
	IsIncidentOther = "IS_INCIDENT_OTHER",
	IsIncidentPhysicalContactAggression = "IS_INCIDENT_PHYSICAL_CONTACT_AGGRESSION",
	IsIncidentVerbalAbuseDisrespectingStudent = "IS_INCIDENT_VERBAL_ABUSE_DISRESPECTING_STUDENT",
	IsMotivationAnger = "IS_MOTIVATION_ANGER",
	IsMotivationAttentionSeeking = "IS_MOTIVATION_ATTENTION_SEEKING",
	IsMotivationFrustration = "IS_MOTIVATION_FRUSTRATION",
	IsMotivationHabit = "IS_MOTIVATION_HABIT",
	IsMotivationLackOfSelfContol = "IS_MOTIVATION_LACK_OF_SELF_CONTOL",
	IsMotivationOther = "IS_MOTIVATION_OTHER",
	IsMotivationReaction = "IS_MOTIVATION_REACTION",
}

export type StudentBehaviorNoteUpdateBulkInput = {
	additionalComments?: InputMaybe<Scalars["String"]["input"]>;
	clearIncidentLocation?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearIncidentTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	consequenceRecOther?: InputMaybe<Scalars["String"]["input"]>;
	incidentLocation?: InputMaybe<StudentBehaviorNoteIncidentLocation>;
	incidentOther?: InputMaybe<Scalars["String"]["input"]>;
	incidentTime?: InputMaybe<Scalars["Time"]["input"]>;
	isConsequenceRecDirectorIntervention?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecParentContactFromReporter?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecParentContactFromSchoolDirector?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecSenOrSelIntervention?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecStudentServiceTeamIntervention?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDefianceOrNonCompliance?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDisrepectingTeacher?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDisruption?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentFightingPhysicalAggression?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentPhysicalContactAggression?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentVerbalAbuseDisrespectingStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationAnger?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationAttentionSeeking?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationFrustration?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationHabit?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationLackOfSelfContol?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationReaction?: InputMaybe<Scalars["Boolean"]["input"]>;
	motivationOther?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentBehaviorNoteUpdateInput = {
	additionalComments?: InputMaybe<Scalars["String"]["input"]>;
	clearIncidentLocation?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearIncidentTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	consequenceRecOther?: InputMaybe<Scalars["String"]["input"]>;
	incidentLocation?: InputMaybe<StudentBehaviorNoteIncidentLocation>;
	incidentOther?: InputMaybe<Scalars["String"]["input"]>;
	incidentTime?: InputMaybe<Scalars["Time"]["input"]>;
	isConsequenceRecDirectorIntervention?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecParentContactFromReporter?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecParentContactFromSchoolDirector?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecSenOrSelIntervention?: InputMaybe<Scalars["Boolean"]["input"]>;
	isConsequenceRecStudentServiceTeamIntervention?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDefianceOrNonCompliance?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDisrepectingTeacher?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentDisruption?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentFightingPhysicalAggression?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentPhysicalContactAggression?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIncidentVerbalAbuseDisrespectingStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationAnger?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationAttentionSeeking?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationFrustration?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationHabit?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationLackOfSelfContol?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isMotivationReaction?: InputMaybe<Scalars["Boolean"]["input"]>;
	motivationOther?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentConnection = {
	__typename?: "StudentConnection";
	edges: Array<StudentEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentCourseSectionEnrollment = Node & {
	__typename?: "StudentCourseSectionEnrollment";
	courseSection: CourseSection;
	courseSectionID: Scalars["ID"]["output"];
	earlyEndDate: Maybe<Scalars["Date"]["output"]>;
	id: Scalars["ID"]["output"];
	lateStartDate: Maybe<Scalars["Date"]["output"]>;
	student: Student;
	studentID: Scalars["ID"]["output"];
};

export type StudentCourseSectionEnrollmentConnection = {
	__typename?: "StudentCourseSectionEnrollmentConnection";
	edges: Array<StudentCourseSectionEnrollmentEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentCourseSectionEnrollmentCreateInput = {
	courseSectionID: Scalars["ID"]["input"];
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type StudentCourseSectionEnrollmentEdge = {
	__typename?: "StudentCourseSectionEnrollmentEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentCourseSectionEnrollment;
};

export type StudentCourseSectionEnrollmentFilterInput = {
	and?: InputMaybe<Array<StudentCourseSectionEnrollmentFilterInput>>;
	courseSection?: InputMaybe<Array<CourseSectionFilterInput>>;
	courseSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	earlyEndDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	earlyEndDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	lateStartDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	lateStartDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	lateStartDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	not?: InputMaybe<StudentCourseSectionEnrollmentFilterInput>;
	or?: InputMaybe<Array<StudentCourseSectionEnrollmentFilterInput>>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentCourseSectionEnrollmentHistory = Node & {
	__typename?: "StudentCourseSectionEnrollmentHistory";
	courseSectionID: Maybe<Scalars["ID"]["output"]>;
	earlyEndDate: Maybe<Scalars["Date"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	lateStartDate: Maybe<Scalars["Date"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentCourseSectionEnrollmentHistoryConnection = {
	__typename?: "StudentCourseSectionEnrollmentHistoryConnection";
	edges: Array<StudentCourseSectionEnrollmentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentCourseSectionEnrollmentHistoryEdge = {
	__typename?: "StudentCourseSectionEnrollmentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentCourseSectionEnrollmentHistory;
};

export type StudentCourseSectionEnrollmentHistoryFilterInput = {
	and?: InputMaybe<Array<StudentCourseSectionEnrollmentHistoryFilterInput>>;
	courseSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	earlyEndDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	earlyEndDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	lateStartDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	lateStartDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	lateStartDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	not?: InputMaybe<StudentCourseSectionEnrollmentHistoryFilterInput>;
	or?: InputMaybe<Array<StudentCourseSectionEnrollmentHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentCourseSectionEnrollmentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentCourseSectionEnrollmentHistoryOrderField>;
};

export enum StudentCourseSectionEnrollmentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentCourseSectionEnrollmentInCourseSectionCreateInput = {
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type StudentCourseSectionEnrollmentInStudentCreateInput = {
	courseSectionID: Scalars["ID"]["input"];
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type StudentCourseSectionEnrollmentOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentCourseSectionEnrollmentOrderField>;
};

export enum StudentCourseSectionEnrollmentOrderField {
	EarlyEndDate = "EARLY_END_DATE",
	LateStartDate = "LATE_START_DATE",
}

export type StudentCourseSectionEnrollmentUpdateBulkInput = {
	clearEarlyEndDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearLateStartDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type StudentCourseSectionEnrollmentUpdateInput = {
	clearEarlyEndDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearLateStartDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type StudentCreateInput = {
	contracts?: InputMaybe<Array<ContractInStudentCreateInput>>;
	courseAssessmentMarks?: InputMaybe<Array<CourseAssessmentMarkInStudentCreateInput>>;
	courseAssessmentSubmissions?: InputMaybe<Array<CourseAssessmentSubmissionInStudentCreateInput>>;
	courseAttendanceRecords?: InputMaybe<Array<CourseAttendanceRecordInStudentCreateInput>>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudents?: InputMaybe<Array<EnrollmentApplicationStudentInStudentCreateInput>>;
	graduationYear?: InputMaybe<Scalars["Int"]["input"]>;
	messageTopicIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	person?: InputMaybe<PersonInStudentCreateInput>;
	personID?: InputMaybe<Scalars["ID"]["input"]>;
	primaryStudentNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	relationshipIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	relationships?: InputMaybe<Array<RelationshipInStudentCreateInput>>;
	reportCards?: InputMaybe<Array<ReportCardInStudentCreateInput>>;
	schoolAttendanceRecords?: InputMaybe<Array<SchoolAttendanceRecordInStudentCreateInput>>;
	secondaryStudentNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentAcademicTermEnrollments?: InputMaybe<Array<StudentAcademicTermEnrollmentInStudentCreateInput>>;
	studentCourseSectionEnrollments?: InputMaybe<Array<StudentCourseSectionEnrollmentInStudentCreateInput>>;
	studentDataConsentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentDataConsents?: InputMaybe<Array<StudentDataConsentInStudentCreateInput>>;
	studentEnrollmentIntents?: InputMaybe<Array<StudentEnrollmentIntentInStudentCreateInput>>;
	studentHomeRoomSectionEnrollments?: InputMaybe<Array<StudentHomeRoomSectionEnrollmentInStudentCreateInput>>;
	studentInformationVerificationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalConditionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalConditions?: InputMaybe<Array<StudentMedicalConditionInStudentCreateInput>>;
	studentMedicalContactIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalContacts?: InputMaybe<Array<StudentMedicalContactInStudentCreateInput>>;
	studentMedicalEventIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalEvents?: InputMaybe<Array<StudentMedicalEventInStudentCreateInput>>;
	studentMedicalProfile?: InputMaybe<StudentMedicalProfileInStudentCreateInput>;
	studentOtcMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentOtcMedications?: InputMaybe<Array<StudentOTCMedicationInStudentCreateInput>>;
	studentPrescriptionMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentPrescriptionMedications?: InputMaybe<Array<StudentPrescriptionMedicationInStudentCreateInput>>;
	studentVaccinationRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentVaccinationRecords?: InputMaybe<Array<StudentVaccinationRecordInStudentCreateInput>>;
};

export type StudentDataConsent = Node & {
	__typename?: "StudentDataConsent";
	allowBirthdayInCalendar: Scalars["Boolean"]["output"];
	allowPublishStudentWorkGeneral: Scalars["Boolean"]["output"];
	allowPublishVisualMediaOfGuardianForPromotion: Scalars["Boolean"]["output"];
	allowPublishVisualMediaOfStudentForPromotion: Scalars["Boolean"]["output"];
	allowPublishVisualMediaOfStudentGeneral: Scalars["Boolean"]["output"];
	allowSendCalendarEvents: Scalars["Boolean"]["output"];
	allowSendNewsletters: Scalars["Boolean"]["output"];
	allowShareInformationWithIbOrganization: Scalars["Boolean"]["output"];
	allowShareInformationWithOnlinePlatforms: Scalars["Boolean"]["output"];
	allowShareInformationWithPearsonEdexcel: Scalars["Boolean"]["output"];
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	student: Student;
	studentID: Scalars["ID"]["output"];
	updatedAt: Scalars["Time"]["output"];
};

export type StudentDataConsentConnection = {
	__typename?: "StudentDataConsentConnection";
	edges: Array<StudentDataConsentEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentDataConsentCreateInput = {
	allowBirthdayInCalendar?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishStudentWorkGeneral?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfGuardianForPromotion?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentForPromotion?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentGeneral?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendCalendarEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendNewsletters?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithIbOrganization?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithOnlinePlatforms?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithPearsonEdexcel?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type StudentDataConsentEdge = {
	__typename?: "StudentDataConsentEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentDataConsent;
};

export type StudentDataConsentFilterInput = {
	allowBirthdayInCalendarEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowBirthdayInCalendarNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishStudentWorkGeneralEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishStudentWorkGeneralNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfGuardianForPromotionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfGuardianForPromotionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentForPromotionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentForPromotionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentGeneralEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentGeneralNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendCalendarEventsEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendCalendarEventsNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendNewslettersEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendNewslettersNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithIbOrganizationEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithIbOrganizationNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithOnlinePlatformsEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithOnlinePlatformsNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithPearsonEdexcelEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithPearsonEdexcelNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	and?: InputMaybe<Array<StudentDataConsentFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentDataConsentFilterInput>;
	or?: InputMaybe<Array<StudentDataConsentFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	updatedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	updatedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
};

export type StudentDataConsentHistory = Node & {
	__typename?: "StudentDataConsentHistory";
	allowBirthdayInCalendar: Maybe<Scalars["Boolean"]["output"]>;
	allowPublishStudentWorkGeneral: Maybe<Scalars["Boolean"]["output"]>;
	allowPublishVisualMediaOfGuardianForPromotion: Maybe<Scalars["Boolean"]["output"]>;
	allowPublishVisualMediaOfStudentForPromotion: Maybe<Scalars["Boolean"]["output"]>;
	allowPublishVisualMediaOfStudentGeneral: Maybe<Scalars["Boolean"]["output"]>;
	allowSendCalendarEvents: Maybe<Scalars["Boolean"]["output"]>;
	allowSendNewsletters: Maybe<Scalars["Boolean"]["output"]>;
	allowShareInformationWithIbOrganization: Maybe<Scalars["Boolean"]["output"]>;
	allowShareInformationWithOnlinePlatforms: Maybe<Scalars["Boolean"]["output"]>;
	allowShareInformationWithPearsonEdexcel: Maybe<Scalars["Boolean"]["output"]>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
	updatedAt: Maybe<Scalars["Time"]["output"]>;
};

export type StudentDataConsentHistoryConnection = {
	__typename?: "StudentDataConsentHistoryConnection";
	edges: Array<StudentDataConsentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentDataConsentHistoryEdge = {
	__typename?: "StudentDataConsentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentDataConsentHistory;
};

export type StudentDataConsentHistoryFilterInput = {
	allowBirthdayInCalendarEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowBirthdayInCalendarIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowBirthdayInCalendarNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishStudentWorkGeneralEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishStudentWorkGeneralIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishStudentWorkGeneralNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfGuardianForPromotionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfGuardianForPromotionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfGuardianForPromotionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentForPromotionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentForPromotionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentForPromotionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentGeneralEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentGeneralIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentGeneralNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendCalendarEventsEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendCalendarEventsIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendCalendarEventsNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendNewslettersEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendNewslettersIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendNewslettersNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithIbOrganizationEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithIbOrganizationIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithIbOrganizationNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithOnlinePlatformsEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithOnlinePlatformsIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithOnlinePlatformsNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithPearsonEdexcelEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithPearsonEdexcelIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithPearsonEdexcelNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	and?: InputMaybe<Array<StudentDataConsentHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentDataConsentHistoryFilterInput>;
	or?: InputMaybe<Array<StudentDataConsentHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	updatedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	updatedAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	updatedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
};

export type StudentDataConsentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentDataConsentHistoryOrderField>;
};

export enum StudentDataConsentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentDataConsentInAuthorCreateInput = {
	allowBirthdayInCalendar?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishStudentWorkGeneral?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfGuardianForPromotion?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentForPromotion?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentGeneral?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendCalendarEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendNewsletters?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithIbOrganization?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithOnlinePlatforms?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithPearsonEdexcel?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type StudentDataConsentInStudentCreateInput = {
	allowBirthdayInCalendar?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishStudentWorkGeneral?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfGuardianForPromotion?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentForPromotion?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentGeneral?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendCalendarEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendNewsletters?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithIbOrganization?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithOnlinePlatforms?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithPearsonEdexcel?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type StudentDataConsentOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentDataConsentOrderField>;
};

export enum StudentDataConsentOrderField {
	AllowBirthdayInCalendar = "ALLOW_BIRTHDAY_IN_CALENDAR",
	AllowPublishStudentWorkGeneral = "ALLOW_PUBLISH_STUDENT_WORK_GENERAL",
	AllowPublishVisualMediaOfGuardianForPromotion = "ALLOW_PUBLISH_VISUAL_MEDIA_OF_GUARDIAN_FOR_PROMOTION",
	AllowPublishVisualMediaOfStudentForPromotion = "ALLOW_PUBLISH_VISUAL_MEDIA_OF_STUDENT_FOR_PROMOTION",
	AllowPublishVisualMediaOfStudentGeneral = "ALLOW_PUBLISH_VISUAL_MEDIA_OF_STUDENT_GENERAL",
	AllowSendCalendarEvents = "ALLOW_SEND_CALENDAR_EVENTS",
	AllowSendNewsletters = "ALLOW_SEND_NEWSLETTERS",
	AllowShareInformationWithIbOrganization = "ALLOW_SHARE_INFORMATION_WITH_IB_ORGANIZATION",
	AllowShareInformationWithOnlinePlatforms = "ALLOW_SHARE_INFORMATION_WITH_ONLINE_PLATFORMS",
	AllowShareInformationWithPearsonEdexcel = "ALLOW_SHARE_INFORMATION_WITH_PEARSON_EDEXCEL",
	CreatedAt = "CREATED_AT",
	UpdatedAt = "UPDATED_AT",
}

export type StudentDataConsentUpdateBulkInput = {
	allowBirthdayInCalendar?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishStudentWorkGeneral?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfGuardianForPromotion?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentForPromotion?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentGeneral?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendCalendarEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendNewsletters?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithIbOrganization?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithOnlinePlatforms?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithPearsonEdexcel?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentDataConsentUpdateInput = {
	allowBirthdayInCalendar?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishStudentWorkGeneral?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfGuardianForPromotion?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentForPromotion?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowPublishVisualMediaOfStudentGeneral?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendCalendarEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowSendNewsletters?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithIbOrganization?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithOnlinePlatforms?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowShareInformationWithPearsonEdexcel?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentEdge = {
	__typename?: "StudentEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Student;
};

export type StudentEnrollmentApplication = Node & {
	__typename?: "StudentEnrollmentApplication";
	enrollmentApplicationStudent: EnrollmentApplicationStudent;
	enrollmentApplicationStudentID: Scalars["ID"]["output"];
	id: Scalars["ID"]["output"];
	status: StudentEnrollmentApplicationStatus;
	statusUpdatedAt: Scalars["Time"]["output"];
};

export type StudentEnrollmentApplicationConnection = {
	__typename?: "StudentEnrollmentApplicationConnection";
	edges: Array<StudentEnrollmentApplicationEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentEnrollmentApplicationCreateInput = {
	enrollmentApplicationStudent?: InputMaybe<EnrollmentApplicationStudentInStudentEnrollmentApplicationCreateInput>;
	enrollmentApplicationStudentID?: InputMaybe<Scalars["ID"]["input"]>;
	status?: InputMaybe<StudentEnrollmentApplicationStatus>;
};

export type StudentEnrollmentApplicationEdge = {
	__typename?: "StudentEnrollmentApplicationEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentEnrollmentApplication;
};

export type StudentEnrollmentApplicationFilterInput = {
	and?: InputMaybe<Array<StudentEnrollmentApplicationFilterInput>>;
	enrollmentApplicationStudent?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	enrollmentApplicationStudentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationStudentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationStudentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentEnrollmentApplicationFilterInput>;
	or?: InputMaybe<Array<StudentEnrollmentApplicationFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	statusEQ?: InputMaybe<StudentEnrollmentApplicationStatus>;
	statusIn?: InputMaybe<Array<StudentEnrollmentApplicationStatus>>;
	statusNEQ?: InputMaybe<StudentEnrollmentApplicationStatus>;
	statusNotIn?: InputMaybe<Array<StudentEnrollmentApplicationStatus>>;
	statusUpdatedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	statusUpdatedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	statusUpdatedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	statusUpdatedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	statusUpdatedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	statusUpdatedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	statusUpdatedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	statusUpdatedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
};

export type StudentEnrollmentApplicationHistory = Node & {
	__typename?: "StudentEnrollmentApplicationHistory";
	enrollmentApplicationStudentID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
	status: Maybe<StudentEnrollmentApplicationHistoryStatus>;
	statusUpdatedAt: Maybe<Scalars["Time"]["output"]>;
};

export type StudentEnrollmentApplicationHistoryConnection = {
	__typename?: "StudentEnrollmentApplicationHistoryConnection";
	edges: Array<StudentEnrollmentApplicationHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentEnrollmentApplicationHistoryEdge = {
	__typename?: "StudentEnrollmentApplicationHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentEnrollmentApplicationHistory;
};

export type StudentEnrollmentApplicationHistoryFilterInput = {
	and?: InputMaybe<Array<StudentEnrollmentApplicationHistoryFilterInput>>;
	enrollmentApplicationStudentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationStudentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationStudentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	enrollmentApplicationStudentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentEnrollmentApplicationHistoryFilterInput>;
	or?: InputMaybe<Array<StudentEnrollmentApplicationHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	statusEQ?: InputMaybe<StudentEnrollmentApplicationHistoryStatus>;
	statusIn?: InputMaybe<Array<StudentEnrollmentApplicationHistoryStatus>>;
	statusIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	statusNEQ?: InputMaybe<StudentEnrollmentApplicationHistoryStatus>;
	statusNotIn?: InputMaybe<Array<StudentEnrollmentApplicationHistoryStatus>>;
	statusUpdatedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	statusUpdatedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	statusUpdatedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	statusUpdatedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	statusUpdatedAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	statusUpdatedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	statusUpdatedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	statusUpdatedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	statusUpdatedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
};

export type StudentEnrollmentApplicationHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentEnrollmentApplicationHistoryOrderField>;
};

export enum StudentEnrollmentApplicationHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export enum StudentEnrollmentApplicationHistoryStatus {
	Approved = "approved",
	Pending = "pending",
	Rejected = "rejected",
}

export type StudentEnrollmentApplicationInEnrollmentApplicationStudentCreateInput = {
	status?: InputMaybe<StudentEnrollmentApplicationStatus>;
};

export type StudentEnrollmentApplicationOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentEnrollmentApplicationOrderField>;
};

export enum StudentEnrollmentApplicationOrderField {
	Status = "STATUS",
	StatusUpdatedAt = "STATUS_UPDATED_AT",
}

export enum StudentEnrollmentApplicationStatus {
	Approved = "approved",
	Pending = "pending",
	Rejected = "rejected",
}

export type StudentEnrollmentApplicationUpdateBulkInput = {
	status?: InputMaybe<StudentEnrollmentApplicationStatus>;
};

export type StudentEnrollmentApplicationUpdateInput = {
	status?: InputMaybe<StudentEnrollmentApplicationStatus>;
};

export type StudentEnrollmentIntent = Node & {
	__typename?: "StudentEnrollmentIntent";
	academicYear: AcademicYear;
	academicYearID: Scalars["ID"]["output"];
	createdAt: Scalars["Time"]["output"];
	declineReason: Maybe<StudentEnrollmentIntentDeclineReason>;
	declineReasonDescription: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	isEnrolling: Scalars["Boolean"]["output"];
	isInterestedInMealPlan: Scalars["Boolean"]["output"];
	student: Student;
	studentID: Scalars["ID"]["output"];
};

export type StudentEnrollmentIntentConnection = {
	__typename?: "StudentEnrollmentIntentConnection";
	edges: Array<StudentEnrollmentIntentEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentEnrollmentIntentCreateInput = {
	academicYearID: Scalars["ID"]["input"];
	declineReason?: InputMaybe<StudentEnrollmentIntentDeclineReason>;
	declineReasonDescription?: InputMaybe<Scalars["String"]["input"]>;
	isEnrolling?: InputMaybe<Scalars["Boolean"]["input"]>;
	isInterestedInMealPlan?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export enum StudentEnrollmentIntentDeclineReason {
	Academic = "academic",
	Administrative = "administrative",
	Financial = "financial",
	Graduating = "graduating",
	Health = "health",
	Other = "other",
	Relocation = "relocation",
	Social = "social",
}

export type StudentEnrollmentIntentEdge = {
	__typename?: "StudentEnrollmentIntentEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentEnrollmentIntent;
};

export type StudentEnrollmentIntentFilterInput = {
	academicYear?: InputMaybe<Array<AcademicYearFilterInput>>;
	academicYearIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicYearIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	academicYearIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicYearIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	and?: InputMaybe<Array<StudentEnrollmentIntentFilterInput>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	declineReasonDescriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	declineReasonDescriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	declineReasonDescriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	declineReasonDescriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	declineReasonDescriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	declineReasonDescriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	declineReasonDescriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	declineReasonDescriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	declineReasonDescriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	declineReasonDescriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	declineReasonEQ?: InputMaybe<StudentEnrollmentIntentDeclineReason>;
	declineReasonIn?: InputMaybe<Array<StudentEnrollmentIntentDeclineReason>>;
	declineReasonIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	declineReasonNEQ?: InputMaybe<StudentEnrollmentIntentDeclineReason>;
	declineReasonNotIn?: InputMaybe<Array<StudentEnrollmentIntentDeclineReason>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isEnrollingEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEnrollingNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isInterestedInMealPlanEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isInterestedInMealPlanNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<StudentEnrollmentIntentFilterInput>;
	or?: InputMaybe<Array<StudentEnrollmentIntentFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentEnrollmentIntentHistory = Node & {
	__typename?: "StudentEnrollmentIntentHistory";
	academicYearID: Maybe<Scalars["ID"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	declineReason: Maybe<StudentEnrollmentIntentHistoryDeclineReason>;
	declineReasonDescription: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isEnrolling: Maybe<Scalars["Boolean"]["output"]>;
	isInterestedInMealPlan: Maybe<Scalars["Boolean"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentEnrollmentIntentHistoryConnection = {
	__typename?: "StudentEnrollmentIntentHistoryConnection";
	edges: Array<StudentEnrollmentIntentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export enum StudentEnrollmentIntentHistoryDeclineReason {
	Academic = "academic",
	Administrative = "administrative",
	Financial = "financial",
	Graduating = "graduating",
	Health = "health",
	Other = "other",
	Relocation = "relocation",
	Social = "social",
}

export type StudentEnrollmentIntentHistoryEdge = {
	__typename?: "StudentEnrollmentIntentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentEnrollmentIntentHistory;
};

export type StudentEnrollmentIntentHistoryFilterInput = {
	academicYearIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicYearIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	academicYearIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	academicYearIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	academicYearIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	and?: InputMaybe<Array<StudentEnrollmentIntentHistoryFilterInput>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	declineReasonDescriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	declineReasonDescriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	declineReasonDescriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	declineReasonDescriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	declineReasonDescriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	declineReasonDescriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	declineReasonDescriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	declineReasonDescriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	declineReasonDescriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	declineReasonDescriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	declineReasonDescriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	declineReasonEQ?: InputMaybe<StudentEnrollmentIntentHistoryDeclineReason>;
	declineReasonIn?: InputMaybe<Array<StudentEnrollmentIntentHistoryDeclineReason>>;
	declineReasonIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	declineReasonNEQ?: InputMaybe<StudentEnrollmentIntentHistoryDeclineReason>;
	declineReasonNotIn?: InputMaybe<Array<StudentEnrollmentIntentHistoryDeclineReason>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isEnrollingEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEnrollingIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isEnrollingNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isInterestedInMealPlanEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isInterestedInMealPlanIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isInterestedInMealPlanNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<StudentEnrollmentIntentHistoryFilterInput>;
	or?: InputMaybe<Array<StudentEnrollmentIntentHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentEnrollmentIntentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentEnrollmentIntentHistoryOrderField>;
};

export enum StudentEnrollmentIntentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentEnrollmentIntentInAcademicYearCreateInput = {
	declineReason?: InputMaybe<StudentEnrollmentIntentDeclineReason>;
	declineReasonDescription?: InputMaybe<Scalars["String"]["input"]>;
	isEnrolling?: InputMaybe<Scalars["Boolean"]["input"]>;
	isInterestedInMealPlan?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type StudentEnrollmentIntentInStudentCreateInput = {
	academicYearID: Scalars["ID"]["input"];
	declineReason?: InputMaybe<StudentEnrollmentIntentDeclineReason>;
	declineReasonDescription?: InputMaybe<Scalars["String"]["input"]>;
	isEnrolling?: InputMaybe<Scalars["Boolean"]["input"]>;
	isInterestedInMealPlan?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type StudentEnrollmentIntentOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentEnrollmentIntentOrderField>;
};

export enum StudentEnrollmentIntentOrderField {
	CreatedAt = "CREATED_AT",
	DeclineReason = "DECLINE_REASON",
	IsEnrolling = "IS_ENROLLING",
	IsInterestedInMealPlan = "IS_INTERESTED_IN_MEAL_PLAN",
}

export type StudentEnrollmentIntentUpdateBulkInput = {
	clearDeclineReason?: InputMaybe<Scalars["Boolean"]["input"]>;
	declineReason?: InputMaybe<StudentEnrollmentIntentDeclineReason>;
	declineReasonDescription?: InputMaybe<Scalars["String"]["input"]>;
	isEnrolling?: InputMaybe<Scalars["Boolean"]["input"]>;
	isInterestedInMealPlan?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type StudentEnrollmentIntentUpdateInput = {
	clearDeclineReason?: InputMaybe<Scalars["Boolean"]["input"]>;
	declineReason?: InputMaybe<StudentEnrollmentIntentDeclineReason>;
	declineReasonDescription?: InputMaybe<Scalars["String"]["input"]>;
	isEnrolling?: InputMaybe<Scalars["Boolean"]["input"]>;
	isInterestedInMealPlan?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type StudentFilterInput = {
	and?: InputMaybe<Array<StudentFilterInput>>;
	contracts?: InputMaybe<Array<ContractFilterInput>>;
	courseAssessmentMarks?: InputMaybe<Array<CourseAssessmentMarkFilterInput>>;
	courseAssessmentSubmissions?: InputMaybe<Array<CourseAssessmentSubmissionFilterInput>>;
	courseAttendanceRecords?: InputMaybe<Array<CourseAttendanceRecordFilterInput>>;
	enrollmentApplicationStudents?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput>>;
	graduationYearEQ?: InputMaybe<Scalars["Int"]["input"]>;
	graduationYearGT?: InputMaybe<Scalars["Int"]["input"]>;
	graduationYearGTE?: InputMaybe<Scalars["Int"]["input"]>;
	graduationYearIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	graduationYearIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	graduationYearLT?: InputMaybe<Scalars["Int"]["input"]>;
	graduationYearLTE?: InputMaybe<Scalars["Int"]["input"]>;
	graduationYearNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	graduationYearNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	hasContracts?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCourseAssessmentMarks?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCourseAssessmentSubmissions?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCourseAttendanceRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMessageTopics?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPrimaryStudentNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasRelationships?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasReportCards?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSchoolAttendanceRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSecondaryStudentNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentAcademicTermEnrollments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentCourseSectionEnrollments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentDataConsents?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentEnrollmentIntents?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentHomeRoomSectionEnrollments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentInformationVerifications?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentMedicalConditions?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentMedicalContacts?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentMedicalEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentMedicalProfile?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentOTCMedications?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentPrescriptionMedications?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentVaccinationRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageTopics?: InputMaybe<Array<MessageTopicFilterInput>>;
	not?: InputMaybe<StudentFilterInput>;
	or?: InputMaybe<Array<StudentFilterInput>>;
	person?: InputMaybe<Array<PersonFilterInput>>;
	personIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	primaryStudentNotes?: InputMaybe<Array<StudentNoteFilterInput>>;
	relationships?: InputMaybe<Array<RelationshipFilterInput>>;
	reportCards?: InputMaybe<Array<ReportCardFilterInput>>;
	schoolAttendanceRecords?: InputMaybe<Array<SchoolAttendanceRecordFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	secondaryStudentNotes?: InputMaybe<Array<StudentNoteFilterInput>>;
	studentAcademicTermEnrollments?: InputMaybe<Array<StudentAcademicTermEnrollmentFilterInput>>;
	studentCourseSectionEnrollments?: InputMaybe<Array<StudentCourseSectionEnrollmentFilterInput>>;
	studentDataConsents?: InputMaybe<Array<StudentDataConsentFilterInput>>;
	studentEnrollmentIntents?: InputMaybe<Array<StudentEnrollmentIntentFilterInput>>;
	studentHomeRoomSectionEnrollments?: InputMaybe<Array<StudentHomeRoomSectionEnrollmentFilterInput>>;
	studentInformationVerifications?: InputMaybe<Array<StudentInformationVerificationFilterInput>>;
	studentMedicalConditions?: InputMaybe<Array<StudentMedicalConditionFilterInput>>;
	studentMedicalContacts?: InputMaybe<Array<StudentMedicalContactFilterInput>>;
	studentMedicalEvents?: InputMaybe<Array<StudentMedicalEventFilterInput>>;
	studentMedicalProfile?: InputMaybe<Array<StudentMedicalProfileFilterInput>>;
	studentOtcMedications?: InputMaybe<Array<StudentOTCMedicationFilterInput>>;
	studentPrescriptionMedications?: InputMaybe<Array<StudentPrescriptionMedicationFilterInput>>;
	studentVaccinationRecords?: InputMaybe<Array<StudentVaccinationRecordFilterInput>>;
};

export type StudentHealthNote = Node & {
	__typename?: "StudentHealthNote";
	body: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	studentNote: StudentNote;
	studentNoteID: Scalars["ID"]["output"];
};

export type StudentHealthNoteConnection = {
	__typename?: "StudentHealthNoteConnection";
	edges: Array<StudentHealthNoteEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentHealthNoteCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	studentNote?: InputMaybe<StudentNoteInStudentHealthNoteCreateInput>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentHealthNoteEdge = {
	__typename?: "StudentHealthNoteEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentHealthNote;
};

export type StudentHealthNoteFilterInput = {
	and?: InputMaybe<Array<StudentHealthNoteFilterInput>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentHealthNoteFilterInput>;
	or?: InputMaybe<Array<StudentHealthNoteFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentNote?: InputMaybe<Array<StudentNoteFilterInput>>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentHealthNoteHistory = Node & {
	__typename?: "StudentHealthNoteHistory";
	body: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
	studentNoteID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentHealthNoteHistoryConnection = {
	__typename?: "StudentHealthNoteHistoryConnection";
	edges: Array<StudentHealthNoteHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentHealthNoteHistoryEdge = {
	__typename?: "StudentHealthNoteHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentHealthNoteHistory;
};

export type StudentHealthNoteHistoryFilterInput = {
	and?: InputMaybe<Array<StudentHealthNoteHistoryFilterInput>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentHealthNoteHistoryFilterInput>;
	or?: InputMaybe<Array<StudentHealthNoteHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentHealthNoteHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentHealthNoteHistoryOrderField>;
};

export enum StudentHealthNoteHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentHealthNoteInStudentNoteCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentHealthNoteOrder = {
	direction: OrderDirection;
};

export type StudentHealthNoteUpdateBulkInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentHealthNoteUpdateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentHistory = Node & {
	__typename?: "StudentHistory";
	graduationYear: Maybe<Scalars["Int"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
	personID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentHistoryConnection = {
	__typename?: "StudentHistoryConnection";
	edges: Array<StudentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentHistoryEdge = {
	__typename?: "StudentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentHistory;
};

export type StudentHistoryFilterInput = {
	and?: InputMaybe<Array<StudentHistoryFilterInput>>;
	graduationYearEQ?: InputMaybe<Scalars["Int"]["input"]>;
	graduationYearGT?: InputMaybe<Scalars["Int"]["input"]>;
	graduationYearGTE?: InputMaybe<Scalars["Int"]["input"]>;
	graduationYearIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	graduationYearIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	graduationYearLT?: InputMaybe<Scalars["Int"]["input"]>;
	graduationYearLTE?: InputMaybe<Scalars["Int"]["input"]>;
	graduationYearNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	graduationYearNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentHistoryFilterInput>;
	or?: InputMaybe<Array<StudentHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	personIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	personIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentHistoryOrderField>;
};

export enum StudentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentHomeRoomSectionEnrollment = Node & {
	__typename?: "StudentHomeRoomSectionEnrollment";
	earlyEndDate: Maybe<Scalars["Date"]["output"]>;
	homeRoomSection: HomeRoomSection;
	homeRoomSectionID: Scalars["ID"]["output"];
	id: Scalars["ID"]["output"];
	lateStartDate: Maybe<Scalars["Date"]["output"]>;
	student: Student;
	studentID: Scalars["ID"]["output"];
};

export type StudentHomeRoomSectionEnrollmentConnection = {
	__typename?: "StudentHomeRoomSectionEnrollmentConnection";
	edges: Array<StudentHomeRoomSectionEnrollmentEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentHomeRoomSectionEnrollmentCreateInput = {
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	homeRoomSectionID: Scalars["ID"]["input"];
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type StudentHomeRoomSectionEnrollmentEdge = {
	__typename?: "StudentHomeRoomSectionEnrollmentEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentHomeRoomSectionEnrollment;
};

export type StudentHomeRoomSectionEnrollmentFilterInput = {
	and?: InputMaybe<Array<StudentHomeRoomSectionEnrollmentFilterInput>>;
	earlyEndDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	earlyEndDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	homeRoomSection?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
	homeRoomSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	lateStartDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	lateStartDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	lateStartDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	not?: InputMaybe<StudentHomeRoomSectionEnrollmentFilterInput>;
	or?: InputMaybe<Array<StudentHomeRoomSectionEnrollmentFilterInput>>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentHomeRoomSectionEnrollmentHistory = Node & {
	__typename?: "StudentHomeRoomSectionEnrollmentHistory";
	earlyEndDate: Maybe<Scalars["Date"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	homeRoomSectionID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	lateStartDate: Maybe<Scalars["Date"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentHomeRoomSectionEnrollmentHistoryConnection = {
	__typename?: "StudentHomeRoomSectionEnrollmentHistoryConnection";
	edges: Array<StudentHomeRoomSectionEnrollmentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentHomeRoomSectionEnrollmentHistoryEdge = {
	__typename?: "StudentHomeRoomSectionEnrollmentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentHomeRoomSectionEnrollmentHistory;
};

export type StudentHomeRoomSectionEnrollmentHistoryFilterInput = {
	and?: InputMaybe<Array<StudentHomeRoomSectionEnrollmentHistoryFilterInput>>;
	earlyEndDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	earlyEndDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoomSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	lateStartDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	lateStartDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	lateStartDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	not?: InputMaybe<StudentHomeRoomSectionEnrollmentHistoryFilterInput>;
	or?: InputMaybe<Array<StudentHomeRoomSectionEnrollmentHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentHomeRoomSectionEnrollmentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentHomeRoomSectionEnrollmentHistoryOrderField>;
};

export enum StudentHomeRoomSectionEnrollmentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentHomeRoomSectionEnrollmentInHomeRoomSectionCreateInput = {
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type StudentHomeRoomSectionEnrollmentInStudentCreateInput = {
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	homeRoomSectionID: Scalars["ID"]["input"];
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type StudentHomeRoomSectionEnrollmentOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentHomeRoomSectionEnrollmentOrderField>;
};

export enum StudentHomeRoomSectionEnrollmentOrderField {
	EarlyEndDate = "EARLY_END_DATE",
	LateStartDate = "LATE_START_DATE",
}

export type StudentHomeRoomSectionEnrollmentUpdateBulkInput = {
	clearEarlyEndDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearLateStartDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type StudentHomeRoomSectionEnrollmentUpdateInput = {
	clearEarlyEndDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearLateStartDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type StudentInPersonCreateInput = {
	contracts?: InputMaybe<Array<ContractInStudentCreateInput>>;
	courseAssessmentMarks?: InputMaybe<Array<CourseAssessmentMarkInStudentCreateInput>>;
	courseAssessmentSubmissions?: InputMaybe<Array<CourseAssessmentSubmissionInStudentCreateInput>>;
	courseAttendanceRecords?: InputMaybe<Array<CourseAttendanceRecordInStudentCreateInput>>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudents?: InputMaybe<Array<EnrollmentApplicationStudentInStudentCreateInput>>;
	graduationYear?: InputMaybe<Scalars["Int"]["input"]>;
	messageTopicIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	primaryStudentNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	relationshipIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	relationships?: InputMaybe<Array<RelationshipInStudentCreateInput>>;
	reportCards?: InputMaybe<Array<ReportCardInStudentCreateInput>>;
	schoolAttendanceRecords?: InputMaybe<Array<SchoolAttendanceRecordInStudentCreateInput>>;
	secondaryStudentNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentAcademicTermEnrollments?: InputMaybe<Array<StudentAcademicTermEnrollmentInStudentCreateInput>>;
	studentCourseSectionEnrollments?: InputMaybe<Array<StudentCourseSectionEnrollmentInStudentCreateInput>>;
	studentDataConsentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentDataConsents?: InputMaybe<Array<StudentDataConsentInStudentCreateInput>>;
	studentEnrollmentIntents?: InputMaybe<Array<StudentEnrollmentIntentInStudentCreateInput>>;
	studentHomeRoomSectionEnrollments?: InputMaybe<Array<StudentHomeRoomSectionEnrollmentInStudentCreateInput>>;
	studentInformationVerificationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalConditionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalConditions?: InputMaybe<Array<StudentMedicalConditionInStudentCreateInput>>;
	studentMedicalContactIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalContacts?: InputMaybe<Array<StudentMedicalContactInStudentCreateInput>>;
	studentMedicalEventIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalEvents?: InputMaybe<Array<StudentMedicalEventInStudentCreateInput>>;
	studentMedicalProfile?: InputMaybe<StudentMedicalProfileInStudentCreateInput>;
	studentOtcMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentOtcMedications?: InputMaybe<Array<StudentOTCMedicationInStudentCreateInput>>;
	studentPrescriptionMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentPrescriptionMedications?: InputMaybe<Array<StudentPrescriptionMedicationInStudentCreateInput>>;
	studentVaccinationRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentVaccinationRecords?: InputMaybe<Array<StudentVaccinationRecordInStudentCreateInput>>;
};

export type StudentInStudentMedicalProfileCreateInput = {
	contracts?: InputMaybe<Array<ContractInStudentCreateInput>>;
	courseAssessmentMarks?: InputMaybe<Array<CourseAssessmentMarkInStudentCreateInput>>;
	courseAssessmentSubmissions?: InputMaybe<Array<CourseAssessmentSubmissionInStudentCreateInput>>;
	courseAttendanceRecords?: InputMaybe<Array<CourseAttendanceRecordInStudentCreateInput>>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	enrollmentApplicationStudents?: InputMaybe<Array<EnrollmentApplicationStudentInStudentCreateInput>>;
	graduationYear?: InputMaybe<Scalars["Int"]["input"]>;
	messageTopicIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	person?: InputMaybe<PersonInStudentCreateInput>;
	personID?: InputMaybe<Scalars["ID"]["input"]>;
	primaryStudentNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	relationshipIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	relationships?: InputMaybe<Array<RelationshipInStudentCreateInput>>;
	reportCards?: InputMaybe<Array<ReportCardInStudentCreateInput>>;
	schoolAttendanceRecords?: InputMaybe<Array<SchoolAttendanceRecordInStudentCreateInput>>;
	secondaryStudentNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentAcademicTermEnrollments?: InputMaybe<Array<StudentAcademicTermEnrollmentInStudentCreateInput>>;
	studentCourseSectionEnrollments?: InputMaybe<Array<StudentCourseSectionEnrollmentInStudentCreateInput>>;
	studentDataConsentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentDataConsents?: InputMaybe<Array<StudentDataConsentInStudentCreateInput>>;
	studentEnrollmentIntents?: InputMaybe<Array<StudentEnrollmentIntentInStudentCreateInput>>;
	studentHomeRoomSectionEnrollments?: InputMaybe<Array<StudentHomeRoomSectionEnrollmentInStudentCreateInput>>;
	studentInformationVerificationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalConditionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalConditions?: InputMaybe<Array<StudentMedicalConditionInStudentCreateInput>>;
	studentMedicalContactIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalContacts?: InputMaybe<Array<StudentMedicalContactInStudentCreateInput>>;
	studentMedicalEventIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalEvents?: InputMaybe<Array<StudentMedicalEventInStudentCreateInput>>;
	studentOtcMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentOtcMedications?: InputMaybe<Array<StudentOTCMedicationInStudentCreateInput>>;
	studentPrescriptionMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentPrescriptionMedications?: InputMaybe<Array<StudentPrescriptionMedicationInStudentCreateInput>>;
	studentVaccinationRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentVaccinationRecords?: InputMaybe<Array<StudentVaccinationRecordInStudentCreateInput>>;
};

export type StudentIncidentNote = Node & {
	__typename?: "StudentIncidentNote";
	actionsTaken: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	incidentLocation: Maybe<StudentIncidentNoteIncidentLocation>;
	incidentTime: Maybe<Scalars["Time"]["output"]>;
	studentNote: StudentNote;
	studentNoteID: Scalars["ID"]["output"];
	suggestionsForFuture: Scalars["String"]["output"];
};

export type StudentIncidentNoteConnection = {
	__typename?: "StudentIncidentNoteConnection";
	edges: Array<StudentIncidentNoteEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentIncidentNoteCreateInput = {
	actionsTaken?: InputMaybe<Scalars["String"]["input"]>;
	incidentLocation?: InputMaybe<StudentIncidentNoteIncidentLocation>;
	incidentTime?: InputMaybe<Scalars["Time"]["input"]>;
	studentNote?: InputMaybe<StudentNoteInStudentIncidentNoteCreateInput>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
	suggestionsForFuture?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentIncidentNoteEdge = {
	__typename?: "StudentIncidentNoteEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentIncidentNote;
};

export type StudentIncidentNoteFilterInput = {
	actionsTakenContains?: InputMaybe<Scalars["String"]["input"]>;
	actionsTakenEQ?: InputMaybe<Scalars["String"]["input"]>;
	actionsTakenHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	actionsTakenHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	actionsTakenIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	actionsTakenNEQ?: InputMaybe<Scalars["String"]["input"]>;
	actionsTakenNotContains?: InputMaybe<Scalars["String"]["input"]>;
	actionsTakenNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	actionsTakenNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	actionsTakenNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<StudentIncidentNoteFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	incidentLocationEQ?: InputMaybe<StudentIncidentNoteIncidentLocation>;
	incidentLocationIn?: InputMaybe<Array<StudentIncidentNoteIncidentLocation>>;
	incidentLocationIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	incidentLocationNEQ?: InputMaybe<StudentIncidentNoteIncidentLocation>;
	incidentLocationNotIn?: InputMaybe<Array<StudentIncidentNoteIncidentLocation>>;
	incidentTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	incidentTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	incidentTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	not?: InputMaybe<StudentIncidentNoteFilterInput>;
	or?: InputMaybe<Array<StudentIncidentNoteFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentNote?: InputMaybe<Array<StudentNoteFilterInput>>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	suggestionsForFutureContains?: InputMaybe<Scalars["String"]["input"]>;
	suggestionsForFutureEQ?: InputMaybe<Scalars["String"]["input"]>;
	suggestionsForFutureHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	suggestionsForFutureHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	suggestionsForFutureIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	suggestionsForFutureNEQ?: InputMaybe<Scalars["String"]["input"]>;
	suggestionsForFutureNotContains?: InputMaybe<Scalars["String"]["input"]>;
	suggestionsForFutureNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	suggestionsForFutureNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	suggestionsForFutureNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type StudentIncidentNoteHistory = Node & {
	__typename?: "StudentIncidentNoteHistory";
	actionsTaken: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	incidentLocation: Maybe<StudentIncidentNoteHistoryIncidentLocation>;
	incidentTime: Maybe<Scalars["Time"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	studentNoteID: Maybe<Scalars["ID"]["output"]>;
	suggestionsForFuture: Maybe<Scalars["String"]["output"]>;
};

export type StudentIncidentNoteHistoryConnection = {
	__typename?: "StudentIncidentNoteHistoryConnection";
	edges: Array<StudentIncidentNoteHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentIncidentNoteHistoryEdge = {
	__typename?: "StudentIncidentNoteHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentIncidentNoteHistory;
};

export type StudentIncidentNoteHistoryFilterInput = {
	actionsTakenContains?: InputMaybe<Scalars["String"]["input"]>;
	actionsTakenEQ?: InputMaybe<Scalars["String"]["input"]>;
	actionsTakenHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	actionsTakenHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	actionsTakenIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	actionsTakenIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	actionsTakenNEQ?: InputMaybe<Scalars["String"]["input"]>;
	actionsTakenNotContains?: InputMaybe<Scalars["String"]["input"]>;
	actionsTakenNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	actionsTakenNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	actionsTakenNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<StudentIncidentNoteHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	incidentLocationEQ?: InputMaybe<StudentIncidentNoteHistoryIncidentLocation>;
	incidentLocationIn?: InputMaybe<Array<StudentIncidentNoteHistoryIncidentLocation>>;
	incidentLocationIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	incidentLocationNEQ?: InputMaybe<StudentIncidentNoteHistoryIncidentLocation>;
	incidentLocationNotIn?: InputMaybe<Array<StudentIncidentNoteHistoryIncidentLocation>>;
	incidentTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	incidentTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	incidentTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	not?: InputMaybe<StudentIncidentNoteHistoryFilterInput>;
	or?: InputMaybe<Array<StudentIncidentNoteHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	suggestionsForFutureContains?: InputMaybe<Scalars["String"]["input"]>;
	suggestionsForFutureEQ?: InputMaybe<Scalars["String"]["input"]>;
	suggestionsForFutureHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	suggestionsForFutureHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	suggestionsForFutureIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	suggestionsForFutureIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	suggestionsForFutureNEQ?: InputMaybe<Scalars["String"]["input"]>;
	suggestionsForFutureNotContains?: InputMaybe<Scalars["String"]["input"]>;
	suggestionsForFutureNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	suggestionsForFutureNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	suggestionsForFutureNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export enum StudentIncidentNoteHistoryIncidentLocation {
	Cafeteria = "cafeteria",
	Classroom = "classroom",
	Garden = "garden",
	Hallways = "hallways",
	Playground = "playground",
	SpecialtyClass = "specialty_class",
	Transportation = "transportation",
}

export type StudentIncidentNoteHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentIncidentNoteHistoryOrderField>;
};

export enum StudentIncidentNoteHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentIncidentNoteInStudentNoteCreateInput = {
	actionsTaken?: InputMaybe<Scalars["String"]["input"]>;
	incidentLocation?: InputMaybe<StudentIncidentNoteIncidentLocation>;
	incidentTime?: InputMaybe<Scalars["Time"]["input"]>;
	suggestionsForFuture?: InputMaybe<Scalars["String"]["input"]>;
};

export enum StudentIncidentNoteIncidentLocation {
	Cafeteria = "cafeteria",
	Classroom = "classroom",
	Garden = "garden",
	Hallways = "hallways",
	Playground = "playground",
	SpecialtyClass = "specialty_class",
	Transportation = "transportation",
}

export type StudentIncidentNoteOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentIncidentNoteOrderField>;
};

export enum StudentIncidentNoteOrderField {
	IncidentLocation = "INCIDENT_LOCATION",
	IncidentTime = "INCIDENT_TIME",
}

export type StudentIncidentNoteUpdateBulkInput = {
	actionsTaken?: InputMaybe<Scalars["String"]["input"]>;
	clearIncidentLocation?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearIncidentTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	incidentLocation?: InputMaybe<StudentIncidentNoteIncidentLocation>;
	incidentTime?: InputMaybe<Scalars["Time"]["input"]>;
	suggestionsForFuture?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentIncidentNoteUpdateInput = {
	actionsTaken?: InputMaybe<Scalars["String"]["input"]>;
	clearIncidentLocation?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearIncidentTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	incidentLocation?: InputMaybe<StudentIncidentNoteIncidentLocation>;
	incidentTime?: InputMaybe<Scalars["Time"]["input"]>;
	suggestionsForFuture?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentInformationVerification = Node & {
	__typename?: "StudentInformationVerification";
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	createdAt: Scalars["Time"]["output"];
	guardians: Array<Guardian>;
	hasVerifiedGuardians: Scalars["Boolean"]["output"];
	hasVerifiedStudentHealth: Scalars["Boolean"]["output"];
	id: Scalars["ID"]["output"];
	students: Array<Student>;
};

export type StudentInformationVerificationGuardiansArgs = {
	filters?: InputMaybe<Array<GuardianFilterInput>>;
	order?: InputMaybe<GuardianOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentInformationVerificationStudentsArgs = {
	filters?: InputMaybe<Array<StudentFilterInput>>;
	order?: InputMaybe<StudentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentInformationVerificationConnection = {
	__typename?: "StudentInformationVerificationConnection";
	edges: Array<StudentInformationVerificationEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentInformationVerificationCreateInput = {
	createdAt?: InputMaybe<Scalars["Time"]["input"]>;
	guardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	hasVerifiedGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasVerifiedStudentHealth?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentInformationVerificationEdge = {
	__typename?: "StudentInformationVerificationEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentInformationVerification;
};

export type StudentInformationVerificationFilterInput = {
	and?: InputMaybe<Array<StudentInformationVerificationFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	guardians?: InputMaybe<Array<GuardianFilterInput>>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasVerifiedGuardiansEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasVerifiedGuardiansNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasVerifiedStudentHealthEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasVerifiedStudentHealthNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentInformationVerificationFilterInput>;
	or?: InputMaybe<Array<StudentInformationVerificationFilterInput>>;
	students?: InputMaybe<Array<StudentFilterInput>>;
};

export type StudentInformationVerificationGuardianHistory = Node & {
	__typename?: "StudentInformationVerificationGuardianHistory";
	guardianID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	studentInformationVerificationID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentInformationVerificationGuardianHistoryConnection = {
	__typename?: "StudentInformationVerificationGuardianHistoryConnection";
	edges: Array<StudentInformationVerificationGuardianHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentInformationVerificationGuardianHistoryEdge = {
	__typename?: "StudentInformationVerificationGuardianHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentInformationVerificationGuardianHistory;
};

export type StudentInformationVerificationGuardianHistoryFilterInput = {
	and?: InputMaybe<Array<StudentInformationVerificationGuardianHistoryFilterInput>>;
	guardianIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	guardianIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	guardianIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	guardianIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	guardianIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentInformationVerificationGuardianHistoryFilterInput>;
	or?: InputMaybe<Array<StudentInformationVerificationGuardianHistoryFilterInput>>;
	studentInformationVerificationIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentInformationVerificationIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentInformationVerificationIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentInformationVerificationIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentInformationVerificationIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentInformationVerificationGuardianHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentInformationVerificationGuardianHistoryOrderField>;
};

export enum StudentInformationVerificationGuardianHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentInformationVerificationHistory = Node & {
	__typename?: "StudentInformationVerificationHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	hasVerifiedGuardians: Maybe<Scalars["Boolean"]["output"]>;
	hasVerifiedStudentHealth: Maybe<Scalars["Boolean"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentInformationVerificationHistoryConnection = {
	__typename?: "StudentInformationVerificationHistoryConnection";
	edges: Array<StudentInformationVerificationHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentInformationVerificationHistoryEdge = {
	__typename?: "StudentInformationVerificationHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentInformationVerificationHistory;
};

export type StudentInformationVerificationHistoryFilterInput = {
	and?: InputMaybe<Array<StudentInformationVerificationHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasVerifiedGuardiansEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasVerifiedGuardiansIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasVerifiedGuardiansNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasVerifiedStudentHealthEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasVerifiedStudentHealthIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasVerifiedStudentHealthNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentInformationVerificationHistoryFilterInput>;
	or?: InputMaybe<Array<StudentInformationVerificationHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentInformationVerificationHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentInformationVerificationHistoryOrderField>;
};

export enum StudentInformationVerificationHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentInformationVerificationInAuthorCreateInput = {
	createdAt?: InputMaybe<Scalars["Time"]["input"]>;
	guardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	hasVerifiedGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasVerifiedStudentHealth?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentInformationVerificationOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentInformationVerificationOrderField>;
};

export enum StudentInformationVerificationOrderField {
	CreatedAt = "CREATED_AT",
}

export type StudentInformationVerificationStudentHistory = Node & {
	__typename?: "StudentInformationVerificationStudentHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	studentID: Maybe<Scalars["ID"]["output"]>;
	studentInformationVerificationID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentInformationVerificationStudentHistoryConnection = {
	__typename?: "StudentInformationVerificationStudentHistoryConnection";
	edges: Array<StudentInformationVerificationStudentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentInformationVerificationStudentHistoryEdge = {
	__typename?: "StudentInformationVerificationStudentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentInformationVerificationStudentHistory;
};

export type StudentInformationVerificationStudentHistoryFilterInput = {
	and?: InputMaybe<Array<StudentInformationVerificationStudentHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentInformationVerificationStudentHistoryFilterInput>;
	or?: InputMaybe<Array<StudentInformationVerificationStudentHistoryFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentInformationVerificationIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentInformationVerificationIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentInformationVerificationIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentInformationVerificationIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentInformationVerificationIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentInformationVerificationStudentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentInformationVerificationStudentHistoryOrderField>;
};

export enum StudentInformationVerificationStudentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentInformationVerificationUpdateBulkInput = {
	addGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	guardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	hasVerifiedGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasVerifiedStudentHealth?: InputMaybe<Scalars["Boolean"]["input"]>;
	removeGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentInformationVerificationUpdateInput = {
	addGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	guardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	hasVerifiedGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasVerifiedStudentHealth?: InputMaybe<Scalars["Boolean"]["input"]>;
	removeGuardianIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentInjuryNote = Node & {
	__typename?: "StudentInjuryNote";
	actionTakenOther: Scalars["String"]["output"];
	adultWhoProvidedMedicalAttention: Scalars["String"]["output"];
	causeOfInjury: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	incidentLocation: Maybe<StudentInjuryNoteIncidentLocation>;
	incidentTime: Maybe<Scalars["Time"]["output"]>;
	isActionTakenHomeroomTeachersNotified: Scalars["Boolean"]["output"];
	isActionTakenOther: Scalars["Boolean"]["output"];
	isActionTakenParentNotificationNotNecessary: Scalars["Boolean"]["output"];
	isActionTakenParentNotifiedByPhone: Scalars["Boolean"]["output"];
	isActionTakenParentNotifiedByPortal: Scalars["Boolean"]["output"];
	isActionTakenParentsRequestedToCollectStudent: Scalars["Boolean"]["output"];
	medicalAttentionProvided: Scalars["String"]["output"];
	studentNote: StudentNote;
	studentNoteID: Scalars["ID"]["output"];
	wereOtherStudentsCauseOfInjury: Scalars["Boolean"]["output"];
};

export type StudentInjuryNoteConnection = {
	__typename?: "StudentInjuryNoteConnection";
	edges: Array<StudentInjuryNoteEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentInjuryNoteCreateInput = {
	actionTakenOther?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttention?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjury?: InputMaybe<Scalars["String"]["input"]>;
	incidentLocation?: InputMaybe<StudentInjuryNoteIncidentLocation>;
	incidentTime?: InputMaybe<Scalars["Time"]["input"]>;
	isActionTakenHomeroomTeachersNotified?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotificationNotNecessary?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotifiedByPhone?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotifiedByPortal?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentsRequestedToCollectStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicalAttentionProvided?: InputMaybe<Scalars["String"]["input"]>;
	studentNote?: InputMaybe<StudentNoteInStudentInjuryNoteCreateInput>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
	wereOtherStudentsCauseOfInjury?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type StudentInjuryNoteEdge = {
	__typename?: "StudentInjuryNoteEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentInjuryNote;
};

export type StudentInjuryNoteFilterInput = {
	actionTakenOtherContains?: InputMaybe<Scalars["String"]["input"]>;
	actionTakenOtherEQ?: InputMaybe<Scalars["String"]["input"]>;
	actionTakenOtherHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	actionTakenOtherHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	actionTakenOtherIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	actionTakenOtherNEQ?: InputMaybe<Scalars["String"]["input"]>;
	actionTakenOtherNotContains?: InputMaybe<Scalars["String"]["input"]>;
	actionTakenOtherNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	actionTakenOtherNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	actionTakenOtherNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	adultWhoProvidedMedicalAttentionContains?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttentionEQ?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttentionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttentionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttentionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	adultWhoProvidedMedicalAttentionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttentionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttentionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttentionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttentionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<StudentInjuryNoteFilterInput>>;
	causeOfInjuryContains?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjuryEQ?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjuryHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjuryHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjuryIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	causeOfInjuryNEQ?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjuryNotContains?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjuryNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjuryNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjuryNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	incidentLocationEQ?: InputMaybe<StudentInjuryNoteIncidentLocation>;
	incidentLocationIn?: InputMaybe<Array<StudentInjuryNoteIncidentLocation>>;
	incidentLocationIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	incidentLocationNEQ?: InputMaybe<StudentInjuryNoteIncidentLocation>;
	incidentLocationNotIn?: InputMaybe<Array<StudentInjuryNoteIncidentLocation>>;
	incidentTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	incidentTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	incidentTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	isActionTakenHomeroomTeachersNotifiedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenHomeroomTeachersNotifiedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenOtherEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenOtherNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotificationNotNecessaryEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotificationNotNecessaryNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotifiedByPhoneEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotifiedByPhoneNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotifiedByPortalEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotifiedByPortalNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentsRequestedToCollectStudentEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentsRequestedToCollectStudentNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicalAttentionProvidedContains?: InputMaybe<Scalars["String"]["input"]>;
	medicalAttentionProvidedEQ?: InputMaybe<Scalars["String"]["input"]>;
	medicalAttentionProvidedHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	medicalAttentionProvidedHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	medicalAttentionProvidedIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	medicalAttentionProvidedNEQ?: InputMaybe<Scalars["String"]["input"]>;
	medicalAttentionProvidedNotContains?: InputMaybe<Scalars["String"]["input"]>;
	medicalAttentionProvidedNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	medicalAttentionProvidedNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	medicalAttentionProvidedNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<StudentInjuryNoteFilterInput>;
	or?: InputMaybe<Array<StudentInjuryNoteFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentNote?: InputMaybe<Array<StudentNoteFilterInput>>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	wereOtherStudentsCauseOfInjuryEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	wereOtherStudentsCauseOfInjuryNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type StudentInjuryNoteHistory = Node & {
	__typename?: "StudentInjuryNoteHistory";
	actionTakenOther: Maybe<Scalars["String"]["output"]>;
	adultWhoProvidedMedicalAttention: Maybe<Scalars["String"]["output"]>;
	causeOfInjury: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	incidentLocation: Maybe<StudentInjuryNoteHistoryIncidentLocation>;
	incidentTime: Maybe<Scalars["Time"]["output"]>;
	isActionTakenHomeroomTeachersNotified: Maybe<Scalars["Boolean"]["output"]>;
	isActionTakenOther: Maybe<Scalars["Boolean"]["output"]>;
	isActionTakenParentNotificationNotNecessary: Maybe<Scalars["Boolean"]["output"]>;
	isActionTakenParentNotifiedByPhone: Maybe<Scalars["Boolean"]["output"]>;
	isActionTakenParentNotifiedByPortal: Maybe<Scalars["Boolean"]["output"]>;
	isActionTakenParentsRequestedToCollectStudent: Maybe<Scalars["Boolean"]["output"]>;
	medicalAttentionProvided: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	studentNoteID: Maybe<Scalars["ID"]["output"]>;
	wereOtherStudentsCauseOfInjury: Maybe<Scalars["Boolean"]["output"]>;
};

export type StudentInjuryNoteHistoryConnection = {
	__typename?: "StudentInjuryNoteHistoryConnection";
	edges: Array<StudentInjuryNoteHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentInjuryNoteHistoryEdge = {
	__typename?: "StudentInjuryNoteHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentInjuryNoteHistory;
};

export type StudentInjuryNoteHistoryFilterInput = {
	actionTakenOtherContains?: InputMaybe<Scalars["String"]["input"]>;
	actionTakenOtherEQ?: InputMaybe<Scalars["String"]["input"]>;
	actionTakenOtherHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	actionTakenOtherHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	actionTakenOtherIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	actionTakenOtherIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	actionTakenOtherNEQ?: InputMaybe<Scalars["String"]["input"]>;
	actionTakenOtherNotContains?: InputMaybe<Scalars["String"]["input"]>;
	actionTakenOtherNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	actionTakenOtherNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	actionTakenOtherNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	adultWhoProvidedMedicalAttentionContains?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttentionEQ?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttentionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttentionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttentionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	adultWhoProvidedMedicalAttentionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	adultWhoProvidedMedicalAttentionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttentionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttentionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttentionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttentionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<StudentInjuryNoteHistoryFilterInput>>;
	causeOfInjuryContains?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjuryEQ?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjuryHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjuryHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjuryIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	causeOfInjuryIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	causeOfInjuryNEQ?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjuryNotContains?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjuryNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjuryNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjuryNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	incidentLocationEQ?: InputMaybe<StudentInjuryNoteHistoryIncidentLocation>;
	incidentLocationIn?: InputMaybe<Array<StudentInjuryNoteHistoryIncidentLocation>>;
	incidentLocationIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	incidentLocationNEQ?: InputMaybe<StudentInjuryNoteHistoryIncidentLocation>;
	incidentLocationNotIn?: InputMaybe<Array<StudentInjuryNoteHistoryIncidentLocation>>;
	incidentTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	incidentTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	incidentTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	incidentTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	isActionTakenHomeroomTeachersNotifiedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenHomeroomTeachersNotifiedIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenHomeroomTeachersNotifiedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenOtherEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenOtherIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenOtherNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotificationNotNecessaryEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotificationNotNecessaryIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotificationNotNecessaryNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotifiedByPhoneEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotifiedByPhoneIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotifiedByPhoneNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotifiedByPortalEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotifiedByPortalIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotifiedByPortalNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentsRequestedToCollectStudentEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentsRequestedToCollectStudentIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentsRequestedToCollectStudentNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicalAttentionProvidedContains?: InputMaybe<Scalars["String"]["input"]>;
	medicalAttentionProvidedEQ?: InputMaybe<Scalars["String"]["input"]>;
	medicalAttentionProvidedHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	medicalAttentionProvidedHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	medicalAttentionProvidedIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	medicalAttentionProvidedIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicalAttentionProvidedNEQ?: InputMaybe<Scalars["String"]["input"]>;
	medicalAttentionProvidedNotContains?: InputMaybe<Scalars["String"]["input"]>;
	medicalAttentionProvidedNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	medicalAttentionProvidedNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	medicalAttentionProvidedNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<StudentInjuryNoteHistoryFilterInput>;
	or?: InputMaybe<Array<StudentInjuryNoteHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	wereOtherStudentsCauseOfInjuryEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	wereOtherStudentsCauseOfInjuryIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	wereOtherStudentsCauseOfInjuryNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum StudentInjuryNoteHistoryIncidentLocation {
	Cafeteria = "cafeteria",
	Classroom = "classroom",
	Garden = "garden",
	Hallways = "hallways",
	Playground = "playground",
	SpecialtyClass = "specialty_class",
	Transportation = "transportation",
}

export type StudentInjuryNoteHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentInjuryNoteHistoryOrderField>;
};

export enum StudentInjuryNoteHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentInjuryNoteInStudentNoteCreateInput = {
	actionTakenOther?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttention?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjury?: InputMaybe<Scalars["String"]["input"]>;
	incidentLocation?: InputMaybe<StudentInjuryNoteIncidentLocation>;
	incidentTime?: InputMaybe<Scalars["Time"]["input"]>;
	isActionTakenHomeroomTeachersNotified?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotificationNotNecessary?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotifiedByPhone?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotifiedByPortal?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentsRequestedToCollectStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicalAttentionProvided?: InputMaybe<Scalars["String"]["input"]>;
	wereOtherStudentsCauseOfInjury?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum StudentInjuryNoteIncidentLocation {
	Cafeteria = "cafeteria",
	Classroom = "classroom",
	Garden = "garden",
	Hallways = "hallways",
	Playground = "playground",
	SpecialtyClass = "specialty_class",
	Transportation = "transportation",
}

export type StudentInjuryNoteOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentInjuryNoteOrderField>;
};

export enum StudentInjuryNoteOrderField {
	IncidentLocation = "INCIDENT_LOCATION",
	IncidentTime = "INCIDENT_TIME",
	IsActionTakenHomeroomTeachersNotified = "IS_ACTION_TAKEN_HOMEROOM_TEACHERS_NOTIFIED",
	IsActionTakenOther = "IS_ACTION_TAKEN_OTHER",
	IsActionTakenParentsRequestedToCollectStudent = "IS_ACTION_TAKEN_PARENTS_REQUESTED_TO_COLLECT_STUDENT",
	IsActionTakenParentNotificationNotNecessary = "IS_ACTION_TAKEN_PARENT_NOTIFICATION_NOT_NECESSARY",
	IsActionTakenParentNotifiedByPhone = "IS_ACTION_TAKEN_PARENT_NOTIFIED_BY_PHONE",
	IsActionTakenParentNotifiedByPortal = "IS_ACTION_TAKEN_PARENT_NOTIFIED_BY_PORTAL",
	WereOtherStudentsCauseOfInjury = "WERE_OTHER_STUDENTS_CAUSE_OF_INJURY",
}

export type StudentInjuryNoteUpdateBulkInput = {
	actionTakenOther?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttention?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjury?: InputMaybe<Scalars["String"]["input"]>;
	clearIncidentLocation?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearIncidentTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	incidentLocation?: InputMaybe<StudentInjuryNoteIncidentLocation>;
	incidentTime?: InputMaybe<Scalars["Time"]["input"]>;
	isActionTakenHomeroomTeachersNotified?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotificationNotNecessary?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotifiedByPhone?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotifiedByPortal?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentsRequestedToCollectStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicalAttentionProvided?: InputMaybe<Scalars["String"]["input"]>;
	wereOtherStudentsCauseOfInjury?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type StudentInjuryNoteUpdateInput = {
	actionTakenOther?: InputMaybe<Scalars["String"]["input"]>;
	adultWhoProvidedMedicalAttention?: InputMaybe<Scalars["String"]["input"]>;
	causeOfInjury?: InputMaybe<Scalars["String"]["input"]>;
	clearIncidentLocation?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearIncidentTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	incidentLocation?: InputMaybe<StudentInjuryNoteIncidentLocation>;
	incidentTime?: InputMaybe<Scalars["Time"]["input"]>;
	isActionTakenHomeroomTeachersNotified?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotificationNotNecessary?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotifiedByPhone?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentNotifiedByPortal?: InputMaybe<Scalars["Boolean"]["input"]>;
	isActionTakenParentsRequestedToCollectStudent?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicalAttentionProvided?: InputMaybe<Scalars["String"]["input"]>;
	wereOtherStudentsCauseOfInjury?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type StudentMedicalCondition = Node & {
	__typename?: "StudentMedicalCondition";
	id: Scalars["ID"]["output"];
	isProminent: Scalars["Boolean"]["output"];
	medicalCondition: MedicalCondition;
	medicalConditionID: Scalars["ID"]["output"];
	notes: Scalars["String"]["output"];
	student: Student;
	studentID: Scalars["ID"]["output"];
};

export type StudentMedicalConditionConnection = {
	__typename?: "StudentMedicalConditionConnection";
	edges: Array<StudentMedicalConditionEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentMedicalConditionCreateInput = {
	isProminent?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicalConditionID: Scalars["ID"]["input"];
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type StudentMedicalConditionEdge = {
	__typename?: "StudentMedicalConditionEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentMedicalCondition;
};

export type StudentMedicalConditionFilterInput = {
	and?: InputMaybe<Array<StudentMedicalConditionFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isProminentEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isProminentNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicalCondition?: InputMaybe<Array<MedicalConditionFilterInput>>;
	medicalConditionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	medicalConditionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	medicalConditionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	medicalConditionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentMedicalConditionFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<StudentMedicalConditionFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentMedicalConditionHistory = Node & {
	__typename?: "StudentMedicalConditionHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isProminent: Maybe<Scalars["Boolean"]["output"]>;
	medicalConditionID: Maybe<Scalars["ID"]["output"]>;
	notes: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentMedicalConditionHistoryConnection = {
	__typename?: "StudentMedicalConditionHistoryConnection";
	edges: Array<StudentMedicalConditionHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentMedicalConditionHistoryEdge = {
	__typename?: "StudentMedicalConditionHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentMedicalConditionHistory;
};

export type StudentMedicalConditionHistoryFilterInput = {
	and?: InputMaybe<Array<StudentMedicalConditionHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isProminentEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isProminentIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isProminentNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicalConditionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	medicalConditionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	medicalConditionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicalConditionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	medicalConditionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentMedicalConditionHistoryFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<StudentMedicalConditionHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentMedicalConditionHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentMedicalConditionHistoryOrderField>;
};

export enum StudentMedicalConditionHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentMedicalConditionInMedicalConditionCreateInput = {
	isProminent?: InputMaybe<Scalars["Boolean"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type StudentMedicalConditionInStudentCreateInput = {
	isProminent?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicalConditionID: Scalars["ID"]["input"];
	notes?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentMedicalConditionOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentMedicalConditionOrderField>;
};

export enum StudentMedicalConditionOrderField {
	IsProminent = "IS_PROMINENT",
}

export type StudentMedicalConditionUpdateBulkInput = {
	isProminent?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicalConditionID?: InputMaybe<Scalars["ID"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentMedicalConditionUpdateInput = {
	isProminent?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicalConditionID?: InputMaybe<Scalars["ID"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentMedicalContact = Node & {
	__typename?: "StudentMedicalContact";
	address: Scalars["String"]["output"];
	contactType: Scalars["String"]["output"];
	emailAddress: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	institutionName: Scalars["String"]["output"];
	name: Scalars["String"]["output"];
	notes: Scalars["String"]["output"];
	phoneNumber: Scalars["String"]["output"];
	student: Student;
	studentID: Scalars["ID"]["output"];
};

export type StudentMedicalContactConnection = {
	__typename?: "StudentMedicalContactConnection";
	edges: Array<StudentMedicalContactEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentMedicalContactCreateInput = {
	address?: InputMaybe<Scalars["String"]["input"]>;
	contactType: Scalars["String"]["input"];
	emailAddress?: InputMaybe<Scalars["String"]["input"]>;
	institutionName?: InputMaybe<Scalars["String"]["input"]>;
	name: Scalars["String"]["input"];
	notes?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumber: Scalars["String"]["input"];
	studentID: Scalars["ID"]["input"];
};

export type StudentMedicalContactEdge = {
	__typename?: "StudentMedicalContactEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentMedicalContact;
};

export type StudentMedicalContactFilterInput = {
	addressContains?: InputMaybe<Scalars["String"]["input"]>;
	addressEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressNEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressNotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<StudentMedicalContactFilterInput>>;
	contactTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	contactTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	contactTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	contactTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	contactTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	contactTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	contactTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	contactTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	contactTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	contactTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	emailAddressContains?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	emailAddressNEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotContains?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	institutionNameContains?: InputMaybe<Scalars["String"]["input"]>;
	institutionNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	institutionNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	institutionNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	institutionNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	institutionNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	institutionNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	institutionNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	institutionNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	institutionNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<StudentMedicalContactFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<StudentMedicalContactFilterInput>>;
	phoneNumberContains?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberEQ?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	phoneNumberNEQ?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotContains?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentMedicalContactHistory = Node & {
	__typename?: "StudentMedicalContactHistory";
	address: Maybe<Scalars["String"]["output"]>;
	contactType: Maybe<Scalars["String"]["output"]>;
	emailAddress: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	institutionName: Maybe<Scalars["String"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	notes: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	phoneNumber: Maybe<Scalars["String"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentMedicalContactHistoryConnection = {
	__typename?: "StudentMedicalContactHistoryConnection";
	edges: Array<StudentMedicalContactHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentMedicalContactHistoryEdge = {
	__typename?: "StudentMedicalContactHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentMedicalContactHistory;
};

export type StudentMedicalContactHistoryFilterInput = {
	addressContains?: InputMaybe<Scalars["String"]["input"]>;
	addressEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	addressIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	addressNEQ?: InputMaybe<Scalars["String"]["input"]>;
	addressNotContains?: InputMaybe<Scalars["String"]["input"]>;
	addressNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	addressNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	addressNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<StudentMedicalContactHistoryFilterInput>>;
	contactTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	contactTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	contactTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	contactTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	contactTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	contactTypeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	contactTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	contactTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	contactTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	contactTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	contactTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	emailAddressContains?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	emailAddressIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	emailAddressNEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotContains?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailAddressNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	institutionNameContains?: InputMaybe<Scalars["String"]["input"]>;
	institutionNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	institutionNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	institutionNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	institutionNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	institutionNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	institutionNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	institutionNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	institutionNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	institutionNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	institutionNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<StudentMedicalContactHistoryFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<StudentMedicalContactHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	phoneNumberContains?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberEQ?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	phoneNumberIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	phoneNumberNEQ?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotContains?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumberNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentMedicalContactHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentMedicalContactHistoryOrderField>;
};

export enum StudentMedicalContactHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentMedicalContactInStudentCreateInput = {
	address?: InputMaybe<Scalars["String"]["input"]>;
	contactType: Scalars["String"]["input"];
	emailAddress?: InputMaybe<Scalars["String"]["input"]>;
	institutionName?: InputMaybe<Scalars["String"]["input"]>;
	name: Scalars["String"]["input"];
	notes?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumber: Scalars["String"]["input"];
};

export type StudentMedicalContactOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentMedicalContactOrderField>;
};

export enum StudentMedicalContactOrderField {
	ContactType = "CONTACT_TYPE",
	Name = "NAME",
}

export type StudentMedicalContactUpdateBulkInput = {
	address?: InputMaybe<Scalars["String"]["input"]>;
	contactType?: InputMaybe<Scalars["String"]["input"]>;
	emailAddress?: InputMaybe<Scalars["String"]["input"]>;
	institutionName?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentMedicalContactUpdateInput = {
	address?: InputMaybe<Scalars["String"]["input"]>;
	contactType?: InputMaybe<Scalars["String"]["input"]>;
	emailAddress?: InputMaybe<Scalars["String"]["input"]>;
	institutionName?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentMedicalEvent = Node & {
	__typename?: "StudentMedicalEvent";
	attendingEmployees: Array<Employee>;
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	checkInTime: Scalars["Time"]["output"];
	checkOutTime: Maybe<Scalars["Time"]["output"]>;
	description: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	mediaAttachments: Array<MediaAttachment>;
	notes: Scalars["String"]["output"];
	outcome: Scalars["String"]["output"];
	student: Student;
	studentID: Scalars["ID"]["output"];
	treatment: Scalars["String"]["output"];
};

export type StudentMedicalEventAttendingEmployeesArgs = {
	filters?: InputMaybe<Array<EmployeeFilterInput>>;
	order?: InputMaybe<EmployeeOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentMedicalEventMediaAttachmentsArgs = {
	filters?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	order?: InputMaybe<MediaAttachmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentMedicalEventConnection = {
	__typename?: "StudentMedicalEventConnection";
	edges: Array<StudentMedicalEventEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentMedicalEventCreateInput = {
	attendingEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	checkInTime?: InputMaybe<Scalars["Time"]["input"]>;
	checkOutTime?: InputMaybe<Scalars["Time"]["input"]>;
	description: Scalars["String"]["input"];
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInStudentMedicalEventCreateInput>>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	outcome: Scalars["String"]["input"];
	studentID: Scalars["ID"]["input"];
	treatment: Scalars["String"]["input"];
};

export type StudentMedicalEventEdge = {
	__typename?: "StudentMedicalEventEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentMedicalEvent;
};

export type StudentMedicalEventFilterInput = {
	and?: InputMaybe<Array<StudentMedicalEventFilterInput>>;
	attendingEmployees?: InputMaybe<Array<EmployeeFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	checkInTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	checkInTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	checkInTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	checkInTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	checkInTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	checkInTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	checkInTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	checkInTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	checkOutTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	checkOutTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	checkOutTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	checkOutTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	checkOutTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	checkOutTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	checkOutTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	checkOutTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	checkOutTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasAttendingEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMediaAttachments?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	not?: InputMaybe<StudentMedicalEventFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<StudentMedicalEventFilterInput>>;
	outcomeContains?: InputMaybe<Scalars["String"]["input"]>;
	outcomeEQ?: InputMaybe<Scalars["String"]["input"]>;
	outcomeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	outcomeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	outcomeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	outcomeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	outcomeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	outcomeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	outcomeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	outcomeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	treatmentContains?: InputMaybe<Scalars["String"]["input"]>;
	treatmentEQ?: InputMaybe<Scalars["String"]["input"]>;
	treatmentHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	treatmentHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	treatmentIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	treatmentNEQ?: InputMaybe<Scalars["String"]["input"]>;
	treatmentNotContains?: InputMaybe<Scalars["String"]["input"]>;
	treatmentNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	treatmentNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	treatmentNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type StudentMedicalEventHistory = Node & {
	__typename?: "StudentMedicalEventHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	checkInTime: Maybe<Scalars["Time"]["output"]>;
	checkOutTime: Maybe<Scalars["Time"]["output"]>;
	description: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	notes: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	outcome: Maybe<Scalars["String"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
	treatment: Maybe<Scalars["String"]["output"]>;
};

export type StudentMedicalEventHistoryConnection = {
	__typename?: "StudentMedicalEventHistoryConnection";
	edges: Array<StudentMedicalEventHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentMedicalEventHistoryEdge = {
	__typename?: "StudentMedicalEventHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentMedicalEventHistory;
};

export type StudentMedicalEventHistoryFilterInput = {
	and?: InputMaybe<Array<StudentMedicalEventHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	checkInTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	checkInTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	checkInTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	checkInTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	checkInTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	checkInTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	checkInTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	checkInTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	checkInTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	checkOutTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	checkOutTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	checkOutTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	checkOutTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	checkOutTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	checkOutTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	checkOutTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	checkOutTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	checkOutTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentMedicalEventHistoryFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<StudentMedicalEventHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	outcomeContains?: InputMaybe<Scalars["String"]["input"]>;
	outcomeEQ?: InputMaybe<Scalars["String"]["input"]>;
	outcomeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	outcomeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	outcomeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	outcomeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	outcomeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	outcomeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	outcomeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	outcomeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	outcomeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	treatmentContains?: InputMaybe<Scalars["String"]["input"]>;
	treatmentEQ?: InputMaybe<Scalars["String"]["input"]>;
	treatmentHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	treatmentHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	treatmentIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	treatmentIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	treatmentNEQ?: InputMaybe<Scalars["String"]["input"]>;
	treatmentNotContains?: InputMaybe<Scalars["String"]["input"]>;
	treatmentNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	treatmentNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	treatmentNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type StudentMedicalEventHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentMedicalEventHistoryOrderField>;
};

export enum StudentMedicalEventHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentMedicalEventInAuthorCreateInput = {
	attendingEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	checkInTime?: InputMaybe<Scalars["Time"]["input"]>;
	checkOutTime?: InputMaybe<Scalars["Time"]["input"]>;
	description: Scalars["String"]["input"];
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInStudentMedicalEventCreateInput>>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	outcome: Scalars["String"]["input"];
	studentID: Scalars["ID"]["input"];
	treatment: Scalars["String"]["input"];
};

export type StudentMedicalEventInStudentCreateInput = {
	attendingEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	checkInTime?: InputMaybe<Scalars["Time"]["input"]>;
	checkOutTime?: InputMaybe<Scalars["Time"]["input"]>;
	description: Scalars["String"]["input"];
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInStudentMedicalEventCreateInput>>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	outcome: Scalars["String"]["input"];
	treatment: Scalars["String"]["input"];
};

export type StudentMedicalEventOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentMedicalEventOrderField>;
};

export enum StudentMedicalEventOrderField {
	CheckInTime = "CHECK_IN_TIME",
	CheckOutTime = "CHECK_OUT_TIME",
}

export type StudentMedicalEventUpdateBulkInput = {
	addAttendingEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	attendingEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	checkInTime?: InputMaybe<Scalars["Time"]["input"]>;
	checkOutTime?: InputMaybe<Scalars["Time"]["input"]>;
	clearAttendingEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearCheckOutTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	outcome?: InputMaybe<Scalars["String"]["input"]>;
	removeAttendingEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
	treatment?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentMedicalEventUpdateInput = {
	addAttendingEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	attendingEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	checkInTime?: InputMaybe<Scalars["Time"]["input"]>;
	checkOutTime?: InputMaybe<Scalars["Time"]["input"]>;
	clearAttendingEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearCheckOutTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	outcome?: InputMaybe<Scalars["String"]["input"]>;
	removeAttendingEmployeeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
	treatment?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentMedicalProfile = Node & {
	__typename?: "StudentMedicalProfile";
	id: Scalars["ID"]["output"];
	isSchoolAllowedToTreat: Scalars["Boolean"]["output"];
	isSchoolAllowedToUseEpipen: Scalars["Boolean"]["output"];
	student: Student;
	studentID: Scalars["ID"]["output"];
};

export type StudentMedicalProfileConnection = {
	__typename?: "StudentMedicalProfileConnection";
	edges: Array<StudentMedicalProfileEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentMedicalProfileCreateInput = {
	isSchoolAllowedToTreat?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSchoolAllowedToUseEpipen?: InputMaybe<Scalars["Boolean"]["input"]>;
	student?: InputMaybe<StudentInStudentMedicalProfileCreateInput>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentMedicalProfileEdge = {
	__typename?: "StudentMedicalProfileEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentMedicalProfile;
};

export type StudentMedicalProfileFilterInput = {
	and?: InputMaybe<Array<StudentMedicalProfileFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isSchoolAllowedToTreatEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSchoolAllowedToTreatNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSchoolAllowedToUseEpipenEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSchoolAllowedToUseEpipenNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<StudentMedicalProfileFilterInput>;
	or?: InputMaybe<Array<StudentMedicalProfileFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentMedicalProfileHistory = Node & {
	__typename?: "StudentMedicalProfileHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isSchoolAllowedToTreat: Maybe<Scalars["Boolean"]["output"]>;
	isSchoolAllowedToUseEpipen: Maybe<Scalars["Boolean"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentMedicalProfileHistoryConnection = {
	__typename?: "StudentMedicalProfileHistoryConnection";
	edges: Array<StudentMedicalProfileHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentMedicalProfileHistoryEdge = {
	__typename?: "StudentMedicalProfileHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentMedicalProfileHistory;
};

export type StudentMedicalProfileHistoryFilterInput = {
	and?: InputMaybe<Array<StudentMedicalProfileHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isSchoolAllowedToTreatEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSchoolAllowedToTreatIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSchoolAllowedToTreatNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSchoolAllowedToUseEpipenEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSchoolAllowedToUseEpipenIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSchoolAllowedToUseEpipenNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<StudentMedicalProfileHistoryFilterInput>;
	or?: InputMaybe<Array<StudentMedicalProfileHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentMedicalProfileHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentMedicalProfileHistoryOrderField>;
};

export enum StudentMedicalProfileHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentMedicalProfileInStudentCreateInput = {
	isSchoolAllowedToTreat?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSchoolAllowedToUseEpipen?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type StudentMedicalProfileOrder = {
	direction: OrderDirection;
};

export type StudentMedicalProfileUpdateBulkInput = {
	isSchoolAllowedToTreat?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSchoolAllowedToUseEpipen?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type StudentMedicalProfileUpdateInput = {
	isSchoolAllowedToTreat?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSchoolAllowedToUseEpipen?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type StudentMedicationNote = Node & {
	__typename?: "StudentMedicationNote";
	body: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	studentNote: StudentNote;
	studentNoteID: Scalars["ID"]["output"];
};

export type StudentMedicationNoteConnection = {
	__typename?: "StudentMedicationNoteConnection";
	edges: Array<StudentMedicationNoteEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentMedicationNoteCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	studentNote?: InputMaybe<StudentNoteInStudentMedicationNoteCreateInput>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentMedicationNoteEdge = {
	__typename?: "StudentMedicationNoteEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentMedicationNote;
};

export type StudentMedicationNoteFilterInput = {
	and?: InputMaybe<Array<StudentMedicationNoteFilterInput>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentMedicationNoteFilterInput>;
	or?: InputMaybe<Array<StudentMedicationNoteFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentNote?: InputMaybe<Array<StudentNoteFilterInput>>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentMedicationNoteHistory = Node & {
	__typename?: "StudentMedicationNoteHistory";
	body: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
	studentNoteID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentMedicationNoteHistoryConnection = {
	__typename?: "StudentMedicationNoteHistoryConnection";
	edges: Array<StudentMedicationNoteHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentMedicationNoteHistoryEdge = {
	__typename?: "StudentMedicationNoteHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentMedicationNoteHistory;
};

export type StudentMedicationNoteHistoryFilterInput = {
	and?: InputMaybe<Array<StudentMedicationNoteHistoryFilterInput>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentMedicationNoteHistoryFilterInput>;
	or?: InputMaybe<Array<StudentMedicationNoteHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentMedicationNoteHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentMedicationNoteHistoryOrderField>;
};

export enum StudentMedicationNoteHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentMedicationNoteInStudentNoteCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentMedicationNoteOrder = {
	direction: OrderDirection;
};

export type StudentMedicationNoteUpdateBulkInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentMedicationNoteUpdateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentMessageTopicHistory = Node & {
	__typename?: "StudentMessageTopicHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	messageTopicID: Maybe<Scalars["ID"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentMessageTopicHistoryConnection = {
	__typename?: "StudentMessageTopicHistoryConnection";
	edges: Array<StudentMessageTopicHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentMessageTopicHistoryEdge = {
	__typename?: "StudentMessageTopicHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentMessageTopicHistory;
};

export type StudentMessageTopicHistoryFilterInput = {
	and?: InputMaybe<Array<StudentMessageTopicHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageTopicIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageTopicIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageTopicIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageTopicIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageTopicIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentMessageTopicHistoryFilterInput>;
	or?: InputMaybe<Array<StudentMessageTopicHistoryFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentMessageTopicHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentMessageTopicHistoryOrderField>;
};

export enum StudentMessageTopicHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentNote = Node & {
	__typename?: "StudentNote";
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Scalars["String"]["output"];
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	isPinned: Scalars["Boolean"]["output"];
	isResolved: Scalars["Boolean"]["output"];
	mediaAttachments: Array<MediaAttachment>;
	noteType: StudentNoteNoteType;
	primaryStudents: Array<Student>;
	requiresResolution: Scalars["Boolean"]["output"];
	resolutionDescription: Scalars["String"]["output"];
	resolvedAt: Maybe<Scalars["Time"]["output"]>;
	secondaryStudents: Array<Student>;
	sharingRecord: Maybe<SharingRecord>;
	socialComments: Array<SocialComment>;
	studentAcademicNote: Maybe<StudentAcademicNote>;
	studentAttendanceNote: Maybe<StudentAttendanceNote>;
	studentBehaviorNote: Maybe<StudentBehaviorNote>;
	studentHealthNote: Maybe<StudentHealthNote>;
	studentIncidentNote: Maybe<StudentIncidentNote>;
	studentInjuryNote: Maybe<StudentInjuryNote>;
	studentMedicationNote: Maybe<StudentMedicationNote>;
	studentSocialEmotionalNote: Maybe<StudentSocialEmotionalNote>;
};

export type StudentNoteMediaAttachmentsArgs = {
	filters?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	order?: InputMaybe<MediaAttachmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentNotePrimaryStudentsArgs = {
	filters?: InputMaybe<Array<StudentFilterInput>>;
	order?: InputMaybe<StudentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentNoteSecondaryStudentsArgs = {
	filters?: InputMaybe<Array<StudentFilterInput>>;
	order?: InputMaybe<StudentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentNoteSocialCommentsArgs = {
	filters?: InputMaybe<Array<SocialCommentFilterInput>>;
	order?: InputMaybe<SocialCommentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type StudentNoteConnection = {
	__typename?: "StudentNoteConnection";
	edges: Array<StudentNoteEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentNoteCreateInput = {
	body: Scalars["String"]["input"];
	isPinned?: InputMaybe<Scalars["Boolean"]["input"]>;
	isResolved?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInStudentNoteCreateInput>>;
	noteType: StudentNoteNoteType;
	primaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	requiresResolution?: InputMaybe<Scalars["Boolean"]["input"]>;
	resolutionDescription?: InputMaybe<Scalars["String"]["input"]>;
	resolvedAt?: InputMaybe<Scalars["Time"]["input"]>;
	secondaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecord?: InputMaybe<SharingRecordInStudentNoteCreateInput>;
	socialComments?: InputMaybe<Array<SocialCommentInStudentNoteCreateInput>>;
	studentAcademicNote?: InputMaybe<StudentAcademicNoteInStudentNoteCreateInput>;
	studentAttendanceNote?: InputMaybe<StudentAttendanceNoteInStudentNoteCreateInput>;
	studentBehaviorNote?: InputMaybe<StudentBehaviorNoteInStudentNoteCreateInput>;
	studentHealthNote?: InputMaybe<StudentHealthNoteInStudentNoteCreateInput>;
	studentIncidentNote?: InputMaybe<StudentIncidentNoteInStudentNoteCreateInput>;
	studentInjuryNote?: InputMaybe<StudentInjuryNoteInStudentNoteCreateInput>;
	studentMedicationNote?: InputMaybe<StudentMedicationNoteInStudentNoteCreateInput>;
	studentSocialEmotionalNote?: InputMaybe<StudentSocialEmotionalNoteInStudentNoteCreateInput>;
};

export type StudentNoteEdge = {
	__typename?: "StudentNoteEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentNote;
};

export type StudentNoteFilterInput = {
	and?: InputMaybe<Array<StudentNoteFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMediaAttachments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPrimaryStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSecondaryStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharingRecord?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSocialComments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentAcademicNote?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentAttendanceNote?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentBehaviorNote?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentHealthNote?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentIncidentNote?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentInjuryNote?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentMedicationNote?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasStudentSocialEmotionalNote?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isPinnedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPinnedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isResolvedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isResolvedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	not?: InputMaybe<StudentNoteFilterInput>;
	noteTypeEQ?: InputMaybe<StudentNoteNoteType>;
	noteTypeIn?: InputMaybe<Array<StudentNoteNoteType>>;
	noteTypeNEQ?: InputMaybe<StudentNoteNoteType>;
	noteTypeNotIn?: InputMaybe<Array<StudentNoteNoteType>>;
	or?: InputMaybe<Array<StudentNoteFilterInput>>;
	primaryStudents?: InputMaybe<Array<StudentFilterInput>>;
	requiresResolutionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	requiresResolutionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	resolutionDescriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	resolutionDescriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	resolutionDescriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	resolutionDescriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	resolutionDescriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	resolutionDescriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	resolutionDescriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	resolutionDescriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	resolutionDescriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	resolutionDescriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	resolvedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	resolvedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	resolvedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	resolvedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	resolvedAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	resolvedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	resolvedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	resolvedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	resolvedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	secondaryStudents?: InputMaybe<Array<StudentFilterInput>>;
	sharingRecord?: InputMaybe<Array<SharingRecordFilterInput>>;
	socialComments?: InputMaybe<Array<SocialCommentFilterInput>>;
	studentAcademicNote?: InputMaybe<Array<StudentAcademicNoteFilterInput>>;
	studentAttendanceNote?: InputMaybe<Array<StudentAttendanceNoteFilterInput>>;
	studentBehaviorNote?: InputMaybe<Array<StudentBehaviorNoteFilterInput>>;
	studentHealthNote?: InputMaybe<Array<StudentHealthNoteFilterInput>>;
	studentIncidentNote?: InputMaybe<Array<StudentIncidentNoteFilterInput>>;
	studentInjuryNote?: InputMaybe<Array<StudentInjuryNoteFilterInput>>;
	studentMedicationNote?: InputMaybe<Array<StudentMedicationNoteFilterInput>>;
	studentSocialEmotionalNote?: InputMaybe<Array<StudentSocialEmotionalNoteFilterInput>>;
};

export type StudentNoteHistory = Node & {
	__typename?: "StudentNoteHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Maybe<Scalars["String"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isPinned: Maybe<Scalars["Boolean"]["output"]>;
	isResolved: Maybe<Scalars["Boolean"]["output"]>;
	noteType: Maybe<StudentNoteHistoryNoteType>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	requiresResolution: Maybe<Scalars["Boolean"]["output"]>;
	resolutionDescription: Maybe<Scalars["String"]["output"]>;
	resolvedAt: Maybe<Scalars["Time"]["output"]>;
};

export type StudentNoteHistoryConnection = {
	__typename?: "StudentNoteHistoryConnection";
	edges: Array<StudentNoteHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentNoteHistoryEdge = {
	__typename?: "StudentNoteHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentNoteHistory;
};

export type StudentNoteHistoryFilterInput = {
	and?: InputMaybe<Array<StudentNoteHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isPinnedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPinnedIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPinnedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isResolvedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isResolvedIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isResolvedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<StudentNoteHistoryFilterInput>;
	noteTypeEQ?: InputMaybe<StudentNoteHistoryNoteType>;
	noteTypeIn?: InputMaybe<Array<StudentNoteHistoryNoteType>>;
	noteTypeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	noteTypeNEQ?: InputMaybe<StudentNoteHistoryNoteType>;
	noteTypeNotIn?: InputMaybe<Array<StudentNoteHistoryNoteType>>;
	or?: InputMaybe<Array<StudentNoteHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	requiresResolutionEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	requiresResolutionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	requiresResolutionNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	resolutionDescriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	resolutionDescriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	resolutionDescriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	resolutionDescriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	resolutionDescriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	resolutionDescriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	resolutionDescriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	resolutionDescriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	resolutionDescriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	resolutionDescriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	resolutionDescriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	resolvedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	resolvedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	resolvedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	resolvedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	resolvedAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	resolvedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	resolvedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	resolvedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	resolvedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export enum StudentNoteHistoryNoteType {
	Academic = "academic",
	Attendance = "attendance",
	Behavior = "behavior",
	General = "general",
	Health = "health",
	Incident = "incident",
	Injury = "injury",
	Medication = "medication",
	SocialEmotional = "social_emotional",
}

export type StudentNoteHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentNoteHistoryOrderField>;
};

export enum StudentNoteHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentNoteInAuthorCreateInput = {
	body: Scalars["String"]["input"];
	isPinned?: InputMaybe<Scalars["Boolean"]["input"]>;
	isResolved?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInStudentNoteCreateInput>>;
	noteType: StudentNoteNoteType;
	primaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	requiresResolution?: InputMaybe<Scalars["Boolean"]["input"]>;
	resolutionDescription?: InputMaybe<Scalars["String"]["input"]>;
	resolvedAt?: InputMaybe<Scalars["Time"]["input"]>;
	secondaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecord?: InputMaybe<SharingRecordInStudentNoteCreateInput>;
	socialComments?: InputMaybe<Array<SocialCommentInStudentNoteCreateInput>>;
	studentAcademicNote?: InputMaybe<StudentAcademicNoteInStudentNoteCreateInput>;
	studentAttendanceNote?: InputMaybe<StudentAttendanceNoteInStudentNoteCreateInput>;
	studentBehaviorNote?: InputMaybe<StudentBehaviorNoteInStudentNoteCreateInput>;
	studentHealthNote?: InputMaybe<StudentHealthNoteInStudentNoteCreateInput>;
	studentIncidentNote?: InputMaybe<StudentIncidentNoteInStudentNoteCreateInput>;
	studentInjuryNote?: InputMaybe<StudentInjuryNoteInStudentNoteCreateInput>;
	studentMedicationNote?: InputMaybe<StudentMedicationNoteInStudentNoteCreateInput>;
	studentSocialEmotionalNote?: InputMaybe<StudentSocialEmotionalNoteInStudentNoteCreateInput>;
};

export type StudentNoteInSharingRecordCreateInput = {
	body: Scalars["String"]["input"];
	isPinned?: InputMaybe<Scalars["Boolean"]["input"]>;
	isResolved?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInStudentNoteCreateInput>>;
	noteType: StudentNoteNoteType;
	primaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	requiresResolution?: InputMaybe<Scalars["Boolean"]["input"]>;
	resolutionDescription?: InputMaybe<Scalars["String"]["input"]>;
	resolvedAt?: InputMaybe<Scalars["Time"]["input"]>;
	secondaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	socialComments?: InputMaybe<Array<SocialCommentInStudentNoteCreateInput>>;
	studentAcademicNote?: InputMaybe<StudentAcademicNoteInStudentNoteCreateInput>;
	studentAttendanceNote?: InputMaybe<StudentAttendanceNoteInStudentNoteCreateInput>;
	studentBehaviorNote?: InputMaybe<StudentBehaviorNoteInStudentNoteCreateInput>;
	studentHealthNote?: InputMaybe<StudentHealthNoteInStudentNoteCreateInput>;
	studentIncidentNote?: InputMaybe<StudentIncidentNoteInStudentNoteCreateInput>;
	studentInjuryNote?: InputMaybe<StudentInjuryNoteInStudentNoteCreateInput>;
	studentMedicationNote?: InputMaybe<StudentMedicationNoteInStudentNoteCreateInput>;
	studentSocialEmotionalNote?: InputMaybe<StudentSocialEmotionalNoteInStudentNoteCreateInput>;
};

export type StudentNoteInStudentAcademicNoteCreateInput = {
	body: Scalars["String"]["input"];
	isPinned?: InputMaybe<Scalars["Boolean"]["input"]>;
	isResolved?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInStudentNoteCreateInput>>;
	noteType: StudentNoteNoteType;
	primaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	requiresResolution?: InputMaybe<Scalars["Boolean"]["input"]>;
	resolutionDescription?: InputMaybe<Scalars["String"]["input"]>;
	resolvedAt?: InputMaybe<Scalars["Time"]["input"]>;
	secondaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecord?: InputMaybe<SharingRecordInStudentNoteCreateInput>;
	socialComments?: InputMaybe<Array<SocialCommentInStudentNoteCreateInput>>;
	studentAttendanceNote?: InputMaybe<StudentAttendanceNoteInStudentNoteCreateInput>;
	studentBehaviorNote?: InputMaybe<StudentBehaviorNoteInStudentNoteCreateInput>;
	studentHealthNote?: InputMaybe<StudentHealthNoteInStudentNoteCreateInput>;
	studentIncidentNote?: InputMaybe<StudentIncidentNoteInStudentNoteCreateInput>;
	studentInjuryNote?: InputMaybe<StudentInjuryNoteInStudentNoteCreateInput>;
	studentMedicationNote?: InputMaybe<StudentMedicationNoteInStudentNoteCreateInput>;
	studentSocialEmotionalNote?: InputMaybe<StudentSocialEmotionalNoteInStudentNoteCreateInput>;
};

export type StudentNoteInStudentAttendanceNoteCreateInput = {
	body: Scalars["String"]["input"];
	isPinned?: InputMaybe<Scalars["Boolean"]["input"]>;
	isResolved?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInStudentNoteCreateInput>>;
	noteType: StudentNoteNoteType;
	primaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	requiresResolution?: InputMaybe<Scalars["Boolean"]["input"]>;
	resolutionDescription?: InputMaybe<Scalars["String"]["input"]>;
	resolvedAt?: InputMaybe<Scalars["Time"]["input"]>;
	secondaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecord?: InputMaybe<SharingRecordInStudentNoteCreateInput>;
	socialComments?: InputMaybe<Array<SocialCommentInStudentNoteCreateInput>>;
	studentAcademicNote?: InputMaybe<StudentAcademicNoteInStudentNoteCreateInput>;
	studentBehaviorNote?: InputMaybe<StudentBehaviorNoteInStudentNoteCreateInput>;
	studentHealthNote?: InputMaybe<StudentHealthNoteInStudentNoteCreateInput>;
	studentIncidentNote?: InputMaybe<StudentIncidentNoteInStudentNoteCreateInput>;
	studentInjuryNote?: InputMaybe<StudentInjuryNoteInStudentNoteCreateInput>;
	studentMedicationNote?: InputMaybe<StudentMedicationNoteInStudentNoteCreateInput>;
	studentSocialEmotionalNote?: InputMaybe<StudentSocialEmotionalNoteInStudentNoteCreateInput>;
};

export type StudentNoteInStudentBehaviorNoteCreateInput = {
	body: Scalars["String"]["input"];
	isPinned?: InputMaybe<Scalars["Boolean"]["input"]>;
	isResolved?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInStudentNoteCreateInput>>;
	noteType: StudentNoteNoteType;
	primaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	requiresResolution?: InputMaybe<Scalars["Boolean"]["input"]>;
	resolutionDescription?: InputMaybe<Scalars["String"]["input"]>;
	resolvedAt?: InputMaybe<Scalars["Time"]["input"]>;
	secondaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecord?: InputMaybe<SharingRecordInStudentNoteCreateInput>;
	socialComments?: InputMaybe<Array<SocialCommentInStudentNoteCreateInput>>;
	studentAcademicNote?: InputMaybe<StudentAcademicNoteInStudentNoteCreateInput>;
	studentAttendanceNote?: InputMaybe<StudentAttendanceNoteInStudentNoteCreateInput>;
	studentHealthNote?: InputMaybe<StudentHealthNoteInStudentNoteCreateInput>;
	studentIncidentNote?: InputMaybe<StudentIncidentNoteInStudentNoteCreateInput>;
	studentInjuryNote?: InputMaybe<StudentInjuryNoteInStudentNoteCreateInput>;
	studentMedicationNote?: InputMaybe<StudentMedicationNoteInStudentNoteCreateInput>;
	studentSocialEmotionalNote?: InputMaybe<StudentSocialEmotionalNoteInStudentNoteCreateInput>;
};

export type StudentNoteInStudentHealthNoteCreateInput = {
	body: Scalars["String"]["input"];
	isPinned?: InputMaybe<Scalars["Boolean"]["input"]>;
	isResolved?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInStudentNoteCreateInput>>;
	noteType: StudentNoteNoteType;
	primaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	requiresResolution?: InputMaybe<Scalars["Boolean"]["input"]>;
	resolutionDescription?: InputMaybe<Scalars["String"]["input"]>;
	resolvedAt?: InputMaybe<Scalars["Time"]["input"]>;
	secondaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecord?: InputMaybe<SharingRecordInStudentNoteCreateInput>;
	socialComments?: InputMaybe<Array<SocialCommentInStudentNoteCreateInput>>;
	studentAcademicNote?: InputMaybe<StudentAcademicNoteInStudentNoteCreateInput>;
	studentAttendanceNote?: InputMaybe<StudentAttendanceNoteInStudentNoteCreateInput>;
	studentBehaviorNote?: InputMaybe<StudentBehaviorNoteInStudentNoteCreateInput>;
	studentIncidentNote?: InputMaybe<StudentIncidentNoteInStudentNoteCreateInput>;
	studentInjuryNote?: InputMaybe<StudentInjuryNoteInStudentNoteCreateInput>;
	studentMedicationNote?: InputMaybe<StudentMedicationNoteInStudentNoteCreateInput>;
	studentSocialEmotionalNote?: InputMaybe<StudentSocialEmotionalNoteInStudentNoteCreateInput>;
};

export type StudentNoteInStudentIncidentNoteCreateInput = {
	body: Scalars["String"]["input"];
	isPinned?: InputMaybe<Scalars["Boolean"]["input"]>;
	isResolved?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInStudentNoteCreateInput>>;
	noteType: StudentNoteNoteType;
	primaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	requiresResolution?: InputMaybe<Scalars["Boolean"]["input"]>;
	resolutionDescription?: InputMaybe<Scalars["String"]["input"]>;
	resolvedAt?: InputMaybe<Scalars["Time"]["input"]>;
	secondaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecord?: InputMaybe<SharingRecordInStudentNoteCreateInput>;
	socialComments?: InputMaybe<Array<SocialCommentInStudentNoteCreateInput>>;
	studentAcademicNote?: InputMaybe<StudentAcademicNoteInStudentNoteCreateInput>;
	studentAttendanceNote?: InputMaybe<StudentAttendanceNoteInStudentNoteCreateInput>;
	studentBehaviorNote?: InputMaybe<StudentBehaviorNoteInStudentNoteCreateInput>;
	studentHealthNote?: InputMaybe<StudentHealthNoteInStudentNoteCreateInput>;
	studentInjuryNote?: InputMaybe<StudentInjuryNoteInStudentNoteCreateInput>;
	studentMedicationNote?: InputMaybe<StudentMedicationNoteInStudentNoteCreateInput>;
	studentSocialEmotionalNote?: InputMaybe<StudentSocialEmotionalNoteInStudentNoteCreateInput>;
};

export type StudentNoteInStudentInjuryNoteCreateInput = {
	body: Scalars["String"]["input"];
	isPinned?: InputMaybe<Scalars["Boolean"]["input"]>;
	isResolved?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInStudentNoteCreateInput>>;
	noteType: StudentNoteNoteType;
	primaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	requiresResolution?: InputMaybe<Scalars["Boolean"]["input"]>;
	resolutionDescription?: InputMaybe<Scalars["String"]["input"]>;
	resolvedAt?: InputMaybe<Scalars["Time"]["input"]>;
	secondaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecord?: InputMaybe<SharingRecordInStudentNoteCreateInput>;
	socialComments?: InputMaybe<Array<SocialCommentInStudentNoteCreateInput>>;
	studentAcademicNote?: InputMaybe<StudentAcademicNoteInStudentNoteCreateInput>;
	studentAttendanceNote?: InputMaybe<StudentAttendanceNoteInStudentNoteCreateInput>;
	studentBehaviorNote?: InputMaybe<StudentBehaviorNoteInStudentNoteCreateInput>;
	studentHealthNote?: InputMaybe<StudentHealthNoteInStudentNoteCreateInput>;
	studentIncidentNote?: InputMaybe<StudentIncidentNoteInStudentNoteCreateInput>;
	studentMedicationNote?: InputMaybe<StudentMedicationNoteInStudentNoteCreateInput>;
	studentSocialEmotionalNote?: InputMaybe<StudentSocialEmotionalNoteInStudentNoteCreateInput>;
};

export type StudentNoteInStudentMedicationNoteCreateInput = {
	body: Scalars["String"]["input"];
	isPinned?: InputMaybe<Scalars["Boolean"]["input"]>;
	isResolved?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInStudentNoteCreateInput>>;
	noteType: StudentNoteNoteType;
	primaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	requiresResolution?: InputMaybe<Scalars["Boolean"]["input"]>;
	resolutionDescription?: InputMaybe<Scalars["String"]["input"]>;
	resolvedAt?: InputMaybe<Scalars["Time"]["input"]>;
	secondaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecord?: InputMaybe<SharingRecordInStudentNoteCreateInput>;
	socialComments?: InputMaybe<Array<SocialCommentInStudentNoteCreateInput>>;
	studentAcademicNote?: InputMaybe<StudentAcademicNoteInStudentNoteCreateInput>;
	studentAttendanceNote?: InputMaybe<StudentAttendanceNoteInStudentNoteCreateInput>;
	studentBehaviorNote?: InputMaybe<StudentBehaviorNoteInStudentNoteCreateInput>;
	studentHealthNote?: InputMaybe<StudentHealthNoteInStudentNoteCreateInput>;
	studentIncidentNote?: InputMaybe<StudentIncidentNoteInStudentNoteCreateInput>;
	studentInjuryNote?: InputMaybe<StudentInjuryNoteInStudentNoteCreateInput>;
	studentSocialEmotionalNote?: InputMaybe<StudentSocialEmotionalNoteInStudentNoteCreateInput>;
};

export type StudentNoteInStudentSocialEmotionalNoteCreateInput = {
	body: Scalars["String"]["input"];
	isPinned?: InputMaybe<Scalars["Boolean"]["input"]>;
	isResolved?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInStudentNoteCreateInput>>;
	noteType: StudentNoteNoteType;
	primaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	requiresResolution?: InputMaybe<Scalars["Boolean"]["input"]>;
	resolutionDescription?: InputMaybe<Scalars["String"]["input"]>;
	resolvedAt?: InputMaybe<Scalars["Time"]["input"]>;
	secondaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecord?: InputMaybe<SharingRecordInStudentNoteCreateInput>;
	socialComments?: InputMaybe<Array<SocialCommentInStudentNoteCreateInput>>;
	studentAcademicNote?: InputMaybe<StudentAcademicNoteInStudentNoteCreateInput>;
	studentAttendanceNote?: InputMaybe<StudentAttendanceNoteInStudentNoteCreateInput>;
	studentBehaviorNote?: InputMaybe<StudentBehaviorNoteInStudentNoteCreateInput>;
	studentHealthNote?: InputMaybe<StudentHealthNoteInStudentNoteCreateInput>;
	studentIncidentNote?: InputMaybe<StudentIncidentNoteInStudentNoteCreateInput>;
	studentInjuryNote?: InputMaybe<StudentInjuryNoteInStudentNoteCreateInput>;
	studentMedicationNote?: InputMaybe<StudentMedicationNoteInStudentNoteCreateInput>;
};

export enum StudentNoteNoteType {
	Academic = "academic",
	Attendance = "attendance",
	Behavior = "behavior",
	General = "general",
	Health = "health",
	Incident = "incident",
	Injury = "injury",
	Medication = "medication",
	SocialEmotional = "social_emotional",
}

export type StudentNoteOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentNoteOrderField>;
};

export enum StudentNoteOrderField {
	CreatedAt = "CREATED_AT",
	IsPinned = "IS_PINNED",
	IsResolved = "IS_RESOLVED",
	NoteType = "NOTE_TYPE",
	RequiresResolution = "REQUIRES_RESOLUTION",
	ResolvedAt = "RESOLVED_AT",
}

export type StudentNotePrimaryStudentNoteStudentPrimaryStudentHistory = Node & {
	__typename?: "StudentNotePrimaryStudentNoteStudentPrimaryStudentHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	studentID: Maybe<Scalars["ID"]["output"]>;
	studentNoteID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentNotePrimaryStudentNoteStudentPrimaryStudentHistoryConnection = {
	__typename?: "StudentNotePrimaryStudentNoteStudentPrimaryStudentHistoryConnection";
	edges: Array<StudentNotePrimaryStudentNoteStudentPrimaryStudentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentNotePrimaryStudentNoteStudentPrimaryStudentHistoryEdge = {
	__typename?: "StudentNotePrimaryStudentNoteStudentPrimaryStudentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentNotePrimaryStudentNoteStudentPrimaryStudentHistory;
};

export type StudentNotePrimaryStudentNoteStudentPrimaryStudentHistoryFilterInput = {
	and?: InputMaybe<Array<StudentNotePrimaryStudentNoteStudentPrimaryStudentHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentNotePrimaryStudentNoteStudentPrimaryStudentHistoryFilterInput>;
	or?: InputMaybe<Array<StudentNotePrimaryStudentNoteStudentPrimaryStudentHistoryFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentNotePrimaryStudentNoteStudentPrimaryStudentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentNotePrimaryStudentNoteStudentPrimaryStudentHistoryOrderField>;
};

export enum StudentNotePrimaryStudentNoteStudentPrimaryStudentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistory = Node & {
	__typename?: "StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	studentID: Maybe<Scalars["ID"]["output"]>;
	studentNoteID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistoryConnection = {
	__typename?: "StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistoryConnection";
	edges: Array<StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistoryEdge = {
	__typename?: "StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistory;
};

export type StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistoryFilterInput = {
	and?: InputMaybe<Array<StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistoryFilterInput>;
	or?: InputMaybe<Array<StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistoryFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistoryOrderField>;
};

export enum StudentNoteSecondaryStudentNoteStudentSecondaryStudentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentNoteUpdateBulkInput = {
	addPrimaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSecondaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	body?: InputMaybe<Scalars["String"]["input"]>;
	clearPrimaryStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearResolvedAt?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSecondaryStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPinned?: InputMaybe<Scalars["Boolean"]["input"]>;
	isResolved?: InputMaybe<Scalars["Boolean"]["input"]>;
	noteType?: InputMaybe<StudentNoteNoteType>;
	primaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePrimaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSecondaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	requiresResolution?: InputMaybe<Scalars["Boolean"]["input"]>;
	resolutionDescription?: InputMaybe<Scalars["String"]["input"]>;
	resolvedAt?: InputMaybe<Scalars["Time"]["input"]>;
	secondaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentNoteUpdateInput = {
	addPrimaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSecondaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	body?: InputMaybe<Scalars["String"]["input"]>;
	clearPrimaryStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearResolvedAt?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSecondaryStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPinned?: InputMaybe<Scalars["Boolean"]["input"]>;
	isResolved?: InputMaybe<Scalars["Boolean"]["input"]>;
	noteType?: InputMaybe<StudentNoteNoteType>;
	primaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePrimaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSecondaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	requiresResolution?: InputMaybe<Scalars["Boolean"]["input"]>;
	resolutionDescription?: InputMaybe<Scalars["String"]["input"]>;
	resolvedAt?: InputMaybe<Scalars["Time"]["input"]>;
	secondaryStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentOTCMedication = Node & {
	__typename?: "StudentOTCMedication";
	id: Scalars["ID"]["output"];
	isAllowed: Scalars["Boolean"]["output"];
	medication: Medication;
	medicationID: Scalars["ID"]["output"];
	notes: Scalars["String"]["output"];
	student: Student;
	studentID: Scalars["ID"]["output"];
};

export type StudentOTCMedicationConnection = {
	__typename?: "StudentOTCMedicationConnection";
	edges: Array<StudentOTCMedicationEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentOTCMedicationCreateInput = {
	isAllowed?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicationID: Scalars["ID"]["input"];
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type StudentOTCMedicationEdge = {
	__typename?: "StudentOTCMedicationEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentOTCMedication;
};

export type StudentOTCMedicationFilterInput = {
	and?: InputMaybe<Array<StudentOTCMedicationFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isAllowedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isAllowedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	medication?: InputMaybe<Array<MedicationFilterInput>>;
	medicationIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	medicationIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	medicationIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	medicationIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentOTCMedicationFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<StudentOTCMedicationFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentOTCMedicationHistory = Node & {
	__typename?: "StudentOTCMedicationHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isAllowed: Maybe<Scalars["Boolean"]["output"]>;
	medicationID: Maybe<Scalars["ID"]["output"]>;
	notes: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentOTCMedicationHistoryConnection = {
	__typename?: "StudentOTCMedicationHistoryConnection";
	edges: Array<StudentOTCMedicationHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentOTCMedicationHistoryEdge = {
	__typename?: "StudentOTCMedicationHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentOTCMedicationHistory;
};

export type StudentOTCMedicationHistoryFilterInput = {
	and?: InputMaybe<Array<StudentOTCMedicationHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isAllowedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isAllowedIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isAllowedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicationIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	medicationIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	medicationIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicationIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	medicationIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentOTCMedicationHistoryFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<StudentOTCMedicationHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentOTCMedicationHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentOTCMedicationHistoryOrderField>;
};

export enum StudentOTCMedicationHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentOTCMedicationInMedicationCreateInput = {
	isAllowed?: InputMaybe<Scalars["Boolean"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type StudentOTCMedicationInStudentCreateInput = {
	isAllowed?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicationID: Scalars["ID"]["input"];
	notes?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentOTCMedicationOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentOTCMedicationOrderField>;
};

export enum StudentOTCMedicationOrderField {
	IsAllowed = "IS_ALLOWED",
}

export type StudentOTCMedicationUpdateBulkInput = {
	isAllowed?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicationID?: InputMaybe<Scalars["ID"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentOTCMedicationUpdateInput = {
	isAllowed?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicationID?: InputMaybe<Scalars["ID"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentOrderField>;
};

export enum StudentOrderField {
	GraduationYear = "GRADUATION_YEAR",
}

export type StudentPrescriptionMedication = Node & {
	__typename?: "StudentPrescriptionMedication";
	administration: Scalars["String"]["output"];
	canSelfAdminister: Scalars["Boolean"]["output"];
	id: Scalars["ID"]["output"];
	medication: Medication;
	medicationID: Scalars["ID"]["output"];
	notes: Scalars["String"]["output"];
	student: Student;
	studentID: Scalars["ID"]["output"];
};

export type StudentPrescriptionMedicationConnection = {
	__typename?: "StudentPrescriptionMedicationConnection";
	edges: Array<StudentPrescriptionMedicationEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentPrescriptionMedicationCreateInput = {
	administration: Scalars["String"]["input"];
	canSelfAdminister?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicationID: Scalars["ID"]["input"];
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type StudentPrescriptionMedicationEdge = {
	__typename?: "StudentPrescriptionMedicationEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentPrescriptionMedication;
};

export type StudentPrescriptionMedicationFilterInput = {
	administrationContains?: InputMaybe<Scalars["String"]["input"]>;
	administrationEQ?: InputMaybe<Scalars["String"]["input"]>;
	administrationHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	administrationHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	administrationIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	administrationNEQ?: InputMaybe<Scalars["String"]["input"]>;
	administrationNotContains?: InputMaybe<Scalars["String"]["input"]>;
	administrationNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	administrationNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	administrationNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<StudentPrescriptionMedicationFilterInput>>;
	canSelfAdministerEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	canSelfAdministerNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	medication?: InputMaybe<Array<MedicationFilterInput>>;
	medicationIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	medicationIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	medicationIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	medicationIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentPrescriptionMedicationFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<StudentPrescriptionMedicationFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentPrescriptionMedicationHistory = Node & {
	__typename?: "StudentPrescriptionMedicationHistory";
	administration: Maybe<Scalars["String"]["output"]>;
	canSelfAdminister: Maybe<Scalars["Boolean"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	medicationID: Maybe<Scalars["ID"]["output"]>;
	notes: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentPrescriptionMedicationHistoryConnection = {
	__typename?: "StudentPrescriptionMedicationHistoryConnection";
	edges: Array<StudentPrescriptionMedicationHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentPrescriptionMedicationHistoryEdge = {
	__typename?: "StudentPrescriptionMedicationHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentPrescriptionMedicationHistory;
};

export type StudentPrescriptionMedicationHistoryFilterInput = {
	administrationContains?: InputMaybe<Scalars["String"]["input"]>;
	administrationEQ?: InputMaybe<Scalars["String"]["input"]>;
	administrationHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	administrationHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	administrationIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	administrationIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	administrationNEQ?: InputMaybe<Scalars["String"]["input"]>;
	administrationNotContains?: InputMaybe<Scalars["String"]["input"]>;
	administrationNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	administrationNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	administrationNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<StudentPrescriptionMedicationHistoryFilterInput>>;
	canSelfAdministerEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	canSelfAdministerIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	canSelfAdministerNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	medicationIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	medicationIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	medicationIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicationIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	medicationIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentPrescriptionMedicationHistoryFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<StudentPrescriptionMedicationHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentPrescriptionMedicationHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentPrescriptionMedicationHistoryOrderField>;
};

export enum StudentPrescriptionMedicationHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentPrescriptionMedicationInMedicationCreateInput = {
	administration: Scalars["String"]["input"];
	canSelfAdminister?: InputMaybe<Scalars["Boolean"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID: Scalars["ID"]["input"];
};

export type StudentPrescriptionMedicationInStudentCreateInput = {
	administration: Scalars["String"]["input"];
	canSelfAdminister?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicationID: Scalars["ID"]["input"];
	notes?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentPrescriptionMedicationOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentPrescriptionMedicationOrderField>;
};

export enum StudentPrescriptionMedicationOrderField {
	CanSelfAdminister = "CAN_SELF_ADMINISTER",
}

export type StudentPrescriptionMedicationUpdateBulkInput = {
	administration?: InputMaybe<Scalars["String"]["input"]>;
	canSelfAdminister?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicationID?: InputMaybe<Scalars["ID"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentPrescriptionMedicationUpdateInput = {
	administration?: InputMaybe<Scalars["String"]["input"]>;
	canSelfAdminister?: InputMaybe<Scalars["Boolean"]["input"]>;
	medicationID?: InputMaybe<Scalars["ID"]["input"]>;
	notes?: InputMaybe<Scalars["String"]["input"]>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentSectionReportCardSectionsCompletionProgressStatistics = {
	__typename?: "StudentSectionReportCardSectionsCompletionProgressStatistics";
	id: Scalars["ID"]["output"];
	statistics: Array<IndividualReportCardCompletionProgressStatistics>;
};

export type StudentSocialEmotionalNote = Node & {
	__typename?: "StudentSocialEmotionalNote";
	id: Scalars["ID"]["output"];
	isIssueNatureAttentionIssue: Scalars["Boolean"]["output"];
	isIssueNatureEmotionalOrVulnerableIssue: Scalars["Boolean"]["output"];
	isIssueNatureFocusIssue: Scalars["Boolean"]["output"];
	isIssueNatureLearningDifficulty: Scalars["Boolean"]["output"];
	isIssueNatureOther: Scalars["Boolean"]["output"];
	isSolutionRecDifferentiatedLearning: Scalars["Boolean"]["output"];
	isSolutionRecInClassSupport: Scalars["Boolean"]["output"];
	isSolutionRecIndividualLearningPlan: Scalars["Boolean"]["output"];
	isSolutionRecOther: Scalars["Boolean"]["output"];
	isSolutionRecProfessionalSupport: Scalars["Boolean"]["output"];
	isSolutionRecTutoring: Scalars["Boolean"]["output"];
	issueNatureOther: Scalars["String"]["output"];
	solutionRecOther: Scalars["String"]["output"];
	studentNote: StudentNote;
	studentNoteID: Scalars["ID"]["output"];
};

export type StudentSocialEmotionalNoteConnection = {
	__typename?: "StudentSocialEmotionalNoteConnection";
	edges: Array<StudentSocialEmotionalNoteEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentSocialEmotionalNoteCreateInput = {
	isIssueNatureAttentionIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureEmotionalOrVulnerableIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureFocusIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureLearningDifficulty?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecDifferentiatedLearning?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecInClassSupport?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecIndividualLearningPlan?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecProfessionalSupport?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecTutoring?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueNatureOther?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOther?: InputMaybe<Scalars["String"]["input"]>;
	studentNote?: InputMaybe<StudentNoteInStudentSocialEmotionalNoteCreateInput>;
	studentNoteID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentSocialEmotionalNoteEdge = {
	__typename?: "StudentSocialEmotionalNoteEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentSocialEmotionalNote;
};

export type StudentSocialEmotionalNoteFilterInput = {
	and?: InputMaybe<Array<StudentSocialEmotionalNoteFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isIssueNatureAttentionIssueEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureAttentionIssueNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureEmotionalOrVulnerableIssueEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureEmotionalOrVulnerableIssueNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureFocusIssueEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureFocusIssueNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureLearningDifficultyEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureLearningDifficultyNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureOtherEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureOtherNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecDifferentiatedLearningEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecDifferentiatedLearningNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecInClassSupportEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecInClassSupportNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecIndividualLearningPlanEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecIndividualLearningPlanNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecOtherEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecOtherNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecProfessionalSupportEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecProfessionalSupportNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecTutoringEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecTutoringNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueNatureOtherContains?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherEQ?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	issueNatureOtherNEQ?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherNotContains?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<StudentSocialEmotionalNoteFilterInput>;
	or?: InputMaybe<Array<StudentSocialEmotionalNoteFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherContains?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherEQ?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	solutionRecOtherNEQ?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherNotContains?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	studentNote?: InputMaybe<Array<StudentNoteFilterInput>>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentSocialEmotionalNoteHistory = Node & {
	__typename?: "StudentSocialEmotionalNoteHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isIssueNatureAttentionIssue: Maybe<Scalars["Boolean"]["output"]>;
	isIssueNatureEmotionalOrVulnerableIssue: Maybe<Scalars["Boolean"]["output"]>;
	isIssueNatureFocusIssue: Maybe<Scalars["Boolean"]["output"]>;
	isIssueNatureLearningDifficulty: Maybe<Scalars["Boolean"]["output"]>;
	isIssueNatureOther: Maybe<Scalars["Boolean"]["output"]>;
	isSolutionRecDifferentiatedLearning: Maybe<Scalars["Boolean"]["output"]>;
	isSolutionRecInClassSupport: Maybe<Scalars["Boolean"]["output"]>;
	isSolutionRecIndividualLearningPlan: Maybe<Scalars["Boolean"]["output"]>;
	isSolutionRecOther: Maybe<Scalars["Boolean"]["output"]>;
	isSolutionRecProfessionalSupport: Maybe<Scalars["Boolean"]["output"]>;
	isSolutionRecTutoring: Maybe<Scalars["Boolean"]["output"]>;
	issueNatureOther: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	solutionRecOther: Maybe<Scalars["String"]["output"]>;
	studentNoteID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentSocialEmotionalNoteHistoryConnection = {
	__typename?: "StudentSocialEmotionalNoteHistoryConnection";
	edges: Array<StudentSocialEmotionalNoteHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentSocialEmotionalNoteHistoryEdge = {
	__typename?: "StudentSocialEmotionalNoteHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentSocialEmotionalNoteHistory;
};

export type StudentSocialEmotionalNoteHistoryFilterInput = {
	and?: InputMaybe<Array<StudentSocialEmotionalNoteHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isIssueNatureAttentionIssueEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureAttentionIssueIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureAttentionIssueNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureEmotionalOrVulnerableIssueEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureEmotionalOrVulnerableIssueIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureEmotionalOrVulnerableIssueNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureFocusIssueEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureFocusIssueIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureFocusIssueNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureLearningDifficultyEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureLearningDifficultyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureLearningDifficultyNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureOtherEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureOtherIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureOtherNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecDifferentiatedLearningEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecDifferentiatedLearningIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecDifferentiatedLearningNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecInClassSupportEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecInClassSupportIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecInClassSupportNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecIndividualLearningPlanEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecIndividualLearningPlanIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecIndividualLearningPlanNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecOtherEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecOtherIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecOtherNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecProfessionalSupportEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecProfessionalSupportIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecProfessionalSupportNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecTutoringEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecTutoringIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecTutoringNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueNatureOtherContains?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherEQ?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	issueNatureOtherIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueNatureOtherNEQ?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherNotContains?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	issueNatureOtherNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<StudentSocialEmotionalNoteHistoryFilterInput>;
	or?: InputMaybe<Array<StudentSocialEmotionalNoteHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherContains?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherEQ?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	solutionRecOtherIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	solutionRecOtherNEQ?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherNotContains?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOtherNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	studentNoteIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentNoteIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentNoteIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentNoteIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentSocialEmotionalNoteHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentSocialEmotionalNoteHistoryOrderField>;
};

export enum StudentSocialEmotionalNoteHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentSocialEmotionalNoteInStudentNoteCreateInput = {
	isIssueNatureAttentionIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureEmotionalOrVulnerableIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureFocusIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureLearningDifficulty?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecDifferentiatedLearning?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecInClassSupport?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecIndividualLearningPlan?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecProfessionalSupport?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecTutoring?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueNatureOther?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOther?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentSocialEmotionalNoteOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentSocialEmotionalNoteOrderField>;
};

export enum StudentSocialEmotionalNoteOrderField {
	IsIssueNatureAttentionIssue = "IS_ISSUE_NATURE_ATTENTION_ISSUE",
	IsIssueNatureEmotionalOrVulnerableIssue = "IS_ISSUE_NATURE_EMOTIONAL_OR_VULNERABLE_ISSUE",
	IsIssueNatureFocusIssue = "IS_ISSUE_NATURE_FOCUS_ISSUE",
	IsIssueNatureLearningDifficulty = "IS_ISSUE_NATURE_LEARNING_DIFFICULTY",
	IsIssueNatureOther = "IS_ISSUE_NATURE_OTHER",
	IsSolutionRecDifferentiatedLearning = "IS_SOLUTION_REC_DIFFERENTIATED_LEARNING",
	IsSolutionRecIndividualLearningPlan = "IS_SOLUTION_REC_INDIVIDUAL_LEARNING_PLAN",
	IsSolutionRecInClassSupport = "IS_SOLUTION_REC_IN_CLASS_SUPPORT",
	IsSolutionRecOther = "IS_SOLUTION_REC_OTHER",
	IsSolutionRecProfessionalSupport = "IS_SOLUTION_REC_PROFESSIONAL_SUPPORT",
	IsSolutionRecTutoring = "IS_SOLUTION_REC_TUTORING",
}

export type StudentSocialEmotionalNoteUpdateBulkInput = {
	isIssueNatureAttentionIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureEmotionalOrVulnerableIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureFocusIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureLearningDifficulty?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecDifferentiatedLearning?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecInClassSupport?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecIndividualLearningPlan?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecProfessionalSupport?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecTutoring?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueNatureOther?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOther?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentSocialEmotionalNoteUpdateInput = {
	isIssueNatureAttentionIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureEmotionalOrVulnerableIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureFocusIssue?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureLearningDifficulty?: InputMaybe<Scalars["Boolean"]["input"]>;
	isIssueNatureOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecDifferentiatedLearning?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecInClassSupport?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecIndividualLearningPlan?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecOther?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecProfessionalSupport?: InputMaybe<Scalars["Boolean"]["input"]>;
	isSolutionRecTutoring?: InputMaybe<Scalars["Boolean"]["input"]>;
	issueNatureOther?: InputMaybe<Scalars["String"]["input"]>;
	solutionRecOther?: InputMaybe<Scalars["String"]["input"]>;
};

export type StudentUpdateBulkInput = {
	addEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addMessageTopicIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addPrimaryStudentNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addRelationshipIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSecondaryStudentNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentDataConsentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentInformationVerificationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentMedicalConditionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentMedicalContactIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentMedicalEventIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentOTCMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentPrescriptionMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentVaccinationRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearGraduationYear?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearMessageTopics?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearPrimaryStudentNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearRelationships?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSecondaryStudentNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentDataConsents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentInformationVerifications?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentMedicalConditions?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentMedicalContacts?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentMedicalEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentOTCMedications?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentPrescriptionMedications?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentVaccinationRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	graduationYear?: InputMaybe<Scalars["Int"]["input"]>;
	messageTopicIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	primaryStudentNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	relationshipIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeMessageTopicIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePrimaryStudentNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeRelationshipIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSecondaryStudentNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentDataConsentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentInformationVerificationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentMedicalConditionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentMedicalContactIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentMedicalEventIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentOTCMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentPrescriptionMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentVaccinationRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	secondaryStudentNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentDataConsentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentInformationVerificationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalConditionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalContactIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalEventIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentOtcMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentPrescriptionMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentVaccinationRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentUpdateInput = {
	addEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addMessageTopicIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addPrimaryStudentNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addRelationshipIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSecondaryStudentNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentDataConsentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentInformationVerificationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentMedicalConditionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentMedicalContactIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentMedicalEventIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentOTCMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentPrescriptionMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addStudentVaccinationRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearEnrollmentApplicationStudents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearGraduationYear?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearMessageTopics?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearPrimaryStudentNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearRelationships?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSecondaryStudentNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentDataConsents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentInformationVerifications?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentMedicalConditions?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentMedicalContacts?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentMedicalEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentOTCMedications?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentPrescriptionMedications?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStudentVaccinationRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	enrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	graduationYear?: InputMaybe<Scalars["Int"]["input"]>;
	messageTopicIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personID?: InputMaybe<Scalars["ID"]["input"]>;
	primaryStudentNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	relationshipIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeEnrollmentApplicationStudentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeMessageTopicIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePrimaryStudentNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeRelationshipIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSecondaryStudentNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentDataConsentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentInformationVerificationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentMedicalConditionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentMedicalContactIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentMedicalEventIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentOTCMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentPrescriptionMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeStudentVaccinationRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	secondaryStudentNoteIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentDataConsentIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentInformationVerificationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalConditionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalContactIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentMedicalEventIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentOtcMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentPrescriptionMedicationIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentVaccinationRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentVaccinationRecord = Node & {
	__typename?: "StudentVaccinationRecord";
	id: Scalars["ID"]["output"];
	notes: Scalars["String"]["output"];
	receivedOn: Scalars["Date"]["output"];
	student: Student;
	studentID: Scalars["ID"]["output"];
	vaccine: Vaccine;
	vaccineID: Scalars["ID"]["output"];
};

export type StudentVaccinationRecordConnection = {
	__typename?: "StudentVaccinationRecordConnection";
	edges: Array<StudentVaccinationRecordEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentVaccinationRecordCreateInput = {
	notes?: InputMaybe<Scalars["String"]["input"]>;
	receivedOn: Scalars["Date"]["input"];
	studentID: Scalars["ID"]["input"];
	vaccineID: Scalars["ID"]["input"];
};

export type StudentVaccinationRecordEdge = {
	__typename?: "StudentVaccinationRecordEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentVaccinationRecord;
};

export type StudentVaccinationRecordFilterInput = {
	and?: InputMaybe<Array<StudentVaccinationRecordFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentVaccinationRecordFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<StudentVaccinationRecordFilterInput>>;
	receivedOnEQ?: InputMaybe<Scalars["Date"]["input"]>;
	receivedOnGT?: InputMaybe<Scalars["Date"]["input"]>;
	receivedOnGTE?: InputMaybe<Scalars["Date"]["input"]>;
	receivedOnIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	receivedOnLT?: InputMaybe<Scalars["Date"]["input"]>;
	receivedOnLTE?: InputMaybe<Scalars["Date"]["input"]>;
	receivedOnNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	receivedOnNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	student?: InputMaybe<Array<StudentFilterInput>>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	vaccine?: InputMaybe<Array<VaccineFilterInput>>;
	vaccineIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	vaccineIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	vaccineIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	vaccineIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentVaccinationRecordHistory = Node & {
	__typename?: "StudentVaccinationRecordHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	notes: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	receivedOn: Maybe<Scalars["Date"]["output"]>;
	studentID: Maybe<Scalars["ID"]["output"]>;
	vaccineID: Maybe<Scalars["ID"]["output"]>;
};

export type StudentVaccinationRecordHistoryConnection = {
	__typename?: "StudentVaccinationRecordHistoryConnection";
	edges: Array<StudentVaccinationRecordHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type StudentVaccinationRecordHistoryEdge = {
	__typename?: "StudentVaccinationRecordHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: StudentVaccinationRecordHistory;
};

export type StudentVaccinationRecordHistoryFilterInput = {
	and?: InputMaybe<Array<StudentVaccinationRecordHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<StudentVaccinationRecordHistoryFilterInput>;
	notesContains?: InputMaybe<Scalars["String"]["input"]>;
	notesEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	notesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	notesNEQ?: InputMaybe<Scalars["String"]["input"]>;
	notesNotContains?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	notesNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	or?: InputMaybe<Array<StudentVaccinationRecordHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	receivedOnEQ?: InputMaybe<Scalars["Date"]["input"]>;
	receivedOnGT?: InputMaybe<Scalars["Date"]["input"]>;
	receivedOnGTE?: InputMaybe<Scalars["Date"]["input"]>;
	receivedOnIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	receivedOnIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	receivedOnLT?: InputMaybe<Scalars["Date"]["input"]>;
	receivedOnLTE?: InputMaybe<Scalars["Date"]["input"]>;
	receivedOnNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	receivedOnNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	studentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	studentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	vaccineIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	vaccineIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	vaccineIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	vaccineIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	vaccineIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type StudentVaccinationRecordHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentVaccinationRecordHistoryOrderField>;
};

export enum StudentVaccinationRecordHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type StudentVaccinationRecordInStudentCreateInput = {
	notes?: InputMaybe<Scalars["String"]["input"]>;
	receivedOn: Scalars["Date"]["input"];
	vaccineID: Scalars["ID"]["input"];
};

export type StudentVaccinationRecordInVaccineCreateInput = {
	notes?: InputMaybe<Scalars["String"]["input"]>;
	receivedOn: Scalars["Date"]["input"];
	studentID: Scalars["ID"]["input"];
};

export type StudentVaccinationRecordOrder = {
	direction: OrderDirection;
	field?: InputMaybe<StudentVaccinationRecordOrderField>;
};

export enum StudentVaccinationRecordOrderField {
	ReceivedOn = "RECEIVED_ON",
}

export type StudentVaccinationRecordUpdateBulkInput = {
	notes?: InputMaybe<Scalars["String"]["input"]>;
	receivedOn?: InputMaybe<Scalars["Date"]["input"]>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
	vaccineID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type StudentVaccinationRecordUpdateInput = {
	notes?: InputMaybe<Scalars["String"]["input"]>;
	receivedOn?: InputMaybe<Scalars["Date"]["input"]>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
	vaccineID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type TeacherCourseSectionEnrollment = Node & {
	__typename?: "TeacherCourseSectionEnrollment";
	courseSection: CourseSection;
	courseSectionID: Scalars["ID"]["output"];
	earlyEndDate: Maybe<Scalars["Date"]["output"]>;
	id: Scalars["ID"]["output"];
	lateStartDate: Maybe<Scalars["Date"]["output"]>;
	teacher: Employee;
	teacherID: Scalars["ID"]["output"];
};

export type TeacherCourseSectionEnrollmentConnection = {
	__typename?: "TeacherCourseSectionEnrollmentConnection";
	edges: Array<TeacherCourseSectionEnrollmentEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type TeacherCourseSectionEnrollmentCreateInput = {
	courseSectionID: Scalars["ID"]["input"];
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
	teacherID: Scalars["ID"]["input"];
};

export type TeacherCourseSectionEnrollmentEdge = {
	__typename?: "TeacherCourseSectionEnrollmentEdge";
	cursor: Scalars["Cursor"]["output"];
	node: TeacherCourseSectionEnrollment;
};

export type TeacherCourseSectionEnrollmentFilterInput = {
	and?: InputMaybe<Array<TeacherCourseSectionEnrollmentFilterInput>>;
	courseSection?: InputMaybe<Array<CourseSectionFilterInput>>;
	courseSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	earlyEndDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	earlyEndDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	lateStartDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	lateStartDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	lateStartDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	not?: InputMaybe<TeacherCourseSectionEnrollmentFilterInput>;
	or?: InputMaybe<Array<TeacherCourseSectionEnrollmentFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	teacher?: InputMaybe<Array<EmployeeFilterInput>>;
	teacherIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	teacherIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	teacherIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	teacherIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type TeacherCourseSectionEnrollmentHistory = Node & {
	__typename?: "TeacherCourseSectionEnrollmentHistory";
	courseSectionID: Maybe<Scalars["ID"]["output"]>;
	earlyEndDate: Maybe<Scalars["Date"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	lateStartDate: Maybe<Scalars["Date"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	teacherID: Maybe<Scalars["ID"]["output"]>;
};

export type TeacherCourseSectionEnrollmentHistoryConnection = {
	__typename?: "TeacherCourseSectionEnrollmentHistoryConnection";
	edges: Array<TeacherCourseSectionEnrollmentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type TeacherCourseSectionEnrollmentHistoryEdge = {
	__typename?: "TeacherCourseSectionEnrollmentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: TeacherCourseSectionEnrollmentHistory;
};

export type TeacherCourseSectionEnrollmentHistoryFilterInput = {
	and?: InputMaybe<Array<TeacherCourseSectionEnrollmentHistoryFilterInput>>;
	courseSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	earlyEndDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	earlyEndDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	lateStartDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	lateStartDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	lateStartDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	not?: InputMaybe<TeacherCourseSectionEnrollmentHistoryFilterInput>;
	or?: InputMaybe<Array<TeacherCourseSectionEnrollmentHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	teacherIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	teacherIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	teacherIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	teacherIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	teacherIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type TeacherCourseSectionEnrollmentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<TeacherCourseSectionEnrollmentHistoryOrderField>;
};

export enum TeacherCourseSectionEnrollmentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type TeacherCourseSectionEnrollmentInCourseSectionCreateInput = {
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
	teacherID: Scalars["ID"]["input"];
};

export type TeacherCourseSectionEnrollmentInTeacherCreateInput = {
	courseSectionID: Scalars["ID"]["input"];
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type TeacherCourseSectionEnrollmentOrder = {
	direction: OrderDirection;
	field?: InputMaybe<TeacherCourseSectionEnrollmentOrderField>;
};

export enum TeacherCourseSectionEnrollmentOrderField {
	EarlyEndDate = "EARLY_END_DATE",
	LateStartDate = "LATE_START_DATE",
}

export type TeacherCourseSectionEnrollmentUpdateBulkInput = {
	clearEarlyEndDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearLateStartDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type TeacherCourseSectionEnrollmentUpdateInput = {
	clearEarlyEndDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearLateStartDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type TeacherHomeRoomSectionEnrollment = Node & {
	__typename?: "TeacherHomeRoomSectionEnrollment";
	earlyEndDate: Maybe<Scalars["Date"]["output"]>;
	homeRoomSection: HomeRoomSection;
	homeRoomSectionID: Scalars["ID"]["output"];
	id: Scalars["ID"]["output"];
	lateStartDate: Maybe<Scalars["Date"]["output"]>;
	teacher: Employee;
	teacherID: Scalars["ID"]["output"];
};

export type TeacherHomeRoomSectionEnrollmentConnection = {
	__typename?: "TeacherHomeRoomSectionEnrollmentConnection";
	edges: Array<TeacherHomeRoomSectionEnrollmentEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type TeacherHomeRoomSectionEnrollmentCreateInput = {
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	homeRoomSectionID: Scalars["ID"]["input"];
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
	teacherID: Scalars["ID"]["input"];
};

export type TeacherHomeRoomSectionEnrollmentEdge = {
	__typename?: "TeacherHomeRoomSectionEnrollmentEdge";
	cursor: Scalars["Cursor"]["output"];
	node: TeacherHomeRoomSectionEnrollment;
};

export type TeacherHomeRoomSectionEnrollmentFilterInput = {
	and?: InputMaybe<Array<TeacherHomeRoomSectionEnrollmentFilterInput>>;
	earlyEndDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	earlyEndDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	homeRoomSection?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
	homeRoomSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	lateStartDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	lateStartDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	lateStartDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	not?: InputMaybe<TeacherHomeRoomSectionEnrollmentFilterInput>;
	or?: InputMaybe<Array<TeacherHomeRoomSectionEnrollmentFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	teacher?: InputMaybe<Array<EmployeeFilterInput>>;
	teacherIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	teacherIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	teacherIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	teacherIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type TeacherHomeRoomSectionEnrollmentHistory = Node & {
	__typename?: "TeacherHomeRoomSectionEnrollmentHistory";
	earlyEndDate: Maybe<Scalars["Date"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	homeRoomSectionID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	lateStartDate: Maybe<Scalars["Date"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	teacherID: Maybe<Scalars["ID"]["output"]>;
};

export type TeacherHomeRoomSectionEnrollmentHistoryConnection = {
	__typename?: "TeacherHomeRoomSectionEnrollmentHistoryConnection";
	edges: Array<TeacherHomeRoomSectionEnrollmentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type TeacherHomeRoomSectionEnrollmentHistoryEdge = {
	__typename?: "TeacherHomeRoomSectionEnrollmentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: TeacherHomeRoomSectionEnrollmentHistory;
};

export type TeacherHomeRoomSectionEnrollmentHistoryFilterInput = {
	and?: InputMaybe<Array<TeacherHomeRoomSectionEnrollmentHistoryFilterInput>>;
	earlyEndDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	earlyEndDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoomSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	lateStartDateEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateGTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	lateStartDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	lateStartDateLT?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateLTE?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNEQ?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDateNotIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
	not?: InputMaybe<TeacherHomeRoomSectionEnrollmentHistoryFilterInput>;
	or?: InputMaybe<Array<TeacherHomeRoomSectionEnrollmentHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	teacherIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	teacherIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	teacherIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	teacherIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	teacherIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type TeacherHomeRoomSectionEnrollmentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<TeacherHomeRoomSectionEnrollmentHistoryOrderField>;
};

export enum TeacherHomeRoomSectionEnrollmentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type TeacherHomeRoomSectionEnrollmentInHomeRoomSectionCreateInput = {
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
	teacherID: Scalars["ID"]["input"];
};

export type TeacherHomeRoomSectionEnrollmentInTeacherCreateInput = {
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	homeRoomSectionID: Scalars["ID"]["input"];
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type TeacherHomeRoomSectionEnrollmentOrder = {
	direction: OrderDirection;
	field?: InputMaybe<TeacherHomeRoomSectionEnrollmentOrderField>;
};

export enum TeacherHomeRoomSectionEnrollmentOrderField {
	EarlyEndDate = "EARLY_END_DATE",
	LateStartDate = "LATE_START_DATE",
}

export type TeacherHomeRoomSectionEnrollmentUpdateBulkInput = {
	clearEarlyEndDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearLateStartDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type TeacherHomeRoomSectionEnrollmentUpdateInput = {
	clearEarlyEndDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearLateStartDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type TeacherSectionReportCardSectionsCompletionProgressStatistics = {
	__typename?: "TeacherSectionReportCardSectionsCompletionProgressStatistics";
	id: Scalars["ID"]["output"];
	statistics: Array<IndividualReportCardCompletionProgressStatistics>;
};

export type ThirdPartyContractPayer = {
	__typename?: "ThirdPartyContractPayer";
	companyAddress: Scalars["String"]["output"];
	companyName: Scalars["String"]["output"];
	fiscalNumber: Scalars["String"]["output"];
	legalRepresentative: Scalars["String"]["output"];
	phone: Scalars["String"]["output"];
	representativeEmail: Scalars["String"]["output"];
	tradeRegistryNumber: Scalars["String"]["output"];
};

export type TimelineConnection = {
	__typename?: "TimelineConnection";
	hasMore: Scalars["Boolean"]["output"];
	items: Array<TimelineItem>;
};

export type TimelineFilterInput = {
	asViewerType?: InputMaybe<TimelineViewerType>;
	classYearID?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionID?: InputMaybe<Scalars["ID"]["input"]>;
	employeeID?: InputMaybe<Scalars["ID"]["input"]>;
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	homeRoomSectionID?: InputMaybe<Scalars["ID"]["input"]>;
	objectTypeIn?: InputMaybe<Array<TimelineObjectType>>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
	studentID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type TimelineItem = {
	__typename?: "TimelineItem";
	actorID: Scalars["ID"]["output"];
	actorName: Scalars["String"]["output"];
	objectID: Scalars["ID"]["output"];
	objectName: Scalars["String"]["output"];
	objectTime: Scalars["Time"]["output"];
	objectTimeIsDate: Scalars["Boolean"]["output"];
	objectType: TimelineObjectType;
};

export enum TimelineObjectType {
	AcademicTerm = "ACADEMIC_TERM",
	Announcement = "ANNOUNCEMENT",
	CalendarEvent = "CALENDAR_EVENT",
	Contract = "CONTRACT",
	Newsletter = "NEWSLETTER",
	Payment = "PAYMENT",
	Post = "POST",
	SchoolAttendanceRecord = "SCHOOL_ATTENDANCE_RECORD",
	StudentAcademicNote = "STUDENT_ACADEMIC_NOTE",
	StudentAttendanceNote = "STUDENT_ATTENDANCE_NOTE",
	StudentBehaviorNote = "STUDENT_BEHAVIOR_NOTE",
	StudentGeneralNote = "STUDENT_GENERAL_NOTE",
	StudentHealthNote = "STUDENT_HEALTH_NOTE",
	StudentIncidentNote = "STUDENT_INCIDENT_NOTE",
	StudentInjuryNote = "STUDENT_INJURY_NOTE",
	StudentMedicalEvent = "STUDENT_MEDICAL_EVENT",
	StudentMedicationNote = "STUDENT_MEDICATION_NOTE",
	StudentNote = "STUDENT_NOTE",
	StudentSocialEmotionalNote = "STUDENT_SOCIAL_EMOTIONAL_NOTE",
}

export type TimelinePagination = {
	limit?: InputMaybe<Scalars["Int"]["input"]>;
	offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum TimelineViewerType {
	Author = "AUTHOR",
	Employee = "EMPLOYEE",
	Guardian = "GUARDIAN",
}

export type TrustedDevice = Node & {
	__typename?: "TrustedDevice";
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	isCurrent: Scalars["Boolean"]["output"];
	name: Scalars["String"]["output"];
	sessions: Array<Session>;
	user: User;
	userID: Scalars["ID"]["output"];
};

export type TrustedDeviceSessionsArgs = {
	filters?: InputMaybe<Array<SessionFilterInput>>;
	order?: InputMaybe<SessionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type TrustedDeviceConnection = {
	__typename?: "TrustedDeviceConnection";
	edges: Array<TrustedDeviceEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type TrustedDeviceEdge = {
	__typename?: "TrustedDeviceEdge";
	cursor: Scalars["Cursor"]["output"];
	node: TrustedDevice;
};

export type TrustedDeviceFilterInput = {
	and?: InputMaybe<Array<TrustedDeviceFilterInput>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasSessions?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<TrustedDeviceFilterInput>;
	or?: InputMaybe<Array<TrustedDeviceFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	sessions?: InputMaybe<Array<SessionFilterInput>>;
	user?: InputMaybe<Array<UserFilterInput>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type TrustedDeviceOrder = {
	direction: OrderDirection;
	field?: InputMaybe<TrustedDeviceOrderField>;
};

export enum TrustedDeviceOrderField {
	CreatedAt = "CREATED_AT",
}

export type User = Node & {
	__typename?: "User";
	approvedContracts: Array<Contract>;
	approvedReportCards: Array<ReportCard>;
	authoredAnnouncements: Array<Announcement>;
	authoredCalendarEventResponses: Array<CalendarEventResponse>;
	authoredCalendarEvents: Array<CalendarEvent>;
	authoredCourseAssessmentMarks: Array<CourseAssessmentMark>;
	authoredCourseAssessmentSubmissions: Array<CourseAssessmentSubmission>;
	authoredCourseAssessments: Array<CourseAssessment>;
	authoredCourseAttendanceRecords: Array<CourseAttendanceRecord>;
	authoredMessageGroupArchivePoints: Array<MessageGroupArchivePoint>;
	authoredMessages: Array<Message>;
	authoredNewsletters: Array<Newsletter>;
	authoredPosts: Array<Post>;
	authoredSchoolAttendanceRecords: Array<SchoolAttendanceRecord>;
	authoredSocialComments: Array<SocialComment>;
	authoredSocialReactions: Array<SocialReaction>;
	authoredStudentDataConsents: Array<StudentDataConsent>;
	authoredStudentInformationVerifications: Array<StudentInformationVerification>;
	authoredStudentMedicalEvents: Array<StudentMedicalEvent>;
	authoredStudentNotes: Array<StudentNote>;
	email: Scalars["String"]["output"];
	externalNotificationFrequency: UserExternalNotificationFrequency;
	id: Scalars["ID"]["output"];
	isCurrent: Scalars["Boolean"]["output"];
	loginRecords: Array<LoginRecord>;
	memberGroups: Array<UserGroup>;
	messageAvailabilityPeriods: Array<MessageAvailabilityPeriod>;
	messageGroups: Array<MessageGroup>;
	mfaFactor: Maybe<MFAFactor>;
	mfaInvalidOTPAttempts: Array<MFAInvalidOTPAttempt>;
	passwordUpdatedAt: Scalars["Time"]["output"];
	permissionGroups: Array<PermissionGroup>;
	person: Maybe<Person>;
	sessions: Array<Session>;
	sharedSharingRecords: Array<SharingRecord>;
	sharingRecords: Array<SharingRecord>;
	status: UserStatus;
	submittedReportCardSections: Array<ReportCardSection>;
	timeZoneName: Scalars["String"]["output"];
	trustedDevices: Array<TrustedDevice>;
	userExternalNotificationMarker: Maybe<UserExternalNotificationMarker>;
	userGroups: Array<UserGroup>;
	userViewRecords: Array<UserViewRecord>;
};

export type UserApprovedContractsArgs = {
	filters?: InputMaybe<Array<ContractFilterInput>>;
	order?: InputMaybe<ContractOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserApprovedReportCardsArgs = {
	filters?: InputMaybe<Array<ReportCardFilterInput>>;
	order?: InputMaybe<ReportCardOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredAnnouncementsArgs = {
	filters?: InputMaybe<Array<AnnouncementFilterInput>>;
	order?: InputMaybe<AnnouncementOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredCalendarEventResponsesArgs = {
	filters?: InputMaybe<Array<CalendarEventResponseFilterInput>>;
	order?: InputMaybe<CalendarEventResponseOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredCalendarEventsArgs = {
	filters?: InputMaybe<Array<CalendarEventFilterInput>>;
	order?: InputMaybe<CalendarEventOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredCourseAssessmentMarksArgs = {
	filters?: InputMaybe<Array<CourseAssessmentMarkFilterInput>>;
	order?: InputMaybe<CourseAssessmentMarkOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredCourseAssessmentSubmissionsArgs = {
	filters?: InputMaybe<Array<CourseAssessmentSubmissionFilterInput>>;
	order?: InputMaybe<CourseAssessmentSubmissionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredCourseAssessmentsArgs = {
	filters?: InputMaybe<Array<CourseAssessmentFilterInput>>;
	order?: InputMaybe<CourseAssessmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredCourseAttendanceRecordsArgs = {
	filters?: InputMaybe<Array<CourseAttendanceRecordFilterInput>>;
	order?: InputMaybe<CourseAttendanceRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredMessageGroupArchivePointsArgs = {
	filters?: InputMaybe<Array<MessageGroupArchivePointFilterInput>>;
	order?: InputMaybe<MessageGroupArchivePointOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredMessagesArgs = {
	filters?: InputMaybe<Array<MessageFilterInput>>;
	order?: InputMaybe<MessageOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredNewslettersArgs = {
	filters?: InputMaybe<Array<NewsletterFilterInput>>;
	order?: InputMaybe<NewsletterOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredPostsArgs = {
	filters?: InputMaybe<Array<PostFilterInput>>;
	order?: InputMaybe<PostOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredSchoolAttendanceRecordsArgs = {
	filters?: InputMaybe<Array<SchoolAttendanceRecordFilterInput>>;
	order?: InputMaybe<SchoolAttendanceRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredSocialCommentsArgs = {
	filters?: InputMaybe<Array<SocialCommentFilterInput>>;
	order?: InputMaybe<SocialCommentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredSocialReactionsArgs = {
	filters?: InputMaybe<Array<SocialReactionFilterInput>>;
	order?: InputMaybe<SocialReactionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredStudentDataConsentsArgs = {
	filters?: InputMaybe<Array<StudentDataConsentFilterInput>>;
	order?: InputMaybe<StudentDataConsentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredStudentInformationVerificationsArgs = {
	filters?: InputMaybe<Array<StudentInformationVerificationFilterInput>>;
	order?: InputMaybe<StudentInformationVerificationOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredStudentMedicalEventsArgs = {
	filters?: InputMaybe<Array<StudentMedicalEventFilterInput>>;
	order?: InputMaybe<StudentMedicalEventOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredStudentNotesArgs = {
	filters?: InputMaybe<Array<StudentNoteFilterInput>>;
	order?: InputMaybe<StudentNoteOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserLoginRecordsArgs = {
	filters?: InputMaybe<Array<LoginRecordFilterInput>>;
	order?: InputMaybe<LoginRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserMemberGroupsArgs = {
	filters?: InputMaybe<Array<UserGroupFilterInput>>;
	order?: InputMaybe<UserGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserMessageAvailabilityPeriodsArgs = {
	filters?: InputMaybe<Array<MessageAvailabilityPeriodFilterInput>>;
	order?: InputMaybe<MessageAvailabilityPeriodOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserMessageGroupsArgs = {
	filters?: InputMaybe<Array<MessageGroupFilterInput>>;
	order?: InputMaybe<MessageGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserMFAInvalidOTPAttemptsArgs = {
	filters?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput>>;
	order?: InputMaybe<MFAInvalidOTPAttemptOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserPermissionGroupsArgs = {
	filters?: InputMaybe<Array<PermissionGroupFilterInput>>;
	order?: InputMaybe<PermissionGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserSessionsArgs = {
	filters?: InputMaybe<Array<SessionFilterInput>>;
	order?: InputMaybe<SessionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserSharedSharingRecordsArgs = {
	filters?: InputMaybe<Array<SharingRecordFilterInput>>;
	order?: InputMaybe<SharingRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserSharingRecordsArgs = {
	filters?: InputMaybe<Array<SharingRecordFilterInput>>;
	order?: InputMaybe<SharingRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserSubmittedReportCardSectionsArgs = {
	filters?: InputMaybe<Array<ReportCardSectionFilterInput>>;
	order?: InputMaybe<ReportCardSectionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserTrustedDevicesArgs = {
	filters?: InputMaybe<Array<TrustedDeviceFilterInput>>;
	order?: InputMaybe<TrustedDeviceOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserUserGroupsArgs = {
	filters?: InputMaybe<Array<UserGroupFilterInput>>;
	order?: InputMaybe<UserGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserUserViewRecordsArgs = {
	filters?: InputMaybe<Array<UserViewRecordFilterInput>>;
	order?: InputMaybe<UserViewRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserConnection = {
	__typename?: "UserConnection";
	edges: Array<UserEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserCreateInput = {
	email: Scalars["String"]["input"];
	messageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	permissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	person?: InputMaybe<PersonInUserCreateInput>;
	personID?: InputMaybe<Scalars["ID"]["input"]>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	timeZoneName?: InputMaybe<Scalars["String"]["input"]>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserEdge = {
	__typename?: "UserEdge";
	cursor: Scalars["Cursor"]["output"];
	node: User;
};

export enum UserExternalNotificationFrequency {
	Daily = "daily",
	Never = "never",
	Weekly = "weekly",
}

export type UserExternalNotificationMarker = Node & {
	__typename?: "UserExternalNotificationMarker";
	id: Scalars["ID"]["output"];
	lastCommunicationCheck: Scalars["Time"]["output"];
	lastNewsletterCheck: Scalars["Time"]["output"];
	lastSocialCheck: Scalars["Time"]["output"];
	user: User;
	userID: Scalars["ID"]["output"];
};

export type UserExternalNotificationMarkerConnection = {
	__typename?: "UserExternalNotificationMarkerConnection";
	edges: Array<UserExternalNotificationMarkerEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserExternalNotificationMarkerEdge = {
	__typename?: "UserExternalNotificationMarkerEdge";
	cursor: Scalars["Cursor"]["output"];
	node: UserExternalNotificationMarker;
};

export type UserExternalNotificationMarkerFilterInput = {
	and?: InputMaybe<Array<UserExternalNotificationMarkerFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	lastCommunicationCheckEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastCommunicationCheckGT?: InputMaybe<Scalars["Time"]["input"]>;
	lastCommunicationCheckGTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastCommunicationCheckIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	lastCommunicationCheckLT?: InputMaybe<Scalars["Time"]["input"]>;
	lastCommunicationCheckLTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastCommunicationCheckNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastCommunicationCheckNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	lastNewsletterCheckEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastNewsletterCheckGT?: InputMaybe<Scalars["Time"]["input"]>;
	lastNewsletterCheckGTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastNewsletterCheckIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	lastNewsletterCheckLT?: InputMaybe<Scalars["Time"]["input"]>;
	lastNewsletterCheckLTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastNewsletterCheckNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastNewsletterCheckNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	lastSocialCheckEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastSocialCheckGT?: InputMaybe<Scalars["Time"]["input"]>;
	lastSocialCheckGTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastSocialCheckIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	lastSocialCheckLT?: InputMaybe<Scalars["Time"]["input"]>;
	lastSocialCheckLTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastSocialCheckNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastSocialCheckNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	not?: InputMaybe<UserExternalNotificationMarkerFilterInput>;
	or?: InputMaybe<Array<UserExternalNotificationMarkerFilterInput>>;
	user?: InputMaybe<Array<UserFilterInput>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserExternalNotificationMarkerOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserExternalNotificationMarkerOrderField>;
};

export enum UserExternalNotificationMarkerOrderField {
	LastCommunicationCheck = "LAST_COMMUNICATION_CHECK",
	LastNewsletterCheck = "LAST_NEWSLETTER_CHECK",
	LastSocialCheck = "LAST_SOCIAL_CHECK",
}

export type UserFilterInput = {
	and?: InputMaybe<Array<UserFilterInput>>;
	approvedContracts?: InputMaybe<Array<ContractFilterInput>>;
	approvedReportCards?: InputMaybe<Array<ReportCardFilterInput>>;
	authoredAnnouncements?: InputMaybe<Array<AnnouncementFilterInput>>;
	authoredCalendarEventResponses?: InputMaybe<Array<CalendarEventResponseFilterInput>>;
	authoredCalendarEvents?: InputMaybe<Array<CalendarEventFilterInput>>;
	authoredCourseAssessmentMarks?: InputMaybe<Array<CourseAssessmentMarkFilterInput>>;
	authoredCourseAssessmentSubmissions?: InputMaybe<Array<CourseAssessmentSubmissionFilterInput>>;
	authoredCourseAssessments?: InputMaybe<Array<CourseAssessmentFilterInput>>;
	authoredCourseAttendanceRecords?: InputMaybe<Array<CourseAttendanceRecordFilterInput>>;
	authoredMessageGroupArchivePoints?: InputMaybe<Array<MessageGroupArchivePointFilterInput>>;
	authoredMessages?: InputMaybe<Array<MessageFilterInput>>;
	authoredNewsletters?: InputMaybe<Array<NewsletterFilterInput>>;
	authoredPosts?: InputMaybe<Array<PostFilterInput>>;
	authoredSchoolAttendanceRecords?: InputMaybe<Array<SchoolAttendanceRecordFilterInput>>;
	authoredSocialComments?: InputMaybe<Array<SocialCommentFilterInput>>;
	authoredSocialReactions?: InputMaybe<Array<SocialReactionFilterInput>>;
	authoredStudentDataConsents?: InputMaybe<Array<StudentDataConsentFilterInput>>;
	authoredStudentInformationVerifications?: InputMaybe<Array<StudentInformationVerificationFilterInput>>;
	authoredStudentMedicalEvents?: InputMaybe<Array<StudentMedicalEventFilterInput>>;
	authoredStudentNotes?: InputMaybe<Array<StudentNoteFilterInput>>;
	emailContains?: InputMaybe<Scalars["String"]["input"]>;
	emailEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	emailNEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailNotContains?: InputMaybe<Scalars["String"]["input"]>;
	emailNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	externalNotificationFrequencyEQ?: InputMaybe<UserExternalNotificationFrequency>;
	externalNotificationFrequencyIn?: InputMaybe<Array<UserExternalNotificationFrequency>>;
	externalNotificationFrequencyNEQ?: InputMaybe<UserExternalNotificationFrequency>;
	externalNotificationFrequencyNotIn?: InputMaybe<Array<UserExternalNotificationFrequency>>;
	hasApprovedContracts?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasApprovedReportCards?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredAnnouncements?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredCalendarEventResponses?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredCalendarEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredCourseAssessmentMarks?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredCourseAssessmentSubmissions?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredCourseAssessments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredCourseAttendanceRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredMessageGroupArchivePoints?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredMessages?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredNewsletters?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredPosts?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredSchoolAttendanceRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredSocialComments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredSocialReactions?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredStudentDataConsents?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredStudentInformationVerifications?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredStudentMedicalEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredStudentNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasLoginRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMFAFactor?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMFAInvalidOTPAttempts?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMemberGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMessageAvailabilityPeriods?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMessageGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPermissionGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPerson?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSessions?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharedSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSubmittedReportCardSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasTrustedDevices?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUserExternalNotificationMarker?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUserViewRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isCurrentEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	loginRecords?: InputMaybe<Array<LoginRecordFilterInput>>;
	memberGroups?: InputMaybe<Array<UserGroupFilterInput>>;
	messageAvailabilityPeriods?: InputMaybe<Array<MessageAvailabilityPeriodFilterInput>>;
	messageGroups?: InputMaybe<Array<MessageGroupFilterInput>>;
	mfaFactor?: InputMaybe<Array<MFAFactorFilterInput>>;
	mfaInvalidOTPAttempts?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput>>;
	not?: InputMaybe<UserFilterInput>;
	or?: InputMaybe<Array<UserFilterInput>>;
	passwordUpdatedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	passwordUpdatedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	permissionGroups?: InputMaybe<Array<PermissionGroupFilterInput>>;
	person?: InputMaybe<Array<PersonFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	sessions?: InputMaybe<Array<SessionFilterInput>>;
	sharedSharingRecords?: InputMaybe<Array<SharingRecordFilterInput>>;
	sharingRecords?: InputMaybe<Array<SharingRecordFilterInput>>;
	statusEQ?: InputMaybe<UserStatus>;
	statusIn?: InputMaybe<Array<UserStatus>>;
	statusNEQ?: InputMaybe<UserStatus>;
	statusNotIn?: InputMaybe<Array<UserStatus>>;
	submittedReportCardSections?: InputMaybe<Array<ReportCardSectionFilterInput>>;
	timeZoneNameContains?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	timeZoneNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	trustedDevices?: InputMaybe<Array<TrustedDeviceFilterInput>>;
	userExternalNotificationMarker?: InputMaybe<Array<UserExternalNotificationMarkerFilterInput>>;
	userGroups?: InputMaybe<Array<UserGroupFilterInput>>;
	userViewRecords?: InputMaybe<Array<UserViewRecordFilterInput>>;
};

export type UserGroup = Node & {
	__typename?: "UserGroup";
	classYearCategories: Array<ClassYearCategory>;
	classYears: Array<ClassYear>;
	color: Scalars["String"]["output"];
	courseSections: Array<CourseSection>;
	description: Scalars["String"]["output"];
	homeRoomSections: Array<HomeRoomSection>;
	id: Scalars["ID"]["output"];
	includeAllUsersOfPersonTypes: Scalars["Boolean"]["output"];
	includeEmployees: Scalars["Boolean"]["output"];
	includeGuardians: Scalars["Boolean"]["output"];
	isPublic: Scalars["Boolean"]["output"];
	members: Array<User>;
	messageGroups: Array<MessageGroup>;
	name: Scalars["String"]["output"];
	sharingRecords: Array<SharingRecord>;
	users: Array<User>;
};

export type UserGroupClassYearCategoriesArgs = {
	filters?: InputMaybe<Array<ClassYearCategoryFilterInput>>;
	order?: InputMaybe<ClassYearCategoryOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserGroupClassYearsArgs = {
	filters?: InputMaybe<Array<ClassYearFilterInput>>;
	order?: InputMaybe<ClassYearOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserGroupCourseSectionsArgs = {
	filters?: InputMaybe<Array<CourseSectionFilterInput>>;
	order?: InputMaybe<CourseSectionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserGroupHomeRoomSectionsArgs = {
	filters?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
	order?: InputMaybe<HomeRoomSectionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserGroupMembersArgs = {
	filters?: InputMaybe<Array<UserFilterInput>>;
	order?: InputMaybe<UserOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserGroupMessageGroupsArgs = {
	filters?: InputMaybe<Array<MessageGroupFilterInput>>;
	order?: InputMaybe<MessageGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserGroupSharingRecordsArgs = {
	filters?: InputMaybe<Array<SharingRecordFilterInput>>;
	order?: InputMaybe<SharingRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserGroupUsersArgs = {
	filters?: InputMaybe<Array<UserFilterInput>>;
	order?: InputMaybe<UserOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserGroupClassYearCategoryHistory = Node & {
	__typename?: "UserGroupClassYearCategoryHistory";
	classYearCategoryID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	userGroupID: Maybe<Scalars["ID"]["output"]>;
};

export type UserGroupClassYearCategoryHistoryConnection = {
	__typename?: "UserGroupClassYearCategoryHistoryConnection";
	edges: Array<UserGroupClassYearCategoryHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserGroupClassYearCategoryHistoryEdge = {
	__typename?: "UserGroupClassYearCategoryHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: UserGroupClassYearCategoryHistory;
};

export type UserGroupClassYearCategoryHistoryFilterInput = {
	and?: InputMaybe<Array<UserGroupClassYearCategoryHistoryFilterInput>>;
	classYearCategoryIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearCategoryIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearCategoryIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	classYearCategoryIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearCategoryIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<UserGroupClassYearCategoryHistoryFilterInput>;
	or?: InputMaybe<Array<UserGroupClassYearCategoryHistoryFilterInput>>;
	userGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserGroupClassYearCategoryHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserGroupClassYearCategoryHistoryOrderField>;
};

export enum UserGroupClassYearCategoryHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type UserGroupClassYearHistory = Node & {
	__typename?: "UserGroupClassYearHistory";
	classYearID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	userGroupID: Maybe<Scalars["ID"]["output"]>;
};

export type UserGroupClassYearHistoryConnection = {
	__typename?: "UserGroupClassYearHistoryConnection";
	edges: Array<UserGroupClassYearHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserGroupClassYearHistoryEdge = {
	__typename?: "UserGroupClassYearHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: UserGroupClassYearHistory;
};

export type UserGroupClassYearHistoryFilterInput = {
	and?: InputMaybe<Array<UserGroupClassYearHistoryFilterInput>>;
	classYearIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	classYearIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	classYearIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<UserGroupClassYearHistoryFilterInput>;
	or?: InputMaybe<Array<UserGroupClassYearHistoryFilterInput>>;
	userGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserGroupClassYearHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserGroupClassYearHistoryOrderField>;
};

export enum UserGroupClassYearHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type UserGroupConnection = {
	__typename?: "UserGroupConnection";
	edges: Array<UserGroupEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserGroupCourseSectionHistory = Node & {
	__typename?: "UserGroupCourseSectionHistory";
	courseSectionID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	userGroupID: Maybe<Scalars["ID"]["output"]>;
};

export type UserGroupCourseSectionHistoryConnection = {
	__typename?: "UserGroupCourseSectionHistoryConnection";
	edges: Array<UserGroupCourseSectionHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserGroupCourseSectionHistoryEdge = {
	__typename?: "UserGroupCourseSectionHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: UserGroupCourseSectionHistory;
};

export type UserGroupCourseSectionHistoryFilterInput = {
	and?: InputMaybe<Array<UserGroupCourseSectionHistoryFilterInput>>;
	courseSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	courseSectionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	courseSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<UserGroupCourseSectionHistoryFilterInput>;
	or?: InputMaybe<Array<UserGroupCourseSectionHistoryFilterInput>>;
	userGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserGroupCourseSectionHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserGroupCourseSectionHistoryOrderField>;
};

export enum UserGroupCourseSectionHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type UserGroupCreateInput = {
	classYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	color?: InputMaybe<Scalars["String"]["input"]>;
	courseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	homeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	includeAllUsersOfPersonTypes?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name: Scalars["String"]["input"];
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserGroupEdge = {
	__typename?: "UserGroupEdge";
	cursor: Scalars["Cursor"]["output"];
	node: UserGroup;
};

export type UserGroupFilterInput = {
	and?: InputMaybe<Array<UserGroupFilterInput>>;
	classYearCategories?: InputMaybe<Array<ClassYearCategoryFilterInput>>;
	classYears?: InputMaybe<Array<ClassYearFilterInput>>;
	colorContains?: InputMaybe<Scalars["String"]["input"]>;
	colorEQ?: InputMaybe<Scalars["String"]["input"]>;
	colorHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	colorHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	colorIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	colorNEQ?: InputMaybe<Scalars["String"]["input"]>;
	colorNotContains?: InputMaybe<Scalars["String"]["input"]>;
	colorNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	colorNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	colorNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	courseSections?: InputMaybe<Array<CourseSectionFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasClassYearCategories?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasClassYears?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCourseSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasHomeRoomSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMembers?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMessageGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoomSections?: InputMaybe<Array<HomeRoomSectionFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	includeAllUsersOfPersonTypesEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeAllUsersOfPersonTypesNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployeesEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployeesNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardiansEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardiansNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublicEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublicNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	members?: InputMaybe<Array<UserFilterInput>>;
	messageGroups?: InputMaybe<Array<MessageGroupFilterInput>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<UserGroupFilterInput>;
	or?: InputMaybe<Array<UserGroupFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	sharingRecords?: InputMaybe<Array<SharingRecordFilterInput>>;
	users?: InputMaybe<Array<UserFilterInput>>;
};

export type UserGroupHistory = Node & {
	__typename?: "UserGroupHistory";
	color: Maybe<Scalars["String"]["output"]>;
	description: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	includeAllUsersOfPersonTypes: Maybe<Scalars["Boolean"]["output"]>;
	includeEmployees: Maybe<Scalars["Boolean"]["output"]>;
	includeGuardians: Maybe<Scalars["Boolean"]["output"]>;
	isPublic: Maybe<Scalars["Boolean"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type UserGroupHistoryConnection = {
	__typename?: "UserGroupHistoryConnection";
	edges: Array<UserGroupHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserGroupHistoryEdge = {
	__typename?: "UserGroupHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: UserGroupHistory;
};

export type UserGroupHistoryFilterInput = {
	and?: InputMaybe<Array<UserGroupHistoryFilterInput>>;
	colorContains?: InputMaybe<Scalars["String"]["input"]>;
	colorEQ?: InputMaybe<Scalars["String"]["input"]>;
	colorHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	colorHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	colorIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	colorIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	colorNEQ?: InputMaybe<Scalars["String"]["input"]>;
	colorNotContains?: InputMaybe<Scalars["String"]["input"]>;
	colorNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	colorNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	colorNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	includeAllUsersOfPersonTypesEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeAllUsersOfPersonTypesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeAllUsersOfPersonTypesNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployeesEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployeesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployeesNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardiansEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardiansIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardiansNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublicEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublicIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublicNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<UserGroupHistoryFilterInput>;
	or?: InputMaybe<Array<UserGroupHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type UserGroupHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserGroupHistoryOrderField>;
};

export enum UserGroupHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type UserGroupHomeRoomSectionHistory = Node & {
	__typename?: "UserGroupHomeRoomSectionHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	homeRoomSectionID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	userGroupID: Maybe<Scalars["ID"]["output"]>;
};

export type UserGroupHomeRoomSectionHistoryConnection = {
	__typename?: "UserGroupHomeRoomSectionHistoryConnection";
	edges: Array<UserGroupHomeRoomSectionHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserGroupHomeRoomSectionHistoryEdge = {
	__typename?: "UserGroupHomeRoomSectionHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: UserGroupHomeRoomSectionHistory;
};

export type UserGroupHomeRoomSectionHistoryFilterInput = {
	and?: InputMaybe<Array<UserGroupHomeRoomSectionHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	homeRoomSectionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	homeRoomSectionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<UserGroupHomeRoomSectionHistoryFilterInput>;
	or?: InputMaybe<Array<UserGroupHomeRoomSectionHistoryFilterInput>>;
	userGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserGroupHomeRoomSectionHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserGroupHomeRoomSectionHistoryOrderField>;
};

export enum UserGroupHomeRoomSectionHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type UserGroupMemberGroupUserMemberHistory = Node & {
	__typename?: "UserGroupMemberGroupUserMemberHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	userGroupID: Maybe<Scalars["ID"]["output"]>;
	userID: Maybe<Scalars["ID"]["output"]>;
};

export type UserGroupMemberGroupUserMemberHistoryConnection = {
	__typename?: "UserGroupMemberGroupUserMemberHistoryConnection";
	edges: Array<UserGroupMemberGroupUserMemberHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserGroupMemberGroupUserMemberHistoryEdge = {
	__typename?: "UserGroupMemberGroupUserMemberHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: UserGroupMemberGroupUserMemberHistory;
};

export type UserGroupMemberGroupUserMemberHistoryFilterInput = {
	and?: InputMaybe<Array<UserGroupMemberGroupUserMemberHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<UserGroupMemberGroupUserMemberHistoryFilterInput>;
	or?: InputMaybe<Array<UserGroupMemberGroupUserMemberHistoryFilterInput>>;
	userGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserGroupMemberGroupUserMemberHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserGroupMemberGroupUserMemberHistoryOrderField>;
};

export enum UserGroupMemberGroupUserMemberHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type UserGroupOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserGroupOrderField>;
};

export enum UserGroupOrderField {
	Name = "NAME",
}

export type UserGroupUpdateBulkInput = {
	addClassYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addCourseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addHomeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addMessageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearClassYearCategories?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearClassYears?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearCourseSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearHomeRoomSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearMessageGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	color?: InputMaybe<Scalars["String"]["input"]>;
	courseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	homeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	includeAllUsersOfPersonTypes?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeClassYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeCourseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeHomeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeMessageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserGroupUpdateInput = {
	addClassYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addCourseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addHomeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addMessageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	classYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearClassYearCategories?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearClassYears?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearCourseSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearHomeRoomSections?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearMessageGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	color?: InputMaybe<Scalars["String"]["input"]>;
	courseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	homeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	includeAllUsersOfPersonTypes?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
	includeGuardians?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeClassYearCategoryIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeClassYearIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeCourseSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeHomeRoomSectionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeMessageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserGroupUserHistory = Node & {
	__typename?: "UserGroupUserHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	userGroupID: Maybe<Scalars["ID"]["output"]>;
	userID: Maybe<Scalars["ID"]["output"]>;
};

export type UserGroupUserHistoryConnection = {
	__typename?: "UserGroupUserHistoryConnection";
	edges: Array<UserGroupUserHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserGroupUserHistoryEdge = {
	__typename?: "UserGroupUserHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: UserGroupUserHistory;
};

export type UserGroupUserHistoryFilterInput = {
	and?: InputMaybe<Array<UserGroupUserHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<UserGroupUserHistoryFilterInput>;
	or?: InputMaybe<Array<UserGroupUserHistoryFilterInput>>;
	userGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserGroupUserHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserGroupUserHistoryOrderField>;
};

export enum UserGroupUserHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type UserHistory = Node & {
	__typename?: "UserHistory";
	email: Maybe<Scalars["String"]["output"]>;
	externalNotificationFrequency: Maybe<UserHistoryExternalNotificationFrequency>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
	passwordUpdatedAt: Maybe<Scalars["Time"]["output"]>;
	status: Maybe<UserHistoryStatus>;
	timeZoneName: Maybe<Scalars["String"]["output"]>;
};

export type UserHistoryConnection = {
	__typename?: "UserHistoryConnection";
	edges: Array<UserHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserHistoryEdge = {
	__typename?: "UserHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: UserHistory;
};

export enum UserHistoryExternalNotificationFrequency {
	Daily = "daily",
	Never = "never",
	Weekly = "weekly",
}

export type UserHistoryFilterInput = {
	and?: InputMaybe<Array<UserHistoryFilterInput>>;
	emailContains?: InputMaybe<Scalars["String"]["input"]>;
	emailEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	emailIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	emailNEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailNotContains?: InputMaybe<Scalars["String"]["input"]>;
	emailNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	externalNotificationFrequencyEQ?: InputMaybe<UserHistoryExternalNotificationFrequency>;
	externalNotificationFrequencyIn?: InputMaybe<Array<UserHistoryExternalNotificationFrequency>>;
	externalNotificationFrequencyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	externalNotificationFrequencyNEQ?: InputMaybe<UserHistoryExternalNotificationFrequency>;
	externalNotificationFrequencyNotIn?: InputMaybe<Array<UserHistoryExternalNotificationFrequency>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<UserHistoryFilterInput>;
	or?: InputMaybe<Array<UserHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	passwordUpdatedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	passwordUpdatedAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	passwordUpdatedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	statusEQ?: InputMaybe<UserHistoryStatus>;
	statusIn?: InputMaybe<Array<UserHistoryStatus>>;
	statusIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	statusNEQ?: InputMaybe<UserHistoryStatus>;
	statusNotIn?: InputMaybe<Array<UserHistoryStatus>>;
	timeZoneNameContains?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	timeZoneNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	timeZoneNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type UserHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserHistoryOrderField>;
};

export enum UserHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export enum UserHistoryStatus {
	Active = "active",
	Created = "created",
	Disabled = "disabled",
	Invited = "invited",
}

export type UserInPersonCreateInput = {
	email: Scalars["String"]["input"];
	messageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	permissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	timeZoneName?: InputMaybe<Scalars["String"]["input"]>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserOrderField>;
};

export enum UserOrderField {
	Email = "EMAIL",
	ExternalNotificationFrequency = "EXTERNAL_NOTIFICATION_FREQUENCY",
	PasswordUpdatedAt = "PASSWORD_UPDATED_AT",
	Status = "STATUS",
}

export enum UserStatus {
	Active = "active",
	Created = "created",
	Disabled = "disabled",
	Invited = "invited",
}

export type UserUpdateBulkInput = {
	addMessageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addPermissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearMessageGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearPermissionGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	externalNotificationFrequency?: InputMaybe<UserExternalNotificationFrequency>;
	messageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	permissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeMessageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePermissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	status?: InputMaybe<UserStatus>;
	timeZoneName?: InputMaybe<Scalars["String"]["input"]>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserUpdateInput = {
	addMessageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addPermissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearMessageGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearPermissionGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearPerson?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearSharingRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	email?: InputMaybe<Scalars["String"]["input"]>;
	externalNotificationFrequency?: InputMaybe<UserExternalNotificationFrequency>;
	messageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	permissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	personID?: InputMaybe<Scalars["ID"]["input"]>;
	removeMessageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePermissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	status?: InputMaybe<UserStatus>;
	timeZoneName?: InputMaybe<Scalars["String"]["input"]>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserViewRecord = Node & {
	__typename?: "UserViewRecord";
	firstViewedAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	lastViewedAt: Scalars["Time"]["output"];
	targetID: Scalars["ID"]["output"];
	user: User;
	userID: Scalars["ID"]["output"];
};

export type UserViewRecordConnection = {
	__typename?: "UserViewRecordConnection";
	edges: Array<UserViewRecordEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserViewRecordCreateInput = {
	targetID: Scalars["ID"]["input"];
};

export type UserViewRecordEdge = {
	__typename?: "UserViewRecordEdge";
	cursor: Scalars["Cursor"]["output"];
	node: UserViewRecord;
};

export type UserViewRecordFilterInput = {
	and?: InputMaybe<Array<UserViewRecordFilterInput>>;
	firstViewedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	firstViewedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	firstViewedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	firstViewedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	firstViewedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	firstViewedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	firstViewedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	firstViewedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	lastViewedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastViewedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	lastViewedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastViewedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	lastViewedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	lastViewedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastViewedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastViewedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	not?: InputMaybe<UserViewRecordFilterInput>;
	or?: InputMaybe<Array<UserViewRecordFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	targetIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	targetIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	targetIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	targetIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	user?: InputMaybe<Array<UserFilterInput>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserViewRecordInUserCreateInput = {
	targetID: Scalars["ID"]["input"];
};

export type UserViewRecordOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserViewRecordOrderField>;
};

export enum UserViewRecordOrderField {
	FirstViewedAt = "FIRST_VIEWED_AT",
	LastViewedAt = "LAST_VIEWED_AT",
}

export type UserViewRecordUpdateInput = {
	_filler?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Vaccine = Node & {
	__typename?: "Vaccine";
	description: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
	studentVaccinationRecords: Array<StudentVaccinationRecord>;
};

export type VaccineStudentVaccinationRecordsArgs = {
	filters?: InputMaybe<Array<StudentVaccinationRecordFilterInput>>;
	order?: InputMaybe<StudentVaccinationRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type VaccineConnection = {
	__typename?: "VaccineConnection";
	edges: Array<VaccineEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type VaccineCreateInput = {
	description?: InputMaybe<Scalars["String"]["input"]>;
	name: Scalars["String"]["input"];
	studentVaccinationRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentVaccinationRecords?: InputMaybe<Array<StudentVaccinationRecordInVaccineCreateInput>>;
};

export type VaccineEdge = {
	__typename?: "VaccineEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Vaccine;
};

export type VaccineFilterInput = {
	and?: InputMaybe<Array<VaccineFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasStudentVaccinationRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<VaccineFilterInput>;
	or?: InputMaybe<Array<VaccineFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	studentVaccinationRecords?: InputMaybe<Array<StudentVaccinationRecordFilterInput>>;
};

export type VaccineHistory = Node & {
	__typename?: "VaccineHistory";
	description: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type VaccineHistoryConnection = {
	__typename?: "VaccineHistoryConnection";
	edges: Array<VaccineHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type VaccineHistoryEdge = {
	__typename?: "VaccineHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: VaccineHistory;
};

export type VaccineHistoryFilterInput = {
	and?: InputMaybe<Array<VaccineHistoryFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<VaccineHistoryFilterInput>;
	or?: InputMaybe<Array<VaccineHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type VaccineHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<VaccineHistoryOrderField>;
};

export enum VaccineHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type VaccineOrder = {
	direction: OrderDirection;
	field?: InputMaybe<VaccineOrderField>;
};

export enum VaccineOrderField {
	Name = "NAME",
}

export type VaccineUpdateBulkInput = {
	addStudentVaccinationRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearStudentVaccinationRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeStudentVaccinationRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentVaccinationRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type VaccineUpdateInput = {
	addStudentVaccinationRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearStudentVaccinationRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeStudentVaccinationRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	studentVaccinationRecordIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type AcademicSubjectCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<AcademicSubjectFilterInput> | AcademicSubjectFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AcademicSubjectOrder>;
}>;

export type AcademicSubjectCountQuery = {
	__typename?: "Query";
	academicSubjectConnection: { __typename?: "AcademicSubjectConnection"; totalCount: number };
};

export type AcademicSubjectCreateMutationVariables = Exact<{
	input: AcademicSubjectCreateInput;
}>;

export type AcademicSubjectCreateMutation = {
	__typename?: "Mutation";
	createAcademicSubject: { __typename?: "AcademicSubject"; id: string; name: string; color: string };
};

export type AcademicSubjectDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AcademicSubjectDeleteMutation = { __typename?: "Mutation"; deleteAcademicSubject: boolean };

export type AcademicSubjectDetailFragment = { __typename?: "AcademicSubject"; id: string; name: string; color: string };

export type AcademicSubjectDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AcademicSubjectDetailQuery = {
	__typename?: "Query";
	academicSubject: { __typename?: "AcademicSubject"; id: string; name: string; color: string };
};

export type AcademicSubjectIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<AcademicSubjectFilterInput> | AcademicSubjectFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AcademicSubjectOrder>;
}>;

export type AcademicSubjectIndexQuery = {
	__typename?: "Query";
	academicSubjectConnection: {
		__typename?: "AcademicSubjectConnection";
		edges: Array<{
			__typename?: "AcademicSubjectEdge";
			node: { __typename?: "AcademicSubject"; id: string; name: string; color: string };
		}>;
	};
};

export type AcademicSubjectNameFragment = { __typename?: "AcademicSubject"; name: string };

export type AcademicSubjectNameAndColorFragment = { __typename?: "AcademicSubject"; name: string; color: string };

export type AcademicSubjectNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AcademicSubjectNameQuery = {
	__typename?: "Query";
	academicSubject: { __typename?: "AcademicSubject"; id: string; name: string };
};

export type AcademicSubjectNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<AcademicSubjectFilterInput> | AcademicSubjectFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AcademicSubjectOrder>;
}>;

export type AcademicSubjectNamesQuery = {
	__typename?: "Query";
	academicSubjectConnection: {
		__typename?: "AcademicSubjectConnection";
		edges: Array<{
			__typename?: "AcademicSubjectEdge";
			node: { __typename?: "AcademicSubject"; id: string; name: string };
		}>;
	};
};

export type AcademicSubjectPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<AcademicSubjectFilterInput> | AcademicSubjectFilterInput>;
	order?: InputMaybe<AcademicSubjectOrder>;
}>;

export type AcademicSubjectPaginationQuery = {
	__typename?: "Query";
	academicSubjectConnection: {
		__typename?: "AcademicSubjectConnection";
		totalCount: number;
		edges: Array<{ __typename?: "AcademicSubjectEdge"; cursor: string }>;
	};
};

export type AcademicSubjectSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<AcademicSubjectFilterInput> | AcademicSubjectFilterInput>;
	order?: InputMaybe<AcademicSubjectOrder>;
}>;

export type AcademicSubjectSelectQuery = {
	__typename?: "Query";
	academicSubjectConnection: {
		__typename?: "AcademicSubjectConnection";
		edges: Array<{
			__typename?: "AcademicSubjectEdge";
			node: { __typename?: "AcademicSubject"; id: string; name: string };
		}>;
	};
};

export type AcademicSubjectUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: AcademicSubjectUpdateInput;
}>;

export type AcademicSubjectUpdateMutation = {
	__typename?: "Mutation";
	updateAcademicSubject: { __typename?: "AcademicSubject"; id: string; name: string; color: string };
};

export type AcademicTermCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<AcademicTermFilterInput> | AcademicTermFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AcademicTermOrder>;
}>;

export type AcademicTermCountQuery = {
	__typename?: "Query";
	academicTermConnection: { __typename?: "AcademicTermConnection"; totalCount: number };
};

export type AcademicTermCreateMutationVariables = Exact<{
	input: AcademicTermCreateInput;
}>;

export type AcademicTermCreateMutation = {
	__typename?: "Mutation";
	createAcademicTerm: {
		__typename?: "AcademicTerm";
		id: string;
		name: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		startDate: string;
		endDate: string;
		academicYear: { __typename?: "AcademicYear"; id: string; name: string };
	};
};

export type AcademicTermsDatesListQueryVariables = Exact<{
	filters?: InputMaybe<Array<AcademicTermFilterInput> | AcademicTermFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AcademicTermOrder>;
}>;

export type AcademicTermsDatesListQuery = {
	__typename?: "Query";
	academicTermConnection: {
		__typename?: "AcademicTermConnection";
		edges: Array<{
			__typename?: "AcademicTermEdge";
			node: {
				__typename?: "AcademicTerm";
				id: string;
				name: string;
				startDate: string;
				endDate: string;
				academicYear: { __typename?: "AcademicYear"; id: string; name: string };
			};
		}>;
	};
};

export type AcademicTermDatesQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AcademicTermDatesQuery = {
	__typename?: "Query";
	academicTerm: {
		__typename?: "AcademicTerm";
		id: string;
		name: string;
		startDate: string;
		endDate: string;
		academicYear: { __typename?: "AcademicYear"; id: string; name: string };
	};
};

export type AcademicTermsPreviousAndNextQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
	date: Scalars["Date"]["input"];
}>;

export type AcademicTermsPreviousAndNextQuery = {
	__typename?: "Query";
	previous: {
		__typename?: "AcademicTermConnection";
		edges: Array<{
			__typename?: "AcademicTermEdge";
			node: {
				__typename?: "AcademicTerm";
				id: string;
				name: string;
				startDate: string;
				endDate: string;
				academicYear: { __typename?: "AcademicYear"; id: string; name: string };
			};
		}>;
	};
	next: {
		__typename?: "AcademicTermConnection";
		edges: Array<{
			__typename?: "AcademicTermEdge";
			node: {
				__typename?: "AcademicTerm";
				id: string;
				name: string;
				startDate: string;
				endDate: string;
				academicYear: { __typename?: "AcademicYear"; id: string; name: string };
			};
		}>;
	};
};

export type AcademicTermDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AcademicTermDeleteMutation = { __typename?: "Mutation"; deleteAcademicTerm: boolean };

export type AcademicTermDetailFragment = {
	__typename?: "AcademicTerm";
	id: string;
	name: string;
	imageURL: string;
	imageKey: string;
	imageContentType: string;
	startDate: string;
	endDate: string;
	academicYear: { __typename?: "AcademicYear"; id: string; name: string };
};

export type AcademicTermDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AcademicTermDetailQuery = {
	__typename?: "Query";
	academicTerm: {
		__typename?: "AcademicTerm";
		id: string;
		name: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		startDate: string;
		endDate: string;
		academicYear: { __typename?: "AcademicYear"; id: string; name: string };
	};
};

export type AcademicTermIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<AcademicTermFilterInput> | AcademicTermFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AcademicTermOrder>;
}>;

export type AcademicTermIndexQuery = {
	__typename?: "Query";
	academicTermConnection: {
		__typename?: "AcademicTermConnection";
		edges: Array<{
			__typename?: "AcademicTermEdge";
			node: {
				__typename?: "AcademicTerm";
				id: string;
				name: string;
				startDate: string;
				endDate: string;
				studentAcademicTermEnrollments: Array<{
					__typename?: "StudentAcademicTermEnrollment";
					id: string;
					lateStartDate: string | null;
					earlyEndDate: string | null;
				}>;
			};
		}>;
	};
};

export type AcademicTermNameFragment = { __typename?: "AcademicTerm"; name: string };

export type AcademicTermNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AcademicTermNameQuery = {
	__typename?: "Query";
	academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
};

export type AcademicTermNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<AcademicTermFilterInput> | AcademicTermFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AcademicTermOrder>;
}>;

export type AcademicTermNamesQuery = {
	__typename?: "Query";
	academicTermConnection: {
		__typename?: "AcademicTermConnection";
		edges: Array<{ __typename?: "AcademicTermEdge"; node: { __typename?: "AcademicTerm"; id: string; name: string } }>;
	};
};

export type AcademicTermPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<AcademicTermFilterInput> | AcademicTermFilterInput>;
	order?: InputMaybe<AcademicTermOrder>;
}>;

export type AcademicTermPaginationQuery = {
	__typename?: "Query";
	academicTermConnection: {
		__typename?: "AcademicTermConnection";
		totalCount: number;
		edges: Array<{ __typename?: "AcademicTermEdge"; cursor: string }>;
	};
};

export type AcademicTermSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<AcademicTermFilterInput> | AcademicTermFilterInput>;
	order?: InputMaybe<AcademicTermOrder>;
}>;

export type AcademicTermSelectQuery = {
	__typename?: "Query";
	academicTermConnection: {
		__typename?: "AcademicTermConnection";
		edges: Array<{ __typename?: "AcademicTermEdge"; node: { __typename?: "AcademicTerm"; id: string; name: string } }>;
	};
};

export type AcademicTermUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: AcademicTermUpdateInput;
}>;

export type AcademicTermUpdateMutation = {
	__typename?: "Mutation";
	updateAcademicTerm: {
		__typename?: "AcademicTerm";
		id: string;
		name: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		startDate: string;
		endDate: string;
		academicYear: { __typename?: "AcademicYear"; id: string; name: string };
	};
};

export type AcademicYearCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<AcademicYearFilterInput> | AcademicYearFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AcademicYearOrder>;
}>;

export type AcademicYearCountQuery = {
	__typename?: "Query";
	academicYearConnection: { __typename?: "AcademicYearConnection"; totalCount: number };
};

export type AcademicYearCreateMutationVariables = Exact<{
	input: AcademicYearCreateInput;
}>;

export type AcademicYearCreateMutation = {
	__typename?: "Mutation";
	createAcademicYear: {
		__typename?: "AcademicYear";
		id: string;
		name: string;
		academicTerms: Array<{ __typename?: "AcademicTerm"; id: string; name: string }>;
	};
};

export type AcademicYearDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AcademicYearDeleteMutation = { __typename?: "Mutation"; deleteAcademicYear: boolean };

export type AcademicYearDetailFragment = {
	__typename?: "AcademicYear";
	id: string;
	name: string;
	academicTerms: Array<{ __typename?: "AcademicTerm"; id: string; name: string }>;
};

export type AcademicYearDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AcademicYearDetailQuery = {
	__typename?: "Query";
	academicYear: {
		__typename?: "AcademicYear";
		id: string;
		name: string;
		academicTerms: Array<{ __typename?: "AcademicTerm"; id: string; name: string }>;
	};
};

export type AcademicYearIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<AcademicYearFilterInput> | AcademicYearFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AcademicYearOrder>;
}>;

export type AcademicYearIndexQuery = {
	__typename?: "Query";
	academicYearConnection: {
		__typename?: "AcademicYearConnection";
		edges: Array<{
			__typename?: "AcademicYearEdge";
			node: {
				__typename?: "AcademicYear";
				id: string;
				name: string;
				academicTerms: Array<{
					__typename?: "AcademicTerm";
					id: string;
					startDate: string;
					endDate: string;
					name: string;
				}>;
			};
		}>;
	};
};

export type AcademicYearNameFragment = { __typename?: "AcademicYear"; name: string };

export type AcademicYearNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AcademicYearNameQuery = {
	__typename?: "Query";
	academicYear: { __typename?: "AcademicYear"; id: string; name: string };
};

export type AcademicYearNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<AcademicYearFilterInput> | AcademicYearFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AcademicYearOrder>;
}>;

export type AcademicYearNamesQuery = {
	__typename?: "Query";
	academicYearConnection: {
		__typename?: "AcademicYearConnection";
		edges: Array<{ __typename?: "AcademicYearEdge"; node: { __typename?: "AcademicYear"; id: string; name: string } }>;
	};
};

export type AcademicYearPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<AcademicYearFilterInput> | AcademicYearFilterInput>;
	order?: InputMaybe<AcademicYearOrder>;
}>;

export type AcademicYearPaginationQuery = {
	__typename?: "Query";
	academicYearConnection: {
		__typename?: "AcademicYearConnection";
		totalCount: number;
		edges: Array<{ __typename?: "AcademicYearEdge"; cursor: string }>;
	};
};

export type AcademicYearSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<AcademicYearFilterInput> | AcademicYearFilterInput>;
	order?: InputMaybe<AcademicYearOrder>;
}>;

export type AcademicYearSelectQuery = {
	__typename?: "Query";
	academicYearConnection: {
		__typename?: "AcademicYearConnection";
		edges: Array<{ __typename?: "AcademicYearEdge"; node: { __typename?: "AcademicYear"; id: string; name: string } }>;
	};
};

export type AcademicYearUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: AcademicYearUpdateInput;
}>;

export type AcademicYearUpdateMutation = {
	__typename?: "Mutation";
	updateAcademicYear: {
		__typename?: "AcademicYear";
		id: string;
		name: string;
		academicTerms: Array<{ __typename?: "AcademicTerm"; id: string; name: string }>;
	};
};

export type AddressCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<AddressFilterInput> | AddressFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AddressOrder>;
}>;

export type AddressCountQuery = {
	__typename?: "Query";
	addressConnection: { __typename?: "AddressConnection"; totalCount: number };
};

export type AddressCreateMutationVariables = Exact<{
	input: AddressCreateInput;
}>;

export type AddressCreateMutation = {
	__typename?: "Mutation";
	createAddress: {
		__typename?: "Address";
		id: string;
		name: string;
		addressLine1: string;
		addressLine2: string;
		city: string;
		postalCode: string;
		stateOrProvince: string;
		country: { __typename?: "Country"; id: string; name: string };
		people: Array<{ __typename?: "Person"; id: string; name: string; publicName: string }>;
	};
};

export type AddressDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AddressDeleteMutation = { __typename?: "Mutation"; deleteAddress: boolean };

export type AddressDetailFragment = {
	__typename?: "Address";
	id: string;
	name: string;
	addressLine1: string;
	addressLine2: string;
	city: string;
	postalCode: string;
	stateOrProvince: string;
	country: { __typename?: "Country"; id: string; name: string };
	people: Array<{ __typename?: "Person"; id: string; name: string; publicName: string }>;
};

export type AddressDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AddressDetailQuery = {
	__typename?: "Query";
	address: {
		__typename?: "Address";
		id: string;
		name: string;
		addressLine1: string;
		addressLine2: string;
		city: string;
		postalCode: string;
		stateOrProvince: string;
		country: { __typename?: "Country"; id: string; name: string };
		people: Array<{ __typename?: "Person"; id: string; name: string; publicName: string }>;
	};
};

export type AddressIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<AddressFilterInput> | AddressFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AddressOrder>;
}>;

export type AddressIndexQuery = {
	__typename?: "Query";
	addressConnection: {
		__typename?: "AddressConnection";
		edges: Array<{
			__typename?: "AddressEdge";
			node: {
				__typename?: "Address";
				id: string;
				name: string;
				addressLine1: string;
				addressLine2: string;
				city: string;
				postalCode: string;
				stateOrProvince: string;
				country: { __typename?: "Country"; id: string; name: string };
			};
		}>;
	};
};

export type AddressListQueryVariables = Exact<{
	filters?: InputMaybe<Array<AddressFilterInput> | AddressFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AddressOrder>;
}>;

export type AddressListQuery = {
	__typename?: "Query";
	addressConnection: {
		__typename?: "AddressConnection";
		edges: Array<{
			__typename?: "AddressEdge";
			node: {
				__typename?: "Address";
				id: string;
				name: string;
				addressLine1: string;
				addressLine2: string;
				city: string;
				postalCode: string;
				stateOrProvince: string;
				country: { __typename?: "Country"; id: string; name: string };
			};
		}>;
	};
};

export type AddressNameFragment = { __typename?: "Address"; name: string; addressLine1: string };

export type AddressInformationFragment = {
	__typename?: "Address";
	name: string;
	addressLine1: string;
	addressLine2: string;
	city: string;
	postalCode: string;
	stateOrProvince: string;
	country: { __typename?: "Country"; id: string; name: string };
};

export type AddressNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AddressNameQuery = {
	__typename?: "Query";
	address: { __typename?: "Address"; id: string; name: string; addressLine1: string };
};

export type AddressNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<AddressFilterInput> | AddressFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AddressOrder>;
}>;

export type AddressNamesQuery = {
	__typename?: "Query";
	addressConnection: {
		__typename?: "AddressConnection";
		edges: Array<{
			__typename?: "AddressEdge";
			node: { __typename?: "Address"; id: string; name: string; addressLine1: string };
		}>;
	};
};

export type AddressPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<AddressFilterInput> | AddressFilterInput>;
	order?: InputMaybe<AddressOrder>;
}>;

export type AddressPaginationQuery = {
	__typename?: "Query";
	addressConnection: {
		__typename?: "AddressConnection";
		totalCount: number;
		edges: Array<{ __typename?: "AddressEdge"; cursor: string }>;
	};
};

export type AddressSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<AddressFilterInput> | AddressFilterInput>;
	order?: InputMaybe<AddressOrder>;
}>;

export type AddressSelectQuery = {
	__typename?: "Query";
	addressConnection: {
		__typename?: "AddressConnection";
		edges: Array<{
			__typename?: "AddressEdge";
			node: {
				__typename?: "Address";
				id: string;
				name: string;
				addressLine1: string;
				addressLine2: string;
				city: string;
				postalCode: string;
				stateOrProvince: string;
				country: { __typename?: "Country"; id: string; name: string };
			};
		}>;
	};
};

export type AddressUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: AddressUpdateInput;
}>;

export type AddressUpdateMutation = {
	__typename?: "Mutation";
	updateAddress: {
		__typename?: "Address";
		id: string;
		name: string;
		addressLine1: string;
		addressLine2: string;
		city: string;
		postalCode: string;
		stateOrProvince: string;
		country: { __typename?: "Country"; id: string; name: string };
		people: Array<{ __typename?: "Person"; id: string; name: string; publicName: string }>;
	};
};

export type AnnouncementCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AnnouncementOrder>;
}>;

export type AnnouncementCountQuery = {
	__typename?: "Query";
	announcementConnection: { __typename?: "AnnouncementConnection"; totalCount: number };
};

export type AnnouncementCreateMutationVariables = Exact<{
	input: AnnouncementCreateInput;
}>;

export type AnnouncementCreateMutation = {
	__typename?: "Mutation";
	createAnnouncement: {
		__typename?: "Announcement";
		id: string;
		title: string;
		body: string;
		startTime: string;
		endTime: string | null;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
			taggedPeople: Array<{
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
			}>;
		}>;
		sharingRecord: {
			__typename?: "SharingRecord";
			id: string;
			isPublic: boolean;
			includeEmployees: boolean;
			includeGuardians: boolean;
			includeAllUsersOfPersonTypes: boolean;
			classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
			classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
			courseSections: Array<{
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			}>;
			homeRoomSections: Array<{
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			}>;
		} | null;
	};
};

export type AnnouncementDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AnnouncementDeleteMutation = { __typename?: "Mutation"; deleteAnnouncement: boolean };

export type AnnouncementDetailFragment = {
	__typename?: "Announcement";
	id: string;
	title: string;
	body: string;
	startTime: string;
	endTime: string | null;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
	} | null;
	mediaAttachments: Array<{
		__typename?: "MediaAttachment";
		id: string;
		displayOrder: number;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
		taggedPeople: Array<{
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
		}>;
	}>;
	sharingRecord: {
		__typename?: "SharingRecord";
		id: string;
		isPublic: boolean;
		includeEmployees: boolean;
		includeGuardians: boolean;
		includeAllUsersOfPersonTypes: boolean;
		classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
		courseSections: Array<{
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		}>;
		homeRoomSections: Array<{
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		}>;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		}>;
	} | null;
};

export type AnnouncementDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AnnouncementDetailQuery = {
	__typename?: "Query";
	announcement: {
		__typename?: "Announcement";
		id: string;
		title: string;
		body: string;
		startTime: string;
		endTime: string | null;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
			taggedPeople: Array<{
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
			}>;
		}>;
		sharingRecord: {
			__typename?: "SharingRecord";
			id: string;
			isPublic: boolean;
			includeEmployees: boolean;
			includeGuardians: boolean;
			includeAllUsersOfPersonTypes: boolean;
			classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
			classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
			courseSections: Array<{
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			}>;
			homeRoomSections: Array<{
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			}>;
		} | null;
	};
};

export type AnnouncementHomePageListQueryVariables = Exact<{
	filters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AnnouncementOrder>;
}>;

export type AnnouncementHomePageListQuery = {
	__typename?: "Query";
	announcementConnection: {
		__typename?: "AnnouncementConnection";
		pageInfo: { __typename?: "PageInfo"; endCursor: string | null; hasNextPage: boolean };
		edges: Array<{
			__typename?: "AnnouncementEdge";
			node: {
				__typename?: "Announcement";
				id: string;
				title: string;
				body: string;
				startTime: string;
				endTime: string | null;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					} | null;
				} | null;
				mediaAttachments: Array<{
					__typename?: "MediaAttachment";
					id: string;
					title: string;
					description: string;
					isFile: boolean;
					fileURL: string;
					fileKey: string;
					fileContentType: string;
					linkURL: string;
				}>;
			};
		}>;
	};
};

export type AnnouncementCommunicationCenterPageListQueryVariables = Exact<{
	filters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AnnouncementOrder>;
}>;

export type AnnouncementCommunicationCenterPageListQuery = {
	__typename?: "Query";
	announcementConnection: {
		__typename?: "AnnouncementConnection";
		edges: Array<{
			__typename?: "AnnouncementEdge";
			node: {
				__typename?: "Announcement";
				id: string;
				title: string;
				body: string;
				startTime: string;
				endTime: string | null;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					} | null;
				} | null;
				mediaAttachments: Array<{
					__typename?: "MediaAttachment";
					id: string;
					title: string;
					description: string;
					isFile: boolean;
					fileURL: string;
					fileKey: string;
					fileContentType: string;
					linkURL: string;
				}>;
			};
		}>;
	};
};

export type AnnouncementIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AnnouncementOrder>;
}>;

export type AnnouncementIndexQuery = {
	__typename?: "Query";
	announcementConnection: {
		__typename?: "AnnouncementConnection";
		edges: Array<{
			__typename?: "AnnouncementEdge";
			node: {
				__typename?: "Announcement";
				id: string;
				title: string;
				body: string;
				startTime: string;
				endTime: string | null;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
				} | null;
			};
		}>;
	};
};

export type AnnouncementNameFragment = { __typename?: "Announcement"; title: string };

export type AnnouncementNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AnnouncementNameQuery = {
	__typename?: "Query";
	announcement: { __typename?: "Announcement"; id: string; title: string };
};

export type AnnouncementNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AnnouncementOrder>;
}>;

export type AnnouncementNamesQuery = {
	__typename?: "Query";
	announcementConnection: {
		__typename?: "AnnouncementConnection";
		edges: Array<{ __typename?: "AnnouncementEdge"; node: { __typename?: "Announcement"; id: string; title: string } }>;
	};
};

export type AnnouncementPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
	order?: InputMaybe<AnnouncementOrder>;
}>;

export type AnnouncementPaginationQuery = {
	__typename?: "Query";
	announcementConnection: {
		__typename?: "AnnouncementConnection";
		totalCount: number;
		edges: Array<{ __typename?: "AnnouncementEdge"; cursor: string }>;
	};
};

export type AnnouncementSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
	order?: InputMaybe<AnnouncementOrder>;
}>;

export type AnnouncementSelectQuery = {
	__typename?: "Query";
	announcementConnection: {
		__typename?: "AnnouncementConnection";
		edges: Array<{ __typename?: "AnnouncementEdge"; node: { __typename?: "Announcement"; id: string; title: string } }>;
	};
};

export type AnnouncementSocialItemsQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AnnouncementSocialItemsQuery = {
	__typename?: "Query";
	announcement: {
		__typename?: "Announcement";
		id: string;
		socialReactions: Array<{
			__typename?: "SocialReaction";
			id: string;
			reaction: SocialReactionReaction;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				email: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			};
		}>;
	};
};

export type AnnouncementStatisticsQueryVariables = Exact<{
	filters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
}>;

export type AnnouncementStatisticsQuery = {
	__typename?: "Query";
	announcementStatistics: { __typename?: "AnnouncementStatistics"; count: number; views: number; reactions: number };
};

export type AnnouncementUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: AnnouncementUpdateInput;
}>;

export type AnnouncementUpdateMutation = {
	__typename?: "Mutation";
	updateAnnouncement: {
		__typename?: "Announcement";
		id: string;
		title: string;
		body: string;
		startTime: string;
		endTime: string | null;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
			taggedPeople: Array<{
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
			}>;
		}>;
		sharingRecord: {
			__typename?: "SharingRecord";
			id: string;
			isPublic: boolean;
			includeEmployees: boolean;
			includeGuardians: boolean;
			includeAllUsersOfPersonTypes: boolean;
			classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
			classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
			courseSections: Array<{
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			}>;
			homeRoomSections: Array<{
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			}>;
		} | null;
	};
};

export type AttendanceStatusCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<AttendanceStatusFilterInput> | AttendanceStatusFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AttendanceStatusOrder>;
}>;

export type AttendanceStatusCountQuery = {
	__typename?: "Query";
	attendanceStatusConnection: { __typename?: "AttendanceStatusConnection"; totalCount: number };
};

export type AttendanceStatusCreateMutationVariables = Exact<{
	input: AttendanceStatusCreateInput;
}>;

export type AttendanceStatusCreateMutation = {
	__typename?: "Mutation";
	createAttendanceStatus: {
		__typename?: "AttendanceStatus";
		id: string;
		name: string;
		code: string;
		description: string;
		indicatesAbsent: boolean;
		indicatesLateArrival: boolean;
		indicatesEarlyDeparture: boolean;
		indicatesExcused: boolean;
		isDefault: boolean;
		displayOrder: number | null;
	};
};

export type AttendanceStatusDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AttendanceStatusDeleteMutation = { __typename?: "Mutation"; deleteAttendanceStatus: boolean };

export type AttendanceStatusDetailFragment = {
	__typename?: "AttendanceStatus";
	id: string;
	name: string;
	code: string;
	description: string;
	indicatesAbsent: boolean;
	indicatesLateArrival: boolean;
	indicatesEarlyDeparture: boolean;
	indicatesExcused: boolean;
	isDefault: boolean;
	displayOrder: number | null;
};

export type AttendanceStatusDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AttendanceStatusDetailQuery = {
	__typename?: "Query";
	attendanceStatus: {
		__typename?: "AttendanceStatus";
		id: string;
		name: string;
		code: string;
		description: string;
		indicatesAbsent: boolean;
		indicatesLateArrival: boolean;
		indicatesEarlyDeparture: boolean;
		indicatesExcused: boolean;
		isDefault: boolean;
		displayOrder: number | null;
	};
};

export type AttendanceStatusIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<AttendanceStatusFilterInput> | AttendanceStatusFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AttendanceStatusOrder>;
}>;

export type AttendanceStatusIndexQuery = {
	__typename?: "Query";
	attendanceStatusConnection: {
		__typename?: "AttendanceStatusConnection";
		edges: Array<{
			__typename?: "AttendanceStatusEdge";
			node: {
				__typename?: "AttendanceStatus";
				id: string;
				name: string;
				code: string;
				description: string;
				indicatesAbsent: boolean;
				indicatesLateArrival: boolean;
				indicatesEarlyDeparture: boolean;
				indicatesExcused: boolean;
				isDefault: boolean;
				displayOrder: number | null;
			};
		}>;
	};
};

export type AttendanceStatusListQueryVariables = Exact<{
	filters?: InputMaybe<Array<AttendanceStatusFilterInput> | AttendanceStatusFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AttendanceStatusOrder>;
}>;

export type AttendanceStatusListQuery = {
	__typename?: "Query";
	attendanceStatusConnection: {
		__typename?: "AttendanceStatusConnection";
		edges: Array<{
			__typename?: "AttendanceStatusEdge";
			node: {
				__typename?: "AttendanceStatus";
				id: string;
				name: string;
				code: string;
				description: string;
				indicatesAbsent: boolean;
				indicatesLateArrival: boolean;
				indicatesEarlyDeparture: boolean;
				indicatesExcused: boolean;
				isDefault: boolean;
			};
		}>;
	};
};

export type AttendanceStatusNameFragment = { __typename?: "AttendanceStatus"; name: string; code: string };

export type AttendanceStatusInfoFragment = {
	__typename?: "AttendanceStatus";
	indicatesAbsent: boolean;
	indicatesLateArrival: boolean;
	indicatesEarlyDeparture: boolean;
	indicatesExcused: boolean;
};

export type AttendanceStatusNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AttendanceStatusNameQuery = {
	__typename?: "Query";
	attendanceStatus: { __typename?: "AttendanceStatus"; id: string; name: string; code: string };
};

export type AttendanceStatusNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<AttendanceStatusFilterInput> | AttendanceStatusFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AttendanceStatusOrder>;
}>;

export type AttendanceStatusNamesQuery = {
	__typename?: "Query";
	attendanceStatusConnection: {
		__typename?: "AttendanceStatusConnection";
		edges: Array<{
			__typename?: "AttendanceStatusEdge";
			node: { __typename?: "AttendanceStatus"; id: string; name: string; code: string };
		}>;
	};
};

export type AttendanceStatusPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<AttendanceStatusFilterInput> | AttendanceStatusFilterInput>;
	order?: InputMaybe<AttendanceStatusOrder>;
}>;

export type AttendanceStatusPaginationQuery = {
	__typename?: "Query";
	attendanceStatusConnection: {
		__typename?: "AttendanceStatusConnection";
		totalCount: number;
		edges: Array<{ __typename?: "AttendanceStatusEdge"; cursor: string }>;
	};
};

export type AttendanceStatusSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<AttendanceStatusFilterInput> | AttendanceStatusFilterInput>;
	order?: InputMaybe<AttendanceStatusOrder>;
}>;

export type AttendanceStatusSelectQuery = {
	__typename?: "Query";
	attendanceStatusConnection: {
		__typename?: "AttendanceStatusConnection";
		edges: Array<{
			__typename?: "AttendanceStatusEdge";
			node: { __typename?: "AttendanceStatus"; id: string; name: string; code: string };
		}>;
	};
};

export type AttendanceStatusUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: AttendanceStatusUpdateInput;
}>;

export type AttendanceStatusUpdateMutation = {
	__typename?: "Mutation";
	updateAttendanceStatus: {
		__typename?: "AttendanceStatus";
		id: string;
		name: string;
		code: string;
		description: string;
		indicatesAbsent: boolean;
		indicatesLateArrival: boolean;
		indicatesEarlyDeparture: boolean;
		indicatesExcused: boolean;
		isDefault: boolean;
		displayOrder: number | null;
	};
};

export type BillingAdjustmentCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<BillingAdjustmentFilterInput> | BillingAdjustmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<BillingAdjustmentOrder>;
}>;

export type BillingAdjustmentCountQuery = {
	__typename?: "Query";
	billingAdjustmentConnection: { __typename?: "BillingAdjustmentConnection"; totalCount: number };
};

export type BillingAdjustmentCreateMutationVariables = Exact<{
	input: BillingAdjustmentCreateInput;
}>;

export type BillingAdjustmentCreateMutation = {
	__typename?: "Mutation";
	createBillingAdjustment: {
		__typename?: "BillingAdjustment";
		id: string;
		issueDate: string;
		amount: number;
		notes: string;
		invoice: { __typename?: "Invoice"; id: string; name: string; dueDate: string };
	};
};

export type BillingAdjustmentDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type BillingAdjustmentDeleteMutation = { __typename?: "Mutation"; deleteBillingAdjustment: boolean };

export type BillingAdjustmentDetailFragment = {
	__typename?: "BillingAdjustment";
	id: string;
	issueDate: string;
	amount: number;
	notes: string;
	invoice: { __typename?: "Invoice"; id: string; name: string; dueDate: string };
};

export type BillingAdjustmentDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type BillingAdjustmentDetailQuery = {
	__typename?: "Query";
	billingAdjustment: {
		__typename?: "BillingAdjustment";
		id: string;
		issueDate: string;
		amount: number;
		notes: string;
		invoice: { __typename?: "Invoice"; id: string; name: string; dueDate: string };
	};
};

export type BillingAdjustmentIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<BillingAdjustmentFilterInput> | BillingAdjustmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<BillingAdjustmentOrder>;
}>;

export type BillingAdjustmentIndexQuery = {
	__typename?: "Query";
	billingAdjustmentConnection: {
		__typename?: "BillingAdjustmentConnection";
		edges: Array<{
			__typename?: "BillingAdjustmentEdge";
			node: { __typename?: "BillingAdjustment"; id: string; issueDate: string; amount: number; notes: string };
		}>;
	};
};

export type BillingAdjustmentNameFragment = { __typename?: "BillingAdjustment"; id: string };

export type BillingAdjustmentNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type BillingAdjustmentNameQuery = {
	__typename?: "Query";
	billingAdjustment: { __typename?: "BillingAdjustment"; id: string };
};

export type BillingAdjustmentNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<BillingAdjustmentFilterInput> | BillingAdjustmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<BillingAdjustmentOrder>;
}>;

export type BillingAdjustmentNamesQuery = {
	__typename?: "Query";
	billingAdjustmentConnection: {
		__typename?: "BillingAdjustmentConnection";
		edges: Array<{ __typename?: "BillingAdjustmentEdge"; node: { __typename?: "BillingAdjustment"; id: string } }>;
	};
};

export type BillingAdjustmentPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<BillingAdjustmentFilterInput> | BillingAdjustmentFilterInput>;
	order?: InputMaybe<BillingAdjustmentOrder>;
}>;

export type BillingAdjustmentPaginationQuery = {
	__typename?: "Query";
	billingAdjustmentConnection: {
		__typename?: "BillingAdjustmentConnection";
		totalCount: number;
		edges: Array<{ __typename?: "BillingAdjustmentEdge"; cursor: string }>;
	};
};

export type BillingAdjustmentSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<BillingAdjustmentFilterInput> | BillingAdjustmentFilterInput>;
	order?: InputMaybe<BillingAdjustmentOrder>;
}>;

export type BillingAdjustmentSelectQuery = {
	__typename?: "Query";
	billingAdjustmentConnection: {
		__typename?: "BillingAdjustmentConnection";
		edges: Array<{ __typename?: "BillingAdjustmentEdge"; node: { __typename?: "BillingAdjustment"; id: string } }>;
	};
};

export type BillingAdjustmentUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: BillingAdjustmentUpdateInput;
}>;

export type BillingAdjustmentUpdateMutation = {
	__typename?: "Mutation";
	updateBillingAdjustment: {
		__typename?: "BillingAdjustment";
		id: string;
		issueDate: string;
		amount: number;
		notes: string;
		invoice: { __typename?: "Invoice"; id: string; name: string; dueDate: string };
	};
};

export type BuildingCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<BuildingFilterInput> | BuildingFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<BuildingOrder>;
}>;

export type BuildingCountQuery = {
	__typename?: "Query";
	buildingConnection: { __typename?: "BuildingConnection"; totalCount: number };
};

export type BuildingCreateMutationVariables = Exact<{
	input: BuildingCreateInput;
}>;

export type BuildingCreateMutation = {
	__typename?: "Mutation";
	createBuilding: {
		__typename?: "Building";
		id: string;
		name: string;
		buildingFloors: Array<{ __typename?: "BuildingFloor"; id: string; level: number }>;
		campus: { __typename?: "Campus"; id: string; name: string };
	};
};

export type BuildingDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type BuildingDeleteMutation = { __typename?: "Mutation"; deleteBuilding: boolean };

export type BuildingDetailFragment = {
	__typename?: "Building";
	id: string;
	name: string;
	buildingFloors: Array<{ __typename?: "BuildingFloor"; id: string; level: number }>;
	campus: { __typename?: "Campus"; id: string; name: string };
};

export type BuildingDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type BuildingDetailQuery = {
	__typename?: "Query";
	building: {
		__typename?: "Building";
		id: string;
		name: string;
		buildingFloors: Array<{ __typename?: "BuildingFloor"; id: string; level: number }>;
		campus: { __typename?: "Campus"; id: string; name: string };
	};
};

export type BuildingIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<BuildingFilterInput> | BuildingFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<BuildingOrder>;
}>;

export type BuildingIndexQuery = {
	__typename?: "Query";
	buildingConnection: {
		__typename?: "BuildingConnection";
		edges: Array<{
			__typename?: "BuildingEdge";
			node: {
				__typename?: "Building";
				id: string;
				name: string;
				buildingFloors: Array<{ __typename?: "BuildingFloor"; id: string }>;
				campus: { __typename?: "Campus"; id: string; name: string };
			};
		}>;
	};
};

export type BuildingNameFragment = { __typename?: "Building"; name: string };

export type BuildingNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type BuildingNameQuery = {
	__typename?: "Query";
	building: { __typename?: "Building"; id: string; name: string };
};

export type BuildingNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<BuildingFilterInput> | BuildingFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<BuildingOrder>;
}>;

export type BuildingNamesQuery = {
	__typename?: "Query";
	buildingConnection: {
		__typename?: "BuildingConnection";
		edges: Array<{ __typename?: "BuildingEdge"; node: { __typename?: "Building"; id: string; name: string } }>;
	};
};

export type BuildingPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<BuildingFilterInput> | BuildingFilterInput>;
	order?: InputMaybe<BuildingOrder>;
}>;

export type BuildingPaginationQuery = {
	__typename?: "Query";
	buildingConnection: {
		__typename?: "BuildingConnection";
		totalCount: number;
		edges: Array<{ __typename?: "BuildingEdge"; cursor: string }>;
	};
};

export type BuildingSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<BuildingFilterInput> | BuildingFilterInput>;
	order?: InputMaybe<BuildingOrder>;
}>;

export type BuildingSelectQuery = {
	__typename?: "Query";
	buildingConnection: {
		__typename?: "BuildingConnection";
		edges: Array<{ __typename?: "BuildingEdge"; node: { __typename?: "Building"; id: string; name: string } }>;
	};
};

export type BuildingUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: BuildingUpdateInput;
}>;

export type BuildingUpdateMutation = {
	__typename?: "Mutation";
	updateBuilding: {
		__typename?: "Building";
		id: string;
		name: string;
		buildingFloors: Array<{ __typename?: "BuildingFloor"; id: string; level: number }>;
		campus: { __typename?: "Campus"; id: string; name: string };
	};
};

export type BuildingFloorCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<BuildingFloorFilterInput> | BuildingFloorFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<BuildingFloorOrder>;
}>;

export type BuildingFloorCountQuery = {
	__typename?: "Query";
	buildingFloorConnection: { __typename?: "BuildingFloorConnection"; totalCount: number };
};

export type BuildingFloorCreateMutationVariables = Exact<{
	input: BuildingFloorCreateInput;
}>;

export type BuildingFloorCreateMutation = {
	__typename?: "Mutation";
	createBuildingFloor: {
		__typename?: "BuildingFloor";
		id: string;
		level: number;
		building: { __typename?: "Building"; id: string; name: string };
		rooms: Array<{ __typename?: "Room"; id: string; name: string }>;
	};
};

export type BuildingFloorDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type BuildingFloorDeleteMutation = { __typename?: "Mutation"; deleteBuildingFloor: boolean };

export type BuildingFloorDetailFragment = {
	__typename?: "BuildingFloor";
	id: string;
	level: number;
	building: { __typename?: "Building"; id: string; name: string };
	rooms: Array<{ __typename?: "Room"; id: string; name: string }>;
};

export type BuildingFloorDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type BuildingFloorDetailQuery = {
	__typename?: "Query";
	buildingFloor: {
		__typename?: "BuildingFloor";
		id: string;
		level: number;
		building: { __typename?: "Building"; id: string; name: string };
		rooms: Array<{ __typename?: "Room"; id: string; name: string }>;
	};
};

export type BuildingFloorIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<BuildingFloorFilterInput> | BuildingFloorFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<BuildingFloorOrder>;
}>;

export type BuildingFloorIndexQuery = {
	__typename?: "Query";
	buildingFloorConnection: {
		__typename?: "BuildingFloorConnection";
		edges: Array<{
			__typename?: "BuildingFloorEdge";
			node: {
				__typename?: "BuildingFloor";
				id: string;
				level: number;
				building: {
					__typename?: "Building";
					id: string;
					name: string;
					campus: { __typename?: "Campus"; id: string; name: string };
				};
				rooms: Array<{ __typename?: "Room"; id: string }>;
			};
		}>;
	};
};

export type BuildingFloorNameFragment = { __typename?: "BuildingFloor"; level: number };

export type BuildingFloorNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type BuildingFloorNameQuery = {
	__typename?: "Query";
	buildingFloor: { __typename?: "BuildingFloor"; id: string; level: number };
};

export type BuildingFloorNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<BuildingFloorFilterInput> | BuildingFloorFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<BuildingFloorOrder>;
}>;

export type BuildingFloorNamesQuery = {
	__typename?: "Query";
	buildingFloorConnection: {
		__typename?: "BuildingFloorConnection";
		edges: Array<{
			__typename?: "BuildingFloorEdge";
			node: { __typename?: "BuildingFloor"; id: string; level: number };
		}>;
	};
};

export type BuildingFloorPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<BuildingFloorFilterInput> | BuildingFloorFilterInput>;
	order?: InputMaybe<BuildingFloorOrder>;
}>;

export type BuildingFloorPaginationQuery = {
	__typename?: "Query";
	buildingFloorConnection: {
		__typename?: "BuildingFloorConnection";
		totalCount: number;
		edges: Array<{ __typename?: "BuildingFloorEdge"; cursor: string }>;
	};
};

export type BuildingFloorSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<BuildingFloorFilterInput> | BuildingFloorFilterInput>;
	order?: InputMaybe<BuildingFloorOrder>;
}>;

export type BuildingFloorSelectQuery = {
	__typename?: "Query";
	buildingFloorConnection: {
		__typename?: "BuildingFloorConnection";
		edges: Array<{
			__typename?: "BuildingFloorEdge";
			node: { __typename?: "BuildingFloor"; id: string; level: number };
		}>;
	};
};

export type BuildingFloorUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: BuildingFloorUpdateInput;
}>;

export type BuildingFloorUpdateMutation = {
	__typename?: "Mutation";
	updateBuildingFloor: {
		__typename?: "BuildingFloor";
		id: string;
		level: number;
		building: { __typename?: "Building"; id: string; name: string };
		rooms: Array<{ __typename?: "Room"; id: string; name: string }>;
	};
};

export type CalendarEventTimingFragment = {
	__typename?: "CalendarEvent";
	isAllDay: boolean;
	startTime: string | null;
	endTime: string | null;
	startDate: string | null;
	endDate: string | null;
};

export type CalendarEventCalendarSlimListQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type CalendarEventCalendarSlimListQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		edges: Array<{
			__typename?: "CalendarEventEdge";
			node: {
				__typename?: "CalendarEvent";
				id: string;
				name: string;
				isAllDay: boolean;
				startTime: string | null;
				endTime: string | null;
				startDate: string | null;
				endDate: string | null;
				author: { __typename?: "User"; id: string; isCurrent: boolean } | null;
				sharingRecord: {
					__typename?: "SharingRecord";
					id: string;
					isPublic: boolean;
					userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
				} | null;
			};
		}>;
	};
};

export type CalendarEventCalendarListQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type CalendarEventCalendarListQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		edges: Array<{
			__typename?: "CalendarEventEdge";
			node: {
				__typename?: "CalendarEvent";
				id: string;
				name: string;
				description: string;
				isAllDay: boolean;
				startTime: string | null;
				endTime: string | null;
				startDate: string | null;
				endDate: string | null;
				author: { __typename?: "User"; id: string; isCurrent: boolean } | null;
				sharingRecord: {
					__typename?: "SharingRecord";
					id: string;
					isPublic: boolean;
					userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
				} | null;
			};
		}>;
	};
};

export type CalendarEventCalendarDetailFragment = {
	__typename?: "CalendarEvent";
	id: string;
	name: string;
	description: string;
	location: string;
	imageURL: string;
	imageKey: string;
	imageContentType: string;
	isAllDay: boolean;
	startTime: string | null;
	endTime: string | null;
	startDate: string | null;
	isMultiDay: boolean;
	endDate: string | null;
	allowsResponses: boolean;
	createdAt: string;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
	} | null;
	calendarEventResponses: Array<{
		__typename?: "CalendarEventResponse";
		id: string;
		response: CalendarEventResponseResponse;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
	}>;
	mediaAttachments: Array<{
		__typename?: "MediaAttachment";
		id: string;
		displayOrder: number;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
		taggedPeople: Array<{
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
		}>;
	}>;
	sharingRecord: { __typename?: "SharingRecord"; id: string; isPublic: boolean } | null;
};

export type CalendarEventCalendarDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CalendarEventCalendarDetailQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		edges: Array<{
			__typename?: "CalendarEventEdge";
			node: {
				__typename?: "CalendarEvent";
				id: string;
				name: string;
				description: string;
				location: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
				isAllDay: boolean;
				startTime: string | null;
				endTime: string | null;
				startDate: string | null;
				isMultiDay: boolean;
				endDate: string | null;
				allowsResponses: boolean;
				createdAt: string;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					} | null;
				} | null;
				calendarEventResponses: Array<{
					__typename?: "CalendarEventResponse";
					id: string;
					response: CalendarEventResponseResponse;
					author: {
						__typename?: "User";
						id: string;
						email: string;
						isCurrent: boolean;
						person: {
							__typename?: "Person";
							id: string;
							name: string;
							publicName: string;
							imageURL: string;
							imageKey: string;
							imageContentType: string;
						} | null;
					} | null;
				}>;
				mediaAttachments: Array<{
					__typename?: "MediaAttachment";
					id: string;
					displayOrder: number;
					title: string;
					description: string;
					isFile: boolean;
					fileURL: string;
					fileKey: string;
					fileContentType: string;
					linkURL: string;
					taggedPeople: Array<{
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
					}>;
				}>;
				sharingRecord: { __typename?: "SharingRecord"; id: string; isPublic: boolean } | null;
			};
		}>;
	};
};

export type CalendarEventCalendarDetailedListQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type CalendarEventCalendarDetailedListQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		edges: Array<{
			__typename?: "CalendarEventEdge";
			node: {
				__typename?: "CalendarEvent";
				id: string;
				name: string;
				description: string;
				location: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
				isAllDay: boolean;
				startTime: string | null;
				endTime: string | null;
				startDate: string | null;
				isMultiDay: boolean;
				endDate: string | null;
				allowsResponses: boolean;
				createdAt: string;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					} | null;
				} | null;
				calendarEventResponses: Array<{
					__typename?: "CalendarEventResponse";
					id: string;
					response: CalendarEventResponseResponse;
					author: {
						__typename?: "User";
						id: string;
						email: string;
						isCurrent: boolean;
						person: {
							__typename?: "Person";
							id: string;
							name: string;
							publicName: string;
							imageURL: string;
							imageKey: string;
							imageContentType: string;
						} | null;
					} | null;
				}>;
				mediaAttachments: Array<{
					__typename?: "MediaAttachment";
					id: string;
					displayOrder: number;
					title: string;
					description: string;
					isFile: boolean;
					fileURL: string;
					fileKey: string;
					fileContentType: string;
					linkURL: string;
					taggedPeople: Array<{
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
					}>;
				}>;
				sharingRecord: { __typename?: "SharingRecord"; id: string; isPublic: boolean } | null;
			};
		}>;
	};
};

export type CalendarEventCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type CalendarEventCountQuery = {
	__typename?: "Query";
	calendarEventConnection: { __typename?: "CalendarEventConnection"; totalCount: number };
};

export type CalendarEventCreateMutationVariables = Exact<{
	input: CalendarEventCreateInput;
}>;

export type CalendarEventCreateMutation = {
	__typename?: "Mutation";
	createCalendarEvent: {
		__typename?: "CalendarEvent";
		id: string;
		name: string;
		description: string;
		location: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		isAllDay: boolean;
		startTime: string | null;
		endTime: string | null;
		startDate: string | null;
		isMultiDay: boolean;
		endDate: string | null;
		allowsResponses: boolean;
		createdAt: string;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
		calendarEventResponses: Array<{
			__typename?: "CalendarEventResponse";
			id: string;
			response: CalendarEventResponseResponse;
			author: {
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
			} | null;
		}>;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
			taggedPeople: Array<{
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
			}>;
		}>;
		sharingRecord: {
			__typename?: "SharingRecord";
			id: string;
			isPublic: boolean;
			includeEmployees: boolean;
			includeGuardians: boolean;
			includeAllUsersOfPersonTypes: boolean;
			classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
			classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
			courseSections: Array<{
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			}>;
			homeRoomSections: Array<{
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			}>;
		} | null;
	};
};

export type CalendarEventDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CalendarEventDeleteMutation = { __typename?: "Mutation"; deleteCalendarEvent: boolean };

export type CalendarEventDetailFragment = {
	__typename?: "CalendarEvent";
	id: string;
	name: string;
	description: string;
	location: string;
	imageURL: string;
	imageKey: string;
	imageContentType: string;
	isAllDay: boolean;
	startTime: string | null;
	endTime: string | null;
	startDate: string | null;
	isMultiDay: boolean;
	endDate: string | null;
	allowsResponses: boolean;
	createdAt: string;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
	} | null;
	calendarEventResponses: Array<{
		__typename?: "CalendarEventResponse";
		id: string;
		response: CalendarEventResponseResponse;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
	}>;
	mediaAttachments: Array<{
		__typename?: "MediaAttachment";
		id: string;
		displayOrder: number;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
		taggedPeople: Array<{
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
		}>;
	}>;
	sharingRecord: {
		__typename?: "SharingRecord";
		id: string;
		isPublic: boolean;
		includeEmployees: boolean;
		includeGuardians: boolean;
		includeAllUsersOfPersonTypes: boolean;
		classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
		courseSections: Array<{
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		}>;
		homeRoomSections: Array<{
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		}>;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		}>;
	} | null;
};

export type CalendarEventDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CalendarEventDetailQuery = {
	__typename?: "Query";
	calendarEvent: {
		__typename?: "CalendarEvent";
		id: string;
		name: string;
		description: string;
		location: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		isAllDay: boolean;
		startTime: string | null;
		endTime: string | null;
		startDate: string | null;
		isMultiDay: boolean;
		endDate: string | null;
		allowsResponses: boolean;
		createdAt: string;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
		calendarEventResponses: Array<{
			__typename?: "CalendarEventResponse";
			id: string;
			response: CalendarEventResponseResponse;
			author: {
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
			} | null;
		}>;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
			taggedPeople: Array<{
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
			}>;
		}>;
		sharingRecord: {
			__typename?: "SharingRecord";
			id: string;
			isPublic: boolean;
			includeEmployees: boolean;
			includeGuardians: boolean;
			includeAllUsersOfPersonTypes: boolean;
			classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
			classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
			courseSections: Array<{
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			}>;
			homeRoomSections: Array<{
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			}>;
		} | null;
	};
};

export type CalendarEventIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type CalendarEventIndexQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		edges: Array<{
			__typename?: "CalendarEventEdge";
			node: {
				__typename?: "CalendarEvent";
				id: string;
				name: string;
				description: string;
				location: string;
				imageURL: string;
				imageContentType: string;
				isAllDay: boolean;
				startTime: string | null;
				endTime: string | null;
				startDate: string | null;
				isMultiDay: boolean;
				endDate: string | null;
				allowsResponses: boolean;
				createdAt: string;
			};
		}>;
	};
};

export type CalendarEventNameFragment = { __typename?: "CalendarEvent"; name: string };

export type CalendarEventNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CalendarEventNameQuery = {
	__typename?: "Query";
	calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string };
};

export type CalendarEventNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type CalendarEventNamesQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		edges: Array<{
			__typename?: "CalendarEventEdge";
			node: { __typename?: "CalendarEvent"; id: string; name: string };
		}>;
	};
};

export type CalendarEventPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type CalendarEventPaginationQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		totalCount: number;
		edges: Array<{ __typename?: "CalendarEventEdge"; cursor: string }>;
	};
};

export type CalendarEventSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type CalendarEventSelectQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		edges: Array<{
			__typename?: "CalendarEventEdge";
			node: { __typename?: "CalendarEvent"; id: string; name: string };
		}>;
	};
};

export type CalendarEventStatisticsQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
}>;

export type CalendarEventStatisticsQuery = {
	__typename?: "Query";
	calendarEventStatistics: {
		__typename?: "CalendarEventStatistics";
		count: number;
		responsesAttending: number;
		responsesMaybeAttending: number;
		responsesNotAttending: number;
	};
};

export type CalendarEventListQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type CalendarEventListQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		edges: Array<{
			__typename?: "CalendarEventEdge";
			node: {
				__typename?: "CalendarEvent";
				id: string;
				name: string;
				imageURL: string;
				imageContentType: string;
				isAllDay: boolean;
				startTime: string | null;
				endTime: string | null;
				startDate: string | null;
				endDate: string | null;
				allowsResponses: boolean;
				calendarEventResponses: Array<{
					__typename?: "CalendarEventResponse";
					id: string;
					response: CalendarEventResponseResponse;
				}>;
			};
		}>;
	};
};

export type CalendarEventUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: CalendarEventUpdateInput;
}>;

export type CalendarEventUpdateMutation = {
	__typename?: "Mutation";
	updateCalendarEvent: {
		__typename?: "CalendarEvent";
		id: string;
		name: string;
		description: string;
		location: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		isAllDay: boolean;
		startTime: string | null;
		endTime: string | null;
		startDate: string | null;
		isMultiDay: boolean;
		endDate: string | null;
		allowsResponses: boolean;
		createdAt: string;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
		calendarEventResponses: Array<{
			__typename?: "CalendarEventResponse";
			id: string;
			response: CalendarEventResponseResponse;
			author: {
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
			} | null;
		}>;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
			taggedPeople: Array<{
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
			}>;
		}>;
		sharingRecord: {
			__typename?: "SharingRecord";
			id: string;
			isPublic: boolean;
			includeEmployees: boolean;
			includeGuardians: boolean;
			includeAllUsersOfPersonTypes: boolean;
			classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
			classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
			courseSections: Array<{
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			}>;
			homeRoomSections: Array<{
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			}>;
		} | null;
	};
};

export type CalendarEventUserListQueryVariables = Exact<{
	calendarEventID: Scalars["ID"]["input"];
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type CalendarEventUserListQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		totalCount: number;
		pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor: string | null };
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				authoredCalendarEventResponses: Array<{
					__typename?: "CalendarEventResponse";
					id: string;
					response: CalendarEventResponseResponse;
				}>;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
			};
		}>;
	};
};

export type CalendarEventResponseCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventResponseFilterInput> | CalendarEventResponseFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventResponseOrder>;
}>;

export type CalendarEventResponseCountQuery = {
	__typename?: "Query";
	calendarEventResponseConnection: { __typename?: "CalendarEventResponseConnection"; totalCount: number };
};

export type CalendarEventResponseCreateMutationVariables = Exact<{
	input: CalendarEventResponseCreateInput;
}>;

export type CalendarEventResponseCreateMutation = {
	__typename?: "Mutation";
	createCalendarEventResponse: {
		__typename?: "CalendarEventResponse";
		id: string;
		response: CalendarEventResponseResponse;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string };
	};
};

export type CalendarEventResponseDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CalendarEventResponseDeleteMutation = { __typename?: "Mutation"; deleteCalendarEventResponse: boolean };

export type CalendarEventResponseDetailFragment = {
	__typename?: "CalendarEventResponse";
	id: string;
	response: CalendarEventResponseResponse;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	} | null;
	calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string };
};

export type CalendarEventResponseDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CalendarEventResponseDetailQuery = {
	__typename?: "Query";
	calendarEventResponse: {
		__typename?: "CalendarEventResponse";
		id: string;
		response: CalendarEventResponseResponse;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string };
	};
};

export type CalendarEventResponseIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventResponseFilterInput> | CalendarEventResponseFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventResponseOrder>;
}>;

export type CalendarEventResponseIndexQuery = {
	__typename?: "Query";
	calendarEventResponseConnection: {
		__typename?: "CalendarEventResponseConnection";
		edges: Array<{
			__typename?: "CalendarEventResponseEdge";
			node: { __typename?: "CalendarEventResponse"; id: string; response: CalendarEventResponseResponse };
		}>;
	};
};

export type CalendarEventResponseNameFragment = { __typename?: "CalendarEventResponse"; id: string };

export type CalendarEventResponseNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CalendarEventResponseNameQuery = {
	__typename?: "Query";
	calendarEventResponse: { __typename?: "CalendarEventResponse"; id: string };
};

export type CalendarEventResponseNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventResponseFilterInput> | CalendarEventResponseFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventResponseOrder>;
}>;

export type CalendarEventResponseNamesQuery = {
	__typename?: "Query";
	calendarEventResponseConnection: {
		__typename?: "CalendarEventResponseConnection";
		edges: Array<{
			__typename?: "CalendarEventResponseEdge";
			node: { __typename?: "CalendarEventResponse"; id: string };
		}>;
	};
};

export type CalendarEventResponsePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventResponseFilterInput> | CalendarEventResponseFilterInput>;
	order?: InputMaybe<CalendarEventResponseOrder>;
}>;

export type CalendarEventResponsePaginationQuery = {
	__typename?: "Query";
	calendarEventResponseConnection: {
		__typename?: "CalendarEventResponseConnection";
		totalCount: number;
		edges: Array<{ __typename?: "CalendarEventResponseEdge"; cursor: string }>;
	};
};

export type CalendarEventResponseSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventResponseFilterInput> | CalendarEventResponseFilterInput>;
	order?: InputMaybe<CalendarEventResponseOrder>;
}>;

export type CalendarEventResponseSelectQuery = {
	__typename?: "Query";
	calendarEventResponseConnection: {
		__typename?: "CalendarEventResponseConnection";
		edges: Array<{
			__typename?: "CalendarEventResponseEdge";
			node: { __typename?: "CalendarEventResponse"; id: string };
		}>;
	};
};

export type CalendarEventResponseUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: CalendarEventResponseUpdateInput;
}>;

export type CalendarEventResponseUpdateMutation = {
	__typename?: "Mutation";
	updateCalendarEventResponse: {
		__typename?: "CalendarEventResponse";
		id: string;
		response: CalendarEventResponseResponse;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string };
	};
};

export type CampusCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<CampusFilterInput> | CampusFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CampusOrder>;
}>;

export type CampusCountQuery = {
	__typename?: "Query";
	campusConnection: { __typename?: "CampusConnection"; totalCount: number };
};

export type CampusCreateMutationVariables = Exact<{
	input: CampusCreateInput;
}>;

export type CampusCreateMutation = {
	__typename?: "Mutation";
	createCampus: {
		__typename?: "Campus";
		id: string;
		name: string;
		phoneNumber: string;
		addressLine1: string;
		addressLine2: string;
		city: string;
		postalCode: string;
		stateOrProvince: string;
		buildings: Array<{ __typename?: "Building"; id: string; name: string }>;
		country: { __typename?: "Country"; id: string; name: string };
		employees: Array<{
			__typename?: "Employee";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		}>;
	};
};

export type CampusDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CampusDeleteMutation = { __typename?: "Mutation"; deleteCampus: boolean };

export type CampusDetailFragment = {
	__typename?: "Campus";
	id: string;
	name: string;
	phoneNumber: string;
	addressLine1: string;
	addressLine2: string;
	city: string;
	postalCode: string;
	stateOrProvince: string;
	buildings: Array<{ __typename?: "Building"; id: string; name: string }>;
	country: { __typename?: "Country"; id: string; name: string };
	employees: Array<{
		__typename?: "Employee";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	}>;
};

export type CampusDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CampusDetailQuery = {
	__typename?: "Query";
	campus: {
		__typename?: "Campus";
		id: string;
		name: string;
		phoneNumber: string;
		addressLine1: string;
		addressLine2: string;
		city: string;
		postalCode: string;
		stateOrProvince: string;
		buildings: Array<{ __typename?: "Building"; id: string; name: string }>;
		country: { __typename?: "Country"; id: string; name: string };
		employees: Array<{
			__typename?: "Employee";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		}>;
	};
};

export type CampusIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<CampusFilterInput> | CampusFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CampusOrder>;
}>;

export type CampusIndexQuery = {
	__typename?: "Query";
	campusConnection: {
		__typename?: "CampusConnection";
		edges: Array<{
			__typename?: "CampusEdge";
			node: {
				__typename?: "Campus";
				id: string;
				name: string;
				phoneNumber: string;
				addressLine1: string;
				addressLine2: string;
				city: string;
				postalCode: string;
				stateOrProvince: string;
				country: { __typename?: "Country"; id: string; name: string };
				buildings: Array<{ __typename?: "Building"; id: string }>;
			};
		}>;
	};
};

export type CampusNameFragment = { __typename?: "Campus"; name: string };

export type CampusNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CampusNameQuery = { __typename?: "Query"; campus: { __typename?: "Campus"; id: string; name: string } };

export type CampusNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<CampusFilterInput> | CampusFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CampusOrder>;
}>;

export type CampusNamesQuery = {
	__typename?: "Query";
	campusConnection: {
		__typename?: "CampusConnection";
		edges: Array<{ __typename?: "CampusEdge"; node: { __typename?: "Campus"; id: string; name: string } }>;
	};
};

export type CampusPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<CampusFilterInput> | CampusFilterInput>;
	order?: InputMaybe<CampusOrder>;
}>;

export type CampusPaginationQuery = {
	__typename?: "Query";
	campusConnection: {
		__typename?: "CampusConnection";
		totalCount: number;
		edges: Array<{ __typename?: "CampusEdge"; cursor: string }>;
	};
};

export type CampusSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<CampusFilterInput> | CampusFilterInput>;
	order?: InputMaybe<CampusOrder>;
}>;

export type CampusSelectQuery = {
	__typename?: "Query";
	campusConnection: {
		__typename?: "CampusConnection";
		edges: Array<{ __typename?: "CampusEdge"; node: { __typename?: "Campus"; id: string; name: string } }>;
	};
};

export type CampusUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: CampusUpdateInput;
}>;

export type CampusUpdateMutation = {
	__typename?: "Mutation";
	updateCampus: {
		__typename?: "Campus";
		id: string;
		name: string;
		phoneNumber: string;
		addressLine1: string;
		addressLine2: string;
		city: string;
		postalCode: string;
		stateOrProvince: string;
		buildings: Array<{ __typename?: "Building"; id: string; name: string }>;
		country: { __typename?: "Country"; id: string; name: string };
		employees: Array<{
			__typename?: "Employee";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		}>;
	};
};

export type ClassYearCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<ClassYearFilterInput> | ClassYearFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ClassYearOrder>;
}>;

export type ClassYearCountQuery = {
	__typename?: "Query";
	classYearConnection: { __typename?: "ClassYearConnection"; totalCount: number };
};

export type ClassYearCreateMutationVariables = Exact<{
	input: ClassYearCreateInput;
}>;

export type ClassYearCreateMutation = {
	__typename?: "Mutation";
	createClassYear: {
		__typename?: "ClassYear";
		id: string;
		name: string;
		yearsFromGraduation: number;
		graduationYear: number;
		classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
	};
};

export type ClassYearDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ClassYearDeleteMutation = { __typename?: "Mutation"; deleteClassYear: boolean };

export type ClassYearDetailFragment = {
	__typename?: "ClassYear";
	id: string;
	name: string;
	yearsFromGraduation: number;
	graduationYear: number;
	classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
};

export type ClassYearDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ClassYearDetailQuery = {
	__typename?: "Query";
	classYear: {
		__typename?: "ClassYear";
		id: string;
		name: string;
		yearsFromGraduation: number;
		graduationYear: number;
		classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
	};
};

export type ClassYearIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<ClassYearFilterInput> | ClassYearFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ClassYearOrder>;
}>;

export type ClassYearIndexQuery = {
	__typename?: "Query";
	classYearConnection: {
		__typename?: "ClassYearConnection";
		edges: Array<{
			__typename?: "ClassYearEdge";
			node: { __typename?: "ClassYear"; id: string; name: string; yearsFromGraduation: number; graduationYear: number };
		}>;
	};
};

export type ClassYearLookupQueryVariables = Exact<{
	filters?: InputMaybe<Array<ClassYearFilterInput> | ClassYearFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ClassYearOrder>;
}>;

export type ClassYearLookupQuery = {
	__typename?: "Query";
	classYearConnection: {
		__typename?: "ClassYearConnection";
		edges: Array<{
			__typename?: "ClassYearEdge";
			node: { __typename?: "ClassYear"; id: string; name: string; yearsFromGraduation: number; graduationYear: number };
		}>;
	};
};

export type ClassYearNameFragment = { __typename?: "ClassYear"; name: string };

export type ClassYearNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ClassYearNameQuery = {
	__typename?: "Query";
	classYear: { __typename?: "ClassYear"; id: string; name: string };
};

export type ClassYearNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<ClassYearFilterInput> | ClassYearFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ClassYearOrder>;
}>;

export type ClassYearNamesQuery = {
	__typename?: "Query";
	classYearConnection: {
		__typename?: "ClassYearConnection";
		edges: Array<{ __typename?: "ClassYearEdge"; node: { __typename?: "ClassYear"; id: string; name: string } }>;
	};
};

export type ClassYearPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<ClassYearFilterInput> | ClassYearFilterInput>;
	order?: InputMaybe<ClassYearOrder>;
}>;

export type ClassYearPaginationQuery = {
	__typename?: "Query";
	classYearConnection: {
		__typename?: "ClassYearConnection";
		totalCount: number;
		edges: Array<{ __typename?: "ClassYearEdge"; cursor: string }>;
	};
};

export type ClassYearSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<ClassYearFilterInput> | ClassYearFilterInput>;
	order?: InputMaybe<ClassYearOrder>;
}>;

export type ClassYearSelectQuery = {
	__typename?: "Query";
	classYearConnection: {
		__typename?: "ClassYearConnection";
		edges: Array<{ __typename?: "ClassYearEdge"; node: { __typename?: "ClassYear"; id: string; name: string } }>;
	};
};

export type ClassYearUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: ClassYearUpdateInput;
}>;

export type ClassYearUpdateMutation = {
	__typename?: "Mutation";
	updateClassYear: {
		__typename?: "ClassYear";
		id: string;
		name: string;
		yearsFromGraduation: number;
		graduationYear: number;
		classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
	};
};

export type ClassYearCategoryCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<ClassYearCategoryFilterInput> | ClassYearCategoryFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ClassYearCategoryOrder>;
}>;

export type ClassYearCategoryCountQuery = {
	__typename?: "Query";
	classYearCategoryConnection: { __typename?: "ClassYearCategoryConnection"; totalCount: number };
};

export type ClassYearCategoryCreateMutationVariables = Exact<{
	input: ClassYearCategoryCreateInput;
}>;

export type ClassYearCategoryCreateMutation = {
	__typename?: "Mutation";
	createClassYearCategory: {
		__typename?: "ClassYearCategory";
		id: string;
		name: string;
		description: string;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
	};
};

export type ClassYearCategoryDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ClassYearCategoryDeleteMutation = { __typename?: "Mutation"; deleteClassYearCategory: boolean };

export type ClassYearCategoryDetailFragment = {
	__typename?: "ClassYearCategory";
	id: string;
	name: string;
	description: string;
	classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
};

export type ClassYearCategoryDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ClassYearCategoryDetailQuery = {
	__typename?: "Query";
	classYearCategory: {
		__typename?: "ClassYearCategory";
		id: string;
		name: string;
		description: string;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
	};
};

export type ClassYearCategoryIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<ClassYearCategoryFilterInput> | ClassYearCategoryFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ClassYearCategoryOrder>;
}>;

export type ClassYearCategoryIndexQuery = {
	__typename?: "Query";
	classYearCategoryConnection: {
		__typename?: "ClassYearCategoryConnection";
		edges: Array<{
			__typename?: "ClassYearCategoryEdge";
			node: { __typename?: "ClassYearCategory"; id: string; name: string; description: string };
		}>;
	};
};

export type ClassYearCategoryNameFragment = { __typename?: "ClassYearCategory"; name: string };

export type ClassYearCategoryNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ClassYearCategoryNameQuery = {
	__typename?: "Query";
	classYearCategory: { __typename?: "ClassYearCategory"; id: string; name: string };
};

export type ClassYearCategoryNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<ClassYearCategoryFilterInput> | ClassYearCategoryFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ClassYearCategoryOrder>;
}>;

export type ClassYearCategoryNamesQuery = {
	__typename?: "Query";
	classYearCategoryConnection: {
		__typename?: "ClassYearCategoryConnection";
		edges: Array<{
			__typename?: "ClassYearCategoryEdge";
			node: { __typename?: "ClassYearCategory"; id: string; name: string };
		}>;
	};
};

export type ClassYearCategoryPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<ClassYearCategoryFilterInput> | ClassYearCategoryFilterInput>;
	order?: InputMaybe<ClassYearCategoryOrder>;
}>;

export type ClassYearCategoryPaginationQuery = {
	__typename?: "Query";
	classYearCategoryConnection: {
		__typename?: "ClassYearCategoryConnection";
		totalCount: number;
		edges: Array<{ __typename?: "ClassYearCategoryEdge"; cursor: string }>;
	};
};

export type ClassYearCategorySelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<ClassYearCategoryFilterInput> | ClassYearCategoryFilterInput>;
	order?: InputMaybe<ClassYearCategoryOrder>;
}>;

export type ClassYearCategorySelectQuery = {
	__typename?: "Query";
	classYearCategoryConnection: {
		__typename?: "ClassYearCategoryConnection";
		edges: Array<{
			__typename?: "ClassYearCategoryEdge";
			node: { __typename?: "ClassYearCategory"; id: string; name: string };
		}>;
	};
};

export type ClassYearCategoryUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: ClassYearCategoryUpdateInput;
}>;

export type ClassYearCategoryUpdateMutation = {
	__typename?: "Mutation";
	updateClassYearCategory: {
		__typename?: "ClassYearCategory";
		id: string;
		name: string;
		description: string;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
	};
};

export type ContractCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractFilterInput> | ContractFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ContractOrder>;
}>;

export type ContractCountQuery = {
	__typename?: "Query";
	contractConnection: { __typename?: "ContractConnection"; totalCount: number };
};

export type ContractCreateMutationVariables = Exact<{
	input: ContractCreateInput;
}>;

export type ContractCreateMutation = {
	__typename?: "Mutation";
	createContract: {
		__typename?: "Contract";
		id: string;
		name: string;
		status: string;
		isApproved: boolean;
		isFinalized: boolean;
		effectiveDate: string | null;
		dateVoided: string | null;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		signedFileURL: string;
		signedFileKey: string;
		signedFileContentType: string;
		approvingUser: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		academicTerms: Array<{ __typename?: "AcademicTerm"; id: string; name: string }>;
		student: {
			__typename?: "Student";
			id: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		};
		contractLineItems: Array<{
			__typename?: "ContractLineItem";
			id: string;
			displayOrder: number;
			isDiscount: boolean;
			amount: number;
			dateAdded: string | null;
			dateRemoved: string | null;
			service: { __typename?: "Service"; id: string; name: string } | null;
			discount: { __typename?: "Discount"; id: string; name: string } | null;
			childContractLineItems: Array<{
				__typename?: "ContractLineItem";
				id: string;
				displayOrder: number;
				isDiscount: boolean;
				amount: number;
				service: { __typename?: "Service"; id: string; name: string } | null;
				discount: { __typename?: "Discount"; id: string; name: string } | null;
			}>;
		}>;
		contractInstallments: Array<{
			__typename?: "ContractInstallment";
			id: string;
			dueDate: string;
			portion: number;
			invoices: Array<{
				__typename?: "Invoice";
				id: string;
				paymentLineItems: Array<{ __typename?: "PaymentLineItem"; id: string; amount: number }>;
				billingAdjustments: Array<{ __typename?: "BillingAdjustment"; id: string; amount: number }>;
			}>;
		}>;
	};
};

export type ContractDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ContractDeleteMutation = { __typename?: "Mutation"; deleteContract: boolean };

export type ContractDetailFragment = {
	__typename?: "Contract";
	id: string;
	name: string;
	status: string;
	isApproved: boolean;
	isFinalized: boolean;
	effectiveDate: string | null;
	dateVoided: string | null;
	fileURL: string;
	fileKey: string;
	fileContentType: string;
	signedFileURL: string;
	signedFileKey: string;
	signedFileContentType: string;
	approvingUser: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	} | null;
	academicTerms: Array<{ __typename?: "AcademicTerm"; id: string; name: string }>;
	student: {
		__typename?: "Student";
		id: string;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		};
	};
	contractLineItems: Array<{
		__typename?: "ContractLineItem";
		id: string;
		displayOrder: number;
		isDiscount: boolean;
		amount: number;
		dateAdded: string | null;
		dateRemoved: string | null;
		service: { __typename?: "Service"; id: string; name: string } | null;
		discount: { __typename?: "Discount"; id: string; name: string } | null;
		childContractLineItems: Array<{
			__typename?: "ContractLineItem";
			id: string;
			displayOrder: number;
			isDiscount: boolean;
			amount: number;
			service: { __typename?: "Service"; id: string; name: string } | null;
			discount: { __typename?: "Discount"; id: string; name: string } | null;
		}>;
	}>;
	contractInstallments: Array<{
		__typename?: "ContractInstallment";
		id: string;
		dueDate: string;
		portion: number;
		invoices: Array<{
			__typename?: "Invoice";
			id: string;
			paymentLineItems: Array<{ __typename?: "PaymentLineItem"; id: string; amount: number }>;
			billingAdjustments: Array<{ __typename?: "BillingAdjustment"; id: string; amount: number }>;
		}>;
	}>;
};

export type ContractDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ContractDetailQuery = {
	__typename?: "Query";
	contract: {
		__typename?: "Contract";
		id: string;
		name: string;
		status: string;
		isApproved: boolean;
		isFinalized: boolean;
		effectiveDate: string | null;
		dateVoided: string | null;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		signedFileURL: string;
		signedFileKey: string;
		signedFileContentType: string;
		approvingUser: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		academicTerms: Array<{ __typename?: "AcademicTerm"; id: string; name: string }>;
		student: {
			__typename?: "Student";
			id: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		};
		contractLineItems: Array<{
			__typename?: "ContractLineItem";
			id: string;
			displayOrder: number;
			isDiscount: boolean;
			amount: number;
			dateAdded: string | null;
			dateRemoved: string | null;
			service: { __typename?: "Service"; id: string; name: string } | null;
			discount: { __typename?: "Discount"; id: string; name: string } | null;
			childContractLineItems: Array<{
				__typename?: "ContractLineItem";
				id: string;
				displayOrder: number;
				isDiscount: boolean;
				amount: number;
				service: { __typename?: "Service"; id: string; name: string } | null;
				discount: { __typename?: "Discount"; id: string; name: string } | null;
			}>;
		}>;
		contractInstallments: Array<{
			__typename?: "ContractInstallment";
			id: string;
			dueDate: string;
			portion: number;
			invoices: Array<{
				__typename?: "Invoice";
				id: string;
				paymentLineItems: Array<{ __typename?: "PaymentLineItem"; id: string; amount: number }>;
				billingAdjustments: Array<{ __typename?: "BillingAdjustment"; id: string; amount: number }>;
			}>;
		}>;
	};
};

export type ContractStudentIdQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ContractStudentIdQuery = {
	__typename?: "Query";
	contract: { __typename?: "Contract"; id: string; studentID: string };
};

export type ContractDisplayQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
	studentID: Scalars["ID"]["input"];
}>;

export type ContractDisplayQuery = {
	__typename?: "Query";
	contract: {
		__typename?: "Contract";
		id: string;
		name: string;
		effectiveDate: string | null;
		student: {
			__typename?: "Student";
			id: string;
			graduationYear: number | null;
			person: {
				__typename?: "Person";
				id: string;
				givenName: string;
				familyName: string;
				dateOfBirth: string | null;
				gender: string;
				nationalIdentificationNumber: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
			studentMedicalProfile: {
				__typename?: "StudentMedicalProfile";
				id: string;
				isSchoolAllowedToTreat: boolean;
				isSchoolAllowedToUseEpipen: boolean;
			} | null;
		};
		contractLineItems: Array<{
			__typename?: "ContractLineItem";
			id: string;
			displayOrder: number;
			isDiscount: boolean;
			amount: number;
			dateAdded: string | null;
			dateRemoved: string | null;
			service: { __typename?: "Service"; id: string; category: ServiceCategory; name: string } | null;
			discount: { __typename?: "Discount"; id: string; name: string } | null;
			childContractLineItems: Array<{
				__typename?: "ContractLineItem";
				id: string;
				displayOrder: number;
				isDiscount: boolean;
				amount: number;
				service: { __typename?: "Service"; id: string; name: string } | null;
				discount: { __typename?: "Discount"; id: string; name: string } | null;
			}>;
		}>;
		contractInstallments: Array<{
			__typename?: "ContractInstallment";
			id: string;
			dueDate: string;
			portion: number;
			invoices: Array<{
				__typename?: "Invoice";
				id: string;
				paymentLineItems: Array<{ __typename?: "PaymentLineItem"; id: string; amount: number }>;
				billingAdjustments: Array<{ __typename?: "BillingAdjustment"; id: string; amount: number }>;
			}>;
		}>;
	};
	guardianConnection: {
		__typename?: "GuardianConnection";
		edges: Array<{
			__typename?: "GuardianEdge";
			node: {
				__typename?: "Guardian";
				id: string;
				relationshipStatus: GuardianRelationshipStatus | null;
				person: {
					__typename?: "Person";
					id: string;
					givenName: string;
					familyName: string;
					nationalIdentificationNumber: string;
					governmentDocumentSeries: string;
					governmentDocumentNumber: string;
					governmentDocumentIssuedBy: string;
					name: string;
					publicName: string;
					phoneNumbers: Array<{ __typename?: "PhoneNumber"; id: string; phoneNumber: string }>;
					emailAddresses: Array<{ __typename?: "EmailAddress"; id: string; emailAddress: string }>;
					addresses: Array<{
						__typename?: "Address";
						id: string;
						name: string;
						addressLine1: string;
						addressLine2: string;
						city: string;
						postalCode: string;
						stateOrProvince: string;
						country: { __typename?: "Country"; id: string; name: string };
					}>;
				};
				relationships: Array<{ __typename?: "Relationship"; id: string; hasCustody: boolean }>;
			};
		}>;
	};
	studentThirdPartyContractPayer: {
		__typename?: "ThirdPartyContractPayer";
		companyName: string;
		fiscalNumber: string;
		tradeRegistryNumber: string;
		companyAddress: string;
		legalRepresentative: string;
		representativeEmail: string;
		phone: string;
	};
	studentPrescriptionMedicationConnection: {
		__typename?: "StudentPrescriptionMedicationConnection";
		edges: Array<{
			__typename?: "StudentPrescriptionMedicationEdge";
			node: {
				__typename?: "StudentPrescriptionMedication";
				id: string;
				notes: string;
				canSelfAdminister: boolean;
				administration: string;
				medication: { __typename?: "Medication"; id: string; name: string };
			};
		}>;
	};
	studentMedicalConditionConnection: {
		__typename?: "StudentMedicalConditionConnection";
		edges: Array<{
			__typename?: "StudentMedicalConditionEdge";
			node: {
				__typename?: "StudentMedicalCondition";
				id: string;
				notes: string;
				medicalCondition: { __typename?: "MedicalCondition"; id: string; name: string };
			};
		}>;
	};
	studentOTCMedicationConnection: {
		__typename?: "StudentOTCMedicationConnection";
		edges: Array<{
			__typename?: "StudentOTCMedicationEdge";
			node: {
				__typename?: "StudentOTCMedication";
				id: string;
				isAllowed: boolean;
				medication: { __typename?: "Medication"; id: string; name: string };
			};
		}>;
	};
};

export type ContractIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractFilterInput> | ContractFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ContractOrder>;
}>;

export type ContractIndexQuery = {
	__typename?: "Query";
	contractConnection: {
		__typename?: "ContractConnection";
		edges: Array<{
			__typename?: "ContractEdge";
			node: {
				__typename?: "Contract";
				id: string;
				name: string;
				status: string;
				isApproved: boolean;
				isFinalized: boolean;
				effectiveDate: string | null;
				dateVoided: string | null;
				fileURL: string;
				fileContentType: string;
				signedFileURL: string;
				signedFileContentType: string;
			};
		}>;
	};
};

export type ContractListQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractFilterInput> | ContractFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ContractOrder>;
}>;

export type ContractListQuery = {
	__typename?: "Query";
	contractConnection: {
		__typename?: "ContractConnection";
		edges: Array<{
			__typename?: "ContractEdge";
			node: {
				__typename?: "Contract";
				id: string;
				name: string;
				status: string;
				effectiveDate: string | null;
				dateVoided: string | null;
				student: {
					__typename?: "Student";
					id: string;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					};
				};
				contractLineItems: Array<{
					__typename?: "ContractLineItem";
					id: string;
					displayOrder: number;
					amount: number;
					dateAdded: string | null;
					dateRemoved: string | null;
					isDiscount: boolean;
					service: { __typename?: "Service"; id: string; name: string } | null;
					discount: { __typename?: "Discount"; id: string; name: string } | null;
					childContractLineItems: Array<{
						__typename?: "ContractLineItem";
						id: string;
						amount: number;
						isDiscount: boolean;
						service: { __typename?: "Service"; id: string; name: string } | null;
						discount: { __typename?: "Discount"; id: string; name: string } | null;
					}>;
				}>;
				contractInstallments: Array<{
					__typename?: "ContractInstallment";
					id: string;
					dueDate: string;
					portion: number;
					invoices: Array<{
						__typename?: "Invoice";
						id: string;
						paymentLineItems: Array<{ __typename?: "PaymentLineItem"; id: string; amount: number }>;
						billingAdjustments: Array<{ __typename?: "BillingAdjustment"; id: string; amount: number }>;
					}>;
				}>;
			};
		}>;
	};
};

export type ContractNameFragment = { __typename?: "Contract"; name: string };

export type ContractNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ContractNameQuery = {
	__typename?: "Query";
	contract: { __typename?: "Contract"; id: string; name: string };
};

export type ContractNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractFilterInput> | ContractFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ContractOrder>;
}>;

export type ContractNamesQuery = {
	__typename?: "Query";
	contractConnection: {
		__typename?: "ContractConnection";
		edges: Array<{ __typename?: "ContractEdge"; node: { __typename?: "Contract"; id: string; name: string } }>;
	};
};

export type ContractPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractFilterInput> | ContractFilterInput>;
	order?: InputMaybe<ContractOrder>;
}>;

export type ContractPaginationQuery = {
	__typename?: "Query";
	contractConnection: {
		__typename?: "ContractConnection";
		totalCount: number;
		edges: Array<{ __typename?: "ContractEdge"; cursor: string }>;
	};
};

export type ContractSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractFilterInput> | ContractFilterInput>;
	order?: InputMaybe<ContractOrder>;
}>;

export type ContractSelectQuery = {
	__typename?: "Query";
	contractConnection: {
		__typename?: "ContractConnection";
		edges: Array<{
			__typename?: "ContractEdge";
			node: { __typename?: "Contract"; id: string; effectiveDate: string | null; name: string };
		}>;
	};
};

export type ContractUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: ContractUpdateInput;
}>;

export type ContractUpdateMutation = {
	__typename?: "Mutation";
	updateContract: {
		__typename?: "Contract";
		id: string;
		name: string;
		status: string;
		isApproved: boolean;
		isFinalized: boolean;
		effectiveDate: string | null;
		dateVoided: string | null;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		signedFileURL: string;
		signedFileKey: string;
		signedFileContentType: string;
		approvingUser: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		academicTerms: Array<{ __typename?: "AcademicTerm"; id: string; name: string }>;
		student: {
			__typename?: "Student";
			id: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		};
		contractLineItems: Array<{
			__typename?: "ContractLineItem";
			id: string;
			displayOrder: number;
			isDiscount: boolean;
			amount: number;
			dateAdded: string | null;
			dateRemoved: string | null;
			service: { __typename?: "Service"; id: string; name: string } | null;
			discount: { __typename?: "Discount"; id: string; name: string } | null;
			childContractLineItems: Array<{
				__typename?: "ContractLineItem";
				id: string;
				displayOrder: number;
				isDiscount: boolean;
				amount: number;
				service: { __typename?: "Service"; id: string; name: string } | null;
				discount: { __typename?: "Discount"; id: string; name: string } | null;
			}>;
		}>;
		contractInstallments: Array<{
			__typename?: "ContractInstallment";
			id: string;
			dueDate: string;
			portion: number;
			invoices: Array<{
				__typename?: "Invoice";
				id: string;
				paymentLineItems: Array<{ __typename?: "PaymentLineItem"; id: string; amount: number }>;
				billingAdjustments: Array<{ __typename?: "BillingAdjustment"; id: string; amount: number }>;
			}>;
		}>;
	};
};

export type ContractInstallmentCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractInstallmentFilterInput> | ContractInstallmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ContractInstallmentOrder>;
}>;

export type ContractInstallmentCountQuery = {
	__typename?: "Query";
	contractInstallmentConnection: { __typename?: "ContractInstallmentConnection"; totalCount: number };
};

export type ContractInstallmentCreateMutationVariables = Exact<{
	input: ContractInstallmentCreateInput;
}>;

export type ContractInstallmentCreateMutation = {
	__typename?: "Mutation";
	createContractInstallment: {
		__typename?: "ContractInstallment";
		id: string;
		dueDate: string;
		portion: number;
		contract: {
			__typename?: "Contract";
			id: string;
			name: string;
			status: string;
			isApproved: boolean;
			isFinalized: boolean;
			effectiveDate: string | null;
			dateVoided: string | null;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			signedFileURL: string;
			signedFileKey: string;
			signedFileContentType: string;
			approvingUser: {
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			} | null;
			academicTerms: Array<{ __typename?: "AcademicTerm"; id: string; name: string }>;
			student: {
				__typename?: "Student";
				id: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
			contractLineItems: Array<{
				__typename?: "ContractLineItem";
				id: string;
				displayOrder: number;
				isDiscount: boolean;
				amount: number;
				dateAdded: string | null;
				dateRemoved: string | null;
				service: { __typename?: "Service"; id: string; name: string } | null;
				discount: { __typename?: "Discount"; id: string; name: string } | null;
				childContractLineItems: Array<{
					__typename?: "ContractLineItem";
					id: string;
					displayOrder: number;
					isDiscount: boolean;
					amount: number;
					service: { __typename?: "Service"; id: string; name: string } | null;
					discount: { __typename?: "Discount"; id: string; name: string } | null;
				}>;
			}>;
			contractInstallments: Array<{
				__typename?: "ContractInstallment";
				id: string;
				dueDate: string;
				portion: number;
				invoices: Array<{
					__typename?: "Invoice";
					id: string;
					paymentLineItems: Array<{ __typename?: "PaymentLineItem"; id: string; amount: number }>;
					billingAdjustments: Array<{ __typename?: "BillingAdjustment"; id: string; amount: number }>;
				}>;
			}>;
		};
		invoices: Array<{
			__typename?: "Invoice";
			id: string;
			name: string;
			issueDate: string;
			dueDate: string;
			status: InvoiceStatus;
			invoiceLineItems: Array<{
				__typename?: "InvoiceLineItem";
				id: string;
				amount: number;
				contractLineItem: {
					__typename?: "ContractLineItem";
					id: string;
					service: { __typename?: "Service"; id: string; name: string } | null;
					discount: { __typename?: "Discount"; id: string; name: string } | null;
				};
			}>;
			paymentLineItems: Array<{
				__typename?: "PaymentLineItem";
				id: string;
				amount: number;
				localAmount: number | null;
				payment: {
					__typename?: "Payment";
					id: string;
					issueDate: string;
					paymentMethod: PaymentPaymentMethod;
					isInLocalCurrency: boolean;
					localCurrency: string;
				};
			}>;
			billingAdjustments: Array<{ __typename?: "BillingAdjustment"; id: string; amount: number }>;
		}>;
	};
};

export type ContractInstallmentDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ContractInstallmentDeleteMutation = { __typename?: "Mutation"; deleteContractInstallment: boolean };

export type ContractInstallmentDetailFragment = {
	__typename?: "ContractInstallment";
	id: string;
	dueDate: string;
	portion: number;
	contract: {
		__typename?: "Contract";
		id: string;
		name: string;
		status: string;
		isApproved: boolean;
		isFinalized: boolean;
		effectiveDate: string | null;
		dateVoided: string | null;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		signedFileURL: string;
		signedFileKey: string;
		signedFileContentType: string;
		approvingUser: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		academicTerms: Array<{ __typename?: "AcademicTerm"; id: string; name: string }>;
		student: {
			__typename?: "Student";
			id: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		};
		contractLineItems: Array<{
			__typename?: "ContractLineItem";
			id: string;
			displayOrder: number;
			isDiscount: boolean;
			amount: number;
			dateAdded: string | null;
			dateRemoved: string | null;
			service: { __typename?: "Service"; id: string; name: string } | null;
			discount: { __typename?: "Discount"; id: string; name: string } | null;
			childContractLineItems: Array<{
				__typename?: "ContractLineItem";
				id: string;
				displayOrder: number;
				isDiscount: boolean;
				amount: number;
				service: { __typename?: "Service"; id: string; name: string } | null;
				discount: { __typename?: "Discount"; id: string; name: string } | null;
			}>;
		}>;
		contractInstallments: Array<{
			__typename?: "ContractInstallment";
			id: string;
			dueDate: string;
			portion: number;
			invoices: Array<{
				__typename?: "Invoice";
				id: string;
				paymentLineItems: Array<{ __typename?: "PaymentLineItem"; id: string; amount: number }>;
				billingAdjustments: Array<{ __typename?: "BillingAdjustment"; id: string; amount: number }>;
			}>;
		}>;
	};
	invoices: Array<{
		__typename?: "Invoice";
		id: string;
		name: string;
		issueDate: string;
		dueDate: string;
		status: InvoiceStatus;
		invoiceLineItems: Array<{
			__typename?: "InvoiceLineItem";
			id: string;
			amount: number;
			contractLineItem: {
				__typename?: "ContractLineItem";
				id: string;
				service: { __typename?: "Service"; id: string; name: string } | null;
				discount: { __typename?: "Discount"; id: string; name: string } | null;
			};
		}>;
		paymentLineItems: Array<{
			__typename?: "PaymentLineItem";
			id: string;
			amount: number;
			localAmount: number | null;
			payment: {
				__typename?: "Payment";
				id: string;
				issueDate: string;
				paymentMethod: PaymentPaymentMethod;
				isInLocalCurrency: boolean;
				localCurrency: string;
			};
		}>;
		billingAdjustments: Array<{ __typename?: "BillingAdjustment"; id: string; amount: number }>;
	}>;
};

export type ContractInstallmentDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ContractInstallmentDetailQuery = {
	__typename?: "Query";
	contractInstallment: {
		__typename?: "ContractInstallment";
		id: string;
		dueDate: string;
		portion: number;
		contract: {
			__typename?: "Contract";
			id: string;
			name: string;
			status: string;
			isApproved: boolean;
			isFinalized: boolean;
			effectiveDate: string | null;
			dateVoided: string | null;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			signedFileURL: string;
			signedFileKey: string;
			signedFileContentType: string;
			approvingUser: {
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			} | null;
			academicTerms: Array<{ __typename?: "AcademicTerm"; id: string; name: string }>;
			student: {
				__typename?: "Student";
				id: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
			contractLineItems: Array<{
				__typename?: "ContractLineItem";
				id: string;
				displayOrder: number;
				isDiscount: boolean;
				amount: number;
				dateAdded: string | null;
				dateRemoved: string | null;
				service: { __typename?: "Service"; id: string; name: string } | null;
				discount: { __typename?: "Discount"; id: string; name: string } | null;
				childContractLineItems: Array<{
					__typename?: "ContractLineItem";
					id: string;
					displayOrder: number;
					isDiscount: boolean;
					amount: number;
					service: { __typename?: "Service"; id: string; name: string } | null;
					discount: { __typename?: "Discount"; id: string; name: string } | null;
				}>;
			}>;
			contractInstallments: Array<{
				__typename?: "ContractInstallment";
				id: string;
				dueDate: string;
				portion: number;
				invoices: Array<{
					__typename?: "Invoice";
					id: string;
					paymentLineItems: Array<{ __typename?: "PaymentLineItem"; id: string; amount: number }>;
					billingAdjustments: Array<{ __typename?: "BillingAdjustment"; id: string; amount: number }>;
				}>;
			}>;
		};
		invoices: Array<{
			__typename?: "Invoice";
			id: string;
			name: string;
			issueDate: string;
			dueDate: string;
			status: InvoiceStatus;
			invoiceLineItems: Array<{
				__typename?: "InvoiceLineItem";
				id: string;
				amount: number;
				contractLineItem: {
					__typename?: "ContractLineItem";
					id: string;
					service: { __typename?: "Service"; id: string; name: string } | null;
					discount: { __typename?: "Discount"; id: string; name: string } | null;
				};
			}>;
			paymentLineItems: Array<{
				__typename?: "PaymentLineItem";
				id: string;
				amount: number;
				localAmount: number | null;
				payment: {
					__typename?: "Payment";
					id: string;
					issueDate: string;
					paymentMethod: PaymentPaymentMethod;
					isInLocalCurrency: boolean;
					localCurrency: string;
				};
			}>;
			billingAdjustments: Array<{ __typename?: "BillingAdjustment"; id: string; amount: number }>;
		}>;
	};
};

export type ContractInstallmentIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractInstallmentFilterInput> | ContractInstallmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ContractInstallmentOrder>;
}>;

export type ContractInstallmentIndexQuery = {
	__typename?: "Query";
	contractInstallmentConnection: {
		__typename?: "ContractInstallmentConnection";
		edges: Array<{
			__typename?: "ContractInstallmentEdge";
			node: { __typename?: "ContractInstallment"; id: string; dueDate: string; portion: number };
		}>;
	};
};

export type ContractInstallmentNameFragment = { __typename?: "ContractInstallment"; id: string };

export type ContractInstallmentNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ContractInstallmentNameQuery = {
	__typename?: "Query";
	contractInstallment: { __typename?: "ContractInstallment"; id: string };
};

export type ContractInstallmentNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractInstallmentFilterInput> | ContractInstallmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ContractInstallmentOrder>;
}>;

export type ContractInstallmentNamesQuery = {
	__typename?: "Query";
	contractInstallmentConnection: {
		__typename?: "ContractInstallmentConnection";
		edges: Array<{ __typename?: "ContractInstallmentEdge"; node: { __typename?: "ContractInstallment"; id: string } }>;
	};
};

export type ContractInstallmentPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractInstallmentFilterInput> | ContractInstallmentFilterInput>;
	order?: InputMaybe<ContractInstallmentOrder>;
}>;

export type ContractInstallmentPaginationQuery = {
	__typename?: "Query";
	contractInstallmentConnection: {
		__typename?: "ContractInstallmentConnection";
		totalCount: number;
		edges: Array<{ __typename?: "ContractInstallmentEdge"; cursor: string }>;
	};
};

export type ContractInstallmentSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractInstallmentFilterInput> | ContractInstallmentFilterInput>;
	order?: InputMaybe<ContractInstallmentOrder>;
}>;

export type ContractInstallmentSelectQuery = {
	__typename?: "Query";
	contractInstallmentConnection: {
		__typename?: "ContractInstallmentConnection";
		edges: Array<{ __typename?: "ContractInstallmentEdge"; node: { __typename?: "ContractInstallment"; id: string } }>;
	};
};

export type ContractInstallmentUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: ContractInstallmentUpdateInput;
}>;

export type ContractInstallmentUpdateMutation = {
	__typename?: "Mutation";
	updateContractInstallment: {
		__typename?: "ContractInstallment";
		id: string;
		dueDate: string;
		portion: number;
		contract: {
			__typename?: "Contract";
			id: string;
			name: string;
			status: string;
			isApproved: boolean;
			isFinalized: boolean;
			effectiveDate: string | null;
			dateVoided: string | null;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			signedFileURL: string;
			signedFileKey: string;
			signedFileContentType: string;
			approvingUser: {
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			} | null;
			academicTerms: Array<{ __typename?: "AcademicTerm"; id: string; name: string }>;
			student: {
				__typename?: "Student";
				id: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
			contractLineItems: Array<{
				__typename?: "ContractLineItem";
				id: string;
				displayOrder: number;
				isDiscount: boolean;
				amount: number;
				dateAdded: string | null;
				dateRemoved: string | null;
				service: { __typename?: "Service"; id: string; name: string } | null;
				discount: { __typename?: "Discount"; id: string; name: string } | null;
				childContractLineItems: Array<{
					__typename?: "ContractLineItem";
					id: string;
					displayOrder: number;
					isDiscount: boolean;
					amount: number;
					service: { __typename?: "Service"; id: string; name: string } | null;
					discount: { __typename?: "Discount"; id: string; name: string } | null;
				}>;
			}>;
			contractInstallments: Array<{
				__typename?: "ContractInstallment";
				id: string;
				dueDate: string;
				portion: number;
				invoices: Array<{
					__typename?: "Invoice";
					id: string;
					paymentLineItems: Array<{ __typename?: "PaymentLineItem"; id: string; amount: number }>;
					billingAdjustments: Array<{ __typename?: "BillingAdjustment"; id: string; amount: number }>;
				}>;
			}>;
		};
		invoices: Array<{
			__typename?: "Invoice";
			id: string;
			name: string;
			issueDate: string;
			dueDate: string;
			status: InvoiceStatus;
			invoiceLineItems: Array<{
				__typename?: "InvoiceLineItem";
				id: string;
				amount: number;
				contractLineItem: {
					__typename?: "ContractLineItem";
					id: string;
					service: { __typename?: "Service"; id: string; name: string } | null;
					discount: { __typename?: "Discount"; id: string; name: string } | null;
				};
			}>;
			paymentLineItems: Array<{
				__typename?: "PaymentLineItem";
				id: string;
				amount: number;
				localAmount: number | null;
				payment: {
					__typename?: "Payment";
					id: string;
					issueDate: string;
					paymentMethod: PaymentPaymentMethod;
					isInLocalCurrency: boolean;
					localCurrency: string;
				};
			}>;
			billingAdjustments: Array<{ __typename?: "BillingAdjustment"; id: string; amount: number }>;
		}>;
	};
};

export type ContractLineItemCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractLineItemFilterInput> | ContractLineItemFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ContractLineItemOrder>;
}>;

export type ContractLineItemCountQuery = {
	__typename?: "Query";
	contractLineItemConnection: { __typename?: "ContractLineItemConnection"; totalCount: number };
};

export type ContractLineItemCreateMutationVariables = Exact<{
	input: ContractLineItemCreateInput;
}>;

export type ContractLineItemCreateMutation = {
	__typename?: "Mutation";
	createContractLineItem: {
		__typename?: "ContractLineItem";
		id: string;
		displayOrder: number;
		description: string;
		isDiscount: boolean;
		amount: number;
		dateAdded: string | null;
		dateRemoved: string | null;
		contract: { __typename?: "Contract"; id: string; name: string } | null;
		discount: { __typename?: "Discount"; id: string; name: string } | null;
		parentContractLineItem: {
			__typename?: "ContractLineItem";
			id: string;
			service: { __typename?: "Service"; id: string; name: string } | null;
			discount: { __typename?: "Discount"; id: string; name: string } | null;
		} | null;
		service: { __typename?: "Service"; id: string; name: string } | null;
	};
};

export type ContractLineItemDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ContractLineItemDeleteMutation = { __typename?: "Mutation"; deleteContractLineItem: boolean };

export type ContractLineItemDetailFragment = {
	__typename?: "ContractLineItem";
	id: string;
	displayOrder: number;
	description: string;
	isDiscount: boolean;
	amount: number;
	dateAdded: string | null;
	dateRemoved: string | null;
	contract: { __typename?: "Contract"; id: string; name: string } | null;
	discount: { __typename?: "Discount"; id: string; name: string } | null;
	parentContractLineItem: {
		__typename?: "ContractLineItem";
		id: string;
		service: { __typename?: "Service"; id: string; name: string } | null;
		discount: { __typename?: "Discount"; id: string; name: string } | null;
	} | null;
	service: { __typename?: "Service"; id: string; name: string } | null;
};

export type ContractLineItemDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ContractLineItemDetailQuery = {
	__typename?: "Query";
	contractLineItem: {
		__typename?: "ContractLineItem";
		id: string;
		displayOrder: number;
		description: string;
		isDiscount: boolean;
		amount: number;
		dateAdded: string | null;
		dateRemoved: string | null;
		contract: { __typename?: "Contract"; id: string; name: string } | null;
		discount: { __typename?: "Discount"; id: string; name: string } | null;
		parentContractLineItem: {
			__typename?: "ContractLineItem";
			id: string;
			service: { __typename?: "Service"; id: string; name: string } | null;
			discount: { __typename?: "Discount"; id: string; name: string } | null;
		} | null;
		service: { __typename?: "Service"; id: string; name: string } | null;
	};
};

export type ContractLineItemIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractLineItemFilterInput> | ContractLineItemFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ContractLineItemOrder>;
}>;

export type ContractLineItemIndexQuery = {
	__typename?: "Query";
	contractLineItemConnection: {
		__typename?: "ContractLineItemConnection";
		edges: Array<{
			__typename?: "ContractLineItemEdge";
			node: {
				__typename?: "ContractLineItem";
				id: string;
				displayOrder: number;
				description: string;
				isDiscount: boolean;
				amount: number;
				dateAdded: string | null;
				dateRemoved: string | null;
			};
		}>;
	};
};

export type ChildContractLineItemListQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractLineItemFilterInput> | ContractLineItemFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ContractLineItemOrder>;
}>;

export type ChildContractLineItemListQuery = {
	__typename?: "Query";
	contractLineItemConnection: {
		__typename?: "ContractLineItemConnection";
		edges: Array<{
			__typename?: "ContractLineItemEdge";
			node: {
				__typename?: "ContractLineItem";
				id: string;
				displayOrder: number;
				isDiscount: boolean;
				amount: number;
				service: { __typename?: "Service"; id: string; name: string } | null;
				discount: { __typename?: "Discount"; id: string; name: string } | null;
			};
		}>;
	};
};

export type ContractLineItemNameFragment = {
	__typename?: "ContractLineItem";
	service: { __typename?: "Service"; id: string; name: string } | null;
	discount: { __typename?: "Discount"; id: string; name: string } | null;
};

export type ContractLineItemNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ContractLineItemNameQuery = {
	__typename?: "Query";
	contractLineItem: {
		__typename?: "ContractLineItem";
		id: string;
		service: { __typename?: "Service"; id: string; name: string } | null;
		discount: { __typename?: "Discount"; id: string; name: string } | null;
	};
};

export type ContractLineItemNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractLineItemFilterInput> | ContractLineItemFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ContractLineItemOrder>;
}>;

export type ContractLineItemNamesQuery = {
	__typename?: "Query";
	contractLineItemConnection: {
		__typename?: "ContractLineItemConnection";
		edges: Array<{
			__typename?: "ContractLineItemEdge";
			node: {
				__typename?: "ContractLineItem";
				id: string;
				service: { __typename?: "Service"; id: string; name: string } | null;
				discount: { __typename?: "Discount"; id: string; name: string } | null;
			};
		}>;
	};
};

export type ContractLineItemPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractLineItemFilterInput> | ContractLineItemFilterInput>;
	order?: InputMaybe<ContractLineItemOrder>;
}>;

export type ContractLineItemPaginationQuery = {
	__typename?: "Query";
	contractLineItemConnection: {
		__typename?: "ContractLineItemConnection";
		totalCount: number;
		edges: Array<{ __typename?: "ContractLineItemEdge"; cursor: string }>;
	};
};

export type ContractLineItemPricingFragment = {
	__typename?: "ContractLineItem";
	isDiscount: boolean;
	amount: number;
	childContractLineItems: Array<{ __typename?: "ContractLineItem"; isDiscount: boolean; amount: number }>;
};

export type ContractLineItemSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractLineItemFilterInput> | ContractLineItemFilterInput>;
	order?: InputMaybe<ContractLineItemOrder>;
}>;

export type ContractLineItemSelectQuery = {
	__typename?: "Query";
	contractLineItemConnection: {
		__typename?: "ContractLineItemConnection";
		edges: Array<{
			__typename?: "ContractLineItemEdge";
			node: {
				__typename?: "ContractLineItem";
				id: string;
				service: { __typename?: "Service"; id: string; name: string } | null;
				discount: { __typename?: "Discount"; id: string; name: string } | null;
			};
		}>;
	};
};

export type ContractLineItemUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: ContractLineItemUpdateInput;
}>;

export type ContractLineItemUpdateMutation = {
	__typename?: "Mutation";
	updateContractLineItem: {
		__typename?: "ContractLineItem";
		id: string;
		displayOrder: number;
		description: string;
		isDiscount: boolean;
		amount: number;
		dateAdded: string | null;
		dateRemoved: string | null;
		contract: { __typename?: "Contract"; id: string; name: string } | null;
		discount: { __typename?: "Discount"; id: string; name: string } | null;
		parentContractLineItem: {
			__typename?: "ContractLineItem";
			id: string;
			service: { __typename?: "Service"; id: string; name: string } | null;
			discount: { __typename?: "Discount"; id: string; name: string } | null;
		} | null;
		service: { __typename?: "Service"; id: string; name: string } | null;
	};
};

export type CountryCheckUniqueNameQueryVariables = Exact<{
	ignoreID?: InputMaybe<Scalars["ID"]["input"]>;
	name: Scalars["String"]["input"];
}>;

export type CountryCheckUniqueNameQuery = {
	__typename?: "Query";
	countryConnection: { __typename?: "CountryConnection"; totalCount: number };
};

export type CountryCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<CountryFilterInput> | CountryFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CountryOrder>;
}>;

export type CountryCountQuery = {
	__typename?: "Query";
	countryConnection: { __typename?: "CountryConnection"; totalCount: number };
};

export type CountryCreateMutationVariables = Exact<{
	input: CountryCreateInput;
}>;

export type CountryCreateMutation = {
	__typename?: "Mutation";
	createCountry: {
		__typename?: "Country";
		id: string;
		name: string;
		enrollmentApplicationStudents: Array<{ __typename?: "EnrollmentApplicationStudent"; id: string; name: string }>;
		people: Array<{ __typename?: "Person"; id: string; name: string; publicName: string }>;
	};
};

export type CountryDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CountryDeleteMutation = { __typename?: "Mutation"; deleteCountry: boolean };

export type CountryDetailFragment = {
	__typename?: "Country";
	id: string;
	name: string;
	enrollmentApplicationStudents: Array<{ __typename?: "EnrollmentApplicationStudent"; id: string; name: string }>;
	people: Array<{ __typename?: "Person"; id: string; name: string; publicName: string }>;
};

export type CountryDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CountryDetailQuery = {
	__typename?: "Query";
	country: {
		__typename?: "Country";
		id: string;
		name: string;
		enrollmentApplicationStudents: Array<{ __typename?: "EnrollmentApplicationStudent"; id: string; name: string }>;
		people: Array<{ __typename?: "Person"; id: string; name: string; publicName: string }>;
	};
};

export type CountryIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<CountryFilterInput> | CountryFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CountryOrder>;
}>;

export type CountryIndexQuery = {
	__typename?: "Query";
	countryConnection: {
		__typename?: "CountryConnection";
		edges: Array<{ __typename?: "CountryEdge"; node: { __typename?: "Country"; id: string; name: string } }>;
	};
};

export type CountryNameFragment = { __typename?: "Country"; name: string };

export type CountryNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CountryNameQuery = { __typename?: "Query"; country: { __typename?: "Country"; id: string; name: string } };

export type CountryNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<CountryFilterInput> | CountryFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CountryOrder>;
}>;

export type CountryNamesQuery = {
	__typename?: "Query";
	countryConnection: {
		__typename?: "CountryConnection";
		edges: Array<{ __typename?: "CountryEdge"; node: { __typename?: "Country"; id: string; name: string } }>;
	};
};

export type CountryPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<CountryFilterInput> | CountryFilterInput>;
	order?: InputMaybe<CountryOrder>;
}>;

export type CountryPaginationQuery = {
	__typename?: "Query";
	countryConnection: {
		__typename?: "CountryConnection";
		totalCount: number;
		edges: Array<{ __typename?: "CountryEdge"; cursor: string }>;
	};
};

export type CountrySelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<CountryFilterInput> | CountryFilterInput>;
	order?: InputMaybe<CountryOrder>;
}>;

export type CountrySelectQuery = {
	__typename?: "Query";
	countryConnection: {
		__typename?: "CountryConnection";
		edges: Array<{ __typename?: "CountryEdge"; node: { __typename?: "Country"; id: string; name: string } }>;
	};
};

export type CountryUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: CountryUpdateInput;
}>;

export type CountryUpdateMutation = {
	__typename?: "Mutation";
	updateCountry: {
		__typename?: "Country";
		id: string;
		name: string;
		enrollmentApplicationStudents: Array<{ __typename?: "EnrollmentApplicationStudent"; id: string; name: string }>;
		people: Array<{ __typename?: "Person"; id: string; name: string; publicName: string }>;
	};
};

export type CourseCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseFilterInput> | CourseFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseOrder>;
}>;

export type CourseCountQuery = {
	__typename?: "Query";
	courseConnection: { __typename?: "CourseConnection"; totalCount: number };
};

export type CourseCreateMutationVariables = Exact<{
	input: CourseCreateInput;
}>;

export type CourseCreateMutation = {
	__typename?: "Mutation";
	createCourse: {
		__typename?: "Course";
		id: string;
		name: string;
		description: string;
		academicSubject: { __typename?: "AcademicSubject"; id: string; name: string };
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
	};
};

export type CourseDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseDeleteMutation = { __typename?: "Mutation"; deleteCourse: boolean };

export type CourseDetailFragment = {
	__typename?: "Course";
	id: string;
	name: string;
	description: string;
	academicSubject: { __typename?: "AcademicSubject"; id: string; name: string };
	classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
};

export type CourseDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseDetailQuery = {
	__typename?: "Query";
	course: {
		__typename?: "Course";
		id: string;
		name: string;
		description: string;
		academicSubject: { __typename?: "AcademicSubject"; id: string; name: string };
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
	};
};

export type CourseIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseFilterInput> | CourseFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseOrder>;
}>;

export type CourseIndexQuery = {
	__typename?: "Query";
	courseConnection: {
		__typename?: "CourseConnection";
		edges: Array<{
			__typename?: "CourseEdge";
			node: {
				__typename?: "Course";
				id: string;
				name: string;
				description: string;
				academicSubject: { __typename?: "AcademicSubject"; id: string; name: string };
				classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
			};
		}>;
	};
};

export type CourseNameFragment = { __typename?: "Course"; name: string };

export type CourseNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseNameQuery = { __typename?: "Query"; course: { __typename?: "Course"; id: string; name: string } };

export type CourseNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseFilterInput> | CourseFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseOrder>;
}>;

export type CourseNamesQuery = {
	__typename?: "Query";
	courseConnection: {
		__typename?: "CourseConnection";
		edges: Array<{ __typename?: "CourseEdge"; node: { __typename?: "Course"; id: string; name: string } }>;
	};
};

export type CoursePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseFilterInput> | CourseFilterInput>;
	order?: InputMaybe<CourseOrder>;
}>;

export type CoursePaginationQuery = {
	__typename?: "Query";
	courseConnection: {
		__typename?: "CourseConnection";
		totalCount: number;
		edges: Array<{ __typename?: "CourseEdge"; cursor: string }>;
	};
};

export type CourseSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseFilterInput> | CourseFilterInput>;
	order?: InputMaybe<CourseOrder>;
}>;

export type CourseSelectQuery = {
	__typename?: "Query";
	courseConnection: {
		__typename?: "CourseConnection";
		edges: Array<{ __typename?: "CourseEdge"; node: { __typename?: "Course"; id: string; name: string } }>;
	};
};

export type CourseUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: CourseUpdateInput;
}>;

export type CourseUpdateMutation = {
	__typename?: "Mutation";
	updateCourse: {
		__typename?: "Course";
		id: string;
		name: string;
		description: string;
		academicSubject: { __typename?: "AcademicSubject"; id: string; name: string };
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
	};
};

export type CourseAssessmentCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentFilterInput> | CourseAssessmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentOrder>;
}>;

export type CourseAssessmentCountQuery = {
	__typename?: "Query";
	courseAssessmentConnection: { __typename?: "CourseAssessmentConnection"; totalCount: number };
};

export type CourseAssessmentCreateMutationVariables = Exact<{
	input: CourseAssessmentCreateInput;
}>;

export type CourseAssessmentCreateMutation = {
	__typename?: "Mutation";
	createCourseAssessment: {
		__typename?: "CourseAssessment";
		id: string;
		name: string;
		description: string;
		totalPoints: number;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		courseAssessmentCategory: { __typename?: "CourseAssessmentCategory"; id: string; name: string };
		courseAssessmentTimings: Array<{
			__typename?: "CourseAssessmentTiming";
			id: string;
			assignOn: string | null;
			dueOn: string | null;
			courseSection: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			};
		}>;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
		}>;
	};
};

export type CourseAssessmentDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAssessmentDeleteMutation = { __typename?: "Mutation"; deleteCourseAssessment: boolean };

export type CourseAssessmentDetailFragment = {
	__typename?: "CourseAssessment";
	id: string;
	name: string;
	description: string;
	totalPoints: number;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	} | null;
	courseAssessmentCategory: { __typename?: "CourseAssessmentCategory"; id: string; name: string };
	courseAssessmentTimings: Array<{
		__typename?: "CourseAssessmentTiming";
		id: string;
		assignOn: string | null;
		dueOn: string | null;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		};
	}>;
	mediaAttachments: Array<{
		__typename?: "MediaAttachment";
		id: string;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
	}>;
};

export type CourseAssessmentDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAssessmentDetailQuery = {
	__typename?: "Query";
	courseAssessment: {
		__typename?: "CourseAssessment";
		id: string;
		name: string;
		description: string;
		totalPoints: number;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		courseAssessmentCategory: { __typename?: "CourseAssessmentCategory"; id: string; name: string };
		courseAssessmentTimings: Array<{
			__typename?: "CourseAssessmentTiming";
			id: string;
			assignOn: string | null;
			dueOn: string | null;
			courseSection: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			};
		}>;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
		}>;
	};
};

export type CourseSectionGradeBookQueryVariables = Exact<{
	courseSectionID: Scalars["ID"]["input"];
	filters?: InputMaybe<Array<CourseAssessmentTimingFilterInput> | CourseAssessmentTimingFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentTimingOrder>;
}>;

export type CourseSectionGradeBookQuery = {
	__typename?: "Query";
	courseAssessmentTimingConnection: {
		__typename?: "CourseAssessmentTimingConnection";
		edges: Array<{
			__typename?: "CourseAssessmentTimingEdge";
			node: {
				__typename?: "CourseAssessmentTiming";
				id: string;
				dueOn: string | null;
				courseAssessment: {
					__typename?: "CourseAssessment";
					id: string;
					totalPoints: number;
					name: string;
					courseAssessmentSubmissions: Array<{
						__typename?: "CourseAssessmentSubmission";
						id: string;
						studentID: string;
					}>;
					courseAssessmentMarks: Array<{
						__typename?: "CourseAssessmentMark";
						id: string;
						studentID: string;
						points: number;
						wasLate: boolean;
						isExcused: boolean;
					}>;
				};
			};
		}>;
	};
};

export type StudentCourseSectionGradeBookQueryVariables = Exact<{
	studentID: Scalars["ID"]["input"];
	courseSectionID: Scalars["ID"]["input"];
	filters?: InputMaybe<Array<CourseAssessmentTimingFilterInput> | CourseAssessmentTimingFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentTimingOrder>;
}>;

export type StudentCourseSectionGradeBookQuery = {
	__typename?: "Query";
	courseAssessmentTimingConnection: {
		__typename?: "CourseAssessmentTimingConnection";
		edges: Array<{
			__typename?: "CourseAssessmentTimingEdge";
			node: {
				__typename?: "CourseAssessmentTiming";
				id: string;
				dueOn: string | null;
				courseAssessment: {
					__typename?: "CourseAssessment";
					id: string;
					totalPoints: number;
					name: string;
					courseAssessmentSubmissions: Array<{
						__typename?: "CourseAssessmentSubmission";
						id: string;
						studentID: string;
						submissionDate: string;
						mediaAttachments: Array<{
							__typename?: "MediaAttachment";
							id: string;
							isFile: boolean;
							fileContentType: string;
						}>;
					}>;
					courseAssessmentMarks: Array<{
						__typename?: "CourseAssessmentMark";
						id: string;
						studentID: string;
						points: number;
						wasLate: boolean;
						isExcused: boolean;
						notes: string;
					}>;
				};
			};
		}>;
	};
};

export type CourseAssessmentIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentFilterInput> | CourseAssessmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentOrder>;
}>;

export type CourseAssessmentIndexQuery = {
	__typename?: "Query";
	courseAssessmentConnection: {
		__typename?: "CourseAssessmentConnection";
		edges: Array<{
			__typename?: "CourseAssessmentEdge";
			node: { __typename?: "CourseAssessment"; id: string; name: string; description: string; totalPoints: number };
		}>;
	};
};

export type CourseSectionCourseAssessmentSummaryListQueryVariables = Exact<{
	courseSectionID: Scalars["ID"]["input"];
	filters?: InputMaybe<Array<CourseAssessmentFilterInput> | CourseAssessmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentOrder>;
}>;

export type CourseSectionCourseAssessmentSummaryListQuery = {
	__typename?: "Query";
	courseAssessmentConnection: {
		__typename?: "CourseAssessmentConnection";
		edges: Array<{
			__typename?: "CourseAssessmentEdge";
			node: {
				__typename?: "CourseAssessment";
				id: string;
				name: string;
				courseAssessmentCategory: { __typename?: "CourseAssessmentCategory"; id: string; name: string };
				courseAssessmentSubmissions: Array<{ __typename?: "CourseAssessmentSubmission"; id: string }>;
				courseAssessmentMarks: Array<{ __typename?: "CourseAssessmentMark"; id: string }>;
				courseAssessmentTimings: Array<{ __typename?: "CourseAssessmentTiming"; id: string; dueOn: string | null }>;
			};
		}>;
	};
};

export type CourseSectionCourseAssessmentPreviewSummaryListQueryVariables = Exact<{
	courseSectionID: Scalars["ID"]["input"];
	filters?: InputMaybe<Array<CourseAssessmentFilterInput> | CourseAssessmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentOrder>;
}>;

export type CourseSectionCourseAssessmentPreviewSummaryListQuery = {
	__typename?: "Query";
	courseAssessmentConnection: {
		__typename?: "CourseAssessmentConnection";
		edges: Array<{
			__typename?: "CourseAssessmentEdge";
			node: {
				__typename?: "CourseAssessment";
				id: string;
				name: string;
				courseAssessmentCategory: { __typename?: "CourseAssessmentCategory"; id: string; name: string };
				courseAssessmentTimings: Array<{ __typename?: "CourseAssessmentTiming"; id: string; dueOn: string | null }>;
			};
		}>;
	};
};

export type CourseAssessmentNameFragment = { __typename?: "CourseAssessment"; name: string };

export type CourseAssessmentNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAssessmentNameQuery = {
	__typename?: "Query";
	courseAssessment: { __typename?: "CourseAssessment"; id: string; name: string };
};

export type CourseAssessmentNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentFilterInput> | CourseAssessmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentOrder>;
}>;

export type CourseAssessmentNamesQuery = {
	__typename?: "Query";
	courseAssessmentConnection: {
		__typename?: "CourseAssessmentConnection";
		edges: Array<{
			__typename?: "CourseAssessmentEdge";
			node: { __typename?: "CourseAssessment"; id: string; name: string };
		}>;
	};
};

export type CourseAssessmentPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentFilterInput> | CourseAssessmentFilterInput>;
	order?: InputMaybe<CourseAssessmentOrder>;
}>;

export type CourseAssessmentPaginationQuery = {
	__typename?: "Query";
	courseAssessmentConnection: {
		__typename?: "CourseAssessmentConnection";
		totalCount: number;
		edges: Array<{ __typename?: "CourseAssessmentEdge"; cursor: string }>;
	};
};

export type CourseAssessmentSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentFilterInput> | CourseAssessmentFilterInput>;
	order?: InputMaybe<CourseAssessmentOrder>;
}>;

export type CourseAssessmentSelectQuery = {
	__typename?: "Query";
	courseAssessmentConnection: {
		__typename?: "CourseAssessmentConnection";
		edges: Array<{
			__typename?: "CourseAssessmentEdge";
			node: { __typename?: "CourseAssessment"; id: string; name: string };
		}>;
	};
};

export type CourseAssessmentStudentsListQueryVariables = Exact<{
	courseAssessmentID: Scalars["ID"]["input"];
	filters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentOrder>;
}>;

export type CourseAssessmentStudentsListQuery = {
	__typename?: "Query";
	studentConnection: {
		__typename?: "StudentConnection";
		edges: Array<{
			__typename?: "StudentEdge";
			node: {
				__typename?: "Student";
				id: string;
				courseAssessmentMarks: Array<{
					__typename?: "CourseAssessmentMark";
					id: string;
					wasLate: boolean;
					points: number;
					isExcused: boolean;
					notes: string;
				}>;
				courseAssessmentSubmissions: Array<{
					__typename?: "CourseAssessmentSubmission";
					id: string;
					submissionDate: string;
					mediaAttachments: Array<{
						__typename?: "MediaAttachment";
						id: string;
						isFile: boolean;
						fileContentType: string;
					}>;
				}>;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			};
		}>;
	};
};

export type CourseAssessmentUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: CourseAssessmentUpdateInput;
}>;

export type CourseAssessmentUpdateMutation = {
	__typename?: "Mutation";
	updateCourseAssessment: {
		__typename?: "CourseAssessment";
		id: string;
		name: string;
		description: string;
		totalPoints: number;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		courseAssessmentCategory: { __typename?: "CourseAssessmentCategory"; id: string; name: string };
		courseAssessmentTimings: Array<{
			__typename?: "CourseAssessmentTiming";
			id: string;
			assignOn: string | null;
			dueOn: string | null;
			courseSection: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			};
		}>;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
		}>;
	};
};

export type CourseAssessmentCategoryCheckUniqueNameQueryVariables = Exact<{
	ignoreID?: InputMaybe<Scalars["ID"]["input"]>;
	name: Scalars["String"]["input"];
}>;

export type CourseAssessmentCategoryCheckUniqueNameQuery = {
	__typename?: "Query";
	courseAssessmentCategoryConnection: { __typename?: "CourseAssessmentCategoryConnection"; totalCount: number };
};

export type CourseAssessmentCategoryCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentCategoryFilterInput> | CourseAssessmentCategoryFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentCategoryOrder>;
}>;

export type CourseAssessmentCategoryCountQuery = {
	__typename?: "Query";
	courseAssessmentCategoryConnection: { __typename?: "CourseAssessmentCategoryConnection"; totalCount: number };
};

export type CourseAssessmentCategoryCreateMutationVariables = Exact<{
	input: CourseAssessmentCategoryCreateInput;
}>;

export type CourseAssessmentCategoryCreateMutation = {
	__typename?: "Mutation";
	createCourseAssessmentCategory: { __typename?: "CourseAssessmentCategory"; id: string; name: string };
};

export type CourseAssessmentCategoryDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAssessmentCategoryDeleteMutation = {
	__typename?: "Mutation";
	deleteCourseAssessmentCategory: boolean;
};

export type CourseAssessmentCategoryDetailFragment = {
	__typename?: "CourseAssessmentCategory";
	id: string;
	name: string;
};

export type CourseAssessmentCategoryDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAssessmentCategoryDetailQuery = {
	__typename?: "Query";
	courseAssessmentCategory: { __typename?: "CourseAssessmentCategory"; id: string; name: string };
};

export type CourseAssessmentCategoryIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentCategoryFilterInput> | CourseAssessmentCategoryFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentCategoryOrder>;
}>;

export type CourseAssessmentCategoryIndexQuery = {
	__typename?: "Query";
	courseAssessmentCategoryConnection: {
		__typename?: "CourseAssessmentCategoryConnection";
		edges: Array<{
			__typename?: "CourseAssessmentCategoryEdge";
			node: { __typename?: "CourseAssessmentCategory"; id: string; name: string };
		}>;
	};
};

export type CourseAssessmentCategoryNameFragment = { __typename?: "CourseAssessmentCategory"; name: string };

export type CourseAssessmentCategoryNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAssessmentCategoryNameQuery = {
	__typename?: "Query";
	courseAssessmentCategory: { __typename?: "CourseAssessmentCategory"; id: string; name: string };
};

export type CourseAssessmentCategoryNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentCategoryFilterInput> | CourseAssessmentCategoryFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentCategoryOrder>;
}>;

export type CourseAssessmentCategoryNamesQuery = {
	__typename?: "Query";
	courseAssessmentCategoryConnection: {
		__typename?: "CourseAssessmentCategoryConnection";
		edges: Array<{
			__typename?: "CourseAssessmentCategoryEdge";
			node: { __typename?: "CourseAssessmentCategory"; id: string; name: string };
		}>;
	};
};

export type CourseAssessmentCategoryPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentCategoryFilterInput> | CourseAssessmentCategoryFilterInput>;
	order?: InputMaybe<CourseAssessmentCategoryOrder>;
}>;

export type CourseAssessmentCategoryPaginationQuery = {
	__typename?: "Query";
	courseAssessmentCategoryConnection: {
		__typename?: "CourseAssessmentCategoryConnection";
		totalCount: number;
		edges: Array<{ __typename?: "CourseAssessmentCategoryEdge"; cursor: string }>;
	};
};

export type CourseAssessmentCategorySelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentCategoryFilterInput> | CourseAssessmentCategoryFilterInput>;
	order?: InputMaybe<CourseAssessmentCategoryOrder>;
}>;

export type CourseAssessmentCategorySelectQuery = {
	__typename?: "Query";
	courseAssessmentCategoryConnection: {
		__typename?: "CourseAssessmentCategoryConnection";
		edges: Array<{
			__typename?: "CourseAssessmentCategoryEdge";
			node: { __typename?: "CourseAssessmentCategory"; id: string; name: string };
		}>;
	};
};

export type CourseAssessmentCategoryUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: CourseAssessmentCategoryUpdateInput;
}>;

export type CourseAssessmentCategoryUpdateMutation = {
	__typename?: "Mutation";
	updateCourseAssessmentCategory: { __typename?: "CourseAssessmentCategory"; id: string; name: string };
};

export type CourseAssessmentCategoryMarkPortionCountQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<CourseAssessmentCategoryMarkPortionFilterInput> | CourseAssessmentCategoryMarkPortionFilterInput
	>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentCategoryMarkPortionOrder>;
}>;

export type CourseAssessmentCategoryMarkPortionCountQuery = {
	__typename?: "Query";
	courseAssessmentCategoryMarkPortionConnection: {
		__typename?: "CourseAssessmentCategoryMarkPortionConnection";
		totalCount: number;
	};
};

export type CourseAssessmentCategoryMarkPortionCreateMutationVariables = Exact<{
	input: CourseAssessmentCategoryMarkPortionCreateInput;
}>;

export type CourseAssessmentCategoryMarkPortionCreateMutation = {
	__typename?: "Mutation";
	createCourseAssessmentCategoryMarkPortion: {
		__typename?: "CourseAssessmentCategoryMarkPortion";
		id: string;
		markPortion: number;
		courseAssessmentCategory: { __typename?: "CourseAssessmentCategory"; id: string; name: string } | null;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		};
	};
};

export type CourseAssessmentCategoryMarkPortionDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAssessmentCategoryMarkPortionDeleteMutation = {
	__typename?: "Mutation";
	deleteCourseAssessmentCategoryMarkPortion: boolean;
};

export type CourseAssessmentCategoryMarkPortionDetailFragment = {
	__typename?: "CourseAssessmentCategoryMarkPortion";
	id: string;
	markPortion: number;
	courseAssessmentCategory: { __typename?: "CourseAssessmentCategory"; id: string; name: string } | null;
	courseSection: {
		__typename?: "CourseSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		course: { __typename?: "Course"; id: string; name: string };
	};
};

export type CourseAssessmentCategoryMarkPortionDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAssessmentCategoryMarkPortionDetailQuery = {
	__typename?: "Query";
	courseAssessmentCategoryMarkPortion: {
		__typename?: "CourseAssessmentCategoryMarkPortion";
		id: string;
		markPortion: number;
		courseAssessmentCategory: { __typename?: "CourseAssessmentCategory"; id: string; name: string } | null;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		};
	};
};

export type CourseAssessmentCategoryMarkPortionIndexQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<CourseAssessmentCategoryMarkPortionFilterInput> | CourseAssessmentCategoryMarkPortionFilterInput
	>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentCategoryMarkPortionOrder>;
}>;

export type CourseAssessmentCategoryMarkPortionIndexQuery = {
	__typename?: "Query";
	courseAssessmentCategoryMarkPortionConnection: {
		__typename?: "CourseAssessmentCategoryMarkPortionConnection";
		edges: Array<{
			__typename?: "CourseAssessmentCategoryMarkPortionEdge";
			node: { __typename?: "CourseAssessmentCategoryMarkPortion"; id: string; markPortion: number };
		}>;
	};
};

export type CourseAssessmentCategoryMarkPortionNameFragment = {
	__typename?: "CourseAssessmentCategoryMarkPortion";
	id: string;
};

export type CourseAssessmentCategoryMarkPortionNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAssessmentCategoryMarkPortionNameQuery = {
	__typename?: "Query";
	courseAssessmentCategoryMarkPortion: { __typename?: "CourseAssessmentCategoryMarkPortion"; id: string };
};

export type CourseAssessmentCategoryMarkPortionNamesQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<CourseAssessmentCategoryMarkPortionFilterInput> | CourseAssessmentCategoryMarkPortionFilterInput
	>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentCategoryMarkPortionOrder>;
}>;

export type CourseAssessmentCategoryMarkPortionNamesQuery = {
	__typename?: "Query";
	courseAssessmentCategoryMarkPortionConnection: {
		__typename?: "CourseAssessmentCategoryMarkPortionConnection";
		edges: Array<{
			__typename?: "CourseAssessmentCategoryMarkPortionEdge";
			node: { __typename?: "CourseAssessmentCategoryMarkPortion"; id: string };
		}>;
	};
};

export type CourseAssessmentCategoryMarkPortionPaginationQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<CourseAssessmentCategoryMarkPortionFilterInput> | CourseAssessmentCategoryMarkPortionFilterInput
	>;
	order?: InputMaybe<CourseAssessmentCategoryMarkPortionOrder>;
}>;

export type CourseAssessmentCategoryMarkPortionPaginationQuery = {
	__typename?: "Query";
	courseAssessmentCategoryMarkPortionConnection: {
		__typename?: "CourseAssessmentCategoryMarkPortionConnection";
		totalCount: number;
		edges: Array<{ __typename?: "CourseAssessmentCategoryMarkPortionEdge"; cursor: string }>;
	};
};

export type CourseAssessmentCategoryMarkPortionSelectQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<CourseAssessmentCategoryMarkPortionFilterInput> | CourseAssessmentCategoryMarkPortionFilterInput
	>;
	order?: InputMaybe<CourseAssessmentCategoryMarkPortionOrder>;
}>;

export type CourseAssessmentCategoryMarkPortionSelectQuery = {
	__typename?: "Query";
	courseAssessmentCategoryMarkPortionConnection: {
		__typename?: "CourseAssessmentCategoryMarkPortionConnection";
		edges: Array<{
			__typename?: "CourseAssessmentCategoryMarkPortionEdge";
			node: { __typename?: "CourseAssessmentCategoryMarkPortion"; id: string };
		}>;
	};
};

export type CourseAssessmentCategoryMarkPortionUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: CourseAssessmentCategoryMarkPortionUpdateInput;
}>;

export type CourseAssessmentCategoryMarkPortionUpdateMutation = {
	__typename?: "Mutation";
	updateCourseAssessmentCategoryMarkPortion: {
		__typename?: "CourseAssessmentCategoryMarkPortion";
		id: string;
		markPortion: number;
		courseAssessmentCategory: { __typename?: "CourseAssessmentCategory"; id: string; name: string } | null;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		};
	};
};

export type CourseAssessmentMarkCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentMarkFilterInput> | CourseAssessmentMarkFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentMarkOrder>;
}>;

export type CourseAssessmentMarkCountQuery = {
	__typename?: "Query";
	courseAssessmentMarkConnection: { __typename?: "CourseAssessmentMarkConnection"; totalCount: number };
};

export type CourseAssessmentMarkCreateMutationVariables = Exact<{
	input: CourseAssessmentMarkCreateInput;
}>;

export type CourseAssessmentMarkCreateMutation = {
	__typename?: "Mutation";
	createCourseAssessmentMark: {
		__typename?: "CourseAssessmentMark";
		id: string;
		points: number;
		isExcused: boolean;
		wasLate: boolean;
		notes: string;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		courseAssessment: { __typename?: "CourseAssessment"; id: string; name: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type CourseAssessmentMarkDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAssessmentMarkDeleteMutation = { __typename?: "Mutation"; deleteCourseAssessmentMark: boolean };

export type CourseAssessmentMarkDetailFragment = {
	__typename?: "CourseAssessmentMark";
	id: string;
	points: number;
	isExcused: boolean;
	wasLate: boolean;
	notes: string;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	} | null;
	courseAssessment: { __typename?: "CourseAssessment"; id: string; name: string };
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type CourseAssessmentMarkDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAssessmentMarkDetailQuery = {
	__typename?: "Query";
	courseAssessmentMark: {
		__typename?: "CourseAssessmentMark";
		id: string;
		points: number;
		isExcused: boolean;
		wasLate: boolean;
		notes: string;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		courseAssessment: { __typename?: "CourseAssessment"; id: string; name: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type CourseAssessmentMarkIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentMarkFilterInput> | CourseAssessmentMarkFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentMarkOrder>;
}>;

export type CourseAssessmentMarkIndexQuery = {
	__typename?: "Query";
	courseAssessmentMarkConnection: {
		__typename?: "CourseAssessmentMarkConnection";
		edges: Array<{
			__typename?: "CourseAssessmentMarkEdge";
			node: {
				__typename?: "CourseAssessmentMark";
				id: string;
				points: number;
				isExcused: boolean;
				wasLate: boolean;
				notes: string;
			};
		}>;
	};
};

export type CourseAssessmentMarkNameFragment = { __typename?: "CourseAssessmentMark"; id: string };

export type CourseAssessmentMarkNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAssessmentMarkNameQuery = {
	__typename?: "Query";
	courseAssessmentMark: { __typename?: "CourseAssessmentMark"; id: string };
};

export type CourseAssessmentMarkNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentMarkFilterInput> | CourseAssessmentMarkFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentMarkOrder>;
}>;

export type CourseAssessmentMarkNamesQuery = {
	__typename?: "Query";
	courseAssessmentMarkConnection: {
		__typename?: "CourseAssessmentMarkConnection";
		edges: Array<{
			__typename?: "CourseAssessmentMarkEdge";
			node: { __typename?: "CourseAssessmentMark"; id: string };
		}>;
	};
};

export type CourseAssessmentMarkPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentMarkFilterInput> | CourseAssessmentMarkFilterInput>;
	order?: InputMaybe<CourseAssessmentMarkOrder>;
}>;

export type CourseAssessmentMarkPaginationQuery = {
	__typename?: "Query";
	courseAssessmentMarkConnection: {
		__typename?: "CourseAssessmentMarkConnection";
		totalCount: number;
		edges: Array<{ __typename?: "CourseAssessmentMarkEdge"; cursor: string }>;
	};
};

export type CourseAssessmentMarkSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentMarkFilterInput> | CourseAssessmentMarkFilterInput>;
	order?: InputMaybe<CourseAssessmentMarkOrder>;
}>;

export type CourseAssessmentMarkSelectQuery = {
	__typename?: "Query";
	courseAssessmentMarkConnection: {
		__typename?: "CourseAssessmentMarkConnection";
		edges: Array<{
			__typename?: "CourseAssessmentMarkEdge";
			node: { __typename?: "CourseAssessmentMark"; id: string };
		}>;
	};
};

export type CourseAssessmentMarkUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: CourseAssessmentMarkUpdateInput;
}>;

export type CourseAssessmentMarkUpdateMutation = {
	__typename?: "Mutation";
	updateCourseAssessmentMark: {
		__typename?: "CourseAssessmentMark";
		id: string;
		points: number;
		isExcused: boolean;
		wasLate: boolean;
		notes: string;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		courseAssessment: { __typename?: "CourseAssessment"; id: string; name: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type CourseAssessmentSubmissionCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentSubmissionFilterInput> | CourseAssessmentSubmissionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentSubmissionOrder>;
}>;

export type CourseAssessmentSubmissionCountQuery = {
	__typename?: "Query";
	courseAssessmentSubmissionConnection: { __typename?: "CourseAssessmentSubmissionConnection"; totalCount: number };
};

export type CourseAssessmentSubmissionCreateMutationVariables = Exact<{
	input: CourseAssessmentSubmissionCreateInput;
}>;

export type CourseAssessmentSubmissionCreateMutation = {
	__typename?: "Mutation";
	createCourseAssessmentSubmission: {
		__typename?: "CourseAssessmentSubmission";
		id: string;
		createdAt: string;
		body: string;
		submissionDate: string;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		courseAssessment: { __typename?: "CourseAssessment"; id: string; name: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type CourseAssessmentSubmissionDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAssessmentSubmissionDeleteMutation = {
	__typename?: "Mutation";
	deleteCourseAssessmentSubmission: boolean;
};

export type CourseAssessmentSubmissionDetailFragment = {
	__typename?: "CourseAssessmentSubmission";
	id: string;
	createdAt: string;
	body: string;
	submissionDate: string;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	} | null;
	courseAssessment: { __typename?: "CourseAssessment"; id: string; name: string };
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type CourseAssessmentSubmissionDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAssessmentSubmissionDetailQuery = {
	__typename?: "Query";
	courseAssessmentSubmission: {
		__typename?: "CourseAssessmentSubmission";
		id: string;
		createdAt: string;
		body: string;
		submissionDate: string;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		courseAssessment: { __typename?: "CourseAssessment"; id: string; name: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type CourseAssessmentSubmissionIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentSubmissionFilterInput> | CourseAssessmentSubmissionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentSubmissionOrder>;
}>;

export type CourseAssessmentSubmissionIndexQuery = {
	__typename?: "Query";
	courseAssessmentSubmissionConnection: {
		__typename?: "CourseAssessmentSubmissionConnection";
		edges: Array<{
			__typename?: "CourseAssessmentSubmissionEdge";
			node: {
				__typename?: "CourseAssessmentSubmission";
				id: string;
				createdAt: string;
				body: string;
				submissionDate: string;
			};
		}>;
	};
};

export type CourseAssessmentSubmissionNameFragment = { __typename?: "CourseAssessmentSubmission"; id: string };

export type CourseAssessmentSubmissionNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAssessmentSubmissionNameQuery = {
	__typename?: "Query";
	courseAssessmentSubmission: { __typename?: "CourseAssessmentSubmission"; id: string };
};

export type CourseAssessmentSubmissionNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentSubmissionFilterInput> | CourseAssessmentSubmissionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentSubmissionOrder>;
}>;

export type CourseAssessmentSubmissionNamesQuery = {
	__typename?: "Query";
	courseAssessmentSubmissionConnection: {
		__typename?: "CourseAssessmentSubmissionConnection";
		edges: Array<{
			__typename?: "CourseAssessmentSubmissionEdge";
			node: { __typename?: "CourseAssessmentSubmission"; id: string };
		}>;
	};
};

export type CourseAssessmentSubmissionPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentSubmissionFilterInput> | CourseAssessmentSubmissionFilterInput>;
	order?: InputMaybe<CourseAssessmentSubmissionOrder>;
}>;

export type CourseAssessmentSubmissionPaginationQuery = {
	__typename?: "Query";
	courseAssessmentSubmissionConnection: {
		__typename?: "CourseAssessmentSubmissionConnection";
		totalCount: number;
		edges: Array<{ __typename?: "CourseAssessmentSubmissionEdge"; cursor: string }>;
	};
};

export type CourseAssessmentSubmissionSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentSubmissionFilterInput> | CourseAssessmentSubmissionFilterInput>;
	order?: InputMaybe<CourseAssessmentSubmissionOrder>;
}>;

export type CourseAssessmentSubmissionSelectQuery = {
	__typename?: "Query";
	courseAssessmentSubmissionConnection: {
		__typename?: "CourseAssessmentSubmissionConnection";
		edges: Array<{
			__typename?: "CourseAssessmentSubmissionEdge";
			node: { __typename?: "CourseAssessmentSubmission"; id: string };
		}>;
	};
};

export type CourseAssessmentSubmissionUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: CourseAssessmentSubmissionUpdateInput;
}>;

export type CourseAssessmentSubmissionUpdateMutation = {
	__typename?: "Mutation";
	updateCourseAssessmentSubmission: {
		__typename?: "CourseAssessmentSubmission";
		id: string;
		createdAt: string;
		body: string;
		submissionDate: string;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		courseAssessment: { __typename?: "CourseAssessment"; id: string; name: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type CourseAssessmentTimingCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentTimingFilterInput> | CourseAssessmentTimingFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentTimingOrder>;
}>;

export type CourseAssessmentTimingCountQuery = {
	__typename?: "Query";
	courseAssessmentTimingConnection: { __typename?: "CourseAssessmentTimingConnection"; totalCount: number };
};

export type CourseAssessmentTimingCreateMutationVariables = Exact<{
	input: CourseAssessmentTimingCreateInput;
}>;

export type CourseAssessmentTimingCreateMutation = {
	__typename?: "Mutation";
	createCourseAssessmentTiming: {
		__typename?: "CourseAssessmentTiming";
		id: string;
		assignOn: string | null;
		dueOn: string | null;
		courseAssessment: { __typename?: "CourseAssessment"; id: string; name: string };
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		};
	};
};

export type CourseAssessmentTimingDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAssessmentTimingDeleteMutation = { __typename?: "Mutation"; deleteCourseAssessmentTiming: boolean };

export type CourseAssessmentTimingDetailFragment = {
	__typename?: "CourseAssessmentTiming";
	id: string;
	assignOn: string | null;
	dueOn: string | null;
	courseAssessment: { __typename?: "CourseAssessment"; id: string; name: string };
	courseSection: {
		__typename?: "CourseSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		course: { __typename?: "Course"; id: string; name: string };
	};
};

export type CourseAssessmentTimingDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAssessmentTimingDetailQuery = {
	__typename?: "Query";
	courseAssessmentTiming: {
		__typename?: "CourseAssessmentTiming";
		id: string;
		assignOn: string | null;
		dueOn: string | null;
		courseAssessment: { __typename?: "CourseAssessment"; id: string; name: string };
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		};
	};
};

export type CourseAssessmentTimingIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentTimingFilterInput> | CourseAssessmentTimingFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentTimingOrder>;
}>;

export type CourseAssessmentTimingIndexQuery = {
	__typename?: "Query";
	courseAssessmentTimingConnection: {
		__typename?: "CourseAssessmentTimingConnection";
		edges: Array<{
			__typename?: "CourseAssessmentTimingEdge";
			node: { __typename?: "CourseAssessmentTiming"; id: string; assignOn: string | null; dueOn: string | null };
		}>;
	};
};

export type CourseAssessmentTimingNameFragment = { __typename?: "CourseAssessmentTiming"; id: string };

export type CourseAssessmentTimingNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAssessmentTimingNameQuery = {
	__typename?: "Query";
	courseAssessmentTiming: { __typename?: "CourseAssessmentTiming"; id: string };
};

export type CourseAssessmentTimingNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentTimingFilterInput> | CourseAssessmentTimingFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAssessmentTimingOrder>;
}>;

export type CourseAssessmentTimingNamesQuery = {
	__typename?: "Query";
	courseAssessmentTimingConnection: {
		__typename?: "CourseAssessmentTimingConnection";
		edges: Array<{
			__typename?: "CourseAssessmentTimingEdge";
			node: { __typename?: "CourseAssessmentTiming"; id: string };
		}>;
	};
};

export type CourseAssessmentTimingPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentTimingFilterInput> | CourseAssessmentTimingFilterInput>;
	order?: InputMaybe<CourseAssessmentTimingOrder>;
}>;

export type CourseAssessmentTimingPaginationQuery = {
	__typename?: "Query";
	courseAssessmentTimingConnection: {
		__typename?: "CourseAssessmentTimingConnection";
		totalCount: number;
		edges: Array<{ __typename?: "CourseAssessmentTimingEdge"; cursor: string }>;
	};
};

export type CourseAssessmentTimingSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAssessmentTimingFilterInput> | CourseAssessmentTimingFilterInput>;
	order?: InputMaybe<CourseAssessmentTimingOrder>;
}>;

export type CourseAssessmentTimingSelectQuery = {
	__typename?: "Query";
	courseAssessmentTimingConnection: {
		__typename?: "CourseAssessmentTimingConnection";
		edges: Array<{
			__typename?: "CourseAssessmentTimingEdge";
			node: { __typename?: "CourseAssessmentTiming"; id: string };
		}>;
	};
};

export type CourseAssessmentTimingUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: CourseAssessmentTimingUpdateInput;
}>;

export type CourseAssessmentTimingUpdateMutation = {
	__typename?: "Mutation";
	updateCourseAssessmentTiming: {
		__typename?: "CourseAssessmentTiming";
		id: string;
		assignOn: string | null;
		dueOn: string | null;
		courseAssessment: { __typename?: "CourseAssessment"; id: string; name: string };
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		};
	};
};

export type CourseAttendanceRecordCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAttendanceRecordFilterInput> | CourseAttendanceRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAttendanceRecordOrder>;
}>;

export type CourseAttendanceRecordCountQuery = {
	__typename?: "Query";
	courseAttendanceRecordConnection: { __typename?: "CourseAttendanceRecordConnection"; totalCount: number };
};

export type CourseAttendanceRecordBulkCreateMutationVariables = Exact<{
	inputs: Array<CourseAttendanceRecordCreateInput> | CourseAttendanceRecordCreateInput;
}>;

export type CourseAttendanceRecordBulkCreateMutation = {
	__typename?: "Mutation";
	createBulkCourseAttendanceRecords: {
		__typename?: "CourseAttendanceRecordConnection";
		edges: Array<{
			__typename?: "CourseAttendanceRecordEdge";
			node: { __typename?: "CourseAttendanceRecord"; id: string };
		}>;
	};
};

export type CourseAttendanceRecordCreateMutationVariables = Exact<{
	input: CourseAttendanceRecordCreateInput;
}>;

export type CourseAttendanceRecordCreateMutation = {
	__typename?: "Mutation";
	createCourseAttendanceRecord: {
		__typename?: "CourseAttendanceRecord";
		id: string;
		createdAt: string;
		attendanceDate: string;
		notes: string;
		attendanceStatus: { __typename?: "AttendanceStatus"; id: string; name: string; code: string };
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		courseSectionPeriod: { __typename?: "CourseSectionPeriod"; id: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type CourseAttendanceRecordDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAttendanceRecordDeleteMutation = { __typename?: "Mutation"; deleteCourseAttendanceRecord: boolean };

export type CourseAttendanceRecordDetailFragment = {
	__typename?: "CourseAttendanceRecord";
	id: string;
	createdAt: string;
	attendanceDate: string;
	notes: string;
	attendanceStatus: { __typename?: "AttendanceStatus"; id: string; name: string; code: string };
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	} | null;
	courseSectionPeriod: { __typename?: "CourseSectionPeriod"; id: string };
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type CourseAttendanceRecordDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAttendanceRecordDetailQuery = {
	__typename?: "Query";
	courseAttendanceRecord: {
		__typename?: "CourseAttendanceRecord";
		id: string;
		createdAt: string;
		attendanceDate: string;
		notes: string;
		attendanceStatus: { __typename?: "AttendanceStatus"; id: string; name: string; code: string };
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		courseSectionPeriod: { __typename?: "CourseSectionPeriod"; id: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type CourseAttendanceRecordIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAttendanceRecordFilterInput> | CourseAttendanceRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAttendanceRecordOrder>;
}>;

export type CourseAttendanceRecordIndexQuery = {
	__typename?: "Query";
	courseAttendanceRecordConnection: {
		__typename?: "CourseAttendanceRecordConnection";
		edges: Array<{
			__typename?: "CourseAttendanceRecordEdge";
			node: {
				__typename?: "CourseAttendanceRecord";
				id: string;
				createdAt: string;
				attendanceDate: string;
				notes: string;
			};
		}>;
	};
};

export type CourseAttendanceRecordListQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAttendanceRecordFilterInput> | CourseAttendanceRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAttendanceRecordOrder>;
}>;

export type CourseAttendanceRecordListQuery = {
	__typename?: "Query";
	courseAttendanceRecordConnection: {
		__typename?: "CourseAttendanceRecordConnection";
		edges: Array<{
			__typename?: "CourseAttendanceRecordEdge";
			node: {
				__typename?: "CourseAttendanceRecord";
				id: string;
				createdAt: string;
				attendanceDate: string;
				notes: string;
				attendanceStatus: {
					__typename?: "AttendanceStatus";
					id: string;
					description: string;
					name: string;
					code: string;
					indicatesAbsent: boolean;
					indicatesLateArrival: boolean;
					indicatesEarlyDeparture: boolean;
					indicatesExcused: boolean;
				};
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
				} | null;
				courseSectionPeriod: { __typename?: "CourseSectionPeriod"; id: string };
				student: {
					__typename?: "Student";
					id: string;
					person: { __typename?: "Person"; id: string; name: string; publicName: string };
				};
			};
		}>;
	};
};

export type CourseAttendanceRecordNameFragment = { __typename?: "CourseAttendanceRecord"; id: string };

export type CourseAttendanceRecordNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseAttendanceRecordNameQuery = {
	__typename?: "Query";
	courseAttendanceRecord: { __typename?: "CourseAttendanceRecord"; id: string };
};

export type CourseAttendanceRecordNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAttendanceRecordFilterInput> | CourseAttendanceRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseAttendanceRecordOrder>;
}>;

export type CourseAttendanceRecordNamesQuery = {
	__typename?: "Query";
	courseAttendanceRecordConnection: {
		__typename?: "CourseAttendanceRecordConnection";
		edges: Array<{
			__typename?: "CourseAttendanceRecordEdge";
			node: { __typename?: "CourseAttendanceRecord"; id: string };
		}>;
	};
};

export type CourseAttendanceRecordPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAttendanceRecordFilterInput> | CourseAttendanceRecordFilterInput>;
	order?: InputMaybe<CourseAttendanceRecordOrder>;
}>;

export type CourseAttendanceRecordPaginationQuery = {
	__typename?: "Query";
	courseAttendanceRecordConnection: {
		__typename?: "CourseAttendanceRecordConnection";
		totalCount: number;
		edges: Array<{ __typename?: "CourseAttendanceRecordEdge"; cursor: string }>;
	};
};

export type CourseAttendanceRecordSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseAttendanceRecordFilterInput> | CourseAttendanceRecordFilterInput>;
	order?: InputMaybe<CourseAttendanceRecordOrder>;
}>;

export type CourseAttendanceRecordSelectQuery = {
	__typename?: "Query";
	courseAttendanceRecordConnection: {
		__typename?: "CourseAttendanceRecordConnection";
		edges: Array<{
			__typename?: "CourseAttendanceRecordEdge";
			node: { __typename?: "CourseAttendanceRecord"; id: string };
		}>;
	};
};

export type CourseAttendanceRecordUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: CourseAttendanceRecordUpdateInput;
}>;

export type CourseAttendanceRecordUpdateMutation = {
	__typename?: "Mutation";
	updateCourseAttendanceRecord: {
		__typename?: "CourseAttendanceRecord";
		id: string;
		createdAt: string;
		attendanceDate: string;
		notes: string;
		attendanceStatus: { __typename?: "AttendanceStatus"; id: string; name: string; code: string };
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		courseSectionPeriod: { __typename?: "CourseSectionPeriod"; id: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type CourseSectionCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseSectionFilterInput> | CourseSectionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseSectionOrder>;
}>;

export type CourseSectionCountQuery = {
	__typename?: "Query";
	courseSectionConnection: { __typename?: "CourseSectionConnection"; totalCount: number };
};

export type CourseSectionCreateMutationVariables = Exact<{
	input: CourseSectionCreateInput;
}>;

export type CourseSectionCreateMutation = {
	__typename?: "Mutation";
	createCourseSection: {
		__typename?: "CourseSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string; name: string };
		course: {
			__typename?: "Course";
			id: string;
			name: string;
			academicSubject: { __typename?: "AcademicSubject"; id: string; color: string };
			classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
		};
		homeRoomSection: {
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		} | null;
		studentCourseSectionEnrollments: Array<{
			__typename?: "StudentCourseSectionEnrollment";
			id: string;
			lateStartDate: string | null;
			earlyEndDate: string | null;
			student: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				yearsFromGraduation: number;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
		teacherCourseSectionEnrollments: Array<{
			__typename?: "TeacherCourseSectionEnrollment";
			id: string;
			lateStartDate: string | null;
			earlyEndDate: string | null;
			teacher: {
				__typename?: "Employee";
				id: string;
				role: EmployeeRole;
				jobTitle: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type CourseSectionDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseSectionDeleteMutation = { __typename?: "Mutation"; deleteCourseSection: boolean };

export type CourseSectionDetailFragment = {
	__typename?: "CourseSection";
	id: string;
	namePrefix: string;
	nameSuffix: string;
	academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string; name: string };
	course: {
		__typename?: "Course";
		id: string;
		name: string;
		academicSubject: { __typename?: "AcademicSubject"; id: string; color: string };
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
	};
	homeRoomSection: {
		__typename?: "HomeRoomSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
	} | null;
	studentCourseSectionEnrollments: Array<{
		__typename?: "StudentCourseSectionEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		student: {
			__typename?: "Student";
			id: string;
			graduationYear: number | null;
			yearsFromGraduation: number;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		};
	}>;
	teacherCourseSectionEnrollments: Array<{
		__typename?: "TeacherCourseSectionEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		teacher: {
			__typename?: "Employee";
			id: string;
			role: EmployeeRole;
			jobTitle: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		};
	}>;
};

export type CourseSectionDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseSectionDetailQuery = {
	__typename?: "Query";
	courseSection: {
		__typename?: "CourseSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string; name: string };
		course: {
			__typename?: "Course";
			id: string;
			name: string;
			academicSubject: { __typename?: "AcademicSubject"; id: string; color: string };
			classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
		};
		homeRoomSection: {
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		} | null;
		studentCourseSectionEnrollments: Array<{
			__typename?: "StudentCourseSectionEnrollment";
			id: string;
			lateStartDate: string | null;
			earlyEndDate: string | null;
			student: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				yearsFromGraduation: number;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
		teacherCourseSectionEnrollments: Array<{
			__typename?: "TeacherCourseSectionEnrollment";
			id: string;
			lateStartDate: string | null;
			earlyEndDate: string | null;
			teacher: {
				__typename?: "Employee";
				id: string;
				role: EmployeeRole;
				jobTitle: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type CourseSectionIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseSectionFilterInput> | CourseSectionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseSectionOrder>;
}>;

export type CourseSectionIndexQuery = {
	__typename?: "Query";
	courseSectionConnection: {
		__typename?: "CourseSectionConnection";
		edges: Array<{
			__typename?: "CourseSectionEdge";
			node: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string; name: string };
				course: {
					__typename?: "Course";
					id: string;
					name: string;
					academicSubject: { __typename?: "AcademicSubject"; id: string; name: string };
					classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
				};
				homeRoomSection: {
					__typename?: "HomeRoomSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
				} | null;
				studentCourseSectionEnrollments: Array<{
					__typename?: "StudentCourseSectionEnrollment";
					id: string;
					lateStartDate: string | null;
					earlyEndDate: string | null;
				}>;
				teacherCourseSectionEnrollments: Array<{
					__typename?: "TeacherCourseSectionEnrollment";
					id: string;
					lateStartDate: string | null;
					earlyEndDate: string | null;
					teacher: {
						__typename?: "Employee";
						id: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string };
					};
				}>;
			};
		}>;
	};
};

export type CourseSectionNameAndDetailsQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseSectionNameAndDetailsQuery = {
	__typename?: "Query";
	courseSection: {
		__typename?: "CourseSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		course: {
			__typename?: "Course";
			id: string;
			name: string;
			classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
		};
		homeRoomSection: {
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		} | null;
	};
};

export type CourseSectionNamesAndTeachersQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseSectionFilterInput> | CourseSectionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseSectionOrder>;
}>;

export type CourseSectionNamesAndTeachersQuery = {
	__typename?: "Query";
	courseSectionConnection: {
		__typename?: "CourseSectionConnection";
		totalCount: number;
		edges: Array<{
			__typename?: "CourseSectionEdge";
			node: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: {
					__typename?: "Course";
					id: string;
					name: string;
					academicSubject: { __typename?: "AcademicSubject"; id: string; name: string; color: string };
					classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
				};
				homeRoomSection: {
					__typename?: "HomeRoomSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
				} | null;
				teacherCourseSectionEnrollments: Array<{
					__typename?: "TeacherCourseSectionEnrollment";
					id: string;
					teacher: {
						__typename?: "Employee";
						id: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string };
					};
				}>;
			};
		}>;
	};
};

export type CourseSectionListQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseSectionFilterInput> | CourseSectionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseSectionOrder>;
}>;

export type CourseSectionListQuery = {
	__typename?: "Query";
	courseSectionConnection: {
		__typename?: "CourseSectionConnection";
		totalCount: number;
		edges: Array<{
			__typename?: "CourseSectionEdge";
			node: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: {
					__typename?: "Course";
					id: string;
					name: string;
					academicSubject: { __typename?: "AcademicSubject"; id: string; name: string; color: string };
					classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
				};
				homeRoomSection: {
					__typename?: "HomeRoomSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
				} | null;
				studentCourseSectionEnrollments: Array<{
					__typename?: "StudentCourseSectionEnrollment";
					id: string;
					lateStartDate: string | null;
					earlyEndDate: string | null;
					student: {
						__typename?: "Student";
						id: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string };
					};
				}>;
				teacherCourseSectionEnrollments: Array<{
					__typename?: "TeacherCourseSectionEnrollment";
					id: string;
					teacher: {
						__typename?: "Employee";
						id: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string };
					};
				}>;
			};
		}>;
	};
};

export type CourseSectionSummaryListQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseSectionFilterInput> | CourseSectionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseSectionOrder>;
}>;

export type CourseSectionSummaryListQuery = {
	__typename?: "Query";
	courseSectionConnection: {
		__typename?: "CourseSectionConnection";
		edges: Array<{
			__typename?: "CourseSectionEdge";
			node: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: {
					__typename?: "Course";
					id: string;
					name: string;
					academicSubject: { __typename?: "AcademicSubject"; id: string; name: string; color: string };
				};
				homeRoomSection: {
					__typename?: "HomeRoomSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
				} | null;
				teacherCourseSectionEnrollments: Array<{
					__typename?: "TeacherCourseSectionEnrollment";
					id: string;
					teacher: {
						__typename?: "Employee";
						id: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string };
					};
				}>;
				studentCourseSectionEnrollments: Array<{ __typename?: "StudentCourseSectionEnrollment"; id: string }>;
				courseSectionPeriods: Array<{
					__typename?: "CourseSectionPeriod";
					id: string;
					dayOfWeek: number;
					startTimeMinutes: number;
					endTimeMinutes: number;
				}>;
			};
		}>;
	};
};

export type CourseSectionOverviewListQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseSectionFilterInput> | CourseSectionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseSectionOrder>;
}>;

export type CourseSectionOverviewListQuery = {
	__typename?: "Query";
	courseSectionConnection: {
		__typename?: "CourseSectionConnection";
		edges: Array<{
			__typename?: "CourseSectionEdge";
			node: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: {
					__typename?: "Course";
					id: string;
					name: string;
					academicSubject: { __typename?: "AcademicSubject"; id: string; color: string };
					classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
				};
				homeRoomSection: {
					__typename?: "HomeRoomSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
				} | null;
				studentCourseSectionEnrollments: Array<{
					__typename?: "StudentCourseSectionEnrollment";
					id: string;
					lateStartDate: string | null;
					earlyEndDate: string | null;
					student: {
						__typename?: "Student";
						id: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string };
					};
				}>;
			};
		}>;
	};
};

export type CourseSectionDetailedSelectListQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseSectionFilterInput> | CourseSectionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseSectionOrder>;
}>;

export type CourseSectionDetailedSelectListQuery = {
	__typename?: "Query";
	courseSectionConnection: {
		__typename?: "CourseSectionConnection";
		totalCount: number;
		edges: Array<{
			__typename?: "CourseSectionEdge";
			node: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: {
					__typename?: "Course";
					id: string;
					name: string;
					classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
				};
				homeRoomSection: {
					__typename?: "HomeRoomSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
				} | null;
			};
		}>;
	};
};

export type CourseSectionNameFragment = {
	__typename?: "CourseSection";
	namePrefix: string;
	nameSuffix: string;
	course: { __typename?: "Course"; id: string; name: string };
};

export type CourseSectionNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseSectionNameQuery = {
	__typename?: "Query";
	courseSection: {
		__typename?: "CourseSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		course: { __typename?: "Course"; id: string; name: string };
	};
};

export type CourseSectionNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseSectionFilterInput> | CourseSectionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseSectionOrder>;
}>;

export type CourseSectionNamesQuery = {
	__typename?: "Query";
	courseSectionConnection: {
		__typename?: "CourseSectionConnection";
		edges: Array<{
			__typename?: "CourseSectionEdge";
			node: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			};
		}>;
	};
};

export type CourseSectionPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseSectionFilterInput> | CourseSectionFilterInput>;
	order?: InputMaybe<CourseSectionOrder>;
}>;

export type CourseSectionPaginationQuery = {
	__typename?: "Query";
	courseSectionConnection: {
		__typename?: "CourseSectionConnection";
		totalCount: number;
		edges: Array<{ __typename?: "CourseSectionEdge"; cursor: string }>;
	};
};

export type CourseSectionSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseSectionFilterInput> | CourseSectionFilterInput>;
	order?: InputMaybe<CourseSectionOrder>;
}>;

export type CourseSectionSelectQuery = {
	__typename?: "Query";
	courseSectionConnection: {
		__typename?: "CourseSectionConnection";
		edges: Array<{
			__typename?: "CourseSectionEdge";
			node: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			};
		}>;
	};
};

export type CourseSectionUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: CourseSectionUpdateInput;
}>;

export type CourseSectionUpdateMutation = {
	__typename?: "Mutation";
	updateCourseSection: {
		__typename?: "CourseSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string; name: string };
		course: {
			__typename?: "Course";
			id: string;
			name: string;
			academicSubject: { __typename?: "AcademicSubject"; id: string; color: string };
			classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
		};
		homeRoomSection: {
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		} | null;
		studentCourseSectionEnrollments: Array<{
			__typename?: "StudentCourseSectionEnrollment";
			id: string;
			lateStartDate: string | null;
			earlyEndDate: string | null;
			student: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				yearsFromGraduation: number;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
		teacherCourseSectionEnrollments: Array<{
			__typename?: "TeacherCourseSectionEnrollment";
			id: string;
			lateStartDate: string | null;
			earlyEndDate: string | null;
			teacher: {
				__typename?: "Employee";
				id: string;
				role: EmployeeRole;
				jobTitle: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type CourseSectionPeriodCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseSectionPeriodFilterInput> | CourseSectionPeriodFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseSectionPeriodOrder>;
}>;

export type CourseSectionPeriodCountQuery = {
	__typename?: "Query";
	courseSectionPeriodConnection: { __typename?: "CourseSectionPeriodConnection"; totalCount: number };
};

export type CourseSectionPeriodCreateMutationVariables = Exact<{
	input: CourseSectionPeriodCreateInput;
}>;

export type CourseSectionPeriodCreateMutation = {
	__typename?: "Mutation";
	createCourseSectionPeriod: {
		__typename?: "CourseSectionPeriod";
		id: string;
		dayOfWeek: number;
		startTimeMinutes: number;
		endTimeMinutes: number;
		isActive: boolean;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string; name: string };
			course: { __typename?: "Course"; id: string; name: string };
		};
		room: { __typename?: "Room"; id: string; name: string } | null;
	};
};

export type CourseSectionPeriodDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseSectionPeriodDeleteMutation = { __typename?: "Mutation"; deleteCourseSectionPeriod: boolean };

export type CourseSectionPeriodDetailFragment = {
	__typename?: "CourseSectionPeriod";
	id: string;
	dayOfWeek: number;
	startTimeMinutes: number;
	endTimeMinutes: number;
	isActive: boolean;
	courseSection: {
		__typename?: "CourseSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string; name: string };
		course: { __typename?: "Course"; id: string; name: string };
	};
	room: { __typename?: "Room"; id: string; name: string } | null;
};

export type CourseSectionPeriodDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseSectionPeriodDetailQuery = {
	__typename?: "Query";
	courseSectionPeriod: {
		__typename?: "CourseSectionPeriod";
		id: string;
		dayOfWeek: number;
		startTimeMinutes: number;
		endTimeMinutes: number;
		isActive: boolean;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string; name: string };
			course: { __typename?: "Course"; id: string; name: string };
		};
		room: { __typename?: "Room"; id: string; name: string } | null;
	};
};

export type CourseSectionPeriodIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseSectionPeriodFilterInput> | CourseSectionPeriodFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseSectionPeriodOrder>;
}>;

export type CourseSectionPeriodIndexQuery = {
	__typename?: "Query";
	courseSectionPeriodConnection: {
		__typename?: "CourseSectionPeriodConnection";
		edges: Array<{
			__typename?: "CourseSectionPeriodEdge";
			node: {
				__typename?: "CourseSectionPeriod";
				id: string;
				dayOfWeek: number;
				startTimeMinutes: number;
				endTimeMinutes: number;
				isActive: boolean;
			};
		}>;
	};
};

export type CourseSectionPeriodNameFragment = { __typename?: "CourseSectionPeriod"; id: string };

export type CourseSectionPeriodNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CourseSectionPeriodNameQuery = {
	__typename?: "Query";
	courseSectionPeriod: { __typename?: "CourseSectionPeriod"; id: string };
};

export type CourseSectionPeriodNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseSectionPeriodFilterInput> | CourseSectionPeriodFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseSectionPeriodOrder>;
}>;

export type CourseSectionPeriodNamesQuery = {
	__typename?: "Query";
	courseSectionPeriodConnection: {
		__typename?: "CourseSectionPeriodConnection";
		edges: Array<{ __typename?: "CourseSectionPeriodEdge"; node: { __typename?: "CourseSectionPeriod"; id: string } }>;
	};
};

export type CourseSectionPeriodPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseSectionPeriodFilterInput> | CourseSectionPeriodFilterInput>;
	order?: InputMaybe<CourseSectionPeriodOrder>;
}>;

export type CourseSectionPeriodPaginationQuery = {
	__typename?: "Query";
	courseSectionPeriodConnection: {
		__typename?: "CourseSectionPeriodConnection";
		totalCount: number;
		edges: Array<{ __typename?: "CourseSectionPeriodEdge"; cursor: string }>;
	};
};

export type CourseSectionPeriodScheduleListQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseSectionPeriodFilterInput> | CourseSectionPeriodFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseSectionPeriodOrder>;
}>;

export type CourseSectionPeriodScheduleListQuery = {
	__typename?: "Query";
	courseSectionPeriodConnection: {
		__typename?: "CourseSectionPeriodConnection";
		pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor: string | null };
		edges: Array<{
			__typename?: "CourseSectionPeriodEdge";
			node: {
				__typename?: "CourseSectionPeriod";
				id: string;
				dayOfWeek: number;
				startTimeMinutes: number;
				endTimeMinutes: number;
				isActive: boolean;
				courseSection: {
					__typename?: "CourseSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string; name: string };
					course: {
						__typename?: "Course";
						id: string;
						name: string;
						academicSubject: { __typename?: "AcademicSubject"; id: string; name: string; color: string };
						classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
					};
					homeRoomSection: {
						__typename?: "HomeRoomSection";
						id: string;
						namePrefix: string;
						nameSuffix: string;
						homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
					} | null;
				};
				room: { __typename?: "Room"; id: string; name: string } | null;
			};
		}>;
	};
};

export type CourseSectionCourseSectionPeriodScheduleListQueryVariables = Exact<{
	date: Scalars["Date"]["input"];
	filters?: InputMaybe<Array<CourseSectionPeriodFilterInput> | CourseSectionPeriodFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseSectionPeriodOrder>;
}>;

export type CourseSectionCourseSectionPeriodScheduleListQuery = {
	__typename?: "Query";
	courseSectionPeriodConnection: {
		__typename?: "CourseSectionPeriodConnection";
		pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor: string | null };
		edges: Array<{
			__typename?: "CourseSectionPeriodEdge";
			node: {
				__typename?: "CourseSectionPeriod";
				id: string;
				dayOfWeek: number;
				startTimeMinutes: number;
				endTimeMinutes: number;
				isActive: boolean;
				room: { __typename?: "Room"; id: string; name: string } | null;
				courseAttendanceRecords: Array<{ __typename?: "CourseAttendanceRecord"; id: string }>;
			};
		}>;
	};
};

export type CourseSectionPeriodScheduleWithStudentsListQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseSectionPeriodFilterInput> | CourseSectionPeriodFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CourseSectionPeriodOrder>;
}>;

export type CourseSectionPeriodScheduleWithStudentsListQuery = {
	__typename?: "Query";
	courseSectionPeriodConnection: {
		__typename?: "CourseSectionPeriodConnection";
		edges: Array<{
			__typename?: "CourseSectionPeriodEdge";
			node: {
				__typename?: "CourseSectionPeriod";
				id: string;
				dayOfWeek: number;
				startTimeMinutes: number;
				endTimeMinutes: number;
				isActive: boolean;
				courseSection: {
					__typename?: "CourseSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string; name: string };
					course: {
						__typename?: "Course";
						id: string;
						name: string;
						academicSubject: { __typename?: "AcademicSubject"; id: string; name: string; color: string };
						classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
					};
					homeRoomSection: {
						__typename?: "HomeRoomSection";
						id: string;
						namePrefix: string;
						nameSuffix: string;
						homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
					} | null;
					studentCourseSectionEnrollments: Array<{
						__typename?: "StudentCourseSectionEnrollment";
						id: string;
						lateStartDate: string | null;
						earlyEndDate: string | null;
					}>;
				};
				room: { __typename?: "Room"; id: string; name: string } | null;
			};
		}>;
	};
};

export type CourseSectionPeriodSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<CourseSectionPeriodFilterInput> | CourseSectionPeriodFilterInput>;
	order?: InputMaybe<CourseSectionPeriodOrder>;
}>;

export type CourseSectionPeriodSelectQuery = {
	__typename?: "Query";
	courseSectionPeriodConnection: {
		__typename?: "CourseSectionPeriodConnection";
		edges: Array<{ __typename?: "CourseSectionPeriodEdge"; node: { __typename?: "CourseSectionPeriod"; id: string } }>;
	};
};

export type CourseSectionPeriodUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: CourseSectionPeriodUpdateInput;
}>;

export type CourseSectionPeriodUpdateMutation = {
	__typename?: "Mutation";
	updateCourseSectionPeriod: {
		__typename?: "CourseSectionPeriod";
		id: string;
		dayOfWeek: number;
		startTimeMinutes: number;
		endTimeMinutes: number;
		isActive: boolean;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string; name: string };
			course: { __typename?: "Course"; id: string; name: string };
		};
		room: { __typename?: "Room"; id: string; name: string } | null;
	};
};

export type DiscountCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<DiscountFilterInput> | DiscountFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<DiscountOrder>;
}>;

export type DiscountCountQuery = {
	__typename?: "Query";
	discountConnection: { __typename?: "DiscountConnection"; totalCount: number };
};

export type DiscountCreateMutationVariables = Exact<{
	input: DiscountCreateInput;
}>;

export type DiscountCreateMutation = {
	__typename?: "Mutation";
	createDiscount: {
		__typename?: "Discount";
		id: string;
		name: string;
		description: string;
		isActive: boolean;
		isPercentageAmount: boolean;
		flatAmount: number | null;
		percentageAmount: number | null;
	};
};

export type DiscountDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type DiscountDeleteMutation = { __typename?: "Mutation"; deleteDiscount: boolean };

export type DiscountDetailFragment = {
	__typename?: "Discount";
	id: string;
	name: string;
	description: string;
	isActive: boolean;
	isPercentageAmount: boolean;
	flatAmount: number | null;
	percentageAmount: number | null;
};

export type DiscountDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type DiscountDetailQuery = {
	__typename?: "Query";
	discount: {
		__typename?: "Discount";
		id: string;
		name: string;
		description: string;
		isActive: boolean;
		isPercentageAmount: boolean;
		flatAmount: number | null;
		percentageAmount: number | null;
	};
};

export type DiscountIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<DiscountFilterInput> | DiscountFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<DiscountOrder>;
}>;

export type DiscountIndexQuery = {
	__typename?: "Query";
	discountConnection: {
		__typename?: "DiscountConnection";
		edges: Array<{
			__typename?: "DiscountEdge";
			node: {
				__typename?: "Discount";
				id: string;
				name: string;
				description: string;
				isActive: boolean;
				isPercentageAmount: boolean;
				flatAmount: number | null;
				percentageAmount: number | null;
			};
		}>;
	};
};

export type DiscountNameFragment = { __typename?: "Discount"; name: string };

export type DiscountNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type DiscountNameQuery = {
	__typename?: "Query";
	discount: { __typename?: "Discount"; id: string; name: string };
};

export type DiscountNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<DiscountFilterInput> | DiscountFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<DiscountOrder>;
}>;

export type DiscountNamesQuery = {
	__typename?: "Query";
	discountConnection: {
		__typename?: "DiscountConnection";
		edges: Array<{ __typename?: "DiscountEdge"; node: { __typename?: "Discount"; id: string; name: string } }>;
	};
};

export type DiscountPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<DiscountFilterInput> | DiscountFilterInput>;
	order?: InputMaybe<DiscountOrder>;
}>;

export type DiscountPaginationQuery = {
	__typename?: "Query";
	discountConnection: {
		__typename?: "DiscountConnection";
		totalCount: number;
		edges: Array<{ __typename?: "DiscountEdge"; cursor: string }>;
	};
};

export type DiscountSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<DiscountFilterInput> | DiscountFilterInput>;
	order?: InputMaybe<DiscountOrder>;
}>;

export type DiscountSelectQuery = {
	__typename?: "Query";
	discountConnection: {
		__typename?: "DiscountConnection";
		edges: Array<{
			__typename?: "DiscountEdge";
			node: {
				__typename?: "Discount";
				id: string;
				isPercentageAmount: boolean;
				flatAmount: number | null;
				percentageAmount: number | null;
				name: string;
			};
		}>;
	};
};

export type DiscountUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: DiscountUpdateInput;
}>;

export type DiscountUpdateMutation = {
	__typename?: "Mutation";
	updateDiscount: {
		__typename?: "Discount";
		id: string;
		name: string;
		description: string;
		isActive: boolean;
		isPercentageAmount: boolean;
		flatAmount: number | null;
		percentageAmount: number | null;
	};
};

export type EmailAddressCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<EmailAddressFilterInput> | EmailAddressFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EmailAddressOrder>;
}>;

export type EmailAddressCountQuery = {
	__typename?: "Query";
	emailAddressConnection: { __typename?: "EmailAddressConnection"; totalCount: number };
};

export type EmailAddressCreateMutationVariables = Exact<{
	input: EmailAddressCreateInput;
}>;

export type EmailAddressCreateMutation = {
	__typename?: "Mutation";
	createEmailAddress: {
		__typename?: "EmailAddress";
		id: string;
		name: string;
		emailAddress: string;
		isPrimary: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	};
};

export type EmailAddressDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EmailAddressDeleteMutation = { __typename?: "Mutation"; deleteEmailAddress: boolean };

export type EmailAddressDetailFragment = {
	__typename?: "EmailAddress";
	id: string;
	name: string;
	emailAddress: string;
	isPrimary: boolean;
	person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
};

export type EmailAddressDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EmailAddressDetailQuery = {
	__typename?: "Query";
	emailAddress: {
		__typename?: "EmailAddress";
		id: string;
		name: string;
		emailAddress: string;
		isPrimary: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	};
};

export type EmailAddressIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<EmailAddressFilterInput> | EmailAddressFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EmailAddressOrder>;
}>;

export type EmailAddressIndexQuery = {
	__typename?: "Query";
	emailAddressConnection: {
		__typename?: "EmailAddressConnection";
		edges: Array<{
			__typename?: "EmailAddressEdge";
			node: { __typename?: "EmailAddress"; id: string; name: string; emailAddress: string; isPrimary: boolean };
		}>;
	};
};

export type EmailAddressNameFragment = { __typename?: "EmailAddress"; name: string; emailAddress: string };

export type EmailAddressNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EmailAddressNameQuery = {
	__typename?: "Query";
	emailAddress: { __typename?: "EmailAddress"; id: string; name: string; emailAddress: string };
};

export type EmailAddressNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<EmailAddressFilterInput> | EmailAddressFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EmailAddressOrder>;
}>;

export type EmailAddressNamesQuery = {
	__typename?: "Query";
	emailAddressConnection: {
		__typename?: "EmailAddressConnection";
		edges: Array<{
			__typename?: "EmailAddressEdge";
			node: { __typename?: "EmailAddress"; id: string; name: string; emailAddress: string };
		}>;
	};
};

export type EmailAddressPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<EmailAddressFilterInput> | EmailAddressFilterInput>;
	order?: InputMaybe<EmailAddressOrder>;
}>;

export type EmailAddressPaginationQuery = {
	__typename?: "Query";
	emailAddressConnection: {
		__typename?: "EmailAddressConnection";
		totalCount: number;
		edges: Array<{ __typename?: "EmailAddressEdge"; cursor: string }>;
	};
};

export type EmailAddressSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<EmailAddressFilterInput> | EmailAddressFilterInput>;
	order?: InputMaybe<EmailAddressOrder>;
}>;

export type EmailAddressSelectQuery = {
	__typename?: "Query";
	emailAddressConnection: {
		__typename?: "EmailAddressConnection";
		edges: Array<{
			__typename?: "EmailAddressEdge";
			node: { __typename?: "EmailAddress"; id: string; name: string; emailAddress: string };
		}>;
	};
};

export type EmailAddressUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: EmailAddressUpdateInput;
}>;

export type EmailAddressUpdateMutation = {
	__typename?: "Mutation";
	updateEmailAddress: {
		__typename?: "EmailAddress";
		id: string;
		name: string;
		emailAddress: string;
		isPrimary: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	};
};

export type EmployeeCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<EmployeeFilterInput> | EmployeeFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EmployeeOrder>;
}>;

export type EmployeeCountQuery = {
	__typename?: "Query";
	employeeConnection: { __typename?: "EmployeeConnection"; totalCount: number };
};

export type EmployeeCreateMutationVariables = Exact<{
	input: EmployeeCreateInput;
}>;

export type EmployeeCreateMutation = {
	__typename?: "Mutation";
	createEmployee: {
		__typename?: "Employee";
		id: string;
		workEmailAddress: string;
		jobTitle: string;
		role: EmployeeRole;
		startDate: string;
		endDate: string | null;
		bio: string;
		campuses: Array<{ __typename?: "Campus"; id: string; name: string }>;
		classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			middleName: string;
			familyName: string;
			nameOrder: PersonNameOrder;
			nickname: string;
			alternateNames: string;
			publicNameFormat: PersonPublicNameFormat;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
			gender: string;
			dateOfBirth: string | null;
			englishLanguageFluency: PersonEnglishLanguageFluency | null;
			occupation: string;
			nationalIdentificationNumber: string;
			governmentDocumentSeries: string;
			governmentDocumentNumber: string;
			governmentDocumentIssuedBy: string;
			nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
			languages: Array<{ __typename?: "Language"; id: string; name: string }>;
			addresses: Array<{
				__typename?: "Address";
				id: string;
				name: string;
				addressLine1: string;
				addressLine2: string;
				city: string;
				postalCode: string;
				stateOrProvince: string;
				country: { __typename?: "Country"; id: string; name: string };
			}>;
			emailAddresses: Array<{
				__typename?: "EmailAddress";
				id: string;
				emailAddress: string;
				isPrimary: boolean;
				name: string;
			}>;
			employee: {
				__typename?: "Employee";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			guardian: {
				__typename?: "Guardian";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			phoneNumbers: Array<{
				__typename?: "PhoneNumber";
				id: string;
				phoneNumber: string;
				isPrimary: boolean;
				name: string;
			}>;
			student: {
				__typename?: "Student";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			user: {
				__typename?: "User";
				id: string;
				email: string;
				status: UserStatus;
				passwordUpdatedAt: string;
				isCurrent: boolean;
				timeZoneName: string;
				externalNotificationFrequency: UserExternalNotificationFrequency;
				permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					employee: { __typename?: "Employee"; id: string } | null;
					guardian: { __typename?: "Guardian"; id: string } | null;
					student: { __typename?: "Student"; id: string } | null;
				} | null;
				userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
			} | null;
		};
	};
};

export type EmployeeDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EmployeeDeleteMutation = { __typename?: "Mutation"; deleteEmployee: boolean };

export type EmployeeDetailFragment = {
	__typename?: "Employee";
	id: string;
	workEmailAddress: string;
	jobTitle: string;
	role: EmployeeRole;
	startDate: string;
	endDate: string | null;
	bio: string;
	campuses: Array<{ __typename?: "Campus"; id: string; name: string }>;
	classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
	classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
	person: {
		__typename?: "Person";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		middleName: string;
		familyName: string;
		nameOrder: PersonNameOrder;
		nickname: string;
		alternateNames: string;
		publicNameFormat: PersonPublicNameFormat;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		gender: string;
		dateOfBirth: string | null;
		englishLanguageFluency: PersonEnglishLanguageFluency | null;
		occupation: string;
		nationalIdentificationNumber: string;
		governmentDocumentSeries: string;
		governmentDocumentNumber: string;
		governmentDocumentIssuedBy: string;
		nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
		languages: Array<{ __typename?: "Language"; id: string; name: string }>;
		addresses: Array<{
			__typename?: "Address";
			id: string;
			name: string;
			addressLine1: string;
			addressLine2: string;
			city: string;
			postalCode: string;
			stateOrProvince: string;
			country: { __typename?: "Country"; id: string; name: string };
		}>;
		emailAddresses: Array<{
			__typename?: "EmailAddress";
			id: string;
			emailAddress: string;
			isPrimary: boolean;
			name: string;
		}>;
		employee: {
			__typename?: "Employee";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		guardian: {
			__typename?: "Guardian";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		phoneNumbers: Array<{
			__typename?: "PhoneNumber";
			id: string;
			phoneNumber: string;
			isPrimary: boolean;
			name: string;
		}>;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		user: {
			__typename?: "User";
			id: string;
			email: string;
			status: UserStatus;
			passwordUpdatedAt: string;
			isCurrent: boolean;
			timeZoneName: string;
			externalNotificationFrequency: UserExternalNotificationFrequency;
			permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				employee: { __typename?: "Employee"; id: string } | null;
				guardian: { __typename?: "Guardian"; id: string } | null;
				student: { __typename?: "Student"; id: string } | null;
			} | null;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		} | null;
	};
};

export type EmployeeDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EmployeeDetailQuery = {
	__typename?: "Query";
	employee: {
		__typename?: "Employee";
		id: string;
		workEmailAddress: string;
		jobTitle: string;
		role: EmployeeRole;
		startDate: string;
		endDate: string | null;
		bio: string;
		campuses: Array<{ __typename?: "Campus"; id: string; name: string }>;
		classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			middleName: string;
			familyName: string;
			nameOrder: PersonNameOrder;
			nickname: string;
			alternateNames: string;
			publicNameFormat: PersonPublicNameFormat;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
			gender: string;
			dateOfBirth: string | null;
			englishLanguageFluency: PersonEnglishLanguageFluency | null;
			occupation: string;
			nationalIdentificationNumber: string;
			governmentDocumentSeries: string;
			governmentDocumentNumber: string;
			governmentDocumentIssuedBy: string;
			nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
			languages: Array<{ __typename?: "Language"; id: string; name: string }>;
			addresses: Array<{
				__typename?: "Address";
				id: string;
				name: string;
				addressLine1: string;
				addressLine2: string;
				city: string;
				postalCode: string;
				stateOrProvince: string;
				country: { __typename?: "Country"; id: string; name: string };
			}>;
			emailAddresses: Array<{
				__typename?: "EmailAddress";
				id: string;
				emailAddress: string;
				isPrimary: boolean;
				name: string;
			}>;
			employee: {
				__typename?: "Employee";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			guardian: {
				__typename?: "Guardian";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			phoneNumbers: Array<{
				__typename?: "PhoneNumber";
				id: string;
				phoneNumber: string;
				isPrimary: boolean;
				name: string;
			}>;
			student: {
				__typename?: "Student";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			user: {
				__typename?: "User";
				id: string;
				email: string;
				status: UserStatus;
				passwordUpdatedAt: string;
				isCurrent: boolean;
				timeZoneName: string;
				externalNotificationFrequency: UserExternalNotificationFrequency;
				permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					employee: { __typename?: "Employee"; id: string } | null;
					guardian: { __typename?: "Guardian"; id: string } | null;
					student: { __typename?: "Student"; id: string } | null;
				} | null;
				userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
			} | null;
		};
	};
};

export type EmployeeIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<EmployeeFilterInput> | EmployeeFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EmployeeOrder>;
}>;

export type EmployeeIndexQuery = {
	__typename?: "Query";
	employeeConnection: {
		__typename?: "EmployeeConnection";
		edges: Array<{
			__typename?: "EmployeeEdge";
			node: {
				__typename?: "Employee";
				id: string;
				workEmailAddress: string;
				jobTitle: string;
				role: EmployeeRole;
				startDate: string;
				endDate: string | null;
				person: {
					__typename?: "Person";
					id: string;
					gender: string;
					dateOfBirth: string | null;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
					addresses: Array<{
						__typename?: "Address";
						id: string;
						name: string;
						addressLine1: string;
						addressLine2: string;
						city: string;
						postalCode: string;
						stateOrProvince: string;
						country: { __typename?: "Country"; id: string; name: string };
					}>;
					emailAddresses: Array<{ __typename?: "EmailAddress"; id: string; emailAddress: string }>;
					phoneNumbers: Array<{ __typename?: "PhoneNumber"; id: string; phoneNumber: string }>;
				};
				teacherCourseSectionEnrollments: Array<{
					__typename?: "TeacherCourseSectionEnrollment";
					id: string;
					courseSection: {
						__typename?: "CourseSection";
						id: string;
						academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string };
						course: {
							__typename?: "Course";
							id: string;
							classYears: Array<{ __typename?: "ClassYear"; id: string; yearsFromGraduation: number; name: string }>;
						};
					};
				}>;
				teacherHomeRoomSectionEnrollments: Array<{
					__typename?: "TeacherHomeRoomSectionEnrollment";
					id: string;
					homeRoomSection: {
						__typename?: "HomeRoomSection";
						id: string;
						namePrefix: string;
						nameSuffix: string;
						homeRoom: {
							__typename?: "HomeRoom";
							id: string;
							name: string;
							classYear: { __typename?: "ClassYear"; id: string; yearsFromGraduation: number };
						};
						academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string };
					};
				}>;
			};
		}>;
	};
};

export type EmployeeNameFragment = {
	__typename?: "Employee";
	person: { __typename?: "Person"; id: string; name: string; publicName: string };
};

export type EmployeeNameAndImageFragment = {
	__typename?: "Employee";
	person: {
		__typename?: "Person";
		id: string;
		name: string;
		publicName: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
	};
};

export type EmployeeNameDescriptionAndImageFragment = {
	__typename?: "Employee";
	role: EmployeeRole;
	jobTitle: string;
	person: {
		__typename?: "Person";
		id: string;
		name: string;
		publicName: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
	};
};

export type EmployeeNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EmployeeNameQuery = {
	__typename?: "Query";
	employee: {
		__typename?: "Employee";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type EmployeeNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<EmployeeFilterInput> | EmployeeFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EmployeeOrder>;
}>;

export type EmployeeNamesQuery = {
	__typename?: "Query";
	employeeConnection: {
		__typename?: "EmployeeConnection";
		edges: Array<{
			__typename?: "EmployeeEdge";
			node: {
				__typename?: "Employee";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			};
		}>;
	};
};

export type EmployeePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<EmployeeFilterInput> | EmployeeFilterInput>;
	order?: InputMaybe<EmployeeOrder>;
}>;

export type EmployeePaginationQuery = {
	__typename?: "Query";
	employeeConnection: {
		__typename?: "EmployeeConnection";
		totalCount: number;
		edges: Array<{ __typename?: "EmployeeEdge"; cursor: string }>;
	};
};

export type EmployeeSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<EmployeeFilterInput> | EmployeeFilterInput>;
	order?: InputMaybe<EmployeeOrder>;
}>;

export type EmployeeSelectQuery = {
	__typename?: "Query";
	employeeConnection: {
		__typename?: "EmployeeConnection";
		edges: Array<{
			__typename?: "EmployeeEdge";
			node: {
				__typename?: "Employee";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			};
		}>;
	};
};

export type EmployeeNamesAndImagesQueryVariables = Exact<{
	filters?: InputMaybe<Array<EmployeeFilterInput> | EmployeeFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EmployeeOrder>;
}>;

export type EmployeeNamesAndImagesQuery = {
	__typename?: "Query";
	employeeConnection: {
		__typename?: "EmployeeConnection";
		totalCount: number;
		edges: Array<{
			__typename?: "EmployeeEdge";
			node: {
				__typename?: "Employee";
				id: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type EmployeeNamesDescriptionsAndImagesQueryVariables = Exact<{
	filters?: InputMaybe<Array<EmployeeFilterInput> | EmployeeFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EmployeeOrder>;
}>;

export type EmployeeNamesDescriptionsAndImagesQuery = {
	__typename?: "Query";
	employeeConnection: {
		__typename?: "EmployeeConnection";
		pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor: string | null };
		edges: Array<{
			__typename?: "EmployeeEdge";
			node: {
				__typename?: "Employee";
				id: string;
				role: EmployeeRole;
				jobTitle: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type EmployeeNameImageAndUserQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EmployeeNameImageAndUserQuery = {
	__typename?: "Query";
	employee: {
		__typename?: "Employee";
		id: string;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
			user: { __typename?: "User"; id: string; status: UserStatus } | null;
		};
	};
};

export type EmployeeTooltipQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
	date: Scalars["Date"]["input"];
}>;

export type EmployeeTooltipQuery = {
	__typename?: "Query";
	employee: {
		__typename?: "Employee";
		id: string;
		jobTitle: string;
		teacherHomeRoomSectionEnrollments: Array<{
			__typename?: "TeacherHomeRoomSectionEnrollment";
			id: string;
			homeRoomSection: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			};
		}>;
		teacherCourseSectionEnrollments: Array<{
			__typename?: "TeacherCourseSectionEnrollment";
			id: string;
			courseSection: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			};
		}>;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		};
	};
};

export type EmployeeUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: EmployeeUpdateInput;
}>;

export type EmployeeUpdateMutation = {
	__typename?: "Mutation";
	updateEmployee: {
		__typename?: "Employee";
		id: string;
		workEmailAddress: string;
		jobTitle: string;
		role: EmployeeRole;
		startDate: string;
		endDate: string | null;
		bio: string;
		campuses: Array<{ __typename?: "Campus"; id: string; name: string }>;
		classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			middleName: string;
			familyName: string;
			nameOrder: PersonNameOrder;
			nickname: string;
			alternateNames: string;
			publicNameFormat: PersonPublicNameFormat;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
			gender: string;
			dateOfBirth: string | null;
			englishLanguageFluency: PersonEnglishLanguageFluency | null;
			occupation: string;
			nationalIdentificationNumber: string;
			governmentDocumentSeries: string;
			governmentDocumentNumber: string;
			governmentDocumentIssuedBy: string;
			nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
			languages: Array<{ __typename?: "Language"; id: string; name: string }>;
			addresses: Array<{
				__typename?: "Address";
				id: string;
				name: string;
				addressLine1: string;
				addressLine2: string;
				city: string;
				postalCode: string;
				stateOrProvince: string;
				country: { __typename?: "Country"; id: string; name: string };
			}>;
			emailAddresses: Array<{
				__typename?: "EmailAddress";
				id: string;
				emailAddress: string;
				isPrimary: boolean;
				name: string;
			}>;
			employee: {
				__typename?: "Employee";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			guardian: {
				__typename?: "Guardian";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			phoneNumbers: Array<{
				__typename?: "PhoneNumber";
				id: string;
				phoneNumber: string;
				isPrimary: boolean;
				name: string;
			}>;
			student: {
				__typename?: "Student";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			user: {
				__typename?: "User";
				id: string;
				email: string;
				status: UserStatus;
				passwordUpdatedAt: string;
				isCurrent: boolean;
				timeZoneName: string;
				externalNotificationFrequency: UserExternalNotificationFrequency;
				permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					employee: { __typename?: "Employee"; id: string } | null;
					guardian: { __typename?: "Guardian"; id: string } | null;
					student: { __typename?: "Student"; id: string } | null;
				} | null;
				userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
			} | null;
		};
	};
};

export type EnrollmentApplicationCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<EnrollmentApplicationFilterInput> | EnrollmentApplicationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EnrollmentApplicationOrder>;
}>;

export type EnrollmentApplicationCountQuery = {
	__typename?: "Query";
	enrollmentApplicationConnection: { __typename?: "EnrollmentApplicationConnection"; totalCount: number };
};

export type EnrollmentApplicationCreateMutationVariables = Exact<{
	input: EnrollmentApplicationCreateInput;
}>;

export type EnrollmentApplicationCreateMutation = {
	__typename?: "Mutation";
	createEnrollmentApplication: {
		__typename?: "EnrollmentApplication";
		id: string;
		createdAt: string;
		wasInquirySubmitted: boolean;
		inquirySubmittedAt: string | null;
		wasApplicationSubmitted: boolean;
		applicationSubmittedAt: string | null;
		source: string;
		sourceDetails: string;
		doesConsentToCorrespondence: boolean;
		doesConsentToDataUse: boolean;
		doesConsentToDataProtectionPolicy: boolean;
		notes: string;
		signatureName: string;
		signatureDate: string | null;
	};
};

export type EnrollmentApplicationDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EnrollmentApplicationDeleteMutation = { __typename?: "Mutation"; deleteEnrollmentApplication: boolean };

export type EnrollmentApplicationDetailFragment = {
	__typename?: "EnrollmentApplication";
	id: string;
	createdAt: string;
	wasInquirySubmitted: boolean;
	inquirySubmittedAt: string | null;
	wasApplicationSubmitted: boolean;
	applicationSubmittedAt: string | null;
	source: string;
	sourceDetails: string;
	doesConsentToCorrespondence: boolean;
	doesConsentToDataUse: boolean;
	doesConsentToDataProtectionPolicy: boolean;
	notes: string;
	signatureName: string;
	signatureDate: string | null;
};

export type EnrollmentApplicationDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EnrollmentApplicationDetailQuery = {
	__typename?: "Query";
	enrollmentApplication: {
		__typename?: "EnrollmentApplication";
		id: string;
		createdAt: string;
		wasInquirySubmitted: boolean;
		inquirySubmittedAt: string | null;
		wasApplicationSubmitted: boolean;
		applicationSubmittedAt: string | null;
		source: string;
		sourceDetails: string;
		doesConsentToCorrespondence: boolean;
		doesConsentToDataUse: boolean;
		doesConsentToDataProtectionPolicy: boolean;
		notes: string;
		signatureName: string;
		signatureDate: string | null;
	};
};

export type EnrollmentApplicationIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<EnrollmentApplicationFilterInput> | EnrollmentApplicationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EnrollmentApplicationOrder>;
}>;

export type EnrollmentApplicationIndexQuery = {
	__typename?: "Query";
	enrollmentApplicationConnection: {
		__typename?: "EnrollmentApplicationConnection";
		edges: Array<{
			__typename?: "EnrollmentApplicationEdge";
			node: {
				__typename?: "EnrollmentApplication";
				id: string;
				createdAt: string;
				wasInquirySubmitted: boolean;
				inquirySubmittedAt: string | null;
				wasApplicationSubmitted: boolean;
				applicationSubmittedAt: string | null;
				source: string;
				sourceDetails: string;
				doesConsentToCorrespondence: boolean;
				doesConsentToDataUse: boolean;
				doesConsentToDataProtectionPolicy: boolean;
				notes: string;
				signatureName: string;
				signatureDate: string | null;
			};
		}>;
	};
};

export type EnrollmentApplicationNameFragment = { __typename?: "EnrollmentApplication"; id: string };

export type EnrollmentApplicationNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EnrollmentApplicationNameQuery = {
	__typename?: "Query";
	enrollmentApplication: { __typename?: "EnrollmentApplication"; id: string };
};

export type EnrollmentApplicationNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<EnrollmentApplicationFilterInput> | EnrollmentApplicationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EnrollmentApplicationOrder>;
}>;

export type EnrollmentApplicationNamesQuery = {
	__typename?: "Query";
	enrollmentApplicationConnection: {
		__typename?: "EnrollmentApplicationConnection";
		edges: Array<{
			__typename?: "EnrollmentApplicationEdge";
			node: { __typename?: "EnrollmentApplication"; id: string };
		}>;
	};
};

export type EnrollmentApplicationPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<EnrollmentApplicationFilterInput> | EnrollmentApplicationFilterInput>;
	order?: InputMaybe<EnrollmentApplicationOrder>;
}>;

export type EnrollmentApplicationPaginationQuery = {
	__typename?: "Query";
	enrollmentApplicationConnection: {
		__typename?: "EnrollmentApplicationConnection";
		totalCount: number;
		edges: Array<{ __typename?: "EnrollmentApplicationEdge"; cursor: string }>;
	};
};

export type EnrollmentApplicationSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<EnrollmentApplicationFilterInput> | EnrollmentApplicationFilterInput>;
	order?: InputMaybe<EnrollmentApplicationOrder>;
}>;

export type EnrollmentApplicationSelectQuery = {
	__typename?: "Query";
	enrollmentApplicationConnection: {
		__typename?: "EnrollmentApplicationConnection";
		edges: Array<{
			__typename?: "EnrollmentApplicationEdge";
			node: { __typename?: "EnrollmentApplication"; id: string };
		}>;
	};
};

export type SubmitEnrollmentApplicationMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SubmitEnrollmentApplicationMutation = {
	__typename?: "Mutation";
	submitEnrollmentApplication: {
		__typename?: "EnrollmentApplication";
		id: string;
		createdAt: string;
		wasInquirySubmitted: boolean;
		inquirySubmittedAt: string | null;
		wasApplicationSubmitted: boolean;
		applicationSubmittedAt: string | null;
		source: string;
		sourceDetails: string;
		doesConsentToCorrespondence: boolean;
		doesConsentToDataUse: boolean;
		doesConsentToDataProtectionPolicy: boolean;
		notes: string;
		signatureName: string;
		signatureDate: string | null;
	};
};

export type EnrollmentApplicationUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: EnrollmentApplicationUpdateInput;
}>;

export type EnrollmentApplicationUpdateMutation = {
	__typename?: "Mutation";
	updateEnrollmentApplication: {
		__typename?: "EnrollmentApplication";
		id: string;
		createdAt: string;
		wasInquirySubmitted: boolean;
		inquirySubmittedAt: string | null;
		wasApplicationSubmitted: boolean;
		applicationSubmittedAt: string | null;
		source: string;
		sourceDetails: string;
		doesConsentToCorrespondence: boolean;
		doesConsentToDataUse: boolean;
		doesConsentToDataProtectionPolicy: boolean;
		notes: string;
		signatureName: string;
		signatureDate: string | null;
	};
};

export type EnrollmentApplicationGuardianCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput> | EnrollmentApplicationGuardianFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EnrollmentApplicationGuardianOrder>;
}>;

export type EnrollmentApplicationGuardianCountQuery = {
	__typename?: "Query";
	enrollmentApplicationGuardianConnection: {
		__typename?: "EnrollmentApplicationGuardianConnection";
		totalCount: number;
	};
};

export type EnrollmentApplicationGuardianCreateMutationVariables = Exact<{
	input: EnrollmentApplicationGuardianCreateInput;
}>;

export type EnrollmentApplicationGuardianCreateMutation = {
	__typename?: "Mutation";
	createEnrollmentApplicationGuardian: {
		__typename?: "EnrollmentApplicationGuardian";
		id: string;
		name: string;
		givenName: string;
		middleName: string;
		familyName: string;
		nameOrder: EnrollmentApplicationGuardianNameOrder;
		dateOfBirth: string | null;
		gender: string;
		relationshipType: string;
		relationshipStatus: EnrollmentApplicationGuardianRelationshipStatus | null;
		emailAddress: string;
		phoneNumber: string;
		addressLine1: string;
		addressLine2: string;
		addressCity: string;
		addressPostalCode: string;
		addressStateOrProvince: string;
		isPrimary: boolean;
		isFinancialContact: boolean;
		isEmergencyContact: boolean;
		isAuthorizedForPickup: boolean;
		livesWithStudent: boolean;
		isPrimaryOnApplication: boolean;
		addressCountry: { __typename?: "Country"; id: string; name: string } | null;
		enrollmentApplication: { __typename?: "EnrollmentApplication"; id: string };
		guardian: {
			__typename?: "Guardian";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		targetAddressGuardian: { __typename?: "EnrollmentApplicationGuardian"; id: string; name: string } | null;
	};
};

export type EnrollmentApplicationGuardianDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EnrollmentApplicationGuardianDeleteMutation = {
	__typename?: "Mutation";
	deleteEnrollmentApplicationGuardian: boolean;
};

export type EnrollmentApplicationGuardianDetailFragment = {
	__typename?: "EnrollmentApplicationGuardian";
	id: string;
	name: string;
	givenName: string;
	middleName: string;
	familyName: string;
	nameOrder: EnrollmentApplicationGuardianNameOrder;
	dateOfBirth: string | null;
	gender: string;
	relationshipType: string;
	relationshipStatus: EnrollmentApplicationGuardianRelationshipStatus | null;
	emailAddress: string;
	phoneNumber: string;
	addressLine1: string;
	addressLine2: string;
	addressCity: string;
	addressPostalCode: string;
	addressStateOrProvince: string;
	isPrimary: boolean;
	isFinancialContact: boolean;
	isEmergencyContact: boolean;
	isAuthorizedForPickup: boolean;
	livesWithStudent: boolean;
	isPrimaryOnApplication: boolean;
	addressCountry: { __typename?: "Country"; id: string; name: string } | null;
	enrollmentApplication: { __typename?: "EnrollmentApplication"; id: string };
	guardian: {
		__typename?: "Guardian";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	} | null;
	targetAddressGuardian: { __typename?: "EnrollmentApplicationGuardian"; id: string; name: string } | null;
};

export type EnrollmentApplicationGuardianDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EnrollmentApplicationGuardianDetailQuery = {
	__typename?: "Query";
	enrollmentApplicationGuardian: {
		__typename?: "EnrollmentApplicationGuardian";
		id: string;
		name: string;
		givenName: string;
		middleName: string;
		familyName: string;
		nameOrder: EnrollmentApplicationGuardianNameOrder;
		dateOfBirth: string | null;
		gender: string;
		relationshipType: string;
		relationshipStatus: EnrollmentApplicationGuardianRelationshipStatus | null;
		emailAddress: string;
		phoneNumber: string;
		addressLine1: string;
		addressLine2: string;
		addressCity: string;
		addressPostalCode: string;
		addressStateOrProvince: string;
		isPrimary: boolean;
		isFinancialContact: boolean;
		isEmergencyContact: boolean;
		isAuthorizedForPickup: boolean;
		livesWithStudent: boolean;
		isPrimaryOnApplication: boolean;
		addressCountry: { __typename?: "Country"; id: string; name: string } | null;
		enrollmentApplication: { __typename?: "EnrollmentApplication"; id: string };
		guardian: {
			__typename?: "Guardian";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		targetAddressGuardian: { __typename?: "EnrollmentApplicationGuardian"; id: string; name: string } | null;
	};
};

export type EnrollmentApplicationGuardianIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput> | EnrollmentApplicationGuardianFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EnrollmentApplicationGuardianOrder>;
}>;

export type EnrollmentApplicationGuardianIndexQuery = {
	__typename?: "Query";
	enrollmentApplicationGuardianConnection: {
		__typename?: "EnrollmentApplicationGuardianConnection";
		edges: Array<{
			__typename?: "EnrollmentApplicationGuardianEdge";
			node: {
				__typename?: "EnrollmentApplicationGuardian";
				id: string;
				name: string;
				givenName: string;
				middleName: string;
				familyName: string;
				nameOrder: EnrollmentApplicationGuardianNameOrder;
				dateOfBirth: string | null;
				gender: string;
				relationshipType: string;
				relationshipStatus: EnrollmentApplicationGuardianRelationshipStatus | null;
				emailAddress: string;
				phoneNumber: string;
				addressLine1: string;
				addressLine2: string;
				addressCity: string;
				addressPostalCode: string;
				addressStateOrProvince: string;
				isPrimary: boolean;
				isFinancialContact: boolean;
				isEmergencyContact: boolean;
				isAuthorizedForPickup: boolean;
				livesWithStudent: boolean;
				isPrimaryOnApplication: boolean;
			};
		}>;
	};
};

export type EnrollmentApplicationGuardianReviewListQueryVariables = Exact<{
	filters?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput> | EnrollmentApplicationGuardianFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EnrollmentApplicationGuardianOrder>;
}>;

export type EnrollmentApplicationGuardianReviewListQuery = {
	__typename?: "Query";
	enrollmentApplicationGuardianConnection: {
		__typename?: "EnrollmentApplicationGuardianConnection";
		edges: Array<{
			__typename?: "EnrollmentApplicationGuardianEdge";
			node: {
				__typename?: "EnrollmentApplicationGuardian";
				id: string;
				relationshipType: string;
				phoneNumber: string;
				name: string;
			};
		}>;
	};
};

export type EnrollmentApplicationGuardianAddressInformationFragment = {
	__typename?: "EnrollmentApplicationGuardian";
	addressLine1: string;
	addressLine2: string;
	addressCity: string;
	addressPostalCode: string;
	addressStateOrProvince: string;
	addressCountry: { __typename?: "Country"; id: string; name: string } | null;
};

export type EnrollmentApplicationGuardianAddressListQueryVariables = Exact<{
	filters?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput> | EnrollmentApplicationGuardianFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EnrollmentApplicationGuardianOrder>;
}>;

export type EnrollmentApplicationGuardianAddressListQuery = {
	__typename?: "Query";
	enrollmentApplicationGuardianConnection: {
		__typename?: "EnrollmentApplicationGuardianConnection";
		edges: Array<{
			__typename?: "EnrollmentApplicationGuardianEdge";
			node: {
				__typename?: "EnrollmentApplicationGuardian";
				id: string;
				name: string;
				addressLine1: string;
				addressLine2: string;
				addressCity: string;
				addressPostalCode: string;
				addressStateOrProvince: string;
				targetAddressGuardian: {
					__typename?: "EnrollmentApplicationGuardian";
					id: string;
					name: string;
					addressLine1: string;
					addressLine2: string;
					addressCity: string;
					addressPostalCode: string;
					addressStateOrProvince: string;
					addressCountry: { __typename?: "Country"; id: string; name: string } | null;
				} | null;
				addressCountry: { __typename?: "Country"; id: string; name: string } | null;
			};
		}>;
	};
};

export type EnrollmentApplicationGuardianNameFragment = { __typename?: "EnrollmentApplicationGuardian"; name: string };

export type EnrollmentApplicationGuardianNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EnrollmentApplicationGuardianNameQuery = {
	__typename?: "Query";
	enrollmentApplicationGuardian: { __typename?: "EnrollmentApplicationGuardian"; id: string; name: string };
};

export type EnrollmentApplicationGuardianNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput> | EnrollmentApplicationGuardianFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EnrollmentApplicationGuardianOrder>;
}>;

export type EnrollmentApplicationGuardianNamesQuery = {
	__typename?: "Query";
	enrollmentApplicationGuardianConnection: {
		__typename?: "EnrollmentApplicationGuardianConnection";
		edges: Array<{
			__typename?: "EnrollmentApplicationGuardianEdge";
			node: { __typename?: "EnrollmentApplicationGuardian"; id: string; name: string };
		}>;
	};
};

export type EnrollmentApplicationGuardianPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput> | EnrollmentApplicationGuardianFilterInput>;
	order?: InputMaybe<EnrollmentApplicationGuardianOrder>;
}>;

export type EnrollmentApplicationGuardianPaginationQuery = {
	__typename?: "Query";
	enrollmentApplicationGuardianConnection: {
		__typename?: "EnrollmentApplicationGuardianConnection";
		totalCount: number;
		edges: Array<{ __typename?: "EnrollmentApplicationGuardianEdge"; cursor: string }>;
	};
};

export type EnrollmentApplicationGuardianSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<EnrollmentApplicationGuardianFilterInput> | EnrollmentApplicationGuardianFilterInput>;
	order?: InputMaybe<EnrollmentApplicationGuardianOrder>;
}>;

export type EnrollmentApplicationGuardianSelectQuery = {
	__typename?: "Query";
	enrollmentApplicationGuardianConnection: {
		__typename?: "EnrollmentApplicationGuardianConnection";
		edges: Array<{
			__typename?: "EnrollmentApplicationGuardianEdge";
			node: { __typename?: "EnrollmentApplicationGuardian"; id: string; name: string };
		}>;
	};
};

export type EnrollmentApplicationGuardianUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: EnrollmentApplicationGuardianUpdateInput;
}>;

export type EnrollmentApplicationGuardianUpdateMutation = {
	__typename?: "Mutation";
	updateEnrollmentApplicationGuardian: {
		__typename?: "EnrollmentApplicationGuardian";
		id: string;
		name: string;
		givenName: string;
		middleName: string;
		familyName: string;
		nameOrder: EnrollmentApplicationGuardianNameOrder;
		dateOfBirth: string | null;
		gender: string;
		relationshipType: string;
		relationshipStatus: EnrollmentApplicationGuardianRelationshipStatus | null;
		emailAddress: string;
		phoneNumber: string;
		addressLine1: string;
		addressLine2: string;
		addressCity: string;
		addressPostalCode: string;
		addressStateOrProvince: string;
		isPrimary: boolean;
		isFinancialContact: boolean;
		isEmergencyContact: boolean;
		isAuthorizedForPickup: boolean;
		livesWithStudent: boolean;
		isPrimaryOnApplication: boolean;
		addressCountry: { __typename?: "Country"; id: string; name: string } | null;
		enrollmentApplication: { __typename?: "EnrollmentApplication"; id: string };
		guardian: {
			__typename?: "Guardian";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		targetAddressGuardian: { __typename?: "EnrollmentApplicationGuardian"; id: string; name: string } | null;
	};
};

export type EnrollmentApplicationStudentCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput> | EnrollmentApplicationStudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EnrollmentApplicationStudentOrder>;
}>;

export type EnrollmentApplicationStudentCountQuery = {
	__typename?: "Query";
	enrollmentApplicationStudentConnection: { __typename?: "EnrollmentApplicationStudentConnection"; totalCount: number };
};

export type EnrollmentApplicationStudentCreateMutationVariables = Exact<{
	input: EnrollmentApplicationStudentCreateInput;
}>;

export type EnrollmentApplicationStudentCreateMutation = {
	__typename?: "Mutation";
	createEnrollmentApplicationStudent: {
		__typename?: "EnrollmentApplicationStudent";
		id: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		name: string;
		givenName: string;
		middleName: string;
		familyName: string;
		nameOrder: EnrollmentApplicationStudentNameOrder;
		dateOfBirth: string;
		gender: string;
		englishLanguageFluency: EnrollmentApplicationStudentEnglishLanguageFluency | null;
		questionnaireActivities: string;
		questionnaireHasPsychTreatment: boolean;
		questionnairePsychTreatmentDescription: string;
		questionnaireHasSpecialNeeds: boolean;
		questionnaireSpecialNeedsDescription: string;
		questionnaireHasBehaviors: boolean;
		questionnaireBehaviorsDescription: string;
		questionnaireDescription: string;
		questionnaireAdditionalInformation: string;
		academicYear: { __typename?: "AcademicYear"; id: string; name: string };
		classYear: { __typename?: "ClassYear"; id: string; name: string };
		currentClassYear: { __typename?: "ClassYear"; id: string; name: string } | null;
		enrollmentApplication: { __typename?: "EnrollmentApplication"; id: string };
		languages: Array<{ __typename?: "Language"; id: string; name: string }>;
		nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
	};
};

export type EnrollmentApplicationStudentDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EnrollmentApplicationStudentDeleteMutation = {
	__typename?: "Mutation";
	deleteEnrollmentApplicationStudent: boolean;
};

export type EnrollmentApplicationStudentDetailFragment = {
	__typename?: "EnrollmentApplicationStudent";
	id: string;
	imageURL: string;
	imageKey: string;
	imageContentType: string;
	name: string;
	givenName: string;
	middleName: string;
	familyName: string;
	nameOrder: EnrollmentApplicationStudentNameOrder;
	dateOfBirth: string;
	gender: string;
	englishLanguageFluency: EnrollmentApplicationStudentEnglishLanguageFluency | null;
	questionnaireActivities: string;
	questionnaireHasPsychTreatment: boolean;
	questionnairePsychTreatmentDescription: string;
	questionnaireHasSpecialNeeds: boolean;
	questionnaireSpecialNeedsDescription: string;
	questionnaireHasBehaviors: boolean;
	questionnaireBehaviorsDescription: string;
	questionnaireDescription: string;
	questionnaireAdditionalInformation: string;
	academicYear: { __typename?: "AcademicYear"; id: string; name: string };
	classYear: { __typename?: "ClassYear"; id: string; name: string };
	currentClassYear: { __typename?: "ClassYear"; id: string; name: string } | null;
	enrollmentApplication: { __typename?: "EnrollmentApplication"; id: string };
	languages: Array<{ __typename?: "Language"; id: string; name: string }>;
	nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	} | null;
};

export type EnrollmentApplicationStudentDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EnrollmentApplicationStudentDetailQuery = {
	__typename?: "Query";
	enrollmentApplicationStudent: {
		__typename?: "EnrollmentApplicationStudent";
		id: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		name: string;
		givenName: string;
		middleName: string;
		familyName: string;
		nameOrder: EnrollmentApplicationStudentNameOrder;
		dateOfBirth: string;
		gender: string;
		englishLanguageFluency: EnrollmentApplicationStudentEnglishLanguageFluency | null;
		questionnaireActivities: string;
		questionnaireHasPsychTreatment: boolean;
		questionnairePsychTreatmentDescription: string;
		questionnaireHasSpecialNeeds: boolean;
		questionnaireSpecialNeedsDescription: string;
		questionnaireHasBehaviors: boolean;
		questionnaireBehaviorsDescription: string;
		questionnaireDescription: string;
		questionnaireAdditionalInformation: string;
		academicYear: { __typename?: "AcademicYear"; id: string; name: string };
		classYear: { __typename?: "ClassYear"; id: string; name: string };
		currentClassYear: { __typename?: "ClassYear"; id: string; name: string } | null;
		enrollmentApplication: { __typename?: "EnrollmentApplication"; id: string };
		languages: Array<{ __typename?: "Language"; id: string; name: string }>;
		nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
	};
};

export type EnrollmentApplicationStudentIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput> | EnrollmentApplicationStudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EnrollmentApplicationStudentOrder>;
}>;

export type EnrollmentApplicationStudentIndexQuery = {
	__typename?: "Query";
	enrollmentApplicationStudentConnection: {
		__typename?: "EnrollmentApplicationStudentConnection";
		edges: Array<{
			__typename?: "EnrollmentApplicationStudentEdge";
			node: {
				__typename?: "EnrollmentApplicationStudent";
				id: string;
				imageURL: string;
				imageContentType: string;
				name: string;
				givenName: string;
				middleName: string;
				familyName: string;
				nameOrder: EnrollmentApplicationStudentNameOrder;
				dateOfBirth: string;
				gender: string;
				englishLanguageFluency: EnrollmentApplicationStudentEnglishLanguageFluency | null;
				questionnaireActivities: string;
				questionnaireHasPsychTreatment: boolean;
				questionnairePsychTreatmentDescription: string;
				questionnaireHasSpecialNeeds: boolean;
				questionnaireSpecialNeedsDescription: string;
				questionnaireHasBehaviors: boolean;
				questionnaireBehaviorsDescription: string;
				questionnaireDescription: string;
				questionnaireAdditionalInformation: string;
			};
		}>;
	};
};

export type EnrollmentApplicationStudentReviewListQueryVariables = Exact<{
	filters?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput> | EnrollmentApplicationStudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EnrollmentApplicationStudentOrder>;
}>;

export type EnrollmentApplicationStudentReviewListQuery = {
	__typename?: "Query";
	enrollmentApplicationStudentConnection: {
		__typename?: "EnrollmentApplicationStudentConnection";
		edges: Array<{
			__typename?: "EnrollmentApplicationStudentEdge";
			node: {
				__typename?: "EnrollmentApplicationStudent";
				id: string;
				dateOfBirth: string;
				name: string;
				imageKey: string;
				imageContentType: string;
				imageURL: string;
				classYear: { __typename?: "ClassYear"; id: string; name: string };
			};
		}>;
	};
};

export type EnrollmentApplicationStudentNameFragment = { __typename?: "EnrollmentApplicationStudent"; name: string };

export type EnrollmentApplicationStudentNameAndImageFragment = {
	__typename?: "EnrollmentApplicationStudent";
	name: string;
	imageKey: string;
	imageContentType: string;
	imageURL: string;
};

export type EnrollmentApplicationStudentNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EnrollmentApplicationStudentNameQuery = {
	__typename?: "Query";
	enrollmentApplicationStudent: { __typename?: "EnrollmentApplicationStudent"; id: string; name: string };
};

export type EnrollmentApplicationStudentNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput> | EnrollmentApplicationStudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EnrollmentApplicationStudentOrder>;
}>;

export type EnrollmentApplicationStudentNamesQuery = {
	__typename?: "Query";
	enrollmentApplicationStudentConnection: {
		__typename?: "EnrollmentApplicationStudentConnection";
		edges: Array<{
			__typename?: "EnrollmentApplicationStudentEdge";
			node: { __typename?: "EnrollmentApplicationStudent"; id: string; name: string };
		}>;
	};
};

export type EnrollmentApplicationStudentPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput> | EnrollmentApplicationStudentFilterInput>;
	order?: InputMaybe<EnrollmentApplicationStudentOrder>;
}>;

export type EnrollmentApplicationStudentPaginationQuery = {
	__typename?: "Query";
	enrollmentApplicationStudentConnection: {
		__typename?: "EnrollmentApplicationStudentConnection";
		totalCount: number;
		edges: Array<{ __typename?: "EnrollmentApplicationStudentEdge"; cursor: string }>;
	};
};

export type EnrollmentApplicationStudentSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<EnrollmentApplicationStudentFilterInput> | EnrollmentApplicationStudentFilterInput>;
	order?: InputMaybe<EnrollmentApplicationStudentOrder>;
}>;

export type EnrollmentApplicationStudentSelectQuery = {
	__typename?: "Query";
	enrollmentApplicationStudentConnection: {
		__typename?: "EnrollmentApplicationStudentConnection";
		edges: Array<{
			__typename?: "EnrollmentApplicationStudentEdge";
			node: { __typename?: "EnrollmentApplicationStudent"; id: string; name: string };
		}>;
	};
};

export type EnrollmentApplicationStudentUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: EnrollmentApplicationStudentUpdateInput;
}>;

export type EnrollmentApplicationStudentUpdateMutation = {
	__typename?: "Mutation";
	updateEnrollmentApplicationStudent: {
		__typename?: "EnrollmentApplicationStudent";
		id: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		name: string;
		givenName: string;
		middleName: string;
		familyName: string;
		nameOrder: EnrollmentApplicationStudentNameOrder;
		dateOfBirth: string;
		gender: string;
		englishLanguageFluency: EnrollmentApplicationStudentEnglishLanguageFluency | null;
		questionnaireActivities: string;
		questionnaireHasPsychTreatment: boolean;
		questionnairePsychTreatmentDescription: string;
		questionnaireHasSpecialNeeds: boolean;
		questionnaireSpecialNeedsDescription: string;
		questionnaireHasBehaviors: boolean;
		questionnaireBehaviorsDescription: string;
		questionnaireDescription: string;
		questionnaireAdditionalInformation: string;
		academicYear: { __typename?: "AcademicYear"; id: string; name: string };
		classYear: { __typename?: "ClassYear"; id: string; name: string };
		currentClassYear: { __typename?: "ClassYear"; id: string; name: string } | null;
		enrollmentApplication: { __typename?: "EnrollmentApplication"; id: string };
		languages: Array<{ __typename?: "Language"; id: string; name: string }>;
		nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
	};
};

export type EnrollmentApplicationStudentSchoolCountQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<EnrollmentApplicationStudentSchoolFilterInput> | EnrollmentApplicationStudentSchoolFilterInput
	>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EnrollmentApplicationStudentSchoolOrder>;
}>;

export type EnrollmentApplicationStudentSchoolCountQuery = {
	__typename?: "Query";
	enrollmentApplicationStudentSchoolConnection: {
		__typename?: "EnrollmentApplicationStudentSchoolConnection";
		totalCount: number;
	};
};

export type EnrollmentApplicationStudentSchoolCreateMutationVariables = Exact<{
	input: EnrollmentApplicationStudentSchoolCreateInput;
}>;

export type EnrollmentApplicationStudentSchoolCreateMutation = {
	__typename?: "Mutation";
	createEnrollmentApplicationStudentSchool: {
		__typename?: "EnrollmentApplicationStudentSchool";
		id: string;
		name: string;
		city: string;
		startDate: string;
		endDate: string;
		country: { __typename?: "Country"; id: string; name: string };
		enrollmentApplicationStudent: { __typename?: "EnrollmentApplicationStudent"; id: string; name: string };
	};
};

export type EnrollmentApplicationStudentSchoolDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EnrollmentApplicationStudentSchoolDeleteMutation = {
	__typename?: "Mutation";
	deleteEnrollmentApplicationStudentSchool: boolean;
};

export type EnrollmentApplicationStudentSchoolDetailFragment = {
	__typename?: "EnrollmentApplicationStudentSchool";
	id: string;
	name: string;
	city: string;
	startDate: string;
	endDate: string;
	country: { __typename?: "Country"; id: string; name: string };
	enrollmentApplicationStudent: { __typename?: "EnrollmentApplicationStudent"; id: string; name: string };
};

export type EnrollmentApplicationStudentSchoolDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EnrollmentApplicationStudentSchoolDetailQuery = {
	__typename?: "Query";
	enrollmentApplicationStudentSchool: {
		__typename?: "EnrollmentApplicationStudentSchool";
		id: string;
		name: string;
		city: string;
		startDate: string;
		endDate: string;
		country: { __typename?: "Country"; id: string; name: string };
		enrollmentApplicationStudent: { __typename?: "EnrollmentApplicationStudent"; id: string; name: string };
	};
};

export type EnrollmentApplicationStudentSchoolIndexQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<EnrollmentApplicationStudentSchoolFilterInput> | EnrollmentApplicationStudentSchoolFilterInput
	>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EnrollmentApplicationStudentSchoolOrder>;
}>;

export type EnrollmentApplicationStudentSchoolIndexQuery = {
	__typename?: "Query";
	enrollmentApplicationStudentSchoolConnection: {
		__typename?: "EnrollmentApplicationStudentSchoolConnection";
		edges: Array<{
			__typename?: "EnrollmentApplicationStudentSchoolEdge";
			node: {
				__typename?: "EnrollmentApplicationStudentSchool";
				id: string;
				name: string;
				city: string;
				startDate: string;
				endDate: string;
			};
		}>;
	};
};

export type EnrollmentApplicationStudentSchoolNameFragment = {
	__typename?: "EnrollmentApplicationStudentSchool";
	name: string;
};

export type EnrollmentApplicationStudentSchoolNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type EnrollmentApplicationStudentSchoolNameQuery = {
	__typename?: "Query";
	enrollmentApplicationStudentSchool: { __typename?: "EnrollmentApplicationStudentSchool"; id: string; name: string };
};

export type EnrollmentApplicationStudentSchoolNamesQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<EnrollmentApplicationStudentSchoolFilterInput> | EnrollmentApplicationStudentSchoolFilterInput
	>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<EnrollmentApplicationStudentSchoolOrder>;
}>;

export type EnrollmentApplicationStudentSchoolNamesQuery = {
	__typename?: "Query";
	enrollmentApplicationStudentSchoolConnection: {
		__typename?: "EnrollmentApplicationStudentSchoolConnection";
		edges: Array<{
			__typename?: "EnrollmentApplicationStudentSchoolEdge";
			node: { __typename?: "EnrollmentApplicationStudentSchool"; id: string; name: string };
		}>;
	};
};

export type EnrollmentApplicationStudentSchoolPaginationQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<EnrollmentApplicationStudentSchoolFilterInput> | EnrollmentApplicationStudentSchoolFilterInput
	>;
	order?: InputMaybe<EnrollmentApplicationStudentSchoolOrder>;
}>;

export type EnrollmentApplicationStudentSchoolPaginationQuery = {
	__typename?: "Query";
	enrollmentApplicationStudentSchoolConnection: {
		__typename?: "EnrollmentApplicationStudentSchoolConnection";
		totalCount: number;
		edges: Array<{ __typename?: "EnrollmentApplicationStudentSchoolEdge"; cursor: string }>;
	};
};

export type EnrollmentApplicationStudentSchoolSelectQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<EnrollmentApplicationStudentSchoolFilterInput> | EnrollmentApplicationStudentSchoolFilterInput
	>;
	order?: InputMaybe<EnrollmentApplicationStudentSchoolOrder>;
}>;

export type EnrollmentApplicationStudentSchoolSelectQuery = {
	__typename?: "Query";
	enrollmentApplicationStudentSchoolConnection: {
		__typename?: "EnrollmentApplicationStudentSchoolConnection";
		edges: Array<{
			__typename?: "EnrollmentApplicationStudentSchoolEdge";
			node: { __typename?: "EnrollmentApplicationStudentSchool"; id: string; name: string };
		}>;
	};
};

export type EnrollmentApplicationStudentSchoolUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: EnrollmentApplicationStudentSchoolUpdateInput;
}>;

export type EnrollmentApplicationStudentSchoolUpdateMutation = {
	__typename?: "Mutation";
	updateEnrollmentApplicationStudentSchool: {
		__typename?: "EnrollmentApplicationStudentSchool";
		id: string;
		name: string;
		city: string;
		startDate: string;
		endDate: string;
		country: { __typename?: "Country"; id: string; name: string };
		enrollmentApplicationStudent: { __typename?: "EnrollmentApplicationStudent"; id: string; name: string };
	};
};

export type GuardianCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<GuardianFilterInput> | GuardianFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<GuardianOrder>;
}>;

export type GuardianCountQuery = {
	__typename?: "Query";
	guardianConnection: { __typename?: "GuardianConnection"; totalCount: number };
};

export type GuardianCreateMutationVariables = Exact<{
	input: GuardianCreateInput;
}>;

export type GuardianCreateMutation = {
	__typename?: "Mutation";
	createGuardian: {
		__typename?: "Guardian";
		id: string;
		relationshipStatus: GuardianRelationshipStatus | null;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			middleName: string;
			familyName: string;
			nameOrder: PersonNameOrder;
			nickname: string;
			alternateNames: string;
			publicNameFormat: PersonPublicNameFormat;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
			gender: string;
			dateOfBirth: string | null;
			englishLanguageFluency: PersonEnglishLanguageFluency | null;
			occupation: string;
			nationalIdentificationNumber: string;
			governmentDocumentSeries: string;
			governmentDocumentNumber: string;
			governmentDocumentIssuedBy: string;
			nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
			languages: Array<{ __typename?: "Language"; id: string; name: string }>;
			addresses: Array<{
				__typename?: "Address";
				id: string;
				name: string;
				addressLine1: string;
				addressLine2: string;
				city: string;
				postalCode: string;
				stateOrProvince: string;
				country: { __typename?: "Country"; id: string; name: string };
			}>;
			emailAddresses: Array<{
				__typename?: "EmailAddress";
				id: string;
				emailAddress: string;
				isPrimary: boolean;
				name: string;
			}>;
			employee: {
				__typename?: "Employee";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			guardian: {
				__typename?: "Guardian";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			phoneNumbers: Array<{
				__typename?: "PhoneNumber";
				id: string;
				phoneNumber: string;
				isPrimary: boolean;
				name: string;
			}>;
			student: {
				__typename?: "Student";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			user: {
				__typename?: "User";
				id: string;
				email: string;
				status: UserStatus;
				passwordUpdatedAt: string;
				isCurrent: boolean;
				timeZoneName: string;
				externalNotificationFrequency: UserExternalNotificationFrequency;
				permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					employee: { __typename?: "Employee"; id: string } | null;
					guardian: { __typename?: "Guardian"; id: string } | null;
					student: { __typename?: "Student"; id: string } | null;
				} | null;
				userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
			} | null;
		};
		relationships: Array<{
			__typename?: "Relationship";
			id: string;
			relationshipType: string;
			isPrimary: boolean;
			isEmergencyContact: boolean;
			isAuthorizedForPickup: boolean;
			isFinancialContact: boolean;
			livesWithStudent: boolean;
			hasCustody: boolean;
			student: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				yearsFromGraduation: number;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type GuardianDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type GuardianDeleteMutation = { __typename?: "Mutation"; deleteGuardian: boolean };

export type GuardianDetailFragment = {
	__typename?: "Guardian";
	id: string;
	relationshipStatus: GuardianRelationshipStatus | null;
	person: {
		__typename?: "Person";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		middleName: string;
		familyName: string;
		nameOrder: PersonNameOrder;
		nickname: string;
		alternateNames: string;
		publicNameFormat: PersonPublicNameFormat;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		gender: string;
		dateOfBirth: string | null;
		englishLanguageFluency: PersonEnglishLanguageFluency | null;
		occupation: string;
		nationalIdentificationNumber: string;
		governmentDocumentSeries: string;
		governmentDocumentNumber: string;
		governmentDocumentIssuedBy: string;
		nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
		languages: Array<{ __typename?: "Language"; id: string; name: string }>;
		addresses: Array<{
			__typename?: "Address";
			id: string;
			name: string;
			addressLine1: string;
			addressLine2: string;
			city: string;
			postalCode: string;
			stateOrProvince: string;
			country: { __typename?: "Country"; id: string; name: string };
		}>;
		emailAddresses: Array<{
			__typename?: "EmailAddress";
			id: string;
			emailAddress: string;
			isPrimary: boolean;
			name: string;
		}>;
		employee: {
			__typename?: "Employee";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		guardian: {
			__typename?: "Guardian";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		phoneNumbers: Array<{
			__typename?: "PhoneNumber";
			id: string;
			phoneNumber: string;
			isPrimary: boolean;
			name: string;
		}>;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		user: {
			__typename?: "User";
			id: string;
			email: string;
			status: UserStatus;
			passwordUpdatedAt: string;
			isCurrent: boolean;
			timeZoneName: string;
			externalNotificationFrequency: UserExternalNotificationFrequency;
			permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				employee: { __typename?: "Employee"; id: string } | null;
				guardian: { __typename?: "Guardian"; id: string } | null;
				student: { __typename?: "Student"; id: string } | null;
			} | null;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		} | null;
	};
	relationships: Array<{
		__typename?: "Relationship";
		id: string;
		relationshipType: string;
		isPrimary: boolean;
		isEmergencyContact: boolean;
		isAuthorizedForPickup: boolean;
		isFinancialContact: boolean;
		livesWithStudent: boolean;
		hasCustody: boolean;
		student: {
			__typename?: "Student";
			id: string;
			graduationYear: number | null;
			yearsFromGraduation: number;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		};
	}>;
};

export type GuardianDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type GuardianDetailQuery = {
	__typename?: "Query";
	guardian: {
		__typename?: "Guardian";
		id: string;
		relationshipStatus: GuardianRelationshipStatus | null;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			middleName: string;
			familyName: string;
			nameOrder: PersonNameOrder;
			nickname: string;
			alternateNames: string;
			publicNameFormat: PersonPublicNameFormat;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
			gender: string;
			dateOfBirth: string | null;
			englishLanguageFluency: PersonEnglishLanguageFluency | null;
			occupation: string;
			nationalIdentificationNumber: string;
			governmentDocumentSeries: string;
			governmentDocumentNumber: string;
			governmentDocumentIssuedBy: string;
			nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
			languages: Array<{ __typename?: "Language"; id: string; name: string }>;
			addresses: Array<{
				__typename?: "Address";
				id: string;
				name: string;
				addressLine1: string;
				addressLine2: string;
				city: string;
				postalCode: string;
				stateOrProvince: string;
				country: { __typename?: "Country"; id: string; name: string };
			}>;
			emailAddresses: Array<{
				__typename?: "EmailAddress";
				id: string;
				emailAddress: string;
				isPrimary: boolean;
				name: string;
			}>;
			employee: {
				__typename?: "Employee";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			guardian: {
				__typename?: "Guardian";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			phoneNumbers: Array<{
				__typename?: "PhoneNumber";
				id: string;
				phoneNumber: string;
				isPrimary: boolean;
				name: string;
			}>;
			student: {
				__typename?: "Student";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			user: {
				__typename?: "User";
				id: string;
				email: string;
				status: UserStatus;
				passwordUpdatedAt: string;
				isCurrent: boolean;
				timeZoneName: string;
				externalNotificationFrequency: UserExternalNotificationFrequency;
				permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					employee: { __typename?: "Employee"; id: string } | null;
					guardian: { __typename?: "Guardian"; id: string } | null;
					student: { __typename?: "Student"; id: string } | null;
				} | null;
				userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
			} | null;
		};
		relationships: Array<{
			__typename?: "Relationship";
			id: string;
			relationshipType: string;
			isPrimary: boolean;
			isEmergencyContact: boolean;
			isAuthorizedForPickup: boolean;
			isFinancialContact: boolean;
			livesWithStudent: boolean;
			hasCustody: boolean;
			student: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				yearsFromGraduation: number;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type GuardianIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<GuardianFilterInput> | GuardianFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<GuardianOrder>;
}>;

export type GuardianIndexQuery = {
	__typename?: "Query";
	guardianConnection: {
		__typename?: "GuardianConnection";
		edges: Array<{
			__typename?: "GuardianEdge";
			node: {
				__typename?: "Guardian";
				id: string;
				relationshipStatus: GuardianRelationshipStatus | null;
				person: {
					__typename?: "Person";
					id: string;
					gender: string;
					dateOfBirth: string | null;
					englishLanguageFluency: PersonEnglishLanguageFluency | null;
					occupation: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
					nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
					languages: Array<{ __typename?: "Language"; id: string; name: string }>;
					addresses: Array<{
						__typename?: "Address";
						id: string;
						name: string;
						addressLine1: string;
						addressLine2: string;
						city: string;
						postalCode: string;
						stateOrProvince: string;
						country: { __typename?: "Country"; id: string; name: string };
					}>;
					emailAddresses: Array<{ __typename?: "EmailAddress"; id: string; emailAddress: string }>;
					phoneNumbers: Array<{ __typename?: "PhoneNumber"; id: string; phoneNumber: string }>;
				};
				relationships: Array<{
					__typename?: "Relationship";
					id: string;
					student: {
						__typename?: "Student";
						id: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string };
					};
				}>;
			};
		}>;
	};
};

export type GuardianNameFragment = {
	__typename?: "Guardian";
	person: { __typename?: "Person"; id: string; name: string; publicName: string };
};

export type GuardianNameAndImageFragment = {
	__typename?: "Guardian";
	person: {
		__typename?: "Person";
		id: string;
		name: string;
		publicName: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
	};
};

export type GuardianNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type GuardianNameQuery = {
	__typename?: "Query";
	guardian: {
		__typename?: "Guardian";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type GuardianNamesAndImagesQueryVariables = Exact<{
	filters?: InputMaybe<Array<GuardianFilterInput> | GuardianFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<GuardianOrder>;
}>;

export type GuardianNamesAndImagesQuery = {
	__typename?: "Query";
	guardianConnection: {
		__typename?: "GuardianConnection";
		edges: Array<{
			__typename?: "GuardianEdge";
			node: {
				__typename?: "Guardian";
				id: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type GuardianNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<GuardianFilterInput> | GuardianFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<GuardianOrder>;
}>;

export type GuardianNamesQuery = {
	__typename?: "Query";
	guardianConnection: {
		__typename?: "GuardianConnection";
		edges: Array<{
			__typename?: "GuardianEdge";
			node: {
				__typename?: "Guardian";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			};
		}>;
	};
};

export type GuardianPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<GuardianFilterInput> | GuardianFilterInput>;
	order?: InputMaybe<GuardianOrder>;
}>;

export type GuardianPaginationQuery = {
	__typename?: "Query";
	guardianConnection: {
		__typename?: "GuardianConnection";
		totalCount: number;
		edges: Array<{ __typename?: "GuardianEdge"; cursor: string }>;
	};
};

export type GuardianSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<GuardianFilterInput> | GuardianFilterInput>;
	order?: InputMaybe<GuardianOrder>;
}>;

export type GuardianSelectQuery = {
	__typename?: "Query";
	guardianConnection: {
		__typename?: "GuardianConnection";
		edges: Array<{
			__typename?: "GuardianEdge";
			node: {
				__typename?: "Guardian";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			};
		}>;
	};
};

export type GuardianTooltipQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type GuardianTooltipQuery = {
	__typename?: "Query";
	guardian: {
		__typename?: "Guardian";
		id: string;
		relationships: Array<{
			__typename?: "Relationship";
			id: string;
			relationshipType: string;
			student: {
				__typename?: "Student";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			};
		}>;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		};
	};
};

export type GuardianUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: GuardianUpdateInput;
}>;

export type GuardianUpdateMutation = {
	__typename?: "Mutation";
	updateGuardian: {
		__typename?: "Guardian";
		id: string;
		relationshipStatus: GuardianRelationshipStatus | null;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			middleName: string;
			familyName: string;
			nameOrder: PersonNameOrder;
			nickname: string;
			alternateNames: string;
			publicNameFormat: PersonPublicNameFormat;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
			gender: string;
			dateOfBirth: string | null;
			englishLanguageFluency: PersonEnglishLanguageFluency | null;
			occupation: string;
			nationalIdentificationNumber: string;
			governmentDocumentSeries: string;
			governmentDocumentNumber: string;
			governmentDocumentIssuedBy: string;
			nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
			languages: Array<{ __typename?: "Language"; id: string; name: string }>;
			addresses: Array<{
				__typename?: "Address";
				id: string;
				name: string;
				addressLine1: string;
				addressLine2: string;
				city: string;
				postalCode: string;
				stateOrProvince: string;
				country: { __typename?: "Country"; id: string; name: string };
			}>;
			emailAddresses: Array<{
				__typename?: "EmailAddress";
				id: string;
				emailAddress: string;
				isPrimary: boolean;
				name: string;
			}>;
			employee: {
				__typename?: "Employee";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			guardian: {
				__typename?: "Guardian";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			phoneNumbers: Array<{
				__typename?: "PhoneNumber";
				id: string;
				phoneNumber: string;
				isPrimary: boolean;
				name: string;
			}>;
			student: {
				__typename?: "Student";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			user: {
				__typename?: "User";
				id: string;
				email: string;
				status: UserStatus;
				passwordUpdatedAt: string;
				isCurrent: boolean;
				timeZoneName: string;
				externalNotificationFrequency: UserExternalNotificationFrequency;
				permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					employee: { __typename?: "Employee"; id: string } | null;
					guardian: { __typename?: "Guardian"; id: string } | null;
					student: { __typename?: "Student"; id: string } | null;
				} | null;
				userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
			} | null;
		};
		relationships: Array<{
			__typename?: "Relationship";
			id: string;
			relationshipType: string;
			isPrimary: boolean;
			isEmergencyContact: boolean;
			isAuthorizedForPickup: boolean;
			isFinancialContact: boolean;
			livesWithStudent: boolean;
			hasCustody: boolean;
			student: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				yearsFromGraduation: number;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type HomeRoomCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<HomeRoomFilterInput> | HomeRoomFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<HomeRoomOrder>;
}>;

export type HomeRoomCountQuery = {
	__typename?: "Query";
	homeRoomConnection: { __typename?: "HomeRoomConnection"; totalCount: number };
};

export type HomeRoomCreateMutationVariables = Exact<{
	input: HomeRoomCreateInput;
}>;

export type HomeRoomCreateMutation = {
	__typename?: "Mutation";
	createHomeRoom: {
		__typename?: "HomeRoom";
		id: string;
		name: string;
		description: string;
		classYear: { __typename?: "ClassYear"; id: string; name: string };
	};
};

export type HomeRoomDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type HomeRoomDeleteMutation = { __typename?: "Mutation"; deleteHomeRoom: boolean };

export type HomeRoomDetailFragment = {
	__typename?: "HomeRoom";
	id: string;
	name: string;
	description: string;
	classYear: { __typename?: "ClassYear"; id: string; name: string };
};

export type HomeRoomDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type HomeRoomDetailQuery = {
	__typename?: "Query";
	homeRoom: {
		__typename?: "HomeRoom";
		id: string;
		name: string;
		description: string;
		classYear: { __typename?: "ClassYear"; id: string; name: string };
	};
};

export type HomeRoomIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<HomeRoomFilterInput> | HomeRoomFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<HomeRoomOrder>;
}>;

export type HomeRoomIndexQuery = {
	__typename?: "Query";
	homeRoomConnection: {
		__typename?: "HomeRoomConnection";
		edges: Array<{
			__typename?: "HomeRoomEdge";
			node: {
				__typename?: "HomeRoom";
				id: string;
				name: string;
				description: string;
				classYear: { __typename?: "ClassYear"; id: string; name: string };
			};
		}>;
	};
};

export type HomeRoomNameFragment = { __typename?: "HomeRoom"; name: string };

export type HomeRoomNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type HomeRoomNameQuery = {
	__typename?: "Query";
	homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
};

export type HomeRoomNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<HomeRoomFilterInput> | HomeRoomFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<HomeRoomOrder>;
}>;

export type HomeRoomNamesQuery = {
	__typename?: "Query";
	homeRoomConnection: {
		__typename?: "HomeRoomConnection";
		edges: Array<{ __typename?: "HomeRoomEdge"; node: { __typename?: "HomeRoom"; id: string; name: string } }>;
	};
};

export type HomeRoomPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<HomeRoomFilterInput> | HomeRoomFilterInput>;
	order?: InputMaybe<HomeRoomOrder>;
}>;

export type HomeRoomPaginationQuery = {
	__typename?: "Query";
	homeRoomConnection: {
		__typename?: "HomeRoomConnection";
		totalCount: number;
		edges: Array<{ __typename?: "HomeRoomEdge"; cursor: string }>;
	};
};

export type HomeRoomSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<HomeRoomFilterInput> | HomeRoomFilterInput>;
	order?: InputMaybe<HomeRoomOrder>;
}>;

export type HomeRoomSelectQuery = {
	__typename?: "Query";
	homeRoomConnection: {
		__typename?: "HomeRoomConnection";
		edges: Array<{ __typename?: "HomeRoomEdge"; node: { __typename?: "HomeRoom"; id: string; name: string } }>;
	};
};

export type HomeRoomUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: HomeRoomUpdateInput;
}>;

export type HomeRoomUpdateMutation = {
	__typename?: "Mutation";
	updateHomeRoom: {
		__typename?: "HomeRoom";
		id: string;
		name: string;
		description: string;
		classYear: { __typename?: "ClassYear"; id: string; name: string };
	};
};

export type HomeRoomSectionCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<HomeRoomSectionFilterInput> | HomeRoomSectionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<HomeRoomSectionOrder>;
}>;

export type HomeRoomSectionCountQuery = {
	__typename?: "Query";
	homeRoomSectionConnection: { __typename?: "HomeRoomSectionConnection"; totalCount: number };
};

export type HomeRoomSectionCreateMutationVariables = Exact<{
	input: HomeRoomSectionCreateInput;
}>;

export type HomeRoomSectionCreateMutation = {
	__typename?: "Mutation";
	createHomeRoomSection: {
		__typename?: "HomeRoomSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string; name: string };
		homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		room: { __typename?: "Room"; id: string; name: string } | null;
		studentHomeRoomSectionEnrollments: Array<{
			__typename?: "StudentHomeRoomSectionEnrollment";
			id: string;
			lateStartDate: string | null;
			earlyEndDate: string | null;
			student: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				yearsFromGraduation: number;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
		teacherHomeRoomSectionEnrollments: Array<{
			__typename?: "TeacherHomeRoomSectionEnrollment";
			id: string;
			lateStartDate: string | null;
			earlyEndDate: string | null;
			teacher: {
				__typename?: "Employee";
				id: string;
				role: EmployeeRole;
				jobTitle: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type HomeRoomSectionDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type HomeRoomSectionDeleteMutation = { __typename?: "Mutation"; deleteHomeRoomSection: boolean };

export type HomeRoomSectionDetailFragment = {
	__typename?: "HomeRoomSection";
	id: string;
	namePrefix: string;
	nameSuffix: string;
	academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string; name: string };
	homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
	room: { __typename?: "Room"; id: string; name: string } | null;
	studentHomeRoomSectionEnrollments: Array<{
		__typename?: "StudentHomeRoomSectionEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		student: {
			__typename?: "Student";
			id: string;
			graduationYear: number | null;
			yearsFromGraduation: number;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		};
	}>;
	teacherHomeRoomSectionEnrollments: Array<{
		__typename?: "TeacherHomeRoomSectionEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		teacher: {
			__typename?: "Employee";
			id: string;
			role: EmployeeRole;
			jobTitle: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		};
	}>;
};

export type HomeRoomSectionDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type HomeRoomSectionDetailQuery = {
	__typename?: "Query";
	homeRoomSection: {
		__typename?: "HomeRoomSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string; name: string };
		homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		room: { __typename?: "Room"; id: string; name: string } | null;
		studentHomeRoomSectionEnrollments: Array<{
			__typename?: "StudentHomeRoomSectionEnrollment";
			id: string;
			lateStartDate: string | null;
			earlyEndDate: string | null;
			student: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				yearsFromGraduation: number;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
		teacherHomeRoomSectionEnrollments: Array<{
			__typename?: "TeacherHomeRoomSectionEnrollment";
			id: string;
			lateStartDate: string | null;
			earlyEndDate: string | null;
			teacher: {
				__typename?: "Employee";
				id: string;
				role: EmployeeRole;
				jobTitle: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type HomeRoomSectionIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<HomeRoomSectionFilterInput> | HomeRoomSectionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<HomeRoomSectionOrder>;
}>;

export type HomeRoomSectionIndexQuery = {
	__typename?: "Query";
	homeRoomSectionConnection: {
		__typename?: "HomeRoomSectionConnection";
		edges: Array<{
			__typename?: "HomeRoomSectionEdge";
			node: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string; name: string };
				homeRoom: {
					__typename?: "HomeRoom";
					id: string;
					name: string;
					classYear: { __typename?: "ClassYear"; id: string; name: string };
				};
				studentHomeRoomSectionEnrollments: Array<{
					__typename?: "StudentHomeRoomSectionEnrollment";
					id: string;
					lateStartDate: string | null;
					earlyEndDate: string | null;
				}>;
				teacherHomeRoomSectionEnrollments: Array<{
					__typename?: "TeacherHomeRoomSectionEnrollment";
					id: string;
					lateStartDate: string | null;
					earlyEndDate: string | null;
					teacher: {
						__typename?: "Employee";
						id: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string };
					};
				}>;
			};
		}>;
	};
};

export type HomeRoomSectionListQueryVariables = Exact<{
	filters?: InputMaybe<Array<HomeRoomSectionFilterInput> | HomeRoomSectionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<HomeRoomSectionOrder>;
}>;

export type HomeRoomSectionListQuery = {
	__typename?: "Query";
	homeRoomSectionConnection: {
		__typename?: "HomeRoomSectionConnection";
		edges: Array<{
			__typename?: "HomeRoomSectionEdge";
			node: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				studentHomeRoomSectionEnrollments: Array<{
					__typename?: "StudentHomeRoomSectionEnrollment";
					id: string;
					lateStartDate: string | null;
					earlyEndDate: string | null;
					student: {
						__typename?: "Student";
						id: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string };
					};
				}>;
				teacherHomeRoomSectionEnrollments: Array<{
					__typename?: "TeacherHomeRoomSectionEnrollment";
					id: string;
					teacher: {
						__typename?: "Employee";
						id: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string };
					};
				}>;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			};
		}>;
	};
};

export type HomeRoomSectionNamesAndTeachersListQueryVariables = Exact<{
	filters?: InputMaybe<Array<HomeRoomSectionFilterInput> | HomeRoomSectionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<HomeRoomSectionOrder>;
}>;

export type HomeRoomSectionNamesAndTeachersListQuery = {
	__typename?: "Query";
	homeRoomSectionConnection: {
		__typename?: "HomeRoomSectionConnection";
		edges: Array<{
			__typename?: "HomeRoomSectionEdge";
			node: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				teacherHomeRoomSectionEnrollments: Array<{
					__typename?: "TeacherHomeRoomSectionEnrollment";
					id: string;
					teacher: {
						__typename?: "Employee";
						id: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string };
					};
				}>;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			};
		}>;
	};
};

export type HomeRoomSectionNameFragment = {
	__typename?: "HomeRoomSection";
	namePrefix: string;
	nameSuffix: string;
	homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
};

export type HomeRoomSectionNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type HomeRoomSectionNameQuery = {
	__typename?: "Query";
	homeRoomSection: {
		__typename?: "HomeRoomSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
	};
};

export type HomeRoomSectionNamesAndTeachersQueryVariables = Exact<{
	filters?: InputMaybe<Array<HomeRoomSectionFilterInput> | HomeRoomSectionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<HomeRoomSectionOrder>;
}>;

export type HomeRoomSectionNamesAndTeachersQuery = {
	__typename?: "Query";
	homeRoomSectionConnection: {
		__typename?: "HomeRoomSectionConnection";
		edges: Array<{
			__typename?: "HomeRoomSectionEdge";
			node: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				teacherHomeRoomSectionEnrollments: Array<{
					__typename?: "TeacherHomeRoomSectionEnrollment";
					id: string;
					teacher: {
						__typename?: "Employee";
						id: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string };
					};
				}>;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			};
		}>;
	};
};

export type HomeRoomSectionNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<HomeRoomSectionFilterInput> | HomeRoomSectionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<HomeRoomSectionOrder>;
}>;

export type HomeRoomSectionNamesQuery = {
	__typename?: "Query";
	homeRoomSectionConnection: {
		__typename?: "HomeRoomSectionConnection";
		edges: Array<{
			__typename?: "HomeRoomSectionEdge";
			node: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			};
		}>;
	};
};

export type HomeRoomSectionPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<HomeRoomSectionFilterInput> | HomeRoomSectionFilterInput>;
	order?: InputMaybe<HomeRoomSectionOrder>;
}>;

export type HomeRoomSectionPaginationQuery = {
	__typename?: "Query";
	homeRoomSectionConnection: {
		__typename?: "HomeRoomSectionConnection";
		totalCount: number;
		edges: Array<{ __typename?: "HomeRoomSectionEdge"; cursor: string }>;
	};
};

export type HomeRoomSectionSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<HomeRoomSectionFilterInput> | HomeRoomSectionFilterInput>;
	order?: InputMaybe<HomeRoomSectionOrder>;
}>;

export type HomeRoomSectionSelectQuery = {
	__typename?: "Query";
	homeRoomSectionConnection: {
		__typename?: "HomeRoomSectionConnection";
		edges: Array<{
			__typename?: "HomeRoomSectionEdge";
			node: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			};
		}>;
	};
};

export type HomeRoomSectionUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: HomeRoomSectionUpdateInput;
}>;

export type HomeRoomSectionUpdateMutation = {
	__typename?: "Mutation";
	updateHomeRoomSection: {
		__typename?: "HomeRoomSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string; name: string };
		homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		room: { __typename?: "Room"; id: string; name: string } | null;
		studentHomeRoomSectionEnrollments: Array<{
			__typename?: "StudentHomeRoomSectionEnrollment";
			id: string;
			lateStartDate: string | null;
			earlyEndDate: string | null;
			student: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				yearsFromGraduation: number;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
		teacherHomeRoomSectionEnrollments: Array<{
			__typename?: "TeacherHomeRoomSectionEnrollment";
			id: string;
			lateStartDate: string | null;
			earlyEndDate: string | null;
			teacher: {
				__typename?: "Employee";
				id: string;
				role: EmployeeRole;
				jobTitle: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type InvoiceCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<InvoiceFilterInput> | InvoiceFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<InvoiceOrder>;
}>;

export type InvoiceCountQuery = {
	__typename?: "Query";
	invoiceConnection: { __typename?: "InvoiceConnection"; totalCount: number };
};

export type CreateInvoiceForContractInstallmentMutationVariables = Exact<{
	contractInstallmentID: Scalars["ID"]["input"];
}>;

export type CreateInvoiceForContractInstallmentMutation = {
	__typename?: "Mutation";
	createInvoiceForContractInstallment: {
		__typename?: "Invoice";
		id: string;
		name: string;
		status: InvoiceStatus;
		issueDate: string;
		dueDate: string;
		description: string;
		contractInstallment: { __typename?: "ContractInstallment"; id: string };
	};
};

export type InvoiceCreateMutationVariables = Exact<{
	input: InvoiceCreateInput;
}>;

export type InvoiceCreateMutation = {
	__typename?: "Mutation";
	createInvoice: {
		__typename?: "Invoice";
		id: string;
		name: string;
		status: InvoiceStatus;
		issueDate: string;
		dueDate: string;
		description: string;
		contractInstallment: { __typename?: "ContractInstallment"; id: string };
	};
};

export type InvoiceDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type InvoiceDeleteMutation = { __typename?: "Mutation"; deleteInvoice: boolean };

export type InvoiceDetailFragment = {
	__typename?: "Invoice";
	id: string;
	name: string;
	status: InvoiceStatus;
	issueDate: string;
	dueDate: string;
	description: string;
	contractInstallment: { __typename?: "ContractInstallment"; id: string };
};

export type InvoiceDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type InvoiceDetailQuery = {
	__typename?: "Query";
	invoice: {
		__typename?: "Invoice";
		id: string;
		name: string;
		status: InvoiceStatus;
		issueDate: string;
		dueDate: string;
		description: string;
		contractInstallment: { __typename?: "ContractInstallment"; id: string };
	};
};

export type InvoiceIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<InvoiceFilterInput> | InvoiceFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<InvoiceOrder>;
}>;

export type InvoiceIndexQuery = {
	__typename?: "Query";
	invoiceConnection: {
		__typename?: "InvoiceConnection";
		edges: Array<{
			__typename?: "InvoiceEdge";
			node: {
				__typename?: "Invoice";
				id: string;
				name: string;
				status: InvoiceStatus;
				issueDate: string;
				dueDate: string;
				description: string;
			};
		}>;
	};
};

export type PaymentLineItemInvoiceSelectionInformationQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PaymentLineItemInvoiceSelectionInformationQuery = {
	__typename?: "Query";
	invoice: {
		__typename?: "Invoice";
		id: string;
		contractInstallment: {
			__typename?: "ContractInstallment";
			id: string;
			contract: { __typename?: "Contract"; id: string; student: { __typename?: "Student"; id: string } };
		};
		invoiceLineItems: Array<{ __typename?: "InvoiceLineItem"; id: string; amount: number }>;
		paymentLineItems: Array<{ __typename?: "PaymentLineItem"; id: string; amount: number }>;
		billingAdjustments: Array<{ __typename?: "BillingAdjustment"; id: string; amount: number }>;
	};
};

export type InvoicePaymentInformationListQueryVariables = Exact<{
	filters?: InputMaybe<Array<InvoiceFilterInput> | InvoiceFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<InvoiceOrder>;
}>;

export type InvoicePaymentInformationListQuery = {
	__typename?: "Query";
	invoiceConnection: {
		__typename?: "InvoiceConnection";
		edges: Array<{
			__typename?: "InvoiceEdge";
			node: {
				__typename?: "Invoice";
				id: string;
				name: string;
				status: InvoiceStatus;
				dueDate: string;
				contractInstallment: {
					__typename?: "ContractInstallment";
					id: string;
					contract: {
						__typename?: "Contract";
						id: string;
						name: string;
						student: {
							__typename?: "Student";
							id: string;
							person: {
								__typename?: "Person";
								id: string;
								name: string;
								publicName: string;
								imageURL: string;
								imageKey: string;
								imageContentType: string;
							};
						};
						contractInstallments: Array<{ __typename?: "ContractInstallment"; id: string; dueDate: string }>;
					};
				};
				invoiceLineItems: Array<{ __typename?: "InvoiceLineItem"; id: string; amount: number }>;
				paymentLineItems: Array<{ __typename?: "PaymentLineItem"; id: string; amount: number }>;
				billingAdjustments: Array<{ __typename?: "BillingAdjustment"; id: string; amount: number }>;
			};
		}>;
	};
};

export type InvoiceNameFragment = { __typename?: "Invoice"; name: string; dueDate: string };

export type InvoiceNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type InvoiceNameQuery = {
	__typename?: "Query";
	invoice: { __typename?: "Invoice"; id: string; name: string; dueDate: string };
};

export type InvoiceNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<InvoiceFilterInput> | InvoiceFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<InvoiceOrder>;
}>;

export type InvoiceNamesQuery = {
	__typename?: "Query";
	invoiceConnection: {
		__typename?: "InvoiceConnection";
		edges: Array<{
			__typename?: "InvoiceEdge";
			node: { __typename?: "Invoice"; id: string; name: string; dueDate: string };
		}>;
	};
};

export type InvoicePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<InvoiceFilterInput> | InvoiceFilterInput>;
	order?: InputMaybe<InvoiceOrder>;
}>;

export type InvoicePaginationQuery = {
	__typename?: "Query";
	invoiceConnection: {
		__typename?: "InvoiceConnection";
		totalCount: number;
		edges: Array<{ __typename?: "InvoiceEdge"; cursor: string }>;
	};
};

export type InvoiceSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<InvoiceFilterInput> | InvoiceFilterInput>;
	order?: InputMaybe<InvoiceOrder>;
}>;

export type InvoiceSelectQuery = {
	__typename?: "Query";
	invoiceConnection: {
		__typename?: "InvoiceConnection";
		edges: Array<{
			__typename?: "InvoiceEdge";
			node: { __typename?: "Invoice"; id: string; name: string; dueDate: string };
		}>;
	};
};

export type InvoiceUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: InvoiceUpdateInput;
}>;

export type InvoiceUpdateMutation = {
	__typename?: "Mutation";
	updateInvoice: {
		__typename?: "Invoice";
		id: string;
		name: string;
		status: InvoiceStatus;
		issueDate: string;
		dueDate: string;
		description: string;
		contractInstallment: { __typename?: "ContractInstallment"; id: string };
	};
};

export type InvoiceLineItemCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<InvoiceLineItemFilterInput> | InvoiceLineItemFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<InvoiceLineItemOrder>;
}>;

export type InvoiceLineItemCountQuery = {
	__typename?: "Query";
	invoiceLineItemConnection: { __typename?: "InvoiceLineItemConnection"; totalCount: number };
};

export type InvoiceLineItemCreateMutationVariables = Exact<{
	input: InvoiceLineItemCreateInput;
}>;

export type InvoiceLineItemCreateMutation = {
	__typename?: "Mutation";
	createInvoiceLineItem: {
		__typename?: "InvoiceLineItem";
		id: string;
		displayOrder: number;
		amount: number;
		contractLineItem: {
			__typename?: "ContractLineItem";
			id: string;
			service: { __typename?: "Service"; id: string; name: string } | null;
			discount: { __typename?: "Discount"; id: string; name: string } | null;
		};
		invoice: { __typename?: "Invoice"; id: string; name: string; dueDate: string };
	};
};

export type InvoiceLineItemDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type InvoiceLineItemDeleteMutation = { __typename?: "Mutation"; deleteInvoiceLineItem: boolean };

export type InvoiceLineItemDetailFragment = {
	__typename?: "InvoiceLineItem";
	id: string;
	displayOrder: number;
	amount: number;
	contractLineItem: {
		__typename?: "ContractLineItem";
		id: string;
		service: { __typename?: "Service"; id: string; name: string } | null;
		discount: { __typename?: "Discount"; id: string; name: string } | null;
	};
	invoice: { __typename?: "Invoice"; id: string; name: string; dueDate: string };
};

export type InvoiceLineItemDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type InvoiceLineItemDetailQuery = {
	__typename?: "Query";
	invoiceLineItem: {
		__typename?: "InvoiceLineItem";
		id: string;
		displayOrder: number;
		amount: number;
		contractLineItem: {
			__typename?: "ContractLineItem";
			id: string;
			service: { __typename?: "Service"; id: string; name: string } | null;
			discount: { __typename?: "Discount"; id: string; name: string } | null;
		};
		invoice: { __typename?: "Invoice"; id: string; name: string; dueDate: string };
	};
};

export type InvoiceLineItemIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<InvoiceLineItemFilterInput> | InvoiceLineItemFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<InvoiceLineItemOrder>;
}>;

export type InvoiceLineItemIndexQuery = {
	__typename?: "Query";
	invoiceLineItemConnection: {
		__typename?: "InvoiceLineItemConnection";
		edges: Array<{
			__typename?: "InvoiceLineItemEdge";
			node: { __typename?: "InvoiceLineItem"; id: string; displayOrder: number; amount: number };
		}>;
	};
};

export type InvoiceLineItemNameFragment = {
	__typename?: "InvoiceLineItem";
	contractLineItem: {
		__typename?: "ContractLineItem";
		id: string;
		service: { __typename?: "Service"; id: string; name: string } | null;
		discount: { __typename?: "Discount"; id: string; name: string } | null;
	};
};

export type InvoiceLineItemNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type InvoiceLineItemNameQuery = {
	__typename?: "Query";
	invoiceLineItem: {
		__typename?: "InvoiceLineItem";
		id: string;
		contractLineItem: {
			__typename?: "ContractLineItem";
			id: string;
			service: { __typename?: "Service"; id: string; name: string } | null;
			discount: { __typename?: "Discount"; id: string; name: string } | null;
		};
	};
};

export type InvoiceLineItemNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<InvoiceLineItemFilterInput> | InvoiceLineItemFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<InvoiceLineItemOrder>;
}>;

export type InvoiceLineItemNamesQuery = {
	__typename?: "Query";
	invoiceLineItemConnection: {
		__typename?: "InvoiceLineItemConnection";
		edges: Array<{
			__typename?: "InvoiceLineItemEdge";
			node: {
				__typename?: "InvoiceLineItem";
				id: string;
				contractLineItem: {
					__typename?: "ContractLineItem";
					id: string;
					service: { __typename?: "Service"; id: string; name: string } | null;
					discount: { __typename?: "Discount"; id: string; name: string } | null;
				};
			};
		}>;
	};
};

export type InvoiceLineItemPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<InvoiceLineItemFilterInput> | InvoiceLineItemFilterInput>;
	order?: InputMaybe<InvoiceLineItemOrder>;
}>;

export type InvoiceLineItemPaginationQuery = {
	__typename?: "Query";
	invoiceLineItemConnection: {
		__typename?: "InvoiceLineItemConnection";
		totalCount: number;
		edges: Array<{ __typename?: "InvoiceLineItemEdge"; cursor: string }>;
	};
};

export type InvoiceLineItemSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<InvoiceLineItemFilterInput> | InvoiceLineItemFilterInput>;
	order?: InputMaybe<InvoiceLineItemOrder>;
}>;

export type InvoiceLineItemSelectQuery = {
	__typename?: "Query";
	invoiceLineItemConnection: {
		__typename?: "InvoiceLineItemConnection";
		edges: Array<{
			__typename?: "InvoiceLineItemEdge";
			node: {
				__typename?: "InvoiceLineItem";
				id: string;
				contractLineItem: {
					__typename?: "ContractLineItem";
					id: string;
					service: { __typename?: "Service"; id: string; name: string } | null;
					discount: { __typename?: "Discount"; id: string; name: string } | null;
				};
			};
		}>;
	};
};

export type InvoiceLineItemUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: InvoiceLineItemUpdateInput;
}>;

export type InvoiceLineItemUpdateMutation = {
	__typename?: "Mutation";
	updateInvoiceLineItem: {
		__typename?: "InvoiceLineItem";
		id: string;
		displayOrder: number;
		amount: number;
		contractLineItem: {
			__typename?: "ContractLineItem";
			id: string;
			service: { __typename?: "Service"; id: string; name: string } | null;
			discount: { __typename?: "Discount"; id: string; name: string } | null;
		};
		invoice: { __typename?: "Invoice"; id: string; name: string; dueDate: string };
	};
};

export type LanguageCheckUniqueNameQueryVariables = Exact<{
	ignoreID?: InputMaybe<Scalars["ID"]["input"]>;
	name: Scalars["String"]["input"];
}>;

export type LanguageCheckUniqueNameQuery = {
	__typename?: "Query";
	languageConnection: { __typename?: "LanguageConnection"; totalCount: number };
};

export type LanguageCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<LanguageFilterInput> | LanguageFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<LanguageOrder>;
}>;

export type LanguageCountQuery = {
	__typename?: "Query";
	languageConnection: { __typename?: "LanguageConnection"; totalCount: number };
};

export type LanguageCreateMutationVariables = Exact<{
	input: LanguageCreateInput;
}>;

export type LanguageCreateMutation = {
	__typename?: "Mutation";
	createLanguage: {
		__typename?: "Language";
		id: string;
		name: string;
		enrollmentApplicationStudents: Array<{ __typename?: "EnrollmentApplicationStudent"; id: string; name: string }>;
		people: Array<{ __typename?: "Person"; id: string; name: string; publicName: string }>;
	};
};

export type LanguageDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type LanguageDeleteMutation = { __typename?: "Mutation"; deleteLanguage: boolean };

export type LanguageDetailFragment = {
	__typename?: "Language";
	id: string;
	name: string;
	enrollmentApplicationStudents: Array<{ __typename?: "EnrollmentApplicationStudent"; id: string; name: string }>;
	people: Array<{ __typename?: "Person"; id: string; name: string; publicName: string }>;
};

export type LanguageDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type LanguageDetailQuery = {
	__typename?: "Query";
	language: {
		__typename?: "Language";
		id: string;
		name: string;
		enrollmentApplicationStudents: Array<{ __typename?: "EnrollmentApplicationStudent"; id: string; name: string }>;
		people: Array<{ __typename?: "Person"; id: string; name: string; publicName: string }>;
	};
};

export type LanguageIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<LanguageFilterInput> | LanguageFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<LanguageOrder>;
}>;

export type LanguageIndexQuery = {
	__typename?: "Query";
	languageConnection: {
		__typename?: "LanguageConnection";
		edges: Array<{ __typename?: "LanguageEdge"; node: { __typename?: "Language"; id: string; name: string } }>;
	};
};

export type LanguageNameFragment = { __typename?: "Language"; name: string };

export type LanguageNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type LanguageNameQuery = {
	__typename?: "Query";
	language: { __typename?: "Language"; id: string; name: string };
};

export type LanguageNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<LanguageFilterInput> | LanguageFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<LanguageOrder>;
}>;

export type LanguageNamesQuery = {
	__typename?: "Query";
	languageConnection: {
		__typename?: "LanguageConnection";
		edges: Array<{ __typename?: "LanguageEdge"; node: { __typename?: "Language"; id: string; name: string } }>;
	};
};

export type LanguagePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<LanguageFilterInput> | LanguageFilterInput>;
	order?: InputMaybe<LanguageOrder>;
}>;

export type LanguagePaginationQuery = {
	__typename?: "Query";
	languageConnection: {
		__typename?: "LanguageConnection";
		totalCount: number;
		edges: Array<{ __typename?: "LanguageEdge"; cursor: string }>;
	};
};

export type LanguageSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<LanguageFilterInput> | LanguageFilterInput>;
	order?: InputMaybe<LanguageOrder>;
}>;

export type LanguageSelectQuery = {
	__typename?: "Query";
	languageConnection: {
		__typename?: "LanguageConnection";
		edges: Array<{ __typename?: "LanguageEdge"; node: { __typename?: "Language"; id: string; name: string } }>;
	};
};

export type LanguageUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: LanguageUpdateInput;
}>;

export type LanguageUpdateMutation = {
	__typename?: "Mutation";
	updateLanguage: {
		__typename?: "Language";
		id: string;
		name: string;
		enrollmentApplicationStudents: Array<{ __typename?: "EnrollmentApplicationStudent"; id: string; name: string }>;
		people: Array<{ __typename?: "Person"; id: string; name: string; publicName: string }>;
	};
};

export type LearningObjectiveCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<LearningObjectiveFilterInput> | LearningObjectiveFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<LearningObjectiveOrder>;
}>;

export type LearningObjectiveCountQuery = {
	__typename?: "Query";
	learningObjectiveConnection: { __typename?: "LearningObjectiveConnection"; totalCount: number };
};

export type LearningObjectiveCreateMutationVariables = Exact<{
	input: LearningObjectiveCreateInput;
}>;

export type LearningObjectiveCreateMutation = {
	__typename?: "Mutation";
	createLearningObjective: {
		__typename?: "LearningObjective";
		id: string;
		name: string;
		description: string;
		learningObjectiveCategory: { __typename?: "LearningObjectiveCategory"; id: string; name: string };
	};
};

export type LearningObjectiveDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type LearningObjectiveDeleteMutation = { __typename?: "Mutation"; deleteLearningObjective: boolean };

export type LearningObjectiveDetailFragment = {
	__typename?: "LearningObjective";
	id: string;
	name: string;
	description: string;
	learningObjectiveCategory: { __typename?: "LearningObjectiveCategory"; id: string; name: string };
};

export type LearningObjectiveDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type LearningObjectiveDetailQuery = {
	__typename?: "Query";
	learningObjective: {
		__typename?: "LearningObjective";
		id: string;
		name: string;
		description: string;
		learningObjectiveCategory: { __typename?: "LearningObjectiveCategory"; id: string; name: string };
	};
};

export type LearningObjectiveIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<LearningObjectiveFilterInput> | LearningObjectiveFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<LearningObjectiveOrder>;
}>;

export type LearningObjectiveIndexQuery = {
	__typename?: "Query";
	learningObjectiveConnection: {
		__typename?: "LearningObjectiveConnection";
		edges: Array<{
			__typename?: "LearningObjectiveEdge";
			node: { __typename?: "LearningObjective"; id: string; name: string; description: string };
		}>;
	};
};

export type LearningObjectiveNameFragment = { __typename?: "LearningObjective"; name: string };

export type LearningObjectiveNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type LearningObjectiveNameQuery = {
	__typename?: "Query";
	learningObjective: { __typename?: "LearningObjective"; id: string; name: string };
};

export type LearningObjectiveNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<LearningObjectiveFilterInput> | LearningObjectiveFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<LearningObjectiveOrder>;
}>;

export type LearningObjectiveNamesQuery = {
	__typename?: "Query";
	learningObjectiveConnection: {
		__typename?: "LearningObjectiveConnection";
		edges: Array<{
			__typename?: "LearningObjectiveEdge";
			node: { __typename?: "LearningObjective"; id: string; name: string };
		}>;
	};
};

export type LearningObjectivePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<LearningObjectiveFilterInput> | LearningObjectiveFilterInput>;
	order?: InputMaybe<LearningObjectiveOrder>;
}>;

export type LearningObjectivePaginationQuery = {
	__typename?: "Query";
	learningObjectiveConnection: {
		__typename?: "LearningObjectiveConnection";
		totalCount: number;
		edges: Array<{ __typename?: "LearningObjectiveEdge"; cursor: string }>;
	};
};

export type LearningObjectiveSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<LearningObjectiveFilterInput> | LearningObjectiveFilterInput>;
	order?: InputMaybe<LearningObjectiveOrder>;
}>;

export type LearningObjectiveSelectQuery = {
	__typename?: "Query";
	learningObjectiveConnection: {
		__typename?: "LearningObjectiveConnection";
		edges: Array<{
			__typename?: "LearningObjectiveEdge";
			node: { __typename?: "LearningObjective"; id: string; name: string };
		}>;
	};
};

export type LearningObjectiveUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: LearningObjectiveUpdateInput;
}>;

export type LearningObjectiveUpdateMutation = {
	__typename?: "Mutation";
	updateLearningObjective: {
		__typename?: "LearningObjective";
		id: string;
		name: string;
		description: string;
		learningObjectiveCategory: { __typename?: "LearningObjectiveCategory"; id: string; name: string };
	};
};

export type LearningObjectiveCategoryCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<LearningObjectiveCategoryFilterInput> | LearningObjectiveCategoryFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<LearningObjectiveCategoryOrder>;
}>;

export type LearningObjectiveCategoryCountQuery = {
	__typename?: "Query";
	learningObjectiveCategoryConnection: { __typename?: "LearningObjectiveCategoryConnection"; totalCount: number };
};

export type LearningObjectiveCategoryCreateMutationVariables = Exact<{
	input: LearningObjectiveCategoryCreateInput;
}>;

export type LearningObjectiveCategoryCreateMutation = {
	__typename?: "Mutation";
	createLearningObjectiveCategory: {
		__typename?: "LearningObjectiveCategory";
		id: string;
		name: string;
		markingSystem: { __typename?: "MarkingSystem"; id: string; name: string } | null;
	};
};

export type LearningObjectiveCategoryDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type LearningObjectiveCategoryDeleteMutation = {
	__typename?: "Mutation";
	deleteLearningObjectiveCategory: boolean;
};

export type LearningObjectiveCategoryDetailFragment = {
	__typename?: "LearningObjectiveCategory";
	id: string;
	name: string;
	markingSystem: { __typename?: "MarkingSystem"; id: string; name: string } | null;
};

export type LearningObjectiveCategoryDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type LearningObjectiveCategoryDetailQuery = {
	__typename?: "Query";
	learningObjectiveCategory: {
		__typename?: "LearningObjectiveCategory";
		id: string;
		name: string;
		markingSystem: { __typename?: "MarkingSystem"; id: string; name: string } | null;
	};
};

export type LearningObjectiveCategoryIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<LearningObjectiveCategoryFilterInput> | LearningObjectiveCategoryFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<LearningObjectiveCategoryOrder>;
}>;

export type LearningObjectiveCategoryIndexQuery = {
	__typename?: "Query";
	learningObjectiveCategoryConnection: {
		__typename?: "LearningObjectiveCategoryConnection";
		edges: Array<{
			__typename?: "LearningObjectiveCategoryEdge";
			node: { __typename?: "LearningObjectiveCategory"; id: string; name: string };
		}>;
	};
};

export type LearningObjectiveCategoryNameFragment = { __typename?: "LearningObjectiveCategory"; name: string };

export type LearningObjectiveCategoryNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type LearningObjectiveCategoryNameQuery = {
	__typename?: "Query";
	learningObjectiveCategory: { __typename?: "LearningObjectiveCategory"; id: string; name: string };
};

export type LearningObjectiveCategoryNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<LearningObjectiveCategoryFilterInput> | LearningObjectiveCategoryFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<LearningObjectiveCategoryOrder>;
}>;

export type LearningObjectiveCategoryNamesQuery = {
	__typename?: "Query";
	learningObjectiveCategoryConnection: {
		__typename?: "LearningObjectiveCategoryConnection";
		edges: Array<{
			__typename?: "LearningObjectiveCategoryEdge";
			node: { __typename?: "LearningObjectiveCategory"; id: string; name: string };
		}>;
	};
};

export type LearningObjectiveCategoryPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<LearningObjectiveCategoryFilterInput> | LearningObjectiveCategoryFilterInput>;
	order?: InputMaybe<LearningObjectiveCategoryOrder>;
}>;

export type LearningObjectiveCategoryPaginationQuery = {
	__typename?: "Query";
	learningObjectiveCategoryConnection: {
		__typename?: "LearningObjectiveCategoryConnection";
		totalCount: number;
		edges: Array<{ __typename?: "LearningObjectiveCategoryEdge"; cursor: string }>;
	};
};

export type LearningObjectiveCategorySelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<LearningObjectiveCategoryFilterInput> | LearningObjectiveCategoryFilterInput>;
	order?: InputMaybe<LearningObjectiveCategoryOrder>;
}>;

export type LearningObjectiveCategorySelectQuery = {
	__typename?: "Query";
	learningObjectiveCategoryConnection: {
		__typename?: "LearningObjectiveCategoryConnection";
		edges: Array<{
			__typename?: "LearningObjectiveCategoryEdge";
			node: { __typename?: "LearningObjectiveCategory"; id: string; name: string };
		}>;
	};
};

export type LearningObjectiveCategoryUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: LearningObjectiveCategoryUpdateInput;
}>;

export type LearningObjectiveCategoryUpdateMutation = {
	__typename?: "Mutation";
	updateLearningObjectiveCategory: {
		__typename?: "LearningObjectiveCategory";
		id: string;
		name: string;
		markingSystem: { __typename?: "MarkingSystem"; id: string; name: string } | null;
	};
};

export type LoginRecordCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<LoginRecordFilterInput> | LoginRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<LoginRecordOrder>;
}>;

export type LoginRecordCountQuery = {
	__typename?: "Query";
	loginRecordConnection: { __typename?: "LoginRecordConnection"; totalCount: number };
};

export type LoginRecordDetailFragment = {
	__typename?: "LoginRecord";
	id: string;
	createdAt: string;
	userEmail: string;
	wasBlocked: boolean;
	wasSuccessful: boolean;
	isTrusted: boolean;
	session: { __typename?: "Session"; id: string } | null;
	user: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	} | null;
};

export type LoginRecordDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type LoginRecordDetailQuery = {
	__typename?: "Query";
	loginRecord: {
		__typename?: "LoginRecord";
		id: string;
		createdAt: string;
		userEmail: string;
		wasBlocked: boolean;
		wasSuccessful: boolean;
		isTrusted: boolean;
		session: { __typename?: "Session"; id: string } | null;
		user: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
	};
};

export type LoginRecordIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<LoginRecordFilterInput> | LoginRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<LoginRecordOrder>;
}>;

export type LoginRecordIndexQuery = {
	__typename?: "Query";
	loginRecordConnection: {
		__typename?: "LoginRecordConnection";
		edges: Array<{
			__typename?: "LoginRecordEdge";
			node: {
				__typename?: "LoginRecord";
				id: string;
				createdAt: string;
				userEmail: string;
				wasBlocked: boolean;
				wasSuccessful: boolean;
				isTrusted: boolean;
			};
		}>;
	};
};

export type LoginRecordNameFragment = { __typename?: "LoginRecord"; id: string };

export type LoginRecordNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type LoginRecordNameQuery = { __typename?: "Query"; loginRecord: { __typename?: "LoginRecord"; id: string } };

export type LoginRecordNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<LoginRecordFilterInput> | LoginRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<LoginRecordOrder>;
}>;

export type LoginRecordNamesQuery = {
	__typename?: "Query";
	loginRecordConnection: {
		__typename?: "LoginRecordConnection";
		edges: Array<{ __typename?: "LoginRecordEdge"; node: { __typename?: "LoginRecord"; id: string } }>;
	};
};

export type LoginRecordPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<LoginRecordFilterInput> | LoginRecordFilterInput>;
	order?: InputMaybe<LoginRecordOrder>;
}>;

export type LoginRecordPaginationQuery = {
	__typename?: "Query";
	loginRecordConnection: {
		__typename?: "LoginRecordConnection";
		totalCount: number;
		edges: Array<{ __typename?: "LoginRecordEdge"; cursor: string }>;
	};
};

export type LoginRecordSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<LoginRecordFilterInput> | LoginRecordFilterInput>;
	order?: InputMaybe<LoginRecordOrder>;
}>;

export type LoginRecordSelectQuery = {
	__typename?: "Query";
	loginRecordConnection: {
		__typename?: "LoginRecordConnection";
		edges: Array<{ __typename?: "LoginRecordEdge"; node: { __typename?: "LoginRecord"; id: string } }>;
	};
};

export type MFAFactorCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<MFAFactorFilterInput> | MFAFactorFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MFAFactorOrder>;
}>;

export type MFAFactorCountQuery = {
	__typename?: "Query";
	mfaFactorConnection: { __typename?: "MFAFactorConnection"; totalCount: number };
};

export type MFAFactorDetailFragment = {
	__typename?: "MFAFactor";
	id: string;
	createdAt: string;
	count: number;
	isApp: boolean;
	email: string;
	sms: string;
	isVerified: boolean;
	user: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	};
};

export type MFAFactorDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MFAFactorDetailQuery = {
	__typename?: "Query";
	mfaFactor: {
		__typename?: "MFAFactor";
		id: string;
		createdAt: string;
		count: number;
		isApp: boolean;
		email: string;
		sms: string;
		isVerified: boolean;
		user: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
	};
};

export type MFAFactorIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<MFAFactorFilterInput> | MFAFactorFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MFAFactorOrder>;
}>;

export type MFAFactorIndexQuery = {
	__typename?: "Query";
	mfaFactorConnection: {
		__typename?: "MFAFactorConnection";
		edges: Array<{
			__typename?: "MFAFactorEdge";
			node: {
				__typename?: "MFAFactor";
				id: string;
				createdAt: string;
				count: number;
				isApp: boolean;
				email: string;
				sms: string;
				isVerified: boolean;
			};
		}>;
	};
};

export type MFAFactorNameFragment = { __typename?: "MFAFactor"; email: string };

export type MFAFactorNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MFAFactorNameQuery = {
	__typename?: "Query";
	mfaFactor: { __typename?: "MFAFactor"; id: string; email: string };
};

export type MFAFactorNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<MFAFactorFilterInput> | MFAFactorFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MFAFactorOrder>;
}>;

export type MFAFactorNamesQuery = {
	__typename?: "Query";
	mfaFactorConnection: {
		__typename?: "MFAFactorConnection";
		edges: Array<{ __typename?: "MFAFactorEdge"; node: { __typename?: "MFAFactor"; id: string; email: string } }>;
	};
};

export type MFAFactorPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<MFAFactorFilterInput> | MFAFactorFilterInput>;
	order?: InputMaybe<MFAFactorOrder>;
}>;

export type MFAFactorPaginationQuery = {
	__typename?: "Query";
	mfaFactorConnection: {
		__typename?: "MFAFactorConnection";
		totalCount: number;
		edges: Array<{ __typename?: "MFAFactorEdge"; cursor: string }>;
	};
};

export type MFAFactorSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<MFAFactorFilterInput> | MFAFactorFilterInput>;
	order?: InputMaybe<MFAFactorOrder>;
}>;

export type MFAFactorSelectQuery = {
	__typename?: "Query";
	mfaFactorConnection: {
		__typename?: "MFAFactorConnection";
		edges: Array<{ __typename?: "MFAFactorEdge"; node: { __typename?: "MFAFactor"; id: string; email: string } }>;
	};
};

export type MFAInvalidOTPAttemptCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput> | MFAInvalidOTPAttemptFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MFAInvalidOTPAttemptOrder>;
}>;

export type MFAInvalidOTPAttemptCountQuery = {
	__typename?: "Query";
	mfaInvalidOTPAttemptConnection: { __typename?: "MFAInvalidOTPAttemptConnection"; totalCount: number };
};

export type MFAInvalidOTPAttemptDetailFragment = {
	__typename?: "MFAInvalidOTPAttempt";
	id: string;
	createdAt: string;
	session: { __typename?: "Session"; id: string } | null;
	user: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	};
};

export type MFAInvalidOTPAttemptDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MFAInvalidOTPAttemptDetailQuery = {
	__typename?: "Query";
	mfaInvalidOTPAttempt: {
		__typename?: "MFAInvalidOTPAttempt";
		id: string;
		createdAt: string;
		session: { __typename?: "Session"; id: string } | null;
		user: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
	};
};

export type MFAInvalidOTPAttemptIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput> | MFAInvalidOTPAttemptFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MFAInvalidOTPAttemptOrder>;
}>;

export type MFAInvalidOTPAttemptIndexQuery = {
	__typename?: "Query";
	mfaInvalidOTPAttemptConnection: {
		__typename?: "MFAInvalidOTPAttemptConnection";
		edges: Array<{
			__typename?: "MFAInvalidOTPAttemptEdge";
			node: { __typename?: "MFAInvalidOTPAttempt"; id: string; createdAt: string };
		}>;
	};
};

export type MFAInvalidOTPAttemptNameFragment = { __typename?: "MFAInvalidOTPAttempt"; id: string };

export type MFAInvalidOTPAttemptNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MFAInvalidOTPAttemptNameQuery = {
	__typename?: "Query";
	mfaInvalidOTPAttempt: { __typename?: "MFAInvalidOTPAttempt"; id: string };
};

export type MFAInvalidOTPAttemptNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput> | MFAInvalidOTPAttemptFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MFAInvalidOTPAttemptOrder>;
}>;

export type MFAInvalidOTPAttemptNamesQuery = {
	__typename?: "Query";
	mfaInvalidOTPAttemptConnection: {
		__typename?: "MFAInvalidOTPAttemptConnection";
		edges: Array<{
			__typename?: "MFAInvalidOTPAttemptEdge";
			node: { __typename?: "MFAInvalidOTPAttempt"; id: string };
		}>;
	};
};

export type MFAInvalidOTPAttemptPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput> | MFAInvalidOTPAttemptFilterInput>;
	order?: InputMaybe<MFAInvalidOTPAttemptOrder>;
}>;

export type MFAInvalidOTPAttemptPaginationQuery = {
	__typename?: "Query";
	mfaInvalidOTPAttemptConnection: {
		__typename?: "MFAInvalidOTPAttemptConnection";
		totalCount: number;
		edges: Array<{ __typename?: "MFAInvalidOTPAttemptEdge"; cursor: string }>;
	};
};

export type MFAInvalidOTPAttemptSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput> | MFAInvalidOTPAttemptFilterInput>;
	order?: InputMaybe<MFAInvalidOTPAttemptOrder>;
}>;

export type MFAInvalidOTPAttemptSelectQuery = {
	__typename?: "Query";
	mfaInvalidOTPAttemptConnection: {
		__typename?: "MFAInvalidOTPAttemptConnection";
		edges: Array<{
			__typename?: "MFAInvalidOTPAttemptEdge";
			node: { __typename?: "MFAInvalidOTPAttempt"; id: string };
		}>;
	};
};

export type MarkValueCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<MarkValueFilterInput> | MarkValueFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MarkValueOrder>;
}>;

export type MarkValueCountQuery = {
	__typename?: "Query";
	markValueConnection: { __typename?: "MarkValueConnection"; totalCount: number };
};

export type MarkValueCreateMutationVariables = Exact<{
	input: MarkValueCreateInput;
}>;

export type MarkValueCreateMutation = {
	__typename?: "Mutation";
	createMarkValue: {
		__typename?: "MarkValue";
		id: string;
		name: string;
		shortName: string;
		value: number;
		isNull: boolean;
		description: string;
		markingSystem: { __typename?: "MarkingSystem"; id: string; name: string };
	};
};

export type MarkValueDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MarkValueDeleteMutation = { __typename?: "Mutation"; deleteMarkValue: boolean };

export type MarkValueDetailFragment = {
	__typename?: "MarkValue";
	id: string;
	name: string;
	shortName: string;
	value: number;
	isNull: boolean;
	description: string;
	markingSystem: { __typename?: "MarkingSystem"; id: string; name: string };
};

export type MarkValueDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MarkValueDetailQuery = {
	__typename?: "Query";
	markValue: {
		__typename?: "MarkValue";
		id: string;
		name: string;
		shortName: string;
		value: number;
		isNull: boolean;
		description: string;
		markingSystem: { __typename?: "MarkingSystem"; id: string; name: string };
	};
};

export type MarkValueIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<MarkValueFilterInput> | MarkValueFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MarkValueOrder>;
}>;

export type MarkValueIndexQuery = {
	__typename?: "Query";
	markValueConnection: {
		__typename?: "MarkValueConnection";
		edges: Array<{
			__typename?: "MarkValueEdge";
			node: {
				__typename?: "MarkValue";
				id: string;
				name: string;
				shortName: string;
				value: number;
				isNull: boolean;
				description: string;
			};
		}>;
	};
};

export type MarkValueNameFragment = { __typename?: "MarkValue"; name: string };

export type MarkValueNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MarkValueNameQuery = {
	__typename?: "Query";
	markValue: { __typename?: "MarkValue"; id: string; name: string };
};

export type MarkValueNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<MarkValueFilterInput> | MarkValueFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MarkValueOrder>;
}>;

export type MarkValueNamesQuery = {
	__typename?: "Query";
	markValueConnection: {
		__typename?: "MarkValueConnection";
		edges: Array<{ __typename?: "MarkValueEdge"; node: { __typename?: "MarkValue"; id: string; name: string } }>;
	};
};

export type MarkValuePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<MarkValueFilterInput> | MarkValueFilterInput>;
	order?: InputMaybe<MarkValueOrder>;
}>;

export type MarkValuePaginationQuery = {
	__typename?: "Query";
	markValueConnection: {
		__typename?: "MarkValueConnection";
		totalCount: number;
		edges: Array<{ __typename?: "MarkValueEdge"; cursor: string }>;
	};
};

export type MarkValueSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<MarkValueFilterInput> | MarkValueFilterInput>;
	order?: InputMaybe<MarkValueOrder>;
}>;

export type MarkValueSelectQuery = {
	__typename?: "Query";
	markValueConnection: {
		__typename?: "MarkValueConnection";
		edges: Array<{ __typename?: "MarkValueEdge"; node: { __typename?: "MarkValue"; id: string; name: string } }>;
	};
};

export type MarkValueUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: MarkValueUpdateInput;
}>;

export type MarkValueUpdateMutation = {
	__typename?: "Mutation";
	updateMarkValue: {
		__typename?: "MarkValue";
		id: string;
		name: string;
		shortName: string;
		value: number;
		isNull: boolean;
		description: string;
		markingSystem: { __typename?: "MarkingSystem"; id: string; name: string };
	};
};

export type MarkingSystemCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<MarkingSystemFilterInput> | MarkingSystemFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MarkingSystemOrder>;
}>;

export type MarkingSystemCountQuery = {
	__typename?: "Query";
	markingSystemConnection: { __typename?: "MarkingSystemConnection"; totalCount: number };
};

export type MarkingSystemCreateMutationVariables = Exact<{
	input: MarkingSystemCreateInput;
}>;

export type MarkingSystemCreateMutation = {
	__typename?: "Mutation";
	createMarkingSystem: { __typename?: "MarkingSystem"; id: string; name: string; description: string };
};

export type MarkingSystemDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MarkingSystemDeleteMutation = { __typename?: "Mutation"; deleteMarkingSystem: boolean };

export type MarkingSystemDetailFragment = {
	__typename?: "MarkingSystem";
	id: string;
	name: string;
	description: string;
};

export type MarkingSystemDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MarkingSystemDetailQuery = {
	__typename?: "Query";
	markingSystem: { __typename?: "MarkingSystem"; id: string; name: string; description: string };
};

export type MarkingSystemIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<MarkingSystemFilterInput> | MarkingSystemFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MarkingSystemOrder>;
}>;

export type MarkingSystemIndexQuery = {
	__typename?: "Query";
	markingSystemConnection: {
		__typename?: "MarkingSystemConnection";
		edges: Array<{
			__typename?: "MarkingSystemEdge";
			node: { __typename?: "MarkingSystem"; id: string; name: string; description: string };
		}>;
	};
};

export type MarkingSystemNameFragment = { __typename?: "MarkingSystem"; name: string };

export type MarkingSystemNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MarkingSystemNameQuery = {
	__typename?: "Query";
	markingSystem: { __typename?: "MarkingSystem"; id: string; name: string };
};

export type MarkingSystemNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<MarkingSystemFilterInput> | MarkingSystemFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MarkingSystemOrder>;
}>;

export type MarkingSystemNamesQuery = {
	__typename?: "Query";
	markingSystemConnection: {
		__typename?: "MarkingSystemConnection";
		edges: Array<{
			__typename?: "MarkingSystemEdge";
			node: { __typename?: "MarkingSystem"; id: string; name: string };
		}>;
	};
};

export type MarkingSystemPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<MarkingSystemFilterInput> | MarkingSystemFilterInput>;
	order?: InputMaybe<MarkingSystemOrder>;
}>;

export type MarkingSystemPaginationQuery = {
	__typename?: "Query";
	markingSystemConnection: {
		__typename?: "MarkingSystemConnection";
		totalCount: number;
		edges: Array<{ __typename?: "MarkingSystemEdge"; cursor: string }>;
	};
};

export type MarkingSystemSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<MarkingSystemFilterInput> | MarkingSystemFilterInput>;
	order?: InputMaybe<MarkingSystemOrder>;
}>;

export type MarkingSystemSelectQuery = {
	__typename?: "Query";
	markingSystemConnection: {
		__typename?: "MarkingSystemConnection";
		edges: Array<{
			__typename?: "MarkingSystemEdge";
			node: { __typename?: "MarkingSystem"; id: string; name: string };
		}>;
	};
};

export type MarkingSystemUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: MarkingSystemUpdateInput;
}>;

export type MarkingSystemUpdateMutation = {
	__typename?: "Mutation";
	updateMarkingSystem: { __typename?: "MarkingSystem"; id: string; name: string; description: string };
};

export type MediaAttachmentCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<MediaAttachmentFilterInput> | MediaAttachmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MediaAttachmentOrder>;
}>;

export type MediaAttachmentCountQuery = {
	__typename?: "Query";
	mediaAttachmentConnection: { __typename?: "MediaAttachmentConnection"; totalCount: number };
};

export type MediaAttachmentCreateMutationVariables = Exact<{
	input: MediaAttachmentCreateInput;
}>;

export type MediaAttachmentCreateMutation = {
	__typename?: "Mutation";
	createMediaAttachment: {
		__typename?: "MediaAttachment";
		id: string;
		displayOrder: number;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
		announcement: { __typename?: "Announcement"; id: string; title: string } | null;
		calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string } | null;
		courseAssessment: { __typename?: "CourseAssessment"; id: string; name: string } | null;
		courseAssessmentSubmission: { __typename?: "CourseAssessmentSubmission"; id: string } | null;
		message: { __typename?: "Message"; id: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
		studentMedicalEvent: { __typename?: "StudentMedicalEvent"; id: string } | null;
		studentNote: { __typename?: "StudentNote"; id: string } | null;
		taggedPeople: Array<{ __typename?: "Person"; id: string; name: string; publicName: string }>;
	};
};

export type MediaAttachmentDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MediaAttachmentDeleteMutation = { __typename?: "Mutation"; deleteMediaAttachment: boolean };

export type MediaAttachmentDetailFragment = {
	__typename?: "MediaAttachment";
	id: string;
	displayOrder: number;
	title: string;
	description: string;
	isFile: boolean;
	fileURL: string;
	fileKey: string;
	fileContentType: string;
	linkURL: string;
	announcement: { __typename?: "Announcement"; id: string; title: string } | null;
	calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string } | null;
	courseAssessment: { __typename?: "CourseAssessment"; id: string; name: string } | null;
	courseAssessmentSubmission: { __typename?: "CourseAssessmentSubmission"; id: string } | null;
	message: { __typename?: "Message"; id: string } | null;
	post: { __typename?: "Post"; id: string; title: string } | null;
	studentMedicalEvent: { __typename?: "StudentMedicalEvent"; id: string } | null;
	studentNote: { __typename?: "StudentNote"; id: string } | null;
	taggedPeople: Array<{ __typename?: "Person"; id: string; name: string; publicName: string }>;
};

export type MediaAttachmentDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MediaAttachmentDetailQuery = {
	__typename?: "Query";
	mediaAttachment: {
		__typename?: "MediaAttachment";
		id: string;
		displayOrder: number;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
		announcement: { __typename?: "Announcement"; id: string; title: string } | null;
		calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string } | null;
		courseAssessment: { __typename?: "CourseAssessment"; id: string; name: string } | null;
		courseAssessmentSubmission: { __typename?: "CourseAssessmentSubmission"; id: string } | null;
		message: { __typename?: "Message"; id: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
		studentMedicalEvent: { __typename?: "StudentMedicalEvent"; id: string } | null;
		studentNote: { __typename?: "StudentNote"; id: string } | null;
		taggedPeople: Array<{ __typename?: "Person"; id: string; name: string; publicName: string }>;
	};
};

export type MediaAttachmentIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<MediaAttachmentFilterInput> | MediaAttachmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MediaAttachmentOrder>;
}>;

export type MediaAttachmentIndexQuery = {
	__typename?: "Query";
	mediaAttachmentConnection: {
		__typename?: "MediaAttachmentConnection";
		edges: Array<{
			__typename?: "MediaAttachmentEdge";
			node: {
				__typename?: "MediaAttachment";
				id: string;
				displayOrder: number;
				title: string;
				description: string;
				isFile: boolean;
				fileURL: string;
				fileContentType: string;
				linkURL: string;
			};
		}>;
	};
};

export type MediaAttachmentNameFragment = { __typename?: "MediaAttachment"; title: string };

export type MediaAttachmentNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MediaAttachmentNameQuery = {
	__typename?: "Query";
	mediaAttachment: { __typename?: "MediaAttachment"; id: string; title: string };
};

export type MediaAttachmentNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<MediaAttachmentFilterInput> | MediaAttachmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MediaAttachmentOrder>;
}>;

export type MediaAttachmentNamesQuery = {
	__typename?: "Query";
	mediaAttachmentConnection: {
		__typename?: "MediaAttachmentConnection";
		edges: Array<{
			__typename?: "MediaAttachmentEdge";
			node: { __typename?: "MediaAttachment"; id: string; title: string };
		}>;
	};
};

export type MediaAttachmentPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<MediaAttachmentFilterInput> | MediaAttachmentFilterInput>;
	order?: InputMaybe<MediaAttachmentOrder>;
}>;

export type MediaAttachmentPaginationQuery = {
	__typename?: "Query";
	mediaAttachmentConnection: {
		__typename?: "MediaAttachmentConnection";
		totalCount: number;
		edges: Array<{ __typename?: "MediaAttachmentEdge"; cursor: string }>;
	};
};

export type MediaAttachmentSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<MediaAttachmentFilterInput> | MediaAttachmentFilterInput>;
	order?: InputMaybe<MediaAttachmentOrder>;
}>;

export type MediaAttachmentSelectQuery = {
	__typename?: "Query";
	mediaAttachmentConnection: {
		__typename?: "MediaAttachmentConnection";
		edges: Array<{
			__typename?: "MediaAttachmentEdge";
			node: { __typename?: "MediaAttachment"; id: string; title: string };
		}>;
	};
};

export type MediaAttachmentSocialItemsQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MediaAttachmentSocialItemsQuery = {
	__typename?: "Query";
	mediaAttachment: {
		__typename?: "MediaAttachment";
		id: string;
		socialReactions: Array<{
			__typename?: "SocialReaction";
			id: string;
			reaction: SocialReactionReaction;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				email: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			};
		}>;
		socialComments: Array<{
			__typename?: "SocialComment";
			id: string;
			body: string;
			createdAt: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				email: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
			};
		}>;
	};
};

export type MediaAttachmentUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: MediaAttachmentUpdateInput;
}>;

export type MediaAttachmentUpdateMutation = {
	__typename?: "Mutation";
	updateMediaAttachment: {
		__typename?: "MediaAttachment";
		id: string;
		displayOrder: number;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
		announcement: { __typename?: "Announcement"; id: string; title: string } | null;
		calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string } | null;
		courseAssessment: { __typename?: "CourseAssessment"; id: string; name: string } | null;
		courseAssessmentSubmission: { __typename?: "CourseAssessmentSubmission"; id: string } | null;
		message: { __typename?: "Message"; id: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
		studentMedicalEvent: { __typename?: "StudentMedicalEvent"; id: string } | null;
		studentNote: { __typename?: "StudentNote"; id: string } | null;
		taggedPeople: Array<{ __typename?: "Person"; id: string; name: string; publicName: string }>;
	};
};

export type MediaAttachmentVisualCatalogListQueryVariables = Exact<{
	filters?: InputMaybe<Array<MediaAttachmentFilterInput> | MediaAttachmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MediaAttachmentOrder>;
}>;

export type MediaAttachmentVisualCatalogListQuery = {
	__typename?: "Query";
	mediaAttachmentConnection: {
		__typename?: "MediaAttachmentConnection";
		pageInfo: { __typename?: "PageInfo"; endCursor: string | null; hasNextPage: boolean };
		edges: Array<{
			__typename?: "MediaAttachmentEdge";
			node: {
				__typename?: "MediaAttachment";
				id: string;
				title: string;
				description: string;
				fileURL: string;
				fileKey: string;
				fileContentType: string;
				postID: string | null;
			};
		}>;
	};
};

export type MedicalConditionCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<MedicalConditionFilterInput> | MedicalConditionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MedicalConditionOrder>;
}>;

export type MedicalConditionCountQuery = {
	__typename?: "Query";
	medicalConditionConnection: { __typename?: "MedicalConditionConnection"; totalCount: number };
};

export type MedicalConditionCreateMutationVariables = Exact<{
	input: MedicalConditionCreateInput;
}>;

export type MedicalConditionCreateMutation = {
	__typename?: "Mutation";
	createMedicalCondition: {
		__typename?: "MedicalCondition";
		id: string;
		name: string;
		conditionType: MedicalConditionConditionType;
		description: string;
	};
};

export type MedicalConditionDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MedicalConditionDeleteMutation = { __typename?: "Mutation"; deleteMedicalCondition: boolean };

export type MedicalConditionDetailFragment = {
	__typename?: "MedicalCondition";
	id: string;
	name: string;
	conditionType: MedicalConditionConditionType;
	description: string;
};

export type MedicalConditionDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MedicalConditionDetailQuery = {
	__typename?: "Query";
	medicalCondition: {
		__typename?: "MedicalCondition";
		id: string;
		name: string;
		conditionType: MedicalConditionConditionType;
		description: string;
	};
};

export type MedicalConditionIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<MedicalConditionFilterInput> | MedicalConditionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MedicalConditionOrder>;
}>;

export type MedicalConditionIndexQuery = {
	__typename?: "Query";
	medicalConditionConnection: {
		__typename?: "MedicalConditionConnection";
		edges: Array<{
			__typename?: "MedicalConditionEdge";
			node: {
				__typename?: "MedicalCondition";
				id: string;
				name: string;
				conditionType: MedicalConditionConditionType;
				description: string;
			};
		}>;
	};
};

export type MedicalConditionNameFragment = { __typename?: "MedicalCondition"; name: string };

export type MedicalConditionNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MedicalConditionNameQuery = {
	__typename?: "Query";
	medicalCondition: { __typename?: "MedicalCondition"; id: string; name: string };
};

export type MedicalConditionNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<MedicalConditionFilterInput> | MedicalConditionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MedicalConditionOrder>;
}>;

export type MedicalConditionNamesQuery = {
	__typename?: "Query";
	medicalConditionConnection: {
		__typename?: "MedicalConditionConnection";
		edges: Array<{
			__typename?: "MedicalConditionEdge";
			node: { __typename?: "MedicalCondition"; id: string; name: string };
		}>;
	};
};

export type MedicalConditionPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<MedicalConditionFilterInput> | MedicalConditionFilterInput>;
	order?: InputMaybe<MedicalConditionOrder>;
}>;

export type MedicalConditionPaginationQuery = {
	__typename?: "Query";
	medicalConditionConnection: {
		__typename?: "MedicalConditionConnection";
		totalCount: number;
		edges: Array<{ __typename?: "MedicalConditionEdge"; cursor: string }>;
	};
};

export type MedicalConditionSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<MedicalConditionFilterInput> | MedicalConditionFilterInput>;
	order?: InputMaybe<MedicalConditionOrder>;
}>;

export type MedicalConditionSelectQuery = {
	__typename?: "Query";
	medicalConditionConnection: {
		__typename?: "MedicalConditionConnection";
		edges: Array<{
			__typename?: "MedicalConditionEdge";
			node: { __typename?: "MedicalCondition"; id: string; name: string };
		}>;
	};
};

export type MedicalConditionUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: MedicalConditionUpdateInput;
}>;

export type MedicalConditionUpdateMutation = {
	__typename?: "Mutation";
	updateMedicalCondition: {
		__typename?: "MedicalCondition";
		id: string;
		name: string;
		conditionType: MedicalConditionConditionType;
		description: string;
	};
};

export type MedicationCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<MedicationFilterInput> | MedicationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MedicationOrder>;
}>;

export type MedicationCountQuery = {
	__typename?: "Query";
	medicationConnection: { __typename?: "MedicationConnection"; totalCount: number };
};

export type MedicationCreateMutationVariables = Exact<{
	input: MedicationCreateInput;
}>;

export type MedicationCreateMutation = {
	__typename?: "Mutation";
	createMedication: {
		__typename?: "Medication";
		id: string;
		name: string;
		isPrescription: boolean;
		description: string;
	};
};

export type MedicationDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MedicationDeleteMutation = { __typename?: "Mutation"; deleteMedication: boolean };

export type MedicationDetailFragment = {
	__typename?: "Medication";
	id: string;
	name: string;
	isPrescription: boolean;
	description: string;
};

export type MedicationDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MedicationDetailQuery = {
	__typename?: "Query";
	medication: { __typename?: "Medication"; id: string; name: string; isPrescription: boolean; description: string };
};

export type MedicationIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<MedicationFilterInput> | MedicationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MedicationOrder>;
}>;

export type MedicationIndexQuery = {
	__typename?: "Query";
	medicationConnection: {
		__typename?: "MedicationConnection";
		edges: Array<{
			__typename?: "MedicationEdge";
			node: { __typename?: "Medication"; id: string; name: string; isPrescription: boolean; description: string };
		}>;
	};
};

export type MedicationNameFragment = { __typename?: "Medication"; name: string };

export type MedicationNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MedicationNameQuery = {
	__typename?: "Query";
	medication: { __typename?: "Medication"; id: string; name: string };
};

export type MedicationNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<MedicationFilterInput> | MedicationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MedicationOrder>;
}>;

export type MedicationNamesQuery = {
	__typename?: "Query";
	medicationConnection: {
		__typename?: "MedicationConnection";
		edges: Array<{ __typename?: "MedicationEdge"; node: { __typename?: "Medication"; id: string; name: string } }>;
	};
};

export type MedicationPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<MedicationFilterInput> | MedicationFilterInput>;
	order?: InputMaybe<MedicationOrder>;
}>;

export type MedicationPaginationQuery = {
	__typename?: "Query";
	medicationConnection: {
		__typename?: "MedicationConnection";
		totalCount: number;
		edges: Array<{ __typename?: "MedicationEdge"; cursor: string }>;
	};
};

export type MedicationSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<MedicationFilterInput> | MedicationFilterInput>;
	order?: InputMaybe<MedicationOrder>;
}>;

export type MedicationSelectQuery = {
	__typename?: "Query";
	medicationConnection: {
		__typename?: "MedicationConnection";
		edges: Array<{ __typename?: "MedicationEdge"; node: { __typename?: "Medication"; id: string; name: string } }>;
	};
};

export type MedicationUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: MedicationUpdateInput;
}>;

export type MedicationUpdateMutation = {
	__typename?: "Mutation";
	updateMedication: {
		__typename?: "Medication";
		id: string;
		name: string;
		isPrescription: boolean;
		description: string;
	};
};

export type MessageCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageFilterInput> | MessageFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageOrder>;
}>;

export type MessageCountQuery = {
	__typename?: "Query";
	messageConnection: { __typename?: "MessageConnection"; totalCount: number };
};

export type MessageCreateMutationVariables = Exact<{
	input: MessageCreateInput;
}>;

export type MessageCreateMutation = {
	__typename?: "Mutation";
	createMessage: {
		__typename?: "Message";
		id: string;
		createdAt: string;
		body: string;
		lastEditedAt: string | null;
		isRemoved: boolean;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
		messageGroup: {
			__typename?: "MessageGroup";
			id: string;
			customName: string;
			users: Array<{
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		};
	};
};

export type MessageDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageDeleteMutation = { __typename?: "Mutation"; deleteMessage: boolean };

export type MessageDetailFragment = {
	__typename?: "Message";
	id: string;
	createdAt: string;
	body: string;
	lastEditedAt: string | null;
	isRemoved: boolean;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	};
	messageGroup: {
		__typename?: "MessageGroup";
		id: string;
		customName: string;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		}>;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
	};
};

export type MessageDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageDetailQuery = {
	__typename?: "Query";
	message: {
		__typename?: "Message";
		id: string;
		createdAt: string;
		body: string;
		lastEditedAt: string | null;
		isRemoved: boolean;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
		messageGroup: {
			__typename?: "MessageGroup";
			id: string;
			customName: string;
			users: Array<{
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		};
	};
};

export type MessageDetailForEditQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageDetailForEditQuery = {
	__typename?: "Query";
	message: {
		__typename?: "Message";
		id: string;
		body: string;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
			taggedPeople: Array<{
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
			}>;
		}>;
	};
};

export type MessageInMessageGroupFragment = {
	__typename?: "Message";
	id: string;
	createdAt: string;
	body: string;
	lastEditedAt: string | null;
	isRemoved: boolean;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
			employee: { __typename?: "Employee"; id: string; role: EmployeeRole } | null;
		} | null;
	};
	mediaAttachments: Array<{
		__typename?: "MediaAttachment";
		id: string;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
	}>;
	messageTopic: {
		__typename?: "MessageTopic";
		id: string;
		students: Array<{
			__typename?: "Student";
			id: string;
			graduationYear: number | null;
			yearsFromGraduation: number;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
	} | null;
};

export type MessageGroupMessagesListQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageFilterInput> | MessageFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageOrder>;
}>;

export type MessageGroupMessagesListQuery = {
	__typename?: "Query";
	messageConnection: {
		__typename?: "MessageConnection";
		pageInfo: {
			__typename?: "PageInfo";
			startCursor: string | null;
			endCursor: string | null;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
		edges: Array<{
			__typename?: "MessageEdge";
			node: {
				__typename?: "Message";
				id: string;
				createdAt: string;
				body: string;
				lastEditedAt: string | null;
				isRemoved: boolean;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
						employee: { __typename?: "Employee"; id: string; role: EmployeeRole } | null;
					} | null;
				};
				mediaAttachments: Array<{
					__typename?: "MediaAttachment";
					id: string;
					title: string;
					description: string;
					isFile: boolean;
					fileURL: string;
					fileKey: string;
					fileContentType: string;
					linkURL: string;
				}>;
				messageTopic: {
					__typename?: "MessageTopic";
					id: string;
					students: Array<{
						__typename?: "Student";
						id: string;
						graduationYear: number | null;
						yearsFromGraduation: number;
						person: {
							__typename?: "Person";
							id: string;
							name: string;
							publicName: string;
							imageURL: string;
							imageKey: string;
							imageContentType: string;
						};
					}>;
				} | null;
			};
		}>;
	};
};

export type MessageGroupLatestTopicQueryVariables = Exact<{
	messageGroupID: Scalars["ID"]["input"];
}>;

export type MessageGroupLatestTopicQuery = {
	__typename?: "Query";
	messageConnection: {
		__typename?: "MessageConnection";
		edges: Array<{
			__typename?: "MessageEdge";
			node: {
				__typename?: "Message";
				id: string;
				createdAt: string;
				body: string;
				lastEditedAt: string | null;
				isRemoved: boolean;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
						employee: { __typename?: "Employee"; id: string; role: EmployeeRole } | null;
					} | null;
				};
				mediaAttachments: Array<{
					__typename?: "MediaAttachment";
					id: string;
					title: string;
					description: string;
					isFile: boolean;
					fileURL: string;
					fileKey: string;
					fileContentType: string;
					linkURL: string;
				}>;
				messageTopic: {
					__typename?: "MessageTopic";
					id: string;
					students: Array<{
						__typename?: "Student";
						id: string;
						graduationYear: number | null;
						yearsFromGraduation: number;
						person: {
							__typename?: "Person";
							id: string;
							name: string;
							publicName: string;
							imageURL: string;
							imageKey: string;
							imageContentType: string;
						};
					}>;
				} | null;
			};
		}>;
	};
};

export type MessageIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageFilterInput> | MessageFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageOrder>;
}>;

export type MessageIndexQuery = {
	__typename?: "Query";
	messageConnection: {
		__typename?: "MessageConnection";
		edges: Array<{
			__typename?: "MessageEdge";
			node: {
				__typename?: "Message";
				id: string;
				createdAt: string;
				body: string;
				lastEditedAt: string | null;
				isRemoved: boolean;
			};
		}>;
	};
};

export type LatestMessagesAndMessageGroupsListQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageFilterInput> | MessageFilterInput>;
	archived?: InputMaybe<Scalars["Boolean"]["input"]>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageOrder>;
}>;

export type LatestMessagesAndMessageGroupsListQuery = {
	__typename?: "Query";
	latestMessageByGroupConnection: {
		__typename?: "MessageConnection";
		edges: Array<{
			__typename?: "MessageEdge";
			node: {
				__typename?: "Message";
				id: string;
				createdAt: string;
				body: string;
				isRemoved: boolean;
				messageGroup: {
					__typename?: "MessageGroup";
					id: string;
					customName: string;
					users: Array<{
						__typename?: "User";
						id: string;
						email: string;
						isCurrent: boolean;
						messageAvailabilityPeriods: Array<{
							__typename?: "MessageAvailabilityPeriod";
							id: string;
							dayOfWeek: number;
							startTimeMinutes: number;
							endTimeMinutes: number;
						}>;
						person: {
							__typename?: "Person";
							id: string;
							name: string;
							publicName: string;
							imageURL: string;
							imageKey: string;
							imageContentType: string;
						} | null;
					}>;
					userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
				};
				mediaAttachments: Array<{ __typename?: "MediaAttachment"; id: string }>;
			};
		}>;
	};
};

export type MessageNameFragment = { __typename?: "Message"; id: string };

export type MessageNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageNameQuery = { __typename?: "Query"; message: { __typename?: "Message"; id: string } };

export type MessageNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageFilterInput> | MessageFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageOrder>;
}>;

export type MessageNamesQuery = {
	__typename?: "Query";
	messageConnection: {
		__typename?: "MessageConnection";
		edges: Array<{ __typename?: "MessageEdge"; node: { __typename?: "Message"; id: string } }>;
	};
};

export type UnreadMessagesCountQueryVariables = Exact<{ [key: string]: never }>;

export type UnreadMessagesCountQuery = { __typename?: "Query"; unreadMessagesCount: number };

export type MessagePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageFilterInput> | MessageFilterInput>;
	order?: InputMaybe<MessageOrder>;
}>;

export type MessagePaginationQuery = {
	__typename?: "Query";
	messageConnection: {
		__typename?: "MessageConnection";
		totalCount: number;
		edges: Array<{ __typename?: "MessageEdge"; cursor: string }>;
	};
};

export type MessageSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageFilterInput> | MessageFilterInput>;
	order?: InputMaybe<MessageOrder>;
}>;

export type MessageSelectQuery = {
	__typename?: "Query";
	messageConnection: {
		__typename?: "MessageConnection";
		edges: Array<{ __typename?: "MessageEdge"; node: { __typename?: "Message"; id: string } }>;
	};
};

export type MessageUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: MessageUpdateInput;
}>;

export type MessageUpdateMutation = {
	__typename?: "Mutation";
	updateMessage: {
		__typename?: "Message";
		id: string;
		createdAt: string;
		body: string;
		lastEditedAt: string | null;
		isRemoved: boolean;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
		messageGroup: {
			__typename?: "MessageGroup";
			id: string;
			customName: string;
			users: Array<{
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		};
	};
};

export type MessageAvailabilityPeriodCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageAvailabilityPeriodFilterInput> | MessageAvailabilityPeriodFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageAvailabilityPeriodOrder>;
}>;

export type MessageAvailabilityPeriodCountQuery = {
	__typename?: "Query";
	messageAvailabilityPeriodConnection: { __typename?: "MessageAvailabilityPeriodConnection"; totalCount: number };
};

export type MessageAvailabilityPeriodCreateMutationVariables = Exact<{
	input: MessageAvailabilityPeriodCreateInput;
}>;

export type MessageAvailabilityPeriodCreateMutation = {
	__typename?: "Mutation";
	createMessageAvailabilityPeriod: {
		__typename?: "MessageAvailabilityPeriod";
		id: string;
		dayOfWeek: number;
		startTimeMinutes: number;
		endTimeMinutes: number;
		user: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
	};
};

export type MessageAvailabilityPeriodDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageAvailabilityPeriodDeleteMutation = {
	__typename?: "Mutation";
	deleteMessageAvailabilityPeriod: boolean;
};

export type MessageAvailabilityPeriodDetailFragment = {
	__typename?: "MessageAvailabilityPeriod";
	id: string;
	dayOfWeek: number;
	startTimeMinutes: number;
	endTimeMinutes: number;
	user: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	};
};

export type MessageAvailabilityPeriodDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageAvailabilityPeriodDetailQuery = {
	__typename?: "Query";
	messageAvailabilityPeriod: {
		__typename?: "MessageAvailabilityPeriod";
		id: string;
		dayOfWeek: number;
		startTimeMinutes: number;
		endTimeMinutes: number;
		user: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
	};
};

export type MessageAvailabilityPeriodIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageAvailabilityPeriodFilterInput> | MessageAvailabilityPeriodFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageAvailabilityPeriodOrder>;
}>;

export type MessageAvailabilityPeriodIndexQuery = {
	__typename?: "Query";
	messageAvailabilityPeriodConnection: {
		__typename?: "MessageAvailabilityPeriodConnection";
		edges: Array<{
			__typename?: "MessageAvailabilityPeriodEdge";
			node: {
				__typename?: "MessageAvailabilityPeriod";
				id: string;
				dayOfWeek: number;
				startTimeMinutes: number;
				endTimeMinutes: number;
			};
		}>;
	};
};

export type MessageAvailabilityPeriodNameFragment = { __typename?: "MessageAvailabilityPeriod"; id: string };

export type MessageAvailabilityPeriodNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageAvailabilityPeriodNameQuery = {
	__typename?: "Query";
	messageAvailabilityPeriod: { __typename?: "MessageAvailabilityPeriod"; id: string };
};

export type MessageAvailabilityPeriodNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageAvailabilityPeriodFilterInput> | MessageAvailabilityPeriodFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageAvailabilityPeriodOrder>;
}>;

export type MessageAvailabilityPeriodNamesQuery = {
	__typename?: "Query";
	messageAvailabilityPeriodConnection: {
		__typename?: "MessageAvailabilityPeriodConnection";
		edges: Array<{
			__typename?: "MessageAvailabilityPeriodEdge";
			node: { __typename?: "MessageAvailabilityPeriod"; id: string };
		}>;
	};
};

export type MessageAvailabilityPeriodPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageAvailabilityPeriodFilterInput> | MessageAvailabilityPeriodFilterInput>;
	order?: InputMaybe<MessageAvailabilityPeriodOrder>;
}>;

export type MessageAvailabilityPeriodPaginationQuery = {
	__typename?: "Query";
	messageAvailabilityPeriodConnection: {
		__typename?: "MessageAvailabilityPeriodConnection";
		totalCount: number;
		edges: Array<{ __typename?: "MessageAvailabilityPeriodEdge"; cursor: string }>;
	};
};

export type MessageAvailabilityPeriodSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageAvailabilityPeriodFilterInput> | MessageAvailabilityPeriodFilterInput>;
	order?: InputMaybe<MessageAvailabilityPeriodOrder>;
}>;

export type MessageAvailabilityPeriodSelectQuery = {
	__typename?: "Query";
	messageAvailabilityPeriodConnection: {
		__typename?: "MessageAvailabilityPeriodConnection";
		edges: Array<{
			__typename?: "MessageAvailabilityPeriodEdge";
			node: { __typename?: "MessageAvailabilityPeriod"; id: string };
		}>;
	};
};

export type MessageAvailabilityPeriodTimingFragment = {
	__typename?: "MessageAvailabilityPeriod";
	dayOfWeek: number;
	startTimeMinutes: number;
	endTimeMinutes: number;
};

export type MessageAvailabilityPeriodUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: MessageAvailabilityPeriodUpdateInput;
}>;

export type MessageAvailabilityPeriodUpdateMutation = {
	__typename?: "Mutation";
	updateMessageAvailabilityPeriod: {
		__typename?: "MessageAvailabilityPeriod";
		id: string;
		dayOfWeek: number;
		startTimeMinutes: number;
		endTimeMinutes: number;
		user: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
	};
};

export type CanViewerSendMessageInGroupQueryVariables = Exact<{
	messageGroupID: Scalars["ID"]["input"];
}>;

export type CanViewerSendMessageInGroupQuery = {
	__typename?: "Query";
	viewer: {
		__typename?: "User";
		id: string;
		person: { __typename?: "Person"; id: string; publicNameFormat: PersonPublicNameFormat } | null;
	};
	messageGroup: {
		__typename?: "MessageGroup";
		id: string;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; members: Array<{ __typename?: "User"; id: string }> }>;
		users: Array<{ __typename?: "User"; id: string }>;
	};
};

export type MessageGroupCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupFilterInput> | MessageGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageGroupOrder>;
}>;

export type MessageGroupCountQuery = {
	__typename?: "Query";
	messageGroupConnection: { __typename?: "MessageGroupConnection"; totalCount: number };
};

export type MessageGroupCreateOrUpdateMutationVariables = Exact<{
	input: MessageGroupCreateInput;
}>;

export type MessageGroupCreateOrUpdateMutation = {
	__typename?: "Mutation";
	createOrUpdateMessageGroup: {
		__typename?: "MessageGroup";
		id: string;
		customName: string;
		isOneOnOne: boolean;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
				employee: { __typename?: "Employee"; id: string; jobTitle: string } | null;
				guardian: { __typename?: "Guardian"; id: string } | null;
			} | null;
			messageAvailabilityPeriods: Array<{
				__typename?: "MessageAvailabilityPeriod";
				id: string;
				dayOfWeek: number;
				startTimeMinutes: number;
				endTimeMinutes: number;
			}>;
		}>;
	};
};

export type MessageGroupCreateMutationVariables = Exact<{
	input: MessageGroupCreateInput;
}>;

export type MessageGroupCreateMutation = {
	__typename?: "Mutation";
	createMessageGroup: {
		__typename?: "MessageGroup";
		id: string;
		customName: string;
		isOneOnOne: boolean;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
				employee: { __typename?: "Employee"; id: string; jobTitle: string } | null;
				guardian: { __typename?: "Guardian"; id: string } | null;
			} | null;
			messageAvailabilityPeriods: Array<{
				__typename?: "MessageAvailabilityPeriod";
				id: string;
				dayOfWeek: number;
				startTimeMinutes: number;
				endTimeMinutes: number;
			}>;
		}>;
	};
};

export type MessageGroupDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageGroupDeleteMutation = { __typename?: "Mutation"; deleteMessageGroup: boolean };

export type MessageGroupDetailFragment = {
	__typename?: "MessageGroup";
	id: string;
	customName: string;
	isOneOnOne: boolean;
	userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
	users: Array<{
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
			employee: { __typename?: "Employee"; id: string; jobTitle: string } | null;
			guardian: { __typename?: "Guardian"; id: string } | null;
		} | null;
		messageAvailabilityPeriods: Array<{
			__typename?: "MessageAvailabilityPeriod";
			id: string;
			dayOfWeek: number;
			startTimeMinutes: number;
			endTimeMinutes: number;
		}>;
	}>;
};

export type MessageGroupDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageGroupDetailQuery = {
	__typename?: "Query";
	messageGroup: {
		__typename?: "MessageGroup";
		id: string;
		customName: string;
		isOneOnOne: boolean;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
				employee: { __typename?: "Employee"; id: string; jobTitle: string } | null;
				guardian: { __typename?: "Guardian"; id: string } | null;
			} | null;
			messageAvailabilityPeriods: Array<{
				__typename?: "MessageAvailabilityPeriod";
				id: string;
				dayOfWeek: number;
				startTimeMinutes: number;
				endTimeMinutes: number;
			}>;
		}>;
	};
};

export type MessageGroupIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupFilterInput> | MessageGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageGroupOrder>;
}>;

export type MessageGroupIndexQuery = {
	__typename?: "Query";
	messageGroupConnection: {
		__typename?: "MessageGroupConnection";
		edges: Array<{
			__typename?: "MessageGroupEdge";
			node: { __typename?: "MessageGroup"; id: string; customName: string; isOneOnOne: boolean };
		}>;
	};
};

export type MessageGroupNameFragment = {
	__typename?: "MessageGroup";
	customName: string;
	users: Array<{
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	}>;
	userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
};

export type MessageGroupNameAndImageFragment = {
	__typename?: "MessageGroup";
	customName: string;
	users: Array<{
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
	}>;
	userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
};

export type MessageGroupNameImageAndAvailabilityFragment = {
	__typename?: "MessageGroup";
	customName: string;
	users: Array<{
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		messageAvailabilityPeriods: Array<{
			__typename?: "MessageAvailabilityPeriod";
			id: string;
			dayOfWeek: number;
			startTimeMinutes: number;
			endTimeMinutes: number;
		}>;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
	}>;
	userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
};

export type MessageGroupNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageGroupNameQuery = {
	__typename?: "Query";
	messageGroup: {
		__typename?: "MessageGroup";
		id: string;
		customName: string;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		}>;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
	};
};

export type MessageGroupNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupFilterInput> | MessageGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageGroupOrder>;
}>;

export type MessageGroupNamesQuery = {
	__typename?: "Query";
	messageGroupConnection: {
		__typename?: "MessageGroupConnection";
		edges: Array<{
			__typename?: "MessageGroupEdge";
			node: {
				__typename?: "MessageGroup";
				id: string;
				customName: string;
				users: Array<{
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
				}>;
				userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
			};
		}>;
	};
};

export type MessageGroupPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupFilterInput> | MessageGroupFilterInput>;
	order?: InputMaybe<MessageGroupOrder>;
}>;

export type MessageGroupPaginationQuery = {
	__typename?: "Query";
	messageGroupConnection: {
		__typename?: "MessageGroupConnection";
		totalCount: number;
		edges: Array<{ __typename?: "MessageGroupEdge"; cursor: string }>;
	};
};

export type MessageGroupUserFragment = {
	__typename?: "User";
	id: string;
	email: string;
	isCurrent: boolean;
	person: {
		__typename?: "Person";
		id: string;
		name: string;
		publicName: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		employee: { __typename?: "Employee"; id: string; jobTitle: string } | null;
		guardian: { __typename?: "Guardian"; id: string } | null;
	} | null;
	messageAvailabilityPeriods: Array<{
		__typename?: "MessageAvailabilityPeriod";
		id: string;
		dayOfWeek: number;
		startTimeMinutes: number;
		endTimeMinutes: number;
	}>;
};

export type MessageGroupUserGroupParticipantUserListQueryVariables = Exact<{
	messageGroupID: Scalars["ID"]["input"];
}>;

export type MessageGroupUserGroupParticipantUserListQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
					employee: { __typename?: "Employee"; id: string; jobTitle: string } | null;
					guardian: { __typename?: "Guardian"; id: string } | null;
				} | null;
				messageAvailabilityPeriods: Array<{
					__typename?: "MessageAvailabilityPeriod";
					id: string;
					dayOfWeek: number;
					startTimeMinutes: number;
					endTimeMinutes: number;
				}>;
			};
		}>;
	};
};

export type UserForMessagesFragment = {
	__typename?: "User";
	id: string;
	email: string;
	isCurrent: boolean;
	person: {
		__typename?: "Person";
		id: string;
		name: string;
		publicName: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		employee: { __typename?: "Employee"; id: string; role: EmployeeRole; jobTitle: string } | null;
		guardian: {
			__typename?: "Guardian";
			id: string;
			relationships: Array<{ __typename?: "Relationship"; id: string; studentID: string }>;
		} | null;
	} | null;
	messageAvailabilityPeriods: Array<{
		__typename?: "MessageAvailabilityPeriod";
		id: string;
		dayOfWeek: number;
		startTimeMinutes: number;
		endTimeMinutes: number;
	}>;
};

export type UserListForMessagesQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type UserListForMessagesQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
					employee: { __typename?: "Employee"; id: string; role: EmployeeRole; jobTitle: string } | null;
					guardian: {
						__typename?: "Guardian";
						id: string;
						relationships: Array<{ __typename?: "Relationship"; id: string; studentID: string }>;
					} | null;
				} | null;
				messageAvailabilityPeriods: Array<{
					__typename?: "MessageAvailabilityPeriod";
					id: string;
					dayOfWeek: number;
					startTimeMinutes: number;
					endTimeMinutes: number;
				}>;
			};
		}>;
	};
};

export type UserAndUserGroupListForMessagesQueryVariables = Exact<{
	userFilters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	userGroupFilters?: InputMaybe<Array<UserGroupFilterInput> | UserGroupFilterInput>;
}>;

export type UserAndUserGroupListForMessagesQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
					employee: { __typename?: "Employee"; id: string; role: EmployeeRole; jobTitle: string } | null;
					guardian: {
						__typename?: "Guardian";
						id: string;
						relationships: Array<{ __typename?: "Relationship"; id: string; studentID: string }>;
					} | null;
				} | null;
				messageAvailabilityPeriods: Array<{
					__typename?: "MessageAvailabilityPeriod";
					id: string;
					dayOfWeek: number;
					startTimeMinutes: number;
					endTimeMinutes: number;
				}>;
			};
		}>;
	};
	userGroupConnection: {
		__typename?: "UserGroupConnection";
		edges: Array<{
			__typename?: "UserGroupEdge";
			node: {
				__typename?: "UserGroup";
				id: string;
				name: string;
				color: string;
				members: Array<{ __typename?: "User"; id: string; isCurrent: boolean }>;
			};
		}>;
	};
};

export type StudentGuardianAndTeachersForMessagesQueryVariables = Exact<{
	studentIDs: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
	date: Scalars["Date"]["input"];
}>;

export type StudentGuardianAndTeachersForMessagesQuery = {
	__typename?: "Query";
	guardianConnection: {
		__typename?: "GuardianConnection";
		edges: Array<{ __typename?: "GuardianEdge"; node: { __typename?: "Guardian"; id: string } }>;
	};
	employeeConnection: {
		__typename?: "EmployeeConnection";
		edges: Array<{ __typename?: "EmployeeEdge"; node: { __typename?: "Employee"; id: string } }>;
	};
};

export type MessageGroupSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupFilterInput> | MessageGroupFilterInput>;
	order?: InputMaybe<MessageGroupOrder>;
}>;

export type MessageGroupSelectQuery = {
	__typename?: "Query";
	messageGroupConnection: {
		__typename?: "MessageGroupConnection";
		edges: Array<{
			__typename?: "MessageGroupEdge";
			node: {
				__typename?: "MessageGroup";
				id: string;
				customName: string;
				users: Array<{
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
				}>;
				userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
			};
		}>;
	};
};

export type MessageGroupUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: MessageGroupUpdateInput;
}>;

export type MessageGroupUpdateMutation = {
	__typename?: "Mutation";
	updateMessageGroup: {
		__typename?: "MessageGroup";
		id: string;
		customName: string;
		isOneOnOne: boolean;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
				employee: { __typename?: "Employee"; id: string; jobTitle: string } | null;
				guardian: { __typename?: "Guardian"; id: string } | null;
			} | null;
			messageAvailabilityPeriods: Array<{
				__typename?: "MessageAvailabilityPeriod";
				id: string;
				dayOfWeek: number;
				startTimeMinutes: number;
				endTimeMinutes: number;
			}>;
		}>;
	};
};

export type MessageGroupArchivePointCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupArchivePointFilterInput> | MessageGroupArchivePointFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageGroupArchivePointOrder>;
}>;

export type MessageGroupArchivePointCountQuery = {
	__typename?: "Query";
	messageGroupArchivePointConnection: { __typename?: "MessageGroupArchivePointConnection"; totalCount: number };
};

export type MessageGroupArchivePointCreateMutationVariables = Exact<{
	input: MessageGroupArchivePointCreateInput;
}>;

export type MessageGroupArchivePointCreateMutation = {
	__typename?: "Mutation";
	createMessageGroupArchivePoint: {
		__typename?: "MessageGroupArchivePoint";
		id: string;
		createdAt: string;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
		messageGroup: {
			__typename?: "MessageGroup";
			id: string;
			customName: string;
			users: Array<{
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		};
	};
};

export type MessageGroupArchivePointDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageGroupArchivePointDeleteMutation = {
	__typename?: "Mutation";
	deleteMessageGroupArchivePoint: boolean;
};

export type MessageGroupArchivePointDetailFragment = {
	__typename?: "MessageGroupArchivePoint";
	id: string;
	createdAt: string;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	};
	messageGroup: {
		__typename?: "MessageGroup";
		id: string;
		customName: string;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		}>;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
	};
};

export type MessageGroupArchivePointDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageGroupArchivePointDetailQuery = {
	__typename?: "Query";
	messageGroupArchivePoint: {
		__typename?: "MessageGroupArchivePoint";
		id: string;
		createdAt: string;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
		messageGroup: {
			__typename?: "MessageGroup";
			id: string;
			customName: string;
			users: Array<{
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		};
	};
};

export type MessageGroupArchivePointIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupArchivePointFilterInput> | MessageGroupArchivePointFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageGroupArchivePointOrder>;
}>;

export type MessageGroupArchivePointIndexQuery = {
	__typename?: "Query";
	messageGroupArchivePointConnection: {
		__typename?: "MessageGroupArchivePointConnection";
		edges: Array<{
			__typename?: "MessageGroupArchivePointEdge";
			node: { __typename?: "MessageGroupArchivePoint"; id: string; createdAt: string };
		}>;
	};
};

export type MessageGroupArchivePointListInMessageGroupQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupArchivePointFilterInput> | MessageGroupArchivePointFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageGroupArchivePointOrder>;
}>;

export type MessageGroupArchivePointListInMessageGroupQuery = {
	__typename?: "Query";
	messageGroupArchivePointConnection: {
		__typename?: "MessageGroupArchivePointConnection";
		edges: Array<{
			__typename?: "MessageGroupArchivePointEdge";
			node: {
				__typename?: "MessageGroupArchivePoint";
				id: string;
				createdAt: string;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					} | null;
				};
			};
		}>;
	};
};

export type MessageGroupArchivePointNameFragment = { __typename?: "MessageGroupArchivePoint"; id: string };

export type MessageGroupArchivePointNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageGroupArchivePointNameQuery = {
	__typename?: "Query";
	messageGroupArchivePoint: { __typename?: "MessageGroupArchivePoint"; id: string };
};

export type MessageGroupArchivePointNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupArchivePointFilterInput> | MessageGroupArchivePointFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageGroupArchivePointOrder>;
}>;

export type MessageGroupArchivePointNamesQuery = {
	__typename?: "Query";
	messageGroupArchivePointConnection: {
		__typename?: "MessageGroupArchivePointConnection";
		edges: Array<{
			__typename?: "MessageGroupArchivePointEdge";
			node: { __typename?: "MessageGroupArchivePoint"; id: string };
		}>;
	};
};

export type MessageGroupArchivePointPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupArchivePointFilterInput> | MessageGroupArchivePointFilterInput>;
	order?: InputMaybe<MessageGroupArchivePointOrder>;
}>;

export type MessageGroupArchivePointPaginationQuery = {
	__typename?: "Query";
	messageGroupArchivePointConnection: {
		__typename?: "MessageGroupArchivePointConnection";
		totalCount: number;
		edges: Array<{ __typename?: "MessageGroupArchivePointEdge"; cursor: string }>;
	};
};

export type MessageGroupArchivePointSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupArchivePointFilterInput> | MessageGroupArchivePointFilterInput>;
	order?: InputMaybe<MessageGroupArchivePointOrder>;
}>;

export type MessageGroupArchivePointSelectQuery = {
	__typename?: "Query";
	messageGroupArchivePointConnection: {
		__typename?: "MessageGroupArchivePointConnection";
		edges: Array<{
			__typename?: "MessageGroupArchivePointEdge";
			node: { __typename?: "MessageGroupArchivePoint"; id: string };
		}>;
	};
};

export type MessageGroupArchivePointUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: MessageGroupArchivePointUpdateInput;
}>;

export type MessageGroupArchivePointUpdateMutation = {
	__typename?: "Mutation";
	updateMessageGroupArchivePoint: {
		__typename?: "MessageGroupArchivePoint";
		id: string;
		createdAt: string;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
		messageGroup: {
			__typename?: "MessageGroup";
			id: string;
			customName: string;
			users: Array<{
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		};
	};
};

export type MessageTopicCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageTopicFilterInput> | MessageTopicFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageTopicOrder>;
}>;

export type MessageTopicCountQuery = {
	__typename?: "Query";
	messageTopicConnection: { __typename?: "MessageTopicConnection"; totalCount: number };
};

export type MessageTopicCreateMutationVariables = Exact<{
	input: MessageTopicCreateInput;
}>;

export type MessageTopicCreateMutation = {
	__typename?: "Mutation";
	createMessageTopic: {
		__typename?: "MessageTopic";
		id: string;
		name: string;
		message: { __typename?: "Message"; id: string };
		students: Array<{
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		}>;
	};
};

export type MessageTopicDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageTopicDeleteMutation = { __typename?: "Mutation"; deleteMessageTopic: boolean };

export type MessageTopicDetailFragment = {
	__typename?: "MessageTopic";
	id: string;
	name: string;
	message: { __typename?: "Message"; id: string };
	students: Array<{
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	}>;
};

export type MessageTopicDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageTopicDetailQuery = {
	__typename?: "Query";
	messageTopic: {
		__typename?: "MessageTopic";
		id: string;
		name: string;
		message: { __typename?: "Message"; id: string };
		students: Array<{
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		}>;
	};
};

export type MessageTopicIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageTopicFilterInput> | MessageTopicFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageTopicOrder>;
}>;

export type MessageTopicIndexQuery = {
	__typename?: "Query";
	messageTopicConnection: {
		__typename?: "MessageTopicConnection";
		edges: Array<{ __typename?: "MessageTopicEdge"; node: { __typename?: "MessageTopic"; id: string; name: string } }>;
	};
};

export type MessageTopicNameFragment = { __typename?: "MessageTopic"; name: string };

export type MessageTopicNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageTopicNameQuery = {
	__typename?: "Query";
	messageTopic: { __typename?: "MessageTopic"; id: string; name: string };
};

export type MessageTopicNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageTopicFilterInput> | MessageTopicFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageTopicOrder>;
}>;

export type MessageTopicNamesQuery = {
	__typename?: "Query";
	messageTopicConnection: {
		__typename?: "MessageTopicConnection";
		edges: Array<{ __typename?: "MessageTopicEdge"; node: { __typename?: "MessageTopic"; id: string; name: string } }>;
	};
};

export type MessageTopicPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageTopicFilterInput> | MessageTopicFilterInput>;
	order?: InputMaybe<MessageTopicOrder>;
}>;

export type MessageTopicPaginationQuery = {
	__typename?: "Query";
	messageTopicConnection: {
		__typename?: "MessageTopicConnection";
		totalCount: number;
		edges: Array<{ __typename?: "MessageTopicEdge"; cursor: string }>;
	};
};

export type MessageTopicSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageTopicFilterInput> | MessageTopicFilterInput>;
	order?: InputMaybe<MessageTopicOrder>;
}>;

export type MessageTopicSelectQuery = {
	__typename?: "Query";
	messageTopicConnection: {
		__typename?: "MessageTopicConnection";
		edges: Array<{ __typename?: "MessageTopicEdge"; node: { __typename?: "MessageTopic"; id: string; name: string } }>;
	};
};

export type MessageTopicUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: MessageTopicUpdateInput;
}>;

export type MessageTopicUpdateMutation = {
	__typename?: "Mutation";
	updateMessageTopic: {
		__typename?: "MessageTopic";
		id: string;
		name: string;
		message: { __typename?: "Message"; id: string };
		students: Array<{
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		}>;
	};
};

export type NewsletterCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<NewsletterFilterInput> | NewsletterFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<NewsletterOrder>;
}>;

export type NewsletterCountQuery = {
	__typename?: "Query";
	newsletterConnection: { __typename?: "NewsletterConnection"; totalCount: number };
};

export type NewsletterCreateMutationVariables = Exact<{
	input: NewsletterCreateInput;
}>;

export type NewsletterCreateMutation = {
	__typename?: "Mutation";
	createNewsletter: {
		__typename?: "Newsletter";
		id: string;
		title: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		body: string;
		releaseAt: string | null;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
		sharingRecord: {
			__typename?: "SharingRecord";
			id: string;
			isPublic: boolean;
			includeEmployees: boolean;
			includeGuardians: boolean;
			includeAllUsersOfPersonTypes: boolean;
			classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
			classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
			courseSections: Array<{
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			}>;
			homeRoomSections: Array<{
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			}>;
		} | null;
	};
};

export type NewsletterDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type NewsletterDeleteMutation = { __typename?: "Mutation"; deleteNewsletter: boolean };

export type NewsletterDetailFragment = {
	__typename?: "Newsletter";
	id: string;
	title: string;
	imageURL: string;
	imageKey: string;
	imageContentType: string;
	body: string;
	releaseAt: string | null;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
	} | null;
	sharingRecord: {
		__typename?: "SharingRecord";
		id: string;
		isPublic: boolean;
		includeEmployees: boolean;
		includeGuardians: boolean;
		includeAllUsersOfPersonTypes: boolean;
		classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
		courseSections: Array<{
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		}>;
		homeRoomSections: Array<{
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		}>;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		}>;
	} | null;
};

export type NewsletterDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type NewsletterDetailQuery = {
	__typename?: "Query";
	newsletter: {
		__typename?: "Newsletter";
		id: string;
		title: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		body: string;
		releaseAt: string | null;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
		sharingRecord: {
			__typename?: "SharingRecord";
			id: string;
			isPublic: boolean;
			includeEmployees: boolean;
			includeGuardians: boolean;
			includeAllUsersOfPersonTypes: boolean;
			classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
			classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
			courseSections: Array<{
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			}>;
			homeRoomSections: Array<{
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			}>;
		} | null;
	};
};

export type NewsletterDisplayListItemFragment = {
	__typename?: "Newsletter";
	id: string;
	title: string;
	imageURL: string;
	imageKey: string;
	imageContentType: string;
	body: string;
	releaseAt: string | null;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
	} | null;
};

export type NewsletterDisplayListQueryVariables = Exact<{
	filters?: InputMaybe<Array<NewsletterFilterInput> | NewsletterFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<NewsletterOrder>;
}>;

export type NewsletterDisplayListQuery = {
	__typename?: "Query";
	newsletterConnection: {
		__typename?: "NewsletterConnection";
		edges: Array<{
			__typename?: "NewsletterEdge";
			node: {
				__typename?: "Newsletter";
				id: string;
				title: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
				body: string;
				releaseAt: string | null;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					} | null;
				} | null;
			};
		}>;
	};
};

export type NewsletterIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<NewsletterFilterInput> | NewsletterFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<NewsletterOrder>;
}>;

export type NewsletterIndexQuery = {
	__typename?: "Query";
	newsletterConnection: {
		__typename?: "NewsletterConnection";
		edges: Array<{
			__typename?: "NewsletterEdge";
			node: {
				__typename?: "Newsletter";
				id: string;
				title: string;
				imageURL: string;
				imageContentType: string;
				body: string;
				releaseAt: string | null;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
				} | null;
			};
		}>;
	};
};

export type NewsletterNameFragment = { __typename?: "Newsletter"; title: string };

export type NewsletterNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type NewsletterNameQuery = {
	__typename?: "Query";
	newsletter: { __typename?: "Newsletter"; id: string; title: string };
};

export type NewsletterNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<NewsletterFilterInput> | NewsletterFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<NewsletterOrder>;
}>;

export type NewsletterNamesQuery = {
	__typename?: "Query";
	newsletterConnection: {
		__typename?: "NewsletterConnection";
		edges: Array<{ __typename?: "NewsletterEdge"; node: { __typename?: "Newsletter"; id: string; title: string } }>;
	};
};

export type NewsletterPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<NewsletterFilterInput> | NewsletterFilterInput>;
	order?: InputMaybe<NewsletterOrder>;
}>;

export type NewsletterPaginationQuery = {
	__typename?: "Query";
	newsletterConnection: {
		__typename?: "NewsletterConnection";
		totalCount: number;
		edges: Array<{ __typename?: "NewsletterEdge"; cursor: string }>;
	};
};

export type NewsletterSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<NewsletterFilterInput> | NewsletterFilterInput>;
	order?: InputMaybe<NewsletterOrder>;
}>;

export type NewsletterSelectQuery = {
	__typename?: "Query";
	newsletterConnection: {
		__typename?: "NewsletterConnection";
		edges: Array<{ __typename?: "NewsletterEdge"; node: { __typename?: "Newsletter"; id: string; title: string } }>;
	};
};

export type NewsletterSocialItemsQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type NewsletterSocialItemsQuery = {
	__typename?: "Query";
	newsletter: {
		__typename?: "Newsletter";
		id: string;
		socialReactions: Array<{
			__typename?: "SocialReaction";
			id: string;
			reaction: SocialReactionReaction;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				email: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			};
		}>;
		socialComments: Array<{
			__typename?: "SocialComment";
			id: string;
			body: string;
			createdAt: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				email: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
			};
		}>;
	};
};

export type NewsletterStatisticsQueryVariables = Exact<{
	filters?: InputMaybe<Array<NewsletterFilterInput> | NewsletterFilterInput>;
}>;

export type NewsletterStatisticsQuery = {
	__typename?: "Query";
	newsletterStatistics: {
		__typename?: "NewsletterStatistics";
		count: number;
		views: number;
		reactions: number;
		comments: number;
	};
};

export type NewsletterUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: NewsletterUpdateInput;
}>;

export type NewsletterUpdateMutation = {
	__typename?: "Mutation";
	updateNewsletter: {
		__typename?: "Newsletter";
		id: string;
		title: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		body: string;
		releaseAt: string | null;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
		sharingRecord: {
			__typename?: "SharingRecord";
			id: string;
			isPublic: boolean;
			includeEmployees: boolean;
			includeGuardians: boolean;
			includeAllUsersOfPersonTypes: boolean;
			classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
			classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
			courseSections: Array<{
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			}>;
			homeRoomSections: Array<{
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			}>;
		} | null;
	};
};

export type PaymentCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<PaymentFilterInput> | PaymentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PaymentOrder>;
}>;

export type PaymentCountQuery = {
	__typename?: "Query";
	paymentConnection: { __typename?: "PaymentConnection"; totalCount: number };
};

export type PaymentCreateMutationVariables = Exact<{
	input: PaymentCreateInput;
}>;

export type PaymentCreateMutation = {
	__typename?: "Mutation";
	createPayment: {
		__typename?: "Payment";
		id: string;
		isCustomPayer: boolean;
		customPayerName: string;
		issueDate: string;
		paymentMethod: PaymentPaymentMethod;
		isInLocalCurrency: boolean;
		localCurrency: string;
		notes: string;
		guardianPayer: {
			__typename?: "Guardian";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
	};
};

export type PaymentDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PaymentDeleteMutation = { __typename?: "Mutation"; deletePayment: boolean };

export type PaymentDetailFragment = {
	__typename?: "Payment";
	id: string;
	isCustomPayer: boolean;
	customPayerName: string;
	issueDate: string;
	paymentMethod: PaymentPaymentMethod;
	isInLocalCurrency: boolean;
	localCurrency: string;
	notes: string;
	guardianPayer: {
		__typename?: "Guardian";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	} | null;
};

export type PaymentDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PaymentDetailQuery = {
	__typename?: "Query";
	payment: {
		__typename?: "Payment";
		id: string;
		isCustomPayer: boolean;
		customPayerName: string;
		issueDate: string;
		paymentMethod: PaymentPaymentMethod;
		isInLocalCurrency: boolean;
		localCurrency: string;
		notes: string;
		guardianPayer: {
			__typename?: "Guardian";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
	};
};

export type PaymentIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<PaymentFilterInput> | PaymentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PaymentOrder>;
}>;

export type PaymentIndexQuery = {
	__typename?: "Query";
	paymentConnection: {
		__typename?: "PaymentConnection";
		edges: Array<{
			__typename?: "PaymentEdge";
			node: {
				__typename?: "Payment";
				id: string;
				isCustomPayer: boolean;
				customPayerName: string;
				issueDate: string;
				paymentMethod: PaymentPaymentMethod;
				isInLocalCurrency: boolean;
				localCurrency: string;
				notes: string;
			};
		}>;
	};
};

export type PaymentNameFragment = { __typename?: "Payment"; id: string };

export type PaymentNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PaymentNameQuery = { __typename?: "Query"; payment: { __typename?: "Payment"; id: string } };

export type PaymentNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<PaymentFilterInput> | PaymentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PaymentOrder>;
}>;

export type PaymentNamesQuery = {
	__typename?: "Query";
	paymentConnection: {
		__typename?: "PaymentConnection";
		edges: Array<{ __typename?: "PaymentEdge"; node: { __typename?: "Payment"; id: string } }>;
	};
};

export type PaymentPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<PaymentFilterInput> | PaymentFilterInput>;
	order?: InputMaybe<PaymentOrder>;
}>;

export type PaymentPaginationQuery = {
	__typename?: "Query";
	paymentConnection: {
		__typename?: "PaymentConnection";
		totalCount: number;
		edges: Array<{ __typename?: "PaymentEdge"; cursor: string }>;
	};
};

export type PaymentSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<PaymentFilterInput> | PaymentFilterInput>;
	order?: InputMaybe<PaymentOrder>;
}>;

export type PaymentSelectQuery = {
	__typename?: "Query";
	paymentConnection: {
		__typename?: "PaymentConnection";
		edges: Array<{ __typename?: "PaymentEdge"; node: { __typename?: "Payment"; id: string } }>;
	};
};

export type PaymentUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: PaymentUpdateInput;
}>;

export type PaymentUpdateMutation = {
	__typename?: "Mutation";
	updatePayment: {
		__typename?: "Payment";
		id: string;
		isCustomPayer: boolean;
		customPayerName: string;
		issueDate: string;
		paymentMethod: PaymentPaymentMethod;
		isInLocalCurrency: boolean;
		localCurrency: string;
		notes: string;
		guardianPayer: {
			__typename?: "Guardian";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
	};
};

export type PaymentLineItemCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<PaymentLineItemFilterInput> | PaymentLineItemFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PaymentLineItemOrder>;
}>;

export type PaymentLineItemCountQuery = {
	__typename?: "Query";
	paymentLineItemConnection: { __typename?: "PaymentLineItemConnection"; totalCount: number };
};

export type PaymentLineItemCreateMutationVariables = Exact<{
	input: PaymentLineItemCreateInput;
}>;

export type PaymentLineItemCreateMutation = {
	__typename?: "Mutation";
	createPaymentLineItem: {
		__typename?: "PaymentLineItem";
		id: string;
		displayOrder: number;
		amount: number;
		localAmount: number | null;
		invoice: { __typename?: "Invoice"; id: string; name: string; dueDate: string };
		payment: { __typename?: "Payment"; id: string };
	};
};

export type PaymentLineItemDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PaymentLineItemDeleteMutation = { __typename?: "Mutation"; deletePaymentLineItem: boolean };

export type PaymentLineItemDetailFragment = {
	__typename?: "PaymentLineItem";
	id: string;
	displayOrder: number;
	amount: number;
	localAmount: number | null;
	invoice: { __typename?: "Invoice"; id: string; name: string; dueDate: string };
	payment: { __typename?: "Payment"; id: string };
};

export type PaymentLineItemDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PaymentLineItemDetailQuery = {
	__typename?: "Query";
	paymentLineItem: {
		__typename?: "PaymentLineItem";
		id: string;
		displayOrder: number;
		amount: number;
		localAmount: number | null;
		invoice: { __typename?: "Invoice"; id: string; name: string; dueDate: string };
		payment: { __typename?: "Payment"; id: string };
	};
};

export type PaymentLineItemIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<PaymentLineItemFilterInput> | PaymentLineItemFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PaymentLineItemOrder>;
}>;

export type PaymentLineItemIndexQuery = {
	__typename?: "Query";
	paymentLineItemConnection: {
		__typename?: "PaymentLineItemConnection";
		edges: Array<{
			__typename?: "PaymentLineItemEdge";
			node: {
				__typename?: "PaymentLineItem";
				id: string;
				displayOrder: number;
				amount: number;
				localAmount: number | null;
			};
		}>;
	};
};

export type PaymentLineItemNameFragment = { __typename?: "PaymentLineItem"; id: string };

export type PaymentLineItemNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PaymentLineItemNameQuery = {
	__typename?: "Query";
	paymentLineItem: { __typename?: "PaymentLineItem"; id: string };
};

export type PaymentLineItemNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<PaymentLineItemFilterInput> | PaymentLineItemFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PaymentLineItemOrder>;
}>;

export type PaymentLineItemNamesQuery = {
	__typename?: "Query";
	paymentLineItemConnection: {
		__typename?: "PaymentLineItemConnection";
		edges: Array<{ __typename?: "PaymentLineItemEdge"; node: { __typename?: "PaymentLineItem"; id: string } }>;
	};
};

export type PaymentLineItemPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<PaymentLineItemFilterInput> | PaymentLineItemFilterInput>;
	order?: InputMaybe<PaymentLineItemOrder>;
}>;

export type PaymentLineItemPaginationQuery = {
	__typename?: "Query";
	paymentLineItemConnection: {
		__typename?: "PaymentLineItemConnection";
		totalCount: number;
		edges: Array<{ __typename?: "PaymentLineItemEdge"; cursor: string }>;
	};
};

export type PaymentLineItemSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<PaymentLineItemFilterInput> | PaymentLineItemFilterInput>;
	order?: InputMaybe<PaymentLineItemOrder>;
}>;

export type PaymentLineItemSelectQuery = {
	__typename?: "Query";
	paymentLineItemConnection: {
		__typename?: "PaymentLineItemConnection";
		edges: Array<{ __typename?: "PaymentLineItemEdge"; node: { __typename?: "PaymentLineItem"; id: string } }>;
	};
};

export type PaymentLineItemUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: PaymentLineItemUpdateInput;
}>;

export type PaymentLineItemUpdateMutation = {
	__typename?: "Mutation";
	updatePaymentLineItem: {
		__typename?: "PaymentLineItem";
		id: string;
		displayOrder: number;
		amount: number;
		localAmount: number | null;
		invoice: { __typename?: "Invoice"; id: string; name: string; dueDate: string };
		payment: { __typename?: "Payment"; id: string };
	};
};

export type PermissionCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionFilterInput> | PermissionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PermissionOrder>;
}>;

export type PermissionCountQuery = {
	__typename?: "Query";
	permissionConnection: { __typename?: "PermissionConnection"; totalCount: number };
};

export type PermissionDetailFragment = {
	__typename?: "Permission";
	id: string;
	name: string;
	family: string;
	action: string;
	level: string;
	description: string;
	permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
};

export type PermissionDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PermissionDetailQuery = {
	__typename?: "Query";
	permission: {
		__typename?: "Permission";
		id: string;
		name: string;
		family: string;
		action: string;
		level: string;
		description: string;
		permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
	};
};

export type PermissionIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionFilterInput> | PermissionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PermissionOrder>;
}>;

export type PermissionIndexQuery = {
	__typename?: "Query";
	permissionConnection: {
		__typename?: "PermissionConnection";
		edges: Array<{
			__typename?: "PermissionEdge";
			node: {
				__typename?: "Permission";
				id: string;
				name: string;
				family: string;
				action: string;
				level: string;
				description: string;
			};
		}>;
	};
};

export type PermissionNameFragment = { __typename?: "Permission"; name: string };

export type PermissionNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PermissionNameQuery = {
	__typename?: "Query";
	permission: { __typename?: "Permission"; id: string; name: string };
};

export type PermissionNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionFilterInput> | PermissionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PermissionOrder>;
}>;

export type PermissionNamesQuery = {
	__typename?: "Query";
	permissionConnection: {
		__typename?: "PermissionConnection";
		edges: Array<{ __typename?: "PermissionEdge"; node: { __typename?: "Permission"; id: string; name: string } }>;
	};
};

export type PermissionPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionFilterInput> | PermissionFilterInput>;
	order?: InputMaybe<PermissionOrder>;
}>;

export type PermissionPaginationQuery = {
	__typename?: "Query";
	permissionConnection: {
		__typename?: "PermissionConnection";
		totalCount: number;
		edges: Array<{ __typename?: "PermissionEdge"; cursor: string }>;
	};
};

export type PermissionSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionFilterInput> | PermissionFilterInput>;
	order?: InputMaybe<PermissionOrder>;
}>;

export type PermissionSelectQuery = {
	__typename?: "Query";
	permissionConnection: {
		__typename?: "PermissionConnection";
		edges: Array<{ __typename?: "PermissionEdge"; node: { __typename?: "Permission"; id: string; name: string } }>;
	};
};

export type PermissionUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: PermissionUpdateInput;
}>;

export type PermissionUpdateMutation = {
	__typename?: "Mutation";
	updatePermission: {
		__typename?: "Permission";
		id: string;
		name: string;
		family: string;
		action: string;
		level: string;
		description: string;
		permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
	};
};

export type PermissionGroupCheckUniqueNameQueryVariables = Exact<{
	ignoreID?: InputMaybe<Scalars["ID"]["input"]>;
	name: Scalars["String"]["input"];
}>;

export type PermissionGroupCheckUniqueNameQuery = {
	__typename?: "Query";
	permissionGroupConnection: { __typename?: "PermissionGroupConnection"; totalCount: number };
};

export type PermissionGroupCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionGroupFilterInput> | PermissionGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PermissionGroupOrder>;
}>;

export type PermissionGroupCountQuery = {
	__typename?: "Query";
	permissionGroupConnection: { __typename?: "PermissionGroupConnection"; totalCount: number };
};

export type PermissionGroupCreateMutationVariables = Exact<{
	input: PermissionGroupCreateInput;
}>;

export type PermissionGroupCreateMutation = {
	__typename?: "Mutation";
	createPermissionGroup: {
		__typename?: "PermissionGroup";
		id: string;
		name: string;
		description: string;
		permissions: Array<{ __typename?: "Permission"; id: string; name: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		}>;
	};
};

export type PermissionGroupDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PermissionGroupDeleteMutation = { __typename?: "Mutation"; deletePermissionGroup: boolean };

export type PermissionGroupDetailFragment = {
	__typename?: "PermissionGroup";
	id: string;
	name: string;
	description: string;
	permissions: Array<{ __typename?: "Permission"; id: string; name: string }>;
	users: Array<{
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	}>;
};

export type PermissionGroupDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PermissionGroupDetailQuery = {
	__typename?: "Query";
	permissionGroup: {
		__typename?: "PermissionGroup";
		id: string;
		name: string;
		description: string;
		permissions: Array<{ __typename?: "Permission"; id: string; name: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		}>;
	};
};

export type PermissionGroupIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionGroupFilterInput> | PermissionGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PermissionGroupOrder>;
}>;

export type PermissionGroupIndexQuery = {
	__typename?: "Query";
	permissionGroupConnection: {
		__typename?: "PermissionGroupConnection";
		edges: Array<{
			__typename?: "PermissionGroupEdge";
			node: { __typename?: "PermissionGroup"; id: string; name: string; description: string };
		}>;
	};
};

export type PermissionGroupNameFragment = { __typename?: "PermissionGroup"; name: string };

export type PermissionGroupNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PermissionGroupNameQuery = {
	__typename?: "Query";
	permissionGroup: { __typename?: "PermissionGroup"; id: string; name: string };
};

export type PermissionGroupNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionGroupFilterInput> | PermissionGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PermissionGroupOrder>;
}>;

export type PermissionGroupNamesQuery = {
	__typename?: "Query";
	permissionGroupConnection: {
		__typename?: "PermissionGroupConnection";
		edges: Array<{
			__typename?: "PermissionGroupEdge";
			node: { __typename?: "PermissionGroup"; id: string; name: string };
		}>;
	};
};

export type PermissionGroupPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionGroupFilterInput> | PermissionGroupFilterInput>;
	order?: InputMaybe<PermissionGroupOrder>;
}>;

export type PermissionGroupPaginationQuery = {
	__typename?: "Query";
	permissionGroupConnection: {
		__typename?: "PermissionGroupConnection";
		totalCount: number;
		edges: Array<{ __typename?: "PermissionGroupEdge"; cursor: string }>;
	};
};

export type PermissionGroupSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionGroupFilterInput> | PermissionGroupFilterInput>;
	order?: InputMaybe<PermissionGroupOrder>;
}>;

export type PermissionGroupSelectQuery = {
	__typename?: "Query";
	permissionGroupConnection: {
		__typename?: "PermissionGroupConnection";
		edges: Array<{
			__typename?: "PermissionGroupEdge";
			node: { __typename?: "PermissionGroup"; id: string; name: string };
		}>;
	};
};

export type PermissionGroupUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: PermissionGroupUpdateInput;
}>;

export type PermissionGroupUpdateMutation = {
	__typename?: "Mutation";
	updatePermissionGroup: {
		__typename?: "PermissionGroup";
		id: string;
		name: string;
		description: string;
		permissions: Array<{ __typename?: "Permission"; id: string; name: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		}>;
	};
};

export type PersonContactListQueryVariables = Exact<{
	filters?: InputMaybe<Array<PersonFilterInput> | PersonFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PersonOrder>;
}>;

export type PersonContactListQuery = {
	__typename?: "Query";
	personConnection: {
		__typename?: "PersonConnection";
		pageInfo: { __typename?: "PageInfo"; endCursor: string | null; hasNextPage: boolean };
		edges: Array<{
			__typename?: "PersonEdge";
			node: {
				__typename?: "Person";
				id: string;
				givenName: string;
				familyName: string;
				nameOrder: PersonNameOrder;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
				name: string;
				publicName: string;
				employee: { __typename?: "Employee"; id: string; role: EmployeeRole; jobTitle: string } | null;
				guardian: { __typename?: "Guardian"; id: string } | null;
				student: {
					__typename?: "Student";
					id: string;
					graduationYear: number | null;
					yearsFromGraduation: number;
				} | null;
				user: { __typename?: "User"; id: string; status: UserStatus } | null;
				emailAddresses: Array<{
					__typename?: "EmailAddress";
					id: string;
					emailAddress: string;
					isPrimary: boolean;
					name: string;
				}>;
				phoneNumbers: Array<{
					__typename?: "PhoneNumber";
					id: string;
					phoneNumber: string;
					isPrimary: boolean;
					name: string;
				}>;
			};
		}>;
	};
};

export type PersonContactDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PersonContactDetailQuery = {
	__typename?: "Query";
	person: {
		__typename?: "Person";
		id: string;
		givenName: string;
		familyName: string;
		nameOrder: PersonNameOrder;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		name: string;
		publicName: string;
		employee: { __typename?: "Employee"; id: string; role: EmployeeRole; jobTitle: string } | null;
		guardian: { __typename?: "Guardian"; id: string } | null;
		student: { __typename?: "Student"; id: string; graduationYear: number | null; yearsFromGraduation: number } | null;
		user: { __typename?: "User"; id: string; status: UserStatus } | null;
		addresses: Array<{
			__typename?: "Address";
			id: string;
			name: string;
			addressLine1: string;
			addressLine2: string;
			city: string;
			postalCode: string;
			stateOrProvince: string;
			country: { __typename?: "Country"; id: string; name: string };
		}>;
		emailAddresses: Array<{
			__typename?: "EmailAddress";
			id: string;
			emailAddress: string;
			isPrimary: boolean;
			name: string;
		}>;
		phoneNumbers: Array<{
			__typename?: "PhoneNumber";
			id: string;
			phoneNumber: string;
			isPrimary: boolean;
			name: string;
		}>;
	};
};

export type PersonCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<PersonFilterInput> | PersonFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PersonOrder>;
}>;

export type PersonCountQuery = {
	__typename?: "Query";
	personConnection: { __typename?: "PersonConnection"; totalCount: number };
};

export type PersonCreateMutationVariables = Exact<{
	input: PersonCreateInput;
}>;

export type PersonCreateMutation = {
	__typename?: "Mutation";
	createPerson: {
		__typename?: "Person";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		middleName: string;
		familyName: string;
		nameOrder: PersonNameOrder;
		nickname: string;
		alternateNames: string;
		publicNameFormat: PersonPublicNameFormat;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		gender: string;
		dateOfBirth: string | null;
		englishLanguageFluency: PersonEnglishLanguageFluency | null;
		occupation: string;
		nationalIdentificationNumber: string;
		governmentDocumentSeries: string;
		governmentDocumentNumber: string;
		governmentDocumentIssuedBy: string;
		nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
		languages: Array<{ __typename?: "Language"; id: string; name: string }>;
		addresses: Array<{
			__typename?: "Address";
			id: string;
			name: string;
			addressLine1: string;
			addressLine2: string;
			city: string;
			postalCode: string;
			stateOrProvince: string;
			country: { __typename?: "Country"; id: string; name: string };
		}>;
		emailAddresses: Array<{
			__typename?: "EmailAddress";
			id: string;
			emailAddress: string;
			isPrimary: boolean;
			name: string;
		}>;
		employee: {
			__typename?: "Employee";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		guardian: {
			__typename?: "Guardian";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		phoneNumbers: Array<{
			__typename?: "PhoneNumber";
			id: string;
			phoneNumber: string;
			isPrimary: boolean;
			name: string;
		}>;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		user: {
			__typename?: "User";
			id: string;
			email: string;
			status: UserStatus;
			passwordUpdatedAt: string;
			isCurrent: boolean;
			timeZoneName: string;
			externalNotificationFrequency: UserExternalNotificationFrequency;
			permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				employee: { __typename?: "Employee"; id: string } | null;
				guardian: { __typename?: "Guardian"; id: string } | null;
				student: { __typename?: "Student"; id: string } | null;
			} | null;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		} | null;
	};
};

export type PersonDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PersonDeleteMutation = { __typename?: "Mutation"; deletePerson: boolean };

export type PersonDetailFragment = {
	__typename?: "Person";
	id: string;
	name: string;
	publicName: string;
	givenName: string;
	middleName: string;
	familyName: string;
	nameOrder: PersonNameOrder;
	nickname: string;
	alternateNames: string;
	publicNameFormat: PersonPublicNameFormat;
	imageURL: string;
	imageKey: string;
	imageContentType: string;
	gender: string;
	dateOfBirth: string | null;
	englishLanguageFluency: PersonEnglishLanguageFluency | null;
	occupation: string;
	nationalIdentificationNumber: string;
	governmentDocumentSeries: string;
	governmentDocumentNumber: string;
	governmentDocumentIssuedBy: string;
	nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
	languages: Array<{ __typename?: "Language"; id: string; name: string }>;
	addresses: Array<{
		__typename?: "Address";
		id: string;
		name: string;
		addressLine1: string;
		addressLine2: string;
		city: string;
		postalCode: string;
		stateOrProvince: string;
		country: { __typename?: "Country"; id: string; name: string };
	}>;
	emailAddresses: Array<{
		__typename?: "EmailAddress";
		id: string;
		emailAddress: string;
		isPrimary: boolean;
		name: string;
	}>;
	employee: {
		__typename?: "Employee";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	} | null;
	guardian: {
		__typename?: "Guardian";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	} | null;
	phoneNumbers: Array<{
		__typename?: "PhoneNumber";
		id: string;
		phoneNumber: string;
		isPrimary: boolean;
		name: string;
	}>;
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	} | null;
	user: {
		__typename?: "User";
		id: string;
		email: string;
		status: UserStatus;
		passwordUpdatedAt: string;
		isCurrent: boolean;
		timeZoneName: string;
		externalNotificationFrequency: UserExternalNotificationFrequency;
		permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			employee: { __typename?: "Employee"; id: string } | null;
			guardian: { __typename?: "Guardian"; id: string } | null;
			student: { __typename?: "Student"; id: string } | null;
		} | null;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
	} | null;
};

export type PersonDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PersonDetailQuery = {
	__typename?: "Query";
	person: {
		__typename?: "Person";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		middleName: string;
		familyName: string;
		nameOrder: PersonNameOrder;
		nickname: string;
		alternateNames: string;
		publicNameFormat: PersonPublicNameFormat;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		gender: string;
		dateOfBirth: string | null;
		englishLanguageFluency: PersonEnglishLanguageFluency | null;
		occupation: string;
		nationalIdentificationNumber: string;
		governmentDocumentSeries: string;
		governmentDocumentNumber: string;
		governmentDocumentIssuedBy: string;
		nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
		languages: Array<{ __typename?: "Language"; id: string; name: string }>;
		addresses: Array<{
			__typename?: "Address";
			id: string;
			name: string;
			addressLine1: string;
			addressLine2: string;
			city: string;
			postalCode: string;
			stateOrProvince: string;
			country: { __typename?: "Country"; id: string; name: string };
		}>;
		emailAddresses: Array<{
			__typename?: "EmailAddress";
			id: string;
			emailAddress: string;
			isPrimary: boolean;
			name: string;
		}>;
		employee: {
			__typename?: "Employee";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		guardian: {
			__typename?: "Guardian";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		phoneNumbers: Array<{
			__typename?: "PhoneNumber";
			id: string;
			phoneNumber: string;
			isPrimary: boolean;
			name: string;
		}>;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		user: {
			__typename?: "User";
			id: string;
			email: string;
			status: UserStatus;
			passwordUpdatedAt: string;
			isCurrent: boolean;
			timeZoneName: string;
			externalNotificationFrequency: UserExternalNotificationFrequency;
			permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				employee: { __typename?: "Employee"; id: string } | null;
				guardian: { __typename?: "Guardian"; id: string } | null;
				student: { __typename?: "Student"; id: string } | null;
			} | null;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		} | null;
	};
};

export type PersonIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<PersonFilterInput> | PersonFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PersonOrder>;
}>;

export type PersonIndexQuery = {
	__typename?: "Query";
	personConnection: {
		__typename?: "PersonConnection";
		edges: Array<{
			__typename?: "PersonEdge";
			node: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				middleName: string;
				familyName: string;
				nameOrder: PersonNameOrder;
				nickname: string;
				alternateNames: string;
				publicNameFormat: PersonPublicNameFormat;
				imageURL: string;
				imageContentType: string;
				gender: string;
				dateOfBirth: string | null;
				englishLanguageFluency: PersonEnglishLanguageFluency | null;
				occupation: string;
				nationalIdentificationNumber: string;
				governmentDocumentSeries: string;
				governmentDocumentNumber: string;
				governmentDocumentIssuedBy: string;
			};
		}>;
	};
};

export type PersonNameFragment = { __typename?: "Person"; name: string; publicName: string };

export type PersonNameAndImageFragment = {
	__typename?: "Person";
	name: string;
	publicName: string;
	imageURL: string;
	imageKey: string;
	imageContentType: string;
};

export type PersonNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PersonNameQuery = {
	__typename?: "Query";
	person: { __typename?: "Person"; id: string; name: string; publicName: string };
};

export type PersonNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<PersonFilterInput> | PersonFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PersonOrder>;
}>;

export type PersonNamesQuery = {
	__typename?: "Query";
	personConnection: {
		__typename?: "PersonConnection";
		edges: Array<{
			__typename?: "PersonEdge";
			node: { __typename?: "Person"; id: string; name: string; publicName: string };
		}>;
	};
};

export type PersonPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<PersonFilterInput> | PersonFilterInput>;
	order?: InputMaybe<PersonOrder>;
}>;

export type PersonPaginationQuery = {
	__typename?: "Query";
	personConnection: {
		__typename?: "PersonConnection";
		totalCount: number;
		edges: Array<{ __typename?: "PersonEdge"; cursor: string }>;
	};
};

export type PersonSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<PersonFilterInput> | PersonFilterInput>;
	order?: InputMaybe<PersonOrder>;
}>;

export type PersonSelectQuery = {
	__typename?: "Query";
	personConnection: {
		__typename?: "PersonConnection";
		edges: Array<{
			__typename?: "PersonEdge";
			node: { __typename?: "Person"; id: string; name: string; publicName: string };
		}>;
	};
};

export type PersonUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: PersonUpdateInput;
}>;

export type PersonUpdateMutation = {
	__typename?: "Mutation";
	updatePerson: {
		__typename?: "Person";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		middleName: string;
		familyName: string;
		nameOrder: PersonNameOrder;
		nickname: string;
		alternateNames: string;
		publicNameFormat: PersonPublicNameFormat;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		gender: string;
		dateOfBirth: string | null;
		englishLanguageFluency: PersonEnglishLanguageFluency | null;
		occupation: string;
		nationalIdentificationNumber: string;
		governmentDocumentSeries: string;
		governmentDocumentNumber: string;
		governmentDocumentIssuedBy: string;
		nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
		languages: Array<{ __typename?: "Language"; id: string; name: string }>;
		addresses: Array<{
			__typename?: "Address";
			id: string;
			name: string;
			addressLine1: string;
			addressLine2: string;
			city: string;
			postalCode: string;
			stateOrProvince: string;
			country: { __typename?: "Country"; id: string; name: string };
		}>;
		emailAddresses: Array<{
			__typename?: "EmailAddress";
			id: string;
			emailAddress: string;
			isPrimary: boolean;
			name: string;
		}>;
		employee: {
			__typename?: "Employee";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		guardian: {
			__typename?: "Guardian";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		phoneNumbers: Array<{
			__typename?: "PhoneNumber";
			id: string;
			phoneNumber: string;
			isPrimary: boolean;
			name: string;
		}>;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		user: {
			__typename?: "User";
			id: string;
			email: string;
			status: UserStatus;
			passwordUpdatedAt: string;
			isCurrent: boolean;
			timeZoneName: string;
			externalNotificationFrequency: UserExternalNotificationFrequency;
			permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				employee: { __typename?: "Employee"; id: string } | null;
				guardian: { __typename?: "Guardian"; id: string } | null;
				student: { __typename?: "Student"; id: string } | null;
			} | null;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		} | null;
	};
};

export type PhoneNumberCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<PhoneNumberFilterInput> | PhoneNumberFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PhoneNumberOrder>;
}>;

export type PhoneNumberCountQuery = {
	__typename?: "Query";
	phoneNumberConnection: { __typename?: "PhoneNumberConnection"; totalCount: number };
};

export type PhoneNumberCreateMutationVariables = Exact<{
	input: PhoneNumberCreateInput;
}>;

export type PhoneNumberCreateMutation = {
	__typename?: "Mutation";
	createPhoneNumber: {
		__typename?: "PhoneNumber";
		id: string;
		name: string;
		phoneNumber: string;
		isPrimary: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	};
};

export type PhoneNumberDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PhoneNumberDeleteMutation = { __typename?: "Mutation"; deletePhoneNumber: boolean };

export type PhoneNumberDetailFragment = {
	__typename?: "PhoneNumber";
	id: string;
	name: string;
	phoneNumber: string;
	isPrimary: boolean;
	person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
};

export type PhoneNumberDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PhoneNumberDetailQuery = {
	__typename?: "Query";
	phoneNumber: {
		__typename?: "PhoneNumber";
		id: string;
		name: string;
		phoneNumber: string;
		isPrimary: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	};
};

export type PhoneNumberIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<PhoneNumberFilterInput> | PhoneNumberFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PhoneNumberOrder>;
}>;

export type PhoneNumberIndexQuery = {
	__typename?: "Query";
	phoneNumberConnection: {
		__typename?: "PhoneNumberConnection";
		edges: Array<{
			__typename?: "PhoneNumberEdge";
			node: { __typename?: "PhoneNumber"; id: string; name: string; phoneNumber: string; isPrimary: boolean };
		}>;
	};
};

export type PhoneNumberNameFragment = { __typename?: "PhoneNumber"; name: string; phoneNumber: string };

export type PhoneNumberNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PhoneNumberNameQuery = {
	__typename?: "Query";
	phoneNumber: { __typename?: "PhoneNumber"; id: string; name: string; phoneNumber: string };
};

export type PhoneNumberNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<PhoneNumberFilterInput> | PhoneNumberFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PhoneNumberOrder>;
}>;

export type PhoneNumberNamesQuery = {
	__typename?: "Query";
	phoneNumberConnection: {
		__typename?: "PhoneNumberConnection";
		edges: Array<{
			__typename?: "PhoneNumberEdge";
			node: { __typename?: "PhoneNumber"; id: string; name: string; phoneNumber: string };
		}>;
	};
};

export type PhoneNumberPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<PhoneNumberFilterInput> | PhoneNumberFilterInput>;
	order?: InputMaybe<PhoneNumberOrder>;
}>;

export type PhoneNumberPaginationQuery = {
	__typename?: "Query";
	phoneNumberConnection: {
		__typename?: "PhoneNumberConnection";
		totalCount: number;
		edges: Array<{ __typename?: "PhoneNumberEdge"; cursor: string }>;
	};
};

export type PhoneNumberSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<PhoneNumberFilterInput> | PhoneNumberFilterInput>;
	order?: InputMaybe<PhoneNumberOrder>;
}>;

export type PhoneNumberSelectQuery = {
	__typename?: "Query";
	phoneNumberConnection: {
		__typename?: "PhoneNumberConnection";
		edges: Array<{
			__typename?: "PhoneNumberEdge";
			node: { __typename?: "PhoneNumber"; id: string; name: string; phoneNumber: string };
		}>;
	};
};

export type PhoneNumberUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: PhoneNumberUpdateInput;
}>;

export type PhoneNumberUpdateMutation = {
	__typename?: "Mutation";
	updatePhoneNumber: {
		__typename?: "PhoneNumber";
		id: string;
		name: string;
		phoneNumber: string;
		isPrimary: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	};
};

export type PostCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<PostFilterInput> | PostFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PostOrder>;
}>;

export type PostCountQuery = {
	__typename?: "Query";
	postConnection: { __typename?: "PostConnection"; totalCount: number };
};

export type PostCreateMutationVariables = Exact<{
	input: PostCreateInput;
}>;

export type PostCreateMutation = {
	__typename?: "Mutation";
	createPost: {
		__typename?: "Post";
		id: string;
		createdAt: string;
		title: string;
		body: string;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
			taggedPeople: Array<{
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
			}>;
		}>;
		socialReactions: Array<{
			__typename?: "SocialReaction";
			id: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				email: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			};
		}>;
		socialComments: Array<{
			__typename?: "SocialComment";
			id: string;
			body: string;
			createdAt: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				email: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
			};
		}>;
		sharingRecord: {
			__typename?: "SharingRecord";
			id: string;
			isPublic: boolean;
			includeEmployees: boolean;
			includeGuardians: boolean;
			includeAllUsersOfPersonTypes: boolean;
			classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
			classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
			courseSections: Array<{
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			}>;
			homeRoomSections: Array<{
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			}>;
		} | null;
	};
};

export type PostDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PostDeleteMutation = { __typename?: "Mutation"; deletePost: boolean };

export type PostDetailFragment = {
	__typename?: "Post";
	id: string;
	createdAt: string;
	title: string;
	body: string;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
	} | null;
	mediaAttachments: Array<{
		__typename?: "MediaAttachment";
		id: string;
		displayOrder: number;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
		taggedPeople: Array<{
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
		}>;
	}>;
	socialReactions: Array<{
		__typename?: "SocialReaction";
		id: string;
		author: {
			__typename?: "User";
			id: string;
			isCurrent: boolean;
			email: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
	}>;
	socialComments: Array<{
		__typename?: "SocialComment";
		id: string;
		body: string;
		createdAt: string;
		author: {
			__typename?: "User";
			id: string;
			isCurrent: boolean;
			email: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		};
	}>;
	sharingRecord: {
		__typename?: "SharingRecord";
		id: string;
		isPublic: boolean;
		includeEmployees: boolean;
		includeGuardians: boolean;
		includeAllUsersOfPersonTypes: boolean;
		classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
		courseSections: Array<{
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		}>;
		homeRoomSections: Array<{
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		}>;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		}>;
	} | null;
};

export type PostDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PostDetailQuery = {
	__typename?: "Query";
	post: {
		__typename?: "Post";
		id: string;
		createdAt: string;
		title: string;
		body: string;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
			taggedPeople: Array<{
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
			}>;
		}>;
		socialReactions: Array<{
			__typename?: "SocialReaction";
			id: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				email: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			};
		}>;
		socialComments: Array<{
			__typename?: "SocialComment";
			id: string;
			body: string;
			createdAt: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				email: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
			};
		}>;
		sharingRecord: {
			__typename?: "SharingRecord";
			id: string;
			isPublic: boolean;
			includeEmployees: boolean;
			includeGuardians: boolean;
			includeAllUsersOfPersonTypes: boolean;
			classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
			classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
			courseSections: Array<{
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			}>;
			homeRoomSections: Array<{
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			}>;
		} | null;
	};
};

export type PostIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<PostFilterInput> | PostFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PostOrder>;
}>;

export type PostIndexQuery = {
	__typename?: "Query";
	postConnection: {
		__typename?: "PostConnection";
		edges: Array<{
			__typename?: "PostEdge";
			node: {
				__typename?: "Post";
				id: string;
				createdAt: string;
				title: string;
				body: string;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
				} | null;
			};
		}>;
	};
};

export type PostNameFragment = { __typename?: "Post"; title: string };

export type PostNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PostNameQuery = { __typename?: "Query"; post: { __typename?: "Post"; id: string; title: string } };

export type PostNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<PostFilterInput> | PostFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PostOrder>;
}>;

export type PostNamesQuery = {
	__typename?: "Query";
	postConnection: {
		__typename?: "PostConnection";
		edges: Array<{ __typename?: "PostEdge"; node: { __typename?: "Post"; id: string; title: string } }>;
	};
};

export type PostPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<PostFilterInput> | PostFilterInput>;
	order?: InputMaybe<PostOrder>;
}>;

export type PostPaginationQuery = {
	__typename?: "Query";
	postConnection: {
		__typename?: "PostConnection";
		totalCount: number;
		edges: Array<{ __typename?: "PostEdge"; cursor: string }>;
	};
};

export type PostSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<PostFilterInput> | PostFilterInput>;
	order?: InputMaybe<PostOrder>;
}>;

export type PostSelectQuery = {
	__typename?: "Query";
	postConnection: {
		__typename?: "PostConnection";
		edges: Array<{ __typename?: "PostEdge"; node: { __typename?: "Post"; id: string; title: string } }>;
	};
};

export type PostSocialItemsQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PostSocialItemsQuery = {
	__typename?: "Query";
	post: {
		__typename?: "Post";
		id: string;
		socialReactions: Array<{
			__typename?: "SocialReaction";
			id: string;
			reaction: SocialReactionReaction;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				email: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			};
		}>;
		socialComments: Array<{
			__typename?: "SocialComment";
			id: string;
			body: string;
			createdAt: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				email: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
			};
		}>;
	};
};

export type PostStatisticsQueryVariables = Exact<{
	filters?: InputMaybe<Array<PostFilterInput> | PostFilterInput>;
}>;

export type PostStatisticsQuery = {
	__typename?: "Query";
	postStatistics: { __typename?: "PostStatistics"; count: number; views: number; reactions: number; comments: number };
};

export type PostUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: PostUpdateInput;
}>;

export type PostUpdateMutation = {
	__typename?: "Mutation";
	updatePost: {
		__typename?: "Post";
		id: string;
		createdAt: string;
		title: string;
		body: string;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
			taggedPeople: Array<{
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
			}>;
		}>;
		socialReactions: Array<{
			__typename?: "SocialReaction";
			id: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				email: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			};
		}>;
		socialComments: Array<{
			__typename?: "SocialComment";
			id: string;
			body: string;
			createdAt: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				email: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
			};
		}>;
		sharingRecord: {
			__typename?: "SharingRecord";
			id: string;
			isPublic: boolean;
			includeEmployees: boolean;
			includeGuardians: boolean;
			includeAllUsersOfPersonTypes: boolean;
			classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
			classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
			courseSections: Array<{
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			}>;
			homeRoomSections: Array<{
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			}>;
		} | null;
	};
};

export type QuotationCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<QuotationFilterInput> | QuotationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<QuotationOrder>;
}>;

export type QuotationCountQuery = {
	__typename?: "Query";
	quotationConnection: { __typename?: "QuotationConnection"; totalCount: number };
};

export type QuotationCreateMutationVariables = Exact<{
	input: QuotationCreateInput;
}>;

export type QuotationCreateMutation = {
	__typename?: "Mutation";
	createQuotation: { __typename?: "Quotation"; id: string; body: string; attribution: string };
};

export type DailyQuotationQueryVariables = Exact<{
	date: Scalars["Date"]["input"];
}>;

export type DailyQuotationQuery = {
	__typename?: "Query";
	dailyQuotation: { __typename?: "Quotation"; id: string; body: string; attribution: string };
};

export type QuotationDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type QuotationDeleteMutation = { __typename?: "Mutation"; deleteQuotation: boolean };

export type QuotationDetailFragment = { __typename?: "Quotation"; id: string; body: string; attribution: string };

export type QuotationDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type QuotationDetailQuery = {
	__typename?: "Query";
	quotation: { __typename?: "Quotation"; id: string; body: string; attribution: string };
};

export type QuotationIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<QuotationFilterInput> | QuotationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<QuotationOrder>;
}>;

export type QuotationIndexQuery = {
	__typename?: "Query";
	quotationConnection: {
		__typename?: "QuotationConnection";
		edges: Array<{
			__typename?: "QuotationEdge";
			node: { __typename?: "Quotation"; id: string; body: string; attribution: string };
		}>;
	};
};

export type QuotationNameFragment = { __typename?: "Quotation"; id: string };

export type QuotationNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type QuotationNameQuery = { __typename?: "Query"; quotation: { __typename?: "Quotation"; id: string } };

export type QuotationNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<QuotationFilterInput> | QuotationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<QuotationOrder>;
}>;

export type QuotationNamesQuery = {
	__typename?: "Query";
	quotationConnection: {
		__typename?: "QuotationConnection";
		edges: Array<{ __typename?: "QuotationEdge"; node: { __typename?: "Quotation"; id: string } }>;
	};
};

export type QuotationPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<QuotationFilterInput> | QuotationFilterInput>;
	order?: InputMaybe<QuotationOrder>;
}>;

export type QuotationPaginationQuery = {
	__typename?: "Query";
	quotationConnection: {
		__typename?: "QuotationConnection";
		totalCount: number;
		edges: Array<{ __typename?: "QuotationEdge"; cursor: string }>;
	};
};

export type QuotationSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<QuotationFilterInput> | QuotationFilterInput>;
	order?: InputMaybe<QuotationOrder>;
}>;

export type QuotationSelectQuery = {
	__typename?: "Query";
	quotationConnection: {
		__typename?: "QuotationConnection";
		edges: Array<{ __typename?: "QuotationEdge"; node: { __typename?: "Quotation"; id: string } }>;
	};
};

export type QuotationUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: QuotationUpdateInput;
}>;

export type QuotationUpdateMutation = {
	__typename?: "Mutation";
	updateQuotation: { __typename?: "Quotation"; id: string; body: string; attribution: string };
};

export type RefundCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<RefundFilterInput> | RefundFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<RefundOrder>;
}>;

export type RefundCountQuery = {
	__typename?: "Query";
	refundConnection: { __typename?: "RefundConnection"; totalCount: number };
};

export type RefundCreateMutationVariables = Exact<{
	input: RefundCreateInput;
}>;

export type RefundCreateMutation = {
	__typename?: "Mutation";
	createRefund: {
		__typename?: "Refund";
		id: string;
		issueDate: string;
		amount: number;
		localAmount: number | null;
		isInLocalCurrency: boolean;
		localCurrency: string;
		notes: string;
		payment: { __typename?: "Payment"; id: string };
	};
};

export type RefundDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type RefundDeleteMutation = { __typename?: "Mutation"; deleteRefund: boolean };

export type RefundDetailFragment = {
	__typename?: "Refund";
	id: string;
	issueDate: string;
	amount: number;
	localAmount: number | null;
	isInLocalCurrency: boolean;
	localCurrency: string;
	notes: string;
	payment: { __typename?: "Payment"; id: string };
};

export type RefundDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type RefundDetailQuery = {
	__typename?: "Query";
	refund: {
		__typename?: "Refund";
		id: string;
		issueDate: string;
		amount: number;
		localAmount: number | null;
		isInLocalCurrency: boolean;
		localCurrency: string;
		notes: string;
		payment: { __typename?: "Payment"; id: string };
	};
};

export type RefundIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<RefundFilterInput> | RefundFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<RefundOrder>;
}>;

export type RefundIndexQuery = {
	__typename?: "Query";
	refundConnection: {
		__typename?: "RefundConnection";
		edges: Array<{
			__typename?: "RefundEdge";
			node: {
				__typename?: "Refund";
				id: string;
				issueDate: string;
				amount: number;
				localAmount: number | null;
				isInLocalCurrency: boolean;
				localCurrency: string;
				notes: string;
			};
		}>;
	};
};

export type RefundNameFragment = { __typename?: "Refund"; id: string };

export type RefundNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type RefundNameQuery = { __typename?: "Query"; refund: { __typename?: "Refund"; id: string } };

export type RefundNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<RefundFilterInput> | RefundFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<RefundOrder>;
}>;

export type RefundNamesQuery = {
	__typename?: "Query";
	refundConnection: {
		__typename?: "RefundConnection";
		edges: Array<{ __typename?: "RefundEdge"; node: { __typename?: "Refund"; id: string } }>;
	};
};

export type RefundPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<RefundFilterInput> | RefundFilterInput>;
	order?: InputMaybe<RefundOrder>;
}>;

export type RefundPaginationQuery = {
	__typename?: "Query";
	refundConnection: {
		__typename?: "RefundConnection";
		totalCount: number;
		edges: Array<{ __typename?: "RefundEdge"; cursor: string }>;
	};
};

export type RefundSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<RefundFilterInput> | RefundFilterInput>;
	order?: InputMaybe<RefundOrder>;
}>;

export type RefundSelectQuery = {
	__typename?: "Query";
	refundConnection: {
		__typename?: "RefundConnection";
		edges: Array<{ __typename?: "RefundEdge"; node: { __typename?: "Refund"; id: string } }>;
	};
};

export type RefundUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: RefundUpdateInput;
}>;

export type RefundUpdateMutation = {
	__typename?: "Mutation";
	updateRefund: {
		__typename?: "Refund";
		id: string;
		issueDate: string;
		amount: number;
		localAmount: number | null;
		isInLocalCurrency: boolean;
		localCurrency: string;
		notes: string;
		payment: { __typename?: "Payment"; id: string };
	};
};

export type RelationshipCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<RelationshipFilterInput> | RelationshipFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<RelationshipOrder>;
}>;

export type RelationshipCountQuery = {
	__typename?: "Query";
	relationshipConnection: { __typename?: "RelationshipConnection"; totalCount: number };
};

export type RelationshipCreateMutationVariables = Exact<{
	input: RelationshipCreateInput;
}>;

export type RelationshipCreateMutation = {
	__typename?: "Mutation";
	createRelationship: {
		__typename?: "Relationship";
		id: string;
		relationshipType: string;
		isPrimary: boolean;
		isFinancialContact: boolean;
		isEmergencyContact: boolean;
		isAuthorizedForPickup: boolean;
		livesWithStudent: boolean;
		hasCustody: boolean;
		guardian: {
			__typename?: "Guardian";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type RelationshipDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type RelationshipDeleteMutation = { __typename?: "Mutation"; deleteRelationship: boolean };

export type RelationshipDetailFragment = {
	__typename?: "Relationship";
	id: string;
	relationshipType: string;
	isPrimary: boolean;
	isFinancialContact: boolean;
	isEmergencyContact: boolean;
	isAuthorizedForPickup: boolean;
	livesWithStudent: boolean;
	hasCustody: boolean;
	guardian: {
		__typename?: "Guardian";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type RelationshipDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type RelationshipDetailQuery = {
	__typename?: "Query";
	relationship: {
		__typename?: "Relationship";
		id: string;
		relationshipType: string;
		isPrimary: boolean;
		isFinancialContact: boolean;
		isEmergencyContact: boolean;
		isAuthorizedForPickup: boolean;
		livesWithStudent: boolean;
		hasCustody: boolean;
		guardian: {
			__typename?: "Guardian";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type RelationshipIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<RelationshipFilterInput> | RelationshipFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<RelationshipOrder>;
}>;

export type RelationshipIndexQuery = {
	__typename?: "Query";
	relationshipConnection: {
		__typename?: "RelationshipConnection";
		edges: Array<{
			__typename?: "RelationshipEdge";
			node: {
				__typename?: "Relationship";
				id: string;
				relationshipType: string;
				isPrimary: boolean;
				isFinancialContact: boolean;
				isEmergencyContact: boolean;
				isAuthorizedForPickup: boolean;
				livesWithStudent: boolean;
				hasCustody: boolean;
			};
		}>;
	};
};

export type RelationshipNameFragment = { __typename?: "Relationship"; id: string };

export type RelationshipNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type RelationshipNameQuery = { __typename?: "Query"; relationship: { __typename?: "Relationship"; id: string } };

export type RelationshipNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<RelationshipFilterInput> | RelationshipFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<RelationshipOrder>;
}>;

export type RelationshipNamesQuery = {
	__typename?: "Query";
	relationshipConnection: {
		__typename?: "RelationshipConnection";
		edges: Array<{ __typename?: "RelationshipEdge"; node: { __typename?: "Relationship"; id: string } }>;
	};
};

export type RelationshipPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<RelationshipFilterInput> | RelationshipFilterInput>;
	order?: InputMaybe<RelationshipOrder>;
}>;

export type RelationshipPaginationQuery = {
	__typename?: "Query";
	relationshipConnection: {
		__typename?: "RelationshipConnection";
		totalCount: number;
		edges: Array<{ __typename?: "RelationshipEdge"; cursor: string }>;
	};
};

export type RelationshipSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<RelationshipFilterInput> | RelationshipFilterInput>;
	order?: InputMaybe<RelationshipOrder>;
}>;

export type RelationshipSelectQuery = {
	__typename?: "Query";
	relationshipConnection: {
		__typename?: "RelationshipConnection";
		edges: Array<{ __typename?: "RelationshipEdge"; node: { __typename?: "Relationship"; id: string } }>;
	};
};

export type RelationshipUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: RelationshipUpdateInput;
}>;

export type RelationshipUpdateMutation = {
	__typename?: "Mutation";
	updateRelationship: {
		__typename?: "Relationship";
		id: string;
		relationshipType: string;
		isPrimary: boolean;
		isFinancialContact: boolean;
		isEmergencyContact: boolean;
		isAuthorizedForPickup: boolean;
		livesWithStudent: boolean;
		hasCustody: boolean;
		guardian: {
			__typename?: "Guardian";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type ReportCardCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardFilterInput> | ReportCardFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ReportCardOrder>;
}>;

export type ReportCardCountQuery = {
	__typename?: "Query";
	reportCardConnection: { __typename?: "ReportCardConnection"; totalCount: number };
};

export type ReportCardCreateMutationVariables = Exact<{
	input: ReportCardCreateInput;
}>;

export type ReportCardCreateMutation = {
	__typename?: "Mutation";
	createReportCard: {
		__typename?: "ReportCard";
		id: string;
		isComplete: boolean;
		releaseDate: string | null;
		isReleased: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
		approvingUser: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type ReportCardDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ReportCardDeleteMutation = { __typename?: "Mutation"; deleteReportCard: boolean };

export type ReportCardDetailFragment = {
	__typename?: "ReportCard";
	id: string;
	isComplete: boolean;
	releaseDate: string | null;
	isReleased: boolean;
	fileURL: string;
	fileKey: string;
	fileContentType: string;
	academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
	approvingUser: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	} | null;
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type ReportCardDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ReportCardDetailQuery = {
	__typename?: "Query";
	reportCard: {
		__typename?: "ReportCard";
		id: string;
		isComplete: boolean;
		releaseDate: string | null;
		isReleased: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
		approvingUser: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type ReportCardSectionDisplayFragment = {
	__typename?: "ReportCardSection";
	isComplete: boolean;
	comment: string;
	generalComment1: string;
	generalComment2: string;
	reportCardSectionPolicy: {
		__typename?: "ReportCardSectionPolicy";
		id: string;
		nameSuffix: string;
		usesDescription: boolean;
		descriptionLabel: string;
		description: string;
		usesOverallMark: boolean;
		isOverallMarkManual: boolean;
		overallMarkLabel: string;
		usesComment: boolean;
		commentLabel: string;
		isForHomeRoomSection: boolean;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			teacherCourseSectionEnrollments: Array<{
				__typename?: "TeacherCourseSectionEnrollment";
				id: string;
				teacher: {
					__typename?: "Employee";
					id: string;
					person: { __typename?: "Person"; id: string; name: string; publicName: string };
				};
			}>;
			course: { __typename?: "Course"; id: string; name: string };
		} | null;
		homeRoomSection: {
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			teacherHomeRoomSectionEnrollments: Array<{
				__typename?: "TeacherHomeRoomSectionEnrollment";
				id: string;
				teacher: {
					__typename?: "Employee";
					id: string;
					person: { __typename?: "Person"; id: string; name: string; publicName: string };
				};
			}>;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		} | null;
	};
	overallMarkValue: { __typename?: "MarkValue"; id: string; name: string } | null;
	reportCardSectionLearningObjectives: Array<{
		__typename?: "ReportCardSectionLearningObjective";
		id: string;
		learningObjective: {
			__typename?: "LearningObjective";
			id: string;
			description: string;
			learningObjectiveCategoryID: string;
			name: string;
		};
		markValue: { __typename?: "MarkValue"; id: string; name: string } | null;
	}>;
};

export type ReportCardDisplayQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ReportCardDisplayQuery = {
	__typename?: "Query";
	reportCardConnection: {
		__typename?: "ReportCardConnection";
		edges: Array<{
			__typename?: "ReportCardEdge";
			node: {
				__typename?: "ReportCard";
				id: string;
				isComplete: boolean;
				releaseDate: string | null;
				student: {
					__typename?: "Student";
					id: string;
					graduationYear: number | null;
					yearsFromGraduation: number;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					};
				};
				academicTerm: {
					__typename?: "AcademicTerm";
					id: string;
					name: string;
					academicYear: { __typename?: "AcademicYear"; id: string; name: string };
				};
				reportCardSections: Array<{
					__typename?: "ReportCardSection";
					id: string;
					isComplete: boolean;
					comment: string;
					generalComment1: string;
					generalComment2: string;
					reportCardSectionPolicy: {
						__typename?: "ReportCardSectionPolicy";
						id: string;
						nameSuffix: string;
						usesDescription: boolean;
						descriptionLabel: string;
						description: string;
						usesOverallMark: boolean;
						isOverallMarkManual: boolean;
						overallMarkLabel: string;
						usesComment: boolean;
						commentLabel: string;
						isForHomeRoomSection: boolean;
						courseSection: {
							__typename?: "CourseSection";
							id: string;
							namePrefix: string;
							nameSuffix: string;
							teacherCourseSectionEnrollments: Array<{
								__typename?: "TeacherCourseSectionEnrollment";
								id: string;
								teacher: {
									__typename?: "Employee";
									id: string;
									person: { __typename?: "Person"; id: string; name: string; publicName: string };
								};
							}>;
							course: { __typename?: "Course"; id: string; name: string };
						} | null;
						homeRoomSection: {
							__typename?: "HomeRoomSection";
							id: string;
							namePrefix: string;
							nameSuffix: string;
							teacherHomeRoomSectionEnrollments: Array<{
								__typename?: "TeacherHomeRoomSectionEnrollment";
								id: string;
								teacher: {
									__typename?: "Employee";
									id: string;
									person: { __typename?: "Person"; id: string; name: string; publicName: string };
								};
							}>;
							homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
						} | null;
					};
					overallMarkValue: { __typename?: "MarkValue"; id: string; name: string } | null;
					reportCardSectionLearningObjectives: Array<{
						__typename?: "ReportCardSectionLearningObjective";
						id: string;
						learningObjective: {
							__typename?: "LearningObjective";
							id: string;
							description: string;
							learningObjectiveCategoryID: string;
							name: string;
						};
						markValue: { __typename?: "MarkValue"; id: string; name: string } | null;
					}>;
				}>;
			};
		}>;
	};
	learningObjectiveCategoryConnection: {
		__typename?: "LearningObjectiveCategoryConnection";
		edges: Array<{
			__typename?: "LearningObjectiveCategoryEdge";
			node: {
				__typename?: "LearningObjectiveCategory";
				id: string;
				name: string;
				markingSystem: {
					__typename?: "MarkingSystem";
					id: string;
					markValues: Array<{ __typename?: "MarkValue"; id: string; name: string }>;
				} | null;
			};
		}>;
	};
};

export type ReportCardSectionsDisplayQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardSectionFilterInput> | ReportCardSectionFilterInput>;
}>;

export type ReportCardSectionsDisplayQuery = {
	__typename?: "Query";
	reportCardSectionConnection: {
		__typename?: "ReportCardSectionConnection";
		edges: Array<{
			__typename?: "ReportCardSectionEdge";
			node: {
				__typename?: "ReportCardSection";
				id: string;
				isComplete: boolean;
				comment: string;
				generalComment1: string;
				generalComment2: string;
				reportCardSectionPolicy: {
					__typename?: "ReportCardSectionPolicy";
					id: string;
					nameSuffix: string;
					usesDescription: boolean;
					descriptionLabel: string;
					description: string;
					usesOverallMark: boolean;
					isOverallMarkManual: boolean;
					overallMarkLabel: string;
					usesComment: boolean;
					commentLabel: string;
					isForHomeRoomSection: boolean;
					courseSection: {
						__typename?: "CourseSection";
						id: string;
						namePrefix: string;
						nameSuffix: string;
						teacherCourseSectionEnrollments: Array<{
							__typename?: "TeacherCourseSectionEnrollment";
							id: string;
							teacher: {
								__typename?: "Employee";
								id: string;
								person: { __typename?: "Person"; id: string; name: string; publicName: string };
							};
						}>;
						course: { __typename?: "Course"; id: string; name: string };
					} | null;
					homeRoomSection: {
						__typename?: "HomeRoomSection";
						id: string;
						namePrefix: string;
						nameSuffix: string;
						teacherHomeRoomSectionEnrollments: Array<{
							__typename?: "TeacherHomeRoomSectionEnrollment";
							id: string;
							teacher: {
								__typename?: "Employee";
								id: string;
								person: { __typename?: "Person"; id: string; name: string; publicName: string };
							};
						}>;
						homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
					} | null;
				};
				overallMarkValue: { __typename?: "MarkValue"; id: string; name: string } | null;
				reportCardSectionLearningObjectives: Array<{
					__typename?: "ReportCardSectionLearningObjective";
					id: string;
					learningObjective: {
						__typename?: "LearningObjective";
						id: string;
						description: string;
						learningObjectiveCategoryID: string;
						name: string;
					};
					markValue: { __typename?: "MarkValue"; id: string; name: string } | null;
				}>;
			};
		}>;
	};
	learningObjectiveCategoryConnection: {
		__typename?: "LearningObjectiveCategoryConnection";
		edges: Array<{
			__typename?: "LearningObjectiveCategoryEdge";
			node: {
				__typename?: "LearningObjectiveCategory";
				id: string;
				name: string;
				markingSystem: {
					__typename?: "MarkingSystem";
					id: string;
					markValues: Array<{ __typename?: "MarkValue"; id: string; name: string }>;
				} | null;
			};
		}>;
	};
};

export type ReportCardIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardFilterInput> | ReportCardFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ReportCardOrder>;
}>;

export type ReportCardIndexQuery = {
	__typename?: "Query";
	reportCardConnection: {
		__typename?: "ReportCardConnection";
		edges: Array<{
			__typename?: "ReportCardEdge";
			node: {
				__typename?: "ReportCard";
				id: string;
				isComplete: boolean;
				releaseDate: string | null;
				isReleased: boolean;
				fileURL: string;
				fileContentType: string;
				student: {
					__typename?: "Student";
					id: string;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					};
				};
				academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
			};
		}>;
	};
};

export type ReportCardNameFragment = {
	__typename?: "ReportCard";
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
	academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
};

export type ReportCardNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ReportCardNameQuery = {
	__typename?: "Query";
	reportCard: {
		__typename?: "ReportCard";
		id: string;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
		academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
	};
};

export type ReportCardNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardFilterInput> | ReportCardFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ReportCardOrder>;
}>;

export type ReportCardNamesQuery = {
	__typename?: "Query";
	reportCardConnection: {
		__typename?: "ReportCardConnection";
		edges: Array<{
			__typename?: "ReportCardEdge";
			node: {
				__typename?: "ReportCard";
				id: string;
				student: {
					__typename?: "Student";
					id: string;
					person: { __typename?: "Person"; id: string; name: string; publicName: string };
				};
				academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
			};
		}>;
	};
};

export type ReportCardPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardFilterInput> | ReportCardFilterInput>;
	order?: InputMaybe<ReportCardOrder>;
}>;

export type ReportCardPaginationQuery = {
	__typename?: "Query";
	reportCardConnection: {
		__typename?: "ReportCardConnection";
		totalCount: number;
		edges: Array<{ __typename?: "ReportCardEdge"; cursor: string }>;
	};
};

export type ReportCardSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardFilterInput> | ReportCardFilterInput>;
	order?: InputMaybe<ReportCardOrder>;
}>;

export type ReportCardSelectQuery = {
	__typename?: "Query";
	reportCardConnection: {
		__typename?: "ReportCardConnection";
		edges: Array<{
			__typename?: "ReportCardEdge";
			node: {
				__typename?: "ReportCard";
				id: string;
				student: {
					__typename?: "Student";
					id: string;
					person: { __typename?: "Person"; id: string; name: string; publicName: string };
				};
				academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
			};
		}>;
	};
};

export type ReportCardUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: ReportCardUpdateInput;
}>;

export type ReportCardUpdateMutation = {
	__typename?: "Mutation";
	updateReportCard: {
		__typename?: "ReportCard";
		id: string;
		isComplete: boolean;
		releaseDate: string | null;
		isReleased: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
		approvingUser: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type ReportCardSectionCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardSectionFilterInput> | ReportCardSectionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ReportCardSectionOrder>;
}>;

export type ReportCardSectionCountQuery = {
	__typename?: "Query";
	reportCardSectionConnection: { __typename?: "ReportCardSectionConnection"; totalCount: number };
};

export type ReportCardSectionCreateMutationVariables = Exact<{
	input: ReportCardSectionCreateInput;
}>;

export type ReportCardSectionCreateMutation = {
	__typename?: "Mutation";
	createReportCardSection: {
		__typename?: "ReportCardSection";
		id: string;
		comment: string;
		generalComment1: string;
		generalComment2: string;
		isComplete: boolean;
		overallMarkValue: { __typename?: "MarkValue"; id: string; name: string } | null;
		reportCard: {
			__typename?: "ReportCard";
			id: string;
			student: {
				__typename?: "Student";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			};
			academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
		};
		reportCardSectionPolicy: {
			__typename?: "ReportCardSectionPolicy";
			id: string;
			nameSuffix: string;
			courseSection: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			} | null;
			homeRoomSection: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			} | null;
		};
		submittingUser: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
	};
};

export type ReportCardSectionDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ReportCardSectionDeleteMutation = { __typename?: "Mutation"; deleteReportCardSection: boolean };

export type ReportCardSectionDetailFragment = {
	__typename?: "ReportCardSection";
	id: string;
	comment: string;
	generalComment1: string;
	generalComment2: string;
	isComplete: boolean;
	overallMarkValue: { __typename?: "MarkValue"; id: string; name: string } | null;
	reportCard: {
		__typename?: "ReportCard";
		id: string;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
		academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
	};
	reportCardSectionPolicy: {
		__typename?: "ReportCardSectionPolicy";
		id: string;
		nameSuffix: string;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		} | null;
		homeRoomSection: {
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		} | null;
	};
	submittingUser: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	} | null;
};

export type ReportCardSectionDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ReportCardSectionDetailQuery = {
	__typename?: "Query";
	reportCardSection: {
		__typename?: "ReportCardSection";
		id: string;
		comment: string;
		generalComment1: string;
		generalComment2: string;
		isComplete: boolean;
		overallMarkValue: { __typename?: "MarkValue"; id: string; name: string } | null;
		reportCard: {
			__typename?: "ReportCard";
			id: string;
			student: {
				__typename?: "Student";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			};
			academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
		};
		reportCardSectionPolicy: {
			__typename?: "ReportCardSectionPolicy";
			id: string;
			nameSuffix: string;
			courseSection: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			} | null;
			homeRoomSection: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			} | null;
		};
		submittingUser: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
	};
};

export type ReportCardSectionIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardSectionFilterInput> | ReportCardSectionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ReportCardSectionOrder>;
}>;

export type ReportCardSectionIndexQuery = {
	__typename?: "Query";
	reportCardSectionConnection: {
		__typename?: "ReportCardSectionConnection";
		edges: Array<{
			__typename?: "ReportCardSectionEdge";
			node: {
				__typename?: "ReportCardSection";
				id: string;
				comment: string;
				generalComment1: string;
				generalComment2: string;
				isComplete: boolean;
			};
		}>;
	};
};

export type ReportCardSectionNameFragment = {
	__typename?: "ReportCardSection";
	reportCardSectionPolicy: {
		__typename?: "ReportCardSectionPolicy";
		id: string;
		nameSuffix: string;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		} | null;
		homeRoomSection: {
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		} | null;
	};
};

export type ReportCardSectionNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ReportCardSectionNameQuery = {
	__typename?: "Query";
	reportCardSection: {
		__typename?: "ReportCardSection";
		id: string;
		reportCardSectionPolicy: {
			__typename?: "ReportCardSectionPolicy";
			id: string;
			nameSuffix: string;
			courseSection: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			} | null;
			homeRoomSection: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			} | null;
		};
	};
};

export type ReportCardSectionNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardSectionFilterInput> | ReportCardSectionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ReportCardSectionOrder>;
}>;

export type ReportCardSectionNamesQuery = {
	__typename?: "Query";
	reportCardSectionConnection: {
		__typename?: "ReportCardSectionConnection";
		edges: Array<{
			__typename?: "ReportCardSectionEdge";
			node: {
				__typename?: "ReportCardSection";
				id: string;
				reportCardSectionPolicy: {
					__typename?: "ReportCardSectionPolicy";
					id: string;
					nameSuffix: string;
					courseSection: {
						__typename?: "CourseSection";
						id: string;
						namePrefix: string;
						nameSuffix: string;
						course: { __typename?: "Course"; id: string; name: string };
					} | null;
					homeRoomSection: {
						__typename?: "HomeRoomSection";
						id: string;
						namePrefix: string;
						nameSuffix: string;
						homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
					} | null;
				};
			};
		}>;
	};
};

export type ReportCardSectionPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardSectionFilterInput> | ReportCardSectionFilterInput>;
	order?: InputMaybe<ReportCardSectionOrder>;
}>;

export type ReportCardSectionPaginationQuery = {
	__typename?: "Query";
	reportCardSectionConnection: {
		__typename?: "ReportCardSectionConnection";
		totalCount: number;
		edges: Array<{ __typename?: "ReportCardSectionEdge"; cursor: string }>;
	};
};

export type ReportCardSectionSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardSectionFilterInput> | ReportCardSectionFilterInput>;
	order?: InputMaybe<ReportCardSectionOrder>;
}>;

export type ReportCardSectionSelectQuery = {
	__typename?: "Query";
	reportCardSectionConnection: {
		__typename?: "ReportCardSectionConnection";
		edges: Array<{
			__typename?: "ReportCardSectionEdge";
			node: {
				__typename?: "ReportCardSection";
				id: string;
				reportCardSectionPolicy: {
					__typename?: "ReportCardSectionPolicy";
					id: string;
					nameSuffix: string;
					courseSection: {
						__typename?: "CourseSection";
						id: string;
						namePrefix: string;
						nameSuffix: string;
						course: { __typename?: "Course"; id: string; name: string };
					} | null;
					homeRoomSection: {
						__typename?: "HomeRoomSection";
						id: string;
						namePrefix: string;
						nameSuffix: string;
						homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
					} | null;
				};
			};
		}>;
	};
};

export type ReportCardSectionUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: ReportCardSectionUpdateInput;
}>;

export type ReportCardSectionUpdateMutation = {
	__typename?: "Mutation";
	updateReportCardSection: {
		__typename?: "ReportCardSection";
		id: string;
		comment: string;
		generalComment1: string;
		generalComment2: string;
		isComplete: boolean;
		overallMarkValue: { __typename?: "MarkValue"; id: string; name: string } | null;
		reportCard: {
			__typename?: "ReportCard";
			id: string;
			student: {
				__typename?: "Student";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			};
			academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
		};
		reportCardSectionPolicy: {
			__typename?: "ReportCardSectionPolicy";
			id: string;
			nameSuffix: string;
			courseSection: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			} | null;
			homeRoomSection: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			} | null;
		};
		submittingUser: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
	};
};

export type ReportCardSectionLearningObjectiveCountQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<ReportCardSectionLearningObjectiveFilterInput> | ReportCardSectionLearningObjectiveFilterInput
	>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ReportCardSectionLearningObjectiveOrder>;
}>;

export type ReportCardSectionLearningObjectiveCountQuery = {
	__typename?: "Query";
	reportCardSectionLearningObjectiveConnection: {
		__typename?: "ReportCardSectionLearningObjectiveConnection";
		totalCount: number;
	};
};

export type ReportCardSectionLearningObjectiveCreateMutationVariables = Exact<{
	input: ReportCardSectionLearningObjectiveCreateInput;
}>;

export type ReportCardSectionLearningObjectiveCreateMutation = {
	__typename?: "Mutation";
	createReportCardSectionLearningObjective: {
		__typename?: "ReportCardSectionLearningObjective";
		id: string;
		learningObjective: { __typename?: "LearningObjective"; id: string; name: string };
		markValue: { __typename?: "MarkValue"; id: string; name: string } | null;
		reportCardSection: {
			__typename?: "ReportCardSection";
			id: string;
			reportCardSectionPolicy: {
				__typename?: "ReportCardSectionPolicy";
				id: string;
				nameSuffix: string;
				courseSection: {
					__typename?: "CourseSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					course: { __typename?: "Course"; id: string; name: string };
				} | null;
				homeRoomSection: {
					__typename?: "HomeRoomSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
				} | null;
			};
		};
	};
};

export type ReportCardSectionLearningObjectiveDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ReportCardSectionLearningObjectiveDeleteMutation = {
	__typename?: "Mutation";
	deleteReportCardSectionLearningObjective: boolean;
};

export type ReportCardSectionLearningObjectiveDetailFragment = {
	__typename?: "ReportCardSectionLearningObjective";
	id: string;
	learningObjective: { __typename?: "LearningObjective"; id: string; name: string };
	markValue: { __typename?: "MarkValue"; id: string; name: string } | null;
	reportCardSection: {
		__typename?: "ReportCardSection";
		id: string;
		reportCardSectionPolicy: {
			__typename?: "ReportCardSectionPolicy";
			id: string;
			nameSuffix: string;
			courseSection: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			} | null;
			homeRoomSection: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			} | null;
		};
	};
};

export type ReportCardSectionLearningObjectiveDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ReportCardSectionLearningObjectiveDetailQuery = {
	__typename?: "Query";
	reportCardSectionLearningObjective: {
		__typename?: "ReportCardSectionLearningObjective";
		id: string;
		learningObjective: { __typename?: "LearningObjective"; id: string; name: string };
		markValue: { __typename?: "MarkValue"; id: string; name: string } | null;
		reportCardSection: {
			__typename?: "ReportCardSection";
			id: string;
			reportCardSectionPolicy: {
				__typename?: "ReportCardSectionPolicy";
				id: string;
				nameSuffix: string;
				courseSection: {
					__typename?: "CourseSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					course: { __typename?: "Course"; id: string; name: string };
				} | null;
				homeRoomSection: {
					__typename?: "HomeRoomSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
				} | null;
			};
		};
	};
};

export type ReportCardSectionLearningObjectiveIndexQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<ReportCardSectionLearningObjectiveFilterInput> | ReportCardSectionLearningObjectiveFilterInput
	>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ReportCardSectionLearningObjectiveOrder>;
}>;

export type ReportCardSectionLearningObjectiveIndexQuery = {
	__typename?: "Query";
	reportCardSectionLearningObjectiveConnection: {
		__typename?: "ReportCardSectionLearningObjectiveConnection";
		edges: Array<{
			__typename?: "ReportCardSectionLearningObjectiveEdge";
			node: { __typename?: "ReportCardSectionLearningObjective"; id: string };
		}>;
	};
};

export type ReportCardSectionLearningObjectiveNameFragment = {
	__typename?: "ReportCardSectionLearningObjective";
	id: string;
};

export type ReportCardSectionLearningObjectiveNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ReportCardSectionLearningObjectiveNameQuery = {
	__typename?: "Query";
	reportCardSectionLearningObjective: { __typename?: "ReportCardSectionLearningObjective"; id: string };
};

export type ReportCardSectionLearningObjectiveNamesQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<ReportCardSectionLearningObjectiveFilterInput> | ReportCardSectionLearningObjectiveFilterInput
	>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ReportCardSectionLearningObjectiveOrder>;
}>;

export type ReportCardSectionLearningObjectiveNamesQuery = {
	__typename?: "Query";
	reportCardSectionLearningObjectiveConnection: {
		__typename?: "ReportCardSectionLearningObjectiveConnection";
		edges: Array<{
			__typename?: "ReportCardSectionLearningObjectiveEdge";
			node: { __typename?: "ReportCardSectionLearningObjective"; id: string };
		}>;
	};
};

export type ReportCardSectionLearningObjectivePaginationQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<ReportCardSectionLearningObjectiveFilterInput> | ReportCardSectionLearningObjectiveFilterInput
	>;
	order?: InputMaybe<ReportCardSectionLearningObjectiveOrder>;
}>;

export type ReportCardSectionLearningObjectivePaginationQuery = {
	__typename?: "Query";
	reportCardSectionLearningObjectiveConnection: {
		__typename?: "ReportCardSectionLearningObjectiveConnection";
		totalCount: number;
		edges: Array<{ __typename?: "ReportCardSectionLearningObjectiveEdge"; cursor: string }>;
	};
};

export type ReportCardSectionLearningObjectiveSelectQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<ReportCardSectionLearningObjectiveFilterInput> | ReportCardSectionLearningObjectiveFilterInput
	>;
	order?: InputMaybe<ReportCardSectionLearningObjectiveOrder>;
}>;

export type ReportCardSectionLearningObjectiveSelectQuery = {
	__typename?: "Query";
	reportCardSectionLearningObjectiveConnection: {
		__typename?: "ReportCardSectionLearningObjectiveConnection";
		edges: Array<{
			__typename?: "ReportCardSectionLearningObjectiveEdge";
			node: { __typename?: "ReportCardSectionLearningObjective"; id: string };
		}>;
	};
};

export type ReportCardSectionLearningObjectiveUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: ReportCardSectionLearningObjectiveUpdateInput;
}>;

export type ReportCardSectionLearningObjectiveUpdateMutation = {
	__typename?: "Mutation";
	updateReportCardSectionLearningObjective: {
		__typename?: "ReportCardSectionLearningObjective";
		id: string;
		learningObjective: { __typename?: "LearningObjective"; id: string; name: string };
		markValue: { __typename?: "MarkValue"; id: string; name: string } | null;
		reportCardSection: {
			__typename?: "ReportCardSection";
			id: string;
			reportCardSectionPolicy: {
				__typename?: "ReportCardSectionPolicy";
				id: string;
				nameSuffix: string;
				courseSection: {
					__typename?: "CourseSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					course: { __typename?: "Course"; id: string; name: string };
				} | null;
				homeRoomSection: {
					__typename?: "HomeRoomSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
				} | null;
			};
		};
	};
};

export type ReportCardSectionPolicyCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardSectionPolicyFilterInput> | ReportCardSectionPolicyFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ReportCardSectionPolicyOrder>;
}>;

export type ReportCardSectionPolicyCountQuery = {
	__typename?: "Query";
	reportCardSectionPolicyConnection: { __typename?: "ReportCardSectionPolicyConnection"; totalCount: number };
};

export type ReportCardSectionPolicyCreateMutationVariables = Exact<{
	input: ReportCardSectionPolicyCreateInput;
}>;

export type ReportCardSectionPolicyCreateMutation = {
	__typename?: "Mutation";
	createReportCardSectionPolicy: {
		__typename?: "ReportCardSectionPolicy";
		id: string;
		nameSuffix: string;
		usesDescription: boolean;
		descriptionLabel: string;
		description: string;
		usesOverallMark: boolean;
		overallMarkLabel: string;
		isOverallMarkManual: boolean;
		usesComment: boolean;
		commentLabel: string;
		minCommentLength: number;
		maxCommentLength: number;
		isForHomeRoomSection: boolean;
		usesGeneralComments: boolean;
		minGeneralComment1Length: number;
		maxGeneralComment1Length: number;
		minGeneralComment2Length: number;
		maxGeneralComment2Length: number;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		} | null;
		homeRoomSection: {
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		} | null;
		overallMarkingSystem: { __typename?: "MarkingSystem"; id: string; name: string } | null;
	};
};

export type ReportCardSectionPolicyDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ReportCardSectionPolicyDeleteMutation = { __typename?: "Mutation"; deleteReportCardSectionPolicy: boolean };

export type ReportCardSectionPolicyDetailFragment = {
	__typename?: "ReportCardSectionPolicy";
	id: string;
	nameSuffix: string;
	usesDescription: boolean;
	descriptionLabel: string;
	description: string;
	usesOverallMark: boolean;
	overallMarkLabel: string;
	isOverallMarkManual: boolean;
	usesComment: boolean;
	commentLabel: string;
	minCommentLength: number;
	maxCommentLength: number;
	isForHomeRoomSection: boolean;
	usesGeneralComments: boolean;
	minGeneralComment1Length: number;
	maxGeneralComment1Length: number;
	minGeneralComment2Length: number;
	maxGeneralComment2Length: number;
	courseSection: {
		__typename?: "CourseSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		course: { __typename?: "Course"; id: string; name: string };
	} | null;
	homeRoomSection: {
		__typename?: "HomeRoomSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
	} | null;
	overallMarkingSystem: { __typename?: "MarkingSystem"; id: string; name: string } | null;
};

export type ReportCardSectionPolicyDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ReportCardSectionPolicyDetailQuery = {
	__typename?: "Query";
	reportCardSectionPolicy: {
		__typename?: "ReportCardSectionPolicy";
		id: string;
		nameSuffix: string;
		usesDescription: boolean;
		descriptionLabel: string;
		description: string;
		usesOverallMark: boolean;
		overallMarkLabel: string;
		isOverallMarkManual: boolean;
		usesComment: boolean;
		commentLabel: string;
		minCommentLength: number;
		maxCommentLength: number;
		isForHomeRoomSection: boolean;
		usesGeneralComments: boolean;
		minGeneralComment1Length: number;
		maxGeneralComment1Length: number;
		minGeneralComment2Length: number;
		maxGeneralComment2Length: number;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		} | null;
		homeRoomSection: {
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		} | null;
		overallMarkingSystem: { __typename?: "MarkingSystem"; id: string; name: string } | null;
	};
};

export type ReportCardSectionPolicyIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardSectionPolicyFilterInput> | ReportCardSectionPolicyFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ReportCardSectionPolicyOrder>;
}>;

export type ReportCardSectionPolicyIndexQuery = {
	__typename?: "Query";
	reportCardSectionPolicyConnection: {
		__typename?: "ReportCardSectionPolicyConnection";
		edges: Array<{
			__typename?: "ReportCardSectionPolicyEdge";
			node: {
				__typename?: "ReportCardSectionPolicy";
				id: string;
				nameSuffix: string;
				usesDescription: boolean;
				descriptionLabel: string;
				description: string;
				usesOverallMark: boolean;
				overallMarkLabel: string;
				isOverallMarkManual: boolean;
				usesComment: boolean;
				commentLabel: string;
				minCommentLength: number;
				maxCommentLength: number;
				isForHomeRoomSection: boolean;
				usesGeneralComments: boolean;
				minGeneralComment1Length: number;
				maxGeneralComment1Length: number;
				minGeneralComment2Length: number;
				maxGeneralComment2Length: number;
			};
		}>;
	};
};

export type ReportCardSectionPolicyNameFragment = {
	__typename?: "ReportCardSectionPolicy";
	nameSuffix: string;
	courseSection: {
		__typename?: "CourseSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		course: { __typename?: "Course"; id: string; name: string };
	} | null;
	homeRoomSection: {
		__typename?: "HomeRoomSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
	} | null;
};

export type ReportCardSectionPolicyNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ReportCardSectionPolicyNameQuery = {
	__typename?: "Query";
	reportCardSectionPolicy: {
		__typename?: "ReportCardSectionPolicy";
		id: string;
		nameSuffix: string;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		} | null;
		homeRoomSection: {
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		} | null;
	};
};

export type ReportCardSectionPolicyNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardSectionPolicyFilterInput> | ReportCardSectionPolicyFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ReportCardSectionPolicyOrder>;
}>;

export type ReportCardSectionPolicyNamesQuery = {
	__typename?: "Query";
	reportCardSectionPolicyConnection: {
		__typename?: "ReportCardSectionPolicyConnection";
		edges: Array<{
			__typename?: "ReportCardSectionPolicyEdge";
			node: {
				__typename?: "ReportCardSectionPolicy";
				id: string;
				nameSuffix: string;
				courseSection: {
					__typename?: "CourseSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					course: { __typename?: "Course"; id: string; name: string };
				} | null;
				homeRoomSection: {
					__typename?: "HomeRoomSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
				} | null;
			};
		}>;
	};
};

export type ReportCardSectionPolicyPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardSectionPolicyFilterInput> | ReportCardSectionPolicyFilterInput>;
	order?: InputMaybe<ReportCardSectionPolicyOrder>;
}>;

export type ReportCardSectionPolicyPaginationQuery = {
	__typename?: "Query";
	reportCardSectionPolicyConnection: {
		__typename?: "ReportCardSectionPolicyConnection";
		totalCount: number;
		edges: Array<{ __typename?: "ReportCardSectionPolicyEdge"; cursor: string }>;
	};
};

export type ReportCardSectionPolicySelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardSectionPolicyFilterInput> | ReportCardSectionPolicyFilterInput>;
	order?: InputMaybe<ReportCardSectionPolicyOrder>;
}>;

export type ReportCardSectionPolicySelectQuery = {
	__typename?: "Query";
	reportCardSectionPolicyConnection: {
		__typename?: "ReportCardSectionPolicyConnection";
		edges: Array<{
			__typename?: "ReportCardSectionPolicyEdge";
			node: {
				__typename?: "ReportCardSectionPolicy";
				id: string;
				nameSuffix: string;
				courseSection: {
					__typename?: "CourseSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					course: { __typename?: "Course"; id: string; name: string };
				} | null;
				homeRoomSection: {
					__typename?: "HomeRoomSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
				} | null;
			};
		}>;
	};
};

export type ReportCardSectionPolicyUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: ReportCardSectionPolicyUpdateInput;
}>;

export type ReportCardSectionPolicyUpdateMutation = {
	__typename?: "Mutation";
	updateReportCardSectionPolicy: {
		__typename?: "ReportCardSectionPolicy";
		id: string;
		nameSuffix: string;
		usesDescription: boolean;
		descriptionLabel: string;
		description: string;
		usesOverallMark: boolean;
		overallMarkLabel: string;
		isOverallMarkManual: boolean;
		usesComment: boolean;
		commentLabel: string;
		minCommentLength: number;
		maxCommentLength: number;
		isForHomeRoomSection: boolean;
		usesGeneralComments: boolean;
		minGeneralComment1Length: number;
		maxGeneralComment1Length: number;
		minGeneralComment2Length: number;
		maxGeneralComment2Length: number;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		} | null;
		homeRoomSection: {
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		} | null;
		overallMarkingSystem: { __typename?: "MarkingSystem"; id: string; name: string } | null;
	};
};

export type CourseAttendanceRecordCountStatisticsQueryVariables = Exact<{
	date: Scalars["Date"]["input"];
	studentFilters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	courseAttendanceRecordFilters?: InputMaybe<
		Array<CourseAttendanceRecordFilterInput> | CourseAttendanceRecordFilterInput
	>;
}>;

export type CourseAttendanceRecordCountStatisticsQuery = {
	__typename?: "Query";
	courseAttendanceRecordCountStatistics: {
		__typename?: "AttendanceRecordCountStatistics";
		students: number;
		present: number;
		presentTotal: number;
		absentExcused: number;
		absentUnexcused: number;
		absentTotal: number;
		lateArrivalExcused: number;
		lateArrivalUnexcused: number;
		lateArrivalTotal: number;
		earlyDepartureExcused: number;
		earlyDepartureUnexcused: number;
		earlyDepartureTotal: number;
		notTaken: number;
	};
};

export type CourseSectionAttendanceRecordsReportQueryVariables = Exact<{
	date: Scalars["Date"]["input"];
	courseSectionID: Scalars["ID"]["input"];
}>;

export type CourseSectionAttendanceRecordsReportQuery = {
	__typename?: "Query";
	studentConnection: {
		__typename?: "StudentConnection";
		edges: Array<{
			__typename?: "StudentEdge";
			node: {
				__typename?: "Student";
				id: string;
				courseAttendanceRecords: Array<{
					__typename?: "CourseAttendanceRecord";
					id: string;
					notes: string;
					attendanceStatus: {
						__typename?: "AttendanceStatus";
						id: string;
						code: string;
						name: string;
						description: string;
						indicatesAbsent: boolean;
						indicatesLateArrival: boolean;
						indicatesEarlyDeparture: boolean;
						indicatesExcused: boolean;
					};
				}>;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			};
		}>;
	};
};

export type CourseAttendanceRecordCountStatisticsRangeQueryVariables = Exact<{
	startDate: Scalars["Date"]["input"];
	endDate: Scalars["Date"]["input"];
	studentFilters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	courseAttendanceRecordFilters?: InputMaybe<
		Array<CourseAttendanceRecordFilterInput> | CourseAttendanceRecordFilterInput
	>;
}>;

export type CourseAttendanceRecordCountStatisticsRangeQuery = {
	__typename?: "Query";
	courseAttendanceRecordCountStatisticsRange: Array<{
		__typename?: "AttendanceRecordCountStatistics";
		date: string;
		students: number;
		present: number;
		presentTotal: number;
		absentExcused: number;
		absentUnexcused: number;
		absentTotal: number;
		lateArrivalExcused: number;
		lateArrivalUnexcused: number;
		lateArrivalTotal: number;
		earlyDepartureExcused: number;
		earlyDepartureUnexcused: number;
		earlyDepartureTotal: number;
		notTaken: number;
	}>;
};

export type SchoolAttendanceRecordCountStatisticsQueryVariables = Exact<{
	date: Scalars["Date"]["input"];
	studentFilters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	schoolAttendanceRecordFilters?: InputMaybe<
		Array<SchoolAttendanceRecordFilterInput> | SchoolAttendanceRecordFilterInput
	>;
}>;

export type SchoolAttendanceRecordCountStatisticsQuery = {
	__typename?: "Query";
	schoolAttendanceRecordCountStatistics: {
		__typename?: "AttendanceRecordCountStatistics";
		students: number;
		present: number;
		presentTotal: number;
		absentExcused: number;
		absentUnexcused: number;
		absentTotal: number;
		lateArrivalExcused: number;
		lateArrivalUnexcused: number;
		lateArrivalTotal: number;
		earlyDepartureExcused: number;
		earlyDepartureUnexcused: number;
		earlyDepartureTotal: number;
		notTaken: number;
	};
};

export type SchoolAttendanceRecordCountStatisticsWithStatusesQueryVariables = Exact<{
	date: Scalars["Date"]["input"];
	studentFilters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	schoolAttendanceRecordFilters?: InputMaybe<
		Array<SchoolAttendanceRecordFilterInput> | SchoolAttendanceRecordFilterInput
	>;
}>;

export type SchoolAttendanceRecordCountStatisticsWithStatusesQuery = {
	__typename?: "Query";
	schoolAttendanceRecordCountStatistics: {
		__typename?: "AttendanceRecordCountStatistics";
		students: number;
		present: number;
		presentTotal: number;
		absentExcused: number;
		absentUnexcused: number;
		absentTotal: number;
		lateArrivalExcused: number;
		lateArrivalUnexcused: number;
		lateArrivalTotal: number;
		earlyDepartureExcused: number;
		earlyDepartureUnexcused: number;
		earlyDepartureTotal: number;
		notTaken: number;
		statuses: Array<{
			__typename?: "AttendanceStatusCountStatistics";
			id: string;
			name: string;
			code: string;
			description: string;
			indicatesAbsent: boolean;
			indicatesLateArrival: boolean;
			indicatesEarlyDeparture: boolean;
			indicatesExcused: boolean;
			count: number;
		}>;
	};
};

export type SchoolAttendanceRecordCountStatisticsRangeQueryVariables = Exact<{
	startDate: Scalars["Date"]["input"];
	endDate: Scalars["Date"]["input"];
	studentFilters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	schoolAttendanceRecordFilters?: InputMaybe<
		Array<SchoolAttendanceRecordFilterInput> | SchoolAttendanceRecordFilterInput
	>;
}>;

export type SchoolAttendanceRecordCountStatisticsRangeQuery = {
	__typename?: "Query";
	schoolAttendanceRecordCountStatisticsRange: Array<{
		__typename?: "AttendanceRecordCountStatistics";
		date: string;
		students: number;
		present: number;
		presentTotal: number;
		absentExcused: number;
		absentUnexcused: number;
		absentTotal: number;
		lateArrivalExcused: number;
		lateArrivalUnexcused: number;
		lateArrivalTotal: number;
		earlyDepartureExcused: number;
		earlyDepartureUnexcused: number;
		earlyDepartureTotal: number;
		notTaken: number;
	}>;
};

export type StudentSchoolAttendanceRecordCountStatisticsRangeSumQueryVariables = Exact<{
	startDate: Scalars["Date"]["input"];
	endDate: Scalars["Date"]["input"];
	studentID: Scalars["ID"]["input"];
	schoolAttendanceRecordFilters?: InputMaybe<
		Array<SchoolAttendanceRecordFilterInput> | SchoolAttendanceRecordFilterInput
	>;
}>;

export type StudentSchoolAttendanceRecordCountStatisticsRangeSumQuery = {
	__typename?: "Query";
	studentSchoolAttendanceRecordCountStatisticsRangeSum: {
		__typename?: "AttendanceRecordCountStatistics";
		students: number;
		present: number;
		presentTotal: number;
		absentExcused: number;
		absentUnexcused: number;
		absentTotal: number;
		lateArrivalExcused: number;
		lateArrivalUnexcused: number;
		lateArrivalTotal: number;
		earlyDepartureExcused: number;
		earlyDepartureUnexcused: number;
		earlyDepartureTotal: number;
		notTaken: number;
	};
};

export type CommunicationCenterStatisticsQueryVariables = Exact<{
	announcementFilters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
	newsletterFilters?: InputMaybe<Array<NewsletterFilterInput> | NewsletterFilterInput>;
	postFilters?: InputMaybe<Array<PostFilterInput> | PostFilterInput>;
	calendarEventFilters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
}>;

export type CommunicationCenterStatisticsQuery = {
	__typename?: "Query";
	announcementStatistics: { __typename?: "AnnouncementStatistics"; count: number; views: number; reactions: number };
	newsletterStatistics: {
		__typename?: "NewsletterStatistics";
		count: number;
		views: number;
		reactions: number;
		comments: number;
	};
	postStatistics: { __typename?: "PostStatistics"; count: number; views: number; reactions: number; comments: number };
	calendarEventStatistics: {
		__typename?: "CalendarEventStatistics";
		count: number;
		responsesAttending: number;
		responsesMaybeAttending: number;
		responsesNotAttending: number;
	};
};

export type RoomCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<RoomFilterInput> | RoomFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<RoomOrder>;
}>;

export type RoomCountQuery = {
	__typename?: "Query";
	roomConnection: { __typename?: "RoomConnection"; totalCount: number };
};

export type RoomCreateMutationVariables = Exact<{
	input: RoomCreateInput;
}>;

export type RoomCreateMutation = {
	__typename?: "Mutation";
	createRoom: {
		__typename?: "Room";
		id: string;
		name: string;
		roomNumber: string;
		buildingFloor: { __typename?: "BuildingFloor"; id: string; level: number };
	};
};

export type RoomDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type RoomDeleteMutation = { __typename?: "Mutation"; deleteRoom: boolean };

export type RoomDetailFragment = {
	__typename?: "Room";
	id: string;
	name: string;
	roomNumber: string;
	buildingFloor: { __typename?: "BuildingFloor"; id: string; level: number };
};

export type RoomDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type RoomDetailQuery = {
	__typename?: "Query";
	room: {
		__typename?: "Room";
		id: string;
		name: string;
		roomNumber: string;
		buildingFloor: { __typename?: "BuildingFloor"; id: string; level: number };
	};
};

export type RoomIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<RoomFilterInput> | RoomFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<RoomOrder>;
}>;

export type RoomIndexQuery = {
	__typename?: "Query";
	roomConnection: {
		__typename?: "RoomConnection";
		edges: Array<{
			__typename?: "RoomEdge";
			node: {
				__typename?: "Room";
				id: string;
				name: string;
				roomNumber: string;
				buildingFloor: {
					__typename?: "BuildingFloor";
					id: string;
					level: number;
					building: {
						__typename?: "Building";
						id: string;
						name: string;
						campus: { __typename?: "Campus"; id: string; name: string };
					};
				};
			};
		}>;
	};
};

export type RoomNameFragment = { __typename?: "Room"; name: string };

export type RoomNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type RoomNameQuery = { __typename?: "Query"; room: { __typename?: "Room"; id: string; name: string } };

export type RoomNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<RoomFilterInput> | RoomFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<RoomOrder>;
}>;

export type RoomNamesQuery = {
	__typename?: "Query";
	roomConnection: {
		__typename?: "RoomConnection";
		edges: Array<{ __typename?: "RoomEdge"; node: { __typename?: "Room"; id: string; name: string } }>;
	};
};

export type RoomPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<RoomFilterInput> | RoomFilterInput>;
	order?: InputMaybe<RoomOrder>;
}>;

export type RoomPaginationQuery = {
	__typename?: "Query";
	roomConnection: {
		__typename?: "RoomConnection";
		totalCount: number;
		edges: Array<{ __typename?: "RoomEdge"; cursor: string }>;
	};
};

export type RoomSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<RoomFilterInput> | RoomFilterInput>;
	order?: InputMaybe<RoomOrder>;
}>;

export type RoomSelectQuery = {
	__typename?: "Query";
	roomConnection: {
		__typename?: "RoomConnection";
		edges: Array<{ __typename?: "RoomEdge"; node: { __typename?: "Room"; id: string; name: string } }>;
	};
};

export type RoomUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: RoomUpdateInput;
}>;

export type RoomUpdateMutation = {
	__typename?: "Mutation";
	updateRoom: {
		__typename?: "Room";
		id: string;
		name: string;
		roomNumber: string;
		buildingFloor: { __typename?: "BuildingFloor"; id: string; level: number };
	};
};

export type CreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutationVariables = Exact<{
	attendanceDate: Scalars["Date"]["input"];
	studentIDs: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
	attendanceStatusID: Scalars["ID"]["input"];
}>;

export type CreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutation = {
	__typename?: "Mutation";
	createOrUpdateBulkSchoolAttendanceRecordsOnDate: {
		__typename?: "SchoolAttendanceRecordConnection";
		edges: Array<{
			__typename?: "SchoolAttendanceRecordEdge";
			node: { __typename?: "SchoolAttendanceRecord"; id: string };
		}>;
	};
};

export type SchoolAttendanceRecordCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<SchoolAttendanceRecordFilterInput> | SchoolAttendanceRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SchoolAttendanceRecordOrder>;
}>;

export type SchoolAttendanceRecordCountQuery = {
	__typename?: "Query";
	schoolAttendanceRecordConnection: { __typename?: "SchoolAttendanceRecordConnection"; totalCount: number };
};

export type SchoolAttendanceRecordCreateMutationVariables = Exact<{
	input: SchoolAttendanceRecordCreateInput;
}>;

export type SchoolAttendanceRecordCreateMutation = {
	__typename?: "Mutation";
	createSchoolAttendanceRecord: {
		__typename?: "SchoolAttendanceRecord";
		id: string;
		createdAt: string;
		attendanceDate: string;
		arrivalTime: string | null;
		departureTime: string | null;
		notes: string;
		wasSetByCourseAttendance: boolean;
		attendanceStatus: { __typename?: "AttendanceStatus"; id: string; name: string; code: string };
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type SchoolAttendanceRecordDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SchoolAttendanceRecordDeleteMutation = { __typename?: "Mutation"; deleteSchoolAttendanceRecord: boolean };

export type SchoolAttendanceRecordDetailFragment = {
	__typename?: "SchoolAttendanceRecord";
	id: string;
	createdAt: string;
	attendanceDate: string;
	arrivalTime: string | null;
	departureTime: string | null;
	notes: string;
	wasSetByCourseAttendance: boolean;
	attendanceStatus: { __typename?: "AttendanceStatus"; id: string; name: string; code: string };
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	} | null;
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type SchoolAttendanceRecordDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SchoolAttendanceRecordDetailQuery = {
	__typename?: "Query";
	schoolAttendanceRecord: {
		__typename?: "SchoolAttendanceRecord";
		id: string;
		createdAt: string;
		attendanceDate: string;
		arrivalTime: string | null;
		departureTime: string | null;
		notes: string;
		wasSetByCourseAttendance: boolean;
		attendanceStatus: { __typename?: "AttendanceStatus"; id: string; name: string; code: string };
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type SchoolAttendanceRecordIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<SchoolAttendanceRecordFilterInput> | SchoolAttendanceRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SchoolAttendanceRecordOrder>;
}>;

export type SchoolAttendanceRecordIndexQuery = {
	__typename?: "Query";
	schoolAttendanceRecordConnection: {
		__typename?: "SchoolAttendanceRecordConnection";
		edges: Array<{
			__typename?: "SchoolAttendanceRecordEdge";
			node: {
				__typename?: "SchoolAttendanceRecord";
				id: string;
				createdAt: string;
				attendanceDate: string;
				arrivalTime: string | null;
				departureTime: string | null;
				notes: string;
				wasSetByCourseAttendance: boolean;
			};
		}>;
	};
};

export type SchoolAttendanceRecordListQueryVariables = Exact<{
	filters?: InputMaybe<Array<SchoolAttendanceRecordFilterInput> | SchoolAttendanceRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SchoolAttendanceRecordOrder>;
}>;

export type SchoolAttendanceRecordListQuery = {
	__typename?: "Query";
	schoolAttendanceRecordConnection: {
		__typename?: "SchoolAttendanceRecordConnection";
		edges: Array<{
			__typename?: "SchoolAttendanceRecordEdge";
			node: {
				__typename?: "SchoolAttendanceRecord";
				id: string;
				createdAt: string;
				attendanceDate: string;
				arrivalTime: string | null;
				departureTime: string | null;
				notes: string;
				wasSetByCourseAttendance: boolean;
				attendanceStatus: {
					__typename?: "AttendanceStatus";
					id: string;
					description: string;
					name: string;
					code: string;
					indicatesAbsent: boolean;
					indicatesLateArrival: boolean;
					indicatesEarlyDeparture: boolean;
					indicatesExcused: boolean;
				};
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
				} | null;
				student: {
					__typename?: "Student";
					id: string;
					person: { __typename?: "Person"; id: string; name: string; publicName: string };
				};
			};
		}>;
	};
};

export type SchoolAttendanceRecordListForCourseAttendanceQueryVariables = Exact<{
	filters?: InputMaybe<Array<SchoolAttendanceRecordFilterInput> | SchoolAttendanceRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SchoolAttendanceRecordOrder>;
}>;

export type SchoolAttendanceRecordListForCourseAttendanceQuery = {
	__typename?: "Query";
	schoolAttendanceRecordConnection: {
		__typename?: "SchoolAttendanceRecordConnection";
		edges: Array<{
			__typename?: "SchoolAttendanceRecordEdge";
			node: { __typename?: "SchoolAttendanceRecord"; id: string; studentID: string; attendanceStatusID: string };
		}>;
	};
};

export type SchoolAttendanceRecordNameFragment = { __typename?: "SchoolAttendanceRecord"; id: string };

export type SchoolAttendanceRecordNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SchoolAttendanceRecordNameQuery = {
	__typename?: "Query";
	schoolAttendanceRecord: { __typename?: "SchoolAttendanceRecord"; id: string };
};

export type SchoolAttendanceRecordNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<SchoolAttendanceRecordFilterInput> | SchoolAttendanceRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SchoolAttendanceRecordOrder>;
}>;

export type SchoolAttendanceRecordNamesQuery = {
	__typename?: "Query";
	schoolAttendanceRecordConnection: {
		__typename?: "SchoolAttendanceRecordConnection";
		edges: Array<{
			__typename?: "SchoolAttendanceRecordEdge";
			node: { __typename?: "SchoolAttendanceRecord"; id: string };
		}>;
	};
};

export type SchoolAttendanceRecordPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<SchoolAttendanceRecordFilterInput> | SchoolAttendanceRecordFilterInput>;
	order?: InputMaybe<SchoolAttendanceRecordOrder>;
}>;

export type SchoolAttendanceRecordPaginationQuery = {
	__typename?: "Query";
	schoolAttendanceRecordConnection: {
		__typename?: "SchoolAttendanceRecordConnection";
		totalCount: number;
		edges: Array<{ __typename?: "SchoolAttendanceRecordEdge"; cursor: string }>;
	};
};

export type SchoolAttendanceRecordSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<SchoolAttendanceRecordFilterInput> | SchoolAttendanceRecordFilterInput>;
	order?: InputMaybe<SchoolAttendanceRecordOrder>;
}>;

export type SchoolAttendanceRecordSelectQuery = {
	__typename?: "Query";
	schoolAttendanceRecordConnection: {
		__typename?: "SchoolAttendanceRecordConnection";
		edges: Array<{
			__typename?: "SchoolAttendanceRecordEdge";
			node: { __typename?: "SchoolAttendanceRecord"; id: string };
		}>;
	};
};

export type StudentSchoolAttendanceRecordsQueryVariables = Exact<{
	filters?: InputMaybe<Array<SchoolAttendanceRecordFilterInput> | SchoolAttendanceRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SchoolAttendanceRecordOrder>;
}>;

export type StudentSchoolAttendanceRecordsQuery = {
	__typename?: "Query";
	schoolAttendanceRecordConnection: {
		__typename?: "SchoolAttendanceRecordConnection";
		edges: Array<{
			__typename?: "SchoolAttendanceRecordEdge";
			node: {
				__typename?: "SchoolAttendanceRecord";
				id: string;
				createdAt: string;
				attendanceDate: string;
				notes: string;
				arrivalTime: string | null;
				departureTime: string | null;
				wasSetByCourseAttendance: boolean;
				attendanceStatus: {
					__typename?: "AttendanceStatus";
					id: string;
					indicatesAbsent: boolean;
					indicatesLateArrival: boolean;
					indicatesEarlyDeparture: boolean;
					indicatesExcused: boolean;
					name: string;
					code: string;
				};
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
				} | null;
			};
		}>;
	};
};

export type SchoolAttendanceRecordUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: SchoolAttendanceRecordUpdateInput;
}>;

export type SchoolAttendanceRecordUpdateMutation = {
	__typename?: "Mutation";
	updateSchoolAttendanceRecord: {
		__typename?: "SchoolAttendanceRecord";
		id: string;
		createdAt: string;
		attendanceDate: string;
		arrivalTime: string | null;
		departureTime: string | null;
		notes: string;
		wasSetByCourseAttendance: boolean;
		attendanceStatus: { __typename?: "AttendanceStatus"; id: string; name: string; code: string };
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type ServiceCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<ServiceFilterInput> | ServiceFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ServiceOrder>;
}>;

export type ServiceCountQuery = {
	__typename?: "Query";
	serviceConnection: { __typename?: "ServiceConnection"; totalCount: number };
};

export type ServiceCreateMutationVariables = Exact<{
	input: ServiceCreateInput;
}>;

export type ServiceCreateMutation = {
	__typename?: "Mutation";
	createService: {
		__typename?: "Service";
		id: string;
		name: string;
		description: string;
		category: ServiceCategory;
		isActive: boolean;
		price: number;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
	};
};

export type ServiceDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ServiceDeleteMutation = { __typename?: "Mutation"; deleteService: boolean };

export type ServiceDetailFragment = {
	__typename?: "Service";
	id: string;
	name: string;
	description: string;
	category: ServiceCategory;
	isActive: boolean;
	price: number;
	classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
};

export type ServiceDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ServiceDetailQuery = {
	__typename?: "Query";
	service: {
		__typename?: "Service";
		id: string;
		name: string;
		description: string;
		category: ServiceCategory;
		isActive: boolean;
		price: number;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
	};
};

export type ServiceIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<ServiceFilterInput> | ServiceFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ServiceOrder>;
}>;

export type ServiceIndexQuery = {
	__typename?: "Query";
	serviceConnection: {
		__typename?: "ServiceConnection";
		edges: Array<{
			__typename?: "ServiceEdge";
			node: {
				__typename?: "Service";
				id: string;
				name: string;
				description: string;
				category: ServiceCategory;
				isActive: boolean;
				price: number;
			};
		}>;
	};
};

export type ServiceInformationListQueryVariables = Exact<{
	filters?: InputMaybe<Array<ServiceFilterInput> | ServiceFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ServiceOrder>;
}>;

export type ServiceInformationListQuery = {
	__typename?: "Query";
	serviceConnection: {
		__typename?: "ServiceConnection";
		edges: Array<{
			__typename?: "ServiceEdge";
			node: {
				__typename?: "Service";
				id: string;
				name: string;
				description: string;
				category: ServiceCategory;
				isActive: boolean;
				price: number;
			};
		}>;
	};
};

export type ServiceNameFragment = { __typename?: "Service"; name: string };

export type ServiceNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ServiceNameQuery = { __typename?: "Query"; service: { __typename?: "Service"; id: string; name: string } };

export type ServiceNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<ServiceFilterInput> | ServiceFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ServiceOrder>;
}>;

export type ServiceNamesQuery = {
	__typename?: "Query";
	serviceConnection: {
		__typename?: "ServiceConnection";
		edges: Array<{ __typename?: "ServiceEdge"; node: { __typename?: "Service"; id: string; name: string } }>;
	};
};

export type ServicePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<ServiceFilterInput> | ServiceFilterInput>;
	order?: InputMaybe<ServiceOrder>;
}>;

export type ServicePaginationQuery = {
	__typename?: "Query";
	serviceConnection: {
		__typename?: "ServiceConnection";
		totalCount: number;
		edges: Array<{ __typename?: "ServiceEdge"; cursor: string }>;
	};
};

export type ServiceSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<ServiceFilterInput> | ServiceFilterInput>;
	order?: InputMaybe<ServiceOrder>;
}>;

export type ServiceSelectQuery = {
	__typename?: "Query";
	serviceConnection: {
		__typename?: "ServiceConnection";
		edges: Array<{
			__typename?: "ServiceEdge";
			node: { __typename?: "Service"; id: string; price: number; name: string };
		}>;
	};
};

export type ServiceUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: ServiceUpdateInput;
}>;

export type ServiceUpdateMutation = {
	__typename?: "Mutation";
	updateService: {
		__typename?: "Service";
		id: string;
		name: string;
		description: string;
		category: ServiceCategory;
		isActive: boolean;
		price: number;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
	};
};

export type SessionCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<SessionFilterInput> | SessionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SessionOrder>;
}>;

export type SessionCountQuery = {
	__typename?: "Query";
	sessionConnection: { __typename?: "SessionConnection"; totalCount: number };
};

export type SessionDetailFragment = {
	__typename?: "Session";
	id: string;
	createdAt: string;
	updatedAt: string;
	expiresAt: string;
	longestInactiveSec: number;
	isVerified: boolean;
	isCurrent: boolean;
	loginRecord: { __typename?: "LoginRecord"; id: string } | null;
	mfaInvalidOTPAttempts: Array<{ __typename?: "MFAInvalidOTPAttempt"; id: string }>;
	trustedDevice: { __typename?: "TrustedDevice"; id: string; name: string } | null;
	user: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	};
};

export type SessionDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SessionDetailQuery = {
	__typename?: "Query";
	session: {
		__typename?: "Session";
		id: string;
		createdAt: string;
		updatedAt: string;
		expiresAt: string;
		longestInactiveSec: number;
		isVerified: boolean;
		isCurrent: boolean;
		loginRecord: { __typename?: "LoginRecord"; id: string } | null;
		mfaInvalidOTPAttempts: Array<{ __typename?: "MFAInvalidOTPAttempt"; id: string }>;
		trustedDevice: { __typename?: "TrustedDevice"; id: string; name: string } | null;
		user: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
	};
};

export type SessionIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<SessionFilterInput> | SessionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SessionOrder>;
}>;

export type SessionIndexQuery = {
	__typename?: "Query";
	sessionConnection: {
		__typename?: "SessionConnection";
		edges: Array<{
			__typename?: "SessionEdge";
			node: {
				__typename?: "Session";
				id: string;
				createdAt: string;
				updatedAt: string;
				expiresAt: string;
				longestInactiveSec: number;
				isVerified: boolean;
				isCurrent: boolean;
			};
		}>;
	};
};

export type SessionNameFragment = { __typename?: "Session"; id: string };

export type SessionNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SessionNameQuery = { __typename?: "Query"; session: { __typename?: "Session"; id: string } };

export type SessionNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<SessionFilterInput> | SessionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SessionOrder>;
}>;

export type SessionNamesQuery = {
	__typename?: "Query";
	sessionConnection: {
		__typename?: "SessionConnection";
		edges: Array<{ __typename?: "SessionEdge"; node: { __typename?: "Session"; id: string } }>;
	};
};

export type SessionPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<SessionFilterInput> | SessionFilterInput>;
	order?: InputMaybe<SessionOrder>;
}>;

export type SessionPaginationQuery = {
	__typename?: "Query";
	sessionConnection: {
		__typename?: "SessionConnection";
		totalCount: number;
		edges: Array<{ __typename?: "SessionEdge"; cursor: string }>;
	};
};

export type SessionSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<SessionFilterInput> | SessionFilterInput>;
	order?: InputMaybe<SessionOrder>;
}>;

export type SessionSelectQuery = {
	__typename?: "Query";
	sessionConnection: {
		__typename?: "SessionConnection";
		edges: Array<{ __typename?: "SessionEdge"; node: { __typename?: "Session"; id: string } }>;
	};
};

export type SharingRecordCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<SharingRecordFilterInput> | SharingRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SharingRecordOrder>;
}>;

export type SharingRecordCountQuery = {
	__typename?: "Query";
	sharingRecordConnection: { __typename?: "SharingRecordConnection"; totalCount: number };
};

export type SharingRecordCreateMutationVariables = Exact<{
	input: SharingRecordCreateInput;
}>;

export type SharingRecordCreateMutation = {
	__typename?: "Mutation";
	createSharingRecord: {
		__typename?: "SharingRecord";
		id: string;
		isPublic: boolean;
		includeEmployees: boolean;
		includeGuardians: boolean;
		includeAllUsersOfPersonTypes: boolean;
		announcement: { __typename?: "Announcement"; id: string; title: string } | null;
		calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string } | null;
		classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
		courseSections: Array<{
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		}>;
		homeRoomSections: Array<{
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		}>;
		newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
		studentNote: { __typename?: "StudentNote"; id: string } | null;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		}>;
	};
};

export type SharingRecordDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SharingRecordDeleteMutation = { __typename?: "Mutation"; deleteSharingRecord: boolean };

export type SharingRecordDetailInParentFragment = {
	__typename?: "SharingRecord";
	id: string;
	isPublic: boolean;
	includeEmployees: boolean;
	includeGuardians: boolean;
	includeAllUsersOfPersonTypes: boolean;
	classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
	classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
	courseSections: Array<{
		__typename?: "CourseSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		course: { __typename?: "Course"; id: string; name: string };
	}>;
	homeRoomSections: Array<{
		__typename?: "HomeRoomSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
	}>;
	userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
	users: Array<{
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	}>;
};

export type SharingRecordDetailFragment = {
	__typename?: "SharingRecord";
	id: string;
	isPublic: boolean;
	includeEmployees: boolean;
	includeGuardians: boolean;
	includeAllUsersOfPersonTypes: boolean;
	announcement: { __typename?: "Announcement"; id: string; title: string } | null;
	calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string } | null;
	classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
	classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
	courseSections: Array<{
		__typename?: "CourseSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		course: { __typename?: "Course"; id: string; name: string };
	}>;
	homeRoomSections: Array<{
		__typename?: "HomeRoomSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
	}>;
	newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
	post: { __typename?: "Post"; id: string; title: string } | null;
	studentNote: { __typename?: "StudentNote"; id: string } | null;
	userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
	users: Array<{
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	}>;
};

export type SharingRecordDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SharingRecordDetailQuery = {
	__typename?: "Query";
	sharingRecord: {
		__typename?: "SharingRecord";
		id: string;
		isPublic: boolean;
		includeEmployees: boolean;
		includeGuardians: boolean;
		includeAllUsersOfPersonTypes: boolean;
		announcement: { __typename?: "Announcement"; id: string; title: string } | null;
		calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string } | null;
		classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
		courseSections: Array<{
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		}>;
		homeRoomSections: Array<{
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		}>;
		newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
		studentNote: { __typename?: "StudentNote"; id: string } | null;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		}>;
	};
};

export type SharingRecordIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<SharingRecordFilterInput> | SharingRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SharingRecordOrder>;
}>;

export type SharingRecordIndexQuery = {
	__typename?: "Query";
	sharingRecordConnection: {
		__typename?: "SharingRecordConnection";
		edges: Array<{
			__typename?: "SharingRecordEdge";
			node: {
				__typename?: "SharingRecord";
				id: string;
				isPublic: boolean;
				includeEmployees: boolean;
				includeGuardians: boolean;
				includeAllUsersOfPersonTypes: boolean;
			};
		}>;
	};
};

export type SharingRecordNameFragment = { __typename?: "SharingRecord"; id: string };

export type SharingRecordNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SharingRecordNameQuery = {
	__typename?: "Query";
	sharingRecord: { __typename?: "SharingRecord"; id: string };
};

export type SharingRecordNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<SharingRecordFilterInput> | SharingRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SharingRecordOrder>;
}>;

export type SharingRecordNamesQuery = {
	__typename?: "Query";
	sharingRecordConnection: {
		__typename?: "SharingRecordConnection";
		edges: Array<{ __typename?: "SharingRecordEdge"; node: { __typename?: "SharingRecord"; id: string } }>;
	};
};

export type SharingRecordPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<SharingRecordFilterInput> | SharingRecordFilterInput>;
	order?: InputMaybe<SharingRecordOrder>;
}>;

export type SharingRecordPaginationQuery = {
	__typename?: "Query";
	sharingRecordConnection: {
		__typename?: "SharingRecordConnection";
		totalCount: number;
		edges: Array<{ __typename?: "SharingRecordEdge"; cursor: string }>;
	};
};

export type SharingRecordSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<SharingRecordFilterInput> | SharingRecordFilterInput>;
	order?: InputMaybe<SharingRecordOrder>;
}>;

export type SharingRecordSelectQuery = {
	__typename?: "Query";
	sharingRecordConnection: {
		__typename?: "SharingRecordConnection";
		edges: Array<{ __typename?: "SharingRecordEdge"; node: { __typename?: "SharingRecord"; id: string } }>;
	};
};

export type SharingRecordUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: SharingRecordUpdateInput;
}>;

export type SharingRecordUpdateMutation = {
	__typename?: "Mutation";
	updateSharingRecord: {
		__typename?: "SharingRecord";
		id: string;
		isPublic: boolean;
		includeEmployees: boolean;
		includeGuardians: boolean;
		includeAllUsersOfPersonTypes: boolean;
		announcement: { __typename?: "Announcement"; id: string; title: string } | null;
		calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string } | null;
		classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
		courseSections: Array<{
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		}>;
		homeRoomSections: Array<{
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		}>;
		newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
		studentNote: { __typename?: "StudentNote"; id: string } | null;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		}>;
	};
};

export type SharingRecordPreviewQueryVariables = Exact<{
	filters?: InputMaybe<Array<SharingRecordFilterInput> | SharingRecordFilterInput>;
}>;

export type SharingRecordPreviewQuery = {
	__typename?: "Query";
	sharingRecordConnection: {
		__typename?: "SharingRecordConnection";
		edges: Array<{
			__typename?: "SharingRecordEdge";
			node: {
				__typename?: "SharingRecord";
				id: string;
				isPublic: boolean;
				userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
			};
		}>;
	};
	userConnection: { __typename?: "UserConnection"; totalCount: number };
};

export type SharingRecordUsersPreviewQueryVariables = Exact<{
	sharingRecord: SharingRecordCreateInput;
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type SharingRecordUsersPreviewQuery = {
	__typename?: "Query";
	sharedUserConnection: {
		__typename?: "UserConnection";
		totalCount: number;
		pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor: string | null };
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				email: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
					employee: { __typename?: "Employee"; id: string; jobTitle: string; role: EmployeeRole } | null;
					guardian: { __typename?: "Guardian"; id: string } | null;
					student: {
						__typename?: "Student";
						id: string;
						graduationYear: number | null;
						yearsFromGraduation: number;
					} | null;
				} | null;
			};
		}>;
	};
};

export type SocialCommentCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialCommentFilterInput> | SocialCommentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SocialCommentOrder>;
}>;

export type SocialCommentCountQuery = {
	__typename?: "Query";
	socialCommentConnection: { __typename?: "SocialCommentConnection"; totalCount: number };
};

export type SocialCommentCreateMutationVariables = Exact<{
	input: SocialCommentCreateInput;
}>;

export type SocialCommentCreateMutation = {
	__typename?: "Mutation";
	createSocialComment: {
		__typename?: "SocialComment";
		id: string;
		createdAt: string;
		body: string;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
		mediaAttachment: { __typename?: "MediaAttachment"; id: string; title: string } | null;
		newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
		studentNote: { __typename?: "StudentNote"; id: string } | null;
	};
};

export type SocialCommentDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SocialCommentDeleteMutation = { __typename?: "Mutation"; deleteSocialComment: boolean };

export type SocialCommentDetailFragment = {
	__typename?: "SocialComment";
	id: string;
	createdAt: string;
	body: string;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	};
	mediaAttachment: { __typename?: "MediaAttachment"; id: string; title: string } | null;
	newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
	post: { __typename?: "Post"; id: string; title: string } | null;
	studentNote: { __typename?: "StudentNote"; id: string } | null;
};

export type SocialCommentDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SocialCommentDetailQuery = {
	__typename?: "Query";
	socialComment: {
		__typename?: "SocialComment";
		id: string;
		createdAt: string;
		body: string;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
		mediaAttachment: { __typename?: "MediaAttachment"; id: string; title: string } | null;
		newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
		studentNote: { __typename?: "StudentNote"; id: string } | null;
	};
};

export type SocialCommentIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialCommentFilterInput> | SocialCommentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SocialCommentOrder>;
}>;

export type SocialCommentIndexQuery = {
	__typename?: "Query";
	socialCommentConnection: {
		__typename?: "SocialCommentConnection";
		edges: Array<{
			__typename?: "SocialCommentEdge";
			node: { __typename?: "SocialComment"; id: string; createdAt: string; body: string };
		}>;
	};
};

export type SocialCommentListQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialCommentFilterInput> | SocialCommentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SocialCommentOrder>;
}>;

export type SocialCommentListQuery = {
	__typename?: "Query";
	socialCommentConnection: {
		__typename?: "SocialCommentConnection";
		totalCount: number;
		edges: Array<{
			__typename?: "SocialCommentEdge";
			node: {
				__typename?: "SocialComment";
				id: string;
				body: string;
				createdAt: string;
				author: {
					__typename?: "User";
					id: string;
					isCurrent: boolean;
					email: string;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					} | null;
				};
			};
		}>;
	};
};

export type SocialCommentNameFragment = { __typename?: "SocialComment"; id: string };

export type SocialCommentNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SocialCommentNameQuery = {
	__typename?: "Query";
	socialComment: { __typename?: "SocialComment"; id: string };
};

export type SocialCommentNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialCommentFilterInput> | SocialCommentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SocialCommentOrder>;
}>;

export type SocialCommentNamesQuery = {
	__typename?: "Query";
	socialCommentConnection: {
		__typename?: "SocialCommentConnection";
		edges: Array<{ __typename?: "SocialCommentEdge"; node: { __typename?: "SocialComment"; id: string } }>;
	};
};

export type SocialCommentPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialCommentFilterInput> | SocialCommentFilterInput>;
	order?: InputMaybe<SocialCommentOrder>;
}>;

export type SocialCommentPaginationQuery = {
	__typename?: "Query";
	socialCommentConnection: {
		__typename?: "SocialCommentConnection";
		totalCount: number;
		edges: Array<{ __typename?: "SocialCommentEdge"; cursor: string }>;
	};
};

export type SocialCommentSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialCommentFilterInput> | SocialCommentFilterInput>;
	order?: InputMaybe<SocialCommentOrder>;
}>;

export type SocialCommentSelectQuery = {
	__typename?: "Query";
	socialCommentConnection: {
		__typename?: "SocialCommentConnection";
		edges: Array<{ __typename?: "SocialCommentEdge"; node: { __typename?: "SocialComment"; id: string } }>;
	};
};

export type SocialCommentUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: SocialCommentUpdateInput;
}>;

export type SocialCommentUpdateMutation = {
	__typename?: "Mutation";
	updateSocialComment: {
		__typename?: "SocialComment";
		id: string;
		createdAt: string;
		body: string;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
		mediaAttachment: { __typename?: "MediaAttachment"; id: string; title: string } | null;
		newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
		studentNote: { __typename?: "StudentNote"; id: string } | null;
	};
};

export type SocialReactionCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialReactionFilterInput> | SocialReactionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SocialReactionOrder>;
}>;

export type SocialReactionCountQuery = {
	__typename?: "Query";
	socialReactionConnection: { __typename?: "SocialReactionConnection"; totalCount: number };
};

export type SocialReactionCreateMutationVariables = Exact<{
	input: SocialReactionCreateInput;
}>;

export type SocialReactionCreateMutation = {
	__typename?: "Mutation";
	createSocialReaction: {
		__typename?: "SocialReaction";
		id: string;
		createdAt: string;
		reaction: SocialReactionReaction;
		announcement: { __typename?: "Announcement"; id: string; title: string } | null;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
		mediaAttachment: { __typename?: "MediaAttachment"; id: string; title: string } | null;
		newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
	};
};

export type SocialReactionDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SocialReactionDeleteMutation = { __typename?: "Mutation"; deleteSocialReaction: boolean };

export type SocialReactionDetailFragment = {
	__typename?: "SocialReaction";
	id: string;
	createdAt: string;
	reaction: SocialReactionReaction;
	announcement: { __typename?: "Announcement"; id: string; title: string } | null;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	};
	mediaAttachment: { __typename?: "MediaAttachment"; id: string; title: string } | null;
	newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
	post: { __typename?: "Post"; id: string; title: string } | null;
};

export type SocialReactionDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SocialReactionDetailQuery = {
	__typename?: "Query";
	socialReaction: {
		__typename?: "SocialReaction";
		id: string;
		createdAt: string;
		reaction: SocialReactionReaction;
		announcement: { __typename?: "Announcement"; id: string; title: string } | null;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
		mediaAttachment: { __typename?: "MediaAttachment"; id: string; title: string } | null;
		newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
	};
};

export type SocialReactionIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialReactionFilterInput> | SocialReactionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SocialReactionOrder>;
}>;

export type SocialReactionIndexQuery = {
	__typename?: "Query";
	socialReactionConnection: {
		__typename?: "SocialReactionConnection";
		edges: Array<{
			__typename?: "SocialReactionEdge";
			node: { __typename?: "SocialReaction"; id: string; createdAt: string; reaction: SocialReactionReaction };
		}>;
	};
};

export type SocialReactionNameFragment = { __typename?: "SocialReaction"; id: string };

export type SocialReactionNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SocialReactionNameQuery = {
	__typename?: "Query";
	socialReaction: { __typename?: "SocialReaction"; id: string };
};

export type SocialReactionNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialReactionFilterInput> | SocialReactionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SocialReactionOrder>;
}>;

export type SocialReactionNamesQuery = {
	__typename?: "Query";
	socialReactionConnection: {
		__typename?: "SocialReactionConnection";
		edges: Array<{ __typename?: "SocialReactionEdge"; node: { __typename?: "SocialReaction"; id: string } }>;
	};
};

export type SocialReactionPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialReactionFilterInput> | SocialReactionFilterInput>;
	order?: InputMaybe<SocialReactionOrder>;
}>;

export type SocialReactionPaginationQuery = {
	__typename?: "Query";
	socialReactionConnection: {
		__typename?: "SocialReactionConnection";
		totalCount: number;
		edges: Array<{ __typename?: "SocialReactionEdge"; cursor: string }>;
	};
};

export type SocialReactionSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialReactionFilterInput> | SocialReactionFilterInput>;
	order?: InputMaybe<SocialReactionOrder>;
}>;

export type SocialReactionSelectQuery = {
	__typename?: "Query";
	socialReactionConnection: {
		__typename?: "SocialReactionConnection";
		edges: Array<{ __typename?: "SocialReactionEdge"; node: { __typename?: "SocialReaction"; id: string } }>;
	};
};

export type SocialReactionUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: SocialReactionUpdateInput;
}>;

export type SocialReactionUpdateMutation = {
	__typename?: "Mutation";
	updateSocialReaction: {
		__typename?: "SocialReaction";
		id: string;
		createdAt: string;
		reaction: SocialReactionReaction;
		announcement: { __typename?: "Announcement"; id: string; title: string } | null;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
		mediaAttachment: { __typename?: "MediaAttachment"; id: string; title: string } | null;
		newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
	};
};

export type StudentAcademicOverviewQueryVariables = Exact<{
	studentID: Scalars["ID"]["input"];
	academicTermID: Scalars["ID"]["input"];
	yearsFromGraduation: Scalars["Int"]["input"];
}>;

export type StudentAcademicOverviewQuery = {
	__typename?: "Query";
	homeRoomSectionConnection: {
		__typename?: "HomeRoomSectionConnection";
		edges: Array<{
			__typename?: "HomeRoomSectionEdge";
			node: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				teacherHomeRoomSectionEnrollments: Array<{
					__typename?: "TeacherHomeRoomSectionEnrollment";
					id: string;
					teacher: {
						__typename?: "Employee";
						id: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string };
					};
				}>;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			};
		}>;
	};
	courseSectionConnection: {
		__typename?: "CourseSectionConnection";
		edges: Array<{
			__typename?: "CourseSectionEdge";
			node: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				teacherCourseSectionEnrollments: Array<{
					__typename?: "TeacherCourseSectionEnrollment";
					id: string;
					teacher: {
						__typename?: "Employee";
						id: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string };
					};
				}>;
				course: { __typename?: "Course"; id: string; name: string };
			};
		}>;
	};
	campusConnection: {
		__typename?: "CampusConnection";
		edges: Array<{ __typename?: "CampusEdge"; node: { __typename?: "Campus"; id: string; name: string } }>;
	};
	classYearConnection: {
		__typename?: "ClassYearConnection";
		edges: Array<{ __typename?: "ClassYearEdge"; node: { __typename?: "ClassYear"; id: string; name: string } }>;
	};
};

export type StudentAttendanceCalendarQueryVariables = Exact<{
	studentID: Scalars["ID"]["input"];
	startDate: Scalars["Date"]["input"];
	endDate: Scalars["Date"]["input"];
}>;

export type StudentAttendanceCalendarQuery = {
	__typename?: "Query";
	schoolAttendanceRecordConnection: {
		__typename?: "SchoolAttendanceRecordConnection";
		edges: Array<{
			__typename?: "SchoolAttendanceRecordEdge";
			node: {
				__typename?: "SchoolAttendanceRecord";
				id: string;
				createdAt: string;
				attendanceDate: string;
				arrivalTime: string | null;
				departureTime: string | null;
				notes: string;
				wasSetByCourseAttendance: boolean;
				attendanceStatus: {
					__typename?: "AttendanceStatus";
					id: string;
					name: string;
					code: string;
					description: string;
					indicatesAbsent: boolean;
					indicatesLateArrival: boolean;
					indicatesEarlyDeparture: boolean;
					indicatesExcused: boolean;
				};
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
				} | null;
			};
		}>;
	};
	studentNoteConnection: {
		__typename?: "StudentNoteConnection";
		edges: Array<{
			__typename?: "StudentNoteEdge";
			node: {
				__typename?: "StudentNote";
				id: string;
				noteType: StudentNoteNoteType;
				body: string;
				studentAttendanceNote: {
					__typename?: "StudentAttendanceNote";
					id: string;
					startDate: string;
					endDate: string;
				} | null;
			};
		}>;
	};
};

export type StudentsSchoolAttendanceListQueryVariables = Exact<{
	date: Scalars["Date"]["input"];
	filters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentOrder>;
}>;

export type StudentsSchoolAttendanceListQuery = {
	__typename?: "Query";
	studentConnection: {
		__typename?: "StudentConnection";
		pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor: string | null };
		edges: Array<{
			__typename?: "StudentEdge";
			node: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				studentHomeRoomSectionEnrollments: Array<{
					__typename?: "StudentHomeRoomSectionEnrollment";
					id: string;
					homeRoomSection: {
						__typename?: "HomeRoomSection";
						id: string;
						namePrefix: string;
						nameSuffix: string;
						homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
					};
				}>;
				schoolAttendanceRecords: Array<{
					__typename?: "SchoolAttendanceRecord";
					id: string;
					createdAt: string;
					attendanceDate: string;
					arrivalTime: string | null;
					departureTime: string | null;
					notes: string;
					attendanceStatus: {
						__typename?: "AttendanceStatus";
						id: string;
						description: string;
						name: string;
						code: string;
						indicatesAbsent: boolean;
						indicatesLateArrival: boolean;
						indicatesEarlyDeparture: boolean;
						indicatesExcused: boolean;
					};
					author: {
						__typename?: "User";
						id: string;
						email: string;
						isCurrent: boolean;
						person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
					} | null;
				}>;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			};
		}>;
	};
};

export type StudentClassPlacementQueryVariables = Exact<{
	studentID: Scalars["ID"]["input"];
}>;

export type StudentClassPlacementQuery = {
	__typename?: "Query";
	studentHomeRoomSectionEnrollmentConnection: {
		__typename?: "StudentHomeRoomSectionEnrollmentConnection";
		edges: Array<{
			__typename?: "StudentHomeRoomSectionEnrollmentEdge";
			node: {
				__typename?: "StudentHomeRoomSectionEnrollment";
				homeRoomSection: {
					__typename?: "HomeRoomSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					teacherHomeRoomSectionEnrollments: Array<{
						__typename?: "TeacherHomeRoomSectionEnrollment";
						id: string;
						teacher: {
							__typename?: "Employee";
							id: string;
							jobTitle: string;
							bio: string;
							person: {
								__typename?: "Person";
								id: string;
								name: string;
								publicName: string;
								imageURL: string;
								imageKey: string;
								imageContentType: string;
							};
						};
					}>;
					homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
				};
			};
		}>;
	};
};

export type StudentMailCredentialsQueryVariables = Exact<{
	studentID: Scalars["ID"]["input"];
}>;

export type StudentMailCredentialsQuery = {
	__typename?: "Query";
	studentSchoolMailCredentials: { __typename?: "SchoolMailCredentials"; email: string; password: string };
};

export type StudentsClassYearLookupQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentOrder>;
}>;

export type StudentsClassYearLookupQuery = {
	__typename?: "Query";
	studentConnection: {
		__typename?: "StudentConnection";
		edges: Array<{
			__typename?: "StudentEdge";
			node: { __typename?: "Student"; id: string; graduationYear: number | null; yearsFromGraduation: number };
		}>;
	};
};

export type StudentCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentOrder>;
}>;

export type StudentCountQuery = {
	__typename?: "Query";
	studentConnection: { __typename?: "StudentConnection"; totalCount: number };
};

export type StudentCreateWizardReviewEnrollmentQueryVariables = Exact<{
	academicTermID: Scalars["ID"]["input"];
	homeRoomSectionID: Scalars["ID"]["input"];
	courseSectionIDs: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type StudentCreateWizardReviewEnrollmentQuery = {
	__typename?: "Query";
	academicTermConnection: {
		__typename?: "AcademicTermConnection";
		edges: Array<{ __typename?: "AcademicTermEdge"; node: { __typename?: "AcademicTerm"; id: string; name: string } }>;
	};
	homeRoomSectionConnection: {
		__typename?: "HomeRoomSectionConnection";
		edges: Array<{
			__typename?: "HomeRoomSectionEdge";
			node: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			};
		}>;
	};
	courseSectionConnection: {
		__typename?: "CourseSectionConnection";
		edges: Array<{
			__typename?: "CourseSectionEdge";
			node: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			};
		}>;
	};
};

export type CreateStudentFromWizardMutationVariables = Exact<{
	studentInputs: Array<StudentCreateInput> | StudentCreateInput;
	guardianInputs: Array<GuardianCreateInput> | GuardianCreateInput;
	addressInputs: Array<AddressCreateInput> | AddressCreateInput;
	guardianAddressPairs:
		| Array<Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]>
		| Array<Scalars["Int"]["input"]>
		| Scalars["Int"]["input"];
}>;

export type CreateStudentFromWizardMutation = {
	__typename?: "Mutation";
	createStudentFromWizard: {
		__typename?: "StudentConnection";
		edges: Array<{
			__typename?: "StudentEdge";
			node: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				yearsFromGraduation: number;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					middleName: string;
					familyName: string;
					nameOrder: PersonNameOrder;
					nickname: string;
					alternateNames: string;
					publicNameFormat: PersonPublicNameFormat;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
					gender: string;
					dateOfBirth: string | null;
					englishLanguageFluency: PersonEnglishLanguageFluency | null;
					occupation: string;
					nationalIdentificationNumber: string;
					governmentDocumentSeries: string;
					governmentDocumentNumber: string;
					governmentDocumentIssuedBy: string;
					nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
					languages: Array<{ __typename?: "Language"; id: string; name: string }>;
					addresses: Array<{
						__typename?: "Address";
						id: string;
						name: string;
						addressLine1: string;
						addressLine2: string;
						city: string;
						postalCode: string;
						stateOrProvince: string;
						country: { __typename?: "Country"; id: string; name: string };
					}>;
					emailAddresses: Array<{
						__typename?: "EmailAddress";
						id: string;
						emailAddress: string;
						isPrimary: boolean;
						name: string;
					}>;
					employee: {
						__typename?: "Employee";
						id: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string };
					} | null;
					guardian: {
						__typename?: "Guardian";
						id: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string };
					} | null;
					phoneNumbers: Array<{
						__typename?: "PhoneNumber";
						id: string;
						phoneNumber: string;
						isPrimary: boolean;
						name: string;
					}>;
					student: {
						__typename?: "Student";
						id: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string };
					} | null;
					user: {
						__typename?: "User";
						id: string;
						email: string;
						status: UserStatus;
						passwordUpdatedAt: string;
						isCurrent: boolean;
						timeZoneName: string;
						externalNotificationFrequency: UserExternalNotificationFrequency;
						permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
						person: {
							__typename?: "Person";
							id: string;
							name: string;
							publicName: string;
							employee: { __typename?: "Employee"; id: string } | null;
							guardian: { __typename?: "Guardian"; id: string } | null;
							student: { __typename?: "Student"; id: string } | null;
						} | null;
						userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
					} | null;
				};
				relationships: Array<{
					__typename?: "Relationship";
					id: string;
					relationshipType: string;
					isPrimary: boolean;
					isEmergencyContact: boolean;
					isAuthorizedForPickup: boolean;
					isFinancialContact: boolean;
					livesWithStudent: boolean;
					hasCustody: boolean;
					guardian: {
						__typename?: "Guardian";
						id: string;
						person: {
							__typename?: "Person";
							id: string;
							userID: string | null;
							name: string;
							publicName: string;
							imageURL: string;
							imageKey: string;
							imageContentType: string;
							addresses: Array<{
								__typename?: "Address";
								id: string;
								name: string;
								addressLine1: string;
								addressLine2: string;
								city: string;
								postalCode: string;
								stateOrProvince: string;
								country: { __typename?: "Country"; id: string; name: string };
							}>;
							emailAddresses: Array<{
								__typename?: "EmailAddress";
								id: string;
								emailAddress: string;
								isPrimary: boolean;
								name: string;
							}>;
							phoneNumbers: Array<{
								__typename?: "PhoneNumber";
								id: string;
								phoneNumber: string;
								isPrimary: boolean;
								name: string;
							}>;
						};
					};
				}>;
			};
		}>;
	};
};

export type StudentCreateMutationVariables = Exact<{
	input: StudentCreateInput;
}>;

export type StudentCreateMutation = {
	__typename?: "Mutation";
	createStudent: {
		__typename?: "Student";
		id: string;
		graduationYear: number | null;
		yearsFromGraduation: number;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			middleName: string;
			familyName: string;
			nameOrder: PersonNameOrder;
			nickname: string;
			alternateNames: string;
			publicNameFormat: PersonPublicNameFormat;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
			gender: string;
			dateOfBirth: string | null;
			englishLanguageFluency: PersonEnglishLanguageFluency | null;
			occupation: string;
			nationalIdentificationNumber: string;
			governmentDocumentSeries: string;
			governmentDocumentNumber: string;
			governmentDocumentIssuedBy: string;
			nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
			languages: Array<{ __typename?: "Language"; id: string; name: string }>;
			addresses: Array<{
				__typename?: "Address";
				id: string;
				name: string;
				addressLine1: string;
				addressLine2: string;
				city: string;
				postalCode: string;
				stateOrProvince: string;
				country: { __typename?: "Country"; id: string; name: string };
			}>;
			emailAddresses: Array<{
				__typename?: "EmailAddress";
				id: string;
				emailAddress: string;
				isPrimary: boolean;
				name: string;
			}>;
			employee: {
				__typename?: "Employee";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			guardian: {
				__typename?: "Guardian";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			phoneNumbers: Array<{
				__typename?: "PhoneNumber";
				id: string;
				phoneNumber: string;
				isPrimary: boolean;
				name: string;
			}>;
			student: {
				__typename?: "Student";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			user: {
				__typename?: "User";
				id: string;
				email: string;
				status: UserStatus;
				passwordUpdatedAt: string;
				isCurrent: boolean;
				timeZoneName: string;
				externalNotificationFrequency: UserExternalNotificationFrequency;
				permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					employee: { __typename?: "Employee"; id: string } | null;
					guardian: { __typename?: "Guardian"; id: string } | null;
					student: { __typename?: "Student"; id: string } | null;
				} | null;
				userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
			} | null;
		};
		relationships: Array<{
			__typename?: "Relationship";
			id: string;
			relationshipType: string;
			isPrimary: boolean;
			isEmergencyContact: boolean;
			isAuthorizedForPickup: boolean;
			isFinancialContact: boolean;
			livesWithStudent: boolean;
			hasCustody: boolean;
			guardian: {
				__typename?: "Guardian";
				id: string;
				person: {
					__typename?: "Person";
					id: string;
					userID: string | null;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
					addresses: Array<{
						__typename?: "Address";
						id: string;
						name: string;
						addressLine1: string;
						addressLine2: string;
						city: string;
						postalCode: string;
						stateOrProvince: string;
						country: { __typename?: "Country"; id: string; name: string };
					}>;
					emailAddresses: Array<{
						__typename?: "EmailAddress";
						id: string;
						emailAddress: string;
						isPrimary: boolean;
						name: string;
					}>;
					phoneNumbers: Array<{
						__typename?: "PhoneNumber";
						id: string;
						phoneNumber: string;
						isPrimary: boolean;
						name: string;
					}>;
				};
			};
		}>;
	};
};

export type StudentDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentDeleteMutation = { __typename?: "Mutation"; deleteStudent: boolean };

export type StudentDetailFragment = {
	__typename?: "Student";
	id: string;
	graduationYear: number | null;
	yearsFromGraduation: number;
	person: {
		__typename?: "Person";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		middleName: string;
		familyName: string;
		nameOrder: PersonNameOrder;
		nickname: string;
		alternateNames: string;
		publicNameFormat: PersonPublicNameFormat;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		gender: string;
		dateOfBirth: string | null;
		englishLanguageFluency: PersonEnglishLanguageFluency | null;
		occupation: string;
		nationalIdentificationNumber: string;
		governmentDocumentSeries: string;
		governmentDocumentNumber: string;
		governmentDocumentIssuedBy: string;
		nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
		languages: Array<{ __typename?: "Language"; id: string; name: string }>;
		addresses: Array<{
			__typename?: "Address";
			id: string;
			name: string;
			addressLine1: string;
			addressLine2: string;
			city: string;
			postalCode: string;
			stateOrProvince: string;
			country: { __typename?: "Country"; id: string; name: string };
		}>;
		emailAddresses: Array<{
			__typename?: "EmailAddress";
			id: string;
			emailAddress: string;
			isPrimary: boolean;
			name: string;
		}>;
		employee: {
			__typename?: "Employee";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		guardian: {
			__typename?: "Guardian";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		phoneNumbers: Array<{
			__typename?: "PhoneNumber";
			id: string;
			phoneNumber: string;
			isPrimary: boolean;
			name: string;
		}>;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		} | null;
		user: {
			__typename?: "User";
			id: string;
			email: string;
			status: UserStatus;
			passwordUpdatedAt: string;
			isCurrent: boolean;
			timeZoneName: string;
			externalNotificationFrequency: UserExternalNotificationFrequency;
			permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				employee: { __typename?: "Employee"; id: string } | null;
				guardian: { __typename?: "Guardian"; id: string } | null;
				student: { __typename?: "Student"; id: string } | null;
			} | null;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		} | null;
	};
	relationships: Array<{
		__typename?: "Relationship";
		id: string;
		relationshipType: string;
		isPrimary: boolean;
		isEmergencyContact: boolean;
		isAuthorizedForPickup: boolean;
		isFinancialContact: boolean;
		livesWithStudent: boolean;
		hasCustody: boolean;
		guardian: {
			__typename?: "Guardian";
			id: string;
			person: {
				__typename?: "Person";
				id: string;
				userID: string | null;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
				addresses: Array<{
					__typename?: "Address";
					id: string;
					name: string;
					addressLine1: string;
					addressLine2: string;
					city: string;
					postalCode: string;
					stateOrProvince: string;
					country: { __typename?: "Country"; id: string; name: string };
				}>;
				emailAddresses: Array<{
					__typename?: "EmailAddress";
					id: string;
					emailAddress: string;
					isPrimary: boolean;
					name: string;
				}>;
				phoneNumbers: Array<{
					__typename?: "PhoneNumber";
					id: string;
					phoneNumber: string;
					isPrimary: boolean;
					name: string;
				}>;
			};
		};
	}>;
};

export type StudentDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentDetailQuery = {
	__typename?: "Query";
	student: {
		__typename?: "Student";
		id: string;
		graduationYear: number | null;
		yearsFromGraduation: number;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			middleName: string;
			familyName: string;
			nameOrder: PersonNameOrder;
			nickname: string;
			alternateNames: string;
			publicNameFormat: PersonPublicNameFormat;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
			gender: string;
			dateOfBirth: string | null;
			englishLanguageFluency: PersonEnglishLanguageFluency | null;
			occupation: string;
			nationalIdentificationNumber: string;
			governmentDocumentSeries: string;
			governmentDocumentNumber: string;
			governmentDocumentIssuedBy: string;
			nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
			languages: Array<{ __typename?: "Language"; id: string; name: string }>;
			addresses: Array<{
				__typename?: "Address";
				id: string;
				name: string;
				addressLine1: string;
				addressLine2: string;
				city: string;
				postalCode: string;
				stateOrProvince: string;
				country: { __typename?: "Country"; id: string; name: string };
			}>;
			emailAddresses: Array<{
				__typename?: "EmailAddress";
				id: string;
				emailAddress: string;
				isPrimary: boolean;
				name: string;
			}>;
			employee: {
				__typename?: "Employee";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			guardian: {
				__typename?: "Guardian";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			phoneNumbers: Array<{
				__typename?: "PhoneNumber";
				id: string;
				phoneNumber: string;
				isPrimary: boolean;
				name: string;
			}>;
			student: {
				__typename?: "Student";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			user: {
				__typename?: "User";
				id: string;
				email: string;
				status: UserStatus;
				passwordUpdatedAt: string;
				isCurrent: boolean;
				timeZoneName: string;
				externalNotificationFrequency: UserExternalNotificationFrequency;
				permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					employee: { __typename?: "Employee"; id: string } | null;
					guardian: { __typename?: "Guardian"; id: string } | null;
					student: { __typename?: "Student"; id: string } | null;
				} | null;
				userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
			} | null;
		};
		relationships: Array<{
			__typename?: "Relationship";
			id: string;
			relationshipType: string;
			isPrimary: boolean;
			isEmergencyContact: boolean;
			isAuthorizedForPickup: boolean;
			isFinancialContact: boolean;
			livesWithStudent: boolean;
			hasCustody: boolean;
			guardian: {
				__typename?: "Guardian";
				id: string;
				person: {
					__typename?: "Person";
					id: string;
					userID: string | null;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
					addresses: Array<{
						__typename?: "Address";
						id: string;
						name: string;
						addressLine1: string;
						addressLine2: string;
						city: string;
						postalCode: string;
						stateOrProvince: string;
						country: { __typename?: "Country"; id: string; name: string };
					}>;
					emailAddresses: Array<{
						__typename?: "EmailAddress";
						id: string;
						emailAddress: string;
						isPrimary: boolean;
						name: string;
					}>;
					phoneNumbers: Array<{
						__typename?: "PhoneNumber";
						id: string;
						phoneNumber: string;
						isPrimary: boolean;
						name: string;
					}>;
				};
			};
		}>;
	};
};

export type StudentsWithEnrollmentIntentsListQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentOrder>;
	studentEnrollmentIntentFilters?: InputMaybe<
		Array<StudentEnrollmentIntentFilterInput> | StudentEnrollmentIntentFilterInput
	>;
}>;

export type StudentsWithEnrollmentIntentsListQuery = {
	__typename?: "Query";
	studentNextYearTuitionAmounts: Record<string, any> | null;
	studentConnection: {
		__typename?: "StudentConnection";
		edges: Array<{
			__typename?: "StudentEdge";
			node: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				yearsFromGraduation: number;
				studentEnrollmentIntents: Array<{
					__typename?: "StudentEnrollmentIntent";
					id: string;
					createdAt: string;
					isEnrolling: boolean;
					isInterestedInMealPlan: boolean;
					declineReason: StudentEnrollmentIntentDeclineReason | null;
					declineReasonDescription: string;
				}>;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type CreateOrUpdateBulkStudentEnrollmentIntentsMutationVariables = Exact<{
	inputs: Array<StudentEnrollmentIntentCreateInput> | StudentEnrollmentIntentCreateInput;
}>;

export type CreateOrUpdateBulkStudentEnrollmentIntentsMutation = {
	__typename?: "Mutation";
	createOrUpdateBulkStudentEnrollmentIntents: {
		__typename?: "StudentEnrollmentIntentConnection";
		edges: Array<{
			__typename?: "StudentEnrollmentIntentEdge";
			node: {
				__typename?: "StudentEnrollmentIntent";
				id: string;
				createdAt: string;
				isEnrolling: boolean;
				isInterestedInMealPlan: boolean;
				declineReason: StudentEnrollmentIntentDeclineReason | null;
				declineReasonDescription: string;
				academicYear: { __typename?: "AcademicYear"; id: string; name: string };
				student: {
					__typename?: "Student";
					id: string;
					person: { __typename?: "Person"; id: string; name: string; publicName: string };
				};
			};
		}>;
	};
};

export type UnenrollStudentFromAcademicTermMutationVariables = Exact<{
	studentID: Scalars["ID"]["input"];
	academicTermID: Scalars["ID"]["input"];
}>;

export type UnenrollStudentFromAcademicTermMutation = {
	__typename?: "Mutation";
	unenrollStudentFromAcademicTerm: {
		__typename?: "StudentAcademicTermUnenrollmentResult";
		studentAcademicTermEnrollments: { __typename?: "DeleteBulkResponse"; ids: Array<number> };
		studentHomeRoomSectionEnrollments: { __typename?: "DeleteBulkResponse"; ids: Array<number> };
		studentCourseSectionEnrollments: { __typename?: "DeleteBulkResponse"; ids: Array<number> };
	};
};

export type SetStudentEnrollmentMutationVariables = Exact<{
	studentID: Scalars["ID"]["input"];
	academicTermID: Scalars["ID"]["input"];
	lateStartDate?: InputMaybe<Scalars["Date"]["input"]>;
	earlyEndDate?: InputMaybe<Scalars["Date"]["input"]>;
	graduationYear: Scalars["Int"]["input"];
	homeRoomSectionID?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionIDs: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type SetStudentEnrollmentMutation = { __typename?: "Mutation"; setStudentEnrollment: boolean };

export type StudentEnrollmentsListQueryVariables = Exact<{
	studentID: Scalars["ID"]["input"];
	academicTermID: Scalars["ID"]["input"];
}>;

export type StudentEnrollmentsListQuery = {
	__typename?: "Query";
	studentAcademicTermEnrollmentConnection: {
		__typename?: "StudentAcademicTermEnrollmentConnection";
		edges: Array<{
			__typename?: "StudentAcademicTermEnrollmentEdge";
			node: {
				__typename?: "StudentAcademicTermEnrollment";
				id: string;
				lateStartDate: string | null;
				earlyEndDate: string | null;
			};
		}>;
	};
	studentHomeRoomSectionEnrollmentConnection: {
		__typename?: "StudentHomeRoomSectionEnrollmentConnection";
		edges: Array<{
			__typename?: "StudentHomeRoomSectionEnrollmentEdge";
			node: {
				__typename?: "StudentHomeRoomSectionEnrollment";
				id: string;
				lateStartDate: string | null;
				earlyEndDate: string | null;
				homeRoomSection: {
					__typename?: "HomeRoomSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
				};
			};
		}>;
	};
	studentCourseSectionEnrollmentConnection: {
		__typename?: "StudentCourseSectionEnrollmentConnection";
		edges: Array<{
			__typename?: "StudentCourseSectionEnrollmentEdge";
			node: {
				__typename?: "StudentCourseSectionEnrollment";
				id: string;
				lateStartDate: string | null;
				earlyEndDate: string | null;
				courseSection: {
					__typename?: "CourseSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					homeRoomSection: {
						__typename?: "HomeRoomSection";
						id: string;
						namePrefix: string;
						nameSuffix: string;
						homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
					} | null;
					course: { __typename?: "Course"; id: string; name: string };
				};
			};
		}>;
	};
};

export type StudentIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentOrder>;
}>;

export type StudentIndexQuery = {
	__typename?: "Query";
	studentConnection: {
		__typename?: "StudentConnection";
		edges: Array<{
			__typename?: "StudentEdge";
			node: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				yearsFromGraduation: number;
				person: {
					__typename?: "Person";
					id: string;
					gender: string;
					dateOfBirth: string | null;
					englishLanguageFluency: PersonEnglishLanguageFluency | null;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
					nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
					languages: Array<{ __typename?: "Language"; id: string; name: string }>;
				};
				studentAcademicTermEnrollments: Array<{
					__typename?: "StudentAcademicTermEnrollment";
					id: string;
					lateStartDate: string | null;
					earlyEndDate: string | null;
					academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string };
				}>;
				relationships: Array<{
					__typename?: "Relationship";
					id: string;
					relationshipType: string;
					guardian: {
						__typename?: "Guardian";
						id: string;
						person: {
							__typename?: "Person";
							id: string;
							name: string;
							publicName: string;
							addresses: Array<{
								__typename?: "Address";
								id: string;
								name: string;
								addressLine1: string;
								addressLine2: string;
								city: string;
								postalCode: string;
								stateOrProvince: string;
								country: { __typename?: "Country"; id: string; name: string };
							}>;
							emailAddresses: Array<{ __typename?: "EmailAddress"; id: string; emailAddress: string }>;
							phoneNumbers: Array<{ __typename?: "PhoneNumber"; id: string; phoneNumber: string }>;
						};
					};
				}>;
			};
		}>;
	};
};

export type StudentNameFragment = {
	__typename?: "Student";
	person: { __typename?: "Person"; id: string; name: string; publicName: string };
};

export type StudentNameAndImageFragment = {
	__typename?: "Student";
	person: {
		__typename?: "Person";
		id: string;
		name: string;
		publicName: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
	};
};

export type StudentNameDescriptionAndImageFragment = {
	__typename?: "Student";
	graduationYear: number | null;
	yearsFromGraduation: number;
	person: {
		__typename?: "Person";
		id: string;
		name: string;
		publicName: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
	};
};

export type StudentNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentNameQuery = {
	__typename?: "Query";
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type StudentNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentOrder>;
}>;

export type StudentNamesQuery = {
	__typename?: "Query";
	studentConnection: {
		__typename?: "StudentConnection";
		edges: Array<{
			__typename?: "StudentEdge";
			node: {
				__typename?: "Student";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			};
		}>;
	};
};

export type StudentPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	order?: InputMaybe<StudentOrder>;
}>;

export type StudentPaginationQuery = {
	__typename?: "Query";
	studentConnection: {
		__typename?: "StudentConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentEdge"; cursor: string }>;
	};
};

export type StudentSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	order?: InputMaybe<StudentOrder>;
}>;

export type StudentSelectQuery = {
	__typename?: "Query";
	studentConnection: {
		__typename?: "StudentConnection";
		edges: Array<{
			__typename?: "StudentEdge";
			node: {
				__typename?: "Student";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			};
		}>;
	};
};

export type StudentNameAndImageQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentNameAndImageQuery = {
	__typename?: "Query";
	student: {
		__typename?: "Student";
		id: string;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		};
	};
};

export type StudentNamesAndImagesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentOrder>;
}>;

export type StudentNamesAndImagesQuery = {
	__typename?: "Query";
	studentConnection: {
		__typename?: "StudentConnection";
		totalCount: number;
		edges: Array<{
			__typename?: "StudentEdge";
			node: {
				__typename?: "Student";
				id: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type StudentNamePartsAndImagesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentOrder>;
}>;

export type StudentNamePartsAndImagesQuery = {
	__typename?: "Query";
	studentConnection: {
		__typename?: "StudentConnection";
		totalCount: number;
		edges: Array<{
			__typename?: "StudentEdge";
			node: {
				__typename?: "Student";
				id: string;
				person: {
					__typename?: "Person";
					id: string;
					familyName: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type StudentNamesDescriptionsAndImagesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentOrder>;
}>;

export type StudentNamesDescriptionsAndImagesQuery = {
	__typename?: "Query";
	studentConnection: {
		__typename?: "StudentConnection";
		totalCount: number;
		pageInfo: { __typename?: "PageInfo"; endCursor: string | null; hasNextPage: boolean };
		edges: Array<{
			__typename?: "StudentEdge";
			node: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				yearsFromGraduation: number;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type StudentNamesDescriptionsHomeRoomSectionsAndImagesQueryVariables = Exact<{
	date: Scalars["Date"]["input"];
	filters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentOrder>;
}>;

export type StudentNamesDescriptionsHomeRoomSectionsAndImagesQuery = {
	__typename?: "Query";
	studentConnection: {
		__typename?: "StudentConnection";
		totalCount: number;
		pageInfo: { __typename?: "PageInfo"; endCursor: string | null; hasNextPage: boolean };
		edges: Array<{
			__typename?: "StudentEdge";
			node: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				yearsFromGraduation: number;
				studentHomeRoomSectionEnrollments: Array<{
					__typename?: "StudentHomeRoomSectionEnrollment";
					id: string;
					homeRoomSection: {
						__typename?: "HomeRoomSection";
						id: string;
						namePrefix: string;
						nameSuffix: string;
						homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
					};
				}>;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type StudentTooltipQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
	date: Scalars["Date"]["input"];
}>;

export type StudentTooltipQuery = {
	__typename?: "Query";
	student: {
		__typename?: "Student";
		id: string;
		graduationYear: number | null;
		yearsFromGraduation: number;
		person: {
			__typename?: "Person";
			id: string;
			dateOfBirth: string | null;
			gender: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
			nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
			languages: Array<{ __typename?: "Language"; id: string; name: string }>;
		};
		studentAcademicTermEnrollments: Array<{
			__typename?: "StudentAcademicTermEnrollment";
			id: string;
			lateStartDate: string | null;
			earlyEndDate: string | null;
		}>;
		studentHomeRoomSectionEnrollments: Array<{
			__typename?: "StudentHomeRoomSectionEnrollment";
			id: string;
			homeRoomSection: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			};
		}>;
	};
};

export type StudentNextYearTuitionAmountQueryVariables = Exact<{
	studentID: Scalars["ID"]["input"];
}>;

export type StudentNextYearTuitionAmountQuery = { __typename?: "Query"; studentNextYearTuitionAmount: number };

export type StudentUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentUpdateInput;
}>;

export type StudentUpdateMutation = {
	__typename?: "Mutation";
	updateStudent: {
		__typename?: "Student";
		id: string;
		graduationYear: number | null;
		yearsFromGraduation: number;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			middleName: string;
			familyName: string;
			nameOrder: PersonNameOrder;
			nickname: string;
			alternateNames: string;
			publicNameFormat: PersonPublicNameFormat;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
			gender: string;
			dateOfBirth: string | null;
			englishLanguageFluency: PersonEnglishLanguageFluency | null;
			occupation: string;
			nationalIdentificationNumber: string;
			governmentDocumentSeries: string;
			governmentDocumentNumber: string;
			governmentDocumentIssuedBy: string;
			nationalities: Array<{ __typename?: "Country"; id: string; name: string }>;
			languages: Array<{ __typename?: "Language"; id: string; name: string }>;
			addresses: Array<{
				__typename?: "Address";
				id: string;
				name: string;
				addressLine1: string;
				addressLine2: string;
				city: string;
				postalCode: string;
				stateOrProvince: string;
				country: { __typename?: "Country"; id: string; name: string };
			}>;
			emailAddresses: Array<{
				__typename?: "EmailAddress";
				id: string;
				emailAddress: string;
				isPrimary: boolean;
				name: string;
			}>;
			employee: {
				__typename?: "Employee";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			guardian: {
				__typename?: "Guardian";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			phoneNumbers: Array<{
				__typename?: "PhoneNumber";
				id: string;
				phoneNumber: string;
				isPrimary: boolean;
				name: string;
			}>;
			student: {
				__typename?: "Student";
				id: string;
				person: { __typename?: "Person"; id: string; name: string; publicName: string };
			} | null;
			user: {
				__typename?: "User";
				id: string;
				email: string;
				status: UserStatus;
				passwordUpdatedAt: string;
				isCurrent: boolean;
				timeZoneName: string;
				externalNotificationFrequency: UserExternalNotificationFrequency;
				permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					employee: { __typename?: "Employee"; id: string } | null;
					guardian: { __typename?: "Guardian"; id: string } | null;
					student: { __typename?: "Student"; id: string } | null;
				} | null;
				userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
			} | null;
		};
		relationships: Array<{
			__typename?: "Relationship";
			id: string;
			relationshipType: string;
			isPrimary: boolean;
			isEmergencyContact: boolean;
			isAuthorizedForPickup: boolean;
			isFinancialContact: boolean;
			livesWithStudent: boolean;
			hasCustody: boolean;
			guardian: {
				__typename?: "Guardian";
				id: string;
				person: {
					__typename?: "Person";
					id: string;
					userID: string | null;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
					addresses: Array<{
						__typename?: "Address";
						id: string;
						name: string;
						addressLine1: string;
						addressLine2: string;
						city: string;
						postalCode: string;
						stateOrProvince: string;
						country: { __typename?: "Country"; id: string; name: string };
					}>;
					emailAddresses: Array<{
						__typename?: "EmailAddress";
						id: string;
						emailAddress: string;
						isPrimary: boolean;
						name: string;
					}>;
					phoneNumbers: Array<{
						__typename?: "PhoneNumber";
						id: string;
						phoneNumber: string;
						isPrimary: boolean;
						name: string;
					}>;
				};
			};
		}>;
	};
};

export type StudentAcademicNoteCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentAcademicNoteFilterInput> | StudentAcademicNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentAcademicNoteOrder>;
}>;

export type StudentAcademicNoteCountQuery = {
	__typename?: "Query";
	studentAcademicNoteConnection: { __typename?: "StudentAcademicNoteConnection"; totalCount: number };
};

export type StudentAcademicNoteCreateMutationVariables = Exact<{
	input: StudentAcademicNoteCreateInput;
}>;

export type StudentAcademicNoteCreateMutation = {
	__typename?: "Mutation";
	createStudentAcademicNote: {
		__typename?: "StudentAcademicNote";
		id: string;
		isIssueNatureLearningDifficulty: boolean;
		isIssueNatureAttentionIssue: boolean;
		isIssueNatureFocusIssue: boolean;
		isIssueNatureEmotionalOrVulnerableIssue: boolean;
		isIssueNatureOther: boolean;
		issueNatureOther: string;
		isSolutionRecDifferentiatedLearning: boolean;
		isSolutionRecIndividualLearningPlan: boolean;
		isSolutionRecTutoring: boolean;
		isSolutionRecProfessionalSupport: boolean;
		isSolutionRecInClassSupport: boolean;
		isSolutionRecOther: boolean;
		solutionRecOther: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentAcademicNoteDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentAcademicNoteDeleteMutation = { __typename?: "Mutation"; deleteStudentAcademicNote: boolean };

export type StudentAcademicNoteDetailFragment = {
	__typename?: "StudentAcademicNote";
	id: string;
	isIssueNatureLearningDifficulty: boolean;
	isIssueNatureAttentionIssue: boolean;
	isIssueNatureFocusIssue: boolean;
	isIssueNatureEmotionalOrVulnerableIssue: boolean;
	isIssueNatureOther: boolean;
	issueNatureOther: string;
	isSolutionRecDifferentiatedLearning: boolean;
	isSolutionRecIndividualLearningPlan: boolean;
	isSolutionRecTutoring: boolean;
	isSolutionRecProfessionalSupport: boolean;
	isSolutionRecInClassSupport: boolean;
	isSolutionRecOther: boolean;
	solutionRecOther: string;
	studentNote: { __typename?: "StudentNote"; id: string };
};

export type StudentAcademicNoteDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentAcademicNoteDetailQuery = {
	__typename?: "Query";
	studentAcademicNote: {
		__typename?: "StudentAcademicNote";
		id: string;
		isIssueNatureLearningDifficulty: boolean;
		isIssueNatureAttentionIssue: boolean;
		isIssueNatureFocusIssue: boolean;
		isIssueNatureEmotionalOrVulnerableIssue: boolean;
		isIssueNatureOther: boolean;
		issueNatureOther: string;
		isSolutionRecDifferentiatedLearning: boolean;
		isSolutionRecIndividualLearningPlan: boolean;
		isSolutionRecTutoring: boolean;
		isSolutionRecProfessionalSupport: boolean;
		isSolutionRecInClassSupport: boolean;
		isSolutionRecOther: boolean;
		solutionRecOther: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentAcademicNoteIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentAcademicNoteFilterInput> | StudentAcademicNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentAcademicNoteOrder>;
}>;

export type StudentAcademicNoteIndexQuery = {
	__typename?: "Query";
	studentAcademicNoteConnection: {
		__typename?: "StudentAcademicNoteConnection";
		edges: Array<{
			__typename?: "StudentAcademicNoteEdge";
			node: {
				__typename?: "StudentAcademicNote";
				id: string;
				isIssueNatureLearningDifficulty: boolean;
				isIssueNatureAttentionIssue: boolean;
				isIssueNatureFocusIssue: boolean;
				isIssueNatureEmotionalOrVulnerableIssue: boolean;
				isIssueNatureOther: boolean;
				issueNatureOther: string;
				isSolutionRecDifferentiatedLearning: boolean;
				isSolutionRecIndividualLearningPlan: boolean;
				isSolutionRecTutoring: boolean;
				isSolutionRecProfessionalSupport: boolean;
				isSolutionRecInClassSupport: boolean;
				isSolutionRecOther: boolean;
				solutionRecOther: string;
			};
		}>;
	};
};

export type StudentAcademicNoteNameFragment = { __typename?: "StudentAcademicNote"; id: string };

export type StudentAcademicNoteNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentAcademicNoteNameQuery = {
	__typename?: "Query";
	studentAcademicNote: { __typename?: "StudentAcademicNote"; id: string };
};

export type StudentAcademicNoteNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentAcademicNoteFilterInput> | StudentAcademicNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentAcademicNoteOrder>;
}>;

export type StudentAcademicNoteNamesQuery = {
	__typename?: "Query";
	studentAcademicNoteConnection: {
		__typename?: "StudentAcademicNoteConnection";
		edges: Array<{ __typename?: "StudentAcademicNoteEdge"; node: { __typename?: "StudentAcademicNote"; id: string } }>;
	};
};

export type StudentAcademicNotePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentAcademicNoteFilterInput> | StudentAcademicNoteFilterInput>;
	order?: InputMaybe<StudentAcademicNoteOrder>;
}>;

export type StudentAcademicNotePaginationQuery = {
	__typename?: "Query";
	studentAcademicNoteConnection: {
		__typename?: "StudentAcademicNoteConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentAcademicNoteEdge"; cursor: string }>;
	};
};

export type StudentAcademicNoteSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentAcademicNoteFilterInput> | StudentAcademicNoteFilterInput>;
	order?: InputMaybe<StudentAcademicNoteOrder>;
}>;

export type StudentAcademicNoteSelectQuery = {
	__typename?: "Query";
	studentAcademicNoteConnection: {
		__typename?: "StudentAcademicNoteConnection";
		edges: Array<{ __typename?: "StudentAcademicNoteEdge"; node: { __typename?: "StudentAcademicNote"; id: string } }>;
	};
};

export type StudentAcademicNoteUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentAcademicNoteUpdateInput;
}>;

export type StudentAcademicNoteUpdateMutation = {
	__typename?: "Mutation";
	updateStudentAcademicNote: {
		__typename?: "StudentAcademicNote";
		id: string;
		isIssueNatureLearningDifficulty: boolean;
		isIssueNatureAttentionIssue: boolean;
		isIssueNatureFocusIssue: boolean;
		isIssueNatureEmotionalOrVulnerableIssue: boolean;
		isIssueNatureOther: boolean;
		issueNatureOther: string;
		isSolutionRecDifferentiatedLearning: boolean;
		isSolutionRecIndividualLearningPlan: boolean;
		isSolutionRecTutoring: boolean;
		isSolutionRecProfessionalSupport: boolean;
		isSolutionRecInClassSupport: boolean;
		isSolutionRecOther: boolean;
		solutionRecOther: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentAcademicTermEnrollmentCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentAcademicTermEnrollmentFilterInput> | StudentAcademicTermEnrollmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentAcademicTermEnrollmentOrder>;
}>;

export type StudentAcademicTermEnrollmentCountQuery = {
	__typename?: "Query";
	studentAcademicTermEnrollmentConnection: {
		__typename?: "StudentAcademicTermEnrollmentConnection";
		totalCount: number;
	};
};

export type StudentAcademicTermEnrollmentCreateMutationVariables = Exact<{
	input: StudentAcademicTermEnrollmentCreateInput;
}>;

export type StudentAcademicTermEnrollmentCreateMutation = {
	__typename?: "Mutation";
	createStudentAcademicTermEnrollment: {
		__typename?: "StudentAcademicTermEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentAcademicTermEnrollmentDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentAcademicTermEnrollmentDeleteMutation = {
	__typename?: "Mutation";
	deleteStudentAcademicTermEnrollment: boolean;
};

export type StudentAcademicTermEnrollmentDetailFragment = {
	__typename?: "StudentAcademicTermEnrollment";
	id: string;
	lateStartDate: string | null;
	earlyEndDate: string | null;
	academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type StudentAcademicTermEnrollmentDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentAcademicTermEnrollmentDetailQuery = {
	__typename?: "Query";
	studentAcademicTermEnrollment: {
		__typename?: "StudentAcademicTermEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentAcademicTermEnrollmentIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentAcademicTermEnrollmentFilterInput> | StudentAcademicTermEnrollmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentAcademicTermEnrollmentOrder>;
}>;

export type StudentAcademicTermEnrollmentIndexQuery = {
	__typename?: "Query";
	studentAcademicTermEnrollmentConnection: {
		__typename?: "StudentAcademicTermEnrollmentConnection";
		edges: Array<{
			__typename?: "StudentAcademicTermEnrollmentEdge";
			node: {
				__typename?: "StudentAcademicTermEnrollment";
				id: string;
				lateStartDate: string | null;
				earlyEndDate: string | null;
			};
		}>;
	};
};

export type StudentAcademicTermEnrollmentListQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentAcademicTermEnrollmentFilterInput> | StudentAcademicTermEnrollmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentAcademicTermEnrollmentOrder>;
}>;

export type StudentAcademicTermEnrollmentListQuery = {
	__typename?: "Query";
	studentAcademicTermEnrollmentConnection: {
		__typename?: "StudentAcademicTermEnrollmentConnection";
		edges: Array<{
			__typename?: "StudentAcademicTermEnrollmentEdge";
			node: {
				__typename?: "StudentAcademicTermEnrollment";
				id: string;
				lateStartDate: string | null;
				earlyEndDate: string | null;
				academicTerm: { __typename?: "AcademicTerm"; id: string; startDate: string; endDate: string };
			};
		}>;
	};
};

export type StudentAcademicTermEnrollmentNameFragment = { __typename?: "StudentAcademicTermEnrollment"; id: string };

export type StudentAcademicTermEnrollmentNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentAcademicTermEnrollmentNameQuery = {
	__typename?: "Query";
	studentAcademicTermEnrollment: { __typename?: "StudentAcademicTermEnrollment"; id: string };
};

export type StudentAcademicTermEnrollmentNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentAcademicTermEnrollmentFilterInput> | StudentAcademicTermEnrollmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentAcademicTermEnrollmentOrder>;
}>;

export type StudentAcademicTermEnrollmentNamesQuery = {
	__typename?: "Query";
	studentAcademicTermEnrollmentConnection: {
		__typename?: "StudentAcademicTermEnrollmentConnection";
		edges: Array<{
			__typename?: "StudentAcademicTermEnrollmentEdge";
			node: { __typename?: "StudentAcademicTermEnrollment"; id: string };
		}>;
	};
};

export type StudentAcademicTermEnrollmentPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentAcademicTermEnrollmentFilterInput> | StudentAcademicTermEnrollmentFilterInput>;
	order?: InputMaybe<StudentAcademicTermEnrollmentOrder>;
}>;

export type StudentAcademicTermEnrollmentPaginationQuery = {
	__typename?: "Query";
	studentAcademicTermEnrollmentConnection: {
		__typename?: "StudentAcademicTermEnrollmentConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentAcademicTermEnrollmentEdge"; cursor: string }>;
	};
};

export type StudentAcademicTermEnrollmentSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentAcademicTermEnrollmentFilterInput> | StudentAcademicTermEnrollmentFilterInput>;
	order?: InputMaybe<StudentAcademicTermEnrollmentOrder>;
}>;

export type StudentAcademicTermEnrollmentSelectQuery = {
	__typename?: "Query";
	studentAcademicTermEnrollmentConnection: {
		__typename?: "StudentAcademicTermEnrollmentConnection";
		edges: Array<{
			__typename?: "StudentAcademicTermEnrollmentEdge";
			node: { __typename?: "StudentAcademicTermEnrollment"; id: string };
		}>;
	};
};

export type StudentAcademicTermEnrollmentUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentAcademicTermEnrollmentUpdateInput;
}>;

export type StudentAcademicTermEnrollmentUpdateMutation = {
	__typename?: "Mutation";
	updateStudentAcademicTermEnrollment: {
		__typename?: "StudentAcademicTermEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentAttendanceNoteCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentAttendanceNoteFilterInput> | StudentAttendanceNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentAttendanceNoteOrder>;
}>;

export type StudentAttendanceNoteCountQuery = {
	__typename?: "Query";
	studentAttendanceNoteConnection: { __typename?: "StudentAttendanceNoteConnection"; totalCount: number };
};

export type StudentAttendanceNoteCreateMutationVariables = Exact<{
	input: StudentAttendanceNoteCreateInput;
}>;

export type StudentAttendanceNoteCreateMutation = {
	__typename?: "Mutation";
	createStudentAttendanceNote: {
		__typename?: "StudentAttendanceNote";
		id: string;
		startDate: string;
		endDate: string;
		attendanceStatus: {
			__typename?: "AttendanceStatus";
			id: string;
			code: string;
			description: string;
			indicatesAbsent: boolean;
			indicatesLateArrival: boolean;
			indicatesEarlyDeparture: boolean;
			indicatesExcused: boolean;
			name: string;
		} | null;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentAttendanceNoteDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentAttendanceNoteDeleteMutation = { __typename?: "Mutation"; deleteStudentAttendanceNote: boolean };

export type StudentAttendanceNoteDetailFragment = {
	__typename?: "StudentAttendanceNote";
	id: string;
	startDate: string;
	endDate: string;
	attendanceStatus: {
		__typename?: "AttendanceStatus";
		id: string;
		code: string;
		description: string;
		indicatesAbsent: boolean;
		indicatesLateArrival: boolean;
		indicatesEarlyDeparture: boolean;
		indicatesExcused: boolean;
		name: string;
	} | null;
	studentNote: { __typename?: "StudentNote"; id: string };
};

export type StudentAttendanceNoteDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentAttendanceNoteDetailQuery = {
	__typename?: "Query";
	studentAttendanceNote: {
		__typename?: "StudentAttendanceNote";
		id: string;
		startDate: string;
		endDate: string;
		attendanceStatus: {
			__typename?: "AttendanceStatus";
			id: string;
			code: string;
			description: string;
			indicatesAbsent: boolean;
			indicatesLateArrival: boolean;
			indicatesEarlyDeparture: boolean;
			indicatesExcused: boolean;
			name: string;
		} | null;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentAttendanceNoteIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentAttendanceNoteFilterInput> | StudentAttendanceNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentAttendanceNoteOrder>;
}>;

export type StudentAttendanceNoteIndexQuery = {
	__typename?: "Query";
	studentAttendanceNoteConnection: {
		__typename?: "StudentAttendanceNoteConnection";
		edges: Array<{
			__typename?: "StudentAttendanceNoteEdge";
			node: { __typename?: "StudentAttendanceNote"; id: string; startDate: string; endDate: string };
		}>;
	};
};

export type StudentAttendanceNoteNameFragment = { __typename?: "StudentAttendanceNote"; id: string };

export type StudentAttendanceNoteNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentAttendanceNoteNameQuery = {
	__typename?: "Query";
	studentAttendanceNote: { __typename?: "StudentAttendanceNote"; id: string };
};

export type StudentAttendanceNoteNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentAttendanceNoteFilterInput> | StudentAttendanceNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentAttendanceNoteOrder>;
}>;

export type StudentAttendanceNoteNamesQuery = {
	__typename?: "Query";
	studentAttendanceNoteConnection: {
		__typename?: "StudentAttendanceNoteConnection";
		edges: Array<{
			__typename?: "StudentAttendanceNoteEdge";
			node: { __typename?: "StudentAttendanceNote"; id: string };
		}>;
	};
};

export type StudentAttendanceNotePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentAttendanceNoteFilterInput> | StudentAttendanceNoteFilterInput>;
	order?: InputMaybe<StudentAttendanceNoteOrder>;
}>;

export type StudentAttendanceNotePaginationQuery = {
	__typename?: "Query";
	studentAttendanceNoteConnection: {
		__typename?: "StudentAttendanceNoteConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentAttendanceNoteEdge"; cursor: string }>;
	};
};

export type StudentAttendanceNoteSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentAttendanceNoteFilterInput> | StudentAttendanceNoteFilterInput>;
	order?: InputMaybe<StudentAttendanceNoteOrder>;
}>;

export type StudentAttendanceNoteSelectQuery = {
	__typename?: "Query";
	studentAttendanceNoteConnection: {
		__typename?: "StudentAttendanceNoteConnection";
		edges: Array<{
			__typename?: "StudentAttendanceNoteEdge";
			node: { __typename?: "StudentAttendanceNote"; id: string };
		}>;
	};
};

export type StudentAttendanceNoteUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentAttendanceNoteUpdateInput;
}>;

export type StudentAttendanceNoteUpdateMutation = {
	__typename?: "Mutation";
	updateStudentAttendanceNote: {
		__typename?: "StudentAttendanceNote";
		id: string;
		startDate: string;
		endDate: string;
		attendanceStatus: {
			__typename?: "AttendanceStatus";
			id: string;
			code: string;
			description: string;
			indicatesAbsent: boolean;
			indicatesLateArrival: boolean;
			indicatesEarlyDeparture: boolean;
			indicatesExcused: boolean;
			name: string;
		} | null;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentBehaviorNoteCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentBehaviorNoteFilterInput> | StudentBehaviorNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentBehaviorNoteOrder>;
}>;

export type StudentBehaviorNoteCountQuery = {
	__typename?: "Query";
	studentBehaviorNoteConnection: { __typename?: "StudentBehaviorNoteConnection"; totalCount: number };
};

export type StudentBehaviorNoteCreateMutationVariables = Exact<{
	input: StudentBehaviorNoteCreateInput;
}>;

export type StudentBehaviorNoteCreateMutation = {
	__typename?: "Mutation";
	createStudentBehaviorNote: {
		__typename?: "StudentBehaviorNote";
		id: string;
		incidentTime: string | null;
		incidentLocation: StudentBehaviorNoteIncidentLocation | null;
		isIncidentPhysicalContactAggression: boolean;
		isIncidentFightingPhysicalAggression: boolean;
		isIncidentVerbalAbuseDisrespectingStudent: boolean;
		isIncidentDisrepectingTeacher: boolean;
		isIncidentDisruption: boolean;
		isIncidentDefianceOrNonCompliance: boolean;
		isIncidentOther: boolean;
		incidentOther: string;
		isMotivationAttentionSeeking: boolean;
		isMotivationReaction: boolean;
		isMotivationAnger: boolean;
		isMotivationFrustration: boolean;
		isMotivationHabit: boolean;
		isMotivationLackOfSelfContol: boolean;
		isMotivationOther: boolean;
		motivationOther: string;
		isConsequenceRecDirectorIntervention: boolean;
		isConsequenceRecSenOrSelIntervention: boolean;
		isConsequenceRecStudentServiceTeamIntervention: boolean;
		isConsequenceRecParentContactFromReporter: boolean;
		isConsequenceRecParentContactFromSchoolDirector: boolean;
		isConsequenceRecOther: boolean;
		consequenceRecOther: string;
		additionalComments: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentBehaviorNoteDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentBehaviorNoteDeleteMutation = { __typename?: "Mutation"; deleteStudentBehaviorNote: boolean };

export type StudentBehaviorNoteDetailFragment = {
	__typename?: "StudentBehaviorNote";
	id: string;
	incidentTime: string | null;
	incidentLocation: StudentBehaviorNoteIncidentLocation | null;
	isIncidentPhysicalContactAggression: boolean;
	isIncidentFightingPhysicalAggression: boolean;
	isIncidentVerbalAbuseDisrespectingStudent: boolean;
	isIncidentDisrepectingTeacher: boolean;
	isIncidentDisruption: boolean;
	isIncidentDefianceOrNonCompliance: boolean;
	isIncidentOther: boolean;
	incidentOther: string;
	isMotivationAttentionSeeking: boolean;
	isMotivationReaction: boolean;
	isMotivationAnger: boolean;
	isMotivationFrustration: boolean;
	isMotivationHabit: boolean;
	isMotivationLackOfSelfContol: boolean;
	isMotivationOther: boolean;
	motivationOther: string;
	isConsequenceRecDirectorIntervention: boolean;
	isConsequenceRecSenOrSelIntervention: boolean;
	isConsequenceRecStudentServiceTeamIntervention: boolean;
	isConsequenceRecParentContactFromReporter: boolean;
	isConsequenceRecParentContactFromSchoolDirector: boolean;
	isConsequenceRecOther: boolean;
	consequenceRecOther: string;
	additionalComments: string;
	studentNote: { __typename?: "StudentNote"; id: string };
};

export type StudentBehaviorNoteDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentBehaviorNoteDetailQuery = {
	__typename?: "Query";
	studentBehaviorNote: {
		__typename?: "StudentBehaviorNote";
		id: string;
		incidentTime: string | null;
		incidentLocation: StudentBehaviorNoteIncidentLocation | null;
		isIncidentPhysicalContactAggression: boolean;
		isIncidentFightingPhysicalAggression: boolean;
		isIncidentVerbalAbuseDisrespectingStudent: boolean;
		isIncidentDisrepectingTeacher: boolean;
		isIncidentDisruption: boolean;
		isIncidentDefianceOrNonCompliance: boolean;
		isIncidentOther: boolean;
		incidentOther: string;
		isMotivationAttentionSeeking: boolean;
		isMotivationReaction: boolean;
		isMotivationAnger: boolean;
		isMotivationFrustration: boolean;
		isMotivationHabit: boolean;
		isMotivationLackOfSelfContol: boolean;
		isMotivationOther: boolean;
		motivationOther: string;
		isConsequenceRecDirectorIntervention: boolean;
		isConsequenceRecSenOrSelIntervention: boolean;
		isConsequenceRecStudentServiceTeamIntervention: boolean;
		isConsequenceRecParentContactFromReporter: boolean;
		isConsequenceRecParentContactFromSchoolDirector: boolean;
		isConsequenceRecOther: boolean;
		consequenceRecOther: string;
		additionalComments: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentBehaviorNoteIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentBehaviorNoteFilterInput> | StudentBehaviorNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentBehaviorNoteOrder>;
}>;

export type StudentBehaviorNoteIndexQuery = {
	__typename?: "Query";
	studentBehaviorNoteConnection: {
		__typename?: "StudentBehaviorNoteConnection";
		edges: Array<{
			__typename?: "StudentBehaviorNoteEdge";
			node: {
				__typename?: "StudentBehaviorNote";
				id: string;
				incidentTime: string | null;
				incidentLocation: StudentBehaviorNoteIncidentLocation | null;
				isIncidentPhysicalContactAggression: boolean;
				isIncidentFightingPhysicalAggression: boolean;
				isIncidentVerbalAbuseDisrespectingStudent: boolean;
				isIncidentDisrepectingTeacher: boolean;
				isIncidentDisruption: boolean;
				isIncidentDefianceOrNonCompliance: boolean;
				isIncidentOther: boolean;
				incidentOther: string;
				isMotivationAttentionSeeking: boolean;
				isMotivationReaction: boolean;
				isMotivationAnger: boolean;
				isMotivationFrustration: boolean;
				isMotivationHabit: boolean;
				isMotivationLackOfSelfContol: boolean;
				isMotivationOther: boolean;
				motivationOther: string;
				isConsequenceRecDirectorIntervention: boolean;
				isConsequenceRecSenOrSelIntervention: boolean;
				isConsequenceRecStudentServiceTeamIntervention: boolean;
				isConsequenceRecParentContactFromReporter: boolean;
				isConsequenceRecParentContactFromSchoolDirector: boolean;
				isConsequenceRecOther: boolean;
				consequenceRecOther: string;
				additionalComments: string;
			};
		}>;
	};
};

export type StudentBehaviorNoteNameFragment = { __typename?: "StudentBehaviorNote"; id: string };

export type StudentBehaviorNoteNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentBehaviorNoteNameQuery = {
	__typename?: "Query";
	studentBehaviorNote: { __typename?: "StudentBehaviorNote"; id: string };
};

export type StudentBehaviorNoteNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentBehaviorNoteFilterInput> | StudentBehaviorNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentBehaviorNoteOrder>;
}>;

export type StudentBehaviorNoteNamesQuery = {
	__typename?: "Query";
	studentBehaviorNoteConnection: {
		__typename?: "StudentBehaviorNoteConnection";
		edges: Array<{ __typename?: "StudentBehaviorNoteEdge"; node: { __typename?: "StudentBehaviorNote"; id: string } }>;
	};
};

export type StudentBehaviorNotePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentBehaviorNoteFilterInput> | StudentBehaviorNoteFilterInput>;
	order?: InputMaybe<StudentBehaviorNoteOrder>;
}>;

export type StudentBehaviorNotePaginationQuery = {
	__typename?: "Query";
	studentBehaviorNoteConnection: {
		__typename?: "StudentBehaviorNoteConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentBehaviorNoteEdge"; cursor: string }>;
	};
};

export type StudentBehaviorNoteSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentBehaviorNoteFilterInput> | StudentBehaviorNoteFilterInput>;
	order?: InputMaybe<StudentBehaviorNoteOrder>;
}>;

export type StudentBehaviorNoteSelectQuery = {
	__typename?: "Query";
	studentBehaviorNoteConnection: {
		__typename?: "StudentBehaviorNoteConnection";
		edges: Array<{ __typename?: "StudentBehaviorNoteEdge"; node: { __typename?: "StudentBehaviorNote"; id: string } }>;
	};
};

export type StudentBehaviorNoteUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentBehaviorNoteUpdateInput;
}>;

export type StudentBehaviorNoteUpdateMutation = {
	__typename?: "Mutation";
	updateStudentBehaviorNote: {
		__typename?: "StudentBehaviorNote";
		id: string;
		incidentTime: string | null;
		incidentLocation: StudentBehaviorNoteIncidentLocation | null;
		isIncidentPhysicalContactAggression: boolean;
		isIncidentFightingPhysicalAggression: boolean;
		isIncidentVerbalAbuseDisrespectingStudent: boolean;
		isIncidentDisrepectingTeacher: boolean;
		isIncidentDisruption: boolean;
		isIncidentDefianceOrNonCompliance: boolean;
		isIncidentOther: boolean;
		incidentOther: string;
		isMotivationAttentionSeeking: boolean;
		isMotivationReaction: boolean;
		isMotivationAnger: boolean;
		isMotivationFrustration: boolean;
		isMotivationHabit: boolean;
		isMotivationLackOfSelfContol: boolean;
		isMotivationOther: boolean;
		motivationOther: string;
		isConsequenceRecDirectorIntervention: boolean;
		isConsequenceRecSenOrSelIntervention: boolean;
		isConsequenceRecStudentServiceTeamIntervention: boolean;
		isConsequenceRecParentContactFromReporter: boolean;
		isConsequenceRecParentContactFromSchoolDirector: boolean;
		isConsequenceRecOther: boolean;
		consequenceRecOther: string;
		additionalComments: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentCourseSectionEnrollmentCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentCourseSectionEnrollmentFilterInput> | StudentCourseSectionEnrollmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentCourseSectionEnrollmentOrder>;
}>;

export type StudentCourseSectionEnrollmentCountQuery = {
	__typename?: "Query";
	studentCourseSectionEnrollmentConnection: {
		__typename?: "StudentCourseSectionEnrollmentConnection";
		totalCount: number;
	};
};

export type StudentCourseSectionEnrollmentCreateMutationVariables = Exact<{
	input: StudentCourseSectionEnrollmentCreateInput;
}>;

export type StudentCourseSectionEnrollmentCreateMutation = {
	__typename?: "Mutation";
	createStudentCourseSectionEnrollment: {
		__typename?: "StudentCourseSectionEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		};
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentCourseSectionEnrollmentDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentCourseSectionEnrollmentDeleteMutation = {
	__typename?: "Mutation";
	deleteStudentCourseSectionEnrollment: boolean;
};

export type StudentCourseSectionEnrollmentDetailFragment = {
	__typename?: "StudentCourseSectionEnrollment";
	id: string;
	lateStartDate: string | null;
	earlyEndDate: string | null;
	courseSection: {
		__typename?: "CourseSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		course: { __typename?: "Course"; id: string; name: string };
	};
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type StudentCourseSectionEnrollmentDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentCourseSectionEnrollmentDetailQuery = {
	__typename?: "Query";
	studentCourseSectionEnrollment: {
		__typename?: "StudentCourseSectionEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		};
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentCourseSectionEnrollmentIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentCourseSectionEnrollmentFilterInput> | StudentCourseSectionEnrollmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentCourseSectionEnrollmentOrder>;
}>;

export type StudentCourseSectionEnrollmentIndexQuery = {
	__typename?: "Query";
	studentCourseSectionEnrollmentConnection: {
		__typename?: "StudentCourseSectionEnrollmentConnection";
		edges: Array<{
			__typename?: "StudentCourseSectionEnrollmentEdge";
			node: {
				__typename?: "StudentCourseSectionEnrollment";
				id: string;
				lateStartDate: string | null;
				earlyEndDate: string | null;
			};
		}>;
	};
};

export type StudentCourseSectionEnrollmentNameFragment = { __typename?: "StudentCourseSectionEnrollment"; id: string };

export type StudentCourseSectionEnrollmentNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentCourseSectionEnrollmentNameQuery = {
	__typename?: "Query";
	studentCourseSectionEnrollment: { __typename?: "StudentCourseSectionEnrollment"; id: string };
};

export type StudentCourseSectionEnrollmentNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentCourseSectionEnrollmentFilterInput> | StudentCourseSectionEnrollmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentCourseSectionEnrollmentOrder>;
}>;

export type StudentCourseSectionEnrollmentNamesQuery = {
	__typename?: "Query";
	studentCourseSectionEnrollmentConnection: {
		__typename?: "StudentCourseSectionEnrollmentConnection";
		edges: Array<{
			__typename?: "StudentCourseSectionEnrollmentEdge";
			node: { __typename?: "StudentCourseSectionEnrollment"; id: string };
		}>;
	};
};

export type StudentCourseSectionEnrollmentPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentCourseSectionEnrollmentFilterInput> | StudentCourseSectionEnrollmentFilterInput>;
	order?: InputMaybe<StudentCourseSectionEnrollmentOrder>;
}>;

export type StudentCourseSectionEnrollmentPaginationQuery = {
	__typename?: "Query";
	studentCourseSectionEnrollmentConnection: {
		__typename?: "StudentCourseSectionEnrollmentConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentCourseSectionEnrollmentEdge"; cursor: string }>;
	};
};

export type StudentCourseSectionEnrollmentSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentCourseSectionEnrollmentFilterInput> | StudentCourseSectionEnrollmentFilterInput>;
	order?: InputMaybe<StudentCourseSectionEnrollmentOrder>;
}>;

export type StudentCourseSectionEnrollmentSelectQuery = {
	__typename?: "Query";
	studentCourseSectionEnrollmentConnection: {
		__typename?: "StudentCourseSectionEnrollmentConnection";
		edges: Array<{
			__typename?: "StudentCourseSectionEnrollmentEdge";
			node: { __typename?: "StudentCourseSectionEnrollment"; id: string };
		}>;
	};
};

export type StudentCourseSectionEnrollmentUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentCourseSectionEnrollmentUpdateInput;
}>;

export type StudentCourseSectionEnrollmentUpdateMutation = {
	__typename?: "Mutation";
	updateStudentCourseSectionEnrollment: {
		__typename?: "StudentCourseSectionEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		};
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentDataConsentCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentDataConsentFilterInput> | StudentDataConsentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentDataConsentOrder>;
}>;

export type StudentDataConsentCountQuery = {
	__typename?: "Query";
	studentDataConsentConnection: { __typename?: "StudentDataConsentConnection"; totalCount: number };
};

export type StudentDataConsentCreateMutationVariables = Exact<{
	input: StudentDataConsentCreateInput;
}>;

export type StudentDataConsentCreateMutation = {
	__typename?: "Mutation";
	createStudentDataConsent: {
		__typename?: "StudentDataConsent";
		id: string;
		createdAt: string;
		updatedAt: string;
		allowPublishVisualMediaOfStudentGeneral: boolean;
		allowPublishVisualMediaOfStudentForPromotion: boolean;
		allowPublishVisualMediaOfGuardianForPromotion: boolean;
		allowPublishStudentWorkGeneral: boolean;
		allowShareInformationWithPearsonEdexcel: boolean;
		allowShareInformationWithIbOrganization: boolean;
		allowShareInformationWithOnlinePlatforms: boolean;
		allowBirthdayInCalendar: boolean;
		allowSendNewsletters: boolean;
		allowSendCalendarEvents: boolean;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		student: {
			__typename?: "Student";
			id: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		};
	};
};

export type StudentDataConsentDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentDataConsentDeleteMutation = { __typename?: "Mutation"; deleteStudentDataConsent: boolean };

export type StudentDataConsentDetailFragment = {
	__typename?: "StudentDataConsent";
	id: string;
	createdAt: string;
	updatedAt: string;
	allowPublishVisualMediaOfStudentGeneral: boolean;
	allowPublishVisualMediaOfStudentForPromotion: boolean;
	allowPublishVisualMediaOfGuardianForPromotion: boolean;
	allowPublishStudentWorkGeneral: boolean;
	allowShareInformationWithPearsonEdexcel: boolean;
	allowShareInformationWithIbOrganization: boolean;
	allowShareInformationWithOnlinePlatforms: boolean;
	allowBirthdayInCalendar: boolean;
	allowSendNewsletters: boolean;
	allowSendCalendarEvents: boolean;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	} | null;
	student: {
		__typename?: "Student";
		id: string;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		};
	};
};

export type StudentDataConsentDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentDataConsentDetailQuery = {
	__typename?: "Query";
	studentDataConsent: {
		__typename?: "StudentDataConsent";
		id: string;
		createdAt: string;
		updatedAt: string;
		allowPublishVisualMediaOfStudentGeneral: boolean;
		allowPublishVisualMediaOfStudentForPromotion: boolean;
		allowPublishVisualMediaOfGuardianForPromotion: boolean;
		allowPublishStudentWorkGeneral: boolean;
		allowShareInformationWithPearsonEdexcel: boolean;
		allowShareInformationWithIbOrganization: boolean;
		allowShareInformationWithOnlinePlatforms: boolean;
		allowBirthdayInCalendar: boolean;
		allowSendNewsletters: boolean;
		allowSendCalendarEvents: boolean;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		student: {
			__typename?: "Student";
			id: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		};
	};
};

export type StudentDataConsentIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentDataConsentFilterInput> | StudentDataConsentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentDataConsentOrder>;
}>;

export type StudentDataConsentIndexQuery = {
	__typename?: "Query";
	studentDataConsentConnection: {
		__typename?: "StudentDataConsentConnection";
		edges: Array<{
			__typename?: "StudentDataConsentEdge";
			node: {
				__typename?: "StudentDataConsent";
				id: string;
				createdAt: string;
				updatedAt: string;
				allowPublishVisualMediaOfStudentGeneral: boolean;
				allowPublishVisualMediaOfStudentForPromotion: boolean;
				allowPublishVisualMediaOfGuardianForPromotion: boolean;
				allowPublishStudentWorkGeneral: boolean;
				allowShareInformationWithPearsonEdexcel: boolean;
				allowShareInformationWithIbOrganization: boolean;
				allowShareInformationWithOnlinePlatforms: boolean;
				allowBirthdayInCalendar: boolean;
				allowSendNewsletters: boolean;
				allowSendCalendarEvents: boolean;
				student: {
					__typename?: "Student";
					id: string;
					person: { __typename?: "Person"; id: string; name: string; publicName: string };
				};
			};
		}>;
	};
};

export type StudentDataConsentListQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentDataConsentFilterInput> | StudentDataConsentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentDataConsentOrder>;
}>;

export type StudentDataConsentListQuery = {
	__typename?: "Query";
	studentDataConsentConnection: {
		__typename?: "StudentDataConsentConnection";
		edges: Array<{
			__typename?: "StudentDataConsentEdge";
			node: {
				__typename?: "StudentDataConsent";
				id: string;
				createdAt: string;
				allowPublishVisualMediaOfStudentGeneral: boolean;
				allowPublishVisualMediaOfStudentForPromotion: boolean;
				allowPublishVisualMediaOfGuardianForPromotion: boolean;
				allowPublishStudentWorkGeneral: boolean;
				allowShareInformationWithPearsonEdexcel: boolean;
				allowShareInformationWithIbOrganization: boolean;
				allowShareInformationWithOnlinePlatforms: boolean;
				allowBirthdayInCalendar: boolean;
				allowSendNewsletters: boolean;
				allowSendCalendarEvents: boolean;
			};
		}>;
	};
};

export type StudentDataConsentDetailListQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentDataConsentFilterInput> | StudentDataConsentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentDataConsentOrder>;
}>;

export type StudentDataConsentDetailListQuery = {
	__typename?: "Query";
	studentDataConsentConnection: {
		__typename?: "StudentDataConsentConnection";
		edges: Array<{
			__typename?: "StudentDataConsentEdge";
			node: {
				__typename?: "StudentDataConsent";
				id: string;
				createdAt: string;
				updatedAt: string;
				allowPublishVisualMediaOfStudentGeneral: boolean;
				allowPublishVisualMediaOfStudentForPromotion: boolean;
				allowPublishVisualMediaOfGuardianForPromotion: boolean;
				allowPublishStudentWorkGeneral: boolean;
				allowShareInformationWithPearsonEdexcel: boolean;
				allowShareInformationWithIbOrganization: boolean;
				allowShareInformationWithOnlinePlatforms: boolean;
				allowBirthdayInCalendar: boolean;
				allowSendNewsletters: boolean;
				allowSendCalendarEvents: boolean;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
				} | null;
				student: {
					__typename?: "Student";
					id: string;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					};
				};
			};
		}>;
	};
};

export type StudentDataConsentNameFragment = { __typename?: "StudentDataConsent"; id: string };

export type StudentDataConsentNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentDataConsentNameQuery = {
	__typename?: "Query";
	studentDataConsent: { __typename?: "StudentDataConsent"; id: string };
};

export type StudentDataConsentNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentDataConsentFilterInput> | StudentDataConsentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentDataConsentOrder>;
}>;

export type StudentDataConsentNamesQuery = {
	__typename?: "Query";
	studentDataConsentConnection: {
		__typename?: "StudentDataConsentConnection";
		edges: Array<{ __typename?: "StudentDataConsentEdge"; node: { __typename?: "StudentDataConsent"; id: string } }>;
	};
};

export type StudentDataConsentPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentDataConsentFilterInput> | StudentDataConsentFilterInput>;
	order?: InputMaybe<StudentDataConsentOrder>;
}>;

export type StudentDataConsentPaginationQuery = {
	__typename?: "Query";
	studentDataConsentConnection: {
		__typename?: "StudentDataConsentConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentDataConsentEdge"; cursor: string }>;
	};
};

export type StudentDataConsentSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentDataConsentFilterInput> | StudentDataConsentFilterInput>;
	order?: InputMaybe<StudentDataConsentOrder>;
}>;

export type StudentDataConsentSelectQuery = {
	__typename?: "Query";
	studentDataConsentConnection: {
		__typename?: "StudentDataConsentConnection";
		edges: Array<{ __typename?: "StudentDataConsentEdge"; node: { __typename?: "StudentDataConsent"; id: string } }>;
	};
};

export type StudentDataConsentUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentDataConsentUpdateInput;
}>;

export type StudentDataConsentUpdateMutation = {
	__typename?: "Mutation";
	updateStudentDataConsent: {
		__typename?: "StudentDataConsent";
		id: string;
		createdAt: string;
		updatedAt: string;
		allowPublishVisualMediaOfStudentGeneral: boolean;
		allowPublishVisualMediaOfStudentForPromotion: boolean;
		allowPublishVisualMediaOfGuardianForPromotion: boolean;
		allowPublishStudentWorkGeneral: boolean;
		allowShareInformationWithPearsonEdexcel: boolean;
		allowShareInformationWithIbOrganization: boolean;
		allowShareInformationWithOnlinePlatforms: boolean;
		allowBirthdayInCalendar: boolean;
		allowSendNewsletters: boolean;
		allowSendCalendarEvents: boolean;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		student: {
			__typename?: "Student";
			id: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		};
	};
};

export type StudentEnrollmentApplicationCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentEnrollmentApplicationFilterInput> | StudentEnrollmentApplicationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentEnrollmentApplicationOrder>;
}>;

export type StudentEnrollmentApplicationCountQuery = {
	__typename?: "Query";
	studentEnrollmentApplicationConnection: { __typename?: "StudentEnrollmentApplicationConnection"; totalCount: number };
};

export type StudentEnrollmentApplicationCreateMutationVariables = Exact<{
	input: StudentEnrollmentApplicationCreateInput;
}>;

export type StudentEnrollmentApplicationCreateMutation = {
	__typename?: "Mutation";
	createStudentEnrollmentApplication: {
		__typename?: "StudentEnrollmentApplication";
		id: string;
		status: StudentEnrollmentApplicationStatus;
		statusUpdatedAt: string;
		enrollmentApplicationStudent: { __typename?: "EnrollmentApplicationStudent"; id: string; name: string };
	};
};

export type StudentEnrollmentApplicationDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentEnrollmentApplicationDeleteMutation = {
	__typename?: "Mutation";
	deleteStudentEnrollmentApplication: boolean;
};

export type StudentEnrollmentApplicationDetailFragment = {
	__typename?: "StudentEnrollmentApplication";
	id: string;
	status: StudentEnrollmentApplicationStatus;
	statusUpdatedAt: string;
	enrollmentApplicationStudent: { __typename?: "EnrollmentApplicationStudent"; id: string; name: string };
};

export type StudentEnrollmentApplicationDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentEnrollmentApplicationDetailQuery = {
	__typename?: "Query";
	studentEnrollmentApplication: {
		__typename?: "StudentEnrollmentApplication";
		id: string;
		status: StudentEnrollmentApplicationStatus;
		statusUpdatedAt: string;
		enrollmentApplicationStudent: { __typename?: "EnrollmentApplicationStudent"; id: string; name: string };
	};
};

export type StudentEnrollmentApplicationIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentEnrollmentApplicationFilterInput> | StudentEnrollmentApplicationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentEnrollmentApplicationOrder>;
}>;

export type StudentEnrollmentApplicationIndexQuery = {
	__typename?: "Query";
	studentEnrollmentApplicationConnection: {
		__typename?: "StudentEnrollmentApplicationConnection";
		edges: Array<{
			__typename?: "StudentEnrollmentApplicationEdge";
			node: {
				__typename?: "StudentEnrollmentApplication";
				id: string;
				status: StudentEnrollmentApplicationStatus;
				statusUpdatedAt: string;
			};
		}>;
	};
};

export type StudentEnrollmentApplicationNameFragment = { __typename?: "StudentEnrollmentApplication"; id: string };

export type StudentEnrollmentApplicationNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentEnrollmentApplicationNameQuery = {
	__typename?: "Query";
	studentEnrollmentApplication: { __typename?: "StudentEnrollmentApplication"; id: string };
};

export type StudentEnrollmentApplicationNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentEnrollmentApplicationFilterInput> | StudentEnrollmentApplicationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentEnrollmentApplicationOrder>;
}>;

export type StudentEnrollmentApplicationNamesQuery = {
	__typename?: "Query";
	studentEnrollmentApplicationConnection: {
		__typename?: "StudentEnrollmentApplicationConnection";
		edges: Array<{
			__typename?: "StudentEnrollmentApplicationEdge";
			node: { __typename?: "StudentEnrollmentApplication"; id: string };
		}>;
	};
};

export type StudentEnrollmentApplicationPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentEnrollmentApplicationFilterInput> | StudentEnrollmentApplicationFilterInput>;
	order?: InputMaybe<StudentEnrollmentApplicationOrder>;
}>;

export type StudentEnrollmentApplicationPaginationQuery = {
	__typename?: "Query";
	studentEnrollmentApplicationConnection: {
		__typename?: "StudentEnrollmentApplicationConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentEnrollmentApplicationEdge"; cursor: string }>;
	};
};

export type StudentEnrollmentApplicationSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentEnrollmentApplicationFilterInput> | StudentEnrollmentApplicationFilterInput>;
	order?: InputMaybe<StudentEnrollmentApplicationOrder>;
}>;

export type StudentEnrollmentApplicationSelectQuery = {
	__typename?: "Query";
	studentEnrollmentApplicationConnection: {
		__typename?: "StudentEnrollmentApplicationConnection";
		edges: Array<{
			__typename?: "StudentEnrollmentApplicationEdge";
			node: { __typename?: "StudentEnrollmentApplication"; id: string };
		}>;
	};
};

export type StudentEnrollmentApplicationUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentEnrollmentApplicationUpdateInput;
}>;

export type StudentEnrollmentApplicationUpdateMutation = {
	__typename?: "Mutation";
	updateStudentEnrollmentApplication: {
		__typename?: "StudentEnrollmentApplication";
		id: string;
		status: StudentEnrollmentApplicationStatus;
		statusUpdatedAt: string;
		enrollmentApplicationStudent: { __typename?: "EnrollmentApplicationStudent"; id: string; name: string };
	};
};

export type StudentEnrollmentIntentCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentEnrollmentIntentFilterInput> | StudentEnrollmentIntentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentEnrollmentIntentOrder>;
}>;

export type StudentEnrollmentIntentCountQuery = {
	__typename?: "Query";
	studentEnrollmentIntentConnection: { __typename?: "StudentEnrollmentIntentConnection"; totalCount: number };
};

export type StudentEnrollmentIntentCreateMutationVariables = Exact<{
	input: StudentEnrollmentIntentCreateInput;
}>;

export type StudentEnrollmentIntentCreateMutation = {
	__typename?: "Mutation";
	createStudentEnrollmentIntent: {
		__typename?: "StudentEnrollmentIntent";
		id: string;
		createdAt: string;
		isEnrolling: boolean;
		isInterestedInMealPlan: boolean;
		declineReason: StudentEnrollmentIntentDeclineReason | null;
		declineReasonDescription: string;
		academicYear: { __typename?: "AcademicYear"; id: string; name: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentEnrollmentIntentDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentEnrollmentIntentDeleteMutation = { __typename?: "Mutation"; deleteStudentEnrollmentIntent: boolean };

export type StudentEnrollmentIntentDetailFragment = {
	__typename?: "StudentEnrollmentIntent";
	id: string;
	createdAt: string;
	isEnrolling: boolean;
	isInterestedInMealPlan: boolean;
	declineReason: StudentEnrollmentIntentDeclineReason | null;
	declineReasonDescription: string;
	academicYear: { __typename?: "AcademicYear"; id: string; name: string };
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type StudentEnrollmentIntentDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentEnrollmentIntentDetailQuery = {
	__typename?: "Query";
	studentEnrollmentIntent: {
		__typename?: "StudentEnrollmentIntent";
		id: string;
		createdAt: string;
		isEnrolling: boolean;
		isInterestedInMealPlan: boolean;
		declineReason: StudentEnrollmentIntentDeclineReason | null;
		declineReasonDescription: string;
		academicYear: { __typename?: "AcademicYear"; id: string; name: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentEnrollmentIntentIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentEnrollmentIntentFilterInput> | StudentEnrollmentIntentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentEnrollmentIntentOrder>;
}>;

export type StudentEnrollmentIntentIndexQuery = {
	__typename?: "Query";
	studentEnrollmentIntentConnection: {
		__typename?: "StudentEnrollmentIntentConnection";
		edges: Array<{
			__typename?: "StudentEnrollmentIntentEdge";
			node: {
				__typename?: "StudentEnrollmentIntent";
				id: string;
				createdAt: string;
				isEnrolling: boolean;
				isInterestedInMealPlan: boolean;
				declineReason: StudentEnrollmentIntentDeclineReason | null;
				declineReasonDescription: string;
			};
		}>;
	};
};

export type StudentEnrollmentIntentNameFragment = { __typename?: "StudentEnrollmentIntent"; id: string };

export type StudentEnrollmentIntentNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentEnrollmentIntentNameQuery = {
	__typename?: "Query";
	studentEnrollmentIntent: { __typename?: "StudentEnrollmentIntent"; id: string };
};

export type StudentEnrollmentIntentNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentEnrollmentIntentFilterInput> | StudentEnrollmentIntentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentEnrollmentIntentOrder>;
}>;

export type StudentEnrollmentIntentNamesQuery = {
	__typename?: "Query";
	studentEnrollmentIntentConnection: {
		__typename?: "StudentEnrollmentIntentConnection";
		edges: Array<{
			__typename?: "StudentEnrollmentIntentEdge";
			node: { __typename?: "StudentEnrollmentIntent"; id: string };
		}>;
	};
};

export type StudentEnrollmentIntentPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentEnrollmentIntentFilterInput> | StudentEnrollmentIntentFilterInput>;
	order?: InputMaybe<StudentEnrollmentIntentOrder>;
}>;

export type StudentEnrollmentIntentPaginationQuery = {
	__typename?: "Query";
	studentEnrollmentIntentConnection: {
		__typename?: "StudentEnrollmentIntentConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentEnrollmentIntentEdge"; cursor: string }>;
	};
};

export type StudentEnrollmentIntentSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentEnrollmentIntentFilterInput> | StudentEnrollmentIntentFilterInput>;
	order?: InputMaybe<StudentEnrollmentIntentOrder>;
}>;

export type StudentEnrollmentIntentSelectQuery = {
	__typename?: "Query";
	studentEnrollmentIntentConnection: {
		__typename?: "StudentEnrollmentIntentConnection";
		edges: Array<{
			__typename?: "StudentEnrollmentIntentEdge";
			node: { __typename?: "StudentEnrollmentIntent"; id: string };
		}>;
	};
};

export type StudentEnrollmentIntentUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentEnrollmentIntentUpdateInput;
}>;

export type StudentEnrollmentIntentUpdateMutation = {
	__typename?: "Mutation";
	updateStudentEnrollmentIntent: {
		__typename?: "StudentEnrollmentIntent";
		id: string;
		createdAt: string;
		isEnrolling: boolean;
		isInterestedInMealPlan: boolean;
		declineReason: StudentEnrollmentIntentDeclineReason | null;
		declineReasonDescription: string;
		academicYear: { __typename?: "AcademicYear"; id: string; name: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentHealthNoteCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentHealthNoteFilterInput> | StudentHealthNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentHealthNoteOrder>;
}>;

export type StudentHealthNoteCountQuery = {
	__typename?: "Query";
	studentHealthNoteConnection: { __typename?: "StudentHealthNoteConnection"; totalCount: number };
};

export type StudentHealthNoteCreateMutationVariables = Exact<{
	input: StudentHealthNoteCreateInput;
}>;

export type StudentHealthNoteCreateMutation = {
	__typename?: "Mutation";
	createStudentHealthNote: {
		__typename?: "StudentHealthNote";
		id: string;
		body: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentHealthNoteDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentHealthNoteDeleteMutation = { __typename?: "Mutation"; deleteStudentHealthNote: boolean };

export type StudentHealthNoteDetailFragment = {
	__typename?: "StudentHealthNote";
	id: string;
	body: string;
	studentNote: { __typename?: "StudentNote"; id: string };
};

export type StudentHealthNoteDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentHealthNoteDetailQuery = {
	__typename?: "Query";
	studentHealthNote: {
		__typename?: "StudentHealthNote";
		id: string;
		body: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentHealthNoteIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentHealthNoteFilterInput> | StudentHealthNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentHealthNoteOrder>;
}>;

export type StudentHealthNoteIndexQuery = {
	__typename?: "Query";
	studentHealthNoteConnection: {
		__typename?: "StudentHealthNoteConnection";
		edges: Array<{
			__typename?: "StudentHealthNoteEdge";
			node: { __typename?: "StudentHealthNote"; id: string; body: string };
		}>;
	};
};

export type StudentHealthNoteNameFragment = { __typename?: "StudentHealthNote"; id: string };

export type StudentHealthNoteNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentHealthNoteNameQuery = {
	__typename?: "Query";
	studentHealthNote: { __typename?: "StudentHealthNote"; id: string };
};

export type StudentHealthNoteNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentHealthNoteFilterInput> | StudentHealthNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentHealthNoteOrder>;
}>;

export type StudentHealthNoteNamesQuery = {
	__typename?: "Query";
	studentHealthNoteConnection: {
		__typename?: "StudentHealthNoteConnection";
		edges: Array<{ __typename?: "StudentHealthNoteEdge"; node: { __typename?: "StudentHealthNote"; id: string } }>;
	};
};

export type StudentHealthNotePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentHealthNoteFilterInput> | StudentHealthNoteFilterInput>;
	order?: InputMaybe<StudentHealthNoteOrder>;
}>;

export type StudentHealthNotePaginationQuery = {
	__typename?: "Query";
	studentHealthNoteConnection: {
		__typename?: "StudentHealthNoteConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentHealthNoteEdge"; cursor: string }>;
	};
};

export type StudentHealthNoteSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentHealthNoteFilterInput> | StudentHealthNoteFilterInput>;
	order?: InputMaybe<StudentHealthNoteOrder>;
}>;

export type StudentHealthNoteSelectQuery = {
	__typename?: "Query";
	studentHealthNoteConnection: {
		__typename?: "StudentHealthNoteConnection";
		edges: Array<{ __typename?: "StudentHealthNoteEdge"; node: { __typename?: "StudentHealthNote"; id: string } }>;
	};
};

export type StudentHealthNoteUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentHealthNoteUpdateInput;
}>;

export type StudentHealthNoteUpdateMutation = {
	__typename?: "Mutation";
	updateStudentHealthNote: {
		__typename?: "StudentHealthNote";
		id: string;
		body: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentHomeRoomSectionEnrollmentCountQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<StudentHomeRoomSectionEnrollmentFilterInput> | StudentHomeRoomSectionEnrollmentFilterInput
	>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentHomeRoomSectionEnrollmentOrder>;
}>;

export type StudentHomeRoomSectionEnrollmentCountQuery = {
	__typename?: "Query";
	studentHomeRoomSectionEnrollmentConnection: {
		__typename?: "StudentHomeRoomSectionEnrollmentConnection";
		totalCount: number;
	};
};

export type StudentHomeRoomSectionEnrollmentCreateMutationVariables = Exact<{
	input: StudentHomeRoomSectionEnrollmentCreateInput;
}>;

export type StudentHomeRoomSectionEnrollmentCreateMutation = {
	__typename?: "Mutation";
	createStudentHomeRoomSectionEnrollment: {
		__typename?: "StudentHomeRoomSectionEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		homeRoomSection: {
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		};
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentHomeRoomSectionEnrollmentDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentHomeRoomSectionEnrollmentDeleteMutation = {
	__typename?: "Mutation";
	deleteStudentHomeRoomSectionEnrollment: boolean;
};

export type StudentHomeRoomSectionEnrollmentDetailFragment = {
	__typename?: "StudentHomeRoomSectionEnrollment";
	id: string;
	lateStartDate: string | null;
	earlyEndDate: string | null;
	homeRoomSection: {
		__typename?: "HomeRoomSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
	};
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type StudentHomeRoomSectionEnrollmentDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentHomeRoomSectionEnrollmentDetailQuery = {
	__typename?: "Query";
	studentHomeRoomSectionEnrollment: {
		__typename?: "StudentHomeRoomSectionEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		homeRoomSection: {
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		};
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentHomeRoomSectionEnrollmentIndexQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<StudentHomeRoomSectionEnrollmentFilterInput> | StudentHomeRoomSectionEnrollmentFilterInput
	>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentHomeRoomSectionEnrollmentOrder>;
}>;

export type StudentHomeRoomSectionEnrollmentIndexQuery = {
	__typename?: "Query";
	studentHomeRoomSectionEnrollmentConnection: {
		__typename?: "StudentHomeRoomSectionEnrollmentConnection";
		edges: Array<{
			__typename?: "StudentHomeRoomSectionEnrollmentEdge";
			node: {
				__typename?: "StudentHomeRoomSectionEnrollment";
				id: string;
				lateStartDate: string | null;
				earlyEndDate: string | null;
			};
		}>;
	};
};

export type StudentHomeRoomSectionEnrollmentNameFragment = {
	__typename?: "StudentHomeRoomSectionEnrollment";
	id: string;
};

export type StudentHomeRoomSectionEnrollmentNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentHomeRoomSectionEnrollmentNameQuery = {
	__typename?: "Query";
	studentHomeRoomSectionEnrollment: { __typename?: "StudentHomeRoomSectionEnrollment"; id: string };
};

export type StudentHomeRoomSectionEnrollmentNamesQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<StudentHomeRoomSectionEnrollmentFilterInput> | StudentHomeRoomSectionEnrollmentFilterInput
	>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentHomeRoomSectionEnrollmentOrder>;
}>;

export type StudentHomeRoomSectionEnrollmentNamesQuery = {
	__typename?: "Query";
	studentHomeRoomSectionEnrollmentConnection: {
		__typename?: "StudentHomeRoomSectionEnrollmentConnection";
		edges: Array<{
			__typename?: "StudentHomeRoomSectionEnrollmentEdge";
			node: { __typename?: "StudentHomeRoomSectionEnrollment"; id: string };
		}>;
	};
};

export type StudentHomeRoomSectionEnrollmentPaginationQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<StudentHomeRoomSectionEnrollmentFilterInput> | StudentHomeRoomSectionEnrollmentFilterInput
	>;
	order?: InputMaybe<StudentHomeRoomSectionEnrollmentOrder>;
}>;

export type StudentHomeRoomSectionEnrollmentPaginationQuery = {
	__typename?: "Query";
	studentHomeRoomSectionEnrollmentConnection: {
		__typename?: "StudentHomeRoomSectionEnrollmentConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentHomeRoomSectionEnrollmentEdge"; cursor: string }>;
	};
};

export type StudentHomeRoomSectionEnrollmentSelectQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<StudentHomeRoomSectionEnrollmentFilterInput> | StudentHomeRoomSectionEnrollmentFilterInput
	>;
	order?: InputMaybe<StudentHomeRoomSectionEnrollmentOrder>;
}>;

export type StudentHomeRoomSectionEnrollmentSelectQuery = {
	__typename?: "Query";
	studentHomeRoomSectionEnrollmentConnection: {
		__typename?: "StudentHomeRoomSectionEnrollmentConnection";
		edges: Array<{
			__typename?: "StudentHomeRoomSectionEnrollmentEdge";
			node: { __typename?: "StudentHomeRoomSectionEnrollment"; id: string };
		}>;
	};
};

export type StudentHomeRoomSectionEnrollmentUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentHomeRoomSectionEnrollmentUpdateInput;
}>;

export type StudentHomeRoomSectionEnrollmentUpdateMutation = {
	__typename?: "Mutation";
	updateStudentHomeRoomSectionEnrollment: {
		__typename?: "StudentHomeRoomSectionEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		homeRoomSection: {
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		};
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentIncidentNoteCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentIncidentNoteFilterInput> | StudentIncidentNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentIncidentNoteOrder>;
}>;

export type StudentIncidentNoteCountQuery = {
	__typename?: "Query";
	studentIncidentNoteConnection: { __typename?: "StudentIncidentNoteConnection"; totalCount: number };
};

export type StudentIncidentNoteCreateMutationVariables = Exact<{
	input: StudentIncidentNoteCreateInput;
}>;

export type StudentIncidentNoteCreateMutation = {
	__typename?: "Mutation";
	createStudentIncidentNote: {
		__typename?: "StudentIncidentNote";
		id: string;
		incidentTime: string | null;
		incidentLocation: StudentIncidentNoteIncidentLocation | null;
		actionsTaken: string;
		suggestionsForFuture: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentIncidentNoteDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentIncidentNoteDeleteMutation = { __typename?: "Mutation"; deleteStudentIncidentNote: boolean };

export type StudentIncidentNoteDetailFragment = {
	__typename?: "StudentIncidentNote";
	id: string;
	incidentTime: string | null;
	incidentLocation: StudentIncidentNoteIncidentLocation | null;
	actionsTaken: string;
	suggestionsForFuture: string;
	studentNote: { __typename?: "StudentNote"; id: string };
};

export type StudentIncidentNoteDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentIncidentNoteDetailQuery = {
	__typename?: "Query";
	studentIncidentNote: {
		__typename?: "StudentIncidentNote";
		id: string;
		incidentTime: string | null;
		incidentLocation: StudentIncidentNoteIncidentLocation | null;
		actionsTaken: string;
		suggestionsForFuture: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentIncidentNoteIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentIncidentNoteFilterInput> | StudentIncidentNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentIncidentNoteOrder>;
}>;

export type StudentIncidentNoteIndexQuery = {
	__typename?: "Query";
	studentIncidentNoteConnection: {
		__typename?: "StudentIncidentNoteConnection";
		edges: Array<{
			__typename?: "StudentIncidentNoteEdge";
			node: {
				__typename?: "StudentIncidentNote";
				id: string;
				incidentTime: string | null;
				incidentLocation: StudentIncidentNoteIncidentLocation | null;
				actionsTaken: string;
				suggestionsForFuture: string;
			};
		}>;
	};
};

export type StudentIncidentNoteNameFragment = { __typename?: "StudentIncidentNote"; id: string };

export type StudentIncidentNoteNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentIncidentNoteNameQuery = {
	__typename?: "Query";
	studentIncidentNote: { __typename?: "StudentIncidentNote"; id: string };
};

export type StudentIncidentNoteNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentIncidentNoteFilterInput> | StudentIncidentNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentIncidentNoteOrder>;
}>;

export type StudentIncidentNoteNamesQuery = {
	__typename?: "Query";
	studentIncidentNoteConnection: {
		__typename?: "StudentIncidentNoteConnection";
		edges: Array<{ __typename?: "StudentIncidentNoteEdge"; node: { __typename?: "StudentIncidentNote"; id: string } }>;
	};
};

export type StudentIncidentNotePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentIncidentNoteFilterInput> | StudentIncidentNoteFilterInput>;
	order?: InputMaybe<StudentIncidentNoteOrder>;
}>;

export type StudentIncidentNotePaginationQuery = {
	__typename?: "Query";
	studentIncidentNoteConnection: {
		__typename?: "StudentIncidentNoteConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentIncidentNoteEdge"; cursor: string }>;
	};
};

export type StudentIncidentNoteSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentIncidentNoteFilterInput> | StudentIncidentNoteFilterInput>;
	order?: InputMaybe<StudentIncidentNoteOrder>;
}>;

export type StudentIncidentNoteSelectQuery = {
	__typename?: "Query";
	studentIncidentNoteConnection: {
		__typename?: "StudentIncidentNoteConnection";
		edges: Array<{ __typename?: "StudentIncidentNoteEdge"; node: { __typename?: "StudentIncidentNote"; id: string } }>;
	};
};

export type StudentIncidentNoteUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentIncidentNoteUpdateInput;
}>;

export type StudentIncidentNoteUpdateMutation = {
	__typename?: "Mutation";
	updateStudentIncidentNote: {
		__typename?: "StudentIncidentNote";
		id: string;
		incidentTime: string | null;
		incidentLocation: StudentIncidentNoteIncidentLocation | null;
		actionsTaken: string;
		suggestionsForFuture: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentInformationVerificationCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentInformationVerificationFilterInput> | StudentInformationVerificationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentInformationVerificationOrder>;
}>;

export type StudentInformationVerificationCountQuery = {
	__typename?: "Query";
	studentInformationVerificationConnection: {
		__typename?: "StudentInformationVerificationConnection";
		totalCount: number;
	};
};

export type StudentInformationVerificationCreateMutationVariables = Exact<{
	input: StudentInformationVerificationCreateInput;
}>;

export type StudentInformationVerificationCreateMutation = {
	__typename?: "Mutation";
	createStudentInformationVerification: {
		__typename?: "StudentInformationVerification";
		id: string;
		createdAt: string;
		hasVerifiedGuardians: boolean;
		hasVerifiedStudentHealth: boolean;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		guardians: Array<{
			__typename?: "Guardian";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		}>;
		students: Array<{
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		}>;
	};
};

export type StudentInformationVerificationDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentInformationVerificationDeleteMutation = {
	__typename?: "Mutation";
	deleteStudentInformationVerification: boolean;
};

export type StudentInformationVerificationDetailFragment = {
	__typename?: "StudentInformationVerification";
	id: string;
	createdAt: string;
	hasVerifiedGuardians: boolean;
	hasVerifiedStudentHealth: boolean;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	} | null;
	guardians: Array<{
		__typename?: "Guardian";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	}>;
	students: Array<{
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	}>;
};

export type StudentInformationVerificationDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentInformationVerificationDetailQuery = {
	__typename?: "Query";
	studentInformationVerification: {
		__typename?: "StudentInformationVerification";
		id: string;
		createdAt: string;
		hasVerifiedGuardians: boolean;
		hasVerifiedStudentHealth: boolean;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		guardians: Array<{
			__typename?: "Guardian";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		}>;
		students: Array<{
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		}>;
	};
};

export type StudentInformationVerificationIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentInformationVerificationFilterInput> | StudentInformationVerificationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentInformationVerificationOrder>;
}>;

export type StudentInformationVerificationIndexQuery = {
	__typename?: "Query";
	studentInformationVerificationConnection: {
		__typename?: "StudentInformationVerificationConnection";
		edges: Array<{
			__typename?: "StudentInformationVerificationEdge";
			node: {
				__typename?: "StudentInformationVerification";
				id: string;
				createdAt: string;
				hasVerifiedGuardians: boolean;
				hasVerifiedStudentHealth: boolean;
			};
		}>;
	};
};

export type StudentInformationVerificationNameFragment = { __typename?: "StudentInformationVerification"; id: string };

export type StudentInformationVerificationNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentInformationVerificationNameQuery = {
	__typename?: "Query";
	studentInformationVerification: { __typename?: "StudentInformationVerification"; id: string };
};

export type StudentInformationVerificationNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentInformationVerificationFilterInput> | StudentInformationVerificationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentInformationVerificationOrder>;
}>;

export type StudentInformationVerificationNamesQuery = {
	__typename?: "Query";
	studentInformationVerificationConnection: {
		__typename?: "StudentInformationVerificationConnection";
		edges: Array<{
			__typename?: "StudentInformationVerificationEdge";
			node: { __typename?: "StudentInformationVerification"; id: string };
		}>;
	};
};

export type StudentInformationVerificationPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentInformationVerificationFilterInput> | StudentInformationVerificationFilterInput>;
	order?: InputMaybe<StudentInformationVerificationOrder>;
}>;

export type StudentInformationVerificationPaginationQuery = {
	__typename?: "Query";
	studentInformationVerificationConnection: {
		__typename?: "StudentInformationVerificationConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentInformationVerificationEdge"; cursor: string }>;
	};
};

export type StudentInformationVerificationSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentInformationVerificationFilterInput> | StudentInformationVerificationFilterInput>;
	order?: InputMaybe<StudentInformationVerificationOrder>;
}>;

export type StudentInformationVerificationSelectQuery = {
	__typename?: "Query";
	studentInformationVerificationConnection: {
		__typename?: "StudentInformationVerificationConnection";
		edges: Array<{
			__typename?: "StudentInformationVerificationEdge";
			node: { __typename?: "StudentInformationVerification"; id: string };
		}>;
	};
};

export type StudentInformationVerificationUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentInformationVerificationUpdateInput;
}>;

export type StudentInformationVerificationUpdateMutation = {
	__typename?: "Mutation";
	updateStudentInformationVerification: {
		__typename?: "StudentInformationVerification";
		id: string;
		createdAt: string;
		hasVerifiedGuardians: boolean;
		hasVerifiedStudentHealth: boolean;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		} | null;
		guardians: Array<{
			__typename?: "Guardian";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		}>;
		students: Array<{
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		}>;
	};
};

export type StudentInjuryNoteCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentInjuryNoteFilterInput> | StudentInjuryNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentInjuryNoteOrder>;
}>;

export type StudentInjuryNoteCountQuery = {
	__typename?: "Query";
	studentInjuryNoteConnection: { __typename?: "StudentInjuryNoteConnection"; totalCount: number };
};

export type StudentInjuryNoteCreateMutationVariables = Exact<{
	input: StudentInjuryNoteCreateInput;
}>;

export type StudentInjuryNoteCreateMutation = {
	__typename?: "Mutation";
	createStudentInjuryNote: {
		__typename?: "StudentInjuryNote";
		id: string;
		incidentTime: string | null;
		incidentLocation: StudentInjuryNoteIncidentLocation | null;
		wereOtherStudentsCauseOfInjury: boolean;
		causeOfInjury: string;
		medicalAttentionProvided: string;
		adultWhoProvidedMedicalAttention: string;
		isActionTakenHomeroomTeachersNotified: boolean;
		isActionTakenParentNotifiedByPortal: boolean;
		isActionTakenParentNotifiedByPhone: boolean;
		isActionTakenParentsRequestedToCollectStudent: boolean;
		isActionTakenParentNotificationNotNecessary: boolean;
		isActionTakenOther: boolean;
		actionTakenOther: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentInjuryNoteDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentInjuryNoteDeleteMutation = { __typename?: "Mutation"; deleteStudentInjuryNote: boolean };

export type StudentInjuryNoteDetailFragment = {
	__typename?: "StudentInjuryNote";
	id: string;
	incidentTime: string | null;
	incidentLocation: StudentInjuryNoteIncidentLocation | null;
	wereOtherStudentsCauseOfInjury: boolean;
	causeOfInjury: string;
	medicalAttentionProvided: string;
	adultWhoProvidedMedicalAttention: string;
	isActionTakenHomeroomTeachersNotified: boolean;
	isActionTakenParentNotifiedByPortal: boolean;
	isActionTakenParentNotifiedByPhone: boolean;
	isActionTakenParentsRequestedToCollectStudent: boolean;
	isActionTakenParentNotificationNotNecessary: boolean;
	isActionTakenOther: boolean;
	actionTakenOther: string;
	studentNote: { __typename?: "StudentNote"; id: string };
};

export type StudentInjuryNoteDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentInjuryNoteDetailQuery = {
	__typename?: "Query";
	studentInjuryNote: {
		__typename?: "StudentInjuryNote";
		id: string;
		incidentTime: string | null;
		incidentLocation: StudentInjuryNoteIncidentLocation | null;
		wereOtherStudentsCauseOfInjury: boolean;
		causeOfInjury: string;
		medicalAttentionProvided: string;
		adultWhoProvidedMedicalAttention: string;
		isActionTakenHomeroomTeachersNotified: boolean;
		isActionTakenParentNotifiedByPortal: boolean;
		isActionTakenParentNotifiedByPhone: boolean;
		isActionTakenParentsRequestedToCollectStudent: boolean;
		isActionTakenParentNotificationNotNecessary: boolean;
		isActionTakenOther: boolean;
		actionTakenOther: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentInjuryNoteIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentInjuryNoteFilterInput> | StudentInjuryNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentInjuryNoteOrder>;
}>;

export type StudentInjuryNoteIndexQuery = {
	__typename?: "Query";
	studentInjuryNoteConnection: {
		__typename?: "StudentInjuryNoteConnection";
		edges: Array<{
			__typename?: "StudentInjuryNoteEdge";
			node: {
				__typename?: "StudentInjuryNote";
				id: string;
				incidentTime: string | null;
				incidentLocation: StudentInjuryNoteIncidentLocation | null;
				wereOtherStudentsCauseOfInjury: boolean;
				causeOfInjury: string;
				medicalAttentionProvided: string;
				adultWhoProvidedMedicalAttention: string;
				isActionTakenHomeroomTeachersNotified: boolean;
				isActionTakenParentNotifiedByPortal: boolean;
				isActionTakenParentNotifiedByPhone: boolean;
				isActionTakenParentsRequestedToCollectStudent: boolean;
				isActionTakenParentNotificationNotNecessary: boolean;
				isActionTakenOther: boolean;
				actionTakenOther: string;
			};
		}>;
	};
};

export type StudentInjuryNoteNameFragment = { __typename?: "StudentInjuryNote"; id: string };

export type StudentInjuryNoteNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentInjuryNoteNameQuery = {
	__typename?: "Query";
	studentInjuryNote: { __typename?: "StudentInjuryNote"; id: string };
};

export type StudentInjuryNoteNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentInjuryNoteFilterInput> | StudentInjuryNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentInjuryNoteOrder>;
}>;

export type StudentInjuryNoteNamesQuery = {
	__typename?: "Query";
	studentInjuryNoteConnection: {
		__typename?: "StudentInjuryNoteConnection";
		edges: Array<{ __typename?: "StudentInjuryNoteEdge"; node: { __typename?: "StudentInjuryNote"; id: string } }>;
	};
};

export type StudentInjuryNotePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentInjuryNoteFilterInput> | StudentInjuryNoteFilterInput>;
	order?: InputMaybe<StudentInjuryNoteOrder>;
}>;

export type StudentInjuryNotePaginationQuery = {
	__typename?: "Query";
	studentInjuryNoteConnection: {
		__typename?: "StudentInjuryNoteConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentInjuryNoteEdge"; cursor: string }>;
	};
};

export type StudentInjuryNoteSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentInjuryNoteFilterInput> | StudentInjuryNoteFilterInput>;
	order?: InputMaybe<StudentInjuryNoteOrder>;
}>;

export type StudentInjuryNoteSelectQuery = {
	__typename?: "Query";
	studentInjuryNoteConnection: {
		__typename?: "StudentInjuryNoteConnection";
		edges: Array<{ __typename?: "StudentInjuryNoteEdge"; node: { __typename?: "StudentInjuryNote"; id: string } }>;
	};
};

export type StudentInjuryNoteUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentInjuryNoteUpdateInput;
}>;

export type StudentInjuryNoteUpdateMutation = {
	__typename?: "Mutation";
	updateStudentInjuryNote: {
		__typename?: "StudentInjuryNote";
		id: string;
		incidentTime: string | null;
		incidentLocation: StudentInjuryNoteIncidentLocation | null;
		wereOtherStudentsCauseOfInjury: boolean;
		causeOfInjury: string;
		medicalAttentionProvided: string;
		adultWhoProvidedMedicalAttention: string;
		isActionTakenHomeroomTeachersNotified: boolean;
		isActionTakenParentNotifiedByPortal: boolean;
		isActionTakenParentNotifiedByPhone: boolean;
		isActionTakenParentsRequestedToCollectStudent: boolean;
		isActionTakenParentNotificationNotNecessary: boolean;
		isActionTakenOther: boolean;
		actionTakenOther: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentMedicalConditionCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalConditionFilterInput> | StudentMedicalConditionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentMedicalConditionOrder>;
}>;

export type StudentMedicalConditionCountQuery = {
	__typename?: "Query";
	studentMedicalConditionConnection: { __typename?: "StudentMedicalConditionConnection"; totalCount: number };
};

export type StudentMedicalConditionCreateMutationVariables = Exact<{
	input: StudentMedicalConditionCreateInput;
}>;

export type StudentMedicalConditionCreateMutation = {
	__typename?: "Mutation";
	createStudentMedicalCondition: {
		__typename?: "StudentMedicalCondition";
		id: string;
		isProminent: boolean;
		notes: string;
		medicalCondition: {
			__typename?: "MedicalCondition";
			id: string;
			conditionType: MedicalConditionConditionType;
			name: string;
		};
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentMedicalConditionDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentMedicalConditionDeleteMutation = { __typename?: "Mutation"; deleteStudentMedicalCondition: boolean };

export type StudentMedicalConditionDetailFragment = {
	__typename?: "StudentMedicalCondition";
	id: string;
	isProminent: boolean;
	notes: string;
	medicalCondition: {
		__typename?: "MedicalCondition";
		id: string;
		conditionType: MedicalConditionConditionType;
		name: string;
	};
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type StudentMedicalConditionDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentMedicalConditionDetailQuery = {
	__typename?: "Query";
	studentMedicalCondition: {
		__typename?: "StudentMedicalCondition";
		id: string;
		isProminent: boolean;
		notes: string;
		medicalCondition: {
			__typename?: "MedicalCondition";
			id: string;
			conditionType: MedicalConditionConditionType;
			name: string;
		};
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentMedicalConditionIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalConditionFilterInput> | StudentMedicalConditionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentMedicalConditionOrder>;
}>;

export type StudentMedicalConditionIndexQuery = {
	__typename?: "Query";
	studentMedicalConditionConnection: {
		__typename?: "StudentMedicalConditionConnection";
		edges: Array<{
			__typename?: "StudentMedicalConditionEdge";
			node: { __typename?: "StudentMedicalCondition"; id: string; isProminent: boolean; notes: string };
		}>;
	};
};

export type StudentMedicalConditionStudentListQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalConditionFilterInput> | StudentMedicalConditionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentMedicalConditionOrder>;
}>;

export type StudentMedicalConditionStudentListQuery = {
	__typename?: "Query";
	studentMedicalConditionConnection: {
		__typename?: "StudentMedicalConditionConnection";
		edges: Array<{
			__typename?: "StudentMedicalConditionEdge";
			node: {
				__typename?: "StudentMedicalCondition";
				id: string;
				isProminent: boolean;
				notes: string;
				medicalCondition: {
					__typename?: "MedicalCondition";
					id: string;
					conditionType: MedicalConditionConditionType;
					name: string;
				};
			};
		}>;
	};
};

export type StudentMedicalConditionNameFragment = { __typename?: "StudentMedicalCondition"; id: string };

export type StudentMedicalConditionNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentMedicalConditionNameQuery = {
	__typename?: "Query";
	studentMedicalCondition: { __typename?: "StudentMedicalCondition"; id: string };
};

export type StudentMedicalConditionNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalConditionFilterInput> | StudentMedicalConditionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentMedicalConditionOrder>;
}>;

export type StudentMedicalConditionNamesQuery = {
	__typename?: "Query";
	studentMedicalConditionConnection: {
		__typename?: "StudentMedicalConditionConnection";
		edges: Array<{
			__typename?: "StudentMedicalConditionEdge";
			node: { __typename?: "StudentMedicalCondition"; id: string };
		}>;
	};
};

export type StudentMedicalConditionPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalConditionFilterInput> | StudentMedicalConditionFilterInput>;
	order?: InputMaybe<StudentMedicalConditionOrder>;
}>;

export type StudentMedicalConditionPaginationQuery = {
	__typename?: "Query";
	studentMedicalConditionConnection: {
		__typename?: "StudentMedicalConditionConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentMedicalConditionEdge"; cursor: string }>;
	};
};

export type StudentMedicalConditionSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalConditionFilterInput> | StudentMedicalConditionFilterInput>;
	order?: InputMaybe<StudentMedicalConditionOrder>;
}>;

export type StudentMedicalConditionSelectQuery = {
	__typename?: "Query";
	studentMedicalConditionConnection: {
		__typename?: "StudentMedicalConditionConnection";
		edges: Array<{
			__typename?: "StudentMedicalConditionEdge";
			node: { __typename?: "StudentMedicalCondition"; id: string };
		}>;
	};
};

export type StudentMedicalConditionUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentMedicalConditionUpdateInput;
}>;

export type StudentMedicalConditionUpdateMutation = {
	__typename?: "Mutation";
	updateStudentMedicalCondition: {
		__typename?: "StudentMedicalCondition";
		id: string;
		isProminent: boolean;
		notes: string;
		medicalCondition: {
			__typename?: "MedicalCondition";
			id: string;
			conditionType: MedicalConditionConditionType;
			name: string;
		};
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentMedicalContactCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalContactFilterInput> | StudentMedicalContactFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentMedicalContactOrder>;
}>;

export type StudentMedicalContactCountQuery = {
	__typename?: "Query";
	studentMedicalContactConnection: { __typename?: "StudentMedicalContactConnection"; totalCount: number };
};

export type StudentMedicalContactCreateMutationVariables = Exact<{
	input: StudentMedicalContactCreateInput;
}>;

export type StudentMedicalContactCreateMutation = {
	__typename?: "Mutation";
	createStudentMedicalContact: {
		__typename?: "StudentMedicalContact";
		id: string;
		name: string;
		contactType: string;
		institutionName: string;
		phoneNumber: string;
		emailAddress: string;
		address: string;
		notes: string;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentMedicalContactDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentMedicalContactDeleteMutation = { __typename?: "Mutation"; deleteStudentMedicalContact: boolean };

export type StudentMedicalContactDetailFragment = {
	__typename?: "StudentMedicalContact";
	id: string;
	name: string;
	contactType: string;
	institutionName: string;
	phoneNumber: string;
	emailAddress: string;
	address: string;
	notes: string;
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type StudentMedicalContactDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentMedicalContactDetailQuery = {
	__typename?: "Query";
	studentMedicalContact: {
		__typename?: "StudentMedicalContact";
		id: string;
		name: string;
		contactType: string;
		institutionName: string;
		phoneNumber: string;
		emailAddress: string;
		address: string;
		notes: string;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentMedicalContactIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalContactFilterInput> | StudentMedicalContactFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentMedicalContactOrder>;
}>;

export type StudentMedicalContactIndexQuery = {
	__typename?: "Query";
	studentMedicalContactConnection: {
		__typename?: "StudentMedicalContactConnection";
		edges: Array<{
			__typename?: "StudentMedicalContactEdge";
			node: {
				__typename?: "StudentMedicalContact";
				id: string;
				name: string;
				contactType: string;
				institutionName: string;
				phoneNumber: string;
				emailAddress: string;
				address: string;
				notes: string;
			};
		}>;
	};
};

export type StudentMedicalContactStudentListQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalContactFilterInput> | StudentMedicalContactFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentMedicalContactOrder>;
}>;

export type StudentMedicalContactStudentListQuery = {
	__typename?: "Query";
	studentMedicalContactConnection: {
		__typename?: "StudentMedicalContactConnection";
		edges: Array<{
			__typename?: "StudentMedicalContactEdge";
			node: {
				__typename?: "StudentMedicalContact";
				id: string;
				name: string;
				contactType: string;
				institutionName: string;
				phoneNumber: string;
				emailAddress: string;
				address: string;
				notes: string;
			};
		}>;
	};
};

export type StudentMedicalContactNameFragment = { __typename?: "StudentMedicalContact"; name: string };

export type StudentMedicalContactNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentMedicalContactNameQuery = {
	__typename?: "Query";
	studentMedicalContact: { __typename?: "StudentMedicalContact"; id: string; name: string };
};

export type StudentMedicalContactNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalContactFilterInput> | StudentMedicalContactFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentMedicalContactOrder>;
}>;

export type StudentMedicalContactNamesQuery = {
	__typename?: "Query";
	studentMedicalContactConnection: {
		__typename?: "StudentMedicalContactConnection";
		edges: Array<{
			__typename?: "StudentMedicalContactEdge";
			node: { __typename?: "StudentMedicalContact"; id: string; name: string };
		}>;
	};
};

export type StudentMedicalContactPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalContactFilterInput> | StudentMedicalContactFilterInput>;
	order?: InputMaybe<StudentMedicalContactOrder>;
}>;

export type StudentMedicalContactPaginationQuery = {
	__typename?: "Query";
	studentMedicalContactConnection: {
		__typename?: "StudentMedicalContactConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentMedicalContactEdge"; cursor: string }>;
	};
};

export type StudentMedicalContactSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalContactFilterInput> | StudentMedicalContactFilterInput>;
	order?: InputMaybe<StudentMedicalContactOrder>;
}>;

export type StudentMedicalContactSelectQuery = {
	__typename?: "Query";
	studentMedicalContactConnection: {
		__typename?: "StudentMedicalContactConnection";
		edges: Array<{
			__typename?: "StudentMedicalContactEdge";
			node: { __typename?: "StudentMedicalContact"; id: string; name: string };
		}>;
	};
};

export type StudentMedicalContactUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentMedicalContactUpdateInput;
}>;

export type StudentMedicalContactUpdateMutation = {
	__typename?: "Mutation";
	updateStudentMedicalContact: {
		__typename?: "StudentMedicalContact";
		id: string;
		name: string;
		contactType: string;
		institutionName: string;
		phoneNumber: string;
		emailAddress: string;
		address: string;
		notes: string;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentMedicalEventCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalEventFilterInput> | StudentMedicalEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentMedicalEventOrder>;
}>;

export type StudentMedicalEventCountQuery = {
	__typename?: "Query";
	studentMedicalEventConnection: { __typename?: "StudentMedicalEventConnection"; totalCount: number };
};

export type StudentMedicalEventCreateMutationVariables = Exact<{
	input: StudentMedicalEventCreateInput;
}>;

export type StudentMedicalEventCreateMutation = {
	__typename?: "Mutation";
	createStudentMedicalEvent: {
		__typename?: "StudentMedicalEvent";
		id: string;
		checkInTime: string;
		checkOutTime: string | null;
		description: string;
		treatment: string;
		outcome: string;
		notes: string;
		attendingEmployees: Array<{
			__typename?: "Employee";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		}>;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
		student: {
			__typename?: "Student";
			id: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		};
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
			taggedPeople: Array<{
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
			}>;
		}>;
	};
};

export type StudentMedicalEventDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentMedicalEventDeleteMutation = { __typename?: "Mutation"; deleteStudentMedicalEvent: boolean };

export type StudentMedicalEventDetailFragment = {
	__typename?: "StudentMedicalEvent";
	id: string;
	checkInTime: string;
	checkOutTime: string | null;
	description: string;
	treatment: string;
	outcome: string;
	notes: string;
	attendingEmployees: Array<{
		__typename?: "Employee";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	}>;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
	} | null;
	student: {
		__typename?: "Student";
		id: string;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		};
	};
	mediaAttachments: Array<{
		__typename?: "MediaAttachment";
		id: string;
		displayOrder: number;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
		taggedPeople: Array<{
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
		}>;
	}>;
};

export type StudentMedicalEventDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentMedicalEventDetailQuery = {
	__typename?: "Query";
	studentMedicalEvent: {
		__typename?: "StudentMedicalEvent";
		id: string;
		checkInTime: string;
		checkOutTime: string | null;
		description: string;
		treatment: string;
		outcome: string;
		notes: string;
		attendingEmployees: Array<{
			__typename?: "Employee";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		}>;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
		student: {
			__typename?: "Student";
			id: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		};
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
			taggedPeople: Array<{
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
			}>;
		}>;
	};
};

export type StudentMedicalEventIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalEventFilterInput> | StudentMedicalEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentMedicalEventOrder>;
}>;

export type StudentMedicalEventIndexQuery = {
	__typename?: "Query";
	studentMedicalEventConnection: {
		__typename?: "StudentMedicalEventConnection";
		edges: Array<{
			__typename?: "StudentMedicalEventEdge";
			node: {
				__typename?: "StudentMedicalEvent";
				id: string;
				checkInTime: string;
				checkOutTime: string | null;
				description: string;
				treatment: string;
				outcome: string;
				notes: string;
			};
		}>;
	};
};

export type StudentMedicalEventNameFragment = { __typename?: "StudentMedicalEvent"; id: string };

export type StudentMedicalEventNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentMedicalEventNameQuery = {
	__typename?: "Query";
	studentMedicalEvent: { __typename?: "StudentMedicalEvent"; id: string };
};

export type StudentMedicalEventNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalEventFilterInput> | StudentMedicalEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentMedicalEventOrder>;
}>;

export type StudentMedicalEventNamesQuery = {
	__typename?: "Query";
	studentMedicalEventConnection: {
		__typename?: "StudentMedicalEventConnection";
		edges: Array<{ __typename?: "StudentMedicalEventEdge"; node: { __typename?: "StudentMedicalEvent"; id: string } }>;
	};
};

export type StudentMedicalEventPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalEventFilterInput> | StudentMedicalEventFilterInput>;
	order?: InputMaybe<StudentMedicalEventOrder>;
}>;

export type StudentMedicalEventPaginationQuery = {
	__typename?: "Query";
	studentMedicalEventConnection: {
		__typename?: "StudentMedicalEventConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentMedicalEventEdge"; cursor: string }>;
	};
};

export type StudentMedicalEventSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalEventFilterInput> | StudentMedicalEventFilterInput>;
	order?: InputMaybe<StudentMedicalEventOrder>;
}>;

export type StudentMedicalEventSelectQuery = {
	__typename?: "Query";
	studentMedicalEventConnection: {
		__typename?: "StudentMedicalEventConnection";
		edges: Array<{ __typename?: "StudentMedicalEventEdge"; node: { __typename?: "StudentMedicalEvent"; id: string } }>;
	};
};

export type StudentMedicalEventUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentMedicalEventUpdateInput;
}>;

export type StudentMedicalEventUpdateMutation = {
	__typename?: "Mutation";
	updateStudentMedicalEvent: {
		__typename?: "StudentMedicalEvent";
		id: string;
		checkInTime: string;
		checkOutTime: string | null;
		description: string;
		treatment: string;
		outcome: string;
		notes: string;
		attendingEmployees: Array<{
			__typename?: "Employee";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		}>;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
		student: {
			__typename?: "Student";
			id: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		};
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
			taggedPeople: Array<{
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
			}>;
		}>;
	};
};

export type StudentMedicalProfileCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalProfileFilterInput> | StudentMedicalProfileFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentMedicalProfileOrder>;
}>;

export type StudentMedicalProfileCountQuery = {
	__typename?: "Query";
	studentMedicalProfileConnection: { __typename?: "StudentMedicalProfileConnection"; totalCount: number };
};

export type StudentMedicalProfileCreateMutationVariables = Exact<{
	input: StudentMedicalProfileCreateInput;
}>;

export type StudentMedicalProfileCreateMutation = {
	__typename?: "Mutation";
	createStudentMedicalProfile: {
		__typename?: "StudentMedicalProfile";
		id: string;
		isSchoolAllowedToTreat: boolean;
		isSchoolAllowedToUseEpipen: boolean;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentMedicalProfileDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentMedicalProfileDeleteMutation = { __typename?: "Mutation"; deleteStudentMedicalProfile: boolean };

export type StudentMedicalProfileDetailFragment = {
	__typename?: "StudentMedicalProfile";
	id: string;
	isSchoolAllowedToTreat: boolean;
	isSchoolAllowedToUseEpipen: boolean;
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type StudentMedicalProfileDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentMedicalProfileDetailQuery = {
	__typename?: "Query";
	studentMedicalProfile: {
		__typename?: "StudentMedicalProfile";
		id: string;
		isSchoolAllowedToTreat: boolean;
		isSchoolAllowedToUseEpipen: boolean;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentMedicalProfileIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalProfileFilterInput> | StudentMedicalProfileFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentMedicalProfileOrder>;
}>;

export type StudentMedicalProfileIndexQuery = {
	__typename?: "Query";
	studentMedicalProfileConnection: {
		__typename?: "StudentMedicalProfileConnection";
		edges: Array<{
			__typename?: "StudentMedicalProfileEdge";
			node: {
				__typename?: "StudentMedicalProfile";
				id: string;
				isSchoolAllowedToTreat: boolean;
				isSchoolAllowedToUseEpipen: boolean;
			};
		}>;
	};
};

export type StudentMedicalProfileNameFragment = { __typename?: "StudentMedicalProfile"; id: string };

export type StudentMedicalProfileNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentMedicalProfileNameQuery = {
	__typename?: "Query";
	studentMedicalProfile: { __typename?: "StudentMedicalProfile"; id: string };
};

export type StudentMedicalProfileNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalProfileFilterInput> | StudentMedicalProfileFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentMedicalProfileOrder>;
}>;

export type StudentMedicalProfileNamesQuery = {
	__typename?: "Query";
	studentMedicalProfileConnection: {
		__typename?: "StudentMedicalProfileConnection";
		edges: Array<{
			__typename?: "StudentMedicalProfileEdge";
			node: { __typename?: "StudentMedicalProfile"; id: string };
		}>;
	};
};

export type StudentMedicalProfilePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalProfileFilterInput> | StudentMedicalProfileFilterInput>;
	order?: InputMaybe<StudentMedicalProfileOrder>;
}>;

export type StudentMedicalProfilePaginationQuery = {
	__typename?: "Query";
	studentMedicalProfileConnection: {
		__typename?: "StudentMedicalProfileConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentMedicalProfileEdge"; cursor: string }>;
	};
};

export type StudentMedicalProfileSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalProfileFilterInput> | StudentMedicalProfileFilterInput>;
	order?: InputMaybe<StudentMedicalProfileOrder>;
}>;

export type StudentMedicalProfileSelectQuery = {
	__typename?: "Query";
	studentMedicalProfileConnection: {
		__typename?: "StudentMedicalProfileConnection";
		edges: Array<{
			__typename?: "StudentMedicalProfileEdge";
			node: { __typename?: "StudentMedicalProfile"; id: string };
		}>;
	};
};

export type StudentMedicalProfileUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentMedicalProfileUpdateInput;
}>;

export type StudentMedicalProfileUpdateMutation = {
	__typename?: "Mutation";
	updateStudentMedicalProfile: {
		__typename?: "StudentMedicalProfile";
		id: string;
		isSchoolAllowedToTreat: boolean;
		isSchoolAllowedToUseEpipen: boolean;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentMedicationNoteCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicationNoteFilterInput> | StudentMedicationNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentMedicationNoteOrder>;
}>;

export type StudentMedicationNoteCountQuery = {
	__typename?: "Query";
	studentMedicationNoteConnection: { __typename?: "StudentMedicationNoteConnection"; totalCount: number };
};

export type StudentMedicationNoteCreateMutationVariables = Exact<{
	input: StudentMedicationNoteCreateInput;
}>;

export type StudentMedicationNoteCreateMutation = {
	__typename?: "Mutation";
	createStudentMedicationNote: {
		__typename?: "StudentMedicationNote";
		id: string;
		body: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentMedicationNoteDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentMedicationNoteDeleteMutation = { __typename?: "Mutation"; deleteStudentMedicationNote: boolean };

export type StudentMedicationNoteDetailFragment = {
	__typename?: "StudentMedicationNote";
	id: string;
	body: string;
	studentNote: { __typename?: "StudentNote"; id: string };
};

export type StudentMedicationNoteDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentMedicationNoteDetailQuery = {
	__typename?: "Query";
	studentMedicationNote: {
		__typename?: "StudentMedicationNote";
		id: string;
		body: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentMedicationNoteIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicationNoteFilterInput> | StudentMedicationNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentMedicationNoteOrder>;
}>;

export type StudentMedicationNoteIndexQuery = {
	__typename?: "Query";
	studentMedicationNoteConnection: {
		__typename?: "StudentMedicationNoteConnection";
		edges: Array<{
			__typename?: "StudentMedicationNoteEdge";
			node: { __typename?: "StudentMedicationNote"; id: string; body: string };
		}>;
	};
};

export type StudentMedicationNoteNameFragment = { __typename?: "StudentMedicationNote"; id: string };

export type StudentMedicationNoteNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentMedicationNoteNameQuery = {
	__typename?: "Query";
	studentMedicationNote: { __typename?: "StudentMedicationNote"; id: string };
};

export type StudentMedicationNoteNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicationNoteFilterInput> | StudentMedicationNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentMedicationNoteOrder>;
}>;

export type StudentMedicationNoteNamesQuery = {
	__typename?: "Query";
	studentMedicationNoteConnection: {
		__typename?: "StudentMedicationNoteConnection";
		edges: Array<{
			__typename?: "StudentMedicationNoteEdge";
			node: { __typename?: "StudentMedicationNote"; id: string };
		}>;
	};
};

export type StudentMedicationNotePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicationNoteFilterInput> | StudentMedicationNoteFilterInput>;
	order?: InputMaybe<StudentMedicationNoteOrder>;
}>;

export type StudentMedicationNotePaginationQuery = {
	__typename?: "Query";
	studentMedicationNoteConnection: {
		__typename?: "StudentMedicationNoteConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentMedicationNoteEdge"; cursor: string }>;
	};
};

export type StudentMedicationNoteSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicationNoteFilterInput> | StudentMedicationNoteFilterInput>;
	order?: InputMaybe<StudentMedicationNoteOrder>;
}>;

export type StudentMedicationNoteSelectQuery = {
	__typename?: "Query";
	studentMedicationNoteConnection: {
		__typename?: "StudentMedicationNoteConnection";
		edges: Array<{
			__typename?: "StudentMedicationNoteEdge";
			node: { __typename?: "StudentMedicationNote"; id: string };
		}>;
	};
};

export type StudentMedicationNoteUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentMedicationNoteUpdateInput;
}>;

export type StudentMedicationNoteUpdateMutation = {
	__typename?: "Mutation";
	updateStudentMedicationNote: {
		__typename?: "StudentMedicationNote";
		id: string;
		body: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentNoteCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentNoteFilterInput> | StudentNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentNoteOrder>;
}>;

export type StudentNoteCountQuery = {
	__typename?: "Query";
	studentNoteConnection: { __typename?: "StudentNoteConnection"; totalCount: number };
};

export type StudentNoteCreateMutationVariables = Exact<{
	input: StudentNoteCreateInput;
}>;

export type StudentNoteCreateMutation = {
	__typename?: "Mutation";
	createStudentNote: {
		__typename?: "StudentNote";
		id: string;
		noteType: StudentNoteNoteType;
		createdAt: string;
		body: string;
		isPinned: boolean;
		requiresResolution: boolean;
		isResolved: boolean;
		resolvedAt: string | null;
		resolutionDescription: string;
		studentAcademicNote: {
			__typename?: "StudentAcademicNote";
			id: string;
			isIssueNatureLearningDifficulty: boolean;
			isIssueNatureAttentionIssue: boolean;
			isIssueNatureFocusIssue: boolean;
			isIssueNatureEmotionalOrVulnerableIssue: boolean;
			isIssueNatureOther: boolean;
			issueNatureOther: string;
			isSolutionRecDifferentiatedLearning: boolean;
			isSolutionRecIndividualLearningPlan: boolean;
			isSolutionRecTutoring: boolean;
			isSolutionRecProfessionalSupport: boolean;
			isSolutionRecInClassSupport: boolean;
			isSolutionRecOther: boolean;
			solutionRecOther: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentAttendanceNote: {
			__typename?: "StudentAttendanceNote";
			id: string;
			startDate: string;
			endDate: string;
			attendanceStatus: {
				__typename?: "AttendanceStatus";
				id: string;
				code: string;
				description: string;
				indicatesAbsent: boolean;
				indicatesLateArrival: boolean;
				indicatesEarlyDeparture: boolean;
				indicatesExcused: boolean;
				name: string;
			} | null;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentBehaviorNote: {
			__typename?: "StudentBehaviorNote";
			id: string;
			incidentTime: string | null;
			incidentLocation: StudentBehaviorNoteIncidentLocation | null;
			isIncidentPhysicalContactAggression: boolean;
			isIncidentFightingPhysicalAggression: boolean;
			isIncidentVerbalAbuseDisrespectingStudent: boolean;
			isIncidentDisrepectingTeacher: boolean;
			isIncidentDisruption: boolean;
			isIncidentDefianceOrNonCompliance: boolean;
			isIncidentOther: boolean;
			incidentOther: string;
			isMotivationAttentionSeeking: boolean;
			isMotivationReaction: boolean;
			isMotivationAnger: boolean;
			isMotivationFrustration: boolean;
			isMotivationHabit: boolean;
			isMotivationLackOfSelfContol: boolean;
			isMotivationOther: boolean;
			motivationOther: string;
			isConsequenceRecDirectorIntervention: boolean;
			isConsequenceRecSenOrSelIntervention: boolean;
			isConsequenceRecStudentServiceTeamIntervention: boolean;
			isConsequenceRecParentContactFromReporter: boolean;
			isConsequenceRecParentContactFromSchoolDirector: boolean;
			isConsequenceRecOther: boolean;
			consequenceRecOther: string;
			additionalComments: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentHealthNote: {
			__typename?: "StudentHealthNote";
			id: string;
			body: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentIncidentNote: {
			__typename?: "StudentIncidentNote";
			id: string;
			incidentTime: string | null;
			incidentLocation: StudentIncidentNoteIncidentLocation | null;
			actionsTaken: string;
			suggestionsForFuture: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentInjuryNote: {
			__typename?: "StudentInjuryNote";
			id: string;
			incidentTime: string | null;
			incidentLocation: StudentInjuryNoteIncidentLocation | null;
			wereOtherStudentsCauseOfInjury: boolean;
			causeOfInjury: string;
			medicalAttentionProvided: string;
			adultWhoProvidedMedicalAttention: string;
			isActionTakenHomeroomTeachersNotified: boolean;
			isActionTakenParentNotifiedByPortal: boolean;
			isActionTakenParentNotifiedByPhone: boolean;
			isActionTakenParentsRequestedToCollectStudent: boolean;
			isActionTakenParentNotificationNotNecessary: boolean;
			isActionTakenOther: boolean;
			actionTakenOther: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentMedicationNote: {
			__typename?: "StudentMedicationNote";
			id: string;
			body: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentSocialEmotionalNote: {
			__typename?: "StudentSocialEmotionalNote";
			id: string;
			isIssueNatureLearningDifficulty: boolean;
			isIssueNatureAttentionIssue: boolean;
			isIssueNatureFocusIssue: boolean;
			isIssueNatureEmotionalOrVulnerableIssue: boolean;
			isIssueNatureOther: boolean;
			issueNatureOther: string;
			isSolutionRecDifferentiatedLearning: boolean;
			isSolutionRecIndividualLearningPlan: boolean;
			isSolutionRecTutoring: boolean;
			isSolutionRecProfessionalSupport: boolean;
			isSolutionRecInClassSupport: boolean;
			isSolutionRecOther: boolean;
			solutionRecOther: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
		primaryStudents: Array<{
			__typename?: "Student";
			id: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
		secondaryStudents: Array<{
			__typename?: "Student";
			id: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
			taggedPeople: Array<{
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
			}>;
		}>;
		socialComments: Array<{
			__typename?: "SocialComment";
			id: string;
			body: string;
			createdAt: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				email: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
			};
		}>;
	};
};

export type StudentNoteDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentNoteDeleteMutation = { __typename?: "Mutation"; deleteStudentNote: boolean };

export type StudentNoteDetailFragment = {
	__typename?: "StudentNote";
	id: string;
	noteType: StudentNoteNoteType;
	createdAt: string;
	body: string;
	isPinned: boolean;
	requiresResolution: boolean;
	isResolved: boolean;
	resolvedAt: string | null;
	resolutionDescription: string;
	studentAcademicNote: {
		__typename?: "StudentAcademicNote";
		id: string;
		isIssueNatureLearningDifficulty: boolean;
		isIssueNatureAttentionIssue: boolean;
		isIssueNatureFocusIssue: boolean;
		isIssueNatureEmotionalOrVulnerableIssue: boolean;
		isIssueNatureOther: boolean;
		issueNatureOther: string;
		isSolutionRecDifferentiatedLearning: boolean;
		isSolutionRecIndividualLearningPlan: boolean;
		isSolutionRecTutoring: boolean;
		isSolutionRecProfessionalSupport: boolean;
		isSolutionRecInClassSupport: boolean;
		isSolutionRecOther: boolean;
		solutionRecOther: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	} | null;
	studentAttendanceNote: {
		__typename?: "StudentAttendanceNote";
		id: string;
		startDate: string;
		endDate: string;
		attendanceStatus: {
			__typename?: "AttendanceStatus";
			id: string;
			code: string;
			description: string;
			indicatesAbsent: boolean;
			indicatesLateArrival: boolean;
			indicatesEarlyDeparture: boolean;
			indicatesExcused: boolean;
			name: string;
		} | null;
		studentNote: { __typename?: "StudentNote"; id: string };
	} | null;
	studentBehaviorNote: {
		__typename?: "StudentBehaviorNote";
		id: string;
		incidentTime: string | null;
		incidentLocation: StudentBehaviorNoteIncidentLocation | null;
		isIncidentPhysicalContactAggression: boolean;
		isIncidentFightingPhysicalAggression: boolean;
		isIncidentVerbalAbuseDisrespectingStudent: boolean;
		isIncidentDisrepectingTeacher: boolean;
		isIncidentDisruption: boolean;
		isIncidentDefianceOrNonCompliance: boolean;
		isIncidentOther: boolean;
		incidentOther: string;
		isMotivationAttentionSeeking: boolean;
		isMotivationReaction: boolean;
		isMotivationAnger: boolean;
		isMotivationFrustration: boolean;
		isMotivationHabit: boolean;
		isMotivationLackOfSelfContol: boolean;
		isMotivationOther: boolean;
		motivationOther: string;
		isConsequenceRecDirectorIntervention: boolean;
		isConsequenceRecSenOrSelIntervention: boolean;
		isConsequenceRecStudentServiceTeamIntervention: boolean;
		isConsequenceRecParentContactFromReporter: boolean;
		isConsequenceRecParentContactFromSchoolDirector: boolean;
		isConsequenceRecOther: boolean;
		consequenceRecOther: string;
		additionalComments: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	} | null;
	studentHealthNote: {
		__typename?: "StudentHealthNote";
		id: string;
		body: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	} | null;
	studentIncidentNote: {
		__typename?: "StudentIncidentNote";
		id: string;
		incidentTime: string | null;
		incidentLocation: StudentIncidentNoteIncidentLocation | null;
		actionsTaken: string;
		suggestionsForFuture: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	} | null;
	studentInjuryNote: {
		__typename?: "StudentInjuryNote";
		id: string;
		incidentTime: string | null;
		incidentLocation: StudentInjuryNoteIncidentLocation | null;
		wereOtherStudentsCauseOfInjury: boolean;
		causeOfInjury: string;
		medicalAttentionProvided: string;
		adultWhoProvidedMedicalAttention: string;
		isActionTakenHomeroomTeachersNotified: boolean;
		isActionTakenParentNotifiedByPortal: boolean;
		isActionTakenParentNotifiedByPhone: boolean;
		isActionTakenParentsRequestedToCollectStudent: boolean;
		isActionTakenParentNotificationNotNecessary: boolean;
		isActionTakenOther: boolean;
		actionTakenOther: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	} | null;
	studentMedicationNote: {
		__typename?: "StudentMedicationNote";
		id: string;
		body: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	} | null;
	studentSocialEmotionalNote: {
		__typename?: "StudentSocialEmotionalNote";
		id: string;
		isIssueNatureLearningDifficulty: boolean;
		isIssueNatureAttentionIssue: boolean;
		isIssueNatureFocusIssue: boolean;
		isIssueNatureEmotionalOrVulnerableIssue: boolean;
		isIssueNatureOther: boolean;
		issueNatureOther: string;
		isSolutionRecDifferentiatedLearning: boolean;
		isSolutionRecIndividualLearningPlan: boolean;
		isSolutionRecTutoring: boolean;
		isSolutionRecProfessionalSupport: boolean;
		isSolutionRecInClassSupport: boolean;
		isSolutionRecOther: boolean;
		solutionRecOther: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	} | null;
	author: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
	} | null;
	primaryStudents: Array<{
		__typename?: "Student";
		id: string;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		};
	}>;
	secondaryStudents: Array<{
		__typename?: "Student";
		id: string;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		};
	}>;
	mediaAttachments: Array<{
		__typename?: "MediaAttachment";
		id: string;
		displayOrder: number;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
		taggedPeople: Array<{
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
		}>;
	}>;
	socialComments: Array<{
		__typename?: "SocialComment";
		id: string;
		body: string;
		createdAt: string;
		author: {
			__typename?: "User";
			id: string;
			isCurrent: boolean;
			email: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		};
	}>;
};

export type StudentNoteDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentNoteDetailQuery = {
	__typename?: "Query";
	studentNote: {
		__typename?: "StudentNote";
		id: string;
		noteType: StudentNoteNoteType;
		createdAt: string;
		body: string;
		isPinned: boolean;
		requiresResolution: boolean;
		isResolved: boolean;
		resolvedAt: string | null;
		resolutionDescription: string;
		studentAcademicNote: {
			__typename?: "StudentAcademicNote";
			id: string;
			isIssueNatureLearningDifficulty: boolean;
			isIssueNatureAttentionIssue: boolean;
			isIssueNatureFocusIssue: boolean;
			isIssueNatureEmotionalOrVulnerableIssue: boolean;
			isIssueNatureOther: boolean;
			issueNatureOther: string;
			isSolutionRecDifferentiatedLearning: boolean;
			isSolutionRecIndividualLearningPlan: boolean;
			isSolutionRecTutoring: boolean;
			isSolutionRecProfessionalSupport: boolean;
			isSolutionRecInClassSupport: boolean;
			isSolutionRecOther: boolean;
			solutionRecOther: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentAttendanceNote: {
			__typename?: "StudentAttendanceNote";
			id: string;
			startDate: string;
			endDate: string;
			attendanceStatus: {
				__typename?: "AttendanceStatus";
				id: string;
				code: string;
				description: string;
				indicatesAbsent: boolean;
				indicatesLateArrival: boolean;
				indicatesEarlyDeparture: boolean;
				indicatesExcused: boolean;
				name: string;
			} | null;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentBehaviorNote: {
			__typename?: "StudentBehaviorNote";
			id: string;
			incidentTime: string | null;
			incidentLocation: StudentBehaviorNoteIncidentLocation | null;
			isIncidentPhysicalContactAggression: boolean;
			isIncidentFightingPhysicalAggression: boolean;
			isIncidentVerbalAbuseDisrespectingStudent: boolean;
			isIncidentDisrepectingTeacher: boolean;
			isIncidentDisruption: boolean;
			isIncidentDefianceOrNonCompliance: boolean;
			isIncidentOther: boolean;
			incidentOther: string;
			isMotivationAttentionSeeking: boolean;
			isMotivationReaction: boolean;
			isMotivationAnger: boolean;
			isMotivationFrustration: boolean;
			isMotivationHabit: boolean;
			isMotivationLackOfSelfContol: boolean;
			isMotivationOther: boolean;
			motivationOther: string;
			isConsequenceRecDirectorIntervention: boolean;
			isConsequenceRecSenOrSelIntervention: boolean;
			isConsequenceRecStudentServiceTeamIntervention: boolean;
			isConsequenceRecParentContactFromReporter: boolean;
			isConsequenceRecParentContactFromSchoolDirector: boolean;
			isConsequenceRecOther: boolean;
			consequenceRecOther: string;
			additionalComments: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentHealthNote: {
			__typename?: "StudentHealthNote";
			id: string;
			body: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentIncidentNote: {
			__typename?: "StudentIncidentNote";
			id: string;
			incidentTime: string | null;
			incidentLocation: StudentIncidentNoteIncidentLocation | null;
			actionsTaken: string;
			suggestionsForFuture: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentInjuryNote: {
			__typename?: "StudentInjuryNote";
			id: string;
			incidentTime: string | null;
			incidentLocation: StudentInjuryNoteIncidentLocation | null;
			wereOtherStudentsCauseOfInjury: boolean;
			causeOfInjury: string;
			medicalAttentionProvided: string;
			adultWhoProvidedMedicalAttention: string;
			isActionTakenHomeroomTeachersNotified: boolean;
			isActionTakenParentNotifiedByPortal: boolean;
			isActionTakenParentNotifiedByPhone: boolean;
			isActionTakenParentsRequestedToCollectStudent: boolean;
			isActionTakenParentNotificationNotNecessary: boolean;
			isActionTakenOther: boolean;
			actionTakenOther: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentMedicationNote: {
			__typename?: "StudentMedicationNote";
			id: string;
			body: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentSocialEmotionalNote: {
			__typename?: "StudentSocialEmotionalNote";
			id: string;
			isIssueNatureLearningDifficulty: boolean;
			isIssueNatureAttentionIssue: boolean;
			isIssueNatureFocusIssue: boolean;
			isIssueNatureEmotionalOrVulnerableIssue: boolean;
			isIssueNatureOther: boolean;
			issueNatureOther: string;
			isSolutionRecDifferentiatedLearning: boolean;
			isSolutionRecIndividualLearningPlan: boolean;
			isSolutionRecTutoring: boolean;
			isSolutionRecProfessionalSupport: boolean;
			isSolutionRecInClassSupport: boolean;
			isSolutionRecOther: boolean;
			solutionRecOther: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
		primaryStudents: Array<{
			__typename?: "Student";
			id: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
		secondaryStudents: Array<{
			__typename?: "Student";
			id: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
			taggedPeople: Array<{
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
			}>;
		}>;
		socialComments: Array<{
			__typename?: "SocialComment";
			id: string;
			body: string;
			createdAt: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				email: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
			};
		}>;
	};
};

export type StudentNoteIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentNoteFilterInput> | StudentNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentNoteOrder>;
}>;

export type StudentNoteIndexQuery = {
	__typename?: "Query";
	studentNoteConnection: {
		__typename?: "StudentNoteConnection";
		edges: Array<{
			__typename?: "StudentNoteEdge";
			node: {
				__typename?: "StudentNote";
				id: string;
				noteType: StudentNoteNoteType;
				createdAt: string;
				body: string;
				isPinned: boolean;
				requiresResolution: boolean;
				isResolved: boolean;
				resolvedAt: string | null;
				resolutionDescription: string;
			};
		}>;
	};
};

export type StudentNoteStudentPinnedListQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentNoteFilterInput> | StudentNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentNoteOrder>;
}>;

export type StudentNoteStudentPinnedListQuery = {
	__typename?: "Query";
	studentNoteConnection: {
		__typename?: "StudentNoteConnection";
		edges: Array<{
			__typename?: "StudentNoteEdge";
			node: {
				__typename?: "StudentNote";
				id: string;
				noteType: StudentNoteNoteType;
				createdAt: string;
				body: string;
				isPinned: boolean;
			};
		}>;
	};
};

export type StudentNoteOverviewListQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentNoteFilterInput> | StudentNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentNoteOrder>;
}>;

export type StudentNoteOverviewListQuery = {
	__typename?: "Query";
	studentNoteConnection: {
		__typename?: "StudentNoteConnection";
		edges: Array<{
			__typename?: "StudentNoteEdge";
			node: {
				__typename?: "StudentNote";
				id: string;
				noteType: StudentNoteNoteType;
				createdAt: string;
				body: string;
				isPinned: boolean;
				primaryStudents: Array<{
					__typename?: "Student";
					id: string;
					person: { __typename?: "Person"; id: string; name: string; publicName: string };
				}>;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
				} | null;
			};
		}>;
	};
};

export type StudentAttendanceNotesListQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentNoteFilterInput> | StudentNoteFilterInput>;
	studentFilters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentNoteOrder>;
}>;

export type StudentAttendanceNotesListQuery = {
	__typename?: "Query";
	studentNoteConnection: {
		__typename?: "StudentNoteConnection";
		edges: Array<{
			__typename?: "StudentNoteEdge";
			node: {
				__typename?: "StudentNote";
				id: string;
				noteType: StudentNoteNoteType;
				createdAt: string;
				body: string;
				studentAttendanceNote: {
					__typename?: "StudentAttendanceNote";
					id: string;
					startDate: string;
					endDate: string;
					attendanceStatus: {
						__typename?: "AttendanceStatus";
						id: string;
						name: string;
						code: string;
						description: string;
						indicatesAbsent: boolean;
						indicatesLateArrival: boolean;
						indicatesEarlyDeparture: boolean;
						indicatesExcused: boolean;
					} | null;
				} | null;
				primaryStudents: Array<{
					__typename?: "Student";
					id: string;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					};
				}>;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					} | null;
				} | null;
			};
		}>;
	};
};

export type StudentNoteNameFragment = { __typename?: "StudentNote"; id: string };

export type StudentNoteNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentNoteNameQuery = { __typename?: "Query"; studentNote: { __typename?: "StudentNote"; id: string } };

export type StudentNoteNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentNoteFilterInput> | StudentNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentNoteOrder>;
}>;

export type StudentNoteNamesQuery = {
	__typename?: "Query";
	studentNoteConnection: {
		__typename?: "StudentNoteConnection";
		edges: Array<{ __typename?: "StudentNoteEdge"; node: { __typename?: "StudentNote"; id: string } }>;
	};
};

export type StudentNotePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentNoteFilterInput> | StudentNoteFilterInput>;
	order?: InputMaybe<StudentNoteOrder>;
}>;

export type StudentNotePaginationQuery = {
	__typename?: "Query";
	studentNoteConnection: {
		__typename?: "StudentNoteConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentNoteEdge"; cursor: string }>;
	};
};

export type StudentNoteSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentNoteFilterInput> | StudentNoteFilterInput>;
	order?: InputMaybe<StudentNoteOrder>;
}>;

export type StudentNoteSelectQuery = {
	__typename?: "Query";
	studentNoteConnection: {
		__typename?: "StudentNoteConnection";
		edges: Array<{ __typename?: "StudentNoteEdge"; node: { __typename?: "StudentNote"; id: string } }>;
	};
};

export type StudentNoteUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentNoteUpdateInput;
}>;

export type StudentNoteUpdateMutation = {
	__typename?: "Mutation";
	updateStudentNote: {
		__typename?: "StudentNote";
		id: string;
		noteType: StudentNoteNoteType;
		createdAt: string;
		body: string;
		isPinned: boolean;
		requiresResolution: boolean;
		isResolved: boolean;
		resolvedAt: string | null;
		resolutionDescription: string;
		studentAcademicNote: {
			__typename?: "StudentAcademicNote";
			id: string;
			isIssueNatureLearningDifficulty: boolean;
			isIssueNatureAttentionIssue: boolean;
			isIssueNatureFocusIssue: boolean;
			isIssueNatureEmotionalOrVulnerableIssue: boolean;
			isIssueNatureOther: boolean;
			issueNatureOther: string;
			isSolutionRecDifferentiatedLearning: boolean;
			isSolutionRecIndividualLearningPlan: boolean;
			isSolutionRecTutoring: boolean;
			isSolutionRecProfessionalSupport: boolean;
			isSolutionRecInClassSupport: boolean;
			isSolutionRecOther: boolean;
			solutionRecOther: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentAttendanceNote: {
			__typename?: "StudentAttendanceNote";
			id: string;
			startDate: string;
			endDate: string;
			attendanceStatus: {
				__typename?: "AttendanceStatus";
				id: string;
				code: string;
				description: string;
				indicatesAbsent: boolean;
				indicatesLateArrival: boolean;
				indicatesEarlyDeparture: boolean;
				indicatesExcused: boolean;
				name: string;
			} | null;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentBehaviorNote: {
			__typename?: "StudentBehaviorNote";
			id: string;
			incidentTime: string | null;
			incidentLocation: StudentBehaviorNoteIncidentLocation | null;
			isIncidentPhysicalContactAggression: boolean;
			isIncidentFightingPhysicalAggression: boolean;
			isIncidentVerbalAbuseDisrespectingStudent: boolean;
			isIncidentDisrepectingTeacher: boolean;
			isIncidentDisruption: boolean;
			isIncidentDefianceOrNonCompliance: boolean;
			isIncidentOther: boolean;
			incidentOther: string;
			isMotivationAttentionSeeking: boolean;
			isMotivationReaction: boolean;
			isMotivationAnger: boolean;
			isMotivationFrustration: boolean;
			isMotivationHabit: boolean;
			isMotivationLackOfSelfContol: boolean;
			isMotivationOther: boolean;
			motivationOther: string;
			isConsequenceRecDirectorIntervention: boolean;
			isConsequenceRecSenOrSelIntervention: boolean;
			isConsequenceRecStudentServiceTeamIntervention: boolean;
			isConsequenceRecParentContactFromReporter: boolean;
			isConsequenceRecParentContactFromSchoolDirector: boolean;
			isConsequenceRecOther: boolean;
			consequenceRecOther: string;
			additionalComments: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentHealthNote: {
			__typename?: "StudentHealthNote";
			id: string;
			body: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentIncidentNote: {
			__typename?: "StudentIncidentNote";
			id: string;
			incidentTime: string | null;
			incidentLocation: StudentIncidentNoteIncidentLocation | null;
			actionsTaken: string;
			suggestionsForFuture: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentInjuryNote: {
			__typename?: "StudentInjuryNote";
			id: string;
			incidentTime: string | null;
			incidentLocation: StudentInjuryNoteIncidentLocation | null;
			wereOtherStudentsCauseOfInjury: boolean;
			causeOfInjury: string;
			medicalAttentionProvided: string;
			adultWhoProvidedMedicalAttention: string;
			isActionTakenHomeroomTeachersNotified: boolean;
			isActionTakenParentNotifiedByPortal: boolean;
			isActionTakenParentNotifiedByPhone: boolean;
			isActionTakenParentsRequestedToCollectStudent: boolean;
			isActionTakenParentNotificationNotNecessary: boolean;
			isActionTakenOther: boolean;
			actionTakenOther: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentMedicationNote: {
			__typename?: "StudentMedicationNote";
			id: string;
			body: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		studentSocialEmotionalNote: {
			__typename?: "StudentSocialEmotionalNote";
			id: string;
			isIssueNatureLearningDifficulty: boolean;
			isIssueNatureAttentionIssue: boolean;
			isIssueNatureFocusIssue: boolean;
			isIssueNatureEmotionalOrVulnerableIssue: boolean;
			isIssueNatureOther: boolean;
			issueNatureOther: string;
			isSolutionRecDifferentiatedLearning: boolean;
			isSolutionRecIndividualLearningPlan: boolean;
			isSolutionRecTutoring: boolean;
			isSolutionRecProfessionalSupport: boolean;
			isSolutionRecInClassSupport: boolean;
			isSolutionRecOther: boolean;
			solutionRecOther: string;
			studentNote: { __typename?: "StudentNote"; id: string };
		} | null;
		author: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		} | null;
		primaryStudents: Array<{
			__typename?: "Student";
			id: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
		secondaryStudents: Array<{
			__typename?: "Student";
			id: string;
			person: {
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
			taggedPeople: Array<{
				__typename?: "Person";
				id: string;
				name: string;
				publicName: string;
				user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
			}>;
		}>;
		socialComments: Array<{
			__typename?: "SocialComment";
			id: string;
			body: string;
			createdAt: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				email: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
			};
		}>;
	};
};

export type StudentOTCMedicationCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentOTCMedicationFilterInput> | StudentOTCMedicationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentOTCMedicationOrder>;
}>;

export type StudentOTCMedicationCountQuery = {
	__typename?: "Query";
	studentOTCMedicationConnection: { __typename?: "StudentOTCMedicationConnection"; totalCount: number };
};

export type StudentOTCMedicationCreateMutationVariables = Exact<{
	input: StudentOTCMedicationCreateInput;
}>;

export type StudentOTCMedicationCreateMutation = {
	__typename?: "Mutation";
	createStudentOTCMedication: {
		__typename?: "StudentOTCMedication";
		id: string;
		isAllowed: boolean;
		notes: string;
		medication: { __typename?: "Medication"; id: string; name: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentOTCMedicationDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentOTCMedicationDeleteMutation = { __typename?: "Mutation"; deleteStudentOTCMedication: boolean };

export type StudentOTCMedicationDetailFragment = {
	__typename?: "StudentOTCMedication";
	id: string;
	isAllowed: boolean;
	notes: string;
	medication: { __typename?: "Medication"; id: string; name: string };
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type StudentOTCMedicationDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentOTCMedicationDetailQuery = {
	__typename?: "Query";
	studentOTCMedication: {
		__typename?: "StudentOTCMedication";
		id: string;
		isAllowed: boolean;
		notes: string;
		medication: { __typename?: "Medication"; id: string; name: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentOTCMedicationIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentOTCMedicationFilterInput> | StudentOTCMedicationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentOTCMedicationOrder>;
}>;

export type StudentOTCMedicationIndexQuery = {
	__typename?: "Query";
	studentOTCMedicationConnection: {
		__typename?: "StudentOTCMedicationConnection";
		edges: Array<{
			__typename?: "StudentOTCMedicationEdge";
			node: { __typename?: "StudentOTCMedication"; id: string; isAllowed: boolean; notes: string };
		}>;
	};
};

export type StudentOTCMedicationStudentListQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentOTCMedicationFilterInput> | StudentOTCMedicationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentOTCMedicationOrder>;
}>;

export type StudentOTCMedicationStudentListQuery = {
	__typename?: "Query";
	studentOTCMedicationConnection: {
		__typename?: "StudentOTCMedicationConnection";
		edges: Array<{
			__typename?: "StudentOTCMedicationEdge";
			node: {
				__typename?: "StudentOTCMedication";
				id: string;
				isAllowed: boolean;
				notes: string;
				medication: { __typename?: "Medication"; id: string; name: string };
			};
		}>;
	};
};

export type StudentOTCMedicationNameFragment = { __typename?: "StudentOTCMedication"; id: string };

export type StudentOTCMedicationNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentOTCMedicationNameQuery = {
	__typename?: "Query";
	studentOTCMedication: { __typename?: "StudentOTCMedication"; id: string };
};

export type StudentOTCMedicationNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentOTCMedicationFilterInput> | StudentOTCMedicationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentOTCMedicationOrder>;
}>;

export type StudentOTCMedicationNamesQuery = {
	__typename?: "Query";
	studentOTCMedicationConnection: {
		__typename?: "StudentOTCMedicationConnection";
		edges: Array<{
			__typename?: "StudentOTCMedicationEdge";
			node: { __typename?: "StudentOTCMedication"; id: string };
		}>;
	};
};

export type StudentOTCMedicationPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentOTCMedicationFilterInput> | StudentOTCMedicationFilterInput>;
	order?: InputMaybe<StudentOTCMedicationOrder>;
}>;

export type StudentOTCMedicationPaginationQuery = {
	__typename?: "Query";
	studentOTCMedicationConnection: {
		__typename?: "StudentOTCMedicationConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentOTCMedicationEdge"; cursor: string }>;
	};
};

export type StudentOTCMedicationSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentOTCMedicationFilterInput> | StudentOTCMedicationFilterInput>;
	order?: InputMaybe<StudentOTCMedicationOrder>;
}>;

export type StudentOTCMedicationSelectQuery = {
	__typename?: "Query";
	studentOTCMedicationConnection: {
		__typename?: "StudentOTCMedicationConnection";
		edges: Array<{
			__typename?: "StudentOTCMedicationEdge";
			node: { __typename?: "StudentOTCMedication"; id: string };
		}>;
	};
};

export type StudentOTCMedicationUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentOTCMedicationUpdateInput;
}>;

export type StudentOTCMedicationUpdateMutation = {
	__typename?: "Mutation";
	updateStudentOTCMedication: {
		__typename?: "StudentOTCMedication";
		id: string;
		isAllowed: boolean;
		notes: string;
		medication: { __typename?: "Medication"; id: string; name: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentPrescriptionMedicationCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentPrescriptionMedicationFilterInput> | StudentPrescriptionMedicationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentPrescriptionMedicationOrder>;
}>;

export type StudentPrescriptionMedicationCountQuery = {
	__typename?: "Query";
	studentPrescriptionMedicationConnection: {
		__typename?: "StudentPrescriptionMedicationConnection";
		totalCount: number;
	};
};

export type StudentPrescriptionMedicationCreateMutationVariables = Exact<{
	input: StudentPrescriptionMedicationCreateInput;
}>;

export type StudentPrescriptionMedicationCreateMutation = {
	__typename?: "Mutation";
	createStudentPrescriptionMedication: {
		__typename?: "StudentPrescriptionMedication";
		id: string;
		administration: string;
		canSelfAdminister: boolean;
		notes: string;
		medication: { __typename?: "Medication"; id: string; name: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentPrescriptionMedicationDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentPrescriptionMedicationDeleteMutation = {
	__typename?: "Mutation";
	deleteStudentPrescriptionMedication: boolean;
};

export type StudentPrescriptionMedicationDetailFragment = {
	__typename?: "StudentPrescriptionMedication";
	id: string;
	administration: string;
	canSelfAdminister: boolean;
	notes: string;
	medication: { __typename?: "Medication"; id: string; name: string };
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type StudentPrescriptionMedicationDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentPrescriptionMedicationDetailQuery = {
	__typename?: "Query";
	studentPrescriptionMedication: {
		__typename?: "StudentPrescriptionMedication";
		id: string;
		administration: string;
		canSelfAdminister: boolean;
		notes: string;
		medication: { __typename?: "Medication"; id: string; name: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentPrescriptionMedicationIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentPrescriptionMedicationFilterInput> | StudentPrescriptionMedicationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentPrescriptionMedicationOrder>;
}>;

export type StudentPrescriptionMedicationIndexQuery = {
	__typename?: "Query";
	studentPrescriptionMedicationConnection: {
		__typename?: "StudentPrescriptionMedicationConnection";
		edges: Array<{
			__typename?: "StudentPrescriptionMedicationEdge";
			node: {
				__typename?: "StudentPrescriptionMedication";
				id: string;
				administration: string;
				canSelfAdminister: boolean;
				notes: string;
			};
		}>;
	};
};

export type StudentPrescriptionMedicationStudentListQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentPrescriptionMedicationFilterInput> | StudentPrescriptionMedicationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentPrescriptionMedicationOrder>;
}>;

export type StudentPrescriptionMedicationStudentListQuery = {
	__typename?: "Query";
	studentPrescriptionMedicationConnection: {
		__typename?: "StudentPrescriptionMedicationConnection";
		edges: Array<{
			__typename?: "StudentPrescriptionMedicationEdge";
			node: {
				__typename?: "StudentPrescriptionMedication";
				id: string;
				administration: string;
				canSelfAdminister: boolean;
				notes: string;
				medication: { __typename?: "Medication"; id: string; name: string };
			};
		}>;
	};
};

export type StudentPrescriptionMedicationNameFragment = { __typename?: "StudentPrescriptionMedication"; id: string };

export type StudentPrescriptionMedicationNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentPrescriptionMedicationNameQuery = {
	__typename?: "Query";
	studentPrescriptionMedication: { __typename?: "StudentPrescriptionMedication"; id: string };
};

export type StudentPrescriptionMedicationNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentPrescriptionMedicationFilterInput> | StudentPrescriptionMedicationFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentPrescriptionMedicationOrder>;
}>;

export type StudentPrescriptionMedicationNamesQuery = {
	__typename?: "Query";
	studentPrescriptionMedicationConnection: {
		__typename?: "StudentPrescriptionMedicationConnection";
		edges: Array<{
			__typename?: "StudentPrescriptionMedicationEdge";
			node: { __typename?: "StudentPrescriptionMedication"; id: string };
		}>;
	};
};

export type StudentPrescriptionMedicationPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentPrescriptionMedicationFilterInput> | StudentPrescriptionMedicationFilterInput>;
	order?: InputMaybe<StudentPrescriptionMedicationOrder>;
}>;

export type StudentPrescriptionMedicationPaginationQuery = {
	__typename?: "Query";
	studentPrescriptionMedicationConnection: {
		__typename?: "StudentPrescriptionMedicationConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentPrescriptionMedicationEdge"; cursor: string }>;
	};
};

export type StudentPrescriptionMedicationSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentPrescriptionMedicationFilterInput> | StudentPrescriptionMedicationFilterInput>;
	order?: InputMaybe<StudentPrescriptionMedicationOrder>;
}>;

export type StudentPrescriptionMedicationSelectQuery = {
	__typename?: "Query";
	studentPrescriptionMedicationConnection: {
		__typename?: "StudentPrescriptionMedicationConnection";
		edges: Array<{
			__typename?: "StudentPrescriptionMedicationEdge";
			node: { __typename?: "StudentPrescriptionMedication"; id: string };
		}>;
	};
};

export type StudentPrescriptionMedicationUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentPrescriptionMedicationUpdateInput;
}>;

export type StudentPrescriptionMedicationUpdateMutation = {
	__typename?: "Mutation";
	updateStudentPrescriptionMedication: {
		__typename?: "StudentPrescriptionMedication";
		id: string;
		administration: string;
		canSelfAdminister: boolean;
		notes: string;
		medication: { __typename?: "Medication"; id: string; name: string };
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type StudentSocialEmotionalNoteCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentSocialEmotionalNoteFilterInput> | StudentSocialEmotionalNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentSocialEmotionalNoteOrder>;
}>;

export type StudentSocialEmotionalNoteCountQuery = {
	__typename?: "Query";
	studentSocialEmotionalNoteConnection: { __typename?: "StudentSocialEmotionalNoteConnection"; totalCount: number };
};

export type StudentSocialEmotionalNoteCreateMutationVariables = Exact<{
	input: StudentSocialEmotionalNoteCreateInput;
}>;

export type StudentSocialEmotionalNoteCreateMutation = {
	__typename?: "Mutation";
	createStudentSocialEmotionalNote: {
		__typename?: "StudentSocialEmotionalNote";
		id: string;
		isIssueNatureLearningDifficulty: boolean;
		isIssueNatureAttentionIssue: boolean;
		isIssueNatureFocusIssue: boolean;
		isIssueNatureEmotionalOrVulnerableIssue: boolean;
		isIssueNatureOther: boolean;
		issueNatureOther: string;
		isSolutionRecDifferentiatedLearning: boolean;
		isSolutionRecIndividualLearningPlan: boolean;
		isSolutionRecTutoring: boolean;
		isSolutionRecProfessionalSupport: boolean;
		isSolutionRecInClassSupport: boolean;
		isSolutionRecOther: boolean;
		solutionRecOther: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentSocialEmotionalNoteDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentSocialEmotionalNoteDeleteMutation = {
	__typename?: "Mutation";
	deleteStudentSocialEmotionalNote: boolean;
};

export type StudentSocialEmotionalNoteDetailFragment = {
	__typename?: "StudentSocialEmotionalNote";
	id: string;
	isIssueNatureLearningDifficulty: boolean;
	isIssueNatureAttentionIssue: boolean;
	isIssueNatureFocusIssue: boolean;
	isIssueNatureEmotionalOrVulnerableIssue: boolean;
	isIssueNatureOther: boolean;
	issueNatureOther: string;
	isSolutionRecDifferentiatedLearning: boolean;
	isSolutionRecIndividualLearningPlan: boolean;
	isSolutionRecTutoring: boolean;
	isSolutionRecProfessionalSupport: boolean;
	isSolutionRecInClassSupport: boolean;
	isSolutionRecOther: boolean;
	solutionRecOther: string;
	studentNote: { __typename?: "StudentNote"; id: string };
};

export type StudentSocialEmotionalNoteDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentSocialEmotionalNoteDetailQuery = {
	__typename?: "Query";
	studentSocialEmotionalNote: {
		__typename?: "StudentSocialEmotionalNote";
		id: string;
		isIssueNatureLearningDifficulty: boolean;
		isIssueNatureAttentionIssue: boolean;
		isIssueNatureFocusIssue: boolean;
		isIssueNatureEmotionalOrVulnerableIssue: boolean;
		isIssueNatureOther: boolean;
		issueNatureOther: string;
		isSolutionRecDifferentiatedLearning: boolean;
		isSolutionRecIndividualLearningPlan: boolean;
		isSolutionRecTutoring: boolean;
		isSolutionRecProfessionalSupport: boolean;
		isSolutionRecInClassSupport: boolean;
		isSolutionRecOther: boolean;
		solutionRecOther: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentSocialEmotionalNoteIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentSocialEmotionalNoteFilterInput> | StudentSocialEmotionalNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentSocialEmotionalNoteOrder>;
}>;

export type StudentSocialEmotionalNoteIndexQuery = {
	__typename?: "Query";
	studentSocialEmotionalNoteConnection: {
		__typename?: "StudentSocialEmotionalNoteConnection";
		edges: Array<{
			__typename?: "StudentSocialEmotionalNoteEdge";
			node: {
				__typename?: "StudentSocialEmotionalNote";
				id: string;
				isIssueNatureLearningDifficulty: boolean;
				isIssueNatureAttentionIssue: boolean;
				isIssueNatureFocusIssue: boolean;
				isIssueNatureEmotionalOrVulnerableIssue: boolean;
				isIssueNatureOther: boolean;
				issueNatureOther: string;
				isSolutionRecDifferentiatedLearning: boolean;
				isSolutionRecIndividualLearningPlan: boolean;
				isSolutionRecTutoring: boolean;
				isSolutionRecProfessionalSupport: boolean;
				isSolutionRecInClassSupport: boolean;
				isSolutionRecOther: boolean;
				solutionRecOther: string;
			};
		}>;
	};
};

export type StudentSocialEmotionalNoteNameFragment = { __typename?: "StudentSocialEmotionalNote"; id: string };

export type StudentSocialEmotionalNoteNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentSocialEmotionalNoteNameQuery = {
	__typename?: "Query";
	studentSocialEmotionalNote: { __typename?: "StudentSocialEmotionalNote"; id: string };
};

export type StudentSocialEmotionalNoteNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentSocialEmotionalNoteFilterInput> | StudentSocialEmotionalNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentSocialEmotionalNoteOrder>;
}>;

export type StudentSocialEmotionalNoteNamesQuery = {
	__typename?: "Query";
	studentSocialEmotionalNoteConnection: {
		__typename?: "StudentSocialEmotionalNoteConnection";
		edges: Array<{
			__typename?: "StudentSocialEmotionalNoteEdge";
			node: { __typename?: "StudentSocialEmotionalNote"; id: string };
		}>;
	};
};

export type StudentSocialEmotionalNotePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentSocialEmotionalNoteFilterInput> | StudentSocialEmotionalNoteFilterInput>;
	order?: InputMaybe<StudentSocialEmotionalNoteOrder>;
}>;

export type StudentSocialEmotionalNotePaginationQuery = {
	__typename?: "Query";
	studentSocialEmotionalNoteConnection: {
		__typename?: "StudentSocialEmotionalNoteConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentSocialEmotionalNoteEdge"; cursor: string }>;
	};
};

export type StudentSocialEmotionalNoteSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentSocialEmotionalNoteFilterInput> | StudentSocialEmotionalNoteFilterInput>;
	order?: InputMaybe<StudentSocialEmotionalNoteOrder>;
}>;

export type StudentSocialEmotionalNoteSelectQuery = {
	__typename?: "Query";
	studentSocialEmotionalNoteConnection: {
		__typename?: "StudentSocialEmotionalNoteConnection";
		edges: Array<{
			__typename?: "StudentSocialEmotionalNoteEdge";
			node: { __typename?: "StudentSocialEmotionalNote"; id: string };
		}>;
	};
};

export type StudentSocialEmotionalNoteUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentSocialEmotionalNoteUpdateInput;
}>;

export type StudentSocialEmotionalNoteUpdateMutation = {
	__typename?: "Mutation";
	updateStudentSocialEmotionalNote: {
		__typename?: "StudentSocialEmotionalNote";
		id: string;
		isIssueNatureLearningDifficulty: boolean;
		isIssueNatureAttentionIssue: boolean;
		isIssueNatureFocusIssue: boolean;
		isIssueNatureEmotionalOrVulnerableIssue: boolean;
		isIssueNatureOther: boolean;
		issueNatureOther: string;
		isSolutionRecDifferentiatedLearning: boolean;
		isSolutionRecIndividualLearningPlan: boolean;
		isSolutionRecTutoring: boolean;
		isSolutionRecProfessionalSupport: boolean;
		isSolutionRecInClassSupport: boolean;
		isSolutionRecOther: boolean;
		solutionRecOther: string;
		studentNote: { __typename?: "StudentNote"; id: string };
	};
};

export type StudentVaccinationRecordCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentVaccinationRecordFilterInput> | StudentVaccinationRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentVaccinationRecordOrder>;
}>;

export type StudentVaccinationRecordCountQuery = {
	__typename?: "Query";
	studentVaccinationRecordConnection: { __typename?: "StudentVaccinationRecordConnection"; totalCount: number };
};

export type StudentVaccinationRecordCreateMutationVariables = Exact<{
	input: StudentVaccinationRecordCreateInput;
}>;

export type StudentVaccinationRecordCreateMutation = {
	__typename?: "Mutation";
	createStudentVaccinationRecord: {
		__typename?: "StudentVaccinationRecord";
		id: string;
		receivedOn: string;
		notes: string;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
		vaccine: { __typename?: "Vaccine"; id: string; name: string };
	};
};

export type StudentVaccinationRecordDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentVaccinationRecordDeleteMutation = {
	__typename?: "Mutation";
	deleteStudentVaccinationRecord: boolean;
};

export type StudentVaccinationRecordDetailFragment = {
	__typename?: "StudentVaccinationRecord";
	id: string;
	receivedOn: string;
	notes: string;
	student: {
		__typename?: "Student";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
	vaccine: { __typename?: "Vaccine"; id: string; name: string };
};

export type StudentVaccinationRecordDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentVaccinationRecordDetailQuery = {
	__typename?: "Query";
	studentVaccinationRecord: {
		__typename?: "StudentVaccinationRecord";
		id: string;
		receivedOn: string;
		notes: string;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
		vaccine: { __typename?: "Vaccine"; id: string; name: string };
	};
};

export type StudentVaccinationRecordIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentVaccinationRecordFilterInput> | StudentVaccinationRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentVaccinationRecordOrder>;
}>;

export type StudentVaccinationRecordIndexQuery = {
	__typename?: "Query";
	studentVaccinationRecordConnection: {
		__typename?: "StudentVaccinationRecordConnection";
		edges: Array<{
			__typename?: "StudentVaccinationRecordEdge";
			node: { __typename?: "StudentVaccinationRecord"; id: string; receivedOn: string; notes: string };
		}>;
	};
};

export type StudentVaccinationRecordStudentListQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentVaccinationRecordFilterInput> | StudentVaccinationRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentVaccinationRecordOrder>;
}>;

export type StudentVaccinationRecordStudentListQuery = {
	__typename?: "Query";
	studentVaccinationRecordConnection: {
		__typename?: "StudentVaccinationRecordConnection";
		edges: Array<{
			__typename?: "StudentVaccinationRecordEdge";
			node: {
				__typename?: "StudentVaccinationRecord";
				id: string;
				receivedOn: string;
				notes: string;
				vaccine: { __typename?: "Vaccine"; id: string; name: string };
			};
		}>;
	};
};

export type StudentVaccinationRecordNameFragment = { __typename?: "StudentVaccinationRecord"; id: string };

export type StudentVaccinationRecordNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type StudentVaccinationRecordNameQuery = {
	__typename?: "Query";
	studentVaccinationRecord: { __typename?: "StudentVaccinationRecord"; id: string };
};

export type StudentVaccinationRecordNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentVaccinationRecordFilterInput> | StudentVaccinationRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentVaccinationRecordOrder>;
}>;

export type StudentVaccinationRecordNamesQuery = {
	__typename?: "Query";
	studentVaccinationRecordConnection: {
		__typename?: "StudentVaccinationRecordConnection";
		edges: Array<{
			__typename?: "StudentVaccinationRecordEdge";
			node: { __typename?: "StudentVaccinationRecord"; id: string };
		}>;
	};
};

export type StudentVaccinationRecordPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentVaccinationRecordFilterInput> | StudentVaccinationRecordFilterInput>;
	order?: InputMaybe<StudentVaccinationRecordOrder>;
}>;

export type StudentVaccinationRecordPaginationQuery = {
	__typename?: "Query";
	studentVaccinationRecordConnection: {
		__typename?: "StudentVaccinationRecordConnection";
		totalCount: number;
		edges: Array<{ __typename?: "StudentVaccinationRecordEdge"; cursor: string }>;
	};
};

export type StudentVaccinationRecordSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentVaccinationRecordFilterInput> | StudentVaccinationRecordFilterInput>;
	order?: InputMaybe<StudentVaccinationRecordOrder>;
}>;

export type StudentVaccinationRecordSelectQuery = {
	__typename?: "Query";
	studentVaccinationRecordConnection: {
		__typename?: "StudentVaccinationRecordConnection";
		edges: Array<{
			__typename?: "StudentVaccinationRecordEdge";
			node: { __typename?: "StudentVaccinationRecord"; id: string };
		}>;
	};
};

export type StudentVaccinationRecordUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: StudentVaccinationRecordUpdateInput;
}>;

export type StudentVaccinationRecordUpdateMutation = {
	__typename?: "Mutation";
	updateStudentVaccinationRecord: {
		__typename?: "StudentVaccinationRecord";
		id: string;
		receivedOn: string;
		notes: string;
		student: {
			__typename?: "Student";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
		vaccine: { __typename?: "Vaccine"; id: string; name: string };
	};
};

export type TeacherCourseSectionEnrollmentCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<TeacherCourseSectionEnrollmentFilterInput> | TeacherCourseSectionEnrollmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<TeacherCourseSectionEnrollmentOrder>;
}>;

export type TeacherCourseSectionEnrollmentCountQuery = {
	__typename?: "Query";
	teacherCourseSectionEnrollmentConnection: {
		__typename?: "TeacherCourseSectionEnrollmentConnection";
		totalCount: number;
	};
};

export type TeacherCourseSectionEnrollmentCreateMutationVariables = Exact<{
	input: TeacherCourseSectionEnrollmentCreateInput;
}>;

export type TeacherCourseSectionEnrollmentCreateMutation = {
	__typename?: "Mutation";
	createTeacherCourseSectionEnrollment: {
		__typename?: "TeacherCourseSectionEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		};
		teacher: {
			__typename?: "Employee";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type TeacherCourseSectionEnrollmentDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type TeacherCourseSectionEnrollmentDeleteMutation = {
	__typename?: "Mutation";
	deleteTeacherCourseSectionEnrollment: boolean;
};

export type TeacherCourseSectionEnrollmentDetailFragment = {
	__typename?: "TeacherCourseSectionEnrollment";
	id: string;
	lateStartDate: string | null;
	earlyEndDate: string | null;
	courseSection: {
		__typename?: "CourseSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		course: { __typename?: "Course"; id: string; name: string };
	};
	teacher: {
		__typename?: "Employee";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type TeacherCourseSectionEnrollmentDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type TeacherCourseSectionEnrollmentDetailQuery = {
	__typename?: "Query";
	teacherCourseSectionEnrollment: {
		__typename?: "TeacherCourseSectionEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		};
		teacher: {
			__typename?: "Employee";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type TeacherCourseSectionEnrollmentIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<TeacherCourseSectionEnrollmentFilterInput> | TeacherCourseSectionEnrollmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<TeacherCourseSectionEnrollmentOrder>;
}>;

export type TeacherCourseSectionEnrollmentIndexQuery = {
	__typename?: "Query";
	teacherCourseSectionEnrollmentConnection: {
		__typename?: "TeacherCourseSectionEnrollmentConnection";
		edges: Array<{
			__typename?: "TeacherCourseSectionEnrollmentEdge";
			node: {
				__typename?: "TeacherCourseSectionEnrollment";
				id: string;
				lateStartDate: string | null;
				earlyEndDate: string | null;
			};
		}>;
	};
};

export type TeacherCourseSectionEnrollmentNameFragment = { __typename?: "TeacherCourseSectionEnrollment"; id: string };

export type TeacherCourseSectionEnrollmentNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type TeacherCourseSectionEnrollmentNameQuery = {
	__typename?: "Query";
	teacherCourseSectionEnrollment: { __typename?: "TeacherCourseSectionEnrollment"; id: string };
};

export type TeacherCourseSectionEnrollmentNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<TeacherCourseSectionEnrollmentFilterInput> | TeacherCourseSectionEnrollmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<TeacherCourseSectionEnrollmentOrder>;
}>;

export type TeacherCourseSectionEnrollmentNamesQuery = {
	__typename?: "Query";
	teacherCourseSectionEnrollmentConnection: {
		__typename?: "TeacherCourseSectionEnrollmentConnection";
		edges: Array<{
			__typename?: "TeacherCourseSectionEnrollmentEdge";
			node: { __typename?: "TeacherCourseSectionEnrollment"; id: string };
		}>;
	};
};

export type TeacherCourseSectionEnrollmentPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<TeacherCourseSectionEnrollmentFilterInput> | TeacherCourseSectionEnrollmentFilterInput>;
	order?: InputMaybe<TeacherCourseSectionEnrollmentOrder>;
}>;

export type TeacherCourseSectionEnrollmentPaginationQuery = {
	__typename?: "Query";
	teacherCourseSectionEnrollmentConnection: {
		__typename?: "TeacherCourseSectionEnrollmentConnection";
		totalCount: number;
		edges: Array<{ __typename?: "TeacherCourseSectionEnrollmentEdge"; cursor: string }>;
	};
};

export type TeacherCourseSectionEnrollmentSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<TeacherCourseSectionEnrollmentFilterInput> | TeacherCourseSectionEnrollmentFilterInput>;
	order?: InputMaybe<TeacherCourseSectionEnrollmentOrder>;
}>;

export type TeacherCourseSectionEnrollmentSelectQuery = {
	__typename?: "Query";
	teacherCourseSectionEnrollmentConnection: {
		__typename?: "TeacherCourseSectionEnrollmentConnection";
		edges: Array<{
			__typename?: "TeacherCourseSectionEnrollmentEdge";
			node: { __typename?: "TeacherCourseSectionEnrollment"; id: string };
		}>;
	};
};

export type TeacherCourseSectionEnrollmentUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: TeacherCourseSectionEnrollmentUpdateInput;
}>;

export type TeacherCourseSectionEnrollmentUpdateMutation = {
	__typename?: "Mutation";
	updateTeacherCourseSectionEnrollment: {
		__typename?: "TeacherCourseSectionEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		};
		teacher: {
			__typename?: "Employee";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type TeacherHomeRoomSectionEnrollmentCountQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<TeacherHomeRoomSectionEnrollmentFilterInput> | TeacherHomeRoomSectionEnrollmentFilterInput
	>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<TeacherHomeRoomSectionEnrollmentOrder>;
}>;

export type TeacherHomeRoomSectionEnrollmentCountQuery = {
	__typename?: "Query";
	teacherHomeRoomSectionEnrollmentConnection: {
		__typename?: "TeacherHomeRoomSectionEnrollmentConnection";
		totalCount: number;
	};
};

export type TeacherHomeRoomSectionEnrollmentCreateMutationVariables = Exact<{
	input: TeacherHomeRoomSectionEnrollmentCreateInput;
}>;

export type TeacherHomeRoomSectionEnrollmentCreateMutation = {
	__typename?: "Mutation";
	createTeacherHomeRoomSectionEnrollment: {
		__typename?: "TeacherHomeRoomSectionEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		homeRoomSection: {
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		};
		teacher: {
			__typename?: "Employee";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type TeacherHomeRoomSectionEnrollmentDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type TeacherHomeRoomSectionEnrollmentDeleteMutation = {
	__typename?: "Mutation";
	deleteTeacherHomeRoomSectionEnrollment: boolean;
};

export type TeacherHomeRoomSectionEnrollmentDetailFragment = {
	__typename?: "TeacherHomeRoomSectionEnrollment";
	id: string;
	lateStartDate: string | null;
	earlyEndDate: string | null;
	homeRoomSection: {
		__typename?: "HomeRoomSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
	};
	teacher: {
		__typename?: "Employee";
		id: string;
		person: { __typename?: "Person"; id: string; name: string; publicName: string };
	};
};

export type TeacherHomeRoomSectionEnrollmentDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type TeacherHomeRoomSectionEnrollmentDetailQuery = {
	__typename?: "Query";
	teacherHomeRoomSectionEnrollment: {
		__typename?: "TeacherHomeRoomSectionEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		homeRoomSection: {
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		};
		teacher: {
			__typename?: "Employee";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type TeacherHomeRoomSectionEnrollmentIndexQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<TeacherHomeRoomSectionEnrollmentFilterInput> | TeacherHomeRoomSectionEnrollmentFilterInput
	>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<TeacherHomeRoomSectionEnrollmentOrder>;
}>;

export type TeacherHomeRoomSectionEnrollmentIndexQuery = {
	__typename?: "Query";
	teacherHomeRoomSectionEnrollmentConnection: {
		__typename?: "TeacherHomeRoomSectionEnrollmentConnection";
		edges: Array<{
			__typename?: "TeacherHomeRoomSectionEnrollmentEdge";
			node: {
				__typename?: "TeacherHomeRoomSectionEnrollment";
				id: string;
				lateStartDate: string | null;
				earlyEndDate: string | null;
			};
		}>;
	};
};

export type TeacherHomeRoomSectionEnrollmentNameFragment = {
	__typename?: "TeacherHomeRoomSectionEnrollment";
	id: string;
};

export type TeacherHomeRoomSectionEnrollmentNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type TeacherHomeRoomSectionEnrollmentNameQuery = {
	__typename?: "Query";
	teacherHomeRoomSectionEnrollment: { __typename?: "TeacherHomeRoomSectionEnrollment"; id: string };
};

export type TeacherHomeRoomSectionEnrollmentNamesQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<TeacherHomeRoomSectionEnrollmentFilterInput> | TeacherHomeRoomSectionEnrollmentFilterInput
	>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<TeacherHomeRoomSectionEnrollmentOrder>;
}>;

export type TeacherHomeRoomSectionEnrollmentNamesQuery = {
	__typename?: "Query";
	teacherHomeRoomSectionEnrollmentConnection: {
		__typename?: "TeacherHomeRoomSectionEnrollmentConnection";
		edges: Array<{
			__typename?: "TeacherHomeRoomSectionEnrollmentEdge";
			node: { __typename?: "TeacherHomeRoomSectionEnrollment"; id: string };
		}>;
	};
};

export type TeacherHomeRoomSectionEnrollmentPaginationQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<TeacherHomeRoomSectionEnrollmentFilterInput> | TeacherHomeRoomSectionEnrollmentFilterInput
	>;
	order?: InputMaybe<TeacherHomeRoomSectionEnrollmentOrder>;
}>;

export type TeacherHomeRoomSectionEnrollmentPaginationQuery = {
	__typename?: "Query";
	teacherHomeRoomSectionEnrollmentConnection: {
		__typename?: "TeacherHomeRoomSectionEnrollmentConnection";
		totalCount: number;
		edges: Array<{ __typename?: "TeacherHomeRoomSectionEnrollmentEdge"; cursor: string }>;
	};
};

export type TeacherHomeRoomSectionEnrollmentSelectQueryVariables = Exact<{
	filters?: InputMaybe<
		Array<TeacherHomeRoomSectionEnrollmentFilterInput> | TeacherHomeRoomSectionEnrollmentFilterInput
	>;
	order?: InputMaybe<TeacherHomeRoomSectionEnrollmentOrder>;
}>;

export type TeacherHomeRoomSectionEnrollmentSelectQuery = {
	__typename?: "Query";
	teacherHomeRoomSectionEnrollmentConnection: {
		__typename?: "TeacherHomeRoomSectionEnrollmentConnection";
		edges: Array<{
			__typename?: "TeacherHomeRoomSectionEnrollmentEdge";
			node: { __typename?: "TeacherHomeRoomSectionEnrollment"; id: string };
		}>;
	};
};

export type TeacherHomeRoomSectionEnrollmentUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: TeacherHomeRoomSectionEnrollmentUpdateInput;
}>;

export type TeacherHomeRoomSectionEnrollmentUpdateMutation = {
	__typename?: "Mutation";
	updateTeacherHomeRoomSectionEnrollment: {
		__typename?: "TeacherHomeRoomSectionEnrollment";
		id: string;
		lateStartDate: string | null;
		earlyEndDate: string | null;
		homeRoomSection: {
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		};
		teacher: {
			__typename?: "Employee";
			id: string;
			person: { __typename?: "Person"; id: string; name: string; publicName: string };
		};
	};
};

export type TrustedDeviceCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<TrustedDeviceFilterInput> | TrustedDeviceFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<TrustedDeviceOrder>;
}>;

export type TrustedDeviceCountQuery = {
	__typename?: "Query";
	trustedDeviceConnection: { __typename?: "TrustedDeviceConnection"; totalCount: number };
};

export type TrustedDeviceDetailFragment = {
	__typename?: "TrustedDevice";
	id: string;
	createdAt: string;
	name: string;
	isCurrent: boolean;
	sessions: Array<{ __typename?: "Session"; id: string }>;
	user: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	};
};

export type TrustedDeviceDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type TrustedDeviceDetailQuery = {
	__typename?: "Query";
	trustedDevice: {
		__typename?: "TrustedDevice";
		id: string;
		createdAt: string;
		name: string;
		isCurrent: boolean;
		sessions: Array<{ __typename?: "Session"; id: string }>;
		user: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
	};
};

export type TrustedDeviceIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<TrustedDeviceFilterInput> | TrustedDeviceFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<TrustedDeviceOrder>;
}>;

export type TrustedDeviceIndexQuery = {
	__typename?: "Query";
	trustedDeviceConnection: {
		__typename?: "TrustedDeviceConnection";
		edges: Array<{
			__typename?: "TrustedDeviceEdge";
			node: { __typename?: "TrustedDevice"; id: string; createdAt: string; name: string; isCurrent: boolean };
		}>;
	};
};

export type TrustedDeviceNameFragment = { __typename?: "TrustedDevice"; name: string };

export type TrustedDeviceNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type TrustedDeviceNameQuery = {
	__typename?: "Query";
	trustedDevice: { __typename?: "TrustedDevice"; id: string; name: string };
};

export type TrustedDeviceNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<TrustedDeviceFilterInput> | TrustedDeviceFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<TrustedDeviceOrder>;
}>;

export type TrustedDeviceNamesQuery = {
	__typename?: "Query";
	trustedDeviceConnection: {
		__typename?: "TrustedDeviceConnection";
		edges: Array<{
			__typename?: "TrustedDeviceEdge";
			node: { __typename?: "TrustedDevice"; id: string; name: string };
		}>;
	};
};

export type TrustedDevicePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<TrustedDeviceFilterInput> | TrustedDeviceFilterInput>;
	order?: InputMaybe<TrustedDeviceOrder>;
}>;

export type TrustedDevicePaginationQuery = {
	__typename?: "Query";
	trustedDeviceConnection: {
		__typename?: "TrustedDeviceConnection";
		totalCount: number;
		edges: Array<{ __typename?: "TrustedDeviceEdge"; cursor: string }>;
	};
};

export type TrustedDeviceSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<TrustedDeviceFilterInput> | TrustedDeviceFilterInput>;
	order?: InputMaybe<TrustedDeviceOrder>;
}>;

export type TrustedDeviceSelectQuery = {
	__typename?: "Query";
	trustedDeviceConnection: {
		__typename?: "TrustedDeviceConnection";
		edges: Array<{
			__typename?: "TrustedDeviceEdge";
			node: { __typename?: "TrustedDevice"; id: string; name: string };
		}>;
	};
};

export type UserCheckUniqueEmailQueryVariables = Exact<{
	ignoreID?: InputMaybe<Scalars["ID"]["input"]>;
	email: Scalars["String"]["input"];
}>;

export type UserCheckUniqueEmailQuery = {
	__typename?: "Query";
	userConnection: { __typename?: "UserConnection"; totalCount: number };
};

export type UserCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type UserCountQuery = {
	__typename?: "Query";
	userConnection: { __typename?: "UserConnection"; totalCount: number };
};

export type UserCreateMutationVariables = Exact<{
	input: UserCreateInput;
}>;

export type UserCreateMutation = {
	__typename?: "Mutation";
	createUser: {
		__typename?: "User";
		id: string;
		email: string;
		status: UserStatus;
		passwordUpdatedAt: string;
		isCurrent: boolean;
		timeZoneName: string;
		externalNotificationFrequency: UserExternalNotificationFrequency;
		permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			employee: { __typename?: "Employee"; id: string } | null;
			guardian: { __typename?: "Guardian"; id: string } | null;
			student: { __typename?: "Student"; id: string } | null;
		} | null;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
	};
};

export type UserDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type UserDeleteMutation = { __typename?: "Mutation"; deleteUser: boolean };

export type UserDetailFragment = {
	__typename?: "User";
	id: string;
	email: string;
	status: UserStatus;
	passwordUpdatedAt: string;
	isCurrent: boolean;
	timeZoneName: string;
	externalNotificationFrequency: UserExternalNotificationFrequency;
	permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
	person: {
		__typename?: "Person";
		id: string;
		name: string;
		publicName: string;
		employee: { __typename?: "Employee"; id: string } | null;
		guardian: { __typename?: "Guardian"; id: string } | null;
		student: { __typename?: "Student"; id: string } | null;
	} | null;
	userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
};

export type UserDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type UserDetailQuery = {
	__typename?: "Query";
	user: {
		__typename?: "User";
		id: string;
		email: string;
		status: UserStatus;
		passwordUpdatedAt: string;
		isCurrent: boolean;
		timeZoneName: string;
		externalNotificationFrequency: UserExternalNotificationFrequency;
		permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			employee: { __typename?: "Employee"; id: string } | null;
			guardian: { __typename?: "Guardian"; id: string } | null;
			student: { __typename?: "Student"; id: string } | null;
		} | null;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
	};
};

export type UserIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type UserIndexQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				email: string;
				status: UserStatus;
				passwordUpdatedAt: string;
				isCurrent: boolean;
				timeZoneName: string;
				externalNotificationFrequency: UserExternalNotificationFrequency;
			};
		}>;
	};
};

export type SendUserInviteMessageMutationVariables = Exact<{
	userID: Scalars["ID"]["input"];
}>;

export type SendUserInviteMessageMutation = { __typename?: "Mutation"; inviteUser: boolean };

export type SendParentPortalInviteMessageMutationVariables = Exact<{
	userID: Scalars["ID"]["input"];
}>;

export type SendParentPortalInviteMessageMutation = { __typename?: "Mutation"; sendParentPortalInviteMessage: boolean };

export type UserDetailedSelectListQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type UserDetailedSelectListQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					employee: { __typename?: "Employee"; id: string; jobTitle: string } | null;
					guardian: { __typename?: "Guardian"; id: string } | null;
					student: { __typename?: "Student"; id: string } | null;
				} | null;
			};
		}>;
	};
};

export type UserNameDescriptionAndImageFragment = {
	__typename?: "User";
	email: string;
	person: {
		__typename?: "Person";
		id: string;
		name: string;
		publicName: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		employee: { __typename?: "Employee"; id: string; jobTitle: string; role: EmployeeRole } | null;
		guardian: { __typename?: "Guardian"; id: string } | null;
		student: { __typename?: "Student"; id: string; graduationYear: number | null; yearsFromGraduation: number } | null;
	} | null;
};

export type UserNamesDescriptionsAndImagesQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type UserNamesDescriptionsAndImagesQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor: string | null };
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				email: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
					employee: { __typename?: "Employee"; id: string; jobTitle: string; role: EmployeeRole } | null;
					guardian: { __typename?: "Guardian"; id: string } | null;
					student: {
						__typename?: "Student";
						id: string;
						graduationYear: number | null;
						yearsFromGraduation: number;
					} | null;
				} | null;
			};
		}>;
	};
};

export type UserNameFragment = {
	__typename?: "User";
	email: string;
	isCurrent: boolean;
	person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
};

export type UserNameAndImageFragment = {
	__typename?: "User";
	email: string;
	isCurrent: boolean;
	person: {
		__typename?: "Person";
		id: string;
		name: string;
		publicName: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
	} | null;
};

export type UserNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type UserNameQuery = {
	__typename?: "Query";
	user: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	};
};

export type UserNamesAndImagesQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type UserNamesAndImagesQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
			};
		}>;
	};
};

export type UserNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type UserNamesQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			};
		}>;
	};
};

export type UserPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	order?: InputMaybe<UserOrder>;
}>;

export type UserPaginationQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		totalCount: number;
		edges: Array<{ __typename?: "UserEdge"; cursor: string }>;
	};
};

export type UserSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	order?: InputMaybe<UserOrder>;
}>;

export type UserSelectQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				email: string;
				isCurrent: boolean;
				person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
			};
		}>;
	};
};

export type UserUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: UserUpdateInput;
}>;

export type UserUpdateMutation = {
	__typename?: "Mutation";
	updateUser: {
		__typename?: "User";
		id: string;
		email: string;
		status: UserStatus;
		passwordUpdatedAt: string;
		isCurrent: boolean;
		timeZoneName: string;
		externalNotificationFrequency: UserExternalNotificationFrequency;
		permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			employee: { __typename?: "Employee"; id: string } | null;
			guardian: { __typename?: "Guardian"; id: string } | null;
			student: { __typename?: "Student"; id: string } | null;
		} | null;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
	};
};

export type ParentPortalViewerInfoQueryVariables = Exact<{ [key: string]: never }>;

export type ParentPortalViewerInfoQuery = {
	__typename?: "Query";
	viewer: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		externalNotificationFrequency: UserExternalNotificationFrequency;
		person: {
			__typename?: "Person";
			id: string;
			givenName: string;
			familyName: string;
			nameOrder: PersonNameOrder;
			publicNameFormat: PersonPublicNameFormat;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
			guardian: {
				__typename?: "Guardian";
				id: string;
				relationships: Array<{
					__typename?: "Relationship";
					id: string;
					relationshipType: string;
					isPrimary: boolean;
					student: {
						__typename?: "Student";
						id: string;
						person: {
							__typename?: "Person";
							id: string;
							givenName: string;
							name: string;
							publicName: string;
							imageURL: string;
							imageKey: string;
							imageContentType: string;
						};
					};
				}>;
			} | null;
		} | null;
	};
};

export type InternalPortalsViewerInfoQueryVariables = Exact<{ [key: string]: never }>;

export type InternalPortalsViewerInfoQuery = {
	__typename?: "Query";
	viewer: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
			employee: { __typename?: "Employee"; id: string; role: EmployeeRole; jobTitle: string } | null;
			guardian: { __typename?: "Guardian"; id: string } | null;
		} | null;
	};
};

export type ViewerPublicNameFormatQueryVariables = Exact<{ [key: string]: never }>;

export type ViewerPublicNameFormatQuery = {
	__typename?: "Query";
	viewer: {
		__typename?: "User";
		id: string;
		person: { __typename?: "Person"; id: string; publicNameFormat: PersonPublicNameFormat } | null;
	};
};

export type UserGroupCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserGroupFilterInput> | UserGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserGroupOrder>;
}>;

export type UserGroupCountQuery = {
	__typename?: "Query";
	userGroupConnection: { __typename?: "UserGroupConnection"; totalCount: number };
};

export type UserGroupCreateMutationVariables = Exact<{
	input: UserGroupCreateInput;
}>;

export type UserGroupCreateMutation = {
	__typename?: "Mutation";
	createUserGroup: {
		__typename?: "UserGroup";
		id: string;
		name: string;
		description: string;
		color: string;
		isPublic: boolean;
		includeEmployees: boolean;
		includeGuardians: boolean;
		includeAllUsersOfPersonTypes: boolean;
		classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
		courseSections: Array<{
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		}>;
		homeRoomSections: Array<{
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		}>;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		}>;
	};
};

export type UserGroupDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type UserGroupDeleteMutation = { __typename?: "Mutation"; deleteUserGroup: boolean };

export type UserGroupDetailFragment = {
	__typename?: "UserGroup";
	id: string;
	name: string;
	description: string;
	color: string;
	isPublic: boolean;
	includeEmployees: boolean;
	includeGuardians: boolean;
	includeAllUsersOfPersonTypes: boolean;
	classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
	classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
	courseSections: Array<{
		__typename?: "CourseSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		course: { __typename?: "Course"; id: string; name: string };
	}>;
	homeRoomSections: Array<{
		__typename?: "HomeRoomSection";
		id: string;
		namePrefix: string;
		nameSuffix: string;
		homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
	}>;
	users: Array<{
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	}>;
};

export type UserGroupDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type UserGroupDetailQuery = {
	__typename?: "Query";
	userGroup: {
		__typename?: "UserGroup";
		id: string;
		name: string;
		description: string;
		color: string;
		isPublic: boolean;
		includeEmployees: boolean;
		includeGuardians: boolean;
		includeAllUsersOfPersonTypes: boolean;
		classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
		courseSections: Array<{
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		}>;
		homeRoomSections: Array<{
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		}>;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		}>;
	};
};

export type UserGroupIDsQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserGroupFilterInput> | UserGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserGroupOrder>;
}>;

export type UserGroupIDsQuery = {
	__typename?: "Query";
	userGroupConnection: {
		__typename?: "UserGroupConnection";
		edges: Array<{ __typename?: "UserGroupEdge"; node: { __typename?: "UserGroup"; id: string } }>;
	};
};

export type UserGroupIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserGroupFilterInput> | UserGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserGroupOrder>;
}>;

export type UserGroupIndexQuery = {
	__typename?: "Query";
	userGroupConnection: {
		__typename?: "UserGroupConnection";
		edges: Array<{
			__typename?: "UserGroupEdge";
			node: {
				__typename?: "UserGroup";
				id: string;
				name: string;
				description: string;
				color: string;
				isPublic: boolean;
				members: Array<{ __typename?: "User"; id: string }>;
			};
		}>;
	};
};

export type UserGroupDetailedSelectListQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserGroupFilterInput> | UserGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserGroupOrder>;
}>;

export type UserGroupDetailedSelectListQuery = {
	__typename?: "Query";
	userGroupConnection: {
		__typename?: "UserGroupConnection";
		edges: Array<{
			__typename?: "UserGroupEdge";
			node: {
				__typename?: "UserGroup";
				id: string;
				description: string;
				name: string;
				currentUserMembers: Array<{ __typename?: "User"; id: string }>;
			};
		}>;
	};
};

export type UserGroupNameFragment = { __typename?: "UserGroup"; name: string };

export type UserGroupNameAndColorFragment = { __typename?: "UserGroup"; name: string; color: string };

export type UserGroupNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type UserGroupNameQuery = {
	__typename?: "Query";
	userGroup: { __typename?: "UserGroup"; id: string; name: string };
};

export type UserGroupNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserGroupFilterInput> | UserGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserGroupOrder>;
}>;

export type UserGroupNamesQuery = {
	__typename?: "Query";
	userGroupConnection: {
		__typename?: "UserGroupConnection";
		edges: Array<{ __typename?: "UserGroupEdge"; node: { __typename?: "UserGroup"; id: string; name: string } }>;
	};
};

export type UserGroupNamesAndColorsQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserGroupFilterInput> | UserGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserGroupOrder>;
}>;

export type UserGroupNamesAndColorsQuery = {
	__typename?: "Query";
	userGroupConnection: {
		__typename?: "UserGroupConnection";
		edges: Array<{
			__typename?: "UserGroupEdge";
			node: { __typename?: "UserGroup"; id: string; name: string; color: string };
		}>;
	};
};

export type UserGroupPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserGroupFilterInput> | UserGroupFilterInput>;
	order?: InputMaybe<UserGroupOrder>;
}>;

export type UserGroupPaginationQuery = {
	__typename?: "Query";
	userGroupConnection: {
		__typename?: "UserGroupConnection";
		totalCount: number;
		edges: Array<{ __typename?: "UserGroupEdge"; cursor: string }>;
	};
};

export type UserGroupSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserGroupFilterInput> | UserGroupFilterInput>;
	order?: InputMaybe<UserGroupOrder>;
}>;

export type UserGroupSelectQuery = {
	__typename?: "Query";
	userGroupConnection: {
		__typename?: "UserGroupConnection";
		edges: Array<{ __typename?: "UserGroupEdge"; node: { __typename?: "UserGroup"; id: string; name: string } }>;
	};
};

export type UserGroupUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: UserGroupUpdateInput;
}>;

export type UserGroupUpdateMutation = {
	__typename?: "Mutation";
	updateUserGroup: {
		__typename?: "UserGroup";
		id: string;
		name: string;
		description: string;
		color: string;
		isPublic: boolean;
		includeEmployees: boolean;
		includeGuardians: boolean;
		includeAllUsersOfPersonTypes: boolean;
		classYearCategories: Array<{ __typename?: "ClassYearCategory"; id: string; name: string }>;
		classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
		courseSections: Array<{
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		}>;
		homeRoomSections: Array<{
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		}>;
		users: Array<{
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		}>;
	};
};

export type UserViewRecordCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserViewRecordFilterInput> | UserViewRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserViewRecordOrder>;
}>;

export type UserViewRecordCountQuery = {
	__typename?: "Query";
	userViewRecordConnection: { __typename?: "UserViewRecordConnection"; totalCount: number };
};

export type UserViewRecordCreateMutationVariables = Exact<{
	input: UserViewRecordCreateInput;
}>;

export type UserViewRecordCreateMutation = {
	__typename?: "Mutation";
	createUserViewRecord: {
		__typename?: "UserViewRecord";
		id: string;
		targetID: string;
		firstViewedAt: string;
		lastViewedAt: string;
		user: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
	};
};

export type UserViewRecordDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type UserViewRecordDeleteMutation = { __typename?: "Mutation"; deleteUserViewRecord: boolean };

export type UserViewRecordDetailFragment = {
	__typename?: "UserViewRecord";
	id: string;
	targetID: string;
	firstViewedAt: string;
	lastViewedAt: string;
	user: {
		__typename?: "User";
		id: string;
		email: string;
		isCurrent: boolean;
		person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
	};
};

export type UserViewRecordDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type UserViewRecordDetailQuery = {
	__typename?: "Query";
	userViewRecord: {
		__typename?: "UserViewRecord";
		id: string;
		targetID: string;
		firstViewedAt: string;
		lastViewedAt: string;
		user: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
	};
};

export type UserViewRecordIDsQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserViewRecordFilterInput> | UserViewRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserViewRecordOrder>;
}>;

export type UserViewRecordIDsQuery = {
	__typename?: "Query";
	userViewRecordConnection: {
		__typename?: "UserViewRecordConnection";
		edges: Array<{
			__typename?: "UserViewRecordEdge";
			node: { __typename?: "UserViewRecord"; id: string; targetID: string };
		}>;
	};
};

export type UserViewRecordIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserViewRecordFilterInput> | UserViewRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserViewRecordOrder>;
}>;

export type UserViewRecordIndexQuery = {
	__typename?: "Query";
	userViewRecordConnection: {
		__typename?: "UserViewRecordConnection";
		edges: Array<{
			__typename?: "UserViewRecordEdge";
			node: {
				__typename?: "UserViewRecord";
				id: string;
				targetID: string;
				firstViewedAt: string;
				lastViewedAt: string;
			};
		}>;
	};
};

export type UserViewRecordNameFragment = { __typename?: "UserViewRecord"; id: string };

export type UserViewRecordNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type UserViewRecordNameQuery = {
	__typename?: "Query";
	userViewRecord: { __typename?: "UserViewRecord"; id: string };
};

export type UserViewRecordNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserViewRecordFilterInput> | UserViewRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserViewRecordOrder>;
}>;

export type UserViewRecordNamesQuery = {
	__typename?: "Query";
	userViewRecordConnection: {
		__typename?: "UserViewRecordConnection";
		edges: Array<{ __typename?: "UserViewRecordEdge"; node: { __typename?: "UserViewRecord"; id: string } }>;
	};
};

export type UserViewRecordPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserViewRecordFilterInput> | UserViewRecordFilterInput>;
	order?: InputMaybe<UserViewRecordOrder>;
}>;

export type UserViewRecordPaginationQuery = {
	__typename?: "Query";
	userViewRecordConnection: {
		__typename?: "UserViewRecordConnection";
		totalCount: number;
		edges: Array<{ __typename?: "UserViewRecordEdge"; cursor: string }>;
	};
};

export type RecordViewMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type RecordViewMutation = {
	__typename?: "Mutation";
	recordView: {
		__typename?: "UserViewRecord";
		id: string;
		targetID: string;
		userID: string;
		firstViewedAt: string;
		lastViewedAt: string;
	};
};

export type RecordViewsMutationVariables = Exact<{
	ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type RecordViewsMutation = {
	__typename?: "Mutation";
	recordViews: {
		__typename?: "UserViewRecordConnection";
		edges: Array<{
			__typename?: "UserViewRecordEdge";
			node: {
				__typename?: "UserViewRecord";
				id: string;
				targetID: string;
				userID: string;
				firstViewedAt: string;
				lastViewedAt: string;
			};
		}>;
	};
};

export type UserViewRecordSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserViewRecordFilterInput> | UserViewRecordFilterInput>;
	order?: InputMaybe<UserViewRecordOrder>;
}>;

export type UserViewRecordSelectQuery = {
	__typename?: "Query";
	userViewRecordConnection: {
		__typename?: "UserViewRecordConnection";
		edges: Array<{ __typename?: "UserViewRecordEdge"; node: { __typename?: "UserViewRecord"; id: string } }>;
	};
};

export type UserViewRecordListForTargetQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserViewRecordFilterInput> | UserViewRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserViewRecordOrder>;
}>;

export type UserViewRecordListForTargetQuery = {
	__typename?: "Query";
	userViewRecordConnection: {
		__typename?: "UserViewRecordConnection";
		edges: Array<{
			__typename?: "UserViewRecordEdge";
			node: { __typename?: "UserViewRecord"; id: string; targetID: string; lastViewedAt: string };
		}>;
	};
};

export type UserViewRecordListForTargetWithUserQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserViewRecordFilterInput> | UserViewRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserViewRecordOrder>;
}>;

export type UserViewRecordListForTargetWithUserQuery = {
	__typename?: "Query";
	userViewRecordConnection: {
		__typename?: "UserViewRecordConnection";
		edges: Array<{
			__typename?: "UserViewRecordEdge";
			node: {
				__typename?: "UserViewRecord";
				id: string;
				targetID: string;
				lastViewedAt: string;
				user: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
				};
			};
		}>;
	};
};

export type UserViewRecordUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: UserViewRecordUpdateInput;
}>;

export type UserViewRecordUpdateMutation = {
	__typename?: "Mutation";
	updateUserViewRecord: {
		__typename?: "UserViewRecord";
		id: string;
		targetID: string;
		firstViewedAt: string;
		lastViewedAt: string;
		user: {
			__typename?: "User";
			id: string;
			email: string;
			isCurrent: boolean;
			person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
		};
	};
};

export type VaccineCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<VaccineFilterInput> | VaccineFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<VaccineOrder>;
}>;

export type VaccineCountQuery = {
	__typename?: "Query";
	vaccineConnection: { __typename?: "VaccineConnection"; totalCount: number };
};

export type VaccineCreateMutationVariables = Exact<{
	input: VaccineCreateInput;
}>;

export type VaccineCreateMutation = {
	__typename?: "Mutation";
	createVaccine: { __typename?: "Vaccine"; id: string; name: string; description: string };
};

export type VaccineDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type VaccineDeleteMutation = { __typename?: "Mutation"; deleteVaccine: boolean };

export type VaccineDetailFragment = { __typename?: "Vaccine"; id: string; name: string; description: string };

export type VaccineDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type VaccineDetailQuery = {
	__typename?: "Query";
	vaccine: { __typename?: "Vaccine"; id: string; name: string; description: string };
};

export type VaccineIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<VaccineFilterInput> | VaccineFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<VaccineOrder>;
}>;

export type VaccineIndexQuery = {
	__typename?: "Query";
	vaccineConnection: {
		__typename?: "VaccineConnection";
		edges: Array<{
			__typename?: "VaccineEdge";
			node: { __typename?: "Vaccine"; id: string; name: string; description: string };
		}>;
	};
};

export type VaccineNameFragment = { __typename?: "Vaccine"; name: string };

export type VaccineNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type VaccineNameQuery = { __typename?: "Query"; vaccine: { __typename?: "Vaccine"; id: string; name: string } };

export type VaccineNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<VaccineFilterInput> | VaccineFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<VaccineOrder>;
}>;

export type VaccineNamesQuery = {
	__typename?: "Query";
	vaccineConnection: {
		__typename?: "VaccineConnection";
		edges: Array<{ __typename?: "VaccineEdge"; node: { __typename?: "Vaccine"; id: string; name: string } }>;
	};
};

export type VaccinePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<VaccineFilterInput> | VaccineFilterInput>;
	order?: InputMaybe<VaccineOrder>;
}>;

export type VaccinePaginationQuery = {
	__typename?: "Query";
	vaccineConnection: {
		__typename?: "VaccineConnection";
		totalCount: number;
		edges: Array<{ __typename?: "VaccineEdge"; cursor: string }>;
	};
};

export type VaccineSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<VaccineFilterInput> | VaccineFilterInput>;
	order?: InputMaybe<VaccineOrder>;
}>;

export type VaccineSelectQuery = {
	__typename?: "Query";
	vaccineConnection: {
		__typename?: "VaccineConnection";
		edges: Array<{ __typename?: "VaccineEdge"; node: { __typename?: "Vaccine"; id: string; name: string } }>;
	};
};

export type VaccineUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: VaccineUpdateInput;
}>;

export type VaccineUpdateMutation = {
	__typename?: "Mutation";
	updateVaccine: { __typename?: "Vaccine"; id: string; name: string; description: string };
};

export type AdmissionsReEnrollmentSummaryQueryVariables = Exact<{
	filters: ContractFilterInput;
}>;

export type AdmissionsReEnrollmentSummaryQuery = {
	__typename?: "Query";
	incomplete: { __typename?: "ContractConnection"; totalCount: number };
	readyForReview: { __typename?: "ContractConnection"; totalCount: number };
	approved: { __typename?: "ContractConnection"; totalCount: number };
	signed: { __typename?: "ContractConnection"; totalCount: number };
};

export type StudentsWithContractsListQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentOrder>;
	contractFilters?: InputMaybe<Array<ContractFilterInput> | ContractFilterInput>;
}>;

export type StudentsWithContractsListQuery = {
	__typename?: "Query";
	studentConnection: {
		__typename?: "StudentConnection";
		edges: Array<{
			__typename?: "StudentEdge";
			node: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				yearsFromGraduation: number;
				contracts: Array<{
					__typename?: "Contract";
					id: string;
					status: string;
					isApproved: boolean;
					signedFileURL: string;
					signedFileKey: string;
					signedFileContentType: string;
					name: string;
					contractLineItems: Array<{ __typename?: "ContractLineItem"; id: string; amount: number }>;
					contractInstallments: Array<{ __typename?: "ContractInstallment"; id: string }>;
				}>;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type AdmissionsCenterReEnrollmentStudentQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
	contractFilters: ContractFilterInput;
}>;

export type AdmissionsCenterReEnrollmentStudentQuery = {
	__typename?: "Query";
	studentConnection: {
		__typename?: "StudentConnection";
		edges: Array<{
			__typename?: "StudentEdge";
			node: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				yearsFromGraduation: number;
				relationships: Array<{
					__typename?: "Relationship";
					id: string;
					relationshipType: string;
					isPrimary: boolean;
					isFinancialContact: boolean;
					isEmergencyContact: boolean;
					isAuthorizedForPickup: boolean;
					livesWithStudent: boolean;
					hasCustody: boolean;
					guardian: {
						__typename?: "Guardian";
						id: string;
						person: {
							__typename?: "Person";
							id: string;
							userID: string | null;
							name: string;
							publicName: string;
							imageURL: string;
							imageKey: string;
							imageContentType: string;
							phoneNumbers: Array<{
								__typename?: "PhoneNumber";
								id: string;
								name: string;
								isPrimary: boolean;
								phoneNumber: string;
							}>;
							emailAddresses: Array<{
								__typename?: "EmailAddress";
								id: string;
								name: string;
								isPrimary: boolean;
								emailAddress: string;
							}>;
							addresses: Array<{
								__typename?: "Address";
								id: string;
								name: string;
								addressLine1: string;
								addressLine2: string;
								city: string;
								postalCode: string;
								stateOrProvince: string;
								country: { __typename?: "Country"; id: string; name: string };
							}>;
						};
					};
				}>;
				studentMedicalConditions: Array<{
					__typename?: "StudentMedicalCondition";
					id: string;
					isProminent: boolean;
					notes: string;
					medicalCondition: {
						__typename?: "MedicalCondition";
						id: string;
						conditionType: MedicalConditionConditionType;
						name: string;
					};
				}>;
				studentPrescriptionMedications: Array<{
					__typename?: "StudentPrescriptionMedication";
					id: string;
					administration: string;
					notes: string;
					canSelfAdminister: boolean;
					medication: { __typename?: "Medication"; id: string; name: string };
				}>;
				studentOtcMedications: Array<{
					__typename?: "StudentOTCMedication";
					id: string;
					isAllowed: boolean;
					notes: string;
					medication: { __typename?: "Medication"; id: string; name: string };
				}>;
				studentVaccinationRecords: Array<{
					__typename?: "StudentVaccinationRecord";
					id: string;
					receivedOn: string;
					notes: string;
					vaccine: { __typename?: "Vaccine"; id: string; name: string };
				}>;
				studentDataConsents: Array<{
					__typename?: "StudentDataConsent";
					id: string;
					createdAt: string;
					updatedAt: string;
					allowPublishVisualMediaOfStudentGeneral: boolean;
					allowPublishVisualMediaOfStudentForPromotion: boolean;
					allowPublishVisualMediaOfGuardianForPromotion: boolean;
					allowPublishStudentWorkGeneral: boolean;
					allowShareInformationWithPearsonEdexcel: boolean;
					allowShareInformationWithIbOrganization: boolean;
					allowShareInformationWithOnlinePlatforms: boolean;
					allowBirthdayInCalendar: boolean;
					allowSendNewsletters: boolean;
					allowSendCalendarEvents: boolean;
					author: {
						__typename?: "User";
						id: string;
						email: string;
						isCurrent: boolean;
						person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
					} | null;
					student: {
						__typename?: "Student";
						id: string;
						person: {
							__typename?: "Person";
							id: string;
							name: string;
							publicName: string;
							imageURL: string;
							imageKey: string;
							imageContentType: string;
						};
					};
				}>;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
	contractConnection: {
		__typename?: "ContractConnection";
		edges: Array<{
			__typename?: "ContractEdge";
			node: {
				__typename?: "Contract";
				id: string;
				status: string;
				isApproved: boolean;
				fileURL: string;
				signedFileURL: string;
				signedFileKey: string;
				signedFileContentType: string;
				name: string;
				contractLineItems: Array<{
					__typename?: "ContractLineItem";
					id: string;
					displayOrder: number;
					amount: number;
					dateAdded: string | null;
					dateRemoved: string | null;
					isDiscount: boolean;
					service: { __typename?: "Service"; id: string; name: string } | null;
					discount: { __typename?: "Discount"; id: string; name: string } | null;
					childContractLineItems: Array<{
						__typename?: "ContractLineItem";
						id: string;
						amount: number;
						isDiscount: boolean;
						service: { __typename?: "Service"; id: string; name: string } | null;
						discount: { __typename?: "Discount"; id: string; name: string } | null;
					}>;
				}>;
				contractInstallments: Array<{
					__typename?: "ContractInstallment";
					id: string;
					dueDate: string;
					portion: number;
				}>;
			};
		}>;
	};
};

export type BirthdaysQueryVariables = Exact<{
	dates: Array<Scalars["Date"]["input"]> | Scalars["Date"]["input"];
	filters?: InputMaybe<Array<PersonFilterInput> | PersonFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PersonOrder>;
}>;

export type BirthdaysQuery = {
	__typename?: "Query";
	personConnectionByBirthday: {
		__typename?: "PersonConnection";
		edges: Array<{
			__typename?: "PersonEdge";
			node: {
				__typename?: "Person";
				id: string;
				givenName: string;
				familyName: string;
				dateOfBirth: string | null;
				name: string;
				publicName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
				student: { __typename?: "Student"; id: string } | null;
				employee: { __typename?: "Employee"; id: string } | null;
				guardian: { __typename?: "Guardian"; id: string } | null;
			};
		}>;
	};
};

export type DailyReportSummaryQueryVariables = Exact<{
	date: Scalars["Date"]["input"];
	calendarEventFilters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	studentNoteFilters?: InputMaybe<Array<StudentNoteFilterInput> | StudentNoteFilterInput>;
	academicTermID: Scalars["ID"]["input"];
}>;

export type DailyReportSummaryQuery = {
	__typename?: "Query";
	calendarEventConnection: { __typename?: "CalendarEventConnection"; totalCount: number };
	studentNoteConnection: { __typename?: "StudentNoteConnection"; totalCount: number };
	personConnectionByBirthday: { __typename?: "PersonConnection"; totalCount: number };
	studentConnection: { __typename?: "StudentConnection"; totalCount: number };
	classYearConnection: { __typename?: "ClassYearConnection"; totalCount: number };
	employeeConnection: { __typename?: "EmployeeConnection"; totalCount: number };
};

export type GlobalSearchQueryVariables = Exact<{
	filters: Array<SearchResultFilterInput> | SearchResultFilterInput;
}>;

export type GlobalSearchQuery = {
	__typename?: "Query";
	searchResultConnection: {
		__typename?: "SearchResultConnection";
		edges: Array<{
			__typename?: "SearchResultEdge";
			node: { __typename?: "SearchResult"; id: string; name: string; modelName: string; searchText: string };
		}>;
	};
};

export type HubsIndexPageSummaryQueryVariables = Exact<{
	date: Scalars["Date"]["input"];
}>;

export type HubsIndexPageSummaryQuery = {
	__typename?: "Query";
	studentConnection: { __typename?: "StudentConnection"; totalCount: number };
	employeeConnection: { __typename?: "EmployeeConnection"; totalCount: number };
	announcementConnection: { __typename?: "AnnouncementConnection"; totalCount: number };
	newsletterConnection: { __typename?: "NewsletterConnection"; totalCount: number };
	postConnection: { __typename?: "PostConnection"; totalCount: number };
	calendarEventConnection: { __typename?: "CalendarEventConnection"; totalCount: number };
};

export type ModelIDsQueryVariables = Exact<{ [key: string]: never }>;

export type ModelIDsQuery = {
	__typename?: "Query";
	modelIDs: Array<{ __typename?: "ModelIDInformation"; modelName: string; minID: string; maxID: string }>;
};

export type GuardianOnboardingSubmissionMutationVariables = Exact<{
	studentDataConsentInput?: InputMaybe<StudentDataConsentCreateInput>;
	personInput?: InputMaybe<PersonUpdateInput>;
	userInput?: InputMaybe<UserUpdateInput>;
}>;

export type GuardianOnboardingSubmissionMutation = { __typename?: "Mutation"; guardianOnboardingSubmission: boolean };

export type ReEnrollmentGuardiansOverviewQueryVariables = Exact<{
	filters?: InputMaybe<Array<GuardianFilterInput> | GuardianFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<GuardianOrder>;
}>;

export type ReEnrollmentGuardiansOverviewQuery = {
	__typename?: "Query";
	guardianConnection: {
		__typename?: "GuardianConnection";
		edges: Array<{
			__typename?: "GuardianEdge";
			node: {
				__typename?: "Guardian";
				id: string;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
					phoneNumbers: Array<{ __typename?: "PhoneNumber"; id: string; phoneNumber: string }>;
					emailAddresses: Array<{ __typename?: "EmailAddress"; id: string; emailAddress: string }>;
					addresses: Array<{
						__typename?: "Address";
						id: string;
						name: string;
						addressLine1: string;
						addressLine2: string;
						city: string;
						postalCode: string;
						stateOrProvince: string;
						country: { __typename?: "Country"; id: string; name: string };
					}>;
				};
				relationships: Array<{ __typename?: "Relationship"; id: string; relationshipType: string }>;
			};
		}>;
	};
};

export type ReEnrollmentGuardianDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ReEnrollmentGuardianDetailQuery = {
	__typename?: "Query";
	guardian: {
		__typename?: "Guardian";
		id: string;
		person: {
			__typename?: "Person";
			id: string;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
			phoneNumbers: Array<{
				__typename?: "PhoneNumber";
				id: string;
				name: string;
				phoneNumber: string;
				isPrimary: boolean;
			}>;
			emailAddresses: Array<{
				__typename?: "EmailAddress";
				id: string;
				name: string;
				emailAddress: string;
				isPrimary: boolean;
			}>;
			addresses: Array<{
				__typename?: "Address";
				id: string;
				name: string;
				addressLine1: string;
				addressLine2: string;
				city: string;
				postalCode: string;
				stateOrProvince: string;
				country: { __typename?: "Country"; id: string; name: string };
			}>;
		};
		relationships: Array<{ __typename?: "Relationship"; id: string; relationshipType: string }>;
	};
};

export type ReEnrollmentStudentHealthOverviewQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentOrder>;
}>;

export type ReEnrollmentStudentHealthOverviewQuery = {
	__typename?: "Query";
	studentConnection: {
		__typename?: "StudentConnection";
		edges: Array<{
			__typename?: "StudentEdge";
			node: {
				__typename?: "Student";
				id: string;
				person: {
					__typename?: "Person";
					id: string;
					dateOfBirth: string | null;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
				studentMedicalConditions: Array<{
					__typename?: "StudentMedicalCondition";
					id: string;
					isProminent: boolean;
					notes: string;
					medicalCondition: {
						__typename?: "MedicalCondition";
						id: string;
						conditionType: MedicalConditionConditionType;
						name: string;
					};
				}>;
				studentPrescriptionMedications: Array<{
					__typename?: "StudentPrescriptionMedication";
					id: string;
					administration: string;
					notes: string;
					canSelfAdminister: boolean;
					medication: { __typename?: "Medication"; id: string; name: string };
				}>;
				studentOtcMedications: Array<{
					__typename?: "StudentOTCMedication";
					id: string;
					isAllowed: boolean;
					notes: string;
					medication: { __typename?: "Medication"; id: string; name: string };
				}>;
				studentVaccinationRecords: Array<{
					__typename?: "StudentVaccinationRecord";
					id: string;
					receivedOn: string;
					notes: string;
					vaccine: { __typename?: "Vaccine"; id: string; name: string };
				}>;
			};
		}>;
	};
};

export type ReEnrollmentStudentHealthDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ReEnrollmentStudentHealthDetailQuery = {
	__typename?: "Query";
	student: {
		__typename?: "Student";
		id: string;
		person: {
			__typename?: "Person";
			id: string;
			dateOfBirth: string | null;
			name: string;
			publicName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		};
		studentMedicalConditions: Array<{
			__typename?: "StudentMedicalCondition";
			id: string;
			isProminent: boolean;
			notes: string;
			medicalCondition: {
				__typename?: "MedicalCondition";
				id: string;
				conditionType: MedicalConditionConditionType;
				name: string;
			};
		}>;
		studentPrescriptionMedications: Array<{
			__typename?: "StudentPrescriptionMedication";
			id: string;
			administration: string;
			notes: string;
			canSelfAdminister: boolean;
			medication: { __typename?: "Medication"; id: string; name: string };
		}>;
		studentOtcMedications: Array<{
			__typename?: "StudentOTCMedication";
			id: string;
			isAllowed: boolean;
			notes: string;
			medication: { __typename?: "Medication"; id: string; name: string };
		}>;
		studentVaccinationRecords: Array<{
			__typename?: "StudentVaccinationRecord";
			id: string;
			receivedOn: string;
			notes: string;
			vaccine: { __typename?: "Vaccine"; id: string; name: string };
		}>;
	};
};

export type CreateOrUpdateRecentStudentDataConsentsMutationVariables = Exact<{
	studentDataConsentInput: StudentDataConsentCreateInput;
	studentIDs: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type CreateOrUpdateRecentStudentDataConsentsMutation = {
	__typename?: "Mutation";
	createOrUpdateRecentStudentDataConsents: boolean;
};

export type ReEnrollmentMealPlanContractListQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractFilterInput> | ContractFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ContractOrder>;
}>;

export type ReEnrollmentMealPlanContractListQuery = {
	__typename?: "Query";
	contractConnection: {
		__typename?: "ContractConnection";
		edges: Array<{
			__typename?: "ContractEdge";
			node: {
				__typename?: "Contract";
				id: string;
				status: string;
				student: {
					__typename?: "Student";
					id: string;
					graduationYear: number | null;
					yearsFromGraduation: number;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					};
				};
				contractLineItems: Array<{ __typename?: "ContractLineItem"; id: string; serviceID: string | null }>;
			};
		}>;
	};
};

export type SetMealPlanOnContractMutationVariables = Exact<{
	contractID: Scalars["ID"]["input"];
	mealPlanID: Scalars["ID"]["input"];
}>;

export type SetMealPlanOnContractMutation = { __typename?: "Mutation"; setMealPlanOnContract: boolean };

export type RemoveMealPlanFromContractMutationVariables = Exact<{
	contractID: Scalars["ID"]["input"];
}>;

export type RemoveMealPlanFromContractMutation = { __typename?: "Mutation"; removeMealPlanFromContract: boolean };

export type ReEnrollmentPaymentPlanContractListQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractFilterInput> | ContractFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ContractOrder>;
}>;

export type ReEnrollmentPaymentPlanContractListQuery = {
	__typename?: "Query";
	contractConnection: {
		__typename?: "ContractConnection";
		edges: Array<{
			__typename?: "ContractEdge";
			node: {
				__typename?: "Contract";
				id: string;
				name: string;
				status: string;
				effectiveDate: string | null;
				dateVoided: string | null;
				student: {
					__typename?: "Student";
					id: string;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					};
				};
				contractLineItems: Array<{
					__typename?: "ContractLineItem";
					id: string;
					displayOrder: number;
					amount: number;
					dateAdded: string | null;
					dateRemoved: string | null;
					isDiscount: boolean;
					service: { __typename?: "Service"; id: string; name: string } | null;
					discount: { __typename?: "Discount"; id: string; name: string } | null;
					childContractLineItems: Array<{
						__typename?: "ContractLineItem";
						id: string;
						amount: number;
						isDiscount: boolean;
						service: { __typename?: "Service"; id: string; name: string } | null;
						discount: { __typename?: "Discount"; id: string; name: string } | null;
					}>;
				}>;
				contractInstallments: Array<{
					__typename?: "ContractInstallment";
					id: string;
					dueDate: string;
					portion: number;
				}>;
			};
		}>;
	};
};

export type SetPaymentPlanOnContractMutationVariables = Exact<{
	contractID: Scalars["ID"]["input"];
	numPayments: Scalars["Int"]["input"];
}>;

export type SetPaymentPlanOnContractMutation = { __typename?: "Mutation"; setPaymentPlanOnContract: boolean };

export type ReEnrollmentReviewQueryVariables = Exact<{
	studentFilters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	contractFilters?: InputMaybe<Array<ContractFilterInput> | ContractFilterInput>;
}>;

export type ReEnrollmentReviewQuery = {
	__typename?: "Query";
	studentConnection: {
		__typename?: "StudentConnection";
		edges: Array<{
			__typename?: "StudentEdge";
			node: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				yearsFromGraduation: number;
				person: {
					__typename?: "Person";
					id: string;
					dateOfBirth: string | null;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
				contracts: Array<{
					__typename?: "Contract";
					id: string;
					contractLineItems: Array<{
						__typename?: "ContractLineItem";
						id: string;
						isDiscount: boolean;
						amount: number;
						service: { __typename?: "Service"; id: string; category: ServiceCategory; name: string } | null;
						childContractLineItems: Array<{
							__typename?: "ContractLineItem";
							id: string;
							isDiscount: boolean;
							amount: number;
						}>;
					}>;
					contractInstallments: Array<{
						__typename?: "ContractInstallment";
						id: string;
						dueDate: string;
						portion: number;
					}>;
				}>;
			};
		}>;
	};
};

export type ReEnrollmentNoticeQueryVariables = Exact<{
	studentFilters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	contractFilters?: InputMaybe<Array<ContractFilterInput> | ContractFilterInput>;
}>;

export type ReEnrollmentNoticeQuery = {
	__typename?: "Query";
	studentConnection: {
		__typename?: "StudentConnection";
		edges: Array<{
			__typename?: "StudentEdge";
			node: {
				__typename?: "Student";
				id: string;
				contracts: Array<{
					__typename?: "Contract";
					id: string;
					contractInstallments: Array<{ __typename?: "ContractInstallment"; id: string }>;
				}>;
			};
		}>;
	};
};

export type ParentPortalReEnrollmentContractsQueryVariables = Exact<{
	filters: Array<ContractFilterInput> | ContractFilterInput;
}>;

export type ParentPortalReEnrollmentContractsQuery = {
	__typename?: "Query";
	contractConnection: {
		__typename?: "ContractConnection";
		edges: Array<{
			__typename?: "ContractEdge";
			node: {
				__typename?: "Contract";
				id: string;
				name: string;
				status: string;
				fileURL: string;
				fileKey: string;
				fileContentType: string;
				student: {
					__typename?: "Student";
					id: string;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					};
				};
			};
		}>;
	};
};

export type ReportCardsCompletionProgressStatisticsQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardFilterInput> | ReportCardFilterInput>;
}>;

export type ReportCardsCompletionProgressStatisticsQuery = {
	__typename?: "Query";
	reportCardsCompletionProgressStatistics: {
		__typename?: "AggregateReportCardCompletionProgressStatistics";
		count: number;
		incomplete: number;
		ready: number;
		complete: number;
	};
};

export type ReportCardSectionsCompletionProgressStatisticsQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardSectionFilterInput> | ReportCardSectionFilterInput>;
}>;

export type ReportCardSectionsCompletionProgressStatisticsQuery = {
	__typename?: "Query";
	reportCardSectionsCompletionProgressStatistics: {
		__typename?: "AggregateReportCardCompletionProgressStatistics";
		count: number;
		incomplete: number;
		ready: number;
		complete: number;
	};
};

export type SectionsReportCardSectionsCompletionProgressStatisticsQueryVariables = Exact<{
	homeRoomSectionFilters?: InputMaybe<Array<HomeRoomSectionFilterInput> | HomeRoomSectionFilterInput>;
	courseSectionFilters?: InputMaybe<Array<CourseSectionFilterInput> | CourseSectionFilterInput>;
}>;

export type SectionsReportCardSectionsCompletionProgressStatisticsQuery = {
	__typename?: "Query";
	homeRoomSectionConnection: {
		__typename?: "HomeRoomSectionConnection";
		edges: Array<{
			__typename?: "HomeRoomSectionEdge";
			node: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				studentHomeRoomSectionEnrollments: Array<{
					__typename?: "StudentHomeRoomSectionEnrollment";
					id: string;
					lateStartDate: string | null;
					earlyEndDate: string | null;
				}>;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			};
		}>;
	};
	courseSectionConnection: {
		__typename?: "CourseSectionConnection";
		edges: Array<{
			__typename?: "CourseSectionEdge";
			node: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: {
					__typename?: "Course";
					id: string;
					name: string;
					academicSubject: { __typename?: "AcademicSubject"; id: string; name: string; color: string };
					classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
				};
				homeRoomSection: {
					__typename?: "HomeRoomSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
				} | null;
				studentCourseSectionEnrollments: Array<{
					__typename?: "StudentCourseSectionEnrollment";
					id: string;
					lateStartDate: string | null;
					earlyEndDate: string | null;
				}>;
			};
		}>;
	};
	sectionsReportCardSectionsCompletionProgressStatistics: Array<{
		__typename?: "SectionReportCardSectionsCompletionProgressStatistics";
		id: string;
		statistics: {
			__typename?: "AggregateReportCardCompletionProgressStatistics";
			count: number;
			incomplete: number;
			ready: number;
			complete: number;
		};
	}>;
};

export type StudentsReportCardSectionCompletionProgressStatisticsQueryVariables = Exact<{
	reportCardSectionFilters?: InputMaybe<Array<ReportCardSectionFilterInput> | ReportCardSectionFilterInput>;
}>;

export type StudentsReportCardSectionCompletionProgressStatisticsQuery = {
	__typename?: "Query";
	studentsReportCardSectionCompletionProgressStatistics: Array<{
		__typename?: "IndividualReportCardCompletionProgressStatistics";
		id: string;
		isReady: boolean;
		isComplete: boolean;
		completionPercentage: number;
	}>;
};

export type AspectsReportCardSectionCompletionProgressStatisticsQueryVariables = Exact<{
	reportCardSectionFilters?: InputMaybe<Array<ReportCardSectionFilterInput> | ReportCardSectionFilterInput>;
}>;

export type AspectsReportCardSectionCompletionProgressStatisticsQuery = {
	__typename?: "Query";
	aspectsReportCardSectionCompletionProgressStatistics: Array<{
		__typename?: "AspectIndividualReportCardCompletionProgressStatistics";
		id: string;
		isReady: boolean;
		isComplete: boolean;
		completionPercentage: number;
	}>;
};

export type PoliciesAspectsReportCardSectionCompletionProgressStatisticsQueryVariables = Exact<{
	reportCardSectionFilters?: InputMaybe<Array<ReportCardSectionFilterInput> | ReportCardSectionFilterInput>;
}>;

export type PoliciesAspectsReportCardSectionCompletionProgressStatisticsQuery = {
	__typename?: "Query";
	policiesAspectsReportCardSectionCompletionProgressStatistics: Array<{
		__typename?: "PolicyAspectIndividualReportCardCompletionProgressStatistics";
		id: string;
		statistics: Array<{
			__typename?: "AspectIndividualReportCardCompletionProgressStatistics";
			id: string;
			isReady: boolean;
			isComplete: boolean;
			completionPercentage: number;
		}>;
	}>;
};

export type AdminReportCardStudentsTableQueryVariables = Exact<{
	academicTermID: Scalars["ID"]["input"];
	studentFilters?: InputMaybe<Array<StudentFilterInput> | StudentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentOrder>;
}>;

export type AdminReportCardStudentsTableQuery = {
	__typename?: "Query";
	studentConnection: {
		__typename?: "StudentConnection";
		edges: Array<{
			__typename?: "StudentEdge";
			node: {
				__typename?: "Student";
				id: string;
				graduationYear: number | null;
				yearsFromGraduation: number;
				reportCards: Array<{ __typename?: "ReportCard"; id: string; isComplete: boolean }>;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
	homeRoomSectionConnection: {
		__typename?: "HomeRoomSectionConnection";
		edges: Array<{
			__typename?: "HomeRoomSectionEdge";
			node: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			};
		}>;
	};
	courseSectionConnection: {
		__typename?: "CourseSectionConnection";
		edges: Array<{
			__typename?: "CourseSectionEdge";
			node: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			};
		}>;
	};
	studentsReportCardCompletionProgressStatistics: Array<{
		__typename?: "IndividualReportCardCompletionProgressStatistics";
		id: string;
		isReady: boolean;
		isComplete: boolean;
		completionPercentage: number;
	}>;
	studentsSectionsReportCardSectionCompletionProgressStatistics: Array<{
		__typename?: "StudentSectionReportCardSectionsCompletionProgressStatistics";
		id: string;
		statistics: Array<{
			__typename?: "IndividualReportCardCompletionProgressStatistics";
			id: string;
			isReady: boolean;
			isComplete: boolean;
			completionPercentage: number;
		}>;
	}>;
};

export type AdminReportCardTeachersTableQueryVariables = Exact<{
	academicTermID: Scalars["ID"]["input"];
	teacherFilters?: InputMaybe<Array<EmployeeFilterInput> | EmployeeFilterInput>;
}>;

export type AdminReportCardTeachersTableQuery = {
	__typename?: "Query";
	employeeConnection: {
		__typename?: "EmployeeConnection";
		edges: Array<{
			__typename?: "EmployeeEdge";
			node: {
				__typename?: "Employee";
				id: string;
				teacherHomeRoomSectionEnrollments: Array<{
					__typename?: "TeacherHomeRoomSectionEnrollment";
					id: string;
					homeRoomSection: {
						__typename?: "HomeRoomSection";
						id: string;
						homeRoom: {
							__typename?: "HomeRoom";
							id: string;
							classYear: { __typename?: "ClassYear"; id: string; yearsFromGraduation: number; name: string };
						};
					};
				}>;
				teacherCourseSectionEnrollments: Array<{
					__typename?: "TeacherCourseSectionEnrollment";
					id: string;
					courseSection: {
						__typename?: "CourseSection";
						id: string;
						course: {
							__typename?: "Course";
							id: string;
							classYears: Array<{ __typename?: "ClassYear"; id: string; yearsFromGraduation: number; name: string }>;
						};
					};
				}>;
				person: {
					__typename?: "Person";
					id: string;
					name: string;
					publicName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
	homeRoomSectionConnection: {
		__typename?: "HomeRoomSectionConnection";
		edges: Array<{
			__typename?: "HomeRoomSectionEdge";
			node: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			};
		}>;
	};
	courseSectionConnection: {
		__typename?: "CourseSectionConnection";
		edges: Array<{
			__typename?: "CourseSectionEdge";
			node: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: { __typename?: "Course"; id: string; name: string };
			};
		}>;
	};
	teachersSectionsReportCardSectionCompletionProgressStatistics: Array<{
		__typename?: "TeacherSectionReportCardSectionsCompletionProgressStatistics";
		id: string;
		statistics: Array<{
			__typename?: "IndividualReportCardCompletionProgressStatistics";
			id: string;
			isReady: boolean;
			isComplete: boolean;
			completionPercentage: number;
		}>;
	}>;
};

export type StudentReportCardSchoolAttendanceStatisticsQueryVariables = Exact<{
	studentID: Scalars["ID"]["input"];
	academicTermID: Scalars["ID"]["input"];
}>;

export type StudentReportCardSchoolAttendanceStatisticsQuery = {
	__typename?: "Query";
	studentReportCardSchoolAttendanceStatistics: {
		__typename?: "ReportCardAttendanceStatistics";
		total: number;
		present: number;
		excusedLateArrival: number;
		unexcusedLateArrival: number;
		excusedEarlyDeparture: number;
		unexcusedEarlyDeparture: number;
		excusedAbsent: number;
		unexcusedAbsent: number;
	};
};

export type StudentReportCardCourseAttendanceStatisticsQueryVariables = Exact<{
	studentID: Scalars["ID"]["input"];
	academicTermID: Scalars["ID"]["input"];
}>;

export type StudentReportCardCourseAttendanceStatisticsQuery = {
	__typename?: "Query";
	studentReportCardCourseAttendanceStatistics: {
		__typename?: "ReportCardAttendanceStatistics";
		total: number;
		present: number;
		excusedLateArrival: number;
		unexcusedLateArrival: number;
		excusedEarlyDeparture: number;
		unexcusedEarlyDeparture: number;
		excusedAbsent: number;
		unexcusedAbsent: number;
	};
};

export type TeacherReportCardCourseAndHomeRoomSectionsListQueryVariables = Exact<{
	academicTermID: Scalars["ID"]["input"];
}>;

export type TeacherReportCardCourseAndHomeRoomSectionsListQuery = {
	__typename?: "Query";
	courseSectionConnection: {
		__typename?: "CourseSectionConnection";
		edges: Array<{
			__typename?: "CourseSectionEdge";
			node: {
				__typename?: "CourseSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				course: {
					__typename?: "Course";
					id: string;
					name: string;
					classYears: Array<{ __typename?: "ClassYear"; id: string; name: string }>;
				};
				homeRoomSection: {
					__typename?: "HomeRoomSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
				} | null;
				teacherCourseSectionEnrollments: Array<{
					__typename?: "TeacherCourseSectionEnrollment";
					id: string;
					teacher: {
						__typename?: "Employee";
						id: string;
						person: {
							__typename?: "Person";
							id: string;
							name: string;
							publicName: string;
							imageURL: string;
							imageKey: string;
							imageContentType: string;
						};
					};
				}>;
			};
		}>;
	};
	homeRoomSectionConnection: {
		__typename?: "HomeRoomSectionConnection";
		edges: Array<{
			__typename?: "HomeRoomSectionEdge";
			node: {
				__typename?: "HomeRoomSection";
				id: string;
				namePrefix: string;
				nameSuffix: string;
				teacherHomeRoomSectionEnrollments: Array<{
					__typename?: "TeacherHomeRoomSectionEnrollment";
					id: string;
					teacher: {
						__typename?: "Employee";
						id: string;
						person: {
							__typename?: "Person";
							id: string;
							name: string;
							publicName: string;
							imageURL: string;
							imageKey: string;
							imageContentType: string;
						};
					};
				}>;
				homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
			};
		}>;
	};
};

export type StudentReportCardSectionFormInformationQueryVariables = Exact<{
	academicTermID: Scalars["ID"]["input"];
	studentID: Scalars["ID"]["input"];
	homeRoomSectionID?: InputMaybe<Scalars["ID"]["input"]>;
	courseSectionID?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type StudentReportCardSectionFormInformationQuery = {
	__typename?: "Query";
	reportCardSectionConnection: {
		__typename?: "ReportCardSectionConnection";
		edges: Array<{
			__typename?: "ReportCardSectionEdge";
			node: {
				__typename?: "ReportCardSection";
				id: string;
				comment: string;
				generalComment1: string;
				generalComment2: string;
				isComplete: boolean;
				overallMarkValue: { __typename?: "MarkValue"; id: string; name: string } | null;
				reportCard: { __typename?: "ReportCard"; id: string; isComplete: boolean; isReleased: boolean };
				reportCardSectionPolicy: {
					__typename?: "ReportCardSectionPolicy";
					id: string;
					usesOverallMark: boolean;
					isOverallMarkManual: boolean;
					overallMarkLabel: string;
					usesComment: boolean;
					commentLabel: string;
					minCommentLength: number;
					maxCommentLength: number;
					usesGeneralComments: boolean;
					minGeneralComment1Length: number;
					maxGeneralComment1Length: number;
					minGeneralComment2Length: number;
					maxGeneralComment2Length: number;
					nameSuffix: string;
					overallMarkingSystem: {
						__typename?: "MarkingSystem";
						id: string;
						markValues: Array<{ __typename?: "MarkValue"; id: string; name: string }>;
					} | null;
					courseSection: {
						__typename?: "CourseSection";
						id: string;
						namePrefix: string;
						nameSuffix: string;
						course: { __typename?: "Course"; id: string; name: string };
					} | null;
					homeRoomSection: {
						__typename?: "HomeRoomSection";
						id: string;
						namePrefix: string;
						nameSuffix: string;
						homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
					} | null;
				};
				reportCardSectionLearningObjectives: Array<{
					__typename?: "ReportCardSectionLearningObjective";
					id: string;
					learningObjective: {
						__typename?: "LearningObjective";
						id: string;
						description: string;
						learningObjectiveCategoryID: string;
						name: string;
					};
					markValue: { __typename?: "MarkValue"; id: string; name: string } | null;
				}>;
			};
		}>;
	};
	learningObjectiveCategoryConnection: {
		__typename?: "LearningObjectiveCategoryConnection";
		edges: Array<{
			__typename?: "LearningObjectiveCategoryEdge";
			node: {
				__typename?: "LearningObjectiveCategory";
				id: string;
				name: string;
				markingSystem: {
					__typename?: "MarkingSystem";
					id: string;
					markValues: Array<{ __typename?: "MarkValue"; id: string; name: string }>;
				} | null;
			};
		}>;
	};
};

export type ReportCardSectionLearningObjectivesNavigationListQueryVariables = Exact<{
	academicTermID: Scalars["ID"]["input"];
	courseSectionID?: InputMaybe<Scalars["ID"]["input"]>;
	homeRoomSectionID?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type ReportCardSectionLearningObjectivesNavigationListQuery = {
	__typename?: "Query";
	reportCardSectionPolicyConnection: {
		__typename?: "ReportCardSectionPolicyConnection";
		edges: Array<{
			__typename?: "ReportCardSectionPolicyEdge";
			node: {
				__typename?: "ReportCardSectionPolicy";
				id: string;
				usesOverallMark: boolean;
				isOverallMarkManual: boolean;
				overallMarkLabel: string;
				usesComment: boolean;
				commentLabel: string;
				usesGeneralComments: boolean;
				nameSuffix: string;
				reportCardSections: Array<{
					__typename?: "ReportCardSection";
					id: string;
					reportCardSectionLearningObjectives: Array<{
						__typename?: "ReportCardSectionLearningObjective";
						id: string;
						learningObjectiveID: string;
					}>;
				}>;
				courseSection: {
					__typename?: "CourseSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					course: { __typename?: "Course"; id: string; name: string };
				} | null;
				homeRoomSection: {
					__typename?: "HomeRoomSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
				} | null;
			};
		}>;
	};
	learningObjectiveCategoryConnection: {
		__typename?: "LearningObjectiveCategoryConnection";
		edges: Array<{
			__typename?: "LearningObjectiveCategoryEdge";
			node: {
				__typename?: "LearningObjectiveCategory";
				id: string;
				name: string;
				learningObjectives: Array<{ __typename?: "LearningObjective"; id: string; name: string }>;
			};
		}>;
	};
};

export type LearningObjectiveAspectReportCardSectionFormInformationQueryVariables = Exact<{
	academicTermID: Scalars["ID"]["input"];
	reportCardSectionPolicyID: Scalars["ID"]["input"];
	learningObjectiveID: Scalars["ID"]["input"];
}>;

export type LearningObjectiveAspectReportCardSectionFormInformationQuery = {
	__typename?: "Query";
	reportCardSectionLearningObjectiveConnection: {
		__typename?: "ReportCardSectionLearningObjectiveConnection";
		edges: Array<{
			__typename?: "ReportCardSectionLearningObjectiveEdge";
			node: {
				__typename?: "ReportCardSectionLearningObjective";
				id: string;
				markValue: { __typename?: "MarkValue"; id: string; name: string } | null;
				reportCardSection: {
					__typename?: "ReportCardSection";
					id: string;
					isComplete: boolean;
					reportCard: {
						__typename?: "ReportCard";
						id: string;
						student: {
							__typename?: "Student";
							id: string;
							person: {
								__typename?: "Person";
								id: string;
								familyName: string;
								name: string;
								publicName: string;
								imageURL: string;
								imageKey: string;
								imageContentType: string;
							};
						};
					};
				};
			};
		}>;
	};
	learningObjective: {
		__typename?: "LearningObjective";
		id: string;
		description: string;
		name: string;
		learningObjectiveCategory: {
			__typename?: "LearningObjectiveCategory";
			id: string;
			name: string;
			markingSystem: {
				__typename?: "MarkingSystem";
				id: string;
				markValues: Array<{ __typename?: "MarkValue"; id: string; name: string }>;
			} | null;
		};
	};
};

export type OverallMarkAspectReportCardSectionFormInformationQueryVariables = Exact<{
	academicTermID: Scalars["ID"]["input"];
	reportCardSectionPolicyID: Scalars["ID"]["input"];
}>;

export type OverallMarkAspectReportCardSectionFormInformationQuery = {
	__typename?: "Query";
	reportCardSectionConnection: {
		__typename?: "ReportCardSectionConnection";
		edges: Array<{
			__typename?: "ReportCardSectionEdge";
			node: {
				__typename?: "ReportCardSection";
				id: string;
				isComplete: boolean;
				overallMarkValue: { __typename?: "MarkValue"; id: string; name: string } | null;
				reportCard: {
					__typename?: "ReportCard";
					id: string;
					student: {
						__typename?: "Student";
						id: string;
						person: {
							__typename?: "Person";
							id: string;
							familyName: string;
							name: string;
							publicName: string;
							imageURL: string;
							imageKey: string;
							imageContentType: string;
						};
					};
				};
			};
		}>;
	};
};

export type CommentAspectReportCardSectionFormInformationQueryVariables = Exact<{
	academicTermID: Scalars["ID"]["input"];
	reportCardSectionPolicyID: Scalars["ID"]["input"];
}>;

export type CommentAspectReportCardSectionFormInformationQuery = {
	__typename?: "Query";
	reportCardSectionConnection: {
		__typename?: "ReportCardSectionConnection";
		edges: Array<{
			__typename?: "ReportCardSectionEdge";
			node: {
				__typename?: "ReportCardSection";
				id: string;
				comment: string;
				generalComment1: string;
				generalComment2: string;
				isComplete: boolean;
				reportCard: {
					__typename?: "ReportCard";
					id: string;
					student: {
						__typename?: "Student";
						id: string;
						person: {
							__typename?: "Person";
							id: string;
							familyName: string;
							name: string;
							publicName: string;
							imageURL: string;
							imageKey: string;
							imageContentType: string;
						};
					};
				};
			};
		}>;
	};
	reportCardSectionPolicy: {
		__typename?: "ReportCardSectionPolicy";
		id: string;
		minCommentLength: number;
		maxCommentLength: number;
		minGeneralComment1Length: number;
		maxGeneralComment1Length: number;
		minGeneralComment2Length: number;
		maxGeneralComment2Length: number;
	};
};

export type ReportCardSectionPolicyGradingInformationQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type ReportCardSectionPolicyGradingInformationQuery = {
	__typename?: "Query";
	reportCardSectionPolicy: {
		__typename?: "ReportCardSectionPolicy";
		id: string;
		usesOverallMark: boolean;
		overallMarkLabel: string;
		usesComment: boolean;
		commentLabel: string;
		usesGeneralComments: boolean;
		nameSuffix: string;
		overallMarkingSystem: {
			__typename?: "MarkingSystem";
			id: string;
			markValues: Array<{ __typename?: "MarkValue"; id: string; name: string }>;
		} | null;
		courseSection: {
			__typename?: "CourseSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			course: { __typename?: "Course"; id: string; name: string };
		} | null;
		homeRoomSection: {
			__typename?: "HomeRoomSection";
			id: string;
			namePrefix: string;
			nameSuffix: string;
			homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
		} | null;
	};
};

export type LearningObjectiveReportCardInformationQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type LearningObjectiveReportCardInformationQuery = {
	__typename?: "Query";
	learningObjective: {
		__typename?: "LearningObjective";
		id: string;
		description: string;
		name: string;
		learningObjectiveCategory: { __typename?: "LearningObjectiveCategory"; id: string; name: string };
	};
};

export type ReportCardSectionsReviewInformationQueryVariables = Exact<{
	filters?: InputMaybe<Array<ReportCardSectionPolicyFilterInput> | ReportCardSectionPolicyFilterInput>;
}>;

export type ReportCardSectionsReviewInformationQuery = {
	__typename?: "Query";
	reportCardSectionPolicyConnection: {
		__typename?: "ReportCardSectionPolicyConnection";
		edges: Array<{
			__typename?: "ReportCardSectionPolicyEdge";
			node: {
				__typename?: "ReportCardSectionPolicy";
				id: string;
				usesOverallMark: boolean;
				isOverallMarkManual: boolean;
				overallMarkLabel: string;
				usesComment: boolean;
				commentLabel: string;
				minCommentLength: number;
				maxCommentLength: number;
				usesGeneralComments: boolean;
				minGeneralComment1Length: number;
				maxGeneralComment1Length: number;
				minGeneralComment2Length: number;
				maxGeneralComment2Length: number;
				nameSuffix: string;
				reportCardSections: Array<{
					__typename?: "ReportCardSection";
					id: string;
					overallMarkValueID: string | null;
					comment: string;
					generalComment1: string;
					generalComment2: string;
					isComplete: boolean;
					reportCard: {
						__typename?: "ReportCard";
						id: string;
						student: {
							__typename?: "Student";
							id: string;
							person: {
								__typename?: "Person";
								id: string;
								familyName: string;
								name: string;
								publicName: string;
								imageURL: string;
								imageKey: string;
								imageContentType: string;
							};
						};
					};
					reportCardSectionLearningObjectives: Array<{
						__typename?: "ReportCardSectionLearningObjective";
						id: string;
						learningObjectiveID: string;
						markValueID: string | null;
					}>;
				}>;
				courseSection: {
					__typename?: "CourseSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					course: { __typename?: "Course"; id: string; name: string };
				} | null;
				homeRoomSection: {
					__typename?: "HomeRoomSection";
					id: string;
					namePrefix: string;
					nameSuffix: string;
					homeRoom: { __typename?: "HomeRoom"; id: string; name: string };
				} | null;
			};
		}>;
	};
	learningObjectiveCategoryConnection: {
		__typename?: "LearningObjectiveCategoryConnection";
		edges: Array<{
			__typename?: "LearningObjectiveCategoryEdge";
			node: {
				__typename?: "LearningObjectiveCategory";
				id: string;
				name: string;
				learningObjectives: Array<{ __typename?: "LearningObjective"; id: string; name: string }>;
			};
		}>;
	};
};

export type SubmitBulkReportCardsMutationVariables = Exact<{
	ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type SubmitBulkReportCardsMutation = {
	__typename?: "Mutation";
	updateBulkReportCards: {
		__typename?: "ReportCardConnection";
		edges: Array<{
			__typename?: "ReportCardEdge";
			node: { __typename?: "ReportCard"; id: string; isComplete: boolean };
		}>;
	};
};

export type SubmitBulkReportCardSectionsMutationVariables = Exact<{
	ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type SubmitBulkReportCardSectionsMutation = {
	__typename?: "Mutation";
	updateBulkReportCardSections: {
		__typename?: "ReportCardSectionConnection";
		edges: Array<{
			__typename?: "ReportCardSectionEdge";
			node: { __typename?: "ReportCardSection"; id: string; isComplete: boolean };
		}>;
	};
};

export type RevokeSubmissionBulkReportCardSectionsMutationVariables = Exact<{
	ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type RevokeSubmissionBulkReportCardSectionsMutation = {
	__typename?: "Mutation";
	updateBulkReportCardSections: {
		__typename?: "ReportCardSectionConnection";
		edges: Array<{
			__typename?: "ReportCardSectionEdge";
			node: { __typename?: "ReportCardSection"; id: string; isComplete: boolean };
		}>;
	};
};

export type ParentPortalReportCardsQueryVariables = Exact<{
	filters: Array<ReportCardFilterInput> | ReportCardFilterInput;
}>;

export type ParentPortalReportCardsQuery = {
	__typename?: "Query";
	reportCardConnection: {
		__typename?: "ReportCardConnection";
		edges: Array<{
			__typename?: "ReportCardEdge";
			node: {
				__typename?: "ReportCard";
				id: string;
				fileURL: string;
				fileKey: string;
				fileContentType: string;
				student: {
					__typename?: "Student";
					id: string;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					};
				};
				academicTerm: { __typename?: "AcademicTerm"; id: string; name: string };
			};
		}>;
	};
};

export type TimelineQueryVariables = Exact<{
	filter?: InputMaybe<TimelineFilterInput>;
	pagination?: InputMaybe<TimelinePagination>;
	timeZone?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type TimelineQuery = {
	__typename?: "Query";
	timeline: {
		__typename?: "TimelineConnection";
		hasMore: boolean;
		items: Array<{
			__typename?: "TimelineItem";
			objectType: TimelineObjectType;
			objectTime: string;
			objectTimeIsDate: boolean;
			objectID: string;
		}>;
	};
};

export type TimelineAcademicTermListQueryVariables = Exact<{
	filters?: InputMaybe<Array<AcademicTermFilterInput> | AcademicTermFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AcademicTermOrder>;
}>;

export type TimelineAcademicTermListQuery = {
	__typename?: "Query";
	academicTermConnection: {
		__typename?: "AcademicTermConnection";
		edges: Array<{
			__typename?: "AcademicTermEdge";
			node: {
				__typename?: "AcademicTerm";
				id: string;
				name: string;
				imageURL: string;
				startDate: string;
				endDate: string;
			};
		}>;
	};
};

export type TimelineAnnouncementListQueryVariables = Exact<{
	filters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AnnouncementOrder>;
}>;

export type TimelineAnnouncementListQuery = {
	__typename?: "Query";
	announcementConnection: {
		__typename?: "AnnouncementConnection";
		edges: Array<{
			__typename?: "AnnouncementEdge";
			node: {
				__typename?: "Announcement";
				id: string;
				title: string;
				body: string;
				startTime: string;
				endTime: string | null;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					} | null;
				} | null;
				mediaAttachments: Array<{
					__typename?: "MediaAttachment";
					id: string;
					title: string;
					description: string;
					isFile: boolean;
					fileURL: string;
					fileKey: string;
					fileContentType: string;
					linkURL: string;
				}>;
				socialReactions: Array<{
					__typename?: "SocialReaction";
					id: string;
					author: {
						__typename?: "User";
						id: string;
						isCurrent: boolean;
						email: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
					};
				}>;
				sharingRecord: {
					__typename?: "SharingRecord";
					id: string;
					isPublic: boolean;
					userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
				} | null;
			};
		}>;
	};
};

export type TimelineCalendarEventListQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type TimelineCalendarEventListQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		edges: Array<{
			__typename?: "CalendarEventEdge";
			node: {
				__typename?: "CalendarEvent";
				id: string;
				name: string;
				description: string;
				location: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
				isAllDay: boolean;
				startTime: string | null;
				endTime: string | null;
				startDate: string | null;
				isMultiDay: boolean;
				endDate: string | null;
				allowsResponses: boolean;
				createdAt: string;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					} | null;
				} | null;
				calendarEventResponses: Array<{
					__typename?: "CalendarEventResponse";
					id: string;
					response: CalendarEventResponseResponse;
					author: {
						__typename?: "User";
						id: string;
						email: string;
						isCurrent: boolean;
						person: {
							__typename?: "Person";
							id: string;
							name: string;
							publicName: string;
							imageURL: string;
							imageKey: string;
							imageContentType: string;
						} | null;
					} | null;
				}>;
				mediaAttachments: Array<{
					__typename?: "MediaAttachment";
					id: string;
					displayOrder: number;
					title: string;
					description: string;
					isFile: boolean;
					fileURL: string;
					fileKey: string;
					fileContentType: string;
					linkURL: string;
					taggedPeople: Array<{
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
					}>;
				}>;
				sharingRecord: { __typename?: "SharingRecord"; id: string; isPublic: boolean } | null;
			};
		}>;
	};
};

export type TimelineContractListQueryVariables = Exact<{
	filters?: InputMaybe<Array<ContractFilterInput> | ContractFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<ContractOrder>;
}>;

export type TimelineContractListQuery = {
	__typename?: "Query";
	contractConnection: {
		__typename?: "ContractConnection";
		edges: Array<{
			__typename?: "ContractEdge";
			node: {
				__typename?: "Contract";
				id: string;
				name: string;
				effectiveDate: string | null;
				student: {
					__typename?: "Student";
					id: string;
					person: { __typename?: "Person"; id: string; name: string; publicName: string };
				};
				academicTerms: Array<{
					__typename?: "AcademicTerm";
					id: string;
					academicYear: { __typename?: "AcademicYear"; id: string; name: string };
				}>;
				contractLineItems: Array<{
					__typename?: "ContractLineItem";
					id: string;
					service: { __typename?: "Service"; id: string; name: string } | null;
					discount: { __typename?: "Discount"; id: string; name: string } | null;
				}>;
			};
		}>;
	};
};

export type TimelineNewsletterListQueryVariables = Exact<{
	filters?: InputMaybe<Array<NewsletterFilterInput> | NewsletterFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<NewsletterOrder>;
}>;

export type TimelineNewsletterListQuery = {
	__typename?: "Query";
	newsletterConnection: {
		__typename?: "NewsletterConnection";
		edges: Array<{
			__typename?: "NewsletterEdge";
			node: {
				__typename?: "Newsletter";
				id: string;
				title: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
				body: string;
				releaseAt: string | null;
				socialReactions: Array<{
					__typename?: "SocialReaction";
					id: string;
					author: {
						__typename?: "User";
						id: string;
						isCurrent: boolean;
						email: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
					};
				}>;
				socialComments: Array<{
					__typename?: "SocialComment";
					id: string;
					body: string;
					createdAt: string;
					author: {
						__typename?: "User";
						id: string;
						isCurrent: boolean;
						email: string;
						person: {
							__typename?: "Person";
							id: string;
							name: string;
							publicName: string;
							imageURL: string;
							imageKey: string;
							imageContentType: string;
						} | null;
					};
				}>;
				sharingRecord: {
					__typename?: "SharingRecord";
					id: string;
					isPublic: boolean;
					userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
				} | null;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					} | null;
				} | null;
			};
		}>;
	};
};

export type TimelinePaymentListQueryVariables = Exact<{
	filters?: InputMaybe<Array<PaymentFilterInput> | PaymentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PaymentOrder>;
}>;

export type TimelinePaymentListQuery = {
	__typename?: "Query";
	paymentConnection: {
		__typename?: "PaymentConnection";
		edges: Array<{
			__typename?: "PaymentEdge";
			node: {
				__typename?: "Payment";
				id: string;
				issueDate: string;
				paymentMethod: PaymentPaymentMethod;
				paymentLineItems: Array<{
					__typename?: "PaymentLineItem";
					id: string;
					amount: number;
					invoice: {
						__typename?: "Invoice";
						id: string;
						contractInstallment: {
							__typename?: "ContractInstallment";
							id: string;
							contract: {
								__typename?: "Contract";
								id: string;
								student: {
									__typename?: "Student";
									id: string;
									person: { __typename?: "Person"; id: string; name: string; publicName: string };
								};
							};
						};
					};
				}>;
			};
		}>;
	};
};

export type TimelinePostListQueryVariables = Exact<{
	filters?: InputMaybe<Array<PostFilterInput> | PostFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PostOrder>;
}>;

export type TimelinePostListQuery = {
	__typename?: "Query";
	postConnection: {
		__typename?: "PostConnection";
		edges: Array<{
			__typename?: "PostEdge";
			node: {
				__typename?: "Post";
				id: string;
				createdAt: string;
				title: string;
				body: string;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					} | null;
				} | null;
				mediaAttachments: Array<{
					__typename?: "MediaAttachment";
					id: string;
					title: string;
					description: string;
					isFile: boolean;
					fileURL: string;
					fileKey: string;
					fileContentType: string;
					linkURL: string;
					taggedPeople: Array<{
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						user: { __typename?: "User"; id: string; isCurrent: boolean } | null;
					}>;
				}>;
				socialReactions: Array<{
					__typename?: "SocialReaction";
					id: string;
					author: {
						__typename?: "User";
						id: string;
						isCurrent: boolean;
						email: string;
						person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
					};
				}>;
				socialComments: Array<{
					__typename?: "SocialComment";
					id: string;
					body: string;
					createdAt: string;
					author: {
						__typename?: "User";
						id: string;
						isCurrent: boolean;
						email: string;
						person: {
							__typename?: "Person";
							id: string;
							name: string;
							publicName: string;
							imageURL: string;
							imageKey: string;
							imageContentType: string;
						} | null;
					};
				}>;
				sharingRecord: {
					__typename?: "SharingRecord";
					id: string;
					isPublic: boolean;
					userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
				} | null;
			};
		}>;
	};
};

export type TimelineSchoolAttendanceRecordListQueryVariables = Exact<{
	filters?: InputMaybe<Array<SchoolAttendanceRecordFilterInput> | SchoolAttendanceRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SchoolAttendanceRecordOrder>;
}>;

export type TimelineSchoolAttendanceRecordListQuery = {
	__typename?: "Query";
	schoolAttendanceRecordConnection: {
		__typename?: "SchoolAttendanceRecordConnection";
		edges: Array<{
			__typename?: "SchoolAttendanceRecordEdge";
			node: {
				__typename?: "SchoolAttendanceRecord";
				id: string;
				createdAt: string;
				arrivalTime: string | null;
				departureTime: string | null;
				attendanceStatus: {
					__typename?: "AttendanceStatus";
					id: string;
					name: string;
					code: string;
					description: string;
					indicatesAbsent: boolean;
					indicatesLateArrival: boolean;
					indicatesEarlyDeparture: boolean;
					indicatesExcused: boolean;
				};
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					} | null;
				} | null;
				student: {
					__typename?: "Student";
					id: string;
					person: { __typename?: "Person"; id: string; name: string; publicName: string };
				};
			};
		}>;
	};
};

export type TimelineStudentMedicalEventListQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentMedicalEventFilterInput> | StudentMedicalEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentMedicalEventOrder>;
}>;

export type TimelineStudentMedicalEventListQuery = {
	__typename?: "Query";
	studentMedicalEventConnection: {
		__typename?: "StudentMedicalEventConnection";
		edges: Array<{
			__typename?: "StudentMedicalEventEdge";
			node: {
				__typename?: "StudentMedicalEvent";
				id: string;
				checkInTime: string;
				description: string;
				student: {
					__typename?: "Student";
					id: string;
					person: { __typename?: "Person"; id: string; name: string; publicName: string };
				};
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: { __typename?: "Person"; id: string; name: string; publicName: string } | null;
				} | null;
			};
		}>;
	};
};

export type TimelineStudentNoteListQueryVariables = Exact<{
	filters?: InputMaybe<Array<StudentNoteFilterInput> | StudentNoteFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<StudentNoteOrder>;
}>;

export type TimelineStudentNoteListQuery = {
	__typename?: "Query";
	studentNoteConnection: {
		__typename?: "StudentNoteConnection";
		edges: Array<{
			__typename?: "StudentNoteEdge";
			node: {
				__typename?: "StudentNote";
				id: string;
				noteType: StudentNoteNoteType;
				createdAt: string;
				body: string;
				author: {
					__typename?: "User";
					id: string;
					email: string;
					isCurrent: boolean;
					person: {
						__typename?: "Person";
						id: string;
						name: string;
						publicName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					} | null;
				} | null;
				primaryStudents: Array<{
					__typename?: "Student";
					id: string;
					person: { __typename?: "Person"; id: string; name: string; publicName: string };
				}>;
			};
		}>;
	};
};

export type ViewerWithPermissionsQueryVariables = Exact<{ [key: string]: never }>;

export type ViewerWithPermissionsQuery = {
	__typename?: "Query";
	viewer: { __typename?: "User"; id: string; email: string; status: UserStatus };
	permissionConnection: {
		__typename?: "PermissionConnection";
		edges: Array<{ __typename?: "PermissionEdge"; node: { __typename?: "Permission"; name: string } }>;
	};
};

export const AcademicSubjectDetailFragmentDoc = gql`
	fragment AcademicSubjectDetail on AcademicSubject {
		id
		name
		color
	}
`;
export const AcademicSubjectNameAndColorFragmentDoc = gql`
	fragment AcademicSubjectNameAndColor on AcademicSubject {
		name
		color
	}
`;
export const AcademicYearNameFragmentDoc = gql`
	fragment AcademicYearName on AcademicYear {
		name
	}
`;
export const AcademicTermDetailFragmentDoc = gql`
	fragment AcademicTermDetail on AcademicTerm {
		id
		name
		imageURL
		imageKey
		imageContentType
		startDate
		endDate
		academicYear {
			id
			...AcademicYearName
		}
	}
	${AcademicYearNameFragmentDoc}
`;
export const AcademicTermNameFragmentDoc = gql`
	fragment AcademicTermName on AcademicTerm {
		name
	}
`;
export const AcademicYearDetailFragmentDoc = gql`
	fragment AcademicYearDetail on AcademicYear {
		id
		name
		academicTerms {
			id
			...AcademicTermName
		}
	}
	${AcademicTermNameFragmentDoc}
`;
export const CountryNameFragmentDoc = gql`
	fragment CountryName on Country {
		name
	}
`;
export const PersonNameFragmentDoc = gql`
	fragment PersonName on Person {
		name
		publicName
	}
`;
export const AddressDetailFragmentDoc = gql`
	fragment AddressDetail on Address {
		id
		name
		addressLine1
		addressLine2
		city
		postalCode
		stateOrProvince
		country {
			id
			...CountryName
		}
		people {
			id
			...PersonName
		}
	}
	${CountryNameFragmentDoc}
	${PersonNameFragmentDoc}
`;
export const AddressNameFragmentDoc = gql`
	fragment AddressName on Address {
		name
		addressLine1
	}
`;
export const PersonNameAndImageFragmentDoc = gql`
	fragment PersonNameAndImage on Person {
		name
		publicName
		imageURL
		imageKey
		imageContentType
	}
`;
export const UserNameAndImageFragmentDoc = gql`
	fragment UserNameAndImage on User {
		email
		isCurrent
		person {
			id
			...PersonNameAndImage
		}
	}
	${PersonNameAndImageFragmentDoc}
`;
export const ClassYearCategoryNameFragmentDoc = gql`
	fragment ClassYearCategoryName on ClassYearCategory {
		name
	}
`;
export const ClassYearNameFragmentDoc = gql`
	fragment ClassYearName on ClassYear {
		name
	}
`;
export const CourseNameFragmentDoc = gql`
	fragment CourseName on Course {
		name
	}
`;
export const CourseSectionNameFragmentDoc = gql`
	fragment CourseSectionName on CourseSection {
		namePrefix
		nameSuffix
		course {
			id
			...CourseName
		}
	}
	${CourseNameFragmentDoc}
`;
export const HomeRoomNameFragmentDoc = gql`
	fragment HomeRoomName on HomeRoom {
		name
	}
`;
export const HomeRoomSectionNameFragmentDoc = gql`
	fragment HomeRoomSectionName on HomeRoomSection {
		namePrefix
		nameSuffix
		homeRoom {
			id
			...HomeRoomName
		}
	}
	${HomeRoomNameFragmentDoc}
`;
export const UserGroupNameAndColorFragmentDoc = gql`
	fragment UserGroupNameAndColor on UserGroup {
		name
		color
	}
`;
export const UserNameFragmentDoc = gql`
	fragment UserName on User {
		email
		isCurrent
		person {
			id
			...PersonName
		}
	}
	${PersonNameFragmentDoc}
`;
export const SharingRecordDetailInParentFragmentDoc = gql`
	fragment SharingRecordDetailInParent on SharingRecord {
		id
		isPublic
		includeEmployees
		includeGuardians
		includeAllUsersOfPersonTypes
		classYearCategories {
			id
			...ClassYearCategoryName
		}
		classYears {
			id
			...ClassYearName
		}
		courseSections {
			id
			...CourseSectionName
		}
		homeRoomSections {
			id
			...HomeRoomSectionName
		}
		userGroups {
			id
			...UserGroupNameAndColor
		}
		users {
			id
			...UserName
		}
	}
	${ClassYearCategoryNameFragmentDoc}
	${ClassYearNameFragmentDoc}
	${CourseSectionNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${UserGroupNameAndColorFragmentDoc}
	${UserNameFragmentDoc}
`;
export const AnnouncementDetailFragmentDoc = gql`
	fragment AnnouncementDetail on Announcement {
		id
		title
		body
		startTime
		endTime
		author {
			id
			...UserNameAndImage
		}
		mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
			id
			displayOrder
			title
			description
			isFile
			fileURL
			fileKey
			fileContentType
			linkURL
			taggedPeople {
				id
				...PersonName
				user {
					id
					isCurrent
				}
			}
		}
		sharingRecord {
			...SharingRecordDetailInParent
		}
	}
	${UserNameAndImageFragmentDoc}
	${PersonNameFragmentDoc}
	${SharingRecordDetailInParentFragmentDoc}
`;
export const AttendanceStatusDetailFragmentDoc = gql`
	fragment AttendanceStatusDetail on AttendanceStatus {
		id
		name
		code
		description
		indicatesAbsent
		indicatesLateArrival
		indicatesEarlyDeparture
		indicatesExcused
		isDefault
		displayOrder
	}
`;
export const AttendanceStatusInfoFragmentDoc = gql`
	fragment AttendanceStatusInfo on AttendanceStatus {
		indicatesAbsent
		indicatesLateArrival
		indicatesEarlyDeparture
		indicatesExcused
	}
`;
export const InvoiceNameFragmentDoc = gql`
	fragment InvoiceName on Invoice {
		name
		dueDate
	}
`;
export const BillingAdjustmentDetailFragmentDoc = gql`
	fragment BillingAdjustmentDetail on BillingAdjustment {
		id
		issueDate
		amount
		notes
		invoice {
			id
			...InvoiceName
		}
	}
	${InvoiceNameFragmentDoc}
`;
export const BillingAdjustmentNameFragmentDoc = gql`
	fragment BillingAdjustmentName on BillingAdjustment {
		id
	}
`;
export const BuildingFloorNameFragmentDoc = gql`
	fragment BuildingFloorName on BuildingFloor {
		level
	}
`;
export const CampusNameFragmentDoc = gql`
	fragment CampusName on Campus {
		name
	}
`;
export const BuildingDetailFragmentDoc = gql`
	fragment BuildingDetail on Building {
		id
		name
		buildingFloors {
			id
			...BuildingFloorName
		}
		campus {
			id
			...CampusName
		}
	}
	${BuildingFloorNameFragmentDoc}
	${CampusNameFragmentDoc}
`;
export const BuildingNameFragmentDoc = gql`
	fragment BuildingName on Building {
		name
	}
`;
export const RoomNameFragmentDoc = gql`
	fragment RoomName on Room {
		name
	}
`;
export const BuildingFloorDetailFragmentDoc = gql`
	fragment BuildingFloorDetail on BuildingFloor {
		id
		level
		building {
			id
			...BuildingName
		}
		rooms {
			id
			...RoomName
		}
	}
	${BuildingNameFragmentDoc}
	${RoomNameFragmentDoc}
`;
export const CalendarEventTimingFragmentDoc = gql`
	fragment CalendarEventTiming on CalendarEvent {
		isAllDay
		startTime
		endTime
		startDate
		endDate
	}
`;
export const CalendarEventCalendarDetailFragmentDoc = gql`
	fragment CalendarEventCalendarDetail on CalendarEvent {
		id
		name
		description
		location
		imageURL
		imageKey
		imageContentType
		isAllDay
		startTime
		endTime
		startDate
		isMultiDay
		endDate
		allowsResponses
		createdAt
		author {
			id
			...UserNameAndImage
		}
		calendarEventResponses(filters: { author: { isCurrentEQ: true } }) {
			id
			response
			author {
				id
				...UserNameAndImage
			}
		}
		mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
			id
			displayOrder
			title
			description
			isFile
			fileURL
			fileKey
			fileContentType
			linkURL
			taggedPeople {
				id
				...PersonName
				user {
					id
					isCurrent
				}
			}
		}
		sharingRecord {
			id
			isPublic
		}
	}
	${UserNameAndImageFragmentDoc}
	${PersonNameFragmentDoc}
`;
export const CalendarEventDetailFragmentDoc = gql`
	fragment CalendarEventDetail on CalendarEvent {
		id
		name
		description
		location
		imageURL
		imageKey
		imageContentType
		isAllDay
		startTime
		endTime
		startDate
		isMultiDay
		endDate
		allowsResponses
		createdAt
		author {
			id
			...UserNameAndImage
		}
		calendarEventResponses(filters: { author: { isCurrentEQ: true } }) {
			id
			response
			author {
				id
				...UserNameAndImage
			}
		}
		mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
			id
			displayOrder
			title
			description
			isFile
			fileURL
			fileKey
			fileContentType
			linkURL
			taggedPeople {
				id
				...PersonName
				user {
					id
					isCurrent
				}
			}
		}
		sharingRecord {
			...SharingRecordDetailInParent
		}
	}
	${UserNameAndImageFragmentDoc}
	${PersonNameFragmentDoc}
	${SharingRecordDetailInParentFragmentDoc}
`;
export const CalendarEventNameFragmentDoc = gql`
	fragment CalendarEventName on CalendarEvent {
		name
	}
`;
export const CalendarEventResponseDetailFragmentDoc = gql`
	fragment CalendarEventResponseDetail on CalendarEventResponse {
		id
		response
		author {
			id
			...UserName
		}
		calendarEvent {
			id
			...CalendarEventName
		}
	}
	${UserNameFragmentDoc}
	${CalendarEventNameFragmentDoc}
`;
export const CalendarEventResponseNameFragmentDoc = gql`
	fragment CalendarEventResponseName on CalendarEventResponse {
		id
	}
`;
export const EmployeeNameFragmentDoc = gql`
	fragment EmployeeName on Employee {
		person {
			id
			...PersonName
		}
	}
	${PersonNameFragmentDoc}
`;
export const CampusDetailFragmentDoc = gql`
	fragment CampusDetail on Campus {
		id
		name
		phoneNumber
		addressLine1
		addressLine2
		city
		postalCode
		stateOrProvince
		buildings {
			id
			...BuildingName
		}
		country {
			id
			...CountryName
		}
		employees {
			id
			...EmployeeName
		}
	}
	${BuildingNameFragmentDoc}
	${CountryNameFragmentDoc}
	${EmployeeNameFragmentDoc}
`;
export const ClassYearDetailFragmentDoc = gql`
	fragment ClassYearDetail on ClassYear {
		id
		name
		yearsFromGraduation
		graduationYear
		classYearCategories {
			id
			...ClassYearCategoryName
		}
	}
	${ClassYearCategoryNameFragmentDoc}
`;
export const ClassYearCategoryDetailFragmentDoc = gql`
	fragment ClassYearCategoryDetail on ClassYearCategory {
		id
		name
		description
		classYears {
			id
			...ClassYearName
		}
	}
	${ClassYearNameFragmentDoc}
`;
export const StudentNameAndImageFragmentDoc = gql`
	fragment StudentNameAndImage on Student {
		person {
			id
			...PersonNameAndImage
		}
	}
	${PersonNameAndImageFragmentDoc}
`;
export const ServiceNameFragmentDoc = gql`
	fragment ServiceName on Service {
		name
	}
`;
export const DiscountNameFragmentDoc = gql`
	fragment DiscountName on Discount {
		name
	}
`;
export const ContractDetailFragmentDoc = gql`
	fragment ContractDetail on Contract {
		id
		name
		status
		isApproved
		isFinalized
		effectiveDate
		dateVoided
		fileURL
		fileKey
		fileContentType
		signedFileURL
		signedFileKey
		signedFileContentType
		approvingUser {
			id
			...UserName
		}
		academicTerms {
			id
			...AcademicTermName
		}
		student {
			id
			...StudentNameAndImage
		}
		contractLineItems(order: { field: DISPLAY_ORDER, direction: ASC }) {
			id
			displayOrder
			isDiscount
			amount
			dateAdded
			dateRemoved
			service {
				id
				...ServiceName
			}
			discount {
				id
				...DiscountName
			}
			childContractLineItems(order: { field: DISPLAY_ORDER, direction: ASC }) {
				id
				displayOrder
				isDiscount
				amount
				service {
					id
					...ServiceName
				}
				discount {
					id
					...DiscountName
				}
			}
		}
		contractInstallments(order: { field: DUE_DATE, direction: ASC }) {
			id
			dueDate
			portion
			invoices {
				id
				paymentLineItems {
					id
					amount
				}
				billingAdjustments {
					id
					amount
				}
			}
		}
	}
	${UserNameFragmentDoc}
	${AcademicTermNameFragmentDoc}
	${StudentNameAndImageFragmentDoc}
	${ServiceNameFragmentDoc}
	${DiscountNameFragmentDoc}
`;
export const ContractInstallmentDetailFragmentDoc = gql`
	fragment ContractInstallmentDetail on ContractInstallment {
		id
		dueDate
		portion
		contract {
			...ContractDetail
		}
		invoices(order: { field: ISSUE_DATE, direction: ASC }) {
			id
			name
			issueDate
			dueDate
			status
			invoiceLineItems(order: { field: DISPLAY_ORDER, direction: ASC }) {
				id
				amount
				contractLineItem {
					id
					service {
						id
						...ServiceName
					}
					discount {
						id
						...DiscountName
					}
				}
			}
			paymentLineItems {
				id
				amount
				localAmount
				payment {
					id
					issueDate
					paymentMethod
					isInLocalCurrency
					localCurrency
				}
			}
			billingAdjustments {
				id
				amount
			}
		}
	}
	${ContractDetailFragmentDoc}
	${ServiceNameFragmentDoc}
	${DiscountNameFragmentDoc}
`;
export const ContractNameFragmentDoc = gql`
	fragment ContractName on Contract {
		name
	}
`;
export const ContractLineItemNameFragmentDoc = gql`
	fragment ContractLineItemName on ContractLineItem {
		service {
			id
			...ServiceName
		}
		discount {
			id
			...DiscountName
		}
	}
	${ServiceNameFragmentDoc}
	${DiscountNameFragmentDoc}
`;
export const ContractLineItemDetailFragmentDoc = gql`
	fragment ContractLineItemDetail on ContractLineItem {
		id
		displayOrder
		description
		isDiscount
		amount
		dateAdded
		dateRemoved
		contract {
			id
			...ContractName
		}
		discount {
			id
			...DiscountName
		}
		parentContractLineItem {
			id
			...ContractLineItemName
		}
		service {
			id
			...ServiceName
		}
	}
	${ContractNameFragmentDoc}
	${DiscountNameFragmentDoc}
	${ContractLineItemNameFragmentDoc}
	${ServiceNameFragmentDoc}
`;
export const ContractLineItemPricingFragmentDoc = gql`
	fragment ContractLineItemPricing on ContractLineItem {
		isDiscount
		amount
		childContractLineItems {
			isDiscount
			amount
		}
	}
`;
export const EnrollmentApplicationStudentNameFragmentDoc = gql`
	fragment EnrollmentApplicationStudentName on EnrollmentApplicationStudent {
		name
	}
`;
export const CountryDetailFragmentDoc = gql`
	fragment CountryDetail on Country {
		id
		name
		enrollmentApplicationStudents {
			id
			...EnrollmentApplicationStudentName
		}
		people {
			id
			...PersonName
		}
	}
	${EnrollmentApplicationStudentNameFragmentDoc}
	${PersonNameFragmentDoc}
`;
export const AcademicSubjectNameFragmentDoc = gql`
	fragment AcademicSubjectName on AcademicSubject {
		name
	}
`;
export const CourseDetailFragmentDoc = gql`
	fragment CourseDetail on Course {
		id
		name
		description
		academicSubject {
			id
			...AcademicSubjectName
		}
		classYears {
			id
			...ClassYearName
		}
	}
	${AcademicSubjectNameFragmentDoc}
	${ClassYearNameFragmentDoc}
`;
export const CourseAssessmentCategoryNameFragmentDoc = gql`
	fragment CourseAssessmentCategoryName on CourseAssessmentCategory {
		name
	}
`;
export const CourseAssessmentDetailFragmentDoc = gql`
	fragment CourseAssessmentDetail on CourseAssessment {
		id
		name
		description
		totalPoints
		author {
			id
			...UserName
		}
		courseAssessmentCategory {
			id
			...CourseAssessmentCategoryName
		}
		courseAssessmentTimings {
			id
			assignOn
			dueOn
			courseSection {
				id
				...CourseSectionName
			}
		}
		mediaAttachments {
			id
			title
			description
			isFile
			fileURL
			fileKey
			fileContentType
			linkURL
		}
	}
	${UserNameFragmentDoc}
	${CourseAssessmentCategoryNameFragmentDoc}
	${CourseSectionNameFragmentDoc}
`;
export const CourseAssessmentCategoryDetailFragmentDoc = gql`
	fragment CourseAssessmentCategoryDetail on CourseAssessmentCategory {
		id
		name
	}
`;
export const CourseAssessmentCategoryMarkPortionDetailFragmentDoc = gql`
	fragment CourseAssessmentCategoryMarkPortionDetail on CourseAssessmentCategoryMarkPortion {
		id
		markPortion
		courseAssessmentCategory {
			id
			...CourseAssessmentCategoryName
		}
		courseSection {
			id
			...CourseSectionName
		}
	}
	${CourseAssessmentCategoryNameFragmentDoc}
	${CourseSectionNameFragmentDoc}
`;
export const CourseAssessmentCategoryMarkPortionNameFragmentDoc = gql`
	fragment CourseAssessmentCategoryMarkPortionName on CourseAssessmentCategoryMarkPortion {
		id
	}
`;
export const CourseAssessmentNameFragmentDoc = gql`
	fragment CourseAssessmentName on CourseAssessment {
		name
	}
`;
export const StudentNameFragmentDoc = gql`
	fragment StudentName on Student {
		person {
			id
			...PersonName
		}
	}
	${PersonNameFragmentDoc}
`;
export const CourseAssessmentMarkDetailFragmentDoc = gql`
	fragment CourseAssessmentMarkDetail on CourseAssessmentMark {
		id
		points
		isExcused
		wasLate
		notes
		author {
			id
			...UserName
		}
		courseAssessment {
			id
			...CourseAssessmentName
		}
		student {
			id
			...StudentName
		}
	}
	${UserNameFragmentDoc}
	${CourseAssessmentNameFragmentDoc}
	${StudentNameFragmentDoc}
`;
export const CourseAssessmentMarkNameFragmentDoc = gql`
	fragment CourseAssessmentMarkName on CourseAssessmentMark {
		id
	}
`;
export const CourseAssessmentSubmissionDetailFragmentDoc = gql`
	fragment CourseAssessmentSubmissionDetail on CourseAssessmentSubmission {
		id
		createdAt
		body
		submissionDate
		author {
			id
			...UserName
		}
		courseAssessment {
			id
			...CourseAssessmentName
		}
		student {
			id
			...StudentName
		}
	}
	${UserNameFragmentDoc}
	${CourseAssessmentNameFragmentDoc}
	${StudentNameFragmentDoc}
`;
export const CourseAssessmentTimingDetailFragmentDoc = gql`
	fragment CourseAssessmentTimingDetail on CourseAssessmentTiming {
		id
		assignOn
		dueOn
		courseAssessment {
			id
			...CourseAssessmentName
		}
		courseSection {
			id
			...CourseSectionName
		}
	}
	${CourseAssessmentNameFragmentDoc}
	${CourseSectionNameFragmentDoc}
`;
export const CourseAssessmentTimingNameFragmentDoc = gql`
	fragment CourseAssessmentTimingName on CourseAssessmentTiming {
		id
	}
`;
export const AttendanceStatusNameFragmentDoc = gql`
	fragment AttendanceStatusName on AttendanceStatus {
		name
		code
	}
`;
export const CourseSectionPeriodNameFragmentDoc = gql`
	fragment CourseSectionPeriodName on CourseSectionPeriod {
		id
	}
`;
export const CourseAttendanceRecordDetailFragmentDoc = gql`
	fragment CourseAttendanceRecordDetail on CourseAttendanceRecord {
		id
		createdAt
		attendanceDate
		notes
		attendanceStatus {
			id
			...AttendanceStatusName
		}
		author {
			id
			...UserName
		}
		courseSectionPeriod {
			id
			...CourseSectionPeriodName
		}
		student {
			id
			...StudentName
		}
	}
	${AttendanceStatusNameFragmentDoc}
	${UserNameFragmentDoc}
	${CourseSectionPeriodNameFragmentDoc}
	${StudentNameFragmentDoc}
`;
export const CourseAttendanceRecordNameFragmentDoc = gql`
	fragment CourseAttendanceRecordName on CourseAttendanceRecord {
		id
	}
`;
export const EmployeeNameAndImageFragmentDoc = gql`
	fragment EmployeeNameAndImage on Employee {
		person {
			id
			...PersonNameAndImage
		}
	}
	${PersonNameAndImageFragmentDoc}
`;
export const CourseSectionDetailFragmentDoc = gql`
	fragment CourseSectionDetail on CourseSection {
		id
		namePrefix
		nameSuffix
		academicTerm {
			id
			...AcademicTermName
			startDate
			endDate
		}
		course {
			id
			...CourseName
			academicSubject {
				id
				color
			}
			classYears(order: { field: YEARS_FROM_GRADUATION, direction: DESC }) {
				id
				...ClassYearName
			}
		}
		homeRoomSection {
			id
			...HomeRoomSectionName
		}
		studentCourseSectionEnrollments {
			id
			lateStartDate
			earlyEndDate
			student {
				id
				...StudentNameAndImage
				graduationYear
				yearsFromGraduation
			}
		}
		teacherCourseSectionEnrollments {
			id
			lateStartDate
			earlyEndDate
			teacher {
				id
				...EmployeeNameAndImage
				role
				jobTitle
			}
		}
	}
	${AcademicTermNameFragmentDoc}
	${CourseNameFragmentDoc}
	${ClassYearNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${StudentNameAndImageFragmentDoc}
	${EmployeeNameAndImageFragmentDoc}
`;
export const CourseSectionPeriodDetailFragmentDoc = gql`
	fragment CourseSectionPeriodDetail on CourseSectionPeriod {
		id
		dayOfWeek
		startTimeMinutes
		endTimeMinutes
		isActive
		courseSection {
			id
			...CourseSectionName
			academicTerm {
				id
				...AcademicTermName
				startDate
				endDate
			}
		}
		room {
			id
			...RoomName
		}
	}
	${CourseSectionNameFragmentDoc}
	${AcademicTermNameFragmentDoc}
	${RoomNameFragmentDoc}
`;
export const DiscountDetailFragmentDoc = gql`
	fragment DiscountDetail on Discount {
		id
		name
		description
		isActive
		isPercentageAmount
		flatAmount
		percentageAmount
	}
`;
export const EmailAddressDetailFragmentDoc = gql`
	fragment EmailAddressDetail on EmailAddress {
		id
		name
		emailAddress
		isPrimary
		person {
			id
			...PersonName
		}
	}
	${PersonNameFragmentDoc}
`;
export const LanguageNameFragmentDoc = gql`
	fragment LanguageName on Language {
		name
	}
`;
export const AddressInformationFragmentDoc = gql`
	fragment AddressInformation on Address {
		name
		addressLine1
		addressLine2
		city
		postalCode
		stateOrProvince
		country {
			id
			...CountryName
		}
	}
	${CountryNameFragmentDoc}
`;
export const EmailAddressNameFragmentDoc = gql`
	fragment EmailAddressName on EmailAddress {
		name
		emailAddress
	}
`;
export const GuardianNameFragmentDoc = gql`
	fragment GuardianName on Guardian {
		person {
			id
			...PersonName
		}
	}
	${PersonNameFragmentDoc}
`;
export const PhoneNumberNameFragmentDoc = gql`
	fragment PhoneNumberName on PhoneNumber {
		name
		phoneNumber
	}
`;
export const PermissionGroupNameFragmentDoc = gql`
	fragment PermissionGroupName on PermissionGroup {
		name
	}
`;
export const UserGroupNameFragmentDoc = gql`
	fragment UserGroupName on UserGroup {
		name
	}
`;
export const UserDetailFragmentDoc = gql`
	fragment UserDetail on User {
		id
		email
		status
		passwordUpdatedAt
		isCurrent
		timeZoneName
		externalNotificationFrequency
		permissionGroups {
			id
			...PermissionGroupName
		}
		person {
			id
			...PersonName
			employee {
				id
			}
			guardian {
				id
			}
			student {
				id
			}
		}
		userGroups {
			id
			...UserGroupName
		}
	}
	${PermissionGroupNameFragmentDoc}
	${PersonNameFragmentDoc}
	${UserGroupNameFragmentDoc}
`;
export const PersonDetailFragmentDoc = gql`
	fragment PersonDetail on Person {
		id
		name
		publicName
		givenName
		middleName
		familyName
		nameOrder
		nickname
		alternateNames
		publicNameFormat
		imageURL
		imageKey
		imageContentType
		gender
		dateOfBirth
		nationalities {
			id
			...CountryName
		}
		languages {
			id
			...LanguageName
		}
		englishLanguageFluency
		occupation
		nationalIdentificationNumber
		governmentDocumentSeries
		governmentDocumentNumber
		governmentDocumentIssuedBy
		addresses {
			id
			...AddressInformation
		}
		emailAddresses(order: { field: IS_PRIMARY, direction: DESC }) {
			id
			...EmailAddressName
			emailAddress
			isPrimary
		}
		employee {
			id
			...EmployeeName
		}
		guardian {
			id
			...GuardianName
		}
		phoneNumbers(order: { field: IS_PRIMARY, direction: DESC }) {
			id
			...PhoneNumberName
			phoneNumber
			isPrimary
		}
		student {
			id
			...StudentName
		}
		user {
			id
			...UserDetail
		}
	}
	${CountryNameFragmentDoc}
	${LanguageNameFragmentDoc}
	${AddressInformationFragmentDoc}
	${EmailAddressNameFragmentDoc}
	${EmployeeNameFragmentDoc}
	${GuardianNameFragmentDoc}
	${PhoneNumberNameFragmentDoc}
	${StudentNameFragmentDoc}
	${UserDetailFragmentDoc}
`;
export const EmployeeDetailFragmentDoc = gql`
	fragment EmployeeDetail on Employee {
		id
		workEmailAddress
		jobTitle
		role
		startDate
		endDate
		bio
		campuses {
			id
			...CampusName
		}
		classYearCategories {
			id
			...ClassYearCategoryName
		}
		classYears {
			id
			...ClassYearName
		}
		person {
			...PersonDetail
		}
	}
	${CampusNameFragmentDoc}
	${ClassYearCategoryNameFragmentDoc}
	${ClassYearNameFragmentDoc}
	${PersonDetailFragmentDoc}
`;
export const EmployeeNameDescriptionAndImageFragmentDoc = gql`
	fragment EmployeeNameDescriptionAndImage on Employee {
		role
		jobTitle
		person {
			id
			...PersonNameAndImage
		}
	}
	${PersonNameAndImageFragmentDoc}
`;
export const EnrollmentApplicationDetailFragmentDoc = gql`
	fragment EnrollmentApplicationDetail on EnrollmentApplication {
		id
		createdAt
		wasInquirySubmitted
		inquirySubmittedAt
		wasApplicationSubmitted
		applicationSubmittedAt
		source
		sourceDetails
		doesConsentToCorrespondence
		doesConsentToDataUse
		doesConsentToDataProtectionPolicy
		notes
		signatureName
		signatureDate
	}
`;
export const EnrollmentApplicationNameFragmentDoc = gql`
	fragment EnrollmentApplicationName on EnrollmentApplication {
		id
	}
`;
export const EnrollmentApplicationGuardianNameFragmentDoc = gql`
	fragment EnrollmentApplicationGuardianName on EnrollmentApplicationGuardian {
		name
	}
`;
export const EnrollmentApplicationGuardianDetailFragmentDoc = gql`
	fragment EnrollmentApplicationGuardianDetail on EnrollmentApplicationGuardian {
		id
		name
		givenName
		middleName
		familyName
		nameOrder
		dateOfBirth
		gender
		relationshipType
		relationshipStatus
		emailAddress
		phoneNumber
		addressLine1
		addressLine2
		addressCity
		addressPostalCode
		addressStateOrProvince
		isPrimary
		isFinancialContact
		isEmergencyContact
		isAuthorizedForPickup
		livesWithStudent
		isPrimaryOnApplication
		addressCountry {
			id
			...CountryName
		}
		enrollmentApplication {
			id
			...EnrollmentApplicationName
		}
		guardian {
			id
			...GuardianName
		}
		targetAddressGuardian {
			id
			...EnrollmentApplicationGuardianName
		}
	}
	${CountryNameFragmentDoc}
	${EnrollmentApplicationNameFragmentDoc}
	${GuardianNameFragmentDoc}
	${EnrollmentApplicationGuardianNameFragmentDoc}
`;
export const EnrollmentApplicationGuardianAddressInformationFragmentDoc = gql`
	fragment EnrollmentApplicationGuardianAddressInformation on EnrollmentApplicationGuardian {
		addressLine1
		addressLine2
		addressCity
		addressPostalCode
		addressStateOrProvince
		addressCountry {
			id
			...CountryName
		}
	}
	${CountryNameFragmentDoc}
`;
export const EnrollmentApplicationStudentDetailFragmentDoc = gql`
	fragment EnrollmentApplicationStudentDetail on EnrollmentApplicationStudent {
		id
		imageURL
		imageKey
		imageContentType
		name
		givenName
		middleName
		familyName
		nameOrder
		dateOfBirth
		gender
		englishLanguageFluency
		questionnaireActivities
		questionnaireHasPsychTreatment
		questionnairePsychTreatmentDescription
		questionnaireHasSpecialNeeds
		questionnaireSpecialNeedsDescription
		questionnaireHasBehaviors
		questionnaireBehaviorsDescription
		questionnaireDescription
		questionnaireAdditionalInformation
		academicYear {
			id
			...AcademicYearName
		}
		classYear {
			id
			...ClassYearName
		}
		currentClassYear {
			id
			...ClassYearName
		}
		enrollmentApplication {
			id
			...EnrollmentApplicationName
		}
		languages {
			id
			...LanguageName
		}
		nationalities {
			id
			...CountryName
		}
		student {
			id
			...StudentName
		}
	}
	${AcademicYearNameFragmentDoc}
	${ClassYearNameFragmentDoc}
	${EnrollmentApplicationNameFragmentDoc}
	${LanguageNameFragmentDoc}
	${CountryNameFragmentDoc}
	${StudentNameFragmentDoc}
`;
export const EnrollmentApplicationStudentNameAndImageFragmentDoc = gql`
	fragment EnrollmentApplicationStudentNameAndImage on EnrollmentApplicationStudent {
		name
		imageKey
		imageContentType
		imageURL
	}
`;
export const EnrollmentApplicationStudentSchoolDetailFragmentDoc = gql`
	fragment EnrollmentApplicationStudentSchoolDetail on EnrollmentApplicationStudentSchool {
		id
		name
		city
		startDate
		endDate
		country {
			id
			...CountryName
		}
		enrollmentApplicationStudent {
			id
			...EnrollmentApplicationStudentName
		}
	}
	${CountryNameFragmentDoc}
	${EnrollmentApplicationStudentNameFragmentDoc}
`;
export const EnrollmentApplicationStudentSchoolNameFragmentDoc = gql`
	fragment EnrollmentApplicationStudentSchoolName on EnrollmentApplicationStudentSchool {
		name
	}
`;
export const GuardianDetailFragmentDoc = gql`
	fragment GuardianDetail on Guardian {
		id
		relationshipStatus
		person {
			...PersonDetail
		}
		relationships(order: { field: IS_PRIMARY, direction: DESC }) {
			id
			relationshipType
			isPrimary
			isEmergencyContact
			isAuthorizedForPickup
			isFinancialContact
			livesWithStudent
			hasCustody
			student {
				id
				graduationYear
				yearsFromGraduation
				person {
					id
					...PersonNameAndImage
				}
			}
		}
	}
	${PersonDetailFragmentDoc}
	${PersonNameAndImageFragmentDoc}
`;
export const GuardianNameAndImageFragmentDoc = gql`
	fragment GuardianNameAndImage on Guardian {
		person {
			id
			...PersonNameAndImage
		}
	}
	${PersonNameAndImageFragmentDoc}
`;
export const HomeRoomDetailFragmentDoc = gql`
	fragment HomeRoomDetail on HomeRoom {
		id
		name
		description
		classYear {
			id
			...ClassYearName
		}
	}
	${ClassYearNameFragmentDoc}
`;
export const HomeRoomSectionDetailFragmentDoc = gql`
	fragment HomeRoomSectionDetail on HomeRoomSection {
		id
		namePrefix
		nameSuffix
		academicTerm {
			id
			...AcademicTermName
			startDate
			endDate
		}
		homeRoom {
			id
			...HomeRoomName
		}
		room {
			id
			...RoomName
		}
		studentHomeRoomSectionEnrollments {
			id
			lateStartDate
			earlyEndDate
			student {
				id
				...StudentNameAndImage
				graduationYear
				yearsFromGraduation
			}
		}
		teacherHomeRoomSectionEnrollments {
			id
			lateStartDate
			earlyEndDate
			teacher {
				id
				...EmployeeNameAndImage
				role
				jobTitle
			}
		}
	}
	${AcademicTermNameFragmentDoc}
	${HomeRoomNameFragmentDoc}
	${RoomNameFragmentDoc}
	${StudentNameAndImageFragmentDoc}
	${EmployeeNameAndImageFragmentDoc}
`;
export const ContractInstallmentNameFragmentDoc = gql`
	fragment ContractInstallmentName on ContractInstallment {
		id
	}
`;
export const InvoiceDetailFragmentDoc = gql`
	fragment InvoiceDetail on Invoice {
		id
		name
		status
		issueDate
		dueDate
		description
		contractInstallment {
			id
			...ContractInstallmentName
		}
	}
	${ContractInstallmentNameFragmentDoc}
`;
export const InvoiceLineItemDetailFragmentDoc = gql`
	fragment InvoiceLineItemDetail on InvoiceLineItem {
		id
		displayOrder
		amount
		contractLineItem {
			id
			...ContractLineItemName
		}
		invoice {
			id
			...InvoiceName
		}
	}
	${ContractLineItemNameFragmentDoc}
	${InvoiceNameFragmentDoc}
`;
export const InvoiceLineItemNameFragmentDoc = gql`
	fragment InvoiceLineItemName on InvoiceLineItem {
		contractLineItem {
			id
			...ContractLineItemName
		}
	}
	${ContractLineItemNameFragmentDoc}
`;
export const LanguageDetailFragmentDoc = gql`
	fragment LanguageDetail on Language {
		id
		name
		enrollmentApplicationStudents {
			id
			...EnrollmentApplicationStudentName
		}
		people {
			id
			...PersonName
		}
	}
	${EnrollmentApplicationStudentNameFragmentDoc}
	${PersonNameFragmentDoc}
`;
export const LearningObjectiveCategoryNameFragmentDoc = gql`
	fragment LearningObjectiveCategoryName on LearningObjectiveCategory {
		name
	}
`;
export const LearningObjectiveDetailFragmentDoc = gql`
	fragment LearningObjectiveDetail on LearningObjective {
		id
		name
		description
		learningObjectiveCategory {
			id
			...LearningObjectiveCategoryName
		}
	}
	${LearningObjectiveCategoryNameFragmentDoc}
`;
export const MarkingSystemNameFragmentDoc = gql`
	fragment MarkingSystemName on MarkingSystem {
		name
	}
`;
export const LearningObjectiveCategoryDetailFragmentDoc = gql`
	fragment LearningObjectiveCategoryDetail on LearningObjectiveCategory {
		id
		name
		markingSystem {
			id
			...MarkingSystemName
		}
	}
	${MarkingSystemNameFragmentDoc}
`;
export const SessionNameFragmentDoc = gql`
	fragment SessionName on Session {
		id
	}
`;
export const LoginRecordDetailFragmentDoc = gql`
	fragment LoginRecordDetail on LoginRecord {
		id
		createdAt
		userEmail
		wasBlocked
		wasSuccessful
		isTrusted
		session {
			id
			...SessionName
		}
		user {
			id
			...UserName
		}
	}
	${SessionNameFragmentDoc}
	${UserNameFragmentDoc}
`;
export const MFAFactorDetailFragmentDoc = gql`
	fragment MFAFactorDetail on MFAFactor {
		id
		createdAt
		count
		isApp
		email
		sms
		isVerified
		user {
			id
			...UserName
		}
	}
	${UserNameFragmentDoc}
`;
export const MFAFactorNameFragmentDoc = gql`
	fragment MFAFactorName on MFAFactor {
		email
	}
`;
export const MFAInvalidOTPAttemptDetailFragmentDoc = gql`
	fragment MFAInvalidOTPAttemptDetail on MFAInvalidOTPAttempt {
		id
		createdAt
		session {
			id
			...SessionName
		}
		user {
			id
			...UserName
		}
	}
	${SessionNameFragmentDoc}
	${UserNameFragmentDoc}
`;
export const MarkValueDetailFragmentDoc = gql`
	fragment MarkValueDetail on MarkValue {
		id
		name
		shortName
		value
		isNull
		description
		markingSystem {
			id
			...MarkingSystemName
		}
	}
	${MarkingSystemNameFragmentDoc}
`;
export const MarkingSystemDetailFragmentDoc = gql`
	fragment MarkingSystemDetail on MarkingSystem {
		id
		name
		description
	}
`;
export const AnnouncementNameFragmentDoc = gql`
	fragment AnnouncementName on Announcement {
		title
	}
`;
export const CourseAssessmentSubmissionNameFragmentDoc = gql`
	fragment CourseAssessmentSubmissionName on CourseAssessmentSubmission {
		id
	}
`;
export const MessageNameFragmentDoc = gql`
	fragment MessageName on Message {
		id
	}
`;
export const PostNameFragmentDoc = gql`
	fragment PostName on Post {
		title
	}
`;
export const StudentMedicalEventNameFragmentDoc = gql`
	fragment StudentMedicalEventName on StudentMedicalEvent {
		id
	}
`;
export const StudentNoteNameFragmentDoc = gql`
	fragment StudentNoteName on StudentNote {
		id
	}
`;
export const MediaAttachmentDetailFragmentDoc = gql`
	fragment MediaAttachmentDetail on MediaAttachment {
		id
		displayOrder
		title
		description
		isFile
		fileURL
		fileKey
		fileContentType
		linkURL
		announcement {
			id
			...AnnouncementName
		}
		calendarEvent {
			id
			...CalendarEventName
		}
		courseAssessment {
			id
			...CourseAssessmentName
		}
		courseAssessmentSubmission {
			id
			...CourseAssessmentSubmissionName
		}
		message {
			id
			...MessageName
		}
		post {
			id
			...PostName
		}
		studentMedicalEvent {
			id
			...StudentMedicalEventName
		}
		studentNote {
			id
			...StudentNoteName
		}
		taggedPeople {
			id
			...PersonName
		}
	}
	${AnnouncementNameFragmentDoc}
	${CalendarEventNameFragmentDoc}
	${CourseAssessmentNameFragmentDoc}
	${CourseAssessmentSubmissionNameFragmentDoc}
	${MessageNameFragmentDoc}
	${PostNameFragmentDoc}
	${StudentMedicalEventNameFragmentDoc}
	${StudentNoteNameFragmentDoc}
	${PersonNameFragmentDoc}
`;
export const MedicalConditionDetailFragmentDoc = gql`
	fragment MedicalConditionDetail on MedicalCondition {
		id
		name
		conditionType
		description
	}
`;
export const MedicationDetailFragmentDoc = gql`
	fragment MedicationDetail on Medication {
		id
		name
		isPrescription
		description
	}
`;
export const MessageGroupNameFragmentDoc = gql`
	fragment MessageGroupName on MessageGroup {
		customName
		users {
			id
			...UserName
		}
		userGroups {
			id
			...UserGroupName
		}
	}
	${UserNameFragmentDoc}
	${UserGroupNameFragmentDoc}
`;
export const MessageDetailFragmentDoc = gql`
	fragment MessageDetail on Message {
		id
		createdAt
		body
		lastEditedAt
		isRemoved
		author {
			id
			...UserName
		}
		messageGroup {
			id
			...MessageGroupName
		}
	}
	${UserNameFragmentDoc}
	${MessageGroupNameFragmentDoc}
`;
export const StudentNameDescriptionAndImageFragmentDoc = gql`
	fragment StudentNameDescriptionAndImage on Student {
		graduationYear
		yearsFromGraduation
		person {
			id
			...PersonNameAndImage
		}
	}
	${PersonNameAndImageFragmentDoc}
`;
export const MessageInMessageGroupFragmentDoc = gql`
	fragment MessageInMessageGroup on Message {
		id
		createdAt
		body
		lastEditedAt
		isRemoved
		author {
			id
			email
			isCurrent
			person {
				id
				...PersonNameAndImage
				employee {
					id
					role
				}
			}
		}
		mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
			id
			title
			description
			isFile
			fileURL
			fileKey
			fileContentType
			linkURL
		}
		messageTopic {
			id
			students {
				id
				...StudentNameDescriptionAndImage
			}
		}
	}
	${PersonNameAndImageFragmentDoc}
	${StudentNameDescriptionAndImageFragmentDoc}
`;
export const MessageAvailabilityPeriodDetailFragmentDoc = gql`
	fragment MessageAvailabilityPeriodDetail on MessageAvailabilityPeriod {
		id
		dayOfWeek
		startTimeMinutes
		endTimeMinutes
		user {
			id
			...UserName
		}
	}
	${UserNameFragmentDoc}
`;
export const MessageAvailabilityPeriodNameFragmentDoc = gql`
	fragment MessageAvailabilityPeriodName on MessageAvailabilityPeriod {
		id
	}
`;
export const MessageAvailabilityPeriodTimingFragmentDoc = gql`
	fragment MessageAvailabilityPeriodTiming on MessageAvailabilityPeriod {
		dayOfWeek
		startTimeMinutes
		endTimeMinutes
	}
`;
export const MessageGroupUserFragmentDoc = gql`
	fragment MessageGroupUser on User {
		id
		email
		isCurrent
		person {
			id
			...PersonNameAndImage
			employee {
				id
				jobTitle
			}
			guardian {
				id
			}
		}
		messageAvailabilityPeriods(order: { field: DAY_OF_WEEK, direction: ASC }) {
			id
			...MessageAvailabilityPeriodTiming
		}
	}
	${PersonNameAndImageFragmentDoc}
	${MessageAvailabilityPeriodTimingFragmentDoc}
`;
export const MessageGroupDetailFragmentDoc = gql`
	fragment MessageGroupDetail on MessageGroup {
		id
		customName
		isOneOnOne
		userGroups {
			id
			...UserGroupNameAndColor
		}
		users {
			...MessageGroupUser
		}
	}
	${UserGroupNameAndColorFragmentDoc}
	${MessageGroupUserFragmentDoc}
`;
export const MessageGroupNameAndImageFragmentDoc = gql`
	fragment MessageGroupNameAndImage on MessageGroup {
		customName
		users {
			id
			...UserNameAndImage
		}
		userGroups {
			id
			...UserGroupNameAndColor
		}
	}
	${UserNameAndImageFragmentDoc}
	${UserGroupNameAndColorFragmentDoc}
`;
export const MessageGroupNameImageAndAvailabilityFragmentDoc = gql`
	fragment MessageGroupNameImageAndAvailability on MessageGroup {
		customName
		users {
			id
			...UserNameAndImage
			messageAvailabilityPeriods {
				id
				dayOfWeek
				startTimeMinutes
				endTimeMinutes
			}
		}
		userGroups {
			id
			...UserGroupNameAndColor
		}
	}
	${UserNameAndImageFragmentDoc}
	${UserGroupNameAndColorFragmentDoc}
`;
export const UserForMessagesFragmentDoc = gql`
	fragment UserForMessages on User {
		id
		email
		isCurrent
		person {
			id
			...PersonNameAndImage
			employee {
				id
				role
				jobTitle
			}
			guardian {
				id
				relationships {
					id
					studentID
				}
			}
		}
		messageAvailabilityPeriods(order: { field: DAY_OF_WEEK, direction: ASC }) {
			id
			...MessageAvailabilityPeriodTiming
		}
	}
	${PersonNameAndImageFragmentDoc}
	${MessageAvailabilityPeriodTimingFragmentDoc}
`;
export const MessageGroupArchivePointDetailFragmentDoc = gql`
	fragment MessageGroupArchivePointDetail on MessageGroupArchivePoint {
		id
		createdAt
		author {
			id
			...UserName
		}
		messageGroup {
			id
			...MessageGroupName
		}
	}
	${UserNameFragmentDoc}
	${MessageGroupNameFragmentDoc}
`;
export const MessageGroupArchivePointNameFragmentDoc = gql`
	fragment MessageGroupArchivePointName on MessageGroupArchivePoint {
		id
	}
`;
export const MessageTopicDetailFragmentDoc = gql`
	fragment MessageTopicDetail on MessageTopic {
		id
		name
		message {
			id
			...MessageName
		}
		students {
			id
			...StudentName
		}
	}
	${MessageNameFragmentDoc}
	${StudentNameFragmentDoc}
`;
export const MessageTopicNameFragmentDoc = gql`
	fragment MessageTopicName on MessageTopic {
		name
	}
`;
export const NewsletterDetailFragmentDoc = gql`
	fragment NewsletterDetail on Newsletter {
		id
		title
		imageURL
		imageKey
		imageContentType
		body
		releaseAt
		author {
			id
			...UserNameAndImage
		}
		sharingRecord {
			...SharingRecordDetailInParent
		}
	}
	${UserNameAndImageFragmentDoc}
	${SharingRecordDetailInParentFragmentDoc}
`;
export const NewsletterDisplayListItemFragmentDoc = gql`
	fragment NewsletterDisplayListItem on Newsletter {
		id
		title
		imageURL
		imageKey
		imageContentType
		body
		releaseAt
		author {
			id
			...UserNameAndImage
		}
	}
	${UserNameAndImageFragmentDoc}
`;
export const PaymentDetailFragmentDoc = gql`
	fragment PaymentDetail on Payment {
		id
		isCustomPayer
		customPayerName
		issueDate
		paymentMethod
		isInLocalCurrency
		localCurrency
		notes
		guardianPayer {
			id
			...GuardianName
		}
	}
	${GuardianNameFragmentDoc}
`;
export const PaymentNameFragmentDoc = gql`
	fragment PaymentName on Payment {
		id
	}
`;
export const PaymentLineItemDetailFragmentDoc = gql`
	fragment PaymentLineItemDetail on PaymentLineItem {
		id
		displayOrder
		amount
		localAmount
		invoice {
			id
			...InvoiceName
		}
		payment {
			id
			...PaymentName
		}
	}
	${InvoiceNameFragmentDoc}
	${PaymentNameFragmentDoc}
`;
export const PaymentLineItemNameFragmentDoc = gql`
	fragment PaymentLineItemName on PaymentLineItem {
		id
	}
`;
export const PermissionDetailFragmentDoc = gql`
	fragment PermissionDetail on Permission {
		id
		name
		family
		action
		level
		description
		permissionGroups {
			id
			...PermissionGroupName
		}
	}
	${PermissionGroupNameFragmentDoc}
`;
export const PermissionNameFragmentDoc = gql`
	fragment PermissionName on Permission {
		name
	}
`;
export const PermissionGroupDetailFragmentDoc = gql`
	fragment PermissionGroupDetail on PermissionGroup {
		id
		name
		description
		permissions {
			id
			...PermissionName
		}
		users {
			id
			...UserName
		}
	}
	${PermissionNameFragmentDoc}
	${UserNameFragmentDoc}
`;
export const PhoneNumberDetailFragmentDoc = gql`
	fragment PhoneNumberDetail on PhoneNumber {
		id
		name
		phoneNumber
		isPrimary
		person {
			id
			...PersonName
		}
	}
	${PersonNameFragmentDoc}
`;
export const PostDetailFragmentDoc = gql`
	fragment PostDetail on Post {
		id
		createdAt
		title
		body
		author {
			id
			...UserNameAndImage
		}
		mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
			id
			displayOrder
			title
			description
			isFile
			fileURL
			fileKey
			fileContentType
			linkURL
			taggedPeople {
				id
				...PersonName
				user {
					id
					isCurrent
				}
			}
		}
		socialReactions(order: { field: CREATED_AT, direction: DESC }) {
			id
			author {
				id
				...UserName
				isCurrent
			}
		}
		socialComments(order: { field: CREATED_AT, direction: DESC }) {
			id
			body
			createdAt
			author {
				id
				...UserNameAndImage
				isCurrent
			}
		}
		sharingRecord {
			...SharingRecordDetailInParent
		}
	}
	${UserNameAndImageFragmentDoc}
	${PersonNameFragmentDoc}
	${UserNameFragmentDoc}
	${SharingRecordDetailInParentFragmentDoc}
`;
export const QuotationDetailFragmentDoc = gql`
	fragment QuotationDetail on Quotation {
		id
		body
		attribution
	}
`;
export const QuotationNameFragmentDoc = gql`
	fragment QuotationName on Quotation {
		id
	}
`;
export const RefundDetailFragmentDoc = gql`
	fragment RefundDetail on Refund {
		id
		issueDate
		amount
		localAmount
		isInLocalCurrency
		localCurrency
		notes
		payment {
			id
			...PaymentName
		}
	}
	${PaymentNameFragmentDoc}
`;
export const RefundNameFragmentDoc = gql`
	fragment RefundName on Refund {
		id
	}
`;
export const RelationshipDetailFragmentDoc = gql`
	fragment RelationshipDetail on Relationship {
		id
		relationshipType
		isPrimary
		isFinancialContact
		isEmergencyContact
		isAuthorizedForPickup
		livesWithStudent
		hasCustody
		guardian {
			id
			...GuardianName
		}
		student {
			id
			...StudentName
		}
	}
	${GuardianNameFragmentDoc}
	${StudentNameFragmentDoc}
`;
export const RelationshipNameFragmentDoc = gql`
	fragment RelationshipName on Relationship {
		id
	}
`;
export const ReportCardDetailFragmentDoc = gql`
	fragment ReportCardDetail on ReportCard {
		id
		isComplete
		releaseDate
		isReleased
		fileURL
		fileKey
		fileContentType
		academicTerm {
			id
			...AcademicTermName
		}
		approvingUser {
			id
			...UserName
		}
		student {
			id
			...StudentName
		}
	}
	${AcademicTermNameFragmentDoc}
	${UserNameFragmentDoc}
	${StudentNameFragmentDoc}
`;
export const MarkValueNameFragmentDoc = gql`
	fragment MarkValueName on MarkValue {
		name
	}
`;
export const LearningObjectiveNameFragmentDoc = gql`
	fragment LearningObjectiveName on LearningObjective {
		name
	}
`;
export const ReportCardSectionDisplayFragmentDoc = gql`
	fragment ReportCardSectionDisplay on ReportCardSection {
		isComplete
		comment
		generalComment1
		generalComment2
		reportCardSectionPolicy {
			id
			nameSuffix
			usesDescription
			descriptionLabel
			description
			usesOverallMark
			isOverallMarkManual
			overallMarkLabel
			usesComment
			commentLabel
			isForHomeRoomSection
			courseSection {
				id
				...CourseSectionName
				teacherCourseSectionEnrollments {
					id
					teacher {
						id
						...EmployeeName
					}
				}
			}
			homeRoomSection {
				id
				...HomeRoomSectionName
				teacherHomeRoomSectionEnrollments {
					id
					teacher {
						id
						...EmployeeName
					}
				}
			}
		}
		overallMarkValue {
			id
			...MarkValueName
		}
		reportCardSectionLearningObjectives {
			id
			learningObjective {
				id
				...LearningObjectiveName
				description
				learningObjectiveCategoryID
			}
			markValue {
				id
				...MarkValueName
			}
		}
	}
	${CourseSectionNameFragmentDoc}
	${EmployeeNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${MarkValueNameFragmentDoc}
	${LearningObjectiveNameFragmentDoc}
`;
export const ReportCardNameFragmentDoc = gql`
	fragment ReportCardName on ReportCard {
		student {
			id
			...StudentName
		}
		academicTerm {
			id
			...AcademicTermName
		}
	}
	${StudentNameFragmentDoc}
	${AcademicTermNameFragmentDoc}
`;
export const ReportCardSectionPolicyNameFragmentDoc = gql`
	fragment ReportCardSectionPolicyName on ReportCardSectionPolicy {
		nameSuffix
		courseSection {
			id
			...CourseSectionName
		}
		homeRoomSection {
			id
			...HomeRoomSectionName
		}
	}
	${CourseSectionNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
`;
export const ReportCardSectionDetailFragmentDoc = gql`
	fragment ReportCardSectionDetail on ReportCardSection {
		id
		comment
		generalComment1
		generalComment2
		isComplete
		overallMarkValue {
			id
			...MarkValueName
		}
		reportCard {
			id
			...ReportCardName
		}
		reportCardSectionPolicy {
			id
			...ReportCardSectionPolicyName
		}
		submittingUser {
			id
			...UserName
		}
	}
	${MarkValueNameFragmentDoc}
	${ReportCardNameFragmentDoc}
	${ReportCardSectionPolicyNameFragmentDoc}
	${UserNameFragmentDoc}
`;
export const ReportCardSectionNameFragmentDoc = gql`
	fragment ReportCardSectionName on ReportCardSection {
		reportCardSectionPolicy {
			id
			...ReportCardSectionPolicyName
		}
	}
	${ReportCardSectionPolicyNameFragmentDoc}
`;
export const ReportCardSectionLearningObjectiveDetailFragmentDoc = gql`
	fragment ReportCardSectionLearningObjectiveDetail on ReportCardSectionLearningObjective {
		id
		learningObjective {
			id
			...LearningObjectiveName
		}
		markValue {
			id
			...MarkValueName
		}
		reportCardSection {
			id
			...ReportCardSectionName
		}
	}
	${LearningObjectiveNameFragmentDoc}
	${MarkValueNameFragmentDoc}
	${ReportCardSectionNameFragmentDoc}
`;
export const ReportCardSectionLearningObjectiveNameFragmentDoc = gql`
	fragment ReportCardSectionLearningObjectiveName on ReportCardSectionLearningObjective {
		id
	}
`;
export const ReportCardSectionPolicyDetailFragmentDoc = gql`
	fragment ReportCardSectionPolicyDetail on ReportCardSectionPolicy {
		id
		nameSuffix
		usesDescription
		descriptionLabel
		description
		usesOverallMark
		overallMarkLabel
		isOverallMarkManual
		usesComment
		commentLabel
		minCommentLength
		maxCommentLength
		isForHomeRoomSection
		usesGeneralComments
		minGeneralComment1Length
		maxGeneralComment1Length
		minGeneralComment2Length
		maxGeneralComment2Length
		courseSection {
			id
			...CourseSectionName
		}
		homeRoomSection {
			id
			...HomeRoomSectionName
		}
		overallMarkingSystem {
			id
			...MarkingSystemName
		}
	}
	${CourseSectionNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${MarkingSystemNameFragmentDoc}
`;
export const RoomDetailFragmentDoc = gql`
	fragment RoomDetail on Room {
		id
		name
		roomNumber
		buildingFloor {
			id
			...BuildingFloorName
		}
	}
	${BuildingFloorNameFragmentDoc}
`;
export const SchoolAttendanceRecordDetailFragmentDoc = gql`
	fragment SchoolAttendanceRecordDetail on SchoolAttendanceRecord {
		id
		createdAt
		attendanceDate
		arrivalTime
		departureTime
		notes
		wasSetByCourseAttendance
		attendanceStatus {
			id
			...AttendanceStatusName
		}
		author {
			id
			...UserName
		}
		student {
			id
			...StudentName
		}
	}
	${AttendanceStatusNameFragmentDoc}
	${UserNameFragmentDoc}
	${StudentNameFragmentDoc}
`;
export const SchoolAttendanceRecordNameFragmentDoc = gql`
	fragment SchoolAttendanceRecordName on SchoolAttendanceRecord {
		id
	}
`;
export const ServiceDetailFragmentDoc = gql`
	fragment ServiceDetail on Service {
		id
		name
		description
		category
		isActive
		price
		classYears {
			id
			...ClassYearName
		}
	}
	${ClassYearNameFragmentDoc}
`;
export const LoginRecordNameFragmentDoc = gql`
	fragment LoginRecordName on LoginRecord {
		id
	}
`;
export const MFAInvalidOTPAttemptNameFragmentDoc = gql`
	fragment MFAInvalidOTPAttemptName on MFAInvalidOTPAttempt {
		id
	}
`;
export const TrustedDeviceNameFragmentDoc = gql`
	fragment TrustedDeviceName on TrustedDevice {
		name
	}
`;
export const SessionDetailFragmentDoc = gql`
	fragment SessionDetail on Session {
		id
		createdAt
		updatedAt
		expiresAt
		longestInactiveSec
		isVerified
		isCurrent
		loginRecord {
			id
			...LoginRecordName
		}
		mfaInvalidOTPAttempts {
			id
			...MFAInvalidOTPAttemptName
		}
		trustedDevice {
			id
			...TrustedDeviceName
		}
		user {
			id
			...UserName
		}
	}
	${LoginRecordNameFragmentDoc}
	${MFAInvalidOTPAttemptNameFragmentDoc}
	${TrustedDeviceNameFragmentDoc}
	${UserNameFragmentDoc}
`;
export const NewsletterNameFragmentDoc = gql`
	fragment NewsletterName on Newsletter {
		title
	}
`;
export const SharingRecordDetailFragmentDoc = gql`
	fragment SharingRecordDetail on SharingRecord {
		id
		isPublic
		includeEmployees
		includeGuardians
		includeAllUsersOfPersonTypes
		announcement {
			id
			...AnnouncementName
		}
		calendarEvent {
			id
			...CalendarEventName
		}
		classYearCategories {
			id
			...ClassYearCategoryName
		}
		classYears {
			id
			...ClassYearName
		}
		courseSections {
			id
			...CourseSectionName
		}
		homeRoomSections {
			id
			...HomeRoomSectionName
		}
		newsletter {
			id
			...NewsletterName
		}
		post {
			id
			...PostName
		}
		studentNote {
			id
			...StudentNoteName
		}
		userGroups {
			id
			...UserGroupName
		}
		users {
			id
			...UserName
		}
	}
	${AnnouncementNameFragmentDoc}
	${CalendarEventNameFragmentDoc}
	${ClassYearCategoryNameFragmentDoc}
	${ClassYearNameFragmentDoc}
	${CourseSectionNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${NewsletterNameFragmentDoc}
	${PostNameFragmentDoc}
	${StudentNoteNameFragmentDoc}
	${UserGroupNameFragmentDoc}
	${UserNameFragmentDoc}
`;
export const SharingRecordNameFragmentDoc = gql`
	fragment SharingRecordName on SharingRecord {
		id
	}
`;
export const MediaAttachmentNameFragmentDoc = gql`
	fragment MediaAttachmentName on MediaAttachment {
		title
	}
`;
export const SocialCommentDetailFragmentDoc = gql`
	fragment SocialCommentDetail on SocialComment {
		id
		createdAt
		body
		author {
			id
			...UserName
		}
		mediaAttachment {
			id
			...MediaAttachmentName
		}
		newsletter {
			id
			...NewsletterName
		}
		post {
			id
			...PostName
		}
		studentNote {
			id
			...StudentNoteName
		}
	}
	${UserNameFragmentDoc}
	${MediaAttachmentNameFragmentDoc}
	${NewsletterNameFragmentDoc}
	${PostNameFragmentDoc}
	${StudentNoteNameFragmentDoc}
`;
export const SocialCommentNameFragmentDoc = gql`
	fragment SocialCommentName on SocialComment {
		id
	}
`;
export const SocialReactionDetailFragmentDoc = gql`
	fragment SocialReactionDetail on SocialReaction {
		id
		createdAt
		reaction
		announcement {
			id
			...AnnouncementName
		}
		author {
			id
			...UserName
		}
		mediaAttachment {
			id
			...MediaAttachmentName
		}
		newsletter {
			id
			...NewsletterName
		}
		post {
			id
			...PostName
		}
	}
	${AnnouncementNameFragmentDoc}
	${UserNameFragmentDoc}
	${MediaAttachmentNameFragmentDoc}
	${NewsletterNameFragmentDoc}
	${PostNameFragmentDoc}
`;
export const SocialReactionNameFragmentDoc = gql`
	fragment SocialReactionName on SocialReaction {
		id
	}
`;
export const StudentDetailFragmentDoc = gql`
	fragment StudentDetail on Student {
		id
		graduationYear
		yearsFromGraduation
		person {
			...PersonDetail
		}
		relationships(order: { field: IS_PRIMARY, direction: DESC }) {
			id
			relationshipType
			isPrimary
			isEmergencyContact
			isAuthorizedForPickup
			isFinancialContact
			livesWithStudent
			hasCustody
			guardian {
				id
				person {
					id
					...PersonNameAndImage
					userID
					addresses {
						id
						...AddressInformation
					}
					emailAddresses(order: { field: IS_PRIMARY, direction: DESC }) {
						id
						...EmailAddressName
						emailAddress
						isPrimary
					}
					phoneNumbers(order: { field: IS_PRIMARY, direction: DESC }) {
						id
						...PhoneNumberName
						phoneNumber
						isPrimary
					}
				}
			}
		}
	}
	${PersonDetailFragmentDoc}
	${PersonNameAndImageFragmentDoc}
	${AddressInformationFragmentDoc}
	${EmailAddressNameFragmentDoc}
	${PhoneNumberNameFragmentDoc}
`;
export const StudentAcademicNoteNameFragmentDoc = gql`
	fragment StudentAcademicNoteName on StudentAcademicNote {
		id
	}
`;
export const StudentAcademicTermEnrollmentDetailFragmentDoc = gql`
	fragment StudentAcademicTermEnrollmentDetail on StudentAcademicTermEnrollment {
		id
		lateStartDate
		earlyEndDate
		academicTerm {
			id
			...AcademicTermName
		}
		student {
			id
			...StudentName
		}
	}
	${AcademicTermNameFragmentDoc}
	${StudentNameFragmentDoc}
`;
export const StudentAcademicTermEnrollmentNameFragmentDoc = gql`
	fragment StudentAcademicTermEnrollmentName on StudentAcademicTermEnrollment {
		id
	}
`;
export const StudentAttendanceNoteNameFragmentDoc = gql`
	fragment StudentAttendanceNoteName on StudentAttendanceNote {
		id
	}
`;
export const StudentBehaviorNoteNameFragmentDoc = gql`
	fragment StudentBehaviorNoteName on StudentBehaviorNote {
		id
	}
`;
export const StudentCourseSectionEnrollmentDetailFragmentDoc = gql`
	fragment StudentCourseSectionEnrollmentDetail on StudentCourseSectionEnrollment {
		id
		lateStartDate
		earlyEndDate
		courseSection {
			id
			...CourseSectionName
		}
		student {
			id
			...StudentName
		}
	}
	${CourseSectionNameFragmentDoc}
	${StudentNameFragmentDoc}
`;
export const StudentCourseSectionEnrollmentNameFragmentDoc = gql`
	fragment StudentCourseSectionEnrollmentName on StudentCourseSectionEnrollment {
		id
	}
`;
export const StudentDataConsentDetailFragmentDoc = gql`
	fragment StudentDataConsentDetail on StudentDataConsent {
		id
		createdAt
		updatedAt
		allowPublishVisualMediaOfStudentGeneral
		allowPublishVisualMediaOfStudentForPromotion
		allowPublishVisualMediaOfGuardianForPromotion
		allowPublishStudentWorkGeneral
		allowShareInformationWithPearsonEdexcel
		allowShareInformationWithIbOrganization
		allowShareInformationWithOnlinePlatforms
		allowBirthdayInCalendar
		allowSendNewsletters
		allowSendCalendarEvents
		author {
			id
			...UserName
		}
		student {
			id
			...StudentNameAndImage
		}
	}
	${UserNameFragmentDoc}
	${StudentNameAndImageFragmentDoc}
`;
export const StudentDataConsentNameFragmentDoc = gql`
	fragment StudentDataConsentName on StudentDataConsent {
		id
	}
`;
export const StudentEnrollmentApplicationDetailFragmentDoc = gql`
	fragment StudentEnrollmentApplicationDetail on StudentEnrollmentApplication {
		id
		status
		statusUpdatedAt
		enrollmentApplicationStudent {
			id
			...EnrollmentApplicationStudentName
		}
	}
	${EnrollmentApplicationStudentNameFragmentDoc}
`;
export const StudentEnrollmentApplicationNameFragmentDoc = gql`
	fragment StudentEnrollmentApplicationName on StudentEnrollmentApplication {
		id
	}
`;
export const StudentEnrollmentIntentDetailFragmentDoc = gql`
	fragment StudentEnrollmentIntentDetail on StudentEnrollmentIntent {
		id
		createdAt
		isEnrolling
		isInterestedInMealPlan
		declineReason
		declineReasonDescription
		academicYear {
			id
			...AcademicYearName
		}
		student {
			id
			...StudentName
		}
	}
	${AcademicYearNameFragmentDoc}
	${StudentNameFragmentDoc}
`;
export const StudentEnrollmentIntentNameFragmentDoc = gql`
	fragment StudentEnrollmentIntentName on StudentEnrollmentIntent {
		id
	}
`;
export const StudentHealthNoteNameFragmentDoc = gql`
	fragment StudentHealthNoteName on StudentHealthNote {
		id
	}
`;
export const StudentHomeRoomSectionEnrollmentDetailFragmentDoc = gql`
	fragment StudentHomeRoomSectionEnrollmentDetail on StudentHomeRoomSectionEnrollment {
		id
		lateStartDate
		earlyEndDate
		homeRoomSection {
			id
			...HomeRoomSectionName
		}
		student {
			id
			...StudentName
		}
	}
	${HomeRoomSectionNameFragmentDoc}
	${StudentNameFragmentDoc}
`;
export const StudentHomeRoomSectionEnrollmentNameFragmentDoc = gql`
	fragment StudentHomeRoomSectionEnrollmentName on StudentHomeRoomSectionEnrollment {
		id
	}
`;
export const StudentIncidentNoteNameFragmentDoc = gql`
	fragment StudentIncidentNoteName on StudentIncidentNote {
		id
	}
`;
export const StudentInformationVerificationDetailFragmentDoc = gql`
	fragment StudentInformationVerificationDetail on StudentInformationVerification {
		id
		createdAt
		hasVerifiedGuardians
		hasVerifiedStudentHealth
		author {
			id
			...UserName
		}
		guardians {
			id
			...GuardianName
		}
		students {
			id
			...StudentName
		}
	}
	${UserNameFragmentDoc}
	${GuardianNameFragmentDoc}
	${StudentNameFragmentDoc}
`;
export const StudentInformationVerificationNameFragmentDoc = gql`
	fragment StudentInformationVerificationName on StudentInformationVerification {
		id
	}
`;
export const StudentInjuryNoteNameFragmentDoc = gql`
	fragment StudentInjuryNoteName on StudentInjuryNote {
		id
	}
`;
export const MedicalConditionNameFragmentDoc = gql`
	fragment MedicalConditionName on MedicalCondition {
		name
	}
`;
export const StudentMedicalConditionDetailFragmentDoc = gql`
	fragment StudentMedicalConditionDetail on StudentMedicalCondition {
		id
		isProminent
		notes
		medicalCondition {
			id
			...MedicalConditionName
			conditionType
		}
		student {
			id
			...StudentName
		}
	}
	${MedicalConditionNameFragmentDoc}
	${StudentNameFragmentDoc}
`;
export const StudentMedicalConditionNameFragmentDoc = gql`
	fragment StudentMedicalConditionName on StudentMedicalCondition {
		id
	}
`;
export const StudentMedicalContactDetailFragmentDoc = gql`
	fragment StudentMedicalContactDetail on StudentMedicalContact {
		id
		name
		contactType
		institutionName
		phoneNumber
		emailAddress
		address
		notes
		student {
			id
			...StudentName
		}
	}
	${StudentNameFragmentDoc}
`;
export const StudentMedicalContactNameFragmentDoc = gql`
	fragment StudentMedicalContactName on StudentMedicalContact {
		name
	}
`;
export const StudentMedicalEventDetailFragmentDoc = gql`
	fragment StudentMedicalEventDetail on StudentMedicalEvent {
		id
		checkInTime
		checkOutTime
		description
		treatment
		outcome
		notes
		attendingEmployees {
			id
			...EmployeeName
		}
		author {
			id
			...UserNameAndImage
		}
		student {
			id
			...StudentNameAndImage
		}
		mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
			id
			displayOrder
			title
			description
			isFile
			fileURL
			fileKey
			fileContentType
			linkURL
			taggedPeople {
				id
				...PersonName
				user {
					id
					isCurrent
				}
			}
		}
	}
	${EmployeeNameFragmentDoc}
	${UserNameAndImageFragmentDoc}
	${StudentNameAndImageFragmentDoc}
	${PersonNameFragmentDoc}
`;
export const StudentMedicalProfileDetailFragmentDoc = gql`
	fragment StudentMedicalProfileDetail on StudentMedicalProfile {
		id
		isSchoolAllowedToTreat
		isSchoolAllowedToUseEpipen
		student {
			id
			...StudentName
		}
	}
	${StudentNameFragmentDoc}
`;
export const StudentMedicalProfileNameFragmentDoc = gql`
	fragment StudentMedicalProfileName on StudentMedicalProfile {
		id
	}
`;
export const StudentMedicationNoteNameFragmentDoc = gql`
	fragment StudentMedicationNoteName on StudentMedicationNote {
		id
	}
`;
export const StudentAcademicNoteDetailFragmentDoc = gql`
	fragment StudentAcademicNoteDetail on StudentAcademicNote {
		id
		isIssueNatureLearningDifficulty
		isIssueNatureAttentionIssue
		isIssueNatureFocusIssue
		isIssueNatureEmotionalOrVulnerableIssue
		isIssueNatureOther
		issueNatureOther
		isSolutionRecDifferentiatedLearning
		isSolutionRecIndividualLearningPlan
		isSolutionRecTutoring
		isSolutionRecProfessionalSupport
		isSolutionRecInClassSupport
		isSolutionRecOther
		solutionRecOther
		studentNote {
			id
			...StudentNoteName
		}
	}
	${StudentNoteNameFragmentDoc}
`;
export const StudentAttendanceNoteDetailFragmentDoc = gql`
	fragment StudentAttendanceNoteDetail on StudentAttendanceNote {
		id
		startDate
		endDate
		attendanceStatus {
			id
			...AttendanceStatusName
			code
			description
			indicatesAbsent
			indicatesLateArrival
			indicatesEarlyDeparture
			indicatesExcused
		}
		studentNote {
			id
			...StudentNoteName
		}
	}
	${AttendanceStatusNameFragmentDoc}
	${StudentNoteNameFragmentDoc}
`;
export const StudentBehaviorNoteDetailFragmentDoc = gql`
	fragment StudentBehaviorNoteDetail on StudentBehaviorNote {
		id
		incidentTime
		incidentLocation
		isIncidentPhysicalContactAggression
		isIncidentFightingPhysicalAggression
		isIncidentVerbalAbuseDisrespectingStudent
		isIncidentDisrepectingTeacher
		isIncidentDisruption
		isIncidentDefianceOrNonCompliance
		isIncidentOther
		incidentOther
		isMotivationAttentionSeeking
		isMotivationReaction
		isMotivationAnger
		isMotivationFrustration
		isMotivationHabit
		isMotivationLackOfSelfContol
		isMotivationOther
		motivationOther
		isConsequenceRecDirectorIntervention
		isConsequenceRecSenOrSelIntervention
		isConsequenceRecStudentServiceTeamIntervention
		isConsequenceRecParentContactFromReporter
		isConsequenceRecParentContactFromSchoolDirector
		isConsequenceRecOther
		consequenceRecOther
		additionalComments
		studentNote {
			id
			...StudentNoteName
		}
	}
	${StudentNoteNameFragmentDoc}
`;
export const StudentHealthNoteDetailFragmentDoc = gql`
	fragment StudentHealthNoteDetail on StudentHealthNote {
		id
		body
		studentNote {
			id
			...StudentNoteName
		}
	}
	${StudentNoteNameFragmentDoc}
`;
export const StudentIncidentNoteDetailFragmentDoc = gql`
	fragment StudentIncidentNoteDetail on StudentIncidentNote {
		id
		incidentTime
		incidentLocation
		actionsTaken
		suggestionsForFuture
		studentNote {
			id
			...StudentNoteName
		}
	}
	${StudentNoteNameFragmentDoc}
`;
export const StudentInjuryNoteDetailFragmentDoc = gql`
	fragment StudentInjuryNoteDetail on StudentInjuryNote {
		id
		incidentTime
		incidentLocation
		wereOtherStudentsCauseOfInjury
		causeOfInjury
		medicalAttentionProvided
		adultWhoProvidedMedicalAttention
		isActionTakenHomeroomTeachersNotified
		isActionTakenParentNotifiedByPortal
		isActionTakenParentNotifiedByPhone
		isActionTakenParentsRequestedToCollectStudent
		isActionTakenParentNotificationNotNecessary
		isActionTakenOther
		actionTakenOther
		studentNote {
			id
			...StudentNoteName
		}
	}
	${StudentNoteNameFragmentDoc}
`;
export const StudentMedicationNoteDetailFragmentDoc = gql`
	fragment StudentMedicationNoteDetail on StudentMedicationNote {
		id
		body
		studentNote {
			id
			...StudentNoteName
		}
	}
	${StudentNoteNameFragmentDoc}
`;
export const StudentSocialEmotionalNoteDetailFragmentDoc = gql`
	fragment StudentSocialEmotionalNoteDetail on StudentSocialEmotionalNote {
		id
		isIssueNatureLearningDifficulty
		isIssueNatureAttentionIssue
		isIssueNatureFocusIssue
		isIssueNatureEmotionalOrVulnerableIssue
		isIssueNatureOther
		issueNatureOther
		isSolutionRecDifferentiatedLearning
		isSolutionRecIndividualLearningPlan
		isSolutionRecTutoring
		isSolutionRecProfessionalSupport
		isSolutionRecInClassSupport
		isSolutionRecOther
		solutionRecOther
		studentNote {
			id
			...StudentNoteName
		}
	}
	${StudentNoteNameFragmentDoc}
`;
export const StudentNoteDetailFragmentDoc = gql`
	fragment StudentNoteDetail on StudentNote {
		id
		noteType
		createdAt
		body
		isPinned
		requiresResolution
		isResolved
		resolvedAt
		resolutionDescription
		studentAcademicNote {
			...StudentAcademicNoteDetail
		}
		studentAttendanceNote {
			...StudentAttendanceNoteDetail
		}
		studentBehaviorNote {
			...StudentBehaviorNoteDetail
		}
		studentHealthNote {
			...StudentHealthNoteDetail
		}
		studentIncidentNote {
			...StudentIncidentNoteDetail
		}
		studentInjuryNote {
			...StudentInjuryNoteDetail
		}
		studentMedicationNote {
			...StudentMedicationNoteDetail
		}
		studentSocialEmotionalNote {
			...StudentSocialEmotionalNoteDetail
		}
		author {
			id
			...UserNameAndImage
		}
		primaryStudents {
			id
			...StudentNameAndImage
		}
		secondaryStudents {
			id
			...StudentNameAndImage
		}
		mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
			id
			displayOrder
			title
			description
			isFile
			fileURL
			fileKey
			fileContentType
			linkURL
			taggedPeople {
				id
				...PersonName
				user {
					id
					isCurrent
				}
			}
		}
		socialComments(order: { field: CREATED_AT, direction: DESC }) {
			id
			body
			createdAt
			author {
				id
				...UserNameAndImage
				isCurrent
			}
		}
	}
	${StudentAcademicNoteDetailFragmentDoc}
	${StudentAttendanceNoteDetailFragmentDoc}
	${StudentBehaviorNoteDetailFragmentDoc}
	${StudentHealthNoteDetailFragmentDoc}
	${StudentIncidentNoteDetailFragmentDoc}
	${StudentInjuryNoteDetailFragmentDoc}
	${StudentMedicationNoteDetailFragmentDoc}
	${StudentSocialEmotionalNoteDetailFragmentDoc}
	${UserNameAndImageFragmentDoc}
	${StudentNameAndImageFragmentDoc}
	${PersonNameFragmentDoc}
`;
export const MedicationNameFragmentDoc = gql`
	fragment MedicationName on Medication {
		name
	}
`;
export const StudentOTCMedicationDetailFragmentDoc = gql`
	fragment StudentOTCMedicationDetail on StudentOTCMedication {
		id
		isAllowed
		notes
		medication {
			id
			...MedicationName
		}
		student {
			id
			...StudentName
		}
	}
	${MedicationNameFragmentDoc}
	${StudentNameFragmentDoc}
`;
export const StudentOTCMedicationNameFragmentDoc = gql`
	fragment StudentOTCMedicationName on StudentOTCMedication {
		id
	}
`;
export const StudentPrescriptionMedicationDetailFragmentDoc = gql`
	fragment StudentPrescriptionMedicationDetail on StudentPrescriptionMedication {
		id
		administration
		canSelfAdminister
		notes
		medication {
			id
			...MedicationName
		}
		student {
			id
			...StudentName
		}
	}
	${MedicationNameFragmentDoc}
	${StudentNameFragmentDoc}
`;
export const StudentPrescriptionMedicationNameFragmentDoc = gql`
	fragment StudentPrescriptionMedicationName on StudentPrescriptionMedication {
		id
	}
`;
export const StudentSocialEmotionalNoteNameFragmentDoc = gql`
	fragment StudentSocialEmotionalNoteName on StudentSocialEmotionalNote {
		id
	}
`;
export const VaccineNameFragmentDoc = gql`
	fragment VaccineName on Vaccine {
		name
	}
`;
export const StudentVaccinationRecordDetailFragmentDoc = gql`
	fragment StudentVaccinationRecordDetail on StudentVaccinationRecord {
		id
		receivedOn
		notes
		student {
			id
			...StudentName
		}
		vaccine {
			id
			...VaccineName
		}
	}
	${StudentNameFragmentDoc}
	${VaccineNameFragmentDoc}
`;
export const StudentVaccinationRecordNameFragmentDoc = gql`
	fragment StudentVaccinationRecordName on StudentVaccinationRecord {
		id
	}
`;
export const TeacherCourseSectionEnrollmentDetailFragmentDoc = gql`
	fragment TeacherCourseSectionEnrollmentDetail on TeacherCourseSectionEnrollment {
		id
		lateStartDate
		earlyEndDate
		courseSection {
			id
			...CourseSectionName
		}
		teacher {
			id
			...EmployeeName
		}
	}
	${CourseSectionNameFragmentDoc}
	${EmployeeNameFragmentDoc}
`;
export const TeacherCourseSectionEnrollmentNameFragmentDoc = gql`
	fragment TeacherCourseSectionEnrollmentName on TeacherCourseSectionEnrollment {
		id
	}
`;
export const TeacherHomeRoomSectionEnrollmentDetailFragmentDoc = gql`
	fragment TeacherHomeRoomSectionEnrollmentDetail on TeacherHomeRoomSectionEnrollment {
		id
		lateStartDate
		earlyEndDate
		homeRoomSection {
			id
			...HomeRoomSectionName
		}
		teacher {
			id
			...EmployeeName
		}
	}
	${HomeRoomSectionNameFragmentDoc}
	${EmployeeNameFragmentDoc}
`;
export const TeacherHomeRoomSectionEnrollmentNameFragmentDoc = gql`
	fragment TeacherHomeRoomSectionEnrollmentName on TeacherHomeRoomSectionEnrollment {
		id
	}
`;
export const TrustedDeviceDetailFragmentDoc = gql`
	fragment TrustedDeviceDetail on TrustedDevice {
		id
		createdAt
		name
		isCurrent
		sessions {
			id
			...SessionName
		}
		user {
			id
			...UserName
		}
	}
	${SessionNameFragmentDoc}
	${UserNameFragmentDoc}
`;
export const UserNameDescriptionAndImageFragmentDoc = gql`
	fragment UserNameDescriptionAndImage on User {
		email
		person {
			id
			...PersonNameAndImage
			employee {
				id
				jobTitle
				role
			}
			guardian {
				id
			}
			student {
				id
				graduationYear
				yearsFromGraduation
			}
		}
	}
	${PersonNameAndImageFragmentDoc}
`;
export const UserGroupDetailFragmentDoc = gql`
	fragment UserGroupDetail on UserGroup {
		id
		name
		description
		color
		isPublic
		includeEmployees
		includeGuardians
		includeAllUsersOfPersonTypes
		classYearCategories {
			id
			...ClassYearCategoryName
		}
		classYears {
			id
			...ClassYearName
		}
		courseSections {
			id
			...CourseSectionName
		}
		homeRoomSections {
			id
			...HomeRoomSectionName
		}
		users {
			id
			...UserName
		}
	}
	${ClassYearCategoryNameFragmentDoc}
	${ClassYearNameFragmentDoc}
	${CourseSectionNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${UserNameFragmentDoc}
`;
export const UserViewRecordDetailFragmentDoc = gql`
	fragment UserViewRecordDetail on UserViewRecord {
		id
		targetID
		firstViewedAt
		lastViewedAt
		user {
			id
			...UserName
		}
	}
	${UserNameFragmentDoc}
`;
export const UserViewRecordNameFragmentDoc = gql`
	fragment UserViewRecordName on UserViewRecord {
		id
	}
`;
export const VaccineDetailFragmentDoc = gql`
	fragment VaccineDetail on Vaccine {
		id
		name
		description
	}
`;
export const AcademicSubjectCountDocument = gql`
	query academicSubjectCount(
		$filters: [AcademicSubjectFilterInput!]
		$pagination: Pagination
		$order: AcademicSubjectOrder
	) {
		academicSubjectConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useAcademicSubjectCountQuery__
 *
 * To run a query within a React component, call `useAcademicSubjectCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicSubjectCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicSubjectCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAcademicSubjectCountQuery(
	baseOptions?: Apollo.QueryHookOptions<AcademicSubjectCountQuery, AcademicSubjectCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicSubjectCountQuery, AcademicSubjectCountQueryVariables>(
		AcademicSubjectCountDocument,
		options,
	);
}
export function useAcademicSubjectCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicSubjectCountQuery, AcademicSubjectCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicSubjectCountQuery, AcademicSubjectCountQueryVariables>(
		AcademicSubjectCountDocument,
		options,
	);
}
export function useAcademicSubjectCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicSubjectCountQuery, AcademicSubjectCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicSubjectCountQuery, AcademicSubjectCountQueryVariables>(
		AcademicSubjectCountDocument,
		options,
	);
}
export type AcademicSubjectCountQueryHookResult = ReturnType<typeof useAcademicSubjectCountQuery>;
export type AcademicSubjectCountLazyQueryHookResult = ReturnType<typeof useAcademicSubjectCountLazyQuery>;
export type AcademicSubjectCountSuspenseQueryHookResult = ReturnType<typeof useAcademicSubjectCountSuspenseQuery>;
export type AcademicSubjectCountQueryResult = Apollo.QueryResult<
	AcademicSubjectCountQuery,
	AcademicSubjectCountQueryVariables
>;
export const AcademicSubjectCreateDocument = gql`
	mutation academicSubjectCreate($input: AcademicSubjectCreateInput!) {
		createAcademicSubject(input: $input) {
			...AcademicSubjectDetail
		}
	}
	${AcademicSubjectDetailFragmentDoc}
`;
export type AcademicSubjectCreateMutationFn = Apollo.MutationFunction<
	AcademicSubjectCreateMutation,
	AcademicSubjectCreateMutationVariables
>;

/**
 * __useAcademicSubjectCreateMutation__
 *
 * To run a mutation, you first call `useAcademicSubjectCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcademicSubjectCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [academicSubjectCreateMutation, { data, loading, error }] = useAcademicSubjectCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcademicSubjectCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<AcademicSubjectCreateMutation, AcademicSubjectCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AcademicSubjectCreateMutation, AcademicSubjectCreateMutationVariables>(
		AcademicSubjectCreateDocument,
		options,
	);
}
export type AcademicSubjectCreateMutationHookResult = ReturnType<typeof useAcademicSubjectCreateMutation>;
export type AcademicSubjectCreateMutationResult = Apollo.MutationResult<AcademicSubjectCreateMutation>;
export type AcademicSubjectCreateMutationOptions = Apollo.BaseMutationOptions<
	AcademicSubjectCreateMutation,
	AcademicSubjectCreateMutationVariables
>;
export const AcademicSubjectDeleteDocument = gql`
	mutation academicSubjectDelete($id: ID!) {
		deleteAcademicSubject(id: $id)
	}
`;
export type AcademicSubjectDeleteMutationFn = Apollo.MutationFunction<
	AcademicSubjectDeleteMutation,
	AcademicSubjectDeleteMutationVariables
>;

/**
 * __useAcademicSubjectDeleteMutation__
 *
 * To run a mutation, you first call `useAcademicSubjectDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcademicSubjectDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [academicSubjectDeleteMutation, { data, loading, error }] = useAcademicSubjectDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcademicSubjectDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<AcademicSubjectDeleteMutation, AcademicSubjectDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AcademicSubjectDeleteMutation, AcademicSubjectDeleteMutationVariables>(
		AcademicSubjectDeleteDocument,
		options,
	);
}
export type AcademicSubjectDeleteMutationHookResult = ReturnType<typeof useAcademicSubjectDeleteMutation>;
export type AcademicSubjectDeleteMutationResult = Apollo.MutationResult<AcademicSubjectDeleteMutation>;
export type AcademicSubjectDeleteMutationOptions = Apollo.BaseMutationOptions<
	AcademicSubjectDeleteMutation,
	AcademicSubjectDeleteMutationVariables
>;
export const AcademicSubjectDetailDocument = gql`
	query academicSubjectDetail($id: ID!) {
		academicSubject(id: $id) {
			...AcademicSubjectDetail
		}
	}
	${AcademicSubjectDetailFragmentDoc}
`;

/**
 * __useAcademicSubjectDetailQuery__
 *
 * To run a query within a React component, call `useAcademicSubjectDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicSubjectDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicSubjectDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcademicSubjectDetailQuery(
	baseOptions: Apollo.QueryHookOptions<AcademicSubjectDetailQuery, AcademicSubjectDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicSubjectDetailQuery, AcademicSubjectDetailQueryVariables>(
		AcademicSubjectDetailDocument,
		options,
	);
}
export function useAcademicSubjectDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicSubjectDetailQuery, AcademicSubjectDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicSubjectDetailQuery, AcademicSubjectDetailQueryVariables>(
		AcademicSubjectDetailDocument,
		options,
	);
}
export function useAcademicSubjectDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicSubjectDetailQuery, AcademicSubjectDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicSubjectDetailQuery, AcademicSubjectDetailQueryVariables>(
		AcademicSubjectDetailDocument,
		options,
	);
}
export type AcademicSubjectDetailQueryHookResult = ReturnType<typeof useAcademicSubjectDetailQuery>;
export type AcademicSubjectDetailLazyQueryHookResult = ReturnType<typeof useAcademicSubjectDetailLazyQuery>;
export type AcademicSubjectDetailSuspenseQueryHookResult = ReturnType<typeof useAcademicSubjectDetailSuspenseQuery>;
export type AcademicSubjectDetailQueryResult = Apollo.QueryResult<
	AcademicSubjectDetailQuery,
	AcademicSubjectDetailQueryVariables
>;
export const AcademicSubjectIndexDocument = gql`
	query academicSubjectIndex(
		$filters: [AcademicSubjectFilterInput!]
		$pagination: Pagination
		$order: AcademicSubjectOrder
	) {
		academicSubjectConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					color
				}
			}
		}
	}
`;

/**
 * __useAcademicSubjectIndexQuery__
 *
 * To run a query within a React component, call `useAcademicSubjectIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicSubjectIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicSubjectIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAcademicSubjectIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<AcademicSubjectIndexQuery, AcademicSubjectIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicSubjectIndexQuery, AcademicSubjectIndexQueryVariables>(
		AcademicSubjectIndexDocument,
		options,
	);
}
export function useAcademicSubjectIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicSubjectIndexQuery, AcademicSubjectIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicSubjectIndexQuery, AcademicSubjectIndexQueryVariables>(
		AcademicSubjectIndexDocument,
		options,
	);
}
export function useAcademicSubjectIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicSubjectIndexQuery, AcademicSubjectIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicSubjectIndexQuery, AcademicSubjectIndexQueryVariables>(
		AcademicSubjectIndexDocument,
		options,
	);
}
export type AcademicSubjectIndexQueryHookResult = ReturnType<typeof useAcademicSubjectIndexQuery>;
export type AcademicSubjectIndexLazyQueryHookResult = ReturnType<typeof useAcademicSubjectIndexLazyQuery>;
export type AcademicSubjectIndexSuspenseQueryHookResult = ReturnType<typeof useAcademicSubjectIndexSuspenseQuery>;
export type AcademicSubjectIndexQueryResult = Apollo.QueryResult<
	AcademicSubjectIndexQuery,
	AcademicSubjectIndexQueryVariables
>;
export const AcademicSubjectNameDocument = gql`
	query academicSubjectName($id: ID!) {
		academicSubject(id: $id) {
			id
			...AcademicSubjectName
		}
	}
	${AcademicSubjectNameFragmentDoc}
`;

/**
 * __useAcademicSubjectNameQuery__
 *
 * To run a query within a React component, call `useAcademicSubjectNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicSubjectNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicSubjectNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcademicSubjectNameQuery(
	baseOptions: Apollo.QueryHookOptions<AcademicSubjectNameQuery, AcademicSubjectNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicSubjectNameQuery, AcademicSubjectNameQueryVariables>(
		AcademicSubjectNameDocument,
		options,
	);
}
export function useAcademicSubjectNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicSubjectNameQuery, AcademicSubjectNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicSubjectNameQuery, AcademicSubjectNameQueryVariables>(
		AcademicSubjectNameDocument,
		options,
	);
}
export function useAcademicSubjectNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicSubjectNameQuery, AcademicSubjectNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicSubjectNameQuery, AcademicSubjectNameQueryVariables>(
		AcademicSubjectNameDocument,
		options,
	);
}
export type AcademicSubjectNameQueryHookResult = ReturnType<typeof useAcademicSubjectNameQuery>;
export type AcademicSubjectNameLazyQueryHookResult = ReturnType<typeof useAcademicSubjectNameLazyQuery>;
export type AcademicSubjectNameSuspenseQueryHookResult = ReturnType<typeof useAcademicSubjectNameSuspenseQuery>;
export type AcademicSubjectNameQueryResult = Apollo.QueryResult<
	AcademicSubjectNameQuery,
	AcademicSubjectNameQueryVariables
>;
export const AcademicSubjectNamesDocument = gql`
	query academicSubjectNames(
		$filters: [AcademicSubjectFilterInput!]
		$pagination: Pagination
		$order: AcademicSubjectOrder
	) {
		academicSubjectConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...AcademicSubjectName
				}
			}
		}
	}
	${AcademicSubjectNameFragmentDoc}
`;

/**
 * __useAcademicSubjectNamesQuery__
 *
 * To run a query within a React component, call `useAcademicSubjectNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicSubjectNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicSubjectNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAcademicSubjectNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<AcademicSubjectNamesQuery, AcademicSubjectNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicSubjectNamesQuery, AcademicSubjectNamesQueryVariables>(
		AcademicSubjectNamesDocument,
		options,
	);
}
export function useAcademicSubjectNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicSubjectNamesQuery, AcademicSubjectNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicSubjectNamesQuery, AcademicSubjectNamesQueryVariables>(
		AcademicSubjectNamesDocument,
		options,
	);
}
export function useAcademicSubjectNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicSubjectNamesQuery, AcademicSubjectNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicSubjectNamesQuery, AcademicSubjectNamesQueryVariables>(
		AcademicSubjectNamesDocument,
		options,
	);
}
export type AcademicSubjectNamesQueryHookResult = ReturnType<typeof useAcademicSubjectNamesQuery>;
export type AcademicSubjectNamesLazyQueryHookResult = ReturnType<typeof useAcademicSubjectNamesLazyQuery>;
export type AcademicSubjectNamesSuspenseQueryHookResult = ReturnType<typeof useAcademicSubjectNamesSuspenseQuery>;
export type AcademicSubjectNamesQueryResult = Apollo.QueryResult<
	AcademicSubjectNamesQuery,
	AcademicSubjectNamesQueryVariables
>;
export const AcademicSubjectPaginationDocument = gql`
	query academicSubjectPagination($filters: [AcademicSubjectFilterInput!], $order: AcademicSubjectOrder) {
		academicSubjectConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useAcademicSubjectPaginationQuery__
 *
 * To run a query within a React component, call `useAcademicSubjectPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicSubjectPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicSubjectPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAcademicSubjectPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<AcademicSubjectPaginationQuery, AcademicSubjectPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicSubjectPaginationQuery, AcademicSubjectPaginationQueryVariables>(
		AcademicSubjectPaginationDocument,
		options,
	);
}
export function useAcademicSubjectPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicSubjectPaginationQuery, AcademicSubjectPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicSubjectPaginationQuery, AcademicSubjectPaginationQueryVariables>(
		AcademicSubjectPaginationDocument,
		options,
	);
}
export function useAcademicSubjectPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		AcademicSubjectPaginationQuery,
		AcademicSubjectPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicSubjectPaginationQuery, AcademicSubjectPaginationQueryVariables>(
		AcademicSubjectPaginationDocument,
		options,
	);
}
export type AcademicSubjectPaginationQueryHookResult = ReturnType<typeof useAcademicSubjectPaginationQuery>;
export type AcademicSubjectPaginationLazyQueryHookResult = ReturnType<typeof useAcademicSubjectPaginationLazyQuery>;
export type AcademicSubjectPaginationSuspenseQueryHookResult = ReturnType<
	typeof useAcademicSubjectPaginationSuspenseQuery
>;
export type AcademicSubjectPaginationQueryResult = Apollo.QueryResult<
	AcademicSubjectPaginationQuery,
	AcademicSubjectPaginationQueryVariables
>;
export const AcademicSubjectSelectDocument = gql`
	query academicSubjectSelect($filters: [AcademicSubjectFilterInput!], $order: AcademicSubjectOrder) {
		academicSubjectConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...AcademicSubjectName
				}
			}
		}
	}
	${AcademicSubjectNameFragmentDoc}
`;

/**
 * __useAcademicSubjectSelectQuery__
 *
 * To run a query within a React component, call `useAcademicSubjectSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicSubjectSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicSubjectSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAcademicSubjectSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<AcademicSubjectSelectQuery, AcademicSubjectSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicSubjectSelectQuery, AcademicSubjectSelectQueryVariables>(
		AcademicSubjectSelectDocument,
		options,
	);
}
export function useAcademicSubjectSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicSubjectSelectQuery, AcademicSubjectSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicSubjectSelectQuery, AcademicSubjectSelectQueryVariables>(
		AcademicSubjectSelectDocument,
		options,
	);
}
export function useAcademicSubjectSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicSubjectSelectQuery, AcademicSubjectSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicSubjectSelectQuery, AcademicSubjectSelectQueryVariables>(
		AcademicSubjectSelectDocument,
		options,
	);
}
export type AcademicSubjectSelectQueryHookResult = ReturnType<typeof useAcademicSubjectSelectQuery>;
export type AcademicSubjectSelectLazyQueryHookResult = ReturnType<typeof useAcademicSubjectSelectLazyQuery>;
export type AcademicSubjectSelectSuspenseQueryHookResult = ReturnType<typeof useAcademicSubjectSelectSuspenseQuery>;
export type AcademicSubjectSelectQueryResult = Apollo.QueryResult<
	AcademicSubjectSelectQuery,
	AcademicSubjectSelectQueryVariables
>;
export const AcademicSubjectUpdateDocument = gql`
	mutation academicSubjectUpdate($id: ID!, $input: AcademicSubjectUpdateInput!) {
		updateAcademicSubject(id: $id, input: $input) {
			...AcademicSubjectDetail
		}
	}
	${AcademicSubjectDetailFragmentDoc}
`;
export type AcademicSubjectUpdateMutationFn = Apollo.MutationFunction<
	AcademicSubjectUpdateMutation,
	AcademicSubjectUpdateMutationVariables
>;

/**
 * __useAcademicSubjectUpdateMutation__
 *
 * To run a mutation, you first call `useAcademicSubjectUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcademicSubjectUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [academicSubjectUpdateMutation, { data, loading, error }] = useAcademicSubjectUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcademicSubjectUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<AcademicSubjectUpdateMutation, AcademicSubjectUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AcademicSubjectUpdateMutation, AcademicSubjectUpdateMutationVariables>(
		AcademicSubjectUpdateDocument,
		options,
	);
}
export type AcademicSubjectUpdateMutationHookResult = ReturnType<typeof useAcademicSubjectUpdateMutation>;
export type AcademicSubjectUpdateMutationResult = Apollo.MutationResult<AcademicSubjectUpdateMutation>;
export type AcademicSubjectUpdateMutationOptions = Apollo.BaseMutationOptions<
	AcademicSubjectUpdateMutation,
	AcademicSubjectUpdateMutationVariables
>;
export const AcademicTermCountDocument = gql`
	query academicTermCount($filters: [AcademicTermFilterInput!], $pagination: Pagination, $order: AcademicTermOrder) {
		academicTermConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useAcademicTermCountQuery__
 *
 * To run a query within a React component, call `useAcademicTermCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicTermCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicTermCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAcademicTermCountQuery(
	baseOptions?: Apollo.QueryHookOptions<AcademicTermCountQuery, AcademicTermCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicTermCountQuery, AcademicTermCountQueryVariables>(AcademicTermCountDocument, options);
}
export function useAcademicTermCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicTermCountQuery, AcademicTermCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicTermCountQuery, AcademicTermCountQueryVariables>(
		AcademicTermCountDocument,
		options,
	);
}
export function useAcademicTermCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicTermCountQuery, AcademicTermCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicTermCountQuery, AcademicTermCountQueryVariables>(
		AcademicTermCountDocument,
		options,
	);
}
export type AcademicTermCountQueryHookResult = ReturnType<typeof useAcademicTermCountQuery>;
export type AcademicTermCountLazyQueryHookResult = ReturnType<typeof useAcademicTermCountLazyQuery>;
export type AcademicTermCountSuspenseQueryHookResult = ReturnType<typeof useAcademicTermCountSuspenseQuery>;
export type AcademicTermCountQueryResult = Apollo.QueryResult<AcademicTermCountQuery, AcademicTermCountQueryVariables>;
export const AcademicTermCreateDocument = gql`
	mutation academicTermCreate($input: AcademicTermCreateInput!) {
		createAcademicTerm(input: $input) {
			...AcademicTermDetail
		}
	}
	${AcademicTermDetailFragmentDoc}
`;
export type AcademicTermCreateMutationFn = Apollo.MutationFunction<
	AcademicTermCreateMutation,
	AcademicTermCreateMutationVariables
>;

/**
 * __useAcademicTermCreateMutation__
 *
 * To run a mutation, you first call `useAcademicTermCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcademicTermCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [academicTermCreateMutation, { data, loading, error }] = useAcademicTermCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcademicTermCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<AcademicTermCreateMutation, AcademicTermCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AcademicTermCreateMutation, AcademicTermCreateMutationVariables>(
		AcademicTermCreateDocument,
		options,
	);
}
export type AcademicTermCreateMutationHookResult = ReturnType<typeof useAcademicTermCreateMutation>;
export type AcademicTermCreateMutationResult = Apollo.MutationResult<AcademicTermCreateMutation>;
export type AcademicTermCreateMutationOptions = Apollo.BaseMutationOptions<
	AcademicTermCreateMutation,
	AcademicTermCreateMutationVariables
>;
export const AcademicTermsDatesListDocument = gql`
	query academicTermsDatesList(
		$filters: [AcademicTermFilterInput!]
		$pagination: Pagination
		$order: AcademicTermOrder
	) {
		academicTermConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					startDate
					endDate
					academicYear {
						id
						name
					}
				}
			}
		}
	}
`;

/**
 * __useAcademicTermsDatesListQuery__
 *
 * To run a query within a React component, call `useAcademicTermsDatesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicTermsDatesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicTermsDatesListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAcademicTermsDatesListQuery(
	baseOptions?: Apollo.QueryHookOptions<AcademicTermsDatesListQuery, AcademicTermsDatesListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicTermsDatesListQuery, AcademicTermsDatesListQueryVariables>(
		AcademicTermsDatesListDocument,
		options,
	);
}
export function useAcademicTermsDatesListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicTermsDatesListQuery, AcademicTermsDatesListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicTermsDatesListQuery, AcademicTermsDatesListQueryVariables>(
		AcademicTermsDatesListDocument,
		options,
	);
}
export function useAcademicTermsDatesListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicTermsDatesListQuery, AcademicTermsDatesListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicTermsDatesListQuery, AcademicTermsDatesListQueryVariables>(
		AcademicTermsDatesListDocument,
		options,
	);
}
export type AcademicTermsDatesListQueryHookResult = ReturnType<typeof useAcademicTermsDatesListQuery>;
export type AcademicTermsDatesListLazyQueryHookResult = ReturnType<typeof useAcademicTermsDatesListLazyQuery>;
export type AcademicTermsDatesListSuspenseQueryHookResult = ReturnType<typeof useAcademicTermsDatesListSuspenseQuery>;
export type AcademicTermsDatesListQueryResult = Apollo.QueryResult<
	AcademicTermsDatesListQuery,
	AcademicTermsDatesListQueryVariables
>;
export const AcademicTermDatesDocument = gql`
	query academicTermDates($id: ID!) {
		academicTerm(id: $id) {
			id
			name
			startDate
			endDate
			academicYear {
				id
				name
			}
		}
	}
`;

/**
 * __useAcademicTermDatesQuery__
 *
 * To run a query within a React component, call `useAcademicTermDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicTermDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicTermDatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcademicTermDatesQuery(
	baseOptions: Apollo.QueryHookOptions<AcademicTermDatesQuery, AcademicTermDatesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicTermDatesQuery, AcademicTermDatesQueryVariables>(AcademicTermDatesDocument, options);
}
export function useAcademicTermDatesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicTermDatesQuery, AcademicTermDatesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicTermDatesQuery, AcademicTermDatesQueryVariables>(
		AcademicTermDatesDocument,
		options,
	);
}
export function useAcademicTermDatesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicTermDatesQuery, AcademicTermDatesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicTermDatesQuery, AcademicTermDatesQueryVariables>(
		AcademicTermDatesDocument,
		options,
	);
}
export type AcademicTermDatesQueryHookResult = ReturnType<typeof useAcademicTermDatesQuery>;
export type AcademicTermDatesLazyQueryHookResult = ReturnType<typeof useAcademicTermDatesLazyQuery>;
export type AcademicTermDatesSuspenseQueryHookResult = ReturnType<typeof useAcademicTermDatesSuspenseQuery>;
export type AcademicTermDatesQueryResult = Apollo.QueryResult<AcademicTermDatesQuery, AcademicTermDatesQueryVariables>;
export const AcademicTermsPreviousAndNextDocument = gql`
	query academicTermsPreviousAndNext($id: ID!, $date: Date!) {
		previous: academicTermConnection(
			filters: { idNEQ: $id, startDateLT: $date }
			order: { field: START_DATE, direction: DESC }
			pagination: { first: 1 }
		) {
			edges {
				node {
					id
					name
					startDate
					endDate
					academicYear {
						id
						name
					}
				}
			}
		}
		next: academicTermConnection(
			filters: { idNEQ: $id, startDateGT: $date }
			order: { field: START_DATE, direction: ASC }
			pagination: { first: 1 }
		) {
			edges {
				node {
					id
					name
					startDate
					endDate
					academicYear {
						id
						name
					}
				}
			}
		}
	}
`;

/**
 * __useAcademicTermsPreviousAndNextQuery__
 *
 * To run a query within a React component, call `useAcademicTermsPreviousAndNextQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicTermsPreviousAndNextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicTermsPreviousAndNextQuery({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useAcademicTermsPreviousAndNextQuery(
	baseOptions: Apollo.QueryHookOptions<AcademicTermsPreviousAndNextQuery, AcademicTermsPreviousAndNextQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicTermsPreviousAndNextQuery, AcademicTermsPreviousAndNextQueryVariables>(
		AcademicTermsPreviousAndNextDocument,
		options,
	);
}
export function useAcademicTermsPreviousAndNextLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		AcademicTermsPreviousAndNextQuery,
		AcademicTermsPreviousAndNextQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicTermsPreviousAndNextQuery, AcademicTermsPreviousAndNextQueryVariables>(
		AcademicTermsPreviousAndNextDocument,
		options,
	);
}
export function useAcademicTermsPreviousAndNextSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		AcademicTermsPreviousAndNextQuery,
		AcademicTermsPreviousAndNextQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicTermsPreviousAndNextQuery, AcademicTermsPreviousAndNextQueryVariables>(
		AcademicTermsPreviousAndNextDocument,
		options,
	);
}
export type AcademicTermsPreviousAndNextQueryHookResult = ReturnType<typeof useAcademicTermsPreviousAndNextQuery>;
export type AcademicTermsPreviousAndNextLazyQueryHookResult = ReturnType<
	typeof useAcademicTermsPreviousAndNextLazyQuery
>;
export type AcademicTermsPreviousAndNextSuspenseQueryHookResult = ReturnType<
	typeof useAcademicTermsPreviousAndNextSuspenseQuery
>;
export type AcademicTermsPreviousAndNextQueryResult = Apollo.QueryResult<
	AcademicTermsPreviousAndNextQuery,
	AcademicTermsPreviousAndNextQueryVariables
>;
export const AcademicTermDeleteDocument = gql`
	mutation academicTermDelete($id: ID!) {
		deleteAcademicTerm(id: $id)
	}
`;
export type AcademicTermDeleteMutationFn = Apollo.MutationFunction<
	AcademicTermDeleteMutation,
	AcademicTermDeleteMutationVariables
>;

/**
 * __useAcademicTermDeleteMutation__
 *
 * To run a mutation, you first call `useAcademicTermDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcademicTermDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [academicTermDeleteMutation, { data, loading, error }] = useAcademicTermDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcademicTermDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<AcademicTermDeleteMutation, AcademicTermDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AcademicTermDeleteMutation, AcademicTermDeleteMutationVariables>(
		AcademicTermDeleteDocument,
		options,
	);
}
export type AcademicTermDeleteMutationHookResult = ReturnType<typeof useAcademicTermDeleteMutation>;
export type AcademicTermDeleteMutationResult = Apollo.MutationResult<AcademicTermDeleteMutation>;
export type AcademicTermDeleteMutationOptions = Apollo.BaseMutationOptions<
	AcademicTermDeleteMutation,
	AcademicTermDeleteMutationVariables
>;
export const AcademicTermDetailDocument = gql`
	query academicTermDetail($id: ID!) {
		academicTerm(id: $id) {
			...AcademicTermDetail
		}
	}
	${AcademicTermDetailFragmentDoc}
`;

/**
 * __useAcademicTermDetailQuery__
 *
 * To run a query within a React component, call `useAcademicTermDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicTermDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicTermDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcademicTermDetailQuery(
	baseOptions: Apollo.QueryHookOptions<AcademicTermDetailQuery, AcademicTermDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicTermDetailQuery, AcademicTermDetailQueryVariables>(
		AcademicTermDetailDocument,
		options,
	);
}
export function useAcademicTermDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicTermDetailQuery, AcademicTermDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicTermDetailQuery, AcademicTermDetailQueryVariables>(
		AcademicTermDetailDocument,
		options,
	);
}
export function useAcademicTermDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicTermDetailQuery, AcademicTermDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicTermDetailQuery, AcademicTermDetailQueryVariables>(
		AcademicTermDetailDocument,
		options,
	);
}
export type AcademicTermDetailQueryHookResult = ReturnType<typeof useAcademicTermDetailQuery>;
export type AcademicTermDetailLazyQueryHookResult = ReturnType<typeof useAcademicTermDetailLazyQuery>;
export type AcademicTermDetailSuspenseQueryHookResult = ReturnType<typeof useAcademicTermDetailSuspenseQuery>;
export type AcademicTermDetailQueryResult = Apollo.QueryResult<
	AcademicTermDetailQuery,
	AcademicTermDetailQueryVariables
>;
export const AcademicTermIndexDocument = gql`
	query academicTermIndex($filters: [AcademicTermFilterInput!], $pagination: Pagination, $order: AcademicTermOrder) {
		academicTermConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					startDate
					endDate
					studentAcademicTermEnrollments {
						id
						lateStartDate
						earlyEndDate
					}
				}
			}
		}
	}
`;

/**
 * __useAcademicTermIndexQuery__
 *
 * To run a query within a React component, call `useAcademicTermIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicTermIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicTermIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAcademicTermIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<AcademicTermIndexQuery, AcademicTermIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicTermIndexQuery, AcademicTermIndexQueryVariables>(AcademicTermIndexDocument, options);
}
export function useAcademicTermIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicTermIndexQuery, AcademicTermIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicTermIndexQuery, AcademicTermIndexQueryVariables>(
		AcademicTermIndexDocument,
		options,
	);
}
export function useAcademicTermIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicTermIndexQuery, AcademicTermIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicTermIndexQuery, AcademicTermIndexQueryVariables>(
		AcademicTermIndexDocument,
		options,
	);
}
export type AcademicTermIndexQueryHookResult = ReturnType<typeof useAcademicTermIndexQuery>;
export type AcademicTermIndexLazyQueryHookResult = ReturnType<typeof useAcademicTermIndexLazyQuery>;
export type AcademicTermIndexSuspenseQueryHookResult = ReturnType<typeof useAcademicTermIndexSuspenseQuery>;
export type AcademicTermIndexQueryResult = Apollo.QueryResult<AcademicTermIndexQuery, AcademicTermIndexQueryVariables>;
export const AcademicTermNameDocument = gql`
	query academicTermName($id: ID!) {
		academicTerm(id: $id) {
			id
			...AcademicTermName
		}
	}
	${AcademicTermNameFragmentDoc}
`;

/**
 * __useAcademicTermNameQuery__
 *
 * To run a query within a React component, call `useAcademicTermNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicTermNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicTermNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcademicTermNameQuery(
	baseOptions: Apollo.QueryHookOptions<AcademicTermNameQuery, AcademicTermNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicTermNameQuery, AcademicTermNameQueryVariables>(AcademicTermNameDocument, options);
}
export function useAcademicTermNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicTermNameQuery, AcademicTermNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicTermNameQuery, AcademicTermNameQueryVariables>(AcademicTermNameDocument, options);
}
export function useAcademicTermNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicTermNameQuery, AcademicTermNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicTermNameQuery, AcademicTermNameQueryVariables>(
		AcademicTermNameDocument,
		options,
	);
}
export type AcademicTermNameQueryHookResult = ReturnType<typeof useAcademicTermNameQuery>;
export type AcademicTermNameLazyQueryHookResult = ReturnType<typeof useAcademicTermNameLazyQuery>;
export type AcademicTermNameSuspenseQueryHookResult = ReturnType<typeof useAcademicTermNameSuspenseQuery>;
export type AcademicTermNameQueryResult = Apollo.QueryResult<AcademicTermNameQuery, AcademicTermNameQueryVariables>;
export const AcademicTermNamesDocument = gql`
	query academicTermNames($filters: [AcademicTermFilterInput!], $pagination: Pagination, $order: AcademicTermOrder) {
		academicTermConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...AcademicTermName
				}
			}
		}
	}
	${AcademicTermNameFragmentDoc}
`;

/**
 * __useAcademicTermNamesQuery__
 *
 * To run a query within a React component, call `useAcademicTermNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicTermNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicTermNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAcademicTermNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<AcademicTermNamesQuery, AcademicTermNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicTermNamesQuery, AcademicTermNamesQueryVariables>(AcademicTermNamesDocument, options);
}
export function useAcademicTermNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicTermNamesQuery, AcademicTermNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicTermNamesQuery, AcademicTermNamesQueryVariables>(
		AcademicTermNamesDocument,
		options,
	);
}
export function useAcademicTermNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicTermNamesQuery, AcademicTermNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicTermNamesQuery, AcademicTermNamesQueryVariables>(
		AcademicTermNamesDocument,
		options,
	);
}
export type AcademicTermNamesQueryHookResult = ReturnType<typeof useAcademicTermNamesQuery>;
export type AcademicTermNamesLazyQueryHookResult = ReturnType<typeof useAcademicTermNamesLazyQuery>;
export type AcademicTermNamesSuspenseQueryHookResult = ReturnType<typeof useAcademicTermNamesSuspenseQuery>;
export type AcademicTermNamesQueryResult = Apollo.QueryResult<AcademicTermNamesQuery, AcademicTermNamesQueryVariables>;
export const AcademicTermPaginationDocument = gql`
	query academicTermPagination($filters: [AcademicTermFilterInput!], $order: AcademicTermOrder) {
		academicTermConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useAcademicTermPaginationQuery__
 *
 * To run a query within a React component, call `useAcademicTermPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicTermPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicTermPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAcademicTermPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<AcademicTermPaginationQuery, AcademicTermPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicTermPaginationQuery, AcademicTermPaginationQueryVariables>(
		AcademicTermPaginationDocument,
		options,
	);
}
export function useAcademicTermPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicTermPaginationQuery, AcademicTermPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicTermPaginationQuery, AcademicTermPaginationQueryVariables>(
		AcademicTermPaginationDocument,
		options,
	);
}
export function useAcademicTermPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicTermPaginationQuery, AcademicTermPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicTermPaginationQuery, AcademicTermPaginationQueryVariables>(
		AcademicTermPaginationDocument,
		options,
	);
}
export type AcademicTermPaginationQueryHookResult = ReturnType<typeof useAcademicTermPaginationQuery>;
export type AcademicTermPaginationLazyQueryHookResult = ReturnType<typeof useAcademicTermPaginationLazyQuery>;
export type AcademicTermPaginationSuspenseQueryHookResult = ReturnType<typeof useAcademicTermPaginationSuspenseQuery>;
export type AcademicTermPaginationQueryResult = Apollo.QueryResult<
	AcademicTermPaginationQuery,
	AcademicTermPaginationQueryVariables
>;
export const AcademicTermSelectDocument = gql`
	query academicTermSelect($filters: [AcademicTermFilterInput!], $order: AcademicTermOrder) {
		academicTermConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...AcademicTermName
				}
			}
		}
	}
	${AcademicTermNameFragmentDoc}
`;

/**
 * __useAcademicTermSelectQuery__
 *
 * To run a query within a React component, call `useAcademicTermSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicTermSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicTermSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAcademicTermSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<AcademicTermSelectQuery, AcademicTermSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicTermSelectQuery, AcademicTermSelectQueryVariables>(
		AcademicTermSelectDocument,
		options,
	);
}
export function useAcademicTermSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicTermSelectQuery, AcademicTermSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicTermSelectQuery, AcademicTermSelectQueryVariables>(
		AcademicTermSelectDocument,
		options,
	);
}
export function useAcademicTermSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicTermSelectQuery, AcademicTermSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicTermSelectQuery, AcademicTermSelectQueryVariables>(
		AcademicTermSelectDocument,
		options,
	);
}
export type AcademicTermSelectQueryHookResult = ReturnType<typeof useAcademicTermSelectQuery>;
export type AcademicTermSelectLazyQueryHookResult = ReturnType<typeof useAcademicTermSelectLazyQuery>;
export type AcademicTermSelectSuspenseQueryHookResult = ReturnType<typeof useAcademicTermSelectSuspenseQuery>;
export type AcademicTermSelectQueryResult = Apollo.QueryResult<
	AcademicTermSelectQuery,
	AcademicTermSelectQueryVariables
>;
export const AcademicTermUpdateDocument = gql`
	mutation academicTermUpdate($id: ID!, $input: AcademicTermUpdateInput!) {
		updateAcademicTerm(id: $id, input: $input) {
			...AcademicTermDetail
		}
	}
	${AcademicTermDetailFragmentDoc}
`;
export type AcademicTermUpdateMutationFn = Apollo.MutationFunction<
	AcademicTermUpdateMutation,
	AcademicTermUpdateMutationVariables
>;

/**
 * __useAcademicTermUpdateMutation__
 *
 * To run a mutation, you first call `useAcademicTermUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcademicTermUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [academicTermUpdateMutation, { data, loading, error }] = useAcademicTermUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcademicTermUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<AcademicTermUpdateMutation, AcademicTermUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AcademicTermUpdateMutation, AcademicTermUpdateMutationVariables>(
		AcademicTermUpdateDocument,
		options,
	);
}
export type AcademicTermUpdateMutationHookResult = ReturnType<typeof useAcademicTermUpdateMutation>;
export type AcademicTermUpdateMutationResult = Apollo.MutationResult<AcademicTermUpdateMutation>;
export type AcademicTermUpdateMutationOptions = Apollo.BaseMutationOptions<
	AcademicTermUpdateMutation,
	AcademicTermUpdateMutationVariables
>;
export const AcademicYearCountDocument = gql`
	query academicYearCount($filters: [AcademicYearFilterInput!], $pagination: Pagination, $order: AcademicYearOrder) {
		academicYearConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useAcademicYearCountQuery__
 *
 * To run a query within a React component, call `useAcademicYearCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicYearCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicYearCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAcademicYearCountQuery(
	baseOptions?: Apollo.QueryHookOptions<AcademicYearCountQuery, AcademicYearCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicYearCountQuery, AcademicYearCountQueryVariables>(AcademicYearCountDocument, options);
}
export function useAcademicYearCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicYearCountQuery, AcademicYearCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicYearCountQuery, AcademicYearCountQueryVariables>(
		AcademicYearCountDocument,
		options,
	);
}
export function useAcademicYearCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicYearCountQuery, AcademicYearCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicYearCountQuery, AcademicYearCountQueryVariables>(
		AcademicYearCountDocument,
		options,
	);
}
export type AcademicYearCountQueryHookResult = ReturnType<typeof useAcademicYearCountQuery>;
export type AcademicYearCountLazyQueryHookResult = ReturnType<typeof useAcademicYearCountLazyQuery>;
export type AcademicYearCountSuspenseQueryHookResult = ReturnType<typeof useAcademicYearCountSuspenseQuery>;
export type AcademicYearCountQueryResult = Apollo.QueryResult<AcademicYearCountQuery, AcademicYearCountQueryVariables>;
export const AcademicYearCreateDocument = gql`
	mutation academicYearCreate($input: AcademicYearCreateInput!) {
		createAcademicYear(input: $input) {
			...AcademicYearDetail
		}
	}
	${AcademicYearDetailFragmentDoc}
`;
export type AcademicYearCreateMutationFn = Apollo.MutationFunction<
	AcademicYearCreateMutation,
	AcademicYearCreateMutationVariables
>;

/**
 * __useAcademicYearCreateMutation__
 *
 * To run a mutation, you first call `useAcademicYearCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcademicYearCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [academicYearCreateMutation, { data, loading, error }] = useAcademicYearCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcademicYearCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<AcademicYearCreateMutation, AcademicYearCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AcademicYearCreateMutation, AcademicYearCreateMutationVariables>(
		AcademicYearCreateDocument,
		options,
	);
}
export type AcademicYearCreateMutationHookResult = ReturnType<typeof useAcademicYearCreateMutation>;
export type AcademicYearCreateMutationResult = Apollo.MutationResult<AcademicYearCreateMutation>;
export type AcademicYearCreateMutationOptions = Apollo.BaseMutationOptions<
	AcademicYearCreateMutation,
	AcademicYearCreateMutationVariables
>;
export const AcademicYearDeleteDocument = gql`
	mutation academicYearDelete($id: ID!) {
		deleteAcademicYear(id: $id)
	}
`;
export type AcademicYearDeleteMutationFn = Apollo.MutationFunction<
	AcademicYearDeleteMutation,
	AcademicYearDeleteMutationVariables
>;

/**
 * __useAcademicYearDeleteMutation__
 *
 * To run a mutation, you first call `useAcademicYearDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcademicYearDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [academicYearDeleteMutation, { data, loading, error }] = useAcademicYearDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcademicYearDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<AcademicYearDeleteMutation, AcademicYearDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AcademicYearDeleteMutation, AcademicYearDeleteMutationVariables>(
		AcademicYearDeleteDocument,
		options,
	);
}
export type AcademicYearDeleteMutationHookResult = ReturnType<typeof useAcademicYearDeleteMutation>;
export type AcademicYearDeleteMutationResult = Apollo.MutationResult<AcademicYearDeleteMutation>;
export type AcademicYearDeleteMutationOptions = Apollo.BaseMutationOptions<
	AcademicYearDeleteMutation,
	AcademicYearDeleteMutationVariables
>;
export const AcademicYearDetailDocument = gql`
	query academicYearDetail($id: ID!) {
		academicYear(id: $id) {
			...AcademicYearDetail
		}
	}
	${AcademicYearDetailFragmentDoc}
`;

/**
 * __useAcademicYearDetailQuery__
 *
 * To run a query within a React component, call `useAcademicYearDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicYearDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicYearDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcademicYearDetailQuery(
	baseOptions: Apollo.QueryHookOptions<AcademicYearDetailQuery, AcademicYearDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicYearDetailQuery, AcademicYearDetailQueryVariables>(
		AcademicYearDetailDocument,
		options,
	);
}
export function useAcademicYearDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicYearDetailQuery, AcademicYearDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicYearDetailQuery, AcademicYearDetailQueryVariables>(
		AcademicYearDetailDocument,
		options,
	);
}
export function useAcademicYearDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicYearDetailQuery, AcademicYearDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicYearDetailQuery, AcademicYearDetailQueryVariables>(
		AcademicYearDetailDocument,
		options,
	);
}
export type AcademicYearDetailQueryHookResult = ReturnType<typeof useAcademicYearDetailQuery>;
export type AcademicYearDetailLazyQueryHookResult = ReturnType<typeof useAcademicYearDetailLazyQuery>;
export type AcademicYearDetailSuspenseQueryHookResult = ReturnType<typeof useAcademicYearDetailSuspenseQuery>;
export type AcademicYearDetailQueryResult = Apollo.QueryResult<
	AcademicYearDetailQuery,
	AcademicYearDetailQueryVariables
>;
export const AcademicYearIndexDocument = gql`
	query academicYearIndex($filters: [AcademicYearFilterInput!], $pagination: Pagination, $order: AcademicYearOrder) {
		academicYearConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					academicTerms {
						id
						...AcademicTermName
						startDate
						endDate
					}
				}
			}
		}
	}
	${AcademicTermNameFragmentDoc}
`;

/**
 * __useAcademicYearIndexQuery__
 *
 * To run a query within a React component, call `useAcademicYearIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicYearIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicYearIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAcademicYearIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<AcademicYearIndexQuery, AcademicYearIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicYearIndexQuery, AcademicYearIndexQueryVariables>(AcademicYearIndexDocument, options);
}
export function useAcademicYearIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicYearIndexQuery, AcademicYearIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicYearIndexQuery, AcademicYearIndexQueryVariables>(
		AcademicYearIndexDocument,
		options,
	);
}
export function useAcademicYearIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicYearIndexQuery, AcademicYearIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicYearIndexQuery, AcademicYearIndexQueryVariables>(
		AcademicYearIndexDocument,
		options,
	);
}
export type AcademicYearIndexQueryHookResult = ReturnType<typeof useAcademicYearIndexQuery>;
export type AcademicYearIndexLazyQueryHookResult = ReturnType<typeof useAcademicYearIndexLazyQuery>;
export type AcademicYearIndexSuspenseQueryHookResult = ReturnType<typeof useAcademicYearIndexSuspenseQuery>;
export type AcademicYearIndexQueryResult = Apollo.QueryResult<AcademicYearIndexQuery, AcademicYearIndexQueryVariables>;
export const AcademicYearNameDocument = gql`
	query academicYearName($id: ID!) {
		academicYear(id: $id) {
			id
			...AcademicYearName
		}
	}
	${AcademicYearNameFragmentDoc}
`;

/**
 * __useAcademicYearNameQuery__
 *
 * To run a query within a React component, call `useAcademicYearNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicYearNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicYearNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcademicYearNameQuery(
	baseOptions: Apollo.QueryHookOptions<AcademicYearNameQuery, AcademicYearNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicYearNameQuery, AcademicYearNameQueryVariables>(AcademicYearNameDocument, options);
}
export function useAcademicYearNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicYearNameQuery, AcademicYearNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicYearNameQuery, AcademicYearNameQueryVariables>(AcademicYearNameDocument, options);
}
export function useAcademicYearNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicYearNameQuery, AcademicYearNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicYearNameQuery, AcademicYearNameQueryVariables>(
		AcademicYearNameDocument,
		options,
	);
}
export type AcademicYearNameQueryHookResult = ReturnType<typeof useAcademicYearNameQuery>;
export type AcademicYearNameLazyQueryHookResult = ReturnType<typeof useAcademicYearNameLazyQuery>;
export type AcademicYearNameSuspenseQueryHookResult = ReturnType<typeof useAcademicYearNameSuspenseQuery>;
export type AcademicYearNameQueryResult = Apollo.QueryResult<AcademicYearNameQuery, AcademicYearNameQueryVariables>;
export const AcademicYearNamesDocument = gql`
	query academicYearNames($filters: [AcademicYearFilterInput!], $pagination: Pagination, $order: AcademicYearOrder) {
		academicYearConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...AcademicYearName
				}
			}
		}
	}
	${AcademicYearNameFragmentDoc}
`;

/**
 * __useAcademicYearNamesQuery__
 *
 * To run a query within a React component, call `useAcademicYearNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicYearNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicYearNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAcademicYearNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<AcademicYearNamesQuery, AcademicYearNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicYearNamesQuery, AcademicYearNamesQueryVariables>(AcademicYearNamesDocument, options);
}
export function useAcademicYearNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicYearNamesQuery, AcademicYearNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicYearNamesQuery, AcademicYearNamesQueryVariables>(
		AcademicYearNamesDocument,
		options,
	);
}
export function useAcademicYearNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicYearNamesQuery, AcademicYearNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicYearNamesQuery, AcademicYearNamesQueryVariables>(
		AcademicYearNamesDocument,
		options,
	);
}
export type AcademicYearNamesQueryHookResult = ReturnType<typeof useAcademicYearNamesQuery>;
export type AcademicYearNamesLazyQueryHookResult = ReturnType<typeof useAcademicYearNamesLazyQuery>;
export type AcademicYearNamesSuspenseQueryHookResult = ReturnType<typeof useAcademicYearNamesSuspenseQuery>;
export type AcademicYearNamesQueryResult = Apollo.QueryResult<AcademicYearNamesQuery, AcademicYearNamesQueryVariables>;
export const AcademicYearPaginationDocument = gql`
	query academicYearPagination($filters: [AcademicYearFilterInput!], $order: AcademicYearOrder) {
		academicYearConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useAcademicYearPaginationQuery__
 *
 * To run a query within a React component, call `useAcademicYearPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicYearPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicYearPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAcademicYearPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<AcademicYearPaginationQuery, AcademicYearPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicYearPaginationQuery, AcademicYearPaginationQueryVariables>(
		AcademicYearPaginationDocument,
		options,
	);
}
export function useAcademicYearPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicYearPaginationQuery, AcademicYearPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicYearPaginationQuery, AcademicYearPaginationQueryVariables>(
		AcademicYearPaginationDocument,
		options,
	);
}
export function useAcademicYearPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicYearPaginationQuery, AcademicYearPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicYearPaginationQuery, AcademicYearPaginationQueryVariables>(
		AcademicYearPaginationDocument,
		options,
	);
}
export type AcademicYearPaginationQueryHookResult = ReturnType<typeof useAcademicYearPaginationQuery>;
export type AcademicYearPaginationLazyQueryHookResult = ReturnType<typeof useAcademicYearPaginationLazyQuery>;
export type AcademicYearPaginationSuspenseQueryHookResult = ReturnType<typeof useAcademicYearPaginationSuspenseQuery>;
export type AcademicYearPaginationQueryResult = Apollo.QueryResult<
	AcademicYearPaginationQuery,
	AcademicYearPaginationQueryVariables
>;
export const AcademicYearSelectDocument = gql`
	query academicYearSelect($filters: [AcademicYearFilterInput!], $order: AcademicYearOrder) {
		academicYearConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...AcademicYearName
				}
			}
		}
	}
	${AcademicYearNameFragmentDoc}
`;

/**
 * __useAcademicYearSelectQuery__
 *
 * To run a query within a React component, call `useAcademicYearSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicYearSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicYearSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAcademicYearSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<AcademicYearSelectQuery, AcademicYearSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AcademicYearSelectQuery, AcademicYearSelectQueryVariables>(
		AcademicYearSelectDocument,
		options,
	);
}
export function useAcademicYearSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AcademicYearSelectQuery, AcademicYearSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AcademicYearSelectQuery, AcademicYearSelectQueryVariables>(
		AcademicYearSelectDocument,
		options,
	);
}
export function useAcademicYearSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AcademicYearSelectQuery, AcademicYearSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AcademicYearSelectQuery, AcademicYearSelectQueryVariables>(
		AcademicYearSelectDocument,
		options,
	);
}
export type AcademicYearSelectQueryHookResult = ReturnType<typeof useAcademicYearSelectQuery>;
export type AcademicYearSelectLazyQueryHookResult = ReturnType<typeof useAcademicYearSelectLazyQuery>;
export type AcademicYearSelectSuspenseQueryHookResult = ReturnType<typeof useAcademicYearSelectSuspenseQuery>;
export type AcademicYearSelectQueryResult = Apollo.QueryResult<
	AcademicYearSelectQuery,
	AcademicYearSelectQueryVariables
>;
export const AcademicYearUpdateDocument = gql`
	mutation academicYearUpdate($id: ID!, $input: AcademicYearUpdateInput!) {
		updateAcademicYear(id: $id, input: $input) {
			...AcademicYearDetail
		}
	}
	${AcademicYearDetailFragmentDoc}
`;
export type AcademicYearUpdateMutationFn = Apollo.MutationFunction<
	AcademicYearUpdateMutation,
	AcademicYearUpdateMutationVariables
>;

/**
 * __useAcademicYearUpdateMutation__
 *
 * To run a mutation, you first call `useAcademicYearUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcademicYearUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [academicYearUpdateMutation, { data, loading, error }] = useAcademicYearUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcademicYearUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<AcademicYearUpdateMutation, AcademicYearUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AcademicYearUpdateMutation, AcademicYearUpdateMutationVariables>(
		AcademicYearUpdateDocument,
		options,
	);
}
export type AcademicYearUpdateMutationHookResult = ReturnType<typeof useAcademicYearUpdateMutation>;
export type AcademicYearUpdateMutationResult = Apollo.MutationResult<AcademicYearUpdateMutation>;
export type AcademicYearUpdateMutationOptions = Apollo.BaseMutationOptions<
	AcademicYearUpdateMutation,
	AcademicYearUpdateMutationVariables
>;
export const AddressCountDocument = gql`
	query addressCount($filters: [AddressFilterInput!], $pagination: Pagination, $order: AddressOrder) {
		addressConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useAddressCountQuery__
 *
 * To run a query within a React component, call `useAddressCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAddressCountQuery(
	baseOptions?: Apollo.QueryHookOptions<AddressCountQuery, AddressCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AddressCountQuery, AddressCountQueryVariables>(AddressCountDocument, options);
}
export function useAddressCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AddressCountQuery, AddressCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AddressCountQuery, AddressCountQueryVariables>(AddressCountDocument, options);
}
export function useAddressCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AddressCountQuery, AddressCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AddressCountQuery, AddressCountQueryVariables>(AddressCountDocument, options);
}
export type AddressCountQueryHookResult = ReturnType<typeof useAddressCountQuery>;
export type AddressCountLazyQueryHookResult = ReturnType<typeof useAddressCountLazyQuery>;
export type AddressCountSuspenseQueryHookResult = ReturnType<typeof useAddressCountSuspenseQuery>;
export type AddressCountQueryResult = Apollo.QueryResult<AddressCountQuery, AddressCountQueryVariables>;
export const AddressCreateDocument = gql`
	mutation addressCreate($input: AddressCreateInput!) {
		createAddress(input: $input) {
			...AddressDetail
		}
	}
	${AddressDetailFragmentDoc}
`;
export type AddressCreateMutationFn = Apollo.MutationFunction<AddressCreateMutation, AddressCreateMutationVariables>;

/**
 * __useAddressCreateMutation__
 *
 * To run a mutation, you first call `useAddressCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddressCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addressCreateMutation, { data, loading, error }] = useAddressCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddressCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<AddressCreateMutation, AddressCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AddressCreateMutation, AddressCreateMutationVariables>(AddressCreateDocument, options);
}
export type AddressCreateMutationHookResult = ReturnType<typeof useAddressCreateMutation>;
export type AddressCreateMutationResult = Apollo.MutationResult<AddressCreateMutation>;
export type AddressCreateMutationOptions = Apollo.BaseMutationOptions<
	AddressCreateMutation,
	AddressCreateMutationVariables
>;
export const AddressDeleteDocument = gql`
	mutation addressDelete($id: ID!) {
		deleteAddress(id: $id)
	}
`;
export type AddressDeleteMutationFn = Apollo.MutationFunction<AddressDeleteMutation, AddressDeleteMutationVariables>;

/**
 * __useAddressDeleteMutation__
 *
 * To run a mutation, you first call `useAddressDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddressDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addressDeleteMutation, { data, loading, error }] = useAddressDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddressDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<AddressDeleteMutation, AddressDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AddressDeleteMutation, AddressDeleteMutationVariables>(AddressDeleteDocument, options);
}
export type AddressDeleteMutationHookResult = ReturnType<typeof useAddressDeleteMutation>;
export type AddressDeleteMutationResult = Apollo.MutationResult<AddressDeleteMutation>;
export type AddressDeleteMutationOptions = Apollo.BaseMutationOptions<
	AddressDeleteMutation,
	AddressDeleteMutationVariables
>;
export const AddressDetailDocument = gql`
	query addressDetail($id: ID!) {
		address(id: $id) {
			...AddressDetail
		}
	}
	${AddressDetailFragmentDoc}
`;

/**
 * __useAddressDetailQuery__
 *
 * To run a query within a React component, call `useAddressDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddressDetailQuery(
	baseOptions: Apollo.QueryHookOptions<AddressDetailQuery, AddressDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AddressDetailQuery, AddressDetailQueryVariables>(AddressDetailDocument, options);
}
export function useAddressDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AddressDetailQuery, AddressDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AddressDetailQuery, AddressDetailQueryVariables>(AddressDetailDocument, options);
}
export function useAddressDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AddressDetailQuery, AddressDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AddressDetailQuery, AddressDetailQueryVariables>(AddressDetailDocument, options);
}
export type AddressDetailQueryHookResult = ReturnType<typeof useAddressDetailQuery>;
export type AddressDetailLazyQueryHookResult = ReturnType<typeof useAddressDetailLazyQuery>;
export type AddressDetailSuspenseQueryHookResult = ReturnType<typeof useAddressDetailSuspenseQuery>;
export type AddressDetailQueryResult = Apollo.QueryResult<AddressDetailQuery, AddressDetailQueryVariables>;
export const AddressIndexDocument = gql`
	query addressIndex($filters: [AddressFilterInput!], $pagination: Pagination, $order: AddressOrder) {
		addressConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					addressLine1
					addressLine2
					city
					postalCode
					stateOrProvince
					country {
						id
						...CountryName
					}
				}
			}
		}
	}
	${CountryNameFragmentDoc}
`;

/**
 * __useAddressIndexQuery__
 *
 * To run a query within a React component, call `useAddressIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAddressIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<AddressIndexQuery, AddressIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AddressIndexQuery, AddressIndexQueryVariables>(AddressIndexDocument, options);
}
export function useAddressIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AddressIndexQuery, AddressIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AddressIndexQuery, AddressIndexQueryVariables>(AddressIndexDocument, options);
}
export function useAddressIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AddressIndexQuery, AddressIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AddressIndexQuery, AddressIndexQueryVariables>(AddressIndexDocument, options);
}
export type AddressIndexQueryHookResult = ReturnType<typeof useAddressIndexQuery>;
export type AddressIndexLazyQueryHookResult = ReturnType<typeof useAddressIndexLazyQuery>;
export type AddressIndexSuspenseQueryHookResult = ReturnType<typeof useAddressIndexSuspenseQuery>;
export type AddressIndexQueryResult = Apollo.QueryResult<AddressIndexQuery, AddressIndexQueryVariables>;
export const AddressListDocument = gql`
	query addressList($filters: [AddressFilterInput!], $pagination: Pagination, $order: AddressOrder) {
		addressConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					addressLine1
					addressLine2
					city
					postalCode
					stateOrProvince
					country {
						id
						...CountryName
					}
				}
			}
		}
	}
	${CountryNameFragmentDoc}
`;

/**
 * __useAddressListQuery__
 *
 * To run a query within a React component, call `useAddressListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAddressListQuery(
	baseOptions?: Apollo.QueryHookOptions<AddressListQuery, AddressListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AddressListQuery, AddressListQueryVariables>(AddressListDocument, options);
}
export function useAddressListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AddressListQuery, AddressListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AddressListQuery, AddressListQueryVariables>(AddressListDocument, options);
}
export function useAddressListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AddressListQuery, AddressListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AddressListQuery, AddressListQueryVariables>(AddressListDocument, options);
}
export type AddressListQueryHookResult = ReturnType<typeof useAddressListQuery>;
export type AddressListLazyQueryHookResult = ReturnType<typeof useAddressListLazyQuery>;
export type AddressListSuspenseQueryHookResult = ReturnType<typeof useAddressListSuspenseQuery>;
export type AddressListQueryResult = Apollo.QueryResult<AddressListQuery, AddressListQueryVariables>;
export const AddressNameDocument = gql`
	query addressName($id: ID!) {
		address(id: $id) {
			id
			...AddressName
		}
	}
	${AddressNameFragmentDoc}
`;

/**
 * __useAddressNameQuery__
 *
 * To run a query within a React component, call `useAddressNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddressNameQuery(baseOptions: Apollo.QueryHookOptions<AddressNameQuery, AddressNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AddressNameQuery, AddressNameQueryVariables>(AddressNameDocument, options);
}
export function useAddressNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AddressNameQuery, AddressNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AddressNameQuery, AddressNameQueryVariables>(AddressNameDocument, options);
}
export function useAddressNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AddressNameQuery, AddressNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AddressNameQuery, AddressNameQueryVariables>(AddressNameDocument, options);
}
export type AddressNameQueryHookResult = ReturnType<typeof useAddressNameQuery>;
export type AddressNameLazyQueryHookResult = ReturnType<typeof useAddressNameLazyQuery>;
export type AddressNameSuspenseQueryHookResult = ReturnType<typeof useAddressNameSuspenseQuery>;
export type AddressNameQueryResult = Apollo.QueryResult<AddressNameQuery, AddressNameQueryVariables>;
export const AddressNamesDocument = gql`
	query addressNames($filters: [AddressFilterInput!], $pagination: Pagination, $order: AddressOrder) {
		addressConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...AddressName
				}
			}
		}
	}
	${AddressNameFragmentDoc}
`;

/**
 * __useAddressNamesQuery__
 *
 * To run a query within a React component, call `useAddressNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAddressNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<AddressNamesQuery, AddressNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AddressNamesQuery, AddressNamesQueryVariables>(AddressNamesDocument, options);
}
export function useAddressNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AddressNamesQuery, AddressNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AddressNamesQuery, AddressNamesQueryVariables>(AddressNamesDocument, options);
}
export function useAddressNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AddressNamesQuery, AddressNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AddressNamesQuery, AddressNamesQueryVariables>(AddressNamesDocument, options);
}
export type AddressNamesQueryHookResult = ReturnType<typeof useAddressNamesQuery>;
export type AddressNamesLazyQueryHookResult = ReturnType<typeof useAddressNamesLazyQuery>;
export type AddressNamesSuspenseQueryHookResult = ReturnType<typeof useAddressNamesSuspenseQuery>;
export type AddressNamesQueryResult = Apollo.QueryResult<AddressNamesQuery, AddressNamesQueryVariables>;
export const AddressPaginationDocument = gql`
	query addressPagination($filters: [AddressFilterInput!], $order: AddressOrder) {
		addressConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useAddressPaginationQuery__
 *
 * To run a query within a React component, call `useAddressPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAddressPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<AddressPaginationQuery, AddressPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AddressPaginationQuery, AddressPaginationQueryVariables>(AddressPaginationDocument, options);
}
export function useAddressPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AddressPaginationQuery, AddressPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AddressPaginationQuery, AddressPaginationQueryVariables>(
		AddressPaginationDocument,
		options,
	);
}
export function useAddressPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AddressPaginationQuery, AddressPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AddressPaginationQuery, AddressPaginationQueryVariables>(
		AddressPaginationDocument,
		options,
	);
}
export type AddressPaginationQueryHookResult = ReturnType<typeof useAddressPaginationQuery>;
export type AddressPaginationLazyQueryHookResult = ReturnType<typeof useAddressPaginationLazyQuery>;
export type AddressPaginationSuspenseQueryHookResult = ReturnType<typeof useAddressPaginationSuspenseQuery>;
export type AddressPaginationQueryResult = Apollo.QueryResult<AddressPaginationQuery, AddressPaginationQueryVariables>;
export const AddressSelectDocument = gql`
	query addressSelect($filters: [AddressFilterInput!], $order: AddressOrder) {
		addressConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...AddressInformation
				}
			}
		}
	}
	${AddressInformationFragmentDoc}
`;

/**
 * __useAddressSelectQuery__
 *
 * To run a query within a React component, call `useAddressSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAddressSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<AddressSelectQuery, AddressSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AddressSelectQuery, AddressSelectQueryVariables>(AddressSelectDocument, options);
}
export function useAddressSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AddressSelectQuery, AddressSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AddressSelectQuery, AddressSelectQueryVariables>(AddressSelectDocument, options);
}
export function useAddressSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AddressSelectQuery, AddressSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AddressSelectQuery, AddressSelectQueryVariables>(AddressSelectDocument, options);
}
export type AddressSelectQueryHookResult = ReturnType<typeof useAddressSelectQuery>;
export type AddressSelectLazyQueryHookResult = ReturnType<typeof useAddressSelectLazyQuery>;
export type AddressSelectSuspenseQueryHookResult = ReturnType<typeof useAddressSelectSuspenseQuery>;
export type AddressSelectQueryResult = Apollo.QueryResult<AddressSelectQuery, AddressSelectQueryVariables>;
export const AddressUpdateDocument = gql`
	mutation addressUpdate($id: ID!, $input: AddressUpdateInput!) {
		updateAddress(id: $id, input: $input) {
			...AddressDetail
		}
	}
	${AddressDetailFragmentDoc}
`;
export type AddressUpdateMutationFn = Apollo.MutationFunction<AddressUpdateMutation, AddressUpdateMutationVariables>;

/**
 * __useAddressUpdateMutation__
 *
 * To run a mutation, you first call `useAddressUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddressUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addressUpdateMutation, { data, loading, error }] = useAddressUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddressUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<AddressUpdateMutation, AddressUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AddressUpdateMutation, AddressUpdateMutationVariables>(AddressUpdateDocument, options);
}
export type AddressUpdateMutationHookResult = ReturnType<typeof useAddressUpdateMutation>;
export type AddressUpdateMutationResult = Apollo.MutationResult<AddressUpdateMutation>;
export type AddressUpdateMutationOptions = Apollo.BaseMutationOptions<
	AddressUpdateMutation,
	AddressUpdateMutationVariables
>;
export const AnnouncementCountDocument = gql`
	query announcementCount($filters: [AnnouncementFilterInput!], $pagination: Pagination, $order: AnnouncementOrder) {
		announcementConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useAnnouncementCountQuery__
 *
 * To run a query within a React component, call `useAnnouncementCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAnnouncementCountQuery(
	baseOptions?: Apollo.QueryHookOptions<AnnouncementCountQuery, AnnouncementCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementCountQuery, AnnouncementCountQueryVariables>(AnnouncementCountDocument, options);
}
export function useAnnouncementCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementCountQuery, AnnouncementCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementCountQuery, AnnouncementCountQueryVariables>(
		AnnouncementCountDocument,
		options,
	);
}
export function useAnnouncementCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementCountQuery, AnnouncementCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementCountQuery, AnnouncementCountQueryVariables>(
		AnnouncementCountDocument,
		options,
	);
}
export type AnnouncementCountQueryHookResult = ReturnType<typeof useAnnouncementCountQuery>;
export type AnnouncementCountLazyQueryHookResult = ReturnType<typeof useAnnouncementCountLazyQuery>;
export type AnnouncementCountSuspenseQueryHookResult = ReturnType<typeof useAnnouncementCountSuspenseQuery>;
export type AnnouncementCountQueryResult = Apollo.QueryResult<AnnouncementCountQuery, AnnouncementCountQueryVariables>;
export const AnnouncementCreateDocument = gql`
	mutation announcementCreate($input: AnnouncementCreateInput!) {
		createAnnouncement(input: $input) {
			...AnnouncementDetail
		}
	}
	${AnnouncementDetailFragmentDoc}
`;
export type AnnouncementCreateMutationFn = Apollo.MutationFunction<
	AnnouncementCreateMutation,
	AnnouncementCreateMutationVariables
>;

/**
 * __useAnnouncementCreateMutation__
 *
 * To run a mutation, you first call `useAnnouncementCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [announcementCreateMutation, { data, loading, error }] = useAnnouncementCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnnouncementCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<AnnouncementCreateMutation, AnnouncementCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AnnouncementCreateMutation, AnnouncementCreateMutationVariables>(
		AnnouncementCreateDocument,
		options,
	);
}
export type AnnouncementCreateMutationHookResult = ReturnType<typeof useAnnouncementCreateMutation>;
export type AnnouncementCreateMutationResult = Apollo.MutationResult<AnnouncementCreateMutation>;
export type AnnouncementCreateMutationOptions = Apollo.BaseMutationOptions<
	AnnouncementCreateMutation,
	AnnouncementCreateMutationVariables
>;
export const AnnouncementDeleteDocument = gql`
	mutation announcementDelete($id: ID!) {
		deleteAnnouncement(id: $id)
	}
`;
export type AnnouncementDeleteMutationFn = Apollo.MutationFunction<
	AnnouncementDeleteMutation,
	AnnouncementDeleteMutationVariables
>;

/**
 * __useAnnouncementDeleteMutation__
 *
 * To run a mutation, you first call `useAnnouncementDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [announcementDeleteMutation, { data, loading, error }] = useAnnouncementDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnnouncementDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<AnnouncementDeleteMutation, AnnouncementDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AnnouncementDeleteMutation, AnnouncementDeleteMutationVariables>(
		AnnouncementDeleteDocument,
		options,
	);
}
export type AnnouncementDeleteMutationHookResult = ReturnType<typeof useAnnouncementDeleteMutation>;
export type AnnouncementDeleteMutationResult = Apollo.MutationResult<AnnouncementDeleteMutation>;
export type AnnouncementDeleteMutationOptions = Apollo.BaseMutationOptions<
	AnnouncementDeleteMutation,
	AnnouncementDeleteMutationVariables
>;
export const AnnouncementDetailDocument = gql`
	query announcementDetail($id: ID!) {
		announcement(id: $id) {
			...AnnouncementDetail
		}
	}
	${AnnouncementDetailFragmentDoc}
`;

/**
 * __useAnnouncementDetailQuery__
 *
 * To run a query within a React component, call `useAnnouncementDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnnouncementDetailQuery(
	baseOptions: Apollo.QueryHookOptions<AnnouncementDetailQuery, AnnouncementDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementDetailQuery, AnnouncementDetailQueryVariables>(
		AnnouncementDetailDocument,
		options,
	);
}
export function useAnnouncementDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementDetailQuery, AnnouncementDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementDetailQuery, AnnouncementDetailQueryVariables>(
		AnnouncementDetailDocument,
		options,
	);
}
export function useAnnouncementDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementDetailQuery, AnnouncementDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementDetailQuery, AnnouncementDetailQueryVariables>(
		AnnouncementDetailDocument,
		options,
	);
}
export type AnnouncementDetailQueryHookResult = ReturnType<typeof useAnnouncementDetailQuery>;
export type AnnouncementDetailLazyQueryHookResult = ReturnType<typeof useAnnouncementDetailLazyQuery>;
export type AnnouncementDetailSuspenseQueryHookResult = ReturnType<typeof useAnnouncementDetailSuspenseQuery>;
export type AnnouncementDetailQueryResult = Apollo.QueryResult<
	AnnouncementDetailQuery,
	AnnouncementDetailQueryVariables
>;
export const AnnouncementHomePageListDocument = gql`
	query announcementHomePageList(
		$filters: [AnnouncementFilterInput!]
		$pagination: Pagination
		$order: AnnouncementOrder
	) {
		announcementConnection(filters: $filters, pagination: $pagination, order: $order) {
			pageInfo {
				endCursor
				hasNextPage
			}
			edges {
				node {
					id
					title
					body
					startTime
					endTime
					author {
						id
						...UserNameAndImage
					}
					mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
						id
						title
						description
						isFile
						fileURL
						fileKey
						fileContentType
						linkURL
					}
				}
			}
		}
	}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __useAnnouncementHomePageListQuery__
 *
 * To run a query within a React component, call `useAnnouncementHomePageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementHomePageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementHomePageListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAnnouncementHomePageListQuery(
	baseOptions?: Apollo.QueryHookOptions<AnnouncementHomePageListQuery, AnnouncementHomePageListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementHomePageListQuery, AnnouncementHomePageListQueryVariables>(
		AnnouncementHomePageListDocument,
		options,
	);
}
export function useAnnouncementHomePageListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementHomePageListQuery, AnnouncementHomePageListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementHomePageListQuery, AnnouncementHomePageListQueryVariables>(
		AnnouncementHomePageListDocument,
		options,
	);
}
export function useAnnouncementHomePageListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementHomePageListQuery, AnnouncementHomePageListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementHomePageListQuery, AnnouncementHomePageListQueryVariables>(
		AnnouncementHomePageListDocument,
		options,
	);
}
export type AnnouncementHomePageListQueryHookResult = ReturnType<typeof useAnnouncementHomePageListQuery>;
export type AnnouncementHomePageListLazyQueryHookResult = ReturnType<typeof useAnnouncementHomePageListLazyQuery>;
export type AnnouncementHomePageListSuspenseQueryHookResult = ReturnType<
	typeof useAnnouncementHomePageListSuspenseQuery
>;
export type AnnouncementHomePageListQueryResult = Apollo.QueryResult<
	AnnouncementHomePageListQuery,
	AnnouncementHomePageListQueryVariables
>;
export const AnnouncementCommunicationCenterPageListDocument = gql`
	query announcementCommunicationCenterPageList(
		$filters: [AnnouncementFilterInput!]
		$pagination: Pagination
		$order: AnnouncementOrder
	) {
		announcementConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					title
					body
					startTime
					endTime
					author {
						id
						...UserNameAndImage
					}
					mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
						id
						title
						description
						isFile
						fileURL
						fileKey
						fileContentType
						linkURL
					}
				}
			}
		}
	}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __useAnnouncementCommunicationCenterPageListQuery__
 *
 * To run a query within a React component, call `useAnnouncementCommunicationCenterPageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementCommunicationCenterPageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementCommunicationCenterPageListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAnnouncementCommunicationCenterPageListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		AnnouncementCommunicationCenterPageListQuery,
		AnnouncementCommunicationCenterPageListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		AnnouncementCommunicationCenterPageListQuery,
		AnnouncementCommunicationCenterPageListQueryVariables
	>(AnnouncementCommunicationCenterPageListDocument, options);
}
export function useAnnouncementCommunicationCenterPageListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		AnnouncementCommunicationCenterPageListQuery,
		AnnouncementCommunicationCenterPageListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		AnnouncementCommunicationCenterPageListQuery,
		AnnouncementCommunicationCenterPageListQueryVariables
	>(AnnouncementCommunicationCenterPageListDocument, options);
}
export function useAnnouncementCommunicationCenterPageListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		AnnouncementCommunicationCenterPageListQuery,
		AnnouncementCommunicationCenterPageListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		AnnouncementCommunicationCenterPageListQuery,
		AnnouncementCommunicationCenterPageListQueryVariables
	>(AnnouncementCommunicationCenterPageListDocument, options);
}
export type AnnouncementCommunicationCenterPageListQueryHookResult = ReturnType<
	typeof useAnnouncementCommunicationCenterPageListQuery
>;
export type AnnouncementCommunicationCenterPageListLazyQueryHookResult = ReturnType<
	typeof useAnnouncementCommunicationCenterPageListLazyQuery
>;
export type AnnouncementCommunicationCenterPageListSuspenseQueryHookResult = ReturnType<
	typeof useAnnouncementCommunicationCenterPageListSuspenseQuery
>;
export type AnnouncementCommunicationCenterPageListQueryResult = Apollo.QueryResult<
	AnnouncementCommunicationCenterPageListQuery,
	AnnouncementCommunicationCenterPageListQueryVariables
>;
export const AnnouncementIndexDocument = gql`
	query announcementIndex($filters: [AnnouncementFilterInput!], $pagination: Pagination, $order: AnnouncementOrder) {
		announcementConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					title
					body
					startTime
					endTime
					author {
						id
						...UserName
					}
				}
			}
		}
	}
	${UserNameFragmentDoc}
`;

/**
 * __useAnnouncementIndexQuery__
 *
 * To run a query within a React component, call `useAnnouncementIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAnnouncementIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<AnnouncementIndexQuery, AnnouncementIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementIndexQuery, AnnouncementIndexQueryVariables>(AnnouncementIndexDocument, options);
}
export function useAnnouncementIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementIndexQuery, AnnouncementIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementIndexQuery, AnnouncementIndexQueryVariables>(
		AnnouncementIndexDocument,
		options,
	);
}
export function useAnnouncementIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementIndexQuery, AnnouncementIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementIndexQuery, AnnouncementIndexQueryVariables>(
		AnnouncementIndexDocument,
		options,
	);
}
export type AnnouncementIndexQueryHookResult = ReturnType<typeof useAnnouncementIndexQuery>;
export type AnnouncementIndexLazyQueryHookResult = ReturnType<typeof useAnnouncementIndexLazyQuery>;
export type AnnouncementIndexSuspenseQueryHookResult = ReturnType<typeof useAnnouncementIndexSuspenseQuery>;
export type AnnouncementIndexQueryResult = Apollo.QueryResult<AnnouncementIndexQuery, AnnouncementIndexQueryVariables>;
export const AnnouncementNameDocument = gql`
	query announcementName($id: ID!) {
		announcement(id: $id) {
			id
			...AnnouncementName
		}
	}
	${AnnouncementNameFragmentDoc}
`;

/**
 * __useAnnouncementNameQuery__
 *
 * To run a query within a React component, call `useAnnouncementNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnnouncementNameQuery(
	baseOptions: Apollo.QueryHookOptions<AnnouncementNameQuery, AnnouncementNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementNameQuery, AnnouncementNameQueryVariables>(AnnouncementNameDocument, options);
}
export function useAnnouncementNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementNameQuery, AnnouncementNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementNameQuery, AnnouncementNameQueryVariables>(AnnouncementNameDocument, options);
}
export function useAnnouncementNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementNameQuery, AnnouncementNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementNameQuery, AnnouncementNameQueryVariables>(
		AnnouncementNameDocument,
		options,
	);
}
export type AnnouncementNameQueryHookResult = ReturnType<typeof useAnnouncementNameQuery>;
export type AnnouncementNameLazyQueryHookResult = ReturnType<typeof useAnnouncementNameLazyQuery>;
export type AnnouncementNameSuspenseQueryHookResult = ReturnType<typeof useAnnouncementNameSuspenseQuery>;
export type AnnouncementNameQueryResult = Apollo.QueryResult<AnnouncementNameQuery, AnnouncementNameQueryVariables>;
export const AnnouncementNamesDocument = gql`
	query announcementNames($filters: [AnnouncementFilterInput!], $pagination: Pagination, $order: AnnouncementOrder) {
		announcementConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...AnnouncementName
				}
			}
		}
	}
	${AnnouncementNameFragmentDoc}
`;

/**
 * __useAnnouncementNamesQuery__
 *
 * To run a query within a React component, call `useAnnouncementNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAnnouncementNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<AnnouncementNamesQuery, AnnouncementNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementNamesQuery, AnnouncementNamesQueryVariables>(AnnouncementNamesDocument, options);
}
export function useAnnouncementNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementNamesQuery, AnnouncementNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementNamesQuery, AnnouncementNamesQueryVariables>(
		AnnouncementNamesDocument,
		options,
	);
}
export function useAnnouncementNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementNamesQuery, AnnouncementNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementNamesQuery, AnnouncementNamesQueryVariables>(
		AnnouncementNamesDocument,
		options,
	);
}
export type AnnouncementNamesQueryHookResult = ReturnType<typeof useAnnouncementNamesQuery>;
export type AnnouncementNamesLazyQueryHookResult = ReturnType<typeof useAnnouncementNamesLazyQuery>;
export type AnnouncementNamesSuspenseQueryHookResult = ReturnType<typeof useAnnouncementNamesSuspenseQuery>;
export type AnnouncementNamesQueryResult = Apollo.QueryResult<AnnouncementNamesQuery, AnnouncementNamesQueryVariables>;
export const AnnouncementPaginationDocument = gql`
	query announcementPagination($filters: [AnnouncementFilterInput!], $order: AnnouncementOrder) {
		announcementConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useAnnouncementPaginationQuery__
 *
 * To run a query within a React component, call `useAnnouncementPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAnnouncementPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<AnnouncementPaginationQuery, AnnouncementPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementPaginationQuery, AnnouncementPaginationQueryVariables>(
		AnnouncementPaginationDocument,
		options,
	);
}
export function useAnnouncementPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementPaginationQuery, AnnouncementPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementPaginationQuery, AnnouncementPaginationQueryVariables>(
		AnnouncementPaginationDocument,
		options,
	);
}
export function useAnnouncementPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementPaginationQuery, AnnouncementPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementPaginationQuery, AnnouncementPaginationQueryVariables>(
		AnnouncementPaginationDocument,
		options,
	);
}
export type AnnouncementPaginationQueryHookResult = ReturnType<typeof useAnnouncementPaginationQuery>;
export type AnnouncementPaginationLazyQueryHookResult = ReturnType<typeof useAnnouncementPaginationLazyQuery>;
export type AnnouncementPaginationSuspenseQueryHookResult = ReturnType<typeof useAnnouncementPaginationSuspenseQuery>;
export type AnnouncementPaginationQueryResult = Apollo.QueryResult<
	AnnouncementPaginationQuery,
	AnnouncementPaginationQueryVariables
>;
export const AnnouncementSelectDocument = gql`
	query announcementSelect($filters: [AnnouncementFilterInput!], $order: AnnouncementOrder) {
		announcementConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...AnnouncementName
				}
			}
		}
	}
	${AnnouncementNameFragmentDoc}
`;

/**
 * __useAnnouncementSelectQuery__
 *
 * To run a query within a React component, call `useAnnouncementSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAnnouncementSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<AnnouncementSelectQuery, AnnouncementSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementSelectQuery, AnnouncementSelectQueryVariables>(
		AnnouncementSelectDocument,
		options,
	);
}
export function useAnnouncementSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementSelectQuery, AnnouncementSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementSelectQuery, AnnouncementSelectQueryVariables>(
		AnnouncementSelectDocument,
		options,
	);
}
export function useAnnouncementSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementSelectQuery, AnnouncementSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementSelectQuery, AnnouncementSelectQueryVariables>(
		AnnouncementSelectDocument,
		options,
	);
}
export type AnnouncementSelectQueryHookResult = ReturnType<typeof useAnnouncementSelectQuery>;
export type AnnouncementSelectLazyQueryHookResult = ReturnType<typeof useAnnouncementSelectLazyQuery>;
export type AnnouncementSelectSuspenseQueryHookResult = ReturnType<typeof useAnnouncementSelectSuspenseQuery>;
export type AnnouncementSelectQueryResult = Apollo.QueryResult<
	AnnouncementSelectQuery,
	AnnouncementSelectQueryVariables
>;
export const AnnouncementSocialItemsDocument = gql`
	query announcementSocialItems($id: ID!) {
		announcement(id: $id) {
			id
			socialReactions(order: { field: CREATED_AT, direction: DESC }) {
				id
				reaction
				author {
					id
					...UserName
					isCurrent
				}
			}
		}
	}
	${UserNameFragmentDoc}
`;

/**
 * __useAnnouncementSocialItemsQuery__
 *
 * To run a query within a React component, call `useAnnouncementSocialItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementSocialItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementSocialItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnnouncementSocialItemsQuery(
	baseOptions: Apollo.QueryHookOptions<AnnouncementSocialItemsQuery, AnnouncementSocialItemsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementSocialItemsQuery, AnnouncementSocialItemsQueryVariables>(
		AnnouncementSocialItemsDocument,
		options,
	);
}
export function useAnnouncementSocialItemsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementSocialItemsQuery, AnnouncementSocialItemsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementSocialItemsQuery, AnnouncementSocialItemsQueryVariables>(
		AnnouncementSocialItemsDocument,
		options,
	);
}
export function useAnnouncementSocialItemsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementSocialItemsQuery, AnnouncementSocialItemsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementSocialItemsQuery, AnnouncementSocialItemsQueryVariables>(
		AnnouncementSocialItemsDocument,
		options,
	);
}
export type AnnouncementSocialItemsQueryHookResult = ReturnType<typeof useAnnouncementSocialItemsQuery>;
export type AnnouncementSocialItemsLazyQueryHookResult = ReturnType<typeof useAnnouncementSocialItemsLazyQuery>;
export type AnnouncementSocialItemsSuspenseQueryHookResult = ReturnType<typeof useAnnouncementSocialItemsSuspenseQuery>;
export type AnnouncementSocialItemsQueryResult = Apollo.QueryResult<
	AnnouncementSocialItemsQuery,
	AnnouncementSocialItemsQueryVariables
>;
export const AnnouncementStatisticsDocument = gql`
	query announcementStatistics($filters: [AnnouncementFilterInput!]) {
		announcementStatistics(filters: $filters) {
			count
			views
			reactions
		}
	}
`;

/**
 * __useAnnouncementStatisticsQuery__
 *
 * To run a query within a React component, call `useAnnouncementStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementStatisticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAnnouncementStatisticsQuery(
	baseOptions?: Apollo.QueryHookOptions<AnnouncementStatisticsQuery, AnnouncementStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementStatisticsQuery, AnnouncementStatisticsQueryVariables>(
		AnnouncementStatisticsDocument,
		options,
	);
}
export function useAnnouncementStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementStatisticsQuery, AnnouncementStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementStatisticsQuery, AnnouncementStatisticsQueryVariables>(
		AnnouncementStatisticsDocument,
		options,
	);
}
export function useAnnouncementStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementStatisticsQuery, AnnouncementStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementStatisticsQuery, AnnouncementStatisticsQueryVariables>(
		AnnouncementStatisticsDocument,
		options,
	);
}
export type AnnouncementStatisticsQueryHookResult = ReturnType<typeof useAnnouncementStatisticsQuery>;
export type AnnouncementStatisticsLazyQueryHookResult = ReturnType<typeof useAnnouncementStatisticsLazyQuery>;
export type AnnouncementStatisticsSuspenseQueryHookResult = ReturnType<typeof useAnnouncementStatisticsSuspenseQuery>;
export type AnnouncementStatisticsQueryResult = Apollo.QueryResult<
	AnnouncementStatisticsQuery,
	AnnouncementStatisticsQueryVariables
>;
export const AnnouncementUpdateDocument = gql`
	mutation announcementUpdate($id: ID!, $input: AnnouncementUpdateInput!) {
		updateAnnouncement(id: $id, input: $input) {
			...AnnouncementDetail
		}
	}
	${AnnouncementDetailFragmentDoc}
`;
export type AnnouncementUpdateMutationFn = Apollo.MutationFunction<
	AnnouncementUpdateMutation,
	AnnouncementUpdateMutationVariables
>;

/**
 * __useAnnouncementUpdateMutation__
 *
 * To run a mutation, you first call `useAnnouncementUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [announcementUpdateMutation, { data, loading, error }] = useAnnouncementUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnnouncementUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<AnnouncementUpdateMutation, AnnouncementUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AnnouncementUpdateMutation, AnnouncementUpdateMutationVariables>(
		AnnouncementUpdateDocument,
		options,
	);
}
export type AnnouncementUpdateMutationHookResult = ReturnType<typeof useAnnouncementUpdateMutation>;
export type AnnouncementUpdateMutationResult = Apollo.MutationResult<AnnouncementUpdateMutation>;
export type AnnouncementUpdateMutationOptions = Apollo.BaseMutationOptions<
	AnnouncementUpdateMutation,
	AnnouncementUpdateMutationVariables
>;
export const AttendanceStatusCountDocument = gql`
	query attendanceStatusCount(
		$filters: [AttendanceStatusFilterInput!]
		$pagination: Pagination
		$order: AttendanceStatusOrder
	) {
		attendanceStatusConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useAttendanceStatusCountQuery__
 *
 * To run a query within a React component, call `useAttendanceStatusCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceStatusCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceStatusCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAttendanceStatusCountQuery(
	baseOptions?: Apollo.QueryHookOptions<AttendanceStatusCountQuery, AttendanceStatusCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AttendanceStatusCountQuery, AttendanceStatusCountQueryVariables>(
		AttendanceStatusCountDocument,
		options,
	);
}
export function useAttendanceStatusCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AttendanceStatusCountQuery, AttendanceStatusCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AttendanceStatusCountQuery, AttendanceStatusCountQueryVariables>(
		AttendanceStatusCountDocument,
		options,
	);
}
export function useAttendanceStatusCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AttendanceStatusCountQuery, AttendanceStatusCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AttendanceStatusCountQuery, AttendanceStatusCountQueryVariables>(
		AttendanceStatusCountDocument,
		options,
	);
}
export type AttendanceStatusCountQueryHookResult = ReturnType<typeof useAttendanceStatusCountQuery>;
export type AttendanceStatusCountLazyQueryHookResult = ReturnType<typeof useAttendanceStatusCountLazyQuery>;
export type AttendanceStatusCountSuspenseQueryHookResult = ReturnType<typeof useAttendanceStatusCountSuspenseQuery>;
export type AttendanceStatusCountQueryResult = Apollo.QueryResult<
	AttendanceStatusCountQuery,
	AttendanceStatusCountQueryVariables
>;
export const AttendanceStatusCreateDocument = gql`
	mutation attendanceStatusCreate($input: AttendanceStatusCreateInput!) {
		createAttendanceStatus(input: $input) {
			...AttendanceStatusDetail
		}
	}
	${AttendanceStatusDetailFragmentDoc}
`;
export type AttendanceStatusCreateMutationFn = Apollo.MutationFunction<
	AttendanceStatusCreateMutation,
	AttendanceStatusCreateMutationVariables
>;

/**
 * __useAttendanceStatusCreateMutation__
 *
 * To run a mutation, you first call `useAttendanceStatusCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttendanceStatusCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attendanceStatusCreateMutation, { data, loading, error }] = useAttendanceStatusCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttendanceStatusCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<AttendanceStatusCreateMutation, AttendanceStatusCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AttendanceStatusCreateMutation, AttendanceStatusCreateMutationVariables>(
		AttendanceStatusCreateDocument,
		options,
	);
}
export type AttendanceStatusCreateMutationHookResult = ReturnType<typeof useAttendanceStatusCreateMutation>;
export type AttendanceStatusCreateMutationResult = Apollo.MutationResult<AttendanceStatusCreateMutation>;
export type AttendanceStatusCreateMutationOptions = Apollo.BaseMutationOptions<
	AttendanceStatusCreateMutation,
	AttendanceStatusCreateMutationVariables
>;
export const AttendanceStatusDeleteDocument = gql`
	mutation attendanceStatusDelete($id: ID!) {
		deleteAttendanceStatus(id: $id)
	}
`;
export type AttendanceStatusDeleteMutationFn = Apollo.MutationFunction<
	AttendanceStatusDeleteMutation,
	AttendanceStatusDeleteMutationVariables
>;

/**
 * __useAttendanceStatusDeleteMutation__
 *
 * To run a mutation, you first call `useAttendanceStatusDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttendanceStatusDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attendanceStatusDeleteMutation, { data, loading, error }] = useAttendanceStatusDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAttendanceStatusDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<AttendanceStatusDeleteMutation, AttendanceStatusDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AttendanceStatusDeleteMutation, AttendanceStatusDeleteMutationVariables>(
		AttendanceStatusDeleteDocument,
		options,
	);
}
export type AttendanceStatusDeleteMutationHookResult = ReturnType<typeof useAttendanceStatusDeleteMutation>;
export type AttendanceStatusDeleteMutationResult = Apollo.MutationResult<AttendanceStatusDeleteMutation>;
export type AttendanceStatusDeleteMutationOptions = Apollo.BaseMutationOptions<
	AttendanceStatusDeleteMutation,
	AttendanceStatusDeleteMutationVariables
>;
export const AttendanceStatusDetailDocument = gql`
	query attendanceStatusDetail($id: ID!) {
		attendanceStatus(id: $id) {
			...AttendanceStatusDetail
		}
	}
	${AttendanceStatusDetailFragmentDoc}
`;

/**
 * __useAttendanceStatusDetailQuery__
 *
 * To run a query within a React component, call `useAttendanceStatusDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceStatusDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceStatusDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAttendanceStatusDetailQuery(
	baseOptions: Apollo.QueryHookOptions<AttendanceStatusDetailQuery, AttendanceStatusDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AttendanceStatusDetailQuery, AttendanceStatusDetailQueryVariables>(
		AttendanceStatusDetailDocument,
		options,
	);
}
export function useAttendanceStatusDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AttendanceStatusDetailQuery, AttendanceStatusDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AttendanceStatusDetailQuery, AttendanceStatusDetailQueryVariables>(
		AttendanceStatusDetailDocument,
		options,
	);
}
export function useAttendanceStatusDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AttendanceStatusDetailQuery, AttendanceStatusDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AttendanceStatusDetailQuery, AttendanceStatusDetailQueryVariables>(
		AttendanceStatusDetailDocument,
		options,
	);
}
export type AttendanceStatusDetailQueryHookResult = ReturnType<typeof useAttendanceStatusDetailQuery>;
export type AttendanceStatusDetailLazyQueryHookResult = ReturnType<typeof useAttendanceStatusDetailLazyQuery>;
export type AttendanceStatusDetailSuspenseQueryHookResult = ReturnType<typeof useAttendanceStatusDetailSuspenseQuery>;
export type AttendanceStatusDetailQueryResult = Apollo.QueryResult<
	AttendanceStatusDetailQuery,
	AttendanceStatusDetailQueryVariables
>;
export const AttendanceStatusIndexDocument = gql`
	query attendanceStatusIndex(
		$filters: [AttendanceStatusFilterInput!]
		$pagination: Pagination
		$order: AttendanceStatusOrder
	) {
		attendanceStatusConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					code
					description
					indicatesAbsent
					indicatesLateArrival
					indicatesEarlyDeparture
					indicatesExcused
					isDefault
					displayOrder
				}
			}
		}
	}
`;

/**
 * __useAttendanceStatusIndexQuery__
 *
 * To run a query within a React component, call `useAttendanceStatusIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceStatusIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceStatusIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAttendanceStatusIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<AttendanceStatusIndexQuery, AttendanceStatusIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AttendanceStatusIndexQuery, AttendanceStatusIndexQueryVariables>(
		AttendanceStatusIndexDocument,
		options,
	);
}
export function useAttendanceStatusIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AttendanceStatusIndexQuery, AttendanceStatusIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AttendanceStatusIndexQuery, AttendanceStatusIndexQueryVariables>(
		AttendanceStatusIndexDocument,
		options,
	);
}
export function useAttendanceStatusIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AttendanceStatusIndexQuery, AttendanceStatusIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AttendanceStatusIndexQuery, AttendanceStatusIndexQueryVariables>(
		AttendanceStatusIndexDocument,
		options,
	);
}
export type AttendanceStatusIndexQueryHookResult = ReturnType<typeof useAttendanceStatusIndexQuery>;
export type AttendanceStatusIndexLazyQueryHookResult = ReturnType<typeof useAttendanceStatusIndexLazyQuery>;
export type AttendanceStatusIndexSuspenseQueryHookResult = ReturnType<typeof useAttendanceStatusIndexSuspenseQuery>;
export type AttendanceStatusIndexQueryResult = Apollo.QueryResult<
	AttendanceStatusIndexQuery,
	AttendanceStatusIndexQueryVariables
>;
export const AttendanceStatusListDocument = gql`
	query attendanceStatusList(
		$filters: [AttendanceStatusFilterInput!]
		$pagination: Pagination
		$order: AttendanceStatusOrder
	) {
		attendanceStatusConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					code
					description
					indicatesAbsent
					indicatesLateArrival
					indicatesEarlyDeparture
					indicatesExcused
					isDefault
				}
			}
		}
	}
`;

/**
 * __useAttendanceStatusListQuery__
 *
 * To run a query within a React component, call `useAttendanceStatusListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceStatusListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceStatusListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAttendanceStatusListQuery(
	baseOptions?: Apollo.QueryHookOptions<AttendanceStatusListQuery, AttendanceStatusListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AttendanceStatusListQuery, AttendanceStatusListQueryVariables>(
		AttendanceStatusListDocument,
		options,
	);
}
export function useAttendanceStatusListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AttendanceStatusListQuery, AttendanceStatusListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AttendanceStatusListQuery, AttendanceStatusListQueryVariables>(
		AttendanceStatusListDocument,
		options,
	);
}
export function useAttendanceStatusListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AttendanceStatusListQuery, AttendanceStatusListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AttendanceStatusListQuery, AttendanceStatusListQueryVariables>(
		AttendanceStatusListDocument,
		options,
	);
}
export type AttendanceStatusListQueryHookResult = ReturnType<typeof useAttendanceStatusListQuery>;
export type AttendanceStatusListLazyQueryHookResult = ReturnType<typeof useAttendanceStatusListLazyQuery>;
export type AttendanceStatusListSuspenseQueryHookResult = ReturnType<typeof useAttendanceStatusListSuspenseQuery>;
export type AttendanceStatusListQueryResult = Apollo.QueryResult<
	AttendanceStatusListQuery,
	AttendanceStatusListQueryVariables
>;
export const AttendanceStatusNameDocument = gql`
	query attendanceStatusName($id: ID!) {
		attendanceStatus(id: $id) {
			id
			...AttendanceStatusName
		}
	}
	${AttendanceStatusNameFragmentDoc}
`;

/**
 * __useAttendanceStatusNameQuery__
 *
 * To run a query within a React component, call `useAttendanceStatusNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceStatusNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceStatusNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAttendanceStatusNameQuery(
	baseOptions: Apollo.QueryHookOptions<AttendanceStatusNameQuery, AttendanceStatusNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AttendanceStatusNameQuery, AttendanceStatusNameQueryVariables>(
		AttendanceStatusNameDocument,
		options,
	);
}
export function useAttendanceStatusNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AttendanceStatusNameQuery, AttendanceStatusNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AttendanceStatusNameQuery, AttendanceStatusNameQueryVariables>(
		AttendanceStatusNameDocument,
		options,
	);
}
export function useAttendanceStatusNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AttendanceStatusNameQuery, AttendanceStatusNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AttendanceStatusNameQuery, AttendanceStatusNameQueryVariables>(
		AttendanceStatusNameDocument,
		options,
	);
}
export type AttendanceStatusNameQueryHookResult = ReturnType<typeof useAttendanceStatusNameQuery>;
export type AttendanceStatusNameLazyQueryHookResult = ReturnType<typeof useAttendanceStatusNameLazyQuery>;
export type AttendanceStatusNameSuspenseQueryHookResult = ReturnType<typeof useAttendanceStatusNameSuspenseQuery>;
export type AttendanceStatusNameQueryResult = Apollo.QueryResult<
	AttendanceStatusNameQuery,
	AttendanceStatusNameQueryVariables
>;
export const AttendanceStatusNamesDocument = gql`
	query attendanceStatusNames(
		$filters: [AttendanceStatusFilterInput!]
		$pagination: Pagination
		$order: AttendanceStatusOrder
	) {
		attendanceStatusConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...AttendanceStatusName
				}
			}
		}
	}
	${AttendanceStatusNameFragmentDoc}
`;

/**
 * __useAttendanceStatusNamesQuery__
 *
 * To run a query within a React component, call `useAttendanceStatusNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceStatusNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceStatusNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAttendanceStatusNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<AttendanceStatusNamesQuery, AttendanceStatusNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AttendanceStatusNamesQuery, AttendanceStatusNamesQueryVariables>(
		AttendanceStatusNamesDocument,
		options,
	);
}
export function useAttendanceStatusNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AttendanceStatusNamesQuery, AttendanceStatusNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AttendanceStatusNamesQuery, AttendanceStatusNamesQueryVariables>(
		AttendanceStatusNamesDocument,
		options,
	);
}
export function useAttendanceStatusNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AttendanceStatusNamesQuery, AttendanceStatusNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AttendanceStatusNamesQuery, AttendanceStatusNamesQueryVariables>(
		AttendanceStatusNamesDocument,
		options,
	);
}
export type AttendanceStatusNamesQueryHookResult = ReturnType<typeof useAttendanceStatusNamesQuery>;
export type AttendanceStatusNamesLazyQueryHookResult = ReturnType<typeof useAttendanceStatusNamesLazyQuery>;
export type AttendanceStatusNamesSuspenseQueryHookResult = ReturnType<typeof useAttendanceStatusNamesSuspenseQuery>;
export type AttendanceStatusNamesQueryResult = Apollo.QueryResult<
	AttendanceStatusNamesQuery,
	AttendanceStatusNamesQueryVariables
>;
export const AttendanceStatusPaginationDocument = gql`
	query attendanceStatusPagination($filters: [AttendanceStatusFilterInput!], $order: AttendanceStatusOrder) {
		attendanceStatusConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useAttendanceStatusPaginationQuery__
 *
 * To run a query within a React component, call `useAttendanceStatusPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceStatusPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceStatusPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAttendanceStatusPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<AttendanceStatusPaginationQuery, AttendanceStatusPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AttendanceStatusPaginationQuery, AttendanceStatusPaginationQueryVariables>(
		AttendanceStatusPaginationDocument,
		options,
	);
}
export function useAttendanceStatusPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AttendanceStatusPaginationQuery, AttendanceStatusPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AttendanceStatusPaginationQuery, AttendanceStatusPaginationQueryVariables>(
		AttendanceStatusPaginationDocument,
		options,
	);
}
export function useAttendanceStatusPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		AttendanceStatusPaginationQuery,
		AttendanceStatusPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AttendanceStatusPaginationQuery, AttendanceStatusPaginationQueryVariables>(
		AttendanceStatusPaginationDocument,
		options,
	);
}
export type AttendanceStatusPaginationQueryHookResult = ReturnType<typeof useAttendanceStatusPaginationQuery>;
export type AttendanceStatusPaginationLazyQueryHookResult = ReturnType<typeof useAttendanceStatusPaginationLazyQuery>;
export type AttendanceStatusPaginationSuspenseQueryHookResult = ReturnType<
	typeof useAttendanceStatusPaginationSuspenseQuery
>;
export type AttendanceStatusPaginationQueryResult = Apollo.QueryResult<
	AttendanceStatusPaginationQuery,
	AttendanceStatusPaginationQueryVariables
>;
export const AttendanceStatusSelectDocument = gql`
	query attendanceStatusSelect($filters: [AttendanceStatusFilterInput!], $order: AttendanceStatusOrder) {
		attendanceStatusConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...AttendanceStatusName
				}
			}
		}
	}
	${AttendanceStatusNameFragmentDoc}
`;

/**
 * __useAttendanceStatusSelectQuery__
 *
 * To run a query within a React component, call `useAttendanceStatusSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceStatusSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceStatusSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAttendanceStatusSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<AttendanceStatusSelectQuery, AttendanceStatusSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AttendanceStatusSelectQuery, AttendanceStatusSelectQueryVariables>(
		AttendanceStatusSelectDocument,
		options,
	);
}
export function useAttendanceStatusSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AttendanceStatusSelectQuery, AttendanceStatusSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AttendanceStatusSelectQuery, AttendanceStatusSelectQueryVariables>(
		AttendanceStatusSelectDocument,
		options,
	);
}
export function useAttendanceStatusSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AttendanceStatusSelectQuery, AttendanceStatusSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AttendanceStatusSelectQuery, AttendanceStatusSelectQueryVariables>(
		AttendanceStatusSelectDocument,
		options,
	);
}
export type AttendanceStatusSelectQueryHookResult = ReturnType<typeof useAttendanceStatusSelectQuery>;
export type AttendanceStatusSelectLazyQueryHookResult = ReturnType<typeof useAttendanceStatusSelectLazyQuery>;
export type AttendanceStatusSelectSuspenseQueryHookResult = ReturnType<typeof useAttendanceStatusSelectSuspenseQuery>;
export type AttendanceStatusSelectQueryResult = Apollo.QueryResult<
	AttendanceStatusSelectQuery,
	AttendanceStatusSelectQueryVariables
>;
export const AttendanceStatusUpdateDocument = gql`
	mutation attendanceStatusUpdate($id: ID!, $input: AttendanceStatusUpdateInput!) {
		updateAttendanceStatus(id: $id, input: $input) {
			...AttendanceStatusDetail
		}
	}
	${AttendanceStatusDetailFragmentDoc}
`;
export type AttendanceStatusUpdateMutationFn = Apollo.MutationFunction<
	AttendanceStatusUpdateMutation,
	AttendanceStatusUpdateMutationVariables
>;

/**
 * __useAttendanceStatusUpdateMutation__
 *
 * To run a mutation, you first call `useAttendanceStatusUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttendanceStatusUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attendanceStatusUpdateMutation, { data, loading, error }] = useAttendanceStatusUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttendanceStatusUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<AttendanceStatusUpdateMutation, AttendanceStatusUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AttendanceStatusUpdateMutation, AttendanceStatusUpdateMutationVariables>(
		AttendanceStatusUpdateDocument,
		options,
	);
}
export type AttendanceStatusUpdateMutationHookResult = ReturnType<typeof useAttendanceStatusUpdateMutation>;
export type AttendanceStatusUpdateMutationResult = Apollo.MutationResult<AttendanceStatusUpdateMutation>;
export type AttendanceStatusUpdateMutationOptions = Apollo.BaseMutationOptions<
	AttendanceStatusUpdateMutation,
	AttendanceStatusUpdateMutationVariables
>;
export const BillingAdjustmentCountDocument = gql`
	query billingAdjustmentCount(
		$filters: [BillingAdjustmentFilterInput!]
		$pagination: Pagination
		$order: BillingAdjustmentOrder
	) {
		billingAdjustmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useBillingAdjustmentCountQuery__
 *
 * To run a query within a React component, call `useBillingAdjustmentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingAdjustmentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingAdjustmentCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBillingAdjustmentCountQuery(
	baseOptions?: Apollo.QueryHookOptions<BillingAdjustmentCountQuery, BillingAdjustmentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BillingAdjustmentCountQuery, BillingAdjustmentCountQueryVariables>(
		BillingAdjustmentCountDocument,
		options,
	);
}
export function useBillingAdjustmentCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BillingAdjustmentCountQuery, BillingAdjustmentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BillingAdjustmentCountQuery, BillingAdjustmentCountQueryVariables>(
		BillingAdjustmentCountDocument,
		options,
	);
}
export function useBillingAdjustmentCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BillingAdjustmentCountQuery, BillingAdjustmentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BillingAdjustmentCountQuery, BillingAdjustmentCountQueryVariables>(
		BillingAdjustmentCountDocument,
		options,
	);
}
export type BillingAdjustmentCountQueryHookResult = ReturnType<typeof useBillingAdjustmentCountQuery>;
export type BillingAdjustmentCountLazyQueryHookResult = ReturnType<typeof useBillingAdjustmentCountLazyQuery>;
export type BillingAdjustmentCountSuspenseQueryHookResult = ReturnType<typeof useBillingAdjustmentCountSuspenseQuery>;
export type BillingAdjustmentCountQueryResult = Apollo.QueryResult<
	BillingAdjustmentCountQuery,
	BillingAdjustmentCountQueryVariables
>;
export const BillingAdjustmentCreateDocument = gql`
	mutation billingAdjustmentCreate($input: BillingAdjustmentCreateInput!) {
		createBillingAdjustment(input: $input) {
			...BillingAdjustmentDetail
		}
	}
	${BillingAdjustmentDetailFragmentDoc}
`;
export type BillingAdjustmentCreateMutationFn = Apollo.MutationFunction<
	BillingAdjustmentCreateMutation,
	BillingAdjustmentCreateMutationVariables
>;

/**
 * __useBillingAdjustmentCreateMutation__
 *
 * To run a mutation, you first call `useBillingAdjustmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillingAdjustmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingAdjustmentCreateMutation, { data, loading, error }] = useBillingAdjustmentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingAdjustmentCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<BillingAdjustmentCreateMutation, BillingAdjustmentCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<BillingAdjustmentCreateMutation, BillingAdjustmentCreateMutationVariables>(
		BillingAdjustmentCreateDocument,
		options,
	);
}
export type BillingAdjustmentCreateMutationHookResult = ReturnType<typeof useBillingAdjustmentCreateMutation>;
export type BillingAdjustmentCreateMutationResult = Apollo.MutationResult<BillingAdjustmentCreateMutation>;
export type BillingAdjustmentCreateMutationOptions = Apollo.BaseMutationOptions<
	BillingAdjustmentCreateMutation,
	BillingAdjustmentCreateMutationVariables
>;
export const BillingAdjustmentDeleteDocument = gql`
	mutation billingAdjustmentDelete($id: ID!) {
		deleteBillingAdjustment(id: $id)
	}
`;
export type BillingAdjustmentDeleteMutationFn = Apollo.MutationFunction<
	BillingAdjustmentDeleteMutation,
	BillingAdjustmentDeleteMutationVariables
>;

/**
 * __useBillingAdjustmentDeleteMutation__
 *
 * To run a mutation, you first call `useBillingAdjustmentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillingAdjustmentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingAdjustmentDeleteMutation, { data, loading, error }] = useBillingAdjustmentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBillingAdjustmentDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<BillingAdjustmentDeleteMutation, BillingAdjustmentDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<BillingAdjustmentDeleteMutation, BillingAdjustmentDeleteMutationVariables>(
		BillingAdjustmentDeleteDocument,
		options,
	);
}
export type BillingAdjustmentDeleteMutationHookResult = ReturnType<typeof useBillingAdjustmentDeleteMutation>;
export type BillingAdjustmentDeleteMutationResult = Apollo.MutationResult<BillingAdjustmentDeleteMutation>;
export type BillingAdjustmentDeleteMutationOptions = Apollo.BaseMutationOptions<
	BillingAdjustmentDeleteMutation,
	BillingAdjustmentDeleteMutationVariables
>;
export const BillingAdjustmentDetailDocument = gql`
	query billingAdjustmentDetail($id: ID!) {
		billingAdjustment(id: $id) {
			...BillingAdjustmentDetail
		}
	}
	${BillingAdjustmentDetailFragmentDoc}
`;

/**
 * __useBillingAdjustmentDetailQuery__
 *
 * To run a query within a React component, call `useBillingAdjustmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingAdjustmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingAdjustmentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBillingAdjustmentDetailQuery(
	baseOptions: Apollo.QueryHookOptions<BillingAdjustmentDetailQuery, BillingAdjustmentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BillingAdjustmentDetailQuery, BillingAdjustmentDetailQueryVariables>(
		BillingAdjustmentDetailDocument,
		options,
	);
}
export function useBillingAdjustmentDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BillingAdjustmentDetailQuery, BillingAdjustmentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BillingAdjustmentDetailQuery, BillingAdjustmentDetailQueryVariables>(
		BillingAdjustmentDetailDocument,
		options,
	);
}
export function useBillingAdjustmentDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BillingAdjustmentDetailQuery, BillingAdjustmentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BillingAdjustmentDetailQuery, BillingAdjustmentDetailQueryVariables>(
		BillingAdjustmentDetailDocument,
		options,
	);
}
export type BillingAdjustmentDetailQueryHookResult = ReturnType<typeof useBillingAdjustmentDetailQuery>;
export type BillingAdjustmentDetailLazyQueryHookResult = ReturnType<typeof useBillingAdjustmentDetailLazyQuery>;
export type BillingAdjustmentDetailSuspenseQueryHookResult = ReturnType<typeof useBillingAdjustmentDetailSuspenseQuery>;
export type BillingAdjustmentDetailQueryResult = Apollo.QueryResult<
	BillingAdjustmentDetailQuery,
	BillingAdjustmentDetailQueryVariables
>;
export const BillingAdjustmentIndexDocument = gql`
	query billingAdjustmentIndex(
		$filters: [BillingAdjustmentFilterInput!]
		$pagination: Pagination
		$order: BillingAdjustmentOrder
	) {
		billingAdjustmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					issueDate
					amount
					notes
				}
			}
		}
	}
`;

/**
 * __useBillingAdjustmentIndexQuery__
 *
 * To run a query within a React component, call `useBillingAdjustmentIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingAdjustmentIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingAdjustmentIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBillingAdjustmentIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<BillingAdjustmentIndexQuery, BillingAdjustmentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BillingAdjustmentIndexQuery, BillingAdjustmentIndexQueryVariables>(
		BillingAdjustmentIndexDocument,
		options,
	);
}
export function useBillingAdjustmentIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BillingAdjustmentIndexQuery, BillingAdjustmentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BillingAdjustmentIndexQuery, BillingAdjustmentIndexQueryVariables>(
		BillingAdjustmentIndexDocument,
		options,
	);
}
export function useBillingAdjustmentIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BillingAdjustmentIndexQuery, BillingAdjustmentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BillingAdjustmentIndexQuery, BillingAdjustmentIndexQueryVariables>(
		BillingAdjustmentIndexDocument,
		options,
	);
}
export type BillingAdjustmentIndexQueryHookResult = ReturnType<typeof useBillingAdjustmentIndexQuery>;
export type BillingAdjustmentIndexLazyQueryHookResult = ReturnType<typeof useBillingAdjustmentIndexLazyQuery>;
export type BillingAdjustmentIndexSuspenseQueryHookResult = ReturnType<typeof useBillingAdjustmentIndexSuspenseQuery>;
export type BillingAdjustmentIndexQueryResult = Apollo.QueryResult<
	BillingAdjustmentIndexQuery,
	BillingAdjustmentIndexQueryVariables
>;
export const BillingAdjustmentNameDocument = gql`
	query billingAdjustmentName($id: ID!) {
		billingAdjustment(id: $id) {
			id
			...BillingAdjustmentName
		}
	}
	${BillingAdjustmentNameFragmentDoc}
`;

/**
 * __useBillingAdjustmentNameQuery__
 *
 * To run a query within a React component, call `useBillingAdjustmentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingAdjustmentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingAdjustmentNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBillingAdjustmentNameQuery(
	baseOptions: Apollo.QueryHookOptions<BillingAdjustmentNameQuery, BillingAdjustmentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BillingAdjustmentNameQuery, BillingAdjustmentNameQueryVariables>(
		BillingAdjustmentNameDocument,
		options,
	);
}
export function useBillingAdjustmentNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BillingAdjustmentNameQuery, BillingAdjustmentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BillingAdjustmentNameQuery, BillingAdjustmentNameQueryVariables>(
		BillingAdjustmentNameDocument,
		options,
	);
}
export function useBillingAdjustmentNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BillingAdjustmentNameQuery, BillingAdjustmentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BillingAdjustmentNameQuery, BillingAdjustmentNameQueryVariables>(
		BillingAdjustmentNameDocument,
		options,
	);
}
export type BillingAdjustmentNameQueryHookResult = ReturnType<typeof useBillingAdjustmentNameQuery>;
export type BillingAdjustmentNameLazyQueryHookResult = ReturnType<typeof useBillingAdjustmentNameLazyQuery>;
export type BillingAdjustmentNameSuspenseQueryHookResult = ReturnType<typeof useBillingAdjustmentNameSuspenseQuery>;
export type BillingAdjustmentNameQueryResult = Apollo.QueryResult<
	BillingAdjustmentNameQuery,
	BillingAdjustmentNameQueryVariables
>;
export const BillingAdjustmentNamesDocument = gql`
	query billingAdjustmentNames(
		$filters: [BillingAdjustmentFilterInput!]
		$pagination: Pagination
		$order: BillingAdjustmentOrder
	) {
		billingAdjustmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...BillingAdjustmentName
				}
			}
		}
	}
	${BillingAdjustmentNameFragmentDoc}
`;

/**
 * __useBillingAdjustmentNamesQuery__
 *
 * To run a query within a React component, call `useBillingAdjustmentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingAdjustmentNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingAdjustmentNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBillingAdjustmentNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<BillingAdjustmentNamesQuery, BillingAdjustmentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BillingAdjustmentNamesQuery, BillingAdjustmentNamesQueryVariables>(
		BillingAdjustmentNamesDocument,
		options,
	);
}
export function useBillingAdjustmentNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BillingAdjustmentNamesQuery, BillingAdjustmentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BillingAdjustmentNamesQuery, BillingAdjustmentNamesQueryVariables>(
		BillingAdjustmentNamesDocument,
		options,
	);
}
export function useBillingAdjustmentNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BillingAdjustmentNamesQuery, BillingAdjustmentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BillingAdjustmentNamesQuery, BillingAdjustmentNamesQueryVariables>(
		BillingAdjustmentNamesDocument,
		options,
	);
}
export type BillingAdjustmentNamesQueryHookResult = ReturnType<typeof useBillingAdjustmentNamesQuery>;
export type BillingAdjustmentNamesLazyQueryHookResult = ReturnType<typeof useBillingAdjustmentNamesLazyQuery>;
export type BillingAdjustmentNamesSuspenseQueryHookResult = ReturnType<typeof useBillingAdjustmentNamesSuspenseQuery>;
export type BillingAdjustmentNamesQueryResult = Apollo.QueryResult<
	BillingAdjustmentNamesQuery,
	BillingAdjustmentNamesQueryVariables
>;
export const BillingAdjustmentPaginationDocument = gql`
	query billingAdjustmentPagination($filters: [BillingAdjustmentFilterInput!], $order: BillingAdjustmentOrder) {
		billingAdjustmentConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useBillingAdjustmentPaginationQuery__
 *
 * To run a query within a React component, call `useBillingAdjustmentPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingAdjustmentPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingAdjustmentPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBillingAdjustmentPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<BillingAdjustmentPaginationQuery, BillingAdjustmentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BillingAdjustmentPaginationQuery, BillingAdjustmentPaginationQueryVariables>(
		BillingAdjustmentPaginationDocument,
		options,
	);
}
export function useBillingAdjustmentPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		BillingAdjustmentPaginationQuery,
		BillingAdjustmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BillingAdjustmentPaginationQuery, BillingAdjustmentPaginationQueryVariables>(
		BillingAdjustmentPaginationDocument,
		options,
	);
}
export function useBillingAdjustmentPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		BillingAdjustmentPaginationQuery,
		BillingAdjustmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BillingAdjustmentPaginationQuery, BillingAdjustmentPaginationQueryVariables>(
		BillingAdjustmentPaginationDocument,
		options,
	);
}
export type BillingAdjustmentPaginationQueryHookResult = ReturnType<typeof useBillingAdjustmentPaginationQuery>;
export type BillingAdjustmentPaginationLazyQueryHookResult = ReturnType<typeof useBillingAdjustmentPaginationLazyQuery>;
export type BillingAdjustmentPaginationSuspenseQueryHookResult = ReturnType<
	typeof useBillingAdjustmentPaginationSuspenseQuery
>;
export type BillingAdjustmentPaginationQueryResult = Apollo.QueryResult<
	BillingAdjustmentPaginationQuery,
	BillingAdjustmentPaginationQueryVariables
>;
export const BillingAdjustmentSelectDocument = gql`
	query billingAdjustmentSelect($filters: [BillingAdjustmentFilterInput!], $order: BillingAdjustmentOrder) {
		billingAdjustmentConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...BillingAdjustmentName
				}
			}
		}
	}
	${BillingAdjustmentNameFragmentDoc}
`;

/**
 * __useBillingAdjustmentSelectQuery__
 *
 * To run a query within a React component, call `useBillingAdjustmentSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingAdjustmentSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingAdjustmentSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBillingAdjustmentSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<BillingAdjustmentSelectQuery, BillingAdjustmentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BillingAdjustmentSelectQuery, BillingAdjustmentSelectQueryVariables>(
		BillingAdjustmentSelectDocument,
		options,
	);
}
export function useBillingAdjustmentSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BillingAdjustmentSelectQuery, BillingAdjustmentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BillingAdjustmentSelectQuery, BillingAdjustmentSelectQueryVariables>(
		BillingAdjustmentSelectDocument,
		options,
	);
}
export function useBillingAdjustmentSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BillingAdjustmentSelectQuery, BillingAdjustmentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BillingAdjustmentSelectQuery, BillingAdjustmentSelectQueryVariables>(
		BillingAdjustmentSelectDocument,
		options,
	);
}
export type BillingAdjustmentSelectQueryHookResult = ReturnType<typeof useBillingAdjustmentSelectQuery>;
export type BillingAdjustmentSelectLazyQueryHookResult = ReturnType<typeof useBillingAdjustmentSelectLazyQuery>;
export type BillingAdjustmentSelectSuspenseQueryHookResult = ReturnType<typeof useBillingAdjustmentSelectSuspenseQuery>;
export type BillingAdjustmentSelectQueryResult = Apollo.QueryResult<
	BillingAdjustmentSelectQuery,
	BillingAdjustmentSelectQueryVariables
>;
export const BillingAdjustmentUpdateDocument = gql`
	mutation billingAdjustmentUpdate($id: ID!, $input: BillingAdjustmentUpdateInput!) {
		updateBillingAdjustment(id: $id, input: $input) {
			...BillingAdjustmentDetail
		}
	}
	${BillingAdjustmentDetailFragmentDoc}
`;
export type BillingAdjustmentUpdateMutationFn = Apollo.MutationFunction<
	BillingAdjustmentUpdateMutation,
	BillingAdjustmentUpdateMutationVariables
>;

/**
 * __useBillingAdjustmentUpdateMutation__
 *
 * To run a mutation, you first call `useBillingAdjustmentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillingAdjustmentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingAdjustmentUpdateMutation, { data, loading, error }] = useBillingAdjustmentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingAdjustmentUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<BillingAdjustmentUpdateMutation, BillingAdjustmentUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<BillingAdjustmentUpdateMutation, BillingAdjustmentUpdateMutationVariables>(
		BillingAdjustmentUpdateDocument,
		options,
	);
}
export type BillingAdjustmentUpdateMutationHookResult = ReturnType<typeof useBillingAdjustmentUpdateMutation>;
export type BillingAdjustmentUpdateMutationResult = Apollo.MutationResult<BillingAdjustmentUpdateMutation>;
export type BillingAdjustmentUpdateMutationOptions = Apollo.BaseMutationOptions<
	BillingAdjustmentUpdateMutation,
	BillingAdjustmentUpdateMutationVariables
>;
export const BuildingCountDocument = gql`
	query buildingCount($filters: [BuildingFilterInput!], $pagination: Pagination, $order: BuildingOrder) {
		buildingConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useBuildingCountQuery__
 *
 * To run a query within a React component, call `useBuildingCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBuildingCountQuery(
	baseOptions?: Apollo.QueryHookOptions<BuildingCountQuery, BuildingCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BuildingCountQuery, BuildingCountQueryVariables>(BuildingCountDocument, options);
}
export function useBuildingCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BuildingCountQuery, BuildingCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BuildingCountQuery, BuildingCountQueryVariables>(BuildingCountDocument, options);
}
export function useBuildingCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingCountQuery, BuildingCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BuildingCountQuery, BuildingCountQueryVariables>(BuildingCountDocument, options);
}
export type BuildingCountQueryHookResult = ReturnType<typeof useBuildingCountQuery>;
export type BuildingCountLazyQueryHookResult = ReturnType<typeof useBuildingCountLazyQuery>;
export type BuildingCountSuspenseQueryHookResult = ReturnType<typeof useBuildingCountSuspenseQuery>;
export type BuildingCountQueryResult = Apollo.QueryResult<BuildingCountQuery, BuildingCountQueryVariables>;
export const BuildingCreateDocument = gql`
	mutation buildingCreate($input: BuildingCreateInput!) {
		createBuilding(input: $input) {
			...BuildingDetail
		}
	}
	${BuildingDetailFragmentDoc}
`;
export type BuildingCreateMutationFn = Apollo.MutationFunction<BuildingCreateMutation, BuildingCreateMutationVariables>;

/**
 * __useBuildingCreateMutation__
 *
 * To run a mutation, you first call `useBuildingCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildingCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildingCreateMutation, { data, loading, error }] = useBuildingCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuildingCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<BuildingCreateMutation, BuildingCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<BuildingCreateMutation, BuildingCreateMutationVariables>(BuildingCreateDocument, options);
}
export type BuildingCreateMutationHookResult = ReturnType<typeof useBuildingCreateMutation>;
export type BuildingCreateMutationResult = Apollo.MutationResult<BuildingCreateMutation>;
export type BuildingCreateMutationOptions = Apollo.BaseMutationOptions<
	BuildingCreateMutation,
	BuildingCreateMutationVariables
>;
export const BuildingDeleteDocument = gql`
	mutation buildingDelete($id: ID!) {
		deleteBuilding(id: $id)
	}
`;
export type BuildingDeleteMutationFn = Apollo.MutationFunction<BuildingDeleteMutation, BuildingDeleteMutationVariables>;

/**
 * __useBuildingDeleteMutation__
 *
 * To run a mutation, you first call `useBuildingDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildingDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildingDeleteMutation, { data, loading, error }] = useBuildingDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuildingDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<BuildingDeleteMutation, BuildingDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<BuildingDeleteMutation, BuildingDeleteMutationVariables>(BuildingDeleteDocument, options);
}
export type BuildingDeleteMutationHookResult = ReturnType<typeof useBuildingDeleteMutation>;
export type BuildingDeleteMutationResult = Apollo.MutationResult<BuildingDeleteMutation>;
export type BuildingDeleteMutationOptions = Apollo.BaseMutationOptions<
	BuildingDeleteMutation,
	BuildingDeleteMutationVariables
>;
export const BuildingDetailDocument = gql`
	query buildingDetail($id: ID!) {
		building(id: $id) {
			...BuildingDetail
		}
	}
	${BuildingDetailFragmentDoc}
`;

/**
 * __useBuildingDetailQuery__
 *
 * To run a query within a React component, call `useBuildingDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuildingDetailQuery(
	baseOptions: Apollo.QueryHookOptions<BuildingDetailQuery, BuildingDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BuildingDetailQuery, BuildingDetailQueryVariables>(BuildingDetailDocument, options);
}
export function useBuildingDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BuildingDetailQuery, BuildingDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BuildingDetailQuery, BuildingDetailQueryVariables>(BuildingDetailDocument, options);
}
export function useBuildingDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingDetailQuery, BuildingDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BuildingDetailQuery, BuildingDetailQueryVariables>(BuildingDetailDocument, options);
}
export type BuildingDetailQueryHookResult = ReturnType<typeof useBuildingDetailQuery>;
export type BuildingDetailLazyQueryHookResult = ReturnType<typeof useBuildingDetailLazyQuery>;
export type BuildingDetailSuspenseQueryHookResult = ReturnType<typeof useBuildingDetailSuspenseQuery>;
export type BuildingDetailQueryResult = Apollo.QueryResult<BuildingDetailQuery, BuildingDetailQueryVariables>;
export const BuildingIndexDocument = gql`
	query buildingIndex($filters: [BuildingFilterInput!], $pagination: Pagination, $order: BuildingOrder) {
		buildingConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					buildingFloors {
						id
					}
					campus {
						id
						...CampusName
					}
				}
			}
		}
	}
	${CampusNameFragmentDoc}
`;

/**
 * __useBuildingIndexQuery__
 *
 * To run a query within a React component, call `useBuildingIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBuildingIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<BuildingIndexQuery, BuildingIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BuildingIndexQuery, BuildingIndexQueryVariables>(BuildingIndexDocument, options);
}
export function useBuildingIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BuildingIndexQuery, BuildingIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BuildingIndexQuery, BuildingIndexQueryVariables>(BuildingIndexDocument, options);
}
export function useBuildingIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingIndexQuery, BuildingIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BuildingIndexQuery, BuildingIndexQueryVariables>(BuildingIndexDocument, options);
}
export type BuildingIndexQueryHookResult = ReturnType<typeof useBuildingIndexQuery>;
export type BuildingIndexLazyQueryHookResult = ReturnType<typeof useBuildingIndexLazyQuery>;
export type BuildingIndexSuspenseQueryHookResult = ReturnType<typeof useBuildingIndexSuspenseQuery>;
export type BuildingIndexQueryResult = Apollo.QueryResult<BuildingIndexQuery, BuildingIndexQueryVariables>;
export const BuildingNameDocument = gql`
	query buildingName($id: ID!) {
		building(id: $id) {
			id
			...BuildingName
		}
	}
	${BuildingNameFragmentDoc}
`;

/**
 * __useBuildingNameQuery__
 *
 * To run a query within a React component, call `useBuildingNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuildingNameQuery(
	baseOptions: Apollo.QueryHookOptions<BuildingNameQuery, BuildingNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BuildingNameQuery, BuildingNameQueryVariables>(BuildingNameDocument, options);
}
export function useBuildingNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BuildingNameQuery, BuildingNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BuildingNameQuery, BuildingNameQueryVariables>(BuildingNameDocument, options);
}
export function useBuildingNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingNameQuery, BuildingNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BuildingNameQuery, BuildingNameQueryVariables>(BuildingNameDocument, options);
}
export type BuildingNameQueryHookResult = ReturnType<typeof useBuildingNameQuery>;
export type BuildingNameLazyQueryHookResult = ReturnType<typeof useBuildingNameLazyQuery>;
export type BuildingNameSuspenseQueryHookResult = ReturnType<typeof useBuildingNameSuspenseQuery>;
export type BuildingNameQueryResult = Apollo.QueryResult<BuildingNameQuery, BuildingNameQueryVariables>;
export const BuildingNamesDocument = gql`
	query buildingNames($filters: [BuildingFilterInput!], $pagination: Pagination, $order: BuildingOrder) {
		buildingConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...BuildingName
				}
			}
		}
	}
	${BuildingNameFragmentDoc}
`;

/**
 * __useBuildingNamesQuery__
 *
 * To run a query within a React component, call `useBuildingNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBuildingNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<BuildingNamesQuery, BuildingNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BuildingNamesQuery, BuildingNamesQueryVariables>(BuildingNamesDocument, options);
}
export function useBuildingNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BuildingNamesQuery, BuildingNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BuildingNamesQuery, BuildingNamesQueryVariables>(BuildingNamesDocument, options);
}
export function useBuildingNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingNamesQuery, BuildingNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BuildingNamesQuery, BuildingNamesQueryVariables>(BuildingNamesDocument, options);
}
export type BuildingNamesQueryHookResult = ReturnType<typeof useBuildingNamesQuery>;
export type BuildingNamesLazyQueryHookResult = ReturnType<typeof useBuildingNamesLazyQuery>;
export type BuildingNamesSuspenseQueryHookResult = ReturnType<typeof useBuildingNamesSuspenseQuery>;
export type BuildingNamesQueryResult = Apollo.QueryResult<BuildingNamesQuery, BuildingNamesQueryVariables>;
export const BuildingPaginationDocument = gql`
	query buildingPagination($filters: [BuildingFilterInput!], $order: BuildingOrder) {
		buildingConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useBuildingPaginationQuery__
 *
 * To run a query within a React component, call `useBuildingPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBuildingPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<BuildingPaginationQuery, BuildingPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BuildingPaginationQuery, BuildingPaginationQueryVariables>(
		BuildingPaginationDocument,
		options,
	);
}
export function useBuildingPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BuildingPaginationQuery, BuildingPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BuildingPaginationQuery, BuildingPaginationQueryVariables>(
		BuildingPaginationDocument,
		options,
	);
}
export function useBuildingPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingPaginationQuery, BuildingPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BuildingPaginationQuery, BuildingPaginationQueryVariables>(
		BuildingPaginationDocument,
		options,
	);
}
export type BuildingPaginationQueryHookResult = ReturnType<typeof useBuildingPaginationQuery>;
export type BuildingPaginationLazyQueryHookResult = ReturnType<typeof useBuildingPaginationLazyQuery>;
export type BuildingPaginationSuspenseQueryHookResult = ReturnType<typeof useBuildingPaginationSuspenseQuery>;
export type BuildingPaginationQueryResult = Apollo.QueryResult<
	BuildingPaginationQuery,
	BuildingPaginationQueryVariables
>;
export const BuildingSelectDocument = gql`
	query buildingSelect($filters: [BuildingFilterInput!], $order: BuildingOrder) {
		buildingConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...BuildingName
				}
			}
		}
	}
	${BuildingNameFragmentDoc}
`;

/**
 * __useBuildingSelectQuery__
 *
 * To run a query within a React component, call `useBuildingSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBuildingSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<BuildingSelectQuery, BuildingSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BuildingSelectQuery, BuildingSelectQueryVariables>(BuildingSelectDocument, options);
}
export function useBuildingSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BuildingSelectQuery, BuildingSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BuildingSelectQuery, BuildingSelectQueryVariables>(BuildingSelectDocument, options);
}
export function useBuildingSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingSelectQuery, BuildingSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BuildingSelectQuery, BuildingSelectQueryVariables>(BuildingSelectDocument, options);
}
export type BuildingSelectQueryHookResult = ReturnType<typeof useBuildingSelectQuery>;
export type BuildingSelectLazyQueryHookResult = ReturnType<typeof useBuildingSelectLazyQuery>;
export type BuildingSelectSuspenseQueryHookResult = ReturnType<typeof useBuildingSelectSuspenseQuery>;
export type BuildingSelectQueryResult = Apollo.QueryResult<BuildingSelectQuery, BuildingSelectQueryVariables>;
export const BuildingUpdateDocument = gql`
	mutation buildingUpdate($id: ID!, $input: BuildingUpdateInput!) {
		updateBuilding(id: $id, input: $input) {
			...BuildingDetail
		}
	}
	${BuildingDetailFragmentDoc}
`;
export type BuildingUpdateMutationFn = Apollo.MutationFunction<BuildingUpdateMutation, BuildingUpdateMutationVariables>;

/**
 * __useBuildingUpdateMutation__
 *
 * To run a mutation, you first call `useBuildingUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildingUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildingUpdateMutation, { data, loading, error }] = useBuildingUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuildingUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<BuildingUpdateMutation, BuildingUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<BuildingUpdateMutation, BuildingUpdateMutationVariables>(BuildingUpdateDocument, options);
}
export type BuildingUpdateMutationHookResult = ReturnType<typeof useBuildingUpdateMutation>;
export type BuildingUpdateMutationResult = Apollo.MutationResult<BuildingUpdateMutation>;
export type BuildingUpdateMutationOptions = Apollo.BaseMutationOptions<
	BuildingUpdateMutation,
	BuildingUpdateMutationVariables
>;
export const BuildingFloorCountDocument = gql`
	query buildingFloorCount($filters: [BuildingFloorFilterInput!], $pagination: Pagination, $order: BuildingFloorOrder) {
		buildingFloorConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useBuildingFloorCountQuery__
 *
 * To run a query within a React component, call `useBuildingFloorCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingFloorCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingFloorCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBuildingFloorCountQuery(
	baseOptions?: Apollo.QueryHookOptions<BuildingFloorCountQuery, BuildingFloorCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BuildingFloorCountQuery, BuildingFloorCountQueryVariables>(
		BuildingFloorCountDocument,
		options,
	);
}
export function useBuildingFloorCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BuildingFloorCountQuery, BuildingFloorCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BuildingFloorCountQuery, BuildingFloorCountQueryVariables>(
		BuildingFloorCountDocument,
		options,
	);
}
export function useBuildingFloorCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingFloorCountQuery, BuildingFloorCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BuildingFloorCountQuery, BuildingFloorCountQueryVariables>(
		BuildingFloorCountDocument,
		options,
	);
}
export type BuildingFloorCountQueryHookResult = ReturnType<typeof useBuildingFloorCountQuery>;
export type BuildingFloorCountLazyQueryHookResult = ReturnType<typeof useBuildingFloorCountLazyQuery>;
export type BuildingFloorCountSuspenseQueryHookResult = ReturnType<typeof useBuildingFloorCountSuspenseQuery>;
export type BuildingFloorCountQueryResult = Apollo.QueryResult<
	BuildingFloorCountQuery,
	BuildingFloorCountQueryVariables
>;
export const BuildingFloorCreateDocument = gql`
	mutation buildingFloorCreate($input: BuildingFloorCreateInput!) {
		createBuildingFloor(input: $input) {
			...BuildingFloorDetail
		}
	}
	${BuildingFloorDetailFragmentDoc}
`;
export type BuildingFloorCreateMutationFn = Apollo.MutationFunction<
	BuildingFloorCreateMutation,
	BuildingFloorCreateMutationVariables
>;

/**
 * __useBuildingFloorCreateMutation__
 *
 * To run a mutation, you first call `useBuildingFloorCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildingFloorCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildingFloorCreateMutation, { data, loading, error }] = useBuildingFloorCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuildingFloorCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<BuildingFloorCreateMutation, BuildingFloorCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<BuildingFloorCreateMutation, BuildingFloorCreateMutationVariables>(
		BuildingFloorCreateDocument,
		options,
	);
}
export type BuildingFloorCreateMutationHookResult = ReturnType<typeof useBuildingFloorCreateMutation>;
export type BuildingFloorCreateMutationResult = Apollo.MutationResult<BuildingFloorCreateMutation>;
export type BuildingFloorCreateMutationOptions = Apollo.BaseMutationOptions<
	BuildingFloorCreateMutation,
	BuildingFloorCreateMutationVariables
>;
export const BuildingFloorDeleteDocument = gql`
	mutation buildingFloorDelete($id: ID!) {
		deleteBuildingFloor(id: $id)
	}
`;
export type BuildingFloorDeleteMutationFn = Apollo.MutationFunction<
	BuildingFloorDeleteMutation,
	BuildingFloorDeleteMutationVariables
>;

/**
 * __useBuildingFloorDeleteMutation__
 *
 * To run a mutation, you first call `useBuildingFloorDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildingFloorDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildingFloorDeleteMutation, { data, loading, error }] = useBuildingFloorDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuildingFloorDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<BuildingFloorDeleteMutation, BuildingFloorDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<BuildingFloorDeleteMutation, BuildingFloorDeleteMutationVariables>(
		BuildingFloorDeleteDocument,
		options,
	);
}
export type BuildingFloorDeleteMutationHookResult = ReturnType<typeof useBuildingFloorDeleteMutation>;
export type BuildingFloorDeleteMutationResult = Apollo.MutationResult<BuildingFloorDeleteMutation>;
export type BuildingFloorDeleteMutationOptions = Apollo.BaseMutationOptions<
	BuildingFloorDeleteMutation,
	BuildingFloorDeleteMutationVariables
>;
export const BuildingFloorDetailDocument = gql`
	query buildingFloorDetail($id: ID!) {
		buildingFloor(id: $id) {
			...BuildingFloorDetail
		}
	}
	${BuildingFloorDetailFragmentDoc}
`;

/**
 * __useBuildingFloorDetailQuery__
 *
 * To run a query within a React component, call `useBuildingFloorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingFloorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingFloorDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuildingFloorDetailQuery(
	baseOptions: Apollo.QueryHookOptions<BuildingFloorDetailQuery, BuildingFloorDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BuildingFloorDetailQuery, BuildingFloorDetailQueryVariables>(
		BuildingFloorDetailDocument,
		options,
	);
}
export function useBuildingFloorDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BuildingFloorDetailQuery, BuildingFloorDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BuildingFloorDetailQuery, BuildingFloorDetailQueryVariables>(
		BuildingFloorDetailDocument,
		options,
	);
}
export function useBuildingFloorDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingFloorDetailQuery, BuildingFloorDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BuildingFloorDetailQuery, BuildingFloorDetailQueryVariables>(
		BuildingFloorDetailDocument,
		options,
	);
}
export type BuildingFloorDetailQueryHookResult = ReturnType<typeof useBuildingFloorDetailQuery>;
export type BuildingFloorDetailLazyQueryHookResult = ReturnType<typeof useBuildingFloorDetailLazyQuery>;
export type BuildingFloorDetailSuspenseQueryHookResult = ReturnType<typeof useBuildingFloorDetailSuspenseQuery>;
export type BuildingFloorDetailQueryResult = Apollo.QueryResult<
	BuildingFloorDetailQuery,
	BuildingFloorDetailQueryVariables
>;
export const BuildingFloorIndexDocument = gql`
	query buildingFloorIndex($filters: [BuildingFloorFilterInput!], $pagination: Pagination, $order: BuildingFloorOrder) {
		buildingFloorConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					level
					building {
						id
						...BuildingName
						campus {
							id
							...CampusName
						}
					}
					rooms {
						id
					}
				}
			}
		}
	}
	${BuildingNameFragmentDoc}
	${CampusNameFragmentDoc}
`;

/**
 * __useBuildingFloorIndexQuery__
 *
 * To run a query within a React component, call `useBuildingFloorIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingFloorIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingFloorIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBuildingFloorIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<BuildingFloorIndexQuery, BuildingFloorIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BuildingFloorIndexQuery, BuildingFloorIndexQueryVariables>(
		BuildingFloorIndexDocument,
		options,
	);
}
export function useBuildingFloorIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BuildingFloorIndexQuery, BuildingFloorIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BuildingFloorIndexQuery, BuildingFloorIndexQueryVariables>(
		BuildingFloorIndexDocument,
		options,
	);
}
export function useBuildingFloorIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingFloorIndexQuery, BuildingFloorIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BuildingFloorIndexQuery, BuildingFloorIndexQueryVariables>(
		BuildingFloorIndexDocument,
		options,
	);
}
export type BuildingFloorIndexQueryHookResult = ReturnType<typeof useBuildingFloorIndexQuery>;
export type BuildingFloorIndexLazyQueryHookResult = ReturnType<typeof useBuildingFloorIndexLazyQuery>;
export type BuildingFloorIndexSuspenseQueryHookResult = ReturnType<typeof useBuildingFloorIndexSuspenseQuery>;
export type BuildingFloorIndexQueryResult = Apollo.QueryResult<
	BuildingFloorIndexQuery,
	BuildingFloorIndexQueryVariables
>;
export const BuildingFloorNameDocument = gql`
	query buildingFloorName($id: ID!) {
		buildingFloor(id: $id) {
			id
			...BuildingFloorName
		}
	}
	${BuildingFloorNameFragmentDoc}
`;

/**
 * __useBuildingFloorNameQuery__
 *
 * To run a query within a React component, call `useBuildingFloorNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingFloorNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingFloorNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuildingFloorNameQuery(
	baseOptions: Apollo.QueryHookOptions<BuildingFloorNameQuery, BuildingFloorNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BuildingFloorNameQuery, BuildingFloorNameQueryVariables>(BuildingFloorNameDocument, options);
}
export function useBuildingFloorNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BuildingFloorNameQuery, BuildingFloorNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BuildingFloorNameQuery, BuildingFloorNameQueryVariables>(
		BuildingFloorNameDocument,
		options,
	);
}
export function useBuildingFloorNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingFloorNameQuery, BuildingFloorNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BuildingFloorNameQuery, BuildingFloorNameQueryVariables>(
		BuildingFloorNameDocument,
		options,
	);
}
export type BuildingFloorNameQueryHookResult = ReturnType<typeof useBuildingFloorNameQuery>;
export type BuildingFloorNameLazyQueryHookResult = ReturnType<typeof useBuildingFloorNameLazyQuery>;
export type BuildingFloorNameSuspenseQueryHookResult = ReturnType<typeof useBuildingFloorNameSuspenseQuery>;
export type BuildingFloorNameQueryResult = Apollo.QueryResult<BuildingFloorNameQuery, BuildingFloorNameQueryVariables>;
export const BuildingFloorNamesDocument = gql`
	query buildingFloorNames($filters: [BuildingFloorFilterInput!], $pagination: Pagination, $order: BuildingFloorOrder) {
		buildingFloorConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...BuildingFloorName
				}
			}
		}
	}
	${BuildingFloorNameFragmentDoc}
`;

/**
 * __useBuildingFloorNamesQuery__
 *
 * To run a query within a React component, call `useBuildingFloorNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingFloorNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingFloorNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBuildingFloorNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<BuildingFloorNamesQuery, BuildingFloorNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BuildingFloorNamesQuery, BuildingFloorNamesQueryVariables>(
		BuildingFloorNamesDocument,
		options,
	);
}
export function useBuildingFloorNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BuildingFloorNamesQuery, BuildingFloorNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BuildingFloorNamesQuery, BuildingFloorNamesQueryVariables>(
		BuildingFloorNamesDocument,
		options,
	);
}
export function useBuildingFloorNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingFloorNamesQuery, BuildingFloorNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BuildingFloorNamesQuery, BuildingFloorNamesQueryVariables>(
		BuildingFloorNamesDocument,
		options,
	);
}
export type BuildingFloorNamesQueryHookResult = ReturnType<typeof useBuildingFloorNamesQuery>;
export type BuildingFloorNamesLazyQueryHookResult = ReturnType<typeof useBuildingFloorNamesLazyQuery>;
export type BuildingFloorNamesSuspenseQueryHookResult = ReturnType<typeof useBuildingFloorNamesSuspenseQuery>;
export type BuildingFloorNamesQueryResult = Apollo.QueryResult<
	BuildingFloorNamesQuery,
	BuildingFloorNamesQueryVariables
>;
export const BuildingFloorPaginationDocument = gql`
	query buildingFloorPagination($filters: [BuildingFloorFilterInput!], $order: BuildingFloorOrder) {
		buildingFloorConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useBuildingFloorPaginationQuery__
 *
 * To run a query within a React component, call `useBuildingFloorPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingFloorPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingFloorPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBuildingFloorPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<BuildingFloorPaginationQuery, BuildingFloorPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BuildingFloorPaginationQuery, BuildingFloorPaginationQueryVariables>(
		BuildingFloorPaginationDocument,
		options,
	);
}
export function useBuildingFloorPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BuildingFloorPaginationQuery, BuildingFloorPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BuildingFloorPaginationQuery, BuildingFloorPaginationQueryVariables>(
		BuildingFloorPaginationDocument,
		options,
	);
}
export function useBuildingFloorPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingFloorPaginationQuery, BuildingFloorPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BuildingFloorPaginationQuery, BuildingFloorPaginationQueryVariables>(
		BuildingFloorPaginationDocument,
		options,
	);
}
export type BuildingFloorPaginationQueryHookResult = ReturnType<typeof useBuildingFloorPaginationQuery>;
export type BuildingFloorPaginationLazyQueryHookResult = ReturnType<typeof useBuildingFloorPaginationLazyQuery>;
export type BuildingFloorPaginationSuspenseQueryHookResult = ReturnType<typeof useBuildingFloorPaginationSuspenseQuery>;
export type BuildingFloorPaginationQueryResult = Apollo.QueryResult<
	BuildingFloorPaginationQuery,
	BuildingFloorPaginationQueryVariables
>;
export const BuildingFloorSelectDocument = gql`
	query buildingFloorSelect($filters: [BuildingFloorFilterInput!], $order: BuildingFloorOrder) {
		buildingFloorConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...BuildingFloorName
				}
			}
		}
	}
	${BuildingFloorNameFragmentDoc}
`;

/**
 * __useBuildingFloorSelectQuery__
 *
 * To run a query within a React component, call `useBuildingFloorSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingFloorSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingFloorSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBuildingFloorSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<BuildingFloorSelectQuery, BuildingFloorSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BuildingFloorSelectQuery, BuildingFloorSelectQueryVariables>(
		BuildingFloorSelectDocument,
		options,
	);
}
export function useBuildingFloorSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BuildingFloorSelectQuery, BuildingFloorSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BuildingFloorSelectQuery, BuildingFloorSelectQueryVariables>(
		BuildingFloorSelectDocument,
		options,
	);
}
export function useBuildingFloorSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingFloorSelectQuery, BuildingFloorSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BuildingFloorSelectQuery, BuildingFloorSelectQueryVariables>(
		BuildingFloorSelectDocument,
		options,
	);
}
export type BuildingFloorSelectQueryHookResult = ReturnType<typeof useBuildingFloorSelectQuery>;
export type BuildingFloorSelectLazyQueryHookResult = ReturnType<typeof useBuildingFloorSelectLazyQuery>;
export type BuildingFloorSelectSuspenseQueryHookResult = ReturnType<typeof useBuildingFloorSelectSuspenseQuery>;
export type BuildingFloorSelectQueryResult = Apollo.QueryResult<
	BuildingFloorSelectQuery,
	BuildingFloorSelectQueryVariables
>;
export const BuildingFloorUpdateDocument = gql`
	mutation buildingFloorUpdate($id: ID!, $input: BuildingFloorUpdateInput!) {
		updateBuildingFloor(id: $id, input: $input) {
			...BuildingFloorDetail
		}
	}
	${BuildingFloorDetailFragmentDoc}
`;
export type BuildingFloorUpdateMutationFn = Apollo.MutationFunction<
	BuildingFloorUpdateMutation,
	BuildingFloorUpdateMutationVariables
>;

/**
 * __useBuildingFloorUpdateMutation__
 *
 * To run a mutation, you first call `useBuildingFloorUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildingFloorUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildingFloorUpdateMutation, { data, loading, error }] = useBuildingFloorUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuildingFloorUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<BuildingFloorUpdateMutation, BuildingFloorUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<BuildingFloorUpdateMutation, BuildingFloorUpdateMutationVariables>(
		BuildingFloorUpdateDocument,
		options,
	);
}
export type BuildingFloorUpdateMutationHookResult = ReturnType<typeof useBuildingFloorUpdateMutation>;
export type BuildingFloorUpdateMutationResult = Apollo.MutationResult<BuildingFloorUpdateMutation>;
export type BuildingFloorUpdateMutationOptions = Apollo.BaseMutationOptions<
	BuildingFloorUpdateMutation,
	BuildingFloorUpdateMutationVariables
>;
export const CalendarEventCalendarSlimListDocument = gql`
	query calendarEventCalendarSlimList(
		$filters: [CalendarEventFilterInput!]
		$pagination: Pagination
		$order: CalendarEventOrder
	) {
		calendarEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					...CalendarEventTiming
					author {
						id
						isCurrent
					}
					sharingRecord {
						id
						isPublic
						userGroups {
							id
							...UserGroupNameAndColor
						}
					}
				}
			}
		}
	}
	${CalendarEventTimingFragmentDoc}
	${UserGroupNameAndColorFragmentDoc}
`;

/**
 * __useCalendarEventCalendarSlimListQuery__
 *
 * To run a query within a React component, call `useCalendarEventCalendarSlimListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventCalendarSlimListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventCalendarSlimListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventCalendarSlimListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CalendarEventCalendarSlimListQuery,
		CalendarEventCalendarSlimListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventCalendarSlimListQuery, CalendarEventCalendarSlimListQueryVariables>(
		CalendarEventCalendarSlimListDocument,
		options,
	);
}
export function useCalendarEventCalendarSlimListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CalendarEventCalendarSlimListQuery,
		CalendarEventCalendarSlimListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventCalendarSlimListQuery, CalendarEventCalendarSlimListQueryVariables>(
		CalendarEventCalendarSlimListDocument,
		options,
	);
}
export function useCalendarEventCalendarSlimListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventCalendarSlimListQuery,
		CalendarEventCalendarSlimListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventCalendarSlimListQuery, CalendarEventCalendarSlimListQueryVariables>(
		CalendarEventCalendarSlimListDocument,
		options,
	);
}
export type CalendarEventCalendarSlimListQueryHookResult = ReturnType<typeof useCalendarEventCalendarSlimListQuery>;
export type CalendarEventCalendarSlimListLazyQueryHookResult = ReturnType<
	typeof useCalendarEventCalendarSlimListLazyQuery
>;
export type CalendarEventCalendarSlimListSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventCalendarSlimListSuspenseQuery
>;
export type CalendarEventCalendarSlimListQueryResult = Apollo.QueryResult<
	CalendarEventCalendarSlimListQuery,
	CalendarEventCalendarSlimListQueryVariables
>;
export const CalendarEventCalendarListDocument = gql`
	query calendarEventCalendarList(
		$filters: [CalendarEventFilterInput!]
		$pagination: Pagination
		$order: CalendarEventOrder
	) {
		calendarEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					description
					...CalendarEventTiming
					author {
						id
						isCurrent
					}
					sharingRecord {
						id
						isPublic
						userGroups {
							id
							...UserGroupNameAndColor
						}
					}
				}
			}
		}
	}
	${CalendarEventTimingFragmentDoc}
	${UserGroupNameAndColorFragmentDoc}
`;

/**
 * __useCalendarEventCalendarListQuery__
 *
 * To run a query within a React component, call `useCalendarEventCalendarListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventCalendarListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventCalendarListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventCalendarListQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventCalendarListQuery, CalendarEventCalendarListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventCalendarListQuery, CalendarEventCalendarListQueryVariables>(
		CalendarEventCalendarListDocument,
		options,
	);
}
export function useCalendarEventCalendarListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventCalendarListQuery, CalendarEventCalendarListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventCalendarListQuery, CalendarEventCalendarListQueryVariables>(
		CalendarEventCalendarListDocument,
		options,
	);
}
export function useCalendarEventCalendarListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventCalendarListQuery,
		CalendarEventCalendarListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventCalendarListQuery, CalendarEventCalendarListQueryVariables>(
		CalendarEventCalendarListDocument,
		options,
	);
}
export type CalendarEventCalendarListQueryHookResult = ReturnType<typeof useCalendarEventCalendarListQuery>;
export type CalendarEventCalendarListLazyQueryHookResult = ReturnType<typeof useCalendarEventCalendarListLazyQuery>;
export type CalendarEventCalendarListSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventCalendarListSuspenseQuery
>;
export type CalendarEventCalendarListQueryResult = Apollo.QueryResult<
	CalendarEventCalendarListQuery,
	CalendarEventCalendarListQueryVariables
>;
export const CalendarEventCalendarDetailDocument = gql`
	query calendarEventCalendarDetail($id: ID!) {
		calendarEventConnection(filters: { idEQ: $id }) {
			edges {
				node {
					...CalendarEventCalendarDetail
				}
			}
		}
	}
	${CalendarEventCalendarDetailFragmentDoc}
`;

/**
 * __useCalendarEventCalendarDetailQuery__
 *
 * To run a query within a React component, call `useCalendarEventCalendarDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventCalendarDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventCalendarDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalendarEventCalendarDetailQuery(
	baseOptions: Apollo.QueryHookOptions<CalendarEventCalendarDetailQuery, CalendarEventCalendarDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventCalendarDetailQuery, CalendarEventCalendarDetailQueryVariables>(
		CalendarEventCalendarDetailDocument,
		options,
	);
}
export function useCalendarEventCalendarDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CalendarEventCalendarDetailQuery,
		CalendarEventCalendarDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventCalendarDetailQuery, CalendarEventCalendarDetailQueryVariables>(
		CalendarEventCalendarDetailDocument,
		options,
	);
}
export function useCalendarEventCalendarDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventCalendarDetailQuery,
		CalendarEventCalendarDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventCalendarDetailQuery, CalendarEventCalendarDetailQueryVariables>(
		CalendarEventCalendarDetailDocument,
		options,
	);
}
export type CalendarEventCalendarDetailQueryHookResult = ReturnType<typeof useCalendarEventCalendarDetailQuery>;
export type CalendarEventCalendarDetailLazyQueryHookResult = ReturnType<typeof useCalendarEventCalendarDetailLazyQuery>;
export type CalendarEventCalendarDetailSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventCalendarDetailSuspenseQuery
>;
export type CalendarEventCalendarDetailQueryResult = Apollo.QueryResult<
	CalendarEventCalendarDetailQuery,
	CalendarEventCalendarDetailQueryVariables
>;
export const CalendarEventCalendarDetailedListDocument = gql`
	query calendarEventCalendarDetailedList(
		$filters: [CalendarEventFilterInput!]
		$pagination: Pagination
		$order: CalendarEventOrder
	) {
		calendarEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					...CalendarEventCalendarDetail
				}
			}
		}
	}
	${CalendarEventCalendarDetailFragmentDoc}
`;

/**
 * __useCalendarEventCalendarDetailedListQuery__
 *
 * To run a query within a React component, call `useCalendarEventCalendarDetailedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventCalendarDetailedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventCalendarDetailedListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventCalendarDetailedListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CalendarEventCalendarDetailedListQuery,
		CalendarEventCalendarDetailedListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventCalendarDetailedListQuery, CalendarEventCalendarDetailedListQueryVariables>(
		CalendarEventCalendarDetailedListDocument,
		options,
	);
}
export function useCalendarEventCalendarDetailedListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CalendarEventCalendarDetailedListQuery,
		CalendarEventCalendarDetailedListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventCalendarDetailedListQuery, CalendarEventCalendarDetailedListQueryVariables>(
		CalendarEventCalendarDetailedListDocument,
		options,
	);
}
export function useCalendarEventCalendarDetailedListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventCalendarDetailedListQuery,
		CalendarEventCalendarDetailedListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CalendarEventCalendarDetailedListQuery,
		CalendarEventCalendarDetailedListQueryVariables
	>(CalendarEventCalendarDetailedListDocument, options);
}
export type CalendarEventCalendarDetailedListQueryHookResult = ReturnType<
	typeof useCalendarEventCalendarDetailedListQuery
>;
export type CalendarEventCalendarDetailedListLazyQueryHookResult = ReturnType<
	typeof useCalendarEventCalendarDetailedListLazyQuery
>;
export type CalendarEventCalendarDetailedListSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventCalendarDetailedListSuspenseQuery
>;
export type CalendarEventCalendarDetailedListQueryResult = Apollo.QueryResult<
	CalendarEventCalendarDetailedListQuery,
	CalendarEventCalendarDetailedListQueryVariables
>;
export const CalendarEventCountDocument = gql`
	query calendarEventCount($filters: [CalendarEventFilterInput!], $pagination: Pagination, $order: CalendarEventOrder) {
		calendarEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useCalendarEventCountQuery__
 *
 * To run a query within a React component, call `useCalendarEventCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventCountQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventCountQuery, CalendarEventCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventCountQuery, CalendarEventCountQueryVariables>(
		CalendarEventCountDocument,
		options,
	);
}
export function useCalendarEventCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventCountQuery, CalendarEventCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventCountQuery, CalendarEventCountQueryVariables>(
		CalendarEventCountDocument,
		options,
	);
}
export function useCalendarEventCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventCountQuery, CalendarEventCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventCountQuery, CalendarEventCountQueryVariables>(
		CalendarEventCountDocument,
		options,
	);
}
export type CalendarEventCountQueryHookResult = ReturnType<typeof useCalendarEventCountQuery>;
export type CalendarEventCountLazyQueryHookResult = ReturnType<typeof useCalendarEventCountLazyQuery>;
export type CalendarEventCountSuspenseQueryHookResult = ReturnType<typeof useCalendarEventCountSuspenseQuery>;
export type CalendarEventCountQueryResult = Apollo.QueryResult<
	CalendarEventCountQuery,
	CalendarEventCountQueryVariables
>;
export const CalendarEventCreateDocument = gql`
	mutation calendarEventCreate($input: CalendarEventCreateInput!) {
		createCalendarEvent(input: $input) {
			...CalendarEventDetail
		}
	}
	${CalendarEventDetailFragmentDoc}
`;
export type CalendarEventCreateMutationFn = Apollo.MutationFunction<
	CalendarEventCreateMutation,
	CalendarEventCreateMutationVariables
>;

/**
 * __useCalendarEventCreateMutation__
 *
 * To run a mutation, you first call `useCalendarEventCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventCreateMutation, { data, loading, error }] = useCalendarEventCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarEventCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<CalendarEventCreateMutation, CalendarEventCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CalendarEventCreateMutation, CalendarEventCreateMutationVariables>(
		CalendarEventCreateDocument,
		options,
	);
}
export type CalendarEventCreateMutationHookResult = ReturnType<typeof useCalendarEventCreateMutation>;
export type CalendarEventCreateMutationResult = Apollo.MutationResult<CalendarEventCreateMutation>;
export type CalendarEventCreateMutationOptions = Apollo.BaseMutationOptions<
	CalendarEventCreateMutation,
	CalendarEventCreateMutationVariables
>;
export const CalendarEventDeleteDocument = gql`
	mutation calendarEventDelete($id: ID!) {
		deleteCalendarEvent(id: $id)
	}
`;
export type CalendarEventDeleteMutationFn = Apollo.MutationFunction<
	CalendarEventDeleteMutation,
	CalendarEventDeleteMutationVariables
>;

/**
 * __useCalendarEventDeleteMutation__
 *
 * To run a mutation, you first call `useCalendarEventDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventDeleteMutation, { data, loading, error }] = useCalendarEventDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalendarEventDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<CalendarEventDeleteMutation, CalendarEventDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CalendarEventDeleteMutation, CalendarEventDeleteMutationVariables>(
		CalendarEventDeleteDocument,
		options,
	);
}
export type CalendarEventDeleteMutationHookResult = ReturnType<typeof useCalendarEventDeleteMutation>;
export type CalendarEventDeleteMutationResult = Apollo.MutationResult<CalendarEventDeleteMutation>;
export type CalendarEventDeleteMutationOptions = Apollo.BaseMutationOptions<
	CalendarEventDeleteMutation,
	CalendarEventDeleteMutationVariables
>;
export const CalendarEventDetailDocument = gql`
	query calendarEventDetail($id: ID!) {
		calendarEvent(id: $id) {
			...CalendarEventDetail
		}
	}
	${CalendarEventDetailFragmentDoc}
`;

/**
 * __useCalendarEventDetailQuery__
 *
 * To run a query within a React component, call `useCalendarEventDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalendarEventDetailQuery(
	baseOptions: Apollo.QueryHookOptions<CalendarEventDetailQuery, CalendarEventDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventDetailQuery, CalendarEventDetailQueryVariables>(
		CalendarEventDetailDocument,
		options,
	);
}
export function useCalendarEventDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventDetailQuery, CalendarEventDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventDetailQuery, CalendarEventDetailQueryVariables>(
		CalendarEventDetailDocument,
		options,
	);
}
export function useCalendarEventDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventDetailQuery, CalendarEventDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventDetailQuery, CalendarEventDetailQueryVariables>(
		CalendarEventDetailDocument,
		options,
	);
}
export type CalendarEventDetailQueryHookResult = ReturnType<typeof useCalendarEventDetailQuery>;
export type CalendarEventDetailLazyQueryHookResult = ReturnType<typeof useCalendarEventDetailLazyQuery>;
export type CalendarEventDetailSuspenseQueryHookResult = ReturnType<typeof useCalendarEventDetailSuspenseQuery>;
export type CalendarEventDetailQueryResult = Apollo.QueryResult<
	CalendarEventDetailQuery,
	CalendarEventDetailQueryVariables
>;
export const CalendarEventIndexDocument = gql`
	query calendarEventIndex($filters: [CalendarEventFilterInput!], $pagination: Pagination, $order: CalendarEventOrder) {
		calendarEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					description
					location
					imageURL
					imageContentType
					isAllDay
					startTime
					endTime
					startDate
					isMultiDay
					endDate
					allowsResponses
					createdAt
				}
			}
		}
	}
`;

/**
 * __useCalendarEventIndexQuery__
 *
 * To run a query within a React component, call `useCalendarEventIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventIndexQuery, CalendarEventIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventIndexQuery, CalendarEventIndexQueryVariables>(
		CalendarEventIndexDocument,
		options,
	);
}
export function useCalendarEventIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventIndexQuery, CalendarEventIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventIndexQuery, CalendarEventIndexQueryVariables>(
		CalendarEventIndexDocument,
		options,
	);
}
export function useCalendarEventIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventIndexQuery, CalendarEventIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventIndexQuery, CalendarEventIndexQueryVariables>(
		CalendarEventIndexDocument,
		options,
	);
}
export type CalendarEventIndexQueryHookResult = ReturnType<typeof useCalendarEventIndexQuery>;
export type CalendarEventIndexLazyQueryHookResult = ReturnType<typeof useCalendarEventIndexLazyQuery>;
export type CalendarEventIndexSuspenseQueryHookResult = ReturnType<typeof useCalendarEventIndexSuspenseQuery>;
export type CalendarEventIndexQueryResult = Apollo.QueryResult<
	CalendarEventIndexQuery,
	CalendarEventIndexQueryVariables
>;
export const CalendarEventNameDocument = gql`
	query calendarEventName($id: ID!) {
		calendarEvent(id: $id) {
			id
			...CalendarEventName
		}
	}
	${CalendarEventNameFragmentDoc}
`;

/**
 * __useCalendarEventNameQuery__
 *
 * To run a query within a React component, call `useCalendarEventNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalendarEventNameQuery(
	baseOptions: Apollo.QueryHookOptions<CalendarEventNameQuery, CalendarEventNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventNameQuery, CalendarEventNameQueryVariables>(CalendarEventNameDocument, options);
}
export function useCalendarEventNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventNameQuery, CalendarEventNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventNameQuery, CalendarEventNameQueryVariables>(
		CalendarEventNameDocument,
		options,
	);
}
export function useCalendarEventNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventNameQuery, CalendarEventNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventNameQuery, CalendarEventNameQueryVariables>(
		CalendarEventNameDocument,
		options,
	);
}
export type CalendarEventNameQueryHookResult = ReturnType<typeof useCalendarEventNameQuery>;
export type CalendarEventNameLazyQueryHookResult = ReturnType<typeof useCalendarEventNameLazyQuery>;
export type CalendarEventNameSuspenseQueryHookResult = ReturnType<typeof useCalendarEventNameSuspenseQuery>;
export type CalendarEventNameQueryResult = Apollo.QueryResult<CalendarEventNameQuery, CalendarEventNameQueryVariables>;
export const CalendarEventNamesDocument = gql`
	query calendarEventNames($filters: [CalendarEventFilterInput!], $pagination: Pagination, $order: CalendarEventOrder) {
		calendarEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...CalendarEventName
				}
			}
		}
	}
	${CalendarEventNameFragmentDoc}
`;

/**
 * __useCalendarEventNamesQuery__
 *
 * To run a query within a React component, call `useCalendarEventNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventNamesQuery, CalendarEventNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventNamesQuery, CalendarEventNamesQueryVariables>(
		CalendarEventNamesDocument,
		options,
	);
}
export function useCalendarEventNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventNamesQuery, CalendarEventNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventNamesQuery, CalendarEventNamesQueryVariables>(
		CalendarEventNamesDocument,
		options,
	);
}
export function useCalendarEventNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventNamesQuery, CalendarEventNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventNamesQuery, CalendarEventNamesQueryVariables>(
		CalendarEventNamesDocument,
		options,
	);
}
export type CalendarEventNamesQueryHookResult = ReturnType<typeof useCalendarEventNamesQuery>;
export type CalendarEventNamesLazyQueryHookResult = ReturnType<typeof useCalendarEventNamesLazyQuery>;
export type CalendarEventNamesSuspenseQueryHookResult = ReturnType<typeof useCalendarEventNamesSuspenseQuery>;
export type CalendarEventNamesQueryResult = Apollo.QueryResult<
	CalendarEventNamesQuery,
	CalendarEventNamesQueryVariables
>;
export const CalendarEventPaginationDocument = gql`
	query calendarEventPagination($filters: [CalendarEventFilterInput!], $order: CalendarEventOrder) {
		calendarEventConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useCalendarEventPaginationQuery__
 *
 * To run a query within a React component, call `useCalendarEventPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventPaginationQuery, CalendarEventPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventPaginationQuery, CalendarEventPaginationQueryVariables>(
		CalendarEventPaginationDocument,
		options,
	);
}
export function useCalendarEventPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventPaginationQuery, CalendarEventPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventPaginationQuery, CalendarEventPaginationQueryVariables>(
		CalendarEventPaginationDocument,
		options,
	);
}
export function useCalendarEventPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventPaginationQuery, CalendarEventPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventPaginationQuery, CalendarEventPaginationQueryVariables>(
		CalendarEventPaginationDocument,
		options,
	);
}
export type CalendarEventPaginationQueryHookResult = ReturnType<typeof useCalendarEventPaginationQuery>;
export type CalendarEventPaginationLazyQueryHookResult = ReturnType<typeof useCalendarEventPaginationLazyQuery>;
export type CalendarEventPaginationSuspenseQueryHookResult = ReturnType<typeof useCalendarEventPaginationSuspenseQuery>;
export type CalendarEventPaginationQueryResult = Apollo.QueryResult<
	CalendarEventPaginationQuery,
	CalendarEventPaginationQueryVariables
>;
export const CalendarEventSelectDocument = gql`
	query calendarEventSelect($filters: [CalendarEventFilterInput!], $order: CalendarEventOrder) {
		calendarEventConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...CalendarEventName
				}
			}
		}
	}
	${CalendarEventNameFragmentDoc}
`;

/**
 * __useCalendarEventSelectQuery__
 *
 * To run a query within a React component, call `useCalendarEventSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventSelectQuery, CalendarEventSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventSelectQuery, CalendarEventSelectQueryVariables>(
		CalendarEventSelectDocument,
		options,
	);
}
export function useCalendarEventSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventSelectQuery, CalendarEventSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventSelectQuery, CalendarEventSelectQueryVariables>(
		CalendarEventSelectDocument,
		options,
	);
}
export function useCalendarEventSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventSelectQuery, CalendarEventSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventSelectQuery, CalendarEventSelectQueryVariables>(
		CalendarEventSelectDocument,
		options,
	);
}
export type CalendarEventSelectQueryHookResult = ReturnType<typeof useCalendarEventSelectQuery>;
export type CalendarEventSelectLazyQueryHookResult = ReturnType<typeof useCalendarEventSelectLazyQuery>;
export type CalendarEventSelectSuspenseQueryHookResult = ReturnType<typeof useCalendarEventSelectSuspenseQuery>;
export type CalendarEventSelectQueryResult = Apollo.QueryResult<
	CalendarEventSelectQuery,
	CalendarEventSelectQueryVariables
>;
export const CalendarEventStatisticsDocument = gql`
	query calendarEventStatistics($filters: [CalendarEventFilterInput!]) {
		calendarEventStatistics(filters: $filters) {
			count
			responsesAttending
			responsesMaybeAttending
			responsesNotAttending
		}
	}
`;

/**
 * __useCalendarEventStatisticsQuery__
 *
 * To run a query within a React component, call `useCalendarEventStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventStatisticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCalendarEventStatisticsQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventStatisticsQuery, CalendarEventStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventStatisticsQuery, CalendarEventStatisticsQueryVariables>(
		CalendarEventStatisticsDocument,
		options,
	);
}
export function useCalendarEventStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventStatisticsQuery, CalendarEventStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventStatisticsQuery, CalendarEventStatisticsQueryVariables>(
		CalendarEventStatisticsDocument,
		options,
	);
}
export function useCalendarEventStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventStatisticsQuery, CalendarEventStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventStatisticsQuery, CalendarEventStatisticsQueryVariables>(
		CalendarEventStatisticsDocument,
		options,
	);
}
export type CalendarEventStatisticsQueryHookResult = ReturnType<typeof useCalendarEventStatisticsQuery>;
export type CalendarEventStatisticsLazyQueryHookResult = ReturnType<typeof useCalendarEventStatisticsLazyQuery>;
export type CalendarEventStatisticsSuspenseQueryHookResult = ReturnType<typeof useCalendarEventStatisticsSuspenseQuery>;
export type CalendarEventStatisticsQueryResult = Apollo.QueryResult<
	CalendarEventStatisticsQuery,
	CalendarEventStatisticsQueryVariables
>;
export const CalendarEventListDocument = gql`
	query calendarEventList($filters: [CalendarEventFilterInput!], $pagination: Pagination, $order: CalendarEventOrder) {
		calendarEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					imageURL
					imageContentType
					isAllDay
					startTime
					endTime
					startDate
					endDate
					allowsResponses
					calendarEventResponses(filters: { author: { isCurrentEQ: true } }) {
						id
						response
					}
				}
			}
		}
	}
`;

/**
 * __useCalendarEventListQuery__
 *
 * To run a query within a React component, call `useCalendarEventListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventListQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventListQuery, CalendarEventListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventListQuery, CalendarEventListQueryVariables>(CalendarEventListDocument, options);
}
export function useCalendarEventListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventListQuery, CalendarEventListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventListQuery, CalendarEventListQueryVariables>(
		CalendarEventListDocument,
		options,
	);
}
export function useCalendarEventListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventListQuery, CalendarEventListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventListQuery, CalendarEventListQueryVariables>(
		CalendarEventListDocument,
		options,
	);
}
export type CalendarEventListQueryHookResult = ReturnType<typeof useCalendarEventListQuery>;
export type CalendarEventListLazyQueryHookResult = ReturnType<typeof useCalendarEventListLazyQuery>;
export type CalendarEventListSuspenseQueryHookResult = ReturnType<typeof useCalendarEventListSuspenseQuery>;
export type CalendarEventListQueryResult = Apollo.QueryResult<CalendarEventListQuery, CalendarEventListQueryVariables>;
export const CalendarEventUpdateDocument = gql`
	mutation calendarEventUpdate($id: ID!, $input: CalendarEventUpdateInput!) {
		updateCalendarEvent(id: $id, input: $input) {
			...CalendarEventDetail
		}
	}
	${CalendarEventDetailFragmentDoc}
`;
export type CalendarEventUpdateMutationFn = Apollo.MutationFunction<
	CalendarEventUpdateMutation,
	CalendarEventUpdateMutationVariables
>;

/**
 * __useCalendarEventUpdateMutation__
 *
 * To run a mutation, you first call `useCalendarEventUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventUpdateMutation, { data, loading, error }] = useCalendarEventUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarEventUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<CalendarEventUpdateMutation, CalendarEventUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CalendarEventUpdateMutation, CalendarEventUpdateMutationVariables>(
		CalendarEventUpdateDocument,
		options,
	);
}
export type CalendarEventUpdateMutationHookResult = ReturnType<typeof useCalendarEventUpdateMutation>;
export type CalendarEventUpdateMutationResult = Apollo.MutationResult<CalendarEventUpdateMutation>;
export type CalendarEventUpdateMutationOptions = Apollo.BaseMutationOptions<
	CalendarEventUpdateMutation,
	CalendarEventUpdateMutationVariables
>;
export const CalendarEventUserListDocument = gql`
	query calendarEventUserList($calendarEventID: ID!, $pagination: Pagination, $order: UserOrder) {
		userConnection(
			filters: {
				or: [
					{
						sharedSharingRecords: { calendarEventIDEQ: $calendarEventID }
						not: {
							authoredCalendarEventResponses: [{ calendarEventIDEQ: $calendarEventID, responseEQ: not_attending }]
						}
					}
					{ authoredCalendarEventResponses: [{ calendarEventIDEQ: $calendarEventID, responseNEQ: not_attending }] }
				]
			}
			pagination: $pagination
			order: $order
		) {
			totalCount
			pageInfo {
				hasNextPage
				endCursor
			}
			edges {
				node {
					id
					...UserNameAndImage
					authoredCalendarEventResponses(filters: { calendarEventIDEQ: $calendarEventID }) {
						id
						response
					}
				}
			}
		}
	}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __useCalendarEventUserListQuery__
 *
 * To run a query within a React component, call `useCalendarEventUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventUserListQuery({
 *   variables: {
 *      calendarEventID: // value for 'calendarEventID'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventUserListQuery(
	baseOptions: Apollo.QueryHookOptions<CalendarEventUserListQuery, CalendarEventUserListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventUserListQuery, CalendarEventUserListQueryVariables>(
		CalendarEventUserListDocument,
		options,
	);
}
export function useCalendarEventUserListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventUserListQuery, CalendarEventUserListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventUserListQuery, CalendarEventUserListQueryVariables>(
		CalendarEventUserListDocument,
		options,
	);
}
export function useCalendarEventUserListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventUserListQuery, CalendarEventUserListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventUserListQuery, CalendarEventUserListQueryVariables>(
		CalendarEventUserListDocument,
		options,
	);
}
export type CalendarEventUserListQueryHookResult = ReturnType<typeof useCalendarEventUserListQuery>;
export type CalendarEventUserListLazyQueryHookResult = ReturnType<typeof useCalendarEventUserListLazyQuery>;
export type CalendarEventUserListSuspenseQueryHookResult = ReturnType<typeof useCalendarEventUserListSuspenseQuery>;
export type CalendarEventUserListQueryResult = Apollo.QueryResult<
	CalendarEventUserListQuery,
	CalendarEventUserListQueryVariables
>;
export const CalendarEventResponseCountDocument = gql`
	query calendarEventResponseCount(
		$filters: [CalendarEventResponseFilterInput!]
		$pagination: Pagination
		$order: CalendarEventResponseOrder
	) {
		calendarEventResponseConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useCalendarEventResponseCountQuery__
 *
 * To run a query within a React component, call `useCalendarEventResponseCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponseCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventResponseCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventResponseCountQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventResponseCountQuery, CalendarEventResponseCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventResponseCountQuery, CalendarEventResponseCountQueryVariables>(
		CalendarEventResponseCountDocument,
		options,
	);
}
export function useCalendarEventResponseCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventResponseCountQuery, CalendarEventResponseCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventResponseCountQuery, CalendarEventResponseCountQueryVariables>(
		CalendarEventResponseCountDocument,
		options,
	);
}
export function useCalendarEventResponseCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventResponseCountQuery,
		CalendarEventResponseCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventResponseCountQuery, CalendarEventResponseCountQueryVariables>(
		CalendarEventResponseCountDocument,
		options,
	);
}
export type CalendarEventResponseCountQueryHookResult = ReturnType<typeof useCalendarEventResponseCountQuery>;
export type CalendarEventResponseCountLazyQueryHookResult = ReturnType<typeof useCalendarEventResponseCountLazyQuery>;
export type CalendarEventResponseCountSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventResponseCountSuspenseQuery
>;
export type CalendarEventResponseCountQueryResult = Apollo.QueryResult<
	CalendarEventResponseCountQuery,
	CalendarEventResponseCountQueryVariables
>;
export const CalendarEventResponseCreateDocument = gql`
	mutation calendarEventResponseCreate($input: CalendarEventResponseCreateInput!) {
		createCalendarEventResponse(input: $input) {
			...CalendarEventResponseDetail
		}
	}
	${CalendarEventResponseDetailFragmentDoc}
`;
export type CalendarEventResponseCreateMutationFn = Apollo.MutationFunction<
	CalendarEventResponseCreateMutation,
	CalendarEventResponseCreateMutationVariables
>;

/**
 * __useCalendarEventResponseCreateMutation__
 *
 * To run a mutation, you first call `useCalendarEventResponseCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponseCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventResponseCreateMutation, { data, loading, error }] = useCalendarEventResponseCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarEventResponseCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CalendarEventResponseCreateMutation,
		CalendarEventResponseCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CalendarEventResponseCreateMutation, CalendarEventResponseCreateMutationVariables>(
		CalendarEventResponseCreateDocument,
		options,
	);
}
export type CalendarEventResponseCreateMutationHookResult = ReturnType<typeof useCalendarEventResponseCreateMutation>;
export type CalendarEventResponseCreateMutationResult = Apollo.MutationResult<CalendarEventResponseCreateMutation>;
export type CalendarEventResponseCreateMutationOptions = Apollo.BaseMutationOptions<
	CalendarEventResponseCreateMutation,
	CalendarEventResponseCreateMutationVariables
>;
export const CalendarEventResponseDeleteDocument = gql`
	mutation calendarEventResponseDelete($id: ID!) {
		deleteCalendarEventResponse(id: $id)
	}
`;
export type CalendarEventResponseDeleteMutationFn = Apollo.MutationFunction<
	CalendarEventResponseDeleteMutation,
	CalendarEventResponseDeleteMutationVariables
>;

/**
 * __useCalendarEventResponseDeleteMutation__
 *
 * To run a mutation, you first call `useCalendarEventResponseDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponseDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventResponseDeleteMutation, { data, loading, error }] = useCalendarEventResponseDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalendarEventResponseDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CalendarEventResponseDeleteMutation,
		CalendarEventResponseDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CalendarEventResponseDeleteMutation, CalendarEventResponseDeleteMutationVariables>(
		CalendarEventResponseDeleteDocument,
		options,
	);
}
export type CalendarEventResponseDeleteMutationHookResult = ReturnType<typeof useCalendarEventResponseDeleteMutation>;
export type CalendarEventResponseDeleteMutationResult = Apollo.MutationResult<CalendarEventResponseDeleteMutation>;
export type CalendarEventResponseDeleteMutationOptions = Apollo.BaseMutationOptions<
	CalendarEventResponseDeleteMutation,
	CalendarEventResponseDeleteMutationVariables
>;
export const CalendarEventResponseDetailDocument = gql`
	query calendarEventResponseDetail($id: ID!) {
		calendarEventResponse(id: $id) {
			...CalendarEventResponseDetail
		}
	}
	${CalendarEventResponseDetailFragmentDoc}
`;

/**
 * __useCalendarEventResponseDetailQuery__
 *
 * To run a query within a React component, call `useCalendarEventResponseDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponseDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventResponseDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalendarEventResponseDetailQuery(
	baseOptions: Apollo.QueryHookOptions<CalendarEventResponseDetailQuery, CalendarEventResponseDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventResponseDetailQuery, CalendarEventResponseDetailQueryVariables>(
		CalendarEventResponseDetailDocument,
		options,
	);
}
export function useCalendarEventResponseDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CalendarEventResponseDetailQuery,
		CalendarEventResponseDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventResponseDetailQuery, CalendarEventResponseDetailQueryVariables>(
		CalendarEventResponseDetailDocument,
		options,
	);
}
export function useCalendarEventResponseDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventResponseDetailQuery,
		CalendarEventResponseDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventResponseDetailQuery, CalendarEventResponseDetailQueryVariables>(
		CalendarEventResponseDetailDocument,
		options,
	);
}
export type CalendarEventResponseDetailQueryHookResult = ReturnType<typeof useCalendarEventResponseDetailQuery>;
export type CalendarEventResponseDetailLazyQueryHookResult = ReturnType<typeof useCalendarEventResponseDetailLazyQuery>;
export type CalendarEventResponseDetailSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventResponseDetailSuspenseQuery
>;
export type CalendarEventResponseDetailQueryResult = Apollo.QueryResult<
	CalendarEventResponseDetailQuery,
	CalendarEventResponseDetailQueryVariables
>;
export const CalendarEventResponseIndexDocument = gql`
	query calendarEventResponseIndex(
		$filters: [CalendarEventResponseFilterInput!]
		$pagination: Pagination
		$order: CalendarEventResponseOrder
	) {
		calendarEventResponseConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					response
				}
			}
		}
	}
`;

/**
 * __useCalendarEventResponseIndexQuery__
 *
 * To run a query within a React component, call `useCalendarEventResponseIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponseIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventResponseIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventResponseIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventResponseIndexQuery, CalendarEventResponseIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventResponseIndexQuery, CalendarEventResponseIndexQueryVariables>(
		CalendarEventResponseIndexDocument,
		options,
	);
}
export function useCalendarEventResponseIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventResponseIndexQuery, CalendarEventResponseIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventResponseIndexQuery, CalendarEventResponseIndexQueryVariables>(
		CalendarEventResponseIndexDocument,
		options,
	);
}
export function useCalendarEventResponseIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventResponseIndexQuery,
		CalendarEventResponseIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventResponseIndexQuery, CalendarEventResponseIndexQueryVariables>(
		CalendarEventResponseIndexDocument,
		options,
	);
}
export type CalendarEventResponseIndexQueryHookResult = ReturnType<typeof useCalendarEventResponseIndexQuery>;
export type CalendarEventResponseIndexLazyQueryHookResult = ReturnType<typeof useCalendarEventResponseIndexLazyQuery>;
export type CalendarEventResponseIndexSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventResponseIndexSuspenseQuery
>;
export type CalendarEventResponseIndexQueryResult = Apollo.QueryResult<
	CalendarEventResponseIndexQuery,
	CalendarEventResponseIndexQueryVariables
>;
export const CalendarEventResponseNameDocument = gql`
	query calendarEventResponseName($id: ID!) {
		calendarEventResponse(id: $id) {
			id
			...CalendarEventResponseName
		}
	}
	${CalendarEventResponseNameFragmentDoc}
`;

/**
 * __useCalendarEventResponseNameQuery__
 *
 * To run a query within a React component, call `useCalendarEventResponseNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponseNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventResponseNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalendarEventResponseNameQuery(
	baseOptions: Apollo.QueryHookOptions<CalendarEventResponseNameQuery, CalendarEventResponseNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventResponseNameQuery, CalendarEventResponseNameQueryVariables>(
		CalendarEventResponseNameDocument,
		options,
	);
}
export function useCalendarEventResponseNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventResponseNameQuery, CalendarEventResponseNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventResponseNameQuery, CalendarEventResponseNameQueryVariables>(
		CalendarEventResponseNameDocument,
		options,
	);
}
export function useCalendarEventResponseNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventResponseNameQuery,
		CalendarEventResponseNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventResponseNameQuery, CalendarEventResponseNameQueryVariables>(
		CalendarEventResponseNameDocument,
		options,
	);
}
export type CalendarEventResponseNameQueryHookResult = ReturnType<typeof useCalendarEventResponseNameQuery>;
export type CalendarEventResponseNameLazyQueryHookResult = ReturnType<typeof useCalendarEventResponseNameLazyQuery>;
export type CalendarEventResponseNameSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventResponseNameSuspenseQuery
>;
export type CalendarEventResponseNameQueryResult = Apollo.QueryResult<
	CalendarEventResponseNameQuery,
	CalendarEventResponseNameQueryVariables
>;
export const CalendarEventResponseNamesDocument = gql`
	query calendarEventResponseNames(
		$filters: [CalendarEventResponseFilterInput!]
		$pagination: Pagination
		$order: CalendarEventResponseOrder
	) {
		calendarEventResponseConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...CalendarEventResponseName
				}
			}
		}
	}
	${CalendarEventResponseNameFragmentDoc}
`;

/**
 * __useCalendarEventResponseNamesQuery__
 *
 * To run a query within a React component, call `useCalendarEventResponseNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponseNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventResponseNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventResponseNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventResponseNamesQuery, CalendarEventResponseNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventResponseNamesQuery, CalendarEventResponseNamesQueryVariables>(
		CalendarEventResponseNamesDocument,
		options,
	);
}
export function useCalendarEventResponseNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventResponseNamesQuery, CalendarEventResponseNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventResponseNamesQuery, CalendarEventResponseNamesQueryVariables>(
		CalendarEventResponseNamesDocument,
		options,
	);
}
export function useCalendarEventResponseNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventResponseNamesQuery,
		CalendarEventResponseNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventResponseNamesQuery, CalendarEventResponseNamesQueryVariables>(
		CalendarEventResponseNamesDocument,
		options,
	);
}
export type CalendarEventResponseNamesQueryHookResult = ReturnType<typeof useCalendarEventResponseNamesQuery>;
export type CalendarEventResponseNamesLazyQueryHookResult = ReturnType<typeof useCalendarEventResponseNamesLazyQuery>;
export type CalendarEventResponseNamesSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventResponseNamesSuspenseQuery
>;
export type CalendarEventResponseNamesQueryResult = Apollo.QueryResult<
	CalendarEventResponseNamesQuery,
	CalendarEventResponseNamesQueryVariables
>;
export const CalendarEventResponsePaginationDocument = gql`
	query calendarEventResponsePagination(
		$filters: [CalendarEventResponseFilterInput!]
		$order: CalendarEventResponseOrder
	) {
		calendarEventResponseConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useCalendarEventResponsePaginationQuery__
 *
 * To run a query within a React component, call `useCalendarEventResponsePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponsePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventResponsePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventResponsePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CalendarEventResponsePaginationQuery,
		CalendarEventResponsePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventResponsePaginationQuery, CalendarEventResponsePaginationQueryVariables>(
		CalendarEventResponsePaginationDocument,
		options,
	);
}
export function useCalendarEventResponsePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CalendarEventResponsePaginationQuery,
		CalendarEventResponsePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventResponsePaginationQuery, CalendarEventResponsePaginationQueryVariables>(
		CalendarEventResponsePaginationDocument,
		options,
	);
}
export function useCalendarEventResponsePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventResponsePaginationQuery,
		CalendarEventResponsePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventResponsePaginationQuery, CalendarEventResponsePaginationQueryVariables>(
		CalendarEventResponsePaginationDocument,
		options,
	);
}
export type CalendarEventResponsePaginationQueryHookResult = ReturnType<typeof useCalendarEventResponsePaginationQuery>;
export type CalendarEventResponsePaginationLazyQueryHookResult = ReturnType<
	typeof useCalendarEventResponsePaginationLazyQuery
>;
export type CalendarEventResponsePaginationSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventResponsePaginationSuspenseQuery
>;
export type CalendarEventResponsePaginationQueryResult = Apollo.QueryResult<
	CalendarEventResponsePaginationQuery,
	CalendarEventResponsePaginationQueryVariables
>;
export const CalendarEventResponseSelectDocument = gql`
	query calendarEventResponseSelect($filters: [CalendarEventResponseFilterInput!], $order: CalendarEventResponseOrder) {
		calendarEventResponseConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...CalendarEventResponseName
				}
			}
		}
	}
	${CalendarEventResponseNameFragmentDoc}
`;

/**
 * __useCalendarEventResponseSelectQuery__
 *
 * To run a query within a React component, call `useCalendarEventResponseSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponseSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventResponseSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventResponseSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventResponseSelectQuery, CalendarEventResponseSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventResponseSelectQuery, CalendarEventResponseSelectQueryVariables>(
		CalendarEventResponseSelectDocument,
		options,
	);
}
export function useCalendarEventResponseSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CalendarEventResponseSelectQuery,
		CalendarEventResponseSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventResponseSelectQuery, CalendarEventResponseSelectQueryVariables>(
		CalendarEventResponseSelectDocument,
		options,
	);
}
export function useCalendarEventResponseSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventResponseSelectQuery,
		CalendarEventResponseSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventResponseSelectQuery, CalendarEventResponseSelectQueryVariables>(
		CalendarEventResponseSelectDocument,
		options,
	);
}
export type CalendarEventResponseSelectQueryHookResult = ReturnType<typeof useCalendarEventResponseSelectQuery>;
export type CalendarEventResponseSelectLazyQueryHookResult = ReturnType<typeof useCalendarEventResponseSelectLazyQuery>;
export type CalendarEventResponseSelectSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventResponseSelectSuspenseQuery
>;
export type CalendarEventResponseSelectQueryResult = Apollo.QueryResult<
	CalendarEventResponseSelectQuery,
	CalendarEventResponseSelectQueryVariables
>;
export const CalendarEventResponseUpdateDocument = gql`
	mutation calendarEventResponseUpdate($id: ID!, $input: CalendarEventResponseUpdateInput!) {
		updateCalendarEventResponse(id: $id, input: $input) {
			...CalendarEventResponseDetail
		}
	}
	${CalendarEventResponseDetailFragmentDoc}
`;
export type CalendarEventResponseUpdateMutationFn = Apollo.MutationFunction<
	CalendarEventResponseUpdateMutation,
	CalendarEventResponseUpdateMutationVariables
>;

/**
 * __useCalendarEventResponseUpdateMutation__
 *
 * To run a mutation, you first call `useCalendarEventResponseUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponseUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventResponseUpdateMutation, { data, loading, error }] = useCalendarEventResponseUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarEventResponseUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CalendarEventResponseUpdateMutation,
		CalendarEventResponseUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CalendarEventResponseUpdateMutation, CalendarEventResponseUpdateMutationVariables>(
		CalendarEventResponseUpdateDocument,
		options,
	);
}
export type CalendarEventResponseUpdateMutationHookResult = ReturnType<typeof useCalendarEventResponseUpdateMutation>;
export type CalendarEventResponseUpdateMutationResult = Apollo.MutationResult<CalendarEventResponseUpdateMutation>;
export type CalendarEventResponseUpdateMutationOptions = Apollo.BaseMutationOptions<
	CalendarEventResponseUpdateMutation,
	CalendarEventResponseUpdateMutationVariables
>;
export const CampusCountDocument = gql`
	query campusCount($filters: [CampusFilterInput!], $pagination: Pagination, $order: CampusOrder) {
		campusConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useCampusCountQuery__
 *
 * To run a query within a React component, call `useCampusCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampusCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampusCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCampusCountQuery(
	baseOptions?: Apollo.QueryHookOptions<CampusCountQuery, CampusCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CampusCountQuery, CampusCountQueryVariables>(CampusCountDocument, options);
}
export function useCampusCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CampusCountQuery, CampusCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CampusCountQuery, CampusCountQueryVariables>(CampusCountDocument, options);
}
export function useCampusCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CampusCountQuery, CampusCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CampusCountQuery, CampusCountQueryVariables>(CampusCountDocument, options);
}
export type CampusCountQueryHookResult = ReturnType<typeof useCampusCountQuery>;
export type CampusCountLazyQueryHookResult = ReturnType<typeof useCampusCountLazyQuery>;
export type CampusCountSuspenseQueryHookResult = ReturnType<typeof useCampusCountSuspenseQuery>;
export type CampusCountQueryResult = Apollo.QueryResult<CampusCountQuery, CampusCountQueryVariables>;
export const CampusCreateDocument = gql`
	mutation campusCreate($input: CampusCreateInput!) {
		createCampus(input: $input) {
			...CampusDetail
		}
	}
	${CampusDetailFragmentDoc}
`;
export type CampusCreateMutationFn = Apollo.MutationFunction<CampusCreateMutation, CampusCreateMutationVariables>;

/**
 * __useCampusCreateMutation__
 *
 * To run a mutation, you first call `useCampusCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampusCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campusCreateMutation, { data, loading, error }] = useCampusCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCampusCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<CampusCreateMutation, CampusCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CampusCreateMutation, CampusCreateMutationVariables>(CampusCreateDocument, options);
}
export type CampusCreateMutationHookResult = ReturnType<typeof useCampusCreateMutation>;
export type CampusCreateMutationResult = Apollo.MutationResult<CampusCreateMutation>;
export type CampusCreateMutationOptions = Apollo.BaseMutationOptions<
	CampusCreateMutation,
	CampusCreateMutationVariables
>;
export const CampusDeleteDocument = gql`
	mutation campusDelete($id: ID!) {
		deleteCampus(id: $id)
	}
`;
export type CampusDeleteMutationFn = Apollo.MutationFunction<CampusDeleteMutation, CampusDeleteMutationVariables>;

/**
 * __useCampusDeleteMutation__
 *
 * To run a mutation, you first call `useCampusDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampusDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campusDeleteMutation, { data, loading, error }] = useCampusDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampusDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<CampusDeleteMutation, CampusDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CampusDeleteMutation, CampusDeleteMutationVariables>(CampusDeleteDocument, options);
}
export type CampusDeleteMutationHookResult = ReturnType<typeof useCampusDeleteMutation>;
export type CampusDeleteMutationResult = Apollo.MutationResult<CampusDeleteMutation>;
export type CampusDeleteMutationOptions = Apollo.BaseMutationOptions<
	CampusDeleteMutation,
	CampusDeleteMutationVariables
>;
export const CampusDetailDocument = gql`
	query campusDetail($id: ID!) {
		campus(id: $id) {
			...CampusDetail
		}
	}
	${CampusDetailFragmentDoc}
`;

/**
 * __useCampusDetailQuery__
 *
 * To run a query within a React component, call `useCampusDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampusDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampusDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampusDetailQuery(
	baseOptions: Apollo.QueryHookOptions<CampusDetailQuery, CampusDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CampusDetailQuery, CampusDetailQueryVariables>(CampusDetailDocument, options);
}
export function useCampusDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CampusDetailQuery, CampusDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CampusDetailQuery, CampusDetailQueryVariables>(CampusDetailDocument, options);
}
export function useCampusDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CampusDetailQuery, CampusDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CampusDetailQuery, CampusDetailQueryVariables>(CampusDetailDocument, options);
}
export type CampusDetailQueryHookResult = ReturnType<typeof useCampusDetailQuery>;
export type CampusDetailLazyQueryHookResult = ReturnType<typeof useCampusDetailLazyQuery>;
export type CampusDetailSuspenseQueryHookResult = ReturnType<typeof useCampusDetailSuspenseQuery>;
export type CampusDetailQueryResult = Apollo.QueryResult<CampusDetailQuery, CampusDetailQueryVariables>;
export const CampusIndexDocument = gql`
	query campusIndex($filters: [CampusFilterInput!], $pagination: Pagination, $order: CampusOrder) {
		campusConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					phoneNumber
					addressLine1
					addressLine2
					city
					postalCode
					stateOrProvince
					country {
						id
						...CountryName
					}
					buildings {
						id
					}
				}
			}
		}
	}
	${CountryNameFragmentDoc}
`;

/**
 * __useCampusIndexQuery__
 *
 * To run a query within a React component, call `useCampusIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampusIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampusIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCampusIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<CampusIndexQuery, CampusIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CampusIndexQuery, CampusIndexQueryVariables>(CampusIndexDocument, options);
}
export function useCampusIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CampusIndexQuery, CampusIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CampusIndexQuery, CampusIndexQueryVariables>(CampusIndexDocument, options);
}
export function useCampusIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CampusIndexQuery, CampusIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CampusIndexQuery, CampusIndexQueryVariables>(CampusIndexDocument, options);
}
export type CampusIndexQueryHookResult = ReturnType<typeof useCampusIndexQuery>;
export type CampusIndexLazyQueryHookResult = ReturnType<typeof useCampusIndexLazyQuery>;
export type CampusIndexSuspenseQueryHookResult = ReturnType<typeof useCampusIndexSuspenseQuery>;
export type CampusIndexQueryResult = Apollo.QueryResult<CampusIndexQuery, CampusIndexQueryVariables>;
export const CampusNameDocument = gql`
	query campusName($id: ID!) {
		campus(id: $id) {
			id
			...CampusName
		}
	}
	${CampusNameFragmentDoc}
`;

/**
 * __useCampusNameQuery__
 *
 * To run a query within a React component, call `useCampusNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampusNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampusNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampusNameQuery(baseOptions: Apollo.QueryHookOptions<CampusNameQuery, CampusNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CampusNameQuery, CampusNameQueryVariables>(CampusNameDocument, options);
}
export function useCampusNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CampusNameQuery, CampusNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CampusNameQuery, CampusNameQueryVariables>(CampusNameDocument, options);
}
export function useCampusNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CampusNameQuery, CampusNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CampusNameQuery, CampusNameQueryVariables>(CampusNameDocument, options);
}
export type CampusNameQueryHookResult = ReturnType<typeof useCampusNameQuery>;
export type CampusNameLazyQueryHookResult = ReturnType<typeof useCampusNameLazyQuery>;
export type CampusNameSuspenseQueryHookResult = ReturnType<typeof useCampusNameSuspenseQuery>;
export type CampusNameQueryResult = Apollo.QueryResult<CampusNameQuery, CampusNameQueryVariables>;
export const CampusNamesDocument = gql`
	query campusNames($filters: [CampusFilterInput!], $pagination: Pagination, $order: CampusOrder) {
		campusConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...CampusName
				}
			}
		}
	}
	${CampusNameFragmentDoc}
`;

/**
 * __useCampusNamesQuery__
 *
 * To run a query within a React component, call `useCampusNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampusNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampusNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCampusNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<CampusNamesQuery, CampusNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CampusNamesQuery, CampusNamesQueryVariables>(CampusNamesDocument, options);
}
export function useCampusNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CampusNamesQuery, CampusNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CampusNamesQuery, CampusNamesQueryVariables>(CampusNamesDocument, options);
}
export function useCampusNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CampusNamesQuery, CampusNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CampusNamesQuery, CampusNamesQueryVariables>(CampusNamesDocument, options);
}
export type CampusNamesQueryHookResult = ReturnType<typeof useCampusNamesQuery>;
export type CampusNamesLazyQueryHookResult = ReturnType<typeof useCampusNamesLazyQuery>;
export type CampusNamesSuspenseQueryHookResult = ReturnType<typeof useCampusNamesSuspenseQuery>;
export type CampusNamesQueryResult = Apollo.QueryResult<CampusNamesQuery, CampusNamesQueryVariables>;
export const CampusPaginationDocument = gql`
	query campusPagination($filters: [CampusFilterInput!], $order: CampusOrder) {
		campusConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useCampusPaginationQuery__
 *
 * To run a query within a React component, call `useCampusPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampusPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampusPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCampusPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<CampusPaginationQuery, CampusPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CampusPaginationQuery, CampusPaginationQueryVariables>(CampusPaginationDocument, options);
}
export function useCampusPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CampusPaginationQuery, CampusPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CampusPaginationQuery, CampusPaginationQueryVariables>(CampusPaginationDocument, options);
}
export function useCampusPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CampusPaginationQuery, CampusPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CampusPaginationQuery, CampusPaginationQueryVariables>(
		CampusPaginationDocument,
		options,
	);
}
export type CampusPaginationQueryHookResult = ReturnType<typeof useCampusPaginationQuery>;
export type CampusPaginationLazyQueryHookResult = ReturnType<typeof useCampusPaginationLazyQuery>;
export type CampusPaginationSuspenseQueryHookResult = ReturnType<typeof useCampusPaginationSuspenseQuery>;
export type CampusPaginationQueryResult = Apollo.QueryResult<CampusPaginationQuery, CampusPaginationQueryVariables>;
export const CampusSelectDocument = gql`
	query campusSelect($filters: [CampusFilterInput!], $order: CampusOrder) {
		campusConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...CampusName
				}
			}
		}
	}
	${CampusNameFragmentDoc}
`;

/**
 * __useCampusSelectQuery__
 *
 * To run a query within a React component, call `useCampusSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampusSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampusSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCampusSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<CampusSelectQuery, CampusSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CampusSelectQuery, CampusSelectQueryVariables>(CampusSelectDocument, options);
}
export function useCampusSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CampusSelectQuery, CampusSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CampusSelectQuery, CampusSelectQueryVariables>(CampusSelectDocument, options);
}
export function useCampusSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CampusSelectQuery, CampusSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CampusSelectQuery, CampusSelectQueryVariables>(CampusSelectDocument, options);
}
export type CampusSelectQueryHookResult = ReturnType<typeof useCampusSelectQuery>;
export type CampusSelectLazyQueryHookResult = ReturnType<typeof useCampusSelectLazyQuery>;
export type CampusSelectSuspenseQueryHookResult = ReturnType<typeof useCampusSelectSuspenseQuery>;
export type CampusSelectQueryResult = Apollo.QueryResult<CampusSelectQuery, CampusSelectQueryVariables>;
export const CampusUpdateDocument = gql`
	mutation campusUpdate($id: ID!, $input: CampusUpdateInput!) {
		updateCampus(id: $id, input: $input) {
			...CampusDetail
		}
	}
	${CampusDetailFragmentDoc}
`;
export type CampusUpdateMutationFn = Apollo.MutationFunction<CampusUpdateMutation, CampusUpdateMutationVariables>;

/**
 * __useCampusUpdateMutation__
 *
 * To run a mutation, you first call `useCampusUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampusUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campusUpdateMutation, { data, loading, error }] = useCampusUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCampusUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<CampusUpdateMutation, CampusUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CampusUpdateMutation, CampusUpdateMutationVariables>(CampusUpdateDocument, options);
}
export type CampusUpdateMutationHookResult = ReturnType<typeof useCampusUpdateMutation>;
export type CampusUpdateMutationResult = Apollo.MutationResult<CampusUpdateMutation>;
export type CampusUpdateMutationOptions = Apollo.BaseMutationOptions<
	CampusUpdateMutation,
	CampusUpdateMutationVariables
>;
export const ClassYearCountDocument = gql`
	query classYearCount($filters: [ClassYearFilterInput!], $pagination: Pagination, $order: ClassYearOrder) {
		classYearConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useClassYearCountQuery__
 *
 * To run a query within a React component, call `useClassYearCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassYearCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassYearCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useClassYearCountQuery(
	baseOptions?: Apollo.QueryHookOptions<ClassYearCountQuery, ClassYearCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ClassYearCountQuery, ClassYearCountQueryVariables>(ClassYearCountDocument, options);
}
export function useClassYearCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ClassYearCountQuery, ClassYearCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ClassYearCountQuery, ClassYearCountQueryVariables>(ClassYearCountDocument, options);
}
export function useClassYearCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ClassYearCountQuery, ClassYearCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ClassYearCountQuery, ClassYearCountQueryVariables>(ClassYearCountDocument, options);
}
export type ClassYearCountQueryHookResult = ReturnType<typeof useClassYearCountQuery>;
export type ClassYearCountLazyQueryHookResult = ReturnType<typeof useClassYearCountLazyQuery>;
export type ClassYearCountSuspenseQueryHookResult = ReturnType<typeof useClassYearCountSuspenseQuery>;
export type ClassYearCountQueryResult = Apollo.QueryResult<ClassYearCountQuery, ClassYearCountQueryVariables>;
export const ClassYearCreateDocument = gql`
	mutation classYearCreate($input: ClassYearCreateInput!) {
		createClassYear(input: $input) {
			...ClassYearDetail
		}
	}
	${ClassYearDetailFragmentDoc}
`;
export type ClassYearCreateMutationFn = Apollo.MutationFunction<
	ClassYearCreateMutation,
	ClassYearCreateMutationVariables
>;

/**
 * __useClassYearCreateMutation__
 *
 * To run a mutation, you first call `useClassYearCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClassYearCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [classYearCreateMutation, { data, loading, error }] = useClassYearCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClassYearCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<ClassYearCreateMutation, ClassYearCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ClassYearCreateMutation, ClassYearCreateMutationVariables>(
		ClassYearCreateDocument,
		options,
	);
}
export type ClassYearCreateMutationHookResult = ReturnType<typeof useClassYearCreateMutation>;
export type ClassYearCreateMutationResult = Apollo.MutationResult<ClassYearCreateMutation>;
export type ClassYearCreateMutationOptions = Apollo.BaseMutationOptions<
	ClassYearCreateMutation,
	ClassYearCreateMutationVariables
>;
export const ClassYearDeleteDocument = gql`
	mutation classYearDelete($id: ID!) {
		deleteClassYear(id: $id)
	}
`;
export type ClassYearDeleteMutationFn = Apollo.MutationFunction<
	ClassYearDeleteMutation,
	ClassYearDeleteMutationVariables
>;

/**
 * __useClassYearDeleteMutation__
 *
 * To run a mutation, you first call `useClassYearDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClassYearDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [classYearDeleteMutation, { data, loading, error }] = useClassYearDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClassYearDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<ClassYearDeleteMutation, ClassYearDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ClassYearDeleteMutation, ClassYearDeleteMutationVariables>(
		ClassYearDeleteDocument,
		options,
	);
}
export type ClassYearDeleteMutationHookResult = ReturnType<typeof useClassYearDeleteMutation>;
export type ClassYearDeleteMutationResult = Apollo.MutationResult<ClassYearDeleteMutation>;
export type ClassYearDeleteMutationOptions = Apollo.BaseMutationOptions<
	ClassYearDeleteMutation,
	ClassYearDeleteMutationVariables
>;
export const ClassYearDetailDocument = gql`
	query classYearDetail($id: ID!) {
		classYear(id: $id) {
			...ClassYearDetail
		}
	}
	${ClassYearDetailFragmentDoc}
`;

/**
 * __useClassYearDetailQuery__
 *
 * To run a query within a React component, call `useClassYearDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassYearDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassYearDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClassYearDetailQuery(
	baseOptions: Apollo.QueryHookOptions<ClassYearDetailQuery, ClassYearDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ClassYearDetailQuery, ClassYearDetailQueryVariables>(ClassYearDetailDocument, options);
}
export function useClassYearDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ClassYearDetailQuery, ClassYearDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ClassYearDetailQuery, ClassYearDetailQueryVariables>(ClassYearDetailDocument, options);
}
export function useClassYearDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ClassYearDetailQuery, ClassYearDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ClassYearDetailQuery, ClassYearDetailQueryVariables>(ClassYearDetailDocument, options);
}
export type ClassYearDetailQueryHookResult = ReturnType<typeof useClassYearDetailQuery>;
export type ClassYearDetailLazyQueryHookResult = ReturnType<typeof useClassYearDetailLazyQuery>;
export type ClassYearDetailSuspenseQueryHookResult = ReturnType<typeof useClassYearDetailSuspenseQuery>;
export type ClassYearDetailQueryResult = Apollo.QueryResult<ClassYearDetailQuery, ClassYearDetailQueryVariables>;
export const ClassYearIndexDocument = gql`
	query classYearIndex($filters: [ClassYearFilterInput!], $pagination: Pagination, $order: ClassYearOrder) {
		classYearConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					yearsFromGraduation
					graduationYear
				}
			}
		}
	}
`;

/**
 * __useClassYearIndexQuery__
 *
 * To run a query within a React component, call `useClassYearIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassYearIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassYearIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useClassYearIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<ClassYearIndexQuery, ClassYearIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ClassYearIndexQuery, ClassYearIndexQueryVariables>(ClassYearIndexDocument, options);
}
export function useClassYearIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ClassYearIndexQuery, ClassYearIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ClassYearIndexQuery, ClassYearIndexQueryVariables>(ClassYearIndexDocument, options);
}
export function useClassYearIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ClassYearIndexQuery, ClassYearIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ClassYearIndexQuery, ClassYearIndexQueryVariables>(ClassYearIndexDocument, options);
}
export type ClassYearIndexQueryHookResult = ReturnType<typeof useClassYearIndexQuery>;
export type ClassYearIndexLazyQueryHookResult = ReturnType<typeof useClassYearIndexLazyQuery>;
export type ClassYearIndexSuspenseQueryHookResult = ReturnType<typeof useClassYearIndexSuspenseQuery>;
export type ClassYearIndexQueryResult = Apollo.QueryResult<ClassYearIndexQuery, ClassYearIndexQueryVariables>;
export const ClassYearLookupDocument = gql`
	query classYearLookup($filters: [ClassYearFilterInput!], $pagination: Pagination, $order: ClassYearOrder) {
		classYearConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					yearsFromGraduation
					graduationYear
				}
			}
		}
	}
`;

/**
 * __useClassYearLookupQuery__
 *
 * To run a query within a React component, call `useClassYearLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassYearLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassYearLookupQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useClassYearLookupQuery(
	baseOptions?: Apollo.QueryHookOptions<ClassYearLookupQuery, ClassYearLookupQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ClassYearLookupQuery, ClassYearLookupQueryVariables>(ClassYearLookupDocument, options);
}
export function useClassYearLookupLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ClassYearLookupQuery, ClassYearLookupQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ClassYearLookupQuery, ClassYearLookupQueryVariables>(ClassYearLookupDocument, options);
}
export function useClassYearLookupSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ClassYearLookupQuery, ClassYearLookupQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ClassYearLookupQuery, ClassYearLookupQueryVariables>(ClassYearLookupDocument, options);
}
export type ClassYearLookupQueryHookResult = ReturnType<typeof useClassYearLookupQuery>;
export type ClassYearLookupLazyQueryHookResult = ReturnType<typeof useClassYearLookupLazyQuery>;
export type ClassYearLookupSuspenseQueryHookResult = ReturnType<typeof useClassYearLookupSuspenseQuery>;
export type ClassYearLookupQueryResult = Apollo.QueryResult<ClassYearLookupQuery, ClassYearLookupQueryVariables>;
export const ClassYearNameDocument = gql`
	query classYearName($id: ID!) {
		classYear(id: $id) {
			id
			...ClassYearName
		}
	}
	${ClassYearNameFragmentDoc}
`;

/**
 * __useClassYearNameQuery__
 *
 * To run a query within a React component, call `useClassYearNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassYearNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassYearNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClassYearNameQuery(
	baseOptions: Apollo.QueryHookOptions<ClassYearNameQuery, ClassYearNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ClassYearNameQuery, ClassYearNameQueryVariables>(ClassYearNameDocument, options);
}
export function useClassYearNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ClassYearNameQuery, ClassYearNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ClassYearNameQuery, ClassYearNameQueryVariables>(ClassYearNameDocument, options);
}
export function useClassYearNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ClassYearNameQuery, ClassYearNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ClassYearNameQuery, ClassYearNameQueryVariables>(ClassYearNameDocument, options);
}
export type ClassYearNameQueryHookResult = ReturnType<typeof useClassYearNameQuery>;
export type ClassYearNameLazyQueryHookResult = ReturnType<typeof useClassYearNameLazyQuery>;
export type ClassYearNameSuspenseQueryHookResult = ReturnType<typeof useClassYearNameSuspenseQuery>;
export type ClassYearNameQueryResult = Apollo.QueryResult<ClassYearNameQuery, ClassYearNameQueryVariables>;
export const ClassYearNamesDocument = gql`
	query classYearNames($filters: [ClassYearFilterInput!], $pagination: Pagination, $order: ClassYearOrder) {
		classYearConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...ClassYearName
				}
			}
		}
	}
	${ClassYearNameFragmentDoc}
`;

/**
 * __useClassYearNamesQuery__
 *
 * To run a query within a React component, call `useClassYearNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassYearNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassYearNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useClassYearNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<ClassYearNamesQuery, ClassYearNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ClassYearNamesQuery, ClassYearNamesQueryVariables>(ClassYearNamesDocument, options);
}
export function useClassYearNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ClassYearNamesQuery, ClassYearNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ClassYearNamesQuery, ClassYearNamesQueryVariables>(ClassYearNamesDocument, options);
}
export function useClassYearNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ClassYearNamesQuery, ClassYearNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ClassYearNamesQuery, ClassYearNamesQueryVariables>(ClassYearNamesDocument, options);
}
export type ClassYearNamesQueryHookResult = ReturnType<typeof useClassYearNamesQuery>;
export type ClassYearNamesLazyQueryHookResult = ReturnType<typeof useClassYearNamesLazyQuery>;
export type ClassYearNamesSuspenseQueryHookResult = ReturnType<typeof useClassYearNamesSuspenseQuery>;
export type ClassYearNamesQueryResult = Apollo.QueryResult<ClassYearNamesQuery, ClassYearNamesQueryVariables>;
export const ClassYearPaginationDocument = gql`
	query classYearPagination($filters: [ClassYearFilterInput!], $order: ClassYearOrder) {
		classYearConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useClassYearPaginationQuery__
 *
 * To run a query within a React component, call `useClassYearPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassYearPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassYearPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useClassYearPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<ClassYearPaginationQuery, ClassYearPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ClassYearPaginationQuery, ClassYearPaginationQueryVariables>(
		ClassYearPaginationDocument,
		options,
	);
}
export function useClassYearPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ClassYearPaginationQuery, ClassYearPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ClassYearPaginationQuery, ClassYearPaginationQueryVariables>(
		ClassYearPaginationDocument,
		options,
	);
}
export function useClassYearPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ClassYearPaginationQuery, ClassYearPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ClassYearPaginationQuery, ClassYearPaginationQueryVariables>(
		ClassYearPaginationDocument,
		options,
	);
}
export type ClassYearPaginationQueryHookResult = ReturnType<typeof useClassYearPaginationQuery>;
export type ClassYearPaginationLazyQueryHookResult = ReturnType<typeof useClassYearPaginationLazyQuery>;
export type ClassYearPaginationSuspenseQueryHookResult = ReturnType<typeof useClassYearPaginationSuspenseQuery>;
export type ClassYearPaginationQueryResult = Apollo.QueryResult<
	ClassYearPaginationQuery,
	ClassYearPaginationQueryVariables
>;
export const ClassYearSelectDocument = gql`
	query classYearSelect($filters: [ClassYearFilterInput!], $order: ClassYearOrder) {
		classYearConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...ClassYearName
				}
			}
		}
	}
	${ClassYearNameFragmentDoc}
`;

/**
 * __useClassYearSelectQuery__
 *
 * To run a query within a React component, call `useClassYearSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassYearSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassYearSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useClassYearSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<ClassYearSelectQuery, ClassYearSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ClassYearSelectQuery, ClassYearSelectQueryVariables>(ClassYearSelectDocument, options);
}
export function useClassYearSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ClassYearSelectQuery, ClassYearSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ClassYearSelectQuery, ClassYearSelectQueryVariables>(ClassYearSelectDocument, options);
}
export function useClassYearSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ClassYearSelectQuery, ClassYearSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ClassYearSelectQuery, ClassYearSelectQueryVariables>(ClassYearSelectDocument, options);
}
export type ClassYearSelectQueryHookResult = ReturnType<typeof useClassYearSelectQuery>;
export type ClassYearSelectLazyQueryHookResult = ReturnType<typeof useClassYearSelectLazyQuery>;
export type ClassYearSelectSuspenseQueryHookResult = ReturnType<typeof useClassYearSelectSuspenseQuery>;
export type ClassYearSelectQueryResult = Apollo.QueryResult<ClassYearSelectQuery, ClassYearSelectQueryVariables>;
export const ClassYearUpdateDocument = gql`
	mutation classYearUpdate($id: ID!, $input: ClassYearUpdateInput!) {
		updateClassYear(id: $id, input: $input) {
			...ClassYearDetail
		}
	}
	${ClassYearDetailFragmentDoc}
`;
export type ClassYearUpdateMutationFn = Apollo.MutationFunction<
	ClassYearUpdateMutation,
	ClassYearUpdateMutationVariables
>;

/**
 * __useClassYearUpdateMutation__
 *
 * To run a mutation, you first call `useClassYearUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClassYearUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [classYearUpdateMutation, { data, loading, error }] = useClassYearUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClassYearUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<ClassYearUpdateMutation, ClassYearUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ClassYearUpdateMutation, ClassYearUpdateMutationVariables>(
		ClassYearUpdateDocument,
		options,
	);
}
export type ClassYearUpdateMutationHookResult = ReturnType<typeof useClassYearUpdateMutation>;
export type ClassYearUpdateMutationResult = Apollo.MutationResult<ClassYearUpdateMutation>;
export type ClassYearUpdateMutationOptions = Apollo.BaseMutationOptions<
	ClassYearUpdateMutation,
	ClassYearUpdateMutationVariables
>;
export const ClassYearCategoryCountDocument = gql`
	query classYearCategoryCount(
		$filters: [ClassYearCategoryFilterInput!]
		$pagination: Pagination
		$order: ClassYearCategoryOrder
	) {
		classYearCategoryConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useClassYearCategoryCountQuery__
 *
 * To run a query within a React component, call `useClassYearCategoryCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassYearCategoryCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassYearCategoryCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useClassYearCategoryCountQuery(
	baseOptions?: Apollo.QueryHookOptions<ClassYearCategoryCountQuery, ClassYearCategoryCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ClassYearCategoryCountQuery, ClassYearCategoryCountQueryVariables>(
		ClassYearCategoryCountDocument,
		options,
	);
}
export function useClassYearCategoryCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ClassYearCategoryCountQuery, ClassYearCategoryCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ClassYearCategoryCountQuery, ClassYearCategoryCountQueryVariables>(
		ClassYearCategoryCountDocument,
		options,
	);
}
export function useClassYearCategoryCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ClassYearCategoryCountQuery, ClassYearCategoryCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ClassYearCategoryCountQuery, ClassYearCategoryCountQueryVariables>(
		ClassYearCategoryCountDocument,
		options,
	);
}
export type ClassYearCategoryCountQueryHookResult = ReturnType<typeof useClassYearCategoryCountQuery>;
export type ClassYearCategoryCountLazyQueryHookResult = ReturnType<typeof useClassYearCategoryCountLazyQuery>;
export type ClassYearCategoryCountSuspenseQueryHookResult = ReturnType<typeof useClassYearCategoryCountSuspenseQuery>;
export type ClassYearCategoryCountQueryResult = Apollo.QueryResult<
	ClassYearCategoryCountQuery,
	ClassYearCategoryCountQueryVariables
>;
export const ClassYearCategoryCreateDocument = gql`
	mutation classYearCategoryCreate($input: ClassYearCategoryCreateInput!) {
		createClassYearCategory(input: $input) {
			...ClassYearCategoryDetail
		}
	}
	${ClassYearCategoryDetailFragmentDoc}
`;
export type ClassYearCategoryCreateMutationFn = Apollo.MutationFunction<
	ClassYearCategoryCreateMutation,
	ClassYearCategoryCreateMutationVariables
>;

/**
 * __useClassYearCategoryCreateMutation__
 *
 * To run a mutation, you first call `useClassYearCategoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClassYearCategoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [classYearCategoryCreateMutation, { data, loading, error }] = useClassYearCategoryCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClassYearCategoryCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<ClassYearCategoryCreateMutation, ClassYearCategoryCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ClassYearCategoryCreateMutation, ClassYearCategoryCreateMutationVariables>(
		ClassYearCategoryCreateDocument,
		options,
	);
}
export type ClassYearCategoryCreateMutationHookResult = ReturnType<typeof useClassYearCategoryCreateMutation>;
export type ClassYearCategoryCreateMutationResult = Apollo.MutationResult<ClassYearCategoryCreateMutation>;
export type ClassYearCategoryCreateMutationOptions = Apollo.BaseMutationOptions<
	ClassYearCategoryCreateMutation,
	ClassYearCategoryCreateMutationVariables
>;
export const ClassYearCategoryDeleteDocument = gql`
	mutation classYearCategoryDelete($id: ID!) {
		deleteClassYearCategory(id: $id)
	}
`;
export type ClassYearCategoryDeleteMutationFn = Apollo.MutationFunction<
	ClassYearCategoryDeleteMutation,
	ClassYearCategoryDeleteMutationVariables
>;

/**
 * __useClassYearCategoryDeleteMutation__
 *
 * To run a mutation, you first call `useClassYearCategoryDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClassYearCategoryDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [classYearCategoryDeleteMutation, { data, loading, error }] = useClassYearCategoryDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClassYearCategoryDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<ClassYearCategoryDeleteMutation, ClassYearCategoryDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ClassYearCategoryDeleteMutation, ClassYearCategoryDeleteMutationVariables>(
		ClassYearCategoryDeleteDocument,
		options,
	);
}
export type ClassYearCategoryDeleteMutationHookResult = ReturnType<typeof useClassYearCategoryDeleteMutation>;
export type ClassYearCategoryDeleteMutationResult = Apollo.MutationResult<ClassYearCategoryDeleteMutation>;
export type ClassYearCategoryDeleteMutationOptions = Apollo.BaseMutationOptions<
	ClassYearCategoryDeleteMutation,
	ClassYearCategoryDeleteMutationVariables
>;
export const ClassYearCategoryDetailDocument = gql`
	query classYearCategoryDetail($id: ID!) {
		classYearCategory(id: $id) {
			...ClassYearCategoryDetail
		}
	}
	${ClassYearCategoryDetailFragmentDoc}
`;

/**
 * __useClassYearCategoryDetailQuery__
 *
 * To run a query within a React component, call `useClassYearCategoryDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassYearCategoryDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassYearCategoryDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClassYearCategoryDetailQuery(
	baseOptions: Apollo.QueryHookOptions<ClassYearCategoryDetailQuery, ClassYearCategoryDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ClassYearCategoryDetailQuery, ClassYearCategoryDetailQueryVariables>(
		ClassYearCategoryDetailDocument,
		options,
	);
}
export function useClassYearCategoryDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ClassYearCategoryDetailQuery, ClassYearCategoryDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ClassYearCategoryDetailQuery, ClassYearCategoryDetailQueryVariables>(
		ClassYearCategoryDetailDocument,
		options,
	);
}
export function useClassYearCategoryDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ClassYearCategoryDetailQuery, ClassYearCategoryDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ClassYearCategoryDetailQuery, ClassYearCategoryDetailQueryVariables>(
		ClassYearCategoryDetailDocument,
		options,
	);
}
export type ClassYearCategoryDetailQueryHookResult = ReturnType<typeof useClassYearCategoryDetailQuery>;
export type ClassYearCategoryDetailLazyQueryHookResult = ReturnType<typeof useClassYearCategoryDetailLazyQuery>;
export type ClassYearCategoryDetailSuspenseQueryHookResult = ReturnType<typeof useClassYearCategoryDetailSuspenseQuery>;
export type ClassYearCategoryDetailQueryResult = Apollo.QueryResult<
	ClassYearCategoryDetailQuery,
	ClassYearCategoryDetailQueryVariables
>;
export const ClassYearCategoryIndexDocument = gql`
	query classYearCategoryIndex(
		$filters: [ClassYearCategoryFilterInput!]
		$pagination: Pagination
		$order: ClassYearCategoryOrder
	) {
		classYearCategoryConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					description
				}
			}
		}
	}
`;

/**
 * __useClassYearCategoryIndexQuery__
 *
 * To run a query within a React component, call `useClassYearCategoryIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassYearCategoryIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassYearCategoryIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useClassYearCategoryIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<ClassYearCategoryIndexQuery, ClassYearCategoryIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ClassYearCategoryIndexQuery, ClassYearCategoryIndexQueryVariables>(
		ClassYearCategoryIndexDocument,
		options,
	);
}
export function useClassYearCategoryIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ClassYearCategoryIndexQuery, ClassYearCategoryIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ClassYearCategoryIndexQuery, ClassYearCategoryIndexQueryVariables>(
		ClassYearCategoryIndexDocument,
		options,
	);
}
export function useClassYearCategoryIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ClassYearCategoryIndexQuery, ClassYearCategoryIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ClassYearCategoryIndexQuery, ClassYearCategoryIndexQueryVariables>(
		ClassYearCategoryIndexDocument,
		options,
	);
}
export type ClassYearCategoryIndexQueryHookResult = ReturnType<typeof useClassYearCategoryIndexQuery>;
export type ClassYearCategoryIndexLazyQueryHookResult = ReturnType<typeof useClassYearCategoryIndexLazyQuery>;
export type ClassYearCategoryIndexSuspenseQueryHookResult = ReturnType<typeof useClassYearCategoryIndexSuspenseQuery>;
export type ClassYearCategoryIndexQueryResult = Apollo.QueryResult<
	ClassYearCategoryIndexQuery,
	ClassYearCategoryIndexQueryVariables
>;
export const ClassYearCategoryNameDocument = gql`
	query classYearCategoryName($id: ID!) {
		classYearCategory(id: $id) {
			id
			...ClassYearCategoryName
		}
	}
	${ClassYearCategoryNameFragmentDoc}
`;

/**
 * __useClassYearCategoryNameQuery__
 *
 * To run a query within a React component, call `useClassYearCategoryNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassYearCategoryNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassYearCategoryNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClassYearCategoryNameQuery(
	baseOptions: Apollo.QueryHookOptions<ClassYearCategoryNameQuery, ClassYearCategoryNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ClassYearCategoryNameQuery, ClassYearCategoryNameQueryVariables>(
		ClassYearCategoryNameDocument,
		options,
	);
}
export function useClassYearCategoryNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ClassYearCategoryNameQuery, ClassYearCategoryNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ClassYearCategoryNameQuery, ClassYearCategoryNameQueryVariables>(
		ClassYearCategoryNameDocument,
		options,
	);
}
export function useClassYearCategoryNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ClassYearCategoryNameQuery, ClassYearCategoryNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ClassYearCategoryNameQuery, ClassYearCategoryNameQueryVariables>(
		ClassYearCategoryNameDocument,
		options,
	);
}
export type ClassYearCategoryNameQueryHookResult = ReturnType<typeof useClassYearCategoryNameQuery>;
export type ClassYearCategoryNameLazyQueryHookResult = ReturnType<typeof useClassYearCategoryNameLazyQuery>;
export type ClassYearCategoryNameSuspenseQueryHookResult = ReturnType<typeof useClassYearCategoryNameSuspenseQuery>;
export type ClassYearCategoryNameQueryResult = Apollo.QueryResult<
	ClassYearCategoryNameQuery,
	ClassYearCategoryNameQueryVariables
>;
export const ClassYearCategoryNamesDocument = gql`
	query classYearCategoryNames(
		$filters: [ClassYearCategoryFilterInput!]
		$pagination: Pagination
		$order: ClassYearCategoryOrder
	) {
		classYearCategoryConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...ClassYearCategoryName
				}
			}
		}
	}
	${ClassYearCategoryNameFragmentDoc}
`;

/**
 * __useClassYearCategoryNamesQuery__
 *
 * To run a query within a React component, call `useClassYearCategoryNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassYearCategoryNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassYearCategoryNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useClassYearCategoryNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<ClassYearCategoryNamesQuery, ClassYearCategoryNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ClassYearCategoryNamesQuery, ClassYearCategoryNamesQueryVariables>(
		ClassYearCategoryNamesDocument,
		options,
	);
}
export function useClassYearCategoryNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ClassYearCategoryNamesQuery, ClassYearCategoryNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ClassYearCategoryNamesQuery, ClassYearCategoryNamesQueryVariables>(
		ClassYearCategoryNamesDocument,
		options,
	);
}
export function useClassYearCategoryNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ClassYearCategoryNamesQuery, ClassYearCategoryNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ClassYearCategoryNamesQuery, ClassYearCategoryNamesQueryVariables>(
		ClassYearCategoryNamesDocument,
		options,
	);
}
export type ClassYearCategoryNamesQueryHookResult = ReturnType<typeof useClassYearCategoryNamesQuery>;
export type ClassYearCategoryNamesLazyQueryHookResult = ReturnType<typeof useClassYearCategoryNamesLazyQuery>;
export type ClassYearCategoryNamesSuspenseQueryHookResult = ReturnType<typeof useClassYearCategoryNamesSuspenseQuery>;
export type ClassYearCategoryNamesQueryResult = Apollo.QueryResult<
	ClassYearCategoryNamesQuery,
	ClassYearCategoryNamesQueryVariables
>;
export const ClassYearCategoryPaginationDocument = gql`
	query classYearCategoryPagination($filters: [ClassYearCategoryFilterInput!], $order: ClassYearCategoryOrder) {
		classYearCategoryConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useClassYearCategoryPaginationQuery__
 *
 * To run a query within a React component, call `useClassYearCategoryPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassYearCategoryPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassYearCategoryPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useClassYearCategoryPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<ClassYearCategoryPaginationQuery, ClassYearCategoryPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ClassYearCategoryPaginationQuery, ClassYearCategoryPaginationQueryVariables>(
		ClassYearCategoryPaginationDocument,
		options,
	);
}
export function useClassYearCategoryPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ClassYearCategoryPaginationQuery,
		ClassYearCategoryPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ClassYearCategoryPaginationQuery, ClassYearCategoryPaginationQueryVariables>(
		ClassYearCategoryPaginationDocument,
		options,
	);
}
export function useClassYearCategoryPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ClassYearCategoryPaginationQuery,
		ClassYearCategoryPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ClassYearCategoryPaginationQuery, ClassYearCategoryPaginationQueryVariables>(
		ClassYearCategoryPaginationDocument,
		options,
	);
}
export type ClassYearCategoryPaginationQueryHookResult = ReturnType<typeof useClassYearCategoryPaginationQuery>;
export type ClassYearCategoryPaginationLazyQueryHookResult = ReturnType<typeof useClassYearCategoryPaginationLazyQuery>;
export type ClassYearCategoryPaginationSuspenseQueryHookResult = ReturnType<
	typeof useClassYearCategoryPaginationSuspenseQuery
>;
export type ClassYearCategoryPaginationQueryResult = Apollo.QueryResult<
	ClassYearCategoryPaginationQuery,
	ClassYearCategoryPaginationQueryVariables
>;
export const ClassYearCategorySelectDocument = gql`
	query classYearCategorySelect($filters: [ClassYearCategoryFilterInput!], $order: ClassYearCategoryOrder) {
		classYearCategoryConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...ClassYearCategoryName
				}
			}
		}
	}
	${ClassYearCategoryNameFragmentDoc}
`;

/**
 * __useClassYearCategorySelectQuery__
 *
 * To run a query within a React component, call `useClassYearCategorySelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassYearCategorySelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassYearCategorySelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useClassYearCategorySelectQuery(
	baseOptions?: Apollo.QueryHookOptions<ClassYearCategorySelectQuery, ClassYearCategorySelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ClassYearCategorySelectQuery, ClassYearCategorySelectQueryVariables>(
		ClassYearCategorySelectDocument,
		options,
	);
}
export function useClassYearCategorySelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ClassYearCategorySelectQuery, ClassYearCategorySelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ClassYearCategorySelectQuery, ClassYearCategorySelectQueryVariables>(
		ClassYearCategorySelectDocument,
		options,
	);
}
export function useClassYearCategorySelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ClassYearCategorySelectQuery, ClassYearCategorySelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ClassYearCategorySelectQuery, ClassYearCategorySelectQueryVariables>(
		ClassYearCategorySelectDocument,
		options,
	);
}
export type ClassYearCategorySelectQueryHookResult = ReturnType<typeof useClassYearCategorySelectQuery>;
export type ClassYearCategorySelectLazyQueryHookResult = ReturnType<typeof useClassYearCategorySelectLazyQuery>;
export type ClassYearCategorySelectSuspenseQueryHookResult = ReturnType<typeof useClassYearCategorySelectSuspenseQuery>;
export type ClassYearCategorySelectQueryResult = Apollo.QueryResult<
	ClassYearCategorySelectQuery,
	ClassYearCategorySelectQueryVariables
>;
export const ClassYearCategoryUpdateDocument = gql`
	mutation classYearCategoryUpdate($id: ID!, $input: ClassYearCategoryUpdateInput!) {
		updateClassYearCategory(id: $id, input: $input) {
			...ClassYearCategoryDetail
		}
	}
	${ClassYearCategoryDetailFragmentDoc}
`;
export type ClassYearCategoryUpdateMutationFn = Apollo.MutationFunction<
	ClassYearCategoryUpdateMutation,
	ClassYearCategoryUpdateMutationVariables
>;

/**
 * __useClassYearCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useClassYearCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClassYearCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [classYearCategoryUpdateMutation, { data, loading, error }] = useClassYearCategoryUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClassYearCategoryUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<ClassYearCategoryUpdateMutation, ClassYearCategoryUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ClassYearCategoryUpdateMutation, ClassYearCategoryUpdateMutationVariables>(
		ClassYearCategoryUpdateDocument,
		options,
	);
}
export type ClassYearCategoryUpdateMutationHookResult = ReturnType<typeof useClassYearCategoryUpdateMutation>;
export type ClassYearCategoryUpdateMutationResult = Apollo.MutationResult<ClassYearCategoryUpdateMutation>;
export type ClassYearCategoryUpdateMutationOptions = Apollo.BaseMutationOptions<
	ClassYearCategoryUpdateMutation,
	ClassYearCategoryUpdateMutationVariables
>;
export const ContractCountDocument = gql`
	query contractCount($filters: [ContractFilterInput!], $pagination: Pagination, $order: ContractOrder) {
		contractConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useContractCountQuery__
 *
 * To run a query within a React component, call `useContractCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useContractCountQuery(
	baseOptions?: Apollo.QueryHookOptions<ContractCountQuery, ContractCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractCountQuery, ContractCountQueryVariables>(ContractCountDocument, options);
}
export function useContractCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractCountQuery, ContractCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractCountQuery, ContractCountQueryVariables>(ContractCountDocument, options);
}
export function useContractCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractCountQuery, ContractCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractCountQuery, ContractCountQueryVariables>(ContractCountDocument, options);
}
export type ContractCountQueryHookResult = ReturnType<typeof useContractCountQuery>;
export type ContractCountLazyQueryHookResult = ReturnType<typeof useContractCountLazyQuery>;
export type ContractCountSuspenseQueryHookResult = ReturnType<typeof useContractCountSuspenseQuery>;
export type ContractCountQueryResult = Apollo.QueryResult<ContractCountQuery, ContractCountQueryVariables>;
export const ContractCreateDocument = gql`
	mutation contractCreate($input: ContractCreateInput!) {
		createContract(input: $input) {
			...ContractDetail
		}
	}
	${ContractDetailFragmentDoc}
`;
export type ContractCreateMutationFn = Apollo.MutationFunction<ContractCreateMutation, ContractCreateMutationVariables>;

/**
 * __useContractCreateMutation__
 *
 * To run a mutation, you first call `useContractCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractCreateMutation, { data, loading, error }] = useContractCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContractCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<ContractCreateMutation, ContractCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ContractCreateMutation, ContractCreateMutationVariables>(ContractCreateDocument, options);
}
export type ContractCreateMutationHookResult = ReturnType<typeof useContractCreateMutation>;
export type ContractCreateMutationResult = Apollo.MutationResult<ContractCreateMutation>;
export type ContractCreateMutationOptions = Apollo.BaseMutationOptions<
	ContractCreateMutation,
	ContractCreateMutationVariables
>;
export const ContractDeleteDocument = gql`
	mutation contractDelete($id: ID!) {
		deleteContract(id: $id)
	}
`;
export type ContractDeleteMutationFn = Apollo.MutationFunction<ContractDeleteMutation, ContractDeleteMutationVariables>;

/**
 * __useContractDeleteMutation__
 *
 * To run a mutation, you first call `useContractDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractDeleteMutation, { data, loading, error }] = useContractDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<ContractDeleteMutation, ContractDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ContractDeleteMutation, ContractDeleteMutationVariables>(ContractDeleteDocument, options);
}
export type ContractDeleteMutationHookResult = ReturnType<typeof useContractDeleteMutation>;
export type ContractDeleteMutationResult = Apollo.MutationResult<ContractDeleteMutation>;
export type ContractDeleteMutationOptions = Apollo.BaseMutationOptions<
	ContractDeleteMutation,
	ContractDeleteMutationVariables
>;
export const ContractDetailDocument = gql`
	query contractDetail($id: ID!) {
		contract(id: $id) {
			...ContractDetail
		}
	}
	${ContractDetailFragmentDoc}
`;

/**
 * __useContractDetailQuery__
 *
 * To run a query within a React component, call `useContractDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractDetailQuery(
	baseOptions: Apollo.QueryHookOptions<ContractDetailQuery, ContractDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractDetailQuery, ContractDetailQueryVariables>(ContractDetailDocument, options);
}
export function useContractDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractDetailQuery, ContractDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractDetailQuery, ContractDetailQueryVariables>(ContractDetailDocument, options);
}
export function useContractDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractDetailQuery, ContractDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractDetailQuery, ContractDetailQueryVariables>(ContractDetailDocument, options);
}
export type ContractDetailQueryHookResult = ReturnType<typeof useContractDetailQuery>;
export type ContractDetailLazyQueryHookResult = ReturnType<typeof useContractDetailLazyQuery>;
export type ContractDetailSuspenseQueryHookResult = ReturnType<typeof useContractDetailSuspenseQuery>;
export type ContractDetailQueryResult = Apollo.QueryResult<ContractDetailQuery, ContractDetailQueryVariables>;
export const ContractStudentIdDocument = gql`
	query contractStudentID($id: ID!) {
		contract(id: $id) {
			id
			studentID
		}
	}
`;

/**
 * __useContractStudentIdQuery__
 *
 * To run a query within a React component, call `useContractStudentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractStudentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractStudentIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractStudentIdQuery(
	baseOptions: Apollo.QueryHookOptions<ContractStudentIdQuery, ContractStudentIdQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractStudentIdQuery, ContractStudentIdQueryVariables>(ContractStudentIdDocument, options);
}
export function useContractStudentIdLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractStudentIdQuery, ContractStudentIdQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractStudentIdQuery, ContractStudentIdQueryVariables>(
		ContractStudentIdDocument,
		options,
	);
}
export function useContractStudentIdSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractStudentIdQuery, ContractStudentIdQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractStudentIdQuery, ContractStudentIdQueryVariables>(
		ContractStudentIdDocument,
		options,
	);
}
export type ContractStudentIdQueryHookResult = ReturnType<typeof useContractStudentIdQuery>;
export type ContractStudentIdLazyQueryHookResult = ReturnType<typeof useContractStudentIdLazyQuery>;
export type ContractStudentIdSuspenseQueryHookResult = ReturnType<typeof useContractStudentIdSuspenseQuery>;
export type ContractStudentIdQueryResult = Apollo.QueryResult<ContractStudentIdQuery, ContractStudentIdQueryVariables>;
export const ContractDisplayDocument = gql`
	query contractDisplay($id: ID!, $studentID: ID!) {
		contract(id: $id) {
			id
			name
			effectiveDate
			student {
				id
				person {
					id
					...PersonNameAndImage
					givenName
					familyName
					dateOfBirth
					gender
					nationalIdentificationNumber
				}
				graduationYear
				studentMedicalProfile {
					id
					isSchoolAllowedToTreat
					isSchoolAllowedToUseEpipen
				}
			}
			contractLineItems(order: { field: DISPLAY_ORDER, direction: ASC }) {
				id
				displayOrder
				isDiscount
				amount
				dateAdded
				dateRemoved
				service {
					id
					...ServiceName
					category
				}
				discount {
					id
					...DiscountName
				}
				childContractLineItems(order: { field: DISPLAY_ORDER, direction: ASC }) {
					id
					displayOrder
					isDiscount
					amount
					service {
						id
						...ServiceName
					}
					discount {
						id
						...DiscountName
					}
				}
			}
			contractInstallments(order: { field: DUE_DATE, direction: ASC }) {
				id
				dueDate
				portion
				invoices {
					id
					paymentLineItems {
						id
						amount
					}
					billingAdjustments {
						id
						amount
					}
				}
			}
		}
		guardianConnection(filters: { relationships: { studentIDEQ: $studentID, isPrimaryEQ: true } }) {
			edges {
				node {
					id
					person {
						id
						...PersonName
						givenName
						familyName
						nationalIdentificationNumber
						governmentDocumentSeries
						governmentDocumentNumber
						governmentDocumentIssuedBy
						phoneNumbers(order: { field: IS_PRIMARY, direction: DESC }) {
							id
							phoneNumber
						}
						emailAddresses(order: { field: IS_PRIMARY, direction: DESC }) {
							id
							emailAddress
						}
						addresses {
							id
							...AddressInformation
						}
					}
					relationshipStatus
					relationships(filters: { studentIDEQ: $studentID }) {
						id
						hasCustody
					}
				}
			}
		}
		studentThirdPartyContractPayer(studentID: $studentID) {
			companyName
			fiscalNumber
			tradeRegistryNumber
			companyAddress
			legalRepresentative
			representativeEmail
			phone
		}
		studentPrescriptionMedicationConnection(filters: { studentIDEQ: $studentID }) {
			edges {
				node {
					id
					medication {
						id
						...MedicationName
					}
					notes
					canSelfAdminister
					administration
				}
			}
		}
		studentMedicalConditionConnection(filters: { studentIDEQ: $studentID }) {
			edges {
				node {
					id
					medicalCondition {
						id
						...MedicalConditionName
					}
					notes
				}
			}
		}
		studentOTCMedicationConnection(filters: { studentIDEQ: $studentID }) {
			edges {
				node {
					id
					medication {
						id
						...MedicationName
					}
					isAllowed
				}
			}
		}
	}
	${PersonNameAndImageFragmentDoc}
	${ServiceNameFragmentDoc}
	${DiscountNameFragmentDoc}
	${PersonNameFragmentDoc}
	${AddressInformationFragmentDoc}
	${MedicationNameFragmentDoc}
	${MedicalConditionNameFragmentDoc}
`;

/**
 * __useContractDisplayQuery__
 *
 * To run a query within a React component, call `useContractDisplayQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractDisplayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractDisplayQuery({
 *   variables: {
 *      id: // value for 'id'
 *      studentID: // value for 'studentID'
 *   },
 * });
 */
export function useContractDisplayQuery(
	baseOptions: Apollo.QueryHookOptions<ContractDisplayQuery, ContractDisplayQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractDisplayQuery, ContractDisplayQueryVariables>(ContractDisplayDocument, options);
}
export function useContractDisplayLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractDisplayQuery, ContractDisplayQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractDisplayQuery, ContractDisplayQueryVariables>(ContractDisplayDocument, options);
}
export function useContractDisplaySuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractDisplayQuery, ContractDisplayQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractDisplayQuery, ContractDisplayQueryVariables>(ContractDisplayDocument, options);
}
export type ContractDisplayQueryHookResult = ReturnType<typeof useContractDisplayQuery>;
export type ContractDisplayLazyQueryHookResult = ReturnType<typeof useContractDisplayLazyQuery>;
export type ContractDisplaySuspenseQueryHookResult = ReturnType<typeof useContractDisplaySuspenseQuery>;
export type ContractDisplayQueryResult = Apollo.QueryResult<ContractDisplayQuery, ContractDisplayQueryVariables>;
export const ContractIndexDocument = gql`
	query contractIndex($filters: [ContractFilterInput!], $pagination: Pagination, $order: ContractOrder) {
		contractConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					status
					isApproved
					isFinalized
					effectiveDate
					dateVoided
					fileURL
					fileContentType
					signedFileURL
					signedFileContentType
				}
			}
		}
	}
`;

/**
 * __useContractIndexQuery__
 *
 * To run a query within a React component, call `useContractIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useContractIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<ContractIndexQuery, ContractIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractIndexQuery, ContractIndexQueryVariables>(ContractIndexDocument, options);
}
export function useContractIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractIndexQuery, ContractIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractIndexQuery, ContractIndexQueryVariables>(ContractIndexDocument, options);
}
export function useContractIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractIndexQuery, ContractIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractIndexQuery, ContractIndexQueryVariables>(ContractIndexDocument, options);
}
export type ContractIndexQueryHookResult = ReturnType<typeof useContractIndexQuery>;
export type ContractIndexLazyQueryHookResult = ReturnType<typeof useContractIndexLazyQuery>;
export type ContractIndexSuspenseQueryHookResult = ReturnType<typeof useContractIndexSuspenseQuery>;
export type ContractIndexQueryResult = Apollo.QueryResult<ContractIndexQuery, ContractIndexQueryVariables>;
export const ContractListDocument = gql`
	query contractList($filters: [ContractFilterInput!], $pagination: Pagination, $order: ContractOrder) {
		contractConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					status
					effectiveDate
					dateVoided
					student {
						id
						...StudentNameAndImage
					}
					contractLineItems(order: { field: DISPLAY_ORDER, direction: ASC }) {
						id
						displayOrder
						amount
						dateAdded
						dateRemoved
						isDiscount
						service {
							id
							...ServiceName
						}
						discount {
							id
							...DiscountName
						}
						childContractLineItems(order: { field: DISPLAY_ORDER, direction: ASC }) {
							id
							amount
							isDiscount
							service {
								id
								...ServiceName
							}
							discount {
								id
								...DiscountName
							}
						}
					}
					contractInstallments(order: { field: DUE_DATE, direction: ASC }) {
						id
						dueDate
						portion
						invoices {
							id
							paymentLineItems {
								id
								amount
							}
							billingAdjustments {
								id
								amount
							}
						}
					}
				}
			}
		}
	}
	${StudentNameAndImageFragmentDoc}
	${ServiceNameFragmentDoc}
	${DiscountNameFragmentDoc}
`;

/**
 * __useContractListQuery__
 *
 * To run a query within a React component, call `useContractListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useContractListQuery(
	baseOptions?: Apollo.QueryHookOptions<ContractListQuery, ContractListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractListQuery, ContractListQueryVariables>(ContractListDocument, options);
}
export function useContractListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractListQuery, ContractListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractListQuery, ContractListQueryVariables>(ContractListDocument, options);
}
export function useContractListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractListQuery, ContractListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractListQuery, ContractListQueryVariables>(ContractListDocument, options);
}
export type ContractListQueryHookResult = ReturnType<typeof useContractListQuery>;
export type ContractListLazyQueryHookResult = ReturnType<typeof useContractListLazyQuery>;
export type ContractListSuspenseQueryHookResult = ReturnType<typeof useContractListSuspenseQuery>;
export type ContractListQueryResult = Apollo.QueryResult<ContractListQuery, ContractListQueryVariables>;
export const ContractNameDocument = gql`
	query contractName($id: ID!) {
		contract(id: $id) {
			id
			...ContractName
		}
	}
	${ContractNameFragmentDoc}
`;

/**
 * __useContractNameQuery__
 *
 * To run a query within a React component, call `useContractNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractNameQuery(
	baseOptions: Apollo.QueryHookOptions<ContractNameQuery, ContractNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractNameQuery, ContractNameQueryVariables>(ContractNameDocument, options);
}
export function useContractNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractNameQuery, ContractNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractNameQuery, ContractNameQueryVariables>(ContractNameDocument, options);
}
export function useContractNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractNameQuery, ContractNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractNameQuery, ContractNameQueryVariables>(ContractNameDocument, options);
}
export type ContractNameQueryHookResult = ReturnType<typeof useContractNameQuery>;
export type ContractNameLazyQueryHookResult = ReturnType<typeof useContractNameLazyQuery>;
export type ContractNameSuspenseQueryHookResult = ReturnType<typeof useContractNameSuspenseQuery>;
export type ContractNameQueryResult = Apollo.QueryResult<ContractNameQuery, ContractNameQueryVariables>;
export const ContractNamesDocument = gql`
	query contractNames($filters: [ContractFilterInput!], $pagination: Pagination, $order: ContractOrder) {
		contractConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...ContractName
				}
			}
		}
	}
	${ContractNameFragmentDoc}
`;

/**
 * __useContractNamesQuery__
 *
 * To run a query within a React component, call `useContractNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useContractNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<ContractNamesQuery, ContractNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractNamesQuery, ContractNamesQueryVariables>(ContractNamesDocument, options);
}
export function useContractNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractNamesQuery, ContractNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractNamesQuery, ContractNamesQueryVariables>(ContractNamesDocument, options);
}
export function useContractNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractNamesQuery, ContractNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractNamesQuery, ContractNamesQueryVariables>(ContractNamesDocument, options);
}
export type ContractNamesQueryHookResult = ReturnType<typeof useContractNamesQuery>;
export type ContractNamesLazyQueryHookResult = ReturnType<typeof useContractNamesLazyQuery>;
export type ContractNamesSuspenseQueryHookResult = ReturnType<typeof useContractNamesSuspenseQuery>;
export type ContractNamesQueryResult = Apollo.QueryResult<ContractNamesQuery, ContractNamesQueryVariables>;
export const ContractPaginationDocument = gql`
	query contractPagination($filters: [ContractFilterInput!], $order: ContractOrder) {
		contractConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useContractPaginationQuery__
 *
 * To run a query within a React component, call `useContractPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useContractPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<ContractPaginationQuery, ContractPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractPaginationQuery, ContractPaginationQueryVariables>(
		ContractPaginationDocument,
		options,
	);
}
export function useContractPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractPaginationQuery, ContractPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractPaginationQuery, ContractPaginationQueryVariables>(
		ContractPaginationDocument,
		options,
	);
}
export function useContractPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractPaginationQuery, ContractPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractPaginationQuery, ContractPaginationQueryVariables>(
		ContractPaginationDocument,
		options,
	);
}
export type ContractPaginationQueryHookResult = ReturnType<typeof useContractPaginationQuery>;
export type ContractPaginationLazyQueryHookResult = ReturnType<typeof useContractPaginationLazyQuery>;
export type ContractPaginationSuspenseQueryHookResult = ReturnType<typeof useContractPaginationSuspenseQuery>;
export type ContractPaginationQueryResult = Apollo.QueryResult<
	ContractPaginationQuery,
	ContractPaginationQueryVariables
>;
export const ContractSelectDocument = gql`
	query contractSelect($filters: [ContractFilterInput!], $order: ContractOrder) {
		contractConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...ContractName
					effectiveDate
				}
			}
		}
	}
	${ContractNameFragmentDoc}
`;

/**
 * __useContractSelectQuery__
 *
 * To run a query within a React component, call `useContractSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useContractSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<ContractSelectQuery, ContractSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractSelectQuery, ContractSelectQueryVariables>(ContractSelectDocument, options);
}
export function useContractSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractSelectQuery, ContractSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractSelectQuery, ContractSelectQueryVariables>(ContractSelectDocument, options);
}
export function useContractSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractSelectQuery, ContractSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractSelectQuery, ContractSelectQueryVariables>(ContractSelectDocument, options);
}
export type ContractSelectQueryHookResult = ReturnType<typeof useContractSelectQuery>;
export type ContractSelectLazyQueryHookResult = ReturnType<typeof useContractSelectLazyQuery>;
export type ContractSelectSuspenseQueryHookResult = ReturnType<typeof useContractSelectSuspenseQuery>;
export type ContractSelectQueryResult = Apollo.QueryResult<ContractSelectQuery, ContractSelectQueryVariables>;
export const ContractUpdateDocument = gql`
	mutation contractUpdate($id: ID!, $input: ContractUpdateInput!) {
		updateContract(id: $id, input: $input) {
			...ContractDetail
		}
	}
	${ContractDetailFragmentDoc}
`;
export type ContractUpdateMutationFn = Apollo.MutationFunction<ContractUpdateMutation, ContractUpdateMutationVariables>;

/**
 * __useContractUpdateMutation__
 *
 * To run a mutation, you first call `useContractUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractUpdateMutation, { data, loading, error }] = useContractUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContractUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<ContractUpdateMutation, ContractUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ContractUpdateMutation, ContractUpdateMutationVariables>(ContractUpdateDocument, options);
}
export type ContractUpdateMutationHookResult = ReturnType<typeof useContractUpdateMutation>;
export type ContractUpdateMutationResult = Apollo.MutationResult<ContractUpdateMutation>;
export type ContractUpdateMutationOptions = Apollo.BaseMutationOptions<
	ContractUpdateMutation,
	ContractUpdateMutationVariables
>;
export const ContractInstallmentCountDocument = gql`
	query contractInstallmentCount(
		$filters: [ContractInstallmentFilterInput!]
		$pagination: Pagination
		$order: ContractInstallmentOrder
	) {
		contractInstallmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useContractInstallmentCountQuery__
 *
 * To run a query within a React component, call `useContractInstallmentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractInstallmentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractInstallmentCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useContractInstallmentCountQuery(
	baseOptions?: Apollo.QueryHookOptions<ContractInstallmentCountQuery, ContractInstallmentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractInstallmentCountQuery, ContractInstallmentCountQueryVariables>(
		ContractInstallmentCountDocument,
		options,
	);
}
export function useContractInstallmentCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractInstallmentCountQuery, ContractInstallmentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractInstallmentCountQuery, ContractInstallmentCountQueryVariables>(
		ContractInstallmentCountDocument,
		options,
	);
}
export function useContractInstallmentCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractInstallmentCountQuery, ContractInstallmentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractInstallmentCountQuery, ContractInstallmentCountQueryVariables>(
		ContractInstallmentCountDocument,
		options,
	);
}
export type ContractInstallmentCountQueryHookResult = ReturnType<typeof useContractInstallmentCountQuery>;
export type ContractInstallmentCountLazyQueryHookResult = ReturnType<typeof useContractInstallmentCountLazyQuery>;
export type ContractInstallmentCountSuspenseQueryHookResult = ReturnType<
	typeof useContractInstallmentCountSuspenseQuery
>;
export type ContractInstallmentCountQueryResult = Apollo.QueryResult<
	ContractInstallmentCountQuery,
	ContractInstallmentCountQueryVariables
>;
export const ContractInstallmentCreateDocument = gql`
	mutation contractInstallmentCreate($input: ContractInstallmentCreateInput!) {
		createContractInstallment(input: $input) {
			...ContractInstallmentDetail
		}
	}
	${ContractInstallmentDetailFragmentDoc}
`;
export type ContractInstallmentCreateMutationFn = Apollo.MutationFunction<
	ContractInstallmentCreateMutation,
	ContractInstallmentCreateMutationVariables
>;

/**
 * __useContractInstallmentCreateMutation__
 *
 * To run a mutation, you first call `useContractInstallmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractInstallmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractInstallmentCreateMutation, { data, loading, error }] = useContractInstallmentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContractInstallmentCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ContractInstallmentCreateMutation,
		ContractInstallmentCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ContractInstallmentCreateMutation, ContractInstallmentCreateMutationVariables>(
		ContractInstallmentCreateDocument,
		options,
	);
}
export type ContractInstallmentCreateMutationHookResult = ReturnType<typeof useContractInstallmentCreateMutation>;
export type ContractInstallmentCreateMutationResult = Apollo.MutationResult<ContractInstallmentCreateMutation>;
export type ContractInstallmentCreateMutationOptions = Apollo.BaseMutationOptions<
	ContractInstallmentCreateMutation,
	ContractInstallmentCreateMutationVariables
>;
export const ContractInstallmentDeleteDocument = gql`
	mutation contractInstallmentDelete($id: ID!) {
		deleteContractInstallment(id: $id)
	}
`;
export type ContractInstallmentDeleteMutationFn = Apollo.MutationFunction<
	ContractInstallmentDeleteMutation,
	ContractInstallmentDeleteMutationVariables
>;

/**
 * __useContractInstallmentDeleteMutation__
 *
 * To run a mutation, you first call `useContractInstallmentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractInstallmentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractInstallmentDeleteMutation, { data, loading, error }] = useContractInstallmentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractInstallmentDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ContractInstallmentDeleteMutation,
		ContractInstallmentDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ContractInstallmentDeleteMutation, ContractInstallmentDeleteMutationVariables>(
		ContractInstallmentDeleteDocument,
		options,
	);
}
export type ContractInstallmentDeleteMutationHookResult = ReturnType<typeof useContractInstallmentDeleteMutation>;
export type ContractInstallmentDeleteMutationResult = Apollo.MutationResult<ContractInstallmentDeleteMutation>;
export type ContractInstallmentDeleteMutationOptions = Apollo.BaseMutationOptions<
	ContractInstallmentDeleteMutation,
	ContractInstallmentDeleteMutationVariables
>;
export const ContractInstallmentDetailDocument = gql`
	query contractInstallmentDetail($id: ID!) {
		contractInstallment(id: $id) {
			...ContractInstallmentDetail
		}
	}
	${ContractInstallmentDetailFragmentDoc}
`;

/**
 * __useContractInstallmentDetailQuery__
 *
 * To run a query within a React component, call `useContractInstallmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractInstallmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractInstallmentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractInstallmentDetailQuery(
	baseOptions: Apollo.QueryHookOptions<ContractInstallmentDetailQuery, ContractInstallmentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractInstallmentDetailQuery, ContractInstallmentDetailQueryVariables>(
		ContractInstallmentDetailDocument,
		options,
	);
}
export function useContractInstallmentDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractInstallmentDetailQuery, ContractInstallmentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractInstallmentDetailQuery, ContractInstallmentDetailQueryVariables>(
		ContractInstallmentDetailDocument,
		options,
	);
}
export function useContractInstallmentDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ContractInstallmentDetailQuery,
		ContractInstallmentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractInstallmentDetailQuery, ContractInstallmentDetailQueryVariables>(
		ContractInstallmentDetailDocument,
		options,
	);
}
export type ContractInstallmentDetailQueryHookResult = ReturnType<typeof useContractInstallmentDetailQuery>;
export type ContractInstallmentDetailLazyQueryHookResult = ReturnType<typeof useContractInstallmentDetailLazyQuery>;
export type ContractInstallmentDetailSuspenseQueryHookResult = ReturnType<
	typeof useContractInstallmentDetailSuspenseQuery
>;
export type ContractInstallmentDetailQueryResult = Apollo.QueryResult<
	ContractInstallmentDetailQuery,
	ContractInstallmentDetailQueryVariables
>;
export const ContractInstallmentIndexDocument = gql`
	query contractInstallmentIndex(
		$filters: [ContractInstallmentFilterInput!]
		$pagination: Pagination
		$order: ContractInstallmentOrder
	) {
		contractInstallmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					dueDate
					portion
				}
			}
		}
	}
`;

/**
 * __useContractInstallmentIndexQuery__
 *
 * To run a query within a React component, call `useContractInstallmentIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractInstallmentIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractInstallmentIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useContractInstallmentIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<ContractInstallmentIndexQuery, ContractInstallmentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractInstallmentIndexQuery, ContractInstallmentIndexQueryVariables>(
		ContractInstallmentIndexDocument,
		options,
	);
}
export function useContractInstallmentIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractInstallmentIndexQuery, ContractInstallmentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractInstallmentIndexQuery, ContractInstallmentIndexQueryVariables>(
		ContractInstallmentIndexDocument,
		options,
	);
}
export function useContractInstallmentIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractInstallmentIndexQuery, ContractInstallmentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractInstallmentIndexQuery, ContractInstallmentIndexQueryVariables>(
		ContractInstallmentIndexDocument,
		options,
	);
}
export type ContractInstallmentIndexQueryHookResult = ReturnType<typeof useContractInstallmentIndexQuery>;
export type ContractInstallmentIndexLazyQueryHookResult = ReturnType<typeof useContractInstallmentIndexLazyQuery>;
export type ContractInstallmentIndexSuspenseQueryHookResult = ReturnType<
	typeof useContractInstallmentIndexSuspenseQuery
>;
export type ContractInstallmentIndexQueryResult = Apollo.QueryResult<
	ContractInstallmentIndexQuery,
	ContractInstallmentIndexQueryVariables
>;
export const ContractInstallmentNameDocument = gql`
	query contractInstallmentName($id: ID!) {
		contractInstallment(id: $id) {
			id
			...ContractInstallmentName
		}
	}
	${ContractInstallmentNameFragmentDoc}
`;

/**
 * __useContractInstallmentNameQuery__
 *
 * To run a query within a React component, call `useContractInstallmentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractInstallmentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractInstallmentNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractInstallmentNameQuery(
	baseOptions: Apollo.QueryHookOptions<ContractInstallmentNameQuery, ContractInstallmentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractInstallmentNameQuery, ContractInstallmentNameQueryVariables>(
		ContractInstallmentNameDocument,
		options,
	);
}
export function useContractInstallmentNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractInstallmentNameQuery, ContractInstallmentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractInstallmentNameQuery, ContractInstallmentNameQueryVariables>(
		ContractInstallmentNameDocument,
		options,
	);
}
export function useContractInstallmentNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractInstallmentNameQuery, ContractInstallmentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractInstallmentNameQuery, ContractInstallmentNameQueryVariables>(
		ContractInstallmentNameDocument,
		options,
	);
}
export type ContractInstallmentNameQueryHookResult = ReturnType<typeof useContractInstallmentNameQuery>;
export type ContractInstallmentNameLazyQueryHookResult = ReturnType<typeof useContractInstallmentNameLazyQuery>;
export type ContractInstallmentNameSuspenseQueryHookResult = ReturnType<typeof useContractInstallmentNameSuspenseQuery>;
export type ContractInstallmentNameQueryResult = Apollo.QueryResult<
	ContractInstallmentNameQuery,
	ContractInstallmentNameQueryVariables
>;
export const ContractInstallmentNamesDocument = gql`
	query contractInstallmentNames(
		$filters: [ContractInstallmentFilterInput!]
		$pagination: Pagination
		$order: ContractInstallmentOrder
	) {
		contractInstallmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...ContractInstallmentName
				}
			}
		}
	}
	${ContractInstallmentNameFragmentDoc}
`;

/**
 * __useContractInstallmentNamesQuery__
 *
 * To run a query within a React component, call `useContractInstallmentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractInstallmentNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractInstallmentNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useContractInstallmentNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<ContractInstallmentNamesQuery, ContractInstallmentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractInstallmentNamesQuery, ContractInstallmentNamesQueryVariables>(
		ContractInstallmentNamesDocument,
		options,
	);
}
export function useContractInstallmentNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractInstallmentNamesQuery, ContractInstallmentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractInstallmentNamesQuery, ContractInstallmentNamesQueryVariables>(
		ContractInstallmentNamesDocument,
		options,
	);
}
export function useContractInstallmentNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractInstallmentNamesQuery, ContractInstallmentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractInstallmentNamesQuery, ContractInstallmentNamesQueryVariables>(
		ContractInstallmentNamesDocument,
		options,
	);
}
export type ContractInstallmentNamesQueryHookResult = ReturnType<typeof useContractInstallmentNamesQuery>;
export type ContractInstallmentNamesLazyQueryHookResult = ReturnType<typeof useContractInstallmentNamesLazyQuery>;
export type ContractInstallmentNamesSuspenseQueryHookResult = ReturnType<
	typeof useContractInstallmentNamesSuspenseQuery
>;
export type ContractInstallmentNamesQueryResult = Apollo.QueryResult<
	ContractInstallmentNamesQuery,
	ContractInstallmentNamesQueryVariables
>;
export const ContractInstallmentPaginationDocument = gql`
	query contractInstallmentPagination($filters: [ContractInstallmentFilterInput!], $order: ContractInstallmentOrder) {
		contractInstallmentConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useContractInstallmentPaginationQuery__
 *
 * To run a query within a React component, call `useContractInstallmentPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractInstallmentPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractInstallmentPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useContractInstallmentPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ContractInstallmentPaginationQuery,
		ContractInstallmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractInstallmentPaginationQuery, ContractInstallmentPaginationQueryVariables>(
		ContractInstallmentPaginationDocument,
		options,
	);
}
export function useContractInstallmentPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ContractInstallmentPaginationQuery,
		ContractInstallmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractInstallmentPaginationQuery, ContractInstallmentPaginationQueryVariables>(
		ContractInstallmentPaginationDocument,
		options,
	);
}
export function useContractInstallmentPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ContractInstallmentPaginationQuery,
		ContractInstallmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractInstallmentPaginationQuery, ContractInstallmentPaginationQueryVariables>(
		ContractInstallmentPaginationDocument,
		options,
	);
}
export type ContractInstallmentPaginationQueryHookResult = ReturnType<typeof useContractInstallmentPaginationQuery>;
export type ContractInstallmentPaginationLazyQueryHookResult = ReturnType<
	typeof useContractInstallmentPaginationLazyQuery
>;
export type ContractInstallmentPaginationSuspenseQueryHookResult = ReturnType<
	typeof useContractInstallmentPaginationSuspenseQuery
>;
export type ContractInstallmentPaginationQueryResult = Apollo.QueryResult<
	ContractInstallmentPaginationQuery,
	ContractInstallmentPaginationQueryVariables
>;
export const ContractInstallmentSelectDocument = gql`
	query contractInstallmentSelect($filters: [ContractInstallmentFilterInput!], $order: ContractInstallmentOrder) {
		contractInstallmentConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...ContractInstallmentName
				}
			}
		}
	}
	${ContractInstallmentNameFragmentDoc}
`;

/**
 * __useContractInstallmentSelectQuery__
 *
 * To run a query within a React component, call `useContractInstallmentSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractInstallmentSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractInstallmentSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useContractInstallmentSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<ContractInstallmentSelectQuery, ContractInstallmentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractInstallmentSelectQuery, ContractInstallmentSelectQueryVariables>(
		ContractInstallmentSelectDocument,
		options,
	);
}
export function useContractInstallmentSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractInstallmentSelectQuery, ContractInstallmentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractInstallmentSelectQuery, ContractInstallmentSelectQueryVariables>(
		ContractInstallmentSelectDocument,
		options,
	);
}
export function useContractInstallmentSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ContractInstallmentSelectQuery,
		ContractInstallmentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractInstallmentSelectQuery, ContractInstallmentSelectQueryVariables>(
		ContractInstallmentSelectDocument,
		options,
	);
}
export type ContractInstallmentSelectQueryHookResult = ReturnType<typeof useContractInstallmentSelectQuery>;
export type ContractInstallmentSelectLazyQueryHookResult = ReturnType<typeof useContractInstallmentSelectLazyQuery>;
export type ContractInstallmentSelectSuspenseQueryHookResult = ReturnType<
	typeof useContractInstallmentSelectSuspenseQuery
>;
export type ContractInstallmentSelectQueryResult = Apollo.QueryResult<
	ContractInstallmentSelectQuery,
	ContractInstallmentSelectQueryVariables
>;
export const ContractInstallmentUpdateDocument = gql`
	mutation contractInstallmentUpdate($id: ID!, $input: ContractInstallmentUpdateInput!) {
		updateContractInstallment(id: $id, input: $input) {
			...ContractInstallmentDetail
		}
	}
	${ContractInstallmentDetailFragmentDoc}
`;
export type ContractInstallmentUpdateMutationFn = Apollo.MutationFunction<
	ContractInstallmentUpdateMutation,
	ContractInstallmentUpdateMutationVariables
>;

/**
 * __useContractInstallmentUpdateMutation__
 *
 * To run a mutation, you first call `useContractInstallmentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractInstallmentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractInstallmentUpdateMutation, { data, loading, error }] = useContractInstallmentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContractInstallmentUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ContractInstallmentUpdateMutation,
		ContractInstallmentUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ContractInstallmentUpdateMutation, ContractInstallmentUpdateMutationVariables>(
		ContractInstallmentUpdateDocument,
		options,
	);
}
export type ContractInstallmentUpdateMutationHookResult = ReturnType<typeof useContractInstallmentUpdateMutation>;
export type ContractInstallmentUpdateMutationResult = Apollo.MutationResult<ContractInstallmentUpdateMutation>;
export type ContractInstallmentUpdateMutationOptions = Apollo.BaseMutationOptions<
	ContractInstallmentUpdateMutation,
	ContractInstallmentUpdateMutationVariables
>;
export const ContractLineItemCountDocument = gql`
	query contractLineItemCount(
		$filters: [ContractLineItemFilterInput!]
		$pagination: Pagination
		$order: ContractLineItemOrder
	) {
		contractLineItemConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useContractLineItemCountQuery__
 *
 * To run a query within a React component, call `useContractLineItemCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractLineItemCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractLineItemCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useContractLineItemCountQuery(
	baseOptions?: Apollo.QueryHookOptions<ContractLineItemCountQuery, ContractLineItemCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractLineItemCountQuery, ContractLineItemCountQueryVariables>(
		ContractLineItemCountDocument,
		options,
	);
}
export function useContractLineItemCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractLineItemCountQuery, ContractLineItemCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractLineItemCountQuery, ContractLineItemCountQueryVariables>(
		ContractLineItemCountDocument,
		options,
	);
}
export function useContractLineItemCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractLineItemCountQuery, ContractLineItemCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractLineItemCountQuery, ContractLineItemCountQueryVariables>(
		ContractLineItemCountDocument,
		options,
	);
}
export type ContractLineItemCountQueryHookResult = ReturnType<typeof useContractLineItemCountQuery>;
export type ContractLineItemCountLazyQueryHookResult = ReturnType<typeof useContractLineItemCountLazyQuery>;
export type ContractLineItemCountSuspenseQueryHookResult = ReturnType<typeof useContractLineItemCountSuspenseQuery>;
export type ContractLineItemCountQueryResult = Apollo.QueryResult<
	ContractLineItemCountQuery,
	ContractLineItemCountQueryVariables
>;
export const ContractLineItemCreateDocument = gql`
	mutation contractLineItemCreate($input: ContractLineItemCreateInput!) {
		createContractLineItem(input: $input) {
			...ContractLineItemDetail
		}
	}
	${ContractLineItemDetailFragmentDoc}
`;
export type ContractLineItemCreateMutationFn = Apollo.MutationFunction<
	ContractLineItemCreateMutation,
	ContractLineItemCreateMutationVariables
>;

/**
 * __useContractLineItemCreateMutation__
 *
 * To run a mutation, you first call `useContractLineItemCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractLineItemCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractLineItemCreateMutation, { data, loading, error }] = useContractLineItemCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContractLineItemCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<ContractLineItemCreateMutation, ContractLineItemCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ContractLineItemCreateMutation, ContractLineItemCreateMutationVariables>(
		ContractLineItemCreateDocument,
		options,
	);
}
export type ContractLineItemCreateMutationHookResult = ReturnType<typeof useContractLineItemCreateMutation>;
export type ContractLineItemCreateMutationResult = Apollo.MutationResult<ContractLineItemCreateMutation>;
export type ContractLineItemCreateMutationOptions = Apollo.BaseMutationOptions<
	ContractLineItemCreateMutation,
	ContractLineItemCreateMutationVariables
>;
export const ContractLineItemDeleteDocument = gql`
	mutation contractLineItemDelete($id: ID!) {
		deleteContractLineItem(id: $id)
	}
`;
export type ContractLineItemDeleteMutationFn = Apollo.MutationFunction<
	ContractLineItemDeleteMutation,
	ContractLineItemDeleteMutationVariables
>;

/**
 * __useContractLineItemDeleteMutation__
 *
 * To run a mutation, you first call `useContractLineItemDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractLineItemDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractLineItemDeleteMutation, { data, loading, error }] = useContractLineItemDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractLineItemDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<ContractLineItemDeleteMutation, ContractLineItemDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ContractLineItemDeleteMutation, ContractLineItemDeleteMutationVariables>(
		ContractLineItemDeleteDocument,
		options,
	);
}
export type ContractLineItemDeleteMutationHookResult = ReturnType<typeof useContractLineItemDeleteMutation>;
export type ContractLineItemDeleteMutationResult = Apollo.MutationResult<ContractLineItemDeleteMutation>;
export type ContractLineItemDeleteMutationOptions = Apollo.BaseMutationOptions<
	ContractLineItemDeleteMutation,
	ContractLineItemDeleteMutationVariables
>;
export const ContractLineItemDetailDocument = gql`
	query contractLineItemDetail($id: ID!) {
		contractLineItem(id: $id) {
			...ContractLineItemDetail
		}
	}
	${ContractLineItemDetailFragmentDoc}
`;

/**
 * __useContractLineItemDetailQuery__
 *
 * To run a query within a React component, call `useContractLineItemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractLineItemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractLineItemDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractLineItemDetailQuery(
	baseOptions: Apollo.QueryHookOptions<ContractLineItemDetailQuery, ContractLineItemDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractLineItemDetailQuery, ContractLineItemDetailQueryVariables>(
		ContractLineItemDetailDocument,
		options,
	);
}
export function useContractLineItemDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractLineItemDetailQuery, ContractLineItemDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractLineItemDetailQuery, ContractLineItemDetailQueryVariables>(
		ContractLineItemDetailDocument,
		options,
	);
}
export function useContractLineItemDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractLineItemDetailQuery, ContractLineItemDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractLineItemDetailQuery, ContractLineItemDetailQueryVariables>(
		ContractLineItemDetailDocument,
		options,
	);
}
export type ContractLineItemDetailQueryHookResult = ReturnType<typeof useContractLineItemDetailQuery>;
export type ContractLineItemDetailLazyQueryHookResult = ReturnType<typeof useContractLineItemDetailLazyQuery>;
export type ContractLineItemDetailSuspenseQueryHookResult = ReturnType<typeof useContractLineItemDetailSuspenseQuery>;
export type ContractLineItemDetailQueryResult = Apollo.QueryResult<
	ContractLineItemDetailQuery,
	ContractLineItemDetailQueryVariables
>;
export const ContractLineItemIndexDocument = gql`
	query contractLineItemIndex(
		$filters: [ContractLineItemFilterInput!]
		$pagination: Pagination
		$order: ContractLineItemOrder
	) {
		contractLineItemConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					displayOrder
					description
					isDiscount
					amount
					dateAdded
					dateRemoved
				}
			}
		}
	}
`;

/**
 * __useContractLineItemIndexQuery__
 *
 * To run a query within a React component, call `useContractLineItemIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractLineItemIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractLineItemIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useContractLineItemIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<ContractLineItemIndexQuery, ContractLineItemIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractLineItemIndexQuery, ContractLineItemIndexQueryVariables>(
		ContractLineItemIndexDocument,
		options,
	);
}
export function useContractLineItemIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractLineItemIndexQuery, ContractLineItemIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractLineItemIndexQuery, ContractLineItemIndexQueryVariables>(
		ContractLineItemIndexDocument,
		options,
	);
}
export function useContractLineItemIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractLineItemIndexQuery, ContractLineItemIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractLineItemIndexQuery, ContractLineItemIndexQueryVariables>(
		ContractLineItemIndexDocument,
		options,
	);
}
export type ContractLineItemIndexQueryHookResult = ReturnType<typeof useContractLineItemIndexQuery>;
export type ContractLineItemIndexLazyQueryHookResult = ReturnType<typeof useContractLineItemIndexLazyQuery>;
export type ContractLineItemIndexSuspenseQueryHookResult = ReturnType<typeof useContractLineItemIndexSuspenseQuery>;
export type ContractLineItemIndexQueryResult = Apollo.QueryResult<
	ContractLineItemIndexQuery,
	ContractLineItemIndexQueryVariables
>;
export const ChildContractLineItemListDocument = gql`
	query childContractLineItemList(
		$filters: [ContractLineItemFilterInput!]
		$pagination: Pagination
		$order: ContractLineItemOrder
	) {
		contractLineItemConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...ContractLineItemName
					displayOrder
					isDiscount
					amount
				}
			}
		}
	}
	${ContractLineItemNameFragmentDoc}
`;

/**
 * __useChildContractLineItemListQuery__
 *
 * To run a query within a React component, call `useChildContractLineItemListQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildContractLineItemListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChildContractLineItemListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useChildContractLineItemListQuery(
	baseOptions?: Apollo.QueryHookOptions<ChildContractLineItemListQuery, ChildContractLineItemListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ChildContractLineItemListQuery, ChildContractLineItemListQueryVariables>(
		ChildContractLineItemListDocument,
		options,
	);
}
export function useChildContractLineItemListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ChildContractLineItemListQuery, ChildContractLineItemListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ChildContractLineItemListQuery, ChildContractLineItemListQueryVariables>(
		ChildContractLineItemListDocument,
		options,
	);
}
export function useChildContractLineItemListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ChildContractLineItemListQuery,
		ChildContractLineItemListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ChildContractLineItemListQuery, ChildContractLineItemListQueryVariables>(
		ChildContractLineItemListDocument,
		options,
	);
}
export type ChildContractLineItemListQueryHookResult = ReturnType<typeof useChildContractLineItemListQuery>;
export type ChildContractLineItemListLazyQueryHookResult = ReturnType<typeof useChildContractLineItemListLazyQuery>;
export type ChildContractLineItemListSuspenseQueryHookResult = ReturnType<
	typeof useChildContractLineItemListSuspenseQuery
>;
export type ChildContractLineItemListQueryResult = Apollo.QueryResult<
	ChildContractLineItemListQuery,
	ChildContractLineItemListQueryVariables
>;
export const ContractLineItemNameDocument = gql`
	query contractLineItemName($id: ID!) {
		contractLineItem(id: $id) {
			id
			...ContractLineItemName
		}
	}
	${ContractLineItemNameFragmentDoc}
`;

/**
 * __useContractLineItemNameQuery__
 *
 * To run a query within a React component, call `useContractLineItemNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractLineItemNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractLineItemNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractLineItemNameQuery(
	baseOptions: Apollo.QueryHookOptions<ContractLineItemNameQuery, ContractLineItemNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractLineItemNameQuery, ContractLineItemNameQueryVariables>(
		ContractLineItemNameDocument,
		options,
	);
}
export function useContractLineItemNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractLineItemNameQuery, ContractLineItemNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractLineItemNameQuery, ContractLineItemNameQueryVariables>(
		ContractLineItemNameDocument,
		options,
	);
}
export function useContractLineItemNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractLineItemNameQuery, ContractLineItemNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractLineItemNameQuery, ContractLineItemNameQueryVariables>(
		ContractLineItemNameDocument,
		options,
	);
}
export type ContractLineItemNameQueryHookResult = ReturnType<typeof useContractLineItemNameQuery>;
export type ContractLineItemNameLazyQueryHookResult = ReturnType<typeof useContractLineItemNameLazyQuery>;
export type ContractLineItemNameSuspenseQueryHookResult = ReturnType<typeof useContractLineItemNameSuspenseQuery>;
export type ContractLineItemNameQueryResult = Apollo.QueryResult<
	ContractLineItemNameQuery,
	ContractLineItemNameQueryVariables
>;
export const ContractLineItemNamesDocument = gql`
	query contractLineItemNames(
		$filters: [ContractLineItemFilterInput!]
		$pagination: Pagination
		$order: ContractLineItemOrder
	) {
		contractLineItemConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...ContractLineItemName
				}
			}
		}
	}
	${ContractLineItemNameFragmentDoc}
`;

/**
 * __useContractLineItemNamesQuery__
 *
 * To run a query within a React component, call `useContractLineItemNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractLineItemNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractLineItemNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useContractLineItemNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<ContractLineItemNamesQuery, ContractLineItemNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractLineItemNamesQuery, ContractLineItemNamesQueryVariables>(
		ContractLineItemNamesDocument,
		options,
	);
}
export function useContractLineItemNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractLineItemNamesQuery, ContractLineItemNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractLineItemNamesQuery, ContractLineItemNamesQueryVariables>(
		ContractLineItemNamesDocument,
		options,
	);
}
export function useContractLineItemNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractLineItemNamesQuery, ContractLineItemNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractLineItemNamesQuery, ContractLineItemNamesQueryVariables>(
		ContractLineItemNamesDocument,
		options,
	);
}
export type ContractLineItemNamesQueryHookResult = ReturnType<typeof useContractLineItemNamesQuery>;
export type ContractLineItemNamesLazyQueryHookResult = ReturnType<typeof useContractLineItemNamesLazyQuery>;
export type ContractLineItemNamesSuspenseQueryHookResult = ReturnType<typeof useContractLineItemNamesSuspenseQuery>;
export type ContractLineItemNamesQueryResult = Apollo.QueryResult<
	ContractLineItemNamesQuery,
	ContractLineItemNamesQueryVariables
>;
export const ContractLineItemPaginationDocument = gql`
	query contractLineItemPagination($filters: [ContractLineItemFilterInput!], $order: ContractLineItemOrder) {
		contractLineItemConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useContractLineItemPaginationQuery__
 *
 * To run a query within a React component, call `useContractLineItemPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractLineItemPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractLineItemPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useContractLineItemPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<ContractLineItemPaginationQuery, ContractLineItemPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractLineItemPaginationQuery, ContractLineItemPaginationQueryVariables>(
		ContractLineItemPaginationDocument,
		options,
	);
}
export function useContractLineItemPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractLineItemPaginationQuery, ContractLineItemPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractLineItemPaginationQuery, ContractLineItemPaginationQueryVariables>(
		ContractLineItemPaginationDocument,
		options,
	);
}
export function useContractLineItemPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ContractLineItemPaginationQuery,
		ContractLineItemPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractLineItemPaginationQuery, ContractLineItemPaginationQueryVariables>(
		ContractLineItemPaginationDocument,
		options,
	);
}
export type ContractLineItemPaginationQueryHookResult = ReturnType<typeof useContractLineItemPaginationQuery>;
export type ContractLineItemPaginationLazyQueryHookResult = ReturnType<typeof useContractLineItemPaginationLazyQuery>;
export type ContractLineItemPaginationSuspenseQueryHookResult = ReturnType<
	typeof useContractLineItemPaginationSuspenseQuery
>;
export type ContractLineItemPaginationQueryResult = Apollo.QueryResult<
	ContractLineItemPaginationQuery,
	ContractLineItemPaginationQueryVariables
>;
export const ContractLineItemSelectDocument = gql`
	query contractLineItemSelect($filters: [ContractLineItemFilterInput!], $order: ContractLineItemOrder) {
		contractLineItemConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...ContractLineItemName
				}
			}
		}
	}
	${ContractLineItemNameFragmentDoc}
`;

/**
 * __useContractLineItemSelectQuery__
 *
 * To run a query within a React component, call `useContractLineItemSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractLineItemSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractLineItemSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useContractLineItemSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<ContractLineItemSelectQuery, ContractLineItemSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContractLineItemSelectQuery, ContractLineItemSelectQueryVariables>(
		ContractLineItemSelectDocument,
		options,
	);
}
export function useContractLineItemSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ContractLineItemSelectQuery, ContractLineItemSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContractLineItemSelectQuery, ContractLineItemSelectQueryVariables>(
		ContractLineItemSelectDocument,
		options,
	);
}
export function useContractLineItemSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ContractLineItemSelectQuery, ContractLineItemSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContractLineItemSelectQuery, ContractLineItemSelectQueryVariables>(
		ContractLineItemSelectDocument,
		options,
	);
}
export type ContractLineItemSelectQueryHookResult = ReturnType<typeof useContractLineItemSelectQuery>;
export type ContractLineItemSelectLazyQueryHookResult = ReturnType<typeof useContractLineItemSelectLazyQuery>;
export type ContractLineItemSelectSuspenseQueryHookResult = ReturnType<typeof useContractLineItemSelectSuspenseQuery>;
export type ContractLineItemSelectQueryResult = Apollo.QueryResult<
	ContractLineItemSelectQuery,
	ContractLineItemSelectQueryVariables
>;
export const ContractLineItemUpdateDocument = gql`
	mutation contractLineItemUpdate($id: ID!, $input: ContractLineItemUpdateInput!) {
		updateContractLineItem(id: $id, input: $input) {
			...ContractLineItemDetail
		}
	}
	${ContractLineItemDetailFragmentDoc}
`;
export type ContractLineItemUpdateMutationFn = Apollo.MutationFunction<
	ContractLineItemUpdateMutation,
	ContractLineItemUpdateMutationVariables
>;

/**
 * __useContractLineItemUpdateMutation__
 *
 * To run a mutation, you first call `useContractLineItemUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractLineItemUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractLineItemUpdateMutation, { data, loading, error }] = useContractLineItemUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContractLineItemUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<ContractLineItemUpdateMutation, ContractLineItemUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ContractLineItemUpdateMutation, ContractLineItemUpdateMutationVariables>(
		ContractLineItemUpdateDocument,
		options,
	);
}
export type ContractLineItemUpdateMutationHookResult = ReturnType<typeof useContractLineItemUpdateMutation>;
export type ContractLineItemUpdateMutationResult = Apollo.MutationResult<ContractLineItemUpdateMutation>;
export type ContractLineItemUpdateMutationOptions = Apollo.BaseMutationOptions<
	ContractLineItemUpdateMutation,
	ContractLineItemUpdateMutationVariables
>;
export const CountryCheckUniqueNameDocument = gql`
	query countryCheckUniqueName($ignoreID: ID, $name: String!) {
		countryConnection(filters: { idNEQ: $ignoreID, nameEQ: $name }) {
			totalCount
		}
	}
`;

/**
 * __useCountryCheckUniqueNameQuery__
 *
 * To run a query within a React component, call `useCountryCheckUniqueNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountryCheckUniqueNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountryCheckUniqueNameQuery({
 *   variables: {
 *      ignoreID: // value for 'ignoreID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCountryCheckUniqueNameQuery(
	baseOptions: Apollo.QueryHookOptions<CountryCheckUniqueNameQuery, CountryCheckUniqueNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CountryCheckUniqueNameQuery, CountryCheckUniqueNameQueryVariables>(
		CountryCheckUniqueNameDocument,
		options,
	);
}
export function useCountryCheckUniqueNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CountryCheckUniqueNameQuery, CountryCheckUniqueNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CountryCheckUniqueNameQuery, CountryCheckUniqueNameQueryVariables>(
		CountryCheckUniqueNameDocument,
		options,
	);
}
export function useCountryCheckUniqueNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CountryCheckUniqueNameQuery, CountryCheckUniqueNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CountryCheckUniqueNameQuery, CountryCheckUniqueNameQueryVariables>(
		CountryCheckUniqueNameDocument,
		options,
	);
}
export type CountryCheckUniqueNameQueryHookResult = ReturnType<typeof useCountryCheckUniqueNameQuery>;
export type CountryCheckUniqueNameLazyQueryHookResult = ReturnType<typeof useCountryCheckUniqueNameLazyQuery>;
export type CountryCheckUniqueNameSuspenseQueryHookResult = ReturnType<typeof useCountryCheckUniqueNameSuspenseQuery>;
export type CountryCheckUniqueNameQueryResult = Apollo.QueryResult<
	CountryCheckUniqueNameQuery,
	CountryCheckUniqueNameQueryVariables
>;
export const CountryCountDocument = gql`
	query countryCount($filters: [CountryFilterInput!], $pagination: Pagination, $order: CountryOrder) {
		countryConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useCountryCountQuery__
 *
 * To run a query within a React component, call `useCountryCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountryCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountryCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCountryCountQuery(
	baseOptions?: Apollo.QueryHookOptions<CountryCountQuery, CountryCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CountryCountQuery, CountryCountQueryVariables>(CountryCountDocument, options);
}
export function useCountryCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CountryCountQuery, CountryCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CountryCountQuery, CountryCountQueryVariables>(CountryCountDocument, options);
}
export function useCountryCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CountryCountQuery, CountryCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CountryCountQuery, CountryCountQueryVariables>(CountryCountDocument, options);
}
export type CountryCountQueryHookResult = ReturnType<typeof useCountryCountQuery>;
export type CountryCountLazyQueryHookResult = ReturnType<typeof useCountryCountLazyQuery>;
export type CountryCountSuspenseQueryHookResult = ReturnType<typeof useCountryCountSuspenseQuery>;
export type CountryCountQueryResult = Apollo.QueryResult<CountryCountQuery, CountryCountQueryVariables>;
export const CountryCreateDocument = gql`
	mutation countryCreate($input: CountryCreateInput!) {
		createCountry(input: $input) {
			...CountryDetail
		}
	}
	${CountryDetailFragmentDoc}
`;
export type CountryCreateMutationFn = Apollo.MutationFunction<CountryCreateMutation, CountryCreateMutationVariables>;

/**
 * __useCountryCreateMutation__
 *
 * To run a mutation, you first call `useCountryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCountryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [countryCreateMutation, { data, loading, error }] = useCountryCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCountryCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<CountryCreateMutation, CountryCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CountryCreateMutation, CountryCreateMutationVariables>(CountryCreateDocument, options);
}
export type CountryCreateMutationHookResult = ReturnType<typeof useCountryCreateMutation>;
export type CountryCreateMutationResult = Apollo.MutationResult<CountryCreateMutation>;
export type CountryCreateMutationOptions = Apollo.BaseMutationOptions<
	CountryCreateMutation,
	CountryCreateMutationVariables
>;
export const CountryDeleteDocument = gql`
	mutation countryDelete($id: ID!) {
		deleteCountry(id: $id)
	}
`;
export type CountryDeleteMutationFn = Apollo.MutationFunction<CountryDeleteMutation, CountryDeleteMutationVariables>;

/**
 * __useCountryDeleteMutation__
 *
 * To run a mutation, you first call `useCountryDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCountryDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [countryDeleteMutation, { data, loading, error }] = useCountryDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCountryDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<CountryDeleteMutation, CountryDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CountryDeleteMutation, CountryDeleteMutationVariables>(CountryDeleteDocument, options);
}
export type CountryDeleteMutationHookResult = ReturnType<typeof useCountryDeleteMutation>;
export type CountryDeleteMutationResult = Apollo.MutationResult<CountryDeleteMutation>;
export type CountryDeleteMutationOptions = Apollo.BaseMutationOptions<
	CountryDeleteMutation,
	CountryDeleteMutationVariables
>;
export const CountryDetailDocument = gql`
	query countryDetail($id: ID!) {
		country(id: $id) {
			...CountryDetail
		}
	}
	${CountryDetailFragmentDoc}
`;

/**
 * __useCountryDetailQuery__
 *
 * To run a query within a React component, call `useCountryDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountryDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountryDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCountryDetailQuery(
	baseOptions: Apollo.QueryHookOptions<CountryDetailQuery, CountryDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CountryDetailQuery, CountryDetailQueryVariables>(CountryDetailDocument, options);
}
export function useCountryDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CountryDetailQuery, CountryDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CountryDetailQuery, CountryDetailQueryVariables>(CountryDetailDocument, options);
}
export function useCountryDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CountryDetailQuery, CountryDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CountryDetailQuery, CountryDetailQueryVariables>(CountryDetailDocument, options);
}
export type CountryDetailQueryHookResult = ReturnType<typeof useCountryDetailQuery>;
export type CountryDetailLazyQueryHookResult = ReturnType<typeof useCountryDetailLazyQuery>;
export type CountryDetailSuspenseQueryHookResult = ReturnType<typeof useCountryDetailSuspenseQuery>;
export type CountryDetailQueryResult = Apollo.QueryResult<CountryDetailQuery, CountryDetailQueryVariables>;
export const CountryIndexDocument = gql`
	query countryIndex($filters: [CountryFilterInput!], $pagination: Pagination, $order: CountryOrder) {
		countryConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
				}
			}
		}
	}
`;

/**
 * __useCountryIndexQuery__
 *
 * To run a query within a React component, call `useCountryIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountryIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountryIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCountryIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<CountryIndexQuery, CountryIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CountryIndexQuery, CountryIndexQueryVariables>(CountryIndexDocument, options);
}
export function useCountryIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CountryIndexQuery, CountryIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CountryIndexQuery, CountryIndexQueryVariables>(CountryIndexDocument, options);
}
export function useCountryIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CountryIndexQuery, CountryIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CountryIndexQuery, CountryIndexQueryVariables>(CountryIndexDocument, options);
}
export type CountryIndexQueryHookResult = ReturnType<typeof useCountryIndexQuery>;
export type CountryIndexLazyQueryHookResult = ReturnType<typeof useCountryIndexLazyQuery>;
export type CountryIndexSuspenseQueryHookResult = ReturnType<typeof useCountryIndexSuspenseQuery>;
export type CountryIndexQueryResult = Apollo.QueryResult<CountryIndexQuery, CountryIndexQueryVariables>;
export const CountryNameDocument = gql`
	query countryName($id: ID!) {
		country(id: $id) {
			id
			...CountryName
		}
	}
	${CountryNameFragmentDoc}
`;

/**
 * __useCountryNameQuery__
 *
 * To run a query within a React component, call `useCountryNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountryNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountryNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCountryNameQuery(baseOptions: Apollo.QueryHookOptions<CountryNameQuery, CountryNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CountryNameQuery, CountryNameQueryVariables>(CountryNameDocument, options);
}
export function useCountryNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CountryNameQuery, CountryNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CountryNameQuery, CountryNameQueryVariables>(CountryNameDocument, options);
}
export function useCountryNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CountryNameQuery, CountryNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CountryNameQuery, CountryNameQueryVariables>(CountryNameDocument, options);
}
export type CountryNameQueryHookResult = ReturnType<typeof useCountryNameQuery>;
export type CountryNameLazyQueryHookResult = ReturnType<typeof useCountryNameLazyQuery>;
export type CountryNameSuspenseQueryHookResult = ReturnType<typeof useCountryNameSuspenseQuery>;
export type CountryNameQueryResult = Apollo.QueryResult<CountryNameQuery, CountryNameQueryVariables>;
export const CountryNamesDocument = gql`
	query countryNames($filters: [CountryFilterInput!], $pagination: Pagination, $order: CountryOrder) {
		countryConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...CountryName
				}
			}
		}
	}
	${CountryNameFragmentDoc}
`;

/**
 * __useCountryNamesQuery__
 *
 * To run a query within a React component, call `useCountryNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountryNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountryNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCountryNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<CountryNamesQuery, CountryNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CountryNamesQuery, CountryNamesQueryVariables>(CountryNamesDocument, options);
}
export function useCountryNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CountryNamesQuery, CountryNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CountryNamesQuery, CountryNamesQueryVariables>(CountryNamesDocument, options);
}
export function useCountryNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CountryNamesQuery, CountryNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CountryNamesQuery, CountryNamesQueryVariables>(CountryNamesDocument, options);
}
export type CountryNamesQueryHookResult = ReturnType<typeof useCountryNamesQuery>;
export type CountryNamesLazyQueryHookResult = ReturnType<typeof useCountryNamesLazyQuery>;
export type CountryNamesSuspenseQueryHookResult = ReturnType<typeof useCountryNamesSuspenseQuery>;
export type CountryNamesQueryResult = Apollo.QueryResult<CountryNamesQuery, CountryNamesQueryVariables>;
export const CountryPaginationDocument = gql`
	query countryPagination($filters: [CountryFilterInput!], $order: CountryOrder) {
		countryConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useCountryPaginationQuery__
 *
 * To run a query within a React component, call `useCountryPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountryPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountryPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCountryPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<CountryPaginationQuery, CountryPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CountryPaginationQuery, CountryPaginationQueryVariables>(CountryPaginationDocument, options);
}
export function useCountryPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CountryPaginationQuery, CountryPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CountryPaginationQuery, CountryPaginationQueryVariables>(
		CountryPaginationDocument,
		options,
	);
}
export function useCountryPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CountryPaginationQuery, CountryPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CountryPaginationQuery, CountryPaginationQueryVariables>(
		CountryPaginationDocument,
		options,
	);
}
export type CountryPaginationQueryHookResult = ReturnType<typeof useCountryPaginationQuery>;
export type CountryPaginationLazyQueryHookResult = ReturnType<typeof useCountryPaginationLazyQuery>;
export type CountryPaginationSuspenseQueryHookResult = ReturnType<typeof useCountryPaginationSuspenseQuery>;
export type CountryPaginationQueryResult = Apollo.QueryResult<CountryPaginationQuery, CountryPaginationQueryVariables>;
export const CountrySelectDocument = gql`
	query countrySelect($filters: [CountryFilterInput!], $order: CountryOrder) {
		countryConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...CountryName
				}
			}
		}
	}
	${CountryNameFragmentDoc}
`;

/**
 * __useCountrySelectQuery__
 *
 * To run a query within a React component, call `useCountrySelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountrySelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountrySelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCountrySelectQuery(
	baseOptions?: Apollo.QueryHookOptions<CountrySelectQuery, CountrySelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CountrySelectQuery, CountrySelectQueryVariables>(CountrySelectDocument, options);
}
export function useCountrySelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CountrySelectQuery, CountrySelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CountrySelectQuery, CountrySelectQueryVariables>(CountrySelectDocument, options);
}
export function useCountrySelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CountrySelectQuery, CountrySelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CountrySelectQuery, CountrySelectQueryVariables>(CountrySelectDocument, options);
}
export type CountrySelectQueryHookResult = ReturnType<typeof useCountrySelectQuery>;
export type CountrySelectLazyQueryHookResult = ReturnType<typeof useCountrySelectLazyQuery>;
export type CountrySelectSuspenseQueryHookResult = ReturnType<typeof useCountrySelectSuspenseQuery>;
export type CountrySelectQueryResult = Apollo.QueryResult<CountrySelectQuery, CountrySelectQueryVariables>;
export const CountryUpdateDocument = gql`
	mutation countryUpdate($id: ID!, $input: CountryUpdateInput!) {
		updateCountry(id: $id, input: $input) {
			...CountryDetail
		}
	}
	${CountryDetailFragmentDoc}
`;
export type CountryUpdateMutationFn = Apollo.MutationFunction<CountryUpdateMutation, CountryUpdateMutationVariables>;

/**
 * __useCountryUpdateMutation__
 *
 * To run a mutation, you first call `useCountryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCountryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [countryUpdateMutation, { data, loading, error }] = useCountryUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCountryUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<CountryUpdateMutation, CountryUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CountryUpdateMutation, CountryUpdateMutationVariables>(CountryUpdateDocument, options);
}
export type CountryUpdateMutationHookResult = ReturnType<typeof useCountryUpdateMutation>;
export type CountryUpdateMutationResult = Apollo.MutationResult<CountryUpdateMutation>;
export type CountryUpdateMutationOptions = Apollo.BaseMutationOptions<
	CountryUpdateMutation,
	CountryUpdateMutationVariables
>;
export const CourseCountDocument = gql`
	query courseCount($filters: [CourseFilterInput!], $pagination: Pagination, $order: CourseOrder) {
		courseConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useCourseCountQuery__
 *
 * To run a query within a React component, call `useCourseCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseCountQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseCountQuery, CourseCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseCountQuery, CourseCountQueryVariables>(CourseCountDocument, options);
}
export function useCourseCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseCountQuery, CourseCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseCountQuery, CourseCountQueryVariables>(CourseCountDocument, options);
}
export function useCourseCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseCountQuery, CourseCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseCountQuery, CourseCountQueryVariables>(CourseCountDocument, options);
}
export type CourseCountQueryHookResult = ReturnType<typeof useCourseCountQuery>;
export type CourseCountLazyQueryHookResult = ReturnType<typeof useCourseCountLazyQuery>;
export type CourseCountSuspenseQueryHookResult = ReturnType<typeof useCourseCountSuspenseQuery>;
export type CourseCountQueryResult = Apollo.QueryResult<CourseCountQuery, CourseCountQueryVariables>;
export const CourseCreateDocument = gql`
	mutation courseCreate($input: CourseCreateInput!) {
		createCourse(input: $input) {
			...CourseDetail
		}
	}
	${CourseDetailFragmentDoc}
`;
export type CourseCreateMutationFn = Apollo.MutationFunction<CourseCreateMutation, CourseCreateMutationVariables>;

/**
 * __useCourseCreateMutation__
 *
 * To run a mutation, you first call `useCourseCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseCreateMutation, { data, loading, error }] = useCourseCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<CourseCreateMutation, CourseCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseCreateMutation, CourseCreateMutationVariables>(CourseCreateDocument, options);
}
export type CourseCreateMutationHookResult = ReturnType<typeof useCourseCreateMutation>;
export type CourseCreateMutationResult = Apollo.MutationResult<CourseCreateMutation>;
export type CourseCreateMutationOptions = Apollo.BaseMutationOptions<
	CourseCreateMutation,
	CourseCreateMutationVariables
>;
export const CourseDeleteDocument = gql`
	mutation courseDelete($id: ID!) {
		deleteCourse(id: $id)
	}
`;
export type CourseDeleteMutationFn = Apollo.MutationFunction<CourseDeleteMutation, CourseDeleteMutationVariables>;

/**
 * __useCourseDeleteMutation__
 *
 * To run a mutation, you first call `useCourseDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseDeleteMutation, { data, loading, error }] = useCourseDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<CourseDeleteMutation, CourseDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseDeleteMutation, CourseDeleteMutationVariables>(CourseDeleteDocument, options);
}
export type CourseDeleteMutationHookResult = ReturnType<typeof useCourseDeleteMutation>;
export type CourseDeleteMutationResult = Apollo.MutationResult<CourseDeleteMutation>;
export type CourseDeleteMutationOptions = Apollo.BaseMutationOptions<
	CourseDeleteMutation,
	CourseDeleteMutationVariables
>;
export const CourseDetailDocument = gql`
	query courseDetail($id: ID!) {
		course(id: $id) {
			...CourseDetail
		}
	}
	${CourseDetailFragmentDoc}
`;

/**
 * __useCourseDetailQuery__
 *
 * To run a query within a React component, call `useCourseDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseDetailQuery(
	baseOptions: Apollo.QueryHookOptions<CourseDetailQuery, CourseDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseDetailQuery, CourseDetailQueryVariables>(CourseDetailDocument, options);
}
export function useCourseDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseDetailQuery, CourseDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseDetailQuery, CourseDetailQueryVariables>(CourseDetailDocument, options);
}
export function useCourseDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseDetailQuery, CourseDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseDetailQuery, CourseDetailQueryVariables>(CourseDetailDocument, options);
}
export type CourseDetailQueryHookResult = ReturnType<typeof useCourseDetailQuery>;
export type CourseDetailLazyQueryHookResult = ReturnType<typeof useCourseDetailLazyQuery>;
export type CourseDetailSuspenseQueryHookResult = ReturnType<typeof useCourseDetailSuspenseQuery>;
export type CourseDetailQueryResult = Apollo.QueryResult<CourseDetailQuery, CourseDetailQueryVariables>;
export const CourseIndexDocument = gql`
	query courseIndex($filters: [CourseFilterInput!], $pagination: Pagination, $order: CourseOrder) {
		courseConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					description
					academicSubject {
						id
						...AcademicSubjectName
					}
					classYears(order: { field: YEARS_FROM_GRADUATION, direction: DESC }) {
						id
						...ClassYearName
					}
				}
			}
		}
	}
	${AcademicSubjectNameFragmentDoc}
	${ClassYearNameFragmentDoc}
`;

/**
 * __useCourseIndexQuery__
 *
 * To run a query within a React component, call `useCourseIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseIndexQuery, CourseIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseIndexQuery, CourseIndexQueryVariables>(CourseIndexDocument, options);
}
export function useCourseIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseIndexQuery, CourseIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseIndexQuery, CourseIndexQueryVariables>(CourseIndexDocument, options);
}
export function useCourseIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseIndexQuery, CourseIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseIndexQuery, CourseIndexQueryVariables>(CourseIndexDocument, options);
}
export type CourseIndexQueryHookResult = ReturnType<typeof useCourseIndexQuery>;
export type CourseIndexLazyQueryHookResult = ReturnType<typeof useCourseIndexLazyQuery>;
export type CourseIndexSuspenseQueryHookResult = ReturnType<typeof useCourseIndexSuspenseQuery>;
export type CourseIndexQueryResult = Apollo.QueryResult<CourseIndexQuery, CourseIndexQueryVariables>;
export const CourseNameDocument = gql`
	query courseName($id: ID!) {
		course(id: $id) {
			id
			...CourseName
		}
	}
	${CourseNameFragmentDoc}
`;

/**
 * __useCourseNameQuery__
 *
 * To run a query within a React component, call `useCourseNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseNameQuery(baseOptions: Apollo.QueryHookOptions<CourseNameQuery, CourseNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseNameQuery, CourseNameQueryVariables>(CourseNameDocument, options);
}
export function useCourseNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseNameQuery, CourseNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseNameQuery, CourseNameQueryVariables>(CourseNameDocument, options);
}
export function useCourseNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseNameQuery, CourseNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseNameQuery, CourseNameQueryVariables>(CourseNameDocument, options);
}
export type CourseNameQueryHookResult = ReturnType<typeof useCourseNameQuery>;
export type CourseNameLazyQueryHookResult = ReturnType<typeof useCourseNameLazyQuery>;
export type CourseNameSuspenseQueryHookResult = ReturnType<typeof useCourseNameSuspenseQuery>;
export type CourseNameQueryResult = Apollo.QueryResult<CourseNameQuery, CourseNameQueryVariables>;
export const CourseNamesDocument = gql`
	query courseNames($filters: [CourseFilterInput!], $pagination: Pagination, $order: CourseOrder) {
		courseConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...CourseName
				}
			}
		}
	}
	${CourseNameFragmentDoc}
`;

/**
 * __useCourseNamesQuery__
 *
 * To run a query within a React component, call `useCourseNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseNamesQuery, CourseNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseNamesQuery, CourseNamesQueryVariables>(CourseNamesDocument, options);
}
export function useCourseNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseNamesQuery, CourseNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseNamesQuery, CourseNamesQueryVariables>(CourseNamesDocument, options);
}
export function useCourseNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseNamesQuery, CourseNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseNamesQuery, CourseNamesQueryVariables>(CourseNamesDocument, options);
}
export type CourseNamesQueryHookResult = ReturnType<typeof useCourseNamesQuery>;
export type CourseNamesLazyQueryHookResult = ReturnType<typeof useCourseNamesLazyQuery>;
export type CourseNamesSuspenseQueryHookResult = ReturnType<typeof useCourseNamesSuspenseQuery>;
export type CourseNamesQueryResult = Apollo.QueryResult<CourseNamesQuery, CourseNamesQueryVariables>;
export const CoursePaginationDocument = gql`
	query coursePagination($filters: [CourseFilterInput!], $order: CourseOrder) {
		courseConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useCoursePaginationQuery__
 *
 * To run a query within a React component, call `useCoursePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoursePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoursePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCoursePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<CoursePaginationQuery, CoursePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CoursePaginationQuery, CoursePaginationQueryVariables>(CoursePaginationDocument, options);
}
export function useCoursePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CoursePaginationQuery, CoursePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CoursePaginationQuery, CoursePaginationQueryVariables>(CoursePaginationDocument, options);
}
export function useCoursePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CoursePaginationQuery, CoursePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CoursePaginationQuery, CoursePaginationQueryVariables>(
		CoursePaginationDocument,
		options,
	);
}
export type CoursePaginationQueryHookResult = ReturnType<typeof useCoursePaginationQuery>;
export type CoursePaginationLazyQueryHookResult = ReturnType<typeof useCoursePaginationLazyQuery>;
export type CoursePaginationSuspenseQueryHookResult = ReturnType<typeof useCoursePaginationSuspenseQuery>;
export type CoursePaginationQueryResult = Apollo.QueryResult<CoursePaginationQuery, CoursePaginationQueryVariables>;
export const CourseSelectDocument = gql`
	query courseSelect($filters: [CourseFilterInput!], $order: CourseOrder) {
		courseConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...CourseName
				}
			}
		}
	}
	${CourseNameFragmentDoc}
`;

/**
 * __useCourseSelectQuery__
 *
 * To run a query within a React component, call `useCourseSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseSelectQuery, CourseSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSelectQuery, CourseSelectQueryVariables>(CourseSelectDocument, options);
}
export function useCourseSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseSelectQuery, CourseSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSelectQuery, CourseSelectQueryVariables>(CourseSelectDocument, options);
}
export function useCourseSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseSelectQuery, CourseSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSelectQuery, CourseSelectQueryVariables>(CourseSelectDocument, options);
}
export type CourseSelectQueryHookResult = ReturnType<typeof useCourseSelectQuery>;
export type CourseSelectLazyQueryHookResult = ReturnType<typeof useCourseSelectLazyQuery>;
export type CourseSelectSuspenseQueryHookResult = ReturnType<typeof useCourseSelectSuspenseQuery>;
export type CourseSelectQueryResult = Apollo.QueryResult<CourseSelectQuery, CourseSelectQueryVariables>;
export const CourseUpdateDocument = gql`
	mutation courseUpdate($id: ID!, $input: CourseUpdateInput!) {
		updateCourse(id: $id, input: $input) {
			...CourseDetail
		}
	}
	${CourseDetailFragmentDoc}
`;
export type CourseUpdateMutationFn = Apollo.MutationFunction<CourseUpdateMutation, CourseUpdateMutationVariables>;

/**
 * __useCourseUpdateMutation__
 *
 * To run a mutation, you first call `useCourseUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseUpdateMutation, { data, loading, error }] = useCourseUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<CourseUpdateMutation, CourseUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseUpdateMutation, CourseUpdateMutationVariables>(CourseUpdateDocument, options);
}
export type CourseUpdateMutationHookResult = ReturnType<typeof useCourseUpdateMutation>;
export type CourseUpdateMutationResult = Apollo.MutationResult<CourseUpdateMutation>;
export type CourseUpdateMutationOptions = Apollo.BaseMutationOptions<
	CourseUpdateMutation,
	CourseUpdateMutationVariables
>;
export const CourseAssessmentCountDocument = gql`
	query courseAssessmentCount(
		$filters: [CourseAssessmentFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentOrder
	) {
		courseAssessmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useCourseAssessmentCountQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentCountQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseAssessmentCountQuery, CourseAssessmentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentCountQuery, CourseAssessmentCountQueryVariables>(
		CourseAssessmentCountDocument,
		options,
	);
}
export function useCourseAssessmentCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseAssessmentCountQuery, CourseAssessmentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentCountQuery, CourseAssessmentCountQueryVariables>(
		CourseAssessmentCountDocument,
		options,
	);
}
export function useCourseAssessmentCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseAssessmentCountQuery, CourseAssessmentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentCountQuery, CourseAssessmentCountQueryVariables>(
		CourseAssessmentCountDocument,
		options,
	);
}
export type CourseAssessmentCountQueryHookResult = ReturnType<typeof useCourseAssessmentCountQuery>;
export type CourseAssessmentCountLazyQueryHookResult = ReturnType<typeof useCourseAssessmentCountLazyQuery>;
export type CourseAssessmentCountSuspenseQueryHookResult = ReturnType<typeof useCourseAssessmentCountSuspenseQuery>;
export type CourseAssessmentCountQueryResult = Apollo.QueryResult<
	CourseAssessmentCountQuery,
	CourseAssessmentCountQueryVariables
>;
export const CourseAssessmentCreateDocument = gql`
	mutation courseAssessmentCreate($input: CourseAssessmentCreateInput!) {
		createCourseAssessment(input: $input) {
			...CourseAssessmentDetail
		}
	}
	${CourseAssessmentDetailFragmentDoc}
`;
export type CourseAssessmentCreateMutationFn = Apollo.MutationFunction<
	CourseAssessmentCreateMutation,
	CourseAssessmentCreateMutationVariables
>;

/**
 * __useCourseAssessmentCreateMutation__
 *
 * To run a mutation, you first call `useCourseAssessmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAssessmentCreateMutation, { data, loading, error }] = useCourseAssessmentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseAssessmentCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<CourseAssessmentCreateMutation, CourseAssessmentCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseAssessmentCreateMutation, CourseAssessmentCreateMutationVariables>(
		CourseAssessmentCreateDocument,
		options,
	);
}
export type CourseAssessmentCreateMutationHookResult = ReturnType<typeof useCourseAssessmentCreateMutation>;
export type CourseAssessmentCreateMutationResult = Apollo.MutationResult<CourseAssessmentCreateMutation>;
export type CourseAssessmentCreateMutationOptions = Apollo.BaseMutationOptions<
	CourseAssessmentCreateMutation,
	CourseAssessmentCreateMutationVariables
>;
export const CourseAssessmentDeleteDocument = gql`
	mutation courseAssessmentDelete($id: ID!) {
		deleteCourseAssessment(id: $id)
	}
`;
export type CourseAssessmentDeleteMutationFn = Apollo.MutationFunction<
	CourseAssessmentDeleteMutation,
	CourseAssessmentDeleteMutationVariables
>;

/**
 * __useCourseAssessmentDeleteMutation__
 *
 * To run a mutation, you first call `useCourseAssessmentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAssessmentDeleteMutation, { data, loading, error }] = useCourseAssessmentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAssessmentDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<CourseAssessmentDeleteMutation, CourseAssessmentDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseAssessmentDeleteMutation, CourseAssessmentDeleteMutationVariables>(
		CourseAssessmentDeleteDocument,
		options,
	);
}
export type CourseAssessmentDeleteMutationHookResult = ReturnType<typeof useCourseAssessmentDeleteMutation>;
export type CourseAssessmentDeleteMutationResult = Apollo.MutationResult<CourseAssessmentDeleteMutation>;
export type CourseAssessmentDeleteMutationOptions = Apollo.BaseMutationOptions<
	CourseAssessmentDeleteMutation,
	CourseAssessmentDeleteMutationVariables
>;
export const CourseAssessmentDetailDocument = gql`
	query courseAssessmentDetail($id: ID!) {
		courseAssessment(id: $id) {
			...CourseAssessmentDetail
		}
	}
	${CourseAssessmentDetailFragmentDoc}
`;

/**
 * __useCourseAssessmentDetailQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAssessmentDetailQuery(
	baseOptions: Apollo.QueryHookOptions<CourseAssessmentDetailQuery, CourseAssessmentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentDetailQuery, CourseAssessmentDetailQueryVariables>(
		CourseAssessmentDetailDocument,
		options,
	);
}
export function useCourseAssessmentDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseAssessmentDetailQuery, CourseAssessmentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentDetailQuery, CourseAssessmentDetailQueryVariables>(
		CourseAssessmentDetailDocument,
		options,
	);
}
export function useCourseAssessmentDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseAssessmentDetailQuery, CourseAssessmentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentDetailQuery, CourseAssessmentDetailQueryVariables>(
		CourseAssessmentDetailDocument,
		options,
	);
}
export type CourseAssessmentDetailQueryHookResult = ReturnType<typeof useCourseAssessmentDetailQuery>;
export type CourseAssessmentDetailLazyQueryHookResult = ReturnType<typeof useCourseAssessmentDetailLazyQuery>;
export type CourseAssessmentDetailSuspenseQueryHookResult = ReturnType<typeof useCourseAssessmentDetailSuspenseQuery>;
export type CourseAssessmentDetailQueryResult = Apollo.QueryResult<
	CourseAssessmentDetailQuery,
	CourseAssessmentDetailQueryVariables
>;
export const CourseSectionGradeBookDocument = gql`
	query courseSectionGradeBook(
		$courseSectionID: ID!
		$filters: [CourseAssessmentTimingFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentTimingOrder
	) {
		courseAssessmentTimingConnection(
			filters: { courseSectionIDEQ: $courseSectionID, or: $filters }
			pagination: $pagination
			order: $order
		) {
			edges {
				node {
					id
					dueOn
					courseAssessment {
						id
						...CourseAssessmentName
						totalPoints
						courseAssessmentSubmissions(
							filters: { student: { studentCourseSectionEnrollments: { courseSectionIDEQ: $courseSectionID } } }
						) {
							id
							studentID
						}
						courseAssessmentMarks(
							filters: { student: { studentCourseSectionEnrollments: { courseSectionIDEQ: $courseSectionID } } }
						) {
							id
							studentID
							points
							wasLate
							isExcused
						}
					}
				}
			}
		}
	}
	${CourseAssessmentNameFragmentDoc}
`;

/**
 * __useCourseSectionGradeBookQuery__
 *
 * To run a query within a React component, call `useCourseSectionGradeBookQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionGradeBookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionGradeBookQuery({
 *   variables: {
 *      courseSectionID: // value for 'courseSectionID'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionGradeBookQuery(
	baseOptions: Apollo.QueryHookOptions<CourseSectionGradeBookQuery, CourseSectionGradeBookQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionGradeBookQuery, CourseSectionGradeBookQueryVariables>(
		CourseSectionGradeBookDocument,
		options,
	);
}
export function useCourseSectionGradeBookLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseSectionGradeBookQuery, CourseSectionGradeBookQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionGradeBookQuery, CourseSectionGradeBookQueryVariables>(
		CourseSectionGradeBookDocument,
		options,
	);
}
export function useCourseSectionGradeBookSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseSectionGradeBookQuery, CourseSectionGradeBookQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionGradeBookQuery, CourseSectionGradeBookQueryVariables>(
		CourseSectionGradeBookDocument,
		options,
	);
}
export type CourseSectionGradeBookQueryHookResult = ReturnType<typeof useCourseSectionGradeBookQuery>;
export type CourseSectionGradeBookLazyQueryHookResult = ReturnType<typeof useCourseSectionGradeBookLazyQuery>;
export type CourseSectionGradeBookSuspenseQueryHookResult = ReturnType<typeof useCourseSectionGradeBookSuspenseQuery>;
export type CourseSectionGradeBookQueryResult = Apollo.QueryResult<
	CourseSectionGradeBookQuery,
	CourseSectionGradeBookQueryVariables
>;
export const StudentCourseSectionGradeBookDocument = gql`
	query studentCourseSectionGradeBook(
		$studentID: ID!
		$courseSectionID: ID!
		$filters: [CourseAssessmentTimingFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentTimingOrder
	) {
		courseAssessmentTimingConnection(
			filters: { courseSectionIDEQ: $courseSectionID, or: $filters }
			pagination: $pagination
			order: $order
		) {
			edges {
				node {
					id
					dueOn
					courseAssessment {
						id
						...CourseAssessmentName
						totalPoints
						courseAssessmentSubmissions(
							filters: {
								student: { idEQ: $studentID, studentCourseSectionEnrollments: { courseSectionIDEQ: $courseSectionID } }
							}
						) {
							id
							studentID
							submissionDate
							mediaAttachments {
								id
								isFile
								fileContentType
							}
						}
						courseAssessmentMarks(
							filters: {
								student: { idEQ: $studentID, studentCourseSectionEnrollments: { courseSectionIDEQ: $courseSectionID } }
							}
						) {
							id
							studentID
							points
							wasLate
							isExcused
							notes
						}
					}
				}
			}
		}
	}
	${CourseAssessmentNameFragmentDoc}
`;

/**
 * __useStudentCourseSectionGradeBookQuery__
 *
 * To run a query within a React component, call `useStudentCourseSectionGradeBookQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentCourseSectionGradeBookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentCourseSectionGradeBookQuery({
 *   variables: {
 *      studentID: // value for 'studentID'
 *      courseSectionID: // value for 'courseSectionID'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentCourseSectionGradeBookQuery(
	baseOptions: Apollo.QueryHookOptions<StudentCourseSectionGradeBookQuery, StudentCourseSectionGradeBookQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentCourseSectionGradeBookQuery, StudentCourseSectionGradeBookQueryVariables>(
		StudentCourseSectionGradeBookDocument,
		options,
	);
}
export function useStudentCourseSectionGradeBookLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentCourseSectionGradeBookQuery,
		StudentCourseSectionGradeBookQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentCourseSectionGradeBookQuery, StudentCourseSectionGradeBookQueryVariables>(
		StudentCourseSectionGradeBookDocument,
		options,
	);
}
export function useStudentCourseSectionGradeBookSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentCourseSectionGradeBookQuery,
		StudentCourseSectionGradeBookQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentCourseSectionGradeBookQuery, StudentCourseSectionGradeBookQueryVariables>(
		StudentCourseSectionGradeBookDocument,
		options,
	);
}
export type StudentCourseSectionGradeBookQueryHookResult = ReturnType<typeof useStudentCourseSectionGradeBookQuery>;
export type StudentCourseSectionGradeBookLazyQueryHookResult = ReturnType<
	typeof useStudentCourseSectionGradeBookLazyQuery
>;
export type StudentCourseSectionGradeBookSuspenseQueryHookResult = ReturnType<
	typeof useStudentCourseSectionGradeBookSuspenseQuery
>;
export type StudentCourseSectionGradeBookQueryResult = Apollo.QueryResult<
	StudentCourseSectionGradeBookQuery,
	StudentCourseSectionGradeBookQueryVariables
>;
export const CourseAssessmentIndexDocument = gql`
	query courseAssessmentIndex(
		$filters: [CourseAssessmentFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentOrder
	) {
		courseAssessmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					description
					totalPoints
				}
			}
		}
	}
`;

/**
 * __useCourseAssessmentIndexQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseAssessmentIndexQuery, CourseAssessmentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentIndexQuery, CourseAssessmentIndexQueryVariables>(
		CourseAssessmentIndexDocument,
		options,
	);
}
export function useCourseAssessmentIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseAssessmentIndexQuery, CourseAssessmentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentIndexQuery, CourseAssessmentIndexQueryVariables>(
		CourseAssessmentIndexDocument,
		options,
	);
}
export function useCourseAssessmentIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseAssessmentIndexQuery, CourseAssessmentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentIndexQuery, CourseAssessmentIndexQueryVariables>(
		CourseAssessmentIndexDocument,
		options,
	);
}
export type CourseAssessmentIndexQueryHookResult = ReturnType<typeof useCourseAssessmentIndexQuery>;
export type CourseAssessmentIndexLazyQueryHookResult = ReturnType<typeof useCourseAssessmentIndexLazyQuery>;
export type CourseAssessmentIndexSuspenseQueryHookResult = ReturnType<typeof useCourseAssessmentIndexSuspenseQuery>;
export type CourseAssessmentIndexQueryResult = Apollo.QueryResult<
	CourseAssessmentIndexQuery,
	CourseAssessmentIndexQueryVariables
>;
export const CourseSectionCourseAssessmentSummaryListDocument = gql`
	query courseSectionCourseAssessmentSummaryList(
		$courseSectionID: ID!
		$filters: [CourseAssessmentFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentOrder
	) {
		courseAssessmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					courseAssessmentCategory {
						id
						...CourseAssessmentCategoryName
					}
					courseAssessmentSubmissions(
						filters: { student: { studentCourseSectionEnrollments: { courseSectionIDEQ: $courseSectionID } } }
					) {
						id
					}
					courseAssessmentMarks(
						filters: { student: { studentCourseSectionEnrollments: { courseSectionIDEQ: $courseSectionID } } }
					) {
						id
					}
					courseAssessmentTimings(filters: { courseSectionIDEQ: $courseSectionID }) {
						id
						dueOn
					}
				}
			}
		}
	}
	${CourseAssessmentCategoryNameFragmentDoc}
`;

/**
 * __useCourseSectionCourseAssessmentSummaryListQuery__
 *
 * To run a query within a React component, call `useCourseSectionCourseAssessmentSummaryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionCourseAssessmentSummaryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionCourseAssessmentSummaryListQuery({
 *   variables: {
 *      courseSectionID: // value for 'courseSectionID'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionCourseAssessmentSummaryListQuery(
	baseOptions: Apollo.QueryHookOptions<
		CourseSectionCourseAssessmentSummaryListQuery,
		CourseSectionCourseAssessmentSummaryListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CourseSectionCourseAssessmentSummaryListQuery,
		CourseSectionCourseAssessmentSummaryListQueryVariables
	>(CourseSectionCourseAssessmentSummaryListDocument, options);
}
export function useCourseSectionCourseAssessmentSummaryListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseSectionCourseAssessmentSummaryListQuery,
		CourseSectionCourseAssessmentSummaryListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CourseSectionCourseAssessmentSummaryListQuery,
		CourseSectionCourseAssessmentSummaryListQueryVariables
	>(CourseSectionCourseAssessmentSummaryListDocument, options);
}
export function useCourseSectionCourseAssessmentSummaryListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseSectionCourseAssessmentSummaryListQuery,
		CourseSectionCourseAssessmentSummaryListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CourseSectionCourseAssessmentSummaryListQuery,
		CourseSectionCourseAssessmentSummaryListQueryVariables
	>(CourseSectionCourseAssessmentSummaryListDocument, options);
}
export type CourseSectionCourseAssessmentSummaryListQueryHookResult = ReturnType<
	typeof useCourseSectionCourseAssessmentSummaryListQuery
>;
export type CourseSectionCourseAssessmentSummaryListLazyQueryHookResult = ReturnType<
	typeof useCourseSectionCourseAssessmentSummaryListLazyQuery
>;
export type CourseSectionCourseAssessmentSummaryListSuspenseQueryHookResult = ReturnType<
	typeof useCourseSectionCourseAssessmentSummaryListSuspenseQuery
>;
export type CourseSectionCourseAssessmentSummaryListQueryResult = Apollo.QueryResult<
	CourseSectionCourseAssessmentSummaryListQuery,
	CourseSectionCourseAssessmentSummaryListQueryVariables
>;
export const CourseSectionCourseAssessmentPreviewSummaryListDocument = gql`
	query courseSectionCourseAssessmentPreviewSummaryList(
		$courseSectionID: ID!
		$filters: [CourseAssessmentFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentOrder
	) {
		courseAssessmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					courseAssessmentCategory {
						id
						...CourseAssessmentCategoryName
					}
					courseAssessmentTimings(filters: { courseSectionIDEQ: $courseSectionID }) {
						id
						dueOn
					}
				}
			}
		}
	}
	${CourseAssessmentCategoryNameFragmentDoc}
`;

/**
 * __useCourseSectionCourseAssessmentPreviewSummaryListQuery__
 *
 * To run a query within a React component, call `useCourseSectionCourseAssessmentPreviewSummaryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionCourseAssessmentPreviewSummaryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionCourseAssessmentPreviewSummaryListQuery({
 *   variables: {
 *      courseSectionID: // value for 'courseSectionID'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionCourseAssessmentPreviewSummaryListQuery(
	baseOptions: Apollo.QueryHookOptions<
		CourseSectionCourseAssessmentPreviewSummaryListQuery,
		CourseSectionCourseAssessmentPreviewSummaryListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CourseSectionCourseAssessmentPreviewSummaryListQuery,
		CourseSectionCourseAssessmentPreviewSummaryListQueryVariables
	>(CourseSectionCourseAssessmentPreviewSummaryListDocument, options);
}
export function useCourseSectionCourseAssessmentPreviewSummaryListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseSectionCourseAssessmentPreviewSummaryListQuery,
		CourseSectionCourseAssessmentPreviewSummaryListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CourseSectionCourseAssessmentPreviewSummaryListQuery,
		CourseSectionCourseAssessmentPreviewSummaryListQueryVariables
	>(CourseSectionCourseAssessmentPreviewSummaryListDocument, options);
}
export function useCourseSectionCourseAssessmentPreviewSummaryListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseSectionCourseAssessmentPreviewSummaryListQuery,
		CourseSectionCourseAssessmentPreviewSummaryListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CourseSectionCourseAssessmentPreviewSummaryListQuery,
		CourseSectionCourseAssessmentPreviewSummaryListQueryVariables
	>(CourseSectionCourseAssessmentPreviewSummaryListDocument, options);
}
export type CourseSectionCourseAssessmentPreviewSummaryListQueryHookResult = ReturnType<
	typeof useCourseSectionCourseAssessmentPreviewSummaryListQuery
>;
export type CourseSectionCourseAssessmentPreviewSummaryListLazyQueryHookResult = ReturnType<
	typeof useCourseSectionCourseAssessmentPreviewSummaryListLazyQuery
>;
export type CourseSectionCourseAssessmentPreviewSummaryListSuspenseQueryHookResult = ReturnType<
	typeof useCourseSectionCourseAssessmentPreviewSummaryListSuspenseQuery
>;
export type CourseSectionCourseAssessmentPreviewSummaryListQueryResult = Apollo.QueryResult<
	CourseSectionCourseAssessmentPreviewSummaryListQuery,
	CourseSectionCourseAssessmentPreviewSummaryListQueryVariables
>;
export const CourseAssessmentNameDocument = gql`
	query courseAssessmentName($id: ID!) {
		courseAssessment(id: $id) {
			id
			...CourseAssessmentName
		}
	}
	${CourseAssessmentNameFragmentDoc}
`;

/**
 * __useCourseAssessmentNameQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAssessmentNameQuery(
	baseOptions: Apollo.QueryHookOptions<CourseAssessmentNameQuery, CourseAssessmentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentNameQuery, CourseAssessmentNameQueryVariables>(
		CourseAssessmentNameDocument,
		options,
	);
}
export function useCourseAssessmentNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseAssessmentNameQuery, CourseAssessmentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentNameQuery, CourseAssessmentNameQueryVariables>(
		CourseAssessmentNameDocument,
		options,
	);
}
export function useCourseAssessmentNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseAssessmentNameQuery, CourseAssessmentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentNameQuery, CourseAssessmentNameQueryVariables>(
		CourseAssessmentNameDocument,
		options,
	);
}
export type CourseAssessmentNameQueryHookResult = ReturnType<typeof useCourseAssessmentNameQuery>;
export type CourseAssessmentNameLazyQueryHookResult = ReturnType<typeof useCourseAssessmentNameLazyQuery>;
export type CourseAssessmentNameSuspenseQueryHookResult = ReturnType<typeof useCourseAssessmentNameSuspenseQuery>;
export type CourseAssessmentNameQueryResult = Apollo.QueryResult<
	CourseAssessmentNameQuery,
	CourseAssessmentNameQueryVariables
>;
export const CourseAssessmentNamesDocument = gql`
	query courseAssessmentNames(
		$filters: [CourseAssessmentFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentOrder
	) {
		courseAssessmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...CourseAssessmentName
				}
			}
		}
	}
	${CourseAssessmentNameFragmentDoc}
`;

/**
 * __useCourseAssessmentNamesQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseAssessmentNamesQuery, CourseAssessmentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentNamesQuery, CourseAssessmentNamesQueryVariables>(
		CourseAssessmentNamesDocument,
		options,
	);
}
export function useCourseAssessmentNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseAssessmentNamesQuery, CourseAssessmentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentNamesQuery, CourseAssessmentNamesQueryVariables>(
		CourseAssessmentNamesDocument,
		options,
	);
}
export function useCourseAssessmentNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseAssessmentNamesQuery, CourseAssessmentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentNamesQuery, CourseAssessmentNamesQueryVariables>(
		CourseAssessmentNamesDocument,
		options,
	);
}
export type CourseAssessmentNamesQueryHookResult = ReturnType<typeof useCourseAssessmentNamesQuery>;
export type CourseAssessmentNamesLazyQueryHookResult = ReturnType<typeof useCourseAssessmentNamesLazyQuery>;
export type CourseAssessmentNamesSuspenseQueryHookResult = ReturnType<typeof useCourseAssessmentNamesSuspenseQuery>;
export type CourseAssessmentNamesQueryResult = Apollo.QueryResult<
	CourseAssessmentNamesQuery,
	CourseAssessmentNamesQueryVariables
>;
export const CourseAssessmentPaginationDocument = gql`
	query courseAssessmentPagination($filters: [CourseAssessmentFilterInput!], $order: CourseAssessmentOrder) {
		courseAssessmentConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useCourseAssessmentPaginationQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseAssessmentPaginationQuery, CourseAssessmentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentPaginationQuery, CourseAssessmentPaginationQueryVariables>(
		CourseAssessmentPaginationDocument,
		options,
	);
}
export function useCourseAssessmentPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseAssessmentPaginationQuery, CourseAssessmentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentPaginationQuery, CourseAssessmentPaginationQueryVariables>(
		CourseAssessmentPaginationDocument,
		options,
	);
}
export function useCourseAssessmentPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentPaginationQuery,
		CourseAssessmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentPaginationQuery, CourseAssessmentPaginationQueryVariables>(
		CourseAssessmentPaginationDocument,
		options,
	);
}
export type CourseAssessmentPaginationQueryHookResult = ReturnType<typeof useCourseAssessmentPaginationQuery>;
export type CourseAssessmentPaginationLazyQueryHookResult = ReturnType<typeof useCourseAssessmentPaginationLazyQuery>;
export type CourseAssessmentPaginationSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentPaginationSuspenseQuery
>;
export type CourseAssessmentPaginationQueryResult = Apollo.QueryResult<
	CourseAssessmentPaginationQuery,
	CourseAssessmentPaginationQueryVariables
>;
export const CourseAssessmentSelectDocument = gql`
	query courseAssessmentSelect($filters: [CourseAssessmentFilterInput!], $order: CourseAssessmentOrder) {
		courseAssessmentConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...CourseAssessmentName
				}
			}
		}
	}
	${CourseAssessmentNameFragmentDoc}
`;

/**
 * __useCourseAssessmentSelectQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseAssessmentSelectQuery, CourseAssessmentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentSelectQuery, CourseAssessmentSelectQueryVariables>(
		CourseAssessmentSelectDocument,
		options,
	);
}
export function useCourseAssessmentSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseAssessmentSelectQuery, CourseAssessmentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentSelectQuery, CourseAssessmentSelectQueryVariables>(
		CourseAssessmentSelectDocument,
		options,
	);
}
export function useCourseAssessmentSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseAssessmentSelectQuery, CourseAssessmentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentSelectQuery, CourseAssessmentSelectQueryVariables>(
		CourseAssessmentSelectDocument,
		options,
	);
}
export type CourseAssessmentSelectQueryHookResult = ReturnType<typeof useCourseAssessmentSelectQuery>;
export type CourseAssessmentSelectLazyQueryHookResult = ReturnType<typeof useCourseAssessmentSelectLazyQuery>;
export type CourseAssessmentSelectSuspenseQueryHookResult = ReturnType<typeof useCourseAssessmentSelectSuspenseQuery>;
export type CourseAssessmentSelectQueryResult = Apollo.QueryResult<
	CourseAssessmentSelectQuery,
	CourseAssessmentSelectQueryVariables
>;
export const CourseAssessmentStudentsListDocument = gql`
	query courseAssessmentStudentsList(
		$courseAssessmentID: ID!
		$filters: [StudentFilterInput!]
		$pagination: Pagination
		$order: StudentOrder
	) {
		studentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentName
					courseAssessmentMarks(filters: { courseAssessmentIDEQ: $courseAssessmentID }) {
						id
						wasLate
						points
						isExcused
						notes
					}
					courseAssessmentSubmissions(filters: { courseAssessmentIDEQ: $courseAssessmentID }) {
						id
						submissionDate
						mediaAttachments {
							id
							isFile
							fileContentType
						}
					}
				}
			}
		}
	}
	${StudentNameFragmentDoc}
`;

/**
 * __useCourseAssessmentStudentsListQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentStudentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentStudentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentStudentsListQuery({
 *   variables: {
 *      courseAssessmentID: // value for 'courseAssessmentID'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentStudentsListQuery(
	baseOptions: Apollo.QueryHookOptions<CourseAssessmentStudentsListQuery, CourseAssessmentStudentsListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentStudentsListQuery, CourseAssessmentStudentsListQueryVariables>(
		CourseAssessmentStudentsListDocument,
		options,
	);
}
export function useCourseAssessmentStudentsListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentStudentsListQuery,
		CourseAssessmentStudentsListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentStudentsListQuery, CourseAssessmentStudentsListQueryVariables>(
		CourseAssessmentStudentsListDocument,
		options,
	);
}
export function useCourseAssessmentStudentsListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentStudentsListQuery,
		CourseAssessmentStudentsListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentStudentsListQuery, CourseAssessmentStudentsListQueryVariables>(
		CourseAssessmentStudentsListDocument,
		options,
	);
}
export type CourseAssessmentStudentsListQueryHookResult = ReturnType<typeof useCourseAssessmentStudentsListQuery>;
export type CourseAssessmentStudentsListLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentStudentsListLazyQuery
>;
export type CourseAssessmentStudentsListSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentStudentsListSuspenseQuery
>;
export type CourseAssessmentStudentsListQueryResult = Apollo.QueryResult<
	CourseAssessmentStudentsListQuery,
	CourseAssessmentStudentsListQueryVariables
>;
export const CourseAssessmentUpdateDocument = gql`
	mutation courseAssessmentUpdate($id: ID!, $input: CourseAssessmentUpdateInput!) {
		updateCourseAssessment(id: $id, input: $input) {
			...CourseAssessmentDetail
		}
	}
	${CourseAssessmentDetailFragmentDoc}
`;
export type CourseAssessmentUpdateMutationFn = Apollo.MutationFunction<
	CourseAssessmentUpdateMutation,
	CourseAssessmentUpdateMutationVariables
>;

/**
 * __useCourseAssessmentUpdateMutation__
 *
 * To run a mutation, you first call `useCourseAssessmentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAssessmentUpdateMutation, { data, loading, error }] = useCourseAssessmentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseAssessmentUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<CourseAssessmentUpdateMutation, CourseAssessmentUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseAssessmentUpdateMutation, CourseAssessmentUpdateMutationVariables>(
		CourseAssessmentUpdateDocument,
		options,
	);
}
export type CourseAssessmentUpdateMutationHookResult = ReturnType<typeof useCourseAssessmentUpdateMutation>;
export type CourseAssessmentUpdateMutationResult = Apollo.MutationResult<CourseAssessmentUpdateMutation>;
export type CourseAssessmentUpdateMutationOptions = Apollo.BaseMutationOptions<
	CourseAssessmentUpdateMutation,
	CourseAssessmentUpdateMutationVariables
>;
export const CourseAssessmentCategoryCheckUniqueNameDocument = gql`
	query courseAssessmentCategoryCheckUniqueName($ignoreID: ID, $name: String!) {
		courseAssessmentCategoryConnection(filters: { idNEQ: $ignoreID, nameEQ: $name }) {
			totalCount
		}
	}
`;

/**
 * __useCourseAssessmentCategoryCheckUniqueNameQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentCategoryCheckUniqueNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryCheckUniqueNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentCategoryCheckUniqueNameQuery({
 *   variables: {
 *      ignoreID: // value for 'ignoreID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCourseAssessmentCategoryCheckUniqueNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		CourseAssessmentCategoryCheckUniqueNameQuery,
		CourseAssessmentCategoryCheckUniqueNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CourseAssessmentCategoryCheckUniqueNameQuery,
		CourseAssessmentCategoryCheckUniqueNameQueryVariables
	>(CourseAssessmentCategoryCheckUniqueNameDocument, options);
}
export function useCourseAssessmentCategoryCheckUniqueNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentCategoryCheckUniqueNameQuery,
		CourseAssessmentCategoryCheckUniqueNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CourseAssessmentCategoryCheckUniqueNameQuery,
		CourseAssessmentCategoryCheckUniqueNameQueryVariables
	>(CourseAssessmentCategoryCheckUniqueNameDocument, options);
}
export function useCourseAssessmentCategoryCheckUniqueNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentCategoryCheckUniqueNameQuery,
		CourseAssessmentCategoryCheckUniqueNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CourseAssessmentCategoryCheckUniqueNameQuery,
		CourseAssessmentCategoryCheckUniqueNameQueryVariables
	>(CourseAssessmentCategoryCheckUniqueNameDocument, options);
}
export type CourseAssessmentCategoryCheckUniqueNameQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryCheckUniqueNameQuery
>;
export type CourseAssessmentCategoryCheckUniqueNameLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryCheckUniqueNameLazyQuery
>;
export type CourseAssessmentCategoryCheckUniqueNameSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryCheckUniqueNameSuspenseQuery
>;
export type CourseAssessmentCategoryCheckUniqueNameQueryResult = Apollo.QueryResult<
	CourseAssessmentCategoryCheckUniqueNameQuery,
	CourseAssessmentCategoryCheckUniqueNameQueryVariables
>;
export const CourseAssessmentCategoryCountDocument = gql`
	query courseAssessmentCategoryCount(
		$filters: [CourseAssessmentCategoryFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentCategoryOrder
	) {
		courseAssessmentCategoryConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useCourseAssessmentCategoryCountQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentCategoryCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentCategoryCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentCategoryCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseAssessmentCategoryCountQuery,
		CourseAssessmentCategoryCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentCategoryCountQuery, CourseAssessmentCategoryCountQueryVariables>(
		CourseAssessmentCategoryCountDocument,
		options,
	);
}
export function useCourseAssessmentCategoryCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentCategoryCountQuery,
		CourseAssessmentCategoryCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentCategoryCountQuery, CourseAssessmentCategoryCountQueryVariables>(
		CourseAssessmentCategoryCountDocument,
		options,
	);
}
export function useCourseAssessmentCategoryCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentCategoryCountQuery,
		CourseAssessmentCategoryCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentCategoryCountQuery, CourseAssessmentCategoryCountQueryVariables>(
		CourseAssessmentCategoryCountDocument,
		options,
	);
}
export type CourseAssessmentCategoryCountQueryHookResult = ReturnType<typeof useCourseAssessmentCategoryCountQuery>;
export type CourseAssessmentCategoryCountLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryCountLazyQuery
>;
export type CourseAssessmentCategoryCountSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryCountSuspenseQuery
>;
export type CourseAssessmentCategoryCountQueryResult = Apollo.QueryResult<
	CourseAssessmentCategoryCountQuery,
	CourseAssessmentCategoryCountQueryVariables
>;
export const CourseAssessmentCategoryCreateDocument = gql`
	mutation courseAssessmentCategoryCreate($input: CourseAssessmentCategoryCreateInput!) {
		createCourseAssessmentCategory(input: $input) {
			...CourseAssessmentCategoryDetail
		}
	}
	${CourseAssessmentCategoryDetailFragmentDoc}
`;
export type CourseAssessmentCategoryCreateMutationFn = Apollo.MutationFunction<
	CourseAssessmentCategoryCreateMutation,
	CourseAssessmentCategoryCreateMutationVariables
>;

/**
 * __useCourseAssessmentCategoryCreateMutation__
 *
 * To run a mutation, you first call `useCourseAssessmentCategoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAssessmentCategoryCreateMutation, { data, loading, error }] = useCourseAssessmentCategoryCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseAssessmentCategoryCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAssessmentCategoryCreateMutation,
		CourseAssessmentCategoryCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseAssessmentCategoryCreateMutation, CourseAssessmentCategoryCreateMutationVariables>(
		CourseAssessmentCategoryCreateDocument,
		options,
	);
}
export type CourseAssessmentCategoryCreateMutationHookResult = ReturnType<
	typeof useCourseAssessmentCategoryCreateMutation
>;
export type CourseAssessmentCategoryCreateMutationResult =
	Apollo.MutationResult<CourseAssessmentCategoryCreateMutation>;
export type CourseAssessmentCategoryCreateMutationOptions = Apollo.BaseMutationOptions<
	CourseAssessmentCategoryCreateMutation,
	CourseAssessmentCategoryCreateMutationVariables
>;
export const CourseAssessmentCategoryDeleteDocument = gql`
	mutation courseAssessmentCategoryDelete($id: ID!) {
		deleteCourseAssessmentCategory(id: $id)
	}
`;
export type CourseAssessmentCategoryDeleteMutationFn = Apollo.MutationFunction<
	CourseAssessmentCategoryDeleteMutation,
	CourseAssessmentCategoryDeleteMutationVariables
>;

/**
 * __useCourseAssessmentCategoryDeleteMutation__
 *
 * To run a mutation, you first call `useCourseAssessmentCategoryDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAssessmentCategoryDeleteMutation, { data, loading, error }] = useCourseAssessmentCategoryDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAssessmentCategoryDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAssessmentCategoryDeleteMutation,
		CourseAssessmentCategoryDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseAssessmentCategoryDeleteMutation, CourseAssessmentCategoryDeleteMutationVariables>(
		CourseAssessmentCategoryDeleteDocument,
		options,
	);
}
export type CourseAssessmentCategoryDeleteMutationHookResult = ReturnType<
	typeof useCourseAssessmentCategoryDeleteMutation
>;
export type CourseAssessmentCategoryDeleteMutationResult =
	Apollo.MutationResult<CourseAssessmentCategoryDeleteMutation>;
export type CourseAssessmentCategoryDeleteMutationOptions = Apollo.BaseMutationOptions<
	CourseAssessmentCategoryDeleteMutation,
	CourseAssessmentCategoryDeleteMutationVariables
>;
export const CourseAssessmentCategoryDetailDocument = gql`
	query courseAssessmentCategoryDetail($id: ID!) {
		courseAssessmentCategory(id: $id) {
			...CourseAssessmentCategoryDetail
		}
	}
	${CourseAssessmentCategoryDetailFragmentDoc}
`;

/**
 * __useCourseAssessmentCategoryDetailQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentCategoryDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentCategoryDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAssessmentCategoryDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		CourseAssessmentCategoryDetailQuery,
		CourseAssessmentCategoryDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentCategoryDetailQuery, CourseAssessmentCategoryDetailQueryVariables>(
		CourseAssessmentCategoryDetailDocument,
		options,
	);
}
export function useCourseAssessmentCategoryDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentCategoryDetailQuery,
		CourseAssessmentCategoryDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentCategoryDetailQuery, CourseAssessmentCategoryDetailQueryVariables>(
		CourseAssessmentCategoryDetailDocument,
		options,
	);
}
export function useCourseAssessmentCategoryDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentCategoryDetailQuery,
		CourseAssessmentCategoryDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentCategoryDetailQuery, CourseAssessmentCategoryDetailQueryVariables>(
		CourseAssessmentCategoryDetailDocument,
		options,
	);
}
export type CourseAssessmentCategoryDetailQueryHookResult = ReturnType<typeof useCourseAssessmentCategoryDetailQuery>;
export type CourseAssessmentCategoryDetailLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryDetailLazyQuery
>;
export type CourseAssessmentCategoryDetailSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryDetailSuspenseQuery
>;
export type CourseAssessmentCategoryDetailQueryResult = Apollo.QueryResult<
	CourseAssessmentCategoryDetailQuery,
	CourseAssessmentCategoryDetailQueryVariables
>;
export const CourseAssessmentCategoryIndexDocument = gql`
	query courseAssessmentCategoryIndex(
		$filters: [CourseAssessmentCategoryFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentCategoryOrder
	) {
		courseAssessmentCategoryConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
				}
			}
		}
	}
`;

/**
 * __useCourseAssessmentCategoryIndexQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentCategoryIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentCategoryIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentCategoryIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseAssessmentCategoryIndexQuery,
		CourseAssessmentCategoryIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentCategoryIndexQuery, CourseAssessmentCategoryIndexQueryVariables>(
		CourseAssessmentCategoryIndexDocument,
		options,
	);
}
export function useCourseAssessmentCategoryIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentCategoryIndexQuery,
		CourseAssessmentCategoryIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentCategoryIndexQuery, CourseAssessmentCategoryIndexQueryVariables>(
		CourseAssessmentCategoryIndexDocument,
		options,
	);
}
export function useCourseAssessmentCategoryIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentCategoryIndexQuery,
		CourseAssessmentCategoryIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentCategoryIndexQuery, CourseAssessmentCategoryIndexQueryVariables>(
		CourseAssessmentCategoryIndexDocument,
		options,
	);
}
export type CourseAssessmentCategoryIndexQueryHookResult = ReturnType<typeof useCourseAssessmentCategoryIndexQuery>;
export type CourseAssessmentCategoryIndexLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryIndexLazyQuery
>;
export type CourseAssessmentCategoryIndexSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryIndexSuspenseQuery
>;
export type CourseAssessmentCategoryIndexQueryResult = Apollo.QueryResult<
	CourseAssessmentCategoryIndexQuery,
	CourseAssessmentCategoryIndexQueryVariables
>;
export const CourseAssessmentCategoryNameDocument = gql`
	query courseAssessmentCategoryName($id: ID!) {
		courseAssessmentCategory(id: $id) {
			id
			...CourseAssessmentCategoryName
		}
	}
	${CourseAssessmentCategoryNameFragmentDoc}
`;

/**
 * __useCourseAssessmentCategoryNameQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentCategoryNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentCategoryNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAssessmentCategoryNameQuery(
	baseOptions: Apollo.QueryHookOptions<CourseAssessmentCategoryNameQuery, CourseAssessmentCategoryNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentCategoryNameQuery, CourseAssessmentCategoryNameQueryVariables>(
		CourseAssessmentCategoryNameDocument,
		options,
	);
}
export function useCourseAssessmentCategoryNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentCategoryNameQuery,
		CourseAssessmentCategoryNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentCategoryNameQuery, CourseAssessmentCategoryNameQueryVariables>(
		CourseAssessmentCategoryNameDocument,
		options,
	);
}
export function useCourseAssessmentCategoryNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentCategoryNameQuery,
		CourseAssessmentCategoryNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentCategoryNameQuery, CourseAssessmentCategoryNameQueryVariables>(
		CourseAssessmentCategoryNameDocument,
		options,
	);
}
export type CourseAssessmentCategoryNameQueryHookResult = ReturnType<typeof useCourseAssessmentCategoryNameQuery>;
export type CourseAssessmentCategoryNameLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryNameLazyQuery
>;
export type CourseAssessmentCategoryNameSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryNameSuspenseQuery
>;
export type CourseAssessmentCategoryNameQueryResult = Apollo.QueryResult<
	CourseAssessmentCategoryNameQuery,
	CourseAssessmentCategoryNameQueryVariables
>;
export const CourseAssessmentCategoryNamesDocument = gql`
	query courseAssessmentCategoryNames(
		$filters: [CourseAssessmentCategoryFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentCategoryOrder
	) {
		courseAssessmentCategoryConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...CourseAssessmentCategoryName
				}
			}
		}
	}
	${CourseAssessmentCategoryNameFragmentDoc}
`;

/**
 * __useCourseAssessmentCategoryNamesQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentCategoryNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentCategoryNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentCategoryNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseAssessmentCategoryNamesQuery,
		CourseAssessmentCategoryNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentCategoryNamesQuery, CourseAssessmentCategoryNamesQueryVariables>(
		CourseAssessmentCategoryNamesDocument,
		options,
	);
}
export function useCourseAssessmentCategoryNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentCategoryNamesQuery,
		CourseAssessmentCategoryNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentCategoryNamesQuery, CourseAssessmentCategoryNamesQueryVariables>(
		CourseAssessmentCategoryNamesDocument,
		options,
	);
}
export function useCourseAssessmentCategoryNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentCategoryNamesQuery,
		CourseAssessmentCategoryNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentCategoryNamesQuery, CourseAssessmentCategoryNamesQueryVariables>(
		CourseAssessmentCategoryNamesDocument,
		options,
	);
}
export type CourseAssessmentCategoryNamesQueryHookResult = ReturnType<typeof useCourseAssessmentCategoryNamesQuery>;
export type CourseAssessmentCategoryNamesLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryNamesLazyQuery
>;
export type CourseAssessmentCategoryNamesSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryNamesSuspenseQuery
>;
export type CourseAssessmentCategoryNamesQueryResult = Apollo.QueryResult<
	CourseAssessmentCategoryNamesQuery,
	CourseAssessmentCategoryNamesQueryVariables
>;
export const CourseAssessmentCategoryPaginationDocument = gql`
	query courseAssessmentCategoryPagination(
		$filters: [CourseAssessmentCategoryFilterInput!]
		$order: CourseAssessmentCategoryOrder
	) {
		courseAssessmentCategoryConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useCourseAssessmentCategoryPaginationQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentCategoryPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentCategoryPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentCategoryPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseAssessmentCategoryPaginationQuery,
		CourseAssessmentCategoryPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentCategoryPaginationQuery, CourseAssessmentCategoryPaginationQueryVariables>(
		CourseAssessmentCategoryPaginationDocument,
		options,
	);
}
export function useCourseAssessmentCategoryPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentCategoryPaginationQuery,
		CourseAssessmentCategoryPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentCategoryPaginationQuery, CourseAssessmentCategoryPaginationQueryVariables>(
		CourseAssessmentCategoryPaginationDocument,
		options,
	);
}
export function useCourseAssessmentCategoryPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentCategoryPaginationQuery,
		CourseAssessmentCategoryPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CourseAssessmentCategoryPaginationQuery,
		CourseAssessmentCategoryPaginationQueryVariables
	>(CourseAssessmentCategoryPaginationDocument, options);
}
export type CourseAssessmentCategoryPaginationQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryPaginationQuery
>;
export type CourseAssessmentCategoryPaginationLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryPaginationLazyQuery
>;
export type CourseAssessmentCategoryPaginationSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryPaginationSuspenseQuery
>;
export type CourseAssessmentCategoryPaginationQueryResult = Apollo.QueryResult<
	CourseAssessmentCategoryPaginationQuery,
	CourseAssessmentCategoryPaginationQueryVariables
>;
export const CourseAssessmentCategorySelectDocument = gql`
	query courseAssessmentCategorySelect(
		$filters: [CourseAssessmentCategoryFilterInput!]
		$order: CourseAssessmentCategoryOrder
	) {
		courseAssessmentCategoryConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...CourseAssessmentCategoryName
				}
			}
		}
	}
	${CourseAssessmentCategoryNameFragmentDoc}
`;

/**
 * __useCourseAssessmentCategorySelectQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentCategorySelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategorySelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentCategorySelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentCategorySelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseAssessmentCategorySelectQuery,
		CourseAssessmentCategorySelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentCategorySelectQuery, CourseAssessmentCategorySelectQueryVariables>(
		CourseAssessmentCategorySelectDocument,
		options,
	);
}
export function useCourseAssessmentCategorySelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentCategorySelectQuery,
		CourseAssessmentCategorySelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentCategorySelectQuery, CourseAssessmentCategorySelectQueryVariables>(
		CourseAssessmentCategorySelectDocument,
		options,
	);
}
export function useCourseAssessmentCategorySelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentCategorySelectQuery,
		CourseAssessmentCategorySelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentCategorySelectQuery, CourseAssessmentCategorySelectQueryVariables>(
		CourseAssessmentCategorySelectDocument,
		options,
	);
}
export type CourseAssessmentCategorySelectQueryHookResult = ReturnType<typeof useCourseAssessmentCategorySelectQuery>;
export type CourseAssessmentCategorySelectLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategorySelectLazyQuery
>;
export type CourseAssessmentCategorySelectSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategorySelectSuspenseQuery
>;
export type CourseAssessmentCategorySelectQueryResult = Apollo.QueryResult<
	CourseAssessmentCategorySelectQuery,
	CourseAssessmentCategorySelectQueryVariables
>;
export const CourseAssessmentCategoryUpdateDocument = gql`
	mutation courseAssessmentCategoryUpdate($id: ID!, $input: CourseAssessmentCategoryUpdateInput!) {
		updateCourseAssessmentCategory(id: $id, input: $input) {
			...CourseAssessmentCategoryDetail
		}
	}
	${CourseAssessmentCategoryDetailFragmentDoc}
`;
export type CourseAssessmentCategoryUpdateMutationFn = Apollo.MutationFunction<
	CourseAssessmentCategoryUpdateMutation,
	CourseAssessmentCategoryUpdateMutationVariables
>;

/**
 * __useCourseAssessmentCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useCourseAssessmentCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAssessmentCategoryUpdateMutation, { data, loading, error }] = useCourseAssessmentCategoryUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseAssessmentCategoryUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAssessmentCategoryUpdateMutation,
		CourseAssessmentCategoryUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseAssessmentCategoryUpdateMutation, CourseAssessmentCategoryUpdateMutationVariables>(
		CourseAssessmentCategoryUpdateDocument,
		options,
	);
}
export type CourseAssessmentCategoryUpdateMutationHookResult = ReturnType<
	typeof useCourseAssessmentCategoryUpdateMutation
>;
export type CourseAssessmentCategoryUpdateMutationResult =
	Apollo.MutationResult<CourseAssessmentCategoryUpdateMutation>;
export type CourseAssessmentCategoryUpdateMutationOptions = Apollo.BaseMutationOptions<
	CourseAssessmentCategoryUpdateMutation,
	CourseAssessmentCategoryUpdateMutationVariables
>;
export const CourseAssessmentCategoryMarkPortionCountDocument = gql`
	query courseAssessmentCategoryMarkPortionCount(
		$filters: [CourseAssessmentCategoryMarkPortionFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentCategoryMarkPortionOrder
	) {
		courseAssessmentCategoryMarkPortionConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useCourseAssessmentCategoryMarkPortionCountQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentCategoryMarkPortionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryMarkPortionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentCategoryMarkPortionCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentCategoryMarkPortionCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseAssessmentCategoryMarkPortionCountQuery,
		CourseAssessmentCategoryMarkPortionCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CourseAssessmentCategoryMarkPortionCountQuery,
		CourseAssessmentCategoryMarkPortionCountQueryVariables
	>(CourseAssessmentCategoryMarkPortionCountDocument, options);
}
export function useCourseAssessmentCategoryMarkPortionCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentCategoryMarkPortionCountQuery,
		CourseAssessmentCategoryMarkPortionCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CourseAssessmentCategoryMarkPortionCountQuery,
		CourseAssessmentCategoryMarkPortionCountQueryVariables
	>(CourseAssessmentCategoryMarkPortionCountDocument, options);
}
export function useCourseAssessmentCategoryMarkPortionCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentCategoryMarkPortionCountQuery,
		CourseAssessmentCategoryMarkPortionCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CourseAssessmentCategoryMarkPortionCountQuery,
		CourseAssessmentCategoryMarkPortionCountQueryVariables
	>(CourseAssessmentCategoryMarkPortionCountDocument, options);
}
export type CourseAssessmentCategoryMarkPortionCountQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionCountQuery
>;
export type CourseAssessmentCategoryMarkPortionCountLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionCountLazyQuery
>;
export type CourseAssessmentCategoryMarkPortionCountSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionCountSuspenseQuery
>;
export type CourseAssessmentCategoryMarkPortionCountQueryResult = Apollo.QueryResult<
	CourseAssessmentCategoryMarkPortionCountQuery,
	CourseAssessmentCategoryMarkPortionCountQueryVariables
>;
export const CourseAssessmentCategoryMarkPortionCreateDocument = gql`
	mutation courseAssessmentCategoryMarkPortionCreate($input: CourseAssessmentCategoryMarkPortionCreateInput!) {
		createCourseAssessmentCategoryMarkPortion(input: $input) {
			...CourseAssessmentCategoryMarkPortionDetail
		}
	}
	${CourseAssessmentCategoryMarkPortionDetailFragmentDoc}
`;
export type CourseAssessmentCategoryMarkPortionCreateMutationFn = Apollo.MutationFunction<
	CourseAssessmentCategoryMarkPortionCreateMutation,
	CourseAssessmentCategoryMarkPortionCreateMutationVariables
>;

/**
 * __useCourseAssessmentCategoryMarkPortionCreateMutation__
 *
 * To run a mutation, you first call `useCourseAssessmentCategoryMarkPortionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryMarkPortionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAssessmentCategoryMarkPortionCreateMutation, { data, loading, error }] = useCourseAssessmentCategoryMarkPortionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseAssessmentCategoryMarkPortionCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAssessmentCategoryMarkPortionCreateMutation,
		CourseAssessmentCategoryMarkPortionCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CourseAssessmentCategoryMarkPortionCreateMutation,
		CourseAssessmentCategoryMarkPortionCreateMutationVariables
	>(CourseAssessmentCategoryMarkPortionCreateDocument, options);
}
export type CourseAssessmentCategoryMarkPortionCreateMutationHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionCreateMutation
>;
export type CourseAssessmentCategoryMarkPortionCreateMutationResult =
	Apollo.MutationResult<CourseAssessmentCategoryMarkPortionCreateMutation>;
export type CourseAssessmentCategoryMarkPortionCreateMutationOptions = Apollo.BaseMutationOptions<
	CourseAssessmentCategoryMarkPortionCreateMutation,
	CourseAssessmentCategoryMarkPortionCreateMutationVariables
>;
export const CourseAssessmentCategoryMarkPortionDeleteDocument = gql`
	mutation courseAssessmentCategoryMarkPortionDelete($id: ID!) {
		deleteCourseAssessmentCategoryMarkPortion(id: $id)
	}
`;
export type CourseAssessmentCategoryMarkPortionDeleteMutationFn = Apollo.MutationFunction<
	CourseAssessmentCategoryMarkPortionDeleteMutation,
	CourseAssessmentCategoryMarkPortionDeleteMutationVariables
>;

/**
 * __useCourseAssessmentCategoryMarkPortionDeleteMutation__
 *
 * To run a mutation, you first call `useCourseAssessmentCategoryMarkPortionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryMarkPortionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAssessmentCategoryMarkPortionDeleteMutation, { data, loading, error }] = useCourseAssessmentCategoryMarkPortionDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAssessmentCategoryMarkPortionDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAssessmentCategoryMarkPortionDeleteMutation,
		CourseAssessmentCategoryMarkPortionDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CourseAssessmentCategoryMarkPortionDeleteMutation,
		CourseAssessmentCategoryMarkPortionDeleteMutationVariables
	>(CourseAssessmentCategoryMarkPortionDeleteDocument, options);
}
export type CourseAssessmentCategoryMarkPortionDeleteMutationHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionDeleteMutation
>;
export type CourseAssessmentCategoryMarkPortionDeleteMutationResult =
	Apollo.MutationResult<CourseAssessmentCategoryMarkPortionDeleteMutation>;
export type CourseAssessmentCategoryMarkPortionDeleteMutationOptions = Apollo.BaseMutationOptions<
	CourseAssessmentCategoryMarkPortionDeleteMutation,
	CourseAssessmentCategoryMarkPortionDeleteMutationVariables
>;
export const CourseAssessmentCategoryMarkPortionDetailDocument = gql`
	query courseAssessmentCategoryMarkPortionDetail($id: ID!) {
		courseAssessmentCategoryMarkPortion(id: $id) {
			...CourseAssessmentCategoryMarkPortionDetail
		}
	}
	${CourseAssessmentCategoryMarkPortionDetailFragmentDoc}
`;

/**
 * __useCourseAssessmentCategoryMarkPortionDetailQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentCategoryMarkPortionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryMarkPortionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentCategoryMarkPortionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAssessmentCategoryMarkPortionDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		CourseAssessmentCategoryMarkPortionDetailQuery,
		CourseAssessmentCategoryMarkPortionDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CourseAssessmentCategoryMarkPortionDetailQuery,
		CourseAssessmentCategoryMarkPortionDetailQueryVariables
	>(CourseAssessmentCategoryMarkPortionDetailDocument, options);
}
export function useCourseAssessmentCategoryMarkPortionDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentCategoryMarkPortionDetailQuery,
		CourseAssessmentCategoryMarkPortionDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CourseAssessmentCategoryMarkPortionDetailQuery,
		CourseAssessmentCategoryMarkPortionDetailQueryVariables
	>(CourseAssessmentCategoryMarkPortionDetailDocument, options);
}
export function useCourseAssessmentCategoryMarkPortionDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentCategoryMarkPortionDetailQuery,
		CourseAssessmentCategoryMarkPortionDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CourseAssessmentCategoryMarkPortionDetailQuery,
		CourseAssessmentCategoryMarkPortionDetailQueryVariables
	>(CourseAssessmentCategoryMarkPortionDetailDocument, options);
}
export type CourseAssessmentCategoryMarkPortionDetailQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionDetailQuery
>;
export type CourseAssessmentCategoryMarkPortionDetailLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionDetailLazyQuery
>;
export type CourseAssessmentCategoryMarkPortionDetailSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionDetailSuspenseQuery
>;
export type CourseAssessmentCategoryMarkPortionDetailQueryResult = Apollo.QueryResult<
	CourseAssessmentCategoryMarkPortionDetailQuery,
	CourseAssessmentCategoryMarkPortionDetailQueryVariables
>;
export const CourseAssessmentCategoryMarkPortionIndexDocument = gql`
	query courseAssessmentCategoryMarkPortionIndex(
		$filters: [CourseAssessmentCategoryMarkPortionFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentCategoryMarkPortionOrder
	) {
		courseAssessmentCategoryMarkPortionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					markPortion
				}
			}
		}
	}
`;

/**
 * __useCourseAssessmentCategoryMarkPortionIndexQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentCategoryMarkPortionIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryMarkPortionIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentCategoryMarkPortionIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentCategoryMarkPortionIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseAssessmentCategoryMarkPortionIndexQuery,
		CourseAssessmentCategoryMarkPortionIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CourseAssessmentCategoryMarkPortionIndexQuery,
		CourseAssessmentCategoryMarkPortionIndexQueryVariables
	>(CourseAssessmentCategoryMarkPortionIndexDocument, options);
}
export function useCourseAssessmentCategoryMarkPortionIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentCategoryMarkPortionIndexQuery,
		CourseAssessmentCategoryMarkPortionIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CourseAssessmentCategoryMarkPortionIndexQuery,
		CourseAssessmentCategoryMarkPortionIndexQueryVariables
	>(CourseAssessmentCategoryMarkPortionIndexDocument, options);
}
export function useCourseAssessmentCategoryMarkPortionIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentCategoryMarkPortionIndexQuery,
		CourseAssessmentCategoryMarkPortionIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CourseAssessmentCategoryMarkPortionIndexQuery,
		CourseAssessmentCategoryMarkPortionIndexQueryVariables
	>(CourseAssessmentCategoryMarkPortionIndexDocument, options);
}
export type CourseAssessmentCategoryMarkPortionIndexQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionIndexQuery
>;
export type CourseAssessmentCategoryMarkPortionIndexLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionIndexLazyQuery
>;
export type CourseAssessmentCategoryMarkPortionIndexSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionIndexSuspenseQuery
>;
export type CourseAssessmentCategoryMarkPortionIndexQueryResult = Apollo.QueryResult<
	CourseAssessmentCategoryMarkPortionIndexQuery,
	CourseAssessmentCategoryMarkPortionIndexQueryVariables
>;
export const CourseAssessmentCategoryMarkPortionNameDocument = gql`
	query courseAssessmentCategoryMarkPortionName($id: ID!) {
		courseAssessmentCategoryMarkPortion(id: $id) {
			id
			...CourseAssessmentCategoryMarkPortionName
		}
	}
	${CourseAssessmentCategoryMarkPortionNameFragmentDoc}
`;

/**
 * __useCourseAssessmentCategoryMarkPortionNameQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentCategoryMarkPortionNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryMarkPortionNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentCategoryMarkPortionNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAssessmentCategoryMarkPortionNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		CourseAssessmentCategoryMarkPortionNameQuery,
		CourseAssessmentCategoryMarkPortionNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CourseAssessmentCategoryMarkPortionNameQuery,
		CourseAssessmentCategoryMarkPortionNameQueryVariables
	>(CourseAssessmentCategoryMarkPortionNameDocument, options);
}
export function useCourseAssessmentCategoryMarkPortionNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentCategoryMarkPortionNameQuery,
		CourseAssessmentCategoryMarkPortionNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CourseAssessmentCategoryMarkPortionNameQuery,
		CourseAssessmentCategoryMarkPortionNameQueryVariables
	>(CourseAssessmentCategoryMarkPortionNameDocument, options);
}
export function useCourseAssessmentCategoryMarkPortionNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentCategoryMarkPortionNameQuery,
		CourseAssessmentCategoryMarkPortionNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CourseAssessmentCategoryMarkPortionNameQuery,
		CourseAssessmentCategoryMarkPortionNameQueryVariables
	>(CourseAssessmentCategoryMarkPortionNameDocument, options);
}
export type CourseAssessmentCategoryMarkPortionNameQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionNameQuery
>;
export type CourseAssessmentCategoryMarkPortionNameLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionNameLazyQuery
>;
export type CourseAssessmentCategoryMarkPortionNameSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionNameSuspenseQuery
>;
export type CourseAssessmentCategoryMarkPortionNameQueryResult = Apollo.QueryResult<
	CourseAssessmentCategoryMarkPortionNameQuery,
	CourseAssessmentCategoryMarkPortionNameQueryVariables
>;
export const CourseAssessmentCategoryMarkPortionNamesDocument = gql`
	query courseAssessmentCategoryMarkPortionNames(
		$filters: [CourseAssessmentCategoryMarkPortionFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentCategoryMarkPortionOrder
	) {
		courseAssessmentCategoryMarkPortionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...CourseAssessmentCategoryMarkPortionName
				}
			}
		}
	}
	${CourseAssessmentCategoryMarkPortionNameFragmentDoc}
`;

/**
 * __useCourseAssessmentCategoryMarkPortionNamesQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentCategoryMarkPortionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryMarkPortionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentCategoryMarkPortionNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentCategoryMarkPortionNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseAssessmentCategoryMarkPortionNamesQuery,
		CourseAssessmentCategoryMarkPortionNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CourseAssessmentCategoryMarkPortionNamesQuery,
		CourseAssessmentCategoryMarkPortionNamesQueryVariables
	>(CourseAssessmentCategoryMarkPortionNamesDocument, options);
}
export function useCourseAssessmentCategoryMarkPortionNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentCategoryMarkPortionNamesQuery,
		CourseAssessmentCategoryMarkPortionNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CourseAssessmentCategoryMarkPortionNamesQuery,
		CourseAssessmentCategoryMarkPortionNamesQueryVariables
	>(CourseAssessmentCategoryMarkPortionNamesDocument, options);
}
export function useCourseAssessmentCategoryMarkPortionNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentCategoryMarkPortionNamesQuery,
		CourseAssessmentCategoryMarkPortionNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CourseAssessmentCategoryMarkPortionNamesQuery,
		CourseAssessmentCategoryMarkPortionNamesQueryVariables
	>(CourseAssessmentCategoryMarkPortionNamesDocument, options);
}
export type CourseAssessmentCategoryMarkPortionNamesQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionNamesQuery
>;
export type CourseAssessmentCategoryMarkPortionNamesLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionNamesLazyQuery
>;
export type CourseAssessmentCategoryMarkPortionNamesSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionNamesSuspenseQuery
>;
export type CourseAssessmentCategoryMarkPortionNamesQueryResult = Apollo.QueryResult<
	CourseAssessmentCategoryMarkPortionNamesQuery,
	CourseAssessmentCategoryMarkPortionNamesQueryVariables
>;
export const CourseAssessmentCategoryMarkPortionPaginationDocument = gql`
	query courseAssessmentCategoryMarkPortionPagination(
		$filters: [CourseAssessmentCategoryMarkPortionFilterInput!]
		$order: CourseAssessmentCategoryMarkPortionOrder
	) {
		courseAssessmentCategoryMarkPortionConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useCourseAssessmentCategoryMarkPortionPaginationQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentCategoryMarkPortionPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryMarkPortionPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentCategoryMarkPortionPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentCategoryMarkPortionPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseAssessmentCategoryMarkPortionPaginationQuery,
		CourseAssessmentCategoryMarkPortionPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CourseAssessmentCategoryMarkPortionPaginationQuery,
		CourseAssessmentCategoryMarkPortionPaginationQueryVariables
	>(CourseAssessmentCategoryMarkPortionPaginationDocument, options);
}
export function useCourseAssessmentCategoryMarkPortionPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentCategoryMarkPortionPaginationQuery,
		CourseAssessmentCategoryMarkPortionPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CourseAssessmentCategoryMarkPortionPaginationQuery,
		CourseAssessmentCategoryMarkPortionPaginationQueryVariables
	>(CourseAssessmentCategoryMarkPortionPaginationDocument, options);
}
export function useCourseAssessmentCategoryMarkPortionPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentCategoryMarkPortionPaginationQuery,
		CourseAssessmentCategoryMarkPortionPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CourseAssessmentCategoryMarkPortionPaginationQuery,
		CourseAssessmentCategoryMarkPortionPaginationQueryVariables
	>(CourseAssessmentCategoryMarkPortionPaginationDocument, options);
}
export type CourseAssessmentCategoryMarkPortionPaginationQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionPaginationQuery
>;
export type CourseAssessmentCategoryMarkPortionPaginationLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionPaginationLazyQuery
>;
export type CourseAssessmentCategoryMarkPortionPaginationSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionPaginationSuspenseQuery
>;
export type CourseAssessmentCategoryMarkPortionPaginationQueryResult = Apollo.QueryResult<
	CourseAssessmentCategoryMarkPortionPaginationQuery,
	CourseAssessmentCategoryMarkPortionPaginationQueryVariables
>;
export const CourseAssessmentCategoryMarkPortionSelectDocument = gql`
	query courseAssessmentCategoryMarkPortionSelect(
		$filters: [CourseAssessmentCategoryMarkPortionFilterInput!]
		$order: CourseAssessmentCategoryMarkPortionOrder
	) {
		courseAssessmentCategoryMarkPortionConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...CourseAssessmentCategoryMarkPortionName
				}
			}
		}
	}
	${CourseAssessmentCategoryMarkPortionNameFragmentDoc}
`;

/**
 * __useCourseAssessmentCategoryMarkPortionSelectQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentCategoryMarkPortionSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryMarkPortionSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentCategoryMarkPortionSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentCategoryMarkPortionSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseAssessmentCategoryMarkPortionSelectQuery,
		CourseAssessmentCategoryMarkPortionSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CourseAssessmentCategoryMarkPortionSelectQuery,
		CourseAssessmentCategoryMarkPortionSelectQueryVariables
	>(CourseAssessmentCategoryMarkPortionSelectDocument, options);
}
export function useCourseAssessmentCategoryMarkPortionSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentCategoryMarkPortionSelectQuery,
		CourseAssessmentCategoryMarkPortionSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CourseAssessmentCategoryMarkPortionSelectQuery,
		CourseAssessmentCategoryMarkPortionSelectQueryVariables
	>(CourseAssessmentCategoryMarkPortionSelectDocument, options);
}
export function useCourseAssessmentCategoryMarkPortionSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentCategoryMarkPortionSelectQuery,
		CourseAssessmentCategoryMarkPortionSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CourseAssessmentCategoryMarkPortionSelectQuery,
		CourseAssessmentCategoryMarkPortionSelectQueryVariables
	>(CourseAssessmentCategoryMarkPortionSelectDocument, options);
}
export type CourseAssessmentCategoryMarkPortionSelectQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionSelectQuery
>;
export type CourseAssessmentCategoryMarkPortionSelectLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionSelectLazyQuery
>;
export type CourseAssessmentCategoryMarkPortionSelectSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionSelectSuspenseQuery
>;
export type CourseAssessmentCategoryMarkPortionSelectQueryResult = Apollo.QueryResult<
	CourseAssessmentCategoryMarkPortionSelectQuery,
	CourseAssessmentCategoryMarkPortionSelectQueryVariables
>;
export const CourseAssessmentCategoryMarkPortionUpdateDocument = gql`
	mutation courseAssessmentCategoryMarkPortionUpdate(
		$id: ID!
		$input: CourseAssessmentCategoryMarkPortionUpdateInput!
	) {
		updateCourseAssessmentCategoryMarkPortion(id: $id, input: $input) {
			...CourseAssessmentCategoryMarkPortionDetail
		}
	}
	${CourseAssessmentCategoryMarkPortionDetailFragmentDoc}
`;
export type CourseAssessmentCategoryMarkPortionUpdateMutationFn = Apollo.MutationFunction<
	CourseAssessmentCategoryMarkPortionUpdateMutation,
	CourseAssessmentCategoryMarkPortionUpdateMutationVariables
>;

/**
 * __useCourseAssessmentCategoryMarkPortionUpdateMutation__
 *
 * To run a mutation, you first call `useCourseAssessmentCategoryMarkPortionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentCategoryMarkPortionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAssessmentCategoryMarkPortionUpdateMutation, { data, loading, error }] = useCourseAssessmentCategoryMarkPortionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseAssessmentCategoryMarkPortionUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAssessmentCategoryMarkPortionUpdateMutation,
		CourseAssessmentCategoryMarkPortionUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CourseAssessmentCategoryMarkPortionUpdateMutation,
		CourseAssessmentCategoryMarkPortionUpdateMutationVariables
	>(CourseAssessmentCategoryMarkPortionUpdateDocument, options);
}
export type CourseAssessmentCategoryMarkPortionUpdateMutationHookResult = ReturnType<
	typeof useCourseAssessmentCategoryMarkPortionUpdateMutation
>;
export type CourseAssessmentCategoryMarkPortionUpdateMutationResult =
	Apollo.MutationResult<CourseAssessmentCategoryMarkPortionUpdateMutation>;
export type CourseAssessmentCategoryMarkPortionUpdateMutationOptions = Apollo.BaseMutationOptions<
	CourseAssessmentCategoryMarkPortionUpdateMutation,
	CourseAssessmentCategoryMarkPortionUpdateMutationVariables
>;
export const CourseAssessmentMarkCountDocument = gql`
	query courseAssessmentMarkCount(
		$filters: [CourseAssessmentMarkFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentMarkOrder
	) {
		courseAssessmentMarkConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useCourseAssessmentMarkCountQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentMarkCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentMarkCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentMarkCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentMarkCountQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseAssessmentMarkCountQuery, CourseAssessmentMarkCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentMarkCountQuery, CourseAssessmentMarkCountQueryVariables>(
		CourseAssessmentMarkCountDocument,
		options,
	);
}
export function useCourseAssessmentMarkCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseAssessmentMarkCountQuery, CourseAssessmentMarkCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentMarkCountQuery, CourseAssessmentMarkCountQueryVariables>(
		CourseAssessmentMarkCountDocument,
		options,
	);
}
export function useCourseAssessmentMarkCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentMarkCountQuery,
		CourseAssessmentMarkCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentMarkCountQuery, CourseAssessmentMarkCountQueryVariables>(
		CourseAssessmentMarkCountDocument,
		options,
	);
}
export type CourseAssessmentMarkCountQueryHookResult = ReturnType<typeof useCourseAssessmentMarkCountQuery>;
export type CourseAssessmentMarkCountLazyQueryHookResult = ReturnType<typeof useCourseAssessmentMarkCountLazyQuery>;
export type CourseAssessmentMarkCountSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentMarkCountSuspenseQuery
>;
export type CourseAssessmentMarkCountQueryResult = Apollo.QueryResult<
	CourseAssessmentMarkCountQuery,
	CourseAssessmentMarkCountQueryVariables
>;
export const CourseAssessmentMarkCreateDocument = gql`
	mutation courseAssessmentMarkCreate($input: CourseAssessmentMarkCreateInput!) {
		createCourseAssessmentMark(input: $input) {
			...CourseAssessmentMarkDetail
		}
	}
	${CourseAssessmentMarkDetailFragmentDoc}
`;
export type CourseAssessmentMarkCreateMutationFn = Apollo.MutationFunction<
	CourseAssessmentMarkCreateMutation,
	CourseAssessmentMarkCreateMutationVariables
>;

/**
 * __useCourseAssessmentMarkCreateMutation__
 *
 * To run a mutation, you first call `useCourseAssessmentMarkCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentMarkCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAssessmentMarkCreateMutation, { data, loading, error }] = useCourseAssessmentMarkCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseAssessmentMarkCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAssessmentMarkCreateMutation,
		CourseAssessmentMarkCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseAssessmentMarkCreateMutation, CourseAssessmentMarkCreateMutationVariables>(
		CourseAssessmentMarkCreateDocument,
		options,
	);
}
export type CourseAssessmentMarkCreateMutationHookResult = ReturnType<typeof useCourseAssessmentMarkCreateMutation>;
export type CourseAssessmentMarkCreateMutationResult = Apollo.MutationResult<CourseAssessmentMarkCreateMutation>;
export type CourseAssessmentMarkCreateMutationOptions = Apollo.BaseMutationOptions<
	CourseAssessmentMarkCreateMutation,
	CourseAssessmentMarkCreateMutationVariables
>;
export const CourseAssessmentMarkDeleteDocument = gql`
	mutation courseAssessmentMarkDelete($id: ID!) {
		deleteCourseAssessmentMark(id: $id)
	}
`;
export type CourseAssessmentMarkDeleteMutationFn = Apollo.MutationFunction<
	CourseAssessmentMarkDeleteMutation,
	CourseAssessmentMarkDeleteMutationVariables
>;

/**
 * __useCourseAssessmentMarkDeleteMutation__
 *
 * To run a mutation, you first call `useCourseAssessmentMarkDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentMarkDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAssessmentMarkDeleteMutation, { data, loading, error }] = useCourseAssessmentMarkDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAssessmentMarkDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAssessmentMarkDeleteMutation,
		CourseAssessmentMarkDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseAssessmentMarkDeleteMutation, CourseAssessmentMarkDeleteMutationVariables>(
		CourseAssessmentMarkDeleteDocument,
		options,
	);
}
export type CourseAssessmentMarkDeleteMutationHookResult = ReturnType<typeof useCourseAssessmentMarkDeleteMutation>;
export type CourseAssessmentMarkDeleteMutationResult = Apollo.MutationResult<CourseAssessmentMarkDeleteMutation>;
export type CourseAssessmentMarkDeleteMutationOptions = Apollo.BaseMutationOptions<
	CourseAssessmentMarkDeleteMutation,
	CourseAssessmentMarkDeleteMutationVariables
>;
export const CourseAssessmentMarkDetailDocument = gql`
	query courseAssessmentMarkDetail($id: ID!) {
		courseAssessmentMark(id: $id) {
			...CourseAssessmentMarkDetail
		}
	}
	${CourseAssessmentMarkDetailFragmentDoc}
`;

/**
 * __useCourseAssessmentMarkDetailQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentMarkDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentMarkDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentMarkDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAssessmentMarkDetailQuery(
	baseOptions: Apollo.QueryHookOptions<CourseAssessmentMarkDetailQuery, CourseAssessmentMarkDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentMarkDetailQuery, CourseAssessmentMarkDetailQueryVariables>(
		CourseAssessmentMarkDetailDocument,
		options,
	);
}
export function useCourseAssessmentMarkDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseAssessmentMarkDetailQuery, CourseAssessmentMarkDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentMarkDetailQuery, CourseAssessmentMarkDetailQueryVariables>(
		CourseAssessmentMarkDetailDocument,
		options,
	);
}
export function useCourseAssessmentMarkDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentMarkDetailQuery,
		CourseAssessmentMarkDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentMarkDetailQuery, CourseAssessmentMarkDetailQueryVariables>(
		CourseAssessmentMarkDetailDocument,
		options,
	);
}
export type CourseAssessmentMarkDetailQueryHookResult = ReturnType<typeof useCourseAssessmentMarkDetailQuery>;
export type CourseAssessmentMarkDetailLazyQueryHookResult = ReturnType<typeof useCourseAssessmentMarkDetailLazyQuery>;
export type CourseAssessmentMarkDetailSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentMarkDetailSuspenseQuery
>;
export type CourseAssessmentMarkDetailQueryResult = Apollo.QueryResult<
	CourseAssessmentMarkDetailQuery,
	CourseAssessmentMarkDetailQueryVariables
>;
export const CourseAssessmentMarkIndexDocument = gql`
	query courseAssessmentMarkIndex(
		$filters: [CourseAssessmentMarkFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentMarkOrder
	) {
		courseAssessmentMarkConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					points
					isExcused
					wasLate
					notes
				}
			}
		}
	}
`;

/**
 * __useCourseAssessmentMarkIndexQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentMarkIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentMarkIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentMarkIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentMarkIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseAssessmentMarkIndexQuery, CourseAssessmentMarkIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentMarkIndexQuery, CourseAssessmentMarkIndexQueryVariables>(
		CourseAssessmentMarkIndexDocument,
		options,
	);
}
export function useCourseAssessmentMarkIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseAssessmentMarkIndexQuery, CourseAssessmentMarkIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentMarkIndexQuery, CourseAssessmentMarkIndexQueryVariables>(
		CourseAssessmentMarkIndexDocument,
		options,
	);
}
export function useCourseAssessmentMarkIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentMarkIndexQuery,
		CourseAssessmentMarkIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentMarkIndexQuery, CourseAssessmentMarkIndexQueryVariables>(
		CourseAssessmentMarkIndexDocument,
		options,
	);
}
export type CourseAssessmentMarkIndexQueryHookResult = ReturnType<typeof useCourseAssessmentMarkIndexQuery>;
export type CourseAssessmentMarkIndexLazyQueryHookResult = ReturnType<typeof useCourseAssessmentMarkIndexLazyQuery>;
export type CourseAssessmentMarkIndexSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentMarkIndexSuspenseQuery
>;
export type CourseAssessmentMarkIndexQueryResult = Apollo.QueryResult<
	CourseAssessmentMarkIndexQuery,
	CourseAssessmentMarkIndexQueryVariables
>;
export const CourseAssessmentMarkNameDocument = gql`
	query courseAssessmentMarkName($id: ID!) {
		courseAssessmentMark(id: $id) {
			id
			...CourseAssessmentMarkName
		}
	}
	${CourseAssessmentMarkNameFragmentDoc}
`;

/**
 * __useCourseAssessmentMarkNameQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentMarkNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentMarkNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentMarkNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAssessmentMarkNameQuery(
	baseOptions: Apollo.QueryHookOptions<CourseAssessmentMarkNameQuery, CourseAssessmentMarkNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentMarkNameQuery, CourseAssessmentMarkNameQueryVariables>(
		CourseAssessmentMarkNameDocument,
		options,
	);
}
export function useCourseAssessmentMarkNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseAssessmentMarkNameQuery, CourseAssessmentMarkNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentMarkNameQuery, CourseAssessmentMarkNameQueryVariables>(
		CourseAssessmentMarkNameDocument,
		options,
	);
}
export function useCourseAssessmentMarkNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseAssessmentMarkNameQuery, CourseAssessmentMarkNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentMarkNameQuery, CourseAssessmentMarkNameQueryVariables>(
		CourseAssessmentMarkNameDocument,
		options,
	);
}
export type CourseAssessmentMarkNameQueryHookResult = ReturnType<typeof useCourseAssessmentMarkNameQuery>;
export type CourseAssessmentMarkNameLazyQueryHookResult = ReturnType<typeof useCourseAssessmentMarkNameLazyQuery>;
export type CourseAssessmentMarkNameSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentMarkNameSuspenseQuery
>;
export type CourseAssessmentMarkNameQueryResult = Apollo.QueryResult<
	CourseAssessmentMarkNameQuery,
	CourseAssessmentMarkNameQueryVariables
>;
export const CourseAssessmentMarkNamesDocument = gql`
	query courseAssessmentMarkNames(
		$filters: [CourseAssessmentMarkFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentMarkOrder
	) {
		courseAssessmentMarkConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...CourseAssessmentMarkName
				}
			}
		}
	}
	${CourseAssessmentMarkNameFragmentDoc}
`;

/**
 * __useCourseAssessmentMarkNamesQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentMarkNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentMarkNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentMarkNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentMarkNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseAssessmentMarkNamesQuery, CourseAssessmentMarkNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentMarkNamesQuery, CourseAssessmentMarkNamesQueryVariables>(
		CourseAssessmentMarkNamesDocument,
		options,
	);
}
export function useCourseAssessmentMarkNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseAssessmentMarkNamesQuery, CourseAssessmentMarkNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentMarkNamesQuery, CourseAssessmentMarkNamesQueryVariables>(
		CourseAssessmentMarkNamesDocument,
		options,
	);
}
export function useCourseAssessmentMarkNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentMarkNamesQuery,
		CourseAssessmentMarkNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentMarkNamesQuery, CourseAssessmentMarkNamesQueryVariables>(
		CourseAssessmentMarkNamesDocument,
		options,
	);
}
export type CourseAssessmentMarkNamesQueryHookResult = ReturnType<typeof useCourseAssessmentMarkNamesQuery>;
export type CourseAssessmentMarkNamesLazyQueryHookResult = ReturnType<typeof useCourseAssessmentMarkNamesLazyQuery>;
export type CourseAssessmentMarkNamesSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentMarkNamesSuspenseQuery
>;
export type CourseAssessmentMarkNamesQueryResult = Apollo.QueryResult<
	CourseAssessmentMarkNamesQuery,
	CourseAssessmentMarkNamesQueryVariables
>;
export const CourseAssessmentMarkPaginationDocument = gql`
	query courseAssessmentMarkPagination(
		$filters: [CourseAssessmentMarkFilterInput!]
		$order: CourseAssessmentMarkOrder
	) {
		courseAssessmentMarkConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useCourseAssessmentMarkPaginationQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentMarkPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentMarkPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentMarkPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentMarkPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseAssessmentMarkPaginationQuery,
		CourseAssessmentMarkPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentMarkPaginationQuery, CourseAssessmentMarkPaginationQueryVariables>(
		CourseAssessmentMarkPaginationDocument,
		options,
	);
}
export function useCourseAssessmentMarkPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentMarkPaginationQuery,
		CourseAssessmentMarkPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentMarkPaginationQuery, CourseAssessmentMarkPaginationQueryVariables>(
		CourseAssessmentMarkPaginationDocument,
		options,
	);
}
export function useCourseAssessmentMarkPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentMarkPaginationQuery,
		CourseAssessmentMarkPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentMarkPaginationQuery, CourseAssessmentMarkPaginationQueryVariables>(
		CourseAssessmentMarkPaginationDocument,
		options,
	);
}
export type CourseAssessmentMarkPaginationQueryHookResult = ReturnType<typeof useCourseAssessmentMarkPaginationQuery>;
export type CourseAssessmentMarkPaginationLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentMarkPaginationLazyQuery
>;
export type CourseAssessmentMarkPaginationSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentMarkPaginationSuspenseQuery
>;
export type CourseAssessmentMarkPaginationQueryResult = Apollo.QueryResult<
	CourseAssessmentMarkPaginationQuery,
	CourseAssessmentMarkPaginationQueryVariables
>;
export const CourseAssessmentMarkSelectDocument = gql`
	query courseAssessmentMarkSelect($filters: [CourseAssessmentMarkFilterInput!], $order: CourseAssessmentMarkOrder) {
		courseAssessmentMarkConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...CourseAssessmentMarkName
				}
			}
		}
	}
	${CourseAssessmentMarkNameFragmentDoc}
`;

/**
 * __useCourseAssessmentMarkSelectQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentMarkSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentMarkSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentMarkSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentMarkSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseAssessmentMarkSelectQuery, CourseAssessmentMarkSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentMarkSelectQuery, CourseAssessmentMarkSelectQueryVariables>(
		CourseAssessmentMarkSelectDocument,
		options,
	);
}
export function useCourseAssessmentMarkSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseAssessmentMarkSelectQuery, CourseAssessmentMarkSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentMarkSelectQuery, CourseAssessmentMarkSelectQueryVariables>(
		CourseAssessmentMarkSelectDocument,
		options,
	);
}
export function useCourseAssessmentMarkSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentMarkSelectQuery,
		CourseAssessmentMarkSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentMarkSelectQuery, CourseAssessmentMarkSelectQueryVariables>(
		CourseAssessmentMarkSelectDocument,
		options,
	);
}
export type CourseAssessmentMarkSelectQueryHookResult = ReturnType<typeof useCourseAssessmentMarkSelectQuery>;
export type CourseAssessmentMarkSelectLazyQueryHookResult = ReturnType<typeof useCourseAssessmentMarkSelectLazyQuery>;
export type CourseAssessmentMarkSelectSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentMarkSelectSuspenseQuery
>;
export type CourseAssessmentMarkSelectQueryResult = Apollo.QueryResult<
	CourseAssessmentMarkSelectQuery,
	CourseAssessmentMarkSelectQueryVariables
>;
export const CourseAssessmentMarkUpdateDocument = gql`
	mutation courseAssessmentMarkUpdate($id: ID!, $input: CourseAssessmentMarkUpdateInput!) {
		updateCourseAssessmentMark(id: $id, input: $input) {
			...CourseAssessmentMarkDetail
		}
	}
	${CourseAssessmentMarkDetailFragmentDoc}
`;
export type CourseAssessmentMarkUpdateMutationFn = Apollo.MutationFunction<
	CourseAssessmentMarkUpdateMutation,
	CourseAssessmentMarkUpdateMutationVariables
>;

/**
 * __useCourseAssessmentMarkUpdateMutation__
 *
 * To run a mutation, you first call `useCourseAssessmentMarkUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentMarkUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAssessmentMarkUpdateMutation, { data, loading, error }] = useCourseAssessmentMarkUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseAssessmentMarkUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAssessmentMarkUpdateMutation,
		CourseAssessmentMarkUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseAssessmentMarkUpdateMutation, CourseAssessmentMarkUpdateMutationVariables>(
		CourseAssessmentMarkUpdateDocument,
		options,
	);
}
export type CourseAssessmentMarkUpdateMutationHookResult = ReturnType<typeof useCourseAssessmentMarkUpdateMutation>;
export type CourseAssessmentMarkUpdateMutationResult = Apollo.MutationResult<CourseAssessmentMarkUpdateMutation>;
export type CourseAssessmentMarkUpdateMutationOptions = Apollo.BaseMutationOptions<
	CourseAssessmentMarkUpdateMutation,
	CourseAssessmentMarkUpdateMutationVariables
>;
export const CourseAssessmentSubmissionCountDocument = gql`
	query courseAssessmentSubmissionCount(
		$filters: [CourseAssessmentSubmissionFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentSubmissionOrder
	) {
		courseAssessmentSubmissionConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useCourseAssessmentSubmissionCountQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentSubmissionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentSubmissionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentSubmissionCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentSubmissionCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseAssessmentSubmissionCountQuery,
		CourseAssessmentSubmissionCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentSubmissionCountQuery, CourseAssessmentSubmissionCountQueryVariables>(
		CourseAssessmentSubmissionCountDocument,
		options,
	);
}
export function useCourseAssessmentSubmissionCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentSubmissionCountQuery,
		CourseAssessmentSubmissionCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentSubmissionCountQuery, CourseAssessmentSubmissionCountQueryVariables>(
		CourseAssessmentSubmissionCountDocument,
		options,
	);
}
export function useCourseAssessmentSubmissionCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentSubmissionCountQuery,
		CourseAssessmentSubmissionCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentSubmissionCountQuery, CourseAssessmentSubmissionCountQueryVariables>(
		CourseAssessmentSubmissionCountDocument,
		options,
	);
}
export type CourseAssessmentSubmissionCountQueryHookResult = ReturnType<typeof useCourseAssessmentSubmissionCountQuery>;
export type CourseAssessmentSubmissionCountLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionCountLazyQuery
>;
export type CourseAssessmentSubmissionCountSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionCountSuspenseQuery
>;
export type CourseAssessmentSubmissionCountQueryResult = Apollo.QueryResult<
	CourseAssessmentSubmissionCountQuery,
	CourseAssessmentSubmissionCountQueryVariables
>;
export const CourseAssessmentSubmissionCreateDocument = gql`
	mutation courseAssessmentSubmissionCreate($input: CourseAssessmentSubmissionCreateInput!) {
		createCourseAssessmentSubmission(input: $input) {
			...CourseAssessmentSubmissionDetail
		}
	}
	${CourseAssessmentSubmissionDetailFragmentDoc}
`;
export type CourseAssessmentSubmissionCreateMutationFn = Apollo.MutationFunction<
	CourseAssessmentSubmissionCreateMutation,
	CourseAssessmentSubmissionCreateMutationVariables
>;

/**
 * __useCourseAssessmentSubmissionCreateMutation__
 *
 * To run a mutation, you first call `useCourseAssessmentSubmissionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentSubmissionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAssessmentSubmissionCreateMutation, { data, loading, error }] = useCourseAssessmentSubmissionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseAssessmentSubmissionCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAssessmentSubmissionCreateMutation,
		CourseAssessmentSubmissionCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CourseAssessmentSubmissionCreateMutation,
		CourseAssessmentSubmissionCreateMutationVariables
	>(CourseAssessmentSubmissionCreateDocument, options);
}
export type CourseAssessmentSubmissionCreateMutationHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionCreateMutation
>;
export type CourseAssessmentSubmissionCreateMutationResult =
	Apollo.MutationResult<CourseAssessmentSubmissionCreateMutation>;
export type CourseAssessmentSubmissionCreateMutationOptions = Apollo.BaseMutationOptions<
	CourseAssessmentSubmissionCreateMutation,
	CourseAssessmentSubmissionCreateMutationVariables
>;
export const CourseAssessmentSubmissionDeleteDocument = gql`
	mutation courseAssessmentSubmissionDelete($id: ID!) {
		deleteCourseAssessmentSubmission(id: $id)
	}
`;
export type CourseAssessmentSubmissionDeleteMutationFn = Apollo.MutationFunction<
	CourseAssessmentSubmissionDeleteMutation,
	CourseAssessmentSubmissionDeleteMutationVariables
>;

/**
 * __useCourseAssessmentSubmissionDeleteMutation__
 *
 * To run a mutation, you first call `useCourseAssessmentSubmissionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentSubmissionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAssessmentSubmissionDeleteMutation, { data, loading, error }] = useCourseAssessmentSubmissionDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAssessmentSubmissionDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAssessmentSubmissionDeleteMutation,
		CourseAssessmentSubmissionDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CourseAssessmentSubmissionDeleteMutation,
		CourseAssessmentSubmissionDeleteMutationVariables
	>(CourseAssessmentSubmissionDeleteDocument, options);
}
export type CourseAssessmentSubmissionDeleteMutationHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionDeleteMutation
>;
export type CourseAssessmentSubmissionDeleteMutationResult =
	Apollo.MutationResult<CourseAssessmentSubmissionDeleteMutation>;
export type CourseAssessmentSubmissionDeleteMutationOptions = Apollo.BaseMutationOptions<
	CourseAssessmentSubmissionDeleteMutation,
	CourseAssessmentSubmissionDeleteMutationVariables
>;
export const CourseAssessmentSubmissionDetailDocument = gql`
	query courseAssessmentSubmissionDetail($id: ID!) {
		courseAssessmentSubmission(id: $id) {
			...CourseAssessmentSubmissionDetail
		}
	}
	${CourseAssessmentSubmissionDetailFragmentDoc}
`;

/**
 * __useCourseAssessmentSubmissionDetailQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentSubmissionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentSubmissionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentSubmissionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAssessmentSubmissionDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		CourseAssessmentSubmissionDetailQuery,
		CourseAssessmentSubmissionDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentSubmissionDetailQuery, CourseAssessmentSubmissionDetailQueryVariables>(
		CourseAssessmentSubmissionDetailDocument,
		options,
	);
}
export function useCourseAssessmentSubmissionDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentSubmissionDetailQuery,
		CourseAssessmentSubmissionDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentSubmissionDetailQuery, CourseAssessmentSubmissionDetailQueryVariables>(
		CourseAssessmentSubmissionDetailDocument,
		options,
	);
}
export function useCourseAssessmentSubmissionDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentSubmissionDetailQuery,
		CourseAssessmentSubmissionDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentSubmissionDetailQuery, CourseAssessmentSubmissionDetailQueryVariables>(
		CourseAssessmentSubmissionDetailDocument,
		options,
	);
}
export type CourseAssessmentSubmissionDetailQueryHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionDetailQuery
>;
export type CourseAssessmentSubmissionDetailLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionDetailLazyQuery
>;
export type CourseAssessmentSubmissionDetailSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionDetailSuspenseQuery
>;
export type CourseAssessmentSubmissionDetailQueryResult = Apollo.QueryResult<
	CourseAssessmentSubmissionDetailQuery,
	CourseAssessmentSubmissionDetailQueryVariables
>;
export const CourseAssessmentSubmissionIndexDocument = gql`
	query courseAssessmentSubmissionIndex(
		$filters: [CourseAssessmentSubmissionFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentSubmissionOrder
	) {
		courseAssessmentSubmissionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					body
					submissionDate
				}
			}
		}
	}
`;

/**
 * __useCourseAssessmentSubmissionIndexQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentSubmissionIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentSubmissionIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentSubmissionIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentSubmissionIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseAssessmentSubmissionIndexQuery,
		CourseAssessmentSubmissionIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentSubmissionIndexQuery, CourseAssessmentSubmissionIndexQueryVariables>(
		CourseAssessmentSubmissionIndexDocument,
		options,
	);
}
export function useCourseAssessmentSubmissionIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentSubmissionIndexQuery,
		CourseAssessmentSubmissionIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentSubmissionIndexQuery, CourseAssessmentSubmissionIndexQueryVariables>(
		CourseAssessmentSubmissionIndexDocument,
		options,
	);
}
export function useCourseAssessmentSubmissionIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentSubmissionIndexQuery,
		CourseAssessmentSubmissionIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentSubmissionIndexQuery, CourseAssessmentSubmissionIndexQueryVariables>(
		CourseAssessmentSubmissionIndexDocument,
		options,
	);
}
export type CourseAssessmentSubmissionIndexQueryHookResult = ReturnType<typeof useCourseAssessmentSubmissionIndexQuery>;
export type CourseAssessmentSubmissionIndexLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionIndexLazyQuery
>;
export type CourseAssessmentSubmissionIndexSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionIndexSuspenseQuery
>;
export type CourseAssessmentSubmissionIndexQueryResult = Apollo.QueryResult<
	CourseAssessmentSubmissionIndexQuery,
	CourseAssessmentSubmissionIndexQueryVariables
>;
export const CourseAssessmentSubmissionNameDocument = gql`
	query courseAssessmentSubmissionName($id: ID!) {
		courseAssessmentSubmission(id: $id) {
			id
			...CourseAssessmentSubmissionName
		}
	}
	${CourseAssessmentSubmissionNameFragmentDoc}
`;

/**
 * __useCourseAssessmentSubmissionNameQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentSubmissionNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentSubmissionNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentSubmissionNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAssessmentSubmissionNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		CourseAssessmentSubmissionNameQuery,
		CourseAssessmentSubmissionNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentSubmissionNameQuery, CourseAssessmentSubmissionNameQueryVariables>(
		CourseAssessmentSubmissionNameDocument,
		options,
	);
}
export function useCourseAssessmentSubmissionNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentSubmissionNameQuery,
		CourseAssessmentSubmissionNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentSubmissionNameQuery, CourseAssessmentSubmissionNameQueryVariables>(
		CourseAssessmentSubmissionNameDocument,
		options,
	);
}
export function useCourseAssessmentSubmissionNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentSubmissionNameQuery,
		CourseAssessmentSubmissionNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentSubmissionNameQuery, CourseAssessmentSubmissionNameQueryVariables>(
		CourseAssessmentSubmissionNameDocument,
		options,
	);
}
export type CourseAssessmentSubmissionNameQueryHookResult = ReturnType<typeof useCourseAssessmentSubmissionNameQuery>;
export type CourseAssessmentSubmissionNameLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionNameLazyQuery
>;
export type CourseAssessmentSubmissionNameSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionNameSuspenseQuery
>;
export type CourseAssessmentSubmissionNameQueryResult = Apollo.QueryResult<
	CourseAssessmentSubmissionNameQuery,
	CourseAssessmentSubmissionNameQueryVariables
>;
export const CourseAssessmentSubmissionNamesDocument = gql`
	query courseAssessmentSubmissionNames(
		$filters: [CourseAssessmentSubmissionFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentSubmissionOrder
	) {
		courseAssessmentSubmissionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...CourseAssessmentSubmissionName
				}
			}
		}
	}
	${CourseAssessmentSubmissionNameFragmentDoc}
`;

/**
 * __useCourseAssessmentSubmissionNamesQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentSubmissionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentSubmissionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentSubmissionNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentSubmissionNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseAssessmentSubmissionNamesQuery,
		CourseAssessmentSubmissionNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentSubmissionNamesQuery, CourseAssessmentSubmissionNamesQueryVariables>(
		CourseAssessmentSubmissionNamesDocument,
		options,
	);
}
export function useCourseAssessmentSubmissionNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentSubmissionNamesQuery,
		CourseAssessmentSubmissionNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentSubmissionNamesQuery, CourseAssessmentSubmissionNamesQueryVariables>(
		CourseAssessmentSubmissionNamesDocument,
		options,
	);
}
export function useCourseAssessmentSubmissionNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentSubmissionNamesQuery,
		CourseAssessmentSubmissionNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentSubmissionNamesQuery, CourseAssessmentSubmissionNamesQueryVariables>(
		CourseAssessmentSubmissionNamesDocument,
		options,
	);
}
export type CourseAssessmentSubmissionNamesQueryHookResult = ReturnType<typeof useCourseAssessmentSubmissionNamesQuery>;
export type CourseAssessmentSubmissionNamesLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionNamesLazyQuery
>;
export type CourseAssessmentSubmissionNamesSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionNamesSuspenseQuery
>;
export type CourseAssessmentSubmissionNamesQueryResult = Apollo.QueryResult<
	CourseAssessmentSubmissionNamesQuery,
	CourseAssessmentSubmissionNamesQueryVariables
>;
export const CourseAssessmentSubmissionPaginationDocument = gql`
	query courseAssessmentSubmissionPagination(
		$filters: [CourseAssessmentSubmissionFilterInput!]
		$order: CourseAssessmentSubmissionOrder
	) {
		courseAssessmentSubmissionConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useCourseAssessmentSubmissionPaginationQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentSubmissionPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentSubmissionPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentSubmissionPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentSubmissionPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseAssessmentSubmissionPaginationQuery,
		CourseAssessmentSubmissionPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentSubmissionPaginationQuery, CourseAssessmentSubmissionPaginationQueryVariables>(
		CourseAssessmentSubmissionPaginationDocument,
		options,
	);
}
export function useCourseAssessmentSubmissionPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentSubmissionPaginationQuery,
		CourseAssessmentSubmissionPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CourseAssessmentSubmissionPaginationQuery,
		CourseAssessmentSubmissionPaginationQueryVariables
	>(CourseAssessmentSubmissionPaginationDocument, options);
}
export function useCourseAssessmentSubmissionPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentSubmissionPaginationQuery,
		CourseAssessmentSubmissionPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CourseAssessmentSubmissionPaginationQuery,
		CourseAssessmentSubmissionPaginationQueryVariables
	>(CourseAssessmentSubmissionPaginationDocument, options);
}
export type CourseAssessmentSubmissionPaginationQueryHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionPaginationQuery
>;
export type CourseAssessmentSubmissionPaginationLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionPaginationLazyQuery
>;
export type CourseAssessmentSubmissionPaginationSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionPaginationSuspenseQuery
>;
export type CourseAssessmentSubmissionPaginationQueryResult = Apollo.QueryResult<
	CourseAssessmentSubmissionPaginationQuery,
	CourseAssessmentSubmissionPaginationQueryVariables
>;
export const CourseAssessmentSubmissionSelectDocument = gql`
	query courseAssessmentSubmissionSelect(
		$filters: [CourseAssessmentSubmissionFilterInput!]
		$order: CourseAssessmentSubmissionOrder
	) {
		courseAssessmentSubmissionConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...CourseAssessmentSubmissionName
				}
			}
		}
	}
	${CourseAssessmentSubmissionNameFragmentDoc}
`;

/**
 * __useCourseAssessmentSubmissionSelectQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentSubmissionSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentSubmissionSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentSubmissionSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentSubmissionSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseAssessmentSubmissionSelectQuery,
		CourseAssessmentSubmissionSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentSubmissionSelectQuery, CourseAssessmentSubmissionSelectQueryVariables>(
		CourseAssessmentSubmissionSelectDocument,
		options,
	);
}
export function useCourseAssessmentSubmissionSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentSubmissionSelectQuery,
		CourseAssessmentSubmissionSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentSubmissionSelectQuery, CourseAssessmentSubmissionSelectQueryVariables>(
		CourseAssessmentSubmissionSelectDocument,
		options,
	);
}
export function useCourseAssessmentSubmissionSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentSubmissionSelectQuery,
		CourseAssessmentSubmissionSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentSubmissionSelectQuery, CourseAssessmentSubmissionSelectQueryVariables>(
		CourseAssessmentSubmissionSelectDocument,
		options,
	);
}
export type CourseAssessmentSubmissionSelectQueryHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionSelectQuery
>;
export type CourseAssessmentSubmissionSelectLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionSelectLazyQuery
>;
export type CourseAssessmentSubmissionSelectSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionSelectSuspenseQuery
>;
export type CourseAssessmentSubmissionSelectQueryResult = Apollo.QueryResult<
	CourseAssessmentSubmissionSelectQuery,
	CourseAssessmentSubmissionSelectQueryVariables
>;
export const CourseAssessmentSubmissionUpdateDocument = gql`
	mutation courseAssessmentSubmissionUpdate($id: ID!, $input: CourseAssessmentSubmissionUpdateInput!) {
		updateCourseAssessmentSubmission(id: $id, input: $input) {
			...CourseAssessmentSubmissionDetail
		}
	}
	${CourseAssessmentSubmissionDetailFragmentDoc}
`;
export type CourseAssessmentSubmissionUpdateMutationFn = Apollo.MutationFunction<
	CourseAssessmentSubmissionUpdateMutation,
	CourseAssessmentSubmissionUpdateMutationVariables
>;

/**
 * __useCourseAssessmentSubmissionUpdateMutation__
 *
 * To run a mutation, you first call `useCourseAssessmentSubmissionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentSubmissionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAssessmentSubmissionUpdateMutation, { data, loading, error }] = useCourseAssessmentSubmissionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseAssessmentSubmissionUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAssessmentSubmissionUpdateMutation,
		CourseAssessmentSubmissionUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CourseAssessmentSubmissionUpdateMutation,
		CourseAssessmentSubmissionUpdateMutationVariables
	>(CourseAssessmentSubmissionUpdateDocument, options);
}
export type CourseAssessmentSubmissionUpdateMutationHookResult = ReturnType<
	typeof useCourseAssessmentSubmissionUpdateMutation
>;
export type CourseAssessmentSubmissionUpdateMutationResult =
	Apollo.MutationResult<CourseAssessmentSubmissionUpdateMutation>;
export type CourseAssessmentSubmissionUpdateMutationOptions = Apollo.BaseMutationOptions<
	CourseAssessmentSubmissionUpdateMutation,
	CourseAssessmentSubmissionUpdateMutationVariables
>;
export const CourseAssessmentTimingCountDocument = gql`
	query courseAssessmentTimingCount(
		$filters: [CourseAssessmentTimingFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentTimingOrder
	) {
		courseAssessmentTimingConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useCourseAssessmentTimingCountQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentTimingCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentTimingCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentTimingCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentTimingCountQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseAssessmentTimingCountQuery, CourseAssessmentTimingCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentTimingCountQuery, CourseAssessmentTimingCountQueryVariables>(
		CourseAssessmentTimingCountDocument,
		options,
	);
}
export function useCourseAssessmentTimingCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentTimingCountQuery,
		CourseAssessmentTimingCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentTimingCountQuery, CourseAssessmentTimingCountQueryVariables>(
		CourseAssessmentTimingCountDocument,
		options,
	);
}
export function useCourseAssessmentTimingCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentTimingCountQuery,
		CourseAssessmentTimingCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentTimingCountQuery, CourseAssessmentTimingCountQueryVariables>(
		CourseAssessmentTimingCountDocument,
		options,
	);
}
export type CourseAssessmentTimingCountQueryHookResult = ReturnType<typeof useCourseAssessmentTimingCountQuery>;
export type CourseAssessmentTimingCountLazyQueryHookResult = ReturnType<typeof useCourseAssessmentTimingCountLazyQuery>;
export type CourseAssessmentTimingCountSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentTimingCountSuspenseQuery
>;
export type CourseAssessmentTimingCountQueryResult = Apollo.QueryResult<
	CourseAssessmentTimingCountQuery,
	CourseAssessmentTimingCountQueryVariables
>;
export const CourseAssessmentTimingCreateDocument = gql`
	mutation courseAssessmentTimingCreate($input: CourseAssessmentTimingCreateInput!) {
		createCourseAssessmentTiming(input: $input) {
			...CourseAssessmentTimingDetail
		}
	}
	${CourseAssessmentTimingDetailFragmentDoc}
`;
export type CourseAssessmentTimingCreateMutationFn = Apollo.MutationFunction<
	CourseAssessmentTimingCreateMutation,
	CourseAssessmentTimingCreateMutationVariables
>;

/**
 * __useCourseAssessmentTimingCreateMutation__
 *
 * To run a mutation, you first call `useCourseAssessmentTimingCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentTimingCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAssessmentTimingCreateMutation, { data, loading, error }] = useCourseAssessmentTimingCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseAssessmentTimingCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAssessmentTimingCreateMutation,
		CourseAssessmentTimingCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseAssessmentTimingCreateMutation, CourseAssessmentTimingCreateMutationVariables>(
		CourseAssessmentTimingCreateDocument,
		options,
	);
}
export type CourseAssessmentTimingCreateMutationHookResult = ReturnType<typeof useCourseAssessmentTimingCreateMutation>;
export type CourseAssessmentTimingCreateMutationResult = Apollo.MutationResult<CourseAssessmentTimingCreateMutation>;
export type CourseAssessmentTimingCreateMutationOptions = Apollo.BaseMutationOptions<
	CourseAssessmentTimingCreateMutation,
	CourseAssessmentTimingCreateMutationVariables
>;
export const CourseAssessmentTimingDeleteDocument = gql`
	mutation courseAssessmentTimingDelete($id: ID!) {
		deleteCourseAssessmentTiming(id: $id)
	}
`;
export type CourseAssessmentTimingDeleteMutationFn = Apollo.MutationFunction<
	CourseAssessmentTimingDeleteMutation,
	CourseAssessmentTimingDeleteMutationVariables
>;

/**
 * __useCourseAssessmentTimingDeleteMutation__
 *
 * To run a mutation, you first call `useCourseAssessmentTimingDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentTimingDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAssessmentTimingDeleteMutation, { data, loading, error }] = useCourseAssessmentTimingDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAssessmentTimingDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAssessmentTimingDeleteMutation,
		CourseAssessmentTimingDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseAssessmentTimingDeleteMutation, CourseAssessmentTimingDeleteMutationVariables>(
		CourseAssessmentTimingDeleteDocument,
		options,
	);
}
export type CourseAssessmentTimingDeleteMutationHookResult = ReturnType<typeof useCourseAssessmentTimingDeleteMutation>;
export type CourseAssessmentTimingDeleteMutationResult = Apollo.MutationResult<CourseAssessmentTimingDeleteMutation>;
export type CourseAssessmentTimingDeleteMutationOptions = Apollo.BaseMutationOptions<
	CourseAssessmentTimingDeleteMutation,
	CourseAssessmentTimingDeleteMutationVariables
>;
export const CourseAssessmentTimingDetailDocument = gql`
	query courseAssessmentTimingDetail($id: ID!) {
		courseAssessmentTiming(id: $id) {
			...CourseAssessmentTimingDetail
		}
	}
	${CourseAssessmentTimingDetailFragmentDoc}
`;

/**
 * __useCourseAssessmentTimingDetailQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentTimingDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentTimingDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentTimingDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAssessmentTimingDetailQuery(
	baseOptions: Apollo.QueryHookOptions<CourseAssessmentTimingDetailQuery, CourseAssessmentTimingDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentTimingDetailQuery, CourseAssessmentTimingDetailQueryVariables>(
		CourseAssessmentTimingDetailDocument,
		options,
	);
}
export function useCourseAssessmentTimingDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentTimingDetailQuery,
		CourseAssessmentTimingDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentTimingDetailQuery, CourseAssessmentTimingDetailQueryVariables>(
		CourseAssessmentTimingDetailDocument,
		options,
	);
}
export function useCourseAssessmentTimingDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentTimingDetailQuery,
		CourseAssessmentTimingDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentTimingDetailQuery, CourseAssessmentTimingDetailQueryVariables>(
		CourseAssessmentTimingDetailDocument,
		options,
	);
}
export type CourseAssessmentTimingDetailQueryHookResult = ReturnType<typeof useCourseAssessmentTimingDetailQuery>;
export type CourseAssessmentTimingDetailLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentTimingDetailLazyQuery
>;
export type CourseAssessmentTimingDetailSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentTimingDetailSuspenseQuery
>;
export type CourseAssessmentTimingDetailQueryResult = Apollo.QueryResult<
	CourseAssessmentTimingDetailQuery,
	CourseAssessmentTimingDetailQueryVariables
>;
export const CourseAssessmentTimingIndexDocument = gql`
	query courseAssessmentTimingIndex(
		$filters: [CourseAssessmentTimingFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentTimingOrder
	) {
		courseAssessmentTimingConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					assignOn
					dueOn
				}
			}
		}
	}
`;

/**
 * __useCourseAssessmentTimingIndexQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentTimingIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentTimingIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentTimingIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentTimingIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseAssessmentTimingIndexQuery, CourseAssessmentTimingIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentTimingIndexQuery, CourseAssessmentTimingIndexQueryVariables>(
		CourseAssessmentTimingIndexDocument,
		options,
	);
}
export function useCourseAssessmentTimingIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentTimingIndexQuery,
		CourseAssessmentTimingIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentTimingIndexQuery, CourseAssessmentTimingIndexQueryVariables>(
		CourseAssessmentTimingIndexDocument,
		options,
	);
}
export function useCourseAssessmentTimingIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentTimingIndexQuery,
		CourseAssessmentTimingIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentTimingIndexQuery, CourseAssessmentTimingIndexQueryVariables>(
		CourseAssessmentTimingIndexDocument,
		options,
	);
}
export type CourseAssessmentTimingIndexQueryHookResult = ReturnType<typeof useCourseAssessmentTimingIndexQuery>;
export type CourseAssessmentTimingIndexLazyQueryHookResult = ReturnType<typeof useCourseAssessmentTimingIndexLazyQuery>;
export type CourseAssessmentTimingIndexSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentTimingIndexSuspenseQuery
>;
export type CourseAssessmentTimingIndexQueryResult = Apollo.QueryResult<
	CourseAssessmentTimingIndexQuery,
	CourseAssessmentTimingIndexQueryVariables
>;
export const CourseAssessmentTimingNameDocument = gql`
	query courseAssessmentTimingName($id: ID!) {
		courseAssessmentTiming(id: $id) {
			id
			...CourseAssessmentTimingName
		}
	}
	${CourseAssessmentTimingNameFragmentDoc}
`;

/**
 * __useCourseAssessmentTimingNameQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentTimingNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentTimingNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentTimingNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAssessmentTimingNameQuery(
	baseOptions: Apollo.QueryHookOptions<CourseAssessmentTimingNameQuery, CourseAssessmentTimingNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentTimingNameQuery, CourseAssessmentTimingNameQueryVariables>(
		CourseAssessmentTimingNameDocument,
		options,
	);
}
export function useCourseAssessmentTimingNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseAssessmentTimingNameQuery, CourseAssessmentTimingNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentTimingNameQuery, CourseAssessmentTimingNameQueryVariables>(
		CourseAssessmentTimingNameDocument,
		options,
	);
}
export function useCourseAssessmentTimingNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentTimingNameQuery,
		CourseAssessmentTimingNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentTimingNameQuery, CourseAssessmentTimingNameQueryVariables>(
		CourseAssessmentTimingNameDocument,
		options,
	);
}
export type CourseAssessmentTimingNameQueryHookResult = ReturnType<typeof useCourseAssessmentTimingNameQuery>;
export type CourseAssessmentTimingNameLazyQueryHookResult = ReturnType<typeof useCourseAssessmentTimingNameLazyQuery>;
export type CourseAssessmentTimingNameSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentTimingNameSuspenseQuery
>;
export type CourseAssessmentTimingNameQueryResult = Apollo.QueryResult<
	CourseAssessmentTimingNameQuery,
	CourseAssessmentTimingNameQueryVariables
>;
export const CourseAssessmentTimingNamesDocument = gql`
	query courseAssessmentTimingNames(
		$filters: [CourseAssessmentTimingFilterInput!]
		$pagination: Pagination
		$order: CourseAssessmentTimingOrder
	) {
		courseAssessmentTimingConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...CourseAssessmentTimingName
				}
			}
		}
	}
	${CourseAssessmentTimingNameFragmentDoc}
`;

/**
 * __useCourseAssessmentTimingNamesQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentTimingNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentTimingNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentTimingNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentTimingNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseAssessmentTimingNamesQuery, CourseAssessmentTimingNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentTimingNamesQuery, CourseAssessmentTimingNamesQueryVariables>(
		CourseAssessmentTimingNamesDocument,
		options,
	);
}
export function useCourseAssessmentTimingNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentTimingNamesQuery,
		CourseAssessmentTimingNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentTimingNamesQuery, CourseAssessmentTimingNamesQueryVariables>(
		CourseAssessmentTimingNamesDocument,
		options,
	);
}
export function useCourseAssessmentTimingNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentTimingNamesQuery,
		CourseAssessmentTimingNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentTimingNamesQuery, CourseAssessmentTimingNamesQueryVariables>(
		CourseAssessmentTimingNamesDocument,
		options,
	);
}
export type CourseAssessmentTimingNamesQueryHookResult = ReturnType<typeof useCourseAssessmentTimingNamesQuery>;
export type CourseAssessmentTimingNamesLazyQueryHookResult = ReturnType<typeof useCourseAssessmentTimingNamesLazyQuery>;
export type CourseAssessmentTimingNamesSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentTimingNamesSuspenseQuery
>;
export type CourseAssessmentTimingNamesQueryResult = Apollo.QueryResult<
	CourseAssessmentTimingNamesQuery,
	CourseAssessmentTimingNamesQueryVariables
>;
export const CourseAssessmentTimingPaginationDocument = gql`
	query courseAssessmentTimingPagination(
		$filters: [CourseAssessmentTimingFilterInput!]
		$order: CourseAssessmentTimingOrder
	) {
		courseAssessmentTimingConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useCourseAssessmentTimingPaginationQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentTimingPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentTimingPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentTimingPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentTimingPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseAssessmentTimingPaginationQuery,
		CourseAssessmentTimingPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentTimingPaginationQuery, CourseAssessmentTimingPaginationQueryVariables>(
		CourseAssessmentTimingPaginationDocument,
		options,
	);
}
export function useCourseAssessmentTimingPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentTimingPaginationQuery,
		CourseAssessmentTimingPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentTimingPaginationQuery, CourseAssessmentTimingPaginationQueryVariables>(
		CourseAssessmentTimingPaginationDocument,
		options,
	);
}
export function useCourseAssessmentTimingPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentTimingPaginationQuery,
		CourseAssessmentTimingPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentTimingPaginationQuery, CourseAssessmentTimingPaginationQueryVariables>(
		CourseAssessmentTimingPaginationDocument,
		options,
	);
}
export type CourseAssessmentTimingPaginationQueryHookResult = ReturnType<
	typeof useCourseAssessmentTimingPaginationQuery
>;
export type CourseAssessmentTimingPaginationLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentTimingPaginationLazyQuery
>;
export type CourseAssessmentTimingPaginationSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentTimingPaginationSuspenseQuery
>;
export type CourseAssessmentTimingPaginationQueryResult = Apollo.QueryResult<
	CourseAssessmentTimingPaginationQuery,
	CourseAssessmentTimingPaginationQueryVariables
>;
export const CourseAssessmentTimingSelectDocument = gql`
	query courseAssessmentTimingSelect(
		$filters: [CourseAssessmentTimingFilterInput!]
		$order: CourseAssessmentTimingOrder
	) {
		courseAssessmentTimingConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...CourseAssessmentTimingName
				}
			}
		}
	}
	${CourseAssessmentTimingNameFragmentDoc}
`;

/**
 * __useCourseAssessmentTimingSelectQuery__
 *
 * To run a query within a React component, call `useCourseAssessmentTimingSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentTimingSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAssessmentTimingSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAssessmentTimingSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseAssessmentTimingSelectQuery, CourseAssessmentTimingSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAssessmentTimingSelectQuery, CourseAssessmentTimingSelectQueryVariables>(
		CourseAssessmentTimingSelectDocument,
		options,
	);
}
export function useCourseAssessmentTimingSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAssessmentTimingSelectQuery,
		CourseAssessmentTimingSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAssessmentTimingSelectQuery, CourseAssessmentTimingSelectQueryVariables>(
		CourseAssessmentTimingSelectDocument,
		options,
	);
}
export function useCourseAssessmentTimingSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAssessmentTimingSelectQuery,
		CourseAssessmentTimingSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAssessmentTimingSelectQuery, CourseAssessmentTimingSelectQueryVariables>(
		CourseAssessmentTimingSelectDocument,
		options,
	);
}
export type CourseAssessmentTimingSelectQueryHookResult = ReturnType<typeof useCourseAssessmentTimingSelectQuery>;
export type CourseAssessmentTimingSelectLazyQueryHookResult = ReturnType<
	typeof useCourseAssessmentTimingSelectLazyQuery
>;
export type CourseAssessmentTimingSelectSuspenseQueryHookResult = ReturnType<
	typeof useCourseAssessmentTimingSelectSuspenseQuery
>;
export type CourseAssessmentTimingSelectQueryResult = Apollo.QueryResult<
	CourseAssessmentTimingSelectQuery,
	CourseAssessmentTimingSelectQueryVariables
>;
export const CourseAssessmentTimingUpdateDocument = gql`
	mutation courseAssessmentTimingUpdate($id: ID!, $input: CourseAssessmentTimingUpdateInput!) {
		updateCourseAssessmentTiming(id: $id, input: $input) {
			...CourseAssessmentTimingDetail
		}
	}
	${CourseAssessmentTimingDetailFragmentDoc}
`;
export type CourseAssessmentTimingUpdateMutationFn = Apollo.MutationFunction<
	CourseAssessmentTimingUpdateMutation,
	CourseAssessmentTimingUpdateMutationVariables
>;

/**
 * __useCourseAssessmentTimingUpdateMutation__
 *
 * To run a mutation, you first call `useCourseAssessmentTimingUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAssessmentTimingUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAssessmentTimingUpdateMutation, { data, loading, error }] = useCourseAssessmentTimingUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseAssessmentTimingUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAssessmentTimingUpdateMutation,
		CourseAssessmentTimingUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseAssessmentTimingUpdateMutation, CourseAssessmentTimingUpdateMutationVariables>(
		CourseAssessmentTimingUpdateDocument,
		options,
	);
}
export type CourseAssessmentTimingUpdateMutationHookResult = ReturnType<typeof useCourseAssessmentTimingUpdateMutation>;
export type CourseAssessmentTimingUpdateMutationResult = Apollo.MutationResult<CourseAssessmentTimingUpdateMutation>;
export type CourseAssessmentTimingUpdateMutationOptions = Apollo.BaseMutationOptions<
	CourseAssessmentTimingUpdateMutation,
	CourseAssessmentTimingUpdateMutationVariables
>;
export const CourseAttendanceRecordCountDocument = gql`
	query courseAttendanceRecordCount(
		$filters: [CourseAttendanceRecordFilterInput!]
		$pagination: Pagination
		$order: CourseAttendanceRecordOrder
	) {
		courseAttendanceRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useCourseAttendanceRecordCountQuery__
 *
 * To run a query within a React component, call `useCourseAttendanceRecordCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAttendanceRecordCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAttendanceRecordCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAttendanceRecordCountQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseAttendanceRecordCountQuery, CourseAttendanceRecordCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAttendanceRecordCountQuery, CourseAttendanceRecordCountQueryVariables>(
		CourseAttendanceRecordCountDocument,
		options,
	);
}
export function useCourseAttendanceRecordCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAttendanceRecordCountQuery,
		CourseAttendanceRecordCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAttendanceRecordCountQuery, CourseAttendanceRecordCountQueryVariables>(
		CourseAttendanceRecordCountDocument,
		options,
	);
}
export function useCourseAttendanceRecordCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAttendanceRecordCountQuery,
		CourseAttendanceRecordCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAttendanceRecordCountQuery, CourseAttendanceRecordCountQueryVariables>(
		CourseAttendanceRecordCountDocument,
		options,
	);
}
export type CourseAttendanceRecordCountQueryHookResult = ReturnType<typeof useCourseAttendanceRecordCountQuery>;
export type CourseAttendanceRecordCountLazyQueryHookResult = ReturnType<typeof useCourseAttendanceRecordCountLazyQuery>;
export type CourseAttendanceRecordCountSuspenseQueryHookResult = ReturnType<
	typeof useCourseAttendanceRecordCountSuspenseQuery
>;
export type CourseAttendanceRecordCountQueryResult = Apollo.QueryResult<
	CourseAttendanceRecordCountQuery,
	CourseAttendanceRecordCountQueryVariables
>;
export const CourseAttendanceRecordBulkCreateDocument = gql`
	mutation courseAttendanceRecordBulkCreate($inputs: [CourseAttendanceRecordCreateInput!]!) {
		createBulkCourseAttendanceRecords(inputs: $inputs) {
			edges {
				node {
					id
				}
			}
		}
	}
`;
export type CourseAttendanceRecordBulkCreateMutationFn = Apollo.MutationFunction<
	CourseAttendanceRecordBulkCreateMutation,
	CourseAttendanceRecordBulkCreateMutationVariables
>;

/**
 * __useCourseAttendanceRecordBulkCreateMutation__
 *
 * To run a mutation, you first call `useCourseAttendanceRecordBulkCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAttendanceRecordBulkCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAttendanceRecordBulkCreateMutation, { data, loading, error }] = useCourseAttendanceRecordBulkCreateMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCourseAttendanceRecordBulkCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAttendanceRecordBulkCreateMutation,
		CourseAttendanceRecordBulkCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CourseAttendanceRecordBulkCreateMutation,
		CourseAttendanceRecordBulkCreateMutationVariables
	>(CourseAttendanceRecordBulkCreateDocument, options);
}
export type CourseAttendanceRecordBulkCreateMutationHookResult = ReturnType<
	typeof useCourseAttendanceRecordBulkCreateMutation
>;
export type CourseAttendanceRecordBulkCreateMutationResult =
	Apollo.MutationResult<CourseAttendanceRecordBulkCreateMutation>;
export type CourseAttendanceRecordBulkCreateMutationOptions = Apollo.BaseMutationOptions<
	CourseAttendanceRecordBulkCreateMutation,
	CourseAttendanceRecordBulkCreateMutationVariables
>;
export const CourseAttendanceRecordCreateDocument = gql`
	mutation courseAttendanceRecordCreate($input: CourseAttendanceRecordCreateInput!) {
		createCourseAttendanceRecord(input: $input) {
			...CourseAttendanceRecordDetail
		}
	}
	${CourseAttendanceRecordDetailFragmentDoc}
`;
export type CourseAttendanceRecordCreateMutationFn = Apollo.MutationFunction<
	CourseAttendanceRecordCreateMutation,
	CourseAttendanceRecordCreateMutationVariables
>;

/**
 * __useCourseAttendanceRecordCreateMutation__
 *
 * To run a mutation, you first call `useCourseAttendanceRecordCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAttendanceRecordCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAttendanceRecordCreateMutation, { data, loading, error }] = useCourseAttendanceRecordCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseAttendanceRecordCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAttendanceRecordCreateMutation,
		CourseAttendanceRecordCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseAttendanceRecordCreateMutation, CourseAttendanceRecordCreateMutationVariables>(
		CourseAttendanceRecordCreateDocument,
		options,
	);
}
export type CourseAttendanceRecordCreateMutationHookResult = ReturnType<typeof useCourseAttendanceRecordCreateMutation>;
export type CourseAttendanceRecordCreateMutationResult = Apollo.MutationResult<CourseAttendanceRecordCreateMutation>;
export type CourseAttendanceRecordCreateMutationOptions = Apollo.BaseMutationOptions<
	CourseAttendanceRecordCreateMutation,
	CourseAttendanceRecordCreateMutationVariables
>;
export const CourseAttendanceRecordDeleteDocument = gql`
	mutation courseAttendanceRecordDelete($id: ID!) {
		deleteCourseAttendanceRecord(id: $id)
	}
`;
export type CourseAttendanceRecordDeleteMutationFn = Apollo.MutationFunction<
	CourseAttendanceRecordDeleteMutation,
	CourseAttendanceRecordDeleteMutationVariables
>;

/**
 * __useCourseAttendanceRecordDeleteMutation__
 *
 * To run a mutation, you first call `useCourseAttendanceRecordDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAttendanceRecordDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAttendanceRecordDeleteMutation, { data, loading, error }] = useCourseAttendanceRecordDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAttendanceRecordDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAttendanceRecordDeleteMutation,
		CourseAttendanceRecordDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseAttendanceRecordDeleteMutation, CourseAttendanceRecordDeleteMutationVariables>(
		CourseAttendanceRecordDeleteDocument,
		options,
	);
}
export type CourseAttendanceRecordDeleteMutationHookResult = ReturnType<typeof useCourseAttendanceRecordDeleteMutation>;
export type CourseAttendanceRecordDeleteMutationResult = Apollo.MutationResult<CourseAttendanceRecordDeleteMutation>;
export type CourseAttendanceRecordDeleteMutationOptions = Apollo.BaseMutationOptions<
	CourseAttendanceRecordDeleteMutation,
	CourseAttendanceRecordDeleteMutationVariables
>;
export const CourseAttendanceRecordDetailDocument = gql`
	query courseAttendanceRecordDetail($id: ID!) {
		courseAttendanceRecord(id: $id) {
			...CourseAttendanceRecordDetail
		}
	}
	${CourseAttendanceRecordDetailFragmentDoc}
`;

/**
 * __useCourseAttendanceRecordDetailQuery__
 *
 * To run a query within a React component, call `useCourseAttendanceRecordDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAttendanceRecordDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAttendanceRecordDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAttendanceRecordDetailQuery(
	baseOptions: Apollo.QueryHookOptions<CourseAttendanceRecordDetailQuery, CourseAttendanceRecordDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAttendanceRecordDetailQuery, CourseAttendanceRecordDetailQueryVariables>(
		CourseAttendanceRecordDetailDocument,
		options,
	);
}
export function useCourseAttendanceRecordDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAttendanceRecordDetailQuery,
		CourseAttendanceRecordDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAttendanceRecordDetailQuery, CourseAttendanceRecordDetailQueryVariables>(
		CourseAttendanceRecordDetailDocument,
		options,
	);
}
export function useCourseAttendanceRecordDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAttendanceRecordDetailQuery,
		CourseAttendanceRecordDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAttendanceRecordDetailQuery, CourseAttendanceRecordDetailQueryVariables>(
		CourseAttendanceRecordDetailDocument,
		options,
	);
}
export type CourseAttendanceRecordDetailQueryHookResult = ReturnType<typeof useCourseAttendanceRecordDetailQuery>;
export type CourseAttendanceRecordDetailLazyQueryHookResult = ReturnType<
	typeof useCourseAttendanceRecordDetailLazyQuery
>;
export type CourseAttendanceRecordDetailSuspenseQueryHookResult = ReturnType<
	typeof useCourseAttendanceRecordDetailSuspenseQuery
>;
export type CourseAttendanceRecordDetailQueryResult = Apollo.QueryResult<
	CourseAttendanceRecordDetailQuery,
	CourseAttendanceRecordDetailQueryVariables
>;
export const CourseAttendanceRecordIndexDocument = gql`
	query courseAttendanceRecordIndex(
		$filters: [CourseAttendanceRecordFilterInput!]
		$pagination: Pagination
		$order: CourseAttendanceRecordOrder
	) {
		courseAttendanceRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					attendanceDate
					notes
				}
			}
		}
	}
`;

/**
 * __useCourseAttendanceRecordIndexQuery__
 *
 * To run a query within a React component, call `useCourseAttendanceRecordIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAttendanceRecordIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAttendanceRecordIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAttendanceRecordIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseAttendanceRecordIndexQuery, CourseAttendanceRecordIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAttendanceRecordIndexQuery, CourseAttendanceRecordIndexQueryVariables>(
		CourseAttendanceRecordIndexDocument,
		options,
	);
}
export function useCourseAttendanceRecordIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAttendanceRecordIndexQuery,
		CourseAttendanceRecordIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAttendanceRecordIndexQuery, CourseAttendanceRecordIndexQueryVariables>(
		CourseAttendanceRecordIndexDocument,
		options,
	);
}
export function useCourseAttendanceRecordIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAttendanceRecordIndexQuery,
		CourseAttendanceRecordIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAttendanceRecordIndexQuery, CourseAttendanceRecordIndexQueryVariables>(
		CourseAttendanceRecordIndexDocument,
		options,
	);
}
export type CourseAttendanceRecordIndexQueryHookResult = ReturnType<typeof useCourseAttendanceRecordIndexQuery>;
export type CourseAttendanceRecordIndexLazyQueryHookResult = ReturnType<typeof useCourseAttendanceRecordIndexLazyQuery>;
export type CourseAttendanceRecordIndexSuspenseQueryHookResult = ReturnType<
	typeof useCourseAttendanceRecordIndexSuspenseQuery
>;
export type CourseAttendanceRecordIndexQueryResult = Apollo.QueryResult<
	CourseAttendanceRecordIndexQuery,
	CourseAttendanceRecordIndexQueryVariables
>;
export const CourseAttendanceRecordListDocument = gql`
	query courseAttendanceRecordList(
		$filters: [CourseAttendanceRecordFilterInput!]
		$pagination: Pagination
		$order: CourseAttendanceRecordOrder
	) {
		courseAttendanceRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					attendanceDate
					notes
					attendanceStatus {
						id
						...AttendanceStatusName
						description
						...AttendanceStatusInfo
					}
					author {
						id
						...UserName
					}
					courseSectionPeriod {
						id
						...CourseSectionPeriodName
					}
					student {
						id
						...StudentName
					}
				}
			}
		}
	}
	${AttendanceStatusNameFragmentDoc}
	${AttendanceStatusInfoFragmentDoc}
	${UserNameFragmentDoc}
	${CourseSectionPeriodNameFragmentDoc}
	${StudentNameFragmentDoc}
`;

/**
 * __useCourseAttendanceRecordListQuery__
 *
 * To run a query within a React component, call `useCourseAttendanceRecordListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAttendanceRecordListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAttendanceRecordListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAttendanceRecordListQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseAttendanceRecordListQuery, CourseAttendanceRecordListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAttendanceRecordListQuery, CourseAttendanceRecordListQueryVariables>(
		CourseAttendanceRecordListDocument,
		options,
	);
}
export function useCourseAttendanceRecordListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseAttendanceRecordListQuery, CourseAttendanceRecordListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAttendanceRecordListQuery, CourseAttendanceRecordListQueryVariables>(
		CourseAttendanceRecordListDocument,
		options,
	);
}
export function useCourseAttendanceRecordListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAttendanceRecordListQuery,
		CourseAttendanceRecordListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAttendanceRecordListQuery, CourseAttendanceRecordListQueryVariables>(
		CourseAttendanceRecordListDocument,
		options,
	);
}
export type CourseAttendanceRecordListQueryHookResult = ReturnType<typeof useCourseAttendanceRecordListQuery>;
export type CourseAttendanceRecordListLazyQueryHookResult = ReturnType<typeof useCourseAttendanceRecordListLazyQuery>;
export type CourseAttendanceRecordListSuspenseQueryHookResult = ReturnType<
	typeof useCourseAttendanceRecordListSuspenseQuery
>;
export type CourseAttendanceRecordListQueryResult = Apollo.QueryResult<
	CourseAttendanceRecordListQuery,
	CourseAttendanceRecordListQueryVariables
>;
export const CourseAttendanceRecordNameDocument = gql`
	query courseAttendanceRecordName($id: ID!) {
		courseAttendanceRecord(id: $id) {
			id
			...CourseAttendanceRecordName
		}
	}
	${CourseAttendanceRecordNameFragmentDoc}
`;

/**
 * __useCourseAttendanceRecordNameQuery__
 *
 * To run a query within a React component, call `useCourseAttendanceRecordNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAttendanceRecordNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAttendanceRecordNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseAttendanceRecordNameQuery(
	baseOptions: Apollo.QueryHookOptions<CourseAttendanceRecordNameQuery, CourseAttendanceRecordNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAttendanceRecordNameQuery, CourseAttendanceRecordNameQueryVariables>(
		CourseAttendanceRecordNameDocument,
		options,
	);
}
export function useCourseAttendanceRecordNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseAttendanceRecordNameQuery, CourseAttendanceRecordNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAttendanceRecordNameQuery, CourseAttendanceRecordNameQueryVariables>(
		CourseAttendanceRecordNameDocument,
		options,
	);
}
export function useCourseAttendanceRecordNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAttendanceRecordNameQuery,
		CourseAttendanceRecordNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAttendanceRecordNameQuery, CourseAttendanceRecordNameQueryVariables>(
		CourseAttendanceRecordNameDocument,
		options,
	);
}
export type CourseAttendanceRecordNameQueryHookResult = ReturnType<typeof useCourseAttendanceRecordNameQuery>;
export type CourseAttendanceRecordNameLazyQueryHookResult = ReturnType<typeof useCourseAttendanceRecordNameLazyQuery>;
export type CourseAttendanceRecordNameSuspenseQueryHookResult = ReturnType<
	typeof useCourseAttendanceRecordNameSuspenseQuery
>;
export type CourseAttendanceRecordNameQueryResult = Apollo.QueryResult<
	CourseAttendanceRecordNameQuery,
	CourseAttendanceRecordNameQueryVariables
>;
export const CourseAttendanceRecordNamesDocument = gql`
	query courseAttendanceRecordNames(
		$filters: [CourseAttendanceRecordFilterInput!]
		$pagination: Pagination
		$order: CourseAttendanceRecordOrder
	) {
		courseAttendanceRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...CourseAttendanceRecordName
				}
			}
		}
	}
	${CourseAttendanceRecordNameFragmentDoc}
`;

/**
 * __useCourseAttendanceRecordNamesQuery__
 *
 * To run a query within a React component, call `useCourseAttendanceRecordNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAttendanceRecordNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAttendanceRecordNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAttendanceRecordNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseAttendanceRecordNamesQuery, CourseAttendanceRecordNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAttendanceRecordNamesQuery, CourseAttendanceRecordNamesQueryVariables>(
		CourseAttendanceRecordNamesDocument,
		options,
	);
}
export function useCourseAttendanceRecordNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAttendanceRecordNamesQuery,
		CourseAttendanceRecordNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAttendanceRecordNamesQuery, CourseAttendanceRecordNamesQueryVariables>(
		CourseAttendanceRecordNamesDocument,
		options,
	);
}
export function useCourseAttendanceRecordNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAttendanceRecordNamesQuery,
		CourseAttendanceRecordNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAttendanceRecordNamesQuery, CourseAttendanceRecordNamesQueryVariables>(
		CourseAttendanceRecordNamesDocument,
		options,
	);
}
export type CourseAttendanceRecordNamesQueryHookResult = ReturnType<typeof useCourseAttendanceRecordNamesQuery>;
export type CourseAttendanceRecordNamesLazyQueryHookResult = ReturnType<typeof useCourseAttendanceRecordNamesLazyQuery>;
export type CourseAttendanceRecordNamesSuspenseQueryHookResult = ReturnType<
	typeof useCourseAttendanceRecordNamesSuspenseQuery
>;
export type CourseAttendanceRecordNamesQueryResult = Apollo.QueryResult<
	CourseAttendanceRecordNamesQuery,
	CourseAttendanceRecordNamesQueryVariables
>;
export const CourseAttendanceRecordPaginationDocument = gql`
	query courseAttendanceRecordPagination(
		$filters: [CourseAttendanceRecordFilterInput!]
		$order: CourseAttendanceRecordOrder
	) {
		courseAttendanceRecordConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useCourseAttendanceRecordPaginationQuery__
 *
 * To run a query within a React component, call `useCourseAttendanceRecordPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAttendanceRecordPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAttendanceRecordPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAttendanceRecordPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseAttendanceRecordPaginationQuery,
		CourseAttendanceRecordPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAttendanceRecordPaginationQuery, CourseAttendanceRecordPaginationQueryVariables>(
		CourseAttendanceRecordPaginationDocument,
		options,
	);
}
export function useCourseAttendanceRecordPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAttendanceRecordPaginationQuery,
		CourseAttendanceRecordPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAttendanceRecordPaginationQuery, CourseAttendanceRecordPaginationQueryVariables>(
		CourseAttendanceRecordPaginationDocument,
		options,
	);
}
export function useCourseAttendanceRecordPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAttendanceRecordPaginationQuery,
		CourseAttendanceRecordPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAttendanceRecordPaginationQuery, CourseAttendanceRecordPaginationQueryVariables>(
		CourseAttendanceRecordPaginationDocument,
		options,
	);
}
export type CourseAttendanceRecordPaginationQueryHookResult = ReturnType<
	typeof useCourseAttendanceRecordPaginationQuery
>;
export type CourseAttendanceRecordPaginationLazyQueryHookResult = ReturnType<
	typeof useCourseAttendanceRecordPaginationLazyQuery
>;
export type CourseAttendanceRecordPaginationSuspenseQueryHookResult = ReturnType<
	typeof useCourseAttendanceRecordPaginationSuspenseQuery
>;
export type CourseAttendanceRecordPaginationQueryResult = Apollo.QueryResult<
	CourseAttendanceRecordPaginationQuery,
	CourseAttendanceRecordPaginationQueryVariables
>;
export const CourseAttendanceRecordSelectDocument = gql`
	query courseAttendanceRecordSelect(
		$filters: [CourseAttendanceRecordFilterInput!]
		$order: CourseAttendanceRecordOrder
	) {
		courseAttendanceRecordConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...CourseAttendanceRecordName
				}
			}
		}
	}
	${CourseAttendanceRecordNameFragmentDoc}
`;

/**
 * __useCourseAttendanceRecordSelectQuery__
 *
 * To run a query within a React component, call `useCourseAttendanceRecordSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAttendanceRecordSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAttendanceRecordSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseAttendanceRecordSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseAttendanceRecordSelectQuery, CourseAttendanceRecordSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseAttendanceRecordSelectQuery, CourseAttendanceRecordSelectQueryVariables>(
		CourseAttendanceRecordSelectDocument,
		options,
	);
}
export function useCourseAttendanceRecordSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAttendanceRecordSelectQuery,
		CourseAttendanceRecordSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseAttendanceRecordSelectQuery, CourseAttendanceRecordSelectQueryVariables>(
		CourseAttendanceRecordSelectDocument,
		options,
	);
}
export function useCourseAttendanceRecordSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAttendanceRecordSelectQuery,
		CourseAttendanceRecordSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseAttendanceRecordSelectQuery, CourseAttendanceRecordSelectQueryVariables>(
		CourseAttendanceRecordSelectDocument,
		options,
	);
}
export type CourseAttendanceRecordSelectQueryHookResult = ReturnType<typeof useCourseAttendanceRecordSelectQuery>;
export type CourseAttendanceRecordSelectLazyQueryHookResult = ReturnType<
	typeof useCourseAttendanceRecordSelectLazyQuery
>;
export type CourseAttendanceRecordSelectSuspenseQueryHookResult = ReturnType<
	typeof useCourseAttendanceRecordSelectSuspenseQuery
>;
export type CourseAttendanceRecordSelectQueryResult = Apollo.QueryResult<
	CourseAttendanceRecordSelectQuery,
	CourseAttendanceRecordSelectQueryVariables
>;
export const CourseAttendanceRecordUpdateDocument = gql`
	mutation courseAttendanceRecordUpdate($id: ID!, $input: CourseAttendanceRecordUpdateInput!) {
		updateCourseAttendanceRecord(id: $id, input: $input) {
			...CourseAttendanceRecordDetail
		}
	}
	${CourseAttendanceRecordDetailFragmentDoc}
`;
export type CourseAttendanceRecordUpdateMutationFn = Apollo.MutationFunction<
	CourseAttendanceRecordUpdateMutation,
	CourseAttendanceRecordUpdateMutationVariables
>;

/**
 * __useCourseAttendanceRecordUpdateMutation__
 *
 * To run a mutation, you first call `useCourseAttendanceRecordUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseAttendanceRecordUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseAttendanceRecordUpdateMutation, { data, loading, error }] = useCourseAttendanceRecordUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseAttendanceRecordUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseAttendanceRecordUpdateMutation,
		CourseAttendanceRecordUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseAttendanceRecordUpdateMutation, CourseAttendanceRecordUpdateMutationVariables>(
		CourseAttendanceRecordUpdateDocument,
		options,
	);
}
export type CourseAttendanceRecordUpdateMutationHookResult = ReturnType<typeof useCourseAttendanceRecordUpdateMutation>;
export type CourseAttendanceRecordUpdateMutationResult = Apollo.MutationResult<CourseAttendanceRecordUpdateMutation>;
export type CourseAttendanceRecordUpdateMutationOptions = Apollo.BaseMutationOptions<
	CourseAttendanceRecordUpdateMutation,
	CourseAttendanceRecordUpdateMutationVariables
>;
export const CourseSectionCountDocument = gql`
	query courseSectionCount($filters: [CourseSectionFilterInput!], $pagination: Pagination, $order: CourseSectionOrder) {
		courseSectionConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useCourseSectionCountQuery__
 *
 * To run a query within a React component, call `useCourseSectionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionCountQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseSectionCountQuery, CourseSectionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionCountQuery, CourseSectionCountQueryVariables>(
		CourseSectionCountDocument,
		options,
	);
}
export function useCourseSectionCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseSectionCountQuery, CourseSectionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionCountQuery, CourseSectionCountQueryVariables>(
		CourseSectionCountDocument,
		options,
	);
}
export function useCourseSectionCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseSectionCountQuery, CourseSectionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionCountQuery, CourseSectionCountQueryVariables>(
		CourseSectionCountDocument,
		options,
	);
}
export type CourseSectionCountQueryHookResult = ReturnType<typeof useCourseSectionCountQuery>;
export type CourseSectionCountLazyQueryHookResult = ReturnType<typeof useCourseSectionCountLazyQuery>;
export type CourseSectionCountSuspenseQueryHookResult = ReturnType<typeof useCourseSectionCountSuspenseQuery>;
export type CourseSectionCountQueryResult = Apollo.QueryResult<
	CourseSectionCountQuery,
	CourseSectionCountQueryVariables
>;
export const CourseSectionCreateDocument = gql`
	mutation courseSectionCreate($input: CourseSectionCreateInput!) {
		createCourseSection(input: $input) {
			...CourseSectionDetail
		}
	}
	${CourseSectionDetailFragmentDoc}
`;
export type CourseSectionCreateMutationFn = Apollo.MutationFunction<
	CourseSectionCreateMutation,
	CourseSectionCreateMutationVariables
>;

/**
 * __useCourseSectionCreateMutation__
 *
 * To run a mutation, you first call `useCourseSectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseSectionCreateMutation, { data, loading, error }] = useCourseSectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseSectionCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<CourseSectionCreateMutation, CourseSectionCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseSectionCreateMutation, CourseSectionCreateMutationVariables>(
		CourseSectionCreateDocument,
		options,
	);
}
export type CourseSectionCreateMutationHookResult = ReturnType<typeof useCourseSectionCreateMutation>;
export type CourseSectionCreateMutationResult = Apollo.MutationResult<CourseSectionCreateMutation>;
export type CourseSectionCreateMutationOptions = Apollo.BaseMutationOptions<
	CourseSectionCreateMutation,
	CourseSectionCreateMutationVariables
>;
export const CourseSectionDeleteDocument = gql`
	mutation courseSectionDelete($id: ID!) {
		deleteCourseSection(id: $id)
	}
`;
export type CourseSectionDeleteMutationFn = Apollo.MutationFunction<
	CourseSectionDeleteMutation,
	CourseSectionDeleteMutationVariables
>;

/**
 * __useCourseSectionDeleteMutation__
 *
 * To run a mutation, you first call `useCourseSectionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseSectionDeleteMutation, { data, loading, error }] = useCourseSectionDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseSectionDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<CourseSectionDeleteMutation, CourseSectionDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseSectionDeleteMutation, CourseSectionDeleteMutationVariables>(
		CourseSectionDeleteDocument,
		options,
	);
}
export type CourseSectionDeleteMutationHookResult = ReturnType<typeof useCourseSectionDeleteMutation>;
export type CourseSectionDeleteMutationResult = Apollo.MutationResult<CourseSectionDeleteMutation>;
export type CourseSectionDeleteMutationOptions = Apollo.BaseMutationOptions<
	CourseSectionDeleteMutation,
	CourseSectionDeleteMutationVariables
>;
export const CourseSectionDetailDocument = gql`
	query courseSectionDetail($id: ID!) {
		courseSection(id: $id) {
			...CourseSectionDetail
		}
	}
	${CourseSectionDetailFragmentDoc}
`;

/**
 * __useCourseSectionDetailQuery__
 *
 * To run a query within a React component, call `useCourseSectionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseSectionDetailQuery(
	baseOptions: Apollo.QueryHookOptions<CourseSectionDetailQuery, CourseSectionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionDetailQuery, CourseSectionDetailQueryVariables>(
		CourseSectionDetailDocument,
		options,
	);
}
export function useCourseSectionDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseSectionDetailQuery, CourseSectionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionDetailQuery, CourseSectionDetailQueryVariables>(
		CourseSectionDetailDocument,
		options,
	);
}
export function useCourseSectionDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseSectionDetailQuery, CourseSectionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionDetailQuery, CourseSectionDetailQueryVariables>(
		CourseSectionDetailDocument,
		options,
	);
}
export type CourseSectionDetailQueryHookResult = ReturnType<typeof useCourseSectionDetailQuery>;
export type CourseSectionDetailLazyQueryHookResult = ReturnType<typeof useCourseSectionDetailLazyQuery>;
export type CourseSectionDetailSuspenseQueryHookResult = ReturnType<typeof useCourseSectionDetailSuspenseQuery>;
export type CourseSectionDetailQueryResult = Apollo.QueryResult<
	CourseSectionDetailQuery,
	CourseSectionDetailQueryVariables
>;
export const CourseSectionIndexDocument = gql`
	query courseSectionIndex($filters: [CourseSectionFilterInput!], $pagination: Pagination, $order: CourseSectionOrder) {
		courseSectionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					namePrefix
					nameSuffix
					academicTerm {
						id
						...AcademicTermName
						startDate
						endDate
					}
					course {
						id
						...CourseName
						academicSubject {
							id
							...AcademicSubjectName
						}
						classYears(order: { field: YEARS_FROM_GRADUATION, direction: DESC }) {
							id
							...ClassYearName
						}
					}
					homeRoomSection {
						id
						...HomeRoomSectionName
					}
					studentCourseSectionEnrollments {
						id
						lateStartDate
						earlyEndDate
					}
					teacherCourseSectionEnrollments {
						id
						lateStartDate
						earlyEndDate
						teacher {
							id
							...EmployeeName
						}
					}
				}
			}
		}
	}
	${AcademicTermNameFragmentDoc}
	${CourseNameFragmentDoc}
	${AcademicSubjectNameFragmentDoc}
	${ClassYearNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${EmployeeNameFragmentDoc}
`;

/**
 * __useCourseSectionIndexQuery__
 *
 * To run a query within a React component, call `useCourseSectionIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseSectionIndexQuery, CourseSectionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionIndexQuery, CourseSectionIndexQueryVariables>(
		CourseSectionIndexDocument,
		options,
	);
}
export function useCourseSectionIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseSectionIndexQuery, CourseSectionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionIndexQuery, CourseSectionIndexQueryVariables>(
		CourseSectionIndexDocument,
		options,
	);
}
export function useCourseSectionIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseSectionIndexQuery, CourseSectionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionIndexQuery, CourseSectionIndexQueryVariables>(
		CourseSectionIndexDocument,
		options,
	);
}
export type CourseSectionIndexQueryHookResult = ReturnType<typeof useCourseSectionIndexQuery>;
export type CourseSectionIndexLazyQueryHookResult = ReturnType<typeof useCourseSectionIndexLazyQuery>;
export type CourseSectionIndexSuspenseQueryHookResult = ReturnType<typeof useCourseSectionIndexSuspenseQuery>;
export type CourseSectionIndexQueryResult = Apollo.QueryResult<
	CourseSectionIndexQuery,
	CourseSectionIndexQueryVariables
>;
export const CourseSectionNameAndDetailsDocument = gql`
	query courseSectionNameAndDetails($id: ID!) {
		courseSection(id: $id) {
			id
			namePrefix
			nameSuffix
			course {
				id
				name
				classYears(order: { field: YEARS_FROM_GRADUATION, direction: DESC }) {
					id
					...ClassYearName
				}
			}
			homeRoomSection {
				id
				...HomeRoomSectionName
			}
		}
	}
	${ClassYearNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
`;

/**
 * __useCourseSectionNameAndDetailsQuery__
 *
 * To run a query within a React component, call `useCourseSectionNameAndDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionNameAndDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionNameAndDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseSectionNameAndDetailsQuery(
	baseOptions: Apollo.QueryHookOptions<CourseSectionNameAndDetailsQuery, CourseSectionNameAndDetailsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionNameAndDetailsQuery, CourseSectionNameAndDetailsQueryVariables>(
		CourseSectionNameAndDetailsDocument,
		options,
	);
}
export function useCourseSectionNameAndDetailsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseSectionNameAndDetailsQuery,
		CourseSectionNameAndDetailsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionNameAndDetailsQuery, CourseSectionNameAndDetailsQueryVariables>(
		CourseSectionNameAndDetailsDocument,
		options,
	);
}
export function useCourseSectionNameAndDetailsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseSectionNameAndDetailsQuery,
		CourseSectionNameAndDetailsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionNameAndDetailsQuery, CourseSectionNameAndDetailsQueryVariables>(
		CourseSectionNameAndDetailsDocument,
		options,
	);
}
export type CourseSectionNameAndDetailsQueryHookResult = ReturnType<typeof useCourseSectionNameAndDetailsQuery>;
export type CourseSectionNameAndDetailsLazyQueryHookResult = ReturnType<typeof useCourseSectionNameAndDetailsLazyQuery>;
export type CourseSectionNameAndDetailsSuspenseQueryHookResult = ReturnType<
	typeof useCourseSectionNameAndDetailsSuspenseQuery
>;
export type CourseSectionNameAndDetailsQueryResult = Apollo.QueryResult<
	CourseSectionNameAndDetailsQuery,
	CourseSectionNameAndDetailsQueryVariables
>;
export const CourseSectionNamesAndTeachersDocument = gql`
	query courseSectionNamesAndTeachers(
		$filters: [CourseSectionFilterInput!]
		$pagination: Pagination
		$order: CourseSectionOrder
	) {
		courseSectionConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
			edges {
				node {
					id
					namePrefix
					nameSuffix
					course {
						id
						name
						academicSubject {
							id
							...AcademicSubjectNameAndColor
						}
						classYears(order: { field: YEARS_FROM_GRADUATION, direction: DESC }) {
							id
							...ClassYearName
						}
					}
					homeRoomSection {
						id
						...HomeRoomSectionName
					}
					teacherCourseSectionEnrollments {
						id
						teacher {
							id
							...EmployeeName
						}
					}
				}
			}
		}
	}
	${AcademicSubjectNameAndColorFragmentDoc}
	${ClassYearNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${EmployeeNameFragmentDoc}
`;

/**
 * __useCourseSectionNamesAndTeachersQuery__
 *
 * To run a query within a React component, call `useCourseSectionNamesAndTeachersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionNamesAndTeachersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionNamesAndTeachersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionNamesAndTeachersQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseSectionNamesAndTeachersQuery,
		CourseSectionNamesAndTeachersQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionNamesAndTeachersQuery, CourseSectionNamesAndTeachersQueryVariables>(
		CourseSectionNamesAndTeachersDocument,
		options,
	);
}
export function useCourseSectionNamesAndTeachersLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseSectionNamesAndTeachersQuery,
		CourseSectionNamesAndTeachersQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionNamesAndTeachersQuery, CourseSectionNamesAndTeachersQueryVariables>(
		CourseSectionNamesAndTeachersDocument,
		options,
	);
}
export function useCourseSectionNamesAndTeachersSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseSectionNamesAndTeachersQuery,
		CourseSectionNamesAndTeachersQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionNamesAndTeachersQuery, CourseSectionNamesAndTeachersQueryVariables>(
		CourseSectionNamesAndTeachersDocument,
		options,
	);
}
export type CourseSectionNamesAndTeachersQueryHookResult = ReturnType<typeof useCourseSectionNamesAndTeachersQuery>;
export type CourseSectionNamesAndTeachersLazyQueryHookResult = ReturnType<
	typeof useCourseSectionNamesAndTeachersLazyQuery
>;
export type CourseSectionNamesAndTeachersSuspenseQueryHookResult = ReturnType<
	typeof useCourseSectionNamesAndTeachersSuspenseQuery
>;
export type CourseSectionNamesAndTeachersQueryResult = Apollo.QueryResult<
	CourseSectionNamesAndTeachersQuery,
	CourseSectionNamesAndTeachersQueryVariables
>;
export const CourseSectionListDocument = gql`
	query courseSectionList($filters: [CourseSectionFilterInput!], $pagination: Pagination, $order: CourseSectionOrder) {
		courseSectionConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
			edges {
				node {
					id
					namePrefix
					nameSuffix
					course {
						id
						name
						academicSubject {
							id
							...AcademicSubjectNameAndColor
						}
						classYears(order: { field: YEARS_FROM_GRADUATION, direction: DESC }) {
							id
							...ClassYearName
						}
					}
					homeRoomSection {
						id
						...HomeRoomSectionName
					}
					studentCourseSectionEnrollments {
						id
						lateStartDate
						earlyEndDate
						student {
							id
							...StudentName
						}
					}
					teacherCourseSectionEnrollments {
						id
						teacher {
							id
							...EmployeeName
						}
					}
				}
			}
		}
	}
	${AcademicSubjectNameAndColorFragmentDoc}
	${ClassYearNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${StudentNameFragmentDoc}
	${EmployeeNameFragmentDoc}
`;

/**
 * __useCourseSectionListQuery__
 *
 * To run a query within a React component, call `useCourseSectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionListQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseSectionListQuery, CourseSectionListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionListQuery, CourseSectionListQueryVariables>(CourseSectionListDocument, options);
}
export function useCourseSectionListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseSectionListQuery, CourseSectionListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionListQuery, CourseSectionListQueryVariables>(
		CourseSectionListDocument,
		options,
	);
}
export function useCourseSectionListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseSectionListQuery, CourseSectionListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionListQuery, CourseSectionListQueryVariables>(
		CourseSectionListDocument,
		options,
	);
}
export type CourseSectionListQueryHookResult = ReturnType<typeof useCourseSectionListQuery>;
export type CourseSectionListLazyQueryHookResult = ReturnType<typeof useCourseSectionListLazyQuery>;
export type CourseSectionListSuspenseQueryHookResult = ReturnType<typeof useCourseSectionListSuspenseQuery>;
export type CourseSectionListQueryResult = Apollo.QueryResult<CourseSectionListQuery, CourseSectionListQueryVariables>;
export const CourseSectionSummaryListDocument = gql`
	query courseSectionSummaryList(
		$filters: [CourseSectionFilterInput!]
		$pagination: Pagination
		$order: CourseSectionOrder
	) {
		courseSectionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...CourseSectionName
					course {
						id
						academicSubject {
							id
							...AcademicSubjectNameAndColor
						}
					}
					homeRoomSection {
						id
						...HomeRoomSectionName
					}
					teacherCourseSectionEnrollments {
						id
						teacher {
							id
							...EmployeeName
						}
					}
					studentCourseSectionEnrollments {
						id
					}
					courseSectionPeriods(order: { field: DAY_OF_WEEK, direction: ASC }) {
						id
						dayOfWeek
						startTimeMinutes
						endTimeMinutes
					}
				}
			}
		}
	}
	${CourseSectionNameFragmentDoc}
	${AcademicSubjectNameAndColorFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${EmployeeNameFragmentDoc}
`;

/**
 * __useCourseSectionSummaryListQuery__
 *
 * To run a query within a React component, call `useCourseSectionSummaryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionSummaryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionSummaryListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionSummaryListQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseSectionSummaryListQuery, CourseSectionSummaryListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionSummaryListQuery, CourseSectionSummaryListQueryVariables>(
		CourseSectionSummaryListDocument,
		options,
	);
}
export function useCourseSectionSummaryListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseSectionSummaryListQuery, CourseSectionSummaryListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionSummaryListQuery, CourseSectionSummaryListQueryVariables>(
		CourseSectionSummaryListDocument,
		options,
	);
}
export function useCourseSectionSummaryListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseSectionSummaryListQuery, CourseSectionSummaryListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionSummaryListQuery, CourseSectionSummaryListQueryVariables>(
		CourseSectionSummaryListDocument,
		options,
	);
}
export type CourseSectionSummaryListQueryHookResult = ReturnType<typeof useCourseSectionSummaryListQuery>;
export type CourseSectionSummaryListLazyQueryHookResult = ReturnType<typeof useCourseSectionSummaryListLazyQuery>;
export type CourseSectionSummaryListSuspenseQueryHookResult = ReturnType<
	typeof useCourseSectionSummaryListSuspenseQuery
>;
export type CourseSectionSummaryListQueryResult = Apollo.QueryResult<
	CourseSectionSummaryListQuery,
	CourseSectionSummaryListQueryVariables
>;
export const CourseSectionOverviewListDocument = gql`
	query courseSectionOverviewList(
		$filters: [CourseSectionFilterInput!]
		$pagination: Pagination
		$order: CourseSectionOrder
	) {
		courseSectionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					namePrefix
					nameSuffix
					course {
						id
						...CourseName
						academicSubject {
							id
							color
						}
						classYears(order: { field: YEARS_FROM_GRADUATION, direction: DESC }) {
							id
							...ClassYearName
						}
					}
					homeRoomSection {
						id
						...HomeRoomSectionName
					}
					studentCourseSectionEnrollments {
						id
						lateStartDate
						earlyEndDate
						student {
							id
							...StudentName
						}
					}
				}
			}
		}
	}
	${CourseNameFragmentDoc}
	${ClassYearNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${StudentNameFragmentDoc}
`;

/**
 * __useCourseSectionOverviewListQuery__
 *
 * To run a query within a React component, call `useCourseSectionOverviewListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionOverviewListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionOverviewListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionOverviewListQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseSectionOverviewListQuery, CourseSectionOverviewListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionOverviewListQuery, CourseSectionOverviewListQueryVariables>(
		CourseSectionOverviewListDocument,
		options,
	);
}
export function useCourseSectionOverviewListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseSectionOverviewListQuery, CourseSectionOverviewListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionOverviewListQuery, CourseSectionOverviewListQueryVariables>(
		CourseSectionOverviewListDocument,
		options,
	);
}
export function useCourseSectionOverviewListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseSectionOverviewListQuery,
		CourseSectionOverviewListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionOverviewListQuery, CourseSectionOverviewListQueryVariables>(
		CourseSectionOverviewListDocument,
		options,
	);
}
export type CourseSectionOverviewListQueryHookResult = ReturnType<typeof useCourseSectionOverviewListQuery>;
export type CourseSectionOverviewListLazyQueryHookResult = ReturnType<typeof useCourseSectionOverviewListLazyQuery>;
export type CourseSectionOverviewListSuspenseQueryHookResult = ReturnType<
	typeof useCourseSectionOverviewListSuspenseQuery
>;
export type CourseSectionOverviewListQueryResult = Apollo.QueryResult<
	CourseSectionOverviewListQuery,
	CourseSectionOverviewListQueryVariables
>;
export const CourseSectionDetailedSelectListDocument = gql`
	query courseSectionDetailedSelectList(
		$filters: [CourseSectionFilterInput!]
		$pagination: Pagination
		$order: CourseSectionOrder
	) {
		courseSectionConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
			edges {
				node {
					id
					namePrefix
					nameSuffix
					course {
						id
						name
						classYears(order: { field: YEARS_FROM_GRADUATION, direction: DESC }) {
							id
							...ClassYearName
						}
					}
					homeRoomSection {
						id
						...HomeRoomSectionName
					}
				}
			}
		}
	}
	${ClassYearNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
`;

/**
 * __useCourseSectionDetailedSelectListQuery__
 *
 * To run a query within a React component, call `useCourseSectionDetailedSelectListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionDetailedSelectListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionDetailedSelectListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionDetailedSelectListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseSectionDetailedSelectListQuery,
		CourseSectionDetailedSelectListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionDetailedSelectListQuery, CourseSectionDetailedSelectListQueryVariables>(
		CourseSectionDetailedSelectListDocument,
		options,
	);
}
export function useCourseSectionDetailedSelectListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseSectionDetailedSelectListQuery,
		CourseSectionDetailedSelectListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionDetailedSelectListQuery, CourseSectionDetailedSelectListQueryVariables>(
		CourseSectionDetailedSelectListDocument,
		options,
	);
}
export function useCourseSectionDetailedSelectListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseSectionDetailedSelectListQuery,
		CourseSectionDetailedSelectListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionDetailedSelectListQuery, CourseSectionDetailedSelectListQueryVariables>(
		CourseSectionDetailedSelectListDocument,
		options,
	);
}
export type CourseSectionDetailedSelectListQueryHookResult = ReturnType<typeof useCourseSectionDetailedSelectListQuery>;
export type CourseSectionDetailedSelectListLazyQueryHookResult = ReturnType<
	typeof useCourseSectionDetailedSelectListLazyQuery
>;
export type CourseSectionDetailedSelectListSuspenseQueryHookResult = ReturnType<
	typeof useCourseSectionDetailedSelectListSuspenseQuery
>;
export type CourseSectionDetailedSelectListQueryResult = Apollo.QueryResult<
	CourseSectionDetailedSelectListQuery,
	CourseSectionDetailedSelectListQueryVariables
>;
export const CourseSectionNameDocument = gql`
	query courseSectionName($id: ID!) {
		courseSection(id: $id) {
			id
			...CourseSectionName
		}
	}
	${CourseSectionNameFragmentDoc}
`;

/**
 * __useCourseSectionNameQuery__
 *
 * To run a query within a React component, call `useCourseSectionNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseSectionNameQuery(
	baseOptions: Apollo.QueryHookOptions<CourseSectionNameQuery, CourseSectionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionNameQuery, CourseSectionNameQueryVariables>(CourseSectionNameDocument, options);
}
export function useCourseSectionNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseSectionNameQuery, CourseSectionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionNameQuery, CourseSectionNameQueryVariables>(
		CourseSectionNameDocument,
		options,
	);
}
export function useCourseSectionNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseSectionNameQuery, CourseSectionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionNameQuery, CourseSectionNameQueryVariables>(
		CourseSectionNameDocument,
		options,
	);
}
export type CourseSectionNameQueryHookResult = ReturnType<typeof useCourseSectionNameQuery>;
export type CourseSectionNameLazyQueryHookResult = ReturnType<typeof useCourseSectionNameLazyQuery>;
export type CourseSectionNameSuspenseQueryHookResult = ReturnType<typeof useCourseSectionNameSuspenseQuery>;
export type CourseSectionNameQueryResult = Apollo.QueryResult<CourseSectionNameQuery, CourseSectionNameQueryVariables>;
export const CourseSectionNamesDocument = gql`
	query courseSectionNames($filters: [CourseSectionFilterInput!], $pagination: Pagination, $order: CourseSectionOrder) {
		courseSectionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...CourseSectionName
				}
			}
		}
	}
	${CourseSectionNameFragmentDoc}
`;

/**
 * __useCourseSectionNamesQuery__
 *
 * To run a query within a React component, call `useCourseSectionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseSectionNamesQuery, CourseSectionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionNamesQuery, CourseSectionNamesQueryVariables>(
		CourseSectionNamesDocument,
		options,
	);
}
export function useCourseSectionNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseSectionNamesQuery, CourseSectionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionNamesQuery, CourseSectionNamesQueryVariables>(
		CourseSectionNamesDocument,
		options,
	);
}
export function useCourseSectionNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseSectionNamesQuery, CourseSectionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionNamesQuery, CourseSectionNamesQueryVariables>(
		CourseSectionNamesDocument,
		options,
	);
}
export type CourseSectionNamesQueryHookResult = ReturnType<typeof useCourseSectionNamesQuery>;
export type CourseSectionNamesLazyQueryHookResult = ReturnType<typeof useCourseSectionNamesLazyQuery>;
export type CourseSectionNamesSuspenseQueryHookResult = ReturnType<typeof useCourseSectionNamesSuspenseQuery>;
export type CourseSectionNamesQueryResult = Apollo.QueryResult<
	CourseSectionNamesQuery,
	CourseSectionNamesQueryVariables
>;
export const CourseSectionPaginationDocument = gql`
	query courseSectionPagination($filters: [CourseSectionFilterInput!], $order: CourseSectionOrder) {
		courseSectionConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useCourseSectionPaginationQuery__
 *
 * To run a query within a React component, call `useCourseSectionPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseSectionPaginationQuery, CourseSectionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionPaginationQuery, CourseSectionPaginationQueryVariables>(
		CourseSectionPaginationDocument,
		options,
	);
}
export function useCourseSectionPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseSectionPaginationQuery, CourseSectionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionPaginationQuery, CourseSectionPaginationQueryVariables>(
		CourseSectionPaginationDocument,
		options,
	);
}
export function useCourseSectionPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseSectionPaginationQuery, CourseSectionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionPaginationQuery, CourseSectionPaginationQueryVariables>(
		CourseSectionPaginationDocument,
		options,
	);
}
export type CourseSectionPaginationQueryHookResult = ReturnType<typeof useCourseSectionPaginationQuery>;
export type CourseSectionPaginationLazyQueryHookResult = ReturnType<typeof useCourseSectionPaginationLazyQuery>;
export type CourseSectionPaginationSuspenseQueryHookResult = ReturnType<typeof useCourseSectionPaginationSuspenseQuery>;
export type CourseSectionPaginationQueryResult = Apollo.QueryResult<
	CourseSectionPaginationQuery,
	CourseSectionPaginationQueryVariables
>;
export const CourseSectionSelectDocument = gql`
	query courseSectionSelect($filters: [CourseSectionFilterInput!], $order: CourseSectionOrder) {
		courseSectionConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...CourseSectionName
				}
			}
		}
	}
	${CourseSectionNameFragmentDoc}
`;

/**
 * __useCourseSectionSelectQuery__
 *
 * To run a query within a React component, call `useCourseSectionSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseSectionSelectQuery, CourseSectionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionSelectQuery, CourseSectionSelectQueryVariables>(
		CourseSectionSelectDocument,
		options,
	);
}
export function useCourseSectionSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseSectionSelectQuery, CourseSectionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionSelectQuery, CourseSectionSelectQueryVariables>(
		CourseSectionSelectDocument,
		options,
	);
}
export function useCourseSectionSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseSectionSelectQuery, CourseSectionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionSelectQuery, CourseSectionSelectQueryVariables>(
		CourseSectionSelectDocument,
		options,
	);
}
export type CourseSectionSelectQueryHookResult = ReturnType<typeof useCourseSectionSelectQuery>;
export type CourseSectionSelectLazyQueryHookResult = ReturnType<typeof useCourseSectionSelectLazyQuery>;
export type CourseSectionSelectSuspenseQueryHookResult = ReturnType<typeof useCourseSectionSelectSuspenseQuery>;
export type CourseSectionSelectQueryResult = Apollo.QueryResult<
	CourseSectionSelectQuery,
	CourseSectionSelectQueryVariables
>;
export const CourseSectionUpdateDocument = gql`
	mutation courseSectionUpdate($id: ID!, $input: CourseSectionUpdateInput!) {
		updateCourseSection(id: $id, input: $input) {
			...CourseSectionDetail
		}
	}
	${CourseSectionDetailFragmentDoc}
`;
export type CourseSectionUpdateMutationFn = Apollo.MutationFunction<
	CourseSectionUpdateMutation,
	CourseSectionUpdateMutationVariables
>;

/**
 * __useCourseSectionUpdateMutation__
 *
 * To run a mutation, you first call `useCourseSectionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseSectionUpdateMutation, { data, loading, error }] = useCourseSectionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseSectionUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<CourseSectionUpdateMutation, CourseSectionUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseSectionUpdateMutation, CourseSectionUpdateMutationVariables>(
		CourseSectionUpdateDocument,
		options,
	);
}
export type CourseSectionUpdateMutationHookResult = ReturnType<typeof useCourseSectionUpdateMutation>;
export type CourseSectionUpdateMutationResult = Apollo.MutationResult<CourseSectionUpdateMutation>;
export type CourseSectionUpdateMutationOptions = Apollo.BaseMutationOptions<
	CourseSectionUpdateMutation,
	CourseSectionUpdateMutationVariables
>;
export const CourseSectionPeriodCountDocument = gql`
	query courseSectionPeriodCount(
		$filters: [CourseSectionPeriodFilterInput!]
		$pagination: Pagination
		$order: CourseSectionPeriodOrder
	) {
		courseSectionPeriodConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useCourseSectionPeriodCountQuery__
 *
 * To run a query within a React component, call `useCourseSectionPeriodCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionPeriodCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionPeriodCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionPeriodCountQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseSectionPeriodCountQuery, CourseSectionPeriodCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionPeriodCountQuery, CourseSectionPeriodCountQueryVariables>(
		CourseSectionPeriodCountDocument,
		options,
	);
}
export function useCourseSectionPeriodCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseSectionPeriodCountQuery, CourseSectionPeriodCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionPeriodCountQuery, CourseSectionPeriodCountQueryVariables>(
		CourseSectionPeriodCountDocument,
		options,
	);
}
export function useCourseSectionPeriodCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseSectionPeriodCountQuery, CourseSectionPeriodCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionPeriodCountQuery, CourseSectionPeriodCountQueryVariables>(
		CourseSectionPeriodCountDocument,
		options,
	);
}
export type CourseSectionPeriodCountQueryHookResult = ReturnType<typeof useCourseSectionPeriodCountQuery>;
export type CourseSectionPeriodCountLazyQueryHookResult = ReturnType<typeof useCourseSectionPeriodCountLazyQuery>;
export type CourseSectionPeriodCountSuspenseQueryHookResult = ReturnType<
	typeof useCourseSectionPeriodCountSuspenseQuery
>;
export type CourseSectionPeriodCountQueryResult = Apollo.QueryResult<
	CourseSectionPeriodCountQuery,
	CourseSectionPeriodCountQueryVariables
>;
export const CourseSectionPeriodCreateDocument = gql`
	mutation courseSectionPeriodCreate($input: CourseSectionPeriodCreateInput!) {
		createCourseSectionPeriod(input: $input) {
			...CourseSectionPeriodDetail
		}
	}
	${CourseSectionPeriodDetailFragmentDoc}
`;
export type CourseSectionPeriodCreateMutationFn = Apollo.MutationFunction<
	CourseSectionPeriodCreateMutation,
	CourseSectionPeriodCreateMutationVariables
>;

/**
 * __useCourseSectionPeriodCreateMutation__
 *
 * To run a mutation, you first call `useCourseSectionPeriodCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionPeriodCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseSectionPeriodCreateMutation, { data, loading, error }] = useCourseSectionPeriodCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseSectionPeriodCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseSectionPeriodCreateMutation,
		CourseSectionPeriodCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseSectionPeriodCreateMutation, CourseSectionPeriodCreateMutationVariables>(
		CourseSectionPeriodCreateDocument,
		options,
	);
}
export type CourseSectionPeriodCreateMutationHookResult = ReturnType<typeof useCourseSectionPeriodCreateMutation>;
export type CourseSectionPeriodCreateMutationResult = Apollo.MutationResult<CourseSectionPeriodCreateMutation>;
export type CourseSectionPeriodCreateMutationOptions = Apollo.BaseMutationOptions<
	CourseSectionPeriodCreateMutation,
	CourseSectionPeriodCreateMutationVariables
>;
export const CourseSectionPeriodDeleteDocument = gql`
	mutation courseSectionPeriodDelete($id: ID!) {
		deleteCourseSectionPeriod(id: $id)
	}
`;
export type CourseSectionPeriodDeleteMutationFn = Apollo.MutationFunction<
	CourseSectionPeriodDeleteMutation,
	CourseSectionPeriodDeleteMutationVariables
>;

/**
 * __useCourseSectionPeriodDeleteMutation__
 *
 * To run a mutation, you first call `useCourseSectionPeriodDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionPeriodDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseSectionPeriodDeleteMutation, { data, loading, error }] = useCourseSectionPeriodDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseSectionPeriodDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseSectionPeriodDeleteMutation,
		CourseSectionPeriodDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseSectionPeriodDeleteMutation, CourseSectionPeriodDeleteMutationVariables>(
		CourseSectionPeriodDeleteDocument,
		options,
	);
}
export type CourseSectionPeriodDeleteMutationHookResult = ReturnType<typeof useCourseSectionPeriodDeleteMutation>;
export type CourseSectionPeriodDeleteMutationResult = Apollo.MutationResult<CourseSectionPeriodDeleteMutation>;
export type CourseSectionPeriodDeleteMutationOptions = Apollo.BaseMutationOptions<
	CourseSectionPeriodDeleteMutation,
	CourseSectionPeriodDeleteMutationVariables
>;
export const CourseSectionPeriodDetailDocument = gql`
	query courseSectionPeriodDetail($id: ID!) {
		courseSectionPeriod(id: $id) {
			...CourseSectionPeriodDetail
		}
	}
	${CourseSectionPeriodDetailFragmentDoc}
`;

/**
 * __useCourseSectionPeriodDetailQuery__
 *
 * To run a query within a React component, call `useCourseSectionPeriodDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionPeriodDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionPeriodDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseSectionPeriodDetailQuery(
	baseOptions: Apollo.QueryHookOptions<CourseSectionPeriodDetailQuery, CourseSectionPeriodDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionPeriodDetailQuery, CourseSectionPeriodDetailQueryVariables>(
		CourseSectionPeriodDetailDocument,
		options,
	);
}
export function useCourseSectionPeriodDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseSectionPeriodDetailQuery, CourseSectionPeriodDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionPeriodDetailQuery, CourseSectionPeriodDetailQueryVariables>(
		CourseSectionPeriodDetailDocument,
		options,
	);
}
export function useCourseSectionPeriodDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseSectionPeriodDetailQuery,
		CourseSectionPeriodDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionPeriodDetailQuery, CourseSectionPeriodDetailQueryVariables>(
		CourseSectionPeriodDetailDocument,
		options,
	);
}
export type CourseSectionPeriodDetailQueryHookResult = ReturnType<typeof useCourseSectionPeriodDetailQuery>;
export type CourseSectionPeriodDetailLazyQueryHookResult = ReturnType<typeof useCourseSectionPeriodDetailLazyQuery>;
export type CourseSectionPeriodDetailSuspenseQueryHookResult = ReturnType<
	typeof useCourseSectionPeriodDetailSuspenseQuery
>;
export type CourseSectionPeriodDetailQueryResult = Apollo.QueryResult<
	CourseSectionPeriodDetailQuery,
	CourseSectionPeriodDetailQueryVariables
>;
export const CourseSectionPeriodIndexDocument = gql`
	query courseSectionPeriodIndex(
		$filters: [CourseSectionPeriodFilterInput!]
		$pagination: Pagination
		$order: CourseSectionPeriodOrder
	) {
		courseSectionPeriodConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					dayOfWeek
					startTimeMinutes
					endTimeMinutes
					isActive
				}
			}
		}
	}
`;

/**
 * __useCourseSectionPeriodIndexQuery__
 *
 * To run a query within a React component, call `useCourseSectionPeriodIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionPeriodIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionPeriodIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionPeriodIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseSectionPeriodIndexQuery, CourseSectionPeriodIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionPeriodIndexQuery, CourseSectionPeriodIndexQueryVariables>(
		CourseSectionPeriodIndexDocument,
		options,
	);
}
export function useCourseSectionPeriodIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseSectionPeriodIndexQuery, CourseSectionPeriodIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionPeriodIndexQuery, CourseSectionPeriodIndexQueryVariables>(
		CourseSectionPeriodIndexDocument,
		options,
	);
}
export function useCourseSectionPeriodIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseSectionPeriodIndexQuery, CourseSectionPeriodIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionPeriodIndexQuery, CourseSectionPeriodIndexQueryVariables>(
		CourseSectionPeriodIndexDocument,
		options,
	);
}
export type CourseSectionPeriodIndexQueryHookResult = ReturnType<typeof useCourseSectionPeriodIndexQuery>;
export type CourseSectionPeriodIndexLazyQueryHookResult = ReturnType<typeof useCourseSectionPeriodIndexLazyQuery>;
export type CourseSectionPeriodIndexSuspenseQueryHookResult = ReturnType<
	typeof useCourseSectionPeriodIndexSuspenseQuery
>;
export type CourseSectionPeriodIndexQueryResult = Apollo.QueryResult<
	CourseSectionPeriodIndexQuery,
	CourseSectionPeriodIndexQueryVariables
>;
export const CourseSectionPeriodNameDocument = gql`
	query courseSectionPeriodName($id: ID!) {
		courseSectionPeriod(id: $id) {
			id
			...CourseSectionPeriodName
		}
	}
	${CourseSectionPeriodNameFragmentDoc}
`;

/**
 * __useCourseSectionPeriodNameQuery__
 *
 * To run a query within a React component, call `useCourseSectionPeriodNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionPeriodNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionPeriodNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCourseSectionPeriodNameQuery(
	baseOptions: Apollo.QueryHookOptions<CourseSectionPeriodNameQuery, CourseSectionPeriodNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionPeriodNameQuery, CourseSectionPeriodNameQueryVariables>(
		CourseSectionPeriodNameDocument,
		options,
	);
}
export function useCourseSectionPeriodNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseSectionPeriodNameQuery, CourseSectionPeriodNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionPeriodNameQuery, CourseSectionPeriodNameQueryVariables>(
		CourseSectionPeriodNameDocument,
		options,
	);
}
export function useCourseSectionPeriodNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseSectionPeriodNameQuery, CourseSectionPeriodNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionPeriodNameQuery, CourseSectionPeriodNameQueryVariables>(
		CourseSectionPeriodNameDocument,
		options,
	);
}
export type CourseSectionPeriodNameQueryHookResult = ReturnType<typeof useCourseSectionPeriodNameQuery>;
export type CourseSectionPeriodNameLazyQueryHookResult = ReturnType<typeof useCourseSectionPeriodNameLazyQuery>;
export type CourseSectionPeriodNameSuspenseQueryHookResult = ReturnType<typeof useCourseSectionPeriodNameSuspenseQuery>;
export type CourseSectionPeriodNameQueryResult = Apollo.QueryResult<
	CourseSectionPeriodNameQuery,
	CourseSectionPeriodNameQueryVariables
>;
export const CourseSectionPeriodNamesDocument = gql`
	query courseSectionPeriodNames(
		$filters: [CourseSectionPeriodFilterInput!]
		$pagination: Pagination
		$order: CourseSectionPeriodOrder
	) {
		courseSectionPeriodConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...CourseSectionPeriodName
				}
			}
		}
	}
	${CourseSectionPeriodNameFragmentDoc}
`;

/**
 * __useCourseSectionPeriodNamesQuery__
 *
 * To run a query within a React component, call `useCourseSectionPeriodNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionPeriodNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionPeriodNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionPeriodNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseSectionPeriodNamesQuery, CourseSectionPeriodNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionPeriodNamesQuery, CourseSectionPeriodNamesQueryVariables>(
		CourseSectionPeriodNamesDocument,
		options,
	);
}
export function useCourseSectionPeriodNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseSectionPeriodNamesQuery, CourseSectionPeriodNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionPeriodNamesQuery, CourseSectionPeriodNamesQueryVariables>(
		CourseSectionPeriodNamesDocument,
		options,
	);
}
export function useCourseSectionPeriodNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CourseSectionPeriodNamesQuery, CourseSectionPeriodNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionPeriodNamesQuery, CourseSectionPeriodNamesQueryVariables>(
		CourseSectionPeriodNamesDocument,
		options,
	);
}
export type CourseSectionPeriodNamesQueryHookResult = ReturnType<typeof useCourseSectionPeriodNamesQuery>;
export type CourseSectionPeriodNamesLazyQueryHookResult = ReturnType<typeof useCourseSectionPeriodNamesLazyQuery>;
export type CourseSectionPeriodNamesSuspenseQueryHookResult = ReturnType<
	typeof useCourseSectionPeriodNamesSuspenseQuery
>;
export type CourseSectionPeriodNamesQueryResult = Apollo.QueryResult<
	CourseSectionPeriodNamesQuery,
	CourseSectionPeriodNamesQueryVariables
>;
export const CourseSectionPeriodPaginationDocument = gql`
	query courseSectionPeriodPagination($filters: [CourseSectionPeriodFilterInput!], $order: CourseSectionPeriodOrder) {
		courseSectionPeriodConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useCourseSectionPeriodPaginationQuery__
 *
 * To run a query within a React component, call `useCourseSectionPeriodPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionPeriodPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionPeriodPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionPeriodPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseSectionPeriodPaginationQuery,
		CourseSectionPeriodPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionPeriodPaginationQuery, CourseSectionPeriodPaginationQueryVariables>(
		CourseSectionPeriodPaginationDocument,
		options,
	);
}
export function useCourseSectionPeriodPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseSectionPeriodPaginationQuery,
		CourseSectionPeriodPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionPeriodPaginationQuery, CourseSectionPeriodPaginationQueryVariables>(
		CourseSectionPeriodPaginationDocument,
		options,
	);
}
export function useCourseSectionPeriodPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseSectionPeriodPaginationQuery,
		CourseSectionPeriodPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionPeriodPaginationQuery, CourseSectionPeriodPaginationQueryVariables>(
		CourseSectionPeriodPaginationDocument,
		options,
	);
}
export type CourseSectionPeriodPaginationQueryHookResult = ReturnType<typeof useCourseSectionPeriodPaginationQuery>;
export type CourseSectionPeriodPaginationLazyQueryHookResult = ReturnType<
	typeof useCourseSectionPeriodPaginationLazyQuery
>;
export type CourseSectionPeriodPaginationSuspenseQueryHookResult = ReturnType<
	typeof useCourseSectionPeriodPaginationSuspenseQuery
>;
export type CourseSectionPeriodPaginationQueryResult = Apollo.QueryResult<
	CourseSectionPeriodPaginationQuery,
	CourseSectionPeriodPaginationQueryVariables
>;
export const CourseSectionPeriodScheduleListDocument = gql`
	query courseSectionPeriodScheduleList(
		$filters: [CourseSectionPeriodFilterInput!]
		$pagination: Pagination
		$order: CourseSectionPeriodOrder
	) {
		courseSectionPeriodConnection(filters: $filters, pagination: $pagination, order: $order) {
			pageInfo {
				hasNextPage
				endCursor
			}
			edges {
				node {
					id
					dayOfWeek
					startTimeMinutes
					endTimeMinutes
					isActive
					courseSection {
						id
						...CourseSectionName
						academicTerm {
							id
							...AcademicTermName
							startDate
							endDate
						}
						course {
							id
							academicSubject {
								id
								...AcademicSubjectNameAndColor
							}
							classYears {
								id
								...ClassYearName
							}
						}
						homeRoomSection {
							id
							...HomeRoomSectionName
						}
					}
					room {
						id
						...RoomName
					}
				}
			}
		}
	}
	${CourseSectionNameFragmentDoc}
	${AcademicTermNameFragmentDoc}
	${AcademicSubjectNameAndColorFragmentDoc}
	${ClassYearNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${RoomNameFragmentDoc}
`;

/**
 * __useCourseSectionPeriodScheduleListQuery__
 *
 * To run a query within a React component, call `useCourseSectionPeriodScheduleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionPeriodScheduleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionPeriodScheduleListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionPeriodScheduleListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseSectionPeriodScheduleListQuery,
		CourseSectionPeriodScheduleListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionPeriodScheduleListQuery, CourseSectionPeriodScheduleListQueryVariables>(
		CourseSectionPeriodScheduleListDocument,
		options,
	);
}
export function useCourseSectionPeriodScheduleListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseSectionPeriodScheduleListQuery,
		CourseSectionPeriodScheduleListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionPeriodScheduleListQuery, CourseSectionPeriodScheduleListQueryVariables>(
		CourseSectionPeriodScheduleListDocument,
		options,
	);
}
export function useCourseSectionPeriodScheduleListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseSectionPeriodScheduleListQuery,
		CourseSectionPeriodScheduleListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionPeriodScheduleListQuery, CourseSectionPeriodScheduleListQueryVariables>(
		CourseSectionPeriodScheduleListDocument,
		options,
	);
}
export type CourseSectionPeriodScheduleListQueryHookResult = ReturnType<typeof useCourseSectionPeriodScheduleListQuery>;
export type CourseSectionPeriodScheduleListLazyQueryHookResult = ReturnType<
	typeof useCourseSectionPeriodScheduleListLazyQuery
>;
export type CourseSectionPeriodScheduleListSuspenseQueryHookResult = ReturnType<
	typeof useCourseSectionPeriodScheduleListSuspenseQuery
>;
export type CourseSectionPeriodScheduleListQueryResult = Apollo.QueryResult<
	CourseSectionPeriodScheduleListQuery,
	CourseSectionPeriodScheduleListQueryVariables
>;
export const CourseSectionCourseSectionPeriodScheduleListDocument = gql`
	query courseSectionCourseSectionPeriodScheduleList(
		$date: Date!
		$filters: [CourseSectionPeriodFilterInput!]
		$pagination: Pagination
		$order: CourseSectionPeriodOrder
	) {
		courseSectionPeriodConnection(filters: $filters, pagination: $pagination, order: $order) {
			pageInfo {
				hasNextPage
				endCursor
			}
			edges {
				node {
					id
					dayOfWeek
					startTimeMinutes
					endTimeMinutes
					isActive
					room {
						id
						...RoomName
					}
					courseAttendanceRecords(filters: { attendanceDateEQ: $date }) {
						id
					}
				}
			}
		}
	}
	${RoomNameFragmentDoc}
`;

/**
 * __useCourseSectionCourseSectionPeriodScheduleListQuery__
 *
 * To run a query within a React component, call `useCourseSectionCourseSectionPeriodScheduleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionCourseSectionPeriodScheduleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionCourseSectionPeriodScheduleListQuery({
 *   variables: {
 *      date: // value for 'date'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionCourseSectionPeriodScheduleListQuery(
	baseOptions: Apollo.QueryHookOptions<
		CourseSectionCourseSectionPeriodScheduleListQuery,
		CourseSectionCourseSectionPeriodScheduleListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CourseSectionCourseSectionPeriodScheduleListQuery,
		CourseSectionCourseSectionPeriodScheduleListQueryVariables
	>(CourseSectionCourseSectionPeriodScheduleListDocument, options);
}
export function useCourseSectionCourseSectionPeriodScheduleListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseSectionCourseSectionPeriodScheduleListQuery,
		CourseSectionCourseSectionPeriodScheduleListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CourseSectionCourseSectionPeriodScheduleListQuery,
		CourseSectionCourseSectionPeriodScheduleListQueryVariables
	>(CourseSectionCourseSectionPeriodScheduleListDocument, options);
}
export function useCourseSectionCourseSectionPeriodScheduleListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseSectionCourseSectionPeriodScheduleListQuery,
		CourseSectionCourseSectionPeriodScheduleListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CourseSectionCourseSectionPeriodScheduleListQuery,
		CourseSectionCourseSectionPeriodScheduleListQueryVariables
	>(CourseSectionCourseSectionPeriodScheduleListDocument, options);
}
export type CourseSectionCourseSectionPeriodScheduleListQueryHookResult = ReturnType<
	typeof useCourseSectionCourseSectionPeriodScheduleListQuery
>;
export type CourseSectionCourseSectionPeriodScheduleListLazyQueryHookResult = ReturnType<
	typeof useCourseSectionCourseSectionPeriodScheduleListLazyQuery
>;
export type CourseSectionCourseSectionPeriodScheduleListSuspenseQueryHookResult = ReturnType<
	typeof useCourseSectionCourseSectionPeriodScheduleListSuspenseQuery
>;
export type CourseSectionCourseSectionPeriodScheduleListQueryResult = Apollo.QueryResult<
	CourseSectionCourseSectionPeriodScheduleListQuery,
	CourseSectionCourseSectionPeriodScheduleListQueryVariables
>;
export const CourseSectionPeriodScheduleWithStudentsListDocument = gql`
	query courseSectionPeriodScheduleWithStudentsList(
		$filters: [CourseSectionPeriodFilterInput!]
		$pagination: Pagination
		$order: CourseSectionPeriodOrder
	) {
		courseSectionPeriodConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					dayOfWeek
					startTimeMinutes
					endTimeMinutes
					isActive
					courseSection {
						id
						...CourseSectionName
						academicTerm {
							id
							...AcademicTermName
							startDate
							endDate
						}
						course {
							id
							academicSubject {
								id
								...AcademicSubjectNameAndColor
							}
							classYears {
								id
								...ClassYearName
							}
						}
						homeRoomSection {
							id
							...HomeRoomSectionName
						}
						studentCourseSectionEnrollments {
							id
							lateStartDate
							earlyEndDate
						}
					}
					room {
						id
						...RoomName
					}
				}
			}
		}
	}
	${CourseSectionNameFragmentDoc}
	${AcademicTermNameFragmentDoc}
	${AcademicSubjectNameAndColorFragmentDoc}
	${ClassYearNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${RoomNameFragmentDoc}
`;

/**
 * __useCourseSectionPeriodScheduleWithStudentsListQuery__
 *
 * To run a query within a React component, call `useCourseSectionPeriodScheduleWithStudentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionPeriodScheduleWithStudentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionPeriodScheduleWithStudentsListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionPeriodScheduleWithStudentsListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CourseSectionPeriodScheduleWithStudentsListQuery,
		CourseSectionPeriodScheduleWithStudentsListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CourseSectionPeriodScheduleWithStudentsListQuery,
		CourseSectionPeriodScheduleWithStudentsListQueryVariables
	>(CourseSectionPeriodScheduleWithStudentsListDocument, options);
}
export function useCourseSectionPeriodScheduleWithStudentsListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseSectionPeriodScheduleWithStudentsListQuery,
		CourseSectionPeriodScheduleWithStudentsListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CourseSectionPeriodScheduleWithStudentsListQuery,
		CourseSectionPeriodScheduleWithStudentsListQueryVariables
	>(CourseSectionPeriodScheduleWithStudentsListDocument, options);
}
export function useCourseSectionPeriodScheduleWithStudentsListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseSectionPeriodScheduleWithStudentsListQuery,
		CourseSectionPeriodScheduleWithStudentsListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CourseSectionPeriodScheduleWithStudentsListQuery,
		CourseSectionPeriodScheduleWithStudentsListQueryVariables
	>(CourseSectionPeriodScheduleWithStudentsListDocument, options);
}
export type CourseSectionPeriodScheduleWithStudentsListQueryHookResult = ReturnType<
	typeof useCourseSectionPeriodScheduleWithStudentsListQuery
>;
export type CourseSectionPeriodScheduleWithStudentsListLazyQueryHookResult = ReturnType<
	typeof useCourseSectionPeriodScheduleWithStudentsListLazyQuery
>;
export type CourseSectionPeriodScheduleWithStudentsListSuspenseQueryHookResult = ReturnType<
	typeof useCourseSectionPeriodScheduleWithStudentsListSuspenseQuery
>;
export type CourseSectionPeriodScheduleWithStudentsListQueryResult = Apollo.QueryResult<
	CourseSectionPeriodScheduleWithStudentsListQuery,
	CourseSectionPeriodScheduleWithStudentsListQueryVariables
>;
export const CourseSectionPeriodSelectDocument = gql`
	query courseSectionPeriodSelect($filters: [CourseSectionPeriodFilterInput!], $order: CourseSectionPeriodOrder) {
		courseSectionPeriodConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...CourseSectionPeriodName
				}
			}
		}
	}
	${CourseSectionPeriodNameFragmentDoc}
`;

/**
 * __useCourseSectionPeriodSelectQuery__
 *
 * To run a query within a React component, call `useCourseSectionPeriodSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionPeriodSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionPeriodSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCourseSectionPeriodSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<CourseSectionPeriodSelectQuery, CourseSectionPeriodSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionPeriodSelectQuery, CourseSectionPeriodSelectQueryVariables>(
		CourseSectionPeriodSelectDocument,
		options,
	);
}
export function useCourseSectionPeriodSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CourseSectionPeriodSelectQuery, CourseSectionPeriodSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CourseSectionPeriodSelectQuery, CourseSectionPeriodSelectQueryVariables>(
		CourseSectionPeriodSelectDocument,
		options,
	);
}
export function useCourseSectionPeriodSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseSectionPeriodSelectQuery,
		CourseSectionPeriodSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CourseSectionPeriodSelectQuery, CourseSectionPeriodSelectQueryVariables>(
		CourseSectionPeriodSelectDocument,
		options,
	);
}
export type CourseSectionPeriodSelectQueryHookResult = ReturnType<typeof useCourseSectionPeriodSelectQuery>;
export type CourseSectionPeriodSelectLazyQueryHookResult = ReturnType<typeof useCourseSectionPeriodSelectLazyQuery>;
export type CourseSectionPeriodSelectSuspenseQueryHookResult = ReturnType<
	typeof useCourseSectionPeriodSelectSuspenseQuery
>;
export type CourseSectionPeriodSelectQueryResult = Apollo.QueryResult<
	CourseSectionPeriodSelectQuery,
	CourseSectionPeriodSelectQueryVariables
>;
export const CourseSectionPeriodUpdateDocument = gql`
	mutation courseSectionPeriodUpdate($id: ID!, $input: CourseSectionPeriodUpdateInput!) {
		updateCourseSectionPeriod(id: $id, input: $input) {
			...CourseSectionPeriodDetail
		}
	}
	${CourseSectionPeriodDetailFragmentDoc}
`;
export type CourseSectionPeriodUpdateMutationFn = Apollo.MutationFunction<
	CourseSectionPeriodUpdateMutation,
	CourseSectionPeriodUpdateMutationVariables
>;

/**
 * __useCourseSectionPeriodUpdateMutation__
 *
 * To run a mutation, you first call `useCourseSectionPeriodUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionPeriodUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseSectionPeriodUpdateMutation, { data, loading, error }] = useCourseSectionPeriodUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCourseSectionPeriodUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CourseSectionPeriodUpdateMutation,
		CourseSectionPeriodUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CourseSectionPeriodUpdateMutation, CourseSectionPeriodUpdateMutationVariables>(
		CourseSectionPeriodUpdateDocument,
		options,
	);
}
export type CourseSectionPeriodUpdateMutationHookResult = ReturnType<typeof useCourseSectionPeriodUpdateMutation>;
export type CourseSectionPeriodUpdateMutationResult = Apollo.MutationResult<CourseSectionPeriodUpdateMutation>;
export type CourseSectionPeriodUpdateMutationOptions = Apollo.BaseMutationOptions<
	CourseSectionPeriodUpdateMutation,
	CourseSectionPeriodUpdateMutationVariables
>;
export const DiscountCountDocument = gql`
	query discountCount($filters: [DiscountFilterInput!], $pagination: Pagination, $order: DiscountOrder) {
		discountConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useDiscountCountQuery__
 *
 * To run a query within a React component, call `useDiscountCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useDiscountCountQuery(
	baseOptions?: Apollo.QueryHookOptions<DiscountCountQuery, DiscountCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<DiscountCountQuery, DiscountCountQueryVariables>(DiscountCountDocument, options);
}
export function useDiscountCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<DiscountCountQuery, DiscountCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<DiscountCountQuery, DiscountCountQueryVariables>(DiscountCountDocument, options);
}
export function useDiscountCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<DiscountCountQuery, DiscountCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<DiscountCountQuery, DiscountCountQueryVariables>(DiscountCountDocument, options);
}
export type DiscountCountQueryHookResult = ReturnType<typeof useDiscountCountQuery>;
export type DiscountCountLazyQueryHookResult = ReturnType<typeof useDiscountCountLazyQuery>;
export type DiscountCountSuspenseQueryHookResult = ReturnType<typeof useDiscountCountSuspenseQuery>;
export type DiscountCountQueryResult = Apollo.QueryResult<DiscountCountQuery, DiscountCountQueryVariables>;
export const DiscountCreateDocument = gql`
	mutation discountCreate($input: DiscountCreateInput!) {
		createDiscount(input: $input) {
			...DiscountDetail
		}
	}
	${DiscountDetailFragmentDoc}
`;
export type DiscountCreateMutationFn = Apollo.MutationFunction<DiscountCreateMutation, DiscountCreateMutationVariables>;

/**
 * __useDiscountCreateMutation__
 *
 * To run a mutation, you first call `useDiscountCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscountCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discountCreateMutation, { data, loading, error }] = useDiscountCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDiscountCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<DiscountCreateMutation, DiscountCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DiscountCreateMutation, DiscountCreateMutationVariables>(DiscountCreateDocument, options);
}
export type DiscountCreateMutationHookResult = ReturnType<typeof useDiscountCreateMutation>;
export type DiscountCreateMutationResult = Apollo.MutationResult<DiscountCreateMutation>;
export type DiscountCreateMutationOptions = Apollo.BaseMutationOptions<
	DiscountCreateMutation,
	DiscountCreateMutationVariables
>;
export const DiscountDeleteDocument = gql`
	mutation discountDelete($id: ID!) {
		deleteDiscount(id: $id)
	}
`;
export type DiscountDeleteMutationFn = Apollo.MutationFunction<DiscountDeleteMutation, DiscountDeleteMutationVariables>;

/**
 * __useDiscountDeleteMutation__
 *
 * To run a mutation, you first call `useDiscountDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscountDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discountDeleteMutation, { data, loading, error }] = useDiscountDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDiscountDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<DiscountDeleteMutation, DiscountDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DiscountDeleteMutation, DiscountDeleteMutationVariables>(DiscountDeleteDocument, options);
}
export type DiscountDeleteMutationHookResult = ReturnType<typeof useDiscountDeleteMutation>;
export type DiscountDeleteMutationResult = Apollo.MutationResult<DiscountDeleteMutation>;
export type DiscountDeleteMutationOptions = Apollo.BaseMutationOptions<
	DiscountDeleteMutation,
	DiscountDeleteMutationVariables
>;
export const DiscountDetailDocument = gql`
	query discountDetail($id: ID!) {
		discount(id: $id) {
			...DiscountDetail
		}
	}
	${DiscountDetailFragmentDoc}
`;

/**
 * __useDiscountDetailQuery__
 *
 * To run a query within a React component, call `useDiscountDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDiscountDetailQuery(
	baseOptions: Apollo.QueryHookOptions<DiscountDetailQuery, DiscountDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<DiscountDetailQuery, DiscountDetailQueryVariables>(DiscountDetailDocument, options);
}
export function useDiscountDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<DiscountDetailQuery, DiscountDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<DiscountDetailQuery, DiscountDetailQueryVariables>(DiscountDetailDocument, options);
}
export function useDiscountDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<DiscountDetailQuery, DiscountDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<DiscountDetailQuery, DiscountDetailQueryVariables>(DiscountDetailDocument, options);
}
export type DiscountDetailQueryHookResult = ReturnType<typeof useDiscountDetailQuery>;
export type DiscountDetailLazyQueryHookResult = ReturnType<typeof useDiscountDetailLazyQuery>;
export type DiscountDetailSuspenseQueryHookResult = ReturnType<typeof useDiscountDetailSuspenseQuery>;
export type DiscountDetailQueryResult = Apollo.QueryResult<DiscountDetailQuery, DiscountDetailQueryVariables>;
export const DiscountIndexDocument = gql`
	query discountIndex($filters: [DiscountFilterInput!], $pagination: Pagination, $order: DiscountOrder) {
		discountConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					description
					isActive
					isPercentageAmount
					flatAmount
					percentageAmount
				}
			}
		}
	}
`;

/**
 * __useDiscountIndexQuery__
 *
 * To run a query within a React component, call `useDiscountIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useDiscountIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<DiscountIndexQuery, DiscountIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<DiscountIndexQuery, DiscountIndexQueryVariables>(DiscountIndexDocument, options);
}
export function useDiscountIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<DiscountIndexQuery, DiscountIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<DiscountIndexQuery, DiscountIndexQueryVariables>(DiscountIndexDocument, options);
}
export function useDiscountIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<DiscountIndexQuery, DiscountIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<DiscountIndexQuery, DiscountIndexQueryVariables>(DiscountIndexDocument, options);
}
export type DiscountIndexQueryHookResult = ReturnType<typeof useDiscountIndexQuery>;
export type DiscountIndexLazyQueryHookResult = ReturnType<typeof useDiscountIndexLazyQuery>;
export type DiscountIndexSuspenseQueryHookResult = ReturnType<typeof useDiscountIndexSuspenseQuery>;
export type DiscountIndexQueryResult = Apollo.QueryResult<DiscountIndexQuery, DiscountIndexQueryVariables>;
export const DiscountNameDocument = gql`
	query discountName($id: ID!) {
		discount(id: $id) {
			id
			...DiscountName
		}
	}
	${DiscountNameFragmentDoc}
`;

/**
 * __useDiscountNameQuery__
 *
 * To run a query within a React component, call `useDiscountNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDiscountNameQuery(
	baseOptions: Apollo.QueryHookOptions<DiscountNameQuery, DiscountNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<DiscountNameQuery, DiscountNameQueryVariables>(DiscountNameDocument, options);
}
export function useDiscountNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<DiscountNameQuery, DiscountNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<DiscountNameQuery, DiscountNameQueryVariables>(DiscountNameDocument, options);
}
export function useDiscountNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<DiscountNameQuery, DiscountNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<DiscountNameQuery, DiscountNameQueryVariables>(DiscountNameDocument, options);
}
export type DiscountNameQueryHookResult = ReturnType<typeof useDiscountNameQuery>;
export type DiscountNameLazyQueryHookResult = ReturnType<typeof useDiscountNameLazyQuery>;
export type DiscountNameSuspenseQueryHookResult = ReturnType<typeof useDiscountNameSuspenseQuery>;
export type DiscountNameQueryResult = Apollo.QueryResult<DiscountNameQuery, DiscountNameQueryVariables>;
export const DiscountNamesDocument = gql`
	query discountNames($filters: [DiscountFilterInput!], $pagination: Pagination, $order: DiscountOrder) {
		discountConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...DiscountName
				}
			}
		}
	}
	${DiscountNameFragmentDoc}
`;

/**
 * __useDiscountNamesQuery__
 *
 * To run a query within a React component, call `useDiscountNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useDiscountNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<DiscountNamesQuery, DiscountNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<DiscountNamesQuery, DiscountNamesQueryVariables>(DiscountNamesDocument, options);
}
export function useDiscountNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<DiscountNamesQuery, DiscountNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<DiscountNamesQuery, DiscountNamesQueryVariables>(DiscountNamesDocument, options);
}
export function useDiscountNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<DiscountNamesQuery, DiscountNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<DiscountNamesQuery, DiscountNamesQueryVariables>(DiscountNamesDocument, options);
}
export type DiscountNamesQueryHookResult = ReturnType<typeof useDiscountNamesQuery>;
export type DiscountNamesLazyQueryHookResult = ReturnType<typeof useDiscountNamesLazyQuery>;
export type DiscountNamesSuspenseQueryHookResult = ReturnType<typeof useDiscountNamesSuspenseQuery>;
export type DiscountNamesQueryResult = Apollo.QueryResult<DiscountNamesQuery, DiscountNamesQueryVariables>;
export const DiscountPaginationDocument = gql`
	query discountPagination($filters: [DiscountFilterInput!], $order: DiscountOrder) {
		discountConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useDiscountPaginationQuery__
 *
 * To run a query within a React component, call `useDiscountPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useDiscountPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<DiscountPaginationQuery, DiscountPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<DiscountPaginationQuery, DiscountPaginationQueryVariables>(
		DiscountPaginationDocument,
		options,
	);
}
export function useDiscountPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<DiscountPaginationQuery, DiscountPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<DiscountPaginationQuery, DiscountPaginationQueryVariables>(
		DiscountPaginationDocument,
		options,
	);
}
export function useDiscountPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<DiscountPaginationQuery, DiscountPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<DiscountPaginationQuery, DiscountPaginationQueryVariables>(
		DiscountPaginationDocument,
		options,
	);
}
export type DiscountPaginationQueryHookResult = ReturnType<typeof useDiscountPaginationQuery>;
export type DiscountPaginationLazyQueryHookResult = ReturnType<typeof useDiscountPaginationLazyQuery>;
export type DiscountPaginationSuspenseQueryHookResult = ReturnType<typeof useDiscountPaginationSuspenseQuery>;
export type DiscountPaginationQueryResult = Apollo.QueryResult<
	DiscountPaginationQuery,
	DiscountPaginationQueryVariables
>;
export const DiscountSelectDocument = gql`
	query discountSelect($filters: [DiscountFilterInput!], $order: DiscountOrder) {
		discountConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...DiscountName
					isPercentageAmount
					flatAmount
					percentageAmount
				}
			}
		}
	}
	${DiscountNameFragmentDoc}
`;

/**
 * __useDiscountSelectQuery__
 *
 * To run a query within a React component, call `useDiscountSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useDiscountSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<DiscountSelectQuery, DiscountSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<DiscountSelectQuery, DiscountSelectQueryVariables>(DiscountSelectDocument, options);
}
export function useDiscountSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<DiscountSelectQuery, DiscountSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<DiscountSelectQuery, DiscountSelectQueryVariables>(DiscountSelectDocument, options);
}
export function useDiscountSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<DiscountSelectQuery, DiscountSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<DiscountSelectQuery, DiscountSelectQueryVariables>(DiscountSelectDocument, options);
}
export type DiscountSelectQueryHookResult = ReturnType<typeof useDiscountSelectQuery>;
export type DiscountSelectLazyQueryHookResult = ReturnType<typeof useDiscountSelectLazyQuery>;
export type DiscountSelectSuspenseQueryHookResult = ReturnType<typeof useDiscountSelectSuspenseQuery>;
export type DiscountSelectQueryResult = Apollo.QueryResult<DiscountSelectQuery, DiscountSelectQueryVariables>;
export const DiscountUpdateDocument = gql`
	mutation discountUpdate($id: ID!, $input: DiscountUpdateInput!) {
		updateDiscount(id: $id, input: $input) {
			...DiscountDetail
		}
	}
	${DiscountDetailFragmentDoc}
`;
export type DiscountUpdateMutationFn = Apollo.MutationFunction<DiscountUpdateMutation, DiscountUpdateMutationVariables>;

/**
 * __useDiscountUpdateMutation__
 *
 * To run a mutation, you first call `useDiscountUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscountUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discountUpdateMutation, { data, loading, error }] = useDiscountUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDiscountUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<DiscountUpdateMutation, DiscountUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<DiscountUpdateMutation, DiscountUpdateMutationVariables>(DiscountUpdateDocument, options);
}
export type DiscountUpdateMutationHookResult = ReturnType<typeof useDiscountUpdateMutation>;
export type DiscountUpdateMutationResult = Apollo.MutationResult<DiscountUpdateMutation>;
export type DiscountUpdateMutationOptions = Apollo.BaseMutationOptions<
	DiscountUpdateMutation,
	DiscountUpdateMutationVariables
>;
export const EmailAddressCountDocument = gql`
	query emailAddressCount($filters: [EmailAddressFilterInput!], $pagination: Pagination, $order: EmailAddressOrder) {
		emailAddressConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useEmailAddressCountQuery__
 *
 * To run a query within a React component, call `useEmailAddressCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailAddressCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailAddressCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEmailAddressCountQuery(
	baseOptions?: Apollo.QueryHookOptions<EmailAddressCountQuery, EmailAddressCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EmailAddressCountQuery, EmailAddressCountQueryVariables>(EmailAddressCountDocument, options);
}
export function useEmailAddressCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EmailAddressCountQuery, EmailAddressCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EmailAddressCountQuery, EmailAddressCountQueryVariables>(
		EmailAddressCountDocument,
		options,
	);
}
export function useEmailAddressCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<EmailAddressCountQuery, EmailAddressCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EmailAddressCountQuery, EmailAddressCountQueryVariables>(
		EmailAddressCountDocument,
		options,
	);
}
export type EmailAddressCountQueryHookResult = ReturnType<typeof useEmailAddressCountQuery>;
export type EmailAddressCountLazyQueryHookResult = ReturnType<typeof useEmailAddressCountLazyQuery>;
export type EmailAddressCountSuspenseQueryHookResult = ReturnType<typeof useEmailAddressCountSuspenseQuery>;
export type EmailAddressCountQueryResult = Apollo.QueryResult<EmailAddressCountQuery, EmailAddressCountQueryVariables>;
export const EmailAddressCreateDocument = gql`
	mutation emailAddressCreate($input: EmailAddressCreateInput!) {
		createEmailAddress(input: $input) {
			...EmailAddressDetail
		}
	}
	${EmailAddressDetailFragmentDoc}
`;
export type EmailAddressCreateMutationFn = Apollo.MutationFunction<
	EmailAddressCreateMutation,
	EmailAddressCreateMutationVariables
>;

/**
 * __useEmailAddressCreateMutation__
 *
 * To run a mutation, you first call `useEmailAddressCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailAddressCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailAddressCreateMutation, { data, loading, error }] = useEmailAddressCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmailAddressCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<EmailAddressCreateMutation, EmailAddressCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<EmailAddressCreateMutation, EmailAddressCreateMutationVariables>(
		EmailAddressCreateDocument,
		options,
	);
}
export type EmailAddressCreateMutationHookResult = ReturnType<typeof useEmailAddressCreateMutation>;
export type EmailAddressCreateMutationResult = Apollo.MutationResult<EmailAddressCreateMutation>;
export type EmailAddressCreateMutationOptions = Apollo.BaseMutationOptions<
	EmailAddressCreateMutation,
	EmailAddressCreateMutationVariables
>;
export const EmailAddressDeleteDocument = gql`
	mutation emailAddressDelete($id: ID!) {
		deleteEmailAddress(id: $id)
	}
`;
export type EmailAddressDeleteMutationFn = Apollo.MutationFunction<
	EmailAddressDeleteMutation,
	EmailAddressDeleteMutationVariables
>;

/**
 * __useEmailAddressDeleteMutation__
 *
 * To run a mutation, you first call `useEmailAddressDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailAddressDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailAddressDeleteMutation, { data, loading, error }] = useEmailAddressDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailAddressDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<EmailAddressDeleteMutation, EmailAddressDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<EmailAddressDeleteMutation, EmailAddressDeleteMutationVariables>(
		EmailAddressDeleteDocument,
		options,
	);
}
export type EmailAddressDeleteMutationHookResult = ReturnType<typeof useEmailAddressDeleteMutation>;
export type EmailAddressDeleteMutationResult = Apollo.MutationResult<EmailAddressDeleteMutation>;
export type EmailAddressDeleteMutationOptions = Apollo.BaseMutationOptions<
	EmailAddressDeleteMutation,
	EmailAddressDeleteMutationVariables
>;
export const EmailAddressDetailDocument = gql`
	query emailAddressDetail($id: ID!) {
		emailAddress(id: $id) {
			...EmailAddressDetail
		}
	}
	${EmailAddressDetailFragmentDoc}
`;

/**
 * __useEmailAddressDetailQuery__
 *
 * To run a query within a React component, call `useEmailAddressDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailAddressDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailAddressDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailAddressDetailQuery(
	baseOptions: Apollo.QueryHookOptions<EmailAddressDetailQuery, EmailAddressDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EmailAddressDetailQuery, EmailAddressDetailQueryVariables>(
		EmailAddressDetailDocument,
		options,
	);
}
export function useEmailAddressDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EmailAddressDetailQuery, EmailAddressDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EmailAddressDetailQuery, EmailAddressDetailQueryVariables>(
		EmailAddressDetailDocument,
		options,
	);
}
export function useEmailAddressDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<EmailAddressDetailQuery, EmailAddressDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EmailAddressDetailQuery, EmailAddressDetailQueryVariables>(
		EmailAddressDetailDocument,
		options,
	);
}
export type EmailAddressDetailQueryHookResult = ReturnType<typeof useEmailAddressDetailQuery>;
export type EmailAddressDetailLazyQueryHookResult = ReturnType<typeof useEmailAddressDetailLazyQuery>;
export type EmailAddressDetailSuspenseQueryHookResult = ReturnType<typeof useEmailAddressDetailSuspenseQuery>;
export type EmailAddressDetailQueryResult = Apollo.QueryResult<
	EmailAddressDetailQuery,
	EmailAddressDetailQueryVariables
>;
export const EmailAddressIndexDocument = gql`
	query emailAddressIndex($filters: [EmailAddressFilterInput!], $pagination: Pagination, $order: EmailAddressOrder) {
		emailAddressConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					emailAddress
					isPrimary
				}
			}
		}
	}
`;

/**
 * __useEmailAddressIndexQuery__
 *
 * To run a query within a React component, call `useEmailAddressIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailAddressIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailAddressIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEmailAddressIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<EmailAddressIndexQuery, EmailAddressIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EmailAddressIndexQuery, EmailAddressIndexQueryVariables>(EmailAddressIndexDocument, options);
}
export function useEmailAddressIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EmailAddressIndexQuery, EmailAddressIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EmailAddressIndexQuery, EmailAddressIndexQueryVariables>(
		EmailAddressIndexDocument,
		options,
	);
}
export function useEmailAddressIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<EmailAddressIndexQuery, EmailAddressIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EmailAddressIndexQuery, EmailAddressIndexQueryVariables>(
		EmailAddressIndexDocument,
		options,
	);
}
export type EmailAddressIndexQueryHookResult = ReturnType<typeof useEmailAddressIndexQuery>;
export type EmailAddressIndexLazyQueryHookResult = ReturnType<typeof useEmailAddressIndexLazyQuery>;
export type EmailAddressIndexSuspenseQueryHookResult = ReturnType<typeof useEmailAddressIndexSuspenseQuery>;
export type EmailAddressIndexQueryResult = Apollo.QueryResult<EmailAddressIndexQuery, EmailAddressIndexQueryVariables>;
export const EmailAddressNameDocument = gql`
	query emailAddressName($id: ID!) {
		emailAddress(id: $id) {
			id
			...EmailAddressName
		}
	}
	${EmailAddressNameFragmentDoc}
`;

/**
 * __useEmailAddressNameQuery__
 *
 * To run a query within a React component, call `useEmailAddressNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailAddressNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailAddressNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailAddressNameQuery(
	baseOptions: Apollo.QueryHookOptions<EmailAddressNameQuery, EmailAddressNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EmailAddressNameQuery, EmailAddressNameQueryVariables>(EmailAddressNameDocument, options);
}
export function useEmailAddressNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EmailAddressNameQuery, EmailAddressNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EmailAddressNameQuery, EmailAddressNameQueryVariables>(EmailAddressNameDocument, options);
}
export function useEmailAddressNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<EmailAddressNameQuery, EmailAddressNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EmailAddressNameQuery, EmailAddressNameQueryVariables>(
		EmailAddressNameDocument,
		options,
	);
}
export type EmailAddressNameQueryHookResult = ReturnType<typeof useEmailAddressNameQuery>;
export type EmailAddressNameLazyQueryHookResult = ReturnType<typeof useEmailAddressNameLazyQuery>;
export type EmailAddressNameSuspenseQueryHookResult = ReturnType<typeof useEmailAddressNameSuspenseQuery>;
export type EmailAddressNameQueryResult = Apollo.QueryResult<EmailAddressNameQuery, EmailAddressNameQueryVariables>;
export const EmailAddressNamesDocument = gql`
	query emailAddressNames($filters: [EmailAddressFilterInput!], $pagination: Pagination, $order: EmailAddressOrder) {
		emailAddressConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...EmailAddressName
				}
			}
		}
	}
	${EmailAddressNameFragmentDoc}
`;

/**
 * __useEmailAddressNamesQuery__
 *
 * To run a query within a React component, call `useEmailAddressNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailAddressNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailAddressNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEmailAddressNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<EmailAddressNamesQuery, EmailAddressNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EmailAddressNamesQuery, EmailAddressNamesQueryVariables>(EmailAddressNamesDocument, options);
}
export function useEmailAddressNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EmailAddressNamesQuery, EmailAddressNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EmailAddressNamesQuery, EmailAddressNamesQueryVariables>(
		EmailAddressNamesDocument,
		options,
	);
}
export function useEmailAddressNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<EmailAddressNamesQuery, EmailAddressNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EmailAddressNamesQuery, EmailAddressNamesQueryVariables>(
		EmailAddressNamesDocument,
		options,
	);
}
export type EmailAddressNamesQueryHookResult = ReturnType<typeof useEmailAddressNamesQuery>;
export type EmailAddressNamesLazyQueryHookResult = ReturnType<typeof useEmailAddressNamesLazyQuery>;
export type EmailAddressNamesSuspenseQueryHookResult = ReturnType<typeof useEmailAddressNamesSuspenseQuery>;
export type EmailAddressNamesQueryResult = Apollo.QueryResult<EmailAddressNamesQuery, EmailAddressNamesQueryVariables>;
export const EmailAddressPaginationDocument = gql`
	query emailAddressPagination($filters: [EmailAddressFilterInput!], $order: EmailAddressOrder) {
		emailAddressConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useEmailAddressPaginationQuery__
 *
 * To run a query within a React component, call `useEmailAddressPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailAddressPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailAddressPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEmailAddressPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<EmailAddressPaginationQuery, EmailAddressPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EmailAddressPaginationQuery, EmailAddressPaginationQueryVariables>(
		EmailAddressPaginationDocument,
		options,
	);
}
export function useEmailAddressPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EmailAddressPaginationQuery, EmailAddressPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EmailAddressPaginationQuery, EmailAddressPaginationQueryVariables>(
		EmailAddressPaginationDocument,
		options,
	);
}
export function useEmailAddressPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<EmailAddressPaginationQuery, EmailAddressPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EmailAddressPaginationQuery, EmailAddressPaginationQueryVariables>(
		EmailAddressPaginationDocument,
		options,
	);
}
export type EmailAddressPaginationQueryHookResult = ReturnType<typeof useEmailAddressPaginationQuery>;
export type EmailAddressPaginationLazyQueryHookResult = ReturnType<typeof useEmailAddressPaginationLazyQuery>;
export type EmailAddressPaginationSuspenseQueryHookResult = ReturnType<typeof useEmailAddressPaginationSuspenseQuery>;
export type EmailAddressPaginationQueryResult = Apollo.QueryResult<
	EmailAddressPaginationQuery,
	EmailAddressPaginationQueryVariables
>;
export const EmailAddressSelectDocument = gql`
	query emailAddressSelect($filters: [EmailAddressFilterInput!], $order: EmailAddressOrder) {
		emailAddressConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...EmailAddressName
				}
			}
		}
	}
	${EmailAddressNameFragmentDoc}
`;

/**
 * __useEmailAddressSelectQuery__
 *
 * To run a query within a React component, call `useEmailAddressSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailAddressSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailAddressSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEmailAddressSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<EmailAddressSelectQuery, EmailAddressSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EmailAddressSelectQuery, EmailAddressSelectQueryVariables>(
		EmailAddressSelectDocument,
		options,
	);
}
export function useEmailAddressSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EmailAddressSelectQuery, EmailAddressSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EmailAddressSelectQuery, EmailAddressSelectQueryVariables>(
		EmailAddressSelectDocument,
		options,
	);
}
export function useEmailAddressSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<EmailAddressSelectQuery, EmailAddressSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EmailAddressSelectQuery, EmailAddressSelectQueryVariables>(
		EmailAddressSelectDocument,
		options,
	);
}
export type EmailAddressSelectQueryHookResult = ReturnType<typeof useEmailAddressSelectQuery>;
export type EmailAddressSelectLazyQueryHookResult = ReturnType<typeof useEmailAddressSelectLazyQuery>;
export type EmailAddressSelectSuspenseQueryHookResult = ReturnType<typeof useEmailAddressSelectSuspenseQuery>;
export type EmailAddressSelectQueryResult = Apollo.QueryResult<
	EmailAddressSelectQuery,
	EmailAddressSelectQueryVariables
>;
export const EmailAddressUpdateDocument = gql`
	mutation emailAddressUpdate($id: ID!, $input: EmailAddressUpdateInput!) {
		updateEmailAddress(id: $id, input: $input) {
			...EmailAddressDetail
		}
	}
	${EmailAddressDetailFragmentDoc}
`;
export type EmailAddressUpdateMutationFn = Apollo.MutationFunction<
	EmailAddressUpdateMutation,
	EmailAddressUpdateMutationVariables
>;

/**
 * __useEmailAddressUpdateMutation__
 *
 * To run a mutation, you first call `useEmailAddressUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailAddressUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailAddressUpdateMutation, { data, loading, error }] = useEmailAddressUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmailAddressUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<EmailAddressUpdateMutation, EmailAddressUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<EmailAddressUpdateMutation, EmailAddressUpdateMutationVariables>(
		EmailAddressUpdateDocument,
		options,
	);
}
export type EmailAddressUpdateMutationHookResult = ReturnType<typeof useEmailAddressUpdateMutation>;
export type EmailAddressUpdateMutationResult = Apollo.MutationResult<EmailAddressUpdateMutation>;
export type EmailAddressUpdateMutationOptions = Apollo.BaseMutationOptions<
	EmailAddressUpdateMutation,
	EmailAddressUpdateMutationVariables
>;
export const EmployeeCountDocument = gql`
	query employeeCount($filters: [EmployeeFilterInput!], $pagination: Pagination, $order: EmployeeOrder) {
		employeeConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useEmployeeCountQuery__
 *
 * To run a query within a React component, call `useEmployeeCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEmployeeCountQuery(
	baseOptions?: Apollo.QueryHookOptions<EmployeeCountQuery, EmployeeCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EmployeeCountQuery, EmployeeCountQueryVariables>(EmployeeCountDocument, options);
}
export function useEmployeeCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EmployeeCountQuery, EmployeeCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EmployeeCountQuery, EmployeeCountQueryVariables>(EmployeeCountDocument, options);
}
export function useEmployeeCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeCountQuery, EmployeeCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EmployeeCountQuery, EmployeeCountQueryVariables>(EmployeeCountDocument, options);
}
export type EmployeeCountQueryHookResult = ReturnType<typeof useEmployeeCountQuery>;
export type EmployeeCountLazyQueryHookResult = ReturnType<typeof useEmployeeCountLazyQuery>;
export type EmployeeCountSuspenseQueryHookResult = ReturnType<typeof useEmployeeCountSuspenseQuery>;
export type EmployeeCountQueryResult = Apollo.QueryResult<EmployeeCountQuery, EmployeeCountQueryVariables>;
export const EmployeeCreateDocument = gql`
	mutation employeeCreate($input: EmployeeCreateInput!) {
		createEmployee(input: $input) {
			...EmployeeDetail
		}
	}
	${EmployeeDetailFragmentDoc}
`;
export type EmployeeCreateMutationFn = Apollo.MutationFunction<EmployeeCreateMutation, EmployeeCreateMutationVariables>;

/**
 * __useEmployeeCreateMutation__
 *
 * To run a mutation, you first call `useEmployeeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployeeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employeeCreateMutation, { data, loading, error }] = useEmployeeCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmployeeCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<EmployeeCreateMutation, EmployeeCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<EmployeeCreateMutation, EmployeeCreateMutationVariables>(EmployeeCreateDocument, options);
}
export type EmployeeCreateMutationHookResult = ReturnType<typeof useEmployeeCreateMutation>;
export type EmployeeCreateMutationResult = Apollo.MutationResult<EmployeeCreateMutation>;
export type EmployeeCreateMutationOptions = Apollo.BaseMutationOptions<
	EmployeeCreateMutation,
	EmployeeCreateMutationVariables
>;
export const EmployeeDeleteDocument = gql`
	mutation employeeDelete($id: ID!) {
		deleteEmployee(id: $id)
	}
`;
export type EmployeeDeleteMutationFn = Apollo.MutationFunction<EmployeeDeleteMutation, EmployeeDeleteMutationVariables>;

/**
 * __useEmployeeDeleteMutation__
 *
 * To run a mutation, you first call `useEmployeeDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployeeDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employeeDeleteMutation, { data, loading, error }] = useEmployeeDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<EmployeeDeleteMutation, EmployeeDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<EmployeeDeleteMutation, EmployeeDeleteMutationVariables>(EmployeeDeleteDocument, options);
}
export type EmployeeDeleteMutationHookResult = ReturnType<typeof useEmployeeDeleteMutation>;
export type EmployeeDeleteMutationResult = Apollo.MutationResult<EmployeeDeleteMutation>;
export type EmployeeDeleteMutationOptions = Apollo.BaseMutationOptions<
	EmployeeDeleteMutation,
	EmployeeDeleteMutationVariables
>;
export const EmployeeDetailDocument = gql`
	query employeeDetail($id: ID!) {
		employee(id: $id) {
			...EmployeeDetail
		}
	}
	${EmployeeDetailFragmentDoc}
`;

/**
 * __useEmployeeDetailQuery__
 *
 * To run a query within a React component, call `useEmployeeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeDetailQuery(
	baseOptions: Apollo.QueryHookOptions<EmployeeDetailQuery, EmployeeDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EmployeeDetailQuery, EmployeeDetailQueryVariables>(EmployeeDetailDocument, options);
}
export function useEmployeeDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EmployeeDetailQuery, EmployeeDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EmployeeDetailQuery, EmployeeDetailQueryVariables>(EmployeeDetailDocument, options);
}
export function useEmployeeDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeDetailQuery, EmployeeDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EmployeeDetailQuery, EmployeeDetailQueryVariables>(EmployeeDetailDocument, options);
}
export type EmployeeDetailQueryHookResult = ReturnType<typeof useEmployeeDetailQuery>;
export type EmployeeDetailLazyQueryHookResult = ReturnType<typeof useEmployeeDetailLazyQuery>;
export type EmployeeDetailSuspenseQueryHookResult = ReturnType<typeof useEmployeeDetailSuspenseQuery>;
export type EmployeeDetailQueryResult = Apollo.QueryResult<EmployeeDetailQuery, EmployeeDetailQueryVariables>;
export const EmployeeIndexDocument = gql`
	query employeeIndex($filters: [EmployeeFilterInput!], $pagination: Pagination, $order: EmployeeOrder) {
		employeeConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					workEmailAddress
					jobTitle
					role
					startDate
					endDate
					person {
						id
						...PersonNameAndImage
						gender
						dateOfBirth
						addresses {
							id
							...AddressInformation
						}
						emailAddresses(order: { field: IS_PRIMARY, direction: DESC }) {
							id
							emailAddress
						}
						phoneNumbers(order: { field: IS_PRIMARY, direction: DESC }) {
							id
							phoneNumber
						}
					}
					teacherCourseSectionEnrollments {
						id
						courseSection {
							id
							academicTerm {
								id
								startDate
								endDate
							}
							course {
								id
								classYears {
									id
									...ClassYearName
									yearsFromGraduation
								}
							}
						}
					}
					teacherHomeRoomSectionEnrollments {
						id
						homeRoomSection {
							id
							namePrefix
							nameSuffix
							homeRoom {
								id
								...HomeRoomName
								classYear {
									id
									yearsFromGraduation
								}
							}
							academicTerm {
								id
								startDate
								endDate
							}
						}
					}
				}
			}
		}
	}
	${PersonNameAndImageFragmentDoc}
	${AddressInformationFragmentDoc}
	${ClassYearNameFragmentDoc}
	${HomeRoomNameFragmentDoc}
`;

/**
 * __useEmployeeIndexQuery__
 *
 * To run a query within a React component, call `useEmployeeIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEmployeeIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<EmployeeIndexQuery, EmployeeIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EmployeeIndexQuery, EmployeeIndexQueryVariables>(EmployeeIndexDocument, options);
}
export function useEmployeeIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EmployeeIndexQuery, EmployeeIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EmployeeIndexQuery, EmployeeIndexQueryVariables>(EmployeeIndexDocument, options);
}
export function useEmployeeIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeIndexQuery, EmployeeIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EmployeeIndexQuery, EmployeeIndexQueryVariables>(EmployeeIndexDocument, options);
}
export type EmployeeIndexQueryHookResult = ReturnType<typeof useEmployeeIndexQuery>;
export type EmployeeIndexLazyQueryHookResult = ReturnType<typeof useEmployeeIndexLazyQuery>;
export type EmployeeIndexSuspenseQueryHookResult = ReturnType<typeof useEmployeeIndexSuspenseQuery>;
export type EmployeeIndexQueryResult = Apollo.QueryResult<EmployeeIndexQuery, EmployeeIndexQueryVariables>;
export const EmployeeNameDocument = gql`
	query employeeName($id: ID!) {
		employee(id: $id) {
			id
			...EmployeeName
		}
	}
	${EmployeeNameFragmentDoc}
`;

/**
 * __useEmployeeNameQuery__
 *
 * To run a query within a React component, call `useEmployeeNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeNameQuery(
	baseOptions: Apollo.QueryHookOptions<EmployeeNameQuery, EmployeeNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EmployeeNameQuery, EmployeeNameQueryVariables>(EmployeeNameDocument, options);
}
export function useEmployeeNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EmployeeNameQuery, EmployeeNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EmployeeNameQuery, EmployeeNameQueryVariables>(EmployeeNameDocument, options);
}
export function useEmployeeNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeNameQuery, EmployeeNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EmployeeNameQuery, EmployeeNameQueryVariables>(EmployeeNameDocument, options);
}
export type EmployeeNameQueryHookResult = ReturnType<typeof useEmployeeNameQuery>;
export type EmployeeNameLazyQueryHookResult = ReturnType<typeof useEmployeeNameLazyQuery>;
export type EmployeeNameSuspenseQueryHookResult = ReturnType<typeof useEmployeeNameSuspenseQuery>;
export type EmployeeNameQueryResult = Apollo.QueryResult<EmployeeNameQuery, EmployeeNameQueryVariables>;
export const EmployeeNamesDocument = gql`
	query employeeNames($filters: [EmployeeFilterInput!], $pagination: Pagination, $order: EmployeeOrder) {
		employeeConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...EmployeeName
				}
			}
		}
	}
	${EmployeeNameFragmentDoc}
`;

/**
 * __useEmployeeNamesQuery__
 *
 * To run a query within a React component, call `useEmployeeNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEmployeeNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<EmployeeNamesQuery, EmployeeNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EmployeeNamesQuery, EmployeeNamesQueryVariables>(EmployeeNamesDocument, options);
}
export function useEmployeeNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EmployeeNamesQuery, EmployeeNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EmployeeNamesQuery, EmployeeNamesQueryVariables>(EmployeeNamesDocument, options);
}
export function useEmployeeNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeNamesQuery, EmployeeNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EmployeeNamesQuery, EmployeeNamesQueryVariables>(EmployeeNamesDocument, options);
}
export type EmployeeNamesQueryHookResult = ReturnType<typeof useEmployeeNamesQuery>;
export type EmployeeNamesLazyQueryHookResult = ReturnType<typeof useEmployeeNamesLazyQuery>;
export type EmployeeNamesSuspenseQueryHookResult = ReturnType<typeof useEmployeeNamesSuspenseQuery>;
export type EmployeeNamesQueryResult = Apollo.QueryResult<EmployeeNamesQuery, EmployeeNamesQueryVariables>;
export const EmployeePaginationDocument = gql`
	query employeePagination($filters: [EmployeeFilterInput!], $order: EmployeeOrder) {
		employeeConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useEmployeePaginationQuery__
 *
 * To run a query within a React component, call `useEmployeePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEmployeePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<EmployeePaginationQuery, EmployeePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EmployeePaginationQuery, EmployeePaginationQueryVariables>(
		EmployeePaginationDocument,
		options,
	);
}
export function useEmployeePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EmployeePaginationQuery, EmployeePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EmployeePaginationQuery, EmployeePaginationQueryVariables>(
		EmployeePaginationDocument,
		options,
	);
}
export function useEmployeePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeePaginationQuery, EmployeePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EmployeePaginationQuery, EmployeePaginationQueryVariables>(
		EmployeePaginationDocument,
		options,
	);
}
export type EmployeePaginationQueryHookResult = ReturnType<typeof useEmployeePaginationQuery>;
export type EmployeePaginationLazyQueryHookResult = ReturnType<typeof useEmployeePaginationLazyQuery>;
export type EmployeePaginationSuspenseQueryHookResult = ReturnType<typeof useEmployeePaginationSuspenseQuery>;
export type EmployeePaginationQueryResult = Apollo.QueryResult<
	EmployeePaginationQuery,
	EmployeePaginationQueryVariables
>;
export const EmployeeSelectDocument = gql`
	query employeeSelect($filters: [EmployeeFilterInput!], $order: EmployeeOrder) {
		employeeConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...EmployeeName
				}
			}
		}
	}
	${EmployeeNameFragmentDoc}
`;

/**
 * __useEmployeeSelectQuery__
 *
 * To run a query within a React component, call `useEmployeeSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEmployeeSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<EmployeeSelectQuery, EmployeeSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EmployeeSelectQuery, EmployeeSelectQueryVariables>(EmployeeSelectDocument, options);
}
export function useEmployeeSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EmployeeSelectQuery, EmployeeSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EmployeeSelectQuery, EmployeeSelectQueryVariables>(EmployeeSelectDocument, options);
}
export function useEmployeeSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeSelectQuery, EmployeeSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EmployeeSelectQuery, EmployeeSelectQueryVariables>(EmployeeSelectDocument, options);
}
export type EmployeeSelectQueryHookResult = ReturnType<typeof useEmployeeSelectQuery>;
export type EmployeeSelectLazyQueryHookResult = ReturnType<typeof useEmployeeSelectLazyQuery>;
export type EmployeeSelectSuspenseQueryHookResult = ReturnType<typeof useEmployeeSelectSuspenseQuery>;
export type EmployeeSelectQueryResult = Apollo.QueryResult<EmployeeSelectQuery, EmployeeSelectQueryVariables>;
export const EmployeeNamesAndImagesDocument = gql`
	query employeeNamesAndImages($filters: [EmployeeFilterInput!], $pagination: Pagination, $order: EmployeeOrder) {
		employeeConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
			edges {
				node {
					id
					...EmployeeNameAndImage
				}
			}
		}
	}
	${EmployeeNameAndImageFragmentDoc}
`;

/**
 * __useEmployeeNamesAndImagesQuery__
 *
 * To run a query within a React component, call `useEmployeeNamesAndImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeNamesAndImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeNamesAndImagesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEmployeeNamesAndImagesQuery(
	baseOptions?: Apollo.QueryHookOptions<EmployeeNamesAndImagesQuery, EmployeeNamesAndImagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EmployeeNamesAndImagesQuery, EmployeeNamesAndImagesQueryVariables>(
		EmployeeNamesAndImagesDocument,
		options,
	);
}
export function useEmployeeNamesAndImagesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EmployeeNamesAndImagesQuery, EmployeeNamesAndImagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EmployeeNamesAndImagesQuery, EmployeeNamesAndImagesQueryVariables>(
		EmployeeNamesAndImagesDocument,
		options,
	);
}
export function useEmployeeNamesAndImagesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeNamesAndImagesQuery, EmployeeNamesAndImagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EmployeeNamesAndImagesQuery, EmployeeNamesAndImagesQueryVariables>(
		EmployeeNamesAndImagesDocument,
		options,
	);
}
export type EmployeeNamesAndImagesQueryHookResult = ReturnType<typeof useEmployeeNamesAndImagesQuery>;
export type EmployeeNamesAndImagesLazyQueryHookResult = ReturnType<typeof useEmployeeNamesAndImagesLazyQuery>;
export type EmployeeNamesAndImagesSuspenseQueryHookResult = ReturnType<typeof useEmployeeNamesAndImagesSuspenseQuery>;
export type EmployeeNamesAndImagesQueryResult = Apollo.QueryResult<
	EmployeeNamesAndImagesQuery,
	EmployeeNamesAndImagesQueryVariables
>;
export const EmployeeNamesDescriptionsAndImagesDocument = gql`
	query employeeNamesDescriptionsAndImages(
		$filters: [EmployeeFilterInput!]
		$pagination: Pagination
		$order: EmployeeOrder
	) {
		employeeConnection(filters: $filters, pagination: $pagination, order: $order) {
			pageInfo {
				hasNextPage
				endCursor
			}
			edges {
				node {
					id
					...EmployeeNameDescriptionAndImage
				}
			}
		}
	}
	${EmployeeNameDescriptionAndImageFragmentDoc}
`;

/**
 * __useEmployeeNamesDescriptionsAndImagesQuery__
 *
 * To run a query within a React component, call `useEmployeeNamesDescriptionsAndImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeNamesDescriptionsAndImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeNamesDescriptionsAndImagesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEmployeeNamesDescriptionsAndImagesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EmployeeNamesDescriptionsAndImagesQuery,
		EmployeeNamesDescriptionsAndImagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EmployeeNamesDescriptionsAndImagesQuery, EmployeeNamesDescriptionsAndImagesQueryVariables>(
		EmployeeNamesDescriptionsAndImagesDocument,
		options,
	);
}
export function useEmployeeNamesDescriptionsAndImagesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EmployeeNamesDescriptionsAndImagesQuery,
		EmployeeNamesDescriptionsAndImagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EmployeeNamesDescriptionsAndImagesQuery, EmployeeNamesDescriptionsAndImagesQueryVariables>(
		EmployeeNamesDescriptionsAndImagesDocument,
		options,
	);
}
export function useEmployeeNamesDescriptionsAndImagesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EmployeeNamesDescriptionsAndImagesQuery,
		EmployeeNamesDescriptionsAndImagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EmployeeNamesDescriptionsAndImagesQuery,
		EmployeeNamesDescriptionsAndImagesQueryVariables
	>(EmployeeNamesDescriptionsAndImagesDocument, options);
}
export type EmployeeNamesDescriptionsAndImagesQueryHookResult = ReturnType<
	typeof useEmployeeNamesDescriptionsAndImagesQuery
>;
export type EmployeeNamesDescriptionsAndImagesLazyQueryHookResult = ReturnType<
	typeof useEmployeeNamesDescriptionsAndImagesLazyQuery
>;
export type EmployeeNamesDescriptionsAndImagesSuspenseQueryHookResult = ReturnType<
	typeof useEmployeeNamesDescriptionsAndImagesSuspenseQuery
>;
export type EmployeeNamesDescriptionsAndImagesQueryResult = Apollo.QueryResult<
	EmployeeNamesDescriptionsAndImagesQuery,
	EmployeeNamesDescriptionsAndImagesQueryVariables
>;
export const EmployeeNameImageAndUserDocument = gql`
	query employeeNameImageAndUser($id: ID!) {
		employee(id: $id) {
			id
			person {
				id
				...PersonNameAndImage
				user {
					id
					status
				}
			}
		}
	}
	${PersonNameAndImageFragmentDoc}
`;

/**
 * __useEmployeeNameImageAndUserQuery__
 *
 * To run a query within a React component, call `useEmployeeNameImageAndUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeNameImageAndUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeNameImageAndUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeNameImageAndUserQuery(
	baseOptions: Apollo.QueryHookOptions<EmployeeNameImageAndUserQuery, EmployeeNameImageAndUserQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EmployeeNameImageAndUserQuery, EmployeeNameImageAndUserQueryVariables>(
		EmployeeNameImageAndUserDocument,
		options,
	);
}
export function useEmployeeNameImageAndUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EmployeeNameImageAndUserQuery, EmployeeNameImageAndUserQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EmployeeNameImageAndUserQuery, EmployeeNameImageAndUserQueryVariables>(
		EmployeeNameImageAndUserDocument,
		options,
	);
}
export function useEmployeeNameImageAndUserSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeNameImageAndUserQuery, EmployeeNameImageAndUserQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EmployeeNameImageAndUserQuery, EmployeeNameImageAndUserQueryVariables>(
		EmployeeNameImageAndUserDocument,
		options,
	);
}
export type EmployeeNameImageAndUserQueryHookResult = ReturnType<typeof useEmployeeNameImageAndUserQuery>;
export type EmployeeNameImageAndUserLazyQueryHookResult = ReturnType<typeof useEmployeeNameImageAndUserLazyQuery>;
export type EmployeeNameImageAndUserSuspenseQueryHookResult = ReturnType<
	typeof useEmployeeNameImageAndUserSuspenseQuery
>;
export type EmployeeNameImageAndUserQueryResult = Apollo.QueryResult<
	EmployeeNameImageAndUserQuery,
	EmployeeNameImageAndUserQueryVariables
>;
export const EmployeeTooltipDocument = gql`
	query employeeTooltip($id: ID!, $date: Date!) {
		employee(id: $id) {
			id
			...EmployeeNameAndImage
			jobTitle
			teacherHomeRoomSectionEnrollments(
				filters: { homeRoomSection: { academicTerm: { startDateLTE: $date, endDateGTE: $date } } }
			) {
				id
				homeRoomSection {
					id
					...HomeRoomSectionName
				}
			}
			teacherCourseSectionEnrollments(
				filters: { courseSection: { academicTerm: { startDateLTE: $date, endDateGTE: $date } } }
			) {
				id
				courseSection {
					id
					...CourseSectionName
				}
			}
		}
	}
	${EmployeeNameAndImageFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${CourseSectionNameFragmentDoc}
`;

/**
 * __useEmployeeTooltipQuery__
 *
 * To run a query within a React component, call `useEmployeeTooltipQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeTooltipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeTooltipQuery({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useEmployeeTooltipQuery(
	baseOptions: Apollo.QueryHookOptions<EmployeeTooltipQuery, EmployeeTooltipQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EmployeeTooltipQuery, EmployeeTooltipQueryVariables>(EmployeeTooltipDocument, options);
}
export function useEmployeeTooltipLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EmployeeTooltipQuery, EmployeeTooltipQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EmployeeTooltipQuery, EmployeeTooltipQueryVariables>(EmployeeTooltipDocument, options);
}
export function useEmployeeTooltipSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeTooltipQuery, EmployeeTooltipQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EmployeeTooltipQuery, EmployeeTooltipQueryVariables>(EmployeeTooltipDocument, options);
}
export type EmployeeTooltipQueryHookResult = ReturnType<typeof useEmployeeTooltipQuery>;
export type EmployeeTooltipLazyQueryHookResult = ReturnType<typeof useEmployeeTooltipLazyQuery>;
export type EmployeeTooltipSuspenseQueryHookResult = ReturnType<typeof useEmployeeTooltipSuspenseQuery>;
export type EmployeeTooltipQueryResult = Apollo.QueryResult<EmployeeTooltipQuery, EmployeeTooltipQueryVariables>;
export const EmployeeUpdateDocument = gql`
	mutation employeeUpdate($id: ID!, $input: EmployeeUpdateInput!) {
		updateEmployee(id: $id, input: $input) {
			...EmployeeDetail
		}
	}
	${EmployeeDetailFragmentDoc}
`;
export type EmployeeUpdateMutationFn = Apollo.MutationFunction<EmployeeUpdateMutation, EmployeeUpdateMutationVariables>;

/**
 * __useEmployeeUpdateMutation__
 *
 * To run a mutation, you first call `useEmployeeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployeeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employeeUpdateMutation, { data, loading, error }] = useEmployeeUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmployeeUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<EmployeeUpdateMutation, EmployeeUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<EmployeeUpdateMutation, EmployeeUpdateMutationVariables>(EmployeeUpdateDocument, options);
}
export type EmployeeUpdateMutationHookResult = ReturnType<typeof useEmployeeUpdateMutation>;
export type EmployeeUpdateMutationResult = Apollo.MutationResult<EmployeeUpdateMutation>;
export type EmployeeUpdateMutationOptions = Apollo.BaseMutationOptions<
	EmployeeUpdateMutation,
	EmployeeUpdateMutationVariables
>;
export const EnrollmentApplicationCountDocument = gql`
	query enrollmentApplicationCount(
		$filters: [EnrollmentApplicationFilterInput!]
		$pagination: Pagination
		$order: EnrollmentApplicationOrder
	) {
		enrollmentApplicationConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useEnrollmentApplicationCountQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationCountQuery(
	baseOptions?: Apollo.QueryHookOptions<EnrollmentApplicationCountQuery, EnrollmentApplicationCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationCountQuery, EnrollmentApplicationCountQueryVariables>(
		EnrollmentApplicationCountDocument,
		options,
	);
}
export function useEnrollmentApplicationCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EnrollmentApplicationCountQuery, EnrollmentApplicationCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EnrollmentApplicationCountQuery, EnrollmentApplicationCountQueryVariables>(
		EnrollmentApplicationCountDocument,
		options,
	);
}
export function useEnrollmentApplicationCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationCountQuery,
		EnrollmentApplicationCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EnrollmentApplicationCountQuery, EnrollmentApplicationCountQueryVariables>(
		EnrollmentApplicationCountDocument,
		options,
	);
}
export type EnrollmentApplicationCountQueryHookResult = ReturnType<typeof useEnrollmentApplicationCountQuery>;
export type EnrollmentApplicationCountLazyQueryHookResult = ReturnType<typeof useEnrollmentApplicationCountLazyQuery>;
export type EnrollmentApplicationCountSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationCountSuspenseQuery
>;
export type EnrollmentApplicationCountQueryResult = Apollo.QueryResult<
	EnrollmentApplicationCountQuery,
	EnrollmentApplicationCountQueryVariables
>;
export const EnrollmentApplicationCreateDocument = gql`
	mutation enrollmentApplicationCreate($input: EnrollmentApplicationCreateInput!) {
		createEnrollmentApplication(input: $input) {
			...EnrollmentApplicationDetail
		}
	}
	${EnrollmentApplicationDetailFragmentDoc}
`;
export type EnrollmentApplicationCreateMutationFn = Apollo.MutationFunction<
	EnrollmentApplicationCreateMutation,
	EnrollmentApplicationCreateMutationVariables
>;

/**
 * __useEnrollmentApplicationCreateMutation__
 *
 * To run a mutation, you first call `useEnrollmentApplicationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollmentApplicationCreateMutation, { data, loading, error }] = useEnrollmentApplicationCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnrollmentApplicationCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		EnrollmentApplicationCreateMutation,
		EnrollmentApplicationCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<EnrollmentApplicationCreateMutation, EnrollmentApplicationCreateMutationVariables>(
		EnrollmentApplicationCreateDocument,
		options,
	);
}
export type EnrollmentApplicationCreateMutationHookResult = ReturnType<typeof useEnrollmentApplicationCreateMutation>;
export type EnrollmentApplicationCreateMutationResult = Apollo.MutationResult<EnrollmentApplicationCreateMutation>;
export type EnrollmentApplicationCreateMutationOptions = Apollo.BaseMutationOptions<
	EnrollmentApplicationCreateMutation,
	EnrollmentApplicationCreateMutationVariables
>;
export const EnrollmentApplicationDeleteDocument = gql`
	mutation enrollmentApplicationDelete($id: ID!) {
		deleteEnrollmentApplication(id: $id)
	}
`;
export type EnrollmentApplicationDeleteMutationFn = Apollo.MutationFunction<
	EnrollmentApplicationDeleteMutation,
	EnrollmentApplicationDeleteMutationVariables
>;

/**
 * __useEnrollmentApplicationDeleteMutation__
 *
 * To run a mutation, you first call `useEnrollmentApplicationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollmentApplicationDeleteMutation, { data, loading, error }] = useEnrollmentApplicationDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnrollmentApplicationDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		EnrollmentApplicationDeleteMutation,
		EnrollmentApplicationDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<EnrollmentApplicationDeleteMutation, EnrollmentApplicationDeleteMutationVariables>(
		EnrollmentApplicationDeleteDocument,
		options,
	);
}
export type EnrollmentApplicationDeleteMutationHookResult = ReturnType<typeof useEnrollmentApplicationDeleteMutation>;
export type EnrollmentApplicationDeleteMutationResult = Apollo.MutationResult<EnrollmentApplicationDeleteMutation>;
export type EnrollmentApplicationDeleteMutationOptions = Apollo.BaseMutationOptions<
	EnrollmentApplicationDeleteMutation,
	EnrollmentApplicationDeleteMutationVariables
>;
export const EnrollmentApplicationDetailDocument = gql`
	query enrollmentApplicationDetail($id: ID!) {
		enrollmentApplication(id: $id) {
			...EnrollmentApplicationDetail
		}
	}
	${EnrollmentApplicationDetailFragmentDoc}
`;

/**
 * __useEnrollmentApplicationDetailQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnrollmentApplicationDetailQuery(
	baseOptions: Apollo.QueryHookOptions<EnrollmentApplicationDetailQuery, EnrollmentApplicationDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationDetailQuery, EnrollmentApplicationDetailQueryVariables>(
		EnrollmentApplicationDetailDocument,
		options,
	);
}
export function useEnrollmentApplicationDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationDetailQuery,
		EnrollmentApplicationDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EnrollmentApplicationDetailQuery, EnrollmentApplicationDetailQueryVariables>(
		EnrollmentApplicationDetailDocument,
		options,
	);
}
export function useEnrollmentApplicationDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationDetailQuery,
		EnrollmentApplicationDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EnrollmentApplicationDetailQuery, EnrollmentApplicationDetailQueryVariables>(
		EnrollmentApplicationDetailDocument,
		options,
	);
}
export type EnrollmentApplicationDetailQueryHookResult = ReturnType<typeof useEnrollmentApplicationDetailQuery>;
export type EnrollmentApplicationDetailLazyQueryHookResult = ReturnType<typeof useEnrollmentApplicationDetailLazyQuery>;
export type EnrollmentApplicationDetailSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationDetailSuspenseQuery
>;
export type EnrollmentApplicationDetailQueryResult = Apollo.QueryResult<
	EnrollmentApplicationDetailQuery,
	EnrollmentApplicationDetailQueryVariables
>;
export const EnrollmentApplicationIndexDocument = gql`
	query enrollmentApplicationIndex(
		$filters: [EnrollmentApplicationFilterInput!]
		$pagination: Pagination
		$order: EnrollmentApplicationOrder
	) {
		enrollmentApplicationConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					wasInquirySubmitted
					inquirySubmittedAt
					wasApplicationSubmitted
					applicationSubmittedAt
					source
					sourceDetails
					doesConsentToCorrespondence
					doesConsentToDataUse
					doesConsentToDataProtectionPolicy
					notes
					signatureName
					signatureDate
				}
			}
		}
	}
`;

/**
 * __useEnrollmentApplicationIndexQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<EnrollmentApplicationIndexQuery, EnrollmentApplicationIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationIndexQuery, EnrollmentApplicationIndexQueryVariables>(
		EnrollmentApplicationIndexDocument,
		options,
	);
}
export function useEnrollmentApplicationIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EnrollmentApplicationIndexQuery, EnrollmentApplicationIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EnrollmentApplicationIndexQuery, EnrollmentApplicationIndexQueryVariables>(
		EnrollmentApplicationIndexDocument,
		options,
	);
}
export function useEnrollmentApplicationIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationIndexQuery,
		EnrollmentApplicationIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EnrollmentApplicationIndexQuery, EnrollmentApplicationIndexQueryVariables>(
		EnrollmentApplicationIndexDocument,
		options,
	);
}
export type EnrollmentApplicationIndexQueryHookResult = ReturnType<typeof useEnrollmentApplicationIndexQuery>;
export type EnrollmentApplicationIndexLazyQueryHookResult = ReturnType<typeof useEnrollmentApplicationIndexLazyQuery>;
export type EnrollmentApplicationIndexSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationIndexSuspenseQuery
>;
export type EnrollmentApplicationIndexQueryResult = Apollo.QueryResult<
	EnrollmentApplicationIndexQuery,
	EnrollmentApplicationIndexQueryVariables
>;
export const EnrollmentApplicationNameDocument = gql`
	query enrollmentApplicationName($id: ID!) {
		enrollmentApplication(id: $id) {
			id
			...EnrollmentApplicationName
		}
	}
	${EnrollmentApplicationNameFragmentDoc}
`;

/**
 * __useEnrollmentApplicationNameQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnrollmentApplicationNameQuery(
	baseOptions: Apollo.QueryHookOptions<EnrollmentApplicationNameQuery, EnrollmentApplicationNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationNameQuery, EnrollmentApplicationNameQueryVariables>(
		EnrollmentApplicationNameDocument,
		options,
	);
}
export function useEnrollmentApplicationNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EnrollmentApplicationNameQuery, EnrollmentApplicationNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EnrollmentApplicationNameQuery, EnrollmentApplicationNameQueryVariables>(
		EnrollmentApplicationNameDocument,
		options,
	);
}
export function useEnrollmentApplicationNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationNameQuery,
		EnrollmentApplicationNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EnrollmentApplicationNameQuery, EnrollmentApplicationNameQueryVariables>(
		EnrollmentApplicationNameDocument,
		options,
	);
}
export type EnrollmentApplicationNameQueryHookResult = ReturnType<typeof useEnrollmentApplicationNameQuery>;
export type EnrollmentApplicationNameLazyQueryHookResult = ReturnType<typeof useEnrollmentApplicationNameLazyQuery>;
export type EnrollmentApplicationNameSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationNameSuspenseQuery
>;
export type EnrollmentApplicationNameQueryResult = Apollo.QueryResult<
	EnrollmentApplicationNameQuery,
	EnrollmentApplicationNameQueryVariables
>;
export const EnrollmentApplicationNamesDocument = gql`
	query enrollmentApplicationNames(
		$filters: [EnrollmentApplicationFilterInput!]
		$pagination: Pagination
		$order: EnrollmentApplicationOrder
	) {
		enrollmentApplicationConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...EnrollmentApplicationName
				}
			}
		}
	}
	${EnrollmentApplicationNameFragmentDoc}
`;

/**
 * __useEnrollmentApplicationNamesQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<EnrollmentApplicationNamesQuery, EnrollmentApplicationNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationNamesQuery, EnrollmentApplicationNamesQueryVariables>(
		EnrollmentApplicationNamesDocument,
		options,
	);
}
export function useEnrollmentApplicationNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<EnrollmentApplicationNamesQuery, EnrollmentApplicationNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EnrollmentApplicationNamesQuery, EnrollmentApplicationNamesQueryVariables>(
		EnrollmentApplicationNamesDocument,
		options,
	);
}
export function useEnrollmentApplicationNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationNamesQuery,
		EnrollmentApplicationNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EnrollmentApplicationNamesQuery, EnrollmentApplicationNamesQueryVariables>(
		EnrollmentApplicationNamesDocument,
		options,
	);
}
export type EnrollmentApplicationNamesQueryHookResult = ReturnType<typeof useEnrollmentApplicationNamesQuery>;
export type EnrollmentApplicationNamesLazyQueryHookResult = ReturnType<typeof useEnrollmentApplicationNamesLazyQuery>;
export type EnrollmentApplicationNamesSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationNamesSuspenseQuery
>;
export type EnrollmentApplicationNamesQueryResult = Apollo.QueryResult<
	EnrollmentApplicationNamesQuery,
	EnrollmentApplicationNamesQueryVariables
>;
export const EnrollmentApplicationPaginationDocument = gql`
	query enrollmentApplicationPagination(
		$filters: [EnrollmentApplicationFilterInput!]
		$order: EnrollmentApplicationOrder
	) {
		enrollmentApplicationConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useEnrollmentApplicationPaginationQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationPaginationQuery,
		EnrollmentApplicationPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationPaginationQuery, EnrollmentApplicationPaginationQueryVariables>(
		EnrollmentApplicationPaginationDocument,
		options,
	);
}
export function useEnrollmentApplicationPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationPaginationQuery,
		EnrollmentApplicationPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EnrollmentApplicationPaginationQuery, EnrollmentApplicationPaginationQueryVariables>(
		EnrollmentApplicationPaginationDocument,
		options,
	);
}
export function useEnrollmentApplicationPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationPaginationQuery,
		EnrollmentApplicationPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EnrollmentApplicationPaginationQuery, EnrollmentApplicationPaginationQueryVariables>(
		EnrollmentApplicationPaginationDocument,
		options,
	);
}
export type EnrollmentApplicationPaginationQueryHookResult = ReturnType<typeof useEnrollmentApplicationPaginationQuery>;
export type EnrollmentApplicationPaginationLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationPaginationLazyQuery
>;
export type EnrollmentApplicationPaginationSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationPaginationSuspenseQuery
>;
export type EnrollmentApplicationPaginationQueryResult = Apollo.QueryResult<
	EnrollmentApplicationPaginationQuery,
	EnrollmentApplicationPaginationQueryVariables
>;
export const EnrollmentApplicationSelectDocument = gql`
	query enrollmentApplicationSelect($filters: [EnrollmentApplicationFilterInput!], $order: EnrollmentApplicationOrder) {
		enrollmentApplicationConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...EnrollmentApplicationName
				}
			}
		}
	}
	${EnrollmentApplicationNameFragmentDoc}
`;

/**
 * __useEnrollmentApplicationSelectQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<EnrollmentApplicationSelectQuery, EnrollmentApplicationSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationSelectQuery, EnrollmentApplicationSelectQueryVariables>(
		EnrollmentApplicationSelectDocument,
		options,
	);
}
export function useEnrollmentApplicationSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationSelectQuery,
		EnrollmentApplicationSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EnrollmentApplicationSelectQuery, EnrollmentApplicationSelectQueryVariables>(
		EnrollmentApplicationSelectDocument,
		options,
	);
}
export function useEnrollmentApplicationSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationSelectQuery,
		EnrollmentApplicationSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EnrollmentApplicationSelectQuery, EnrollmentApplicationSelectQueryVariables>(
		EnrollmentApplicationSelectDocument,
		options,
	);
}
export type EnrollmentApplicationSelectQueryHookResult = ReturnType<typeof useEnrollmentApplicationSelectQuery>;
export type EnrollmentApplicationSelectLazyQueryHookResult = ReturnType<typeof useEnrollmentApplicationSelectLazyQuery>;
export type EnrollmentApplicationSelectSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationSelectSuspenseQuery
>;
export type EnrollmentApplicationSelectQueryResult = Apollo.QueryResult<
	EnrollmentApplicationSelectQuery,
	EnrollmentApplicationSelectQueryVariables
>;
export const SubmitEnrollmentApplicationDocument = gql`
	mutation submitEnrollmentApplication($id: ID!) {
		submitEnrollmentApplication(id: $id) {
			...EnrollmentApplicationDetail
		}
	}
	${EnrollmentApplicationDetailFragmentDoc}
`;
export type SubmitEnrollmentApplicationMutationFn = Apollo.MutationFunction<
	SubmitEnrollmentApplicationMutation,
	SubmitEnrollmentApplicationMutationVariables
>;

/**
 * __useSubmitEnrollmentApplicationMutation__
 *
 * To run a mutation, you first call `useSubmitEnrollmentApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitEnrollmentApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitEnrollmentApplicationMutation, { data, loading, error }] = useSubmitEnrollmentApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitEnrollmentApplicationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SubmitEnrollmentApplicationMutation,
		SubmitEnrollmentApplicationMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SubmitEnrollmentApplicationMutation, SubmitEnrollmentApplicationMutationVariables>(
		SubmitEnrollmentApplicationDocument,
		options,
	);
}
export type SubmitEnrollmentApplicationMutationHookResult = ReturnType<typeof useSubmitEnrollmentApplicationMutation>;
export type SubmitEnrollmentApplicationMutationResult = Apollo.MutationResult<SubmitEnrollmentApplicationMutation>;
export type SubmitEnrollmentApplicationMutationOptions = Apollo.BaseMutationOptions<
	SubmitEnrollmentApplicationMutation,
	SubmitEnrollmentApplicationMutationVariables
>;
export const EnrollmentApplicationUpdateDocument = gql`
	mutation enrollmentApplicationUpdate($id: ID!, $input: EnrollmentApplicationUpdateInput!) {
		updateEnrollmentApplication(id: $id, input: $input) {
			...EnrollmentApplicationDetail
		}
	}
	${EnrollmentApplicationDetailFragmentDoc}
`;
export type EnrollmentApplicationUpdateMutationFn = Apollo.MutationFunction<
	EnrollmentApplicationUpdateMutation,
	EnrollmentApplicationUpdateMutationVariables
>;

/**
 * __useEnrollmentApplicationUpdateMutation__
 *
 * To run a mutation, you first call `useEnrollmentApplicationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollmentApplicationUpdateMutation, { data, loading, error }] = useEnrollmentApplicationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnrollmentApplicationUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		EnrollmentApplicationUpdateMutation,
		EnrollmentApplicationUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<EnrollmentApplicationUpdateMutation, EnrollmentApplicationUpdateMutationVariables>(
		EnrollmentApplicationUpdateDocument,
		options,
	);
}
export type EnrollmentApplicationUpdateMutationHookResult = ReturnType<typeof useEnrollmentApplicationUpdateMutation>;
export type EnrollmentApplicationUpdateMutationResult = Apollo.MutationResult<EnrollmentApplicationUpdateMutation>;
export type EnrollmentApplicationUpdateMutationOptions = Apollo.BaseMutationOptions<
	EnrollmentApplicationUpdateMutation,
	EnrollmentApplicationUpdateMutationVariables
>;
export const EnrollmentApplicationGuardianCountDocument = gql`
	query enrollmentApplicationGuardianCount(
		$filters: [EnrollmentApplicationGuardianFilterInput!]
		$pagination: Pagination
		$order: EnrollmentApplicationGuardianOrder
	) {
		enrollmentApplicationGuardianConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useEnrollmentApplicationGuardianCountQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationGuardianCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationGuardianCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationGuardianCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationGuardianCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationGuardianCountQuery,
		EnrollmentApplicationGuardianCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationGuardianCountQuery, EnrollmentApplicationGuardianCountQueryVariables>(
		EnrollmentApplicationGuardianCountDocument,
		options,
	);
}
export function useEnrollmentApplicationGuardianCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationGuardianCountQuery,
		EnrollmentApplicationGuardianCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EnrollmentApplicationGuardianCountQuery, EnrollmentApplicationGuardianCountQueryVariables>(
		EnrollmentApplicationGuardianCountDocument,
		options,
	);
}
export function useEnrollmentApplicationGuardianCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationGuardianCountQuery,
		EnrollmentApplicationGuardianCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationGuardianCountQuery,
		EnrollmentApplicationGuardianCountQueryVariables
	>(EnrollmentApplicationGuardianCountDocument, options);
}
export type EnrollmentApplicationGuardianCountQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianCountQuery
>;
export type EnrollmentApplicationGuardianCountLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianCountLazyQuery
>;
export type EnrollmentApplicationGuardianCountSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianCountSuspenseQuery
>;
export type EnrollmentApplicationGuardianCountQueryResult = Apollo.QueryResult<
	EnrollmentApplicationGuardianCountQuery,
	EnrollmentApplicationGuardianCountQueryVariables
>;
export const EnrollmentApplicationGuardianCreateDocument = gql`
	mutation enrollmentApplicationGuardianCreate($input: EnrollmentApplicationGuardianCreateInput!) {
		createEnrollmentApplicationGuardian(input: $input) {
			...EnrollmentApplicationGuardianDetail
		}
	}
	${EnrollmentApplicationGuardianDetailFragmentDoc}
`;
export type EnrollmentApplicationGuardianCreateMutationFn = Apollo.MutationFunction<
	EnrollmentApplicationGuardianCreateMutation,
	EnrollmentApplicationGuardianCreateMutationVariables
>;

/**
 * __useEnrollmentApplicationGuardianCreateMutation__
 *
 * To run a mutation, you first call `useEnrollmentApplicationGuardianCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationGuardianCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollmentApplicationGuardianCreateMutation, { data, loading, error }] = useEnrollmentApplicationGuardianCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnrollmentApplicationGuardianCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		EnrollmentApplicationGuardianCreateMutation,
		EnrollmentApplicationGuardianCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		EnrollmentApplicationGuardianCreateMutation,
		EnrollmentApplicationGuardianCreateMutationVariables
	>(EnrollmentApplicationGuardianCreateDocument, options);
}
export type EnrollmentApplicationGuardianCreateMutationHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianCreateMutation
>;
export type EnrollmentApplicationGuardianCreateMutationResult =
	Apollo.MutationResult<EnrollmentApplicationGuardianCreateMutation>;
export type EnrollmentApplicationGuardianCreateMutationOptions = Apollo.BaseMutationOptions<
	EnrollmentApplicationGuardianCreateMutation,
	EnrollmentApplicationGuardianCreateMutationVariables
>;
export const EnrollmentApplicationGuardianDeleteDocument = gql`
	mutation enrollmentApplicationGuardianDelete($id: ID!) {
		deleteEnrollmentApplicationGuardian(id: $id)
	}
`;
export type EnrollmentApplicationGuardianDeleteMutationFn = Apollo.MutationFunction<
	EnrollmentApplicationGuardianDeleteMutation,
	EnrollmentApplicationGuardianDeleteMutationVariables
>;

/**
 * __useEnrollmentApplicationGuardianDeleteMutation__
 *
 * To run a mutation, you first call `useEnrollmentApplicationGuardianDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationGuardianDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollmentApplicationGuardianDeleteMutation, { data, loading, error }] = useEnrollmentApplicationGuardianDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnrollmentApplicationGuardianDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		EnrollmentApplicationGuardianDeleteMutation,
		EnrollmentApplicationGuardianDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		EnrollmentApplicationGuardianDeleteMutation,
		EnrollmentApplicationGuardianDeleteMutationVariables
	>(EnrollmentApplicationGuardianDeleteDocument, options);
}
export type EnrollmentApplicationGuardianDeleteMutationHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianDeleteMutation
>;
export type EnrollmentApplicationGuardianDeleteMutationResult =
	Apollo.MutationResult<EnrollmentApplicationGuardianDeleteMutation>;
export type EnrollmentApplicationGuardianDeleteMutationOptions = Apollo.BaseMutationOptions<
	EnrollmentApplicationGuardianDeleteMutation,
	EnrollmentApplicationGuardianDeleteMutationVariables
>;
export const EnrollmentApplicationGuardianDetailDocument = gql`
	query enrollmentApplicationGuardianDetail($id: ID!) {
		enrollmentApplicationGuardian(id: $id) {
			...EnrollmentApplicationGuardianDetail
		}
	}
	${EnrollmentApplicationGuardianDetailFragmentDoc}
`;

/**
 * __useEnrollmentApplicationGuardianDetailQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationGuardianDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationGuardianDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationGuardianDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnrollmentApplicationGuardianDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		EnrollmentApplicationGuardianDetailQuery,
		EnrollmentApplicationGuardianDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationGuardianDetailQuery, EnrollmentApplicationGuardianDetailQueryVariables>(
		EnrollmentApplicationGuardianDetailDocument,
		options,
	);
}
export function useEnrollmentApplicationGuardianDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationGuardianDetailQuery,
		EnrollmentApplicationGuardianDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		EnrollmentApplicationGuardianDetailQuery,
		EnrollmentApplicationGuardianDetailQueryVariables
	>(EnrollmentApplicationGuardianDetailDocument, options);
}
export function useEnrollmentApplicationGuardianDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationGuardianDetailQuery,
		EnrollmentApplicationGuardianDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationGuardianDetailQuery,
		EnrollmentApplicationGuardianDetailQueryVariables
	>(EnrollmentApplicationGuardianDetailDocument, options);
}
export type EnrollmentApplicationGuardianDetailQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianDetailQuery
>;
export type EnrollmentApplicationGuardianDetailLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianDetailLazyQuery
>;
export type EnrollmentApplicationGuardianDetailSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianDetailSuspenseQuery
>;
export type EnrollmentApplicationGuardianDetailQueryResult = Apollo.QueryResult<
	EnrollmentApplicationGuardianDetailQuery,
	EnrollmentApplicationGuardianDetailQueryVariables
>;
export const EnrollmentApplicationGuardianIndexDocument = gql`
	query enrollmentApplicationGuardianIndex(
		$filters: [EnrollmentApplicationGuardianFilterInput!]
		$pagination: Pagination
		$order: EnrollmentApplicationGuardianOrder
	) {
		enrollmentApplicationGuardianConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					givenName
					middleName
					familyName
					nameOrder
					dateOfBirth
					gender
					relationshipType
					relationshipStatus
					emailAddress
					phoneNumber
					addressLine1
					addressLine2
					addressCity
					addressPostalCode
					addressStateOrProvince
					isPrimary
					isFinancialContact
					isEmergencyContact
					isAuthorizedForPickup
					livesWithStudent
					isPrimaryOnApplication
				}
			}
		}
	}
`;

/**
 * __useEnrollmentApplicationGuardianIndexQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationGuardianIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationGuardianIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationGuardianIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationGuardianIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationGuardianIndexQuery,
		EnrollmentApplicationGuardianIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationGuardianIndexQuery, EnrollmentApplicationGuardianIndexQueryVariables>(
		EnrollmentApplicationGuardianIndexDocument,
		options,
	);
}
export function useEnrollmentApplicationGuardianIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationGuardianIndexQuery,
		EnrollmentApplicationGuardianIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EnrollmentApplicationGuardianIndexQuery, EnrollmentApplicationGuardianIndexQueryVariables>(
		EnrollmentApplicationGuardianIndexDocument,
		options,
	);
}
export function useEnrollmentApplicationGuardianIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationGuardianIndexQuery,
		EnrollmentApplicationGuardianIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationGuardianIndexQuery,
		EnrollmentApplicationGuardianIndexQueryVariables
	>(EnrollmentApplicationGuardianIndexDocument, options);
}
export type EnrollmentApplicationGuardianIndexQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianIndexQuery
>;
export type EnrollmentApplicationGuardianIndexLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianIndexLazyQuery
>;
export type EnrollmentApplicationGuardianIndexSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianIndexSuspenseQuery
>;
export type EnrollmentApplicationGuardianIndexQueryResult = Apollo.QueryResult<
	EnrollmentApplicationGuardianIndexQuery,
	EnrollmentApplicationGuardianIndexQueryVariables
>;
export const EnrollmentApplicationGuardianReviewListDocument = gql`
	query enrollmentApplicationGuardianReviewList(
		$filters: [EnrollmentApplicationGuardianFilterInput!]
		$pagination: Pagination
		$order: EnrollmentApplicationGuardianOrder
	) {
		enrollmentApplicationGuardianConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...EnrollmentApplicationGuardianName
					relationshipType
					phoneNumber
				}
			}
		}
	}
	${EnrollmentApplicationGuardianNameFragmentDoc}
`;

/**
 * __useEnrollmentApplicationGuardianReviewListQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationGuardianReviewListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationGuardianReviewListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationGuardianReviewListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationGuardianReviewListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationGuardianReviewListQuery,
		EnrollmentApplicationGuardianReviewListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		EnrollmentApplicationGuardianReviewListQuery,
		EnrollmentApplicationGuardianReviewListQueryVariables
	>(EnrollmentApplicationGuardianReviewListDocument, options);
}
export function useEnrollmentApplicationGuardianReviewListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationGuardianReviewListQuery,
		EnrollmentApplicationGuardianReviewListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		EnrollmentApplicationGuardianReviewListQuery,
		EnrollmentApplicationGuardianReviewListQueryVariables
	>(EnrollmentApplicationGuardianReviewListDocument, options);
}
export function useEnrollmentApplicationGuardianReviewListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationGuardianReviewListQuery,
		EnrollmentApplicationGuardianReviewListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationGuardianReviewListQuery,
		EnrollmentApplicationGuardianReviewListQueryVariables
	>(EnrollmentApplicationGuardianReviewListDocument, options);
}
export type EnrollmentApplicationGuardianReviewListQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianReviewListQuery
>;
export type EnrollmentApplicationGuardianReviewListLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianReviewListLazyQuery
>;
export type EnrollmentApplicationGuardianReviewListSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianReviewListSuspenseQuery
>;
export type EnrollmentApplicationGuardianReviewListQueryResult = Apollo.QueryResult<
	EnrollmentApplicationGuardianReviewListQuery,
	EnrollmentApplicationGuardianReviewListQueryVariables
>;
export const EnrollmentApplicationGuardianAddressListDocument = gql`
	query enrollmentApplicationGuardianAddressList(
		$filters: [EnrollmentApplicationGuardianFilterInput!]
		$pagination: Pagination
		$order: EnrollmentApplicationGuardianOrder
	) {
		enrollmentApplicationGuardianConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...EnrollmentApplicationGuardianName
					...EnrollmentApplicationGuardianAddressInformation
					targetAddressGuardian {
						id
						...EnrollmentApplicationGuardianName
						...EnrollmentApplicationGuardianAddressInformation
					}
				}
			}
		}
	}
	${EnrollmentApplicationGuardianNameFragmentDoc}
	${EnrollmentApplicationGuardianAddressInformationFragmentDoc}
`;

/**
 * __useEnrollmentApplicationGuardianAddressListQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationGuardianAddressListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationGuardianAddressListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationGuardianAddressListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationGuardianAddressListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationGuardianAddressListQuery,
		EnrollmentApplicationGuardianAddressListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		EnrollmentApplicationGuardianAddressListQuery,
		EnrollmentApplicationGuardianAddressListQueryVariables
	>(EnrollmentApplicationGuardianAddressListDocument, options);
}
export function useEnrollmentApplicationGuardianAddressListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationGuardianAddressListQuery,
		EnrollmentApplicationGuardianAddressListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		EnrollmentApplicationGuardianAddressListQuery,
		EnrollmentApplicationGuardianAddressListQueryVariables
	>(EnrollmentApplicationGuardianAddressListDocument, options);
}
export function useEnrollmentApplicationGuardianAddressListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationGuardianAddressListQuery,
		EnrollmentApplicationGuardianAddressListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationGuardianAddressListQuery,
		EnrollmentApplicationGuardianAddressListQueryVariables
	>(EnrollmentApplicationGuardianAddressListDocument, options);
}
export type EnrollmentApplicationGuardianAddressListQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianAddressListQuery
>;
export type EnrollmentApplicationGuardianAddressListLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianAddressListLazyQuery
>;
export type EnrollmentApplicationGuardianAddressListSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianAddressListSuspenseQuery
>;
export type EnrollmentApplicationGuardianAddressListQueryResult = Apollo.QueryResult<
	EnrollmentApplicationGuardianAddressListQuery,
	EnrollmentApplicationGuardianAddressListQueryVariables
>;
export const EnrollmentApplicationGuardianNameDocument = gql`
	query enrollmentApplicationGuardianName($id: ID!) {
		enrollmentApplicationGuardian(id: $id) {
			id
			...EnrollmentApplicationGuardianName
		}
	}
	${EnrollmentApplicationGuardianNameFragmentDoc}
`;

/**
 * __useEnrollmentApplicationGuardianNameQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationGuardianNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationGuardianNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationGuardianNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnrollmentApplicationGuardianNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		EnrollmentApplicationGuardianNameQuery,
		EnrollmentApplicationGuardianNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationGuardianNameQuery, EnrollmentApplicationGuardianNameQueryVariables>(
		EnrollmentApplicationGuardianNameDocument,
		options,
	);
}
export function useEnrollmentApplicationGuardianNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationGuardianNameQuery,
		EnrollmentApplicationGuardianNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EnrollmentApplicationGuardianNameQuery, EnrollmentApplicationGuardianNameQueryVariables>(
		EnrollmentApplicationGuardianNameDocument,
		options,
	);
}
export function useEnrollmentApplicationGuardianNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationGuardianNameQuery,
		EnrollmentApplicationGuardianNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationGuardianNameQuery,
		EnrollmentApplicationGuardianNameQueryVariables
	>(EnrollmentApplicationGuardianNameDocument, options);
}
export type EnrollmentApplicationGuardianNameQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianNameQuery
>;
export type EnrollmentApplicationGuardianNameLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianNameLazyQuery
>;
export type EnrollmentApplicationGuardianNameSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianNameSuspenseQuery
>;
export type EnrollmentApplicationGuardianNameQueryResult = Apollo.QueryResult<
	EnrollmentApplicationGuardianNameQuery,
	EnrollmentApplicationGuardianNameQueryVariables
>;
export const EnrollmentApplicationGuardianNamesDocument = gql`
	query enrollmentApplicationGuardianNames(
		$filters: [EnrollmentApplicationGuardianFilterInput!]
		$pagination: Pagination
		$order: EnrollmentApplicationGuardianOrder
	) {
		enrollmentApplicationGuardianConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...EnrollmentApplicationGuardianName
				}
			}
		}
	}
	${EnrollmentApplicationGuardianNameFragmentDoc}
`;

/**
 * __useEnrollmentApplicationGuardianNamesQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationGuardianNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationGuardianNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationGuardianNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationGuardianNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationGuardianNamesQuery,
		EnrollmentApplicationGuardianNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationGuardianNamesQuery, EnrollmentApplicationGuardianNamesQueryVariables>(
		EnrollmentApplicationGuardianNamesDocument,
		options,
	);
}
export function useEnrollmentApplicationGuardianNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationGuardianNamesQuery,
		EnrollmentApplicationGuardianNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EnrollmentApplicationGuardianNamesQuery, EnrollmentApplicationGuardianNamesQueryVariables>(
		EnrollmentApplicationGuardianNamesDocument,
		options,
	);
}
export function useEnrollmentApplicationGuardianNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationGuardianNamesQuery,
		EnrollmentApplicationGuardianNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationGuardianNamesQuery,
		EnrollmentApplicationGuardianNamesQueryVariables
	>(EnrollmentApplicationGuardianNamesDocument, options);
}
export type EnrollmentApplicationGuardianNamesQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianNamesQuery
>;
export type EnrollmentApplicationGuardianNamesLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianNamesLazyQuery
>;
export type EnrollmentApplicationGuardianNamesSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianNamesSuspenseQuery
>;
export type EnrollmentApplicationGuardianNamesQueryResult = Apollo.QueryResult<
	EnrollmentApplicationGuardianNamesQuery,
	EnrollmentApplicationGuardianNamesQueryVariables
>;
export const EnrollmentApplicationGuardianPaginationDocument = gql`
	query enrollmentApplicationGuardianPagination(
		$filters: [EnrollmentApplicationGuardianFilterInput!]
		$order: EnrollmentApplicationGuardianOrder
	) {
		enrollmentApplicationGuardianConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useEnrollmentApplicationGuardianPaginationQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationGuardianPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationGuardianPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationGuardianPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationGuardianPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationGuardianPaginationQuery,
		EnrollmentApplicationGuardianPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		EnrollmentApplicationGuardianPaginationQuery,
		EnrollmentApplicationGuardianPaginationQueryVariables
	>(EnrollmentApplicationGuardianPaginationDocument, options);
}
export function useEnrollmentApplicationGuardianPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationGuardianPaginationQuery,
		EnrollmentApplicationGuardianPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		EnrollmentApplicationGuardianPaginationQuery,
		EnrollmentApplicationGuardianPaginationQueryVariables
	>(EnrollmentApplicationGuardianPaginationDocument, options);
}
export function useEnrollmentApplicationGuardianPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationGuardianPaginationQuery,
		EnrollmentApplicationGuardianPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationGuardianPaginationQuery,
		EnrollmentApplicationGuardianPaginationQueryVariables
	>(EnrollmentApplicationGuardianPaginationDocument, options);
}
export type EnrollmentApplicationGuardianPaginationQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianPaginationQuery
>;
export type EnrollmentApplicationGuardianPaginationLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianPaginationLazyQuery
>;
export type EnrollmentApplicationGuardianPaginationSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianPaginationSuspenseQuery
>;
export type EnrollmentApplicationGuardianPaginationQueryResult = Apollo.QueryResult<
	EnrollmentApplicationGuardianPaginationQuery,
	EnrollmentApplicationGuardianPaginationQueryVariables
>;
export const EnrollmentApplicationGuardianSelectDocument = gql`
	query enrollmentApplicationGuardianSelect(
		$filters: [EnrollmentApplicationGuardianFilterInput!]
		$order: EnrollmentApplicationGuardianOrder
	) {
		enrollmentApplicationGuardianConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...EnrollmentApplicationGuardianName
				}
			}
		}
	}
	${EnrollmentApplicationGuardianNameFragmentDoc}
`;

/**
 * __useEnrollmentApplicationGuardianSelectQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationGuardianSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationGuardianSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationGuardianSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationGuardianSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationGuardianSelectQuery,
		EnrollmentApplicationGuardianSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationGuardianSelectQuery, EnrollmentApplicationGuardianSelectQueryVariables>(
		EnrollmentApplicationGuardianSelectDocument,
		options,
	);
}
export function useEnrollmentApplicationGuardianSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationGuardianSelectQuery,
		EnrollmentApplicationGuardianSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		EnrollmentApplicationGuardianSelectQuery,
		EnrollmentApplicationGuardianSelectQueryVariables
	>(EnrollmentApplicationGuardianSelectDocument, options);
}
export function useEnrollmentApplicationGuardianSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationGuardianSelectQuery,
		EnrollmentApplicationGuardianSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationGuardianSelectQuery,
		EnrollmentApplicationGuardianSelectQueryVariables
	>(EnrollmentApplicationGuardianSelectDocument, options);
}
export type EnrollmentApplicationGuardianSelectQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianSelectQuery
>;
export type EnrollmentApplicationGuardianSelectLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianSelectLazyQuery
>;
export type EnrollmentApplicationGuardianSelectSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianSelectSuspenseQuery
>;
export type EnrollmentApplicationGuardianSelectQueryResult = Apollo.QueryResult<
	EnrollmentApplicationGuardianSelectQuery,
	EnrollmentApplicationGuardianSelectQueryVariables
>;
export const EnrollmentApplicationGuardianUpdateDocument = gql`
	mutation enrollmentApplicationGuardianUpdate($id: ID!, $input: EnrollmentApplicationGuardianUpdateInput!) {
		updateEnrollmentApplicationGuardian(id: $id, input: $input) {
			...EnrollmentApplicationGuardianDetail
		}
	}
	${EnrollmentApplicationGuardianDetailFragmentDoc}
`;
export type EnrollmentApplicationGuardianUpdateMutationFn = Apollo.MutationFunction<
	EnrollmentApplicationGuardianUpdateMutation,
	EnrollmentApplicationGuardianUpdateMutationVariables
>;

/**
 * __useEnrollmentApplicationGuardianUpdateMutation__
 *
 * To run a mutation, you first call `useEnrollmentApplicationGuardianUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationGuardianUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollmentApplicationGuardianUpdateMutation, { data, loading, error }] = useEnrollmentApplicationGuardianUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnrollmentApplicationGuardianUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		EnrollmentApplicationGuardianUpdateMutation,
		EnrollmentApplicationGuardianUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		EnrollmentApplicationGuardianUpdateMutation,
		EnrollmentApplicationGuardianUpdateMutationVariables
	>(EnrollmentApplicationGuardianUpdateDocument, options);
}
export type EnrollmentApplicationGuardianUpdateMutationHookResult = ReturnType<
	typeof useEnrollmentApplicationGuardianUpdateMutation
>;
export type EnrollmentApplicationGuardianUpdateMutationResult =
	Apollo.MutationResult<EnrollmentApplicationGuardianUpdateMutation>;
export type EnrollmentApplicationGuardianUpdateMutationOptions = Apollo.BaseMutationOptions<
	EnrollmentApplicationGuardianUpdateMutation,
	EnrollmentApplicationGuardianUpdateMutationVariables
>;
export const EnrollmentApplicationStudentCountDocument = gql`
	query enrollmentApplicationStudentCount(
		$filters: [EnrollmentApplicationStudentFilterInput!]
		$pagination: Pagination
		$order: EnrollmentApplicationStudentOrder
	) {
		enrollmentApplicationStudentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useEnrollmentApplicationStudentCountQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationStudentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationStudentCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationStudentCountQuery,
		EnrollmentApplicationStudentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationStudentCountQuery, EnrollmentApplicationStudentCountQueryVariables>(
		EnrollmentApplicationStudentCountDocument,
		options,
	);
}
export function useEnrollmentApplicationStudentCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationStudentCountQuery,
		EnrollmentApplicationStudentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EnrollmentApplicationStudentCountQuery, EnrollmentApplicationStudentCountQueryVariables>(
		EnrollmentApplicationStudentCountDocument,
		options,
	);
}
export function useEnrollmentApplicationStudentCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationStudentCountQuery,
		EnrollmentApplicationStudentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationStudentCountQuery,
		EnrollmentApplicationStudentCountQueryVariables
	>(EnrollmentApplicationStudentCountDocument, options);
}
export type EnrollmentApplicationStudentCountQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentCountQuery
>;
export type EnrollmentApplicationStudentCountLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentCountLazyQuery
>;
export type EnrollmentApplicationStudentCountSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentCountSuspenseQuery
>;
export type EnrollmentApplicationStudentCountQueryResult = Apollo.QueryResult<
	EnrollmentApplicationStudentCountQuery,
	EnrollmentApplicationStudentCountQueryVariables
>;
export const EnrollmentApplicationStudentCreateDocument = gql`
	mutation enrollmentApplicationStudentCreate($input: EnrollmentApplicationStudentCreateInput!) {
		createEnrollmentApplicationStudent(input: $input) {
			...EnrollmentApplicationStudentDetail
		}
	}
	${EnrollmentApplicationStudentDetailFragmentDoc}
`;
export type EnrollmentApplicationStudentCreateMutationFn = Apollo.MutationFunction<
	EnrollmentApplicationStudentCreateMutation,
	EnrollmentApplicationStudentCreateMutationVariables
>;

/**
 * __useEnrollmentApplicationStudentCreateMutation__
 *
 * To run a mutation, you first call `useEnrollmentApplicationStudentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollmentApplicationStudentCreateMutation, { data, loading, error }] = useEnrollmentApplicationStudentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		EnrollmentApplicationStudentCreateMutation,
		EnrollmentApplicationStudentCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		EnrollmentApplicationStudentCreateMutation,
		EnrollmentApplicationStudentCreateMutationVariables
	>(EnrollmentApplicationStudentCreateDocument, options);
}
export type EnrollmentApplicationStudentCreateMutationHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentCreateMutation
>;
export type EnrollmentApplicationStudentCreateMutationResult =
	Apollo.MutationResult<EnrollmentApplicationStudentCreateMutation>;
export type EnrollmentApplicationStudentCreateMutationOptions = Apollo.BaseMutationOptions<
	EnrollmentApplicationStudentCreateMutation,
	EnrollmentApplicationStudentCreateMutationVariables
>;
export const EnrollmentApplicationStudentDeleteDocument = gql`
	mutation enrollmentApplicationStudentDelete($id: ID!) {
		deleteEnrollmentApplicationStudent(id: $id)
	}
`;
export type EnrollmentApplicationStudentDeleteMutationFn = Apollo.MutationFunction<
	EnrollmentApplicationStudentDeleteMutation,
	EnrollmentApplicationStudentDeleteMutationVariables
>;

/**
 * __useEnrollmentApplicationStudentDeleteMutation__
 *
 * To run a mutation, you first call `useEnrollmentApplicationStudentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollmentApplicationStudentDeleteMutation, { data, loading, error }] = useEnrollmentApplicationStudentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		EnrollmentApplicationStudentDeleteMutation,
		EnrollmentApplicationStudentDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		EnrollmentApplicationStudentDeleteMutation,
		EnrollmentApplicationStudentDeleteMutationVariables
	>(EnrollmentApplicationStudentDeleteDocument, options);
}
export type EnrollmentApplicationStudentDeleteMutationHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentDeleteMutation
>;
export type EnrollmentApplicationStudentDeleteMutationResult =
	Apollo.MutationResult<EnrollmentApplicationStudentDeleteMutation>;
export type EnrollmentApplicationStudentDeleteMutationOptions = Apollo.BaseMutationOptions<
	EnrollmentApplicationStudentDeleteMutation,
	EnrollmentApplicationStudentDeleteMutationVariables
>;
export const EnrollmentApplicationStudentDetailDocument = gql`
	query enrollmentApplicationStudentDetail($id: ID!) {
		enrollmentApplicationStudent(id: $id) {
			...EnrollmentApplicationStudentDetail
		}
	}
	${EnrollmentApplicationStudentDetailFragmentDoc}
`;

/**
 * __useEnrollmentApplicationStudentDetailQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationStudentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationStudentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		EnrollmentApplicationStudentDetailQuery,
		EnrollmentApplicationStudentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationStudentDetailQuery, EnrollmentApplicationStudentDetailQueryVariables>(
		EnrollmentApplicationStudentDetailDocument,
		options,
	);
}
export function useEnrollmentApplicationStudentDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationStudentDetailQuery,
		EnrollmentApplicationStudentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EnrollmentApplicationStudentDetailQuery, EnrollmentApplicationStudentDetailQueryVariables>(
		EnrollmentApplicationStudentDetailDocument,
		options,
	);
}
export function useEnrollmentApplicationStudentDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationStudentDetailQuery,
		EnrollmentApplicationStudentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationStudentDetailQuery,
		EnrollmentApplicationStudentDetailQueryVariables
	>(EnrollmentApplicationStudentDetailDocument, options);
}
export type EnrollmentApplicationStudentDetailQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentDetailQuery
>;
export type EnrollmentApplicationStudentDetailLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentDetailLazyQuery
>;
export type EnrollmentApplicationStudentDetailSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentDetailSuspenseQuery
>;
export type EnrollmentApplicationStudentDetailQueryResult = Apollo.QueryResult<
	EnrollmentApplicationStudentDetailQuery,
	EnrollmentApplicationStudentDetailQueryVariables
>;
export const EnrollmentApplicationStudentIndexDocument = gql`
	query enrollmentApplicationStudentIndex(
		$filters: [EnrollmentApplicationStudentFilterInput!]
		$pagination: Pagination
		$order: EnrollmentApplicationStudentOrder
	) {
		enrollmentApplicationStudentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					imageURL
					imageContentType
					name
					givenName
					middleName
					familyName
					nameOrder
					dateOfBirth
					gender
					englishLanguageFluency
					questionnaireActivities
					questionnaireHasPsychTreatment
					questionnairePsychTreatmentDescription
					questionnaireHasSpecialNeeds
					questionnaireSpecialNeedsDescription
					questionnaireHasBehaviors
					questionnaireBehaviorsDescription
					questionnaireDescription
					questionnaireAdditionalInformation
				}
			}
		}
	}
`;

/**
 * __useEnrollmentApplicationStudentIndexQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationStudentIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationStudentIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationStudentIndexQuery,
		EnrollmentApplicationStudentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationStudentIndexQuery, EnrollmentApplicationStudentIndexQueryVariables>(
		EnrollmentApplicationStudentIndexDocument,
		options,
	);
}
export function useEnrollmentApplicationStudentIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationStudentIndexQuery,
		EnrollmentApplicationStudentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EnrollmentApplicationStudentIndexQuery, EnrollmentApplicationStudentIndexQueryVariables>(
		EnrollmentApplicationStudentIndexDocument,
		options,
	);
}
export function useEnrollmentApplicationStudentIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationStudentIndexQuery,
		EnrollmentApplicationStudentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationStudentIndexQuery,
		EnrollmentApplicationStudentIndexQueryVariables
	>(EnrollmentApplicationStudentIndexDocument, options);
}
export type EnrollmentApplicationStudentIndexQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentIndexQuery
>;
export type EnrollmentApplicationStudentIndexLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentIndexLazyQuery
>;
export type EnrollmentApplicationStudentIndexSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentIndexSuspenseQuery
>;
export type EnrollmentApplicationStudentIndexQueryResult = Apollo.QueryResult<
	EnrollmentApplicationStudentIndexQuery,
	EnrollmentApplicationStudentIndexQueryVariables
>;
export const EnrollmentApplicationStudentReviewListDocument = gql`
	query enrollmentApplicationStudentReviewList(
		$filters: [EnrollmentApplicationStudentFilterInput!]
		$pagination: Pagination
		$order: EnrollmentApplicationStudentOrder
	) {
		enrollmentApplicationStudentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...EnrollmentApplicationStudentNameAndImage
					dateOfBirth
					classYear {
						id
						...ClassYearName
					}
				}
			}
		}
	}
	${EnrollmentApplicationStudentNameAndImageFragmentDoc}
	${ClassYearNameFragmentDoc}
`;

/**
 * __useEnrollmentApplicationStudentReviewListQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationStudentReviewListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentReviewListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationStudentReviewListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentReviewListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationStudentReviewListQuery,
		EnrollmentApplicationStudentReviewListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		EnrollmentApplicationStudentReviewListQuery,
		EnrollmentApplicationStudentReviewListQueryVariables
	>(EnrollmentApplicationStudentReviewListDocument, options);
}
export function useEnrollmentApplicationStudentReviewListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationStudentReviewListQuery,
		EnrollmentApplicationStudentReviewListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		EnrollmentApplicationStudentReviewListQuery,
		EnrollmentApplicationStudentReviewListQueryVariables
	>(EnrollmentApplicationStudentReviewListDocument, options);
}
export function useEnrollmentApplicationStudentReviewListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationStudentReviewListQuery,
		EnrollmentApplicationStudentReviewListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationStudentReviewListQuery,
		EnrollmentApplicationStudentReviewListQueryVariables
	>(EnrollmentApplicationStudentReviewListDocument, options);
}
export type EnrollmentApplicationStudentReviewListQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentReviewListQuery
>;
export type EnrollmentApplicationStudentReviewListLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentReviewListLazyQuery
>;
export type EnrollmentApplicationStudentReviewListSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentReviewListSuspenseQuery
>;
export type EnrollmentApplicationStudentReviewListQueryResult = Apollo.QueryResult<
	EnrollmentApplicationStudentReviewListQuery,
	EnrollmentApplicationStudentReviewListQueryVariables
>;
export const EnrollmentApplicationStudentNameDocument = gql`
	query enrollmentApplicationStudentName($id: ID!) {
		enrollmentApplicationStudent(id: $id) {
			id
			...EnrollmentApplicationStudentName
		}
	}
	${EnrollmentApplicationStudentNameFragmentDoc}
`;

/**
 * __useEnrollmentApplicationStudentNameQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationStudentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationStudentNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		EnrollmentApplicationStudentNameQuery,
		EnrollmentApplicationStudentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationStudentNameQuery, EnrollmentApplicationStudentNameQueryVariables>(
		EnrollmentApplicationStudentNameDocument,
		options,
	);
}
export function useEnrollmentApplicationStudentNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationStudentNameQuery,
		EnrollmentApplicationStudentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EnrollmentApplicationStudentNameQuery, EnrollmentApplicationStudentNameQueryVariables>(
		EnrollmentApplicationStudentNameDocument,
		options,
	);
}
export function useEnrollmentApplicationStudentNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationStudentNameQuery,
		EnrollmentApplicationStudentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<EnrollmentApplicationStudentNameQuery, EnrollmentApplicationStudentNameQueryVariables>(
		EnrollmentApplicationStudentNameDocument,
		options,
	);
}
export type EnrollmentApplicationStudentNameQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentNameQuery
>;
export type EnrollmentApplicationStudentNameLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentNameLazyQuery
>;
export type EnrollmentApplicationStudentNameSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentNameSuspenseQuery
>;
export type EnrollmentApplicationStudentNameQueryResult = Apollo.QueryResult<
	EnrollmentApplicationStudentNameQuery,
	EnrollmentApplicationStudentNameQueryVariables
>;
export const EnrollmentApplicationStudentNamesDocument = gql`
	query enrollmentApplicationStudentNames(
		$filters: [EnrollmentApplicationStudentFilterInput!]
		$pagination: Pagination
		$order: EnrollmentApplicationStudentOrder
	) {
		enrollmentApplicationStudentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...EnrollmentApplicationStudentName
				}
			}
		}
	}
	${EnrollmentApplicationStudentNameFragmentDoc}
`;

/**
 * __useEnrollmentApplicationStudentNamesQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationStudentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationStudentNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationStudentNamesQuery,
		EnrollmentApplicationStudentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationStudentNamesQuery, EnrollmentApplicationStudentNamesQueryVariables>(
		EnrollmentApplicationStudentNamesDocument,
		options,
	);
}
export function useEnrollmentApplicationStudentNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationStudentNamesQuery,
		EnrollmentApplicationStudentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EnrollmentApplicationStudentNamesQuery, EnrollmentApplicationStudentNamesQueryVariables>(
		EnrollmentApplicationStudentNamesDocument,
		options,
	);
}
export function useEnrollmentApplicationStudentNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationStudentNamesQuery,
		EnrollmentApplicationStudentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationStudentNamesQuery,
		EnrollmentApplicationStudentNamesQueryVariables
	>(EnrollmentApplicationStudentNamesDocument, options);
}
export type EnrollmentApplicationStudentNamesQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentNamesQuery
>;
export type EnrollmentApplicationStudentNamesLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentNamesLazyQuery
>;
export type EnrollmentApplicationStudentNamesSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentNamesSuspenseQuery
>;
export type EnrollmentApplicationStudentNamesQueryResult = Apollo.QueryResult<
	EnrollmentApplicationStudentNamesQuery,
	EnrollmentApplicationStudentNamesQueryVariables
>;
export const EnrollmentApplicationStudentPaginationDocument = gql`
	query enrollmentApplicationStudentPagination(
		$filters: [EnrollmentApplicationStudentFilterInput!]
		$order: EnrollmentApplicationStudentOrder
	) {
		enrollmentApplicationStudentConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useEnrollmentApplicationStudentPaginationQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationStudentPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationStudentPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationStudentPaginationQuery,
		EnrollmentApplicationStudentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		EnrollmentApplicationStudentPaginationQuery,
		EnrollmentApplicationStudentPaginationQueryVariables
	>(EnrollmentApplicationStudentPaginationDocument, options);
}
export function useEnrollmentApplicationStudentPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationStudentPaginationQuery,
		EnrollmentApplicationStudentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		EnrollmentApplicationStudentPaginationQuery,
		EnrollmentApplicationStudentPaginationQueryVariables
	>(EnrollmentApplicationStudentPaginationDocument, options);
}
export function useEnrollmentApplicationStudentPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationStudentPaginationQuery,
		EnrollmentApplicationStudentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationStudentPaginationQuery,
		EnrollmentApplicationStudentPaginationQueryVariables
	>(EnrollmentApplicationStudentPaginationDocument, options);
}
export type EnrollmentApplicationStudentPaginationQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentPaginationQuery
>;
export type EnrollmentApplicationStudentPaginationLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentPaginationLazyQuery
>;
export type EnrollmentApplicationStudentPaginationSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentPaginationSuspenseQuery
>;
export type EnrollmentApplicationStudentPaginationQueryResult = Apollo.QueryResult<
	EnrollmentApplicationStudentPaginationQuery,
	EnrollmentApplicationStudentPaginationQueryVariables
>;
export const EnrollmentApplicationStudentSelectDocument = gql`
	query enrollmentApplicationStudentSelect(
		$filters: [EnrollmentApplicationStudentFilterInput!]
		$order: EnrollmentApplicationStudentOrder
	) {
		enrollmentApplicationStudentConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...EnrollmentApplicationStudentName
				}
			}
		}
	}
	${EnrollmentApplicationStudentNameFragmentDoc}
`;

/**
 * __useEnrollmentApplicationStudentSelectQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationStudentSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationStudentSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationStudentSelectQuery,
		EnrollmentApplicationStudentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<EnrollmentApplicationStudentSelectQuery, EnrollmentApplicationStudentSelectQueryVariables>(
		EnrollmentApplicationStudentSelectDocument,
		options,
	);
}
export function useEnrollmentApplicationStudentSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationStudentSelectQuery,
		EnrollmentApplicationStudentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<EnrollmentApplicationStudentSelectQuery, EnrollmentApplicationStudentSelectQueryVariables>(
		EnrollmentApplicationStudentSelectDocument,
		options,
	);
}
export function useEnrollmentApplicationStudentSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationStudentSelectQuery,
		EnrollmentApplicationStudentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationStudentSelectQuery,
		EnrollmentApplicationStudentSelectQueryVariables
	>(EnrollmentApplicationStudentSelectDocument, options);
}
export type EnrollmentApplicationStudentSelectQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSelectQuery
>;
export type EnrollmentApplicationStudentSelectLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSelectLazyQuery
>;
export type EnrollmentApplicationStudentSelectSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSelectSuspenseQuery
>;
export type EnrollmentApplicationStudentSelectQueryResult = Apollo.QueryResult<
	EnrollmentApplicationStudentSelectQuery,
	EnrollmentApplicationStudentSelectQueryVariables
>;
export const EnrollmentApplicationStudentUpdateDocument = gql`
	mutation enrollmentApplicationStudentUpdate($id: ID!, $input: EnrollmentApplicationStudentUpdateInput!) {
		updateEnrollmentApplicationStudent(id: $id, input: $input) {
			...EnrollmentApplicationStudentDetail
		}
	}
	${EnrollmentApplicationStudentDetailFragmentDoc}
`;
export type EnrollmentApplicationStudentUpdateMutationFn = Apollo.MutationFunction<
	EnrollmentApplicationStudentUpdateMutation,
	EnrollmentApplicationStudentUpdateMutationVariables
>;

/**
 * __useEnrollmentApplicationStudentUpdateMutation__
 *
 * To run a mutation, you first call `useEnrollmentApplicationStudentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollmentApplicationStudentUpdateMutation, { data, loading, error }] = useEnrollmentApplicationStudentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		EnrollmentApplicationStudentUpdateMutation,
		EnrollmentApplicationStudentUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		EnrollmentApplicationStudentUpdateMutation,
		EnrollmentApplicationStudentUpdateMutationVariables
	>(EnrollmentApplicationStudentUpdateDocument, options);
}
export type EnrollmentApplicationStudentUpdateMutationHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentUpdateMutation
>;
export type EnrollmentApplicationStudentUpdateMutationResult =
	Apollo.MutationResult<EnrollmentApplicationStudentUpdateMutation>;
export type EnrollmentApplicationStudentUpdateMutationOptions = Apollo.BaseMutationOptions<
	EnrollmentApplicationStudentUpdateMutation,
	EnrollmentApplicationStudentUpdateMutationVariables
>;
export const EnrollmentApplicationStudentSchoolCountDocument = gql`
	query enrollmentApplicationStudentSchoolCount(
		$filters: [EnrollmentApplicationStudentSchoolFilterInput!]
		$pagination: Pagination
		$order: EnrollmentApplicationStudentSchoolOrder
	) {
		enrollmentApplicationStudentSchoolConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useEnrollmentApplicationStudentSchoolCountQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationStudentSchoolCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentSchoolCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationStudentSchoolCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentSchoolCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationStudentSchoolCountQuery,
		EnrollmentApplicationStudentSchoolCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		EnrollmentApplicationStudentSchoolCountQuery,
		EnrollmentApplicationStudentSchoolCountQueryVariables
	>(EnrollmentApplicationStudentSchoolCountDocument, options);
}
export function useEnrollmentApplicationStudentSchoolCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationStudentSchoolCountQuery,
		EnrollmentApplicationStudentSchoolCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		EnrollmentApplicationStudentSchoolCountQuery,
		EnrollmentApplicationStudentSchoolCountQueryVariables
	>(EnrollmentApplicationStudentSchoolCountDocument, options);
}
export function useEnrollmentApplicationStudentSchoolCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationStudentSchoolCountQuery,
		EnrollmentApplicationStudentSchoolCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationStudentSchoolCountQuery,
		EnrollmentApplicationStudentSchoolCountQueryVariables
	>(EnrollmentApplicationStudentSchoolCountDocument, options);
}
export type EnrollmentApplicationStudentSchoolCountQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolCountQuery
>;
export type EnrollmentApplicationStudentSchoolCountLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolCountLazyQuery
>;
export type EnrollmentApplicationStudentSchoolCountSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolCountSuspenseQuery
>;
export type EnrollmentApplicationStudentSchoolCountQueryResult = Apollo.QueryResult<
	EnrollmentApplicationStudentSchoolCountQuery,
	EnrollmentApplicationStudentSchoolCountQueryVariables
>;
export const EnrollmentApplicationStudentSchoolCreateDocument = gql`
	mutation enrollmentApplicationStudentSchoolCreate($input: EnrollmentApplicationStudentSchoolCreateInput!) {
		createEnrollmentApplicationStudentSchool(input: $input) {
			...EnrollmentApplicationStudentSchoolDetail
		}
	}
	${EnrollmentApplicationStudentSchoolDetailFragmentDoc}
`;
export type EnrollmentApplicationStudentSchoolCreateMutationFn = Apollo.MutationFunction<
	EnrollmentApplicationStudentSchoolCreateMutation,
	EnrollmentApplicationStudentSchoolCreateMutationVariables
>;

/**
 * __useEnrollmentApplicationStudentSchoolCreateMutation__
 *
 * To run a mutation, you first call `useEnrollmentApplicationStudentSchoolCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentSchoolCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollmentApplicationStudentSchoolCreateMutation, { data, loading, error }] = useEnrollmentApplicationStudentSchoolCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentSchoolCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		EnrollmentApplicationStudentSchoolCreateMutation,
		EnrollmentApplicationStudentSchoolCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		EnrollmentApplicationStudentSchoolCreateMutation,
		EnrollmentApplicationStudentSchoolCreateMutationVariables
	>(EnrollmentApplicationStudentSchoolCreateDocument, options);
}
export type EnrollmentApplicationStudentSchoolCreateMutationHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolCreateMutation
>;
export type EnrollmentApplicationStudentSchoolCreateMutationResult =
	Apollo.MutationResult<EnrollmentApplicationStudentSchoolCreateMutation>;
export type EnrollmentApplicationStudentSchoolCreateMutationOptions = Apollo.BaseMutationOptions<
	EnrollmentApplicationStudentSchoolCreateMutation,
	EnrollmentApplicationStudentSchoolCreateMutationVariables
>;
export const EnrollmentApplicationStudentSchoolDeleteDocument = gql`
	mutation enrollmentApplicationStudentSchoolDelete($id: ID!) {
		deleteEnrollmentApplicationStudentSchool(id: $id)
	}
`;
export type EnrollmentApplicationStudentSchoolDeleteMutationFn = Apollo.MutationFunction<
	EnrollmentApplicationStudentSchoolDeleteMutation,
	EnrollmentApplicationStudentSchoolDeleteMutationVariables
>;

/**
 * __useEnrollmentApplicationStudentSchoolDeleteMutation__
 *
 * To run a mutation, you first call `useEnrollmentApplicationStudentSchoolDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentSchoolDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollmentApplicationStudentSchoolDeleteMutation, { data, loading, error }] = useEnrollmentApplicationStudentSchoolDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentSchoolDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		EnrollmentApplicationStudentSchoolDeleteMutation,
		EnrollmentApplicationStudentSchoolDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		EnrollmentApplicationStudentSchoolDeleteMutation,
		EnrollmentApplicationStudentSchoolDeleteMutationVariables
	>(EnrollmentApplicationStudentSchoolDeleteDocument, options);
}
export type EnrollmentApplicationStudentSchoolDeleteMutationHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolDeleteMutation
>;
export type EnrollmentApplicationStudentSchoolDeleteMutationResult =
	Apollo.MutationResult<EnrollmentApplicationStudentSchoolDeleteMutation>;
export type EnrollmentApplicationStudentSchoolDeleteMutationOptions = Apollo.BaseMutationOptions<
	EnrollmentApplicationStudentSchoolDeleteMutation,
	EnrollmentApplicationStudentSchoolDeleteMutationVariables
>;
export const EnrollmentApplicationStudentSchoolDetailDocument = gql`
	query enrollmentApplicationStudentSchoolDetail($id: ID!) {
		enrollmentApplicationStudentSchool(id: $id) {
			...EnrollmentApplicationStudentSchoolDetail
		}
	}
	${EnrollmentApplicationStudentSchoolDetailFragmentDoc}
`;

/**
 * __useEnrollmentApplicationStudentSchoolDetailQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationStudentSchoolDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentSchoolDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationStudentSchoolDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentSchoolDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		EnrollmentApplicationStudentSchoolDetailQuery,
		EnrollmentApplicationStudentSchoolDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		EnrollmentApplicationStudentSchoolDetailQuery,
		EnrollmentApplicationStudentSchoolDetailQueryVariables
	>(EnrollmentApplicationStudentSchoolDetailDocument, options);
}
export function useEnrollmentApplicationStudentSchoolDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationStudentSchoolDetailQuery,
		EnrollmentApplicationStudentSchoolDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		EnrollmentApplicationStudentSchoolDetailQuery,
		EnrollmentApplicationStudentSchoolDetailQueryVariables
	>(EnrollmentApplicationStudentSchoolDetailDocument, options);
}
export function useEnrollmentApplicationStudentSchoolDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationStudentSchoolDetailQuery,
		EnrollmentApplicationStudentSchoolDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationStudentSchoolDetailQuery,
		EnrollmentApplicationStudentSchoolDetailQueryVariables
	>(EnrollmentApplicationStudentSchoolDetailDocument, options);
}
export type EnrollmentApplicationStudentSchoolDetailQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolDetailQuery
>;
export type EnrollmentApplicationStudentSchoolDetailLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolDetailLazyQuery
>;
export type EnrollmentApplicationStudentSchoolDetailSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolDetailSuspenseQuery
>;
export type EnrollmentApplicationStudentSchoolDetailQueryResult = Apollo.QueryResult<
	EnrollmentApplicationStudentSchoolDetailQuery,
	EnrollmentApplicationStudentSchoolDetailQueryVariables
>;
export const EnrollmentApplicationStudentSchoolIndexDocument = gql`
	query enrollmentApplicationStudentSchoolIndex(
		$filters: [EnrollmentApplicationStudentSchoolFilterInput!]
		$pagination: Pagination
		$order: EnrollmentApplicationStudentSchoolOrder
	) {
		enrollmentApplicationStudentSchoolConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					city
					startDate
					endDate
				}
			}
		}
	}
`;

/**
 * __useEnrollmentApplicationStudentSchoolIndexQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationStudentSchoolIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentSchoolIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationStudentSchoolIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentSchoolIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationStudentSchoolIndexQuery,
		EnrollmentApplicationStudentSchoolIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		EnrollmentApplicationStudentSchoolIndexQuery,
		EnrollmentApplicationStudentSchoolIndexQueryVariables
	>(EnrollmentApplicationStudentSchoolIndexDocument, options);
}
export function useEnrollmentApplicationStudentSchoolIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationStudentSchoolIndexQuery,
		EnrollmentApplicationStudentSchoolIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		EnrollmentApplicationStudentSchoolIndexQuery,
		EnrollmentApplicationStudentSchoolIndexQueryVariables
	>(EnrollmentApplicationStudentSchoolIndexDocument, options);
}
export function useEnrollmentApplicationStudentSchoolIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationStudentSchoolIndexQuery,
		EnrollmentApplicationStudentSchoolIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationStudentSchoolIndexQuery,
		EnrollmentApplicationStudentSchoolIndexQueryVariables
	>(EnrollmentApplicationStudentSchoolIndexDocument, options);
}
export type EnrollmentApplicationStudentSchoolIndexQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolIndexQuery
>;
export type EnrollmentApplicationStudentSchoolIndexLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolIndexLazyQuery
>;
export type EnrollmentApplicationStudentSchoolIndexSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolIndexSuspenseQuery
>;
export type EnrollmentApplicationStudentSchoolIndexQueryResult = Apollo.QueryResult<
	EnrollmentApplicationStudentSchoolIndexQuery,
	EnrollmentApplicationStudentSchoolIndexQueryVariables
>;
export const EnrollmentApplicationStudentSchoolNameDocument = gql`
	query enrollmentApplicationStudentSchoolName($id: ID!) {
		enrollmentApplicationStudentSchool(id: $id) {
			id
			...EnrollmentApplicationStudentSchoolName
		}
	}
	${EnrollmentApplicationStudentSchoolNameFragmentDoc}
`;

/**
 * __useEnrollmentApplicationStudentSchoolNameQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationStudentSchoolNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentSchoolNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationStudentSchoolNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentSchoolNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		EnrollmentApplicationStudentSchoolNameQuery,
		EnrollmentApplicationStudentSchoolNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		EnrollmentApplicationStudentSchoolNameQuery,
		EnrollmentApplicationStudentSchoolNameQueryVariables
	>(EnrollmentApplicationStudentSchoolNameDocument, options);
}
export function useEnrollmentApplicationStudentSchoolNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationStudentSchoolNameQuery,
		EnrollmentApplicationStudentSchoolNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		EnrollmentApplicationStudentSchoolNameQuery,
		EnrollmentApplicationStudentSchoolNameQueryVariables
	>(EnrollmentApplicationStudentSchoolNameDocument, options);
}
export function useEnrollmentApplicationStudentSchoolNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationStudentSchoolNameQuery,
		EnrollmentApplicationStudentSchoolNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationStudentSchoolNameQuery,
		EnrollmentApplicationStudentSchoolNameQueryVariables
	>(EnrollmentApplicationStudentSchoolNameDocument, options);
}
export type EnrollmentApplicationStudentSchoolNameQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolNameQuery
>;
export type EnrollmentApplicationStudentSchoolNameLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolNameLazyQuery
>;
export type EnrollmentApplicationStudentSchoolNameSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolNameSuspenseQuery
>;
export type EnrollmentApplicationStudentSchoolNameQueryResult = Apollo.QueryResult<
	EnrollmentApplicationStudentSchoolNameQuery,
	EnrollmentApplicationStudentSchoolNameQueryVariables
>;
export const EnrollmentApplicationStudentSchoolNamesDocument = gql`
	query enrollmentApplicationStudentSchoolNames(
		$filters: [EnrollmentApplicationStudentSchoolFilterInput!]
		$pagination: Pagination
		$order: EnrollmentApplicationStudentSchoolOrder
	) {
		enrollmentApplicationStudentSchoolConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...EnrollmentApplicationStudentSchoolName
				}
			}
		}
	}
	${EnrollmentApplicationStudentSchoolNameFragmentDoc}
`;

/**
 * __useEnrollmentApplicationStudentSchoolNamesQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationStudentSchoolNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentSchoolNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationStudentSchoolNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentSchoolNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationStudentSchoolNamesQuery,
		EnrollmentApplicationStudentSchoolNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		EnrollmentApplicationStudentSchoolNamesQuery,
		EnrollmentApplicationStudentSchoolNamesQueryVariables
	>(EnrollmentApplicationStudentSchoolNamesDocument, options);
}
export function useEnrollmentApplicationStudentSchoolNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationStudentSchoolNamesQuery,
		EnrollmentApplicationStudentSchoolNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		EnrollmentApplicationStudentSchoolNamesQuery,
		EnrollmentApplicationStudentSchoolNamesQueryVariables
	>(EnrollmentApplicationStudentSchoolNamesDocument, options);
}
export function useEnrollmentApplicationStudentSchoolNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationStudentSchoolNamesQuery,
		EnrollmentApplicationStudentSchoolNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationStudentSchoolNamesQuery,
		EnrollmentApplicationStudentSchoolNamesQueryVariables
	>(EnrollmentApplicationStudentSchoolNamesDocument, options);
}
export type EnrollmentApplicationStudentSchoolNamesQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolNamesQuery
>;
export type EnrollmentApplicationStudentSchoolNamesLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolNamesLazyQuery
>;
export type EnrollmentApplicationStudentSchoolNamesSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolNamesSuspenseQuery
>;
export type EnrollmentApplicationStudentSchoolNamesQueryResult = Apollo.QueryResult<
	EnrollmentApplicationStudentSchoolNamesQuery,
	EnrollmentApplicationStudentSchoolNamesQueryVariables
>;
export const EnrollmentApplicationStudentSchoolPaginationDocument = gql`
	query enrollmentApplicationStudentSchoolPagination(
		$filters: [EnrollmentApplicationStudentSchoolFilterInput!]
		$order: EnrollmentApplicationStudentSchoolOrder
	) {
		enrollmentApplicationStudentSchoolConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useEnrollmentApplicationStudentSchoolPaginationQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationStudentSchoolPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentSchoolPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationStudentSchoolPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentSchoolPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationStudentSchoolPaginationQuery,
		EnrollmentApplicationStudentSchoolPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		EnrollmentApplicationStudentSchoolPaginationQuery,
		EnrollmentApplicationStudentSchoolPaginationQueryVariables
	>(EnrollmentApplicationStudentSchoolPaginationDocument, options);
}
export function useEnrollmentApplicationStudentSchoolPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationStudentSchoolPaginationQuery,
		EnrollmentApplicationStudentSchoolPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		EnrollmentApplicationStudentSchoolPaginationQuery,
		EnrollmentApplicationStudentSchoolPaginationQueryVariables
	>(EnrollmentApplicationStudentSchoolPaginationDocument, options);
}
export function useEnrollmentApplicationStudentSchoolPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationStudentSchoolPaginationQuery,
		EnrollmentApplicationStudentSchoolPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationStudentSchoolPaginationQuery,
		EnrollmentApplicationStudentSchoolPaginationQueryVariables
	>(EnrollmentApplicationStudentSchoolPaginationDocument, options);
}
export type EnrollmentApplicationStudentSchoolPaginationQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolPaginationQuery
>;
export type EnrollmentApplicationStudentSchoolPaginationLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolPaginationLazyQuery
>;
export type EnrollmentApplicationStudentSchoolPaginationSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolPaginationSuspenseQuery
>;
export type EnrollmentApplicationStudentSchoolPaginationQueryResult = Apollo.QueryResult<
	EnrollmentApplicationStudentSchoolPaginationQuery,
	EnrollmentApplicationStudentSchoolPaginationQueryVariables
>;
export const EnrollmentApplicationStudentSchoolSelectDocument = gql`
	query enrollmentApplicationStudentSchoolSelect(
		$filters: [EnrollmentApplicationStudentSchoolFilterInput!]
		$order: EnrollmentApplicationStudentSchoolOrder
	) {
		enrollmentApplicationStudentSchoolConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...EnrollmentApplicationStudentSchoolName
				}
			}
		}
	}
	${EnrollmentApplicationStudentSchoolNameFragmentDoc}
`;

/**
 * __useEnrollmentApplicationStudentSchoolSelectQuery__
 *
 * To run a query within a React component, call `useEnrollmentApplicationStudentSchoolSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentSchoolSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentApplicationStudentSchoolSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentSchoolSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		EnrollmentApplicationStudentSchoolSelectQuery,
		EnrollmentApplicationStudentSchoolSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		EnrollmentApplicationStudentSchoolSelectQuery,
		EnrollmentApplicationStudentSchoolSelectQueryVariables
	>(EnrollmentApplicationStudentSchoolSelectDocument, options);
}
export function useEnrollmentApplicationStudentSchoolSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		EnrollmentApplicationStudentSchoolSelectQuery,
		EnrollmentApplicationStudentSchoolSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		EnrollmentApplicationStudentSchoolSelectQuery,
		EnrollmentApplicationStudentSchoolSelectQueryVariables
	>(EnrollmentApplicationStudentSchoolSelectDocument, options);
}
export function useEnrollmentApplicationStudentSchoolSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		EnrollmentApplicationStudentSchoolSelectQuery,
		EnrollmentApplicationStudentSchoolSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		EnrollmentApplicationStudentSchoolSelectQuery,
		EnrollmentApplicationStudentSchoolSelectQueryVariables
	>(EnrollmentApplicationStudentSchoolSelectDocument, options);
}
export type EnrollmentApplicationStudentSchoolSelectQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolSelectQuery
>;
export type EnrollmentApplicationStudentSchoolSelectLazyQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolSelectLazyQuery
>;
export type EnrollmentApplicationStudentSchoolSelectSuspenseQueryHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolSelectSuspenseQuery
>;
export type EnrollmentApplicationStudentSchoolSelectQueryResult = Apollo.QueryResult<
	EnrollmentApplicationStudentSchoolSelectQuery,
	EnrollmentApplicationStudentSchoolSelectQueryVariables
>;
export const EnrollmentApplicationStudentSchoolUpdateDocument = gql`
	mutation enrollmentApplicationStudentSchoolUpdate($id: ID!, $input: EnrollmentApplicationStudentSchoolUpdateInput!) {
		updateEnrollmentApplicationStudentSchool(id: $id, input: $input) {
			...EnrollmentApplicationStudentSchoolDetail
		}
	}
	${EnrollmentApplicationStudentSchoolDetailFragmentDoc}
`;
export type EnrollmentApplicationStudentSchoolUpdateMutationFn = Apollo.MutationFunction<
	EnrollmentApplicationStudentSchoolUpdateMutation,
	EnrollmentApplicationStudentSchoolUpdateMutationVariables
>;

/**
 * __useEnrollmentApplicationStudentSchoolUpdateMutation__
 *
 * To run a mutation, you first call `useEnrollmentApplicationStudentSchoolUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentApplicationStudentSchoolUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollmentApplicationStudentSchoolUpdateMutation, { data, loading, error }] = useEnrollmentApplicationStudentSchoolUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnrollmentApplicationStudentSchoolUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		EnrollmentApplicationStudentSchoolUpdateMutation,
		EnrollmentApplicationStudentSchoolUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		EnrollmentApplicationStudentSchoolUpdateMutation,
		EnrollmentApplicationStudentSchoolUpdateMutationVariables
	>(EnrollmentApplicationStudentSchoolUpdateDocument, options);
}
export type EnrollmentApplicationStudentSchoolUpdateMutationHookResult = ReturnType<
	typeof useEnrollmentApplicationStudentSchoolUpdateMutation
>;
export type EnrollmentApplicationStudentSchoolUpdateMutationResult =
	Apollo.MutationResult<EnrollmentApplicationStudentSchoolUpdateMutation>;
export type EnrollmentApplicationStudentSchoolUpdateMutationOptions = Apollo.BaseMutationOptions<
	EnrollmentApplicationStudentSchoolUpdateMutation,
	EnrollmentApplicationStudentSchoolUpdateMutationVariables
>;
export const GuardianCountDocument = gql`
	query guardianCount($filters: [GuardianFilterInput!], $pagination: Pagination, $order: GuardianOrder) {
		guardianConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useGuardianCountQuery__
 *
 * To run a query within a React component, call `useGuardianCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuardianCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGuardianCountQuery(
	baseOptions?: Apollo.QueryHookOptions<GuardianCountQuery, GuardianCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GuardianCountQuery, GuardianCountQueryVariables>(GuardianCountDocument, options);
}
export function useGuardianCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GuardianCountQuery, GuardianCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GuardianCountQuery, GuardianCountQueryVariables>(GuardianCountDocument, options);
}
export function useGuardianCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<GuardianCountQuery, GuardianCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GuardianCountQuery, GuardianCountQueryVariables>(GuardianCountDocument, options);
}
export type GuardianCountQueryHookResult = ReturnType<typeof useGuardianCountQuery>;
export type GuardianCountLazyQueryHookResult = ReturnType<typeof useGuardianCountLazyQuery>;
export type GuardianCountSuspenseQueryHookResult = ReturnType<typeof useGuardianCountSuspenseQuery>;
export type GuardianCountQueryResult = Apollo.QueryResult<GuardianCountQuery, GuardianCountQueryVariables>;
export const GuardianCreateDocument = gql`
	mutation guardianCreate($input: GuardianCreateInput!) {
		createGuardian(input: $input) {
			...GuardianDetail
		}
	}
	${GuardianDetailFragmentDoc}
`;
export type GuardianCreateMutationFn = Apollo.MutationFunction<GuardianCreateMutation, GuardianCreateMutationVariables>;

/**
 * __useGuardianCreateMutation__
 *
 * To run a mutation, you first call `useGuardianCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGuardianCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [guardianCreateMutation, { data, loading, error }] = useGuardianCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGuardianCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<GuardianCreateMutation, GuardianCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<GuardianCreateMutation, GuardianCreateMutationVariables>(GuardianCreateDocument, options);
}
export type GuardianCreateMutationHookResult = ReturnType<typeof useGuardianCreateMutation>;
export type GuardianCreateMutationResult = Apollo.MutationResult<GuardianCreateMutation>;
export type GuardianCreateMutationOptions = Apollo.BaseMutationOptions<
	GuardianCreateMutation,
	GuardianCreateMutationVariables
>;
export const GuardianDeleteDocument = gql`
	mutation guardianDelete($id: ID!) {
		deleteGuardian(id: $id)
	}
`;
export type GuardianDeleteMutationFn = Apollo.MutationFunction<GuardianDeleteMutation, GuardianDeleteMutationVariables>;

/**
 * __useGuardianDeleteMutation__
 *
 * To run a mutation, you first call `useGuardianDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGuardianDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [guardianDeleteMutation, { data, loading, error }] = useGuardianDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGuardianDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<GuardianDeleteMutation, GuardianDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<GuardianDeleteMutation, GuardianDeleteMutationVariables>(GuardianDeleteDocument, options);
}
export type GuardianDeleteMutationHookResult = ReturnType<typeof useGuardianDeleteMutation>;
export type GuardianDeleteMutationResult = Apollo.MutationResult<GuardianDeleteMutation>;
export type GuardianDeleteMutationOptions = Apollo.BaseMutationOptions<
	GuardianDeleteMutation,
	GuardianDeleteMutationVariables
>;
export const GuardianDetailDocument = gql`
	query guardianDetail($id: ID!) {
		guardian(id: $id) {
			...GuardianDetail
		}
	}
	${GuardianDetailFragmentDoc}
`;

/**
 * __useGuardianDetailQuery__
 *
 * To run a query within a React component, call `useGuardianDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuardianDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGuardianDetailQuery(
	baseOptions: Apollo.QueryHookOptions<GuardianDetailQuery, GuardianDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GuardianDetailQuery, GuardianDetailQueryVariables>(GuardianDetailDocument, options);
}
export function useGuardianDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GuardianDetailQuery, GuardianDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GuardianDetailQuery, GuardianDetailQueryVariables>(GuardianDetailDocument, options);
}
export function useGuardianDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<GuardianDetailQuery, GuardianDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GuardianDetailQuery, GuardianDetailQueryVariables>(GuardianDetailDocument, options);
}
export type GuardianDetailQueryHookResult = ReturnType<typeof useGuardianDetailQuery>;
export type GuardianDetailLazyQueryHookResult = ReturnType<typeof useGuardianDetailLazyQuery>;
export type GuardianDetailSuspenseQueryHookResult = ReturnType<typeof useGuardianDetailSuspenseQuery>;
export type GuardianDetailQueryResult = Apollo.QueryResult<GuardianDetailQuery, GuardianDetailQueryVariables>;
export const GuardianIndexDocument = gql`
	query guardianIndex($filters: [GuardianFilterInput!], $pagination: Pagination, $order: GuardianOrder) {
		guardianConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					relationshipStatus
					person {
						id
						...PersonNameAndImage
						gender
						dateOfBirth
						nationalities {
							id
							...CountryName
						}
						languages {
							id
							...LanguageName
						}
						englishLanguageFluency
						occupation
						addresses {
							id
							...AddressInformation
						}
						emailAddresses(order: { field: IS_PRIMARY, direction: DESC }) {
							id
							emailAddress
						}
						phoneNumbers(order: { field: IS_PRIMARY, direction: DESC }) {
							id
							phoneNumber
						}
					}
					relationships {
						id
						student {
							id
							...StudentName
						}
					}
				}
			}
		}
	}
	${PersonNameAndImageFragmentDoc}
	${CountryNameFragmentDoc}
	${LanguageNameFragmentDoc}
	${AddressInformationFragmentDoc}
	${StudentNameFragmentDoc}
`;

/**
 * __useGuardianIndexQuery__
 *
 * To run a query within a React component, call `useGuardianIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuardianIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGuardianIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<GuardianIndexQuery, GuardianIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GuardianIndexQuery, GuardianIndexQueryVariables>(GuardianIndexDocument, options);
}
export function useGuardianIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GuardianIndexQuery, GuardianIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GuardianIndexQuery, GuardianIndexQueryVariables>(GuardianIndexDocument, options);
}
export function useGuardianIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<GuardianIndexQuery, GuardianIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GuardianIndexQuery, GuardianIndexQueryVariables>(GuardianIndexDocument, options);
}
export type GuardianIndexQueryHookResult = ReturnType<typeof useGuardianIndexQuery>;
export type GuardianIndexLazyQueryHookResult = ReturnType<typeof useGuardianIndexLazyQuery>;
export type GuardianIndexSuspenseQueryHookResult = ReturnType<typeof useGuardianIndexSuspenseQuery>;
export type GuardianIndexQueryResult = Apollo.QueryResult<GuardianIndexQuery, GuardianIndexQueryVariables>;
export const GuardianNameDocument = gql`
	query guardianName($id: ID!) {
		guardian(id: $id) {
			id
			...GuardianName
		}
	}
	${GuardianNameFragmentDoc}
`;

/**
 * __useGuardianNameQuery__
 *
 * To run a query within a React component, call `useGuardianNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuardianNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGuardianNameQuery(
	baseOptions: Apollo.QueryHookOptions<GuardianNameQuery, GuardianNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GuardianNameQuery, GuardianNameQueryVariables>(GuardianNameDocument, options);
}
export function useGuardianNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GuardianNameQuery, GuardianNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GuardianNameQuery, GuardianNameQueryVariables>(GuardianNameDocument, options);
}
export function useGuardianNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<GuardianNameQuery, GuardianNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GuardianNameQuery, GuardianNameQueryVariables>(GuardianNameDocument, options);
}
export type GuardianNameQueryHookResult = ReturnType<typeof useGuardianNameQuery>;
export type GuardianNameLazyQueryHookResult = ReturnType<typeof useGuardianNameLazyQuery>;
export type GuardianNameSuspenseQueryHookResult = ReturnType<typeof useGuardianNameSuspenseQuery>;
export type GuardianNameQueryResult = Apollo.QueryResult<GuardianNameQuery, GuardianNameQueryVariables>;
export const GuardianNamesAndImagesDocument = gql`
	query guardianNamesAndImages($filters: [GuardianFilterInput!], $pagination: Pagination, $order: GuardianOrder) {
		guardianConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...GuardianNameAndImage
				}
			}
		}
	}
	${GuardianNameAndImageFragmentDoc}
`;

/**
 * __useGuardianNamesAndImagesQuery__
 *
 * To run a query within a React component, call `useGuardianNamesAndImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianNamesAndImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuardianNamesAndImagesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGuardianNamesAndImagesQuery(
	baseOptions?: Apollo.QueryHookOptions<GuardianNamesAndImagesQuery, GuardianNamesAndImagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GuardianNamesAndImagesQuery, GuardianNamesAndImagesQueryVariables>(
		GuardianNamesAndImagesDocument,
		options,
	);
}
export function useGuardianNamesAndImagesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GuardianNamesAndImagesQuery, GuardianNamesAndImagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GuardianNamesAndImagesQuery, GuardianNamesAndImagesQueryVariables>(
		GuardianNamesAndImagesDocument,
		options,
	);
}
export function useGuardianNamesAndImagesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<GuardianNamesAndImagesQuery, GuardianNamesAndImagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GuardianNamesAndImagesQuery, GuardianNamesAndImagesQueryVariables>(
		GuardianNamesAndImagesDocument,
		options,
	);
}
export type GuardianNamesAndImagesQueryHookResult = ReturnType<typeof useGuardianNamesAndImagesQuery>;
export type GuardianNamesAndImagesLazyQueryHookResult = ReturnType<typeof useGuardianNamesAndImagesLazyQuery>;
export type GuardianNamesAndImagesSuspenseQueryHookResult = ReturnType<typeof useGuardianNamesAndImagesSuspenseQuery>;
export type GuardianNamesAndImagesQueryResult = Apollo.QueryResult<
	GuardianNamesAndImagesQuery,
	GuardianNamesAndImagesQueryVariables
>;
export const GuardianNamesDocument = gql`
	query guardianNames($filters: [GuardianFilterInput!], $pagination: Pagination, $order: GuardianOrder) {
		guardianConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...GuardianName
				}
			}
		}
	}
	${GuardianNameFragmentDoc}
`;

/**
 * __useGuardianNamesQuery__
 *
 * To run a query within a React component, call `useGuardianNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuardianNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGuardianNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<GuardianNamesQuery, GuardianNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GuardianNamesQuery, GuardianNamesQueryVariables>(GuardianNamesDocument, options);
}
export function useGuardianNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GuardianNamesQuery, GuardianNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GuardianNamesQuery, GuardianNamesQueryVariables>(GuardianNamesDocument, options);
}
export function useGuardianNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<GuardianNamesQuery, GuardianNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GuardianNamesQuery, GuardianNamesQueryVariables>(GuardianNamesDocument, options);
}
export type GuardianNamesQueryHookResult = ReturnType<typeof useGuardianNamesQuery>;
export type GuardianNamesLazyQueryHookResult = ReturnType<typeof useGuardianNamesLazyQuery>;
export type GuardianNamesSuspenseQueryHookResult = ReturnType<typeof useGuardianNamesSuspenseQuery>;
export type GuardianNamesQueryResult = Apollo.QueryResult<GuardianNamesQuery, GuardianNamesQueryVariables>;
export const GuardianPaginationDocument = gql`
	query guardianPagination($filters: [GuardianFilterInput!], $order: GuardianOrder) {
		guardianConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useGuardianPaginationQuery__
 *
 * To run a query within a React component, call `useGuardianPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuardianPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGuardianPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<GuardianPaginationQuery, GuardianPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GuardianPaginationQuery, GuardianPaginationQueryVariables>(
		GuardianPaginationDocument,
		options,
	);
}
export function useGuardianPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GuardianPaginationQuery, GuardianPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GuardianPaginationQuery, GuardianPaginationQueryVariables>(
		GuardianPaginationDocument,
		options,
	);
}
export function useGuardianPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<GuardianPaginationQuery, GuardianPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GuardianPaginationQuery, GuardianPaginationQueryVariables>(
		GuardianPaginationDocument,
		options,
	);
}
export type GuardianPaginationQueryHookResult = ReturnType<typeof useGuardianPaginationQuery>;
export type GuardianPaginationLazyQueryHookResult = ReturnType<typeof useGuardianPaginationLazyQuery>;
export type GuardianPaginationSuspenseQueryHookResult = ReturnType<typeof useGuardianPaginationSuspenseQuery>;
export type GuardianPaginationQueryResult = Apollo.QueryResult<
	GuardianPaginationQuery,
	GuardianPaginationQueryVariables
>;
export const GuardianSelectDocument = gql`
	query guardianSelect($filters: [GuardianFilterInput!], $order: GuardianOrder) {
		guardianConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...GuardianName
				}
			}
		}
	}
	${GuardianNameFragmentDoc}
`;

/**
 * __useGuardianSelectQuery__
 *
 * To run a query within a React component, call `useGuardianSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuardianSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGuardianSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<GuardianSelectQuery, GuardianSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GuardianSelectQuery, GuardianSelectQueryVariables>(GuardianSelectDocument, options);
}
export function useGuardianSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GuardianSelectQuery, GuardianSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GuardianSelectQuery, GuardianSelectQueryVariables>(GuardianSelectDocument, options);
}
export function useGuardianSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<GuardianSelectQuery, GuardianSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GuardianSelectQuery, GuardianSelectQueryVariables>(GuardianSelectDocument, options);
}
export type GuardianSelectQueryHookResult = ReturnType<typeof useGuardianSelectQuery>;
export type GuardianSelectLazyQueryHookResult = ReturnType<typeof useGuardianSelectLazyQuery>;
export type GuardianSelectSuspenseQueryHookResult = ReturnType<typeof useGuardianSelectSuspenseQuery>;
export type GuardianSelectQueryResult = Apollo.QueryResult<GuardianSelectQuery, GuardianSelectQueryVariables>;
export const GuardianTooltipDocument = gql`
	query guardianTooltip($id: ID!) {
		guardian(id: $id) {
			id
			...GuardianNameAndImage
			relationships(order: { field: IS_PRIMARY, direction: DESC }) {
				id
				relationshipType
				student {
					id
					...StudentName
				}
			}
		}
	}
	${GuardianNameAndImageFragmentDoc}
	${StudentNameFragmentDoc}
`;

/**
 * __useGuardianTooltipQuery__
 *
 * To run a query within a React component, call `useGuardianTooltipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianTooltipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuardianTooltipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGuardianTooltipQuery(
	baseOptions: Apollo.QueryHookOptions<GuardianTooltipQuery, GuardianTooltipQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GuardianTooltipQuery, GuardianTooltipQueryVariables>(GuardianTooltipDocument, options);
}
export function useGuardianTooltipLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GuardianTooltipQuery, GuardianTooltipQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GuardianTooltipQuery, GuardianTooltipQueryVariables>(GuardianTooltipDocument, options);
}
export function useGuardianTooltipSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<GuardianTooltipQuery, GuardianTooltipQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GuardianTooltipQuery, GuardianTooltipQueryVariables>(GuardianTooltipDocument, options);
}
export type GuardianTooltipQueryHookResult = ReturnType<typeof useGuardianTooltipQuery>;
export type GuardianTooltipLazyQueryHookResult = ReturnType<typeof useGuardianTooltipLazyQuery>;
export type GuardianTooltipSuspenseQueryHookResult = ReturnType<typeof useGuardianTooltipSuspenseQuery>;
export type GuardianTooltipQueryResult = Apollo.QueryResult<GuardianTooltipQuery, GuardianTooltipQueryVariables>;
export const GuardianUpdateDocument = gql`
	mutation guardianUpdate($id: ID!, $input: GuardianUpdateInput!) {
		updateGuardian(id: $id, input: $input) {
			...GuardianDetail
		}
	}
	${GuardianDetailFragmentDoc}
`;
export type GuardianUpdateMutationFn = Apollo.MutationFunction<GuardianUpdateMutation, GuardianUpdateMutationVariables>;

/**
 * __useGuardianUpdateMutation__
 *
 * To run a mutation, you first call `useGuardianUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGuardianUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [guardianUpdateMutation, { data, loading, error }] = useGuardianUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGuardianUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<GuardianUpdateMutation, GuardianUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<GuardianUpdateMutation, GuardianUpdateMutationVariables>(GuardianUpdateDocument, options);
}
export type GuardianUpdateMutationHookResult = ReturnType<typeof useGuardianUpdateMutation>;
export type GuardianUpdateMutationResult = Apollo.MutationResult<GuardianUpdateMutation>;
export type GuardianUpdateMutationOptions = Apollo.BaseMutationOptions<
	GuardianUpdateMutation,
	GuardianUpdateMutationVariables
>;
export const HomeRoomCountDocument = gql`
	query homeRoomCount($filters: [HomeRoomFilterInput!], $pagination: Pagination, $order: HomeRoomOrder) {
		homeRoomConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useHomeRoomCountQuery__
 *
 * To run a query within a React component, call `useHomeRoomCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRoomCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHomeRoomCountQuery(
	baseOptions?: Apollo.QueryHookOptions<HomeRoomCountQuery, HomeRoomCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<HomeRoomCountQuery, HomeRoomCountQueryVariables>(HomeRoomCountDocument, options);
}
export function useHomeRoomCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<HomeRoomCountQuery, HomeRoomCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<HomeRoomCountQuery, HomeRoomCountQueryVariables>(HomeRoomCountDocument, options);
}
export function useHomeRoomCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<HomeRoomCountQuery, HomeRoomCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<HomeRoomCountQuery, HomeRoomCountQueryVariables>(HomeRoomCountDocument, options);
}
export type HomeRoomCountQueryHookResult = ReturnType<typeof useHomeRoomCountQuery>;
export type HomeRoomCountLazyQueryHookResult = ReturnType<typeof useHomeRoomCountLazyQuery>;
export type HomeRoomCountSuspenseQueryHookResult = ReturnType<typeof useHomeRoomCountSuspenseQuery>;
export type HomeRoomCountQueryResult = Apollo.QueryResult<HomeRoomCountQuery, HomeRoomCountQueryVariables>;
export const HomeRoomCreateDocument = gql`
	mutation homeRoomCreate($input: HomeRoomCreateInput!) {
		createHomeRoom(input: $input) {
			...HomeRoomDetail
		}
	}
	${HomeRoomDetailFragmentDoc}
`;
export type HomeRoomCreateMutationFn = Apollo.MutationFunction<HomeRoomCreateMutation, HomeRoomCreateMutationVariables>;

/**
 * __useHomeRoomCreateMutation__
 *
 * To run a mutation, you first call `useHomeRoomCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [homeRoomCreateMutation, { data, loading, error }] = useHomeRoomCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHomeRoomCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<HomeRoomCreateMutation, HomeRoomCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<HomeRoomCreateMutation, HomeRoomCreateMutationVariables>(HomeRoomCreateDocument, options);
}
export type HomeRoomCreateMutationHookResult = ReturnType<typeof useHomeRoomCreateMutation>;
export type HomeRoomCreateMutationResult = Apollo.MutationResult<HomeRoomCreateMutation>;
export type HomeRoomCreateMutationOptions = Apollo.BaseMutationOptions<
	HomeRoomCreateMutation,
	HomeRoomCreateMutationVariables
>;
export const HomeRoomDeleteDocument = gql`
	mutation homeRoomDelete($id: ID!) {
		deleteHomeRoom(id: $id)
	}
`;
export type HomeRoomDeleteMutationFn = Apollo.MutationFunction<HomeRoomDeleteMutation, HomeRoomDeleteMutationVariables>;

/**
 * __useHomeRoomDeleteMutation__
 *
 * To run a mutation, you first call `useHomeRoomDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [homeRoomDeleteMutation, { data, loading, error }] = useHomeRoomDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHomeRoomDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<HomeRoomDeleteMutation, HomeRoomDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<HomeRoomDeleteMutation, HomeRoomDeleteMutationVariables>(HomeRoomDeleteDocument, options);
}
export type HomeRoomDeleteMutationHookResult = ReturnType<typeof useHomeRoomDeleteMutation>;
export type HomeRoomDeleteMutationResult = Apollo.MutationResult<HomeRoomDeleteMutation>;
export type HomeRoomDeleteMutationOptions = Apollo.BaseMutationOptions<
	HomeRoomDeleteMutation,
	HomeRoomDeleteMutationVariables
>;
export const HomeRoomDetailDocument = gql`
	query homeRoomDetail($id: ID!) {
		homeRoom(id: $id) {
			...HomeRoomDetail
		}
	}
	${HomeRoomDetailFragmentDoc}
`;

/**
 * __useHomeRoomDetailQuery__
 *
 * To run a query within a React component, call `useHomeRoomDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRoomDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHomeRoomDetailQuery(
	baseOptions: Apollo.QueryHookOptions<HomeRoomDetailQuery, HomeRoomDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<HomeRoomDetailQuery, HomeRoomDetailQueryVariables>(HomeRoomDetailDocument, options);
}
export function useHomeRoomDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<HomeRoomDetailQuery, HomeRoomDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<HomeRoomDetailQuery, HomeRoomDetailQueryVariables>(HomeRoomDetailDocument, options);
}
export function useHomeRoomDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<HomeRoomDetailQuery, HomeRoomDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<HomeRoomDetailQuery, HomeRoomDetailQueryVariables>(HomeRoomDetailDocument, options);
}
export type HomeRoomDetailQueryHookResult = ReturnType<typeof useHomeRoomDetailQuery>;
export type HomeRoomDetailLazyQueryHookResult = ReturnType<typeof useHomeRoomDetailLazyQuery>;
export type HomeRoomDetailSuspenseQueryHookResult = ReturnType<typeof useHomeRoomDetailSuspenseQuery>;
export type HomeRoomDetailQueryResult = Apollo.QueryResult<HomeRoomDetailQuery, HomeRoomDetailQueryVariables>;
export const HomeRoomIndexDocument = gql`
	query homeRoomIndex($filters: [HomeRoomFilterInput!], $pagination: Pagination, $order: HomeRoomOrder) {
		homeRoomConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					description
					classYear {
						id
						...ClassYearName
					}
				}
			}
		}
	}
	${ClassYearNameFragmentDoc}
`;

/**
 * __useHomeRoomIndexQuery__
 *
 * To run a query within a React component, call `useHomeRoomIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRoomIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHomeRoomIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<HomeRoomIndexQuery, HomeRoomIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<HomeRoomIndexQuery, HomeRoomIndexQueryVariables>(HomeRoomIndexDocument, options);
}
export function useHomeRoomIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<HomeRoomIndexQuery, HomeRoomIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<HomeRoomIndexQuery, HomeRoomIndexQueryVariables>(HomeRoomIndexDocument, options);
}
export function useHomeRoomIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<HomeRoomIndexQuery, HomeRoomIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<HomeRoomIndexQuery, HomeRoomIndexQueryVariables>(HomeRoomIndexDocument, options);
}
export type HomeRoomIndexQueryHookResult = ReturnType<typeof useHomeRoomIndexQuery>;
export type HomeRoomIndexLazyQueryHookResult = ReturnType<typeof useHomeRoomIndexLazyQuery>;
export type HomeRoomIndexSuspenseQueryHookResult = ReturnType<typeof useHomeRoomIndexSuspenseQuery>;
export type HomeRoomIndexQueryResult = Apollo.QueryResult<HomeRoomIndexQuery, HomeRoomIndexQueryVariables>;
export const HomeRoomNameDocument = gql`
	query homeRoomName($id: ID!) {
		homeRoom(id: $id) {
			id
			...HomeRoomName
		}
	}
	${HomeRoomNameFragmentDoc}
`;

/**
 * __useHomeRoomNameQuery__
 *
 * To run a query within a React component, call `useHomeRoomNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRoomNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHomeRoomNameQuery(
	baseOptions: Apollo.QueryHookOptions<HomeRoomNameQuery, HomeRoomNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<HomeRoomNameQuery, HomeRoomNameQueryVariables>(HomeRoomNameDocument, options);
}
export function useHomeRoomNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<HomeRoomNameQuery, HomeRoomNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<HomeRoomNameQuery, HomeRoomNameQueryVariables>(HomeRoomNameDocument, options);
}
export function useHomeRoomNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<HomeRoomNameQuery, HomeRoomNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<HomeRoomNameQuery, HomeRoomNameQueryVariables>(HomeRoomNameDocument, options);
}
export type HomeRoomNameQueryHookResult = ReturnType<typeof useHomeRoomNameQuery>;
export type HomeRoomNameLazyQueryHookResult = ReturnType<typeof useHomeRoomNameLazyQuery>;
export type HomeRoomNameSuspenseQueryHookResult = ReturnType<typeof useHomeRoomNameSuspenseQuery>;
export type HomeRoomNameQueryResult = Apollo.QueryResult<HomeRoomNameQuery, HomeRoomNameQueryVariables>;
export const HomeRoomNamesDocument = gql`
	query homeRoomNames($filters: [HomeRoomFilterInput!], $pagination: Pagination, $order: HomeRoomOrder) {
		homeRoomConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...HomeRoomName
				}
			}
		}
	}
	${HomeRoomNameFragmentDoc}
`;

/**
 * __useHomeRoomNamesQuery__
 *
 * To run a query within a React component, call `useHomeRoomNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRoomNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHomeRoomNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<HomeRoomNamesQuery, HomeRoomNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<HomeRoomNamesQuery, HomeRoomNamesQueryVariables>(HomeRoomNamesDocument, options);
}
export function useHomeRoomNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<HomeRoomNamesQuery, HomeRoomNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<HomeRoomNamesQuery, HomeRoomNamesQueryVariables>(HomeRoomNamesDocument, options);
}
export function useHomeRoomNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<HomeRoomNamesQuery, HomeRoomNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<HomeRoomNamesQuery, HomeRoomNamesQueryVariables>(HomeRoomNamesDocument, options);
}
export type HomeRoomNamesQueryHookResult = ReturnType<typeof useHomeRoomNamesQuery>;
export type HomeRoomNamesLazyQueryHookResult = ReturnType<typeof useHomeRoomNamesLazyQuery>;
export type HomeRoomNamesSuspenseQueryHookResult = ReturnType<typeof useHomeRoomNamesSuspenseQuery>;
export type HomeRoomNamesQueryResult = Apollo.QueryResult<HomeRoomNamesQuery, HomeRoomNamesQueryVariables>;
export const HomeRoomPaginationDocument = gql`
	query homeRoomPagination($filters: [HomeRoomFilterInput!], $order: HomeRoomOrder) {
		homeRoomConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useHomeRoomPaginationQuery__
 *
 * To run a query within a React component, call `useHomeRoomPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRoomPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHomeRoomPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<HomeRoomPaginationQuery, HomeRoomPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<HomeRoomPaginationQuery, HomeRoomPaginationQueryVariables>(
		HomeRoomPaginationDocument,
		options,
	);
}
export function useHomeRoomPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<HomeRoomPaginationQuery, HomeRoomPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<HomeRoomPaginationQuery, HomeRoomPaginationQueryVariables>(
		HomeRoomPaginationDocument,
		options,
	);
}
export function useHomeRoomPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<HomeRoomPaginationQuery, HomeRoomPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<HomeRoomPaginationQuery, HomeRoomPaginationQueryVariables>(
		HomeRoomPaginationDocument,
		options,
	);
}
export type HomeRoomPaginationQueryHookResult = ReturnType<typeof useHomeRoomPaginationQuery>;
export type HomeRoomPaginationLazyQueryHookResult = ReturnType<typeof useHomeRoomPaginationLazyQuery>;
export type HomeRoomPaginationSuspenseQueryHookResult = ReturnType<typeof useHomeRoomPaginationSuspenseQuery>;
export type HomeRoomPaginationQueryResult = Apollo.QueryResult<
	HomeRoomPaginationQuery,
	HomeRoomPaginationQueryVariables
>;
export const HomeRoomSelectDocument = gql`
	query homeRoomSelect($filters: [HomeRoomFilterInput!], $order: HomeRoomOrder) {
		homeRoomConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...HomeRoomName
				}
			}
		}
	}
	${HomeRoomNameFragmentDoc}
`;

/**
 * __useHomeRoomSelectQuery__
 *
 * To run a query within a React component, call `useHomeRoomSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRoomSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHomeRoomSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<HomeRoomSelectQuery, HomeRoomSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<HomeRoomSelectQuery, HomeRoomSelectQueryVariables>(HomeRoomSelectDocument, options);
}
export function useHomeRoomSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<HomeRoomSelectQuery, HomeRoomSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<HomeRoomSelectQuery, HomeRoomSelectQueryVariables>(HomeRoomSelectDocument, options);
}
export function useHomeRoomSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<HomeRoomSelectQuery, HomeRoomSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<HomeRoomSelectQuery, HomeRoomSelectQueryVariables>(HomeRoomSelectDocument, options);
}
export type HomeRoomSelectQueryHookResult = ReturnType<typeof useHomeRoomSelectQuery>;
export type HomeRoomSelectLazyQueryHookResult = ReturnType<typeof useHomeRoomSelectLazyQuery>;
export type HomeRoomSelectSuspenseQueryHookResult = ReturnType<typeof useHomeRoomSelectSuspenseQuery>;
export type HomeRoomSelectQueryResult = Apollo.QueryResult<HomeRoomSelectQuery, HomeRoomSelectQueryVariables>;
export const HomeRoomUpdateDocument = gql`
	mutation homeRoomUpdate($id: ID!, $input: HomeRoomUpdateInput!) {
		updateHomeRoom(id: $id, input: $input) {
			...HomeRoomDetail
		}
	}
	${HomeRoomDetailFragmentDoc}
`;
export type HomeRoomUpdateMutationFn = Apollo.MutationFunction<HomeRoomUpdateMutation, HomeRoomUpdateMutationVariables>;

/**
 * __useHomeRoomUpdateMutation__
 *
 * To run a mutation, you first call `useHomeRoomUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [homeRoomUpdateMutation, { data, loading, error }] = useHomeRoomUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHomeRoomUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<HomeRoomUpdateMutation, HomeRoomUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<HomeRoomUpdateMutation, HomeRoomUpdateMutationVariables>(HomeRoomUpdateDocument, options);
}
export type HomeRoomUpdateMutationHookResult = ReturnType<typeof useHomeRoomUpdateMutation>;
export type HomeRoomUpdateMutationResult = Apollo.MutationResult<HomeRoomUpdateMutation>;
export type HomeRoomUpdateMutationOptions = Apollo.BaseMutationOptions<
	HomeRoomUpdateMutation,
	HomeRoomUpdateMutationVariables
>;
export const HomeRoomSectionCountDocument = gql`
	query homeRoomSectionCount(
		$filters: [HomeRoomSectionFilterInput!]
		$pagination: Pagination
		$order: HomeRoomSectionOrder
	) {
		homeRoomSectionConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useHomeRoomSectionCountQuery__
 *
 * To run a query within a React component, call `useHomeRoomSectionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomSectionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRoomSectionCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHomeRoomSectionCountQuery(
	baseOptions?: Apollo.QueryHookOptions<HomeRoomSectionCountQuery, HomeRoomSectionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<HomeRoomSectionCountQuery, HomeRoomSectionCountQueryVariables>(
		HomeRoomSectionCountDocument,
		options,
	);
}
export function useHomeRoomSectionCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<HomeRoomSectionCountQuery, HomeRoomSectionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<HomeRoomSectionCountQuery, HomeRoomSectionCountQueryVariables>(
		HomeRoomSectionCountDocument,
		options,
	);
}
export function useHomeRoomSectionCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<HomeRoomSectionCountQuery, HomeRoomSectionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<HomeRoomSectionCountQuery, HomeRoomSectionCountQueryVariables>(
		HomeRoomSectionCountDocument,
		options,
	);
}
export type HomeRoomSectionCountQueryHookResult = ReturnType<typeof useHomeRoomSectionCountQuery>;
export type HomeRoomSectionCountLazyQueryHookResult = ReturnType<typeof useHomeRoomSectionCountLazyQuery>;
export type HomeRoomSectionCountSuspenseQueryHookResult = ReturnType<typeof useHomeRoomSectionCountSuspenseQuery>;
export type HomeRoomSectionCountQueryResult = Apollo.QueryResult<
	HomeRoomSectionCountQuery,
	HomeRoomSectionCountQueryVariables
>;
export const HomeRoomSectionCreateDocument = gql`
	mutation homeRoomSectionCreate($input: HomeRoomSectionCreateInput!) {
		createHomeRoomSection(input: $input) {
			...HomeRoomSectionDetail
		}
	}
	${HomeRoomSectionDetailFragmentDoc}
`;
export type HomeRoomSectionCreateMutationFn = Apollo.MutationFunction<
	HomeRoomSectionCreateMutation,
	HomeRoomSectionCreateMutationVariables
>;

/**
 * __useHomeRoomSectionCreateMutation__
 *
 * To run a mutation, you first call `useHomeRoomSectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomSectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [homeRoomSectionCreateMutation, { data, loading, error }] = useHomeRoomSectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHomeRoomSectionCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<HomeRoomSectionCreateMutation, HomeRoomSectionCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<HomeRoomSectionCreateMutation, HomeRoomSectionCreateMutationVariables>(
		HomeRoomSectionCreateDocument,
		options,
	);
}
export type HomeRoomSectionCreateMutationHookResult = ReturnType<typeof useHomeRoomSectionCreateMutation>;
export type HomeRoomSectionCreateMutationResult = Apollo.MutationResult<HomeRoomSectionCreateMutation>;
export type HomeRoomSectionCreateMutationOptions = Apollo.BaseMutationOptions<
	HomeRoomSectionCreateMutation,
	HomeRoomSectionCreateMutationVariables
>;
export const HomeRoomSectionDeleteDocument = gql`
	mutation homeRoomSectionDelete($id: ID!) {
		deleteHomeRoomSection(id: $id)
	}
`;
export type HomeRoomSectionDeleteMutationFn = Apollo.MutationFunction<
	HomeRoomSectionDeleteMutation,
	HomeRoomSectionDeleteMutationVariables
>;

/**
 * __useHomeRoomSectionDeleteMutation__
 *
 * To run a mutation, you first call `useHomeRoomSectionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomSectionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [homeRoomSectionDeleteMutation, { data, loading, error }] = useHomeRoomSectionDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHomeRoomSectionDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<HomeRoomSectionDeleteMutation, HomeRoomSectionDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<HomeRoomSectionDeleteMutation, HomeRoomSectionDeleteMutationVariables>(
		HomeRoomSectionDeleteDocument,
		options,
	);
}
export type HomeRoomSectionDeleteMutationHookResult = ReturnType<typeof useHomeRoomSectionDeleteMutation>;
export type HomeRoomSectionDeleteMutationResult = Apollo.MutationResult<HomeRoomSectionDeleteMutation>;
export type HomeRoomSectionDeleteMutationOptions = Apollo.BaseMutationOptions<
	HomeRoomSectionDeleteMutation,
	HomeRoomSectionDeleteMutationVariables
>;
export const HomeRoomSectionDetailDocument = gql`
	query homeRoomSectionDetail($id: ID!) {
		homeRoomSection(id: $id) {
			...HomeRoomSectionDetail
		}
	}
	${HomeRoomSectionDetailFragmentDoc}
`;

/**
 * __useHomeRoomSectionDetailQuery__
 *
 * To run a query within a React component, call `useHomeRoomSectionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomSectionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRoomSectionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHomeRoomSectionDetailQuery(
	baseOptions: Apollo.QueryHookOptions<HomeRoomSectionDetailQuery, HomeRoomSectionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<HomeRoomSectionDetailQuery, HomeRoomSectionDetailQueryVariables>(
		HomeRoomSectionDetailDocument,
		options,
	);
}
export function useHomeRoomSectionDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<HomeRoomSectionDetailQuery, HomeRoomSectionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<HomeRoomSectionDetailQuery, HomeRoomSectionDetailQueryVariables>(
		HomeRoomSectionDetailDocument,
		options,
	);
}
export function useHomeRoomSectionDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<HomeRoomSectionDetailQuery, HomeRoomSectionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<HomeRoomSectionDetailQuery, HomeRoomSectionDetailQueryVariables>(
		HomeRoomSectionDetailDocument,
		options,
	);
}
export type HomeRoomSectionDetailQueryHookResult = ReturnType<typeof useHomeRoomSectionDetailQuery>;
export type HomeRoomSectionDetailLazyQueryHookResult = ReturnType<typeof useHomeRoomSectionDetailLazyQuery>;
export type HomeRoomSectionDetailSuspenseQueryHookResult = ReturnType<typeof useHomeRoomSectionDetailSuspenseQuery>;
export type HomeRoomSectionDetailQueryResult = Apollo.QueryResult<
	HomeRoomSectionDetailQuery,
	HomeRoomSectionDetailQueryVariables
>;
export const HomeRoomSectionIndexDocument = gql`
	query homeRoomSectionIndex(
		$filters: [HomeRoomSectionFilterInput!]
		$pagination: Pagination
		$order: HomeRoomSectionOrder
	) {
		homeRoomSectionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					namePrefix
					nameSuffix
					academicTerm {
						id
						...AcademicTermName
						startDate
						endDate
					}
					homeRoom {
						id
						...HomeRoomName
						classYear {
							id
							...ClassYearName
						}
					}
					studentHomeRoomSectionEnrollments {
						id
						lateStartDate
						earlyEndDate
					}
					teacherHomeRoomSectionEnrollments {
						id
						lateStartDate
						earlyEndDate
						teacher {
							id
							...EmployeeName
						}
					}
				}
			}
		}
	}
	${AcademicTermNameFragmentDoc}
	${HomeRoomNameFragmentDoc}
	${ClassYearNameFragmentDoc}
	${EmployeeNameFragmentDoc}
`;

/**
 * __useHomeRoomSectionIndexQuery__
 *
 * To run a query within a React component, call `useHomeRoomSectionIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomSectionIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRoomSectionIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHomeRoomSectionIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<HomeRoomSectionIndexQuery, HomeRoomSectionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<HomeRoomSectionIndexQuery, HomeRoomSectionIndexQueryVariables>(
		HomeRoomSectionIndexDocument,
		options,
	);
}
export function useHomeRoomSectionIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<HomeRoomSectionIndexQuery, HomeRoomSectionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<HomeRoomSectionIndexQuery, HomeRoomSectionIndexQueryVariables>(
		HomeRoomSectionIndexDocument,
		options,
	);
}
export function useHomeRoomSectionIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<HomeRoomSectionIndexQuery, HomeRoomSectionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<HomeRoomSectionIndexQuery, HomeRoomSectionIndexQueryVariables>(
		HomeRoomSectionIndexDocument,
		options,
	);
}
export type HomeRoomSectionIndexQueryHookResult = ReturnType<typeof useHomeRoomSectionIndexQuery>;
export type HomeRoomSectionIndexLazyQueryHookResult = ReturnType<typeof useHomeRoomSectionIndexLazyQuery>;
export type HomeRoomSectionIndexSuspenseQueryHookResult = ReturnType<typeof useHomeRoomSectionIndexSuspenseQuery>;
export type HomeRoomSectionIndexQueryResult = Apollo.QueryResult<
	HomeRoomSectionIndexQuery,
	HomeRoomSectionIndexQueryVariables
>;
export const HomeRoomSectionListDocument = gql`
	query homeRoomSectionList(
		$filters: [HomeRoomSectionFilterInput!]
		$pagination: Pagination
		$order: HomeRoomSectionOrder
	) {
		homeRoomSectionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...HomeRoomSectionName
					studentHomeRoomSectionEnrollments {
						id
						lateStartDate
						earlyEndDate
						student {
							id
							...StudentName
						}
					}
					teacherHomeRoomSectionEnrollments {
						id
						teacher {
							id
							...EmployeeName
						}
					}
				}
			}
		}
	}
	${HomeRoomSectionNameFragmentDoc}
	${StudentNameFragmentDoc}
	${EmployeeNameFragmentDoc}
`;

/**
 * __useHomeRoomSectionListQuery__
 *
 * To run a query within a React component, call `useHomeRoomSectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomSectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRoomSectionListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHomeRoomSectionListQuery(
	baseOptions?: Apollo.QueryHookOptions<HomeRoomSectionListQuery, HomeRoomSectionListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<HomeRoomSectionListQuery, HomeRoomSectionListQueryVariables>(
		HomeRoomSectionListDocument,
		options,
	);
}
export function useHomeRoomSectionListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<HomeRoomSectionListQuery, HomeRoomSectionListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<HomeRoomSectionListQuery, HomeRoomSectionListQueryVariables>(
		HomeRoomSectionListDocument,
		options,
	);
}
export function useHomeRoomSectionListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<HomeRoomSectionListQuery, HomeRoomSectionListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<HomeRoomSectionListQuery, HomeRoomSectionListQueryVariables>(
		HomeRoomSectionListDocument,
		options,
	);
}
export type HomeRoomSectionListQueryHookResult = ReturnType<typeof useHomeRoomSectionListQuery>;
export type HomeRoomSectionListLazyQueryHookResult = ReturnType<typeof useHomeRoomSectionListLazyQuery>;
export type HomeRoomSectionListSuspenseQueryHookResult = ReturnType<typeof useHomeRoomSectionListSuspenseQuery>;
export type HomeRoomSectionListQueryResult = Apollo.QueryResult<
	HomeRoomSectionListQuery,
	HomeRoomSectionListQueryVariables
>;
export const HomeRoomSectionNamesAndTeachersListDocument = gql`
	query homeRoomSectionNamesAndTeachersList(
		$filters: [HomeRoomSectionFilterInput!]
		$pagination: Pagination
		$order: HomeRoomSectionOrder
	) {
		homeRoomSectionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...HomeRoomSectionName
					teacherHomeRoomSectionEnrollments {
						id
						teacher {
							id
							...EmployeeName
						}
					}
				}
			}
		}
	}
	${HomeRoomSectionNameFragmentDoc}
	${EmployeeNameFragmentDoc}
`;

/**
 * __useHomeRoomSectionNamesAndTeachersListQuery__
 *
 * To run a query within a React component, call `useHomeRoomSectionNamesAndTeachersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomSectionNamesAndTeachersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRoomSectionNamesAndTeachersListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHomeRoomSectionNamesAndTeachersListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		HomeRoomSectionNamesAndTeachersListQuery,
		HomeRoomSectionNamesAndTeachersListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<HomeRoomSectionNamesAndTeachersListQuery, HomeRoomSectionNamesAndTeachersListQueryVariables>(
		HomeRoomSectionNamesAndTeachersListDocument,
		options,
	);
}
export function useHomeRoomSectionNamesAndTeachersListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		HomeRoomSectionNamesAndTeachersListQuery,
		HomeRoomSectionNamesAndTeachersListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		HomeRoomSectionNamesAndTeachersListQuery,
		HomeRoomSectionNamesAndTeachersListQueryVariables
	>(HomeRoomSectionNamesAndTeachersListDocument, options);
}
export function useHomeRoomSectionNamesAndTeachersListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		HomeRoomSectionNamesAndTeachersListQuery,
		HomeRoomSectionNamesAndTeachersListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		HomeRoomSectionNamesAndTeachersListQuery,
		HomeRoomSectionNamesAndTeachersListQueryVariables
	>(HomeRoomSectionNamesAndTeachersListDocument, options);
}
export type HomeRoomSectionNamesAndTeachersListQueryHookResult = ReturnType<
	typeof useHomeRoomSectionNamesAndTeachersListQuery
>;
export type HomeRoomSectionNamesAndTeachersListLazyQueryHookResult = ReturnType<
	typeof useHomeRoomSectionNamesAndTeachersListLazyQuery
>;
export type HomeRoomSectionNamesAndTeachersListSuspenseQueryHookResult = ReturnType<
	typeof useHomeRoomSectionNamesAndTeachersListSuspenseQuery
>;
export type HomeRoomSectionNamesAndTeachersListQueryResult = Apollo.QueryResult<
	HomeRoomSectionNamesAndTeachersListQuery,
	HomeRoomSectionNamesAndTeachersListQueryVariables
>;
export const HomeRoomSectionNameDocument = gql`
	query homeRoomSectionName($id: ID!) {
		homeRoomSection(id: $id) {
			id
			...HomeRoomSectionName
		}
	}
	${HomeRoomSectionNameFragmentDoc}
`;

/**
 * __useHomeRoomSectionNameQuery__
 *
 * To run a query within a React component, call `useHomeRoomSectionNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomSectionNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRoomSectionNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHomeRoomSectionNameQuery(
	baseOptions: Apollo.QueryHookOptions<HomeRoomSectionNameQuery, HomeRoomSectionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<HomeRoomSectionNameQuery, HomeRoomSectionNameQueryVariables>(
		HomeRoomSectionNameDocument,
		options,
	);
}
export function useHomeRoomSectionNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<HomeRoomSectionNameQuery, HomeRoomSectionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<HomeRoomSectionNameQuery, HomeRoomSectionNameQueryVariables>(
		HomeRoomSectionNameDocument,
		options,
	);
}
export function useHomeRoomSectionNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<HomeRoomSectionNameQuery, HomeRoomSectionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<HomeRoomSectionNameQuery, HomeRoomSectionNameQueryVariables>(
		HomeRoomSectionNameDocument,
		options,
	);
}
export type HomeRoomSectionNameQueryHookResult = ReturnType<typeof useHomeRoomSectionNameQuery>;
export type HomeRoomSectionNameLazyQueryHookResult = ReturnType<typeof useHomeRoomSectionNameLazyQuery>;
export type HomeRoomSectionNameSuspenseQueryHookResult = ReturnType<typeof useHomeRoomSectionNameSuspenseQuery>;
export type HomeRoomSectionNameQueryResult = Apollo.QueryResult<
	HomeRoomSectionNameQuery,
	HomeRoomSectionNameQueryVariables
>;
export const HomeRoomSectionNamesAndTeachersDocument = gql`
	query homeRoomSectionNamesAndTeachers(
		$filters: [HomeRoomSectionFilterInput!]
		$pagination: Pagination
		$order: HomeRoomSectionOrder
	) {
		homeRoomSectionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...HomeRoomSectionName
					teacherHomeRoomSectionEnrollments {
						id
						teacher {
							id
							...EmployeeName
						}
					}
				}
			}
		}
	}
	${HomeRoomSectionNameFragmentDoc}
	${EmployeeNameFragmentDoc}
`;

/**
 * __useHomeRoomSectionNamesAndTeachersQuery__
 *
 * To run a query within a React component, call `useHomeRoomSectionNamesAndTeachersQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomSectionNamesAndTeachersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRoomSectionNamesAndTeachersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHomeRoomSectionNamesAndTeachersQuery(
	baseOptions?: Apollo.QueryHookOptions<
		HomeRoomSectionNamesAndTeachersQuery,
		HomeRoomSectionNamesAndTeachersQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<HomeRoomSectionNamesAndTeachersQuery, HomeRoomSectionNamesAndTeachersQueryVariables>(
		HomeRoomSectionNamesAndTeachersDocument,
		options,
	);
}
export function useHomeRoomSectionNamesAndTeachersLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		HomeRoomSectionNamesAndTeachersQuery,
		HomeRoomSectionNamesAndTeachersQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<HomeRoomSectionNamesAndTeachersQuery, HomeRoomSectionNamesAndTeachersQueryVariables>(
		HomeRoomSectionNamesAndTeachersDocument,
		options,
	);
}
export function useHomeRoomSectionNamesAndTeachersSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		HomeRoomSectionNamesAndTeachersQuery,
		HomeRoomSectionNamesAndTeachersQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<HomeRoomSectionNamesAndTeachersQuery, HomeRoomSectionNamesAndTeachersQueryVariables>(
		HomeRoomSectionNamesAndTeachersDocument,
		options,
	);
}
export type HomeRoomSectionNamesAndTeachersQueryHookResult = ReturnType<typeof useHomeRoomSectionNamesAndTeachersQuery>;
export type HomeRoomSectionNamesAndTeachersLazyQueryHookResult = ReturnType<
	typeof useHomeRoomSectionNamesAndTeachersLazyQuery
>;
export type HomeRoomSectionNamesAndTeachersSuspenseQueryHookResult = ReturnType<
	typeof useHomeRoomSectionNamesAndTeachersSuspenseQuery
>;
export type HomeRoomSectionNamesAndTeachersQueryResult = Apollo.QueryResult<
	HomeRoomSectionNamesAndTeachersQuery,
	HomeRoomSectionNamesAndTeachersQueryVariables
>;
export const HomeRoomSectionNamesDocument = gql`
	query homeRoomSectionNames(
		$filters: [HomeRoomSectionFilterInput!]
		$pagination: Pagination
		$order: HomeRoomSectionOrder
	) {
		homeRoomSectionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...HomeRoomSectionName
				}
			}
		}
	}
	${HomeRoomSectionNameFragmentDoc}
`;

/**
 * __useHomeRoomSectionNamesQuery__
 *
 * To run a query within a React component, call `useHomeRoomSectionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomSectionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRoomSectionNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHomeRoomSectionNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<HomeRoomSectionNamesQuery, HomeRoomSectionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<HomeRoomSectionNamesQuery, HomeRoomSectionNamesQueryVariables>(
		HomeRoomSectionNamesDocument,
		options,
	);
}
export function useHomeRoomSectionNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<HomeRoomSectionNamesQuery, HomeRoomSectionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<HomeRoomSectionNamesQuery, HomeRoomSectionNamesQueryVariables>(
		HomeRoomSectionNamesDocument,
		options,
	);
}
export function useHomeRoomSectionNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<HomeRoomSectionNamesQuery, HomeRoomSectionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<HomeRoomSectionNamesQuery, HomeRoomSectionNamesQueryVariables>(
		HomeRoomSectionNamesDocument,
		options,
	);
}
export type HomeRoomSectionNamesQueryHookResult = ReturnType<typeof useHomeRoomSectionNamesQuery>;
export type HomeRoomSectionNamesLazyQueryHookResult = ReturnType<typeof useHomeRoomSectionNamesLazyQuery>;
export type HomeRoomSectionNamesSuspenseQueryHookResult = ReturnType<typeof useHomeRoomSectionNamesSuspenseQuery>;
export type HomeRoomSectionNamesQueryResult = Apollo.QueryResult<
	HomeRoomSectionNamesQuery,
	HomeRoomSectionNamesQueryVariables
>;
export const HomeRoomSectionPaginationDocument = gql`
	query homeRoomSectionPagination($filters: [HomeRoomSectionFilterInput!], $order: HomeRoomSectionOrder) {
		homeRoomSectionConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useHomeRoomSectionPaginationQuery__
 *
 * To run a query within a React component, call `useHomeRoomSectionPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomSectionPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRoomSectionPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHomeRoomSectionPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<HomeRoomSectionPaginationQuery, HomeRoomSectionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<HomeRoomSectionPaginationQuery, HomeRoomSectionPaginationQueryVariables>(
		HomeRoomSectionPaginationDocument,
		options,
	);
}
export function useHomeRoomSectionPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<HomeRoomSectionPaginationQuery, HomeRoomSectionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<HomeRoomSectionPaginationQuery, HomeRoomSectionPaginationQueryVariables>(
		HomeRoomSectionPaginationDocument,
		options,
	);
}
export function useHomeRoomSectionPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		HomeRoomSectionPaginationQuery,
		HomeRoomSectionPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<HomeRoomSectionPaginationQuery, HomeRoomSectionPaginationQueryVariables>(
		HomeRoomSectionPaginationDocument,
		options,
	);
}
export type HomeRoomSectionPaginationQueryHookResult = ReturnType<typeof useHomeRoomSectionPaginationQuery>;
export type HomeRoomSectionPaginationLazyQueryHookResult = ReturnType<typeof useHomeRoomSectionPaginationLazyQuery>;
export type HomeRoomSectionPaginationSuspenseQueryHookResult = ReturnType<
	typeof useHomeRoomSectionPaginationSuspenseQuery
>;
export type HomeRoomSectionPaginationQueryResult = Apollo.QueryResult<
	HomeRoomSectionPaginationQuery,
	HomeRoomSectionPaginationQueryVariables
>;
export const HomeRoomSectionSelectDocument = gql`
	query homeRoomSectionSelect($filters: [HomeRoomSectionFilterInput!], $order: HomeRoomSectionOrder) {
		homeRoomSectionConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...HomeRoomSectionName
				}
			}
		}
	}
	${HomeRoomSectionNameFragmentDoc}
`;

/**
 * __useHomeRoomSectionSelectQuery__
 *
 * To run a query within a React component, call `useHomeRoomSectionSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomSectionSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRoomSectionSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHomeRoomSectionSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<HomeRoomSectionSelectQuery, HomeRoomSectionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<HomeRoomSectionSelectQuery, HomeRoomSectionSelectQueryVariables>(
		HomeRoomSectionSelectDocument,
		options,
	);
}
export function useHomeRoomSectionSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<HomeRoomSectionSelectQuery, HomeRoomSectionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<HomeRoomSectionSelectQuery, HomeRoomSectionSelectQueryVariables>(
		HomeRoomSectionSelectDocument,
		options,
	);
}
export function useHomeRoomSectionSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<HomeRoomSectionSelectQuery, HomeRoomSectionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<HomeRoomSectionSelectQuery, HomeRoomSectionSelectQueryVariables>(
		HomeRoomSectionSelectDocument,
		options,
	);
}
export type HomeRoomSectionSelectQueryHookResult = ReturnType<typeof useHomeRoomSectionSelectQuery>;
export type HomeRoomSectionSelectLazyQueryHookResult = ReturnType<typeof useHomeRoomSectionSelectLazyQuery>;
export type HomeRoomSectionSelectSuspenseQueryHookResult = ReturnType<typeof useHomeRoomSectionSelectSuspenseQuery>;
export type HomeRoomSectionSelectQueryResult = Apollo.QueryResult<
	HomeRoomSectionSelectQuery,
	HomeRoomSectionSelectQueryVariables
>;
export const HomeRoomSectionUpdateDocument = gql`
	mutation homeRoomSectionUpdate($id: ID!, $input: HomeRoomSectionUpdateInput!) {
		updateHomeRoomSection(id: $id, input: $input) {
			...HomeRoomSectionDetail
		}
	}
	${HomeRoomSectionDetailFragmentDoc}
`;
export type HomeRoomSectionUpdateMutationFn = Apollo.MutationFunction<
	HomeRoomSectionUpdateMutation,
	HomeRoomSectionUpdateMutationVariables
>;

/**
 * __useHomeRoomSectionUpdateMutation__
 *
 * To run a mutation, you first call `useHomeRoomSectionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHomeRoomSectionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [homeRoomSectionUpdateMutation, { data, loading, error }] = useHomeRoomSectionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHomeRoomSectionUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<HomeRoomSectionUpdateMutation, HomeRoomSectionUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<HomeRoomSectionUpdateMutation, HomeRoomSectionUpdateMutationVariables>(
		HomeRoomSectionUpdateDocument,
		options,
	);
}
export type HomeRoomSectionUpdateMutationHookResult = ReturnType<typeof useHomeRoomSectionUpdateMutation>;
export type HomeRoomSectionUpdateMutationResult = Apollo.MutationResult<HomeRoomSectionUpdateMutation>;
export type HomeRoomSectionUpdateMutationOptions = Apollo.BaseMutationOptions<
	HomeRoomSectionUpdateMutation,
	HomeRoomSectionUpdateMutationVariables
>;
export const InvoiceCountDocument = gql`
	query invoiceCount($filters: [InvoiceFilterInput!], $pagination: Pagination, $order: InvoiceOrder) {
		invoiceConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useInvoiceCountQuery__
 *
 * To run a query within a React component, call `useInvoiceCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useInvoiceCountQuery(
	baseOptions?: Apollo.QueryHookOptions<InvoiceCountQuery, InvoiceCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<InvoiceCountQuery, InvoiceCountQueryVariables>(InvoiceCountDocument, options);
}
export function useInvoiceCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<InvoiceCountQuery, InvoiceCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<InvoiceCountQuery, InvoiceCountQueryVariables>(InvoiceCountDocument, options);
}
export function useInvoiceCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceCountQuery, InvoiceCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<InvoiceCountQuery, InvoiceCountQueryVariables>(InvoiceCountDocument, options);
}
export type InvoiceCountQueryHookResult = ReturnType<typeof useInvoiceCountQuery>;
export type InvoiceCountLazyQueryHookResult = ReturnType<typeof useInvoiceCountLazyQuery>;
export type InvoiceCountSuspenseQueryHookResult = ReturnType<typeof useInvoiceCountSuspenseQuery>;
export type InvoiceCountQueryResult = Apollo.QueryResult<InvoiceCountQuery, InvoiceCountQueryVariables>;
export const CreateInvoiceForContractInstallmentDocument = gql`
	mutation createInvoiceForContractInstallment($contractInstallmentID: ID!) {
		createInvoiceForContractInstallment(contractInstallmentID: $contractInstallmentID) {
			...InvoiceDetail
		}
	}
	${InvoiceDetailFragmentDoc}
`;
export type CreateInvoiceForContractInstallmentMutationFn = Apollo.MutationFunction<
	CreateInvoiceForContractInstallmentMutation,
	CreateInvoiceForContractInstallmentMutationVariables
>;

/**
 * __useCreateInvoiceForContractInstallmentMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceForContractInstallmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceForContractInstallmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceForContractInstallmentMutation, { data, loading, error }] = useCreateInvoiceForContractInstallmentMutation({
 *   variables: {
 *      contractInstallmentID: // value for 'contractInstallmentID'
 *   },
 * });
 */
export function useCreateInvoiceForContractInstallmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateInvoiceForContractInstallmentMutation,
		CreateInvoiceForContractInstallmentMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateInvoiceForContractInstallmentMutation,
		CreateInvoiceForContractInstallmentMutationVariables
	>(CreateInvoiceForContractInstallmentDocument, options);
}
export type CreateInvoiceForContractInstallmentMutationHookResult = ReturnType<
	typeof useCreateInvoiceForContractInstallmentMutation
>;
export type CreateInvoiceForContractInstallmentMutationResult =
	Apollo.MutationResult<CreateInvoiceForContractInstallmentMutation>;
export type CreateInvoiceForContractInstallmentMutationOptions = Apollo.BaseMutationOptions<
	CreateInvoiceForContractInstallmentMutation,
	CreateInvoiceForContractInstallmentMutationVariables
>;
export const InvoiceCreateDocument = gql`
	mutation invoiceCreate($input: InvoiceCreateInput!) {
		createInvoice(input: $input) {
			...InvoiceDetail
		}
	}
	${InvoiceDetailFragmentDoc}
`;
export type InvoiceCreateMutationFn = Apollo.MutationFunction<InvoiceCreateMutation, InvoiceCreateMutationVariables>;

/**
 * __useInvoiceCreateMutation__
 *
 * To run a mutation, you first call `useInvoiceCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceCreateMutation, { data, loading, error }] = useInvoiceCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<InvoiceCreateMutation, InvoiceCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<InvoiceCreateMutation, InvoiceCreateMutationVariables>(InvoiceCreateDocument, options);
}
export type InvoiceCreateMutationHookResult = ReturnType<typeof useInvoiceCreateMutation>;
export type InvoiceCreateMutationResult = Apollo.MutationResult<InvoiceCreateMutation>;
export type InvoiceCreateMutationOptions = Apollo.BaseMutationOptions<
	InvoiceCreateMutation,
	InvoiceCreateMutationVariables
>;
export const InvoiceDeleteDocument = gql`
	mutation invoiceDelete($id: ID!) {
		deleteInvoice(id: $id)
	}
`;
export type InvoiceDeleteMutationFn = Apollo.MutationFunction<InvoiceDeleteMutation, InvoiceDeleteMutationVariables>;

/**
 * __useInvoiceDeleteMutation__
 *
 * To run a mutation, you first call `useInvoiceDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceDeleteMutation, { data, loading, error }] = useInvoiceDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<InvoiceDeleteMutation, InvoiceDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<InvoiceDeleteMutation, InvoiceDeleteMutationVariables>(InvoiceDeleteDocument, options);
}
export type InvoiceDeleteMutationHookResult = ReturnType<typeof useInvoiceDeleteMutation>;
export type InvoiceDeleteMutationResult = Apollo.MutationResult<InvoiceDeleteMutation>;
export type InvoiceDeleteMutationOptions = Apollo.BaseMutationOptions<
	InvoiceDeleteMutation,
	InvoiceDeleteMutationVariables
>;
export const InvoiceDetailDocument = gql`
	query invoiceDetail($id: ID!) {
		invoice(id: $id) {
			...InvoiceDetail
		}
	}
	${InvoiceDetailFragmentDoc}
`;

/**
 * __useInvoiceDetailQuery__
 *
 * To run a query within a React component, call `useInvoiceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceDetailQuery(
	baseOptions: Apollo.QueryHookOptions<InvoiceDetailQuery, InvoiceDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<InvoiceDetailQuery, InvoiceDetailQueryVariables>(InvoiceDetailDocument, options);
}
export function useInvoiceDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<InvoiceDetailQuery, InvoiceDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<InvoiceDetailQuery, InvoiceDetailQueryVariables>(InvoiceDetailDocument, options);
}
export function useInvoiceDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceDetailQuery, InvoiceDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<InvoiceDetailQuery, InvoiceDetailQueryVariables>(InvoiceDetailDocument, options);
}
export type InvoiceDetailQueryHookResult = ReturnType<typeof useInvoiceDetailQuery>;
export type InvoiceDetailLazyQueryHookResult = ReturnType<typeof useInvoiceDetailLazyQuery>;
export type InvoiceDetailSuspenseQueryHookResult = ReturnType<typeof useInvoiceDetailSuspenseQuery>;
export type InvoiceDetailQueryResult = Apollo.QueryResult<InvoiceDetailQuery, InvoiceDetailQueryVariables>;
export const InvoiceIndexDocument = gql`
	query invoiceIndex($filters: [InvoiceFilterInput!], $pagination: Pagination, $order: InvoiceOrder) {
		invoiceConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					status
					issueDate
					dueDate
					description
				}
			}
		}
	}
`;

/**
 * __useInvoiceIndexQuery__
 *
 * To run a query within a React component, call `useInvoiceIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useInvoiceIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<InvoiceIndexQuery, InvoiceIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<InvoiceIndexQuery, InvoiceIndexQueryVariables>(InvoiceIndexDocument, options);
}
export function useInvoiceIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<InvoiceIndexQuery, InvoiceIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<InvoiceIndexQuery, InvoiceIndexQueryVariables>(InvoiceIndexDocument, options);
}
export function useInvoiceIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceIndexQuery, InvoiceIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<InvoiceIndexQuery, InvoiceIndexQueryVariables>(InvoiceIndexDocument, options);
}
export type InvoiceIndexQueryHookResult = ReturnType<typeof useInvoiceIndexQuery>;
export type InvoiceIndexLazyQueryHookResult = ReturnType<typeof useInvoiceIndexLazyQuery>;
export type InvoiceIndexSuspenseQueryHookResult = ReturnType<typeof useInvoiceIndexSuspenseQuery>;
export type InvoiceIndexQueryResult = Apollo.QueryResult<InvoiceIndexQuery, InvoiceIndexQueryVariables>;
export const PaymentLineItemInvoiceSelectionInformationDocument = gql`
	query paymentLineItemInvoiceSelectionInformation($id: ID!) {
		invoice(id: $id) {
			id
			contractInstallment {
				id
				contract {
					id
					student {
						id
					}
				}
			}
			invoiceLineItems {
				id
				amount
			}
			paymentLineItems {
				id
				amount
			}
			billingAdjustments {
				id
				amount
			}
		}
	}
`;

/**
 * __usePaymentLineItemInvoiceSelectionInformationQuery__
 *
 * To run a query within a React component, call `usePaymentLineItemInvoiceSelectionInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentLineItemInvoiceSelectionInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentLineItemInvoiceSelectionInformationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentLineItemInvoiceSelectionInformationQuery(
	baseOptions: Apollo.QueryHookOptions<
		PaymentLineItemInvoiceSelectionInformationQuery,
		PaymentLineItemInvoiceSelectionInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		PaymentLineItemInvoiceSelectionInformationQuery,
		PaymentLineItemInvoiceSelectionInformationQueryVariables
	>(PaymentLineItemInvoiceSelectionInformationDocument, options);
}
export function usePaymentLineItemInvoiceSelectionInformationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PaymentLineItemInvoiceSelectionInformationQuery,
		PaymentLineItemInvoiceSelectionInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		PaymentLineItemInvoiceSelectionInformationQuery,
		PaymentLineItemInvoiceSelectionInformationQueryVariables
	>(PaymentLineItemInvoiceSelectionInformationDocument, options);
}
export function usePaymentLineItemInvoiceSelectionInformationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		PaymentLineItemInvoiceSelectionInformationQuery,
		PaymentLineItemInvoiceSelectionInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		PaymentLineItemInvoiceSelectionInformationQuery,
		PaymentLineItemInvoiceSelectionInformationQueryVariables
	>(PaymentLineItemInvoiceSelectionInformationDocument, options);
}
export type PaymentLineItemInvoiceSelectionInformationQueryHookResult = ReturnType<
	typeof usePaymentLineItemInvoiceSelectionInformationQuery
>;
export type PaymentLineItemInvoiceSelectionInformationLazyQueryHookResult = ReturnType<
	typeof usePaymentLineItemInvoiceSelectionInformationLazyQuery
>;
export type PaymentLineItemInvoiceSelectionInformationSuspenseQueryHookResult = ReturnType<
	typeof usePaymentLineItemInvoiceSelectionInformationSuspenseQuery
>;
export type PaymentLineItemInvoiceSelectionInformationQueryResult = Apollo.QueryResult<
	PaymentLineItemInvoiceSelectionInformationQuery,
	PaymentLineItemInvoiceSelectionInformationQueryVariables
>;
export const InvoicePaymentInformationListDocument = gql`
	query invoicePaymentInformationList($filters: [InvoiceFilterInput!], $pagination: Pagination, $order: InvoiceOrder) {
		invoiceConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					status
					dueDate
					contractInstallment {
						id
						contract {
							id
							...ContractName
							student {
								id
								...StudentNameAndImage
							}
							contractInstallments(order: { field: DUE_DATE, direction: ASC }) {
								id
								dueDate
							}
						}
					}
					invoiceLineItems {
						id
						amount
					}
					paymentLineItems {
						id
						amount
					}
					billingAdjustments {
						id
						amount
					}
				}
			}
		}
	}
	${ContractNameFragmentDoc}
	${StudentNameAndImageFragmentDoc}
`;

/**
 * __useInvoicePaymentInformationListQuery__
 *
 * To run a query within a React component, call `useInvoicePaymentInformationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicePaymentInformationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicePaymentInformationListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useInvoicePaymentInformationListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		InvoicePaymentInformationListQuery,
		InvoicePaymentInformationListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<InvoicePaymentInformationListQuery, InvoicePaymentInformationListQueryVariables>(
		InvoicePaymentInformationListDocument,
		options,
	);
}
export function useInvoicePaymentInformationListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		InvoicePaymentInformationListQuery,
		InvoicePaymentInformationListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<InvoicePaymentInformationListQuery, InvoicePaymentInformationListQueryVariables>(
		InvoicePaymentInformationListDocument,
		options,
	);
}
export function useInvoicePaymentInformationListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		InvoicePaymentInformationListQuery,
		InvoicePaymentInformationListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<InvoicePaymentInformationListQuery, InvoicePaymentInformationListQueryVariables>(
		InvoicePaymentInformationListDocument,
		options,
	);
}
export type InvoicePaymentInformationListQueryHookResult = ReturnType<typeof useInvoicePaymentInformationListQuery>;
export type InvoicePaymentInformationListLazyQueryHookResult = ReturnType<
	typeof useInvoicePaymentInformationListLazyQuery
>;
export type InvoicePaymentInformationListSuspenseQueryHookResult = ReturnType<
	typeof useInvoicePaymentInformationListSuspenseQuery
>;
export type InvoicePaymentInformationListQueryResult = Apollo.QueryResult<
	InvoicePaymentInformationListQuery,
	InvoicePaymentInformationListQueryVariables
>;
export const InvoiceNameDocument = gql`
	query invoiceName($id: ID!) {
		invoice(id: $id) {
			id
			...InvoiceName
		}
	}
	${InvoiceNameFragmentDoc}
`;

/**
 * __useInvoiceNameQuery__
 *
 * To run a query within a React component, call `useInvoiceNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceNameQuery(baseOptions: Apollo.QueryHookOptions<InvoiceNameQuery, InvoiceNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<InvoiceNameQuery, InvoiceNameQueryVariables>(InvoiceNameDocument, options);
}
export function useInvoiceNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<InvoiceNameQuery, InvoiceNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<InvoiceNameQuery, InvoiceNameQueryVariables>(InvoiceNameDocument, options);
}
export function useInvoiceNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceNameQuery, InvoiceNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<InvoiceNameQuery, InvoiceNameQueryVariables>(InvoiceNameDocument, options);
}
export type InvoiceNameQueryHookResult = ReturnType<typeof useInvoiceNameQuery>;
export type InvoiceNameLazyQueryHookResult = ReturnType<typeof useInvoiceNameLazyQuery>;
export type InvoiceNameSuspenseQueryHookResult = ReturnType<typeof useInvoiceNameSuspenseQuery>;
export type InvoiceNameQueryResult = Apollo.QueryResult<InvoiceNameQuery, InvoiceNameQueryVariables>;
export const InvoiceNamesDocument = gql`
	query invoiceNames($filters: [InvoiceFilterInput!], $pagination: Pagination, $order: InvoiceOrder) {
		invoiceConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...InvoiceName
				}
			}
		}
	}
	${InvoiceNameFragmentDoc}
`;

/**
 * __useInvoiceNamesQuery__
 *
 * To run a query within a React component, call `useInvoiceNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useInvoiceNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<InvoiceNamesQuery, InvoiceNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<InvoiceNamesQuery, InvoiceNamesQueryVariables>(InvoiceNamesDocument, options);
}
export function useInvoiceNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<InvoiceNamesQuery, InvoiceNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<InvoiceNamesQuery, InvoiceNamesQueryVariables>(InvoiceNamesDocument, options);
}
export function useInvoiceNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceNamesQuery, InvoiceNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<InvoiceNamesQuery, InvoiceNamesQueryVariables>(InvoiceNamesDocument, options);
}
export type InvoiceNamesQueryHookResult = ReturnType<typeof useInvoiceNamesQuery>;
export type InvoiceNamesLazyQueryHookResult = ReturnType<typeof useInvoiceNamesLazyQuery>;
export type InvoiceNamesSuspenseQueryHookResult = ReturnType<typeof useInvoiceNamesSuspenseQuery>;
export type InvoiceNamesQueryResult = Apollo.QueryResult<InvoiceNamesQuery, InvoiceNamesQueryVariables>;
export const InvoicePaginationDocument = gql`
	query invoicePagination($filters: [InvoiceFilterInput!], $order: InvoiceOrder) {
		invoiceConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useInvoicePaginationQuery__
 *
 * To run a query within a React component, call `useInvoicePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useInvoicePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<InvoicePaginationQuery, InvoicePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<InvoicePaginationQuery, InvoicePaginationQueryVariables>(InvoicePaginationDocument, options);
}
export function useInvoicePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<InvoicePaginationQuery, InvoicePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<InvoicePaginationQuery, InvoicePaginationQueryVariables>(
		InvoicePaginationDocument,
		options,
	);
}
export function useInvoicePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<InvoicePaginationQuery, InvoicePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<InvoicePaginationQuery, InvoicePaginationQueryVariables>(
		InvoicePaginationDocument,
		options,
	);
}
export type InvoicePaginationQueryHookResult = ReturnType<typeof useInvoicePaginationQuery>;
export type InvoicePaginationLazyQueryHookResult = ReturnType<typeof useInvoicePaginationLazyQuery>;
export type InvoicePaginationSuspenseQueryHookResult = ReturnType<typeof useInvoicePaginationSuspenseQuery>;
export type InvoicePaginationQueryResult = Apollo.QueryResult<InvoicePaginationQuery, InvoicePaginationQueryVariables>;
export const InvoiceSelectDocument = gql`
	query invoiceSelect($filters: [InvoiceFilterInput!], $order: InvoiceOrder) {
		invoiceConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...InvoiceName
				}
			}
		}
	}
	${InvoiceNameFragmentDoc}
`;

/**
 * __useInvoiceSelectQuery__
 *
 * To run a query within a React component, call `useInvoiceSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useInvoiceSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<InvoiceSelectQuery, InvoiceSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<InvoiceSelectQuery, InvoiceSelectQueryVariables>(InvoiceSelectDocument, options);
}
export function useInvoiceSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<InvoiceSelectQuery, InvoiceSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<InvoiceSelectQuery, InvoiceSelectQueryVariables>(InvoiceSelectDocument, options);
}
export function useInvoiceSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceSelectQuery, InvoiceSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<InvoiceSelectQuery, InvoiceSelectQueryVariables>(InvoiceSelectDocument, options);
}
export type InvoiceSelectQueryHookResult = ReturnType<typeof useInvoiceSelectQuery>;
export type InvoiceSelectLazyQueryHookResult = ReturnType<typeof useInvoiceSelectLazyQuery>;
export type InvoiceSelectSuspenseQueryHookResult = ReturnType<typeof useInvoiceSelectSuspenseQuery>;
export type InvoiceSelectQueryResult = Apollo.QueryResult<InvoiceSelectQuery, InvoiceSelectQueryVariables>;
export const InvoiceUpdateDocument = gql`
	mutation invoiceUpdate($id: ID!, $input: InvoiceUpdateInput!) {
		updateInvoice(id: $id, input: $input) {
			...InvoiceDetail
		}
	}
	${InvoiceDetailFragmentDoc}
`;
export type InvoiceUpdateMutationFn = Apollo.MutationFunction<InvoiceUpdateMutation, InvoiceUpdateMutationVariables>;

/**
 * __useInvoiceUpdateMutation__
 *
 * To run a mutation, you first call `useInvoiceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceUpdateMutation, { data, loading, error }] = useInvoiceUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<InvoiceUpdateMutation, InvoiceUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<InvoiceUpdateMutation, InvoiceUpdateMutationVariables>(InvoiceUpdateDocument, options);
}
export type InvoiceUpdateMutationHookResult = ReturnType<typeof useInvoiceUpdateMutation>;
export type InvoiceUpdateMutationResult = Apollo.MutationResult<InvoiceUpdateMutation>;
export type InvoiceUpdateMutationOptions = Apollo.BaseMutationOptions<
	InvoiceUpdateMutation,
	InvoiceUpdateMutationVariables
>;
export const InvoiceLineItemCountDocument = gql`
	query invoiceLineItemCount(
		$filters: [InvoiceLineItemFilterInput!]
		$pagination: Pagination
		$order: InvoiceLineItemOrder
	) {
		invoiceLineItemConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useInvoiceLineItemCountQuery__
 *
 * To run a query within a React component, call `useInvoiceLineItemCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceLineItemCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceLineItemCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useInvoiceLineItemCountQuery(
	baseOptions?: Apollo.QueryHookOptions<InvoiceLineItemCountQuery, InvoiceLineItemCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<InvoiceLineItemCountQuery, InvoiceLineItemCountQueryVariables>(
		InvoiceLineItemCountDocument,
		options,
	);
}
export function useInvoiceLineItemCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<InvoiceLineItemCountQuery, InvoiceLineItemCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<InvoiceLineItemCountQuery, InvoiceLineItemCountQueryVariables>(
		InvoiceLineItemCountDocument,
		options,
	);
}
export function useInvoiceLineItemCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceLineItemCountQuery, InvoiceLineItemCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<InvoiceLineItemCountQuery, InvoiceLineItemCountQueryVariables>(
		InvoiceLineItemCountDocument,
		options,
	);
}
export type InvoiceLineItemCountQueryHookResult = ReturnType<typeof useInvoiceLineItemCountQuery>;
export type InvoiceLineItemCountLazyQueryHookResult = ReturnType<typeof useInvoiceLineItemCountLazyQuery>;
export type InvoiceLineItemCountSuspenseQueryHookResult = ReturnType<typeof useInvoiceLineItemCountSuspenseQuery>;
export type InvoiceLineItemCountQueryResult = Apollo.QueryResult<
	InvoiceLineItemCountQuery,
	InvoiceLineItemCountQueryVariables
>;
export const InvoiceLineItemCreateDocument = gql`
	mutation invoiceLineItemCreate($input: InvoiceLineItemCreateInput!) {
		createInvoiceLineItem(input: $input) {
			...InvoiceLineItemDetail
		}
	}
	${InvoiceLineItemDetailFragmentDoc}
`;
export type InvoiceLineItemCreateMutationFn = Apollo.MutationFunction<
	InvoiceLineItemCreateMutation,
	InvoiceLineItemCreateMutationVariables
>;

/**
 * __useInvoiceLineItemCreateMutation__
 *
 * To run a mutation, you first call `useInvoiceLineItemCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceLineItemCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceLineItemCreateMutation, { data, loading, error }] = useInvoiceLineItemCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceLineItemCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<InvoiceLineItemCreateMutation, InvoiceLineItemCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<InvoiceLineItemCreateMutation, InvoiceLineItemCreateMutationVariables>(
		InvoiceLineItemCreateDocument,
		options,
	);
}
export type InvoiceLineItemCreateMutationHookResult = ReturnType<typeof useInvoiceLineItemCreateMutation>;
export type InvoiceLineItemCreateMutationResult = Apollo.MutationResult<InvoiceLineItemCreateMutation>;
export type InvoiceLineItemCreateMutationOptions = Apollo.BaseMutationOptions<
	InvoiceLineItemCreateMutation,
	InvoiceLineItemCreateMutationVariables
>;
export const InvoiceLineItemDeleteDocument = gql`
	mutation invoiceLineItemDelete($id: ID!) {
		deleteInvoiceLineItem(id: $id)
	}
`;
export type InvoiceLineItemDeleteMutationFn = Apollo.MutationFunction<
	InvoiceLineItemDeleteMutation,
	InvoiceLineItemDeleteMutationVariables
>;

/**
 * __useInvoiceLineItemDeleteMutation__
 *
 * To run a mutation, you first call `useInvoiceLineItemDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceLineItemDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceLineItemDeleteMutation, { data, loading, error }] = useInvoiceLineItemDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceLineItemDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<InvoiceLineItemDeleteMutation, InvoiceLineItemDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<InvoiceLineItemDeleteMutation, InvoiceLineItemDeleteMutationVariables>(
		InvoiceLineItemDeleteDocument,
		options,
	);
}
export type InvoiceLineItemDeleteMutationHookResult = ReturnType<typeof useInvoiceLineItemDeleteMutation>;
export type InvoiceLineItemDeleteMutationResult = Apollo.MutationResult<InvoiceLineItemDeleteMutation>;
export type InvoiceLineItemDeleteMutationOptions = Apollo.BaseMutationOptions<
	InvoiceLineItemDeleteMutation,
	InvoiceLineItemDeleteMutationVariables
>;
export const InvoiceLineItemDetailDocument = gql`
	query invoiceLineItemDetail($id: ID!) {
		invoiceLineItem(id: $id) {
			...InvoiceLineItemDetail
		}
	}
	${InvoiceLineItemDetailFragmentDoc}
`;

/**
 * __useInvoiceLineItemDetailQuery__
 *
 * To run a query within a React component, call `useInvoiceLineItemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceLineItemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceLineItemDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceLineItemDetailQuery(
	baseOptions: Apollo.QueryHookOptions<InvoiceLineItemDetailQuery, InvoiceLineItemDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<InvoiceLineItemDetailQuery, InvoiceLineItemDetailQueryVariables>(
		InvoiceLineItemDetailDocument,
		options,
	);
}
export function useInvoiceLineItemDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<InvoiceLineItemDetailQuery, InvoiceLineItemDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<InvoiceLineItemDetailQuery, InvoiceLineItemDetailQueryVariables>(
		InvoiceLineItemDetailDocument,
		options,
	);
}
export function useInvoiceLineItemDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceLineItemDetailQuery, InvoiceLineItemDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<InvoiceLineItemDetailQuery, InvoiceLineItemDetailQueryVariables>(
		InvoiceLineItemDetailDocument,
		options,
	);
}
export type InvoiceLineItemDetailQueryHookResult = ReturnType<typeof useInvoiceLineItemDetailQuery>;
export type InvoiceLineItemDetailLazyQueryHookResult = ReturnType<typeof useInvoiceLineItemDetailLazyQuery>;
export type InvoiceLineItemDetailSuspenseQueryHookResult = ReturnType<typeof useInvoiceLineItemDetailSuspenseQuery>;
export type InvoiceLineItemDetailQueryResult = Apollo.QueryResult<
	InvoiceLineItemDetailQuery,
	InvoiceLineItemDetailQueryVariables
>;
export const InvoiceLineItemIndexDocument = gql`
	query invoiceLineItemIndex(
		$filters: [InvoiceLineItemFilterInput!]
		$pagination: Pagination
		$order: InvoiceLineItemOrder
	) {
		invoiceLineItemConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					displayOrder
					amount
				}
			}
		}
	}
`;

/**
 * __useInvoiceLineItemIndexQuery__
 *
 * To run a query within a React component, call `useInvoiceLineItemIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceLineItemIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceLineItemIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useInvoiceLineItemIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<InvoiceLineItemIndexQuery, InvoiceLineItemIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<InvoiceLineItemIndexQuery, InvoiceLineItemIndexQueryVariables>(
		InvoiceLineItemIndexDocument,
		options,
	);
}
export function useInvoiceLineItemIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<InvoiceLineItemIndexQuery, InvoiceLineItemIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<InvoiceLineItemIndexQuery, InvoiceLineItemIndexQueryVariables>(
		InvoiceLineItemIndexDocument,
		options,
	);
}
export function useInvoiceLineItemIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceLineItemIndexQuery, InvoiceLineItemIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<InvoiceLineItemIndexQuery, InvoiceLineItemIndexQueryVariables>(
		InvoiceLineItemIndexDocument,
		options,
	);
}
export type InvoiceLineItemIndexQueryHookResult = ReturnType<typeof useInvoiceLineItemIndexQuery>;
export type InvoiceLineItemIndexLazyQueryHookResult = ReturnType<typeof useInvoiceLineItemIndexLazyQuery>;
export type InvoiceLineItemIndexSuspenseQueryHookResult = ReturnType<typeof useInvoiceLineItemIndexSuspenseQuery>;
export type InvoiceLineItemIndexQueryResult = Apollo.QueryResult<
	InvoiceLineItemIndexQuery,
	InvoiceLineItemIndexQueryVariables
>;
export const InvoiceLineItemNameDocument = gql`
	query invoiceLineItemName($id: ID!) {
		invoiceLineItem(id: $id) {
			id
			...InvoiceLineItemName
		}
	}
	${InvoiceLineItemNameFragmentDoc}
`;

/**
 * __useInvoiceLineItemNameQuery__
 *
 * To run a query within a React component, call `useInvoiceLineItemNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceLineItemNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceLineItemNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceLineItemNameQuery(
	baseOptions: Apollo.QueryHookOptions<InvoiceLineItemNameQuery, InvoiceLineItemNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<InvoiceLineItemNameQuery, InvoiceLineItemNameQueryVariables>(
		InvoiceLineItemNameDocument,
		options,
	);
}
export function useInvoiceLineItemNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<InvoiceLineItemNameQuery, InvoiceLineItemNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<InvoiceLineItemNameQuery, InvoiceLineItemNameQueryVariables>(
		InvoiceLineItemNameDocument,
		options,
	);
}
export function useInvoiceLineItemNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceLineItemNameQuery, InvoiceLineItemNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<InvoiceLineItemNameQuery, InvoiceLineItemNameQueryVariables>(
		InvoiceLineItemNameDocument,
		options,
	);
}
export type InvoiceLineItemNameQueryHookResult = ReturnType<typeof useInvoiceLineItemNameQuery>;
export type InvoiceLineItemNameLazyQueryHookResult = ReturnType<typeof useInvoiceLineItemNameLazyQuery>;
export type InvoiceLineItemNameSuspenseQueryHookResult = ReturnType<typeof useInvoiceLineItemNameSuspenseQuery>;
export type InvoiceLineItemNameQueryResult = Apollo.QueryResult<
	InvoiceLineItemNameQuery,
	InvoiceLineItemNameQueryVariables
>;
export const InvoiceLineItemNamesDocument = gql`
	query invoiceLineItemNames(
		$filters: [InvoiceLineItemFilterInput!]
		$pagination: Pagination
		$order: InvoiceLineItemOrder
	) {
		invoiceLineItemConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...InvoiceLineItemName
				}
			}
		}
	}
	${InvoiceLineItemNameFragmentDoc}
`;

/**
 * __useInvoiceLineItemNamesQuery__
 *
 * To run a query within a React component, call `useInvoiceLineItemNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceLineItemNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceLineItemNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useInvoiceLineItemNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<InvoiceLineItemNamesQuery, InvoiceLineItemNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<InvoiceLineItemNamesQuery, InvoiceLineItemNamesQueryVariables>(
		InvoiceLineItemNamesDocument,
		options,
	);
}
export function useInvoiceLineItemNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<InvoiceLineItemNamesQuery, InvoiceLineItemNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<InvoiceLineItemNamesQuery, InvoiceLineItemNamesQueryVariables>(
		InvoiceLineItemNamesDocument,
		options,
	);
}
export function useInvoiceLineItemNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceLineItemNamesQuery, InvoiceLineItemNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<InvoiceLineItemNamesQuery, InvoiceLineItemNamesQueryVariables>(
		InvoiceLineItemNamesDocument,
		options,
	);
}
export type InvoiceLineItemNamesQueryHookResult = ReturnType<typeof useInvoiceLineItemNamesQuery>;
export type InvoiceLineItemNamesLazyQueryHookResult = ReturnType<typeof useInvoiceLineItemNamesLazyQuery>;
export type InvoiceLineItemNamesSuspenseQueryHookResult = ReturnType<typeof useInvoiceLineItemNamesSuspenseQuery>;
export type InvoiceLineItemNamesQueryResult = Apollo.QueryResult<
	InvoiceLineItemNamesQuery,
	InvoiceLineItemNamesQueryVariables
>;
export const InvoiceLineItemPaginationDocument = gql`
	query invoiceLineItemPagination($filters: [InvoiceLineItemFilterInput!], $order: InvoiceLineItemOrder) {
		invoiceLineItemConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useInvoiceLineItemPaginationQuery__
 *
 * To run a query within a React component, call `useInvoiceLineItemPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceLineItemPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceLineItemPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useInvoiceLineItemPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<InvoiceLineItemPaginationQuery, InvoiceLineItemPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<InvoiceLineItemPaginationQuery, InvoiceLineItemPaginationQueryVariables>(
		InvoiceLineItemPaginationDocument,
		options,
	);
}
export function useInvoiceLineItemPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<InvoiceLineItemPaginationQuery, InvoiceLineItemPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<InvoiceLineItemPaginationQuery, InvoiceLineItemPaginationQueryVariables>(
		InvoiceLineItemPaginationDocument,
		options,
	);
}
export function useInvoiceLineItemPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		InvoiceLineItemPaginationQuery,
		InvoiceLineItemPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<InvoiceLineItemPaginationQuery, InvoiceLineItemPaginationQueryVariables>(
		InvoiceLineItemPaginationDocument,
		options,
	);
}
export type InvoiceLineItemPaginationQueryHookResult = ReturnType<typeof useInvoiceLineItemPaginationQuery>;
export type InvoiceLineItemPaginationLazyQueryHookResult = ReturnType<typeof useInvoiceLineItemPaginationLazyQuery>;
export type InvoiceLineItemPaginationSuspenseQueryHookResult = ReturnType<
	typeof useInvoiceLineItemPaginationSuspenseQuery
>;
export type InvoiceLineItemPaginationQueryResult = Apollo.QueryResult<
	InvoiceLineItemPaginationQuery,
	InvoiceLineItemPaginationQueryVariables
>;
export const InvoiceLineItemSelectDocument = gql`
	query invoiceLineItemSelect($filters: [InvoiceLineItemFilterInput!], $order: InvoiceLineItemOrder) {
		invoiceLineItemConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...InvoiceLineItemName
				}
			}
		}
	}
	${InvoiceLineItemNameFragmentDoc}
`;

/**
 * __useInvoiceLineItemSelectQuery__
 *
 * To run a query within a React component, call `useInvoiceLineItemSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceLineItemSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceLineItemSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useInvoiceLineItemSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<InvoiceLineItemSelectQuery, InvoiceLineItemSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<InvoiceLineItemSelectQuery, InvoiceLineItemSelectQueryVariables>(
		InvoiceLineItemSelectDocument,
		options,
	);
}
export function useInvoiceLineItemSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<InvoiceLineItemSelectQuery, InvoiceLineItemSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<InvoiceLineItemSelectQuery, InvoiceLineItemSelectQueryVariables>(
		InvoiceLineItemSelectDocument,
		options,
	);
}
export function useInvoiceLineItemSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<InvoiceLineItemSelectQuery, InvoiceLineItemSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<InvoiceLineItemSelectQuery, InvoiceLineItemSelectQueryVariables>(
		InvoiceLineItemSelectDocument,
		options,
	);
}
export type InvoiceLineItemSelectQueryHookResult = ReturnType<typeof useInvoiceLineItemSelectQuery>;
export type InvoiceLineItemSelectLazyQueryHookResult = ReturnType<typeof useInvoiceLineItemSelectLazyQuery>;
export type InvoiceLineItemSelectSuspenseQueryHookResult = ReturnType<typeof useInvoiceLineItemSelectSuspenseQuery>;
export type InvoiceLineItemSelectQueryResult = Apollo.QueryResult<
	InvoiceLineItemSelectQuery,
	InvoiceLineItemSelectQueryVariables
>;
export const InvoiceLineItemUpdateDocument = gql`
	mutation invoiceLineItemUpdate($id: ID!, $input: InvoiceLineItemUpdateInput!) {
		updateInvoiceLineItem(id: $id, input: $input) {
			...InvoiceLineItemDetail
		}
	}
	${InvoiceLineItemDetailFragmentDoc}
`;
export type InvoiceLineItemUpdateMutationFn = Apollo.MutationFunction<
	InvoiceLineItemUpdateMutation,
	InvoiceLineItemUpdateMutationVariables
>;

/**
 * __useInvoiceLineItemUpdateMutation__
 *
 * To run a mutation, you first call `useInvoiceLineItemUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceLineItemUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceLineItemUpdateMutation, { data, loading, error }] = useInvoiceLineItemUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceLineItemUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<InvoiceLineItemUpdateMutation, InvoiceLineItemUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<InvoiceLineItemUpdateMutation, InvoiceLineItemUpdateMutationVariables>(
		InvoiceLineItemUpdateDocument,
		options,
	);
}
export type InvoiceLineItemUpdateMutationHookResult = ReturnType<typeof useInvoiceLineItemUpdateMutation>;
export type InvoiceLineItemUpdateMutationResult = Apollo.MutationResult<InvoiceLineItemUpdateMutation>;
export type InvoiceLineItemUpdateMutationOptions = Apollo.BaseMutationOptions<
	InvoiceLineItemUpdateMutation,
	InvoiceLineItemUpdateMutationVariables
>;
export const LanguageCheckUniqueNameDocument = gql`
	query languageCheckUniqueName($ignoreID: ID, $name: String!) {
		languageConnection(filters: { idNEQ: $ignoreID, nameEQ: $name }) {
			totalCount
		}
	}
`;

/**
 * __useLanguageCheckUniqueNameQuery__
 *
 * To run a query within a React component, call `useLanguageCheckUniqueNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguageCheckUniqueNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguageCheckUniqueNameQuery({
 *   variables: {
 *      ignoreID: // value for 'ignoreID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useLanguageCheckUniqueNameQuery(
	baseOptions: Apollo.QueryHookOptions<LanguageCheckUniqueNameQuery, LanguageCheckUniqueNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LanguageCheckUniqueNameQuery, LanguageCheckUniqueNameQueryVariables>(
		LanguageCheckUniqueNameDocument,
		options,
	);
}
export function useLanguageCheckUniqueNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LanguageCheckUniqueNameQuery, LanguageCheckUniqueNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LanguageCheckUniqueNameQuery, LanguageCheckUniqueNameQueryVariables>(
		LanguageCheckUniqueNameDocument,
		options,
	);
}
export function useLanguageCheckUniqueNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LanguageCheckUniqueNameQuery, LanguageCheckUniqueNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LanguageCheckUniqueNameQuery, LanguageCheckUniqueNameQueryVariables>(
		LanguageCheckUniqueNameDocument,
		options,
	);
}
export type LanguageCheckUniqueNameQueryHookResult = ReturnType<typeof useLanguageCheckUniqueNameQuery>;
export type LanguageCheckUniqueNameLazyQueryHookResult = ReturnType<typeof useLanguageCheckUniqueNameLazyQuery>;
export type LanguageCheckUniqueNameSuspenseQueryHookResult = ReturnType<typeof useLanguageCheckUniqueNameSuspenseQuery>;
export type LanguageCheckUniqueNameQueryResult = Apollo.QueryResult<
	LanguageCheckUniqueNameQuery,
	LanguageCheckUniqueNameQueryVariables
>;
export const LanguageCountDocument = gql`
	query languageCount($filters: [LanguageFilterInput!], $pagination: Pagination, $order: LanguageOrder) {
		languageConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useLanguageCountQuery__
 *
 * To run a query within a React component, call `useLanguageCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguageCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguageCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLanguageCountQuery(
	baseOptions?: Apollo.QueryHookOptions<LanguageCountQuery, LanguageCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LanguageCountQuery, LanguageCountQueryVariables>(LanguageCountDocument, options);
}
export function useLanguageCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LanguageCountQuery, LanguageCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LanguageCountQuery, LanguageCountQueryVariables>(LanguageCountDocument, options);
}
export function useLanguageCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LanguageCountQuery, LanguageCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LanguageCountQuery, LanguageCountQueryVariables>(LanguageCountDocument, options);
}
export type LanguageCountQueryHookResult = ReturnType<typeof useLanguageCountQuery>;
export type LanguageCountLazyQueryHookResult = ReturnType<typeof useLanguageCountLazyQuery>;
export type LanguageCountSuspenseQueryHookResult = ReturnType<typeof useLanguageCountSuspenseQuery>;
export type LanguageCountQueryResult = Apollo.QueryResult<LanguageCountQuery, LanguageCountQueryVariables>;
export const LanguageCreateDocument = gql`
	mutation languageCreate($input: LanguageCreateInput!) {
		createLanguage(input: $input) {
			...LanguageDetail
		}
	}
	${LanguageDetailFragmentDoc}
`;
export type LanguageCreateMutationFn = Apollo.MutationFunction<LanguageCreateMutation, LanguageCreateMutationVariables>;

/**
 * __useLanguageCreateMutation__
 *
 * To run a mutation, you first call `useLanguageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLanguageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [languageCreateMutation, { data, loading, error }] = useLanguageCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLanguageCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<LanguageCreateMutation, LanguageCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<LanguageCreateMutation, LanguageCreateMutationVariables>(LanguageCreateDocument, options);
}
export type LanguageCreateMutationHookResult = ReturnType<typeof useLanguageCreateMutation>;
export type LanguageCreateMutationResult = Apollo.MutationResult<LanguageCreateMutation>;
export type LanguageCreateMutationOptions = Apollo.BaseMutationOptions<
	LanguageCreateMutation,
	LanguageCreateMutationVariables
>;
export const LanguageDeleteDocument = gql`
	mutation languageDelete($id: ID!) {
		deleteLanguage(id: $id)
	}
`;
export type LanguageDeleteMutationFn = Apollo.MutationFunction<LanguageDeleteMutation, LanguageDeleteMutationVariables>;

/**
 * __useLanguageDeleteMutation__
 *
 * To run a mutation, you first call `useLanguageDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLanguageDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [languageDeleteMutation, { data, loading, error }] = useLanguageDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLanguageDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<LanguageDeleteMutation, LanguageDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<LanguageDeleteMutation, LanguageDeleteMutationVariables>(LanguageDeleteDocument, options);
}
export type LanguageDeleteMutationHookResult = ReturnType<typeof useLanguageDeleteMutation>;
export type LanguageDeleteMutationResult = Apollo.MutationResult<LanguageDeleteMutation>;
export type LanguageDeleteMutationOptions = Apollo.BaseMutationOptions<
	LanguageDeleteMutation,
	LanguageDeleteMutationVariables
>;
export const LanguageDetailDocument = gql`
	query languageDetail($id: ID!) {
		language(id: $id) {
			...LanguageDetail
		}
	}
	${LanguageDetailFragmentDoc}
`;

/**
 * __useLanguageDetailQuery__
 *
 * To run a query within a React component, call `useLanguageDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguageDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguageDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLanguageDetailQuery(
	baseOptions: Apollo.QueryHookOptions<LanguageDetailQuery, LanguageDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LanguageDetailQuery, LanguageDetailQueryVariables>(LanguageDetailDocument, options);
}
export function useLanguageDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LanguageDetailQuery, LanguageDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LanguageDetailQuery, LanguageDetailQueryVariables>(LanguageDetailDocument, options);
}
export function useLanguageDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LanguageDetailQuery, LanguageDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LanguageDetailQuery, LanguageDetailQueryVariables>(LanguageDetailDocument, options);
}
export type LanguageDetailQueryHookResult = ReturnType<typeof useLanguageDetailQuery>;
export type LanguageDetailLazyQueryHookResult = ReturnType<typeof useLanguageDetailLazyQuery>;
export type LanguageDetailSuspenseQueryHookResult = ReturnType<typeof useLanguageDetailSuspenseQuery>;
export type LanguageDetailQueryResult = Apollo.QueryResult<LanguageDetailQuery, LanguageDetailQueryVariables>;
export const LanguageIndexDocument = gql`
	query languageIndex($filters: [LanguageFilterInput!], $pagination: Pagination, $order: LanguageOrder) {
		languageConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
				}
			}
		}
	}
`;

/**
 * __useLanguageIndexQuery__
 *
 * To run a query within a React component, call `useLanguageIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguageIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguageIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLanguageIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<LanguageIndexQuery, LanguageIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LanguageIndexQuery, LanguageIndexQueryVariables>(LanguageIndexDocument, options);
}
export function useLanguageIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LanguageIndexQuery, LanguageIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LanguageIndexQuery, LanguageIndexQueryVariables>(LanguageIndexDocument, options);
}
export function useLanguageIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LanguageIndexQuery, LanguageIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LanguageIndexQuery, LanguageIndexQueryVariables>(LanguageIndexDocument, options);
}
export type LanguageIndexQueryHookResult = ReturnType<typeof useLanguageIndexQuery>;
export type LanguageIndexLazyQueryHookResult = ReturnType<typeof useLanguageIndexLazyQuery>;
export type LanguageIndexSuspenseQueryHookResult = ReturnType<typeof useLanguageIndexSuspenseQuery>;
export type LanguageIndexQueryResult = Apollo.QueryResult<LanguageIndexQuery, LanguageIndexQueryVariables>;
export const LanguageNameDocument = gql`
	query languageName($id: ID!) {
		language(id: $id) {
			id
			...LanguageName
		}
	}
	${LanguageNameFragmentDoc}
`;

/**
 * __useLanguageNameQuery__
 *
 * To run a query within a React component, call `useLanguageNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguageNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguageNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLanguageNameQuery(
	baseOptions: Apollo.QueryHookOptions<LanguageNameQuery, LanguageNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LanguageNameQuery, LanguageNameQueryVariables>(LanguageNameDocument, options);
}
export function useLanguageNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LanguageNameQuery, LanguageNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LanguageNameQuery, LanguageNameQueryVariables>(LanguageNameDocument, options);
}
export function useLanguageNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LanguageNameQuery, LanguageNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LanguageNameQuery, LanguageNameQueryVariables>(LanguageNameDocument, options);
}
export type LanguageNameQueryHookResult = ReturnType<typeof useLanguageNameQuery>;
export type LanguageNameLazyQueryHookResult = ReturnType<typeof useLanguageNameLazyQuery>;
export type LanguageNameSuspenseQueryHookResult = ReturnType<typeof useLanguageNameSuspenseQuery>;
export type LanguageNameQueryResult = Apollo.QueryResult<LanguageNameQuery, LanguageNameQueryVariables>;
export const LanguageNamesDocument = gql`
	query languageNames($filters: [LanguageFilterInput!], $pagination: Pagination, $order: LanguageOrder) {
		languageConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...LanguageName
				}
			}
		}
	}
	${LanguageNameFragmentDoc}
`;

/**
 * __useLanguageNamesQuery__
 *
 * To run a query within a React component, call `useLanguageNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguageNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguageNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLanguageNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<LanguageNamesQuery, LanguageNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LanguageNamesQuery, LanguageNamesQueryVariables>(LanguageNamesDocument, options);
}
export function useLanguageNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LanguageNamesQuery, LanguageNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LanguageNamesQuery, LanguageNamesQueryVariables>(LanguageNamesDocument, options);
}
export function useLanguageNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LanguageNamesQuery, LanguageNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LanguageNamesQuery, LanguageNamesQueryVariables>(LanguageNamesDocument, options);
}
export type LanguageNamesQueryHookResult = ReturnType<typeof useLanguageNamesQuery>;
export type LanguageNamesLazyQueryHookResult = ReturnType<typeof useLanguageNamesLazyQuery>;
export type LanguageNamesSuspenseQueryHookResult = ReturnType<typeof useLanguageNamesSuspenseQuery>;
export type LanguageNamesQueryResult = Apollo.QueryResult<LanguageNamesQuery, LanguageNamesQueryVariables>;
export const LanguagePaginationDocument = gql`
	query languagePagination($filters: [LanguageFilterInput!], $order: LanguageOrder) {
		languageConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useLanguagePaginationQuery__
 *
 * To run a query within a React component, call `useLanguagePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguagePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguagePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLanguagePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<LanguagePaginationQuery, LanguagePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LanguagePaginationQuery, LanguagePaginationQueryVariables>(
		LanguagePaginationDocument,
		options,
	);
}
export function useLanguagePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LanguagePaginationQuery, LanguagePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LanguagePaginationQuery, LanguagePaginationQueryVariables>(
		LanguagePaginationDocument,
		options,
	);
}
export function useLanguagePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LanguagePaginationQuery, LanguagePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LanguagePaginationQuery, LanguagePaginationQueryVariables>(
		LanguagePaginationDocument,
		options,
	);
}
export type LanguagePaginationQueryHookResult = ReturnType<typeof useLanguagePaginationQuery>;
export type LanguagePaginationLazyQueryHookResult = ReturnType<typeof useLanguagePaginationLazyQuery>;
export type LanguagePaginationSuspenseQueryHookResult = ReturnType<typeof useLanguagePaginationSuspenseQuery>;
export type LanguagePaginationQueryResult = Apollo.QueryResult<
	LanguagePaginationQuery,
	LanguagePaginationQueryVariables
>;
export const LanguageSelectDocument = gql`
	query languageSelect($filters: [LanguageFilterInput!], $order: LanguageOrder) {
		languageConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...LanguageName
				}
			}
		}
	}
	${LanguageNameFragmentDoc}
`;

/**
 * __useLanguageSelectQuery__
 *
 * To run a query within a React component, call `useLanguageSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguageSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguageSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLanguageSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<LanguageSelectQuery, LanguageSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LanguageSelectQuery, LanguageSelectQueryVariables>(LanguageSelectDocument, options);
}
export function useLanguageSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LanguageSelectQuery, LanguageSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LanguageSelectQuery, LanguageSelectQueryVariables>(LanguageSelectDocument, options);
}
export function useLanguageSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LanguageSelectQuery, LanguageSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LanguageSelectQuery, LanguageSelectQueryVariables>(LanguageSelectDocument, options);
}
export type LanguageSelectQueryHookResult = ReturnType<typeof useLanguageSelectQuery>;
export type LanguageSelectLazyQueryHookResult = ReturnType<typeof useLanguageSelectLazyQuery>;
export type LanguageSelectSuspenseQueryHookResult = ReturnType<typeof useLanguageSelectSuspenseQuery>;
export type LanguageSelectQueryResult = Apollo.QueryResult<LanguageSelectQuery, LanguageSelectQueryVariables>;
export const LanguageUpdateDocument = gql`
	mutation languageUpdate($id: ID!, $input: LanguageUpdateInput!) {
		updateLanguage(id: $id, input: $input) {
			...LanguageDetail
		}
	}
	${LanguageDetailFragmentDoc}
`;
export type LanguageUpdateMutationFn = Apollo.MutationFunction<LanguageUpdateMutation, LanguageUpdateMutationVariables>;

/**
 * __useLanguageUpdateMutation__
 *
 * To run a mutation, you first call `useLanguageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLanguageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [languageUpdateMutation, { data, loading, error }] = useLanguageUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLanguageUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<LanguageUpdateMutation, LanguageUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<LanguageUpdateMutation, LanguageUpdateMutationVariables>(LanguageUpdateDocument, options);
}
export type LanguageUpdateMutationHookResult = ReturnType<typeof useLanguageUpdateMutation>;
export type LanguageUpdateMutationResult = Apollo.MutationResult<LanguageUpdateMutation>;
export type LanguageUpdateMutationOptions = Apollo.BaseMutationOptions<
	LanguageUpdateMutation,
	LanguageUpdateMutationVariables
>;
export const LearningObjectiveCountDocument = gql`
	query learningObjectiveCount(
		$filters: [LearningObjectiveFilterInput!]
		$pagination: Pagination
		$order: LearningObjectiveOrder
	) {
		learningObjectiveConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useLearningObjectiveCountQuery__
 *
 * To run a query within a React component, call `useLearningObjectiveCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningObjectiveCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLearningObjectiveCountQuery(
	baseOptions?: Apollo.QueryHookOptions<LearningObjectiveCountQuery, LearningObjectiveCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LearningObjectiveCountQuery, LearningObjectiveCountQueryVariables>(
		LearningObjectiveCountDocument,
		options,
	);
}
export function useLearningObjectiveCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LearningObjectiveCountQuery, LearningObjectiveCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LearningObjectiveCountQuery, LearningObjectiveCountQueryVariables>(
		LearningObjectiveCountDocument,
		options,
	);
}
export function useLearningObjectiveCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LearningObjectiveCountQuery, LearningObjectiveCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LearningObjectiveCountQuery, LearningObjectiveCountQueryVariables>(
		LearningObjectiveCountDocument,
		options,
	);
}
export type LearningObjectiveCountQueryHookResult = ReturnType<typeof useLearningObjectiveCountQuery>;
export type LearningObjectiveCountLazyQueryHookResult = ReturnType<typeof useLearningObjectiveCountLazyQuery>;
export type LearningObjectiveCountSuspenseQueryHookResult = ReturnType<typeof useLearningObjectiveCountSuspenseQuery>;
export type LearningObjectiveCountQueryResult = Apollo.QueryResult<
	LearningObjectiveCountQuery,
	LearningObjectiveCountQueryVariables
>;
export const LearningObjectiveCreateDocument = gql`
	mutation learningObjectiveCreate($input: LearningObjectiveCreateInput!) {
		createLearningObjective(input: $input) {
			...LearningObjectiveDetail
		}
	}
	${LearningObjectiveDetailFragmentDoc}
`;
export type LearningObjectiveCreateMutationFn = Apollo.MutationFunction<
	LearningObjectiveCreateMutation,
	LearningObjectiveCreateMutationVariables
>;

/**
 * __useLearningObjectiveCreateMutation__
 *
 * To run a mutation, you first call `useLearningObjectiveCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningObjectiveCreateMutation, { data, loading, error }] = useLearningObjectiveCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLearningObjectiveCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<LearningObjectiveCreateMutation, LearningObjectiveCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<LearningObjectiveCreateMutation, LearningObjectiveCreateMutationVariables>(
		LearningObjectiveCreateDocument,
		options,
	);
}
export type LearningObjectiveCreateMutationHookResult = ReturnType<typeof useLearningObjectiveCreateMutation>;
export type LearningObjectiveCreateMutationResult = Apollo.MutationResult<LearningObjectiveCreateMutation>;
export type LearningObjectiveCreateMutationOptions = Apollo.BaseMutationOptions<
	LearningObjectiveCreateMutation,
	LearningObjectiveCreateMutationVariables
>;
export const LearningObjectiveDeleteDocument = gql`
	mutation learningObjectiveDelete($id: ID!) {
		deleteLearningObjective(id: $id)
	}
`;
export type LearningObjectiveDeleteMutationFn = Apollo.MutationFunction<
	LearningObjectiveDeleteMutation,
	LearningObjectiveDeleteMutationVariables
>;

/**
 * __useLearningObjectiveDeleteMutation__
 *
 * To run a mutation, you first call `useLearningObjectiveDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningObjectiveDeleteMutation, { data, loading, error }] = useLearningObjectiveDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningObjectiveDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<LearningObjectiveDeleteMutation, LearningObjectiveDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<LearningObjectiveDeleteMutation, LearningObjectiveDeleteMutationVariables>(
		LearningObjectiveDeleteDocument,
		options,
	);
}
export type LearningObjectiveDeleteMutationHookResult = ReturnType<typeof useLearningObjectiveDeleteMutation>;
export type LearningObjectiveDeleteMutationResult = Apollo.MutationResult<LearningObjectiveDeleteMutation>;
export type LearningObjectiveDeleteMutationOptions = Apollo.BaseMutationOptions<
	LearningObjectiveDeleteMutation,
	LearningObjectiveDeleteMutationVariables
>;
export const LearningObjectiveDetailDocument = gql`
	query learningObjectiveDetail($id: ID!) {
		learningObjective(id: $id) {
			...LearningObjectiveDetail
		}
	}
	${LearningObjectiveDetailFragmentDoc}
`;

/**
 * __useLearningObjectiveDetailQuery__
 *
 * To run a query within a React component, call `useLearningObjectiveDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningObjectiveDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningObjectiveDetailQuery(
	baseOptions: Apollo.QueryHookOptions<LearningObjectiveDetailQuery, LearningObjectiveDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LearningObjectiveDetailQuery, LearningObjectiveDetailQueryVariables>(
		LearningObjectiveDetailDocument,
		options,
	);
}
export function useLearningObjectiveDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LearningObjectiveDetailQuery, LearningObjectiveDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LearningObjectiveDetailQuery, LearningObjectiveDetailQueryVariables>(
		LearningObjectiveDetailDocument,
		options,
	);
}
export function useLearningObjectiveDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LearningObjectiveDetailQuery, LearningObjectiveDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LearningObjectiveDetailQuery, LearningObjectiveDetailQueryVariables>(
		LearningObjectiveDetailDocument,
		options,
	);
}
export type LearningObjectiveDetailQueryHookResult = ReturnType<typeof useLearningObjectiveDetailQuery>;
export type LearningObjectiveDetailLazyQueryHookResult = ReturnType<typeof useLearningObjectiveDetailLazyQuery>;
export type LearningObjectiveDetailSuspenseQueryHookResult = ReturnType<typeof useLearningObjectiveDetailSuspenseQuery>;
export type LearningObjectiveDetailQueryResult = Apollo.QueryResult<
	LearningObjectiveDetailQuery,
	LearningObjectiveDetailQueryVariables
>;
export const LearningObjectiveIndexDocument = gql`
	query learningObjectiveIndex(
		$filters: [LearningObjectiveFilterInput!]
		$pagination: Pagination
		$order: LearningObjectiveOrder
	) {
		learningObjectiveConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					description
				}
			}
		}
	}
`;

/**
 * __useLearningObjectiveIndexQuery__
 *
 * To run a query within a React component, call `useLearningObjectiveIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningObjectiveIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLearningObjectiveIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<LearningObjectiveIndexQuery, LearningObjectiveIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LearningObjectiveIndexQuery, LearningObjectiveIndexQueryVariables>(
		LearningObjectiveIndexDocument,
		options,
	);
}
export function useLearningObjectiveIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LearningObjectiveIndexQuery, LearningObjectiveIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LearningObjectiveIndexQuery, LearningObjectiveIndexQueryVariables>(
		LearningObjectiveIndexDocument,
		options,
	);
}
export function useLearningObjectiveIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LearningObjectiveIndexQuery, LearningObjectiveIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LearningObjectiveIndexQuery, LearningObjectiveIndexQueryVariables>(
		LearningObjectiveIndexDocument,
		options,
	);
}
export type LearningObjectiveIndexQueryHookResult = ReturnType<typeof useLearningObjectiveIndexQuery>;
export type LearningObjectiveIndexLazyQueryHookResult = ReturnType<typeof useLearningObjectiveIndexLazyQuery>;
export type LearningObjectiveIndexSuspenseQueryHookResult = ReturnType<typeof useLearningObjectiveIndexSuspenseQuery>;
export type LearningObjectiveIndexQueryResult = Apollo.QueryResult<
	LearningObjectiveIndexQuery,
	LearningObjectiveIndexQueryVariables
>;
export const LearningObjectiveNameDocument = gql`
	query learningObjectiveName($id: ID!) {
		learningObjective(id: $id) {
			id
			...LearningObjectiveName
		}
	}
	${LearningObjectiveNameFragmentDoc}
`;

/**
 * __useLearningObjectiveNameQuery__
 *
 * To run a query within a React component, call `useLearningObjectiveNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningObjectiveNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningObjectiveNameQuery(
	baseOptions: Apollo.QueryHookOptions<LearningObjectiveNameQuery, LearningObjectiveNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LearningObjectiveNameQuery, LearningObjectiveNameQueryVariables>(
		LearningObjectiveNameDocument,
		options,
	);
}
export function useLearningObjectiveNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LearningObjectiveNameQuery, LearningObjectiveNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LearningObjectiveNameQuery, LearningObjectiveNameQueryVariables>(
		LearningObjectiveNameDocument,
		options,
	);
}
export function useLearningObjectiveNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LearningObjectiveNameQuery, LearningObjectiveNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LearningObjectiveNameQuery, LearningObjectiveNameQueryVariables>(
		LearningObjectiveNameDocument,
		options,
	);
}
export type LearningObjectiveNameQueryHookResult = ReturnType<typeof useLearningObjectiveNameQuery>;
export type LearningObjectiveNameLazyQueryHookResult = ReturnType<typeof useLearningObjectiveNameLazyQuery>;
export type LearningObjectiveNameSuspenseQueryHookResult = ReturnType<typeof useLearningObjectiveNameSuspenseQuery>;
export type LearningObjectiveNameQueryResult = Apollo.QueryResult<
	LearningObjectiveNameQuery,
	LearningObjectiveNameQueryVariables
>;
export const LearningObjectiveNamesDocument = gql`
	query learningObjectiveNames(
		$filters: [LearningObjectiveFilterInput!]
		$pagination: Pagination
		$order: LearningObjectiveOrder
	) {
		learningObjectiveConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...LearningObjectiveName
				}
			}
		}
	}
	${LearningObjectiveNameFragmentDoc}
`;

/**
 * __useLearningObjectiveNamesQuery__
 *
 * To run a query within a React component, call `useLearningObjectiveNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningObjectiveNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLearningObjectiveNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<LearningObjectiveNamesQuery, LearningObjectiveNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LearningObjectiveNamesQuery, LearningObjectiveNamesQueryVariables>(
		LearningObjectiveNamesDocument,
		options,
	);
}
export function useLearningObjectiveNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LearningObjectiveNamesQuery, LearningObjectiveNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LearningObjectiveNamesQuery, LearningObjectiveNamesQueryVariables>(
		LearningObjectiveNamesDocument,
		options,
	);
}
export function useLearningObjectiveNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LearningObjectiveNamesQuery, LearningObjectiveNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LearningObjectiveNamesQuery, LearningObjectiveNamesQueryVariables>(
		LearningObjectiveNamesDocument,
		options,
	);
}
export type LearningObjectiveNamesQueryHookResult = ReturnType<typeof useLearningObjectiveNamesQuery>;
export type LearningObjectiveNamesLazyQueryHookResult = ReturnType<typeof useLearningObjectiveNamesLazyQuery>;
export type LearningObjectiveNamesSuspenseQueryHookResult = ReturnType<typeof useLearningObjectiveNamesSuspenseQuery>;
export type LearningObjectiveNamesQueryResult = Apollo.QueryResult<
	LearningObjectiveNamesQuery,
	LearningObjectiveNamesQueryVariables
>;
export const LearningObjectivePaginationDocument = gql`
	query learningObjectivePagination($filters: [LearningObjectiveFilterInput!], $order: LearningObjectiveOrder) {
		learningObjectiveConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useLearningObjectivePaginationQuery__
 *
 * To run a query within a React component, call `useLearningObjectivePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectivePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningObjectivePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLearningObjectivePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<LearningObjectivePaginationQuery, LearningObjectivePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LearningObjectivePaginationQuery, LearningObjectivePaginationQueryVariables>(
		LearningObjectivePaginationDocument,
		options,
	);
}
export function useLearningObjectivePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		LearningObjectivePaginationQuery,
		LearningObjectivePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LearningObjectivePaginationQuery, LearningObjectivePaginationQueryVariables>(
		LearningObjectivePaginationDocument,
		options,
	);
}
export function useLearningObjectivePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		LearningObjectivePaginationQuery,
		LearningObjectivePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LearningObjectivePaginationQuery, LearningObjectivePaginationQueryVariables>(
		LearningObjectivePaginationDocument,
		options,
	);
}
export type LearningObjectivePaginationQueryHookResult = ReturnType<typeof useLearningObjectivePaginationQuery>;
export type LearningObjectivePaginationLazyQueryHookResult = ReturnType<typeof useLearningObjectivePaginationLazyQuery>;
export type LearningObjectivePaginationSuspenseQueryHookResult = ReturnType<
	typeof useLearningObjectivePaginationSuspenseQuery
>;
export type LearningObjectivePaginationQueryResult = Apollo.QueryResult<
	LearningObjectivePaginationQuery,
	LearningObjectivePaginationQueryVariables
>;
export const LearningObjectiveSelectDocument = gql`
	query learningObjectiveSelect($filters: [LearningObjectiveFilterInput!], $order: LearningObjectiveOrder) {
		learningObjectiveConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...LearningObjectiveName
				}
			}
		}
	}
	${LearningObjectiveNameFragmentDoc}
`;

/**
 * __useLearningObjectiveSelectQuery__
 *
 * To run a query within a React component, call `useLearningObjectiveSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningObjectiveSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLearningObjectiveSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<LearningObjectiveSelectQuery, LearningObjectiveSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LearningObjectiveSelectQuery, LearningObjectiveSelectQueryVariables>(
		LearningObjectiveSelectDocument,
		options,
	);
}
export function useLearningObjectiveSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LearningObjectiveSelectQuery, LearningObjectiveSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LearningObjectiveSelectQuery, LearningObjectiveSelectQueryVariables>(
		LearningObjectiveSelectDocument,
		options,
	);
}
export function useLearningObjectiveSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LearningObjectiveSelectQuery, LearningObjectiveSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LearningObjectiveSelectQuery, LearningObjectiveSelectQueryVariables>(
		LearningObjectiveSelectDocument,
		options,
	);
}
export type LearningObjectiveSelectQueryHookResult = ReturnType<typeof useLearningObjectiveSelectQuery>;
export type LearningObjectiveSelectLazyQueryHookResult = ReturnType<typeof useLearningObjectiveSelectLazyQuery>;
export type LearningObjectiveSelectSuspenseQueryHookResult = ReturnType<typeof useLearningObjectiveSelectSuspenseQuery>;
export type LearningObjectiveSelectQueryResult = Apollo.QueryResult<
	LearningObjectiveSelectQuery,
	LearningObjectiveSelectQueryVariables
>;
export const LearningObjectiveUpdateDocument = gql`
	mutation learningObjectiveUpdate($id: ID!, $input: LearningObjectiveUpdateInput!) {
		updateLearningObjective(id: $id, input: $input) {
			...LearningObjectiveDetail
		}
	}
	${LearningObjectiveDetailFragmentDoc}
`;
export type LearningObjectiveUpdateMutationFn = Apollo.MutationFunction<
	LearningObjectiveUpdateMutation,
	LearningObjectiveUpdateMutationVariables
>;

/**
 * __useLearningObjectiveUpdateMutation__
 *
 * To run a mutation, you first call `useLearningObjectiveUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningObjectiveUpdateMutation, { data, loading, error }] = useLearningObjectiveUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLearningObjectiveUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<LearningObjectiveUpdateMutation, LearningObjectiveUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<LearningObjectiveUpdateMutation, LearningObjectiveUpdateMutationVariables>(
		LearningObjectiveUpdateDocument,
		options,
	);
}
export type LearningObjectiveUpdateMutationHookResult = ReturnType<typeof useLearningObjectiveUpdateMutation>;
export type LearningObjectiveUpdateMutationResult = Apollo.MutationResult<LearningObjectiveUpdateMutation>;
export type LearningObjectiveUpdateMutationOptions = Apollo.BaseMutationOptions<
	LearningObjectiveUpdateMutation,
	LearningObjectiveUpdateMutationVariables
>;
export const LearningObjectiveCategoryCountDocument = gql`
	query learningObjectiveCategoryCount(
		$filters: [LearningObjectiveCategoryFilterInput!]
		$pagination: Pagination
		$order: LearningObjectiveCategoryOrder
	) {
		learningObjectiveCategoryConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useLearningObjectiveCategoryCountQuery__
 *
 * To run a query within a React component, call `useLearningObjectiveCategoryCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveCategoryCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningObjectiveCategoryCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLearningObjectiveCategoryCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		LearningObjectiveCategoryCountQuery,
		LearningObjectiveCategoryCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LearningObjectiveCategoryCountQuery, LearningObjectiveCategoryCountQueryVariables>(
		LearningObjectiveCategoryCountDocument,
		options,
	);
}
export function useLearningObjectiveCategoryCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		LearningObjectiveCategoryCountQuery,
		LearningObjectiveCategoryCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LearningObjectiveCategoryCountQuery, LearningObjectiveCategoryCountQueryVariables>(
		LearningObjectiveCategoryCountDocument,
		options,
	);
}
export function useLearningObjectiveCategoryCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		LearningObjectiveCategoryCountQuery,
		LearningObjectiveCategoryCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LearningObjectiveCategoryCountQuery, LearningObjectiveCategoryCountQueryVariables>(
		LearningObjectiveCategoryCountDocument,
		options,
	);
}
export type LearningObjectiveCategoryCountQueryHookResult = ReturnType<typeof useLearningObjectiveCategoryCountQuery>;
export type LearningObjectiveCategoryCountLazyQueryHookResult = ReturnType<
	typeof useLearningObjectiveCategoryCountLazyQuery
>;
export type LearningObjectiveCategoryCountSuspenseQueryHookResult = ReturnType<
	typeof useLearningObjectiveCategoryCountSuspenseQuery
>;
export type LearningObjectiveCategoryCountQueryResult = Apollo.QueryResult<
	LearningObjectiveCategoryCountQuery,
	LearningObjectiveCategoryCountQueryVariables
>;
export const LearningObjectiveCategoryCreateDocument = gql`
	mutation learningObjectiveCategoryCreate($input: LearningObjectiveCategoryCreateInput!) {
		createLearningObjectiveCategory(input: $input) {
			...LearningObjectiveCategoryDetail
		}
	}
	${LearningObjectiveCategoryDetailFragmentDoc}
`;
export type LearningObjectiveCategoryCreateMutationFn = Apollo.MutationFunction<
	LearningObjectiveCategoryCreateMutation,
	LearningObjectiveCategoryCreateMutationVariables
>;

/**
 * __useLearningObjectiveCategoryCreateMutation__
 *
 * To run a mutation, you first call `useLearningObjectiveCategoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveCategoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningObjectiveCategoryCreateMutation, { data, loading, error }] = useLearningObjectiveCategoryCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLearningObjectiveCategoryCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		LearningObjectiveCategoryCreateMutation,
		LearningObjectiveCategoryCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<LearningObjectiveCategoryCreateMutation, LearningObjectiveCategoryCreateMutationVariables>(
		LearningObjectiveCategoryCreateDocument,
		options,
	);
}
export type LearningObjectiveCategoryCreateMutationHookResult = ReturnType<
	typeof useLearningObjectiveCategoryCreateMutation
>;
export type LearningObjectiveCategoryCreateMutationResult =
	Apollo.MutationResult<LearningObjectiveCategoryCreateMutation>;
export type LearningObjectiveCategoryCreateMutationOptions = Apollo.BaseMutationOptions<
	LearningObjectiveCategoryCreateMutation,
	LearningObjectiveCategoryCreateMutationVariables
>;
export const LearningObjectiveCategoryDeleteDocument = gql`
	mutation learningObjectiveCategoryDelete($id: ID!) {
		deleteLearningObjectiveCategory(id: $id)
	}
`;
export type LearningObjectiveCategoryDeleteMutationFn = Apollo.MutationFunction<
	LearningObjectiveCategoryDeleteMutation,
	LearningObjectiveCategoryDeleteMutationVariables
>;

/**
 * __useLearningObjectiveCategoryDeleteMutation__
 *
 * To run a mutation, you first call `useLearningObjectiveCategoryDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveCategoryDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningObjectiveCategoryDeleteMutation, { data, loading, error }] = useLearningObjectiveCategoryDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningObjectiveCategoryDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		LearningObjectiveCategoryDeleteMutation,
		LearningObjectiveCategoryDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<LearningObjectiveCategoryDeleteMutation, LearningObjectiveCategoryDeleteMutationVariables>(
		LearningObjectiveCategoryDeleteDocument,
		options,
	);
}
export type LearningObjectiveCategoryDeleteMutationHookResult = ReturnType<
	typeof useLearningObjectiveCategoryDeleteMutation
>;
export type LearningObjectiveCategoryDeleteMutationResult =
	Apollo.MutationResult<LearningObjectiveCategoryDeleteMutation>;
export type LearningObjectiveCategoryDeleteMutationOptions = Apollo.BaseMutationOptions<
	LearningObjectiveCategoryDeleteMutation,
	LearningObjectiveCategoryDeleteMutationVariables
>;
export const LearningObjectiveCategoryDetailDocument = gql`
	query learningObjectiveCategoryDetail($id: ID!) {
		learningObjectiveCategory(id: $id) {
			...LearningObjectiveCategoryDetail
		}
	}
	${LearningObjectiveCategoryDetailFragmentDoc}
`;

/**
 * __useLearningObjectiveCategoryDetailQuery__
 *
 * To run a query within a React component, call `useLearningObjectiveCategoryDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveCategoryDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningObjectiveCategoryDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningObjectiveCategoryDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		LearningObjectiveCategoryDetailQuery,
		LearningObjectiveCategoryDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LearningObjectiveCategoryDetailQuery, LearningObjectiveCategoryDetailQueryVariables>(
		LearningObjectiveCategoryDetailDocument,
		options,
	);
}
export function useLearningObjectiveCategoryDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		LearningObjectiveCategoryDetailQuery,
		LearningObjectiveCategoryDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LearningObjectiveCategoryDetailQuery, LearningObjectiveCategoryDetailQueryVariables>(
		LearningObjectiveCategoryDetailDocument,
		options,
	);
}
export function useLearningObjectiveCategoryDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		LearningObjectiveCategoryDetailQuery,
		LearningObjectiveCategoryDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LearningObjectiveCategoryDetailQuery, LearningObjectiveCategoryDetailQueryVariables>(
		LearningObjectiveCategoryDetailDocument,
		options,
	);
}
export type LearningObjectiveCategoryDetailQueryHookResult = ReturnType<typeof useLearningObjectiveCategoryDetailQuery>;
export type LearningObjectiveCategoryDetailLazyQueryHookResult = ReturnType<
	typeof useLearningObjectiveCategoryDetailLazyQuery
>;
export type LearningObjectiveCategoryDetailSuspenseQueryHookResult = ReturnType<
	typeof useLearningObjectiveCategoryDetailSuspenseQuery
>;
export type LearningObjectiveCategoryDetailQueryResult = Apollo.QueryResult<
	LearningObjectiveCategoryDetailQuery,
	LearningObjectiveCategoryDetailQueryVariables
>;
export const LearningObjectiveCategoryIndexDocument = gql`
	query learningObjectiveCategoryIndex(
		$filters: [LearningObjectiveCategoryFilterInput!]
		$pagination: Pagination
		$order: LearningObjectiveCategoryOrder
	) {
		learningObjectiveCategoryConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
				}
			}
		}
	}
`;

/**
 * __useLearningObjectiveCategoryIndexQuery__
 *
 * To run a query within a React component, call `useLearningObjectiveCategoryIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveCategoryIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningObjectiveCategoryIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLearningObjectiveCategoryIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		LearningObjectiveCategoryIndexQuery,
		LearningObjectiveCategoryIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LearningObjectiveCategoryIndexQuery, LearningObjectiveCategoryIndexQueryVariables>(
		LearningObjectiveCategoryIndexDocument,
		options,
	);
}
export function useLearningObjectiveCategoryIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		LearningObjectiveCategoryIndexQuery,
		LearningObjectiveCategoryIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LearningObjectiveCategoryIndexQuery, LearningObjectiveCategoryIndexQueryVariables>(
		LearningObjectiveCategoryIndexDocument,
		options,
	);
}
export function useLearningObjectiveCategoryIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		LearningObjectiveCategoryIndexQuery,
		LearningObjectiveCategoryIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LearningObjectiveCategoryIndexQuery, LearningObjectiveCategoryIndexQueryVariables>(
		LearningObjectiveCategoryIndexDocument,
		options,
	);
}
export type LearningObjectiveCategoryIndexQueryHookResult = ReturnType<typeof useLearningObjectiveCategoryIndexQuery>;
export type LearningObjectiveCategoryIndexLazyQueryHookResult = ReturnType<
	typeof useLearningObjectiveCategoryIndexLazyQuery
>;
export type LearningObjectiveCategoryIndexSuspenseQueryHookResult = ReturnType<
	typeof useLearningObjectiveCategoryIndexSuspenseQuery
>;
export type LearningObjectiveCategoryIndexQueryResult = Apollo.QueryResult<
	LearningObjectiveCategoryIndexQuery,
	LearningObjectiveCategoryIndexQueryVariables
>;
export const LearningObjectiveCategoryNameDocument = gql`
	query learningObjectiveCategoryName($id: ID!) {
		learningObjectiveCategory(id: $id) {
			id
			...LearningObjectiveCategoryName
		}
	}
	${LearningObjectiveCategoryNameFragmentDoc}
`;

/**
 * __useLearningObjectiveCategoryNameQuery__
 *
 * To run a query within a React component, call `useLearningObjectiveCategoryNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveCategoryNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningObjectiveCategoryNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningObjectiveCategoryNameQuery(
	baseOptions: Apollo.QueryHookOptions<LearningObjectiveCategoryNameQuery, LearningObjectiveCategoryNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LearningObjectiveCategoryNameQuery, LearningObjectiveCategoryNameQueryVariables>(
		LearningObjectiveCategoryNameDocument,
		options,
	);
}
export function useLearningObjectiveCategoryNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		LearningObjectiveCategoryNameQuery,
		LearningObjectiveCategoryNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LearningObjectiveCategoryNameQuery, LearningObjectiveCategoryNameQueryVariables>(
		LearningObjectiveCategoryNameDocument,
		options,
	);
}
export function useLearningObjectiveCategoryNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		LearningObjectiveCategoryNameQuery,
		LearningObjectiveCategoryNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LearningObjectiveCategoryNameQuery, LearningObjectiveCategoryNameQueryVariables>(
		LearningObjectiveCategoryNameDocument,
		options,
	);
}
export type LearningObjectiveCategoryNameQueryHookResult = ReturnType<typeof useLearningObjectiveCategoryNameQuery>;
export type LearningObjectiveCategoryNameLazyQueryHookResult = ReturnType<
	typeof useLearningObjectiveCategoryNameLazyQuery
>;
export type LearningObjectiveCategoryNameSuspenseQueryHookResult = ReturnType<
	typeof useLearningObjectiveCategoryNameSuspenseQuery
>;
export type LearningObjectiveCategoryNameQueryResult = Apollo.QueryResult<
	LearningObjectiveCategoryNameQuery,
	LearningObjectiveCategoryNameQueryVariables
>;
export const LearningObjectiveCategoryNamesDocument = gql`
	query learningObjectiveCategoryNames(
		$filters: [LearningObjectiveCategoryFilterInput!]
		$pagination: Pagination
		$order: LearningObjectiveCategoryOrder
	) {
		learningObjectiveCategoryConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...LearningObjectiveCategoryName
				}
			}
		}
	}
	${LearningObjectiveCategoryNameFragmentDoc}
`;

/**
 * __useLearningObjectiveCategoryNamesQuery__
 *
 * To run a query within a React component, call `useLearningObjectiveCategoryNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveCategoryNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningObjectiveCategoryNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLearningObjectiveCategoryNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		LearningObjectiveCategoryNamesQuery,
		LearningObjectiveCategoryNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LearningObjectiveCategoryNamesQuery, LearningObjectiveCategoryNamesQueryVariables>(
		LearningObjectiveCategoryNamesDocument,
		options,
	);
}
export function useLearningObjectiveCategoryNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		LearningObjectiveCategoryNamesQuery,
		LearningObjectiveCategoryNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LearningObjectiveCategoryNamesQuery, LearningObjectiveCategoryNamesQueryVariables>(
		LearningObjectiveCategoryNamesDocument,
		options,
	);
}
export function useLearningObjectiveCategoryNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		LearningObjectiveCategoryNamesQuery,
		LearningObjectiveCategoryNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LearningObjectiveCategoryNamesQuery, LearningObjectiveCategoryNamesQueryVariables>(
		LearningObjectiveCategoryNamesDocument,
		options,
	);
}
export type LearningObjectiveCategoryNamesQueryHookResult = ReturnType<typeof useLearningObjectiveCategoryNamesQuery>;
export type LearningObjectiveCategoryNamesLazyQueryHookResult = ReturnType<
	typeof useLearningObjectiveCategoryNamesLazyQuery
>;
export type LearningObjectiveCategoryNamesSuspenseQueryHookResult = ReturnType<
	typeof useLearningObjectiveCategoryNamesSuspenseQuery
>;
export type LearningObjectiveCategoryNamesQueryResult = Apollo.QueryResult<
	LearningObjectiveCategoryNamesQuery,
	LearningObjectiveCategoryNamesQueryVariables
>;
export const LearningObjectiveCategoryPaginationDocument = gql`
	query learningObjectiveCategoryPagination(
		$filters: [LearningObjectiveCategoryFilterInput!]
		$order: LearningObjectiveCategoryOrder
	) {
		learningObjectiveCategoryConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useLearningObjectiveCategoryPaginationQuery__
 *
 * To run a query within a React component, call `useLearningObjectiveCategoryPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveCategoryPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningObjectiveCategoryPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLearningObjectiveCategoryPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		LearningObjectiveCategoryPaginationQuery,
		LearningObjectiveCategoryPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LearningObjectiveCategoryPaginationQuery, LearningObjectiveCategoryPaginationQueryVariables>(
		LearningObjectiveCategoryPaginationDocument,
		options,
	);
}
export function useLearningObjectiveCategoryPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		LearningObjectiveCategoryPaginationQuery,
		LearningObjectiveCategoryPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		LearningObjectiveCategoryPaginationQuery,
		LearningObjectiveCategoryPaginationQueryVariables
	>(LearningObjectiveCategoryPaginationDocument, options);
}
export function useLearningObjectiveCategoryPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		LearningObjectiveCategoryPaginationQuery,
		LearningObjectiveCategoryPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		LearningObjectiveCategoryPaginationQuery,
		LearningObjectiveCategoryPaginationQueryVariables
	>(LearningObjectiveCategoryPaginationDocument, options);
}
export type LearningObjectiveCategoryPaginationQueryHookResult = ReturnType<
	typeof useLearningObjectiveCategoryPaginationQuery
>;
export type LearningObjectiveCategoryPaginationLazyQueryHookResult = ReturnType<
	typeof useLearningObjectiveCategoryPaginationLazyQuery
>;
export type LearningObjectiveCategoryPaginationSuspenseQueryHookResult = ReturnType<
	typeof useLearningObjectiveCategoryPaginationSuspenseQuery
>;
export type LearningObjectiveCategoryPaginationQueryResult = Apollo.QueryResult<
	LearningObjectiveCategoryPaginationQuery,
	LearningObjectiveCategoryPaginationQueryVariables
>;
export const LearningObjectiveCategorySelectDocument = gql`
	query learningObjectiveCategorySelect(
		$filters: [LearningObjectiveCategoryFilterInput!]
		$order: LearningObjectiveCategoryOrder
	) {
		learningObjectiveCategoryConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...LearningObjectiveCategoryName
				}
			}
		}
	}
	${LearningObjectiveCategoryNameFragmentDoc}
`;

/**
 * __useLearningObjectiveCategorySelectQuery__
 *
 * To run a query within a React component, call `useLearningObjectiveCategorySelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveCategorySelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningObjectiveCategorySelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLearningObjectiveCategorySelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		LearningObjectiveCategorySelectQuery,
		LearningObjectiveCategorySelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LearningObjectiveCategorySelectQuery, LearningObjectiveCategorySelectQueryVariables>(
		LearningObjectiveCategorySelectDocument,
		options,
	);
}
export function useLearningObjectiveCategorySelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		LearningObjectiveCategorySelectQuery,
		LearningObjectiveCategorySelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LearningObjectiveCategorySelectQuery, LearningObjectiveCategorySelectQueryVariables>(
		LearningObjectiveCategorySelectDocument,
		options,
	);
}
export function useLearningObjectiveCategorySelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		LearningObjectiveCategorySelectQuery,
		LearningObjectiveCategorySelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LearningObjectiveCategorySelectQuery, LearningObjectiveCategorySelectQueryVariables>(
		LearningObjectiveCategorySelectDocument,
		options,
	);
}
export type LearningObjectiveCategorySelectQueryHookResult = ReturnType<typeof useLearningObjectiveCategorySelectQuery>;
export type LearningObjectiveCategorySelectLazyQueryHookResult = ReturnType<
	typeof useLearningObjectiveCategorySelectLazyQuery
>;
export type LearningObjectiveCategorySelectSuspenseQueryHookResult = ReturnType<
	typeof useLearningObjectiveCategorySelectSuspenseQuery
>;
export type LearningObjectiveCategorySelectQueryResult = Apollo.QueryResult<
	LearningObjectiveCategorySelectQuery,
	LearningObjectiveCategorySelectQueryVariables
>;
export const LearningObjectiveCategoryUpdateDocument = gql`
	mutation learningObjectiveCategoryUpdate($id: ID!, $input: LearningObjectiveCategoryUpdateInput!) {
		updateLearningObjectiveCategory(id: $id, input: $input) {
			...LearningObjectiveCategoryDetail
		}
	}
	${LearningObjectiveCategoryDetailFragmentDoc}
`;
export type LearningObjectiveCategoryUpdateMutationFn = Apollo.MutationFunction<
	LearningObjectiveCategoryUpdateMutation,
	LearningObjectiveCategoryUpdateMutationVariables
>;

/**
 * __useLearningObjectiveCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useLearningObjectiveCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningObjectiveCategoryUpdateMutation, { data, loading, error }] = useLearningObjectiveCategoryUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLearningObjectiveCategoryUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		LearningObjectiveCategoryUpdateMutation,
		LearningObjectiveCategoryUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<LearningObjectiveCategoryUpdateMutation, LearningObjectiveCategoryUpdateMutationVariables>(
		LearningObjectiveCategoryUpdateDocument,
		options,
	);
}
export type LearningObjectiveCategoryUpdateMutationHookResult = ReturnType<
	typeof useLearningObjectiveCategoryUpdateMutation
>;
export type LearningObjectiveCategoryUpdateMutationResult =
	Apollo.MutationResult<LearningObjectiveCategoryUpdateMutation>;
export type LearningObjectiveCategoryUpdateMutationOptions = Apollo.BaseMutationOptions<
	LearningObjectiveCategoryUpdateMutation,
	LearningObjectiveCategoryUpdateMutationVariables
>;
export const LoginRecordCountDocument = gql`
	query loginRecordCount($filters: [LoginRecordFilterInput!], $pagination: Pagination, $order: LoginRecordOrder) {
		loginRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useLoginRecordCountQuery__
 *
 * To run a query within a React component, call `useLoginRecordCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginRecordCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginRecordCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLoginRecordCountQuery(
	baseOptions?: Apollo.QueryHookOptions<LoginRecordCountQuery, LoginRecordCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LoginRecordCountQuery, LoginRecordCountQueryVariables>(LoginRecordCountDocument, options);
}
export function useLoginRecordCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LoginRecordCountQuery, LoginRecordCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LoginRecordCountQuery, LoginRecordCountQueryVariables>(LoginRecordCountDocument, options);
}
export function useLoginRecordCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LoginRecordCountQuery, LoginRecordCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LoginRecordCountQuery, LoginRecordCountQueryVariables>(
		LoginRecordCountDocument,
		options,
	);
}
export type LoginRecordCountQueryHookResult = ReturnType<typeof useLoginRecordCountQuery>;
export type LoginRecordCountLazyQueryHookResult = ReturnType<typeof useLoginRecordCountLazyQuery>;
export type LoginRecordCountSuspenseQueryHookResult = ReturnType<typeof useLoginRecordCountSuspenseQuery>;
export type LoginRecordCountQueryResult = Apollo.QueryResult<LoginRecordCountQuery, LoginRecordCountQueryVariables>;
export const LoginRecordDetailDocument = gql`
	query loginRecordDetail($id: ID!) {
		loginRecord(id: $id) {
			...LoginRecordDetail
		}
	}
	${LoginRecordDetailFragmentDoc}
`;

/**
 * __useLoginRecordDetailQuery__
 *
 * To run a query within a React component, call `useLoginRecordDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginRecordDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginRecordDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoginRecordDetailQuery(
	baseOptions: Apollo.QueryHookOptions<LoginRecordDetailQuery, LoginRecordDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LoginRecordDetailQuery, LoginRecordDetailQueryVariables>(LoginRecordDetailDocument, options);
}
export function useLoginRecordDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LoginRecordDetailQuery, LoginRecordDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LoginRecordDetailQuery, LoginRecordDetailQueryVariables>(
		LoginRecordDetailDocument,
		options,
	);
}
export function useLoginRecordDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LoginRecordDetailQuery, LoginRecordDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LoginRecordDetailQuery, LoginRecordDetailQueryVariables>(
		LoginRecordDetailDocument,
		options,
	);
}
export type LoginRecordDetailQueryHookResult = ReturnType<typeof useLoginRecordDetailQuery>;
export type LoginRecordDetailLazyQueryHookResult = ReturnType<typeof useLoginRecordDetailLazyQuery>;
export type LoginRecordDetailSuspenseQueryHookResult = ReturnType<typeof useLoginRecordDetailSuspenseQuery>;
export type LoginRecordDetailQueryResult = Apollo.QueryResult<LoginRecordDetailQuery, LoginRecordDetailQueryVariables>;
export const LoginRecordIndexDocument = gql`
	query loginRecordIndex($filters: [LoginRecordFilterInput!], $pagination: Pagination, $order: LoginRecordOrder) {
		loginRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					userEmail
					wasBlocked
					wasSuccessful
					isTrusted
				}
			}
		}
	}
`;

/**
 * __useLoginRecordIndexQuery__
 *
 * To run a query within a React component, call `useLoginRecordIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginRecordIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginRecordIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLoginRecordIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<LoginRecordIndexQuery, LoginRecordIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LoginRecordIndexQuery, LoginRecordIndexQueryVariables>(LoginRecordIndexDocument, options);
}
export function useLoginRecordIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LoginRecordIndexQuery, LoginRecordIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LoginRecordIndexQuery, LoginRecordIndexQueryVariables>(LoginRecordIndexDocument, options);
}
export function useLoginRecordIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LoginRecordIndexQuery, LoginRecordIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LoginRecordIndexQuery, LoginRecordIndexQueryVariables>(
		LoginRecordIndexDocument,
		options,
	);
}
export type LoginRecordIndexQueryHookResult = ReturnType<typeof useLoginRecordIndexQuery>;
export type LoginRecordIndexLazyQueryHookResult = ReturnType<typeof useLoginRecordIndexLazyQuery>;
export type LoginRecordIndexSuspenseQueryHookResult = ReturnType<typeof useLoginRecordIndexSuspenseQuery>;
export type LoginRecordIndexQueryResult = Apollo.QueryResult<LoginRecordIndexQuery, LoginRecordIndexQueryVariables>;
export const LoginRecordNameDocument = gql`
	query loginRecordName($id: ID!) {
		loginRecord(id: $id) {
			id
			...LoginRecordName
		}
	}
	${LoginRecordNameFragmentDoc}
`;

/**
 * __useLoginRecordNameQuery__
 *
 * To run a query within a React component, call `useLoginRecordNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginRecordNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginRecordNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoginRecordNameQuery(
	baseOptions: Apollo.QueryHookOptions<LoginRecordNameQuery, LoginRecordNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LoginRecordNameQuery, LoginRecordNameQueryVariables>(LoginRecordNameDocument, options);
}
export function useLoginRecordNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LoginRecordNameQuery, LoginRecordNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LoginRecordNameQuery, LoginRecordNameQueryVariables>(LoginRecordNameDocument, options);
}
export function useLoginRecordNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LoginRecordNameQuery, LoginRecordNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LoginRecordNameQuery, LoginRecordNameQueryVariables>(LoginRecordNameDocument, options);
}
export type LoginRecordNameQueryHookResult = ReturnType<typeof useLoginRecordNameQuery>;
export type LoginRecordNameLazyQueryHookResult = ReturnType<typeof useLoginRecordNameLazyQuery>;
export type LoginRecordNameSuspenseQueryHookResult = ReturnType<typeof useLoginRecordNameSuspenseQuery>;
export type LoginRecordNameQueryResult = Apollo.QueryResult<LoginRecordNameQuery, LoginRecordNameQueryVariables>;
export const LoginRecordNamesDocument = gql`
	query loginRecordNames($filters: [LoginRecordFilterInput!], $pagination: Pagination, $order: LoginRecordOrder) {
		loginRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...LoginRecordName
				}
			}
		}
	}
	${LoginRecordNameFragmentDoc}
`;

/**
 * __useLoginRecordNamesQuery__
 *
 * To run a query within a React component, call `useLoginRecordNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginRecordNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginRecordNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLoginRecordNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<LoginRecordNamesQuery, LoginRecordNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LoginRecordNamesQuery, LoginRecordNamesQueryVariables>(LoginRecordNamesDocument, options);
}
export function useLoginRecordNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LoginRecordNamesQuery, LoginRecordNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LoginRecordNamesQuery, LoginRecordNamesQueryVariables>(LoginRecordNamesDocument, options);
}
export function useLoginRecordNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LoginRecordNamesQuery, LoginRecordNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LoginRecordNamesQuery, LoginRecordNamesQueryVariables>(
		LoginRecordNamesDocument,
		options,
	);
}
export type LoginRecordNamesQueryHookResult = ReturnType<typeof useLoginRecordNamesQuery>;
export type LoginRecordNamesLazyQueryHookResult = ReturnType<typeof useLoginRecordNamesLazyQuery>;
export type LoginRecordNamesSuspenseQueryHookResult = ReturnType<typeof useLoginRecordNamesSuspenseQuery>;
export type LoginRecordNamesQueryResult = Apollo.QueryResult<LoginRecordNamesQuery, LoginRecordNamesQueryVariables>;
export const LoginRecordPaginationDocument = gql`
	query loginRecordPagination($filters: [LoginRecordFilterInput!], $order: LoginRecordOrder) {
		loginRecordConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useLoginRecordPaginationQuery__
 *
 * To run a query within a React component, call `useLoginRecordPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginRecordPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginRecordPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLoginRecordPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<LoginRecordPaginationQuery, LoginRecordPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LoginRecordPaginationQuery, LoginRecordPaginationQueryVariables>(
		LoginRecordPaginationDocument,
		options,
	);
}
export function useLoginRecordPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LoginRecordPaginationQuery, LoginRecordPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LoginRecordPaginationQuery, LoginRecordPaginationQueryVariables>(
		LoginRecordPaginationDocument,
		options,
	);
}
export function useLoginRecordPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LoginRecordPaginationQuery, LoginRecordPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LoginRecordPaginationQuery, LoginRecordPaginationQueryVariables>(
		LoginRecordPaginationDocument,
		options,
	);
}
export type LoginRecordPaginationQueryHookResult = ReturnType<typeof useLoginRecordPaginationQuery>;
export type LoginRecordPaginationLazyQueryHookResult = ReturnType<typeof useLoginRecordPaginationLazyQuery>;
export type LoginRecordPaginationSuspenseQueryHookResult = ReturnType<typeof useLoginRecordPaginationSuspenseQuery>;
export type LoginRecordPaginationQueryResult = Apollo.QueryResult<
	LoginRecordPaginationQuery,
	LoginRecordPaginationQueryVariables
>;
export const LoginRecordSelectDocument = gql`
	query loginRecordSelect($filters: [LoginRecordFilterInput!], $order: LoginRecordOrder) {
		loginRecordConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...LoginRecordName
				}
			}
		}
	}
	${LoginRecordNameFragmentDoc}
`;

/**
 * __useLoginRecordSelectQuery__
 *
 * To run a query within a React component, call `useLoginRecordSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginRecordSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginRecordSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLoginRecordSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<LoginRecordSelectQuery, LoginRecordSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LoginRecordSelectQuery, LoginRecordSelectQueryVariables>(LoginRecordSelectDocument, options);
}
export function useLoginRecordSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LoginRecordSelectQuery, LoginRecordSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LoginRecordSelectQuery, LoginRecordSelectQueryVariables>(
		LoginRecordSelectDocument,
		options,
	);
}
export function useLoginRecordSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<LoginRecordSelectQuery, LoginRecordSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LoginRecordSelectQuery, LoginRecordSelectQueryVariables>(
		LoginRecordSelectDocument,
		options,
	);
}
export type LoginRecordSelectQueryHookResult = ReturnType<typeof useLoginRecordSelectQuery>;
export type LoginRecordSelectLazyQueryHookResult = ReturnType<typeof useLoginRecordSelectLazyQuery>;
export type LoginRecordSelectSuspenseQueryHookResult = ReturnType<typeof useLoginRecordSelectSuspenseQuery>;
export type LoginRecordSelectQueryResult = Apollo.QueryResult<LoginRecordSelectQuery, LoginRecordSelectQueryVariables>;
export const MFAFactorCountDocument = gql`
	query mfaFactorCount($filters: [MFAFactorFilterInput!], $pagination: Pagination, $order: MFAFactorOrder) {
		mfaFactorConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useMFAFactorCountQuery__
 *
 * To run a query within a React component, call `useMFAFactorCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMFAFactorCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMFAFactorCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMFAFactorCountQuery(
	baseOptions?: Apollo.QueryHookOptions<MFAFactorCountQuery, MFAFactorCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MFAFactorCountQuery, MFAFactorCountQueryVariables>(MFAFactorCountDocument, options);
}
export function useMFAFactorCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MFAFactorCountQuery, MFAFactorCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MFAFactorCountQuery, MFAFactorCountQueryVariables>(MFAFactorCountDocument, options);
}
export function useMFAFactorCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MFAFactorCountQuery, MFAFactorCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MFAFactorCountQuery, MFAFactorCountQueryVariables>(MFAFactorCountDocument, options);
}
export type MFAFactorCountQueryHookResult = ReturnType<typeof useMFAFactorCountQuery>;
export type MFAFactorCountLazyQueryHookResult = ReturnType<typeof useMFAFactorCountLazyQuery>;
export type MFAFactorCountSuspenseQueryHookResult = ReturnType<typeof useMFAFactorCountSuspenseQuery>;
export type MFAFactorCountQueryResult = Apollo.QueryResult<MFAFactorCountQuery, MFAFactorCountQueryVariables>;
export const MFAFactorDetailDocument = gql`
	query mfaFactorDetail($id: ID!) {
		mfaFactor(id: $id) {
			...MFAFactorDetail
		}
	}
	${MFAFactorDetailFragmentDoc}
`;

/**
 * __useMFAFactorDetailQuery__
 *
 * To run a query within a React component, call `useMFAFactorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMFAFactorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMFAFactorDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMFAFactorDetailQuery(
	baseOptions: Apollo.QueryHookOptions<MFAFactorDetailQuery, MFAFactorDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MFAFactorDetailQuery, MFAFactorDetailQueryVariables>(MFAFactorDetailDocument, options);
}
export function useMFAFactorDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MFAFactorDetailQuery, MFAFactorDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MFAFactorDetailQuery, MFAFactorDetailQueryVariables>(MFAFactorDetailDocument, options);
}
export function useMFAFactorDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MFAFactorDetailQuery, MFAFactorDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MFAFactorDetailQuery, MFAFactorDetailQueryVariables>(MFAFactorDetailDocument, options);
}
export type MFAFactorDetailQueryHookResult = ReturnType<typeof useMFAFactorDetailQuery>;
export type MFAFactorDetailLazyQueryHookResult = ReturnType<typeof useMFAFactorDetailLazyQuery>;
export type MFAFactorDetailSuspenseQueryHookResult = ReturnType<typeof useMFAFactorDetailSuspenseQuery>;
export type MFAFactorDetailQueryResult = Apollo.QueryResult<MFAFactorDetailQuery, MFAFactorDetailQueryVariables>;
export const MFAFactorIndexDocument = gql`
	query mfaFactorIndex($filters: [MFAFactorFilterInput!], $pagination: Pagination, $order: MFAFactorOrder) {
		mfaFactorConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					count
					isApp
					email
					sms
					isVerified
				}
			}
		}
	}
`;

/**
 * __useMFAFactorIndexQuery__
 *
 * To run a query within a React component, call `useMFAFactorIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useMFAFactorIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMFAFactorIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMFAFactorIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<MFAFactorIndexQuery, MFAFactorIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MFAFactorIndexQuery, MFAFactorIndexQueryVariables>(MFAFactorIndexDocument, options);
}
export function useMFAFactorIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MFAFactorIndexQuery, MFAFactorIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MFAFactorIndexQuery, MFAFactorIndexQueryVariables>(MFAFactorIndexDocument, options);
}
export function useMFAFactorIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MFAFactorIndexQuery, MFAFactorIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MFAFactorIndexQuery, MFAFactorIndexQueryVariables>(MFAFactorIndexDocument, options);
}
export type MFAFactorIndexQueryHookResult = ReturnType<typeof useMFAFactorIndexQuery>;
export type MFAFactorIndexLazyQueryHookResult = ReturnType<typeof useMFAFactorIndexLazyQuery>;
export type MFAFactorIndexSuspenseQueryHookResult = ReturnType<typeof useMFAFactorIndexSuspenseQuery>;
export type MFAFactorIndexQueryResult = Apollo.QueryResult<MFAFactorIndexQuery, MFAFactorIndexQueryVariables>;
export const MFAFactorNameDocument = gql`
	query mfaFactorName($id: ID!) {
		mfaFactor(id: $id) {
			id
			...MFAFactorName
		}
	}
	${MFAFactorNameFragmentDoc}
`;

/**
 * __useMFAFactorNameQuery__
 *
 * To run a query within a React component, call `useMFAFactorNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useMFAFactorNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMFAFactorNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMFAFactorNameQuery(
	baseOptions: Apollo.QueryHookOptions<MFAFactorNameQuery, MFAFactorNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MFAFactorNameQuery, MFAFactorNameQueryVariables>(MFAFactorNameDocument, options);
}
export function useMFAFactorNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MFAFactorNameQuery, MFAFactorNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MFAFactorNameQuery, MFAFactorNameQueryVariables>(MFAFactorNameDocument, options);
}
export function useMFAFactorNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MFAFactorNameQuery, MFAFactorNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MFAFactorNameQuery, MFAFactorNameQueryVariables>(MFAFactorNameDocument, options);
}
export type MFAFactorNameQueryHookResult = ReturnType<typeof useMFAFactorNameQuery>;
export type MFAFactorNameLazyQueryHookResult = ReturnType<typeof useMFAFactorNameLazyQuery>;
export type MFAFactorNameSuspenseQueryHookResult = ReturnType<typeof useMFAFactorNameSuspenseQuery>;
export type MFAFactorNameQueryResult = Apollo.QueryResult<MFAFactorNameQuery, MFAFactorNameQueryVariables>;
export const MFAFactorNamesDocument = gql`
	query mfaFactorNames($filters: [MFAFactorFilterInput!], $pagination: Pagination, $order: MFAFactorOrder) {
		mfaFactorConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...MFAFactorName
				}
			}
		}
	}
	${MFAFactorNameFragmentDoc}
`;

/**
 * __useMFAFactorNamesQuery__
 *
 * To run a query within a React component, call `useMFAFactorNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMFAFactorNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMFAFactorNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMFAFactorNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<MFAFactorNamesQuery, MFAFactorNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MFAFactorNamesQuery, MFAFactorNamesQueryVariables>(MFAFactorNamesDocument, options);
}
export function useMFAFactorNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MFAFactorNamesQuery, MFAFactorNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MFAFactorNamesQuery, MFAFactorNamesQueryVariables>(MFAFactorNamesDocument, options);
}
export function useMFAFactorNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MFAFactorNamesQuery, MFAFactorNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MFAFactorNamesQuery, MFAFactorNamesQueryVariables>(MFAFactorNamesDocument, options);
}
export type MFAFactorNamesQueryHookResult = ReturnType<typeof useMFAFactorNamesQuery>;
export type MFAFactorNamesLazyQueryHookResult = ReturnType<typeof useMFAFactorNamesLazyQuery>;
export type MFAFactorNamesSuspenseQueryHookResult = ReturnType<typeof useMFAFactorNamesSuspenseQuery>;
export type MFAFactorNamesQueryResult = Apollo.QueryResult<MFAFactorNamesQuery, MFAFactorNamesQueryVariables>;
export const MFAFactorPaginationDocument = gql`
	query mfaFactorPagination($filters: [MFAFactorFilterInput!], $order: MFAFactorOrder) {
		mfaFactorConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useMFAFactorPaginationQuery__
 *
 * To run a query within a React component, call `useMFAFactorPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMFAFactorPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMFAFactorPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMFAFactorPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<MFAFactorPaginationQuery, MFAFactorPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MFAFactorPaginationQuery, MFAFactorPaginationQueryVariables>(
		MFAFactorPaginationDocument,
		options,
	);
}
export function useMFAFactorPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MFAFactorPaginationQuery, MFAFactorPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MFAFactorPaginationQuery, MFAFactorPaginationQueryVariables>(
		MFAFactorPaginationDocument,
		options,
	);
}
export function useMFAFactorPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MFAFactorPaginationQuery, MFAFactorPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MFAFactorPaginationQuery, MFAFactorPaginationQueryVariables>(
		MFAFactorPaginationDocument,
		options,
	);
}
export type MFAFactorPaginationQueryHookResult = ReturnType<typeof useMFAFactorPaginationQuery>;
export type MFAFactorPaginationLazyQueryHookResult = ReturnType<typeof useMFAFactorPaginationLazyQuery>;
export type MFAFactorPaginationSuspenseQueryHookResult = ReturnType<typeof useMFAFactorPaginationSuspenseQuery>;
export type MFAFactorPaginationQueryResult = Apollo.QueryResult<
	MFAFactorPaginationQuery,
	MFAFactorPaginationQueryVariables
>;
export const MFAFactorSelectDocument = gql`
	query mfaFactorSelect($filters: [MFAFactorFilterInput!], $order: MFAFactorOrder) {
		mfaFactorConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...MFAFactorName
				}
			}
		}
	}
	${MFAFactorNameFragmentDoc}
`;

/**
 * __useMFAFactorSelectQuery__
 *
 * To run a query within a React component, call `useMFAFactorSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMFAFactorSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMFAFactorSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMFAFactorSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<MFAFactorSelectQuery, MFAFactorSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MFAFactorSelectQuery, MFAFactorSelectQueryVariables>(MFAFactorSelectDocument, options);
}
export function useMFAFactorSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MFAFactorSelectQuery, MFAFactorSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MFAFactorSelectQuery, MFAFactorSelectQueryVariables>(MFAFactorSelectDocument, options);
}
export function useMFAFactorSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MFAFactorSelectQuery, MFAFactorSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MFAFactorSelectQuery, MFAFactorSelectQueryVariables>(MFAFactorSelectDocument, options);
}
export type MFAFactorSelectQueryHookResult = ReturnType<typeof useMFAFactorSelectQuery>;
export type MFAFactorSelectLazyQueryHookResult = ReturnType<typeof useMFAFactorSelectLazyQuery>;
export type MFAFactorSelectSuspenseQueryHookResult = ReturnType<typeof useMFAFactorSelectSuspenseQuery>;
export type MFAFactorSelectQueryResult = Apollo.QueryResult<MFAFactorSelectQuery, MFAFactorSelectQueryVariables>;
export const MFAInvalidOTPAttemptCountDocument = gql`
	query mfaInvalidOTPAttemptCount(
		$filters: [MFAInvalidOTPAttemptFilterInput!]
		$pagination: Pagination
		$order: MFAInvalidOTPAttemptOrder
	) {
		mfaInvalidOTPAttemptConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useMFAInvalidOTPAttemptCountQuery__
 *
 * To run a query within a React component, call `useMFAInvalidOTPAttemptCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMFAInvalidOTPAttemptCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMFAInvalidOTPAttemptCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMFAInvalidOTPAttemptCountQuery(
	baseOptions?: Apollo.QueryHookOptions<MFAInvalidOTPAttemptCountQuery, MFAInvalidOTPAttemptCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MFAInvalidOTPAttemptCountQuery, MFAInvalidOTPAttemptCountQueryVariables>(
		MFAInvalidOTPAttemptCountDocument,
		options,
	);
}
export function useMFAInvalidOTPAttemptCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MFAInvalidOTPAttemptCountQuery, MFAInvalidOTPAttemptCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MFAInvalidOTPAttemptCountQuery, MFAInvalidOTPAttemptCountQueryVariables>(
		MFAInvalidOTPAttemptCountDocument,
		options,
	);
}
export function useMFAInvalidOTPAttemptCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MFAInvalidOTPAttemptCountQuery,
		MFAInvalidOTPAttemptCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MFAInvalidOTPAttemptCountQuery, MFAInvalidOTPAttemptCountQueryVariables>(
		MFAInvalidOTPAttemptCountDocument,
		options,
	);
}
export type MFAInvalidOTPAttemptCountQueryHookResult = ReturnType<typeof useMFAInvalidOTPAttemptCountQuery>;
export type MFAInvalidOTPAttemptCountLazyQueryHookResult = ReturnType<typeof useMFAInvalidOTPAttemptCountLazyQuery>;
export type MFAInvalidOTPAttemptCountSuspenseQueryHookResult = ReturnType<
	typeof useMFAInvalidOTPAttemptCountSuspenseQuery
>;
export type MFAInvalidOTPAttemptCountQueryResult = Apollo.QueryResult<
	MFAInvalidOTPAttemptCountQuery,
	MFAInvalidOTPAttemptCountQueryVariables
>;
export const MFAInvalidOTPAttemptDetailDocument = gql`
	query mfaInvalidOTPAttemptDetail($id: ID!) {
		mfaInvalidOTPAttempt(id: $id) {
			...MFAInvalidOTPAttemptDetail
		}
	}
	${MFAInvalidOTPAttemptDetailFragmentDoc}
`;

/**
 * __useMFAInvalidOTPAttemptDetailQuery__
 *
 * To run a query within a React component, call `useMFAInvalidOTPAttemptDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMFAInvalidOTPAttemptDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMFAInvalidOTPAttemptDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMFAInvalidOTPAttemptDetailQuery(
	baseOptions: Apollo.QueryHookOptions<MFAInvalidOTPAttemptDetailQuery, MFAInvalidOTPAttemptDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MFAInvalidOTPAttemptDetailQuery, MFAInvalidOTPAttemptDetailQueryVariables>(
		MFAInvalidOTPAttemptDetailDocument,
		options,
	);
}
export function useMFAInvalidOTPAttemptDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MFAInvalidOTPAttemptDetailQuery, MFAInvalidOTPAttemptDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MFAInvalidOTPAttemptDetailQuery, MFAInvalidOTPAttemptDetailQueryVariables>(
		MFAInvalidOTPAttemptDetailDocument,
		options,
	);
}
export function useMFAInvalidOTPAttemptDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MFAInvalidOTPAttemptDetailQuery,
		MFAInvalidOTPAttemptDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MFAInvalidOTPAttemptDetailQuery, MFAInvalidOTPAttemptDetailQueryVariables>(
		MFAInvalidOTPAttemptDetailDocument,
		options,
	);
}
export type MFAInvalidOTPAttemptDetailQueryHookResult = ReturnType<typeof useMFAInvalidOTPAttemptDetailQuery>;
export type MFAInvalidOTPAttemptDetailLazyQueryHookResult = ReturnType<typeof useMFAInvalidOTPAttemptDetailLazyQuery>;
export type MFAInvalidOTPAttemptDetailSuspenseQueryHookResult = ReturnType<
	typeof useMFAInvalidOTPAttemptDetailSuspenseQuery
>;
export type MFAInvalidOTPAttemptDetailQueryResult = Apollo.QueryResult<
	MFAInvalidOTPAttemptDetailQuery,
	MFAInvalidOTPAttemptDetailQueryVariables
>;
export const MFAInvalidOTPAttemptIndexDocument = gql`
	query mfaInvalidOTPAttemptIndex(
		$filters: [MFAInvalidOTPAttemptFilterInput!]
		$pagination: Pagination
		$order: MFAInvalidOTPAttemptOrder
	) {
		mfaInvalidOTPAttemptConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
				}
			}
		}
	}
`;

/**
 * __useMFAInvalidOTPAttemptIndexQuery__
 *
 * To run a query within a React component, call `useMFAInvalidOTPAttemptIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useMFAInvalidOTPAttemptIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMFAInvalidOTPAttemptIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMFAInvalidOTPAttemptIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<MFAInvalidOTPAttemptIndexQuery, MFAInvalidOTPAttemptIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MFAInvalidOTPAttemptIndexQuery, MFAInvalidOTPAttemptIndexQueryVariables>(
		MFAInvalidOTPAttemptIndexDocument,
		options,
	);
}
export function useMFAInvalidOTPAttemptIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MFAInvalidOTPAttemptIndexQuery, MFAInvalidOTPAttemptIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MFAInvalidOTPAttemptIndexQuery, MFAInvalidOTPAttemptIndexQueryVariables>(
		MFAInvalidOTPAttemptIndexDocument,
		options,
	);
}
export function useMFAInvalidOTPAttemptIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MFAInvalidOTPAttemptIndexQuery,
		MFAInvalidOTPAttemptIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MFAInvalidOTPAttemptIndexQuery, MFAInvalidOTPAttemptIndexQueryVariables>(
		MFAInvalidOTPAttemptIndexDocument,
		options,
	);
}
export type MFAInvalidOTPAttemptIndexQueryHookResult = ReturnType<typeof useMFAInvalidOTPAttemptIndexQuery>;
export type MFAInvalidOTPAttemptIndexLazyQueryHookResult = ReturnType<typeof useMFAInvalidOTPAttemptIndexLazyQuery>;
export type MFAInvalidOTPAttemptIndexSuspenseQueryHookResult = ReturnType<
	typeof useMFAInvalidOTPAttemptIndexSuspenseQuery
>;
export type MFAInvalidOTPAttemptIndexQueryResult = Apollo.QueryResult<
	MFAInvalidOTPAttemptIndexQuery,
	MFAInvalidOTPAttemptIndexQueryVariables
>;
export const MFAInvalidOTPAttemptNameDocument = gql`
	query mfaInvalidOTPAttemptName($id: ID!) {
		mfaInvalidOTPAttempt(id: $id) {
			id
			...MFAInvalidOTPAttemptName
		}
	}
	${MFAInvalidOTPAttemptNameFragmentDoc}
`;

/**
 * __useMFAInvalidOTPAttemptNameQuery__
 *
 * To run a query within a React component, call `useMFAInvalidOTPAttemptNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useMFAInvalidOTPAttemptNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMFAInvalidOTPAttemptNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMFAInvalidOTPAttemptNameQuery(
	baseOptions: Apollo.QueryHookOptions<MFAInvalidOTPAttemptNameQuery, MFAInvalidOTPAttemptNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MFAInvalidOTPAttemptNameQuery, MFAInvalidOTPAttemptNameQueryVariables>(
		MFAInvalidOTPAttemptNameDocument,
		options,
	);
}
export function useMFAInvalidOTPAttemptNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MFAInvalidOTPAttemptNameQuery, MFAInvalidOTPAttemptNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MFAInvalidOTPAttemptNameQuery, MFAInvalidOTPAttemptNameQueryVariables>(
		MFAInvalidOTPAttemptNameDocument,
		options,
	);
}
export function useMFAInvalidOTPAttemptNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MFAInvalidOTPAttemptNameQuery, MFAInvalidOTPAttemptNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MFAInvalidOTPAttemptNameQuery, MFAInvalidOTPAttemptNameQueryVariables>(
		MFAInvalidOTPAttemptNameDocument,
		options,
	);
}
export type MFAInvalidOTPAttemptNameQueryHookResult = ReturnType<typeof useMFAInvalidOTPAttemptNameQuery>;
export type MFAInvalidOTPAttemptNameLazyQueryHookResult = ReturnType<typeof useMFAInvalidOTPAttemptNameLazyQuery>;
export type MFAInvalidOTPAttemptNameSuspenseQueryHookResult = ReturnType<
	typeof useMFAInvalidOTPAttemptNameSuspenseQuery
>;
export type MFAInvalidOTPAttemptNameQueryResult = Apollo.QueryResult<
	MFAInvalidOTPAttemptNameQuery,
	MFAInvalidOTPAttemptNameQueryVariables
>;
export const MFAInvalidOTPAttemptNamesDocument = gql`
	query mfaInvalidOTPAttemptNames(
		$filters: [MFAInvalidOTPAttemptFilterInput!]
		$pagination: Pagination
		$order: MFAInvalidOTPAttemptOrder
	) {
		mfaInvalidOTPAttemptConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...MFAInvalidOTPAttemptName
				}
			}
		}
	}
	${MFAInvalidOTPAttemptNameFragmentDoc}
`;

/**
 * __useMFAInvalidOTPAttemptNamesQuery__
 *
 * To run a query within a React component, call `useMFAInvalidOTPAttemptNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMFAInvalidOTPAttemptNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMFAInvalidOTPAttemptNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMFAInvalidOTPAttemptNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<MFAInvalidOTPAttemptNamesQuery, MFAInvalidOTPAttemptNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MFAInvalidOTPAttemptNamesQuery, MFAInvalidOTPAttemptNamesQueryVariables>(
		MFAInvalidOTPAttemptNamesDocument,
		options,
	);
}
export function useMFAInvalidOTPAttemptNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MFAInvalidOTPAttemptNamesQuery, MFAInvalidOTPAttemptNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MFAInvalidOTPAttemptNamesQuery, MFAInvalidOTPAttemptNamesQueryVariables>(
		MFAInvalidOTPAttemptNamesDocument,
		options,
	);
}
export function useMFAInvalidOTPAttemptNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MFAInvalidOTPAttemptNamesQuery,
		MFAInvalidOTPAttemptNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MFAInvalidOTPAttemptNamesQuery, MFAInvalidOTPAttemptNamesQueryVariables>(
		MFAInvalidOTPAttemptNamesDocument,
		options,
	);
}
export type MFAInvalidOTPAttemptNamesQueryHookResult = ReturnType<typeof useMFAInvalidOTPAttemptNamesQuery>;
export type MFAInvalidOTPAttemptNamesLazyQueryHookResult = ReturnType<typeof useMFAInvalidOTPAttemptNamesLazyQuery>;
export type MFAInvalidOTPAttemptNamesSuspenseQueryHookResult = ReturnType<
	typeof useMFAInvalidOTPAttemptNamesSuspenseQuery
>;
export type MFAInvalidOTPAttemptNamesQueryResult = Apollo.QueryResult<
	MFAInvalidOTPAttemptNamesQuery,
	MFAInvalidOTPAttemptNamesQueryVariables
>;
export const MFAInvalidOTPAttemptPaginationDocument = gql`
	query mfaInvalidOTPAttemptPagination(
		$filters: [MFAInvalidOTPAttemptFilterInput!]
		$order: MFAInvalidOTPAttemptOrder
	) {
		mfaInvalidOTPAttemptConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useMFAInvalidOTPAttemptPaginationQuery__
 *
 * To run a query within a React component, call `useMFAInvalidOTPAttemptPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMFAInvalidOTPAttemptPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMFAInvalidOTPAttemptPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMFAInvalidOTPAttemptPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MFAInvalidOTPAttemptPaginationQuery,
		MFAInvalidOTPAttemptPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MFAInvalidOTPAttemptPaginationQuery, MFAInvalidOTPAttemptPaginationQueryVariables>(
		MFAInvalidOTPAttemptPaginationDocument,
		options,
	);
}
export function useMFAInvalidOTPAttemptPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MFAInvalidOTPAttemptPaginationQuery,
		MFAInvalidOTPAttemptPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MFAInvalidOTPAttemptPaginationQuery, MFAInvalidOTPAttemptPaginationQueryVariables>(
		MFAInvalidOTPAttemptPaginationDocument,
		options,
	);
}
export function useMFAInvalidOTPAttemptPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MFAInvalidOTPAttemptPaginationQuery,
		MFAInvalidOTPAttemptPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MFAInvalidOTPAttemptPaginationQuery, MFAInvalidOTPAttemptPaginationQueryVariables>(
		MFAInvalidOTPAttemptPaginationDocument,
		options,
	);
}
export type MFAInvalidOTPAttemptPaginationQueryHookResult = ReturnType<typeof useMFAInvalidOTPAttemptPaginationQuery>;
export type MFAInvalidOTPAttemptPaginationLazyQueryHookResult = ReturnType<
	typeof useMFAInvalidOTPAttemptPaginationLazyQuery
>;
export type MFAInvalidOTPAttemptPaginationSuspenseQueryHookResult = ReturnType<
	typeof useMFAInvalidOTPAttemptPaginationSuspenseQuery
>;
export type MFAInvalidOTPAttemptPaginationQueryResult = Apollo.QueryResult<
	MFAInvalidOTPAttemptPaginationQuery,
	MFAInvalidOTPAttemptPaginationQueryVariables
>;
export const MFAInvalidOTPAttemptSelectDocument = gql`
	query mfaInvalidOTPAttemptSelect($filters: [MFAInvalidOTPAttemptFilterInput!], $order: MFAInvalidOTPAttemptOrder) {
		mfaInvalidOTPAttemptConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...MFAInvalidOTPAttemptName
				}
			}
		}
	}
	${MFAInvalidOTPAttemptNameFragmentDoc}
`;

/**
 * __useMFAInvalidOTPAttemptSelectQuery__
 *
 * To run a query within a React component, call `useMFAInvalidOTPAttemptSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMFAInvalidOTPAttemptSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMFAInvalidOTPAttemptSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMFAInvalidOTPAttemptSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<MFAInvalidOTPAttemptSelectQuery, MFAInvalidOTPAttemptSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MFAInvalidOTPAttemptSelectQuery, MFAInvalidOTPAttemptSelectQueryVariables>(
		MFAInvalidOTPAttemptSelectDocument,
		options,
	);
}
export function useMFAInvalidOTPAttemptSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MFAInvalidOTPAttemptSelectQuery, MFAInvalidOTPAttemptSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MFAInvalidOTPAttemptSelectQuery, MFAInvalidOTPAttemptSelectQueryVariables>(
		MFAInvalidOTPAttemptSelectDocument,
		options,
	);
}
export function useMFAInvalidOTPAttemptSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MFAInvalidOTPAttemptSelectQuery,
		MFAInvalidOTPAttemptSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MFAInvalidOTPAttemptSelectQuery, MFAInvalidOTPAttemptSelectQueryVariables>(
		MFAInvalidOTPAttemptSelectDocument,
		options,
	);
}
export type MFAInvalidOTPAttemptSelectQueryHookResult = ReturnType<typeof useMFAInvalidOTPAttemptSelectQuery>;
export type MFAInvalidOTPAttemptSelectLazyQueryHookResult = ReturnType<typeof useMFAInvalidOTPAttemptSelectLazyQuery>;
export type MFAInvalidOTPAttemptSelectSuspenseQueryHookResult = ReturnType<
	typeof useMFAInvalidOTPAttemptSelectSuspenseQuery
>;
export type MFAInvalidOTPAttemptSelectQueryResult = Apollo.QueryResult<
	MFAInvalidOTPAttemptSelectQuery,
	MFAInvalidOTPAttemptSelectQueryVariables
>;
export const MarkValueCountDocument = gql`
	query markValueCount($filters: [MarkValueFilterInput!], $pagination: Pagination, $order: MarkValueOrder) {
		markValueConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useMarkValueCountQuery__
 *
 * To run a query within a React component, call `useMarkValueCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkValueCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkValueCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMarkValueCountQuery(
	baseOptions?: Apollo.QueryHookOptions<MarkValueCountQuery, MarkValueCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MarkValueCountQuery, MarkValueCountQueryVariables>(MarkValueCountDocument, options);
}
export function useMarkValueCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MarkValueCountQuery, MarkValueCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MarkValueCountQuery, MarkValueCountQueryVariables>(MarkValueCountDocument, options);
}
export function useMarkValueCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MarkValueCountQuery, MarkValueCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MarkValueCountQuery, MarkValueCountQueryVariables>(MarkValueCountDocument, options);
}
export type MarkValueCountQueryHookResult = ReturnType<typeof useMarkValueCountQuery>;
export type MarkValueCountLazyQueryHookResult = ReturnType<typeof useMarkValueCountLazyQuery>;
export type MarkValueCountSuspenseQueryHookResult = ReturnType<typeof useMarkValueCountSuspenseQuery>;
export type MarkValueCountQueryResult = Apollo.QueryResult<MarkValueCountQuery, MarkValueCountQueryVariables>;
export const MarkValueCreateDocument = gql`
	mutation markValueCreate($input: MarkValueCreateInput!) {
		createMarkValue(input: $input) {
			...MarkValueDetail
		}
	}
	${MarkValueDetailFragmentDoc}
`;
export type MarkValueCreateMutationFn = Apollo.MutationFunction<
	MarkValueCreateMutation,
	MarkValueCreateMutationVariables
>;

/**
 * __useMarkValueCreateMutation__
 *
 * To run a mutation, you first call `useMarkValueCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkValueCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markValueCreateMutation, { data, loading, error }] = useMarkValueCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkValueCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<MarkValueCreateMutation, MarkValueCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MarkValueCreateMutation, MarkValueCreateMutationVariables>(
		MarkValueCreateDocument,
		options,
	);
}
export type MarkValueCreateMutationHookResult = ReturnType<typeof useMarkValueCreateMutation>;
export type MarkValueCreateMutationResult = Apollo.MutationResult<MarkValueCreateMutation>;
export type MarkValueCreateMutationOptions = Apollo.BaseMutationOptions<
	MarkValueCreateMutation,
	MarkValueCreateMutationVariables
>;
export const MarkValueDeleteDocument = gql`
	mutation markValueDelete($id: ID!) {
		deleteMarkValue(id: $id)
	}
`;
export type MarkValueDeleteMutationFn = Apollo.MutationFunction<
	MarkValueDeleteMutation,
	MarkValueDeleteMutationVariables
>;

/**
 * __useMarkValueDeleteMutation__
 *
 * To run a mutation, you first call `useMarkValueDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkValueDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markValueDeleteMutation, { data, loading, error }] = useMarkValueDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkValueDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<MarkValueDeleteMutation, MarkValueDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MarkValueDeleteMutation, MarkValueDeleteMutationVariables>(
		MarkValueDeleteDocument,
		options,
	);
}
export type MarkValueDeleteMutationHookResult = ReturnType<typeof useMarkValueDeleteMutation>;
export type MarkValueDeleteMutationResult = Apollo.MutationResult<MarkValueDeleteMutation>;
export type MarkValueDeleteMutationOptions = Apollo.BaseMutationOptions<
	MarkValueDeleteMutation,
	MarkValueDeleteMutationVariables
>;
export const MarkValueDetailDocument = gql`
	query markValueDetail($id: ID!) {
		markValue(id: $id) {
			...MarkValueDetail
		}
	}
	${MarkValueDetailFragmentDoc}
`;

/**
 * __useMarkValueDetailQuery__
 *
 * To run a query within a React component, call `useMarkValueDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkValueDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkValueDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkValueDetailQuery(
	baseOptions: Apollo.QueryHookOptions<MarkValueDetailQuery, MarkValueDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MarkValueDetailQuery, MarkValueDetailQueryVariables>(MarkValueDetailDocument, options);
}
export function useMarkValueDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MarkValueDetailQuery, MarkValueDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MarkValueDetailQuery, MarkValueDetailQueryVariables>(MarkValueDetailDocument, options);
}
export function useMarkValueDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MarkValueDetailQuery, MarkValueDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MarkValueDetailQuery, MarkValueDetailQueryVariables>(MarkValueDetailDocument, options);
}
export type MarkValueDetailQueryHookResult = ReturnType<typeof useMarkValueDetailQuery>;
export type MarkValueDetailLazyQueryHookResult = ReturnType<typeof useMarkValueDetailLazyQuery>;
export type MarkValueDetailSuspenseQueryHookResult = ReturnType<typeof useMarkValueDetailSuspenseQuery>;
export type MarkValueDetailQueryResult = Apollo.QueryResult<MarkValueDetailQuery, MarkValueDetailQueryVariables>;
export const MarkValueIndexDocument = gql`
	query markValueIndex($filters: [MarkValueFilterInput!], $pagination: Pagination, $order: MarkValueOrder) {
		markValueConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					shortName
					value
					isNull
					description
				}
			}
		}
	}
`;

/**
 * __useMarkValueIndexQuery__
 *
 * To run a query within a React component, call `useMarkValueIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkValueIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkValueIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMarkValueIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<MarkValueIndexQuery, MarkValueIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MarkValueIndexQuery, MarkValueIndexQueryVariables>(MarkValueIndexDocument, options);
}
export function useMarkValueIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MarkValueIndexQuery, MarkValueIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MarkValueIndexQuery, MarkValueIndexQueryVariables>(MarkValueIndexDocument, options);
}
export function useMarkValueIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MarkValueIndexQuery, MarkValueIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MarkValueIndexQuery, MarkValueIndexQueryVariables>(MarkValueIndexDocument, options);
}
export type MarkValueIndexQueryHookResult = ReturnType<typeof useMarkValueIndexQuery>;
export type MarkValueIndexLazyQueryHookResult = ReturnType<typeof useMarkValueIndexLazyQuery>;
export type MarkValueIndexSuspenseQueryHookResult = ReturnType<typeof useMarkValueIndexSuspenseQuery>;
export type MarkValueIndexQueryResult = Apollo.QueryResult<MarkValueIndexQuery, MarkValueIndexQueryVariables>;
export const MarkValueNameDocument = gql`
	query markValueName($id: ID!) {
		markValue(id: $id) {
			id
			...MarkValueName
		}
	}
	${MarkValueNameFragmentDoc}
`;

/**
 * __useMarkValueNameQuery__
 *
 * To run a query within a React component, call `useMarkValueNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkValueNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkValueNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkValueNameQuery(
	baseOptions: Apollo.QueryHookOptions<MarkValueNameQuery, MarkValueNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MarkValueNameQuery, MarkValueNameQueryVariables>(MarkValueNameDocument, options);
}
export function useMarkValueNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MarkValueNameQuery, MarkValueNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MarkValueNameQuery, MarkValueNameQueryVariables>(MarkValueNameDocument, options);
}
export function useMarkValueNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MarkValueNameQuery, MarkValueNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MarkValueNameQuery, MarkValueNameQueryVariables>(MarkValueNameDocument, options);
}
export type MarkValueNameQueryHookResult = ReturnType<typeof useMarkValueNameQuery>;
export type MarkValueNameLazyQueryHookResult = ReturnType<typeof useMarkValueNameLazyQuery>;
export type MarkValueNameSuspenseQueryHookResult = ReturnType<typeof useMarkValueNameSuspenseQuery>;
export type MarkValueNameQueryResult = Apollo.QueryResult<MarkValueNameQuery, MarkValueNameQueryVariables>;
export const MarkValueNamesDocument = gql`
	query markValueNames($filters: [MarkValueFilterInput!], $pagination: Pagination, $order: MarkValueOrder) {
		markValueConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...MarkValueName
				}
			}
		}
	}
	${MarkValueNameFragmentDoc}
`;

/**
 * __useMarkValueNamesQuery__
 *
 * To run a query within a React component, call `useMarkValueNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkValueNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkValueNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMarkValueNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<MarkValueNamesQuery, MarkValueNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MarkValueNamesQuery, MarkValueNamesQueryVariables>(MarkValueNamesDocument, options);
}
export function useMarkValueNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MarkValueNamesQuery, MarkValueNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MarkValueNamesQuery, MarkValueNamesQueryVariables>(MarkValueNamesDocument, options);
}
export function useMarkValueNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MarkValueNamesQuery, MarkValueNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MarkValueNamesQuery, MarkValueNamesQueryVariables>(MarkValueNamesDocument, options);
}
export type MarkValueNamesQueryHookResult = ReturnType<typeof useMarkValueNamesQuery>;
export type MarkValueNamesLazyQueryHookResult = ReturnType<typeof useMarkValueNamesLazyQuery>;
export type MarkValueNamesSuspenseQueryHookResult = ReturnType<typeof useMarkValueNamesSuspenseQuery>;
export type MarkValueNamesQueryResult = Apollo.QueryResult<MarkValueNamesQuery, MarkValueNamesQueryVariables>;
export const MarkValuePaginationDocument = gql`
	query markValuePagination($filters: [MarkValueFilterInput!], $order: MarkValueOrder) {
		markValueConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useMarkValuePaginationQuery__
 *
 * To run a query within a React component, call `useMarkValuePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkValuePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkValuePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMarkValuePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<MarkValuePaginationQuery, MarkValuePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MarkValuePaginationQuery, MarkValuePaginationQueryVariables>(
		MarkValuePaginationDocument,
		options,
	);
}
export function useMarkValuePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MarkValuePaginationQuery, MarkValuePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MarkValuePaginationQuery, MarkValuePaginationQueryVariables>(
		MarkValuePaginationDocument,
		options,
	);
}
export function useMarkValuePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MarkValuePaginationQuery, MarkValuePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MarkValuePaginationQuery, MarkValuePaginationQueryVariables>(
		MarkValuePaginationDocument,
		options,
	);
}
export type MarkValuePaginationQueryHookResult = ReturnType<typeof useMarkValuePaginationQuery>;
export type MarkValuePaginationLazyQueryHookResult = ReturnType<typeof useMarkValuePaginationLazyQuery>;
export type MarkValuePaginationSuspenseQueryHookResult = ReturnType<typeof useMarkValuePaginationSuspenseQuery>;
export type MarkValuePaginationQueryResult = Apollo.QueryResult<
	MarkValuePaginationQuery,
	MarkValuePaginationQueryVariables
>;
export const MarkValueSelectDocument = gql`
	query markValueSelect($filters: [MarkValueFilterInput!], $order: MarkValueOrder) {
		markValueConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...MarkValueName
				}
			}
		}
	}
	${MarkValueNameFragmentDoc}
`;

/**
 * __useMarkValueSelectQuery__
 *
 * To run a query within a React component, call `useMarkValueSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkValueSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkValueSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMarkValueSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<MarkValueSelectQuery, MarkValueSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MarkValueSelectQuery, MarkValueSelectQueryVariables>(MarkValueSelectDocument, options);
}
export function useMarkValueSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MarkValueSelectQuery, MarkValueSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MarkValueSelectQuery, MarkValueSelectQueryVariables>(MarkValueSelectDocument, options);
}
export function useMarkValueSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MarkValueSelectQuery, MarkValueSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MarkValueSelectQuery, MarkValueSelectQueryVariables>(MarkValueSelectDocument, options);
}
export type MarkValueSelectQueryHookResult = ReturnType<typeof useMarkValueSelectQuery>;
export type MarkValueSelectLazyQueryHookResult = ReturnType<typeof useMarkValueSelectLazyQuery>;
export type MarkValueSelectSuspenseQueryHookResult = ReturnType<typeof useMarkValueSelectSuspenseQuery>;
export type MarkValueSelectQueryResult = Apollo.QueryResult<MarkValueSelectQuery, MarkValueSelectQueryVariables>;
export const MarkValueUpdateDocument = gql`
	mutation markValueUpdate($id: ID!, $input: MarkValueUpdateInput!) {
		updateMarkValue(id: $id, input: $input) {
			...MarkValueDetail
		}
	}
	${MarkValueDetailFragmentDoc}
`;
export type MarkValueUpdateMutationFn = Apollo.MutationFunction<
	MarkValueUpdateMutation,
	MarkValueUpdateMutationVariables
>;

/**
 * __useMarkValueUpdateMutation__
 *
 * To run a mutation, you first call `useMarkValueUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkValueUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markValueUpdateMutation, { data, loading, error }] = useMarkValueUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkValueUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<MarkValueUpdateMutation, MarkValueUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MarkValueUpdateMutation, MarkValueUpdateMutationVariables>(
		MarkValueUpdateDocument,
		options,
	);
}
export type MarkValueUpdateMutationHookResult = ReturnType<typeof useMarkValueUpdateMutation>;
export type MarkValueUpdateMutationResult = Apollo.MutationResult<MarkValueUpdateMutation>;
export type MarkValueUpdateMutationOptions = Apollo.BaseMutationOptions<
	MarkValueUpdateMutation,
	MarkValueUpdateMutationVariables
>;
export const MarkingSystemCountDocument = gql`
	query markingSystemCount($filters: [MarkingSystemFilterInput!], $pagination: Pagination, $order: MarkingSystemOrder) {
		markingSystemConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useMarkingSystemCountQuery__
 *
 * To run a query within a React component, call `useMarkingSystemCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkingSystemCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkingSystemCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMarkingSystemCountQuery(
	baseOptions?: Apollo.QueryHookOptions<MarkingSystemCountQuery, MarkingSystemCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MarkingSystemCountQuery, MarkingSystemCountQueryVariables>(
		MarkingSystemCountDocument,
		options,
	);
}
export function useMarkingSystemCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MarkingSystemCountQuery, MarkingSystemCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MarkingSystemCountQuery, MarkingSystemCountQueryVariables>(
		MarkingSystemCountDocument,
		options,
	);
}
export function useMarkingSystemCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MarkingSystemCountQuery, MarkingSystemCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MarkingSystemCountQuery, MarkingSystemCountQueryVariables>(
		MarkingSystemCountDocument,
		options,
	);
}
export type MarkingSystemCountQueryHookResult = ReturnType<typeof useMarkingSystemCountQuery>;
export type MarkingSystemCountLazyQueryHookResult = ReturnType<typeof useMarkingSystemCountLazyQuery>;
export type MarkingSystemCountSuspenseQueryHookResult = ReturnType<typeof useMarkingSystemCountSuspenseQuery>;
export type MarkingSystemCountQueryResult = Apollo.QueryResult<
	MarkingSystemCountQuery,
	MarkingSystemCountQueryVariables
>;
export const MarkingSystemCreateDocument = gql`
	mutation markingSystemCreate($input: MarkingSystemCreateInput!) {
		createMarkingSystem(input: $input) {
			...MarkingSystemDetail
		}
	}
	${MarkingSystemDetailFragmentDoc}
`;
export type MarkingSystemCreateMutationFn = Apollo.MutationFunction<
	MarkingSystemCreateMutation,
	MarkingSystemCreateMutationVariables
>;

/**
 * __useMarkingSystemCreateMutation__
 *
 * To run a mutation, you first call `useMarkingSystemCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkingSystemCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markingSystemCreateMutation, { data, loading, error }] = useMarkingSystemCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkingSystemCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<MarkingSystemCreateMutation, MarkingSystemCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MarkingSystemCreateMutation, MarkingSystemCreateMutationVariables>(
		MarkingSystemCreateDocument,
		options,
	);
}
export type MarkingSystemCreateMutationHookResult = ReturnType<typeof useMarkingSystemCreateMutation>;
export type MarkingSystemCreateMutationResult = Apollo.MutationResult<MarkingSystemCreateMutation>;
export type MarkingSystemCreateMutationOptions = Apollo.BaseMutationOptions<
	MarkingSystemCreateMutation,
	MarkingSystemCreateMutationVariables
>;
export const MarkingSystemDeleteDocument = gql`
	mutation markingSystemDelete($id: ID!) {
		deleteMarkingSystem(id: $id)
	}
`;
export type MarkingSystemDeleteMutationFn = Apollo.MutationFunction<
	MarkingSystemDeleteMutation,
	MarkingSystemDeleteMutationVariables
>;

/**
 * __useMarkingSystemDeleteMutation__
 *
 * To run a mutation, you first call `useMarkingSystemDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkingSystemDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markingSystemDeleteMutation, { data, loading, error }] = useMarkingSystemDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkingSystemDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<MarkingSystemDeleteMutation, MarkingSystemDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MarkingSystemDeleteMutation, MarkingSystemDeleteMutationVariables>(
		MarkingSystemDeleteDocument,
		options,
	);
}
export type MarkingSystemDeleteMutationHookResult = ReturnType<typeof useMarkingSystemDeleteMutation>;
export type MarkingSystemDeleteMutationResult = Apollo.MutationResult<MarkingSystemDeleteMutation>;
export type MarkingSystemDeleteMutationOptions = Apollo.BaseMutationOptions<
	MarkingSystemDeleteMutation,
	MarkingSystemDeleteMutationVariables
>;
export const MarkingSystemDetailDocument = gql`
	query markingSystemDetail($id: ID!) {
		markingSystem(id: $id) {
			...MarkingSystemDetail
		}
	}
	${MarkingSystemDetailFragmentDoc}
`;

/**
 * __useMarkingSystemDetailQuery__
 *
 * To run a query within a React component, call `useMarkingSystemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkingSystemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkingSystemDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkingSystemDetailQuery(
	baseOptions: Apollo.QueryHookOptions<MarkingSystemDetailQuery, MarkingSystemDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MarkingSystemDetailQuery, MarkingSystemDetailQueryVariables>(
		MarkingSystemDetailDocument,
		options,
	);
}
export function useMarkingSystemDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MarkingSystemDetailQuery, MarkingSystemDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MarkingSystemDetailQuery, MarkingSystemDetailQueryVariables>(
		MarkingSystemDetailDocument,
		options,
	);
}
export function useMarkingSystemDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MarkingSystemDetailQuery, MarkingSystemDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MarkingSystemDetailQuery, MarkingSystemDetailQueryVariables>(
		MarkingSystemDetailDocument,
		options,
	);
}
export type MarkingSystemDetailQueryHookResult = ReturnType<typeof useMarkingSystemDetailQuery>;
export type MarkingSystemDetailLazyQueryHookResult = ReturnType<typeof useMarkingSystemDetailLazyQuery>;
export type MarkingSystemDetailSuspenseQueryHookResult = ReturnType<typeof useMarkingSystemDetailSuspenseQuery>;
export type MarkingSystemDetailQueryResult = Apollo.QueryResult<
	MarkingSystemDetailQuery,
	MarkingSystemDetailQueryVariables
>;
export const MarkingSystemIndexDocument = gql`
	query markingSystemIndex($filters: [MarkingSystemFilterInput!], $pagination: Pagination, $order: MarkingSystemOrder) {
		markingSystemConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					description
				}
			}
		}
	}
`;

/**
 * __useMarkingSystemIndexQuery__
 *
 * To run a query within a React component, call `useMarkingSystemIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkingSystemIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkingSystemIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMarkingSystemIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<MarkingSystemIndexQuery, MarkingSystemIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MarkingSystemIndexQuery, MarkingSystemIndexQueryVariables>(
		MarkingSystemIndexDocument,
		options,
	);
}
export function useMarkingSystemIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MarkingSystemIndexQuery, MarkingSystemIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MarkingSystemIndexQuery, MarkingSystemIndexQueryVariables>(
		MarkingSystemIndexDocument,
		options,
	);
}
export function useMarkingSystemIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MarkingSystemIndexQuery, MarkingSystemIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MarkingSystemIndexQuery, MarkingSystemIndexQueryVariables>(
		MarkingSystemIndexDocument,
		options,
	);
}
export type MarkingSystemIndexQueryHookResult = ReturnType<typeof useMarkingSystemIndexQuery>;
export type MarkingSystemIndexLazyQueryHookResult = ReturnType<typeof useMarkingSystemIndexLazyQuery>;
export type MarkingSystemIndexSuspenseQueryHookResult = ReturnType<typeof useMarkingSystemIndexSuspenseQuery>;
export type MarkingSystemIndexQueryResult = Apollo.QueryResult<
	MarkingSystemIndexQuery,
	MarkingSystemIndexQueryVariables
>;
export const MarkingSystemNameDocument = gql`
	query markingSystemName($id: ID!) {
		markingSystem(id: $id) {
			id
			...MarkingSystemName
		}
	}
	${MarkingSystemNameFragmentDoc}
`;

/**
 * __useMarkingSystemNameQuery__
 *
 * To run a query within a React component, call `useMarkingSystemNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkingSystemNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkingSystemNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkingSystemNameQuery(
	baseOptions: Apollo.QueryHookOptions<MarkingSystemNameQuery, MarkingSystemNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MarkingSystemNameQuery, MarkingSystemNameQueryVariables>(MarkingSystemNameDocument, options);
}
export function useMarkingSystemNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MarkingSystemNameQuery, MarkingSystemNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MarkingSystemNameQuery, MarkingSystemNameQueryVariables>(
		MarkingSystemNameDocument,
		options,
	);
}
export function useMarkingSystemNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MarkingSystemNameQuery, MarkingSystemNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MarkingSystemNameQuery, MarkingSystemNameQueryVariables>(
		MarkingSystemNameDocument,
		options,
	);
}
export type MarkingSystemNameQueryHookResult = ReturnType<typeof useMarkingSystemNameQuery>;
export type MarkingSystemNameLazyQueryHookResult = ReturnType<typeof useMarkingSystemNameLazyQuery>;
export type MarkingSystemNameSuspenseQueryHookResult = ReturnType<typeof useMarkingSystemNameSuspenseQuery>;
export type MarkingSystemNameQueryResult = Apollo.QueryResult<MarkingSystemNameQuery, MarkingSystemNameQueryVariables>;
export const MarkingSystemNamesDocument = gql`
	query markingSystemNames($filters: [MarkingSystemFilterInput!], $pagination: Pagination, $order: MarkingSystemOrder) {
		markingSystemConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...MarkingSystemName
				}
			}
		}
	}
	${MarkingSystemNameFragmentDoc}
`;

/**
 * __useMarkingSystemNamesQuery__
 *
 * To run a query within a React component, call `useMarkingSystemNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkingSystemNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkingSystemNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMarkingSystemNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<MarkingSystemNamesQuery, MarkingSystemNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MarkingSystemNamesQuery, MarkingSystemNamesQueryVariables>(
		MarkingSystemNamesDocument,
		options,
	);
}
export function useMarkingSystemNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MarkingSystemNamesQuery, MarkingSystemNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MarkingSystemNamesQuery, MarkingSystemNamesQueryVariables>(
		MarkingSystemNamesDocument,
		options,
	);
}
export function useMarkingSystemNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MarkingSystemNamesQuery, MarkingSystemNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MarkingSystemNamesQuery, MarkingSystemNamesQueryVariables>(
		MarkingSystemNamesDocument,
		options,
	);
}
export type MarkingSystemNamesQueryHookResult = ReturnType<typeof useMarkingSystemNamesQuery>;
export type MarkingSystemNamesLazyQueryHookResult = ReturnType<typeof useMarkingSystemNamesLazyQuery>;
export type MarkingSystemNamesSuspenseQueryHookResult = ReturnType<typeof useMarkingSystemNamesSuspenseQuery>;
export type MarkingSystemNamesQueryResult = Apollo.QueryResult<
	MarkingSystemNamesQuery,
	MarkingSystemNamesQueryVariables
>;
export const MarkingSystemPaginationDocument = gql`
	query markingSystemPagination($filters: [MarkingSystemFilterInput!], $order: MarkingSystemOrder) {
		markingSystemConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useMarkingSystemPaginationQuery__
 *
 * To run a query within a React component, call `useMarkingSystemPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkingSystemPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkingSystemPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMarkingSystemPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<MarkingSystemPaginationQuery, MarkingSystemPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MarkingSystemPaginationQuery, MarkingSystemPaginationQueryVariables>(
		MarkingSystemPaginationDocument,
		options,
	);
}
export function useMarkingSystemPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MarkingSystemPaginationQuery, MarkingSystemPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MarkingSystemPaginationQuery, MarkingSystemPaginationQueryVariables>(
		MarkingSystemPaginationDocument,
		options,
	);
}
export function useMarkingSystemPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MarkingSystemPaginationQuery, MarkingSystemPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MarkingSystemPaginationQuery, MarkingSystemPaginationQueryVariables>(
		MarkingSystemPaginationDocument,
		options,
	);
}
export type MarkingSystemPaginationQueryHookResult = ReturnType<typeof useMarkingSystemPaginationQuery>;
export type MarkingSystemPaginationLazyQueryHookResult = ReturnType<typeof useMarkingSystemPaginationLazyQuery>;
export type MarkingSystemPaginationSuspenseQueryHookResult = ReturnType<typeof useMarkingSystemPaginationSuspenseQuery>;
export type MarkingSystemPaginationQueryResult = Apollo.QueryResult<
	MarkingSystemPaginationQuery,
	MarkingSystemPaginationQueryVariables
>;
export const MarkingSystemSelectDocument = gql`
	query markingSystemSelect($filters: [MarkingSystemFilterInput!], $order: MarkingSystemOrder) {
		markingSystemConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...MarkingSystemName
				}
			}
		}
	}
	${MarkingSystemNameFragmentDoc}
`;

/**
 * __useMarkingSystemSelectQuery__
 *
 * To run a query within a React component, call `useMarkingSystemSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkingSystemSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkingSystemSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMarkingSystemSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<MarkingSystemSelectQuery, MarkingSystemSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MarkingSystemSelectQuery, MarkingSystemSelectQueryVariables>(
		MarkingSystemSelectDocument,
		options,
	);
}
export function useMarkingSystemSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MarkingSystemSelectQuery, MarkingSystemSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MarkingSystemSelectQuery, MarkingSystemSelectQueryVariables>(
		MarkingSystemSelectDocument,
		options,
	);
}
export function useMarkingSystemSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MarkingSystemSelectQuery, MarkingSystemSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MarkingSystemSelectQuery, MarkingSystemSelectQueryVariables>(
		MarkingSystemSelectDocument,
		options,
	);
}
export type MarkingSystemSelectQueryHookResult = ReturnType<typeof useMarkingSystemSelectQuery>;
export type MarkingSystemSelectLazyQueryHookResult = ReturnType<typeof useMarkingSystemSelectLazyQuery>;
export type MarkingSystemSelectSuspenseQueryHookResult = ReturnType<typeof useMarkingSystemSelectSuspenseQuery>;
export type MarkingSystemSelectQueryResult = Apollo.QueryResult<
	MarkingSystemSelectQuery,
	MarkingSystemSelectQueryVariables
>;
export const MarkingSystemUpdateDocument = gql`
	mutation markingSystemUpdate($id: ID!, $input: MarkingSystemUpdateInput!) {
		updateMarkingSystem(id: $id, input: $input) {
			...MarkingSystemDetail
		}
	}
	${MarkingSystemDetailFragmentDoc}
`;
export type MarkingSystemUpdateMutationFn = Apollo.MutationFunction<
	MarkingSystemUpdateMutation,
	MarkingSystemUpdateMutationVariables
>;

/**
 * __useMarkingSystemUpdateMutation__
 *
 * To run a mutation, you first call `useMarkingSystemUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkingSystemUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markingSystemUpdateMutation, { data, loading, error }] = useMarkingSystemUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkingSystemUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<MarkingSystemUpdateMutation, MarkingSystemUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MarkingSystemUpdateMutation, MarkingSystemUpdateMutationVariables>(
		MarkingSystemUpdateDocument,
		options,
	);
}
export type MarkingSystemUpdateMutationHookResult = ReturnType<typeof useMarkingSystemUpdateMutation>;
export type MarkingSystemUpdateMutationResult = Apollo.MutationResult<MarkingSystemUpdateMutation>;
export type MarkingSystemUpdateMutationOptions = Apollo.BaseMutationOptions<
	MarkingSystemUpdateMutation,
	MarkingSystemUpdateMutationVariables
>;
export const MediaAttachmentCountDocument = gql`
	query mediaAttachmentCount(
		$filters: [MediaAttachmentFilterInput!]
		$pagination: Pagination
		$order: MediaAttachmentOrder
	) {
		mediaAttachmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useMediaAttachmentCountQuery__
 *
 * To run a query within a React component, call `useMediaAttachmentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAttachmentCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMediaAttachmentCountQuery(
	baseOptions?: Apollo.QueryHookOptions<MediaAttachmentCountQuery, MediaAttachmentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MediaAttachmentCountQuery, MediaAttachmentCountQueryVariables>(
		MediaAttachmentCountDocument,
		options,
	);
}
export function useMediaAttachmentCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MediaAttachmentCountQuery, MediaAttachmentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MediaAttachmentCountQuery, MediaAttachmentCountQueryVariables>(
		MediaAttachmentCountDocument,
		options,
	);
}
export function useMediaAttachmentCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MediaAttachmentCountQuery, MediaAttachmentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MediaAttachmentCountQuery, MediaAttachmentCountQueryVariables>(
		MediaAttachmentCountDocument,
		options,
	);
}
export type MediaAttachmentCountQueryHookResult = ReturnType<typeof useMediaAttachmentCountQuery>;
export type MediaAttachmentCountLazyQueryHookResult = ReturnType<typeof useMediaAttachmentCountLazyQuery>;
export type MediaAttachmentCountSuspenseQueryHookResult = ReturnType<typeof useMediaAttachmentCountSuspenseQuery>;
export type MediaAttachmentCountQueryResult = Apollo.QueryResult<
	MediaAttachmentCountQuery,
	MediaAttachmentCountQueryVariables
>;
export const MediaAttachmentCreateDocument = gql`
	mutation mediaAttachmentCreate($input: MediaAttachmentCreateInput!) {
		createMediaAttachment(input: $input) {
			...MediaAttachmentDetail
		}
	}
	${MediaAttachmentDetailFragmentDoc}
`;
export type MediaAttachmentCreateMutationFn = Apollo.MutationFunction<
	MediaAttachmentCreateMutation,
	MediaAttachmentCreateMutationVariables
>;

/**
 * __useMediaAttachmentCreateMutation__
 *
 * To run a mutation, you first call `useMediaAttachmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaAttachmentCreateMutation, { data, loading, error }] = useMediaAttachmentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaAttachmentCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<MediaAttachmentCreateMutation, MediaAttachmentCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MediaAttachmentCreateMutation, MediaAttachmentCreateMutationVariables>(
		MediaAttachmentCreateDocument,
		options,
	);
}
export type MediaAttachmentCreateMutationHookResult = ReturnType<typeof useMediaAttachmentCreateMutation>;
export type MediaAttachmentCreateMutationResult = Apollo.MutationResult<MediaAttachmentCreateMutation>;
export type MediaAttachmentCreateMutationOptions = Apollo.BaseMutationOptions<
	MediaAttachmentCreateMutation,
	MediaAttachmentCreateMutationVariables
>;
export const MediaAttachmentDeleteDocument = gql`
	mutation mediaAttachmentDelete($id: ID!) {
		deleteMediaAttachment(id: $id)
	}
`;
export type MediaAttachmentDeleteMutationFn = Apollo.MutationFunction<
	MediaAttachmentDeleteMutation,
	MediaAttachmentDeleteMutationVariables
>;

/**
 * __useMediaAttachmentDeleteMutation__
 *
 * To run a mutation, you first call `useMediaAttachmentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaAttachmentDeleteMutation, { data, loading, error }] = useMediaAttachmentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMediaAttachmentDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<MediaAttachmentDeleteMutation, MediaAttachmentDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MediaAttachmentDeleteMutation, MediaAttachmentDeleteMutationVariables>(
		MediaAttachmentDeleteDocument,
		options,
	);
}
export type MediaAttachmentDeleteMutationHookResult = ReturnType<typeof useMediaAttachmentDeleteMutation>;
export type MediaAttachmentDeleteMutationResult = Apollo.MutationResult<MediaAttachmentDeleteMutation>;
export type MediaAttachmentDeleteMutationOptions = Apollo.BaseMutationOptions<
	MediaAttachmentDeleteMutation,
	MediaAttachmentDeleteMutationVariables
>;
export const MediaAttachmentDetailDocument = gql`
	query mediaAttachmentDetail($id: ID!) {
		mediaAttachment(id: $id) {
			...MediaAttachmentDetail
		}
	}
	${MediaAttachmentDetailFragmentDoc}
`;

/**
 * __useMediaAttachmentDetailQuery__
 *
 * To run a query within a React component, call `useMediaAttachmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAttachmentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMediaAttachmentDetailQuery(
	baseOptions: Apollo.QueryHookOptions<MediaAttachmentDetailQuery, MediaAttachmentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MediaAttachmentDetailQuery, MediaAttachmentDetailQueryVariables>(
		MediaAttachmentDetailDocument,
		options,
	);
}
export function useMediaAttachmentDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MediaAttachmentDetailQuery, MediaAttachmentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MediaAttachmentDetailQuery, MediaAttachmentDetailQueryVariables>(
		MediaAttachmentDetailDocument,
		options,
	);
}
export function useMediaAttachmentDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MediaAttachmentDetailQuery, MediaAttachmentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MediaAttachmentDetailQuery, MediaAttachmentDetailQueryVariables>(
		MediaAttachmentDetailDocument,
		options,
	);
}
export type MediaAttachmentDetailQueryHookResult = ReturnType<typeof useMediaAttachmentDetailQuery>;
export type MediaAttachmentDetailLazyQueryHookResult = ReturnType<typeof useMediaAttachmentDetailLazyQuery>;
export type MediaAttachmentDetailSuspenseQueryHookResult = ReturnType<typeof useMediaAttachmentDetailSuspenseQuery>;
export type MediaAttachmentDetailQueryResult = Apollo.QueryResult<
	MediaAttachmentDetailQuery,
	MediaAttachmentDetailQueryVariables
>;
export const MediaAttachmentIndexDocument = gql`
	query mediaAttachmentIndex(
		$filters: [MediaAttachmentFilterInput!]
		$pagination: Pagination
		$order: MediaAttachmentOrder
	) {
		mediaAttachmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					displayOrder
					title
					description
					isFile
					fileURL
					fileContentType
					linkURL
				}
			}
		}
	}
`;

/**
 * __useMediaAttachmentIndexQuery__
 *
 * To run a query within a React component, call `useMediaAttachmentIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAttachmentIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMediaAttachmentIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<MediaAttachmentIndexQuery, MediaAttachmentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MediaAttachmentIndexQuery, MediaAttachmentIndexQueryVariables>(
		MediaAttachmentIndexDocument,
		options,
	);
}
export function useMediaAttachmentIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MediaAttachmentIndexQuery, MediaAttachmentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MediaAttachmentIndexQuery, MediaAttachmentIndexQueryVariables>(
		MediaAttachmentIndexDocument,
		options,
	);
}
export function useMediaAttachmentIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MediaAttachmentIndexQuery, MediaAttachmentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MediaAttachmentIndexQuery, MediaAttachmentIndexQueryVariables>(
		MediaAttachmentIndexDocument,
		options,
	);
}
export type MediaAttachmentIndexQueryHookResult = ReturnType<typeof useMediaAttachmentIndexQuery>;
export type MediaAttachmentIndexLazyQueryHookResult = ReturnType<typeof useMediaAttachmentIndexLazyQuery>;
export type MediaAttachmentIndexSuspenseQueryHookResult = ReturnType<typeof useMediaAttachmentIndexSuspenseQuery>;
export type MediaAttachmentIndexQueryResult = Apollo.QueryResult<
	MediaAttachmentIndexQuery,
	MediaAttachmentIndexQueryVariables
>;
export const MediaAttachmentNameDocument = gql`
	query mediaAttachmentName($id: ID!) {
		mediaAttachment(id: $id) {
			id
			...MediaAttachmentName
		}
	}
	${MediaAttachmentNameFragmentDoc}
`;

/**
 * __useMediaAttachmentNameQuery__
 *
 * To run a query within a React component, call `useMediaAttachmentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAttachmentNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMediaAttachmentNameQuery(
	baseOptions: Apollo.QueryHookOptions<MediaAttachmentNameQuery, MediaAttachmentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MediaAttachmentNameQuery, MediaAttachmentNameQueryVariables>(
		MediaAttachmentNameDocument,
		options,
	);
}
export function useMediaAttachmentNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MediaAttachmentNameQuery, MediaAttachmentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MediaAttachmentNameQuery, MediaAttachmentNameQueryVariables>(
		MediaAttachmentNameDocument,
		options,
	);
}
export function useMediaAttachmentNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MediaAttachmentNameQuery, MediaAttachmentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MediaAttachmentNameQuery, MediaAttachmentNameQueryVariables>(
		MediaAttachmentNameDocument,
		options,
	);
}
export type MediaAttachmentNameQueryHookResult = ReturnType<typeof useMediaAttachmentNameQuery>;
export type MediaAttachmentNameLazyQueryHookResult = ReturnType<typeof useMediaAttachmentNameLazyQuery>;
export type MediaAttachmentNameSuspenseQueryHookResult = ReturnType<typeof useMediaAttachmentNameSuspenseQuery>;
export type MediaAttachmentNameQueryResult = Apollo.QueryResult<
	MediaAttachmentNameQuery,
	MediaAttachmentNameQueryVariables
>;
export const MediaAttachmentNamesDocument = gql`
	query mediaAttachmentNames(
		$filters: [MediaAttachmentFilterInput!]
		$pagination: Pagination
		$order: MediaAttachmentOrder
	) {
		mediaAttachmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...MediaAttachmentName
				}
			}
		}
	}
	${MediaAttachmentNameFragmentDoc}
`;

/**
 * __useMediaAttachmentNamesQuery__
 *
 * To run a query within a React component, call `useMediaAttachmentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAttachmentNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMediaAttachmentNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<MediaAttachmentNamesQuery, MediaAttachmentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MediaAttachmentNamesQuery, MediaAttachmentNamesQueryVariables>(
		MediaAttachmentNamesDocument,
		options,
	);
}
export function useMediaAttachmentNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MediaAttachmentNamesQuery, MediaAttachmentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MediaAttachmentNamesQuery, MediaAttachmentNamesQueryVariables>(
		MediaAttachmentNamesDocument,
		options,
	);
}
export function useMediaAttachmentNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MediaAttachmentNamesQuery, MediaAttachmentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MediaAttachmentNamesQuery, MediaAttachmentNamesQueryVariables>(
		MediaAttachmentNamesDocument,
		options,
	);
}
export type MediaAttachmentNamesQueryHookResult = ReturnType<typeof useMediaAttachmentNamesQuery>;
export type MediaAttachmentNamesLazyQueryHookResult = ReturnType<typeof useMediaAttachmentNamesLazyQuery>;
export type MediaAttachmentNamesSuspenseQueryHookResult = ReturnType<typeof useMediaAttachmentNamesSuspenseQuery>;
export type MediaAttachmentNamesQueryResult = Apollo.QueryResult<
	MediaAttachmentNamesQuery,
	MediaAttachmentNamesQueryVariables
>;
export const MediaAttachmentPaginationDocument = gql`
	query mediaAttachmentPagination($filters: [MediaAttachmentFilterInput!], $order: MediaAttachmentOrder) {
		mediaAttachmentConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useMediaAttachmentPaginationQuery__
 *
 * To run a query within a React component, call `useMediaAttachmentPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAttachmentPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMediaAttachmentPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<MediaAttachmentPaginationQuery, MediaAttachmentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MediaAttachmentPaginationQuery, MediaAttachmentPaginationQueryVariables>(
		MediaAttachmentPaginationDocument,
		options,
	);
}
export function useMediaAttachmentPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MediaAttachmentPaginationQuery, MediaAttachmentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MediaAttachmentPaginationQuery, MediaAttachmentPaginationQueryVariables>(
		MediaAttachmentPaginationDocument,
		options,
	);
}
export function useMediaAttachmentPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MediaAttachmentPaginationQuery,
		MediaAttachmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MediaAttachmentPaginationQuery, MediaAttachmentPaginationQueryVariables>(
		MediaAttachmentPaginationDocument,
		options,
	);
}
export type MediaAttachmentPaginationQueryHookResult = ReturnType<typeof useMediaAttachmentPaginationQuery>;
export type MediaAttachmentPaginationLazyQueryHookResult = ReturnType<typeof useMediaAttachmentPaginationLazyQuery>;
export type MediaAttachmentPaginationSuspenseQueryHookResult = ReturnType<
	typeof useMediaAttachmentPaginationSuspenseQuery
>;
export type MediaAttachmentPaginationQueryResult = Apollo.QueryResult<
	MediaAttachmentPaginationQuery,
	MediaAttachmentPaginationQueryVariables
>;
export const MediaAttachmentSelectDocument = gql`
	query mediaAttachmentSelect($filters: [MediaAttachmentFilterInput!], $order: MediaAttachmentOrder) {
		mediaAttachmentConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...MediaAttachmentName
				}
			}
		}
	}
	${MediaAttachmentNameFragmentDoc}
`;

/**
 * __useMediaAttachmentSelectQuery__
 *
 * To run a query within a React component, call `useMediaAttachmentSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAttachmentSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMediaAttachmentSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<MediaAttachmentSelectQuery, MediaAttachmentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MediaAttachmentSelectQuery, MediaAttachmentSelectQueryVariables>(
		MediaAttachmentSelectDocument,
		options,
	);
}
export function useMediaAttachmentSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MediaAttachmentSelectQuery, MediaAttachmentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MediaAttachmentSelectQuery, MediaAttachmentSelectQueryVariables>(
		MediaAttachmentSelectDocument,
		options,
	);
}
export function useMediaAttachmentSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MediaAttachmentSelectQuery, MediaAttachmentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MediaAttachmentSelectQuery, MediaAttachmentSelectQueryVariables>(
		MediaAttachmentSelectDocument,
		options,
	);
}
export type MediaAttachmentSelectQueryHookResult = ReturnType<typeof useMediaAttachmentSelectQuery>;
export type MediaAttachmentSelectLazyQueryHookResult = ReturnType<typeof useMediaAttachmentSelectLazyQuery>;
export type MediaAttachmentSelectSuspenseQueryHookResult = ReturnType<typeof useMediaAttachmentSelectSuspenseQuery>;
export type MediaAttachmentSelectQueryResult = Apollo.QueryResult<
	MediaAttachmentSelectQuery,
	MediaAttachmentSelectQueryVariables
>;
export const MediaAttachmentSocialItemsDocument = gql`
	query mediaAttachmentSocialItems($id: ID!) {
		mediaAttachment(id: $id) {
			id
			socialReactions(order: { field: CREATED_AT, direction: DESC }) {
				id
				reaction
				author {
					id
					...UserName
					isCurrent
				}
			}
			socialComments(order: { field: CREATED_AT, direction: DESC }) {
				id
				body
				createdAt
				author {
					id
					...UserNameAndImage
					isCurrent
				}
			}
		}
	}
	${UserNameFragmentDoc}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __useMediaAttachmentSocialItemsQuery__
 *
 * To run a query within a React component, call `useMediaAttachmentSocialItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentSocialItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAttachmentSocialItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMediaAttachmentSocialItemsQuery(
	baseOptions: Apollo.QueryHookOptions<MediaAttachmentSocialItemsQuery, MediaAttachmentSocialItemsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MediaAttachmentSocialItemsQuery, MediaAttachmentSocialItemsQueryVariables>(
		MediaAttachmentSocialItemsDocument,
		options,
	);
}
export function useMediaAttachmentSocialItemsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MediaAttachmentSocialItemsQuery, MediaAttachmentSocialItemsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MediaAttachmentSocialItemsQuery, MediaAttachmentSocialItemsQueryVariables>(
		MediaAttachmentSocialItemsDocument,
		options,
	);
}
export function useMediaAttachmentSocialItemsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MediaAttachmentSocialItemsQuery,
		MediaAttachmentSocialItemsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MediaAttachmentSocialItemsQuery, MediaAttachmentSocialItemsQueryVariables>(
		MediaAttachmentSocialItemsDocument,
		options,
	);
}
export type MediaAttachmentSocialItemsQueryHookResult = ReturnType<typeof useMediaAttachmentSocialItemsQuery>;
export type MediaAttachmentSocialItemsLazyQueryHookResult = ReturnType<typeof useMediaAttachmentSocialItemsLazyQuery>;
export type MediaAttachmentSocialItemsSuspenseQueryHookResult = ReturnType<
	typeof useMediaAttachmentSocialItemsSuspenseQuery
>;
export type MediaAttachmentSocialItemsQueryResult = Apollo.QueryResult<
	MediaAttachmentSocialItemsQuery,
	MediaAttachmentSocialItemsQueryVariables
>;
export const MediaAttachmentUpdateDocument = gql`
	mutation mediaAttachmentUpdate($id: ID!, $input: MediaAttachmentUpdateInput!) {
		updateMediaAttachment(id: $id, input: $input) {
			...MediaAttachmentDetail
		}
	}
	${MediaAttachmentDetailFragmentDoc}
`;
export type MediaAttachmentUpdateMutationFn = Apollo.MutationFunction<
	MediaAttachmentUpdateMutation,
	MediaAttachmentUpdateMutationVariables
>;

/**
 * __useMediaAttachmentUpdateMutation__
 *
 * To run a mutation, you first call `useMediaAttachmentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaAttachmentUpdateMutation, { data, loading, error }] = useMediaAttachmentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaAttachmentUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<MediaAttachmentUpdateMutation, MediaAttachmentUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MediaAttachmentUpdateMutation, MediaAttachmentUpdateMutationVariables>(
		MediaAttachmentUpdateDocument,
		options,
	);
}
export type MediaAttachmentUpdateMutationHookResult = ReturnType<typeof useMediaAttachmentUpdateMutation>;
export type MediaAttachmentUpdateMutationResult = Apollo.MutationResult<MediaAttachmentUpdateMutation>;
export type MediaAttachmentUpdateMutationOptions = Apollo.BaseMutationOptions<
	MediaAttachmentUpdateMutation,
	MediaAttachmentUpdateMutationVariables
>;
export const MediaAttachmentVisualCatalogListDocument = gql`
	query mediaAttachmentVisualCatalogList(
		$filters: [MediaAttachmentFilterInput!]
		$pagination: Pagination
		$order: MediaAttachmentOrder
	) {
		mediaAttachmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			pageInfo {
				endCursor
				hasNextPage
			}
			edges {
				node {
					id
					title
					description
					fileURL
					fileKey
					fileContentType
					postID
				}
			}
		}
	}
`;

/**
 * __useMediaAttachmentVisualCatalogListQuery__
 *
 * To run a query within a React component, call `useMediaAttachmentVisualCatalogListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentVisualCatalogListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAttachmentVisualCatalogListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMediaAttachmentVisualCatalogListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MediaAttachmentVisualCatalogListQuery,
		MediaAttachmentVisualCatalogListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MediaAttachmentVisualCatalogListQuery, MediaAttachmentVisualCatalogListQueryVariables>(
		MediaAttachmentVisualCatalogListDocument,
		options,
	);
}
export function useMediaAttachmentVisualCatalogListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MediaAttachmentVisualCatalogListQuery,
		MediaAttachmentVisualCatalogListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MediaAttachmentVisualCatalogListQuery, MediaAttachmentVisualCatalogListQueryVariables>(
		MediaAttachmentVisualCatalogListDocument,
		options,
	);
}
export function useMediaAttachmentVisualCatalogListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MediaAttachmentVisualCatalogListQuery,
		MediaAttachmentVisualCatalogListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MediaAttachmentVisualCatalogListQuery, MediaAttachmentVisualCatalogListQueryVariables>(
		MediaAttachmentVisualCatalogListDocument,
		options,
	);
}
export type MediaAttachmentVisualCatalogListQueryHookResult = ReturnType<
	typeof useMediaAttachmentVisualCatalogListQuery
>;
export type MediaAttachmentVisualCatalogListLazyQueryHookResult = ReturnType<
	typeof useMediaAttachmentVisualCatalogListLazyQuery
>;
export type MediaAttachmentVisualCatalogListSuspenseQueryHookResult = ReturnType<
	typeof useMediaAttachmentVisualCatalogListSuspenseQuery
>;
export type MediaAttachmentVisualCatalogListQueryResult = Apollo.QueryResult<
	MediaAttachmentVisualCatalogListQuery,
	MediaAttachmentVisualCatalogListQueryVariables
>;
export const MedicalConditionCountDocument = gql`
	query medicalConditionCount(
		$filters: [MedicalConditionFilterInput!]
		$pagination: Pagination
		$order: MedicalConditionOrder
	) {
		medicalConditionConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useMedicalConditionCountQuery__
 *
 * To run a query within a React component, call `useMedicalConditionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicalConditionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicalConditionCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMedicalConditionCountQuery(
	baseOptions?: Apollo.QueryHookOptions<MedicalConditionCountQuery, MedicalConditionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MedicalConditionCountQuery, MedicalConditionCountQueryVariables>(
		MedicalConditionCountDocument,
		options,
	);
}
export function useMedicalConditionCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MedicalConditionCountQuery, MedicalConditionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MedicalConditionCountQuery, MedicalConditionCountQueryVariables>(
		MedicalConditionCountDocument,
		options,
	);
}
export function useMedicalConditionCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MedicalConditionCountQuery, MedicalConditionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MedicalConditionCountQuery, MedicalConditionCountQueryVariables>(
		MedicalConditionCountDocument,
		options,
	);
}
export type MedicalConditionCountQueryHookResult = ReturnType<typeof useMedicalConditionCountQuery>;
export type MedicalConditionCountLazyQueryHookResult = ReturnType<typeof useMedicalConditionCountLazyQuery>;
export type MedicalConditionCountSuspenseQueryHookResult = ReturnType<typeof useMedicalConditionCountSuspenseQuery>;
export type MedicalConditionCountQueryResult = Apollo.QueryResult<
	MedicalConditionCountQuery,
	MedicalConditionCountQueryVariables
>;
export const MedicalConditionCreateDocument = gql`
	mutation medicalConditionCreate($input: MedicalConditionCreateInput!) {
		createMedicalCondition(input: $input) {
			...MedicalConditionDetail
		}
	}
	${MedicalConditionDetailFragmentDoc}
`;
export type MedicalConditionCreateMutationFn = Apollo.MutationFunction<
	MedicalConditionCreateMutation,
	MedicalConditionCreateMutationVariables
>;

/**
 * __useMedicalConditionCreateMutation__
 *
 * To run a mutation, you first call `useMedicalConditionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMedicalConditionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [medicalConditionCreateMutation, { data, loading, error }] = useMedicalConditionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMedicalConditionCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<MedicalConditionCreateMutation, MedicalConditionCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MedicalConditionCreateMutation, MedicalConditionCreateMutationVariables>(
		MedicalConditionCreateDocument,
		options,
	);
}
export type MedicalConditionCreateMutationHookResult = ReturnType<typeof useMedicalConditionCreateMutation>;
export type MedicalConditionCreateMutationResult = Apollo.MutationResult<MedicalConditionCreateMutation>;
export type MedicalConditionCreateMutationOptions = Apollo.BaseMutationOptions<
	MedicalConditionCreateMutation,
	MedicalConditionCreateMutationVariables
>;
export const MedicalConditionDeleteDocument = gql`
	mutation medicalConditionDelete($id: ID!) {
		deleteMedicalCondition(id: $id)
	}
`;
export type MedicalConditionDeleteMutationFn = Apollo.MutationFunction<
	MedicalConditionDeleteMutation,
	MedicalConditionDeleteMutationVariables
>;

/**
 * __useMedicalConditionDeleteMutation__
 *
 * To run a mutation, you first call `useMedicalConditionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMedicalConditionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [medicalConditionDeleteMutation, { data, loading, error }] = useMedicalConditionDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMedicalConditionDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<MedicalConditionDeleteMutation, MedicalConditionDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MedicalConditionDeleteMutation, MedicalConditionDeleteMutationVariables>(
		MedicalConditionDeleteDocument,
		options,
	);
}
export type MedicalConditionDeleteMutationHookResult = ReturnType<typeof useMedicalConditionDeleteMutation>;
export type MedicalConditionDeleteMutationResult = Apollo.MutationResult<MedicalConditionDeleteMutation>;
export type MedicalConditionDeleteMutationOptions = Apollo.BaseMutationOptions<
	MedicalConditionDeleteMutation,
	MedicalConditionDeleteMutationVariables
>;
export const MedicalConditionDetailDocument = gql`
	query medicalConditionDetail($id: ID!) {
		medicalCondition(id: $id) {
			...MedicalConditionDetail
		}
	}
	${MedicalConditionDetailFragmentDoc}
`;

/**
 * __useMedicalConditionDetailQuery__
 *
 * To run a query within a React component, call `useMedicalConditionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicalConditionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicalConditionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMedicalConditionDetailQuery(
	baseOptions: Apollo.QueryHookOptions<MedicalConditionDetailQuery, MedicalConditionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MedicalConditionDetailQuery, MedicalConditionDetailQueryVariables>(
		MedicalConditionDetailDocument,
		options,
	);
}
export function useMedicalConditionDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MedicalConditionDetailQuery, MedicalConditionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MedicalConditionDetailQuery, MedicalConditionDetailQueryVariables>(
		MedicalConditionDetailDocument,
		options,
	);
}
export function useMedicalConditionDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MedicalConditionDetailQuery, MedicalConditionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MedicalConditionDetailQuery, MedicalConditionDetailQueryVariables>(
		MedicalConditionDetailDocument,
		options,
	);
}
export type MedicalConditionDetailQueryHookResult = ReturnType<typeof useMedicalConditionDetailQuery>;
export type MedicalConditionDetailLazyQueryHookResult = ReturnType<typeof useMedicalConditionDetailLazyQuery>;
export type MedicalConditionDetailSuspenseQueryHookResult = ReturnType<typeof useMedicalConditionDetailSuspenseQuery>;
export type MedicalConditionDetailQueryResult = Apollo.QueryResult<
	MedicalConditionDetailQuery,
	MedicalConditionDetailQueryVariables
>;
export const MedicalConditionIndexDocument = gql`
	query medicalConditionIndex(
		$filters: [MedicalConditionFilterInput!]
		$pagination: Pagination
		$order: MedicalConditionOrder
	) {
		medicalConditionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					conditionType
					description
				}
			}
		}
	}
`;

/**
 * __useMedicalConditionIndexQuery__
 *
 * To run a query within a React component, call `useMedicalConditionIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicalConditionIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicalConditionIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMedicalConditionIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<MedicalConditionIndexQuery, MedicalConditionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MedicalConditionIndexQuery, MedicalConditionIndexQueryVariables>(
		MedicalConditionIndexDocument,
		options,
	);
}
export function useMedicalConditionIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MedicalConditionIndexQuery, MedicalConditionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MedicalConditionIndexQuery, MedicalConditionIndexQueryVariables>(
		MedicalConditionIndexDocument,
		options,
	);
}
export function useMedicalConditionIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MedicalConditionIndexQuery, MedicalConditionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MedicalConditionIndexQuery, MedicalConditionIndexQueryVariables>(
		MedicalConditionIndexDocument,
		options,
	);
}
export type MedicalConditionIndexQueryHookResult = ReturnType<typeof useMedicalConditionIndexQuery>;
export type MedicalConditionIndexLazyQueryHookResult = ReturnType<typeof useMedicalConditionIndexLazyQuery>;
export type MedicalConditionIndexSuspenseQueryHookResult = ReturnType<typeof useMedicalConditionIndexSuspenseQuery>;
export type MedicalConditionIndexQueryResult = Apollo.QueryResult<
	MedicalConditionIndexQuery,
	MedicalConditionIndexQueryVariables
>;
export const MedicalConditionNameDocument = gql`
	query medicalConditionName($id: ID!) {
		medicalCondition(id: $id) {
			id
			...MedicalConditionName
		}
	}
	${MedicalConditionNameFragmentDoc}
`;

/**
 * __useMedicalConditionNameQuery__
 *
 * To run a query within a React component, call `useMedicalConditionNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicalConditionNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicalConditionNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMedicalConditionNameQuery(
	baseOptions: Apollo.QueryHookOptions<MedicalConditionNameQuery, MedicalConditionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MedicalConditionNameQuery, MedicalConditionNameQueryVariables>(
		MedicalConditionNameDocument,
		options,
	);
}
export function useMedicalConditionNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MedicalConditionNameQuery, MedicalConditionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MedicalConditionNameQuery, MedicalConditionNameQueryVariables>(
		MedicalConditionNameDocument,
		options,
	);
}
export function useMedicalConditionNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MedicalConditionNameQuery, MedicalConditionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MedicalConditionNameQuery, MedicalConditionNameQueryVariables>(
		MedicalConditionNameDocument,
		options,
	);
}
export type MedicalConditionNameQueryHookResult = ReturnType<typeof useMedicalConditionNameQuery>;
export type MedicalConditionNameLazyQueryHookResult = ReturnType<typeof useMedicalConditionNameLazyQuery>;
export type MedicalConditionNameSuspenseQueryHookResult = ReturnType<typeof useMedicalConditionNameSuspenseQuery>;
export type MedicalConditionNameQueryResult = Apollo.QueryResult<
	MedicalConditionNameQuery,
	MedicalConditionNameQueryVariables
>;
export const MedicalConditionNamesDocument = gql`
	query medicalConditionNames(
		$filters: [MedicalConditionFilterInput!]
		$pagination: Pagination
		$order: MedicalConditionOrder
	) {
		medicalConditionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...MedicalConditionName
				}
			}
		}
	}
	${MedicalConditionNameFragmentDoc}
`;

/**
 * __useMedicalConditionNamesQuery__
 *
 * To run a query within a React component, call `useMedicalConditionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicalConditionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicalConditionNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMedicalConditionNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<MedicalConditionNamesQuery, MedicalConditionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MedicalConditionNamesQuery, MedicalConditionNamesQueryVariables>(
		MedicalConditionNamesDocument,
		options,
	);
}
export function useMedicalConditionNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MedicalConditionNamesQuery, MedicalConditionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MedicalConditionNamesQuery, MedicalConditionNamesQueryVariables>(
		MedicalConditionNamesDocument,
		options,
	);
}
export function useMedicalConditionNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MedicalConditionNamesQuery, MedicalConditionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MedicalConditionNamesQuery, MedicalConditionNamesQueryVariables>(
		MedicalConditionNamesDocument,
		options,
	);
}
export type MedicalConditionNamesQueryHookResult = ReturnType<typeof useMedicalConditionNamesQuery>;
export type MedicalConditionNamesLazyQueryHookResult = ReturnType<typeof useMedicalConditionNamesLazyQuery>;
export type MedicalConditionNamesSuspenseQueryHookResult = ReturnType<typeof useMedicalConditionNamesSuspenseQuery>;
export type MedicalConditionNamesQueryResult = Apollo.QueryResult<
	MedicalConditionNamesQuery,
	MedicalConditionNamesQueryVariables
>;
export const MedicalConditionPaginationDocument = gql`
	query medicalConditionPagination($filters: [MedicalConditionFilterInput!], $order: MedicalConditionOrder) {
		medicalConditionConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useMedicalConditionPaginationQuery__
 *
 * To run a query within a React component, call `useMedicalConditionPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicalConditionPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicalConditionPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMedicalConditionPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<MedicalConditionPaginationQuery, MedicalConditionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MedicalConditionPaginationQuery, MedicalConditionPaginationQueryVariables>(
		MedicalConditionPaginationDocument,
		options,
	);
}
export function useMedicalConditionPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MedicalConditionPaginationQuery, MedicalConditionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MedicalConditionPaginationQuery, MedicalConditionPaginationQueryVariables>(
		MedicalConditionPaginationDocument,
		options,
	);
}
export function useMedicalConditionPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MedicalConditionPaginationQuery,
		MedicalConditionPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MedicalConditionPaginationQuery, MedicalConditionPaginationQueryVariables>(
		MedicalConditionPaginationDocument,
		options,
	);
}
export type MedicalConditionPaginationQueryHookResult = ReturnType<typeof useMedicalConditionPaginationQuery>;
export type MedicalConditionPaginationLazyQueryHookResult = ReturnType<typeof useMedicalConditionPaginationLazyQuery>;
export type MedicalConditionPaginationSuspenseQueryHookResult = ReturnType<
	typeof useMedicalConditionPaginationSuspenseQuery
>;
export type MedicalConditionPaginationQueryResult = Apollo.QueryResult<
	MedicalConditionPaginationQuery,
	MedicalConditionPaginationQueryVariables
>;
export const MedicalConditionSelectDocument = gql`
	query medicalConditionSelect($filters: [MedicalConditionFilterInput!], $order: MedicalConditionOrder) {
		medicalConditionConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...MedicalConditionName
				}
			}
		}
	}
	${MedicalConditionNameFragmentDoc}
`;

/**
 * __useMedicalConditionSelectQuery__
 *
 * To run a query within a React component, call `useMedicalConditionSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicalConditionSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicalConditionSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMedicalConditionSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<MedicalConditionSelectQuery, MedicalConditionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MedicalConditionSelectQuery, MedicalConditionSelectQueryVariables>(
		MedicalConditionSelectDocument,
		options,
	);
}
export function useMedicalConditionSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MedicalConditionSelectQuery, MedicalConditionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MedicalConditionSelectQuery, MedicalConditionSelectQueryVariables>(
		MedicalConditionSelectDocument,
		options,
	);
}
export function useMedicalConditionSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MedicalConditionSelectQuery, MedicalConditionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MedicalConditionSelectQuery, MedicalConditionSelectQueryVariables>(
		MedicalConditionSelectDocument,
		options,
	);
}
export type MedicalConditionSelectQueryHookResult = ReturnType<typeof useMedicalConditionSelectQuery>;
export type MedicalConditionSelectLazyQueryHookResult = ReturnType<typeof useMedicalConditionSelectLazyQuery>;
export type MedicalConditionSelectSuspenseQueryHookResult = ReturnType<typeof useMedicalConditionSelectSuspenseQuery>;
export type MedicalConditionSelectQueryResult = Apollo.QueryResult<
	MedicalConditionSelectQuery,
	MedicalConditionSelectQueryVariables
>;
export const MedicalConditionUpdateDocument = gql`
	mutation medicalConditionUpdate($id: ID!, $input: MedicalConditionUpdateInput!) {
		updateMedicalCondition(id: $id, input: $input) {
			...MedicalConditionDetail
		}
	}
	${MedicalConditionDetailFragmentDoc}
`;
export type MedicalConditionUpdateMutationFn = Apollo.MutationFunction<
	MedicalConditionUpdateMutation,
	MedicalConditionUpdateMutationVariables
>;

/**
 * __useMedicalConditionUpdateMutation__
 *
 * To run a mutation, you first call `useMedicalConditionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMedicalConditionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [medicalConditionUpdateMutation, { data, loading, error }] = useMedicalConditionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMedicalConditionUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<MedicalConditionUpdateMutation, MedicalConditionUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MedicalConditionUpdateMutation, MedicalConditionUpdateMutationVariables>(
		MedicalConditionUpdateDocument,
		options,
	);
}
export type MedicalConditionUpdateMutationHookResult = ReturnType<typeof useMedicalConditionUpdateMutation>;
export type MedicalConditionUpdateMutationResult = Apollo.MutationResult<MedicalConditionUpdateMutation>;
export type MedicalConditionUpdateMutationOptions = Apollo.BaseMutationOptions<
	MedicalConditionUpdateMutation,
	MedicalConditionUpdateMutationVariables
>;
export const MedicationCountDocument = gql`
	query medicationCount($filters: [MedicationFilterInput!], $pagination: Pagination, $order: MedicationOrder) {
		medicationConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useMedicationCountQuery__
 *
 * To run a query within a React component, call `useMedicationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicationCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMedicationCountQuery(
	baseOptions?: Apollo.QueryHookOptions<MedicationCountQuery, MedicationCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MedicationCountQuery, MedicationCountQueryVariables>(MedicationCountDocument, options);
}
export function useMedicationCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MedicationCountQuery, MedicationCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MedicationCountQuery, MedicationCountQueryVariables>(MedicationCountDocument, options);
}
export function useMedicationCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MedicationCountQuery, MedicationCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MedicationCountQuery, MedicationCountQueryVariables>(MedicationCountDocument, options);
}
export type MedicationCountQueryHookResult = ReturnType<typeof useMedicationCountQuery>;
export type MedicationCountLazyQueryHookResult = ReturnType<typeof useMedicationCountLazyQuery>;
export type MedicationCountSuspenseQueryHookResult = ReturnType<typeof useMedicationCountSuspenseQuery>;
export type MedicationCountQueryResult = Apollo.QueryResult<MedicationCountQuery, MedicationCountQueryVariables>;
export const MedicationCreateDocument = gql`
	mutation medicationCreate($input: MedicationCreateInput!) {
		createMedication(input: $input) {
			...MedicationDetail
		}
	}
	${MedicationDetailFragmentDoc}
`;
export type MedicationCreateMutationFn = Apollo.MutationFunction<
	MedicationCreateMutation,
	MedicationCreateMutationVariables
>;

/**
 * __useMedicationCreateMutation__
 *
 * To run a mutation, you first call `useMedicationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMedicationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [medicationCreateMutation, { data, loading, error }] = useMedicationCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMedicationCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<MedicationCreateMutation, MedicationCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MedicationCreateMutation, MedicationCreateMutationVariables>(
		MedicationCreateDocument,
		options,
	);
}
export type MedicationCreateMutationHookResult = ReturnType<typeof useMedicationCreateMutation>;
export type MedicationCreateMutationResult = Apollo.MutationResult<MedicationCreateMutation>;
export type MedicationCreateMutationOptions = Apollo.BaseMutationOptions<
	MedicationCreateMutation,
	MedicationCreateMutationVariables
>;
export const MedicationDeleteDocument = gql`
	mutation medicationDelete($id: ID!) {
		deleteMedication(id: $id)
	}
`;
export type MedicationDeleteMutationFn = Apollo.MutationFunction<
	MedicationDeleteMutation,
	MedicationDeleteMutationVariables
>;

/**
 * __useMedicationDeleteMutation__
 *
 * To run a mutation, you first call `useMedicationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMedicationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [medicationDeleteMutation, { data, loading, error }] = useMedicationDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMedicationDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<MedicationDeleteMutation, MedicationDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MedicationDeleteMutation, MedicationDeleteMutationVariables>(
		MedicationDeleteDocument,
		options,
	);
}
export type MedicationDeleteMutationHookResult = ReturnType<typeof useMedicationDeleteMutation>;
export type MedicationDeleteMutationResult = Apollo.MutationResult<MedicationDeleteMutation>;
export type MedicationDeleteMutationOptions = Apollo.BaseMutationOptions<
	MedicationDeleteMutation,
	MedicationDeleteMutationVariables
>;
export const MedicationDetailDocument = gql`
	query medicationDetail($id: ID!) {
		medication(id: $id) {
			...MedicationDetail
		}
	}
	${MedicationDetailFragmentDoc}
`;

/**
 * __useMedicationDetailQuery__
 *
 * To run a query within a React component, call `useMedicationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicationDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMedicationDetailQuery(
	baseOptions: Apollo.QueryHookOptions<MedicationDetailQuery, MedicationDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MedicationDetailQuery, MedicationDetailQueryVariables>(MedicationDetailDocument, options);
}
export function useMedicationDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MedicationDetailQuery, MedicationDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MedicationDetailQuery, MedicationDetailQueryVariables>(MedicationDetailDocument, options);
}
export function useMedicationDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MedicationDetailQuery, MedicationDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MedicationDetailQuery, MedicationDetailQueryVariables>(
		MedicationDetailDocument,
		options,
	);
}
export type MedicationDetailQueryHookResult = ReturnType<typeof useMedicationDetailQuery>;
export type MedicationDetailLazyQueryHookResult = ReturnType<typeof useMedicationDetailLazyQuery>;
export type MedicationDetailSuspenseQueryHookResult = ReturnType<typeof useMedicationDetailSuspenseQuery>;
export type MedicationDetailQueryResult = Apollo.QueryResult<MedicationDetailQuery, MedicationDetailQueryVariables>;
export const MedicationIndexDocument = gql`
	query medicationIndex($filters: [MedicationFilterInput!], $pagination: Pagination, $order: MedicationOrder) {
		medicationConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					isPrescription
					description
				}
			}
		}
	}
`;

/**
 * __useMedicationIndexQuery__
 *
 * To run a query within a React component, call `useMedicationIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicationIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicationIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMedicationIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<MedicationIndexQuery, MedicationIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MedicationIndexQuery, MedicationIndexQueryVariables>(MedicationIndexDocument, options);
}
export function useMedicationIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MedicationIndexQuery, MedicationIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MedicationIndexQuery, MedicationIndexQueryVariables>(MedicationIndexDocument, options);
}
export function useMedicationIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MedicationIndexQuery, MedicationIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MedicationIndexQuery, MedicationIndexQueryVariables>(MedicationIndexDocument, options);
}
export type MedicationIndexQueryHookResult = ReturnType<typeof useMedicationIndexQuery>;
export type MedicationIndexLazyQueryHookResult = ReturnType<typeof useMedicationIndexLazyQuery>;
export type MedicationIndexSuspenseQueryHookResult = ReturnType<typeof useMedicationIndexSuspenseQuery>;
export type MedicationIndexQueryResult = Apollo.QueryResult<MedicationIndexQuery, MedicationIndexQueryVariables>;
export const MedicationNameDocument = gql`
	query medicationName($id: ID!) {
		medication(id: $id) {
			id
			...MedicationName
		}
	}
	${MedicationNameFragmentDoc}
`;

/**
 * __useMedicationNameQuery__
 *
 * To run a query within a React component, call `useMedicationNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicationNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicationNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMedicationNameQuery(
	baseOptions: Apollo.QueryHookOptions<MedicationNameQuery, MedicationNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MedicationNameQuery, MedicationNameQueryVariables>(MedicationNameDocument, options);
}
export function useMedicationNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MedicationNameQuery, MedicationNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MedicationNameQuery, MedicationNameQueryVariables>(MedicationNameDocument, options);
}
export function useMedicationNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MedicationNameQuery, MedicationNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MedicationNameQuery, MedicationNameQueryVariables>(MedicationNameDocument, options);
}
export type MedicationNameQueryHookResult = ReturnType<typeof useMedicationNameQuery>;
export type MedicationNameLazyQueryHookResult = ReturnType<typeof useMedicationNameLazyQuery>;
export type MedicationNameSuspenseQueryHookResult = ReturnType<typeof useMedicationNameSuspenseQuery>;
export type MedicationNameQueryResult = Apollo.QueryResult<MedicationNameQuery, MedicationNameQueryVariables>;
export const MedicationNamesDocument = gql`
	query medicationNames($filters: [MedicationFilterInput!], $pagination: Pagination, $order: MedicationOrder) {
		medicationConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...MedicationName
				}
			}
		}
	}
	${MedicationNameFragmentDoc}
`;

/**
 * __useMedicationNamesQuery__
 *
 * To run a query within a React component, call `useMedicationNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicationNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicationNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMedicationNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<MedicationNamesQuery, MedicationNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MedicationNamesQuery, MedicationNamesQueryVariables>(MedicationNamesDocument, options);
}
export function useMedicationNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MedicationNamesQuery, MedicationNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MedicationNamesQuery, MedicationNamesQueryVariables>(MedicationNamesDocument, options);
}
export function useMedicationNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MedicationNamesQuery, MedicationNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MedicationNamesQuery, MedicationNamesQueryVariables>(MedicationNamesDocument, options);
}
export type MedicationNamesQueryHookResult = ReturnType<typeof useMedicationNamesQuery>;
export type MedicationNamesLazyQueryHookResult = ReturnType<typeof useMedicationNamesLazyQuery>;
export type MedicationNamesSuspenseQueryHookResult = ReturnType<typeof useMedicationNamesSuspenseQuery>;
export type MedicationNamesQueryResult = Apollo.QueryResult<MedicationNamesQuery, MedicationNamesQueryVariables>;
export const MedicationPaginationDocument = gql`
	query medicationPagination($filters: [MedicationFilterInput!], $order: MedicationOrder) {
		medicationConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useMedicationPaginationQuery__
 *
 * To run a query within a React component, call `useMedicationPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicationPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicationPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMedicationPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<MedicationPaginationQuery, MedicationPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MedicationPaginationQuery, MedicationPaginationQueryVariables>(
		MedicationPaginationDocument,
		options,
	);
}
export function useMedicationPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MedicationPaginationQuery, MedicationPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MedicationPaginationQuery, MedicationPaginationQueryVariables>(
		MedicationPaginationDocument,
		options,
	);
}
export function useMedicationPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MedicationPaginationQuery, MedicationPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MedicationPaginationQuery, MedicationPaginationQueryVariables>(
		MedicationPaginationDocument,
		options,
	);
}
export type MedicationPaginationQueryHookResult = ReturnType<typeof useMedicationPaginationQuery>;
export type MedicationPaginationLazyQueryHookResult = ReturnType<typeof useMedicationPaginationLazyQuery>;
export type MedicationPaginationSuspenseQueryHookResult = ReturnType<typeof useMedicationPaginationSuspenseQuery>;
export type MedicationPaginationQueryResult = Apollo.QueryResult<
	MedicationPaginationQuery,
	MedicationPaginationQueryVariables
>;
export const MedicationSelectDocument = gql`
	query medicationSelect($filters: [MedicationFilterInput!], $order: MedicationOrder) {
		medicationConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...MedicationName
				}
			}
		}
	}
	${MedicationNameFragmentDoc}
`;

/**
 * __useMedicationSelectQuery__
 *
 * To run a query within a React component, call `useMedicationSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicationSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicationSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMedicationSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<MedicationSelectQuery, MedicationSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MedicationSelectQuery, MedicationSelectQueryVariables>(MedicationSelectDocument, options);
}
export function useMedicationSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MedicationSelectQuery, MedicationSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MedicationSelectQuery, MedicationSelectQueryVariables>(MedicationSelectDocument, options);
}
export function useMedicationSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MedicationSelectQuery, MedicationSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MedicationSelectQuery, MedicationSelectQueryVariables>(
		MedicationSelectDocument,
		options,
	);
}
export type MedicationSelectQueryHookResult = ReturnType<typeof useMedicationSelectQuery>;
export type MedicationSelectLazyQueryHookResult = ReturnType<typeof useMedicationSelectLazyQuery>;
export type MedicationSelectSuspenseQueryHookResult = ReturnType<typeof useMedicationSelectSuspenseQuery>;
export type MedicationSelectQueryResult = Apollo.QueryResult<MedicationSelectQuery, MedicationSelectQueryVariables>;
export const MedicationUpdateDocument = gql`
	mutation medicationUpdate($id: ID!, $input: MedicationUpdateInput!) {
		updateMedication(id: $id, input: $input) {
			...MedicationDetail
		}
	}
	${MedicationDetailFragmentDoc}
`;
export type MedicationUpdateMutationFn = Apollo.MutationFunction<
	MedicationUpdateMutation,
	MedicationUpdateMutationVariables
>;

/**
 * __useMedicationUpdateMutation__
 *
 * To run a mutation, you first call `useMedicationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMedicationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [medicationUpdateMutation, { data, loading, error }] = useMedicationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMedicationUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<MedicationUpdateMutation, MedicationUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MedicationUpdateMutation, MedicationUpdateMutationVariables>(
		MedicationUpdateDocument,
		options,
	);
}
export type MedicationUpdateMutationHookResult = ReturnType<typeof useMedicationUpdateMutation>;
export type MedicationUpdateMutationResult = Apollo.MutationResult<MedicationUpdateMutation>;
export type MedicationUpdateMutationOptions = Apollo.BaseMutationOptions<
	MedicationUpdateMutation,
	MedicationUpdateMutationVariables
>;
export const MessageCountDocument = gql`
	query messageCount($filters: [MessageFilterInput!], $pagination: Pagination, $order: MessageOrder) {
		messageConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useMessageCountQuery__
 *
 * To run a query within a React component, call `useMessageCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageCountQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageCountQuery, MessageCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageCountQuery, MessageCountQueryVariables>(MessageCountDocument, options);
}
export function useMessageCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageCountQuery, MessageCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageCountQuery, MessageCountQueryVariables>(MessageCountDocument, options);
}
export function useMessageCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageCountQuery, MessageCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageCountQuery, MessageCountQueryVariables>(MessageCountDocument, options);
}
export type MessageCountQueryHookResult = ReturnType<typeof useMessageCountQuery>;
export type MessageCountLazyQueryHookResult = ReturnType<typeof useMessageCountLazyQuery>;
export type MessageCountSuspenseQueryHookResult = ReturnType<typeof useMessageCountSuspenseQuery>;
export type MessageCountQueryResult = Apollo.QueryResult<MessageCountQuery, MessageCountQueryVariables>;
export const MessageCreateDocument = gql`
	mutation messageCreate($input: MessageCreateInput!) {
		createMessage(input: $input) {
			...MessageDetail
		}
	}
	${MessageDetailFragmentDoc}
`;
export type MessageCreateMutationFn = Apollo.MutationFunction<MessageCreateMutation, MessageCreateMutationVariables>;

/**
 * __useMessageCreateMutation__
 *
 * To run a mutation, you first call `useMessageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageCreateMutation, { data, loading, error }] = useMessageCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<MessageCreateMutation, MessageCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageCreateMutation, MessageCreateMutationVariables>(MessageCreateDocument, options);
}
export type MessageCreateMutationHookResult = ReturnType<typeof useMessageCreateMutation>;
export type MessageCreateMutationResult = Apollo.MutationResult<MessageCreateMutation>;
export type MessageCreateMutationOptions = Apollo.BaseMutationOptions<
	MessageCreateMutation,
	MessageCreateMutationVariables
>;
export const MessageDeleteDocument = gql`
	mutation messageDelete($id: ID!) {
		deleteMessage(id: $id)
	}
`;
export type MessageDeleteMutationFn = Apollo.MutationFunction<MessageDeleteMutation, MessageDeleteMutationVariables>;

/**
 * __useMessageDeleteMutation__
 *
 * To run a mutation, you first call `useMessageDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageDeleteMutation, { data, loading, error }] = useMessageDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<MessageDeleteMutation, MessageDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageDeleteMutation, MessageDeleteMutationVariables>(MessageDeleteDocument, options);
}
export type MessageDeleteMutationHookResult = ReturnType<typeof useMessageDeleteMutation>;
export type MessageDeleteMutationResult = Apollo.MutationResult<MessageDeleteMutation>;
export type MessageDeleteMutationOptions = Apollo.BaseMutationOptions<
	MessageDeleteMutation,
	MessageDeleteMutationVariables
>;
export const MessageDetailDocument = gql`
	query messageDetail($id: ID!) {
		message(id: $id) {
			...MessageDetail
		}
	}
	${MessageDetailFragmentDoc}
`;

/**
 * __useMessageDetailQuery__
 *
 * To run a query within a React component, call `useMessageDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageDetailQuery(
	baseOptions: Apollo.QueryHookOptions<MessageDetailQuery, MessageDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageDetailQuery, MessageDetailQueryVariables>(MessageDetailDocument, options);
}
export function useMessageDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageDetailQuery, MessageDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageDetailQuery, MessageDetailQueryVariables>(MessageDetailDocument, options);
}
export function useMessageDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageDetailQuery, MessageDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageDetailQuery, MessageDetailQueryVariables>(MessageDetailDocument, options);
}
export type MessageDetailQueryHookResult = ReturnType<typeof useMessageDetailQuery>;
export type MessageDetailLazyQueryHookResult = ReturnType<typeof useMessageDetailLazyQuery>;
export type MessageDetailSuspenseQueryHookResult = ReturnType<typeof useMessageDetailSuspenseQuery>;
export type MessageDetailQueryResult = Apollo.QueryResult<MessageDetailQuery, MessageDetailQueryVariables>;
export const MessageDetailForEditDocument = gql`
	query messageDetailForEdit($id: ID!) {
		message(id: $id) {
			id
			body
			mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
				id
				displayOrder
				title
				description
				isFile
				fileURL
				fileKey
				fileContentType
				linkURL
				taggedPeople {
					id
					...PersonName
					user {
						id
						isCurrent
					}
				}
			}
		}
	}
	${PersonNameFragmentDoc}
`;

/**
 * __useMessageDetailForEditQuery__
 *
 * To run a query within a React component, call `useMessageDetailForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageDetailForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageDetailForEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageDetailForEditQuery(
	baseOptions: Apollo.QueryHookOptions<MessageDetailForEditQuery, MessageDetailForEditQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageDetailForEditQuery, MessageDetailForEditQueryVariables>(
		MessageDetailForEditDocument,
		options,
	);
}
export function useMessageDetailForEditLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageDetailForEditQuery, MessageDetailForEditQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageDetailForEditQuery, MessageDetailForEditQueryVariables>(
		MessageDetailForEditDocument,
		options,
	);
}
export function useMessageDetailForEditSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageDetailForEditQuery, MessageDetailForEditQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageDetailForEditQuery, MessageDetailForEditQueryVariables>(
		MessageDetailForEditDocument,
		options,
	);
}
export type MessageDetailForEditQueryHookResult = ReturnType<typeof useMessageDetailForEditQuery>;
export type MessageDetailForEditLazyQueryHookResult = ReturnType<typeof useMessageDetailForEditLazyQuery>;
export type MessageDetailForEditSuspenseQueryHookResult = ReturnType<typeof useMessageDetailForEditSuspenseQuery>;
export type MessageDetailForEditQueryResult = Apollo.QueryResult<
	MessageDetailForEditQuery,
	MessageDetailForEditQueryVariables
>;
export const MessageGroupMessagesListDocument = gql`
	query messageGroupMessagesList($filters: [MessageFilterInput!], $pagination: Pagination, $order: MessageOrder) {
		messageConnection(filters: $filters, pagination: $pagination, order: $order) {
			pageInfo {
				startCursor
				endCursor
				hasNextPage
				hasPreviousPage
			}
			edges {
				node {
					...MessageInMessageGroup
				}
			}
		}
	}
	${MessageInMessageGroupFragmentDoc}
`;

/**
 * __useMessageGroupMessagesListQuery__
 *
 * To run a query within a React component, call `useMessageGroupMessagesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupMessagesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupMessagesListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupMessagesListQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageGroupMessagesListQuery, MessageGroupMessagesListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupMessagesListQuery, MessageGroupMessagesListQueryVariables>(
		MessageGroupMessagesListDocument,
		options,
	);
}
export function useMessageGroupMessagesListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageGroupMessagesListQuery, MessageGroupMessagesListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupMessagesListQuery, MessageGroupMessagesListQueryVariables>(
		MessageGroupMessagesListDocument,
		options,
	);
}
export function useMessageGroupMessagesListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageGroupMessagesListQuery, MessageGroupMessagesListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupMessagesListQuery, MessageGroupMessagesListQueryVariables>(
		MessageGroupMessagesListDocument,
		options,
	);
}
export type MessageGroupMessagesListQueryHookResult = ReturnType<typeof useMessageGroupMessagesListQuery>;
export type MessageGroupMessagesListLazyQueryHookResult = ReturnType<typeof useMessageGroupMessagesListLazyQuery>;
export type MessageGroupMessagesListSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupMessagesListSuspenseQuery
>;
export type MessageGroupMessagesListQueryResult = Apollo.QueryResult<
	MessageGroupMessagesListQuery,
	MessageGroupMessagesListQueryVariables
>;
export const MessageGroupLatestTopicDocument = gql`
	query messageGroupLatestTopic($messageGroupID: ID!) {
		messageConnection(
			filters: { messageGroupIDEQ: $messageGroupID, hasMessageTopic: true }
			order: { field: CREATED_AT, direction: DESC }
			pagination: { first: 1 }
		) {
			edges {
				node {
					...MessageInMessageGroup
				}
			}
		}
	}
	${MessageInMessageGroupFragmentDoc}
`;

/**
 * __useMessageGroupLatestTopicQuery__
 *
 * To run a query within a React component, call `useMessageGroupLatestTopicQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupLatestTopicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupLatestTopicQuery({
 *   variables: {
 *      messageGroupID: // value for 'messageGroupID'
 *   },
 * });
 */
export function useMessageGroupLatestTopicQuery(
	baseOptions: Apollo.QueryHookOptions<MessageGroupLatestTopicQuery, MessageGroupLatestTopicQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupLatestTopicQuery, MessageGroupLatestTopicQueryVariables>(
		MessageGroupLatestTopicDocument,
		options,
	);
}
export function useMessageGroupLatestTopicLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageGroupLatestTopicQuery, MessageGroupLatestTopicQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupLatestTopicQuery, MessageGroupLatestTopicQueryVariables>(
		MessageGroupLatestTopicDocument,
		options,
	);
}
export function useMessageGroupLatestTopicSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageGroupLatestTopicQuery, MessageGroupLatestTopicQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupLatestTopicQuery, MessageGroupLatestTopicQueryVariables>(
		MessageGroupLatestTopicDocument,
		options,
	);
}
export type MessageGroupLatestTopicQueryHookResult = ReturnType<typeof useMessageGroupLatestTopicQuery>;
export type MessageGroupLatestTopicLazyQueryHookResult = ReturnType<typeof useMessageGroupLatestTopicLazyQuery>;
export type MessageGroupLatestTopicSuspenseQueryHookResult = ReturnType<typeof useMessageGroupLatestTopicSuspenseQuery>;
export type MessageGroupLatestTopicQueryResult = Apollo.QueryResult<
	MessageGroupLatestTopicQuery,
	MessageGroupLatestTopicQueryVariables
>;
export const MessageIndexDocument = gql`
	query messageIndex($filters: [MessageFilterInput!], $pagination: Pagination, $order: MessageOrder) {
		messageConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					body
					lastEditedAt
					isRemoved
				}
			}
		}
	}
`;

/**
 * __useMessageIndexQuery__
 *
 * To run a query within a React component, call `useMessageIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageIndexQuery, MessageIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageIndexQuery, MessageIndexQueryVariables>(MessageIndexDocument, options);
}
export function useMessageIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageIndexQuery, MessageIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageIndexQuery, MessageIndexQueryVariables>(MessageIndexDocument, options);
}
export function useMessageIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageIndexQuery, MessageIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageIndexQuery, MessageIndexQueryVariables>(MessageIndexDocument, options);
}
export type MessageIndexQueryHookResult = ReturnType<typeof useMessageIndexQuery>;
export type MessageIndexLazyQueryHookResult = ReturnType<typeof useMessageIndexLazyQuery>;
export type MessageIndexSuspenseQueryHookResult = ReturnType<typeof useMessageIndexSuspenseQuery>;
export type MessageIndexQueryResult = Apollo.QueryResult<MessageIndexQuery, MessageIndexQueryVariables>;
export const LatestMessagesAndMessageGroupsListDocument = gql`
	query latestMessagesAndMessageGroupsList(
		$filters: [MessageFilterInput!]
		$archived: Boolean
		$pagination: Pagination
		$order: MessageOrder
	) {
		latestMessageByGroupConnection(filters: $filters, archived: $archived, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					body
					isRemoved
					messageGroup {
						id
						...MessageGroupNameImageAndAvailability
					}
					mediaAttachments {
						id
					}
				}
			}
		}
	}
	${MessageGroupNameImageAndAvailabilityFragmentDoc}
`;

/**
 * __useLatestMessagesAndMessageGroupsListQuery__
 *
 * To run a query within a React component, call `useLatestMessagesAndMessageGroupsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestMessagesAndMessageGroupsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestMessagesAndMessageGroupsListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      archived: // value for 'archived'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLatestMessagesAndMessageGroupsListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		LatestMessagesAndMessageGroupsListQuery,
		LatestMessagesAndMessageGroupsListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LatestMessagesAndMessageGroupsListQuery, LatestMessagesAndMessageGroupsListQueryVariables>(
		LatestMessagesAndMessageGroupsListDocument,
		options,
	);
}
export function useLatestMessagesAndMessageGroupsListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		LatestMessagesAndMessageGroupsListQuery,
		LatestMessagesAndMessageGroupsListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LatestMessagesAndMessageGroupsListQuery, LatestMessagesAndMessageGroupsListQueryVariables>(
		LatestMessagesAndMessageGroupsListDocument,
		options,
	);
}
export function useLatestMessagesAndMessageGroupsListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		LatestMessagesAndMessageGroupsListQuery,
		LatestMessagesAndMessageGroupsListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		LatestMessagesAndMessageGroupsListQuery,
		LatestMessagesAndMessageGroupsListQueryVariables
	>(LatestMessagesAndMessageGroupsListDocument, options);
}
export type LatestMessagesAndMessageGroupsListQueryHookResult = ReturnType<
	typeof useLatestMessagesAndMessageGroupsListQuery
>;
export type LatestMessagesAndMessageGroupsListLazyQueryHookResult = ReturnType<
	typeof useLatestMessagesAndMessageGroupsListLazyQuery
>;
export type LatestMessagesAndMessageGroupsListSuspenseQueryHookResult = ReturnType<
	typeof useLatestMessagesAndMessageGroupsListSuspenseQuery
>;
export type LatestMessagesAndMessageGroupsListQueryResult = Apollo.QueryResult<
	LatestMessagesAndMessageGroupsListQuery,
	LatestMessagesAndMessageGroupsListQueryVariables
>;
export const MessageNameDocument = gql`
	query messageName($id: ID!) {
		message(id: $id) {
			id
			...MessageName
		}
	}
	${MessageNameFragmentDoc}
`;

/**
 * __useMessageNameQuery__
 *
 * To run a query within a React component, call `useMessageNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageNameQuery(baseOptions: Apollo.QueryHookOptions<MessageNameQuery, MessageNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageNameQuery, MessageNameQueryVariables>(MessageNameDocument, options);
}
export function useMessageNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageNameQuery, MessageNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageNameQuery, MessageNameQueryVariables>(MessageNameDocument, options);
}
export function useMessageNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageNameQuery, MessageNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageNameQuery, MessageNameQueryVariables>(MessageNameDocument, options);
}
export type MessageNameQueryHookResult = ReturnType<typeof useMessageNameQuery>;
export type MessageNameLazyQueryHookResult = ReturnType<typeof useMessageNameLazyQuery>;
export type MessageNameSuspenseQueryHookResult = ReturnType<typeof useMessageNameSuspenseQuery>;
export type MessageNameQueryResult = Apollo.QueryResult<MessageNameQuery, MessageNameQueryVariables>;
export const MessageNamesDocument = gql`
	query messageNames($filters: [MessageFilterInput!], $pagination: Pagination, $order: MessageOrder) {
		messageConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...MessageName
				}
			}
		}
	}
	${MessageNameFragmentDoc}
`;

/**
 * __useMessageNamesQuery__
 *
 * To run a query within a React component, call `useMessageNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageNamesQuery, MessageNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageNamesQuery, MessageNamesQueryVariables>(MessageNamesDocument, options);
}
export function useMessageNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageNamesQuery, MessageNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageNamesQuery, MessageNamesQueryVariables>(MessageNamesDocument, options);
}
export function useMessageNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageNamesQuery, MessageNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageNamesQuery, MessageNamesQueryVariables>(MessageNamesDocument, options);
}
export type MessageNamesQueryHookResult = ReturnType<typeof useMessageNamesQuery>;
export type MessageNamesLazyQueryHookResult = ReturnType<typeof useMessageNamesLazyQuery>;
export type MessageNamesSuspenseQueryHookResult = ReturnType<typeof useMessageNamesSuspenseQuery>;
export type MessageNamesQueryResult = Apollo.QueryResult<MessageNamesQuery, MessageNamesQueryVariables>;
export const UnreadMessagesCountDocument = gql`
	query unreadMessagesCount {
		unreadMessagesCount
	}
`;

/**
 * __useUnreadMessagesCountQuery__
 *
 * To run a query within a React component, call `useUnreadMessagesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadMessagesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadMessagesCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnreadMessagesCountQuery(
	baseOptions?: Apollo.QueryHookOptions<UnreadMessagesCountQuery, UnreadMessagesCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UnreadMessagesCountQuery, UnreadMessagesCountQueryVariables>(
		UnreadMessagesCountDocument,
		options,
	);
}
export function useUnreadMessagesCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UnreadMessagesCountQuery, UnreadMessagesCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UnreadMessagesCountQuery, UnreadMessagesCountQueryVariables>(
		UnreadMessagesCountDocument,
		options,
	);
}
export function useUnreadMessagesCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UnreadMessagesCountQuery, UnreadMessagesCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UnreadMessagesCountQuery, UnreadMessagesCountQueryVariables>(
		UnreadMessagesCountDocument,
		options,
	);
}
export type UnreadMessagesCountQueryHookResult = ReturnType<typeof useUnreadMessagesCountQuery>;
export type UnreadMessagesCountLazyQueryHookResult = ReturnType<typeof useUnreadMessagesCountLazyQuery>;
export type UnreadMessagesCountSuspenseQueryHookResult = ReturnType<typeof useUnreadMessagesCountSuspenseQuery>;
export type UnreadMessagesCountQueryResult = Apollo.QueryResult<
	UnreadMessagesCountQuery,
	UnreadMessagesCountQueryVariables
>;
export const MessagePaginationDocument = gql`
	query messagePagination($filters: [MessageFilterInput!], $order: MessageOrder) {
		messageConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useMessagePaginationQuery__
 *
 * To run a query within a React component, call `useMessagePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessagePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<MessagePaginationQuery, MessagePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessagePaginationQuery, MessagePaginationQueryVariables>(MessagePaginationDocument, options);
}
export function useMessagePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessagePaginationQuery, MessagePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessagePaginationQuery, MessagePaginationQueryVariables>(
		MessagePaginationDocument,
		options,
	);
}
export function useMessagePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessagePaginationQuery, MessagePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessagePaginationQuery, MessagePaginationQueryVariables>(
		MessagePaginationDocument,
		options,
	);
}
export type MessagePaginationQueryHookResult = ReturnType<typeof useMessagePaginationQuery>;
export type MessagePaginationLazyQueryHookResult = ReturnType<typeof useMessagePaginationLazyQuery>;
export type MessagePaginationSuspenseQueryHookResult = ReturnType<typeof useMessagePaginationSuspenseQuery>;
export type MessagePaginationQueryResult = Apollo.QueryResult<MessagePaginationQuery, MessagePaginationQueryVariables>;
export const MessageSelectDocument = gql`
	query messageSelect($filters: [MessageFilterInput!], $order: MessageOrder) {
		messageConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...MessageName
				}
			}
		}
	}
	${MessageNameFragmentDoc}
`;

/**
 * __useMessageSelectQuery__
 *
 * To run a query within a React component, call `useMessageSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageSelectQuery, MessageSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageSelectQuery, MessageSelectQueryVariables>(MessageSelectDocument, options);
}
export function useMessageSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageSelectQuery, MessageSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageSelectQuery, MessageSelectQueryVariables>(MessageSelectDocument, options);
}
export function useMessageSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageSelectQuery, MessageSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageSelectQuery, MessageSelectQueryVariables>(MessageSelectDocument, options);
}
export type MessageSelectQueryHookResult = ReturnType<typeof useMessageSelectQuery>;
export type MessageSelectLazyQueryHookResult = ReturnType<typeof useMessageSelectLazyQuery>;
export type MessageSelectSuspenseQueryHookResult = ReturnType<typeof useMessageSelectSuspenseQuery>;
export type MessageSelectQueryResult = Apollo.QueryResult<MessageSelectQuery, MessageSelectQueryVariables>;
export const MessageUpdateDocument = gql`
	mutation messageUpdate($id: ID!, $input: MessageUpdateInput!) {
		updateMessage(id: $id, input: $input) {
			...MessageDetail
		}
	}
	${MessageDetailFragmentDoc}
`;
export type MessageUpdateMutationFn = Apollo.MutationFunction<MessageUpdateMutation, MessageUpdateMutationVariables>;

/**
 * __useMessageUpdateMutation__
 *
 * To run a mutation, you first call `useMessageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageUpdateMutation, { data, loading, error }] = useMessageUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<MessageUpdateMutation, MessageUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageUpdateMutation, MessageUpdateMutationVariables>(MessageUpdateDocument, options);
}
export type MessageUpdateMutationHookResult = ReturnType<typeof useMessageUpdateMutation>;
export type MessageUpdateMutationResult = Apollo.MutationResult<MessageUpdateMutation>;
export type MessageUpdateMutationOptions = Apollo.BaseMutationOptions<
	MessageUpdateMutation,
	MessageUpdateMutationVariables
>;
export const MessageAvailabilityPeriodCountDocument = gql`
	query messageAvailabilityPeriodCount(
		$filters: [MessageAvailabilityPeriodFilterInput!]
		$pagination: Pagination
		$order: MessageAvailabilityPeriodOrder
	) {
		messageAvailabilityPeriodConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useMessageAvailabilityPeriodCountQuery__
 *
 * To run a query within a React component, call `useMessageAvailabilityPeriodCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageAvailabilityPeriodCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageAvailabilityPeriodCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageAvailabilityPeriodCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MessageAvailabilityPeriodCountQuery,
		MessageAvailabilityPeriodCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageAvailabilityPeriodCountQuery, MessageAvailabilityPeriodCountQueryVariables>(
		MessageAvailabilityPeriodCountDocument,
		options,
	);
}
export function useMessageAvailabilityPeriodCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageAvailabilityPeriodCountQuery,
		MessageAvailabilityPeriodCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageAvailabilityPeriodCountQuery, MessageAvailabilityPeriodCountQueryVariables>(
		MessageAvailabilityPeriodCountDocument,
		options,
	);
}
export function useMessageAvailabilityPeriodCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageAvailabilityPeriodCountQuery,
		MessageAvailabilityPeriodCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageAvailabilityPeriodCountQuery, MessageAvailabilityPeriodCountQueryVariables>(
		MessageAvailabilityPeriodCountDocument,
		options,
	);
}
export type MessageAvailabilityPeriodCountQueryHookResult = ReturnType<typeof useMessageAvailabilityPeriodCountQuery>;
export type MessageAvailabilityPeriodCountLazyQueryHookResult = ReturnType<
	typeof useMessageAvailabilityPeriodCountLazyQuery
>;
export type MessageAvailabilityPeriodCountSuspenseQueryHookResult = ReturnType<
	typeof useMessageAvailabilityPeriodCountSuspenseQuery
>;
export type MessageAvailabilityPeriodCountQueryResult = Apollo.QueryResult<
	MessageAvailabilityPeriodCountQuery,
	MessageAvailabilityPeriodCountQueryVariables
>;
export const MessageAvailabilityPeriodCreateDocument = gql`
	mutation messageAvailabilityPeriodCreate($input: MessageAvailabilityPeriodCreateInput!) {
		createMessageAvailabilityPeriod(input: $input) {
			...MessageAvailabilityPeriodDetail
		}
	}
	${MessageAvailabilityPeriodDetailFragmentDoc}
`;
export type MessageAvailabilityPeriodCreateMutationFn = Apollo.MutationFunction<
	MessageAvailabilityPeriodCreateMutation,
	MessageAvailabilityPeriodCreateMutationVariables
>;

/**
 * __useMessageAvailabilityPeriodCreateMutation__
 *
 * To run a mutation, you first call `useMessageAvailabilityPeriodCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageAvailabilityPeriodCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageAvailabilityPeriodCreateMutation, { data, loading, error }] = useMessageAvailabilityPeriodCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageAvailabilityPeriodCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MessageAvailabilityPeriodCreateMutation,
		MessageAvailabilityPeriodCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageAvailabilityPeriodCreateMutation, MessageAvailabilityPeriodCreateMutationVariables>(
		MessageAvailabilityPeriodCreateDocument,
		options,
	);
}
export type MessageAvailabilityPeriodCreateMutationHookResult = ReturnType<
	typeof useMessageAvailabilityPeriodCreateMutation
>;
export type MessageAvailabilityPeriodCreateMutationResult =
	Apollo.MutationResult<MessageAvailabilityPeriodCreateMutation>;
export type MessageAvailabilityPeriodCreateMutationOptions = Apollo.BaseMutationOptions<
	MessageAvailabilityPeriodCreateMutation,
	MessageAvailabilityPeriodCreateMutationVariables
>;
export const MessageAvailabilityPeriodDeleteDocument = gql`
	mutation messageAvailabilityPeriodDelete($id: ID!) {
		deleteMessageAvailabilityPeriod(id: $id)
	}
`;
export type MessageAvailabilityPeriodDeleteMutationFn = Apollo.MutationFunction<
	MessageAvailabilityPeriodDeleteMutation,
	MessageAvailabilityPeriodDeleteMutationVariables
>;

/**
 * __useMessageAvailabilityPeriodDeleteMutation__
 *
 * To run a mutation, you first call `useMessageAvailabilityPeriodDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageAvailabilityPeriodDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageAvailabilityPeriodDeleteMutation, { data, loading, error }] = useMessageAvailabilityPeriodDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageAvailabilityPeriodDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MessageAvailabilityPeriodDeleteMutation,
		MessageAvailabilityPeriodDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageAvailabilityPeriodDeleteMutation, MessageAvailabilityPeriodDeleteMutationVariables>(
		MessageAvailabilityPeriodDeleteDocument,
		options,
	);
}
export type MessageAvailabilityPeriodDeleteMutationHookResult = ReturnType<
	typeof useMessageAvailabilityPeriodDeleteMutation
>;
export type MessageAvailabilityPeriodDeleteMutationResult =
	Apollo.MutationResult<MessageAvailabilityPeriodDeleteMutation>;
export type MessageAvailabilityPeriodDeleteMutationOptions = Apollo.BaseMutationOptions<
	MessageAvailabilityPeriodDeleteMutation,
	MessageAvailabilityPeriodDeleteMutationVariables
>;
export const MessageAvailabilityPeriodDetailDocument = gql`
	query messageAvailabilityPeriodDetail($id: ID!) {
		messageAvailabilityPeriod(id: $id) {
			...MessageAvailabilityPeriodDetail
		}
	}
	${MessageAvailabilityPeriodDetailFragmentDoc}
`;

/**
 * __useMessageAvailabilityPeriodDetailQuery__
 *
 * To run a query within a React component, call `useMessageAvailabilityPeriodDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageAvailabilityPeriodDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageAvailabilityPeriodDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageAvailabilityPeriodDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		MessageAvailabilityPeriodDetailQuery,
		MessageAvailabilityPeriodDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageAvailabilityPeriodDetailQuery, MessageAvailabilityPeriodDetailQueryVariables>(
		MessageAvailabilityPeriodDetailDocument,
		options,
	);
}
export function useMessageAvailabilityPeriodDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageAvailabilityPeriodDetailQuery,
		MessageAvailabilityPeriodDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageAvailabilityPeriodDetailQuery, MessageAvailabilityPeriodDetailQueryVariables>(
		MessageAvailabilityPeriodDetailDocument,
		options,
	);
}
export function useMessageAvailabilityPeriodDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageAvailabilityPeriodDetailQuery,
		MessageAvailabilityPeriodDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageAvailabilityPeriodDetailQuery, MessageAvailabilityPeriodDetailQueryVariables>(
		MessageAvailabilityPeriodDetailDocument,
		options,
	);
}
export type MessageAvailabilityPeriodDetailQueryHookResult = ReturnType<typeof useMessageAvailabilityPeriodDetailQuery>;
export type MessageAvailabilityPeriodDetailLazyQueryHookResult = ReturnType<
	typeof useMessageAvailabilityPeriodDetailLazyQuery
>;
export type MessageAvailabilityPeriodDetailSuspenseQueryHookResult = ReturnType<
	typeof useMessageAvailabilityPeriodDetailSuspenseQuery
>;
export type MessageAvailabilityPeriodDetailQueryResult = Apollo.QueryResult<
	MessageAvailabilityPeriodDetailQuery,
	MessageAvailabilityPeriodDetailQueryVariables
>;
export const MessageAvailabilityPeriodIndexDocument = gql`
	query messageAvailabilityPeriodIndex(
		$filters: [MessageAvailabilityPeriodFilterInput!]
		$pagination: Pagination
		$order: MessageAvailabilityPeriodOrder
	) {
		messageAvailabilityPeriodConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					dayOfWeek
					startTimeMinutes
					endTimeMinutes
				}
			}
		}
	}
`;

/**
 * __useMessageAvailabilityPeriodIndexQuery__
 *
 * To run a query within a React component, call `useMessageAvailabilityPeriodIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageAvailabilityPeriodIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageAvailabilityPeriodIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageAvailabilityPeriodIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MessageAvailabilityPeriodIndexQuery,
		MessageAvailabilityPeriodIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageAvailabilityPeriodIndexQuery, MessageAvailabilityPeriodIndexQueryVariables>(
		MessageAvailabilityPeriodIndexDocument,
		options,
	);
}
export function useMessageAvailabilityPeriodIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageAvailabilityPeriodIndexQuery,
		MessageAvailabilityPeriodIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageAvailabilityPeriodIndexQuery, MessageAvailabilityPeriodIndexQueryVariables>(
		MessageAvailabilityPeriodIndexDocument,
		options,
	);
}
export function useMessageAvailabilityPeriodIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageAvailabilityPeriodIndexQuery,
		MessageAvailabilityPeriodIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageAvailabilityPeriodIndexQuery, MessageAvailabilityPeriodIndexQueryVariables>(
		MessageAvailabilityPeriodIndexDocument,
		options,
	);
}
export type MessageAvailabilityPeriodIndexQueryHookResult = ReturnType<typeof useMessageAvailabilityPeriodIndexQuery>;
export type MessageAvailabilityPeriodIndexLazyQueryHookResult = ReturnType<
	typeof useMessageAvailabilityPeriodIndexLazyQuery
>;
export type MessageAvailabilityPeriodIndexSuspenseQueryHookResult = ReturnType<
	typeof useMessageAvailabilityPeriodIndexSuspenseQuery
>;
export type MessageAvailabilityPeriodIndexQueryResult = Apollo.QueryResult<
	MessageAvailabilityPeriodIndexQuery,
	MessageAvailabilityPeriodIndexQueryVariables
>;
export const MessageAvailabilityPeriodNameDocument = gql`
	query messageAvailabilityPeriodName($id: ID!) {
		messageAvailabilityPeriod(id: $id) {
			id
			...MessageAvailabilityPeriodName
		}
	}
	${MessageAvailabilityPeriodNameFragmentDoc}
`;

/**
 * __useMessageAvailabilityPeriodNameQuery__
 *
 * To run a query within a React component, call `useMessageAvailabilityPeriodNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageAvailabilityPeriodNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageAvailabilityPeriodNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageAvailabilityPeriodNameQuery(
	baseOptions: Apollo.QueryHookOptions<MessageAvailabilityPeriodNameQuery, MessageAvailabilityPeriodNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageAvailabilityPeriodNameQuery, MessageAvailabilityPeriodNameQueryVariables>(
		MessageAvailabilityPeriodNameDocument,
		options,
	);
}
export function useMessageAvailabilityPeriodNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageAvailabilityPeriodNameQuery,
		MessageAvailabilityPeriodNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageAvailabilityPeriodNameQuery, MessageAvailabilityPeriodNameQueryVariables>(
		MessageAvailabilityPeriodNameDocument,
		options,
	);
}
export function useMessageAvailabilityPeriodNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageAvailabilityPeriodNameQuery,
		MessageAvailabilityPeriodNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageAvailabilityPeriodNameQuery, MessageAvailabilityPeriodNameQueryVariables>(
		MessageAvailabilityPeriodNameDocument,
		options,
	);
}
export type MessageAvailabilityPeriodNameQueryHookResult = ReturnType<typeof useMessageAvailabilityPeriodNameQuery>;
export type MessageAvailabilityPeriodNameLazyQueryHookResult = ReturnType<
	typeof useMessageAvailabilityPeriodNameLazyQuery
>;
export type MessageAvailabilityPeriodNameSuspenseQueryHookResult = ReturnType<
	typeof useMessageAvailabilityPeriodNameSuspenseQuery
>;
export type MessageAvailabilityPeriodNameQueryResult = Apollo.QueryResult<
	MessageAvailabilityPeriodNameQuery,
	MessageAvailabilityPeriodNameQueryVariables
>;
export const MessageAvailabilityPeriodNamesDocument = gql`
	query messageAvailabilityPeriodNames(
		$filters: [MessageAvailabilityPeriodFilterInput!]
		$pagination: Pagination
		$order: MessageAvailabilityPeriodOrder
	) {
		messageAvailabilityPeriodConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...MessageAvailabilityPeriodName
				}
			}
		}
	}
	${MessageAvailabilityPeriodNameFragmentDoc}
`;

/**
 * __useMessageAvailabilityPeriodNamesQuery__
 *
 * To run a query within a React component, call `useMessageAvailabilityPeriodNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageAvailabilityPeriodNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageAvailabilityPeriodNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageAvailabilityPeriodNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MessageAvailabilityPeriodNamesQuery,
		MessageAvailabilityPeriodNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageAvailabilityPeriodNamesQuery, MessageAvailabilityPeriodNamesQueryVariables>(
		MessageAvailabilityPeriodNamesDocument,
		options,
	);
}
export function useMessageAvailabilityPeriodNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageAvailabilityPeriodNamesQuery,
		MessageAvailabilityPeriodNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageAvailabilityPeriodNamesQuery, MessageAvailabilityPeriodNamesQueryVariables>(
		MessageAvailabilityPeriodNamesDocument,
		options,
	);
}
export function useMessageAvailabilityPeriodNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageAvailabilityPeriodNamesQuery,
		MessageAvailabilityPeriodNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageAvailabilityPeriodNamesQuery, MessageAvailabilityPeriodNamesQueryVariables>(
		MessageAvailabilityPeriodNamesDocument,
		options,
	);
}
export type MessageAvailabilityPeriodNamesQueryHookResult = ReturnType<typeof useMessageAvailabilityPeriodNamesQuery>;
export type MessageAvailabilityPeriodNamesLazyQueryHookResult = ReturnType<
	typeof useMessageAvailabilityPeriodNamesLazyQuery
>;
export type MessageAvailabilityPeriodNamesSuspenseQueryHookResult = ReturnType<
	typeof useMessageAvailabilityPeriodNamesSuspenseQuery
>;
export type MessageAvailabilityPeriodNamesQueryResult = Apollo.QueryResult<
	MessageAvailabilityPeriodNamesQuery,
	MessageAvailabilityPeriodNamesQueryVariables
>;
export const MessageAvailabilityPeriodPaginationDocument = gql`
	query messageAvailabilityPeriodPagination(
		$filters: [MessageAvailabilityPeriodFilterInput!]
		$order: MessageAvailabilityPeriodOrder
	) {
		messageAvailabilityPeriodConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useMessageAvailabilityPeriodPaginationQuery__
 *
 * To run a query within a React component, call `useMessageAvailabilityPeriodPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageAvailabilityPeriodPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageAvailabilityPeriodPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageAvailabilityPeriodPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MessageAvailabilityPeriodPaginationQuery,
		MessageAvailabilityPeriodPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageAvailabilityPeriodPaginationQuery, MessageAvailabilityPeriodPaginationQueryVariables>(
		MessageAvailabilityPeriodPaginationDocument,
		options,
	);
}
export function useMessageAvailabilityPeriodPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageAvailabilityPeriodPaginationQuery,
		MessageAvailabilityPeriodPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MessageAvailabilityPeriodPaginationQuery,
		MessageAvailabilityPeriodPaginationQueryVariables
	>(MessageAvailabilityPeriodPaginationDocument, options);
}
export function useMessageAvailabilityPeriodPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageAvailabilityPeriodPaginationQuery,
		MessageAvailabilityPeriodPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		MessageAvailabilityPeriodPaginationQuery,
		MessageAvailabilityPeriodPaginationQueryVariables
	>(MessageAvailabilityPeriodPaginationDocument, options);
}
export type MessageAvailabilityPeriodPaginationQueryHookResult = ReturnType<
	typeof useMessageAvailabilityPeriodPaginationQuery
>;
export type MessageAvailabilityPeriodPaginationLazyQueryHookResult = ReturnType<
	typeof useMessageAvailabilityPeriodPaginationLazyQuery
>;
export type MessageAvailabilityPeriodPaginationSuspenseQueryHookResult = ReturnType<
	typeof useMessageAvailabilityPeriodPaginationSuspenseQuery
>;
export type MessageAvailabilityPeriodPaginationQueryResult = Apollo.QueryResult<
	MessageAvailabilityPeriodPaginationQuery,
	MessageAvailabilityPeriodPaginationQueryVariables
>;
export const MessageAvailabilityPeriodSelectDocument = gql`
	query messageAvailabilityPeriodSelect(
		$filters: [MessageAvailabilityPeriodFilterInput!]
		$order: MessageAvailabilityPeriodOrder
	) {
		messageAvailabilityPeriodConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...MessageAvailabilityPeriodName
				}
			}
		}
	}
	${MessageAvailabilityPeriodNameFragmentDoc}
`;

/**
 * __useMessageAvailabilityPeriodSelectQuery__
 *
 * To run a query within a React component, call `useMessageAvailabilityPeriodSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageAvailabilityPeriodSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageAvailabilityPeriodSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageAvailabilityPeriodSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MessageAvailabilityPeriodSelectQuery,
		MessageAvailabilityPeriodSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageAvailabilityPeriodSelectQuery, MessageAvailabilityPeriodSelectQueryVariables>(
		MessageAvailabilityPeriodSelectDocument,
		options,
	);
}
export function useMessageAvailabilityPeriodSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageAvailabilityPeriodSelectQuery,
		MessageAvailabilityPeriodSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageAvailabilityPeriodSelectQuery, MessageAvailabilityPeriodSelectQueryVariables>(
		MessageAvailabilityPeriodSelectDocument,
		options,
	);
}
export function useMessageAvailabilityPeriodSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageAvailabilityPeriodSelectQuery,
		MessageAvailabilityPeriodSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageAvailabilityPeriodSelectQuery, MessageAvailabilityPeriodSelectQueryVariables>(
		MessageAvailabilityPeriodSelectDocument,
		options,
	);
}
export type MessageAvailabilityPeriodSelectQueryHookResult = ReturnType<typeof useMessageAvailabilityPeriodSelectQuery>;
export type MessageAvailabilityPeriodSelectLazyQueryHookResult = ReturnType<
	typeof useMessageAvailabilityPeriodSelectLazyQuery
>;
export type MessageAvailabilityPeriodSelectSuspenseQueryHookResult = ReturnType<
	typeof useMessageAvailabilityPeriodSelectSuspenseQuery
>;
export type MessageAvailabilityPeriodSelectQueryResult = Apollo.QueryResult<
	MessageAvailabilityPeriodSelectQuery,
	MessageAvailabilityPeriodSelectQueryVariables
>;
export const MessageAvailabilityPeriodUpdateDocument = gql`
	mutation messageAvailabilityPeriodUpdate($id: ID!, $input: MessageAvailabilityPeriodUpdateInput!) {
		updateMessageAvailabilityPeriod(id: $id, input: $input) {
			...MessageAvailabilityPeriodDetail
		}
	}
	${MessageAvailabilityPeriodDetailFragmentDoc}
`;
export type MessageAvailabilityPeriodUpdateMutationFn = Apollo.MutationFunction<
	MessageAvailabilityPeriodUpdateMutation,
	MessageAvailabilityPeriodUpdateMutationVariables
>;

/**
 * __useMessageAvailabilityPeriodUpdateMutation__
 *
 * To run a mutation, you first call `useMessageAvailabilityPeriodUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageAvailabilityPeriodUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageAvailabilityPeriodUpdateMutation, { data, loading, error }] = useMessageAvailabilityPeriodUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageAvailabilityPeriodUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MessageAvailabilityPeriodUpdateMutation,
		MessageAvailabilityPeriodUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageAvailabilityPeriodUpdateMutation, MessageAvailabilityPeriodUpdateMutationVariables>(
		MessageAvailabilityPeriodUpdateDocument,
		options,
	);
}
export type MessageAvailabilityPeriodUpdateMutationHookResult = ReturnType<
	typeof useMessageAvailabilityPeriodUpdateMutation
>;
export type MessageAvailabilityPeriodUpdateMutationResult =
	Apollo.MutationResult<MessageAvailabilityPeriodUpdateMutation>;
export type MessageAvailabilityPeriodUpdateMutationOptions = Apollo.BaseMutationOptions<
	MessageAvailabilityPeriodUpdateMutation,
	MessageAvailabilityPeriodUpdateMutationVariables
>;
export const CanViewerSendMessageInGroupDocument = gql`
	query canViewerSendMessageInGroup($messageGroupID: ID!) {
		viewer {
			id
			person {
				id
				publicNameFormat
			}
		}
		messageGroup(id: $messageGroupID) {
			id
			userGroups {
				id
				members(filters: { isCurrentEQ: true }) {
					id
				}
			}
			users(filters: { isCurrentEQ: true }) {
				id
			}
		}
	}
`;

/**
 * __useCanViewerSendMessageInGroupQuery__
 *
 * To run a query within a React component, call `useCanViewerSendMessageInGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanViewerSendMessageInGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanViewerSendMessageInGroupQuery({
 *   variables: {
 *      messageGroupID: // value for 'messageGroupID'
 *   },
 * });
 */
export function useCanViewerSendMessageInGroupQuery(
	baseOptions: Apollo.QueryHookOptions<CanViewerSendMessageInGroupQuery, CanViewerSendMessageInGroupQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CanViewerSendMessageInGroupQuery, CanViewerSendMessageInGroupQueryVariables>(
		CanViewerSendMessageInGroupDocument,
		options,
	);
}
export function useCanViewerSendMessageInGroupLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CanViewerSendMessageInGroupQuery,
		CanViewerSendMessageInGroupQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CanViewerSendMessageInGroupQuery, CanViewerSendMessageInGroupQueryVariables>(
		CanViewerSendMessageInGroupDocument,
		options,
	);
}
export function useCanViewerSendMessageInGroupSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CanViewerSendMessageInGroupQuery,
		CanViewerSendMessageInGroupQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CanViewerSendMessageInGroupQuery, CanViewerSendMessageInGroupQueryVariables>(
		CanViewerSendMessageInGroupDocument,
		options,
	);
}
export type CanViewerSendMessageInGroupQueryHookResult = ReturnType<typeof useCanViewerSendMessageInGroupQuery>;
export type CanViewerSendMessageInGroupLazyQueryHookResult = ReturnType<typeof useCanViewerSendMessageInGroupLazyQuery>;
export type CanViewerSendMessageInGroupSuspenseQueryHookResult = ReturnType<
	typeof useCanViewerSendMessageInGroupSuspenseQuery
>;
export type CanViewerSendMessageInGroupQueryResult = Apollo.QueryResult<
	CanViewerSendMessageInGroupQuery,
	CanViewerSendMessageInGroupQueryVariables
>;
export const MessageGroupCountDocument = gql`
	query messageGroupCount($filters: [MessageGroupFilterInput!], $pagination: Pagination, $order: MessageGroupOrder) {
		messageGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useMessageGroupCountQuery__
 *
 * To run a query within a React component, call `useMessageGroupCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupCountQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageGroupCountQuery, MessageGroupCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupCountQuery, MessageGroupCountQueryVariables>(MessageGroupCountDocument, options);
}
export function useMessageGroupCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageGroupCountQuery, MessageGroupCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupCountQuery, MessageGroupCountQueryVariables>(
		MessageGroupCountDocument,
		options,
	);
}
export function useMessageGroupCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageGroupCountQuery, MessageGroupCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupCountQuery, MessageGroupCountQueryVariables>(
		MessageGroupCountDocument,
		options,
	);
}
export type MessageGroupCountQueryHookResult = ReturnType<typeof useMessageGroupCountQuery>;
export type MessageGroupCountLazyQueryHookResult = ReturnType<typeof useMessageGroupCountLazyQuery>;
export type MessageGroupCountSuspenseQueryHookResult = ReturnType<typeof useMessageGroupCountSuspenseQuery>;
export type MessageGroupCountQueryResult = Apollo.QueryResult<MessageGroupCountQuery, MessageGroupCountQueryVariables>;
export const MessageGroupCreateOrUpdateDocument = gql`
	mutation messageGroupCreateOrUpdate($input: MessageGroupCreateInput!) {
		createOrUpdateMessageGroup(input: $input) {
			...MessageGroupDetail
		}
	}
	${MessageGroupDetailFragmentDoc}
`;
export type MessageGroupCreateOrUpdateMutationFn = Apollo.MutationFunction<
	MessageGroupCreateOrUpdateMutation,
	MessageGroupCreateOrUpdateMutationVariables
>;

/**
 * __useMessageGroupCreateOrUpdateMutation__
 *
 * To run a mutation, you first call `useMessageGroupCreateOrUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupCreateOrUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageGroupCreateOrUpdateMutation, { data, loading, error }] = useMessageGroupCreateOrUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageGroupCreateOrUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MessageGroupCreateOrUpdateMutation,
		MessageGroupCreateOrUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageGroupCreateOrUpdateMutation, MessageGroupCreateOrUpdateMutationVariables>(
		MessageGroupCreateOrUpdateDocument,
		options,
	);
}
export type MessageGroupCreateOrUpdateMutationHookResult = ReturnType<typeof useMessageGroupCreateOrUpdateMutation>;
export type MessageGroupCreateOrUpdateMutationResult = Apollo.MutationResult<MessageGroupCreateOrUpdateMutation>;
export type MessageGroupCreateOrUpdateMutationOptions = Apollo.BaseMutationOptions<
	MessageGroupCreateOrUpdateMutation,
	MessageGroupCreateOrUpdateMutationVariables
>;
export const MessageGroupCreateDocument = gql`
	mutation messageGroupCreate($input: MessageGroupCreateInput!) {
		createMessageGroup(input: $input) {
			...MessageGroupDetail
		}
	}
	${MessageGroupDetailFragmentDoc}
`;
export type MessageGroupCreateMutationFn = Apollo.MutationFunction<
	MessageGroupCreateMutation,
	MessageGroupCreateMutationVariables
>;

/**
 * __useMessageGroupCreateMutation__
 *
 * To run a mutation, you first call `useMessageGroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageGroupCreateMutation, { data, loading, error }] = useMessageGroupCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageGroupCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<MessageGroupCreateMutation, MessageGroupCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageGroupCreateMutation, MessageGroupCreateMutationVariables>(
		MessageGroupCreateDocument,
		options,
	);
}
export type MessageGroupCreateMutationHookResult = ReturnType<typeof useMessageGroupCreateMutation>;
export type MessageGroupCreateMutationResult = Apollo.MutationResult<MessageGroupCreateMutation>;
export type MessageGroupCreateMutationOptions = Apollo.BaseMutationOptions<
	MessageGroupCreateMutation,
	MessageGroupCreateMutationVariables
>;
export const MessageGroupDeleteDocument = gql`
	mutation messageGroupDelete($id: ID!) {
		deleteMessageGroup(id: $id)
	}
`;
export type MessageGroupDeleteMutationFn = Apollo.MutationFunction<
	MessageGroupDeleteMutation,
	MessageGroupDeleteMutationVariables
>;

/**
 * __useMessageGroupDeleteMutation__
 *
 * To run a mutation, you first call `useMessageGroupDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageGroupDeleteMutation, { data, loading, error }] = useMessageGroupDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageGroupDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<MessageGroupDeleteMutation, MessageGroupDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageGroupDeleteMutation, MessageGroupDeleteMutationVariables>(
		MessageGroupDeleteDocument,
		options,
	);
}
export type MessageGroupDeleteMutationHookResult = ReturnType<typeof useMessageGroupDeleteMutation>;
export type MessageGroupDeleteMutationResult = Apollo.MutationResult<MessageGroupDeleteMutation>;
export type MessageGroupDeleteMutationOptions = Apollo.BaseMutationOptions<
	MessageGroupDeleteMutation,
	MessageGroupDeleteMutationVariables
>;
export const MessageGroupDetailDocument = gql`
	query messageGroupDetail($id: ID!) {
		messageGroup(id: $id) {
			...MessageGroupDetail
		}
	}
	${MessageGroupDetailFragmentDoc}
`;

/**
 * __useMessageGroupDetailQuery__
 *
 * To run a query within a React component, call `useMessageGroupDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageGroupDetailQuery(
	baseOptions: Apollo.QueryHookOptions<MessageGroupDetailQuery, MessageGroupDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupDetailQuery, MessageGroupDetailQueryVariables>(
		MessageGroupDetailDocument,
		options,
	);
}
export function useMessageGroupDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageGroupDetailQuery, MessageGroupDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupDetailQuery, MessageGroupDetailQueryVariables>(
		MessageGroupDetailDocument,
		options,
	);
}
export function useMessageGroupDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageGroupDetailQuery, MessageGroupDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupDetailQuery, MessageGroupDetailQueryVariables>(
		MessageGroupDetailDocument,
		options,
	);
}
export type MessageGroupDetailQueryHookResult = ReturnType<typeof useMessageGroupDetailQuery>;
export type MessageGroupDetailLazyQueryHookResult = ReturnType<typeof useMessageGroupDetailLazyQuery>;
export type MessageGroupDetailSuspenseQueryHookResult = ReturnType<typeof useMessageGroupDetailSuspenseQuery>;
export type MessageGroupDetailQueryResult = Apollo.QueryResult<
	MessageGroupDetailQuery,
	MessageGroupDetailQueryVariables
>;
export const MessageGroupIndexDocument = gql`
	query messageGroupIndex($filters: [MessageGroupFilterInput!], $pagination: Pagination, $order: MessageGroupOrder) {
		messageGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					customName
					isOneOnOne
				}
			}
		}
	}
`;

/**
 * __useMessageGroupIndexQuery__
 *
 * To run a query within a React component, call `useMessageGroupIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageGroupIndexQuery, MessageGroupIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupIndexQuery, MessageGroupIndexQueryVariables>(MessageGroupIndexDocument, options);
}
export function useMessageGroupIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageGroupIndexQuery, MessageGroupIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupIndexQuery, MessageGroupIndexQueryVariables>(
		MessageGroupIndexDocument,
		options,
	);
}
export function useMessageGroupIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageGroupIndexQuery, MessageGroupIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupIndexQuery, MessageGroupIndexQueryVariables>(
		MessageGroupIndexDocument,
		options,
	);
}
export type MessageGroupIndexQueryHookResult = ReturnType<typeof useMessageGroupIndexQuery>;
export type MessageGroupIndexLazyQueryHookResult = ReturnType<typeof useMessageGroupIndexLazyQuery>;
export type MessageGroupIndexSuspenseQueryHookResult = ReturnType<typeof useMessageGroupIndexSuspenseQuery>;
export type MessageGroupIndexQueryResult = Apollo.QueryResult<MessageGroupIndexQuery, MessageGroupIndexQueryVariables>;
export const MessageGroupNameDocument = gql`
	query messageGroupName($id: ID!) {
		messageGroup(id: $id) {
			id
			...MessageGroupName
		}
	}
	${MessageGroupNameFragmentDoc}
`;

/**
 * __useMessageGroupNameQuery__
 *
 * To run a query within a React component, call `useMessageGroupNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageGroupNameQuery(
	baseOptions: Apollo.QueryHookOptions<MessageGroupNameQuery, MessageGroupNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupNameQuery, MessageGroupNameQueryVariables>(MessageGroupNameDocument, options);
}
export function useMessageGroupNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageGroupNameQuery, MessageGroupNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupNameQuery, MessageGroupNameQueryVariables>(MessageGroupNameDocument, options);
}
export function useMessageGroupNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageGroupNameQuery, MessageGroupNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupNameQuery, MessageGroupNameQueryVariables>(
		MessageGroupNameDocument,
		options,
	);
}
export type MessageGroupNameQueryHookResult = ReturnType<typeof useMessageGroupNameQuery>;
export type MessageGroupNameLazyQueryHookResult = ReturnType<typeof useMessageGroupNameLazyQuery>;
export type MessageGroupNameSuspenseQueryHookResult = ReturnType<typeof useMessageGroupNameSuspenseQuery>;
export type MessageGroupNameQueryResult = Apollo.QueryResult<MessageGroupNameQuery, MessageGroupNameQueryVariables>;
export const MessageGroupNamesDocument = gql`
	query messageGroupNames($filters: [MessageGroupFilterInput!], $pagination: Pagination, $order: MessageGroupOrder) {
		messageGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...MessageGroupName
				}
			}
		}
	}
	${MessageGroupNameFragmentDoc}
`;

/**
 * __useMessageGroupNamesQuery__
 *
 * To run a query within a React component, call `useMessageGroupNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageGroupNamesQuery, MessageGroupNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupNamesQuery, MessageGroupNamesQueryVariables>(MessageGroupNamesDocument, options);
}
export function useMessageGroupNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageGroupNamesQuery, MessageGroupNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupNamesQuery, MessageGroupNamesQueryVariables>(
		MessageGroupNamesDocument,
		options,
	);
}
export function useMessageGroupNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageGroupNamesQuery, MessageGroupNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupNamesQuery, MessageGroupNamesQueryVariables>(
		MessageGroupNamesDocument,
		options,
	);
}
export type MessageGroupNamesQueryHookResult = ReturnType<typeof useMessageGroupNamesQuery>;
export type MessageGroupNamesLazyQueryHookResult = ReturnType<typeof useMessageGroupNamesLazyQuery>;
export type MessageGroupNamesSuspenseQueryHookResult = ReturnType<typeof useMessageGroupNamesSuspenseQuery>;
export type MessageGroupNamesQueryResult = Apollo.QueryResult<MessageGroupNamesQuery, MessageGroupNamesQueryVariables>;
export const MessageGroupPaginationDocument = gql`
	query messageGroupPagination($filters: [MessageGroupFilterInput!], $order: MessageGroupOrder) {
		messageGroupConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useMessageGroupPaginationQuery__
 *
 * To run a query within a React component, call `useMessageGroupPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageGroupPaginationQuery, MessageGroupPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupPaginationQuery, MessageGroupPaginationQueryVariables>(
		MessageGroupPaginationDocument,
		options,
	);
}
export function useMessageGroupPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageGroupPaginationQuery, MessageGroupPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupPaginationQuery, MessageGroupPaginationQueryVariables>(
		MessageGroupPaginationDocument,
		options,
	);
}
export function useMessageGroupPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageGroupPaginationQuery, MessageGroupPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupPaginationQuery, MessageGroupPaginationQueryVariables>(
		MessageGroupPaginationDocument,
		options,
	);
}
export type MessageGroupPaginationQueryHookResult = ReturnType<typeof useMessageGroupPaginationQuery>;
export type MessageGroupPaginationLazyQueryHookResult = ReturnType<typeof useMessageGroupPaginationLazyQuery>;
export type MessageGroupPaginationSuspenseQueryHookResult = ReturnType<typeof useMessageGroupPaginationSuspenseQuery>;
export type MessageGroupPaginationQueryResult = Apollo.QueryResult<
	MessageGroupPaginationQuery,
	MessageGroupPaginationQueryVariables
>;
export const MessageGroupUserGroupParticipantUserListDocument = gql`
	query messageGroupUserGroupParticipantUserList($messageGroupID: ID!) {
		userConnection(
			filters: {
				and: [
					{ memberGroups: { messageGroups: { idEQ: $messageGroupID } } }
					{ not: { messageGroups: { idEQ: $messageGroupID } } }
				]
			}
		) {
			edges {
				node {
					...MessageGroupUser
				}
			}
		}
	}
	${MessageGroupUserFragmentDoc}
`;

/**
 * __useMessageGroupUserGroupParticipantUserListQuery__
 *
 * To run a query within a React component, call `useMessageGroupUserGroupParticipantUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupUserGroupParticipantUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupUserGroupParticipantUserListQuery({
 *   variables: {
 *      messageGroupID: // value for 'messageGroupID'
 *   },
 * });
 */
export function useMessageGroupUserGroupParticipantUserListQuery(
	baseOptions: Apollo.QueryHookOptions<
		MessageGroupUserGroupParticipantUserListQuery,
		MessageGroupUserGroupParticipantUserListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		MessageGroupUserGroupParticipantUserListQuery,
		MessageGroupUserGroupParticipantUserListQueryVariables
	>(MessageGroupUserGroupParticipantUserListDocument, options);
}
export function useMessageGroupUserGroupParticipantUserListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageGroupUserGroupParticipantUserListQuery,
		MessageGroupUserGroupParticipantUserListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MessageGroupUserGroupParticipantUserListQuery,
		MessageGroupUserGroupParticipantUserListQueryVariables
	>(MessageGroupUserGroupParticipantUserListDocument, options);
}
export function useMessageGroupUserGroupParticipantUserListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageGroupUserGroupParticipantUserListQuery,
		MessageGroupUserGroupParticipantUserListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		MessageGroupUserGroupParticipantUserListQuery,
		MessageGroupUserGroupParticipantUserListQueryVariables
	>(MessageGroupUserGroupParticipantUserListDocument, options);
}
export type MessageGroupUserGroupParticipantUserListQueryHookResult = ReturnType<
	typeof useMessageGroupUserGroupParticipantUserListQuery
>;
export type MessageGroupUserGroupParticipantUserListLazyQueryHookResult = ReturnType<
	typeof useMessageGroupUserGroupParticipantUserListLazyQuery
>;
export type MessageGroupUserGroupParticipantUserListSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupUserGroupParticipantUserListSuspenseQuery
>;
export type MessageGroupUserGroupParticipantUserListQueryResult = Apollo.QueryResult<
	MessageGroupUserGroupParticipantUserListQuery,
	MessageGroupUserGroupParticipantUserListQueryVariables
>;
export const UserListForMessagesDocument = gql`
	query userListForMessages($filters: [UserFilterInput!], $pagination: Pagination, $order: UserOrder) {
		userConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					...UserForMessages
				}
			}
		}
	}
	${UserForMessagesFragmentDoc}
`;

/**
 * __useUserListForMessagesQuery__
 *
 * To run a query within a React component, call `useUserListForMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListForMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListForMessagesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserListForMessagesQuery(
	baseOptions?: Apollo.QueryHookOptions<UserListForMessagesQuery, UserListForMessagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserListForMessagesQuery, UserListForMessagesQueryVariables>(
		UserListForMessagesDocument,
		options,
	);
}
export function useUserListForMessagesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserListForMessagesQuery, UserListForMessagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserListForMessagesQuery, UserListForMessagesQueryVariables>(
		UserListForMessagesDocument,
		options,
	);
}
export function useUserListForMessagesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserListForMessagesQuery, UserListForMessagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserListForMessagesQuery, UserListForMessagesQueryVariables>(
		UserListForMessagesDocument,
		options,
	);
}
export type UserListForMessagesQueryHookResult = ReturnType<typeof useUserListForMessagesQuery>;
export type UserListForMessagesLazyQueryHookResult = ReturnType<typeof useUserListForMessagesLazyQuery>;
export type UserListForMessagesSuspenseQueryHookResult = ReturnType<typeof useUserListForMessagesSuspenseQuery>;
export type UserListForMessagesQueryResult = Apollo.QueryResult<
	UserListForMessagesQuery,
	UserListForMessagesQueryVariables
>;
export const UserAndUserGroupListForMessagesDocument = gql`
	query userAndUserGroupListForMessages($userFilters: [UserFilterInput!], $userGroupFilters: [UserGroupFilterInput!]) {
		userConnection(filters: $userFilters) {
			edges {
				node {
					...UserForMessages
				}
			}
		}
		userGroupConnection(filters: $userGroupFilters) {
			edges {
				node {
					id
					...UserGroupNameAndColor
					members {
						id
						isCurrent
					}
				}
			}
		}
	}
	${UserForMessagesFragmentDoc}
	${UserGroupNameAndColorFragmentDoc}
`;

/**
 * __useUserAndUserGroupListForMessagesQuery__
 *
 * To run a query within a React component, call `useUserAndUserGroupListForMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAndUserGroupListForMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAndUserGroupListForMessagesQuery({
 *   variables: {
 *      userFilters: // value for 'userFilters'
 *      userGroupFilters: // value for 'userGroupFilters'
 *   },
 * });
 */
export function useUserAndUserGroupListForMessagesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UserAndUserGroupListForMessagesQuery,
		UserAndUserGroupListForMessagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserAndUserGroupListForMessagesQuery, UserAndUserGroupListForMessagesQueryVariables>(
		UserAndUserGroupListForMessagesDocument,
		options,
	);
}
export function useUserAndUserGroupListForMessagesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserAndUserGroupListForMessagesQuery,
		UserAndUserGroupListForMessagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserAndUserGroupListForMessagesQuery, UserAndUserGroupListForMessagesQueryVariables>(
		UserAndUserGroupListForMessagesDocument,
		options,
	);
}
export function useUserAndUserGroupListForMessagesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		UserAndUserGroupListForMessagesQuery,
		UserAndUserGroupListForMessagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserAndUserGroupListForMessagesQuery, UserAndUserGroupListForMessagesQueryVariables>(
		UserAndUserGroupListForMessagesDocument,
		options,
	);
}
export type UserAndUserGroupListForMessagesQueryHookResult = ReturnType<typeof useUserAndUserGroupListForMessagesQuery>;
export type UserAndUserGroupListForMessagesLazyQueryHookResult = ReturnType<
	typeof useUserAndUserGroupListForMessagesLazyQuery
>;
export type UserAndUserGroupListForMessagesSuspenseQueryHookResult = ReturnType<
	typeof useUserAndUserGroupListForMessagesSuspenseQuery
>;
export type UserAndUserGroupListForMessagesQueryResult = Apollo.QueryResult<
	UserAndUserGroupListForMessagesQuery,
	UserAndUserGroupListForMessagesQueryVariables
>;
export const StudentGuardianAndTeachersForMessagesDocument = gql`
	query studentGuardianAndTeachersForMessages($studentIDs: [ID!]!, $date: Date!) {
		guardianConnection(filters: { relationships: { studentIDIn: $studentIDs } }) {
			edges {
				node {
					id
				}
			}
		}
		employeeConnection(
			filters: {
				or: [
					{
						teacherCourseSectionEnrollments: {
							courseSection: {
								studentCourseSectionEnrollments: { studentIDIn: $studentIDs }
								academicTerm: { startDateLTE: $date, endDateGTE: $date }
							}
						}
					}
					{
						teacherHomeRoomSectionEnrollments: {
							homeRoomSection: {
								studentHomeRoomSectionEnrollments: { studentIDIn: $studentIDs }
								academicTerm: { startDateLTE: $date, endDateGTE: $date }
							}
						}
					}
				]
			}
		) {
			edges {
				node {
					id
				}
			}
		}
	}
`;

/**
 * __useStudentGuardianAndTeachersForMessagesQuery__
 *
 * To run a query within a React component, call `useStudentGuardianAndTeachersForMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentGuardianAndTeachersForMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentGuardianAndTeachersForMessagesQuery({
 *   variables: {
 *      studentIDs: // value for 'studentIDs'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useStudentGuardianAndTeachersForMessagesQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentGuardianAndTeachersForMessagesQuery,
		StudentGuardianAndTeachersForMessagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentGuardianAndTeachersForMessagesQuery,
		StudentGuardianAndTeachersForMessagesQueryVariables
	>(StudentGuardianAndTeachersForMessagesDocument, options);
}
export function useStudentGuardianAndTeachersForMessagesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentGuardianAndTeachersForMessagesQuery,
		StudentGuardianAndTeachersForMessagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentGuardianAndTeachersForMessagesQuery,
		StudentGuardianAndTeachersForMessagesQueryVariables
	>(StudentGuardianAndTeachersForMessagesDocument, options);
}
export function useStudentGuardianAndTeachersForMessagesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentGuardianAndTeachersForMessagesQuery,
		StudentGuardianAndTeachersForMessagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentGuardianAndTeachersForMessagesQuery,
		StudentGuardianAndTeachersForMessagesQueryVariables
	>(StudentGuardianAndTeachersForMessagesDocument, options);
}
export type StudentGuardianAndTeachersForMessagesQueryHookResult = ReturnType<
	typeof useStudentGuardianAndTeachersForMessagesQuery
>;
export type StudentGuardianAndTeachersForMessagesLazyQueryHookResult = ReturnType<
	typeof useStudentGuardianAndTeachersForMessagesLazyQuery
>;
export type StudentGuardianAndTeachersForMessagesSuspenseQueryHookResult = ReturnType<
	typeof useStudentGuardianAndTeachersForMessagesSuspenseQuery
>;
export type StudentGuardianAndTeachersForMessagesQueryResult = Apollo.QueryResult<
	StudentGuardianAndTeachersForMessagesQuery,
	StudentGuardianAndTeachersForMessagesQueryVariables
>;
export const MessageGroupSelectDocument = gql`
	query messageGroupSelect($filters: [MessageGroupFilterInput!], $order: MessageGroupOrder) {
		messageGroupConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...MessageGroupName
				}
			}
		}
	}
	${MessageGroupNameFragmentDoc}
`;

/**
 * __useMessageGroupSelectQuery__
 *
 * To run a query within a React component, call `useMessageGroupSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageGroupSelectQuery, MessageGroupSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupSelectQuery, MessageGroupSelectQueryVariables>(
		MessageGroupSelectDocument,
		options,
	);
}
export function useMessageGroupSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageGroupSelectQuery, MessageGroupSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupSelectQuery, MessageGroupSelectQueryVariables>(
		MessageGroupSelectDocument,
		options,
	);
}
export function useMessageGroupSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageGroupSelectQuery, MessageGroupSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupSelectQuery, MessageGroupSelectQueryVariables>(
		MessageGroupSelectDocument,
		options,
	);
}
export type MessageGroupSelectQueryHookResult = ReturnType<typeof useMessageGroupSelectQuery>;
export type MessageGroupSelectLazyQueryHookResult = ReturnType<typeof useMessageGroupSelectLazyQuery>;
export type MessageGroupSelectSuspenseQueryHookResult = ReturnType<typeof useMessageGroupSelectSuspenseQuery>;
export type MessageGroupSelectQueryResult = Apollo.QueryResult<
	MessageGroupSelectQuery,
	MessageGroupSelectQueryVariables
>;
export const MessageGroupUpdateDocument = gql`
	mutation messageGroupUpdate($id: ID!, $input: MessageGroupUpdateInput!) {
		updateMessageGroup(id: $id, input: $input) {
			...MessageGroupDetail
		}
	}
	${MessageGroupDetailFragmentDoc}
`;
export type MessageGroupUpdateMutationFn = Apollo.MutationFunction<
	MessageGroupUpdateMutation,
	MessageGroupUpdateMutationVariables
>;

/**
 * __useMessageGroupUpdateMutation__
 *
 * To run a mutation, you first call `useMessageGroupUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageGroupUpdateMutation, { data, loading, error }] = useMessageGroupUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageGroupUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<MessageGroupUpdateMutation, MessageGroupUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageGroupUpdateMutation, MessageGroupUpdateMutationVariables>(
		MessageGroupUpdateDocument,
		options,
	);
}
export type MessageGroupUpdateMutationHookResult = ReturnType<typeof useMessageGroupUpdateMutation>;
export type MessageGroupUpdateMutationResult = Apollo.MutationResult<MessageGroupUpdateMutation>;
export type MessageGroupUpdateMutationOptions = Apollo.BaseMutationOptions<
	MessageGroupUpdateMutation,
	MessageGroupUpdateMutationVariables
>;
export const MessageGroupArchivePointCountDocument = gql`
	query messageGroupArchivePointCount(
		$filters: [MessageGroupArchivePointFilterInput!]
		$pagination: Pagination
		$order: MessageGroupArchivePointOrder
	) {
		messageGroupArchivePointConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useMessageGroupArchivePointCountQuery__
 *
 * To run a query within a React component, call `useMessageGroupArchivePointCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupArchivePointCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupArchivePointCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MessageGroupArchivePointCountQuery,
		MessageGroupArchivePointCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupArchivePointCountQuery, MessageGroupArchivePointCountQueryVariables>(
		MessageGroupArchivePointCountDocument,
		options,
	);
}
export function useMessageGroupArchivePointCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageGroupArchivePointCountQuery,
		MessageGroupArchivePointCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupArchivePointCountQuery, MessageGroupArchivePointCountQueryVariables>(
		MessageGroupArchivePointCountDocument,
		options,
	);
}
export function useMessageGroupArchivePointCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageGroupArchivePointCountQuery,
		MessageGroupArchivePointCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupArchivePointCountQuery, MessageGroupArchivePointCountQueryVariables>(
		MessageGroupArchivePointCountDocument,
		options,
	);
}
export type MessageGroupArchivePointCountQueryHookResult = ReturnType<typeof useMessageGroupArchivePointCountQuery>;
export type MessageGroupArchivePointCountLazyQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointCountLazyQuery
>;
export type MessageGroupArchivePointCountSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointCountSuspenseQuery
>;
export type MessageGroupArchivePointCountQueryResult = Apollo.QueryResult<
	MessageGroupArchivePointCountQuery,
	MessageGroupArchivePointCountQueryVariables
>;
export const MessageGroupArchivePointCreateDocument = gql`
	mutation messageGroupArchivePointCreate($input: MessageGroupArchivePointCreateInput!) {
		createMessageGroupArchivePoint(input: $input) {
			...MessageGroupArchivePointDetail
		}
	}
	${MessageGroupArchivePointDetailFragmentDoc}
`;
export type MessageGroupArchivePointCreateMutationFn = Apollo.MutationFunction<
	MessageGroupArchivePointCreateMutation,
	MessageGroupArchivePointCreateMutationVariables
>;

/**
 * __useMessageGroupArchivePointCreateMutation__
 *
 * To run a mutation, you first call `useMessageGroupArchivePointCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageGroupArchivePointCreateMutation, { data, loading, error }] = useMessageGroupArchivePointCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageGroupArchivePointCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MessageGroupArchivePointCreateMutation,
		MessageGroupArchivePointCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageGroupArchivePointCreateMutation, MessageGroupArchivePointCreateMutationVariables>(
		MessageGroupArchivePointCreateDocument,
		options,
	);
}
export type MessageGroupArchivePointCreateMutationHookResult = ReturnType<
	typeof useMessageGroupArchivePointCreateMutation
>;
export type MessageGroupArchivePointCreateMutationResult =
	Apollo.MutationResult<MessageGroupArchivePointCreateMutation>;
export type MessageGroupArchivePointCreateMutationOptions = Apollo.BaseMutationOptions<
	MessageGroupArchivePointCreateMutation,
	MessageGroupArchivePointCreateMutationVariables
>;
export const MessageGroupArchivePointDeleteDocument = gql`
	mutation messageGroupArchivePointDelete($id: ID!) {
		deleteMessageGroupArchivePoint(id: $id)
	}
`;
export type MessageGroupArchivePointDeleteMutationFn = Apollo.MutationFunction<
	MessageGroupArchivePointDeleteMutation,
	MessageGroupArchivePointDeleteMutationVariables
>;

/**
 * __useMessageGroupArchivePointDeleteMutation__
 *
 * To run a mutation, you first call `useMessageGroupArchivePointDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageGroupArchivePointDeleteMutation, { data, loading, error }] = useMessageGroupArchivePointDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageGroupArchivePointDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MessageGroupArchivePointDeleteMutation,
		MessageGroupArchivePointDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageGroupArchivePointDeleteMutation, MessageGroupArchivePointDeleteMutationVariables>(
		MessageGroupArchivePointDeleteDocument,
		options,
	);
}
export type MessageGroupArchivePointDeleteMutationHookResult = ReturnType<
	typeof useMessageGroupArchivePointDeleteMutation
>;
export type MessageGroupArchivePointDeleteMutationResult =
	Apollo.MutationResult<MessageGroupArchivePointDeleteMutation>;
export type MessageGroupArchivePointDeleteMutationOptions = Apollo.BaseMutationOptions<
	MessageGroupArchivePointDeleteMutation,
	MessageGroupArchivePointDeleteMutationVariables
>;
export const MessageGroupArchivePointDetailDocument = gql`
	query messageGroupArchivePointDetail($id: ID!) {
		messageGroupArchivePoint(id: $id) {
			...MessageGroupArchivePointDetail
		}
	}
	${MessageGroupArchivePointDetailFragmentDoc}
`;

/**
 * __useMessageGroupArchivePointDetailQuery__
 *
 * To run a query within a React component, call `useMessageGroupArchivePointDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupArchivePointDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageGroupArchivePointDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		MessageGroupArchivePointDetailQuery,
		MessageGroupArchivePointDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupArchivePointDetailQuery, MessageGroupArchivePointDetailQueryVariables>(
		MessageGroupArchivePointDetailDocument,
		options,
	);
}
export function useMessageGroupArchivePointDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageGroupArchivePointDetailQuery,
		MessageGroupArchivePointDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupArchivePointDetailQuery, MessageGroupArchivePointDetailQueryVariables>(
		MessageGroupArchivePointDetailDocument,
		options,
	);
}
export function useMessageGroupArchivePointDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageGroupArchivePointDetailQuery,
		MessageGroupArchivePointDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupArchivePointDetailQuery, MessageGroupArchivePointDetailQueryVariables>(
		MessageGroupArchivePointDetailDocument,
		options,
	);
}
export type MessageGroupArchivePointDetailQueryHookResult = ReturnType<typeof useMessageGroupArchivePointDetailQuery>;
export type MessageGroupArchivePointDetailLazyQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointDetailLazyQuery
>;
export type MessageGroupArchivePointDetailSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointDetailSuspenseQuery
>;
export type MessageGroupArchivePointDetailQueryResult = Apollo.QueryResult<
	MessageGroupArchivePointDetailQuery,
	MessageGroupArchivePointDetailQueryVariables
>;
export const MessageGroupArchivePointIndexDocument = gql`
	query messageGroupArchivePointIndex(
		$filters: [MessageGroupArchivePointFilterInput!]
		$pagination: Pagination
		$order: MessageGroupArchivePointOrder
	) {
		messageGroupArchivePointConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
				}
			}
		}
	}
`;

/**
 * __useMessageGroupArchivePointIndexQuery__
 *
 * To run a query within a React component, call `useMessageGroupArchivePointIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupArchivePointIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupArchivePointIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MessageGroupArchivePointIndexQuery,
		MessageGroupArchivePointIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupArchivePointIndexQuery, MessageGroupArchivePointIndexQueryVariables>(
		MessageGroupArchivePointIndexDocument,
		options,
	);
}
export function useMessageGroupArchivePointIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageGroupArchivePointIndexQuery,
		MessageGroupArchivePointIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupArchivePointIndexQuery, MessageGroupArchivePointIndexQueryVariables>(
		MessageGroupArchivePointIndexDocument,
		options,
	);
}
export function useMessageGroupArchivePointIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageGroupArchivePointIndexQuery,
		MessageGroupArchivePointIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupArchivePointIndexQuery, MessageGroupArchivePointIndexQueryVariables>(
		MessageGroupArchivePointIndexDocument,
		options,
	);
}
export type MessageGroupArchivePointIndexQueryHookResult = ReturnType<typeof useMessageGroupArchivePointIndexQuery>;
export type MessageGroupArchivePointIndexLazyQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointIndexLazyQuery
>;
export type MessageGroupArchivePointIndexSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointIndexSuspenseQuery
>;
export type MessageGroupArchivePointIndexQueryResult = Apollo.QueryResult<
	MessageGroupArchivePointIndexQuery,
	MessageGroupArchivePointIndexQueryVariables
>;
export const MessageGroupArchivePointListInMessageGroupDocument = gql`
	query messageGroupArchivePointListInMessageGroup(
		$filters: [MessageGroupArchivePointFilterInput!]
		$pagination: Pagination
		$order: MessageGroupArchivePointOrder
	) {
		messageGroupArchivePointConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					author {
						id
						...UserNameAndImage
					}
				}
			}
		}
	}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __useMessageGroupArchivePointListInMessageGroupQuery__
 *
 * To run a query within a React component, call `useMessageGroupArchivePointListInMessageGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointListInMessageGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupArchivePointListInMessageGroupQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupArchivePointListInMessageGroupQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MessageGroupArchivePointListInMessageGroupQuery,
		MessageGroupArchivePointListInMessageGroupQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		MessageGroupArchivePointListInMessageGroupQuery,
		MessageGroupArchivePointListInMessageGroupQueryVariables
	>(MessageGroupArchivePointListInMessageGroupDocument, options);
}
export function useMessageGroupArchivePointListInMessageGroupLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageGroupArchivePointListInMessageGroupQuery,
		MessageGroupArchivePointListInMessageGroupQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MessageGroupArchivePointListInMessageGroupQuery,
		MessageGroupArchivePointListInMessageGroupQueryVariables
	>(MessageGroupArchivePointListInMessageGroupDocument, options);
}
export function useMessageGroupArchivePointListInMessageGroupSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageGroupArchivePointListInMessageGroupQuery,
		MessageGroupArchivePointListInMessageGroupQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		MessageGroupArchivePointListInMessageGroupQuery,
		MessageGroupArchivePointListInMessageGroupQueryVariables
	>(MessageGroupArchivePointListInMessageGroupDocument, options);
}
export type MessageGroupArchivePointListInMessageGroupQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointListInMessageGroupQuery
>;
export type MessageGroupArchivePointListInMessageGroupLazyQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointListInMessageGroupLazyQuery
>;
export type MessageGroupArchivePointListInMessageGroupSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointListInMessageGroupSuspenseQuery
>;
export type MessageGroupArchivePointListInMessageGroupQueryResult = Apollo.QueryResult<
	MessageGroupArchivePointListInMessageGroupQuery,
	MessageGroupArchivePointListInMessageGroupQueryVariables
>;
export const MessageGroupArchivePointNameDocument = gql`
	query messageGroupArchivePointName($id: ID!) {
		messageGroupArchivePoint(id: $id) {
			id
			...MessageGroupArchivePointName
		}
	}
	${MessageGroupArchivePointNameFragmentDoc}
`;

/**
 * __useMessageGroupArchivePointNameQuery__
 *
 * To run a query within a React component, call `useMessageGroupArchivePointNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupArchivePointNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageGroupArchivePointNameQuery(
	baseOptions: Apollo.QueryHookOptions<MessageGroupArchivePointNameQuery, MessageGroupArchivePointNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupArchivePointNameQuery, MessageGroupArchivePointNameQueryVariables>(
		MessageGroupArchivePointNameDocument,
		options,
	);
}
export function useMessageGroupArchivePointNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageGroupArchivePointNameQuery,
		MessageGroupArchivePointNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupArchivePointNameQuery, MessageGroupArchivePointNameQueryVariables>(
		MessageGroupArchivePointNameDocument,
		options,
	);
}
export function useMessageGroupArchivePointNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageGroupArchivePointNameQuery,
		MessageGroupArchivePointNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupArchivePointNameQuery, MessageGroupArchivePointNameQueryVariables>(
		MessageGroupArchivePointNameDocument,
		options,
	);
}
export type MessageGroupArchivePointNameQueryHookResult = ReturnType<typeof useMessageGroupArchivePointNameQuery>;
export type MessageGroupArchivePointNameLazyQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointNameLazyQuery
>;
export type MessageGroupArchivePointNameSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointNameSuspenseQuery
>;
export type MessageGroupArchivePointNameQueryResult = Apollo.QueryResult<
	MessageGroupArchivePointNameQuery,
	MessageGroupArchivePointNameQueryVariables
>;
export const MessageGroupArchivePointNamesDocument = gql`
	query messageGroupArchivePointNames(
		$filters: [MessageGroupArchivePointFilterInput!]
		$pagination: Pagination
		$order: MessageGroupArchivePointOrder
	) {
		messageGroupArchivePointConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...MessageGroupArchivePointName
				}
			}
		}
	}
	${MessageGroupArchivePointNameFragmentDoc}
`;

/**
 * __useMessageGroupArchivePointNamesQuery__
 *
 * To run a query within a React component, call `useMessageGroupArchivePointNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupArchivePointNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupArchivePointNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MessageGroupArchivePointNamesQuery,
		MessageGroupArchivePointNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupArchivePointNamesQuery, MessageGroupArchivePointNamesQueryVariables>(
		MessageGroupArchivePointNamesDocument,
		options,
	);
}
export function useMessageGroupArchivePointNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageGroupArchivePointNamesQuery,
		MessageGroupArchivePointNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupArchivePointNamesQuery, MessageGroupArchivePointNamesQueryVariables>(
		MessageGroupArchivePointNamesDocument,
		options,
	);
}
export function useMessageGroupArchivePointNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageGroupArchivePointNamesQuery,
		MessageGroupArchivePointNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupArchivePointNamesQuery, MessageGroupArchivePointNamesQueryVariables>(
		MessageGroupArchivePointNamesDocument,
		options,
	);
}
export type MessageGroupArchivePointNamesQueryHookResult = ReturnType<typeof useMessageGroupArchivePointNamesQuery>;
export type MessageGroupArchivePointNamesLazyQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointNamesLazyQuery
>;
export type MessageGroupArchivePointNamesSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointNamesSuspenseQuery
>;
export type MessageGroupArchivePointNamesQueryResult = Apollo.QueryResult<
	MessageGroupArchivePointNamesQuery,
	MessageGroupArchivePointNamesQueryVariables
>;
export const MessageGroupArchivePointPaginationDocument = gql`
	query messageGroupArchivePointPagination(
		$filters: [MessageGroupArchivePointFilterInput!]
		$order: MessageGroupArchivePointOrder
	) {
		messageGroupArchivePointConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useMessageGroupArchivePointPaginationQuery__
 *
 * To run a query within a React component, call `useMessageGroupArchivePointPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupArchivePointPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupArchivePointPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MessageGroupArchivePointPaginationQuery,
		MessageGroupArchivePointPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupArchivePointPaginationQuery, MessageGroupArchivePointPaginationQueryVariables>(
		MessageGroupArchivePointPaginationDocument,
		options,
	);
}
export function useMessageGroupArchivePointPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageGroupArchivePointPaginationQuery,
		MessageGroupArchivePointPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupArchivePointPaginationQuery, MessageGroupArchivePointPaginationQueryVariables>(
		MessageGroupArchivePointPaginationDocument,
		options,
	);
}
export function useMessageGroupArchivePointPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageGroupArchivePointPaginationQuery,
		MessageGroupArchivePointPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		MessageGroupArchivePointPaginationQuery,
		MessageGroupArchivePointPaginationQueryVariables
	>(MessageGroupArchivePointPaginationDocument, options);
}
export type MessageGroupArchivePointPaginationQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointPaginationQuery
>;
export type MessageGroupArchivePointPaginationLazyQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointPaginationLazyQuery
>;
export type MessageGroupArchivePointPaginationSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointPaginationSuspenseQuery
>;
export type MessageGroupArchivePointPaginationQueryResult = Apollo.QueryResult<
	MessageGroupArchivePointPaginationQuery,
	MessageGroupArchivePointPaginationQueryVariables
>;
export const MessageGroupArchivePointSelectDocument = gql`
	query messageGroupArchivePointSelect(
		$filters: [MessageGroupArchivePointFilterInput!]
		$order: MessageGroupArchivePointOrder
	) {
		messageGroupArchivePointConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...MessageGroupArchivePointName
				}
			}
		}
	}
	${MessageGroupArchivePointNameFragmentDoc}
`;

/**
 * __useMessageGroupArchivePointSelectQuery__
 *
 * To run a query within a React component, call `useMessageGroupArchivePointSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupArchivePointSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupArchivePointSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MessageGroupArchivePointSelectQuery,
		MessageGroupArchivePointSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupArchivePointSelectQuery, MessageGroupArchivePointSelectQueryVariables>(
		MessageGroupArchivePointSelectDocument,
		options,
	);
}
export function useMessageGroupArchivePointSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageGroupArchivePointSelectQuery,
		MessageGroupArchivePointSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupArchivePointSelectQuery, MessageGroupArchivePointSelectQueryVariables>(
		MessageGroupArchivePointSelectDocument,
		options,
	);
}
export function useMessageGroupArchivePointSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageGroupArchivePointSelectQuery,
		MessageGroupArchivePointSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupArchivePointSelectQuery, MessageGroupArchivePointSelectQueryVariables>(
		MessageGroupArchivePointSelectDocument,
		options,
	);
}
export type MessageGroupArchivePointSelectQueryHookResult = ReturnType<typeof useMessageGroupArchivePointSelectQuery>;
export type MessageGroupArchivePointSelectLazyQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointSelectLazyQuery
>;
export type MessageGroupArchivePointSelectSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointSelectSuspenseQuery
>;
export type MessageGroupArchivePointSelectQueryResult = Apollo.QueryResult<
	MessageGroupArchivePointSelectQuery,
	MessageGroupArchivePointSelectQueryVariables
>;
export const MessageGroupArchivePointUpdateDocument = gql`
	mutation messageGroupArchivePointUpdate($id: ID!, $input: MessageGroupArchivePointUpdateInput!) {
		updateMessageGroupArchivePoint(id: $id, input: $input) {
			...MessageGroupArchivePointDetail
		}
	}
	${MessageGroupArchivePointDetailFragmentDoc}
`;
export type MessageGroupArchivePointUpdateMutationFn = Apollo.MutationFunction<
	MessageGroupArchivePointUpdateMutation,
	MessageGroupArchivePointUpdateMutationVariables
>;

/**
 * __useMessageGroupArchivePointUpdateMutation__
 *
 * To run a mutation, you first call `useMessageGroupArchivePointUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageGroupArchivePointUpdateMutation, { data, loading, error }] = useMessageGroupArchivePointUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageGroupArchivePointUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MessageGroupArchivePointUpdateMutation,
		MessageGroupArchivePointUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageGroupArchivePointUpdateMutation, MessageGroupArchivePointUpdateMutationVariables>(
		MessageGroupArchivePointUpdateDocument,
		options,
	);
}
export type MessageGroupArchivePointUpdateMutationHookResult = ReturnType<
	typeof useMessageGroupArchivePointUpdateMutation
>;
export type MessageGroupArchivePointUpdateMutationResult =
	Apollo.MutationResult<MessageGroupArchivePointUpdateMutation>;
export type MessageGroupArchivePointUpdateMutationOptions = Apollo.BaseMutationOptions<
	MessageGroupArchivePointUpdateMutation,
	MessageGroupArchivePointUpdateMutationVariables
>;
export const MessageTopicCountDocument = gql`
	query messageTopicCount($filters: [MessageTopicFilterInput!], $pagination: Pagination, $order: MessageTopicOrder) {
		messageTopicConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useMessageTopicCountQuery__
 *
 * To run a query within a React component, call `useMessageTopicCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTopicCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageTopicCountQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageTopicCountQuery, MessageTopicCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageTopicCountQuery, MessageTopicCountQueryVariables>(MessageTopicCountDocument, options);
}
export function useMessageTopicCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageTopicCountQuery, MessageTopicCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageTopicCountQuery, MessageTopicCountQueryVariables>(
		MessageTopicCountDocument,
		options,
	);
}
export function useMessageTopicCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageTopicCountQuery, MessageTopicCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageTopicCountQuery, MessageTopicCountQueryVariables>(
		MessageTopicCountDocument,
		options,
	);
}
export type MessageTopicCountQueryHookResult = ReturnType<typeof useMessageTopicCountQuery>;
export type MessageTopicCountLazyQueryHookResult = ReturnType<typeof useMessageTopicCountLazyQuery>;
export type MessageTopicCountSuspenseQueryHookResult = ReturnType<typeof useMessageTopicCountSuspenseQuery>;
export type MessageTopicCountQueryResult = Apollo.QueryResult<MessageTopicCountQuery, MessageTopicCountQueryVariables>;
export const MessageTopicCreateDocument = gql`
	mutation messageTopicCreate($input: MessageTopicCreateInput!) {
		createMessageTopic(input: $input) {
			...MessageTopicDetail
		}
	}
	${MessageTopicDetailFragmentDoc}
`;
export type MessageTopicCreateMutationFn = Apollo.MutationFunction<
	MessageTopicCreateMutation,
	MessageTopicCreateMutationVariables
>;

/**
 * __useMessageTopicCreateMutation__
 *
 * To run a mutation, you first call `useMessageTopicCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageTopicCreateMutation, { data, loading, error }] = useMessageTopicCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageTopicCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<MessageTopicCreateMutation, MessageTopicCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageTopicCreateMutation, MessageTopicCreateMutationVariables>(
		MessageTopicCreateDocument,
		options,
	);
}
export type MessageTopicCreateMutationHookResult = ReturnType<typeof useMessageTopicCreateMutation>;
export type MessageTopicCreateMutationResult = Apollo.MutationResult<MessageTopicCreateMutation>;
export type MessageTopicCreateMutationOptions = Apollo.BaseMutationOptions<
	MessageTopicCreateMutation,
	MessageTopicCreateMutationVariables
>;
export const MessageTopicDeleteDocument = gql`
	mutation messageTopicDelete($id: ID!) {
		deleteMessageTopic(id: $id)
	}
`;
export type MessageTopicDeleteMutationFn = Apollo.MutationFunction<
	MessageTopicDeleteMutation,
	MessageTopicDeleteMutationVariables
>;

/**
 * __useMessageTopicDeleteMutation__
 *
 * To run a mutation, you first call `useMessageTopicDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageTopicDeleteMutation, { data, loading, error }] = useMessageTopicDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageTopicDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<MessageTopicDeleteMutation, MessageTopicDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageTopicDeleteMutation, MessageTopicDeleteMutationVariables>(
		MessageTopicDeleteDocument,
		options,
	);
}
export type MessageTopicDeleteMutationHookResult = ReturnType<typeof useMessageTopicDeleteMutation>;
export type MessageTopicDeleteMutationResult = Apollo.MutationResult<MessageTopicDeleteMutation>;
export type MessageTopicDeleteMutationOptions = Apollo.BaseMutationOptions<
	MessageTopicDeleteMutation,
	MessageTopicDeleteMutationVariables
>;
export const MessageTopicDetailDocument = gql`
	query messageTopicDetail($id: ID!) {
		messageTopic(id: $id) {
			...MessageTopicDetail
		}
	}
	${MessageTopicDetailFragmentDoc}
`;

/**
 * __useMessageTopicDetailQuery__
 *
 * To run a query within a React component, call `useMessageTopicDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTopicDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageTopicDetailQuery(
	baseOptions: Apollo.QueryHookOptions<MessageTopicDetailQuery, MessageTopicDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageTopicDetailQuery, MessageTopicDetailQueryVariables>(
		MessageTopicDetailDocument,
		options,
	);
}
export function useMessageTopicDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageTopicDetailQuery, MessageTopicDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageTopicDetailQuery, MessageTopicDetailQueryVariables>(
		MessageTopicDetailDocument,
		options,
	);
}
export function useMessageTopicDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageTopicDetailQuery, MessageTopicDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageTopicDetailQuery, MessageTopicDetailQueryVariables>(
		MessageTopicDetailDocument,
		options,
	);
}
export type MessageTopicDetailQueryHookResult = ReturnType<typeof useMessageTopicDetailQuery>;
export type MessageTopicDetailLazyQueryHookResult = ReturnType<typeof useMessageTopicDetailLazyQuery>;
export type MessageTopicDetailSuspenseQueryHookResult = ReturnType<typeof useMessageTopicDetailSuspenseQuery>;
export type MessageTopicDetailQueryResult = Apollo.QueryResult<
	MessageTopicDetailQuery,
	MessageTopicDetailQueryVariables
>;
export const MessageTopicIndexDocument = gql`
	query messageTopicIndex($filters: [MessageTopicFilterInput!], $pagination: Pagination, $order: MessageTopicOrder) {
		messageTopicConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
				}
			}
		}
	}
`;

/**
 * __useMessageTopicIndexQuery__
 *
 * To run a query within a React component, call `useMessageTopicIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTopicIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageTopicIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageTopicIndexQuery, MessageTopicIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageTopicIndexQuery, MessageTopicIndexQueryVariables>(MessageTopicIndexDocument, options);
}
export function useMessageTopicIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageTopicIndexQuery, MessageTopicIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageTopicIndexQuery, MessageTopicIndexQueryVariables>(
		MessageTopicIndexDocument,
		options,
	);
}
export function useMessageTopicIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageTopicIndexQuery, MessageTopicIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageTopicIndexQuery, MessageTopicIndexQueryVariables>(
		MessageTopicIndexDocument,
		options,
	);
}
export type MessageTopicIndexQueryHookResult = ReturnType<typeof useMessageTopicIndexQuery>;
export type MessageTopicIndexLazyQueryHookResult = ReturnType<typeof useMessageTopicIndexLazyQuery>;
export type MessageTopicIndexSuspenseQueryHookResult = ReturnType<typeof useMessageTopicIndexSuspenseQuery>;
export type MessageTopicIndexQueryResult = Apollo.QueryResult<MessageTopicIndexQuery, MessageTopicIndexQueryVariables>;
export const MessageTopicNameDocument = gql`
	query messageTopicName($id: ID!) {
		messageTopic(id: $id) {
			id
			...MessageTopicName
		}
	}
	${MessageTopicNameFragmentDoc}
`;

/**
 * __useMessageTopicNameQuery__
 *
 * To run a query within a React component, call `useMessageTopicNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTopicNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageTopicNameQuery(
	baseOptions: Apollo.QueryHookOptions<MessageTopicNameQuery, MessageTopicNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageTopicNameQuery, MessageTopicNameQueryVariables>(MessageTopicNameDocument, options);
}
export function useMessageTopicNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageTopicNameQuery, MessageTopicNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageTopicNameQuery, MessageTopicNameQueryVariables>(MessageTopicNameDocument, options);
}
export function useMessageTopicNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageTopicNameQuery, MessageTopicNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageTopicNameQuery, MessageTopicNameQueryVariables>(
		MessageTopicNameDocument,
		options,
	);
}
export type MessageTopicNameQueryHookResult = ReturnType<typeof useMessageTopicNameQuery>;
export type MessageTopicNameLazyQueryHookResult = ReturnType<typeof useMessageTopicNameLazyQuery>;
export type MessageTopicNameSuspenseQueryHookResult = ReturnType<typeof useMessageTopicNameSuspenseQuery>;
export type MessageTopicNameQueryResult = Apollo.QueryResult<MessageTopicNameQuery, MessageTopicNameQueryVariables>;
export const MessageTopicNamesDocument = gql`
	query messageTopicNames($filters: [MessageTopicFilterInput!], $pagination: Pagination, $order: MessageTopicOrder) {
		messageTopicConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...MessageTopicName
				}
			}
		}
	}
	${MessageTopicNameFragmentDoc}
`;

/**
 * __useMessageTopicNamesQuery__
 *
 * To run a query within a React component, call `useMessageTopicNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTopicNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageTopicNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageTopicNamesQuery, MessageTopicNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageTopicNamesQuery, MessageTopicNamesQueryVariables>(MessageTopicNamesDocument, options);
}
export function useMessageTopicNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageTopicNamesQuery, MessageTopicNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageTopicNamesQuery, MessageTopicNamesQueryVariables>(
		MessageTopicNamesDocument,
		options,
	);
}
export function useMessageTopicNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageTopicNamesQuery, MessageTopicNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageTopicNamesQuery, MessageTopicNamesQueryVariables>(
		MessageTopicNamesDocument,
		options,
	);
}
export type MessageTopicNamesQueryHookResult = ReturnType<typeof useMessageTopicNamesQuery>;
export type MessageTopicNamesLazyQueryHookResult = ReturnType<typeof useMessageTopicNamesLazyQuery>;
export type MessageTopicNamesSuspenseQueryHookResult = ReturnType<typeof useMessageTopicNamesSuspenseQuery>;
export type MessageTopicNamesQueryResult = Apollo.QueryResult<MessageTopicNamesQuery, MessageTopicNamesQueryVariables>;
export const MessageTopicPaginationDocument = gql`
	query messageTopicPagination($filters: [MessageTopicFilterInput!], $order: MessageTopicOrder) {
		messageTopicConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useMessageTopicPaginationQuery__
 *
 * To run a query within a React component, call `useMessageTopicPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTopicPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageTopicPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageTopicPaginationQuery, MessageTopicPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageTopicPaginationQuery, MessageTopicPaginationQueryVariables>(
		MessageTopicPaginationDocument,
		options,
	);
}
export function useMessageTopicPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageTopicPaginationQuery, MessageTopicPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageTopicPaginationQuery, MessageTopicPaginationQueryVariables>(
		MessageTopicPaginationDocument,
		options,
	);
}
export function useMessageTopicPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageTopicPaginationQuery, MessageTopicPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageTopicPaginationQuery, MessageTopicPaginationQueryVariables>(
		MessageTopicPaginationDocument,
		options,
	);
}
export type MessageTopicPaginationQueryHookResult = ReturnType<typeof useMessageTopicPaginationQuery>;
export type MessageTopicPaginationLazyQueryHookResult = ReturnType<typeof useMessageTopicPaginationLazyQuery>;
export type MessageTopicPaginationSuspenseQueryHookResult = ReturnType<typeof useMessageTopicPaginationSuspenseQuery>;
export type MessageTopicPaginationQueryResult = Apollo.QueryResult<
	MessageTopicPaginationQuery,
	MessageTopicPaginationQueryVariables
>;
export const MessageTopicSelectDocument = gql`
	query messageTopicSelect($filters: [MessageTopicFilterInput!], $order: MessageTopicOrder) {
		messageTopicConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...MessageTopicName
				}
			}
		}
	}
	${MessageTopicNameFragmentDoc}
`;

/**
 * __useMessageTopicSelectQuery__
 *
 * To run a query within a React component, call `useMessageTopicSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTopicSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageTopicSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageTopicSelectQuery, MessageTopicSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageTopicSelectQuery, MessageTopicSelectQueryVariables>(
		MessageTopicSelectDocument,
		options,
	);
}
export function useMessageTopicSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageTopicSelectQuery, MessageTopicSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageTopicSelectQuery, MessageTopicSelectQueryVariables>(
		MessageTopicSelectDocument,
		options,
	);
}
export function useMessageTopicSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageTopicSelectQuery, MessageTopicSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageTopicSelectQuery, MessageTopicSelectQueryVariables>(
		MessageTopicSelectDocument,
		options,
	);
}
export type MessageTopicSelectQueryHookResult = ReturnType<typeof useMessageTopicSelectQuery>;
export type MessageTopicSelectLazyQueryHookResult = ReturnType<typeof useMessageTopicSelectLazyQuery>;
export type MessageTopicSelectSuspenseQueryHookResult = ReturnType<typeof useMessageTopicSelectSuspenseQuery>;
export type MessageTopicSelectQueryResult = Apollo.QueryResult<
	MessageTopicSelectQuery,
	MessageTopicSelectQueryVariables
>;
export const MessageTopicUpdateDocument = gql`
	mutation messageTopicUpdate($id: ID!, $input: MessageTopicUpdateInput!) {
		updateMessageTopic(id: $id, input: $input) {
			...MessageTopicDetail
		}
	}
	${MessageTopicDetailFragmentDoc}
`;
export type MessageTopicUpdateMutationFn = Apollo.MutationFunction<
	MessageTopicUpdateMutation,
	MessageTopicUpdateMutationVariables
>;

/**
 * __useMessageTopicUpdateMutation__
 *
 * To run a mutation, you first call `useMessageTopicUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageTopicUpdateMutation, { data, loading, error }] = useMessageTopicUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageTopicUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<MessageTopicUpdateMutation, MessageTopicUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageTopicUpdateMutation, MessageTopicUpdateMutationVariables>(
		MessageTopicUpdateDocument,
		options,
	);
}
export type MessageTopicUpdateMutationHookResult = ReturnType<typeof useMessageTopicUpdateMutation>;
export type MessageTopicUpdateMutationResult = Apollo.MutationResult<MessageTopicUpdateMutation>;
export type MessageTopicUpdateMutationOptions = Apollo.BaseMutationOptions<
	MessageTopicUpdateMutation,
	MessageTopicUpdateMutationVariables
>;
export const NewsletterCountDocument = gql`
	query newsletterCount($filters: [NewsletterFilterInput!], $pagination: Pagination, $order: NewsletterOrder) {
		newsletterConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useNewsletterCountQuery__
 *
 * To run a query within a React component, call `useNewsletterCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useNewsletterCountQuery(
	baseOptions?: Apollo.QueryHookOptions<NewsletterCountQuery, NewsletterCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterCountQuery, NewsletterCountQueryVariables>(NewsletterCountDocument, options);
}
export function useNewsletterCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterCountQuery, NewsletterCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterCountQuery, NewsletterCountQueryVariables>(NewsletterCountDocument, options);
}
export function useNewsletterCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterCountQuery, NewsletterCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterCountQuery, NewsletterCountQueryVariables>(NewsletterCountDocument, options);
}
export type NewsletterCountQueryHookResult = ReturnType<typeof useNewsletterCountQuery>;
export type NewsletterCountLazyQueryHookResult = ReturnType<typeof useNewsletterCountLazyQuery>;
export type NewsletterCountSuspenseQueryHookResult = ReturnType<typeof useNewsletterCountSuspenseQuery>;
export type NewsletterCountQueryResult = Apollo.QueryResult<NewsletterCountQuery, NewsletterCountQueryVariables>;
export const NewsletterCreateDocument = gql`
	mutation newsletterCreate($input: NewsletterCreateInput!) {
		createNewsletter(input: $input) {
			...NewsletterDetail
		}
	}
	${NewsletterDetailFragmentDoc}
`;
export type NewsletterCreateMutationFn = Apollo.MutationFunction<
	NewsletterCreateMutation,
	NewsletterCreateMutationVariables
>;

/**
 * __useNewsletterCreateMutation__
 *
 * To run a mutation, you first call `useNewsletterCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewsletterCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newsletterCreateMutation, { data, loading, error }] = useNewsletterCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewsletterCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<NewsletterCreateMutation, NewsletterCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<NewsletterCreateMutation, NewsletterCreateMutationVariables>(
		NewsletterCreateDocument,
		options,
	);
}
export type NewsletterCreateMutationHookResult = ReturnType<typeof useNewsletterCreateMutation>;
export type NewsletterCreateMutationResult = Apollo.MutationResult<NewsletterCreateMutation>;
export type NewsletterCreateMutationOptions = Apollo.BaseMutationOptions<
	NewsletterCreateMutation,
	NewsletterCreateMutationVariables
>;
export const NewsletterDeleteDocument = gql`
	mutation newsletterDelete($id: ID!) {
		deleteNewsletter(id: $id)
	}
`;
export type NewsletterDeleteMutationFn = Apollo.MutationFunction<
	NewsletterDeleteMutation,
	NewsletterDeleteMutationVariables
>;

/**
 * __useNewsletterDeleteMutation__
 *
 * To run a mutation, you first call `useNewsletterDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewsletterDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newsletterDeleteMutation, { data, loading, error }] = useNewsletterDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNewsletterDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<NewsletterDeleteMutation, NewsletterDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<NewsletterDeleteMutation, NewsletterDeleteMutationVariables>(
		NewsletterDeleteDocument,
		options,
	);
}
export type NewsletterDeleteMutationHookResult = ReturnType<typeof useNewsletterDeleteMutation>;
export type NewsletterDeleteMutationResult = Apollo.MutationResult<NewsletterDeleteMutation>;
export type NewsletterDeleteMutationOptions = Apollo.BaseMutationOptions<
	NewsletterDeleteMutation,
	NewsletterDeleteMutationVariables
>;
export const NewsletterDetailDocument = gql`
	query newsletterDetail($id: ID!) {
		newsletter(id: $id) {
			...NewsletterDetail
		}
	}
	${NewsletterDetailFragmentDoc}
`;

/**
 * __useNewsletterDetailQuery__
 *
 * To run a query within a React component, call `useNewsletterDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNewsletterDetailQuery(
	baseOptions: Apollo.QueryHookOptions<NewsletterDetailQuery, NewsletterDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterDetailQuery, NewsletterDetailQueryVariables>(NewsletterDetailDocument, options);
}
export function useNewsletterDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterDetailQuery, NewsletterDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterDetailQuery, NewsletterDetailQueryVariables>(NewsletterDetailDocument, options);
}
export function useNewsletterDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterDetailQuery, NewsletterDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterDetailQuery, NewsletterDetailQueryVariables>(
		NewsletterDetailDocument,
		options,
	);
}
export type NewsletterDetailQueryHookResult = ReturnType<typeof useNewsletterDetailQuery>;
export type NewsletterDetailLazyQueryHookResult = ReturnType<typeof useNewsletterDetailLazyQuery>;
export type NewsletterDetailSuspenseQueryHookResult = ReturnType<typeof useNewsletterDetailSuspenseQuery>;
export type NewsletterDetailQueryResult = Apollo.QueryResult<NewsletterDetailQuery, NewsletterDetailQueryVariables>;
export const NewsletterDisplayListDocument = gql`
	query newsletterDisplayList($filters: [NewsletterFilterInput!], $pagination: Pagination, $order: NewsletterOrder) {
		newsletterConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					...NewsletterDisplayListItem
				}
			}
		}
	}
	${NewsletterDisplayListItemFragmentDoc}
`;

/**
 * __useNewsletterDisplayListQuery__
 *
 * To run a query within a React component, call `useNewsletterDisplayListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterDisplayListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterDisplayListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useNewsletterDisplayListQuery(
	baseOptions?: Apollo.QueryHookOptions<NewsletterDisplayListQuery, NewsletterDisplayListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterDisplayListQuery, NewsletterDisplayListQueryVariables>(
		NewsletterDisplayListDocument,
		options,
	);
}
export function useNewsletterDisplayListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterDisplayListQuery, NewsletterDisplayListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterDisplayListQuery, NewsletterDisplayListQueryVariables>(
		NewsletterDisplayListDocument,
		options,
	);
}
export function useNewsletterDisplayListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterDisplayListQuery, NewsletterDisplayListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterDisplayListQuery, NewsletterDisplayListQueryVariables>(
		NewsletterDisplayListDocument,
		options,
	);
}
export type NewsletterDisplayListQueryHookResult = ReturnType<typeof useNewsletterDisplayListQuery>;
export type NewsletterDisplayListLazyQueryHookResult = ReturnType<typeof useNewsletterDisplayListLazyQuery>;
export type NewsletterDisplayListSuspenseQueryHookResult = ReturnType<typeof useNewsletterDisplayListSuspenseQuery>;
export type NewsletterDisplayListQueryResult = Apollo.QueryResult<
	NewsletterDisplayListQuery,
	NewsletterDisplayListQueryVariables
>;
export const NewsletterIndexDocument = gql`
	query newsletterIndex($filters: [NewsletterFilterInput!], $pagination: Pagination, $order: NewsletterOrder) {
		newsletterConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					title
					imageURL
					imageContentType
					body
					releaseAt
					author {
						id
						...UserName
					}
				}
			}
		}
	}
	${UserNameFragmentDoc}
`;

/**
 * __useNewsletterIndexQuery__
 *
 * To run a query within a React component, call `useNewsletterIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useNewsletterIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<NewsletterIndexQuery, NewsletterIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterIndexQuery, NewsletterIndexQueryVariables>(NewsletterIndexDocument, options);
}
export function useNewsletterIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterIndexQuery, NewsletterIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterIndexQuery, NewsletterIndexQueryVariables>(NewsletterIndexDocument, options);
}
export function useNewsletterIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterIndexQuery, NewsletterIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterIndexQuery, NewsletterIndexQueryVariables>(NewsletterIndexDocument, options);
}
export type NewsletterIndexQueryHookResult = ReturnType<typeof useNewsletterIndexQuery>;
export type NewsletterIndexLazyQueryHookResult = ReturnType<typeof useNewsletterIndexLazyQuery>;
export type NewsletterIndexSuspenseQueryHookResult = ReturnType<typeof useNewsletterIndexSuspenseQuery>;
export type NewsletterIndexQueryResult = Apollo.QueryResult<NewsletterIndexQuery, NewsletterIndexQueryVariables>;
export const NewsletterNameDocument = gql`
	query newsletterName($id: ID!) {
		newsletter(id: $id) {
			id
			...NewsletterName
		}
	}
	${NewsletterNameFragmentDoc}
`;

/**
 * __useNewsletterNameQuery__
 *
 * To run a query within a React component, call `useNewsletterNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNewsletterNameQuery(
	baseOptions: Apollo.QueryHookOptions<NewsletterNameQuery, NewsletterNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterNameQuery, NewsletterNameQueryVariables>(NewsletterNameDocument, options);
}
export function useNewsletterNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterNameQuery, NewsletterNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterNameQuery, NewsletterNameQueryVariables>(NewsletterNameDocument, options);
}
export function useNewsletterNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterNameQuery, NewsletterNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterNameQuery, NewsletterNameQueryVariables>(NewsletterNameDocument, options);
}
export type NewsletterNameQueryHookResult = ReturnType<typeof useNewsletterNameQuery>;
export type NewsletterNameLazyQueryHookResult = ReturnType<typeof useNewsletterNameLazyQuery>;
export type NewsletterNameSuspenseQueryHookResult = ReturnType<typeof useNewsletterNameSuspenseQuery>;
export type NewsletterNameQueryResult = Apollo.QueryResult<NewsletterNameQuery, NewsletterNameQueryVariables>;
export const NewsletterNamesDocument = gql`
	query newsletterNames($filters: [NewsletterFilterInput!], $pagination: Pagination, $order: NewsletterOrder) {
		newsletterConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...NewsletterName
				}
			}
		}
	}
	${NewsletterNameFragmentDoc}
`;

/**
 * __useNewsletterNamesQuery__
 *
 * To run a query within a React component, call `useNewsletterNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useNewsletterNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<NewsletterNamesQuery, NewsletterNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterNamesQuery, NewsletterNamesQueryVariables>(NewsletterNamesDocument, options);
}
export function useNewsletterNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterNamesQuery, NewsletterNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterNamesQuery, NewsletterNamesQueryVariables>(NewsletterNamesDocument, options);
}
export function useNewsletterNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterNamesQuery, NewsletterNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterNamesQuery, NewsletterNamesQueryVariables>(NewsletterNamesDocument, options);
}
export type NewsletterNamesQueryHookResult = ReturnType<typeof useNewsletterNamesQuery>;
export type NewsletterNamesLazyQueryHookResult = ReturnType<typeof useNewsletterNamesLazyQuery>;
export type NewsletterNamesSuspenseQueryHookResult = ReturnType<typeof useNewsletterNamesSuspenseQuery>;
export type NewsletterNamesQueryResult = Apollo.QueryResult<NewsletterNamesQuery, NewsletterNamesQueryVariables>;
export const NewsletterPaginationDocument = gql`
	query newsletterPagination($filters: [NewsletterFilterInput!], $order: NewsletterOrder) {
		newsletterConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useNewsletterPaginationQuery__
 *
 * To run a query within a React component, call `useNewsletterPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useNewsletterPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<NewsletterPaginationQuery, NewsletterPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterPaginationQuery, NewsletterPaginationQueryVariables>(
		NewsletterPaginationDocument,
		options,
	);
}
export function useNewsletterPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterPaginationQuery, NewsletterPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterPaginationQuery, NewsletterPaginationQueryVariables>(
		NewsletterPaginationDocument,
		options,
	);
}
export function useNewsletterPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterPaginationQuery, NewsletterPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterPaginationQuery, NewsletterPaginationQueryVariables>(
		NewsletterPaginationDocument,
		options,
	);
}
export type NewsletterPaginationQueryHookResult = ReturnType<typeof useNewsletterPaginationQuery>;
export type NewsletterPaginationLazyQueryHookResult = ReturnType<typeof useNewsletterPaginationLazyQuery>;
export type NewsletterPaginationSuspenseQueryHookResult = ReturnType<typeof useNewsletterPaginationSuspenseQuery>;
export type NewsletterPaginationQueryResult = Apollo.QueryResult<
	NewsletterPaginationQuery,
	NewsletterPaginationQueryVariables
>;
export const NewsletterSelectDocument = gql`
	query newsletterSelect($filters: [NewsletterFilterInput!], $order: NewsletterOrder) {
		newsletterConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...NewsletterName
				}
			}
		}
	}
	${NewsletterNameFragmentDoc}
`;

/**
 * __useNewsletterSelectQuery__
 *
 * To run a query within a React component, call `useNewsletterSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useNewsletterSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<NewsletterSelectQuery, NewsletterSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterSelectQuery, NewsletterSelectQueryVariables>(NewsletterSelectDocument, options);
}
export function useNewsletterSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterSelectQuery, NewsletterSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterSelectQuery, NewsletterSelectQueryVariables>(NewsletterSelectDocument, options);
}
export function useNewsletterSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterSelectQuery, NewsletterSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterSelectQuery, NewsletterSelectQueryVariables>(
		NewsletterSelectDocument,
		options,
	);
}
export type NewsletterSelectQueryHookResult = ReturnType<typeof useNewsletterSelectQuery>;
export type NewsletterSelectLazyQueryHookResult = ReturnType<typeof useNewsletterSelectLazyQuery>;
export type NewsletterSelectSuspenseQueryHookResult = ReturnType<typeof useNewsletterSelectSuspenseQuery>;
export type NewsletterSelectQueryResult = Apollo.QueryResult<NewsletterSelectQuery, NewsletterSelectQueryVariables>;
export const NewsletterSocialItemsDocument = gql`
	query newsletterSocialItems($id: ID!) {
		newsletter(id: $id) {
			id
			socialReactions(order: { field: CREATED_AT, direction: DESC }) {
				id
				reaction
				author {
					id
					...UserName
					isCurrent
				}
			}
			socialComments(order: { field: CREATED_AT, direction: DESC }) {
				id
				body
				createdAt
				author {
					id
					...UserNameAndImage
					isCurrent
				}
			}
		}
	}
	${UserNameFragmentDoc}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __useNewsletterSocialItemsQuery__
 *
 * To run a query within a React component, call `useNewsletterSocialItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterSocialItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterSocialItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNewsletterSocialItemsQuery(
	baseOptions: Apollo.QueryHookOptions<NewsletterSocialItemsQuery, NewsletterSocialItemsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterSocialItemsQuery, NewsletterSocialItemsQueryVariables>(
		NewsletterSocialItemsDocument,
		options,
	);
}
export function useNewsletterSocialItemsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterSocialItemsQuery, NewsletterSocialItemsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterSocialItemsQuery, NewsletterSocialItemsQueryVariables>(
		NewsletterSocialItemsDocument,
		options,
	);
}
export function useNewsletterSocialItemsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterSocialItemsQuery, NewsletterSocialItemsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterSocialItemsQuery, NewsletterSocialItemsQueryVariables>(
		NewsletterSocialItemsDocument,
		options,
	);
}
export type NewsletterSocialItemsQueryHookResult = ReturnType<typeof useNewsletterSocialItemsQuery>;
export type NewsletterSocialItemsLazyQueryHookResult = ReturnType<typeof useNewsletterSocialItemsLazyQuery>;
export type NewsletterSocialItemsSuspenseQueryHookResult = ReturnType<typeof useNewsletterSocialItemsSuspenseQuery>;
export type NewsletterSocialItemsQueryResult = Apollo.QueryResult<
	NewsletterSocialItemsQuery,
	NewsletterSocialItemsQueryVariables
>;
export const NewsletterStatisticsDocument = gql`
	query newsletterStatistics($filters: [NewsletterFilterInput!]) {
		newsletterStatistics(filters: $filters) {
			count
			views
			reactions
			comments
		}
	}
`;

/**
 * __useNewsletterStatisticsQuery__
 *
 * To run a query within a React component, call `useNewsletterStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterStatisticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useNewsletterStatisticsQuery(
	baseOptions?: Apollo.QueryHookOptions<NewsletterStatisticsQuery, NewsletterStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterStatisticsQuery, NewsletterStatisticsQueryVariables>(
		NewsletterStatisticsDocument,
		options,
	);
}
export function useNewsletterStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterStatisticsQuery, NewsletterStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterStatisticsQuery, NewsletterStatisticsQueryVariables>(
		NewsletterStatisticsDocument,
		options,
	);
}
export function useNewsletterStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterStatisticsQuery, NewsletterStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterStatisticsQuery, NewsletterStatisticsQueryVariables>(
		NewsletterStatisticsDocument,
		options,
	);
}
export type NewsletterStatisticsQueryHookResult = ReturnType<typeof useNewsletterStatisticsQuery>;
export type NewsletterStatisticsLazyQueryHookResult = ReturnType<typeof useNewsletterStatisticsLazyQuery>;
export type NewsletterStatisticsSuspenseQueryHookResult = ReturnType<typeof useNewsletterStatisticsSuspenseQuery>;
export type NewsletterStatisticsQueryResult = Apollo.QueryResult<
	NewsletterStatisticsQuery,
	NewsletterStatisticsQueryVariables
>;
export const NewsletterUpdateDocument = gql`
	mutation newsletterUpdate($id: ID!, $input: NewsletterUpdateInput!) {
		updateNewsletter(id: $id, input: $input) {
			...NewsletterDetail
		}
	}
	${NewsletterDetailFragmentDoc}
`;
export type NewsletterUpdateMutationFn = Apollo.MutationFunction<
	NewsletterUpdateMutation,
	NewsletterUpdateMutationVariables
>;

/**
 * __useNewsletterUpdateMutation__
 *
 * To run a mutation, you first call `useNewsletterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewsletterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newsletterUpdateMutation, { data, loading, error }] = useNewsletterUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewsletterUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<NewsletterUpdateMutation, NewsletterUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<NewsletterUpdateMutation, NewsletterUpdateMutationVariables>(
		NewsletterUpdateDocument,
		options,
	);
}
export type NewsletterUpdateMutationHookResult = ReturnType<typeof useNewsletterUpdateMutation>;
export type NewsletterUpdateMutationResult = Apollo.MutationResult<NewsletterUpdateMutation>;
export type NewsletterUpdateMutationOptions = Apollo.BaseMutationOptions<
	NewsletterUpdateMutation,
	NewsletterUpdateMutationVariables
>;
export const PaymentCountDocument = gql`
	query paymentCount($filters: [PaymentFilterInput!], $pagination: Pagination, $order: PaymentOrder) {
		paymentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __usePaymentCountQuery__
 *
 * To run a query within a React component, call `usePaymentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePaymentCountQuery(
	baseOptions?: Apollo.QueryHookOptions<PaymentCountQuery, PaymentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PaymentCountQuery, PaymentCountQueryVariables>(PaymentCountDocument, options);
}
export function usePaymentCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PaymentCountQuery, PaymentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PaymentCountQuery, PaymentCountQueryVariables>(PaymentCountDocument, options);
}
export function usePaymentCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentCountQuery, PaymentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PaymentCountQuery, PaymentCountQueryVariables>(PaymentCountDocument, options);
}
export type PaymentCountQueryHookResult = ReturnType<typeof usePaymentCountQuery>;
export type PaymentCountLazyQueryHookResult = ReturnType<typeof usePaymentCountLazyQuery>;
export type PaymentCountSuspenseQueryHookResult = ReturnType<typeof usePaymentCountSuspenseQuery>;
export type PaymentCountQueryResult = Apollo.QueryResult<PaymentCountQuery, PaymentCountQueryVariables>;
export const PaymentCreateDocument = gql`
	mutation paymentCreate($input: PaymentCreateInput!) {
		createPayment(input: $input) {
			...PaymentDetail
		}
	}
	${PaymentDetailFragmentDoc}
`;
export type PaymentCreateMutationFn = Apollo.MutationFunction<PaymentCreateMutation, PaymentCreateMutationVariables>;

/**
 * __usePaymentCreateMutation__
 *
 * To run a mutation, you first call `usePaymentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentCreateMutation, { data, loading, error }] = usePaymentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<PaymentCreateMutation, PaymentCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PaymentCreateMutation, PaymentCreateMutationVariables>(PaymentCreateDocument, options);
}
export type PaymentCreateMutationHookResult = ReturnType<typeof usePaymentCreateMutation>;
export type PaymentCreateMutationResult = Apollo.MutationResult<PaymentCreateMutation>;
export type PaymentCreateMutationOptions = Apollo.BaseMutationOptions<
	PaymentCreateMutation,
	PaymentCreateMutationVariables
>;
export const PaymentDeleteDocument = gql`
	mutation paymentDelete($id: ID!) {
		deletePayment(id: $id)
	}
`;
export type PaymentDeleteMutationFn = Apollo.MutationFunction<PaymentDeleteMutation, PaymentDeleteMutationVariables>;

/**
 * __usePaymentDeleteMutation__
 *
 * To run a mutation, you first call `usePaymentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentDeleteMutation, { data, loading, error }] = usePaymentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<PaymentDeleteMutation, PaymentDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PaymentDeleteMutation, PaymentDeleteMutationVariables>(PaymentDeleteDocument, options);
}
export type PaymentDeleteMutationHookResult = ReturnType<typeof usePaymentDeleteMutation>;
export type PaymentDeleteMutationResult = Apollo.MutationResult<PaymentDeleteMutation>;
export type PaymentDeleteMutationOptions = Apollo.BaseMutationOptions<
	PaymentDeleteMutation,
	PaymentDeleteMutationVariables
>;
export const PaymentDetailDocument = gql`
	query paymentDetail($id: ID!) {
		payment(id: $id) {
			...PaymentDetail
		}
	}
	${PaymentDetailFragmentDoc}
`;

/**
 * __usePaymentDetailQuery__
 *
 * To run a query within a React component, call `usePaymentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentDetailQuery(
	baseOptions: Apollo.QueryHookOptions<PaymentDetailQuery, PaymentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PaymentDetailQuery, PaymentDetailQueryVariables>(PaymentDetailDocument, options);
}
export function usePaymentDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PaymentDetailQuery, PaymentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PaymentDetailQuery, PaymentDetailQueryVariables>(PaymentDetailDocument, options);
}
export function usePaymentDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentDetailQuery, PaymentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PaymentDetailQuery, PaymentDetailQueryVariables>(PaymentDetailDocument, options);
}
export type PaymentDetailQueryHookResult = ReturnType<typeof usePaymentDetailQuery>;
export type PaymentDetailLazyQueryHookResult = ReturnType<typeof usePaymentDetailLazyQuery>;
export type PaymentDetailSuspenseQueryHookResult = ReturnType<typeof usePaymentDetailSuspenseQuery>;
export type PaymentDetailQueryResult = Apollo.QueryResult<PaymentDetailQuery, PaymentDetailQueryVariables>;
export const PaymentIndexDocument = gql`
	query paymentIndex($filters: [PaymentFilterInput!], $pagination: Pagination, $order: PaymentOrder) {
		paymentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					isCustomPayer
					customPayerName
					issueDate
					paymentMethod
					isInLocalCurrency
					localCurrency
					notes
				}
			}
		}
	}
`;

/**
 * __usePaymentIndexQuery__
 *
 * To run a query within a React component, call `usePaymentIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePaymentIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<PaymentIndexQuery, PaymentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PaymentIndexQuery, PaymentIndexQueryVariables>(PaymentIndexDocument, options);
}
export function usePaymentIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PaymentIndexQuery, PaymentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PaymentIndexQuery, PaymentIndexQueryVariables>(PaymentIndexDocument, options);
}
export function usePaymentIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentIndexQuery, PaymentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PaymentIndexQuery, PaymentIndexQueryVariables>(PaymentIndexDocument, options);
}
export type PaymentIndexQueryHookResult = ReturnType<typeof usePaymentIndexQuery>;
export type PaymentIndexLazyQueryHookResult = ReturnType<typeof usePaymentIndexLazyQuery>;
export type PaymentIndexSuspenseQueryHookResult = ReturnType<typeof usePaymentIndexSuspenseQuery>;
export type PaymentIndexQueryResult = Apollo.QueryResult<PaymentIndexQuery, PaymentIndexQueryVariables>;
export const PaymentNameDocument = gql`
	query paymentName($id: ID!) {
		payment(id: $id) {
			id
			...PaymentName
		}
	}
	${PaymentNameFragmentDoc}
`;

/**
 * __usePaymentNameQuery__
 *
 * To run a query within a React component, call `usePaymentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentNameQuery(baseOptions: Apollo.QueryHookOptions<PaymentNameQuery, PaymentNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PaymentNameQuery, PaymentNameQueryVariables>(PaymentNameDocument, options);
}
export function usePaymentNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PaymentNameQuery, PaymentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PaymentNameQuery, PaymentNameQueryVariables>(PaymentNameDocument, options);
}
export function usePaymentNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentNameQuery, PaymentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PaymentNameQuery, PaymentNameQueryVariables>(PaymentNameDocument, options);
}
export type PaymentNameQueryHookResult = ReturnType<typeof usePaymentNameQuery>;
export type PaymentNameLazyQueryHookResult = ReturnType<typeof usePaymentNameLazyQuery>;
export type PaymentNameSuspenseQueryHookResult = ReturnType<typeof usePaymentNameSuspenseQuery>;
export type PaymentNameQueryResult = Apollo.QueryResult<PaymentNameQuery, PaymentNameQueryVariables>;
export const PaymentNamesDocument = gql`
	query paymentNames($filters: [PaymentFilterInput!], $pagination: Pagination, $order: PaymentOrder) {
		paymentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...PaymentName
				}
			}
		}
	}
	${PaymentNameFragmentDoc}
`;

/**
 * __usePaymentNamesQuery__
 *
 * To run a query within a React component, call `usePaymentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePaymentNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<PaymentNamesQuery, PaymentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PaymentNamesQuery, PaymentNamesQueryVariables>(PaymentNamesDocument, options);
}
export function usePaymentNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PaymentNamesQuery, PaymentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PaymentNamesQuery, PaymentNamesQueryVariables>(PaymentNamesDocument, options);
}
export function usePaymentNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentNamesQuery, PaymentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PaymentNamesQuery, PaymentNamesQueryVariables>(PaymentNamesDocument, options);
}
export type PaymentNamesQueryHookResult = ReturnType<typeof usePaymentNamesQuery>;
export type PaymentNamesLazyQueryHookResult = ReturnType<typeof usePaymentNamesLazyQuery>;
export type PaymentNamesSuspenseQueryHookResult = ReturnType<typeof usePaymentNamesSuspenseQuery>;
export type PaymentNamesQueryResult = Apollo.QueryResult<PaymentNamesQuery, PaymentNamesQueryVariables>;
export const PaymentPaginationDocument = gql`
	query paymentPagination($filters: [PaymentFilterInput!], $order: PaymentOrder) {
		paymentConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __usePaymentPaginationQuery__
 *
 * To run a query within a React component, call `usePaymentPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePaymentPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<PaymentPaginationQuery, PaymentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PaymentPaginationQuery, PaymentPaginationQueryVariables>(PaymentPaginationDocument, options);
}
export function usePaymentPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PaymentPaginationQuery, PaymentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PaymentPaginationQuery, PaymentPaginationQueryVariables>(
		PaymentPaginationDocument,
		options,
	);
}
export function usePaymentPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentPaginationQuery, PaymentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PaymentPaginationQuery, PaymentPaginationQueryVariables>(
		PaymentPaginationDocument,
		options,
	);
}
export type PaymentPaginationQueryHookResult = ReturnType<typeof usePaymentPaginationQuery>;
export type PaymentPaginationLazyQueryHookResult = ReturnType<typeof usePaymentPaginationLazyQuery>;
export type PaymentPaginationSuspenseQueryHookResult = ReturnType<typeof usePaymentPaginationSuspenseQuery>;
export type PaymentPaginationQueryResult = Apollo.QueryResult<PaymentPaginationQuery, PaymentPaginationQueryVariables>;
export const PaymentSelectDocument = gql`
	query paymentSelect($filters: [PaymentFilterInput!], $order: PaymentOrder) {
		paymentConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...PaymentName
				}
			}
		}
	}
	${PaymentNameFragmentDoc}
`;

/**
 * __usePaymentSelectQuery__
 *
 * To run a query within a React component, call `usePaymentSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePaymentSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<PaymentSelectQuery, PaymentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PaymentSelectQuery, PaymentSelectQueryVariables>(PaymentSelectDocument, options);
}
export function usePaymentSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PaymentSelectQuery, PaymentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PaymentSelectQuery, PaymentSelectQueryVariables>(PaymentSelectDocument, options);
}
export function usePaymentSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentSelectQuery, PaymentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PaymentSelectQuery, PaymentSelectQueryVariables>(PaymentSelectDocument, options);
}
export type PaymentSelectQueryHookResult = ReturnType<typeof usePaymentSelectQuery>;
export type PaymentSelectLazyQueryHookResult = ReturnType<typeof usePaymentSelectLazyQuery>;
export type PaymentSelectSuspenseQueryHookResult = ReturnType<typeof usePaymentSelectSuspenseQuery>;
export type PaymentSelectQueryResult = Apollo.QueryResult<PaymentSelectQuery, PaymentSelectQueryVariables>;
export const PaymentUpdateDocument = gql`
	mutation paymentUpdate($id: ID!, $input: PaymentUpdateInput!) {
		updatePayment(id: $id, input: $input) {
			...PaymentDetail
		}
	}
	${PaymentDetailFragmentDoc}
`;
export type PaymentUpdateMutationFn = Apollo.MutationFunction<PaymentUpdateMutation, PaymentUpdateMutationVariables>;

/**
 * __usePaymentUpdateMutation__
 *
 * To run a mutation, you first call `usePaymentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentUpdateMutation, { data, loading, error }] = usePaymentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<PaymentUpdateMutation, PaymentUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PaymentUpdateMutation, PaymentUpdateMutationVariables>(PaymentUpdateDocument, options);
}
export type PaymentUpdateMutationHookResult = ReturnType<typeof usePaymentUpdateMutation>;
export type PaymentUpdateMutationResult = Apollo.MutationResult<PaymentUpdateMutation>;
export type PaymentUpdateMutationOptions = Apollo.BaseMutationOptions<
	PaymentUpdateMutation,
	PaymentUpdateMutationVariables
>;
export const PaymentLineItemCountDocument = gql`
	query paymentLineItemCount(
		$filters: [PaymentLineItemFilterInput!]
		$pagination: Pagination
		$order: PaymentLineItemOrder
	) {
		paymentLineItemConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __usePaymentLineItemCountQuery__
 *
 * To run a query within a React component, call `usePaymentLineItemCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentLineItemCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentLineItemCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePaymentLineItemCountQuery(
	baseOptions?: Apollo.QueryHookOptions<PaymentLineItemCountQuery, PaymentLineItemCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PaymentLineItemCountQuery, PaymentLineItemCountQueryVariables>(
		PaymentLineItemCountDocument,
		options,
	);
}
export function usePaymentLineItemCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PaymentLineItemCountQuery, PaymentLineItemCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PaymentLineItemCountQuery, PaymentLineItemCountQueryVariables>(
		PaymentLineItemCountDocument,
		options,
	);
}
export function usePaymentLineItemCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentLineItemCountQuery, PaymentLineItemCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PaymentLineItemCountQuery, PaymentLineItemCountQueryVariables>(
		PaymentLineItemCountDocument,
		options,
	);
}
export type PaymentLineItemCountQueryHookResult = ReturnType<typeof usePaymentLineItemCountQuery>;
export type PaymentLineItemCountLazyQueryHookResult = ReturnType<typeof usePaymentLineItemCountLazyQuery>;
export type PaymentLineItemCountSuspenseQueryHookResult = ReturnType<typeof usePaymentLineItemCountSuspenseQuery>;
export type PaymentLineItemCountQueryResult = Apollo.QueryResult<
	PaymentLineItemCountQuery,
	PaymentLineItemCountQueryVariables
>;
export const PaymentLineItemCreateDocument = gql`
	mutation paymentLineItemCreate($input: PaymentLineItemCreateInput!) {
		createPaymentLineItem(input: $input) {
			...PaymentLineItemDetail
		}
	}
	${PaymentLineItemDetailFragmentDoc}
`;
export type PaymentLineItemCreateMutationFn = Apollo.MutationFunction<
	PaymentLineItemCreateMutation,
	PaymentLineItemCreateMutationVariables
>;

/**
 * __usePaymentLineItemCreateMutation__
 *
 * To run a mutation, you first call `usePaymentLineItemCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentLineItemCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentLineItemCreateMutation, { data, loading, error }] = usePaymentLineItemCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentLineItemCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<PaymentLineItemCreateMutation, PaymentLineItemCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PaymentLineItemCreateMutation, PaymentLineItemCreateMutationVariables>(
		PaymentLineItemCreateDocument,
		options,
	);
}
export type PaymentLineItemCreateMutationHookResult = ReturnType<typeof usePaymentLineItemCreateMutation>;
export type PaymentLineItemCreateMutationResult = Apollo.MutationResult<PaymentLineItemCreateMutation>;
export type PaymentLineItemCreateMutationOptions = Apollo.BaseMutationOptions<
	PaymentLineItemCreateMutation,
	PaymentLineItemCreateMutationVariables
>;
export const PaymentLineItemDeleteDocument = gql`
	mutation paymentLineItemDelete($id: ID!) {
		deletePaymentLineItem(id: $id)
	}
`;
export type PaymentLineItemDeleteMutationFn = Apollo.MutationFunction<
	PaymentLineItemDeleteMutation,
	PaymentLineItemDeleteMutationVariables
>;

/**
 * __usePaymentLineItemDeleteMutation__
 *
 * To run a mutation, you first call `usePaymentLineItemDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentLineItemDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentLineItemDeleteMutation, { data, loading, error }] = usePaymentLineItemDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentLineItemDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<PaymentLineItemDeleteMutation, PaymentLineItemDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PaymentLineItemDeleteMutation, PaymentLineItemDeleteMutationVariables>(
		PaymentLineItemDeleteDocument,
		options,
	);
}
export type PaymentLineItemDeleteMutationHookResult = ReturnType<typeof usePaymentLineItemDeleteMutation>;
export type PaymentLineItemDeleteMutationResult = Apollo.MutationResult<PaymentLineItemDeleteMutation>;
export type PaymentLineItemDeleteMutationOptions = Apollo.BaseMutationOptions<
	PaymentLineItemDeleteMutation,
	PaymentLineItemDeleteMutationVariables
>;
export const PaymentLineItemDetailDocument = gql`
	query paymentLineItemDetail($id: ID!) {
		paymentLineItem(id: $id) {
			...PaymentLineItemDetail
		}
	}
	${PaymentLineItemDetailFragmentDoc}
`;

/**
 * __usePaymentLineItemDetailQuery__
 *
 * To run a query within a React component, call `usePaymentLineItemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentLineItemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentLineItemDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentLineItemDetailQuery(
	baseOptions: Apollo.QueryHookOptions<PaymentLineItemDetailQuery, PaymentLineItemDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PaymentLineItemDetailQuery, PaymentLineItemDetailQueryVariables>(
		PaymentLineItemDetailDocument,
		options,
	);
}
export function usePaymentLineItemDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PaymentLineItemDetailQuery, PaymentLineItemDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PaymentLineItemDetailQuery, PaymentLineItemDetailQueryVariables>(
		PaymentLineItemDetailDocument,
		options,
	);
}
export function usePaymentLineItemDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentLineItemDetailQuery, PaymentLineItemDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PaymentLineItemDetailQuery, PaymentLineItemDetailQueryVariables>(
		PaymentLineItemDetailDocument,
		options,
	);
}
export type PaymentLineItemDetailQueryHookResult = ReturnType<typeof usePaymentLineItemDetailQuery>;
export type PaymentLineItemDetailLazyQueryHookResult = ReturnType<typeof usePaymentLineItemDetailLazyQuery>;
export type PaymentLineItemDetailSuspenseQueryHookResult = ReturnType<typeof usePaymentLineItemDetailSuspenseQuery>;
export type PaymentLineItemDetailQueryResult = Apollo.QueryResult<
	PaymentLineItemDetailQuery,
	PaymentLineItemDetailQueryVariables
>;
export const PaymentLineItemIndexDocument = gql`
	query paymentLineItemIndex(
		$filters: [PaymentLineItemFilterInput!]
		$pagination: Pagination
		$order: PaymentLineItemOrder
	) {
		paymentLineItemConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					displayOrder
					amount
					localAmount
				}
			}
		}
	}
`;

/**
 * __usePaymentLineItemIndexQuery__
 *
 * To run a query within a React component, call `usePaymentLineItemIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentLineItemIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentLineItemIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePaymentLineItemIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<PaymentLineItemIndexQuery, PaymentLineItemIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PaymentLineItemIndexQuery, PaymentLineItemIndexQueryVariables>(
		PaymentLineItemIndexDocument,
		options,
	);
}
export function usePaymentLineItemIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PaymentLineItemIndexQuery, PaymentLineItemIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PaymentLineItemIndexQuery, PaymentLineItemIndexQueryVariables>(
		PaymentLineItemIndexDocument,
		options,
	);
}
export function usePaymentLineItemIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentLineItemIndexQuery, PaymentLineItemIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PaymentLineItemIndexQuery, PaymentLineItemIndexQueryVariables>(
		PaymentLineItemIndexDocument,
		options,
	);
}
export type PaymentLineItemIndexQueryHookResult = ReturnType<typeof usePaymentLineItemIndexQuery>;
export type PaymentLineItemIndexLazyQueryHookResult = ReturnType<typeof usePaymentLineItemIndexLazyQuery>;
export type PaymentLineItemIndexSuspenseQueryHookResult = ReturnType<typeof usePaymentLineItemIndexSuspenseQuery>;
export type PaymentLineItemIndexQueryResult = Apollo.QueryResult<
	PaymentLineItemIndexQuery,
	PaymentLineItemIndexQueryVariables
>;
export const PaymentLineItemNameDocument = gql`
	query paymentLineItemName($id: ID!) {
		paymentLineItem(id: $id) {
			id
			...PaymentLineItemName
		}
	}
	${PaymentLineItemNameFragmentDoc}
`;

/**
 * __usePaymentLineItemNameQuery__
 *
 * To run a query within a React component, call `usePaymentLineItemNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentLineItemNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentLineItemNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentLineItemNameQuery(
	baseOptions: Apollo.QueryHookOptions<PaymentLineItemNameQuery, PaymentLineItemNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PaymentLineItemNameQuery, PaymentLineItemNameQueryVariables>(
		PaymentLineItemNameDocument,
		options,
	);
}
export function usePaymentLineItemNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PaymentLineItemNameQuery, PaymentLineItemNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PaymentLineItemNameQuery, PaymentLineItemNameQueryVariables>(
		PaymentLineItemNameDocument,
		options,
	);
}
export function usePaymentLineItemNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentLineItemNameQuery, PaymentLineItemNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PaymentLineItemNameQuery, PaymentLineItemNameQueryVariables>(
		PaymentLineItemNameDocument,
		options,
	);
}
export type PaymentLineItemNameQueryHookResult = ReturnType<typeof usePaymentLineItemNameQuery>;
export type PaymentLineItemNameLazyQueryHookResult = ReturnType<typeof usePaymentLineItemNameLazyQuery>;
export type PaymentLineItemNameSuspenseQueryHookResult = ReturnType<typeof usePaymentLineItemNameSuspenseQuery>;
export type PaymentLineItemNameQueryResult = Apollo.QueryResult<
	PaymentLineItemNameQuery,
	PaymentLineItemNameQueryVariables
>;
export const PaymentLineItemNamesDocument = gql`
	query paymentLineItemNames(
		$filters: [PaymentLineItemFilterInput!]
		$pagination: Pagination
		$order: PaymentLineItemOrder
	) {
		paymentLineItemConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...PaymentLineItemName
				}
			}
		}
	}
	${PaymentLineItemNameFragmentDoc}
`;

/**
 * __usePaymentLineItemNamesQuery__
 *
 * To run a query within a React component, call `usePaymentLineItemNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentLineItemNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentLineItemNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePaymentLineItemNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<PaymentLineItemNamesQuery, PaymentLineItemNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PaymentLineItemNamesQuery, PaymentLineItemNamesQueryVariables>(
		PaymentLineItemNamesDocument,
		options,
	);
}
export function usePaymentLineItemNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PaymentLineItemNamesQuery, PaymentLineItemNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PaymentLineItemNamesQuery, PaymentLineItemNamesQueryVariables>(
		PaymentLineItemNamesDocument,
		options,
	);
}
export function usePaymentLineItemNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentLineItemNamesQuery, PaymentLineItemNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PaymentLineItemNamesQuery, PaymentLineItemNamesQueryVariables>(
		PaymentLineItemNamesDocument,
		options,
	);
}
export type PaymentLineItemNamesQueryHookResult = ReturnType<typeof usePaymentLineItemNamesQuery>;
export type PaymentLineItemNamesLazyQueryHookResult = ReturnType<typeof usePaymentLineItemNamesLazyQuery>;
export type PaymentLineItemNamesSuspenseQueryHookResult = ReturnType<typeof usePaymentLineItemNamesSuspenseQuery>;
export type PaymentLineItemNamesQueryResult = Apollo.QueryResult<
	PaymentLineItemNamesQuery,
	PaymentLineItemNamesQueryVariables
>;
export const PaymentLineItemPaginationDocument = gql`
	query paymentLineItemPagination($filters: [PaymentLineItemFilterInput!], $order: PaymentLineItemOrder) {
		paymentLineItemConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __usePaymentLineItemPaginationQuery__
 *
 * To run a query within a React component, call `usePaymentLineItemPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentLineItemPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentLineItemPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePaymentLineItemPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<PaymentLineItemPaginationQuery, PaymentLineItemPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PaymentLineItemPaginationQuery, PaymentLineItemPaginationQueryVariables>(
		PaymentLineItemPaginationDocument,
		options,
	);
}
export function usePaymentLineItemPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PaymentLineItemPaginationQuery, PaymentLineItemPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PaymentLineItemPaginationQuery, PaymentLineItemPaginationQueryVariables>(
		PaymentLineItemPaginationDocument,
		options,
	);
}
export function usePaymentLineItemPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		PaymentLineItemPaginationQuery,
		PaymentLineItemPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PaymentLineItemPaginationQuery, PaymentLineItemPaginationQueryVariables>(
		PaymentLineItemPaginationDocument,
		options,
	);
}
export type PaymentLineItemPaginationQueryHookResult = ReturnType<typeof usePaymentLineItemPaginationQuery>;
export type PaymentLineItemPaginationLazyQueryHookResult = ReturnType<typeof usePaymentLineItemPaginationLazyQuery>;
export type PaymentLineItemPaginationSuspenseQueryHookResult = ReturnType<
	typeof usePaymentLineItemPaginationSuspenseQuery
>;
export type PaymentLineItemPaginationQueryResult = Apollo.QueryResult<
	PaymentLineItemPaginationQuery,
	PaymentLineItemPaginationQueryVariables
>;
export const PaymentLineItemSelectDocument = gql`
	query paymentLineItemSelect($filters: [PaymentLineItemFilterInput!], $order: PaymentLineItemOrder) {
		paymentLineItemConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...PaymentLineItemName
				}
			}
		}
	}
	${PaymentLineItemNameFragmentDoc}
`;

/**
 * __usePaymentLineItemSelectQuery__
 *
 * To run a query within a React component, call `usePaymentLineItemSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentLineItemSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentLineItemSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePaymentLineItemSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<PaymentLineItemSelectQuery, PaymentLineItemSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PaymentLineItemSelectQuery, PaymentLineItemSelectQueryVariables>(
		PaymentLineItemSelectDocument,
		options,
	);
}
export function usePaymentLineItemSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PaymentLineItemSelectQuery, PaymentLineItemSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PaymentLineItemSelectQuery, PaymentLineItemSelectQueryVariables>(
		PaymentLineItemSelectDocument,
		options,
	);
}
export function usePaymentLineItemSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentLineItemSelectQuery, PaymentLineItemSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PaymentLineItemSelectQuery, PaymentLineItemSelectQueryVariables>(
		PaymentLineItemSelectDocument,
		options,
	);
}
export type PaymentLineItemSelectQueryHookResult = ReturnType<typeof usePaymentLineItemSelectQuery>;
export type PaymentLineItemSelectLazyQueryHookResult = ReturnType<typeof usePaymentLineItemSelectLazyQuery>;
export type PaymentLineItemSelectSuspenseQueryHookResult = ReturnType<typeof usePaymentLineItemSelectSuspenseQuery>;
export type PaymentLineItemSelectQueryResult = Apollo.QueryResult<
	PaymentLineItemSelectQuery,
	PaymentLineItemSelectQueryVariables
>;
export const PaymentLineItemUpdateDocument = gql`
	mutation paymentLineItemUpdate($id: ID!, $input: PaymentLineItemUpdateInput!) {
		updatePaymentLineItem(id: $id, input: $input) {
			...PaymentLineItemDetail
		}
	}
	${PaymentLineItemDetailFragmentDoc}
`;
export type PaymentLineItemUpdateMutationFn = Apollo.MutationFunction<
	PaymentLineItemUpdateMutation,
	PaymentLineItemUpdateMutationVariables
>;

/**
 * __usePaymentLineItemUpdateMutation__
 *
 * To run a mutation, you first call `usePaymentLineItemUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentLineItemUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentLineItemUpdateMutation, { data, loading, error }] = usePaymentLineItemUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentLineItemUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<PaymentLineItemUpdateMutation, PaymentLineItemUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PaymentLineItemUpdateMutation, PaymentLineItemUpdateMutationVariables>(
		PaymentLineItemUpdateDocument,
		options,
	);
}
export type PaymentLineItemUpdateMutationHookResult = ReturnType<typeof usePaymentLineItemUpdateMutation>;
export type PaymentLineItemUpdateMutationResult = Apollo.MutationResult<PaymentLineItemUpdateMutation>;
export type PaymentLineItemUpdateMutationOptions = Apollo.BaseMutationOptions<
	PaymentLineItemUpdateMutation,
	PaymentLineItemUpdateMutationVariables
>;
export const PermissionCountDocument = gql`
	query permissionCount($filters: [PermissionFilterInput!], $pagination: Pagination, $order: PermissionOrder) {
		permissionConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __usePermissionCountQuery__
 *
 * To run a query within a React component, call `usePermissionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionCountQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionCountQuery, PermissionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionCountQuery, PermissionCountQueryVariables>(PermissionCountDocument, options);
}
export function usePermissionCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionCountQuery, PermissionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionCountQuery, PermissionCountQueryVariables>(PermissionCountDocument, options);
}
export function usePermissionCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionCountQuery, PermissionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionCountQuery, PermissionCountQueryVariables>(PermissionCountDocument, options);
}
export type PermissionCountQueryHookResult = ReturnType<typeof usePermissionCountQuery>;
export type PermissionCountLazyQueryHookResult = ReturnType<typeof usePermissionCountLazyQuery>;
export type PermissionCountSuspenseQueryHookResult = ReturnType<typeof usePermissionCountSuspenseQuery>;
export type PermissionCountQueryResult = Apollo.QueryResult<PermissionCountQuery, PermissionCountQueryVariables>;
export const PermissionDetailDocument = gql`
	query permissionDetail($id: ID!) {
		permission(id: $id) {
			...PermissionDetail
		}
	}
	${PermissionDetailFragmentDoc}
`;

/**
 * __usePermissionDetailQuery__
 *
 * To run a query within a React component, call `usePermissionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePermissionDetailQuery(
	baseOptions: Apollo.QueryHookOptions<PermissionDetailQuery, PermissionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionDetailQuery, PermissionDetailQueryVariables>(PermissionDetailDocument, options);
}
export function usePermissionDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionDetailQuery, PermissionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionDetailQuery, PermissionDetailQueryVariables>(PermissionDetailDocument, options);
}
export function usePermissionDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionDetailQuery, PermissionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionDetailQuery, PermissionDetailQueryVariables>(
		PermissionDetailDocument,
		options,
	);
}
export type PermissionDetailQueryHookResult = ReturnType<typeof usePermissionDetailQuery>;
export type PermissionDetailLazyQueryHookResult = ReturnType<typeof usePermissionDetailLazyQuery>;
export type PermissionDetailSuspenseQueryHookResult = ReturnType<typeof usePermissionDetailSuspenseQuery>;
export type PermissionDetailQueryResult = Apollo.QueryResult<PermissionDetailQuery, PermissionDetailQueryVariables>;
export const PermissionIndexDocument = gql`
	query permissionIndex($filters: [PermissionFilterInput!], $pagination: Pagination, $order: PermissionOrder) {
		permissionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					family
					action
					level
					description
				}
			}
		}
	}
`;

/**
 * __usePermissionIndexQuery__
 *
 * To run a query within a React component, call `usePermissionIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionIndexQuery, PermissionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionIndexQuery, PermissionIndexQueryVariables>(PermissionIndexDocument, options);
}
export function usePermissionIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionIndexQuery, PermissionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionIndexQuery, PermissionIndexQueryVariables>(PermissionIndexDocument, options);
}
export function usePermissionIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionIndexQuery, PermissionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionIndexQuery, PermissionIndexQueryVariables>(PermissionIndexDocument, options);
}
export type PermissionIndexQueryHookResult = ReturnType<typeof usePermissionIndexQuery>;
export type PermissionIndexLazyQueryHookResult = ReturnType<typeof usePermissionIndexLazyQuery>;
export type PermissionIndexSuspenseQueryHookResult = ReturnType<typeof usePermissionIndexSuspenseQuery>;
export type PermissionIndexQueryResult = Apollo.QueryResult<PermissionIndexQuery, PermissionIndexQueryVariables>;
export const PermissionNameDocument = gql`
	query permissionName($id: ID!) {
		permission(id: $id) {
			id
			...PermissionName
		}
	}
	${PermissionNameFragmentDoc}
`;

/**
 * __usePermissionNameQuery__
 *
 * To run a query within a React component, call `usePermissionNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePermissionNameQuery(
	baseOptions: Apollo.QueryHookOptions<PermissionNameQuery, PermissionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionNameQuery, PermissionNameQueryVariables>(PermissionNameDocument, options);
}
export function usePermissionNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionNameQuery, PermissionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionNameQuery, PermissionNameQueryVariables>(PermissionNameDocument, options);
}
export function usePermissionNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionNameQuery, PermissionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionNameQuery, PermissionNameQueryVariables>(PermissionNameDocument, options);
}
export type PermissionNameQueryHookResult = ReturnType<typeof usePermissionNameQuery>;
export type PermissionNameLazyQueryHookResult = ReturnType<typeof usePermissionNameLazyQuery>;
export type PermissionNameSuspenseQueryHookResult = ReturnType<typeof usePermissionNameSuspenseQuery>;
export type PermissionNameQueryResult = Apollo.QueryResult<PermissionNameQuery, PermissionNameQueryVariables>;
export const PermissionNamesDocument = gql`
	query permissionNames($filters: [PermissionFilterInput!], $pagination: Pagination, $order: PermissionOrder) {
		permissionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...PermissionName
				}
			}
		}
	}
	${PermissionNameFragmentDoc}
`;

/**
 * __usePermissionNamesQuery__
 *
 * To run a query within a React component, call `usePermissionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionNamesQuery, PermissionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionNamesQuery, PermissionNamesQueryVariables>(PermissionNamesDocument, options);
}
export function usePermissionNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionNamesQuery, PermissionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionNamesQuery, PermissionNamesQueryVariables>(PermissionNamesDocument, options);
}
export function usePermissionNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionNamesQuery, PermissionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionNamesQuery, PermissionNamesQueryVariables>(PermissionNamesDocument, options);
}
export type PermissionNamesQueryHookResult = ReturnType<typeof usePermissionNamesQuery>;
export type PermissionNamesLazyQueryHookResult = ReturnType<typeof usePermissionNamesLazyQuery>;
export type PermissionNamesSuspenseQueryHookResult = ReturnType<typeof usePermissionNamesSuspenseQuery>;
export type PermissionNamesQueryResult = Apollo.QueryResult<PermissionNamesQuery, PermissionNamesQueryVariables>;
export const PermissionPaginationDocument = gql`
	query permissionPagination($filters: [PermissionFilterInput!], $order: PermissionOrder) {
		permissionConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __usePermissionPaginationQuery__
 *
 * To run a query within a React component, call `usePermissionPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionPaginationQuery, PermissionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionPaginationQuery, PermissionPaginationQueryVariables>(
		PermissionPaginationDocument,
		options,
	);
}
export function usePermissionPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionPaginationQuery, PermissionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionPaginationQuery, PermissionPaginationQueryVariables>(
		PermissionPaginationDocument,
		options,
	);
}
export function usePermissionPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionPaginationQuery, PermissionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionPaginationQuery, PermissionPaginationQueryVariables>(
		PermissionPaginationDocument,
		options,
	);
}
export type PermissionPaginationQueryHookResult = ReturnType<typeof usePermissionPaginationQuery>;
export type PermissionPaginationLazyQueryHookResult = ReturnType<typeof usePermissionPaginationLazyQuery>;
export type PermissionPaginationSuspenseQueryHookResult = ReturnType<typeof usePermissionPaginationSuspenseQuery>;
export type PermissionPaginationQueryResult = Apollo.QueryResult<
	PermissionPaginationQuery,
	PermissionPaginationQueryVariables
>;
export const PermissionSelectDocument = gql`
	query permissionSelect($filters: [PermissionFilterInput!], $order: PermissionOrder) {
		permissionConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...PermissionName
				}
			}
		}
	}
	${PermissionNameFragmentDoc}
`;

/**
 * __usePermissionSelectQuery__
 *
 * To run a query within a React component, call `usePermissionSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionSelectQuery, PermissionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionSelectQuery, PermissionSelectQueryVariables>(PermissionSelectDocument, options);
}
export function usePermissionSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionSelectQuery, PermissionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionSelectQuery, PermissionSelectQueryVariables>(PermissionSelectDocument, options);
}
export function usePermissionSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionSelectQuery, PermissionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionSelectQuery, PermissionSelectQueryVariables>(
		PermissionSelectDocument,
		options,
	);
}
export type PermissionSelectQueryHookResult = ReturnType<typeof usePermissionSelectQuery>;
export type PermissionSelectLazyQueryHookResult = ReturnType<typeof usePermissionSelectLazyQuery>;
export type PermissionSelectSuspenseQueryHookResult = ReturnType<typeof usePermissionSelectSuspenseQuery>;
export type PermissionSelectQueryResult = Apollo.QueryResult<PermissionSelectQuery, PermissionSelectQueryVariables>;
export const PermissionUpdateDocument = gql`
	mutation permissionUpdate($id: ID!, $input: PermissionUpdateInput!) {
		updatePermission(id: $id, input: $input) {
			...PermissionDetail
		}
	}
	${PermissionDetailFragmentDoc}
`;
export type PermissionUpdateMutationFn = Apollo.MutationFunction<
	PermissionUpdateMutation,
	PermissionUpdateMutationVariables
>;

/**
 * __usePermissionUpdateMutation__
 *
 * To run a mutation, you first call `usePermissionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePermissionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [permissionUpdateMutation, { data, loading, error }] = usePermissionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePermissionUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<PermissionUpdateMutation, PermissionUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PermissionUpdateMutation, PermissionUpdateMutationVariables>(
		PermissionUpdateDocument,
		options,
	);
}
export type PermissionUpdateMutationHookResult = ReturnType<typeof usePermissionUpdateMutation>;
export type PermissionUpdateMutationResult = Apollo.MutationResult<PermissionUpdateMutation>;
export type PermissionUpdateMutationOptions = Apollo.BaseMutationOptions<
	PermissionUpdateMutation,
	PermissionUpdateMutationVariables
>;
export const PermissionGroupCheckUniqueNameDocument = gql`
	query permissionGroupCheckUniqueName($ignoreID: ID, $name: String!) {
		permissionGroupConnection(filters: { idNEQ: $ignoreID, nameEQ: $name }) {
			totalCount
		}
	}
`;

/**
 * __usePermissionGroupCheckUniqueNameQuery__
 *
 * To run a query within a React component, call `usePermissionGroupCheckUniqueNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupCheckUniqueNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionGroupCheckUniqueNameQuery({
 *   variables: {
 *      ignoreID: // value for 'ignoreID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function usePermissionGroupCheckUniqueNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		PermissionGroupCheckUniqueNameQuery,
		PermissionGroupCheckUniqueNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionGroupCheckUniqueNameQuery, PermissionGroupCheckUniqueNameQueryVariables>(
		PermissionGroupCheckUniqueNameDocument,
		options,
	);
}
export function usePermissionGroupCheckUniqueNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PermissionGroupCheckUniqueNameQuery,
		PermissionGroupCheckUniqueNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionGroupCheckUniqueNameQuery, PermissionGroupCheckUniqueNameQueryVariables>(
		PermissionGroupCheckUniqueNameDocument,
		options,
	);
}
export function usePermissionGroupCheckUniqueNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		PermissionGroupCheckUniqueNameQuery,
		PermissionGroupCheckUniqueNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionGroupCheckUniqueNameQuery, PermissionGroupCheckUniqueNameQueryVariables>(
		PermissionGroupCheckUniqueNameDocument,
		options,
	);
}
export type PermissionGroupCheckUniqueNameQueryHookResult = ReturnType<typeof usePermissionGroupCheckUniqueNameQuery>;
export type PermissionGroupCheckUniqueNameLazyQueryHookResult = ReturnType<
	typeof usePermissionGroupCheckUniqueNameLazyQuery
>;
export type PermissionGroupCheckUniqueNameSuspenseQueryHookResult = ReturnType<
	typeof usePermissionGroupCheckUniqueNameSuspenseQuery
>;
export type PermissionGroupCheckUniqueNameQueryResult = Apollo.QueryResult<
	PermissionGroupCheckUniqueNameQuery,
	PermissionGroupCheckUniqueNameQueryVariables
>;
export const PermissionGroupCountDocument = gql`
	query permissionGroupCount(
		$filters: [PermissionGroupFilterInput!]
		$pagination: Pagination
		$order: PermissionGroupOrder
	) {
		permissionGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __usePermissionGroupCountQuery__
 *
 * To run a query within a React component, call `usePermissionGroupCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionGroupCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionGroupCountQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionGroupCountQuery, PermissionGroupCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionGroupCountQuery, PermissionGroupCountQueryVariables>(
		PermissionGroupCountDocument,
		options,
	);
}
export function usePermissionGroupCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionGroupCountQuery, PermissionGroupCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionGroupCountQuery, PermissionGroupCountQueryVariables>(
		PermissionGroupCountDocument,
		options,
	);
}
export function usePermissionGroupCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionGroupCountQuery, PermissionGroupCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionGroupCountQuery, PermissionGroupCountQueryVariables>(
		PermissionGroupCountDocument,
		options,
	);
}
export type PermissionGroupCountQueryHookResult = ReturnType<typeof usePermissionGroupCountQuery>;
export type PermissionGroupCountLazyQueryHookResult = ReturnType<typeof usePermissionGroupCountLazyQuery>;
export type PermissionGroupCountSuspenseQueryHookResult = ReturnType<typeof usePermissionGroupCountSuspenseQuery>;
export type PermissionGroupCountQueryResult = Apollo.QueryResult<
	PermissionGroupCountQuery,
	PermissionGroupCountQueryVariables
>;
export const PermissionGroupCreateDocument = gql`
	mutation permissionGroupCreate($input: PermissionGroupCreateInput!) {
		createPermissionGroup(input: $input) {
			...PermissionGroupDetail
		}
	}
	${PermissionGroupDetailFragmentDoc}
`;
export type PermissionGroupCreateMutationFn = Apollo.MutationFunction<
	PermissionGroupCreateMutation,
	PermissionGroupCreateMutationVariables
>;

/**
 * __usePermissionGroupCreateMutation__
 *
 * To run a mutation, you first call `usePermissionGroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [permissionGroupCreateMutation, { data, loading, error }] = usePermissionGroupCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePermissionGroupCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<PermissionGroupCreateMutation, PermissionGroupCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PermissionGroupCreateMutation, PermissionGroupCreateMutationVariables>(
		PermissionGroupCreateDocument,
		options,
	);
}
export type PermissionGroupCreateMutationHookResult = ReturnType<typeof usePermissionGroupCreateMutation>;
export type PermissionGroupCreateMutationResult = Apollo.MutationResult<PermissionGroupCreateMutation>;
export type PermissionGroupCreateMutationOptions = Apollo.BaseMutationOptions<
	PermissionGroupCreateMutation,
	PermissionGroupCreateMutationVariables
>;
export const PermissionGroupDeleteDocument = gql`
	mutation permissionGroupDelete($id: ID!) {
		deletePermissionGroup(id: $id)
	}
`;
export type PermissionGroupDeleteMutationFn = Apollo.MutationFunction<
	PermissionGroupDeleteMutation,
	PermissionGroupDeleteMutationVariables
>;

/**
 * __usePermissionGroupDeleteMutation__
 *
 * To run a mutation, you first call `usePermissionGroupDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [permissionGroupDeleteMutation, { data, loading, error }] = usePermissionGroupDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePermissionGroupDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<PermissionGroupDeleteMutation, PermissionGroupDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PermissionGroupDeleteMutation, PermissionGroupDeleteMutationVariables>(
		PermissionGroupDeleteDocument,
		options,
	);
}
export type PermissionGroupDeleteMutationHookResult = ReturnType<typeof usePermissionGroupDeleteMutation>;
export type PermissionGroupDeleteMutationResult = Apollo.MutationResult<PermissionGroupDeleteMutation>;
export type PermissionGroupDeleteMutationOptions = Apollo.BaseMutationOptions<
	PermissionGroupDeleteMutation,
	PermissionGroupDeleteMutationVariables
>;
export const PermissionGroupDetailDocument = gql`
	query permissionGroupDetail($id: ID!) {
		permissionGroup(id: $id) {
			...PermissionGroupDetail
		}
	}
	${PermissionGroupDetailFragmentDoc}
`;

/**
 * __usePermissionGroupDetailQuery__
 *
 * To run a query within a React component, call `usePermissionGroupDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionGroupDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePermissionGroupDetailQuery(
	baseOptions: Apollo.QueryHookOptions<PermissionGroupDetailQuery, PermissionGroupDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionGroupDetailQuery, PermissionGroupDetailQueryVariables>(
		PermissionGroupDetailDocument,
		options,
	);
}
export function usePermissionGroupDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionGroupDetailQuery, PermissionGroupDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionGroupDetailQuery, PermissionGroupDetailQueryVariables>(
		PermissionGroupDetailDocument,
		options,
	);
}
export function usePermissionGroupDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionGroupDetailQuery, PermissionGroupDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionGroupDetailQuery, PermissionGroupDetailQueryVariables>(
		PermissionGroupDetailDocument,
		options,
	);
}
export type PermissionGroupDetailQueryHookResult = ReturnType<typeof usePermissionGroupDetailQuery>;
export type PermissionGroupDetailLazyQueryHookResult = ReturnType<typeof usePermissionGroupDetailLazyQuery>;
export type PermissionGroupDetailSuspenseQueryHookResult = ReturnType<typeof usePermissionGroupDetailSuspenseQuery>;
export type PermissionGroupDetailQueryResult = Apollo.QueryResult<
	PermissionGroupDetailQuery,
	PermissionGroupDetailQueryVariables
>;
export const PermissionGroupIndexDocument = gql`
	query permissionGroupIndex(
		$filters: [PermissionGroupFilterInput!]
		$pagination: Pagination
		$order: PermissionGroupOrder
	) {
		permissionGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					description
				}
			}
		}
	}
`;

/**
 * __usePermissionGroupIndexQuery__
 *
 * To run a query within a React component, call `usePermissionGroupIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionGroupIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionGroupIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionGroupIndexQuery, PermissionGroupIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionGroupIndexQuery, PermissionGroupIndexQueryVariables>(
		PermissionGroupIndexDocument,
		options,
	);
}
export function usePermissionGroupIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionGroupIndexQuery, PermissionGroupIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionGroupIndexQuery, PermissionGroupIndexQueryVariables>(
		PermissionGroupIndexDocument,
		options,
	);
}
export function usePermissionGroupIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionGroupIndexQuery, PermissionGroupIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionGroupIndexQuery, PermissionGroupIndexQueryVariables>(
		PermissionGroupIndexDocument,
		options,
	);
}
export type PermissionGroupIndexQueryHookResult = ReturnType<typeof usePermissionGroupIndexQuery>;
export type PermissionGroupIndexLazyQueryHookResult = ReturnType<typeof usePermissionGroupIndexLazyQuery>;
export type PermissionGroupIndexSuspenseQueryHookResult = ReturnType<typeof usePermissionGroupIndexSuspenseQuery>;
export type PermissionGroupIndexQueryResult = Apollo.QueryResult<
	PermissionGroupIndexQuery,
	PermissionGroupIndexQueryVariables
>;
export const PermissionGroupNameDocument = gql`
	query permissionGroupName($id: ID!) {
		permissionGroup(id: $id) {
			id
			...PermissionGroupName
		}
	}
	${PermissionGroupNameFragmentDoc}
`;

/**
 * __usePermissionGroupNameQuery__
 *
 * To run a query within a React component, call `usePermissionGroupNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionGroupNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePermissionGroupNameQuery(
	baseOptions: Apollo.QueryHookOptions<PermissionGroupNameQuery, PermissionGroupNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionGroupNameQuery, PermissionGroupNameQueryVariables>(
		PermissionGroupNameDocument,
		options,
	);
}
export function usePermissionGroupNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionGroupNameQuery, PermissionGroupNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionGroupNameQuery, PermissionGroupNameQueryVariables>(
		PermissionGroupNameDocument,
		options,
	);
}
export function usePermissionGroupNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionGroupNameQuery, PermissionGroupNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionGroupNameQuery, PermissionGroupNameQueryVariables>(
		PermissionGroupNameDocument,
		options,
	);
}
export type PermissionGroupNameQueryHookResult = ReturnType<typeof usePermissionGroupNameQuery>;
export type PermissionGroupNameLazyQueryHookResult = ReturnType<typeof usePermissionGroupNameLazyQuery>;
export type PermissionGroupNameSuspenseQueryHookResult = ReturnType<typeof usePermissionGroupNameSuspenseQuery>;
export type PermissionGroupNameQueryResult = Apollo.QueryResult<
	PermissionGroupNameQuery,
	PermissionGroupNameQueryVariables
>;
export const PermissionGroupNamesDocument = gql`
	query permissionGroupNames(
		$filters: [PermissionGroupFilterInput!]
		$pagination: Pagination
		$order: PermissionGroupOrder
	) {
		permissionGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...PermissionGroupName
				}
			}
		}
	}
	${PermissionGroupNameFragmentDoc}
`;

/**
 * __usePermissionGroupNamesQuery__
 *
 * To run a query within a React component, call `usePermissionGroupNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionGroupNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionGroupNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionGroupNamesQuery, PermissionGroupNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionGroupNamesQuery, PermissionGroupNamesQueryVariables>(
		PermissionGroupNamesDocument,
		options,
	);
}
export function usePermissionGroupNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionGroupNamesQuery, PermissionGroupNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionGroupNamesQuery, PermissionGroupNamesQueryVariables>(
		PermissionGroupNamesDocument,
		options,
	);
}
export function usePermissionGroupNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionGroupNamesQuery, PermissionGroupNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionGroupNamesQuery, PermissionGroupNamesQueryVariables>(
		PermissionGroupNamesDocument,
		options,
	);
}
export type PermissionGroupNamesQueryHookResult = ReturnType<typeof usePermissionGroupNamesQuery>;
export type PermissionGroupNamesLazyQueryHookResult = ReturnType<typeof usePermissionGroupNamesLazyQuery>;
export type PermissionGroupNamesSuspenseQueryHookResult = ReturnType<typeof usePermissionGroupNamesSuspenseQuery>;
export type PermissionGroupNamesQueryResult = Apollo.QueryResult<
	PermissionGroupNamesQuery,
	PermissionGroupNamesQueryVariables
>;
export const PermissionGroupPaginationDocument = gql`
	query permissionGroupPagination($filters: [PermissionGroupFilterInput!], $order: PermissionGroupOrder) {
		permissionGroupConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __usePermissionGroupPaginationQuery__
 *
 * To run a query within a React component, call `usePermissionGroupPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionGroupPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionGroupPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionGroupPaginationQuery, PermissionGroupPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionGroupPaginationQuery, PermissionGroupPaginationQueryVariables>(
		PermissionGroupPaginationDocument,
		options,
	);
}
export function usePermissionGroupPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionGroupPaginationQuery, PermissionGroupPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionGroupPaginationQuery, PermissionGroupPaginationQueryVariables>(
		PermissionGroupPaginationDocument,
		options,
	);
}
export function usePermissionGroupPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		PermissionGroupPaginationQuery,
		PermissionGroupPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionGroupPaginationQuery, PermissionGroupPaginationQueryVariables>(
		PermissionGroupPaginationDocument,
		options,
	);
}
export type PermissionGroupPaginationQueryHookResult = ReturnType<typeof usePermissionGroupPaginationQuery>;
export type PermissionGroupPaginationLazyQueryHookResult = ReturnType<typeof usePermissionGroupPaginationLazyQuery>;
export type PermissionGroupPaginationSuspenseQueryHookResult = ReturnType<
	typeof usePermissionGroupPaginationSuspenseQuery
>;
export type PermissionGroupPaginationQueryResult = Apollo.QueryResult<
	PermissionGroupPaginationQuery,
	PermissionGroupPaginationQueryVariables
>;
export const PermissionGroupSelectDocument = gql`
	query permissionGroupSelect($filters: [PermissionGroupFilterInput!], $order: PermissionGroupOrder) {
		permissionGroupConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...PermissionGroupName
				}
			}
		}
	}
	${PermissionGroupNameFragmentDoc}
`;

/**
 * __usePermissionGroupSelectQuery__
 *
 * To run a query within a React component, call `usePermissionGroupSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionGroupSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionGroupSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionGroupSelectQuery, PermissionGroupSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionGroupSelectQuery, PermissionGroupSelectQueryVariables>(
		PermissionGroupSelectDocument,
		options,
	);
}
export function usePermissionGroupSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionGroupSelectQuery, PermissionGroupSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionGroupSelectQuery, PermissionGroupSelectQueryVariables>(
		PermissionGroupSelectDocument,
		options,
	);
}
export function usePermissionGroupSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionGroupSelectQuery, PermissionGroupSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionGroupSelectQuery, PermissionGroupSelectQueryVariables>(
		PermissionGroupSelectDocument,
		options,
	);
}
export type PermissionGroupSelectQueryHookResult = ReturnType<typeof usePermissionGroupSelectQuery>;
export type PermissionGroupSelectLazyQueryHookResult = ReturnType<typeof usePermissionGroupSelectLazyQuery>;
export type PermissionGroupSelectSuspenseQueryHookResult = ReturnType<typeof usePermissionGroupSelectSuspenseQuery>;
export type PermissionGroupSelectQueryResult = Apollo.QueryResult<
	PermissionGroupSelectQuery,
	PermissionGroupSelectQueryVariables
>;
export const PermissionGroupUpdateDocument = gql`
	mutation permissionGroupUpdate($id: ID!, $input: PermissionGroupUpdateInput!) {
		updatePermissionGroup(id: $id, input: $input) {
			...PermissionGroupDetail
		}
	}
	${PermissionGroupDetailFragmentDoc}
`;
export type PermissionGroupUpdateMutationFn = Apollo.MutationFunction<
	PermissionGroupUpdateMutation,
	PermissionGroupUpdateMutationVariables
>;

/**
 * __usePermissionGroupUpdateMutation__
 *
 * To run a mutation, you first call `usePermissionGroupUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [permissionGroupUpdateMutation, { data, loading, error }] = usePermissionGroupUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePermissionGroupUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<PermissionGroupUpdateMutation, PermissionGroupUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PermissionGroupUpdateMutation, PermissionGroupUpdateMutationVariables>(
		PermissionGroupUpdateDocument,
		options,
	);
}
export type PermissionGroupUpdateMutationHookResult = ReturnType<typeof usePermissionGroupUpdateMutation>;
export type PermissionGroupUpdateMutationResult = Apollo.MutationResult<PermissionGroupUpdateMutation>;
export type PermissionGroupUpdateMutationOptions = Apollo.BaseMutationOptions<
	PermissionGroupUpdateMutation,
	PermissionGroupUpdateMutationVariables
>;
export const PersonContactListDocument = gql`
	query personContactList($filters: [PersonFilterInput!], $pagination: Pagination, $order: PersonOrder) {
		personConnection(filters: $filters, pagination: $pagination, order: $order) {
			pageInfo {
				endCursor
				hasNextPage
			}
			edges {
				node {
					id
					...PersonName
					givenName
					familyName
					nameOrder
					imageURL
					imageKey
					imageContentType
					employee {
						id
						role
						jobTitle
					}
					guardian {
						id
					}
					student {
						id
						graduationYear
						yearsFromGraduation
					}
					user {
						id
						status
					}
					emailAddresses(order: { field: IS_PRIMARY, direction: DESC }) {
						id
						...EmailAddressName
						emailAddress
						isPrimary
					}
					phoneNumbers(order: { field: IS_PRIMARY, direction: DESC }) {
						id
						...PhoneNumberName
						phoneNumber
						isPrimary
					}
				}
			}
		}
	}
	${PersonNameFragmentDoc}
	${EmailAddressNameFragmentDoc}
	${PhoneNumberNameFragmentDoc}
`;

/**
 * __usePersonContactListQuery__
 *
 * To run a query within a React component, call `usePersonContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonContactListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePersonContactListQuery(
	baseOptions?: Apollo.QueryHookOptions<PersonContactListQuery, PersonContactListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PersonContactListQuery, PersonContactListQueryVariables>(PersonContactListDocument, options);
}
export function usePersonContactListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PersonContactListQuery, PersonContactListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PersonContactListQuery, PersonContactListQueryVariables>(
		PersonContactListDocument,
		options,
	);
}
export function usePersonContactListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PersonContactListQuery, PersonContactListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PersonContactListQuery, PersonContactListQueryVariables>(
		PersonContactListDocument,
		options,
	);
}
export type PersonContactListQueryHookResult = ReturnType<typeof usePersonContactListQuery>;
export type PersonContactListLazyQueryHookResult = ReturnType<typeof usePersonContactListLazyQuery>;
export type PersonContactListSuspenseQueryHookResult = ReturnType<typeof usePersonContactListSuspenseQuery>;
export type PersonContactListQueryResult = Apollo.QueryResult<PersonContactListQuery, PersonContactListQueryVariables>;
export const PersonContactDetailDocument = gql`
	query personContactDetail($id: ID!) {
		person(id: $id) {
			id
			...PersonName
			givenName
			familyName
			nameOrder
			imageURL
			imageKey
			imageContentType
			employee {
				id
				role
				jobTitle
			}
			guardian {
				id
			}
			student {
				id
				graduationYear
				yearsFromGraduation
			}
			user {
				id
				status
			}
			addresses {
				id
				...AddressInformation
			}
			emailAddresses(order: { field: IS_PRIMARY, direction: DESC }) {
				id
				...EmailAddressName
				emailAddress
				isPrimary
			}
			phoneNumbers(order: { field: IS_PRIMARY, direction: DESC }) {
				id
				...PhoneNumberName
				phoneNumber
				isPrimary
			}
		}
	}
	${PersonNameFragmentDoc}
	${AddressInformationFragmentDoc}
	${EmailAddressNameFragmentDoc}
	${PhoneNumberNameFragmentDoc}
`;

/**
 * __usePersonContactDetailQuery__
 *
 * To run a query within a React component, call `usePersonContactDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonContactDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonContactDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePersonContactDetailQuery(
	baseOptions: Apollo.QueryHookOptions<PersonContactDetailQuery, PersonContactDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PersonContactDetailQuery, PersonContactDetailQueryVariables>(
		PersonContactDetailDocument,
		options,
	);
}
export function usePersonContactDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PersonContactDetailQuery, PersonContactDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PersonContactDetailQuery, PersonContactDetailQueryVariables>(
		PersonContactDetailDocument,
		options,
	);
}
export function usePersonContactDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PersonContactDetailQuery, PersonContactDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PersonContactDetailQuery, PersonContactDetailQueryVariables>(
		PersonContactDetailDocument,
		options,
	);
}
export type PersonContactDetailQueryHookResult = ReturnType<typeof usePersonContactDetailQuery>;
export type PersonContactDetailLazyQueryHookResult = ReturnType<typeof usePersonContactDetailLazyQuery>;
export type PersonContactDetailSuspenseQueryHookResult = ReturnType<typeof usePersonContactDetailSuspenseQuery>;
export type PersonContactDetailQueryResult = Apollo.QueryResult<
	PersonContactDetailQuery,
	PersonContactDetailQueryVariables
>;
export const PersonCountDocument = gql`
	query personCount($filters: [PersonFilterInput!], $pagination: Pagination, $order: PersonOrder) {
		personConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __usePersonCountQuery__
 *
 * To run a query within a React component, call `usePersonCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePersonCountQuery(
	baseOptions?: Apollo.QueryHookOptions<PersonCountQuery, PersonCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PersonCountQuery, PersonCountQueryVariables>(PersonCountDocument, options);
}
export function usePersonCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PersonCountQuery, PersonCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PersonCountQuery, PersonCountQueryVariables>(PersonCountDocument, options);
}
export function usePersonCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PersonCountQuery, PersonCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PersonCountQuery, PersonCountQueryVariables>(PersonCountDocument, options);
}
export type PersonCountQueryHookResult = ReturnType<typeof usePersonCountQuery>;
export type PersonCountLazyQueryHookResult = ReturnType<typeof usePersonCountLazyQuery>;
export type PersonCountSuspenseQueryHookResult = ReturnType<typeof usePersonCountSuspenseQuery>;
export type PersonCountQueryResult = Apollo.QueryResult<PersonCountQuery, PersonCountQueryVariables>;
export const PersonCreateDocument = gql`
	mutation personCreate($input: PersonCreateInput!) {
		createPerson(input: $input) {
			...PersonDetail
		}
	}
	${PersonDetailFragmentDoc}
`;
export type PersonCreateMutationFn = Apollo.MutationFunction<PersonCreateMutation, PersonCreateMutationVariables>;

/**
 * __usePersonCreateMutation__
 *
 * To run a mutation, you first call `usePersonCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personCreateMutation, { data, loading, error }] = usePersonCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePersonCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<PersonCreateMutation, PersonCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PersonCreateMutation, PersonCreateMutationVariables>(PersonCreateDocument, options);
}
export type PersonCreateMutationHookResult = ReturnType<typeof usePersonCreateMutation>;
export type PersonCreateMutationResult = Apollo.MutationResult<PersonCreateMutation>;
export type PersonCreateMutationOptions = Apollo.BaseMutationOptions<
	PersonCreateMutation,
	PersonCreateMutationVariables
>;
export const PersonDeleteDocument = gql`
	mutation personDelete($id: ID!) {
		deletePerson(id: $id)
	}
`;
export type PersonDeleteMutationFn = Apollo.MutationFunction<PersonDeleteMutation, PersonDeleteMutationVariables>;

/**
 * __usePersonDeleteMutation__
 *
 * To run a mutation, you first call `usePersonDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personDeleteMutation, { data, loading, error }] = usePersonDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePersonDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<PersonDeleteMutation, PersonDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PersonDeleteMutation, PersonDeleteMutationVariables>(PersonDeleteDocument, options);
}
export type PersonDeleteMutationHookResult = ReturnType<typeof usePersonDeleteMutation>;
export type PersonDeleteMutationResult = Apollo.MutationResult<PersonDeleteMutation>;
export type PersonDeleteMutationOptions = Apollo.BaseMutationOptions<
	PersonDeleteMutation,
	PersonDeleteMutationVariables
>;
export const PersonDetailDocument = gql`
	query personDetail($id: ID!) {
		person(id: $id) {
			...PersonDetail
		}
	}
	${PersonDetailFragmentDoc}
`;

/**
 * __usePersonDetailQuery__
 *
 * To run a query within a React component, call `usePersonDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePersonDetailQuery(
	baseOptions: Apollo.QueryHookOptions<PersonDetailQuery, PersonDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PersonDetailQuery, PersonDetailQueryVariables>(PersonDetailDocument, options);
}
export function usePersonDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PersonDetailQuery, PersonDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PersonDetailQuery, PersonDetailQueryVariables>(PersonDetailDocument, options);
}
export function usePersonDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PersonDetailQuery, PersonDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PersonDetailQuery, PersonDetailQueryVariables>(PersonDetailDocument, options);
}
export type PersonDetailQueryHookResult = ReturnType<typeof usePersonDetailQuery>;
export type PersonDetailLazyQueryHookResult = ReturnType<typeof usePersonDetailLazyQuery>;
export type PersonDetailSuspenseQueryHookResult = ReturnType<typeof usePersonDetailSuspenseQuery>;
export type PersonDetailQueryResult = Apollo.QueryResult<PersonDetailQuery, PersonDetailQueryVariables>;
export const PersonIndexDocument = gql`
	query personIndex($filters: [PersonFilterInput!], $pagination: Pagination, $order: PersonOrder) {
		personConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					publicName
					givenName
					middleName
					familyName
					nameOrder
					nickname
					alternateNames
					publicNameFormat
					imageURL
					imageContentType
					gender
					dateOfBirth
					englishLanguageFluency
					occupation
					nationalIdentificationNumber
					governmentDocumentSeries
					governmentDocumentNumber
					governmentDocumentIssuedBy
				}
			}
		}
	}
`;

/**
 * __usePersonIndexQuery__
 *
 * To run a query within a React component, call `usePersonIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePersonIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<PersonIndexQuery, PersonIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PersonIndexQuery, PersonIndexQueryVariables>(PersonIndexDocument, options);
}
export function usePersonIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PersonIndexQuery, PersonIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PersonIndexQuery, PersonIndexQueryVariables>(PersonIndexDocument, options);
}
export function usePersonIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PersonIndexQuery, PersonIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PersonIndexQuery, PersonIndexQueryVariables>(PersonIndexDocument, options);
}
export type PersonIndexQueryHookResult = ReturnType<typeof usePersonIndexQuery>;
export type PersonIndexLazyQueryHookResult = ReturnType<typeof usePersonIndexLazyQuery>;
export type PersonIndexSuspenseQueryHookResult = ReturnType<typeof usePersonIndexSuspenseQuery>;
export type PersonIndexQueryResult = Apollo.QueryResult<PersonIndexQuery, PersonIndexQueryVariables>;
export const PersonNameDocument = gql`
	query personName($id: ID!) {
		person(id: $id) {
			id
			...PersonName
		}
	}
	${PersonNameFragmentDoc}
`;

/**
 * __usePersonNameQuery__
 *
 * To run a query within a React component, call `usePersonNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePersonNameQuery(baseOptions: Apollo.QueryHookOptions<PersonNameQuery, PersonNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PersonNameQuery, PersonNameQueryVariables>(PersonNameDocument, options);
}
export function usePersonNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PersonNameQuery, PersonNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PersonNameQuery, PersonNameQueryVariables>(PersonNameDocument, options);
}
export function usePersonNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PersonNameQuery, PersonNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PersonNameQuery, PersonNameQueryVariables>(PersonNameDocument, options);
}
export type PersonNameQueryHookResult = ReturnType<typeof usePersonNameQuery>;
export type PersonNameLazyQueryHookResult = ReturnType<typeof usePersonNameLazyQuery>;
export type PersonNameSuspenseQueryHookResult = ReturnType<typeof usePersonNameSuspenseQuery>;
export type PersonNameQueryResult = Apollo.QueryResult<PersonNameQuery, PersonNameQueryVariables>;
export const PersonNamesDocument = gql`
	query personNames($filters: [PersonFilterInput!], $pagination: Pagination, $order: PersonOrder) {
		personConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...PersonName
				}
			}
		}
	}
	${PersonNameFragmentDoc}
`;

/**
 * __usePersonNamesQuery__
 *
 * To run a query within a React component, call `usePersonNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePersonNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<PersonNamesQuery, PersonNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PersonNamesQuery, PersonNamesQueryVariables>(PersonNamesDocument, options);
}
export function usePersonNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PersonNamesQuery, PersonNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PersonNamesQuery, PersonNamesQueryVariables>(PersonNamesDocument, options);
}
export function usePersonNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PersonNamesQuery, PersonNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PersonNamesQuery, PersonNamesQueryVariables>(PersonNamesDocument, options);
}
export type PersonNamesQueryHookResult = ReturnType<typeof usePersonNamesQuery>;
export type PersonNamesLazyQueryHookResult = ReturnType<typeof usePersonNamesLazyQuery>;
export type PersonNamesSuspenseQueryHookResult = ReturnType<typeof usePersonNamesSuspenseQuery>;
export type PersonNamesQueryResult = Apollo.QueryResult<PersonNamesQuery, PersonNamesQueryVariables>;
export const PersonPaginationDocument = gql`
	query personPagination($filters: [PersonFilterInput!], $order: PersonOrder) {
		personConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __usePersonPaginationQuery__
 *
 * To run a query within a React component, call `usePersonPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePersonPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<PersonPaginationQuery, PersonPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PersonPaginationQuery, PersonPaginationQueryVariables>(PersonPaginationDocument, options);
}
export function usePersonPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PersonPaginationQuery, PersonPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PersonPaginationQuery, PersonPaginationQueryVariables>(PersonPaginationDocument, options);
}
export function usePersonPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PersonPaginationQuery, PersonPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PersonPaginationQuery, PersonPaginationQueryVariables>(
		PersonPaginationDocument,
		options,
	);
}
export type PersonPaginationQueryHookResult = ReturnType<typeof usePersonPaginationQuery>;
export type PersonPaginationLazyQueryHookResult = ReturnType<typeof usePersonPaginationLazyQuery>;
export type PersonPaginationSuspenseQueryHookResult = ReturnType<typeof usePersonPaginationSuspenseQuery>;
export type PersonPaginationQueryResult = Apollo.QueryResult<PersonPaginationQuery, PersonPaginationQueryVariables>;
export const PersonSelectDocument = gql`
	query personSelect($filters: [PersonFilterInput!], $order: PersonOrder) {
		personConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...PersonName
				}
			}
		}
	}
	${PersonNameFragmentDoc}
`;

/**
 * __usePersonSelectQuery__
 *
 * To run a query within a React component, call `usePersonSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePersonSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<PersonSelectQuery, PersonSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PersonSelectQuery, PersonSelectQueryVariables>(PersonSelectDocument, options);
}
export function usePersonSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PersonSelectQuery, PersonSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PersonSelectQuery, PersonSelectQueryVariables>(PersonSelectDocument, options);
}
export function usePersonSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PersonSelectQuery, PersonSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PersonSelectQuery, PersonSelectQueryVariables>(PersonSelectDocument, options);
}
export type PersonSelectQueryHookResult = ReturnType<typeof usePersonSelectQuery>;
export type PersonSelectLazyQueryHookResult = ReturnType<typeof usePersonSelectLazyQuery>;
export type PersonSelectSuspenseQueryHookResult = ReturnType<typeof usePersonSelectSuspenseQuery>;
export type PersonSelectQueryResult = Apollo.QueryResult<PersonSelectQuery, PersonSelectQueryVariables>;
export const PersonUpdateDocument = gql`
	mutation personUpdate($id: ID!, $input: PersonUpdateInput!) {
		updatePerson(id: $id, input: $input) {
			...PersonDetail
		}
	}
	${PersonDetailFragmentDoc}
`;
export type PersonUpdateMutationFn = Apollo.MutationFunction<PersonUpdateMutation, PersonUpdateMutationVariables>;

/**
 * __usePersonUpdateMutation__
 *
 * To run a mutation, you first call `usePersonUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personUpdateMutation, { data, loading, error }] = usePersonUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePersonUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<PersonUpdateMutation, PersonUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PersonUpdateMutation, PersonUpdateMutationVariables>(PersonUpdateDocument, options);
}
export type PersonUpdateMutationHookResult = ReturnType<typeof usePersonUpdateMutation>;
export type PersonUpdateMutationResult = Apollo.MutationResult<PersonUpdateMutation>;
export type PersonUpdateMutationOptions = Apollo.BaseMutationOptions<
	PersonUpdateMutation,
	PersonUpdateMutationVariables
>;
export const PhoneNumberCountDocument = gql`
	query phoneNumberCount($filters: [PhoneNumberFilterInput!], $pagination: Pagination, $order: PhoneNumberOrder) {
		phoneNumberConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __usePhoneNumberCountQuery__
 *
 * To run a query within a React component, call `usePhoneNumberCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhoneNumberCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhoneNumberCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePhoneNumberCountQuery(
	baseOptions?: Apollo.QueryHookOptions<PhoneNumberCountQuery, PhoneNumberCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PhoneNumberCountQuery, PhoneNumberCountQueryVariables>(PhoneNumberCountDocument, options);
}
export function usePhoneNumberCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PhoneNumberCountQuery, PhoneNumberCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PhoneNumberCountQuery, PhoneNumberCountQueryVariables>(PhoneNumberCountDocument, options);
}
export function usePhoneNumberCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PhoneNumberCountQuery, PhoneNumberCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PhoneNumberCountQuery, PhoneNumberCountQueryVariables>(
		PhoneNumberCountDocument,
		options,
	);
}
export type PhoneNumberCountQueryHookResult = ReturnType<typeof usePhoneNumberCountQuery>;
export type PhoneNumberCountLazyQueryHookResult = ReturnType<typeof usePhoneNumberCountLazyQuery>;
export type PhoneNumberCountSuspenseQueryHookResult = ReturnType<typeof usePhoneNumberCountSuspenseQuery>;
export type PhoneNumberCountQueryResult = Apollo.QueryResult<PhoneNumberCountQuery, PhoneNumberCountQueryVariables>;
export const PhoneNumberCreateDocument = gql`
	mutation phoneNumberCreate($input: PhoneNumberCreateInput!) {
		createPhoneNumber(input: $input) {
			...PhoneNumberDetail
		}
	}
	${PhoneNumberDetailFragmentDoc}
`;
export type PhoneNumberCreateMutationFn = Apollo.MutationFunction<
	PhoneNumberCreateMutation,
	PhoneNumberCreateMutationVariables
>;

/**
 * __usePhoneNumberCreateMutation__
 *
 * To run a mutation, you first call `usePhoneNumberCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePhoneNumberCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [phoneNumberCreateMutation, { data, loading, error }] = usePhoneNumberCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePhoneNumberCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<PhoneNumberCreateMutation, PhoneNumberCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PhoneNumberCreateMutation, PhoneNumberCreateMutationVariables>(
		PhoneNumberCreateDocument,
		options,
	);
}
export type PhoneNumberCreateMutationHookResult = ReturnType<typeof usePhoneNumberCreateMutation>;
export type PhoneNumberCreateMutationResult = Apollo.MutationResult<PhoneNumberCreateMutation>;
export type PhoneNumberCreateMutationOptions = Apollo.BaseMutationOptions<
	PhoneNumberCreateMutation,
	PhoneNumberCreateMutationVariables
>;
export const PhoneNumberDeleteDocument = gql`
	mutation phoneNumberDelete($id: ID!) {
		deletePhoneNumber(id: $id)
	}
`;
export type PhoneNumberDeleteMutationFn = Apollo.MutationFunction<
	PhoneNumberDeleteMutation,
	PhoneNumberDeleteMutationVariables
>;

/**
 * __usePhoneNumberDeleteMutation__
 *
 * To run a mutation, you first call `usePhoneNumberDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePhoneNumberDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [phoneNumberDeleteMutation, { data, loading, error }] = usePhoneNumberDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePhoneNumberDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<PhoneNumberDeleteMutation, PhoneNumberDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PhoneNumberDeleteMutation, PhoneNumberDeleteMutationVariables>(
		PhoneNumberDeleteDocument,
		options,
	);
}
export type PhoneNumberDeleteMutationHookResult = ReturnType<typeof usePhoneNumberDeleteMutation>;
export type PhoneNumberDeleteMutationResult = Apollo.MutationResult<PhoneNumberDeleteMutation>;
export type PhoneNumberDeleteMutationOptions = Apollo.BaseMutationOptions<
	PhoneNumberDeleteMutation,
	PhoneNumberDeleteMutationVariables
>;
export const PhoneNumberDetailDocument = gql`
	query phoneNumberDetail($id: ID!) {
		phoneNumber(id: $id) {
			...PhoneNumberDetail
		}
	}
	${PhoneNumberDetailFragmentDoc}
`;

/**
 * __usePhoneNumberDetailQuery__
 *
 * To run a query within a React component, call `usePhoneNumberDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhoneNumberDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhoneNumberDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePhoneNumberDetailQuery(
	baseOptions: Apollo.QueryHookOptions<PhoneNumberDetailQuery, PhoneNumberDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PhoneNumberDetailQuery, PhoneNumberDetailQueryVariables>(PhoneNumberDetailDocument, options);
}
export function usePhoneNumberDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PhoneNumberDetailQuery, PhoneNumberDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PhoneNumberDetailQuery, PhoneNumberDetailQueryVariables>(
		PhoneNumberDetailDocument,
		options,
	);
}
export function usePhoneNumberDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PhoneNumberDetailQuery, PhoneNumberDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PhoneNumberDetailQuery, PhoneNumberDetailQueryVariables>(
		PhoneNumberDetailDocument,
		options,
	);
}
export type PhoneNumberDetailQueryHookResult = ReturnType<typeof usePhoneNumberDetailQuery>;
export type PhoneNumberDetailLazyQueryHookResult = ReturnType<typeof usePhoneNumberDetailLazyQuery>;
export type PhoneNumberDetailSuspenseQueryHookResult = ReturnType<typeof usePhoneNumberDetailSuspenseQuery>;
export type PhoneNumberDetailQueryResult = Apollo.QueryResult<PhoneNumberDetailQuery, PhoneNumberDetailQueryVariables>;
export const PhoneNumberIndexDocument = gql`
	query phoneNumberIndex($filters: [PhoneNumberFilterInput!], $pagination: Pagination, $order: PhoneNumberOrder) {
		phoneNumberConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					phoneNumber
					isPrimary
				}
			}
		}
	}
`;

/**
 * __usePhoneNumberIndexQuery__
 *
 * To run a query within a React component, call `usePhoneNumberIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhoneNumberIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhoneNumberIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePhoneNumberIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<PhoneNumberIndexQuery, PhoneNumberIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PhoneNumberIndexQuery, PhoneNumberIndexQueryVariables>(PhoneNumberIndexDocument, options);
}
export function usePhoneNumberIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PhoneNumberIndexQuery, PhoneNumberIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PhoneNumberIndexQuery, PhoneNumberIndexQueryVariables>(PhoneNumberIndexDocument, options);
}
export function usePhoneNumberIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PhoneNumberIndexQuery, PhoneNumberIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PhoneNumberIndexQuery, PhoneNumberIndexQueryVariables>(
		PhoneNumberIndexDocument,
		options,
	);
}
export type PhoneNumberIndexQueryHookResult = ReturnType<typeof usePhoneNumberIndexQuery>;
export type PhoneNumberIndexLazyQueryHookResult = ReturnType<typeof usePhoneNumberIndexLazyQuery>;
export type PhoneNumberIndexSuspenseQueryHookResult = ReturnType<typeof usePhoneNumberIndexSuspenseQuery>;
export type PhoneNumberIndexQueryResult = Apollo.QueryResult<PhoneNumberIndexQuery, PhoneNumberIndexQueryVariables>;
export const PhoneNumberNameDocument = gql`
	query phoneNumberName($id: ID!) {
		phoneNumber(id: $id) {
			id
			...PhoneNumberName
		}
	}
	${PhoneNumberNameFragmentDoc}
`;

/**
 * __usePhoneNumberNameQuery__
 *
 * To run a query within a React component, call `usePhoneNumberNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhoneNumberNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhoneNumberNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePhoneNumberNameQuery(
	baseOptions: Apollo.QueryHookOptions<PhoneNumberNameQuery, PhoneNumberNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PhoneNumberNameQuery, PhoneNumberNameQueryVariables>(PhoneNumberNameDocument, options);
}
export function usePhoneNumberNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PhoneNumberNameQuery, PhoneNumberNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PhoneNumberNameQuery, PhoneNumberNameQueryVariables>(PhoneNumberNameDocument, options);
}
export function usePhoneNumberNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PhoneNumberNameQuery, PhoneNumberNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PhoneNumberNameQuery, PhoneNumberNameQueryVariables>(PhoneNumberNameDocument, options);
}
export type PhoneNumberNameQueryHookResult = ReturnType<typeof usePhoneNumberNameQuery>;
export type PhoneNumberNameLazyQueryHookResult = ReturnType<typeof usePhoneNumberNameLazyQuery>;
export type PhoneNumberNameSuspenseQueryHookResult = ReturnType<typeof usePhoneNumberNameSuspenseQuery>;
export type PhoneNumberNameQueryResult = Apollo.QueryResult<PhoneNumberNameQuery, PhoneNumberNameQueryVariables>;
export const PhoneNumberNamesDocument = gql`
	query phoneNumberNames($filters: [PhoneNumberFilterInput!], $pagination: Pagination, $order: PhoneNumberOrder) {
		phoneNumberConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...PhoneNumberName
				}
			}
		}
	}
	${PhoneNumberNameFragmentDoc}
`;

/**
 * __usePhoneNumberNamesQuery__
 *
 * To run a query within a React component, call `usePhoneNumberNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhoneNumberNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhoneNumberNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePhoneNumberNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<PhoneNumberNamesQuery, PhoneNumberNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PhoneNumberNamesQuery, PhoneNumberNamesQueryVariables>(PhoneNumberNamesDocument, options);
}
export function usePhoneNumberNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PhoneNumberNamesQuery, PhoneNumberNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PhoneNumberNamesQuery, PhoneNumberNamesQueryVariables>(PhoneNumberNamesDocument, options);
}
export function usePhoneNumberNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PhoneNumberNamesQuery, PhoneNumberNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PhoneNumberNamesQuery, PhoneNumberNamesQueryVariables>(
		PhoneNumberNamesDocument,
		options,
	);
}
export type PhoneNumberNamesQueryHookResult = ReturnType<typeof usePhoneNumberNamesQuery>;
export type PhoneNumberNamesLazyQueryHookResult = ReturnType<typeof usePhoneNumberNamesLazyQuery>;
export type PhoneNumberNamesSuspenseQueryHookResult = ReturnType<typeof usePhoneNumberNamesSuspenseQuery>;
export type PhoneNumberNamesQueryResult = Apollo.QueryResult<PhoneNumberNamesQuery, PhoneNumberNamesQueryVariables>;
export const PhoneNumberPaginationDocument = gql`
	query phoneNumberPagination($filters: [PhoneNumberFilterInput!], $order: PhoneNumberOrder) {
		phoneNumberConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __usePhoneNumberPaginationQuery__
 *
 * To run a query within a React component, call `usePhoneNumberPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhoneNumberPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhoneNumberPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePhoneNumberPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<PhoneNumberPaginationQuery, PhoneNumberPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PhoneNumberPaginationQuery, PhoneNumberPaginationQueryVariables>(
		PhoneNumberPaginationDocument,
		options,
	);
}
export function usePhoneNumberPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PhoneNumberPaginationQuery, PhoneNumberPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PhoneNumberPaginationQuery, PhoneNumberPaginationQueryVariables>(
		PhoneNumberPaginationDocument,
		options,
	);
}
export function usePhoneNumberPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PhoneNumberPaginationQuery, PhoneNumberPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PhoneNumberPaginationQuery, PhoneNumberPaginationQueryVariables>(
		PhoneNumberPaginationDocument,
		options,
	);
}
export type PhoneNumberPaginationQueryHookResult = ReturnType<typeof usePhoneNumberPaginationQuery>;
export type PhoneNumberPaginationLazyQueryHookResult = ReturnType<typeof usePhoneNumberPaginationLazyQuery>;
export type PhoneNumberPaginationSuspenseQueryHookResult = ReturnType<typeof usePhoneNumberPaginationSuspenseQuery>;
export type PhoneNumberPaginationQueryResult = Apollo.QueryResult<
	PhoneNumberPaginationQuery,
	PhoneNumberPaginationQueryVariables
>;
export const PhoneNumberSelectDocument = gql`
	query phoneNumberSelect($filters: [PhoneNumberFilterInput!], $order: PhoneNumberOrder) {
		phoneNumberConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...PhoneNumberName
				}
			}
		}
	}
	${PhoneNumberNameFragmentDoc}
`;

/**
 * __usePhoneNumberSelectQuery__
 *
 * To run a query within a React component, call `usePhoneNumberSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhoneNumberSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhoneNumberSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePhoneNumberSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<PhoneNumberSelectQuery, PhoneNumberSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PhoneNumberSelectQuery, PhoneNumberSelectQueryVariables>(PhoneNumberSelectDocument, options);
}
export function usePhoneNumberSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PhoneNumberSelectQuery, PhoneNumberSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PhoneNumberSelectQuery, PhoneNumberSelectQueryVariables>(
		PhoneNumberSelectDocument,
		options,
	);
}
export function usePhoneNumberSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PhoneNumberSelectQuery, PhoneNumberSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PhoneNumberSelectQuery, PhoneNumberSelectQueryVariables>(
		PhoneNumberSelectDocument,
		options,
	);
}
export type PhoneNumberSelectQueryHookResult = ReturnType<typeof usePhoneNumberSelectQuery>;
export type PhoneNumberSelectLazyQueryHookResult = ReturnType<typeof usePhoneNumberSelectLazyQuery>;
export type PhoneNumberSelectSuspenseQueryHookResult = ReturnType<typeof usePhoneNumberSelectSuspenseQuery>;
export type PhoneNumberSelectQueryResult = Apollo.QueryResult<PhoneNumberSelectQuery, PhoneNumberSelectQueryVariables>;
export const PhoneNumberUpdateDocument = gql`
	mutation phoneNumberUpdate($id: ID!, $input: PhoneNumberUpdateInput!) {
		updatePhoneNumber(id: $id, input: $input) {
			...PhoneNumberDetail
		}
	}
	${PhoneNumberDetailFragmentDoc}
`;
export type PhoneNumberUpdateMutationFn = Apollo.MutationFunction<
	PhoneNumberUpdateMutation,
	PhoneNumberUpdateMutationVariables
>;

/**
 * __usePhoneNumberUpdateMutation__
 *
 * To run a mutation, you first call `usePhoneNumberUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePhoneNumberUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [phoneNumberUpdateMutation, { data, loading, error }] = usePhoneNumberUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePhoneNumberUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<PhoneNumberUpdateMutation, PhoneNumberUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PhoneNumberUpdateMutation, PhoneNumberUpdateMutationVariables>(
		PhoneNumberUpdateDocument,
		options,
	);
}
export type PhoneNumberUpdateMutationHookResult = ReturnType<typeof usePhoneNumberUpdateMutation>;
export type PhoneNumberUpdateMutationResult = Apollo.MutationResult<PhoneNumberUpdateMutation>;
export type PhoneNumberUpdateMutationOptions = Apollo.BaseMutationOptions<
	PhoneNumberUpdateMutation,
	PhoneNumberUpdateMutationVariables
>;
export const PostCountDocument = gql`
	query postCount($filters: [PostFilterInput!], $pagination: Pagination, $order: PostOrder) {
		postConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __usePostCountQuery__
 *
 * To run a query within a React component, call `usePostCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePostCountQuery(baseOptions?: Apollo.QueryHookOptions<PostCountQuery, PostCountQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PostCountQuery, PostCountQueryVariables>(PostCountDocument, options);
}
export function usePostCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PostCountQuery, PostCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PostCountQuery, PostCountQueryVariables>(PostCountDocument, options);
}
export function usePostCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PostCountQuery, PostCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PostCountQuery, PostCountQueryVariables>(PostCountDocument, options);
}
export type PostCountQueryHookResult = ReturnType<typeof usePostCountQuery>;
export type PostCountLazyQueryHookResult = ReturnType<typeof usePostCountLazyQuery>;
export type PostCountSuspenseQueryHookResult = ReturnType<typeof usePostCountSuspenseQuery>;
export type PostCountQueryResult = Apollo.QueryResult<PostCountQuery, PostCountQueryVariables>;
export const PostCreateDocument = gql`
	mutation postCreate($input: PostCreateInput!) {
		createPost(input: $input) {
			...PostDetail
		}
	}
	${PostDetailFragmentDoc}
`;
export type PostCreateMutationFn = Apollo.MutationFunction<PostCreateMutation, PostCreateMutationVariables>;

/**
 * __usePostCreateMutation__
 *
 * To run a mutation, you first call `usePostCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postCreateMutation, { data, loading, error }] = usePostCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<PostCreateMutation, PostCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PostCreateMutation, PostCreateMutationVariables>(PostCreateDocument, options);
}
export type PostCreateMutationHookResult = ReturnType<typeof usePostCreateMutation>;
export type PostCreateMutationResult = Apollo.MutationResult<PostCreateMutation>;
export type PostCreateMutationOptions = Apollo.BaseMutationOptions<PostCreateMutation, PostCreateMutationVariables>;
export const PostDeleteDocument = gql`
	mutation postDelete($id: ID!) {
		deletePost(id: $id)
	}
`;
export type PostDeleteMutationFn = Apollo.MutationFunction<PostDeleteMutation, PostDeleteMutationVariables>;

/**
 * __usePostDeleteMutation__
 *
 * To run a mutation, you first call `usePostDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postDeleteMutation, { data, loading, error }] = usePostDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<PostDeleteMutation, PostDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PostDeleteMutation, PostDeleteMutationVariables>(PostDeleteDocument, options);
}
export type PostDeleteMutationHookResult = ReturnType<typeof usePostDeleteMutation>;
export type PostDeleteMutationResult = Apollo.MutationResult<PostDeleteMutation>;
export type PostDeleteMutationOptions = Apollo.BaseMutationOptions<PostDeleteMutation, PostDeleteMutationVariables>;
export const PostDetailDocument = gql`
	query postDetail($id: ID!) {
		post(id: $id) {
			...PostDetail
		}
	}
	${PostDetailFragmentDoc}
`;

/**
 * __usePostDetailQuery__
 *
 * To run a query within a React component, call `usePostDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostDetailQuery(baseOptions: Apollo.QueryHookOptions<PostDetailQuery, PostDetailQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PostDetailQuery, PostDetailQueryVariables>(PostDetailDocument, options);
}
export function usePostDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PostDetailQuery, PostDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PostDetailQuery, PostDetailQueryVariables>(PostDetailDocument, options);
}
export function usePostDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PostDetailQuery, PostDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PostDetailQuery, PostDetailQueryVariables>(PostDetailDocument, options);
}
export type PostDetailQueryHookResult = ReturnType<typeof usePostDetailQuery>;
export type PostDetailLazyQueryHookResult = ReturnType<typeof usePostDetailLazyQuery>;
export type PostDetailSuspenseQueryHookResult = ReturnType<typeof usePostDetailSuspenseQuery>;
export type PostDetailQueryResult = Apollo.QueryResult<PostDetailQuery, PostDetailQueryVariables>;
export const PostIndexDocument = gql`
	query postIndex($filters: [PostFilterInput!], $pagination: Pagination, $order: PostOrder) {
		postConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					title
					body
					author {
						id
						...UserName
					}
				}
			}
		}
	}
	${UserNameFragmentDoc}
`;

/**
 * __usePostIndexQuery__
 *
 * To run a query within a React component, call `usePostIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePostIndexQuery(baseOptions?: Apollo.QueryHookOptions<PostIndexQuery, PostIndexQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PostIndexQuery, PostIndexQueryVariables>(PostIndexDocument, options);
}
export function usePostIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PostIndexQuery, PostIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PostIndexQuery, PostIndexQueryVariables>(PostIndexDocument, options);
}
export function usePostIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PostIndexQuery, PostIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PostIndexQuery, PostIndexQueryVariables>(PostIndexDocument, options);
}
export type PostIndexQueryHookResult = ReturnType<typeof usePostIndexQuery>;
export type PostIndexLazyQueryHookResult = ReturnType<typeof usePostIndexLazyQuery>;
export type PostIndexSuspenseQueryHookResult = ReturnType<typeof usePostIndexSuspenseQuery>;
export type PostIndexQueryResult = Apollo.QueryResult<PostIndexQuery, PostIndexQueryVariables>;
export const PostNameDocument = gql`
	query postName($id: ID!) {
		post(id: $id) {
			id
			...PostName
		}
	}
	${PostNameFragmentDoc}
`;

/**
 * __usePostNameQuery__
 *
 * To run a query within a React component, call `usePostNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostNameQuery(baseOptions: Apollo.QueryHookOptions<PostNameQuery, PostNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PostNameQuery, PostNameQueryVariables>(PostNameDocument, options);
}
export function usePostNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostNameQuery, PostNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PostNameQuery, PostNameQueryVariables>(PostNameDocument, options);
}
export function usePostNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PostNameQuery, PostNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PostNameQuery, PostNameQueryVariables>(PostNameDocument, options);
}
export type PostNameQueryHookResult = ReturnType<typeof usePostNameQuery>;
export type PostNameLazyQueryHookResult = ReturnType<typeof usePostNameLazyQuery>;
export type PostNameSuspenseQueryHookResult = ReturnType<typeof usePostNameSuspenseQuery>;
export type PostNameQueryResult = Apollo.QueryResult<PostNameQuery, PostNameQueryVariables>;
export const PostNamesDocument = gql`
	query postNames($filters: [PostFilterInput!], $pagination: Pagination, $order: PostOrder) {
		postConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...PostName
				}
			}
		}
	}
	${PostNameFragmentDoc}
`;

/**
 * __usePostNamesQuery__
 *
 * To run a query within a React component, call `usePostNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePostNamesQuery(baseOptions?: Apollo.QueryHookOptions<PostNamesQuery, PostNamesQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PostNamesQuery, PostNamesQueryVariables>(PostNamesDocument, options);
}
export function usePostNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PostNamesQuery, PostNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PostNamesQuery, PostNamesQueryVariables>(PostNamesDocument, options);
}
export function usePostNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PostNamesQuery, PostNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PostNamesQuery, PostNamesQueryVariables>(PostNamesDocument, options);
}
export type PostNamesQueryHookResult = ReturnType<typeof usePostNamesQuery>;
export type PostNamesLazyQueryHookResult = ReturnType<typeof usePostNamesLazyQuery>;
export type PostNamesSuspenseQueryHookResult = ReturnType<typeof usePostNamesSuspenseQuery>;
export type PostNamesQueryResult = Apollo.QueryResult<PostNamesQuery, PostNamesQueryVariables>;
export const PostPaginationDocument = gql`
	query postPagination($filters: [PostFilterInput!], $order: PostOrder) {
		postConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __usePostPaginationQuery__
 *
 * To run a query within a React component, call `usePostPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePostPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<PostPaginationQuery, PostPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PostPaginationQuery, PostPaginationQueryVariables>(PostPaginationDocument, options);
}
export function usePostPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PostPaginationQuery, PostPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PostPaginationQuery, PostPaginationQueryVariables>(PostPaginationDocument, options);
}
export function usePostPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PostPaginationQuery, PostPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PostPaginationQuery, PostPaginationQueryVariables>(PostPaginationDocument, options);
}
export type PostPaginationQueryHookResult = ReturnType<typeof usePostPaginationQuery>;
export type PostPaginationLazyQueryHookResult = ReturnType<typeof usePostPaginationLazyQuery>;
export type PostPaginationSuspenseQueryHookResult = ReturnType<typeof usePostPaginationSuspenseQuery>;
export type PostPaginationQueryResult = Apollo.QueryResult<PostPaginationQuery, PostPaginationQueryVariables>;
export const PostSelectDocument = gql`
	query postSelect($filters: [PostFilterInput!], $order: PostOrder) {
		postConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...PostName
				}
			}
		}
	}
	${PostNameFragmentDoc}
`;

/**
 * __usePostSelectQuery__
 *
 * To run a query within a React component, call `usePostSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePostSelectQuery(baseOptions?: Apollo.QueryHookOptions<PostSelectQuery, PostSelectQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PostSelectQuery, PostSelectQueryVariables>(PostSelectDocument, options);
}
export function usePostSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PostSelectQuery, PostSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PostSelectQuery, PostSelectQueryVariables>(PostSelectDocument, options);
}
export function usePostSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PostSelectQuery, PostSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PostSelectQuery, PostSelectQueryVariables>(PostSelectDocument, options);
}
export type PostSelectQueryHookResult = ReturnType<typeof usePostSelectQuery>;
export type PostSelectLazyQueryHookResult = ReturnType<typeof usePostSelectLazyQuery>;
export type PostSelectSuspenseQueryHookResult = ReturnType<typeof usePostSelectSuspenseQuery>;
export type PostSelectQueryResult = Apollo.QueryResult<PostSelectQuery, PostSelectQueryVariables>;
export const PostSocialItemsDocument = gql`
	query postSocialItems($id: ID!) {
		post(id: $id) {
			id
			socialReactions(order: { field: CREATED_AT, direction: DESC }) {
				id
				reaction
				author {
					id
					...UserName
					isCurrent
				}
			}
			socialComments(order: { field: CREATED_AT, direction: DESC }) {
				id
				body
				createdAt
				author {
					id
					...UserNameAndImage
					isCurrent
				}
			}
		}
	}
	${UserNameFragmentDoc}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __usePostSocialItemsQuery__
 *
 * To run a query within a React component, call `usePostSocialItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostSocialItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostSocialItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostSocialItemsQuery(
	baseOptions: Apollo.QueryHookOptions<PostSocialItemsQuery, PostSocialItemsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PostSocialItemsQuery, PostSocialItemsQueryVariables>(PostSocialItemsDocument, options);
}
export function usePostSocialItemsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PostSocialItemsQuery, PostSocialItemsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PostSocialItemsQuery, PostSocialItemsQueryVariables>(PostSocialItemsDocument, options);
}
export function usePostSocialItemsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PostSocialItemsQuery, PostSocialItemsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PostSocialItemsQuery, PostSocialItemsQueryVariables>(PostSocialItemsDocument, options);
}
export type PostSocialItemsQueryHookResult = ReturnType<typeof usePostSocialItemsQuery>;
export type PostSocialItemsLazyQueryHookResult = ReturnType<typeof usePostSocialItemsLazyQuery>;
export type PostSocialItemsSuspenseQueryHookResult = ReturnType<typeof usePostSocialItemsSuspenseQuery>;
export type PostSocialItemsQueryResult = Apollo.QueryResult<PostSocialItemsQuery, PostSocialItemsQueryVariables>;
export const PostStatisticsDocument = gql`
	query postStatistics($filters: [PostFilterInput!]) {
		postStatistics(filters: $filters) {
			count
			views
			reactions
			comments
		}
	}
`;

/**
 * __usePostStatisticsQuery__
 *
 * To run a query within a React component, call `usePostStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostStatisticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePostStatisticsQuery(
	baseOptions?: Apollo.QueryHookOptions<PostStatisticsQuery, PostStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PostStatisticsQuery, PostStatisticsQueryVariables>(PostStatisticsDocument, options);
}
export function usePostStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PostStatisticsQuery, PostStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PostStatisticsQuery, PostStatisticsQueryVariables>(PostStatisticsDocument, options);
}
export function usePostStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PostStatisticsQuery, PostStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PostStatisticsQuery, PostStatisticsQueryVariables>(PostStatisticsDocument, options);
}
export type PostStatisticsQueryHookResult = ReturnType<typeof usePostStatisticsQuery>;
export type PostStatisticsLazyQueryHookResult = ReturnType<typeof usePostStatisticsLazyQuery>;
export type PostStatisticsSuspenseQueryHookResult = ReturnType<typeof usePostStatisticsSuspenseQuery>;
export type PostStatisticsQueryResult = Apollo.QueryResult<PostStatisticsQuery, PostStatisticsQueryVariables>;
export const PostUpdateDocument = gql`
	mutation postUpdate($id: ID!, $input: PostUpdateInput!) {
		updatePost(id: $id, input: $input) {
			...PostDetail
		}
	}
	${PostDetailFragmentDoc}
`;
export type PostUpdateMutationFn = Apollo.MutationFunction<PostUpdateMutation, PostUpdateMutationVariables>;

/**
 * __usePostUpdateMutation__
 *
 * To run a mutation, you first call `usePostUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postUpdateMutation, { data, loading, error }] = usePostUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<PostUpdateMutation, PostUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PostUpdateMutation, PostUpdateMutationVariables>(PostUpdateDocument, options);
}
export type PostUpdateMutationHookResult = ReturnType<typeof usePostUpdateMutation>;
export type PostUpdateMutationResult = Apollo.MutationResult<PostUpdateMutation>;
export type PostUpdateMutationOptions = Apollo.BaseMutationOptions<PostUpdateMutation, PostUpdateMutationVariables>;
export const QuotationCountDocument = gql`
	query quotationCount($filters: [QuotationFilterInput!], $pagination: Pagination, $order: QuotationOrder) {
		quotationConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useQuotationCountQuery__
 *
 * To run a query within a React component, call `useQuotationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotationCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useQuotationCountQuery(
	baseOptions?: Apollo.QueryHookOptions<QuotationCountQuery, QuotationCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<QuotationCountQuery, QuotationCountQueryVariables>(QuotationCountDocument, options);
}
export function useQuotationCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<QuotationCountQuery, QuotationCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<QuotationCountQuery, QuotationCountQueryVariables>(QuotationCountDocument, options);
}
export function useQuotationCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<QuotationCountQuery, QuotationCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<QuotationCountQuery, QuotationCountQueryVariables>(QuotationCountDocument, options);
}
export type QuotationCountQueryHookResult = ReturnType<typeof useQuotationCountQuery>;
export type QuotationCountLazyQueryHookResult = ReturnType<typeof useQuotationCountLazyQuery>;
export type QuotationCountSuspenseQueryHookResult = ReturnType<typeof useQuotationCountSuspenseQuery>;
export type QuotationCountQueryResult = Apollo.QueryResult<QuotationCountQuery, QuotationCountQueryVariables>;
export const QuotationCreateDocument = gql`
	mutation quotationCreate($input: QuotationCreateInput!) {
		createQuotation(input: $input) {
			...QuotationDetail
		}
	}
	${QuotationDetailFragmentDoc}
`;
export type QuotationCreateMutationFn = Apollo.MutationFunction<
	QuotationCreateMutation,
	QuotationCreateMutationVariables
>;

/**
 * __useQuotationCreateMutation__
 *
 * To run a mutation, you first call `useQuotationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuotationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quotationCreateMutation, { data, loading, error }] = useQuotationCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuotationCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<QuotationCreateMutation, QuotationCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<QuotationCreateMutation, QuotationCreateMutationVariables>(
		QuotationCreateDocument,
		options,
	);
}
export type QuotationCreateMutationHookResult = ReturnType<typeof useQuotationCreateMutation>;
export type QuotationCreateMutationResult = Apollo.MutationResult<QuotationCreateMutation>;
export type QuotationCreateMutationOptions = Apollo.BaseMutationOptions<
	QuotationCreateMutation,
	QuotationCreateMutationVariables
>;
export const DailyQuotationDocument = gql`
	query dailyQuotation($date: Date!) {
		dailyQuotation(date: $date) {
			...QuotationDetail
		}
	}
	${QuotationDetailFragmentDoc}
`;

/**
 * __useDailyQuotationQuery__
 *
 * To run a query within a React component, call `useDailyQuotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyQuotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyQuotationQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useDailyQuotationQuery(
	baseOptions: Apollo.QueryHookOptions<DailyQuotationQuery, DailyQuotationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<DailyQuotationQuery, DailyQuotationQueryVariables>(DailyQuotationDocument, options);
}
export function useDailyQuotationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<DailyQuotationQuery, DailyQuotationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<DailyQuotationQuery, DailyQuotationQueryVariables>(DailyQuotationDocument, options);
}
export function useDailyQuotationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<DailyQuotationQuery, DailyQuotationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<DailyQuotationQuery, DailyQuotationQueryVariables>(DailyQuotationDocument, options);
}
export type DailyQuotationQueryHookResult = ReturnType<typeof useDailyQuotationQuery>;
export type DailyQuotationLazyQueryHookResult = ReturnType<typeof useDailyQuotationLazyQuery>;
export type DailyQuotationSuspenseQueryHookResult = ReturnType<typeof useDailyQuotationSuspenseQuery>;
export type DailyQuotationQueryResult = Apollo.QueryResult<DailyQuotationQuery, DailyQuotationQueryVariables>;
export const QuotationDeleteDocument = gql`
	mutation quotationDelete($id: ID!) {
		deleteQuotation(id: $id)
	}
`;
export type QuotationDeleteMutationFn = Apollo.MutationFunction<
	QuotationDeleteMutation,
	QuotationDeleteMutationVariables
>;

/**
 * __useQuotationDeleteMutation__
 *
 * To run a mutation, you first call `useQuotationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuotationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quotationDeleteMutation, { data, loading, error }] = useQuotationDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuotationDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<QuotationDeleteMutation, QuotationDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<QuotationDeleteMutation, QuotationDeleteMutationVariables>(
		QuotationDeleteDocument,
		options,
	);
}
export type QuotationDeleteMutationHookResult = ReturnType<typeof useQuotationDeleteMutation>;
export type QuotationDeleteMutationResult = Apollo.MutationResult<QuotationDeleteMutation>;
export type QuotationDeleteMutationOptions = Apollo.BaseMutationOptions<
	QuotationDeleteMutation,
	QuotationDeleteMutationVariables
>;
export const QuotationDetailDocument = gql`
	query quotationDetail($id: ID!) {
		quotation(id: $id) {
			...QuotationDetail
		}
	}
	${QuotationDetailFragmentDoc}
`;

/**
 * __useQuotationDetailQuery__
 *
 * To run a query within a React component, call `useQuotationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotationDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuotationDetailQuery(
	baseOptions: Apollo.QueryHookOptions<QuotationDetailQuery, QuotationDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<QuotationDetailQuery, QuotationDetailQueryVariables>(QuotationDetailDocument, options);
}
export function useQuotationDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<QuotationDetailQuery, QuotationDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<QuotationDetailQuery, QuotationDetailQueryVariables>(QuotationDetailDocument, options);
}
export function useQuotationDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<QuotationDetailQuery, QuotationDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<QuotationDetailQuery, QuotationDetailQueryVariables>(QuotationDetailDocument, options);
}
export type QuotationDetailQueryHookResult = ReturnType<typeof useQuotationDetailQuery>;
export type QuotationDetailLazyQueryHookResult = ReturnType<typeof useQuotationDetailLazyQuery>;
export type QuotationDetailSuspenseQueryHookResult = ReturnType<typeof useQuotationDetailSuspenseQuery>;
export type QuotationDetailQueryResult = Apollo.QueryResult<QuotationDetailQuery, QuotationDetailQueryVariables>;
export const QuotationIndexDocument = gql`
	query quotationIndex($filters: [QuotationFilterInput!], $pagination: Pagination, $order: QuotationOrder) {
		quotationConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					body
					attribution
				}
			}
		}
	}
`;

/**
 * __useQuotationIndexQuery__
 *
 * To run a query within a React component, call `useQuotationIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotationIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotationIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useQuotationIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<QuotationIndexQuery, QuotationIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<QuotationIndexQuery, QuotationIndexQueryVariables>(QuotationIndexDocument, options);
}
export function useQuotationIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<QuotationIndexQuery, QuotationIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<QuotationIndexQuery, QuotationIndexQueryVariables>(QuotationIndexDocument, options);
}
export function useQuotationIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<QuotationIndexQuery, QuotationIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<QuotationIndexQuery, QuotationIndexQueryVariables>(QuotationIndexDocument, options);
}
export type QuotationIndexQueryHookResult = ReturnType<typeof useQuotationIndexQuery>;
export type QuotationIndexLazyQueryHookResult = ReturnType<typeof useQuotationIndexLazyQuery>;
export type QuotationIndexSuspenseQueryHookResult = ReturnType<typeof useQuotationIndexSuspenseQuery>;
export type QuotationIndexQueryResult = Apollo.QueryResult<QuotationIndexQuery, QuotationIndexQueryVariables>;
export const QuotationNameDocument = gql`
	query quotationName($id: ID!) {
		quotation(id: $id) {
			id
			...QuotationName
		}
	}
	${QuotationNameFragmentDoc}
`;

/**
 * __useQuotationNameQuery__
 *
 * To run a query within a React component, call `useQuotationNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotationNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotationNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuotationNameQuery(
	baseOptions: Apollo.QueryHookOptions<QuotationNameQuery, QuotationNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<QuotationNameQuery, QuotationNameQueryVariables>(QuotationNameDocument, options);
}
export function useQuotationNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<QuotationNameQuery, QuotationNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<QuotationNameQuery, QuotationNameQueryVariables>(QuotationNameDocument, options);
}
export function useQuotationNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<QuotationNameQuery, QuotationNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<QuotationNameQuery, QuotationNameQueryVariables>(QuotationNameDocument, options);
}
export type QuotationNameQueryHookResult = ReturnType<typeof useQuotationNameQuery>;
export type QuotationNameLazyQueryHookResult = ReturnType<typeof useQuotationNameLazyQuery>;
export type QuotationNameSuspenseQueryHookResult = ReturnType<typeof useQuotationNameSuspenseQuery>;
export type QuotationNameQueryResult = Apollo.QueryResult<QuotationNameQuery, QuotationNameQueryVariables>;
export const QuotationNamesDocument = gql`
	query quotationNames($filters: [QuotationFilterInput!], $pagination: Pagination, $order: QuotationOrder) {
		quotationConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...QuotationName
				}
			}
		}
	}
	${QuotationNameFragmentDoc}
`;

/**
 * __useQuotationNamesQuery__
 *
 * To run a query within a React component, call `useQuotationNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotationNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotationNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useQuotationNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<QuotationNamesQuery, QuotationNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<QuotationNamesQuery, QuotationNamesQueryVariables>(QuotationNamesDocument, options);
}
export function useQuotationNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<QuotationNamesQuery, QuotationNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<QuotationNamesQuery, QuotationNamesQueryVariables>(QuotationNamesDocument, options);
}
export function useQuotationNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<QuotationNamesQuery, QuotationNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<QuotationNamesQuery, QuotationNamesQueryVariables>(QuotationNamesDocument, options);
}
export type QuotationNamesQueryHookResult = ReturnType<typeof useQuotationNamesQuery>;
export type QuotationNamesLazyQueryHookResult = ReturnType<typeof useQuotationNamesLazyQuery>;
export type QuotationNamesSuspenseQueryHookResult = ReturnType<typeof useQuotationNamesSuspenseQuery>;
export type QuotationNamesQueryResult = Apollo.QueryResult<QuotationNamesQuery, QuotationNamesQueryVariables>;
export const QuotationPaginationDocument = gql`
	query quotationPagination($filters: [QuotationFilterInput!], $order: QuotationOrder) {
		quotationConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useQuotationPaginationQuery__
 *
 * To run a query within a React component, call `useQuotationPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotationPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotationPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useQuotationPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<QuotationPaginationQuery, QuotationPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<QuotationPaginationQuery, QuotationPaginationQueryVariables>(
		QuotationPaginationDocument,
		options,
	);
}
export function useQuotationPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<QuotationPaginationQuery, QuotationPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<QuotationPaginationQuery, QuotationPaginationQueryVariables>(
		QuotationPaginationDocument,
		options,
	);
}
export function useQuotationPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<QuotationPaginationQuery, QuotationPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<QuotationPaginationQuery, QuotationPaginationQueryVariables>(
		QuotationPaginationDocument,
		options,
	);
}
export type QuotationPaginationQueryHookResult = ReturnType<typeof useQuotationPaginationQuery>;
export type QuotationPaginationLazyQueryHookResult = ReturnType<typeof useQuotationPaginationLazyQuery>;
export type QuotationPaginationSuspenseQueryHookResult = ReturnType<typeof useQuotationPaginationSuspenseQuery>;
export type QuotationPaginationQueryResult = Apollo.QueryResult<
	QuotationPaginationQuery,
	QuotationPaginationQueryVariables
>;
export const QuotationSelectDocument = gql`
	query quotationSelect($filters: [QuotationFilterInput!], $order: QuotationOrder) {
		quotationConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...QuotationName
				}
			}
		}
	}
	${QuotationNameFragmentDoc}
`;

/**
 * __useQuotationSelectQuery__
 *
 * To run a query within a React component, call `useQuotationSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotationSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotationSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useQuotationSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<QuotationSelectQuery, QuotationSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<QuotationSelectQuery, QuotationSelectQueryVariables>(QuotationSelectDocument, options);
}
export function useQuotationSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<QuotationSelectQuery, QuotationSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<QuotationSelectQuery, QuotationSelectQueryVariables>(QuotationSelectDocument, options);
}
export function useQuotationSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<QuotationSelectQuery, QuotationSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<QuotationSelectQuery, QuotationSelectQueryVariables>(QuotationSelectDocument, options);
}
export type QuotationSelectQueryHookResult = ReturnType<typeof useQuotationSelectQuery>;
export type QuotationSelectLazyQueryHookResult = ReturnType<typeof useQuotationSelectLazyQuery>;
export type QuotationSelectSuspenseQueryHookResult = ReturnType<typeof useQuotationSelectSuspenseQuery>;
export type QuotationSelectQueryResult = Apollo.QueryResult<QuotationSelectQuery, QuotationSelectQueryVariables>;
export const QuotationUpdateDocument = gql`
	mutation quotationUpdate($id: ID!, $input: QuotationUpdateInput!) {
		updateQuotation(id: $id, input: $input) {
			...QuotationDetail
		}
	}
	${QuotationDetailFragmentDoc}
`;
export type QuotationUpdateMutationFn = Apollo.MutationFunction<
	QuotationUpdateMutation,
	QuotationUpdateMutationVariables
>;

/**
 * __useQuotationUpdateMutation__
 *
 * To run a mutation, you first call `useQuotationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuotationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quotationUpdateMutation, { data, loading, error }] = useQuotationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuotationUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<QuotationUpdateMutation, QuotationUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<QuotationUpdateMutation, QuotationUpdateMutationVariables>(
		QuotationUpdateDocument,
		options,
	);
}
export type QuotationUpdateMutationHookResult = ReturnType<typeof useQuotationUpdateMutation>;
export type QuotationUpdateMutationResult = Apollo.MutationResult<QuotationUpdateMutation>;
export type QuotationUpdateMutationOptions = Apollo.BaseMutationOptions<
	QuotationUpdateMutation,
	QuotationUpdateMutationVariables
>;
export const RefundCountDocument = gql`
	query refundCount($filters: [RefundFilterInput!], $pagination: Pagination, $order: RefundOrder) {
		refundConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useRefundCountQuery__
 *
 * To run a query within a React component, call `useRefundCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRefundCountQuery(
	baseOptions?: Apollo.QueryHookOptions<RefundCountQuery, RefundCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RefundCountQuery, RefundCountQueryVariables>(RefundCountDocument, options);
}
export function useRefundCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RefundCountQuery, RefundCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RefundCountQuery, RefundCountQueryVariables>(RefundCountDocument, options);
}
export function useRefundCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RefundCountQuery, RefundCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RefundCountQuery, RefundCountQueryVariables>(RefundCountDocument, options);
}
export type RefundCountQueryHookResult = ReturnType<typeof useRefundCountQuery>;
export type RefundCountLazyQueryHookResult = ReturnType<typeof useRefundCountLazyQuery>;
export type RefundCountSuspenseQueryHookResult = ReturnType<typeof useRefundCountSuspenseQuery>;
export type RefundCountQueryResult = Apollo.QueryResult<RefundCountQuery, RefundCountQueryVariables>;
export const RefundCreateDocument = gql`
	mutation refundCreate($input: RefundCreateInput!) {
		createRefund(input: $input) {
			...RefundDetail
		}
	}
	${RefundDetailFragmentDoc}
`;
export type RefundCreateMutationFn = Apollo.MutationFunction<RefundCreateMutation, RefundCreateMutationVariables>;

/**
 * __useRefundCreateMutation__
 *
 * To run a mutation, you first call `useRefundCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundCreateMutation, { data, loading, error }] = useRefundCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefundCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<RefundCreateMutation, RefundCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RefundCreateMutation, RefundCreateMutationVariables>(RefundCreateDocument, options);
}
export type RefundCreateMutationHookResult = ReturnType<typeof useRefundCreateMutation>;
export type RefundCreateMutationResult = Apollo.MutationResult<RefundCreateMutation>;
export type RefundCreateMutationOptions = Apollo.BaseMutationOptions<
	RefundCreateMutation,
	RefundCreateMutationVariables
>;
export const RefundDeleteDocument = gql`
	mutation refundDelete($id: ID!) {
		deleteRefund(id: $id)
	}
`;
export type RefundDeleteMutationFn = Apollo.MutationFunction<RefundDeleteMutation, RefundDeleteMutationVariables>;

/**
 * __useRefundDeleteMutation__
 *
 * To run a mutation, you first call `useRefundDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundDeleteMutation, { data, loading, error }] = useRefundDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefundDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<RefundDeleteMutation, RefundDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RefundDeleteMutation, RefundDeleteMutationVariables>(RefundDeleteDocument, options);
}
export type RefundDeleteMutationHookResult = ReturnType<typeof useRefundDeleteMutation>;
export type RefundDeleteMutationResult = Apollo.MutationResult<RefundDeleteMutation>;
export type RefundDeleteMutationOptions = Apollo.BaseMutationOptions<
	RefundDeleteMutation,
	RefundDeleteMutationVariables
>;
export const RefundDetailDocument = gql`
	query refundDetail($id: ID!) {
		refund(id: $id) {
			...RefundDetail
		}
	}
	${RefundDetailFragmentDoc}
`;

/**
 * __useRefundDetailQuery__
 *
 * To run a query within a React component, call `useRefundDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefundDetailQuery(
	baseOptions: Apollo.QueryHookOptions<RefundDetailQuery, RefundDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RefundDetailQuery, RefundDetailQueryVariables>(RefundDetailDocument, options);
}
export function useRefundDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RefundDetailQuery, RefundDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RefundDetailQuery, RefundDetailQueryVariables>(RefundDetailDocument, options);
}
export function useRefundDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RefundDetailQuery, RefundDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RefundDetailQuery, RefundDetailQueryVariables>(RefundDetailDocument, options);
}
export type RefundDetailQueryHookResult = ReturnType<typeof useRefundDetailQuery>;
export type RefundDetailLazyQueryHookResult = ReturnType<typeof useRefundDetailLazyQuery>;
export type RefundDetailSuspenseQueryHookResult = ReturnType<typeof useRefundDetailSuspenseQuery>;
export type RefundDetailQueryResult = Apollo.QueryResult<RefundDetailQuery, RefundDetailQueryVariables>;
export const RefundIndexDocument = gql`
	query refundIndex($filters: [RefundFilterInput!], $pagination: Pagination, $order: RefundOrder) {
		refundConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					issueDate
					amount
					localAmount
					isInLocalCurrency
					localCurrency
					notes
				}
			}
		}
	}
`;

/**
 * __useRefundIndexQuery__
 *
 * To run a query within a React component, call `useRefundIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRefundIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<RefundIndexQuery, RefundIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RefundIndexQuery, RefundIndexQueryVariables>(RefundIndexDocument, options);
}
export function useRefundIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RefundIndexQuery, RefundIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RefundIndexQuery, RefundIndexQueryVariables>(RefundIndexDocument, options);
}
export function useRefundIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RefundIndexQuery, RefundIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RefundIndexQuery, RefundIndexQueryVariables>(RefundIndexDocument, options);
}
export type RefundIndexQueryHookResult = ReturnType<typeof useRefundIndexQuery>;
export type RefundIndexLazyQueryHookResult = ReturnType<typeof useRefundIndexLazyQuery>;
export type RefundIndexSuspenseQueryHookResult = ReturnType<typeof useRefundIndexSuspenseQuery>;
export type RefundIndexQueryResult = Apollo.QueryResult<RefundIndexQuery, RefundIndexQueryVariables>;
export const RefundNameDocument = gql`
	query refundName($id: ID!) {
		refund(id: $id) {
			id
			...RefundName
		}
	}
	${RefundNameFragmentDoc}
`;

/**
 * __useRefundNameQuery__
 *
 * To run a query within a React component, call `useRefundNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefundNameQuery(baseOptions: Apollo.QueryHookOptions<RefundNameQuery, RefundNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RefundNameQuery, RefundNameQueryVariables>(RefundNameDocument, options);
}
export function useRefundNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RefundNameQuery, RefundNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RefundNameQuery, RefundNameQueryVariables>(RefundNameDocument, options);
}
export function useRefundNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RefundNameQuery, RefundNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RefundNameQuery, RefundNameQueryVariables>(RefundNameDocument, options);
}
export type RefundNameQueryHookResult = ReturnType<typeof useRefundNameQuery>;
export type RefundNameLazyQueryHookResult = ReturnType<typeof useRefundNameLazyQuery>;
export type RefundNameSuspenseQueryHookResult = ReturnType<typeof useRefundNameSuspenseQuery>;
export type RefundNameQueryResult = Apollo.QueryResult<RefundNameQuery, RefundNameQueryVariables>;
export const RefundNamesDocument = gql`
	query refundNames($filters: [RefundFilterInput!], $pagination: Pagination, $order: RefundOrder) {
		refundConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...RefundName
				}
			}
		}
	}
	${RefundNameFragmentDoc}
`;

/**
 * __useRefundNamesQuery__
 *
 * To run a query within a React component, call `useRefundNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRefundNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<RefundNamesQuery, RefundNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RefundNamesQuery, RefundNamesQueryVariables>(RefundNamesDocument, options);
}
export function useRefundNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RefundNamesQuery, RefundNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RefundNamesQuery, RefundNamesQueryVariables>(RefundNamesDocument, options);
}
export function useRefundNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RefundNamesQuery, RefundNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RefundNamesQuery, RefundNamesQueryVariables>(RefundNamesDocument, options);
}
export type RefundNamesQueryHookResult = ReturnType<typeof useRefundNamesQuery>;
export type RefundNamesLazyQueryHookResult = ReturnType<typeof useRefundNamesLazyQuery>;
export type RefundNamesSuspenseQueryHookResult = ReturnType<typeof useRefundNamesSuspenseQuery>;
export type RefundNamesQueryResult = Apollo.QueryResult<RefundNamesQuery, RefundNamesQueryVariables>;
export const RefundPaginationDocument = gql`
	query refundPagination($filters: [RefundFilterInput!], $order: RefundOrder) {
		refundConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useRefundPaginationQuery__
 *
 * To run a query within a React component, call `useRefundPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRefundPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<RefundPaginationQuery, RefundPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RefundPaginationQuery, RefundPaginationQueryVariables>(RefundPaginationDocument, options);
}
export function useRefundPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RefundPaginationQuery, RefundPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RefundPaginationQuery, RefundPaginationQueryVariables>(RefundPaginationDocument, options);
}
export function useRefundPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RefundPaginationQuery, RefundPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RefundPaginationQuery, RefundPaginationQueryVariables>(
		RefundPaginationDocument,
		options,
	);
}
export type RefundPaginationQueryHookResult = ReturnType<typeof useRefundPaginationQuery>;
export type RefundPaginationLazyQueryHookResult = ReturnType<typeof useRefundPaginationLazyQuery>;
export type RefundPaginationSuspenseQueryHookResult = ReturnType<typeof useRefundPaginationSuspenseQuery>;
export type RefundPaginationQueryResult = Apollo.QueryResult<RefundPaginationQuery, RefundPaginationQueryVariables>;
export const RefundSelectDocument = gql`
	query refundSelect($filters: [RefundFilterInput!], $order: RefundOrder) {
		refundConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...RefundName
				}
			}
		}
	}
	${RefundNameFragmentDoc}
`;

/**
 * __useRefundSelectQuery__
 *
 * To run a query within a React component, call `useRefundSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRefundSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<RefundSelectQuery, RefundSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RefundSelectQuery, RefundSelectQueryVariables>(RefundSelectDocument, options);
}
export function useRefundSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RefundSelectQuery, RefundSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RefundSelectQuery, RefundSelectQueryVariables>(RefundSelectDocument, options);
}
export function useRefundSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RefundSelectQuery, RefundSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RefundSelectQuery, RefundSelectQueryVariables>(RefundSelectDocument, options);
}
export type RefundSelectQueryHookResult = ReturnType<typeof useRefundSelectQuery>;
export type RefundSelectLazyQueryHookResult = ReturnType<typeof useRefundSelectLazyQuery>;
export type RefundSelectSuspenseQueryHookResult = ReturnType<typeof useRefundSelectSuspenseQuery>;
export type RefundSelectQueryResult = Apollo.QueryResult<RefundSelectQuery, RefundSelectQueryVariables>;
export const RefundUpdateDocument = gql`
	mutation refundUpdate($id: ID!, $input: RefundUpdateInput!) {
		updateRefund(id: $id, input: $input) {
			...RefundDetail
		}
	}
	${RefundDetailFragmentDoc}
`;
export type RefundUpdateMutationFn = Apollo.MutationFunction<RefundUpdateMutation, RefundUpdateMutationVariables>;

/**
 * __useRefundUpdateMutation__
 *
 * To run a mutation, you first call `useRefundUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundUpdateMutation, { data, loading, error }] = useRefundUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefundUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<RefundUpdateMutation, RefundUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RefundUpdateMutation, RefundUpdateMutationVariables>(RefundUpdateDocument, options);
}
export type RefundUpdateMutationHookResult = ReturnType<typeof useRefundUpdateMutation>;
export type RefundUpdateMutationResult = Apollo.MutationResult<RefundUpdateMutation>;
export type RefundUpdateMutationOptions = Apollo.BaseMutationOptions<
	RefundUpdateMutation,
	RefundUpdateMutationVariables
>;
export const RelationshipCountDocument = gql`
	query relationshipCount($filters: [RelationshipFilterInput!], $pagination: Pagination, $order: RelationshipOrder) {
		relationshipConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useRelationshipCountQuery__
 *
 * To run a query within a React component, call `useRelationshipCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelationshipCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelationshipCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRelationshipCountQuery(
	baseOptions?: Apollo.QueryHookOptions<RelationshipCountQuery, RelationshipCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RelationshipCountQuery, RelationshipCountQueryVariables>(RelationshipCountDocument, options);
}
export function useRelationshipCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RelationshipCountQuery, RelationshipCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RelationshipCountQuery, RelationshipCountQueryVariables>(
		RelationshipCountDocument,
		options,
	);
}
export function useRelationshipCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RelationshipCountQuery, RelationshipCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RelationshipCountQuery, RelationshipCountQueryVariables>(
		RelationshipCountDocument,
		options,
	);
}
export type RelationshipCountQueryHookResult = ReturnType<typeof useRelationshipCountQuery>;
export type RelationshipCountLazyQueryHookResult = ReturnType<typeof useRelationshipCountLazyQuery>;
export type RelationshipCountSuspenseQueryHookResult = ReturnType<typeof useRelationshipCountSuspenseQuery>;
export type RelationshipCountQueryResult = Apollo.QueryResult<RelationshipCountQuery, RelationshipCountQueryVariables>;
export const RelationshipCreateDocument = gql`
	mutation relationshipCreate($input: RelationshipCreateInput!) {
		createRelationship(input: $input) {
			...RelationshipDetail
		}
	}
	${RelationshipDetailFragmentDoc}
`;
export type RelationshipCreateMutationFn = Apollo.MutationFunction<
	RelationshipCreateMutation,
	RelationshipCreateMutationVariables
>;

/**
 * __useRelationshipCreateMutation__
 *
 * To run a mutation, you first call `useRelationshipCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRelationshipCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [relationshipCreateMutation, { data, loading, error }] = useRelationshipCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRelationshipCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<RelationshipCreateMutation, RelationshipCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RelationshipCreateMutation, RelationshipCreateMutationVariables>(
		RelationshipCreateDocument,
		options,
	);
}
export type RelationshipCreateMutationHookResult = ReturnType<typeof useRelationshipCreateMutation>;
export type RelationshipCreateMutationResult = Apollo.MutationResult<RelationshipCreateMutation>;
export type RelationshipCreateMutationOptions = Apollo.BaseMutationOptions<
	RelationshipCreateMutation,
	RelationshipCreateMutationVariables
>;
export const RelationshipDeleteDocument = gql`
	mutation relationshipDelete($id: ID!) {
		deleteRelationship(id: $id)
	}
`;
export type RelationshipDeleteMutationFn = Apollo.MutationFunction<
	RelationshipDeleteMutation,
	RelationshipDeleteMutationVariables
>;

/**
 * __useRelationshipDeleteMutation__
 *
 * To run a mutation, you first call `useRelationshipDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRelationshipDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [relationshipDeleteMutation, { data, loading, error }] = useRelationshipDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRelationshipDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<RelationshipDeleteMutation, RelationshipDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RelationshipDeleteMutation, RelationshipDeleteMutationVariables>(
		RelationshipDeleteDocument,
		options,
	);
}
export type RelationshipDeleteMutationHookResult = ReturnType<typeof useRelationshipDeleteMutation>;
export type RelationshipDeleteMutationResult = Apollo.MutationResult<RelationshipDeleteMutation>;
export type RelationshipDeleteMutationOptions = Apollo.BaseMutationOptions<
	RelationshipDeleteMutation,
	RelationshipDeleteMutationVariables
>;
export const RelationshipDetailDocument = gql`
	query relationshipDetail($id: ID!) {
		relationship(id: $id) {
			...RelationshipDetail
		}
	}
	${RelationshipDetailFragmentDoc}
`;

/**
 * __useRelationshipDetailQuery__
 *
 * To run a query within a React component, call `useRelationshipDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelationshipDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelationshipDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRelationshipDetailQuery(
	baseOptions: Apollo.QueryHookOptions<RelationshipDetailQuery, RelationshipDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RelationshipDetailQuery, RelationshipDetailQueryVariables>(
		RelationshipDetailDocument,
		options,
	);
}
export function useRelationshipDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RelationshipDetailQuery, RelationshipDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RelationshipDetailQuery, RelationshipDetailQueryVariables>(
		RelationshipDetailDocument,
		options,
	);
}
export function useRelationshipDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RelationshipDetailQuery, RelationshipDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RelationshipDetailQuery, RelationshipDetailQueryVariables>(
		RelationshipDetailDocument,
		options,
	);
}
export type RelationshipDetailQueryHookResult = ReturnType<typeof useRelationshipDetailQuery>;
export type RelationshipDetailLazyQueryHookResult = ReturnType<typeof useRelationshipDetailLazyQuery>;
export type RelationshipDetailSuspenseQueryHookResult = ReturnType<typeof useRelationshipDetailSuspenseQuery>;
export type RelationshipDetailQueryResult = Apollo.QueryResult<
	RelationshipDetailQuery,
	RelationshipDetailQueryVariables
>;
export const RelationshipIndexDocument = gql`
	query relationshipIndex($filters: [RelationshipFilterInput!], $pagination: Pagination, $order: RelationshipOrder) {
		relationshipConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					relationshipType
					isPrimary
					isFinancialContact
					isEmergencyContact
					isAuthorizedForPickup
					livesWithStudent
					hasCustody
				}
			}
		}
	}
`;

/**
 * __useRelationshipIndexQuery__
 *
 * To run a query within a React component, call `useRelationshipIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelationshipIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelationshipIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRelationshipIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<RelationshipIndexQuery, RelationshipIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RelationshipIndexQuery, RelationshipIndexQueryVariables>(RelationshipIndexDocument, options);
}
export function useRelationshipIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RelationshipIndexQuery, RelationshipIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RelationshipIndexQuery, RelationshipIndexQueryVariables>(
		RelationshipIndexDocument,
		options,
	);
}
export function useRelationshipIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RelationshipIndexQuery, RelationshipIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RelationshipIndexQuery, RelationshipIndexQueryVariables>(
		RelationshipIndexDocument,
		options,
	);
}
export type RelationshipIndexQueryHookResult = ReturnType<typeof useRelationshipIndexQuery>;
export type RelationshipIndexLazyQueryHookResult = ReturnType<typeof useRelationshipIndexLazyQuery>;
export type RelationshipIndexSuspenseQueryHookResult = ReturnType<typeof useRelationshipIndexSuspenseQuery>;
export type RelationshipIndexQueryResult = Apollo.QueryResult<RelationshipIndexQuery, RelationshipIndexQueryVariables>;
export const RelationshipNameDocument = gql`
	query relationshipName($id: ID!) {
		relationship(id: $id) {
			id
			...RelationshipName
		}
	}
	${RelationshipNameFragmentDoc}
`;

/**
 * __useRelationshipNameQuery__
 *
 * To run a query within a React component, call `useRelationshipNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelationshipNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelationshipNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRelationshipNameQuery(
	baseOptions: Apollo.QueryHookOptions<RelationshipNameQuery, RelationshipNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RelationshipNameQuery, RelationshipNameQueryVariables>(RelationshipNameDocument, options);
}
export function useRelationshipNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RelationshipNameQuery, RelationshipNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RelationshipNameQuery, RelationshipNameQueryVariables>(RelationshipNameDocument, options);
}
export function useRelationshipNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RelationshipNameQuery, RelationshipNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RelationshipNameQuery, RelationshipNameQueryVariables>(
		RelationshipNameDocument,
		options,
	);
}
export type RelationshipNameQueryHookResult = ReturnType<typeof useRelationshipNameQuery>;
export type RelationshipNameLazyQueryHookResult = ReturnType<typeof useRelationshipNameLazyQuery>;
export type RelationshipNameSuspenseQueryHookResult = ReturnType<typeof useRelationshipNameSuspenseQuery>;
export type RelationshipNameQueryResult = Apollo.QueryResult<RelationshipNameQuery, RelationshipNameQueryVariables>;
export const RelationshipNamesDocument = gql`
	query relationshipNames($filters: [RelationshipFilterInput!], $pagination: Pagination, $order: RelationshipOrder) {
		relationshipConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...RelationshipName
				}
			}
		}
	}
	${RelationshipNameFragmentDoc}
`;

/**
 * __useRelationshipNamesQuery__
 *
 * To run a query within a React component, call `useRelationshipNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelationshipNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelationshipNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRelationshipNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<RelationshipNamesQuery, RelationshipNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RelationshipNamesQuery, RelationshipNamesQueryVariables>(RelationshipNamesDocument, options);
}
export function useRelationshipNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RelationshipNamesQuery, RelationshipNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RelationshipNamesQuery, RelationshipNamesQueryVariables>(
		RelationshipNamesDocument,
		options,
	);
}
export function useRelationshipNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RelationshipNamesQuery, RelationshipNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RelationshipNamesQuery, RelationshipNamesQueryVariables>(
		RelationshipNamesDocument,
		options,
	);
}
export type RelationshipNamesQueryHookResult = ReturnType<typeof useRelationshipNamesQuery>;
export type RelationshipNamesLazyQueryHookResult = ReturnType<typeof useRelationshipNamesLazyQuery>;
export type RelationshipNamesSuspenseQueryHookResult = ReturnType<typeof useRelationshipNamesSuspenseQuery>;
export type RelationshipNamesQueryResult = Apollo.QueryResult<RelationshipNamesQuery, RelationshipNamesQueryVariables>;
export const RelationshipPaginationDocument = gql`
	query relationshipPagination($filters: [RelationshipFilterInput!], $order: RelationshipOrder) {
		relationshipConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useRelationshipPaginationQuery__
 *
 * To run a query within a React component, call `useRelationshipPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelationshipPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelationshipPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRelationshipPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<RelationshipPaginationQuery, RelationshipPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RelationshipPaginationQuery, RelationshipPaginationQueryVariables>(
		RelationshipPaginationDocument,
		options,
	);
}
export function useRelationshipPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RelationshipPaginationQuery, RelationshipPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RelationshipPaginationQuery, RelationshipPaginationQueryVariables>(
		RelationshipPaginationDocument,
		options,
	);
}
export function useRelationshipPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RelationshipPaginationQuery, RelationshipPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RelationshipPaginationQuery, RelationshipPaginationQueryVariables>(
		RelationshipPaginationDocument,
		options,
	);
}
export type RelationshipPaginationQueryHookResult = ReturnType<typeof useRelationshipPaginationQuery>;
export type RelationshipPaginationLazyQueryHookResult = ReturnType<typeof useRelationshipPaginationLazyQuery>;
export type RelationshipPaginationSuspenseQueryHookResult = ReturnType<typeof useRelationshipPaginationSuspenseQuery>;
export type RelationshipPaginationQueryResult = Apollo.QueryResult<
	RelationshipPaginationQuery,
	RelationshipPaginationQueryVariables
>;
export const RelationshipSelectDocument = gql`
	query relationshipSelect($filters: [RelationshipFilterInput!], $order: RelationshipOrder) {
		relationshipConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...RelationshipName
				}
			}
		}
	}
	${RelationshipNameFragmentDoc}
`;

/**
 * __useRelationshipSelectQuery__
 *
 * To run a query within a React component, call `useRelationshipSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelationshipSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelationshipSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRelationshipSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<RelationshipSelectQuery, RelationshipSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RelationshipSelectQuery, RelationshipSelectQueryVariables>(
		RelationshipSelectDocument,
		options,
	);
}
export function useRelationshipSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RelationshipSelectQuery, RelationshipSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RelationshipSelectQuery, RelationshipSelectQueryVariables>(
		RelationshipSelectDocument,
		options,
	);
}
export function useRelationshipSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RelationshipSelectQuery, RelationshipSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RelationshipSelectQuery, RelationshipSelectQueryVariables>(
		RelationshipSelectDocument,
		options,
	);
}
export type RelationshipSelectQueryHookResult = ReturnType<typeof useRelationshipSelectQuery>;
export type RelationshipSelectLazyQueryHookResult = ReturnType<typeof useRelationshipSelectLazyQuery>;
export type RelationshipSelectSuspenseQueryHookResult = ReturnType<typeof useRelationshipSelectSuspenseQuery>;
export type RelationshipSelectQueryResult = Apollo.QueryResult<
	RelationshipSelectQuery,
	RelationshipSelectQueryVariables
>;
export const RelationshipUpdateDocument = gql`
	mutation relationshipUpdate($id: ID!, $input: RelationshipUpdateInput!) {
		updateRelationship(id: $id, input: $input) {
			...RelationshipDetail
		}
	}
	${RelationshipDetailFragmentDoc}
`;
export type RelationshipUpdateMutationFn = Apollo.MutationFunction<
	RelationshipUpdateMutation,
	RelationshipUpdateMutationVariables
>;

/**
 * __useRelationshipUpdateMutation__
 *
 * To run a mutation, you first call `useRelationshipUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRelationshipUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [relationshipUpdateMutation, { data, loading, error }] = useRelationshipUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRelationshipUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<RelationshipUpdateMutation, RelationshipUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RelationshipUpdateMutation, RelationshipUpdateMutationVariables>(
		RelationshipUpdateDocument,
		options,
	);
}
export type RelationshipUpdateMutationHookResult = ReturnType<typeof useRelationshipUpdateMutation>;
export type RelationshipUpdateMutationResult = Apollo.MutationResult<RelationshipUpdateMutation>;
export type RelationshipUpdateMutationOptions = Apollo.BaseMutationOptions<
	RelationshipUpdateMutation,
	RelationshipUpdateMutationVariables
>;
export const ReportCardCountDocument = gql`
	query reportCardCount($filters: [ReportCardFilterInput!], $pagination: Pagination, $order: ReportCardOrder) {
		reportCardConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useReportCardCountQuery__
 *
 * To run a query within a React component, call `useReportCardCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardCountQuery(
	baseOptions?: Apollo.QueryHookOptions<ReportCardCountQuery, ReportCardCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardCountQuery, ReportCardCountQueryVariables>(ReportCardCountDocument, options);
}
export function useReportCardCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ReportCardCountQuery, ReportCardCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardCountQuery, ReportCardCountQueryVariables>(ReportCardCountDocument, options);
}
export function useReportCardCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ReportCardCountQuery, ReportCardCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardCountQuery, ReportCardCountQueryVariables>(ReportCardCountDocument, options);
}
export type ReportCardCountQueryHookResult = ReturnType<typeof useReportCardCountQuery>;
export type ReportCardCountLazyQueryHookResult = ReturnType<typeof useReportCardCountLazyQuery>;
export type ReportCardCountSuspenseQueryHookResult = ReturnType<typeof useReportCardCountSuspenseQuery>;
export type ReportCardCountQueryResult = Apollo.QueryResult<ReportCardCountQuery, ReportCardCountQueryVariables>;
export const ReportCardCreateDocument = gql`
	mutation reportCardCreate($input: ReportCardCreateInput!) {
		createReportCard(input: $input) {
			...ReportCardDetail
		}
	}
	${ReportCardDetailFragmentDoc}
`;
export type ReportCardCreateMutationFn = Apollo.MutationFunction<
	ReportCardCreateMutation,
	ReportCardCreateMutationVariables
>;

/**
 * __useReportCardCreateMutation__
 *
 * To run a mutation, you first call `useReportCardCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCardCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCardCreateMutation, { data, loading, error }] = useReportCardCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportCardCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<ReportCardCreateMutation, ReportCardCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ReportCardCreateMutation, ReportCardCreateMutationVariables>(
		ReportCardCreateDocument,
		options,
	);
}
export type ReportCardCreateMutationHookResult = ReturnType<typeof useReportCardCreateMutation>;
export type ReportCardCreateMutationResult = Apollo.MutationResult<ReportCardCreateMutation>;
export type ReportCardCreateMutationOptions = Apollo.BaseMutationOptions<
	ReportCardCreateMutation,
	ReportCardCreateMutationVariables
>;
export const ReportCardDeleteDocument = gql`
	mutation reportCardDelete($id: ID!) {
		deleteReportCard(id: $id)
	}
`;
export type ReportCardDeleteMutationFn = Apollo.MutationFunction<
	ReportCardDeleteMutation,
	ReportCardDeleteMutationVariables
>;

/**
 * __useReportCardDeleteMutation__
 *
 * To run a mutation, you first call `useReportCardDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCardDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCardDeleteMutation, { data, loading, error }] = useReportCardDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportCardDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<ReportCardDeleteMutation, ReportCardDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ReportCardDeleteMutation, ReportCardDeleteMutationVariables>(
		ReportCardDeleteDocument,
		options,
	);
}
export type ReportCardDeleteMutationHookResult = ReturnType<typeof useReportCardDeleteMutation>;
export type ReportCardDeleteMutationResult = Apollo.MutationResult<ReportCardDeleteMutation>;
export type ReportCardDeleteMutationOptions = Apollo.BaseMutationOptions<
	ReportCardDeleteMutation,
	ReportCardDeleteMutationVariables
>;
export const ReportCardDetailDocument = gql`
	query reportCardDetail($id: ID!) {
		reportCard(id: $id) {
			...ReportCardDetail
		}
	}
	${ReportCardDetailFragmentDoc}
`;

/**
 * __useReportCardDetailQuery__
 *
 * To run a query within a React component, call `useReportCardDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportCardDetailQuery(
	baseOptions: Apollo.QueryHookOptions<ReportCardDetailQuery, ReportCardDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardDetailQuery, ReportCardDetailQueryVariables>(ReportCardDetailDocument, options);
}
export function useReportCardDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ReportCardDetailQuery, ReportCardDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardDetailQuery, ReportCardDetailQueryVariables>(ReportCardDetailDocument, options);
}
export function useReportCardDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ReportCardDetailQuery, ReportCardDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardDetailQuery, ReportCardDetailQueryVariables>(
		ReportCardDetailDocument,
		options,
	);
}
export type ReportCardDetailQueryHookResult = ReturnType<typeof useReportCardDetailQuery>;
export type ReportCardDetailLazyQueryHookResult = ReturnType<typeof useReportCardDetailLazyQuery>;
export type ReportCardDetailSuspenseQueryHookResult = ReturnType<typeof useReportCardDetailSuspenseQuery>;
export type ReportCardDetailQueryResult = Apollo.QueryResult<ReportCardDetailQuery, ReportCardDetailQueryVariables>;
export const ReportCardDisplayDocument = gql`
	query reportCardDisplay($id: ID!) {
		reportCardConnection(filters: { idEQ: $id }) {
			edges {
				node {
					id
					isComplete
					releaseDate
					student {
						id
						...StudentNameAndImage
						graduationYear
						yearsFromGraduation
					}
					academicTerm {
						id
						...AcademicTermName
						academicYear {
							id
							...AcademicYearName
						}
					}
					reportCardSections {
						id
						...ReportCardSectionDisplay
					}
				}
			}
		}
		learningObjectiveCategoryConnection(
			filters: {
				learningObjectives: { reportCardSectionLearningObjectives: { reportCardSection: { reportCardIDEQ: $id } } }
			}
		) {
			edges {
				node {
					id
					...LearningObjectiveCategoryName
					markingSystem {
						id
						markValues(order: { field: VALUE, direction: ASC }) {
							id
							...MarkValueName
						}
					}
				}
			}
		}
	}
	${StudentNameAndImageFragmentDoc}
	${AcademicTermNameFragmentDoc}
	${AcademicYearNameFragmentDoc}
	${ReportCardSectionDisplayFragmentDoc}
	${LearningObjectiveCategoryNameFragmentDoc}
	${MarkValueNameFragmentDoc}
`;

/**
 * __useReportCardDisplayQuery__
 *
 * To run a query within a React component, call `useReportCardDisplayQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardDisplayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardDisplayQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportCardDisplayQuery(
	baseOptions: Apollo.QueryHookOptions<ReportCardDisplayQuery, ReportCardDisplayQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardDisplayQuery, ReportCardDisplayQueryVariables>(ReportCardDisplayDocument, options);
}
export function useReportCardDisplayLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ReportCardDisplayQuery, ReportCardDisplayQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardDisplayQuery, ReportCardDisplayQueryVariables>(
		ReportCardDisplayDocument,
		options,
	);
}
export function useReportCardDisplaySuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ReportCardDisplayQuery, ReportCardDisplayQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardDisplayQuery, ReportCardDisplayQueryVariables>(
		ReportCardDisplayDocument,
		options,
	);
}
export type ReportCardDisplayQueryHookResult = ReturnType<typeof useReportCardDisplayQuery>;
export type ReportCardDisplayLazyQueryHookResult = ReturnType<typeof useReportCardDisplayLazyQuery>;
export type ReportCardDisplaySuspenseQueryHookResult = ReturnType<typeof useReportCardDisplaySuspenseQuery>;
export type ReportCardDisplayQueryResult = Apollo.QueryResult<ReportCardDisplayQuery, ReportCardDisplayQueryVariables>;
export const ReportCardSectionsDisplayDocument = gql`
	query reportCardSectionsDisplay($filters: [ReportCardSectionFilterInput!]) {
		reportCardSectionConnection(filters: $filters) {
			edges {
				node {
					id
					...ReportCardSectionDisplay
				}
			}
		}
		learningObjectiveCategoryConnection(
			filters: { learningObjectives: { reportCardSectionLearningObjectives: { reportCardSection: $filters } } }
		) {
			edges {
				node {
					id
					...LearningObjectiveCategoryName
					markingSystem {
						id
						markValues(order: { field: VALUE, direction: ASC }) {
							id
							...MarkValueName
						}
					}
				}
			}
		}
	}
	${ReportCardSectionDisplayFragmentDoc}
	${LearningObjectiveCategoryNameFragmentDoc}
	${MarkValueNameFragmentDoc}
`;

/**
 * __useReportCardSectionsDisplayQuery__
 *
 * To run a query within a React component, call `useReportCardSectionsDisplayQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionsDisplayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionsDisplayQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useReportCardSectionsDisplayQuery(
	baseOptions?: Apollo.QueryHookOptions<ReportCardSectionsDisplayQuery, ReportCardSectionsDisplayQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardSectionsDisplayQuery, ReportCardSectionsDisplayQueryVariables>(
		ReportCardSectionsDisplayDocument,
		options,
	);
}
export function useReportCardSectionsDisplayLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ReportCardSectionsDisplayQuery, ReportCardSectionsDisplayQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardSectionsDisplayQuery, ReportCardSectionsDisplayQueryVariables>(
		ReportCardSectionsDisplayDocument,
		options,
	);
}
export function useReportCardSectionsDisplaySuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionsDisplayQuery,
		ReportCardSectionsDisplayQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardSectionsDisplayQuery, ReportCardSectionsDisplayQueryVariables>(
		ReportCardSectionsDisplayDocument,
		options,
	);
}
export type ReportCardSectionsDisplayQueryHookResult = ReturnType<typeof useReportCardSectionsDisplayQuery>;
export type ReportCardSectionsDisplayLazyQueryHookResult = ReturnType<typeof useReportCardSectionsDisplayLazyQuery>;
export type ReportCardSectionsDisplaySuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionsDisplaySuspenseQuery
>;
export type ReportCardSectionsDisplayQueryResult = Apollo.QueryResult<
	ReportCardSectionsDisplayQuery,
	ReportCardSectionsDisplayQueryVariables
>;
export const ReportCardIndexDocument = gql`
	query reportCardIndex($filters: [ReportCardFilterInput!], $pagination: Pagination, $order: ReportCardOrder) {
		reportCardConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					isComplete
					releaseDate
					isReleased
					fileURL
					fileContentType
					student {
						id
						...StudentNameAndImage
					}
					academicTerm {
						id
						...AcademicTermName
					}
				}
			}
		}
	}
	${StudentNameAndImageFragmentDoc}
	${AcademicTermNameFragmentDoc}
`;

/**
 * __useReportCardIndexQuery__
 *
 * To run a query within a React component, call `useReportCardIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<ReportCardIndexQuery, ReportCardIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardIndexQuery, ReportCardIndexQueryVariables>(ReportCardIndexDocument, options);
}
export function useReportCardIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ReportCardIndexQuery, ReportCardIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardIndexQuery, ReportCardIndexQueryVariables>(ReportCardIndexDocument, options);
}
export function useReportCardIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ReportCardIndexQuery, ReportCardIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardIndexQuery, ReportCardIndexQueryVariables>(ReportCardIndexDocument, options);
}
export type ReportCardIndexQueryHookResult = ReturnType<typeof useReportCardIndexQuery>;
export type ReportCardIndexLazyQueryHookResult = ReturnType<typeof useReportCardIndexLazyQuery>;
export type ReportCardIndexSuspenseQueryHookResult = ReturnType<typeof useReportCardIndexSuspenseQuery>;
export type ReportCardIndexQueryResult = Apollo.QueryResult<ReportCardIndexQuery, ReportCardIndexQueryVariables>;
export const ReportCardNameDocument = gql`
	query reportCardName($id: ID!) {
		reportCard(id: $id) {
			id
			...ReportCardName
		}
	}
	${ReportCardNameFragmentDoc}
`;

/**
 * __useReportCardNameQuery__
 *
 * To run a query within a React component, call `useReportCardNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportCardNameQuery(
	baseOptions: Apollo.QueryHookOptions<ReportCardNameQuery, ReportCardNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardNameQuery, ReportCardNameQueryVariables>(ReportCardNameDocument, options);
}
export function useReportCardNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ReportCardNameQuery, ReportCardNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardNameQuery, ReportCardNameQueryVariables>(ReportCardNameDocument, options);
}
export function useReportCardNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ReportCardNameQuery, ReportCardNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardNameQuery, ReportCardNameQueryVariables>(ReportCardNameDocument, options);
}
export type ReportCardNameQueryHookResult = ReturnType<typeof useReportCardNameQuery>;
export type ReportCardNameLazyQueryHookResult = ReturnType<typeof useReportCardNameLazyQuery>;
export type ReportCardNameSuspenseQueryHookResult = ReturnType<typeof useReportCardNameSuspenseQuery>;
export type ReportCardNameQueryResult = Apollo.QueryResult<ReportCardNameQuery, ReportCardNameQueryVariables>;
export const ReportCardNamesDocument = gql`
	query reportCardNames($filters: [ReportCardFilterInput!], $pagination: Pagination, $order: ReportCardOrder) {
		reportCardConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...ReportCardName
				}
			}
		}
	}
	${ReportCardNameFragmentDoc}
`;

/**
 * __useReportCardNamesQuery__
 *
 * To run a query within a React component, call `useReportCardNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<ReportCardNamesQuery, ReportCardNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardNamesQuery, ReportCardNamesQueryVariables>(ReportCardNamesDocument, options);
}
export function useReportCardNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ReportCardNamesQuery, ReportCardNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardNamesQuery, ReportCardNamesQueryVariables>(ReportCardNamesDocument, options);
}
export function useReportCardNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ReportCardNamesQuery, ReportCardNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardNamesQuery, ReportCardNamesQueryVariables>(ReportCardNamesDocument, options);
}
export type ReportCardNamesQueryHookResult = ReturnType<typeof useReportCardNamesQuery>;
export type ReportCardNamesLazyQueryHookResult = ReturnType<typeof useReportCardNamesLazyQuery>;
export type ReportCardNamesSuspenseQueryHookResult = ReturnType<typeof useReportCardNamesSuspenseQuery>;
export type ReportCardNamesQueryResult = Apollo.QueryResult<ReportCardNamesQuery, ReportCardNamesQueryVariables>;
export const ReportCardPaginationDocument = gql`
	query reportCardPagination($filters: [ReportCardFilterInput!], $order: ReportCardOrder) {
		reportCardConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useReportCardPaginationQuery__
 *
 * To run a query within a React component, call `useReportCardPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<ReportCardPaginationQuery, ReportCardPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardPaginationQuery, ReportCardPaginationQueryVariables>(
		ReportCardPaginationDocument,
		options,
	);
}
export function useReportCardPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ReportCardPaginationQuery, ReportCardPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardPaginationQuery, ReportCardPaginationQueryVariables>(
		ReportCardPaginationDocument,
		options,
	);
}
export function useReportCardPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ReportCardPaginationQuery, ReportCardPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardPaginationQuery, ReportCardPaginationQueryVariables>(
		ReportCardPaginationDocument,
		options,
	);
}
export type ReportCardPaginationQueryHookResult = ReturnType<typeof useReportCardPaginationQuery>;
export type ReportCardPaginationLazyQueryHookResult = ReturnType<typeof useReportCardPaginationLazyQuery>;
export type ReportCardPaginationSuspenseQueryHookResult = ReturnType<typeof useReportCardPaginationSuspenseQuery>;
export type ReportCardPaginationQueryResult = Apollo.QueryResult<
	ReportCardPaginationQuery,
	ReportCardPaginationQueryVariables
>;
export const ReportCardSelectDocument = gql`
	query reportCardSelect($filters: [ReportCardFilterInput!], $order: ReportCardOrder) {
		reportCardConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...ReportCardName
				}
			}
		}
	}
	${ReportCardNameFragmentDoc}
`;

/**
 * __useReportCardSelectQuery__
 *
 * To run a query within a React component, call `useReportCardSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<ReportCardSelectQuery, ReportCardSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardSelectQuery, ReportCardSelectQueryVariables>(ReportCardSelectDocument, options);
}
export function useReportCardSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ReportCardSelectQuery, ReportCardSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardSelectQuery, ReportCardSelectQueryVariables>(ReportCardSelectDocument, options);
}
export function useReportCardSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ReportCardSelectQuery, ReportCardSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardSelectQuery, ReportCardSelectQueryVariables>(
		ReportCardSelectDocument,
		options,
	);
}
export type ReportCardSelectQueryHookResult = ReturnType<typeof useReportCardSelectQuery>;
export type ReportCardSelectLazyQueryHookResult = ReturnType<typeof useReportCardSelectLazyQuery>;
export type ReportCardSelectSuspenseQueryHookResult = ReturnType<typeof useReportCardSelectSuspenseQuery>;
export type ReportCardSelectQueryResult = Apollo.QueryResult<ReportCardSelectQuery, ReportCardSelectQueryVariables>;
export const ReportCardUpdateDocument = gql`
	mutation reportCardUpdate($id: ID!, $input: ReportCardUpdateInput!) {
		updateReportCard(id: $id, input: $input) {
			...ReportCardDetail
		}
	}
	${ReportCardDetailFragmentDoc}
`;
export type ReportCardUpdateMutationFn = Apollo.MutationFunction<
	ReportCardUpdateMutation,
	ReportCardUpdateMutationVariables
>;

/**
 * __useReportCardUpdateMutation__
 *
 * To run a mutation, you first call `useReportCardUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCardUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCardUpdateMutation, { data, loading, error }] = useReportCardUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportCardUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<ReportCardUpdateMutation, ReportCardUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ReportCardUpdateMutation, ReportCardUpdateMutationVariables>(
		ReportCardUpdateDocument,
		options,
	);
}
export type ReportCardUpdateMutationHookResult = ReturnType<typeof useReportCardUpdateMutation>;
export type ReportCardUpdateMutationResult = Apollo.MutationResult<ReportCardUpdateMutation>;
export type ReportCardUpdateMutationOptions = Apollo.BaseMutationOptions<
	ReportCardUpdateMutation,
	ReportCardUpdateMutationVariables
>;
export const ReportCardSectionCountDocument = gql`
	query reportCardSectionCount(
		$filters: [ReportCardSectionFilterInput!]
		$pagination: Pagination
		$order: ReportCardSectionOrder
	) {
		reportCardSectionConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useReportCardSectionCountQuery__
 *
 * To run a query within a React component, call `useReportCardSectionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardSectionCountQuery(
	baseOptions?: Apollo.QueryHookOptions<ReportCardSectionCountQuery, ReportCardSectionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardSectionCountQuery, ReportCardSectionCountQueryVariables>(
		ReportCardSectionCountDocument,
		options,
	);
}
export function useReportCardSectionCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ReportCardSectionCountQuery, ReportCardSectionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardSectionCountQuery, ReportCardSectionCountQueryVariables>(
		ReportCardSectionCountDocument,
		options,
	);
}
export function useReportCardSectionCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ReportCardSectionCountQuery, ReportCardSectionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardSectionCountQuery, ReportCardSectionCountQueryVariables>(
		ReportCardSectionCountDocument,
		options,
	);
}
export type ReportCardSectionCountQueryHookResult = ReturnType<typeof useReportCardSectionCountQuery>;
export type ReportCardSectionCountLazyQueryHookResult = ReturnType<typeof useReportCardSectionCountLazyQuery>;
export type ReportCardSectionCountSuspenseQueryHookResult = ReturnType<typeof useReportCardSectionCountSuspenseQuery>;
export type ReportCardSectionCountQueryResult = Apollo.QueryResult<
	ReportCardSectionCountQuery,
	ReportCardSectionCountQueryVariables
>;
export const ReportCardSectionCreateDocument = gql`
	mutation reportCardSectionCreate($input: ReportCardSectionCreateInput!) {
		createReportCardSection(input: $input) {
			...ReportCardSectionDetail
		}
	}
	${ReportCardSectionDetailFragmentDoc}
`;
export type ReportCardSectionCreateMutationFn = Apollo.MutationFunction<
	ReportCardSectionCreateMutation,
	ReportCardSectionCreateMutationVariables
>;

/**
 * __useReportCardSectionCreateMutation__
 *
 * To run a mutation, you first call `useReportCardSectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCardSectionCreateMutation, { data, loading, error }] = useReportCardSectionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportCardSectionCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<ReportCardSectionCreateMutation, ReportCardSectionCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ReportCardSectionCreateMutation, ReportCardSectionCreateMutationVariables>(
		ReportCardSectionCreateDocument,
		options,
	);
}
export type ReportCardSectionCreateMutationHookResult = ReturnType<typeof useReportCardSectionCreateMutation>;
export type ReportCardSectionCreateMutationResult = Apollo.MutationResult<ReportCardSectionCreateMutation>;
export type ReportCardSectionCreateMutationOptions = Apollo.BaseMutationOptions<
	ReportCardSectionCreateMutation,
	ReportCardSectionCreateMutationVariables
>;
export const ReportCardSectionDeleteDocument = gql`
	mutation reportCardSectionDelete($id: ID!) {
		deleteReportCardSection(id: $id)
	}
`;
export type ReportCardSectionDeleteMutationFn = Apollo.MutationFunction<
	ReportCardSectionDeleteMutation,
	ReportCardSectionDeleteMutationVariables
>;

/**
 * __useReportCardSectionDeleteMutation__
 *
 * To run a mutation, you first call `useReportCardSectionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCardSectionDeleteMutation, { data, loading, error }] = useReportCardSectionDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportCardSectionDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<ReportCardSectionDeleteMutation, ReportCardSectionDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ReportCardSectionDeleteMutation, ReportCardSectionDeleteMutationVariables>(
		ReportCardSectionDeleteDocument,
		options,
	);
}
export type ReportCardSectionDeleteMutationHookResult = ReturnType<typeof useReportCardSectionDeleteMutation>;
export type ReportCardSectionDeleteMutationResult = Apollo.MutationResult<ReportCardSectionDeleteMutation>;
export type ReportCardSectionDeleteMutationOptions = Apollo.BaseMutationOptions<
	ReportCardSectionDeleteMutation,
	ReportCardSectionDeleteMutationVariables
>;
export const ReportCardSectionDetailDocument = gql`
	query reportCardSectionDetail($id: ID!) {
		reportCardSection(id: $id) {
			...ReportCardSectionDetail
		}
	}
	${ReportCardSectionDetailFragmentDoc}
`;

/**
 * __useReportCardSectionDetailQuery__
 *
 * To run a query within a React component, call `useReportCardSectionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportCardSectionDetailQuery(
	baseOptions: Apollo.QueryHookOptions<ReportCardSectionDetailQuery, ReportCardSectionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardSectionDetailQuery, ReportCardSectionDetailQueryVariables>(
		ReportCardSectionDetailDocument,
		options,
	);
}
export function useReportCardSectionDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ReportCardSectionDetailQuery, ReportCardSectionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardSectionDetailQuery, ReportCardSectionDetailQueryVariables>(
		ReportCardSectionDetailDocument,
		options,
	);
}
export function useReportCardSectionDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ReportCardSectionDetailQuery, ReportCardSectionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardSectionDetailQuery, ReportCardSectionDetailQueryVariables>(
		ReportCardSectionDetailDocument,
		options,
	);
}
export type ReportCardSectionDetailQueryHookResult = ReturnType<typeof useReportCardSectionDetailQuery>;
export type ReportCardSectionDetailLazyQueryHookResult = ReturnType<typeof useReportCardSectionDetailLazyQuery>;
export type ReportCardSectionDetailSuspenseQueryHookResult = ReturnType<typeof useReportCardSectionDetailSuspenseQuery>;
export type ReportCardSectionDetailQueryResult = Apollo.QueryResult<
	ReportCardSectionDetailQuery,
	ReportCardSectionDetailQueryVariables
>;
export const ReportCardSectionIndexDocument = gql`
	query reportCardSectionIndex(
		$filters: [ReportCardSectionFilterInput!]
		$pagination: Pagination
		$order: ReportCardSectionOrder
	) {
		reportCardSectionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					comment
					generalComment1
					generalComment2
					isComplete
				}
			}
		}
	}
`;

/**
 * __useReportCardSectionIndexQuery__
 *
 * To run a query within a React component, call `useReportCardSectionIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardSectionIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<ReportCardSectionIndexQuery, ReportCardSectionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardSectionIndexQuery, ReportCardSectionIndexQueryVariables>(
		ReportCardSectionIndexDocument,
		options,
	);
}
export function useReportCardSectionIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ReportCardSectionIndexQuery, ReportCardSectionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardSectionIndexQuery, ReportCardSectionIndexQueryVariables>(
		ReportCardSectionIndexDocument,
		options,
	);
}
export function useReportCardSectionIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ReportCardSectionIndexQuery, ReportCardSectionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardSectionIndexQuery, ReportCardSectionIndexQueryVariables>(
		ReportCardSectionIndexDocument,
		options,
	);
}
export type ReportCardSectionIndexQueryHookResult = ReturnType<typeof useReportCardSectionIndexQuery>;
export type ReportCardSectionIndexLazyQueryHookResult = ReturnType<typeof useReportCardSectionIndexLazyQuery>;
export type ReportCardSectionIndexSuspenseQueryHookResult = ReturnType<typeof useReportCardSectionIndexSuspenseQuery>;
export type ReportCardSectionIndexQueryResult = Apollo.QueryResult<
	ReportCardSectionIndexQuery,
	ReportCardSectionIndexQueryVariables
>;
export const ReportCardSectionNameDocument = gql`
	query reportCardSectionName($id: ID!) {
		reportCardSection(id: $id) {
			id
			...ReportCardSectionName
		}
	}
	${ReportCardSectionNameFragmentDoc}
`;

/**
 * __useReportCardSectionNameQuery__
 *
 * To run a query within a React component, call `useReportCardSectionNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportCardSectionNameQuery(
	baseOptions: Apollo.QueryHookOptions<ReportCardSectionNameQuery, ReportCardSectionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardSectionNameQuery, ReportCardSectionNameQueryVariables>(
		ReportCardSectionNameDocument,
		options,
	);
}
export function useReportCardSectionNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ReportCardSectionNameQuery, ReportCardSectionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardSectionNameQuery, ReportCardSectionNameQueryVariables>(
		ReportCardSectionNameDocument,
		options,
	);
}
export function useReportCardSectionNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ReportCardSectionNameQuery, ReportCardSectionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardSectionNameQuery, ReportCardSectionNameQueryVariables>(
		ReportCardSectionNameDocument,
		options,
	);
}
export type ReportCardSectionNameQueryHookResult = ReturnType<typeof useReportCardSectionNameQuery>;
export type ReportCardSectionNameLazyQueryHookResult = ReturnType<typeof useReportCardSectionNameLazyQuery>;
export type ReportCardSectionNameSuspenseQueryHookResult = ReturnType<typeof useReportCardSectionNameSuspenseQuery>;
export type ReportCardSectionNameQueryResult = Apollo.QueryResult<
	ReportCardSectionNameQuery,
	ReportCardSectionNameQueryVariables
>;
export const ReportCardSectionNamesDocument = gql`
	query reportCardSectionNames(
		$filters: [ReportCardSectionFilterInput!]
		$pagination: Pagination
		$order: ReportCardSectionOrder
	) {
		reportCardSectionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...ReportCardSectionName
				}
			}
		}
	}
	${ReportCardSectionNameFragmentDoc}
`;

/**
 * __useReportCardSectionNamesQuery__
 *
 * To run a query within a React component, call `useReportCardSectionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardSectionNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<ReportCardSectionNamesQuery, ReportCardSectionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardSectionNamesQuery, ReportCardSectionNamesQueryVariables>(
		ReportCardSectionNamesDocument,
		options,
	);
}
export function useReportCardSectionNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ReportCardSectionNamesQuery, ReportCardSectionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardSectionNamesQuery, ReportCardSectionNamesQueryVariables>(
		ReportCardSectionNamesDocument,
		options,
	);
}
export function useReportCardSectionNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ReportCardSectionNamesQuery, ReportCardSectionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardSectionNamesQuery, ReportCardSectionNamesQueryVariables>(
		ReportCardSectionNamesDocument,
		options,
	);
}
export type ReportCardSectionNamesQueryHookResult = ReturnType<typeof useReportCardSectionNamesQuery>;
export type ReportCardSectionNamesLazyQueryHookResult = ReturnType<typeof useReportCardSectionNamesLazyQuery>;
export type ReportCardSectionNamesSuspenseQueryHookResult = ReturnType<typeof useReportCardSectionNamesSuspenseQuery>;
export type ReportCardSectionNamesQueryResult = Apollo.QueryResult<
	ReportCardSectionNamesQuery,
	ReportCardSectionNamesQueryVariables
>;
export const ReportCardSectionPaginationDocument = gql`
	query reportCardSectionPagination($filters: [ReportCardSectionFilterInput!], $order: ReportCardSectionOrder) {
		reportCardSectionConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useReportCardSectionPaginationQuery__
 *
 * To run a query within a React component, call `useReportCardSectionPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardSectionPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<ReportCardSectionPaginationQuery, ReportCardSectionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardSectionPaginationQuery, ReportCardSectionPaginationQueryVariables>(
		ReportCardSectionPaginationDocument,
		options,
	);
}
export function useReportCardSectionPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionPaginationQuery,
		ReportCardSectionPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardSectionPaginationQuery, ReportCardSectionPaginationQueryVariables>(
		ReportCardSectionPaginationDocument,
		options,
	);
}
export function useReportCardSectionPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionPaginationQuery,
		ReportCardSectionPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardSectionPaginationQuery, ReportCardSectionPaginationQueryVariables>(
		ReportCardSectionPaginationDocument,
		options,
	);
}
export type ReportCardSectionPaginationQueryHookResult = ReturnType<typeof useReportCardSectionPaginationQuery>;
export type ReportCardSectionPaginationLazyQueryHookResult = ReturnType<typeof useReportCardSectionPaginationLazyQuery>;
export type ReportCardSectionPaginationSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionPaginationSuspenseQuery
>;
export type ReportCardSectionPaginationQueryResult = Apollo.QueryResult<
	ReportCardSectionPaginationQuery,
	ReportCardSectionPaginationQueryVariables
>;
export const ReportCardSectionSelectDocument = gql`
	query reportCardSectionSelect($filters: [ReportCardSectionFilterInput!], $order: ReportCardSectionOrder) {
		reportCardSectionConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...ReportCardSectionName
				}
			}
		}
	}
	${ReportCardSectionNameFragmentDoc}
`;

/**
 * __useReportCardSectionSelectQuery__
 *
 * To run a query within a React component, call `useReportCardSectionSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardSectionSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<ReportCardSectionSelectQuery, ReportCardSectionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardSectionSelectQuery, ReportCardSectionSelectQueryVariables>(
		ReportCardSectionSelectDocument,
		options,
	);
}
export function useReportCardSectionSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ReportCardSectionSelectQuery, ReportCardSectionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardSectionSelectQuery, ReportCardSectionSelectQueryVariables>(
		ReportCardSectionSelectDocument,
		options,
	);
}
export function useReportCardSectionSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ReportCardSectionSelectQuery, ReportCardSectionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardSectionSelectQuery, ReportCardSectionSelectQueryVariables>(
		ReportCardSectionSelectDocument,
		options,
	);
}
export type ReportCardSectionSelectQueryHookResult = ReturnType<typeof useReportCardSectionSelectQuery>;
export type ReportCardSectionSelectLazyQueryHookResult = ReturnType<typeof useReportCardSectionSelectLazyQuery>;
export type ReportCardSectionSelectSuspenseQueryHookResult = ReturnType<typeof useReportCardSectionSelectSuspenseQuery>;
export type ReportCardSectionSelectQueryResult = Apollo.QueryResult<
	ReportCardSectionSelectQuery,
	ReportCardSectionSelectQueryVariables
>;
export const ReportCardSectionUpdateDocument = gql`
	mutation reportCardSectionUpdate($id: ID!, $input: ReportCardSectionUpdateInput!) {
		updateReportCardSection(id: $id, input: $input) {
			...ReportCardSectionDetail
		}
	}
	${ReportCardSectionDetailFragmentDoc}
`;
export type ReportCardSectionUpdateMutationFn = Apollo.MutationFunction<
	ReportCardSectionUpdateMutation,
	ReportCardSectionUpdateMutationVariables
>;

/**
 * __useReportCardSectionUpdateMutation__
 *
 * To run a mutation, you first call `useReportCardSectionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCardSectionUpdateMutation, { data, loading, error }] = useReportCardSectionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportCardSectionUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<ReportCardSectionUpdateMutation, ReportCardSectionUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ReportCardSectionUpdateMutation, ReportCardSectionUpdateMutationVariables>(
		ReportCardSectionUpdateDocument,
		options,
	);
}
export type ReportCardSectionUpdateMutationHookResult = ReturnType<typeof useReportCardSectionUpdateMutation>;
export type ReportCardSectionUpdateMutationResult = Apollo.MutationResult<ReportCardSectionUpdateMutation>;
export type ReportCardSectionUpdateMutationOptions = Apollo.BaseMutationOptions<
	ReportCardSectionUpdateMutation,
	ReportCardSectionUpdateMutationVariables
>;
export const ReportCardSectionLearningObjectiveCountDocument = gql`
	query reportCardSectionLearningObjectiveCount(
		$filters: [ReportCardSectionLearningObjectiveFilterInput!]
		$pagination: Pagination
		$order: ReportCardSectionLearningObjectiveOrder
	) {
		reportCardSectionLearningObjectiveConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useReportCardSectionLearningObjectiveCountQuery__
 *
 * To run a query within a React component, call `useReportCardSectionLearningObjectiveCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionLearningObjectiveCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionLearningObjectiveCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardSectionLearningObjectiveCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ReportCardSectionLearningObjectiveCountQuery,
		ReportCardSectionLearningObjectiveCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReportCardSectionLearningObjectiveCountQuery,
		ReportCardSectionLearningObjectiveCountQueryVariables
	>(ReportCardSectionLearningObjectiveCountDocument, options);
}
export function useReportCardSectionLearningObjectiveCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionLearningObjectiveCountQuery,
		ReportCardSectionLearningObjectiveCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportCardSectionLearningObjectiveCountQuery,
		ReportCardSectionLearningObjectiveCountQueryVariables
	>(ReportCardSectionLearningObjectiveCountDocument, options);
}
export function useReportCardSectionLearningObjectiveCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionLearningObjectiveCountQuery,
		ReportCardSectionLearningObjectiveCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ReportCardSectionLearningObjectiveCountQuery,
		ReportCardSectionLearningObjectiveCountQueryVariables
	>(ReportCardSectionLearningObjectiveCountDocument, options);
}
export type ReportCardSectionLearningObjectiveCountQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveCountQuery
>;
export type ReportCardSectionLearningObjectiveCountLazyQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveCountLazyQuery
>;
export type ReportCardSectionLearningObjectiveCountSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveCountSuspenseQuery
>;
export type ReportCardSectionLearningObjectiveCountQueryResult = Apollo.QueryResult<
	ReportCardSectionLearningObjectiveCountQuery,
	ReportCardSectionLearningObjectiveCountQueryVariables
>;
export const ReportCardSectionLearningObjectiveCreateDocument = gql`
	mutation reportCardSectionLearningObjectiveCreate($input: ReportCardSectionLearningObjectiveCreateInput!) {
		createReportCardSectionLearningObjective(input: $input) {
			...ReportCardSectionLearningObjectiveDetail
		}
	}
	${ReportCardSectionLearningObjectiveDetailFragmentDoc}
`;
export type ReportCardSectionLearningObjectiveCreateMutationFn = Apollo.MutationFunction<
	ReportCardSectionLearningObjectiveCreateMutation,
	ReportCardSectionLearningObjectiveCreateMutationVariables
>;

/**
 * __useReportCardSectionLearningObjectiveCreateMutation__
 *
 * To run a mutation, you first call `useReportCardSectionLearningObjectiveCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionLearningObjectiveCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCardSectionLearningObjectiveCreateMutation, { data, loading, error }] = useReportCardSectionLearningObjectiveCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportCardSectionLearningObjectiveCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ReportCardSectionLearningObjectiveCreateMutation,
		ReportCardSectionLearningObjectiveCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ReportCardSectionLearningObjectiveCreateMutation,
		ReportCardSectionLearningObjectiveCreateMutationVariables
	>(ReportCardSectionLearningObjectiveCreateDocument, options);
}
export type ReportCardSectionLearningObjectiveCreateMutationHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveCreateMutation
>;
export type ReportCardSectionLearningObjectiveCreateMutationResult =
	Apollo.MutationResult<ReportCardSectionLearningObjectiveCreateMutation>;
export type ReportCardSectionLearningObjectiveCreateMutationOptions = Apollo.BaseMutationOptions<
	ReportCardSectionLearningObjectiveCreateMutation,
	ReportCardSectionLearningObjectiveCreateMutationVariables
>;
export const ReportCardSectionLearningObjectiveDeleteDocument = gql`
	mutation reportCardSectionLearningObjectiveDelete($id: ID!) {
		deleteReportCardSectionLearningObjective(id: $id)
	}
`;
export type ReportCardSectionLearningObjectiveDeleteMutationFn = Apollo.MutationFunction<
	ReportCardSectionLearningObjectiveDeleteMutation,
	ReportCardSectionLearningObjectiveDeleteMutationVariables
>;

/**
 * __useReportCardSectionLearningObjectiveDeleteMutation__
 *
 * To run a mutation, you first call `useReportCardSectionLearningObjectiveDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionLearningObjectiveDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCardSectionLearningObjectiveDeleteMutation, { data, loading, error }] = useReportCardSectionLearningObjectiveDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportCardSectionLearningObjectiveDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ReportCardSectionLearningObjectiveDeleteMutation,
		ReportCardSectionLearningObjectiveDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ReportCardSectionLearningObjectiveDeleteMutation,
		ReportCardSectionLearningObjectiveDeleteMutationVariables
	>(ReportCardSectionLearningObjectiveDeleteDocument, options);
}
export type ReportCardSectionLearningObjectiveDeleteMutationHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveDeleteMutation
>;
export type ReportCardSectionLearningObjectiveDeleteMutationResult =
	Apollo.MutationResult<ReportCardSectionLearningObjectiveDeleteMutation>;
export type ReportCardSectionLearningObjectiveDeleteMutationOptions = Apollo.BaseMutationOptions<
	ReportCardSectionLearningObjectiveDeleteMutation,
	ReportCardSectionLearningObjectiveDeleteMutationVariables
>;
export const ReportCardSectionLearningObjectiveDetailDocument = gql`
	query reportCardSectionLearningObjectiveDetail($id: ID!) {
		reportCardSectionLearningObjective(id: $id) {
			...ReportCardSectionLearningObjectiveDetail
		}
	}
	${ReportCardSectionLearningObjectiveDetailFragmentDoc}
`;

/**
 * __useReportCardSectionLearningObjectiveDetailQuery__
 *
 * To run a query within a React component, call `useReportCardSectionLearningObjectiveDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionLearningObjectiveDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionLearningObjectiveDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportCardSectionLearningObjectiveDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		ReportCardSectionLearningObjectiveDetailQuery,
		ReportCardSectionLearningObjectiveDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReportCardSectionLearningObjectiveDetailQuery,
		ReportCardSectionLearningObjectiveDetailQueryVariables
	>(ReportCardSectionLearningObjectiveDetailDocument, options);
}
export function useReportCardSectionLearningObjectiveDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionLearningObjectiveDetailQuery,
		ReportCardSectionLearningObjectiveDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportCardSectionLearningObjectiveDetailQuery,
		ReportCardSectionLearningObjectiveDetailQueryVariables
	>(ReportCardSectionLearningObjectiveDetailDocument, options);
}
export function useReportCardSectionLearningObjectiveDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionLearningObjectiveDetailQuery,
		ReportCardSectionLearningObjectiveDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ReportCardSectionLearningObjectiveDetailQuery,
		ReportCardSectionLearningObjectiveDetailQueryVariables
	>(ReportCardSectionLearningObjectiveDetailDocument, options);
}
export type ReportCardSectionLearningObjectiveDetailQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveDetailQuery
>;
export type ReportCardSectionLearningObjectiveDetailLazyQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveDetailLazyQuery
>;
export type ReportCardSectionLearningObjectiveDetailSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveDetailSuspenseQuery
>;
export type ReportCardSectionLearningObjectiveDetailQueryResult = Apollo.QueryResult<
	ReportCardSectionLearningObjectiveDetailQuery,
	ReportCardSectionLearningObjectiveDetailQueryVariables
>;
export const ReportCardSectionLearningObjectiveIndexDocument = gql`
	query reportCardSectionLearningObjectiveIndex(
		$filters: [ReportCardSectionLearningObjectiveFilterInput!]
		$pagination: Pagination
		$order: ReportCardSectionLearningObjectiveOrder
	) {
		reportCardSectionLearningObjectiveConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
				}
			}
		}
	}
`;

/**
 * __useReportCardSectionLearningObjectiveIndexQuery__
 *
 * To run a query within a React component, call `useReportCardSectionLearningObjectiveIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionLearningObjectiveIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionLearningObjectiveIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardSectionLearningObjectiveIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ReportCardSectionLearningObjectiveIndexQuery,
		ReportCardSectionLearningObjectiveIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReportCardSectionLearningObjectiveIndexQuery,
		ReportCardSectionLearningObjectiveIndexQueryVariables
	>(ReportCardSectionLearningObjectiveIndexDocument, options);
}
export function useReportCardSectionLearningObjectiveIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionLearningObjectiveIndexQuery,
		ReportCardSectionLearningObjectiveIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportCardSectionLearningObjectiveIndexQuery,
		ReportCardSectionLearningObjectiveIndexQueryVariables
	>(ReportCardSectionLearningObjectiveIndexDocument, options);
}
export function useReportCardSectionLearningObjectiveIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionLearningObjectiveIndexQuery,
		ReportCardSectionLearningObjectiveIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ReportCardSectionLearningObjectiveIndexQuery,
		ReportCardSectionLearningObjectiveIndexQueryVariables
	>(ReportCardSectionLearningObjectiveIndexDocument, options);
}
export type ReportCardSectionLearningObjectiveIndexQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveIndexQuery
>;
export type ReportCardSectionLearningObjectiveIndexLazyQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveIndexLazyQuery
>;
export type ReportCardSectionLearningObjectiveIndexSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveIndexSuspenseQuery
>;
export type ReportCardSectionLearningObjectiveIndexQueryResult = Apollo.QueryResult<
	ReportCardSectionLearningObjectiveIndexQuery,
	ReportCardSectionLearningObjectiveIndexQueryVariables
>;
export const ReportCardSectionLearningObjectiveNameDocument = gql`
	query reportCardSectionLearningObjectiveName($id: ID!) {
		reportCardSectionLearningObjective(id: $id) {
			id
			...ReportCardSectionLearningObjectiveName
		}
	}
	${ReportCardSectionLearningObjectiveNameFragmentDoc}
`;

/**
 * __useReportCardSectionLearningObjectiveNameQuery__
 *
 * To run a query within a React component, call `useReportCardSectionLearningObjectiveNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionLearningObjectiveNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionLearningObjectiveNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportCardSectionLearningObjectiveNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		ReportCardSectionLearningObjectiveNameQuery,
		ReportCardSectionLearningObjectiveNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReportCardSectionLearningObjectiveNameQuery,
		ReportCardSectionLearningObjectiveNameQueryVariables
	>(ReportCardSectionLearningObjectiveNameDocument, options);
}
export function useReportCardSectionLearningObjectiveNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionLearningObjectiveNameQuery,
		ReportCardSectionLearningObjectiveNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportCardSectionLearningObjectiveNameQuery,
		ReportCardSectionLearningObjectiveNameQueryVariables
	>(ReportCardSectionLearningObjectiveNameDocument, options);
}
export function useReportCardSectionLearningObjectiveNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionLearningObjectiveNameQuery,
		ReportCardSectionLearningObjectiveNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ReportCardSectionLearningObjectiveNameQuery,
		ReportCardSectionLearningObjectiveNameQueryVariables
	>(ReportCardSectionLearningObjectiveNameDocument, options);
}
export type ReportCardSectionLearningObjectiveNameQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveNameQuery
>;
export type ReportCardSectionLearningObjectiveNameLazyQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveNameLazyQuery
>;
export type ReportCardSectionLearningObjectiveNameSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveNameSuspenseQuery
>;
export type ReportCardSectionLearningObjectiveNameQueryResult = Apollo.QueryResult<
	ReportCardSectionLearningObjectiveNameQuery,
	ReportCardSectionLearningObjectiveNameQueryVariables
>;
export const ReportCardSectionLearningObjectiveNamesDocument = gql`
	query reportCardSectionLearningObjectiveNames(
		$filters: [ReportCardSectionLearningObjectiveFilterInput!]
		$pagination: Pagination
		$order: ReportCardSectionLearningObjectiveOrder
	) {
		reportCardSectionLearningObjectiveConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...ReportCardSectionLearningObjectiveName
				}
			}
		}
	}
	${ReportCardSectionLearningObjectiveNameFragmentDoc}
`;

/**
 * __useReportCardSectionLearningObjectiveNamesQuery__
 *
 * To run a query within a React component, call `useReportCardSectionLearningObjectiveNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionLearningObjectiveNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionLearningObjectiveNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardSectionLearningObjectiveNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ReportCardSectionLearningObjectiveNamesQuery,
		ReportCardSectionLearningObjectiveNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReportCardSectionLearningObjectiveNamesQuery,
		ReportCardSectionLearningObjectiveNamesQueryVariables
	>(ReportCardSectionLearningObjectiveNamesDocument, options);
}
export function useReportCardSectionLearningObjectiveNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionLearningObjectiveNamesQuery,
		ReportCardSectionLearningObjectiveNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportCardSectionLearningObjectiveNamesQuery,
		ReportCardSectionLearningObjectiveNamesQueryVariables
	>(ReportCardSectionLearningObjectiveNamesDocument, options);
}
export function useReportCardSectionLearningObjectiveNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionLearningObjectiveNamesQuery,
		ReportCardSectionLearningObjectiveNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ReportCardSectionLearningObjectiveNamesQuery,
		ReportCardSectionLearningObjectiveNamesQueryVariables
	>(ReportCardSectionLearningObjectiveNamesDocument, options);
}
export type ReportCardSectionLearningObjectiveNamesQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveNamesQuery
>;
export type ReportCardSectionLearningObjectiveNamesLazyQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveNamesLazyQuery
>;
export type ReportCardSectionLearningObjectiveNamesSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveNamesSuspenseQuery
>;
export type ReportCardSectionLearningObjectiveNamesQueryResult = Apollo.QueryResult<
	ReportCardSectionLearningObjectiveNamesQuery,
	ReportCardSectionLearningObjectiveNamesQueryVariables
>;
export const ReportCardSectionLearningObjectivePaginationDocument = gql`
	query reportCardSectionLearningObjectivePagination(
		$filters: [ReportCardSectionLearningObjectiveFilterInput!]
		$order: ReportCardSectionLearningObjectiveOrder
	) {
		reportCardSectionLearningObjectiveConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useReportCardSectionLearningObjectivePaginationQuery__
 *
 * To run a query within a React component, call `useReportCardSectionLearningObjectivePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionLearningObjectivePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionLearningObjectivePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardSectionLearningObjectivePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ReportCardSectionLearningObjectivePaginationQuery,
		ReportCardSectionLearningObjectivePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReportCardSectionLearningObjectivePaginationQuery,
		ReportCardSectionLearningObjectivePaginationQueryVariables
	>(ReportCardSectionLearningObjectivePaginationDocument, options);
}
export function useReportCardSectionLearningObjectivePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionLearningObjectivePaginationQuery,
		ReportCardSectionLearningObjectivePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportCardSectionLearningObjectivePaginationQuery,
		ReportCardSectionLearningObjectivePaginationQueryVariables
	>(ReportCardSectionLearningObjectivePaginationDocument, options);
}
export function useReportCardSectionLearningObjectivePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionLearningObjectivePaginationQuery,
		ReportCardSectionLearningObjectivePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ReportCardSectionLearningObjectivePaginationQuery,
		ReportCardSectionLearningObjectivePaginationQueryVariables
	>(ReportCardSectionLearningObjectivePaginationDocument, options);
}
export type ReportCardSectionLearningObjectivePaginationQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectivePaginationQuery
>;
export type ReportCardSectionLearningObjectivePaginationLazyQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectivePaginationLazyQuery
>;
export type ReportCardSectionLearningObjectivePaginationSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectivePaginationSuspenseQuery
>;
export type ReportCardSectionLearningObjectivePaginationQueryResult = Apollo.QueryResult<
	ReportCardSectionLearningObjectivePaginationQuery,
	ReportCardSectionLearningObjectivePaginationQueryVariables
>;
export const ReportCardSectionLearningObjectiveSelectDocument = gql`
	query reportCardSectionLearningObjectiveSelect(
		$filters: [ReportCardSectionLearningObjectiveFilterInput!]
		$order: ReportCardSectionLearningObjectiveOrder
	) {
		reportCardSectionLearningObjectiveConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...ReportCardSectionLearningObjectiveName
				}
			}
		}
	}
	${ReportCardSectionLearningObjectiveNameFragmentDoc}
`;

/**
 * __useReportCardSectionLearningObjectiveSelectQuery__
 *
 * To run a query within a React component, call `useReportCardSectionLearningObjectiveSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionLearningObjectiveSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionLearningObjectiveSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardSectionLearningObjectiveSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ReportCardSectionLearningObjectiveSelectQuery,
		ReportCardSectionLearningObjectiveSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReportCardSectionLearningObjectiveSelectQuery,
		ReportCardSectionLearningObjectiveSelectQueryVariables
	>(ReportCardSectionLearningObjectiveSelectDocument, options);
}
export function useReportCardSectionLearningObjectiveSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionLearningObjectiveSelectQuery,
		ReportCardSectionLearningObjectiveSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportCardSectionLearningObjectiveSelectQuery,
		ReportCardSectionLearningObjectiveSelectQueryVariables
	>(ReportCardSectionLearningObjectiveSelectDocument, options);
}
export function useReportCardSectionLearningObjectiveSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionLearningObjectiveSelectQuery,
		ReportCardSectionLearningObjectiveSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ReportCardSectionLearningObjectiveSelectQuery,
		ReportCardSectionLearningObjectiveSelectQueryVariables
	>(ReportCardSectionLearningObjectiveSelectDocument, options);
}
export type ReportCardSectionLearningObjectiveSelectQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveSelectQuery
>;
export type ReportCardSectionLearningObjectiveSelectLazyQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveSelectLazyQuery
>;
export type ReportCardSectionLearningObjectiveSelectSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveSelectSuspenseQuery
>;
export type ReportCardSectionLearningObjectiveSelectQueryResult = Apollo.QueryResult<
	ReportCardSectionLearningObjectiveSelectQuery,
	ReportCardSectionLearningObjectiveSelectQueryVariables
>;
export const ReportCardSectionLearningObjectiveUpdateDocument = gql`
	mutation reportCardSectionLearningObjectiveUpdate($id: ID!, $input: ReportCardSectionLearningObjectiveUpdateInput!) {
		updateReportCardSectionLearningObjective(id: $id, input: $input) {
			...ReportCardSectionLearningObjectiveDetail
		}
	}
	${ReportCardSectionLearningObjectiveDetailFragmentDoc}
`;
export type ReportCardSectionLearningObjectiveUpdateMutationFn = Apollo.MutationFunction<
	ReportCardSectionLearningObjectiveUpdateMutation,
	ReportCardSectionLearningObjectiveUpdateMutationVariables
>;

/**
 * __useReportCardSectionLearningObjectiveUpdateMutation__
 *
 * To run a mutation, you first call `useReportCardSectionLearningObjectiveUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionLearningObjectiveUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCardSectionLearningObjectiveUpdateMutation, { data, loading, error }] = useReportCardSectionLearningObjectiveUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportCardSectionLearningObjectiveUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ReportCardSectionLearningObjectiveUpdateMutation,
		ReportCardSectionLearningObjectiveUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		ReportCardSectionLearningObjectiveUpdateMutation,
		ReportCardSectionLearningObjectiveUpdateMutationVariables
	>(ReportCardSectionLearningObjectiveUpdateDocument, options);
}
export type ReportCardSectionLearningObjectiveUpdateMutationHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectiveUpdateMutation
>;
export type ReportCardSectionLearningObjectiveUpdateMutationResult =
	Apollo.MutationResult<ReportCardSectionLearningObjectiveUpdateMutation>;
export type ReportCardSectionLearningObjectiveUpdateMutationOptions = Apollo.BaseMutationOptions<
	ReportCardSectionLearningObjectiveUpdateMutation,
	ReportCardSectionLearningObjectiveUpdateMutationVariables
>;
export const ReportCardSectionPolicyCountDocument = gql`
	query reportCardSectionPolicyCount(
		$filters: [ReportCardSectionPolicyFilterInput!]
		$pagination: Pagination
		$order: ReportCardSectionPolicyOrder
	) {
		reportCardSectionPolicyConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useReportCardSectionPolicyCountQuery__
 *
 * To run a query within a React component, call `useReportCardSectionPolicyCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionPolicyCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionPolicyCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardSectionPolicyCountQuery(
	baseOptions?: Apollo.QueryHookOptions<ReportCardSectionPolicyCountQuery, ReportCardSectionPolicyCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardSectionPolicyCountQuery, ReportCardSectionPolicyCountQueryVariables>(
		ReportCardSectionPolicyCountDocument,
		options,
	);
}
export function useReportCardSectionPolicyCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionPolicyCountQuery,
		ReportCardSectionPolicyCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardSectionPolicyCountQuery, ReportCardSectionPolicyCountQueryVariables>(
		ReportCardSectionPolicyCountDocument,
		options,
	);
}
export function useReportCardSectionPolicyCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionPolicyCountQuery,
		ReportCardSectionPolicyCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardSectionPolicyCountQuery, ReportCardSectionPolicyCountQueryVariables>(
		ReportCardSectionPolicyCountDocument,
		options,
	);
}
export type ReportCardSectionPolicyCountQueryHookResult = ReturnType<typeof useReportCardSectionPolicyCountQuery>;
export type ReportCardSectionPolicyCountLazyQueryHookResult = ReturnType<
	typeof useReportCardSectionPolicyCountLazyQuery
>;
export type ReportCardSectionPolicyCountSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionPolicyCountSuspenseQuery
>;
export type ReportCardSectionPolicyCountQueryResult = Apollo.QueryResult<
	ReportCardSectionPolicyCountQuery,
	ReportCardSectionPolicyCountQueryVariables
>;
export const ReportCardSectionPolicyCreateDocument = gql`
	mutation reportCardSectionPolicyCreate($input: ReportCardSectionPolicyCreateInput!) {
		createReportCardSectionPolicy(input: $input) {
			...ReportCardSectionPolicyDetail
		}
	}
	${ReportCardSectionPolicyDetailFragmentDoc}
`;
export type ReportCardSectionPolicyCreateMutationFn = Apollo.MutationFunction<
	ReportCardSectionPolicyCreateMutation,
	ReportCardSectionPolicyCreateMutationVariables
>;

/**
 * __useReportCardSectionPolicyCreateMutation__
 *
 * To run a mutation, you first call `useReportCardSectionPolicyCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionPolicyCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCardSectionPolicyCreateMutation, { data, loading, error }] = useReportCardSectionPolicyCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportCardSectionPolicyCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ReportCardSectionPolicyCreateMutation,
		ReportCardSectionPolicyCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ReportCardSectionPolicyCreateMutation, ReportCardSectionPolicyCreateMutationVariables>(
		ReportCardSectionPolicyCreateDocument,
		options,
	);
}
export type ReportCardSectionPolicyCreateMutationHookResult = ReturnType<
	typeof useReportCardSectionPolicyCreateMutation
>;
export type ReportCardSectionPolicyCreateMutationResult = Apollo.MutationResult<ReportCardSectionPolicyCreateMutation>;
export type ReportCardSectionPolicyCreateMutationOptions = Apollo.BaseMutationOptions<
	ReportCardSectionPolicyCreateMutation,
	ReportCardSectionPolicyCreateMutationVariables
>;
export const ReportCardSectionPolicyDeleteDocument = gql`
	mutation reportCardSectionPolicyDelete($id: ID!) {
		deleteReportCardSectionPolicy(id: $id)
	}
`;
export type ReportCardSectionPolicyDeleteMutationFn = Apollo.MutationFunction<
	ReportCardSectionPolicyDeleteMutation,
	ReportCardSectionPolicyDeleteMutationVariables
>;

/**
 * __useReportCardSectionPolicyDeleteMutation__
 *
 * To run a mutation, you first call `useReportCardSectionPolicyDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionPolicyDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCardSectionPolicyDeleteMutation, { data, loading, error }] = useReportCardSectionPolicyDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportCardSectionPolicyDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ReportCardSectionPolicyDeleteMutation,
		ReportCardSectionPolicyDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ReportCardSectionPolicyDeleteMutation, ReportCardSectionPolicyDeleteMutationVariables>(
		ReportCardSectionPolicyDeleteDocument,
		options,
	);
}
export type ReportCardSectionPolicyDeleteMutationHookResult = ReturnType<
	typeof useReportCardSectionPolicyDeleteMutation
>;
export type ReportCardSectionPolicyDeleteMutationResult = Apollo.MutationResult<ReportCardSectionPolicyDeleteMutation>;
export type ReportCardSectionPolicyDeleteMutationOptions = Apollo.BaseMutationOptions<
	ReportCardSectionPolicyDeleteMutation,
	ReportCardSectionPolicyDeleteMutationVariables
>;
export const ReportCardSectionPolicyDetailDocument = gql`
	query reportCardSectionPolicyDetail($id: ID!) {
		reportCardSectionPolicy(id: $id) {
			...ReportCardSectionPolicyDetail
		}
	}
	${ReportCardSectionPolicyDetailFragmentDoc}
`;

/**
 * __useReportCardSectionPolicyDetailQuery__
 *
 * To run a query within a React component, call `useReportCardSectionPolicyDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionPolicyDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionPolicyDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportCardSectionPolicyDetailQuery(
	baseOptions: Apollo.QueryHookOptions<ReportCardSectionPolicyDetailQuery, ReportCardSectionPolicyDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardSectionPolicyDetailQuery, ReportCardSectionPolicyDetailQueryVariables>(
		ReportCardSectionPolicyDetailDocument,
		options,
	);
}
export function useReportCardSectionPolicyDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionPolicyDetailQuery,
		ReportCardSectionPolicyDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardSectionPolicyDetailQuery, ReportCardSectionPolicyDetailQueryVariables>(
		ReportCardSectionPolicyDetailDocument,
		options,
	);
}
export function useReportCardSectionPolicyDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionPolicyDetailQuery,
		ReportCardSectionPolicyDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardSectionPolicyDetailQuery, ReportCardSectionPolicyDetailQueryVariables>(
		ReportCardSectionPolicyDetailDocument,
		options,
	);
}
export type ReportCardSectionPolicyDetailQueryHookResult = ReturnType<typeof useReportCardSectionPolicyDetailQuery>;
export type ReportCardSectionPolicyDetailLazyQueryHookResult = ReturnType<
	typeof useReportCardSectionPolicyDetailLazyQuery
>;
export type ReportCardSectionPolicyDetailSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionPolicyDetailSuspenseQuery
>;
export type ReportCardSectionPolicyDetailQueryResult = Apollo.QueryResult<
	ReportCardSectionPolicyDetailQuery,
	ReportCardSectionPolicyDetailQueryVariables
>;
export const ReportCardSectionPolicyIndexDocument = gql`
	query reportCardSectionPolicyIndex(
		$filters: [ReportCardSectionPolicyFilterInput!]
		$pagination: Pagination
		$order: ReportCardSectionPolicyOrder
	) {
		reportCardSectionPolicyConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					nameSuffix
					usesDescription
					descriptionLabel
					description
					usesOverallMark
					overallMarkLabel
					isOverallMarkManual
					usesComment
					commentLabel
					minCommentLength
					maxCommentLength
					isForHomeRoomSection
					usesGeneralComments
					minGeneralComment1Length
					maxGeneralComment1Length
					minGeneralComment2Length
					maxGeneralComment2Length
				}
			}
		}
	}
`;

/**
 * __useReportCardSectionPolicyIndexQuery__
 *
 * To run a query within a React component, call `useReportCardSectionPolicyIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionPolicyIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionPolicyIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardSectionPolicyIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<ReportCardSectionPolicyIndexQuery, ReportCardSectionPolicyIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardSectionPolicyIndexQuery, ReportCardSectionPolicyIndexQueryVariables>(
		ReportCardSectionPolicyIndexDocument,
		options,
	);
}
export function useReportCardSectionPolicyIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionPolicyIndexQuery,
		ReportCardSectionPolicyIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardSectionPolicyIndexQuery, ReportCardSectionPolicyIndexQueryVariables>(
		ReportCardSectionPolicyIndexDocument,
		options,
	);
}
export function useReportCardSectionPolicyIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionPolicyIndexQuery,
		ReportCardSectionPolicyIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardSectionPolicyIndexQuery, ReportCardSectionPolicyIndexQueryVariables>(
		ReportCardSectionPolicyIndexDocument,
		options,
	);
}
export type ReportCardSectionPolicyIndexQueryHookResult = ReturnType<typeof useReportCardSectionPolicyIndexQuery>;
export type ReportCardSectionPolicyIndexLazyQueryHookResult = ReturnType<
	typeof useReportCardSectionPolicyIndexLazyQuery
>;
export type ReportCardSectionPolicyIndexSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionPolicyIndexSuspenseQuery
>;
export type ReportCardSectionPolicyIndexQueryResult = Apollo.QueryResult<
	ReportCardSectionPolicyIndexQuery,
	ReportCardSectionPolicyIndexQueryVariables
>;
export const ReportCardSectionPolicyNameDocument = gql`
	query reportCardSectionPolicyName($id: ID!) {
		reportCardSectionPolicy(id: $id) {
			id
			...ReportCardSectionPolicyName
		}
	}
	${ReportCardSectionPolicyNameFragmentDoc}
`;

/**
 * __useReportCardSectionPolicyNameQuery__
 *
 * To run a query within a React component, call `useReportCardSectionPolicyNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionPolicyNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionPolicyNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportCardSectionPolicyNameQuery(
	baseOptions: Apollo.QueryHookOptions<ReportCardSectionPolicyNameQuery, ReportCardSectionPolicyNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardSectionPolicyNameQuery, ReportCardSectionPolicyNameQueryVariables>(
		ReportCardSectionPolicyNameDocument,
		options,
	);
}
export function useReportCardSectionPolicyNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionPolicyNameQuery,
		ReportCardSectionPolicyNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardSectionPolicyNameQuery, ReportCardSectionPolicyNameQueryVariables>(
		ReportCardSectionPolicyNameDocument,
		options,
	);
}
export function useReportCardSectionPolicyNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionPolicyNameQuery,
		ReportCardSectionPolicyNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardSectionPolicyNameQuery, ReportCardSectionPolicyNameQueryVariables>(
		ReportCardSectionPolicyNameDocument,
		options,
	);
}
export type ReportCardSectionPolicyNameQueryHookResult = ReturnType<typeof useReportCardSectionPolicyNameQuery>;
export type ReportCardSectionPolicyNameLazyQueryHookResult = ReturnType<typeof useReportCardSectionPolicyNameLazyQuery>;
export type ReportCardSectionPolicyNameSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionPolicyNameSuspenseQuery
>;
export type ReportCardSectionPolicyNameQueryResult = Apollo.QueryResult<
	ReportCardSectionPolicyNameQuery,
	ReportCardSectionPolicyNameQueryVariables
>;
export const ReportCardSectionPolicyNamesDocument = gql`
	query reportCardSectionPolicyNames(
		$filters: [ReportCardSectionPolicyFilterInput!]
		$pagination: Pagination
		$order: ReportCardSectionPolicyOrder
	) {
		reportCardSectionPolicyConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...ReportCardSectionPolicyName
				}
			}
		}
	}
	${ReportCardSectionPolicyNameFragmentDoc}
`;

/**
 * __useReportCardSectionPolicyNamesQuery__
 *
 * To run a query within a React component, call `useReportCardSectionPolicyNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionPolicyNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionPolicyNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardSectionPolicyNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<ReportCardSectionPolicyNamesQuery, ReportCardSectionPolicyNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardSectionPolicyNamesQuery, ReportCardSectionPolicyNamesQueryVariables>(
		ReportCardSectionPolicyNamesDocument,
		options,
	);
}
export function useReportCardSectionPolicyNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionPolicyNamesQuery,
		ReportCardSectionPolicyNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardSectionPolicyNamesQuery, ReportCardSectionPolicyNamesQueryVariables>(
		ReportCardSectionPolicyNamesDocument,
		options,
	);
}
export function useReportCardSectionPolicyNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionPolicyNamesQuery,
		ReportCardSectionPolicyNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardSectionPolicyNamesQuery, ReportCardSectionPolicyNamesQueryVariables>(
		ReportCardSectionPolicyNamesDocument,
		options,
	);
}
export type ReportCardSectionPolicyNamesQueryHookResult = ReturnType<typeof useReportCardSectionPolicyNamesQuery>;
export type ReportCardSectionPolicyNamesLazyQueryHookResult = ReturnType<
	typeof useReportCardSectionPolicyNamesLazyQuery
>;
export type ReportCardSectionPolicyNamesSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionPolicyNamesSuspenseQuery
>;
export type ReportCardSectionPolicyNamesQueryResult = Apollo.QueryResult<
	ReportCardSectionPolicyNamesQuery,
	ReportCardSectionPolicyNamesQueryVariables
>;
export const ReportCardSectionPolicyPaginationDocument = gql`
	query reportCardSectionPolicyPagination(
		$filters: [ReportCardSectionPolicyFilterInput!]
		$order: ReportCardSectionPolicyOrder
	) {
		reportCardSectionPolicyConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useReportCardSectionPolicyPaginationQuery__
 *
 * To run a query within a React component, call `useReportCardSectionPolicyPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionPolicyPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionPolicyPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardSectionPolicyPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ReportCardSectionPolicyPaginationQuery,
		ReportCardSectionPolicyPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardSectionPolicyPaginationQuery, ReportCardSectionPolicyPaginationQueryVariables>(
		ReportCardSectionPolicyPaginationDocument,
		options,
	);
}
export function useReportCardSectionPolicyPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionPolicyPaginationQuery,
		ReportCardSectionPolicyPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardSectionPolicyPaginationQuery, ReportCardSectionPolicyPaginationQueryVariables>(
		ReportCardSectionPolicyPaginationDocument,
		options,
	);
}
export function useReportCardSectionPolicyPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionPolicyPaginationQuery,
		ReportCardSectionPolicyPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ReportCardSectionPolicyPaginationQuery,
		ReportCardSectionPolicyPaginationQueryVariables
	>(ReportCardSectionPolicyPaginationDocument, options);
}
export type ReportCardSectionPolicyPaginationQueryHookResult = ReturnType<
	typeof useReportCardSectionPolicyPaginationQuery
>;
export type ReportCardSectionPolicyPaginationLazyQueryHookResult = ReturnType<
	typeof useReportCardSectionPolicyPaginationLazyQuery
>;
export type ReportCardSectionPolicyPaginationSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionPolicyPaginationSuspenseQuery
>;
export type ReportCardSectionPolicyPaginationQueryResult = Apollo.QueryResult<
	ReportCardSectionPolicyPaginationQuery,
	ReportCardSectionPolicyPaginationQueryVariables
>;
export const ReportCardSectionPolicySelectDocument = gql`
	query reportCardSectionPolicySelect(
		$filters: [ReportCardSectionPolicyFilterInput!]
		$order: ReportCardSectionPolicyOrder
	) {
		reportCardSectionPolicyConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...ReportCardSectionPolicyName
				}
			}
		}
	}
	${ReportCardSectionPolicyNameFragmentDoc}
`;

/**
 * __useReportCardSectionPolicySelectQuery__
 *
 * To run a query within a React component, call `useReportCardSectionPolicySelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionPolicySelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionPolicySelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportCardSectionPolicySelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ReportCardSectionPolicySelectQuery,
		ReportCardSectionPolicySelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardSectionPolicySelectQuery, ReportCardSectionPolicySelectQueryVariables>(
		ReportCardSectionPolicySelectDocument,
		options,
	);
}
export function useReportCardSectionPolicySelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionPolicySelectQuery,
		ReportCardSectionPolicySelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReportCardSectionPolicySelectQuery, ReportCardSectionPolicySelectQueryVariables>(
		ReportCardSectionPolicySelectDocument,
		options,
	);
}
export function useReportCardSectionPolicySelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionPolicySelectQuery,
		ReportCardSectionPolicySelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReportCardSectionPolicySelectQuery, ReportCardSectionPolicySelectQueryVariables>(
		ReportCardSectionPolicySelectDocument,
		options,
	);
}
export type ReportCardSectionPolicySelectQueryHookResult = ReturnType<typeof useReportCardSectionPolicySelectQuery>;
export type ReportCardSectionPolicySelectLazyQueryHookResult = ReturnType<
	typeof useReportCardSectionPolicySelectLazyQuery
>;
export type ReportCardSectionPolicySelectSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionPolicySelectSuspenseQuery
>;
export type ReportCardSectionPolicySelectQueryResult = Apollo.QueryResult<
	ReportCardSectionPolicySelectQuery,
	ReportCardSectionPolicySelectQueryVariables
>;
export const ReportCardSectionPolicyUpdateDocument = gql`
	mutation reportCardSectionPolicyUpdate($id: ID!, $input: ReportCardSectionPolicyUpdateInput!) {
		updateReportCardSectionPolicy(id: $id, input: $input) {
			...ReportCardSectionPolicyDetail
		}
	}
	${ReportCardSectionPolicyDetailFragmentDoc}
`;
export type ReportCardSectionPolicyUpdateMutationFn = Apollo.MutationFunction<
	ReportCardSectionPolicyUpdateMutation,
	ReportCardSectionPolicyUpdateMutationVariables
>;

/**
 * __useReportCardSectionPolicyUpdateMutation__
 *
 * To run a mutation, you first call `useReportCardSectionPolicyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionPolicyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCardSectionPolicyUpdateMutation, { data, loading, error }] = useReportCardSectionPolicyUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportCardSectionPolicyUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ReportCardSectionPolicyUpdateMutation,
		ReportCardSectionPolicyUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ReportCardSectionPolicyUpdateMutation, ReportCardSectionPolicyUpdateMutationVariables>(
		ReportCardSectionPolicyUpdateDocument,
		options,
	);
}
export type ReportCardSectionPolicyUpdateMutationHookResult = ReturnType<
	typeof useReportCardSectionPolicyUpdateMutation
>;
export type ReportCardSectionPolicyUpdateMutationResult = Apollo.MutationResult<ReportCardSectionPolicyUpdateMutation>;
export type ReportCardSectionPolicyUpdateMutationOptions = Apollo.BaseMutationOptions<
	ReportCardSectionPolicyUpdateMutation,
	ReportCardSectionPolicyUpdateMutationVariables
>;
export const CourseAttendanceRecordCountStatisticsDocument = gql`
	query courseAttendanceRecordCountStatistics(
		$date: Date!
		$studentFilters: [StudentFilterInput!]
		$courseAttendanceRecordFilters: [CourseAttendanceRecordFilterInput!]
	) {
		courseAttendanceRecordCountStatistics(
			date: $date
			studentFilters: $studentFilters
			courseAttendanceRecordFilters: $courseAttendanceRecordFilters
		) {
			students
			present
			presentTotal
			absentExcused
			absentUnexcused
			absentTotal
			lateArrivalExcused
			lateArrivalUnexcused
			lateArrivalTotal
			earlyDepartureExcused
			earlyDepartureUnexcused
			earlyDepartureTotal
			notTaken
		}
	}
`;

/**
 * __useCourseAttendanceRecordCountStatisticsQuery__
 *
 * To run a query within a React component, call `useCourseAttendanceRecordCountStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAttendanceRecordCountStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAttendanceRecordCountStatisticsQuery({
 *   variables: {
 *      date: // value for 'date'
 *      studentFilters: // value for 'studentFilters'
 *      courseAttendanceRecordFilters: // value for 'courseAttendanceRecordFilters'
 *   },
 * });
 */
export function useCourseAttendanceRecordCountStatisticsQuery(
	baseOptions: Apollo.QueryHookOptions<
		CourseAttendanceRecordCountStatisticsQuery,
		CourseAttendanceRecordCountStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CourseAttendanceRecordCountStatisticsQuery,
		CourseAttendanceRecordCountStatisticsQueryVariables
	>(CourseAttendanceRecordCountStatisticsDocument, options);
}
export function useCourseAttendanceRecordCountStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAttendanceRecordCountStatisticsQuery,
		CourseAttendanceRecordCountStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CourseAttendanceRecordCountStatisticsQuery,
		CourseAttendanceRecordCountStatisticsQueryVariables
	>(CourseAttendanceRecordCountStatisticsDocument, options);
}
export function useCourseAttendanceRecordCountStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAttendanceRecordCountStatisticsQuery,
		CourseAttendanceRecordCountStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CourseAttendanceRecordCountStatisticsQuery,
		CourseAttendanceRecordCountStatisticsQueryVariables
	>(CourseAttendanceRecordCountStatisticsDocument, options);
}
export type CourseAttendanceRecordCountStatisticsQueryHookResult = ReturnType<
	typeof useCourseAttendanceRecordCountStatisticsQuery
>;
export type CourseAttendanceRecordCountStatisticsLazyQueryHookResult = ReturnType<
	typeof useCourseAttendanceRecordCountStatisticsLazyQuery
>;
export type CourseAttendanceRecordCountStatisticsSuspenseQueryHookResult = ReturnType<
	typeof useCourseAttendanceRecordCountStatisticsSuspenseQuery
>;
export type CourseAttendanceRecordCountStatisticsQueryResult = Apollo.QueryResult<
	CourseAttendanceRecordCountStatisticsQuery,
	CourseAttendanceRecordCountStatisticsQueryVariables
>;
export const CourseSectionAttendanceRecordsReportDocument = gql`
	query courseSectionAttendanceRecordsReport($date: Date!, $courseSectionID: ID!) {
		studentConnection(
			filters: {
				studentAcademicTermEnrollments: {
					academicTerm: { startDateLTE: $date, endDateGTE: $date }
					and: [
						{ or: [{ lateStartDateIsNull: true }, { lateStartDateLTE: $date }] }
						{ or: [{ earlyEndDateIsNull: true }, { earlyEndDateGTE: $date }] }
					]
				}
				studentCourseSectionEnrollments: {
					courseSectionIDEQ: $courseSectionID
					and: [
						{ or: [{ lateStartDateIsNull: true }, { lateStartDateLTE: $date }] }
						{ or: [{ earlyEndDateIsNull: true }, { earlyEndDateGTE: $date }] }
					]
				}
			}
		) {
			edges {
				node {
					id
					...StudentName
					courseAttendanceRecords(
						filters: { courseSectionPeriod: { courseSectionIDEQ: $courseSectionID }, attendanceDateEQ: $date }
						order: { field: CREATED_AT, direction: ASC }
					) {
						id
						notes
						attendanceStatus {
							id
							code
							name
							description
							...AttendanceStatusInfo
						}
					}
				}
			}
		}
	}
	${StudentNameFragmentDoc}
	${AttendanceStatusInfoFragmentDoc}
`;

/**
 * __useCourseSectionAttendanceRecordsReportQuery__
 *
 * To run a query within a React component, call `useCourseSectionAttendanceRecordsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSectionAttendanceRecordsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSectionAttendanceRecordsReportQuery({
 *   variables: {
 *      date: // value for 'date'
 *      courseSectionID: // value for 'courseSectionID'
 *   },
 * });
 */
export function useCourseSectionAttendanceRecordsReportQuery(
	baseOptions: Apollo.QueryHookOptions<
		CourseSectionAttendanceRecordsReportQuery,
		CourseSectionAttendanceRecordsReportQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CourseSectionAttendanceRecordsReportQuery, CourseSectionAttendanceRecordsReportQueryVariables>(
		CourseSectionAttendanceRecordsReportDocument,
		options,
	);
}
export function useCourseSectionAttendanceRecordsReportLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseSectionAttendanceRecordsReportQuery,
		CourseSectionAttendanceRecordsReportQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CourseSectionAttendanceRecordsReportQuery,
		CourseSectionAttendanceRecordsReportQueryVariables
	>(CourseSectionAttendanceRecordsReportDocument, options);
}
export function useCourseSectionAttendanceRecordsReportSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseSectionAttendanceRecordsReportQuery,
		CourseSectionAttendanceRecordsReportQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CourseSectionAttendanceRecordsReportQuery,
		CourseSectionAttendanceRecordsReportQueryVariables
	>(CourseSectionAttendanceRecordsReportDocument, options);
}
export type CourseSectionAttendanceRecordsReportQueryHookResult = ReturnType<
	typeof useCourseSectionAttendanceRecordsReportQuery
>;
export type CourseSectionAttendanceRecordsReportLazyQueryHookResult = ReturnType<
	typeof useCourseSectionAttendanceRecordsReportLazyQuery
>;
export type CourseSectionAttendanceRecordsReportSuspenseQueryHookResult = ReturnType<
	typeof useCourseSectionAttendanceRecordsReportSuspenseQuery
>;
export type CourseSectionAttendanceRecordsReportQueryResult = Apollo.QueryResult<
	CourseSectionAttendanceRecordsReportQuery,
	CourseSectionAttendanceRecordsReportQueryVariables
>;
export const CourseAttendanceRecordCountStatisticsRangeDocument = gql`
	query courseAttendanceRecordCountStatisticsRange(
		$startDate: Date!
		$endDate: Date!
		$studentFilters: [StudentFilterInput!]
		$courseAttendanceRecordFilters: [CourseAttendanceRecordFilterInput!]
	) {
		courseAttendanceRecordCountStatisticsRange(
			startDate: $startDate
			endDate: $endDate
			studentFilters: $studentFilters
			courseAttendanceRecordFilters: $courseAttendanceRecordFilters
		) {
			date
			students
			present
			presentTotal
			absentExcused
			absentUnexcused
			absentTotal
			lateArrivalExcused
			lateArrivalUnexcused
			lateArrivalTotal
			earlyDepartureExcused
			earlyDepartureUnexcused
			earlyDepartureTotal
			notTaken
		}
	}
`;

/**
 * __useCourseAttendanceRecordCountStatisticsRangeQuery__
 *
 * To run a query within a React component, call `useCourseAttendanceRecordCountStatisticsRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseAttendanceRecordCountStatisticsRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseAttendanceRecordCountStatisticsRangeQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      studentFilters: // value for 'studentFilters'
 *      courseAttendanceRecordFilters: // value for 'courseAttendanceRecordFilters'
 *   },
 * });
 */
export function useCourseAttendanceRecordCountStatisticsRangeQuery(
	baseOptions: Apollo.QueryHookOptions<
		CourseAttendanceRecordCountStatisticsRangeQuery,
		CourseAttendanceRecordCountStatisticsRangeQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CourseAttendanceRecordCountStatisticsRangeQuery,
		CourseAttendanceRecordCountStatisticsRangeQueryVariables
	>(CourseAttendanceRecordCountStatisticsRangeDocument, options);
}
export function useCourseAttendanceRecordCountStatisticsRangeLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CourseAttendanceRecordCountStatisticsRangeQuery,
		CourseAttendanceRecordCountStatisticsRangeQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CourseAttendanceRecordCountStatisticsRangeQuery,
		CourseAttendanceRecordCountStatisticsRangeQueryVariables
	>(CourseAttendanceRecordCountStatisticsRangeDocument, options);
}
export function useCourseAttendanceRecordCountStatisticsRangeSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CourseAttendanceRecordCountStatisticsRangeQuery,
		CourseAttendanceRecordCountStatisticsRangeQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CourseAttendanceRecordCountStatisticsRangeQuery,
		CourseAttendanceRecordCountStatisticsRangeQueryVariables
	>(CourseAttendanceRecordCountStatisticsRangeDocument, options);
}
export type CourseAttendanceRecordCountStatisticsRangeQueryHookResult = ReturnType<
	typeof useCourseAttendanceRecordCountStatisticsRangeQuery
>;
export type CourseAttendanceRecordCountStatisticsRangeLazyQueryHookResult = ReturnType<
	typeof useCourseAttendanceRecordCountStatisticsRangeLazyQuery
>;
export type CourseAttendanceRecordCountStatisticsRangeSuspenseQueryHookResult = ReturnType<
	typeof useCourseAttendanceRecordCountStatisticsRangeSuspenseQuery
>;
export type CourseAttendanceRecordCountStatisticsRangeQueryResult = Apollo.QueryResult<
	CourseAttendanceRecordCountStatisticsRangeQuery,
	CourseAttendanceRecordCountStatisticsRangeQueryVariables
>;
export const SchoolAttendanceRecordCountStatisticsDocument = gql`
	query schoolAttendanceRecordCountStatistics(
		$date: Date!
		$studentFilters: [StudentFilterInput!]
		$schoolAttendanceRecordFilters: [SchoolAttendanceRecordFilterInput!]
	) {
		schoolAttendanceRecordCountStatistics(
			date: $date
			studentFilters: $studentFilters
			schoolAttendanceRecordFilters: $schoolAttendanceRecordFilters
		) {
			students
			present
			presentTotal
			absentExcused
			absentUnexcused
			absentTotal
			lateArrivalExcused
			lateArrivalUnexcused
			lateArrivalTotal
			earlyDepartureExcused
			earlyDepartureUnexcused
			earlyDepartureTotal
			notTaken
		}
	}
`;

/**
 * __useSchoolAttendanceRecordCountStatisticsQuery__
 *
 * To run a query within a React component, call `useSchoolAttendanceRecordCountStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolAttendanceRecordCountStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolAttendanceRecordCountStatisticsQuery({
 *   variables: {
 *      date: // value for 'date'
 *      studentFilters: // value for 'studentFilters'
 *      schoolAttendanceRecordFilters: // value for 'schoolAttendanceRecordFilters'
 *   },
 * });
 */
export function useSchoolAttendanceRecordCountStatisticsQuery(
	baseOptions: Apollo.QueryHookOptions<
		SchoolAttendanceRecordCountStatisticsQuery,
		SchoolAttendanceRecordCountStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SchoolAttendanceRecordCountStatisticsQuery,
		SchoolAttendanceRecordCountStatisticsQueryVariables
	>(SchoolAttendanceRecordCountStatisticsDocument, options);
}
export function useSchoolAttendanceRecordCountStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SchoolAttendanceRecordCountStatisticsQuery,
		SchoolAttendanceRecordCountStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SchoolAttendanceRecordCountStatisticsQuery,
		SchoolAttendanceRecordCountStatisticsQueryVariables
	>(SchoolAttendanceRecordCountStatisticsDocument, options);
}
export function useSchoolAttendanceRecordCountStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		SchoolAttendanceRecordCountStatisticsQuery,
		SchoolAttendanceRecordCountStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		SchoolAttendanceRecordCountStatisticsQuery,
		SchoolAttendanceRecordCountStatisticsQueryVariables
	>(SchoolAttendanceRecordCountStatisticsDocument, options);
}
export type SchoolAttendanceRecordCountStatisticsQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordCountStatisticsQuery
>;
export type SchoolAttendanceRecordCountStatisticsLazyQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordCountStatisticsLazyQuery
>;
export type SchoolAttendanceRecordCountStatisticsSuspenseQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordCountStatisticsSuspenseQuery
>;
export type SchoolAttendanceRecordCountStatisticsQueryResult = Apollo.QueryResult<
	SchoolAttendanceRecordCountStatisticsQuery,
	SchoolAttendanceRecordCountStatisticsQueryVariables
>;
export const SchoolAttendanceRecordCountStatisticsWithStatusesDocument = gql`
	query schoolAttendanceRecordCountStatisticsWithStatuses(
		$date: Date!
		$studentFilters: [StudentFilterInput!]
		$schoolAttendanceRecordFilters: [SchoolAttendanceRecordFilterInput!]
	) {
		schoolAttendanceRecordCountStatistics(
			date: $date
			studentFilters: $studentFilters
			schoolAttendanceRecordFilters: $schoolAttendanceRecordFilters
		) {
			students
			present
			presentTotal
			absentExcused
			absentUnexcused
			absentTotal
			lateArrivalExcused
			lateArrivalUnexcused
			lateArrivalTotal
			earlyDepartureExcused
			earlyDepartureUnexcused
			earlyDepartureTotal
			notTaken
			statuses {
				id
				name
				code
				description
				indicatesAbsent
				indicatesLateArrival
				indicatesEarlyDeparture
				indicatesExcused
				count
			}
		}
	}
`;

/**
 * __useSchoolAttendanceRecordCountStatisticsWithStatusesQuery__
 *
 * To run a query within a React component, call `useSchoolAttendanceRecordCountStatisticsWithStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolAttendanceRecordCountStatisticsWithStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolAttendanceRecordCountStatisticsWithStatusesQuery({
 *   variables: {
 *      date: // value for 'date'
 *      studentFilters: // value for 'studentFilters'
 *      schoolAttendanceRecordFilters: // value for 'schoolAttendanceRecordFilters'
 *   },
 * });
 */
export function useSchoolAttendanceRecordCountStatisticsWithStatusesQuery(
	baseOptions: Apollo.QueryHookOptions<
		SchoolAttendanceRecordCountStatisticsWithStatusesQuery,
		SchoolAttendanceRecordCountStatisticsWithStatusesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SchoolAttendanceRecordCountStatisticsWithStatusesQuery,
		SchoolAttendanceRecordCountStatisticsWithStatusesQueryVariables
	>(SchoolAttendanceRecordCountStatisticsWithStatusesDocument, options);
}
export function useSchoolAttendanceRecordCountStatisticsWithStatusesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SchoolAttendanceRecordCountStatisticsWithStatusesQuery,
		SchoolAttendanceRecordCountStatisticsWithStatusesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SchoolAttendanceRecordCountStatisticsWithStatusesQuery,
		SchoolAttendanceRecordCountStatisticsWithStatusesQueryVariables
	>(SchoolAttendanceRecordCountStatisticsWithStatusesDocument, options);
}
export function useSchoolAttendanceRecordCountStatisticsWithStatusesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		SchoolAttendanceRecordCountStatisticsWithStatusesQuery,
		SchoolAttendanceRecordCountStatisticsWithStatusesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		SchoolAttendanceRecordCountStatisticsWithStatusesQuery,
		SchoolAttendanceRecordCountStatisticsWithStatusesQueryVariables
	>(SchoolAttendanceRecordCountStatisticsWithStatusesDocument, options);
}
export type SchoolAttendanceRecordCountStatisticsWithStatusesQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordCountStatisticsWithStatusesQuery
>;
export type SchoolAttendanceRecordCountStatisticsWithStatusesLazyQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordCountStatisticsWithStatusesLazyQuery
>;
export type SchoolAttendanceRecordCountStatisticsWithStatusesSuspenseQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordCountStatisticsWithStatusesSuspenseQuery
>;
export type SchoolAttendanceRecordCountStatisticsWithStatusesQueryResult = Apollo.QueryResult<
	SchoolAttendanceRecordCountStatisticsWithStatusesQuery,
	SchoolAttendanceRecordCountStatisticsWithStatusesQueryVariables
>;
export const SchoolAttendanceRecordCountStatisticsRangeDocument = gql`
	query schoolAttendanceRecordCountStatisticsRange(
		$startDate: Date!
		$endDate: Date!
		$studentFilters: [StudentFilterInput!]
		$schoolAttendanceRecordFilters: [SchoolAttendanceRecordFilterInput!]
	) {
		schoolAttendanceRecordCountStatisticsRange(
			startDate: $startDate
			endDate: $endDate
			studentFilters: $studentFilters
			schoolAttendanceRecordFilters: $schoolAttendanceRecordFilters
		) {
			date
			students
			present
			presentTotal
			absentExcused
			absentUnexcused
			absentTotal
			lateArrivalExcused
			lateArrivalUnexcused
			lateArrivalTotal
			earlyDepartureExcused
			earlyDepartureUnexcused
			earlyDepartureTotal
			notTaken
		}
	}
`;

/**
 * __useSchoolAttendanceRecordCountStatisticsRangeQuery__
 *
 * To run a query within a React component, call `useSchoolAttendanceRecordCountStatisticsRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolAttendanceRecordCountStatisticsRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolAttendanceRecordCountStatisticsRangeQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      studentFilters: // value for 'studentFilters'
 *      schoolAttendanceRecordFilters: // value for 'schoolAttendanceRecordFilters'
 *   },
 * });
 */
export function useSchoolAttendanceRecordCountStatisticsRangeQuery(
	baseOptions: Apollo.QueryHookOptions<
		SchoolAttendanceRecordCountStatisticsRangeQuery,
		SchoolAttendanceRecordCountStatisticsRangeQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SchoolAttendanceRecordCountStatisticsRangeQuery,
		SchoolAttendanceRecordCountStatisticsRangeQueryVariables
	>(SchoolAttendanceRecordCountStatisticsRangeDocument, options);
}
export function useSchoolAttendanceRecordCountStatisticsRangeLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SchoolAttendanceRecordCountStatisticsRangeQuery,
		SchoolAttendanceRecordCountStatisticsRangeQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SchoolAttendanceRecordCountStatisticsRangeQuery,
		SchoolAttendanceRecordCountStatisticsRangeQueryVariables
	>(SchoolAttendanceRecordCountStatisticsRangeDocument, options);
}
export function useSchoolAttendanceRecordCountStatisticsRangeSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		SchoolAttendanceRecordCountStatisticsRangeQuery,
		SchoolAttendanceRecordCountStatisticsRangeQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		SchoolAttendanceRecordCountStatisticsRangeQuery,
		SchoolAttendanceRecordCountStatisticsRangeQueryVariables
	>(SchoolAttendanceRecordCountStatisticsRangeDocument, options);
}
export type SchoolAttendanceRecordCountStatisticsRangeQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordCountStatisticsRangeQuery
>;
export type SchoolAttendanceRecordCountStatisticsRangeLazyQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordCountStatisticsRangeLazyQuery
>;
export type SchoolAttendanceRecordCountStatisticsRangeSuspenseQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordCountStatisticsRangeSuspenseQuery
>;
export type SchoolAttendanceRecordCountStatisticsRangeQueryResult = Apollo.QueryResult<
	SchoolAttendanceRecordCountStatisticsRangeQuery,
	SchoolAttendanceRecordCountStatisticsRangeQueryVariables
>;
export const StudentSchoolAttendanceRecordCountStatisticsRangeSumDocument = gql`
	query studentSchoolAttendanceRecordCountStatisticsRangeSum(
		$startDate: Date!
		$endDate: Date!
		$studentID: ID!
		$schoolAttendanceRecordFilters: [SchoolAttendanceRecordFilterInput!]
	) {
		studentSchoolAttendanceRecordCountStatisticsRangeSum(
			startDate: $startDate
			endDate: $endDate
			studentID: $studentID
			schoolAttendanceRecordFilters: $schoolAttendanceRecordFilters
		) {
			students
			present
			presentTotal
			absentExcused
			absentUnexcused
			absentTotal
			lateArrivalExcused
			lateArrivalUnexcused
			lateArrivalTotal
			earlyDepartureExcused
			earlyDepartureUnexcused
			earlyDepartureTotal
			notTaken
		}
	}
`;

/**
 * __useStudentSchoolAttendanceRecordCountStatisticsRangeSumQuery__
 *
 * To run a query within a React component, call `useStudentSchoolAttendanceRecordCountStatisticsRangeSumQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentSchoolAttendanceRecordCountStatisticsRangeSumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentSchoolAttendanceRecordCountStatisticsRangeSumQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      studentID: // value for 'studentID'
 *      schoolAttendanceRecordFilters: // value for 'schoolAttendanceRecordFilters'
 *   },
 * });
 */
export function useStudentSchoolAttendanceRecordCountStatisticsRangeSumQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentSchoolAttendanceRecordCountStatisticsRangeSumQuery,
		StudentSchoolAttendanceRecordCountStatisticsRangeSumQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentSchoolAttendanceRecordCountStatisticsRangeSumQuery,
		StudentSchoolAttendanceRecordCountStatisticsRangeSumQueryVariables
	>(StudentSchoolAttendanceRecordCountStatisticsRangeSumDocument, options);
}
export function useStudentSchoolAttendanceRecordCountStatisticsRangeSumLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentSchoolAttendanceRecordCountStatisticsRangeSumQuery,
		StudentSchoolAttendanceRecordCountStatisticsRangeSumQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentSchoolAttendanceRecordCountStatisticsRangeSumQuery,
		StudentSchoolAttendanceRecordCountStatisticsRangeSumQueryVariables
	>(StudentSchoolAttendanceRecordCountStatisticsRangeSumDocument, options);
}
export function useStudentSchoolAttendanceRecordCountStatisticsRangeSumSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentSchoolAttendanceRecordCountStatisticsRangeSumQuery,
		StudentSchoolAttendanceRecordCountStatisticsRangeSumQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentSchoolAttendanceRecordCountStatisticsRangeSumQuery,
		StudentSchoolAttendanceRecordCountStatisticsRangeSumQueryVariables
	>(StudentSchoolAttendanceRecordCountStatisticsRangeSumDocument, options);
}
export type StudentSchoolAttendanceRecordCountStatisticsRangeSumQueryHookResult = ReturnType<
	typeof useStudentSchoolAttendanceRecordCountStatisticsRangeSumQuery
>;
export type StudentSchoolAttendanceRecordCountStatisticsRangeSumLazyQueryHookResult = ReturnType<
	typeof useStudentSchoolAttendanceRecordCountStatisticsRangeSumLazyQuery
>;
export type StudentSchoolAttendanceRecordCountStatisticsRangeSumSuspenseQueryHookResult = ReturnType<
	typeof useStudentSchoolAttendanceRecordCountStatisticsRangeSumSuspenseQuery
>;
export type StudentSchoolAttendanceRecordCountStatisticsRangeSumQueryResult = Apollo.QueryResult<
	StudentSchoolAttendanceRecordCountStatisticsRangeSumQuery,
	StudentSchoolAttendanceRecordCountStatisticsRangeSumQueryVariables
>;
export const CommunicationCenterStatisticsDocument = gql`
	query communicationCenterStatistics(
		$announcementFilters: [AnnouncementFilterInput!]
		$newsletterFilters: [NewsletterFilterInput!]
		$postFilters: [PostFilterInput!]
		$calendarEventFilters: [CalendarEventFilterInput!]
	) {
		announcementStatistics(filters: $announcementFilters) {
			count
			views
			reactions
		}
		newsletterStatistics(filters: $newsletterFilters) {
			count
			views
			reactions
			comments
		}
		postStatistics(filters: $postFilters) {
			count
			views
			reactions
			comments
		}
		calendarEventStatistics(filters: $calendarEventFilters) {
			count
			responsesAttending
			responsesMaybeAttending
			responsesNotAttending
		}
	}
`;

/**
 * __useCommunicationCenterStatisticsQuery__
 *
 * To run a query within a React component, call `useCommunicationCenterStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunicationCenterStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunicationCenterStatisticsQuery({
 *   variables: {
 *      announcementFilters: // value for 'announcementFilters'
 *      newsletterFilters: // value for 'newsletterFilters'
 *      postFilters: // value for 'postFilters'
 *      calendarEventFilters: // value for 'calendarEventFilters'
 *   },
 * });
 */
export function useCommunicationCenterStatisticsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CommunicationCenterStatisticsQuery,
		CommunicationCenterStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CommunicationCenterStatisticsQuery, CommunicationCenterStatisticsQueryVariables>(
		CommunicationCenterStatisticsDocument,
		options,
	);
}
export function useCommunicationCenterStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CommunicationCenterStatisticsQuery,
		CommunicationCenterStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CommunicationCenterStatisticsQuery, CommunicationCenterStatisticsQueryVariables>(
		CommunicationCenterStatisticsDocument,
		options,
	);
}
export function useCommunicationCenterStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CommunicationCenterStatisticsQuery,
		CommunicationCenterStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CommunicationCenterStatisticsQuery, CommunicationCenterStatisticsQueryVariables>(
		CommunicationCenterStatisticsDocument,
		options,
	);
}
export type CommunicationCenterStatisticsQueryHookResult = ReturnType<typeof useCommunicationCenterStatisticsQuery>;
export type CommunicationCenterStatisticsLazyQueryHookResult = ReturnType<
	typeof useCommunicationCenterStatisticsLazyQuery
>;
export type CommunicationCenterStatisticsSuspenseQueryHookResult = ReturnType<
	typeof useCommunicationCenterStatisticsSuspenseQuery
>;
export type CommunicationCenterStatisticsQueryResult = Apollo.QueryResult<
	CommunicationCenterStatisticsQuery,
	CommunicationCenterStatisticsQueryVariables
>;
export const RoomCountDocument = gql`
	query roomCount($filters: [RoomFilterInput!], $pagination: Pagination, $order: RoomOrder) {
		roomConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useRoomCountQuery__
 *
 * To run a query within a React component, call `useRoomCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRoomCountQuery(baseOptions?: Apollo.QueryHookOptions<RoomCountQuery, RoomCountQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RoomCountQuery, RoomCountQueryVariables>(RoomCountDocument, options);
}
export function useRoomCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RoomCountQuery, RoomCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RoomCountQuery, RoomCountQueryVariables>(RoomCountDocument, options);
}
export function useRoomCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RoomCountQuery, RoomCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RoomCountQuery, RoomCountQueryVariables>(RoomCountDocument, options);
}
export type RoomCountQueryHookResult = ReturnType<typeof useRoomCountQuery>;
export type RoomCountLazyQueryHookResult = ReturnType<typeof useRoomCountLazyQuery>;
export type RoomCountSuspenseQueryHookResult = ReturnType<typeof useRoomCountSuspenseQuery>;
export type RoomCountQueryResult = Apollo.QueryResult<RoomCountQuery, RoomCountQueryVariables>;
export const RoomCreateDocument = gql`
	mutation roomCreate($input: RoomCreateInput!) {
		createRoom(input: $input) {
			...RoomDetail
		}
	}
	${RoomDetailFragmentDoc}
`;
export type RoomCreateMutationFn = Apollo.MutationFunction<RoomCreateMutation, RoomCreateMutationVariables>;

/**
 * __useRoomCreateMutation__
 *
 * To run a mutation, you first call `useRoomCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoomCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roomCreateMutation, { data, loading, error }] = useRoomCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRoomCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<RoomCreateMutation, RoomCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RoomCreateMutation, RoomCreateMutationVariables>(RoomCreateDocument, options);
}
export type RoomCreateMutationHookResult = ReturnType<typeof useRoomCreateMutation>;
export type RoomCreateMutationResult = Apollo.MutationResult<RoomCreateMutation>;
export type RoomCreateMutationOptions = Apollo.BaseMutationOptions<RoomCreateMutation, RoomCreateMutationVariables>;
export const RoomDeleteDocument = gql`
	mutation roomDelete($id: ID!) {
		deleteRoom(id: $id)
	}
`;
export type RoomDeleteMutationFn = Apollo.MutationFunction<RoomDeleteMutation, RoomDeleteMutationVariables>;

/**
 * __useRoomDeleteMutation__
 *
 * To run a mutation, you first call `useRoomDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoomDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roomDeleteMutation, { data, loading, error }] = useRoomDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoomDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<RoomDeleteMutation, RoomDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RoomDeleteMutation, RoomDeleteMutationVariables>(RoomDeleteDocument, options);
}
export type RoomDeleteMutationHookResult = ReturnType<typeof useRoomDeleteMutation>;
export type RoomDeleteMutationResult = Apollo.MutationResult<RoomDeleteMutation>;
export type RoomDeleteMutationOptions = Apollo.BaseMutationOptions<RoomDeleteMutation, RoomDeleteMutationVariables>;
export const RoomDetailDocument = gql`
	query roomDetail($id: ID!) {
		room(id: $id) {
			...RoomDetail
		}
	}
	${RoomDetailFragmentDoc}
`;

/**
 * __useRoomDetailQuery__
 *
 * To run a query within a React component, call `useRoomDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoomDetailQuery(baseOptions: Apollo.QueryHookOptions<RoomDetailQuery, RoomDetailQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RoomDetailQuery, RoomDetailQueryVariables>(RoomDetailDocument, options);
}
export function useRoomDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RoomDetailQuery, RoomDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RoomDetailQuery, RoomDetailQueryVariables>(RoomDetailDocument, options);
}
export function useRoomDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RoomDetailQuery, RoomDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RoomDetailQuery, RoomDetailQueryVariables>(RoomDetailDocument, options);
}
export type RoomDetailQueryHookResult = ReturnType<typeof useRoomDetailQuery>;
export type RoomDetailLazyQueryHookResult = ReturnType<typeof useRoomDetailLazyQuery>;
export type RoomDetailSuspenseQueryHookResult = ReturnType<typeof useRoomDetailSuspenseQuery>;
export type RoomDetailQueryResult = Apollo.QueryResult<RoomDetailQuery, RoomDetailQueryVariables>;
export const RoomIndexDocument = gql`
	query roomIndex($filters: [RoomFilterInput!], $pagination: Pagination, $order: RoomOrder) {
		roomConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					roomNumber
					buildingFloor {
						id
						...BuildingFloorName
						building {
							id
							...BuildingName
							campus {
								id
								...CampusName
							}
						}
					}
				}
			}
		}
	}
	${BuildingFloorNameFragmentDoc}
	${BuildingNameFragmentDoc}
	${CampusNameFragmentDoc}
`;

/**
 * __useRoomIndexQuery__
 *
 * To run a query within a React component, call `useRoomIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRoomIndexQuery(baseOptions?: Apollo.QueryHookOptions<RoomIndexQuery, RoomIndexQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RoomIndexQuery, RoomIndexQueryVariables>(RoomIndexDocument, options);
}
export function useRoomIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RoomIndexQuery, RoomIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RoomIndexQuery, RoomIndexQueryVariables>(RoomIndexDocument, options);
}
export function useRoomIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RoomIndexQuery, RoomIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RoomIndexQuery, RoomIndexQueryVariables>(RoomIndexDocument, options);
}
export type RoomIndexQueryHookResult = ReturnType<typeof useRoomIndexQuery>;
export type RoomIndexLazyQueryHookResult = ReturnType<typeof useRoomIndexLazyQuery>;
export type RoomIndexSuspenseQueryHookResult = ReturnType<typeof useRoomIndexSuspenseQuery>;
export type RoomIndexQueryResult = Apollo.QueryResult<RoomIndexQuery, RoomIndexQueryVariables>;
export const RoomNameDocument = gql`
	query roomName($id: ID!) {
		room(id: $id) {
			id
			...RoomName
		}
	}
	${RoomNameFragmentDoc}
`;

/**
 * __useRoomNameQuery__
 *
 * To run a query within a React component, call `useRoomNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoomNameQuery(baseOptions: Apollo.QueryHookOptions<RoomNameQuery, RoomNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RoomNameQuery, RoomNameQueryVariables>(RoomNameDocument, options);
}
export function useRoomNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomNameQuery, RoomNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RoomNameQuery, RoomNameQueryVariables>(RoomNameDocument, options);
}
export function useRoomNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RoomNameQuery, RoomNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RoomNameQuery, RoomNameQueryVariables>(RoomNameDocument, options);
}
export type RoomNameQueryHookResult = ReturnType<typeof useRoomNameQuery>;
export type RoomNameLazyQueryHookResult = ReturnType<typeof useRoomNameLazyQuery>;
export type RoomNameSuspenseQueryHookResult = ReturnType<typeof useRoomNameSuspenseQuery>;
export type RoomNameQueryResult = Apollo.QueryResult<RoomNameQuery, RoomNameQueryVariables>;
export const RoomNamesDocument = gql`
	query roomNames($filters: [RoomFilterInput!], $pagination: Pagination, $order: RoomOrder) {
		roomConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...RoomName
				}
			}
		}
	}
	${RoomNameFragmentDoc}
`;

/**
 * __useRoomNamesQuery__
 *
 * To run a query within a React component, call `useRoomNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRoomNamesQuery(baseOptions?: Apollo.QueryHookOptions<RoomNamesQuery, RoomNamesQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RoomNamesQuery, RoomNamesQueryVariables>(RoomNamesDocument, options);
}
export function useRoomNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RoomNamesQuery, RoomNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RoomNamesQuery, RoomNamesQueryVariables>(RoomNamesDocument, options);
}
export function useRoomNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RoomNamesQuery, RoomNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RoomNamesQuery, RoomNamesQueryVariables>(RoomNamesDocument, options);
}
export type RoomNamesQueryHookResult = ReturnType<typeof useRoomNamesQuery>;
export type RoomNamesLazyQueryHookResult = ReturnType<typeof useRoomNamesLazyQuery>;
export type RoomNamesSuspenseQueryHookResult = ReturnType<typeof useRoomNamesSuspenseQuery>;
export type RoomNamesQueryResult = Apollo.QueryResult<RoomNamesQuery, RoomNamesQueryVariables>;
export const RoomPaginationDocument = gql`
	query roomPagination($filters: [RoomFilterInput!], $order: RoomOrder) {
		roomConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useRoomPaginationQuery__
 *
 * To run a query within a React component, call `useRoomPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRoomPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<RoomPaginationQuery, RoomPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RoomPaginationQuery, RoomPaginationQueryVariables>(RoomPaginationDocument, options);
}
export function useRoomPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RoomPaginationQuery, RoomPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RoomPaginationQuery, RoomPaginationQueryVariables>(RoomPaginationDocument, options);
}
export function useRoomPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RoomPaginationQuery, RoomPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RoomPaginationQuery, RoomPaginationQueryVariables>(RoomPaginationDocument, options);
}
export type RoomPaginationQueryHookResult = ReturnType<typeof useRoomPaginationQuery>;
export type RoomPaginationLazyQueryHookResult = ReturnType<typeof useRoomPaginationLazyQuery>;
export type RoomPaginationSuspenseQueryHookResult = ReturnType<typeof useRoomPaginationSuspenseQuery>;
export type RoomPaginationQueryResult = Apollo.QueryResult<RoomPaginationQuery, RoomPaginationQueryVariables>;
export const RoomSelectDocument = gql`
	query roomSelect($filters: [RoomFilterInput!], $order: RoomOrder) {
		roomConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...RoomName
				}
			}
		}
	}
	${RoomNameFragmentDoc}
`;

/**
 * __useRoomSelectQuery__
 *
 * To run a query within a React component, call `useRoomSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useRoomSelectQuery(baseOptions?: Apollo.QueryHookOptions<RoomSelectQuery, RoomSelectQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RoomSelectQuery, RoomSelectQueryVariables>(RoomSelectDocument, options);
}
export function useRoomSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RoomSelectQuery, RoomSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RoomSelectQuery, RoomSelectQueryVariables>(RoomSelectDocument, options);
}
export function useRoomSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<RoomSelectQuery, RoomSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RoomSelectQuery, RoomSelectQueryVariables>(RoomSelectDocument, options);
}
export type RoomSelectQueryHookResult = ReturnType<typeof useRoomSelectQuery>;
export type RoomSelectLazyQueryHookResult = ReturnType<typeof useRoomSelectLazyQuery>;
export type RoomSelectSuspenseQueryHookResult = ReturnType<typeof useRoomSelectSuspenseQuery>;
export type RoomSelectQueryResult = Apollo.QueryResult<RoomSelectQuery, RoomSelectQueryVariables>;
export const RoomUpdateDocument = gql`
	mutation roomUpdate($id: ID!, $input: RoomUpdateInput!) {
		updateRoom(id: $id, input: $input) {
			...RoomDetail
		}
	}
	${RoomDetailFragmentDoc}
`;
export type RoomUpdateMutationFn = Apollo.MutationFunction<RoomUpdateMutation, RoomUpdateMutationVariables>;

/**
 * __useRoomUpdateMutation__
 *
 * To run a mutation, you first call `useRoomUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRoomUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [roomUpdateMutation, { data, loading, error }] = useRoomUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRoomUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<RoomUpdateMutation, RoomUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RoomUpdateMutation, RoomUpdateMutationVariables>(RoomUpdateDocument, options);
}
export type RoomUpdateMutationHookResult = ReturnType<typeof useRoomUpdateMutation>;
export type RoomUpdateMutationResult = Apollo.MutationResult<RoomUpdateMutation>;
export type RoomUpdateMutationOptions = Apollo.BaseMutationOptions<RoomUpdateMutation, RoomUpdateMutationVariables>;
export const CreateOrUpdateBulkSchoolAttendanceRecordsOnDateDocument = gql`
	mutation createOrUpdateBulkSchoolAttendanceRecordsOnDate(
		$attendanceDate: Date!
		$studentIDs: [ID!]!
		$attendanceStatusID: ID!
	) {
		createOrUpdateBulkSchoolAttendanceRecordsOnDate(
			attendanceDate: $attendanceDate
			studentIDs: $studentIDs
			attendanceStatusID: $attendanceStatusID
		) {
			edges {
				node {
					id
				}
			}
		}
	}
`;
export type CreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutationFn = Apollo.MutationFunction<
	CreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutation,
	CreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutationVariables
>;

/**
 * __useCreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBulkSchoolAttendanceRecordsOnDateMutation, { data, loading, error }] = useCreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutation({
 *   variables: {
 *      attendanceDate: // value for 'attendanceDate'
 *      studentIDs: // value for 'studentIDs'
 *      attendanceStatusID: // value for 'attendanceStatusID'
 *   },
 * });
 */
export function useCreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutation,
		CreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutation,
		CreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutationVariables
	>(CreateOrUpdateBulkSchoolAttendanceRecordsOnDateDocument, options);
}
export type CreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutationHookResult = ReturnType<
	typeof useCreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutation
>;
export type CreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutationResult =
	Apollo.MutationResult<CreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutation>;
export type CreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutationOptions = Apollo.BaseMutationOptions<
	CreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutation,
	CreateOrUpdateBulkSchoolAttendanceRecordsOnDateMutationVariables
>;
export const SchoolAttendanceRecordCountDocument = gql`
	query schoolAttendanceRecordCount(
		$filters: [SchoolAttendanceRecordFilterInput!]
		$pagination: Pagination
		$order: SchoolAttendanceRecordOrder
	) {
		schoolAttendanceRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useSchoolAttendanceRecordCountQuery__
 *
 * To run a query within a React component, call `useSchoolAttendanceRecordCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolAttendanceRecordCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolAttendanceRecordCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSchoolAttendanceRecordCountQuery(
	baseOptions?: Apollo.QueryHookOptions<SchoolAttendanceRecordCountQuery, SchoolAttendanceRecordCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SchoolAttendanceRecordCountQuery, SchoolAttendanceRecordCountQueryVariables>(
		SchoolAttendanceRecordCountDocument,
		options,
	);
}
export function useSchoolAttendanceRecordCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SchoolAttendanceRecordCountQuery,
		SchoolAttendanceRecordCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SchoolAttendanceRecordCountQuery, SchoolAttendanceRecordCountQueryVariables>(
		SchoolAttendanceRecordCountDocument,
		options,
	);
}
export function useSchoolAttendanceRecordCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		SchoolAttendanceRecordCountQuery,
		SchoolAttendanceRecordCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SchoolAttendanceRecordCountQuery, SchoolAttendanceRecordCountQueryVariables>(
		SchoolAttendanceRecordCountDocument,
		options,
	);
}
export type SchoolAttendanceRecordCountQueryHookResult = ReturnType<typeof useSchoolAttendanceRecordCountQuery>;
export type SchoolAttendanceRecordCountLazyQueryHookResult = ReturnType<typeof useSchoolAttendanceRecordCountLazyQuery>;
export type SchoolAttendanceRecordCountSuspenseQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordCountSuspenseQuery
>;
export type SchoolAttendanceRecordCountQueryResult = Apollo.QueryResult<
	SchoolAttendanceRecordCountQuery,
	SchoolAttendanceRecordCountQueryVariables
>;
export const SchoolAttendanceRecordCreateDocument = gql`
	mutation schoolAttendanceRecordCreate($input: SchoolAttendanceRecordCreateInput!) {
		createSchoolAttendanceRecord(input: $input) {
			...SchoolAttendanceRecordDetail
		}
	}
	${SchoolAttendanceRecordDetailFragmentDoc}
`;
export type SchoolAttendanceRecordCreateMutationFn = Apollo.MutationFunction<
	SchoolAttendanceRecordCreateMutation,
	SchoolAttendanceRecordCreateMutationVariables
>;

/**
 * __useSchoolAttendanceRecordCreateMutation__
 *
 * To run a mutation, you first call `useSchoolAttendanceRecordCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolAttendanceRecordCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolAttendanceRecordCreateMutation, { data, loading, error }] = useSchoolAttendanceRecordCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolAttendanceRecordCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SchoolAttendanceRecordCreateMutation,
		SchoolAttendanceRecordCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SchoolAttendanceRecordCreateMutation, SchoolAttendanceRecordCreateMutationVariables>(
		SchoolAttendanceRecordCreateDocument,
		options,
	);
}
export type SchoolAttendanceRecordCreateMutationHookResult = ReturnType<typeof useSchoolAttendanceRecordCreateMutation>;
export type SchoolAttendanceRecordCreateMutationResult = Apollo.MutationResult<SchoolAttendanceRecordCreateMutation>;
export type SchoolAttendanceRecordCreateMutationOptions = Apollo.BaseMutationOptions<
	SchoolAttendanceRecordCreateMutation,
	SchoolAttendanceRecordCreateMutationVariables
>;
export const SchoolAttendanceRecordDeleteDocument = gql`
	mutation schoolAttendanceRecordDelete($id: ID!) {
		deleteSchoolAttendanceRecord(id: $id)
	}
`;
export type SchoolAttendanceRecordDeleteMutationFn = Apollo.MutationFunction<
	SchoolAttendanceRecordDeleteMutation,
	SchoolAttendanceRecordDeleteMutationVariables
>;

/**
 * __useSchoolAttendanceRecordDeleteMutation__
 *
 * To run a mutation, you first call `useSchoolAttendanceRecordDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolAttendanceRecordDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolAttendanceRecordDeleteMutation, { data, loading, error }] = useSchoolAttendanceRecordDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSchoolAttendanceRecordDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SchoolAttendanceRecordDeleteMutation,
		SchoolAttendanceRecordDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SchoolAttendanceRecordDeleteMutation, SchoolAttendanceRecordDeleteMutationVariables>(
		SchoolAttendanceRecordDeleteDocument,
		options,
	);
}
export type SchoolAttendanceRecordDeleteMutationHookResult = ReturnType<typeof useSchoolAttendanceRecordDeleteMutation>;
export type SchoolAttendanceRecordDeleteMutationResult = Apollo.MutationResult<SchoolAttendanceRecordDeleteMutation>;
export type SchoolAttendanceRecordDeleteMutationOptions = Apollo.BaseMutationOptions<
	SchoolAttendanceRecordDeleteMutation,
	SchoolAttendanceRecordDeleteMutationVariables
>;
export const SchoolAttendanceRecordDetailDocument = gql`
	query schoolAttendanceRecordDetail($id: ID!) {
		schoolAttendanceRecord(id: $id) {
			...SchoolAttendanceRecordDetail
		}
	}
	${SchoolAttendanceRecordDetailFragmentDoc}
`;

/**
 * __useSchoolAttendanceRecordDetailQuery__
 *
 * To run a query within a React component, call `useSchoolAttendanceRecordDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolAttendanceRecordDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolAttendanceRecordDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSchoolAttendanceRecordDetailQuery(
	baseOptions: Apollo.QueryHookOptions<SchoolAttendanceRecordDetailQuery, SchoolAttendanceRecordDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SchoolAttendanceRecordDetailQuery, SchoolAttendanceRecordDetailQueryVariables>(
		SchoolAttendanceRecordDetailDocument,
		options,
	);
}
export function useSchoolAttendanceRecordDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SchoolAttendanceRecordDetailQuery,
		SchoolAttendanceRecordDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SchoolAttendanceRecordDetailQuery, SchoolAttendanceRecordDetailQueryVariables>(
		SchoolAttendanceRecordDetailDocument,
		options,
	);
}
export function useSchoolAttendanceRecordDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		SchoolAttendanceRecordDetailQuery,
		SchoolAttendanceRecordDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SchoolAttendanceRecordDetailQuery, SchoolAttendanceRecordDetailQueryVariables>(
		SchoolAttendanceRecordDetailDocument,
		options,
	);
}
export type SchoolAttendanceRecordDetailQueryHookResult = ReturnType<typeof useSchoolAttendanceRecordDetailQuery>;
export type SchoolAttendanceRecordDetailLazyQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordDetailLazyQuery
>;
export type SchoolAttendanceRecordDetailSuspenseQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordDetailSuspenseQuery
>;
export type SchoolAttendanceRecordDetailQueryResult = Apollo.QueryResult<
	SchoolAttendanceRecordDetailQuery,
	SchoolAttendanceRecordDetailQueryVariables
>;
export const SchoolAttendanceRecordIndexDocument = gql`
	query schoolAttendanceRecordIndex(
		$filters: [SchoolAttendanceRecordFilterInput!]
		$pagination: Pagination
		$order: SchoolAttendanceRecordOrder
	) {
		schoolAttendanceRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					attendanceDate
					arrivalTime
					departureTime
					notes
					wasSetByCourseAttendance
				}
			}
		}
	}
`;

/**
 * __useSchoolAttendanceRecordIndexQuery__
 *
 * To run a query within a React component, call `useSchoolAttendanceRecordIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolAttendanceRecordIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolAttendanceRecordIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSchoolAttendanceRecordIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<SchoolAttendanceRecordIndexQuery, SchoolAttendanceRecordIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SchoolAttendanceRecordIndexQuery, SchoolAttendanceRecordIndexQueryVariables>(
		SchoolAttendanceRecordIndexDocument,
		options,
	);
}
export function useSchoolAttendanceRecordIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SchoolAttendanceRecordIndexQuery,
		SchoolAttendanceRecordIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SchoolAttendanceRecordIndexQuery, SchoolAttendanceRecordIndexQueryVariables>(
		SchoolAttendanceRecordIndexDocument,
		options,
	);
}
export function useSchoolAttendanceRecordIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		SchoolAttendanceRecordIndexQuery,
		SchoolAttendanceRecordIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SchoolAttendanceRecordIndexQuery, SchoolAttendanceRecordIndexQueryVariables>(
		SchoolAttendanceRecordIndexDocument,
		options,
	);
}
export type SchoolAttendanceRecordIndexQueryHookResult = ReturnType<typeof useSchoolAttendanceRecordIndexQuery>;
export type SchoolAttendanceRecordIndexLazyQueryHookResult = ReturnType<typeof useSchoolAttendanceRecordIndexLazyQuery>;
export type SchoolAttendanceRecordIndexSuspenseQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordIndexSuspenseQuery
>;
export type SchoolAttendanceRecordIndexQueryResult = Apollo.QueryResult<
	SchoolAttendanceRecordIndexQuery,
	SchoolAttendanceRecordIndexQueryVariables
>;
export const SchoolAttendanceRecordListDocument = gql`
	query schoolAttendanceRecordList(
		$filters: [SchoolAttendanceRecordFilterInput!]
		$pagination: Pagination
		$order: SchoolAttendanceRecordOrder
	) {
		schoolAttendanceRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					attendanceDate
					arrivalTime
					departureTime
					notes
					wasSetByCourseAttendance
					attendanceStatus {
						id
						...AttendanceStatusName
						description
						...AttendanceStatusInfo
					}
					author {
						id
						...UserName
					}
					student {
						id
						...StudentName
					}
				}
			}
		}
	}
	${AttendanceStatusNameFragmentDoc}
	${AttendanceStatusInfoFragmentDoc}
	${UserNameFragmentDoc}
	${StudentNameFragmentDoc}
`;

/**
 * __useSchoolAttendanceRecordListQuery__
 *
 * To run a query within a React component, call `useSchoolAttendanceRecordListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolAttendanceRecordListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolAttendanceRecordListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSchoolAttendanceRecordListQuery(
	baseOptions?: Apollo.QueryHookOptions<SchoolAttendanceRecordListQuery, SchoolAttendanceRecordListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SchoolAttendanceRecordListQuery, SchoolAttendanceRecordListQueryVariables>(
		SchoolAttendanceRecordListDocument,
		options,
	);
}
export function useSchoolAttendanceRecordListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SchoolAttendanceRecordListQuery, SchoolAttendanceRecordListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SchoolAttendanceRecordListQuery, SchoolAttendanceRecordListQueryVariables>(
		SchoolAttendanceRecordListDocument,
		options,
	);
}
export function useSchoolAttendanceRecordListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		SchoolAttendanceRecordListQuery,
		SchoolAttendanceRecordListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SchoolAttendanceRecordListQuery, SchoolAttendanceRecordListQueryVariables>(
		SchoolAttendanceRecordListDocument,
		options,
	);
}
export type SchoolAttendanceRecordListQueryHookResult = ReturnType<typeof useSchoolAttendanceRecordListQuery>;
export type SchoolAttendanceRecordListLazyQueryHookResult = ReturnType<typeof useSchoolAttendanceRecordListLazyQuery>;
export type SchoolAttendanceRecordListSuspenseQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordListSuspenseQuery
>;
export type SchoolAttendanceRecordListQueryResult = Apollo.QueryResult<
	SchoolAttendanceRecordListQuery,
	SchoolAttendanceRecordListQueryVariables
>;
export const SchoolAttendanceRecordListForCourseAttendanceDocument = gql`
	query schoolAttendanceRecordListForCourseAttendance(
		$filters: [SchoolAttendanceRecordFilterInput!]
		$pagination: Pagination
		$order: SchoolAttendanceRecordOrder
	) {
		schoolAttendanceRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					studentID
					attendanceStatusID
				}
			}
		}
	}
`;

/**
 * __useSchoolAttendanceRecordListForCourseAttendanceQuery__
 *
 * To run a query within a React component, call `useSchoolAttendanceRecordListForCourseAttendanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolAttendanceRecordListForCourseAttendanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolAttendanceRecordListForCourseAttendanceQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSchoolAttendanceRecordListForCourseAttendanceQuery(
	baseOptions?: Apollo.QueryHookOptions<
		SchoolAttendanceRecordListForCourseAttendanceQuery,
		SchoolAttendanceRecordListForCourseAttendanceQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SchoolAttendanceRecordListForCourseAttendanceQuery,
		SchoolAttendanceRecordListForCourseAttendanceQueryVariables
	>(SchoolAttendanceRecordListForCourseAttendanceDocument, options);
}
export function useSchoolAttendanceRecordListForCourseAttendanceLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SchoolAttendanceRecordListForCourseAttendanceQuery,
		SchoolAttendanceRecordListForCourseAttendanceQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SchoolAttendanceRecordListForCourseAttendanceQuery,
		SchoolAttendanceRecordListForCourseAttendanceQueryVariables
	>(SchoolAttendanceRecordListForCourseAttendanceDocument, options);
}
export function useSchoolAttendanceRecordListForCourseAttendanceSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		SchoolAttendanceRecordListForCourseAttendanceQuery,
		SchoolAttendanceRecordListForCourseAttendanceQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		SchoolAttendanceRecordListForCourseAttendanceQuery,
		SchoolAttendanceRecordListForCourseAttendanceQueryVariables
	>(SchoolAttendanceRecordListForCourseAttendanceDocument, options);
}
export type SchoolAttendanceRecordListForCourseAttendanceQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordListForCourseAttendanceQuery
>;
export type SchoolAttendanceRecordListForCourseAttendanceLazyQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordListForCourseAttendanceLazyQuery
>;
export type SchoolAttendanceRecordListForCourseAttendanceSuspenseQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordListForCourseAttendanceSuspenseQuery
>;
export type SchoolAttendanceRecordListForCourseAttendanceQueryResult = Apollo.QueryResult<
	SchoolAttendanceRecordListForCourseAttendanceQuery,
	SchoolAttendanceRecordListForCourseAttendanceQueryVariables
>;
export const SchoolAttendanceRecordNameDocument = gql`
	query schoolAttendanceRecordName($id: ID!) {
		schoolAttendanceRecord(id: $id) {
			id
			...SchoolAttendanceRecordName
		}
	}
	${SchoolAttendanceRecordNameFragmentDoc}
`;

/**
 * __useSchoolAttendanceRecordNameQuery__
 *
 * To run a query within a React component, call `useSchoolAttendanceRecordNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolAttendanceRecordNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolAttendanceRecordNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSchoolAttendanceRecordNameQuery(
	baseOptions: Apollo.QueryHookOptions<SchoolAttendanceRecordNameQuery, SchoolAttendanceRecordNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SchoolAttendanceRecordNameQuery, SchoolAttendanceRecordNameQueryVariables>(
		SchoolAttendanceRecordNameDocument,
		options,
	);
}
export function useSchoolAttendanceRecordNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SchoolAttendanceRecordNameQuery, SchoolAttendanceRecordNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SchoolAttendanceRecordNameQuery, SchoolAttendanceRecordNameQueryVariables>(
		SchoolAttendanceRecordNameDocument,
		options,
	);
}
export function useSchoolAttendanceRecordNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		SchoolAttendanceRecordNameQuery,
		SchoolAttendanceRecordNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SchoolAttendanceRecordNameQuery, SchoolAttendanceRecordNameQueryVariables>(
		SchoolAttendanceRecordNameDocument,
		options,
	);
}
export type SchoolAttendanceRecordNameQueryHookResult = ReturnType<typeof useSchoolAttendanceRecordNameQuery>;
export type SchoolAttendanceRecordNameLazyQueryHookResult = ReturnType<typeof useSchoolAttendanceRecordNameLazyQuery>;
export type SchoolAttendanceRecordNameSuspenseQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordNameSuspenseQuery
>;
export type SchoolAttendanceRecordNameQueryResult = Apollo.QueryResult<
	SchoolAttendanceRecordNameQuery,
	SchoolAttendanceRecordNameQueryVariables
>;
export const SchoolAttendanceRecordNamesDocument = gql`
	query schoolAttendanceRecordNames(
		$filters: [SchoolAttendanceRecordFilterInput!]
		$pagination: Pagination
		$order: SchoolAttendanceRecordOrder
	) {
		schoolAttendanceRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...SchoolAttendanceRecordName
				}
			}
		}
	}
	${SchoolAttendanceRecordNameFragmentDoc}
`;

/**
 * __useSchoolAttendanceRecordNamesQuery__
 *
 * To run a query within a React component, call `useSchoolAttendanceRecordNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolAttendanceRecordNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolAttendanceRecordNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSchoolAttendanceRecordNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<SchoolAttendanceRecordNamesQuery, SchoolAttendanceRecordNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SchoolAttendanceRecordNamesQuery, SchoolAttendanceRecordNamesQueryVariables>(
		SchoolAttendanceRecordNamesDocument,
		options,
	);
}
export function useSchoolAttendanceRecordNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SchoolAttendanceRecordNamesQuery,
		SchoolAttendanceRecordNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SchoolAttendanceRecordNamesQuery, SchoolAttendanceRecordNamesQueryVariables>(
		SchoolAttendanceRecordNamesDocument,
		options,
	);
}
export function useSchoolAttendanceRecordNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		SchoolAttendanceRecordNamesQuery,
		SchoolAttendanceRecordNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SchoolAttendanceRecordNamesQuery, SchoolAttendanceRecordNamesQueryVariables>(
		SchoolAttendanceRecordNamesDocument,
		options,
	);
}
export type SchoolAttendanceRecordNamesQueryHookResult = ReturnType<typeof useSchoolAttendanceRecordNamesQuery>;
export type SchoolAttendanceRecordNamesLazyQueryHookResult = ReturnType<typeof useSchoolAttendanceRecordNamesLazyQuery>;
export type SchoolAttendanceRecordNamesSuspenseQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordNamesSuspenseQuery
>;
export type SchoolAttendanceRecordNamesQueryResult = Apollo.QueryResult<
	SchoolAttendanceRecordNamesQuery,
	SchoolAttendanceRecordNamesQueryVariables
>;
export const SchoolAttendanceRecordPaginationDocument = gql`
	query schoolAttendanceRecordPagination(
		$filters: [SchoolAttendanceRecordFilterInput!]
		$order: SchoolAttendanceRecordOrder
	) {
		schoolAttendanceRecordConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useSchoolAttendanceRecordPaginationQuery__
 *
 * To run a query within a React component, call `useSchoolAttendanceRecordPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolAttendanceRecordPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolAttendanceRecordPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSchoolAttendanceRecordPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		SchoolAttendanceRecordPaginationQuery,
		SchoolAttendanceRecordPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SchoolAttendanceRecordPaginationQuery, SchoolAttendanceRecordPaginationQueryVariables>(
		SchoolAttendanceRecordPaginationDocument,
		options,
	);
}
export function useSchoolAttendanceRecordPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SchoolAttendanceRecordPaginationQuery,
		SchoolAttendanceRecordPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SchoolAttendanceRecordPaginationQuery, SchoolAttendanceRecordPaginationQueryVariables>(
		SchoolAttendanceRecordPaginationDocument,
		options,
	);
}
export function useSchoolAttendanceRecordPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		SchoolAttendanceRecordPaginationQuery,
		SchoolAttendanceRecordPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SchoolAttendanceRecordPaginationQuery, SchoolAttendanceRecordPaginationQueryVariables>(
		SchoolAttendanceRecordPaginationDocument,
		options,
	);
}
export type SchoolAttendanceRecordPaginationQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordPaginationQuery
>;
export type SchoolAttendanceRecordPaginationLazyQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordPaginationLazyQuery
>;
export type SchoolAttendanceRecordPaginationSuspenseQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordPaginationSuspenseQuery
>;
export type SchoolAttendanceRecordPaginationQueryResult = Apollo.QueryResult<
	SchoolAttendanceRecordPaginationQuery,
	SchoolAttendanceRecordPaginationQueryVariables
>;
export const SchoolAttendanceRecordSelectDocument = gql`
	query schoolAttendanceRecordSelect(
		$filters: [SchoolAttendanceRecordFilterInput!]
		$order: SchoolAttendanceRecordOrder
	) {
		schoolAttendanceRecordConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...SchoolAttendanceRecordName
				}
			}
		}
	}
	${SchoolAttendanceRecordNameFragmentDoc}
`;

/**
 * __useSchoolAttendanceRecordSelectQuery__
 *
 * To run a query within a React component, call `useSchoolAttendanceRecordSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolAttendanceRecordSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolAttendanceRecordSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSchoolAttendanceRecordSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<SchoolAttendanceRecordSelectQuery, SchoolAttendanceRecordSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SchoolAttendanceRecordSelectQuery, SchoolAttendanceRecordSelectQueryVariables>(
		SchoolAttendanceRecordSelectDocument,
		options,
	);
}
export function useSchoolAttendanceRecordSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SchoolAttendanceRecordSelectQuery,
		SchoolAttendanceRecordSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SchoolAttendanceRecordSelectQuery, SchoolAttendanceRecordSelectQueryVariables>(
		SchoolAttendanceRecordSelectDocument,
		options,
	);
}
export function useSchoolAttendanceRecordSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		SchoolAttendanceRecordSelectQuery,
		SchoolAttendanceRecordSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SchoolAttendanceRecordSelectQuery, SchoolAttendanceRecordSelectQueryVariables>(
		SchoolAttendanceRecordSelectDocument,
		options,
	);
}
export type SchoolAttendanceRecordSelectQueryHookResult = ReturnType<typeof useSchoolAttendanceRecordSelectQuery>;
export type SchoolAttendanceRecordSelectLazyQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordSelectLazyQuery
>;
export type SchoolAttendanceRecordSelectSuspenseQueryHookResult = ReturnType<
	typeof useSchoolAttendanceRecordSelectSuspenseQuery
>;
export type SchoolAttendanceRecordSelectQueryResult = Apollo.QueryResult<
	SchoolAttendanceRecordSelectQuery,
	SchoolAttendanceRecordSelectQueryVariables
>;
export const StudentSchoolAttendanceRecordsDocument = gql`
	query studentSchoolAttendanceRecords(
		$filters: [SchoolAttendanceRecordFilterInput!]
		$pagination: Pagination
		$order: SchoolAttendanceRecordOrder
	) {
		schoolAttendanceRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					attendanceDate
					notes
					arrivalTime
					departureTime
					wasSetByCourseAttendance
					attendanceStatus {
						id
						...AttendanceStatusName
						indicatesAbsent
						indicatesLateArrival
						indicatesEarlyDeparture
						indicatesExcused
					}
					author {
						id
						...UserName
					}
				}
			}
		}
	}
	${AttendanceStatusNameFragmentDoc}
	${UserNameFragmentDoc}
`;

/**
 * __useStudentSchoolAttendanceRecordsQuery__
 *
 * To run a query within a React component, call `useStudentSchoolAttendanceRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentSchoolAttendanceRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentSchoolAttendanceRecordsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentSchoolAttendanceRecordsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentSchoolAttendanceRecordsQuery,
		StudentSchoolAttendanceRecordsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentSchoolAttendanceRecordsQuery, StudentSchoolAttendanceRecordsQueryVariables>(
		StudentSchoolAttendanceRecordsDocument,
		options,
	);
}
export function useStudentSchoolAttendanceRecordsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentSchoolAttendanceRecordsQuery,
		StudentSchoolAttendanceRecordsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentSchoolAttendanceRecordsQuery, StudentSchoolAttendanceRecordsQueryVariables>(
		StudentSchoolAttendanceRecordsDocument,
		options,
	);
}
export function useStudentSchoolAttendanceRecordsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentSchoolAttendanceRecordsQuery,
		StudentSchoolAttendanceRecordsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentSchoolAttendanceRecordsQuery, StudentSchoolAttendanceRecordsQueryVariables>(
		StudentSchoolAttendanceRecordsDocument,
		options,
	);
}
export type StudentSchoolAttendanceRecordsQueryHookResult = ReturnType<typeof useStudentSchoolAttendanceRecordsQuery>;
export type StudentSchoolAttendanceRecordsLazyQueryHookResult = ReturnType<
	typeof useStudentSchoolAttendanceRecordsLazyQuery
>;
export type StudentSchoolAttendanceRecordsSuspenseQueryHookResult = ReturnType<
	typeof useStudentSchoolAttendanceRecordsSuspenseQuery
>;
export type StudentSchoolAttendanceRecordsQueryResult = Apollo.QueryResult<
	StudentSchoolAttendanceRecordsQuery,
	StudentSchoolAttendanceRecordsQueryVariables
>;
export const SchoolAttendanceRecordUpdateDocument = gql`
	mutation schoolAttendanceRecordUpdate($id: ID!, $input: SchoolAttendanceRecordUpdateInput!) {
		updateSchoolAttendanceRecord(id: $id, input: $input) {
			...SchoolAttendanceRecordDetail
		}
	}
	${SchoolAttendanceRecordDetailFragmentDoc}
`;
export type SchoolAttendanceRecordUpdateMutationFn = Apollo.MutationFunction<
	SchoolAttendanceRecordUpdateMutation,
	SchoolAttendanceRecordUpdateMutationVariables
>;

/**
 * __useSchoolAttendanceRecordUpdateMutation__
 *
 * To run a mutation, you first call `useSchoolAttendanceRecordUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolAttendanceRecordUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolAttendanceRecordUpdateMutation, { data, loading, error }] = useSchoolAttendanceRecordUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolAttendanceRecordUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SchoolAttendanceRecordUpdateMutation,
		SchoolAttendanceRecordUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SchoolAttendanceRecordUpdateMutation, SchoolAttendanceRecordUpdateMutationVariables>(
		SchoolAttendanceRecordUpdateDocument,
		options,
	);
}
export type SchoolAttendanceRecordUpdateMutationHookResult = ReturnType<typeof useSchoolAttendanceRecordUpdateMutation>;
export type SchoolAttendanceRecordUpdateMutationResult = Apollo.MutationResult<SchoolAttendanceRecordUpdateMutation>;
export type SchoolAttendanceRecordUpdateMutationOptions = Apollo.BaseMutationOptions<
	SchoolAttendanceRecordUpdateMutation,
	SchoolAttendanceRecordUpdateMutationVariables
>;
export const ServiceCountDocument = gql`
	query serviceCount($filters: [ServiceFilterInput!], $pagination: Pagination, $order: ServiceOrder) {
		serviceConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useServiceCountQuery__
 *
 * To run a query within a React component, call `useServiceCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useServiceCountQuery(
	baseOptions?: Apollo.QueryHookOptions<ServiceCountQuery, ServiceCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ServiceCountQuery, ServiceCountQueryVariables>(ServiceCountDocument, options);
}
export function useServiceCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ServiceCountQuery, ServiceCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ServiceCountQuery, ServiceCountQueryVariables>(ServiceCountDocument, options);
}
export function useServiceCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceCountQuery, ServiceCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ServiceCountQuery, ServiceCountQueryVariables>(ServiceCountDocument, options);
}
export type ServiceCountQueryHookResult = ReturnType<typeof useServiceCountQuery>;
export type ServiceCountLazyQueryHookResult = ReturnType<typeof useServiceCountLazyQuery>;
export type ServiceCountSuspenseQueryHookResult = ReturnType<typeof useServiceCountSuspenseQuery>;
export type ServiceCountQueryResult = Apollo.QueryResult<ServiceCountQuery, ServiceCountQueryVariables>;
export const ServiceCreateDocument = gql`
	mutation serviceCreate($input: ServiceCreateInput!) {
		createService(input: $input) {
			...ServiceDetail
		}
	}
	${ServiceDetailFragmentDoc}
`;
export type ServiceCreateMutationFn = Apollo.MutationFunction<ServiceCreateMutation, ServiceCreateMutationVariables>;

/**
 * __useServiceCreateMutation__
 *
 * To run a mutation, you first call `useServiceCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useServiceCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serviceCreateMutation, { data, loading, error }] = useServiceCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useServiceCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<ServiceCreateMutation, ServiceCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ServiceCreateMutation, ServiceCreateMutationVariables>(ServiceCreateDocument, options);
}
export type ServiceCreateMutationHookResult = ReturnType<typeof useServiceCreateMutation>;
export type ServiceCreateMutationResult = Apollo.MutationResult<ServiceCreateMutation>;
export type ServiceCreateMutationOptions = Apollo.BaseMutationOptions<
	ServiceCreateMutation,
	ServiceCreateMutationVariables
>;
export const ServiceDeleteDocument = gql`
	mutation serviceDelete($id: ID!) {
		deleteService(id: $id)
	}
`;
export type ServiceDeleteMutationFn = Apollo.MutationFunction<ServiceDeleteMutation, ServiceDeleteMutationVariables>;

/**
 * __useServiceDeleteMutation__
 *
 * To run a mutation, you first call `useServiceDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useServiceDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serviceDeleteMutation, { data, loading, error }] = useServiceDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useServiceDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<ServiceDeleteMutation, ServiceDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ServiceDeleteMutation, ServiceDeleteMutationVariables>(ServiceDeleteDocument, options);
}
export type ServiceDeleteMutationHookResult = ReturnType<typeof useServiceDeleteMutation>;
export type ServiceDeleteMutationResult = Apollo.MutationResult<ServiceDeleteMutation>;
export type ServiceDeleteMutationOptions = Apollo.BaseMutationOptions<
	ServiceDeleteMutation,
	ServiceDeleteMutationVariables
>;
export const ServiceDetailDocument = gql`
	query serviceDetail($id: ID!) {
		service(id: $id) {
			...ServiceDetail
		}
	}
	${ServiceDetailFragmentDoc}
`;

/**
 * __useServiceDetailQuery__
 *
 * To run a query within a React component, call `useServiceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useServiceDetailQuery(
	baseOptions: Apollo.QueryHookOptions<ServiceDetailQuery, ServiceDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ServiceDetailQuery, ServiceDetailQueryVariables>(ServiceDetailDocument, options);
}
export function useServiceDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ServiceDetailQuery, ServiceDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ServiceDetailQuery, ServiceDetailQueryVariables>(ServiceDetailDocument, options);
}
export function useServiceDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceDetailQuery, ServiceDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ServiceDetailQuery, ServiceDetailQueryVariables>(ServiceDetailDocument, options);
}
export type ServiceDetailQueryHookResult = ReturnType<typeof useServiceDetailQuery>;
export type ServiceDetailLazyQueryHookResult = ReturnType<typeof useServiceDetailLazyQuery>;
export type ServiceDetailSuspenseQueryHookResult = ReturnType<typeof useServiceDetailSuspenseQuery>;
export type ServiceDetailQueryResult = Apollo.QueryResult<ServiceDetailQuery, ServiceDetailQueryVariables>;
export const ServiceIndexDocument = gql`
	query serviceIndex($filters: [ServiceFilterInput!], $pagination: Pagination, $order: ServiceOrder) {
		serviceConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					description
					category
					isActive
					price
				}
			}
		}
	}
`;

/**
 * __useServiceIndexQuery__
 *
 * To run a query within a React component, call `useServiceIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useServiceIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<ServiceIndexQuery, ServiceIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ServiceIndexQuery, ServiceIndexQueryVariables>(ServiceIndexDocument, options);
}
export function useServiceIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ServiceIndexQuery, ServiceIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ServiceIndexQuery, ServiceIndexQueryVariables>(ServiceIndexDocument, options);
}
export function useServiceIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceIndexQuery, ServiceIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ServiceIndexQuery, ServiceIndexQueryVariables>(ServiceIndexDocument, options);
}
export type ServiceIndexQueryHookResult = ReturnType<typeof useServiceIndexQuery>;
export type ServiceIndexLazyQueryHookResult = ReturnType<typeof useServiceIndexLazyQuery>;
export type ServiceIndexSuspenseQueryHookResult = ReturnType<typeof useServiceIndexSuspenseQuery>;
export type ServiceIndexQueryResult = Apollo.QueryResult<ServiceIndexQuery, ServiceIndexQueryVariables>;
export const ServiceInformationListDocument = gql`
	query serviceInformationList($filters: [ServiceFilterInput!], $pagination: Pagination, $order: ServiceOrder) {
		serviceConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					description
					category
					isActive
					price
				}
			}
		}
	}
`;

/**
 * __useServiceInformationListQuery__
 *
 * To run a query within a React component, call `useServiceInformationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceInformationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceInformationListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useServiceInformationListQuery(
	baseOptions?: Apollo.QueryHookOptions<ServiceInformationListQuery, ServiceInformationListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ServiceInformationListQuery, ServiceInformationListQueryVariables>(
		ServiceInformationListDocument,
		options,
	);
}
export function useServiceInformationListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ServiceInformationListQuery, ServiceInformationListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ServiceInformationListQuery, ServiceInformationListQueryVariables>(
		ServiceInformationListDocument,
		options,
	);
}
export function useServiceInformationListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceInformationListQuery, ServiceInformationListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ServiceInformationListQuery, ServiceInformationListQueryVariables>(
		ServiceInformationListDocument,
		options,
	);
}
export type ServiceInformationListQueryHookResult = ReturnType<typeof useServiceInformationListQuery>;
export type ServiceInformationListLazyQueryHookResult = ReturnType<typeof useServiceInformationListLazyQuery>;
export type ServiceInformationListSuspenseQueryHookResult = ReturnType<typeof useServiceInformationListSuspenseQuery>;
export type ServiceInformationListQueryResult = Apollo.QueryResult<
	ServiceInformationListQuery,
	ServiceInformationListQueryVariables
>;
export const ServiceNameDocument = gql`
	query serviceName($id: ID!) {
		service(id: $id) {
			id
			...ServiceName
		}
	}
	${ServiceNameFragmentDoc}
`;

/**
 * __useServiceNameQuery__
 *
 * To run a query within a React component, call `useServiceNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useServiceNameQuery(baseOptions: Apollo.QueryHookOptions<ServiceNameQuery, ServiceNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ServiceNameQuery, ServiceNameQueryVariables>(ServiceNameDocument, options);
}
export function useServiceNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ServiceNameQuery, ServiceNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ServiceNameQuery, ServiceNameQueryVariables>(ServiceNameDocument, options);
}
export function useServiceNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceNameQuery, ServiceNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ServiceNameQuery, ServiceNameQueryVariables>(ServiceNameDocument, options);
}
export type ServiceNameQueryHookResult = ReturnType<typeof useServiceNameQuery>;
export type ServiceNameLazyQueryHookResult = ReturnType<typeof useServiceNameLazyQuery>;
export type ServiceNameSuspenseQueryHookResult = ReturnType<typeof useServiceNameSuspenseQuery>;
export type ServiceNameQueryResult = Apollo.QueryResult<ServiceNameQuery, ServiceNameQueryVariables>;
export const ServiceNamesDocument = gql`
	query serviceNames($filters: [ServiceFilterInput!], $pagination: Pagination, $order: ServiceOrder) {
		serviceConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...ServiceName
				}
			}
		}
	}
	${ServiceNameFragmentDoc}
`;

/**
 * __useServiceNamesQuery__
 *
 * To run a query within a React component, call `useServiceNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useServiceNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<ServiceNamesQuery, ServiceNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ServiceNamesQuery, ServiceNamesQueryVariables>(ServiceNamesDocument, options);
}
export function useServiceNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ServiceNamesQuery, ServiceNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ServiceNamesQuery, ServiceNamesQueryVariables>(ServiceNamesDocument, options);
}
export function useServiceNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceNamesQuery, ServiceNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ServiceNamesQuery, ServiceNamesQueryVariables>(ServiceNamesDocument, options);
}
export type ServiceNamesQueryHookResult = ReturnType<typeof useServiceNamesQuery>;
export type ServiceNamesLazyQueryHookResult = ReturnType<typeof useServiceNamesLazyQuery>;
export type ServiceNamesSuspenseQueryHookResult = ReturnType<typeof useServiceNamesSuspenseQuery>;
export type ServiceNamesQueryResult = Apollo.QueryResult<ServiceNamesQuery, ServiceNamesQueryVariables>;
export const ServicePaginationDocument = gql`
	query servicePagination($filters: [ServiceFilterInput!], $order: ServiceOrder) {
		serviceConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useServicePaginationQuery__
 *
 * To run a query within a React component, call `useServicePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useServicePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<ServicePaginationQuery, ServicePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ServicePaginationQuery, ServicePaginationQueryVariables>(ServicePaginationDocument, options);
}
export function useServicePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ServicePaginationQuery, ServicePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ServicePaginationQuery, ServicePaginationQueryVariables>(
		ServicePaginationDocument,
		options,
	);
}
export function useServicePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ServicePaginationQuery, ServicePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ServicePaginationQuery, ServicePaginationQueryVariables>(
		ServicePaginationDocument,
		options,
	);
}
export type ServicePaginationQueryHookResult = ReturnType<typeof useServicePaginationQuery>;
export type ServicePaginationLazyQueryHookResult = ReturnType<typeof useServicePaginationLazyQuery>;
export type ServicePaginationSuspenseQueryHookResult = ReturnType<typeof useServicePaginationSuspenseQuery>;
export type ServicePaginationQueryResult = Apollo.QueryResult<ServicePaginationQuery, ServicePaginationQueryVariables>;
export const ServiceSelectDocument = gql`
	query serviceSelect($filters: [ServiceFilterInput!], $order: ServiceOrder) {
		serviceConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...ServiceName
					price
				}
			}
		}
	}
	${ServiceNameFragmentDoc}
`;

/**
 * __useServiceSelectQuery__
 *
 * To run a query within a React component, call `useServiceSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useServiceSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<ServiceSelectQuery, ServiceSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ServiceSelectQuery, ServiceSelectQueryVariables>(ServiceSelectDocument, options);
}
export function useServiceSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ServiceSelectQuery, ServiceSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ServiceSelectQuery, ServiceSelectQueryVariables>(ServiceSelectDocument, options);
}
export function useServiceSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceSelectQuery, ServiceSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ServiceSelectQuery, ServiceSelectQueryVariables>(ServiceSelectDocument, options);
}
export type ServiceSelectQueryHookResult = ReturnType<typeof useServiceSelectQuery>;
export type ServiceSelectLazyQueryHookResult = ReturnType<typeof useServiceSelectLazyQuery>;
export type ServiceSelectSuspenseQueryHookResult = ReturnType<typeof useServiceSelectSuspenseQuery>;
export type ServiceSelectQueryResult = Apollo.QueryResult<ServiceSelectQuery, ServiceSelectQueryVariables>;
export const ServiceUpdateDocument = gql`
	mutation serviceUpdate($id: ID!, $input: ServiceUpdateInput!) {
		updateService(id: $id, input: $input) {
			...ServiceDetail
		}
	}
	${ServiceDetailFragmentDoc}
`;
export type ServiceUpdateMutationFn = Apollo.MutationFunction<ServiceUpdateMutation, ServiceUpdateMutationVariables>;

/**
 * __useServiceUpdateMutation__
 *
 * To run a mutation, you first call `useServiceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useServiceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serviceUpdateMutation, { data, loading, error }] = useServiceUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useServiceUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<ServiceUpdateMutation, ServiceUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ServiceUpdateMutation, ServiceUpdateMutationVariables>(ServiceUpdateDocument, options);
}
export type ServiceUpdateMutationHookResult = ReturnType<typeof useServiceUpdateMutation>;
export type ServiceUpdateMutationResult = Apollo.MutationResult<ServiceUpdateMutation>;
export type ServiceUpdateMutationOptions = Apollo.BaseMutationOptions<
	ServiceUpdateMutation,
	ServiceUpdateMutationVariables
>;
export const SessionCountDocument = gql`
	query sessionCount($filters: [SessionFilterInput!], $pagination: Pagination, $order: SessionOrder) {
		sessionConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useSessionCountQuery__
 *
 * To run a query within a React component, call `useSessionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSessionCountQuery(
	baseOptions?: Apollo.QueryHookOptions<SessionCountQuery, SessionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SessionCountQuery, SessionCountQueryVariables>(SessionCountDocument, options);
}
export function useSessionCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SessionCountQuery, SessionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SessionCountQuery, SessionCountQueryVariables>(SessionCountDocument, options);
}
export function useSessionCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SessionCountQuery, SessionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SessionCountQuery, SessionCountQueryVariables>(SessionCountDocument, options);
}
export type SessionCountQueryHookResult = ReturnType<typeof useSessionCountQuery>;
export type SessionCountLazyQueryHookResult = ReturnType<typeof useSessionCountLazyQuery>;
export type SessionCountSuspenseQueryHookResult = ReturnType<typeof useSessionCountSuspenseQuery>;
export type SessionCountQueryResult = Apollo.QueryResult<SessionCountQuery, SessionCountQueryVariables>;
export const SessionDetailDocument = gql`
	query sessionDetail($id: ID!) {
		session(id: $id) {
			...SessionDetail
		}
	}
	${SessionDetailFragmentDoc}
`;

/**
 * __useSessionDetailQuery__
 *
 * To run a query within a React component, call `useSessionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSessionDetailQuery(
	baseOptions: Apollo.QueryHookOptions<SessionDetailQuery, SessionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SessionDetailQuery, SessionDetailQueryVariables>(SessionDetailDocument, options);
}
export function useSessionDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SessionDetailQuery, SessionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SessionDetailQuery, SessionDetailQueryVariables>(SessionDetailDocument, options);
}
export function useSessionDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SessionDetailQuery, SessionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SessionDetailQuery, SessionDetailQueryVariables>(SessionDetailDocument, options);
}
export type SessionDetailQueryHookResult = ReturnType<typeof useSessionDetailQuery>;
export type SessionDetailLazyQueryHookResult = ReturnType<typeof useSessionDetailLazyQuery>;
export type SessionDetailSuspenseQueryHookResult = ReturnType<typeof useSessionDetailSuspenseQuery>;
export type SessionDetailQueryResult = Apollo.QueryResult<SessionDetailQuery, SessionDetailQueryVariables>;
export const SessionIndexDocument = gql`
	query sessionIndex($filters: [SessionFilterInput!], $pagination: Pagination, $order: SessionOrder) {
		sessionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					updatedAt
					expiresAt
					longestInactiveSec
					isVerified
					isCurrent
				}
			}
		}
	}
`;

/**
 * __useSessionIndexQuery__
 *
 * To run a query within a React component, call `useSessionIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSessionIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<SessionIndexQuery, SessionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SessionIndexQuery, SessionIndexQueryVariables>(SessionIndexDocument, options);
}
export function useSessionIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SessionIndexQuery, SessionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SessionIndexQuery, SessionIndexQueryVariables>(SessionIndexDocument, options);
}
export function useSessionIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SessionIndexQuery, SessionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SessionIndexQuery, SessionIndexQueryVariables>(SessionIndexDocument, options);
}
export type SessionIndexQueryHookResult = ReturnType<typeof useSessionIndexQuery>;
export type SessionIndexLazyQueryHookResult = ReturnType<typeof useSessionIndexLazyQuery>;
export type SessionIndexSuspenseQueryHookResult = ReturnType<typeof useSessionIndexSuspenseQuery>;
export type SessionIndexQueryResult = Apollo.QueryResult<SessionIndexQuery, SessionIndexQueryVariables>;
export const SessionNameDocument = gql`
	query sessionName($id: ID!) {
		session(id: $id) {
			id
			...SessionName
		}
	}
	${SessionNameFragmentDoc}
`;

/**
 * __useSessionNameQuery__
 *
 * To run a query within a React component, call `useSessionNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSessionNameQuery(baseOptions: Apollo.QueryHookOptions<SessionNameQuery, SessionNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SessionNameQuery, SessionNameQueryVariables>(SessionNameDocument, options);
}
export function useSessionNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SessionNameQuery, SessionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SessionNameQuery, SessionNameQueryVariables>(SessionNameDocument, options);
}
export function useSessionNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SessionNameQuery, SessionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SessionNameQuery, SessionNameQueryVariables>(SessionNameDocument, options);
}
export type SessionNameQueryHookResult = ReturnType<typeof useSessionNameQuery>;
export type SessionNameLazyQueryHookResult = ReturnType<typeof useSessionNameLazyQuery>;
export type SessionNameSuspenseQueryHookResult = ReturnType<typeof useSessionNameSuspenseQuery>;
export type SessionNameQueryResult = Apollo.QueryResult<SessionNameQuery, SessionNameQueryVariables>;
export const SessionNamesDocument = gql`
	query sessionNames($filters: [SessionFilterInput!], $pagination: Pagination, $order: SessionOrder) {
		sessionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...SessionName
				}
			}
		}
	}
	${SessionNameFragmentDoc}
`;

/**
 * __useSessionNamesQuery__
 *
 * To run a query within a React component, call `useSessionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSessionNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<SessionNamesQuery, SessionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SessionNamesQuery, SessionNamesQueryVariables>(SessionNamesDocument, options);
}
export function useSessionNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SessionNamesQuery, SessionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SessionNamesQuery, SessionNamesQueryVariables>(SessionNamesDocument, options);
}
export function useSessionNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SessionNamesQuery, SessionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SessionNamesQuery, SessionNamesQueryVariables>(SessionNamesDocument, options);
}
export type SessionNamesQueryHookResult = ReturnType<typeof useSessionNamesQuery>;
export type SessionNamesLazyQueryHookResult = ReturnType<typeof useSessionNamesLazyQuery>;
export type SessionNamesSuspenseQueryHookResult = ReturnType<typeof useSessionNamesSuspenseQuery>;
export type SessionNamesQueryResult = Apollo.QueryResult<SessionNamesQuery, SessionNamesQueryVariables>;
export const SessionPaginationDocument = gql`
	query sessionPagination($filters: [SessionFilterInput!], $order: SessionOrder) {
		sessionConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useSessionPaginationQuery__
 *
 * To run a query within a React component, call `useSessionPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSessionPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<SessionPaginationQuery, SessionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SessionPaginationQuery, SessionPaginationQueryVariables>(SessionPaginationDocument, options);
}
export function useSessionPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SessionPaginationQuery, SessionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SessionPaginationQuery, SessionPaginationQueryVariables>(
		SessionPaginationDocument,
		options,
	);
}
export function useSessionPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SessionPaginationQuery, SessionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SessionPaginationQuery, SessionPaginationQueryVariables>(
		SessionPaginationDocument,
		options,
	);
}
export type SessionPaginationQueryHookResult = ReturnType<typeof useSessionPaginationQuery>;
export type SessionPaginationLazyQueryHookResult = ReturnType<typeof useSessionPaginationLazyQuery>;
export type SessionPaginationSuspenseQueryHookResult = ReturnType<typeof useSessionPaginationSuspenseQuery>;
export type SessionPaginationQueryResult = Apollo.QueryResult<SessionPaginationQuery, SessionPaginationQueryVariables>;
export const SessionSelectDocument = gql`
	query sessionSelect($filters: [SessionFilterInput!], $order: SessionOrder) {
		sessionConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...SessionName
				}
			}
		}
	}
	${SessionNameFragmentDoc}
`;

/**
 * __useSessionSelectQuery__
 *
 * To run a query within a React component, call `useSessionSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSessionSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<SessionSelectQuery, SessionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SessionSelectQuery, SessionSelectQueryVariables>(SessionSelectDocument, options);
}
export function useSessionSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SessionSelectQuery, SessionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SessionSelectQuery, SessionSelectQueryVariables>(SessionSelectDocument, options);
}
export function useSessionSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SessionSelectQuery, SessionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SessionSelectQuery, SessionSelectQueryVariables>(SessionSelectDocument, options);
}
export type SessionSelectQueryHookResult = ReturnType<typeof useSessionSelectQuery>;
export type SessionSelectLazyQueryHookResult = ReturnType<typeof useSessionSelectLazyQuery>;
export type SessionSelectSuspenseQueryHookResult = ReturnType<typeof useSessionSelectSuspenseQuery>;
export type SessionSelectQueryResult = Apollo.QueryResult<SessionSelectQuery, SessionSelectQueryVariables>;
export const SharingRecordCountDocument = gql`
	query sharingRecordCount($filters: [SharingRecordFilterInput!], $pagination: Pagination, $order: SharingRecordOrder) {
		sharingRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useSharingRecordCountQuery__
 *
 * To run a query within a React component, call `useSharingRecordCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingRecordCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingRecordCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSharingRecordCountQuery(
	baseOptions?: Apollo.QueryHookOptions<SharingRecordCountQuery, SharingRecordCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SharingRecordCountQuery, SharingRecordCountQueryVariables>(
		SharingRecordCountDocument,
		options,
	);
}
export function useSharingRecordCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SharingRecordCountQuery, SharingRecordCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SharingRecordCountQuery, SharingRecordCountQueryVariables>(
		SharingRecordCountDocument,
		options,
	);
}
export function useSharingRecordCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SharingRecordCountQuery, SharingRecordCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SharingRecordCountQuery, SharingRecordCountQueryVariables>(
		SharingRecordCountDocument,
		options,
	);
}
export type SharingRecordCountQueryHookResult = ReturnType<typeof useSharingRecordCountQuery>;
export type SharingRecordCountLazyQueryHookResult = ReturnType<typeof useSharingRecordCountLazyQuery>;
export type SharingRecordCountSuspenseQueryHookResult = ReturnType<typeof useSharingRecordCountSuspenseQuery>;
export type SharingRecordCountQueryResult = Apollo.QueryResult<
	SharingRecordCountQuery,
	SharingRecordCountQueryVariables
>;
export const SharingRecordCreateDocument = gql`
	mutation sharingRecordCreate($input: SharingRecordCreateInput!) {
		createSharingRecord(input: $input) {
			...SharingRecordDetail
		}
	}
	${SharingRecordDetailFragmentDoc}
`;
export type SharingRecordCreateMutationFn = Apollo.MutationFunction<
	SharingRecordCreateMutation,
	SharingRecordCreateMutationVariables
>;

/**
 * __useSharingRecordCreateMutation__
 *
 * To run a mutation, you first call `useSharingRecordCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharingRecordCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharingRecordCreateMutation, { data, loading, error }] = useSharingRecordCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSharingRecordCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<SharingRecordCreateMutation, SharingRecordCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SharingRecordCreateMutation, SharingRecordCreateMutationVariables>(
		SharingRecordCreateDocument,
		options,
	);
}
export type SharingRecordCreateMutationHookResult = ReturnType<typeof useSharingRecordCreateMutation>;
export type SharingRecordCreateMutationResult = Apollo.MutationResult<SharingRecordCreateMutation>;
export type SharingRecordCreateMutationOptions = Apollo.BaseMutationOptions<
	SharingRecordCreateMutation,
	SharingRecordCreateMutationVariables
>;
export const SharingRecordDeleteDocument = gql`
	mutation sharingRecordDelete($id: ID!) {
		deleteSharingRecord(id: $id)
	}
`;
export type SharingRecordDeleteMutationFn = Apollo.MutationFunction<
	SharingRecordDeleteMutation,
	SharingRecordDeleteMutationVariables
>;

/**
 * __useSharingRecordDeleteMutation__
 *
 * To run a mutation, you first call `useSharingRecordDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharingRecordDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharingRecordDeleteMutation, { data, loading, error }] = useSharingRecordDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSharingRecordDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<SharingRecordDeleteMutation, SharingRecordDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SharingRecordDeleteMutation, SharingRecordDeleteMutationVariables>(
		SharingRecordDeleteDocument,
		options,
	);
}
export type SharingRecordDeleteMutationHookResult = ReturnType<typeof useSharingRecordDeleteMutation>;
export type SharingRecordDeleteMutationResult = Apollo.MutationResult<SharingRecordDeleteMutation>;
export type SharingRecordDeleteMutationOptions = Apollo.BaseMutationOptions<
	SharingRecordDeleteMutation,
	SharingRecordDeleteMutationVariables
>;
export const SharingRecordDetailDocument = gql`
	query sharingRecordDetail($id: ID!) {
		sharingRecord(id: $id) {
			...SharingRecordDetail
		}
	}
	${SharingRecordDetailFragmentDoc}
`;

/**
 * __useSharingRecordDetailQuery__
 *
 * To run a query within a React component, call `useSharingRecordDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingRecordDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingRecordDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSharingRecordDetailQuery(
	baseOptions: Apollo.QueryHookOptions<SharingRecordDetailQuery, SharingRecordDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SharingRecordDetailQuery, SharingRecordDetailQueryVariables>(
		SharingRecordDetailDocument,
		options,
	);
}
export function useSharingRecordDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SharingRecordDetailQuery, SharingRecordDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SharingRecordDetailQuery, SharingRecordDetailQueryVariables>(
		SharingRecordDetailDocument,
		options,
	);
}
export function useSharingRecordDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SharingRecordDetailQuery, SharingRecordDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SharingRecordDetailQuery, SharingRecordDetailQueryVariables>(
		SharingRecordDetailDocument,
		options,
	);
}
export type SharingRecordDetailQueryHookResult = ReturnType<typeof useSharingRecordDetailQuery>;
export type SharingRecordDetailLazyQueryHookResult = ReturnType<typeof useSharingRecordDetailLazyQuery>;
export type SharingRecordDetailSuspenseQueryHookResult = ReturnType<typeof useSharingRecordDetailSuspenseQuery>;
export type SharingRecordDetailQueryResult = Apollo.QueryResult<
	SharingRecordDetailQuery,
	SharingRecordDetailQueryVariables
>;
export const SharingRecordIndexDocument = gql`
	query sharingRecordIndex($filters: [SharingRecordFilterInput!], $pagination: Pagination, $order: SharingRecordOrder) {
		sharingRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					isPublic
					includeEmployees
					includeGuardians
					includeAllUsersOfPersonTypes
				}
			}
		}
	}
`;

/**
 * __useSharingRecordIndexQuery__
 *
 * To run a query within a React component, call `useSharingRecordIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingRecordIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingRecordIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSharingRecordIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<SharingRecordIndexQuery, SharingRecordIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SharingRecordIndexQuery, SharingRecordIndexQueryVariables>(
		SharingRecordIndexDocument,
		options,
	);
}
export function useSharingRecordIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SharingRecordIndexQuery, SharingRecordIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SharingRecordIndexQuery, SharingRecordIndexQueryVariables>(
		SharingRecordIndexDocument,
		options,
	);
}
export function useSharingRecordIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SharingRecordIndexQuery, SharingRecordIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SharingRecordIndexQuery, SharingRecordIndexQueryVariables>(
		SharingRecordIndexDocument,
		options,
	);
}
export type SharingRecordIndexQueryHookResult = ReturnType<typeof useSharingRecordIndexQuery>;
export type SharingRecordIndexLazyQueryHookResult = ReturnType<typeof useSharingRecordIndexLazyQuery>;
export type SharingRecordIndexSuspenseQueryHookResult = ReturnType<typeof useSharingRecordIndexSuspenseQuery>;
export type SharingRecordIndexQueryResult = Apollo.QueryResult<
	SharingRecordIndexQuery,
	SharingRecordIndexQueryVariables
>;
export const SharingRecordNameDocument = gql`
	query sharingRecordName($id: ID!) {
		sharingRecord(id: $id) {
			id
			...SharingRecordName
		}
	}
	${SharingRecordNameFragmentDoc}
`;

/**
 * __useSharingRecordNameQuery__
 *
 * To run a query within a React component, call `useSharingRecordNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingRecordNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingRecordNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSharingRecordNameQuery(
	baseOptions: Apollo.QueryHookOptions<SharingRecordNameQuery, SharingRecordNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SharingRecordNameQuery, SharingRecordNameQueryVariables>(SharingRecordNameDocument, options);
}
export function useSharingRecordNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SharingRecordNameQuery, SharingRecordNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SharingRecordNameQuery, SharingRecordNameQueryVariables>(
		SharingRecordNameDocument,
		options,
	);
}
export function useSharingRecordNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SharingRecordNameQuery, SharingRecordNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SharingRecordNameQuery, SharingRecordNameQueryVariables>(
		SharingRecordNameDocument,
		options,
	);
}
export type SharingRecordNameQueryHookResult = ReturnType<typeof useSharingRecordNameQuery>;
export type SharingRecordNameLazyQueryHookResult = ReturnType<typeof useSharingRecordNameLazyQuery>;
export type SharingRecordNameSuspenseQueryHookResult = ReturnType<typeof useSharingRecordNameSuspenseQuery>;
export type SharingRecordNameQueryResult = Apollo.QueryResult<SharingRecordNameQuery, SharingRecordNameQueryVariables>;
export const SharingRecordNamesDocument = gql`
	query sharingRecordNames($filters: [SharingRecordFilterInput!], $pagination: Pagination, $order: SharingRecordOrder) {
		sharingRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...SharingRecordName
				}
			}
		}
	}
	${SharingRecordNameFragmentDoc}
`;

/**
 * __useSharingRecordNamesQuery__
 *
 * To run a query within a React component, call `useSharingRecordNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingRecordNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingRecordNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSharingRecordNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<SharingRecordNamesQuery, SharingRecordNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SharingRecordNamesQuery, SharingRecordNamesQueryVariables>(
		SharingRecordNamesDocument,
		options,
	);
}
export function useSharingRecordNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SharingRecordNamesQuery, SharingRecordNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SharingRecordNamesQuery, SharingRecordNamesQueryVariables>(
		SharingRecordNamesDocument,
		options,
	);
}
export function useSharingRecordNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SharingRecordNamesQuery, SharingRecordNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SharingRecordNamesQuery, SharingRecordNamesQueryVariables>(
		SharingRecordNamesDocument,
		options,
	);
}
export type SharingRecordNamesQueryHookResult = ReturnType<typeof useSharingRecordNamesQuery>;
export type SharingRecordNamesLazyQueryHookResult = ReturnType<typeof useSharingRecordNamesLazyQuery>;
export type SharingRecordNamesSuspenseQueryHookResult = ReturnType<typeof useSharingRecordNamesSuspenseQuery>;
export type SharingRecordNamesQueryResult = Apollo.QueryResult<
	SharingRecordNamesQuery,
	SharingRecordNamesQueryVariables
>;
export const SharingRecordPaginationDocument = gql`
	query sharingRecordPagination($filters: [SharingRecordFilterInput!], $order: SharingRecordOrder) {
		sharingRecordConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useSharingRecordPaginationQuery__
 *
 * To run a query within a React component, call `useSharingRecordPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingRecordPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingRecordPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSharingRecordPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<SharingRecordPaginationQuery, SharingRecordPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SharingRecordPaginationQuery, SharingRecordPaginationQueryVariables>(
		SharingRecordPaginationDocument,
		options,
	);
}
export function useSharingRecordPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SharingRecordPaginationQuery, SharingRecordPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SharingRecordPaginationQuery, SharingRecordPaginationQueryVariables>(
		SharingRecordPaginationDocument,
		options,
	);
}
export function useSharingRecordPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SharingRecordPaginationQuery, SharingRecordPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SharingRecordPaginationQuery, SharingRecordPaginationQueryVariables>(
		SharingRecordPaginationDocument,
		options,
	);
}
export type SharingRecordPaginationQueryHookResult = ReturnType<typeof useSharingRecordPaginationQuery>;
export type SharingRecordPaginationLazyQueryHookResult = ReturnType<typeof useSharingRecordPaginationLazyQuery>;
export type SharingRecordPaginationSuspenseQueryHookResult = ReturnType<typeof useSharingRecordPaginationSuspenseQuery>;
export type SharingRecordPaginationQueryResult = Apollo.QueryResult<
	SharingRecordPaginationQuery,
	SharingRecordPaginationQueryVariables
>;
export const SharingRecordSelectDocument = gql`
	query sharingRecordSelect($filters: [SharingRecordFilterInput!], $order: SharingRecordOrder) {
		sharingRecordConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...SharingRecordName
				}
			}
		}
	}
	${SharingRecordNameFragmentDoc}
`;

/**
 * __useSharingRecordSelectQuery__
 *
 * To run a query within a React component, call `useSharingRecordSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingRecordSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingRecordSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSharingRecordSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<SharingRecordSelectQuery, SharingRecordSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SharingRecordSelectQuery, SharingRecordSelectQueryVariables>(
		SharingRecordSelectDocument,
		options,
	);
}
export function useSharingRecordSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SharingRecordSelectQuery, SharingRecordSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SharingRecordSelectQuery, SharingRecordSelectQueryVariables>(
		SharingRecordSelectDocument,
		options,
	);
}
export function useSharingRecordSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SharingRecordSelectQuery, SharingRecordSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SharingRecordSelectQuery, SharingRecordSelectQueryVariables>(
		SharingRecordSelectDocument,
		options,
	);
}
export type SharingRecordSelectQueryHookResult = ReturnType<typeof useSharingRecordSelectQuery>;
export type SharingRecordSelectLazyQueryHookResult = ReturnType<typeof useSharingRecordSelectLazyQuery>;
export type SharingRecordSelectSuspenseQueryHookResult = ReturnType<typeof useSharingRecordSelectSuspenseQuery>;
export type SharingRecordSelectQueryResult = Apollo.QueryResult<
	SharingRecordSelectQuery,
	SharingRecordSelectQueryVariables
>;
export const SharingRecordUpdateDocument = gql`
	mutation sharingRecordUpdate($id: ID!, $input: SharingRecordUpdateInput!) {
		updateSharingRecord(id: $id, input: $input) {
			...SharingRecordDetail
		}
	}
	${SharingRecordDetailFragmentDoc}
`;
export type SharingRecordUpdateMutationFn = Apollo.MutationFunction<
	SharingRecordUpdateMutation,
	SharingRecordUpdateMutationVariables
>;

/**
 * __useSharingRecordUpdateMutation__
 *
 * To run a mutation, you first call `useSharingRecordUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharingRecordUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharingRecordUpdateMutation, { data, loading, error }] = useSharingRecordUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSharingRecordUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<SharingRecordUpdateMutation, SharingRecordUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SharingRecordUpdateMutation, SharingRecordUpdateMutationVariables>(
		SharingRecordUpdateDocument,
		options,
	);
}
export type SharingRecordUpdateMutationHookResult = ReturnType<typeof useSharingRecordUpdateMutation>;
export type SharingRecordUpdateMutationResult = Apollo.MutationResult<SharingRecordUpdateMutation>;
export type SharingRecordUpdateMutationOptions = Apollo.BaseMutationOptions<
	SharingRecordUpdateMutation,
	SharingRecordUpdateMutationVariables
>;
export const SharingRecordPreviewDocument = gql`
	query sharingRecordPreview($filters: [SharingRecordFilterInput!]) {
		sharingRecordConnection(filters: $filters) {
			edges {
				node {
					id
					isPublic
					userGroups {
						id
						...UserGroupName
					}
				}
			}
		}
		userConnection(filters: { sharedSharingRecords: $filters }) {
			totalCount
		}
	}
	${UserGroupNameFragmentDoc}
`;

/**
 * __useSharingRecordPreviewQuery__
 *
 * To run a query within a React component, call `useSharingRecordPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingRecordPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingRecordPreviewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSharingRecordPreviewQuery(
	baseOptions?: Apollo.QueryHookOptions<SharingRecordPreviewQuery, SharingRecordPreviewQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SharingRecordPreviewQuery, SharingRecordPreviewQueryVariables>(
		SharingRecordPreviewDocument,
		options,
	);
}
export function useSharingRecordPreviewLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SharingRecordPreviewQuery, SharingRecordPreviewQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SharingRecordPreviewQuery, SharingRecordPreviewQueryVariables>(
		SharingRecordPreviewDocument,
		options,
	);
}
export function useSharingRecordPreviewSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SharingRecordPreviewQuery, SharingRecordPreviewQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SharingRecordPreviewQuery, SharingRecordPreviewQueryVariables>(
		SharingRecordPreviewDocument,
		options,
	);
}
export type SharingRecordPreviewQueryHookResult = ReturnType<typeof useSharingRecordPreviewQuery>;
export type SharingRecordPreviewLazyQueryHookResult = ReturnType<typeof useSharingRecordPreviewLazyQuery>;
export type SharingRecordPreviewSuspenseQueryHookResult = ReturnType<typeof useSharingRecordPreviewSuspenseQuery>;
export type SharingRecordPreviewQueryResult = Apollo.QueryResult<
	SharingRecordPreviewQuery,
	SharingRecordPreviewQueryVariables
>;
export const SharingRecordUsersPreviewDocument = gql`
	query sharingRecordUsersPreview(
		$sharingRecord: SharingRecordCreateInput!
		$filters: [UserFilterInput!]
		$pagination: Pagination
		$order: UserOrder
	) {
		sharedUserConnection(sharingRecord: $sharingRecord, filters: $filters, pagination: $pagination, order: $order) {
			totalCount
			pageInfo {
				hasNextPage
				endCursor
			}
			edges {
				node {
					id
					...UserNameDescriptionAndImage
				}
			}
		}
	}
	${UserNameDescriptionAndImageFragmentDoc}
`;

/**
 * __useSharingRecordUsersPreviewQuery__
 *
 * To run a query within a React component, call `useSharingRecordUsersPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingRecordUsersPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingRecordUsersPreviewQuery({
 *   variables: {
 *      sharingRecord: // value for 'sharingRecord'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSharingRecordUsersPreviewQuery(
	baseOptions: Apollo.QueryHookOptions<SharingRecordUsersPreviewQuery, SharingRecordUsersPreviewQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SharingRecordUsersPreviewQuery, SharingRecordUsersPreviewQueryVariables>(
		SharingRecordUsersPreviewDocument,
		options,
	);
}
export function useSharingRecordUsersPreviewLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SharingRecordUsersPreviewQuery, SharingRecordUsersPreviewQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SharingRecordUsersPreviewQuery, SharingRecordUsersPreviewQueryVariables>(
		SharingRecordUsersPreviewDocument,
		options,
	);
}
export function useSharingRecordUsersPreviewSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		SharingRecordUsersPreviewQuery,
		SharingRecordUsersPreviewQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SharingRecordUsersPreviewQuery, SharingRecordUsersPreviewQueryVariables>(
		SharingRecordUsersPreviewDocument,
		options,
	);
}
export type SharingRecordUsersPreviewQueryHookResult = ReturnType<typeof useSharingRecordUsersPreviewQuery>;
export type SharingRecordUsersPreviewLazyQueryHookResult = ReturnType<typeof useSharingRecordUsersPreviewLazyQuery>;
export type SharingRecordUsersPreviewSuspenseQueryHookResult = ReturnType<
	typeof useSharingRecordUsersPreviewSuspenseQuery
>;
export type SharingRecordUsersPreviewQueryResult = Apollo.QueryResult<
	SharingRecordUsersPreviewQuery,
	SharingRecordUsersPreviewQueryVariables
>;
export const SocialCommentCountDocument = gql`
	query socialCommentCount($filters: [SocialCommentFilterInput!], $pagination: Pagination, $order: SocialCommentOrder) {
		socialCommentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useSocialCommentCountQuery__
 *
 * To run a query within a React component, call `useSocialCommentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialCommentCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialCommentCountQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialCommentCountQuery, SocialCommentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialCommentCountQuery, SocialCommentCountQueryVariables>(
		SocialCommentCountDocument,
		options,
	);
}
export function useSocialCommentCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialCommentCountQuery, SocialCommentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialCommentCountQuery, SocialCommentCountQueryVariables>(
		SocialCommentCountDocument,
		options,
	);
}
export function useSocialCommentCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialCommentCountQuery, SocialCommentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialCommentCountQuery, SocialCommentCountQueryVariables>(
		SocialCommentCountDocument,
		options,
	);
}
export type SocialCommentCountQueryHookResult = ReturnType<typeof useSocialCommentCountQuery>;
export type SocialCommentCountLazyQueryHookResult = ReturnType<typeof useSocialCommentCountLazyQuery>;
export type SocialCommentCountSuspenseQueryHookResult = ReturnType<typeof useSocialCommentCountSuspenseQuery>;
export type SocialCommentCountQueryResult = Apollo.QueryResult<
	SocialCommentCountQuery,
	SocialCommentCountQueryVariables
>;
export const SocialCommentCreateDocument = gql`
	mutation socialCommentCreate($input: SocialCommentCreateInput!) {
		createSocialComment(input: $input) {
			...SocialCommentDetail
		}
	}
	${SocialCommentDetailFragmentDoc}
`;
export type SocialCommentCreateMutationFn = Apollo.MutationFunction<
	SocialCommentCreateMutation,
	SocialCommentCreateMutationVariables
>;

/**
 * __useSocialCommentCreateMutation__
 *
 * To run a mutation, you first call `useSocialCommentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialCommentCreateMutation, { data, loading, error }] = useSocialCommentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSocialCommentCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<SocialCommentCreateMutation, SocialCommentCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SocialCommentCreateMutation, SocialCommentCreateMutationVariables>(
		SocialCommentCreateDocument,
		options,
	);
}
export type SocialCommentCreateMutationHookResult = ReturnType<typeof useSocialCommentCreateMutation>;
export type SocialCommentCreateMutationResult = Apollo.MutationResult<SocialCommentCreateMutation>;
export type SocialCommentCreateMutationOptions = Apollo.BaseMutationOptions<
	SocialCommentCreateMutation,
	SocialCommentCreateMutationVariables
>;
export const SocialCommentDeleteDocument = gql`
	mutation socialCommentDelete($id: ID!) {
		deleteSocialComment(id: $id)
	}
`;
export type SocialCommentDeleteMutationFn = Apollo.MutationFunction<
	SocialCommentDeleteMutation,
	SocialCommentDeleteMutationVariables
>;

/**
 * __useSocialCommentDeleteMutation__
 *
 * To run a mutation, you first call `useSocialCommentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialCommentDeleteMutation, { data, loading, error }] = useSocialCommentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSocialCommentDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<SocialCommentDeleteMutation, SocialCommentDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SocialCommentDeleteMutation, SocialCommentDeleteMutationVariables>(
		SocialCommentDeleteDocument,
		options,
	);
}
export type SocialCommentDeleteMutationHookResult = ReturnType<typeof useSocialCommentDeleteMutation>;
export type SocialCommentDeleteMutationResult = Apollo.MutationResult<SocialCommentDeleteMutation>;
export type SocialCommentDeleteMutationOptions = Apollo.BaseMutationOptions<
	SocialCommentDeleteMutation,
	SocialCommentDeleteMutationVariables
>;
export const SocialCommentDetailDocument = gql`
	query socialCommentDetail($id: ID!) {
		socialComment(id: $id) {
			...SocialCommentDetail
		}
	}
	${SocialCommentDetailFragmentDoc}
`;

/**
 * __useSocialCommentDetailQuery__
 *
 * To run a query within a React component, call `useSocialCommentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialCommentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSocialCommentDetailQuery(
	baseOptions: Apollo.QueryHookOptions<SocialCommentDetailQuery, SocialCommentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialCommentDetailQuery, SocialCommentDetailQueryVariables>(
		SocialCommentDetailDocument,
		options,
	);
}
export function useSocialCommentDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialCommentDetailQuery, SocialCommentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialCommentDetailQuery, SocialCommentDetailQueryVariables>(
		SocialCommentDetailDocument,
		options,
	);
}
export function useSocialCommentDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialCommentDetailQuery, SocialCommentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialCommentDetailQuery, SocialCommentDetailQueryVariables>(
		SocialCommentDetailDocument,
		options,
	);
}
export type SocialCommentDetailQueryHookResult = ReturnType<typeof useSocialCommentDetailQuery>;
export type SocialCommentDetailLazyQueryHookResult = ReturnType<typeof useSocialCommentDetailLazyQuery>;
export type SocialCommentDetailSuspenseQueryHookResult = ReturnType<typeof useSocialCommentDetailSuspenseQuery>;
export type SocialCommentDetailQueryResult = Apollo.QueryResult<
	SocialCommentDetailQuery,
	SocialCommentDetailQueryVariables
>;
export const SocialCommentIndexDocument = gql`
	query socialCommentIndex($filters: [SocialCommentFilterInput!], $pagination: Pagination, $order: SocialCommentOrder) {
		socialCommentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					body
				}
			}
		}
	}
`;

/**
 * __useSocialCommentIndexQuery__
 *
 * To run a query within a React component, call `useSocialCommentIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialCommentIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialCommentIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialCommentIndexQuery, SocialCommentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialCommentIndexQuery, SocialCommentIndexQueryVariables>(
		SocialCommentIndexDocument,
		options,
	);
}
export function useSocialCommentIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialCommentIndexQuery, SocialCommentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialCommentIndexQuery, SocialCommentIndexQueryVariables>(
		SocialCommentIndexDocument,
		options,
	);
}
export function useSocialCommentIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialCommentIndexQuery, SocialCommentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialCommentIndexQuery, SocialCommentIndexQueryVariables>(
		SocialCommentIndexDocument,
		options,
	);
}
export type SocialCommentIndexQueryHookResult = ReturnType<typeof useSocialCommentIndexQuery>;
export type SocialCommentIndexLazyQueryHookResult = ReturnType<typeof useSocialCommentIndexLazyQuery>;
export type SocialCommentIndexSuspenseQueryHookResult = ReturnType<typeof useSocialCommentIndexSuspenseQuery>;
export type SocialCommentIndexQueryResult = Apollo.QueryResult<
	SocialCommentIndexQuery,
	SocialCommentIndexQueryVariables
>;
export const SocialCommentListDocument = gql`
	query socialCommentList($filters: [SocialCommentFilterInput!], $pagination: Pagination, $order: SocialCommentOrder) {
		socialCommentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
			edges {
				node {
					id
					body
					createdAt
					author {
						id
						...UserNameAndImage
						isCurrent
					}
				}
			}
		}
	}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __useSocialCommentListQuery__
 *
 * To run a query within a React component, call `useSocialCommentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialCommentListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialCommentListQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialCommentListQuery, SocialCommentListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialCommentListQuery, SocialCommentListQueryVariables>(SocialCommentListDocument, options);
}
export function useSocialCommentListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialCommentListQuery, SocialCommentListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialCommentListQuery, SocialCommentListQueryVariables>(
		SocialCommentListDocument,
		options,
	);
}
export function useSocialCommentListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialCommentListQuery, SocialCommentListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialCommentListQuery, SocialCommentListQueryVariables>(
		SocialCommentListDocument,
		options,
	);
}
export type SocialCommentListQueryHookResult = ReturnType<typeof useSocialCommentListQuery>;
export type SocialCommentListLazyQueryHookResult = ReturnType<typeof useSocialCommentListLazyQuery>;
export type SocialCommentListSuspenseQueryHookResult = ReturnType<typeof useSocialCommentListSuspenseQuery>;
export type SocialCommentListQueryResult = Apollo.QueryResult<SocialCommentListQuery, SocialCommentListQueryVariables>;
export const SocialCommentNameDocument = gql`
	query socialCommentName($id: ID!) {
		socialComment(id: $id) {
			id
			...SocialCommentName
		}
	}
	${SocialCommentNameFragmentDoc}
`;

/**
 * __useSocialCommentNameQuery__
 *
 * To run a query within a React component, call `useSocialCommentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialCommentNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSocialCommentNameQuery(
	baseOptions: Apollo.QueryHookOptions<SocialCommentNameQuery, SocialCommentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialCommentNameQuery, SocialCommentNameQueryVariables>(SocialCommentNameDocument, options);
}
export function useSocialCommentNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialCommentNameQuery, SocialCommentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialCommentNameQuery, SocialCommentNameQueryVariables>(
		SocialCommentNameDocument,
		options,
	);
}
export function useSocialCommentNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialCommentNameQuery, SocialCommentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialCommentNameQuery, SocialCommentNameQueryVariables>(
		SocialCommentNameDocument,
		options,
	);
}
export type SocialCommentNameQueryHookResult = ReturnType<typeof useSocialCommentNameQuery>;
export type SocialCommentNameLazyQueryHookResult = ReturnType<typeof useSocialCommentNameLazyQuery>;
export type SocialCommentNameSuspenseQueryHookResult = ReturnType<typeof useSocialCommentNameSuspenseQuery>;
export type SocialCommentNameQueryResult = Apollo.QueryResult<SocialCommentNameQuery, SocialCommentNameQueryVariables>;
export const SocialCommentNamesDocument = gql`
	query socialCommentNames($filters: [SocialCommentFilterInput!], $pagination: Pagination, $order: SocialCommentOrder) {
		socialCommentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...SocialCommentName
				}
			}
		}
	}
	${SocialCommentNameFragmentDoc}
`;

/**
 * __useSocialCommentNamesQuery__
 *
 * To run a query within a React component, call `useSocialCommentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialCommentNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialCommentNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialCommentNamesQuery, SocialCommentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialCommentNamesQuery, SocialCommentNamesQueryVariables>(
		SocialCommentNamesDocument,
		options,
	);
}
export function useSocialCommentNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialCommentNamesQuery, SocialCommentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialCommentNamesQuery, SocialCommentNamesQueryVariables>(
		SocialCommentNamesDocument,
		options,
	);
}
export function useSocialCommentNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialCommentNamesQuery, SocialCommentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialCommentNamesQuery, SocialCommentNamesQueryVariables>(
		SocialCommentNamesDocument,
		options,
	);
}
export type SocialCommentNamesQueryHookResult = ReturnType<typeof useSocialCommentNamesQuery>;
export type SocialCommentNamesLazyQueryHookResult = ReturnType<typeof useSocialCommentNamesLazyQuery>;
export type SocialCommentNamesSuspenseQueryHookResult = ReturnType<typeof useSocialCommentNamesSuspenseQuery>;
export type SocialCommentNamesQueryResult = Apollo.QueryResult<
	SocialCommentNamesQuery,
	SocialCommentNamesQueryVariables
>;
export const SocialCommentPaginationDocument = gql`
	query socialCommentPagination($filters: [SocialCommentFilterInput!], $order: SocialCommentOrder) {
		socialCommentConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useSocialCommentPaginationQuery__
 *
 * To run a query within a React component, call `useSocialCommentPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialCommentPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialCommentPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialCommentPaginationQuery, SocialCommentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialCommentPaginationQuery, SocialCommentPaginationQueryVariables>(
		SocialCommentPaginationDocument,
		options,
	);
}
export function useSocialCommentPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialCommentPaginationQuery, SocialCommentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialCommentPaginationQuery, SocialCommentPaginationQueryVariables>(
		SocialCommentPaginationDocument,
		options,
	);
}
export function useSocialCommentPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialCommentPaginationQuery, SocialCommentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialCommentPaginationQuery, SocialCommentPaginationQueryVariables>(
		SocialCommentPaginationDocument,
		options,
	);
}
export type SocialCommentPaginationQueryHookResult = ReturnType<typeof useSocialCommentPaginationQuery>;
export type SocialCommentPaginationLazyQueryHookResult = ReturnType<typeof useSocialCommentPaginationLazyQuery>;
export type SocialCommentPaginationSuspenseQueryHookResult = ReturnType<typeof useSocialCommentPaginationSuspenseQuery>;
export type SocialCommentPaginationQueryResult = Apollo.QueryResult<
	SocialCommentPaginationQuery,
	SocialCommentPaginationQueryVariables
>;
export const SocialCommentSelectDocument = gql`
	query socialCommentSelect($filters: [SocialCommentFilterInput!], $order: SocialCommentOrder) {
		socialCommentConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...SocialCommentName
				}
			}
		}
	}
	${SocialCommentNameFragmentDoc}
`;

/**
 * __useSocialCommentSelectQuery__
 *
 * To run a query within a React component, call `useSocialCommentSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialCommentSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialCommentSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialCommentSelectQuery, SocialCommentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialCommentSelectQuery, SocialCommentSelectQueryVariables>(
		SocialCommentSelectDocument,
		options,
	);
}
export function useSocialCommentSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialCommentSelectQuery, SocialCommentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialCommentSelectQuery, SocialCommentSelectQueryVariables>(
		SocialCommentSelectDocument,
		options,
	);
}
export function useSocialCommentSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialCommentSelectQuery, SocialCommentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialCommentSelectQuery, SocialCommentSelectQueryVariables>(
		SocialCommentSelectDocument,
		options,
	);
}
export type SocialCommentSelectQueryHookResult = ReturnType<typeof useSocialCommentSelectQuery>;
export type SocialCommentSelectLazyQueryHookResult = ReturnType<typeof useSocialCommentSelectLazyQuery>;
export type SocialCommentSelectSuspenseQueryHookResult = ReturnType<typeof useSocialCommentSelectSuspenseQuery>;
export type SocialCommentSelectQueryResult = Apollo.QueryResult<
	SocialCommentSelectQuery,
	SocialCommentSelectQueryVariables
>;
export const SocialCommentUpdateDocument = gql`
	mutation socialCommentUpdate($id: ID!, $input: SocialCommentUpdateInput!) {
		updateSocialComment(id: $id, input: $input) {
			...SocialCommentDetail
		}
	}
	${SocialCommentDetailFragmentDoc}
`;
export type SocialCommentUpdateMutationFn = Apollo.MutationFunction<
	SocialCommentUpdateMutation,
	SocialCommentUpdateMutationVariables
>;

/**
 * __useSocialCommentUpdateMutation__
 *
 * To run a mutation, you first call `useSocialCommentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialCommentUpdateMutation, { data, loading, error }] = useSocialCommentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSocialCommentUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<SocialCommentUpdateMutation, SocialCommentUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SocialCommentUpdateMutation, SocialCommentUpdateMutationVariables>(
		SocialCommentUpdateDocument,
		options,
	);
}
export type SocialCommentUpdateMutationHookResult = ReturnType<typeof useSocialCommentUpdateMutation>;
export type SocialCommentUpdateMutationResult = Apollo.MutationResult<SocialCommentUpdateMutation>;
export type SocialCommentUpdateMutationOptions = Apollo.BaseMutationOptions<
	SocialCommentUpdateMutation,
	SocialCommentUpdateMutationVariables
>;
export const SocialReactionCountDocument = gql`
	query socialReactionCount(
		$filters: [SocialReactionFilterInput!]
		$pagination: Pagination
		$order: SocialReactionOrder
	) {
		socialReactionConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useSocialReactionCountQuery__
 *
 * To run a query within a React component, call `useSocialReactionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialReactionCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialReactionCountQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialReactionCountQuery, SocialReactionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialReactionCountQuery, SocialReactionCountQueryVariables>(
		SocialReactionCountDocument,
		options,
	);
}
export function useSocialReactionCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialReactionCountQuery, SocialReactionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialReactionCountQuery, SocialReactionCountQueryVariables>(
		SocialReactionCountDocument,
		options,
	);
}
export function useSocialReactionCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialReactionCountQuery, SocialReactionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialReactionCountQuery, SocialReactionCountQueryVariables>(
		SocialReactionCountDocument,
		options,
	);
}
export type SocialReactionCountQueryHookResult = ReturnType<typeof useSocialReactionCountQuery>;
export type SocialReactionCountLazyQueryHookResult = ReturnType<typeof useSocialReactionCountLazyQuery>;
export type SocialReactionCountSuspenseQueryHookResult = ReturnType<typeof useSocialReactionCountSuspenseQuery>;
export type SocialReactionCountQueryResult = Apollo.QueryResult<
	SocialReactionCountQuery,
	SocialReactionCountQueryVariables
>;
export const SocialReactionCreateDocument = gql`
	mutation socialReactionCreate($input: SocialReactionCreateInput!) {
		createSocialReaction(input: $input) {
			...SocialReactionDetail
		}
	}
	${SocialReactionDetailFragmentDoc}
`;
export type SocialReactionCreateMutationFn = Apollo.MutationFunction<
	SocialReactionCreateMutation,
	SocialReactionCreateMutationVariables
>;

/**
 * __useSocialReactionCreateMutation__
 *
 * To run a mutation, you first call `useSocialReactionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialReactionCreateMutation, { data, loading, error }] = useSocialReactionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSocialReactionCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<SocialReactionCreateMutation, SocialReactionCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SocialReactionCreateMutation, SocialReactionCreateMutationVariables>(
		SocialReactionCreateDocument,
		options,
	);
}
export type SocialReactionCreateMutationHookResult = ReturnType<typeof useSocialReactionCreateMutation>;
export type SocialReactionCreateMutationResult = Apollo.MutationResult<SocialReactionCreateMutation>;
export type SocialReactionCreateMutationOptions = Apollo.BaseMutationOptions<
	SocialReactionCreateMutation,
	SocialReactionCreateMutationVariables
>;
export const SocialReactionDeleteDocument = gql`
	mutation socialReactionDelete($id: ID!) {
		deleteSocialReaction(id: $id)
	}
`;
export type SocialReactionDeleteMutationFn = Apollo.MutationFunction<
	SocialReactionDeleteMutation,
	SocialReactionDeleteMutationVariables
>;

/**
 * __useSocialReactionDeleteMutation__
 *
 * To run a mutation, you first call `useSocialReactionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialReactionDeleteMutation, { data, loading, error }] = useSocialReactionDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSocialReactionDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<SocialReactionDeleteMutation, SocialReactionDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SocialReactionDeleteMutation, SocialReactionDeleteMutationVariables>(
		SocialReactionDeleteDocument,
		options,
	);
}
export type SocialReactionDeleteMutationHookResult = ReturnType<typeof useSocialReactionDeleteMutation>;
export type SocialReactionDeleteMutationResult = Apollo.MutationResult<SocialReactionDeleteMutation>;
export type SocialReactionDeleteMutationOptions = Apollo.BaseMutationOptions<
	SocialReactionDeleteMutation,
	SocialReactionDeleteMutationVariables
>;
export const SocialReactionDetailDocument = gql`
	query socialReactionDetail($id: ID!) {
		socialReaction(id: $id) {
			...SocialReactionDetail
		}
	}
	${SocialReactionDetailFragmentDoc}
`;

/**
 * __useSocialReactionDetailQuery__
 *
 * To run a query within a React component, call `useSocialReactionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialReactionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSocialReactionDetailQuery(
	baseOptions: Apollo.QueryHookOptions<SocialReactionDetailQuery, SocialReactionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialReactionDetailQuery, SocialReactionDetailQueryVariables>(
		SocialReactionDetailDocument,
		options,
	);
}
export function useSocialReactionDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialReactionDetailQuery, SocialReactionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialReactionDetailQuery, SocialReactionDetailQueryVariables>(
		SocialReactionDetailDocument,
		options,
	);
}
export function useSocialReactionDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialReactionDetailQuery, SocialReactionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialReactionDetailQuery, SocialReactionDetailQueryVariables>(
		SocialReactionDetailDocument,
		options,
	);
}
export type SocialReactionDetailQueryHookResult = ReturnType<typeof useSocialReactionDetailQuery>;
export type SocialReactionDetailLazyQueryHookResult = ReturnType<typeof useSocialReactionDetailLazyQuery>;
export type SocialReactionDetailSuspenseQueryHookResult = ReturnType<typeof useSocialReactionDetailSuspenseQuery>;
export type SocialReactionDetailQueryResult = Apollo.QueryResult<
	SocialReactionDetailQuery,
	SocialReactionDetailQueryVariables
>;
export const SocialReactionIndexDocument = gql`
	query socialReactionIndex(
		$filters: [SocialReactionFilterInput!]
		$pagination: Pagination
		$order: SocialReactionOrder
	) {
		socialReactionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					reaction
				}
			}
		}
	}
`;

/**
 * __useSocialReactionIndexQuery__
 *
 * To run a query within a React component, call `useSocialReactionIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialReactionIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialReactionIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialReactionIndexQuery, SocialReactionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialReactionIndexQuery, SocialReactionIndexQueryVariables>(
		SocialReactionIndexDocument,
		options,
	);
}
export function useSocialReactionIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialReactionIndexQuery, SocialReactionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialReactionIndexQuery, SocialReactionIndexQueryVariables>(
		SocialReactionIndexDocument,
		options,
	);
}
export function useSocialReactionIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialReactionIndexQuery, SocialReactionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialReactionIndexQuery, SocialReactionIndexQueryVariables>(
		SocialReactionIndexDocument,
		options,
	);
}
export type SocialReactionIndexQueryHookResult = ReturnType<typeof useSocialReactionIndexQuery>;
export type SocialReactionIndexLazyQueryHookResult = ReturnType<typeof useSocialReactionIndexLazyQuery>;
export type SocialReactionIndexSuspenseQueryHookResult = ReturnType<typeof useSocialReactionIndexSuspenseQuery>;
export type SocialReactionIndexQueryResult = Apollo.QueryResult<
	SocialReactionIndexQuery,
	SocialReactionIndexQueryVariables
>;
export const SocialReactionNameDocument = gql`
	query socialReactionName($id: ID!) {
		socialReaction(id: $id) {
			id
			...SocialReactionName
		}
	}
	${SocialReactionNameFragmentDoc}
`;

/**
 * __useSocialReactionNameQuery__
 *
 * To run a query within a React component, call `useSocialReactionNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialReactionNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSocialReactionNameQuery(
	baseOptions: Apollo.QueryHookOptions<SocialReactionNameQuery, SocialReactionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialReactionNameQuery, SocialReactionNameQueryVariables>(
		SocialReactionNameDocument,
		options,
	);
}
export function useSocialReactionNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialReactionNameQuery, SocialReactionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialReactionNameQuery, SocialReactionNameQueryVariables>(
		SocialReactionNameDocument,
		options,
	);
}
export function useSocialReactionNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialReactionNameQuery, SocialReactionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialReactionNameQuery, SocialReactionNameQueryVariables>(
		SocialReactionNameDocument,
		options,
	);
}
export type SocialReactionNameQueryHookResult = ReturnType<typeof useSocialReactionNameQuery>;
export type SocialReactionNameLazyQueryHookResult = ReturnType<typeof useSocialReactionNameLazyQuery>;
export type SocialReactionNameSuspenseQueryHookResult = ReturnType<typeof useSocialReactionNameSuspenseQuery>;
export type SocialReactionNameQueryResult = Apollo.QueryResult<
	SocialReactionNameQuery,
	SocialReactionNameQueryVariables
>;
export const SocialReactionNamesDocument = gql`
	query socialReactionNames(
		$filters: [SocialReactionFilterInput!]
		$pagination: Pagination
		$order: SocialReactionOrder
	) {
		socialReactionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...SocialReactionName
				}
			}
		}
	}
	${SocialReactionNameFragmentDoc}
`;

/**
 * __useSocialReactionNamesQuery__
 *
 * To run a query within a React component, call `useSocialReactionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialReactionNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialReactionNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialReactionNamesQuery, SocialReactionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialReactionNamesQuery, SocialReactionNamesQueryVariables>(
		SocialReactionNamesDocument,
		options,
	);
}
export function useSocialReactionNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialReactionNamesQuery, SocialReactionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialReactionNamesQuery, SocialReactionNamesQueryVariables>(
		SocialReactionNamesDocument,
		options,
	);
}
export function useSocialReactionNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialReactionNamesQuery, SocialReactionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialReactionNamesQuery, SocialReactionNamesQueryVariables>(
		SocialReactionNamesDocument,
		options,
	);
}
export type SocialReactionNamesQueryHookResult = ReturnType<typeof useSocialReactionNamesQuery>;
export type SocialReactionNamesLazyQueryHookResult = ReturnType<typeof useSocialReactionNamesLazyQuery>;
export type SocialReactionNamesSuspenseQueryHookResult = ReturnType<typeof useSocialReactionNamesSuspenseQuery>;
export type SocialReactionNamesQueryResult = Apollo.QueryResult<
	SocialReactionNamesQuery,
	SocialReactionNamesQueryVariables
>;
export const SocialReactionPaginationDocument = gql`
	query socialReactionPagination($filters: [SocialReactionFilterInput!], $order: SocialReactionOrder) {
		socialReactionConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useSocialReactionPaginationQuery__
 *
 * To run a query within a React component, call `useSocialReactionPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialReactionPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialReactionPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialReactionPaginationQuery, SocialReactionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialReactionPaginationQuery, SocialReactionPaginationQueryVariables>(
		SocialReactionPaginationDocument,
		options,
	);
}
export function useSocialReactionPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialReactionPaginationQuery, SocialReactionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialReactionPaginationQuery, SocialReactionPaginationQueryVariables>(
		SocialReactionPaginationDocument,
		options,
	);
}
export function useSocialReactionPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialReactionPaginationQuery, SocialReactionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialReactionPaginationQuery, SocialReactionPaginationQueryVariables>(
		SocialReactionPaginationDocument,
		options,
	);
}
export type SocialReactionPaginationQueryHookResult = ReturnType<typeof useSocialReactionPaginationQuery>;
export type SocialReactionPaginationLazyQueryHookResult = ReturnType<typeof useSocialReactionPaginationLazyQuery>;
export type SocialReactionPaginationSuspenseQueryHookResult = ReturnType<
	typeof useSocialReactionPaginationSuspenseQuery
>;
export type SocialReactionPaginationQueryResult = Apollo.QueryResult<
	SocialReactionPaginationQuery,
	SocialReactionPaginationQueryVariables
>;
export const SocialReactionSelectDocument = gql`
	query socialReactionSelect($filters: [SocialReactionFilterInput!], $order: SocialReactionOrder) {
		socialReactionConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...SocialReactionName
				}
			}
		}
	}
	${SocialReactionNameFragmentDoc}
`;

/**
 * __useSocialReactionSelectQuery__
 *
 * To run a query within a React component, call `useSocialReactionSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialReactionSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialReactionSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialReactionSelectQuery, SocialReactionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialReactionSelectQuery, SocialReactionSelectQueryVariables>(
		SocialReactionSelectDocument,
		options,
	);
}
export function useSocialReactionSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialReactionSelectQuery, SocialReactionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialReactionSelectQuery, SocialReactionSelectQueryVariables>(
		SocialReactionSelectDocument,
		options,
	);
}
export function useSocialReactionSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialReactionSelectQuery, SocialReactionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialReactionSelectQuery, SocialReactionSelectQueryVariables>(
		SocialReactionSelectDocument,
		options,
	);
}
export type SocialReactionSelectQueryHookResult = ReturnType<typeof useSocialReactionSelectQuery>;
export type SocialReactionSelectLazyQueryHookResult = ReturnType<typeof useSocialReactionSelectLazyQuery>;
export type SocialReactionSelectSuspenseQueryHookResult = ReturnType<typeof useSocialReactionSelectSuspenseQuery>;
export type SocialReactionSelectQueryResult = Apollo.QueryResult<
	SocialReactionSelectQuery,
	SocialReactionSelectQueryVariables
>;
export const SocialReactionUpdateDocument = gql`
	mutation socialReactionUpdate($id: ID!, $input: SocialReactionUpdateInput!) {
		updateSocialReaction(id: $id, input: $input) {
			...SocialReactionDetail
		}
	}
	${SocialReactionDetailFragmentDoc}
`;
export type SocialReactionUpdateMutationFn = Apollo.MutationFunction<
	SocialReactionUpdateMutation,
	SocialReactionUpdateMutationVariables
>;

/**
 * __useSocialReactionUpdateMutation__
 *
 * To run a mutation, you first call `useSocialReactionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialReactionUpdateMutation, { data, loading, error }] = useSocialReactionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSocialReactionUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<SocialReactionUpdateMutation, SocialReactionUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SocialReactionUpdateMutation, SocialReactionUpdateMutationVariables>(
		SocialReactionUpdateDocument,
		options,
	);
}
export type SocialReactionUpdateMutationHookResult = ReturnType<typeof useSocialReactionUpdateMutation>;
export type SocialReactionUpdateMutationResult = Apollo.MutationResult<SocialReactionUpdateMutation>;
export type SocialReactionUpdateMutationOptions = Apollo.BaseMutationOptions<
	SocialReactionUpdateMutation,
	SocialReactionUpdateMutationVariables
>;
export const StudentAcademicOverviewDocument = gql`
	query studentAcademicOverview($studentID: ID!, $academicTermID: ID!, $yearsFromGraduation: Int!) {
		homeRoomSectionConnection(
			filters: { academicTermIDEQ: $academicTermID, studentHomeRoomSectionEnrollments: { studentIDEQ: $studentID } }
		) {
			edges {
				node {
					id
					...HomeRoomSectionName
					teacherHomeRoomSectionEnrollments {
						id
						teacher {
							id
							...EmployeeName
						}
					}
				}
			}
		}
		courseSectionConnection(
			filters: { academicTermIDEQ: $academicTermID, studentCourseSectionEnrollments: { studentIDEQ: $studentID } }
		) {
			edges {
				node {
					id
					...CourseSectionName
					teacherCourseSectionEnrollments {
						id
						teacher {
							id
							...EmployeeName
						}
					}
				}
			}
		}
		campusConnection(
			filters: {
				buildings: {
					buildingFloors: {
						rooms: [
							{
								homeRoomSections: {
									academicTermIDEQ: $academicTermID
									studentHomeRoomSectionEnrollments: { studentIDEQ: $studentID }
								}
							}
							{
								courseSectionPeriods: {
									courseSection: {
										academicTermIDEQ: $academicTermID
										studentCourseSectionEnrollments: { studentIDEQ: $studentID }
									}
								}
							}
						]
					}
				}
			}
		) {
			edges {
				node {
					id
					...CampusName
				}
			}
		}
		classYearConnection(filters: { yearsFromGraduationEQ: $yearsFromGraduation }) {
			edges {
				node {
					id
					...ClassYearName
				}
			}
		}
	}
	${HomeRoomSectionNameFragmentDoc}
	${EmployeeNameFragmentDoc}
	${CourseSectionNameFragmentDoc}
	${CampusNameFragmentDoc}
	${ClassYearNameFragmentDoc}
`;

/**
 * __useStudentAcademicOverviewQuery__
 *
 * To run a query within a React component, call `useStudentAcademicOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAcademicOverviewQuery({
 *   variables: {
 *      studentID: // value for 'studentID'
 *      academicTermID: // value for 'academicTermID'
 *      yearsFromGraduation: // value for 'yearsFromGraduation'
 *   },
 * });
 */
export function useStudentAcademicOverviewQuery(
	baseOptions: Apollo.QueryHookOptions<StudentAcademicOverviewQuery, StudentAcademicOverviewQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAcademicOverviewQuery, StudentAcademicOverviewQueryVariables>(
		StudentAcademicOverviewDocument,
		options,
	);
}
export function useStudentAcademicOverviewLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentAcademicOverviewQuery, StudentAcademicOverviewQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAcademicOverviewQuery, StudentAcademicOverviewQueryVariables>(
		StudentAcademicOverviewDocument,
		options,
	);
}
export function useStudentAcademicOverviewSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentAcademicOverviewQuery, StudentAcademicOverviewQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentAcademicOverviewQuery, StudentAcademicOverviewQueryVariables>(
		StudentAcademicOverviewDocument,
		options,
	);
}
export type StudentAcademicOverviewQueryHookResult = ReturnType<typeof useStudentAcademicOverviewQuery>;
export type StudentAcademicOverviewLazyQueryHookResult = ReturnType<typeof useStudentAcademicOverviewLazyQuery>;
export type StudentAcademicOverviewSuspenseQueryHookResult = ReturnType<typeof useStudentAcademicOverviewSuspenseQuery>;
export type StudentAcademicOverviewQueryResult = Apollo.QueryResult<
	StudentAcademicOverviewQuery,
	StudentAcademicOverviewQueryVariables
>;
export const StudentAttendanceCalendarDocument = gql`
	query studentAttendanceCalendar($studentID: ID!, $startDate: Date!, $endDate: Date!) {
		schoolAttendanceRecordConnection(
			filters: { studentIDEQ: $studentID, attendanceDateGTE: $startDate, attendanceDateLTE: $endDate }
		) {
			edges {
				node {
					id
					createdAt
					attendanceDate
					arrivalTime
					departureTime
					notes
					wasSetByCourseAttendance
					attendanceStatus {
						id
						name
						code
						description
						indicatesAbsent
						indicatesLateArrival
						indicatesEarlyDeparture
						indicatesExcused
					}
					author {
						id
						...UserName
					}
				}
			}
		}
		studentNoteConnection(
			filters: {
				primaryStudents: { idEQ: $studentID }
				noteTypeEQ: attendance
				studentAttendanceNote: { startDateLTE: $endDate, endDateGTE: $startDate }
			}
		) {
			edges {
				node {
					id
					noteType
					body
					studentAttendanceNote {
						id
						startDate
						endDate
					}
				}
			}
		}
	}
	${UserNameFragmentDoc}
`;

/**
 * __useStudentAttendanceCalendarQuery__
 *
 * To run a query within a React component, call `useStudentAttendanceCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAttendanceCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAttendanceCalendarQuery({
 *   variables: {
 *      studentID: // value for 'studentID'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useStudentAttendanceCalendarQuery(
	baseOptions: Apollo.QueryHookOptions<StudentAttendanceCalendarQuery, StudentAttendanceCalendarQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAttendanceCalendarQuery, StudentAttendanceCalendarQueryVariables>(
		StudentAttendanceCalendarDocument,
		options,
	);
}
export function useStudentAttendanceCalendarLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentAttendanceCalendarQuery, StudentAttendanceCalendarQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAttendanceCalendarQuery, StudentAttendanceCalendarQueryVariables>(
		StudentAttendanceCalendarDocument,
		options,
	);
}
export function useStudentAttendanceCalendarSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAttendanceCalendarQuery,
		StudentAttendanceCalendarQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentAttendanceCalendarQuery, StudentAttendanceCalendarQueryVariables>(
		StudentAttendanceCalendarDocument,
		options,
	);
}
export type StudentAttendanceCalendarQueryHookResult = ReturnType<typeof useStudentAttendanceCalendarQuery>;
export type StudentAttendanceCalendarLazyQueryHookResult = ReturnType<typeof useStudentAttendanceCalendarLazyQuery>;
export type StudentAttendanceCalendarSuspenseQueryHookResult = ReturnType<
	typeof useStudentAttendanceCalendarSuspenseQuery
>;
export type StudentAttendanceCalendarQueryResult = Apollo.QueryResult<
	StudentAttendanceCalendarQuery,
	StudentAttendanceCalendarQueryVariables
>;
export const StudentsSchoolAttendanceListDocument = gql`
	query studentsSchoolAttendanceList(
		$date: Date!
		$filters: [StudentFilterInput!]
		$pagination: Pagination
		$order: StudentOrder
	) {
		studentConnection(filters: $filters, pagination: $pagination, order: $order) {
			pageInfo {
				hasNextPage
				endCursor
			}
			edges {
				node {
					id
					...StudentName
					graduationYear
					studentHomeRoomSectionEnrollments(
						filters: { homeRoomSection: { academicTerm: { startDateLTE: $date, endDateGTE: $date } } }
					) {
						id
						homeRoomSection {
							id
							...HomeRoomSectionName
						}
					}
					schoolAttendanceRecords(filters: { attendanceDateEQ: $date }, order: { field: CREATED_AT, direction: DESC }) {
						id
						createdAt
						attendanceDate
						arrivalTime
						departureTime
						notes
						attendanceStatus {
							id
							...AttendanceStatusName
							description
							...AttendanceStatusInfo
						}
						author {
							id
							...UserName
						}
					}
				}
			}
		}
	}
	${StudentNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${AttendanceStatusNameFragmentDoc}
	${AttendanceStatusInfoFragmentDoc}
	${UserNameFragmentDoc}
`;

/**
 * __useStudentsSchoolAttendanceListQuery__
 *
 * To run a query within a React component, call `useStudentsSchoolAttendanceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentsSchoolAttendanceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentsSchoolAttendanceListQuery({
 *   variables: {
 *      date: // value for 'date'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentsSchoolAttendanceListQuery(
	baseOptions: Apollo.QueryHookOptions<StudentsSchoolAttendanceListQuery, StudentsSchoolAttendanceListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentsSchoolAttendanceListQuery, StudentsSchoolAttendanceListQueryVariables>(
		StudentsSchoolAttendanceListDocument,
		options,
	);
}
export function useStudentsSchoolAttendanceListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentsSchoolAttendanceListQuery,
		StudentsSchoolAttendanceListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentsSchoolAttendanceListQuery, StudentsSchoolAttendanceListQueryVariables>(
		StudentsSchoolAttendanceListDocument,
		options,
	);
}
export function useStudentsSchoolAttendanceListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentsSchoolAttendanceListQuery,
		StudentsSchoolAttendanceListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentsSchoolAttendanceListQuery, StudentsSchoolAttendanceListQueryVariables>(
		StudentsSchoolAttendanceListDocument,
		options,
	);
}
export type StudentsSchoolAttendanceListQueryHookResult = ReturnType<typeof useStudentsSchoolAttendanceListQuery>;
export type StudentsSchoolAttendanceListLazyQueryHookResult = ReturnType<
	typeof useStudentsSchoolAttendanceListLazyQuery
>;
export type StudentsSchoolAttendanceListSuspenseQueryHookResult = ReturnType<
	typeof useStudentsSchoolAttendanceListSuspenseQuery
>;
export type StudentsSchoolAttendanceListQueryResult = Apollo.QueryResult<
	StudentsSchoolAttendanceListQuery,
	StudentsSchoolAttendanceListQueryVariables
>;
export const StudentClassPlacementDocument = gql`
	query studentClassPlacement($studentID: ID!) {
		studentHomeRoomSectionEnrollmentConnection(filters: { studentIDEQ: $studentID }) {
			edges {
				node {
					homeRoomSection {
						id
						...HomeRoomSectionName
						teacherHomeRoomSectionEnrollments {
							id
							teacher {
								id
								...EmployeeNameAndImage
								jobTitle
								bio
							}
						}
					}
				}
			}
		}
	}
	${HomeRoomSectionNameFragmentDoc}
	${EmployeeNameAndImageFragmentDoc}
`;

/**
 * __useStudentClassPlacementQuery__
 *
 * To run a query within a React component, call `useStudentClassPlacementQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentClassPlacementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentClassPlacementQuery({
 *   variables: {
 *      studentID: // value for 'studentID'
 *   },
 * });
 */
export function useStudentClassPlacementQuery(
	baseOptions: Apollo.QueryHookOptions<StudentClassPlacementQuery, StudentClassPlacementQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentClassPlacementQuery, StudentClassPlacementQueryVariables>(
		StudentClassPlacementDocument,
		options,
	);
}
export function useStudentClassPlacementLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentClassPlacementQuery, StudentClassPlacementQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentClassPlacementQuery, StudentClassPlacementQueryVariables>(
		StudentClassPlacementDocument,
		options,
	);
}
export function useStudentClassPlacementSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentClassPlacementQuery, StudentClassPlacementQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentClassPlacementQuery, StudentClassPlacementQueryVariables>(
		StudentClassPlacementDocument,
		options,
	);
}
export type StudentClassPlacementQueryHookResult = ReturnType<typeof useStudentClassPlacementQuery>;
export type StudentClassPlacementLazyQueryHookResult = ReturnType<typeof useStudentClassPlacementLazyQuery>;
export type StudentClassPlacementSuspenseQueryHookResult = ReturnType<typeof useStudentClassPlacementSuspenseQuery>;
export type StudentClassPlacementQueryResult = Apollo.QueryResult<
	StudentClassPlacementQuery,
	StudentClassPlacementQueryVariables
>;
export const StudentMailCredentialsDocument = gql`
	query studentMailCredentials($studentID: ID!) {
		studentSchoolMailCredentials(studentID: $studentID) {
			email
			password
		}
	}
`;

/**
 * __useStudentMailCredentialsQuery__
 *
 * To run a query within a React component, call `useStudentMailCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMailCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMailCredentialsQuery({
 *   variables: {
 *      studentID: // value for 'studentID'
 *   },
 * });
 */
export function useStudentMailCredentialsQuery(
	baseOptions: Apollo.QueryHookOptions<StudentMailCredentialsQuery, StudentMailCredentialsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMailCredentialsQuery, StudentMailCredentialsQueryVariables>(
		StudentMailCredentialsDocument,
		options,
	);
}
export function useStudentMailCredentialsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMailCredentialsQuery, StudentMailCredentialsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMailCredentialsQuery, StudentMailCredentialsQueryVariables>(
		StudentMailCredentialsDocument,
		options,
	);
}
export function useStudentMailCredentialsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentMailCredentialsQuery, StudentMailCredentialsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMailCredentialsQuery, StudentMailCredentialsQueryVariables>(
		StudentMailCredentialsDocument,
		options,
	);
}
export type StudentMailCredentialsQueryHookResult = ReturnType<typeof useStudentMailCredentialsQuery>;
export type StudentMailCredentialsLazyQueryHookResult = ReturnType<typeof useStudentMailCredentialsLazyQuery>;
export type StudentMailCredentialsSuspenseQueryHookResult = ReturnType<typeof useStudentMailCredentialsSuspenseQuery>;
export type StudentMailCredentialsQueryResult = Apollo.QueryResult<
	StudentMailCredentialsQuery,
	StudentMailCredentialsQueryVariables
>;
export const StudentsClassYearLookupDocument = gql`
	query studentsClassYearLookup($filters: [StudentFilterInput!], $pagination: Pagination, $order: StudentOrder) {
		studentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					graduationYear
					yearsFromGraduation
				}
			}
		}
	}
`;

/**
 * __useStudentsClassYearLookupQuery__
 *
 * To run a query within a React component, call `useStudentsClassYearLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentsClassYearLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentsClassYearLookupQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentsClassYearLookupQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentsClassYearLookupQuery, StudentsClassYearLookupQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentsClassYearLookupQuery, StudentsClassYearLookupQueryVariables>(
		StudentsClassYearLookupDocument,
		options,
	);
}
export function useStudentsClassYearLookupLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentsClassYearLookupQuery, StudentsClassYearLookupQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentsClassYearLookupQuery, StudentsClassYearLookupQueryVariables>(
		StudentsClassYearLookupDocument,
		options,
	);
}
export function useStudentsClassYearLookupSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentsClassYearLookupQuery, StudentsClassYearLookupQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentsClassYearLookupQuery, StudentsClassYearLookupQueryVariables>(
		StudentsClassYearLookupDocument,
		options,
	);
}
export type StudentsClassYearLookupQueryHookResult = ReturnType<typeof useStudentsClassYearLookupQuery>;
export type StudentsClassYearLookupLazyQueryHookResult = ReturnType<typeof useStudentsClassYearLookupLazyQuery>;
export type StudentsClassYearLookupSuspenseQueryHookResult = ReturnType<typeof useStudentsClassYearLookupSuspenseQuery>;
export type StudentsClassYearLookupQueryResult = Apollo.QueryResult<
	StudentsClassYearLookupQuery,
	StudentsClassYearLookupQueryVariables
>;
export const StudentCountDocument = gql`
	query studentCount($filters: [StudentFilterInput!], $pagination: Pagination, $order: StudentOrder) {
		studentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentCountQuery__
 *
 * To run a query within a React component, call `useStudentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentCountQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentCountQuery, StudentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentCountQuery, StudentCountQueryVariables>(StudentCountDocument, options);
}
export function useStudentCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentCountQuery, StudentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentCountQuery, StudentCountQueryVariables>(StudentCountDocument, options);
}
export function useStudentCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentCountQuery, StudentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentCountQuery, StudentCountQueryVariables>(StudentCountDocument, options);
}
export type StudentCountQueryHookResult = ReturnType<typeof useStudentCountQuery>;
export type StudentCountLazyQueryHookResult = ReturnType<typeof useStudentCountLazyQuery>;
export type StudentCountSuspenseQueryHookResult = ReturnType<typeof useStudentCountSuspenseQuery>;
export type StudentCountQueryResult = Apollo.QueryResult<StudentCountQuery, StudentCountQueryVariables>;
export const StudentCreateWizardReviewEnrollmentDocument = gql`
	query studentCreateWizardReviewEnrollment($academicTermID: ID!, $homeRoomSectionID: ID!, $courseSectionIDs: [ID!]!) {
		academicTermConnection(filters: { idIn: [$academicTermID] }) {
			edges {
				node {
					id
					...AcademicTermName
				}
			}
		}
		homeRoomSectionConnection(filters: { idIn: [$homeRoomSectionID] }) {
			edges {
				node {
					id
					...HomeRoomSectionName
				}
			}
		}
		courseSectionConnection(filters: { idIn: $courseSectionIDs }) {
			edges {
				node {
					id
					...CourseSectionName
				}
			}
		}
	}
	${AcademicTermNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${CourseSectionNameFragmentDoc}
`;

/**
 * __useStudentCreateWizardReviewEnrollmentQuery__
 *
 * To run a query within a React component, call `useStudentCreateWizardReviewEnrollmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentCreateWizardReviewEnrollmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentCreateWizardReviewEnrollmentQuery({
 *   variables: {
 *      academicTermID: // value for 'academicTermID'
 *      homeRoomSectionID: // value for 'homeRoomSectionID'
 *      courseSectionIDs: // value for 'courseSectionIDs'
 *   },
 * });
 */
export function useStudentCreateWizardReviewEnrollmentQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentCreateWizardReviewEnrollmentQuery,
		StudentCreateWizardReviewEnrollmentQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentCreateWizardReviewEnrollmentQuery, StudentCreateWizardReviewEnrollmentQueryVariables>(
		StudentCreateWizardReviewEnrollmentDocument,
		options,
	);
}
export function useStudentCreateWizardReviewEnrollmentLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentCreateWizardReviewEnrollmentQuery,
		StudentCreateWizardReviewEnrollmentQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentCreateWizardReviewEnrollmentQuery,
		StudentCreateWizardReviewEnrollmentQueryVariables
	>(StudentCreateWizardReviewEnrollmentDocument, options);
}
export function useStudentCreateWizardReviewEnrollmentSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentCreateWizardReviewEnrollmentQuery,
		StudentCreateWizardReviewEnrollmentQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentCreateWizardReviewEnrollmentQuery,
		StudentCreateWizardReviewEnrollmentQueryVariables
	>(StudentCreateWizardReviewEnrollmentDocument, options);
}
export type StudentCreateWizardReviewEnrollmentQueryHookResult = ReturnType<
	typeof useStudentCreateWizardReviewEnrollmentQuery
>;
export type StudentCreateWizardReviewEnrollmentLazyQueryHookResult = ReturnType<
	typeof useStudentCreateWizardReviewEnrollmentLazyQuery
>;
export type StudentCreateWizardReviewEnrollmentSuspenseQueryHookResult = ReturnType<
	typeof useStudentCreateWizardReviewEnrollmentSuspenseQuery
>;
export type StudentCreateWizardReviewEnrollmentQueryResult = Apollo.QueryResult<
	StudentCreateWizardReviewEnrollmentQuery,
	StudentCreateWizardReviewEnrollmentQueryVariables
>;
export const CreateStudentFromWizardDocument = gql`
	mutation createStudentFromWizard(
		$studentInputs: [StudentCreateInput!]!
		$guardianInputs: [GuardianCreateInput!]!
		$addressInputs: [AddressCreateInput!]!
		$guardianAddressPairs: [[Int!]!]!
	) {
		createStudentFromWizard(
			studentInputs: $studentInputs
			guardianInputs: $guardianInputs
			addressInputs: $addressInputs
			guardianAddressPairs: $guardianAddressPairs
		) {
			edges {
				node {
					...StudentDetail
				}
			}
		}
	}
	${StudentDetailFragmentDoc}
`;
export type CreateStudentFromWizardMutationFn = Apollo.MutationFunction<
	CreateStudentFromWizardMutation,
	CreateStudentFromWizardMutationVariables
>;

/**
 * __useCreateStudentFromWizardMutation__
 *
 * To run a mutation, you first call `useCreateStudentFromWizardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStudentFromWizardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStudentFromWizardMutation, { data, loading, error }] = useCreateStudentFromWizardMutation({
 *   variables: {
 *      studentInputs: // value for 'studentInputs'
 *      guardianInputs: // value for 'guardianInputs'
 *      addressInputs: // value for 'addressInputs'
 *      guardianAddressPairs: // value for 'guardianAddressPairs'
 *   },
 * });
 */
export function useCreateStudentFromWizardMutation(
	baseOptions?: Apollo.MutationHookOptions<CreateStudentFromWizardMutation, CreateStudentFromWizardMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CreateStudentFromWizardMutation, CreateStudentFromWizardMutationVariables>(
		CreateStudentFromWizardDocument,
		options,
	);
}
export type CreateStudentFromWizardMutationHookResult = ReturnType<typeof useCreateStudentFromWizardMutation>;
export type CreateStudentFromWizardMutationResult = Apollo.MutationResult<CreateStudentFromWizardMutation>;
export type CreateStudentFromWizardMutationOptions = Apollo.BaseMutationOptions<
	CreateStudentFromWizardMutation,
	CreateStudentFromWizardMutationVariables
>;
export const StudentCreateDocument = gql`
	mutation studentCreate($input: StudentCreateInput!) {
		createStudent(input: $input) {
			...StudentDetail
		}
	}
	${StudentDetailFragmentDoc}
`;
export type StudentCreateMutationFn = Apollo.MutationFunction<StudentCreateMutation, StudentCreateMutationVariables>;

/**
 * __useStudentCreateMutation__
 *
 * To run a mutation, you first call `useStudentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentCreateMutation, { data, loading, error }] = useStudentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<StudentCreateMutation, StudentCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentCreateMutation, StudentCreateMutationVariables>(StudentCreateDocument, options);
}
export type StudentCreateMutationHookResult = ReturnType<typeof useStudentCreateMutation>;
export type StudentCreateMutationResult = Apollo.MutationResult<StudentCreateMutation>;
export type StudentCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentCreateMutation,
	StudentCreateMutationVariables
>;
export const StudentDeleteDocument = gql`
	mutation studentDelete($id: ID!) {
		deleteStudent(id: $id)
	}
`;
export type StudentDeleteMutationFn = Apollo.MutationFunction<StudentDeleteMutation, StudentDeleteMutationVariables>;

/**
 * __useStudentDeleteMutation__
 *
 * To run a mutation, you first call `useStudentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentDeleteMutation, { data, loading, error }] = useStudentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<StudentDeleteMutation, StudentDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentDeleteMutation, StudentDeleteMutationVariables>(StudentDeleteDocument, options);
}
export type StudentDeleteMutationHookResult = ReturnType<typeof useStudentDeleteMutation>;
export type StudentDeleteMutationResult = Apollo.MutationResult<StudentDeleteMutation>;
export type StudentDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentDeleteMutation,
	StudentDeleteMutationVariables
>;
export const StudentDetailDocument = gql`
	query studentDetail($id: ID!) {
		student(id: $id) {
			...StudentDetail
		}
	}
	${StudentDetailFragmentDoc}
`;

/**
 * __useStudentDetailQuery__
 *
 * To run a query within a React component, call `useStudentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentDetailQuery(
	baseOptions: Apollo.QueryHookOptions<StudentDetailQuery, StudentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentDetailQuery, StudentDetailQueryVariables>(StudentDetailDocument, options);
}
export function useStudentDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentDetailQuery, StudentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentDetailQuery, StudentDetailQueryVariables>(StudentDetailDocument, options);
}
export function useStudentDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentDetailQuery, StudentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentDetailQuery, StudentDetailQueryVariables>(StudentDetailDocument, options);
}
export type StudentDetailQueryHookResult = ReturnType<typeof useStudentDetailQuery>;
export type StudentDetailLazyQueryHookResult = ReturnType<typeof useStudentDetailLazyQuery>;
export type StudentDetailSuspenseQueryHookResult = ReturnType<typeof useStudentDetailSuspenseQuery>;
export type StudentDetailQueryResult = Apollo.QueryResult<StudentDetailQuery, StudentDetailQueryVariables>;
export const StudentsWithEnrollmentIntentsListDocument = gql`
	query studentsWithEnrollmentIntentsList(
		$filters: [StudentFilterInput!]
		$pagination: Pagination
		$order: StudentOrder
		$studentEnrollmentIntentFilters: [StudentEnrollmentIntentFilterInput!]
	) {
		studentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentNameAndImage
					graduationYear
					yearsFromGraduation
					studentEnrollmentIntents(filters: $studentEnrollmentIntentFilters) {
						id
						createdAt
						isEnrolling
						isInterestedInMealPlan
						declineReason
						declineReasonDescription
					}
				}
			}
		}
		studentNextYearTuitionAmounts(filters: $filters, pagination: $pagination, order: $order)
	}
	${StudentNameAndImageFragmentDoc}
`;

/**
 * __useStudentsWithEnrollmentIntentsListQuery__
 *
 * To run a query within a React component, call `useStudentsWithEnrollmentIntentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentsWithEnrollmentIntentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentsWithEnrollmentIntentsListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *      studentEnrollmentIntentFilters: // value for 'studentEnrollmentIntentFilters'
 *   },
 * });
 */
export function useStudentsWithEnrollmentIntentsListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentsWithEnrollmentIntentsListQuery,
		StudentsWithEnrollmentIntentsListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentsWithEnrollmentIntentsListQuery, StudentsWithEnrollmentIntentsListQueryVariables>(
		StudentsWithEnrollmentIntentsListDocument,
		options,
	);
}
export function useStudentsWithEnrollmentIntentsListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentsWithEnrollmentIntentsListQuery,
		StudentsWithEnrollmentIntentsListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentsWithEnrollmentIntentsListQuery, StudentsWithEnrollmentIntentsListQueryVariables>(
		StudentsWithEnrollmentIntentsListDocument,
		options,
	);
}
export function useStudentsWithEnrollmentIntentsListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentsWithEnrollmentIntentsListQuery,
		StudentsWithEnrollmentIntentsListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentsWithEnrollmentIntentsListQuery,
		StudentsWithEnrollmentIntentsListQueryVariables
	>(StudentsWithEnrollmentIntentsListDocument, options);
}
export type StudentsWithEnrollmentIntentsListQueryHookResult = ReturnType<
	typeof useStudentsWithEnrollmentIntentsListQuery
>;
export type StudentsWithEnrollmentIntentsListLazyQueryHookResult = ReturnType<
	typeof useStudentsWithEnrollmentIntentsListLazyQuery
>;
export type StudentsWithEnrollmentIntentsListSuspenseQueryHookResult = ReturnType<
	typeof useStudentsWithEnrollmentIntentsListSuspenseQuery
>;
export type StudentsWithEnrollmentIntentsListQueryResult = Apollo.QueryResult<
	StudentsWithEnrollmentIntentsListQuery,
	StudentsWithEnrollmentIntentsListQueryVariables
>;
export const CreateOrUpdateBulkStudentEnrollmentIntentsDocument = gql`
	mutation createOrUpdateBulkStudentEnrollmentIntents($inputs: [StudentEnrollmentIntentCreateInput!]!) {
		createOrUpdateBulkStudentEnrollmentIntents(inputs: $inputs) {
			edges {
				node {
					...StudentEnrollmentIntentDetail
				}
			}
		}
	}
	${StudentEnrollmentIntentDetailFragmentDoc}
`;
export type CreateOrUpdateBulkStudentEnrollmentIntentsMutationFn = Apollo.MutationFunction<
	CreateOrUpdateBulkStudentEnrollmentIntentsMutation,
	CreateOrUpdateBulkStudentEnrollmentIntentsMutationVariables
>;

/**
 * __useCreateOrUpdateBulkStudentEnrollmentIntentsMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBulkStudentEnrollmentIntentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBulkStudentEnrollmentIntentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBulkStudentEnrollmentIntentsMutation, { data, loading, error }] = useCreateOrUpdateBulkStudentEnrollmentIntentsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateOrUpdateBulkStudentEnrollmentIntentsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrUpdateBulkStudentEnrollmentIntentsMutation,
		CreateOrUpdateBulkStudentEnrollmentIntentsMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrUpdateBulkStudentEnrollmentIntentsMutation,
		CreateOrUpdateBulkStudentEnrollmentIntentsMutationVariables
	>(CreateOrUpdateBulkStudentEnrollmentIntentsDocument, options);
}
export type CreateOrUpdateBulkStudentEnrollmentIntentsMutationHookResult = ReturnType<
	typeof useCreateOrUpdateBulkStudentEnrollmentIntentsMutation
>;
export type CreateOrUpdateBulkStudentEnrollmentIntentsMutationResult =
	Apollo.MutationResult<CreateOrUpdateBulkStudentEnrollmentIntentsMutation>;
export type CreateOrUpdateBulkStudentEnrollmentIntentsMutationOptions = Apollo.BaseMutationOptions<
	CreateOrUpdateBulkStudentEnrollmentIntentsMutation,
	CreateOrUpdateBulkStudentEnrollmentIntentsMutationVariables
>;
export const UnenrollStudentFromAcademicTermDocument = gql`
	mutation unenrollStudentFromAcademicTerm($studentID: ID!, $academicTermID: ID!) {
		unenrollStudentFromAcademicTerm(studentID: $studentID, academicTermID: $academicTermID) {
			studentAcademicTermEnrollments {
				ids
			}
			studentHomeRoomSectionEnrollments {
				ids
			}
			studentCourseSectionEnrollments {
				ids
			}
		}
	}
`;
export type UnenrollStudentFromAcademicTermMutationFn = Apollo.MutationFunction<
	UnenrollStudentFromAcademicTermMutation,
	UnenrollStudentFromAcademicTermMutationVariables
>;

/**
 * __useUnenrollStudentFromAcademicTermMutation__
 *
 * To run a mutation, you first call `useUnenrollStudentFromAcademicTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnenrollStudentFromAcademicTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unenrollStudentFromAcademicTermMutation, { data, loading, error }] = useUnenrollStudentFromAcademicTermMutation({
 *   variables: {
 *      studentID: // value for 'studentID'
 *      academicTermID: // value for 'academicTermID'
 *   },
 * });
 */
export function useUnenrollStudentFromAcademicTermMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UnenrollStudentFromAcademicTermMutation,
		UnenrollStudentFromAcademicTermMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UnenrollStudentFromAcademicTermMutation, UnenrollStudentFromAcademicTermMutationVariables>(
		UnenrollStudentFromAcademicTermDocument,
		options,
	);
}
export type UnenrollStudentFromAcademicTermMutationHookResult = ReturnType<
	typeof useUnenrollStudentFromAcademicTermMutation
>;
export type UnenrollStudentFromAcademicTermMutationResult =
	Apollo.MutationResult<UnenrollStudentFromAcademicTermMutation>;
export type UnenrollStudentFromAcademicTermMutationOptions = Apollo.BaseMutationOptions<
	UnenrollStudentFromAcademicTermMutation,
	UnenrollStudentFromAcademicTermMutationVariables
>;
export const SetStudentEnrollmentDocument = gql`
	mutation setStudentEnrollment(
		$studentID: ID!
		$academicTermID: ID!
		$lateStartDate: Date
		$earlyEndDate: Date
		$graduationYear: Int!
		$homeRoomSectionID: ID
		$courseSectionIDs: [ID!]!
	) {
		setStudentEnrollment(
			studentID: $studentID
			academicTermID: $academicTermID
			lateStartDate: $lateStartDate
			earlyEndDate: $earlyEndDate
			graduationYear: $graduationYear
			homeRoomSectionID: $homeRoomSectionID
			courseSectionIDs: $courseSectionIDs
		)
	}
`;
export type SetStudentEnrollmentMutationFn = Apollo.MutationFunction<
	SetStudentEnrollmentMutation,
	SetStudentEnrollmentMutationVariables
>;

/**
 * __useSetStudentEnrollmentMutation__
 *
 * To run a mutation, you first call `useSetStudentEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStudentEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStudentEnrollmentMutation, { data, loading, error }] = useSetStudentEnrollmentMutation({
 *   variables: {
 *      studentID: // value for 'studentID'
 *      academicTermID: // value for 'academicTermID'
 *      lateStartDate: // value for 'lateStartDate'
 *      earlyEndDate: // value for 'earlyEndDate'
 *      graduationYear: // value for 'graduationYear'
 *      homeRoomSectionID: // value for 'homeRoomSectionID'
 *      courseSectionIDs: // value for 'courseSectionIDs'
 *   },
 * });
 */
export function useSetStudentEnrollmentMutation(
	baseOptions?: Apollo.MutationHookOptions<SetStudentEnrollmentMutation, SetStudentEnrollmentMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SetStudentEnrollmentMutation, SetStudentEnrollmentMutationVariables>(
		SetStudentEnrollmentDocument,
		options,
	);
}
export type SetStudentEnrollmentMutationHookResult = ReturnType<typeof useSetStudentEnrollmentMutation>;
export type SetStudentEnrollmentMutationResult = Apollo.MutationResult<SetStudentEnrollmentMutation>;
export type SetStudentEnrollmentMutationOptions = Apollo.BaseMutationOptions<
	SetStudentEnrollmentMutation,
	SetStudentEnrollmentMutationVariables
>;
export const StudentEnrollmentsListDocument = gql`
	query studentEnrollmentsList($studentID: ID!, $academicTermID: ID!) {
		studentAcademicTermEnrollmentConnection(filters: { studentIDEQ: $studentID, academicTermIDEQ: $academicTermID }) {
			edges {
				node {
					id
					lateStartDate
					earlyEndDate
				}
			}
		}
		studentHomeRoomSectionEnrollmentConnection(
			filters: { studentIDEQ: $studentID, homeRoomSection: { academicTermIDEQ: $academicTermID } }
		) {
			edges {
				node {
					id
					lateStartDate
					earlyEndDate
					homeRoomSection {
						id
						...HomeRoomSectionName
					}
				}
			}
		}
		studentCourseSectionEnrollmentConnection(
			filters: { studentIDEQ: $studentID, courseSection: { academicTermIDEQ: $academicTermID } }
		) {
			edges {
				node {
					id
					lateStartDate
					earlyEndDate
					courseSection {
						id
						...CourseSectionName
						homeRoomSection {
							id
							...HomeRoomSectionName
						}
					}
				}
			}
		}
	}
	${HomeRoomSectionNameFragmentDoc}
	${CourseSectionNameFragmentDoc}
`;

/**
 * __useStudentEnrollmentsListQuery__
 *
 * To run a query within a React component, call `useStudentEnrollmentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentEnrollmentsListQuery({
 *   variables: {
 *      studentID: // value for 'studentID'
 *      academicTermID: // value for 'academicTermID'
 *   },
 * });
 */
export function useStudentEnrollmentsListQuery(
	baseOptions: Apollo.QueryHookOptions<StudentEnrollmentsListQuery, StudentEnrollmentsListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentEnrollmentsListQuery, StudentEnrollmentsListQueryVariables>(
		StudentEnrollmentsListDocument,
		options,
	);
}
export function useStudentEnrollmentsListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentEnrollmentsListQuery, StudentEnrollmentsListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentEnrollmentsListQuery, StudentEnrollmentsListQueryVariables>(
		StudentEnrollmentsListDocument,
		options,
	);
}
export function useStudentEnrollmentsListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentEnrollmentsListQuery, StudentEnrollmentsListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentEnrollmentsListQuery, StudentEnrollmentsListQueryVariables>(
		StudentEnrollmentsListDocument,
		options,
	);
}
export type StudentEnrollmentsListQueryHookResult = ReturnType<typeof useStudentEnrollmentsListQuery>;
export type StudentEnrollmentsListLazyQueryHookResult = ReturnType<typeof useStudentEnrollmentsListLazyQuery>;
export type StudentEnrollmentsListSuspenseQueryHookResult = ReturnType<typeof useStudentEnrollmentsListSuspenseQuery>;
export type StudentEnrollmentsListQueryResult = Apollo.QueryResult<
	StudentEnrollmentsListQuery,
	StudentEnrollmentsListQueryVariables
>;
export const StudentIndexDocument = gql`
	query studentIndex($filters: [StudentFilterInput!], $pagination: Pagination, $order: StudentOrder) {
		studentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					graduationYear
					yearsFromGraduation
					person {
						id
						...PersonNameAndImage
						gender
						dateOfBirth
						nationalities {
							id
							...CountryName
						}
						languages {
							id
							...LanguageName
						}
						englishLanguageFluency
					}
					studentAcademicTermEnrollments {
						id
						lateStartDate
						earlyEndDate
						academicTerm {
							id
							startDate
							endDate
						}
					}
					relationships(order: { field: IS_PRIMARY, direction: DESC }) {
						id
						relationshipType
						guardian {
							id
							person {
								id
								...PersonName
								addresses {
									id
									...AddressInformation
								}
								emailAddresses(order: { field: IS_PRIMARY, direction: DESC }) {
									id
									emailAddress
								}
								phoneNumbers(order: { field: IS_PRIMARY, direction: DESC }) {
									id
									phoneNumber
								}
							}
						}
					}
				}
			}
		}
	}
	${PersonNameAndImageFragmentDoc}
	${CountryNameFragmentDoc}
	${LanguageNameFragmentDoc}
	${PersonNameFragmentDoc}
	${AddressInformationFragmentDoc}
`;

/**
 * __useStudentIndexQuery__
 *
 * To run a query within a React component, call `useStudentIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentIndexQuery, StudentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentIndexQuery, StudentIndexQueryVariables>(StudentIndexDocument, options);
}
export function useStudentIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentIndexQuery, StudentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentIndexQuery, StudentIndexQueryVariables>(StudentIndexDocument, options);
}
export function useStudentIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentIndexQuery, StudentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentIndexQuery, StudentIndexQueryVariables>(StudentIndexDocument, options);
}
export type StudentIndexQueryHookResult = ReturnType<typeof useStudentIndexQuery>;
export type StudentIndexLazyQueryHookResult = ReturnType<typeof useStudentIndexLazyQuery>;
export type StudentIndexSuspenseQueryHookResult = ReturnType<typeof useStudentIndexSuspenseQuery>;
export type StudentIndexQueryResult = Apollo.QueryResult<StudentIndexQuery, StudentIndexQueryVariables>;
export const StudentNameDocument = gql`
	query studentName($id: ID!) {
		student(id: $id) {
			id
			...StudentName
		}
	}
	${StudentNameFragmentDoc}
`;

/**
 * __useStudentNameQuery__
 *
 * To run a query within a React component, call `useStudentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentNameQuery(baseOptions: Apollo.QueryHookOptions<StudentNameQuery, StudentNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentNameQuery, StudentNameQueryVariables>(StudentNameDocument, options);
}
export function useStudentNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentNameQuery, StudentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentNameQuery, StudentNameQueryVariables>(StudentNameDocument, options);
}
export function useStudentNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentNameQuery, StudentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentNameQuery, StudentNameQueryVariables>(StudentNameDocument, options);
}
export type StudentNameQueryHookResult = ReturnType<typeof useStudentNameQuery>;
export type StudentNameLazyQueryHookResult = ReturnType<typeof useStudentNameLazyQuery>;
export type StudentNameSuspenseQueryHookResult = ReturnType<typeof useStudentNameSuspenseQuery>;
export type StudentNameQueryResult = Apollo.QueryResult<StudentNameQuery, StudentNameQueryVariables>;
export const StudentNamesDocument = gql`
	query studentNames($filters: [StudentFilterInput!], $pagination: Pagination, $order: StudentOrder) {
		studentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentName
				}
			}
		}
	}
	${StudentNameFragmentDoc}
`;

/**
 * __useStudentNamesQuery__
 *
 * To run a query within a React component, call `useStudentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentNamesQuery, StudentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentNamesQuery, StudentNamesQueryVariables>(StudentNamesDocument, options);
}
export function useStudentNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentNamesQuery, StudentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentNamesQuery, StudentNamesQueryVariables>(StudentNamesDocument, options);
}
export function useStudentNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentNamesQuery, StudentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentNamesQuery, StudentNamesQueryVariables>(StudentNamesDocument, options);
}
export type StudentNamesQueryHookResult = ReturnType<typeof useStudentNamesQuery>;
export type StudentNamesLazyQueryHookResult = ReturnType<typeof useStudentNamesLazyQuery>;
export type StudentNamesSuspenseQueryHookResult = ReturnType<typeof useStudentNamesSuspenseQuery>;
export type StudentNamesQueryResult = Apollo.QueryResult<StudentNamesQuery, StudentNamesQueryVariables>;
export const StudentPaginationDocument = gql`
	query studentPagination($filters: [StudentFilterInput!], $order: StudentOrder) {
		studentConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentPaginationQuery__
 *
 * To run a query within a React component, call `useStudentPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentPaginationQuery, StudentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentPaginationQuery, StudentPaginationQueryVariables>(StudentPaginationDocument, options);
}
export function useStudentPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentPaginationQuery, StudentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentPaginationQuery, StudentPaginationQueryVariables>(
		StudentPaginationDocument,
		options,
	);
}
export function useStudentPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentPaginationQuery, StudentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentPaginationQuery, StudentPaginationQueryVariables>(
		StudentPaginationDocument,
		options,
	);
}
export type StudentPaginationQueryHookResult = ReturnType<typeof useStudentPaginationQuery>;
export type StudentPaginationLazyQueryHookResult = ReturnType<typeof useStudentPaginationLazyQuery>;
export type StudentPaginationSuspenseQueryHookResult = ReturnType<typeof useStudentPaginationSuspenseQuery>;
export type StudentPaginationQueryResult = Apollo.QueryResult<StudentPaginationQuery, StudentPaginationQueryVariables>;
export const StudentSelectDocument = gql`
	query studentSelect($filters: [StudentFilterInput!], $order: StudentOrder) {
		studentConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentName
				}
			}
		}
	}
	${StudentNameFragmentDoc}
`;

/**
 * __useStudentSelectQuery__
 *
 * To run a query within a React component, call `useStudentSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentSelectQuery, StudentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentSelectQuery, StudentSelectQueryVariables>(StudentSelectDocument, options);
}
export function useStudentSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentSelectQuery, StudentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentSelectQuery, StudentSelectQueryVariables>(StudentSelectDocument, options);
}
export function useStudentSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentSelectQuery, StudentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentSelectQuery, StudentSelectQueryVariables>(StudentSelectDocument, options);
}
export type StudentSelectQueryHookResult = ReturnType<typeof useStudentSelectQuery>;
export type StudentSelectLazyQueryHookResult = ReturnType<typeof useStudentSelectLazyQuery>;
export type StudentSelectSuspenseQueryHookResult = ReturnType<typeof useStudentSelectSuspenseQuery>;
export type StudentSelectQueryResult = Apollo.QueryResult<StudentSelectQuery, StudentSelectQueryVariables>;
export const StudentNameAndImageDocument = gql`
	query studentNameAndImage($id: ID!) {
		student(id: $id) {
			id
			...StudentNameAndImage
		}
	}
	${StudentNameAndImageFragmentDoc}
`;

/**
 * __useStudentNameAndImageQuery__
 *
 * To run a query within a React component, call `useStudentNameAndImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNameAndImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNameAndImageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentNameAndImageQuery(
	baseOptions: Apollo.QueryHookOptions<StudentNameAndImageQuery, StudentNameAndImageQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentNameAndImageQuery, StudentNameAndImageQueryVariables>(
		StudentNameAndImageDocument,
		options,
	);
}
export function useStudentNameAndImageLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentNameAndImageQuery, StudentNameAndImageQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentNameAndImageQuery, StudentNameAndImageQueryVariables>(
		StudentNameAndImageDocument,
		options,
	);
}
export function useStudentNameAndImageSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentNameAndImageQuery, StudentNameAndImageQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentNameAndImageQuery, StudentNameAndImageQueryVariables>(
		StudentNameAndImageDocument,
		options,
	);
}
export type StudentNameAndImageQueryHookResult = ReturnType<typeof useStudentNameAndImageQuery>;
export type StudentNameAndImageLazyQueryHookResult = ReturnType<typeof useStudentNameAndImageLazyQuery>;
export type StudentNameAndImageSuspenseQueryHookResult = ReturnType<typeof useStudentNameAndImageSuspenseQuery>;
export type StudentNameAndImageQueryResult = Apollo.QueryResult<
	StudentNameAndImageQuery,
	StudentNameAndImageQueryVariables
>;
export const StudentNamesAndImagesDocument = gql`
	query studentNamesAndImages($filters: [StudentFilterInput!], $pagination: Pagination, $order: StudentOrder) {
		studentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
			edges {
				node {
					id
					...StudentNameAndImage
				}
			}
		}
	}
	${StudentNameAndImageFragmentDoc}
`;

/**
 * __useStudentNamesAndImagesQuery__
 *
 * To run a query within a React component, call `useStudentNamesAndImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNamesAndImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNamesAndImagesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentNamesAndImagesQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentNamesAndImagesQuery, StudentNamesAndImagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentNamesAndImagesQuery, StudentNamesAndImagesQueryVariables>(
		StudentNamesAndImagesDocument,
		options,
	);
}
export function useStudentNamesAndImagesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentNamesAndImagesQuery, StudentNamesAndImagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentNamesAndImagesQuery, StudentNamesAndImagesQueryVariables>(
		StudentNamesAndImagesDocument,
		options,
	);
}
export function useStudentNamesAndImagesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentNamesAndImagesQuery, StudentNamesAndImagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentNamesAndImagesQuery, StudentNamesAndImagesQueryVariables>(
		StudentNamesAndImagesDocument,
		options,
	);
}
export type StudentNamesAndImagesQueryHookResult = ReturnType<typeof useStudentNamesAndImagesQuery>;
export type StudentNamesAndImagesLazyQueryHookResult = ReturnType<typeof useStudentNamesAndImagesLazyQuery>;
export type StudentNamesAndImagesSuspenseQueryHookResult = ReturnType<typeof useStudentNamesAndImagesSuspenseQuery>;
export type StudentNamesAndImagesQueryResult = Apollo.QueryResult<
	StudentNamesAndImagesQuery,
	StudentNamesAndImagesQueryVariables
>;
export const StudentNamePartsAndImagesDocument = gql`
	query studentNamePartsAndImages($filters: [StudentFilterInput!], $pagination: Pagination, $order: StudentOrder) {
		studentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
			edges {
				node {
					id
					person {
						id
						...PersonNameAndImage
						familyName
					}
				}
			}
		}
	}
	${PersonNameAndImageFragmentDoc}
`;

/**
 * __useStudentNamePartsAndImagesQuery__
 *
 * To run a query within a React component, call `useStudentNamePartsAndImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNamePartsAndImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNamePartsAndImagesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentNamePartsAndImagesQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentNamePartsAndImagesQuery, StudentNamePartsAndImagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentNamePartsAndImagesQuery, StudentNamePartsAndImagesQueryVariables>(
		StudentNamePartsAndImagesDocument,
		options,
	);
}
export function useStudentNamePartsAndImagesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentNamePartsAndImagesQuery, StudentNamePartsAndImagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentNamePartsAndImagesQuery, StudentNamePartsAndImagesQueryVariables>(
		StudentNamePartsAndImagesDocument,
		options,
	);
}
export function useStudentNamePartsAndImagesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentNamePartsAndImagesQuery,
		StudentNamePartsAndImagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentNamePartsAndImagesQuery, StudentNamePartsAndImagesQueryVariables>(
		StudentNamePartsAndImagesDocument,
		options,
	);
}
export type StudentNamePartsAndImagesQueryHookResult = ReturnType<typeof useStudentNamePartsAndImagesQuery>;
export type StudentNamePartsAndImagesLazyQueryHookResult = ReturnType<typeof useStudentNamePartsAndImagesLazyQuery>;
export type StudentNamePartsAndImagesSuspenseQueryHookResult = ReturnType<
	typeof useStudentNamePartsAndImagesSuspenseQuery
>;
export type StudentNamePartsAndImagesQueryResult = Apollo.QueryResult<
	StudentNamePartsAndImagesQuery,
	StudentNamePartsAndImagesQueryVariables
>;
export const StudentNamesDescriptionsAndImagesDocument = gql`
	query studentNamesDescriptionsAndImages(
		$filters: [StudentFilterInput!]
		$pagination: Pagination
		$order: StudentOrder
	) {
		studentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
			pageInfo {
				endCursor
				hasNextPage
			}
			edges {
				node {
					id
					...StudentNameDescriptionAndImage
				}
			}
		}
	}
	${StudentNameDescriptionAndImageFragmentDoc}
`;

/**
 * __useStudentNamesDescriptionsAndImagesQuery__
 *
 * To run a query within a React component, call `useStudentNamesDescriptionsAndImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNamesDescriptionsAndImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNamesDescriptionsAndImagesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentNamesDescriptionsAndImagesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentNamesDescriptionsAndImagesQuery,
		StudentNamesDescriptionsAndImagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentNamesDescriptionsAndImagesQuery, StudentNamesDescriptionsAndImagesQueryVariables>(
		StudentNamesDescriptionsAndImagesDocument,
		options,
	);
}
export function useStudentNamesDescriptionsAndImagesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentNamesDescriptionsAndImagesQuery,
		StudentNamesDescriptionsAndImagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentNamesDescriptionsAndImagesQuery, StudentNamesDescriptionsAndImagesQueryVariables>(
		StudentNamesDescriptionsAndImagesDocument,
		options,
	);
}
export function useStudentNamesDescriptionsAndImagesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentNamesDescriptionsAndImagesQuery,
		StudentNamesDescriptionsAndImagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentNamesDescriptionsAndImagesQuery,
		StudentNamesDescriptionsAndImagesQueryVariables
	>(StudentNamesDescriptionsAndImagesDocument, options);
}
export type StudentNamesDescriptionsAndImagesQueryHookResult = ReturnType<
	typeof useStudentNamesDescriptionsAndImagesQuery
>;
export type StudentNamesDescriptionsAndImagesLazyQueryHookResult = ReturnType<
	typeof useStudentNamesDescriptionsAndImagesLazyQuery
>;
export type StudentNamesDescriptionsAndImagesSuspenseQueryHookResult = ReturnType<
	typeof useStudentNamesDescriptionsAndImagesSuspenseQuery
>;
export type StudentNamesDescriptionsAndImagesQueryResult = Apollo.QueryResult<
	StudentNamesDescriptionsAndImagesQuery,
	StudentNamesDescriptionsAndImagesQueryVariables
>;
export const StudentNamesDescriptionsHomeRoomSectionsAndImagesDocument = gql`
	query studentNamesDescriptionsHomeRoomSectionsAndImages(
		$date: Date!
		$filters: [StudentFilterInput!]
		$pagination: Pagination
		$order: StudentOrder
	) {
		studentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
			pageInfo {
				endCursor
				hasNextPage
			}
			edges {
				node {
					id
					...StudentNameAndImage
					graduationYear
					yearsFromGraduation
					studentHomeRoomSectionEnrollments(
						filters: { homeRoomSection: { academicTerm: { startDateLTE: $date, endDateGTE: $date } } }
					) {
						id
						homeRoomSection {
							id
							...HomeRoomSectionName
						}
					}
				}
			}
		}
	}
	${StudentNameAndImageFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
`;

/**
 * __useStudentNamesDescriptionsHomeRoomSectionsAndImagesQuery__
 *
 * To run a query within a React component, call `useStudentNamesDescriptionsHomeRoomSectionsAndImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNamesDescriptionsHomeRoomSectionsAndImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNamesDescriptionsHomeRoomSectionsAndImagesQuery({
 *   variables: {
 *      date: // value for 'date'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentNamesDescriptionsHomeRoomSectionsAndImagesQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentNamesDescriptionsHomeRoomSectionsAndImagesQuery,
		StudentNamesDescriptionsHomeRoomSectionsAndImagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentNamesDescriptionsHomeRoomSectionsAndImagesQuery,
		StudentNamesDescriptionsHomeRoomSectionsAndImagesQueryVariables
	>(StudentNamesDescriptionsHomeRoomSectionsAndImagesDocument, options);
}
export function useStudentNamesDescriptionsHomeRoomSectionsAndImagesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentNamesDescriptionsHomeRoomSectionsAndImagesQuery,
		StudentNamesDescriptionsHomeRoomSectionsAndImagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentNamesDescriptionsHomeRoomSectionsAndImagesQuery,
		StudentNamesDescriptionsHomeRoomSectionsAndImagesQueryVariables
	>(StudentNamesDescriptionsHomeRoomSectionsAndImagesDocument, options);
}
export function useStudentNamesDescriptionsHomeRoomSectionsAndImagesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentNamesDescriptionsHomeRoomSectionsAndImagesQuery,
		StudentNamesDescriptionsHomeRoomSectionsAndImagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentNamesDescriptionsHomeRoomSectionsAndImagesQuery,
		StudentNamesDescriptionsHomeRoomSectionsAndImagesQueryVariables
	>(StudentNamesDescriptionsHomeRoomSectionsAndImagesDocument, options);
}
export type StudentNamesDescriptionsHomeRoomSectionsAndImagesQueryHookResult = ReturnType<
	typeof useStudentNamesDescriptionsHomeRoomSectionsAndImagesQuery
>;
export type StudentNamesDescriptionsHomeRoomSectionsAndImagesLazyQueryHookResult = ReturnType<
	typeof useStudentNamesDescriptionsHomeRoomSectionsAndImagesLazyQuery
>;
export type StudentNamesDescriptionsHomeRoomSectionsAndImagesSuspenseQueryHookResult = ReturnType<
	typeof useStudentNamesDescriptionsHomeRoomSectionsAndImagesSuspenseQuery
>;
export type StudentNamesDescriptionsHomeRoomSectionsAndImagesQueryResult = Apollo.QueryResult<
	StudentNamesDescriptionsHomeRoomSectionsAndImagesQuery,
	StudentNamesDescriptionsHomeRoomSectionsAndImagesQueryVariables
>;
export const StudentTooltipDocument = gql`
	query studentTooltip($id: ID!, $date: Date!) {
		student(id: $id) {
			id
			graduationYear
			yearsFromGraduation
			person {
				id
				...PersonNameAndImage
				dateOfBirth
				gender
				nationalities {
					id
					...CountryName
				}
				languages {
					id
					...LanguageName
				}
			}
			studentAcademicTermEnrollments(filters: { academicTerm: { startDateLTE: $date, endDateGTE: $date } }) {
				id
				lateStartDate
				earlyEndDate
			}
			studentHomeRoomSectionEnrollments(
				filters: { homeRoomSection: { academicTerm: { startDateLTE: $date, endDateGTE: $date } } }
			) {
				id
				homeRoomSection {
					id
					...HomeRoomSectionName
				}
			}
		}
	}
	${PersonNameAndImageFragmentDoc}
	${CountryNameFragmentDoc}
	${LanguageNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
`;

/**
 * __useStudentTooltipQuery__
 *
 * To run a query within a React component, call `useStudentTooltipQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentTooltipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentTooltipQuery({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useStudentTooltipQuery(
	baseOptions: Apollo.QueryHookOptions<StudentTooltipQuery, StudentTooltipQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentTooltipQuery, StudentTooltipQueryVariables>(StudentTooltipDocument, options);
}
export function useStudentTooltipLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentTooltipQuery, StudentTooltipQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentTooltipQuery, StudentTooltipQueryVariables>(StudentTooltipDocument, options);
}
export function useStudentTooltipSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentTooltipQuery, StudentTooltipQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentTooltipQuery, StudentTooltipQueryVariables>(StudentTooltipDocument, options);
}
export type StudentTooltipQueryHookResult = ReturnType<typeof useStudentTooltipQuery>;
export type StudentTooltipLazyQueryHookResult = ReturnType<typeof useStudentTooltipLazyQuery>;
export type StudentTooltipSuspenseQueryHookResult = ReturnType<typeof useStudentTooltipSuspenseQuery>;
export type StudentTooltipQueryResult = Apollo.QueryResult<StudentTooltipQuery, StudentTooltipQueryVariables>;
export const StudentNextYearTuitionAmountDocument = gql`
	query studentNextYearTuitionAmount($studentID: ID!) {
		studentNextYearTuitionAmount(studentID: $studentID)
	}
`;

/**
 * __useStudentNextYearTuitionAmountQuery__
 *
 * To run a query within a React component, call `useStudentNextYearTuitionAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNextYearTuitionAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNextYearTuitionAmountQuery({
 *   variables: {
 *      studentID: // value for 'studentID'
 *   },
 * });
 */
export function useStudentNextYearTuitionAmountQuery(
	baseOptions: Apollo.QueryHookOptions<StudentNextYearTuitionAmountQuery, StudentNextYearTuitionAmountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentNextYearTuitionAmountQuery, StudentNextYearTuitionAmountQueryVariables>(
		StudentNextYearTuitionAmountDocument,
		options,
	);
}
export function useStudentNextYearTuitionAmountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentNextYearTuitionAmountQuery,
		StudentNextYearTuitionAmountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentNextYearTuitionAmountQuery, StudentNextYearTuitionAmountQueryVariables>(
		StudentNextYearTuitionAmountDocument,
		options,
	);
}
export function useStudentNextYearTuitionAmountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentNextYearTuitionAmountQuery,
		StudentNextYearTuitionAmountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentNextYearTuitionAmountQuery, StudentNextYearTuitionAmountQueryVariables>(
		StudentNextYearTuitionAmountDocument,
		options,
	);
}
export type StudentNextYearTuitionAmountQueryHookResult = ReturnType<typeof useStudentNextYearTuitionAmountQuery>;
export type StudentNextYearTuitionAmountLazyQueryHookResult = ReturnType<
	typeof useStudentNextYearTuitionAmountLazyQuery
>;
export type StudentNextYearTuitionAmountSuspenseQueryHookResult = ReturnType<
	typeof useStudentNextYearTuitionAmountSuspenseQuery
>;
export type StudentNextYearTuitionAmountQueryResult = Apollo.QueryResult<
	StudentNextYearTuitionAmountQuery,
	StudentNextYearTuitionAmountQueryVariables
>;
export const StudentUpdateDocument = gql`
	mutation studentUpdate($id: ID!, $input: StudentUpdateInput!) {
		updateStudent(id: $id, input: $input) {
			...StudentDetail
		}
	}
	${StudentDetailFragmentDoc}
`;
export type StudentUpdateMutationFn = Apollo.MutationFunction<StudentUpdateMutation, StudentUpdateMutationVariables>;

/**
 * __useStudentUpdateMutation__
 *
 * To run a mutation, you first call `useStudentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentUpdateMutation, { data, loading, error }] = useStudentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<StudentUpdateMutation, StudentUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentUpdateMutation, StudentUpdateMutationVariables>(StudentUpdateDocument, options);
}
export type StudentUpdateMutationHookResult = ReturnType<typeof useStudentUpdateMutation>;
export type StudentUpdateMutationResult = Apollo.MutationResult<StudentUpdateMutation>;
export type StudentUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentUpdateMutation,
	StudentUpdateMutationVariables
>;
export const StudentAcademicNoteCountDocument = gql`
	query studentAcademicNoteCount(
		$filters: [StudentAcademicNoteFilterInput!]
		$pagination: Pagination
		$order: StudentAcademicNoteOrder
	) {
		studentAcademicNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentAcademicNoteCountQuery__
 *
 * To run a query within a React component, call `useStudentAcademicNoteCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicNoteCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAcademicNoteCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentAcademicNoteCountQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentAcademicNoteCountQuery, StudentAcademicNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAcademicNoteCountQuery, StudentAcademicNoteCountQueryVariables>(
		StudentAcademicNoteCountDocument,
		options,
	);
}
export function useStudentAcademicNoteCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentAcademicNoteCountQuery, StudentAcademicNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAcademicNoteCountQuery, StudentAcademicNoteCountQueryVariables>(
		StudentAcademicNoteCountDocument,
		options,
	);
}
export function useStudentAcademicNoteCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentAcademicNoteCountQuery, StudentAcademicNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentAcademicNoteCountQuery, StudentAcademicNoteCountQueryVariables>(
		StudentAcademicNoteCountDocument,
		options,
	);
}
export type StudentAcademicNoteCountQueryHookResult = ReturnType<typeof useStudentAcademicNoteCountQuery>;
export type StudentAcademicNoteCountLazyQueryHookResult = ReturnType<typeof useStudentAcademicNoteCountLazyQuery>;
export type StudentAcademicNoteCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentAcademicNoteCountSuspenseQuery
>;
export type StudentAcademicNoteCountQueryResult = Apollo.QueryResult<
	StudentAcademicNoteCountQuery,
	StudentAcademicNoteCountQueryVariables
>;
export const StudentAcademicNoteCreateDocument = gql`
	mutation studentAcademicNoteCreate($input: StudentAcademicNoteCreateInput!) {
		createStudentAcademicNote(input: $input) {
			...StudentAcademicNoteDetail
		}
	}
	${StudentAcademicNoteDetailFragmentDoc}
`;
export type StudentAcademicNoteCreateMutationFn = Apollo.MutationFunction<
	StudentAcademicNoteCreateMutation,
	StudentAcademicNoteCreateMutationVariables
>;

/**
 * __useStudentAcademicNoteCreateMutation__
 *
 * To run a mutation, you first call `useStudentAcademicNoteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicNoteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentAcademicNoteCreateMutation, { data, loading, error }] = useStudentAcademicNoteCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentAcademicNoteCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentAcademicNoteCreateMutation,
		StudentAcademicNoteCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentAcademicNoteCreateMutation, StudentAcademicNoteCreateMutationVariables>(
		StudentAcademicNoteCreateDocument,
		options,
	);
}
export type StudentAcademicNoteCreateMutationHookResult = ReturnType<typeof useStudentAcademicNoteCreateMutation>;
export type StudentAcademicNoteCreateMutationResult = Apollo.MutationResult<StudentAcademicNoteCreateMutation>;
export type StudentAcademicNoteCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentAcademicNoteCreateMutation,
	StudentAcademicNoteCreateMutationVariables
>;
export const StudentAcademicNoteDeleteDocument = gql`
	mutation studentAcademicNoteDelete($id: ID!) {
		deleteStudentAcademicNote(id: $id)
	}
`;
export type StudentAcademicNoteDeleteMutationFn = Apollo.MutationFunction<
	StudentAcademicNoteDeleteMutation,
	StudentAcademicNoteDeleteMutationVariables
>;

/**
 * __useStudentAcademicNoteDeleteMutation__
 *
 * To run a mutation, you first call `useStudentAcademicNoteDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicNoteDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentAcademicNoteDeleteMutation, { data, loading, error }] = useStudentAcademicNoteDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentAcademicNoteDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentAcademicNoteDeleteMutation,
		StudentAcademicNoteDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentAcademicNoteDeleteMutation, StudentAcademicNoteDeleteMutationVariables>(
		StudentAcademicNoteDeleteDocument,
		options,
	);
}
export type StudentAcademicNoteDeleteMutationHookResult = ReturnType<typeof useStudentAcademicNoteDeleteMutation>;
export type StudentAcademicNoteDeleteMutationResult = Apollo.MutationResult<StudentAcademicNoteDeleteMutation>;
export type StudentAcademicNoteDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentAcademicNoteDeleteMutation,
	StudentAcademicNoteDeleteMutationVariables
>;
export const StudentAcademicNoteDetailDocument = gql`
	query studentAcademicNoteDetail($id: ID!) {
		studentAcademicNote(id: $id) {
			...StudentAcademicNoteDetail
		}
	}
	${StudentAcademicNoteDetailFragmentDoc}
`;

/**
 * __useStudentAcademicNoteDetailQuery__
 *
 * To run a query within a React component, call `useStudentAcademicNoteDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicNoteDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAcademicNoteDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentAcademicNoteDetailQuery(
	baseOptions: Apollo.QueryHookOptions<StudentAcademicNoteDetailQuery, StudentAcademicNoteDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAcademicNoteDetailQuery, StudentAcademicNoteDetailQueryVariables>(
		StudentAcademicNoteDetailDocument,
		options,
	);
}
export function useStudentAcademicNoteDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentAcademicNoteDetailQuery, StudentAcademicNoteDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAcademicNoteDetailQuery, StudentAcademicNoteDetailQueryVariables>(
		StudentAcademicNoteDetailDocument,
		options,
	);
}
export function useStudentAcademicNoteDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAcademicNoteDetailQuery,
		StudentAcademicNoteDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentAcademicNoteDetailQuery, StudentAcademicNoteDetailQueryVariables>(
		StudentAcademicNoteDetailDocument,
		options,
	);
}
export type StudentAcademicNoteDetailQueryHookResult = ReturnType<typeof useStudentAcademicNoteDetailQuery>;
export type StudentAcademicNoteDetailLazyQueryHookResult = ReturnType<typeof useStudentAcademicNoteDetailLazyQuery>;
export type StudentAcademicNoteDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentAcademicNoteDetailSuspenseQuery
>;
export type StudentAcademicNoteDetailQueryResult = Apollo.QueryResult<
	StudentAcademicNoteDetailQuery,
	StudentAcademicNoteDetailQueryVariables
>;
export const StudentAcademicNoteIndexDocument = gql`
	query studentAcademicNoteIndex(
		$filters: [StudentAcademicNoteFilterInput!]
		$pagination: Pagination
		$order: StudentAcademicNoteOrder
	) {
		studentAcademicNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					isIssueNatureLearningDifficulty
					isIssueNatureAttentionIssue
					isIssueNatureFocusIssue
					isIssueNatureEmotionalOrVulnerableIssue
					isIssueNatureOther
					issueNatureOther
					isSolutionRecDifferentiatedLearning
					isSolutionRecIndividualLearningPlan
					isSolutionRecTutoring
					isSolutionRecProfessionalSupport
					isSolutionRecInClassSupport
					isSolutionRecOther
					solutionRecOther
				}
			}
		}
	}
`;

/**
 * __useStudentAcademicNoteIndexQuery__
 *
 * To run a query within a React component, call `useStudentAcademicNoteIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicNoteIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAcademicNoteIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentAcademicNoteIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentAcademicNoteIndexQuery, StudentAcademicNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAcademicNoteIndexQuery, StudentAcademicNoteIndexQueryVariables>(
		StudentAcademicNoteIndexDocument,
		options,
	);
}
export function useStudentAcademicNoteIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentAcademicNoteIndexQuery, StudentAcademicNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAcademicNoteIndexQuery, StudentAcademicNoteIndexQueryVariables>(
		StudentAcademicNoteIndexDocument,
		options,
	);
}
export function useStudentAcademicNoteIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentAcademicNoteIndexQuery, StudentAcademicNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentAcademicNoteIndexQuery, StudentAcademicNoteIndexQueryVariables>(
		StudentAcademicNoteIndexDocument,
		options,
	);
}
export type StudentAcademicNoteIndexQueryHookResult = ReturnType<typeof useStudentAcademicNoteIndexQuery>;
export type StudentAcademicNoteIndexLazyQueryHookResult = ReturnType<typeof useStudentAcademicNoteIndexLazyQuery>;
export type StudentAcademicNoteIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentAcademicNoteIndexSuspenseQuery
>;
export type StudentAcademicNoteIndexQueryResult = Apollo.QueryResult<
	StudentAcademicNoteIndexQuery,
	StudentAcademicNoteIndexQueryVariables
>;
export const StudentAcademicNoteNameDocument = gql`
	query studentAcademicNoteName($id: ID!) {
		studentAcademicNote(id: $id) {
			id
			...StudentAcademicNoteName
		}
	}
	${StudentAcademicNoteNameFragmentDoc}
`;

/**
 * __useStudentAcademicNoteNameQuery__
 *
 * To run a query within a React component, call `useStudentAcademicNoteNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicNoteNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAcademicNoteNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentAcademicNoteNameQuery(
	baseOptions: Apollo.QueryHookOptions<StudentAcademicNoteNameQuery, StudentAcademicNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAcademicNoteNameQuery, StudentAcademicNoteNameQueryVariables>(
		StudentAcademicNoteNameDocument,
		options,
	);
}
export function useStudentAcademicNoteNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentAcademicNoteNameQuery, StudentAcademicNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAcademicNoteNameQuery, StudentAcademicNoteNameQueryVariables>(
		StudentAcademicNoteNameDocument,
		options,
	);
}
export function useStudentAcademicNoteNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentAcademicNoteNameQuery, StudentAcademicNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentAcademicNoteNameQuery, StudentAcademicNoteNameQueryVariables>(
		StudentAcademicNoteNameDocument,
		options,
	);
}
export type StudentAcademicNoteNameQueryHookResult = ReturnType<typeof useStudentAcademicNoteNameQuery>;
export type StudentAcademicNoteNameLazyQueryHookResult = ReturnType<typeof useStudentAcademicNoteNameLazyQuery>;
export type StudentAcademicNoteNameSuspenseQueryHookResult = ReturnType<typeof useStudentAcademicNoteNameSuspenseQuery>;
export type StudentAcademicNoteNameQueryResult = Apollo.QueryResult<
	StudentAcademicNoteNameQuery,
	StudentAcademicNoteNameQueryVariables
>;
export const StudentAcademicNoteNamesDocument = gql`
	query studentAcademicNoteNames(
		$filters: [StudentAcademicNoteFilterInput!]
		$pagination: Pagination
		$order: StudentAcademicNoteOrder
	) {
		studentAcademicNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentAcademicNoteName
				}
			}
		}
	}
	${StudentAcademicNoteNameFragmentDoc}
`;

/**
 * __useStudentAcademicNoteNamesQuery__
 *
 * To run a query within a React component, call `useStudentAcademicNoteNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicNoteNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAcademicNoteNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentAcademicNoteNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentAcademicNoteNamesQuery, StudentAcademicNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAcademicNoteNamesQuery, StudentAcademicNoteNamesQueryVariables>(
		StudentAcademicNoteNamesDocument,
		options,
	);
}
export function useStudentAcademicNoteNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentAcademicNoteNamesQuery, StudentAcademicNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAcademicNoteNamesQuery, StudentAcademicNoteNamesQueryVariables>(
		StudentAcademicNoteNamesDocument,
		options,
	);
}
export function useStudentAcademicNoteNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentAcademicNoteNamesQuery, StudentAcademicNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentAcademicNoteNamesQuery, StudentAcademicNoteNamesQueryVariables>(
		StudentAcademicNoteNamesDocument,
		options,
	);
}
export type StudentAcademicNoteNamesQueryHookResult = ReturnType<typeof useStudentAcademicNoteNamesQuery>;
export type StudentAcademicNoteNamesLazyQueryHookResult = ReturnType<typeof useStudentAcademicNoteNamesLazyQuery>;
export type StudentAcademicNoteNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentAcademicNoteNamesSuspenseQuery
>;
export type StudentAcademicNoteNamesQueryResult = Apollo.QueryResult<
	StudentAcademicNoteNamesQuery,
	StudentAcademicNoteNamesQueryVariables
>;
export const StudentAcademicNotePaginationDocument = gql`
	query studentAcademicNotePagination($filters: [StudentAcademicNoteFilterInput!], $order: StudentAcademicNoteOrder) {
		studentAcademicNoteConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentAcademicNotePaginationQuery__
 *
 * To run a query within a React component, call `useStudentAcademicNotePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicNotePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAcademicNotePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentAcademicNotePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentAcademicNotePaginationQuery,
		StudentAcademicNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAcademicNotePaginationQuery, StudentAcademicNotePaginationQueryVariables>(
		StudentAcademicNotePaginationDocument,
		options,
	);
}
export function useStudentAcademicNotePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentAcademicNotePaginationQuery,
		StudentAcademicNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAcademicNotePaginationQuery, StudentAcademicNotePaginationQueryVariables>(
		StudentAcademicNotePaginationDocument,
		options,
	);
}
export function useStudentAcademicNotePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAcademicNotePaginationQuery,
		StudentAcademicNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentAcademicNotePaginationQuery, StudentAcademicNotePaginationQueryVariables>(
		StudentAcademicNotePaginationDocument,
		options,
	);
}
export type StudentAcademicNotePaginationQueryHookResult = ReturnType<typeof useStudentAcademicNotePaginationQuery>;
export type StudentAcademicNotePaginationLazyQueryHookResult = ReturnType<
	typeof useStudentAcademicNotePaginationLazyQuery
>;
export type StudentAcademicNotePaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentAcademicNotePaginationSuspenseQuery
>;
export type StudentAcademicNotePaginationQueryResult = Apollo.QueryResult<
	StudentAcademicNotePaginationQuery,
	StudentAcademicNotePaginationQueryVariables
>;
export const StudentAcademicNoteSelectDocument = gql`
	query studentAcademicNoteSelect($filters: [StudentAcademicNoteFilterInput!], $order: StudentAcademicNoteOrder) {
		studentAcademicNoteConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentAcademicNoteName
				}
			}
		}
	}
	${StudentAcademicNoteNameFragmentDoc}
`;

/**
 * __useStudentAcademicNoteSelectQuery__
 *
 * To run a query within a React component, call `useStudentAcademicNoteSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicNoteSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAcademicNoteSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentAcademicNoteSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentAcademicNoteSelectQuery, StudentAcademicNoteSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAcademicNoteSelectQuery, StudentAcademicNoteSelectQueryVariables>(
		StudentAcademicNoteSelectDocument,
		options,
	);
}
export function useStudentAcademicNoteSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentAcademicNoteSelectQuery, StudentAcademicNoteSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAcademicNoteSelectQuery, StudentAcademicNoteSelectQueryVariables>(
		StudentAcademicNoteSelectDocument,
		options,
	);
}
export function useStudentAcademicNoteSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAcademicNoteSelectQuery,
		StudentAcademicNoteSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentAcademicNoteSelectQuery, StudentAcademicNoteSelectQueryVariables>(
		StudentAcademicNoteSelectDocument,
		options,
	);
}
export type StudentAcademicNoteSelectQueryHookResult = ReturnType<typeof useStudentAcademicNoteSelectQuery>;
export type StudentAcademicNoteSelectLazyQueryHookResult = ReturnType<typeof useStudentAcademicNoteSelectLazyQuery>;
export type StudentAcademicNoteSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentAcademicNoteSelectSuspenseQuery
>;
export type StudentAcademicNoteSelectQueryResult = Apollo.QueryResult<
	StudentAcademicNoteSelectQuery,
	StudentAcademicNoteSelectQueryVariables
>;
export const StudentAcademicNoteUpdateDocument = gql`
	mutation studentAcademicNoteUpdate($id: ID!, $input: StudentAcademicNoteUpdateInput!) {
		updateStudentAcademicNote(id: $id, input: $input) {
			...StudentAcademicNoteDetail
		}
	}
	${StudentAcademicNoteDetailFragmentDoc}
`;
export type StudentAcademicNoteUpdateMutationFn = Apollo.MutationFunction<
	StudentAcademicNoteUpdateMutation,
	StudentAcademicNoteUpdateMutationVariables
>;

/**
 * __useStudentAcademicNoteUpdateMutation__
 *
 * To run a mutation, you first call `useStudentAcademicNoteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicNoteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentAcademicNoteUpdateMutation, { data, loading, error }] = useStudentAcademicNoteUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentAcademicNoteUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentAcademicNoteUpdateMutation,
		StudentAcademicNoteUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentAcademicNoteUpdateMutation, StudentAcademicNoteUpdateMutationVariables>(
		StudentAcademicNoteUpdateDocument,
		options,
	);
}
export type StudentAcademicNoteUpdateMutationHookResult = ReturnType<typeof useStudentAcademicNoteUpdateMutation>;
export type StudentAcademicNoteUpdateMutationResult = Apollo.MutationResult<StudentAcademicNoteUpdateMutation>;
export type StudentAcademicNoteUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentAcademicNoteUpdateMutation,
	StudentAcademicNoteUpdateMutationVariables
>;
export const StudentAcademicTermEnrollmentCountDocument = gql`
	query studentAcademicTermEnrollmentCount(
		$filters: [StudentAcademicTermEnrollmentFilterInput!]
		$pagination: Pagination
		$order: StudentAcademicTermEnrollmentOrder
	) {
		studentAcademicTermEnrollmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentAcademicTermEnrollmentCountQuery__
 *
 * To run a query within a React component, call `useStudentAcademicTermEnrollmentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicTermEnrollmentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAcademicTermEnrollmentCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentAcademicTermEnrollmentCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentAcademicTermEnrollmentCountQuery,
		StudentAcademicTermEnrollmentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAcademicTermEnrollmentCountQuery, StudentAcademicTermEnrollmentCountQueryVariables>(
		StudentAcademicTermEnrollmentCountDocument,
		options,
	);
}
export function useStudentAcademicTermEnrollmentCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentAcademicTermEnrollmentCountQuery,
		StudentAcademicTermEnrollmentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAcademicTermEnrollmentCountQuery, StudentAcademicTermEnrollmentCountQueryVariables>(
		StudentAcademicTermEnrollmentCountDocument,
		options,
	);
}
export function useStudentAcademicTermEnrollmentCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAcademicTermEnrollmentCountQuery,
		StudentAcademicTermEnrollmentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentAcademicTermEnrollmentCountQuery,
		StudentAcademicTermEnrollmentCountQueryVariables
	>(StudentAcademicTermEnrollmentCountDocument, options);
}
export type StudentAcademicTermEnrollmentCountQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentCountQuery
>;
export type StudentAcademicTermEnrollmentCountLazyQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentCountLazyQuery
>;
export type StudentAcademicTermEnrollmentCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentCountSuspenseQuery
>;
export type StudentAcademicTermEnrollmentCountQueryResult = Apollo.QueryResult<
	StudentAcademicTermEnrollmentCountQuery,
	StudentAcademicTermEnrollmentCountQueryVariables
>;
export const StudentAcademicTermEnrollmentCreateDocument = gql`
	mutation studentAcademicTermEnrollmentCreate($input: StudentAcademicTermEnrollmentCreateInput!) {
		createStudentAcademicTermEnrollment(input: $input) {
			...StudentAcademicTermEnrollmentDetail
		}
	}
	${StudentAcademicTermEnrollmentDetailFragmentDoc}
`;
export type StudentAcademicTermEnrollmentCreateMutationFn = Apollo.MutationFunction<
	StudentAcademicTermEnrollmentCreateMutation,
	StudentAcademicTermEnrollmentCreateMutationVariables
>;

/**
 * __useStudentAcademicTermEnrollmentCreateMutation__
 *
 * To run a mutation, you first call `useStudentAcademicTermEnrollmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicTermEnrollmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentAcademicTermEnrollmentCreateMutation, { data, loading, error }] = useStudentAcademicTermEnrollmentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentAcademicTermEnrollmentCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentAcademicTermEnrollmentCreateMutation,
		StudentAcademicTermEnrollmentCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentAcademicTermEnrollmentCreateMutation,
		StudentAcademicTermEnrollmentCreateMutationVariables
	>(StudentAcademicTermEnrollmentCreateDocument, options);
}
export type StudentAcademicTermEnrollmentCreateMutationHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentCreateMutation
>;
export type StudentAcademicTermEnrollmentCreateMutationResult =
	Apollo.MutationResult<StudentAcademicTermEnrollmentCreateMutation>;
export type StudentAcademicTermEnrollmentCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentAcademicTermEnrollmentCreateMutation,
	StudentAcademicTermEnrollmentCreateMutationVariables
>;
export const StudentAcademicTermEnrollmentDeleteDocument = gql`
	mutation studentAcademicTermEnrollmentDelete($id: ID!) {
		deleteStudentAcademicTermEnrollment(id: $id)
	}
`;
export type StudentAcademicTermEnrollmentDeleteMutationFn = Apollo.MutationFunction<
	StudentAcademicTermEnrollmentDeleteMutation,
	StudentAcademicTermEnrollmentDeleteMutationVariables
>;

/**
 * __useStudentAcademicTermEnrollmentDeleteMutation__
 *
 * To run a mutation, you first call `useStudentAcademicTermEnrollmentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicTermEnrollmentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentAcademicTermEnrollmentDeleteMutation, { data, loading, error }] = useStudentAcademicTermEnrollmentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentAcademicTermEnrollmentDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentAcademicTermEnrollmentDeleteMutation,
		StudentAcademicTermEnrollmentDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentAcademicTermEnrollmentDeleteMutation,
		StudentAcademicTermEnrollmentDeleteMutationVariables
	>(StudentAcademicTermEnrollmentDeleteDocument, options);
}
export type StudentAcademicTermEnrollmentDeleteMutationHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentDeleteMutation
>;
export type StudentAcademicTermEnrollmentDeleteMutationResult =
	Apollo.MutationResult<StudentAcademicTermEnrollmentDeleteMutation>;
export type StudentAcademicTermEnrollmentDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentAcademicTermEnrollmentDeleteMutation,
	StudentAcademicTermEnrollmentDeleteMutationVariables
>;
export const StudentAcademicTermEnrollmentDetailDocument = gql`
	query studentAcademicTermEnrollmentDetail($id: ID!) {
		studentAcademicTermEnrollment(id: $id) {
			...StudentAcademicTermEnrollmentDetail
		}
	}
	${StudentAcademicTermEnrollmentDetailFragmentDoc}
`;

/**
 * __useStudentAcademicTermEnrollmentDetailQuery__
 *
 * To run a query within a React component, call `useStudentAcademicTermEnrollmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicTermEnrollmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAcademicTermEnrollmentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentAcademicTermEnrollmentDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentAcademicTermEnrollmentDetailQuery,
		StudentAcademicTermEnrollmentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAcademicTermEnrollmentDetailQuery, StudentAcademicTermEnrollmentDetailQueryVariables>(
		StudentAcademicTermEnrollmentDetailDocument,
		options,
	);
}
export function useStudentAcademicTermEnrollmentDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentAcademicTermEnrollmentDetailQuery,
		StudentAcademicTermEnrollmentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentAcademicTermEnrollmentDetailQuery,
		StudentAcademicTermEnrollmentDetailQueryVariables
	>(StudentAcademicTermEnrollmentDetailDocument, options);
}
export function useStudentAcademicTermEnrollmentDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAcademicTermEnrollmentDetailQuery,
		StudentAcademicTermEnrollmentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentAcademicTermEnrollmentDetailQuery,
		StudentAcademicTermEnrollmentDetailQueryVariables
	>(StudentAcademicTermEnrollmentDetailDocument, options);
}
export type StudentAcademicTermEnrollmentDetailQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentDetailQuery
>;
export type StudentAcademicTermEnrollmentDetailLazyQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentDetailLazyQuery
>;
export type StudentAcademicTermEnrollmentDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentDetailSuspenseQuery
>;
export type StudentAcademicTermEnrollmentDetailQueryResult = Apollo.QueryResult<
	StudentAcademicTermEnrollmentDetailQuery,
	StudentAcademicTermEnrollmentDetailQueryVariables
>;
export const StudentAcademicTermEnrollmentIndexDocument = gql`
	query studentAcademicTermEnrollmentIndex(
		$filters: [StudentAcademicTermEnrollmentFilterInput!]
		$pagination: Pagination
		$order: StudentAcademicTermEnrollmentOrder
	) {
		studentAcademicTermEnrollmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					lateStartDate
					earlyEndDate
				}
			}
		}
	}
`;

/**
 * __useStudentAcademicTermEnrollmentIndexQuery__
 *
 * To run a query within a React component, call `useStudentAcademicTermEnrollmentIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicTermEnrollmentIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAcademicTermEnrollmentIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentAcademicTermEnrollmentIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentAcademicTermEnrollmentIndexQuery,
		StudentAcademicTermEnrollmentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAcademicTermEnrollmentIndexQuery, StudentAcademicTermEnrollmentIndexQueryVariables>(
		StudentAcademicTermEnrollmentIndexDocument,
		options,
	);
}
export function useStudentAcademicTermEnrollmentIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentAcademicTermEnrollmentIndexQuery,
		StudentAcademicTermEnrollmentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAcademicTermEnrollmentIndexQuery, StudentAcademicTermEnrollmentIndexQueryVariables>(
		StudentAcademicTermEnrollmentIndexDocument,
		options,
	);
}
export function useStudentAcademicTermEnrollmentIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAcademicTermEnrollmentIndexQuery,
		StudentAcademicTermEnrollmentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentAcademicTermEnrollmentIndexQuery,
		StudentAcademicTermEnrollmentIndexQueryVariables
	>(StudentAcademicTermEnrollmentIndexDocument, options);
}
export type StudentAcademicTermEnrollmentIndexQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentIndexQuery
>;
export type StudentAcademicTermEnrollmentIndexLazyQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentIndexLazyQuery
>;
export type StudentAcademicTermEnrollmentIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentIndexSuspenseQuery
>;
export type StudentAcademicTermEnrollmentIndexQueryResult = Apollo.QueryResult<
	StudentAcademicTermEnrollmentIndexQuery,
	StudentAcademicTermEnrollmentIndexQueryVariables
>;
export const StudentAcademicTermEnrollmentListDocument = gql`
	query studentAcademicTermEnrollmentList(
		$filters: [StudentAcademicTermEnrollmentFilterInput!]
		$pagination: Pagination
		$order: StudentAcademicTermEnrollmentOrder
	) {
		studentAcademicTermEnrollmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					lateStartDate
					earlyEndDate
					academicTerm {
						id
						startDate
						endDate
					}
				}
			}
		}
	}
`;

/**
 * __useStudentAcademicTermEnrollmentListQuery__
 *
 * To run a query within a React component, call `useStudentAcademicTermEnrollmentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicTermEnrollmentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAcademicTermEnrollmentListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentAcademicTermEnrollmentListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentAcademicTermEnrollmentListQuery,
		StudentAcademicTermEnrollmentListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAcademicTermEnrollmentListQuery, StudentAcademicTermEnrollmentListQueryVariables>(
		StudentAcademicTermEnrollmentListDocument,
		options,
	);
}
export function useStudentAcademicTermEnrollmentListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentAcademicTermEnrollmentListQuery,
		StudentAcademicTermEnrollmentListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAcademicTermEnrollmentListQuery, StudentAcademicTermEnrollmentListQueryVariables>(
		StudentAcademicTermEnrollmentListDocument,
		options,
	);
}
export function useStudentAcademicTermEnrollmentListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAcademicTermEnrollmentListQuery,
		StudentAcademicTermEnrollmentListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentAcademicTermEnrollmentListQuery,
		StudentAcademicTermEnrollmentListQueryVariables
	>(StudentAcademicTermEnrollmentListDocument, options);
}
export type StudentAcademicTermEnrollmentListQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentListQuery
>;
export type StudentAcademicTermEnrollmentListLazyQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentListLazyQuery
>;
export type StudentAcademicTermEnrollmentListSuspenseQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentListSuspenseQuery
>;
export type StudentAcademicTermEnrollmentListQueryResult = Apollo.QueryResult<
	StudentAcademicTermEnrollmentListQuery,
	StudentAcademicTermEnrollmentListQueryVariables
>;
export const StudentAcademicTermEnrollmentNameDocument = gql`
	query studentAcademicTermEnrollmentName($id: ID!) {
		studentAcademicTermEnrollment(id: $id) {
			id
			...StudentAcademicTermEnrollmentName
		}
	}
	${StudentAcademicTermEnrollmentNameFragmentDoc}
`;

/**
 * __useStudentAcademicTermEnrollmentNameQuery__
 *
 * To run a query within a React component, call `useStudentAcademicTermEnrollmentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicTermEnrollmentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAcademicTermEnrollmentNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentAcademicTermEnrollmentNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentAcademicTermEnrollmentNameQuery,
		StudentAcademicTermEnrollmentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAcademicTermEnrollmentNameQuery, StudentAcademicTermEnrollmentNameQueryVariables>(
		StudentAcademicTermEnrollmentNameDocument,
		options,
	);
}
export function useStudentAcademicTermEnrollmentNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentAcademicTermEnrollmentNameQuery,
		StudentAcademicTermEnrollmentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAcademicTermEnrollmentNameQuery, StudentAcademicTermEnrollmentNameQueryVariables>(
		StudentAcademicTermEnrollmentNameDocument,
		options,
	);
}
export function useStudentAcademicTermEnrollmentNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAcademicTermEnrollmentNameQuery,
		StudentAcademicTermEnrollmentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentAcademicTermEnrollmentNameQuery,
		StudentAcademicTermEnrollmentNameQueryVariables
	>(StudentAcademicTermEnrollmentNameDocument, options);
}
export type StudentAcademicTermEnrollmentNameQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentNameQuery
>;
export type StudentAcademicTermEnrollmentNameLazyQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentNameLazyQuery
>;
export type StudentAcademicTermEnrollmentNameSuspenseQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentNameSuspenseQuery
>;
export type StudentAcademicTermEnrollmentNameQueryResult = Apollo.QueryResult<
	StudentAcademicTermEnrollmentNameQuery,
	StudentAcademicTermEnrollmentNameQueryVariables
>;
export const StudentAcademicTermEnrollmentNamesDocument = gql`
	query studentAcademicTermEnrollmentNames(
		$filters: [StudentAcademicTermEnrollmentFilterInput!]
		$pagination: Pagination
		$order: StudentAcademicTermEnrollmentOrder
	) {
		studentAcademicTermEnrollmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentAcademicTermEnrollmentName
				}
			}
		}
	}
	${StudentAcademicTermEnrollmentNameFragmentDoc}
`;

/**
 * __useStudentAcademicTermEnrollmentNamesQuery__
 *
 * To run a query within a React component, call `useStudentAcademicTermEnrollmentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicTermEnrollmentNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAcademicTermEnrollmentNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentAcademicTermEnrollmentNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentAcademicTermEnrollmentNamesQuery,
		StudentAcademicTermEnrollmentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAcademicTermEnrollmentNamesQuery, StudentAcademicTermEnrollmentNamesQueryVariables>(
		StudentAcademicTermEnrollmentNamesDocument,
		options,
	);
}
export function useStudentAcademicTermEnrollmentNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentAcademicTermEnrollmentNamesQuery,
		StudentAcademicTermEnrollmentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAcademicTermEnrollmentNamesQuery, StudentAcademicTermEnrollmentNamesQueryVariables>(
		StudentAcademicTermEnrollmentNamesDocument,
		options,
	);
}
export function useStudentAcademicTermEnrollmentNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAcademicTermEnrollmentNamesQuery,
		StudentAcademicTermEnrollmentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentAcademicTermEnrollmentNamesQuery,
		StudentAcademicTermEnrollmentNamesQueryVariables
	>(StudentAcademicTermEnrollmentNamesDocument, options);
}
export type StudentAcademicTermEnrollmentNamesQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentNamesQuery
>;
export type StudentAcademicTermEnrollmentNamesLazyQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentNamesLazyQuery
>;
export type StudentAcademicTermEnrollmentNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentNamesSuspenseQuery
>;
export type StudentAcademicTermEnrollmentNamesQueryResult = Apollo.QueryResult<
	StudentAcademicTermEnrollmentNamesQuery,
	StudentAcademicTermEnrollmentNamesQueryVariables
>;
export const StudentAcademicTermEnrollmentPaginationDocument = gql`
	query studentAcademicTermEnrollmentPagination(
		$filters: [StudentAcademicTermEnrollmentFilterInput!]
		$order: StudentAcademicTermEnrollmentOrder
	) {
		studentAcademicTermEnrollmentConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentAcademicTermEnrollmentPaginationQuery__
 *
 * To run a query within a React component, call `useStudentAcademicTermEnrollmentPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicTermEnrollmentPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAcademicTermEnrollmentPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentAcademicTermEnrollmentPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentAcademicTermEnrollmentPaginationQuery,
		StudentAcademicTermEnrollmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentAcademicTermEnrollmentPaginationQuery,
		StudentAcademicTermEnrollmentPaginationQueryVariables
	>(StudentAcademicTermEnrollmentPaginationDocument, options);
}
export function useStudentAcademicTermEnrollmentPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentAcademicTermEnrollmentPaginationQuery,
		StudentAcademicTermEnrollmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentAcademicTermEnrollmentPaginationQuery,
		StudentAcademicTermEnrollmentPaginationQueryVariables
	>(StudentAcademicTermEnrollmentPaginationDocument, options);
}
export function useStudentAcademicTermEnrollmentPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAcademicTermEnrollmentPaginationQuery,
		StudentAcademicTermEnrollmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentAcademicTermEnrollmentPaginationQuery,
		StudentAcademicTermEnrollmentPaginationQueryVariables
	>(StudentAcademicTermEnrollmentPaginationDocument, options);
}
export type StudentAcademicTermEnrollmentPaginationQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentPaginationQuery
>;
export type StudentAcademicTermEnrollmentPaginationLazyQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentPaginationLazyQuery
>;
export type StudentAcademicTermEnrollmentPaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentPaginationSuspenseQuery
>;
export type StudentAcademicTermEnrollmentPaginationQueryResult = Apollo.QueryResult<
	StudentAcademicTermEnrollmentPaginationQuery,
	StudentAcademicTermEnrollmentPaginationQueryVariables
>;
export const StudentAcademicTermEnrollmentSelectDocument = gql`
	query studentAcademicTermEnrollmentSelect(
		$filters: [StudentAcademicTermEnrollmentFilterInput!]
		$order: StudentAcademicTermEnrollmentOrder
	) {
		studentAcademicTermEnrollmentConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentAcademicTermEnrollmentName
				}
			}
		}
	}
	${StudentAcademicTermEnrollmentNameFragmentDoc}
`;

/**
 * __useStudentAcademicTermEnrollmentSelectQuery__
 *
 * To run a query within a React component, call `useStudentAcademicTermEnrollmentSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicTermEnrollmentSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAcademicTermEnrollmentSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentAcademicTermEnrollmentSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentAcademicTermEnrollmentSelectQuery,
		StudentAcademicTermEnrollmentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAcademicTermEnrollmentSelectQuery, StudentAcademicTermEnrollmentSelectQueryVariables>(
		StudentAcademicTermEnrollmentSelectDocument,
		options,
	);
}
export function useStudentAcademicTermEnrollmentSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentAcademicTermEnrollmentSelectQuery,
		StudentAcademicTermEnrollmentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentAcademicTermEnrollmentSelectQuery,
		StudentAcademicTermEnrollmentSelectQueryVariables
	>(StudentAcademicTermEnrollmentSelectDocument, options);
}
export function useStudentAcademicTermEnrollmentSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAcademicTermEnrollmentSelectQuery,
		StudentAcademicTermEnrollmentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentAcademicTermEnrollmentSelectQuery,
		StudentAcademicTermEnrollmentSelectQueryVariables
	>(StudentAcademicTermEnrollmentSelectDocument, options);
}
export type StudentAcademicTermEnrollmentSelectQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentSelectQuery
>;
export type StudentAcademicTermEnrollmentSelectLazyQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentSelectLazyQuery
>;
export type StudentAcademicTermEnrollmentSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentSelectSuspenseQuery
>;
export type StudentAcademicTermEnrollmentSelectQueryResult = Apollo.QueryResult<
	StudentAcademicTermEnrollmentSelectQuery,
	StudentAcademicTermEnrollmentSelectQueryVariables
>;
export const StudentAcademicTermEnrollmentUpdateDocument = gql`
	mutation studentAcademicTermEnrollmentUpdate($id: ID!, $input: StudentAcademicTermEnrollmentUpdateInput!) {
		updateStudentAcademicTermEnrollment(id: $id, input: $input) {
			...StudentAcademicTermEnrollmentDetail
		}
	}
	${StudentAcademicTermEnrollmentDetailFragmentDoc}
`;
export type StudentAcademicTermEnrollmentUpdateMutationFn = Apollo.MutationFunction<
	StudentAcademicTermEnrollmentUpdateMutation,
	StudentAcademicTermEnrollmentUpdateMutationVariables
>;

/**
 * __useStudentAcademicTermEnrollmentUpdateMutation__
 *
 * To run a mutation, you first call `useStudentAcademicTermEnrollmentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentAcademicTermEnrollmentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentAcademicTermEnrollmentUpdateMutation, { data, loading, error }] = useStudentAcademicTermEnrollmentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentAcademicTermEnrollmentUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentAcademicTermEnrollmentUpdateMutation,
		StudentAcademicTermEnrollmentUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentAcademicTermEnrollmentUpdateMutation,
		StudentAcademicTermEnrollmentUpdateMutationVariables
	>(StudentAcademicTermEnrollmentUpdateDocument, options);
}
export type StudentAcademicTermEnrollmentUpdateMutationHookResult = ReturnType<
	typeof useStudentAcademicTermEnrollmentUpdateMutation
>;
export type StudentAcademicTermEnrollmentUpdateMutationResult =
	Apollo.MutationResult<StudentAcademicTermEnrollmentUpdateMutation>;
export type StudentAcademicTermEnrollmentUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentAcademicTermEnrollmentUpdateMutation,
	StudentAcademicTermEnrollmentUpdateMutationVariables
>;
export const StudentAttendanceNoteCountDocument = gql`
	query studentAttendanceNoteCount(
		$filters: [StudentAttendanceNoteFilterInput!]
		$pagination: Pagination
		$order: StudentAttendanceNoteOrder
	) {
		studentAttendanceNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentAttendanceNoteCountQuery__
 *
 * To run a query within a React component, call `useStudentAttendanceNoteCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAttendanceNoteCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAttendanceNoteCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentAttendanceNoteCountQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentAttendanceNoteCountQuery, StudentAttendanceNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAttendanceNoteCountQuery, StudentAttendanceNoteCountQueryVariables>(
		StudentAttendanceNoteCountDocument,
		options,
	);
}
export function useStudentAttendanceNoteCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentAttendanceNoteCountQuery, StudentAttendanceNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAttendanceNoteCountQuery, StudentAttendanceNoteCountQueryVariables>(
		StudentAttendanceNoteCountDocument,
		options,
	);
}
export function useStudentAttendanceNoteCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAttendanceNoteCountQuery,
		StudentAttendanceNoteCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentAttendanceNoteCountQuery, StudentAttendanceNoteCountQueryVariables>(
		StudentAttendanceNoteCountDocument,
		options,
	);
}
export type StudentAttendanceNoteCountQueryHookResult = ReturnType<typeof useStudentAttendanceNoteCountQuery>;
export type StudentAttendanceNoteCountLazyQueryHookResult = ReturnType<typeof useStudentAttendanceNoteCountLazyQuery>;
export type StudentAttendanceNoteCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentAttendanceNoteCountSuspenseQuery
>;
export type StudentAttendanceNoteCountQueryResult = Apollo.QueryResult<
	StudentAttendanceNoteCountQuery,
	StudentAttendanceNoteCountQueryVariables
>;
export const StudentAttendanceNoteCreateDocument = gql`
	mutation studentAttendanceNoteCreate($input: StudentAttendanceNoteCreateInput!) {
		createStudentAttendanceNote(input: $input) {
			...StudentAttendanceNoteDetail
		}
	}
	${StudentAttendanceNoteDetailFragmentDoc}
`;
export type StudentAttendanceNoteCreateMutationFn = Apollo.MutationFunction<
	StudentAttendanceNoteCreateMutation,
	StudentAttendanceNoteCreateMutationVariables
>;

/**
 * __useStudentAttendanceNoteCreateMutation__
 *
 * To run a mutation, you first call `useStudentAttendanceNoteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentAttendanceNoteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentAttendanceNoteCreateMutation, { data, loading, error }] = useStudentAttendanceNoteCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentAttendanceNoteCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentAttendanceNoteCreateMutation,
		StudentAttendanceNoteCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentAttendanceNoteCreateMutation, StudentAttendanceNoteCreateMutationVariables>(
		StudentAttendanceNoteCreateDocument,
		options,
	);
}
export type StudentAttendanceNoteCreateMutationHookResult = ReturnType<typeof useStudentAttendanceNoteCreateMutation>;
export type StudentAttendanceNoteCreateMutationResult = Apollo.MutationResult<StudentAttendanceNoteCreateMutation>;
export type StudentAttendanceNoteCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentAttendanceNoteCreateMutation,
	StudentAttendanceNoteCreateMutationVariables
>;
export const StudentAttendanceNoteDeleteDocument = gql`
	mutation studentAttendanceNoteDelete($id: ID!) {
		deleteStudentAttendanceNote(id: $id)
	}
`;
export type StudentAttendanceNoteDeleteMutationFn = Apollo.MutationFunction<
	StudentAttendanceNoteDeleteMutation,
	StudentAttendanceNoteDeleteMutationVariables
>;

/**
 * __useStudentAttendanceNoteDeleteMutation__
 *
 * To run a mutation, you first call `useStudentAttendanceNoteDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentAttendanceNoteDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentAttendanceNoteDeleteMutation, { data, loading, error }] = useStudentAttendanceNoteDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentAttendanceNoteDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentAttendanceNoteDeleteMutation,
		StudentAttendanceNoteDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentAttendanceNoteDeleteMutation, StudentAttendanceNoteDeleteMutationVariables>(
		StudentAttendanceNoteDeleteDocument,
		options,
	);
}
export type StudentAttendanceNoteDeleteMutationHookResult = ReturnType<typeof useStudentAttendanceNoteDeleteMutation>;
export type StudentAttendanceNoteDeleteMutationResult = Apollo.MutationResult<StudentAttendanceNoteDeleteMutation>;
export type StudentAttendanceNoteDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentAttendanceNoteDeleteMutation,
	StudentAttendanceNoteDeleteMutationVariables
>;
export const StudentAttendanceNoteDetailDocument = gql`
	query studentAttendanceNoteDetail($id: ID!) {
		studentAttendanceNote(id: $id) {
			...StudentAttendanceNoteDetail
		}
	}
	${StudentAttendanceNoteDetailFragmentDoc}
`;

/**
 * __useStudentAttendanceNoteDetailQuery__
 *
 * To run a query within a React component, call `useStudentAttendanceNoteDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAttendanceNoteDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAttendanceNoteDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentAttendanceNoteDetailQuery(
	baseOptions: Apollo.QueryHookOptions<StudentAttendanceNoteDetailQuery, StudentAttendanceNoteDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAttendanceNoteDetailQuery, StudentAttendanceNoteDetailQueryVariables>(
		StudentAttendanceNoteDetailDocument,
		options,
	);
}
export function useStudentAttendanceNoteDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentAttendanceNoteDetailQuery,
		StudentAttendanceNoteDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAttendanceNoteDetailQuery, StudentAttendanceNoteDetailQueryVariables>(
		StudentAttendanceNoteDetailDocument,
		options,
	);
}
export function useStudentAttendanceNoteDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAttendanceNoteDetailQuery,
		StudentAttendanceNoteDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentAttendanceNoteDetailQuery, StudentAttendanceNoteDetailQueryVariables>(
		StudentAttendanceNoteDetailDocument,
		options,
	);
}
export type StudentAttendanceNoteDetailQueryHookResult = ReturnType<typeof useStudentAttendanceNoteDetailQuery>;
export type StudentAttendanceNoteDetailLazyQueryHookResult = ReturnType<typeof useStudentAttendanceNoteDetailLazyQuery>;
export type StudentAttendanceNoteDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentAttendanceNoteDetailSuspenseQuery
>;
export type StudentAttendanceNoteDetailQueryResult = Apollo.QueryResult<
	StudentAttendanceNoteDetailQuery,
	StudentAttendanceNoteDetailQueryVariables
>;
export const StudentAttendanceNoteIndexDocument = gql`
	query studentAttendanceNoteIndex(
		$filters: [StudentAttendanceNoteFilterInput!]
		$pagination: Pagination
		$order: StudentAttendanceNoteOrder
	) {
		studentAttendanceNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					startDate
					endDate
				}
			}
		}
	}
`;

/**
 * __useStudentAttendanceNoteIndexQuery__
 *
 * To run a query within a React component, call `useStudentAttendanceNoteIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAttendanceNoteIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAttendanceNoteIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentAttendanceNoteIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentAttendanceNoteIndexQuery, StudentAttendanceNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAttendanceNoteIndexQuery, StudentAttendanceNoteIndexQueryVariables>(
		StudentAttendanceNoteIndexDocument,
		options,
	);
}
export function useStudentAttendanceNoteIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentAttendanceNoteIndexQuery, StudentAttendanceNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAttendanceNoteIndexQuery, StudentAttendanceNoteIndexQueryVariables>(
		StudentAttendanceNoteIndexDocument,
		options,
	);
}
export function useStudentAttendanceNoteIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAttendanceNoteIndexQuery,
		StudentAttendanceNoteIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentAttendanceNoteIndexQuery, StudentAttendanceNoteIndexQueryVariables>(
		StudentAttendanceNoteIndexDocument,
		options,
	);
}
export type StudentAttendanceNoteIndexQueryHookResult = ReturnType<typeof useStudentAttendanceNoteIndexQuery>;
export type StudentAttendanceNoteIndexLazyQueryHookResult = ReturnType<typeof useStudentAttendanceNoteIndexLazyQuery>;
export type StudentAttendanceNoteIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentAttendanceNoteIndexSuspenseQuery
>;
export type StudentAttendanceNoteIndexQueryResult = Apollo.QueryResult<
	StudentAttendanceNoteIndexQuery,
	StudentAttendanceNoteIndexQueryVariables
>;
export const StudentAttendanceNoteNameDocument = gql`
	query studentAttendanceNoteName($id: ID!) {
		studentAttendanceNote(id: $id) {
			id
			...StudentAttendanceNoteName
		}
	}
	${StudentAttendanceNoteNameFragmentDoc}
`;

/**
 * __useStudentAttendanceNoteNameQuery__
 *
 * To run a query within a React component, call `useStudentAttendanceNoteNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAttendanceNoteNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAttendanceNoteNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentAttendanceNoteNameQuery(
	baseOptions: Apollo.QueryHookOptions<StudentAttendanceNoteNameQuery, StudentAttendanceNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAttendanceNoteNameQuery, StudentAttendanceNoteNameQueryVariables>(
		StudentAttendanceNoteNameDocument,
		options,
	);
}
export function useStudentAttendanceNoteNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentAttendanceNoteNameQuery, StudentAttendanceNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAttendanceNoteNameQuery, StudentAttendanceNoteNameQueryVariables>(
		StudentAttendanceNoteNameDocument,
		options,
	);
}
export function useStudentAttendanceNoteNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAttendanceNoteNameQuery,
		StudentAttendanceNoteNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentAttendanceNoteNameQuery, StudentAttendanceNoteNameQueryVariables>(
		StudentAttendanceNoteNameDocument,
		options,
	);
}
export type StudentAttendanceNoteNameQueryHookResult = ReturnType<typeof useStudentAttendanceNoteNameQuery>;
export type StudentAttendanceNoteNameLazyQueryHookResult = ReturnType<typeof useStudentAttendanceNoteNameLazyQuery>;
export type StudentAttendanceNoteNameSuspenseQueryHookResult = ReturnType<
	typeof useStudentAttendanceNoteNameSuspenseQuery
>;
export type StudentAttendanceNoteNameQueryResult = Apollo.QueryResult<
	StudentAttendanceNoteNameQuery,
	StudentAttendanceNoteNameQueryVariables
>;
export const StudentAttendanceNoteNamesDocument = gql`
	query studentAttendanceNoteNames(
		$filters: [StudentAttendanceNoteFilterInput!]
		$pagination: Pagination
		$order: StudentAttendanceNoteOrder
	) {
		studentAttendanceNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentAttendanceNoteName
				}
			}
		}
	}
	${StudentAttendanceNoteNameFragmentDoc}
`;

/**
 * __useStudentAttendanceNoteNamesQuery__
 *
 * To run a query within a React component, call `useStudentAttendanceNoteNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAttendanceNoteNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAttendanceNoteNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentAttendanceNoteNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentAttendanceNoteNamesQuery, StudentAttendanceNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAttendanceNoteNamesQuery, StudentAttendanceNoteNamesQueryVariables>(
		StudentAttendanceNoteNamesDocument,
		options,
	);
}
export function useStudentAttendanceNoteNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentAttendanceNoteNamesQuery, StudentAttendanceNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAttendanceNoteNamesQuery, StudentAttendanceNoteNamesQueryVariables>(
		StudentAttendanceNoteNamesDocument,
		options,
	);
}
export function useStudentAttendanceNoteNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAttendanceNoteNamesQuery,
		StudentAttendanceNoteNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentAttendanceNoteNamesQuery, StudentAttendanceNoteNamesQueryVariables>(
		StudentAttendanceNoteNamesDocument,
		options,
	);
}
export type StudentAttendanceNoteNamesQueryHookResult = ReturnType<typeof useStudentAttendanceNoteNamesQuery>;
export type StudentAttendanceNoteNamesLazyQueryHookResult = ReturnType<typeof useStudentAttendanceNoteNamesLazyQuery>;
export type StudentAttendanceNoteNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentAttendanceNoteNamesSuspenseQuery
>;
export type StudentAttendanceNoteNamesQueryResult = Apollo.QueryResult<
	StudentAttendanceNoteNamesQuery,
	StudentAttendanceNoteNamesQueryVariables
>;
export const StudentAttendanceNotePaginationDocument = gql`
	query studentAttendanceNotePagination(
		$filters: [StudentAttendanceNoteFilterInput!]
		$order: StudentAttendanceNoteOrder
	) {
		studentAttendanceNoteConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentAttendanceNotePaginationQuery__
 *
 * To run a query within a React component, call `useStudentAttendanceNotePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAttendanceNotePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAttendanceNotePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentAttendanceNotePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentAttendanceNotePaginationQuery,
		StudentAttendanceNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAttendanceNotePaginationQuery, StudentAttendanceNotePaginationQueryVariables>(
		StudentAttendanceNotePaginationDocument,
		options,
	);
}
export function useStudentAttendanceNotePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentAttendanceNotePaginationQuery,
		StudentAttendanceNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAttendanceNotePaginationQuery, StudentAttendanceNotePaginationQueryVariables>(
		StudentAttendanceNotePaginationDocument,
		options,
	);
}
export function useStudentAttendanceNotePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAttendanceNotePaginationQuery,
		StudentAttendanceNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentAttendanceNotePaginationQuery, StudentAttendanceNotePaginationQueryVariables>(
		StudentAttendanceNotePaginationDocument,
		options,
	);
}
export type StudentAttendanceNotePaginationQueryHookResult = ReturnType<typeof useStudentAttendanceNotePaginationQuery>;
export type StudentAttendanceNotePaginationLazyQueryHookResult = ReturnType<
	typeof useStudentAttendanceNotePaginationLazyQuery
>;
export type StudentAttendanceNotePaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentAttendanceNotePaginationSuspenseQuery
>;
export type StudentAttendanceNotePaginationQueryResult = Apollo.QueryResult<
	StudentAttendanceNotePaginationQuery,
	StudentAttendanceNotePaginationQueryVariables
>;
export const StudentAttendanceNoteSelectDocument = gql`
	query studentAttendanceNoteSelect($filters: [StudentAttendanceNoteFilterInput!], $order: StudentAttendanceNoteOrder) {
		studentAttendanceNoteConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentAttendanceNoteName
				}
			}
		}
	}
	${StudentAttendanceNoteNameFragmentDoc}
`;

/**
 * __useStudentAttendanceNoteSelectQuery__
 *
 * To run a query within a React component, call `useStudentAttendanceNoteSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAttendanceNoteSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAttendanceNoteSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentAttendanceNoteSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentAttendanceNoteSelectQuery, StudentAttendanceNoteSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAttendanceNoteSelectQuery, StudentAttendanceNoteSelectQueryVariables>(
		StudentAttendanceNoteSelectDocument,
		options,
	);
}
export function useStudentAttendanceNoteSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentAttendanceNoteSelectQuery,
		StudentAttendanceNoteSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAttendanceNoteSelectQuery, StudentAttendanceNoteSelectQueryVariables>(
		StudentAttendanceNoteSelectDocument,
		options,
	);
}
export function useStudentAttendanceNoteSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAttendanceNoteSelectQuery,
		StudentAttendanceNoteSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentAttendanceNoteSelectQuery, StudentAttendanceNoteSelectQueryVariables>(
		StudentAttendanceNoteSelectDocument,
		options,
	);
}
export type StudentAttendanceNoteSelectQueryHookResult = ReturnType<typeof useStudentAttendanceNoteSelectQuery>;
export type StudentAttendanceNoteSelectLazyQueryHookResult = ReturnType<typeof useStudentAttendanceNoteSelectLazyQuery>;
export type StudentAttendanceNoteSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentAttendanceNoteSelectSuspenseQuery
>;
export type StudentAttendanceNoteSelectQueryResult = Apollo.QueryResult<
	StudentAttendanceNoteSelectQuery,
	StudentAttendanceNoteSelectQueryVariables
>;
export const StudentAttendanceNoteUpdateDocument = gql`
	mutation studentAttendanceNoteUpdate($id: ID!, $input: StudentAttendanceNoteUpdateInput!) {
		updateStudentAttendanceNote(id: $id, input: $input) {
			...StudentAttendanceNoteDetail
		}
	}
	${StudentAttendanceNoteDetailFragmentDoc}
`;
export type StudentAttendanceNoteUpdateMutationFn = Apollo.MutationFunction<
	StudentAttendanceNoteUpdateMutation,
	StudentAttendanceNoteUpdateMutationVariables
>;

/**
 * __useStudentAttendanceNoteUpdateMutation__
 *
 * To run a mutation, you first call `useStudentAttendanceNoteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentAttendanceNoteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentAttendanceNoteUpdateMutation, { data, loading, error }] = useStudentAttendanceNoteUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentAttendanceNoteUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentAttendanceNoteUpdateMutation,
		StudentAttendanceNoteUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentAttendanceNoteUpdateMutation, StudentAttendanceNoteUpdateMutationVariables>(
		StudentAttendanceNoteUpdateDocument,
		options,
	);
}
export type StudentAttendanceNoteUpdateMutationHookResult = ReturnType<typeof useStudentAttendanceNoteUpdateMutation>;
export type StudentAttendanceNoteUpdateMutationResult = Apollo.MutationResult<StudentAttendanceNoteUpdateMutation>;
export type StudentAttendanceNoteUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentAttendanceNoteUpdateMutation,
	StudentAttendanceNoteUpdateMutationVariables
>;
export const StudentBehaviorNoteCountDocument = gql`
	query studentBehaviorNoteCount(
		$filters: [StudentBehaviorNoteFilterInput!]
		$pagination: Pagination
		$order: StudentBehaviorNoteOrder
	) {
		studentBehaviorNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentBehaviorNoteCountQuery__
 *
 * To run a query within a React component, call `useStudentBehaviorNoteCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentBehaviorNoteCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentBehaviorNoteCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentBehaviorNoteCountQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentBehaviorNoteCountQuery, StudentBehaviorNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentBehaviorNoteCountQuery, StudentBehaviorNoteCountQueryVariables>(
		StudentBehaviorNoteCountDocument,
		options,
	);
}
export function useStudentBehaviorNoteCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentBehaviorNoteCountQuery, StudentBehaviorNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentBehaviorNoteCountQuery, StudentBehaviorNoteCountQueryVariables>(
		StudentBehaviorNoteCountDocument,
		options,
	);
}
export function useStudentBehaviorNoteCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentBehaviorNoteCountQuery, StudentBehaviorNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentBehaviorNoteCountQuery, StudentBehaviorNoteCountQueryVariables>(
		StudentBehaviorNoteCountDocument,
		options,
	);
}
export type StudentBehaviorNoteCountQueryHookResult = ReturnType<typeof useStudentBehaviorNoteCountQuery>;
export type StudentBehaviorNoteCountLazyQueryHookResult = ReturnType<typeof useStudentBehaviorNoteCountLazyQuery>;
export type StudentBehaviorNoteCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentBehaviorNoteCountSuspenseQuery
>;
export type StudentBehaviorNoteCountQueryResult = Apollo.QueryResult<
	StudentBehaviorNoteCountQuery,
	StudentBehaviorNoteCountQueryVariables
>;
export const StudentBehaviorNoteCreateDocument = gql`
	mutation studentBehaviorNoteCreate($input: StudentBehaviorNoteCreateInput!) {
		createStudentBehaviorNote(input: $input) {
			...StudentBehaviorNoteDetail
		}
	}
	${StudentBehaviorNoteDetailFragmentDoc}
`;
export type StudentBehaviorNoteCreateMutationFn = Apollo.MutationFunction<
	StudentBehaviorNoteCreateMutation,
	StudentBehaviorNoteCreateMutationVariables
>;

/**
 * __useStudentBehaviorNoteCreateMutation__
 *
 * To run a mutation, you first call `useStudentBehaviorNoteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentBehaviorNoteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentBehaviorNoteCreateMutation, { data, loading, error }] = useStudentBehaviorNoteCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentBehaviorNoteCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentBehaviorNoteCreateMutation,
		StudentBehaviorNoteCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentBehaviorNoteCreateMutation, StudentBehaviorNoteCreateMutationVariables>(
		StudentBehaviorNoteCreateDocument,
		options,
	);
}
export type StudentBehaviorNoteCreateMutationHookResult = ReturnType<typeof useStudentBehaviorNoteCreateMutation>;
export type StudentBehaviorNoteCreateMutationResult = Apollo.MutationResult<StudentBehaviorNoteCreateMutation>;
export type StudentBehaviorNoteCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentBehaviorNoteCreateMutation,
	StudentBehaviorNoteCreateMutationVariables
>;
export const StudentBehaviorNoteDeleteDocument = gql`
	mutation studentBehaviorNoteDelete($id: ID!) {
		deleteStudentBehaviorNote(id: $id)
	}
`;
export type StudentBehaviorNoteDeleteMutationFn = Apollo.MutationFunction<
	StudentBehaviorNoteDeleteMutation,
	StudentBehaviorNoteDeleteMutationVariables
>;

/**
 * __useStudentBehaviorNoteDeleteMutation__
 *
 * To run a mutation, you first call `useStudentBehaviorNoteDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentBehaviorNoteDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentBehaviorNoteDeleteMutation, { data, loading, error }] = useStudentBehaviorNoteDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentBehaviorNoteDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentBehaviorNoteDeleteMutation,
		StudentBehaviorNoteDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentBehaviorNoteDeleteMutation, StudentBehaviorNoteDeleteMutationVariables>(
		StudentBehaviorNoteDeleteDocument,
		options,
	);
}
export type StudentBehaviorNoteDeleteMutationHookResult = ReturnType<typeof useStudentBehaviorNoteDeleteMutation>;
export type StudentBehaviorNoteDeleteMutationResult = Apollo.MutationResult<StudentBehaviorNoteDeleteMutation>;
export type StudentBehaviorNoteDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentBehaviorNoteDeleteMutation,
	StudentBehaviorNoteDeleteMutationVariables
>;
export const StudentBehaviorNoteDetailDocument = gql`
	query studentBehaviorNoteDetail($id: ID!) {
		studentBehaviorNote(id: $id) {
			...StudentBehaviorNoteDetail
		}
	}
	${StudentBehaviorNoteDetailFragmentDoc}
`;

/**
 * __useStudentBehaviorNoteDetailQuery__
 *
 * To run a query within a React component, call `useStudentBehaviorNoteDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentBehaviorNoteDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentBehaviorNoteDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentBehaviorNoteDetailQuery(
	baseOptions: Apollo.QueryHookOptions<StudentBehaviorNoteDetailQuery, StudentBehaviorNoteDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentBehaviorNoteDetailQuery, StudentBehaviorNoteDetailQueryVariables>(
		StudentBehaviorNoteDetailDocument,
		options,
	);
}
export function useStudentBehaviorNoteDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentBehaviorNoteDetailQuery, StudentBehaviorNoteDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentBehaviorNoteDetailQuery, StudentBehaviorNoteDetailQueryVariables>(
		StudentBehaviorNoteDetailDocument,
		options,
	);
}
export function useStudentBehaviorNoteDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentBehaviorNoteDetailQuery,
		StudentBehaviorNoteDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentBehaviorNoteDetailQuery, StudentBehaviorNoteDetailQueryVariables>(
		StudentBehaviorNoteDetailDocument,
		options,
	);
}
export type StudentBehaviorNoteDetailQueryHookResult = ReturnType<typeof useStudentBehaviorNoteDetailQuery>;
export type StudentBehaviorNoteDetailLazyQueryHookResult = ReturnType<typeof useStudentBehaviorNoteDetailLazyQuery>;
export type StudentBehaviorNoteDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentBehaviorNoteDetailSuspenseQuery
>;
export type StudentBehaviorNoteDetailQueryResult = Apollo.QueryResult<
	StudentBehaviorNoteDetailQuery,
	StudentBehaviorNoteDetailQueryVariables
>;
export const StudentBehaviorNoteIndexDocument = gql`
	query studentBehaviorNoteIndex(
		$filters: [StudentBehaviorNoteFilterInput!]
		$pagination: Pagination
		$order: StudentBehaviorNoteOrder
	) {
		studentBehaviorNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					incidentTime
					incidentLocation
					isIncidentPhysicalContactAggression
					isIncidentFightingPhysicalAggression
					isIncidentVerbalAbuseDisrespectingStudent
					isIncidentDisrepectingTeacher
					isIncidentDisruption
					isIncidentDefianceOrNonCompliance
					isIncidentOther
					incidentOther
					isMotivationAttentionSeeking
					isMotivationReaction
					isMotivationAnger
					isMotivationFrustration
					isMotivationHabit
					isMotivationLackOfSelfContol
					isMotivationOther
					motivationOther
					isConsequenceRecDirectorIntervention
					isConsequenceRecSenOrSelIntervention
					isConsequenceRecStudentServiceTeamIntervention
					isConsequenceRecParentContactFromReporter
					isConsequenceRecParentContactFromSchoolDirector
					isConsequenceRecOther
					consequenceRecOther
					additionalComments
				}
			}
		}
	}
`;

/**
 * __useStudentBehaviorNoteIndexQuery__
 *
 * To run a query within a React component, call `useStudentBehaviorNoteIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentBehaviorNoteIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentBehaviorNoteIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentBehaviorNoteIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentBehaviorNoteIndexQuery, StudentBehaviorNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentBehaviorNoteIndexQuery, StudentBehaviorNoteIndexQueryVariables>(
		StudentBehaviorNoteIndexDocument,
		options,
	);
}
export function useStudentBehaviorNoteIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentBehaviorNoteIndexQuery, StudentBehaviorNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentBehaviorNoteIndexQuery, StudentBehaviorNoteIndexQueryVariables>(
		StudentBehaviorNoteIndexDocument,
		options,
	);
}
export function useStudentBehaviorNoteIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentBehaviorNoteIndexQuery, StudentBehaviorNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentBehaviorNoteIndexQuery, StudentBehaviorNoteIndexQueryVariables>(
		StudentBehaviorNoteIndexDocument,
		options,
	);
}
export type StudentBehaviorNoteIndexQueryHookResult = ReturnType<typeof useStudentBehaviorNoteIndexQuery>;
export type StudentBehaviorNoteIndexLazyQueryHookResult = ReturnType<typeof useStudentBehaviorNoteIndexLazyQuery>;
export type StudentBehaviorNoteIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentBehaviorNoteIndexSuspenseQuery
>;
export type StudentBehaviorNoteIndexQueryResult = Apollo.QueryResult<
	StudentBehaviorNoteIndexQuery,
	StudentBehaviorNoteIndexQueryVariables
>;
export const StudentBehaviorNoteNameDocument = gql`
	query studentBehaviorNoteName($id: ID!) {
		studentBehaviorNote(id: $id) {
			id
			...StudentBehaviorNoteName
		}
	}
	${StudentBehaviorNoteNameFragmentDoc}
`;

/**
 * __useStudentBehaviorNoteNameQuery__
 *
 * To run a query within a React component, call `useStudentBehaviorNoteNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentBehaviorNoteNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentBehaviorNoteNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentBehaviorNoteNameQuery(
	baseOptions: Apollo.QueryHookOptions<StudentBehaviorNoteNameQuery, StudentBehaviorNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentBehaviorNoteNameQuery, StudentBehaviorNoteNameQueryVariables>(
		StudentBehaviorNoteNameDocument,
		options,
	);
}
export function useStudentBehaviorNoteNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentBehaviorNoteNameQuery, StudentBehaviorNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentBehaviorNoteNameQuery, StudentBehaviorNoteNameQueryVariables>(
		StudentBehaviorNoteNameDocument,
		options,
	);
}
export function useStudentBehaviorNoteNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentBehaviorNoteNameQuery, StudentBehaviorNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentBehaviorNoteNameQuery, StudentBehaviorNoteNameQueryVariables>(
		StudentBehaviorNoteNameDocument,
		options,
	);
}
export type StudentBehaviorNoteNameQueryHookResult = ReturnType<typeof useStudentBehaviorNoteNameQuery>;
export type StudentBehaviorNoteNameLazyQueryHookResult = ReturnType<typeof useStudentBehaviorNoteNameLazyQuery>;
export type StudentBehaviorNoteNameSuspenseQueryHookResult = ReturnType<typeof useStudentBehaviorNoteNameSuspenseQuery>;
export type StudentBehaviorNoteNameQueryResult = Apollo.QueryResult<
	StudentBehaviorNoteNameQuery,
	StudentBehaviorNoteNameQueryVariables
>;
export const StudentBehaviorNoteNamesDocument = gql`
	query studentBehaviorNoteNames(
		$filters: [StudentBehaviorNoteFilterInput!]
		$pagination: Pagination
		$order: StudentBehaviorNoteOrder
	) {
		studentBehaviorNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentBehaviorNoteName
				}
			}
		}
	}
	${StudentBehaviorNoteNameFragmentDoc}
`;

/**
 * __useStudentBehaviorNoteNamesQuery__
 *
 * To run a query within a React component, call `useStudentBehaviorNoteNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentBehaviorNoteNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentBehaviorNoteNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentBehaviorNoteNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentBehaviorNoteNamesQuery, StudentBehaviorNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentBehaviorNoteNamesQuery, StudentBehaviorNoteNamesQueryVariables>(
		StudentBehaviorNoteNamesDocument,
		options,
	);
}
export function useStudentBehaviorNoteNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentBehaviorNoteNamesQuery, StudentBehaviorNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentBehaviorNoteNamesQuery, StudentBehaviorNoteNamesQueryVariables>(
		StudentBehaviorNoteNamesDocument,
		options,
	);
}
export function useStudentBehaviorNoteNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentBehaviorNoteNamesQuery, StudentBehaviorNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentBehaviorNoteNamesQuery, StudentBehaviorNoteNamesQueryVariables>(
		StudentBehaviorNoteNamesDocument,
		options,
	);
}
export type StudentBehaviorNoteNamesQueryHookResult = ReturnType<typeof useStudentBehaviorNoteNamesQuery>;
export type StudentBehaviorNoteNamesLazyQueryHookResult = ReturnType<typeof useStudentBehaviorNoteNamesLazyQuery>;
export type StudentBehaviorNoteNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentBehaviorNoteNamesSuspenseQuery
>;
export type StudentBehaviorNoteNamesQueryResult = Apollo.QueryResult<
	StudentBehaviorNoteNamesQuery,
	StudentBehaviorNoteNamesQueryVariables
>;
export const StudentBehaviorNotePaginationDocument = gql`
	query studentBehaviorNotePagination($filters: [StudentBehaviorNoteFilterInput!], $order: StudentBehaviorNoteOrder) {
		studentBehaviorNoteConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentBehaviorNotePaginationQuery__
 *
 * To run a query within a React component, call `useStudentBehaviorNotePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentBehaviorNotePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentBehaviorNotePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentBehaviorNotePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentBehaviorNotePaginationQuery,
		StudentBehaviorNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentBehaviorNotePaginationQuery, StudentBehaviorNotePaginationQueryVariables>(
		StudentBehaviorNotePaginationDocument,
		options,
	);
}
export function useStudentBehaviorNotePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentBehaviorNotePaginationQuery,
		StudentBehaviorNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentBehaviorNotePaginationQuery, StudentBehaviorNotePaginationQueryVariables>(
		StudentBehaviorNotePaginationDocument,
		options,
	);
}
export function useStudentBehaviorNotePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentBehaviorNotePaginationQuery,
		StudentBehaviorNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentBehaviorNotePaginationQuery, StudentBehaviorNotePaginationQueryVariables>(
		StudentBehaviorNotePaginationDocument,
		options,
	);
}
export type StudentBehaviorNotePaginationQueryHookResult = ReturnType<typeof useStudentBehaviorNotePaginationQuery>;
export type StudentBehaviorNotePaginationLazyQueryHookResult = ReturnType<
	typeof useStudentBehaviorNotePaginationLazyQuery
>;
export type StudentBehaviorNotePaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentBehaviorNotePaginationSuspenseQuery
>;
export type StudentBehaviorNotePaginationQueryResult = Apollo.QueryResult<
	StudentBehaviorNotePaginationQuery,
	StudentBehaviorNotePaginationQueryVariables
>;
export const StudentBehaviorNoteSelectDocument = gql`
	query studentBehaviorNoteSelect($filters: [StudentBehaviorNoteFilterInput!], $order: StudentBehaviorNoteOrder) {
		studentBehaviorNoteConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentBehaviorNoteName
				}
			}
		}
	}
	${StudentBehaviorNoteNameFragmentDoc}
`;

/**
 * __useStudentBehaviorNoteSelectQuery__
 *
 * To run a query within a React component, call `useStudentBehaviorNoteSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentBehaviorNoteSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentBehaviorNoteSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentBehaviorNoteSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentBehaviorNoteSelectQuery, StudentBehaviorNoteSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentBehaviorNoteSelectQuery, StudentBehaviorNoteSelectQueryVariables>(
		StudentBehaviorNoteSelectDocument,
		options,
	);
}
export function useStudentBehaviorNoteSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentBehaviorNoteSelectQuery, StudentBehaviorNoteSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentBehaviorNoteSelectQuery, StudentBehaviorNoteSelectQueryVariables>(
		StudentBehaviorNoteSelectDocument,
		options,
	);
}
export function useStudentBehaviorNoteSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentBehaviorNoteSelectQuery,
		StudentBehaviorNoteSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentBehaviorNoteSelectQuery, StudentBehaviorNoteSelectQueryVariables>(
		StudentBehaviorNoteSelectDocument,
		options,
	);
}
export type StudentBehaviorNoteSelectQueryHookResult = ReturnType<typeof useStudentBehaviorNoteSelectQuery>;
export type StudentBehaviorNoteSelectLazyQueryHookResult = ReturnType<typeof useStudentBehaviorNoteSelectLazyQuery>;
export type StudentBehaviorNoteSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentBehaviorNoteSelectSuspenseQuery
>;
export type StudentBehaviorNoteSelectQueryResult = Apollo.QueryResult<
	StudentBehaviorNoteSelectQuery,
	StudentBehaviorNoteSelectQueryVariables
>;
export const StudentBehaviorNoteUpdateDocument = gql`
	mutation studentBehaviorNoteUpdate($id: ID!, $input: StudentBehaviorNoteUpdateInput!) {
		updateStudentBehaviorNote(id: $id, input: $input) {
			...StudentBehaviorNoteDetail
		}
	}
	${StudentBehaviorNoteDetailFragmentDoc}
`;
export type StudentBehaviorNoteUpdateMutationFn = Apollo.MutationFunction<
	StudentBehaviorNoteUpdateMutation,
	StudentBehaviorNoteUpdateMutationVariables
>;

/**
 * __useStudentBehaviorNoteUpdateMutation__
 *
 * To run a mutation, you first call `useStudentBehaviorNoteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentBehaviorNoteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentBehaviorNoteUpdateMutation, { data, loading, error }] = useStudentBehaviorNoteUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentBehaviorNoteUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentBehaviorNoteUpdateMutation,
		StudentBehaviorNoteUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentBehaviorNoteUpdateMutation, StudentBehaviorNoteUpdateMutationVariables>(
		StudentBehaviorNoteUpdateDocument,
		options,
	);
}
export type StudentBehaviorNoteUpdateMutationHookResult = ReturnType<typeof useStudentBehaviorNoteUpdateMutation>;
export type StudentBehaviorNoteUpdateMutationResult = Apollo.MutationResult<StudentBehaviorNoteUpdateMutation>;
export type StudentBehaviorNoteUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentBehaviorNoteUpdateMutation,
	StudentBehaviorNoteUpdateMutationVariables
>;
export const StudentCourseSectionEnrollmentCountDocument = gql`
	query studentCourseSectionEnrollmentCount(
		$filters: [StudentCourseSectionEnrollmentFilterInput!]
		$pagination: Pagination
		$order: StudentCourseSectionEnrollmentOrder
	) {
		studentCourseSectionEnrollmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentCourseSectionEnrollmentCountQuery__
 *
 * To run a query within a React component, call `useStudentCourseSectionEnrollmentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentCourseSectionEnrollmentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentCourseSectionEnrollmentCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentCourseSectionEnrollmentCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentCourseSectionEnrollmentCountQuery,
		StudentCourseSectionEnrollmentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentCourseSectionEnrollmentCountQuery, StudentCourseSectionEnrollmentCountQueryVariables>(
		StudentCourseSectionEnrollmentCountDocument,
		options,
	);
}
export function useStudentCourseSectionEnrollmentCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentCourseSectionEnrollmentCountQuery,
		StudentCourseSectionEnrollmentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentCourseSectionEnrollmentCountQuery,
		StudentCourseSectionEnrollmentCountQueryVariables
	>(StudentCourseSectionEnrollmentCountDocument, options);
}
export function useStudentCourseSectionEnrollmentCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentCourseSectionEnrollmentCountQuery,
		StudentCourseSectionEnrollmentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentCourseSectionEnrollmentCountQuery,
		StudentCourseSectionEnrollmentCountQueryVariables
	>(StudentCourseSectionEnrollmentCountDocument, options);
}
export type StudentCourseSectionEnrollmentCountQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentCountQuery
>;
export type StudentCourseSectionEnrollmentCountLazyQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentCountLazyQuery
>;
export type StudentCourseSectionEnrollmentCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentCountSuspenseQuery
>;
export type StudentCourseSectionEnrollmentCountQueryResult = Apollo.QueryResult<
	StudentCourseSectionEnrollmentCountQuery,
	StudentCourseSectionEnrollmentCountQueryVariables
>;
export const StudentCourseSectionEnrollmentCreateDocument = gql`
	mutation studentCourseSectionEnrollmentCreate($input: StudentCourseSectionEnrollmentCreateInput!) {
		createStudentCourseSectionEnrollment(input: $input) {
			...StudentCourseSectionEnrollmentDetail
		}
	}
	${StudentCourseSectionEnrollmentDetailFragmentDoc}
`;
export type StudentCourseSectionEnrollmentCreateMutationFn = Apollo.MutationFunction<
	StudentCourseSectionEnrollmentCreateMutation,
	StudentCourseSectionEnrollmentCreateMutationVariables
>;

/**
 * __useStudentCourseSectionEnrollmentCreateMutation__
 *
 * To run a mutation, you first call `useStudentCourseSectionEnrollmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentCourseSectionEnrollmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentCourseSectionEnrollmentCreateMutation, { data, loading, error }] = useStudentCourseSectionEnrollmentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentCourseSectionEnrollmentCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentCourseSectionEnrollmentCreateMutation,
		StudentCourseSectionEnrollmentCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentCourseSectionEnrollmentCreateMutation,
		StudentCourseSectionEnrollmentCreateMutationVariables
	>(StudentCourseSectionEnrollmentCreateDocument, options);
}
export type StudentCourseSectionEnrollmentCreateMutationHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentCreateMutation
>;
export type StudentCourseSectionEnrollmentCreateMutationResult =
	Apollo.MutationResult<StudentCourseSectionEnrollmentCreateMutation>;
export type StudentCourseSectionEnrollmentCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentCourseSectionEnrollmentCreateMutation,
	StudentCourseSectionEnrollmentCreateMutationVariables
>;
export const StudentCourseSectionEnrollmentDeleteDocument = gql`
	mutation studentCourseSectionEnrollmentDelete($id: ID!) {
		deleteStudentCourseSectionEnrollment(id: $id)
	}
`;
export type StudentCourseSectionEnrollmentDeleteMutationFn = Apollo.MutationFunction<
	StudentCourseSectionEnrollmentDeleteMutation,
	StudentCourseSectionEnrollmentDeleteMutationVariables
>;

/**
 * __useStudentCourseSectionEnrollmentDeleteMutation__
 *
 * To run a mutation, you first call `useStudentCourseSectionEnrollmentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentCourseSectionEnrollmentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentCourseSectionEnrollmentDeleteMutation, { data, loading, error }] = useStudentCourseSectionEnrollmentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentCourseSectionEnrollmentDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentCourseSectionEnrollmentDeleteMutation,
		StudentCourseSectionEnrollmentDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentCourseSectionEnrollmentDeleteMutation,
		StudentCourseSectionEnrollmentDeleteMutationVariables
	>(StudentCourseSectionEnrollmentDeleteDocument, options);
}
export type StudentCourseSectionEnrollmentDeleteMutationHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentDeleteMutation
>;
export type StudentCourseSectionEnrollmentDeleteMutationResult =
	Apollo.MutationResult<StudentCourseSectionEnrollmentDeleteMutation>;
export type StudentCourseSectionEnrollmentDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentCourseSectionEnrollmentDeleteMutation,
	StudentCourseSectionEnrollmentDeleteMutationVariables
>;
export const StudentCourseSectionEnrollmentDetailDocument = gql`
	query studentCourseSectionEnrollmentDetail($id: ID!) {
		studentCourseSectionEnrollment(id: $id) {
			...StudentCourseSectionEnrollmentDetail
		}
	}
	${StudentCourseSectionEnrollmentDetailFragmentDoc}
`;

/**
 * __useStudentCourseSectionEnrollmentDetailQuery__
 *
 * To run a query within a React component, call `useStudentCourseSectionEnrollmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentCourseSectionEnrollmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentCourseSectionEnrollmentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentCourseSectionEnrollmentDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentCourseSectionEnrollmentDetailQuery,
		StudentCourseSectionEnrollmentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentCourseSectionEnrollmentDetailQuery, StudentCourseSectionEnrollmentDetailQueryVariables>(
		StudentCourseSectionEnrollmentDetailDocument,
		options,
	);
}
export function useStudentCourseSectionEnrollmentDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentCourseSectionEnrollmentDetailQuery,
		StudentCourseSectionEnrollmentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentCourseSectionEnrollmentDetailQuery,
		StudentCourseSectionEnrollmentDetailQueryVariables
	>(StudentCourseSectionEnrollmentDetailDocument, options);
}
export function useStudentCourseSectionEnrollmentDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentCourseSectionEnrollmentDetailQuery,
		StudentCourseSectionEnrollmentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentCourseSectionEnrollmentDetailQuery,
		StudentCourseSectionEnrollmentDetailQueryVariables
	>(StudentCourseSectionEnrollmentDetailDocument, options);
}
export type StudentCourseSectionEnrollmentDetailQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentDetailQuery
>;
export type StudentCourseSectionEnrollmentDetailLazyQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentDetailLazyQuery
>;
export type StudentCourseSectionEnrollmentDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentDetailSuspenseQuery
>;
export type StudentCourseSectionEnrollmentDetailQueryResult = Apollo.QueryResult<
	StudentCourseSectionEnrollmentDetailQuery,
	StudentCourseSectionEnrollmentDetailQueryVariables
>;
export const StudentCourseSectionEnrollmentIndexDocument = gql`
	query studentCourseSectionEnrollmentIndex(
		$filters: [StudentCourseSectionEnrollmentFilterInput!]
		$pagination: Pagination
		$order: StudentCourseSectionEnrollmentOrder
	) {
		studentCourseSectionEnrollmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					lateStartDate
					earlyEndDate
				}
			}
		}
	}
`;

/**
 * __useStudentCourseSectionEnrollmentIndexQuery__
 *
 * To run a query within a React component, call `useStudentCourseSectionEnrollmentIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentCourseSectionEnrollmentIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentCourseSectionEnrollmentIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentCourseSectionEnrollmentIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentCourseSectionEnrollmentIndexQuery,
		StudentCourseSectionEnrollmentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentCourseSectionEnrollmentIndexQuery, StudentCourseSectionEnrollmentIndexQueryVariables>(
		StudentCourseSectionEnrollmentIndexDocument,
		options,
	);
}
export function useStudentCourseSectionEnrollmentIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentCourseSectionEnrollmentIndexQuery,
		StudentCourseSectionEnrollmentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentCourseSectionEnrollmentIndexQuery,
		StudentCourseSectionEnrollmentIndexQueryVariables
	>(StudentCourseSectionEnrollmentIndexDocument, options);
}
export function useStudentCourseSectionEnrollmentIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentCourseSectionEnrollmentIndexQuery,
		StudentCourseSectionEnrollmentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentCourseSectionEnrollmentIndexQuery,
		StudentCourseSectionEnrollmentIndexQueryVariables
	>(StudentCourseSectionEnrollmentIndexDocument, options);
}
export type StudentCourseSectionEnrollmentIndexQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentIndexQuery
>;
export type StudentCourseSectionEnrollmentIndexLazyQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentIndexLazyQuery
>;
export type StudentCourseSectionEnrollmentIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentIndexSuspenseQuery
>;
export type StudentCourseSectionEnrollmentIndexQueryResult = Apollo.QueryResult<
	StudentCourseSectionEnrollmentIndexQuery,
	StudentCourseSectionEnrollmentIndexQueryVariables
>;
export const StudentCourseSectionEnrollmentNameDocument = gql`
	query studentCourseSectionEnrollmentName($id: ID!) {
		studentCourseSectionEnrollment(id: $id) {
			id
			...StudentCourseSectionEnrollmentName
		}
	}
	${StudentCourseSectionEnrollmentNameFragmentDoc}
`;

/**
 * __useStudentCourseSectionEnrollmentNameQuery__
 *
 * To run a query within a React component, call `useStudentCourseSectionEnrollmentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentCourseSectionEnrollmentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentCourseSectionEnrollmentNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentCourseSectionEnrollmentNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentCourseSectionEnrollmentNameQuery,
		StudentCourseSectionEnrollmentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentCourseSectionEnrollmentNameQuery, StudentCourseSectionEnrollmentNameQueryVariables>(
		StudentCourseSectionEnrollmentNameDocument,
		options,
	);
}
export function useStudentCourseSectionEnrollmentNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentCourseSectionEnrollmentNameQuery,
		StudentCourseSectionEnrollmentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentCourseSectionEnrollmentNameQuery, StudentCourseSectionEnrollmentNameQueryVariables>(
		StudentCourseSectionEnrollmentNameDocument,
		options,
	);
}
export function useStudentCourseSectionEnrollmentNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentCourseSectionEnrollmentNameQuery,
		StudentCourseSectionEnrollmentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentCourseSectionEnrollmentNameQuery,
		StudentCourseSectionEnrollmentNameQueryVariables
	>(StudentCourseSectionEnrollmentNameDocument, options);
}
export type StudentCourseSectionEnrollmentNameQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentNameQuery
>;
export type StudentCourseSectionEnrollmentNameLazyQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentNameLazyQuery
>;
export type StudentCourseSectionEnrollmentNameSuspenseQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentNameSuspenseQuery
>;
export type StudentCourseSectionEnrollmentNameQueryResult = Apollo.QueryResult<
	StudentCourseSectionEnrollmentNameQuery,
	StudentCourseSectionEnrollmentNameQueryVariables
>;
export const StudentCourseSectionEnrollmentNamesDocument = gql`
	query studentCourseSectionEnrollmentNames(
		$filters: [StudentCourseSectionEnrollmentFilterInput!]
		$pagination: Pagination
		$order: StudentCourseSectionEnrollmentOrder
	) {
		studentCourseSectionEnrollmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentCourseSectionEnrollmentName
				}
			}
		}
	}
	${StudentCourseSectionEnrollmentNameFragmentDoc}
`;

/**
 * __useStudentCourseSectionEnrollmentNamesQuery__
 *
 * To run a query within a React component, call `useStudentCourseSectionEnrollmentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentCourseSectionEnrollmentNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentCourseSectionEnrollmentNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentCourseSectionEnrollmentNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentCourseSectionEnrollmentNamesQuery,
		StudentCourseSectionEnrollmentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentCourseSectionEnrollmentNamesQuery, StudentCourseSectionEnrollmentNamesQueryVariables>(
		StudentCourseSectionEnrollmentNamesDocument,
		options,
	);
}
export function useStudentCourseSectionEnrollmentNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentCourseSectionEnrollmentNamesQuery,
		StudentCourseSectionEnrollmentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentCourseSectionEnrollmentNamesQuery,
		StudentCourseSectionEnrollmentNamesQueryVariables
	>(StudentCourseSectionEnrollmentNamesDocument, options);
}
export function useStudentCourseSectionEnrollmentNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentCourseSectionEnrollmentNamesQuery,
		StudentCourseSectionEnrollmentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentCourseSectionEnrollmentNamesQuery,
		StudentCourseSectionEnrollmentNamesQueryVariables
	>(StudentCourseSectionEnrollmentNamesDocument, options);
}
export type StudentCourseSectionEnrollmentNamesQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentNamesQuery
>;
export type StudentCourseSectionEnrollmentNamesLazyQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentNamesLazyQuery
>;
export type StudentCourseSectionEnrollmentNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentNamesSuspenseQuery
>;
export type StudentCourseSectionEnrollmentNamesQueryResult = Apollo.QueryResult<
	StudentCourseSectionEnrollmentNamesQuery,
	StudentCourseSectionEnrollmentNamesQueryVariables
>;
export const StudentCourseSectionEnrollmentPaginationDocument = gql`
	query studentCourseSectionEnrollmentPagination(
		$filters: [StudentCourseSectionEnrollmentFilterInput!]
		$order: StudentCourseSectionEnrollmentOrder
	) {
		studentCourseSectionEnrollmentConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentCourseSectionEnrollmentPaginationQuery__
 *
 * To run a query within a React component, call `useStudentCourseSectionEnrollmentPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentCourseSectionEnrollmentPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentCourseSectionEnrollmentPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentCourseSectionEnrollmentPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentCourseSectionEnrollmentPaginationQuery,
		StudentCourseSectionEnrollmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentCourseSectionEnrollmentPaginationQuery,
		StudentCourseSectionEnrollmentPaginationQueryVariables
	>(StudentCourseSectionEnrollmentPaginationDocument, options);
}
export function useStudentCourseSectionEnrollmentPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentCourseSectionEnrollmentPaginationQuery,
		StudentCourseSectionEnrollmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentCourseSectionEnrollmentPaginationQuery,
		StudentCourseSectionEnrollmentPaginationQueryVariables
	>(StudentCourseSectionEnrollmentPaginationDocument, options);
}
export function useStudentCourseSectionEnrollmentPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentCourseSectionEnrollmentPaginationQuery,
		StudentCourseSectionEnrollmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentCourseSectionEnrollmentPaginationQuery,
		StudentCourseSectionEnrollmentPaginationQueryVariables
	>(StudentCourseSectionEnrollmentPaginationDocument, options);
}
export type StudentCourseSectionEnrollmentPaginationQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentPaginationQuery
>;
export type StudentCourseSectionEnrollmentPaginationLazyQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentPaginationLazyQuery
>;
export type StudentCourseSectionEnrollmentPaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentPaginationSuspenseQuery
>;
export type StudentCourseSectionEnrollmentPaginationQueryResult = Apollo.QueryResult<
	StudentCourseSectionEnrollmentPaginationQuery,
	StudentCourseSectionEnrollmentPaginationQueryVariables
>;
export const StudentCourseSectionEnrollmentSelectDocument = gql`
	query studentCourseSectionEnrollmentSelect(
		$filters: [StudentCourseSectionEnrollmentFilterInput!]
		$order: StudentCourseSectionEnrollmentOrder
	) {
		studentCourseSectionEnrollmentConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentCourseSectionEnrollmentName
				}
			}
		}
	}
	${StudentCourseSectionEnrollmentNameFragmentDoc}
`;

/**
 * __useStudentCourseSectionEnrollmentSelectQuery__
 *
 * To run a query within a React component, call `useStudentCourseSectionEnrollmentSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentCourseSectionEnrollmentSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentCourseSectionEnrollmentSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentCourseSectionEnrollmentSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentCourseSectionEnrollmentSelectQuery,
		StudentCourseSectionEnrollmentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentCourseSectionEnrollmentSelectQuery, StudentCourseSectionEnrollmentSelectQueryVariables>(
		StudentCourseSectionEnrollmentSelectDocument,
		options,
	);
}
export function useStudentCourseSectionEnrollmentSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentCourseSectionEnrollmentSelectQuery,
		StudentCourseSectionEnrollmentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentCourseSectionEnrollmentSelectQuery,
		StudentCourseSectionEnrollmentSelectQueryVariables
	>(StudentCourseSectionEnrollmentSelectDocument, options);
}
export function useStudentCourseSectionEnrollmentSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentCourseSectionEnrollmentSelectQuery,
		StudentCourseSectionEnrollmentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentCourseSectionEnrollmentSelectQuery,
		StudentCourseSectionEnrollmentSelectQueryVariables
	>(StudentCourseSectionEnrollmentSelectDocument, options);
}
export type StudentCourseSectionEnrollmentSelectQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentSelectQuery
>;
export type StudentCourseSectionEnrollmentSelectLazyQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentSelectLazyQuery
>;
export type StudentCourseSectionEnrollmentSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentSelectSuspenseQuery
>;
export type StudentCourseSectionEnrollmentSelectQueryResult = Apollo.QueryResult<
	StudentCourseSectionEnrollmentSelectQuery,
	StudentCourseSectionEnrollmentSelectQueryVariables
>;
export const StudentCourseSectionEnrollmentUpdateDocument = gql`
	mutation studentCourseSectionEnrollmentUpdate($id: ID!, $input: StudentCourseSectionEnrollmentUpdateInput!) {
		updateStudentCourseSectionEnrollment(id: $id, input: $input) {
			...StudentCourseSectionEnrollmentDetail
		}
	}
	${StudentCourseSectionEnrollmentDetailFragmentDoc}
`;
export type StudentCourseSectionEnrollmentUpdateMutationFn = Apollo.MutationFunction<
	StudentCourseSectionEnrollmentUpdateMutation,
	StudentCourseSectionEnrollmentUpdateMutationVariables
>;

/**
 * __useStudentCourseSectionEnrollmentUpdateMutation__
 *
 * To run a mutation, you first call `useStudentCourseSectionEnrollmentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentCourseSectionEnrollmentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentCourseSectionEnrollmentUpdateMutation, { data, loading, error }] = useStudentCourseSectionEnrollmentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentCourseSectionEnrollmentUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentCourseSectionEnrollmentUpdateMutation,
		StudentCourseSectionEnrollmentUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentCourseSectionEnrollmentUpdateMutation,
		StudentCourseSectionEnrollmentUpdateMutationVariables
	>(StudentCourseSectionEnrollmentUpdateDocument, options);
}
export type StudentCourseSectionEnrollmentUpdateMutationHookResult = ReturnType<
	typeof useStudentCourseSectionEnrollmentUpdateMutation
>;
export type StudentCourseSectionEnrollmentUpdateMutationResult =
	Apollo.MutationResult<StudentCourseSectionEnrollmentUpdateMutation>;
export type StudentCourseSectionEnrollmentUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentCourseSectionEnrollmentUpdateMutation,
	StudentCourseSectionEnrollmentUpdateMutationVariables
>;
export const StudentDataConsentCountDocument = gql`
	query studentDataConsentCount(
		$filters: [StudentDataConsentFilterInput!]
		$pagination: Pagination
		$order: StudentDataConsentOrder
	) {
		studentDataConsentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentDataConsentCountQuery__
 *
 * To run a query within a React component, call `useStudentDataConsentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDataConsentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentDataConsentCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentDataConsentCountQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentDataConsentCountQuery, StudentDataConsentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentDataConsentCountQuery, StudentDataConsentCountQueryVariables>(
		StudentDataConsentCountDocument,
		options,
	);
}
export function useStudentDataConsentCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentDataConsentCountQuery, StudentDataConsentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentDataConsentCountQuery, StudentDataConsentCountQueryVariables>(
		StudentDataConsentCountDocument,
		options,
	);
}
export function useStudentDataConsentCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentDataConsentCountQuery, StudentDataConsentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentDataConsentCountQuery, StudentDataConsentCountQueryVariables>(
		StudentDataConsentCountDocument,
		options,
	);
}
export type StudentDataConsentCountQueryHookResult = ReturnType<typeof useStudentDataConsentCountQuery>;
export type StudentDataConsentCountLazyQueryHookResult = ReturnType<typeof useStudentDataConsentCountLazyQuery>;
export type StudentDataConsentCountSuspenseQueryHookResult = ReturnType<typeof useStudentDataConsentCountSuspenseQuery>;
export type StudentDataConsentCountQueryResult = Apollo.QueryResult<
	StudentDataConsentCountQuery,
	StudentDataConsentCountQueryVariables
>;
export const StudentDataConsentCreateDocument = gql`
	mutation studentDataConsentCreate($input: StudentDataConsentCreateInput!) {
		createStudentDataConsent(input: $input) {
			...StudentDataConsentDetail
		}
	}
	${StudentDataConsentDetailFragmentDoc}
`;
export type StudentDataConsentCreateMutationFn = Apollo.MutationFunction<
	StudentDataConsentCreateMutation,
	StudentDataConsentCreateMutationVariables
>;

/**
 * __useStudentDataConsentCreateMutation__
 *
 * To run a mutation, you first call `useStudentDataConsentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentDataConsentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentDataConsentCreateMutation, { data, loading, error }] = useStudentDataConsentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentDataConsentCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<StudentDataConsentCreateMutation, StudentDataConsentCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentDataConsentCreateMutation, StudentDataConsentCreateMutationVariables>(
		StudentDataConsentCreateDocument,
		options,
	);
}
export type StudentDataConsentCreateMutationHookResult = ReturnType<typeof useStudentDataConsentCreateMutation>;
export type StudentDataConsentCreateMutationResult = Apollo.MutationResult<StudentDataConsentCreateMutation>;
export type StudentDataConsentCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentDataConsentCreateMutation,
	StudentDataConsentCreateMutationVariables
>;
export const StudentDataConsentDeleteDocument = gql`
	mutation studentDataConsentDelete($id: ID!) {
		deleteStudentDataConsent(id: $id)
	}
`;
export type StudentDataConsentDeleteMutationFn = Apollo.MutationFunction<
	StudentDataConsentDeleteMutation,
	StudentDataConsentDeleteMutationVariables
>;

/**
 * __useStudentDataConsentDeleteMutation__
 *
 * To run a mutation, you first call `useStudentDataConsentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentDataConsentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentDataConsentDeleteMutation, { data, loading, error }] = useStudentDataConsentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentDataConsentDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<StudentDataConsentDeleteMutation, StudentDataConsentDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentDataConsentDeleteMutation, StudentDataConsentDeleteMutationVariables>(
		StudentDataConsentDeleteDocument,
		options,
	);
}
export type StudentDataConsentDeleteMutationHookResult = ReturnType<typeof useStudentDataConsentDeleteMutation>;
export type StudentDataConsentDeleteMutationResult = Apollo.MutationResult<StudentDataConsentDeleteMutation>;
export type StudentDataConsentDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentDataConsentDeleteMutation,
	StudentDataConsentDeleteMutationVariables
>;
export const StudentDataConsentDetailDocument = gql`
	query studentDataConsentDetail($id: ID!) {
		studentDataConsent(id: $id) {
			...StudentDataConsentDetail
		}
	}
	${StudentDataConsentDetailFragmentDoc}
`;

/**
 * __useStudentDataConsentDetailQuery__
 *
 * To run a query within a React component, call `useStudentDataConsentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDataConsentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentDataConsentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentDataConsentDetailQuery(
	baseOptions: Apollo.QueryHookOptions<StudentDataConsentDetailQuery, StudentDataConsentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentDataConsentDetailQuery, StudentDataConsentDetailQueryVariables>(
		StudentDataConsentDetailDocument,
		options,
	);
}
export function useStudentDataConsentDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentDataConsentDetailQuery, StudentDataConsentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentDataConsentDetailQuery, StudentDataConsentDetailQueryVariables>(
		StudentDataConsentDetailDocument,
		options,
	);
}
export function useStudentDataConsentDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentDataConsentDetailQuery, StudentDataConsentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentDataConsentDetailQuery, StudentDataConsentDetailQueryVariables>(
		StudentDataConsentDetailDocument,
		options,
	);
}
export type StudentDataConsentDetailQueryHookResult = ReturnType<typeof useStudentDataConsentDetailQuery>;
export type StudentDataConsentDetailLazyQueryHookResult = ReturnType<typeof useStudentDataConsentDetailLazyQuery>;
export type StudentDataConsentDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentDataConsentDetailSuspenseQuery
>;
export type StudentDataConsentDetailQueryResult = Apollo.QueryResult<
	StudentDataConsentDetailQuery,
	StudentDataConsentDetailQueryVariables
>;
export const StudentDataConsentIndexDocument = gql`
	query studentDataConsentIndex(
		$filters: [StudentDataConsentFilterInput!]
		$pagination: Pagination
		$order: StudentDataConsentOrder
	) {
		studentDataConsentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					updatedAt
					allowPublishVisualMediaOfStudentGeneral
					allowPublishVisualMediaOfStudentForPromotion
					allowPublishVisualMediaOfGuardianForPromotion
					allowPublishStudentWorkGeneral
					allowShareInformationWithPearsonEdexcel
					allowShareInformationWithIbOrganization
					allowShareInformationWithOnlinePlatforms
					allowBirthdayInCalendar
					allowSendNewsletters
					allowSendCalendarEvents
					student {
						id
						...StudentName
					}
				}
			}
		}
	}
	${StudentNameFragmentDoc}
`;

/**
 * __useStudentDataConsentIndexQuery__
 *
 * To run a query within a React component, call `useStudentDataConsentIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDataConsentIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentDataConsentIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentDataConsentIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentDataConsentIndexQuery, StudentDataConsentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentDataConsentIndexQuery, StudentDataConsentIndexQueryVariables>(
		StudentDataConsentIndexDocument,
		options,
	);
}
export function useStudentDataConsentIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentDataConsentIndexQuery, StudentDataConsentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentDataConsentIndexQuery, StudentDataConsentIndexQueryVariables>(
		StudentDataConsentIndexDocument,
		options,
	);
}
export function useStudentDataConsentIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentDataConsentIndexQuery, StudentDataConsentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentDataConsentIndexQuery, StudentDataConsentIndexQueryVariables>(
		StudentDataConsentIndexDocument,
		options,
	);
}
export type StudentDataConsentIndexQueryHookResult = ReturnType<typeof useStudentDataConsentIndexQuery>;
export type StudentDataConsentIndexLazyQueryHookResult = ReturnType<typeof useStudentDataConsentIndexLazyQuery>;
export type StudentDataConsentIndexSuspenseQueryHookResult = ReturnType<typeof useStudentDataConsentIndexSuspenseQuery>;
export type StudentDataConsentIndexQueryResult = Apollo.QueryResult<
	StudentDataConsentIndexQuery,
	StudentDataConsentIndexQueryVariables
>;
export const StudentDataConsentListDocument = gql`
	query studentDataConsentList(
		$filters: [StudentDataConsentFilterInput!]
		$pagination: Pagination
		$order: StudentDataConsentOrder
	) {
		studentDataConsentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					allowPublishVisualMediaOfStudentGeneral
					allowPublishVisualMediaOfStudentForPromotion
					allowPublishVisualMediaOfGuardianForPromotion
					allowPublishStudentWorkGeneral
					allowShareInformationWithPearsonEdexcel
					allowShareInformationWithIbOrganization
					allowShareInformationWithOnlinePlatforms
					allowBirthdayInCalendar
					allowSendNewsletters
					allowSendCalendarEvents
				}
			}
		}
	}
`;

/**
 * __useStudentDataConsentListQuery__
 *
 * To run a query within a React component, call `useStudentDataConsentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDataConsentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentDataConsentListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentDataConsentListQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentDataConsentListQuery, StudentDataConsentListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentDataConsentListQuery, StudentDataConsentListQueryVariables>(
		StudentDataConsentListDocument,
		options,
	);
}
export function useStudentDataConsentListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentDataConsentListQuery, StudentDataConsentListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentDataConsentListQuery, StudentDataConsentListQueryVariables>(
		StudentDataConsentListDocument,
		options,
	);
}
export function useStudentDataConsentListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentDataConsentListQuery, StudentDataConsentListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentDataConsentListQuery, StudentDataConsentListQueryVariables>(
		StudentDataConsentListDocument,
		options,
	);
}
export type StudentDataConsentListQueryHookResult = ReturnType<typeof useStudentDataConsentListQuery>;
export type StudentDataConsentListLazyQueryHookResult = ReturnType<typeof useStudentDataConsentListLazyQuery>;
export type StudentDataConsentListSuspenseQueryHookResult = ReturnType<typeof useStudentDataConsentListSuspenseQuery>;
export type StudentDataConsentListQueryResult = Apollo.QueryResult<
	StudentDataConsentListQuery,
	StudentDataConsentListQueryVariables
>;
export const StudentDataConsentDetailListDocument = gql`
	query studentDataConsentDetailList(
		$filters: [StudentDataConsentFilterInput!]
		$pagination: Pagination
		$order: StudentDataConsentOrder
	) {
		studentDataConsentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					...StudentDataConsentDetail
				}
			}
		}
	}
	${StudentDataConsentDetailFragmentDoc}
`;

/**
 * __useStudentDataConsentDetailListQuery__
 *
 * To run a query within a React component, call `useStudentDataConsentDetailListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDataConsentDetailListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentDataConsentDetailListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentDataConsentDetailListQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentDataConsentDetailListQuery, StudentDataConsentDetailListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentDataConsentDetailListQuery, StudentDataConsentDetailListQueryVariables>(
		StudentDataConsentDetailListDocument,
		options,
	);
}
export function useStudentDataConsentDetailListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentDataConsentDetailListQuery,
		StudentDataConsentDetailListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentDataConsentDetailListQuery, StudentDataConsentDetailListQueryVariables>(
		StudentDataConsentDetailListDocument,
		options,
	);
}
export function useStudentDataConsentDetailListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentDataConsentDetailListQuery,
		StudentDataConsentDetailListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentDataConsentDetailListQuery, StudentDataConsentDetailListQueryVariables>(
		StudentDataConsentDetailListDocument,
		options,
	);
}
export type StudentDataConsentDetailListQueryHookResult = ReturnType<typeof useStudentDataConsentDetailListQuery>;
export type StudentDataConsentDetailListLazyQueryHookResult = ReturnType<
	typeof useStudentDataConsentDetailListLazyQuery
>;
export type StudentDataConsentDetailListSuspenseQueryHookResult = ReturnType<
	typeof useStudentDataConsentDetailListSuspenseQuery
>;
export type StudentDataConsentDetailListQueryResult = Apollo.QueryResult<
	StudentDataConsentDetailListQuery,
	StudentDataConsentDetailListQueryVariables
>;
export const StudentDataConsentNameDocument = gql`
	query studentDataConsentName($id: ID!) {
		studentDataConsent(id: $id) {
			id
			...StudentDataConsentName
		}
	}
	${StudentDataConsentNameFragmentDoc}
`;

/**
 * __useStudentDataConsentNameQuery__
 *
 * To run a query within a React component, call `useStudentDataConsentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDataConsentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentDataConsentNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentDataConsentNameQuery(
	baseOptions: Apollo.QueryHookOptions<StudentDataConsentNameQuery, StudentDataConsentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentDataConsentNameQuery, StudentDataConsentNameQueryVariables>(
		StudentDataConsentNameDocument,
		options,
	);
}
export function useStudentDataConsentNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentDataConsentNameQuery, StudentDataConsentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentDataConsentNameQuery, StudentDataConsentNameQueryVariables>(
		StudentDataConsentNameDocument,
		options,
	);
}
export function useStudentDataConsentNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentDataConsentNameQuery, StudentDataConsentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentDataConsentNameQuery, StudentDataConsentNameQueryVariables>(
		StudentDataConsentNameDocument,
		options,
	);
}
export type StudentDataConsentNameQueryHookResult = ReturnType<typeof useStudentDataConsentNameQuery>;
export type StudentDataConsentNameLazyQueryHookResult = ReturnType<typeof useStudentDataConsentNameLazyQuery>;
export type StudentDataConsentNameSuspenseQueryHookResult = ReturnType<typeof useStudentDataConsentNameSuspenseQuery>;
export type StudentDataConsentNameQueryResult = Apollo.QueryResult<
	StudentDataConsentNameQuery,
	StudentDataConsentNameQueryVariables
>;
export const StudentDataConsentNamesDocument = gql`
	query studentDataConsentNames(
		$filters: [StudentDataConsentFilterInput!]
		$pagination: Pagination
		$order: StudentDataConsentOrder
	) {
		studentDataConsentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentDataConsentName
				}
			}
		}
	}
	${StudentDataConsentNameFragmentDoc}
`;

/**
 * __useStudentDataConsentNamesQuery__
 *
 * To run a query within a React component, call `useStudentDataConsentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDataConsentNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentDataConsentNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentDataConsentNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentDataConsentNamesQuery, StudentDataConsentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentDataConsentNamesQuery, StudentDataConsentNamesQueryVariables>(
		StudentDataConsentNamesDocument,
		options,
	);
}
export function useStudentDataConsentNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentDataConsentNamesQuery, StudentDataConsentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentDataConsentNamesQuery, StudentDataConsentNamesQueryVariables>(
		StudentDataConsentNamesDocument,
		options,
	);
}
export function useStudentDataConsentNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentDataConsentNamesQuery, StudentDataConsentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentDataConsentNamesQuery, StudentDataConsentNamesQueryVariables>(
		StudentDataConsentNamesDocument,
		options,
	);
}
export type StudentDataConsentNamesQueryHookResult = ReturnType<typeof useStudentDataConsentNamesQuery>;
export type StudentDataConsentNamesLazyQueryHookResult = ReturnType<typeof useStudentDataConsentNamesLazyQuery>;
export type StudentDataConsentNamesSuspenseQueryHookResult = ReturnType<typeof useStudentDataConsentNamesSuspenseQuery>;
export type StudentDataConsentNamesQueryResult = Apollo.QueryResult<
	StudentDataConsentNamesQuery,
	StudentDataConsentNamesQueryVariables
>;
export const StudentDataConsentPaginationDocument = gql`
	query studentDataConsentPagination($filters: [StudentDataConsentFilterInput!], $order: StudentDataConsentOrder) {
		studentDataConsentConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentDataConsentPaginationQuery__
 *
 * To run a query within a React component, call `useStudentDataConsentPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDataConsentPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentDataConsentPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentDataConsentPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentDataConsentPaginationQuery, StudentDataConsentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentDataConsentPaginationQuery, StudentDataConsentPaginationQueryVariables>(
		StudentDataConsentPaginationDocument,
		options,
	);
}
export function useStudentDataConsentPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentDataConsentPaginationQuery,
		StudentDataConsentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentDataConsentPaginationQuery, StudentDataConsentPaginationQueryVariables>(
		StudentDataConsentPaginationDocument,
		options,
	);
}
export function useStudentDataConsentPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentDataConsentPaginationQuery,
		StudentDataConsentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentDataConsentPaginationQuery, StudentDataConsentPaginationQueryVariables>(
		StudentDataConsentPaginationDocument,
		options,
	);
}
export type StudentDataConsentPaginationQueryHookResult = ReturnType<typeof useStudentDataConsentPaginationQuery>;
export type StudentDataConsentPaginationLazyQueryHookResult = ReturnType<
	typeof useStudentDataConsentPaginationLazyQuery
>;
export type StudentDataConsentPaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentDataConsentPaginationSuspenseQuery
>;
export type StudentDataConsentPaginationQueryResult = Apollo.QueryResult<
	StudentDataConsentPaginationQuery,
	StudentDataConsentPaginationQueryVariables
>;
export const StudentDataConsentSelectDocument = gql`
	query studentDataConsentSelect($filters: [StudentDataConsentFilterInput!], $order: StudentDataConsentOrder) {
		studentDataConsentConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentDataConsentName
				}
			}
		}
	}
	${StudentDataConsentNameFragmentDoc}
`;

/**
 * __useStudentDataConsentSelectQuery__
 *
 * To run a query within a React component, call `useStudentDataConsentSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDataConsentSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentDataConsentSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentDataConsentSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentDataConsentSelectQuery, StudentDataConsentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentDataConsentSelectQuery, StudentDataConsentSelectQueryVariables>(
		StudentDataConsentSelectDocument,
		options,
	);
}
export function useStudentDataConsentSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentDataConsentSelectQuery, StudentDataConsentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentDataConsentSelectQuery, StudentDataConsentSelectQueryVariables>(
		StudentDataConsentSelectDocument,
		options,
	);
}
export function useStudentDataConsentSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentDataConsentSelectQuery, StudentDataConsentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentDataConsentSelectQuery, StudentDataConsentSelectQueryVariables>(
		StudentDataConsentSelectDocument,
		options,
	);
}
export type StudentDataConsentSelectQueryHookResult = ReturnType<typeof useStudentDataConsentSelectQuery>;
export type StudentDataConsentSelectLazyQueryHookResult = ReturnType<typeof useStudentDataConsentSelectLazyQuery>;
export type StudentDataConsentSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentDataConsentSelectSuspenseQuery
>;
export type StudentDataConsentSelectQueryResult = Apollo.QueryResult<
	StudentDataConsentSelectQuery,
	StudentDataConsentSelectQueryVariables
>;
export const StudentDataConsentUpdateDocument = gql`
	mutation studentDataConsentUpdate($id: ID!, $input: StudentDataConsentUpdateInput!) {
		updateStudentDataConsent(id: $id, input: $input) {
			...StudentDataConsentDetail
		}
	}
	${StudentDataConsentDetailFragmentDoc}
`;
export type StudentDataConsentUpdateMutationFn = Apollo.MutationFunction<
	StudentDataConsentUpdateMutation,
	StudentDataConsentUpdateMutationVariables
>;

/**
 * __useStudentDataConsentUpdateMutation__
 *
 * To run a mutation, you first call `useStudentDataConsentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentDataConsentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentDataConsentUpdateMutation, { data, loading, error }] = useStudentDataConsentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentDataConsentUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<StudentDataConsentUpdateMutation, StudentDataConsentUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentDataConsentUpdateMutation, StudentDataConsentUpdateMutationVariables>(
		StudentDataConsentUpdateDocument,
		options,
	);
}
export type StudentDataConsentUpdateMutationHookResult = ReturnType<typeof useStudentDataConsentUpdateMutation>;
export type StudentDataConsentUpdateMutationResult = Apollo.MutationResult<StudentDataConsentUpdateMutation>;
export type StudentDataConsentUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentDataConsentUpdateMutation,
	StudentDataConsentUpdateMutationVariables
>;
export const StudentEnrollmentApplicationCountDocument = gql`
	query studentEnrollmentApplicationCount(
		$filters: [StudentEnrollmentApplicationFilterInput!]
		$pagination: Pagination
		$order: StudentEnrollmentApplicationOrder
	) {
		studentEnrollmentApplicationConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentEnrollmentApplicationCountQuery__
 *
 * To run a query within a React component, call `useStudentEnrollmentApplicationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentApplicationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentEnrollmentApplicationCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentEnrollmentApplicationCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentEnrollmentApplicationCountQuery,
		StudentEnrollmentApplicationCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentEnrollmentApplicationCountQuery, StudentEnrollmentApplicationCountQueryVariables>(
		StudentEnrollmentApplicationCountDocument,
		options,
	);
}
export function useStudentEnrollmentApplicationCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentEnrollmentApplicationCountQuery,
		StudentEnrollmentApplicationCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentEnrollmentApplicationCountQuery, StudentEnrollmentApplicationCountQueryVariables>(
		StudentEnrollmentApplicationCountDocument,
		options,
	);
}
export function useStudentEnrollmentApplicationCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentEnrollmentApplicationCountQuery,
		StudentEnrollmentApplicationCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentEnrollmentApplicationCountQuery,
		StudentEnrollmentApplicationCountQueryVariables
	>(StudentEnrollmentApplicationCountDocument, options);
}
export type StudentEnrollmentApplicationCountQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationCountQuery
>;
export type StudentEnrollmentApplicationCountLazyQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationCountLazyQuery
>;
export type StudentEnrollmentApplicationCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationCountSuspenseQuery
>;
export type StudentEnrollmentApplicationCountQueryResult = Apollo.QueryResult<
	StudentEnrollmentApplicationCountQuery,
	StudentEnrollmentApplicationCountQueryVariables
>;
export const StudentEnrollmentApplicationCreateDocument = gql`
	mutation studentEnrollmentApplicationCreate($input: StudentEnrollmentApplicationCreateInput!) {
		createStudentEnrollmentApplication(input: $input) {
			...StudentEnrollmentApplicationDetail
		}
	}
	${StudentEnrollmentApplicationDetailFragmentDoc}
`;
export type StudentEnrollmentApplicationCreateMutationFn = Apollo.MutationFunction<
	StudentEnrollmentApplicationCreateMutation,
	StudentEnrollmentApplicationCreateMutationVariables
>;

/**
 * __useStudentEnrollmentApplicationCreateMutation__
 *
 * To run a mutation, you first call `useStudentEnrollmentApplicationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentApplicationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentEnrollmentApplicationCreateMutation, { data, loading, error }] = useStudentEnrollmentApplicationCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentEnrollmentApplicationCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentEnrollmentApplicationCreateMutation,
		StudentEnrollmentApplicationCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentEnrollmentApplicationCreateMutation,
		StudentEnrollmentApplicationCreateMutationVariables
	>(StudentEnrollmentApplicationCreateDocument, options);
}
export type StudentEnrollmentApplicationCreateMutationHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationCreateMutation
>;
export type StudentEnrollmentApplicationCreateMutationResult =
	Apollo.MutationResult<StudentEnrollmentApplicationCreateMutation>;
export type StudentEnrollmentApplicationCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentEnrollmentApplicationCreateMutation,
	StudentEnrollmentApplicationCreateMutationVariables
>;
export const StudentEnrollmentApplicationDeleteDocument = gql`
	mutation studentEnrollmentApplicationDelete($id: ID!) {
		deleteStudentEnrollmentApplication(id: $id)
	}
`;
export type StudentEnrollmentApplicationDeleteMutationFn = Apollo.MutationFunction<
	StudentEnrollmentApplicationDeleteMutation,
	StudentEnrollmentApplicationDeleteMutationVariables
>;

/**
 * __useStudentEnrollmentApplicationDeleteMutation__
 *
 * To run a mutation, you first call `useStudentEnrollmentApplicationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentApplicationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentEnrollmentApplicationDeleteMutation, { data, loading, error }] = useStudentEnrollmentApplicationDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentEnrollmentApplicationDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentEnrollmentApplicationDeleteMutation,
		StudentEnrollmentApplicationDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentEnrollmentApplicationDeleteMutation,
		StudentEnrollmentApplicationDeleteMutationVariables
	>(StudentEnrollmentApplicationDeleteDocument, options);
}
export type StudentEnrollmentApplicationDeleteMutationHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationDeleteMutation
>;
export type StudentEnrollmentApplicationDeleteMutationResult =
	Apollo.MutationResult<StudentEnrollmentApplicationDeleteMutation>;
export type StudentEnrollmentApplicationDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentEnrollmentApplicationDeleteMutation,
	StudentEnrollmentApplicationDeleteMutationVariables
>;
export const StudentEnrollmentApplicationDetailDocument = gql`
	query studentEnrollmentApplicationDetail($id: ID!) {
		studentEnrollmentApplication(id: $id) {
			...StudentEnrollmentApplicationDetail
		}
	}
	${StudentEnrollmentApplicationDetailFragmentDoc}
`;

/**
 * __useStudentEnrollmentApplicationDetailQuery__
 *
 * To run a query within a React component, call `useStudentEnrollmentApplicationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentApplicationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentEnrollmentApplicationDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentEnrollmentApplicationDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentEnrollmentApplicationDetailQuery,
		StudentEnrollmentApplicationDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentEnrollmentApplicationDetailQuery, StudentEnrollmentApplicationDetailQueryVariables>(
		StudentEnrollmentApplicationDetailDocument,
		options,
	);
}
export function useStudentEnrollmentApplicationDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentEnrollmentApplicationDetailQuery,
		StudentEnrollmentApplicationDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentEnrollmentApplicationDetailQuery, StudentEnrollmentApplicationDetailQueryVariables>(
		StudentEnrollmentApplicationDetailDocument,
		options,
	);
}
export function useStudentEnrollmentApplicationDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentEnrollmentApplicationDetailQuery,
		StudentEnrollmentApplicationDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentEnrollmentApplicationDetailQuery,
		StudentEnrollmentApplicationDetailQueryVariables
	>(StudentEnrollmentApplicationDetailDocument, options);
}
export type StudentEnrollmentApplicationDetailQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationDetailQuery
>;
export type StudentEnrollmentApplicationDetailLazyQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationDetailLazyQuery
>;
export type StudentEnrollmentApplicationDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationDetailSuspenseQuery
>;
export type StudentEnrollmentApplicationDetailQueryResult = Apollo.QueryResult<
	StudentEnrollmentApplicationDetailQuery,
	StudentEnrollmentApplicationDetailQueryVariables
>;
export const StudentEnrollmentApplicationIndexDocument = gql`
	query studentEnrollmentApplicationIndex(
		$filters: [StudentEnrollmentApplicationFilterInput!]
		$pagination: Pagination
		$order: StudentEnrollmentApplicationOrder
	) {
		studentEnrollmentApplicationConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					status
					statusUpdatedAt
				}
			}
		}
	}
`;

/**
 * __useStudentEnrollmentApplicationIndexQuery__
 *
 * To run a query within a React component, call `useStudentEnrollmentApplicationIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentApplicationIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentEnrollmentApplicationIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentEnrollmentApplicationIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentEnrollmentApplicationIndexQuery,
		StudentEnrollmentApplicationIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentEnrollmentApplicationIndexQuery, StudentEnrollmentApplicationIndexQueryVariables>(
		StudentEnrollmentApplicationIndexDocument,
		options,
	);
}
export function useStudentEnrollmentApplicationIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentEnrollmentApplicationIndexQuery,
		StudentEnrollmentApplicationIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentEnrollmentApplicationIndexQuery, StudentEnrollmentApplicationIndexQueryVariables>(
		StudentEnrollmentApplicationIndexDocument,
		options,
	);
}
export function useStudentEnrollmentApplicationIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentEnrollmentApplicationIndexQuery,
		StudentEnrollmentApplicationIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentEnrollmentApplicationIndexQuery,
		StudentEnrollmentApplicationIndexQueryVariables
	>(StudentEnrollmentApplicationIndexDocument, options);
}
export type StudentEnrollmentApplicationIndexQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationIndexQuery
>;
export type StudentEnrollmentApplicationIndexLazyQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationIndexLazyQuery
>;
export type StudentEnrollmentApplicationIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationIndexSuspenseQuery
>;
export type StudentEnrollmentApplicationIndexQueryResult = Apollo.QueryResult<
	StudentEnrollmentApplicationIndexQuery,
	StudentEnrollmentApplicationIndexQueryVariables
>;
export const StudentEnrollmentApplicationNameDocument = gql`
	query studentEnrollmentApplicationName($id: ID!) {
		studentEnrollmentApplication(id: $id) {
			id
			...StudentEnrollmentApplicationName
		}
	}
	${StudentEnrollmentApplicationNameFragmentDoc}
`;

/**
 * __useStudentEnrollmentApplicationNameQuery__
 *
 * To run a query within a React component, call `useStudentEnrollmentApplicationNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentApplicationNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentEnrollmentApplicationNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentEnrollmentApplicationNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentEnrollmentApplicationNameQuery,
		StudentEnrollmentApplicationNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentEnrollmentApplicationNameQuery, StudentEnrollmentApplicationNameQueryVariables>(
		StudentEnrollmentApplicationNameDocument,
		options,
	);
}
export function useStudentEnrollmentApplicationNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentEnrollmentApplicationNameQuery,
		StudentEnrollmentApplicationNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentEnrollmentApplicationNameQuery, StudentEnrollmentApplicationNameQueryVariables>(
		StudentEnrollmentApplicationNameDocument,
		options,
	);
}
export function useStudentEnrollmentApplicationNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentEnrollmentApplicationNameQuery,
		StudentEnrollmentApplicationNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentEnrollmentApplicationNameQuery, StudentEnrollmentApplicationNameQueryVariables>(
		StudentEnrollmentApplicationNameDocument,
		options,
	);
}
export type StudentEnrollmentApplicationNameQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationNameQuery
>;
export type StudentEnrollmentApplicationNameLazyQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationNameLazyQuery
>;
export type StudentEnrollmentApplicationNameSuspenseQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationNameSuspenseQuery
>;
export type StudentEnrollmentApplicationNameQueryResult = Apollo.QueryResult<
	StudentEnrollmentApplicationNameQuery,
	StudentEnrollmentApplicationNameQueryVariables
>;
export const StudentEnrollmentApplicationNamesDocument = gql`
	query studentEnrollmentApplicationNames(
		$filters: [StudentEnrollmentApplicationFilterInput!]
		$pagination: Pagination
		$order: StudentEnrollmentApplicationOrder
	) {
		studentEnrollmentApplicationConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentEnrollmentApplicationName
				}
			}
		}
	}
	${StudentEnrollmentApplicationNameFragmentDoc}
`;

/**
 * __useStudentEnrollmentApplicationNamesQuery__
 *
 * To run a query within a React component, call `useStudentEnrollmentApplicationNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentApplicationNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentEnrollmentApplicationNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentEnrollmentApplicationNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentEnrollmentApplicationNamesQuery,
		StudentEnrollmentApplicationNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentEnrollmentApplicationNamesQuery, StudentEnrollmentApplicationNamesQueryVariables>(
		StudentEnrollmentApplicationNamesDocument,
		options,
	);
}
export function useStudentEnrollmentApplicationNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentEnrollmentApplicationNamesQuery,
		StudentEnrollmentApplicationNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentEnrollmentApplicationNamesQuery, StudentEnrollmentApplicationNamesQueryVariables>(
		StudentEnrollmentApplicationNamesDocument,
		options,
	);
}
export function useStudentEnrollmentApplicationNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentEnrollmentApplicationNamesQuery,
		StudentEnrollmentApplicationNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentEnrollmentApplicationNamesQuery,
		StudentEnrollmentApplicationNamesQueryVariables
	>(StudentEnrollmentApplicationNamesDocument, options);
}
export type StudentEnrollmentApplicationNamesQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationNamesQuery
>;
export type StudentEnrollmentApplicationNamesLazyQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationNamesLazyQuery
>;
export type StudentEnrollmentApplicationNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationNamesSuspenseQuery
>;
export type StudentEnrollmentApplicationNamesQueryResult = Apollo.QueryResult<
	StudentEnrollmentApplicationNamesQuery,
	StudentEnrollmentApplicationNamesQueryVariables
>;
export const StudentEnrollmentApplicationPaginationDocument = gql`
	query studentEnrollmentApplicationPagination(
		$filters: [StudentEnrollmentApplicationFilterInput!]
		$order: StudentEnrollmentApplicationOrder
	) {
		studentEnrollmentApplicationConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentEnrollmentApplicationPaginationQuery__
 *
 * To run a query within a React component, call `useStudentEnrollmentApplicationPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentApplicationPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentEnrollmentApplicationPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentEnrollmentApplicationPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentEnrollmentApplicationPaginationQuery,
		StudentEnrollmentApplicationPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentEnrollmentApplicationPaginationQuery,
		StudentEnrollmentApplicationPaginationQueryVariables
	>(StudentEnrollmentApplicationPaginationDocument, options);
}
export function useStudentEnrollmentApplicationPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentEnrollmentApplicationPaginationQuery,
		StudentEnrollmentApplicationPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentEnrollmentApplicationPaginationQuery,
		StudentEnrollmentApplicationPaginationQueryVariables
	>(StudentEnrollmentApplicationPaginationDocument, options);
}
export function useStudentEnrollmentApplicationPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentEnrollmentApplicationPaginationQuery,
		StudentEnrollmentApplicationPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentEnrollmentApplicationPaginationQuery,
		StudentEnrollmentApplicationPaginationQueryVariables
	>(StudentEnrollmentApplicationPaginationDocument, options);
}
export type StudentEnrollmentApplicationPaginationQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationPaginationQuery
>;
export type StudentEnrollmentApplicationPaginationLazyQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationPaginationLazyQuery
>;
export type StudentEnrollmentApplicationPaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationPaginationSuspenseQuery
>;
export type StudentEnrollmentApplicationPaginationQueryResult = Apollo.QueryResult<
	StudentEnrollmentApplicationPaginationQuery,
	StudentEnrollmentApplicationPaginationQueryVariables
>;
export const StudentEnrollmentApplicationSelectDocument = gql`
	query studentEnrollmentApplicationSelect(
		$filters: [StudentEnrollmentApplicationFilterInput!]
		$order: StudentEnrollmentApplicationOrder
	) {
		studentEnrollmentApplicationConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentEnrollmentApplicationName
				}
			}
		}
	}
	${StudentEnrollmentApplicationNameFragmentDoc}
`;

/**
 * __useStudentEnrollmentApplicationSelectQuery__
 *
 * To run a query within a React component, call `useStudentEnrollmentApplicationSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentApplicationSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentEnrollmentApplicationSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentEnrollmentApplicationSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentEnrollmentApplicationSelectQuery,
		StudentEnrollmentApplicationSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentEnrollmentApplicationSelectQuery, StudentEnrollmentApplicationSelectQueryVariables>(
		StudentEnrollmentApplicationSelectDocument,
		options,
	);
}
export function useStudentEnrollmentApplicationSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentEnrollmentApplicationSelectQuery,
		StudentEnrollmentApplicationSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentEnrollmentApplicationSelectQuery, StudentEnrollmentApplicationSelectQueryVariables>(
		StudentEnrollmentApplicationSelectDocument,
		options,
	);
}
export function useStudentEnrollmentApplicationSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentEnrollmentApplicationSelectQuery,
		StudentEnrollmentApplicationSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentEnrollmentApplicationSelectQuery,
		StudentEnrollmentApplicationSelectQueryVariables
	>(StudentEnrollmentApplicationSelectDocument, options);
}
export type StudentEnrollmentApplicationSelectQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationSelectQuery
>;
export type StudentEnrollmentApplicationSelectLazyQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationSelectLazyQuery
>;
export type StudentEnrollmentApplicationSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationSelectSuspenseQuery
>;
export type StudentEnrollmentApplicationSelectQueryResult = Apollo.QueryResult<
	StudentEnrollmentApplicationSelectQuery,
	StudentEnrollmentApplicationSelectQueryVariables
>;
export const StudentEnrollmentApplicationUpdateDocument = gql`
	mutation studentEnrollmentApplicationUpdate($id: ID!, $input: StudentEnrollmentApplicationUpdateInput!) {
		updateStudentEnrollmentApplication(id: $id, input: $input) {
			...StudentEnrollmentApplicationDetail
		}
	}
	${StudentEnrollmentApplicationDetailFragmentDoc}
`;
export type StudentEnrollmentApplicationUpdateMutationFn = Apollo.MutationFunction<
	StudentEnrollmentApplicationUpdateMutation,
	StudentEnrollmentApplicationUpdateMutationVariables
>;

/**
 * __useStudentEnrollmentApplicationUpdateMutation__
 *
 * To run a mutation, you first call `useStudentEnrollmentApplicationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentApplicationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentEnrollmentApplicationUpdateMutation, { data, loading, error }] = useStudentEnrollmentApplicationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentEnrollmentApplicationUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentEnrollmentApplicationUpdateMutation,
		StudentEnrollmentApplicationUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentEnrollmentApplicationUpdateMutation,
		StudentEnrollmentApplicationUpdateMutationVariables
	>(StudentEnrollmentApplicationUpdateDocument, options);
}
export type StudentEnrollmentApplicationUpdateMutationHookResult = ReturnType<
	typeof useStudentEnrollmentApplicationUpdateMutation
>;
export type StudentEnrollmentApplicationUpdateMutationResult =
	Apollo.MutationResult<StudentEnrollmentApplicationUpdateMutation>;
export type StudentEnrollmentApplicationUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentEnrollmentApplicationUpdateMutation,
	StudentEnrollmentApplicationUpdateMutationVariables
>;
export const StudentEnrollmentIntentCountDocument = gql`
	query studentEnrollmentIntentCount(
		$filters: [StudentEnrollmentIntentFilterInput!]
		$pagination: Pagination
		$order: StudentEnrollmentIntentOrder
	) {
		studentEnrollmentIntentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentEnrollmentIntentCountQuery__
 *
 * To run a query within a React component, call `useStudentEnrollmentIntentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentIntentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentEnrollmentIntentCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentEnrollmentIntentCountQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentEnrollmentIntentCountQuery, StudentEnrollmentIntentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentEnrollmentIntentCountQuery, StudentEnrollmentIntentCountQueryVariables>(
		StudentEnrollmentIntentCountDocument,
		options,
	);
}
export function useStudentEnrollmentIntentCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentEnrollmentIntentCountQuery,
		StudentEnrollmentIntentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentEnrollmentIntentCountQuery, StudentEnrollmentIntentCountQueryVariables>(
		StudentEnrollmentIntentCountDocument,
		options,
	);
}
export function useStudentEnrollmentIntentCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentEnrollmentIntentCountQuery,
		StudentEnrollmentIntentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentEnrollmentIntentCountQuery, StudentEnrollmentIntentCountQueryVariables>(
		StudentEnrollmentIntentCountDocument,
		options,
	);
}
export type StudentEnrollmentIntentCountQueryHookResult = ReturnType<typeof useStudentEnrollmentIntentCountQuery>;
export type StudentEnrollmentIntentCountLazyQueryHookResult = ReturnType<
	typeof useStudentEnrollmentIntentCountLazyQuery
>;
export type StudentEnrollmentIntentCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentEnrollmentIntentCountSuspenseQuery
>;
export type StudentEnrollmentIntentCountQueryResult = Apollo.QueryResult<
	StudentEnrollmentIntentCountQuery,
	StudentEnrollmentIntentCountQueryVariables
>;
export const StudentEnrollmentIntentCreateDocument = gql`
	mutation studentEnrollmentIntentCreate($input: StudentEnrollmentIntentCreateInput!) {
		createStudentEnrollmentIntent(input: $input) {
			...StudentEnrollmentIntentDetail
		}
	}
	${StudentEnrollmentIntentDetailFragmentDoc}
`;
export type StudentEnrollmentIntentCreateMutationFn = Apollo.MutationFunction<
	StudentEnrollmentIntentCreateMutation,
	StudentEnrollmentIntentCreateMutationVariables
>;

/**
 * __useStudentEnrollmentIntentCreateMutation__
 *
 * To run a mutation, you first call `useStudentEnrollmentIntentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentIntentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentEnrollmentIntentCreateMutation, { data, loading, error }] = useStudentEnrollmentIntentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentEnrollmentIntentCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentEnrollmentIntentCreateMutation,
		StudentEnrollmentIntentCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentEnrollmentIntentCreateMutation, StudentEnrollmentIntentCreateMutationVariables>(
		StudentEnrollmentIntentCreateDocument,
		options,
	);
}
export type StudentEnrollmentIntentCreateMutationHookResult = ReturnType<
	typeof useStudentEnrollmentIntentCreateMutation
>;
export type StudentEnrollmentIntentCreateMutationResult = Apollo.MutationResult<StudentEnrollmentIntentCreateMutation>;
export type StudentEnrollmentIntentCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentEnrollmentIntentCreateMutation,
	StudentEnrollmentIntentCreateMutationVariables
>;
export const StudentEnrollmentIntentDeleteDocument = gql`
	mutation studentEnrollmentIntentDelete($id: ID!) {
		deleteStudentEnrollmentIntent(id: $id)
	}
`;
export type StudentEnrollmentIntentDeleteMutationFn = Apollo.MutationFunction<
	StudentEnrollmentIntentDeleteMutation,
	StudentEnrollmentIntentDeleteMutationVariables
>;

/**
 * __useStudentEnrollmentIntentDeleteMutation__
 *
 * To run a mutation, you first call `useStudentEnrollmentIntentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentIntentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentEnrollmentIntentDeleteMutation, { data, loading, error }] = useStudentEnrollmentIntentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentEnrollmentIntentDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentEnrollmentIntentDeleteMutation,
		StudentEnrollmentIntentDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentEnrollmentIntentDeleteMutation, StudentEnrollmentIntentDeleteMutationVariables>(
		StudentEnrollmentIntentDeleteDocument,
		options,
	);
}
export type StudentEnrollmentIntentDeleteMutationHookResult = ReturnType<
	typeof useStudentEnrollmentIntentDeleteMutation
>;
export type StudentEnrollmentIntentDeleteMutationResult = Apollo.MutationResult<StudentEnrollmentIntentDeleteMutation>;
export type StudentEnrollmentIntentDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentEnrollmentIntentDeleteMutation,
	StudentEnrollmentIntentDeleteMutationVariables
>;
export const StudentEnrollmentIntentDetailDocument = gql`
	query studentEnrollmentIntentDetail($id: ID!) {
		studentEnrollmentIntent(id: $id) {
			...StudentEnrollmentIntentDetail
		}
	}
	${StudentEnrollmentIntentDetailFragmentDoc}
`;

/**
 * __useStudentEnrollmentIntentDetailQuery__
 *
 * To run a query within a React component, call `useStudentEnrollmentIntentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentIntentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentEnrollmentIntentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentEnrollmentIntentDetailQuery(
	baseOptions: Apollo.QueryHookOptions<StudentEnrollmentIntentDetailQuery, StudentEnrollmentIntentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentEnrollmentIntentDetailQuery, StudentEnrollmentIntentDetailQueryVariables>(
		StudentEnrollmentIntentDetailDocument,
		options,
	);
}
export function useStudentEnrollmentIntentDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentEnrollmentIntentDetailQuery,
		StudentEnrollmentIntentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentEnrollmentIntentDetailQuery, StudentEnrollmentIntentDetailQueryVariables>(
		StudentEnrollmentIntentDetailDocument,
		options,
	);
}
export function useStudentEnrollmentIntentDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentEnrollmentIntentDetailQuery,
		StudentEnrollmentIntentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentEnrollmentIntentDetailQuery, StudentEnrollmentIntentDetailQueryVariables>(
		StudentEnrollmentIntentDetailDocument,
		options,
	);
}
export type StudentEnrollmentIntentDetailQueryHookResult = ReturnType<typeof useStudentEnrollmentIntentDetailQuery>;
export type StudentEnrollmentIntentDetailLazyQueryHookResult = ReturnType<
	typeof useStudentEnrollmentIntentDetailLazyQuery
>;
export type StudentEnrollmentIntentDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentEnrollmentIntentDetailSuspenseQuery
>;
export type StudentEnrollmentIntentDetailQueryResult = Apollo.QueryResult<
	StudentEnrollmentIntentDetailQuery,
	StudentEnrollmentIntentDetailQueryVariables
>;
export const StudentEnrollmentIntentIndexDocument = gql`
	query studentEnrollmentIntentIndex(
		$filters: [StudentEnrollmentIntentFilterInput!]
		$pagination: Pagination
		$order: StudentEnrollmentIntentOrder
	) {
		studentEnrollmentIntentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					isEnrolling
					isInterestedInMealPlan
					declineReason
					declineReasonDescription
				}
			}
		}
	}
`;

/**
 * __useStudentEnrollmentIntentIndexQuery__
 *
 * To run a query within a React component, call `useStudentEnrollmentIntentIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentIntentIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentEnrollmentIntentIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentEnrollmentIntentIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentEnrollmentIntentIndexQuery, StudentEnrollmentIntentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentEnrollmentIntentIndexQuery, StudentEnrollmentIntentIndexQueryVariables>(
		StudentEnrollmentIntentIndexDocument,
		options,
	);
}
export function useStudentEnrollmentIntentIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentEnrollmentIntentIndexQuery,
		StudentEnrollmentIntentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentEnrollmentIntentIndexQuery, StudentEnrollmentIntentIndexQueryVariables>(
		StudentEnrollmentIntentIndexDocument,
		options,
	);
}
export function useStudentEnrollmentIntentIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentEnrollmentIntentIndexQuery,
		StudentEnrollmentIntentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentEnrollmentIntentIndexQuery, StudentEnrollmentIntentIndexQueryVariables>(
		StudentEnrollmentIntentIndexDocument,
		options,
	);
}
export type StudentEnrollmentIntentIndexQueryHookResult = ReturnType<typeof useStudentEnrollmentIntentIndexQuery>;
export type StudentEnrollmentIntentIndexLazyQueryHookResult = ReturnType<
	typeof useStudentEnrollmentIntentIndexLazyQuery
>;
export type StudentEnrollmentIntentIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentEnrollmentIntentIndexSuspenseQuery
>;
export type StudentEnrollmentIntentIndexQueryResult = Apollo.QueryResult<
	StudentEnrollmentIntentIndexQuery,
	StudentEnrollmentIntentIndexQueryVariables
>;
export const StudentEnrollmentIntentNameDocument = gql`
	query studentEnrollmentIntentName($id: ID!) {
		studentEnrollmentIntent(id: $id) {
			id
			...StudentEnrollmentIntentName
		}
	}
	${StudentEnrollmentIntentNameFragmentDoc}
`;

/**
 * __useStudentEnrollmentIntentNameQuery__
 *
 * To run a query within a React component, call `useStudentEnrollmentIntentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentIntentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentEnrollmentIntentNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentEnrollmentIntentNameQuery(
	baseOptions: Apollo.QueryHookOptions<StudentEnrollmentIntentNameQuery, StudentEnrollmentIntentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentEnrollmentIntentNameQuery, StudentEnrollmentIntentNameQueryVariables>(
		StudentEnrollmentIntentNameDocument,
		options,
	);
}
export function useStudentEnrollmentIntentNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentEnrollmentIntentNameQuery,
		StudentEnrollmentIntentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentEnrollmentIntentNameQuery, StudentEnrollmentIntentNameQueryVariables>(
		StudentEnrollmentIntentNameDocument,
		options,
	);
}
export function useStudentEnrollmentIntentNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentEnrollmentIntentNameQuery,
		StudentEnrollmentIntentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentEnrollmentIntentNameQuery, StudentEnrollmentIntentNameQueryVariables>(
		StudentEnrollmentIntentNameDocument,
		options,
	);
}
export type StudentEnrollmentIntentNameQueryHookResult = ReturnType<typeof useStudentEnrollmentIntentNameQuery>;
export type StudentEnrollmentIntentNameLazyQueryHookResult = ReturnType<typeof useStudentEnrollmentIntentNameLazyQuery>;
export type StudentEnrollmentIntentNameSuspenseQueryHookResult = ReturnType<
	typeof useStudentEnrollmentIntentNameSuspenseQuery
>;
export type StudentEnrollmentIntentNameQueryResult = Apollo.QueryResult<
	StudentEnrollmentIntentNameQuery,
	StudentEnrollmentIntentNameQueryVariables
>;
export const StudentEnrollmentIntentNamesDocument = gql`
	query studentEnrollmentIntentNames(
		$filters: [StudentEnrollmentIntentFilterInput!]
		$pagination: Pagination
		$order: StudentEnrollmentIntentOrder
	) {
		studentEnrollmentIntentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentEnrollmentIntentName
				}
			}
		}
	}
	${StudentEnrollmentIntentNameFragmentDoc}
`;

/**
 * __useStudentEnrollmentIntentNamesQuery__
 *
 * To run a query within a React component, call `useStudentEnrollmentIntentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentIntentNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentEnrollmentIntentNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentEnrollmentIntentNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentEnrollmentIntentNamesQuery, StudentEnrollmentIntentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentEnrollmentIntentNamesQuery, StudentEnrollmentIntentNamesQueryVariables>(
		StudentEnrollmentIntentNamesDocument,
		options,
	);
}
export function useStudentEnrollmentIntentNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentEnrollmentIntentNamesQuery,
		StudentEnrollmentIntentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentEnrollmentIntentNamesQuery, StudentEnrollmentIntentNamesQueryVariables>(
		StudentEnrollmentIntentNamesDocument,
		options,
	);
}
export function useStudentEnrollmentIntentNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentEnrollmentIntentNamesQuery,
		StudentEnrollmentIntentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentEnrollmentIntentNamesQuery, StudentEnrollmentIntentNamesQueryVariables>(
		StudentEnrollmentIntentNamesDocument,
		options,
	);
}
export type StudentEnrollmentIntentNamesQueryHookResult = ReturnType<typeof useStudentEnrollmentIntentNamesQuery>;
export type StudentEnrollmentIntentNamesLazyQueryHookResult = ReturnType<
	typeof useStudentEnrollmentIntentNamesLazyQuery
>;
export type StudentEnrollmentIntentNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentEnrollmentIntentNamesSuspenseQuery
>;
export type StudentEnrollmentIntentNamesQueryResult = Apollo.QueryResult<
	StudentEnrollmentIntentNamesQuery,
	StudentEnrollmentIntentNamesQueryVariables
>;
export const StudentEnrollmentIntentPaginationDocument = gql`
	query studentEnrollmentIntentPagination(
		$filters: [StudentEnrollmentIntentFilterInput!]
		$order: StudentEnrollmentIntentOrder
	) {
		studentEnrollmentIntentConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentEnrollmentIntentPaginationQuery__
 *
 * To run a query within a React component, call `useStudentEnrollmentIntentPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentIntentPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentEnrollmentIntentPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentEnrollmentIntentPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentEnrollmentIntentPaginationQuery,
		StudentEnrollmentIntentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentEnrollmentIntentPaginationQuery, StudentEnrollmentIntentPaginationQueryVariables>(
		StudentEnrollmentIntentPaginationDocument,
		options,
	);
}
export function useStudentEnrollmentIntentPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentEnrollmentIntentPaginationQuery,
		StudentEnrollmentIntentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentEnrollmentIntentPaginationQuery, StudentEnrollmentIntentPaginationQueryVariables>(
		StudentEnrollmentIntentPaginationDocument,
		options,
	);
}
export function useStudentEnrollmentIntentPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentEnrollmentIntentPaginationQuery,
		StudentEnrollmentIntentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentEnrollmentIntentPaginationQuery,
		StudentEnrollmentIntentPaginationQueryVariables
	>(StudentEnrollmentIntentPaginationDocument, options);
}
export type StudentEnrollmentIntentPaginationQueryHookResult = ReturnType<
	typeof useStudentEnrollmentIntentPaginationQuery
>;
export type StudentEnrollmentIntentPaginationLazyQueryHookResult = ReturnType<
	typeof useStudentEnrollmentIntentPaginationLazyQuery
>;
export type StudentEnrollmentIntentPaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentEnrollmentIntentPaginationSuspenseQuery
>;
export type StudentEnrollmentIntentPaginationQueryResult = Apollo.QueryResult<
	StudentEnrollmentIntentPaginationQuery,
	StudentEnrollmentIntentPaginationQueryVariables
>;
export const StudentEnrollmentIntentSelectDocument = gql`
	query studentEnrollmentIntentSelect(
		$filters: [StudentEnrollmentIntentFilterInput!]
		$order: StudentEnrollmentIntentOrder
	) {
		studentEnrollmentIntentConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentEnrollmentIntentName
				}
			}
		}
	}
	${StudentEnrollmentIntentNameFragmentDoc}
`;

/**
 * __useStudentEnrollmentIntentSelectQuery__
 *
 * To run a query within a React component, call `useStudentEnrollmentIntentSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentIntentSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentEnrollmentIntentSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentEnrollmentIntentSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentEnrollmentIntentSelectQuery,
		StudentEnrollmentIntentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentEnrollmentIntentSelectQuery, StudentEnrollmentIntentSelectQueryVariables>(
		StudentEnrollmentIntentSelectDocument,
		options,
	);
}
export function useStudentEnrollmentIntentSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentEnrollmentIntentSelectQuery,
		StudentEnrollmentIntentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentEnrollmentIntentSelectQuery, StudentEnrollmentIntentSelectQueryVariables>(
		StudentEnrollmentIntentSelectDocument,
		options,
	);
}
export function useStudentEnrollmentIntentSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentEnrollmentIntentSelectQuery,
		StudentEnrollmentIntentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentEnrollmentIntentSelectQuery, StudentEnrollmentIntentSelectQueryVariables>(
		StudentEnrollmentIntentSelectDocument,
		options,
	);
}
export type StudentEnrollmentIntentSelectQueryHookResult = ReturnType<typeof useStudentEnrollmentIntentSelectQuery>;
export type StudentEnrollmentIntentSelectLazyQueryHookResult = ReturnType<
	typeof useStudentEnrollmentIntentSelectLazyQuery
>;
export type StudentEnrollmentIntentSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentEnrollmentIntentSelectSuspenseQuery
>;
export type StudentEnrollmentIntentSelectQueryResult = Apollo.QueryResult<
	StudentEnrollmentIntentSelectQuery,
	StudentEnrollmentIntentSelectQueryVariables
>;
export const StudentEnrollmentIntentUpdateDocument = gql`
	mutation studentEnrollmentIntentUpdate($id: ID!, $input: StudentEnrollmentIntentUpdateInput!) {
		updateStudentEnrollmentIntent(id: $id, input: $input) {
			...StudentEnrollmentIntentDetail
		}
	}
	${StudentEnrollmentIntentDetailFragmentDoc}
`;
export type StudentEnrollmentIntentUpdateMutationFn = Apollo.MutationFunction<
	StudentEnrollmentIntentUpdateMutation,
	StudentEnrollmentIntentUpdateMutationVariables
>;

/**
 * __useStudentEnrollmentIntentUpdateMutation__
 *
 * To run a mutation, you first call `useStudentEnrollmentIntentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentEnrollmentIntentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentEnrollmentIntentUpdateMutation, { data, loading, error }] = useStudentEnrollmentIntentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentEnrollmentIntentUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentEnrollmentIntentUpdateMutation,
		StudentEnrollmentIntentUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentEnrollmentIntentUpdateMutation, StudentEnrollmentIntentUpdateMutationVariables>(
		StudentEnrollmentIntentUpdateDocument,
		options,
	);
}
export type StudentEnrollmentIntentUpdateMutationHookResult = ReturnType<
	typeof useStudentEnrollmentIntentUpdateMutation
>;
export type StudentEnrollmentIntentUpdateMutationResult = Apollo.MutationResult<StudentEnrollmentIntentUpdateMutation>;
export type StudentEnrollmentIntentUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentEnrollmentIntentUpdateMutation,
	StudentEnrollmentIntentUpdateMutationVariables
>;
export const StudentHealthNoteCountDocument = gql`
	query studentHealthNoteCount(
		$filters: [StudentHealthNoteFilterInput!]
		$pagination: Pagination
		$order: StudentHealthNoteOrder
	) {
		studentHealthNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentHealthNoteCountQuery__
 *
 * To run a query within a React component, call `useStudentHealthNoteCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentHealthNoteCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentHealthNoteCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentHealthNoteCountQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentHealthNoteCountQuery, StudentHealthNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentHealthNoteCountQuery, StudentHealthNoteCountQueryVariables>(
		StudentHealthNoteCountDocument,
		options,
	);
}
export function useStudentHealthNoteCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentHealthNoteCountQuery, StudentHealthNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentHealthNoteCountQuery, StudentHealthNoteCountQueryVariables>(
		StudentHealthNoteCountDocument,
		options,
	);
}
export function useStudentHealthNoteCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentHealthNoteCountQuery, StudentHealthNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentHealthNoteCountQuery, StudentHealthNoteCountQueryVariables>(
		StudentHealthNoteCountDocument,
		options,
	);
}
export type StudentHealthNoteCountQueryHookResult = ReturnType<typeof useStudentHealthNoteCountQuery>;
export type StudentHealthNoteCountLazyQueryHookResult = ReturnType<typeof useStudentHealthNoteCountLazyQuery>;
export type StudentHealthNoteCountSuspenseQueryHookResult = ReturnType<typeof useStudentHealthNoteCountSuspenseQuery>;
export type StudentHealthNoteCountQueryResult = Apollo.QueryResult<
	StudentHealthNoteCountQuery,
	StudentHealthNoteCountQueryVariables
>;
export const StudentHealthNoteCreateDocument = gql`
	mutation studentHealthNoteCreate($input: StudentHealthNoteCreateInput!) {
		createStudentHealthNote(input: $input) {
			...StudentHealthNoteDetail
		}
	}
	${StudentHealthNoteDetailFragmentDoc}
`;
export type StudentHealthNoteCreateMutationFn = Apollo.MutationFunction<
	StudentHealthNoteCreateMutation,
	StudentHealthNoteCreateMutationVariables
>;

/**
 * __useStudentHealthNoteCreateMutation__
 *
 * To run a mutation, you first call `useStudentHealthNoteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentHealthNoteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentHealthNoteCreateMutation, { data, loading, error }] = useStudentHealthNoteCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentHealthNoteCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<StudentHealthNoteCreateMutation, StudentHealthNoteCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentHealthNoteCreateMutation, StudentHealthNoteCreateMutationVariables>(
		StudentHealthNoteCreateDocument,
		options,
	);
}
export type StudentHealthNoteCreateMutationHookResult = ReturnType<typeof useStudentHealthNoteCreateMutation>;
export type StudentHealthNoteCreateMutationResult = Apollo.MutationResult<StudentHealthNoteCreateMutation>;
export type StudentHealthNoteCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentHealthNoteCreateMutation,
	StudentHealthNoteCreateMutationVariables
>;
export const StudentHealthNoteDeleteDocument = gql`
	mutation studentHealthNoteDelete($id: ID!) {
		deleteStudentHealthNote(id: $id)
	}
`;
export type StudentHealthNoteDeleteMutationFn = Apollo.MutationFunction<
	StudentHealthNoteDeleteMutation,
	StudentHealthNoteDeleteMutationVariables
>;

/**
 * __useStudentHealthNoteDeleteMutation__
 *
 * To run a mutation, you first call `useStudentHealthNoteDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentHealthNoteDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentHealthNoteDeleteMutation, { data, loading, error }] = useStudentHealthNoteDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentHealthNoteDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<StudentHealthNoteDeleteMutation, StudentHealthNoteDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentHealthNoteDeleteMutation, StudentHealthNoteDeleteMutationVariables>(
		StudentHealthNoteDeleteDocument,
		options,
	);
}
export type StudentHealthNoteDeleteMutationHookResult = ReturnType<typeof useStudentHealthNoteDeleteMutation>;
export type StudentHealthNoteDeleteMutationResult = Apollo.MutationResult<StudentHealthNoteDeleteMutation>;
export type StudentHealthNoteDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentHealthNoteDeleteMutation,
	StudentHealthNoteDeleteMutationVariables
>;
export const StudentHealthNoteDetailDocument = gql`
	query studentHealthNoteDetail($id: ID!) {
		studentHealthNote(id: $id) {
			...StudentHealthNoteDetail
		}
	}
	${StudentHealthNoteDetailFragmentDoc}
`;

/**
 * __useStudentHealthNoteDetailQuery__
 *
 * To run a query within a React component, call `useStudentHealthNoteDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentHealthNoteDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentHealthNoteDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentHealthNoteDetailQuery(
	baseOptions: Apollo.QueryHookOptions<StudentHealthNoteDetailQuery, StudentHealthNoteDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentHealthNoteDetailQuery, StudentHealthNoteDetailQueryVariables>(
		StudentHealthNoteDetailDocument,
		options,
	);
}
export function useStudentHealthNoteDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentHealthNoteDetailQuery, StudentHealthNoteDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentHealthNoteDetailQuery, StudentHealthNoteDetailQueryVariables>(
		StudentHealthNoteDetailDocument,
		options,
	);
}
export function useStudentHealthNoteDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentHealthNoteDetailQuery, StudentHealthNoteDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentHealthNoteDetailQuery, StudentHealthNoteDetailQueryVariables>(
		StudentHealthNoteDetailDocument,
		options,
	);
}
export type StudentHealthNoteDetailQueryHookResult = ReturnType<typeof useStudentHealthNoteDetailQuery>;
export type StudentHealthNoteDetailLazyQueryHookResult = ReturnType<typeof useStudentHealthNoteDetailLazyQuery>;
export type StudentHealthNoteDetailSuspenseQueryHookResult = ReturnType<typeof useStudentHealthNoteDetailSuspenseQuery>;
export type StudentHealthNoteDetailQueryResult = Apollo.QueryResult<
	StudentHealthNoteDetailQuery,
	StudentHealthNoteDetailQueryVariables
>;
export const StudentHealthNoteIndexDocument = gql`
	query studentHealthNoteIndex(
		$filters: [StudentHealthNoteFilterInput!]
		$pagination: Pagination
		$order: StudentHealthNoteOrder
	) {
		studentHealthNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					body
				}
			}
		}
	}
`;

/**
 * __useStudentHealthNoteIndexQuery__
 *
 * To run a query within a React component, call `useStudentHealthNoteIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentHealthNoteIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentHealthNoteIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentHealthNoteIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentHealthNoteIndexQuery, StudentHealthNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentHealthNoteIndexQuery, StudentHealthNoteIndexQueryVariables>(
		StudentHealthNoteIndexDocument,
		options,
	);
}
export function useStudentHealthNoteIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentHealthNoteIndexQuery, StudentHealthNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentHealthNoteIndexQuery, StudentHealthNoteIndexQueryVariables>(
		StudentHealthNoteIndexDocument,
		options,
	);
}
export function useStudentHealthNoteIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentHealthNoteIndexQuery, StudentHealthNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentHealthNoteIndexQuery, StudentHealthNoteIndexQueryVariables>(
		StudentHealthNoteIndexDocument,
		options,
	);
}
export type StudentHealthNoteIndexQueryHookResult = ReturnType<typeof useStudentHealthNoteIndexQuery>;
export type StudentHealthNoteIndexLazyQueryHookResult = ReturnType<typeof useStudentHealthNoteIndexLazyQuery>;
export type StudentHealthNoteIndexSuspenseQueryHookResult = ReturnType<typeof useStudentHealthNoteIndexSuspenseQuery>;
export type StudentHealthNoteIndexQueryResult = Apollo.QueryResult<
	StudentHealthNoteIndexQuery,
	StudentHealthNoteIndexQueryVariables
>;
export const StudentHealthNoteNameDocument = gql`
	query studentHealthNoteName($id: ID!) {
		studentHealthNote(id: $id) {
			id
			...StudentHealthNoteName
		}
	}
	${StudentHealthNoteNameFragmentDoc}
`;

/**
 * __useStudentHealthNoteNameQuery__
 *
 * To run a query within a React component, call `useStudentHealthNoteNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentHealthNoteNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentHealthNoteNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentHealthNoteNameQuery(
	baseOptions: Apollo.QueryHookOptions<StudentHealthNoteNameQuery, StudentHealthNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentHealthNoteNameQuery, StudentHealthNoteNameQueryVariables>(
		StudentHealthNoteNameDocument,
		options,
	);
}
export function useStudentHealthNoteNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentHealthNoteNameQuery, StudentHealthNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentHealthNoteNameQuery, StudentHealthNoteNameQueryVariables>(
		StudentHealthNoteNameDocument,
		options,
	);
}
export function useStudentHealthNoteNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentHealthNoteNameQuery, StudentHealthNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentHealthNoteNameQuery, StudentHealthNoteNameQueryVariables>(
		StudentHealthNoteNameDocument,
		options,
	);
}
export type StudentHealthNoteNameQueryHookResult = ReturnType<typeof useStudentHealthNoteNameQuery>;
export type StudentHealthNoteNameLazyQueryHookResult = ReturnType<typeof useStudentHealthNoteNameLazyQuery>;
export type StudentHealthNoteNameSuspenseQueryHookResult = ReturnType<typeof useStudentHealthNoteNameSuspenseQuery>;
export type StudentHealthNoteNameQueryResult = Apollo.QueryResult<
	StudentHealthNoteNameQuery,
	StudentHealthNoteNameQueryVariables
>;
export const StudentHealthNoteNamesDocument = gql`
	query studentHealthNoteNames(
		$filters: [StudentHealthNoteFilterInput!]
		$pagination: Pagination
		$order: StudentHealthNoteOrder
	) {
		studentHealthNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentHealthNoteName
				}
			}
		}
	}
	${StudentHealthNoteNameFragmentDoc}
`;

/**
 * __useStudentHealthNoteNamesQuery__
 *
 * To run a query within a React component, call `useStudentHealthNoteNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentHealthNoteNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentHealthNoteNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentHealthNoteNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentHealthNoteNamesQuery, StudentHealthNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentHealthNoteNamesQuery, StudentHealthNoteNamesQueryVariables>(
		StudentHealthNoteNamesDocument,
		options,
	);
}
export function useStudentHealthNoteNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentHealthNoteNamesQuery, StudentHealthNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentHealthNoteNamesQuery, StudentHealthNoteNamesQueryVariables>(
		StudentHealthNoteNamesDocument,
		options,
	);
}
export function useStudentHealthNoteNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentHealthNoteNamesQuery, StudentHealthNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentHealthNoteNamesQuery, StudentHealthNoteNamesQueryVariables>(
		StudentHealthNoteNamesDocument,
		options,
	);
}
export type StudentHealthNoteNamesQueryHookResult = ReturnType<typeof useStudentHealthNoteNamesQuery>;
export type StudentHealthNoteNamesLazyQueryHookResult = ReturnType<typeof useStudentHealthNoteNamesLazyQuery>;
export type StudentHealthNoteNamesSuspenseQueryHookResult = ReturnType<typeof useStudentHealthNoteNamesSuspenseQuery>;
export type StudentHealthNoteNamesQueryResult = Apollo.QueryResult<
	StudentHealthNoteNamesQuery,
	StudentHealthNoteNamesQueryVariables
>;
export const StudentHealthNotePaginationDocument = gql`
	query studentHealthNotePagination($filters: [StudentHealthNoteFilterInput!], $order: StudentHealthNoteOrder) {
		studentHealthNoteConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentHealthNotePaginationQuery__
 *
 * To run a query within a React component, call `useStudentHealthNotePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentHealthNotePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentHealthNotePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentHealthNotePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentHealthNotePaginationQuery, StudentHealthNotePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentHealthNotePaginationQuery, StudentHealthNotePaginationQueryVariables>(
		StudentHealthNotePaginationDocument,
		options,
	);
}
export function useStudentHealthNotePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentHealthNotePaginationQuery,
		StudentHealthNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentHealthNotePaginationQuery, StudentHealthNotePaginationQueryVariables>(
		StudentHealthNotePaginationDocument,
		options,
	);
}
export function useStudentHealthNotePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentHealthNotePaginationQuery,
		StudentHealthNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentHealthNotePaginationQuery, StudentHealthNotePaginationQueryVariables>(
		StudentHealthNotePaginationDocument,
		options,
	);
}
export type StudentHealthNotePaginationQueryHookResult = ReturnType<typeof useStudentHealthNotePaginationQuery>;
export type StudentHealthNotePaginationLazyQueryHookResult = ReturnType<typeof useStudentHealthNotePaginationLazyQuery>;
export type StudentHealthNotePaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentHealthNotePaginationSuspenseQuery
>;
export type StudentHealthNotePaginationQueryResult = Apollo.QueryResult<
	StudentHealthNotePaginationQuery,
	StudentHealthNotePaginationQueryVariables
>;
export const StudentHealthNoteSelectDocument = gql`
	query studentHealthNoteSelect($filters: [StudentHealthNoteFilterInput!], $order: StudentHealthNoteOrder) {
		studentHealthNoteConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentHealthNoteName
				}
			}
		}
	}
	${StudentHealthNoteNameFragmentDoc}
`;

/**
 * __useStudentHealthNoteSelectQuery__
 *
 * To run a query within a React component, call `useStudentHealthNoteSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentHealthNoteSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentHealthNoteSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentHealthNoteSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentHealthNoteSelectQuery, StudentHealthNoteSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentHealthNoteSelectQuery, StudentHealthNoteSelectQueryVariables>(
		StudentHealthNoteSelectDocument,
		options,
	);
}
export function useStudentHealthNoteSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentHealthNoteSelectQuery, StudentHealthNoteSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentHealthNoteSelectQuery, StudentHealthNoteSelectQueryVariables>(
		StudentHealthNoteSelectDocument,
		options,
	);
}
export function useStudentHealthNoteSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentHealthNoteSelectQuery, StudentHealthNoteSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentHealthNoteSelectQuery, StudentHealthNoteSelectQueryVariables>(
		StudentHealthNoteSelectDocument,
		options,
	);
}
export type StudentHealthNoteSelectQueryHookResult = ReturnType<typeof useStudentHealthNoteSelectQuery>;
export type StudentHealthNoteSelectLazyQueryHookResult = ReturnType<typeof useStudentHealthNoteSelectLazyQuery>;
export type StudentHealthNoteSelectSuspenseQueryHookResult = ReturnType<typeof useStudentHealthNoteSelectSuspenseQuery>;
export type StudentHealthNoteSelectQueryResult = Apollo.QueryResult<
	StudentHealthNoteSelectQuery,
	StudentHealthNoteSelectQueryVariables
>;
export const StudentHealthNoteUpdateDocument = gql`
	mutation studentHealthNoteUpdate($id: ID!, $input: StudentHealthNoteUpdateInput!) {
		updateStudentHealthNote(id: $id, input: $input) {
			...StudentHealthNoteDetail
		}
	}
	${StudentHealthNoteDetailFragmentDoc}
`;
export type StudentHealthNoteUpdateMutationFn = Apollo.MutationFunction<
	StudentHealthNoteUpdateMutation,
	StudentHealthNoteUpdateMutationVariables
>;

/**
 * __useStudentHealthNoteUpdateMutation__
 *
 * To run a mutation, you first call `useStudentHealthNoteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentHealthNoteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentHealthNoteUpdateMutation, { data, loading, error }] = useStudentHealthNoteUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentHealthNoteUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<StudentHealthNoteUpdateMutation, StudentHealthNoteUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentHealthNoteUpdateMutation, StudentHealthNoteUpdateMutationVariables>(
		StudentHealthNoteUpdateDocument,
		options,
	);
}
export type StudentHealthNoteUpdateMutationHookResult = ReturnType<typeof useStudentHealthNoteUpdateMutation>;
export type StudentHealthNoteUpdateMutationResult = Apollo.MutationResult<StudentHealthNoteUpdateMutation>;
export type StudentHealthNoteUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentHealthNoteUpdateMutation,
	StudentHealthNoteUpdateMutationVariables
>;
export const StudentHomeRoomSectionEnrollmentCountDocument = gql`
	query studentHomeRoomSectionEnrollmentCount(
		$filters: [StudentHomeRoomSectionEnrollmentFilterInput!]
		$pagination: Pagination
		$order: StudentHomeRoomSectionEnrollmentOrder
	) {
		studentHomeRoomSectionEnrollmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentHomeRoomSectionEnrollmentCountQuery__
 *
 * To run a query within a React component, call `useStudentHomeRoomSectionEnrollmentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentHomeRoomSectionEnrollmentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentHomeRoomSectionEnrollmentCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentHomeRoomSectionEnrollmentCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentHomeRoomSectionEnrollmentCountQuery,
		StudentHomeRoomSectionEnrollmentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentHomeRoomSectionEnrollmentCountQuery,
		StudentHomeRoomSectionEnrollmentCountQueryVariables
	>(StudentHomeRoomSectionEnrollmentCountDocument, options);
}
export function useStudentHomeRoomSectionEnrollmentCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentHomeRoomSectionEnrollmentCountQuery,
		StudentHomeRoomSectionEnrollmentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentHomeRoomSectionEnrollmentCountQuery,
		StudentHomeRoomSectionEnrollmentCountQueryVariables
	>(StudentHomeRoomSectionEnrollmentCountDocument, options);
}
export function useStudentHomeRoomSectionEnrollmentCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentHomeRoomSectionEnrollmentCountQuery,
		StudentHomeRoomSectionEnrollmentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentHomeRoomSectionEnrollmentCountQuery,
		StudentHomeRoomSectionEnrollmentCountQueryVariables
	>(StudentHomeRoomSectionEnrollmentCountDocument, options);
}
export type StudentHomeRoomSectionEnrollmentCountQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentCountQuery
>;
export type StudentHomeRoomSectionEnrollmentCountLazyQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentCountLazyQuery
>;
export type StudentHomeRoomSectionEnrollmentCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentCountSuspenseQuery
>;
export type StudentHomeRoomSectionEnrollmentCountQueryResult = Apollo.QueryResult<
	StudentHomeRoomSectionEnrollmentCountQuery,
	StudentHomeRoomSectionEnrollmentCountQueryVariables
>;
export const StudentHomeRoomSectionEnrollmentCreateDocument = gql`
	mutation studentHomeRoomSectionEnrollmentCreate($input: StudentHomeRoomSectionEnrollmentCreateInput!) {
		createStudentHomeRoomSectionEnrollment(input: $input) {
			...StudentHomeRoomSectionEnrollmentDetail
		}
	}
	${StudentHomeRoomSectionEnrollmentDetailFragmentDoc}
`;
export type StudentHomeRoomSectionEnrollmentCreateMutationFn = Apollo.MutationFunction<
	StudentHomeRoomSectionEnrollmentCreateMutation,
	StudentHomeRoomSectionEnrollmentCreateMutationVariables
>;

/**
 * __useStudentHomeRoomSectionEnrollmentCreateMutation__
 *
 * To run a mutation, you first call `useStudentHomeRoomSectionEnrollmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentHomeRoomSectionEnrollmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentHomeRoomSectionEnrollmentCreateMutation, { data, loading, error }] = useStudentHomeRoomSectionEnrollmentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentHomeRoomSectionEnrollmentCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentHomeRoomSectionEnrollmentCreateMutation,
		StudentHomeRoomSectionEnrollmentCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentHomeRoomSectionEnrollmentCreateMutation,
		StudentHomeRoomSectionEnrollmentCreateMutationVariables
	>(StudentHomeRoomSectionEnrollmentCreateDocument, options);
}
export type StudentHomeRoomSectionEnrollmentCreateMutationHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentCreateMutation
>;
export type StudentHomeRoomSectionEnrollmentCreateMutationResult =
	Apollo.MutationResult<StudentHomeRoomSectionEnrollmentCreateMutation>;
export type StudentHomeRoomSectionEnrollmentCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentHomeRoomSectionEnrollmentCreateMutation,
	StudentHomeRoomSectionEnrollmentCreateMutationVariables
>;
export const StudentHomeRoomSectionEnrollmentDeleteDocument = gql`
	mutation studentHomeRoomSectionEnrollmentDelete($id: ID!) {
		deleteStudentHomeRoomSectionEnrollment(id: $id)
	}
`;
export type StudentHomeRoomSectionEnrollmentDeleteMutationFn = Apollo.MutationFunction<
	StudentHomeRoomSectionEnrollmentDeleteMutation,
	StudentHomeRoomSectionEnrollmentDeleteMutationVariables
>;

/**
 * __useStudentHomeRoomSectionEnrollmentDeleteMutation__
 *
 * To run a mutation, you first call `useStudentHomeRoomSectionEnrollmentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentHomeRoomSectionEnrollmentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentHomeRoomSectionEnrollmentDeleteMutation, { data, loading, error }] = useStudentHomeRoomSectionEnrollmentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentHomeRoomSectionEnrollmentDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentHomeRoomSectionEnrollmentDeleteMutation,
		StudentHomeRoomSectionEnrollmentDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentHomeRoomSectionEnrollmentDeleteMutation,
		StudentHomeRoomSectionEnrollmentDeleteMutationVariables
	>(StudentHomeRoomSectionEnrollmentDeleteDocument, options);
}
export type StudentHomeRoomSectionEnrollmentDeleteMutationHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentDeleteMutation
>;
export type StudentHomeRoomSectionEnrollmentDeleteMutationResult =
	Apollo.MutationResult<StudentHomeRoomSectionEnrollmentDeleteMutation>;
export type StudentHomeRoomSectionEnrollmentDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentHomeRoomSectionEnrollmentDeleteMutation,
	StudentHomeRoomSectionEnrollmentDeleteMutationVariables
>;
export const StudentHomeRoomSectionEnrollmentDetailDocument = gql`
	query studentHomeRoomSectionEnrollmentDetail($id: ID!) {
		studentHomeRoomSectionEnrollment(id: $id) {
			...StudentHomeRoomSectionEnrollmentDetail
		}
	}
	${StudentHomeRoomSectionEnrollmentDetailFragmentDoc}
`;

/**
 * __useStudentHomeRoomSectionEnrollmentDetailQuery__
 *
 * To run a query within a React component, call `useStudentHomeRoomSectionEnrollmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentHomeRoomSectionEnrollmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentHomeRoomSectionEnrollmentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentHomeRoomSectionEnrollmentDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentHomeRoomSectionEnrollmentDetailQuery,
		StudentHomeRoomSectionEnrollmentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentHomeRoomSectionEnrollmentDetailQuery,
		StudentHomeRoomSectionEnrollmentDetailQueryVariables
	>(StudentHomeRoomSectionEnrollmentDetailDocument, options);
}
export function useStudentHomeRoomSectionEnrollmentDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentHomeRoomSectionEnrollmentDetailQuery,
		StudentHomeRoomSectionEnrollmentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentHomeRoomSectionEnrollmentDetailQuery,
		StudentHomeRoomSectionEnrollmentDetailQueryVariables
	>(StudentHomeRoomSectionEnrollmentDetailDocument, options);
}
export function useStudentHomeRoomSectionEnrollmentDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentHomeRoomSectionEnrollmentDetailQuery,
		StudentHomeRoomSectionEnrollmentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentHomeRoomSectionEnrollmentDetailQuery,
		StudentHomeRoomSectionEnrollmentDetailQueryVariables
	>(StudentHomeRoomSectionEnrollmentDetailDocument, options);
}
export type StudentHomeRoomSectionEnrollmentDetailQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentDetailQuery
>;
export type StudentHomeRoomSectionEnrollmentDetailLazyQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentDetailLazyQuery
>;
export type StudentHomeRoomSectionEnrollmentDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentDetailSuspenseQuery
>;
export type StudentHomeRoomSectionEnrollmentDetailQueryResult = Apollo.QueryResult<
	StudentHomeRoomSectionEnrollmentDetailQuery,
	StudentHomeRoomSectionEnrollmentDetailQueryVariables
>;
export const StudentHomeRoomSectionEnrollmentIndexDocument = gql`
	query studentHomeRoomSectionEnrollmentIndex(
		$filters: [StudentHomeRoomSectionEnrollmentFilterInput!]
		$pagination: Pagination
		$order: StudentHomeRoomSectionEnrollmentOrder
	) {
		studentHomeRoomSectionEnrollmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					lateStartDate
					earlyEndDate
				}
			}
		}
	}
`;

/**
 * __useStudentHomeRoomSectionEnrollmentIndexQuery__
 *
 * To run a query within a React component, call `useStudentHomeRoomSectionEnrollmentIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentHomeRoomSectionEnrollmentIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentHomeRoomSectionEnrollmentIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentHomeRoomSectionEnrollmentIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentHomeRoomSectionEnrollmentIndexQuery,
		StudentHomeRoomSectionEnrollmentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentHomeRoomSectionEnrollmentIndexQuery,
		StudentHomeRoomSectionEnrollmentIndexQueryVariables
	>(StudentHomeRoomSectionEnrollmentIndexDocument, options);
}
export function useStudentHomeRoomSectionEnrollmentIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentHomeRoomSectionEnrollmentIndexQuery,
		StudentHomeRoomSectionEnrollmentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentHomeRoomSectionEnrollmentIndexQuery,
		StudentHomeRoomSectionEnrollmentIndexQueryVariables
	>(StudentHomeRoomSectionEnrollmentIndexDocument, options);
}
export function useStudentHomeRoomSectionEnrollmentIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentHomeRoomSectionEnrollmentIndexQuery,
		StudentHomeRoomSectionEnrollmentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentHomeRoomSectionEnrollmentIndexQuery,
		StudentHomeRoomSectionEnrollmentIndexQueryVariables
	>(StudentHomeRoomSectionEnrollmentIndexDocument, options);
}
export type StudentHomeRoomSectionEnrollmentIndexQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentIndexQuery
>;
export type StudentHomeRoomSectionEnrollmentIndexLazyQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentIndexLazyQuery
>;
export type StudentHomeRoomSectionEnrollmentIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentIndexSuspenseQuery
>;
export type StudentHomeRoomSectionEnrollmentIndexQueryResult = Apollo.QueryResult<
	StudentHomeRoomSectionEnrollmentIndexQuery,
	StudentHomeRoomSectionEnrollmentIndexQueryVariables
>;
export const StudentHomeRoomSectionEnrollmentNameDocument = gql`
	query studentHomeRoomSectionEnrollmentName($id: ID!) {
		studentHomeRoomSectionEnrollment(id: $id) {
			id
			...StudentHomeRoomSectionEnrollmentName
		}
	}
	${StudentHomeRoomSectionEnrollmentNameFragmentDoc}
`;

/**
 * __useStudentHomeRoomSectionEnrollmentNameQuery__
 *
 * To run a query within a React component, call `useStudentHomeRoomSectionEnrollmentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentHomeRoomSectionEnrollmentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentHomeRoomSectionEnrollmentNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentHomeRoomSectionEnrollmentNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentHomeRoomSectionEnrollmentNameQuery,
		StudentHomeRoomSectionEnrollmentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentHomeRoomSectionEnrollmentNameQuery, StudentHomeRoomSectionEnrollmentNameQueryVariables>(
		StudentHomeRoomSectionEnrollmentNameDocument,
		options,
	);
}
export function useStudentHomeRoomSectionEnrollmentNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentHomeRoomSectionEnrollmentNameQuery,
		StudentHomeRoomSectionEnrollmentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentHomeRoomSectionEnrollmentNameQuery,
		StudentHomeRoomSectionEnrollmentNameQueryVariables
	>(StudentHomeRoomSectionEnrollmentNameDocument, options);
}
export function useStudentHomeRoomSectionEnrollmentNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentHomeRoomSectionEnrollmentNameQuery,
		StudentHomeRoomSectionEnrollmentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentHomeRoomSectionEnrollmentNameQuery,
		StudentHomeRoomSectionEnrollmentNameQueryVariables
	>(StudentHomeRoomSectionEnrollmentNameDocument, options);
}
export type StudentHomeRoomSectionEnrollmentNameQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentNameQuery
>;
export type StudentHomeRoomSectionEnrollmentNameLazyQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentNameLazyQuery
>;
export type StudentHomeRoomSectionEnrollmentNameSuspenseQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentNameSuspenseQuery
>;
export type StudentHomeRoomSectionEnrollmentNameQueryResult = Apollo.QueryResult<
	StudentHomeRoomSectionEnrollmentNameQuery,
	StudentHomeRoomSectionEnrollmentNameQueryVariables
>;
export const StudentHomeRoomSectionEnrollmentNamesDocument = gql`
	query studentHomeRoomSectionEnrollmentNames(
		$filters: [StudentHomeRoomSectionEnrollmentFilterInput!]
		$pagination: Pagination
		$order: StudentHomeRoomSectionEnrollmentOrder
	) {
		studentHomeRoomSectionEnrollmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentHomeRoomSectionEnrollmentName
				}
			}
		}
	}
	${StudentHomeRoomSectionEnrollmentNameFragmentDoc}
`;

/**
 * __useStudentHomeRoomSectionEnrollmentNamesQuery__
 *
 * To run a query within a React component, call `useStudentHomeRoomSectionEnrollmentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentHomeRoomSectionEnrollmentNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentHomeRoomSectionEnrollmentNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentHomeRoomSectionEnrollmentNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentHomeRoomSectionEnrollmentNamesQuery,
		StudentHomeRoomSectionEnrollmentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentHomeRoomSectionEnrollmentNamesQuery,
		StudentHomeRoomSectionEnrollmentNamesQueryVariables
	>(StudentHomeRoomSectionEnrollmentNamesDocument, options);
}
export function useStudentHomeRoomSectionEnrollmentNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentHomeRoomSectionEnrollmentNamesQuery,
		StudentHomeRoomSectionEnrollmentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentHomeRoomSectionEnrollmentNamesQuery,
		StudentHomeRoomSectionEnrollmentNamesQueryVariables
	>(StudentHomeRoomSectionEnrollmentNamesDocument, options);
}
export function useStudentHomeRoomSectionEnrollmentNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentHomeRoomSectionEnrollmentNamesQuery,
		StudentHomeRoomSectionEnrollmentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentHomeRoomSectionEnrollmentNamesQuery,
		StudentHomeRoomSectionEnrollmentNamesQueryVariables
	>(StudentHomeRoomSectionEnrollmentNamesDocument, options);
}
export type StudentHomeRoomSectionEnrollmentNamesQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentNamesQuery
>;
export type StudentHomeRoomSectionEnrollmentNamesLazyQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentNamesLazyQuery
>;
export type StudentHomeRoomSectionEnrollmentNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentNamesSuspenseQuery
>;
export type StudentHomeRoomSectionEnrollmentNamesQueryResult = Apollo.QueryResult<
	StudentHomeRoomSectionEnrollmentNamesQuery,
	StudentHomeRoomSectionEnrollmentNamesQueryVariables
>;
export const StudentHomeRoomSectionEnrollmentPaginationDocument = gql`
	query studentHomeRoomSectionEnrollmentPagination(
		$filters: [StudentHomeRoomSectionEnrollmentFilterInput!]
		$order: StudentHomeRoomSectionEnrollmentOrder
	) {
		studentHomeRoomSectionEnrollmentConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentHomeRoomSectionEnrollmentPaginationQuery__
 *
 * To run a query within a React component, call `useStudentHomeRoomSectionEnrollmentPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentHomeRoomSectionEnrollmentPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentHomeRoomSectionEnrollmentPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentHomeRoomSectionEnrollmentPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentHomeRoomSectionEnrollmentPaginationQuery,
		StudentHomeRoomSectionEnrollmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentHomeRoomSectionEnrollmentPaginationQuery,
		StudentHomeRoomSectionEnrollmentPaginationQueryVariables
	>(StudentHomeRoomSectionEnrollmentPaginationDocument, options);
}
export function useStudentHomeRoomSectionEnrollmentPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentHomeRoomSectionEnrollmentPaginationQuery,
		StudentHomeRoomSectionEnrollmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentHomeRoomSectionEnrollmentPaginationQuery,
		StudentHomeRoomSectionEnrollmentPaginationQueryVariables
	>(StudentHomeRoomSectionEnrollmentPaginationDocument, options);
}
export function useStudentHomeRoomSectionEnrollmentPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentHomeRoomSectionEnrollmentPaginationQuery,
		StudentHomeRoomSectionEnrollmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentHomeRoomSectionEnrollmentPaginationQuery,
		StudentHomeRoomSectionEnrollmentPaginationQueryVariables
	>(StudentHomeRoomSectionEnrollmentPaginationDocument, options);
}
export type StudentHomeRoomSectionEnrollmentPaginationQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentPaginationQuery
>;
export type StudentHomeRoomSectionEnrollmentPaginationLazyQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentPaginationLazyQuery
>;
export type StudentHomeRoomSectionEnrollmentPaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentPaginationSuspenseQuery
>;
export type StudentHomeRoomSectionEnrollmentPaginationQueryResult = Apollo.QueryResult<
	StudentHomeRoomSectionEnrollmentPaginationQuery,
	StudentHomeRoomSectionEnrollmentPaginationQueryVariables
>;
export const StudentHomeRoomSectionEnrollmentSelectDocument = gql`
	query studentHomeRoomSectionEnrollmentSelect(
		$filters: [StudentHomeRoomSectionEnrollmentFilterInput!]
		$order: StudentHomeRoomSectionEnrollmentOrder
	) {
		studentHomeRoomSectionEnrollmentConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentHomeRoomSectionEnrollmentName
				}
			}
		}
	}
	${StudentHomeRoomSectionEnrollmentNameFragmentDoc}
`;

/**
 * __useStudentHomeRoomSectionEnrollmentSelectQuery__
 *
 * To run a query within a React component, call `useStudentHomeRoomSectionEnrollmentSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentHomeRoomSectionEnrollmentSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentHomeRoomSectionEnrollmentSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentHomeRoomSectionEnrollmentSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentHomeRoomSectionEnrollmentSelectQuery,
		StudentHomeRoomSectionEnrollmentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentHomeRoomSectionEnrollmentSelectQuery,
		StudentHomeRoomSectionEnrollmentSelectQueryVariables
	>(StudentHomeRoomSectionEnrollmentSelectDocument, options);
}
export function useStudentHomeRoomSectionEnrollmentSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentHomeRoomSectionEnrollmentSelectQuery,
		StudentHomeRoomSectionEnrollmentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentHomeRoomSectionEnrollmentSelectQuery,
		StudentHomeRoomSectionEnrollmentSelectQueryVariables
	>(StudentHomeRoomSectionEnrollmentSelectDocument, options);
}
export function useStudentHomeRoomSectionEnrollmentSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentHomeRoomSectionEnrollmentSelectQuery,
		StudentHomeRoomSectionEnrollmentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentHomeRoomSectionEnrollmentSelectQuery,
		StudentHomeRoomSectionEnrollmentSelectQueryVariables
	>(StudentHomeRoomSectionEnrollmentSelectDocument, options);
}
export type StudentHomeRoomSectionEnrollmentSelectQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentSelectQuery
>;
export type StudentHomeRoomSectionEnrollmentSelectLazyQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentSelectLazyQuery
>;
export type StudentHomeRoomSectionEnrollmentSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentSelectSuspenseQuery
>;
export type StudentHomeRoomSectionEnrollmentSelectQueryResult = Apollo.QueryResult<
	StudentHomeRoomSectionEnrollmentSelectQuery,
	StudentHomeRoomSectionEnrollmentSelectQueryVariables
>;
export const StudentHomeRoomSectionEnrollmentUpdateDocument = gql`
	mutation studentHomeRoomSectionEnrollmentUpdate($id: ID!, $input: StudentHomeRoomSectionEnrollmentUpdateInput!) {
		updateStudentHomeRoomSectionEnrollment(id: $id, input: $input) {
			...StudentHomeRoomSectionEnrollmentDetail
		}
	}
	${StudentHomeRoomSectionEnrollmentDetailFragmentDoc}
`;
export type StudentHomeRoomSectionEnrollmentUpdateMutationFn = Apollo.MutationFunction<
	StudentHomeRoomSectionEnrollmentUpdateMutation,
	StudentHomeRoomSectionEnrollmentUpdateMutationVariables
>;

/**
 * __useStudentHomeRoomSectionEnrollmentUpdateMutation__
 *
 * To run a mutation, you first call `useStudentHomeRoomSectionEnrollmentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentHomeRoomSectionEnrollmentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentHomeRoomSectionEnrollmentUpdateMutation, { data, loading, error }] = useStudentHomeRoomSectionEnrollmentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentHomeRoomSectionEnrollmentUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentHomeRoomSectionEnrollmentUpdateMutation,
		StudentHomeRoomSectionEnrollmentUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentHomeRoomSectionEnrollmentUpdateMutation,
		StudentHomeRoomSectionEnrollmentUpdateMutationVariables
	>(StudentHomeRoomSectionEnrollmentUpdateDocument, options);
}
export type StudentHomeRoomSectionEnrollmentUpdateMutationHookResult = ReturnType<
	typeof useStudentHomeRoomSectionEnrollmentUpdateMutation
>;
export type StudentHomeRoomSectionEnrollmentUpdateMutationResult =
	Apollo.MutationResult<StudentHomeRoomSectionEnrollmentUpdateMutation>;
export type StudentHomeRoomSectionEnrollmentUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentHomeRoomSectionEnrollmentUpdateMutation,
	StudentHomeRoomSectionEnrollmentUpdateMutationVariables
>;
export const StudentIncidentNoteCountDocument = gql`
	query studentIncidentNoteCount(
		$filters: [StudentIncidentNoteFilterInput!]
		$pagination: Pagination
		$order: StudentIncidentNoteOrder
	) {
		studentIncidentNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentIncidentNoteCountQuery__
 *
 * To run a query within a React component, call `useStudentIncidentNoteCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentIncidentNoteCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentIncidentNoteCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentIncidentNoteCountQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentIncidentNoteCountQuery, StudentIncidentNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentIncidentNoteCountQuery, StudentIncidentNoteCountQueryVariables>(
		StudentIncidentNoteCountDocument,
		options,
	);
}
export function useStudentIncidentNoteCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentIncidentNoteCountQuery, StudentIncidentNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentIncidentNoteCountQuery, StudentIncidentNoteCountQueryVariables>(
		StudentIncidentNoteCountDocument,
		options,
	);
}
export function useStudentIncidentNoteCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentIncidentNoteCountQuery, StudentIncidentNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentIncidentNoteCountQuery, StudentIncidentNoteCountQueryVariables>(
		StudentIncidentNoteCountDocument,
		options,
	);
}
export type StudentIncidentNoteCountQueryHookResult = ReturnType<typeof useStudentIncidentNoteCountQuery>;
export type StudentIncidentNoteCountLazyQueryHookResult = ReturnType<typeof useStudentIncidentNoteCountLazyQuery>;
export type StudentIncidentNoteCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentIncidentNoteCountSuspenseQuery
>;
export type StudentIncidentNoteCountQueryResult = Apollo.QueryResult<
	StudentIncidentNoteCountQuery,
	StudentIncidentNoteCountQueryVariables
>;
export const StudentIncidentNoteCreateDocument = gql`
	mutation studentIncidentNoteCreate($input: StudentIncidentNoteCreateInput!) {
		createStudentIncidentNote(input: $input) {
			...StudentIncidentNoteDetail
		}
	}
	${StudentIncidentNoteDetailFragmentDoc}
`;
export type StudentIncidentNoteCreateMutationFn = Apollo.MutationFunction<
	StudentIncidentNoteCreateMutation,
	StudentIncidentNoteCreateMutationVariables
>;

/**
 * __useStudentIncidentNoteCreateMutation__
 *
 * To run a mutation, you first call `useStudentIncidentNoteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentIncidentNoteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentIncidentNoteCreateMutation, { data, loading, error }] = useStudentIncidentNoteCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentIncidentNoteCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentIncidentNoteCreateMutation,
		StudentIncidentNoteCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentIncidentNoteCreateMutation, StudentIncidentNoteCreateMutationVariables>(
		StudentIncidentNoteCreateDocument,
		options,
	);
}
export type StudentIncidentNoteCreateMutationHookResult = ReturnType<typeof useStudentIncidentNoteCreateMutation>;
export type StudentIncidentNoteCreateMutationResult = Apollo.MutationResult<StudentIncidentNoteCreateMutation>;
export type StudentIncidentNoteCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentIncidentNoteCreateMutation,
	StudentIncidentNoteCreateMutationVariables
>;
export const StudentIncidentNoteDeleteDocument = gql`
	mutation studentIncidentNoteDelete($id: ID!) {
		deleteStudentIncidentNote(id: $id)
	}
`;
export type StudentIncidentNoteDeleteMutationFn = Apollo.MutationFunction<
	StudentIncidentNoteDeleteMutation,
	StudentIncidentNoteDeleteMutationVariables
>;

/**
 * __useStudentIncidentNoteDeleteMutation__
 *
 * To run a mutation, you first call `useStudentIncidentNoteDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentIncidentNoteDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentIncidentNoteDeleteMutation, { data, loading, error }] = useStudentIncidentNoteDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentIncidentNoteDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentIncidentNoteDeleteMutation,
		StudentIncidentNoteDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentIncidentNoteDeleteMutation, StudentIncidentNoteDeleteMutationVariables>(
		StudentIncidentNoteDeleteDocument,
		options,
	);
}
export type StudentIncidentNoteDeleteMutationHookResult = ReturnType<typeof useStudentIncidentNoteDeleteMutation>;
export type StudentIncidentNoteDeleteMutationResult = Apollo.MutationResult<StudentIncidentNoteDeleteMutation>;
export type StudentIncidentNoteDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentIncidentNoteDeleteMutation,
	StudentIncidentNoteDeleteMutationVariables
>;
export const StudentIncidentNoteDetailDocument = gql`
	query studentIncidentNoteDetail($id: ID!) {
		studentIncidentNote(id: $id) {
			...StudentIncidentNoteDetail
		}
	}
	${StudentIncidentNoteDetailFragmentDoc}
`;

/**
 * __useStudentIncidentNoteDetailQuery__
 *
 * To run a query within a React component, call `useStudentIncidentNoteDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentIncidentNoteDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentIncidentNoteDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentIncidentNoteDetailQuery(
	baseOptions: Apollo.QueryHookOptions<StudentIncidentNoteDetailQuery, StudentIncidentNoteDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentIncidentNoteDetailQuery, StudentIncidentNoteDetailQueryVariables>(
		StudentIncidentNoteDetailDocument,
		options,
	);
}
export function useStudentIncidentNoteDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentIncidentNoteDetailQuery, StudentIncidentNoteDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentIncidentNoteDetailQuery, StudentIncidentNoteDetailQueryVariables>(
		StudentIncidentNoteDetailDocument,
		options,
	);
}
export function useStudentIncidentNoteDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentIncidentNoteDetailQuery,
		StudentIncidentNoteDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentIncidentNoteDetailQuery, StudentIncidentNoteDetailQueryVariables>(
		StudentIncidentNoteDetailDocument,
		options,
	);
}
export type StudentIncidentNoteDetailQueryHookResult = ReturnType<typeof useStudentIncidentNoteDetailQuery>;
export type StudentIncidentNoteDetailLazyQueryHookResult = ReturnType<typeof useStudentIncidentNoteDetailLazyQuery>;
export type StudentIncidentNoteDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentIncidentNoteDetailSuspenseQuery
>;
export type StudentIncidentNoteDetailQueryResult = Apollo.QueryResult<
	StudentIncidentNoteDetailQuery,
	StudentIncidentNoteDetailQueryVariables
>;
export const StudentIncidentNoteIndexDocument = gql`
	query studentIncidentNoteIndex(
		$filters: [StudentIncidentNoteFilterInput!]
		$pagination: Pagination
		$order: StudentIncidentNoteOrder
	) {
		studentIncidentNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					incidentTime
					incidentLocation
					actionsTaken
					suggestionsForFuture
				}
			}
		}
	}
`;

/**
 * __useStudentIncidentNoteIndexQuery__
 *
 * To run a query within a React component, call `useStudentIncidentNoteIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentIncidentNoteIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentIncidentNoteIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentIncidentNoteIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentIncidentNoteIndexQuery, StudentIncidentNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentIncidentNoteIndexQuery, StudentIncidentNoteIndexQueryVariables>(
		StudentIncidentNoteIndexDocument,
		options,
	);
}
export function useStudentIncidentNoteIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentIncidentNoteIndexQuery, StudentIncidentNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentIncidentNoteIndexQuery, StudentIncidentNoteIndexQueryVariables>(
		StudentIncidentNoteIndexDocument,
		options,
	);
}
export function useStudentIncidentNoteIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentIncidentNoteIndexQuery, StudentIncidentNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentIncidentNoteIndexQuery, StudentIncidentNoteIndexQueryVariables>(
		StudentIncidentNoteIndexDocument,
		options,
	);
}
export type StudentIncidentNoteIndexQueryHookResult = ReturnType<typeof useStudentIncidentNoteIndexQuery>;
export type StudentIncidentNoteIndexLazyQueryHookResult = ReturnType<typeof useStudentIncidentNoteIndexLazyQuery>;
export type StudentIncidentNoteIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentIncidentNoteIndexSuspenseQuery
>;
export type StudentIncidentNoteIndexQueryResult = Apollo.QueryResult<
	StudentIncidentNoteIndexQuery,
	StudentIncidentNoteIndexQueryVariables
>;
export const StudentIncidentNoteNameDocument = gql`
	query studentIncidentNoteName($id: ID!) {
		studentIncidentNote(id: $id) {
			id
			...StudentIncidentNoteName
		}
	}
	${StudentIncidentNoteNameFragmentDoc}
`;

/**
 * __useStudentIncidentNoteNameQuery__
 *
 * To run a query within a React component, call `useStudentIncidentNoteNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentIncidentNoteNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentIncidentNoteNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentIncidentNoteNameQuery(
	baseOptions: Apollo.QueryHookOptions<StudentIncidentNoteNameQuery, StudentIncidentNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentIncidentNoteNameQuery, StudentIncidentNoteNameQueryVariables>(
		StudentIncidentNoteNameDocument,
		options,
	);
}
export function useStudentIncidentNoteNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentIncidentNoteNameQuery, StudentIncidentNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentIncidentNoteNameQuery, StudentIncidentNoteNameQueryVariables>(
		StudentIncidentNoteNameDocument,
		options,
	);
}
export function useStudentIncidentNoteNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentIncidentNoteNameQuery, StudentIncidentNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentIncidentNoteNameQuery, StudentIncidentNoteNameQueryVariables>(
		StudentIncidentNoteNameDocument,
		options,
	);
}
export type StudentIncidentNoteNameQueryHookResult = ReturnType<typeof useStudentIncidentNoteNameQuery>;
export type StudentIncidentNoteNameLazyQueryHookResult = ReturnType<typeof useStudentIncidentNoteNameLazyQuery>;
export type StudentIncidentNoteNameSuspenseQueryHookResult = ReturnType<typeof useStudentIncidentNoteNameSuspenseQuery>;
export type StudentIncidentNoteNameQueryResult = Apollo.QueryResult<
	StudentIncidentNoteNameQuery,
	StudentIncidentNoteNameQueryVariables
>;
export const StudentIncidentNoteNamesDocument = gql`
	query studentIncidentNoteNames(
		$filters: [StudentIncidentNoteFilterInput!]
		$pagination: Pagination
		$order: StudentIncidentNoteOrder
	) {
		studentIncidentNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentIncidentNoteName
				}
			}
		}
	}
	${StudentIncidentNoteNameFragmentDoc}
`;

/**
 * __useStudentIncidentNoteNamesQuery__
 *
 * To run a query within a React component, call `useStudentIncidentNoteNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentIncidentNoteNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentIncidentNoteNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentIncidentNoteNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentIncidentNoteNamesQuery, StudentIncidentNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentIncidentNoteNamesQuery, StudentIncidentNoteNamesQueryVariables>(
		StudentIncidentNoteNamesDocument,
		options,
	);
}
export function useStudentIncidentNoteNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentIncidentNoteNamesQuery, StudentIncidentNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentIncidentNoteNamesQuery, StudentIncidentNoteNamesQueryVariables>(
		StudentIncidentNoteNamesDocument,
		options,
	);
}
export function useStudentIncidentNoteNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentIncidentNoteNamesQuery, StudentIncidentNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentIncidentNoteNamesQuery, StudentIncidentNoteNamesQueryVariables>(
		StudentIncidentNoteNamesDocument,
		options,
	);
}
export type StudentIncidentNoteNamesQueryHookResult = ReturnType<typeof useStudentIncidentNoteNamesQuery>;
export type StudentIncidentNoteNamesLazyQueryHookResult = ReturnType<typeof useStudentIncidentNoteNamesLazyQuery>;
export type StudentIncidentNoteNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentIncidentNoteNamesSuspenseQuery
>;
export type StudentIncidentNoteNamesQueryResult = Apollo.QueryResult<
	StudentIncidentNoteNamesQuery,
	StudentIncidentNoteNamesQueryVariables
>;
export const StudentIncidentNotePaginationDocument = gql`
	query studentIncidentNotePagination($filters: [StudentIncidentNoteFilterInput!], $order: StudentIncidentNoteOrder) {
		studentIncidentNoteConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentIncidentNotePaginationQuery__
 *
 * To run a query within a React component, call `useStudentIncidentNotePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentIncidentNotePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentIncidentNotePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentIncidentNotePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentIncidentNotePaginationQuery,
		StudentIncidentNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentIncidentNotePaginationQuery, StudentIncidentNotePaginationQueryVariables>(
		StudentIncidentNotePaginationDocument,
		options,
	);
}
export function useStudentIncidentNotePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentIncidentNotePaginationQuery,
		StudentIncidentNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentIncidentNotePaginationQuery, StudentIncidentNotePaginationQueryVariables>(
		StudentIncidentNotePaginationDocument,
		options,
	);
}
export function useStudentIncidentNotePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentIncidentNotePaginationQuery,
		StudentIncidentNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentIncidentNotePaginationQuery, StudentIncidentNotePaginationQueryVariables>(
		StudentIncidentNotePaginationDocument,
		options,
	);
}
export type StudentIncidentNotePaginationQueryHookResult = ReturnType<typeof useStudentIncidentNotePaginationQuery>;
export type StudentIncidentNotePaginationLazyQueryHookResult = ReturnType<
	typeof useStudentIncidentNotePaginationLazyQuery
>;
export type StudentIncidentNotePaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentIncidentNotePaginationSuspenseQuery
>;
export type StudentIncidentNotePaginationQueryResult = Apollo.QueryResult<
	StudentIncidentNotePaginationQuery,
	StudentIncidentNotePaginationQueryVariables
>;
export const StudentIncidentNoteSelectDocument = gql`
	query studentIncidentNoteSelect($filters: [StudentIncidentNoteFilterInput!], $order: StudentIncidentNoteOrder) {
		studentIncidentNoteConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentIncidentNoteName
				}
			}
		}
	}
	${StudentIncidentNoteNameFragmentDoc}
`;

/**
 * __useStudentIncidentNoteSelectQuery__
 *
 * To run a query within a React component, call `useStudentIncidentNoteSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentIncidentNoteSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentIncidentNoteSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentIncidentNoteSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentIncidentNoteSelectQuery, StudentIncidentNoteSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentIncidentNoteSelectQuery, StudentIncidentNoteSelectQueryVariables>(
		StudentIncidentNoteSelectDocument,
		options,
	);
}
export function useStudentIncidentNoteSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentIncidentNoteSelectQuery, StudentIncidentNoteSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentIncidentNoteSelectQuery, StudentIncidentNoteSelectQueryVariables>(
		StudentIncidentNoteSelectDocument,
		options,
	);
}
export function useStudentIncidentNoteSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentIncidentNoteSelectQuery,
		StudentIncidentNoteSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentIncidentNoteSelectQuery, StudentIncidentNoteSelectQueryVariables>(
		StudentIncidentNoteSelectDocument,
		options,
	);
}
export type StudentIncidentNoteSelectQueryHookResult = ReturnType<typeof useStudentIncidentNoteSelectQuery>;
export type StudentIncidentNoteSelectLazyQueryHookResult = ReturnType<typeof useStudentIncidentNoteSelectLazyQuery>;
export type StudentIncidentNoteSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentIncidentNoteSelectSuspenseQuery
>;
export type StudentIncidentNoteSelectQueryResult = Apollo.QueryResult<
	StudentIncidentNoteSelectQuery,
	StudentIncidentNoteSelectQueryVariables
>;
export const StudentIncidentNoteUpdateDocument = gql`
	mutation studentIncidentNoteUpdate($id: ID!, $input: StudentIncidentNoteUpdateInput!) {
		updateStudentIncidentNote(id: $id, input: $input) {
			...StudentIncidentNoteDetail
		}
	}
	${StudentIncidentNoteDetailFragmentDoc}
`;
export type StudentIncidentNoteUpdateMutationFn = Apollo.MutationFunction<
	StudentIncidentNoteUpdateMutation,
	StudentIncidentNoteUpdateMutationVariables
>;

/**
 * __useStudentIncidentNoteUpdateMutation__
 *
 * To run a mutation, you first call `useStudentIncidentNoteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentIncidentNoteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentIncidentNoteUpdateMutation, { data, loading, error }] = useStudentIncidentNoteUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentIncidentNoteUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentIncidentNoteUpdateMutation,
		StudentIncidentNoteUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentIncidentNoteUpdateMutation, StudentIncidentNoteUpdateMutationVariables>(
		StudentIncidentNoteUpdateDocument,
		options,
	);
}
export type StudentIncidentNoteUpdateMutationHookResult = ReturnType<typeof useStudentIncidentNoteUpdateMutation>;
export type StudentIncidentNoteUpdateMutationResult = Apollo.MutationResult<StudentIncidentNoteUpdateMutation>;
export type StudentIncidentNoteUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentIncidentNoteUpdateMutation,
	StudentIncidentNoteUpdateMutationVariables
>;
export const StudentInformationVerificationCountDocument = gql`
	query studentInformationVerificationCount(
		$filters: [StudentInformationVerificationFilterInput!]
		$pagination: Pagination
		$order: StudentInformationVerificationOrder
	) {
		studentInformationVerificationConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentInformationVerificationCountQuery__
 *
 * To run a query within a React component, call `useStudentInformationVerificationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentInformationVerificationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentInformationVerificationCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentInformationVerificationCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentInformationVerificationCountQuery,
		StudentInformationVerificationCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentInformationVerificationCountQuery, StudentInformationVerificationCountQueryVariables>(
		StudentInformationVerificationCountDocument,
		options,
	);
}
export function useStudentInformationVerificationCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentInformationVerificationCountQuery,
		StudentInformationVerificationCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentInformationVerificationCountQuery,
		StudentInformationVerificationCountQueryVariables
	>(StudentInformationVerificationCountDocument, options);
}
export function useStudentInformationVerificationCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentInformationVerificationCountQuery,
		StudentInformationVerificationCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentInformationVerificationCountQuery,
		StudentInformationVerificationCountQueryVariables
	>(StudentInformationVerificationCountDocument, options);
}
export type StudentInformationVerificationCountQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationCountQuery
>;
export type StudentInformationVerificationCountLazyQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationCountLazyQuery
>;
export type StudentInformationVerificationCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationCountSuspenseQuery
>;
export type StudentInformationVerificationCountQueryResult = Apollo.QueryResult<
	StudentInformationVerificationCountQuery,
	StudentInformationVerificationCountQueryVariables
>;
export const StudentInformationVerificationCreateDocument = gql`
	mutation studentInformationVerificationCreate($input: StudentInformationVerificationCreateInput!) {
		createStudentInformationVerification(input: $input) {
			...StudentInformationVerificationDetail
		}
	}
	${StudentInformationVerificationDetailFragmentDoc}
`;
export type StudentInformationVerificationCreateMutationFn = Apollo.MutationFunction<
	StudentInformationVerificationCreateMutation,
	StudentInformationVerificationCreateMutationVariables
>;

/**
 * __useStudentInformationVerificationCreateMutation__
 *
 * To run a mutation, you first call `useStudentInformationVerificationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentInformationVerificationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentInformationVerificationCreateMutation, { data, loading, error }] = useStudentInformationVerificationCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentInformationVerificationCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentInformationVerificationCreateMutation,
		StudentInformationVerificationCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentInformationVerificationCreateMutation,
		StudentInformationVerificationCreateMutationVariables
	>(StudentInformationVerificationCreateDocument, options);
}
export type StudentInformationVerificationCreateMutationHookResult = ReturnType<
	typeof useStudentInformationVerificationCreateMutation
>;
export type StudentInformationVerificationCreateMutationResult =
	Apollo.MutationResult<StudentInformationVerificationCreateMutation>;
export type StudentInformationVerificationCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentInformationVerificationCreateMutation,
	StudentInformationVerificationCreateMutationVariables
>;
export const StudentInformationVerificationDeleteDocument = gql`
	mutation studentInformationVerificationDelete($id: ID!) {
		deleteStudentInformationVerification(id: $id)
	}
`;
export type StudentInformationVerificationDeleteMutationFn = Apollo.MutationFunction<
	StudentInformationVerificationDeleteMutation,
	StudentInformationVerificationDeleteMutationVariables
>;

/**
 * __useStudentInformationVerificationDeleteMutation__
 *
 * To run a mutation, you first call `useStudentInformationVerificationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentInformationVerificationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentInformationVerificationDeleteMutation, { data, loading, error }] = useStudentInformationVerificationDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentInformationVerificationDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentInformationVerificationDeleteMutation,
		StudentInformationVerificationDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentInformationVerificationDeleteMutation,
		StudentInformationVerificationDeleteMutationVariables
	>(StudentInformationVerificationDeleteDocument, options);
}
export type StudentInformationVerificationDeleteMutationHookResult = ReturnType<
	typeof useStudentInformationVerificationDeleteMutation
>;
export type StudentInformationVerificationDeleteMutationResult =
	Apollo.MutationResult<StudentInformationVerificationDeleteMutation>;
export type StudentInformationVerificationDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentInformationVerificationDeleteMutation,
	StudentInformationVerificationDeleteMutationVariables
>;
export const StudentInformationVerificationDetailDocument = gql`
	query studentInformationVerificationDetail($id: ID!) {
		studentInformationVerification(id: $id) {
			...StudentInformationVerificationDetail
		}
	}
	${StudentInformationVerificationDetailFragmentDoc}
`;

/**
 * __useStudentInformationVerificationDetailQuery__
 *
 * To run a query within a React component, call `useStudentInformationVerificationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentInformationVerificationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentInformationVerificationDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentInformationVerificationDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentInformationVerificationDetailQuery,
		StudentInformationVerificationDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentInformationVerificationDetailQuery, StudentInformationVerificationDetailQueryVariables>(
		StudentInformationVerificationDetailDocument,
		options,
	);
}
export function useStudentInformationVerificationDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentInformationVerificationDetailQuery,
		StudentInformationVerificationDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentInformationVerificationDetailQuery,
		StudentInformationVerificationDetailQueryVariables
	>(StudentInformationVerificationDetailDocument, options);
}
export function useStudentInformationVerificationDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentInformationVerificationDetailQuery,
		StudentInformationVerificationDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentInformationVerificationDetailQuery,
		StudentInformationVerificationDetailQueryVariables
	>(StudentInformationVerificationDetailDocument, options);
}
export type StudentInformationVerificationDetailQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationDetailQuery
>;
export type StudentInformationVerificationDetailLazyQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationDetailLazyQuery
>;
export type StudentInformationVerificationDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationDetailSuspenseQuery
>;
export type StudentInformationVerificationDetailQueryResult = Apollo.QueryResult<
	StudentInformationVerificationDetailQuery,
	StudentInformationVerificationDetailQueryVariables
>;
export const StudentInformationVerificationIndexDocument = gql`
	query studentInformationVerificationIndex(
		$filters: [StudentInformationVerificationFilterInput!]
		$pagination: Pagination
		$order: StudentInformationVerificationOrder
	) {
		studentInformationVerificationConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					hasVerifiedGuardians
					hasVerifiedStudentHealth
				}
			}
		}
	}
`;

/**
 * __useStudentInformationVerificationIndexQuery__
 *
 * To run a query within a React component, call `useStudentInformationVerificationIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentInformationVerificationIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentInformationVerificationIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentInformationVerificationIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentInformationVerificationIndexQuery,
		StudentInformationVerificationIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentInformationVerificationIndexQuery, StudentInformationVerificationIndexQueryVariables>(
		StudentInformationVerificationIndexDocument,
		options,
	);
}
export function useStudentInformationVerificationIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentInformationVerificationIndexQuery,
		StudentInformationVerificationIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentInformationVerificationIndexQuery,
		StudentInformationVerificationIndexQueryVariables
	>(StudentInformationVerificationIndexDocument, options);
}
export function useStudentInformationVerificationIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentInformationVerificationIndexQuery,
		StudentInformationVerificationIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentInformationVerificationIndexQuery,
		StudentInformationVerificationIndexQueryVariables
	>(StudentInformationVerificationIndexDocument, options);
}
export type StudentInformationVerificationIndexQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationIndexQuery
>;
export type StudentInformationVerificationIndexLazyQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationIndexLazyQuery
>;
export type StudentInformationVerificationIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationIndexSuspenseQuery
>;
export type StudentInformationVerificationIndexQueryResult = Apollo.QueryResult<
	StudentInformationVerificationIndexQuery,
	StudentInformationVerificationIndexQueryVariables
>;
export const StudentInformationVerificationNameDocument = gql`
	query studentInformationVerificationName($id: ID!) {
		studentInformationVerification(id: $id) {
			id
			...StudentInformationVerificationName
		}
	}
	${StudentInformationVerificationNameFragmentDoc}
`;

/**
 * __useStudentInformationVerificationNameQuery__
 *
 * To run a query within a React component, call `useStudentInformationVerificationNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentInformationVerificationNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentInformationVerificationNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentInformationVerificationNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentInformationVerificationNameQuery,
		StudentInformationVerificationNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentInformationVerificationNameQuery, StudentInformationVerificationNameQueryVariables>(
		StudentInformationVerificationNameDocument,
		options,
	);
}
export function useStudentInformationVerificationNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentInformationVerificationNameQuery,
		StudentInformationVerificationNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentInformationVerificationNameQuery, StudentInformationVerificationNameQueryVariables>(
		StudentInformationVerificationNameDocument,
		options,
	);
}
export function useStudentInformationVerificationNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentInformationVerificationNameQuery,
		StudentInformationVerificationNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentInformationVerificationNameQuery,
		StudentInformationVerificationNameQueryVariables
	>(StudentInformationVerificationNameDocument, options);
}
export type StudentInformationVerificationNameQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationNameQuery
>;
export type StudentInformationVerificationNameLazyQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationNameLazyQuery
>;
export type StudentInformationVerificationNameSuspenseQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationNameSuspenseQuery
>;
export type StudentInformationVerificationNameQueryResult = Apollo.QueryResult<
	StudentInformationVerificationNameQuery,
	StudentInformationVerificationNameQueryVariables
>;
export const StudentInformationVerificationNamesDocument = gql`
	query studentInformationVerificationNames(
		$filters: [StudentInformationVerificationFilterInput!]
		$pagination: Pagination
		$order: StudentInformationVerificationOrder
	) {
		studentInformationVerificationConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentInformationVerificationName
				}
			}
		}
	}
	${StudentInformationVerificationNameFragmentDoc}
`;

/**
 * __useStudentInformationVerificationNamesQuery__
 *
 * To run a query within a React component, call `useStudentInformationVerificationNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentInformationVerificationNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentInformationVerificationNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentInformationVerificationNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentInformationVerificationNamesQuery,
		StudentInformationVerificationNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentInformationVerificationNamesQuery, StudentInformationVerificationNamesQueryVariables>(
		StudentInformationVerificationNamesDocument,
		options,
	);
}
export function useStudentInformationVerificationNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentInformationVerificationNamesQuery,
		StudentInformationVerificationNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentInformationVerificationNamesQuery,
		StudentInformationVerificationNamesQueryVariables
	>(StudentInformationVerificationNamesDocument, options);
}
export function useStudentInformationVerificationNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentInformationVerificationNamesQuery,
		StudentInformationVerificationNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentInformationVerificationNamesQuery,
		StudentInformationVerificationNamesQueryVariables
	>(StudentInformationVerificationNamesDocument, options);
}
export type StudentInformationVerificationNamesQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationNamesQuery
>;
export type StudentInformationVerificationNamesLazyQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationNamesLazyQuery
>;
export type StudentInformationVerificationNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationNamesSuspenseQuery
>;
export type StudentInformationVerificationNamesQueryResult = Apollo.QueryResult<
	StudentInformationVerificationNamesQuery,
	StudentInformationVerificationNamesQueryVariables
>;
export const StudentInformationVerificationPaginationDocument = gql`
	query studentInformationVerificationPagination(
		$filters: [StudentInformationVerificationFilterInput!]
		$order: StudentInformationVerificationOrder
	) {
		studentInformationVerificationConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentInformationVerificationPaginationQuery__
 *
 * To run a query within a React component, call `useStudentInformationVerificationPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentInformationVerificationPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentInformationVerificationPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentInformationVerificationPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentInformationVerificationPaginationQuery,
		StudentInformationVerificationPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentInformationVerificationPaginationQuery,
		StudentInformationVerificationPaginationQueryVariables
	>(StudentInformationVerificationPaginationDocument, options);
}
export function useStudentInformationVerificationPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentInformationVerificationPaginationQuery,
		StudentInformationVerificationPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentInformationVerificationPaginationQuery,
		StudentInformationVerificationPaginationQueryVariables
	>(StudentInformationVerificationPaginationDocument, options);
}
export function useStudentInformationVerificationPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentInformationVerificationPaginationQuery,
		StudentInformationVerificationPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentInformationVerificationPaginationQuery,
		StudentInformationVerificationPaginationQueryVariables
	>(StudentInformationVerificationPaginationDocument, options);
}
export type StudentInformationVerificationPaginationQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationPaginationQuery
>;
export type StudentInformationVerificationPaginationLazyQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationPaginationLazyQuery
>;
export type StudentInformationVerificationPaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationPaginationSuspenseQuery
>;
export type StudentInformationVerificationPaginationQueryResult = Apollo.QueryResult<
	StudentInformationVerificationPaginationQuery,
	StudentInformationVerificationPaginationQueryVariables
>;
export const StudentInformationVerificationSelectDocument = gql`
	query studentInformationVerificationSelect(
		$filters: [StudentInformationVerificationFilterInput!]
		$order: StudentInformationVerificationOrder
	) {
		studentInformationVerificationConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentInformationVerificationName
				}
			}
		}
	}
	${StudentInformationVerificationNameFragmentDoc}
`;

/**
 * __useStudentInformationVerificationSelectQuery__
 *
 * To run a query within a React component, call `useStudentInformationVerificationSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentInformationVerificationSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentInformationVerificationSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentInformationVerificationSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentInformationVerificationSelectQuery,
		StudentInformationVerificationSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentInformationVerificationSelectQuery, StudentInformationVerificationSelectQueryVariables>(
		StudentInformationVerificationSelectDocument,
		options,
	);
}
export function useStudentInformationVerificationSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentInformationVerificationSelectQuery,
		StudentInformationVerificationSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentInformationVerificationSelectQuery,
		StudentInformationVerificationSelectQueryVariables
	>(StudentInformationVerificationSelectDocument, options);
}
export function useStudentInformationVerificationSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentInformationVerificationSelectQuery,
		StudentInformationVerificationSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentInformationVerificationSelectQuery,
		StudentInformationVerificationSelectQueryVariables
	>(StudentInformationVerificationSelectDocument, options);
}
export type StudentInformationVerificationSelectQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationSelectQuery
>;
export type StudentInformationVerificationSelectLazyQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationSelectLazyQuery
>;
export type StudentInformationVerificationSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentInformationVerificationSelectSuspenseQuery
>;
export type StudentInformationVerificationSelectQueryResult = Apollo.QueryResult<
	StudentInformationVerificationSelectQuery,
	StudentInformationVerificationSelectQueryVariables
>;
export const StudentInformationVerificationUpdateDocument = gql`
	mutation studentInformationVerificationUpdate($id: ID!, $input: StudentInformationVerificationUpdateInput!) {
		updateStudentInformationVerification(id: $id, input: $input) {
			...StudentInformationVerificationDetail
		}
	}
	${StudentInformationVerificationDetailFragmentDoc}
`;
export type StudentInformationVerificationUpdateMutationFn = Apollo.MutationFunction<
	StudentInformationVerificationUpdateMutation,
	StudentInformationVerificationUpdateMutationVariables
>;

/**
 * __useStudentInformationVerificationUpdateMutation__
 *
 * To run a mutation, you first call `useStudentInformationVerificationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentInformationVerificationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentInformationVerificationUpdateMutation, { data, loading, error }] = useStudentInformationVerificationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentInformationVerificationUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentInformationVerificationUpdateMutation,
		StudentInformationVerificationUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentInformationVerificationUpdateMutation,
		StudentInformationVerificationUpdateMutationVariables
	>(StudentInformationVerificationUpdateDocument, options);
}
export type StudentInformationVerificationUpdateMutationHookResult = ReturnType<
	typeof useStudentInformationVerificationUpdateMutation
>;
export type StudentInformationVerificationUpdateMutationResult =
	Apollo.MutationResult<StudentInformationVerificationUpdateMutation>;
export type StudentInformationVerificationUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentInformationVerificationUpdateMutation,
	StudentInformationVerificationUpdateMutationVariables
>;
export const StudentInjuryNoteCountDocument = gql`
	query studentInjuryNoteCount(
		$filters: [StudentInjuryNoteFilterInput!]
		$pagination: Pagination
		$order: StudentInjuryNoteOrder
	) {
		studentInjuryNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentInjuryNoteCountQuery__
 *
 * To run a query within a React component, call `useStudentInjuryNoteCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentInjuryNoteCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentInjuryNoteCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentInjuryNoteCountQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentInjuryNoteCountQuery, StudentInjuryNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentInjuryNoteCountQuery, StudentInjuryNoteCountQueryVariables>(
		StudentInjuryNoteCountDocument,
		options,
	);
}
export function useStudentInjuryNoteCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentInjuryNoteCountQuery, StudentInjuryNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentInjuryNoteCountQuery, StudentInjuryNoteCountQueryVariables>(
		StudentInjuryNoteCountDocument,
		options,
	);
}
export function useStudentInjuryNoteCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentInjuryNoteCountQuery, StudentInjuryNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentInjuryNoteCountQuery, StudentInjuryNoteCountQueryVariables>(
		StudentInjuryNoteCountDocument,
		options,
	);
}
export type StudentInjuryNoteCountQueryHookResult = ReturnType<typeof useStudentInjuryNoteCountQuery>;
export type StudentInjuryNoteCountLazyQueryHookResult = ReturnType<typeof useStudentInjuryNoteCountLazyQuery>;
export type StudentInjuryNoteCountSuspenseQueryHookResult = ReturnType<typeof useStudentInjuryNoteCountSuspenseQuery>;
export type StudentInjuryNoteCountQueryResult = Apollo.QueryResult<
	StudentInjuryNoteCountQuery,
	StudentInjuryNoteCountQueryVariables
>;
export const StudentInjuryNoteCreateDocument = gql`
	mutation studentInjuryNoteCreate($input: StudentInjuryNoteCreateInput!) {
		createStudentInjuryNote(input: $input) {
			...StudentInjuryNoteDetail
		}
	}
	${StudentInjuryNoteDetailFragmentDoc}
`;
export type StudentInjuryNoteCreateMutationFn = Apollo.MutationFunction<
	StudentInjuryNoteCreateMutation,
	StudentInjuryNoteCreateMutationVariables
>;

/**
 * __useStudentInjuryNoteCreateMutation__
 *
 * To run a mutation, you first call `useStudentInjuryNoteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentInjuryNoteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentInjuryNoteCreateMutation, { data, loading, error }] = useStudentInjuryNoteCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentInjuryNoteCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<StudentInjuryNoteCreateMutation, StudentInjuryNoteCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentInjuryNoteCreateMutation, StudentInjuryNoteCreateMutationVariables>(
		StudentInjuryNoteCreateDocument,
		options,
	);
}
export type StudentInjuryNoteCreateMutationHookResult = ReturnType<typeof useStudentInjuryNoteCreateMutation>;
export type StudentInjuryNoteCreateMutationResult = Apollo.MutationResult<StudentInjuryNoteCreateMutation>;
export type StudentInjuryNoteCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentInjuryNoteCreateMutation,
	StudentInjuryNoteCreateMutationVariables
>;
export const StudentInjuryNoteDeleteDocument = gql`
	mutation studentInjuryNoteDelete($id: ID!) {
		deleteStudentInjuryNote(id: $id)
	}
`;
export type StudentInjuryNoteDeleteMutationFn = Apollo.MutationFunction<
	StudentInjuryNoteDeleteMutation,
	StudentInjuryNoteDeleteMutationVariables
>;

/**
 * __useStudentInjuryNoteDeleteMutation__
 *
 * To run a mutation, you first call `useStudentInjuryNoteDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentInjuryNoteDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentInjuryNoteDeleteMutation, { data, loading, error }] = useStudentInjuryNoteDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentInjuryNoteDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<StudentInjuryNoteDeleteMutation, StudentInjuryNoteDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentInjuryNoteDeleteMutation, StudentInjuryNoteDeleteMutationVariables>(
		StudentInjuryNoteDeleteDocument,
		options,
	);
}
export type StudentInjuryNoteDeleteMutationHookResult = ReturnType<typeof useStudentInjuryNoteDeleteMutation>;
export type StudentInjuryNoteDeleteMutationResult = Apollo.MutationResult<StudentInjuryNoteDeleteMutation>;
export type StudentInjuryNoteDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentInjuryNoteDeleteMutation,
	StudentInjuryNoteDeleteMutationVariables
>;
export const StudentInjuryNoteDetailDocument = gql`
	query studentInjuryNoteDetail($id: ID!) {
		studentInjuryNote(id: $id) {
			...StudentInjuryNoteDetail
		}
	}
	${StudentInjuryNoteDetailFragmentDoc}
`;

/**
 * __useStudentInjuryNoteDetailQuery__
 *
 * To run a query within a React component, call `useStudentInjuryNoteDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentInjuryNoteDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentInjuryNoteDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentInjuryNoteDetailQuery(
	baseOptions: Apollo.QueryHookOptions<StudentInjuryNoteDetailQuery, StudentInjuryNoteDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentInjuryNoteDetailQuery, StudentInjuryNoteDetailQueryVariables>(
		StudentInjuryNoteDetailDocument,
		options,
	);
}
export function useStudentInjuryNoteDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentInjuryNoteDetailQuery, StudentInjuryNoteDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentInjuryNoteDetailQuery, StudentInjuryNoteDetailQueryVariables>(
		StudentInjuryNoteDetailDocument,
		options,
	);
}
export function useStudentInjuryNoteDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentInjuryNoteDetailQuery, StudentInjuryNoteDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentInjuryNoteDetailQuery, StudentInjuryNoteDetailQueryVariables>(
		StudentInjuryNoteDetailDocument,
		options,
	);
}
export type StudentInjuryNoteDetailQueryHookResult = ReturnType<typeof useStudentInjuryNoteDetailQuery>;
export type StudentInjuryNoteDetailLazyQueryHookResult = ReturnType<typeof useStudentInjuryNoteDetailLazyQuery>;
export type StudentInjuryNoteDetailSuspenseQueryHookResult = ReturnType<typeof useStudentInjuryNoteDetailSuspenseQuery>;
export type StudentInjuryNoteDetailQueryResult = Apollo.QueryResult<
	StudentInjuryNoteDetailQuery,
	StudentInjuryNoteDetailQueryVariables
>;
export const StudentInjuryNoteIndexDocument = gql`
	query studentInjuryNoteIndex(
		$filters: [StudentInjuryNoteFilterInput!]
		$pagination: Pagination
		$order: StudentInjuryNoteOrder
	) {
		studentInjuryNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					incidentTime
					incidentLocation
					wereOtherStudentsCauseOfInjury
					causeOfInjury
					medicalAttentionProvided
					adultWhoProvidedMedicalAttention
					isActionTakenHomeroomTeachersNotified
					isActionTakenParentNotifiedByPortal
					isActionTakenParentNotifiedByPhone
					isActionTakenParentsRequestedToCollectStudent
					isActionTakenParentNotificationNotNecessary
					isActionTakenOther
					actionTakenOther
				}
			}
		}
	}
`;

/**
 * __useStudentInjuryNoteIndexQuery__
 *
 * To run a query within a React component, call `useStudentInjuryNoteIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentInjuryNoteIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentInjuryNoteIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentInjuryNoteIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentInjuryNoteIndexQuery, StudentInjuryNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentInjuryNoteIndexQuery, StudentInjuryNoteIndexQueryVariables>(
		StudentInjuryNoteIndexDocument,
		options,
	);
}
export function useStudentInjuryNoteIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentInjuryNoteIndexQuery, StudentInjuryNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentInjuryNoteIndexQuery, StudentInjuryNoteIndexQueryVariables>(
		StudentInjuryNoteIndexDocument,
		options,
	);
}
export function useStudentInjuryNoteIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentInjuryNoteIndexQuery, StudentInjuryNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentInjuryNoteIndexQuery, StudentInjuryNoteIndexQueryVariables>(
		StudentInjuryNoteIndexDocument,
		options,
	);
}
export type StudentInjuryNoteIndexQueryHookResult = ReturnType<typeof useStudentInjuryNoteIndexQuery>;
export type StudentInjuryNoteIndexLazyQueryHookResult = ReturnType<typeof useStudentInjuryNoteIndexLazyQuery>;
export type StudentInjuryNoteIndexSuspenseQueryHookResult = ReturnType<typeof useStudentInjuryNoteIndexSuspenseQuery>;
export type StudentInjuryNoteIndexQueryResult = Apollo.QueryResult<
	StudentInjuryNoteIndexQuery,
	StudentInjuryNoteIndexQueryVariables
>;
export const StudentInjuryNoteNameDocument = gql`
	query studentInjuryNoteName($id: ID!) {
		studentInjuryNote(id: $id) {
			id
			...StudentInjuryNoteName
		}
	}
	${StudentInjuryNoteNameFragmentDoc}
`;

/**
 * __useStudentInjuryNoteNameQuery__
 *
 * To run a query within a React component, call `useStudentInjuryNoteNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentInjuryNoteNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentInjuryNoteNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentInjuryNoteNameQuery(
	baseOptions: Apollo.QueryHookOptions<StudentInjuryNoteNameQuery, StudentInjuryNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentInjuryNoteNameQuery, StudentInjuryNoteNameQueryVariables>(
		StudentInjuryNoteNameDocument,
		options,
	);
}
export function useStudentInjuryNoteNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentInjuryNoteNameQuery, StudentInjuryNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentInjuryNoteNameQuery, StudentInjuryNoteNameQueryVariables>(
		StudentInjuryNoteNameDocument,
		options,
	);
}
export function useStudentInjuryNoteNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentInjuryNoteNameQuery, StudentInjuryNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentInjuryNoteNameQuery, StudentInjuryNoteNameQueryVariables>(
		StudentInjuryNoteNameDocument,
		options,
	);
}
export type StudentInjuryNoteNameQueryHookResult = ReturnType<typeof useStudentInjuryNoteNameQuery>;
export type StudentInjuryNoteNameLazyQueryHookResult = ReturnType<typeof useStudentInjuryNoteNameLazyQuery>;
export type StudentInjuryNoteNameSuspenseQueryHookResult = ReturnType<typeof useStudentInjuryNoteNameSuspenseQuery>;
export type StudentInjuryNoteNameQueryResult = Apollo.QueryResult<
	StudentInjuryNoteNameQuery,
	StudentInjuryNoteNameQueryVariables
>;
export const StudentInjuryNoteNamesDocument = gql`
	query studentInjuryNoteNames(
		$filters: [StudentInjuryNoteFilterInput!]
		$pagination: Pagination
		$order: StudentInjuryNoteOrder
	) {
		studentInjuryNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentInjuryNoteName
				}
			}
		}
	}
	${StudentInjuryNoteNameFragmentDoc}
`;

/**
 * __useStudentInjuryNoteNamesQuery__
 *
 * To run a query within a React component, call `useStudentInjuryNoteNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentInjuryNoteNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentInjuryNoteNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentInjuryNoteNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentInjuryNoteNamesQuery, StudentInjuryNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentInjuryNoteNamesQuery, StudentInjuryNoteNamesQueryVariables>(
		StudentInjuryNoteNamesDocument,
		options,
	);
}
export function useStudentInjuryNoteNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentInjuryNoteNamesQuery, StudentInjuryNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentInjuryNoteNamesQuery, StudentInjuryNoteNamesQueryVariables>(
		StudentInjuryNoteNamesDocument,
		options,
	);
}
export function useStudentInjuryNoteNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentInjuryNoteNamesQuery, StudentInjuryNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentInjuryNoteNamesQuery, StudentInjuryNoteNamesQueryVariables>(
		StudentInjuryNoteNamesDocument,
		options,
	);
}
export type StudentInjuryNoteNamesQueryHookResult = ReturnType<typeof useStudentInjuryNoteNamesQuery>;
export type StudentInjuryNoteNamesLazyQueryHookResult = ReturnType<typeof useStudentInjuryNoteNamesLazyQuery>;
export type StudentInjuryNoteNamesSuspenseQueryHookResult = ReturnType<typeof useStudentInjuryNoteNamesSuspenseQuery>;
export type StudentInjuryNoteNamesQueryResult = Apollo.QueryResult<
	StudentInjuryNoteNamesQuery,
	StudentInjuryNoteNamesQueryVariables
>;
export const StudentInjuryNotePaginationDocument = gql`
	query studentInjuryNotePagination($filters: [StudentInjuryNoteFilterInput!], $order: StudentInjuryNoteOrder) {
		studentInjuryNoteConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentInjuryNotePaginationQuery__
 *
 * To run a query within a React component, call `useStudentInjuryNotePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentInjuryNotePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentInjuryNotePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentInjuryNotePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentInjuryNotePaginationQuery, StudentInjuryNotePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentInjuryNotePaginationQuery, StudentInjuryNotePaginationQueryVariables>(
		StudentInjuryNotePaginationDocument,
		options,
	);
}
export function useStudentInjuryNotePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentInjuryNotePaginationQuery,
		StudentInjuryNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentInjuryNotePaginationQuery, StudentInjuryNotePaginationQueryVariables>(
		StudentInjuryNotePaginationDocument,
		options,
	);
}
export function useStudentInjuryNotePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentInjuryNotePaginationQuery,
		StudentInjuryNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentInjuryNotePaginationQuery, StudentInjuryNotePaginationQueryVariables>(
		StudentInjuryNotePaginationDocument,
		options,
	);
}
export type StudentInjuryNotePaginationQueryHookResult = ReturnType<typeof useStudentInjuryNotePaginationQuery>;
export type StudentInjuryNotePaginationLazyQueryHookResult = ReturnType<typeof useStudentInjuryNotePaginationLazyQuery>;
export type StudentInjuryNotePaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentInjuryNotePaginationSuspenseQuery
>;
export type StudentInjuryNotePaginationQueryResult = Apollo.QueryResult<
	StudentInjuryNotePaginationQuery,
	StudentInjuryNotePaginationQueryVariables
>;
export const StudentInjuryNoteSelectDocument = gql`
	query studentInjuryNoteSelect($filters: [StudentInjuryNoteFilterInput!], $order: StudentInjuryNoteOrder) {
		studentInjuryNoteConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentInjuryNoteName
				}
			}
		}
	}
	${StudentInjuryNoteNameFragmentDoc}
`;

/**
 * __useStudentInjuryNoteSelectQuery__
 *
 * To run a query within a React component, call `useStudentInjuryNoteSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentInjuryNoteSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentInjuryNoteSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentInjuryNoteSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentInjuryNoteSelectQuery, StudentInjuryNoteSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentInjuryNoteSelectQuery, StudentInjuryNoteSelectQueryVariables>(
		StudentInjuryNoteSelectDocument,
		options,
	);
}
export function useStudentInjuryNoteSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentInjuryNoteSelectQuery, StudentInjuryNoteSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentInjuryNoteSelectQuery, StudentInjuryNoteSelectQueryVariables>(
		StudentInjuryNoteSelectDocument,
		options,
	);
}
export function useStudentInjuryNoteSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentInjuryNoteSelectQuery, StudentInjuryNoteSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentInjuryNoteSelectQuery, StudentInjuryNoteSelectQueryVariables>(
		StudentInjuryNoteSelectDocument,
		options,
	);
}
export type StudentInjuryNoteSelectQueryHookResult = ReturnType<typeof useStudentInjuryNoteSelectQuery>;
export type StudentInjuryNoteSelectLazyQueryHookResult = ReturnType<typeof useStudentInjuryNoteSelectLazyQuery>;
export type StudentInjuryNoteSelectSuspenseQueryHookResult = ReturnType<typeof useStudentInjuryNoteSelectSuspenseQuery>;
export type StudentInjuryNoteSelectQueryResult = Apollo.QueryResult<
	StudentInjuryNoteSelectQuery,
	StudentInjuryNoteSelectQueryVariables
>;
export const StudentInjuryNoteUpdateDocument = gql`
	mutation studentInjuryNoteUpdate($id: ID!, $input: StudentInjuryNoteUpdateInput!) {
		updateStudentInjuryNote(id: $id, input: $input) {
			...StudentInjuryNoteDetail
		}
	}
	${StudentInjuryNoteDetailFragmentDoc}
`;
export type StudentInjuryNoteUpdateMutationFn = Apollo.MutationFunction<
	StudentInjuryNoteUpdateMutation,
	StudentInjuryNoteUpdateMutationVariables
>;

/**
 * __useStudentInjuryNoteUpdateMutation__
 *
 * To run a mutation, you first call `useStudentInjuryNoteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentInjuryNoteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentInjuryNoteUpdateMutation, { data, loading, error }] = useStudentInjuryNoteUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentInjuryNoteUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<StudentInjuryNoteUpdateMutation, StudentInjuryNoteUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentInjuryNoteUpdateMutation, StudentInjuryNoteUpdateMutationVariables>(
		StudentInjuryNoteUpdateDocument,
		options,
	);
}
export type StudentInjuryNoteUpdateMutationHookResult = ReturnType<typeof useStudentInjuryNoteUpdateMutation>;
export type StudentInjuryNoteUpdateMutationResult = Apollo.MutationResult<StudentInjuryNoteUpdateMutation>;
export type StudentInjuryNoteUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentInjuryNoteUpdateMutation,
	StudentInjuryNoteUpdateMutationVariables
>;
export const StudentMedicalConditionCountDocument = gql`
	query studentMedicalConditionCount(
		$filters: [StudentMedicalConditionFilterInput!]
		$pagination: Pagination
		$order: StudentMedicalConditionOrder
	) {
		studentMedicalConditionConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentMedicalConditionCountQuery__
 *
 * To run a query within a React component, call `useStudentMedicalConditionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalConditionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalConditionCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalConditionCountQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicalConditionCountQuery, StudentMedicalConditionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalConditionCountQuery, StudentMedicalConditionCountQueryVariables>(
		StudentMedicalConditionCountDocument,
		options,
	);
}
export function useStudentMedicalConditionCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicalConditionCountQuery,
		StudentMedicalConditionCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalConditionCountQuery, StudentMedicalConditionCountQueryVariables>(
		StudentMedicalConditionCountDocument,
		options,
	);
}
export function useStudentMedicalConditionCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalConditionCountQuery,
		StudentMedicalConditionCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalConditionCountQuery, StudentMedicalConditionCountQueryVariables>(
		StudentMedicalConditionCountDocument,
		options,
	);
}
export type StudentMedicalConditionCountQueryHookResult = ReturnType<typeof useStudentMedicalConditionCountQuery>;
export type StudentMedicalConditionCountLazyQueryHookResult = ReturnType<
	typeof useStudentMedicalConditionCountLazyQuery
>;
export type StudentMedicalConditionCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalConditionCountSuspenseQuery
>;
export type StudentMedicalConditionCountQueryResult = Apollo.QueryResult<
	StudentMedicalConditionCountQuery,
	StudentMedicalConditionCountQueryVariables
>;
export const StudentMedicalConditionCreateDocument = gql`
	mutation studentMedicalConditionCreate($input: StudentMedicalConditionCreateInput!) {
		createStudentMedicalCondition(input: $input) {
			...StudentMedicalConditionDetail
		}
	}
	${StudentMedicalConditionDetailFragmentDoc}
`;
export type StudentMedicalConditionCreateMutationFn = Apollo.MutationFunction<
	StudentMedicalConditionCreateMutation,
	StudentMedicalConditionCreateMutationVariables
>;

/**
 * __useStudentMedicalConditionCreateMutation__
 *
 * To run a mutation, you first call `useStudentMedicalConditionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalConditionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentMedicalConditionCreateMutation, { data, loading, error }] = useStudentMedicalConditionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentMedicalConditionCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentMedicalConditionCreateMutation,
		StudentMedicalConditionCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentMedicalConditionCreateMutation, StudentMedicalConditionCreateMutationVariables>(
		StudentMedicalConditionCreateDocument,
		options,
	);
}
export type StudentMedicalConditionCreateMutationHookResult = ReturnType<
	typeof useStudentMedicalConditionCreateMutation
>;
export type StudentMedicalConditionCreateMutationResult = Apollo.MutationResult<StudentMedicalConditionCreateMutation>;
export type StudentMedicalConditionCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentMedicalConditionCreateMutation,
	StudentMedicalConditionCreateMutationVariables
>;
export const StudentMedicalConditionDeleteDocument = gql`
	mutation studentMedicalConditionDelete($id: ID!) {
		deleteStudentMedicalCondition(id: $id)
	}
`;
export type StudentMedicalConditionDeleteMutationFn = Apollo.MutationFunction<
	StudentMedicalConditionDeleteMutation,
	StudentMedicalConditionDeleteMutationVariables
>;

/**
 * __useStudentMedicalConditionDeleteMutation__
 *
 * To run a mutation, you first call `useStudentMedicalConditionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalConditionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentMedicalConditionDeleteMutation, { data, loading, error }] = useStudentMedicalConditionDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentMedicalConditionDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentMedicalConditionDeleteMutation,
		StudentMedicalConditionDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentMedicalConditionDeleteMutation, StudentMedicalConditionDeleteMutationVariables>(
		StudentMedicalConditionDeleteDocument,
		options,
	);
}
export type StudentMedicalConditionDeleteMutationHookResult = ReturnType<
	typeof useStudentMedicalConditionDeleteMutation
>;
export type StudentMedicalConditionDeleteMutationResult = Apollo.MutationResult<StudentMedicalConditionDeleteMutation>;
export type StudentMedicalConditionDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentMedicalConditionDeleteMutation,
	StudentMedicalConditionDeleteMutationVariables
>;
export const StudentMedicalConditionDetailDocument = gql`
	query studentMedicalConditionDetail($id: ID!) {
		studentMedicalCondition(id: $id) {
			...StudentMedicalConditionDetail
		}
	}
	${StudentMedicalConditionDetailFragmentDoc}
`;

/**
 * __useStudentMedicalConditionDetailQuery__
 *
 * To run a query within a React component, call `useStudentMedicalConditionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalConditionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalConditionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentMedicalConditionDetailQuery(
	baseOptions: Apollo.QueryHookOptions<StudentMedicalConditionDetailQuery, StudentMedicalConditionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalConditionDetailQuery, StudentMedicalConditionDetailQueryVariables>(
		StudentMedicalConditionDetailDocument,
		options,
	);
}
export function useStudentMedicalConditionDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicalConditionDetailQuery,
		StudentMedicalConditionDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalConditionDetailQuery, StudentMedicalConditionDetailQueryVariables>(
		StudentMedicalConditionDetailDocument,
		options,
	);
}
export function useStudentMedicalConditionDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalConditionDetailQuery,
		StudentMedicalConditionDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalConditionDetailQuery, StudentMedicalConditionDetailQueryVariables>(
		StudentMedicalConditionDetailDocument,
		options,
	);
}
export type StudentMedicalConditionDetailQueryHookResult = ReturnType<typeof useStudentMedicalConditionDetailQuery>;
export type StudentMedicalConditionDetailLazyQueryHookResult = ReturnType<
	typeof useStudentMedicalConditionDetailLazyQuery
>;
export type StudentMedicalConditionDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalConditionDetailSuspenseQuery
>;
export type StudentMedicalConditionDetailQueryResult = Apollo.QueryResult<
	StudentMedicalConditionDetailQuery,
	StudentMedicalConditionDetailQueryVariables
>;
export const StudentMedicalConditionIndexDocument = gql`
	query studentMedicalConditionIndex(
		$filters: [StudentMedicalConditionFilterInput!]
		$pagination: Pagination
		$order: StudentMedicalConditionOrder
	) {
		studentMedicalConditionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					isProminent
					notes
				}
			}
		}
	}
`;

/**
 * __useStudentMedicalConditionIndexQuery__
 *
 * To run a query within a React component, call `useStudentMedicalConditionIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalConditionIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalConditionIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalConditionIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicalConditionIndexQuery, StudentMedicalConditionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalConditionIndexQuery, StudentMedicalConditionIndexQueryVariables>(
		StudentMedicalConditionIndexDocument,
		options,
	);
}
export function useStudentMedicalConditionIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicalConditionIndexQuery,
		StudentMedicalConditionIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalConditionIndexQuery, StudentMedicalConditionIndexQueryVariables>(
		StudentMedicalConditionIndexDocument,
		options,
	);
}
export function useStudentMedicalConditionIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalConditionIndexQuery,
		StudentMedicalConditionIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalConditionIndexQuery, StudentMedicalConditionIndexQueryVariables>(
		StudentMedicalConditionIndexDocument,
		options,
	);
}
export type StudentMedicalConditionIndexQueryHookResult = ReturnType<typeof useStudentMedicalConditionIndexQuery>;
export type StudentMedicalConditionIndexLazyQueryHookResult = ReturnType<
	typeof useStudentMedicalConditionIndexLazyQuery
>;
export type StudentMedicalConditionIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalConditionIndexSuspenseQuery
>;
export type StudentMedicalConditionIndexQueryResult = Apollo.QueryResult<
	StudentMedicalConditionIndexQuery,
	StudentMedicalConditionIndexQueryVariables
>;
export const StudentMedicalConditionStudentListDocument = gql`
	query studentMedicalConditionStudentList(
		$filters: [StudentMedicalConditionFilterInput!]
		$pagination: Pagination
		$order: StudentMedicalConditionOrder
	) {
		studentMedicalConditionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					isProminent
					notes
					medicalCondition {
						id
						...MedicalConditionName
						conditionType
					}
				}
			}
		}
	}
	${MedicalConditionNameFragmentDoc}
`;

/**
 * __useStudentMedicalConditionStudentListQuery__
 *
 * To run a query within a React component, call `useStudentMedicalConditionStudentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalConditionStudentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalConditionStudentListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalConditionStudentListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentMedicalConditionStudentListQuery,
		StudentMedicalConditionStudentListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalConditionStudentListQuery, StudentMedicalConditionStudentListQueryVariables>(
		StudentMedicalConditionStudentListDocument,
		options,
	);
}
export function useStudentMedicalConditionStudentListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicalConditionStudentListQuery,
		StudentMedicalConditionStudentListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalConditionStudentListQuery, StudentMedicalConditionStudentListQueryVariables>(
		StudentMedicalConditionStudentListDocument,
		options,
	);
}
export function useStudentMedicalConditionStudentListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalConditionStudentListQuery,
		StudentMedicalConditionStudentListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentMedicalConditionStudentListQuery,
		StudentMedicalConditionStudentListQueryVariables
	>(StudentMedicalConditionStudentListDocument, options);
}
export type StudentMedicalConditionStudentListQueryHookResult = ReturnType<
	typeof useStudentMedicalConditionStudentListQuery
>;
export type StudentMedicalConditionStudentListLazyQueryHookResult = ReturnType<
	typeof useStudentMedicalConditionStudentListLazyQuery
>;
export type StudentMedicalConditionStudentListSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalConditionStudentListSuspenseQuery
>;
export type StudentMedicalConditionStudentListQueryResult = Apollo.QueryResult<
	StudentMedicalConditionStudentListQuery,
	StudentMedicalConditionStudentListQueryVariables
>;
export const StudentMedicalConditionNameDocument = gql`
	query studentMedicalConditionName($id: ID!) {
		studentMedicalCondition(id: $id) {
			id
			...StudentMedicalConditionName
		}
	}
	${StudentMedicalConditionNameFragmentDoc}
`;

/**
 * __useStudentMedicalConditionNameQuery__
 *
 * To run a query within a React component, call `useStudentMedicalConditionNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalConditionNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalConditionNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentMedicalConditionNameQuery(
	baseOptions: Apollo.QueryHookOptions<StudentMedicalConditionNameQuery, StudentMedicalConditionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalConditionNameQuery, StudentMedicalConditionNameQueryVariables>(
		StudentMedicalConditionNameDocument,
		options,
	);
}
export function useStudentMedicalConditionNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicalConditionNameQuery,
		StudentMedicalConditionNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalConditionNameQuery, StudentMedicalConditionNameQueryVariables>(
		StudentMedicalConditionNameDocument,
		options,
	);
}
export function useStudentMedicalConditionNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalConditionNameQuery,
		StudentMedicalConditionNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalConditionNameQuery, StudentMedicalConditionNameQueryVariables>(
		StudentMedicalConditionNameDocument,
		options,
	);
}
export type StudentMedicalConditionNameQueryHookResult = ReturnType<typeof useStudentMedicalConditionNameQuery>;
export type StudentMedicalConditionNameLazyQueryHookResult = ReturnType<typeof useStudentMedicalConditionNameLazyQuery>;
export type StudentMedicalConditionNameSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalConditionNameSuspenseQuery
>;
export type StudentMedicalConditionNameQueryResult = Apollo.QueryResult<
	StudentMedicalConditionNameQuery,
	StudentMedicalConditionNameQueryVariables
>;
export const StudentMedicalConditionNamesDocument = gql`
	query studentMedicalConditionNames(
		$filters: [StudentMedicalConditionFilterInput!]
		$pagination: Pagination
		$order: StudentMedicalConditionOrder
	) {
		studentMedicalConditionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentMedicalConditionName
				}
			}
		}
	}
	${StudentMedicalConditionNameFragmentDoc}
`;

/**
 * __useStudentMedicalConditionNamesQuery__
 *
 * To run a query within a React component, call `useStudentMedicalConditionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalConditionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalConditionNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalConditionNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicalConditionNamesQuery, StudentMedicalConditionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalConditionNamesQuery, StudentMedicalConditionNamesQueryVariables>(
		StudentMedicalConditionNamesDocument,
		options,
	);
}
export function useStudentMedicalConditionNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicalConditionNamesQuery,
		StudentMedicalConditionNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalConditionNamesQuery, StudentMedicalConditionNamesQueryVariables>(
		StudentMedicalConditionNamesDocument,
		options,
	);
}
export function useStudentMedicalConditionNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalConditionNamesQuery,
		StudentMedicalConditionNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalConditionNamesQuery, StudentMedicalConditionNamesQueryVariables>(
		StudentMedicalConditionNamesDocument,
		options,
	);
}
export type StudentMedicalConditionNamesQueryHookResult = ReturnType<typeof useStudentMedicalConditionNamesQuery>;
export type StudentMedicalConditionNamesLazyQueryHookResult = ReturnType<
	typeof useStudentMedicalConditionNamesLazyQuery
>;
export type StudentMedicalConditionNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalConditionNamesSuspenseQuery
>;
export type StudentMedicalConditionNamesQueryResult = Apollo.QueryResult<
	StudentMedicalConditionNamesQuery,
	StudentMedicalConditionNamesQueryVariables
>;
export const StudentMedicalConditionPaginationDocument = gql`
	query studentMedicalConditionPagination(
		$filters: [StudentMedicalConditionFilterInput!]
		$order: StudentMedicalConditionOrder
	) {
		studentMedicalConditionConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentMedicalConditionPaginationQuery__
 *
 * To run a query within a React component, call `useStudentMedicalConditionPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalConditionPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalConditionPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalConditionPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentMedicalConditionPaginationQuery,
		StudentMedicalConditionPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalConditionPaginationQuery, StudentMedicalConditionPaginationQueryVariables>(
		StudentMedicalConditionPaginationDocument,
		options,
	);
}
export function useStudentMedicalConditionPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicalConditionPaginationQuery,
		StudentMedicalConditionPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalConditionPaginationQuery, StudentMedicalConditionPaginationQueryVariables>(
		StudentMedicalConditionPaginationDocument,
		options,
	);
}
export function useStudentMedicalConditionPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalConditionPaginationQuery,
		StudentMedicalConditionPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentMedicalConditionPaginationQuery,
		StudentMedicalConditionPaginationQueryVariables
	>(StudentMedicalConditionPaginationDocument, options);
}
export type StudentMedicalConditionPaginationQueryHookResult = ReturnType<
	typeof useStudentMedicalConditionPaginationQuery
>;
export type StudentMedicalConditionPaginationLazyQueryHookResult = ReturnType<
	typeof useStudentMedicalConditionPaginationLazyQuery
>;
export type StudentMedicalConditionPaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalConditionPaginationSuspenseQuery
>;
export type StudentMedicalConditionPaginationQueryResult = Apollo.QueryResult<
	StudentMedicalConditionPaginationQuery,
	StudentMedicalConditionPaginationQueryVariables
>;
export const StudentMedicalConditionSelectDocument = gql`
	query studentMedicalConditionSelect(
		$filters: [StudentMedicalConditionFilterInput!]
		$order: StudentMedicalConditionOrder
	) {
		studentMedicalConditionConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentMedicalConditionName
				}
			}
		}
	}
	${StudentMedicalConditionNameFragmentDoc}
`;

/**
 * __useStudentMedicalConditionSelectQuery__
 *
 * To run a query within a React component, call `useStudentMedicalConditionSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalConditionSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalConditionSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalConditionSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentMedicalConditionSelectQuery,
		StudentMedicalConditionSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalConditionSelectQuery, StudentMedicalConditionSelectQueryVariables>(
		StudentMedicalConditionSelectDocument,
		options,
	);
}
export function useStudentMedicalConditionSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicalConditionSelectQuery,
		StudentMedicalConditionSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalConditionSelectQuery, StudentMedicalConditionSelectQueryVariables>(
		StudentMedicalConditionSelectDocument,
		options,
	);
}
export function useStudentMedicalConditionSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalConditionSelectQuery,
		StudentMedicalConditionSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalConditionSelectQuery, StudentMedicalConditionSelectQueryVariables>(
		StudentMedicalConditionSelectDocument,
		options,
	);
}
export type StudentMedicalConditionSelectQueryHookResult = ReturnType<typeof useStudentMedicalConditionSelectQuery>;
export type StudentMedicalConditionSelectLazyQueryHookResult = ReturnType<
	typeof useStudentMedicalConditionSelectLazyQuery
>;
export type StudentMedicalConditionSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalConditionSelectSuspenseQuery
>;
export type StudentMedicalConditionSelectQueryResult = Apollo.QueryResult<
	StudentMedicalConditionSelectQuery,
	StudentMedicalConditionSelectQueryVariables
>;
export const StudentMedicalConditionUpdateDocument = gql`
	mutation studentMedicalConditionUpdate($id: ID!, $input: StudentMedicalConditionUpdateInput!) {
		updateStudentMedicalCondition(id: $id, input: $input) {
			...StudentMedicalConditionDetail
		}
	}
	${StudentMedicalConditionDetailFragmentDoc}
`;
export type StudentMedicalConditionUpdateMutationFn = Apollo.MutationFunction<
	StudentMedicalConditionUpdateMutation,
	StudentMedicalConditionUpdateMutationVariables
>;

/**
 * __useStudentMedicalConditionUpdateMutation__
 *
 * To run a mutation, you first call `useStudentMedicalConditionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalConditionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentMedicalConditionUpdateMutation, { data, loading, error }] = useStudentMedicalConditionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentMedicalConditionUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentMedicalConditionUpdateMutation,
		StudentMedicalConditionUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentMedicalConditionUpdateMutation, StudentMedicalConditionUpdateMutationVariables>(
		StudentMedicalConditionUpdateDocument,
		options,
	);
}
export type StudentMedicalConditionUpdateMutationHookResult = ReturnType<
	typeof useStudentMedicalConditionUpdateMutation
>;
export type StudentMedicalConditionUpdateMutationResult = Apollo.MutationResult<StudentMedicalConditionUpdateMutation>;
export type StudentMedicalConditionUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentMedicalConditionUpdateMutation,
	StudentMedicalConditionUpdateMutationVariables
>;
export const StudentMedicalContactCountDocument = gql`
	query studentMedicalContactCount(
		$filters: [StudentMedicalContactFilterInput!]
		$pagination: Pagination
		$order: StudentMedicalContactOrder
	) {
		studentMedicalContactConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentMedicalContactCountQuery__
 *
 * To run a query within a React component, call `useStudentMedicalContactCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalContactCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalContactCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalContactCountQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicalContactCountQuery, StudentMedicalContactCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalContactCountQuery, StudentMedicalContactCountQueryVariables>(
		StudentMedicalContactCountDocument,
		options,
	);
}
export function useStudentMedicalContactCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMedicalContactCountQuery, StudentMedicalContactCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalContactCountQuery, StudentMedicalContactCountQueryVariables>(
		StudentMedicalContactCountDocument,
		options,
	);
}
export function useStudentMedicalContactCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalContactCountQuery,
		StudentMedicalContactCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalContactCountQuery, StudentMedicalContactCountQueryVariables>(
		StudentMedicalContactCountDocument,
		options,
	);
}
export type StudentMedicalContactCountQueryHookResult = ReturnType<typeof useStudentMedicalContactCountQuery>;
export type StudentMedicalContactCountLazyQueryHookResult = ReturnType<typeof useStudentMedicalContactCountLazyQuery>;
export type StudentMedicalContactCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalContactCountSuspenseQuery
>;
export type StudentMedicalContactCountQueryResult = Apollo.QueryResult<
	StudentMedicalContactCountQuery,
	StudentMedicalContactCountQueryVariables
>;
export const StudentMedicalContactCreateDocument = gql`
	mutation studentMedicalContactCreate($input: StudentMedicalContactCreateInput!) {
		createStudentMedicalContact(input: $input) {
			...StudentMedicalContactDetail
		}
	}
	${StudentMedicalContactDetailFragmentDoc}
`;
export type StudentMedicalContactCreateMutationFn = Apollo.MutationFunction<
	StudentMedicalContactCreateMutation,
	StudentMedicalContactCreateMutationVariables
>;

/**
 * __useStudentMedicalContactCreateMutation__
 *
 * To run a mutation, you first call `useStudentMedicalContactCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalContactCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentMedicalContactCreateMutation, { data, loading, error }] = useStudentMedicalContactCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentMedicalContactCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentMedicalContactCreateMutation,
		StudentMedicalContactCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentMedicalContactCreateMutation, StudentMedicalContactCreateMutationVariables>(
		StudentMedicalContactCreateDocument,
		options,
	);
}
export type StudentMedicalContactCreateMutationHookResult = ReturnType<typeof useStudentMedicalContactCreateMutation>;
export type StudentMedicalContactCreateMutationResult = Apollo.MutationResult<StudentMedicalContactCreateMutation>;
export type StudentMedicalContactCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentMedicalContactCreateMutation,
	StudentMedicalContactCreateMutationVariables
>;
export const StudentMedicalContactDeleteDocument = gql`
	mutation studentMedicalContactDelete($id: ID!) {
		deleteStudentMedicalContact(id: $id)
	}
`;
export type StudentMedicalContactDeleteMutationFn = Apollo.MutationFunction<
	StudentMedicalContactDeleteMutation,
	StudentMedicalContactDeleteMutationVariables
>;

/**
 * __useStudentMedicalContactDeleteMutation__
 *
 * To run a mutation, you first call `useStudentMedicalContactDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalContactDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentMedicalContactDeleteMutation, { data, loading, error }] = useStudentMedicalContactDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentMedicalContactDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentMedicalContactDeleteMutation,
		StudentMedicalContactDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentMedicalContactDeleteMutation, StudentMedicalContactDeleteMutationVariables>(
		StudentMedicalContactDeleteDocument,
		options,
	);
}
export type StudentMedicalContactDeleteMutationHookResult = ReturnType<typeof useStudentMedicalContactDeleteMutation>;
export type StudentMedicalContactDeleteMutationResult = Apollo.MutationResult<StudentMedicalContactDeleteMutation>;
export type StudentMedicalContactDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentMedicalContactDeleteMutation,
	StudentMedicalContactDeleteMutationVariables
>;
export const StudentMedicalContactDetailDocument = gql`
	query studentMedicalContactDetail($id: ID!) {
		studentMedicalContact(id: $id) {
			...StudentMedicalContactDetail
		}
	}
	${StudentMedicalContactDetailFragmentDoc}
`;

/**
 * __useStudentMedicalContactDetailQuery__
 *
 * To run a query within a React component, call `useStudentMedicalContactDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalContactDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalContactDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentMedicalContactDetailQuery(
	baseOptions: Apollo.QueryHookOptions<StudentMedicalContactDetailQuery, StudentMedicalContactDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalContactDetailQuery, StudentMedicalContactDetailQueryVariables>(
		StudentMedicalContactDetailDocument,
		options,
	);
}
export function useStudentMedicalContactDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicalContactDetailQuery,
		StudentMedicalContactDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalContactDetailQuery, StudentMedicalContactDetailQueryVariables>(
		StudentMedicalContactDetailDocument,
		options,
	);
}
export function useStudentMedicalContactDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalContactDetailQuery,
		StudentMedicalContactDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalContactDetailQuery, StudentMedicalContactDetailQueryVariables>(
		StudentMedicalContactDetailDocument,
		options,
	);
}
export type StudentMedicalContactDetailQueryHookResult = ReturnType<typeof useStudentMedicalContactDetailQuery>;
export type StudentMedicalContactDetailLazyQueryHookResult = ReturnType<typeof useStudentMedicalContactDetailLazyQuery>;
export type StudentMedicalContactDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalContactDetailSuspenseQuery
>;
export type StudentMedicalContactDetailQueryResult = Apollo.QueryResult<
	StudentMedicalContactDetailQuery,
	StudentMedicalContactDetailQueryVariables
>;
export const StudentMedicalContactIndexDocument = gql`
	query studentMedicalContactIndex(
		$filters: [StudentMedicalContactFilterInput!]
		$pagination: Pagination
		$order: StudentMedicalContactOrder
	) {
		studentMedicalContactConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					contactType
					institutionName
					phoneNumber
					emailAddress
					address
					notes
				}
			}
		}
	}
`;

/**
 * __useStudentMedicalContactIndexQuery__
 *
 * To run a query within a React component, call `useStudentMedicalContactIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalContactIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalContactIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalContactIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicalContactIndexQuery, StudentMedicalContactIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalContactIndexQuery, StudentMedicalContactIndexQueryVariables>(
		StudentMedicalContactIndexDocument,
		options,
	);
}
export function useStudentMedicalContactIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMedicalContactIndexQuery, StudentMedicalContactIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalContactIndexQuery, StudentMedicalContactIndexQueryVariables>(
		StudentMedicalContactIndexDocument,
		options,
	);
}
export function useStudentMedicalContactIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalContactIndexQuery,
		StudentMedicalContactIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalContactIndexQuery, StudentMedicalContactIndexQueryVariables>(
		StudentMedicalContactIndexDocument,
		options,
	);
}
export type StudentMedicalContactIndexQueryHookResult = ReturnType<typeof useStudentMedicalContactIndexQuery>;
export type StudentMedicalContactIndexLazyQueryHookResult = ReturnType<typeof useStudentMedicalContactIndexLazyQuery>;
export type StudentMedicalContactIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalContactIndexSuspenseQuery
>;
export type StudentMedicalContactIndexQueryResult = Apollo.QueryResult<
	StudentMedicalContactIndexQuery,
	StudentMedicalContactIndexQueryVariables
>;
export const StudentMedicalContactStudentListDocument = gql`
	query studentMedicalContactStudentList(
		$filters: [StudentMedicalContactFilterInput!]
		$pagination: Pagination
		$order: StudentMedicalContactOrder
	) {
		studentMedicalContactConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					contactType
					institutionName
					phoneNumber
					emailAddress
					address
					notes
				}
			}
		}
	}
`;

/**
 * __useStudentMedicalContactStudentListQuery__
 *
 * To run a query within a React component, call `useStudentMedicalContactStudentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalContactStudentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalContactStudentListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalContactStudentListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentMedicalContactStudentListQuery,
		StudentMedicalContactStudentListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalContactStudentListQuery, StudentMedicalContactStudentListQueryVariables>(
		StudentMedicalContactStudentListDocument,
		options,
	);
}
export function useStudentMedicalContactStudentListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicalContactStudentListQuery,
		StudentMedicalContactStudentListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalContactStudentListQuery, StudentMedicalContactStudentListQueryVariables>(
		StudentMedicalContactStudentListDocument,
		options,
	);
}
export function useStudentMedicalContactStudentListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalContactStudentListQuery,
		StudentMedicalContactStudentListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalContactStudentListQuery, StudentMedicalContactStudentListQueryVariables>(
		StudentMedicalContactStudentListDocument,
		options,
	);
}
export type StudentMedicalContactStudentListQueryHookResult = ReturnType<
	typeof useStudentMedicalContactStudentListQuery
>;
export type StudentMedicalContactStudentListLazyQueryHookResult = ReturnType<
	typeof useStudentMedicalContactStudentListLazyQuery
>;
export type StudentMedicalContactStudentListSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalContactStudentListSuspenseQuery
>;
export type StudentMedicalContactStudentListQueryResult = Apollo.QueryResult<
	StudentMedicalContactStudentListQuery,
	StudentMedicalContactStudentListQueryVariables
>;
export const StudentMedicalContactNameDocument = gql`
	query studentMedicalContactName($id: ID!) {
		studentMedicalContact(id: $id) {
			id
			...StudentMedicalContactName
		}
	}
	${StudentMedicalContactNameFragmentDoc}
`;

/**
 * __useStudentMedicalContactNameQuery__
 *
 * To run a query within a React component, call `useStudentMedicalContactNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalContactNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalContactNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentMedicalContactNameQuery(
	baseOptions: Apollo.QueryHookOptions<StudentMedicalContactNameQuery, StudentMedicalContactNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalContactNameQuery, StudentMedicalContactNameQueryVariables>(
		StudentMedicalContactNameDocument,
		options,
	);
}
export function useStudentMedicalContactNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMedicalContactNameQuery, StudentMedicalContactNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalContactNameQuery, StudentMedicalContactNameQueryVariables>(
		StudentMedicalContactNameDocument,
		options,
	);
}
export function useStudentMedicalContactNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalContactNameQuery,
		StudentMedicalContactNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalContactNameQuery, StudentMedicalContactNameQueryVariables>(
		StudentMedicalContactNameDocument,
		options,
	);
}
export type StudentMedicalContactNameQueryHookResult = ReturnType<typeof useStudentMedicalContactNameQuery>;
export type StudentMedicalContactNameLazyQueryHookResult = ReturnType<typeof useStudentMedicalContactNameLazyQuery>;
export type StudentMedicalContactNameSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalContactNameSuspenseQuery
>;
export type StudentMedicalContactNameQueryResult = Apollo.QueryResult<
	StudentMedicalContactNameQuery,
	StudentMedicalContactNameQueryVariables
>;
export const StudentMedicalContactNamesDocument = gql`
	query studentMedicalContactNames(
		$filters: [StudentMedicalContactFilterInput!]
		$pagination: Pagination
		$order: StudentMedicalContactOrder
	) {
		studentMedicalContactConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentMedicalContactName
				}
			}
		}
	}
	${StudentMedicalContactNameFragmentDoc}
`;

/**
 * __useStudentMedicalContactNamesQuery__
 *
 * To run a query within a React component, call `useStudentMedicalContactNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalContactNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalContactNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalContactNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicalContactNamesQuery, StudentMedicalContactNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalContactNamesQuery, StudentMedicalContactNamesQueryVariables>(
		StudentMedicalContactNamesDocument,
		options,
	);
}
export function useStudentMedicalContactNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMedicalContactNamesQuery, StudentMedicalContactNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalContactNamesQuery, StudentMedicalContactNamesQueryVariables>(
		StudentMedicalContactNamesDocument,
		options,
	);
}
export function useStudentMedicalContactNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalContactNamesQuery,
		StudentMedicalContactNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalContactNamesQuery, StudentMedicalContactNamesQueryVariables>(
		StudentMedicalContactNamesDocument,
		options,
	);
}
export type StudentMedicalContactNamesQueryHookResult = ReturnType<typeof useStudentMedicalContactNamesQuery>;
export type StudentMedicalContactNamesLazyQueryHookResult = ReturnType<typeof useStudentMedicalContactNamesLazyQuery>;
export type StudentMedicalContactNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalContactNamesSuspenseQuery
>;
export type StudentMedicalContactNamesQueryResult = Apollo.QueryResult<
	StudentMedicalContactNamesQuery,
	StudentMedicalContactNamesQueryVariables
>;
export const StudentMedicalContactPaginationDocument = gql`
	query studentMedicalContactPagination(
		$filters: [StudentMedicalContactFilterInput!]
		$order: StudentMedicalContactOrder
	) {
		studentMedicalContactConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentMedicalContactPaginationQuery__
 *
 * To run a query within a React component, call `useStudentMedicalContactPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalContactPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalContactPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalContactPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentMedicalContactPaginationQuery,
		StudentMedicalContactPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalContactPaginationQuery, StudentMedicalContactPaginationQueryVariables>(
		StudentMedicalContactPaginationDocument,
		options,
	);
}
export function useStudentMedicalContactPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicalContactPaginationQuery,
		StudentMedicalContactPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalContactPaginationQuery, StudentMedicalContactPaginationQueryVariables>(
		StudentMedicalContactPaginationDocument,
		options,
	);
}
export function useStudentMedicalContactPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalContactPaginationQuery,
		StudentMedicalContactPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalContactPaginationQuery, StudentMedicalContactPaginationQueryVariables>(
		StudentMedicalContactPaginationDocument,
		options,
	);
}
export type StudentMedicalContactPaginationQueryHookResult = ReturnType<typeof useStudentMedicalContactPaginationQuery>;
export type StudentMedicalContactPaginationLazyQueryHookResult = ReturnType<
	typeof useStudentMedicalContactPaginationLazyQuery
>;
export type StudentMedicalContactPaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalContactPaginationSuspenseQuery
>;
export type StudentMedicalContactPaginationQueryResult = Apollo.QueryResult<
	StudentMedicalContactPaginationQuery,
	StudentMedicalContactPaginationQueryVariables
>;
export const StudentMedicalContactSelectDocument = gql`
	query studentMedicalContactSelect($filters: [StudentMedicalContactFilterInput!], $order: StudentMedicalContactOrder) {
		studentMedicalContactConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentMedicalContactName
				}
			}
		}
	}
	${StudentMedicalContactNameFragmentDoc}
`;

/**
 * __useStudentMedicalContactSelectQuery__
 *
 * To run a query within a React component, call `useStudentMedicalContactSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalContactSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalContactSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalContactSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicalContactSelectQuery, StudentMedicalContactSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalContactSelectQuery, StudentMedicalContactSelectQueryVariables>(
		StudentMedicalContactSelectDocument,
		options,
	);
}
export function useStudentMedicalContactSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicalContactSelectQuery,
		StudentMedicalContactSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalContactSelectQuery, StudentMedicalContactSelectQueryVariables>(
		StudentMedicalContactSelectDocument,
		options,
	);
}
export function useStudentMedicalContactSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalContactSelectQuery,
		StudentMedicalContactSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalContactSelectQuery, StudentMedicalContactSelectQueryVariables>(
		StudentMedicalContactSelectDocument,
		options,
	);
}
export type StudentMedicalContactSelectQueryHookResult = ReturnType<typeof useStudentMedicalContactSelectQuery>;
export type StudentMedicalContactSelectLazyQueryHookResult = ReturnType<typeof useStudentMedicalContactSelectLazyQuery>;
export type StudentMedicalContactSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalContactSelectSuspenseQuery
>;
export type StudentMedicalContactSelectQueryResult = Apollo.QueryResult<
	StudentMedicalContactSelectQuery,
	StudentMedicalContactSelectQueryVariables
>;
export const StudentMedicalContactUpdateDocument = gql`
	mutation studentMedicalContactUpdate($id: ID!, $input: StudentMedicalContactUpdateInput!) {
		updateStudentMedicalContact(id: $id, input: $input) {
			...StudentMedicalContactDetail
		}
	}
	${StudentMedicalContactDetailFragmentDoc}
`;
export type StudentMedicalContactUpdateMutationFn = Apollo.MutationFunction<
	StudentMedicalContactUpdateMutation,
	StudentMedicalContactUpdateMutationVariables
>;

/**
 * __useStudentMedicalContactUpdateMutation__
 *
 * To run a mutation, you first call `useStudentMedicalContactUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalContactUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentMedicalContactUpdateMutation, { data, loading, error }] = useStudentMedicalContactUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentMedicalContactUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentMedicalContactUpdateMutation,
		StudentMedicalContactUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentMedicalContactUpdateMutation, StudentMedicalContactUpdateMutationVariables>(
		StudentMedicalContactUpdateDocument,
		options,
	);
}
export type StudentMedicalContactUpdateMutationHookResult = ReturnType<typeof useStudentMedicalContactUpdateMutation>;
export type StudentMedicalContactUpdateMutationResult = Apollo.MutationResult<StudentMedicalContactUpdateMutation>;
export type StudentMedicalContactUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentMedicalContactUpdateMutation,
	StudentMedicalContactUpdateMutationVariables
>;
export const StudentMedicalEventCountDocument = gql`
	query studentMedicalEventCount(
		$filters: [StudentMedicalEventFilterInput!]
		$pagination: Pagination
		$order: StudentMedicalEventOrder
	) {
		studentMedicalEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentMedicalEventCountQuery__
 *
 * To run a query within a React component, call `useStudentMedicalEventCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalEventCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalEventCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalEventCountQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicalEventCountQuery, StudentMedicalEventCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalEventCountQuery, StudentMedicalEventCountQueryVariables>(
		StudentMedicalEventCountDocument,
		options,
	);
}
export function useStudentMedicalEventCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMedicalEventCountQuery, StudentMedicalEventCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalEventCountQuery, StudentMedicalEventCountQueryVariables>(
		StudentMedicalEventCountDocument,
		options,
	);
}
export function useStudentMedicalEventCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentMedicalEventCountQuery, StudentMedicalEventCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalEventCountQuery, StudentMedicalEventCountQueryVariables>(
		StudentMedicalEventCountDocument,
		options,
	);
}
export type StudentMedicalEventCountQueryHookResult = ReturnType<typeof useStudentMedicalEventCountQuery>;
export type StudentMedicalEventCountLazyQueryHookResult = ReturnType<typeof useStudentMedicalEventCountLazyQuery>;
export type StudentMedicalEventCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalEventCountSuspenseQuery
>;
export type StudentMedicalEventCountQueryResult = Apollo.QueryResult<
	StudentMedicalEventCountQuery,
	StudentMedicalEventCountQueryVariables
>;
export const StudentMedicalEventCreateDocument = gql`
	mutation studentMedicalEventCreate($input: StudentMedicalEventCreateInput!) {
		createStudentMedicalEvent(input: $input) {
			...StudentMedicalEventDetail
		}
	}
	${StudentMedicalEventDetailFragmentDoc}
`;
export type StudentMedicalEventCreateMutationFn = Apollo.MutationFunction<
	StudentMedicalEventCreateMutation,
	StudentMedicalEventCreateMutationVariables
>;

/**
 * __useStudentMedicalEventCreateMutation__
 *
 * To run a mutation, you first call `useStudentMedicalEventCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalEventCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentMedicalEventCreateMutation, { data, loading, error }] = useStudentMedicalEventCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentMedicalEventCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentMedicalEventCreateMutation,
		StudentMedicalEventCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentMedicalEventCreateMutation, StudentMedicalEventCreateMutationVariables>(
		StudentMedicalEventCreateDocument,
		options,
	);
}
export type StudentMedicalEventCreateMutationHookResult = ReturnType<typeof useStudentMedicalEventCreateMutation>;
export type StudentMedicalEventCreateMutationResult = Apollo.MutationResult<StudentMedicalEventCreateMutation>;
export type StudentMedicalEventCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentMedicalEventCreateMutation,
	StudentMedicalEventCreateMutationVariables
>;
export const StudentMedicalEventDeleteDocument = gql`
	mutation studentMedicalEventDelete($id: ID!) {
		deleteStudentMedicalEvent(id: $id)
	}
`;
export type StudentMedicalEventDeleteMutationFn = Apollo.MutationFunction<
	StudentMedicalEventDeleteMutation,
	StudentMedicalEventDeleteMutationVariables
>;

/**
 * __useStudentMedicalEventDeleteMutation__
 *
 * To run a mutation, you first call `useStudentMedicalEventDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalEventDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentMedicalEventDeleteMutation, { data, loading, error }] = useStudentMedicalEventDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentMedicalEventDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentMedicalEventDeleteMutation,
		StudentMedicalEventDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentMedicalEventDeleteMutation, StudentMedicalEventDeleteMutationVariables>(
		StudentMedicalEventDeleteDocument,
		options,
	);
}
export type StudentMedicalEventDeleteMutationHookResult = ReturnType<typeof useStudentMedicalEventDeleteMutation>;
export type StudentMedicalEventDeleteMutationResult = Apollo.MutationResult<StudentMedicalEventDeleteMutation>;
export type StudentMedicalEventDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentMedicalEventDeleteMutation,
	StudentMedicalEventDeleteMutationVariables
>;
export const StudentMedicalEventDetailDocument = gql`
	query studentMedicalEventDetail($id: ID!) {
		studentMedicalEvent(id: $id) {
			...StudentMedicalEventDetail
		}
	}
	${StudentMedicalEventDetailFragmentDoc}
`;

/**
 * __useStudentMedicalEventDetailQuery__
 *
 * To run a query within a React component, call `useStudentMedicalEventDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalEventDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalEventDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentMedicalEventDetailQuery(
	baseOptions: Apollo.QueryHookOptions<StudentMedicalEventDetailQuery, StudentMedicalEventDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalEventDetailQuery, StudentMedicalEventDetailQueryVariables>(
		StudentMedicalEventDetailDocument,
		options,
	);
}
export function useStudentMedicalEventDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMedicalEventDetailQuery, StudentMedicalEventDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalEventDetailQuery, StudentMedicalEventDetailQueryVariables>(
		StudentMedicalEventDetailDocument,
		options,
	);
}
export function useStudentMedicalEventDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalEventDetailQuery,
		StudentMedicalEventDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalEventDetailQuery, StudentMedicalEventDetailQueryVariables>(
		StudentMedicalEventDetailDocument,
		options,
	);
}
export type StudentMedicalEventDetailQueryHookResult = ReturnType<typeof useStudentMedicalEventDetailQuery>;
export type StudentMedicalEventDetailLazyQueryHookResult = ReturnType<typeof useStudentMedicalEventDetailLazyQuery>;
export type StudentMedicalEventDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalEventDetailSuspenseQuery
>;
export type StudentMedicalEventDetailQueryResult = Apollo.QueryResult<
	StudentMedicalEventDetailQuery,
	StudentMedicalEventDetailQueryVariables
>;
export const StudentMedicalEventIndexDocument = gql`
	query studentMedicalEventIndex(
		$filters: [StudentMedicalEventFilterInput!]
		$pagination: Pagination
		$order: StudentMedicalEventOrder
	) {
		studentMedicalEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					checkInTime
					checkOutTime
					description
					treatment
					outcome
					notes
				}
			}
		}
	}
`;

/**
 * __useStudentMedicalEventIndexQuery__
 *
 * To run a query within a React component, call `useStudentMedicalEventIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalEventIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalEventIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalEventIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicalEventIndexQuery, StudentMedicalEventIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalEventIndexQuery, StudentMedicalEventIndexQueryVariables>(
		StudentMedicalEventIndexDocument,
		options,
	);
}
export function useStudentMedicalEventIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMedicalEventIndexQuery, StudentMedicalEventIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalEventIndexQuery, StudentMedicalEventIndexQueryVariables>(
		StudentMedicalEventIndexDocument,
		options,
	);
}
export function useStudentMedicalEventIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentMedicalEventIndexQuery, StudentMedicalEventIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalEventIndexQuery, StudentMedicalEventIndexQueryVariables>(
		StudentMedicalEventIndexDocument,
		options,
	);
}
export type StudentMedicalEventIndexQueryHookResult = ReturnType<typeof useStudentMedicalEventIndexQuery>;
export type StudentMedicalEventIndexLazyQueryHookResult = ReturnType<typeof useStudentMedicalEventIndexLazyQuery>;
export type StudentMedicalEventIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalEventIndexSuspenseQuery
>;
export type StudentMedicalEventIndexQueryResult = Apollo.QueryResult<
	StudentMedicalEventIndexQuery,
	StudentMedicalEventIndexQueryVariables
>;
export const StudentMedicalEventNameDocument = gql`
	query studentMedicalEventName($id: ID!) {
		studentMedicalEvent(id: $id) {
			id
			...StudentMedicalEventName
		}
	}
	${StudentMedicalEventNameFragmentDoc}
`;

/**
 * __useStudentMedicalEventNameQuery__
 *
 * To run a query within a React component, call `useStudentMedicalEventNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalEventNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalEventNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentMedicalEventNameQuery(
	baseOptions: Apollo.QueryHookOptions<StudentMedicalEventNameQuery, StudentMedicalEventNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalEventNameQuery, StudentMedicalEventNameQueryVariables>(
		StudentMedicalEventNameDocument,
		options,
	);
}
export function useStudentMedicalEventNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMedicalEventNameQuery, StudentMedicalEventNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalEventNameQuery, StudentMedicalEventNameQueryVariables>(
		StudentMedicalEventNameDocument,
		options,
	);
}
export function useStudentMedicalEventNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentMedicalEventNameQuery, StudentMedicalEventNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalEventNameQuery, StudentMedicalEventNameQueryVariables>(
		StudentMedicalEventNameDocument,
		options,
	);
}
export type StudentMedicalEventNameQueryHookResult = ReturnType<typeof useStudentMedicalEventNameQuery>;
export type StudentMedicalEventNameLazyQueryHookResult = ReturnType<typeof useStudentMedicalEventNameLazyQuery>;
export type StudentMedicalEventNameSuspenseQueryHookResult = ReturnType<typeof useStudentMedicalEventNameSuspenseQuery>;
export type StudentMedicalEventNameQueryResult = Apollo.QueryResult<
	StudentMedicalEventNameQuery,
	StudentMedicalEventNameQueryVariables
>;
export const StudentMedicalEventNamesDocument = gql`
	query studentMedicalEventNames(
		$filters: [StudentMedicalEventFilterInput!]
		$pagination: Pagination
		$order: StudentMedicalEventOrder
	) {
		studentMedicalEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentMedicalEventName
				}
			}
		}
	}
	${StudentMedicalEventNameFragmentDoc}
`;

/**
 * __useStudentMedicalEventNamesQuery__
 *
 * To run a query within a React component, call `useStudentMedicalEventNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalEventNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalEventNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalEventNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicalEventNamesQuery, StudentMedicalEventNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalEventNamesQuery, StudentMedicalEventNamesQueryVariables>(
		StudentMedicalEventNamesDocument,
		options,
	);
}
export function useStudentMedicalEventNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMedicalEventNamesQuery, StudentMedicalEventNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalEventNamesQuery, StudentMedicalEventNamesQueryVariables>(
		StudentMedicalEventNamesDocument,
		options,
	);
}
export function useStudentMedicalEventNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentMedicalEventNamesQuery, StudentMedicalEventNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalEventNamesQuery, StudentMedicalEventNamesQueryVariables>(
		StudentMedicalEventNamesDocument,
		options,
	);
}
export type StudentMedicalEventNamesQueryHookResult = ReturnType<typeof useStudentMedicalEventNamesQuery>;
export type StudentMedicalEventNamesLazyQueryHookResult = ReturnType<typeof useStudentMedicalEventNamesLazyQuery>;
export type StudentMedicalEventNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalEventNamesSuspenseQuery
>;
export type StudentMedicalEventNamesQueryResult = Apollo.QueryResult<
	StudentMedicalEventNamesQuery,
	StudentMedicalEventNamesQueryVariables
>;
export const StudentMedicalEventPaginationDocument = gql`
	query studentMedicalEventPagination($filters: [StudentMedicalEventFilterInput!], $order: StudentMedicalEventOrder) {
		studentMedicalEventConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentMedicalEventPaginationQuery__
 *
 * To run a query within a React component, call `useStudentMedicalEventPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalEventPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalEventPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalEventPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentMedicalEventPaginationQuery,
		StudentMedicalEventPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalEventPaginationQuery, StudentMedicalEventPaginationQueryVariables>(
		StudentMedicalEventPaginationDocument,
		options,
	);
}
export function useStudentMedicalEventPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicalEventPaginationQuery,
		StudentMedicalEventPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalEventPaginationQuery, StudentMedicalEventPaginationQueryVariables>(
		StudentMedicalEventPaginationDocument,
		options,
	);
}
export function useStudentMedicalEventPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalEventPaginationQuery,
		StudentMedicalEventPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalEventPaginationQuery, StudentMedicalEventPaginationQueryVariables>(
		StudentMedicalEventPaginationDocument,
		options,
	);
}
export type StudentMedicalEventPaginationQueryHookResult = ReturnType<typeof useStudentMedicalEventPaginationQuery>;
export type StudentMedicalEventPaginationLazyQueryHookResult = ReturnType<
	typeof useStudentMedicalEventPaginationLazyQuery
>;
export type StudentMedicalEventPaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalEventPaginationSuspenseQuery
>;
export type StudentMedicalEventPaginationQueryResult = Apollo.QueryResult<
	StudentMedicalEventPaginationQuery,
	StudentMedicalEventPaginationQueryVariables
>;
export const StudentMedicalEventSelectDocument = gql`
	query studentMedicalEventSelect($filters: [StudentMedicalEventFilterInput!], $order: StudentMedicalEventOrder) {
		studentMedicalEventConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentMedicalEventName
				}
			}
		}
	}
	${StudentMedicalEventNameFragmentDoc}
`;

/**
 * __useStudentMedicalEventSelectQuery__
 *
 * To run a query within a React component, call `useStudentMedicalEventSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalEventSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalEventSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalEventSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicalEventSelectQuery, StudentMedicalEventSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalEventSelectQuery, StudentMedicalEventSelectQueryVariables>(
		StudentMedicalEventSelectDocument,
		options,
	);
}
export function useStudentMedicalEventSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMedicalEventSelectQuery, StudentMedicalEventSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalEventSelectQuery, StudentMedicalEventSelectQueryVariables>(
		StudentMedicalEventSelectDocument,
		options,
	);
}
export function useStudentMedicalEventSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalEventSelectQuery,
		StudentMedicalEventSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalEventSelectQuery, StudentMedicalEventSelectQueryVariables>(
		StudentMedicalEventSelectDocument,
		options,
	);
}
export type StudentMedicalEventSelectQueryHookResult = ReturnType<typeof useStudentMedicalEventSelectQuery>;
export type StudentMedicalEventSelectLazyQueryHookResult = ReturnType<typeof useStudentMedicalEventSelectLazyQuery>;
export type StudentMedicalEventSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalEventSelectSuspenseQuery
>;
export type StudentMedicalEventSelectQueryResult = Apollo.QueryResult<
	StudentMedicalEventSelectQuery,
	StudentMedicalEventSelectQueryVariables
>;
export const StudentMedicalEventUpdateDocument = gql`
	mutation studentMedicalEventUpdate($id: ID!, $input: StudentMedicalEventUpdateInput!) {
		updateStudentMedicalEvent(id: $id, input: $input) {
			...StudentMedicalEventDetail
		}
	}
	${StudentMedicalEventDetailFragmentDoc}
`;
export type StudentMedicalEventUpdateMutationFn = Apollo.MutationFunction<
	StudentMedicalEventUpdateMutation,
	StudentMedicalEventUpdateMutationVariables
>;

/**
 * __useStudentMedicalEventUpdateMutation__
 *
 * To run a mutation, you first call `useStudentMedicalEventUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalEventUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentMedicalEventUpdateMutation, { data, loading, error }] = useStudentMedicalEventUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentMedicalEventUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentMedicalEventUpdateMutation,
		StudentMedicalEventUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentMedicalEventUpdateMutation, StudentMedicalEventUpdateMutationVariables>(
		StudentMedicalEventUpdateDocument,
		options,
	);
}
export type StudentMedicalEventUpdateMutationHookResult = ReturnType<typeof useStudentMedicalEventUpdateMutation>;
export type StudentMedicalEventUpdateMutationResult = Apollo.MutationResult<StudentMedicalEventUpdateMutation>;
export type StudentMedicalEventUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentMedicalEventUpdateMutation,
	StudentMedicalEventUpdateMutationVariables
>;
export const StudentMedicalProfileCountDocument = gql`
	query studentMedicalProfileCount(
		$filters: [StudentMedicalProfileFilterInput!]
		$pagination: Pagination
		$order: StudentMedicalProfileOrder
	) {
		studentMedicalProfileConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentMedicalProfileCountQuery__
 *
 * To run a query within a React component, call `useStudentMedicalProfileCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalProfileCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalProfileCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalProfileCountQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicalProfileCountQuery, StudentMedicalProfileCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalProfileCountQuery, StudentMedicalProfileCountQueryVariables>(
		StudentMedicalProfileCountDocument,
		options,
	);
}
export function useStudentMedicalProfileCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMedicalProfileCountQuery, StudentMedicalProfileCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalProfileCountQuery, StudentMedicalProfileCountQueryVariables>(
		StudentMedicalProfileCountDocument,
		options,
	);
}
export function useStudentMedicalProfileCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalProfileCountQuery,
		StudentMedicalProfileCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalProfileCountQuery, StudentMedicalProfileCountQueryVariables>(
		StudentMedicalProfileCountDocument,
		options,
	);
}
export type StudentMedicalProfileCountQueryHookResult = ReturnType<typeof useStudentMedicalProfileCountQuery>;
export type StudentMedicalProfileCountLazyQueryHookResult = ReturnType<typeof useStudentMedicalProfileCountLazyQuery>;
export type StudentMedicalProfileCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalProfileCountSuspenseQuery
>;
export type StudentMedicalProfileCountQueryResult = Apollo.QueryResult<
	StudentMedicalProfileCountQuery,
	StudentMedicalProfileCountQueryVariables
>;
export const StudentMedicalProfileCreateDocument = gql`
	mutation studentMedicalProfileCreate($input: StudentMedicalProfileCreateInput!) {
		createStudentMedicalProfile(input: $input) {
			...StudentMedicalProfileDetail
		}
	}
	${StudentMedicalProfileDetailFragmentDoc}
`;
export type StudentMedicalProfileCreateMutationFn = Apollo.MutationFunction<
	StudentMedicalProfileCreateMutation,
	StudentMedicalProfileCreateMutationVariables
>;

/**
 * __useStudentMedicalProfileCreateMutation__
 *
 * To run a mutation, you first call `useStudentMedicalProfileCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalProfileCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentMedicalProfileCreateMutation, { data, loading, error }] = useStudentMedicalProfileCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentMedicalProfileCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentMedicalProfileCreateMutation,
		StudentMedicalProfileCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentMedicalProfileCreateMutation, StudentMedicalProfileCreateMutationVariables>(
		StudentMedicalProfileCreateDocument,
		options,
	);
}
export type StudentMedicalProfileCreateMutationHookResult = ReturnType<typeof useStudentMedicalProfileCreateMutation>;
export type StudentMedicalProfileCreateMutationResult = Apollo.MutationResult<StudentMedicalProfileCreateMutation>;
export type StudentMedicalProfileCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentMedicalProfileCreateMutation,
	StudentMedicalProfileCreateMutationVariables
>;
export const StudentMedicalProfileDeleteDocument = gql`
	mutation studentMedicalProfileDelete($id: ID!) {
		deleteStudentMedicalProfile(id: $id)
	}
`;
export type StudentMedicalProfileDeleteMutationFn = Apollo.MutationFunction<
	StudentMedicalProfileDeleteMutation,
	StudentMedicalProfileDeleteMutationVariables
>;

/**
 * __useStudentMedicalProfileDeleteMutation__
 *
 * To run a mutation, you first call `useStudentMedicalProfileDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalProfileDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentMedicalProfileDeleteMutation, { data, loading, error }] = useStudentMedicalProfileDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentMedicalProfileDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentMedicalProfileDeleteMutation,
		StudentMedicalProfileDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentMedicalProfileDeleteMutation, StudentMedicalProfileDeleteMutationVariables>(
		StudentMedicalProfileDeleteDocument,
		options,
	);
}
export type StudentMedicalProfileDeleteMutationHookResult = ReturnType<typeof useStudentMedicalProfileDeleteMutation>;
export type StudentMedicalProfileDeleteMutationResult = Apollo.MutationResult<StudentMedicalProfileDeleteMutation>;
export type StudentMedicalProfileDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentMedicalProfileDeleteMutation,
	StudentMedicalProfileDeleteMutationVariables
>;
export const StudentMedicalProfileDetailDocument = gql`
	query studentMedicalProfileDetail($id: ID!) {
		studentMedicalProfile(id: $id) {
			...StudentMedicalProfileDetail
		}
	}
	${StudentMedicalProfileDetailFragmentDoc}
`;

/**
 * __useStudentMedicalProfileDetailQuery__
 *
 * To run a query within a React component, call `useStudentMedicalProfileDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalProfileDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalProfileDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentMedicalProfileDetailQuery(
	baseOptions: Apollo.QueryHookOptions<StudentMedicalProfileDetailQuery, StudentMedicalProfileDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalProfileDetailQuery, StudentMedicalProfileDetailQueryVariables>(
		StudentMedicalProfileDetailDocument,
		options,
	);
}
export function useStudentMedicalProfileDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicalProfileDetailQuery,
		StudentMedicalProfileDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalProfileDetailQuery, StudentMedicalProfileDetailQueryVariables>(
		StudentMedicalProfileDetailDocument,
		options,
	);
}
export function useStudentMedicalProfileDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalProfileDetailQuery,
		StudentMedicalProfileDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalProfileDetailQuery, StudentMedicalProfileDetailQueryVariables>(
		StudentMedicalProfileDetailDocument,
		options,
	);
}
export type StudentMedicalProfileDetailQueryHookResult = ReturnType<typeof useStudentMedicalProfileDetailQuery>;
export type StudentMedicalProfileDetailLazyQueryHookResult = ReturnType<typeof useStudentMedicalProfileDetailLazyQuery>;
export type StudentMedicalProfileDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalProfileDetailSuspenseQuery
>;
export type StudentMedicalProfileDetailQueryResult = Apollo.QueryResult<
	StudentMedicalProfileDetailQuery,
	StudentMedicalProfileDetailQueryVariables
>;
export const StudentMedicalProfileIndexDocument = gql`
	query studentMedicalProfileIndex(
		$filters: [StudentMedicalProfileFilterInput!]
		$pagination: Pagination
		$order: StudentMedicalProfileOrder
	) {
		studentMedicalProfileConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					isSchoolAllowedToTreat
					isSchoolAllowedToUseEpipen
				}
			}
		}
	}
`;

/**
 * __useStudentMedicalProfileIndexQuery__
 *
 * To run a query within a React component, call `useStudentMedicalProfileIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalProfileIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalProfileIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalProfileIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicalProfileIndexQuery, StudentMedicalProfileIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalProfileIndexQuery, StudentMedicalProfileIndexQueryVariables>(
		StudentMedicalProfileIndexDocument,
		options,
	);
}
export function useStudentMedicalProfileIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMedicalProfileIndexQuery, StudentMedicalProfileIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalProfileIndexQuery, StudentMedicalProfileIndexQueryVariables>(
		StudentMedicalProfileIndexDocument,
		options,
	);
}
export function useStudentMedicalProfileIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalProfileIndexQuery,
		StudentMedicalProfileIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalProfileIndexQuery, StudentMedicalProfileIndexQueryVariables>(
		StudentMedicalProfileIndexDocument,
		options,
	);
}
export type StudentMedicalProfileIndexQueryHookResult = ReturnType<typeof useStudentMedicalProfileIndexQuery>;
export type StudentMedicalProfileIndexLazyQueryHookResult = ReturnType<typeof useStudentMedicalProfileIndexLazyQuery>;
export type StudentMedicalProfileIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalProfileIndexSuspenseQuery
>;
export type StudentMedicalProfileIndexQueryResult = Apollo.QueryResult<
	StudentMedicalProfileIndexQuery,
	StudentMedicalProfileIndexQueryVariables
>;
export const StudentMedicalProfileNameDocument = gql`
	query studentMedicalProfileName($id: ID!) {
		studentMedicalProfile(id: $id) {
			id
			...StudentMedicalProfileName
		}
	}
	${StudentMedicalProfileNameFragmentDoc}
`;

/**
 * __useStudentMedicalProfileNameQuery__
 *
 * To run a query within a React component, call `useStudentMedicalProfileNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalProfileNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalProfileNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentMedicalProfileNameQuery(
	baseOptions: Apollo.QueryHookOptions<StudentMedicalProfileNameQuery, StudentMedicalProfileNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalProfileNameQuery, StudentMedicalProfileNameQueryVariables>(
		StudentMedicalProfileNameDocument,
		options,
	);
}
export function useStudentMedicalProfileNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMedicalProfileNameQuery, StudentMedicalProfileNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalProfileNameQuery, StudentMedicalProfileNameQueryVariables>(
		StudentMedicalProfileNameDocument,
		options,
	);
}
export function useStudentMedicalProfileNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalProfileNameQuery,
		StudentMedicalProfileNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalProfileNameQuery, StudentMedicalProfileNameQueryVariables>(
		StudentMedicalProfileNameDocument,
		options,
	);
}
export type StudentMedicalProfileNameQueryHookResult = ReturnType<typeof useStudentMedicalProfileNameQuery>;
export type StudentMedicalProfileNameLazyQueryHookResult = ReturnType<typeof useStudentMedicalProfileNameLazyQuery>;
export type StudentMedicalProfileNameSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalProfileNameSuspenseQuery
>;
export type StudentMedicalProfileNameQueryResult = Apollo.QueryResult<
	StudentMedicalProfileNameQuery,
	StudentMedicalProfileNameQueryVariables
>;
export const StudentMedicalProfileNamesDocument = gql`
	query studentMedicalProfileNames(
		$filters: [StudentMedicalProfileFilterInput!]
		$pagination: Pagination
		$order: StudentMedicalProfileOrder
	) {
		studentMedicalProfileConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentMedicalProfileName
				}
			}
		}
	}
	${StudentMedicalProfileNameFragmentDoc}
`;

/**
 * __useStudentMedicalProfileNamesQuery__
 *
 * To run a query within a React component, call `useStudentMedicalProfileNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalProfileNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalProfileNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalProfileNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicalProfileNamesQuery, StudentMedicalProfileNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalProfileNamesQuery, StudentMedicalProfileNamesQueryVariables>(
		StudentMedicalProfileNamesDocument,
		options,
	);
}
export function useStudentMedicalProfileNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMedicalProfileNamesQuery, StudentMedicalProfileNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalProfileNamesQuery, StudentMedicalProfileNamesQueryVariables>(
		StudentMedicalProfileNamesDocument,
		options,
	);
}
export function useStudentMedicalProfileNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalProfileNamesQuery,
		StudentMedicalProfileNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalProfileNamesQuery, StudentMedicalProfileNamesQueryVariables>(
		StudentMedicalProfileNamesDocument,
		options,
	);
}
export type StudentMedicalProfileNamesQueryHookResult = ReturnType<typeof useStudentMedicalProfileNamesQuery>;
export type StudentMedicalProfileNamesLazyQueryHookResult = ReturnType<typeof useStudentMedicalProfileNamesLazyQuery>;
export type StudentMedicalProfileNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalProfileNamesSuspenseQuery
>;
export type StudentMedicalProfileNamesQueryResult = Apollo.QueryResult<
	StudentMedicalProfileNamesQuery,
	StudentMedicalProfileNamesQueryVariables
>;
export const StudentMedicalProfilePaginationDocument = gql`
	query studentMedicalProfilePagination(
		$filters: [StudentMedicalProfileFilterInput!]
		$order: StudentMedicalProfileOrder
	) {
		studentMedicalProfileConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentMedicalProfilePaginationQuery__
 *
 * To run a query within a React component, call `useStudentMedicalProfilePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalProfilePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalProfilePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalProfilePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentMedicalProfilePaginationQuery,
		StudentMedicalProfilePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalProfilePaginationQuery, StudentMedicalProfilePaginationQueryVariables>(
		StudentMedicalProfilePaginationDocument,
		options,
	);
}
export function useStudentMedicalProfilePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicalProfilePaginationQuery,
		StudentMedicalProfilePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalProfilePaginationQuery, StudentMedicalProfilePaginationQueryVariables>(
		StudentMedicalProfilePaginationDocument,
		options,
	);
}
export function useStudentMedicalProfilePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalProfilePaginationQuery,
		StudentMedicalProfilePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalProfilePaginationQuery, StudentMedicalProfilePaginationQueryVariables>(
		StudentMedicalProfilePaginationDocument,
		options,
	);
}
export type StudentMedicalProfilePaginationQueryHookResult = ReturnType<typeof useStudentMedicalProfilePaginationQuery>;
export type StudentMedicalProfilePaginationLazyQueryHookResult = ReturnType<
	typeof useStudentMedicalProfilePaginationLazyQuery
>;
export type StudentMedicalProfilePaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalProfilePaginationSuspenseQuery
>;
export type StudentMedicalProfilePaginationQueryResult = Apollo.QueryResult<
	StudentMedicalProfilePaginationQuery,
	StudentMedicalProfilePaginationQueryVariables
>;
export const StudentMedicalProfileSelectDocument = gql`
	query studentMedicalProfileSelect($filters: [StudentMedicalProfileFilterInput!], $order: StudentMedicalProfileOrder) {
		studentMedicalProfileConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentMedicalProfileName
				}
			}
		}
	}
	${StudentMedicalProfileNameFragmentDoc}
`;

/**
 * __useStudentMedicalProfileSelectQuery__
 *
 * To run a query within a React component, call `useStudentMedicalProfileSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalProfileSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicalProfileSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicalProfileSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicalProfileSelectQuery, StudentMedicalProfileSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicalProfileSelectQuery, StudentMedicalProfileSelectQueryVariables>(
		StudentMedicalProfileSelectDocument,
		options,
	);
}
export function useStudentMedicalProfileSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicalProfileSelectQuery,
		StudentMedicalProfileSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicalProfileSelectQuery, StudentMedicalProfileSelectQueryVariables>(
		StudentMedicalProfileSelectDocument,
		options,
	);
}
export function useStudentMedicalProfileSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicalProfileSelectQuery,
		StudentMedicalProfileSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicalProfileSelectQuery, StudentMedicalProfileSelectQueryVariables>(
		StudentMedicalProfileSelectDocument,
		options,
	);
}
export type StudentMedicalProfileSelectQueryHookResult = ReturnType<typeof useStudentMedicalProfileSelectQuery>;
export type StudentMedicalProfileSelectLazyQueryHookResult = ReturnType<typeof useStudentMedicalProfileSelectLazyQuery>;
export type StudentMedicalProfileSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicalProfileSelectSuspenseQuery
>;
export type StudentMedicalProfileSelectQueryResult = Apollo.QueryResult<
	StudentMedicalProfileSelectQuery,
	StudentMedicalProfileSelectQueryVariables
>;
export const StudentMedicalProfileUpdateDocument = gql`
	mutation studentMedicalProfileUpdate($id: ID!, $input: StudentMedicalProfileUpdateInput!) {
		updateStudentMedicalProfile(id: $id, input: $input) {
			...StudentMedicalProfileDetail
		}
	}
	${StudentMedicalProfileDetailFragmentDoc}
`;
export type StudentMedicalProfileUpdateMutationFn = Apollo.MutationFunction<
	StudentMedicalProfileUpdateMutation,
	StudentMedicalProfileUpdateMutationVariables
>;

/**
 * __useStudentMedicalProfileUpdateMutation__
 *
 * To run a mutation, you first call `useStudentMedicalProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicalProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentMedicalProfileUpdateMutation, { data, loading, error }] = useStudentMedicalProfileUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentMedicalProfileUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentMedicalProfileUpdateMutation,
		StudentMedicalProfileUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentMedicalProfileUpdateMutation, StudentMedicalProfileUpdateMutationVariables>(
		StudentMedicalProfileUpdateDocument,
		options,
	);
}
export type StudentMedicalProfileUpdateMutationHookResult = ReturnType<typeof useStudentMedicalProfileUpdateMutation>;
export type StudentMedicalProfileUpdateMutationResult = Apollo.MutationResult<StudentMedicalProfileUpdateMutation>;
export type StudentMedicalProfileUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentMedicalProfileUpdateMutation,
	StudentMedicalProfileUpdateMutationVariables
>;
export const StudentMedicationNoteCountDocument = gql`
	query studentMedicationNoteCount(
		$filters: [StudentMedicationNoteFilterInput!]
		$pagination: Pagination
		$order: StudentMedicationNoteOrder
	) {
		studentMedicationNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentMedicationNoteCountQuery__
 *
 * To run a query within a React component, call `useStudentMedicationNoteCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicationNoteCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicationNoteCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicationNoteCountQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicationNoteCountQuery, StudentMedicationNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicationNoteCountQuery, StudentMedicationNoteCountQueryVariables>(
		StudentMedicationNoteCountDocument,
		options,
	);
}
export function useStudentMedicationNoteCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMedicationNoteCountQuery, StudentMedicationNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicationNoteCountQuery, StudentMedicationNoteCountQueryVariables>(
		StudentMedicationNoteCountDocument,
		options,
	);
}
export function useStudentMedicationNoteCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicationNoteCountQuery,
		StudentMedicationNoteCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicationNoteCountQuery, StudentMedicationNoteCountQueryVariables>(
		StudentMedicationNoteCountDocument,
		options,
	);
}
export type StudentMedicationNoteCountQueryHookResult = ReturnType<typeof useStudentMedicationNoteCountQuery>;
export type StudentMedicationNoteCountLazyQueryHookResult = ReturnType<typeof useStudentMedicationNoteCountLazyQuery>;
export type StudentMedicationNoteCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicationNoteCountSuspenseQuery
>;
export type StudentMedicationNoteCountQueryResult = Apollo.QueryResult<
	StudentMedicationNoteCountQuery,
	StudentMedicationNoteCountQueryVariables
>;
export const StudentMedicationNoteCreateDocument = gql`
	mutation studentMedicationNoteCreate($input: StudentMedicationNoteCreateInput!) {
		createStudentMedicationNote(input: $input) {
			...StudentMedicationNoteDetail
		}
	}
	${StudentMedicationNoteDetailFragmentDoc}
`;
export type StudentMedicationNoteCreateMutationFn = Apollo.MutationFunction<
	StudentMedicationNoteCreateMutation,
	StudentMedicationNoteCreateMutationVariables
>;

/**
 * __useStudentMedicationNoteCreateMutation__
 *
 * To run a mutation, you first call `useStudentMedicationNoteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicationNoteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentMedicationNoteCreateMutation, { data, loading, error }] = useStudentMedicationNoteCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentMedicationNoteCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentMedicationNoteCreateMutation,
		StudentMedicationNoteCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentMedicationNoteCreateMutation, StudentMedicationNoteCreateMutationVariables>(
		StudentMedicationNoteCreateDocument,
		options,
	);
}
export type StudentMedicationNoteCreateMutationHookResult = ReturnType<typeof useStudentMedicationNoteCreateMutation>;
export type StudentMedicationNoteCreateMutationResult = Apollo.MutationResult<StudentMedicationNoteCreateMutation>;
export type StudentMedicationNoteCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentMedicationNoteCreateMutation,
	StudentMedicationNoteCreateMutationVariables
>;
export const StudentMedicationNoteDeleteDocument = gql`
	mutation studentMedicationNoteDelete($id: ID!) {
		deleteStudentMedicationNote(id: $id)
	}
`;
export type StudentMedicationNoteDeleteMutationFn = Apollo.MutationFunction<
	StudentMedicationNoteDeleteMutation,
	StudentMedicationNoteDeleteMutationVariables
>;

/**
 * __useStudentMedicationNoteDeleteMutation__
 *
 * To run a mutation, you first call `useStudentMedicationNoteDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicationNoteDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentMedicationNoteDeleteMutation, { data, loading, error }] = useStudentMedicationNoteDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentMedicationNoteDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentMedicationNoteDeleteMutation,
		StudentMedicationNoteDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentMedicationNoteDeleteMutation, StudentMedicationNoteDeleteMutationVariables>(
		StudentMedicationNoteDeleteDocument,
		options,
	);
}
export type StudentMedicationNoteDeleteMutationHookResult = ReturnType<typeof useStudentMedicationNoteDeleteMutation>;
export type StudentMedicationNoteDeleteMutationResult = Apollo.MutationResult<StudentMedicationNoteDeleteMutation>;
export type StudentMedicationNoteDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentMedicationNoteDeleteMutation,
	StudentMedicationNoteDeleteMutationVariables
>;
export const StudentMedicationNoteDetailDocument = gql`
	query studentMedicationNoteDetail($id: ID!) {
		studentMedicationNote(id: $id) {
			...StudentMedicationNoteDetail
		}
	}
	${StudentMedicationNoteDetailFragmentDoc}
`;

/**
 * __useStudentMedicationNoteDetailQuery__
 *
 * To run a query within a React component, call `useStudentMedicationNoteDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicationNoteDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicationNoteDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentMedicationNoteDetailQuery(
	baseOptions: Apollo.QueryHookOptions<StudentMedicationNoteDetailQuery, StudentMedicationNoteDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicationNoteDetailQuery, StudentMedicationNoteDetailQueryVariables>(
		StudentMedicationNoteDetailDocument,
		options,
	);
}
export function useStudentMedicationNoteDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicationNoteDetailQuery,
		StudentMedicationNoteDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicationNoteDetailQuery, StudentMedicationNoteDetailQueryVariables>(
		StudentMedicationNoteDetailDocument,
		options,
	);
}
export function useStudentMedicationNoteDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicationNoteDetailQuery,
		StudentMedicationNoteDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicationNoteDetailQuery, StudentMedicationNoteDetailQueryVariables>(
		StudentMedicationNoteDetailDocument,
		options,
	);
}
export type StudentMedicationNoteDetailQueryHookResult = ReturnType<typeof useStudentMedicationNoteDetailQuery>;
export type StudentMedicationNoteDetailLazyQueryHookResult = ReturnType<typeof useStudentMedicationNoteDetailLazyQuery>;
export type StudentMedicationNoteDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicationNoteDetailSuspenseQuery
>;
export type StudentMedicationNoteDetailQueryResult = Apollo.QueryResult<
	StudentMedicationNoteDetailQuery,
	StudentMedicationNoteDetailQueryVariables
>;
export const StudentMedicationNoteIndexDocument = gql`
	query studentMedicationNoteIndex(
		$filters: [StudentMedicationNoteFilterInput!]
		$pagination: Pagination
		$order: StudentMedicationNoteOrder
	) {
		studentMedicationNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					body
				}
			}
		}
	}
`;

/**
 * __useStudentMedicationNoteIndexQuery__
 *
 * To run a query within a React component, call `useStudentMedicationNoteIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicationNoteIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicationNoteIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicationNoteIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicationNoteIndexQuery, StudentMedicationNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicationNoteIndexQuery, StudentMedicationNoteIndexQueryVariables>(
		StudentMedicationNoteIndexDocument,
		options,
	);
}
export function useStudentMedicationNoteIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMedicationNoteIndexQuery, StudentMedicationNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicationNoteIndexQuery, StudentMedicationNoteIndexQueryVariables>(
		StudentMedicationNoteIndexDocument,
		options,
	);
}
export function useStudentMedicationNoteIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicationNoteIndexQuery,
		StudentMedicationNoteIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicationNoteIndexQuery, StudentMedicationNoteIndexQueryVariables>(
		StudentMedicationNoteIndexDocument,
		options,
	);
}
export type StudentMedicationNoteIndexQueryHookResult = ReturnType<typeof useStudentMedicationNoteIndexQuery>;
export type StudentMedicationNoteIndexLazyQueryHookResult = ReturnType<typeof useStudentMedicationNoteIndexLazyQuery>;
export type StudentMedicationNoteIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicationNoteIndexSuspenseQuery
>;
export type StudentMedicationNoteIndexQueryResult = Apollo.QueryResult<
	StudentMedicationNoteIndexQuery,
	StudentMedicationNoteIndexQueryVariables
>;
export const StudentMedicationNoteNameDocument = gql`
	query studentMedicationNoteName($id: ID!) {
		studentMedicationNote(id: $id) {
			id
			...StudentMedicationNoteName
		}
	}
	${StudentMedicationNoteNameFragmentDoc}
`;

/**
 * __useStudentMedicationNoteNameQuery__
 *
 * To run a query within a React component, call `useStudentMedicationNoteNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicationNoteNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicationNoteNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentMedicationNoteNameQuery(
	baseOptions: Apollo.QueryHookOptions<StudentMedicationNoteNameQuery, StudentMedicationNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicationNoteNameQuery, StudentMedicationNoteNameQueryVariables>(
		StudentMedicationNoteNameDocument,
		options,
	);
}
export function useStudentMedicationNoteNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMedicationNoteNameQuery, StudentMedicationNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicationNoteNameQuery, StudentMedicationNoteNameQueryVariables>(
		StudentMedicationNoteNameDocument,
		options,
	);
}
export function useStudentMedicationNoteNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicationNoteNameQuery,
		StudentMedicationNoteNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicationNoteNameQuery, StudentMedicationNoteNameQueryVariables>(
		StudentMedicationNoteNameDocument,
		options,
	);
}
export type StudentMedicationNoteNameQueryHookResult = ReturnType<typeof useStudentMedicationNoteNameQuery>;
export type StudentMedicationNoteNameLazyQueryHookResult = ReturnType<typeof useStudentMedicationNoteNameLazyQuery>;
export type StudentMedicationNoteNameSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicationNoteNameSuspenseQuery
>;
export type StudentMedicationNoteNameQueryResult = Apollo.QueryResult<
	StudentMedicationNoteNameQuery,
	StudentMedicationNoteNameQueryVariables
>;
export const StudentMedicationNoteNamesDocument = gql`
	query studentMedicationNoteNames(
		$filters: [StudentMedicationNoteFilterInput!]
		$pagination: Pagination
		$order: StudentMedicationNoteOrder
	) {
		studentMedicationNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentMedicationNoteName
				}
			}
		}
	}
	${StudentMedicationNoteNameFragmentDoc}
`;

/**
 * __useStudentMedicationNoteNamesQuery__
 *
 * To run a query within a React component, call `useStudentMedicationNoteNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicationNoteNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicationNoteNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicationNoteNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicationNoteNamesQuery, StudentMedicationNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicationNoteNamesQuery, StudentMedicationNoteNamesQueryVariables>(
		StudentMedicationNoteNamesDocument,
		options,
	);
}
export function useStudentMedicationNoteNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentMedicationNoteNamesQuery, StudentMedicationNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicationNoteNamesQuery, StudentMedicationNoteNamesQueryVariables>(
		StudentMedicationNoteNamesDocument,
		options,
	);
}
export function useStudentMedicationNoteNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicationNoteNamesQuery,
		StudentMedicationNoteNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicationNoteNamesQuery, StudentMedicationNoteNamesQueryVariables>(
		StudentMedicationNoteNamesDocument,
		options,
	);
}
export type StudentMedicationNoteNamesQueryHookResult = ReturnType<typeof useStudentMedicationNoteNamesQuery>;
export type StudentMedicationNoteNamesLazyQueryHookResult = ReturnType<typeof useStudentMedicationNoteNamesLazyQuery>;
export type StudentMedicationNoteNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicationNoteNamesSuspenseQuery
>;
export type StudentMedicationNoteNamesQueryResult = Apollo.QueryResult<
	StudentMedicationNoteNamesQuery,
	StudentMedicationNoteNamesQueryVariables
>;
export const StudentMedicationNotePaginationDocument = gql`
	query studentMedicationNotePagination(
		$filters: [StudentMedicationNoteFilterInput!]
		$order: StudentMedicationNoteOrder
	) {
		studentMedicationNoteConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentMedicationNotePaginationQuery__
 *
 * To run a query within a React component, call `useStudentMedicationNotePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicationNotePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicationNotePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicationNotePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentMedicationNotePaginationQuery,
		StudentMedicationNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicationNotePaginationQuery, StudentMedicationNotePaginationQueryVariables>(
		StudentMedicationNotePaginationDocument,
		options,
	);
}
export function useStudentMedicationNotePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicationNotePaginationQuery,
		StudentMedicationNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicationNotePaginationQuery, StudentMedicationNotePaginationQueryVariables>(
		StudentMedicationNotePaginationDocument,
		options,
	);
}
export function useStudentMedicationNotePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicationNotePaginationQuery,
		StudentMedicationNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicationNotePaginationQuery, StudentMedicationNotePaginationQueryVariables>(
		StudentMedicationNotePaginationDocument,
		options,
	);
}
export type StudentMedicationNotePaginationQueryHookResult = ReturnType<typeof useStudentMedicationNotePaginationQuery>;
export type StudentMedicationNotePaginationLazyQueryHookResult = ReturnType<
	typeof useStudentMedicationNotePaginationLazyQuery
>;
export type StudentMedicationNotePaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicationNotePaginationSuspenseQuery
>;
export type StudentMedicationNotePaginationQueryResult = Apollo.QueryResult<
	StudentMedicationNotePaginationQuery,
	StudentMedicationNotePaginationQueryVariables
>;
export const StudentMedicationNoteSelectDocument = gql`
	query studentMedicationNoteSelect($filters: [StudentMedicationNoteFilterInput!], $order: StudentMedicationNoteOrder) {
		studentMedicationNoteConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentMedicationNoteName
				}
			}
		}
	}
	${StudentMedicationNoteNameFragmentDoc}
`;

/**
 * __useStudentMedicationNoteSelectQuery__
 *
 * To run a query within a React component, call `useStudentMedicationNoteSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicationNoteSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMedicationNoteSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentMedicationNoteSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentMedicationNoteSelectQuery, StudentMedicationNoteSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentMedicationNoteSelectQuery, StudentMedicationNoteSelectQueryVariables>(
		StudentMedicationNoteSelectDocument,
		options,
	);
}
export function useStudentMedicationNoteSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentMedicationNoteSelectQuery,
		StudentMedicationNoteSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentMedicationNoteSelectQuery, StudentMedicationNoteSelectQueryVariables>(
		StudentMedicationNoteSelectDocument,
		options,
	);
}
export function useStudentMedicationNoteSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentMedicationNoteSelectQuery,
		StudentMedicationNoteSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentMedicationNoteSelectQuery, StudentMedicationNoteSelectQueryVariables>(
		StudentMedicationNoteSelectDocument,
		options,
	);
}
export type StudentMedicationNoteSelectQueryHookResult = ReturnType<typeof useStudentMedicationNoteSelectQuery>;
export type StudentMedicationNoteSelectLazyQueryHookResult = ReturnType<typeof useStudentMedicationNoteSelectLazyQuery>;
export type StudentMedicationNoteSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentMedicationNoteSelectSuspenseQuery
>;
export type StudentMedicationNoteSelectQueryResult = Apollo.QueryResult<
	StudentMedicationNoteSelectQuery,
	StudentMedicationNoteSelectQueryVariables
>;
export const StudentMedicationNoteUpdateDocument = gql`
	mutation studentMedicationNoteUpdate($id: ID!, $input: StudentMedicationNoteUpdateInput!) {
		updateStudentMedicationNote(id: $id, input: $input) {
			...StudentMedicationNoteDetail
		}
	}
	${StudentMedicationNoteDetailFragmentDoc}
`;
export type StudentMedicationNoteUpdateMutationFn = Apollo.MutationFunction<
	StudentMedicationNoteUpdateMutation,
	StudentMedicationNoteUpdateMutationVariables
>;

/**
 * __useStudentMedicationNoteUpdateMutation__
 *
 * To run a mutation, you first call `useStudentMedicationNoteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentMedicationNoteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentMedicationNoteUpdateMutation, { data, loading, error }] = useStudentMedicationNoteUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentMedicationNoteUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentMedicationNoteUpdateMutation,
		StudentMedicationNoteUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentMedicationNoteUpdateMutation, StudentMedicationNoteUpdateMutationVariables>(
		StudentMedicationNoteUpdateDocument,
		options,
	);
}
export type StudentMedicationNoteUpdateMutationHookResult = ReturnType<typeof useStudentMedicationNoteUpdateMutation>;
export type StudentMedicationNoteUpdateMutationResult = Apollo.MutationResult<StudentMedicationNoteUpdateMutation>;
export type StudentMedicationNoteUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentMedicationNoteUpdateMutation,
	StudentMedicationNoteUpdateMutationVariables
>;
export const StudentNoteCountDocument = gql`
	query studentNoteCount($filters: [StudentNoteFilterInput!], $pagination: Pagination, $order: StudentNoteOrder) {
		studentNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentNoteCountQuery__
 *
 * To run a query within a React component, call `useStudentNoteCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNoteCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNoteCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentNoteCountQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentNoteCountQuery, StudentNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentNoteCountQuery, StudentNoteCountQueryVariables>(StudentNoteCountDocument, options);
}
export function useStudentNoteCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentNoteCountQuery, StudentNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentNoteCountQuery, StudentNoteCountQueryVariables>(StudentNoteCountDocument, options);
}
export function useStudentNoteCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentNoteCountQuery, StudentNoteCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentNoteCountQuery, StudentNoteCountQueryVariables>(
		StudentNoteCountDocument,
		options,
	);
}
export type StudentNoteCountQueryHookResult = ReturnType<typeof useStudentNoteCountQuery>;
export type StudentNoteCountLazyQueryHookResult = ReturnType<typeof useStudentNoteCountLazyQuery>;
export type StudentNoteCountSuspenseQueryHookResult = ReturnType<typeof useStudentNoteCountSuspenseQuery>;
export type StudentNoteCountQueryResult = Apollo.QueryResult<StudentNoteCountQuery, StudentNoteCountQueryVariables>;
export const StudentNoteCreateDocument = gql`
	mutation studentNoteCreate($input: StudentNoteCreateInput!) {
		createStudentNote(input: $input) {
			...StudentNoteDetail
		}
	}
	${StudentNoteDetailFragmentDoc}
`;
export type StudentNoteCreateMutationFn = Apollo.MutationFunction<
	StudentNoteCreateMutation,
	StudentNoteCreateMutationVariables
>;

/**
 * __useStudentNoteCreateMutation__
 *
 * To run a mutation, you first call `useStudentNoteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentNoteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentNoteCreateMutation, { data, loading, error }] = useStudentNoteCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentNoteCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<StudentNoteCreateMutation, StudentNoteCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentNoteCreateMutation, StudentNoteCreateMutationVariables>(
		StudentNoteCreateDocument,
		options,
	);
}
export type StudentNoteCreateMutationHookResult = ReturnType<typeof useStudentNoteCreateMutation>;
export type StudentNoteCreateMutationResult = Apollo.MutationResult<StudentNoteCreateMutation>;
export type StudentNoteCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentNoteCreateMutation,
	StudentNoteCreateMutationVariables
>;
export const StudentNoteDeleteDocument = gql`
	mutation studentNoteDelete($id: ID!) {
		deleteStudentNote(id: $id)
	}
`;
export type StudentNoteDeleteMutationFn = Apollo.MutationFunction<
	StudentNoteDeleteMutation,
	StudentNoteDeleteMutationVariables
>;

/**
 * __useStudentNoteDeleteMutation__
 *
 * To run a mutation, you first call `useStudentNoteDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentNoteDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentNoteDeleteMutation, { data, loading, error }] = useStudentNoteDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentNoteDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<StudentNoteDeleteMutation, StudentNoteDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentNoteDeleteMutation, StudentNoteDeleteMutationVariables>(
		StudentNoteDeleteDocument,
		options,
	);
}
export type StudentNoteDeleteMutationHookResult = ReturnType<typeof useStudentNoteDeleteMutation>;
export type StudentNoteDeleteMutationResult = Apollo.MutationResult<StudentNoteDeleteMutation>;
export type StudentNoteDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentNoteDeleteMutation,
	StudentNoteDeleteMutationVariables
>;
export const StudentNoteDetailDocument = gql`
	query studentNoteDetail($id: ID!) {
		studentNote(id: $id) {
			...StudentNoteDetail
		}
	}
	${StudentNoteDetailFragmentDoc}
`;

/**
 * __useStudentNoteDetailQuery__
 *
 * To run a query within a React component, call `useStudentNoteDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNoteDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNoteDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentNoteDetailQuery(
	baseOptions: Apollo.QueryHookOptions<StudentNoteDetailQuery, StudentNoteDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentNoteDetailQuery, StudentNoteDetailQueryVariables>(StudentNoteDetailDocument, options);
}
export function useStudentNoteDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentNoteDetailQuery, StudentNoteDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentNoteDetailQuery, StudentNoteDetailQueryVariables>(
		StudentNoteDetailDocument,
		options,
	);
}
export function useStudentNoteDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentNoteDetailQuery, StudentNoteDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentNoteDetailQuery, StudentNoteDetailQueryVariables>(
		StudentNoteDetailDocument,
		options,
	);
}
export type StudentNoteDetailQueryHookResult = ReturnType<typeof useStudentNoteDetailQuery>;
export type StudentNoteDetailLazyQueryHookResult = ReturnType<typeof useStudentNoteDetailLazyQuery>;
export type StudentNoteDetailSuspenseQueryHookResult = ReturnType<typeof useStudentNoteDetailSuspenseQuery>;
export type StudentNoteDetailQueryResult = Apollo.QueryResult<StudentNoteDetailQuery, StudentNoteDetailQueryVariables>;
export const StudentNoteIndexDocument = gql`
	query studentNoteIndex($filters: [StudentNoteFilterInput!], $pagination: Pagination, $order: StudentNoteOrder) {
		studentNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					noteType
					createdAt
					body
					isPinned
					requiresResolution
					isResolved
					resolvedAt
					resolutionDescription
				}
			}
		}
	}
`;

/**
 * __useStudentNoteIndexQuery__
 *
 * To run a query within a React component, call `useStudentNoteIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNoteIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNoteIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentNoteIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentNoteIndexQuery, StudentNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentNoteIndexQuery, StudentNoteIndexQueryVariables>(StudentNoteIndexDocument, options);
}
export function useStudentNoteIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentNoteIndexQuery, StudentNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentNoteIndexQuery, StudentNoteIndexQueryVariables>(StudentNoteIndexDocument, options);
}
export function useStudentNoteIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentNoteIndexQuery, StudentNoteIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentNoteIndexQuery, StudentNoteIndexQueryVariables>(
		StudentNoteIndexDocument,
		options,
	);
}
export type StudentNoteIndexQueryHookResult = ReturnType<typeof useStudentNoteIndexQuery>;
export type StudentNoteIndexLazyQueryHookResult = ReturnType<typeof useStudentNoteIndexLazyQuery>;
export type StudentNoteIndexSuspenseQueryHookResult = ReturnType<typeof useStudentNoteIndexSuspenseQuery>;
export type StudentNoteIndexQueryResult = Apollo.QueryResult<StudentNoteIndexQuery, StudentNoteIndexQueryVariables>;
export const StudentNoteStudentPinnedListDocument = gql`
	query studentNoteStudentPinnedList(
		$filters: [StudentNoteFilterInput!]
		$pagination: Pagination
		$order: StudentNoteOrder
	) {
		studentNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					noteType
					createdAt
					body
					isPinned
				}
			}
		}
	}
`;

/**
 * __useStudentNoteStudentPinnedListQuery__
 *
 * To run a query within a React component, call `useStudentNoteStudentPinnedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNoteStudentPinnedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNoteStudentPinnedListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentNoteStudentPinnedListQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentNoteStudentPinnedListQuery, StudentNoteStudentPinnedListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentNoteStudentPinnedListQuery, StudentNoteStudentPinnedListQueryVariables>(
		StudentNoteStudentPinnedListDocument,
		options,
	);
}
export function useStudentNoteStudentPinnedListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentNoteStudentPinnedListQuery,
		StudentNoteStudentPinnedListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentNoteStudentPinnedListQuery, StudentNoteStudentPinnedListQueryVariables>(
		StudentNoteStudentPinnedListDocument,
		options,
	);
}
export function useStudentNoteStudentPinnedListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentNoteStudentPinnedListQuery,
		StudentNoteStudentPinnedListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentNoteStudentPinnedListQuery, StudentNoteStudentPinnedListQueryVariables>(
		StudentNoteStudentPinnedListDocument,
		options,
	);
}
export type StudentNoteStudentPinnedListQueryHookResult = ReturnType<typeof useStudentNoteStudentPinnedListQuery>;
export type StudentNoteStudentPinnedListLazyQueryHookResult = ReturnType<
	typeof useStudentNoteStudentPinnedListLazyQuery
>;
export type StudentNoteStudentPinnedListSuspenseQueryHookResult = ReturnType<
	typeof useStudentNoteStudentPinnedListSuspenseQuery
>;
export type StudentNoteStudentPinnedListQueryResult = Apollo.QueryResult<
	StudentNoteStudentPinnedListQuery,
	StudentNoteStudentPinnedListQueryVariables
>;
export const StudentNoteOverviewListDocument = gql`
	query studentNoteOverviewList(
		$filters: [StudentNoteFilterInput!]
		$pagination: Pagination
		$order: StudentNoteOrder
	) {
		studentNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					noteType
					createdAt
					body
					isPinned
					primaryStudents {
						id
						...StudentName
					}
					author {
						id
						...UserName
					}
				}
			}
		}
	}
	${StudentNameFragmentDoc}
	${UserNameFragmentDoc}
`;

/**
 * __useStudentNoteOverviewListQuery__
 *
 * To run a query within a React component, call `useStudentNoteOverviewListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNoteOverviewListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNoteOverviewListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentNoteOverviewListQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentNoteOverviewListQuery, StudentNoteOverviewListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentNoteOverviewListQuery, StudentNoteOverviewListQueryVariables>(
		StudentNoteOverviewListDocument,
		options,
	);
}
export function useStudentNoteOverviewListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentNoteOverviewListQuery, StudentNoteOverviewListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentNoteOverviewListQuery, StudentNoteOverviewListQueryVariables>(
		StudentNoteOverviewListDocument,
		options,
	);
}
export function useStudentNoteOverviewListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentNoteOverviewListQuery, StudentNoteOverviewListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentNoteOverviewListQuery, StudentNoteOverviewListQueryVariables>(
		StudentNoteOverviewListDocument,
		options,
	);
}
export type StudentNoteOverviewListQueryHookResult = ReturnType<typeof useStudentNoteOverviewListQuery>;
export type StudentNoteOverviewListLazyQueryHookResult = ReturnType<typeof useStudentNoteOverviewListLazyQuery>;
export type StudentNoteOverviewListSuspenseQueryHookResult = ReturnType<typeof useStudentNoteOverviewListSuspenseQuery>;
export type StudentNoteOverviewListQueryResult = Apollo.QueryResult<
	StudentNoteOverviewListQuery,
	StudentNoteOverviewListQueryVariables
>;
export const StudentAttendanceNotesListDocument = gql`
	query studentAttendanceNotesList(
		$filters: [StudentNoteFilterInput!]
		$studentFilters: [StudentFilterInput!]
		$pagination: Pagination
		$order: StudentNoteOrder
	) {
		studentNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					noteType
					createdAt
					body
					studentAttendanceNote {
						id
						startDate
						endDate
						attendanceStatus {
							id
							name
							code
							description
							indicatesAbsent
							indicatesLateArrival
							indicatesEarlyDeparture
							indicatesExcused
						}
					}
					primaryStudents(filters: $studentFilters) {
						id
						...StudentNameAndImage
					}
					author {
						id
						...UserNameAndImage
					}
				}
			}
		}
	}
	${StudentNameAndImageFragmentDoc}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __useStudentAttendanceNotesListQuery__
 *
 * To run a query within a React component, call `useStudentAttendanceNotesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAttendanceNotesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentAttendanceNotesListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      studentFilters: // value for 'studentFilters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentAttendanceNotesListQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentAttendanceNotesListQuery, StudentAttendanceNotesListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentAttendanceNotesListQuery, StudentAttendanceNotesListQueryVariables>(
		StudentAttendanceNotesListDocument,
		options,
	);
}
export function useStudentAttendanceNotesListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentAttendanceNotesListQuery, StudentAttendanceNotesListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentAttendanceNotesListQuery, StudentAttendanceNotesListQueryVariables>(
		StudentAttendanceNotesListDocument,
		options,
	);
}
export function useStudentAttendanceNotesListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentAttendanceNotesListQuery,
		StudentAttendanceNotesListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentAttendanceNotesListQuery, StudentAttendanceNotesListQueryVariables>(
		StudentAttendanceNotesListDocument,
		options,
	);
}
export type StudentAttendanceNotesListQueryHookResult = ReturnType<typeof useStudentAttendanceNotesListQuery>;
export type StudentAttendanceNotesListLazyQueryHookResult = ReturnType<typeof useStudentAttendanceNotesListLazyQuery>;
export type StudentAttendanceNotesListSuspenseQueryHookResult = ReturnType<
	typeof useStudentAttendanceNotesListSuspenseQuery
>;
export type StudentAttendanceNotesListQueryResult = Apollo.QueryResult<
	StudentAttendanceNotesListQuery,
	StudentAttendanceNotesListQueryVariables
>;
export const StudentNoteNameDocument = gql`
	query studentNoteName($id: ID!) {
		studentNote(id: $id) {
			id
			...StudentNoteName
		}
	}
	${StudentNoteNameFragmentDoc}
`;

/**
 * __useStudentNoteNameQuery__
 *
 * To run a query within a React component, call `useStudentNoteNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNoteNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNoteNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentNoteNameQuery(
	baseOptions: Apollo.QueryHookOptions<StudentNoteNameQuery, StudentNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentNoteNameQuery, StudentNoteNameQueryVariables>(StudentNoteNameDocument, options);
}
export function useStudentNoteNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentNoteNameQuery, StudentNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentNoteNameQuery, StudentNoteNameQueryVariables>(StudentNoteNameDocument, options);
}
export function useStudentNoteNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentNoteNameQuery, StudentNoteNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentNoteNameQuery, StudentNoteNameQueryVariables>(StudentNoteNameDocument, options);
}
export type StudentNoteNameQueryHookResult = ReturnType<typeof useStudentNoteNameQuery>;
export type StudentNoteNameLazyQueryHookResult = ReturnType<typeof useStudentNoteNameLazyQuery>;
export type StudentNoteNameSuspenseQueryHookResult = ReturnType<typeof useStudentNoteNameSuspenseQuery>;
export type StudentNoteNameQueryResult = Apollo.QueryResult<StudentNoteNameQuery, StudentNoteNameQueryVariables>;
export const StudentNoteNamesDocument = gql`
	query studentNoteNames($filters: [StudentNoteFilterInput!], $pagination: Pagination, $order: StudentNoteOrder) {
		studentNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentNoteName
				}
			}
		}
	}
	${StudentNoteNameFragmentDoc}
`;

/**
 * __useStudentNoteNamesQuery__
 *
 * To run a query within a React component, call `useStudentNoteNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNoteNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNoteNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentNoteNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentNoteNamesQuery, StudentNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentNoteNamesQuery, StudentNoteNamesQueryVariables>(StudentNoteNamesDocument, options);
}
export function useStudentNoteNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentNoteNamesQuery, StudentNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentNoteNamesQuery, StudentNoteNamesQueryVariables>(StudentNoteNamesDocument, options);
}
export function useStudentNoteNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentNoteNamesQuery, StudentNoteNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentNoteNamesQuery, StudentNoteNamesQueryVariables>(
		StudentNoteNamesDocument,
		options,
	);
}
export type StudentNoteNamesQueryHookResult = ReturnType<typeof useStudentNoteNamesQuery>;
export type StudentNoteNamesLazyQueryHookResult = ReturnType<typeof useStudentNoteNamesLazyQuery>;
export type StudentNoteNamesSuspenseQueryHookResult = ReturnType<typeof useStudentNoteNamesSuspenseQuery>;
export type StudentNoteNamesQueryResult = Apollo.QueryResult<StudentNoteNamesQuery, StudentNoteNamesQueryVariables>;
export const StudentNotePaginationDocument = gql`
	query studentNotePagination($filters: [StudentNoteFilterInput!], $order: StudentNoteOrder) {
		studentNoteConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentNotePaginationQuery__
 *
 * To run a query within a React component, call `useStudentNotePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNotePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNotePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentNotePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentNotePaginationQuery, StudentNotePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentNotePaginationQuery, StudentNotePaginationQueryVariables>(
		StudentNotePaginationDocument,
		options,
	);
}
export function useStudentNotePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentNotePaginationQuery, StudentNotePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentNotePaginationQuery, StudentNotePaginationQueryVariables>(
		StudentNotePaginationDocument,
		options,
	);
}
export function useStudentNotePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentNotePaginationQuery, StudentNotePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentNotePaginationQuery, StudentNotePaginationQueryVariables>(
		StudentNotePaginationDocument,
		options,
	);
}
export type StudentNotePaginationQueryHookResult = ReturnType<typeof useStudentNotePaginationQuery>;
export type StudentNotePaginationLazyQueryHookResult = ReturnType<typeof useStudentNotePaginationLazyQuery>;
export type StudentNotePaginationSuspenseQueryHookResult = ReturnType<typeof useStudentNotePaginationSuspenseQuery>;
export type StudentNotePaginationQueryResult = Apollo.QueryResult<
	StudentNotePaginationQuery,
	StudentNotePaginationQueryVariables
>;
export const StudentNoteSelectDocument = gql`
	query studentNoteSelect($filters: [StudentNoteFilterInput!], $order: StudentNoteOrder) {
		studentNoteConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentNoteName
				}
			}
		}
	}
	${StudentNoteNameFragmentDoc}
`;

/**
 * __useStudentNoteSelectQuery__
 *
 * To run a query within a React component, call `useStudentNoteSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentNoteSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentNoteSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentNoteSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentNoteSelectQuery, StudentNoteSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentNoteSelectQuery, StudentNoteSelectQueryVariables>(StudentNoteSelectDocument, options);
}
export function useStudentNoteSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentNoteSelectQuery, StudentNoteSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentNoteSelectQuery, StudentNoteSelectQueryVariables>(
		StudentNoteSelectDocument,
		options,
	);
}
export function useStudentNoteSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentNoteSelectQuery, StudentNoteSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentNoteSelectQuery, StudentNoteSelectQueryVariables>(
		StudentNoteSelectDocument,
		options,
	);
}
export type StudentNoteSelectQueryHookResult = ReturnType<typeof useStudentNoteSelectQuery>;
export type StudentNoteSelectLazyQueryHookResult = ReturnType<typeof useStudentNoteSelectLazyQuery>;
export type StudentNoteSelectSuspenseQueryHookResult = ReturnType<typeof useStudentNoteSelectSuspenseQuery>;
export type StudentNoteSelectQueryResult = Apollo.QueryResult<StudentNoteSelectQuery, StudentNoteSelectQueryVariables>;
export const StudentNoteUpdateDocument = gql`
	mutation studentNoteUpdate($id: ID!, $input: StudentNoteUpdateInput!) {
		updateStudentNote(id: $id, input: $input) {
			...StudentNoteDetail
		}
	}
	${StudentNoteDetailFragmentDoc}
`;
export type StudentNoteUpdateMutationFn = Apollo.MutationFunction<
	StudentNoteUpdateMutation,
	StudentNoteUpdateMutationVariables
>;

/**
 * __useStudentNoteUpdateMutation__
 *
 * To run a mutation, you first call `useStudentNoteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentNoteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentNoteUpdateMutation, { data, loading, error }] = useStudentNoteUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentNoteUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<StudentNoteUpdateMutation, StudentNoteUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentNoteUpdateMutation, StudentNoteUpdateMutationVariables>(
		StudentNoteUpdateDocument,
		options,
	);
}
export type StudentNoteUpdateMutationHookResult = ReturnType<typeof useStudentNoteUpdateMutation>;
export type StudentNoteUpdateMutationResult = Apollo.MutationResult<StudentNoteUpdateMutation>;
export type StudentNoteUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentNoteUpdateMutation,
	StudentNoteUpdateMutationVariables
>;
export const StudentOTCMedicationCountDocument = gql`
	query studentOTCMedicationCount(
		$filters: [StudentOTCMedicationFilterInput!]
		$pagination: Pagination
		$order: StudentOTCMedicationOrder
	) {
		studentOTCMedicationConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentOTCMedicationCountQuery__
 *
 * To run a query within a React component, call `useStudentOTCMedicationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentOTCMedicationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentOTCMedicationCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentOTCMedicationCountQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentOTCMedicationCountQuery, StudentOTCMedicationCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentOTCMedicationCountQuery, StudentOTCMedicationCountQueryVariables>(
		StudentOTCMedicationCountDocument,
		options,
	);
}
export function useStudentOTCMedicationCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentOTCMedicationCountQuery, StudentOTCMedicationCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentOTCMedicationCountQuery, StudentOTCMedicationCountQueryVariables>(
		StudentOTCMedicationCountDocument,
		options,
	);
}
export function useStudentOTCMedicationCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentOTCMedicationCountQuery,
		StudentOTCMedicationCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentOTCMedicationCountQuery, StudentOTCMedicationCountQueryVariables>(
		StudentOTCMedicationCountDocument,
		options,
	);
}
export type StudentOTCMedicationCountQueryHookResult = ReturnType<typeof useStudentOTCMedicationCountQuery>;
export type StudentOTCMedicationCountLazyQueryHookResult = ReturnType<typeof useStudentOTCMedicationCountLazyQuery>;
export type StudentOTCMedicationCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentOTCMedicationCountSuspenseQuery
>;
export type StudentOTCMedicationCountQueryResult = Apollo.QueryResult<
	StudentOTCMedicationCountQuery,
	StudentOTCMedicationCountQueryVariables
>;
export const StudentOTCMedicationCreateDocument = gql`
	mutation studentOTCMedicationCreate($input: StudentOTCMedicationCreateInput!) {
		createStudentOTCMedication(input: $input) {
			...StudentOTCMedicationDetail
		}
	}
	${StudentOTCMedicationDetailFragmentDoc}
`;
export type StudentOTCMedicationCreateMutationFn = Apollo.MutationFunction<
	StudentOTCMedicationCreateMutation,
	StudentOTCMedicationCreateMutationVariables
>;

/**
 * __useStudentOTCMedicationCreateMutation__
 *
 * To run a mutation, you first call `useStudentOTCMedicationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentOTCMedicationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentOtcMedicationCreateMutation, { data, loading, error }] = useStudentOTCMedicationCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentOTCMedicationCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentOTCMedicationCreateMutation,
		StudentOTCMedicationCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentOTCMedicationCreateMutation, StudentOTCMedicationCreateMutationVariables>(
		StudentOTCMedicationCreateDocument,
		options,
	);
}
export type StudentOTCMedicationCreateMutationHookResult = ReturnType<typeof useStudentOTCMedicationCreateMutation>;
export type StudentOTCMedicationCreateMutationResult = Apollo.MutationResult<StudentOTCMedicationCreateMutation>;
export type StudentOTCMedicationCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentOTCMedicationCreateMutation,
	StudentOTCMedicationCreateMutationVariables
>;
export const StudentOTCMedicationDeleteDocument = gql`
	mutation studentOTCMedicationDelete($id: ID!) {
		deleteStudentOTCMedication(id: $id)
	}
`;
export type StudentOTCMedicationDeleteMutationFn = Apollo.MutationFunction<
	StudentOTCMedicationDeleteMutation,
	StudentOTCMedicationDeleteMutationVariables
>;

/**
 * __useStudentOTCMedicationDeleteMutation__
 *
 * To run a mutation, you first call `useStudentOTCMedicationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentOTCMedicationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentOtcMedicationDeleteMutation, { data, loading, error }] = useStudentOTCMedicationDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentOTCMedicationDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentOTCMedicationDeleteMutation,
		StudentOTCMedicationDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentOTCMedicationDeleteMutation, StudentOTCMedicationDeleteMutationVariables>(
		StudentOTCMedicationDeleteDocument,
		options,
	);
}
export type StudentOTCMedicationDeleteMutationHookResult = ReturnType<typeof useStudentOTCMedicationDeleteMutation>;
export type StudentOTCMedicationDeleteMutationResult = Apollo.MutationResult<StudentOTCMedicationDeleteMutation>;
export type StudentOTCMedicationDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentOTCMedicationDeleteMutation,
	StudentOTCMedicationDeleteMutationVariables
>;
export const StudentOTCMedicationDetailDocument = gql`
	query studentOTCMedicationDetail($id: ID!) {
		studentOTCMedication(id: $id) {
			...StudentOTCMedicationDetail
		}
	}
	${StudentOTCMedicationDetailFragmentDoc}
`;

/**
 * __useStudentOTCMedicationDetailQuery__
 *
 * To run a query within a React component, call `useStudentOTCMedicationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentOTCMedicationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentOTCMedicationDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentOTCMedicationDetailQuery(
	baseOptions: Apollo.QueryHookOptions<StudentOTCMedicationDetailQuery, StudentOTCMedicationDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentOTCMedicationDetailQuery, StudentOTCMedicationDetailQueryVariables>(
		StudentOTCMedicationDetailDocument,
		options,
	);
}
export function useStudentOTCMedicationDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentOTCMedicationDetailQuery, StudentOTCMedicationDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentOTCMedicationDetailQuery, StudentOTCMedicationDetailQueryVariables>(
		StudentOTCMedicationDetailDocument,
		options,
	);
}
export function useStudentOTCMedicationDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentOTCMedicationDetailQuery,
		StudentOTCMedicationDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentOTCMedicationDetailQuery, StudentOTCMedicationDetailQueryVariables>(
		StudentOTCMedicationDetailDocument,
		options,
	);
}
export type StudentOTCMedicationDetailQueryHookResult = ReturnType<typeof useStudentOTCMedicationDetailQuery>;
export type StudentOTCMedicationDetailLazyQueryHookResult = ReturnType<typeof useStudentOTCMedicationDetailLazyQuery>;
export type StudentOTCMedicationDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentOTCMedicationDetailSuspenseQuery
>;
export type StudentOTCMedicationDetailQueryResult = Apollo.QueryResult<
	StudentOTCMedicationDetailQuery,
	StudentOTCMedicationDetailQueryVariables
>;
export const StudentOTCMedicationIndexDocument = gql`
	query studentOTCMedicationIndex(
		$filters: [StudentOTCMedicationFilterInput!]
		$pagination: Pagination
		$order: StudentOTCMedicationOrder
	) {
		studentOTCMedicationConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					isAllowed
					notes
				}
			}
		}
	}
`;

/**
 * __useStudentOTCMedicationIndexQuery__
 *
 * To run a query within a React component, call `useStudentOTCMedicationIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentOTCMedicationIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentOTCMedicationIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentOTCMedicationIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentOTCMedicationIndexQuery, StudentOTCMedicationIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentOTCMedicationIndexQuery, StudentOTCMedicationIndexQueryVariables>(
		StudentOTCMedicationIndexDocument,
		options,
	);
}
export function useStudentOTCMedicationIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentOTCMedicationIndexQuery, StudentOTCMedicationIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentOTCMedicationIndexQuery, StudentOTCMedicationIndexQueryVariables>(
		StudentOTCMedicationIndexDocument,
		options,
	);
}
export function useStudentOTCMedicationIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentOTCMedicationIndexQuery,
		StudentOTCMedicationIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentOTCMedicationIndexQuery, StudentOTCMedicationIndexQueryVariables>(
		StudentOTCMedicationIndexDocument,
		options,
	);
}
export type StudentOTCMedicationIndexQueryHookResult = ReturnType<typeof useStudentOTCMedicationIndexQuery>;
export type StudentOTCMedicationIndexLazyQueryHookResult = ReturnType<typeof useStudentOTCMedicationIndexLazyQuery>;
export type StudentOTCMedicationIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentOTCMedicationIndexSuspenseQuery
>;
export type StudentOTCMedicationIndexQueryResult = Apollo.QueryResult<
	StudentOTCMedicationIndexQuery,
	StudentOTCMedicationIndexQueryVariables
>;
export const StudentOTCMedicationStudentListDocument = gql`
	query studentOTCMedicationStudentList(
		$filters: [StudentOTCMedicationFilterInput!]
		$pagination: Pagination
		$order: StudentOTCMedicationOrder
	) {
		studentOTCMedicationConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					isAllowed
					notes
					medication {
						id
						...MedicationName
					}
				}
			}
		}
	}
	${MedicationNameFragmentDoc}
`;

/**
 * __useStudentOTCMedicationStudentListQuery__
 *
 * To run a query within a React component, call `useStudentOTCMedicationStudentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentOTCMedicationStudentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentOTCMedicationStudentListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentOTCMedicationStudentListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentOTCMedicationStudentListQuery,
		StudentOTCMedicationStudentListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentOTCMedicationStudentListQuery, StudentOTCMedicationStudentListQueryVariables>(
		StudentOTCMedicationStudentListDocument,
		options,
	);
}
export function useStudentOTCMedicationStudentListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentOTCMedicationStudentListQuery,
		StudentOTCMedicationStudentListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentOTCMedicationStudentListQuery, StudentOTCMedicationStudentListQueryVariables>(
		StudentOTCMedicationStudentListDocument,
		options,
	);
}
export function useStudentOTCMedicationStudentListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentOTCMedicationStudentListQuery,
		StudentOTCMedicationStudentListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentOTCMedicationStudentListQuery, StudentOTCMedicationStudentListQueryVariables>(
		StudentOTCMedicationStudentListDocument,
		options,
	);
}
export type StudentOTCMedicationStudentListQueryHookResult = ReturnType<typeof useStudentOTCMedicationStudentListQuery>;
export type StudentOTCMedicationStudentListLazyQueryHookResult = ReturnType<
	typeof useStudentOTCMedicationStudentListLazyQuery
>;
export type StudentOTCMedicationStudentListSuspenseQueryHookResult = ReturnType<
	typeof useStudentOTCMedicationStudentListSuspenseQuery
>;
export type StudentOTCMedicationStudentListQueryResult = Apollo.QueryResult<
	StudentOTCMedicationStudentListQuery,
	StudentOTCMedicationStudentListQueryVariables
>;
export const StudentOTCMedicationNameDocument = gql`
	query studentOTCMedicationName($id: ID!) {
		studentOTCMedication(id: $id) {
			id
			...StudentOTCMedicationName
		}
	}
	${StudentOTCMedicationNameFragmentDoc}
`;

/**
 * __useStudentOTCMedicationNameQuery__
 *
 * To run a query within a React component, call `useStudentOTCMedicationNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentOTCMedicationNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentOTCMedicationNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentOTCMedicationNameQuery(
	baseOptions: Apollo.QueryHookOptions<StudentOTCMedicationNameQuery, StudentOTCMedicationNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentOTCMedicationNameQuery, StudentOTCMedicationNameQueryVariables>(
		StudentOTCMedicationNameDocument,
		options,
	);
}
export function useStudentOTCMedicationNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentOTCMedicationNameQuery, StudentOTCMedicationNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentOTCMedicationNameQuery, StudentOTCMedicationNameQueryVariables>(
		StudentOTCMedicationNameDocument,
		options,
	);
}
export function useStudentOTCMedicationNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<StudentOTCMedicationNameQuery, StudentOTCMedicationNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentOTCMedicationNameQuery, StudentOTCMedicationNameQueryVariables>(
		StudentOTCMedicationNameDocument,
		options,
	);
}
export type StudentOTCMedicationNameQueryHookResult = ReturnType<typeof useStudentOTCMedicationNameQuery>;
export type StudentOTCMedicationNameLazyQueryHookResult = ReturnType<typeof useStudentOTCMedicationNameLazyQuery>;
export type StudentOTCMedicationNameSuspenseQueryHookResult = ReturnType<
	typeof useStudentOTCMedicationNameSuspenseQuery
>;
export type StudentOTCMedicationNameQueryResult = Apollo.QueryResult<
	StudentOTCMedicationNameQuery,
	StudentOTCMedicationNameQueryVariables
>;
export const StudentOTCMedicationNamesDocument = gql`
	query studentOTCMedicationNames(
		$filters: [StudentOTCMedicationFilterInput!]
		$pagination: Pagination
		$order: StudentOTCMedicationOrder
	) {
		studentOTCMedicationConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentOTCMedicationName
				}
			}
		}
	}
	${StudentOTCMedicationNameFragmentDoc}
`;

/**
 * __useStudentOTCMedicationNamesQuery__
 *
 * To run a query within a React component, call `useStudentOTCMedicationNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentOTCMedicationNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentOTCMedicationNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentOTCMedicationNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentOTCMedicationNamesQuery, StudentOTCMedicationNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentOTCMedicationNamesQuery, StudentOTCMedicationNamesQueryVariables>(
		StudentOTCMedicationNamesDocument,
		options,
	);
}
export function useStudentOTCMedicationNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentOTCMedicationNamesQuery, StudentOTCMedicationNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentOTCMedicationNamesQuery, StudentOTCMedicationNamesQueryVariables>(
		StudentOTCMedicationNamesDocument,
		options,
	);
}
export function useStudentOTCMedicationNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentOTCMedicationNamesQuery,
		StudentOTCMedicationNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentOTCMedicationNamesQuery, StudentOTCMedicationNamesQueryVariables>(
		StudentOTCMedicationNamesDocument,
		options,
	);
}
export type StudentOTCMedicationNamesQueryHookResult = ReturnType<typeof useStudentOTCMedicationNamesQuery>;
export type StudentOTCMedicationNamesLazyQueryHookResult = ReturnType<typeof useStudentOTCMedicationNamesLazyQuery>;
export type StudentOTCMedicationNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentOTCMedicationNamesSuspenseQuery
>;
export type StudentOTCMedicationNamesQueryResult = Apollo.QueryResult<
	StudentOTCMedicationNamesQuery,
	StudentOTCMedicationNamesQueryVariables
>;
export const StudentOTCMedicationPaginationDocument = gql`
	query studentOTCMedicationPagination(
		$filters: [StudentOTCMedicationFilterInput!]
		$order: StudentOTCMedicationOrder
	) {
		studentOTCMedicationConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentOTCMedicationPaginationQuery__
 *
 * To run a query within a React component, call `useStudentOTCMedicationPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentOTCMedicationPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentOTCMedicationPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentOTCMedicationPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentOTCMedicationPaginationQuery,
		StudentOTCMedicationPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentOTCMedicationPaginationQuery, StudentOTCMedicationPaginationQueryVariables>(
		StudentOTCMedicationPaginationDocument,
		options,
	);
}
export function useStudentOTCMedicationPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentOTCMedicationPaginationQuery,
		StudentOTCMedicationPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentOTCMedicationPaginationQuery, StudentOTCMedicationPaginationQueryVariables>(
		StudentOTCMedicationPaginationDocument,
		options,
	);
}
export function useStudentOTCMedicationPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentOTCMedicationPaginationQuery,
		StudentOTCMedicationPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentOTCMedicationPaginationQuery, StudentOTCMedicationPaginationQueryVariables>(
		StudentOTCMedicationPaginationDocument,
		options,
	);
}
export type StudentOTCMedicationPaginationQueryHookResult = ReturnType<typeof useStudentOTCMedicationPaginationQuery>;
export type StudentOTCMedicationPaginationLazyQueryHookResult = ReturnType<
	typeof useStudentOTCMedicationPaginationLazyQuery
>;
export type StudentOTCMedicationPaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentOTCMedicationPaginationSuspenseQuery
>;
export type StudentOTCMedicationPaginationQueryResult = Apollo.QueryResult<
	StudentOTCMedicationPaginationQuery,
	StudentOTCMedicationPaginationQueryVariables
>;
export const StudentOTCMedicationSelectDocument = gql`
	query studentOTCMedicationSelect($filters: [StudentOTCMedicationFilterInput!], $order: StudentOTCMedicationOrder) {
		studentOTCMedicationConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentOTCMedicationName
				}
			}
		}
	}
	${StudentOTCMedicationNameFragmentDoc}
`;

/**
 * __useStudentOTCMedicationSelectQuery__
 *
 * To run a query within a React component, call `useStudentOTCMedicationSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentOTCMedicationSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentOTCMedicationSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentOTCMedicationSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentOTCMedicationSelectQuery, StudentOTCMedicationSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentOTCMedicationSelectQuery, StudentOTCMedicationSelectQueryVariables>(
		StudentOTCMedicationSelectDocument,
		options,
	);
}
export function useStudentOTCMedicationSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentOTCMedicationSelectQuery, StudentOTCMedicationSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentOTCMedicationSelectQuery, StudentOTCMedicationSelectQueryVariables>(
		StudentOTCMedicationSelectDocument,
		options,
	);
}
export function useStudentOTCMedicationSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentOTCMedicationSelectQuery,
		StudentOTCMedicationSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentOTCMedicationSelectQuery, StudentOTCMedicationSelectQueryVariables>(
		StudentOTCMedicationSelectDocument,
		options,
	);
}
export type StudentOTCMedicationSelectQueryHookResult = ReturnType<typeof useStudentOTCMedicationSelectQuery>;
export type StudentOTCMedicationSelectLazyQueryHookResult = ReturnType<typeof useStudentOTCMedicationSelectLazyQuery>;
export type StudentOTCMedicationSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentOTCMedicationSelectSuspenseQuery
>;
export type StudentOTCMedicationSelectQueryResult = Apollo.QueryResult<
	StudentOTCMedicationSelectQuery,
	StudentOTCMedicationSelectQueryVariables
>;
export const StudentOTCMedicationUpdateDocument = gql`
	mutation studentOTCMedicationUpdate($id: ID!, $input: StudentOTCMedicationUpdateInput!) {
		updateStudentOTCMedication(id: $id, input: $input) {
			...StudentOTCMedicationDetail
		}
	}
	${StudentOTCMedicationDetailFragmentDoc}
`;
export type StudentOTCMedicationUpdateMutationFn = Apollo.MutationFunction<
	StudentOTCMedicationUpdateMutation,
	StudentOTCMedicationUpdateMutationVariables
>;

/**
 * __useStudentOTCMedicationUpdateMutation__
 *
 * To run a mutation, you first call `useStudentOTCMedicationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentOTCMedicationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentOtcMedicationUpdateMutation, { data, loading, error }] = useStudentOTCMedicationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentOTCMedicationUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentOTCMedicationUpdateMutation,
		StudentOTCMedicationUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentOTCMedicationUpdateMutation, StudentOTCMedicationUpdateMutationVariables>(
		StudentOTCMedicationUpdateDocument,
		options,
	);
}
export type StudentOTCMedicationUpdateMutationHookResult = ReturnType<typeof useStudentOTCMedicationUpdateMutation>;
export type StudentOTCMedicationUpdateMutationResult = Apollo.MutationResult<StudentOTCMedicationUpdateMutation>;
export type StudentOTCMedicationUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentOTCMedicationUpdateMutation,
	StudentOTCMedicationUpdateMutationVariables
>;
export const StudentPrescriptionMedicationCountDocument = gql`
	query studentPrescriptionMedicationCount(
		$filters: [StudentPrescriptionMedicationFilterInput!]
		$pagination: Pagination
		$order: StudentPrescriptionMedicationOrder
	) {
		studentPrescriptionMedicationConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentPrescriptionMedicationCountQuery__
 *
 * To run a query within a React component, call `useStudentPrescriptionMedicationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentPrescriptionMedicationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentPrescriptionMedicationCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentPrescriptionMedicationCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentPrescriptionMedicationCountQuery,
		StudentPrescriptionMedicationCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentPrescriptionMedicationCountQuery, StudentPrescriptionMedicationCountQueryVariables>(
		StudentPrescriptionMedicationCountDocument,
		options,
	);
}
export function useStudentPrescriptionMedicationCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentPrescriptionMedicationCountQuery,
		StudentPrescriptionMedicationCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentPrescriptionMedicationCountQuery, StudentPrescriptionMedicationCountQueryVariables>(
		StudentPrescriptionMedicationCountDocument,
		options,
	);
}
export function useStudentPrescriptionMedicationCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentPrescriptionMedicationCountQuery,
		StudentPrescriptionMedicationCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentPrescriptionMedicationCountQuery,
		StudentPrescriptionMedicationCountQueryVariables
	>(StudentPrescriptionMedicationCountDocument, options);
}
export type StudentPrescriptionMedicationCountQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationCountQuery
>;
export type StudentPrescriptionMedicationCountLazyQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationCountLazyQuery
>;
export type StudentPrescriptionMedicationCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationCountSuspenseQuery
>;
export type StudentPrescriptionMedicationCountQueryResult = Apollo.QueryResult<
	StudentPrescriptionMedicationCountQuery,
	StudentPrescriptionMedicationCountQueryVariables
>;
export const StudentPrescriptionMedicationCreateDocument = gql`
	mutation studentPrescriptionMedicationCreate($input: StudentPrescriptionMedicationCreateInput!) {
		createStudentPrescriptionMedication(input: $input) {
			...StudentPrescriptionMedicationDetail
		}
	}
	${StudentPrescriptionMedicationDetailFragmentDoc}
`;
export type StudentPrescriptionMedicationCreateMutationFn = Apollo.MutationFunction<
	StudentPrescriptionMedicationCreateMutation,
	StudentPrescriptionMedicationCreateMutationVariables
>;

/**
 * __useStudentPrescriptionMedicationCreateMutation__
 *
 * To run a mutation, you first call `useStudentPrescriptionMedicationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentPrescriptionMedicationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentPrescriptionMedicationCreateMutation, { data, loading, error }] = useStudentPrescriptionMedicationCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentPrescriptionMedicationCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentPrescriptionMedicationCreateMutation,
		StudentPrescriptionMedicationCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentPrescriptionMedicationCreateMutation,
		StudentPrescriptionMedicationCreateMutationVariables
	>(StudentPrescriptionMedicationCreateDocument, options);
}
export type StudentPrescriptionMedicationCreateMutationHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationCreateMutation
>;
export type StudentPrescriptionMedicationCreateMutationResult =
	Apollo.MutationResult<StudentPrescriptionMedicationCreateMutation>;
export type StudentPrescriptionMedicationCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentPrescriptionMedicationCreateMutation,
	StudentPrescriptionMedicationCreateMutationVariables
>;
export const StudentPrescriptionMedicationDeleteDocument = gql`
	mutation studentPrescriptionMedicationDelete($id: ID!) {
		deleteStudentPrescriptionMedication(id: $id)
	}
`;
export type StudentPrescriptionMedicationDeleteMutationFn = Apollo.MutationFunction<
	StudentPrescriptionMedicationDeleteMutation,
	StudentPrescriptionMedicationDeleteMutationVariables
>;

/**
 * __useStudentPrescriptionMedicationDeleteMutation__
 *
 * To run a mutation, you first call `useStudentPrescriptionMedicationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentPrescriptionMedicationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentPrescriptionMedicationDeleteMutation, { data, loading, error }] = useStudentPrescriptionMedicationDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentPrescriptionMedicationDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentPrescriptionMedicationDeleteMutation,
		StudentPrescriptionMedicationDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentPrescriptionMedicationDeleteMutation,
		StudentPrescriptionMedicationDeleteMutationVariables
	>(StudentPrescriptionMedicationDeleteDocument, options);
}
export type StudentPrescriptionMedicationDeleteMutationHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationDeleteMutation
>;
export type StudentPrescriptionMedicationDeleteMutationResult =
	Apollo.MutationResult<StudentPrescriptionMedicationDeleteMutation>;
export type StudentPrescriptionMedicationDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentPrescriptionMedicationDeleteMutation,
	StudentPrescriptionMedicationDeleteMutationVariables
>;
export const StudentPrescriptionMedicationDetailDocument = gql`
	query studentPrescriptionMedicationDetail($id: ID!) {
		studentPrescriptionMedication(id: $id) {
			...StudentPrescriptionMedicationDetail
		}
	}
	${StudentPrescriptionMedicationDetailFragmentDoc}
`;

/**
 * __useStudentPrescriptionMedicationDetailQuery__
 *
 * To run a query within a React component, call `useStudentPrescriptionMedicationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentPrescriptionMedicationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentPrescriptionMedicationDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentPrescriptionMedicationDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentPrescriptionMedicationDetailQuery,
		StudentPrescriptionMedicationDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentPrescriptionMedicationDetailQuery, StudentPrescriptionMedicationDetailQueryVariables>(
		StudentPrescriptionMedicationDetailDocument,
		options,
	);
}
export function useStudentPrescriptionMedicationDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentPrescriptionMedicationDetailQuery,
		StudentPrescriptionMedicationDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentPrescriptionMedicationDetailQuery,
		StudentPrescriptionMedicationDetailQueryVariables
	>(StudentPrescriptionMedicationDetailDocument, options);
}
export function useStudentPrescriptionMedicationDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentPrescriptionMedicationDetailQuery,
		StudentPrescriptionMedicationDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentPrescriptionMedicationDetailQuery,
		StudentPrescriptionMedicationDetailQueryVariables
	>(StudentPrescriptionMedicationDetailDocument, options);
}
export type StudentPrescriptionMedicationDetailQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationDetailQuery
>;
export type StudentPrescriptionMedicationDetailLazyQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationDetailLazyQuery
>;
export type StudentPrescriptionMedicationDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationDetailSuspenseQuery
>;
export type StudentPrescriptionMedicationDetailQueryResult = Apollo.QueryResult<
	StudentPrescriptionMedicationDetailQuery,
	StudentPrescriptionMedicationDetailQueryVariables
>;
export const StudentPrescriptionMedicationIndexDocument = gql`
	query studentPrescriptionMedicationIndex(
		$filters: [StudentPrescriptionMedicationFilterInput!]
		$pagination: Pagination
		$order: StudentPrescriptionMedicationOrder
	) {
		studentPrescriptionMedicationConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					administration
					canSelfAdminister
					notes
				}
			}
		}
	}
`;

/**
 * __useStudentPrescriptionMedicationIndexQuery__
 *
 * To run a query within a React component, call `useStudentPrescriptionMedicationIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentPrescriptionMedicationIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentPrescriptionMedicationIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentPrescriptionMedicationIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentPrescriptionMedicationIndexQuery,
		StudentPrescriptionMedicationIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentPrescriptionMedicationIndexQuery, StudentPrescriptionMedicationIndexQueryVariables>(
		StudentPrescriptionMedicationIndexDocument,
		options,
	);
}
export function useStudentPrescriptionMedicationIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentPrescriptionMedicationIndexQuery,
		StudentPrescriptionMedicationIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentPrescriptionMedicationIndexQuery, StudentPrescriptionMedicationIndexQueryVariables>(
		StudentPrescriptionMedicationIndexDocument,
		options,
	);
}
export function useStudentPrescriptionMedicationIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentPrescriptionMedicationIndexQuery,
		StudentPrescriptionMedicationIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentPrescriptionMedicationIndexQuery,
		StudentPrescriptionMedicationIndexQueryVariables
	>(StudentPrescriptionMedicationIndexDocument, options);
}
export type StudentPrescriptionMedicationIndexQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationIndexQuery
>;
export type StudentPrescriptionMedicationIndexLazyQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationIndexLazyQuery
>;
export type StudentPrescriptionMedicationIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationIndexSuspenseQuery
>;
export type StudentPrescriptionMedicationIndexQueryResult = Apollo.QueryResult<
	StudentPrescriptionMedicationIndexQuery,
	StudentPrescriptionMedicationIndexQueryVariables
>;
export const StudentPrescriptionMedicationStudentListDocument = gql`
	query studentPrescriptionMedicationStudentList(
		$filters: [StudentPrescriptionMedicationFilterInput!]
		$pagination: Pagination
		$order: StudentPrescriptionMedicationOrder
	) {
		studentPrescriptionMedicationConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					administration
					canSelfAdminister
					notes
					medication {
						id
						...MedicationName
					}
				}
			}
		}
	}
	${MedicationNameFragmentDoc}
`;

/**
 * __useStudentPrescriptionMedicationStudentListQuery__
 *
 * To run a query within a React component, call `useStudentPrescriptionMedicationStudentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentPrescriptionMedicationStudentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentPrescriptionMedicationStudentListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentPrescriptionMedicationStudentListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentPrescriptionMedicationStudentListQuery,
		StudentPrescriptionMedicationStudentListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentPrescriptionMedicationStudentListQuery,
		StudentPrescriptionMedicationStudentListQueryVariables
	>(StudentPrescriptionMedicationStudentListDocument, options);
}
export function useStudentPrescriptionMedicationStudentListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentPrescriptionMedicationStudentListQuery,
		StudentPrescriptionMedicationStudentListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentPrescriptionMedicationStudentListQuery,
		StudentPrescriptionMedicationStudentListQueryVariables
	>(StudentPrescriptionMedicationStudentListDocument, options);
}
export function useStudentPrescriptionMedicationStudentListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentPrescriptionMedicationStudentListQuery,
		StudentPrescriptionMedicationStudentListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentPrescriptionMedicationStudentListQuery,
		StudentPrescriptionMedicationStudentListQueryVariables
	>(StudentPrescriptionMedicationStudentListDocument, options);
}
export type StudentPrescriptionMedicationStudentListQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationStudentListQuery
>;
export type StudentPrescriptionMedicationStudentListLazyQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationStudentListLazyQuery
>;
export type StudentPrescriptionMedicationStudentListSuspenseQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationStudentListSuspenseQuery
>;
export type StudentPrescriptionMedicationStudentListQueryResult = Apollo.QueryResult<
	StudentPrescriptionMedicationStudentListQuery,
	StudentPrescriptionMedicationStudentListQueryVariables
>;
export const StudentPrescriptionMedicationNameDocument = gql`
	query studentPrescriptionMedicationName($id: ID!) {
		studentPrescriptionMedication(id: $id) {
			id
			...StudentPrescriptionMedicationName
		}
	}
	${StudentPrescriptionMedicationNameFragmentDoc}
`;

/**
 * __useStudentPrescriptionMedicationNameQuery__
 *
 * To run a query within a React component, call `useStudentPrescriptionMedicationNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentPrescriptionMedicationNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentPrescriptionMedicationNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentPrescriptionMedicationNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentPrescriptionMedicationNameQuery,
		StudentPrescriptionMedicationNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentPrescriptionMedicationNameQuery, StudentPrescriptionMedicationNameQueryVariables>(
		StudentPrescriptionMedicationNameDocument,
		options,
	);
}
export function useStudentPrescriptionMedicationNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentPrescriptionMedicationNameQuery,
		StudentPrescriptionMedicationNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentPrescriptionMedicationNameQuery, StudentPrescriptionMedicationNameQueryVariables>(
		StudentPrescriptionMedicationNameDocument,
		options,
	);
}
export function useStudentPrescriptionMedicationNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentPrescriptionMedicationNameQuery,
		StudentPrescriptionMedicationNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentPrescriptionMedicationNameQuery,
		StudentPrescriptionMedicationNameQueryVariables
	>(StudentPrescriptionMedicationNameDocument, options);
}
export type StudentPrescriptionMedicationNameQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationNameQuery
>;
export type StudentPrescriptionMedicationNameLazyQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationNameLazyQuery
>;
export type StudentPrescriptionMedicationNameSuspenseQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationNameSuspenseQuery
>;
export type StudentPrescriptionMedicationNameQueryResult = Apollo.QueryResult<
	StudentPrescriptionMedicationNameQuery,
	StudentPrescriptionMedicationNameQueryVariables
>;
export const StudentPrescriptionMedicationNamesDocument = gql`
	query studentPrescriptionMedicationNames(
		$filters: [StudentPrescriptionMedicationFilterInput!]
		$pagination: Pagination
		$order: StudentPrescriptionMedicationOrder
	) {
		studentPrescriptionMedicationConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentPrescriptionMedicationName
				}
			}
		}
	}
	${StudentPrescriptionMedicationNameFragmentDoc}
`;

/**
 * __useStudentPrescriptionMedicationNamesQuery__
 *
 * To run a query within a React component, call `useStudentPrescriptionMedicationNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentPrescriptionMedicationNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentPrescriptionMedicationNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentPrescriptionMedicationNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentPrescriptionMedicationNamesQuery,
		StudentPrescriptionMedicationNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentPrescriptionMedicationNamesQuery, StudentPrescriptionMedicationNamesQueryVariables>(
		StudentPrescriptionMedicationNamesDocument,
		options,
	);
}
export function useStudentPrescriptionMedicationNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentPrescriptionMedicationNamesQuery,
		StudentPrescriptionMedicationNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentPrescriptionMedicationNamesQuery, StudentPrescriptionMedicationNamesQueryVariables>(
		StudentPrescriptionMedicationNamesDocument,
		options,
	);
}
export function useStudentPrescriptionMedicationNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentPrescriptionMedicationNamesQuery,
		StudentPrescriptionMedicationNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentPrescriptionMedicationNamesQuery,
		StudentPrescriptionMedicationNamesQueryVariables
	>(StudentPrescriptionMedicationNamesDocument, options);
}
export type StudentPrescriptionMedicationNamesQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationNamesQuery
>;
export type StudentPrescriptionMedicationNamesLazyQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationNamesLazyQuery
>;
export type StudentPrescriptionMedicationNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationNamesSuspenseQuery
>;
export type StudentPrescriptionMedicationNamesQueryResult = Apollo.QueryResult<
	StudentPrescriptionMedicationNamesQuery,
	StudentPrescriptionMedicationNamesQueryVariables
>;
export const StudentPrescriptionMedicationPaginationDocument = gql`
	query studentPrescriptionMedicationPagination(
		$filters: [StudentPrescriptionMedicationFilterInput!]
		$order: StudentPrescriptionMedicationOrder
	) {
		studentPrescriptionMedicationConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentPrescriptionMedicationPaginationQuery__
 *
 * To run a query within a React component, call `useStudentPrescriptionMedicationPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentPrescriptionMedicationPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentPrescriptionMedicationPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentPrescriptionMedicationPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentPrescriptionMedicationPaginationQuery,
		StudentPrescriptionMedicationPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentPrescriptionMedicationPaginationQuery,
		StudentPrescriptionMedicationPaginationQueryVariables
	>(StudentPrescriptionMedicationPaginationDocument, options);
}
export function useStudentPrescriptionMedicationPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentPrescriptionMedicationPaginationQuery,
		StudentPrescriptionMedicationPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentPrescriptionMedicationPaginationQuery,
		StudentPrescriptionMedicationPaginationQueryVariables
	>(StudentPrescriptionMedicationPaginationDocument, options);
}
export function useStudentPrescriptionMedicationPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentPrescriptionMedicationPaginationQuery,
		StudentPrescriptionMedicationPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentPrescriptionMedicationPaginationQuery,
		StudentPrescriptionMedicationPaginationQueryVariables
	>(StudentPrescriptionMedicationPaginationDocument, options);
}
export type StudentPrescriptionMedicationPaginationQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationPaginationQuery
>;
export type StudentPrescriptionMedicationPaginationLazyQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationPaginationLazyQuery
>;
export type StudentPrescriptionMedicationPaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationPaginationSuspenseQuery
>;
export type StudentPrescriptionMedicationPaginationQueryResult = Apollo.QueryResult<
	StudentPrescriptionMedicationPaginationQuery,
	StudentPrescriptionMedicationPaginationQueryVariables
>;
export const StudentPrescriptionMedicationSelectDocument = gql`
	query studentPrescriptionMedicationSelect(
		$filters: [StudentPrescriptionMedicationFilterInput!]
		$order: StudentPrescriptionMedicationOrder
	) {
		studentPrescriptionMedicationConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentPrescriptionMedicationName
				}
			}
		}
	}
	${StudentPrescriptionMedicationNameFragmentDoc}
`;

/**
 * __useStudentPrescriptionMedicationSelectQuery__
 *
 * To run a query within a React component, call `useStudentPrescriptionMedicationSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentPrescriptionMedicationSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentPrescriptionMedicationSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentPrescriptionMedicationSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentPrescriptionMedicationSelectQuery,
		StudentPrescriptionMedicationSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentPrescriptionMedicationSelectQuery, StudentPrescriptionMedicationSelectQueryVariables>(
		StudentPrescriptionMedicationSelectDocument,
		options,
	);
}
export function useStudentPrescriptionMedicationSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentPrescriptionMedicationSelectQuery,
		StudentPrescriptionMedicationSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentPrescriptionMedicationSelectQuery,
		StudentPrescriptionMedicationSelectQueryVariables
	>(StudentPrescriptionMedicationSelectDocument, options);
}
export function useStudentPrescriptionMedicationSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentPrescriptionMedicationSelectQuery,
		StudentPrescriptionMedicationSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentPrescriptionMedicationSelectQuery,
		StudentPrescriptionMedicationSelectQueryVariables
	>(StudentPrescriptionMedicationSelectDocument, options);
}
export type StudentPrescriptionMedicationSelectQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationSelectQuery
>;
export type StudentPrescriptionMedicationSelectLazyQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationSelectLazyQuery
>;
export type StudentPrescriptionMedicationSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationSelectSuspenseQuery
>;
export type StudentPrescriptionMedicationSelectQueryResult = Apollo.QueryResult<
	StudentPrescriptionMedicationSelectQuery,
	StudentPrescriptionMedicationSelectQueryVariables
>;
export const StudentPrescriptionMedicationUpdateDocument = gql`
	mutation studentPrescriptionMedicationUpdate($id: ID!, $input: StudentPrescriptionMedicationUpdateInput!) {
		updateStudentPrescriptionMedication(id: $id, input: $input) {
			...StudentPrescriptionMedicationDetail
		}
	}
	${StudentPrescriptionMedicationDetailFragmentDoc}
`;
export type StudentPrescriptionMedicationUpdateMutationFn = Apollo.MutationFunction<
	StudentPrescriptionMedicationUpdateMutation,
	StudentPrescriptionMedicationUpdateMutationVariables
>;

/**
 * __useStudentPrescriptionMedicationUpdateMutation__
 *
 * To run a mutation, you first call `useStudentPrescriptionMedicationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentPrescriptionMedicationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentPrescriptionMedicationUpdateMutation, { data, loading, error }] = useStudentPrescriptionMedicationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentPrescriptionMedicationUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentPrescriptionMedicationUpdateMutation,
		StudentPrescriptionMedicationUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentPrescriptionMedicationUpdateMutation,
		StudentPrescriptionMedicationUpdateMutationVariables
	>(StudentPrescriptionMedicationUpdateDocument, options);
}
export type StudentPrescriptionMedicationUpdateMutationHookResult = ReturnType<
	typeof useStudentPrescriptionMedicationUpdateMutation
>;
export type StudentPrescriptionMedicationUpdateMutationResult =
	Apollo.MutationResult<StudentPrescriptionMedicationUpdateMutation>;
export type StudentPrescriptionMedicationUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentPrescriptionMedicationUpdateMutation,
	StudentPrescriptionMedicationUpdateMutationVariables
>;
export const StudentSocialEmotionalNoteCountDocument = gql`
	query studentSocialEmotionalNoteCount(
		$filters: [StudentSocialEmotionalNoteFilterInput!]
		$pagination: Pagination
		$order: StudentSocialEmotionalNoteOrder
	) {
		studentSocialEmotionalNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentSocialEmotionalNoteCountQuery__
 *
 * To run a query within a React component, call `useStudentSocialEmotionalNoteCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentSocialEmotionalNoteCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentSocialEmotionalNoteCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentSocialEmotionalNoteCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentSocialEmotionalNoteCountQuery,
		StudentSocialEmotionalNoteCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentSocialEmotionalNoteCountQuery, StudentSocialEmotionalNoteCountQueryVariables>(
		StudentSocialEmotionalNoteCountDocument,
		options,
	);
}
export function useStudentSocialEmotionalNoteCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentSocialEmotionalNoteCountQuery,
		StudentSocialEmotionalNoteCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentSocialEmotionalNoteCountQuery, StudentSocialEmotionalNoteCountQueryVariables>(
		StudentSocialEmotionalNoteCountDocument,
		options,
	);
}
export function useStudentSocialEmotionalNoteCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentSocialEmotionalNoteCountQuery,
		StudentSocialEmotionalNoteCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentSocialEmotionalNoteCountQuery, StudentSocialEmotionalNoteCountQueryVariables>(
		StudentSocialEmotionalNoteCountDocument,
		options,
	);
}
export type StudentSocialEmotionalNoteCountQueryHookResult = ReturnType<typeof useStudentSocialEmotionalNoteCountQuery>;
export type StudentSocialEmotionalNoteCountLazyQueryHookResult = ReturnType<
	typeof useStudentSocialEmotionalNoteCountLazyQuery
>;
export type StudentSocialEmotionalNoteCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentSocialEmotionalNoteCountSuspenseQuery
>;
export type StudentSocialEmotionalNoteCountQueryResult = Apollo.QueryResult<
	StudentSocialEmotionalNoteCountQuery,
	StudentSocialEmotionalNoteCountQueryVariables
>;
export const StudentSocialEmotionalNoteCreateDocument = gql`
	mutation studentSocialEmotionalNoteCreate($input: StudentSocialEmotionalNoteCreateInput!) {
		createStudentSocialEmotionalNote(input: $input) {
			...StudentSocialEmotionalNoteDetail
		}
	}
	${StudentSocialEmotionalNoteDetailFragmentDoc}
`;
export type StudentSocialEmotionalNoteCreateMutationFn = Apollo.MutationFunction<
	StudentSocialEmotionalNoteCreateMutation,
	StudentSocialEmotionalNoteCreateMutationVariables
>;

/**
 * __useStudentSocialEmotionalNoteCreateMutation__
 *
 * To run a mutation, you first call `useStudentSocialEmotionalNoteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentSocialEmotionalNoteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentSocialEmotionalNoteCreateMutation, { data, loading, error }] = useStudentSocialEmotionalNoteCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentSocialEmotionalNoteCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentSocialEmotionalNoteCreateMutation,
		StudentSocialEmotionalNoteCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentSocialEmotionalNoteCreateMutation,
		StudentSocialEmotionalNoteCreateMutationVariables
	>(StudentSocialEmotionalNoteCreateDocument, options);
}
export type StudentSocialEmotionalNoteCreateMutationHookResult = ReturnType<
	typeof useStudentSocialEmotionalNoteCreateMutation
>;
export type StudentSocialEmotionalNoteCreateMutationResult =
	Apollo.MutationResult<StudentSocialEmotionalNoteCreateMutation>;
export type StudentSocialEmotionalNoteCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentSocialEmotionalNoteCreateMutation,
	StudentSocialEmotionalNoteCreateMutationVariables
>;
export const StudentSocialEmotionalNoteDeleteDocument = gql`
	mutation studentSocialEmotionalNoteDelete($id: ID!) {
		deleteStudentSocialEmotionalNote(id: $id)
	}
`;
export type StudentSocialEmotionalNoteDeleteMutationFn = Apollo.MutationFunction<
	StudentSocialEmotionalNoteDeleteMutation,
	StudentSocialEmotionalNoteDeleteMutationVariables
>;

/**
 * __useStudentSocialEmotionalNoteDeleteMutation__
 *
 * To run a mutation, you first call `useStudentSocialEmotionalNoteDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentSocialEmotionalNoteDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentSocialEmotionalNoteDeleteMutation, { data, loading, error }] = useStudentSocialEmotionalNoteDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentSocialEmotionalNoteDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentSocialEmotionalNoteDeleteMutation,
		StudentSocialEmotionalNoteDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentSocialEmotionalNoteDeleteMutation,
		StudentSocialEmotionalNoteDeleteMutationVariables
	>(StudentSocialEmotionalNoteDeleteDocument, options);
}
export type StudentSocialEmotionalNoteDeleteMutationHookResult = ReturnType<
	typeof useStudentSocialEmotionalNoteDeleteMutation
>;
export type StudentSocialEmotionalNoteDeleteMutationResult =
	Apollo.MutationResult<StudentSocialEmotionalNoteDeleteMutation>;
export type StudentSocialEmotionalNoteDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentSocialEmotionalNoteDeleteMutation,
	StudentSocialEmotionalNoteDeleteMutationVariables
>;
export const StudentSocialEmotionalNoteDetailDocument = gql`
	query studentSocialEmotionalNoteDetail($id: ID!) {
		studentSocialEmotionalNote(id: $id) {
			...StudentSocialEmotionalNoteDetail
		}
	}
	${StudentSocialEmotionalNoteDetailFragmentDoc}
`;

/**
 * __useStudentSocialEmotionalNoteDetailQuery__
 *
 * To run a query within a React component, call `useStudentSocialEmotionalNoteDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentSocialEmotionalNoteDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentSocialEmotionalNoteDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentSocialEmotionalNoteDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentSocialEmotionalNoteDetailQuery,
		StudentSocialEmotionalNoteDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentSocialEmotionalNoteDetailQuery, StudentSocialEmotionalNoteDetailQueryVariables>(
		StudentSocialEmotionalNoteDetailDocument,
		options,
	);
}
export function useStudentSocialEmotionalNoteDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentSocialEmotionalNoteDetailQuery,
		StudentSocialEmotionalNoteDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentSocialEmotionalNoteDetailQuery, StudentSocialEmotionalNoteDetailQueryVariables>(
		StudentSocialEmotionalNoteDetailDocument,
		options,
	);
}
export function useStudentSocialEmotionalNoteDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentSocialEmotionalNoteDetailQuery,
		StudentSocialEmotionalNoteDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentSocialEmotionalNoteDetailQuery, StudentSocialEmotionalNoteDetailQueryVariables>(
		StudentSocialEmotionalNoteDetailDocument,
		options,
	);
}
export type StudentSocialEmotionalNoteDetailQueryHookResult = ReturnType<
	typeof useStudentSocialEmotionalNoteDetailQuery
>;
export type StudentSocialEmotionalNoteDetailLazyQueryHookResult = ReturnType<
	typeof useStudentSocialEmotionalNoteDetailLazyQuery
>;
export type StudentSocialEmotionalNoteDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentSocialEmotionalNoteDetailSuspenseQuery
>;
export type StudentSocialEmotionalNoteDetailQueryResult = Apollo.QueryResult<
	StudentSocialEmotionalNoteDetailQuery,
	StudentSocialEmotionalNoteDetailQueryVariables
>;
export const StudentSocialEmotionalNoteIndexDocument = gql`
	query studentSocialEmotionalNoteIndex(
		$filters: [StudentSocialEmotionalNoteFilterInput!]
		$pagination: Pagination
		$order: StudentSocialEmotionalNoteOrder
	) {
		studentSocialEmotionalNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					isIssueNatureLearningDifficulty
					isIssueNatureAttentionIssue
					isIssueNatureFocusIssue
					isIssueNatureEmotionalOrVulnerableIssue
					isIssueNatureOther
					issueNatureOther
					isSolutionRecDifferentiatedLearning
					isSolutionRecIndividualLearningPlan
					isSolutionRecTutoring
					isSolutionRecProfessionalSupport
					isSolutionRecInClassSupport
					isSolutionRecOther
					solutionRecOther
				}
			}
		}
	}
`;

/**
 * __useStudentSocialEmotionalNoteIndexQuery__
 *
 * To run a query within a React component, call `useStudentSocialEmotionalNoteIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentSocialEmotionalNoteIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentSocialEmotionalNoteIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentSocialEmotionalNoteIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentSocialEmotionalNoteIndexQuery,
		StudentSocialEmotionalNoteIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentSocialEmotionalNoteIndexQuery, StudentSocialEmotionalNoteIndexQueryVariables>(
		StudentSocialEmotionalNoteIndexDocument,
		options,
	);
}
export function useStudentSocialEmotionalNoteIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentSocialEmotionalNoteIndexQuery,
		StudentSocialEmotionalNoteIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentSocialEmotionalNoteIndexQuery, StudentSocialEmotionalNoteIndexQueryVariables>(
		StudentSocialEmotionalNoteIndexDocument,
		options,
	);
}
export function useStudentSocialEmotionalNoteIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentSocialEmotionalNoteIndexQuery,
		StudentSocialEmotionalNoteIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentSocialEmotionalNoteIndexQuery, StudentSocialEmotionalNoteIndexQueryVariables>(
		StudentSocialEmotionalNoteIndexDocument,
		options,
	);
}
export type StudentSocialEmotionalNoteIndexQueryHookResult = ReturnType<typeof useStudentSocialEmotionalNoteIndexQuery>;
export type StudentSocialEmotionalNoteIndexLazyQueryHookResult = ReturnType<
	typeof useStudentSocialEmotionalNoteIndexLazyQuery
>;
export type StudentSocialEmotionalNoteIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentSocialEmotionalNoteIndexSuspenseQuery
>;
export type StudentSocialEmotionalNoteIndexQueryResult = Apollo.QueryResult<
	StudentSocialEmotionalNoteIndexQuery,
	StudentSocialEmotionalNoteIndexQueryVariables
>;
export const StudentSocialEmotionalNoteNameDocument = gql`
	query studentSocialEmotionalNoteName($id: ID!) {
		studentSocialEmotionalNote(id: $id) {
			id
			...StudentSocialEmotionalNoteName
		}
	}
	${StudentSocialEmotionalNoteNameFragmentDoc}
`;

/**
 * __useStudentSocialEmotionalNoteNameQuery__
 *
 * To run a query within a React component, call `useStudentSocialEmotionalNoteNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentSocialEmotionalNoteNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentSocialEmotionalNoteNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentSocialEmotionalNoteNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentSocialEmotionalNoteNameQuery,
		StudentSocialEmotionalNoteNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentSocialEmotionalNoteNameQuery, StudentSocialEmotionalNoteNameQueryVariables>(
		StudentSocialEmotionalNoteNameDocument,
		options,
	);
}
export function useStudentSocialEmotionalNoteNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentSocialEmotionalNoteNameQuery,
		StudentSocialEmotionalNoteNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentSocialEmotionalNoteNameQuery, StudentSocialEmotionalNoteNameQueryVariables>(
		StudentSocialEmotionalNoteNameDocument,
		options,
	);
}
export function useStudentSocialEmotionalNoteNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentSocialEmotionalNoteNameQuery,
		StudentSocialEmotionalNoteNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentSocialEmotionalNoteNameQuery, StudentSocialEmotionalNoteNameQueryVariables>(
		StudentSocialEmotionalNoteNameDocument,
		options,
	);
}
export type StudentSocialEmotionalNoteNameQueryHookResult = ReturnType<typeof useStudentSocialEmotionalNoteNameQuery>;
export type StudentSocialEmotionalNoteNameLazyQueryHookResult = ReturnType<
	typeof useStudentSocialEmotionalNoteNameLazyQuery
>;
export type StudentSocialEmotionalNoteNameSuspenseQueryHookResult = ReturnType<
	typeof useStudentSocialEmotionalNoteNameSuspenseQuery
>;
export type StudentSocialEmotionalNoteNameQueryResult = Apollo.QueryResult<
	StudentSocialEmotionalNoteNameQuery,
	StudentSocialEmotionalNoteNameQueryVariables
>;
export const StudentSocialEmotionalNoteNamesDocument = gql`
	query studentSocialEmotionalNoteNames(
		$filters: [StudentSocialEmotionalNoteFilterInput!]
		$pagination: Pagination
		$order: StudentSocialEmotionalNoteOrder
	) {
		studentSocialEmotionalNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentSocialEmotionalNoteName
				}
			}
		}
	}
	${StudentSocialEmotionalNoteNameFragmentDoc}
`;

/**
 * __useStudentSocialEmotionalNoteNamesQuery__
 *
 * To run a query within a React component, call `useStudentSocialEmotionalNoteNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentSocialEmotionalNoteNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentSocialEmotionalNoteNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentSocialEmotionalNoteNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentSocialEmotionalNoteNamesQuery,
		StudentSocialEmotionalNoteNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentSocialEmotionalNoteNamesQuery, StudentSocialEmotionalNoteNamesQueryVariables>(
		StudentSocialEmotionalNoteNamesDocument,
		options,
	);
}
export function useStudentSocialEmotionalNoteNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentSocialEmotionalNoteNamesQuery,
		StudentSocialEmotionalNoteNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentSocialEmotionalNoteNamesQuery, StudentSocialEmotionalNoteNamesQueryVariables>(
		StudentSocialEmotionalNoteNamesDocument,
		options,
	);
}
export function useStudentSocialEmotionalNoteNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentSocialEmotionalNoteNamesQuery,
		StudentSocialEmotionalNoteNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentSocialEmotionalNoteNamesQuery, StudentSocialEmotionalNoteNamesQueryVariables>(
		StudentSocialEmotionalNoteNamesDocument,
		options,
	);
}
export type StudentSocialEmotionalNoteNamesQueryHookResult = ReturnType<typeof useStudentSocialEmotionalNoteNamesQuery>;
export type StudentSocialEmotionalNoteNamesLazyQueryHookResult = ReturnType<
	typeof useStudentSocialEmotionalNoteNamesLazyQuery
>;
export type StudentSocialEmotionalNoteNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentSocialEmotionalNoteNamesSuspenseQuery
>;
export type StudentSocialEmotionalNoteNamesQueryResult = Apollo.QueryResult<
	StudentSocialEmotionalNoteNamesQuery,
	StudentSocialEmotionalNoteNamesQueryVariables
>;
export const StudentSocialEmotionalNotePaginationDocument = gql`
	query studentSocialEmotionalNotePagination(
		$filters: [StudentSocialEmotionalNoteFilterInput!]
		$order: StudentSocialEmotionalNoteOrder
	) {
		studentSocialEmotionalNoteConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentSocialEmotionalNotePaginationQuery__
 *
 * To run a query within a React component, call `useStudentSocialEmotionalNotePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentSocialEmotionalNotePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentSocialEmotionalNotePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentSocialEmotionalNotePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentSocialEmotionalNotePaginationQuery,
		StudentSocialEmotionalNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentSocialEmotionalNotePaginationQuery, StudentSocialEmotionalNotePaginationQueryVariables>(
		StudentSocialEmotionalNotePaginationDocument,
		options,
	);
}
export function useStudentSocialEmotionalNotePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentSocialEmotionalNotePaginationQuery,
		StudentSocialEmotionalNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentSocialEmotionalNotePaginationQuery,
		StudentSocialEmotionalNotePaginationQueryVariables
	>(StudentSocialEmotionalNotePaginationDocument, options);
}
export function useStudentSocialEmotionalNotePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentSocialEmotionalNotePaginationQuery,
		StudentSocialEmotionalNotePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentSocialEmotionalNotePaginationQuery,
		StudentSocialEmotionalNotePaginationQueryVariables
	>(StudentSocialEmotionalNotePaginationDocument, options);
}
export type StudentSocialEmotionalNotePaginationQueryHookResult = ReturnType<
	typeof useStudentSocialEmotionalNotePaginationQuery
>;
export type StudentSocialEmotionalNotePaginationLazyQueryHookResult = ReturnType<
	typeof useStudentSocialEmotionalNotePaginationLazyQuery
>;
export type StudentSocialEmotionalNotePaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentSocialEmotionalNotePaginationSuspenseQuery
>;
export type StudentSocialEmotionalNotePaginationQueryResult = Apollo.QueryResult<
	StudentSocialEmotionalNotePaginationQuery,
	StudentSocialEmotionalNotePaginationQueryVariables
>;
export const StudentSocialEmotionalNoteSelectDocument = gql`
	query studentSocialEmotionalNoteSelect(
		$filters: [StudentSocialEmotionalNoteFilterInput!]
		$order: StudentSocialEmotionalNoteOrder
	) {
		studentSocialEmotionalNoteConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentSocialEmotionalNoteName
				}
			}
		}
	}
	${StudentSocialEmotionalNoteNameFragmentDoc}
`;

/**
 * __useStudentSocialEmotionalNoteSelectQuery__
 *
 * To run a query within a React component, call `useStudentSocialEmotionalNoteSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentSocialEmotionalNoteSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentSocialEmotionalNoteSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentSocialEmotionalNoteSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentSocialEmotionalNoteSelectQuery,
		StudentSocialEmotionalNoteSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentSocialEmotionalNoteSelectQuery, StudentSocialEmotionalNoteSelectQueryVariables>(
		StudentSocialEmotionalNoteSelectDocument,
		options,
	);
}
export function useStudentSocialEmotionalNoteSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentSocialEmotionalNoteSelectQuery,
		StudentSocialEmotionalNoteSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentSocialEmotionalNoteSelectQuery, StudentSocialEmotionalNoteSelectQueryVariables>(
		StudentSocialEmotionalNoteSelectDocument,
		options,
	);
}
export function useStudentSocialEmotionalNoteSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentSocialEmotionalNoteSelectQuery,
		StudentSocialEmotionalNoteSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentSocialEmotionalNoteSelectQuery, StudentSocialEmotionalNoteSelectQueryVariables>(
		StudentSocialEmotionalNoteSelectDocument,
		options,
	);
}
export type StudentSocialEmotionalNoteSelectQueryHookResult = ReturnType<
	typeof useStudentSocialEmotionalNoteSelectQuery
>;
export type StudentSocialEmotionalNoteSelectLazyQueryHookResult = ReturnType<
	typeof useStudentSocialEmotionalNoteSelectLazyQuery
>;
export type StudentSocialEmotionalNoteSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentSocialEmotionalNoteSelectSuspenseQuery
>;
export type StudentSocialEmotionalNoteSelectQueryResult = Apollo.QueryResult<
	StudentSocialEmotionalNoteSelectQuery,
	StudentSocialEmotionalNoteSelectQueryVariables
>;
export const StudentSocialEmotionalNoteUpdateDocument = gql`
	mutation studentSocialEmotionalNoteUpdate($id: ID!, $input: StudentSocialEmotionalNoteUpdateInput!) {
		updateStudentSocialEmotionalNote(id: $id, input: $input) {
			...StudentSocialEmotionalNoteDetail
		}
	}
	${StudentSocialEmotionalNoteDetailFragmentDoc}
`;
export type StudentSocialEmotionalNoteUpdateMutationFn = Apollo.MutationFunction<
	StudentSocialEmotionalNoteUpdateMutation,
	StudentSocialEmotionalNoteUpdateMutationVariables
>;

/**
 * __useStudentSocialEmotionalNoteUpdateMutation__
 *
 * To run a mutation, you first call `useStudentSocialEmotionalNoteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentSocialEmotionalNoteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentSocialEmotionalNoteUpdateMutation, { data, loading, error }] = useStudentSocialEmotionalNoteUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentSocialEmotionalNoteUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentSocialEmotionalNoteUpdateMutation,
		StudentSocialEmotionalNoteUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		StudentSocialEmotionalNoteUpdateMutation,
		StudentSocialEmotionalNoteUpdateMutationVariables
	>(StudentSocialEmotionalNoteUpdateDocument, options);
}
export type StudentSocialEmotionalNoteUpdateMutationHookResult = ReturnType<
	typeof useStudentSocialEmotionalNoteUpdateMutation
>;
export type StudentSocialEmotionalNoteUpdateMutationResult =
	Apollo.MutationResult<StudentSocialEmotionalNoteUpdateMutation>;
export type StudentSocialEmotionalNoteUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentSocialEmotionalNoteUpdateMutation,
	StudentSocialEmotionalNoteUpdateMutationVariables
>;
export const StudentVaccinationRecordCountDocument = gql`
	query studentVaccinationRecordCount(
		$filters: [StudentVaccinationRecordFilterInput!]
		$pagination: Pagination
		$order: StudentVaccinationRecordOrder
	) {
		studentVaccinationRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useStudentVaccinationRecordCountQuery__
 *
 * To run a query within a React component, call `useStudentVaccinationRecordCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentVaccinationRecordCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentVaccinationRecordCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentVaccinationRecordCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentVaccinationRecordCountQuery,
		StudentVaccinationRecordCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentVaccinationRecordCountQuery, StudentVaccinationRecordCountQueryVariables>(
		StudentVaccinationRecordCountDocument,
		options,
	);
}
export function useStudentVaccinationRecordCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentVaccinationRecordCountQuery,
		StudentVaccinationRecordCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentVaccinationRecordCountQuery, StudentVaccinationRecordCountQueryVariables>(
		StudentVaccinationRecordCountDocument,
		options,
	);
}
export function useStudentVaccinationRecordCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentVaccinationRecordCountQuery,
		StudentVaccinationRecordCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentVaccinationRecordCountQuery, StudentVaccinationRecordCountQueryVariables>(
		StudentVaccinationRecordCountDocument,
		options,
	);
}
export type StudentVaccinationRecordCountQueryHookResult = ReturnType<typeof useStudentVaccinationRecordCountQuery>;
export type StudentVaccinationRecordCountLazyQueryHookResult = ReturnType<
	typeof useStudentVaccinationRecordCountLazyQuery
>;
export type StudentVaccinationRecordCountSuspenseQueryHookResult = ReturnType<
	typeof useStudentVaccinationRecordCountSuspenseQuery
>;
export type StudentVaccinationRecordCountQueryResult = Apollo.QueryResult<
	StudentVaccinationRecordCountQuery,
	StudentVaccinationRecordCountQueryVariables
>;
export const StudentVaccinationRecordCreateDocument = gql`
	mutation studentVaccinationRecordCreate($input: StudentVaccinationRecordCreateInput!) {
		createStudentVaccinationRecord(input: $input) {
			...StudentVaccinationRecordDetail
		}
	}
	${StudentVaccinationRecordDetailFragmentDoc}
`;
export type StudentVaccinationRecordCreateMutationFn = Apollo.MutationFunction<
	StudentVaccinationRecordCreateMutation,
	StudentVaccinationRecordCreateMutationVariables
>;

/**
 * __useStudentVaccinationRecordCreateMutation__
 *
 * To run a mutation, you first call `useStudentVaccinationRecordCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentVaccinationRecordCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentVaccinationRecordCreateMutation, { data, loading, error }] = useStudentVaccinationRecordCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentVaccinationRecordCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentVaccinationRecordCreateMutation,
		StudentVaccinationRecordCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentVaccinationRecordCreateMutation, StudentVaccinationRecordCreateMutationVariables>(
		StudentVaccinationRecordCreateDocument,
		options,
	);
}
export type StudentVaccinationRecordCreateMutationHookResult = ReturnType<
	typeof useStudentVaccinationRecordCreateMutation
>;
export type StudentVaccinationRecordCreateMutationResult =
	Apollo.MutationResult<StudentVaccinationRecordCreateMutation>;
export type StudentVaccinationRecordCreateMutationOptions = Apollo.BaseMutationOptions<
	StudentVaccinationRecordCreateMutation,
	StudentVaccinationRecordCreateMutationVariables
>;
export const StudentVaccinationRecordDeleteDocument = gql`
	mutation studentVaccinationRecordDelete($id: ID!) {
		deleteStudentVaccinationRecord(id: $id)
	}
`;
export type StudentVaccinationRecordDeleteMutationFn = Apollo.MutationFunction<
	StudentVaccinationRecordDeleteMutation,
	StudentVaccinationRecordDeleteMutationVariables
>;

/**
 * __useStudentVaccinationRecordDeleteMutation__
 *
 * To run a mutation, you first call `useStudentVaccinationRecordDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentVaccinationRecordDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentVaccinationRecordDeleteMutation, { data, loading, error }] = useStudentVaccinationRecordDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentVaccinationRecordDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentVaccinationRecordDeleteMutation,
		StudentVaccinationRecordDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentVaccinationRecordDeleteMutation, StudentVaccinationRecordDeleteMutationVariables>(
		StudentVaccinationRecordDeleteDocument,
		options,
	);
}
export type StudentVaccinationRecordDeleteMutationHookResult = ReturnType<
	typeof useStudentVaccinationRecordDeleteMutation
>;
export type StudentVaccinationRecordDeleteMutationResult =
	Apollo.MutationResult<StudentVaccinationRecordDeleteMutation>;
export type StudentVaccinationRecordDeleteMutationOptions = Apollo.BaseMutationOptions<
	StudentVaccinationRecordDeleteMutation,
	StudentVaccinationRecordDeleteMutationVariables
>;
export const StudentVaccinationRecordDetailDocument = gql`
	query studentVaccinationRecordDetail($id: ID!) {
		studentVaccinationRecord(id: $id) {
			...StudentVaccinationRecordDetail
		}
	}
	${StudentVaccinationRecordDetailFragmentDoc}
`;

/**
 * __useStudentVaccinationRecordDetailQuery__
 *
 * To run a query within a React component, call `useStudentVaccinationRecordDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentVaccinationRecordDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentVaccinationRecordDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentVaccinationRecordDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentVaccinationRecordDetailQuery,
		StudentVaccinationRecordDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentVaccinationRecordDetailQuery, StudentVaccinationRecordDetailQueryVariables>(
		StudentVaccinationRecordDetailDocument,
		options,
	);
}
export function useStudentVaccinationRecordDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentVaccinationRecordDetailQuery,
		StudentVaccinationRecordDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentVaccinationRecordDetailQuery, StudentVaccinationRecordDetailQueryVariables>(
		StudentVaccinationRecordDetailDocument,
		options,
	);
}
export function useStudentVaccinationRecordDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentVaccinationRecordDetailQuery,
		StudentVaccinationRecordDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentVaccinationRecordDetailQuery, StudentVaccinationRecordDetailQueryVariables>(
		StudentVaccinationRecordDetailDocument,
		options,
	);
}
export type StudentVaccinationRecordDetailQueryHookResult = ReturnType<typeof useStudentVaccinationRecordDetailQuery>;
export type StudentVaccinationRecordDetailLazyQueryHookResult = ReturnType<
	typeof useStudentVaccinationRecordDetailLazyQuery
>;
export type StudentVaccinationRecordDetailSuspenseQueryHookResult = ReturnType<
	typeof useStudentVaccinationRecordDetailSuspenseQuery
>;
export type StudentVaccinationRecordDetailQueryResult = Apollo.QueryResult<
	StudentVaccinationRecordDetailQuery,
	StudentVaccinationRecordDetailQueryVariables
>;
export const StudentVaccinationRecordIndexDocument = gql`
	query studentVaccinationRecordIndex(
		$filters: [StudentVaccinationRecordFilterInput!]
		$pagination: Pagination
		$order: StudentVaccinationRecordOrder
	) {
		studentVaccinationRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					receivedOn
					notes
				}
			}
		}
	}
`;

/**
 * __useStudentVaccinationRecordIndexQuery__
 *
 * To run a query within a React component, call `useStudentVaccinationRecordIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentVaccinationRecordIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentVaccinationRecordIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentVaccinationRecordIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentVaccinationRecordIndexQuery,
		StudentVaccinationRecordIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentVaccinationRecordIndexQuery, StudentVaccinationRecordIndexQueryVariables>(
		StudentVaccinationRecordIndexDocument,
		options,
	);
}
export function useStudentVaccinationRecordIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentVaccinationRecordIndexQuery,
		StudentVaccinationRecordIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentVaccinationRecordIndexQuery, StudentVaccinationRecordIndexQueryVariables>(
		StudentVaccinationRecordIndexDocument,
		options,
	);
}
export function useStudentVaccinationRecordIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentVaccinationRecordIndexQuery,
		StudentVaccinationRecordIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentVaccinationRecordIndexQuery, StudentVaccinationRecordIndexQueryVariables>(
		StudentVaccinationRecordIndexDocument,
		options,
	);
}
export type StudentVaccinationRecordIndexQueryHookResult = ReturnType<typeof useStudentVaccinationRecordIndexQuery>;
export type StudentVaccinationRecordIndexLazyQueryHookResult = ReturnType<
	typeof useStudentVaccinationRecordIndexLazyQuery
>;
export type StudentVaccinationRecordIndexSuspenseQueryHookResult = ReturnType<
	typeof useStudentVaccinationRecordIndexSuspenseQuery
>;
export type StudentVaccinationRecordIndexQueryResult = Apollo.QueryResult<
	StudentVaccinationRecordIndexQuery,
	StudentVaccinationRecordIndexQueryVariables
>;
export const StudentVaccinationRecordStudentListDocument = gql`
	query studentVaccinationRecordStudentList(
		$filters: [StudentVaccinationRecordFilterInput!]
		$pagination: Pagination
		$order: StudentVaccinationRecordOrder
	) {
		studentVaccinationRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					receivedOn
					notes
					vaccine {
						id
						...VaccineName
					}
				}
			}
		}
	}
	${VaccineNameFragmentDoc}
`;

/**
 * __useStudentVaccinationRecordStudentListQuery__
 *
 * To run a query within a React component, call `useStudentVaccinationRecordStudentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentVaccinationRecordStudentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentVaccinationRecordStudentListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentVaccinationRecordStudentListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentVaccinationRecordStudentListQuery,
		StudentVaccinationRecordStudentListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentVaccinationRecordStudentListQuery, StudentVaccinationRecordStudentListQueryVariables>(
		StudentVaccinationRecordStudentListDocument,
		options,
	);
}
export function useStudentVaccinationRecordStudentListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentVaccinationRecordStudentListQuery,
		StudentVaccinationRecordStudentListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentVaccinationRecordStudentListQuery,
		StudentVaccinationRecordStudentListQueryVariables
	>(StudentVaccinationRecordStudentListDocument, options);
}
export function useStudentVaccinationRecordStudentListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentVaccinationRecordStudentListQuery,
		StudentVaccinationRecordStudentListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentVaccinationRecordStudentListQuery,
		StudentVaccinationRecordStudentListQueryVariables
	>(StudentVaccinationRecordStudentListDocument, options);
}
export type StudentVaccinationRecordStudentListQueryHookResult = ReturnType<
	typeof useStudentVaccinationRecordStudentListQuery
>;
export type StudentVaccinationRecordStudentListLazyQueryHookResult = ReturnType<
	typeof useStudentVaccinationRecordStudentListLazyQuery
>;
export type StudentVaccinationRecordStudentListSuspenseQueryHookResult = ReturnType<
	typeof useStudentVaccinationRecordStudentListSuspenseQuery
>;
export type StudentVaccinationRecordStudentListQueryResult = Apollo.QueryResult<
	StudentVaccinationRecordStudentListQuery,
	StudentVaccinationRecordStudentListQueryVariables
>;
export const StudentVaccinationRecordNameDocument = gql`
	query studentVaccinationRecordName($id: ID!) {
		studentVaccinationRecord(id: $id) {
			id
			...StudentVaccinationRecordName
		}
	}
	${StudentVaccinationRecordNameFragmentDoc}
`;

/**
 * __useStudentVaccinationRecordNameQuery__
 *
 * To run a query within a React component, call `useStudentVaccinationRecordNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentVaccinationRecordNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentVaccinationRecordNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentVaccinationRecordNameQuery(
	baseOptions: Apollo.QueryHookOptions<StudentVaccinationRecordNameQuery, StudentVaccinationRecordNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentVaccinationRecordNameQuery, StudentVaccinationRecordNameQueryVariables>(
		StudentVaccinationRecordNameDocument,
		options,
	);
}
export function useStudentVaccinationRecordNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentVaccinationRecordNameQuery,
		StudentVaccinationRecordNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentVaccinationRecordNameQuery, StudentVaccinationRecordNameQueryVariables>(
		StudentVaccinationRecordNameDocument,
		options,
	);
}
export function useStudentVaccinationRecordNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentVaccinationRecordNameQuery,
		StudentVaccinationRecordNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentVaccinationRecordNameQuery, StudentVaccinationRecordNameQueryVariables>(
		StudentVaccinationRecordNameDocument,
		options,
	);
}
export type StudentVaccinationRecordNameQueryHookResult = ReturnType<typeof useStudentVaccinationRecordNameQuery>;
export type StudentVaccinationRecordNameLazyQueryHookResult = ReturnType<
	typeof useStudentVaccinationRecordNameLazyQuery
>;
export type StudentVaccinationRecordNameSuspenseQueryHookResult = ReturnType<
	typeof useStudentVaccinationRecordNameSuspenseQuery
>;
export type StudentVaccinationRecordNameQueryResult = Apollo.QueryResult<
	StudentVaccinationRecordNameQuery,
	StudentVaccinationRecordNameQueryVariables
>;
export const StudentVaccinationRecordNamesDocument = gql`
	query studentVaccinationRecordNames(
		$filters: [StudentVaccinationRecordFilterInput!]
		$pagination: Pagination
		$order: StudentVaccinationRecordOrder
	) {
		studentVaccinationRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentVaccinationRecordName
				}
			}
		}
	}
	${StudentVaccinationRecordNameFragmentDoc}
`;

/**
 * __useStudentVaccinationRecordNamesQuery__
 *
 * To run a query within a React component, call `useStudentVaccinationRecordNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentVaccinationRecordNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentVaccinationRecordNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentVaccinationRecordNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentVaccinationRecordNamesQuery,
		StudentVaccinationRecordNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentVaccinationRecordNamesQuery, StudentVaccinationRecordNamesQueryVariables>(
		StudentVaccinationRecordNamesDocument,
		options,
	);
}
export function useStudentVaccinationRecordNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentVaccinationRecordNamesQuery,
		StudentVaccinationRecordNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentVaccinationRecordNamesQuery, StudentVaccinationRecordNamesQueryVariables>(
		StudentVaccinationRecordNamesDocument,
		options,
	);
}
export function useStudentVaccinationRecordNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentVaccinationRecordNamesQuery,
		StudentVaccinationRecordNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentVaccinationRecordNamesQuery, StudentVaccinationRecordNamesQueryVariables>(
		StudentVaccinationRecordNamesDocument,
		options,
	);
}
export type StudentVaccinationRecordNamesQueryHookResult = ReturnType<typeof useStudentVaccinationRecordNamesQuery>;
export type StudentVaccinationRecordNamesLazyQueryHookResult = ReturnType<
	typeof useStudentVaccinationRecordNamesLazyQuery
>;
export type StudentVaccinationRecordNamesSuspenseQueryHookResult = ReturnType<
	typeof useStudentVaccinationRecordNamesSuspenseQuery
>;
export type StudentVaccinationRecordNamesQueryResult = Apollo.QueryResult<
	StudentVaccinationRecordNamesQuery,
	StudentVaccinationRecordNamesQueryVariables
>;
export const StudentVaccinationRecordPaginationDocument = gql`
	query studentVaccinationRecordPagination(
		$filters: [StudentVaccinationRecordFilterInput!]
		$order: StudentVaccinationRecordOrder
	) {
		studentVaccinationRecordConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useStudentVaccinationRecordPaginationQuery__
 *
 * To run a query within a React component, call `useStudentVaccinationRecordPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentVaccinationRecordPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentVaccinationRecordPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentVaccinationRecordPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentVaccinationRecordPaginationQuery,
		StudentVaccinationRecordPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentVaccinationRecordPaginationQuery, StudentVaccinationRecordPaginationQueryVariables>(
		StudentVaccinationRecordPaginationDocument,
		options,
	);
}
export function useStudentVaccinationRecordPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentVaccinationRecordPaginationQuery,
		StudentVaccinationRecordPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentVaccinationRecordPaginationQuery, StudentVaccinationRecordPaginationQueryVariables>(
		StudentVaccinationRecordPaginationDocument,
		options,
	);
}
export function useStudentVaccinationRecordPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentVaccinationRecordPaginationQuery,
		StudentVaccinationRecordPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentVaccinationRecordPaginationQuery,
		StudentVaccinationRecordPaginationQueryVariables
	>(StudentVaccinationRecordPaginationDocument, options);
}
export type StudentVaccinationRecordPaginationQueryHookResult = ReturnType<
	typeof useStudentVaccinationRecordPaginationQuery
>;
export type StudentVaccinationRecordPaginationLazyQueryHookResult = ReturnType<
	typeof useStudentVaccinationRecordPaginationLazyQuery
>;
export type StudentVaccinationRecordPaginationSuspenseQueryHookResult = ReturnType<
	typeof useStudentVaccinationRecordPaginationSuspenseQuery
>;
export type StudentVaccinationRecordPaginationQueryResult = Apollo.QueryResult<
	StudentVaccinationRecordPaginationQuery,
	StudentVaccinationRecordPaginationQueryVariables
>;
export const StudentVaccinationRecordSelectDocument = gql`
	query studentVaccinationRecordSelect(
		$filters: [StudentVaccinationRecordFilterInput!]
		$order: StudentVaccinationRecordOrder
	) {
		studentVaccinationRecordConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...StudentVaccinationRecordName
				}
			}
		}
	}
	${StudentVaccinationRecordNameFragmentDoc}
`;

/**
 * __useStudentVaccinationRecordSelectQuery__
 *
 * To run a query within a React component, call `useStudentVaccinationRecordSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentVaccinationRecordSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentVaccinationRecordSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useStudentVaccinationRecordSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentVaccinationRecordSelectQuery,
		StudentVaccinationRecordSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentVaccinationRecordSelectQuery, StudentVaccinationRecordSelectQueryVariables>(
		StudentVaccinationRecordSelectDocument,
		options,
	);
}
export function useStudentVaccinationRecordSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentVaccinationRecordSelectQuery,
		StudentVaccinationRecordSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentVaccinationRecordSelectQuery, StudentVaccinationRecordSelectQueryVariables>(
		StudentVaccinationRecordSelectDocument,
		options,
	);
}
export function useStudentVaccinationRecordSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentVaccinationRecordSelectQuery,
		StudentVaccinationRecordSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentVaccinationRecordSelectQuery, StudentVaccinationRecordSelectQueryVariables>(
		StudentVaccinationRecordSelectDocument,
		options,
	);
}
export type StudentVaccinationRecordSelectQueryHookResult = ReturnType<typeof useStudentVaccinationRecordSelectQuery>;
export type StudentVaccinationRecordSelectLazyQueryHookResult = ReturnType<
	typeof useStudentVaccinationRecordSelectLazyQuery
>;
export type StudentVaccinationRecordSelectSuspenseQueryHookResult = ReturnType<
	typeof useStudentVaccinationRecordSelectSuspenseQuery
>;
export type StudentVaccinationRecordSelectQueryResult = Apollo.QueryResult<
	StudentVaccinationRecordSelectQuery,
	StudentVaccinationRecordSelectQueryVariables
>;
export const StudentVaccinationRecordUpdateDocument = gql`
	mutation studentVaccinationRecordUpdate($id: ID!, $input: StudentVaccinationRecordUpdateInput!) {
		updateStudentVaccinationRecord(id: $id, input: $input) {
			...StudentVaccinationRecordDetail
		}
	}
	${StudentVaccinationRecordDetailFragmentDoc}
`;
export type StudentVaccinationRecordUpdateMutationFn = Apollo.MutationFunction<
	StudentVaccinationRecordUpdateMutation,
	StudentVaccinationRecordUpdateMutationVariables
>;

/**
 * __useStudentVaccinationRecordUpdateMutation__
 *
 * To run a mutation, you first call `useStudentVaccinationRecordUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentVaccinationRecordUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentVaccinationRecordUpdateMutation, { data, loading, error }] = useStudentVaccinationRecordUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentVaccinationRecordUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		StudentVaccinationRecordUpdateMutation,
		StudentVaccinationRecordUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<StudentVaccinationRecordUpdateMutation, StudentVaccinationRecordUpdateMutationVariables>(
		StudentVaccinationRecordUpdateDocument,
		options,
	);
}
export type StudentVaccinationRecordUpdateMutationHookResult = ReturnType<
	typeof useStudentVaccinationRecordUpdateMutation
>;
export type StudentVaccinationRecordUpdateMutationResult =
	Apollo.MutationResult<StudentVaccinationRecordUpdateMutation>;
export type StudentVaccinationRecordUpdateMutationOptions = Apollo.BaseMutationOptions<
	StudentVaccinationRecordUpdateMutation,
	StudentVaccinationRecordUpdateMutationVariables
>;
export const TeacherCourseSectionEnrollmentCountDocument = gql`
	query teacherCourseSectionEnrollmentCount(
		$filters: [TeacherCourseSectionEnrollmentFilterInput!]
		$pagination: Pagination
		$order: TeacherCourseSectionEnrollmentOrder
	) {
		teacherCourseSectionEnrollmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useTeacherCourseSectionEnrollmentCountQuery__
 *
 * To run a query within a React component, call `useTeacherCourseSectionEnrollmentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherCourseSectionEnrollmentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherCourseSectionEnrollmentCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTeacherCourseSectionEnrollmentCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TeacherCourseSectionEnrollmentCountQuery,
		TeacherCourseSectionEnrollmentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TeacherCourseSectionEnrollmentCountQuery, TeacherCourseSectionEnrollmentCountQueryVariables>(
		TeacherCourseSectionEnrollmentCountDocument,
		options,
	);
}
export function useTeacherCourseSectionEnrollmentCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeacherCourseSectionEnrollmentCountQuery,
		TeacherCourseSectionEnrollmentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		TeacherCourseSectionEnrollmentCountQuery,
		TeacherCourseSectionEnrollmentCountQueryVariables
	>(TeacherCourseSectionEnrollmentCountDocument, options);
}
export function useTeacherCourseSectionEnrollmentCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TeacherCourseSectionEnrollmentCountQuery,
		TeacherCourseSectionEnrollmentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		TeacherCourseSectionEnrollmentCountQuery,
		TeacherCourseSectionEnrollmentCountQueryVariables
	>(TeacherCourseSectionEnrollmentCountDocument, options);
}
export type TeacherCourseSectionEnrollmentCountQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentCountQuery
>;
export type TeacherCourseSectionEnrollmentCountLazyQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentCountLazyQuery
>;
export type TeacherCourseSectionEnrollmentCountSuspenseQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentCountSuspenseQuery
>;
export type TeacherCourseSectionEnrollmentCountQueryResult = Apollo.QueryResult<
	TeacherCourseSectionEnrollmentCountQuery,
	TeacherCourseSectionEnrollmentCountQueryVariables
>;
export const TeacherCourseSectionEnrollmentCreateDocument = gql`
	mutation teacherCourseSectionEnrollmentCreate($input: TeacherCourseSectionEnrollmentCreateInput!) {
		createTeacherCourseSectionEnrollment(input: $input) {
			...TeacherCourseSectionEnrollmentDetail
		}
	}
	${TeacherCourseSectionEnrollmentDetailFragmentDoc}
`;
export type TeacherCourseSectionEnrollmentCreateMutationFn = Apollo.MutationFunction<
	TeacherCourseSectionEnrollmentCreateMutation,
	TeacherCourseSectionEnrollmentCreateMutationVariables
>;

/**
 * __useTeacherCourseSectionEnrollmentCreateMutation__
 *
 * To run a mutation, you first call `useTeacherCourseSectionEnrollmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeacherCourseSectionEnrollmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teacherCourseSectionEnrollmentCreateMutation, { data, loading, error }] = useTeacherCourseSectionEnrollmentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTeacherCourseSectionEnrollmentCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		TeacherCourseSectionEnrollmentCreateMutation,
		TeacherCourseSectionEnrollmentCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		TeacherCourseSectionEnrollmentCreateMutation,
		TeacherCourseSectionEnrollmentCreateMutationVariables
	>(TeacherCourseSectionEnrollmentCreateDocument, options);
}
export type TeacherCourseSectionEnrollmentCreateMutationHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentCreateMutation
>;
export type TeacherCourseSectionEnrollmentCreateMutationResult =
	Apollo.MutationResult<TeacherCourseSectionEnrollmentCreateMutation>;
export type TeacherCourseSectionEnrollmentCreateMutationOptions = Apollo.BaseMutationOptions<
	TeacherCourseSectionEnrollmentCreateMutation,
	TeacherCourseSectionEnrollmentCreateMutationVariables
>;
export const TeacherCourseSectionEnrollmentDeleteDocument = gql`
	mutation teacherCourseSectionEnrollmentDelete($id: ID!) {
		deleteTeacherCourseSectionEnrollment(id: $id)
	}
`;
export type TeacherCourseSectionEnrollmentDeleteMutationFn = Apollo.MutationFunction<
	TeacherCourseSectionEnrollmentDeleteMutation,
	TeacherCourseSectionEnrollmentDeleteMutationVariables
>;

/**
 * __useTeacherCourseSectionEnrollmentDeleteMutation__
 *
 * To run a mutation, you first call `useTeacherCourseSectionEnrollmentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeacherCourseSectionEnrollmentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teacherCourseSectionEnrollmentDeleteMutation, { data, loading, error }] = useTeacherCourseSectionEnrollmentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeacherCourseSectionEnrollmentDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		TeacherCourseSectionEnrollmentDeleteMutation,
		TeacherCourseSectionEnrollmentDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		TeacherCourseSectionEnrollmentDeleteMutation,
		TeacherCourseSectionEnrollmentDeleteMutationVariables
	>(TeacherCourseSectionEnrollmentDeleteDocument, options);
}
export type TeacherCourseSectionEnrollmentDeleteMutationHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentDeleteMutation
>;
export type TeacherCourseSectionEnrollmentDeleteMutationResult =
	Apollo.MutationResult<TeacherCourseSectionEnrollmentDeleteMutation>;
export type TeacherCourseSectionEnrollmentDeleteMutationOptions = Apollo.BaseMutationOptions<
	TeacherCourseSectionEnrollmentDeleteMutation,
	TeacherCourseSectionEnrollmentDeleteMutationVariables
>;
export const TeacherCourseSectionEnrollmentDetailDocument = gql`
	query teacherCourseSectionEnrollmentDetail($id: ID!) {
		teacherCourseSectionEnrollment(id: $id) {
			...TeacherCourseSectionEnrollmentDetail
		}
	}
	${TeacherCourseSectionEnrollmentDetailFragmentDoc}
`;

/**
 * __useTeacherCourseSectionEnrollmentDetailQuery__
 *
 * To run a query within a React component, call `useTeacherCourseSectionEnrollmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherCourseSectionEnrollmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherCourseSectionEnrollmentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeacherCourseSectionEnrollmentDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		TeacherCourseSectionEnrollmentDetailQuery,
		TeacherCourseSectionEnrollmentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TeacherCourseSectionEnrollmentDetailQuery, TeacherCourseSectionEnrollmentDetailQueryVariables>(
		TeacherCourseSectionEnrollmentDetailDocument,
		options,
	);
}
export function useTeacherCourseSectionEnrollmentDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeacherCourseSectionEnrollmentDetailQuery,
		TeacherCourseSectionEnrollmentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		TeacherCourseSectionEnrollmentDetailQuery,
		TeacherCourseSectionEnrollmentDetailQueryVariables
	>(TeacherCourseSectionEnrollmentDetailDocument, options);
}
export function useTeacherCourseSectionEnrollmentDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TeacherCourseSectionEnrollmentDetailQuery,
		TeacherCourseSectionEnrollmentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		TeacherCourseSectionEnrollmentDetailQuery,
		TeacherCourseSectionEnrollmentDetailQueryVariables
	>(TeacherCourseSectionEnrollmentDetailDocument, options);
}
export type TeacherCourseSectionEnrollmentDetailQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentDetailQuery
>;
export type TeacherCourseSectionEnrollmentDetailLazyQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentDetailLazyQuery
>;
export type TeacherCourseSectionEnrollmentDetailSuspenseQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentDetailSuspenseQuery
>;
export type TeacherCourseSectionEnrollmentDetailQueryResult = Apollo.QueryResult<
	TeacherCourseSectionEnrollmentDetailQuery,
	TeacherCourseSectionEnrollmentDetailQueryVariables
>;
export const TeacherCourseSectionEnrollmentIndexDocument = gql`
	query teacherCourseSectionEnrollmentIndex(
		$filters: [TeacherCourseSectionEnrollmentFilterInput!]
		$pagination: Pagination
		$order: TeacherCourseSectionEnrollmentOrder
	) {
		teacherCourseSectionEnrollmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					lateStartDate
					earlyEndDate
				}
			}
		}
	}
`;

/**
 * __useTeacherCourseSectionEnrollmentIndexQuery__
 *
 * To run a query within a React component, call `useTeacherCourseSectionEnrollmentIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherCourseSectionEnrollmentIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherCourseSectionEnrollmentIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTeacherCourseSectionEnrollmentIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TeacherCourseSectionEnrollmentIndexQuery,
		TeacherCourseSectionEnrollmentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TeacherCourseSectionEnrollmentIndexQuery, TeacherCourseSectionEnrollmentIndexQueryVariables>(
		TeacherCourseSectionEnrollmentIndexDocument,
		options,
	);
}
export function useTeacherCourseSectionEnrollmentIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeacherCourseSectionEnrollmentIndexQuery,
		TeacherCourseSectionEnrollmentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		TeacherCourseSectionEnrollmentIndexQuery,
		TeacherCourseSectionEnrollmentIndexQueryVariables
	>(TeacherCourseSectionEnrollmentIndexDocument, options);
}
export function useTeacherCourseSectionEnrollmentIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TeacherCourseSectionEnrollmentIndexQuery,
		TeacherCourseSectionEnrollmentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		TeacherCourseSectionEnrollmentIndexQuery,
		TeacherCourseSectionEnrollmentIndexQueryVariables
	>(TeacherCourseSectionEnrollmentIndexDocument, options);
}
export type TeacherCourseSectionEnrollmentIndexQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentIndexQuery
>;
export type TeacherCourseSectionEnrollmentIndexLazyQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentIndexLazyQuery
>;
export type TeacherCourseSectionEnrollmentIndexSuspenseQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentIndexSuspenseQuery
>;
export type TeacherCourseSectionEnrollmentIndexQueryResult = Apollo.QueryResult<
	TeacherCourseSectionEnrollmentIndexQuery,
	TeacherCourseSectionEnrollmentIndexQueryVariables
>;
export const TeacherCourseSectionEnrollmentNameDocument = gql`
	query teacherCourseSectionEnrollmentName($id: ID!) {
		teacherCourseSectionEnrollment(id: $id) {
			id
			...TeacherCourseSectionEnrollmentName
		}
	}
	${TeacherCourseSectionEnrollmentNameFragmentDoc}
`;

/**
 * __useTeacherCourseSectionEnrollmentNameQuery__
 *
 * To run a query within a React component, call `useTeacherCourseSectionEnrollmentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherCourseSectionEnrollmentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherCourseSectionEnrollmentNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeacherCourseSectionEnrollmentNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		TeacherCourseSectionEnrollmentNameQuery,
		TeacherCourseSectionEnrollmentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TeacherCourseSectionEnrollmentNameQuery, TeacherCourseSectionEnrollmentNameQueryVariables>(
		TeacherCourseSectionEnrollmentNameDocument,
		options,
	);
}
export function useTeacherCourseSectionEnrollmentNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeacherCourseSectionEnrollmentNameQuery,
		TeacherCourseSectionEnrollmentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TeacherCourseSectionEnrollmentNameQuery, TeacherCourseSectionEnrollmentNameQueryVariables>(
		TeacherCourseSectionEnrollmentNameDocument,
		options,
	);
}
export function useTeacherCourseSectionEnrollmentNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TeacherCourseSectionEnrollmentNameQuery,
		TeacherCourseSectionEnrollmentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		TeacherCourseSectionEnrollmentNameQuery,
		TeacherCourseSectionEnrollmentNameQueryVariables
	>(TeacherCourseSectionEnrollmentNameDocument, options);
}
export type TeacherCourseSectionEnrollmentNameQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentNameQuery
>;
export type TeacherCourseSectionEnrollmentNameLazyQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentNameLazyQuery
>;
export type TeacherCourseSectionEnrollmentNameSuspenseQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentNameSuspenseQuery
>;
export type TeacherCourseSectionEnrollmentNameQueryResult = Apollo.QueryResult<
	TeacherCourseSectionEnrollmentNameQuery,
	TeacherCourseSectionEnrollmentNameQueryVariables
>;
export const TeacherCourseSectionEnrollmentNamesDocument = gql`
	query teacherCourseSectionEnrollmentNames(
		$filters: [TeacherCourseSectionEnrollmentFilterInput!]
		$pagination: Pagination
		$order: TeacherCourseSectionEnrollmentOrder
	) {
		teacherCourseSectionEnrollmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...TeacherCourseSectionEnrollmentName
				}
			}
		}
	}
	${TeacherCourseSectionEnrollmentNameFragmentDoc}
`;

/**
 * __useTeacherCourseSectionEnrollmentNamesQuery__
 *
 * To run a query within a React component, call `useTeacherCourseSectionEnrollmentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherCourseSectionEnrollmentNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherCourseSectionEnrollmentNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTeacherCourseSectionEnrollmentNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TeacherCourseSectionEnrollmentNamesQuery,
		TeacherCourseSectionEnrollmentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TeacherCourseSectionEnrollmentNamesQuery, TeacherCourseSectionEnrollmentNamesQueryVariables>(
		TeacherCourseSectionEnrollmentNamesDocument,
		options,
	);
}
export function useTeacherCourseSectionEnrollmentNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeacherCourseSectionEnrollmentNamesQuery,
		TeacherCourseSectionEnrollmentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		TeacherCourseSectionEnrollmentNamesQuery,
		TeacherCourseSectionEnrollmentNamesQueryVariables
	>(TeacherCourseSectionEnrollmentNamesDocument, options);
}
export function useTeacherCourseSectionEnrollmentNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TeacherCourseSectionEnrollmentNamesQuery,
		TeacherCourseSectionEnrollmentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		TeacherCourseSectionEnrollmentNamesQuery,
		TeacherCourseSectionEnrollmentNamesQueryVariables
	>(TeacherCourseSectionEnrollmentNamesDocument, options);
}
export type TeacherCourseSectionEnrollmentNamesQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentNamesQuery
>;
export type TeacherCourseSectionEnrollmentNamesLazyQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentNamesLazyQuery
>;
export type TeacherCourseSectionEnrollmentNamesSuspenseQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentNamesSuspenseQuery
>;
export type TeacherCourseSectionEnrollmentNamesQueryResult = Apollo.QueryResult<
	TeacherCourseSectionEnrollmentNamesQuery,
	TeacherCourseSectionEnrollmentNamesQueryVariables
>;
export const TeacherCourseSectionEnrollmentPaginationDocument = gql`
	query teacherCourseSectionEnrollmentPagination(
		$filters: [TeacherCourseSectionEnrollmentFilterInput!]
		$order: TeacherCourseSectionEnrollmentOrder
	) {
		teacherCourseSectionEnrollmentConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useTeacherCourseSectionEnrollmentPaginationQuery__
 *
 * To run a query within a React component, call `useTeacherCourseSectionEnrollmentPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherCourseSectionEnrollmentPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherCourseSectionEnrollmentPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTeacherCourseSectionEnrollmentPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TeacherCourseSectionEnrollmentPaginationQuery,
		TeacherCourseSectionEnrollmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		TeacherCourseSectionEnrollmentPaginationQuery,
		TeacherCourseSectionEnrollmentPaginationQueryVariables
	>(TeacherCourseSectionEnrollmentPaginationDocument, options);
}
export function useTeacherCourseSectionEnrollmentPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeacherCourseSectionEnrollmentPaginationQuery,
		TeacherCourseSectionEnrollmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		TeacherCourseSectionEnrollmentPaginationQuery,
		TeacherCourseSectionEnrollmentPaginationQueryVariables
	>(TeacherCourseSectionEnrollmentPaginationDocument, options);
}
export function useTeacherCourseSectionEnrollmentPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TeacherCourseSectionEnrollmentPaginationQuery,
		TeacherCourseSectionEnrollmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		TeacherCourseSectionEnrollmentPaginationQuery,
		TeacherCourseSectionEnrollmentPaginationQueryVariables
	>(TeacherCourseSectionEnrollmentPaginationDocument, options);
}
export type TeacherCourseSectionEnrollmentPaginationQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentPaginationQuery
>;
export type TeacherCourseSectionEnrollmentPaginationLazyQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentPaginationLazyQuery
>;
export type TeacherCourseSectionEnrollmentPaginationSuspenseQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentPaginationSuspenseQuery
>;
export type TeacherCourseSectionEnrollmentPaginationQueryResult = Apollo.QueryResult<
	TeacherCourseSectionEnrollmentPaginationQuery,
	TeacherCourseSectionEnrollmentPaginationQueryVariables
>;
export const TeacherCourseSectionEnrollmentSelectDocument = gql`
	query teacherCourseSectionEnrollmentSelect(
		$filters: [TeacherCourseSectionEnrollmentFilterInput!]
		$order: TeacherCourseSectionEnrollmentOrder
	) {
		teacherCourseSectionEnrollmentConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...TeacherCourseSectionEnrollmentName
				}
			}
		}
	}
	${TeacherCourseSectionEnrollmentNameFragmentDoc}
`;

/**
 * __useTeacherCourseSectionEnrollmentSelectQuery__
 *
 * To run a query within a React component, call `useTeacherCourseSectionEnrollmentSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherCourseSectionEnrollmentSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherCourseSectionEnrollmentSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTeacherCourseSectionEnrollmentSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TeacherCourseSectionEnrollmentSelectQuery,
		TeacherCourseSectionEnrollmentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TeacherCourseSectionEnrollmentSelectQuery, TeacherCourseSectionEnrollmentSelectQueryVariables>(
		TeacherCourseSectionEnrollmentSelectDocument,
		options,
	);
}
export function useTeacherCourseSectionEnrollmentSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeacherCourseSectionEnrollmentSelectQuery,
		TeacherCourseSectionEnrollmentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		TeacherCourseSectionEnrollmentSelectQuery,
		TeacherCourseSectionEnrollmentSelectQueryVariables
	>(TeacherCourseSectionEnrollmentSelectDocument, options);
}
export function useTeacherCourseSectionEnrollmentSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TeacherCourseSectionEnrollmentSelectQuery,
		TeacherCourseSectionEnrollmentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		TeacherCourseSectionEnrollmentSelectQuery,
		TeacherCourseSectionEnrollmentSelectQueryVariables
	>(TeacherCourseSectionEnrollmentSelectDocument, options);
}
export type TeacherCourseSectionEnrollmentSelectQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentSelectQuery
>;
export type TeacherCourseSectionEnrollmentSelectLazyQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentSelectLazyQuery
>;
export type TeacherCourseSectionEnrollmentSelectSuspenseQueryHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentSelectSuspenseQuery
>;
export type TeacherCourseSectionEnrollmentSelectQueryResult = Apollo.QueryResult<
	TeacherCourseSectionEnrollmentSelectQuery,
	TeacherCourseSectionEnrollmentSelectQueryVariables
>;
export const TeacherCourseSectionEnrollmentUpdateDocument = gql`
	mutation teacherCourseSectionEnrollmentUpdate($id: ID!, $input: TeacherCourseSectionEnrollmentUpdateInput!) {
		updateTeacherCourseSectionEnrollment(id: $id, input: $input) {
			...TeacherCourseSectionEnrollmentDetail
		}
	}
	${TeacherCourseSectionEnrollmentDetailFragmentDoc}
`;
export type TeacherCourseSectionEnrollmentUpdateMutationFn = Apollo.MutationFunction<
	TeacherCourseSectionEnrollmentUpdateMutation,
	TeacherCourseSectionEnrollmentUpdateMutationVariables
>;

/**
 * __useTeacherCourseSectionEnrollmentUpdateMutation__
 *
 * To run a mutation, you first call `useTeacherCourseSectionEnrollmentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeacherCourseSectionEnrollmentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teacherCourseSectionEnrollmentUpdateMutation, { data, loading, error }] = useTeacherCourseSectionEnrollmentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTeacherCourseSectionEnrollmentUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		TeacherCourseSectionEnrollmentUpdateMutation,
		TeacherCourseSectionEnrollmentUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		TeacherCourseSectionEnrollmentUpdateMutation,
		TeacherCourseSectionEnrollmentUpdateMutationVariables
	>(TeacherCourseSectionEnrollmentUpdateDocument, options);
}
export type TeacherCourseSectionEnrollmentUpdateMutationHookResult = ReturnType<
	typeof useTeacherCourseSectionEnrollmentUpdateMutation
>;
export type TeacherCourseSectionEnrollmentUpdateMutationResult =
	Apollo.MutationResult<TeacherCourseSectionEnrollmentUpdateMutation>;
export type TeacherCourseSectionEnrollmentUpdateMutationOptions = Apollo.BaseMutationOptions<
	TeacherCourseSectionEnrollmentUpdateMutation,
	TeacherCourseSectionEnrollmentUpdateMutationVariables
>;
export const TeacherHomeRoomSectionEnrollmentCountDocument = gql`
	query teacherHomeRoomSectionEnrollmentCount(
		$filters: [TeacherHomeRoomSectionEnrollmentFilterInput!]
		$pagination: Pagination
		$order: TeacherHomeRoomSectionEnrollmentOrder
	) {
		teacherHomeRoomSectionEnrollmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useTeacherHomeRoomSectionEnrollmentCountQuery__
 *
 * To run a query within a React component, call `useTeacherHomeRoomSectionEnrollmentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherHomeRoomSectionEnrollmentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherHomeRoomSectionEnrollmentCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTeacherHomeRoomSectionEnrollmentCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TeacherHomeRoomSectionEnrollmentCountQuery,
		TeacherHomeRoomSectionEnrollmentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		TeacherHomeRoomSectionEnrollmentCountQuery,
		TeacherHomeRoomSectionEnrollmentCountQueryVariables
	>(TeacherHomeRoomSectionEnrollmentCountDocument, options);
}
export function useTeacherHomeRoomSectionEnrollmentCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeacherHomeRoomSectionEnrollmentCountQuery,
		TeacherHomeRoomSectionEnrollmentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		TeacherHomeRoomSectionEnrollmentCountQuery,
		TeacherHomeRoomSectionEnrollmentCountQueryVariables
	>(TeacherHomeRoomSectionEnrollmentCountDocument, options);
}
export function useTeacherHomeRoomSectionEnrollmentCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TeacherHomeRoomSectionEnrollmentCountQuery,
		TeacherHomeRoomSectionEnrollmentCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		TeacherHomeRoomSectionEnrollmentCountQuery,
		TeacherHomeRoomSectionEnrollmentCountQueryVariables
	>(TeacherHomeRoomSectionEnrollmentCountDocument, options);
}
export type TeacherHomeRoomSectionEnrollmentCountQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentCountQuery
>;
export type TeacherHomeRoomSectionEnrollmentCountLazyQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentCountLazyQuery
>;
export type TeacherHomeRoomSectionEnrollmentCountSuspenseQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentCountSuspenseQuery
>;
export type TeacherHomeRoomSectionEnrollmentCountQueryResult = Apollo.QueryResult<
	TeacherHomeRoomSectionEnrollmentCountQuery,
	TeacherHomeRoomSectionEnrollmentCountQueryVariables
>;
export const TeacherHomeRoomSectionEnrollmentCreateDocument = gql`
	mutation teacherHomeRoomSectionEnrollmentCreate($input: TeacherHomeRoomSectionEnrollmentCreateInput!) {
		createTeacherHomeRoomSectionEnrollment(input: $input) {
			...TeacherHomeRoomSectionEnrollmentDetail
		}
	}
	${TeacherHomeRoomSectionEnrollmentDetailFragmentDoc}
`;
export type TeacherHomeRoomSectionEnrollmentCreateMutationFn = Apollo.MutationFunction<
	TeacherHomeRoomSectionEnrollmentCreateMutation,
	TeacherHomeRoomSectionEnrollmentCreateMutationVariables
>;

/**
 * __useTeacherHomeRoomSectionEnrollmentCreateMutation__
 *
 * To run a mutation, you first call `useTeacherHomeRoomSectionEnrollmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeacherHomeRoomSectionEnrollmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teacherHomeRoomSectionEnrollmentCreateMutation, { data, loading, error }] = useTeacherHomeRoomSectionEnrollmentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTeacherHomeRoomSectionEnrollmentCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		TeacherHomeRoomSectionEnrollmentCreateMutation,
		TeacherHomeRoomSectionEnrollmentCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		TeacherHomeRoomSectionEnrollmentCreateMutation,
		TeacherHomeRoomSectionEnrollmentCreateMutationVariables
	>(TeacherHomeRoomSectionEnrollmentCreateDocument, options);
}
export type TeacherHomeRoomSectionEnrollmentCreateMutationHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentCreateMutation
>;
export type TeacherHomeRoomSectionEnrollmentCreateMutationResult =
	Apollo.MutationResult<TeacherHomeRoomSectionEnrollmentCreateMutation>;
export type TeacherHomeRoomSectionEnrollmentCreateMutationOptions = Apollo.BaseMutationOptions<
	TeacherHomeRoomSectionEnrollmentCreateMutation,
	TeacherHomeRoomSectionEnrollmentCreateMutationVariables
>;
export const TeacherHomeRoomSectionEnrollmentDeleteDocument = gql`
	mutation teacherHomeRoomSectionEnrollmentDelete($id: ID!) {
		deleteTeacherHomeRoomSectionEnrollment(id: $id)
	}
`;
export type TeacherHomeRoomSectionEnrollmentDeleteMutationFn = Apollo.MutationFunction<
	TeacherHomeRoomSectionEnrollmentDeleteMutation,
	TeacherHomeRoomSectionEnrollmentDeleteMutationVariables
>;

/**
 * __useTeacherHomeRoomSectionEnrollmentDeleteMutation__
 *
 * To run a mutation, you first call `useTeacherHomeRoomSectionEnrollmentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeacherHomeRoomSectionEnrollmentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teacherHomeRoomSectionEnrollmentDeleteMutation, { data, loading, error }] = useTeacherHomeRoomSectionEnrollmentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeacherHomeRoomSectionEnrollmentDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		TeacherHomeRoomSectionEnrollmentDeleteMutation,
		TeacherHomeRoomSectionEnrollmentDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		TeacherHomeRoomSectionEnrollmentDeleteMutation,
		TeacherHomeRoomSectionEnrollmentDeleteMutationVariables
	>(TeacherHomeRoomSectionEnrollmentDeleteDocument, options);
}
export type TeacherHomeRoomSectionEnrollmentDeleteMutationHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentDeleteMutation
>;
export type TeacherHomeRoomSectionEnrollmentDeleteMutationResult =
	Apollo.MutationResult<TeacherHomeRoomSectionEnrollmentDeleteMutation>;
export type TeacherHomeRoomSectionEnrollmentDeleteMutationOptions = Apollo.BaseMutationOptions<
	TeacherHomeRoomSectionEnrollmentDeleteMutation,
	TeacherHomeRoomSectionEnrollmentDeleteMutationVariables
>;
export const TeacherHomeRoomSectionEnrollmentDetailDocument = gql`
	query teacherHomeRoomSectionEnrollmentDetail($id: ID!) {
		teacherHomeRoomSectionEnrollment(id: $id) {
			...TeacherHomeRoomSectionEnrollmentDetail
		}
	}
	${TeacherHomeRoomSectionEnrollmentDetailFragmentDoc}
`;

/**
 * __useTeacherHomeRoomSectionEnrollmentDetailQuery__
 *
 * To run a query within a React component, call `useTeacherHomeRoomSectionEnrollmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherHomeRoomSectionEnrollmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherHomeRoomSectionEnrollmentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeacherHomeRoomSectionEnrollmentDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		TeacherHomeRoomSectionEnrollmentDetailQuery,
		TeacherHomeRoomSectionEnrollmentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		TeacherHomeRoomSectionEnrollmentDetailQuery,
		TeacherHomeRoomSectionEnrollmentDetailQueryVariables
	>(TeacherHomeRoomSectionEnrollmentDetailDocument, options);
}
export function useTeacherHomeRoomSectionEnrollmentDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeacherHomeRoomSectionEnrollmentDetailQuery,
		TeacherHomeRoomSectionEnrollmentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		TeacherHomeRoomSectionEnrollmentDetailQuery,
		TeacherHomeRoomSectionEnrollmentDetailQueryVariables
	>(TeacherHomeRoomSectionEnrollmentDetailDocument, options);
}
export function useTeacherHomeRoomSectionEnrollmentDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TeacherHomeRoomSectionEnrollmentDetailQuery,
		TeacherHomeRoomSectionEnrollmentDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		TeacherHomeRoomSectionEnrollmentDetailQuery,
		TeacherHomeRoomSectionEnrollmentDetailQueryVariables
	>(TeacherHomeRoomSectionEnrollmentDetailDocument, options);
}
export type TeacherHomeRoomSectionEnrollmentDetailQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentDetailQuery
>;
export type TeacherHomeRoomSectionEnrollmentDetailLazyQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentDetailLazyQuery
>;
export type TeacherHomeRoomSectionEnrollmentDetailSuspenseQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentDetailSuspenseQuery
>;
export type TeacherHomeRoomSectionEnrollmentDetailQueryResult = Apollo.QueryResult<
	TeacherHomeRoomSectionEnrollmentDetailQuery,
	TeacherHomeRoomSectionEnrollmentDetailQueryVariables
>;
export const TeacherHomeRoomSectionEnrollmentIndexDocument = gql`
	query teacherHomeRoomSectionEnrollmentIndex(
		$filters: [TeacherHomeRoomSectionEnrollmentFilterInput!]
		$pagination: Pagination
		$order: TeacherHomeRoomSectionEnrollmentOrder
	) {
		teacherHomeRoomSectionEnrollmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					lateStartDate
					earlyEndDate
				}
			}
		}
	}
`;

/**
 * __useTeacherHomeRoomSectionEnrollmentIndexQuery__
 *
 * To run a query within a React component, call `useTeacherHomeRoomSectionEnrollmentIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherHomeRoomSectionEnrollmentIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherHomeRoomSectionEnrollmentIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTeacherHomeRoomSectionEnrollmentIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TeacherHomeRoomSectionEnrollmentIndexQuery,
		TeacherHomeRoomSectionEnrollmentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		TeacherHomeRoomSectionEnrollmentIndexQuery,
		TeacherHomeRoomSectionEnrollmentIndexQueryVariables
	>(TeacherHomeRoomSectionEnrollmentIndexDocument, options);
}
export function useTeacherHomeRoomSectionEnrollmentIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeacherHomeRoomSectionEnrollmentIndexQuery,
		TeacherHomeRoomSectionEnrollmentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		TeacherHomeRoomSectionEnrollmentIndexQuery,
		TeacherHomeRoomSectionEnrollmentIndexQueryVariables
	>(TeacherHomeRoomSectionEnrollmentIndexDocument, options);
}
export function useTeacherHomeRoomSectionEnrollmentIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TeacherHomeRoomSectionEnrollmentIndexQuery,
		TeacherHomeRoomSectionEnrollmentIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		TeacherHomeRoomSectionEnrollmentIndexQuery,
		TeacherHomeRoomSectionEnrollmentIndexQueryVariables
	>(TeacherHomeRoomSectionEnrollmentIndexDocument, options);
}
export type TeacherHomeRoomSectionEnrollmentIndexQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentIndexQuery
>;
export type TeacherHomeRoomSectionEnrollmentIndexLazyQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentIndexLazyQuery
>;
export type TeacherHomeRoomSectionEnrollmentIndexSuspenseQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentIndexSuspenseQuery
>;
export type TeacherHomeRoomSectionEnrollmentIndexQueryResult = Apollo.QueryResult<
	TeacherHomeRoomSectionEnrollmentIndexQuery,
	TeacherHomeRoomSectionEnrollmentIndexQueryVariables
>;
export const TeacherHomeRoomSectionEnrollmentNameDocument = gql`
	query teacherHomeRoomSectionEnrollmentName($id: ID!) {
		teacherHomeRoomSectionEnrollment(id: $id) {
			id
			...TeacherHomeRoomSectionEnrollmentName
		}
	}
	${TeacherHomeRoomSectionEnrollmentNameFragmentDoc}
`;

/**
 * __useTeacherHomeRoomSectionEnrollmentNameQuery__
 *
 * To run a query within a React component, call `useTeacherHomeRoomSectionEnrollmentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherHomeRoomSectionEnrollmentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherHomeRoomSectionEnrollmentNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeacherHomeRoomSectionEnrollmentNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		TeacherHomeRoomSectionEnrollmentNameQuery,
		TeacherHomeRoomSectionEnrollmentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TeacherHomeRoomSectionEnrollmentNameQuery, TeacherHomeRoomSectionEnrollmentNameQueryVariables>(
		TeacherHomeRoomSectionEnrollmentNameDocument,
		options,
	);
}
export function useTeacherHomeRoomSectionEnrollmentNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeacherHomeRoomSectionEnrollmentNameQuery,
		TeacherHomeRoomSectionEnrollmentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		TeacherHomeRoomSectionEnrollmentNameQuery,
		TeacherHomeRoomSectionEnrollmentNameQueryVariables
	>(TeacherHomeRoomSectionEnrollmentNameDocument, options);
}
export function useTeacherHomeRoomSectionEnrollmentNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TeacherHomeRoomSectionEnrollmentNameQuery,
		TeacherHomeRoomSectionEnrollmentNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		TeacherHomeRoomSectionEnrollmentNameQuery,
		TeacherHomeRoomSectionEnrollmentNameQueryVariables
	>(TeacherHomeRoomSectionEnrollmentNameDocument, options);
}
export type TeacherHomeRoomSectionEnrollmentNameQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentNameQuery
>;
export type TeacherHomeRoomSectionEnrollmentNameLazyQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentNameLazyQuery
>;
export type TeacherHomeRoomSectionEnrollmentNameSuspenseQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentNameSuspenseQuery
>;
export type TeacherHomeRoomSectionEnrollmentNameQueryResult = Apollo.QueryResult<
	TeacherHomeRoomSectionEnrollmentNameQuery,
	TeacherHomeRoomSectionEnrollmentNameQueryVariables
>;
export const TeacherHomeRoomSectionEnrollmentNamesDocument = gql`
	query teacherHomeRoomSectionEnrollmentNames(
		$filters: [TeacherHomeRoomSectionEnrollmentFilterInput!]
		$pagination: Pagination
		$order: TeacherHomeRoomSectionEnrollmentOrder
	) {
		teacherHomeRoomSectionEnrollmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...TeacherHomeRoomSectionEnrollmentName
				}
			}
		}
	}
	${TeacherHomeRoomSectionEnrollmentNameFragmentDoc}
`;

/**
 * __useTeacherHomeRoomSectionEnrollmentNamesQuery__
 *
 * To run a query within a React component, call `useTeacherHomeRoomSectionEnrollmentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherHomeRoomSectionEnrollmentNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherHomeRoomSectionEnrollmentNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTeacherHomeRoomSectionEnrollmentNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TeacherHomeRoomSectionEnrollmentNamesQuery,
		TeacherHomeRoomSectionEnrollmentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		TeacherHomeRoomSectionEnrollmentNamesQuery,
		TeacherHomeRoomSectionEnrollmentNamesQueryVariables
	>(TeacherHomeRoomSectionEnrollmentNamesDocument, options);
}
export function useTeacherHomeRoomSectionEnrollmentNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeacherHomeRoomSectionEnrollmentNamesQuery,
		TeacherHomeRoomSectionEnrollmentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		TeacherHomeRoomSectionEnrollmentNamesQuery,
		TeacherHomeRoomSectionEnrollmentNamesQueryVariables
	>(TeacherHomeRoomSectionEnrollmentNamesDocument, options);
}
export function useTeacherHomeRoomSectionEnrollmentNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TeacherHomeRoomSectionEnrollmentNamesQuery,
		TeacherHomeRoomSectionEnrollmentNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		TeacherHomeRoomSectionEnrollmentNamesQuery,
		TeacherHomeRoomSectionEnrollmentNamesQueryVariables
	>(TeacherHomeRoomSectionEnrollmentNamesDocument, options);
}
export type TeacherHomeRoomSectionEnrollmentNamesQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentNamesQuery
>;
export type TeacherHomeRoomSectionEnrollmentNamesLazyQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentNamesLazyQuery
>;
export type TeacherHomeRoomSectionEnrollmentNamesSuspenseQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentNamesSuspenseQuery
>;
export type TeacherHomeRoomSectionEnrollmentNamesQueryResult = Apollo.QueryResult<
	TeacherHomeRoomSectionEnrollmentNamesQuery,
	TeacherHomeRoomSectionEnrollmentNamesQueryVariables
>;
export const TeacherHomeRoomSectionEnrollmentPaginationDocument = gql`
	query teacherHomeRoomSectionEnrollmentPagination(
		$filters: [TeacherHomeRoomSectionEnrollmentFilterInput!]
		$order: TeacherHomeRoomSectionEnrollmentOrder
	) {
		teacherHomeRoomSectionEnrollmentConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useTeacherHomeRoomSectionEnrollmentPaginationQuery__
 *
 * To run a query within a React component, call `useTeacherHomeRoomSectionEnrollmentPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherHomeRoomSectionEnrollmentPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherHomeRoomSectionEnrollmentPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTeacherHomeRoomSectionEnrollmentPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TeacherHomeRoomSectionEnrollmentPaginationQuery,
		TeacherHomeRoomSectionEnrollmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		TeacherHomeRoomSectionEnrollmentPaginationQuery,
		TeacherHomeRoomSectionEnrollmentPaginationQueryVariables
	>(TeacherHomeRoomSectionEnrollmentPaginationDocument, options);
}
export function useTeacherHomeRoomSectionEnrollmentPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeacherHomeRoomSectionEnrollmentPaginationQuery,
		TeacherHomeRoomSectionEnrollmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		TeacherHomeRoomSectionEnrollmentPaginationQuery,
		TeacherHomeRoomSectionEnrollmentPaginationQueryVariables
	>(TeacherHomeRoomSectionEnrollmentPaginationDocument, options);
}
export function useTeacherHomeRoomSectionEnrollmentPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TeacherHomeRoomSectionEnrollmentPaginationQuery,
		TeacherHomeRoomSectionEnrollmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		TeacherHomeRoomSectionEnrollmentPaginationQuery,
		TeacherHomeRoomSectionEnrollmentPaginationQueryVariables
	>(TeacherHomeRoomSectionEnrollmentPaginationDocument, options);
}
export type TeacherHomeRoomSectionEnrollmentPaginationQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentPaginationQuery
>;
export type TeacherHomeRoomSectionEnrollmentPaginationLazyQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentPaginationLazyQuery
>;
export type TeacherHomeRoomSectionEnrollmentPaginationSuspenseQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentPaginationSuspenseQuery
>;
export type TeacherHomeRoomSectionEnrollmentPaginationQueryResult = Apollo.QueryResult<
	TeacherHomeRoomSectionEnrollmentPaginationQuery,
	TeacherHomeRoomSectionEnrollmentPaginationQueryVariables
>;
export const TeacherHomeRoomSectionEnrollmentSelectDocument = gql`
	query teacherHomeRoomSectionEnrollmentSelect(
		$filters: [TeacherHomeRoomSectionEnrollmentFilterInput!]
		$order: TeacherHomeRoomSectionEnrollmentOrder
	) {
		teacherHomeRoomSectionEnrollmentConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...TeacherHomeRoomSectionEnrollmentName
				}
			}
		}
	}
	${TeacherHomeRoomSectionEnrollmentNameFragmentDoc}
`;

/**
 * __useTeacherHomeRoomSectionEnrollmentSelectQuery__
 *
 * To run a query within a React component, call `useTeacherHomeRoomSectionEnrollmentSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherHomeRoomSectionEnrollmentSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherHomeRoomSectionEnrollmentSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTeacherHomeRoomSectionEnrollmentSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TeacherHomeRoomSectionEnrollmentSelectQuery,
		TeacherHomeRoomSectionEnrollmentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		TeacherHomeRoomSectionEnrollmentSelectQuery,
		TeacherHomeRoomSectionEnrollmentSelectQueryVariables
	>(TeacherHomeRoomSectionEnrollmentSelectDocument, options);
}
export function useTeacherHomeRoomSectionEnrollmentSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeacherHomeRoomSectionEnrollmentSelectQuery,
		TeacherHomeRoomSectionEnrollmentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		TeacherHomeRoomSectionEnrollmentSelectQuery,
		TeacherHomeRoomSectionEnrollmentSelectQueryVariables
	>(TeacherHomeRoomSectionEnrollmentSelectDocument, options);
}
export function useTeacherHomeRoomSectionEnrollmentSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TeacherHomeRoomSectionEnrollmentSelectQuery,
		TeacherHomeRoomSectionEnrollmentSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		TeacherHomeRoomSectionEnrollmentSelectQuery,
		TeacherHomeRoomSectionEnrollmentSelectQueryVariables
	>(TeacherHomeRoomSectionEnrollmentSelectDocument, options);
}
export type TeacherHomeRoomSectionEnrollmentSelectQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentSelectQuery
>;
export type TeacherHomeRoomSectionEnrollmentSelectLazyQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentSelectLazyQuery
>;
export type TeacherHomeRoomSectionEnrollmentSelectSuspenseQueryHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentSelectSuspenseQuery
>;
export type TeacherHomeRoomSectionEnrollmentSelectQueryResult = Apollo.QueryResult<
	TeacherHomeRoomSectionEnrollmentSelectQuery,
	TeacherHomeRoomSectionEnrollmentSelectQueryVariables
>;
export const TeacherHomeRoomSectionEnrollmentUpdateDocument = gql`
	mutation teacherHomeRoomSectionEnrollmentUpdate($id: ID!, $input: TeacherHomeRoomSectionEnrollmentUpdateInput!) {
		updateTeacherHomeRoomSectionEnrollment(id: $id, input: $input) {
			...TeacherHomeRoomSectionEnrollmentDetail
		}
	}
	${TeacherHomeRoomSectionEnrollmentDetailFragmentDoc}
`;
export type TeacherHomeRoomSectionEnrollmentUpdateMutationFn = Apollo.MutationFunction<
	TeacherHomeRoomSectionEnrollmentUpdateMutation,
	TeacherHomeRoomSectionEnrollmentUpdateMutationVariables
>;

/**
 * __useTeacherHomeRoomSectionEnrollmentUpdateMutation__
 *
 * To run a mutation, you first call `useTeacherHomeRoomSectionEnrollmentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeacherHomeRoomSectionEnrollmentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teacherHomeRoomSectionEnrollmentUpdateMutation, { data, loading, error }] = useTeacherHomeRoomSectionEnrollmentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTeacherHomeRoomSectionEnrollmentUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		TeacherHomeRoomSectionEnrollmentUpdateMutation,
		TeacherHomeRoomSectionEnrollmentUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		TeacherHomeRoomSectionEnrollmentUpdateMutation,
		TeacherHomeRoomSectionEnrollmentUpdateMutationVariables
	>(TeacherHomeRoomSectionEnrollmentUpdateDocument, options);
}
export type TeacherHomeRoomSectionEnrollmentUpdateMutationHookResult = ReturnType<
	typeof useTeacherHomeRoomSectionEnrollmentUpdateMutation
>;
export type TeacherHomeRoomSectionEnrollmentUpdateMutationResult =
	Apollo.MutationResult<TeacherHomeRoomSectionEnrollmentUpdateMutation>;
export type TeacherHomeRoomSectionEnrollmentUpdateMutationOptions = Apollo.BaseMutationOptions<
	TeacherHomeRoomSectionEnrollmentUpdateMutation,
	TeacherHomeRoomSectionEnrollmentUpdateMutationVariables
>;
export const TrustedDeviceCountDocument = gql`
	query trustedDeviceCount($filters: [TrustedDeviceFilterInput!], $pagination: Pagination, $order: TrustedDeviceOrder) {
		trustedDeviceConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useTrustedDeviceCountQuery__
 *
 * To run a query within a React component, call `useTrustedDeviceCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrustedDeviceCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrustedDeviceCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTrustedDeviceCountQuery(
	baseOptions?: Apollo.QueryHookOptions<TrustedDeviceCountQuery, TrustedDeviceCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TrustedDeviceCountQuery, TrustedDeviceCountQueryVariables>(
		TrustedDeviceCountDocument,
		options,
	);
}
export function useTrustedDeviceCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TrustedDeviceCountQuery, TrustedDeviceCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TrustedDeviceCountQuery, TrustedDeviceCountQueryVariables>(
		TrustedDeviceCountDocument,
		options,
	);
}
export function useTrustedDeviceCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TrustedDeviceCountQuery, TrustedDeviceCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TrustedDeviceCountQuery, TrustedDeviceCountQueryVariables>(
		TrustedDeviceCountDocument,
		options,
	);
}
export type TrustedDeviceCountQueryHookResult = ReturnType<typeof useTrustedDeviceCountQuery>;
export type TrustedDeviceCountLazyQueryHookResult = ReturnType<typeof useTrustedDeviceCountLazyQuery>;
export type TrustedDeviceCountSuspenseQueryHookResult = ReturnType<typeof useTrustedDeviceCountSuspenseQuery>;
export type TrustedDeviceCountQueryResult = Apollo.QueryResult<
	TrustedDeviceCountQuery,
	TrustedDeviceCountQueryVariables
>;
export const TrustedDeviceDetailDocument = gql`
	query trustedDeviceDetail($id: ID!) {
		trustedDevice(id: $id) {
			...TrustedDeviceDetail
		}
	}
	${TrustedDeviceDetailFragmentDoc}
`;

/**
 * __useTrustedDeviceDetailQuery__
 *
 * To run a query within a React component, call `useTrustedDeviceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrustedDeviceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrustedDeviceDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrustedDeviceDetailQuery(
	baseOptions: Apollo.QueryHookOptions<TrustedDeviceDetailQuery, TrustedDeviceDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TrustedDeviceDetailQuery, TrustedDeviceDetailQueryVariables>(
		TrustedDeviceDetailDocument,
		options,
	);
}
export function useTrustedDeviceDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TrustedDeviceDetailQuery, TrustedDeviceDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TrustedDeviceDetailQuery, TrustedDeviceDetailQueryVariables>(
		TrustedDeviceDetailDocument,
		options,
	);
}
export function useTrustedDeviceDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TrustedDeviceDetailQuery, TrustedDeviceDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TrustedDeviceDetailQuery, TrustedDeviceDetailQueryVariables>(
		TrustedDeviceDetailDocument,
		options,
	);
}
export type TrustedDeviceDetailQueryHookResult = ReturnType<typeof useTrustedDeviceDetailQuery>;
export type TrustedDeviceDetailLazyQueryHookResult = ReturnType<typeof useTrustedDeviceDetailLazyQuery>;
export type TrustedDeviceDetailSuspenseQueryHookResult = ReturnType<typeof useTrustedDeviceDetailSuspenseQuery>;
export type TrustedDeviceDetailQueryResult = Apollo.QueryResult<
	TrustedDeviceDetailQuery,
	TrustedDeviceDetailQueryVariables
>;
export const TrustedDeviceIndexDocument = gql`
	query trustedDeviceIndex($filters: [TrustedDeviceFilterInput!], $pagination: Pagination, $order: TrustedDeviceOrder) {
		trustedDeviceConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					name
					isCurrent
				}
			}
		}
	}
`;

/**
 * __useTrustedDeviceIndexQuery__
 *
 * To run a query within a React component, call `useTrustedDeviceIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrustedDeviceIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrustedDeviceIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTrustedDeviceIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<TrustedDeviceIndexQuery, TrustedDeviceIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TrustedDeviceIndexQuery, TrustedDeviceIndexQueryVariables>(
		TrustedDeviceIndexDocument,
		options,
	);
}
export function useTrustedDeviceIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TrustedDeviceIndexQuery, TrustedDeviceIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TrustedDeviceIndexQuery, TrustedDeviceIndexQueryVariables>(
		TrustedDeviceIndexDocument,
		options,
	);
}
export function useTrustedDeviceIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TrustedDeviceIndexQuery, TrustedDeviceIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TrustedDeviceIndexQuery, TrustedDeviceIndexQueryVariables>(
		TrustedDeviceIndexDocument,
		options,
	);
}
export type TrustedDeviceIndexQueryHookResult = ReturnType<typeof useTrustedDeviceIndexQuery>;
export type TrustedDeviceIndexLazyQueryHookResult = ReturnType<typeof useTrustedDeviceIndexLazyQuery>;
export type TrustedDeviceIndexSuspenseQueryHookResult = ReturnType<typeof useTrustedDeviceIndexSuspenseQuery>;
export type TrustedDeviceIndexQueryResult = Apollo.QueryResult<
	TrustedDeviceIndexQuery,
	TrustedDeviceIndexQueryVariables
>;
export const TrustedDeviceNameDocument = gql`
	query trustedDeviceName($id: ID!) {
		trustedDevice(id: $id) {
			id
			...TrustedDeviceName
		}
	}
	${TrustedDeviceNameFragmentDoc}
`;

/**
 * __useTrustedDeviceNameQuery__
 *
 * To run a query within a React component, call `useTrustedDeviceNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrustedDeviceNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrustedDeviceNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrustedDeviceNameQuery(
	baseOptions: Apollo.QueryHookOptions<TrustedDeviceNameQuery, TrustedDeviceNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TrustedDeviceNameQuery, TrustedDeviceNameQueryVariables>(TrustedDeviceNameDocument, options);
}
export function useTrustedDeviceNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TrustedDeviceNameQuery, TrustedDeviceNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TrustedDeviceNameQuery, TrustedDeviceNameQueryVariables>(
		TrustedDeviceNameDocument,
		options,
	);
}
export function useTrustedDeviceNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TrustedDeviceNameQuery, TrustedDeviceNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TrustedDeviceNameQuery, TrustedDeviceNameQueryVariables>(
		TrustedDeviceNameDocument,
		options,
	);
}
export type TrustedDeviceNameQueryHookResult = ReturnType<typeof useTrustedDeviceNameQuery>;
export type TrustedDeviceNameLazyQueryHookResult = ReturnType<typeof useTrustedDeviceNameLazyQuery>;
export type TrustedDeviceNameSuspenseQueryHookResult = ReturnType<typeof useTrustedDeviceNameSuspenseQuery>;
export type TrustedDeviceNameQueryResult = Apollo.QueryResult<TrustedDeviceNameQuery, TrustedDeviceNameQueryVariables>;
export const TrustedDeviceNamesDocument = gql`
	query trustedDeviceNames($filters: [TrustedDeviceFilterInput!], $pagination: Pagination, $order: TrustedDeviceOrder) {
		trustedDeviceConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...TrustedDeviceName
				}
			}
		}
	}
	${TrustedDeviceNameFragmentDoc}
`;

/**
 * __useTrustedDeviceNamesQuery__
 *
 * To run a query within a React component, call `useTrustedDeviceNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrustedDeviceNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrustedDeviceNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTrustedDeviceNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<TrustedDeviceNamesQuery, TrustedDeviceNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TrustedDeviceNamesQuery, TrustedDeviceNamesQueryVariables>(
		TrustedDeviceNamesDocument,
		options,
	);
}
export function useTrustedDeviceNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TrustedDeviceNamesQuery, TrustedDeviceNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TrustedDeviceNamesQuery, TrustedDeviceNamesQueryVariables>(
		TrustedDeviceNamesDocument,
		options,
	);
}
export function useTrustedDeviceNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TrustedDeviceNamesQuery, TrustedDeviceNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TrustedDeviceNamesQuery, TrustedDeviceNamesQueryVariables>(
		TrustedDeviceNamesDocument,
		options,
	);
}
export type TrustedDeviceNamesQueryHookResult = ReturnType<typeof useTrustedDeviceNamesQuery>;
export type TrustedDeviceNamesLazyQueryHookResult = ReturnType<typeof useTrustedDeviceNamesLazyQuery>;
export type TrustedDeviceNamesSuspenseQueryHookResult = ReturnType<typeof useTrustedDeviceNamesSuspenseQuery>;
export type TrustedDeviceNamesQueryResult = Apollo.QueryResult<
	TrustedDeviceNamesQuery,
	TrustedDeviceNamesQueryVariables
>;
export const TrustedDevicePaginationDocument = gql`
	query trustedDevicePagination($filters: [TrustedDeviceFilterInput!], $order: TrustedDeviceOrder) {
		trustedDeviceConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useTrustedDevicePaginationQuery__
 *
 * To run a query within a React component, call `useTrustedDevicePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrustedDevicePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrustedDevicePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTrustedDevicePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<TrustedDevicePaginationQuery, TrustedDevicePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TrustedDevicePaginationQuery, TrustedDevicePaginationQueryVariables>(
		TrustedDevicePaginationDocument,
		options,
	);
}
export function useTrustedDevicePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TrustedDevicePaginationQuery, TrustedDevicePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TrustedDevicePaginationQuery, TrustedDevicePaginationQueryVariables>(
		TrustedDevicePaginationDocument,
		options,
	);
}
export function useTrustedDevicePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TrustedDevicePaginationQuery, TrustedDevicePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TrustedDevicePaginationQuery, TrustedDevicePaginationQueryVariables>(
		TrustedDevicePaginationDocument,
		options,
	);
}
export type TrustedDevicePaginationQueryHookResult = ReturnType<typeof useTrustedDevicePaginationQuery>;
export type TrustedDevicePaginationLazyQueryHookResult = ReturnType<typeof useTrustedDevicePaginationLazyQuery>;
export type TrustedDevicePaginationSuspenseQueryHookResult = ReturnType<typeof useTrustedDevicePaginationSuspenseQuery>;
export type TrustedDevicePaginationQueryResult = Apollo.QueryResult<
	TrustedDevicePaginationQuery,
	TrustedDevicePaginationQueryVariables
>;
export const TrustedDeviceSelectDocument = gql`
	query trustedDeviceSelect($filters: [TrustedDeviceFilterInput!], $order: TrustedDeviceOrder) {
		trustedDeviceConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...TrustedDeviceName
				}
			}
		}
	}
	${TrustedDeviceNameFragmentDoc}
`;

/**
 * __useTrustedDeviceSelectQuery__
 *
 * To run a query within a React component, call `useTrustedDeviceSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrustedDeviceSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrustedDeviceSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTrustedDeviceSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<TrustedDeviceSelectQuery, TrustedDeviceSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TrustedDeviceSelectQuery, TrustedDeviceSelectQueryVariables>(
		TrustedDeviceSelectDocument,
		options,
	);
}
export function useTrustedDeviceSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TrustedDeviceSelectQuery, TrustedDeviceSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TrustedDeviceSelectQuery, TrustedDeviceSelectQueryVariables>(
		TrustedDeviceSelectDocument,
		options,
	);
}
export function useTrustedDeviceSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TrustedDeviceSelectQuery, TrustedDeviceSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TrustedDeviceSelectQuery, TrustedDeviceSelectQueryVariables>(
		TrustedDeviceSelectDocument,
		options,
	);
}
export type TrustedDeviceSelectQueryHookResult = ReturnType<typeof useTrustedDeviceSelectQuery>;
export type TrustedDeviceSelectLazyQueryHookResult = ReturnType<typeof useTrustedDeviceSelectLazyQuery>;
export type TrustedDeviceSelectSuspenseQueryHookResult = ReturnType<typeof useTrustedDeviceSelectSuspenseQuery>;
export type TrustedDeviceSelectQueryResult = Apollo.QueryResult<
	TrustedDeviceSelectQuery,
	TrustedDeviceSelectQueryVariables
>;
export const UserCheckUniqueEmailDocument = gql`
	query userCheckUniqueEmail($ignoreID: ID, $email: String!) {
		userConnection(filters: { idNEQ: $ignoreID, emailEQ: $email }) {
			totalCount
		}
	}
`;

/**
 * __useUserCheckUniqueEmailQuery__
 *
 * To run a query within a React component, call `useUserCheckUniqueEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCheckUniqueEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCheckUniqueEmailQuery({
 *   variables: {
 *      ignoreID: // value for 'ignoreID'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserCheckUniqueEmailQuery(
	baseOptions: Apollo.QueryHookOptions<UserCheckUniqueEmailQuery, UserCheckUniqueEmailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserCheckUniqueEmailQuery, UserCheckUniqueEmailQueryVariables>(
		UserCheckUniqueEmailDocument,
		options,
	);
}
export function useUserCheckUniqueEmailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserCheckUniqueEmailQuery, UserCheckUniqueEmailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserCheckUniqueEmailQuery, UserCheckUniqueEmailQueryVariables>(
		UserCheckUniqueEmailDocument,
		options,
	);
}
export function useUserCheckUniqueEmailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserCheckUniqueEmailQuery, UserCheckUniqueEmailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserCheckUniqueEmailQuery, UserCheckUniqueEmailQueryVariables>(
		UserCheckUniqueEmailDocument,
		options,
	);
}
export type UserCheckUniqueEmailQueryHookResult = ReturnType<typeof useUserCheckUniqueEmailQuery>;
export type UserCheckUniqueEmailLazyQueryHookResult = ReturnType<typeof useUserCheckUniqueEmailLazyQuery>;
export type UserCheckUniqueEmailSuspenseQueryHookResult = ReturnType<typeof useUserCheckUniqueEmailSuspenseQuery>;
export type UserCheckUniqueEmailQueryResult = Apollo.QueryResult<
	UserCheckUniqueEmailQuery,
	UserCheckUniqueEmailQueryVariables
>;
export const UserCountDocument = gql`
	query userCount($filters: [UserFilterInput!], $pagination: Pagination, $order: UserOrder) {
		userConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useUserCountQuery__
 *
 * To run a query within a React component, call `useUserCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserCountQuery(baseOptions?: Apollo.QueryHookOptions<UserCountQuery, UserCountQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserCountQuery, UserCountQueryVariables>(UserCountDocument, options);
}
export function useUserCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserCountQuery, UserCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserCountQuery, UserCountQueryVariables>(UserCountDocument, options);
}
export function useUserCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserCountQuery, UserCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserCountQuery, UserCountQueryVariables>(UserCountDocument, options);
}
export type UserCountQueryHookResult = ReturnType<typeof useUserCountQuery>;
export type UserCountLazyQueryHookResult = ReturnType<typeof useUserCountLazyQuery>;
export type UserCountSuspenseQueryHookResult = ReturnType<typeof useUserCountSuspenseQuery>;
export type UserCountQueryResult = Apollo.QueryResult<UserCountQuery, UserCountQueryVariables>;
export const UserCreateDocument = gql`
	mutation userCreate($input: UserCreateInput!) {
		createUser(input: $input) {
			...UserDetail
		}
	}
	${UserDetailFragmentDoc}
`;
export type UserCreateMutationFn = Apollo.MutationFunction<UserCreateMutation, UserCreateMutationVariables>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<UserCreateMutation, UserCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UserCreateMutation, UserCreateMutationVariables>(UserCreateDocument, options);
}
export type UserCreateMutationHookResult = ReturnType<typeof useUserCreateMutation>;
export type UserCreateMutationResult = Apollo.MutationResult<UserCreateMutation>;
export type UserCreateMutationOptions = Apollo.BaseMutationOptions<UserCreateMutation, UserCreateMutationVariables>;
export const UserDeleteDocument = gql`
	mutation userDelete($id: ID!) {
		deleteUser(id: $id)
	}
`;
export type UserDeleteMutationFn = Apollo.MutationFunction<UserDeleteMutation, UserDeleteMutationVariables>;

/**
 * __useUserDeleteMutation__
 *
 * To run a mutation, you first call `useUserDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeleteMutation, { data, loading, error }] = useUserDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<UserDeleteMutation, UserDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UserDeleteMutation, UserDeleteMutationVariables>(UserDeleteDocument, options);
}
export type UserDeleteMutationHookResult = ReturnType<typeof useUserDeleteMutation>;
export type UserDeleteMutationResult = Apollo.MutationResult<UserDeleteMutation>;
export type UserDeleteMutationOptions = Apollo.BaseMutationOptions<UserDeleteMutation, UserDeleteMutationVariables>;
export const UserDetailDocument = gql`
	query userDetail($id: ID!) {
		user(id: $id) {
			...UserDetail
		}
	}
	${UserDetailFragmentDoc}
`;

/**
 * __useUserDetailQuery__
 *
 * To run a query within a React component, call `useUserDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDetailQuery(baseOptions: Apollo.QueryHookOptions<UserDetailQuery, UserDetailQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserDetailQuery, UserDetailQueryVariables>(UserDetailDocument, options);
}
export function useUserDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserDetailQuery, UserDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserDetailQuery, UserDetailQueryVariables>(UserDetailDocument, options);
}
export function useUserDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserDetailQuery, UserDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserDetailQuery, UserDetailQueryVariables>(UserDetailDocument, options);
}
export type UserDetailQueryHookResult = ReturnType<typeof useUserDetailQuery>;
export type UserDetailLazyQueryHookResult = ReturnType<typeof useUserDetailLazyQuery>;
export type UserDetailSuspenseQueryHookResult = ReturnType<typeof useUserDetailSuspenseQuery>;
export type UserDetailQueryResult = Apollo.QueryResult<UserDetailQuery, UserDetailQueryVariables>;
export const UserIndexDocument = gql`
	query userIndex($filters: [UserFilterInput!], $pagination: Pagination, $order: UserOrder) {
		userConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					email
					status
					passwordUpdatedAt
					isCurrent
					timeZoneName
					externalNotificationFrequency
				}
			}
		}
	}
`;

/**
 * __useUserIndexQuery__
 *
 * To run a query within a React component, call `useUserIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserIndexQuery(baseOptions?: Apollo.QueryHookOptions<UserIndexQuery, UserIndexQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserIndexQuery, UserIndexQueryVariables>(UserIndexDocument, options);
}
export function useUserIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserIndexQuery, UserIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserIndexQuery, UserIndexQueryVariables>(UserIndexDocument, options);
}
export function useUserIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserIndexQuery, UserIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserIndexQuery, UserIndexQueryVariables>(UserIndexDocument, options);
}
export type UserIndexQueryHookResult = ReturnType<typeof useUserIndexQuery>;
export type UserIndexLazyQueryHookResult = ReturnType<typeof useUserIndexLazyQuery>;
export type UserIndexSuspenseQueryHookResult = ReturnType<typeof useUserIndexSuspenseQuery>;
export type UserIndexQueryResult = Apollo.QueryResult<UserIndexQuery, UserIndexQueryVariables>;
export const SendUserInviteMessageDocument = gql`
	mutation sendUserInviteMessage($userID: ID!) {
		inviteUser(id: $userID)
	}
`;
export type SendUserInviteMessageMutationFn = Apollo.MutationFunction<
	SendUserInviteMessageMutation,
	SendUserInviteMessageMutationVariables
>;

/**
 * __useSendUserInviteMessageMutation__
 *
 * To run a mutation, you first call `useSendUserInviteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendUserInviteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendUserInviteMessageMutation, { data, loading, error }] = useSendUserInviteMessageMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useSendUserInviteMessageMutation(
	baseOptions?: Apollo.MutationHookOptions<SendUserInviteMessageMutation, SendUserInviteMessageMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SendUserInviteMessageMutation, SendUserInviteMessageMutationVariables>(
		SendUserInviteMessageDocument,
		options,
	);
}
export type SendUserInviteMessageMutationHookResult = ReturnType<typeof useSendUserInviteMessageMutation>;
export type SendUserInviteMessageMutationResult = Apollo.MutationResult<SendUserInviteMessageMutation>;
export type SendUserInviteMessageMutationOptions = Apollo.BaseMutationOptions<
	SendUserInviteMessageMutation,
	SendUserInviteMessageMutationVariables
>;
export const SendParentPortalInviteMessageDocument = gql`
	mutation sendParentPortalInviteMessage($userID: ID!) {
		sendParentPortalInviteMessage(userID: $userID)
	}
`;
export type SendParentPortalInviteMessageMutationFn = Apollo.MutationFunction<
	SendParentPortalInviteMessageMutation,
	SendParentPortalInviteMessageMutationVariables
>;

/**
 * __useSendParentPortalInviteMessageMutation__
 *
 * To run a mutation, you first call `useSendParentPortalInviteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendParentPortalInviteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendParentPortalInviteMessageMutation, { data, loading, error }] = useSendParentPortalInviteMessageMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useSendParentPortalInviteMessageMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SendParentPortalInviteMessageMutation,
		SendParentPortalInviteMessageMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SendParentPortalInviteMessageMutation, SendParentPortalInviteMessageMutationVariables>(
		SendParentPortalInviteMessageDocument,
		options,
	);
}
export type SendParentPortalInviteMessageMutationHookResult = ReturnType<
	typeof useSendParentPortalInviteMessageMutation
>;
export type SendParentPortalInviteMessageMutationResult = Apollo.MutationResult<SendParentPortalInviteMessageMutation>;
export type SendParentPortalInviteMessageMutationOptions = Apollo.BaseMutationOptions<
	SendParentPortalInviteMessageMutation,
	SendParentPortalInviteMessageMutationVariables
>;
export const UserDetailedSelectListDocument = gql`
	query userDetailedSelectList($filters: [UserFilterInput!], $pagination: Pagination, $order: UserOrder) {
		userConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					email
					isCurrent
					person {
						id
						...PersonName
						employee {
							id
							jobTitle
						}
						guardian {
							id
						}
						student {
							id
						}
					}
				}
			}
		}
	}
	${PersonNameFragmentDoc}
`;

/**
 * __useUserDetailedSelectListQuery__
 *
 * To run a query within a React component, call `useUserDetailedSelectListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailedSelectListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailedSelectListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserDetailedSelectListQuery(
	baseOptions?: Apollo.QueryHookOptions<UserDetailedSelectListQuery, UserDetailedSelectListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserDetailedSelectListQuery, UserDetailedSelectListQueryVariables>(
		UserDetailedSelectListDocument,
		options,
	);
}
export function useUserDetailedSelectListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserDetailedSelectListQuery, UserDetailedSelectListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserDetailedSelectListQuery, UserDetailedSelectListQueryVariables>(
		UserDetailedSelectListDocument,
		options,
	);
}
export function useUserDetailedSelectListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserDetailedSelectListQuery, UserDetailedSelectListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserDetailedSelectListQuery, UserDetailedSelectListQueryVariables>(
		UserDetailedSelectListDocument,
		options,
	);
}
export type UserDetailedSelectListQueryHookResult = ReturnType<typeof useUserDetailedSelectListQuery>;
export type UserDetailedSelectListLazyQueryHookResult = ReturnType<typeof useUserDetailedSelectListLazyQuery>;
export type UserDetailedSelectListSuspenseQueryHookResult = ReturnType<typeof useUserDetailedSelectListSuspenseQuery>;
export type UserDetailedSelectListQueryResult = Apollo.QueryResult<
	UserDetailedSelectListQuery,
	UserDetailedSelectListQueryVariables
>;
export const UserNamesDescriptionsAndImagesDocument = gql`
	query userNamesDescriptionsAndImages($filters: [UserFilterInput!], $pagination: Pagination, $order: UserOrder) {
		userConnection(filters: $filters, pagination: $pagination, order: $order) {
			pageInfo {
				hasNextPage
				endCursor
			}
			edges {
				node {
					id
					...UserNameDescriptionAndImage
				}
			}
		}
	}
	${UserNameDescriptionAndImageFragmentDoc}
`;

/**
 * __useUserNamesDescriptionsAndImagesQuery__
 *
 * To run a query within a React component, call `useUserNamesDescriptionsAndImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNamesDescriptionsAndImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNamesDescriptionsAndImagesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserNamesDescriptionsAndImagesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UserNamesDescriptionsAndImagesQuery,
		UserNamesDescriptionsAndImagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserNamesDescriptionsAndImagesQuery, UserNamesDescriptionsAndImagesQueryVariables>(
		UserNamesDescriptionsAndImagesDocument,
		options,
	);
}
export function useUserNamesDescriptionsAndImagesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserNamesDescriptionsAndImagesQuery,
		UserNamesDescriptionsAndImagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserNamesDescriptionsAndImagesQuery, UserNamesDescriptionsAndImagesQueryVariables>(
		UserNamesDescriptionsAndImagesDocument,
		options,
	);
}
export function useUserNamesDescriptionsAndImagesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		UserNamesDescriptionsAndImagesQuery,
		UserNamesDescriptionsAndImagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserNamesDescriptionsAndImagesQuery, UserNamesDescriptionsAndImagesQueryVariables>(
		UserNamesDescriptionsAndImagesDocument,
		options,
	);
}
export type UserNamesDescriptionsAndImagesQueryHookResult = ReturnType<typeof useUserNamesDescriptionsAndImagesQuery>;
export type UserNamesDescriptionsAndImagesLazyQueryHookResult = ReturnType<
	typeof useUserNamesDescriptionsAndImagesLazyQuery
>;
export type UserNamesDescriptionsAndImagesSuspenseQueryHookResult = ReturnType<
	typeof useUserNamesDescriptionsAndImagesSuspenseQuery
>;
export type UserNamesDescriptionsAndImagesQueryResult = Apollo.QueryResult<
	UserNamesDescriptionsAndImagesQuery,
	UserNamesDescriptionsAndImagesQueryVariables
>;
export const UserNameDocument = gql`
	query userName($id: ID!) {
		user(id: $id) {
			id
			...UserName
		}
	}
	${UserNameFragmentDoc}
`;

/**
 * __useUserNameQuery__
 *
 * To run a query within a React component, call `useUserNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserNameQuery(baseOptions: Apollo.QueryHookOptions<UserNameQuery, UserNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserNameQuery, UserNameQueryVariables>(UserNameDocument, options);
}
export function useUserNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNameQuery, UserNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserNameQuery, UserNameQueryVariables>(UserNameDocument, options);
}
export function useUserNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserNameQuery, UserNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserNameQuery, UserNameQueryVariables>(UserNameDocument, options);
}
export type UserNameQueryHookResult = ReturnType<typeof useUserNameQuery>;
export type UserNameLazyQueryHookResult = ReturnType<typeof useUserNameLazyQuery>;
export type UserNameSuspenseQueryHookResult = ReturnType<typeof useUserNameSuspenseQuery>;
export type UserNameQueryResult = Apollo.QueryResult<UserNameQuery, UserNameQueryVariables>;
export const UserNamesAndImagesDocument = gql`
	query userNamesAndImages($filters: [UserFilterInput!], $pagination: Pagination, $order: UserOrder) {
		userConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...UserNameAndImage
				}
			}
		}
	}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __useUserNamesAndImagesQuery__
 *
 * To run a query within a React component, call `useUserNamesAndImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNamesAndImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNamesAndImagesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserNamesAndImagesQuery(
	baseOptions?: Apollo.QueryHookOptions<UserNamesAndImagesQuery, UserNamesAndImagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserNamesAndImagesQuery, UserNamesAndImagesQueryVariables>(
		UserNamesAndImagesDocument,
		options,
	);
}
export function useUserNamesAndImagesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserNamesAndImagesQuery, UserNamesAndImagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserNamesAndImagesQuery, UserNamesAndImagesQueryVariables>(
		UserNamesAndImagesDocument,
		options,
	);
}
export function useUserNamesAndImagesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserNamesAndImagesQuery, UserNamesAndImagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserNamesAndImagesQuery, UserNamesAndImagesQueryVariables>(
		UserNamesAndImagesDocument,
		options,
	);
}
export type UserNamesAndImagesQueryHookResult = ReturnType<typeof useUserNamesAndImagesQuery>;
export type UserNamesAndImagesLazyQueryHookResult = ReturnType<typeof useUserNamesAndImagesLazyQuery>;
export type UserNamesAndImagesSuspenseQueryHookResult = ReturnType<typeof useUserNamesAndImagesSuspenseQuery>;
export type UserNamesAndImagesQueryResult = Apollo.QueryResult<
	UserNamesAndImagesQuery,
	UserNamesAndImagesQueryVariables
>;
export const UserNamesDocument = gql`
	query userNames($filters: [UserFilterInput!], $pagination: Pagination, $order: UserOrder) {
		userConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...UserName
				}
			}
		}
	}
	${UserNameFragmentDoc}
`;

/**
 * __useUserNamesQuery__
 *
 * To run a query within a React component, call `useUserNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserNamesQuery(baseOptions?: Apollo.QueryHookOptions<UserNamesQuery, UserNamesQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserNamesQuery, UserNamesQueryVariables>(UserNamesDocument, options);
}
export function useUserNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserNamesQuery, UserNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserNamesQuery, UserNamesQueryVariables>(UserNamesDocument, options);
}
export function useUserNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserNamesQuery, UserNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserNamesQuery, UserNamesQueryVariables>(UserNamesDocument, options);
}
export type UserNamesQueryHookResult = ReturnType<typeof useUserNamesQuery>;
export type UserNamesLazyQueryHookResult = ReturnType<typeof useUserNamesLazyQuery>;
export type UserNamesSuspenseQueryHookResult = ReturnType<typeof useUserNamesSuspenseQuery>;
export type UserNamesQueryResult = Apollo.QueryResult<UserNamesQuery, UserNamesQueryVariables>;
export const UserPaginationDocument = gql`
	query userPagination($filters: [UserFilterInput!], $order: UserOrder) {
		userConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useUserPaginationQuery__
 *
 * To run a query within a React component, call `useUserPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<UserPaginationQuery, UserPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserPaginationQuery, UserPaginationQueryVariables>(UserPaginationDocument, options);
}
export function useUserPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserPaginationQuery, UserPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserPaginationQuery, UserPaginationQueryVariables>(UserPaginationDocument, options);
}
export function useUserPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserPaginationQuery, UserPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserPaginationQuery, UserPaginationQueryVariables>(UserPaginationDocument, options);
}
export type UserPaginationQueryHookResult = ReturnType<typeof useUserPaginationQuery>;
export type UserPaginationLazyQueryHookResult = ReturnType<typeof useUserPaginationLazyQuery>;
export type UserPaginationSuspenseQueryHookResult = ReturnType<typeof useUserPaginationSuspenseQuery>;
export type UserPaginationQueryResult = Apollo.QueryResult<UserPaginationQuery, UserPaginationQueryVariables>;
export const UserSelectDocument = gql`
	query userSelect($filters: [UserFilterInput!], $order: UserOrder) {
		userConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...UserName
				}
			}
		}
	}
	${UserNameFragmentDoc}
`;

/**
 * __useUserSelectQuery__
 *
 * To run a query within a React component, call `useUserSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserSelectQuery(baseOptions?: Apollo.QueryHookOptions<UserSelectQuery, UserSelectQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserSelectQuery, UserSelectQueryVariables>(UserSelectDocument, options);
}
export function useUserSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserSelectQuery, UserSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserSelectQuery, UserSelectQueryVariables>(UserSelectDocument, options);
}
export function useUserSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserSelectQuery, UserSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserSelectQuery, UserSelectQueryVariables>(UserSelectDocument, options);
}
export type UserSelectQueryHookResult = ReturnType<typeof useUserSelectQuery>;
export type UserSelectLazyQueryHookResult = ReturnType<typeof useUserSelectLazyQuery>;
export type UserSelectSuspenseQueryHookResult = ReturnType<typeof useUserSelectSuspenseQuery>;
export type UserSelectQueryResult = Apollo.QueryResult<UserSelectQuery, UserSelectQueryVariables>;
export const UserUpdateDocument = gql`
	mutation userUpdate($id: ID!, $input: UserUpdateInput!) {
		updateUser(id: $id, input: $input) {
			...UserDetail
		}
	}
	${UserDetailFragmentDoc}
`;
export type UserUpdateMutationFn = Apollo.MutationFunction<UserUpdateMutation, UserUpdateMutationVariables>;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<UserUpdateMutation, UserUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(UserUpdateDocument, options);
}
export type UserUpdateMutationHookResult = ReturnType<typeof useUserUpdateMutation>;
export type UserUpdateMutationResult = Apollo.MutationResult<UserUpdateMutation>;
export type UserUpdateMutationOptions = Apollo.BaseMutationOptions<UserUpdateMutation, UserUpdateMutationVariables>;
export const ParentPortalViewerInfoDocument = gql`
	query parentPortalViewerInfo {
		viewer {
			id
			email
			isCurrent
			externalNotificationFrequency
			person {
				id
				...PersonNameAndImage
				givenName
				familyName
				nameOrder
				publicNameFormat
				guardian {
					id
					relationships(filters: { student: { hasStudentAcademicTermEnrollments: true } }) {
						id
						relationshipType
						isPrimary
						student {
							id
							person {
								id
								...PersonNameAndImage
								givenName
							}
						}
					}
				}
			}
		}
	}
	${PersonNameAndImageFragmentDoc}
`;

/**
 * __useParentPortalViewerInfoQuery__
 *
 * To run a query within a React component, call `useParentPortalViewerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useParentPortalViewerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParentPortalViewerInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useParentPortalViewerInfoQuery(
	baseOptions?: Apollo.QueryHookOptions<ParentPortalViewerInfoQuery, ParentPortalViewerInfoQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ParentPortalViewerInfoQuery, ParentPortalViewerInfoQueryVariables>(
		ParentPortalViewerInfoDocument,
		options,
	);
}
export function useParentPortalViewerInfoLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ParentPortalViewerInfoQuery, ParentPortalViewerInfoQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ParentPortalViewerInfoQuery, ParentPortalViewerInfoQueryVariables>(
		ParentPortalViewerInfoDocument,
		options,
	);
}
export function useParentPortalViewerInfoSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ParentPortalViewerInfoQuery, ParentPortalViewerInfoQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ParentPortalViewerInfoQuery, ParentPortalViewerInfoQueryVariables>(
		ParentPortalViewerInfoDocument,
		options,
	);
}
export type ParentPortalViewerInfoQueryHookResult = ReturnType<typeof useParentPortalViewerInfoQuery>;
export type ParentPortalViewerInfoLazyQueryHookResult = ReturnType<typeof useParentPortalViewerInfoLazyQuery>;
export type ParentPortalViewerInfoSuspenseQueryHookResult = ReturnType<typeof useParentPortalViewerInfoSuspenseQuery>;
export type ParentPortalViewerInfoQueryResult = Apollo.QueryResult<
	ParentPortalViewerInfoQuery,
	ParentPortalViewerInfoQueryVariables
>;
export const InternalPortalsViewerInfoDocument = gql`
	query internalPortalsViewerInfo {
		viewer {
			id
			email
			isCurrent
			person {
				id
				...PersonNameAndImage
				employee {
					id
					role
					jobTitle
				}
				guardian {
					id
				}
			}
		}
	}
	${PersonNameAndImageFragmentDoc}
`;

/**
 * __useInternalPortalsViewerInfoQuery__
 *
 * To run a query within a React component, call `useInternalPortalsViewerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalPortalsViewerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalPortalsViewerInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useInternalPortalsViewerInfoQuery(
	baseOptions?: Apollo.QueryHookOptions<InternalPortalsViewerInfoQuery, InternalPortalsViewerInfoQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<InternalPortalsViewerInfoQuery, InternalPortalsViewerInfoQueryVariables>(
		InternalPortalsViewerInfoDocument,
		options,
	);
}
export function useInternalPortalsViewerInfoLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<InternalPortalsViewerInfoQuery, InternalPortalsViewerInfoQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<InternalPortalsViewerInfoQuery, InternalPortalsViewerInfoQueryVariables>(
		InternalPortalsViewerInfoDocument,
		options,
	);
}
export function useInternalPortalsViewerInfoSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		InternalPortalsViewerInfoQuery,
		InternalPortalsViewerInfoQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<InternalPortalsViewerInfoQuery, InternalPortalsViewerInfoQueryVariables>(
		InternalPortalsViewerInfoDocument,
		options,
	);
}
export type InternalPortalsViewerInfoQueryHookResult = ReturnType<typeof useInternalPortalsViewerInfoQuery>;
export type InternalPortalsViewerInfoLazyQueryHookResult = ReturnType<typeof useInternalPortalsViewerInfoLazyQuery>;
export type InternalPortalsViewerInfoSuspenseQueryHookResult = ReturnType<
	typeof useInternalPortalsViewerInfoSuspenseQuery
>;
export type InternalPortalsViewerInfoQueryResult = Apollo.QueryResult<
	InternalPortalsViewerInfoQuery,
	InternalPortalsViewerInfoQueryVariables
>;
export const ViewerPublicNameFormatDocument = gql`
	query viewerPublicNameFormat {
		viewer {
			id
			person {
				id
				publicNameFormat
			}
		}
	}
`;

/**
 * __useViewerPublicNameFormatQuery__
 *
 * To run a query within a React component, call `useViewerPublicNameFormatQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerPublicNameFormatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerPublicNameFormatQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerPublicNameFormatQuery(
	baseOptions?: Apollo.QueryHookOptions<ViewerPublicNameFormatQuery, ViewerPublicNameFormatQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ViewerPublicNameFormatQuery, ViewerPublicNameFormatQueryVariables>(
		ViewerPublicNameFormatDocument,
		options,
	);
}
export function useViewerPublicNameFormatLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ViewerPublicNameFormatQuery, ViewerPublicNameFormatQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ViewerPublicNameFormatQuery, ViewerPublicNameFormatQueryVariables>(
		ViewerPublicNameFormatDocument,
		options,
	);
}
export function useViewerPublicNameFormatSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ViewerPublicNameFormatQuery, ViewerPublicNameFormatQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ViewerPublicNameFormatQuery, ViewerPublicNameFormatQueryVariables>(
		ViewerPublicNameFormatDocument,
		options,
	);
}
export type ViewerPublicNameFormatQueryHookResult = ReturnType<typeof useViewerPublicNameFormatQuery>;
export type ViewerPublicNameFormatLazyQueryHookResult = ReturnType<typeof useViewerPublicNameFormatLazyQuery>;
export type ViewerPublicNameFormatSuspenseQueryHookResult = ReturnType<typeof useViewerPublicNameFormatSuspenseQuery>;
export type ViewerPublicNameFormatQueryResult = Apollo.QueryResult<
	ViewerPublicNameFormatQuery,
	ViewerPublicNameFormatQueryVariables
>;
export const UserGroupCountDocument = gql`
	query userGroupCount($filters: [UserGroupFilterInput!], $pagination: Pagination, $order: UserGroupOrder) {
		userGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useUserGroupCountQuery__
 *
 * To run a query within a React component, call `useUserGroupCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserGroupCountQuery(
	baseOptions?: Apollo.QueryHookOptions<UserGroupCountQuery, UserGroupCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupCountQuery, UserGroupCountQueryVariables>(UserGroupCountDocument, options);
}
export function useUserGroupCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserGroupCountQuery, UserGroupCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupCountQuery, UserGroupCountQueryVariables>(UserGroupCountDocument, options);
}
export function useUserGroupCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupCountQuery, UserGroupCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupCountQuery, UserGroupCountQueryVariables>(UserGroupCountDocument, options);
}
export type UserGroupCountQueryHookResult = ReturnType<typeof useUserGroupCountQuery>;
export type UserGroupCountLazyQueryHookResult = ReturnType<typeof useUserGroupCountLazyQuery>;
export type UserGroupCountSuspenseQueryHookResult = ReturnType<typeof useUserGroupCountSuspenseQuery>;
export type UserGroupCountQueryResult = Apollo.QueryResult<UserGroupCountQuery, UserGroupCountQueryVariables>;
export const UserGroupCreateDocument = gql`
	mutation userGroupCreate($input: UserGroupCreateInput!) {
		createUserGroup(input: $input) {
			...UserGroupDetail
		}
	}
	${UserGroupDetailFragmentDoc}
`;
export type UserGroupCreateMutationFn = Apollo.MutationFunction<
	UserGroupCreateMutation,
	UserGroupCreateMutationVariables
>;

/**
 * __useUserGroupCreateMutation__
 *
 * To run a mutation, you first call `useUserGroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserGroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userGroupCreateMutation, { data, loading, error }] = useUserGroupCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserGroupCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<UserGroupCreateMutation, UserGroupCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UserGroupCreateMutation, UserGroupCreateMutationVariables>(
		UserGroupCreateDocument,
		options,
	);
}
export type UserGroupCreateMutationHookResult = ReturnType<typeof useUserGroupCreateMutation>;
export type UserGroupCreateMutationResult = Apollo.MutationResult<UserGroupCreateMutation>;
export type UserGroupCreateMutationOptions = Apollo.BaseMutationOptions<
	UserGroupCreateMutation,
	UserGroupCreateMutationVariables
>;
export const UserGroupDeleteDocument = gql`
	mutation userGroupDelete($id: ID!) {
		deleteUserGroup(id: $id)
	}
`;
export type UserGroupDeleteMutationFn = Apollo.MutationFunction<
	UserGroupDeleteMutation,
	UserGroupDeleteMutationVariables
>;

/**
 * __useUserGroupDeleteMutation__
 *
 * To run a mutation, you first call `useUserGroupDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserGroupDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userGroupDeleteMutation, { data, loading, error }] = useUserGroupDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserGroupDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<UserGroupDeleteMutation, UserGroupDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UserGroupDeleteMutation, UserGroupDeleteMutationVariables>(
		UserGroupDeleteDocument,
		options,
	);
}
export type UserGroupDeleteMutationHookResult = ReturnType<typeof useUserGroupDeleteMutation>;
export type UserGroupDeleteMutationResult = Apollo.MutationResult<UserGroupDeleteMutation>;
export type UserGroupDeleteMutationOptions = Apollo.BaseMutationOptions<
	UserGroupDeleteMutation,
	UserGroupDeleteMutationVariables
>;
export const UserGroupDetailDocument = gql`
	query userGroupDetail($id: ID!) {
		userGroup(id: $id) {
			...UserGroupDetail
		}
	}
	${UserGroupDetailFragmentDoc}
`;

/**
 * __useUserGroupDetailQuery__
 *
 * To run a query within a React component, call `useUserGroupDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserGroupDetailQuery(
	baseOptions: Apollo.QueryHookOptions<UserGroupDetailQuery, UserGroupDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupDetailQuery, UserGroupDetailQueryVariables>(UserGroupDetailDocument, options);
}
export function useUserGroupDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserGroupDetailQuery, UserGroupDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupDetailQuery, UserGroupDetailQueryVariables>(UserGroupDetailDocument, options);
}
export function useUserGroupDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupDetailQuery, UserGroupDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupDetailQuery, UserGroupDetailQueryVariables>(UserGroupDetailDocument, options);
}
export type UserGroupDetailQueryHookResult = ReturnType<typeof useUserGroupDetailQuery>;
export type UserGroupDetailLazyQueryHookResult = ReturnType<typeof useUserGroupDetailLazyQuery>;
export type UserGroupDetailSuspenseQueryHookResult = ReturnType<typeof useUserGroupDetailSuspenseQuery>;
export type UserGroupDetailQueryResult = Apollo.QueryResult<UserGroupDetailQuery, UserGroupDetailQueryVariables>;
export const UserGroupIDsDocument = gql`
	query userGroupIDs($filters: [UserGroupFilterInput!], $pagination: Pagination, $order: UserGroupOrder) {
		userGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
				}
			}
		}
	}
`;

/**
 * __useUserGroupIDsQuery__
 *
 * To run a query within a React component, call `useUserGroupIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupIDsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserGroupIDsQuery(
	baseOptions?: Apollo.QueryHookOptions<UserGroupIDsQuery, UserGroupIDsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupIDsQuery, UserGroupIDsQueryVariables>(UserGroupIDsDocument, options);
}
export function useUserGroupIDsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserGroupIDsQuery, UserGroupIDsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupIDsQuery, UserGroupIDsQueryVariables>(UserGroupIDsDocument, options);
}
export function useUserGroupIDsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupIDsQuery, UserGroupIDsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupIDsQuery, UserGroupIDsQueryVariables>(UserGroupIDsDocument, options);
}
export type UserGroupIDsQueryHookResult = ReturnType<typeof useUserGroupIDsQuery>;
export type UserGroupIDsLazyQueryHookResult = ReturnType<typeof useUserGroupIDsLazyQuery>;
export type UserGroupIDsSuspenseQueryHookResult = ReturnType<typeof useUserGroupIDsSuspenseQuery>;
export type UserGroupIDsQueryResult = Apollo.QueryResult<UserGroupIDsQuery, UserGroupIDsQueryVariables>;
export const UserGroupIndexDocument = gql`
	query userGroupIndex($filters: [UserGroupFilterInput!], $pagination: Pagination, $order: UserGroupOrder) {
		userGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					description
					color
					isPublic
					members {
						id
					}
				}
			}
		}
	}
`;

/**
 * __useUserGroupIndexQuery__
 *
 * To run a query within a React component, call `useUserGroupIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserGroupIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<UserGroupIndexQuery, UserGroupIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupIndexQuery, UserGroupIndexQueryVariables>(UserGroupIndexDocument, options);
}
export function useUserGroupIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserGroupIndexQuery, UserGroupIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupIndexQuery, UserGroupIndexQueryVariables>(UserGroupIndexDocument, options);
}
export function useUserGroupIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupIndexQuery, UserGroupIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupIndexQuery, UserGroupIndexQueryVariables>(UserGroupIndexDocument, options);
}
export type UserGroupIndexQueryHookResult = ReturnType<typeof useUserGroupIndexQuery>;
export type UserGroupIndexLazyQueryHookResult = ReturnType<typeof useUserGroupIndexLazyQuery>;
export type UserGroupIndexSuspenseQueryHookResult = ReturnType<typeof useUserGroupIndexSuspenseQuery>;
export type UserGroupIndexQueryResult = Apollo.QueryResult<UserGroupIndexQuery, UserGroupIndexQueryVariables>;
export const UserGroupDetailedSelectListDocument = gql`
	query userGroupDetailedSelectList(
		$filters: [UserGroupFilterInput!]
		$pagination: Pagination
		$order: UserGroupOrder
	) {
		userGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...UserGroupName
					description
					currentUserMembers: members(filters: { isCurrentEQ: true }) {
						id
					}
				}
			}
		}
	}
	${UserGroupNameFragmentDoc}
`;

/**
 * __useUserGroupDetailedSelectListQuery__
 *
 * To run a query within a React component, call `useUserGroupDetailedSelectListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupDetailedSelectListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupDetailedSelectListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserGroupDetailedSelectListQuery(
	baseOptions?: Apollo.QueryHookOptions<UserGroupDetailedSelectListQuery, UserGroupDetailedSelectListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupDetailedSelectListQuery, UserGroupDetailedSelectListQueryVariables>(
		UserGroupDetailedSelectListDocument,
		options,
	);
}
export function useUserGroupDetailedSelectListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserGroupDetailedSelectListQuery,
		UserGroupDetailedSelectListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupDetailedSelectListQuery, UserGroupDetailedSelectListQueryVariables>(
		UserGroupDetailedSelectListDocument,
		options,
	);
}
export function useUserGroupDetailedSelectListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		UserGroupDetailedSelectListQuery,
		UserGroupDetailedSelectListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupDetailedSelectListQuery, UserGroupDetailedSelectListQueryVariables>(
		UserGroupDetailedSelectListDocument,
		options,
	);
}
export type UserGroupDetailedSelectListQueryHookResult = ReturnType<typeof useUserGroupDetailedSelectListQuery>;
export type UserGroupDetailedSelectListLazyQueryHookResult = ReturnType<typeof useUserGroupDetailedSelectListLazyQuery>;
export type UserGroupDetailedSelectListSuspenseQueryHookResult = ReturnType<
	typeof useUserGroupDetailedSelectListSuspenseQuery
>;
export type UserGroupDetailedSelectListQueryResult = Apollo.QueryResult<
	UserGroupDetailedSelectListQuery,
	UserGroupDetailedSelectListQueryVariables
>;
export const UserGroupNameDocument = gql`
	query userGroupName($id: ID!) {
		userGroup(id: $id) {
			id
			...UserGroupName
		}
	}
	${UserGroupNameFragmentDoc}
`;

/**
 * __useUserGroupNameQuery__
 *
 * To run a query within a React component, call `useUserGroupNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserGroupNameQuery(
	baseOptions: Apollo.QueryHookOptions<UserGroupNameQuery, UserGroupNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupNameQuery, UserGroupNameQueryVariables>(UserGroupNameDocument, options);
}
export function useUserGroupNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserGroupNameQuery, UserGroupNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupNameQuery, UserGroupNameQueryVariables>(UserGroupNameDocument, options);
}
export function useUserGroupNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupNameQuery, UserGroupNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupNameQuery, UserGroupNameQueryVariables>(UserGroupNameDocument, options);
}
export type UserGroupNameQueryHookResult = ReturnType<typeof useUserGroupNameQuery>;
export type UserGroupNameLazyQueryHookResult = ReturnType<typeof useUserGroupNameLazyQuery>;
export type UserGroupNameSuspenseQueryHookResult = ReturnType<typeof useUserGroupNameSuspenseQuery>;
export type UserGroupNameQueryResult = Apollo.QueryResult<UserGroupNameQuery, UserGroupNameQueryVariables>;
export const UserGroupNamesDocument = gql`
	query userGroupNames($filters: [UserGroupFilterInput!], $pagination: Pagination, $order: UserGroupOrder) {
		userGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...UserGroupName
				}
			}
		}
	}
	${UserGroupNameFragmentDoc}
`;

/**
 * __useUserGroupNamesQuery__
 *
 * To run a query within a React component, call `useUserGroupNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserGroupNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<UserGroupNamesQuery, UserGroupNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupNamesQuery, UserGroupNamesQueryVariables>(UserGroupNamesDocument, options);
}
export function useUserGroupNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserGroupNamesQuery, UserGroupNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupNamesQuery, UserGroupNamesQueryVariables>(UserGroupNamesDocument, options);
}
export function useUserGroupNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupNamesQuery, UserGroupNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupNamesQuery, UserGroupNamesQueryVariables>(UserGroupNamesDocument, options);
}
export type UserGroupNamesQueryHookResult = ReturnType<typeof useUserGroupNamesQuery>;
export type UserGroupNamesLazyQueryHookResult = ReturnType<typeof useUserGroupNamesLazyQuery>;
export type UserGroupNamesSuspenseQueryHookResult = ReturnType<typeof useUserGroupNamesSuspenseQuery>;
export type UserGroupNamesQueryResult = Apollo.QueryResult<UserGroupNamesQuery, UserGroupNamesQueryVariables>;
export const UserGroupNamesAndColorsDocument = gql`
	query userGroupNamesAndColors($filters: [UserGroupFilterInput!], $pagination: Pagination, $order: UserGroupOrder) {
		userGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...UserGroupNameAndColor
				}
			}
		}
	}
	${UserGroupNameAndColorFragmentDoc}
`;

/**
 * __useUserGroupNamesAndColorsQuery__
 *
 * To run a query within a React component, call `useUserGroupNamesAndColorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupNamesAndColorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupNamesAndColorsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserGroupNamesAndColorsQuery(
	baseOptions?: Apollo.QueryHookOptions<UserGroupNamesAndColorsQuery, UserGroupNamesAndColorsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupNamesAndColorsQuery, UserGroupNamesAndColorsQueryVariables>(
		UserGroupNamesAndColorsDocument,
		options,
	);
}
export function useUserGroupNamesAndColorsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserGroupNamesAndColorsQuery, UserGroupNamesAndColorsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupNamesAndColorsQuery, UserGroupNamesAndColorsQueryVariables>(
		UserGroupNamesAndColorsDocument,
		options,
	);
}
export function useUserGroupNamesAndColorsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupNamesAndColorsQuery, UserGroupNamesAndColorsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupNamesAndColorsQuery, UserGroupNamesAndColorsQueryVariables>(
		UserGroupNamesAndColorsDocument,
		options,
	);
}
export type UserGroupNamesAndColorsQueryHookResult = ReturnType<typeof useUserGroupNamesAndColorsQuery>;
export type UserGroupNamesAndColorsLazyQueryHookResult = ReturnType<typeof useUserGroupNamesAndColorsLazyQuery>;
export type UserGroupNamesAndColorsSuspenseQueryHookResult = ReturnType<typeof useUserGroupNamesAndColorsSuspenseQuery>;
export type UserGroupNamesAndColorsQueryResult = Apollo.QueryResult<
	UserGroupNamesAndColorsQuery,
	UserGroupNamesAndColorsQueryVariables
>;
export const UserGroupPaginationDocument = gql`
	query userGroupPagination($filters: [UserGroupFilterInput!], $order: UserGroupOrder) {
		userGroupConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useUserGroupPaginationQuery__
 *
 * To run a query within a React component, call `useUserGroupPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserGroupPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<UserGroupPaginationQuery, UserGroupPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupPaginationQuery, UserGroupPaginationQueryVariables>(
		UserGroupPaginationDocument,
		options,
	);
}
export function useUserGroupPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserGroupPaginationQuery, UserGroupPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupPaginationQuery, UserGroupPaginationQueryVariables>(
		UserGroupPaginationDocument,
		options,
	);
}
export function useUserGroupPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupPaginationQuery, UserGroupPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupPaginationQuery, UserGroupPaginationQueryVariables>(
		UserGroupPaginationDocument,
		options,
	);
}
export type UserGroupPaginationQueryHookResult = ReturnType<typeof useUserGroupPaginationQuery>;
export type UserGroupPaginationLazyQueryHookResult = ReturnType<typeof useUserGroupPaginationLazyQuery>;
export type UserGroupPaginationSuspenseQueryHookResult = ReturnType<typeof useUserGroupPaginationSuspenseQuery>;
export type UserGroupPaginationQueryResult = Apollo.QueryResult<
	UserGroupPaginationQuery,
	UserGroupPaginationQueryVariables
>;
export const UserGroupSelectDocument = gql`
	query userGroupSelect($filters: [UserGroupFilterInput!], $order: UserGroupOrder) {
		userGroupConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...UserGroupName
				}
			}
		}
	}
	${UserGroupNameFragmentDoc}
`;

/**
 * __useUserGroupSelectQuery__
 *
 * To run a query within a React component, call `useUserGroupSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserGroupSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<UserGroupSelectQuery, UserGroupSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupSelectQuery, UserGroupSelectQueryVariables>(UserGroupSelectDocument, options);
}
export function useUserGroupSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserGroupSelectQuery, UserGroupSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupSelectQuery, UserGroupSelectQueryVariables>(UserGroupSelectDocument, options);
}
export function useUserGroupSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupSelectQuery, UserGroupSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupSelectQuery, UserGroupSelectQueryVariables>(UserGroupSelectDocument, options);
}
export type UserGroupSelectQueryHookResult = ReturnType<typeof useUserGroupSelectQuery>;
export type UserGroupSelectLazyQueryHookResult = ReturnType<typeof useUserGroupSelectLazyQuery>;
export type UserGroupSelectSuspenseQueryHookResult = ReturnType<typeof useUserGroupSelectSuspenseQuery>;
export type UserGroupSelectQueryResult = Apollo.QueryResult<UserGroupSelectQuery, UserGroupSelectQueryVariables>;
export const UserGroupUpdateDocument = gql`
	mutation userGroupUpdate($id: ID!, $input: UserGroupUpdateInput!) {
		updateUserGroup(id: $id, input: $input) {
			...UserGroupDetail
		}
	}
	${UserGroupDetailFragmentDoc}
`;
export type UserGroupUpdateMutationFn = Apollo.MutationFunction<
	UserGroupUpdateMutation,
	UserGroupUpdateMutationVariables
>;

/**
 * __useUserGroupUpdateMutation__
 *
 * To run a mutation, you first call `useUserGroupUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserGroupUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userGroupUpdateMutation, { data, loading, error }] = useUserGroupUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserGroupUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<UserGroupUpdateMutation, UserGroupUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UserGroupUpdateMutation, UserGroupUpdateMutationVariables>(
		UserGroupUpdateDocument,
		options,
	);
}
export type UserGroupUpdateMutationHookResult = ReturnType<typeof useUserGroupUpdateMutation>;
export type UserGroupUpdateMutationResult = Apollo.MutationResult<UserGroupUpdateMutation>;
export type UserGroupUpdateMutationOptions = Apollo.BaseMutationOptions<
	UserGroupUpdateMutation,
	UserGroupUpdateMutationVariables
>;
export const UserViewRecordCountDocument = gql`
	query userViewRecordCount(
		$filters: [UserViewRecordFilterInput!]
		$pagination: Pagination
		$order: UserViewRecordOrder
	) {
		userViewRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useUserViewRecordCountQuery__
 *
 * To run a query within a React component, call `useUserViewRecordCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserViewRecordCountQuery(
	baseOptions?: Apollo.QueryHookOptions<UserViewRecordCountQuery, UserViewRecordCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordCountQuery, UserViewRecordCountQueryVariables>(
		UserViewRecordCountDocument,
		options,
	);
}
export function useUserViewRecordCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserViewRecordCountQuery, UserViewRecordCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserViewRecordCountQuery, UserViewRecordCountQueryVariables>(
		UserViewRecordCountDocument,
		options,
	);
}
export function useUserViewRecordCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserViewRecordCountQuery, UserViewRecordCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserViewRecordCountQuery, UserViewRecordCountQueryVariables>(
		UserViewRecordCountDocument,
		options,
	);
}
export type UserViewRecordCountQueryHookResult = ReturnType<typeof useUserViewRecordCountQuery>;
export type UserViewRecordCountLazyQueryHookResult = ReturnType<typeof useUserViewRecordCountLazyQuery>;
export type UserViewRecordCountSuspenseQueryHookResult = ReturnType<typeof useUserViewRecordCountSuspenseQuery>;
export type UserViewRecordCountQueryResult = Apollo.QueryResult<
	UserViewRecordCountQuery,
	UserViewRecordCountQueryVariables
>;
export const UserViewRecordCreateDocument = gql`
	mutation userViewRecordCreate($input: UserViewRecordCreateInput!) {
		createUserViewRecord(input: $input) {
			...UserViewRecordDetail
		}
	}
	${UserViewRecordDetailFragmentDoc}
`;
export type UserViewRecordCreateMutationFn = Apollo.MutationFunction<
	UserViewRecordCreateMutation,
	UserViewRecordCreateMutationVariables
>;

/**
 * __useUserViewRecordCreateMutation__
 *
 * To run a mutation, you first call `useUserViewRecordCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userViewRecordCreateMutation, { data, loading, error }] = useUserViewRecordCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserViewRecordCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<UserViewRecordCreateMutation, UserViewRecordCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UserViewRecordCreateMutation, UserViewRecordCreateMutationVariables>(
		UserViewRecordCreateDocument,
		options,
	);
}
export type UserViewRecordCreateMutationHookResult = ReturnType<typeof useUserViewRecordCreateMutation>;
export type UserViewRecordCreateMutationResult = Apollo.MutationResult<UserViewRecordCreateMutation>;
export type UserViewRecordCreateMutationOptions = Apollo.BaseMutationOptions<
	UserViewRecordCreateMutation,
	UserViewRecordCreateMutationVariables
>;
export const UserViewRecordDeleteDocument = gql`
	mutation userViewRecordDelete($id: ID!) {
		deleteUserViewRecord(id: $id)
	}
`;
export type UserViewRecordDeleteMutationFn = Apollo.MutationFunction<
	UserViewRecordDeleteMutation,
	UserViewRecordDeleteMutationVariables
>;

/**
 * __useUserViewRecordDeleteMutation__
 *
 * To run a mutation, you first call `useUserViewRecordDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userViewRecordDeleteMutation, { data, loading, error }] = useUserViewRecordDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserViewRecordDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<UserViewRecordDeleteMutation, UserViewRecordDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UserViewRecordDeleteMutation, UserViewRecordDeleteMutationVariables>(
		UserViewRecordDeleteDocument,
		options,
	);
}
export type UserViewRecordDeleteMutationHookResult = ReturnType<typeof useUserViewRecordDeleteMutation>;
export type UserViewRecordDeleteMutationResult = Apollo.MutationResult<UserViewRecordDeleteMutation>;
export type UserViewRecordDeleteMutationOptions = Apollo.BaseMutationOptions<
	UserViewRecordDeleteMutation,
	UserViewRecordDeleteMutationVariables
>;
export const UserViewRecordDetailDocument = gql`
	query userViewRecordDetail($id: ID!) {
		userViewRecord(id: $id) {
			...UserViewRecordDetail
		}
	}
	${UserViewRecordDetailFragmentDoc}
`;

/**
 * __useUserViewRecordDetailQuery__
 *
 * To run a query within a React component, call `useUserViewRecordDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserViewRecordDetailQuery(
	baseOptions: Apollo.QueryHookOptions<UserViewRecordDetailQuery, UserViewRecordDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordDetailQuery, UserViewRecordDetailQueryVariables>(
		UserViewRecordDetailDocument,
		options,
	);
}
export function useUserViewRecordDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserViewRecordDetailQuery, UserViewRecordDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserViewRecordDetailQuery, UserViewRecordDetailQueryVariables>(
		UserViewRecordDetailDocument,
		options,
	);
}
export function useUserViewRecordDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserViewRecordDetailQuery, UserViewRecordDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserViewRecordDetailQuery, UserViewRecordDetailQueryVariables>(
		UserViewRecordDetailDocument,
		options,
	);
}
export type UserViewRecordDetailQueryHookResult = ReturnType<typeof useUserViewRecordDetailQuery>;
export type UserViewRecordDetailLazyQueryHookResult = ReturnType<typeof useUserViewRecordDetailLazyQuery>;
export type UserViewRecordDetailSuspenseQueryHookResult = ReturnType<typeof useUserViewRecordDetailSuspenseQuery>;
export type UserViewRecordDetailQueryResult = Apollo.QueryResult<
	UserViewRecordDetailQuery,
	UserViewRecordDetailQueryVariables
>;
export const UserViewRecordIDsDocument = gql`
	query userViewRecordIDs(
		$filters: [UserViewRecordFilterInput!]
		$pagination: Pagination
		$order: UserViewRecordOrder
	) {
		userViewRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					targetID
				}
			}
		}
	}
`;

/**
 * __useUserViewRecordIDsQuery__
 *
 * To run a query within a React component, call `useUserViewRecordIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordIDsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserViewRecordIDsQuery(
	baseOptions?: Apollo.QueryHookOptions<UserViewRecordIDsQuery, UserViewRecordIDsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordIDsQuery, UserViewRecordIDsQueryVariables>(UserViewRecordIDsDocument, options);
}
export function useUserViewRecordIDsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserViewRecordIDsQuery, UserViewRecordIDsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserViewRecordIDsQuery, UserViewRecordIDsQueryVariables>(
		UserViewRecordIDsDocument,
		options,
	);
}
export function useUserViewRecordIDsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserViewRecordIDsQuery, UserViewRecordIDsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserViewRecordIDsQuery, UserViewRecordIDsQueryVariables>(
		UserViewRecordIDsDocument,
		options,
	);
}
export type UserViewRecordIDsQueryHookResult = ReturnType<typeof useUserViewRecordIDsQuery>;
export type UserViewRecordIDsLazyQueryHookResult = ReturnType<typeof useUserViewRecordIDsLazyQuery>;
export type UserViewRecordIDsSuspenseQueryHookResult = ReturnType<typeof useUserViewRecordIDsSuspenseQuery>;
export type UserViewRecordIDsQueryResult = Apollo.QueryResult<UserViewRecordIDsQuery, UserViewRecordIDsQueryVariables>;
export const UserViewRecordIndexDocument = gql`
	query userViewRecordIndex(
		$filters: [UserViewRecordFilterInput!]
		$pagination: Pagination
		$order: UserViewRecordOrder
	) {
		userViewRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					targetID
					firstViewedAt
					lastViewedAt
				}
			}
		}
	}
`;

/**
 * __useUserViewRecordIndexQuery__
 *
 * To run a query within a React component, call `useUserViewRecordIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserViewRecordIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<UserViewRecordIndexQuery, UserViewRecordIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordIndexQuery, UserViewRecordIndexQueryVariables>(
		UserViewRecordIndexDocument,
		options,
	);
}
export function useUserViewRecordIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserViewRecordIndexQuery, UserViewRecordIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserViewRecordIndexQuery, UserViewRecordIndexQueryVariables>(
		UserViewRecordIndexDocument,
		options,
	);
}
export function useUserViewRecordIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserViewRecordIndexQuery, UserViewRecordIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserViewRecordIndexQuery, UserViewRecordIndexQueryVariables>(
		UserViewRecordIndexDocument,
		options,
	);
}
export type UserViewRecordIndexQueryHookResult = ReturnType<typeof useUserViewRecordIndexQuery>;
export type UserViewRecordIndexLazyQueryHookResult = ReturnType<typeof useUserViewRecordIndexLazyQuery>;
export type UserViewRecordIndexSuspenseQueryHookResult = ReturnType<typeof useUserViewRecordIndexSuspenseQuery>;
export type UserViewRecordIndexQueryResult = Apollo.QueryResult<
	UserViewRecordIndexQuery,
	UserViewRecordIndexQueryVariables
>;
export const UserViewRecordNameDocument = gql`
	query userViewRecordName($id: ID!) {
		userViewRecord(id: $id) {
			id
			...UserViewRecordName
		}
	}
	${UserViewRecordNameFragmentDoc}
`;

/**
 * __useUserViewRecordNameQuery__
 *
 * To run a query within a React component, call `useUserViewRecordNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserViewRecordNameQuery(
	baseOptions: Apollo.QueryHookOptions<UserViewRecordNameQuery, UserViewRecordNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordNameQuery, UserViewRecordNameQueryVariables>(
		UserViewRecordNameDocument,
		options,
	);
}
export function useUserViewRecordNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserViewRecordNameQuery, UserViewRecordNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserViewRecordNameQuery, UserViewRecordNameQueryVariables>(
		UserViewRecordNameDocument,
		options,
	);
}
export function useUserViewRecordNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserViewRecordNameQuery, UserViewRecordNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserViewRecordNameQuery, UserViewRecordNameQueryVariables>(
		UserViewRecordNameDocument,
		options,
	);
}
export type UserViewRecordNameQueryHookResult = ReturnType<typeof useUserViewRecordNameQuery>;
export type UserViewRecordNameLazyQueryHookResult = ReturnType<typeof useUserViewRecordNameLazyQuery>;
export type UserViewRecordNameSuspenseQueryHookResult = ReturnType<typeof useUserViewRecordNameSuspenseQuery>;
export type UserViewRecordNameQueryResult = Apollo.QueryResult<
	UserViewRecordNameQuery,
	UserViewRecordNameQueryVariables
>;
export const UserViewRecordNamesDocument = gql`
	query userViewRecordNames(
		$filters: [UserViewRecordFilterInput!]
		$pagination: Pagination
		$order: UserViewRecordOrder
	) {
		userViewRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...UserViewRecordName
				}
			}
		}
	}
	${UserViewRecordNameFragmentDoc}
`;

/**
 * __useUserViewRecordNamesQuery__
 *
 * To run a query within a React component, call `useUserViewRecordNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserViewRecordNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<UserViewRecordNamesQuery, UserViewRecordNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordNamesQuery, UserViewRecordNamesQueryVariables>(
		UserViewRecordNamesDocument,
		options,
	);
}
export function useUserViewRecordNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserViewRecordNamesQuery, UserViewRecordNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserViewRecordNamesQuery, UserViewRecordNamesQueryVariables>(
		UserViewRecordNamesDocument,
		options,
	);
}
export function useUserViewRecordNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserViewRecordNamesQuery, UserViewRecordNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserViewRecordNamesQuery, UserViewRecordNamesQueryVariables>(
		UserViewRecordNamesDocument,
		options,
	);
}
export type UserViewRecordNamesQueryHookResult = ReturnType<typeof useUserViewRecordNamesQuery>;
export type UserViewRecordNamesLazyQueryHookResult = ReturnType<typeof useUserViewRecordNamesLazyQuery>;
export type UserViewRecordNamesSuspenseQueryHookResult = ReturnType<typeof useUserViewRecordNamesSuspenseQuery>;
export type UserViewRecordNamesQueryResult = Apollo.QueryResult<
	UserViewRecordNamesQuery,
	UserViewRecordNamesQueryVariables
>;
export const UserViewRecordPaginationDocument = gql`
	query userViewRecordPagination($filters: [UserViewRecordFilterInput!], $order: UserViewRecordOrder) {
		userViewRecordConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useUserViewRecordPaginationQuery__
 *
 * To run a query within a React component, call `useUserViewRecordPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserViewRecordPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<UserViewRecordPaginationQuery, UserViewRecordPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordPaginationQuery, UserViewRecordPaginationQueryVariables>(
		UserViewRecordPaginationDocument,
		options,
	);
}
export function useUserViewRecordPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserViewRecordPaginationQuery, UserViewRecordPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserViewRecordPaginationQuery, UserViewRecordPaginationQueryVariables>(
		UserViewRecordPaginationDocument,
		options,
	);
}
export function useUserViewRecordPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserViewRecordPaginationQuery, UserViewRecordPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserViewRecordPaginationQuery, UserViewRecordPaginationQueryVariables>(
		UserViewRecordPaginationDocument,
		options,
	);
}
export type UserViewRecordPaginationQueryHookResult = ReturnType<typeof useUserViewRecordPaginationQuery>;
export type UserViewRecordPaginationLazyQueryHookResult = ReturnType<typeof useUserViewRecordPaginationLazyQuery>;
export type UserViewRecordPaginationSuspenseQueryHookResult = ReturnType<
	typeof useUserViewRecordPaginationSuspenseQuery
>;
export type UserViewRecordPaginationQueryResult = Apollo.QueryResult<
	UserViewRecordPaginationQuery,
	UserViewRecordPaginationQueryVariables
>;
export const RecordViewDocument = gql`
	mutation recordView($id: ID!) {
		recordView(id: $id) {
			id
			targetID
			userID
			firstViewedAt
			lastViewedAt
		}
	}
`;
export type RecordViewMutationFn = Apollo.MutationFunction<RecordViewMutation, RecordViewMutationVariables>;

/**
 * __useRecordViewMutation__
 *
 * To run a mutation, you first call `useRecordViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordViewMutation, { data, loading, error }] = useRecordViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRecordViewMutation(
	baseOptions?: Apollo.MutationHookOptions<RecordViewMutation, RecordViewMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RecordViewMutation, RecordViewMutationVariables>(RecordViewDocument, options);
}
export type RecordViewMutationHookResult = ReturnType<typeof useRecordViewMutation>;
export type RecordViewMutationResult = Apollo.MutationResult<RecordViewMutation>;
export type RecordViewMutationOptions = Apollo.BaseMutationOptions<RecordViewMutation, RecordViewMutationVariables>;
export const RecordViewsDocument = gql`
	mutation recordViews($ids: [ID!]!) {
		recordViews(ids: $ids) {
			edges {
				node {
					id
					targetID
					userID
					firstViewedAt
					lastViewedAt
				}
			}
		}
	}
`;
export type RecordViewsMutationFn = Apollo.MutationFunction<RecordViewsMutation, RecordViewsMutationVariables>;

/**
 * __useRecordViewsMutation__
 *
 * To run a mutation, you first call `useRecordViewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordViewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordViewsMutation, { data, loading, error }] = useRecordViewsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRecordViewsMutation(
	baseOptions?: Apollo.MutationHookOptions<RecordViewsMutation, RecordViewsMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RecordViewsMutation, RecordViewsMutationVariables>(RecordViewsDocument, options);
}
export type RecordViewsMutationHookResult = ReturnType<typeof useRecordViewsMutation>;
export type RecordViewsMutationResult = Apollo.MutationResult<RecordViewsMutation>;
export type RecordViewsMutationOptions = Apollo.BaseMutationOptions<RecordViewsMutation, RecordViewsMutationVariables>;
export const UserViewRecordSelectDocument = gql`
	query userViewRecordSelect($filters: [UserViewRecordFilterInput!], $order: UserViewRecordOrder) {
		userViewRecordConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...UserViewRecordName
				}
			}
		}
	}
	${UserViewRecordNameFragmentDoc}
`;

/**
 * __useUserViewRecordSelectQuery__
 *
 * To run a query within a React component, call `useUserViewRecordSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserViewRecordSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<UserViewRecordSelectQuery, UserViewRecordSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordSelectQuery, UserViewRecordSelectQueryVariables>(
		UserViewRecordSelectDocument,
		options,
	);
}
export function useUserViewRecordSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserViewRecordSelectQuery, UserViewRecordSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserViewRecordSelectQuery, UserViewRecordSelectQueryVariables>(
		UserViewRecordSelectDocument,
		options,
	);
}
export function useUserViewRecordSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserViewRecordSelectQuery, UserViewRecordSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserViewRecordSelectQuery, UserViewRecordSelectQueryVariables>(
		UserViewRecordSelectDocument,
		options,
	);
}
export type UserViewRecordSelectQueryHookResult = ReturnType<typeof useUserViewRecordSelectQuery>;
export type UserViewRecordSelectLazyQueryHookResult = ReturnType<typeof useUserViewRecordSelectLazyQuery>;
export type UserViewRecordSelectSuspenseQueryHookResult = ReturnType<typeof useUserViewRecordSelectSuspenseQuery>;
export type UserViewRecordSelectQueryResult = Apollo.QueryResult<
	UserViewRecordSelectQuery,
	UserViewRecordSelectQueryVariables
>;
export const UserViewRecordListForTargetDocument = gql`
	query userViewRecordListForTarget(
		$filters: [UserViewRecordFilterInput!]
		$pagination: Pagination
		$order: UserViewRecordOrder
	) {
		userViewRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					targetID
					lastViewedAt
				}
			}
		}
	}
`;

/**
 * __useUserViewRecordListForTargetQuery__
 *
 * To run a query within a React component, call `useUserViewRecordListForTargetQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordListForTargetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordListForTargetQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserViewRecordListForTargetQuery(
	baseOptions?: Apollo.QueryHookOptions<UserViewRecordListForTargetQuery, UserViewRecordListForTargetQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordListForTargetQuery, UserViewRecordListForTargetQueryVariables>(
		UserViewRecordListForTargetDocument,
		options,
	);
}
export function useUserViewRecordListForTargetLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserViewRecordListForTargetQuery,
		UserViewRecordListForTargetQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserViewRecordListForTargetQuery, UserViewRecordListForTargetQueryVariables>(
		UserViewRecordListForTargetDocument,
		options,
	);
}
export function useUserViewRecordListForTargetSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		UserViewRecordListForTargetQuery,
		UserViewRecordListForTargetQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserViewRecordListForTargetQuery, UserViewRecordListForTargetQueryVariables>(
		UserViewRecordListForTargetDocument,
		options,
	);
}
export type UserViewRecordListForTargetQueryHookResult = ReturnType<typeof useUserViewRecordListForTargetQuery>;
export type UserViewRecordListForTargetLazyQueryHookResult = ReturnType<typeof useUserViewRecordListForTargetLazyQuery>;
export type UserViewRecordListForTargetSuspenseQueryHookResult = ReturnType<
	typeof useUserViewRecordListForTargetSuspenseQuery
>;
export type UserViewRecordListForTargetQueryResult = Apollo.QueryResult<
	UserViewRecordListForTargetQuery,
	UserViewRecordListForTargetQueryVariables
>;
export const UserViewRecordListForTargetWithUserDocument = gql`
	query userViewRecordListForTargetWithUser(
		$filters: [UserViewRecordFilterInput!]
		$pagination: Pagination
		$order: UserViewRecordOrder
	) {
		userViewRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					targetID
					lastViewedAt
					user {
						id
						...UserName
					}
				}
			}
		}
	}
	${UserNameFragmentDoc}
`;

/**
 * __useUserViewRecordListForTargetWithUserQuery__
 *
 * To run a query within a React component, call `useUserViewRecordListForTargetWithUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordListForTargetWithUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordListForTargetWithUserQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserViewRecordListForTargetWithUserQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UserViewRecordListForTargetWithUserQuery,
		UserViewRecordListForTargetWithUserQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordListForTargetWithUserQuery, UserViewRecordListForTargetWithUserQueryVariables>(
		UserViewRecordListForTargetWithUserDocument,
		options,
	);
}
export function useUserViewRecordListForTargetWithUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserViewRecordListForTargetWithUserQuery,
		UserViewRecordListForTargetWithUserQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UserViewRecordListForTargetWithUserQuery,
		UserViewRecordListForTargetWithUserQueryVariables
	>(UserViewRecordListForTargetWithUserDocument, options);
}
export function useUserViewRecordListForTargetWithUserSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		UserViewRecordListForTargetWithUserQuery,
		UserViewRecordListForTargetWithUserQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		UserViewRecordListForTargetWithUserQuery,
		UserViewRecordListForTargetWithUserQueryVariables
	>(UserViewRecordListForTargetWithUserDocument, options);
}
export type UserViewRecordListForTargetWithUserQueryHookResult = ReturnType<
	typeof useUserViewRecordListForTargetWithUserQuery
>;
export type UserViewRecordListForTargetWithUserLazyQueryHookResult = ReturnType<
	typeof useUserViewRecordListForTargetWithUserLazyQuery
>;
export type UserViewRecordListForTargetWithUserSuspenseQueryHookResult = ReturnType<
	typeof useUserViewRecordListForTargetWithUserSuspenseQuery
>;
export type UserViewRecordListForTargetWithUserQueryResult = Apollo.QueryResult<
	UserViewRecordListForTargetWithUserQuery,
	UserViewRecordListForTargetWithUserQueryVariables
>;
export const UserViewRecordUpdateDocument = gql`
	mutation userViewRecordUpdate($id: ID!, $input: UserViewRecordUpdateInput!) {
		updateUserViewRecord(id: $id, input: $input) {
			...UserViewRecordDetail
		}
	}
	${UserViewRecordDetailFragmentDoc}
`;
export type UserViewRecordUpdateMutationFn = Apollo.MutationFunction<
	UserViewRecordUpdateMutation,
	UserViewRecordUpdateMutationVariables
>;

/**
 * __useUserViewRecordUpdateMutation__
 *
 * To run a mutation, you first call `useUserViewRecordUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userViewRecordUpdateMutation, { data, loading, error }] = useUserViewRecordUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserViewRecordUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<UserViewRecordUpdateMutation, UserViewRecordUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UserViewRecordUpdateMutation, UserViewRecordUpdateMutationVariables>(
		UserViewRecordUpdateDocument,
		options,
	);
}
export type UserViewRecordUpdateMutationHookResult = ReturnType<typeof useUserViewRecordUpdateMutation>;
export type UserViewRecordUpdateMutationResult = Apollo.MutationResult<UserViewRecordUpdateMutation>;
export type UserViewRecordUpdateMutationOptions = Apollo.BaseMutationOptions<
	UserViewRecordUpdateMutation,
	UserViewRecordUpdateMutationVariables
>;
export const VaccineCountDocument = gql`
	query vaccineCount($filters: [VaccineFilterInput!], $pagination: Pagination, $order: VaccineOrder) {
		vaccineConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useVaccineCountQuery__
 *
 * To run a query within a React component, call `useVaccineCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaccineCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaccineCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useVaccineCountQuery(
	baseOptions?: Apollo.QueryHookOptions<VaccineCountQuery, VaccineCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<VaccineCountQuery, VaccineCountQueryVariables>(VaccineCountDocument, options);
}
export function useVaccineCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<VaccineCountQuery, VaccineCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<VaccineCountQuery, VaccineCountQueryVariables>(VaccineCountDocument, options);
}
export function useVaccineCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<VaccineCountQuery, VaccineCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<VaccineCountQuery, VaccineCountQueryVariables>(VaccineCountDocument, options);
}
export type VaccineCountQueryHookResult = ReturnType<typeof useVaccineCountQuery>;
export type VaccineCountLazyQueryHookResult = ReturnType<typeof useVaccineCountLazyQuery>;
export type VaccineCountSuspenseQueryHookResult = ReturnType<typeof useVaccineCountSuspenseQuery>;
export type VaccineCountQueryResult = Apollo.QueryResult<VaccineCountQuery, VaccineCountQueryVariables>;
export const VaccineCreateDocument = gql`
	mutation vaccineCreate($input: VaccineCreateInput!) {
		createVaccine(input: $input) {
			...VaccineDetail
		}
	}
	${VaccineDetailFragmentDoc}
`;
export type VaccineCreateMutationFn = Apollo.MutationFunction<VaccineCreateMutation, VaccineCreateMutationVariables>;

/**
 * __useVaccineCreateMutation__
 *
 * To run a mutation, you first call `useVaccineCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVaccineCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vaccineCreateMutation, { data, loading, error }] = useVaccineCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVaccineCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<VaccineCreateMutation, VaccineCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<VaccineCreateMutation, VaccineCreateMutationVariables>(VaccineCreateDocument, options);
}
export type VaccineCreateMutationHookResult = ReturnType<typeof useVaccineCreateMutation>;
export type VaccineCreateMutationResult = Apollo.MutationResult<VaccineCreateMutation>;
export type VaccineCreateMutationOptions = Apollo.BaseMutationOptions<
	VaccineCreateMutation,
	VaccineCreateMutationVariables
>;
export const VaccineDeleteDocument = gql`
	mutation vaccineDelete($id: ID!) {
		deleteVaccine(id: $id)
	}
`;
export type VaccineDeleteMutationFn = Apollo.MutationFunction<VaccineDeleteMutation, VaccineDeleteMutationVariables>;

/**
 * __useVaccineDeleteMutation__
 *
 * To run a mutation, you first call `useVaccineDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVaccineDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vaccineDeleteMutation, { data, loading, error }] = useVaccineDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVaccineDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<VaccineDeleteMutation, VaccineDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<VaccineDeleteMutation, VaccineDeleteMutationVariables>(VaccineDeleteDocument, options);
}
export type VaccineDeleteMutationHookResult = ReturnType<typeof useVaccineDeleteMutation>;
export type VaccineDeleteMutationResult = Apollo.MutationResult<VaccineDeleteMutation>;
export type VaccineDeleteMutationOptions = Apollo.BaseMutationOptions<
	VaccineDeleteMutation,
	VaccineDeleteMutationVariables
>;
export const VaccineDetailDocument = gql`
	query vaccineDetail($id: ID!) {
		vaccine(id: $id) {
			...VaccineDetail
		}
	}
	${VaccineDetailFragmentDoc}
`;

/**
 * __useVaccineDetailQuery__
 *
 * To run a query within a React component, call `useVaccineDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaccineDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaccineDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVaccineDetailQuery(
	baseOptions: Apollo.QueryHookOptions<VaccineDetailQuery, VaccineDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<VaccineDetailQuery, VaccineDetailQueryVariables>(VaccineDetailDocument, options);
}
export function useVaccineDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<VaccineDetailQuery, VaccineDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<VaccineDetailQuery, VaccineDetailQueryVariables>(VaccineDetailDocument, options);
}
export function useVaccineDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<VaccineDetailQuery, VaccineDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<VaccineDetailQuery, VaccineDetailQueryVariables>(VaccineDetailDocument, options);
}
export type VaccineDetailQueryHookResult = ReturnType<typeof useVaccineDetailQuery>;
export type VaccineDetailLazyQueryHookResult = ReturnType<typeof useVaccineDetailLazyQuery>;
export type VaccineDetailSuspenseQueryHookResult = ReturnType<typeof useVaccineDetailSuspenseQuery>;
export type VaccineDetailQueryResult = Apollo.QueryResult<VaccineDetailQuery, VaccineDetailQueryVariables>;
export const VaccineIndexDocument = gql`
	query vaccineIndex($filters: [VaccineFilterInput!], $pagination: Pagination, $order: VaccineOrder) {
		vaccineConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					description
				}
			}
		}
	}
`;

/**
 * __useVaccineIndexQuery__
 *
 * To run a query within a React component, call `useVaccineIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaccineIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaccineIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useVaccineIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<VaccineIndexQuery, VaccineIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<VaccineIndexQuery, VaccineIndexQueryVariables>(VaccineIndexDocument, options);
}
export function useVaccineIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<VaccineIndexQuery, VaccineIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<VaccineIndexQuery, VaccineIndexQueryVariables>(VaccineIndexDocument, options);
}
export function useVaccineIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<VaccineIndexQuery, VaccineIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<VaccineIndexQuery, VaccineIndexQueryVariables>(VaccineIndexDocument, options);
}
export type VaccineIndexQueryHookResult = ReturnType<typeof useVaccineIndexQuery>;
export type VaccineIndexLazyQueryHookResult = ReturnType<typeof useVaccineIndexLazyQuery>;
export type VaccineIndexSuspenseQueryHookResult = ReturnType<typeof useVaccineIndexSuspenseQuery>;
export type VaccineIndexQueryResult = Apollo.QueryResult<VaccineIndexQuery, VaccineIndexQueryVariables>;
export const VaccineNameDocument = gql`
	query vaccineName($id: ID!) {
		vaccine(id: $id) {
			id
			...VaccineName
		}
	}
	${VaccineNameFragmentDoc}
`;

/**
 * __useVaccineNameQuery__
 *
 * To run a query within a React component, call `useVaccineNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaccineNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaccineNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVaccineNameQuery(baseOptions: Apollo.QueryHookOptions<VaccineNameQuery, VaccineNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<VaccineNameQuery, VaccineNameQueryVariables>(VaccineNameDocument, options);
}
export function useVaccineNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<VaccineNameQuery, VaccineNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<VaccineNameQuery, VaccineNameQueryVariables>(VaccineNameDocument, options);
}
export function useVaccineNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<VaccineNameQuery, VaccineNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<VaccineNameQuery, VaccineNameQueryVariables>(VaccineNameDocument, options);
}
export type VaccineNameQueryHookResult = ReturnType<typeof useVaccineNameQuery>;
export type VaccineNameLazyQueryHookResult = ReturnType<typeof useVaccineNameLazyQuery>;
export type VaccineNameSuspenseQueryHookResult = ReturnType<typeof useVaccineNameSuspenseQuery>;
export type VaccineNameQueryResult = Apollo.QueryResult<VaccineNameQuery, VaccineNameQueryVariables>;
export const VaccineNamesDocument = gql`
	query vaccineNames($filters: [VaccineFilterInput!], $pagination: Pagination, $order: VaccineOrder) {
		vaccineConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...VaccineName
				}
			}
		}
	}
	${VaccineNameFragmentDoc}
`;

/**
 * __useVaccineNamesQuery__
 *
 * To run a query within a React component, call `useVaccineNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaccineNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaccineNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useVaccineNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<VaccineNamesQuery, VaccineNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<VaccineNamesQuery, VaccineNamesQueryVariables>(VaccineNamesDocument, options);
}
export function useVaccineNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<VaccineNamesQuery, VaccineNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<VaccineNamesQuery, VaccineNamesQueryVariables>(VaccineNamesDocument, options);
}
export function useVaccineNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<VaccineNamesQuery, VaccineNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<VaccineNamesQuery, VaccineNamesQueryVariables>(VaccineNamesDocument, options);
}
export type VaccineNamesQueryHookResult = ReturnType<typeof useVaccineNamesQuery>;
export type VaccineNamesLazyQueryHookResult = ReturnType<typeof useVaccineNamesLazyQuery>;
export type VaccineNamesSuspenseQueryHookResult = ReturnType<typeof useVaccineNamesSuspenseQuery>;
export type VaccineNamesQueryResult = Apollo.QueryResult<VaccineNamesQuery, VaccineNamesQueryVariables>;
export const VaccinePaginationDocument = gql`
	query vaccinePagination($filters: [VaccineFilterInput!], $order: VaccineOrder) {
		vaccineConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useVaccinePaginationQuery__
 *
 * To run a query within a React component, call `useVaccinePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaccinePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaccinePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useVaccinePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<VaccinePaginationQuery, VaccinePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<VaccinePaginationQuery, VaccinePaginationQueryVariables>(VaccinePaginationDocument, options);
}
export function useVaccinePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<VaccinePaginationQuery, VaccinePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<VaccinePaginationQuery, VaccinePaginationQueryVariables>(
		VaccinePaginationDocument,
		options,
	);
}
export function useVaccinePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<VaccinePaginationQuery, VaccinePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<VaccinePaginationQuery, VaccinePaginationQueryVariables>(
		VaccinePaginationDocument,
		options,
	);
}
export type VaccinePaginationQueryHookResult = ReturnType<typeof useVaccinePaginationQuery>;
export type VaccinePaginationLazyQueryHookResult = ReturnType<typeof useVaccinePaginationLazyQuery>;
export type VaccinePaginationSuspenseQueryHookResult = ReturnType<typeof useVaccinePaginationSuspenseQuery>;
export type VaccinePaginationQueryResult = Apollo.QueryResult<VaccinePaginationQuery, VaccinePaginationQueryVariables>;
export const VaccineSelectDocument = gql`
	query vaccineSelect($filters: [VaccineFilterInput!], $order: VaccineOrder) {
		vaccineConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...VaccineName
				}
			}
		}
	}
	${VaccineNameFragmentDoc}
`;

/**
 * __useVaccineSelectQuery__
 *
 * To run a query within a React component, call `useVaccineSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaccineSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaccineSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useVaccineSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<VaccineSelectQuery, VaccineSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<VaccineSelectQuery, VaccineSelectQueryVariables>(VaccineSelectDocument, options);
}
export function useVaccineSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<VaccineSelectQuery, VaccineSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<VaccineSelectQuery, VaccineSelectQueryVariables>(VaccineSelectDocument, options);
}
export function useVaccineSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<VaccineSelectQuery, VaccineSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<VaccineSelectQuery, VaccineSelectQueryVariables>(VaccineSelectDocument, options);
}
export type VaccineSelectQueryHookResult = ReturnType<typeof useVaccineSelectQuery>;
export type VaccineSelectLazyQueryHookResult = ReturnType<typeof useVaccineSelectLazyQuery>;
export type VaccineSelectSuspenseQueryHookResult = ReturnType<typeof useVaccineSelectSuspenseQuery>;
export type VaccineSelectQueryResult = Apollo.QueryResult<VaccineSelectQuery, VaccineSelectQueryVariables>;
export const VaccineUpdateDocument = gql`
	mutation vaccineUpdate($id: ID!, $input: VaccineUpdateInput!) {
		updateVaccine(id: $id, input: $input) {
			...VaccineDetail
		}
	}
	${VaccineDetailFragmentDoc}
`;
export type VaccineUpdateMutationFn = Apollo.MutationFunction<VaccineUpdateMutation, VaccineUpdateMutationVariables>;

/**
 * __useVaccineUpdateMutation__
 *
 * To run a mutation, you first call `useVaccineUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVaccineUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vaccineUpdateMutation, { data, loading, error }] = useVaccineUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVaccineUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<VaccineUpdateMutation, VaccineUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<VaccineUpdateMutation, VaccineUpdateMutationVariables>(VaccineUpdateDocument, options);
}
export type VaccineUpdateMutationHookResult = ReturnType<typeof useVaccineUpdateMutation>;
export type VaccineUpdateMutationResult = Apollo.MutationResult<VaccineUpdateMutation>;
export type VaccineUpdateMutationOptions = Apollo.BaseMutationOptions<
	VaccineUpdateMutation,
	VaccineUpdateMutationVariables
>;
export const AdmissionsReEnrollmentSummaryDocument = gql`
	query admissionsReEnrollmentSummary($filters: ContractFilterInput!) {
		incomplete: contractConnection(filters: { and: [$filters, { hasContractInstallments: false }] }) {
			totalCount
		}
		readyForReview: contractConnection(
			filters: { and: [$filters, { hasContractInstallments: true, isApprovedEQ: false, isFinalizedEQ: false }] }
		) {
			totalCount
		}
		approved: contractConnection(
			filters: { and: [$filters, { isApprovedEQ: true, isFinalizedEQ: false, signedFileKeyEQ: "" }] }
		) {
			totalCount
		}
		signed: contractConnection(
			filters: { and: [$filters, { or: [{ isFinalizedEQ: true }, { signedFileKeyNEQ: "" }] }] }
		) {
			totalCount
		}
	}
`;

/**
 * __useAdmissionsReEnrollmentSummaryQuery__
 *
 * To run a query within a React component, call `useAdmissionsReEnrollmentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdmissionsReEnrollmentSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdmissionsReEnrollmentSummaryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAdmissionsReEnrollmentSummaryQuery(
	baseOptions: Apollo.QueryHookOptions<AdmissionsReEnrollmentSummaryQuery, AdmissionsReEnrollmentSummaryQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AdmissionsReEnrollmentSummaryQuery, AdmissionsReEnrollmentSummaryQueryVariables>(
		AdmissionsReEnrollmentSummaryDocument,
		options,
	);
}
export function useAdmissionsReEnrollmentSummaryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		AdmissionsReEnrollmentSummaryQuery,
		AdmissionsReEnrollmentSummaryQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AdmissionsReEnrollmentSummaryQuery, AdmissionsReEnrollmentSummaryQueryVariables>(
		AdmissionsReEnrollmentSummaryDocument,
		options,
	);
}
export function useAdmissionsReEnrollmentSummarySuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		AdmissionsReEnrollmentSummaryQuery,
		AdmissionsReEnrollmentSummaryQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AdmissionsReEnrollmentSummaryQuery, AdmissionsReEnrollmentSummaryQueryVariables>(
		AdmissionsReEnrollmentSummaryDocument,
		options,
	);
}
export type AdmissionsReEnrollmentSummaryQueryHookResult = ReturnType<typeof useAdmissionsReEnrollmentSummaryQuery>;
export type AdmissionsReEnrollmentSummaryLazyQueryHookResult = ReturnType<
	typeof useAdmissionsReEnrollmentSummaryLazyQuery
>;
export type AdmissionsReEnrollmentSummarySuspenseQueryHookResult = ReturnType<
	typeof useAdmissionsReEnrollmentSummarySuspenseQuery
>;
export type AdmissionsReEnrollmentSummaryQueryResult = Apollo.QueryResult<
	AdmissionsReEnrollmentSummaryQuery,
	AdmissionsReEnrollmentSummaryQueryVariables
>;
export const StudentsWithContractsListDocument = gql`
	query studentsWithContractsList(
		$filters: [StudentFilterInput!]
		$pagination: Pagination
		$order: StudentOrder
		$contractFilters: [ContractFilterInput!]
	) {
		studentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentNameAndImage
					graduationYear
					yearsFromGraduation
					contracts(filters: $contractFilters) {
						id
						...ContractName
						status
						isApproved
						signedFileURL
						signedFileKey
						signedFileContentType
						contractLineItems(filters: { service: { categoryEQ: tuition } }) {
							id
							amount
						}
						contractInstallments {
							id
						}
					}
				}
			}
		}
	}
	${StudentNameAndImageFragmentDoc}
	${ContractNameFragmentDoc}
`;

/**
 * __useStudentsWithContractsListQuery__
 *
 * To run a query within a React component, call `useStudentsWithContractsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentsWithContractsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentsWithContractsListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *      contractFilters: // value for 'contractFilters'
 *   },
 * });
 */
export function useStudentsWithContractsListQuery(
	baseOptions?: Apollo.QueryHookOptions<StudentsWithContractsListQuery, StudentsWithContractsListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<StudentsWithContractsListQuery, StudentsWithContractsListQueryVariables>(
		StudentsWithContractsListDocument,
		options,
	);
}
export function useStudentsWithContractsListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<StudentsWithContractsListQuery, StudentsWithContractsListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<StudentsWithContractsListQuery, StudentsWithContractsListQueryVariables>(
		StudentsWithContractsListDocument,
		options,
	);
}
export function useStudentsWithContractsListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentsWithContractsListQuery,
		StudentsWithContractsListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<StudentsWithContractsListQuery, StudentsWithContractsListQueryVariables>(
		StudentsWithContractsListDocument,
		options,
	);
}
export type StudentsWithContractsListQueryHookResult = ReturnType<typeof useStudentsWithContractsListQuery>;
export type StudentsWithContractsListLazyQueryHookResult = ReturnType<typeof useStudentsWithContractsListLazyQuery>;
export type StudentsWithContractsListSuspenseQueryHookResult = ReturnType<
	typeof useStudentsWithContractsListSuspenseQuery
>;
export type StudentsWithContractsListQueryResult = Apollo.QueryResult<
	StudentsWithContractsListQuery,
	StudentsWithContractsListQueryVariables
>;
export const AdmissionsCenterReEnrollmentStudentDocument = gql`
	query admissionsCenterReEnrollmentStudent($id: ID!, $contractFilters: ContractFilterInput!) {
		studentConnection(filters: { idEQ: $id }) {
			edges {
				node {
					id
					...StudentNameAndImage
					graduationYear
					yearsFromGraduation
					relationships {
						id
						relationshipType
						isPrimary
						isFinancialContact
						isEmergencyContact
						isAuthorizedForPickup
						livesWithStudent
						hasCustody
						guardian {
							id
							person {
								id
								...PersonNameAndImage
								userID
								phoneNumbers(order: { field: IS_PRIMARY, direction: DESC }) {
									id
									name
									isPrimary
									phoneNumber
								}
								emailAddresses(order: { field: IS_PRIMARY, direction: DESC }) {
									id
									name
									isPrimary
									emailAddress
								}
								addresses {
									id
									...AddressInformation
								}
							}
						}
					}
					studentMedicalConditions(order: { field: IS_PROMINENT, direction: DESC }) {
						id
						medicalCondition {
							id
							...MedicalConditionName
							conditionType
						}
						isProminent
						notes
					}
					studentPrescriptionMedications {
						id
						medication {
							id
							...MedicationName
						}
						administration
						notes
						canSelfAdminister
					}
					studentOtcMedications {
						id
						medication {
							id
							...MedicationName
						}
						isAllowed
						notes
					}
					studentVaccinationRecords {
						id
						vaccine {
							id
							...VaccineName
						}
						receivedOn
						notes
					}
					studentDataConsents(order: { field: UPDATED_AT, direction: DESC }, pagination: { first: 1 }) {
						id
						...StudentDataConsentDetail
					}
				}
			}
		}
		contractConnection(filters: { and: [$contractFilters, { studentIDEQ: $id }] }) {
			edges {
				node {
					id
					...ContractName
					status
					isApproved
					fileURL
					signedFileURL
					signedFileKey
					signedFileContentType
					contractLineItems(order: { field: DISPLAY_ORDER, direction: ASC }) {
						id
						displayOrder
						amount
						dateAdded
						dateRemoved
						isDiscount
						service {
							id
							...ServiceName
						}
						discount {
							id
							...DiscountName
						}
						childContractLineItems(order: { field: DISPLAY_ORDER, direction: ASC }) {
							id
							amount
							isDiscount
							service {
								id
								...ServiceName
							}
							discount {
								id
								...DiscountName
							}
						}
					}
					contractInstallments(order: { field: DUE_DATE, direction: ASC }) {
						id
						dueDate
						portion
					}
				}
			}
		}
	}
	${StudentNameAndImageFragmentDoc}
	${PersonNameAndImageFragmentDoc}
	${AddressInformationFragmentDoc}
	${MedicalConditionNameFragmentDoc}
	${MedicationNameFragmentDoc}
	${VaccineNameFragmentDoc}
	${StudentDataConsentDetailFragmentDoc}
	${ContractNameFragmentDoc}
	${ServiceNameFragmentDoc}
	${DiscountNameFragmentDoc}
`;

/**
 * __useAdmissionsCenterReEnrollmentStudentQuery__
 *
 * To run a query within a React component, call `useAdmissionsCenterReEnrollmentStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdmissionsCenterReEnrollmentStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdmissionsCenterReEnrollmentStudentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      contractFilters: // value for 'contractFilters'
 *   },
 * });
 */
export function useAdmissionsCenterReEnrollmentStudentQuery(
	baseOptions: Apollo.QueryHookOptions<
		AdmissionsCenterReEnrollmentStudentQuery,
		AdmissionsCenterReEnrollmentStudentQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AdmissionsCenterReEnrollmentStudentQuery, AdmissionsCenterReEnrollmentStudentQueryVariables>(
		AdmissionsCenterReEnrollmentStudentDocument,
		options,
	);
}
export function useAdmissionsCenterReEnrollmentStudentLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		AdmissionsCenterReEnrollmentStudentQuery,
		AdmissionsCenterReEnrollmentStudentQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		AdmissionsCenterReEnrollmentStudentQuery,
		AdmissionsCenterReEnrollmentStudentQueryVariables
	>(AdmissionsCenterReEnrollmentStudentDocument, options);
}
export function useAdmissionsCenterReEnrollmentStudentSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		AdmissionsCenterReEnrollmentStudentQuery,
		AdmissionsCenterReEnrollmentStudentQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		AdmissionsCenterReEnrollmentStudentQuery,
		AdmissionsCenterReEnrollmentStudentQueryVariables
	>(AdmissionsCenterReEnrollmentStudentDocument, options);
}
export type AdmissionsCenterReEnrollmentStudentQueryHookResult = ReturnType<
	typeof useAdmissionsCenterReEnrollmentStudentQuery
>;
export type AdmissionsCenterReEnrollmentStudentLazyQueryHookResult = ReturnType<
	typeof useAdmissionsCenterReEnrollmentStudentLazyQuery
>;
export type AdmissionsCenterReEnrollmentStudentSuspenseQueryHookResult = ReturnType<
	typeof useAdmissionsCenterReEnrollmentStudentSuspenseQuery
>;
export type AdmissionsCenterReEnrollmentStudentQueryResult = Apollo.QueryResult<
	AdmissionsCenterReEnrollmentStudentQuery,
	AdmissionsCenterReEnrollmentStudentQueryVariables
>;
export const BirthdaysDocument = gql`
	query birthdays($dates: [Date!]!, $filters: [PersonFilterInput!], $pagination: Pagination, $order: PersonOrder) {
		personConnectionByBirthday(dates: $dates, filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...PersonNameAndImage
					givenName
					familyName
					dateOfBirth
					student {
						id
					}
					employee {
						id
					}
					guardian {
						id
					}
				}
			}
		}
	}
	${PersonNameAndImageFragmentDoc}
`;

/**
 * __useBirthdaysQuery__
 *
 * To run a query within a React component, call `useBirthdaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useBirthdaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBirthdaysQuery({
 *   variables: {
 *      dates: // value for 'dates'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBirthdaysQuery(baseOptions: Apollo.QueryHookOptions<BirthdaysQuery, BirthdaysQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BirthdaysQuery, BirthdaysQueryVariables>(BirthdaysDocument, options);
}
export function useBirthdaysLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BirthdaysQuery, BirthdaysQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BirthdaysQuery, BirthdaysQueryVariables>(BirthdaysDocument, options);
}
export function useBirthdaysSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BirthdaysQuery, BirthdaysQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BirthdaysQuery, BirthdaysQueryVariables>(BirthdaysDocument, options);
}
export type BirthdaysQueryHookResult = ReturnType<typeof useBirthdaysQuery>;
export type BirthdaysLazyQueryHookResult = ReturnType<typeof useBirthdaysLazyQuery>;
export type BirthdaysSuspenseQueryHookResult = ReturnType<typeof useBirthdaysSuspenseQuery>;
export type BirthdaysQueryResult = Apollo.QueryResult<BirthdaysQuery, BirthdaysQueryVariables>;
export const DailyReportSummaryDocument = gql`
	query dailyReportSummary(
		$date: Date!
		$calendarEventFilters: [CalendarEventFilterInput!]
		$studentNoteFilters: [StudentNoteFilterInput!]
		$academicTermID: ID!
	) {
		calendarEventConnection(filters: $calendarEventFilters) {
			totalCount
		}
		studentNoteConnection(filters: $studentNoteFilters) {
			totalCount
		}
		personConnectionByBirthday(
			dates: [$date]
			filters: [
				{ hasEmployee: true, employee: [{ or: [{ endDateIsNull: true }, { endDateGTE: $date }] }] }
				{
					hasStudent: true
					student: [
						{ studentAcademicTermEnrollments: [{ academicTerm: [{ startDateLTE: $date, endDateGTE: $date }] }] }
					]
				}
			]
		) {
			totalCount
		}
		studentConnection(
			filters: {
				studentAcademicTermEnrollments: {
					academicTermIDEQ: $academicTermID
					and: [
						{ or: [{ lateStartDateLTE: $date }, { lateStartDateIsNull: true }] }
						{ or: [{ earlyEndDateGTE: $date }, { earlyEndDateIsNull: true }] }
					]
				}
			}
		) {
			totalCount
		}
		classYearConnection {
			totalCount
		}
		employeeConnection(filters: { startDateLTE: $date, or: [{ endDateGT: $date }, { endDateIsNull: true }] }) {
			totalCount
		}
	}
`;

/**
 * __useDailyReportSummaryQuery__
 *
 * To run a query within a React component, call `useDailyReportSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyReportSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyReportSummaryQuery({
 *   variables: {
 *      date: // value for 'date'
 *      calendarEventFilters: // value for 'calendarEventFilters'
 *      studentNoteFilters: // value for 'studentNoteFilters'
 *      academicTermID: // value for 'academicTermID'
 *   },
 * });
 */
export function useDailyReportSummaryQuery(
	baseOptions: Apollo.QueryHookOptions<DailyReportSummaryQuery, DailyReportSummaryQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<DailyReportSummaryQuery, DailyReportSummaryQueryVariables>(
		DailyReportSummaryDocument,
		options,
	);
}
export function useDailyReportSummaryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<DailyReportSummaryQuery, DailyReportSummaryQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<DailyReportSummaryQuery, DailyReportSummaryQueryVariables>(
		DailyReportSummaryDocument,
		options,
	);
}
export function useDailyReportSummarySuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<DailyReportSummaryQuery, DailyReportSummaryQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<DailyReportSummaryQuery, DailyReportSummaryQueryVariables>(
		DailyReportSummaryDocument,
		options,
	);
}
export type DailyReportSummaryQueryHookResult = ReturnType<typeof useDailyReportSummaryQuery>;
export type DailyReportSummaryLazyQueryHookResult = ReturnType<typeof useDailyReportSummaryLazyQuery>;
export type DailyReportSummarySuspenseQueryHookResult = ReturnType<typeof useDailyReportSummarySuspenseQuery>;
export type DailyReportSummaryQueryResult = Apollo.QueryResult<
	DailyReportSummaryQuery,
	DailyReportSummaryQueryVariables
>;
export const GlobalSearchDocument = gql`
	query globalSearch($filters: [SearchResultFilterInput!]!) {
		searchResultConnection(filters: $filters, pagination: { first: 100 }) {
			edges {
				node {
					id
					name
					modelName
					searchText
				}
			}
		}
	}
`;

/**
 * __useGlobalSearchQuery__
 *
 * To run a query within a React component, call `useGlobalSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalSearchQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGlobalSearchQuery(
	baseOptions: Apollo.QueryHookOptions<GlobalSearchQuery, GlobalSearchQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GlobalSearchQuery, GlobalSearchQueryVariables>(GlobalSearchDocument, options);
}
export function useGlobalSearchLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GlobalSearchQuery, GlobalSearchQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GlobalSearchQuery, GlobalSearchQueryVariables>(GlobalSearchDocument, options);
}
export function useGlobalSearchSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<GlobalSearchQuery, GlobalSearchQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GlobalSearchQuery, GlobalSearchQueryVariables>(GlobalSearchDocument, options);
}
export type GlobalSearchQueryHookResult = ReturnType<typeof useGlobalSearchQuery>;
export type GlobalSearchLazyQueryHookResult = ReturnType<typeof useGlobalSearchLazyQuery>;
export type GlobalSearchSuspenseQueryHookResult = ReturnType<typeof useGlobalSearchSuspenseQuery>;
export type GlobalSearchQueryResult = Apollo.QueryResult<GlobalSearchQuery, GlobalSearchQueryVariables>;
export const HubsIndexPageSummaryDocument = gql`
	query hubsIndexPageSummary($date: Date!) {
		studentConnection(
			filters: {
				studentAcademicTermEnrollments: {
					academicTerm: { startDateLTE: $date, endDateGT: $date }
					and: [
						{ or: [{ lateStartDateLTE: $date }, { lateStartDateIsNull: true }] }
						{ or: [{ earlyEndDateGTE: $date }, { earlyEndDateIsNull: true }] }
					]
				}
			}
		) {
			totalCount
		}
		employeeConnection(
			filters: {
				and: [
					{ startDateLTE: $date, or: [{ endDateGT: $date }, { endDateIsNull: true }] }
					{
						or: [
							{
								teacherHomeRoomSectionEnrollments: {
									homeRoomSection: { academicTerm: { startDateLTE: $date, endDateGT: $date } }
								}
							}
							{
								teacherCourseSectionEnrollments: {
									courseSection: { academicTerm: { startDateLTE: $date, endDateGT: $date } }
								}
							}
						]
					}
				]
			}
		) {
			totalCount
		}
		announcementConnection {
			totalCount
		}
		newsletterConnection {
			totalCount
		}
		postConnection {
			totalCount
		}
		calendarEventConnection {
			totalCount
		}
	}
`;

/**
 * __useHubsIndexPageSummaryQuery__
 *
 * To run a query within a React component, call `useHubsIndexPageSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useHubsIndexPageSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHubsIndexPageSummaryQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useHubsIndexPageSummaryQuery(
	baseOptions: Apollo.QueryHookOptions<HubsIndexPageSummaryQuery, HubsIndexPageSummaryQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<HubsIndexPageSummaryQuery, HubsIndexPageSummaryQueryVariables>(
		HubsIndexPageSummaryDocument,
		options,
	);
}
export function useHubsIndexPageSummaryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<HubsIndexPageSummaryQuery, HubsIndexPageSummaryQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<HubsIndexPageSummaryQuery, HubsIndexPageSummaryQueryVariables>(
		HubsIndexPageSummaryDocument,
		options,
	);
}
export function useHubsIndexPageSummarySuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<HubsIndexPageSummaryQuery, HubsIndexPageSummaryQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<HubsIndexPageSummaryQuery, HubsIndexPageSummaryQueryVariables>(
		HubsIndexPageSummaryDocument,
		options,
	);
}
export type HubsIndexPageSummaryQueryHookResult = ReturnType<typeof useHubsIndexPageSummaryQuery>;
export type HubsIndexPageSummaryLazyQueryHookResult = ReturnType<typeof useHubsIndexPageSummaryLazyQuery>;
export type HubsIndexPageSummarySuspenseQueryHookResult = ReturnType<typeof useHubsIndexPageSummarySuspenseQuery>;
export type HubsIndexPageSummaryQueryResult = Apollo.QueryResult<
	HubsIndexPageSummaryQuery,
	HubsIndexPageSummaryQueryVariables
>;
export const ModelIDsDocument = gql`
	query modelIDs {
		modelIDs {
			modelName
			minID
			maxID
		}
	}
`;

/**
 * __useModelIDsQuery__
 *
 * To run a query within a React component, call `useModelIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelIDsQuery({
 *   variables: {
 *   },
 * });
 */
export function useModelIDsQuery(baseOptions?: Apollo.QueryHookOptions<ModelIDsQuery, ModelIDsQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ModelIDsQuery, ModelIDsQueryVariables>(ModelIDsDocument, options);
}
export function useModelIDsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelIDsQuery, ModelIDsQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ModelIDsQuery, ModelIDsQueryVariables>(ModelIDsDocument, options);
}
export function useModelIDsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ModelIDsQuery, ModelIDsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ModelIDsQuery, ModelIDsQueryVariables>(ModelIDsDocument, options);
}
export type ModelIDsQueryHookResult = ReturnType<typeof useModelIDsQuery>;
export type ModelIDsLazyQueryHookResult = ReturnType<typeof useModelIDsLazyQuery>;
export type ModelIDsSuspenseQueryHookResult = ReturnType<typeof useModelIDsSuspenseQuery>;
export type ModelIDsQueryResult = Apollo.QueryResult<ModelIDsQuery, ModelIDsQueryVariables>;
export const GuardianOnboardingSubmissionDocument = gql`
	mutation guardianOnboardingSubmission(
		$studentDataConsentInput: StudentDataConsentCreateInput
		$personInput: PersonUpdateInput
		$userInput: UserUpdateInput
	) {
		guardianOnboardingSubmission(
			studentDataConsentInput: $studentDataConsentInput
			personInput: $personInput
			userInput: $userInput
		)
	}
`;
export type GuardianOnboardingSubmissionMutationFn = Apollo.MutationFunction<
	GuardianOnboardingSubmissionMutation,
	GuardianOnboardingSubmissionMutationVariables
>;

/**
 * __useGuardianOnboardingSubmissionMutation__
 *
 * To run a mutation, you first call `useGuardianOnboardingSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGuardianOnboardingSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [guardianOnboardingSubmissionMutation, { data, loading, error }] = useGuardianOnboardingSubmissionMutation({
 *   variables: {
 *      studentDataConsentInput: // value for 'studentDataConsentInput'
 *      personInput: // value for 'personInput'
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useGuardianOnboardingSubmissionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		GuardianOnboardingSubmissionMutation,
		GuardianOnboardingSubmissionMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<GuardianOnboardingSubmissionMutation, GuardianOnboardingSubmissionMutationVariables>(
		GuardianOnboardingSubmissionDocument,
		options,
	);
}
export type GuardianOnboardingSubmissionMutationHookResult = ReturnType<typeof useGuardianOnboardingSubmissionMutation>;
export type GuardianOnboardingSubmissionMutationResult = Apollo.MutationResult<GuardianOnboardingSubmissionMutation>;
export type GuardianOnboardingSubmissionMutationOptions = Apollo.BaseMutationOptions<
	GuardianOnboardingSubmissionMutation,
	GuardianOnboardingSubmissionMutationVariables
>;
export const ReEnrollmentGuardiansOverviewDocument = gql`
	query reEnrollmentGuardiansOverview(
		$filters: [GuardianFilterInput!]
		$pagination: Pagination
		$order: GuardianOrder
	) {
		guardianConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					person {
						id
						...PersonNameAndImage
						phoneNumbers(order: { field: IS_PRIMARY, direction: DESC }) {
							id
							phoneNumber
						}
						emailAddresses(order: { field: IS_PRIMARY, direction: DESC }) {
							id
							emailAddress
						}
						addresses {
							id
							...AddressInformation
						}
					}
					relationships {
						id
						relationshipType
					}
				}
			}
		}
	}
	${PersonNameAndImageFragmentDoc}
	${AddressInformationFragmentDoc}
`;

/**
 * __useReEnrollmentGuardiansOverviewQuery__
 *
 * To run a query within a React component, call `useReEnrollmentGuardiansOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useReEnrollmentGuardiansOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReEnrollmentGuardiansOverviewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReEnrollmentGuardiansOverviewQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ReEnrollmentGuardiansOverviewQuery,
		ReEnrollmentGuardiansOverviewQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReEnrollmentGuardiansOverviewQuery, ReEnrollmentGuardiansOverviewQueryVariables>(
		ReEnrollmentGuardiansOverviewDocument,
		options,
	);
}
export function useReEnrollmentGuardiansOverviewLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReEnrollmentGuardiansOverviewQuery,
		ReEnrollmentGuardiansOverviewQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReEnrollmentGuardiansOverviewQuery, ReEnrollmentGuardiansOverviewQueryVariables>(
		ReEnrollmentGuardiansOverviewDocument,
		options,
	);
}
export function useReEnrollmentGuardiansOverviewSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReEnrollmentGuardiansOverviewQuery,
		ReEnrollmentGuardiansOverviewQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReEnrollmentGuardiansOverviewQuery, ReEnrollmentGuardiansOverviewQueryVariables>(
		ReEnrollmentGuardiansOverviewDocument,
		options,
	);
}
export type ReEnrollmentGuardiansOverviewQueryHookResult = ReturnType<typeof useReEnrollmentGuardiansOverviewQuery>;
export type ReEnrollmentGuardiansOverviewLazyQueryHookResult = ReturnType<
	typeof useReEnrollmentGuardiansOverviewLazyQuery
>;
export type ReEnrollmentGuardiansOverviewSuspenseQueryHookResult = ReturnType<
	typeof useReEnrollmentGuardiansOverviewSuspenseQuery
>;
export type ReEnrollmentGuardiansOverviewQueryResult = Apollo.QueryResult<
	ReEnrollmentGuardiansOverviewQuery,
	ReEnrollmentGuardiansOverviewQueryVariables
>;
export const ReEnrollmentGuardianDetailDocument = gql`
	query reEnrollmentGuardianDetail($id: ID!) {
		guardian(id: $id) {
			id
			person {
				id
				...PersonNameAndImage
				phoneNumbers(order: { field: IS_PRIMARY, direction: DESC }) {
					id
					name
					phoneNumber
					isPrimary
				}
				emailAddresses(order: { field: IS_PRIMARY, direction: DESC }) {
					id
					name
					emailAddress
					isPrimary
				}
				addresses {
					id
					name
					addressLine1
					addressLine2
					city
					postalCode
					stateOrProvince
					country {
						id
						...CountryName
					}
				}
			}
			relationships {
				id
				relationshipType
			}
		}
	}
	${PersonNameAndImageFragmentDoc}
	${CountryNameFragmentDoc}
`;

/**
 * __useReEnrollmentGuardianDetailQuery__
 *
 * To run a query within a React component, call `useReEnrollmentGuardianDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useReEnrollmentGuardianDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReEnrollmentGuardianDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReEnrollmentGuardianDetailQuery(
	baseOptions: Apollo.QueryHookOptions<ReEnrollmentGuardianDetailQuery, ReEnrollmentGuardianDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReEnrollmentGuardianDetailQuery, ReEnrollmentGuardianDetailQueryVariables>(
		ReEnrollmentGuardianDetailDocument,
		options,
	);
}
export function useReEnrollmentGuardianDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ReEnrollmentGuardianDetailQuery, ReEnrollmentGuardianDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReEnrollmentGuardianDetailQuery, ReEnrollmentGuardianDetailQueryVariables>(
		ReEnrollmentGuardianDetailDocument,
		options,
	);
}
export function useReEnrollmentGuardianDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReEnrollmentGuardianDetailQuery,
		ReEnrollmentGuardianDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReEnrollmentGuardianDetailQuery, ReEnrollmentGuardianDetailQueryVariables>(
		ReEnrollmentGuardianDetailDocument,
		options,
	);
}
export type ReEnrollmentGuardianDetailQueryHookResult = ReturnType<typeof useReEnrollmentGuardianDetailQuery>;
export type ReEnrollmentGuardianDetailLazyQueryHookResult = ReturnType<typeof useReEnrollmentGuardianDetailLazyQuery>;
export type ReEnrollmentGuardianDetailSuspenseQueryHookResult = ReturnType<
	typeof useReEnrollmentGuardianDetailSuspenseQuery
>;
export type ReEnrollmentGuardianDetailQueryResult = Apollo.QueryResult<
	ReEnrollmentGuardianDetailQuery,
	ReEnrollmentGuardianDetailQueryVariables
>;
export const ReEnrollmentStudentHealthOverviewDocument = gql`
	query reEnrollmentStudentHealthOverview(
		$filters: [StudentFilterInput!]
		$pagination: Pagination
		$order: StudentOrder
	) {
		studentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					person {
						id
						...PersonNameAndImage
						dateOfBirth
					}
					studentMedicalConditions(order: { field: IS_PROMINENT, direction: DESC }) {
						id
						medicalCondition {
							id
							...MedicalConditionName
							conditionType
						}
						isProminent
						notes
					}
					studentPrescriptionMedications {
						id
						medication {
							id
							...MedicationName
						}
						administration
						notes
						canSelfAdminister
					}
					studentOtcMedications {
						id
						medication {
							id
							...MedicationName
						}
						isAllowed
						notes
					}
					studentVaccinationRecords {
						id
						vaccine {
							id
							...VaccineName
						}
						receivedOn
						notes
					}
				}
			}
		}
	}
	${PersonNameAndImageFragmentDoc}
	${MedicalConditionNameFragmentDoc}
	${MedicationNameFragmentDoc}
	${VaccineNameFragmentDoc}
`;

/**
 * __useReEnrollmentStudentHealthOverviewQuery__
 *
 * To run a query within a React component, call `useReEnrollmentStudentHealthOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useReEnrollmentStudentHealthOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReEnrollmentStudentHealthOverviewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReEnrollmentStudentHealthOverviewQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ReEnrollmentStudentHealthOverviewQuery,
		ReEnrollmentStudentHealthOverviewQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReEnrollmentStudentHealthOverviewQuery, ReEnrollmentStudentHealthOverviewQueryVariables>(
		ReEnrollmentStudentHealthOverviewDocument,
		options,
	);
}
export function useReEnrollmentStudentHealthOverviewLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReEnrollmentStudentHealthOverviewQuery,
		ReEnrollmentStudentHealthOverviewQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReEnrollmentStudentHealthOverviewQuery, ReEnrollmentStudentHealthOverviewQueryVariables>(
		ReEnrollmentStudentHealthOverviewDocument,
		options,
	);
}
export function useReEnrollmentStudentHealthOverviewSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReEnrollmentStudentHealthOverviewQuery,
		ReEnrollmentStudentHealthOverviewQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ReEnrollmentStudentHealthOverviewQuery,
		ReEnrollmentStudentHealthOverviewQueryVariables
	>(ReEnrollmentStudentHealthOverviewDocument, options);
}
export type ReEnrollmentStudentHealthOverviewQueryHookResult = ReturnType<
	typeof useReEnrollmentStudentHealthOverviewQuery
>;
export type ReEnrollmentStudentHealthOverviewLazyQueryHookResult = ReturnType<
	typeof useReEnrollmentStudentHealthOverviewLazyQuery
>;
export type ReEnrollmentStudentHealthOverviewSuspenseQueryHookResult = ReturnType<
	typeof useReEnrollmentStudentHealthOverviewSuspenseQuery
>;
export type ReEnrollmentStudentHealthOverviewQueryResult = Apollo.QueryResult<
	ReEnrollmentStudentHealthOverviewQuery,
	ReEnrollmentStudentHealthOverviewQueryVariables
>;
export const ReEnrollmentStudentHealthDetailDocument = gql`
	query reEnrollmentStudentHealthDetail($id: ID!) {
		student(id: $id) {
			id
			person {
				id
				...PersonNameAndImage
				dateOfBirth
			}
			studentMedicalConditions(order: { field: IS_PROMINENT, direction: DESC }) {
				id
				medicalCondition {
					id
					...MedicalConditionName
					conditionType
				}
				isProminent
				notes
			}
			studentPrescriptionMedications {
				id
				medication {
					id
					...MedicationName
				}
				administration
				notes
				canSelfAdminister
			}
			studentOtcMedications {
				id
				medication {
					id
					...MedicationName
				}
				isAllowed
				notes
			}
			studentVaccinationRecords {
				id
				vaccine {
					id
					...VaccineName
				}
				receivedOn
				notes
			}
		}
	}
	${PersonNameAndImageFragmentDoc}
	${MedicalConditionNameFragmentDoc}
	${MedicationNameFragmentDoc}
	${VaccineNameFragmentDoc}
`;

/**
 * __useReEnrollmentStudentHealthDetailQuery__
 *
 * To run a query within a React component, call `useReEnrollmentStudentHealthDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useReEnrollmentStudentHealthDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReEnrollmentStudentHealthDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReEnrollmentStudentHealthDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		ReEnrollmentStudentHealthDetailQuery,
		ReEnrollmentStudentHealthDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReEnrollmentStudentHealthDetailQuery, ReEnrollmentStudentHealthDetailQueryVariables>(
		ReEnrollmentStudentHealthDetailDocument,
		options,
	);
}
export function useReEnrollmentStudentHealthDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReEnrollmentStudentHealthDetailQuery,
		ReEnrollmentStudentHealthDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReEnrollmentStudentHealthDetailQuery, ReEnrollmentStudentHealthDetailQueryVariables>(
		ReEnrollmentStudentHealthDetailDocument,
		options,
	);
}
export function useReEnrollmentStudentHealthDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReEnrollmentStudentHealthDetailQuery,
		ReEnrollmentStudentHealthDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReEnrollmentStudentHealthDetailQuery, ReEnrollmentStudentHealthDetailQueryVariables>(
		ReEnrollmentStudentHealthDetailDocument,
		options,
	);
}
export type ReEnrollmentStudentHealthDetailQueryHookResult = ReturnType<typeof useReEnrollmentStudentHealthDetailQuery>;
export type ReEnrollmentStudentHealthDetailLazyQueryHookResult = ReturnType<
	typeof useReEnrollmentStudentHealthDetailLazyQuery
>;
export type ReEnrollmentStudentHealthDetailSuspenseQueryHookResult = ReturnType<
	typeof useReEnrollmentStudentHealthDetailSuspenseQuery
>;
export type ReEnrollmentStudentHealthDetailQueryResult = Apollo.QueryResult<
	ReEnrollmentStudentHealthDetailQuery,
	ReEnrollmentStudentHealthDetailQueryVariables
>;
export const CreateOrUpdateRecentStudentDataConsentsDocument = gql`
	mutation createOrUpdateRecentStudentDataConsents(
		$studentDataConsentInput: StudentDataConsentCreateInput!
		$studentIDs: [ID!]!
	) {
		createOrUpdateRecentStudentDataConsents(studentDataConsentInput: $studentDataConsentInput, studentIDs: $studentIDs)
	}
`;
export type CreateOrUpdateRecentStudentDataConsentsMutationFn = Apollo.MutationFunction<
	CreateOrUpdateRecentStudentDataConsentsMutation,
	CreateOrUpdateRecentStudentDataConsentsMutationVariables
>;

/**
 * __useCreateOrUpdateRecentStudentDataConsentsMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateRecentStudentDataConsentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateRecentStudentDataConsentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateRecentStudentDataConsentsMutation, { data, loading, error }] = useCreateOrUpdateRecentStudentDataConsentsMutation({
 *   variables: {
 *      studentDataConsentInput: // value for 'studentDataConsentInput'
 *      studentIDs: // value for 'studentIDs'
 *   },
 * });
 */
export function useCreateOrUpdateRecentStudentDataConsentsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CreateOrUpdateRecentStudentDataConsentsMutation,
		CreateOrUpdateRecentStudentDataConsentsMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		CreateOrUpdateRecentStudentDataConsentsMutation,
		CreateOrUpdateRecentStudentDataConsentsMutationVariables
	>(CreateOrUpdateRecentStudentDataConsentsDocument, options);
}
export type CreateOrUpdateRecentStudentDataConsentsMutationHookResult = ReturnType<
	typeof useCreateOrUpdateRecentStudentDataConsentsMutation
>;
export type CreateOrUpdateRecentStudentDataConsentsMutationResult =
	Apollo.MutationResult<CreateOrUpdateRecentStudentDataConsentsMutation>;
export type CreateOrUpdateRecentStudentDataConsentsMutationOptions = Apollo.BaseMutationOptions<
	CreateOrUpdateRecentStudentDataConsentsMutation,
	CreateOrUpdateRecentStudentDataConsentsMutationVariables
>;
export const ReEnrollmentMealPlanContractListDocument = gql`
	query reEnrollmentMealPlanContractList(
		$filters: [ContractFilterInput!]
		$pagination: Pagination
		$order: ContractOrder
	) {
		contractConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					status
					student {
						id
						...StudentNameAndImage
						graduationYear
						yearsFromGraduation
					}
					contractLineItems(filters: { service: { categoryEQ: meal_plan } }) {
						id
						serviceID
					}
				}
			}
		}
	}
	${StudentNameAndImageFragmentDoc}
`;

/**
 * __useReEnrollmentMealPlanContractListQuery__
 *
 * To run a query within a React component, call `useReEnrollmentMealPlanContractListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReEnrollmentMealPlanContractListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReEnrollmentMealPlanContractListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReEnrollmentMealPlanContractListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ReEnrollmentMealPlanContractListQuery,
		ReEnrollmentMealPlanContractListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReEnrollmentMealPlanContractListQuery, ReEnrollmentMealPlanContractListQueryVariables>(
		ReEnrollmentMealPlanContractListDocument,
		options,
	);
}
export function useReEnrollmentMealPlanContractListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReEnrollmentMealPlanContractListQuery,
		ReEnrollmentMealPlanContractListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReEnrollmentMealPlanContractListQuery, ReEnrollmentMealPlanContractListQueryVariables>(
		ReEnrollmentMealPlanContractListDocument,
		options,
	);
}
export function useReEnrollmentMealPlanContractListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReEnrollmentMealPlanContractListQuery,
		ReEnrollmentMealPlanContractListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReEnrollmentMealPlanContractListQuery, ReEnrollmentMealPlanContractListQueryVariables>(
		ReEnrollmentMealPlanContractListDocument,
		options,
	);
}
export type ReEnrollmentMealPlanContractListQueryHookResult = ReturnType<
	typeof useReEnrollmentMealPlanContractListQuery
>;
export type ReEnrollmentMealPlanContractListLazyQueryHookResult = ReturnType<
	typeof useReEnrollmentMealPlanContractListLazyQuery
>;
export type ReEnrollmentMealPlanContractListSuspenseQueryHookResult = ReturnType<
	typeof useReEnrollmentMealPlanContractListSuspenseQuery
>;
export type ReEnrollmentMealPlanContractListQueryResult = Apollo.QueryResult<
	ReEnrollmentMealPlanContractListQuery,
	ReEnrollmentMealPlanContractListQueryVariables
>;
export const SetMealPlanOnContractDocument = gql`
	mutation setMealPlanOnContract($contractID: ID!, $mealPlanID: ID!) {
		setMealPlanOnContract(contractID: $contractID, mealPlanID: $mealPlanID)
	}
`;
export type SetMealPlanOnContractMutationFn = Apollo.MutationFunction<
	SetMealPlanOnContractMutation,
	SetMealPlanOnContractMutationVariables
>;

/**
 * __useSetMealPlanOnContractMutation__
 *
 * To run a mutation, you first call `useSetMealPlanOnContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMealPlanOnContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMealPlanOnContractMutation, { data, loading, error }] = useSetMealPlanOnContractMutation({
 *   variables: {
 *      contractID: // value for 'contractID'
 *      mealPlanID: // value for 'mealPlanID'
 *   },
 * });
 */
export function useSetMealPlanOnContractMutation(
	baseOptions?: Apollo.MutationHookOptions<SetMealPlanOnContractMutation, SetMealPlanOnContractMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SetMealPlanOnContractMutation, SetMealPlanOnContractMutationVariables>(
		SetMealPlanOnContractDocument,
		options,
	);
}
export type SetMealPlanOnContractMutationHookResult = ReturnType<typeof useSetMealPlanOnContractMutation>;
export type SetMealPlanOnContractMutationResult = Apollo.MutationResult<SetMealPlanOnContractMutation>;
export type SetMealPlanOnContractMutationOptions = Apollo.BaseMutationOptions<
	SetMealPlanOnContractMutation,
	SetMealPlanOnContractMutationVariables
>;
export const RemoveMealPlanFromContractDocument = gql`
	mutation removeMealPlanFromContract($contractID: ID!) {
		removeMealPlanFromContract(contractID: $contractID)
	}
`;
export type RemoveMealPlanFromContractMutationFn = Apollo.MutationFunction<
	RemoveMealPlanFromContractMutation,
	RemoveMealPlanFromContractMutationVariables
>;

/**
 * __useRemoveMealPlanFromContractMutation__
 *
 * To run a mutation, you first call `useRemoveMealPlanFromContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMealPlanFromContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMealPlanFromContractMutation, { data, loading, error }] = useRemoveMealPlanFromContractMutation({
 *   variables: {
 *      contractID: // value for 'contractID'
 *   },
 * });
 */
export function useRemoveMealPlanFromContractMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RemoveMealPlanFromContractMutation,
		RemoveMealPlanFromContractMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RemoveMealPlanFromContractMutation, RemoveMealPlanFromContractMutationVariables>(
		RemoveMealPlanFromContractDocument,
		options,
	);
}
export type RemoveMealPlanFromContractMutationHookResult = ReturnType<typeof useRemoveMealPlanFromContractMutation>;
export type RemoveMealPlanFromContractMutationResult = Apollo.MutationResult<RemoveMealPlanFromContractMutation>;
export type RemoveMealPlanFromContractMutationOptions = Apollo.BaseMutationOptions<
	RemoveMealPlanFromContractMutation,
	RemoveMealPlanFromContractMutationVariables
>;
export const ReEnrollmentPaymentPlanContractListDocument = gql`
	query reEnrollmentPaymentPlanContractList(
		$filters: [ContractFilterInput!]
		$pagination: Pagination
		$order: ContractOrder
	) {
		contractConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					status
					effectiveDate
					dateVoided
					student {
						id
						...StudentNameAndImage
					}
					contractLineItems(order: { field: DISPLAY_ORDER, direction: ASC }) {
						id
						displayOrder
						amount
						dateAdded
						dateRemoved
						isDiscount
						service {
							id
							...ServiceName
						}
						discount {
							id
							...DiscountName
						}
						childContractLineItems(order: { field: DISPLAY_ORDER, direction: ASC }) {
							id
							amount
							isDiscount
							service {
								id
								...ServiceName
							}
							discount {
								id
								...DiscountName
							}
						}
					}
					contractInstallments(order: { field: DUE_DATE, direction: ASC }) {
						id
						dueDate
						portion
					}
				}
			}
		}
	}
	${StudentNameAndImageFragmentDoc}
	${ServiceNameFragmentDoc}
	${DiscountNameFragmentDoc}
`;

/**
 * __useReEnrollmentPaymentPlanContractListQuery__
 *
 * To run a query within a React component, call `useReEnrollmentPaymentPlanContractListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReEnrollmentPaymentPlanContractListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReEnrollmentPaymentPlanContractListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReEnrollmentPaymentPlanContractListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ReEnrollmentPaymentPlanContractListQuery,
		ReEnrollmentPaymentPlanContractListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReEnrollmentPaymentPlanContractListQuery, ReEnrollmentPaymentPlanContractListQueryVariables>(
		ReEnrollmentPaymentPlanContractListDocument,
		options,
	);
}
export function useReEnrollmentPaymentPlanContractListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReEnrollmentPaymentPlanContractListQuery,
		ReEnrollmentPaymentPlanContractListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReEnrollmentPaymentPlanContractListQuery,
		ReEnrollmentPaymentPlanContractListQueryVariables
	>(ReEnrollmentPaymentPlanContractListDocument, options);
}
export function useReEnrollmentPaymentPlanContractListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReEnrollmentPaymentPlanContractListQuery,
		ReEnrollmentPaymentPlanContractListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ReEnrollmentPaymentPlanContractListQuery,
		ReEnrollmentPaymentPlanContractListQueryVariables
	>(ReEnrollmentPaymentPlanContractListDocument, options);
}
export type ReEnrollmentPaymentPlanContractListQueryHookResult = ReturnType<
	typeof useReEnrollmentPaymentPlanContractListQuery
>;
export type ReEnrollmentPaymentPlanContractListLazyQueryHookResult = ReturnType<
	typeof useReEnrollmentPaymentPlanContractListLazyQuery
>;
export type ReEnrollmentPaymentPlanContractListSuspenseQueryHookResult = ReturnType<
	typeof useReEnrollmentPaymentPlanContractListSuspenseQuery
>;
export type ReEnrollmentPaymentPlanContractListQueryResult = Apollo.QueryResult<
	ReEnrollmentPaymentPlanContractListQuery,
	ReEnrollmentPaymentPlanContractListQueryVariables
>;
export const SetPaymentPlanOnContractDocument = gql`
	mutation setPaymentPlanOnContract($contractID: ID!, $numPayments: Int!) {
		setPaymentPlanOnContract(contractID: $contractID, numPayments: $numPayments)
	}
`;
export type SetPaymentPlanOnContractMutationFn = Apollo.MutationFunction<
	SetPaymentPlanOnContractMutation,
	SetPaymentPlanOnContractMutationVariables
>;

/**
 * __useSetPaymentPlanOnContractMutation__
 *
 * To run a mutation, you first call `useSetPaymentPlanOnContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPaymentPlanOnContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPaymentPlanOnContractMutation, { data, loading, error }] = useSetPaymentPlanOnContractMutation({
 *   variables: {
 *      contractID: // value for 'contractID'
 *      numPayments: // value for 'numPayments'
 *   },
 * });
 */
export function useSetPaymentPlanOnContractMutation(
	baseOptions?: Apollo.MutationHookOptions<SetPaymentPlanOnContractMutation, SetPaymentPlanOnContractMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SetPaymentPlanOnContractMutation, SetPaymentPlanOnContractMutationVariables>(
		SetPaymentPlanOnContractDocument,
		options,
	);
}
export type SetPaymentPlanOnContractMutationHookResult = ReturnType<typeof useSetPaymentPlanOnContractMutation>;
export type SetPaymentPlanOnContractMutationResult = Apollo.MutationResult<SetPaymentPlanOnContractMutation>;
export type SetPaymentPlanOnContractMutationOptions = Apollo.BaseMutationOptions<
	SetPaymentPlanOnContractMutation,
	SetPaymentPlanOnContractMutationVariables
>;
export const ReEnrollmentReviewDocument = gql`
	query reEnrollmentReview($studentFilters: [StudentFilterInput!], $contractFilters: [ContractFilterInput!]) {
		studentConnection(filters: $studentFilters) {
			edges {
				node {
					id
					person {
						id
						...PersonNameAndImage
						dateOfBirth
					}
					graduationYear
					yearsFromGraduation
					contracts(filters: $contractFilters) {
						id
						contractLineItems {
							id
							service {
								id
								...ServiceName
								category
							}
							isDiscount
							amount
							childContractLineItems {
								id
								isDiscount
								amount
							}
						}
						contractInstallments {
							id
							dueDate
							portion
						}
					}
				}
			}
		}
	}
	${PersonNameAndImageFragmentDoc}
	${ServiceNameFragmentDoc}
`;

/**
 * __useReEnrollmentReviewQuery__
 *
 * To run a query within a React component, call `useReEnrollmentReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useReEnrollmentReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReEnrollmentReviewQuery({
 *   variables: {
 *      studentFilters: // value for 'studentFilters'
 *      contractFilters: // value for 'contractFilters'
 *   },
 * });
 */
export function useReEnrollmentReviewQuery(
	baseOptions?: Apollo.QueryHookOptions<ReEnrollmentReviewQuery, ReEnrollmentReviewQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReEnrollmentReviewQuery, ReEnrollmentReviewQueryVariables>(
		ReEnrollmentReviewDocument,
		options,
	);
}
export function useReEnrollmentReviewLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ReEnrollmentReviewQuery, ReEnrollmentReviewQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReEnrollmentReviewQuery, ReEnrollmentReviewQueryVariables>(
		ReEnrollmentReviewDocument,
		options,
	);
}
export function useReEnrollmentReviewSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ReEnrollmentReviewQuery, ReEnrollmentReviewQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReEnrollmentReviewQuery, ReEnrollmentReviewQueryVariables>(
		ReEnrollmentReviewDocument,
		options,
	);
}
export type ReEnrollmentReviewQueryHookResult = ReturnType<typeof useReEnrollmentReviewQuery>;
export type ReEnrollmentReviewLazyQueryHookResult = ReturnType<typeof useReEnrollmentReviewLazyQuery>;
export type ReEnrollmentReviewSuspenseQueryHookResult = ReturnType<typeof useReEnrollmentReviewSuspenseQuery>;
export type ReEnrollmentReviewQueryResult = Apollo.QueryResult<
	ReEnrollmentReviewQuery,
	ReEnrollmentReviewQueryVariables
>;
export const ReEnrollmentNoticeDocument = gql`
	query reEnrollmentNotice($studentFilters: [StudentFilterInput!], $contractFilters: [ContractFilterInput!]) {
		studentConnection(filters: $studentFilters) {
			edges {
				node {
					id
					contracts(filters: $contractFilters) {
						id
						contractInstallments {
							id
						}
					}
				}
			}
		}
	}
`;

/**
 * __useReEnrollmentNoticeQuery__
 *
 * To run a query within a React component, call `useReEnrollmentNoticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useReEnrollmentNoticeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReEnrollmentNoticeQuery({
 *   variables: {
 *      studentFilters: // value for 'studentFilters'
 *      contractFilters: // value for 'contractFilters'
 *   },
 * });
 */
export function useReEnrollmentNoticeQuery(
	baseOptions?: Apollo.QueryHookOptions<ReEnrollmentNoticeQuery, ReEnrollmentNoticeQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReEnrollmentNoticeQuery, ReEnrollmentNoticeQueryVariables>(
		ReEnrollmentNoticeDocument,
		options,
	);
}
export function useReEnrollmentNoticeLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ReEnrollmentNoticeQuery, ReEnrollmentNoticeQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ReEnrollmentNoticeQuery, ReEnrollmentNoticeQueryVariables>(
		ReEnrollmentNoticeDocument,
		options,
	);
}
export function useReEnrollmentNoticeSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ReEnrollmentNoticeQuery, ReEnrollmentNoticeQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ReEnrollmentNoticeQuery, ReEnrollmentNoticeQueryVariables>(
		ReEnrollmentNoticeDocument,
		options,
	);
}
export type ReEnrollmentNoticeQueryHookResult = ReturnType<typeof useReEnrollmentNoticeQuery>;
export type ReEnrollmentNoticeLazyQueryHookResult = ReturnType<typeof useReEnrollmentNoticeLazyQuery>;
export type ReEnrollmentNoticeSuspenseQueryHookResult = ReturnType<typeof useReEnrollmentNoticeSuspenseQuery>;
export type ReEnrollmentNoticeQueryResult = Apollo.QueryResult<
	ReEnrollmentNoticeQuery,
	ReEnrollmentNoticeQueryVariables
>;
export const ParentPortalReEnrollmentContractsDocument = gql`
	query parentPortalReEnrollmentContracts($filters: [ContractFilterInput!]!) {
		contractConnection(filters: $filters) {
			edges {
				node {
					id
					name
					status
					fileURL
					fileKey
					fileContentType
					student {
						id
						...StudentNameAndImage
					}
				}
			}
		}
	}
	${StudentNameAndImageFragmentDoc}
`;

/**
 * __useParentPortalReEnrollmentContractsQuery__
 *
 * To run a query within a React component, call `useParentPortalReEnrollmentContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useParentPortalReEnrollmentContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParentPortalReEnrollmentContractsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useParentPortalReEnrollmentContractsQuery(
	baseOptions: Apollo.QueryHookOptions<
		ParentPortalReEnrollmentContractsQuery,
		ParentPortalReEnrollmentContractsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ParentPortalReEnrollmentContractsQuery, ParentPortalReEnrollmentContractsQueryVariables>(
		ParentPortalReEnrollmentContractsDocument,
		options,
	);
}
export function useParentPortalReEnrollmentContractsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ParentPortalReEnrollmentContractsQuery,
		ParentPortalReEnrollmentContractsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ParentPortalReEnrollmentContractsQuery, ParentPortalReEnrollmentContractsQueryVariables>(
		ParentPortalReEnrollmentContractsDocument,
		options,
	);
}
export function useParentPortalReEnrollmentContractsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ParentPortalReEnrollmentContractsQuery,
		ParentPortalReEnrollmentContractsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ParentPortalReEnrollmentContractsQuery,
		ParentPortalReEnrollmentContractsQueryVariables
	>(ParentPortalReEnrollmentContractsDocument, options);
}
export type ParentPortalReEnrollmentContractsQueryHookResult = ReturnType<
	typeof useParentPortalReEnrollmentContractsQuery
>;
export type ParentPortalReEnrollmentContractsLazyQueryHookResult = ReturnType<
	typeof useParentPortalReEnrollmentContractsLazyQuery
>;
export type ParentPortalReEnrollmentContractsSuspenseQueryHookResult = ReturnType<
	typeof useParentPortalReEnrollmentContractsSuspenseQuery
>;
export type ParentPortalReEnrollmentContractsQueryResult = Apollo.QueryResult<
	ParentPortalReEnrollmentContractsQuery,
	ParentPortalReEnrollmentContractsQueryVariables
>;
export const ReportCardsCompletionProgressStatisticsDocument = gql`
	query reportCardsCompletionProgressStatistics($filters: [ReportCardFilterInput!]) {
		reportCardsCompletionProgressStatistics(filters: $filters) {
			count
			incomplete
			ready
			complete
		}
	}
`;

/**
 * __useReportCardsCompletionProgressStatisticsQuery__
 *
 * To run a query within a React component, call `useReportCardsCompletionProgressStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardsCompletionProgressStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardsCompletionProgressStatisticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useReportCardsCompletionProgressStatisticsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ReportCardsCompletionProgressStatisticsQuery,
		ReportCardsCompletionProgressStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReportCardsCompletionProgressStatisticsQuery,
		ReportCardsCompletionProgressStatisticsQueryVariables
	>(ReportCardsCompletionProgressStatisticsDocument, options);
}
export function useReportCardsCompletionProgressStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardsCompletionProgressStatisticsQuery,
		ReportCardsCompletionProgressStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportCardsCompletionProgressStatisticsQuery,
		ReportCardsCompletionProgressStatisticsQueryVariables
	>(ReportCardsCompletionProgressStatisticsDocument, options);
}
export function useReportCardsCompletionProgressStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardsCompletionProgressStatisticsQuery,
		ReportCardsCompletionProgressStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ReportCardsCompletionProgressStatisticsQuery,
		ReportCardsCompletionProgressStatisticsQueryVariables
	>(ReportCardsCompletionProgressStatisticsDocument, options);
}
export type ReportCardsCompletionProgressStatisticsQueryHookResult = ReturnType<
	typeof useReportCardsCompletionProgressStatisticsQuery
>;
export type ReportCardsCompletionProgressStatisticsLazyQueryHookResult = ReturnType<
	typeof useReportCardsCompletionProgressStatisticsLazyQuery
>;
export type ReportCardsCompletionProgressStatisticsSuspenseQueryHookResult = ReturnType<
	typeof useReportCardsCompletionProgressStatisticsSuspenseQuery
>;
export type ReportCardsCompletionProgressStatisticsQueryResult = Apollo.QueryResult<
	ReportCardsCompletionProgressStatisticsQuery,
	ReportCardsCompletionProgressStatisticsQueryVariables
>;
export const ReportCardSectionsCompletionProgressStatisticsDocument = gql`
	query reportCardSectionsCompletionProgressStatistics($filters: [ReportCardSectionFilterInput!]) {
		reportCardSectionsCompletionProgressStatistics(filters: $filters) {
			count
			incomplete
			ready
			complete
		}
	}
`;

/**
 * __useReportCardSectionsCompletionProgressStatisticsQuery__
 *
 * To run a query within a React component, call `useReportCardSectionsCompletionProgressStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionsCompletionProgressStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionsCompletionProgressStatisticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useReportCardSectionsCompletionProgressStatisticsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ReportCardSectionsCompletionProgressStatisticsQuery,
		ReportCardSectionsCompletionProgressStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReportCardSectionsCompletionProgressStatisticsQuery,
		ReportCardSectionsCompletionProgressStatisticsQueryVariables
	>(ReportCardSectionsCompletionProgressStatisticsDocument, options);
}
export function useReportCardSectionsCompletionProgressStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionsCompletionProgressStatisticsQuery,
		ReportCardSectionsCompletionProgressStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportCardSectionsCompletionProgressStatisticsQuery,
		ReportCardSectionsCompletionProgressStatisticsQueryVariables
	>(ReportCardSectionsCompletionProgressStatisticsDocument, options);
}
export function useReportCardSectionsCompletionProgressStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionsCompletionProgressStatisticsQuery,
		ReportCardSectionsCompletionProgressStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ReportCardSectionsCompletionProgressStatisticsQuery,
		ReportCardSectionsCompletionProgressStatisticsQueryVariables
	>(ReportCardSectionsCompletionProgressStatisticsDocument, options);
}
export type ReportCardSectionsCompletionProgressStatisticsQueryHookResult = ReturnType<
	typeof useReportCardSectionsCompletionProgressStatisticsQuery
>;
export type ReportCardSectionsCompletionProgressStatisticsLazyQueryHookResult = ReturnType<
	typeof useReportCardSectionsCompletionProgressStatisticsLazyQuery
>;
export type ReportCardSectionsCompletionProgressStatisticsSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionsCompletionProgressStatisticsSuspenseQuery
>;
export type ReportCardSectionsCompletionProgressStatisticsQueryResult = Apollo.QueryResult<
	ReportCardSectionsCompletionProgressStatisticsQuery,
	ReportCardSectionsCompletionProgressStatisticsQueryVariables
>;
export const SectionsReportCardSectionsCompletionProgressStatisticsDocument = gql`
	query sectionsReportCardSectionsCompletionProgressStatistics(
		$homeRoomSectionFilters: [HomeRoomSectionFilterInput!]
		$courseSectionFilters: [CourseSectionFilterInput!]
	) {
		homeRoomSectionConnection(filters: $homeRoomSectionFilters) {
			edges {
				node {
					id
					...HomeRoomSectionName
					studentHomeRoomSectionEnrollments {
						id
						lateStartDate
						earlyEndDate
					}
				}
			}
		}
		courseSectionConnection(filters: $courseSectionFilters) {
			edges {
				node {
					id
					namePrefix
					nameSuffix
					course {
						id
						name
						academicSubject {
							id
							...AcademicSubjectNameAndColor
						}
						classYears(order: { field: YEARS_FROM_GRADUATION, direction: DESC }) {
							id
							...ClassYearName
						}
					}
					homeRoomSection {
						id
						...HomeRoomSectionName
					}
					studentCourseSectionEnrollments {
						id
						lateStartDate
						earlyEndDate
					}
				}
			}
		}
		sectionsReportCardSectionsCompletionProgressStatistics(
			homeRoomSectionFilters: $homeRoomSectionFilters
			courseSectionFilters: $courseSectionFilters
		) {
			id
			statistics {
				count
				incomplete
				ready
				complete
			}
		}
	}
	${HomeRoomSectionNameFragmentDoc}
	${AcademicSubjectNameAndColorFragmentDoc}
	${ClassYearNameFragmentDoc}
`;

/**
 * __useSectionsReportCardSectionsCompletionProgressStatisticsQuery__
 *
 * To run a query within a React component, call `useSectionsReportCardSectionsCompletionProgressStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectionsReportCardSectionsCompletionProgressStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectionsReportCardSectionsCompletionProgressStatisticsQuery({
 *   variables: {
 *      homeRoomSectionFilters: // value for 'homeRoomSectionFilters'
 *      courseSectionFilters: // value for 'courseSectionFilters'
 *   },
 * });
 */
export function useSectionsReportCardSectionsCompletionProgressStatisticsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		SectionsReportCardSectionsCompletionProgressStatisticsQuery,
		SectionsReportCardSectionsCompletionProgressStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		SectionsReportCardSectionsCompletionProgressStatisticsQuery,
		SectionsReportCardSectionsCompletionProgressStatisticsQueryVariables
	>(SectionsReportCardSectionsCompletionProgressStatisticsDocument, options);
}
export function useSectionsReportCardSectionsCompletionProgressStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SectionsReportCardSectionsCompletionProgressStatisticsQuery,
		SectionsReportCardSectionsCompletionProgressStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		SectionsReportCardSectionsCompletionProgressStatisticsQuery,
		SectionsReportCardSectionsCompletionProgressStatisticsQueryVariables
	>(SectionsReportCardSectionsCompletionProgressStatisticsDocument, options);
}
export function useSectionsReportCardSectionsCompletionProgressStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		SectionsReportCardSectionsCompletionProgressStatisticsQuery,
		SectionsReportCardSectionsCompletionProgressStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		SectionsReportCardSectionsCompletionProgressStatisticsQuery,
		SectionsReportCardSectionsCompletionProgressStatisticsQueryVariables
	>(SectionsReportCardSectionsCompletionProgressStatisticsDocument, options);
}
export type SectionsReportCardSectionsCompletionProgressStatisticsQueryHookResult = ReturnType<
	typeof useSectionsReportCardSectionsCompletionProgressStatisticsQuery
>;
export type SectionsReportCardSectionsCompletionProgressStatisticsLazyQueryHookResult = ReturnType<
	typeof useSectionsReportCardSectionsCompletionProgressStatisticsLazyQuery
>;
export type SectionsReportCardSectionsCompletionProgressStatisticsSuspenseQueryHookResult = ReturnType<
	typeof useSectionsReportCardSectionsCompletionProgressStatisticsSuspenseQuery
>;
export type SectionsReportCardSectionsCompletionProgressStatisticsQueryResult = Apollo.QueryResult<
	SectionsReportCardSectionsCompletionProgressStatisticsQuery,
	SectionsReportCardSectionsCompletionProgressStatisticsQueryVariables
>;
export const StudentsReportCardSectionCompletionProgressStatisticsDocument = gql`
	query studentsReportCardSectionCompletionProgressStatistics(
		$reportCardSectionFilters: [ReportCardSectionFilterInput!]
	) {
		studentsReportCardSectionCompletionProgressStatistics(reportCardSectionFilters: $reportCardSectionFilters) {
			id
			isReady
			isComplete
			completionPercentage
		}
	}
`;

/**
 * __useStudentsReportCardSectionCompletionProgressStatisticsQuery__
 *
 * To run a query within a React component, call `useStudentsReportCardSectionCompletionProgressStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentsReportCardSectionCompletionProgressStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentsReportCardSectionCompletionProgressStatisticsQuery({
 *   variables: {
 *      reportCardSectionFilters: // value for 'reportCardSectionFilters'
 *   },
 * });
 */
export function useStudentsReportCardSectionCompletionProgressStatisticsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		StudentsReportCardSectionCompletionProgressStatisticsQuery,
		StudentsReportCardSectionCompletionProgressStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentsReportCardSectionCompletionProgressStatisticsQuery,
		StudentsReportCardSectionCompletionProgressStatisticsQueryVariables
	>(StudentsReportCardSectionCompletionProgressStatisticsDocument, options);
}
export function useStudentsReportCardSectionCompletionProgressStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentsReportCardSectionCompletionProgressStatisticsQuery,
		StudentsReportCardSectionCompletionProgressStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentsReportCardSectionCompletionProgressStatisticsQuery,
		StudentsReportCardSectionCompletionProgressStatisticsQueryVariables
	>(StudentsReportCardSectionCompletionProgressStatisticsDocument, options);
}
export function useStudentsReportCardSectionCompletionProgressStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentsReportCardSectionCompletionProgressStatisticsQuery,
		StudentsReportCardSectionCompletionProgressStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentsReportCardSectionCompletionProgressStatisticsQuery,
		StudentsReportCardSectionCompletionProgressStatisticsQueryVariables
	>(StudentsReportCardSectionCompletionProgressStatisticsDocument, options);
}
export type StudentsReportCardSectionCompletionProgressStatisticsQueryHookResult = ReturnType<
	typeof useStudentsReportCardSectionCompletionProgressStatisticsQuery
>;
export type StudentsReportCardSectionCompletionProgressStatisticsLazyQueryHookResult = ReturnType<
	typeof useStudentsReportCardSectionCompletionProgressStatisticsLazyQuery
>;
export type StudentsReportCardSectionCompletionProgressStatisticsSuspenseQueryHookResult = ReturnType<
	typeof useStudentsReportCardSectionCompletionProgressStatisticsSuspenseQuery
>;
export type StudentsReportCardSectionCompletionProgressStatisticsQueryResult = Apollo.QueryResult<
	StudentsReportCardSectionCompletionProgressStatisticsQuery,
	StudentsReportCardSectionCompletionProgressStatisticsQueryVariables
>;
export const AspectsReportCardSectionCompletionProgressStatisticsDocument = gql`
	query aspectsReportCardSectionCompletionProgressStatistics(
		$reportCardSectionFilters: [ReportCardSectionFilterInput!]
	) {
		aspectsReportCardSectionCompletionProgressStatistics(reportCardSectionFilters: $reportCardSectionFilters) {
			id
			isReady
			isComplete
			completionPercentage
		}
	}
`;

/**
 * __useAspectsReportCardSectionCompletionProgressStatisticsQuery__
 *
 * To run a query within a React component, call `useAspectsReportCardSectionCompletionProgressStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAspectsReportCardSectionCompletionProgressStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAspectsReportCardSectionCompletionProgressStatisticsQuery({
 *   variables: {
 *      reportCardSectionFilters: // value for 'reportCardSectionFilters'
 *   },
 * });
 */
export function useAspectsReportCardSectionCompletionProgressStatisticsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		AspectsReportCardSectionCompletionProgressStatisticsQuery,
		AspectsReportCardSectionCompletionProgressStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		AspectsReportCardSectionCompletionProgressStatisticsQuery,
		AspectsReportCardSectionCompletionProgressStatisticsQueryVariables
	>(AspectsReportCardSectionCompletionProgressStatisticsDocument, options);
}
export function useAspectsReportCardSectionCompletionProgressStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		AspectsReportCardSectionCompletionProgressStatisticsQuery,
		AspectsReportCardSectionCompletionProgressStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		AspectsReportCardSectionCompletionProgressStatisticsQuery,
		AspectsReportCardSectionCompletionProgressStatisticsQueryVariables
	>(AspectsReportCardSectionCompletionProgressStatisticsDocument, options);
}
export function useAspectsReportCardSectionCompletionProgressStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		AspectsReportCardSectionCompletionProgressStatisticsQuery,
		AspectsReportCardSectionCompletionProgressStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		AspectsReportCardSectionCompletionProgressStatisticsQuery,
		AspectsReportCardSectionCompletionProgressStatisticsQueryVariables
	>(AspectsReportCardSectionCompletionProgressStatisticsDocument, options);
}
export type AspectsReportCardSectionCompletionProgressStatisticsQueryHookResult = ReturnType<
	typeof useAspectsReportCardSectionCompletionProgressStatisticsQuery
>;
export type AspectsReportCardSectionCompletionProgressStatisticsLazyQueryHookResult = ReturnType<
	typeof useAspectsReportCardSectionCompletionProgressStatisticsLazyQuery
>;
export type AspectsReportCardSectionCompletionProgressStatisticsSuspenseQueryHookResult = ReturnType<
	typeof useAspectsReportCardSectionCompletionProgressStatisticsSuspenseQuery
>;
export type AspectsReportCardSectionCompletionProgressStatisticsQueryResult = Apollo.QueryResult<
	AspectsReportCardSectionCompletionProgressStatisticsQuery,
	AspectsReportCardSectionCompletionProgressStatisticsQueryVariables
>;
export const PoliciesAspectsReportCardSectionCompletionProgressStatisticsDocument = gql`
	query policiesAspectsReportCardSectionCompletionProgressStatistics(
		$reportCardSectionFilters: [ReportCardSectionFilterInput!]
	) {
		policiesAspectsReportCardSectionCompletionProgressStatistics(reportCardSectionFilters: $reportCardSectionFilters) {
			id
			statistics {
				id
				isReady
				isComplete
				completionPercentage
			}
		}
	}
`;

/**
 * __usePoliciesAspectsReportCardSectionCompletionProgressStatisticsQuery__
 *
 * To run a query within a React component, call `usePoliciesAspectsReportCardSectionCompletionProgressStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePoliciesAspectsReportCardSectionCompletionProgressStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePoliciesAspectsReportCardSectionCompletionProgressStatisticsQuery({
 *   variables: {
 *      reportCardSectionFilters: // value for 'reportCardSectionFilters'
 *   },
 * });
 */
export function usePoliciesAspectsReportCardSectionCompletionProgressStatisticsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		PoliciesAspectsReportCardSectionCompletionProgressStatisticsQuery,
		PoliciesAspectsReportCardSectionCompletionProgressStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		PoliciesAspectsReportCardSectionCompletionProgressStatisticsQuery,
		PoliciesAspectsReportCardSectionCompletionProgressStatisticsQueryVariables
	>(PoliciesAspectsReportCardSectionCompletionProgressStatisticsDocument, options);
}
export function usePoliciesAspectsReportCardSectionCompletionProgressStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PoliciesAspectsReportCardSectionCompletionProgressStatisticsQuery,
		PoliciesAspectsReportCardSectionCompletionProgressStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		PoliciesAspectsReportCardSectionCompletionProgressStatisticsQuery,
		PoliciesAspectsReportCardSectionCompletionProgressStatisticsQueryVariables
	>(PoliciesAspectsReportCardSectionCompletionProgressStatisticsDocument, options);
}
export function usePoliciesAspectsReportCardSectionCompletionProgressStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		PoliciesAspectsReportCardSectionCompletionProgressStatisticsQuery,
		PoliciesAspectsReportCardSectionCompletionProgressStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		PoliciesAspectsReportCardSectionCompletionProgressStatisticsQuery,
		PoliciesAspectsReportCardSectionCompletionProgressStatisticsQueryVariables
	>(PoliciesAspectsReportCardSectionCompletionProgressStatisticsDocument, options);
}
export type PoliciesAspectsReportCardSectionCompletionProgressStatisticsQueryHookResult = ReturnType<
	typeof usePoliciesAspectsReportCardSectionCompletionProgressStatisticsQuery
>;
export type PoliciesAspectsReportCardSectionCompletionProgressStatisticsLazyQueryHookResult = ReturnType<
	typeof usePoliciesAspectsReportCardSectionCompletionProgressStatisticsLazyQuery
>;
export type PoliciesAspectsReportCardSectionCompletionProgressStatisticsSuspenseQueryHookResult = ReturnType<
	typeof usePoliciesAspectsReportCardSectionCompletionProgressStatisticsSuspenseQuery
>;
export type PoliciesAspectsReportCardSectionCompletionProgressStatisticsQueryResult = Apollo.QueryResult<
	PoliciesAspectsReportCardSectionCompletionProgressStatisticsQuery,
	PoliciesAspectsReportCardSectionCompletionProgressStatisticsQueryVariables
>;
export const AdminReportCardStudentsTableDocument = gql`
	query adminReportCardStudentsTable(
		$academicTermID: ID!
		$studentFilters: [StudentFilterInput!]
		$pagination: Pagination
		$order: StudentOrder
	) {
		studentConnection(filters: $studentFilters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...StudentNameAndImage
					graduationYear
					yearsFromGraduation
					reportCards(filters: { academicTermIDEQ: $academicTermID }) {
						id
						isComplete
					}
				}
			}
		}
		homeRoomSectionConnection(
			filters: { academicTermIDEQ: $academicTermID, studentHomeRoomSectionEnrollments: { student: $studentFilters } }
		) {
			edges {
				node {
					id
					...HomeRoomSectionName
				}
			}
		}
		courseSectionConnection(
			filters: { academicTermIDEQ: $academicTermID, studentCourseSectionEnrollments: { student: $studentFilters } }
		) {
			edges {
				node {
					id
					...CourseSectionName
				}
			}
		}
		studentsReportCardCompletionProgressStatistics(
			reportCardFilters: { student: $studentFilters, academicTermIDEQ: $academicTermID }
		) {
			id
			isReady
			isComplete
			completionPercentage
		}
		studentsSectionsReportCardSectionCompletionProgressStatistics(
			reportCardSectionFilters: { reportCard: { student: $studentFilters, academicTermIDEQ: $academicTermID } }
		) {
			id
			statistics {
				id
				isReady
				isComplete
				completionPercentage
			}
		}
	}
	${StudentNameAndImageFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${CourseSectionNameFragmentDoc}
`;

/**
 * __useAdminReportCardStudentsTableQuery__
 *
 * To run a query within a React component, call `useAdminReportCardStudentsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminReportCardStudentsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminReportCardStudentsTableQuery({
 *   variables: {
 *      academicTermID: // value for 'academicTermID'
 *      studentFilters: // value for 'studentFilters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAdminReportCardStudentsTableQuery(
	baseOptions: Apollo.QueryHookOptions<AdminReportCardStudentsTableQuery, AdminReportCardStudentsTableQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AdminReportCardStudentsTableQuery, AdminReportCardStudentsTableQueryVariables>(
		AdminReportCardStudentsTableDocument,
		options,
	);
}
export function useAdminReportCardStudentsTableLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		AdminReportCardStudentsTableQuery,
		AdminReportCardStudentsTableQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AdminReportCardStudentsTableQuery, AdminReportCardStudentsTableQueryVariables>(
		AdminReportCardStudentsTableDocument,
		options,
	);
}
export function useAdminReportCardStudentsTableSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		AdminReportCardStudentsTableQuery,
		AdminReportCardStudentsTableQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AdminReportCardStudentsTableQuery, AdminReportCardStudentsTableQueryVariables>(
		AdminReportCardStudentsTableDocument,
		options,
	);
}
export type AdminReportCardStudentsTableQueryHookResult = ReturnType<typeof useAdminReportCardStudentsTableQuery>;
export type AdminReportCardStudentsTableLazyQueryHookResult = ReturnType<
	typeof useAdminReportCardStudentsTableLazyQuery
>;
export type AdminReportCardStudentsTableSuspenseQueryHookResult = ReturnType<
	typeof useAdminReportCardStudentsTableSuspenseQuery
>;
export type AdminReportCardStudentsTableQueryResult = Apollo.QueryResult<
	AdminReportCardStudentsTableQuery,
	AdminReportCardStudentsTableQueryVariables
>;
export const AdminReportCardTeachersTableDocument = gql`
	query adminReportCardTeachersTable($academicTermID: ID!, $teacherFilters: [EmployeeFilterInput!]) {
		employeeConnection(filters: $teacherFilters) {
			edges {
				node {
					id
					...EmployeeNameAndImage
					teacherHomeRoomSectionEnrollments {
						id
						homeRoomSection {
							id
							homeRoom {
								id
								classYear {
									id
									...ClassYearName
									yearsFromGraduation
								}
							}
						}
					}
					teacherCourseSectionEnrollments {
						id
						courseSection {
							id
							course {
								id
								classYears {
									id
									...ClassYearName
									yearsFromGraduation
								}
							}
						}
					}
				}
			}
		}
		homeRoomSectionConnection(
			filters: { academicTermIDEQ: $academicTermID, teacherHomeRoomSectionEnrollments: { teacher: $teacherFilters } }
		) {
			edges {
				node {
					id
					...HomeRoomSectionName
				}
			}
		}
		courseSectionConnection(
			filters: { academicTermIDEQ: $academicTermID, teacherCourseSectionEnrollments: { teacher: $teacherFilters } }
		) {
			edges {
				node {
					id
					...CourseSectionName
				}
			}
		}
		teachersSectionsReportCardSectionCompletionProgressStatistics(
			reportCardSectionFilters: {
				reportCard: { academicTermIDEQ: $academicTermID }
				reportCardSectionPolicy: {
					or: [
						{ homeRoomSection: { teacherHomeRoomSectionEnrollments: { teacher: $teacherFilters } } }
						{ courseSection: { teacherCourseSectionEnrollments: { teacher: $teacherFilters } } }
					]
				}
			}
		) {
			id
			statistics {
				id
				isReady
				isComplete
				completionPercentage
			}
		}
	}
	${EmployeeNameAndImageFragmentDoc}
	${ClassYearNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${CourseSectionNameFragmentDoc}
`;

/**
 * __useAdminReportCardTeachersTableQuery__
 *
 * To run a query within a React component, call `useAdminReportCardTeachersTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminReportCardTeachersTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminReportCardTeachersTableQuery({
 *   variables: {
 *      academicTermID: // value for 'academicTermID'
 *      teacherFilters: // value for 'teacherFilters'
 *   },
 * });
 */
export function useAdminReportCardTeachersTableQuery(
	baseOptions: Apollo.QueryHookOptions<AdminReportCardTeachersTableQuery, AdminReportCardTeachersTableQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AdminReportCardTeachersTableQuery, AdminReportCardTeachersTableQueryVariables>(
		AdminReportCardTeachersTableDocument,
		options,
	);
}
export function useAdminReportCardTeachersTableLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		AdminReportCardTeachersTableQuery,
		AdminReportCardTeachersTableQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AdminReportCardTeachersTableQuery, AdminReportCardTeachersTableQueryVariables>(
		AdminReportCardTeachersTableDocument,
		options,
	);
}
export function useAdminReportCardTeachersTableSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		AdminReportCardTeachersTableQuery,
		AdminReportCardTeachersTableQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AdminReportCardTeachersTableQuery, AdminReportCardTeachersTableQueryVariables>(
		AdminReportCardTeachersTableDocument,
		options,
	);
}
export type AdminReportCardTeachersTableQueryHookResult = ReturnType<typeof useAdminReportCardTeachersTableQuery>;
export type AdminReportCardTeachersTableLazyQueryHookResult = ReturnType<
	typeof useAdminReportCardTeachersTableLazyQuery
>;
export type AdminReportCardTeachersTableSuspenseQueryHookResult = ReturnType<
	typeof useAdminReportCardTeachersTableSuspenseQuery
>;
export type AdminReportCardTeachersTableQueryResult = Apollo.QueryResult<
	AdminReportCardTeachersTableQuery,
	AdminReportCardTeachersTableQueryVariables
>;
export const StudentReportCardSchoolAttendanceStatisticsDocument = gql`
	query studentReportCardSchoolAttendanceStatistics($studentID: ID!, $academicTermID: ID!) {
		studentReportCardSchoolAttendanceStatistics(studentID: $studentID, academicTermID: $academicTermID) {
			total
			present
			excusedLateArrival
			unexcusedLateArrival
			excusedEarlyDeparture
			unexcusedEarlyDeparture
			excusedAbsent
			unexcusedAbsent
		}
	}
`;

/**
 * __useStudentReportCardSchoolAttendanceStatisticsQuery__
 *
 * To run a query within a React component, call `useStudentReportCardSchoolAttendanceStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentReportCardSchoolAttendanceStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentReportCardSchoolAttendanceStatisticsQuery({
 *   variables: {
 *      studentID: // value for 'studentID'
 *      academicTermID: // value for 'academicTermID'
 *   },
 * });
 */
export function useStudentReportCardSchoolAttendanceStatisticsQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentReportCardSchoolAttendanceStatisticsQuery,
		StudentReportCardSchoolAttendanceStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentReportCardSchoolAttendanceStatisticsQuery,
		StudentReportCardSchoolAttendanceStatisticsQueryVariables
	>(StudentReportCardSchoolAttendanceStatisticsDocument, options);
}
export function useStudentReportCardSchoolAttendanceStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentReportCardSchoolAttendanceStatisticsQuery,
		StudentReportCardSchoolAttendanceStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentReportCardSchoolAttendanceStatisticsQuery,
		StudentReportCardSchoolAttendanceStatisticsQueryVariables
	>(StudentReportCardSchoolAttendanceStatisticsDocument, options);
}
export function useStudentReportCardSchoolAttendanceStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentReportCardSchoolAttendanceStatisticsQuery,
		StudentReportCardSchoolAttendanceStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentReportCardSchoolAttendanceStatisticsQuery,
		StudentReportCardSchoolAttendanceStatisticsQueryVariables
	>(StudentReportCardSchoolAttendanceStatisticsDocument, options);
}
export type StudentReportCardSchoolAttendanceStatisticsQueryHookResult = ReturnType<
	typeof useStudentReportCardSchoolAttendanceStatisticsQuery
>;
export type StudentReportCardSchoolAttendanceStatisticsLazyQueryHookResult = ReturnType<
	typeof useStudentReportCardSchoolAttendanceStatisticsLazyQuery
>;
export type StudentReportCardSchoolAttendanceStatisticsSuspenseQueryHookResult = ReturnType<
	typeof useStudentReportCardSchoolAttendanceStatisticsSuspenseQuery
>;
export type StudentReportCardSchoolAttendanceStatisticsQueryResult = Apollo.QueryResult<
	StudentReportCardSchoolAttendanceStatisticsQuery,
	StudentReportCardSchoolAttendanceStatisticsQueryVariables
>;
export const StudentReportCardCourseAttendanceStatisticsDocument = gql`
	query studentReportCardCourseAttendanceStatistics($studentID: ID!, $academicTermID: ID!) {
		studentReportCardCourseAttendanceStatistics(studentID: $studentID, academicTermID: $academicTermID) {
			total
			present
			excusedLateArrival
			unexcusedLateArrival
			excusedEarlyDeparture
			unexcusedEarlyDeparture
			excusedAbsent
			unexcusedAbsent
		}
	}
`;

/**
 * __useStudentReportCardCourseAttendanceStatisticsQuery__
 *
 * To run a query within a React component, call `useStudentReportCardCourseAttendanceStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentReportCardCourseAttendanceStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentReportCardCourseAttendanceStatisticsQuery({
 *   variables: {
 *      studentID: // value for 'studentID'
 *      academicTermID: // value for 'academicTermID'
 *   },
 * });
 */
export function useStudentReportCardCourseAttendanceStatisticsQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentReportCardCourseAttendanceStatisticsQuery,
		StudentReportCardCourseAttendanceStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentReportCardCourseAttendanceStatisticsQuery,
		StudentReportCardCourseAttendanceStatisticsQueryVariables
	>(StudentReportCardCourseAttendanceStatisticsDocument, options);
}
export function useStudentReportCardCourseAttendanceStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentReportCardCourseAttendanceStatisticsQuery,
		StudentReportCardCourseAttendanceStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentReportCardCourseAttendanceStatisticsQuery,
		StudentReportCardCourseAttendanceStatisticsQueryVariables
	>(StudentReportCardCourseAttendanceStatisticsDocument, options);
}
export function useStudentReportCardCourseAttendanceStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentReportCardCourseAttendanceStatisticsQuery,
		StudentReportCardCourseAttendanceStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentReportCardCourseAttendanceStatisticsQuery,
		StudentReportCardCourseAttendanceStatisticsQueryVariables
	>(StudentReportCardCourseAttendanceStatisticsDocument, options);
}
export type StudentReportCardCourseAttendanceStatisticsQueryHookResult = ReturnType<
	typeof useStudentReportCardCourseAttendanceStatisticsQuery
>;
export type StudentReportCardCourseAttendanceStatisticsLazyQueryHookResult = ReturnType<
	typeof useStudentReportCardCourseAttendanceStatisticsLazyQuery
>;
export type StudentReportCardCourseAttendanceStatisticsSuspenseQueryHookResult = ReturnType<
	typeof useStudentReportCardCourseAttendanceStatisticsSuspenseQuery
>;
export type StudentReportCardCourseAttendanceStatisticsQueryResult = Apollo.QueryResult<
	StudentReportCardCourseAttendanceStatisticsQuery,
	StudentReportCardCourseAttendanceStatisticsQueryVariables
>;
export const TeacherReportCardCourseAndHomeRoomSectionsListDocument = gql`
	query teacherReportCardCourseAndHomeRoomSectionsList($academicTermID: ID!) {
		courseSectionConnection(
			filters: {
				academicTermIDEQ: $academicTermID
				teacherCourseSectionEnrollments: { teacher: { person: { user: { isCurrentEQ: true } } } }
				reportCardSectionPolicies: { hasReportCardSections: true }
			}
		) {
			edges {
				node {
					id
					namePrefix
					nameSuffix
					course {
						id
						...CourseName
						classYears {
							id
							...ClassYearName
						}
					}
					homeRoomSection {
						id
						...HomeRoomSectionName
					}
					teacherCourseSectionEnrollments {
						id
						teacher {
							id
							...EmployeeNameAndImage
						}
					}
				}
			}
		}
		homeRoomSectionConnection(
			filters: {
				academicTermIDEQ: $academicTermID
				teacherHomeRoomSectionEnrollments: { teacher: { person: { user: { isCurrentEQ: true } } } }
				reportCardSectionPolicies: { hasReportCardSections: true }
			}
		) {
			edges {
				node {
					id
					...HomeRoomSectionName
					teacherHomeRoomSectionEnrollments {
						id
						teacher {
							id
							...EmployeeNameAndImage
						}
					}
				}
			}
		}
	}
	${CourseNameFragmentDoc}
	${ClassYearNameFragmentDoc}
	${HomeRoomSectionNameFragmentDoc}
	${EmployeeNameAndImageFragmentDoc}
`;

/**
 * __useTeacherReportCardCourseAndHomeRoomSectionsListQuery__
 *
 * To run a query within a React component, call `useTeacherReportCardCourseAndHomeRoomSectionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherReportCardCourseAndHomeRoomSectionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherReportCardCourseAndHomeRoomSectionsListQuery({
 *   variables: {
 *      academicTermID: // value for 'academicTermID'
 *   },
 * });
 */
export function useTeacherReportCardCourseAndHomeRoomSectionsListQuery(
	baseOptions: Apollo.QueryHookOptions<
		TeacherReportCardCourseAndHomeRoomSectionsListQuery,
		TeacherReportCardCourseAndHomeRoomSectionsListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		TeacherReportCardCourseAndHomeRoomSectionsListQuery,
		TeacherReportCardCourseAndHomeRoomSectionsListQueryVariables
	>(TeacherReportCardCourseAndHomeRoomSectionsListDocument, options);
}
export function useTeacherReportCardCourseAndHomeRoomSectionsListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeacherReportCardCourseAndHomeRoomSectionsListQuery,
		TeacherReportCardCourseAndHomeRoomSectionsListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		TeacherReportCardCourseAndHomeRoomSectionsListQuery,
		TeacherReportCardCourseAndHomeRoomSectionsListQueryVariables
	>(TeacherReportCardCourseAndHomeRoomSectionsListDocument, options);
}
export function useTeacherReportCardCourseAndHomeRoomSectionsListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TeacherReportCardCourseAndHomeRoomSectionsListQuery,
		TeacherReportCardCourseAndHomeRoomSectionsListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		TeacherReportCardCourseAndHomeRoomSectionsListQuery,
		TeacherReportCardCourseAndHomeRoomSectionsListQueryVariables
	>(TeacherReportCardCourseAndHomeRoomSectionsListDocument, options);
}
export type TeacherReportCardCourseAndHomeRoomSectionsListQueryHookResult = ReturnType<
	typeof useTeacherReportCardCourseAndHomeRoomSectionsListQuery
>;
export type TeacherReportCardCourseAndHomeRoomSectionsListLazyQueryHookResult = ReturnType<
	typeof useTeacherReportCardCourseAndHomeRoomSectionsListLazyQuery
>;
export type TeacherReportCardCourseAndHomeRoomSectionsListSuspenseQueryHookResult = ReturnType<
	typeof useTeacherReportCardCourseAndHomeRoomSectionsListSuspenseQuery
>;
export type TeacherReportCardCourseAndHomeRoomSectionsListQueryResult = Apollo.QueryResult<
	TeacherReportCardCourseAndHomeRoomSectionsListQuery,
	TeacherReportCardCourseAndHomeRoomSectionsListQueryVariables
>;
export const StudentReportCardSectionFormInformationDocument = gql`
	query studentReportCardSectionFormInformation(
		$academicTermID: ID!
		$studentID: ID!
		$homeRoomSectionID: ID
		$courseSectionID: ID
	) {
		reportCardSectionConnection(
			filters: {
				reportCard: { academicTermIDEQ: $academicTermID, studentIDEQ: $studentID }
				reportCardSectionPolicy: { homeRoomSectionIDEQ: $homeRoomSectionID, courseSectionIDEQ: $courseSectionID }
			}
		) {
			edges {
				node {
					id
					...ReportCardSectionName
					overallMarkValue {
						id
						...MarkValueName
					}
					comment
					generalComment1
					generalComment2
					isComplete
					reportCard {
						id
						isComplete
						isReleased
					}
					reportCardSectionPolicy {
						id
						usesOverallMark
						isOverallMarkManual
						overallMarkLabel
						usesComment
						commentLabel
						minCommentLength
						maxCommentLength
						usesGeneralComments
						minGeneralComment1Length
						maxGeneralComment1Length
						minGeneralComment2Length
						maxGeneralComment2Length
						overallMarkingSystem {
							id
							markValues(order: { field: VALUE, direction: ASC }) {
								id
								...MarkValueName
							}
						}
					}
					reportCardSectionLearningObjectives {
						id
						learningObjective {
							id
							...LearningObjectiveName
							description
							learningObjectiveCategoryID
						}
						markValue {
							id
							...MarkValueName
						}
					}
				}
			}
		}
		learningObjectiveCategoryConnection(
			filters: {
				learningObjectives: {
					reportCardSectionLearningObjectives: {
						reportCardSection: {
							reportCard: { academicTermIDEQ: $academicTermID, studentIDEQ: $studentID }
							reportCardSectionPolicy: { homeRoomSectionIDEQ: $homeRoomSectionID, courseSectionIDEQ: $courseSectionID }
						}
					}
				}
			}
		) {
			edges {
				node {
					id
					...LearningObjectiveCategoryName
					markingSystem {
						id
						markValues(order: { field: VALUE, direction: ASC }) {
							id
							...MarkValueName
						}
					}
				}
			}
		}
	}
	${ReportCardSectionNameFragmentDoc}
	${MarkValueNameFragmentDoc}
	${LearningObjectiveNameFragmentDoc}
	${LearningObjectiveCategoryNameFragmentDoc}
`;

/**
 * __useStudentReportCardSectionFormInformationQuery__
 *
 * To run a query within a React component, call `useStudentReportCardSectionFormInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentReportCardSectionFormInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentReportCardSectionFormInformationQuery({
 *   variables: {
 *      academicTermID: // value for 'academicTermID'
 *      studentID: // value for 'studentID'
 *      homeRoomSectionID: // value for 'homeRoomSectionID'
 *      courseSectionID: // value for 'courseSectionID'
 *   },
 * });
 */
export function useStudentReportCardSectionFormInformationQuery(
	baseOptions: Apollo.QueryHookOptions<
		StudentReportCardSectionFormInformationQuery,
		StudentReportCardSectionFormInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		StudentReportCardSectionFormInformationQuery,
		StudentReportCardSectionFormInformationQueryVariables
	>(StudentReportCardSectionFormInformationDocument, options);
}
export function useStudentReportCardSectionFormInformationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		StudentReportCardSectionFormInformationQuery,
		StudentReportCardSectionFormInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		StudentReportCardSectionFormInformationQuery,
		StudentReportCardSectionFormInformationQueryVariables
	>(StudentReportCardSectionFormInformationDocument, options);
}
export function useStudentReportCardSectionFormInformationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		StudentReportCardSectionFormInformationQuery,
		StudentReportCardSectionFormInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		StudentReportCardSectionFormInformationQuery,
		StudentReportCardSectionFormInformationQueryVariables
	>(StudentReportCardSectionFormInformationDocument, options);
}
export type StudentReportCardSectionFormInformationQueryHookResult = ReturnType<
	typeof useStudentReportCardSectionFormInformationQuery
>;
export type StudentReportCardSectionFormInformationLazyQueryHookResult = ReturnType<
	typeof useStudentReportCardSectionFormInformationLazyQuery
>;
export type StudentReportCardSectionFormInformationSuspenseQueryHookResult = ReturnType<
	typeof useStudentReportCardSectionFormInformationSuspenseQuery
>;
export type StudentReportCardSectionFormInformationQueryResult = Apollo.QueryResult<
	StudentReportCardSectionFormInformationQuery,
	StudentReportCardSectionFormInformationQueryVariables
>;
export const ReportCardSectionLearningObjectivesNavigationListDocument = gql`
	query reportCardSectionLearningObjectivesNavigationList(
		$academicTermID: ID!
		$courseSectionID: ID
		$homeRoomSectionID: ID
	) {
		reportCardSectionPolicyConnection(
			filters: {
				reportCardSections: { reportCard: { academicTermIDEQ: $academicTermID } }
				homeRoomSectionIDEQ: $homeRoomSectionID
				courseSectionIDEQ: $courseSectionID
			}
			order: { direction: ASC }
		) {
			edges {
				node {
					id
					...ReportCardSectionPolicyName
					usesOverallMark
					isOverallMarkManual
					overallMarkLabel
					usesComment
					commentLabel
					usesGeneralComments
					reportCardSections {
						id
						reportCardSectionLearningObjectives {
							id
							learningObjectiveID
						}
					}
				}
			}
		}
		learningObjectiveCategoryConnection(
			filters: {
				learningObjectives: {
					reportCardSectionLearningObjectives: {
						reportCardSection: {
							reportCard: { academicTermIDEQ: $academicTermID }
							reportCardSectionPolicy: { courseSectionIDEQ: $courseSectionID, homeRoomSectionIDEQ: $homeRoomSectionID }
						}
					}
				}
			}
			order: { direction: ASC }
		) {
			edges {
				node {
					id
					...LearningObjectiveCategoryName
					learningObjectives {
						id
						...LearningObjectiveName
					}
				}
			}
		}
	}
	${ReportCardSectionPolicyNameFragmentDoc}
	${LearningObjectiveCategoryNameFragmentDoc}
	${LearningObjectiveNameFragmentDoc}
`;

/**
 * __useReportCardSectionLearningObjectivesNavigationListQuery__
 *
 * To run a query within a React component, call `useReportCardSectionLearningObjectivesNavigationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionLearningObjectivesNavigationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionLearningObjectivesNavigationListQuery({
 *   variables: {
 *      academicTermID: // value for 'academicTermID'
 *      courseSectionID: // value for 'courseSectionID'
 *      homeRoomSectionID: // value for 'homeRoomSectionID'
 *   },
 * });
 */
export function useReportCardSectionLearningObjectivesNavigationListQuery(
	baseOptions: Apollo.QueryHookOptions<
		ReportCardSectionLearningObjectivesNavigationListQuery,
		ReportCardSectionLearningObjectivesNavigationListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReportCardSectionLearningObjectivesNavigationListQuery,
		ReportCardSectionLearningObjectivesNavigationListQueryVariables
	>(ReportCardSectionLearningObjectivesNavigationListDocument, options);
}
export function useReportCardSectionLearningObjectivesNavigationListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionLearningObjectivesNavigationListQuery,
		ReportCardSectionLearningObjectivesNavigationListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportCardSectionLearningObjectivesNavigationListQuery,
		ReportCardSectionLearningObjectivesNavigationListQueryVariables
	>(ReportCardSectionLearningObjectivesNavigationListDocument, options);
}
export function useReportCardSectionLearningObjectivesNavigationListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionLearningObjectivesNavigationListQuery,
		ReportCardSectionLearningObjectivesNavigationListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ReportCardSectionLearningObjectivesNavigationListQuery,
		ReportCardSectionLearningObjectivesNavigationListQueryVariables
	>(ReportCardSectionLearningObjectivesNavigationListDocument, options);
}
export type ReportCardSectionLearningObjectivesNavigationListQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectivesNavigationListQuery
>;
export type ReportCardSectionLearningObjectivesNavigationListLazyQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectivesNavigationListLazyQuery
>;
export type ReportCardSectionLearningObjectivesNavigationListSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionLearningObjectivesNavigationListSuspenseQuery
>;
export type ReportCardSectionLearningObjectivesNavigationListQueryResult = Apollo.QueryResult<
	ReportCardSectionLearningObjectivesNavigationListQuery,
	ReportCardSectionLearningObjectivesNavigationListQueryVariables
>;
export const LearningObjectiveAspectReportCardSectionFormInformationDocument = gql`
	query learningObjectiveAspectReportCardSectionFormInformation(
		$academicTermID: ID!
		$reportCardSectionPolicyID: ID!
		$learningObjectiveID: ID!
	) {
		reportCardSectionLearningObjectiveConnection(
			filters: {
				reportCardSection: {
					reportCard: { academicTermIDEQ: $academicTermID }
					reportCardSectionPolicyIDEQ: $reportCardSectionPolicyID
				}
				learningObjectiveIDEQ: $learningObjectiveID
			}
		) {
			edges {
				node {
					id
					markValue {
						id
						...MarkValueName
					}
					reportCardSection {
						id
						isComplete
						reportCard {
							id
							student {
								id
								person {
									id
									...PersonNameAndImage
									familyName
								}
							}
						}
					}
				}
			}
		}
		learningObjective(id: $learningObjectiveID) {
			id
			...LearningObjectiveName
			description
			learningObjectiveCategory {
				id
				...LearningObjectiveCategoryName
				markingSystem {
					id
					markValues(order: { field: VALUE, direction: ASC }) {
						id
						...MarkValueName
					}
				}
			}
		}
	}
	${MarkValueNameFragmentDoc}
	${PersonNameAndImageFragmentDoc}
	${LearningObjectiveNameFragmentDoc}
	${LearningObjectiveCategoryNameFragmentDoc}
`;

/**
 * __useLearningObjectiveAspectReportCardSectionFormInformationQuery__
 *
 * To run a query within a React component, call `useLearningObjectiveAspectReportCardSectionFormInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveAspectReportCardSectionFormInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningObjectiveAspectReportCardSectionFormInformationQuery({
 *   variables: {
 *      academicTermID: // value for 'academicTermID'
 *      reportCardSectionPolicyID: // value for 'reportCardSectionPolicyID'
 *      learningObjectiveID: // value for 'learningObjectiveID'
 *   },
 * });
 */
export function useLearningObjectiveAspectReportCardSectionFormInformationQuery(
	baseOptions: Apollo.QueryHookOptions<
		LearningObjectiveAspectReportCardSectionFormInformationQuery,
		LearningObjectiveAspectReportCardSectionFormInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		LearningObjectiveAspectReportCardSectionFormInformationQuery,
		LearningObjectiveAspectReportCardSectionFormInformationQueryVariables
	>(LearningObjectiveAspectReportCardSectionFormInformationDocument, options);
}
export function useLearningObjectiveAspectReportCardSectionFormInformationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		LearningObjectiveAspectReportCardSectionFormInformationQuery,
		LearningObjectiveAspectReportCardSectionFormInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		LearningObjectiveAspectReportCardSectionFormInformationQuery,
		LearningObjectiveAspectReportCardSectionFormInformationQueryVariables
	>(LearningObjectiveAspectReportCardSectionFormInformationDocument, options);
}
export function useLearningObjectiveAspectReportCardSectionFormInformationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		LearningObjectiveAspectReportCardSectionFormInformationQuery,
		LearningObjectiveAspectReportCardSectionFormInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		LearningObjectiveAspectReportCardSectionFormInformationQuery,
		LearningObjectiveAspectReportCardSectionFormInformationQueryVariables
	>(LearningObjectiveAspectReportCardSectionFormInformationDocument, options);
}
export type LearningObjectiveAspectReportCardSectionFormInformationQueryHookResult = ReturnType<
	typeof useLearningObjectiveAspectReportCardSectionFormInformationQuery
>;
export type LearningObjectiveAspectReportCardSectionFormInformationLazyQueryHookResult = ReturnType<
	typeof useLearningObjectiveAspectReportCardSectionFormInformationLazyQuery
>;
export type LearningObjectiveAspectReportCardSectionFormInformationSuspenseQueryHookResult = ReturnType<
	typeof useLearningObjectiveAspectReportCardSectionFormInformationSuspenseQuery
>;
export type LearningObjectiveAspectReportCardSectionFormInformationQueryResult = Apollo.QueryResult<
	LearningObjectiveAspectReportCardSectionFormInformationQuery,
	LearningObjectiveAspectReportCardSectionFormInformationQueryVariables
>;
export const OverallMarkAspectReportCardSectionFormInformationDocument = gql`
	query overallMarkAspectReportCardSectionFormInformation($academicTermID: ID!, $reportCardSectionPolicyID: ID!) {
		reportCardSectionConnection(
			filters: {
				reportCard: { academicTermIDEQ: $academicTermID }
				reportCardSectionPolicyIDEQ: $reportCardSectionPolicyID
			}
		) {
			edges {
				node {
					id
					isComplete
					overallMarkValue {
						id
						...MarkValueName
					}
					reportCard {
						id
						student {
							id
							person {
								id
								...PersonNameAndImage
								familyName
							}
						}
					}
				}
			}
		}
	}
	${MarkValueNameFragmentDoc}
	${PersonNameAndImageFragmentDoc}
`;

/**
 * __useOverallMarkAspectReportCardSectionFormInformationQuery__
 *
 * To run a query within a React component, call `useOverallMarkAspectReportCardSectionFormInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverallMarkAspectReportCardSectionFormInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverallMarkAspectReportCardSectionFormInformationQuery({
 *   variables: {
 *      academicTermID: // value for 'academicTermID'
 *      reportCardSectionPolicyID: // value for 'reportCardSectionPolicyID'
 *   },
 * });
 */
export function useOverallMarkAspectReportCardSectionFormInformationQuery(
	baseOptions: Apollo.QueryHookOptions<
		OverallMarkAspectReportCardSectionFormInformationQuery,
		OverallMarkAspectReportCardSectionFormInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		OverallMarkAspectReportCardSectionFormInformationQuery,
		OverallMarkAspectReportCardSectionFormInformationQueryVariables
	>(OverallMarkAspectReportCardSectionFormInformationDocument, options);
}
export function useOverallMarkAspectReportCardSectionFormInformationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		OverallMarkAspectReportCardSectionFormInformationQuery,
		OverallMarkAspectReportCardSectionFormInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		OverallMarkAspectReportCardSectionFormInformationQuery,
		OverallMarkAspectReportCardSectionFormInformationQueryVariables
	>(OverallMarkAspectReportCardSectionFormInformationDocument, options);
}
export function useOverallMarkAspectReportCardSectionFormInformationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		OverallMarkAspectReportCardSectionFormInformationQuery,
		OverallMarkAspectReportCardSectionFormInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		OverallMarkAspectReportCardSectionFormInformationQuery,
		OverallMarkAspectReportCardSectionFormInformationQueryVariables
	>(OverallMarkAspectReportCardSectionFormInformationDocument, options);
}
export type OverallMarkAspectReportCardSectionFormInformationQueryHookResult = ReturnType<
	typeof useOverallMarkAspectReportCardSectionFormInformationQuery
>;
export type OverallMarkAspectReportCardSectionFormInformationLazyQueryHookResult = ReturnType<
	typeof useOverallMarkAspectReportCardSectionFormInformationLazyQuery
>;
export type OverallMarkAspectReportCardSectionFormInformationSuspenseQueryHookResult = ReturnType<
	typeof useOverallMarkAspectReportCardSectionFormInformationSuspenseQuery
>;
export type OverallMarkAspectReportCardSectionFormInformationQueryResult = Apollo.QueryResult<
	OverallMarkAspectReportCardSectionFormInformationQuery,
	OverallMarkAspectReportCardSectionFormInformationQueryVariables
>;
export const CommentAspectReportCardSectionFormInformationDocument = gql`
	query commentAspectReportCardSectionFormInformation($academicTermID: ID!, $reportCardSectionPolicyID: ID!) {
		reportCardSectionConnection(
			filters: {
				reportCard: { academicTermIDEQ: $academicTermID }
				reportCardSectionPolicyIDEQ: $reportCardSectionPolicyID
			}
		) {
			edges {
				node {
					id
					comment
					generalComment1
					generalComment2
					isComplete
					reportCard {
						id
						student {
							id
							person {
								id
								...PersonNameAndImage
								familyName
							}
						}
					}
				}
			}
		}
		reportCardSectionPolicy(id: $reportCardSectionPolicyID) {
			id
			minCommentLength
			maxCommentLength
			minGeneralComment1Length
			maxGeneralComment1Length
			minGeneralComment2Length
			maxGeneralComment2Length
		}
	}
	${PersonNameAndImageFragmentDoc}
`;

/**
 * __useCommentAspectReportCardSectionFormInformationQuery__
 *
 * To run a query within a React component, call `useCommentAspectReportCardSectionFormInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentAspectReportCardSectionFormInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentAspectReportCardSectionFormInformationQuery({
 *   variables: {
 *      academicTermID: // value for 'academicTermID'
 *      reportCardSectionPolicyID: // value for 'reportCardSectionPolicyID'
 *   },
 * });
 */
export function useCommentAspectReportCardSectionFormInformationQuery(
	baseOptions: Apollo.QueryHookOptions<
		CommentAspectReportCardSectionFormInformationQuery,
		CommentAspectReportCardSectionFormInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		CommentAspectReportCardSectionFormInformationQuery,
		CommentAspectReportCardSectionFormInformationQueryVariables
	>(CommentAspectReportCardSectionFormInformationDocument, options);
}
export function useCommentAspectReportCardSectionFormInformationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CommentAspectReportCardSectionFormInformationQuery,
		CommentAspectReportCardSectionFormInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		CommentAspectReportCardSectionFormInformationQuery,
		CommentAspectReportCardSectionFormInformationQueryVariables
	>(CommentAspectReportCardSectionFormInformationDocument, options);
}
export function useCommentAspectReportCardSectionFormInformationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CommentAspectReportCardSectionFormInformationQuery,
		CommentAspectReportCardSectionFormInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CommentAspectReportCardSectionFormInformationQuery,
		CommentAspectReportCardSectionFormInformationQueryVariables
	>(CommentAspectReportCardSectionFormInformationDocument, options);
}
export type CommentAspectReportCardSectionFormInformationQueryHookResult = ReturnType<
	typeof useCommentAspectReportCardSectionFormInformationQuery
>;
export type CommentAspectReportCardSectionFormInformationLazyQueryHookResult = ReturnType<
	typeof useCommentAspectReportCardSectionFormInformationLazyQuery
>;
export type CommentAspectReportCardSectionFormInformationSuspenseQueryHookResult = ReturnType<
	typeof useCommentAspectReportCardSectionFormInformationSuspenseQuery
>;
export type CommentAspectReportCardSectionFormInformationQueryResult = Apollo.QueryResult<
	CommentAspectReportCardSectionFormInformationQuery,
	CommentAspectReportCardSectionFormInformationQueryVariables
>;
export const ReportCardSectionPolicyGradingInformationDocument = gql`
	query reportCardSectionPolicyGradingInformation($id: ID!) {
		reportCardSectionPolicy(id: $id) {
			id
			...ReportCardSectionPolicyName
			usesOverallMark
			overallMarkLabel
			usesComment
			commentLabel
			usesGeneralComments
			overallMarkingSystem {
				id
				markValues(order: { field: VALUE, direction: ASC }) {
					id
					...MarkValueName
				}
			}
		}
	}
	${ReportCardSectionPolicyNameFragmentDoc}
	${MarkValueNameFragmentDoc}
`;

/**
 * __useReportCardSectionPolicyGradingInformationQuery__
 *
 * To run a query within a React component, call `useReportCardSectionPolicyGradingInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionPolicyGradingInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionPolicyGradingInformationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportCardSectionPolicyGradingInformationQuery(
	baseOptions: Apollo.QueryHookOptions<
		ReportCardSectionPolicyGradingInformationQuery,
		ReportCardSectionPolicyGradingInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		ReportCardSectionPolicyGradingInformationQuery,
		ReportCardSectionPolicyGradingInformationQueryVariables
	>(ReportCardSectionPolicyGradingInformationDocument, options);
}
export function useReportCardSectionPolicyGradingInformationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionPolicyGradingInformationQuery,
		ReportCardSectionPolicyGradingInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportCardSectionPolicyGradingInformationQuery,
		ReportCardSectionPolicyGradingInformationQueryVariables
	>(ReportCardSectionPolicyGradingInformationDocument, options);
}
export function useReportCardSectionPolicyGradingInformationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionPolicyGradingInformationQuery,
		ReportCardSectionPolicyGradingInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ReportCardSectionPolicyGradingInformationQuery,
		ReportCardSectionPolicyGradingInformationQueryVariables
	>(ReportCardSectionPolicyGradingInformationDocument, options);
}
export type ReportCardSectionPolicyGradingInformationQueryHookResult = ReturnType<
	typeof useReportCardSectionPolicyGradingInformationQuery
>;
export type ReportCardSectionPolicyGradingInformationLazyQueryHookResult = ReturnType<
	typeof useReportCardSectionPolicyGradingInformationLazyQuery
>;
export type ReportCardSectionPolicyGradingInformationSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionPolicyGradingInformationSuspenseQuery
>;
export type ReportCardSectionPolicyGradingInformationQueryResult = Apollo.QueryResult<
	ReportCardSectionPolicyGradingInformationQuery,
	ReportCardSectionPolicyGradingInformationQueryVariables
>;
export const LearningObjectiveReportCardInformationDocument = gql`
	query learningObjectiveReportCardInformation($id: ID!) {
		learningObjective(id: $id) {
			id
			...LearningObjectiveName
			description
			learningObjectiveCategory {
				id
				...LearningObjectiveCategoryName
			}
		}
	}
	${LearningObjectiveNameFragmentDoc}
	${LearningObjectiveCategoryNameFragmentDoc}
`;

/**
 * __useLearningObjectiveReportCardInformationQuery__
 *
 * To run a query within a React component, call `useLearningObjectiveReportCardInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningObjectiveReportCardInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningObjectiveReportCardInformationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningObjectiveReportCardInformationQuery(
	baseOptions: Apollo.QueryHookOptions<
		LearningObjectiveReportCardInformationQuery,
		LearningObjectiveReportCardInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		LearningObjectiveReportCardInformationQuery,
		LearningObjectiveReportCardInformationQueryVariables
	>(LearningObjectiveReportCardInformationDocument, options);
}
export function useLearningObjectiveReportCardInformationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		LearningObjectiveReportCardInformationQuery,
		LearningObjectiveReportCardInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		LearningObjectiveReportCardInformationQuery,
		LearningObjectiveReportCardInformationQueryVariables
	>(LearningObjectiveReportCardInformationDocument, options);
}
export function useLearningObjectiveReportCardInformationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		LearningObjectiveReportCardInformationQuery,
		LearningObjectiveReportCardInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		LearningObjectiveReportCardInformationQuery,
		LearningObjectiveReportCardInformationQueryVariables
	>(LearningObjectiveReportCardInformationDocument, options);
}
export type LearningObjectiveReportCardInformationQueryHookResult = ReturnType<
	typeof useLearningObjectiveReportCardInformationQuery
>;
export type LearningObjectiveReportCardInformationLazyQueryHookResult = ReturnType<
	typeof useLearningObjectiveReportCardInformationLazyQuery
>;
export type LearningObjectiveReportCardInformationSuspenseQueryHookResult = ReturnType<
	typeof useLearningObjectiveReportCardInformationSuspenseQuery
>;
export type LearningObjectiveReportCardInformationQueryResult = Apollo.QueryResult<
	LearningObjectiveReportCardInformationQuery,
	LearningObjectiveReportCardInformationQueryVariables
>;
export const ReportCardSectionsReviewInformationDocument = gql`
	query reportCardSectionsReviewInformation($filters: [ReportCardSectionPolicyFilterInput!]) {
		reportCardSectionPolicyConnection(filters: $filters) {
			edges {
				node {
					id
					...ReportCardSectionPolicyName
					usesOverallMark
					isOverallMarkManual
					overallMarkLabel
					usesComment
					commentLabel
					minCommentLength
					maxCommentLength
					usesGeneralComments
					minGeneralComment1Length
					maxGeneralComment1Length
					minGeneralComment2Length
					maxGeneralComment2Length
					reportCardSections {
						id
						reportCard {
							id
							student {
								id
								person {
									id
									...PersonNameAndImage
									familyName
								}
							}
						}
						overallMarkValueID
						comment
						generalComment1
						generalComment2
						isComplete
						reportCardSectionLearningObjectives {
							id
							learningObjectiveID
							markValueID
						}
					}
				}
			}
		}
		learningObjectiveCategoryConnection(
			filters: {
				learningObjectives: {
					reportCardSectionLearningObjectives: { reportCardSection: { reportCardSectionPolicy: $filters } }
				}
			}
		) {
			edges {
				node {
					id
					...LearningObjectiveCategoryName
					learningObjectives(
						filters: {
							reportCardSectionLearningObjectives: { reportCardSection: { reportCardSectionPolicy: $filters } }
						}
					) {
						id
						...LearningObjectiveName
					}
				}
			}
		}
	}
	${ReportCardSectionPolicyNameFragmentDoc}
	${PersonNameAndImageFragmentDoc}
	${LearningObjectiveCategoryNameFragmentDoc}
	${LearningObjectiveNameFragmentDoc}
`;

/**
 * __useReportCardSectionsReviewInformationQuery__
 *
 * To run a query within a React component, call `useReportCardSectionsReviewInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCardSectionsReviewInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCardSectionsReviewInformationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useReportCardSectionsReviewInformationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ReportCardSectionsReviewInformationQuery,
		ReportCardSectionsReviewInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ReportCardSectionsReviewInformationQuery, ReportCardSectionsReviewInformationQueryVariables>(
		ReportCardSectionsReviewInformationDocument,
		options,
	);
}
export function useReportCardSectionsReviewInformationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ReportCardSectionsReviewInformationQuery,
		ReportCardSectionsReviewInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		ReportCardSectionsReviewInformationQuery,
		ReportCardSectionsReviewInformationQueryVariables
	>(ReportCardSectionsReviewInformationDocument, options);
}
export function useReportCardSectionsReviewInformationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ReportCardSectionsReviewInformationQuery,
		ReportCardSectionsReviewInformationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		ReportCardSectionsReviewInformationQuery,
		ReportCardSectionsReviewInformationQueryVariables
	>(ReportCardSectionsReviewInformationDocument, options);
}
export type ReportCardSectionsReviewInformationQueryHookResult = ReturnType<
	typeof useReportCardSectionsReviewInformationQuery
>;
export type ReportCardSectionsReviewInformationLazyQueryHookResult = ReturnType<
	typeof useReportCardSectionsReviewInformationLazyQuery
>;
export type ReportCardSectionsReviewInformationSuspenseQueryHookResult = ReturnType<
	typeof useReportCardSectionsReviewInformationSuspenseQuery
>;
export type ReportCardSectionsReviewInformationQueryResult = Apollo.QueryResult<
	ReportCardSectionsReviewInformationQuery,
	ReportCardSectionsReviewInformationQueryVariables
>;
export const SubmitBulkReportCardsDocument = gql`
	mutation submitBulkReportCards($ids: [ID!]!) {
		updateBulkReportCards(filters: { idIn: $ids }, input: { isComplete: true }) {
			edges {
				node {
					id
					isComplete
				}
			}
		}
	}
`;
export type SubmitBulkReportCardsMutationFn = Apollo.MutationFunction<
	SubmitBulkReportCardsMutation,
	SubmitBulkReportCardsMutationVariables
>;

/**
 * __useSubmitBulkReportCardsMutation__
 *
 * To run a mutation, you first call `useSubmitBulkReportCardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitBulkReportCardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitBulkReportCardsMutation, { data, loading, error }] = useSubmitBulkReportCardsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSubmitBulkReportCardsMutation(
	baseOptions?: Apollo.MutationHookOptions<SubmitBulkReportCardsMutation, SubmitBulkReportCardsMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SubmitBulkReportCardsMutation, SubmitBulkReportCardsMutationVariables>(
		SubmitBulkReportCardsDocument,
		options,
	);
}
export type SubmitBulkReportCardsMutationHookResult = ReturnType<typeof useSubmitBulkReportCardsMutation>;
export type SubmitBulkReportCardsMutationResult = Apollo.MutationResult<SubmitBulkReportCardsMutation>;
export type SubmitBulkReportCardsMutationOptions = Apollo.BaseMutationOptions<
	SubmitBulkReportCardsMutation,
	SubmitBulkReportCardsMutationVariables
>;
export const SubmitBulkReportCardSectionsDocument = gql`
	mutation submitBulkReportCardSections($ids: [ID!]!) {
		updateBulkReportCardSections(filters: { idIn: $ids }, input: { isComplete: true }) {
			edges {
				node {
					id
					isComplete
				}
			}
		}
	}
`;
export type SubmitBulkReportCardSectionsMutationFn = Apollo.MutationFunction<
	SubmitBulkReportCardSectionsMutation,
	SubmitBulkReportCardSectionsMutationVariables
>;

/**
 * __useSubmitBulkReportCardSectionsMutation__
 *
 * To run a mutation, you first call `useSubmitBulkReportCardSectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitBulkReportCardSectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitBulkReportCardSectionsMutation, { data, loading, error }] = useSubmitBulkReportCardSectionsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSubmitBulkReportCardSectionsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SubmitBulkReportCardSectionsMutation,
		SubmitBulkReportCardSectionsMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SubmitBulkReportCardSectionsMutation, SubmitBulkReportCardSectionsMutationVariables>(
		SubmitBulkReportCardSectionsDocument,
		options,
	);
}
export type SubmitBulkReportCardSectionsMutationHookResult = ReturnType<typeof useSubmitBulkReportCardSectionsMutation>;
export type SubmitBulkReportCardSectionsMutationResult = Apollo.MutationResult<SubmitBulkReportCardSectionsMutation>;
export type SubmitBulkReportCardSectionsMutationOptions = Apollo.BaseMutationOptions<
	SubmitBulkReportCardSectionsMutation,
	SubmitBulkReportCardSectionsMutationVariables
>;
export const RevokeSubmissionBulkReportCardSectionsDocument = gql`
	mutation revokeSubmissionBulkReportCardSections($ids: [ID!]!) {
		updateBulkReportCardSections(filters: { idIn: $ids }, input: { isComplete: false }) {
			edges {
				node {
					id
					isComplete
				}
			}
		}
	}
`;
export type RevokeSubmissionBulkReportCardSectionsMutationFn = Apollo.MutationFunction<
	RevokeSubmissionBulkReportCardSectionsMutation,
	RevokeSubmissionBulkReportCardSectionsMutationVariables
>;

/**
 * __useRevokeSubmissionBulkReportCardSectionsMutation__
 *
 * To run a mutation, you first call `useRevokeSubmissionBulkReportCardSectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeSubmissionBulkReportCardSectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeSubmissionBulkReportCardSectionsMutation, { data, loading, error }] = useRevokeSubmissionBulkReportCardSectionsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRevokeSubmissionBulkReportCardSectionsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RevokeSubmissionBulkReportCardSectionsMutation,
		RevokeSubmissionBulkReportCardSectionsMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RevokeSubmissionBulkReportCardSectionsMutation,
		RevokeSubmissionBulkReportCardSectionsMutationVariables
	>(RevokeSubmissionBulkReportCardSectionsDocument, options);
}
export type RevokeSubmissionBulkReportCardSectionsMutationHookResult = ReturnType<
	typeof useRevokeSubmissionBulkReportCardSectionsMutation
>;
export type RevokeSubmissionBulkReportCardSectionsMutationResult =
	Apollo.MutationResult<RevokeSubmissionBulkReportCardSectionsMutation>;
export type RevokeSubmissionBulkReportCardSectionsMutationOptions = Apollo.BaseMutationOptions<
	RevokeSubmissionBulkReportCardSectionsMutation,
	RevokeSubmissionBulkReportCardSectionsMutationVariables
>;
export const ParentPortalReportCardsDocument = gql`
	query parentPortalReportCards($filters: [ReportCardFilterInput!]!) {
		reportCardConnection(filters: $filters) {
			edges {
				node {
					id
					fileURL
					fileKey
					fileContentType
					student {
						id
						...StudentNameAndImage
					}
					academicTerm {
						id
						...AcademicTermName
					}
				}
			}
		}
	}
	${StudentNameAndImageFragmentDoc}
	${AcademicTermNameFragmentDoc}
`;

/**
 * __useParentPortalReportCardsQuery__
 *
 * To run a query within a React component, call `useParentPortalReportCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useParentPortalReportCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParentPortalReportCardsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useParentPortalReportCardsQuery(
	baseOptions: Apollo.QueryHookOptions<ParentPortalReportCardsQuery, ParentPortalReportCardsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ParentPortalReportCardsQuery, ParentPortalReportCardsQueryVariables>(
		ParentPortalReportCardsDocument,
		options,
	);
}
export function useParentPortalReportCardsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ParentPortalReportCardsQuery, ParentPortalReportCardsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ParentPortalReportCardsQuery, ParentPortalReportCardsQueryVariables>(
		ParentPortalReportCardsDocument,
		options,
	);
}
export function useParentPortalReportCardsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ParentPortalReportCardsQuery, ParentPortalReportCardsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ParentPortalReportCardsQuery, ParentPortalReportCardsQueryVariables>(
		ParentPortalReportCardsDocument,
		options,
	);
}
export type ParentPortalReportCardsQueryHookResult = ReturnType<typeof useParentPortalReportCardsQuery>;
export type ParentPortalReportCardsLazyQueryHookResult = ReturnType<typeof useParentPortalReportCardsLazyQuery>;
export type ParentPortalReportCardsSuspenseQueryHookResult = ReturnType<typeof useParentPortalReportCardsSuspenseQuery>;
export type ParentPortalReportCardsQueryResult = Apollo.QueryResult<
	ParentPortalReportCardsQuery,
	ParentPortalReportCardsQueryVariables
>;
export const TimelineDocument = gql`
	query timeline($filter: TimelineFilterInput, $pagination: TimelinePagination, $timeZone: String) {
		timeline(filter: $filter, pagination: $pagination, timeZone: $timeZone) {
			hasMore
			items {
				objectType
				objectTime
				objectTimeIsDate
				objectID
			}
		}
	}
`;

/**
 * __useTimelineQuery__
 *
 * To run a query within a React component, call `useTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useTimelineQuery(baseOptions?: Apollo.QueryHookOptions<TimelineQuery, TimelineQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TimelineQuery, TimelineQueryVariables>(TimelineDocument, options);
}
export function useTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimelineQuery, TimelineQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TimelineQuery, TimelineQueryVariables>(TimelineDocument, options);
}
export function useTimelineSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TimelineQuery, TimelineQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TimelineQuery, TimelineQueryVariables>(TimelineDocument, options);
}
export type TimelineQueryHookResult = ReturnType<typeof useTimelineQuery>;
export type TimelineLazyQueryHookResult = ReturnType<typeof useTimelineLazyQuery>;
export type TimelineSuspenseQueryHookResult = ReturnType<typeof useTimelineSuspenseQuery>;
export type TimelineQueryResult = Apollo.QueryResult<TimelineQuery, TimelineQueryVariables>;
export const TimelineAcademicTermListDocument = gql`
	query timelineAcademicTermList(
		$filters: [AcademicTermFilterInput!]
		$pagination: Pagination
		$order: AcademicTermOrder
	) {
		academicTermConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					imageURL
					startDate
					endDate
				}
			}
		}
	}
`;

/**
 * __useTimelineAcademicTermListQuery__
 *
 * To run a query within a React component, call `useTimelineAcademicTermListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineAcademicTermListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineAcademicTermListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTimelineAcademicTermListQuery(
	baseOptions?: Apollo.QueryHookOptions<TimelineAcademicTermListQuery, TimelineAcademicTermListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TimelineAcademicTermListQuery, TimelineAcademicTermListQueryVariables>(
		TimelineAcademicTermListDocument,
		options,
	);
}
export function useTimelineAcademicTermListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TimelineAcademicTermListQuery, TimelineAcademicTermListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TimelineAcademicTermListQuery, TimelineAcademicTermListQueryVariables>(
		TimelineAcademicTermListDocument,
		options,
	);
}
export function useTimelineAcademicTermListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TimelineAcademicTermListQuery, TimelineAcademicTermListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TimelineAcademicTermListQuery, TimelineAcademicTermListQueryVariables>(
		TimelineAcademicTermListDocument,
		options,
	);
}
export type TimelineAcademicTermListQueryHookResult = ReturnType<typeof useTimelineAcademicTermListQuery>;
export type TimelineAcademicTermListLazyQueryHookResult = ReturnType<typeof useTimelineAcademicTermListLazyQuery>;
export type TimelineAcademicTermListSuspenseQueryHookResult = ReturnType<
	typeof useTimelineAcademicTermListSuspenseQuery
>;
export type TimelineAcademicTermListQueryResult = Apollo.QueryResult<
	TimelineAcademicTermListQuery,
	TimelineAcademicTermListQueryVariables
>;
export const TimelineAnnouncementListDocument = gql`
	query timelineAnnouncementList(
		$filters: [AnnouncementFilterInput!]
		$pagination: Pagination
		$order: AnnouncementOrder
	) {
		announcementConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					title
					body
					startTime
					endTime
					author {
						id
						...UserNameAndImage
					}
					mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
						id
						title
						description
						isFile
						fileURL
						fileKey
						fileContentType
						linkURL
					}
					socialReactions(order: { field: CREATED_AT, direction: DESC }) {
						id
						author {
							id
							...UserName
							isCurrent
						}
					}
					sharingRecord {
						id
						isPublic
						userGroups {
							id
							...UserGroupNameAndColor
						}
					}
				}
			}
		}
	}
	${UserNameAndImageFragmentDoc}
	${UserNameFragmentDoc}
	${UserGroupNameAndColorFragmentDoc}
`;

/**
 * __useTimelineAnnouncementListQuery__
 *
 * To run a query within a React component, call `useTimelineAnnouncementListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineAnnouncementListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineAnnouncementListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTimelineAnnouncementListQuery(
	baseOptions?: Apollo.QueryHookOptions<TimelineAnnouncementListQuery, TimelineAnnouncementListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TimelineAnnouncementListQuery, TimelineAnnouncementListQueryVariables>(
		TimelineAnnouncementListDocument,
		options,
	);
}
export function useTimelineAnnouncementListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TimelineAnnouncementListQuery, TimelineAnnouncementListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TimelineAnnouncementListQuery, TimelineAnnouncementListQueryVariables>(
		TimelineAnnouncementListDocument,
		options,
	);
}
export function useTimelineAnnouncementListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TimelineAnnouncementListQuery, TimelineAnnouncementListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TimelineAnnouncementListQuery, TimelineAnnouncementListQueryVariables>(
		TimelineAnnouncementListDocument,
		options,
	);
}
export type TimelineAnnouncementListQueryHookResult = ReturnType<typeof useTimelineAnnouncementListQuery>;
export type TimelineAnnouncementListLazyQueryHookResult = ReturnType<typeof useTimelineAnnouncementListLazyQuery>;
export type TimelineAnnouncementListSuspenseQueryHookResult = ReturnType<
	typeof useTimelineAnnouncementListSuspenseQuery
>;
export type TimelineAnnouncementListQueryResult = Apollo.QueryResult<
	TimelineAnnouncementListQuery,
	TimelineAnnouncementListQueryVariables
>;
export const TimelineCalendarEventListDocument = gql`
	query timelineCalendarEventList(
		$filters: [CalendarEventFilterInput!]
		$pagination: Pagination
		$order: CalendarEventOrder
	) {
		calendarEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					...CalendarEventCalendarDetail
				}
			}
		}
	}
	${CalendarEventCalendarDetailFragmentDoc}
`;

/**
 * __useTimelineCalendarEventListQuery__
 *
 * To run a query within a React component, call `useTimelineCalendarEventListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineCalendarEventListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineCalendarEventListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTimelineCalendarEventListQuery(
	baseOptions?: Apollo.QueryHookOptions<TimelineCalendarEventListQuery, TimelineCalendarEventListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TimelineCalendarEventListQuery, TimelineCalendarEventListQueryVariables>(
		TimelineCalendarEventListDocument,
		options,
	);
}
export function useTimelineCalendarEventListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TimelineCalendarEventListQuery, TimelineCalendarEventListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TimelineCalendarEventListQuery, TimelineCalendarEventListQueryVariables>(
		TimelineCalendarEventListDocument,
		options,
	);
}
export function useTimelineCalendarEventListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TimelineCalendarEventListQuery,
		TimelineCalendarEventListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TimelineCalendarEventListQuery, TimelineCalendarEventListQueryVariables>(
		TimelineCalendarEventListDocument,
		options,
	);
}
export type TimelineCalendarEventListQueryHookResult = ReturnType<typeof useTimelineCalendarEventListQuery>;
export type TimelineCalendarEventListLazyQueryHookResult = ReturnType<typeof useTimelineCalendarEventListLazyQuery>;
export type TimelineCalendarEventListSuspenseQueryHookResult = ReturnType<
	typeof useTimelineCalendarEventListSuspenseQuery
>;
export type TimelineCalendarEventListQueryResult = Apollo.QueryResult<
	TimelineCalendarEventListQuery,
	TimelineCalendarEventListQueryVariables
>;
export const TimelineContractListDocument = gql`
	query timelineContractList($filters: [ContractFilterInput!], $pagination: Pagination, $order: ContractOrder) {
		contractConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					effectiveDate
					student {
						id
						...StudentName
					}
					academicTerms {
						id
						academicYear {
							id
							...AcademicYearName
						}
					}
					contractLineItems {
						id
						service {
							id
							...ServiceName
						}
						discount {
							id
							...DiscountName
						}
					}
				}
			}
		}
	}
	${StudentNameFragmentDoc}
	${AcademicYearNameFragmentDoc}
	${ServiceNameFragmentDoc}
	${DiscountNameFragmentDoc}
`;

/**
 * __useTimelineContractListQuery__
 *
 * To run a query within a React component, call `useTimelineContractListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineContractListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineContractListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTimelineContractListQuery(
	baseOptions?: Apollo.QueryHookOptions<TimelineContractListQuery, TimelineContractListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TimelineContractListQuery, TimelineContractListQueryVariables>(
		TimelineContractListDocument,
		options,
	);
}
export function useTimelineContractListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TimelineContractListQuery, TimelineContractListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TimelineContractListQuery, TimelineContractListQueryVariables>(
		TimelineContractListDocument,
		options,
	);
}
export function useTimelineContractListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TimelineContractListQuery, TimelineContractListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TimelineContractListQuery, TimelineContractListQueryVariables>(
		TimelineContractListDocument,
		options,
	);
}
export type TimelineContractListQueryHookResult = ReturnType<typeof useTimelineContractListQuery>;
export type TimelineContractListLazyQueryHookResult = ReturnType<typeof useTimelineContractListLazyQuery>;
export type TimelineContractListSuspenseQueryHookResult = ReturnType<typeof useTimelineContractListSuspenseQuery>;
export type TimelineContractListQueryResult = Apollo.QueryResult<
	TimelineContractListQuery,
	TimelineContractListQueryVariables
>;
export const TimelineNewsletterListDocument = gql`
	query timelineNewsletterList($filters: [NewsletterFilterInput!], $pagination: Pagination, $order: NewsletterOrder) {
		newsletterConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					...NewsletterDisplayListItem
					socialReactions(order: { field: CREATED_AT, direction: DESC }) {
						id
						author {
							id
							...UserName
							isCurrent
						}
					}
					socialComments(order: { field: CREATED_AT, direction: DESC }) {
						id
						body
						createdAt
						author {
							id
							...UserNameAndImage
							isCurrent
						}
					}
					sharingRecord {
						id
						isPublic
						userGroups {
							id
							...UserGroupNameAndColor
						}
					}
				}
			}
		}
	}
	${NewsletterDisplayListItemFragmentDoc}
	${UserNameFragmentDoc}
	${UserNameAndImageFragmentDoc}
	${UserGroupNameAndColorFragmentDoc}
`;

/**
 * __useTimelineNewsletterListQuery__
 *
 * To run a query within a React component, call `useTimelineNewsletterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineNewsletterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineNewsletterListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTimelineNewsletterListQuery(
	baseOptions?: Apollo.QueryHookOptions<TimelineNewsletterListQuery, TimelineNewsletterListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TimelineNewsletterListQuery, TimelineNewsletterListQueryVariables>(
		TimelineNewsletterListDocument,
		options,
	);
}
export function useTimelineNewsletterListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TimelineNewsletterListQuery, TimelineNewsletterListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TimelineNewsletterListQuery, TimelineNewsletterListQueryVariables>(
		TimelineNewsletterListDocument,
		options,
	);
}
export function useTimelineNewsletterListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TimelineNewsletterListQuery, TimelineNewsletterListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TimelineNewsletterListQuery, TimelineNewsletterListQueryVariables>(
		TimelineNewsletterListDocument,
		options,
	);
}
export type TimelineNewsletterListQueryHookResult = ReturnType<typeof useTimelineNewsletterListQuery>;
export type TimelineNewsletterListLazyQueryHookResult = ReturnType<typeof useTimelineNewsletterListLazyQuery>;
export type TimelineNewsletterListSuspenseQueryHookResult = ReturnType<typeof useTimelineNewsletterListSuspenseQuery>;
export type TimelineNewsletterListQueryResult = Apollo.QueryResult<
	TimelineNewsletterListQuery,
	TimelineNewsletterListQueryVariables
>;
export const TimelinePaymentListDocument = gql`
	query timelinePaymentList($filters: [PaymentFilterInput!], $pagination: Pagination, $order: PaymentOrder) {
		paymentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					issueDate
					paymentMethod
					paymentLineItems {
						id
						amount
						invoice {
							id
							contractInstallment {
								id
								contract {
									id
									student {
										id
										...StudentName
									}
								}
							}
						}
					}
				}
			}
		}
	}
	${StudentNameFragmentDoc}
`;

/**
 * __useTimelinePaymentListQuery__
 *
 * To run a query within a React component, call `useTimelinePaymentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelinePaymentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelinePaymentListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTimelinePaymentListQuery(
	baseOptions?: Apollo.QueryHookOptions<TimelinePaymentListQuery, TimelinePaymentListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TimelinePaymentListQuery, TimelinePaymentListQueryVariables>(
		TimelinePaymentListDocument,
		options,
	);
}
export function useTimelinePaymentListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TimelinePaymentListQuery, TimelinePaymentListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TimelinePaymentListQuery, TimelinePaymentListQueryVariables>(
		TimelinePaymentListDocument,
		options,
	);
}
export function useTimelinePaymentListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TimelinePaymentListQuery, TimelinePaymentListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TimelinePaymentListQuery, TimelinePaymentListQueryVariables>(
		TimelinePaymentListDocument,
		options,
	);
}
export type TimelinePaymentListQueryHookResult = ReturnType<typeof useTimelinePaymentListQuery>;
export type TimelinePaymentListLazyQueryHookResult = ReturnType<typeof useTimelinePaymentListLazyQuery>;
export type TimelinePaymentListSuspenseQueryHookResult = ReturnType<typeof useTimelinePaymentListSuspenseQuery>;
export type TimelinePaymentListQueryResult = Apollo.QueryResult<
	TimelinePaymentListQuery,
	TimelinePaymentListQueryVariables
>;
export const TimelinePostListDocument = gql`
	query timelinePostList($filters: [PostFilterInput!], $pagination: Pagination, $order: PostOrder) {
		postConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					title
					body
					author {
						id
						...UserNameAndImage
					}
					mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
						id
						title
						description
						isFile
						fileURL
						fileKey
						fileContentType
						linkURL
						taggedPeople {
							id
							...PersonName
							user {
								id
								isCurrent
							}
						}
					}
					socialReactions(order: { field: CREATED_AT, direction: DESC }) {
						id
						author {
							id
							...UserName
							isCurrent
						}
					}
					socialComments(order: { field: CREATED_AT, direction: DESC }) {
						id
						body
						createdAt
						author {
							id
							...UserNameAndImage
							isCurrent
						}
					}
					sharingRecord {
						id
						isPublic
						userGroups {
							id
							...UserGroupNameAndColor
						}
					}
				}
			}
		}
	}
	${UserNameAndImageFragmentDoc}
	${PersonNameFragmentDoc}
	${UserNameFragmentDoc}
	${UserGroupNameAndColorFragmentDoc}
`;

/**
 * __useTimelinePostListQuery__
 *
 * To run a query within a React component, call `useTimelinePostListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelinePostListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelinePostListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTimelinePostListQuery(
	baseOptions?: Apollo.QueryHookOptions<TimelinePostListQuery, TimelinePostListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TimelinePostListQuery, TimelinePostListQueryVariables>(TimelinePostListDocument, options);
}
export function useTimelinePostListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TimelinePostListQuery, TimelinePostListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TimelinePostListQuery, TimelinePostListQueryVariables>(TimelinePostListDocument, options);
}
export function useTimelinePostListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TimelinePostListQuery, TimelinePostListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TimelinePostListQuery, TimelinePostListQueryVariables>(
		TimelinePostListDocument,
		options,
	);
}
export type TimelinePostListQueryHookResult = ReturnType<typeof useTimelinePostListQuery>;
export type TimelinePostListLazyQueryHookResult = ReturnType<typeof useTimelinePostListLazyQuery>;
export type TimelinePostListSuspenseQueryHookResult = ReturnType<typeof useTimelinePostListSuspenseQuery>;
export type TimelinePostListQueryResult = Apollo.QueryResult<TimelinePostListQuery, TimelinePostListQueryVariables>;
export const TimelineSchoolAttendanceRecordListDocument = gql`
	query timelineSchoolAttendanceRecordList(
		$filters: [SchoolAttendanceRecordFilterInput!]
		$pagination: Pagination
		$order: SchoolAttendanceRecordOrder
	) {
		schoolAttendanceRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					arrivalTime
					departureTime
					attendanceStatus {
						id
						name
						code
						description
						...AttendanceStatusInfo
					}
					author {
						id
						...UserNameAndImage
					}
					student {
						id
						...StudentName
					}
				}
			}
		}
	}
	${AttendanceStatusInfoFragmentDoc}
	${UserNameAndImageFragmentDoc}
	${StudentNameFragmentDoc}
`;

/**
 * __useTimelineSchoolAttendanceRecordListQuery__
 *
 * To run a query within a React component, call `useTimelineSchoolAttendanceRecordListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineSchoolAttendanceRecordListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineSchoolAttendanceRecordListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTimelineSchoolAttendanceRecordListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TimelineSchoolAttendanceRecordListQuery,
		TimelineSchoolAttendanceRecordListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TimelineSchoolAttendanceRecordListQuery, TimelineSchoolAttendanceRecordListQueryVariables>(
		TimelineSchoolAttendanceRecordListDocument,
		options,
	);
}
export function useTimelineSchoolAttendanceRecordListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TimelineSchoolAttendanceRecordListQuery,
		TimelineSchoolAttendanceRecordListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TimelineSchoolAttendanceRecordListQuery, TimelineSchoolAttendanceRecordListQueryVariables>(
		TimelineSchoolAttendanceRecordListDocument,
		options,
	);
}
export function useTimelineSchoolAttendanceRecordListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TimelineSchoolAttendanceRecordListQuery,
		TimelineSchoolAttendanceRecordListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		TimelineSchoolAttendanceRecordListQuery,
		TimelineSchoolAttendanceRecordListQueryVariables
	>(TimelineSchoolAttendanceRecordListDocument, options);
}
export type TimelineSchoolAttendanceRecordListQueryHookResult = ReturnType<
	typeof useTimelineSchoolAttendanceRecordListQuery
>;
export type TimelineSchoolAttendanceRecordListLazyQueryHookResult = ReturnType<
	typeof useTimelineSchoolAttendanceRecordListLazyQuery
>;
export type TimelineSchoolAttendanceRecordListSuspenseQueryHookResult = ReturnType<
	typeof useTimelineSchoolAttendanceRecordListSuspenseQuery
>;
export type TimelineSchoolAttendanceRecordListQueryResult = Apollo.QueryResult<
	TimelineSchoolAttendanceRecordListQuery,
	TimelineSchoolAttendanceRecordListQueryVariables
>;
export const TimelineStudentMedicalEventListDocument = gql`
	query timelineStudentMedicalEventList(
		$filters: [StudentMedicalEventFilterInput!]
		$pagination: Pagination
		$order: StudentMedicalEventOrder
	) {
		studentMedicalEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					checkInTime
					description
					student {
						id
						...StudentName
					}
					author {
						id
						...UserName
					}
				}
			}
		}
	}
	${StudentNameFragmentDoc}
	${UserNameFragmentDoc}
`;

/**
 * __useTimelineStudentMedicalEventListQuery__
 *
 * To run a query within a React component, call `useTimelineStudentMedicalEventListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineStudentMedicalEventListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineStudentMedicalEventListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTimelineStudentMedicalEventListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TimelineStudentMedicalEventListQuery,
		TimelineStudentMedicalEventListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TimelineStudentMedicalEventListQuery, TimelineStudentMedicalEventListQueryVariables>(
		TimelineStudentMedicalEventListDocument,
		options,
	);
}
export function useTimelineStudentMedicalEventListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TimelineStudentMedicalEventListQuery,
		TimelineStudentMedicalEventListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TimelineStudentMedicalEventListQuery, TimelineStudentMedicalEventListQueryVariables>(
		TimelineStudentMedicalEventListDocument,
		options,
	);
}
export function useTimelineStudentMedicalEventListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TimelineStudentMedicalEventListQuery,
		TimelineStudentMedicalEventListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TimelineStudentMedicalEventListQuery, TimelineStudentMedicalEventListQueryVariables>(
		TimelineStudentMedicalEventListDocument,
		options,
	);
}
export type TimelineStudentMedicalEventListQueryHookResult = ReturnType<typeof useTimelineStudentMedicalEventListQuery>;
export type TimelineStudentMedicalEventListLazyQueryHookResult = ReturnType<
	typeof useTimelineStudentMedicalEventListLazyQuery
>;
export type TimelineStudentMedicalEventListSuspenseQueryHookResult = ReturnType<
	typeof useTimelineStudentMedicalEventListSuspenseQuery
>;
export type TimelineStudentMedicalEventListQueryResult = Apollo.QueryResult<
	TimelineStudentMedicalEventListQuery,
	TimelineStudentMedicalEventListQueryVariables
>;
export const TimelineStudentNoteListDocument = gql`
	query timelineStudentNoteList(
		$filters: [StudentNoteFilterInput!]
		$pagination: Pagination
		$order: StudentNoteOrder
	) {
		studentNoteConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					noteType
					createdAt
					body
					author {
						id
						...UserNameAndImage
					}
					primaryStudents {
						id
						...StudentName
					}
				}
			}
		}
	}
	${UserNameAndImageFragmentDoc}
	${StudentNameFragmentDoc}
`;

/**
 * __useTimelineStudentNoteListQuery__
 *
 * To run a query within a React component, call `useTimelineStudentNoteListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineStudentNoteListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineStudentNoteListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTimelineStudentNoteListQuery(
	baseOptions?: Apollo.QueryHookOptions<TimelineStudentNoteListQuery, TimelineStudentNoteListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TimelineStudentNoteListQuery, TimelineStudentNoteListQueryVariables>(
		TimelineStudentNoteListDocument,
		options,
	);
}
export function useTimelineStudentNoteListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TimelineStudentNoteListQuery, TimelineStudentNoteListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TimelineStudentNoteListQuery, TimelineStudentNoteListQueryVariables>(
		TimelineStudentNoteListDocument,
		options,
	);
}
export function useTimelineStudentNoteListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TimelineStudentNoteListQuery, TimelineStudentNoteListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TimelineStudentNoteListQuery, TimelineStudentNoteListQueryVariables>(
		TimelineStudentNoteListDocument,
		options,
	);
}
export type TimelineStudentNoteListQueryHookResult = ReturnType<typeof useTimelineStudentNoteListQuery>;
export type TimelineStudentNoteListLazyQueryHookResult = ReturnType<typeof useTimelineStudentNoteListLazyQuery>;
export type TimelineStudentNoteListSuspenseQueryHookResult = ReturnType<typeof useTimelineStudentNoteListSuspenseQuery>;
export type TimelineStudentNoteListQueryResult = Apollo.QueryResult<
	TimelineStudentNoteListQuery,
	TimelineStudentNoteListQueryVariables
>;
export const ViewerWithPermissionsDocument = gql`
	query viewerWithPermissions {
		viewer {
			id
			email
			status
		}
		permissionConnection(filters: { permissionGroups: { users: { isCurrentEQ: true } } }) {
			edges {
				node {
					name
				}
			}
		}
	}
`;

/**
 * __useViewerWithPermissionsQuery__
 *
 * To run a query within a React component, call `useViewerWithPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerWithPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerWithPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerWithPermissionsQuery(
	baseOptions?: Apollo.QueryHookOptions<ViewerWithPermissionsQuery, ViewerWithPermissionsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ViewerWithPermissionsQuery, ViewerWithPermissionsQueryVariables>(
		ViewerWithPermissionsDocument,
		options,
	);
}
export function useViewerWithPermissionsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ViewerWithPermissionsQuery, ViewerWithPermissionsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ViewerWithPermissionsQuery, ViewerWithPermissionsQueryVariables>(
		ViewerWithPermissionsDocument,
		options,
	);
}
export function useViewerWithPermissionsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ViewerWithPermissionsQuery, ViewerWithPermissionsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ViewerWithPermissionsQuery, ViewerWithPermissionsQueryVariables>(
		ViewerWithPermissionsDocument,
		options,
	);
}
export type ViewerWithPermissionsQueryHookResult = ReturnType<typeof useViewerWithPermissionsQuery>;
export type ViewerWithPermissionsLazyQueryHookResult = ReturnType<typeof useViewerWithPermissionsLazyQuery>;
export type ViewerWithPermissionsSuspenseQueryHookResult = ReturnType<typeof useViewerWithPermissionsSuspenseQuery>;
export type ViewerWithPermissionsQueryResult = Apollo.QueryResult<
	ViewerWithPermissionsQuery,
	ViewerWithPermissionsQueryVariables
>;
